export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Decimal: { input: number; output: number; }
  JSON: { input: { [key: string]: string }; output: { [key: string]: string }; }
  NotEmptyStr: { input: string; output: string; }
  Time: { input: string; output: string; }
  UUID: { input: string; output: string; }
  Void: { input: null; output: null; }
};

export type ApiClientError = {
  __typename?: 'APIClientError';
  errors: Array<Scalars['String']['output']>;
};

export enum ApiKeyJwtTokenScopeEnum {
  Read = 'READ',
  Write = 'WRITE'
}

export type AtsAcceptOfferJobApplicantInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  job_applicant_id: Scalars['ID']['input'];
  job_vacancy_id: Scalars['ID']['input'];
};

export type AtsAcceptOfferJobApplicantResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsAcceptOfferJobApplicantPayload | ValidationErrorV2;

export type AtsAddAttachmentResponse = AtsCreateAttachmentPayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsAddCommentJobVacancyRequestInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  comment: Scalars['String']['input'];
  job_vacancy_request_id: Scalars['ID']['input'];
};

export type AtsAddCommentJobVacancyRequestResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsCommentJobVacancyRequestPayload;

export type AtsAddDocumentsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  documents: Array<AtsAttachmentDocumentInput>;
  form_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AtsAddNoteToJobApplicantInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  job_applicant_id: Scalars['ID']['input'];
  job_vacancy_id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};

export type AtsAddNoteToJobApplicantResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsAddNoteAuditLogPayload | ValidationErrorV2;

export enum AtsAffinityWeightEnum {
  High = 'HIGH',
  Lower = 'LOWER',
  Medium = 'MEDIUM'
}

export type AtsApplicantAlreadyInVacancyError = {
  __typename?: 'ATSApplicantAlreadyInVacancyError';
  /** UID del candidato que ya está en la vacante, para abrir su perfil. Puede venir vacío si no se pudo resolver: el rechazo es válido igual. */
  existing_applicant_uid?: Maybe<Scalars['String']['output']>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** Motivo del rechazo, legible para la persona. */
  message: Scalars['String']['output'];
};

export type AtsApplicantAttachmentDocumentCompletedType = {
  __typename?: 'ATSApplicantAttachmentDocumentCompletedType';
  completed_document: File;
  id: Scalars['ID']['output'];
  required_document: AtsAttachmentDocumentType;
};

export type AtsApplicantAttachmentDocumentFragment = AtsApplicantAttachmentDocumentCompletedType | AtsApplicantAttachmentDocumentPendingType;

export type AtsApplicantAttachmentDocumentPendingType = {
  __typename?: 'ATSApplicantAttachmentDocumentPendingType';
  required_document: AtsAttachmentDocumentType;
};

export type AtsApplicantAttachmentFormDetailOtpInput = {
  applicant_uid: Scalars['String']['input'];
  email: Scalars['String']['input'];
  otp_code: Scalars['String']['input'];
  stage_id: Scalars['ID']['input'];
};

export type AtsApplicantAttachmentFormDetailPayload = {
  __typename?: 'ATSApplicantAttachmentFormDetailPayload';
  applicant_attachments: Array<AtsApplicantAttachmentDocumentFragment>;
  attachment_form: AttachmentFormType;
  completed_documents_percentage: Scalars['String']['output'];
};

export type AtsApplicantAttachmentFormDetailResponse = AtsApplicantAttachmentFormDetailPayload | InternalErrorV2 | ValidationErrorV2;

export type AtsApplicantPreviousParticipationsResponse = PrivateAtsApplicantPreviousParticipations | ResponseInternalError | ResponseValidationError;

export type AtsApplicantProfileInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the job applicant */
  id: Scalars['ID']['input'];
  /** ID of the job vacancy */
  job_vacancy_id: Scalars['ID']['input'];
};

export type AtsApproveJobVacancyRequestStakeholderInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  job_vacancy_request_id: Scalars['ID']['input'];
  language_code?: InputMaybe<Scalars['String']['input']>;
  state: AtsRequestStateTypeEnum;
};

export type AtsApproveJobVacancyRequestStakeholderResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateApproveJobVacancyRequestStakeholderPayload;

export enum AtsApproverTypeEnum {
  Administrator = 'ADMINISTRATOR',
  Leader = 'LEADER',
  OtherUser = 'OTHER_USER'
}

export type AtsAssignedRequestFormConnection = {
  __typename?: 'ATSAssignedRequestFormConnection';
  edges: Array<AtsJobVacancyRequestFormEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type AtsAssignedRequestFormInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type AtsAssignedRequestFormResponse = AtsAssignedRequestFormConnection | ResponseInternalError | ResponseValidationError;

export type AtsAssignmentJobVacancyCareerSiteInput = {
  career_site_ids: Array<Scalars['ID']['input']>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** If True, inactive is_available_career_site for job vacancy */
  is_hidden: Scalars['Boolean']['input'];
  /** ID of the career site configuration */
  job_vacancy_id: Scalars['ID']['input'];
};

export type AtsAssignmentJobVacancyCareerSiteResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsAssignmentJobVacancyCareerSitePayload | ValidationErrorV2;

export enum AtsAttachmentAllowedFormatsEnum {
  DocumentDocDocx = 'DOCUMENT_DOC_DOCX',
  DocumentJpgPng = 'DOCUMENT_JPG_PNG',
  DocumentPdf = 'DOCUMENT_PDF',
  DocumentPpt = 'DOCUMENT_PPT',
  DocumentTxt = 'DOCUMENT_TXT',
  DocumentXlsXlsx = 'DOCUMENT_XLS_XLSX',
  DocumentZip = 'DOCUMENT_ZIP'
}

export type AtsAttachmentDocumentFolderInput = {
  external_folder_id: Scalars['ID']['input'];
  name_folder: Scalars['String']['input'];
};

export type AtsAttachmentDocumentInput = {
  allowed_formats: Array<AtsAttachmentAllowedFormatsEnum>;
  description_document?: InputMaybe<Scalars['String']['input']>;
  /** HRIS DocumentID */
  external_document_id?: InputMaybe<Scalars['ID']['input']>;
  folder?: InputMaybe<AtsAttachmentDocumentFolderInput>;
  name_document: Scalars['String']['input'];
};

export type AtsAttachmentDocumentType = {
  __typename?: 'ATSAttachmentDocumentType';
  allowed_formats: Array<AtsAttachmentAllowedFormatsEnum>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type AtsAttachmentDocumentsResponse = AtsAttachmentFormDocumentConnection | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsAttachmentFolderDocumentsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  folder_id: Scalars['ID']['input'];
  pagination?: InputMaybe<AtsFormDocumentPaginationInput>;
  search?: InputMaybe<AtsFormDocumentSearchInput>;
};

export type AtsAttachmentFolderInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsAttachmentFolderPayload = {
  __typename?: 'ATSAttachmentFolderPayload';
  attachment_folder: PrivateAtsAttachmentFolder;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsAttachmentFolderResponse = AtsAttachmentFolderPayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsAttachmentFoldersInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  form_id: Scalars['ID']['input'];
  pagination?: InputMaybe<AtsFormFolderPaginationInput>;
  search?: InputMaybe<AtsFormFolderSearchInput>;
};

export type AtsAttachmentFoldersResponse = AtsAttachmentFormFolderConnection | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsAttachmentFormConnection = {
  __typename?: 'ATSAttachmentFormConnection';
  edges: Array<PrivateAtsAttachmentFormEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type AtsAttachmentFormDocumentConnection = {
  __typename?: 'ATSAttachmentFormDocumentConnection';
  edges: Array<PrivateAtsAttachmentDocumentEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type AtsAttachmentFormDocumentsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  form_id: Scalars['ID']['input'];
  pagination?: InputMaybe<AtsFormDocumentPaginationInput>;
  search?: InputMaybe<AtsFormDocumentSearchInput>;
};

export type AtsAttachmentFormFolderConnection = {
  __typename?: 'ATSAttachmentFormFolderConnection';
  edges: Array<PrivateAtsAttachmentFolderEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type AtsAttachmentFormInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsAttachmentFormPaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};

export type AtsAttachmentFormPayload = {
  __typename?: 'ATSAttachmentFormPayload';
  attachment_form: PrivateAtsAttachmentForm;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsAttachmentFormResponse = AtsAttachmentFormPayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export enum AtsAttachmentFormSearchFieldsEnum {
  NameForm = 'NAME_FORM'
}

export type AtsAttachmentFormSearchInput = {
  fields: Array<AtsAttachmentFormSearchFieldsEnum>;
  query: Scalars['String']['input'];
};

export enum AtsAttachmentFormSortOrderEnum {
  Name = 'NAME'
}

export type AtsAttachmentFormSortOrderInput = {
  direction: OrderDirectionEnum;
  field: AtsAttachmentFormSortOrderEnum;
};

export type AtsAttachmentFormsResponse = AtsAttachmentFormConnection | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsAttributeAnswerInput = {
  /** EvaluationTemplateCardSectionPointAttribute id */
  card_section_attribute_id: Scalars['ID']['input'];
  /** EvaluationTemplateCardSection id */
  card_section_id: Scalars['ID']['input'];
  /** to edit response scorecard JobApplicantProfileScoreCard id */
  id?: InputMaybe<Scalars['ID']['input']>;
  scale_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AtsAverageStageVacancyResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsAvgStageTimeDashboard | ValidationErrorV2;

export type AtsBlockApplicantInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  is_unlock: Scalars['Boolean']['input'];
  job_applicant_profile_id: Scalars['ID']['input'];
  origin_blocked: OriginBlockedEnum;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type AtsBlockApplicantPayload = {
  __typename?: 'ATSBlockApplicantPayload';
  blocked_applicant: PrivateAtsJobApplicantBlocked;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsBlockApplicantResponse = AtsBlockApplicantPayload | MutationInternalExistsError | MutationValidationExistsError;

export type AtsBulkUpdateJobApplicantTagResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsUpdateJobApplicantTagsPayload;

export type AtsBulkUpdateJobVacancyStageInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  keywords?: InputMaybe<Array<AtsKeywordsInput>>;
  stages: Array<PrivateAtsUpdateJobVacancyStageInput>;
};

export type AtsBulkUpdateJobVacancyStageResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsBulkUpdateJobVacancyStagePayload | ValidationErrorV2;

export type AtsCalculateRatesInput = {
  calculable_auto_currency: Scalars['String']['input'];
  gross_margin: Scalars['Float']['input'];
  job_vacancy_id: Scalars['Int']['input'];
  monthly_rate: Scalars['Float']['input'];
};

export type AtsCandidateFormQuestion = {
  __typename?: 'ATSCandidateFormQuestion';
  allow_multiple_responses: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_dismiss: Scalars['Boolean']['output'];
  is_required: Scalars['Boolean']['output'];
  question_options?: Maybe<Array<AtsCandidateFormQuestionsOption>>;
  question_type: AtsCandidateFormQuestionTypeEnum;
  response_size?: Maybe<AtsCandidateFormResponseQuestionTypeEnum>;
  title: Scalars['String']['output'];
};

export enum AtsCandidateFormQuestionTypeEnum {
  DichotomousQuestion = 'DICHOTOMOUS_QUESTION',
  FileQuestion = 'FILE_QUESTION',
  NumericQuestion = 'NUMERIC_QUESTION',
  SelectMultipleQuestion = 'SELECT_MULTIPLE_QUESTION',
  TextQuestion = 'TEXT_QUESTION'
}

export type AtsCandidateFormQuestionsOption = {
  __typename?: 'ATSCandidateFormQuestionsOption';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type AtsCandidateFormResponse = PrivateAtsCandidateFormInfo | ResponseInternalError | ResponseValidationError;

export enum AtsCandidateFormResponseQuestionTypeEnum {
  LongResponseQuestion = 'LONG_RESPONSE_QUESTION',
  ShortResponseQuestion = 'SHORT_RESPONSE_QUESTION'
}

export type AtsCandidateFormUserResponse = AtsJobVacancy | ResponseInternalError | ResponseValidationError;

export enum AtsCandidateFormVisibilityTypeEnum {
  AlwaysRequiredCandidateFormVisibility = 'ALWAYS_REQUIRED_CANDIDATE_FORM_VISIBILITY',
  DefaultCandidateFormVisibility = 'DEFAULT_CANDIDATE_FORM_VISIBILITY',
  HiddenCandidateFormVisibility = 'HIDDEN_CANDIDATE_FORM_VISIBILITY',
  OptionalCandidateFormVisibility = 'OPTIONAL_CANDIDATE_FORM_VISIBILITY',
  RequiredCandidateFormVisibility = 'REQUIRED_CANDIDATE_FORM_VISIBILITY'
}

export enum AtsCandidatePersonalInfoTypeEnum {
  PersonalInfoCandidateSource = 'PERSONAL_INFO_CANDIDATE_SOURCE',
  PersonalInfoCountry = 'PERSONAL_INFO_COUNTRY',
  PersonalInfoDisability = 'PERSONAL_INFO_DISABILITY',
  PersonalInfoDiversityGender = 'PERSONAL_INFO_DIVERSITY_GENDER',
  PersonalInfoEmail = 'PERSONAL_INFO_EMAIL',
  PersonalInfoLinkedin = 'PERSONAL_INFO_LINKEDIN',
  PersonalInfoName = 'PERSONAL_INFO_NAME',
  PersonalInfoPhone = 'PERSONAL_INFO_PHONE',
  PersonalInfoResume = 'PERSONAL_INFO_RESUME'
}

export enum AtsCandidateQuestionStatusEnum {
  IsDeleted = 'IS_DELETED',
  IsDraft = 'IS_DRAFT',
  IsPublished = 'IS_PUBLISHED'
}

export type AtsCandidateStageDocumentsGroup = {
  __typename?: 'ATSCandidateStageDocumentsGroup';
  form_title: Scalars['String']['output'];
  relative_url: Scalars['String']['output'];
  stage_title: Scalars['String']['output'];
  submitted_documents: Array<AtsCandidateSubmittedDocument>;
  total_documents: Scalars['Int']['output'];
};

export type AtsCandidateStageDocumentsPayload = {
  __typename?: 'ATSCandidateStageDocumentsPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  stages_documents: Array<AtsCandidateStageDocumentsGroup>;
};

export type AtsCandidateSubmittedDocument = {
  __typename?: 'ATSCandidateSubmittedDocument';
  allowed_formats: Array<Scalars['String']['output']>;
  document: File;
  title: Scalars['String']['output'];
};

export type AtsCandidatesDisabilityStatsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsCandidatesDisabilityStatsList | ValidationErrorV2;

export type AtsCandidatesGenderForVacancyResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsCandidatesGenderForVacancyList | ValidationErrorV2;

export type AtsCandidatesGenderStatsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsCandidatesGenderStatsList | ValidationErrorV2;

export type AtsCandidatesSourceStatsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsCandidatesSourceStatsList | ValidationErrorV2;

export enum AtsCardTypeEnum {
  NoteCard = 'NOTE_CARD',
  OpenQuestion = 'OPEN_QUESTION',
  ScoreCard = 'SCORE_CARD',
  YesNoQuestion = 'YES_NO_QUESTION'
}

export enum AtsCareerSiteBackgroundTypeEnum {
  CareerSiteBackgroundImage = 'CAREER_SITE_BACKGROUND_IMAGE',
  CareerSiteBackgroundSolid = 'CAREER_SITE_BACKGROUND_SOLID'
}

export type AtsCareerSiteConfig = {
  __typename?: 'ATSCareerSiteConfig';
  /** Hex color for the background */
  background_color?: Maybe<Scalars['String']['output']>;
  background_image_file?: Maybe<File>;
  /** ID of the background image file */
  background_image_file_id?: Maybe<Scalars['Int']['output']>;
  /** Background type */
  background_type: AtsCareerSiteBackgroundTypeEnum;
  /** Hex color for the button */
  button_color?: Maybe<Scalars['String']['output']>;
  /** Whether the button is enabled */
  button_enabled: Scalars['Boolean']['output'];
  /** Text for the button */
  button_label?: Maybe<Scalars['String']['output']>;
  company_info?: Maybe<AtsCareerSiteConfigOrg>;
  /** Description of the career site */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether description is enabled */
  description_enabled: Scalars['Boolean']['output'];
  /** ID of the career site configuration */
  id: Scalars['ID']['output'];
  /** Whether carer site is hidden */
  is_hidden: Scalars['Boolean']['output'];
  /** Whether the logo is enabled */
  logo_enabled: Scalars['Boolean']['output'];
  logo_file?: Maybe<File>;
  /** ID of the logo file */
  logo_file_id?: Maybe<Scalars['Int']['output']>;
  /** Title of the career site */
  title: Scalars['String']['output'];
  /** Hex color for the title */
  title_color?: Maybe<Scalars['String']['output']>;
  /** Public unique identifier */
  uid?: Maybe<Scalars['String']['output']>;
  /** last updated date of career site config */
  updated_at: Scalars['DateTime']['output'];
  /** Number of vacancies */
  vacancies_count?: Maybe<Scalars['Int']['output']>;
  /** Hex color for the vacancies list */
  vacancies_list_color: Scalars['String']['output'];
  /** Style for vacancies list */
  vacancies_list_style: AtsCareerSiteVacanciesListTypeEnum;
  /** Title for vacancies list */
  vacancies_list_title: Scalars['String']['output'];
  /** visibility for vacancies list */
  visibility: AtsCareerSiteVisibilityEnum;
};

export type AtsCareerSiteConfigInput = {
  career_site_uid?: InputMaybe<Scalars['String']['input']>;
  /** slug company id */
  slug_id: Scalars['String']['input'];
};

export type AtsCareerSiteConfigOrg = {
  __typename?: 'ATSCareerSiteConfigOrg';
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AtsCareerSiteInternal = {
  __typename?: 'ATSCareerSiteInternal';
  /** Hex color for the background */
  background_color?: Maybe<Scalars['String']['output']>;
  background_image_file?: Maybe<File>;
  /** ID of the background image file */
  background_image_file_id?: Maybe<Scalars['Int']['output']>;
  /** Background type */
  background_type: AtsCareerSiteBackgroundTypeEnum;
  /** Hex color for the button */
  button_color?: Maybe<Scalars['String']['output']>;
  /** Whether the button is enabled */
  button_enabled: Scalars['Boolean']['output'];
  /** Text for the button */
  button_label?: Maybe<Scalars['String']['output']>;
  /** Description of the career site */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether description is enabled */
  description_enabled: Scalars['Boolean']['output'];
  /** ID of the career site configuration */
  id: Scalars['ID']['output'];
  /** Whether carer site is hidden */
  is_hidden: Scalars['Boolean']['output'];
  /** Whether the logo is enabled */
  logo_enabled: Scalars['Boolean']['output'];
  logo_file?: Maybe<File>;
  /** ID of the logo file */
  logo_file_id?: Maybe<Scalars['Int']['output']>;
  relative_url?: Maybe<Scalars['String']['output']>;
  /** Title of the career site */
  title: Scalars['String']['output'];
  /** Hex color for the title */
  title_color?: Maybe<Scalars['String']['output']>;
  /** Public unique identifier */
  uid?: Maybe<Scalars['String']['output']>;
  /** last updated date of career site config */
  updated_at: Scalars['DateTime']['output'];
  /** Number of vacancies */
  vacancies_count?: Maybe<Scalars['Int']['output']>;
  /** Hex color for the vacancies list */
  vacancies_list_color: Scalars['String']['output'];
  /** Style for vacancies list */
  vacancies_list_style: AtsCareerSiteVacanciesListTypeEnum;
  /** Title for vacancies list */
  vacancies_list_title: Scalars['String']['output'];
  /** visibility for vacancies list */
  visibility: AtsCareerSiteVisibilityEnum;
};

export type AtsCareerSiteInternalConnection = {
  __typename?: 'ATSCareerSiteInternalConnection';
  edges: Array<AtsCareerSiteInternalEdge>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata: Metadata;
  page_info: PageInfo;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type AtsCareerSiteInternalEdge = {
  __typename?: 'ATSCareerSiteInternalEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AtsCareerSiteInternal;
};

export type AtsCareerSitePaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};

export enum AtsCareerSiteSearchFieldsEnum {
  CareerSiteDescription = 'CAREER_SITE_DESCRIPTION',
  CareerSiteTitle = 'CAREER_SITE_TITLE'
}

export type AtsCareerSiteSearchInput = {
  fields: Array<AtsCareerSiteSearchFieldsEnum>;
  query: Scalars['String']['input'];
};

export enum AtsCareerSiteSortOrderEnum {
  CreatedAt = 'CREATED_AT',
  SortOrder = 'SORT_ORDER',
  Visibility = 'VISIBILITY'
}

export type AtsCareerSiteSortOrderInput = {
  direction: OrderDirectionEnum;
  field: AtsCareerSiteSortOrderEnum;
};

export enum AtsCareerSiteVacanciesListTypeEnum {
  CareerSiteVacanciesListCard = 'CAREER_SITE_VACANCIES_LIST_CARD',
  CareerSiteVacanciesListTable = 'CAREER_SITE_VACANCIES_LIST_TABLE'
}

export enum AtsCareerSiteVisibilityEnum {
  ExternalAccess = 'EXTERNAL_ACCESS',
  InternalAccess = 'INTERNAL_ACCESS'
}

export type AtsCentralizedOrganizationExtraInfoPayload = {
  __typename?: 'ATSCentralizedOrganizationExtraInfoPayload';
  custom_centralized_organization: AtsCustomCentralizedOrganization;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsCentralizedOrganizationPayload = {
  __typename?: 'ATSCentralizedOrganizationPayload';
  custom_centralized_organization: PrivateAtsCustomCentralizedOrganization;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsChangeJobVacancyRequestStateInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  job_vacancy_request_id: Scalars['ID']['input'];
  language_code?: InputMaybe<Scalars['String']['input']>;
  state: AtsRequestStateTypeEnum;
};

export type AtsChangeJobVacancyRequestStateResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsSuccessStatePayload;

export enum AtsCompanyBadgeColorEnum {
  BlueColorBadge = 'BLUE_COLOR_BADGE',
  GreenColorBadge = 'GREEN_COLOR_BADGE',
  OrangeColorBadge = 'ORANGE_COLOR_BADGE',
  PurpleColorBadge = 'PURPLE_COLOR_BADGE',
  RedColorBadge = 'RED_COLOR_BADGE',
  YellowColorBadge = 'YELLOW_COLOR_BADGE'
}

export enum AtsCompanyBadgeSearchFieldsEnum {
  BadgeName = 'BADGE_NAME'
}

export type AtsCompanyBadgeSearchInput = {
  fields: Array<AtsCompanyBadgeSearchFieldsEnum>;
  query: Scalars['String']['input'];
};

export enum AtsCompanyBadgeTypeEnum {
  FlagBadge = 'FLAG_BADGE',
  StarBadge = 'STAR_BADGE'
}

export enum AtsCompanyTagSearchFieldsEnum {
  TagName = 'TAG_NAME'
}

export type AtsCompanyTagsSearchInput = {
  fields: Array<AtsCompanyTagSearchFieldsEnum>;
  query: Scalars['String']['input'];
};

export type AtsCoreJobVacancyConfigRequestInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  job_vacancy_config_request_id: Scalars['ID']['input'];
};

export type AtsCreateApplicantByRecruiterInput = {
  /** Si el reclutador eligió traer el historial de esta persona (TCSTC-4711). Omitirlo significa que no se preguntó — la persona es nueva en la organización. En `true` se reutiliza su currículum anterior si no se adjunta uno. */
  brings_previous_history?: InputMaybe<Scalars['Boolean']['input']>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Correo del candidato. Es lo que identifica a la persona entre vacantes, y no puede repetirse dentro de la misma vacante. */
  email: Scalars['String']['input'];
  /** ID del archivo de currículum ya subido. Opcional. */
  file_cv_id?: InputMaybe<Scalars['ID']['input']>;
  /** Nombre del candidato. */
  first_name: Scalars['String']['input'];
  /** Apellido del candidato. */
  last_name: Scalars['String']['input'];
  /** De dónde vino el candidato (LinkedIn, referido, portal…). Es un dato distinto de quién lo agregó: eso lo registra el sistema desde la sesión. */
  origin_candidates?: InputMaybe<AtsOriginCandidatesEnum>;
  /** ID de la etapa inicial. Debe pertenecer a esta vacante; a diferencia de la postulación pública, que siempre entra por recepción, el reclutador elige. */
  stage_id: Scalars['ID']['input'];
  /** ID de la vacante a la que se agrega el candidato. */
  vacancy_id: Scalars['ID']['input'];
};

export type AtsCreateApplicantByRecruiterPayload = {
  __typename?: 'ATSCreateApplicantByRecruiterPayload';
  /** El candidato creado, incluido quién lo agregó. */
  applicant_profile: PrivateAtsJobApplicantProfile;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsCreateApplicantByRecruiterResponse = AtsApplicantAlreadyInVacancyError | AtsCreateApplicantByRecruiterPayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsCreateApplicationFormInput = {
  applicant_form_info: Array<PrivateAtsFormInfoItemInput>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  job_vacancy_config_request_id: Scalars['ID']['input'];
};

export type AtsCreateApplicationFormResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsCreateApplicationFormPayload;

export type AtsCreateApprovalInput = {
  approval?: Scalars['Boolean']['input'];
  approvers?: InputMaybe<Array<PrivateAtsApproverInput>>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  job_vacancy_config_request_id: Scalars['ID']['input'];
  number_days?: InputMaybe<Scalars['Int']['input']>;
  type_resolution?: InputMaybe<AtsTypeResolutionTypeEnum>;
};

export type AtsCreateApprovalResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsCreateApprovalPayload;

export type AtsCreateAssignmentInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  job_vacancy_config_request_id: Scalars['ID']['input'];
  restriction_by_attribute?: Scalars['Boolean']['input'];
  task_rules?: InputMaybe<Array<PrivateAtsAssignmentRuleInput>>;
  type_assignment?: AtsTypeAssignmentTypeEnum;
};

export type AtsCreateAssignmentResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsCreateAssignmentPayload;

export type AtsCreateAttachmentFormInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  document_ids: Array<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type AtsCreateAttachmentPayload = {
  __typename?: 'ATSCreateAttachmentPayload';
  attachment_documents: PrivateAtsAttachmentDocumentPayload;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsCreateCandidateFormInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  personal_info: Array<PrivateAtsPersonalInfoItemInput>;
  questions_info?: InputMaybe<Array<Scalars['ID']['input']>>;
  recurring_question_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AtsCreateCandidateFormQuestionInput = {
  /** Multiple responses flag for multiple option questions only */
  allow_multiple_responses?: InputMaybe<Scalars['Boolean']['input']>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the job vacancy */
  id: Scalars['ID']['input'];
  /** Dismissal flag for yes/no questions only */
  is_dismiss?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the question is required */
  is_required: Scalars['Boolean']['input'];
  /** Options for multiple option questions only */
  question_options?: InputMaybe<Array<PrivateAtsCandidateFormQuestionsOptionInput>>;
  /** Type of the question */
  question_type: AtsCandidateFormQuestionTypeEnum;
  /** Response size for open questions only */
  response_size?: InputMaybe<AtsCandidateFormResponseQuestionTypeEnum>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  /** Question title */
  title: Scalars['String']['input'];
};

export type AtsCreateCandidateFormQuestionResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsCreateCandidateFormQuestionPayload;

export type AtsCreateCandidateFormResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsCreateCandidateFormPayload;

export type AtsCreateCustomCentralizedOrganizationInput = {
  centralized_organization_id: Scalars['ID']['input'];
  is_demo?: InputMaybe<Scalars['Boolean']['input']>;
  legal_file_id?: InputMaybe<Scalars['ID']['input']>;
  /** Org-level switch for the e-mail sent to approvers when a vacancy request needs their decision. Omit to leave the current value untouched. */
  notify_approver?: InputMaybe<Scalars['Boolean']['input']>;
  /** Org-level switch for the e-mail sent to the requester when their request is resolved, including when it is resolved automatically. Omit to leave the current value untouched. */
  notify_requester?: InputMaybe<Scalars['Boolean']['input']>;
  /** Org-level switch for the e-mail sent to the recruiting team when a vacancy or a request is created. Omit to leave the current value untouched. */
  notify_team?: InputMaybe<Scalars['Boolean']['input']>;
  rrss_logo_file_id?: InputMaybe<Scalars['ID']['input']>;
  show_client_identifier?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AtsCreateCustomCentralizedOrganizationResponse = AtsCentralizedOrganizationPayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsCreateEvaluationCardQuestionInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  company_id?: InputMaybe<Scalars['String']['input']>;
  evaluation_card_question?: InputMaybe<Scalars['ID']['input']>;
  evaluation_template_card_section_id: Scalars['Int']['input'];
  is_required: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  question_text: Scalars['String']['input'];
  question_type: AtsCardTypeEnum;
};

export type AtsCreateEvaluationCardQuestionResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsCreateEvaluationCardQuestionResponsePayload;

export type AtsCreateEvaluationTemplateCardSectionInput = {
  attributes_id?: InputMaybe<Array<Scalars['Int']['input']>>;
  card_type?: InputMaybe<AtsCardTypeEnum>;
  evaluation_template_id: Scalars['Int']['input'];
  scale_option_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AtsCreateEvaluationTemplateInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  company_id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  evaluation_template_id?: InputMaybe<Scalars['String']['input']>;
  language_code: AtsLanguageCodeEnum;
  reference_template_id?: InputMaybe<Scalars['String']['input']>;
  template_reference_id?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type AtsCreateFormRequestConfigExtraFieldsPayload = {
  __typename?: 'ATSCreateFormRequestConfigExtraFieldsPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsCreateJobApplicantMassiveUploadTemplateInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  vacancy_id: Scalars['ID']['input'];
};

export type AtsCreateJobApplicantMassiveUploadTemplatePayload = {
  __typename?: 'ATSCreateJobApplicantMassiveUploadTemplatePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  template: AtsJobApplicantMassiveUploadTemplateType;
};

export type AtsCreateJobApplicantMassiveUploadTemplateResponse = AtsCreateJobApplicantMassiveUploadTemplatePayload | InternalErrorV2 | ValidationErrorV2;

export type AtsCreateJobApplicantTagInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the job applicant */
  job_applicant_id: Scalars['ID']['input'];
  tag_name?: InputMaybe<Scalars['String']['input']>;
};

export type AtsCreateJobVacancyConfigRequestInput = {
  assigned_recruiter_id: Scalars['ID']['input'];
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type_application?: AtsTypeApplicationTypeEnum;
};

export type AtsCreateJobVacancyConfigRequestPayload = {
  __typename?: 'ATSCreateJobVacancyConfigRequestPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  job_vacancy_config_request: PrivateAtsJobVacancyConfigRequest;
};

export type AtsCreateJobVacancyConfigRequestResponse = AtsCreateJobVacancyConfigRequestPayload | MutationInternalExistsError | MutationValidationExistsError;

export type AtsCreateJobVacancyExtraFieldResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsCreateJobVacancyExtraFieldPayload | ValidationErrorV2;

export type AtsCreateJobVacancyFormRequestConfigExtraFieldsResponse = AtsCreateFormRequestConfigExtraFieldsPayload | MutationInternalExistsError | MutationValidationExistsError;

export type AtsCreateJobVacancyInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  client_name?: InputMaybe<Scalars['String']['input']>;
  contract_type?: InputMaybe<AtsVacancyContractTypeEnum>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_by_id?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  hiring_number?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<AtsKeywordsInput>>;
  salary?: InputMaybe<Scalars['Float']['input']>;
  show_contract_type?: InputMaybe<Scalars['Boolean']['input']>;
  show_location?: InputMaybe<Scalars['Boolean']['input']>;
  show_salary?: InputMaybe<Scalars['Boolean']['input']>;
  show_work_mode?: InputMaybe<Scalars['Boolean']['input']>;
  show_work_team_id?: InputMaybe<Scalars['Boolean']['input']>;
  show_workday?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type_vacancy?: InputMaybe<AtsVacancyPositionStatusEnum>;
  updated_by_id?: InputMaybe<Scalars['Int']['input']>;
  work_mode?: InputMaybe<AtsVacancyWorkModalityEnum>;
  work_team_id?: InputMaybe<Scalars['Int']['input']>;
  workday?: InputMaybe<AtsVacancyWorkScheduleEnum>;
};

export type AtsCreateJobVacancyRequestCollaboratorInput = {
  applicant_form_data: Scalars['JSON']['input'];
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  job_vacancy_config_request_id: Scalars['ID']['input'];
  leader_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AtsCreateJobVacancyRequestCollaboratorResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsJobVacancyRequest;

export type AtsCreateJobVacancyStageFromPipelineTemplateInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** id of pipeline template job vacancy stage */
  id: Scalars['ID']['input'];
  /** id of job vacancy */
  job_vacancy_id: Scalars['ID']['input'];
};

export type AtsCreateJobVacancyStageInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the job vacancy */
  id: Scalars['ID']['input'];
  /** Name of the job vacancy stage */
  name?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

export type AtsCreateJobVacancyStageResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsCreateJobVacancyStagePayload | ValidationErrorV2;

export type AtsCreateMailTemplateInput = {
  banner_file_id?: InputMaybe<Scalars['ID']['input']>;
  body: Scalars['String']['input'];
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  file_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  has_job_schedule?: InputMaybe<Scalars['Boolean']['input']>;
  has_job_vacancy?: InputMaybe<Scalars['Boolean']['input']>;
  language_code: AtsLanguageCodeEnum;
  lexical_body: Scalars['String']['input'];
  schedule_info?: InputMaybe<AtsScheduleBaseInfoInput>;
  subject: Scalars['String']['input'];
  template_description?: InputMaybe<Scalars['String']['input']>;
  template_name: Scalars['String']['input'];
  template_reference_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AtsCreateMailTemplatePayload = {
  __typename?: 'ATSCreateMailTemplatePayload';
  email_template: PrivateAtsMailTemplate;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsCreateMailTemplateResponse = AtsCreateMailTemplatePayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsCreateOrUpdateCompanyBadgeInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  color_type: AtsCompanyBadgeColorEnum;
  /** company badge description */
  description?: InputMaybe<Scalars['String']['input']>;
  icon_type: AtsCompanyBadgeTypeEnum;
  /** ID of the company badge */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** company badge name */
  name: Scalars['String']['input'];
};

export type AtsCreateOrUpdateJobVacancyExtraFieldInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  field_type: AtsExtraFieldTypeEnum;
  /** Job vacancy extra filed id */
  id?: InputMaybe<Scalars['ID']['input']>;
  is_deleted: Scalars['Boolean']['input'];
  is_hidden: Scalars['Boolean']['input'];
  is_optional: Scalars['Boolean']['input'];
  is_recurring?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<AtsCreateOrUpdateJobVacancyExtraFieldOptionInput>>;
  sort_order: Scalars['Int']['input'];
};

export type AtsCreateOrUpdateJobVacancyExtraFieldOptionInput = {
  /** Job vacancy extra filed option id */
  id?: InputMaybe<Scalars['ID']['input']>;
  is_deleted: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  sort_order: Scalars['Int']['input'];
};

export type AtsCreateOrUpdateJobVacancyExtraFieldsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  extra_fields: Array<AtsCreateOrUpdateJobVacancyExtraFieldInput>;
  /** Job vacancy id */
  id: Scalars['ID']['input'];
};

export type AtsCreateOrUpdateJobVacancyRequestFormConfigExtraFieldInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  extra_fields: Array<AtsJobVacancyRequestFormConfigExtraFieldInput>;
  /** Job vacancy request form config  id */
  id: Scalars['ID']['input'];
};

export type AtsCreateOrUpdateJobVacancyStagePipelineTemplateInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** pipeline job vacancy stage template description */
  description: Scalars['String']['input'];
  /** ID of the template */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** pipeline job vacancy stage template name */
  name: Scalars['String']['input'];
  stages: Array<PrivateAtsCreateOrUpdateJobVacancyStageTemplateInput>;
};

export type AtsCreateOrUpdateRecruitmentTeamInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  recruiter_user_ids: Array<Scalars['ID']['input']>;
  recruitment_stakeholders_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  seeker_user_ids: Array<Scalars['ID']['input']>;
};

export type AtsCreateOrUpdateRecruitmentTeamResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsCreateOrUpdateRecruitmentTeamPayload;

export type AtsCreatePipelineTemplateJobVacancyStageResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationDiscardStageActionError | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsPipelineTemplateJobVacancyStagePayload | ValidationErrorV2;

export type AtsCreateStakeHolderQuestionnaireResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsCreateQuestionnaireResponsesPayload;

export type AtsCreateStakeholderQuestionnaireResponsesInput = {
  /** JobApplicantProfile id */
  applicant_id: Scalars['ID']['input'];
  attributes_answers?: InputMaybe<Array<AtsAttributeAnswerInput>>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  evaluation_card_id: Scalars['ID']['input'];
  questions_answers?: InputMaybe<Array<AtsQuestionAnswerInput>>;
  /** JobVacancy id */
  vacancy_id: Scalars['ID']['input'];
};

export type AtsCreateTagJobApplicantProfileResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationJobApplicantProfileVacancyTagError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsCreateJobApplicantTagPayload | ValidationErrorV2;

export type AtsCreateUpdateCareerSiteConfigInput = {
  /** Hex color for the background */
  background_color?: InputMaybe<Scalars['String']['input']>;
  /** ID of the background image file */
  background_image_file_id?: InputMaybe<Scalars['Int']['input']>;
  /** Background type */
  background_type: AtsCareerSiteBackgroundTypeEnum;
  /** Hex color for the button */
  button_color?: InputMaybe<Scalars['String']['input']>;
  /** Whether the button is enabled */
  button_enabled: Scalars['Boolean']['input'];
  /** Text for the button */
  button_label?: InputMaybe<Scalars['String']['input']>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Description of the career site */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether description is enabled */
  description_enabled: Scalars['Boolean']['input'];
  /** ID of the career site configuration */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the logo is enabled */
  logo_enabled: Scalars['Boolean']['input'];
  /** ID of the logo file */
  logo_file_id?: InputMaybe<Scalars['Int']['input']>;
  /** Title of the career site */
  title: Scalars['String']['input'];
  /** Hex color for the title */
  title_color?: InputMaybe<Scalars['String']['input']>;
  /** Hex color for the vacancies list */
  vacancies_list_color: Scalars['String']['input'];
  /** Style for vacancies list */
  vacancies_list_style: AtsCareerSiteVacanciesListTypeEnum;
  /** Title for vacancies list */
  vacancies_list_title: Scalars['String']['input'];
  /** visibility for vacancies */
  visibility?: InputMaybe<AtsCareerSiteVisibilityEnum>;
};

export type AtsCreateUpdateCareerSiteConfigResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsCreateUpdateCareerSiteConfigPayload | ValidationErrorV2;

export type AtsCreateUpdateCompanyBadgeResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsCreateUpdateCompanyBadgesPayload | ValidationErrorV2;

export type AtsCreateUpdateCompanyTagsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Id TagJobApplicantProfile tag */
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type AtsCreateUpdateJobApplicantTagResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationCompanyTagError | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsCreateUpdateJobApplicantTagPayload | ValidationErrorV2;

export type AtsCreateVacancyPayload = {
  __typename?: 'ATSCreateVacancyPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  job_vacancy: PrivateAtsJobVacancy;
};

export type AtsCreateVacancyResponse = AtsCreateVacancyPayload | MutationInternalExistsError | MutationRequisitionIdentifierError | MutationValidationExistsError;

export type AtsCreateValidApplicantsInput = {
  /** Bulk upload ID to process valid applicants */
  bulk_upload_id: Scalars['ID']['input'];
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AtsCreateValidApplicantsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsCreateValidApplicantsPayload | ValidationErrorV2;

export type AtsCustomCentralizedOrganization = {
  __typename?: 'ATSCustomCentralizedOrganization';
  centralized_organization_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  recurring_extra_fields?: Maybe<Array<PrivateAtsCreateJobVacancyExtraField>>;
  rrss_logo?: Maybe<File>;
};

export type AtsDateFilterInput = {
  from_date?: InputMaybe<Scalars['DateTime']['input']>;
  to_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AtsDeleteAttachmentFormDocumentPayload = {
  __typename?: 'ATSDeleteAttachmentFormDocumentPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsDeleteAttachmentFormDocumentResponse = AtsDeleteAttachmentFormDocumentPayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsDeleteAttachmentFormPayload = {
  __typename?: 'ATSDeleteAttachmentFormPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsDeleteAttachmentFormResponse = AtsDeleteAttachmentFormPayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsDeleteCompanyBadgeInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the company badge */
  id: Scalars['ID']['input'];
};

export type AtsDeleteCompanyBadgeResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsDeleteCompanyBadgesPayload | ValidationErrorV2;

export type AtsDeleteCompanyTagInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Id TagJobApplicantProfile tag */
  id: Scalars['ID']['input'];
};

export type AtsDeleteEvaluationCardInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsDeleteEvaluationCardPayload = {
  __typename?: 'ATSDeleteEvaluationCardPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsDeleteEvaluationCardResponse = AtsDeleteEvaluationCardPayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsDeleteFormRequestCollaboratorPayload = {
  __typename?: 'ATSDeleteFormRequestCollaboratorPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsDeleteJobApplicantTagInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID tag */
  id: Scalars['ID']['input'];
  /** ID of the job applicant */
  job_applicant_id: Scalars['ID']['input'];
};

export type AtsDeleteJobApplicantTagResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsDeleteTagJobApplicantProfilePayload | ValidationErrorV2;

export type AtsDeleteJobVacancyConfigRequestInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  job_vacancy_config_request_id: Scalars['ID']['input'];
};

export type AtsDeleteJobVacancyConfigRequestResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsDeleteJobVacancyConfigRequestPayload;

export type AtsDeleteJobVacancyFormRequestCollaboratorInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** id of job vacancy form request stakeholder id */
  job_vacancy_request_id: Scalars['ID']['input'];
};

export type AtsDeleteJobVacancyFormRequestCollaboratorResponse = AtsDeleteFormRequestCollaboratorPayload | MutationInternalExistsError | MutationValidationExistsError;

export type AtsDeleteJobVacancyInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsDeleteJobVacancyResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsDeleteJobVacancyPayload;

export type AtsDeleteMailTemplateInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsDeleteMailTemplatePayload = {
  __typename?: 'ATSDeleteMailTemplatePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsDeleteMailTemplateResponse = AtsDeleteMailTemplatePayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsDeletePipelineTemplateJobVacancyStageInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** id of pipeline template job vacancy stage */
  id: Scalars['ID']['input'];
};

export type AtsDeletePipelineTemplateJobVacancyStageResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsDeletePipelineTemplateJobVacancyStagePayload;

export type AtsDeletedAttachmentFormDocumentInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  form_id: Scalars['ID']['input'];
  /** Attachment Form Document Id */
  ids: Array<Scalars['ID']['input']>;
};

export type AtsDeletedAttachmentFormInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsDepartment = {
  __typename?: 'ATSDepartment';
  work_team?: Maybe<CentralizedAreaAts>;
};

export type AtsDepartmentsCareerSiteInput = {
  career_site_uid?: InputMaybe<Scalars['String']['input']>;
  /** slug company id */
  slug_id: Scalars['String']['input'];
};

export enum AtsDisabilityCandidatesEnum {
  ResponseDisabilityNo = 'RESPONSE_DISABILITY_NO',
  ResponseDisabilityYes = 'RESPONSE_DISABILITY_YES'
}

export type AtsDiscardJobApplicantInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  job_applicant_id?: InputMaybe<Scalars['ID']['input']>;
  job_applicant_ids: Array<Scalars['String']['input']>;
  stage_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AtsDiscardJobApplicantResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsDiscardJobApplicantPayload;

export type AtsDownloadJobApplicantErrorLogInput = {
  bulk_upload_id: Scalars['ID']['input'];
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AtsDownloadJobApplicantErrorLogPayload = {
  __typename?: 'ATSDownloadJobApplicantErrorLogPayload';
  bulk_upload_id: Scalars['ID']['output'];
  error_file_id?: Maybe<Scalars['String']['output']>;
  error_file_url?: Maybe<Scalars['String']['output']>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsDownloadJobApplicantErrorLogResponse = AtsDownloadJobApplicantErrorLogPayload | InternalErrorV2 | ValidationErrorV2;

export type AtsDuplicateEvaluationCardInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsDuplicateEvaluationCardResponse = AtsEvaluationCardPayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsDuplicateJobVacancyConfigRequestInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  job_vacancy_config_request_id: Scalars['ID']['input'];
};

export type AtsDuplicateJobVacancyConfigRequestResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsJobVacancyConfigRequest;

export type AtsDuplicateJobVacancyInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsDuplicateJobVacancyResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsDuplicateJobVacancyPayload | ValidationErrorV2;

export type AtsDuplicateMailTemplateInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsDuplicateMailTemplatePayload = {
  __typename?: 'ATSDuplicateMailTemplatePayload';
  email_template: PrivateAtsMailTemplate;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsDuplicateMailTemplateResponse = AtsDuplicateMailTemplatePayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsDuplicatePipelineTemplateJobVacancyStageInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** id of pipeline template job vacancy stage */
  id: Scalars['ID']['input'];
};

export type AtsDuplicatedAttachmentFormInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsEditCandidateFormQuestionInput = {
  /** Multiple responses flag for multiple option questions only */
  allow_multiple_responses?: InputMaybe<Scalars['Boolean']['input']>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the job vacancy */
  id: Scalars['ID']['input'];
  /** Dismissal flag for yes/no questions only */
  is_dismiss?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the question is required */
  is_required: Scalars['Boolean']['input'];
  /** Options for multiple option questions only */
  question_options?: InputMaybe<Array<PrivateAtsCandidateFormQuestionsOptionInput>>;
  /** Type of the question */
  question_type: AtsCandidateFormQuestionTypeEnum;
  /** Response size for open questions only */
  response_size?: InputMaybe<AtsCandidateFormResponseQuestionTypeEnum>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  state: AtsJobVacancyStatusFormQuestion;
  /** Question title */
  title: Scalars['String']['input'];
  vacancy_id: Scalars['ID']['input'];
};

export type AtsEditCandidateFormQuestionResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsEditCandidateFormQuestionPayload;

export type AtsEditEvaluationCardQuestionInput = {
  card_section_id: Scalars['ID']['input'];
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  is_required: Scalars['Boolean']['input'];
  question_text: Scalars['String']['input'];
  question_type: AtsCardTypeEnum;
};

export type AtsEditEvaluationCardQuestionResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsEditEvaluationCardQuestionResponsePayload | ValidationErrorV2;

export enum AtsEmailSendStatusEnum {
  Failed = 'FAILED',
  Success = 'SUCCESS'
}

export type AtsEnableJobVacancyCareerSiteInput = {
  /** Whether the job vacancy is available in the career site */
  enable_career_site: Scalars['Boolean']['input'];
  /** ID of the job vacancy to enable/disable into career site */
  job_vacancy_id: Scalars['ID']['input'];
};

export type AtsEnableJobVacancyCareerSiteResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsEnableJobVacancyCareerSitePayload | ValidationErrorV2;

export type AtsEvaluationCardDetailResponse = PrivateAtsEvaluationTemplate | ResponseInternalError | ResponseValidationError;

export enum AtsEvaluationCardFieldsEnum {
  CreatedAsc = 'CREATED_ASC',
  CreatedDsc = 'CREATED_DSC',
  NameAsc = 'NAME_ASC',
  NameDsc = 'NAME_DSC',
  UsedAsc = 'USED_ASC',
  UsedDsc = 'USED_DSC'
}

export type AtsEvaluationCardInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsEvaluationCardPayload = {
  __typename?: 'ATSEvaluationCardPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export enum AtsEvaluationCardScaleTypeEnum {
  LikeEmojiScale = 'LIKE_EMOJI_SCALE',
  NumberScale = 'NUMBER_SCALE',
  StarScale = 'STAR_SCALE'
}

export type AtsEvaluationCardSearchInput = {
  fields?: InputMaybe<Array<AtsEvaluationCardFieldsEnum>>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type AtsEvaluationCardsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AtsEvaluationCardSearchInput>;
};

export type AtsEvaluationCardsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsEvaluationCardsConnection | ResponseInternalError | ResponseValidationError | ValidationErrorV2;

export type AtsEvaluationTemplateCardSectionPayload = {
  __typename?: 'ATSEvaluationTemplateCardSectionPayload';
  evaluation_template_card_section: PrivateAtsEvaluationTemplateCardSection;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsEvaluationTemplateCardSectionResponse = AtsEvaluationTemplateCardSectionPayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsEvaluationTemplatePayload = {
  __typename?: 'ATSEvaluationTemplatePayload';
  evaluation_template: PrivateAtsEvaluationTemplate;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsEvaluationTemplateResponse = AtsEvaluationTemplatePayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export enum AtsEvaluationTemplateStatusEnum {
  IsDeleted = 'IS_DELETED',
  IsDraft = 'IS_DRAFT',
  IsPublished = 'IS_PUBLISHED'
}

/** ATS event context input */
export type AtsEventContextInput = {
  actor_info?: InputMaybe<AuditLogActorInfoInput>;
  analytics_info?: InputMaybe<AuditLogAnalyticsInfoInput>;
  centralized_organization_id: Scalars['String']['input'];
  email_info?: InputMaybe<AuditLogEmailInfoInput>;
  interview_info?: InputMaybe<AuditLogInterviewInfoInput>;
  job_applicant?: InputMaybe<AuditLogJobApplicantInfoInput>;
  job_vacancy_info?: InputMaybe<AuditLogJobVacancyInfoInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  offer_info?: InputMaybe<AuditLogOfferInfoInput>;
  process_info?: InputMaybe<AuditLogProcessInfoInput>;
  rejection_info?: InputMaybe<AuditLogRejectionInfoInput>;
  stage_info?: InputMaybe<AuditLogStageInfoInput>;
  timestamp: Scalars['DateTime']['input'];
};

export enum AtsExtraFieldTypeEnum {
  CurrencyField = 'CURRENCY_FIELD',
  DateField = 'DATE_FIELD',
  DichotomousField = 'DICHOTOMOUS_FIELD',
  FileField = 'FILE_FIELD',
  NumericField = 'NUMERIC_FIELD',
  SelectMultipleField = 'SELECT_MULTIPLE_FIELD',
  SelectOneField = 'SELECT_ONE_FIELD',
  TextField = 'TEXT_FIELD'
}

export enum AtsFieldApplicationNameTypeEnum {
  ApplicationNameCandidateSource = 'APPLICATION_NAME_CANDIDATE_SOURCE',
  ApplicationNameContractType = 'APPLICATION_NAME_CONTRACT_TYPE',
  ApplicationNameCountryCity = 'APPLICATION_NAME_COUNTRY_CITY',
  ApplicationNameDeadlineDate = 'APPLICATION_NAME_DEADLINE_DATE',
  ApplicationNameDepartment = 'APPLICATION_NAME_DEPARTMENT',
  ApplicationNameDisability = 'APPLICATION_NAME_DISABILITY',
  ApplicationNameDiversityGender = 'APPLICATION_NAME_DIVERSITY_GENDER',
  ApplicationNameGrossMargin = 'APPLICATION_NAME_GROSS_MARGIN',
  ApplicationNameJobDescription = 'APPLICATION_NAME_JOB_DESCRIPTION',
  ApplicationNameJobRole = 'APPLICATION_NAME_JOB_ROLE',
  ApplicationNameJobTitle = 'APPLICATION_NAME_JOB_TITLE',
  ApplicationNameJobType = 'APPLICATION_NAME_JOB_TYPE',
  ApplicationNameKeywords = 'APPLICATION_NAME_KEYWORDS',
  ApplicationNameMonthlyRate = 'APPLICATION_NAME_MONTHLY_RATE',
  ApplicationNamePositionsNumber = 'APPLICATION_NAME_POSITIONS_NUMBER',
  ApplicationNameSalary = 'APPLICATION_NAME_SALARY',
  ApplicationNameWorkModality = 'APPLICATION_NAME_WORK_MODALITY',
  ApplicationNameWorkSchedule = 'APPLICATION_NAME_WORK_SCHEDULE'
}

export enum AtsFieldVisibilityTypeEnum {
  AlwaysRequiredFieldVisibility = 'ALWAYS_REQUIRED_FIELD_VISIBILITY',
  DefaultFieldVisibility = 'DEFAULT_FIELD_VISIBILITY',
  HiddenFieldVisibility = 'HIDDEN_FIELD_VISIBILITY',
  OptionalFieldVisibility = 'OPTIONAL_FIELD_VISIBILITY',
  RequiredFieldVisibility = 'REQUIRED_FIELD_VISIBILITY'
}

export type AtsFolderAttachmentDocumentsResponse = AtsAttachmentFormDocumentConnection | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsFormDocumentPaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};

export enum AtsFormDocumentSearchFieldsEnum {
  NameDocument = 'NAME_DOCUMENT',
  NameFolder = 'NAME_FOLDER'
}

export type AtsFormDocumentSearchInput = {
  fields: Array<AtsFormDocumentSearchFieldsEnum>;
  query: Scalars['String']['input'];
};

export type AtsFormFolderPaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};

export enum AtsFormFolderSearchFieldsEnum {
  NameFolder = 'NAME_FOLDER'
}

export type AtsFormFolderSearchInput = {
  fields: Array<AtsFormFolderSearchFieldsEnum>;
  query: Scalars['String']['input'];
};

export type AtsFunnelDashboardVacancyResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsFunnelDashboard | ValidationErrorV2;

export enum AtsGenderCandidatesEnum {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

export type AtsGeneralStatusVacancyResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsGeneralStatusVacancy | ValidationErrorV2;

export type AtsGenerateKeywordsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  exclude_keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  job_description: Scalars['String']['input'];
};

export type AtsGenerateKeywordsResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateGenerateKeywordsPayload;

export type AtsGetApplicantPreviousParticipationsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Correo del candidato. Es lo que identifica a la persona entre vacantes (BR-3); la comparación no distingue mayúsculas. */
  email: Scalars['String']['input'];
  /** Vacante que se está cargando, para que sus propias filas no se cuenten como historial previo. Si se omite, se devuelven todas las de la organización. */
  exclude_vacancy_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AtsGetApplicationFormResponse = PrivateAtsApplicationFormInfoPayload | ResponseInternalError | ResponseValidationError;

export type AtsGetCandidateFormInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsGetCandidateSourcesDistributionResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsCandidateSourcesDistributionResponse | ValidationErrorV2;

export type AtsGetCandidatesDisabilityStatsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AtsDateFilterInput>;
};

export type AtsGetCandidatesGenderStatsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AtsDateFilterInput>;
};

export type AtsGetCandidatesSourceStatsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AtsDateFilterInput>;
};

export type AtsGetCareerSiteConfigInfoResponse = AtsGetCareerSiteConfigPayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ResponseInternalError | ResponseValidationError | ValidationErrorV2;

export type AtsGetCareerSiteConfigInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the career site configuration */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AtsGetCareerSiteConfigPayload = {
  __typename?: 'ATSGetCareerSiteConfigPayload';
  career_site_config: AtsCareerSiteConfig;
};

export type AtsGetCareerSiteConfigResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsGetCareerSiteConfigPayload | ResponseInternalError | ResponseValidationError | ValidationErrorV2;

export type AtsGetCompanyTagsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AtsCompanyTagsSearchInput>;
};

export type AtsGetCustomCentralizedOrganizationInput = {
  centralized_organization_id: Scalars['ID']['input'];
};

export type AtsGetCustomCentralizedOrganizationResponse = AtsCentralizedOrganizationPayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsGetCustomInfoOrganizationCollaboratorResponse = AtsCentralizedOrganizationExtraInfoPayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsGetHiringBySourceStatsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AtsDateFilterInput>;
};

export type AtsGetHiringDashboardStatsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AtsDateFilterInput>;
};

export type AtsGetJobVacancyConfigRequestInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  job_vacancy_config_request_id: Scalars['ID']['input'];
};

export type AtsGetJobVacancyConfigRequestResponse = PrivateAtsJobVacancyConfigRequest | ResponseInternalError | ResponseValidationError;

export type AtsGetJobVacancyFormRequestHistoryResponse = AtsJobVacancyFormRequestHistoryConnection | ResponseInternalError | ResponseValidationError;

export type AtsGetJobVacancyFormRequestInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of job vacancy form request info */
  id: Scalars['ID']['input'];
};

export type AtsGetJobVacancyFormRequestResponse = PrivateAtsJobVacancyRequest | ResponseInternalError | ResponseValidationError;

export type AtsGetJobVacancyRequestDetailInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  job_vacancy_config_request_id: Scalars['ID']['input'];
  job_vacancy_request_id: Scalars['ID']['input'];
};

export type AtsGetJobVacancyRequestDetailResponse = PrivateAtsJobVacancyRequest | ResponseInternalError | ResponseValidationError;

export type AtsGetJobVacancyStagePipelineTemplateInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the template */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AtsGetJobVacancyStagePipelineTemplatesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AtsPipelineTemplateStageSearchInput>;
  sort?: InputMaybe<Array<AtsPipelineTemplateStageSortInput>>;
};

export type AtsGetJobVacancyStagesInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the job vacancy */
  id: Scalars['ID']['input'];
};

export type AtsGetPipelineTemplateJobVacancyStageResponse = PrivateAtsPipelineTemplateJobVacancyStagePayload | ResponseInternalError | ResponseValidationError;

export type AtsGetPipelineTemplatesJobVacancyStageResponse = PrivateAtsPipelineTemplateJobVacancyStageConnection | ResponseInternalError | ResponseValidationError;

export type AtsGetRecruitmentTeamDashboardStatsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AtsDateFilterInput>;
  pagination?: InputMaybe<AtsRecruitmentStatsPaginationInput>;
};

export type AtsGetRecruitmentTeamVacancyPerformanceInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AtsDateFilterInput>;
  recruitment_id: Scalars['ID']['input'];
};

export type AtsGetReducedJobVacancyStagePipelineTemplatesInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<AtsPipelineTemplateStageSearchInput>;
};

export type AtsGetReducedPipelineTemplatesJobVacancyStageResponse = PrivateAtsPipelineTemplateReducedJobVacancyStagePayload | ResponseInternalError | ResponseValidationError;

export type AtsGetVacancyDashboardStatsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AtsDateFilterInput>;
};

export type AtsGetVacancyInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsGetVacancyStatsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  vacancy_id: Scalars['ID']['input'];
};

export enum AtsGranularityStatsEnum {
  Biweekly = 'BIWEEKLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type AtsHideCareerSiteConfigInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the career site configuration */
  id: Scalars['ID']['input'];
  is_hidden: Scalars['Boolean']['input'];
};

export type AtsHideCareerSiteConfigResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsHideCareerSiteConfigPayload | ValidationErrorV2;

export type AtsHiringBySourceStatsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsHiringBySourceStatsList | ValidationErrorV2;

export type AtsHiringDashboardStatsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsHiringDashboardStats | ValidationErrorV2;

export type AtsHistoryRequestFormInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  job_vacancy_config_request_id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type AtsJobApplicantAttachmentInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsJobApplicantAttachmentResponse = PrivateAtsJobApplicantAttachment | ResponseInternalError | ResponseValidationError;

export type AtsJobApplicantBulkUploadErrorDetail = {
  __typename?: 'ATSJobApplicantBulkUploadErrorDetail';
  cell: Scalars['String']['output'];
  error: Scalars['String']['output'];
  field: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AtsJobApplicantBulkUploadErrorItem = {
  __typename?: 'ATSJobApplicantBulkUploadErrorItem';
  errors: Array<AtsJobApplicantBulkUploadErrorDetail>;
  row: Scalars['Int']['output'];
};

export type AtsJobApplicantFilterInput = {
  /** IDs de quienes presentaron a los candidatos. Sólo devuelve candidatos agregados por esas personas. */
  added_by_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  affinity_weights?: InputMaybe<Array<AtsAffinityWeightEnum>>;
  is_discarded?: InputMaybe<Scalars['Boolean']['input']>;
  is_list?: InputMaybe<Scalars['Boolean']['input']>;
  is_marked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Si es verdadero, devuelve sólo los candidatos que llegaron sin que nadie los agregara: postulantes del portal y los cargados antes de que existiera la atribución, que se comportan igual. */
  only_applied_directly?: InputMaybe<Scalars['Boolean']['input']>;
  stage_id?: InputMaybe<Scalars['ID']['input']>;
  stage_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AtsJobApplicantMassiveUploadDetailInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsJobApplicantMassiveUploadDetailResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsJobApplicantMassiveUploadDetail | ValidationErrorV2;

export type AtsJobApplicantMassiveUploadTemplateType = {
  __typename?: 'ATSJobApplicantMassiveUploadTemplateType';
  created_at: Scalars['DateTime']['output'];
  created_by_id?: Maybe<Scalars['ID']['output']>;
  file_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_updated_at: Scalars['DateTime']['output'];
  vacancy_id: Scalars['ID']['output'];
  version: Scalars['ID']['output'];
};

export enum AtsJobApplicantSearchFieldsEnum {
  JobApplicantAffinity = 'JOB_APPLICANT_AFFINITY',
  JobApplicantEmail = 'JOB_APPLICANT_EMAIL',
  JobApplicantFirstName = 'JOB_APPLICANT_FIRST_NAME',
  JobApplicantLastName = 'JOB_APPLICANT_LAST_NAME'
}

export type AtsJobApplicantSearchInput = {
  fields: Array<AtsJobApplicantSearchFieldsEnum>;
  query: Scalars['String']['input'];
};

export enum AtsJobApplicantSortOrderEnum {
  JobApplicantAffinity = 'JOB_APPLICANT_AFFINITY',
  JobApplicantCreatedAt = 'JOB_APPLICANT_CREATED_AT',
  JobApplicantName = 'JOB_APPLICANT_NAME'
}

export type AtsJobApplicantSortOrderInput = {
  direction: OrderDirectionEnum;
  field: AtsJobApplicantSortOrderEnum;
};

export enum AtsJobApplicantStateEnum {
  Discarded = 'DISCARDED',
  Hired = 'HIRED',
  Progress = 'PROGRESS'
}

export type AtsJobVacancy = {
  __typename?: 'ATSJobVacancy';
  centralized_organization_id?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contract_type?: Maybe<AtsVacancyContractTypeEnum>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extra_field_info?: Maybe<Array<AtsJobVacancyExtraField>>;
  hiring_number?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_paused?: Maybe<Scalars['Boolean']['output']>;
  personal_info: Array<AtsPersonalInfoItem>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  questions: Array<AtsCandidateFormQuestion>;
  relative_url?: Maybe<Scalars['String']['output']>;
  salary?: Maybe<Scalars['Float']['output']>;
  show_contract_type?: Maybe<Scalars['Boolean']['output']>;
  show_location?: Maybe<Scalars['Boolean']['output']>;
  show_salary?: Maybe<Scalars['Boolean']['output']>;
  show_work_mode?: Maybe<Scalars['Boolean']['output']>;
  show_work_team_id?: Maybe<Scalars['Boolean']['output']>;
  show_workday?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<AtsJobVacancyStatusEnum>;
  title?: Maybe<Scalars['String']['output']>;
  type_vacancy?: Maybe<AtsVacancyPositionStatusEnum>;
  work_mode?: Maybe<AtsVacancyWorkModalityEnum>;
  work_team?: Maybe<CentralizedAreaAts>;
  work_team_id?: Maybe<Scalars['Int']['output']>;
  workday?: Maybe<AtsVacancyWorkScheduleEnum>;
};

export type AtsJobVacancyCareerSiteFilterInput = {
  /** Filter by career site ID */
  career_site_id?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by active status */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by job vacancy ID */
  job_vacancy_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AtsJobVacancyCareerSitePaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};

export type AtsJobVacancyCareerSiteResponse = AtsVacancyConnection | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsJobVacancyCareerSiteSearchInput = {
  fields: Array<Scalars['String']['input']>;
  query: Scalars['String']['input'];
};

export type AtsJobVacancyCareerSiteSortOrderInput = {
  direction: OrderDirectionEnum;
  field: Scalars['String']['input'];
};

export type AtsJobVacancyCollaborator = {
  __typename?: 'ATSJobVacancyCollaborator';
  centralized_organization_id?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contract_type?: Maybe<AtsVacancyContractTypeEnum>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extra_field_info?: Maybe<Array<AtsJobVacancyExtraField>>;
  hiring_number?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_paused?: Maybe<Scalars['Boolean']['output']>;
  personal_info: Array<AtsPersonalInfoItem>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  questions: Array<AtsCandidateFormQuestion>;
  salary?: Maybe<Scalars['Float']['output']>;
  show_contract_type?: Maybe<Scalars['Boolean']['output']>;
  show_location?: Maybe<Scalars['Boolean']['output']>;
  show_salary?: Maybe<Scalars['Boolean']['output']>;
  show_work_mode?: Maybe<Scalars['Boolean']['output']>;
  show_work_team_id?: Maybe<Scalars['Boolean']['output']>;
  show_workday?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<AtsJobVacancyStatusEnum>;
  title?: Maybe<Scalars['String']['output']>;
  type_vacancy?: Maybe<AtsVacancyPositionStatusEnum>;
  work_mode?: Maybe<AtsVacancyWorkModalityEnum>;
  work_team?: Maybe<CentralizedAreaAts>;
  work_team_id?: Maybe<Scalars['Int']['output']>;
  workday?: Maybe<AtsVacancyWorkScheduleEnum>;
};

export type AtsJobVacancyConfigRequestListResponse = PrivateAtsJobVacancyConfigRequestConnection | ResponseInternalError | ResponseValidationError;

export enum AtsJobVacancyConfigRequestSearchFieldsEnum {
  Name = 'NAME'
}

export type AtsJobVacancyConfigRequestSearchInput = {
  fields: Array<AtsJobVacancyConfigRequestSearchFieldsEnum>;
  query: Scalars['String']['input'];
};

export enum AtsJobVacancyConfigRequestSortOrderEnum {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  TypeApplication = 'TYPE_APPLICATION'
}

export type AtsJobVacancyConfigRequestSortOrderInput = {
  direction: OrderDirectionEnum;
  field: AtsJobVacancyConfigRequestSortOrderEnum;
};

export type AtsJobVacancyDetailResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsJobVacancy | ResponseInternalError | ResponseValidationError | ValidationErrorV2;

/** An edge in a connection. */
export type AtsJobVacancyEdge = {
  __typename?: 'ATSJobVacancyEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AtsJobVacancy;
};

export type AtsJobVacancyExtraField = {
  __typename?: 'ATSJobVacancyExtraField';
  content?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  field_type: AtsExtraFieldTypeEnum;
  /** Job vacancy extra filed id */
  id: Scalars['ID']['output'];
  is_hidden: Scalars['Boolean']['output'];
  is_optional: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<AtsJobVacancyExtraFieldOption>>;
  sort_order: Scalars['Int']['output'];
  /** Job vacancy id */
  vacancy_id: Scalars['ID']['output'];
};

export type AtsJobVacancyExtraFieldOption = {
  __typename?: 'ATSJobVacancyExtraFieldOption';
  /** Job vacancy extra filed option id */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
};

export type AtsJobVacancyFilterOptionsResponse = PrivateAtsJobVacancyFilterOption | ResponseInternalError | ResponseValidationError;

export type AtsJobVacancyFormRequestHistory = {
  __typename?: 'ATSJobVacancyFormRequestHistory';
  action_type: AtsRequestChanceTypeEnum;
  created_at: Scalars['DateTime']['output'];
  executor?: Maybe<CentralizedUserAts>;
  form_request_id: Scalars['Int']['output'];
};

export type AtsJobVacancyFormRequestHistoryConnection = {
  __typename?: 'ATSJobVacancyFormRequestHistoryConnection';
  edges: Array<AtsJobVacancyFormRequestHistoryEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type AtsJobVacancyFormRequestHistoryEdge = {
  __typename?: 'ATSJobVacancyFormRequestHistoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AtsJobVacancyFormRequestHistory;
};

export type AtsJobVacancyFormRequestReceived = {
  __typename?: 'ATSJobVacancyFormRequestReceived';
  form_config: AtsJobVacancyRequestForm;
  form_request: AtsJobVacancyRequest;
  id: Scalars['ID']['output'];
  state: AtsRequestStateTypeEnum;
};

/** An edge in a connection. */
export type AtsJobVacancyFormRequestReceivedEdge = {
  __typename?: 'ATSJobVacancyFormRequestReceivedEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AtsJobVacancyFormRequestReceived;
};

export enum AtsJobVacancyFormRequestSearchFieldsEnum {
  FormRequestPetitioner = 'FORM_REQUEST_PETITIONER',
  VacancyName = 'VACANCY_NAME'
}

export type AtsJobVacancyFormRequestSearchInput = {
  fields: Array<AtsJobVacancyFormRequestSearchFieldsEnum>;
  query: Scalars['String']['input'];
};

export type AtsJobVacancyFormRequestSortInput = {
  /** Sort type become into ORM django representation ACS='', DESC='-' */
  direction?: OrderDirectionEnum;
  /** Sort enum associated to name enum with db field value, it could be exact db field nome, or kwolenge aggregated name in annotation orm field */
  field: AtsJobVacancyFormRequestSortOrderEnum;
};

export enum AtsJobVacancyFormRequestSortOrderEnum {
  VacancyName = 'VACANCY_NAME',
  VacancyPositions = 'VACANCY_POSITIONS',
  VacancyRequestDate = 'VACANCY_REQUEST_DATE'
}

export enum AtsJobVacancyFormRequestStatesEnum {
  FormRequestStateApproved = 'FORM_REQUEST_STATE_APPROVED',
  FormRequestStatePending = 'FORM_REQUEST_STATE_PENDING',
  FormRequestStateRejected = 'FORM_REQUEST_STATE_REJECTED'
}

export type AtsJobVacancyPublicInfoInput = {
  uid: Scalars['String']['input'];
};

export type AtsJobVacancyRates = {
  __typename?: 'ATSJobVacancyRates';
  calculable_auto_currency: Scalars['String']['output'];
  calculated_budget: Scalars['Float']['output'];
  gross_margin: Scalars['Float']['output'];
  gross_margin_amount: Scalars['Float']['output'];
  mixed_scheme_compensation: Scalars['Float']['output'];
  monthly_rate: Scalars['Float']['output'];
  service_monthly_compensation: Scalars['Float']['output'];
  template_monthly_compensation: Scalars['Float']['output'];
  vacancy_id: Scalars['Int']['output'];
};

export type AtsJobVacancyRatesPayload = {
  __typename?: 'ATSJobVacancyRatesPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  rates: AtsJobVacancyRates;
};

export type AtsJobVacancyRatesResponse = AtsJobVacancyRatesPayload | MutationInternalExistsError | MutationValidationExistsError;

export type AtsJobVacancyRequest = {
  __typename?: 'ATSJobVacancyRequest';
  comment?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by: CentralizedUserAts;
  id: Scalars['ID']['output'];
  job_vacancy: AtsJobVacancyCollaborator;
  state: AtsRequestStateTypeEnum;
};

export type AtsJobVacancyRequestForm = {
  __typename?: 'ATSJobVacancyRequestForm';
  assigned_recruiter?: Maybe<CentralizedUserAts>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type_application: AtsTypeApplicationTypeEnum;
};

export type AtsJobVacancyRequestFormConfigExtraFieldInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  field_type: AtsExtraFieldTypeEnum;
  /** Job vacancy request form extra field id */
  id?: InputMaybe<Scalars['ID']['input']>;
  is_deleted: Scalars['Boolean']['input'];
  is_optional: Scalars['Boolean']['input'];
  is_recurring?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<AtsCreateOrUpdateJobVacancyExtraFieldOptionInput>>;
  sort_order: Scalars['Int']['input'];
};

/** An edge in a connection. */
export type AtsJobVacancyRequestFormEdge = {
  __typename?: 'ATSJobVacancyRequestFormEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AtsJobVacancyRequestForm;
};

export type AtsJobVacancyRequestReceivedConnection = {
  __typename?: 'ATSJobVacancyRequestReceivedConnection';
  edges: Array<AtsJobVacancyFormRequestReceivedEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type AtsJobVacancyRequestSearchInput = {
  fields: Array<AtsJobsVacancyRequestSearchFieldsEnum>;
  query: Scalars['String']['input'];
};

export enum AtsJobVacancyRequestSortOrderEnum {
  RequestCreatedDate = 'REQUEST_CREATED_DATE',
  RequestNameForm = 'REQUEST_NAME_FORM',
  RequestState = 'REQUEST_STATE',
  RequestType = 'REQUEST_TYPE'
}

export type AtsJobVacancyRequestSortOrderInput = {
  direction: OrderDirectionEnum;
  field: AtsJobVacancyRequestSortOrderEnum;
};

export type AtsJobVacancyResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsVacancyConnection | ResponseInternalError | ResponseValidationError | ValidationErrorV2;

export type AtsJobVacancySearchInput = {
  fields: Array<AtsJobsVacancySearchFieldsEnum>;
  query: Scalars['String']['input'];
};

export enum AtsJobVacancySortOrderEnum {
  VacancyDeadline = 'VACANCY_DEADLINE',
  VacancyTitle = 'VACANCY_TITLE'
}

export type AtsJobVacancySortOrderInput = {
  direction: OrderDirectionEnum;
  field: AtsJobVacancySortOrderEnum;
};

export type AtsJobVacancyStage = {
  __typename?: 'ATSJobVacancyStage';
  company_info?: Maybe<AtsPublicCentralizedOrganization>;
  custom_company_info?: Maybe<AtsPublicCustomCentralizedOrganization>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  stage_title: Scalars['String']['output'];
  vacancy_title: Scalars['String']['output'];
};

export enum AtsJobVacancyStageActionEnum {
  AttachmentForm = 'ATTACHMENT_FORM',
  Email = 'EMAIL',
  Evaluation = 'EVALUATION'
}

export enum AtsJobVacancyStageDefaultEnum {
  HiringOffer = 'HIRING_OFFER',
  ReceptionCandidates = 'RECEPTION_CANDIDATES'
}

export type AtsJobVacancyStagePublicInfoInput = {
  stage_id: Scalars['ID']['input'];
  uid: Scalars['String']['input'];
};

export type AtsJobVacancyStagePublicResponse = AtsJobVacancyStage | InternalErrorV2 | ValidationErrorV2;

export type AtsJobVacancyStagesResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsJobVacancyStagesPayload | ResponseInternalError | ResponseValidationError | ValidationErrorV2;

export type AtsJobVacancyStatusCareerSiteInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Whether all job vacancies are available in the career site */
  enable_all?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the career site configuration */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** job vacancies status to enable or disable into career site */
  job_vacancies_status?: InputMaybe<Array<AtsEnableJobVacancyCareerSiteInput>>;
};

export enum AtsJobVacancyStatusEnum {
  IsCancelled = 'IS_CANCELLED',
  IsClosed = 'IS_CLOSED',
  IsDraft = 'IS_DRAFT',
  IsHired = 'IS_HIRED',
  IsPublished = 'IS_PUBLISHED'
}

export enum AtsJobVacancyStatusFormQuestion {
  IsDeleted = 'IS_DELETED',
  IsDraft = 'IS_DRAFT',
  IsPublished = 'IS_PUBLISHED'
}

export enum AtsJobsVacancyRequestSearchFieldsEnum {
  JobVacancyTitle = 'JOB_VACANCY_TITLE',
  NameForm = 'NAME_FORM'
}

export enum AtsJobsVacancySearchFieldsEnum {
  VacancyClient = 'VACANCY_CLIENT',
  VacancyDescription = 'VACANCY_DESCRIPTION',
  VacancyId = 'VACANCY_ID',
  VacancyTitle = 'VACANCY_TITLE'
}

export enum AtsKeywordWeightEnum {
  High = 'HIGH',
  Lower = 'LOWER',
  Medium = 'MEDIUM'
}

export type AtsKeywordsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  is_manual?: InputMaybe<Scalars['Boolean']['input']>;
  is_trash?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sort_order: Scalars['Int']['input'];
  weight: AtsKeywordWeightEnum;
};

export type AtsKeywordsTemporal = KeywordsBase & {
  __typename?: 'ATSKeywordsTemporal';
  is_manual: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  weight: AtsKeywordWeightEnum;
};

export enum AtsLanguageCodeEnum {
  LanguageCodeEn = 'LANGUAGE_CODE_EN',
  LanguageCodeEs = 'LANGUAGE_CODE_ES',
  LanguageCodePt = 'LANGUAGE_CODE_PT'
}

export type AtsListAllJobApplicantFilterInput = {
  badge_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** External-client names of the candidate's vacancy to filter by. Several values are OR-ed. Refused when the organization has not enabled show_client_identifier. */
  client_names?: InputMaybe<Array<Scalars['String']['input']>>;
  is_blocked?: InputMaybe<Scalars['Boolean']['input']>;
  is_marked?: InputMaybe<Scalars['Boolean']['input']>;
  job_vacancy_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  recruiter_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  states?: InputMaybe<Array<AtsJobApplicantStateEnum>>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AtsListAllJobApplicantInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AtsListAllJobApplicantFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AtsJobApplicantSearchInput>;
  sort?: InputMaybe<AtsListAllJobApplicantSortOrderEnum>;
};

export type AtsListAllJobApplicantResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsApplicantConnection | ResponseInternalError | ResponseValidationError | ValidationErrorV2;

export enum AtsListAllJobApplicantSortOrderEnum {
  JobApplicantCreatedAt = 'JOB_APPLICANT_CREATED_AT',
  JobApplicantName = 'JOB_APPLICANT_NAME',
  JobApplicantVacancy = 'JOB_APPLICANT_VACANCY'
}

/** Input for listing attachment forms with search, sorting, and pagination options. */
export type AtsListAttachmentFormInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<AtsAttachmentFormPaginationInput>;
  search?: InputMaybe<AtsAttachmentFormSearchInput>;
  sort?: Array<AtsAttachmentFormSortOrderInput>;
};

export type AtsListCareerSiteConfigInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<AtsCareerSitePaginationInput>;
  search?: InputMaybe<AtsCareerSiteSearchInput>;
  sort?: InputMaybe<AtsCareerSiteSortOrderInput>;
};

export type AtsListCareerSiteConfigResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsCareerSiteConnection | ValidationErrorV2;

export type AtsListCareerSiteInternalResponse = AtsCareerSiteInternalConnection | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsListCommentsJobVacancyRequestInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  job_vacancy_request_id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type AtsListCommentsJobVacancyRequestResponse = PrivateAtsJobVacancyRequestCommentConnection | ResponseInternalError | ResponseValidationError;

export type AtsListCompanyBadgeInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AtsCompanyBadgeSearchInput>;
};

export type AtsListCompanyBadgeResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsCompanyBadgeConnection | ResponseInternalError | ResponseValidationError | ValidationErrorV2;

export type AtsListDepartmentsCareerSitePayload = {
  __typename?: 'ATSListDepartmentsCareerSitePayload';
  departments: Array<AtsDepartment>;
};

export type AtsListDepartmentsCareerSiteResponse = AtsListDepartmentsCareerSitePayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsListJobApplicantInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AtsJobApplicantFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AtsJobApplicantSearchInput>;
  sort?: InputMaybe<AtsJobApplicantSortOrderInput>;
};

export type AtsListJobApplicantResponse = PrivateAtsApplicantConnection | ResponseInternalError | ResponseValidationError;

export type AtsListJobApplicantTagResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsJobApplicantTagConnection | ResponseInternalError | ResponseValidationError | ValidationErrorV2;

export type AtsListJobApplicantTagsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the job vacancy */
  id: Scalars['ID']['input'];
};

export type AtsListJobApplicantTagsResponse = PrivateAtsListJobApplicantTagsPayload | ResponseInternalError | ResponseValidationError;

export type AtsListJobVacanciesDataFilterInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AtsListJobVacanciesFilterInput = {
  /** External-client names to filter by. Several values are OR-ed. Refused when the organization has not enabled show_client_identifier. */
  client_name?: InputMaybe<Array<Scalars['String']['input']>>;
  contract_type?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  currency?: InputMaybe<Array<Scalars['String']['input']>>;
  is_available_career_site?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ids of the assigned recruiters to filter by. Several values are OR-ed. */
  recruiter_assigned_id?: InputMaybe<Array<Scalars['String']['input']>>;
  state?: InputMaybe<Array<Scalars['String']['input']>>;
  vacancy_type?: InputMaybe<Array<Scalars['String']['input']>>;
  work_mode?: InputMaybe<Array<Scalars['String']['input']>>;
  work_team_id?: InputMaybe<Array<Scalars['String']['input']>>;
  workday?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AtsListJobVacancyCareerSiteAssignmentInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AtsJobVacancyCareerSiteFilterInput>;
  pagination?: InputMaybe<AtsJobVacancyCareerSitePaginationInput>;
  search?: InputMaybe<AtsJobVacancyCareerSiteSearchInput>;
  sort?: InputMaybe<AtsJobVacancyCareerSiteSortOrderInput>;
};

export type AtsListJobVacancyCareerSiteFilterInput = {
  career_site_uid?: InputMaybe<Scalars['String']['input']>;
  job_vacancy_department_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AtsListJobVacancyCareerSiteInput = {
  filter?: InputMaybe<AtsListJobVacancyCareerSiteFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AtsJobVacancySearchInput>;
  slug_id: Scalars['String']['input'];
};

export type AtsListJobVacancyCareerSiteResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsJobVacancyCareerSiteConnection | ValidationErrorV2;

export type AtsListJobVacancyConfigRequestInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AtsJobVacancyConfigRequestSearchInput>;
  sort?: InputMaybe<Array<AtsJobVacancyConfigRequestSortOrderInput>>;
};

export type AtsListJobVacancyFormRequestInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AtsListJobVacancyFormRequestsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  job_vacancy_config_request_id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AtsJobVacancyFormRequestSearchInput>;
  sort?: InputMaybe<Array<AtsJobVacancyFormRequestSortInput>>;
};

export type AtsListJobVacancyFormRequestReceivedResponse = AtsJobVacancyRequestReceivedConnection | ResponseInternalError | ResponseValidationError;

export type AtsListJobVacancyFormRequestsFilterInput = {
  form_request_petitioner?: InputMaybe<Array<Scalars['ID']['input']>>;
  form_request_state?: InputMaybe<Array<AtsJobVacancyFormRequestStatesEnum>>;
};

export type AtsListJobVacancyFormRequestsReceivedInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AtsListJobVacancyFormRequestsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AtsJobVacancyFormRequestSearchInput>;
  sort?: InputMaybe<Array<AtsJobVacancyFormRequestSortInput>>;
};

export type AtsListJobVacancyFormsRequestResponse = PrivateAtsJobVacancyRequestConnection | ResponseInternalError | ResponseValidationError;

export type AtsListJobVacancyInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  career_site_id?: InputMaybe<Scalars['Int']['input']>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter?: InputMaybe<AtsListJobVacanciesFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  only_available?: InputMaybe<Scalars['Boolean']['input']>;
  only_published?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AtsJobVacancySearchInput>;
  sort?: InputMaybe<Array<AtsJobVacancySortOrderInput>>;
};

export type AtsListJobVacancyRequestInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AtsListJobVacancyRequestsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AtsJobVacancyRequestSearchInput>;
  sort?: InputMaybe<AtsJobVacancyRequestSortOrderInput>;
};

export type AtsListJobVacancyRequestResponse = PrivateAtsJobVacancyRequestConnection | ResponseInternalError | ResponseValidationError;

export type AtsListJobVacancyRequestsFilterInput = {
  states?: InputMaybe<Array<AtsRequestStateTypeEnum>>;
};

export type AtsListPipelineInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AtsPipelineFilterInput>;
  /** ID of the job vacancy */
  id: Scalars['ID']['input'];
  /** Pide las opciones del filtro «Agregado por» que respalda la pantalla de recepción en vez del tablero. Las dos muestran candidatos distintos, así que una sola lista no puede ser correcta en ambas. Por omisión, el tablero. */
  is_reception?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<AtsJobApplicantSearchInput>;
  sort?: InputMaybe<AtsPipelineSortOrderInput>;
};

export type AtsListStakeholderTaskInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  /** vacancy id */
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type AtsListStakeholderTaskResponse = PrivateAtsStakeholderTaskConnection | ResponseInternalError | ResponseValidationError;

export type AtsListStakeholderVacanciesInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum AtsMailTemplateCategoryEnum {
  Custom = 'CUSTOM',
  Default = 'DEFAULT'
}

export type AtsMailTemplateDetailInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsMailTemplateFilterInput = {
  /** Keep only templates flagged as "Disponible para vacantes" (`TemplateEmail.has_job_vacancy`), i.e. usable in vacancies, pipeline templates and stage actions. It does NOT filter by publication state: that is `state`, the editorial lifecycle of the templates the organization maintains. Sending false does not filter anything. */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  job_vacancy_stage_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum AtsMailTemplateStatusEnum {
  IsDeleted = 'IS_DELETED',
  IsDraft = 'IS_DRAFT',
  IsPublished = 'IS_PUBLISHED'
}

export type AtsMailTemplatesDetailResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsMailTemplate | ResponseInternalError | ResponseValidationError | ValidationErrorV2;

export enum AtsMailTemplatesFieldsEnum {
  TemplateNameAsc = 'TEMPLATE_NAME_ASC',
  TemplateNameDsc = 'TEMPLATE_NAME_DSC'
}

export type AtsMailTemplatesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AtsMailTemplateFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<AtsMailTemplatesSearchInput>;
  /** UI usage context where the resource is used to list email templates */
  ui_component?: InputMaybe<AtsTemplateEmailSourceComponentEnum>;
};

export type AtsMailTemplatesResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsMailTemplatesConnection | ResponseInternalError | ResponseValidationError | ValidationErrorV2;

export type AtsMailTemplatesSearchInput = {
  fields: Array<AtsMailTemplatesFieldsEnum>;
  query: Scalars['String']['input'];
};

export type AtsMarkJobApplicantPayload = {
  __typename?: 'ATSMarkJobApplicantPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsMarkJobApplicantResponse = AtsMarkJobApplicantPayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsMoveDiscardedJobApplicantInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id: Scalars['String']['input'];
  job_applicant_id: Scalars['String']['input'];
  job_vacancy_id: Scalars['String']['input'];
};

export type AtsMoveDiscardedJobApplicantResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsMoveDiscardedJobApplicantPayload;

export type AtsMoveStageJobApplicantResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsMoveStateJobApplicantPayload | ValidationErrorV2;

export type AtsMoveStateJobApplicantInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id: Scalars['String']['input'];
  job_applicant_ids: Array<Scalars['String']['input']>;
  moved_by_user_id?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<AtsOriginMoveCandidatesEnum>;
  stage_id: Scalars['String']['input'];
};

export enum AtsOriginCandidatesEnum {
  CompanyPortal = 'COMPANY_PORTAL',
  JobPortal = 'JOB_PORTAL',
  Linkedin = 'LINKEDIN',
  Referred = 'REFERRED',
  SocialNetwork = 'SOCIAL_NETWORK',
  Unspecified = 'UNSPECIFIED',
  UploadMassive = 'UPLOAD_MASSIVE'
}

export enum AtsOriginMoveCandidatesEnum {
  ApplicantProfile = 'APPLICANT_PROFILE',
  Pipeline = 'PIPELINE'
}

export type AtsPersonalInfoItem = {
  __typename?: 'ATSPersonalInfoItem';
  id: Scalars['ID']['output'];
  label: AtsCandidatePersonalInfoTypeEnum;
  visibility: AtsCandidateFormVisibilityTypeEnum;
};

export type AtsPipelineFilterInput = {
  /** IDs de quienes presentaron a los candidatos. Sólo devuelve candidatos agregados por esas personas. */
  added_by_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  affinity_weights?: InputMaybe<Array<AtsAffinityWeightEnum>>;
  is_marked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Si es verdadero, devuelve sólo los candidatos que llegaron sin que nadie los agregara: postulantes del portal y los cargados antes de que existiera la atribución, que se comportan igual. */
  only_applied_directly?: InputMaybe<Scalars['Boolean']['input']>;
  stage_id?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AtsPipelineResponse = PrivateAtsPipelineByStageList | ResponseInternalError | ResponseValidationError;

export enum AtsPipelineSortFieldEnum {
  JobApplicantAffinity = 'JOB_APPLICANT_AFFINITY',
  JobApplicantCreatedAt = 'JOB_APPLICANT_CREATED_AT'
}

export type AtsPipelineSortOrderInput = {
  direction: OrderDirectionEnum;
  field: AtsPipelineSortFieldEnum;
};

export enum AtsPipelineTemplateStageSearchFieldsEnum {
  PipelineTemplateTitle = 'PIPELINE_TEMPLATE_TITLE'
}

export type AtsPipelineTemplateStageSearchInput = {
  fields: Array<AtsPipelineTemplateStageSearchFieldsEnum>;
  query: Scalars['String']['input'];
};

export type AtsPipelineTemplateStageSortInput = {
  direction: OrderDirectionEnum;
  field: AtsPipelineTemplateStageSortOrderEnum;
};

export enum AtsPipelineTemplateStageSortOrderEnum {
  PipelineTemplateTitle = 'PIPELINE_TEMPLATE_TITLE',
  PipelineTemplateVacancies = 'PIPELINE_TEMPLATE_VACANCIES'
}

export type AtsProfileCandidateQuestionsResponse = PrivateAtsCandidateProfileQuestions | ResponseInternalError | ResponseValidationError;

export type AtsProfileCandidateResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsJobApplicantProfile | ResponseInternalError | ResponseValidationError | ValidationErrorV2;

export type AtsProfileCandidateStageDocumentsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the job applicant */
  id: Scalars['ID']['input'];
  /** ID of the job vacancy */
  job_vacancy_id: Scalars['ID']['input'];
};

export type AtsProfileCandidateStageDocumentsResponse = AtsCandidateStageDocumentsPayload | InternalErrorV2 | ValidationErrorV2;

export type AtsPublicCentralizedOrganization = {
  __typename?: 'ATSPublicCentralizedOrganization';
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AtsPublicCustomCentralizedOrganization = {
  __typename?: 'ATSPublicCustomCentralizedOrganization';
  legal_file?: Maybe<File>;
  rrss_logo?: Maybe<File>;
};

export type AtsPublishVacancyInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsPublishVacancyResponse = MutationInternalExistsError | MutationRequisitionIdentifierError | MutationValidationExistsError | PrivateAtsPublishVacancyPayload;

export type AtsQuestionAnswerInput = {
  /** EvaluationTemplateCardSection id */
  card_section_id: Scalars['ID']['input'];
  card_type: AtsCardTypeEnum;
  /** to edit response scorecard JobApplicantProfileQuestion id */
  id?: InputMaybe<Scalars['ID']['input']>;
  is_optional: Scalars['Boolean']['input'];
  response?: InputMaybe<Scalars['String']['input']>;
};

export type AtsRecruitmentMutation = {
  __typename?: 'ATSRecruitmentMutation';
  /** Accept offer job vacancy. Since TCSTC-4653 this is the gesture that defines a hire: it is what moves hired_number, can_be_closed_as_hired and every hiring metric. The organization is taken from the SESSION; centralized_organization_id on the input is kept on the wire (inherited from ATSBaseInput) but IGNORED — reading the SDL alone would suggest it selects the tenant, and it does not. */
  accept_offer_job_applicant_admin: AtsAcceptOfferJobApplicantResponse;
  /** Mutation to assign vacancy to one or many career sites */
  assign_vacancy_to_career_sites_admin: AtsAssignmentJobVacancyCareerSiteResponse;
  /** Mutation to bulk update job vacancy stages */
  bulk_update_job_vacancy_stage_admin: AtsBulkUpdateJobVacancyStageResponse;
  /** Mutation to calculate and update job vacancy rates. */
  calculate_job_vacancy_rates: AtsJobVacancyRatesResponse;
  /** Agrega un candidato a una vacante registrando qué reclutador lo presentó. La organización y el autor salen de la sesión, nunca del input. */
  create_applicant_by_recruiter_admin: AtsCreateApplicantByRecruiterResponse;
  create_applicant_required_documents: AtsRegisterApplicantRequiredDocumentsResponse;
  /** Mutation to create an attachment form (documents optional). */
  create_attachment_form_admin: AtsAttachmentFormResponse;
  /** Mutation to save a candidate form information fields and questions */
  create_candidate_form_admin: AtsCreateCandidateFormResponse;
  /** Mutation to save a question in candidate_form step */
  create_candidate_form_question_admin: AtsCreateCandidateFormQuestionResponse;
  /** Mutation to create a custom centralized organization for ATS */
  create_centralized_organization_config_admin: AtsCreateCustomCentralizedOrganizationResponse;
  /** Add comment to job vacancy request for the admin */
  create_comment_to_job_vacancy_request_admin: AtsAddCommentJobVacancyRequestResponse;
  /** Add or update documents in an existing attachment form. */
  create_documents_to_form_admin: AtsAddAttachmentResponse;
  /** Mutation to save an evaluation card question */
  create_evaluation_card_question_section: AtsCreateEvaluationCardQuestionResponse;
  /** Mutation to save a evaluation template */
  create_evaluation_template_admin: AtsEvaluationTemplateResponse;
  /** Mutation to save an evaluation template card section */
  create_evaluation_template_card_section_admin: AtsEvaluationTemplateCardSectionResponse;
  /** Mutation to block a job applicant and add them to the blacklist */
  create_job_applicant_blocked: AtsBlockApplicantResponse;
  /** Create a applicant with your answers. */
  create_job_applicant_profile: CreateJobApplicantProfileResponse;
  /** Create tag for a job vacancy */
  create_job_applicant_tag_admin: AtsCreateTagJobApplicantProfileResponse;
  /** Mutation to create a job vacancy */
  create_job_vacancy_admin: AtsCreateVacancyResponse;
  /** Create a JobVacancyConfigRequest (step 1 of the wizard) */
  create_job_vacancy_config_request_admin: AtsCreateJobVacancyConfigRequestResponse;
  /** Mutation to create a vacancy extra field */
  create_job_vacancy_extra_field_admin: AtsCreateJobVacancyExtraFieldResponse;
  /** Create a job vacancy request collaborator */
  create_job_vacancy_request_collaborator: AtsCreateJobVacancyRequestCollaboratorResponse;
  /** Mutation to create a vacancy stage */
  create_job_vacancy_stage_admin: AtsCreateJobVacancyStageResponse;
  /** Mutation to assign a template in vacancy stages */
  create_job_vacancy_stages_from_pipeline_template_admin: AtsJobVacancyStagesResponse;
  /** Mutation to save a mail template */
  create_mail_template_admin: AtsCreateMailTemplateResponse;
  /** Add note to audit log service */
  create_note_job_applicant_admin: AtsAddNoteToJobApplicantResponse;
  /** Mutation to request an Excel report generation */
  create_or_get_report_request_admin: AtsRequestReportResponse;
  /** Mutation to save or edit a recruitment team */
  create_or_update_recruitment_team_admin: AtsCreateOrUpdateRecruitmentTeamResponse;
  /** Mutation to create or update a template for vacancy stages */
  create_pipeline_template_job_vacancy_stages_admin: AtsCreatePipelineTemplateJobVacancyStageResponse;
  /** Create stakeholder evaluation card questionnaire responses */
  create_questionnaire_responses_collaborator: AtsCreateStakeHolderQuestionnaireResponse;
  /** Generates a new massive upload Excel template for a specific vacancy */
  create_template_job_applicant_massive_upload: AtsCreateJobApplicantMassiveUploadTemplateResponse;
  /** Create a JobVacancyConfigRequest (step 2 of the wizard) */
  create_update_application_form_admin: AtsCreateApplicationFormResponse;
  /** Create / update approval settings (wizard paso 4) */
  create_update_approval_admin: AtsCreateApprovalResponse;
  /** Create / update assignment rules (wizard paso 3) */
  create_update_assignment_admin: AtsCreateAssignmentResponse;
  /** Mutation to create or update career site */
  create_update_career_site_admin: AtsCreateUpdateCareerSiteConfigResponse;
  /** Mutation to save a company badge */
  create_update_company_badge_admin: AtsCreateUpdateCompanyBadgeResponse;
  /** Mutation to create a company tag */
  create_update_company_tag_admin: AtsCreateUpdateJobApplicantTagResponse;
  /** Create or Update a job vacancy request form config extra fields */
  create_update_job_vacancy_request_form_config_extra_fields_admin: AtsCreateJobVacancyFormRequestConfigExtraFieldsResponse;
  /** Mutation to create valid job applicants from bulk upload (id) processed data */
  create_valid_applicants_from_bulk_upload: AtsCreateValidApplicantsResponse;
  /** Mutation to delete an existing attachment form with its documents/folders. */
  delete_attachment_form_admin: AtsDeleteAttachmentFormResponse;
  /** Mutation to delete an existing attachment form document */
  delete_attachment_form_documents_admin: AtsDeleteAttachmentFormDocumentResponse;
  /** Mutation to delete a company badge */
  delete_company_badge_admin: AtsDeleteCompanyBadgeResponse;
  /** Mutation to delete a company tag */
  delete_company_tag_admin: AtsDeleteJobApplicantTagResponse;
  /** Mutation to delete the evaluation cards for the admin interface */
  delete_evaluation_template_admin: AtsDeleteEvaluationCardResponse;
  /** Delete tag for a job vacancy */
  delete_job_applicant_tag_admin: AtsDeleteJobApplicantTagResponse;
  /** Mutation to change job vacancy status to delete */
  delete_job_vacancy_admin: AtsDeleteJobVacancyResponse;
  /** Logical delete of JobVacancyConfigRequest */
  delete_job_vacancy_config_request_admin: AtsDeleteJobVacancyConfigRequestResponse;
  /** Cancel a job vacancy request collaborator */
  delete_job_vacancy_form_request_collaborator: AtsDeleteJobVacancyFormRequestCollaboratorResponse;
  /** Mutation to delete a mail template */
  delete_mail_template_admin: AtsDeleteMailTemplateResponse;
  /** Mutation to create or update a template for vacancy stages */
  delete_pipeline_template_job_vacancy_stages_admin: AtsDeletePipelineTemplateJobVacancyStageResponse;
  /** Discard applicants (is_discarded=True) */
  discard_job_applicant_admin: AtsDiscardJobApplicantResponse;
  /** Send a test email using Mailman */
  dispatch_test_mail_admin: AtsSendTestEmailResponse;
  /** Download the bulk upload error log in Excel format */
  download_job_applicant_error_log: AtsDownloadJobApplicantErrorLogResponse;
  /** Mutation to duplicate an existing attachment form with its documents/folders. */
  duplicate_attachment_form_admin: AtsAttachmentFormResponse;
  /** Mutation to duplicate the evaluation cards for the admin interface */
  duplicate_evaluation_template_admin: AtsDuplicateEvaluationCardResponse;
  /** Mutation to duplicate job vacancy */
  duplicate_job_vacancy_admin: AtsDuplicateJobVacancyResponse;
  /** Duplicate a JobVacancyConfigRequest with all its steps */
  duplicate_job_vacancy_config_request_admin: AtsDuplicateJobVacancyConfigRequestResponse;
  /** Mutation to duplicate a mail template */
  duplicate_mail_template_admin: AtsDuplicateMailTemplateResponse;
  /** Mutation to duplicate a pipeline template job vacancy stages  */
  duplicate_pipeline_template_job_vacancy_stages_admin: AtsCreatePipelineTemplateJobVacancyStageResponse;
  /** Mutation to edit a candidate form question */
  edit_candidate_form_question_admin: AtsEditCandidateFormQuestionResponse;
  /** Edit evaluation card question section */
  edit_evaluation_card_question_section: AtsEditEvaluationCardQuestionResponse;
  /** Mutation to update a job vacancy step one */
  edit_job_vacancy_admin: AtsUpdateVacancyResponse;
  /** Mutation to enable job vacancies in career site  */
  enable_job_vacancies_in_career_site_admin: AtsEnableJobVacancyCareerSiteResponse;
  /** Generate and send OTP to applicant email for verification. */
  generate_applicant_otp: GenerateJobApplicantOtpResponse;
  /** Update the state of the vacancy (open, close, pause). */
  generate_keywords_admin: AtsGenerateKeywordsResponse;
  /** Mutation to hide career site */
  hide_career_site_admin: AtsHideCareerSiteConfigResponse;
  /** Move discarded job applicant for a new stage. */
  move_discarded_job_applicant_admin: AtsMoveDiscardedJobApplicantResponse;
  /** Move multiple candidates for a new stage. */
  move_stage_job_applicant_admin: AtsMoveStageJobApplicantResponse;
  /** Mutation to publish to vacancy */
  publish_vacancy_admin: AtsPublishVacancyResponse;
  /** Send e-mail / evaluation notifications to applicants */
  send_notification_admin: AtsSendNotificationResponse;
  /** Set centralized_user_id on ApplicantProfile */
  set_applicant_profile_centralized_user: AtsSetCentralizedUserResponse;
  /** Register a unique visit per IP/day for a vacancy */
  track_vacancy_visit: AtsTrackVisitResponse;
  update_applicant_document: AtsUpdatedApplicantDocumentResponse;
  /** Mutation to update an existing attachment form. */
  update_attachment_form_admin: AtsAttachmentFormResponse;
  /** Update attributes and scale evaluation card section */
  update_attribute_and_scale_evaluation_card_section: AtsEvaluationTemplateResponse;
  /** Mutation to update a custom centralized organization for ATS */
  update_centralized_organization_config_admin: AtsUpdateCustomCentralizedOrganizationResponse;
  /** Mutation to update an evaluation template to PUBLISHED state */
  update_evaluation_template_admin: AtsEvaluationTemplateResponse;
  /** Mutation to mark or unmark an applicant for the admin interface */
  update_job_applicant_mark: AtsMarkJobApplicantResponse;
  /** Update tags for a job applicant */
  update_job_applicant_tags_admin: AtsBulkUpdateJobApplicantTagResponse;
  /** Update a JobVacancyConfigRequest (step 1 of the wizard) */
  update_job_vacancy_config_request_admin: AtsUpdateJobVacancyConfigRequestResponse;
  /** Activate / deactivate the visibility of an application form */
  update_job_vacancy_config_request_visibility_admin: AtsUpdateJobVacancyConfigRequestVisibilityResponse;
  /** Update a job vacancy request collaborator */
  update_job_vacancy_form_request_collaborator: AtsUpdateJobVacancyFormRequestCollaboratorResponse;
  /** Change the status of a vacancy application (approve reject) */
  update_job_vacancy_request_state_admin: AtsChangeJobVacancyRequestStateResponse;
  /** Approve or reject a job vacancy request as a stakeholder */
  update_job_vacancy_request_state_collaborator: AtsApproveJobVacancyRequestStakeholderResponse;
  /** Mutation for editing an mail template */
  update_mail_template_admin: AtsUpdateMailTemplateResponse;
  /** Mutation to update a mail template availability */
  update_mail_template_availability_admin: AtsUpdateMailTemplateAvailabilityResponse;
  /** Mutation to update reorder documents inside an attachment form. */
  update_reorder_attachment_documents_admin: AtsAttachmentFormResponse;
  /** Update the state of the vacancy (open, close, hire, cancel, pause). VACANCY_HIRED requires at least one hired candidate on the vacancy. */
  update_state_job_vacancy_admin: AtsUpdateStateJobVacancyResponse;
  /** Validates and cleans up a bulk upload file. Generates an Excel file with valid candidates and saves errors. */
  validate_job_applicant_massive_upload: AtsValidateJobApplicantMassiveUploadResponse;
};


export type AtsRecruitmentMutationAccept_Offer_Job_Applicant_AdminArgs = {
  input: AtsAcceptOfferJobApplicantInput;
};


export type AtsRecruitmentMutationAssign_Vacancy_To_Career_Sites_AdminArgs = {
  input: AtsAssignmentJobVacancyCareerSiteInput;
};


export type AtsRecruitmentMutationBulk_Update_Job_Vacancy_Stage_AdminArgs = {
  input: AtsBulkUpdateJobVacancyStageInput;
};


export type AtsRecruitmentMutationCalculate_Job_Vacancy_RatesArgs = {
  input: AtsCalculateRatesInput;
};


export type AtsRecruitmentMutationCreate_Applicant_By_Recruiter_AdminArgs = {
  input: AtsCreateApplicantByRecruiterInput;
};


export type AtsRecruitmentMutationCreate_Applicant_Required_DocumentsArgs = {
  input: AtsRegisterApplicantRequiredDocumentsInput;
};


export type AtsRecruitmentMutationCreate_Attachment_Form_AdminArgs = {
  input: AtsCreateAttachmentFormInput;
};


export type AtsRecruitmentMutationCreate_Candidate_Form_AdminArgs = {
  input: AtsCreateCandidateFormInput;
};


export type AtsRecruitmentMutationCreate_Candidate_Form_Question_AdminArgs = {
  input: AtsCreateCandidateFormQuestionInput;
};


export type AtsRecruitmentMutationCreate_Centralized_Organization_Config_AdminArgs = {
  input: AtsCreateCustomCentralizedOrganizationInput;
};


export type AtsRecruitmentMutationCreate_Comment_To_Job_Vacancy_Request_AdminArgs = {
  input: AtsAddCommentJobVacancyRequestInput;
};


export type AtsRecruitmentMutationCreate_Documents_To_Form_AdminArgs = {
  input: AtsAddDocumentsInput;
};


export type AtsRecruitmentMutationCreate_Evaluation_Card_Question_SectionArgs = {
  input: AtsCreateEvaluationCardQuestionInput;
};


export type AtsRecruitmentMutationCreate_Evaluation_Template_AdminArgs = {
  input: AtsCreateEvaluationTemplateInput;
};


export type AtsRecruitmentMutationCreate_Evaluation_Template_Card_Section_AdminArgs = {
  input: AtsCreateEvaluationTemplateCardSectionInput;
};


export type AtsRecruitmentMutationCreate_Job_Applicant_BlockedArgs = {
  input: AtsBlockApplicantInput;
};


export type AtsRecruitmentMutationCreate_Job_Applicant_ProfileArgs = {
  input: CreateJobApplicantProfileInput;
};


export type AtsRecruitmentMutationCreate_Job_Applicant_Tag_AdminArgs = {
  input: AtsCreateJobApplicantTagInput;
};


export type AtsRecruitmentMutationCreate_Job_Vacancy_AdminArgs = {
  input: AtsCreateJobVacancyInput;
};


export type AtsRecruitmentMutationCreate_Job_Vacancy_Config_Request_AdminArgs = {
  input: AtsCreateJobVacancyConfigRequestInput;
};


export type AtsRecruitmentMutationCreate_Job_Vacancy_Extra_Field_AdminArgs = {
  input: AtsCreateOrUpdateJobVacancyExtraFieldsInput;
};


export type AtsRecruitmentMutationCreate_Job_Vacancy_Request_CollaboratorArgs = {
  input: AtsCreateJobVacancyRequestCollaboratorInput;
};


export type AtsRecruitmentMutationCreate_Job_Vacancy_Stage_AdminArgs = {
  input: AtsCreateJobVacancyStageInput;
};


export type AtsRecruitmentMutationCreate_Job_Vacancy_Stages_From_Pipeline_Template_AdminArgs = {
  input: AtsCreateJobVacancyStageFromPipelineTemplateInput;
};


export type AtsRecruitmentMutationCreate_Mail_Template_AdminArgs = {
  input: AtsCreateMailTemplateInput;
};


export type AtsRecruitmentMutationCreate_Note_Job_Applicant_AdminArgs = {
  input: AtsAddNoteToJobApplicantInput;
};


export type AtsRecruitmentMutationCreate_Or_Get_Report_Request_AdminArgs = {
  input: AtsRequestReportInput;
};


export type AtsRecruitmentMutationCreate_Or_Update_Recruitment_Team_AdminArgs = {
  input: AtsCreateOrUpdateRecruitmentTeamInput;
};


export type AtsRecruitmentMutationCreate_Pipeline_Template_Job_Vacancy_Stages_AdminArgs = {
  input: AtsCreateOrUpdateJobVacancyStagePipelineTemplateInput;
};


export type AtsRecruitmentMutationCreate_Questionnaire_Responses_CollaboratorArgs = {
  input: AtsCreateStakeholderQuestionnaireResponsesInput;
};


export type AtsRecruitmentMutationCreate_Template_Job_Applicant_Massive_UploadArgs = {
  input: AtsCreateJobApplicantMassiveUploadTemplateInput;
};


export type AtsRecruitmentMutationCreate_Update_Application_Form_AdminArgs = {
  input: AtsCreateApplicationFormInput;
};


export type AtsRecruitmentMutationCreate_Update_Approval_AdminArgs = {
  input: AtsCreateApprovalInput;
};


export type AtsRecruitmentMutationCreate_Update_Assignment_AdminArgs = {
  input: AtsCreateAssignmentInput;
};


export type AtsRecruitmentMutationCreate_Update_Career_Site_AdminArgs = {
  input: AtsCreateUpdateCareerSiteConfigInput;
};


export type AtsRecruitmentMutationCreate_Update_Company_Badge_AdminArgs = {
  input: AtsCreateOrUpdateCompanyBadgeInput;
};


export type AtsRecruitmentMutationCreate_Update_Company_Tag_AdminArgs = {
  input: AtsCreateUpdateCompanyTagsInput;
};


export type AtsRecruitmentMutationCreate_Update_Job_Vacancy_Request_Form_Config_Extra_Fields_AdminArgs = {
  input: AtsCreateOrUpdateJobVacancyRequestFormConfigExtraFieldInput;
};


export type AtsRecruitmentMutationCreate_Valid_Applicants_From_Bulk_UploadArgs = {
  input: AtsCreateValidApplicantsInput;
};


export type AtsRecruitmentMutationDelete_Attachment_Form_AdminArgs = {
  input: AtsDeletedAttachmentFormInput;
};


export type AtsRecruitmentMutationDelete_Attachment_Form_Documents_AdminArgs = {
  input: AtsDeletedAttachmentFormDocumentInput;
};


export type AtsRecruitmentMutationDelete_Company_Badge_AdminArgs = {
  input: AtsDeleteCompanyBadgeInput;
};


export type AtsRecruitmentMutationDelete_Company_Tag_AdminArgs = {
  input: AtsDeleteCompanyTagInput;
};


export type AtsRecruitmentMutationDelete_Evaluation_Template_AdminArgs = {
  input: AtsDeleteEvaluationCardInput;
};


export type AtsRecruitmentMutationDelete_Job_Applicant_Tag_AdminArgs = {
  input: AtsDeleteJobApplicantTagInput;
};


export type AtsRecruitmentMutationDelete_Job_Vacancy_AdminArgs = {
  input: AtsDeleteJobVacancyInput;
};


export type AtsRecruitmentMutationDelete_Job_Vacancy_Config_Request_AdminArgs = {
  input: AtsDeleteJobVacancyConfigRequestInput;
};


export type AtsRecruitmentMutationDelete_Job_Vacancy_Form_Request_CollaboratorArgs = {
  input: AtsDeleteJobVacancyFormRequestCollaboratorInput;
};


export type AtsRecruitmentMutationDelete_Mail_Template_AdminArgs = {
  input: AtsDeleteMailTemplateInput;
};


export type AtsRecruitmentMutationDelete_Pipeline_Template_Job_Vacancy_Stages_AdminArgs = {
  input: AtsDeletePipelineTemplateJobVacancyStageInput;
};


export type AtsRecruitmentMutationDiscard_Job_Applicant_AdminArgs = {
  input: AtsDiscardJobApplicantInput;
};


export type AtsRecruitmentMutationDispatch_Test_Mail_AdminArgs = {
  input: SendTestEmailInput;
};


export type AtsRecruitmentMutationDownload_Job_Applicant_Error_LogArgs = {
  input: AtsDownloadJobApplicantErrorLogInput;
};


export type AtsRecruitmentMutationDuplicate_Attachment_Form_AdminArgs = {
  input: AtsDuplicatedAttachmentFormInput;
};


export type AtsRecruitmentMutationDuplicate_Evaluation_Template_AdminArgs = {
  input: AtsDuplicateEvaluationCardInput;
};


export type AtsRecruitmentMutationDuplicate_Job_Vacancy_AdminArgs = {
  input: AtsDuplicateJobVacancyInput;
};


export type AtsRecruitmentMutationDuplicate_Job_Vacancy_Config_Request_AdminArgs = {
  input: AtsDuplicateJobVacancyConfigRequestInput;
};


export type AtsRecruitmentMutationDuplicate_Mail_Template_AdminArgs = {
  input: AtsDuplicateMailTemplateInput;
};


export type AtsRecruitmentMutationDuplicate_Pipeline_Template_Job_Vacancy_Stages_AdminArgs = {
  input: AtsDuplicatePipelineTemplateJobVacancyStageInput;
};


export type AtsRecruitmentMutationEdit_Candidate_Form_Question_AdminArgs = {
  input: AtsEditCandidateFormQuestionInput;
};


export type AtsRecruitmentMutationEdit_Evaluation_Card_Question_SectionArgs = {
  input: AtsEditEvaluationCardQuestionInput;
};


export type AtsRecruitmentMutationEdit_Job_Vacancy_AdminArgs = {
  input: AtsUpdateJobVacancyInput;
};


export type AtsRecruitmentMutationEnable_Job_Vacancies_In_Career_Site_AdminArgs = {
  input: AtsJobVacancyStatusCareerSiteInput;
};


export type AtsRecruitmentMutationGenerate_Applicant_OtpArgs = {
  input: GenerateJobApplicantOtpInput;
};


export type AtsRecruitmentMutationGenerate_Keywords_AdminArgs = {
  input: AtsGenerateKeywordsInput;
};


export type AtsRecruitmentMutationHide_Career_Site_AdminArgs = {
  input: AtsHideCareerSiteConfigInput;
};


export type AtsRecruitmentMutationMove_Discarded_Job_Applicant_AdminArgs = {
  input: AtsMoveDiscardedJobApplicantInput;
};


export type AtsRecruitmentMutationMove_Stage_Job_Applicant_AdminArgs = {
  input: AtsMoveStateJobApplicantInput;
};


export type AtsRecruitmentMutationPublish_Vacancy_AdminArgs = {
  input: AtsPublishVacancyInput;
};


export type AtsRecruitmentMutationSend_Notification_AdminArgs = {
  input: AtsSendNotificationInput;
};


export type AtsRecruitmentMutationSet_Applicant_Profile_Centralized_UserArgs = {
  input: AtsSetCentralizedUserInput;
};


export type AtsRecruitmentMutationTrack_Vacancy_VisitArgs = {
  input: AtsGetVacancyStatsInput;
};


export type AtsRecruitmentMutationUpdate_Applicant_DocumentArgs = {
  input: AtsUpdateApplicantDocumentInput;
};


export type AtsRecruitmentMutationUpdate_Attachment_Form_AdminArgs = {
  input: AtsUpdateAttachmentFormInput;
};


export type AtsRecruitmentMutationUpdate_Attribute_And_Scale_Evaluation_Card_SectionArgs = {
  input: AtsUpdateAttributesWithScaleInputType;
};


export type AtsRecruitmentMutationUpdate_Centralized_Organization_Config_AdminArgs = {
  input: AtsUpdateCustomCentralizedOrganizationInput;
};


export type AtsRecruitmentMutationUpdate_Evaluation_Template_AdminArgs = {
  input: AtsUpdateEvaluationTemplateInput;
};


export type AtsRecruitmentMutationUpdate_Job_Applicant_MarkArgs = {
  input: AtsUpdateJobApplicantMarkInput;
};


export type AtsRecruitmentMutationUpdate_Job_Applicant_Tags_AdminArgs = {
  input: AtsUpdateJobApplicantTagsInput;
};


export type AtsRecruitmentMutationUpdate_Job_Vacancy_Config_Request_AdminArgs = {
  input: AtsUpdateJobVacancyConfigRequestInput;
};


export type AtsRecruitmentMutationUpdate_Job_Vacancy_Config_Request_Visibility_AdminArgs = {
  input: AtsUpdateJobVacancyConfigRequestVisibilityInput;
};


export type AtsRecruitmentMutationUpdate_Job_Vacancy_Form_Request_CollaboratorArgs = {
  input: AtsUpdateJobVacancyFormRequestCollaboratorInput;
};


export type AtsRecruitmentMutationUpdate_Job_Vacancy_Request_State_AdminArgs = {
  input: AtsChangeJobVacancyRequestStateInput;
};


export type AtsRecruitmentMutationUpdate_Job_Vacancy_Request_State_CollaboratorArgs = {
  input: AtsApproveJobVacancyRequestStakeholderInput;
};


export type AtsRecruitmentMutationUpdate_Mail_Template_AdminArgs = {
  input: AtsUpdateMailTemplateInput;
};


export type AtsRecruitmentMutationUpdate_Mail_Template_Availability_AdminArgs = {
  input: AtsUpdateMailTemplateAvailabilityInput;
};


export type AtsRecruitmentMutationUpdate_Reorder_Attachment_Documents_AdminArgs = {
  input: AtsReorderDocumentsInput;
};


export type AtsRecruitmentMutationUpdate_State_Job_Vacancy_AdminArgs = {
  input: AtsUpdateStateJobVacancyInput;
};


export type AtsRecruitmentMutationValidate_Job_Applicant_Massive_UploadArgs = {
  input: AtsValidateJobApplicantMassiveUploadInput;
};

export type AtsRecruitmentPerformanceConnection = {
  __typename?: 'ATSRecruitmentPerformanceConnection';
  edges: Array<PrivateAtsRecruitmentPerformanceEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type AtsRecruitmentQuery = {
  __typename?: 'ATSRecruitmentQuery';
  /** Query to get the evaluation cards for the admin interface */
  get_admin_evaluation_cards: AtsEvaluationCardsResponse;
  get_applicant_attachment_form_detail_otp: AtsApplicantAttachmentFormDetailResponse;
  /** Si esta persona ya participó en otra vacante de la organización, y con qué resultado. Se consulta ANTES de cargar al candidato, para poder ofrecerle al reclutador traer su historial. */
  get_applicant_previous_participations_admin: AtsApplicantPreviousParticipationsResponse;
  /** Query to get candidates disability distribution statistics */
  get_ats_candidates_disability_stats_admin: AtsCandidatesDisabilityStatsResponse;
  /** Query to get candidate gender distribution per vacancy */
  get_ats_candidates_gender_for_vacancy_admin: AtsCandidatesGenderForVacancyResponse;
  /** Query to get candidates gender distribution statistics */
  get_ats_candidates_gender_stats_admin: AtsCandidatesGenderStatsResponse;
  /** Query to get candidate source distribution statistics */
  get_ats_candidates_source_stats_admin: AtsCandidatesSourceStatsResponse;
  /** Query to get hiring by source statistics */
  get_ats_hiring_by_source_stats_admin: AtsHiringBySourceStatsResponse;
  /** Retrieves detailed information about an attachment folder for administrators. */
  get_attachment_folder_admin: AtsAttachmentFolderResponse;
  /** Retrieves paginated documents from a folder for administrators. */
  get_attachment_folder_documents_admin: AtsFolderAttachmentDocumentsResponse;
  /** Retrieves a single attachment form for administrators. */
  get_attachment_form_admin: AtsAttachmentFormResponse;
  /** Retrieves paginated attachment form documents for administrators. */
  get_attachment_form_documents_admin: AtsAttachmentDocumentsResponse;
  /** Retrieves paginated attachment form folders for administrators. */
  get_attachment_form_folders_admin: AtsAttachmentFoldersResponse;
  /** Retrieves paginated attachment forms with search, filtering, and sorting capabilities for administrators. */
  get_attachment_forms_admin: AtsAttachmentFormsResponse;
  /** Query to get average days per stage for a vacancy */
  get_avg_time_per_stage_vacancy_admin: AtsAverageStageVacancyResponse;
  /** Query to retrieve the list of documents submitted by the candidate at each stage */
  get_candidate_documents_submitted_by_stage_admin: AtsProfileCandidateStageDocumentsResponse;
  /** Query to get vacancy detail */
  get_candidate_form_admin: AtsCandidateFormResponse;
  /** Query to get candidate source distribution per vacancy */
  get_candidate_sources_distribution_admin: AtsGetCandidateSourcesDistributionResponse;
  /** Query to get career site config */
  get_career_site_admin: AtsGetCareerSiteConfigResponse;
  /** Query to get career site config PUBLIC info */
  get_career_site_config: AtsGetCareerSiteConfigInfoResponse;
  /** Query to get custom centralized organization for Admin */
  get_custom_centralized_organization_admin: AtsGetCustomCentralizedOrganizationResponse;
  /** Query to get custom centralized organization for Collaborator */
  get_custom_centralized_organization_collaborator: AtsGetCustomInfoOrganizationCollaboratorResponse;
  /** Get the details of an evaluation card based on the template ID */
  get_evaluation_card_admin: AtsEvaluationCardDetailResponse;
  /** Query to get funnel recruitment stats per vacancy */
  get_funnel_dashboard_vacancy_admin: AtsFunnelDashboardVacancyResponse;
  /** Query to get general status per vacancy for dashboard */
  get_general_status_vacancy_admin: AtsGeneralStatusVacancyResponse;
  /** Query to get hiring dashboard statistics */
  get_hiring_dashboard_stats_admin: AtsHiringDashboardStatsResponse;
  /** Query to get detail (summary and errors) of a massive upload process for applicants */
  get_job_applicant_massive_upload_detail: AtsJobApplicantMassiveUploadDetailResponse;
  /** Query to get job applicant profile detail */
  get_job_applicant_profile_admin: AtsProfileCandidateResponse;
  /** Complete detail of a application configuration */
  get_job_vacancy_config_request_admin: AtsGetJobVacancyConfigRequestResponse;
  /** Get the application form for a job vacancy config request */
  get_job_vacancy_config_request_application_form_admin: AtsGetApplicationFormResponse;
  /** Query to get data filter option for vacancy list insight view */
  get_job_vacancy_data_filter_options_admin: AtsJobVacancyFilterOptionsResponse;
  /** Query to get a job vacancy request from detail */
  get_job_vacancy_form_request_collaborator: AtsGetJobVacancyFormRequestResponse;
  /** Query to get a job vacancy request history */
  get_job_vacancy_form_request_history_collaborator: AtsGetJobVacancyFormRequestHistoryResponse;
  /** He obtains public information from a Vacancy with his fields and questions */
  get_job_vacancy_public_info: AtsCandidateFormUserResponse;
  /** Get job vacancy request detail for admin users */
  get_job_vacancy_request_detail_admin: AtsGetJobVacancyRequestDetailResponse;
  /** Query to get email template detail for the admin interface */
  get_mail_template_detail_admin: AtsMailTemplatesDetailResponse;
  /** Query to get email templates for the admin interface */
  get_mail_templates_admin: AtsMailTemplatesResponse;
  /** query to get a template detail */
  get_pipeline_template_job_vacancy_stages_admin: AtsGetPipelineTemplateJobVacancyStageResponse;
  /** query to get pipeline templates job vacancy stage from a company */
  get_pipeline_templates_job_vacancy_stages_admin: AtsGetPipelineTemplatesJobVacancyStageResponse;
  /** query to get names and id only from pipeline templates job vacancy stage from a company */
  get_pipeline_templates_reduced_job_vacancy_stages_admin: AtsGetReducedPipelineTemplatesJobVacancyStageResponse;
  /** Query to get tab of questions for a profile applicant */
  get_questions_form_candidate_profile_admin: AtsProfileCandidateQuestionsResponse;
  /** Query to get recruitment team by vacancy ID */
  get_recruitment_team_admin: AtsRecruitmentTeamResponse;
  /** Query to get recruitment team dashboard statistics */
  get_recruitment_team_dashboard_stats_admin: AtsRecruitmentTeamDashboardStatsResponse;
  /** Query to get recruitment team performance by vacancy */
  get_recruitment_team_vacancy_detail_performance_admin: AtsRecruitmentTeamVacancyPerformanceResponse;
  get_scores_cards_and_questions_admin: AtsScoresAndQuestionsApplicantProfileResponse;
  /** Public information from a Job Vacancy Stage */
  get_stage_public_info: AtsJobVacancyStagePublicResponse;
  /** Get evaluation card questionnaire to be responded by stakeholder */
  get_stakeholder_evaluation_card_questionnaire_collaborator: AtsStakeholderQuestionnaireCardResponse;
  /** Query to get vacancy dashboard statistics */
  get_vacancy_dashboard_stats_admin: AtsVacancyDashboardStatsResponse;
  /** Query to get vacancy detail with candidate form */
  get_vacancy_detail_admin: AtsJobVacancyDetailResponse;
  /** Query to get visits and applications for a vacancy by day/week/month */
  get_visits_and_applications_vacancy_admin: AtsVacancyTrafficStatsResponse;
  /** Query to get list of all job applicants */
  list_all_job_applicant_admin: AtsListAllJobApplicantResponse;
  /** Retrieves paginated career site for admin */
  list_career_site_admin: AtsListCareerSiteConfigResponse;
  /** Retrieves paginated career site for collaborators */
  list_career_site_collaborator: AtsListCareerSiteInternalResponse;
  /** Query to get a list of comments from a job vacancy request with pagination number */
  list_comments_job_vacancy_requests_admin: AtsListCommentsJobVacancyRequestResponse;
  /** Query to get company badges */
  list_company_badge_admin: AtsListCompanyBadgeResponse;
  /** query to get a  company tags list */
  list_company_tags_admin: AtsListJobApplicantTagResponse;
  /** Query to get departments for career site PUBLIC info */
  list_departments_career_site: AtsListDepartmentsCareerSiteResponse;
  /** Query to get list of job applicants and list of discarded */
  list_job_applicant_admin: AtsListJobApplicantResponse;
  /** Query to get list of job applicants attachment */
  list_job_applicant_attachment_admin: AtsJobApplicantAttachmentResponse;
  /** Query to get vacancy list */
  list_job_vacancy_admin: AtsJobVacancyResponse;
  /** Retrieves paginated job vacancy career site assignments for admin */
  list_job_vacancy_career_site_admin: AtsListJobVacancyCareerSiteResponse;
  list_job_vacancy_config_requests_admin: AtsJobVacancyConfigRequestListResponse;
  /** Query to get a job vacancy request with pagination number */
  list_job_vacancy_form_requests_admin: AtsListJobVacancyFormsRequestResponse;
  /** Query to get a list of comments from a job vacancy request with pagination number */
  list_job_vacancy_form_requests_assigned: AtsAssignedRequestFormResponse;
  /** Query to get a job vacancy requests received  */
  list_job_vacancy_form_requests_received_collaborator: AtsListJobVacancyFormRequestReceivedResponse;
  /** Query to get a job vacancy request with pagination number */
  list_job_vacancy_requests_admin: AtsListJobVacancyRequestResponse;
  /** Query to get vacancy stages */
  list_job_vacancy_stages_admin: AtsJobVacancyStagesResponse;
  /** Query to get pipeline with list of job applicants */
  list_pipeline_admin: AtsPipelineResponse;
  /** Get vacancies list by stakeholder */
  list_stakeholder_vacancies_collaborator: AtsStakeholderVacanciesResponse;
  /** List stakeholder vacancy task */
  list_stakeholder_vacancy_task_collaborator: AtsListStakeholderTaskResponse;
  /** Query to get all tags by job vacancy */
  list_tags_by_job_vacancy_admin: AtsListJobApplicantTagsResponse;
  /** Query to get job vacancies from career-site PUBLIC - EXTERNAL info */
  list_vacancies_career_site: AtsJobVacancyCareerSiteResponse;
  /** Query to get job vacancies from career-site INTERNAL */
  list_vacancies_career_site_collaborator: AtsJobVacancyCareerSiteResponse;
  /** Quiénes agregaron al menos un candidato en esta vacante. Son las opciones reales del filtro «Agregado por»: no el equipo completo, sólo quienes presentaron a alguien. Devuelve las opciones del TABLERO salvo que `is_reception` sea verdadero, en cuyo caso devuelve las de la pantalla de recepción. */
  list_vacancy_attribution_options_admin: AtsVacancyAttributionOptionsResponse;
};


export type AtsRecruitmentQueryGet_Admin_Evaluation_CardsArgs = {
  input: AtsEvaluationCardsInput;
};


export type AtsRecruitmentQueryGet_Applicant_Attachment_Form_Detail_OtpArgs = {
  input: AtsApplicantAttachmentFormDetailOtpInput;
};


export type AtsRecruitmentQueryGet_Applicant_Previous_Participations_AdminArgs = {
  input: AtsGetApplicantPreviousParticipationsInput;
};


export type AtsRecruitmentQueryGet_Ats_Candidates_Disability_Stats_AdminArgs = {
  input: AtsGetCandidatesDisabilityStatsInput;
};


export type AtsRecruitmentQueryGet_Ats_Candidates_Gender_For_Vacancy_AdminArgs = {
  input: AtsGetVacancyStatsInput;
};


export type AtsRecruitmentQueryGet_Ats_Candidates_Gender_Stats_AdminArgs = {
  input: AtsGetCandidatesGenderStatsInput;
};


export type AtsRecruitmentQueryGet_Ats_Candidates_Source_Stats_AdminArgs = {
  input: AtsGetCandidatesSourceStatsInput;
};


export type AtsRecruitmentQueryGet_Ats_Hiring_By_Source_Stats_AdminArgs = {
  input: AtsGetHiringBySourceStatsInput;
};


export type AtsRecruitmentQueryGet_Attachment_Folder_AdminArgs = {
  input: AtsAttachmentFolderInput;
};


export type AtsRecruitmentQueryGet_Attachment_Folder_Documents_AdminArgs = {
  input: AtsAttachmentFolderDocumentsInput;
};


export type AtsRecruitmentQueryGet_Attachment_Form_AdminArgs = {
  input: AtsAttachmentFormInput;
};


export type AtsRecruitmentQueryGet_Attachment_Form_Documents_AdminArgs = {
  input: AtsAttachmentFormDocumentsInput;
};


export type AtsRecruitmentQueryGet_Attachment_Form_Folders_AdminArgs = {
  input: AtsAttachmentFoldersInput;
};


export type AtsRecruitmentQueryGet_Attachment_Forms_AdminArgs = {
  input: AtsListAttachmentFormInput;
};


export type AtsRecruitmentQueryGet_Avg_Time_Per_Stage_Vacancy_AdminArgs = {
  input: AtsGetVacancyStatsInput;
};


export type AtsRecruitmentQueryGet_Candidate_Documents_Submitted_By_Stage_AdminArgs = {
  input: AtsProfileCandidateStageDocumentsInput;
};


export type AtsRecruitmentQueryGet_Candidate_Form_AdminArgs = {
  input: AtsGetCandidateFormInput;
};


export type AtsRecruitmentQueryGet_Candidate_Sources_Distribution_AdminArgs = {
  input: AtsGetVacancyStatsInput;
};


export type AtsRecruitmentQueryGet_Career_Site_AdminArgs = {
  input: AtsGetCareerSiteConfigInput;
};


export type AtsRecruitmentQueryGet_Career_Site_ConfigArgs = {
  input: AtsCareerSiteConfigInput;
};


export type AtsRecruitmentQueryGet_Custom_Centralized_Organization_AdminArgs = {
  input: AtsGetCustomCentralizedOrganizationInput;
};


export type AtsRecruitmentQueryGet_Custom_Centralized_Organization_CollaboratorArgs = {
  input: AtsGetCustomCentralizedOrganizationInput;
};


export type AtsRecruitmentQueryGet_Evaluation_Card_AdminArgs = {
  input: AtsEvaluationCardInput;
};


export type AtsRecruitmentQueryGet_Funnel_Dashboard_Vacancy_AdminArgs = {
  input: AtsGetVacancyStatsInput;
};


export type AtsRecruitmentQueryGet_General_Status_Vacancy_AdminArgs = {
  input: AtsGetVacancyStatsInput;
};


export type AtsRecruitmentQueryGet_Hiring_Dashboard_Stats_AdminArgs = {
  input: AtsGetHiringDashboardStatsInput;
};


export type AtsRecruitmentQueryGet_Job_Applicant_Massive_Upload_DetailArgs = {
  input: AtsJobApplicantMassiveUploadDetailInput;
};


export type AtsRecruitmentQueryGet_Job_Applicant_Profile_AdminArgs = {
  input: AtsApplicantProfileInput;
};


export type AtsRecruitmentQueryGet_Job_Vacancy_Config_Request_AdminArgs = {
  input: AtsGetJobVacancyConfigRequestInput;
};


export type AtsRecruitmentQueryGet_Job_Vacancy_Config_Request_Application_Form_AdminArgs = {
  input: AtsCoreJobVacancyConfigRequestInput;
};


export type AtsRecruitmentQueryGet_Job_Vacancy_Data_Filter_Options_AdminArgs = {
  input: AtsListJobVacanciesDataFilterInput;
};


export type AtsRecruitmentQueryGet_Job_Vacancy_Form_Request_CollaboratorArgs = {
  input: AtsGetJobVacancyFormRequestInput;
};


export type AtsRecruitmentQueryGet_Job_Vacancy_Form_Request_History_CollaboratorArgs = {
  input: AtsHistoryRequestFormInput;
};


export type AtsRecruitmentQueryGet_Job_Vacancy_Public_InfoArgs = {
  input: AtsJobVacancyPublicInfoInput;
};


export type AtsRecruitmentQueryGet_Job_Vacancy_Request_Detail_AdminArgs = {
  input: AtsGetJobVacancyRequestDetailInput;
};


export type AtsRecruitmentQueryGet_Mail_Template_Detail_AdminArgs = {
  input: AtsMailTemplateDetailInput;
};


export type AtsRecruitmentQueryGet_Mail_Templates_AdminArgs = {
  input: AtsMailTemplatesInput;
};


export type AtsRecruitmentQueryGet_Pipeline_Template_Job_Vacancy_Stages_AdminArgs = {
  input: AtsGetJobVacancyStagePipelineTemplateInput;
};


export type AtsRecruitmentQueryGet_Pipeline_Templates_Job_Vacancy_Stages_AdminArgs = {
  input: AtsGetJobVacancyStagePipelineTemplatesInput;
};


export type AtsRecruitmentQueryGet_Pipeline_Templates_Reduced_Job_Vacancy_Stages_AdminArgs = {
  input: AtsGetReducedJobVacancyStagePipelineTemplatesInput;
};


export type AtsRecruitmentQueryGet_Questions_Form_Candidate_Profile_AdminArgs = {
  input: AtsApplicantProfileInput;
};


export type AtsRecruitmentQueryGet_Recruitment_Team_AdminArgs = {
  input: AtsRecruitmentTeamInput;
};


export type AtsRecruitmentQueryGet_Recruitment_Team_Dashboard_Stats_AdminArgs = {
  input: AtsGetRecruitmentTeamDashboardStatsInput;
};


export type AtsRecruitmentQueryGet_Recruitment_Team_Vacancy_Detail_Performance_AdminArgs = {
  input: AtsGetRecruitmentTeamVacancyPerformanceInput;
};


export type AtsRecruitmentQueryGet_Scores_Cards_And_Questions_AdminArgs = {
  input: AtsScoreAndQuestionsApplicantProfileInput;
};


export type AtsRecruitmentQueryGet_Stage_Public_InfoArgs = {
  input: AtsJobVacancyStagePublicInfoInput;
};


export type AtsRecruitmentQueryGet_Stakeholder_Evaluation_Card_Questionnaire_CollaboratorArgs = {
  input: AtsStakeholderQuestionnaireInput;
};


export type AtsRecruitmentQueryGet_Vacancy_Dashboard_Stats_AdminArgs = {
  input: AtsGetVacancyDashboardStatsInput;
};


export type AtsRecruitmentQueryGet_Vacancy_Detail_AdminArgs = {
  input: AtsGetVacancyInput;
};


export type AtsRecruitmentQueryGet_Visits_And_Applications_Vacancy_AdminArgs = {
  input: AtsVisitsAndApplicationsVacancyAdminInput;
};


export type AtsRecruitmentQueryList_All_Job_Applicant_AdminArgs = {
  input: AtsListAllJobApplicantInput;
};


export type AtsRecruitmentQueryList_Career_Site_AdminArgs = {
  input: AtsListCareerSiteConfigInput;
};


export type AtsRecruitmentQueryList_Career_Site_CollaboratorArgs = {
  input: AtsListCareerSiteConfigInput;
};


export type AtsRecruitmentQueryList_Comments_Job_Vacancy_Requests_AdminArgs = {
  input: AtsListCommentsJobVacancyRequestInput;
};


export type AtsRecruitmentQueryList_Company_Badge_AdminArgs = {
  input: AtsListCompanyBadgeInput;
};


export type AtsRecruitmentQueryList_Company_Tags_AdminArgs = {
  input: AtsGetCompanyTagsInput;
};


export type AtsRecruitmentQueryList_Departments_Career_SiteArgs = {
  input: AtsDepartmentsCareerSiteInput;
};


export type AtsRecruitmentQueryList_Job_Applicant_AdminArgs = {
  input: AtsListJobApplicantInput;
};


export type AtsRecruitmentQueryList_Job_Applicant_Attachment_AdminArgs = {
  input: AtsJobApplicantAttachmentInput;
};


export type AtsRecruitmentQueryList_Job_Vacancy_AdminArgs = {
  input: AtsListJobVacancyInput;
};


export type AtsRecruitmentQueryList_Job_Vacancy_Career_Site_AdminArgs = {
  input: AtsListJobVacancyCareerSiteAssignmentInput;
};


export type AtsRecruitmentQueryList_Job_Vacancy_Config_Requests_AdminArgs = {
  input: AtsListJobVacancyConfigRequestInput;
};


export type AtsRecruitmentQueryList_Job_Vacancy_Form_Requests_AdminArgs = {
  input: AtsListJobVacancyFormRequestInput;
};


export type AtsRecruitmentQueryList_Job_Vacancy_Form_Requests_AssignedArgs = {
  input: AtsAssignedRequestFormInput;
};


export type AtsRecruitmentQueryList_Job_Vacancy_Form_Requests_Received_CollaboratorArgs = {
  input: AtsListJobVacancyFormRequestsReceivedInput;
};


export type AtsRecruitmentQueryList_Job_Vacancy_Requests_AdminArgs = {
  input: AtsListJobVacancyRequestInput;
};


export type AtsRecruitmentQueryList_Job_Vacancy_Stages_AdminArgs = {
  input: AtsGetJobVacancyStagesInput;
};


export type AtsRecruitmentQueryList_Pipeline_AdminArgs = {
  input: AtsListPipelineInput;
};


export type AtsRecruitmentQueryList_Stakeholder_Vacancies_CollaboratorArgs = {
  input: AtsListStakeholderVacanciesInput;
};


export type AtsRecruitmentQueryList_Stakeholder_Vacancy_Task_CollaboratorArgs = {
  input: AtsListStakeholderTaskInput;
};


export type AtsRecruitmentQueryList_Tags_By_Job_Vacancy_AdminArgs = {
  input: AtsListJobApplicantTagsInput;
};


export type AtsRecruitmentQueryList_Vacancies_Career_SiteArgs = {
  input: AtsListJobVacancyCareerSiteInput;
};


export type AtsRecruitmentQueryList_Vacancies_Career_Site_CollaboratorArgs = {
  input: AtsListJobVacancyCareerSiteInput;
};


export type AtsRecruitmentQueryList_Vacancy_Attribution_Options_AdminArgs = {
  input: AtsListPipelineInput;
};

export type AtsRecruitmentStatsPaginationInput = {
  page?: Scalars['Int']['input'];
  page_size?: Scalars['Int']['input'];
  recruiter_team_filter?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AtsRecruitmentTeamDashboardStats = {
  __typename?: 'ATSRecruitmentTeamDashboardStats';
  active_recruiters: Scalars['Int']['output'];
  active_vacancies: Scalars['Float']['output'];
  first_contact: Scalars['Int']['output'];
  performance_recruitment_team: AtsRecruitmentPerformanceConnection;
  recruiter_team?: Maybe<Array<CentralizedUserAts>>;
};

export type AtsRecruitmentTeamDashboardStatsResponse = AtsRecruitmentTeamDashboardStats | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsRecruitmentTeamInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsRecruitmentTeamResponse = PrivateAtsRecruitmentTeamInfo | ResponseInternalError | ResponseValidationError;

export type AtsRecruitmentTeamVacancyPerformanceResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsRecruitmentTeamVacancyPerformanceList | ValidationErrorV2;

export type AtsRegisterApplicantRequiredDocumentsInput = {
  applicant_uid: Scalars['String']['input'];
  company_id: Scalars['ID']['input'];
  documents: Array<RequiredAttachmentDocumentInput>;
  email: Scalars['String']['input'];
  form_id: Scalars['ID']['input'];
  stage_id: Scalars['ID']['input'];
};

export type AtsRegisterApplicantRequiredDocumentsPayload = {
  __typename?: 'ATSRegisterApplicantRequiredDocumentsPayload';
  applicant_attachments: Array<AtsApplicantAttachmentDocumentCompletedType>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsRegisterApplicantRequiredDocumentsResponse = AtsRegisterApplicantRequiredDocumentsPayload | InternalErrorV2 | ValidationErrorV2;

export type AtsReorderDocumentsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  documents: Array<Scalars['ID']['input']>;
  form_id: Scalars['ID']['input'];
};

export enum AtsReportTypeEnum {
  JobApplicantsInfoByJobVacancy = 'JOB_APPLICANTS_INFO_BY_JOB_VACANCY',
  JobApplicantInfoPdf = 'JOB_APPLICANT_INFO_PDF',
  JobVacanciesInfoByOrganization = 'JOB_VACANCIES_INFO_BY_ORGANIZATION',
  JobVacanciesMetricsInfoByVacancy = 'JOB_VACANCIES_METRICS_INFO_BY_VACANCY',
  JobVacanciesStatsInfoByOrganization = 'JOB_VACANCIES_STATS_INFO_BY_ORGANIZATION'
}

export enum AtsRequestChanceTypeEnum {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Created = 'CREATED',
  Rejected = 'REJECTED',
  Updated = 'UPDATED'
}

export type AtsRequestReportInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Language for translation reports (ES, EN, PT) */
  country_code?: AtsLanguageCodeEnum;
  object_id: Scalars['Int']['input'];
  object_type: AtsRequestReportObjectTypeEnum;
  type_report: AtsReportTypeEnum;
};

export enum AtsRequestReportObjectTypeEnum {
  JobApplicantProfile = 'JobApplicantProfile',
  JobVacancy = 'JobVacancy'
}

export type AtsRequestReportResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsRequestReportPayload;

export enum AtsRequestStateTypeEnum {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type AtsScheduleBaseInfoInput = {
  days: AtsScheduleDaysEnum;
  hour: Scalars['String']['input'];
};

export enum AtsScheduleDaysEnum {
  EightDaysSchedule = 'EIGHT_DAYS_SCHEDULE',
  ElevenDaysSchedule = 'ELEVEN_DAYS_SCHEDULE',
  FifteenDaysSchedule = 'FIFTEEN_DAYS_SCHEDULE',
  FiveDaysSchedule = 'FIVE_DAYS_SCHEDULE',
  FourteenDaysSchedule = 'FOURTEEN_DAYS_SCHEDULE',
  FourDaysSchedule = 'FOUR_DAYS_SCHEDULE',
  NineDaysSchedule = 'NINE_DAYS_SCHEDULE',
  OneDaysSchedule = 'ONE_DAYS_SCHEDULE',
  SevenDaysSchedule = 'SEVEN_DAYS_SCHEDULE',
  SixDaysSchedule = 'SIX_DAYS_SCHEDULE',
  TenDaysSchedule = 'TEN_DAYS_SCHEDULE',
  ThirteenDaysSchedule = 'THIRTEEN_DAYS_SCHEDULE',
  ThreeDaysSchedule = 'THREE_DAYS_SCHEDULE',
  TwelveDaysSchedule = 'TWELVE_DAYS_SCHEDULE',
  TwoDaysSchedule = 'TWO_DAYS_SCHEDULE',
  ZeroDaysSchedule = 'ZERO_DAYS_SCHEDULE'
}

export type AtsScheduleUpdateInfoInput = {
  days: AtsScheduleDaysEnum;
  hour: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AtsScoreAndQuestionsApplicantProfileInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  job_applicant_profile: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type AtsScoresAndQuestionsApplicantProfileResponse = AtsScoresAndQuestionsApplicantProfileResponseWrapper | ResponseInternalError | ResponseValidationError;

export type AtsScoresAndQuestionsApplicantProfileResponseWrapper = {
  __typename?: 'ATSScoresAndQuestionsApplicantProfileResponseWrapper';
  cards: Array<PrivateAtsScoresAndQuestionsApplicantProfile>;
  pagination_info: PaginationInfo;
  total_average: Scalars['Float']['output'];
};

export type AtsSendNotificationInput = {
  action_type: AtsJobVacancyStageActionEnum;
  applicant_ids: Array<Scalars['ID']['input']>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  is_discard?: Scalars['Boolean']['input'];
  send_mode: AtsStageSendModeEnum;
  stage_id: Scalars['ID']['input'];
};

export type AtsSendNotificationResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsSendNotificationPayload;

export type AtsSendTestEmailPayload = {
  __typename?: 'ATSSendTestEmailPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  status: AtsEmailSendStatusEnum;
};

export type AtsSendTestEmailResponse = AtsSendTestEmailPayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsSetCentralizedUserInput = {
  applicant_profile_id: Scalars['ID']['input'];
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id: Scalars['ID']['input'];
  vacancy_id: Scalars['ID']['input'];
};

export type AtsSetCentralizedUserPayload = {
  __typename?: 'ATSSetCentralizedUserPayload';
  applicant_profile: PrivateAtsJobApplicantProfile;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsSetCentralizedUserResponse = AtsSetCentralizedUserPayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export enum AtsStageSendModeEnum {
  Auto = 'AUTO',
  Manual = 'MANUAL',
  Scheduled = 'SCHEDULED'
}

export type AtsStakeholderQuestionnaireCardResponse = PrivateAtsStakeholderQuestionnaire | ResponseInternalError | ResponseValidationError;

export type AtsStakeholderQuestionnaireInput = {
  applicant_profile_id: Scalars['Int']['input'];
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  evaluation_card_id: Scalars['Int']['input'];
  vacancy_id: Scalars['Int']['input'];
};

export type AtsStakeholderVacanciesResponse = PrivateAtsStakeholderVacancies | ResponseInternalError | ResponseValidationError;

export enum AtsTemplateBaseEnum {
  ApplicationReceivedTemplate = 'APPLICATION_RECEIVED_TEMPLATE',
  DiscardTemplate = 'DISCARD_TEMPLATE',
  DocumentRequestTemplate = 'DOCUMENT_REQUEST_TEMPLATE',
  JobOfferTemplate = 'JOB_OFFER_TEMPLATE'
}

export enum AtsTemplateEmailReferenceTypeEnum {
  Company = 'COMPANY',
  System = 'SYSTEM',
  Vacancy = 'VACANCY'
}

export enum AtsTemplateEmailSourceComponentEnum {
  JobVacancyStage = 'JOB_VACANCY_STAGE',
  MailTemplate = 'MAIL_TEMPLATE'
}

export type AtsTrackVisitResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsTrackVisitPayload | ValidationErrorV2;

export enum AtsTypeApplicationTypeEnum {
  NewPosition = 'NEW_POSITION',
  ReplacementPosition = 'REPLACEMENT_POSITION'
}

export enum AtsTypeAssignmentTypeEnum {
  AllEmployees = 'ALL_EMPLOYEES',
  OnlyLeaders = 'ONLY_LEADERS'
}

export enum AtsTypeResolutionTypeEnum {
  AutoApprove = 'AUTO_APPROVE',
  AutoDeny = 'AUTO_DENY'
}

export type AtsUpdateApplicantDocumentInput = {
  applicant_uid: Scalars['String']['input'];
  company_id: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  external_file_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  otp_code: Scalars['String']['input'];
};

export type AtsUpdateAttachmentFormInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AtsUpdateAttributesWithScaleInputType = {
  attributes_info: Array<UpdateEvaluationCardAttributeInputType>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  company_id?: InputMaybe<Scalars['String']['input']>;
  evaluation_template_card_section_id?: InputMaybe<Scalars['Int']['input']>;
  scale_info: UpdateEvaluationCardScaleInputType;
};

export type AtsUpdateCustomCentralizedOrganizationInput = {
  centralized_organization_id: Scalars['ID']['input'];
  delete_extra_field_id?: InputMaybe<Scalars['ID']['input']>;
  delete_question_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  is_demo?: InputMaybe<Scalars['Boolean']['input']>;
  legal_file_id?: InputMaybe<Scalars['ID']['input']>;
  /** Org-level switch for the e-mail sent to approvers when a vacancy request needs their decision. Omit to leave the current value untouched. */
  notify_approver?: InputMaybe<Scalars['Boolean']['input']>;
  /** Org-level switch for the e-mail sent to the requester when their request is resolved, including when it is resolved automatically. Omit to leave the current value untouched. */
  notify_requester?: InputMaybe<Scalars['Boolean']['input']>;
  /** Org-level switch for the e-mail sent to the recruiting team when a vacancy or a request is created. Omit to leave the current value untouched. */
  notify_team?: InputMaybe<Scalars['Boolean']['input']>;
  rrss_logo_file_id?: InputMaybe<Scalars['ID']['input']>;
  show_client_identifier?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AtsUpdateCustomCentralizedOrganizationResponse = AtsCentralizedOrganizationPayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsUpdateEvaluationTemplateInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  company_id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  evaluation_template_id?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  reference_template_id?: InputMaybe<Scalars['String']['input']>;
  sections_to_activate?: Array<Scalars['String']['input']>;
  sections_to_delete?: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type AtsUpdateFormRequestCollaboratorPayload = {
  __typename?: 'ATSUpdateFormRequestCollaboratorPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsUpdateJobApplicantMarkInput = {
  badge_comment?: InputMaybe<Scalars['String']['input']>;
  /** ID of the badge company */
  badge_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the job applicant */
  id: Scalars['ID']['input'];
  mark_status: Scalars['Boolean']['input'];
};

export type AtsUpdateJobApplicantTagsInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the job applicant */
  job_applicant_id: Scalars['ID']['input'];
  tag_ids: Array<Scalars['Int']['input']>;
};

export type AtsUpdateJobVacancyConfigRequestInput = {
  assigned_recruiter_id: Scalars['ID']['input'];
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  job_vacancy_config_request_id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type_application?: AtsTypeApplicationTypeEnum;
};

export type AtsUpdateJobVacancyConfigRequestPayload = {
  __typename?: 'ATSUpdateJobVacancyConfigRequestPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  job_vacancy_config_request: PrivateAtsJobVacancyConfigRequest;
};

export type AtsUpdateJobVacancyConfigRequestResponse = AtsUpdateJobVacancyConfigRequestPayload | MutationInternalExistsError | MutationValidationExistsError;

export type AtsUpdateJobVacancyConfigRequestVisibilityInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  is_visible: Scalars['Boolean']['input'];
  job_vacancy_config_request_id: Scalars['ID']['input'];
};

export type AtsUpdateJobVacancyConfigRequestVisibilityResponse = MutationInternalExistsError | MutationValidationExistsError | PrivateAtsUpdateJobVacancyConfigRequestVisibilityPayload;

export type AtsUpdateJobVacancyFormRequestCollaboratorInput = {
  applicant_form_data: Scalars['JSON']['input'];
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Job vacancy form request id to update */
  id: Scalars['ID']['input'];
  job_vacancy_config_request_id: Scalars['ID']['input'];
  leader_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AtsUpdateJobVacancyFormRequestCollaboratorResponse = AtsUpdateFormRequestCollaboratorPayload | MutationInternalExistsError | MutationValidationExistsError;

export type AtsUpdateJobVacancyInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  client_name?: InputMaybe<Scalars['String']['input']>;
  contract_type?: InputMaybe<AtsVacancyContractTypeEnum>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_by_id?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  hiring_number?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  keywords?: InputMaybe<Array<AtsKeywordsInput>>;
  salary?: InputMaybe<Scalars['Float']['input']>;
  show_contract_type?: InputMaybe<Scalars['Boolean']['input']>;
  show_location?: InputMaybe<Scalars['Boolean']['input']>;
  show_salary?: InputMaybe<Scalars['Boolean']['input']>;
  show_work_mode?: InputMaybe<Scalars['Boolean']['input']>;
  show_work_team_id?: InputMaybe<Scalars['Boolean']['input']>;
  show_workday?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type_vacancy?: InputMaybe<AtsVacancyPositionStatusEnum>;
  updated_by_id?: InputMaybe<Scalars['Int']['input']>;
  work_mode?: InputMaybe<AtsVacancyWorkModalityEnum>;
  work_team_id?: InputMaybe<Scalars['Int']['input']>;
  workday?: InputMaybe<AtsVacancyWorkScheduleEnum>;
};

export type AtsUpdateMailTemplateAvailabilityInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AtsUpdateMailTemplateAvailabilityResponse = AtsUpdateMailTemplatePayload | MutationInternalExistsError | MutationValidationExistsError;

export type AtsUpdateMailTemplateInput = {
  attachment_form_id?: InputMaybe<Scalars['ID']['input']>;
  banner_file_id?: InputMaybe<Scalars['ID']['input']>;
  body: Scalars['String']['input'];
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  default_identifier?: InputMaybe<AtsTemplateBaseEnum>;
  file_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  has_job_schedule?: InputMaybe<Scalars['Boolean']['input']>;
  has_job_vacancy?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  job_vacancy_stage_id?: InputMaybe<Scalars['ID']['input']>;
  language_code: AtsLanguageCodeEnum;
  lexical_body: Scalars['String']['input'];
  schedule_info?: InputMaybe<AtsScheduleUpdateInfoInput>;
  subject: Scalars['String']['input'];
  template_description?: InputMaybe<Scalars['String']['input']>;
  template_name: Scalars['String']['input'];
  ui_component?: InputMaybe<AtsTemplateEmailSourceComponentEnum>;
};

export type AtsUpdateMailTemplatePayload = {
  __typename?: 'ATSUpdateMailTemplatePayload';
  email_template: PrivateAtsMailTemplate;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsUpdateMailTemplateResponse = AtsUpdateMailTemplatePayload | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | MutationInternalExistsError | MutationValidationExistsError | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type AtsUpdateStateJobVacancyInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['String']['input'];
  set_pause?: InputMaybe<Scalars['Boolean']['input']>;
  set_state?: InputMaybe<AtsVacancyStatusEnum>;
};

export type AtsUpdateStateJobVacancyResponse = MutationInternalExistsError | MutationJobVacancyNoHiresError | MutationJobVacancyParticipantsExceededError | MutationValidationExistsError | PrivateAtsUpdateStateJobVacancyPayload;

export type AtsUpdateVacancyPayload = {
  __typename?: 'ATSUpdateVacancyPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  job_vacancy: PrivateAtsJobVacancy;
};

export type AtsUpdateVacancyResponse = AtsUpdateVacancyPayload | MutationInternalExistsError | MutationRequisitionIdentifierError | MutationValidationExistsError;

export type AtsUpdatedApplicantDocumentPayload = {
  __typename?: 'ATSUpdatedApplicantDocumentPayload';
  applicant_attachment: AtsApplicantAttachmentDocumentCompletedType;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AtsUpdatedApplicantDocumentResponse = AtsUpdatedApplicantDocumentPayload | InternalErrorV2 | ValidationErrorV2;

export type AtsVacancyAttributionOptionsResponse = PrivateAtsVacancyAttributionOptions | ResponseInternalError | ResponseValidationError;

export type AtsVacancyConnection = {
  __typename?: 'ATSVacancyConnection';
  edges: Array<AtsJobVacancyEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export enum AtsVacancyContractTypeEnum {
  FixedTerm = 'FIXED_TERM',
  Freelance = 'FREELANCE',
  Other = 'OTHER',
  Permanent = 'PERMANENT',
  Practice = 'PRACTICE'
}

export type AtsVacancyDashboardStatsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsVacancyDashboardStats | ValidationErrorV2;

export enum AtsVacancyPositionStatusEnum {
  NewPosition = 'NEW_POSITION',
  Replacement = 'REPLACEMENT'
}

export enum AtsVacancyStatusEnum {
  VacancyCancelled = 'VACANCY_CANCELLED',
  VacancyClosed = 'VACANCY_CLOSED',
  VacancyHired = 'VACANCY_HIRED',
  VacancyOpen = 'VACANCY_OPEN'
}

export type AtsVacancyTrafficStatsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateAtsVisitsAndApplicationsVacancyAdminResponse | ValidationErrorV2;

export enum AtsVacancyWorkModalityEnum {
  Hybrid = 'HYBRID',
  OnSite = 'ON_SITE',
  Virtual = 'VIRTUAL'
}

export enum AtsVacancyWorkScheduleEnum {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME'
}

export type AtsValidateJobApplicantMassiveUploadInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  file_id: Scalars['ID']['input'];
  vacancy_id: Scalars['ID']['input'];
};

export type AtsValidateJobApplicantMassiveUploadPayload = {
  __typename?: 'ATSValidateJobApplicantMassiveUploadPayload';
  bulk_upload_id?: Maybe<Scalars['ID']['output']>;
  error_details?: Maybe<Array<AtsJobApplicantBulkUploadErrorItem>>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  total_errors: Scalars['Int']['output'];
  total_success: Scalars['Int']['output'];
};

export type AtsValidateJobApplicantMassiveUploadResponse = AtsValidateJobApplicantMassiveUploadPayload | InternalErrorV2 | MutationBulkUploadEmptyFileError | MutationBulkUploadInvalidHeaderError | MutationBulkUploadLongerFileError | MutationBulkUploadValidationError | ValidationErrorV2;

export type AtsVisitsAndApplicationsVacancyAdminInput = {
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  granularity: AtsGranularityStatsEnum;
  vacancy_id: Scalars['ID']['input'];
};

export type AbstractAttachment = {
  file: File;
  id: Scalars['ID']['output'];
};

export type AbstractBenefit = {
  attachments: BenefitAttachmentFragmentListType;
  categories: StrListType;
  description?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<TimeStampType>;
  external_link?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_expired: Scalars['Boolean']['output'];
  is_highlighted: Scalars['Boolean']['output'];
  /** Flags this benefit as a custom override of a core benefit */
  is_override?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  provider: BenefitProvider;
  redemption_code?: Maybe<BenefitRedemptionCode>;
  /** Indicates whether the benefit is currently valid for redemption based on its expiration status. */
  validity_status?: Maybe<BenefitValidityStatusEnum>;
};

export type AbstractBenefitCategory = {
  icon_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AcademyNode = {
  __typename?: 'AcademyNode';
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original_id?: Maybe<Scalars['ID']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export enum AccessLevelEnum {
  CrehanaCore = 'CREHANA_CORE',
  CrehanaCoreElevate = 'CREHANA_CORE_ELEVATE',
  CrehanaElevate = 'CREHANA_ELEVATE'
}

export enum AccessTokenBackenEnum {
  ApplicationAndroid = 'APPLICATION_ANDROID',
  ApplicationIos = 'APPLICATION_IOS'
}

export type AccessTokenMutationResponse = AccessTokenSuccessResponse | MutationErrorResponse;

export type AccessTokenSuccessResponse = {
  __typename?: 'AccessTokenSuccessResponse';
  access_token: AuthenticationAccessToken;
  is_new_user: Scalars['Boolean']['output'];
};

export type AccountFunnel = {
  __typename?: 'AccountFunnel';
  available_licenses: Scalars['Int']['output'];
  org_id: Scalars['ID']['output'];
  stock_activated: Scalars['Int']['output'];
  stock_pending: Scalars['Int']['output'];
  stock_registered: Scalars['Int']['output'];
  usage_users: Scalars['Int']['output'];
};

/** This input inherits from the standard interface and adds one more field. The validations for this input are done with Pydantic. */
export type AchievementUpdateInput = {
  custom_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum ActionType {
  Assign = 'ASSIGN',
  Unassign = 'UNASSIGN'
}

export type ActivateAccountInput = {
  key: Scalars['String']['input'];
  next_url?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

/** Confirm the summary and activate the survey in TLNT. This is the last step and it writes: the questions model, the evaluation, its configuration and the recipients. */
export type ActivateClimateSurveyInput = {
  /** Draft workflow ID returned by save_climate_survey_context. */
  draft_id: Scalars['ID']['input'];
};

export type ActivateClimateSurveyResponse = ClimateSurveyActivationType | ClimateWorkflowError | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type ActivateDeactivateAreaLevelResponse = {
  __typename?: 'ActivateDeactivateAreaLevelResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type ActivateOrganizationHeadquarterResponse = {
  __typename?: 'ActivateOrganizationHeadquarterResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type ActivatePolicyInput = {
  centralized_organization_id: Scalars['ID']['input'];
  policy_id: Scalars['ID']['input'];
};

export type ActivatePolicyResponse = {
  __typename?: 'ActivatePolicyResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type ActivateUserResponse = {
  __typename?: 'ActivateUserResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type ActiveAllowedUser = AllowedUserForAssignmentInterface & AllowedUserInterface & {
  __typename?: 'ActiveAllowedUser';
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  tags: UserTagsType;
  user: UserInfoType;
};

export type ActivitiesDataListConnection = {
  __typename?: 'ActivitiesDataListConnection';
  edges: Array<ActivitiesDataTypeEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type ActivitiesDataType = {
  __typename?: 'ActivitiesDataType';
  collaborator_progress?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dip_activity_attachment?: Maybe<Attachment>;
  dip_activity_class?: Maybe<Scalars['String']['output']>;
  dip_activity_id: Scalars['Int']['output'];
  displacement_comment?: Maybe<Scalars['String']['output']>;
  displacement_value?: Maybe<Scalars['Int']['output']>;
  employee_id: Scalars['Int']['output'];
  employee_name: Scalars['String']['output'];
  end_date: Scalars['Date']['output'];
  extra_fields?: Maybe<DipExtraFieldQuestions>;
  id: Scalars['Int']['output'];
  leader_progress?: Maybe<Scalars['Float']['output']>;
  learning_info?: Maybe<LearningInfo>;
  model?: Maybe<PidModelLabels>;
  owner?: Maybe<DipActivityTypeEnum>;
  points?: Maybe<Scalars['Int']['output']>;
  state: Scalars['String']['output'];
  title: Scalars['String']['output'];
  track_start_date: Scalars['Date']['output'];
  tracks?: Maybe<Array<PidTrack>>;
  type_activity: PidActivityTypeEnum;
};

/** An edge in a connection. */
export type ActivitiesDataTypeEdge = {
  __typename?: 'ActivitiesDataTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ActivitiesDataType;
};

/** Response for Chart 2 — activity composition (horizontal bars by module). */
export type ActivityCompositionResponse = {
  __typename?: 'ActivityCompositionResponse';
  /** Whether the current user has product-level access (Management). False means the org does not have Management — frontend should hide the widget. */
  has_permission: Scalars['Boolean']['output'];
  /** Composition items sorted by value descending. */
  items: Array<CompositionItem>;
  /** Localized timestamp of the most recent ETL sync for this widget's data. Format: '23 abr - 9:25am'. Null when freshness cannot be determined. */
  last_updated_at_formatted?: Maybe<Scalars['String']['output']>;
  /** Chart subtitle (e.g. 'Acciones por módulo · delta vs mes anterior'). */
  subtitle: Scalars['String']['output'];
  /** Chart title (e.g. 'Composición de actividad'). */
  title: Scalars['String']['output'];
};

export enum ActivityDipModelLabelsEnum {
  Seventy = 'SEVENTY',
  Ten = 'TEN',
  Twenty = 'TWENTY'
}

export type ActivityPerHour = {
  __typename?: 'ActivityPerHour';
  hour: Scalars['Int']['output'];
  played_seconds?: Maybe<Scalars['Float']['output']>;
};

export type ActivityPerMonth = {
  __typename?: 'ActivityPerMonth';
  month: Scalars['String']['output'];
  played_seconds?: Maybe<Scalars['Float']['output']>;
};

/** Response for Chart 1 — platform activity timeline (line chart). */
export type ActivityTimelineResponse = {
  __typename?: 'ActivityTimelineResponse';
  /** Average daily value from the current month sparkline. */
  average_number: Scalars['Float']['output'];
  /** Label for the current month series (e.g. 'Mayo 2026'). */
  current_month_label: Scalars['String']['output'];
  /** Raw numeric delta vs previous month (e.g. 17.6, -3.2). Positive = up, negative = down. */
  delta_value?: Maybe<Scalars['Float']['output']>;
  /** Formatted percentage change vs previous month (e.g. '17.6%'). */
  delta_vs_previous: Scalars['String']['output'];
  /** Whether the current user has product-level access (Management). False means the org does not have Management — frontend should hide the widget. */
  has_permission: Scalars['Boolean']['output'];
  /** Localized timestamp of the most recent ETL sync for this widget's data. Format: '23 abr - 9:25am'. Null when freshness cannot be determined. */
  last_updated_at_formatted?: Maybe<Scalars['String']['output']>;
  /** Minimum daily value from the current month sparkline. */
  minimum_number: Scalars['Float']['output'];
  /** Maximum daily value from the current month sparkline. */
  peak_number: Scalars['Float']['output'];
  /** Label for the previous month series (e.g. 'Abril 2026 (comparable)'). */
  previous_month_label: Scalars['String']['output'];
  /** Daily data points for the current month. */
  sparkline_current_month: Array<TimelinePoint>;
  /** Daily data points for the previous month. */
  sparkline_previous_month: Array<TimelinePoint>;
  /** Chart subtitle (e.g. 'Usuarios únicos por día · Login events (Centralizada)'). */
  subtitle: Scalars['String']['output'];
  /** Chart title (e.g. 'Actividad de la plataforma'). */
  title: Scalars['String']['output'];
  /** 6 evenly-spaced date labels for the X axis (e.g. ['15 abr', '22 abr', ...]). */
  x_axis_labels: Array<Scalars['String']['output']>;
  /** 5 Y axis values: 0 + 4 evenly-spaced ticks up to the max (e.g. [0, 375, 750, 1125, 1500]). */
  y_axis_labels: Array<Scalars['Int']['output']>;
};

export enum ActivityTypeEnum {
  LastPlayType = 'LAST_PLAY_TYPE',
  NewCourseAssignedType = 'NEW_COURSE_ASSIGNED_TYPE'
}

export type AddAuditLogErrorResponse = {
  __typename?: 'AddAuditLogErrorResponse';
  message: Scalars['String']['output'];
};

export type AddAuditLogInput = {
  action: AuditLogAction;
  domain?: InputMaybe<DomainEnum>;
  environment?: InputMaybe<EnvironmentEnum>;
  event_date: Scalars['DateTime']['input'];
  interface?: InputMaybe<InterfaceEnum>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  new_value?: InputMaybe<Scalars['JSON']['input']>;
  old_value?: InputMaybe<Scalars['JSON']['input']>;
  organization_id: Scalars['ID']['input'];
  resource_id?: InputMaybe<Scalars['ID']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  user_id: Scalars['ID']['input'];
  user_ip?: InputMaybe<Scalars['String']['input']>;
  user_type: UserTypeEnum;
};

export type AddAuditLogSuccessResponse = {
  __typename?: 'AddAuditLogSuccessResponse';
  audit_log: AuditLog;
};

export type AddAuditLogSuccessResponseAddAuditLogErrorResponseServerInternalErrorMutationValidationErrorResponse = AddAuditLogErrorResponse | AddAuditLogSuccessResponse | MutationValidationErrorResponse | ServerInternalError;

export type AddCourseHigherEducationTeamInput = {
  course: HigherEducationTeamCourse;
  organization_slug: Scalars['String']['input'];
  team_id: Scalars['ID']['input'];
};

export type AddCourseHigherEducationTeamResponse = {
  __typename?: 'AddCourseHigherEducationTeamResponse';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AddCourseVideoTranscriptInput = {
  generate_summary?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<VideoLanguageEnum>;
  text: Scalars['String']['input'];
  video_lecture_id: Scalars['ID']['input'];
};

export type AddFileResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | S3PresignDataFields;

export type AddFileV1Response = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | S3PreSignedPayload;

export type AddLocaleKeyInput = {
  auto_translate?: InputMaybe<Array<LocaleLanguageEnum>>;
  default_language?: InputMaybe<LocaleLanguageEnum>;
  default_text?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};

export type AddLocaleKeySuccessReponse = {
  __typename?: 'AddLocaleKeySuccessReponse';
  locale_key: LocaleKey;
};

export type AddLocaleKeySuccessReponseMagiclinkMutationValidationErrorInternalServerError = AddLocaleKeySuccessReponse | InternalServerError | MagiclinkMutationValidationError;

export type AddLocaleValueInput = {
  auto_translate?: InputMaybe<Array<LocaleLanguageEnum>>;
  key: Scalars['String']['input'];
  language: LocaleLanguageEnum;
  namespace: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type AddLocaleValueSuccessReponse = {
  __typename?: 'AddLocaleValueSuccessReponse';
  locale_value: LocaleValue;
};

export type AddLocaleValueSuccessReponseMagiclinkMutationValidationErrorInternalServerError = AddLocaleValueSuccessReponse | InternalServerError | MagiclinkMutationValidationError;

/** Input used in mutation to add users to an existing session [Mutation] */
export type AddSessionUserInput = {
  live_session_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  participants_ids?: InputMaybe<Array<UserSessionInput>>;
};

export type AddSubtitleSrt = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | SubtitleProcess;

export type AddUsersInTeamOrganizationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  organization_team_id: Scalars['ID']['input'];
  user_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AddUsersInTeamOrganizationPayload = {
  __typename?: 'AddUsersInTeamOrganizationPayload';
  invalid_emails: Array<UserOrganizationErrorNode>;
  users: Array<UserOrganizationNode>;
};

export type AddUsersInTeamOrganizationResponse = AddUsersInTeamOrganizationPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type AddVideoTranscriptInternalError = {
  __typename?: 'AddVideoTranscriptInternalError';
  errors: Array<Scalars['String']['output']>;
};

export type AddVideoTranscriptPayload = {
  __typename?: 'AddVideoTranscriptPayload';
  transcript?: Maybe<VideoTranscript>;
};

export type AddVideoTranscriptPayloadAddVideoTranscriptValidationErrorAddVideoTranscriptInternalError = AddVideoTranscriptInternalError | AddVideoTranscriptPayload | AddVideoTranscriptValidationError;

export type AddVideoTranscriptSegmentInput = {
  avg_logprob?: InputMaybe<Scalars['Float']['input']>;
  compression_ratio?: InputMaybe<Scalars['Float']['input']>;
  end: Scalars['Float']['input'];
  language?: InputMaybe<VideoLanguageEnum>;
  no_speech_prob?: InputMaybe<Scalars['Float']['input']>;
  seek: Scalars['Float']['input'];
  segment_id: Scalars['Int']['input'];
  start: Scalars['Float']['input'];
  temperature?: InputMaybe<Scalars['Float']['input']>;
  text: Scalars['String']['input'];
  tokens?: InputMaybe<Scalars['String']['input']>;
  video_transcript_id: Scalars['ID']['input'];
};

export type AddVideoTranscriptSegmentPayload = {
  __typename?: 'AddVideoTranscriptSegmentPayload';
  transcript_segment_group?: Maybe<VideoTranscriptSegmentGroup>;
  transcript_segments?: Maybe<Array<VideoTranscriptSegment>>;
};

export type AddVideoTranscriptSummaryInput = {
  video_transcript_id: Scalars['ID']['input'];
};

export type AddVideoTranscriptSummaryPayload = {
  __typename?: 'AddVideoTranscriptSummaryPayload';
  transcript?: Maybe<VideoTranscript>;
};

export type AddVideoTranscriptValidationError = {
  __typename?: 'AddVideoTranscriptValidationError';
  errors: Array<Scalars['String']['output']>;
};

export type AdminAchievementFragmentNode = IUserAchievementNode & {
  __typename?: 'AdminAchievementFragmentNode';
  achievement_completed: Scalars['Boolean']['output'];
  event?: Maybe<AdminCurrencyEventFragmentNode>;
};

export type AdminAchievementFragmentNodeEdge = {
  __typename?: 'AdminAchievementFragmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AdminAchievementFragmentNode;
};

export type AdminAchievementFragmentNodeEdgeUserAchievementFragmentNodeEdge = AdminAchievementFragmentNodeEdge | UserAchievementFragmentNodeEdge;

export type AdminAllowedUserNode = {
  __typename?: 'AdminAllowedUserNode';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type AdminAllowedUserNodeEdge = {
  __typename?: 'AdminAllowedUserNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AdminAllowedUserNode;
};

export type AdminAssignCategoriesToContentInput = {
  categories: Array<Scalars['String']['input']>;
  content_id: Scalars['String']['input'];
  organization_id: Scalars['Int']['input'];
};

export type AdminAssignTagToCategoriesInput = {
  category_ids: Array<Scalars['ID']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  tag_id: Scalars['ID']['input'];
};

export type AdminAssignTagToCategoriesPayload = {
  __typename?: 'AdminAssignTagToCategoriesPayload';
  assigned_content_count: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  processed_categories_count: Scalars['Int']['output'];
  tag?: Maybe<TagType>;
};

export type AdminAssignTagToCategoriesResponse = AdminAssignTagToCategoriesPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type AdminAssignTagsToContentInput = {
  content_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  tag_ids: Array<Scalars['ID']['input']>;
};

export type AdminAssignTagsToContentPayload = {
  __typename?: 'AdminAssignTagsToContentPayload';
  assigned_tags_count: Scalars['Int']['output'];
  content_id?: Maybe<Scalars['ID']['output']>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AdminAssignTagsToContentResponse = AdminAssignTagsToContentPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type AdminAuditLogCourseQueries = {
  __typename?: 'AdminAuditLogCourseQueries';
  /** Get Course Logs with filters and pagination */
  get_course_logs: AuditLogCourseConnection;
};


export type AdminAuditLogCourseQueriesGet_Course_LogsArgs = {
  input: AuditLogCourseInput;
};

export type AdminBenefit = AbstractBenefit & {
  __typename?: 'AdminBenefit';
  attachments: BenefitAttachmentFragmentListType;
  /** Indicates whether the benefit belongs to the organization or is part of the default Crehana catalog. */
  benefit_type?: Maybe<BenefitTypeEnum>;
  categories: StrListType;
  countries: CountryCodeEnumListType;
  description?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<TimeStampType>;
  external_link?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_expired: Scalars['Boolean']['output'];
  is_highlighted: Scalars['Boolean']['output'];
  /** Flags this benefit as a custom override of a core benefit */
  is_override?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  provider: BenefitProvider;
  publish_state: BenefitPublishStateEnum;
  redemption_code?: Maybe<BenefitRedemptionCode>;
  /** Indicates whether the benefit is currently valid for redemption based on its expiration status. */
  validity_status?: Maybe<BenefitValidityStatusEnum>;
  visibility_state: BenefitVisibilityStateEnum;
};

export type AdminBenefitBenefitPaginationEdge = {
  __typename?: 'AdminBenefitBenefitPaginationEdge';
  /** The item at the end of the edge. */
  node: AdminBenefit;
};

export type AdminBenefitCategoriesPayload = BenefitGraphQlOperation & {
  __typename?: 'AdminBenefitCategoriesPayload';
  categories: AdminBenefitCategoryListType;
  graphql_operation_id: Scalars['ID']['output'];
};

export type AdminBenefitCategoriesResponse = AdminBenefitCategoriesPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type AdminBenefitCategory = AbstractBenefitCategory & {
  __typename?: 'AdminBenefitCategory';
  benefits: AdminBenefitListType;
  icon_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  total_benefits: Scalars['Int']['output'];
  visibility_state: BenefitVisibilityStateEnum;
};


export type AdminBenefitCategoryBenefitsArgs = {
  input?: InputMaybe<BenefitsInCategoryNumPageInput>;
};

export type AdminBenefitCategoryListType = {
  __typename?: 'AdminBenefitCategoryListType';
  items: Array<AdminBenefitCategory>;
  total_count: Scalars['Int']['output'];
  total_filtered: Scalars['Int']['output'];
};

export type AdminBenefitCategoryPayload = BenefitGraphQlOperation & {
  __typename?: 'AdminBenefitCategoryPayload';
  category: AdminBenefitCategory;
  graphql_operation_id: Scalars['ID']['output'];
};

export type AdminBenefitCategoryResponse = AdminBenefitCategoryPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type AdminBenefitIInput = {
  centralized_organization_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type AdminBenefitListType = {
  __typename?: 'AdminBenefitListType';
  items: Array<AdminBenefit>;
  total_count: Scalars['Int']['output'];
  total_filtered: Scalars['Int']['output'];
};

export type AdminBenefitMetadata = {
  __typename?: 'AdminBenefitMetadata';
  highlighted_stats: BenefitHighlightedStats;
  total_count: Scalars['Int']['output'];
  total_filtered: Scalars['Int']['output'];
};

export type AdminBenefitSearchInput = {
  benefit_type?: InputMaybe<BenefitTypeEnum>;
  categories?: Array<Scalars['ID']['input']>;
  countries?: Array<CountryCodeEnum>;
  is_highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  providers?: Array<Scalars['ID']['input']>;
  search_text?: InputMaybe<Scalars['String']['input']>;
  validity_status?: InputMaybe<BenefitValidityStatusEnum>;
  visibility_state?: InputMaybe<BenefitVisibilityStateEnum>;
};

export type AdminBenefitsConnection = {
  __typename?: 'AdminBenefitsConnection';
  /** A list of edges in this connection. */
  edges: Array<AdminBenefitBenefitPaginationEdge>;
  metadata?: Maybe<AdminBenefitMetadata>;
  /** Information to aid in pagination. */
  page_info: BenefitNumPageInfo;
};

export type AdminBenefitsInput = {
  centralized_organization_id: Scalars['ID']['input'];
  filter_by?: InputMaybe<AdminBenefitSearchInput>;
  first?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};

export type AdminBulkRewardTransactionNode = {
  __typename?: 'AdminBulkRewardTransactionNode';
  failed_transactions?: Maybe<Array<CoreResponseNode>>;
  success_transactions?: Maybe<Array<StandartRewardTransactionNode>>;
};

export type AdminCatalogSettingsInput = {
  centralized_organization_id: Scalars['ID']['input'];
};

export type AdminCatalogType = {
  __typename?: 'AdminCatalogType';
  benefit_visibility_scope: BenefitViewScopeEnum;
  catalog_benefit_state: CatalogBenefitStateEnum;
  id: Scalars['ID']['output'];
  is_custom: Scalars['Boolean']['output'];
};

export type AdminCategoriesListInput = {
  centralized_organization_id: Scalars['ID']['input'];
  filter_by: AdminCategorySearchInput;
  first?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};

export type AdminCategoriesMetadataType = {
  __typename?: 'AdminCategoriesMetadataType';
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type AdminCategoriesPageNumberPagination = {
  __typename?: 'AdminCategoriesPageNumberPagination';
  edges: Array<KnowledgeHubAdminCategoryTypePaginationEdge>;
  metadata?: Maybe<AdminCategoriesMetadataType>;
  /** Information to aid in pagination. */
  page_info: NumberPageInfo;
  page_size?: Maybe<Scalars['Int']['output']>;
};

export type AdminCategoryContentFilterInput = {
  tag_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AdminCategoryInput = {
  category_id: Scalars['ID']['input'];
  centralized_organization_id: Scalars['ID']['input'];
};

export type AdminCategoryRestrictionPayload = {
  __typename?: 'AdminCategoryRestrictionPayload';
  category_restriction: CategoryRestrictionType;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AdminCategorySearchInput = {
  search_text?: InputMaybe<Scalars['String']['input']>;
};

export type AdminContentsCursorPagination = {
  __typename?: 'AdminContentsCursorPagination';
  edges: Array<KnowledgeHubAdminContentTypeCursorEdge>;
  metadata?: Maybe<AdminContentsMetadataType>;
  /** Information to aid in pagination. */
  page_info: CursorPageInfo;
  page_size?: Maybe<Scalars['Int']['output']>;
};

export type AdminContentsMetadataType = {
  __typename?: 'AdminContentsMetadataType';
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type AdminContentsPagePagination = {
  __typename?: 'AdminContentsPagePagination';
  edges: Array<KnowledgeHubAdminContentTypeCursorEdge>;
  metadata?: Maybe<AdminContentsMetadataType>;
  /** Information to aid in pagination. */
  page_info: NumberPageInfo;
  page_size?: Maybe<Scalars['Int']['output']>;
};

export type AdminCoreCountryListInput = {
  centralized_organization_id: Scalars['ID']['input'];
  filter_by?: InputMaybe<AdminCountrySearchInput>;
  first?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};

export type AdminCountrySearchInput = {
  country_codes?: Array<CountryCodeEnum>;
};

export type AdminCourseContentFilterInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  content_title?: InputMaybe<Scalars['String']['input']>;
  external_provider_ids_in?: InputMaybe<Array<Scalars['String']['input']>>;
  has_select_crehana_provider?: InputMaybe<Scalars['Boolean']['input']>;
  has_select_own_provider?: InputMaybe<Scalars['Boolean']['input']>;
  has_select_thirty_provider?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_content?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<ContentLanguages>>;
  levels?: InputMaybe<Array<Scalars['String']['input']>>;
  tag_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  visibility_level?: InputMaybe<VisibilityLevelType>;
};

/** Input for retrieve a course live session [Admin Query] */
export type AdminCourseLiveSessionGetInput = {
  organization_id: Scalars['ID']['input'];
  video_lecture_id: Scalars['ID']['input'];
};

export type AdminCreateCategoryPayload = {
  __typename?: 'AdminCreateCategoryPayload';
  category?: Maybe<KnowledgeHubAdminSimpleCategoryType>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AdminCreateCategoryResponse = AdminCreateCategoryPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type AdminCreateCategoryRestrictionInput = {
  category_id: Scalars['Int']['input'];
  custom_field_option_ids: Array<Scalars['String']['input']>;
  operator: B2BCustomFieldSearchOperatorEnum;
  organization_id: Scalars['Int']['input'];
};

export type AdminCreateCategoryRestrictionResponse = AdminCategoryRestrictionPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type AdminCreateContentDocumentsPayload = {
  __typename?: 'AdminCreateContentDocumentsPayload';
  content_documents?: Maybe<Array<KnowledgeHubAdminContentDocumentType>>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AdminCreateOrganizationCategoryInput = {
  image_file_id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
  visibility_level: VisibilityLevelType;
};

export type AdminCreateOrganizationDocumentsInput = {
  documents_to_create: Array<OrganizationCreateDocumentInput>;
  organization_id: Scalars['Int']['input'];
};

export type AdminCreateTagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminCreateTagPayload = {
  __typename?: 'AdminCreateTagPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  tag?: Maybe<TagType>;
};

export type AdminCreateTagResponse = AdminCreateTagPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type AdminCurrencyEventFragmentNode = ICurrencyEventNode & IGamificationNode & {
  __typename?: 'AdminCurrencyEventFragmentNode';
  background_color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by_id?: Maybe<Scalars['ID']['output']>;
  currency_point_id?: Maybe<Scalars['Int']['output']>;
  custom_description?: Maybe<Scalars['String']['output']>;
  custom_name: Scalars['String']['output'];
  custom_text?: Maybe<Scalars['String']['output']>;
  event_id?: Maybe<Scalars['Int']['output']>;
  /** EventName related to the CurrencyEvent's Event */
  event_subject?: Maybe<Scalars['String']['output']>;
  event_type_enum?: Maybe<EventTypeEnum>;
  icon?: Maybe<ImageNode>;
  id: Scalars['ID']['output'];
  is_custom_event: Scalars['Boolean']['output'];
  organization_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  url_redirect?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type AdminCurrencyEventFragmentNodeEdge = {
  __typename?: 'AdminCurrencyEventFragmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AdminCurrencyEventFragmentNode;
};

export type AdminCurrencyEventFragmentNodeEdgeUserCurrencyEventFragmentNodeEdge = AdminCurrencyEventFragmentNodeEdge | UserCurrencyEventFragmentNodeEdge;

export type AdminCurrencyPointConfigNode = {
  __typename?: 'AdminCurrencyPointConfigNode';
  allow_all_users?: Maybe<Scalars['Boolean']['output']>;
  currency_point_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

/** Node for organization admin - platform user */
export type AdminCurrencyPointNode = ICurrencyPointNode & IGamificationNode & {
  __typename?: 'AdminCurrencyPointNode';
  /** List of achievements associated with a currency point */
  achievements: CurrencyEventFragmentConnection;
  /** List of allowed users. */
  allowed_users: AllowedUserFragmentConnection;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  currency_point_config?: Maybe<AdminCurrencyPointConfigNode>;
  /** List of events associated with a currency point */
  events: CurrencyEventFragmentConnection;
  id?: Maybe<Scalars['ID']['output']>;
  initial_setup?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['ID']['output']>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  rewards: RewardFragmentConnection;
  setup_completed?: Maybe<Scalars['Boolean']['output']>;
  status_enum?: Maybe<CurrencyPointStatusEnum>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};


/** Node for organization admin - platform user */
export type AdminCurrencyPointNodeAchievementsArgs = {
  query_variables?: InputMaybe<CurrencyEventQueryInput>;
};


/** Node for organization admin - platform user */
export type AdminCurrencyPointNodeAllowed_UsersArgs = {
  query_variables?: InputMaybe<AllowedUserQueryInput>;
};


/** Node for organization admin - platform user */
export type AdminCurrencyPointNodeEventsArgs = {
  query_variables?: InputMaybe<CurrencyEventQueryInput>;
};


/** Node for organization admin - platform user */
export type AdminCurrencyPointNodeRewardsArgs = {
  query_variables?: InputMaybe<RewardQueryInput>;
};

export type AdminCurrencyPointNodeEdge = {
  __typename?: 'AdminCurrencyPointNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AdminCurrencyPointNode;
};

export type AdminCurrencyPointNodeEdgeUserCurrencyPointNodeEdge = AdminCurrencyPointNodeEdge | UserCurrencyPointNodeEdge;

export type AdminDeleteCategoryPayload = {
  __typename?: 'AdminDeleteCategoryPayload';
  category?: Maybe<KnowledgeHubAdminSimpleCategoryType>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AdminDeleteCategoryResponse = AdminDeleteCategoryPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type AdminDeleteCategoryRestrictionInput = {
  category_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminDeleteCategoryRestrictionResponse = AdminCategoryRestrictionPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type AdminDeleteDocumentContentInput = {
  content_ids: Array<Scalars['String']['input']>;
  organization_id: Scalars['Int']['input'];
};

export type AdminDeleteOrganizationCategoryInput = {
  category_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminDeleteTagInput = {
  id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminDeleteTagPayload = {
  __typename?: 'AdminDeleteTagPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  tag?: Maybe<TagType>;
};

export type AdminDeleteTagResponse = AdminDeleteTagPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type AdminDeletedContentDocumentsPayload = {
  __typename?: 'AdminDeletedContentDocumentsPayload';
  content_documents?: Maybe<Array<KnowledgeHubAdminContentDocumentType>>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AdminDocumentContentFilterInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  content_title?: InputMaybe<Scalars['String']['input']>;
  document_actions?: InputMaybe<Array<DocumentActionEnum>>;
  document_extensions?: InputMaybe<Array<DocumentExtension>>;
  visibility_level?: InputMaybe<VisibilityLevelType>;
};

export type AdminFiltersInput = {
  content_type: ContentTypeV2Enum;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminGetCatalogResumeInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminGetCategoryDetailInput = {
  category_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminGetCourseMentorsInput = {
  course_id: Scalars['ID']['input'];
  organization_id: Scalars['Int']['input'];
};

export type AdminGetEducationCourseContentListInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AdminCourseContentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<KnowledgeHubContentOrderByInput>;
  organization_id: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminGetOrganizationContent = {
  content_value: Scalars['String']['input'];
  organization_id: Scalars['Int']['input'];
};

export type AdminGetTagsByContentValueInput = {
  content_value: Scalars['String']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminGetTrackDetailInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Track ID (organization team ID) */
  organization_team_id: Scalars['Int']['input'];
};

/** This node concentrates on the event and achievement that have been won the most, as well as the most requested reward in the organization. */
export type AdminLeaderboardFragmentNode = {
  __typename?: 'AdminLeaderboardFragmentNode';
  box_one?: Maybe<MostCommonEventFragmentNode>;
  box_three?: Maybe<MostRequestedRewardFragmentNode>;
  box_two?: Maybe<MostCommonEventFragmentNode>;
};

export type AdminListCategoryInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  category_type?: InputMaybe<CategoryTypeV2Enum>;
  custom_field_option_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminListContentByCategoryInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  category_id: Scalars['Int']['input'];
  filters?: InputMaybe<AdminCategoryContentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminListContentByTagsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  tag_ids: Array<Scalars['ID']['input']>;
};

export type AdminListContentDocumentsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AdminDocumentContentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<KnowledgeHubContentOrderByInput>;
  organization_id: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminListTagsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Filter tags by name (case-insensitive). */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AdminLiveSessionUserSetInput = {
  filter: LiveSessionUserSetFilterInput;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  pagination?: LiveSessionPaginationInput;
  search?: InputMaybe<LiveSessionUserSetSearchInput>;
  sort?: Array<LiveSessionUsersOrderBy>;
};

/** Node Admin - User Summary info */
export type AdminOrganizationUserSummaryNode = IUserSummaryNode & {
  __typename?: 'AdminOrganizationUserSummaryNode';
  available_currency_points?: Maybe<Scalars['Float']['output']>;
  events_bank: EventCountConnection;
  organization_id?: Maybe<Scalars['Int']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  redemption_expenses?: Maybe<Scalars['Float']['output']>;
  redemptions_count?: Maybe<Scalars['Float']['output']>;
  total_achievements?: Maybe<Scalars['Int']['output']>;
  total_events?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<MyUserNode>;
  user_id?: Maybe<Scalars['Int']['output']>;
  xp_points?: Maybe<Scalars['Float']['output']>;
};


/** Node Admin - User Summary info */
export type AdminOrganizationUserSummaryNodeEvents_BankArgs = {
  query_variables?: InputMaybe<CurrencyEventQueryInput>;
};

export type AdminOrganizationUserSummaryNodeEdge = {
  __typename?: 'AdminOrganizationUserSummaryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AdminOrganizationUserSummaryNode;
};

export type AdminOrganizationUserSummaryNodeEdgeUserOrganizationUserSummaryNodeEdge = AdminOrganizationUserSummaryNodeEdge | UserOrganizationUserSummaryNodeEdge;

export type AdminProviderListInput = {
  centralized_organization_id: Scalars['ID']['input'];
  filter_by: AdminProviderSearchInput;
  first?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};

export type AdminProviderSearchInput = {
  search_text?: InputMaybe<Scalars['String']['input']>;
};

export type AdminRewardNode = IGamificationNode & IRewardNode & {
  __typename?: 'AdminRewardNode';
  activation_date?: Maybe<Scalars['DateTime']['output']>;
  can_be_deleted?: Maybe<Scalars['Boolean']['output']>;
  /** This field indicates whether a redemption can be made for a particular reward or not */
  can_redeemed_this_reward?: Maybe<Scalars['Boolean']['output']>;
  /** Reward cover */
  cover_attachment?: Maybe<ImageNode>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by_id?: Maybe<Scalars['Int']['output']>;
  currency_point?: Maybe<Scalars['JSON']['output']>;
  currency_point_id?: Maybe<Scalars['ID']['output']>;
  currency_point_value?: Maybe<Scalars['Float']['output']>;
  deactivation_date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_redeemable?: Maybe<Scalars['Boolean']['output']>;
  money_value?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['ID']['output']>;
  quantity_available?: Maybe<Scalars['Float']['output']>;
  quantity_reserved?: Maybe<Scalars['Float']['output']>;
  /** Field for allowed redemptions with a limit on the quantity of redemptions. */
  redemptions_allowed?: Maybe<Scalars['Int']['output']>;
  /** This field indicates the number of redemptions that can be made, it has a value when the admin has declared a value for the redemptions_allowed field. */
  redemptions_available?: Maybe<Scalars['Int']['output']>;
  reward_tags?: Maybe<Array<RewardTagNode>>;
  status_enum?: Maybe<RewardStatusEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminRewardNodeEdge = {
  __typename?: 'AdminRewardNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AdminRewardNode;
};

export type AdminRewardNodeEdgeUserRewardNodeEdge = AdminRewardNodeEdge | UserRewardNodeEdge;

export type AdminTagsMetadataType = {
  __typename?: 'AdminTagsMetadataType';
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type AdminTagsPagePagination = {
  __typename?: 'AdminTagsPagePagination';
  edges: Array<TagWithCountersTypePaginationEdge>;
  metadata?: Maybe<AdminTagsMetadataType>;
  /** Information to aid in pagination. */
  page_info: NumberPageInfo;
  page_size?: Maybe<Scalars['Int']['output']>;
};

export type AdminTrackDetailCategoryType = {
  __typename?: 'AdminTrackDetailCategoryType';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type AdminTrackDetailClosureType = {
  __typename?: 'AdminTrackDetailClosureType';
  close_reason?: Maybe<TrackCloseReasonEnum>;
  closed_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminTrackDetailCourseDependencyRuleType = {
  __typename?: 'AdminTrackDetailCourseDependencyRuleType';
  course_id: Scalars['Int']['output'];
};

export type AdminTrackDetailCourseDependencyType = {
  __typename?: 'AdminTrackDetailCourseDependencyType';
  course_id: Scalars['Int']['output'];
  depends_on: Array<AdminTrackDetailCourseDependencyRuleType>;
  position: Scalars['Int']['output'];
};

export type AdminTrackDetailOrganizationTeamCourseType = {
  __typename?: 'AdminTrackDetailOrganizationTeamCourseType';
  course?: Maybe<ContentCourseNode>;
  is_coming_soon: Scalars['Boolean']['output'];
  is_required?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type AdminTrackDetailRewardType = {
  __typename?: 'AdminTrackDetailRewardType';
  number_courses?: Maybe<Scalars['Int']['output']>;
};

export type AdminTrackDetailType = {
  __typename?: 'AdminTrackDetailType';
  categories: Array<AdminTrackDetailCategoryType>;
  /** Completion requirements currently in force for the track (epic CELC-4900). Null when the track has none configured: that is the empty state of the requirements tab, not an error. */
  completion_rule?: Maybe<TrackCompletionRuleType>;
  content_updated_at?: Maybe<Scalars['DateTime']['output']>;
  cover_image_id?: Maybe<Scalars['Int']['output']>;
  cover_image_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['Date']['output']>;
  expiration_time_in_days?: Maybe<Scalars['Int']['output']>;
  generate_certificate?: Maybe<Scalars['Boolean']['output']>;
  has_reward?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_draft?: Maybe<Scalars['Boolean']['output']>;
  last_closure?: Maybe<AdminTrackDetailClosureType>;
  modality?: Maybe<TrackModalityEnum>;
  name: Scalars['String']['output'];
  organization_team_course_dependencies: Array<AdminTrackDetailCourseDependencyType>;
  organization_team_courses: Array<AdminTrackDetailOrganizationTeamCourseType>;
  prereqs_updated_at?: Maybe<Scalars['DateTime']['output']>;
  reward?: Maybe<AdminTrackDetailRewardType>;
  reward_eligible_category_ids: Array<Scalars['ID']['output']>;
  total_courses_number: Scalars['Int']['output'];
  version?: Maybe<Scalars['String']['output']>;
  visibility_level?: Maybe<VisibilityLevelType>;
};

export type AdminUpdateCategoryPayload = {
  __typename?: 'AdminUpdateCategoryPayload';
  category?: Maybe<KnowledgeHubAdminSimpleCategoryType>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AdminUpdateCategoryResponse = AdminUpdateCategoryPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type AdminUpdateCategoryRestrictionInput = {
  category_id: Scalars['Int']['input'];
  custom_field_option_ids: Array<Scalars['String']['input']>;
  operator: B2BCustomFieldSearchOperatorEnum;
  organization_id: Scalars['Int']['input'];
};

export type AdminUpdateCategoryRestrictionResponse = AdminCategoryRestrictionPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type AdminUpdateContentDocumentPayload = {
  __typename?: 'AdminUpdateContentDocumentPayload';
  content_document?: Maybe<KnowledgeHubAdminContentDocumentType>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type AdminUpdateContentVisibilityInput = {
  content_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<AdminCourseContentFilterInput>;
  has_select_all?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id: Scalars['Int']['input'];
  visibility_level: VisibilityLevelType;
};

export type AdminUpdateOrganizationCategoryInput = {
  category_id: Scalars['ID']['input'];
  image_file_id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  visibility_level?: InputMaybe<VisibilityLevelType>;
};

export type AdminUpdateOrganizationContentConfigInput = {
  content_value: Scalars['String']['input'];
  organization_id: Scalars['Int']['input'];
  visibility_level: VisibilityLevelType;
};

export type AdminUpdateOrganizationDocumentInput = {
  action?: InputMaybe<DocumentActionEnum>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  content_id: Scalars['String']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organization_id: Scalars['Int']['input'];
  visibility_level: VisibilityLevelType;
};

export type AdminUpdateTagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminUpdateTagPayload = {
  __typename?: 'AdminUpdateTagPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  tag?: Maybe<TagType>;
};

export type AdminUpdateTagResponse = AdminUpdateTagPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type AdvancedConfiguration = {
  __typename?: 'AdvancedConfiguration';
  active: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type AdvancedConfigurationInput = {
  company_id: Scalars['Int']['input'];
  configuration_ids: Array<Scalars['Int']['input']>;
};

export type AdvancedConfigurationList = {
  __typename?: 'AdvancedConfigurationList';
  advanced_configurations?: Maybe<Array<AdvancedConfiguration>>;
};

export type AdvancedConfigurationResponse = AdvancedConfigurationList | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

/** Subgraph HRIS - Affected Users by Conditionals Info Node */
export type AffectedUsersByConditionalsNode = {
  __typename?: 'AffectedUsersByConditionalsNode';
  /** User Area Name */
  area_name?: Maybe<Scalars['String']['output']>;
  /** Centralized User ID */
  centralized_user_id: Scalars['Int']['output'];
  /** User Email */
  email: Scalars['String']['output'];
  /** User FirstName */
  firstname: Scalars['String']['output'];
  /** User Organization ID */
  id: Scalars['Int']['output'];
  /** User LastName */
  lastname: Scalars['String']['output'];
  /** User Position Name */
  position_name?: Maybe<Scalars['String']['output']>;
};

export type AffectedUsersByConditionalsNodeCustomConnection = {
  __typename?: 'AffectedUsersByConditionalsNodeCustomConnection';
  edges: Array<AffectedUsersByConditionalsNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type AffectedUsersByConditionalsNodeCustomEdge = {
  __typename?: 'AffectedUsersByConditionalsNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AffectedUsersByConditionalsNode;
};

export type AffectedUsersFilterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
};

export type AgentOsMutation = {
  __typename?: 'AgentOSMutation';
  /** Climate survey wizard operations. */
  climate_survey: ClimateSurveyMutation;
  /** Send an action to resume a paused workflow. */
  send_workflow_action: AgentosSendActionResponse;
  /** Start a new AgentOS workflow. */
  start_workflow: AgentosStartWorkflowResponse;
};


export type AgentOsMutationSend_Workflow_ActionArgs = {
  input: AgentosSendActionInput;
};


export type AgentOsMutationStart_WorkflowArgs = {
  input: AgentosStartWorkflowInput;
};

export type AgentOsQuery = {
  __typename?: 'AgentOSQuery';
  /** Climate survey wizard queries. */
  climate_survey: ClimateSurveyQuery;
  /** Returns aggregated agent usage analytics for the authenticated user's organization: total workflows, unique users, breakdown by agent type, breakdown by status (funnel), and unique users per agent. */
  get_agent_analytics: AgentosGetAgentAnalyticsResponse;
  /** Returns cross-org dashboard metrics: KPIs, agent x status matrix, daily trend, org summary, cancel hotspots, stale workflows. All aggregations in a single call for the usage dashboard. */
  get_dashboard_metrics: AgentosGetDashboardMetricsResponse;
  /** Returns organization onboarding status for the Genesis Hub dashboard: status enum and aggregate counts of active users and positions. */
  get_organization_status: AgentosGetOrganizationStatusResponse;
  /** Returns the detail of a single workflow for the authenticated user. */
  get_user_workflow: AgentosGetUserWorkflowResponse;
  /** Returns all workflows for the authenticated user in their organization. */
  get_user_workflows: AgentosGetUserWorkflowsResponse;
  /** Fetch the current status of an AgentOS workflow thread. */
  get_workflow_status: AgentosGetWorkflowStatusResponse;
  /** Health check for the AgentOS workflow integration. */
  health: Scalars['String']['output'];
};


export type AgentOsQueryGet_Agent_AnalyticsArgs = {
  input: AgentosGetAgentAnalyticsInput;
};


export type AgentOsQueryGet_Dashboard_MetricsArgs = {
  input: AgentosGetDashboardMetricsInput;
};


export type AgentOsQueryGet_Organization_StatusArgs = {
  input: AgentosGetOrganizationStatusInput;
};


export type AgentOsQueryGet_User_WorkflowArgs = {
  input: AgentosGetUserWorkflowInput;
};


export type AgentOsQueryGet_User_WorkflowsArgs = {
  input: AgentosGetUserWorkflowsInput;
};


export type AgentOsQueryGet_Workflow_StatusArgs = {
  input: AgentosGetWorkflowStatusInput;
};

export enum AgentTypeEnum {
  AgentTypeExternal = 'AGENT_TYPE_EXTERNAL',
  AgentTypeInternal = 'AGENT_TYPE_INTERNAL',
  AgentTypeOther = 'AGENT_TYPE_OTHER'
}

/** Supported workflow action types. Union across all agents: genesis/atlas/norte/moves/climate/overtime, scout and competency. */
export enum AgentosActionTypeEnum {
  Back = 'BACK',
  Cancel = 'CANCEL',
  Confirm = 'CONFIRM',
  Continue = 'CONTINUE',
  CreateNew = 'CREATE_NEW',
  DuplicateAndEdit = 'DUPLICATE_AND_EDIT',
  Finish = 'FINISH',
  GenerateExcelDocument = 'GENERATE_EXCEL_DOCUMENT',
  Merge = 'MERGE',
  Message = 'MESSAGE',
  Modify = 'MODIFY',
  MoveChangeArea = 'MOVE_CHANGE_AREA',
  MoveChangeBoss = 'MOVE_CHANGE_BOSS',
  MoveChangePosition = 'MOVE_CHANGE_POSITION',
  MoveRetirement = 'MOVE_RETIREMENT',
  ProvideValue = 'PROVIDE_VALUE',
  Retry = 'RETRY',
  SelectModel = 'SELECT_MODEL',
  SkipStep = 'SKIP_STEP',
  UpdateQuery = 'UPDATE_QUERY',
  UploadFile = 'UPLOAD_FILE'
}

/** Aggregated agent usage analytics for an organization. */
export type AgentosAgentAnalyticsType = {
  __typename?: 'AgentosAgentAnalyticsType';
  /** Total number of unique users who have initiated workflows. */
  total_unique_users: Scalars['Int']['output'];
  /** Total number of workflows in the organization. */
  total_workflows: Scalars['Int']['output'];
  /** Number of unique users per agent type. */
  unique_users_by_agent: Array<AgentosAgentCountType>;
  /** Breakdown of workflow counts by agent type. */
  workflows_by_agent: Array<AgentosAgentCountType>;
  /** Breakdown of workflow counts by status. Reflects the funnel: started → in_progress → done/error. */
  workflows_by_status: Array<AgentosStatusCountType>;
};

/** Count of workflows grouped by agent type. */
export type AgentosAgentCountType = {
  __typename?: 'AgentosAgentCountType';
  /** Agent type identifier, e.g. 'genesis', 'scout', 'atlas', 'norte', 'moves', 'climate', 'overtime'. */
  agent: Scalars['String']['output'];
  /** Number of workflows for this agent. */
  count: Scalars['Int']['output'];
};

/** Structured response emitted by the agent for a completed turn. Strict shape {action, message, data}; the data payload is action-specific (e.g. scout query results, atlas/norte completion payload). */
export type AgentosAgentResponseType = {
  __typename?: 'AgentosAgentResponseType';
  /** Action that produced this response. */
  action: Scalars['String']['output'];
  /** Action-specific payload returned by the agent. */
  data: Scalars['JSON']['output'];
  /** Human-readable message for the UI. */
  message: Scalars['String']['output'];
};

/** Single cell in agent x status matrix. */
export type AgentosAgentStatusCountType = {
  __typename?: 'AgentosAgentStatusCountType';
  agent: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

/** Cancellation hotspot: agent + last_step. */
export type AgentosCancelHotspotType = {
  __typename?: 'AgentosCancelHotspotType';
  agent: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  last_step: Scalars['String']['output'];
};

/** A single survey question. */
export type AgentosClimateQuestionType = {
  __typename?: 'AgentosClimateQuestionType';
  /** Whether this question is mandatory. */
  is_required: Scalars['Boolean']['output'];
  /** Answer options (SINGLE_CHOICE only). */
  options?: Maybe<Array<ClimateQuestionOptionType>>;
  /** Question text. */
  text: Scalars['String']['output'];
  /** Question type. */
  type: ClimateQuestionTypeEnum;
};

/** Workflow count for one day + agent. */
export type AgentosDailyTrendType = {
  __typename?: 'AgentosDailyTrendType';
  agent: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  day: Scalars['String']['output'];
};

/** Full dashboard metrics — all aggregations in one call. */
export type AgentosDashboardMetricsType = {
  __typename?: 'AgentosDashboardMetricsType';
  agent_status_matrix: Array<AgentosAgentStatusCountType>;
  cancel_hotspots: Array<AgentosCancelHotspotType>;
  daily_trend: Array<AgentosDailyTrendType>;
  org_summary: Array<AgentosOrgSummaryType>;
  stale_in_progress: Scalars['Int']['output'];
  total_orgs: Scalars['Int']['output'];
  total_users: Scalars['Int']['output'];
  total_workflows: Scalars['Int']['output'];
  workflows_by_status: Array<AgentosStatusCountType>;
};

/** Input for querying agent usage analytics for the authenticated user's organization. */
export type AgentosGetAgentAnalyticsInput = {
  /** Filter by agent type ('genesis', 'scout', 'atlas', 'norte', 'moves', 'competency', 'climate', 'overtime'). Returns metrics for all agents if omitted. */
  agent?: InputMaybe<Scalars['String']['input']>;
  /** Centralized organization ID to scope analytics by. */
  centralized_organization_id: Scalars['String']['input'];
  /** Start of date range (inclusive). Only workflows created on or after this date are counted. */
  date_from?: InputMaybe<Scalars['DateTime']['input']>;
  /** End of date range (inclusive). Only workflows created on or before this date are counted. */
  date_to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AgentosGetAgentAnalyticsResponse = AgentosAgentAnalyticsType | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input for cross-org dashboard metrics. */
export type AgentosGetDashboardMetricsInput = {
  /** Start of date range (inclusive). */
  date_from?: InputMaybe<Scalars['DateTime']['input']>;
  /** End of date range (inclusive). */
  date_to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AgentosGetDashboardMetricsResponse = AgentosDashboardMetricsType | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input for fetching organization onboarding status. */
export type AgentosGetOrganizationStatusInput = {
  /** Centralized organization ID to query status for. */
  centralized_organization_id: Scalars['Int']['input'];
};

export type AgentosGetOrganizationStatusResponse = AgentosOrganizationStatusType | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input for fetching the detail of a single workflow. */
export type AgentosGetUserWorkflowInput = {
  /** Centralized organization ID to scope the workflow lookup. */
  centralized_organization_id: Scalars['String']['input'];
  /** Organization slug for additional scoping. */
  centralized_organization_slug?: InputMaybe<Scalars['String']['input']>;
  /** Unique workflow identifier to fetch. */
  workflow_id: Scalars['String']['input'];
};

export type AgentosGetUserWorkflowResponse = AgentosUserWorkflowDetailType | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input for querying workflows of the authenticated user. */
export type AgentosGetUserWorkflowsInput = {
  /** Filter by agent type ('genesis', 'scout', 'atlas', 'norte', 'moves', 'competency', 'climate', 'overtime'). Returns all agents if omitted. */
  agent?: InputMaybe<Scalars['String']['input']>;
  /** Centralized organization ID to filter workflows by. Falls back to JWT session if omitted. */
  centralized_organization_id?: InputMaybe<Scalars['String']['input']>;
};

export type AgentosGetUserWorkflowsResponse = AgentosUserWorkflowsResultType | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input for fetching the current status of an AgentOS workflow. */
export type AgentosGetWorkflowStatusInput = {
  /** Thread identifier for state persistence. */
  thread_id: Scalars['String']['input'];
  /** Target workflow identifier. */
  workflow_id: Scalars['String']['input'];
};

export type AgentosGetWorkflowStatusResponse = AgentosWorkflowStatusType | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Interrupt payload sent by the agent when waiting for user input. */
export type AgentosInterruptDataType = {
  __typename?: 'AgentosInterruptDataType';
  /** Action types the user can send to resume the workflow. */
  allowed_actions: Array<Scalars['String']['output']>;
  /** Extra context data for the frontend. */
  data: Scalars['JSON']['output'];
  /** Human-readable message for the UI. */
  message: Scalars['String']['output'];
  /** Current workflow step name. */
  step: Scalars['String']['output'];
  /** What the agent is waiting for. */
  waiting_for: Scalars['String']['output'];
};

/** Organization onboarding status for Genesis Hub. */
export enum AgentosOrgStatusEnum {
  Activa = 'ACTIVA',
  Onboarding = 'ONBOARDING'
}

/** Aggregated metrics for one organization. */
export type AgentosOrgSummaryType = {
  __typename?: 'AgentosOrgSummaryType';
  agents_used: Scalars['Int']['output'];
  cancelled: Scalars['Int']['output'];
  done: Scalars['Int']['output'];
  org_id: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  users: Scalars['Int']['output'];
  workflows: Scalars['Int']['output'];
};

/** Organization onboarding status for the Genesis Hub dashboard. */
export type AgentosOrganizationStatusType = {
  __typename?: 'AgentosOrganizationStatusType';
  /** Total number of active positions (cargos) in the organization. */
  active_positions_count: Scalars['Int']['output'];
  /** Total number of active users in the organization. */
  active_users_count: Scalars['Int']['output'];
  /** Centralized organization identifier. */
  id: Scalars['ID']['output'];
  /** Organization status: ONBOARDING or ACTIVA. */
  status: AgentosOrgStatusEnum;
};

/** Input for sending an action to a paused workflow. */
export type AgentosSendActionInput = {
  /** Action type to send. */
  action_type: AgentosActionTypeEnum;
  /** Optional payload for the action. */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Thread identifier. */
  thread_id: Scalars['String']['input'];
  /** Target workflow identifier. */
  workflow_id: Scalars['String']['input'];
};

export type AgentosSendActionResponse = AgentosWorkflowStatusType | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input for starting a new AgentOS workflow. */
export type AgentosStartWorkflowInput = {
  /** Centralized organization ID used by downstream HRIS bulk operations. */
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Organization slug forwarded to the workflow (used by competency for LLM context). */
  centralized_organization_slug?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated — use centralized_organization_slug instead. */
  organization_slug?: InputMaybe<Scalars['String']['input']>;
  /** Initial user message. Required by scout. Ignored by genesis, atlas and competency. */
  user_message?: InputMaybe<Scalars['String']['input']>;
  /** Workflow type to execute, e.g. 'genesis', 'scout', 'atlas', 'norte', 'moves', 'competency', 'climate', 'overtime'. */
  workflow_type: Scalars['String']['input'];
};

export type AgentosStartWorkflowResponse = AgentosWorkflowStatusType | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Count of workflows grouped by workflow status. */
export type AgentosStatusCountType = {
  __typename?: 'AgentosStatusCountType';
  /** Number of workflows in this status. */
  count: Scalars['Int']['output'];
  /** Workflow lifecycle status: started, in_progress, done, cancelled, error. */
  status: Scalars['String']['output'];
};

/** Detailed view of a single user workflow. */
export type AgentosUserWorkflowDetailType = {
  __typename?: 'AgentosUserWorkflowDetailType';
  /** Agent type, e.g. 'genesis', 'scout', 'atlas', 'norte', 'moves', 'competency', 'climate', 'overtime'. */
  agent: Scalars['String']['output'];
  /** Organization slug recorded at workflow creation. */
  centralized_organization_slug?: Maybe<Scalars['String']['output']>;
  /** When the workflow was created. */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Plain error message present when status is 'error'. */
  error_detail?: Maybe<Scalars['String']['output']>;
  /** Last interrupt payload received from the agent. Contains step-specific data such as positions/employees validation results (genesis) or norte wizard step data (context, frequency, expectations, etc.). */
  last_interrupt_data?: Maybe<Scalars['JSON']['output']>;
  /** Last known step of the workflow. */
  last_step: Scalars['String']['output'];
  /** Workflow lifecycle status: started, in_progress, done, cancelled, error. */
  status: Scalars['String']['output'];
  /** LangGraph thread identifier (UUID). */
  thread_id: Scalars['String']['output'];
  /** When the workflow was last updated. */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Workflow identifier (UUID). */
  workflow_id: Scalars['String']['output'];
};

/** A persisted user workflow record. */
export type AgentosUserWorkflowType = {
  __typename?: 'AgentosUserWorkflowType';
  /** Agent type, e.g. 'genesis', 'scout', 'atlas', 'norte', 'moves', 'competency', 'climate', 'overtime'. */
  agent: Scalars['String']['output'];
  /** When the workflow was created. */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Plain error message present when status is 'error'. */
  error_detail?: Maybe<Scalars['String']['output']>;
  /** Last interrupt payload received from the agent. Populated after each send_workflow_action or start_workflow call. */
  last_interrupt_data?: Maybe<Scalars['JSON']['output']>;
  /** Last known step of the workflow. */
  last_step: Scalars['String']['output'];
  /** Workflow lifecycle status: started, in_progress, done, cancelled, error. */
  status: Scalars['String']['output'];
  /** LangGraph thread identifier (UUID). */
  thread_id: Scalars['String']['output'];
  /** When the workflow was last updated. */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Workflow identifier (UUID). */
  workflow_id: Scalars['String']['output'];
};

/** List of user workflows. */
export type AgentosUserWorkflowsResultType = {
  __typename?: 'AgentosUserWorkflowsResultType';
  /** Workflows belonging to the authenticated user in this organization. */
  workflows: Array<AgentosUserWorkflowType>;
};

/** Current status of an AgentOS workflow. */
export type AgentosWorkflowStatusType = {
  __typename?: 'AgentosWorkflowStatusType';
  /** Structured agent response when the workflow completes or is cancelled; null when status is 'error'. */
  agent_response?: Maybe<AgentosAgentResponseType>;
  /** Name of the current step. */
  current_step: Scalars['String']['output'];
  /** Plain error message present when status is 'error'. */
  error_detail?: Maybe<Scalars['String']['output']>;
  /** Present when the workflow is paused and waiting for user action. */
  interrupt_data?: Maybe<AgentosInterruptDataType>;
  /** Workflow status: started, running, completed, cancelled, error. */
  status: Scalars['String']['output'];
  /** LangGraph thread identifier. The frontend must store this value and send it in every subsequent send_workflow_action call to continue the same agent session. */
  thread_id: Scalars['String']['output'];
  /** Unique workflow identifier. */
  workflow_id: Scalars['String']['output'];
  /** Workflow type, e.g. 'scout'. */
  workflow_type: Scalars['String']['output'];
};

/** A single actionable alert requiring admin attention. */
export type AlertNode = {
  __typename?: 'AlertNode';
  /** Relative URL to act on this alert (e.g. '/analytics-hub/admin/alerts/overdue'). */
  action_url?: Maybe<Scalars['String']['output']>;
  /** Number of affected items. */
  count: Scalars['Int']['output'];
  /** Alert detail/context. */
  description: Scalars['String']['output'];
  /** Icon name for the alert (e.g. 'error', 'schedule', 'trending_down'). */
  icon: Scalars['String']['output'];
  /** Unique alert identifier used for permission filtering (e.g. 'overdue_mandatory_courses'). */
  key: Scalars['String']['output'];
  /** Semantic color token for the alert. Values: 'danger', 'warning', 'info'. Null triggers frontend fallback by key. */
  semantic_color?: Maybe<Scalars['String']['output']>;
  /**
   * Deprecated — use semantic_color instead. Alert severity level.
   * @deprecated Use semantic_color instead. Will be removed once frontend migrates.
   */
  severity: AlertSeverity;
  /** Alert title. */
  title: Scalars['String']['output'];
};

/** Severity level of a dashboard alert. */
export enum AlertSeverity {
  Blue = 'BLUE',
  Orange = 'ORANGE',
  Red = 'RED',
  Yellow = 'YELLOW'
}

/** Sede permitida del solicitante con su conteo de usuarios. */
export type AllowedHeadquarterNode = {
  __typename?: 'AllowedHeadquarterNode';
  /** ID de la sede (headquarter). */
  headquarter_id: Scalars['Int']['output'];
  /** Nombre de la sede. */
  name: Scalars['String']['output'];
  /** Cantidad de usuarios activos que pertenecen a la sede. */
  user_count: Scalars['Int']['output'];
};

export type AllowedUserAchievement = {
  __typename?: 'AllowedUserAchievement';
  icon_url: Scalars['String']['output'];
  occurrences_obtained: Scalars['Int']['output'];
  original_id: Scalars['Int']['output'];
};

export type AllowedUserAssignments = {
  __typename?: 'AllowedUserAssignments';
  total_activated: Scalars['Int']['output'];
  total_deactivated: Scalars['Int']['output'];
  total_updated: Scalars['Int']['output'];
};

export type AllowedUserAssignmentsAssignmentResponse = {
  __typename?: 'AllowedUserAssignmentsAssignmentResponse';
  detail?: Maybe<AllowedUserAssignments>;
  graphql_operation_id: Scalars['ID']['output'];
};

export type AllowedUserConnection = {
  __typename?: 'AllowedUserConnection';
  /** Contains the nodes in this connection */
  edges: Array<AllowedUserNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type AllowedUserCreateInput = {
  allow_all_users?: Scalars['Boolean']['input'];
  allowed_users?: InputMaybe<Array<Scalars['Int']['input']>>;
  currency_point_id: Scalars['ID']['input'];
  disallowed_users?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AllowedUserForAssignmentInterface = {
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  tags: UserTagsType;
  user: UserInfoType;
};

export type AllowedUserFragmentConnection = {
  __typename?: 'AllowedUserFragmentConnection';
  /** Contains the nodes in this connection */
  edges: Array<AdminAllowedUserNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type AllowedUserInterface = {
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  user: UserInfoType;
};

/** This input contains the necessary fields to assign specific users or mark the playroom configuration for all users in the organization. */
export type AllowedUserMutationCreateInput = {
  allow_all_users?: Scalars['Boolean']['input'];
  allowed_users?: InputMaybe<Array<Scalars['String']['input']>>;
  currency_point_id: Scalars['String']['input'];
  disallowed_users?: InputMaybe<Array<Scalars['String']['input']>>;
  organization_id: Scalars['String']['input'];
};

export type AllowedUserNode = {
  __typename?: 'AllowedUserNode';
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  user_id: Scalars['ID']['output'];
};

export type AllowedUserNodeEdge = {
  __typename?: 'AllowedUserNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AllowedUserNode;
};

export type AllowedUserQueryInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  currency_point_id?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AllowedUsersQueryOrderByInput>>;
  organization_id?: InputMaybe<Scalars['ID']['input']>;
  panel_admin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AllowedUserStats = {
  __typename?: 'AllowedUserStats';
  available_points: Scalars['Float']['output'];
  ranking?: Maybe<Scalars['Int']['output']>;
  xp_points: Scalars['Float']['output'];
};

export type AllowedUserSummary = {
  __typename?: 'AllowedUserSummary';
  /** GamificationName */
  currency_point_name?: Maybe<Scalars['String']['output']>;
  /** GamificationStatus */
  currency_point_status: GamificationStatusEnum;
  /** AllowedUserId */
  id: Scalars['Int']['output'];
  /** GamificationStats */
  stats: AllowedUserStats;
  /** UserId */
  user_id: Scalars['Int']['output'];
};

export type AllowedUserSummaryUserSummaryResponse = {
  __typename?: 'AllowedUserSummaryUserSummaryResponse';
  detail?: Maybe<AllowedUserSummary>;
  graphql_operation_id: Scalars['ID']['output'];
};

export enum AllowedUsersEnum {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

export enum AllowedUsersFieldsEnum {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

export type AllowedUsersOrderByInput = {
  direction: OrderDirectionEnum;
  field: AllowedUsersEnum;
};

export type AllowedUsersQueryOrderByInput = {
  direction: OrderDirectionEnum;
  field: AllowedUsersFieldsEnum;
};

export enum AmericaCountryEnum {
  Ar = 'AR',
  Bo = 'BO',
  Br = 'BR',
  Cl = 'CL',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Do = 'DO',
  Ec = 'EC',
  Gt = 'GT',
  Hn = 'HN',
  Mx = 'MX',
  Ni = 'NI',
  Pa = 'PA',
  Pe = 'PE',
  Pr = 'PR',
  Py = 'PY',
  Sv = 'SV',
  Us = 'US',
  Uy = 'UY',
  Ve = 'VE'
}

export type AnalyticsBulkCreateCustomReportsInput = {
  /** SCHEDULE_AND_SAVE activates scheduling; SAVE_NO_SCHEDULE creates without schedule. */
  bulk_mode: BulkScheduleModeInput;
  /** Centralized organization scope. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional shared description (max 150 chars). */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional prefix for names. When provided, final name = '{prefix} ({template name})'. When null/empty, name = template name. Max 50 chars. */
  name_prefix?: InputMaybe<Scalars['String']['input']>;
  /** Product type (e.g. PRODUCT_LEARNING, PRODUCT_MANAGEMENT). */
  product_type: ProductTypeEnum;
  /** Shared wizard config: columns, filters, date ranges, segment. */
  report_input_config: Scalars['JSON']['input'];
  /** List of report_type values to create (max 10). Each must have can_schedule=True. */
  report_types: Array<ReportsEnum>;
  /** Shared schedule config (frequency, day, recipients). Required when bulk_mode=SCHEDULE_AND_SAVE. */
  schedule: ScheduleConfigInput;
};

export type AnalyticsCentralizedOrganizationNode = {
  __typename?: 'AnalyticsCentralizedOrganizationNode';
  central_org_id: Scalars['Int']['output'];
  company_id?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  open_opportunity_id?: Maybe<Scalars['Int']['output']>;
  org_id?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['DateTime']['output']>;
};

export type AnalyticsCentralizedOrganizationQuery = {
  __typename?: 'AnalyticsCentralizedOrganizationQuery';
  get_all_analytics_centralized_organization: Array<AnalyticsCentralizedOrganizationNode>;
};

export type AnalyticsCreateCustomReportInput = {
  /** Centralized organization scope for the custom report. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional description (max 150 chars). */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Display name for the custom report (max 50 chars). */
  name: Scalars['String']['input'];
  /** Product type (e.g. PRODUCT_LEARNING, PRODUCT_MANAGEMENT). */
  product_type: ProductTypeEnum;
  /** Wizard step 1 config: columns, filters, date ranges, segment. */
  report_input_config: Scalars['JSON']['input'];
  /** Report type. Must match a ReportTemplate with can_schedule=True. */
  report_type: ReportsEnum;
  /** Optional schedule config. If omitted, mode defaults to NONE. */
  schedule?: InputMaybe<ScheduleConfigInput>;
  /** Optional segment ID to scope the report to a specific user segment. */
  segment_id?: InputMaybe<Scalars['Int']['input']>;
};

export enum AnalyticsCustomFieldTypeEnum {
  OpenText = 'OPEN_TEXT',
  SelectOption = 'SELECT_OPTION'
}

/** Base input for dashboard queries. */
export type AnalyticsDashboardInput = {
  /** Centralized organization ID to scope the dashboard data. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Optional calendar period-to-date window for widgets that support the date filter (e.g. get_areas_engagement). Omit for the default (current month-to-date). Widgets that are not period-dependent ignore it. */
  period?: InputMaybe<AnalyticsDashboardPeriodWindowInput>;
};

/** Input for the KPI cards query. */
export type AnalyticsDashboardKpiInput = {
  /** Centralized organization ID to scope the dashboard data. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Which KPI cards to retrieve. Send all 3 to get the full section in one request. */
  kpi_types: Array<KpiTypeEnum>;
  /** Number of days to consider (e.g. 30). Sent by frontend. */
  latest_days?: Scalars['Int']['input'];
};

/** Input for General dashboard queries that support the calendar date filter. */
export type AnalyticsDashboardPeriodInput = {
  /** Centralized organization ID to scope the dashboard data. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Calendar period-to-date window for the widget. Defaults to the current month-to-date when omitted. */
  period?: InputMaybe<AnalyticsDashboardPeriodWindowInput>;
};

/** Calendar period-to-date presets for the General dashboard date filter, anchored to the org's today (same contract as the Learning dashboard): semana/mes/trimestre/año = week-start/1st-of-month/quarter-start/Jan-1 → today. CUSTOM covers a range (from_date != to_date) and a single exact date (from_date == to_date). */
export enum AnalyticsDashboardPeriodWindowEnum {
  CurrentMonth = 'CURRENT_MONTH',
  CurrentQuarter = 'CURRENT_QUARTER',
  CurrentWeek = 'CURRENT_WEEK',
  CurrentYear = 'CURRENT_YEAR',
  Custom = 'CUSTOM'
}

/** Calendar period-to-date window for the General dashboard date filter (adopts the Learning period contract). Omit for the default (current month-to-date). Presets run from the start of the period to today. CUSTOM requires from_date and to_date, both inclusive; from_date == to_date is a valid single-day window (Específico), from_date < to_date is a range (Rango). If a preset and dates are both sent, the preset wins. */
export type AnalyticsDashboardPeriodWindowInput = {
  /** Custom range start (inclusive). Required for CUSTOM. */
  from_date?: InputMaybe<Scalars['Date']['input']>;
  /** Calendar period-to-date preset. Defaults to CURRENT_MONTH (month-to-date) when omitted; dates sent without a preset imply CUSTOM. */
  period?: InputMaybe<AnalyticsDashboardPeriodWindowEnum>;
  /** Custom range end (inclusive). Required for CUSTOM. Equal to from_date for a single exact date (Específico). */
  to_date?: InputMaybe<Scalars['Date']['input']>;
};

/** Input for the module pulse cards query. */
export type AnalyticsDashboardPulseInput = {
  /** Centralized organization ID to scope the dashboard data. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Calendar period-to-date window for the pulse KPIs. Defaults to the current month-to-date when omitted. */
  period?: InputMaybe<AnalyticsDashboardPeriodWindowInput>;
  /** Which product cards to retrieve. Send multiple to get several cards in one request. */
  product_types: Array<DashboardProductEnum>;
};

export type AnalyticsDeleteCustomReportInput = {
  /** Centralized organization scope (required for multi-tenant isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID of the custom report to soft-delete. */
  custom_report_id: Scalars['Int']['input'];
};

export type AnalyticsGetCustomReportInput = {
  /** Centralized organization scope. */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID of the custom report to retrieve. */
  custom_report_id: Scalars['Int']['input'];
};

export type AnalyticsGetOrganizationStatsInput = {
  /** The learning organization ID */
  organization_id: Scalars['Int']['input'];
};

export type AnalyticsGetReportColumnConfigInput = {
  /** ID de la organización centralizada. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Tipo de reporte (e.g. REPORT_B2B_USERS). */
  report_type: ReportsEnum;
};

/** Certificates issued in one month. */
export type AnalyticsLearningCertificateMonthlyPoint = {
  __typename?: 'AnalyticsLearningCertificateMonthlyPoint';
  /** Certificates issued in the month. */
  certificates: Scalars['Int']['output'];
  /** Month label, e.g. '2026-06'. */
  period: Scalars['String']['output'];
};

/** Historical certificates and survey-satisfaction data for the organization. Period-independent. Empty arrays are valid (never an error). */
export type AnalyticsLearningCertificatesSatisfaction = {
  __typename?: 'AnalyticsLearningCertificatesSatisfaction';
  /** All-time certificate totals. */
  certificates: AnalyticsLearningCertificatesSummary;
  /** Certificates issued per month, last 12 months, oldest first. */
  certificates_monthly: Array<AnalyticsLearningCertificateMonthlyPoint>;
  /** Structured error code for degraded responses. Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** CSAT per route launched in the last 90 days, ordered by responses desc, capped at 50. */
  route_satisfaction: Array<AnalyticsLearningRouteCsat>;
};

/** Input for the Learning certificates + survey-satisfaction data. Historical (no period field). */
export type AnalyticsLearningCertificatesSatisfactionInput = {
  /** Centralized organization ID to scope the data. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** All-time certificate totals for the organization. */
export type AnalyticsLearningCertificatesSummary = {
  __typename?: 'AnalyticsLearningCertificatesSummary';
  /** Certificates per certified user (total / users with >=1; excludes users without a certificate, BR-1). */
  avg_per_user: Scalars['Float']['output'];
  /** Total evaluation certificates issued. */
  total_issued: Scalars['Int']['output'];
  /** Distinct users with at least one certificate. */
  users_with_certificate: Scalars['Int']['output'];
};

/** Catalog-type filter for the 'Por cursos' views. */
export enum AnalyticsLearningCourseCatalogEnum {
  All = 'ALL',
  Crehana = 'CREHANA',
  Own = 'OWN'
}

/** Detail drawer for one course (ANLT-295): satisfacción promedio (CSAT) + top users by progress. 'Avance por módulo' is deferred — refined has no per-module granularity. */
export type AnalyticsLearningCourseDetail = {
  __typename?: 'AnalyticsLearningCourseDetail';
  /** Course category (category_01 from the catalog, ANLT-397). */
  category: Scalars['String']['output'];
  /** Course identifier. */
  course_id: Scalars['Int']['output'];
  /** Global course rating (avg_course_score); null = 'Sin datos'. */
  csat?: Maybe<Scalars['Float']['output']>;
  /** Number of ratings behind the CSAT (total_course_answers). */
  csat_responses: Scalars['Int']['output'];
  /** Structured error code for degraded responses. Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Detail URL the drawer CTA redirects to; null when the org slug is missing (ANLT-290). */
  redirect_url?: Maybe<Scalars['String']['output']>;
  /** Top users by course progress. */
  top_users: Array<AnalyticsLearningCourseTopUser>;
};

/** Input for the detail drawer of one course (ANLT-295). */
export type AnalyticsLearningCourseDetailInput = {
  /** Centralized organization id. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Course to expand. */
  course_id: Scalars['Int']['input'];
  /** Headquarter (sede) IDs to scope the drawer. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** One row of the 'Por cursos' deep-dive table (ANLT-295): per-course enrollment, progress, evaluation, hours, certificates and CSAT. */
export type AnalyticsLearningCourseTableRow = {
  __typename?: 'AnalyticsLearningCourseTableRow';
  /** Users with an evaluation certificate in the course. */
  certificates: Scalars['Int']['output'];
  /** Enrollments completed within the period. */
  completed: Scalars['Int']['output'];
  /** completados / iniciados x 100 (ANLT-441 M2: canonical 'tasa de finalizacion' = over STARTED, the drawer's source of truth). 0.0 when none started. */
  completion_rate: Scalars['Float']['output'];
  /** Course identifier. */
  course_id: Scalars['Int']['output'];
  /** Course name. */
  course_name: Scalars['String']['output'];
  /** 'Catálogo Crehana' or 'Propio' (from is_crehana). */
  course_type: Scalars['String']['output'];
  /** Global course rating (avg_course_score); null = 'Sin datos' when the course has no answers. */
  csat?: Maybe<Scalars['Float']['output']>;
  /** Distinct users with activity in the course within the period (last_action_date, or started/completed/certified in it) — the report's 'Cantidad de Estudiantes'. Deduped per user (ANLT-500), so it is intentionally decoupled from the KPI band, which counts enrollment rows. */
  enrolled: Scalars['Int']['output'];
  /** % of the period's students (same population as 'enrolled') who took the evaluation and approved it (Aprobado/Certificado); null = 'Eval. aprob.' vacía when no in-period student took it (BR-1). */
  eval_approved_rate?: Maybe<Scalars['Float']['output']>;
  /** True for Crehana-catalog courses; False for own courses. */
  is_crehana: Scalars['Boolean']['output'];
  /** Average course progress (0-100) over the period's students (same population as 'enrolled'), one row per user; 0.0 when the course has no students in the period. */
  progress_avg: Scalars['Float']['output'];
  /** Detail URL the drawer CTA redirects to; null when the org slug is missing (ANLT-290). */
  redirect_url?: Maybe<Scalars['String']['output']>;
  /** Enrollments started within the period. */
  started: Scalars['Int']['output'];
  /** SUM(progress_minutes)/60 for the users whose activity in the course falls in the period (last_action_date — a narrower gate than 'enrolled', which also admits started/completed/certified); 0.0 when no playback registered (BR-2). */
  study_hours: Scalars['Float']['output'];
};

/** A connection to a list of items. */
export type AnalyticsLearningCourseTableRowConnection = {
  __typename?: 'AnalyticsLearningCourseTableRowConnection';
  /** Contains the nodes in this connection */
  edges: Array<AnalyticsLearningCourseTableRowEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type AnalyticsLearningCourseTableRowEdge = {
  __typename?: 'AnalyticsLearningCourseTableRowEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AnalyticsLearningCourseTableRow;
};

/** A top user by course progress (course detail drawer). */
export type AnalyticsLearningCourseTopUser = {
  __typename?: 'AnalyticsLearningCourseTopUser';
  /** Real profile photo URL (report_users.profile_picture); null when the user has no photo → FE falls back to initials (ANLT-440). */
  avatar_url?: Maybe<Scalars['String']['output']>;
  /** The user's progress in the course, 0-100. */
  course_progress: Scalars['Float']['output'];
  /** Job title / cargo (centralized employee base); null when unset (ANLT-440). */
  position?: Maybe<Scalars['String']['output']>;
  /** User identifier. */
  user_id: Scalars['Int']['output'];
  /** User full name. */
  user_name: Scalars['String']['output'];
};

/** Input for the 'Por cursos' deep-dive table (ANLT-295). */
export type AnalyticsLearningCoursesDeepDiveInput = {
  /** Catalog-type filter: todos / propios / Crehana (AC-3). */
  catalog?: AnalyticsLearningCourseCatalogEnum;
  /** Centralized organization id. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Forward cursor pagination. */
  pagination?: InputMaybe<AnalyticsLearningPaginationInput>;
  /** Period window; defaults to the current month. Scopes iniciaron/completados. */
  period?: InputMaybe<AnalyticsLearningDashboardPeriodInput>;
  /** Search by course name (ANLT-394). */
  search?: InputMaybe<AnalyticsLearningSearchInput>;
  /** Filter rows by one segment's values (ANLT-393); combined with `segmentation` as AND. */
  segment_filter?: InputMaybe<AnalyticsLearningSegmentFilterInput>;
  /** User segmentation (same logic as the centralized reports): rules of attribute + operator + values combined with Todas/Alguna. */
  segmentation?: InputMaybe<AnalyticsSegmentInput>;
  /** Sort column + direction; defaults to enrolled desc. */
  sort?: InputMaybe<AnalyticsLearningSortInput>;
};

/** KPI band for the Learning 'Por cursos' deep-dive tab. */
export type AnalyticsLearningCoursesKpis = {
  __typename?: 'AnalyticsLearningCoursesKpis';
  /** Active Crehana-catalog courses. */
  active_courses_catalog: Scalars['Int']['output'];
  /** Active own (non-Crehana) courses. */
  active_courses_own: Scalars['Int']['output'];
  /** Active courses (current-state: at least one active enrollment). */
  active_courses_total: Scalars['Int']['output'];
  /** Courses completed within the period. */
  completed: Scalars['Int']['output'];
  /** completed / started × 100 (0.0 when none started). */
  completion_rate: Scalars['Float']['output'];
  /** Enrollments created within the period. */
  enrollments: Scalars['Int']['output'];
  /** Set when the response is degraded (ORG_NOT_FOUND, INVALID_PERIOD). */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Courses started within the period. */
  started: Scalars['Int']['output'];
};

/** Breakdown of the 'Por cursos' KPIs by a segmentation attribute's top values (ANLT-396). Ordered by enrollments desc, capped at 50. */
export type AnalyticsLearningCoursesKpisBySegment = {
  __typename?: 'AnalyticsLearningCoursesKpisBySegment';
  /** The attribute the metrics are grouped by. */
  attribute: Scalars['String']['output'];
  /** Structured error code for degraded responses. Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Per-segment metrics, enrollments desc. */
  segments: Array<AnalyticsLearningCoursesSegmentRow>;
  /** Total segment values before the 50-row cap. */
  total_segments: Scalars['Int']['output'];
};

/** Input for the 'Por cursos' KPI band (ANLT-293). */
export type AnalyticsLearningCoursesKpisInput = {
  /** Catalog-type filter: todos / propios / Crehana. */
  catalog?: AnalyticsLearningCourseCatalogEnum;
  /** Centralized organization id. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Period window; defaults to the current month. */
  period?: InputMaybe<AnalyticsLearningDashboardPeriodInput>;
  /** User segmentation (same logic as the centralized reports): rules of attribute + operator + values combined with Todas/Alguna. */
  segmentation?: InputMaybe<AnalyticsSegmentInput>;
};

/** Input for the 'Por cursos' KPI breakdown by segment (ANLT-396). */
export type AnalyticsLearningCoursesSegmentInput = {
  /** Employee-base attribute to group by (área, sede, etc.). Provide this OR custom_field_id. */
  attribute?: InputMaybe<AnalyticsLearningSegmentAttributeEnum>;
  /** Catalog-type filter: todos / propios / Crehana. */
  catalog?: AnalyticsLearningCourseCatalogEnum;
  /** Centralized organization id. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Custom-field id to group by. Provide this OR attribute. */
  custom_field_id?: InputMaybe<Scalars['Int']['input']>;
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Period window; defaults to the current month. Scopes enrollments/started/completed. */
  period?: InputMaybe<AnalyticsLearningDashboardPeriodInput>;
  /** User segmentation row filter (orthogonal to the group-by attribute): same logic as the centralized reports. */
  segmentation?: InputMaybe<AnalyticsSegmentInput>;
};

/** One segment's courses KPIs (medallero row, ANLT-396). */
export type AnalyticsLearningCoursesSegmentRow = {
  __typename?: 'AnalyticsLearningCoursesSegmentRow';
  /** Distinct active courses (≥1 active enrollment) among the segment's members (current-state, BR-1). */
  active_courses: Scalars['Int']['output'];
  /** Courses completed within the period in this segment. */
  completed: Scalars['Int']['output'];
  /** completed / started × 100 (0.0 when none started) — same math as the ANLT-293 band. */
  completion_rate: Scalars['Float']['output'];
  /** Enrollments created within the period in this segment. */
  enrollments: Scalars['Int']['output'];
  /** The attribute value (e.g. an área/sede name). */
  segment_value: Scalars['String']['output'];
  /** Courses started within the period in this segment. */
  started: Scalars['Int']['output'];
};

/** Base context for the Learning dashboard shell: resolved organization, Learning module gating, permitted scope and data freshness. Not-contracted is a valid response state, never an error. */
export type AnalyticsLearningDashboardContext = {
  __typename?: 'AnalyticsLearningDashboardContext';
  /** Structured error code for degraded responses (e.g. 'INVALID_INPUT' when neither id nor slug was provided). Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Data freshness for the chip. Null when not determinable. */
  freshness?: Maybe<AnalyticsLearningDashboardFreshness>;
  /** Whether the organization has the Learning module contracted. When false the FE does not offer the view. */
  is_learning_contracted: Scalars['Boolean']['output'];
  /** Resolved organization identity. Null when not found. */
  organization?: Maybe<AnalyticsLearningDashboardOrganization>;
  /** Permitted data scope derived from the session roles: ADMIN (whole org), MANAGER (their team), COLLABORATOR (self). */
  scope: AnalyticsLearningDashboardScopeEnum;
};

/** Input for the Learning dashboard context query. Provide exactly one of centralized_organization_id or organization_slug; id wins if both. */
export type AnalyticsLearningDashboardContextInput = {
  /** Centralized organization ID to resolve the context for. */
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Organization slug, accepted as alternative to the id. */
  organization_slug?: InputMaybe<Scalars['String']['input']>;
};

/** Data freshness mark for the Learning dashboard chip. */
export type AnalyticsLearningDashboardFreshness = {
  __typename?: 'AnalyticsLearningDashboardFreshness';
  /** Most recent ETL run across Learning sources, ISO 8601 UTC. */
  last_updated_at?: Maybe<Scalars['String']['output']>;
  /** Localized freshness label (e.g. '23 abr - 9:25am'). */
  last_updated_at_formatted?: Maybe<Scalars['String']['output']>;
};

/** Organization identity resolved across modules for the Learning dashboard. */
export type AnalyticsLearningDashboardOrganization = {
  __typename?: 'AnalyticsLearningDashboardOrganization';
  /** Organization ID in the centralized module. */
  central_org_id: Scalars['Int']['output'];
  /** Organization ID in the Talent module. */
  company_id?: Maybe<Scalars['Int']['output']>;
  /** Organization country code. */
  country_code?: Maybe<Scalars['String']['output']>;
  /** Organization display name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Organization ID in the Learning module. */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** Organization URL slug. */
  slug?: Maybe<Scalars['String']['output']>;
};

/** Relative period presets for period-dependent Learning dashboard metrics, always anchored to today (never a fixed calendar month). */
export enum AnalyticsLearningDashboardPeriodEnum {
  CurrentMonth = 'CURRENT_MONTH',
  CurrentQuarter = 'CURRENT_QUARTER',
  CurrentWeek = 'CURRENT_WEEK',
  CurrentYear = 'CURRENT_YEAR',
  Custom = 'CUSTOM'
}

/** Period window for period-dependent Learning dashboard metrics. Omit entirely for the default (current month). Presets are relative to today; CUSTOM requires from_date and to_date, both inclusive. If a preset and dates are both sent, the preset wins. */
export type AnalyticsLearningDashboardPeriodInput = {
  /** Custom range start (inclusive). Required for CUSTOM. */
  from_date?: InputMaybe<Scalars['Date']['input']>;
  /** Period preset. Defaults to CURRENT_MONTH when omitted; dates sent without a preset imply CUSTOM. */
  period?: InputMaybe<AnalyticsLearningDashboardPeriodEnum>;
  /** Custom range end (inclusive). Required for CUSTOM. */
  to_date?: InputMaybe<Scalars['Date']['input']>;
};

/** Permitted data scope for the Learning dashboard. */
export enum AnalyticsLearningDashboardScopeEnum {
  Admin = 'ADMIN',
  Collaborator = 'COLLABORATOR',
  Manager = 'MANAGER'
}

/** A filterable attribute (employee-base default or customer custom field) with its selectable values for the organization. */
export type AnalyticsLearningFilterAttribute = {
  __typename?: 'AnalyticsLearningFilterAttribute';
  /** True for customer custom fields, False for employee-base defaults. */
  is_custom: Scalars['Boolean']['output'];
  /** Filter key: a default enum value (area/headquarter/…) or 'custom_<field_id>'. Sent back verbatim in attribute_filters. */
  key: Scalars['String']['output'];
  /** Display label of the attribute. */
  name: Scalars['String']['output'];
  /** True when values are too many to list — FE should use typeahead instead of the (empty) values list. */
  needs_search: Scalars['Boolean']['output'];
  /** Selectable values (empty when needs_search is true). */
  values: Array<AnalyticsLearningFilterValue>;
};

/** Filter catalog for the Learning deep-dive tabs: attributes + values. */
export type AnalyticsLearningFilterOptions = {
  __typename?: 'AnalyticsLearningFilterOptions';
  /** Filterable attributes (defaults first, then custom fields). */
  attributes: Array<AnalyticsLearningFilterAttribute>;
  /** Structured error code for degraded responses. Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
};

/** Input for the deep-dive filter catalog query (ANLT-370). */
export type AnalyticsLearningFilterOptionsInput = {
  /** Centralized organization id. */
  centralized_organization_id: Scalars['Int']['input'];
};

/** One selectable value of a filter attribute. */
export type AnalyticsLearningFilterValue = {
  __typename?: 'AnalyticsLearningFilterValue';
  /** Human-readable label for the value. */
  label: Scalars['String']['output'];
  /** Value to send back in the filter. */
  value: Scalars['String']['output'];
};

/** Historical Learning series for the organization. Period-independent (ignores the global period filter). Arrays run oldest to newest; empty when there is no history (valid state, never an error). */
export type AnalyticsLearningHistoricalSeries = {
  __typename?: 'AnalyticsLearningHistoricalSeries';
  /** Structured error code for degraded responses. Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Pre-formatted data-freshness label in org-local time (e.g. '29 may - 4:25pm'). Null if freshness is unknown. Same format as the general dashboard widgets. */
  last_updated_at_formatted?: Maybe<Scalars['String']['output']>;
  /** Last 12 months, oldest first. */
  monthly: Array<AnalyticsLearningMonthlyPoint>;
  /** Last 8 quarters, oldest first. */
  quarterly: Array<AnalyticsLearningQuarterlyPoint>;
};

/** Input for the historical Learning series. No period field — these series are historical and ignore the global period filter. */
export type AnalyticsLearningHistoricalSeriesInput = {
  /** Centralized organization ID to scope the series. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** An active user with no platform access in the last 30 days. */
export type AnalyticsLearningInactiveUser = {
  __typename?: 'AnalyticsLearningInactiveUser';
  /** User area. */
  area?: Maybe<Scalars['String']['output']>;
  /** User email. */
  email: Scalars['String']['output'];
  /** User headquarter/site. */
  headquarter?: Maybe<Scalars['String']['output']>;
  /** Last platform access (ISO 8601). Null if never logged in. */
  last_activity?: Maybe<Scalars['String']['output']>;
  /** User full name. */
  name: Scalars['String']['output'];
  /** Admin-assigned courses not yet completed (BR-1). */
  pending_courses: Scalars['Int']['output'];
  /** User identifier. */
  user_id: Scalars['Int']['output'];
};

/** A single Learning key metric: current-period value plus the previous-period comparison. */
export type AnalyticsLearningKeyMetric = {
  __typename?: 'AnalyticsLearningKeyMetric';
  /** Denominator behind the value, for sublabels — e.g. active collaborators (the '1,247'), the divisor for 'hours per active', or, for completion_rate, the enrollments created in the period. Null when the value needs no denominator. */
  denominator?: Maybe<Scalars['Float']['output']>;
  /** Raw count behind the value, for sublabels — e.g. engaged collaborators (the '738' in '738 of 1,247'), CSAT responses (the rater count), or, for completion_rate, the enrollments of the period that were completed. Always the number that divides into `value` — never a count from a different population. Null when the value needs no numerator. */
  numerator?: Maybe<Scalars['Float']['output']>;
  /** Value for the immediately preceding window of identical length. Null for fixed-threshold indicators (inactive users). */
  previous_value?: Maybe<Scalars['Float']['output']>;
  /** Daily series over the selected period for the card's trend chart (one point per day, 0-filled). Populated for enrollments, completed_hours and certificates_issued; empty for the rest. */
  sparkline: Array<SparklinePoint>;
  /** Current-period value (count, hours, %, or 1-5 average). */
  value: Scalars['Float']['output'];
  /** Percent change vs the previous period: (value - previous) / previous * 100. Null when there is no previous baseline. */
  variation_percentage?: Maybe<Scalars['Float']['output']>;
};

/** The 7 Learning key indicators for the organization and period, each with its variation vs the previous period. All reads are org-scoped. */
export type AnalyticsLearningKeyMetrics = {
  __typename?: 'AnalyticsLearningKeyMetrics';
  /** Average course rating 1-5 from users who rated in the period (non-raters excluded; same source as the dashboard pulse). */
  average_satisfaction: AnalyticsLearningKeyMetric;
  /** Evaluation certificates issued in the period. */
  certificates_issued: AnalyticsLearningKeyMetric;
  /** Courses completed in the period (completed_date). */
  completed_courses: AnalyticsLearningKeyMetric;
  /** Reproduction hours in the period: SUM(report_courses.progress_hours) (progress x course duration — the report's 'Horas de Reproducción'), over the report cohort, attributed by last_action_date (i.e. hours of collaborators active in the period). */
  completed_hours: AnalyticsLearningKeyMetric;
  /** Share of the PERIOD's enrollment cohort that was completed (ANLT-810): of the enrollments created in the window, the percentage with a completed_date. Value 0-100, bounded by construction (0 when nothing was enrolled in the window). */
  completion_rate: AnalyticsLearningKeyMetric;
  /** % of active collaborators with course activity in the period (course-activity approximation, value 0-100). */
  engaged_collaborators: AnalyticsLearningKeyMetric;
  /** Course enrollments in the period (enroll_date). */
  enrollments: AnalyticsLearningKeyMetric;
  /** Structured error code for degraded responses ('INVALID_PERIOD' on inconsistent period input). Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Active collaborators with no platform access in the last 30 days (fixed threshold, independent of the selected period). */
  inactive_users: AnalyticsLearningKeyMetric;
  /** Pre-formatted data-freshness label in org-local time (e.g. '29 may - 4:25pm'), dashboard-level. Same value/format as get_learning_dashboard_context and the general dashboard widgets. Null if freshness is unknown. */
  last_updated_at_formatted?: Maybe<Scalars['String']['output']>;
  /** Resolved period end (ISO date, inclusive). */
  period_end?: Maybe<Scalars['String']['output']>;
  /** Resolved period start (ISO date). */
  period_start?: Maybe<Scalars['String']['output']>;
};

/** Input for the Learning dashboard key metrics (7 KPIs). The period defaults to the current month when omitted. */
export type AnalyticsLearningKeyMetricsInput = {
  /** Centralized organization ID to scope the metrics. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Period window for the period-dependent indicators. */
  period?: InputMaybe<AnalyticsLearningDashboardPeriodInput>;
};

/** Learning metrics grouped by the values of one segmentation attribute, for the organization and period. Empty segments list when the attribute has no values (valid state, never an error). */
export type AnalyticsLearningMetricsByAttribute = {
  __typename?: 'AnalyticsLearningMetricsByAttribute';
  /** INVALID_ATTRIBUTE (neither/unknown attribute), INVALID_PERIOD, or null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Resolved period end (ISO date, inclusive). */
  period_end?: Maybe<Scalars['String']['output']>;
  /** Resolved period start (ISO date). */
  period_start?: Maybe<Scalars['String']['output']>;
  /** One row per attribute value, ordered by engaged collaborators descending, capped at 50. */
  segments: Array<AnalyticsLearningSegmentMetrics>;
  /** Total distinct values before the 50-row cap. */
  total_segments: Scalars['Int']['output'];
};

/** Input for metrics grouped by a segmentation attribute. Provide exactly one of attribute (default) or custom_field_id (company custom attribute); custom_field_id wins if both are sent. */
export type AnalyticsLearningMetricsByAttributeInput = {
  /** Default attribute to group by. */
  attribute?: InputMaybe<AnalyticsLearningSegmentAttributeEnum>;
  /** Centralized organization ID to scope the grouping. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Company custom field ID to group by. */
  custom_field_id?: InputMaybe<Scalars['Int']['input']>;
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Period window for the grouped metrics. */
  period?: InputMaybe<AnalyticsLearningDashboardPeriodInput>;
};

/** One month of the Learning key-indicator trend. */
export type AnalyticsLearningMonthlyPoint = {
  __typename?: 'AnalyticsLearningMonthlyPoint';
  /** Certificates issued in the month. */
  certificates: Scalars['Int']['output'];
  /** Completions in the month. */
  completed: Scalars['Int']['output'];
  /** Share of the MONTH's enrollment cohort that was completed (ANLT-810), same definition as the quarterly rate. Bounded 0-100 by construction. */
  completion_rate: Scalars['Float']['output'];
  /** Enrollments in the month. */
  enrollments: Scalars['Int']['output'];
  /** Study hours (progress x duration) in the month. */
  hours: Scalars['Float']['output'];
  /** Month label, e.g. '2026-06'. */
  period: Scalars['String']['output'];
  /** Enrollments started in the month. */
  started: Scalars['Int']['output'];
  /** Distinct users enrolled in the month. */
  unique_users: Scalars['Int']['output'];
};

/** Forward cursor pagination for deep-dive tables. */
export type AnalyticsLearningPaginationInput = {
  /** Opaque cursor; return the rows that come after it. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Number of rows to return (clamped to the per-view maximum). */
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** One quarter of the Learning historical series: enrollments and completions split by origin (own vs catalog) plus the consolidated quarterly detail. */
export type AnalyticsLearningQuarterlyPoint = {
  __typename?: 'AnalyticsLearningQuarterlyPoint';
  /** Average course progress (0-100) for the quarter. */
  avg_progress: Scalars['Float']['output'];
  /** Certificates issued in the quarter. */
  certificates: Scalars['Int']['output'];
  /** Total completions in the quarter. */
  completed: Scalars['Int']['output'];
  /** Completions of Crehana catalog courses. */
  completed_catalog: Scalars['Int']['output'];
  /** Completions of company-own courses. */
  completed_own: Scalars['Int']['output'];
  /** Share of the QUARTER's enrollment cohort that was completed (ANLT-810): of the enrollments created in the quarter, the percentage that has a completed_date, whatever date it carries. The numerator is a subset of the denominator, so 0-100 is guaranteed by construction — no cap is applied. */
  completion_rate: Scalars['Float']['output'];
  /** Total enrollments in the quarter. */
  enrollments: Scalars['Int']['output'];
  /** Enrollments of Crehana catalog courses (is_crehana true). */
  enrollments_catalog: Scalars['Int']['output'];
  /** Enrollments of company-own courses (is_crehana false). */
  enrollments_own: Scalars['Int']['output'];
  /** Quarter label, e.g. '2026-Q1'. */
  period: Scalars['String']['output'];
  /** Distinct users enrolled in the quarter. */
  unique_users: Scalars['Int']['output'];
};

/** Learning rankings for the organization: top learners and top courses (period-dependent) plus inactive users (fixed 30-day threshold). */
export type AnalyticsLearningRankings = {
  __typename?: 'AnalyticsLearningRankings';
  /** Structured error code for degraded responses. Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Active users who logged in but not in >30 days, least-inactive (rescuable) first, capped at 25. */
  inactive_users: Array<AnalyticsLearningInactiveUser>;
  /** Resolved period end (ISO date, inclusive). */
  period_end?: Maybe<Scalars['String']['output']>;
  /** Resolved period start (ISO date). */
  period_start?: Maybe<Scalars['String']['output']>;
  /** Top 15 courses by certificates in the period. */
  top_courses: Array<AnalyticsLearningTopCourse>;
  /** Top 15 learners by completions in the period. */
  top_learners: Array<AnalyticsLearningTopLearner>;
  /** Total inactive users before the 25-row cap. */
  total_inactive: Scalars['Int']['output'];
};

/** Input for the Learning rankings. Top learners and top courses respect the period; inactive users use a fixed 30-day threshold. */
export type AnalyticsLearningRankingsInput = {
  /** Centralized organization ID to scope the rankings. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Period for top learners and top courses. */
  period?: InputMaybe<AnalyticsLearningDashboardPeriodInput>;
};

/** Per-course completion inside a route (detail drawer). */
export type AnalyticsLearningRouteCourseRow = {
  __typename?: 'AnalyticsLearningRouteCourseRow';
  /** Users who completed this course. */
  completed: Scalars['Int']['output'];
  /** completed / enrolled x 100 (0.0 when none enrolled). */
  completion_rate: Scalars['Float']['output'];
  /** Course identifier. */
  course_id: Scalars['Int']['output'];
  /** Course name. */
  course_name: Scalars['String']['output'];
  /** Users enrolled in this course within the route. */
  enrolled: Scalars['Int']['output'];
};

/** Course-review satisfaction for one route (track) launched in the last 90 days. csat_score is a 1-5 average of the route's courses' ratings. */
export type AnalyticsLearningRouteCsat = {
  __typename?: 'AnalyticsLearningRouteCsat';
  /** Average course-review score 1-5 (average of the route's courses' ratings). */
  csat_score: Scalars['Float']['output'];
  /** Total course-review ratings across the route's courses. */
  responses: Scalars['Int']['output'];
  /** Route identifier. */
  route_id: Scalars['Int']['output'];
  /** Route name. */
  route_name: Scalars['String']['output'];
  /** Distinct users who rated. */
  unique_users: Scalars['Int']['output'];
};

/** Detail of a single learning route: per-course completion + top users. */
export type AnalyticsLearningRouteDetail = {
  __typename?: 'AnalyticsLearningRouteDetail';
  /** Per-course completion within the route. */
  courses: Array<AnalyticsLearningRouteCourseRow>;
  /** Courses required to complete the route. */
  courses_required: Scalars['Int']['output'];
  /** Total active courses in the route (the drawer's course list length — 'de N cursos'). */
  courses_total: Scalars['Int']['output'];
  /** Distinct users enrolled in the route (count(distinct user_id) over report_routes_users, same source/definition as the table) — denominator for the drawer's evaluations/projects 'n/total' (ANLT-397). */
  enrolled: Scalars['Int']['output'];
  /** Structured error code for degraded responses. Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Version-aware detail URL the drawer CTA redirects to (v1 → estadísticas/grupales, v2 → content/paths); null when the org slug is missing (ANLT-290). */
  redirect_url?: Maybe<Scalars['String']['output']>;
  /** Route identifier. */
  route_id: Scalars['Int']['output'];
  /** Route name. */
  route_name: Scalars['String']['output'];
  /** Top users by route progress. */
  top_users: Array<AnalyticsLearningRouteTopUser>;
};

/** Input for the detail drawer of one learning route (ANLT-291). */
export type AnalyticsLearningRouteDetailInput = {
  /** Centralized organization id. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Headquarter (sede) IDs to scope the drawer. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Route to expand. */
  route_id: Scalars['Int']['input'];
};

/** One learning route with its all-time progress metrics. */
export type AnalyticsLearningRouteRow = {
  __typename?: 'AnalyticsLearningRouteRow';
  /** Users who completed the route / enrolled x 100, 0-100. */
  completion_rate: Scalars['Float']['output'];
  /** Users who completed at least one course in the route. */
  courses_completed: Scalars['Int']['output'];
  /** Courses required to complete the route. */
  courses_required: Scalars['Int']['output'];
  /** Users registered in the route. */
  enrolled: Scalars['Int']['output'];
  /** Users who completed the whole route. */
  route_completed: Scalars['Int']['output'];
  /** Route identifier. */
  route_id: Scalars['Int']['output'];
  /** Route name. */
  route_name: Scalars['String']['output'];
};

/** One row of the 'Por rutas' deep-dive table (ANLT-291): per-route enrollment, progress, evaluation/project approvals, CSAT and status. */
export type AnalyticsLearningRouteTableRow = {
  __typename?: 'AnalyticsLearningRouteTableRow';
  /** Certificates required to complete the route. */
  certificates_required: Scalars['Int']['output'];
  /** route_completed / enrolled x 100 (0.0 when none enrolled). */
  completion_rate: Scalars['Float']['output'];
  /** Courses required to complete the route. */
  courses_required: Scalars['Int']['output'];
  /** Answer-weighted avg course rating over the route's courses; null = 'Sin datos' (BR-2). */
  csat?: Maybe<Scalars['Float']['output']>;
  /** Users registered in the route. */
  enrolled: Scalars['Int']['output'];
  /** Users with at least one approved evaluation (X of `enrolled`). */
  evaluations_approved: Scalars['Int']['output'];
  /** Route members who certified ≥1 final project among THIS route's courses (distinct users with `report_routes_users.project_certified` > 0, where project_certified counts the route's courses whose final project the user certified — dbt current_action=4). X of `enrolled`; route-scoped, so a project certified in a course that is not part of this route is not included (ANLT-499). */
  projects_approved: Scalars['Int']['output'];
  /** Version-aware detail URL the drawer CTA redirects to (v1 → estadísticas/grupales, v2 → content/paths); null when the org slug is missing (ANLT-290). */
  redirect_url?: Maybe<Scalars['String']['output']>;
  /** Users who completed the whole route. */
  route_completed: Scalars['Int']['output'];
  /** Route identifier. */
  route_id: Scalars['Int']['output'];
  /** Route name. */
  route_name: Scalars['String']['output'];
  /** 'Sin inscritos' when enrolled = 0, else 'Activa' (BR-1). */
  status: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type AnalyticsLearningRouteTableRowConnection = {
  __typename?: 'AnalyticsLearningRouteTableRowConnection';
  /** Contains the nodes in this connection */
  edges: Array<AnalyticsLearningRouteTableRowEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type AnalyticsLearningRouteTableRowEdge = {
  __typename?: 'AnalyticsLearningRouteTableRowEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AnalyticsLearningRouteTableRow;
};

/** A top user by route progress (detail drawer). */
export type AnalyticsLearningRouteTopUser = {
  __typename?: 'AnalyticsLearningRouteTopUser';
  /** Real profile photo URL (report_users.profile_picture); null when the user has no photo → FE falls back to initials (ANLT-440). */
  avatar_url?: Maybe<Scalars['String']['output']>;
  /** Job title / cargo (centralized employee base); null when unset (ANLT-440). */
  position?: Maybe<Scalars['String']['output']>;
  /** The user's progress in the route, 0-100. */
  route_progress: Scalars['Float']['output'];
  /** User identifier. */
  user_id: Scalars['Int']['output'];
  /** User full name. */
  user_name: Scalars['String']['output'];
};

/** Input for the 'Por rutas' deep-dive table (ANLT-291). */
export type AnalyticsLearningRoutesDeepDiveInput = {
  /** Centralized organization id. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Forward cursor pagination. */
  pagination?: InputMaybe<AnalyticsLearningPaginationInput>;
  /** Period window (reserved; the route list is current-state). */
  period?: InputMaybe<AnalyticsLearningDashboardPeriodInput>;
  /** Search by route name (ANLT-391). */
  search?: InputMaybe<AnalyticsLearningSearchInput>;
  /** Filter rows by one segment's values (ANLT-393); combined with `segmentation` as AND. */
  segment_filter?: InputMaybe<AnalyticsLearningSegmentFilterInput>;
  /** User segmentation (same logic as the centralized reports): rules of attribute + operator + values combined with Todas/Alguna. */
  segmentation?: InputMaybe<AnalyticsSegmentInput>;
  /** Sort column + direction; defaults to enrolled desc. */
  sort?: InputMaybe<AnalyticsLearningSortInput>;
};

/** KPI band for the Learning 'Por rutas' deep-dive tab (ANLT-289). */
export type AnalyticsLearningRoutesKpis = {
  __typename?: 'AnalyticsLearningRoutesKpis';
  /** Average route_progress over participants (Piero: route_progress = completitud total), 0-100. Excludes non-participants (BR-2). */
  completitud_total: Scalars['Float']['output'];
  /** SUM(courses_completed) / SUM(courses_assigned) × 100. */
  courses_completed_rate: Scalars['Float']['output'];
  /** Set when the response is degraded (ORG_NOT_FOUND, INVALID_PERIOD). */
  error_code?: Maybe<Scalars['String']['output']>;
  /** % of memberships with ≥1 approved evaluation. */
  evaluations_approved_rate: Scalars['Float']['output'];
  /** % of memberships with ≥1 certified project. */
  projects_approved_rate: Scalars['Float']['output'];
  /** % of route memberships completed (is_completed). */
  routes_completed_rate: Scalars['Float']['output'];
};

/** Breakdown of the 'Por rutas' KPIs by a segmentation attribute's top values (ANLT-395). Ordered by memberships desc, capped at 50. */
export type AnalyticsLearningRoutesKpisBySegment = {
  __typename?: 'AnalyticsLearningRoutesKpisBySegment';
  /** The attribute the metrics are grouped by. */
  attribute: Scalars['String']['output'];
  /** Structured error code for degraded responses. Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Per-segment metrics, memberships desc. */
  segments: Array<AnalyticsLearningRoutesSegmentRow>;
  /** Total segment values before the 50-row cap. */
  total_segments: Scalars['Int']['output'];
};

/** Input for the 'Por rutas' KPI band (ANLT-289). */
export type AnalyticsLearningRoutesKpisInput = {
  /** Centralized organization id. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Period window (reserved; the routes band is current-state, like the ANLT-291 routes table). */
  period?: InputMaybe<AnalyticsLearningDashboardPeriodInput>;
  /** User segmentation (same logic as the centralized reports): rules of attribute + operator + values combined with Todas/Alguna. */
  segmentation?: InputMaybe<AnalyticsSegmentInput>;
};

/** Input for the 'Por rutas' KPI breakdown by segment (ANLT-395). */
export type AnalyticsLearningRoutesSegmentInput = {
  /** Employee-base attribute to group by (área, sede, etc.). Provide this OR custom_field_id. */
  attribute?: InputMaybe<AnalyticsLearningSegmentAttributeEnum>;
  /** Centralized organization id. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Custom-field id to group by. Provide this OR attribute. */
  custom_field_id?: InputMaybe<Scalars['Int']['input']>;
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Period window (reserved; the routes breakdown is current-state, like the ANLT-289 band). */
  period?: InputMaybe<AnalyticsLearningDashboardPeriodInput>;
  /** User segmentation row filter (orthogonal to the group-by attribute): same logic as the centralized reports. */
  segmentation?: InputMaybe<AnalyticsSegmentInput>;
};

/** One segment's routes KPIs (medallero row, ANLT-395). */
export type AnalyticsLearningRoutesSegmentRow = {
  __typename?: 'AnalyticsLearningRoutesSegmentRow';
  /** Average route_progress over the segment's participants, 0-100 (same definition as the ANLT-289 band). */
  completitud_total: Scalars['Float']['output'];
  /** SUM(courses_completed) / SUM(courses_assigned) × 100 in the segment. */
  courses_completed_rate: Scalars['Float']['output'];
  /** % of memberships with ≥1 approved evaluation. */
  evaluations_approved_rate: Scalars['Float']['output'];
  /** % of memberships with ≥1 certified project. */
  projects_approved_rate: Scalars['Float']['output'];
  /** % of the segment's route memberships completed. */
  routes_completed_rate: Scalars['Float']['output'];
  /** The attribute value (e.g. an área/sede name). */
  segment_value: Scalars['String']['output'];
  /** Active segment members with ≥1 route membership. */
  users: Scalars['Int']['output'];
};

/** Learning routes table for the organization (all-time). Ordered by enrolled descending. Empty list when the org has no visible routes. */
export type AnalyticsLearningRoutesTable = {
  __typename?: 'AnalyticsLearningRoutesTable';
  /** Structured error code for degraded responses. Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Routes ordered by enrolled descending, capped at 200. */
  routes: Array<AnalyticsLearningRouteRow>;
  /** Total visible routes before the 200-row cap. */
  total_routes: Scalars['Int']['output'];
};

/** Input for the Learning routes table. All-time for v1 (no period); Tipo/Origen filters are deferred until the route-level source is confirmed. */
export type AnalyticsLearningRoutesTableInput = {
  /** Centralized organization ID to scope the routes. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Free-text search for a deep-dive table. */
export type AnalyticsLearningSearchInput = {
  /** Search text; matched against the view's search columns (user name/email on 'Por usuarios', route name on 'Por rutas', course name on 'Por cursos'). */
  query: Scalars['String']['input'];
};

/** Default segmentation attributes from the collaborator base (centralized users organization). */
export enum AnalyticsLearningSegmentAttributeEnum {
  Area = 'AREA',
  Country = 'COUNTRY',
  Department = 'DEPARTMENT',
  Gender = 'GENDER',
  Headquarter = 'HEADQUARTER',
  Position = 'POSITION'
}

/** Filter a deep-dive table by one attribute's values (ANLT-393). Same vocabulary as the 'by segment' breakdown (medallero): pass the clicked row's display values verbatim — the backend expands them to the matching users. */
export type AnalyticsLearningSegmentFilterInput = {
  /** Employee-base attribute (área, sede, etc.). Provide this OR custom_field_id. */
  attribute?: InputMaybe<AnalyticsLearningSegmentAttributeEnum>;
  /** Custom-field id to filter by. Provide this OR attribute (custom_field_id wins when both arrive, like the breakdown). */
  custom_field_id?: InputMaybe<Scalars['Int']['input']>;
  /** Display values to match (exactly as returned by the breakdown rows). Empty list = no filtering. */
  values: Array<Scalars['String']['input']>;
};

/** Learning metrics for one value of the chosen attribute. */
export type AnalyticsLearningSegmentMetrics = {
  __typename?: 'AnalyticsLearningSegmentMetrics';
  /** Evaluation certificates issued in the period. */
  certificates_issued: Scalars['Float']['output'];
  /** Courses completed in the period. */
  completed_courses: Scalars['Float']['output'];
  /** Study hours (progress x duration) in the period. */
  completed_hours: Scalars['Float']['output'];
  /** Completed in the period / started in the period x 100. Independent windowed counts: can exceed 100 when courses started earlier complete inside the window. */
  completion_rate: Scalars['Float']['output'];
  /** Distinct collaborators with course activity in the period. */
  engaged_collaborators: Scalars['Float']['output'];
  /** Attribute value (e.g. 'Marketing' for Área). */
  value: Scalars['String']['output'];
};

/** A segmentation attribute available for the organization. */
export type AnalyticsLearningSegmentationAttribute = {
  __typename?: 'AnalyticsLearningSegmentationAttribute';
  /** True when the attribute was configured by the company. */
  is_custom: Scalars['Boolean']['output'];
  /** Stable key to send back in get_learning_metrics_by_attribute: the enum value for defaults, 'custom_<field_id>' for custom. */
  key: Scalars['String']['output'];
  /** Display label (Spanish for defaults, org-defined for custom). */
  name: Scalars['String']['output'];
};

/** Catalog of attributes the organization can segment metrics by, split into defaults (collaborator base) and company custom fields. */
export type AnalyticsLearningSegmentationAttributes = {
  __typename?: 'AnalyticsLearningSegmentationAttributes';
  /** Custom attributes configured by the company. */
  custom_attributes: Array<AnalyticsLearningSegmentationAttribute>;
  /** Default attributes from the collaborator base. */
  default_attributes: Array<AnalyticsLearningSegmentationAttribute>;
  /** Structured error code for degraded responses. Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
};

/** Input for the Learning segmentation attributes catalog. */
export type AnalyticsLearningSegmentationAttributesInput = {
  /** Centralized organization ID to list attributes for. */
  centralized_organization_id: Scalars['Int']['input'];
};

/** Sort direction for deep-dive tables. */
export enum AnalyticsLearningSortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Sort a deep-dive table by one metric column. */
export type AnalyticsLearningSortInput = {
  /** Ascending or descending order. */
  direction?: AnalyticsLearningSortDirectionEnum;
  /** Sortable column key, validated against the view's whitelist. */
  field: Scalars['String']['input'];
};

/** A top course ranked by certificates in the period. */
export type AnalyticsLearningTopCourse = {
  __typename?: 'AnalyticsLearningTopCourse';
  /** Certificates issued for this course in the period. */
  certificates: Scalars['Int']['output'];
  /** Course identifier. */
  course_id: Scalars['Int']['output'];
  /** Course name. */
  course_name: Scalars['String']['output'];
  /** Origin: true = Crehana catalog, false = company-own course. */
  is_crehana: Scalars['Boolean']['output'];
  /** Distinct users certified in the period. */
  users: Scalars['Int']['output'];
};

/** A top learner ranked by completions in the period. */
export type AnalyticsLearningTopLearner = {
  __typename?: 'AnalyticsLearningTopLearner';
  /** Certificates earned in the period. */
  certificates: Scalars['Int']['output'];
  /** Courses completed in the period. */
  completed: Scalars['Int']['output'];
  /** User email. */
  email: Scalars['String']['output'];
  /** Enrollments in the period. */
  enrollments: Scalars['Int']['output'];
  /** Study hours in the period. */
  hours: Scalars['Float']['output'];
  /** User full name. */
  name: Scalars['String']['output'];
  /** User identifier. */
  user_id: Scalars['Int']['output'];
};

/** Detail drawer for one user (ANLT-299): routes in progress (with %) + recent course activity. */
export type AnalyticsLearningUserDetail = {
  __typename?: 'AnalyticsLearningUserDetail';
  /** Structured error code for degraded responses. Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Most recent course activity, newest first. */
  recent_activity: Array<AnalyticsLearningUserRecentActivity>;
  /** Profile URL the drawer CTA redirects to; null when the org slug is missing (ANLT-290). */
  redirect_url?: Maybe<Scalars['String']['output']>;
  /** Routes the user has not completed yet, with progress. */
  routes_in_progress: Array<AnalyticsLearningUserRouteProgress>;
  /** User identifier. */
  user_id: Scalars['Int']['output'];
};

/** Input for the detail drawer of one user (ANLT-299). */
export type AnalyticsLearningUserDetailInput = {
  /** Centralized organization id. */
  centralized_organization_id: Scalars['Int']['input'];
  /** User to expand. */
  user_id: Scalars['Int']['input'];
};

/** A recent course activity for a user (detail drawer). */
export type AnalyticsLearningUserRecentActivity = {
  __typename?: 'AnalyticsLearningUserRecentActivity';
  /** Course identifier. */
  course_id: Scalars['Int']['output'];
  /** Course name. */
  course_name: Scalars['String']['output'];
  /** The user's progress in the course, 0-100. */
  course_progress: Scalars['Float']['output'];
  /** Date of the user's last action in the course (ISO). */
  last_action_date?: Maybe<Scalars['String']['output']>;
};

/** A route in progress for a user (detail drawer). */
export type AnalyticsLearningUserRouteProgress = {
  __typename?: 'AnalyticsLearningUserRouteProgress';
  /** Active courses assigned to the user in this route — the denominator for the 'N de M cursos' fraction (same columns as the Tracks report). May differ from route_progress, which is based on the route's courses/certificates *required* configuration. */
  courses_assigned: Scalars['Int']['output'];
  /** Courses the user has completed in this route. */
  courses_completed: Scalars['Int']['output'];
  /** Route identifier. */
  route_id: Scalars['Int']['output'];
  /** Route name. */
  route_name: Scalars['String']['output'];
  /** The user's progress in the route, 0-100. */
  route_progress: Scalars['Float']['output'];
};

/** One row of the 'Por usuarios' deep-dive table (ANLT-299): per-user área, course counts, progress, routes, certificates, hours and last activity. Active users only. */
export type AnalyticsLearningUserTableRow = {
  __typename?: 'AnalyticsLearningUserTableRow';
  /** User área (from centralized employee base). */
  area: Scalars['String']['output'];
  /** Real profile photo URL (report_users.profile_picture); null when the user has no photo → FE falls back to initials (ANLT-440). */
  avatar_url?: Maybe<Scalars['String']['output']>;
  /** Courses with an evaluation certificate. */
  certificates: Scalars['Int']['output'];
  /** Courses assigned by an admin (is_admin_assigned, BR-1). */
  courses_assigned: Scalars['Int']['output'];
  /** Courses the user completed. */
  courses_completed: Scalars['Int']['output'];
  /** All active course enrollments of the user. */
  courses_total: Scalars['Int']['output'];
  /** Last activity date (report_users.last_activity, the reports' 'Último login'); null when the user never logged in. */
  last_activity?: Maybe<Scalars['String']['output']>;
  /** Job title / cargo (centralized employee base); powers the user-detail drawer header '{position} · {área}' (ANLT-440). */
  position?: Maybe<Scalars['String']['output']>;
  /** Average course progress across the user's enrollments, 0-100. */
  progress_avg: Scalars['Float']['output'];
  /** Profile URL the drawer CTA redirects to; null when the org slug is missing (ANLT-290). */
  redirect_url?: Maybe<Scalars['String']['output']>;
  /** Distinct routes the user has COMPLETED (RRU.is_completed) — the drawer's 'Rutas completadas' stat (ANLT-441 H2). Was previously showing routes_total (belongs-to) by mistake. */
  routes_completed: Scalars['Int']['output'];
  /** Distinct learning routes the user belongs to. */
  routes_total: Scalars['Int']['output'];
  /** SUM(progress_minutes)/60 across the user's enrollments. */
  study_hours: Scalars['Float']['output'];
  /** User email. */
  user_email: Scalars['String']['output'];
  /** User identifier. */
  user_id: Scalars['Int']['output'];
  /** User full name. */
  user_name: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type AnalyticsLearningUserTableRowConnection = {
  __typename?: 'AnalyticsLearningUserTableRowConnection';
  /** Contains the nodes in this connection */
  edges: Array<AnalyticsLearningUserTableRowEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type AnalyticsLearningUserTableRowEdge = {
  __typename?: 'AnalyticsLearningUserTableRowEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AnalyticsLearningUserTableRow;
};

/** Input for the 'Por usuarios' deep-dive table (ANLT-299). */
export type AnalyticsLearningUsersDeepDiveInput = {
  /** Centralized organization id. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Forward cursor pagination. */
  pagination?: InputMaybe<AnalyticsLearningPaginationInput>;
  /** Period window (reserved; the user list is current-state). */
  period?: InputMaybe<AnalyticsLearningDashboardPeriodInput>;
  /** Search by name/email (AC-4). */
  search?: InputMaybe<AnalyticsLearningSearchInput>;
  /** Filter rows by one segment's values (ANLT-393); combined with `segmentation` as AND. */
  segment_filter?: InputMaybe<AnalyticsLearningSegmentFilterInput>;
  /** User segmentation (same logic as the centralized reports): rules of attribute + operator + values combined with Todas/Alguna. */
  segmentation?: InputMaybe<AnalyticsSegmentInput>;
  /** Sort column + direction; defaults to last_activity desc. */
  sort?: InputMaybe<AnalyticsLearningSortInput>;
};

/** KPI band for the Learning 'Por usuarios' deep-dive tab (ANLT-297). */
export type AnalyticsLearningUsersKpis = {
  __typename?: 'AnalyticsLearningUsersKpis';
  /** Active collaborators in the organization. */
  active_users: Scalars['Int']['output'];
  /** Study hours in the period / participants (users active in the period). Excludes non-participants (AC-3). */
  avg_hours_per_user: Scalars['Float']['output'];
  /** Set when the response is degraded (ORG_NOT_FOUND, INVALID_PERIOD). */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Users with at least one course started in the period (BR-1). */
  studying_users: Scalars['Int']['output'];
  /** Users who earned at least one certificate in the period. */
  users_with_certificate: Scalars['Int']['output'];
};

/** Breakdown of the 'Por usuarios' KPIs by a segmentation attribute's top values (ANLT-297). Ordered by active_users desc, capped at 50. */
export type AnalyticsLearningUsersKpisBySegment = {
  __typename?: 'AnalyticsLearningUsersKpisBySegment';
  /** The attribute the metrics are grouped by. */
  attribute: Scalars['String']['output'];
  /** Structured error code for degraded responses. Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Per-segment metrics, active_users desc. */
  segments: Array<AnalyticsLearningUsersSegmentRow>;
  /** Total segment values before the 50-row cap. */
  total_segments: Scalars['Int']['output'];
};

/** Input for the 'Por usuarios' KPI band (ANLT-297). */
export type AnalyticsLearningUsersKpisInput = {
  /** Centralized organization id. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Period window; defaults to the current month. Scopes studying / hours / certificates. */
  period?: InputMaybe<AnalyticsLearningDashboardPeriodInput>;
  /** User segmentation (same logic as the centralized reports): rules of attribute + operator + values combined with Todas/Alguna. */
  segmentation?: InputMaybe<AnalyticsSegmentInput>;
};

/** Input for the 'Por usuarios' KPI breakdown by segment (ANLT-297). */
export type AnalyticsLearningUsersSegmentInput = {
  /** Employee-base attribute to group by (área, sede, etc.). Provide this OR custom_field_id. */
  attribute?: InputMaybe<AnalyticsLearningSegmentAttributeEnum>;
  /** Centralized organization id. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Custom-field id to group by. Provide this OR attribute. */
  custom_field_id?: InputMaybe<Scalars['Int']['input']>;
  /** Headquarter (sede) IDs to scope the metrics. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter; if omitted, all managed headquarters apply. Users that manage no headquarters ignore this filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Period window; defaults to the current month. */
  period?: InputMaybe<AnalyticsLearningDashboardPeriodInput>;
  /** User segmentation row filter (orthogonal to the group-by attribute): same logic as the centralized reports. */
  segmentation?: InputMaybe<AnalyticsSegmentInput>;
};

/** One segment value's 'Por usuarios' metrics breakdown (ANLT-297). */
export type AnalyticsLearningUsersSegmentRow = {
  __typename?: 'AnalyticsLearningUsersSegmentRow';
  /** Active users in this segment. */
  active_users: Scalars['Int']['output'];
  /** Study hours / participants in this segment (excludes non-participants). */
  avg_hours_per_user: Scalars['Float']['output'];
  /** The attribute value (e.g. an área/sede name). */
  segment_value: Scalars['String']['output'];
  /** Users studying (course started in the period) in this segment. */
  studying_users: Scalars['Int']['output'];
  /** Users with ≥1 certificate in the period in this segment. */
  users_with_certificate: Scalars['Int']['output'];
};

export type AnalyticsListCustomReportCourseIdsInput = {
  /** Centralized organization scope (required for multi-tenant isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Filter by course type: OWN (propios), CREHANA (catálogo), or ALL/omit (todos). */
  course_type?: InputMaybe<CustomReportCourseTypeInput>;
  /** Optional free-text search over the course name. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsListCustomReportCoursesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  /** Centralized organization scope (required for multi-tenant isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** ANLT-827: restrict the result to these course ids (e.g. to preload the edit view of a saved report). Ids that do not belong to the organization are dropped, never echoed back. Combines with course_type/search. */
  course_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by course type: OWN (propios), CREHANA (catálogo), or ALL/omit (todos). */
  course_type?: InputMaybe<CustomReportCourseTypeInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Optional free-text search over the course name. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsListCustomReportRunsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  /** Centralized organization scope (required for multi-tenant isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID of the custom report whose scheduled runs to retrieve. */
  custom_report_id: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Free-text search over recipient names/emails. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsListCustomReportsByReportTypeInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  /** Centralized organization scope. */
  centralized_organization_id: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by report_type from the base template (e.g. REPORT_B2B_GENERAL). */
  report_type: ReportsEnum;
};

export type AnalyticsListCustomReportsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  /** Centralized organization scope. */
  centralized_organization_id: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by product type. */
  product_type?: InputMaybe<ProductTypeEnum>;
  /** Filter by schedule mode (ACTIVE / PAUSE / NONE). */
  schedule_mode?: InputMaybe<ScheduleModeInput>;
  /** Optional free-text search over the report name. Case-insensitive and accent-insensitive (e.g. 'Diseno' matches 'Diseño'). */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsMutationInternalError = {
  __typename?: 'AnalyticsMutationInternalError';
  errors: Array<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
};

export type AnalyticsMutationValidationError = {
  __typename?: 'AnalyticsMutationValidationError';
  errors: Array<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
};

export type AnalyticsOrganizationComparativeStatsNode = {
  __typename?: 'AnalyticsOrganizationComparativeStatsNode';
  /** Percentage of completed courses over total active enrollments */
  completed_courses_percent: Scalars['Float']['output'];
  /** Average study hours per studying user */
  study_percent_hours: Scalars['Float']['output'];
  /** Percentage of studying users over total active users */
  studying_users_percent: Scalars['Float']['output'];
};

export type AnalyticsOrganizationQuery = {
  __typename?: 'AnalyticsOrganizationQuery';
  /** Get weekly user progress from content hours */
  get_content_hours_by_user: AnalyticsUserProgressNode;
  get_organization_account: OrganizationAccountNode;
  /** Get organization comparative stats */
  get_organization_stats: AnalyticsOrganizationStatsNode;
};


export type AnalyticsOrganizationQueryGet_Organization_AccountArgs = {
  organization_id: Scalars['ID']['input'];
};


export type AnalyticsOrganizationQueryGet_Organization_StatsArgs = {
  input: AnalyticsGetOrganizationStatsInput;
};

export type AnalyticsOrganizationStatsNode = {
  __typename?: 'AnalyticsOrganizationStatsNode';
  /** Comparative stats for the organization */
  my_comparative?: Maybe<AnalyticsOrganizationComparativeStatsNode>;
  /** Comparative stats for the organization's industry */
  my_industry_comparative?: Maybe<AnalyticsOrganizationComparativeStatsNode>;
  /** Global comparative stats across all organizations */
  organization_comparative?: Maybe<AnalyticsOrganizationComparativeStatsNode>;
};

export type AnalyticsOrganizationTeamsQuery = {
  __typename?: 'AnalyticsOrganizationTeamsQuery';
  /** Get aggregated statistics for a route: study hours, started/completed/certified courses, users progress and rewards */
  get_completed_statistics_by_route_id: RouteCompletedStatisticsNode;
  /** Get per-course statistics for a route: completions, avg progress, consumed hours and certificates across enrolled users */
  get_courses_statistics_by_route_id: RouteCourseStatisticConnection;
  /** Get organization teams by user with pagination and filtering */
  get_organization_teams_by_user_id: ReportTeamConnection;
  /** Get user statistics for a route, aggregating course progress hours per user */
  get_user_statistics_by_route_id: RouteUserStatisticConnection;
};


export type AnalyticsOrganizationTeamsQueryGet_Completed_Statistics_By_Route_IdArgs = {
  input: GetRouteCompletedStatisticsInput;
};


export type AnalyticsOrganizationTeamsQueryGet_Courses_Statistics_By_Route_IdArgs = {
  input: GetRouteCoursesStatisticsInput;
};


export type AnalyticsOrganizationTeamsQueryGet_Organization_Teams_By_User_IdArgs = {
  input: GetReportTeamsByUserInput;
};


export type AnalyticsOrganizationTeamsQueryGet_User_Statistics_By_Route_IdArgs = {
  input: GetRouteUserStatisticsInput;
};

export type AnalyticsPostFilterInput = {
  channel_ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  published_at_eq?: InputMaybe<Scalars['DateTime']['input']>;
  published_at_range?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type AnalyticsPostOrderInput = {
  desc: Scalars['Boolean']['input'];
  field: InternalCommsAnalyticsPostOrderFields;
};

export type AnalyticsPostSearchInput = {
  fields?: Array<InternalCommsAnalyticsPostSearchFields>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export enum AnalyticsPredefinedAttributeEnum {
  Area = 'AREA',
  Country = 'COUNTRY',
  Department = 'DEPARTMENT',
  Gender = 'GENDER',
  Headquarter = 'HEADQUARTER',
  Level = 'LEVEL',
  Position = 'POSITION',
  PositionCategory = 'POSITION_CATEGORY',
  Role = 'ROLE'
}

export type AnalyticsReportMaxRetriesError = {
  __typename?: 'AnalyticsReportMaxRetriesError';
  errors: Array<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  max_retries: Scalars['Int']['output'];
  retry_count: Scalars['Int']['output'];
};

export type AnalyticsReportMutation = {
  __typename?: 'AnalyticsReportMutation';
  /** Bulk-create multiple Custom Reports (one per report_type) with shared config and schedule. Atomic: if any creation fails, all are rolled back. Idempotency: duplicate requests within 60s are rejected. */
  bulk_create_custom_reports: CustomReportBulkMutationSuccessCustomReportValidationErrorCustomReportScheduleLimitErrorCustomReportInternalError;
  /** Create a new Custom Report (Personalizado) with optional schedule. Requires analytics.scheduled_reports.manage permission to activate scheduling. */
  create_custom_report: CustomReportMutationSuccessCustomReportValidationErrorCustomReportScheduleLimitErrorCustomReportInternalError;
  /** Soft-delete a Custom Report and its schedule. Run history is retained for 90 days. */
  delete_custom_report: CustomReportDeleteSuccessCustomReportValidationErrorCustomReportInternalError;
  report_notify_pending_logs: ReportPendingResponseEventMutationError;
  report_organization_progress_call: ReportResponseReportExistsResponseAnalyticsMutationInternalError;
  /** Update an existing Custom Report (name, description, config, or schedule). Recalculates next_run_at when schedule frequency/day changes. */
  update_custom_report: CustomReportMutationSuccessCustomReportValidationErrorCustomReportScheduleLimitErrorCustomReportInternalError;
};


export type AnalyticsReportMutationBulk_Create_Custom_ReportsArgs = {
  input: AnalyticsBulkCreateCustomReportsInput;
};


export type AnalyticsReportMutationCreate_Custom_ReportArgs = {
  input: AnalyticsCreateCustomReportInput;
};


export type AnalyticsReportMutationDelete_Custom_ReportArgs = {
  input: AnalyticsDeleteCustomReportInput;
};


export type AnalyticsReportMutationReport_Organization_Progress_CallArgs = {
  input: ReportInputNode;
};


export type AnalyticsReportMutationUpdate_Custom_ReportArgs = {
  input: AnalyticsUpdateCustomReportInput;
};

export type AnalyticsReportRateLimitError = {
  __typename?: 'AnalyticsReportRateLimitError';
  errors: Array<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
};

export type AnalyticsRetryReportLogInput = {
  /** Centralized organization slug — must match the active session to validate ownership */
  centralized_organization_slug: Scalars['String']['input'];
  /** Primary key of the ReportLogs record to retry */
  report_log_id: Scalars['Int']['input'];
};

export type AnalyticsScheduledReportTriggerInput = {
  /** Centralized organization ID — used to scope and validate the CustomReport lookup. */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID of the saved CustomReport to execute. */
  custom_report_id: Scalars['Int']['input'];
};

export enum AnalyticsSegmentAlphabeticAttributeEnum {
  Branch = 'BRANCH',
  Country = 'COUNTRY',
  Gender = 'GENDER',
  Position = 'POSITION',
  PositionCategory = 'POSITION_CATEGORY',
  Role = 'ROLE'
}

export enum AnalyticsSegmentAlphabeticMultipleOperatorEnum {
  EqualToOption = 'EQUAL_TO_OPTION'
}

export enum AnalyticsSegmentAlphabeticSingleOperatorEnum {
  Contains = 'CONTAINS',
  DoesNotContain = 'DOES_NOT_CONTAIN',
  EndsWith = 'ENDS_WITH',
  EqualToString = 'EQUAL_TO_STRING',
  StartsWith = 'STARTS_WITH'
}

export enum AnalyticsSegmentDateAttributeEnum {
  DateOfBirth = 'DATE_OF_BIRTH',
  DateOfJoining = 'DATE_OF_JOINING'
}

export enum AnalyticsSegmentDateRangeOperatorEnum {
  Range = 'RANGE'
}

export enum AnalyticsSegmentDateSingleOperatorEnum {
  EqualTo = 'EQUAL_TO'
}

export enum AnalyticsSegmentGlobalModifier {
  And = 'AND',
  Or = 'OR'
}

export type AnalyticsSegmentInput = {
  /** AND: all rules must match. OR: at least one rule must match. */
  global_modifier?: AnalyticsSegmentGlobalModifier;
  /** List of segmentation rules. */
  rules?: Array<AnalyticsSegmentRuleInput>;
  /** DYNAMIC: rules are evaluated at report generation time. STATIC: a saved segment snapshot. */
  type?: AnalyticsSegmentTypeEnum;
};

export enum AnalyticsSegmentNumericRangeOperatorEnum {
  Range = 'RANGE'
}

export enum AnalyticsSegmentNumericSingleOperatorEnum {
  EqualTo = 'EQUAL_TO',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN'
}

export type AnalyticsSegmentRuleAlphabeticInput = {
  /** Predefined structural attribute (gender, country, position, etc.). */
  alphabetic_literal_attribute?: InputMaybe<AnalyticsSegmentAlphabeticAttributeEnum>;
  /** List of accepted values for multi-value matching. */
  alphabetic_multiple_operand?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Operator for multi-value matching (EQUAL_TO_OPTION). Use with alphabetic_multiple_operand. */
  alphabetic_multiple_operator?: InputMaybe<AnalyticsSegmentAlphabeticMultipleOperatorEnum>;
  /** Single string value for single-operator matching. */
  alphabetic_single_operand?: InputMaybe<Scalars['String']['input']>;
  /** Operator for single-value string matching. Use with alphabetic_single_operand. */
  alphabetic_single_operator?: InputMaybe<AnalyticsSegmentAlphabeticSingleOperatorEnum>;
  /** Custom field ID when filtering by a text or select custom field. */
  custom_field_attribute_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AnalyticsSegmentRuleAreaInput = {
  /** Users in any of these area IDs are matched. */
  area_ids?: Array<Scalars['Int']['input']>;
};

export type AnalyticsSegmentRuleDateInput = {
  /** ID of the date custom field to filter on. */
  custom_field_attribute_id?: InputMaybe<Scalars['Int']['input']>;
  /** Predefined date attribute (date_of_birth, date_of_joining). */
  date_literal_attribute?: InputMaybe<AnalyticsSegmentDateAttributeEnum>;
  /** Two-element list [date_from, date_to] for range matching (inclusive). */
  date_range_operand?: InputMaybe<Array<Scalars['Date']['input']>>;
  /** RANGE operator. Use with date_range_operand [from, to]. */
  date_range_operator?: InputMaybe<AnalyticsSegmentDateRangeOperatorEnum>;
  /** Single date value for exact matching. */
  date_single_operand?: InputMaybe<Scalars['Date']['input']>;
  /** Operator for exact date matching. */
  date_single_operator?: InputMaybe<AnalyticsSegmentDateSingleOperatorEnum>;
};

export type AnalyticsSegmentRuleInput = {
  /** Text/ID attribute rule (predefined attribute or custom field). */
  alphabetic_rule?: InputMaybe<AnalyticsSegmentRuleAlphabeticInput>;
  /** Organizational area rule. */
  area_rule?: InputMaybe<AnalyticsSegmentRuleAreaInput>;
  /** Date attribute rule (date of birth, date of joining, or date custom field). */
  date_rule?: InputMaybe<AnalyticsSegmentRuleDateInput>;
  /** Numeric custom field rule. */
  numeric_rule?: InputMaybe<AnalyticsSegmentRuleNumericInput>;
};

export type AnalyticsSegmentRuleNumericInput = {
  /** ID of the numeric custom field to filter on. */
  custom_field_attribute_id?: InputMaybe<Scalars['Int']['input']>;
  /** Two-element list [min, max] for range matching. */
  numeric_range_operand?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** RANGE operator. Use with numeric_range_operand [min, max]. */
  numeric_range_operator?: InputMaybe<AnalyticsSegmentNumericRangeOperatorEnum>;
  /** Single integer value for single-operator matching. */
  numeric_single_operand?: InputMaybe<Scalars['Int']['input']>;
  /** Operator for single-value numeric matching. */
  numeric_single_operator?: InputMaybe<AnalyticsSegmentNumericSingleOperatorEnum>;
};

export enum AnalyticsSegmentTypeEnum {
  Dynamic = 'DYNAMIC',
  Static = 'STATIC'
}

/** The goals of one collaborator (M-R6, expandable row): name, weight and result of each. */
export type AnalyticsTalentCollaboratorGoals = {
  __typename?: 'AnalyticsTalentCollaboratorGoals';
  /** ORG_UNAVAILABLE / INVALID_INPUT / INTERNAL_ERROR. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** The collaborator's goals in this process, capped at 100. */
  goals: Array<AnalyticsTalentGoalRow>;
  /** False when the organization has no Performance module. */
  is_module_contracted: Scalars['Boolean']['output'];
};

/** Input de la fila expandible: las metas de UN colaborador del proceso. */
export type AnalyticsTalentCollaboratorGoalsInput = {
  /** Centralized organization ID the process belongs to. */
  centralized_organization_id: Scalars['Int']['input'];
  /** The collaborator. It is validated against the process cohort, not trusted: an id from another organization returns nothing. */
  employee_id: Scalars['Int']['input'];
  /** Optional cycle; v1 always reads the process's closing cycle. */
  goal_track_id?: InputMaybe<Scalars['Int']['input']>;
  /** Goals process identifier. It is a STRING. */
  process_id: Scalars['String']['input'];
};

/** Blocking situation to filter by. The three are the SAME three the relation cards count (ANLT-621), by import — so the number on the card and the rows this table returns cannot disagree. */
export enum AnalyticsTalentCompetenceBlockFilterEnum {
  WithoutEvaluator = 'WITHOUT_EVALUATOR',
  WithoutLeaderEvaluation = 'WITHOUT_LEADER_EVALUATION',
  WithoutSelfEvaluation = 'WITHOUT_SELF_EVALUATION'
}

/** One collaborator of the process cohort and the state of their evaluation in each relation. */
export type AnalyticsTalentCompetenceCollaboratorRow = {
  __typename?: 'AnalyticsTalentCompetenceCollaboratorRow';
  /**
   * Null when the organization has not filled it, never an empty string.
   *
   * ⚠️ This is CUO's `area`. The «Datos de evaluación de competencias» downloadable publishes `department` under a similar heading — two different columns. Do not expect them to match row by row.
   */
  area?: Maybe<Scalars['String']['output']>;
  /** Leader's name from the flat centralized columns. The reports derive it from a self-join instead — two origins for one value, and their agreement is not verified in this repo. */
  boss_name?: Maybe<Scalars['String']['output']>;
  /** Talent id — the id the frontend selects for the reminder. */
  employee_id: Scalars['Int']['output'];
  /** Collaborator's name. */
  full_name: Scalars['String']['output'];
  /** Site. */
  headquarter?: Maybe<Scalars['String']['output']>;
  /** Job title. */
  position?: Maybe<Scalars['String']['output']>;
  /** One cell per relation this person is involved in. */
  states: Array<AnalyticsTalentCompetenceRelationState>;
};

/** One relation this evaluator was asked to evaluate under, named the same way the cards above name it. */
export type AnalyticsTalentCompetenceEvaluatorRelation = {
  __typename?: 'AnalyticsTalentCompetenceEvaluatorRelation';
  /** Raw literal (`AUTO`, `BOSS`, `SUBORDINATE`, `COWORKER`…). Deliberately a String and not an enum: the vocabulary is open-ended and an enum would break the published schema every time Talent adds one. */
  relation: Scalars['String']['output'];
  /** Spanish name from the shared catalog, so a relation is called the same thing here and on the per-relation cards. A literal the catalog cannot name is passed through RAW — never dropped, and never renamed on a guess. */
  relation_name: Scalars['String']['output'];
};

/** One evaluator and what they owe. The unit of accountability is the EVALUATOR, not the leader: the same person can owe a self-evaluation, two peer reviews and one for their team, and all of them hang off them. */
export type AnalyticsTalentCompetenceEvaluatorRow = {
  __typename?: 'AnalyticsTalentCompetenceEvaluatorRow';
  /** Null when the organization has not filled it — never an empty string masquerading as a value. */
  area?: Maybe<Scalars['String']['output']>;
  /** Evaluations assigned to them, counting (evaluator, evaluated) PAIRS. Cancelled ones excluded. The self-evaluation counts: it is a real task they owe, and the cards above count it too — leaving it out here would break the invariant that these rows sum to what the process card publishes. */
  assigned: Scalars['Int']['output'];
  /** Of those, already submitted. */
  completed: Scalars['Int']['output'];
  /** Talent id of the evaluator — the key the frontend carries into the reminder selection. */
  employee_id: Scalars['Int']['output'];
  /** Evaluator's name, from the centralized world. */
  full_name: Scalars['String']['output'];
  /** Site. */
  headquarter?: Maybe<Scalars['String']['output']>;
  /** `assigned - completed`, floored at 0 and computed in SQL. This is the default sort, descending: who is holding the process back. */
  pending: Scalars['Int']['output'];
  /** Job title. */
  position?: Maybe<Scalars['String']['output']>;
  /**
   * How far this evaluator got, **0–100** with 2 decimals — never the Goals tab's 0–1 `progress_rate`.
   *
   * Nullable in the contract, but **in practice it never arrives null**: a row only exists for someone with at least one countable evaluation, so `assigned` is always ≥ 1. The null branch is a guard, not a state to design a screen around. An active member with nothing assigned has no row here at all — by design, because widening that join is what would break the invariant with the process card.
   */
  progress_percentage?: Maybe<Scalars['Float']['output']>;
  /** Relations this evaluator was assigned under. */
  relations: Array<AnalyticsTalentCompetenceEvaluatorRelation>;
};

/** One competence and how differently the collaborator and their leader see it. */
export type AnalyticsTalentCompetenceGapRow = {
  __typename?: 'AnalyticsTalentCompetenceGapRow';
  /** Collaborators who have **both** views for this competence — the only ones the gap is computed from. Someone with a self-evaluation but no leader review is excluded here and may still count in another competence where they have both. */
  compared_count: Scalars['Int']['output'];
  /** Competence name. */
  competence_name: Scalars['String']['output'];
  /**
   * `self_result - leader_result`, in points of that scale. Positive means the person rates themselves above their leader's view — the reading this block exists to surface.
   *
   * It is the difference of the **two rounded numbers shown beside it**, so the three always add up. Subtracting before rounding would publish a third value that matches neither, which is the kind of discrepancy nobody can explain from the screen.
   */
  gap?: Maybe<Scalars['Float']['output']>;
  /** Average leader result for the same competence, same scale. */
  leader_result?: Maybe<Scalars['Float']['output']>;
  /**
   * Average self-evaluation result for this competence.
   *
   * ⚠️ **In the process's own scale (1–5, 1–100…), NOT a percentage.** The per-competence raw result is stored unnormalised and the formula that converts it lives in the refined model, not here. It is still the right number for this block: self and leader share the scale, so comparing them is valid — comparing either against a percentage from another block is not.
   */
  self_result?: Maybe<Scalars['Float']['output']>;
};

/** One group of the chosen attribute, its result, and the competence dragging it down. */
export type AnalyticsTalentCompetenceGroupRow = {
  __typename?: 'AnalyticsTalentCompetenceGroupRow';
  /**
   * Group's average, **0–100** with 2 decimals, clamped before averaging.
   *
   * NULL — not zero — when nobody in the group has a result yet. A group of people nobody evaluated is not a group that scored zero, and rendering it as zero would put it at the bottom of the list as if it were the worst.
   */
  average_result?: Maybe<Scalars['Float']['output']>;
  /** Collaborators in this group who are enrolled in the process. **Small groups are returned, not hidden** — the interface decides how to present them. Filtering them here would also drop them from the overall figures. */
  employees_count: Scalars['Int']['output'];
  /** Of those, how many have a result — **the denominator of this group's average**. Without it, «12 collaborators» next to an average computed from 4 cannot be interpreted. */
  evaluated_count: Scalars['Int']['output'];
  /** Group name — the attribute's value. Collaborators with the attribute empty are grouped under «Sin asignar» rather than dropped: they are people, and hiding them would make the groups sum to less than the organization. */
  group_value: Scalars['String']['output'];
  /**
   * Lowest-scoring competence in this group — what turns the cut into a development plan instead of one more table. NULL when the group has no competence answers yet.
   *
   * Ties break by competence name, deliberately: without it, two competences with the same average would swap places between requests over identical data, and an administrator would watch the plan move for no reason.
   */
  weakest_competence?: Maybe<Scalars['String']['output']>;
  /**
   * That competence's average in this group.
   *
   * ⚠️ **NOT a percentage — it is in the process's own scale** (1–5, 1–100, …), unlike `average_result`, which is. The per-competence raw result is stored unnormalised, and the formula that converts it lives in the refined model, not here. Use it to rank competences AGAINST EACH OTHER within one process, where they all share a scale — never as a percentage, and never compared across processes.
   *
   * **Whether the self-evaluation counts is decided upstream, not here.** The pipeline drops it before this data exists unless the process is relation-based or the company turned on `contemplate_auto`; when it survives, its `relation_weight` decides how much it weighs, and a weight of 0 excludes it on its own. Filtering it again here would overwrite a setting the customer chose.
   *
   * ⚠️ **The weighting is by relation weight only.** The pipeline also folds in the competence weight, so on processes configured as `RELATION_WEIGHT` this number can differ from the pipeline’s and, in the worst case, name a different weakest competence. The column that would close the gap (`total_weight`) is not replicated into this database yet. Read this field as «weakest within this process, weighted by relation», not as an official figure reconciled with the model.
   */
  weakest_competence_result?: Maybe<Scalars['Float']['output']>;
};

/** Competences of the model ranked from worst to best result (ANLT-638). */
export type AnalyticsTalentCompetenceRanking = {
  __typename?: 'AnalyticsTalentCompetenceRanking';
  /** ORG_UNAVAILABLE when the organization cannot be served (deliberately opaque), INVALID_INPUT when the process id is missing, INTERNAL_ERROR on failure. Null on success — including when the model has no competences with results yet. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the Talent source data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** False ⇒ the block is not rendered at all, not rendered empty. No counts leak. */
  is_module_contracted: Scalars['Boolean']['output'];
  /**
   * **Worst first.** Competences with no result sort last, never first: a competence nobody answered is not the most critical one.
   *
   * Contains every competence the model defines, including the ones nobody was evaluated on — that absence is the finding.
   */
  items: Array<AnalyticsTalentCompetenceRankingItem>;
};

/** One competence of the model, with how the organization scored on it. */
export type AnalyticsTalentCompetenceRankingItem = {
  __typename?: 'AnalyticsTalentCompetenceRankingItem';
  /** Competence name, as the model defines it. */
  competence_name: Scalars['String']['output'];
  /** Collaborators of the cohort with a result on this competence. It is the denominator of `result_percentage`, and the only way to read a null result correctly: 0 means nobody answered. */
  evaluated_count: Scalars['Int']['output'];
  /**
   * Minimum expected for this competence, in the **same unit** as `result_percentage`, so the two can be compared directly.
   *
   * ⚠️ **Null has two different causes, and `expected_varies_by_role` separates them:**
   * - `expected_varies_by_role = false` → the model simply never configured a minimum. Measured on a real model: all 5 competences had none.
   * - `expected_varies_by_role = true` → a minimum EXISTS, but it is not one number: it is configured per job level, so an analyst and a manager are held to different bars on the same competence. Publishing one of them, or their average, would show a threshold **nobody configured** with the authority of an official one.
   */
  expected_percentage?: Maybe<Scalars['Float']['output']>;
  /** True when the minimum expected differs across job levels. Then `expected_percentage` is null **on purpose** — say «depends on the role» rather than leaving an unexplained gap. */
  expected_varies_by_role: Scalars['Boolean']['output'];
  /** Group the competence belongs to. Nullable and **often null**: measured on a real model, all 5 competences had it empty. Treat it as optional grouping, never as a required axis. */
  macro_competence?: Maybe<Scalars['String']['output']>;
  /**
   * Average score on this competence across the enrolled cohort, 0–100.
   *
   * **Null means nobody was evaluated on it** — not zero. A competence the model defines and nobody answered is published with null and sorts LAST, because «not measured» is not «the worst». Check `evaluated_count` to tell the two apart.
   */
  result_percentage?: Maybe<Scalars['Float']['output']>;
  /** Weight of this competence in the model. Same null rule as the expected minimum — see `weight_varies_by_role`. */
  weight_percentage?: Maybe<Scalars['Float']['output']>;
  /** True when the weight differs across job levels. */
  weight_varies_by_role: Scalars['Boolean']['output'];
};

/** One cell: this collaborator, in this relation. */
export type AnalyticsTalentCompetenceRelationState = {
  __typename?: 'AnalyticsTalentCompetenceRelationState';
  /** Raw literal (`AUTO`, `BOSS`…). A String and not an enum: the vocabulary is open-ended and an enum would break the published schema every time Talent adds one. */
  relation: Scalars['String']['output'];
  /** Spanish name from the SAME shared catalog the cards use. A literal the catalog cannot name is passed through raw, never dropped and never renamed on a guess. */
  relation_name: Scalars['String']['output'];
  /** Completed, pending, or nobody assigned. */
  status: AnalyticsTalentCompetenceRelationStatusEnum;
};

/** State of one collaborator's evaluation in ONE relation. Three values, not two: «nobody was assigned to evaluate you» is a different problem from «your evaluator has not done it yet», and they need different interventions — the first is a configuration fix, the second is a reminder. Folding them together would hide the first behind the second. */
export enum AnalyticsTalentCompetenceRelationStatusEnum {
  Completed = 'COMPLETED',
  NoEvaluatorAssigned = 'NO_EVALUATOR_ASSIGNED',
  Pending = 'PENDING'
}

/** Lo que un colaborador sacó en UNA competencia del modelo. */
export type AnalyticsTalentCompetenceResultCell = {
  __typename?: 'AnalyticsTalentCompetenceResultCell';
  /** Competence name, as the model defines it. */
  competence_name: Scalars['String']['output'];
  /**
   * Minimum expected for this competence, in the **same unit** as `result_percentage`, so the two compare directly.
   *
   * ⚠️ Null has two causes, separated by `expected_varies_by_role`: either the model configured no minimum, or a minimum exists but is set per job level, so an analyst and a manager are held to different bars on the same competence.
   */
  expected_percentage?: Maybe<Scalars['Float']['output']>;
  /** True when the minimum differs across job levels. Then `expected_percentage` is null on purpose — say «depends on the role» rather than leaving an unexplained gap. */
  expected_varies_by_role: Scalars['Boolean']['output'];
  /** Group the competence belongs to. Nullable and often null — treat it as optional grouping, never as a required axis. */
  macro_competence?: Maybe<Scalars['String']['output']>;
  /**
   * This person's score on this competence, 0–100.
   *
   * **Null means this person was not evaluated on it** — not zero. Every competence of the model is listed for every collaborator, so the gaps are visible: a competence nobody answered for this person is a finding, and rendering it as 0 would say they scored the worst possible mark on it.
   */
  result_percentage?: Maybe<Scalars['Float']['output']>;
  /** Weight of this competence in the model. Same null rule. */
  weight_percentage?: Maybe<Scalars['Float']['output']>;
};

/** One level of the process's scale and how many collaborators landed in it. */
export type AnalyticsTalentCompetenceResultLevel = {
  __typename?: 'AnalyticsTalentCompetenceResultLevel';
  /** Collaborators at this level. */
  employees_count: Scalars['Int']['output'];
  /** Level name **as the pipeline resolved it** from the process's semaphore configuration (`Cumple con las expectativas`…). It is not recomputed here: the cuts belong to the process, and deriving them again would be a second definition of the same number. */
  label: Scalars['String']['output'];
  /** Band colour from the process configuration, hex without `#`. Consistent across organizations even though the label is not: red → amber → green → blue. `semaphore` is the colour observed on the collaborators' rows; this one is the configured band's. */
  limit_color?: Maybe<Scalars['String']['output']>;
  /** Lower bound of the band, inclusive. Comes from the process's **configuration**, not from the data: a band with nobody in it still has its bounds, and deriving them from the observed min/max would move them depending on who happened to be evaluated. */
  limit_from?: Maybe<Scalars['Float']['output']>;
  /**
   * Upper bound of the band, exclusive.
   *
   * ⚠️ **It can exceed 100.** Measured on a real process: 60 → 75 → 90 → **130**. Meanwhile `average_result` is clamped to [0, 100], so the top band's upper bound may describe a value the averages never reach. Both are correct: this is the organization's configured scale, and the average is the clamped result. Clamping this bound would misreport their configuration; a chart drawn to it should expect the top band to look partly empty.
   *
   * ⚠️ **Unverified: processes configured as `SCALE`.** Upstream, the same column is compared **inclusively and in scale units** for those (`configured_scale_result <= limit`) instead of exclusively and in percent. This repo cannot tell the two apart — `evaluation_format` is not synced to Analytics — so for a `SCALE` process these bounds may be on a different axis than `average_result`. Pending confirmation from Data on whether such processes exist; until then, treat the bound as exclusive and percent-based, which is what every process measured so far does.
   */
  limit_to?: Maybe<Scalars['Float']['output']>;
  /**
   * Identifier of this level within the process's scale — **1 is the lowest**. Use it to **sort**; do NOT use it to index or to compute «level N of M».
   *
   * ⚠️ **It can have gaps.** The value is derived upstream from the band's colour slot (red=1, orange=2, yellow=3, green=4, blue=5) and processes with fewer bands drop slots: a 3-band process can publish `1, 3, 5`. Anything that does `levels[order_id - 1]` or assumes the top band equals the band count breaks on those.
   *
   * The label text is NOT usable for that: it is free per organization. Two real processes: «No cumple → Medianamente cumple → Cumple → Sobrepasa» and «POTENCIAL BAJO → POTENCIAL MEDIO → POTENCIAL ALTO». There is no universal vocabulary, so anything that compares label text breaks on the next customer.
   *
   * NULL when the level was observed but is no longer configured — a recalibration mid-process. Those sort last.
   */
  order_id?: Maybe<Scalars['Int']['output']>;
  /** Level colour, hex without `#` (`80E0B4`, `40B2FF`…). Also resolved upstream. Nullable: an organization that never configured colours still has levels. */
  semaphore?: Maybe<Scalars['String']['output']>;
};

/** Tabla paginada de colaboradores con su detalle por competencia. */
export type AnalyticsTalentCompetenceResultsDetail = {
  __typename?: 'AnalyticsTalentCompetenceResultsDetail';
  /** ORG_UNAVAILABLE when the organization cannot be served (deliberately opaque), INVALID_INPUT when the process id is missing, INTERNAL_ERROR on failure. Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the Talent source data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** True when another page follows this one. */
  has_more: Scalars['Boolean']['output'];
  /** False ⇒ the block is not rendered at all, not rendered empty. No counts leak. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** Opaque cursor for the next page. Null on the last page. */
  next_cursor?: Maybe<Scalars['String']['output']>;
  /** The requested page, already sorted. */
  rows: Array<AnalyticsTalentCompetenceResultsDetailRow>;
  /** Total collaborators matching the SAME filters as the page, search included. It is what the pagination can actually walk. */
  total_count: Scalars['Int']['output'];
};

/** Un colaborador, con su resultado y su detalle. */
export type AnalyticsTalentCompetenceResultsDetailRow = {
  __typename?: 'AnalyticsTalentCompetenceResultsDetailRow';
  /** Area. */
  area?: Maybe<Scalars['String']['output']>;
  /** **Every competence of the model**, in name order — including the ones this person has no result for, which travel with a null result. That is the expandable row. */
  competences: Array<AnalyticsTalentCompetenceResultCell>;
  /** Talent employee id. */
  employee_id: Scalars['Int']['output'];
  /** Collaborator's full name. */
  full_name?: Maybe<Scalars['String']['output']>;
  /** Site. */
  headquarter?: Maybe<Scalars['String']['output']>;
  /** Hex colour of that level (e.g. `80E0B4`). */
  level_color?: Maybe<Scalars['String']['output']>;
  /** Level reached, resolved by the pipeline from **the process's** semaphore configuration. Not derived here: recomputing it would create a second definition of the same value. */
  level_name?: Maybe<Scalars['String']['output']>;
  /** Job title. */
  position?: Maybe<Scalars['String']['output']>;
  /**
   * Overall result for the process, 0–100, **clamped**.
   *
   * Null means the person is in the process but has no result yet — they are still listed, because dropping them would make the table report fewer people than the process actually reaches.
   */
  result_percentage?: Maybe<Scalars['Float']['output']>;
};

/** Per-collaborator competences detail (C-S6), one server-resolved page. An empty page is a SUCCESS, not an error. */
export type AnalyticsTalentCompetencesDetail = {
  __typename?: 'AnalyticsTalentCompetencesDetail';
  /** ORG_UNAVAILABLE (deliberately opaque), INVALID_INPUT when the process id is missing, INTERNAL_ERROR on failure. Null on success, including on an empty page. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the Talent source data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** Whether another page follows. */
  has_more: Scalars['Boolean']['output'];
  /** False ⇒ the block is not rendered at all, not rendered empty. No counts leak. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** Opaque cursor. The client sends it back, never rebuilds it. */
  next_cursor?: Maybe<Scalars['String']['output']>;
  /** This page of collaborators. */
  rows: Array<AnalyticsTalentCompetenceCollaboratorRow>;
  /** Collaborators matching the SAME filters as this page, block filter included. Not the unfiltered cohort: filtering by a blocking situation and still announcing the whole cohort is the count/page divergence bug. */
  total_count: Scalars['Int']['output'];
};

/** Input del detalle por colaborador. El filtro por situación de bloqueo es el que usa el frontend para bajar desde las tarjetas de relación. */
export type AnalyticsTalentCompetencesDetailInput = {
  /** Devuelve SOLO los colaboradores en esa situación, y el total refleja el subconjunto filtrado. Sin filtro, toda la cohorte. */
  block?: InputMaybe<AnalyticsTalentCompetenceBlockFilterEnum>;
  /** Organización centralizada dueña del proceso. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Página pedida. */
  pagination?: InputMaybe<AnalyticsTalentCompetencesDetailPaginationInput>;
  /** Identificador del proceso de competencias, tal como lo devuelve el catálogo. Es un STRING — no parsearlo ni castearlo. El servidor verifica que sea de esta organización antes de leer nada. */
  process_id: Scalars['String']['input'];
  /** Búsqueda por nombre. */
  search?: InputMaybe<AnalyticsTalentCompetencesDetailSearchInput>;
  /** Orden de la tabla. */
  sort?: InputMaybe<AnalyticsTalentCompetencesDetailSortInput>;
};

/** Página pedida, con cursor opaco. */
export type AnalyticsTalentCompetencesDetailPaginationInput = {
  /** Cursor de la última fila de la página anterior. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Filas por página. Por omisión 20, tope 100. */
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Búsqueda por nombre del colaborador. */
export type AnalyticsTalentCompetencesDetailSearchInput = {
  /** Texto a buscar en el nombre. Se escapa antes de llegar al SQL. */
  query: Scalars['String']['input'];
};

/** Orden de la tabla, por columna y dirección. */
export type AnalyticsTalentCompetencesDetailSortInput = {
  /** asc o desc. Por omisión asc: pedir una columna sin dirección no debería invertir el sentido respecto de no pedir nada. */
  direction?: InputMaybe<Scalars['String']['input']>;
  /** Columna: full_name, area, headquarter, position o boss_name. Cualquier otro valor usa el orden por omisión (nombre ascendente). */
  field: Scalars['String']['input'];
};

/** Competences progress per evaluator (C-S5), one server-resolved page. An empty page is a SUCCESS, not an error. */
export type AnalyticsTalentCompetencesEvaluators = {
  __typename?: 'AnalyticsTalentCompetencesEvaluators';
  /** ORG_UNAVAILABLE when the organization cannot be served (deliberately opaque), INVALID_INPUT when the process id is missing, INTERNAL_ERROR on failure. Null on success — including on an empty page. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the Talent source data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** Whether another page follows. */
  has_more: Scalars['Boolean']['output'];
  /** False ⇒ the block is not rendered at all, not rendered empty. No counts leak in that case. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** Opaque cursor for the next page. The client sends it back verbatim and never rebuilds it. */
  next_cursor?: Maybe<Scalars['String']['output']>;
  /** This page of evaluators, whoever owes most first. */
  rows: Array<AnalyticsTalentCompetenceEvaluatorRow>;
  /** Evaluators matching the SAME filters as this page — the toolbar counter. Computed from the same base as the rows, so it cannot announce a number the pages do not deliver. */
  total_count: Scalars['Int']['output'];
};

/** Input de la tabla de avance por evaluador. Un proceso por vez: la tabla responde «a quién hay que perseguir en ESTE proceso». */
export type AnalyticsTalentCompetencesEvaluatorsInput = {
  /** Organización centralizada dueña del proceso. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Página pedida. */
  pagination?: InputMaybe<AnalyticsTalentCompetencesEvaluatorsPaginationInput>;
  /** Identificador del proceso de competencias, tal como lo devuelve el catálogo. Es un STRING — no parsearlo ni castearlo. El servidor verifica que sea de esta organización antes de leer nada: la tabla de relaciones no tiene columna de empresa, así que el proceso es el único aislamiento que hay. */
  process_id: Scalars['String']['input'];
  /** Búsqueda por nombre. */
  search?: InputMaybe<AnalyticsTalentCompetencesEvaluatorsSearchInput>;
  /** Orden de la tabla. */
  sort?: InputMaybe<AnalyticsTalentCompetencesEvaluatorsSortInput>;
};

/** Página pedida, con cursor opaco. */
export type AnalyticsTalentCompetencesEvaluatorsPaginationInput = {
  /** Cursor de la última fila de la página anterior. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Filas por página. Por omisión 20, tope 100. */
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Búsqueda por nombre del evaluador. */
export type AnalyticsTalentCompetencesEvaluatorsSearchInput = {
  /** Texto a buscar en el nombre. Se escapa antes de llegar al SQL. */
  query: Scalars['String']['input'];
};

/** Orden de la tabla, por columna y dirección. */
export type AnalyticsTalentCompetencesEvaluatorsSortInput = {
  /** asc o desc. Por omisión desc. */
  direction?: InputMaybe<Scalars['String']['input']>;
  /** Columna: pending, completed, assigned, progress_percentage, full_name, area, headquarter o position. Cualquier otro valor usa el orden por omisión (pendientes, de mayor a menor). */
  field: Scalars['String']['input'];
};

/** Perception gap per competence (C-R5): where the collaborator's view and their leader's diverge. A different conversation from «who scored low». */
export type AnalyticsTalentCompetencesGap = {
  __typename?: 'AnalyticsTalentCompetencesGap';
  /** ORG_UNAVAILABLE when the organization cannot be served, INVALID_INPUT when the process id is missing, INTERNAL_ERROR on failure. Null on success — including when the comparison does not apply, which is an answer and not an error. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Collaborators left out because they have only one of the two views. Published on purpose: a gap computed over 40 of 300 people is a gap of 40 people, and without this number the screen cannot tell you that. */
  excluded_count: Scalars['Int']['output'];
  /** When the Talent source data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /**
   * Whether the process's relation configuration could be read at all.
   *
   * **False means «unknown», not «not configured».** With it false, `is_applicable` is not an answer — the screen must not claim the comparison does not apply when all it knows is that it could not check. Rows are still published in that case: whatever the query found is real data, and suppressing it would invent an answer.
   */
  has_configuration: Scalars['Boolean']['output'];
  /**
   * Whether the comparison applies to this process at all.
   *
   * **False when the process did not configure both relations** — a 90° process, where only the leader evaluates, has no gap. That is NOT a gap of zero, and the screen must say «does not apply» rather than draw a flat chart: a zero would read as «everyone is perfectly aligned», which is the opposite of «we never asked».
   *
   * ⚠️ **Read `has_configuration` first.** If that is false, this field carries no information — the configuration could not be read, which is not the same as it saying no.
   */
  is_applicable: Scalars['Boolean']['output'];
  /** False ⇒ the block is not rendered at all, not rendered empty. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** Competences, **widest gap first** — where to look. */
  rows: Array<AnalyticsTalentCompetenceGapRow>;
};

/** Input de la brecha de percepción. Un proceso por vez: la comparación solo tiene sentido dentro de una misma escala. */
export type AnalyticsTalentCompetencesGapInput = {
  /** Organización centralizada dueña del proceso. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Identificador del proceso de competencias, tal como lo devuelve el catálogo. Es un STRING — no parsearlo ni castearlo. */
  process_id: Scalars['String']['input'];
};

/** One open competences process and how far along it is. The unit is the (evaluator, evaluated) PAIR — one row per evaluation someone was asked to complete — not the person. Cancelled evaluations are excluded from both numerator and denominator, and only evaluators who are active members of the organization are counted, matching the cohort of the «Consulta reporte general competencias y metas» report. */
export type AnalyticsTalentCompetencesProcessProgress = {
  __typename?: 'AnalyticsTalentCompetencesProcessProgress';
  /** End of the process window, ISO date. The list is ordered by this field ascending, so what is about to expire comes first — which is the question the block exists to answer. */
  end_date?: Maybe<Scalars['String']['output']>;
  /** Collaborators assigned to the process who are ACTIVE members of the organization. Same definition the process selector uses, so both numbers agree on screen. */
  enrolled_count: Scalars['Int']['output'];
  /** Evaluations the evaluator submitted (relation state FINISHED). This is about the evaluator handing in their work — NOT about the committee having calibrated it. Calibration is a later, separate step (see the pending-calibration alert), so a process can be 100% here and still have results moving afterwards. */
  finished_count: Scalars['Int']['output'];
  /** Process identifier. */
  process_id: Scalars['String']['output'];
  /** Process name as the administrator named it. */
  process_name?: Maybe<Scalars['String']['output']>;
  /** Percentage of assigned evaluations completed, on a **0–100** scale (87.5 means 87.5%). The name says «percentage» on purpose: the Goals tab publishes a `progress_rate` on a 0–1 scale, and two adjacent tabs with the same field name and different scales is how a frontend renders 87% as 8700%. NULL — not zero — when the process has no evaluations assigned yet: it is not at 0%, there is nothing to measure. Rendering it as zero would claim nobody did work that nobody was given. */
  progress_percentage?: Maybe<Scalars['Float']['output']>;
  /**
   * DEPRECATED alias of `progress_percentage`. Identical value, on a **0–100** scale despite the name — which is exactly why it was renamed. Do not use it in new queries.
   * @deprecated Renamed to `progress_percentage` (ANLT-625). Same value, clearer name: this one is 0–100 while the Goals tab publishes a `progress_rate` on a 0–1 scale, and two adjacent tabs with the same field name and different scales is how a frontend renders 87% as 8700%. Will be removed once no client selects it.
   */
  progress_rate?: Maybe<Scalars['Float']['output']>;
  /** Start of the process window, ISO date. */
  start_date?: Maybe<Scalars['String']['output']>;
  /** Evaluations assigned in this process: the denominator. */
  total_relations: Scalars['Int']['output'];
};

/** Progress of every OPEN competences process at once (M-C1), so an administrator can tell which one is about to expire without opening them one by one. Only shown when the selector is on «Todos los procesos». */
export type AnalyticsTalentCompetencesProcessesProgress = {
  __typename?: 'AnalyticsTalentCompetencesProcessesProgress';
  /** ORG_UNAVAILABLE when the organization cannot be served — deliberately opaque, it never says whether the org exists. INVALID_INPUT or INTERNAL_ERROR otherwise. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the underlying data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** True when the cap left processes out. */
  has_more: Scalars['Boolean']['output'];
  /** Whether the organization has the Performance module. False means the block must not be rendered at all, not rendered empty. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** Open processes, the closest to expiring first. */
  processes: Array<AnalyticsTalentCompetencesProcessProgress>;
  /** How many open processes the organization has, BEFORE the cap. Compare against the length of `processes` to tell a full list from a truncated one. */
  total_open_processes: Scalars['Int']['output'];
};

/** Input for the open-processes progress block. Takes no process id on purpose: the block compares ALL open processes and only renders when the selector is on «Todos los procesos». */
export type AnalyticsTalentCompetencesProcessesProgressInput = {
  /** Centralized organization id. */
  centralized_organization_id: Scalars['Int']['input'];
  /** How many processes to return. Defaults to 50 and is capped server-side; a larger value is clamped, never honoured. */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Competences progress per configured relation (M-C2), so an administrator can tell which relation is holding the process back. */
export type AnalyticsTalentCompetencesProgressByRelation = {
  __typename?: 'AnalyticsTalentCompetencesProgressByRelation';
  /** The three blocking situations. */
  blockers?: Maybe<AnalyticsTalentCompetencesRelationBlockers>;
  /** ORG_UNAVAILABLE when the organization cannot be served — deliberately opaque. A process of another company returns an empty answer with no error, on purpose, so ids cannot be enumerated. INVALID_INPUT when the process id is missing. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the underlying data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** Whether the process's relation configuration could be read. False with an empty list means «the configuration is unavailable», which is NOT the same as «this process configured no relations» — the screen must not claim the second when it only knows the first. */
  has_configuration: Scalars['Boolean']['output'];
  /** Whether the organization has the Performance module. False means the block must not be rendered at all, not rendered empty. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** Relations, the most blocked first. */
  relations: Array<AnalyticsTalentCompetencesRelationRow>;
};

/** Input for the competences progress-by-relation block. One process at a time: the block answers «which relation is holding THIS process back». */
export type AnalyticsTalentCompetencesProgressByRelationInput = {
  /** Centralized organization ID the process belongs to. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Competences process identifier from the process catalog. It is a STRING — do not parse or cast it. The server checks it belongs to this organization before reading anything: neither the relations table nor the filters table has a company column, so the process is the only isolation there is. */
  process_id: Scalars['String']['input'];
};

/** Competences progress cut by an attribute of the EVALUATOR (M-C4), so an administrator can tell which group is going to keep the process from closing. Worst first. */
export type AnalyticsTalentCompetencesProgressBySegment = {
  __typename?: 'AnalyticsTalentCompetencesProgressBySegment';
  /** Attributes this organization can cut by: the standard ones plus the custom fields it configured. Populate the selector from here — they differ per organization. */
  available_attributes: Array<AnalyticsTalentSegmentAttributeOption>;
  /** ORG_UNAVAILABLE when the ORGANIZATION cannot be served — deliberately opaque. A process that belongs to another company is NOT reported here: it returns an empty cut with no error, on purpose, so the response cannot be used to find out which process ids exist. INVALID_INPUT when the process id is missing or the attribute is unknown; INTERNAL_ERROR when the read fails. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the underlying data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** True when the cap left groups out. */
  has_more: Scalars['Boolean']['output'];
  /** Whether the organization has the Performance module. False means the block must not be rendered at all, not rendered empty. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** Groups, the least advanced first. */
  segments: Array<AnalyticsTalentCompetencesSegmentRow>;
  /** The attribute actually used for this cut. */
  selected_attribute_key?: Maybe<Scalars['String']['output']>;
  /** How many groups exist BEFORE the cap. Compare against the length of `segments` to tell a full cut from a truncated one. */
  total_groups: Scalars['Int']['output'];
};

/** Input for the competences progress by segment block. The attribute comes from `available_attributes` of a previous call; omit it to get the default cut. */
export type AnalyticsTalentCompetencesProgressBySegmentInput = {
  /** Attribute to group by: AREA, DEPARTMENT, POSITION, HEADQUARTER, or `custom_<field_id>`. Same vocabulary as the Goals tab — it reads the same organizational columns. Defaults to POSITION (Cargo). An unknown key is rejected with INVALID_INPUT rather than silently falling back, so a mis-wired selector never shows a cut the admin did not ask for. */
  attribute_key?: InputMaybe<Scalars['String']['input']>;
  /** Centralized organization ID the process belongs to. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Maximum groups returned, worst first. Defaults to 50, capped at 100 — the list is never unbounded. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Competences process identifier from the process catalog. It is a STRING — do not parse or cast it. The server checks it belongs to this organization before reading anything: the relations table has no company column, so the process is the only isolation there is. */
  process_id: Scalars['String']['input'];
};

/** The three blocking situations (AC-3). The unit is the COLLABORATOR, not the relation pair: these count people, over the same cohort the process selector already shows. */
export type AnalyticsTalentCompetencesRelationBlockers = {
  __typename?: 'AnalyticsTalentCompetencesRelationBlockers';
  /** Collaborators assigned to the process who are ACTIVE members of the organization — the denominator, so the screen can say «12 of 340» instead of a naked number. */
  cohort_count: Scalars['Int']['output'];
  /** Whether this process configured the leader relation. False means `without_leader_evaluation` is not a blocker. */
  leader_evaluation_is_configured: Scalars['Boolean']['output'];
  /** Whether this process configured a self-evaluation at all. False means `without_self_evaluation` is not a blocker and must not be rendered as one. */
  self_evaluation_is_configured: Scalars['Boolean']['output'];
  /** Collaborators with nobody assigned to evaluate them. The self-evaluation does NOT count as an evaluator: having only yourself assigned IS being without one. */
  without_evaluator: Scalars['Int']['output'];
  /** Collaborators with no FINISHED evaluation from their leader. Same caveat: check `leader_evaluation_is_configured` before rendering it as a blocker. */
  without_leader_evaluation: Scalars['Int']['output'];
  /** Collaborators with no FINISHED self-evaluation. Covers both «never assigned» and «assigned and not done» in one number — the card asks who did not do it, not why. **Read `self_evaluation_is_configured` first:** in a process that never configured a self-evaluation this number is the whole cohort, and rendering it as a blocker would claim 20,000 people failed to do something that was never asked of them. */
  without_self_evaluation: Scalars['Int']['output'];
};

/** One relation of the process and how far it got. Progress counts (evaluator, evaluated) PAIRS of that relation, on a **0–100** scale — never the Goals tab's 0–1 `progress_rate`. */
export type AnalyticsTalentCompetencesRelationRow = {
  __typename?: 'AnalyticsTalentCompetencesRelationRow';
  /** Evaluations of this relation already submitted. */
  finished_count: Scalars['Int']['output'];
  /** True when the process CONFIGURED this relation. A configured relation nobody ever evaluated still comes back, with zeros — that absence is the finding the block exists to surface. False means evaluations exist for a relation the configuration does not list (e.g. `PROVEEDOR`, which has no configurable id): hiding it would hide work that really happened. */
  is_configured: Scalars['Boolean']['output'];
  /** How far this relation got, 0–100. NULL — not zero — when nothing is assigned: it is not at 0%, there is nothing to measure yet. These rows sort FIRST, because a configured relation with no evaluations generated is the most severe blocker there is. */
  progress_percentage?: Maybe<Scalars['Float']['output']>;
  /** Raw literal stored in the relations table (`BOSS`, `COWORKER`, `AUTO`…). Use `relation_name` for display. */
  relation: Scalars['String']['output'];
  /**
   * Name the customer sees, taken from the same mapping the «Filtros activos» report publishes — i.e. what the organization actually CONFIGURED. For a relation observed but NOT configured there is no published name, so this falls back to the raw literal rather than inventing a label.
   *
   * ⚠️ Two Spanish vocabularies exist for the same relation. This block uses the configuration's («Líder», «Colega», «Colaborador»); the «Datos de evaluación de competencias» downloadable renames them («JEFE», «COLEGA», «COLABORADOR»). `BOSS` is the one that genuinely differs — «Líder» here, «JEFE» there. Show `relation` (the raw literal) alongside the name wherever a user may cross-check against that Excel, or they have to guess the two are the same thing.
   */
  relation_name: Scalars['String']['output'];
  /** Evaluations of this relation assigned, excluding cancelled ones. */
  total_relations: Scalars['Int']['output'];
};

/** Competences results for one closed process (C-R1): how the organization ended up, once the evaluation is over. This is the RESULT — execution progress lives in the Seguimiento tab. */
export type AnalyticsTalentCompetencesResults = {
  __typename?: 'AnalyticsTalentCompetencesResults';
  /** Individual competence answers that make up the process. */
  answers_count: Scalars['Int']['output'];
  /**
   * Organization's average result, **0–100** with 2 decimals — never 0–1.
   *
   * ⚠️ **Clamped to [0, 100] before averaging, not after.** The source column exceeds 100 in 1.28 % of rows, with values up to 2000. Clamping afterwards turns a real 83 into a reported 100, which reads as «the whole organization is at the top» and is false.
   *
   * NULL — not zero — when nobody has a result yet. Its denominator is `evaluated_count`, never `enrolled_count`: people without a result are excluded rather than counted as zero, which would drag the whole organization down.
   */
  average_result?: Maybe<Scalars['Float']['output']>;
  /** Distinct competences the process evaluates. */
  competences_count: Scalars['Int']['output'];
  /** Collaborators assigned to the process who are ACTIVE members — the same cohort the Seguimiento tab publishes, so both tabs agree on how many people the process reaches. */
  enrolled_count: Scalars['Int']['output'];
  /** ORG_UNAVAILABLE when the organization cannot be served (deliberately opaque), INVALID_INPUT when the process id is missing, INTERNAL_ERROR on failure. Null on success — including when the process has no results yet. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Collaborators with an actual result — **exactly the denominator of `average_result`**. Counts results, not rows: a row whose result is null exists but does not count, so the coverage figure cannot claim more people than the average was computed from. */
  evaluated_count: Scalars['Int']['output'];
  /** When the Talent source data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** False ⇒ the block is not rendered at all, not rendered empty. No counts leak. */
  is_module_contracted: Scalars['Boolean']['output'];
  /**
   * Distribution across the scale, most populated first.
   *
   * **Ordered by `order_id`** — the process's real scale, lowest band first. Earlier this list was ordered by population, which was the best available approximation before the semaphore configuration was wired in; a distribution chart drawn in population order misleads even when every bar is right.
   */
  levels: Array<AnalyticsTalentCompetenceResultLevel>;
};

/** Competences results cut by area, position, site or a custom field (C-R3): where to concentrate the development plan. */
export type AnalyticsTalentCompetencesResultsByGroup = {
  __typename?: 'AnalyticsTalentCompetencesResultsByGroup';
  /** ORG_UNAVAILABLE when the organization cannot be served, INVALID_INPUT when the process id is missing **or the `attribute_key` is unknown to this organization** (including a `custom_<id>` that belongs to another company), INTERNAL_ERROR on failure. Null on success — an empty cut is a success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the Talent source data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** Groups, **worst first** — the one that needs the plan. Groups with nobody evaluated sort last: they are unknown, not worst. */
  groups: Array<AnalyticsTalentCompetenceGroupRow>;
  /** False ⇒ the block is not rendered at all, not rendered empty. */
  is_module_contracted: Scalars['Boolean']['output'];
};

/** Input del corte por grupo de resultados. El atributo usa el MISMO vocabulario que el corte de Seguimiento (ANLT-625) y que la pestaña de Metas, porque leen las mismas columnas organizacionales. */
export type AnalyticsTalentCompetencesResultsByGroupInput = {
  /** Atributo por el que agrupar: AREA, DEPARTMENT, POSITION, HEADQUARTER, o `custom_<field_id>`. Por omisión POSITION (Cargo). Una clave desconocida se rechaza con INVALID_INPUT en vez de caer al atributo por omisión en silencio, para que un selector mal cableado nunca muestre un corte que el administrador no pidió. */
  attribute_key?: InputMaybe<Scalars['String']['input']>;
  /** Organización centralizada dueña del proceso. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Identificador del proceso de competencias, tal como lo devuelve el catálogo. Es un STRING — no parsearlo ni castearlo. El servidor verifica que sea de esta organización antes de leer nada: ninguna de las tablas de resultados tiene columna de empresa. */
  process_id: Scalars['String']['input'];
};

/** Input del detalle por competencia. Un proceso por vez: la tabla responde «cómo le fue a cada uno en ESTE proceso». */
export type AnalyticsTalentCompetencesResultsDetailInput = {
  /** Organización centralizada dueña del proceso. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Página pedida. */
  pagination?: InputMaybe<AnalyticsTalentCompetencesResultsDetailPaginationInput>;
  /** Identificador del proceso de competencias, tal como lo devuelve el catálogo. Es un STRING — no parsearlo ni castearlo. El servidor verifica que sea de esta organización antes de leer nada. */
  process_id: Scalars['String']['input'];
  /** Búsqueda por nombre. */
  search?: InputMaybe<AnalyticsTalentCompetencesResultsDetailSearchInput>;
  /** Orden de la tabla. */
  sort?: InputMaybe<AnalyticsTalentCompetencesResultsDetailSortInput>;
};

/** Página pedida, con cursor opaco. */
export type AnalyticsTalentCompetencesResultsDetailPaginationInput = {
  /** Cursor de la última fila de la página anterior. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Filas por página. Por omisión 20, tope 100. */
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Búsqueda por nombre del colaborador. */
export type AnalyticsTalentCompetencesResultsDetailSearchInput = {
  /** Texto a buscar en el nombre. Se escapa antes de llegar al SQL. */
  query: Scalars['String']['input'];
};

/** Orden de la tabla, por columna y dirección. */
export type AnalyticsTalentCompetencesResultsDetailSortInput = {
  /** asc o desc. Por omisión asc: pedir una columna sin dirección no debería invertir el sentido respecto de no pedir nada. */
  direction?: InputMaybe<Scalars['String']['input']>;
  /** Columna: full_name, area, headquarter, position, result_percentage o level_name. Cualquier otro valor usa el orden por omisión (nombre ascendente). */
  field: Scalars['String']['input'];
};

/** Input de la banda de resultados. Un proceso por vez: la banda responde «cómo quedó ESTE proceso», no la historia de la organización. */
export type AnalyticsTalentCompetencesResultsInput = {
  /** Organización centralizada dueña del proceso. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Identificador del proceso de competencias, tal como lo devuelve el catálogo. Es un STRING — no parsearlo ni castearlo. El servidor verifica que sea de esta organización antes de leer nada: la tabla de resultados no tiene columna de empresa. */
  process_id: Scalars['String']['input'];
};

/** One group of the chosen attribute and how far its EVALUATORS got. The subject is the evaluator on purpose: the process fails to close because someone has not submitted, so the group that blocks it is the group holding the pending work — and it is the same subject the process card beside it counts, so the groups add up to it exactly. */
export type AnalyticsTalentCompetencesSegmentRow = {
  __typename?: 'AnalyticsTalentCompetencesSegmentRow';
  /** Distinct EVALUATORS of this group with work in this process. **It is not a partition of the process card's `enrolled_count`** and must not be summed against it: that one counts process PARTICIPANTS, this one counts who was asked to evaluate. In a 360 the two differ by design — a manager evaluates people outside their own group, and a participant may evaluate nobody. What DOES add up exactly to the card is `finished_count` and `total_relations`. */
  evaluators_count: Scalars['Int']['output'];
  /** Evaluations this group submitted. */
  finished_count: Scalars['Int']['output'];
  /** How far the group got, on a **0–100** scale — the same scale as the process card, never the Goals tab's 0–1 `progress_rate`. NULL — not zero — when every evaluation of the group is CANCELLED, which leaves it with no denominator: it is not at 0%, there is nothing left to measure. A group with no relations at all does not appear as a row: it has nobody with work in this process. */
  progress_percentage?: Maybe<Scalars['Float']['output']>;
  /** The attribute's value. Collaborators with no value are grouped under «Sin asignar» instead of being dropped, so the groups still add up to the card above. */
  segment_value: Scalars['String']['output'];
  /** Evaluations assigned to this group, excluding cancelled ones: the denominator. */
  total_relations: Scalars['Int']['output'];
};

/** Data freshness mark for the Talent dashboard chip. */
export type AnalyticsTalentDashboardFreshness = {
  __typename?: 'AnalyticsTalentDashboardFreshness';
  /** Most recent ETL run across Talent sources, ISO 8601 UTC. */
  last_updated_at?: Maybe<Scalars['String']['output']>;
  /** Localized freshness label (e.g. '23 abr - 9:25am'). */
  last_updated_at_formatted?: Maybe<Scalars['String']['output']>;
};

/** The three blocking situations, the same ones the band's cards count. Used to drill from a card into the collaborators behind it. */
export enum AnalyticsTalentGoalBlockFilterEnum {
  NotApproved = 'NOT_APPROVED',
  WithoutGoals = 'WITHOUT_GOALS',
  WithoutSelfReport = 'WITHOUT_SELF_REPORT'
}

/** The three situations blocking the cycle, as counts of collaborators. */
export type AnalyticsTalentGoalBlocks = {
  __typename?: 'AnalyticsTalentGoalBlocks';
  /** Have goals loaded, but at least one is still not approved. */
  not_approved: Scalars['Int']['output'];
  /** Enrolled in the process but with no goal loaded at all. */
  without_goals: Scalars['Int']['output'];
  /** Have approved goals, but at least one has no self-report in the tracked cycle. */
  without_self_report: Scalars['Int']['output'];
};

/** One goal category with how many goals it holds and how much of it is being met. The unit here is the GOAL, not the person. */
export type AnalyticsTalentGoalCategory = {
  __typename?: 'AnalyticsTalentGoalCategory';
  /** Average result of the category's EVALUATED GOALS. The name says «goal» because the unit is the goal, not the person — the sibling cards' averages are per person and the two must not be read against each other. TWO reasons they differ, both deliberate: (1) this is a plain mean over goals while the band is a weighted mean over people; (2) the band and the distribution only count people whose goals are ALL evaluated, while here an evaluated goal counts even if its owner has others pending — so this card can show an average where the band reports zero evaluated collaborators. Null when no goal in the category has a result — not zero. */
  average_goal_result?: Maybe<Scalars['Float']['output']>;
  /** The strategy or approach name. Goals with none carry «Sin categoría» — a real group, not a discard: in the process we reconciled, «Enfoque» is empty on 100% of the rows, and dropping them would leave the card blank without saying why. */
  category: Scalars['String']['output'];
  /** Of those, how many carry a result from the boss. */
  evaluated_goals_count: Scalars['Int']['output'];
  /** Goals in this category, evaluated or not. */
  goals_count: Scalars['Int']['output'];
};

/** One collaborator's row in the goals tracking table. */
export type AnalyticsTalentGoalCollaboratorRow = {
  __typename?: 'AnalyticsTalentGoalCollaboratorRow';
  /** Área, from the centralized world. */
  area?: Maybe<Scalars['String']['output']>;
  /** Leader's name. Empty when the collaborator has none assigned. */
  boss_name?: Maybe<Scalars['String']['output']>;
  /** Furthest stage completed. */
  current_stage: AnalyticsTalentGoalCurrentStageEnum;
  /** Collaborator id in the Talent module. */
  employee_id: Scalars['Int']['output'];
  /** Collaborator name, from the centralized world. */
  full_name: Scalars['String']['output'];
  /** Goals approved. */
  goals_approved: Scalars['Int']['output'];
  /** Approved goals evaluated by the boss in the tracked cycle. */
  goals_boss_reported: Scalars['Int']['output'];
  /** Goals loaded. */
  goals_loaded: Scalars['Int']['output'];
  /** Approved goals with a self-report in the tracked cycle. Never greater than `goals_approved`: the report only measures reports over approved goals. */
  goals_self_reported: Scalars['Int']['output'];
  /** Sede, from the centralized world. */
  headquarter?: Maybe<Scalars['String']['output']>;
  /** Cargo, from the centralized world. */
  position?: Maybe<Scalars['String']['output']>;
  /** How far this person got, 0 to 1: stages completed over the four of the cycle. Same criterion as the group progress in the segment block. */
  progress_rate: Scalars['Float']['output'];
};

/** Furthest stage the collaborator completed. NONE means no goal loaded at all. A stage counts as completed only when ALL their goals reached it — the same rule as the band and the «Jefe Evaluó Todas» column of the report. */
export enum AnalyticsTalentGoalCurrentStageEnum {
  Approved = 'APPROVED',
  BossReported = 'BOSS_REPORTED',
  Loaded = 'LOADED',
  None = 'NONE',
  SelfReported = 'SELF_REPORTED'
}

/** One band of the scale with how many collaborators landed in it. The bounds and the name travel with the count so the chart labels each bar from the organization's own configuration. */
export type AnalyticsTalentGoalDistributionBand = {
  __typename?: 'AnalyticsTalentGoalDistributionBand';
  /** COLLABORATORS in this band — not goals. Bands with nobody travel with a zero instead of being omitted: a missing bar and an empty bar mean different things, and only one of them is true here. */
  collaborators_count: Scalars['Int']['output'];
  /** Position in the scale, ascending. Same index as the scale band. */
  index: Scalars['Int']['output'];
  /** True from «Esperado» upwards. */
  is_compliant: Scalars['Boolean']['output'];
  /** True on the lowest band that does not meet the threshold. */
  is_critical: Scalars['Boolean']['output'];
  /** The band's name: Muy Bajo · Bajo · Esperado · Alto · Excepcional. */
  label: Scalars['String']['output'];
  /** Exclusive lower bound. Null on the lowest band. */
  lower_bound?: Maybe<Scalars['Float']['output']>;
  /** Share of the EVALUATED collaborators, so the bars add up to 100. Null when nobody is evaluated — not zero. */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** Inclusive upper bound, or null for no ceiling. On the TOP band this is max_scale when it is above the band's floor, and results ABOVE it still count here — the scale is what the customer configured to display, not a ceiling on reality. When max_scale is not above that floor it travels NULL, for the same reason: the band has no ceiling the bucketing would enforce. */
  upper_bound?: Maybe<Scalars['Float']['output']>;
};

/** One leader's team in the goals cycle. */
export type AnalyticsTalentGoalLeaderRow = {
  __typename?: 'AnalyticsTalentGoalLeaderRow';
  /** Leader's centralized user id. NULL is the «no leader assigned» group — a real group of enrolled collaborators, not a filler row. It is null and not a sentinel on purpose: a magic zero collides with a real id of zero and silently hands that group's people to someone else. */
  leader_id?: Maybe<Scalars['Int']['output']>;
  /** Leader's name, from the centralized world. */
  leader_name: Scalars['String']['output'];
  /** …the approval stage. */
  pending_approved: Scalars['Int']['output'];
  /** …the boss evaluation. Usually the one to remind this leader about, with the same caveat as `stage_boss_reported`: the data does not say WHO evaluated, only that someone did. */
  pending_boss_reported: Scalars['Int']['output'];
  /** Team members who have NOT completed the loading stage. */
  pending_loaded: Scalars['Int']['output'];
  /** …the self-report stage. */
  pending_self_reported: Scalars['Int']['output'];
  /** How far this team got, 0 to 1: stages its people completed over the ones they could have (team × 4). Same criterion as the group progress in the segment block — two definitions of «progress» in one tab is what the golden rule punishes. */
  progress_rate: Scalars['Float']['output'];
  /** …got them all approved. */
  stage_approved: Scalars['Int']['output'];
  /** …had all their approved goals evaluated by a boss. NOT necessarily by THIS leader: the report's criterion only asks whether a boss evaluation exists, so a goal evaluated by a previous leader counts here too. */
  stage_boss_reported: Scalars['Int']['output'];
  /** Of them, how many loaded all their goals. */
  stage_loaded: Scalars['Int']['output'];
  /** …self-reported all their approved goals. */
  stage_self_reported: Scalars['Int']['output'];
  /** Collaborators of this leader enrolled in the process. */
  team_size: Scalars['Int']['output'];
};

/** One goal of a collaborator, as shown in the ranking's expandable row. */
export type AnalyticsTalentGoalRow = {
  __typename?: 'AnalyticsTalentGoalRow';
  /** Goal identifier. */
  goal_id: Scalars['Int']['output'];
  /** The goal's name. */
  goal_name?: Maybe<Scalars['String']['output']>;
  /** The goal's weight in the collaborator's result. Null when the goal carries no weight — which is exactly why its owner's result can look lower than expected; the report behaves the same way. */
  goal_weight?: Maybe<Scalars['Float']['output']>;
  /** The boss's result for this goal, normalized 0-100 — the «Progreso Jefe» column of the report, not its «Resultado», which carries the raw value in the goal's own unit. Null when not evaluated. */
  result?: Maybe<Scalars['Float']['output']>;
};

/** The scale the organization configured for this process. Its cuts are the process's limit_1..limit_4 and its top is max_scale — the same reading the Talent domain's performance queries already use, so both surfaces cannot disagree about the same configuration. */
export type AnalyticsTalentGoalScale = {
  __typename?: 'AnalyticsTalentGoalScale';
  /** Bands, ascending. Empty when the process configured no cuts. */
  bands: Array<AnalyticsTalentGoalScaleBand>;
  /** False when the process carries no cuts. Every figure that depends on the threshold then travels as null instead of zero. */
  is_configured: Scalars['Boolean']['output'];
  /** Top of the scale as the organization configured it (may exceed 100). Null when not configured. NOT a ceiling on results — and not necessarily the top band's upper_bound: when this value is not above that band's floor, the band travels with a null upper_bound because the interval would be empty. Read the band's own bounds to label it; read this only for the configured scale. */
  max_scale?: Maybe<Scalars['Float']['output']>;
};

/** One band of the organization's scale, with its name and its bounds. The bounds travel so the UI can build its tooltips from the process configuration instead of hardcoding «below 60%» — the same indicator reads differently in two organizations. */
export type AnalyticsTalentGoalScaleBand = {
  __typename?: 'AnalyticsTalentGoalScaleBand';
  /** Position in the scale, ascending. 0 is the lowest band. */
  index: Scalars['Int']['output'];
  /** True from «Esperado» upwards — the compliance threshold. */
  is_compliant: Scalars['Boolean']['output'];
  /** True on the lowest band — the alert card counts it. */
  is_critical: Scalars['Boolean']['output'];
  /** The band's name, shared with the `performance_distribution` query of the Talent domain: Muy Bajo · Bajo · Esperado · Alto · Excepcional. Fixed on purpose — the threshold is a NAME, not a position, so it means the same thing in every organization. */
  label: Scalars['String']['output'];
  /** Exclusive lower bound. Null on the lowest band (no floor). */
  lower_bound?: Maybe<Scalars['Float']['output']>;
  /** Inclusive upper bound, or null for no ceiling. The TOP band carries the process's max_scale only when it is actually above the band's floor — which may exceed 100, results are never clamped. When the organization set max_scale at or below that floor, this travels NULL: the bucketing leaves the top band open, so publishing that value would declare a ceiling the calculation does not apply. */
  upper_bound?: Maybe<Scalars['Float']['output']>;
};

/** One stage of the goals cycle and how far it got. */
export type AnalyticsTalentGoalStage = {
  __typename?: 'AnalyticsTalentGoalStage';
  /** Collaborators who completed the stage. A collaborator completes a stage when ALL their goals reached it — the same rule the «Estado seguimiento de metas» report uses for its «Jefe Evaluó Todas» column, never 'at least one'. */
  completed_count: Scalars['Int']['output'];
  /** Enrolled collaborators who have not completed the stage yet. */
  pending_count: Scalars['Int']['output'];
  /** Which stage of the cycle this row measures. */
  stage: AnalyticsTalentGoalStageEnum;
};

/** Stages of the goals cycle, in order. The data model has no per-process stage catalog — these four are structural columns of the goals tables, so the set is fixed and the FE owns the labels. */
export enum AnalyticsTalentGoalStageEnum {
  Approved = 'APPROVED',
  BossReported = 'BOSS_REPORTED',
  Loaded = 'LOADED',
  SelfReported = 'SELF_REPORTED'
}

/** The tracking cycle the band is measured against. The goals model has no tracks table, so the backend picks the cycle in force (falling back to the most recent) and reports it here for the FE to label. */
export type AnalyticsTalentGoalTrack = {
  __typename?: 'AnalyticsTalentGoalTrack';
  /** Cycle scheduled end date, ISO 8601 (YYYY-MM-DD). */
  end_date?: Maybe<Scalars['String']['output']>;
  /** True when today falls inside the cycle window. False means the cycle already closed and this is the most recent one available. */
  is_in_force: Scalars['Boolean']['output'];
  /** Cycle start date, ISO 8601 (YYYY-MM-DD). */
  start_date?: Maybe<Scalars['String']['output']>;
  /** Identifier of the tracking cycle used for the report stages. */
  track_id: Scalars['String']['output'];
  /** Cycle name as configured by the organization. */
  track_name?: Maybe<Scalars['String']['output']>;
};

/** Compliance by goal category (M-R4): answers whether the problem is in the goals themselves rather than in the people. Strategies and approaches travel as two separate lists because they are two different cuts of the same goals — mixing them would double-count. */
export type AnalyticsTalentGoalsByCategory = {
  __typename?: 'AnalyticsTalentGoalsByCategory';
  /** Cut by «Enfoque», worst average first. */
  approaches: Array<AnalyticsTalentGoalCategory>;
  /** ORG_UNAVAILABLE / INVALID_INPUT / INTERNAL_ERROR. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the underlying data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** False when the organization has no Performance module. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** Cut by «Meta Estratégica», worst average first. */
  strategies: Array<AnalyticsTalentGoalCategory>;
  /** Approaches before the cap. */
  total_approaches: Scalars['Int']['output'];
  /** Strategies before the cap, so the UI can say «50 of N». */
  total_strategies: Scalars['Int']['output'];
  /** The closing cycle these results belong to. */
  track?: Maybe<AnalyticsTalentGoalTrack>;
  /** Goals of this process that the card leaves OUT because their owner has no active record in the centralized users table. The downloadable report does include them — collapsed into its unnamed row, 170 of 623 in the process we reconciled — so a customer pivoting the Excel by «Meta Estratégica» will get bigger counts than this card. The difference is stated here instead of showing up as an unexplained mismatch. */
  uncovered_goals_count: Scalars['Int']['output'];
};

/** Input for the compliance cut by goal category (ANLT-612). Same shape as the other blocks of the tab so the screen reads one process and one cycle everywhere. */
export type AnalyticsTalentGoalsByCategoryInput = {
  /** Centralized organization ID the process belongs to. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional tracking cycle. Leave it out: v1 always reads the process's closing cycle. */
  goal_track_id?: InputMaybe<Scalars['Int']['input']>;
  /** Goals process identifier from the process catalog. It is a STRING — do not parse or cast it. */
  process_id: Scalars['String']['input'];
};

/** How much of the enrolled population actually has a result, and how many collaborators the dashboard could not cover. */
export type AnalyticsTalentGoalsCoverage = {
  __typename?: 'AnalyticsTalentGoalsCoverage';
  /** evaluated / enrolled, as a percentage. Null when nobody is enrolled — there is no coverage to report, and 0 would read as «nobody was evaluated». */
  coverage_percentage?: Maybe<Scalars['Float']['output']>;
  /** Collaborators reached by the process and active in the org. */
  enrolled_count: Scalars['Int']['output'];
  /** Of those, how many have a result from their boss. */
  evaluated_count: Scalars['Int']['output'];
  /** Collaborators WITH goals in this process that the dashboard cannot show, because they have no active record in the centralized users table. They are excluded on purpose — in the downloadable report they do not disappear, they collapse into a single unnamed row that sums all of them, which can inflate the figure without bound. This number exists so that exclusion is stated instead of silently widening the gap against the report. */
  uncovered_count: Scalars['Int']['output'];
};

/** Goals cycle progress for one process: how far each stage got and what is blocking it. Collaborators never included in the process are excluded from every count — they do not count as zero progress. */
export type AnalyticsTalentGoalsCycleProgress = {
  __typename?: 'AnalyticsTalentGoalsCycleProgress';
  /** The three blocking situations. */
  blocks?: Maybe<AnalyticsTalentGoalBlocks>;
  /** Collaborators reached by the process who are active members of the organization. The denominator of every stage. */
  enrolled_count: Scalars['Int']['output'];
  /** ORG_UNAVAILABLE (organization cannot be served — the specific reason is deliberately not disclosed), INVALID_INPUT, INTERNAL_ERROR. Null on success; an all-zero band for a process nobody started is success, not an error. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the Talent source data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** Whether the session has the Performance product. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** The four stages of the cycle, in order. */
  stages: Array<AnalyticsTalentGoalStage>;
  /** Tracking cycle used for the self-report and boss-report stages. Null when the process has no tracking cycle yet — those two stages then read zero. */
  track?: Maybe<AnalyticsTalentGoalTrack>;
};

/** Input for the goals cycle progress band. The process comes from get_talent_process_catalog; pass its process_id verbatim. */
export type AnalyticsTalentGoalsCycleProgressInput = {
  /** Centralized organization ID the process belongs to. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Goals process identifier as returned by the process catalog. It is a STRING (goals use composite ids) — do not parse or cast it. */
  process_id: Scalars['String']['input'];
};

/** Paged collaborator detail for a goals process: each person's current stage, progress and leader. Page, order and search are resolved on the server — organizations have thousands of collaborators. */
export type AnalyticsTalentGoalsDetail = {
  __typename?: 'AnalyticsTalentGoalsDetail';
  /** ORG_UNAVAILABLE (organization cannot be served — the reason is deliberately not disclosed), INVALID_INPUT, INTERNAL_ERROR. Null on success; an empty page is success, not an error. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the Talent source data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** True when more rows exist beyond this page. */
  has_more: Scalars['Boolean']['output'];
  /** Whether the session has the Performance product. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** Opaque cursor for the next page: send it back as `pagination.after`. Null when there is nothing more. Without this the client could not request page 2 at all — the cursor format is internal and must not be reconstructed by hand. */
  next_cursor?: Maybe<Scalars['String']['output']>;
  /** The requested page, already ordered and filtered. */
  rows: Array<AnalyticsTalentGoalCollaboratorRow>;
  /** Collaborators matching the SAME filters as this page. Computed with the identical predicates, so the count and the rows can never disagree. */
  total_count: Scalars['Int']['output'];
};

/** Input del detalle por colaborador. El filtro por situación de bloqueo es el que usa el frontend para bajar desde las tarjetas de la banda. */
export type AnalyticsTalentGoalsDetailInput = {
  /** Devuelve solo los colaboradores en esa situación de bloqueo. Sin filtro, devuelve a todos los inscritos. */
  block?: InputMaybe<AnalyticsTalentGoalBlockFilterEnum>;
  /** Organización centralizada dueña del proceso. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Página pedida. */
  pagination?: InputMaybe<AnalyticsTalentGoalsDetailPaginationInput>;
  /** Identificador del proceso de metas, tal como lo devuelve el catálogo. Es un STRING — no parsearlo ni castearlo. */
  process_id: Scalars['String']['input'];
  /** Búsqueda por nombre. */
  search?: InputMaybe<AnalyticsTalentGoalsDetailSearchInput>;
  /** Orden de la tabla. */
  sort?: InputMaybe<AnalyticsTalentGoalsDetailSortInput>;
};

/** Página pedida, con cursor opaco. */
export type AnalyticsTalentGoalsDetailPaginationInput = {
  /** Cursor de la última fila de la página anterior. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Filas por página. Por omisión 20, tope 100. */
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Búsqueda por nombre del colaborador. */
export type AnalyticsTalentGoalsDetailSearchInput = {
  /** Texto a buscar en el nombre. Se escapa antes de llegar al SQL. */
  query: Scalars['String']['input'];
};

/** Orden de la tabla, por columna y dirección. */
export type AnalyticsTalentGoalsDetailSortInput = {
  /** asc o desc. Por omisión asc, igual que la tabla sin orden explícito: pedir una columna sin dirección no debería invertir el sentido respecto de no pedir nada. */
  direction?: InputMaybe<Scalars['String']['input']>;
  /** Columna: full_name, area, headquarter, position o boss_name. Cualquier otro valor usa el orden por omisión (nombre ascendente). */
  field: Scalars['String']['input'];
};

/** Follow-up discipline (M-R5): who kept the tracking ritual, told apart from how well they scored. It is deliberately NOT the report's «Jefe Evaluó Todas» column — see up_to_date_count. */
export type AnalyticsTalentGoalsDiscipline = {
  __typename?: 'AnalyticsTalentGoalsDiscipline';
  /** Attributes this organization can group by — the shared catalog. */
  available_attributes: Array<AnalyticsTalentSegmentAttributeOption>;
  /** up_to_date over the collaborators who had goals to report, as a percentage. Null when nobody had any. */
  discipline_percentage?: Maybe<Scalars['Float']['output']>;
  /** Collaborators enrolled in the process and active in the org. Null when no cycle has come due yet: the block reads nothing in that case, and a zero would read as «nobody is enrolled». */
  enrolled_count?: Maybe<Scalars['Int']['output']>;
  /** ORG_UNAVAILABLE / INVALID_INPUT / INTERNAL_ERROR. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the underlying data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** Discipline by group, worst first. Empty when there is no ritual. */
  groups: Array<AnalyticsTalentGoalsDisciplineGroup>;
  /** False when the organization has no Performance module. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** Cycles of this process that have already started, counted from the activity recorded against them — the Talent model has no cycle table, so this is OBSERVED, not read from configuration. Each process is measured against its own count, never a fixed one. Zero means no cycle has come due, and every discipline figure travels null. Cycles that start in the future are excluded on purpose: requiring a report for them would drop the whole organization's discipline to zero the day someone schedules the next cycle. */
  observed_tracks: Scalars['Int']['output'];
  /** Enrolled collaborators who HAD goals to report and still owe some follow-up. Null for the same reason as up_to_date_count. */
  pending_count?: Maybe<Scalars['Int']['output']>;
  /** The attribute actually used, echoed back. */
  selected_attribute_key?: Maybe<Scalars['String']['output']>;
  /** Groups before the cap, so the UI can say «50 of N». */
  total_groups: Scalars['Int']['output'];
  /** Collaborators who SELF-REPORTED every approved goal in every cycle already under way. This is NOT the report's «Jefe Evaluó Todas» column: that one compares the BOSS's reports against the goal count, so it says «complies» for people who never self-assessed even once. Null when no cycle has come due — then there is no ritual to have kept, and a zero would read as «nobody did it». */
  up_to_date_count?: Maybe<Scalars['Int']['output']>;
  /** Enrolled collaborators with NO approved goal: they had nothing to report, so they count as neither up to date nor pending. Reported apart so «did not load goals» is never read as «did not keep the ritual» — two different problems needing two different actions. */
  without_goals_count?: Maybe<Scalars['Int']['output']>;
};

/** One group's follow-up discipline: how many of its collaborators kept the ritual through the whole process. */
export type AnalyticsTalentGoalsDisciplineGroup = {
  __typename?: 'AnalyticsTalentGoalsDisciplineGroup';
  /** up_to_date over the collaborators who DID have goals to report, as a percentage. Null when nobody in the group had any — not zero. */
  discipline_percentage?: Maybe<Scalars['Float']['output']>;
  /** Collaborators of the group enrolled in the process. */
  enrolled_count: Scalars['Int']['output'];
  /** The group's value; «Sin asignar» when the attribute is empty. */
  segment_value: Scalars['String']['output'];
  /** Of those, how many self-reported every goal in every cycle. */
  up_to_date_count: Scalars['Int']['output'];
  /** Collaborators of the group with no approved goal at all: they had nothing to report, so they are neither up to date nor pending. */
  without_goals_count: Scalars['Int']['output'];
};

/** Input for the follow-up discipline block (ANLT-616). The attribute key comes from the same shared catalog as the other cuts. */
export type AnalyticsTalentGoalsDisciplineInput = {
  /** Attribute to group the discipline by: AREA, DEPARTMENT, POSITION, HEADQUARTER or `custom_<field_id>`. Defaults to POSITION (Cargo). An unknown key is rejected with INVALID_INPUT instead of silently falling back. */
  attribute_key?: InputMaybe<Scalars['String']['input']>;
  /** Centralized organization ID the process belongs to. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Maximum groups returned, worst first. Defaults to 50, capped at 100 — the list is never unbounded. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Goals process identifier from the process catalog. It is a STRING — do not parse or cast it. */
  process_id: Scalars['String']['input'];
};

/** Distribution of collaborators across the configured scale (M-R2). Answers whether the headline average is hiding extremes. */
export type AnalyticsTalentGoalsDistribution = {
  __typename?: 'AnalyticsTalentGoalsDistribution';
  /** Every configured band, ascending, including the empty ones. Empty when the process has no configured scale. */
  bands: Array<AnalyticsTalentGoalDistributionBand>;
  /** ORG_UNAVAILABLE / INVALID_INPUT / INTERNAL_ERROR. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Collaborators the bands add up to. It is the SAME number the results band reports, on purpose: the chart and the card above it cannot disagree about who was measured. */
  evaluated_count: Scalars['Int']['output'];
  /** When the underlying data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** False when the organization has no Performance module. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** False when the process carries no cuts. There are no bands to draw and no distribution to read — the UI shows that, not an empty chart. */
  is_scale_configured: Scalars['Boolean']['output'];
  /** The closing cycle these results belong to. */
  track?: Maybe<AnalyticsTalentGoalTrack>;
  /** Enrolled collaborators with no result in the closing cycle. They are NOT a band of the scale and must never be drawn as one — «not measured» is not «scored zero». Reported so that bands + this adds up to the enrolled population instead of quietly falling short. */
  without_result_count: Scalars['Int']['output'];
};

/** Input for the compliance distribution (ANLT-611). Same shape as the results band on purpose: the two blocks of the tab read the same process and the same cycle, so the screen cannot ask them different questions by accident. */
export type AnalyticsTalentGoalsDistributionInput = {
  /** Centralized organization ID the process belongs to. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional tracking cycle. Leave it out: v1 always reads the process's closing cycle and exposes no selector. */
  goal_track_id?: InputMaybe<Scalars['Int']['input']>;
  /** Goals process identifier as returned by the process catalog. It is a STRING (goals use composite ids) — do not parse or cast it. */
  process_id: Scalars['String']['input'];
};

/**
 * Day-by-day progress of a goals cycle.
 *
 * IMPORTANT — only two of the four stages can be drawn. `talent_goals` carries no date at all (neither creation nor approval) and `state` is a current value with no history, so «loaded» and «approved» have no point in time to place them at. They are named in `stages_without_date_source` so the client does NOT draw a flat line and pass it off as history: those stages are unknown, not zero.
 */
export type AnalyticsTalentGoalsEvolution = {
  __typename?: 'AnalyticsTalentGoalsEvolution';
  /** Completed AFTER `series_last_day` — filing a report after the cycle closed is common in performance reviews and is nobody's error, but the curve cannot show it. The band above does count them, so this is what makes both numbers agree. */
  completed_after_the_curve?: Maybe<AnalyticsTalentGoalsEvolutionUndated>;
  /** Completed the stage, but the data does not say WHEN — a source problem, worth surfacing to whoever owns the pipeline. */
  completed_without_date?: Maybe<AnalyticsTalentGoalsEvolutionUndated>;
  /** ORG_UNAVAILABLE (organization cannot be served — the reason is deliberately not disclosed), INVALID_INPUT, INTERNAL_ERROR. Null on success; a process with no window yet is success with no points. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the Talent source data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** Whether the session has the Performance product. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** One point per day of the process window, in order. */
  points: Array<AnalyticsTalentGoalsEvolutionPoint>;
  /** Last day of the window (ISO 8601). */
  process_end_date?: Maybe<Scalars['String']['output']>;
  /** First day of the window (ISO 8601). */
  process_start_date?: Maybe<Scalars['String']['output']>;
  /** Last day actually drawn. It is `today` for an open process (days that have not happened must not be drawn as a flat line) and `process_end_date` for a closed one — unless the point cap cut it shorter, which `series_truncated` reports. */
  series_last_day?: Maybe<Scalars['String']['output']>;
  /** True ONLY when the point cap cut the curve short — never for the normal case of an open process ending at today (`series_last_day` already says where the curve ends). Say so in the UI: a truncated curve looks complete, so without this the client would show a process as ending a year before it does. */
  series_truncated: Scalars['Boolean']['output'];
  /** Stages that cannot be drawn because the data has no date for them. Today: LOADED and APPROVED. */
  stages_without_date_source: Array<Scalars['String']['output']>;
  /** Today in the organization's own date, so the client can mark it on the timeline without guessing the timezone. */
  today?: Maybe<Scalars['String']['output']>;
};

/** Input for the cycle evolution curve. The process comes from get_talent_process_catalog; pass its process_id verbatim. */
export type AnalyticsTalentGoalsEvolutionInput = {
  /** Centralized organization ID the process belongs to. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Goals process identifier as returned by the process catalog. It is a STRING (goals use composite ids) — do not parse or cast it. */
  process_id: Scalars['String']['input'];
};

/** One day of the cycle, with the running totals so far. */
export type AnalyticsTalentGoalsEvolutionPoint = {
  __typename?: 'AnalyticsTalentGoalsEvolutionPoint';
  /** Same, for goals evaluated by the leader. */
  boss_reported_total: Scalars['Int']['output'];
  /** The date, ISO 8601 (YYYY-MM-DD). */
  day: Scalars['String']['output'];
  /** Collaborators who had ALL their approved goals self-reported by this day. Running total: it can never go down, because it counts facts that already happened. */
  self_reported_total: Scalars['Int']['output'];
};

/**
 * Collaborators who completed a stage but are NOT on the curve. Reported instead of dropped: without this the last point could close at 40 while the band above says 59, and nobody could tell why.
 *
 * The reconciliation is exact: `last point + completed_without_date + completed_after_the_curve == the band's count for that stage`.
 */
export type AnalyticsTalentGoalsEvolutionUndated = {
  __typename?: 'AnalyticsTalentGoalsEvolutionUndated';
  /** Sin fecha de reporte del líder. */
  boss_reported: Scalars['Int']['output'];
  /** Sin fecha de auto-reporte. */
  self_reported: Scalars['Int']['output'];
};

/**
 * Paged leader detail for a goals process: whose team is on track and whose is holding the cycle back. Page, order and search are resolved on the server.
 *
 * Reconciliation, which is what makes this table verifiable: the sum of `team_size` across ALL pages equals the band's enrolled count, and the same holds stage by stage. That only works because collaborators with no leader on record form their own group instead of vanishing.
 */
export type AnalyticsTalentGoalsLeaders = {
  __typename?: 'AnalyticsTalentGoalsLeaders';
  /** ORG_UNAVAILABLE (organization cannot be served — the reason is deliberately not disclosed), INVALID_INPUT, INTERNAL_ERROR. Null on success; an empty page is success, not an error. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the Talent source data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** True when more rows exist beyond this page. */
  has_more: Scalars['Boolean']['output'];
  /** Whether the session has the Performance product. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** Opaque cursor for the next page: send it back as `pagination.after`. Null when there is nothing more. */
  next_cursor?: Maybe<Scalars['String']['output']>;
  /** The requested page, already ordered and filtered. */
  rows: Array<AnalyticsTalentGoalLeaderRow>;
  /** Leaders matching the SAME filters as this page, computed with identical predicates so the count and the rows can never disagree. */
  total_count: Scalars['Int']['output'];
};

/** Input del avance por líder. */
export type AnalyticsTalentGoalsLeadersInput = {
  /** Organización centralizada dueña del proceso. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Página pedida. */
  pagination?: InputMaybe<AnalyticsTalentGoalsLeadersPaginationInput>;
  /** Identificador del proceso de metas, tal como lo devuelve el catálogo. Es un STRING — no parsearlo ni castearlo. */
  process_id: Scalars['String']['input'];
  /** Búsqueda por nombre del líder. */
  search?: InputMaybe<AnalyticsTalentGoalsLeadersSearchInput>;
  /** Orden de la tabla. */
  sort?: InputMaybe<AnalyticsTalentGoalsLeadersSortInput>;
};

/** Página pedida, con cursor opaco. */
export type AnalyticsTalentGoalsLeadersPaginationInput = {
  /** Cursor de la última fila de la página anterior. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Filas por página. Por omisión 20, tope 100. */
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Búsqueda por nombre del líder. */
export type AnalyticsTalentGoalsLeadersSearchInput = {
  /** Texto a buscar en el nombre. Se escapa antes de llegar al SQL. */
  query: Scalars['String']['input'];
};

/** Orden de la tabla, por columna y dirección. */
export type AnalyticsTalentGoalsLeadersSortInput = {
  /** asc o desc. Por omisión asc. */
  direction?: InputMaybe<Scalars['String']['input']>;
  /** Columna: leader_name, team_size o progress_rate. Cualquier otro valor usa el orden por omisión (avance ascendente: el equipo más atrasado primero). */
  field: Scalars['String']['input'];
};

/** Goals cycle progress cut by a collaborator attribute, worst group first so what needs attention is on top. Carries its own attribute selector. */
export type AnalyticsTalentGoalsProgressBySegment = {
  __typename?: 'AnalyticsTalentGoalsProgressBySegment';
  /** Attributes this organization can group by: the standard ones plus the custom fields it configured. All of them come from the centralized world, where the collaborator's organizational data lives. */
  available_attributes: Array<AnalyticsTalentSegmentAttributeOption>;
  /** ORG_UNAVAILABLE (organization cannot be served — the reason is deliberately not disclosed), INVALID_INPUT (missing process, or an attribute this organization does not have), INTERNAL_ERROR. Null on success; a process nobody started returns empty groups, not an error. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the Talent source data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** True when more groups exist than were returned. */
  has_more: Scalars['Boolean']['output'];
  /** Whether the session has the Performance product. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** Groups, ordered worst progress first. */
  segments: Array<AnalyticsTalentGoalsSegmentRow>;
  /** The attribute actually used for `segments` (defaults to POSITION). */
  selected_attribute_key?: Maybe<Scalars['String']['output']>;
  /** Groups the attribute has BEFORE the page limit. Compare with the length of `segments` to know whether the list was truncated — relevant for high-cardinality attributes such as Cargo. */
  total_groups: Scalars['Int']['output'];
};

/** Input for the goals progress by segment block. The attribute comes from `available_attributes` of a previous call; omit it to get the default cut. */
export type AnalyticsTalentGoalsProgressBySegmentInput = {
  /** Attribute to group by: AREA, DEPARTMENT, POSITION, HEADQUARTER, or `custom_<field_id>`. Defaults to POSITION (Cargo) — the published description said DEPARTMENT and the code has always applied POSITION (`_DEFAULT_ATTRIBUTE`); the contract now says what it does. An unknown key is rejected with INVALID_INPUT rather than silently falling back, so a mis-wired selector never shows a cut the admin did not ask for. */
  attribute_key?: InputMaybe<Scalars['String']['input']>;
  /** Centralized organization ID the process belongs to. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Maximum groups returned, worst first. Defaults to 50, capped at 100 — the list is never unbounded. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Goals process identifier from the process catalog. It is a STRING — do not parse or cast it. */
  process_id: Scalars['String']['input'];
};

/** Paged collaborator ranking for a closed goals process (M-R6). Order, search and paging are resolved on the server — organizations have thousands of collaborators. */
export type AnalyticsTalentGoalsRanking = {
  __typename?: 'AnalyticsTalentGoalsRanking';
  /** ORG_UNAVAILABLE / INVALID_INPUT / INTERNAL_ERROR. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the underlying data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** True when more rows exist beyond this page. */
  has_more: Scalars['Boolean']['output'];
  /** False when the organization has no Performance module. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** Opaque cursor for the next page: send it back as `pagination.after`. */
  next_cursor?: Maybe<Scalars['String']['output']>;
  /** The requested page, already ordered and filtered. */
  rows: Array<AnalyticsTalentGoalsRankingRow>;
  /** The organization's configured scale, to label the bands. */
  scale?: Maybe<AnalyticsTalentGoalScale>;
  /** Collaborators matching the SAME filters as this page, computed with the identical predicates so the count and the rows cannot disagree. */
  total_count: Scalars['Int']['output'];
  /** The closing cycle these results belong to. */
  track?: Maybe<AnalyticsTalentGoalTrack>;
};

/** Input del ranking de colaboradores (ANLT-619). El orden, la búsqueda y la página se resuelven en el servidor. */
export type AnalyticsTalentGoalsRankingInput = {
  /** Centralized organization ID the process belongs to. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional cycle; v1 always reads the process's closing cycle. */
  goal_track_id?: InputMaybe<Scalars['Int']['input']>;
  /** Página pedida. */
  pagination?: InputMaybe<AnalyticsTalentGoalsRankingPaginationInput>;
  /** Goals process identifier from the process catalog. It is a STRING — do not parse or cast it. */
  process_id: Scalars['String']['input'];
  /** Búsqueda por nombre. */
  search?: InputMaybe<AnalyticsTalentGoalsRankingSearchInput>;
  /** Orden de la tabla. */
  sort?: InputMaybe<AnalyticsTalentGoalsRankingSortInput>;
};

/** Página pedida, con cursor opaco. */
export type AnalyticsTalentGoalsRankingPaginationInput = {
  /** Cursor de la última fila de la página anterior. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Filas por página. Por omisión 20, tope 100. */
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** One row of the ranking: a collaborator and where they landed. */
export type AnalyticsTalentGoalsRankingRow = {
  __typename?: 'AnalyticsTalentGoalsRankingRow';
  /** Area. */
  area?: Maybe<Scalars['String']['output']>;
  /** Index of the scale band, matching the distribution's bands. */
  band_index?: Maybe<Scalars['Int']['output']>;
  /** The band's name (Muy Bajo · Bajo · Esperado · Alto · Excepcional). Null when the collaborator has no result or the process configured no scale — the UI shows «sin evaluar», never the lowest band. */
  band_label?: Maybe<Scalars['String']['output']>;
  /** Leader. */
  boss_name?: Maybe<Scalars['String']['output']>;
  /** Collaborator identifier. */
  employee_id: Scalars['Int']['output'];
  /** Name. */
  full_name?: Maybe<Scalars['String']['output']>;
  /** Site. */
  headquarter?: Maybe<Scalars['String']['output']>;
  /** Position. */
  position?: Maybe<Scalars['String']['output']>;
  /** The collaborator's weighted result — the same number the band averages and «Resultado individual por seguimiento» prints. Null when they are enrolled but not evaluated: null is not zero, and a zero here would sort them among the worst performers. */
  result?: Maybe<Scalars['Float']['output']>;
};

/** Búsqueda por nombre del colaborador. */
export type AnalyticsTalentGoalsRankingSearchInput = {
  /** Texto a buscar en el nombre. Se escapa antes de llegar al SQL. */
  query: Scalars['String']['input'];
};

/** Orden de la tabla, por columna y dirección. */
export type AnalyticsTalentGoalsRankingSortInput = {
  /** asc o desc. Por omisión asc, igual que la tabla sin orden. */
  direction?: InputMaybe<Scalars['String']['input']>;
  /** Columna: result, full_name, area, headquarter, position o boss_name. Cualquier otro valor usa el orden por omisión (cumplimiento ascendente: lo urgente arriba). */
  field: Scalars['String']['input'];
};

/** Results band of a goals process (M-R1). The official figure and the plain average travel side by side so the difference is visible. */
export type AnalyticsTalentGoalsResults = {
  __typename?: 'AnalyticsTalentGoalsResults';
  /** Plain average ACROSS evaluated collaborators of their individual results — each individual result being the weighted sum of their goals, as «Resultado individual por seguimiento» computes it. It is NOT the same number a user gets by averaging that report's column: the report also lists collaborators this dashboard excludes (see coverage.uncovered_count), so the two can differ noticeably. Shown next to the official figure, never instead of it. Null when nobody is evaluated. */
  average_compliance?: Maybe<Scalars['Float']['output']>;
  /** Evaluated collaborators at «Esperado» or above. NULL — not zero — when the process has no configured scale: without a threshold there is nothing to have met, and a zero would read as «nobody complied». */
  compliant_count?: Maybe<Scalars['Int']['output']>;
  /** Enrolled vs evaluated, plus the collaborators left uncovered. */
  coverage?: Maybe<AnalyticsTalentGoalsCoverage>;
  /** Evaluated collaborators in the lowest band. NULL when the process has no configured scale, for the same reason as compliant_count. */
  critical_count?: Maybe<Scalars['Int']['output']>;
  /** ORG_UNAVAILABLE / INVALID_INPUT / INTERNAL_ERROR. Never a silent zero: the Learning tab's «all zeros, no reason» failure mode. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the underlying data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** False when the organization has no Performance module. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** THE official figure: percentage of evaluated collaborators who reached the configured threshold. It is NOT the average of their results — the average moves with a single anomalous row, this does not. Null when the process has no configured scale. */
  official_compliance?: Maybe<Scalars['Float']['output']>;
  /** The organization's configured scale for this process. */
  scale?: Maybe<AnalyticsTalentGoalScale>;
  /** The tracking cycle these results belong to. Results always read the process's closing cycle; the dashboard exposes no selector in v1, so the chosen cycle travels back for the UI to label. */
  track?: Maybe<AnalyticsTalentGoalTrack>;
};

/** Compliance by group (M-R3): every group's full distribution plus its average, so a low area can be told apart from an area with a couple of low cases. */
export type AnalyticsTalentGoalsResultsBySegment = {
  __typename?: 'AnalyticsTalentGoalsResultsBySegment';
  /** Attributes this organization can group by — the same catalog the Seguimiento cut publishes, read from the centralized world. */
  available_attributes: Array<AnalyticsTalentSegmentAttributeOption>;
  /** ORG_UNAVAILABLE / INVALID_INPUT / INTERNAL_ERROR. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the underlying data was last refreshed. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** Groups, worst average first; groups with nobody evaluated last. */
  groups: Array<AnalyticsTalentGoalsSegmentResults>;
  /** False when the organization has no Performance module. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** False when the process has no cuts: there is no distribution. */
  is_scale_configured: Scalars['Boolean']['output'];
  /** The attribute actually used, echoed back so the UI labels it. */
  selected_attribute_key?: Maybe<Scalars['String']['output']>;
  /** How many groups exist before the cap, so the UI can say «50 of N» instead of truncating silently. */
  total_groups: Scalars['Int']['output'];
  /** The closing cycle these results belong to. */
  track?: Maybe<AnalyticsTalentGoalTrack>;
};

/** Input for the compliance cut by group (ANLT-613). The attribute key comes from `available_attributes` of a previous call — the same catalog the Seguimiento cut uses, so both tabs offer the same attributes and cannot disagree about what «área» means. */
export type AnalyticsTalentGoalsResultsBySegmentInput = {
  /** Attribute to group by: AREA, DEPARTMENT, POSITION, HEADQUARTER or `custom_<field_id>`. Defaults to POSITION (Cargo), the same default the Seguimiento cut applies. An unknown key is rejected with INVALID_INPUT instead of silently falling back — a mis-wired selector would otherwise show a cut nobody asked for, and it would look perfectly credible. */
  attribute_key?: InputMaybe<Scalars['String']['input']>;
  /** Centralized organization ID the process belongs to. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional tracking cycle. Leave it out: v1 always reads the process's closing cycle. */
  goal_track_id?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum groups returned, worst first. Defaults to 50, capped at 100 — the list is never unbounded. The real total travels in total_groups so the UI can say «50 of N». */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Goals process identifier from the process catalog. It is a STRING — do not parse or cast it. */
  process_id: Scalars['String']['input'];
};

/** Input for the goals results band. The process comes from get_talent_process_catalog; pass its process_id verbatim. */
export type AnalyticsTalentGoalsResultsInput = {
  /** Centralized organization ID the process belongs to. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional tracking cycle. Leave it out: v1 always reads the process's closing cycle and exposes no selector. The parameter exists so adding that selector later does not break this contract. */
  goal_track_id?: InputMaybe<Scalars['Int']['input']>;
  /** Goals process identifier as returned by the process catalog. It is a STRING (goals use composite ids) — do not parse or cast it. */
  process_id: Scalars['String']['input'];
};

/** One group of the cut with its full distribution — not just its average. The average alone hides the dispersion, which is exactly what this block exists to show: whether an area is low because of everyone or because of a couple of cases. */
export type AnalyticsTalentGoalsSegmentResults = {
  __typename?: 'AnalyticsTalentGoalsSegmentResults';
  /** Weighted average of the group's evaluated collaborators. Null — not zero — when nobody in the group was evaluated. */
  average_result?: Maybe<Scalars['Float']['output']>;
  /** The group's distribution, same bands as the overall chart. */
  bands: Array<AnalyticsTalentGoalDistributionBand>;
  /** Of those, how many have a result. The bands add up to this. */
  evaluated_count: Scalars['Int']['output'];
  /** Collaborators enrolled in the process within this group, evaluated or not. Small groups are NOT hidden (AC-2): hiding them would make the groups stop adding up to the enrolled population. */
  group_total: Scalars['Int']['output'];
  /** The group's value. Collaborators with no value carry «Sin asignar» — a real group, not a discard: if 40% of the org has no area on file, that is what the admin needs to see. */
  segment_value: Scalars['String']['output'];
  /** Enrolled in this group with no result. Never a band. */
  without_result_count: Scalars['Int']['output'];
};

/** One group of the chosen attribute and how far it got. */
export type AnalyticsTalentGoalsSegmentRow = {
  __typename?: 'AnalyticsTalentGoalsSegmentRow';
  /** Collaborators of this group enrolled in the process. Each collaborator counts in EXACTLY ONE group: when the organization has several rows or several active answers for the same person, the alphabetically first value wins, deterministically. Otherwise the groups would add up to more than the band above. */
  enrolled_count: Scalars['Int']['output'];
  /** How far the group got, 0 to 1: stages completed divided by (enrolled × 4). Not «% of the last stage», which reads zero for everyone during the early weeks of a cycle and would make the worst-first ordering meaningless. */
  progress_rate: Scalars['Float']['output'];
  /** Value of the attribute for this group. Collaborators with no value loaded are grouped under «Sin asignar» — they are a real group, not a discard: if a third of the organization has no branch office set, that is precisely what the admin needs to see. */
  segment_value: Scalars['String']['output'];
  /** The same four stages as the band, for this group only. */
  stages: Array<AnalyticsTalentGoalStage>;
};

/** Talent module a dashboard tab reads from. */
export enum AnalyticsTalentModuleEnum {
  Competencies = 'COMPETENCIES',
  Goals = 'GOALS'
}

/** A Talent process available in the tab selector. */
export type AnalyticsTalentProcess = {
  __typename?: 'AnalyticsTalentProcess';
  /** Process end date, ISO 8601 (YYYY-MM-DD). */
  end_date?: Maybe<Scalars['String']['output']>;
  /** Collaborators reached by the process who are ACTIVE members of the organization today. Two consequences to render honestly: it counts assigned collaborators, while the «Resumen carga de metas» report lists only those who already have goals loaded (assigned >= loaded); and for a closed process the value drifts down over time as people leave the organization. */
  enrolled_count: Scalars['Int']['output'];
  /** Process identifier as stored in the Talent module. It is a STRING (goals use composite ids); pass it verbatim to the other Talent dashboard queries — never parse or cast it. */
  process_id: Scalars['String']['output'];
  /** Process display name configured by the organization. */
  process_name: Scalars['String']['output'];
  /** Process start date, ISO 8601 (YYYY-MM-DD). */
  start_date?: Maybe<Scalars['String']['output']>;
  /** Whether the process is still open or already closed. */
  status: AnalyticsTalentProcessStatusEnum;
};

/** Catalog of Talent processes for one module, newest first. Called once per tab load; the selected process keys every other block of the tab. Module not contracted and empty catalog are valid responses, never errors. */
export type AnalyticsTalentProcessCatalog = {
  __typename?: 'AnalyticsTalentProcessCatalog';
  /** Process the tab preselects: the open process with the most recent start date; if none is open, the most recently closed one. */
  default_process_id?: Maybe<Scalars['String']['output']>;
  /** ORG_UNAVAILABLE (the organization cannot be served — unknown, inactive, not linked to Talent, or outside your tenancy scope; the specific reason is deliberately not disclosed), INVALID_INPUT, INTERNAL_ERROR (the read failed; is_module_contracted stays truthful). Null on success — an empty catalog is success, not an error. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** When the Talent source data was last refreshed. This is the ETL freshness of the whole tab, not a per-process update timestamp — the source table carries no per-process updated_date. */
  freshness?: Maybe<AnalyticsTalentDashboardFreshness>;
  /** True when more processes exist than were returned. There is no cursor yet: raise `limit` (max 100) to fetch them. */
  has_more: Scalars['Boolean']['output'];
  /** Whether the session has the Performance product. Verified server-side: when false no process data is returned at all. */
  is_module_contracted: Scalars['Boolean']['output'];
  /** Processes of the organization for the requested module. */
  processes: Array<AnalyticsTalentProcess>;
  /** Processes the organization has for this module, BEFORE the page limit. Compare with the length of `processes` to know whether the catalog was truncated. */
  total_count: Scalars['Int']['output'];
};

/** Input for the Talent process catalog query. The module comes from the tab the admin opened; Goals and Competencies are requested separately. */
export type AnalyticsTalentProcessCatalogInput = {
  /** Centralized organization ID whose processes are listed. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Maximum processes returned, newest first. Defaults to 50 and is capped at 100 — the catalog is never unbounded. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Talent module to list processes for. */
  module: AnalyticsTalentModuleEnum;
};

/** Lifecycle state of a Talent process. Decides whether the tab opens in tracking mode (open process) or results mode (closed process). */
export enum AnalyticsTalentProcessStatusEnum {
  Closed = 'CLOSED',
  InProgress = 'IN_PROGRESS'
}

/** An attribute the admin can group by, for the block's own selector. */
export type AnalyticsTalentSegmentAttributeOption = {
  __typename?: 'AnalyticsTalentSegmentAttributeOption';
  /** True when the organization defined this attribute itself. */
  is_custom: Scalars['Boolean']['output'];
  /** Standard attribute name (AREA / DEPARTMENT / POSITION / HEADQUARTER) or `custom_<field_id>` for one the organization configured. Pass it back verbatim. */
  key: Scalars['String']['output'];
  /** Display name. For custom attributes, the name the organization gave it. */
  label: Scalars['String']['output'];
};

export type AnalyticsUpdateCustomReportInput = {
  /** Centralized organization scope (required for multi-tenant isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID of the custom report to update. */
  custom_report_id: Scalars['Int']['input'];
  /** New description (max 150 chars). */
  description?: InputMaybe<Scalars['String']['input']>;
  /** New display name (max 50 chars). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Updated wizard step 1 config. */
  report_input_config?: InputMaybe<Scalars['JSON']['input']>;
  /** Updated schedule config. Pass mode=NONE to deactivate scheduling. */
  schedule?: InputMaybe<ScheduleConfigInput>;
  /** Optional segment ID to scope the report to a specific user segment. */
  segment_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AnalyticsUserProgressDateNode = {
  __typename?: 'AnalyticsUserProgressDateNode';
  /** Date in YYYY-MM-DD format */
  date: Scalars['String']['output'];
  /** Day name (Monday, Tuesday, etc.) */
  day: Scalars['String']['output'];
  /** Total progress seconds for this day */
  seconds: Scalars['Int']['output'];
};

export type AnalyticsUserProgressNode = {
  __typename?: 'AnalyticsUserProgressNode';
  /** Daily progress breakdown for the week */
  dates: Array<AnalyticsUserProgressDateNode>;
  /** Total progress seconds for the current week */
  seconds: Scalars['Int']['output'];
};

export enum AnalyticsUserStatusEnum {
  StatusUsersActive = 'STATUS_USERS_ACTIVE',
  StatusUsersDelete = 'STATUS_USERS_DELETE',
  StatusUsersInactive = 'STATUS_USERS_INACTIVE',
  StatusUsersPending = 'STATUS_USERS_PENDING'
}

export type AnotherFile = {
  __typename?: 'AnotherFile';
  absolute_url?: Maybe<Scalars['String']['output']>;
  bucket_name?: Maybe<Scalars['String']['output']>;
  content_type: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  download_url?: Maybe<Scalars['String']['output']>;
  file_path?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  relative_url?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type AnswerBulkInput = {
  answers: Array<AnswerInput>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AnswerConnection = {
  __typename?: 'AnswerConnection';
  /** Contains the nodes in this connection */
  edges: Array<AnswerNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum AnswerFieldEnum {
  Random = 'RANDOM',
  CreatedAt = 'created_at',
  Position = 'position'
}

export type AnswerInput = {
  answer_check?: InputMaybe<Scalars['Boolean']['input']>;
  answer_text: Scalars['String']['input'];
  attachment_id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  question_id: Scalars['Int']['input'];
};

export type AnswerNode = {
  __typename?: 'AnswerNode';
  answer_text?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_automated: Scalars['Boolean']['output'];
  is_correct_answer?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  original_id?: Maybe<Scalars['Int']['output']>;
};

export type AnswerNodeEdge = {
  __typename?: 'AnswerNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AnswerNode;
};

/** API performed by type */
export type ApiPerformedBy = {
  __typename?: 'ApiPerformedBy';
  /** Type of performed by (API). */
  type: AuditLogPerformedByEnum;
};

export type ApplicantUser = CustomTagInterface & UserOrganizationInterface & {
  __typename?: 'ApplicantUser';
  tags: UserTagsType;
  user: UserInfoType;
};

export type ApplicationFile = {
  __typename?: 'ApplicationFile';
  absolute_url?: Maybe<Scalars['String']['output']>;
  bucket_name?: Maybe<Scalars['String']['output']>;
  content_type: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  download_url?: Maybe<Scalars['String']['output']>;
  file_path?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  relative_url?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export enum ApplicationNameEnum {
  Learning = 'LEARNING',
  Talent = 'TALENT'
}

/** Application product module with UI detail */
export type ApplicationProductNode = {
  __typename?: 'ApplicationProductNode';
  /** UI category header shown in the detail popover */
  category: Scalars['String']['output'];
  /** Product description */
  description?: Maybe<Scalars['String']['output']>;
  /** Detail items shown in the UI list */
  details: Array<Scalars['String']['output']>;
  /** Product icon URL or identifier */
  icon?: Maybe<Scalars['String']['output']>;
  /** Application product ID */
  id: Scalars['Int']['output'];
  /** Whether product is active */
  is_active: Scalars['Boolean']['output'];
  /** Product name */
  name: Scalars['String']['output'];
  /** Product suite ID this product belongs to */
  product_suite_id?: Maybe<Scalars['Int']['output']>;
};

export enum ApplicationRoleEnum {
  RoleAdmin = 'ROLE_ADMIN',
  RoleUser = 'ROLE_USER'
}

export type ApplyBulkImportInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['ID']['input'];
  /** Original file name */
  file_name: Scalars['String']['input'];
  /** Import batch UUID */
  import_batch_id: Scalars['ID']['input'];
  /** Policy ID */
  policy_id: Scalars['ID']['input'];
};

export type ApplyBulkImportPayload = {
  __typename?: 'ApplyBulkImportPayload';
  import_batch_id: Scalars['String']['output'];
};

export type ApplyBulkImportResult = ApplyBulkImportPayload | ForbiddenErrorResponse | InternalErrorResponse | ValidationErrorResponse;

/** Why a request was auto-resolved without completing its approval chain (HRIS-3893) */
export type ApprovalChainAutoResolvedType = {
  __typename?: 'ApprovalChainAutoResolvedType';
  /** Policy timeout in days before auto-resolving */
  auto_resolvable_time_days: Scalars['Int']['output'];
  /** Auto-resolution result */
  result: RequestStatusEnum;
};

/** Who skipped a request's approval chain and when (HRIS-3893) */
export type ApprovalChainSkipType = {
  __typename?: 'ApprovalChainSkipType';
  /** Admin who skipped the approval chain */
  admin: CentralizedUserNode;
  /** When the approval chain was skipped */
  skipped_at: Scalars['DateTime']['output'];
};

export enum ApprovalRequirementStudioEnum {
  FinalProject = 'FINAL_PROJECT',
  NotRequirement = 'NOT_REQUIREMENT',
  QuizEvaluation = 'QUIZ_EVALUATION'
}

export type ApproveIncidencesResult = IncidenceReviewResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type ApprovePidActivitiesInput = {
  activities_id_list: Array<Scalars['Int']['input']>;
};

export type ApprovePidActivitiesResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | SuccessType;

export type ApproveRequestInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Request ID */
  request_id: Scalars['ID']['input'];
};

export type ApproveRequestResponse = {
  __typename?: 'ApproveRequestResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type ArchiveCopilotPlannerReportInput = {
  /** UUID del reporte del Planner Agent a archivar. */
  report_id: Scalars['ID']['input'];
};

export type ArchiveCopilotPlannerReportResult = CopilotPlannerReportArchivedPayload | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type ArchiveEmployeePensionInput = {
  legal_entity_id: Scalars['ID']['input'];
  pension_id: Scalars['ID']['input'];
};

export type ArchiveEmployeePensionResult = EmployeePensionItemResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type ArchiveGovernmentCreditInput = {
  credit_id: Scalars['ID']['input'];
  legal_entity_id: Scalars['ID']['input'];
};

export type ArchiveGovernmentCreditResult = GovernmentCreditItemResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** A single area bar in the engagement chart. */
export type AreaBarNode = {
  __typename?: 'AreaBarNode';
  /** Area/department name. */
  name: Scalars['String']['output'];
  /** Percentage of active collaborators (0–100). */
  pct_active: Scalars['Float']['output'];
};

export type AreaInput = {
  centralized_organization_id: Scalars['Int']['input'];
  filter: AreaListFilterInput;
  order?: InputMaybe<AreaListOrderInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Basic area value (id and name). */
export type AreaLevelValueNode = {
  __typename?: 'AreaLevelValueNode';
  /** Area ID. */
  id: Scalars['Int']['output'];
  /** Area name. */
  name: Scalars['String']['output'];
};

export type AreaLevels = {
  level_1?: InputMaybe<Scalars['Int']['input']>;
  level_2?: InputMaybe<Scalars['Int']['input']>;
  level_3?: InputMaybe<Scalars['Int']['input']>;
  level_4?: InputMaybe<Scalars['Int']['input']>;
};

/** Area hierarchy levels assigned to an employee. */
export type AreaLevelsNode = {
  __typename?: 'AreaLevelsNode';
  /** Root area (Dirección or equivalent, level 1). */
  level_1?: Maybe<AreaLevelValueNode>;
  /** Level 2 area (Departamento or equivalent). */
  level_2?: Maybe<AreaLevelValueNode>;
  /** Level 3 area (Oficina or equivalent). */
  level_3?: Maybe<AreaLevelValueNode>;
  /** Level 4 area (Suboficina or equivalent). */
  level_4?: Maybe<AreaLevelValueNode>;
};

export type AreaListFilterInput = {
  level?: InputMaybe<Array<Scalars['Int']['input']>>;
  parent_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AreaListOrderInput = {
  desc: Scalars['Boolean']['input'];
  field: OrganizationAreaAttributeEnum;
};

/** Repeated Area Names Node in Area Creation */
export type AreaNameNode = {
  __typename?: 'AreaNameNode';
  area_level: Scalars['Int']['output'];
  names: Array<Scalars['String']['output']>;
};

export type AreaSearchInput = {
  centralized_organization_id: Scalars['Int']['input'];
  /** Page size. Defaults to 10 and is capped at 10; higher values are clamped, values below 1 are raised to 1. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Text to search for inside the area name (case-insensitive substring; % and _ are matched literally). Minimum 2 characters after trimming: shorter or blank returns an empty result set. */
  name: Scalars['String']['input'];
  /** Page offset. Defaults to 0; negative values clamp to 0. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AreaSearchResponse = AreaSearchResultsNode | ForbiddenErrorResponse | InternalErrorResponse;

/** Single result of a name-based area search. */
export type AreaSearchResultNode = {
  __typename?: 'AreaSearchResultNode';
  /** Root-level area ID (level 1). */
  area_level_1?: Maybe<Scalars['Int']['output']>;
  /** Level-2 area ID, null when depth < 2. */
  area_level_2?: Maybe<Scalars['Int']['output']>;
  /** Level-3 area ID, null when depth < 3. */
  area_level_3?: Maybe<Scalars['Int']['output']>;
  /** Leaf area ID, null when depth < 4. */
  area_level_4?: Maybe<Scalars['Int']['output']>;
  /** True if the area has sub-areas. */
  has_children: Scalars['Boolean']['output'];
  /** Internal area ID. */
  id: Scalars['Int']['output'];
  /** Area name. */
  name: Scalars['String']['output'];
  /** Full path from root, e.g. 'Corp > Finance'. */
  path: Scalars['String']['output'];
};

/** Paginated search results for area name lookup. */
export type AreaSearchResultsNode = {
  __typename?: 'AreaSearchResultsNode';
  items: Array<AreaSearchResultNode>;
  total: Scalars['Int']['output'];
};

/** Response for Section E2 — areas with most active collaborators. */
export type AreasEngagementResponse = {
  __typename?: 'AreasEngagementResponse';
  /** Top areas sorted by pct_active descending. */
  areas: Array<AreaBarNode>;
  /** Structured error code for degraded responses ('INVALID_PERIOD' on inconsistent period input). Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Whether the current user has product-level access (Management). False means the org does not have Management — frontend should hide the widget. */
  has_permission: Scalars['Boolean']['output'];
  /** Icon name for the widget header (e.g. 'bar_chart'). */
  icon: Scalars['String']['output'];
  /** Localized timestamp of the most recent ETL sync for this widget's data. Format: '23 abr - 9:25am'. Null when freshness cannot be determined. */
  last_updated_at_formatted?: Maybe<Scalars['String']['output']>;
  /** Resolved calendar window [start, end] the percentages cover, for the applied date-filter tag. */
  period?: Maybe<PeriodRange>;
  /** Widget subtitle (e.g. '% de colab con login últimos 30 días · Este mes'). */
  subtitle: Scalars['String']['output'];
  /** Widget title (e.g. 'Áreas con más colaboradores activos'). */
  title: Scalars['String']['output'];
};

export type AssertionCodeType = {
  __typename?: 'AssertionCodeType';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type AssignContentCoursePayload = {
  __typename?: 'AssignContentCoursePayload';
  course_id: Scalars['Int']['output'];
  is_async_flow: Scalars['Boolean']['output'];
  list_user_dont_belong: Array<Scalars['Int']['output']>;
  list_users_deleted: Array<Scalars['Int']['output']>;
  list_users_not_active: Array<Scalars['Int']['output']>;
  total_user_assigned: Scalars['Int']['output'];
};

export type AssignContentTrackPayload = {
  __typename?: 'AssignContentTrackPayload';
  is_async_flow: Scalars['Boolean']['output'];
  list_user_dont_belong: Array<Scalars['Int']['output']>;
  list_users_deleted: Array<Scalars['Int']['output']>;
  list_users_not_active: Array<Scalars['Int']['output']>;
  total_user_assigned: Scalars['Int']['output'];
  track_id: Scalars['Int']['output'];
};

export type AssignCourseByExcelInput = {
  course_id: Scalars['Int']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  success_file_id: Scalars['Int']['input'];
};

export type AssignCourseToMultipleUserByLeaderInput = {
  course_id: Scalars['Int']['input'];
  send_email_to_all_selected_users?: InputMaybe<Scalars['Boolean']['input']>;
  user_list_ids: Array<Scalars['Int']['input']>;
};

export type AssignCourseToMultipleUserInput = {
  centralized_user_list_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  course_id: Scalars['Int']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  send_email_to_all_selected_users?: InputMaybe<Scalars['Boolean']['input']>;
  user_list_ids: Array<Scalars['Int']['input']>;
};

export type AssignOrganizationTeamToUserInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  organization_team_id: Scalars['Int']['input'];
};

export type AssignOrganizationTeamToUserPayload = {
  __typename?: 'AssignOrganizationTeamToUserPayload';
  user_organization_team?: Maybe<UserOrganizationTeamNode>;
};

export type AssignOrganizationUserFileNode = {
  __typename?: 'AssignOrganizationUserFileNode';
  action?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  error_file_id?: Maybe<Scalars['Int']['output']>;
  error_file_url?: Maybe<Scalars['String']['output']>;
  errors_count: Scalars['Int']['output'];
  file_arguments_batch?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  json_response: Scalars['JSON']['output'];
  name_file?: Maybe<Scalars['String']['output']>;
  organization_id: Scalars['Int']['output'];
  registries_count: Scalars['Int']['output'];
  success_count: Scalars['Int']['output'];
  success_file_id?: Maybe<Scalars['Int']['output']>;
  user_upload_by: UserNode;
};

export type AssignOrganizationUserFileQueryInput = {
  assign_organization_user_file_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

/** Result of assigning supervisors to a segment group. */
export type AssignSupervisorsResponse = {
  __typename?: 'AssignSupervisorsResponse';
  assigned: Array<Scalars['Int']['output']>;
  group_id: Scalars['ID']['output'];
  not_in_org: Array<Scalars['Int']['output']>;
};

export type AssignSupervisorsResponseNotFoundResponse = AssignSupervisorsResponse | NotFoundResponse;

export type AssignTrackToMultipleUserInput = {
  centralized_user_list_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  send_email_to_all_selected_users?: InputMaybe<Scalars['Boolean']['input']>;
  track_id: Scalars['Int']['input'];
  user_list_ids: Array<Scalars['Int']['input']>;
};

export type AssignUserOrganizationAreaResponse = {
  __typename?: 'AssignUserOrganizationAreaResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type AssignUserOrganizationHeadquarterResponse = {
  __typename?: 'AssignUserOrganizationHeadquarterResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type AssignUserPolicyBalanceLogInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Centralized User ID */
  centralized_user_id: Scalars['ID']['input'];
  /** Policy ID */
  policy_id: Scalars['ID']['input'];
};

export type AssignUserPolicyBalanceLogResponse = {
  __typename?: 'AssignUserPolicyBalanceLogResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type AssignUserTeamCreationInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  organization_team_id: Scalars['Int']['input'];
  send_email_to_all_selected_users?: InputMaybe<Scalars['Boolean']['input']>;
  success_file_id: Scalars['Int']['input'];
};

/** Input used in assign_users_to_live_session [Mutation] */
export type AssignUsersToLiveSessionInput = {
  /** Target live session id */
  live_session_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to attempt sending the invitation email */
  send_notification?: Scalars['Boolean']['input'];
  /** User IDs to assign — already resolved */
  user_ids: Array<Scalars['ID']['input']>;
};

export type AssignedCourseInfo = {
  __typename?: 'AssignedCourseInfo';
  has_certification?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  users_pending_course: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type AssignedCourseInfoConnection = {
  __typename?: 'AssignedCourseInfoConnection';
  /** Contains the nodes in this connection */
  edges: Array<AssignedCourseInfoEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type AssignedCourseInfoEdge = {
  __typename?: 'AssignedCourseInfoEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AssignedCourseInfo;
};

export type AssignedCourseResponse = AssignedCourseInfoConnection | FoundationLeaderIntegrityError | FoundationLeaderInternalError | FoundationLeaderValidationError;

export type AssignmentEmptyTemplateResponseError = {
  __typename?: 'AssignmentEmptyTemplateResponseError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AssignmentInvalidTemplateResponseError = {
  __typename?: 'AssignmentInvalidTemplateResponseError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AssignmentNotFoundTemplateResponseError = {
  __typename?: 'AssignmentNotFoundTemplateResponseError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AssignmentSummary = {
  __typename?: 'AssignmentSummary';
  /** Count of errors */
  error_count: Scalars['Int']['output'];
  /** Count of documents that will be hidden */
  hidden_count: Scalars['Int']['output'];
  /** Total documents in configuration */
  total_documents: Scalars['Int']['output'];
  /** Count of valid assignments */
  valid_count: Scalars['Int']['output'];
  /** Count of documents that will be visible */
  visible_count: Scalars['Int']['output'];
  /** Count of warnings */
  warning_count: Scalars['Int']['output'];
};

export type AssignmentSummaryFragment = AllowedUserAssignmentsAssignmentResponse | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export enum AssignmentValidationErrorCode {
  ColMismatch = 'COL_MISMATCH',
  ColMissing = 'COL_MISSING',
  DateFormat = 'DATE_FORMAT',
  DateFuture = 'DATE_FUTURE',
  /** @deprecated No está siendo usado. */
  DatePast = 'DATE_PAST',
  DocEmpty = 'DOC_EMPTY',
  DocNotFound = 'DOC_NOT_FOUND',
  ExcelEmpty = 'EXCEL_EMPTY',
  ExcelInvalid = 'EXCEL_INVALID',
  ExcelTooLarge = 'EXCEL_TOO_LARGE',
  FolderInactive = 'FOLDER_INACTIVE',
  FolderNotFound = 'FOLDER_NOT_FOUND',
  InternalError = 'INTERNAL_ERROR',
  ReqFieldEmpty = 'REQ_FIELD_EMPTY',
  VisibilityInvalid = 'VISIBILITY_INVALID'
}

export type AssingnusersToPermissionGroupResponse = {
  __typename?: 'AssingnusersToPermissionGroupResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type AttachRequestFileInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** File ID */
  file_id: Scalars['ID']['input'];
  /** Request ID */
  request_id: Scalars['ID']['input'];
};

export type AttachRequestFileResponse = {
  __typename?: 'AttachRequestFileResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type Attachment = {
  __typename?: 'Attachment';
  created_date?: Maybe<Scalars['Date']['output']>;
  deleted_date?: Maybe<Scalars['Date']['output']>;
  full_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_inactivated_date?: Maybe<Scalars['Date']['output']>;
  last_updated_date?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AttachmentFormType = {
  __typename?: 'AttachmentFormType';
  company_id: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type AttachmentInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AttachmentOrderInput = {
  file_id: Scalars['ID']['input'];
  file_name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type AttachmentPayload = {
  __typename?: 'AttachmentPayload';
  absolute_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AttachmentStudioInput = {
  content_type?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AttachmentType = {
  __typename?: 'AttachmentType';
  attachment: SimpleFile;
  content_type: Scalars['String']['output'];
  created_date: Scalars['DateTime']['output'];
  file_size: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_project_guide: Scalars['Boolean']['output'];
  is_zipped: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type AttendanceDailyManagementReport = {
  __typename?: 'AttendanceDailyManagementReport';
  day_status?: Maybe<Scalars['String']['output']>;
  entry_time?: Maybe<Scalars['String']['output']>;
  exit_time?: Maybe<Scalars['String']['output']>;
  holiday_name?: Maybe<Scalars['String']['output']>;
  is_holiday?: Maybe<Scalars['Boolean']['output']>;
  mark_date?: Maybe<Scalars['Date']['output']>;
  mark_day_of_week?: Maybe<Scalars['String']['output']>;
  overtime_minutes?: Maybe<Scalars['Int']['output']>;
  tardiness_minutes?: Maybe<Scalars['Int']['output']>;
  time_off_policy_name?: Maybe<Scalars['String']['output']>;
  time_off_policy_type_name?: Maybe<Scalars['String']['output']>;
  user_area?: Maybe<Scalars['String']['output']>;
  user_department?: Maybe<Scalars['String']['output']>;
  user_document?: Maybe<Scalars['String']['output']>;
  user_headquarter?: Maybe<Scalars['String']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
  worked_minutes?: Maybe<Scalars['Int']['output']>;
};

export type AttendanceDailyManagementReportConnection = {
  __typename?: 'AttendanceDailyManagementReportConnection';
  /** A list of edges in this connection. */
  edges: Array<AttendanceDailyManagementReportEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type AttendanceDailyManagementReportConnectionQueryValidationErrorQueryInternalError = AttendanceDailyManagementReportConnection | QueryInternalError | QueryValidationError;

export type AttendanceDailyManagementReportEdge = {
  __typename?: 'AttendanceDailyManagementReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AttendanceDailyManagementReport;
};

export type AttendanceMarkReport = {
  __typename?: 'AttendanceMarkReport';
  classification?: Maybe<Scalars['String']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  mark_date?: Maybe<Scalars['Date']['output']>;
  mark_day_of_week?: Maybe<Scalars['String']['output']>;
  mark_time?: Maybe<Scalars['String']['output']>;
  mark_type?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  user_area?: Maybe<Scalars['String']['output']>;
  user_department?: Maybe<Scalars['String']['output']>;
  user_document?: Maybe<Scalars['String']['output']>;
  user_headquarter?: Maybe<Scalars['String']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};

export type AttendanceMarkReportConnection = {
  __typename?: 'AttendanceMarkReportConnection';
  /** A list of edges in this connection. */
  edges: Array<AttendanceMarkReportEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type AttendanceMarkReportConnectionQueryValidationErrorQueryInternalError = AttendanceMarkReportConnection | QueryInternalError | QueryValidationError;

export type AttendanceMarkReportEdge = {
  __typename?: 'AttendanceMarkReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AttendanceMarkReport;
};

export type AttendanceShiftReport = {
  __typename?: 'AttendanceShiftReport';
  created_at?: Maybe<Scalars['Date']['output']>;
  created_by_name?: Maybe<Scalars['String']['output']>;
  days?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  shift_name?: Maybe<Scalars['String']['output']>;
  shift_type?: Maybe<Scalars['String']['output']>;
  tolerance_after_minutes?: Maybe<Scalars['Int']['output']>;
  tolerance_before_minutes?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type AttendanceShiftReportConnection = {
  __typename?: 'AttendanceShiftReportConnection';
  /** A list of edges in this connection. */
  edges: Array<AttendanceShiftReportEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type AttendanceShiftReportConnectionQueryValidationErrorQueryInternalError = AttendanceShiftReportConnection | QueryInternalError | QueryValidationError;

export type AttendanceShiftReportEdge = {
  __typename?: 'AttendanceShiftReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AttendanceShiftReport;
};

export type AttendanceShiftScheduleReport = {
  __typename?: 'AttendanceShiftScheduleReport';
  assigned_by_name?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['Date']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  shift_name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['Date']['output']>;
  user_area?: Maybe<Scalars['String']['output']>;
  user_headquarter?: Maybe<Scalars['String']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};

export type AttendanceShiftScheduleReportConnection = {
  __typename?: 'AttendanceShiftScheduleReportConnection';
  /** A list of edges in this connection. */
  edges: Array<AttendanceShiftScheduleReportEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type AttendanceShiftScheduleReportConnectionQueryValidationErrorQueryInternalError = AttendanceShiftScheduleReportConnection | QueryInternalError | QueryValidationError;

export type AttendanceShiftScheduleReportEdge = {
  __typename?: 'AttendanceShiftScheduleReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AttendanceShiftScheduleReport;
};

/** Who receives the campaign */
export enum AudienceType {
  Collaborator = 'COLLABORATOR',
  Leader = 'LEADER'
}

export type AudioFile = {
  __typename?: 'AudioFile';
  absolute_url?: Maybe<Scalars['String']['output']>;
  bucket_name?: Maybe<Scalars['String']['output']>;
  content_type: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  download_url?: Maybe<Scalars['String']['output']>;
  file_path?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  relative_url?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type AuditLog = {
  __typename?: 'AuditLog';
  action: Scalars['String']['output'];
  domain: DomainEnum;
  event_date: Scalars['DateTime']['output'];
  interface?: Maybe<InterfaceEnum>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  new_value?: Maybe<Scalars['JSON']['output']>;
  old_value?: Maybe<Scalars['JSON']['output']>;
  organization_id: Scalars['ID']['output'];
  resource_id?: Maybe<Scalars['ID']['output']>;
  resource_type?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
  user_ip?: Maybe<Scalars['String']['output']>;
  user_type: UserTypeEnum;
};

/** ATS Events Connection */
export type AuditLogAtsEventConnection = {
  __typename?: 'AuditLogATSEventConnection';
  current_page: Scalars['Int']['output'];
  nodes: Array<AuditLogAtsEventNode>;
  total_count: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

/** Input for saving ATS events */
export type AuditLogAtsEventInput = {
  centralized_organization_id: Scalars['String']['input'];
  context: AtsEventContextInput;
  event_type: Scalars['String']['input'];
};

export type AuditLogAtsEventMutation = {
  __typename?: 'AuditLogATSEventMutation';
  create_ats_event: Scalars['Boolean']['output'];
};


export type AuditLogAtsEventMutationCreate_Ats_EventArgs = {
  input: AuditLogAtsEventInput;
};

/** ATS Event Node */
export type AuditLogAtsEventNode = {
  __typename?: 'AuditLogATSEventNode';
  actor_info?: Maybe<AuditLogActorInfoSchema>;
  analytics_info?: Maybe<AuditLogAnalyticsInfoSchema>;
  centralized_organization_id: Scalars['String']['output'];
  email_info?: Maybe<AuditLogEmailInfoSchema>;
  event_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  interview_info?: Maybe<AuditLogInterviewInfoSchema>;
  job_applicant?: Maybe<AuditLogJobApplicantSchema>;
  job_vacancy_info?: Maybe<AuditLogJobVacancyInfoSchema>;
  note?: Maybe<Scalars['String']['output']>;
  offer_info?: Maybe<AuditLogOfferInfoSchema>;
  process_info?: Maybe<AuditLogProcessInfoSchema>;
  rejection_info?: Maybe<AuditLogRejectionInfoSchema>;
  stage_info?: Maybe<AuditLogStageInfoSchema>;
  timestamp: Scalars['DateTime']['output'];
};

/** Fragment for the account change type. */
export type AuditLogAccount = BaseFieldType & {
  __typename?: 'AuditLogAccount';
  /** Type of change from the account section. */
  account_type: AuditLogAccountChangeType;
  /** Whether the field is visible. */
  is_visible: Scalars['Boolean']['output'];
};

export enum AuditLogAccountChangeType {
  AccountRole = 'ACCOUNT_ROLE',
  AccountUserStatus = 'ACCOUNT_USER_STATUS',
  DeactivationDate = 'DEACTIVATION_DATE',
  ManagedHeadquarters = 'MANAGED_HEADQUARTERS',
  Password = 'PASSWORD',
  Username = 'USERNAME'
}

export enum AuditLogAction {
  MagicLinkCreateUserLogin = 'MAGIC_LINK_CREATE_USER_LOGIN',
  MagicLinkUserLogin = 'MAGIC_LINK_USER_LOGIN',
  OrganizationAdminAddAttribute = 'ORGANIZATION_ADMIN_ADD_ATTRIBUTE',
  OrganizationAdminAddAutomation = 'ORGANIZATION_ADMIN_ADD_AUTOMATION',
  OrganizationAdminAddCourse = 'ORGANIZATION_ADMIN_ADD_COURSE',
  OrganizationAdminAddEcommerceTrack = 'ORGANIZATION_ADMIN_ADD_ECOMMERCE_TRACK',
  OrganizationAdminAddTeam = 'ORGANIZATION_ADMIN_ADD_TEAM',
  OrganizationAdminAddTrack = 'ORGANIZATION_ADMIN_ADD_TRACK',
  OrganizationAdminAddUser = 'ORGANIZATION_ADMIN_ADD_USER',
  OrganizationAdminChangeEmailTemplate = 'ORGANIZATION_ADMIN_CHANGE_EMAIL_TEMPLATE',
  OrganizationAdminChangeInfo = 'ORGANIZATION_ADMIN_CHANGE_INFO',
  OrganizationAdminChangeLookAndFeelApp = 'ORGANIZATION_ADMIN_CHANGE_LOOK_AND_FEEL_APP',
  OrganizationAdminChangeLookAndFeelDesktop = 'ORGANIZATION_ADMIN_CHANGE_LOOK_AND_FEEL_DESKTOP',
  OrganizationAdminChangeUserRole = 'ORGANIZATION_ADMIN_CHANGE_USER_ROLE',
  OrganizationAdminDeactivateUser = 'ORGANIZATION_ADMIN_DEACTIVATE_USER',
  OrganizationAdminDeleteAttribute = 'ORGANIZATION_ADMIN_DELETE_ATTRIBUTE',
  OrganizationAdminDeleteAutomation = 'ORGANIZATION_ADMIN_DELETE_AUTOMATION',
  OrganizationAdminDeleteTeam = 'ORGANIZATION_ADMIN_DELETE_TEAM',
  OrganizationAdminEditAttribute = 'ORGANIZATION_ADMIN_EDIT_ATTRIBUTE',
  OrganizationAdminEditAutomation = 'ORGANIZATION_ADMIN_EDIT_AUTOMATION',
  OrganizationAdminRecoverUserPassword = 'ORGANIZATION_ADMIN_RECOVER_USER_PASSWORD',
  OrganizationUserChangePassword = 'ORGANIZATION_USER_CHANGE_PASSWORD',
  OrganizationUserLogin = 'ORGANIZATION_USER_LOGIN',
  OrganizationUserLoginSso = 'ORGANIZATION_USER_LOGIN_SSO',
  OrganizationUserLogout = 'ORGANIZATION_USER_LOGOUT',
  OrganizationUserRecoverPassword = 'ORGANIZATION_USER_RECOVER_PASSWORD'
}

export enum AuditLogActionFlagEnum {
  Addition = 'ADDITION',
  Change = 'CHANGE',
  Deletion = 'DELETION'
}

export enum AuditLogActionLangEnum {
  Es = 'ES',
  Pt = 'PT'
}

export type AuditLogActorInfoInput = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Actor information */
export type AuditLogActorInfoSchema = {
  __typename?: 'AuditLogActorInfoSchema';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  user_email?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type AuditLogAnalyticsInfoInput = {
  cost_per_hire?: InputMaybe<Scalars['Float']['input']>;
  source_quality_score?: InputMaybe<Scalars['Float']['input']>;
  time_to_hire_days?: InputMaybe<Scalars['Int']['input']>;
};

/** Analytics information */
export type AuditLogAnalyticsInfoSchema = {
  __typename?: 'AuditLogAnalyticsInfoSchema';
  cost_per_hire?: Maybe<Scalars['Float']['output']>;
  source_quality_score?: Maybe<Scalars['Float']['output']>;
  time_to_hire_days?: Maybe<Scalars['Int']['output']>;
};

/** Area change information. */
export type AuditLogAreaChangeSchema = {
  __typename?: 'AuditLogAreaChangeSchema';
  /** New area hierarchy. */
  area_new_value: AuditLogAreaChangeValueSchema;
  /** Previous area hierarchy. */
  area_previous_value: AuditLogAreaChangeValueSchema;
};

export type AuditLogAreaChangeSchemaAuditLogBaseChangeSchema = AuditLogAreaChangeSchema | AuditLogBaseChangeSchema;

/** Area change value information. */
export type AuditLogAreaChangeValueSchema = {
  __typename?: 'AuditLogAreaChangeValueSchema';
  /** First level of the area hierarchy. */
  level_1: AuditLogAreaLevelSchema;
  /** Second level of the area hierarchy. */
  level_2: AuditLogAreaLevelSchema;
  /** Third level of the area hierarchy. */
  level_3: AuditLogAreaLevelSchema;
  /** Fourth level of the area hierarchy. */
  level_4: AuditLogAreaLevelSchema;
};

/** Area level information. */
export type AuditLogAreaLevelSchema = {
  __typename?: 'AuditLogAreaLevelSchema';
  /** Name of the area level. */
  name: Scalars['String']['output'];
  /** Value of the area level. */
  value: Scalars['String']['output'];
};

/** Base change information. */
export type AuditLogBaseChangeSchema = {
  __typename?: 'AuditLogBaseChangeSchema';
  /** The field that was changed. */
  field: AuditLogCustomFieldTypeAuditLogBasicInfoAuditLogPersonalInfoAuditLogJobInfoAuditLogEmergencyContactAuditLogAccount;
  /** New value of the field. */
  new_value: Scalars['String']['output'];
  /** Previous value of the field. */
  previous_value: Scalars['String']['output'];
};

/** Fragment for the basic info change type. */
export type AuditLogBasicInfo = BaseFieldType & {
  __typename?: 'AuditLogBasicInfo';
  /** Type of change from the basic info section. */
  basic_info_type: AuditLogBasicInfoChangeType;
  /** Whether the field is visible. */
  is_visible: Scalars['Boolean']['output'];
};

export enum AuditLogBasicInfoChangeType {
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

export enum AuditLogChangeTypeEnum {
  AdditionalInfo = 'ADDITIONAL_INFO',
  BasicInfo = 'BASIC_INFO',
  EmergencyContact = 'EMERGENCY_CONTACT',
  JobInfo = 'JOB_INFO',
  PersonalInfo = 'PERSONAL_INFO',
  UserAccount = 'USER_ACCOUNT'
}

export enum AuditLogChangeTypeFilterEnum {
  AboutMe = 'ABOUT_ME',
  AccountRole = 'ACCOUNT_ROLE',
  AccountUserStatus = 'ACCOUNT_USER_STATUS',
  AdditionalInfo = 'ADDITIONAL_INFO',
  Address = 'ADDRESS',
  ApplicantMarkAdded = 'APPLICANT_MARK_ADDED',
  ApplicantNoteAdded = 'APPLICANT_NOTE_ADDED',
  ApplicantProfileCreated = 'APPLICANT_PROFILE_CREATED',
  ApplicantStageChanged = 'APPLICANT_STAGE_CHANGED',
  ApplicantVacancyChanged = 'APPLICANT_VACANCY_CHANGED',
  Area = 'AREA',
  AtsInfo = 'ATS_INFO',
  BasicInfo = 'BASIC_INFO',
  Birthday = 'BIRTHDAY',
  Cellphone = 'CELLPHONE',
  City = 'CITY',
  CompanyEntryDate = 'COMPANY_ENTRY_DATE',
  CompanyExitDate = 'COMPANY_EXIT_DATE',
  ContactEmail = 'CONTACT_EMAIL',
  ContactName = 'CONTACT_NAME',
  ContactPhone = 'CONTACT_PHONE',
  ContactRelationship = 'CONTACT_RELATIONSHIP',
  Country = 'COUNTRY',
  DateOfBirth = 'DATE_OF_BIRTH',
  DeactivationDate = 'DEACTIVATION_DATE',
  Email = 'EMAIL',
  EmergencyContact = 'EMERGENCY_CONTACT',
  FirstName = 'FIRST_NAME',
  Gender = 'GENDER',
  Identification = 'IDENTIFICATION',
  IdentificationType = 'IDENTIFICATION_TYPE',
  JobCategory = 'JOB_CATEGORY',
  JobInfo = 'JOB_INFO',
  LastName = 'LAST_NAME',
  Location = 'LOCATION',
  ManagedHeadquarters = 'MANAGED_HEADQUARTERS',
  Manager = 'MANAGER',
  MaritalStatus = 'MARITAL_STATUS',
  Password = 'PASSWORD',
  PersonalEmail = 'PERSONAL_EMAIL',
  PersonalInfo = 'PERSONAL_INFO',
  Phone = 'PHONE',
  Position = 'POSITION',
  Username = 'USERNAME',
  UserAccount = 'USER_ACCOUNT'
}

/** Provide a paginated connection of audit logs. */
export type AuditLogConnection = {
  __typename?: 'AuditLogConnection';
  /** Current page number. */
  current_page: Scalars['Int']['output'];
  /** List of audit log entries. */
  nodes: Array<AuditLogNode>;
  /** Total number of entries. */
  total_count: Scalars['Int']['output'];
  /** Total number of pages. */
  total_pages: Scalars['Int']['output'];
};

export type AuditLogConnectionInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = AuditLogConnection | ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export enum AuditLogContentTypeEnum {
  Course = 'COURSE',
  Gamification = 'GAMIFICATION',
  Quiz = 'QUIZ'
}

export enum AuditLogCourseActionTypeEnum {
  Create = 'CREATE',
  Delete = 'DELETE',
  Download = 'DOWNLOAD',
  Publish = 'PUBLISH',
  Update = 'UPDATE'
}

export type AuditLogCourseActorFragment = AuditLogCourseActorType | AuditLogExternalCourseActorType | AuditLogSystemCourseActorType;

export type AuditLogCourseActorType = {
  __typename?: 'AuditLogCourseActorType';
  centralized_user_id?: Maybe<Scalars['ID']['output']>;
  email: Scalars['String']['output'];
  learning_user_id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum AuditLogCourseActorTypeEnum {
  External = 'EXTERNAL',
  System = 'SYSTEM',
  User = 'USER'
}

export type AuditLogCourseComponentChangeFieldType = {
  __typename?: 'AuditLogCourseComponentChangeFieldType';
  field: Scalars['String']['output'];
  new_value?: Maybe<Scalars['String']['output']>;
  old_value?: Maybe<Scalars['String']['output']>;
};

export enum AuditLogCourseComponentEnum {
  Certificate = 'CERTIFICATE',
  CertificateTemplate = 'CERTIFICATE_TEMPLATE',
  Course = 'COURSE',
  Enrollment = 'ENROLLMENT'
}

export type AuditLogCourseComponentType = {
  __typename?: 'AuditLogCourseComponentType';
  change_fields: Array<AuditLogCourseComponentChangeFieldType>;
  id: Scalars['ID']['output'];
  representation: Scalars['String']['output'];
  type: AuditLogCourseComponentEnum;
};

/** Audit Logs for Course Connection */
export type AuditLogCourseConnection = {
  __typename?: 'AuditLogCourseConnection';
  current_page: Scalars['Int']['output'];
  nodes: Array<AuditLogCourseFragment>;
  page_size: Scalars['Int']['output'];
  total_count: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type AuditLogCourseErrorType = {
  __typename?: 'AuditLogCourseErrorType';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type AuditLogCourseFailureType = AuditLogCourseTypeInterface & {
  __typename?: 'AuditLogCourseFailureType';
  action: AuditLogCourseActionTypeEnum;
  action_at: Scalars['DateTime']['output'];
  actor: AuditLogCourseActorFragment;
  centralized_organization_id?: Maybe<Scalars['ID']['output']>;
  change_message: Scalars['String']['output'];
  component: AuditLogCourseComponentType;
  error_detail?: Maybe<AuditLogCourseErrorType>;
  learning_organization_id?: Maybe<Scalars['ID']['output']>;
  status: AuditLogCourseStatusEnum;
};

export type AuditLogCourseFragment = AuditLogCourseFailureType | AuditLogCourseType;

export type AuditLogCourseInput = {
  action?: InputMaybe<AuditLogCourseActionTypeEnum>;
  actor?: InputMaybe<CourseActorInput>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  component?: InputMaybe<CourseComponentInput>;
  learning_organization_id?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  status?: InputMaybe<AuditLogCourseStatusEnum>;
  timestamp?: InputMaybe<AuditLogDateFilter>;
};

export enum AuditLogCourseStatusEnum {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export type AuditLogCourseType = AuditLogCourseTypeInterface & {
  __typename?: 'AuditLogCourseType';
  action: AuditLogCourseActionTypeEnum;
  action_at: Scalars['DateTime']['output'];
  actor: AuditLogCourseActorFragment;
  centralized_organization_id?: Maybe<Scalars['ID']['output']>;
  change_message: Scalars['String']['output'];
  component: AuditLogCourseComponentType;
  learning_organization_id?: Maybe<Scalars['ID']['output']>;
};

export type AuditLogCourseTypeInterface = {
  action: AuditLogCourseActionTypeEnum;
  action_at: Scalars['DateTime']['output'];
  actor: AuditLogCourseActorFragment;
  centralized_organization_id?: Maybe<Scalars['ID']['output']>;
  change_message: Scalars['String']['output'];
  component: AuditLogCourseComponentType;
  learning_organization_id?: Maybe<Scalars['ID']['output']>;
};

/** Custom field type */
export type AuditLogCustomFieldType = {
  __typename?: 'AuditLogCustomFieldType';
  /** Name of the custom field. */
  custom_name: Scalars['String']['output'];
  /** Unique identifier of the custom field. */
  id: Scalars['String']['output'];
  /** Whether the custom field is visible. */
  is_visible: Scalars['Boolean']['output'];
};

export type AuditLogCustomFieldTypeAuditLogBasicInfoAuditLogPersonalInfoAuditLogJobInfoAuditLogEmergencyContactAuditLogAccount = AuditLogAccount | AuditLogBasicInfo | AuditLogCustomFieldType | AuditLogEmergencyContact | AuditLogJobInfo | AuditLogPersonalInfo;

export type AuditLogDateFilter = {
  /** Start date for filtering (format: YYYY-MM-DD). */
  from_date?: InputMaybe<Scalars['String']['input']>;
  /** End date for filtering (format: YYYY-MM-DD). */
  to_date?: InputMaybe<Scalars['String']['input']>;
};

export type AuditLogEmailInfoInput = {
  status: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  template: Scalars['String']['input'];
  triggered_by?: InputMaybe<Scalars['String']['input']>;
};

/** Email information */
export type AuditLogEmailInfoSchema = {
  __typename?: 'AuditLogEmailInfoSchema';
  status: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  template: Scalars['String']['output'];
  triggered_by?: Maybe<Scalars['String']['output']>;
};

/** Fragment for the emergency contact change type. */
export type AuditLogEmergencyContact = BaseFieldType & {
  __typename?: 'AuditLogEmergencyContact';
  /** Type of change from the emergency contact section. */
  emergency_contact_type: AuditLogEmergencyContactChangeType;
  /** Whether the field is visible. */
  is_visible: Scalars['Boolean']['output'];
};

export enum AuditLogEmergencyContactChangeType {
  ContactEmail = 'CONTACT_EMAIL',
  ContactName = 'CONTACT_NAME',
  ContactPhone = 'CONTACT_PHONE',
  ContactRelationship = 'CONTACT_RELATIONSHIP'
}

export type AuditLogExternalCourseActorType = {
  __typename?: 'AuditLogExternalCourseActorType';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AuditLogFiltersInput = {
  /** Date range for filtering. */
  date?: InputMaybe<AuditLogDateFilter>;
  /** List of user IDs who were impacted by the changes. */
  impacted_user_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of fields that were modified. */
  modified_fields?: InputMaybe<AuditLogModifiedField>;
  /** List of user IDs who made the modifications. */
  performed_by_user_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AuditLogFiltersInputUserProfile = {
  /** List of fields that were modified. */
  modified_fields?: InputMaybe<AuditLogModifiedField>;
  /** List of fields that were modified. */
  section_filter: AuditLogChangeTypeEnum;
};

export type AuditLogFragmentType = AuditLogType | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type AuditLogInterviewInfoInput = {
  duration_minutes?: InputMaybe<Scalars['Int']['input']>;
  interview_type: Scalars['String']['input'];
  interviewer_email: Scalars['String']['input'];
  score?: InputMaybe<Scalars['Float']['input']>;
};

/** Interview information */
export type AuditLogInterviewInfoSchema = {
  __typename?: 'AuditLogInterviewInfoSchema';
  duration_minutes?: Maybe<Scalars['Int']['output']>;
  interview_type: Scalars['String']['output'];
  interviewer_email: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
};

export type AuditLogJobApplicantInfoInput = {
  channel?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  job_applicant_id: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
};

/** Job applicant information */
export type AuditLogJobApplicantSchema = {
  __typename?: 'AuditLogJobApplicantSchema';
  channel?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  job_applicant_id: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

/** Fragment for the job info change type. */
export type AuditLogJobInfo = BaseFieldType & {
  __typename?: 'AuditLogJobInfo';
  /** Whether the field is visible. */
  is_visible: Scalars['Boolean']['output'];
  /** Type of change from the job info section. */
  job_info_type: AuditLogJobInfoChangeType;
};

export enum AuditLogJobInfoChangeType {
  Area = 'AREA',
  CompanyEntryDate = 'COMPANY_ENTRY_DATE',
  CompanyExitDate = 'COMPANY_EXIT_DATE',
  JobCategory = 'JOB_CATEGORY',
  Location = 'LOCATION',
  Manager = 'MANAGER',
  Position = 'POSITION'
}

export type AuditLogJobVacancyInfoInput = {
  department?: InputMaybe<Scalars['String']['input']>;
  job_vacancy_id: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Job vacancy information */
export type AuditLogJobVacancyInfoSchema = {
  __typename?: 'AuditLogJobVacancyInfoSchema';
  department?: Maybe<Scalars['String']['output']>;
  job_vacancy_id: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type AuditLogModifiedField = {
  /** ID of the custom field. */
  custom_field_id?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Type of change for predefined fields. */
  field?: InputMaybe<Array<AuditLogChangeTypeFilterEnum>>;
};

export type AuditLogMutations = {
  __typename?: 'AuditLogMutations';
  /** Add new log entry using PUBSUB */
  register_log_action: AuditLogFragmentType;
};


export type AuditLogMutationsRegister_Log_ActionArgs = {
  input: CreateLogActionInput;
};

/** Store an audit log entry for user changes. */
export type AuditLogNode = {
  __typename?: 'AuditLogNode';
  /** Unique identifier of the organization. */
  centralized_organization_id: Scalars['Int']['output'];
  /** The change that was made. */
  change: AuditLogAreaChangeSchemaAuditLogBaseChangeSchema;
  /** Date of the change in YYYY-MM-DD format. */
  date: Scalars['String']['output'];
  /** Unique identifier of the audit log. */
  id: Scalars['ID']['output'];
  /** User who made the modification. */
  performed_by: CentralizedUserNodeApiPerformedByMigrationPerformedByImpersonatedPerformedBy;
  /** Timestamp of when the change occurred. */
  timestamp: Scalars['DateTime']['output'];
  /** User whose data was changed. */
  user_impacted: CentralizedUserNode;
  /** Whether the change is visible to regular users. */
  visible: Scalars['Boolean']['output'];
};

export type AuditLogOfferInfoInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  salary_amount?: InputMaybe<Scalars['Float']['input']>;
  start_date: Scalars['DateTime']['input'];
  user_id: Scalars['String']['input'];
};

/** Offer information */
export type AuditLogOfferInfoSchema = {
  __typename?: 'AuditLogOfferInfoSchema';
  currency?: Maybe<Scalars['String']['output']>;
  salary_amount?: Maybe<Scalars['Float']['output']>;
  start_date: Scalars['DateTime']['output'];
  user_id: Scalars['String']['output'];
};

export enum AuditLogOrderFieldEnum {
  ActionTime = 'ACTION_TIME',
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

export enum AuditLogPerformedByEnum {
  Api = 'API',
  Migration = 'MIGRATION'
}

/** Fragment for the personal info change type. */
export type AuditLogPersonalInfo = BaseFieldType & {
  __typename?: 'AuditLogPersonalInfo';
  /** Whether the field is visible. */
  is_visible: Scalars['Boolean']['output'];
  /** Type of change from the personal info section. */
  personal_info_type: AuditLogPersonalInfoChangeType;
};

export enum AuditLogPersonalInfoChangeType {
  AboutMe = 'ABOUT_ME',
  Address = 'ADDRESS',
  Birthday = 'BIRTHDAY',
  Cellphone = 'CELLPHONE',
  City = 'CITY',
  Country = 'COUNTRY',
  DateOfBirth = 'DATE_OF_BIRTH',
  Gender = 'GENDER',
  Identification = 'IDENTIFICATION',
  IdentificationType = 'IDENTIFICATION_TYPE',
  MaritalStatus = 'MARITAL_STATUS',
  PersonalEmail = 'PERSONAL_EMAIL',
  Phone = 'PHONE'
}

/** Process information input */
export type AuditLogProcessInfoInput = {
  action_type: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Process information */
export type AuditLogProcessInfoSchema = {
  __typename?: 'AuditLogProcessInfoSchema';
  action_type: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type AuditLogQueries = {
  __typename?: 'AuditLogQueries';
  /** This resource is responsible for listing the history of changes to the courses. */
  course_action_history: Array<AuditLogType>;
};


export type AuditLogQueriesCourse_Action_HistoryArgs = {
  input: QueryCourseAuditLogInput;
};

export type AuditLogQueryInput = {
  /** ID of the centralized organization. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Filtering options. */
  filter?: InputMaybe<AuditLogFiltersInput>;
  /** Pagination options. */
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type AuditLogQueryInputUserProfile = {
  /** ID of the centralized organization. */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID of the centralized user. */
  centralized_user_id: Scalars['String']['input'];
  /** Filtering options. */
  filter?: InputMaybe<AuditLogFiltersInputUserProfile>;
  /** Pagination options. */
  pagination?: InputMaybe<OffsetPaginationInput>;
};

export type AuditLogRejectionInfoInput = {
  feedback_provided: Scalars['Boolean']['input'];
  rehire_eligible: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
};

/** Rejection information */
export type AuditLogRejectionInfoSchema = {
  __typename?: 'AuditLogRejectionInfoSchema';
  feedback_provided: Scalars['Boolean']['output'];
  rehire_eligible: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type AuditLogResolvers = {
  __typename?: 'AuditLogResolvers';
  /** Get ATS events with filters and pagination */
  ats_events: AuditLogAtsEventConnection;
  /** Download audit logs excel format. */
  download_user_audit_logs_admin: DownloadAuditLogConnectionInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
  /** Retrieve filtered and paginated audit logs. */
  get_user_audit_logs_admin: AuditLogConnectionInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
  /** Retrieve filtered and paginated audit logs. */
  get_user_audit_logs_profile: AuditLogConnectionInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
};


export type AuditLogResolversAts_EventsArgs = {
  input: AuditlogAtsEventFiltersInput;
  page?: Scalars['Int']['input'];
  page_size?: Scalars['Int']['input'];
};


export type AuditLogResolversDownload_User_Audit_Logs_AdminArgs = {
  input?: InputMaybe<AuditLogQueryInput>;
};


export type AuditLogResolversGet_User_Audit_Logs_AdminArgs = {
  input?: InputMaybe<AuditLogQueryInput>;
};


export type AuditLogResolversGet_User_Audit_Logs_ProfileArgs = {
  input?: InputMaybe<AuditLogQueryInputUserProfile>;
};

export type AuditLogStageInfoInput = {
  stage?: InputMaybe<Scalars['String']['input']>;
  stage_duration_days?: InputMaybe<Scalars['Int']['input']>;
  stage_from?: InputMaybe<Scalars['String']['input']>;
  stage_to?: InputMaybe<Scalars['String']['input']>;
};

/** Stage information */
export type AuditLogStageInfoSchema = {
  __typename?: 'AuditLogStageInfoSchema';
  stage?: Maybe<Scalars['String']['output']>;
  stage_duration_days?: Maybe<Scalars['Int']['output']>;
  stage_from?: Maybe<Scalars['String']['output']>;
  stage_to?: Maybe<Scalars['String']['output']>;
};

export type AuditLogSystemCourseActorType = {
  __typename?: 'AuditLogSystemCourseActorType';
  process_id?: Maybe<Scalars['ID']['output']>;
  process_name: Scalars['String']['output'];
  process_source?: Maybe<Scalars['String']['output']>;
};

export type AuditLogType = {
  __typename?: 'AuditLogType';
  action_flag_enum?: Maybe<AuditLogActionFlagEnum>;
  change_message?: Maybe<Scalars['JSON']['output']>;
  component_enum?: Maybe<CourseComponentTypeEnum>;
  content_type_enum?: Maybe<AuditLogContentTypeEnum>;
  course_repr?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  descriptive_message?: Maybe<Scalars['JSON']['output']>;
  sub_component_enum?: Maybe<VideoLectureSubComponentTypeEnum>;
  user?: Maybe<User>;
};

/** Filters for querying ATS events */
export type AuditlogAtsEventFiltersInput = {
  centralized_organization_id: Scalars['String']['input'];
  event_type?: InputMaybe<Scalars['String']['input']>;
  from_date?: InputMaybe<Scalars['DateTime']['input']>;
  job_applicant_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  job_vacancy_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  stages?: InputMaybe<Array<Scalars['String']['input']>>;
  to_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum AuthUserRoleEnum {
  AuthRoleAdmin = 'AUTH_ROLE_ADMIN',
  AuthRoleUser = 'AUTH_ROLE_USER'
}

export type AuthenticateFromTalentSessionInput = {
  token: Scalars['String']['input'];
};

export type AuthenticateFromTalentSessionPayload = {
  __typename?: 'AuthenticateFromTalentSessionPayload';
  session_id: Scalars['String']['output'];
};

export type AuthenticateFromTalentSessionPayloadValidationMutationErrorInternalServerMutationError = AuthenticateFromTalentSessionPayload | InternalServerMutationError | ValidationMutationError;

export type AuthenticationApiClient = {
  __typename?: 'AuthenticationAPIClient';
  api_key: Scalars['String']['output'];
  created_date: Scalars['DateTime']['output'];
  debug?: Maybe<Scalars['Boolean']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  kms_key_arn?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organization_id?: Maybe<Scalars['ID']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  secret_access: Scalars['String']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type AuthenticationAccessToken = {
  __typename?: 'AuthenticationAccessToken';
  application_id: Scalars['ID']['output'];
  backend: Scalars['String']['output'];
  created_date: Scalars['DateTime']['output'];
  expire_date: Scalars['DateTime']['output'];
  refresh_token_id: Scalars['ID']['output'];
  revoked_at: Scalars['DateTime']['output'];
  token: Scalars['String']['output'];
  user: User;
  user_agent: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
};

export enum AuthenticationMethodEnum {
  AuthenticationMethodCredentials = 'AUTHENTICATION_METHOD_CREDENTIALS',
  AuthenticationMethodOauth2 = 'AUTHENTICATION_METHOD_OAUTH2',
  AuthenticationMethodSaml2 = 'AUTHENTICATION_METHOD_SAML2'
}

export enum AuthenticationProviderEnum {
  AuthenticationProviderCrehana = 'AUTHENTICATION_PROVIDER_CREHANA',
  AuthenticationProviderCustom = 'AUTHENTICATION_PROVIDER_CUSTOM',
  AuthenticationProviderGoogle = 'AUTHENTICATION_PROVIDER_GOOGLE',
  AuthenticationProviderMicrosoft = 'AUTHENTICATION_PROVIDER_MICROSOFT',
  AuthenticationProviderOpenagora = 'AUTHENTICATION_PROVIDER_OPENAGORA',
  AuthenticationProviderSecureauth = 'AUTHENTICATION_PROVIDER_SECUREAUTH'
}

export type AuthenticationSaml2NamespaceMutation = {
  __typename?: 'AuthenticationSaml2NamespaceMutation';
  create_saml2_claim: Saml2ClaimPayloadValidationMutationErrorInternalServerMutationError;
  create_saml2_idp_configuration: Saml2IdpConfigurationPayloadValidationMutationErrorInternalServerMutationError;
  create_saml2_sp_configuration: Saml2SpConfigurationPayloadValidationMutationErrorInternalServerMutationError;
  delete_saml2_claim: DeleteSaml2ClaimPayloadValidationMutationErrorInternalServerMutationError;
  delete_saml2_service_provider: DeleteSaml2ServiceProviderPayloadValidationMutationErrorInternalServerMutationError;
  delete_saml2_trusted_idp: DeleteSaml2TrustedIdpPayloadValidationMutationErrorInternalServerMutationError;
  generate_saml2_assertion: Saml2AssertionPayloadValidationMutationErrorInternalServerMutationError;
  generate_saml2_sp_authn_request: Saml2SpAuthnRequestPayloadValidationMutationErrorInternalServerMutationError;
  process_saml2_sp_response: Saml2SpProcessedResponsePayloadValidationMutationErrorInternalServerMutationError;
  regenerate_saml2_certificate: Saml2IdpConfigurationPayloadValidationMutationErrorInternalServerMutationError;
  regenerate_saml2_sp_certificate: Saml2SpConfigurationPayloadValidationMutationErrorInternalServerMutationError;
  register_saml2_service_provider: Saml2ServiceProviderPayloadValidationMutationErrorInternalServerMutationError;
  register_saml2_trusted_idp: Saml2TrustedIdpPayloadValidationMutationErrorInternalServerMutationError;
  update_saml2_claim: Saml2ClaimPayloadValidationMutationErrorInternalServerMutationError;
  update_saml2_idp_configuration: Saml2IdpConfigurationPayloadValidationMutationErrorInternalServerMutationError;
  update_saml2_service_provider: Saml2ServiceProviderPayloadValidationMutationErrorInternalServerMutationError;
  update_saml2_sp_configuration: Saml2SpConfigurationPayloadValidationMutationErrorInternalServerMutationError;
  update_saml2_trusted_idp: Saml2TrustedIdpPayloadValidationMutationErrorInternalServerMutationError;
  validate_saml2_authn_request: Saml2AuthnRequestPayloadValidationMutationErrorInternalServerMutationError;
};


export type AuthenticationSaml2NamespaceMutationCreate_Saml2_ClaimArgs = {
  input: CreateSaml2ClaimInput;
};


export type AuthenticationSaml2NamespaceMutationCreate_Saml2_Idp_ConfigurationArgs = {
  input: CreateSaml2IdpConfigurationInput;
};


export type AuthenticationSaml2NamespaceMutationCreate_Saml2_Sp_ConfigurationArgs = {
  input: CreateSaml2SpConfigurationInput;
};


export type AuthenticationSaml2NamespaceMutationDelete_Saml2_ClaimArgs = {
  input: DeleteSaml2ClaimInput;
};


export type AuthenticationSaml2NamespaceMutationDelete_Saml2_Service_ProviderArgs = {
  input: DeleteSaml2ServiceProviderInput;
};


export type AuthenticationSaml2NamespaceMutationDelete_Saml2_Trusted_IdpArgs = {
  input: DeleteSaml2TrustedIdpInput;
};


export type AuthenticationSaml2NamespaceMutationGenerate_Saml2_AssertionArgs = {
  input: GenerateSaml2AssertionInput;
};


export type AuthenticationSaml2NamespaceMutationGenerate_Saml2_Sp_Authn_RequestArgs = {
  input: GenerateSaml2SpAuthnRequestInput;
};


export type AuthenticationSaml2NamespaceMutationProcess_Saml2_Sp_ResponseArgs = {
  input: ProcessSaml2SpResponseInput;
};


export type AuthenticationSaml2NamespaceMutationRegenerate_Saml2_CertificateArgs = {
  input: RegenerateSaml2CertificateInput;
};


export type AuthenticationSaml2NamespaceMutationRegenerate_Saml2_Sp_CertificateArgs = {
  input: RegenerateSaml2SpCertificateInput;
};


export type AuthenticationSaml2NamespaceMutationRegister_Saml2_Service_ProviderArgs = {
  input: RegisterSaml2ServiceProviderInput;
};


export type AuthenticationSaml2NamespaceMutationRegister_Saml2_Trusted_IdpArgs = {
  input: RegisterSaml2TrustedIdpInput;
};


export type AuthenticationSaml2NamespaceMutationUpdate_Saml2_ClaimArgs = {
  input: UpdateSaml2ClaimInput;
};


export type AuthenticationSaml2NamespaceMutationUpdate_Saml2_Idp_ConfigurationArgs = {
  input: UpdateSaml2IdpConfigurationInput;
};


export type AuthenticationSaml2NamespaceMutationUpdate_Saml2_Service_ProviderArgs = {
  input: UpdateSaml2ServiceProviderInput;
};


export type AuthenticationSaml2NamespaceMutationUpdate_Saml2_Sp_ConfigurationArgs = {
  input: UpdateSaml2SpConfigurationInput;
};


export type AuthenticationSaml2NamespaceMutationUpdate_Saml2_Trusted_IdpArgs = {
  input: UpdateSaml2TrustedIdpInput;
};


export type AuthenticationSaml2NamespaceMutationValidate_Saml2_Authn_RequestArgs = {
  input: ValidateSaml2AuthnRequestInput;
};

export type AuthenticationSaml2NamespaceQuery = {
  __typename?: 'AuthenticationSaml2NamespaceQuery';
  saml2_claims: Saml2ClaimsPayloadQueryValidationErrorQueryInternalServerError;
  saml2_idp_configuration: Saml2IdpConfigurationPayloadQueryValidationErrorQueryInternalServerError;
  saml2_idp_metadata: Saml2IdpMetadataPayloadQueryValidationErrorQueryInternalServerError;
  saml2_service_providers: Saml2ServiceProvidersPayloadQueryValidationErrorQueryInternalServerError;
  saml2_sp_configuration: Saml2SpConfigurationPayloadQueryValidationErrorQueryInternalServerError;
  saml2_sp_metadata: Saml2SpMetadataPayloadQueryValidationErrorQueryInternalServerError;
  saml2_sp_sso_url: Saml2SpSsoUrlPayloadQueryValidationErrorQueryInternalServerError;
  saml2_trusted_idps: Saml2TrustedIdpsPayloadQueryValidationErrorQueryInternalServerError;
};


export type AuthenticationSaml2NamespaceQuerySaml2_ClaimsArgs = {
  input: GetSaml2ClaimsInput;
};


export type AuthenticationSaml2NamespaceQuerySaml2_Idp_ConfigurationArgs = {
  input: GetSaml2IdpConfigurationInput;
};


export type AuthenticationSaml2NamespaceQuerySaml2_Idp_MetadataArgs = {
  input: GetSaml2IdpMetadataInput;
};


export type AuthenticationSaml2NamespaceQuerySaml2_Service_ProvidersArgs = {
  input: GetSaml2ServiceProvidersInput;
};


export type AuthenticationSaml2NamespaceQuerySaml2_Sp_ConfigurationArgs = {
  input: GetSaml2SpConfigurationInput;
};


export type AuthenticationSaml2NamespaceQuerySaml2_Sp_MetadataArgs = {
  input: GetSaml2SpMetadataInput;
};


export type AuthenticationSaml2NamespaceQuerySaml2_Sp_Sso_UrlArgs = {
  input: GetSaml2SpSsoUrlInput;
};


export type AuthenticationSaml2NamespaceQuerySaml2_Trusted_IdpsArgs = {
  input: GetSaml2TrustedIdpsInput;
};

/** Returned when a user is not authorized to access a resource (403). */
export type AuthorizationErrorResponse = {
  __typename?: 'AuthorizationErrorResponse';
  code: Scalars['String']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type AuthorizationServerNamespaceMutation = {
  __typename?: 'AuthorizationServerNamespaceMutation';
  create_oauth_client: CreateOAuthClientPayloadValidationMutationErrorIntegrityErrorMutationErrorInternalServerMutationError;
  deactivate_oauth_client: DeactivateOAuthClientPayloadValidationMutationErrorInternalServerMutationError;
  oauth_authorize: OAuthAuthorizePayloadOAuthErrorResponse;
  oauth_register: OAuthRegisterClientPayloadOAuthErrorResponse;
  oauth_revoke: OAuthTokenPayloadOAuthErrorResponse;
  oauth_token: OAuthTokenPayloadOAuthErrorResponse;
  rotate_client_secret: RotateClientSecretPayloadValidationMutationErrorInternalServerMutationError;
  update_oauth_client: OAuthClientPayloadValidationMutationErrorInternalServerMutationError;
};


export type AuthorizationServerNamespaceMutationCreate_Oauth_ClientArgs = {
  input: CreateOAuthClientInput;
};


export type AuthorizationServerNamespaceMutationDeactivate_Oauth_ClientArgs = {
  input: DeactivateOAuthClientInput;
};


export type AuthorizationServerNamespaceMutationOauth_AuthorizeArgs = {
  input: OAuthAuthorizeInput;
};


export type AuthorizationServerNamespaceMutationOauth_RegisterArgs = {
  input: OAuthRegisterClientInput;
};


export type AuthorizationServerNamespaceMutationOauth_RevokeArgs = {
  input: OAuthRevokeInput;
};


export type AuthorizationServerNamespaceMutationOauth_TokenArgs = {
  input: OAuthTokenInput;
};


export type AuthorizationServerNamespaceMutationRotate_Client_SecretArgs = {
  input: RotateClientSecretInput;
};


export type AuthorizationServerNamespaceMutationUpdate_Oauth_ClientArgs = {
  input: UpdateOAuthClientInput;
};

export type AuthorizationServerNamespaceQuery = {
  __typename?: 'AuthorizationServerNamespaceQuery';
  get_oauth_client: OAuthClientPayloadQueryValidationErrorQueryInternalServerError;
  jwks: JwksPayload;
  list_oauth_clients: OAuthClientsPayloadQueryInternalServerError;
  oauth_introspect: OAuthIntrospectPayloadOAuthErrorResponse;
  oauth_userinfo: OAuthUserinfoPayloadOAuthErrorResponse;
  openid_configuration: OpenidConfigurationPayload;
};


export type AuthorizationServerNamespaceQueryGet_Oauth_ClientArgs = {
  input: GetOAuthClientInput;
};


export type AuthorizationServerNamespaceQueryList_Oauth_ClientsArgs = {
  input: ListOAuthClientsInput;
};


export type AuthorizationServerNamespaceQueryOauth_IntrospectArgs = {
  input: OAuthIntrospectInput;
};


export type AuthorizationServerNamespaceQueryOauth_UserinfoArgs = {
  input: OAuthUserinfoInput;
};

export type AutoactivateCentralizedUserPayload = {
  __typename?: 'AutoactivateCentralizedUserPayload';
  centralized_user_organization_id: Scalars['ID']['output'];
};

export type AutoactivateCentralizedUserPayloadValidationMutationErrorInternalServerMutationError = AutoactivateCentralizedUserPayload | InternalServerMutationError | ValidationMutationError;

export enum AutocompleteFieldsTemplateEnum {
  SignerEmail = 'SIGNER_EMAIL',
  SignerLastname = 'SIGNER_LASTNAME',
  SignerName = 'SIGNER_NAME'
}

export type AutomatedTasksMutations = {
  __typename?: 'AutomatedTasksMutations';
  create_or_get_task_admin: CoursesCreateOrGetTaskResponse;
};


export type AutomatedTasksMutationsCreate_Or_Get_Task_AdminArgs = {
  input: CoursesAutomatedCreateOrGetTaskInput;
};

export type AutomationBuilderMutation = {
  __typename?: 'AutomationBuilderMutation';
  create_automation_rule: AutomationRuleResponse;
  delete_automation_rule: AutomationRuleResponse;
  update_automation_rule: AutomationRuleResponse;
};


export type AutomationBuilderMutationCreate_Automation_RuleArgs = {
  input: AutomationRuleInput;
};


export type AutomationBuilderMutationDelete_Automation_RuleArgs = {
  input: AutomationRuleDeleteInput;
};


export type AutomationBuilderMutationUpdate_Automation_RuleArgs = {
  input: AutomationRuleUpdateInput;
};

export type AutomationBuilderQuery = {
  __typename?: 'AutomationBuilderQuery';
  get_automation_rule_by_admin?: Maybe<PrivateAutomationRuleFragment>;
  get_eligible_automation_courses_by_admin: AutomationCoursePageNumberPagination;
  get_segmented_users_list_by_admin: SegmentedUsersPageNumberPagination;
};


export type AutomationBuilderQueryGet_Automation_Rule_By_AdminArgs = {
  input: AutomationRuleGetInput;
};


export type AutomationBuilderQueryGet_Eligible_Automation_Courses_By_AdminArgs = {
  input: EligibleAutomationCoursesInput;
};


export type AutomationBuilderQueryGet_Segmented_Users_List_By_AdminArgs = {
  input: SegmentedUsersListInput;
};

export enum AutomationConditionalTypesEnum {
  AcBeginsWith = 'AC_BEGINS_WITH',
  AcContains = 'AC_CONTAINS',
  AcEndsWith = 'AC_ENDS_WITH',
  AcEqualTo = 'AC_EQUAL_TO',
  AcNotContains = 'AC_NOT_CONTAINS',
  AcNotEqualTo = 'AC_NOT_EQUAL_TO'
}

export type AutomationCourseMetadataType = {
  __typename?: 'AutomationCourseMetadataType';
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type AutomationCoursePageNumberPagination = {
  __typename?: 'AutomationCoursePageNumberPagination';
  edges: Array<AutomationCourseTypePaginationEdge>;
  metadata?: Maybe<AutomationCourseMetadataType>;
  /** Information to aid in pagination. */
  page_info: NumberPageInfo;
  page_size?: Maybe<Scalars['Int']['output']>;
};

export type AutomationCourseProfessorType = {
  __typename?: 'AutomationCourseProfessorType';
  full_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type AutomationCourseType = {
  __typename?: 'AutomationCourseType';
  audio: Array<Scalars['String']['output']>;
  catalog_categories: Array<CatalogCategoryNode>;
  course_type?: Maybe<CourseTypeEnum>;
  description?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  level: LevelType;
  professor?: Maybe<AutomationCourseProfessorType>;
  promo_image?: Maybe<ImageNode>;
  subtitle: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  trailer_source?: Maybe<CourseVideoTrailerNode>;
};

export type AutomationCourseTypePaginationEdge = {
  __typename?: 'AutomationCourseTypePaginationEdge';
  /** The item at the end of the edge. */
  node: AutomationCourseType;
};

export type AutomationCustomizationInput = {
  activation_dates: CustomizationActivationDateInput;
  automation_frequency: AutomationRuleFrequencyEnum;
  notify_users_via_email?: InputMaybe<Scalars['Boolean']['input']>;
  unsubscribe_users?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutomationGraphOperationI = {
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type AutomationRuleAssignedContentTypeInput = {
  course_ids_list?: InputMaybe<Array<Scalars['ID']['input']>>;
  rule_type: AutomationRuleTypeEnum;
  skill_xp_test_ids_list?: InputMaybe<Array<Scalars['ID']['input']>>;
  team_ids_list?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AutomationRuleConditionalTypeI = {
  conditional_type: AutomationConditionalTypesEnum;
  custom_field?: Maybe<B2BCustomFieldType>;
  id: Scalars['ID']['output'];
};

/** [Input] usage in update_automation_rule */
export type AutomationRuleConfigurationsInput = {
  content_type: AutomationRuleAssignedContentTypeInput;
  /** period during which the automation is activated to add users who meet the segmentation rules */
  customization_rules?: InputMaybe<AutomationCustomizationInput>;
  /** Segment users using attributes as rules */
  segmentation_rules?: InputMaybe<Array<SegmentationRulesInput>>;
  settings: AutomationRuleSettingInput;
  users?: InputMaybe<AutomationRuleEligibleUsersInput>;
};

export type AutomationRuleCustomizationType = {
  __typename?: 'AutomationRuleCustomizationType';
  activation_dates?: Maybe<CustomizationActivationDateType>;
  automation_frequency?: Maybe<AutomationRuleFrequencyEnum>;
  id: Scalars['ID']['output'];
  notify_users_via_email?: Maybe<Scalars['Boolean']['output']>;
  unsubscribe_users?: Maybe<Scalars['Boolean']['output']>;
};

/** [Mutation] delete_automation_rule */
export type AutomationRuleDeleteInput = {
  automation_rule_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AutomationRuleEligibleUsersInput = {
  has_select_all?: InputMaybe<Scalars['Boolean']['input']>;
  ids_in_rule_list?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids_out_rule_list?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum AutomationRuleFrequencyEnum {
  Daily = 'DAILY'
}

/** [Query] get_automation_rule_by_admin */
export type AutomationRuleGetInput = {
  automation_rule_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

/** [Mutation] create_automation_rule */
export type AutomationRuleInput = {
  content_type: AutomationRuleAssignedContentTypeInput;
  /** period during which the automation is activated to add users who meet the segmentation rules */
  customization_rules?: InputMaybe<AutomationCustomizationInput>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Segment users using attributes as rules */
  segmentation_rules?: InputMaybe<Array<SegmentationRulesInput>>;
  settings: AutomationRuleSettingInput;
  users?: InputMaybe<AutomationRuleEligibleUsersInput>;
};

export type AutomationRulePayload = AutomationGraphOperationI & {
  __typename?: 'AutomationRulePayload';
  automation_rule?: Maybe<PrivateAutomationRuleFragment>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type AutomationRuleResponse = AutomationRulePayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type AutomationRuleSegmentationListType = AutomationRuleConditionalTypeI & {
  __typename?: 'AutomationRuleSegmentationListType';
  conditional_type: AutomationConditionalTypesEnum;
  custom_field?: Maybe<B2BCustomFieldType>;
  id: Scalars['ID']['output'];
  list_value?: Maybe<Array<Scalars['String']['output']>>;
};

export type AutomationRuleSegmentationTextType = AutomationRuleConditionalTypeI & {
  __typename?: 'AutomationRuleSegmentationTextType';
  conditional_type: AutomationConditionalTypesEnum;
  custom_field?: Maybe<B2BCustomFieldType>;
  id: Scalars['ID']['output'];
  text_value?: Maybe<Scalars['String']['output']>;
};

export type AutomationRuleSettingInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  is_paused?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Date when users are added to the platform (including reactivated users). You can select a date range or apply the rules to all */
  user_creation_date_range?: InputMaybe<UserCreationDateRangeInput>;
};

export enum AutomationRuleTypeEnum {
  AutomationRuleTypeCourse = 'AUTOMATION_RULE_TYPE_COURSE',
  AutomationRuleTypeOnboarding = 'AUTOMATION_RULE_TYPE_ONBOARDING',
  AutomationRuleTypeSkillXp = 'AUTOMATION_RULE_TYPE_SKILL_XP'
}

/** [Mutation] update_automation_rule */
export type AutomationRuleUpdateInput = {
  automation_rule_configurations: AutomationRuleConfigurationsInput;
  automation_rule_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AutomationSegmentationRulesFragment = AutomationRuleSegmentationListType | AutomationRuleSegmentationTextType;

export type AutomationSegmentationRulesFragmentListResponse = {
  __typename?: 'AutomationSegmentationRulesFragmentListResponse';
  items: Array<AutomationSegmentationRulesFragment>;
  total_count?: Maybe<Scalars['Int']['output']>;
  total_count_by_list?: Maybe<Scalars['Int']['output']>;
  total_count_by_text?: Maybe<Scalars['Int']['output']>;
};

export enum AutomationUserTypeEnum {
  Administrator = 'ADMINISTRATOR',
  User = 'USER'
}

export type AvatarTalentType = {
  __typename?: 'AvatarTalentType';
  absolute_url?: Maybe<Scalars['String']['output']>;
  relative_url?: Maybe<Scalars['String']['output']>;
};

/** Dimension used to group the performance average results. LEADERS groups employees by their direct manager (boss_id). */
export enum AverageGroupByDimension {
  Country = 'COUNTRY',
  Department = 'DEPARTMENT',
  Job = 'JOB',
  Leaders = 'LEADERS',
  Subsidiary = 'SUBSIDIARY'
}

export type B2BCustomFieldAffectedUsersConnection = {
  __typename?: 'B2BCustomFieldAffectedUsersConnection';
  edges: Array<UserNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type B2BCustomFieldBuilderQuery = {
  __typename?: 'B2BCustomFieldBuilderQuery';
  /** Query to get the list of users affected by a group of custom selected fields */
  get_b2b_affected_users: B2BCustomFieldAffectedUsersConnection;
  /** Query to list B2B Custom Fields */
  get_b2b_custom_fields: B2BCustomFieldConnection;
};


export type B2BCustomFieldBuilderQueryGet_B2b_Affected_UsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: B2BLisAffectedUsersInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type B2BCustomFieldBuilderQueryGet_B2b_Custom_FieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: B2BCustomFieldsInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type B2BCustomFieldConnection = {
  __typename?: 'B2BCustomFieldConnection';
  edges: Array<LearningCustomFieldNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum B2BCustomFieldOrderByEnum {
  Name = 'NAME'
}

export type B2BCustomFieldOrderByInput = {
  direction: OrderDirectionEnum;
  field: B2BCustomFieldOrderByEnum;
};

export enum B2BCustomFieldSearchOperatorEnum {
  AndOperator = 'AND_OPERATOR',
  OrOperator = 'OR_OPERATOR'
}

export type B2BCustomFieldType = {
  __typename?: 'B2BCustomFieldType';
  custom_field_type?: Maybe<CustomFieldType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Input for B2B Custom Field and the answer values */
export type B2BCustomFieldsAndAnswerInput = {
  custom_field_answer: Scalars['String']['input'];
  custom_field_id: Scalars['UUID']['input'];
};

/** Input for B2B Custom Fields Query */
export type B2BCustomFieldsInput = {
  custom_field_id?: InputMaybe<Scalars['Int']['input']>;
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  order_by?: InputMaybe<Array<B2BCustomFieldOrderByInput>>;
  organization_id: Scalars['Int']['input'];
  search_key?: InputMaybe<Scalars['String']['input']>;
};

/** Input for B2B Get affected users Query */
export type B2BLisAffectedUsersInput = {
  custom_field_details: Array<B2BCustomFieldsAndAnswerInput>;
  filters?: InputMaybe<AffectedUsersFilterInput>;
  operator: B2BCustomFieldSearchOperatorEnum;
  organization_id: Scalars['Int']['input'];
};

/** Tipo de cuenta bancaria para dispersión de nómina. */
export enum BankAccountTypeEnum {
  Ahorro = 'AHORRO',
  Clabe = 'CLABE',
  Debito = 'DEBITO'
}

export type BankListResponse = {
  __typename?: 'BankListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<BankType>;
};

export type BankResponse = {
  __typename?: 'BankResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: BankType;
};

export type BankType = {
  __typename?: 'BankType';
  bank_code: Scalars['String']['output'];
  bank_name: Scalars['String']['output'];
  corporate_color?: Maybe<Scalars['String']['output']>;
  country_code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_configured: Scalars['Boolean']['output'];
  spei_code?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type BaseAnswerI = {
  answer_text?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type BaseEnrollmentUserQuizFormI = {
  approved_at?: Maybe<Scalars['DateTime']['output']>;
  attempts: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_closed: Scalars['Boolean']['output'];
  quiz: QuizType;
  quiz_form_id?: Maybe<Scalars['Int']['output']>;
  status: UserQuizFormStatusEnum;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** Base field type */
export type BaseFieldType = {
  /** Whether the field is visible. */
  is_visible: Scalars['Boolean']['output'];
};

export type BaseImageFileType = {
  __typename?: 'BaseImageFileType';
  image_file?: Maybe<File>;
};

export type BaseImagePathType = {
  __typename?: 'BaseImagePathType';
  image_url?: Maybe<Scalars['String']['output']>;
};

export type BaseMetaDataNode = {
  __typename?: 'BaseMetaDataNode';
  response_message?: Maybe<Scalars['String']['output']>;
  total_records?: Maybe<Scalars['Int']['output']>;
};

export type BaseQuestionI = {
  attachment_id?: Maybe<Scalars['Int']['output']>;
  feedback_text?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  question_help_text?: Maybe<Scalars['String']['output']>;
  question_text?: Maybe<Scalars['String']['output']>;
  question_type?: Maybe<Scalars['String']['output']>;
};

export type BaseQuizI = {
  approval_method?: Maybe<QuizApprovalMethodEnum>;
  approval_percentage?: Maybe<QuizApprovalEnum>;
  approval_points?: Maybe<Scalars['Int']['output']>;
  has_dinamic_questions?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_completed_course_required?: Maybe<Scalars['Boolean']['output']>;
  max_points?: Maybe<Scalars['Int']['output']>;
  num_question?: Maybe<Scalars['Int']['output']>;
  number_dinamic_questions?: Maybe<Scalars['Int']['output']>;
  quiz_type?: Maybe<QuizTypeEnum>;
  retry_limit?: Maybe<QuizRetryLimitEnum>;
  retry_time?: Maybe<QuizRetryTimeEnum>;
  show_answers?: Maybe<QuizShowAnswerEnum>;
  show_answers_immediately?: Maybe<Scalars['Boolean']['output']>;
  time_to_complete?: Maybe<QuizTimeLimitEnum>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Input for create or update live session video class */
export type BasicLiveSessionInput = {
  cover_file_id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_date: Scalars['String']['input'];
  instructor_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  session_title: Scalars['String']['input'];
  start_date: Scalars['String']['input'];
  time_zone: SessionTimeZoneEnum;
  type_session: SessionTypeEnum;
};

export type BatchAttributes = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  data: Scalars['JSON']['input'];
  max_bytes?: Scalars['Int']['input'];
  max_latency?: Scalars['Int']['input'];
  max_messages?: Scalars['Int']['input'];
  message: Scalars['String']['input'];
  method: Scalars['String']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  schema: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};

export enum BatchMode {
  CreateOnly = 'CREATE_ONLY',
  CreateOrUpdate = 'CREATE_OR_UPDATE',
  UpdateOnly = 'UPDATE_ONLY'
}

export type BatchOperationError = {
  __typename?: 'BatchOperationError';
  field?: Maybe<Scalars['String']['output']>;
  movement_id: Scalars['UUID']['output'];
  reason: Scalars['String']['output'];
};

export type BatchResponse = JobPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type BehaviorForm = {
  __typename?: 'BehaviorForm';
  completed_behavior?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  original_id?: Maybe<Scalars['Int']['output']>;
  questions?: Maybe<Array<Maybe<QuestionForm>>>;
};

export type Benefit = AbstractBenefit & {
  __typename?: 'Benefit';
  attachments: BenefitAttachmentFragmentListType;
  categories: StrListType;
  description?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<TimeStampType>;
  external_link?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_expired: Scalars['Boolean']['output'];
  is_highlighted: Scalars['Boolean']['output'];
  /** Flags this benefit as a custom override of a core benefit */
  is_override?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  provider: BenefitProvider;
  redemption_code?: Maybe<BenefitRedemptionCode>;
  /** Indicates whether the benefit is currently valid for redemption based on its expiration status. */
  validity_status?: Maybe<BenefitValidityStatusEnum>;
};

export type BenefitAsHighlightedInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  is_highlighted?: Scalars['Boolean']['input'];
};

export type BenefitAttachmentFragment = BenefitAttachmentImage | BenefitAttachmentPdf;

export type BenefitAttachmentFragmentListType = {
  __typename?: 'BenefitAttachmentFragmentListType';
  items: Array<BenefitAttachmentFragment>;
  total_count: Scalars['Int']['output'];
  total_filtered: Scalars['Int']['output'];
};

export type BenefitAttachmentImage = AbstractAttachment & {
  __typename?: 'BenefitAttachmentImage';
  file: File;
  id: Scalars['ID']['output'];
};

export type BenefitAttachmentPdf = AbstractAttachment & {
  __typename?: 'BenefitAttachmentPDF';
  description?: Maybe<Scalars['String']['output']>;
  file: File;
  id: Scalars['ID']['output'];
};

export type BenefitBenefitPaginationEdge = {
  __typename?: 'BenefitBenefitPaginationEdge';
  /** The item at the end of the edge. */
  node: Benefit;
};

export type BenefitCategoriesPayload = BenefitGraphQlOperation & {
  __typename?: 'BenefitCategoriesPayload';
  categories: BenefitCategoryListType;
  graphql_operation_id: Scalars['ID']['output'];
};

export type BenefitCategoriesResponse = BenefitCategoriesPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type BenefitCategory = AbstractBenefitCategory & {
  __typename?: 'BenefitCategory';
  icon_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BenefitCategoryListType = {
  __typename?: 'BenefitCategoryListType';
  items: Array<BenefitCategory>;
  total_count: Scalars['Int']['output'];
  total_filtered: Scalars['Int']['output'];
};

export type BenefitFragment = AdminBenefit | Benefit;

export type BenefitFragmentListType = {
  __typename?: 'BenefitFragmentListType';
  items: Array<BenefitFragment>;
  total_count: Scalars['Int']['output'];
  total_filtered: Scalars['Int']['output'];
};

export type BenefitGraphQlOperation = {
  graphql_operation_id: Scalars['ID']['output'];
};

export type BenefitHighlightedStats = {
  __typename?: 'BenefitHighlightedStats';
  current_benefits_highlighted: Scalars['Int']['output'];
  max_highlighted_benefits: Scalars['Int']['output'];
};

export type BenefitListPayload = BenefitGraphQlOperation & {
  __typename?: 'BenefitListPayload';
  benefits: BenefitFragmentListType;
  graphql_operation_id: Scalars['ID']['output'];
};

export type BenefitListResponse = BenefitListPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type BenefitListType = {
  __typename?: 'BenefitListType';
  items: Array<Benefit>;
  total_count: Scalars['Int']['output'];
  total_filtered: Scalars['Int']['output'];
};

export type BenefitMetadata = {
  __typename?: 'BenefitMetadata';
  total_count: Scalars['Int']['output'];
  total_filtered: Scalars['Int']['output'];
};

export type BenefitMutationBuilder = {
  __typename?: 'BenefitMutationBuilder';
  mark_benefit_as_highlighted_by_admin: BenefitResponse;
  set_benefit: Scalars['String']['output'];
  update_benefit_publish_states_by_admin: BenefitListResponse;
  update_catalog_settings_by_admin: CatalogSettingsResponse;
};


export type BenefitMutationBuilderMark_Benefit_As_Highlighted_By_AdminArgs = {
  input: MarkBenefitAsHighlightedInput;
};


export type BenefitMutationBuilderUpdate_Benefit_Publish_States_By_AdminArgs = {
  input: ToggleBenefitPublishStateInput;
};


export type BenefitMutationBuilderUpdate_Catalog_Settings_By_AdminArgs = {
  input: UpdateCatalogSettingsInput;
};

export type BenefitNumPageInfo = GamificationPageInfoInterface & {
  __typename?: 'BenefitNumPageInfo';
  /** When paginating forwards, are there more items? */
  has_next_page: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  has_previous_page: Scalars['Boolean']['output'];
  page_size: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type BenefitPayload = BenefitGraphQlOperation & {
  __typename?: 'BenefitPayload';
  benefit: BenefitFragment;
  graphql_operation_id: Scalars['ID']['output'];
};

export type BenefitProvider = {
  __typename?: 'BenefitProvider';
  icon: File;
  id: Scalars['ID']['output'];
  is_custom: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type BenefitProviderBenefitProviderMetadataPaginatedListType = {
  __typename?: 'BenefitProviderBenefitProviderMetadataPaginatedListType';
  items: Array<BenefitProvider>;
  metadata: BenefitProviderMetadata;
  page_info: BenefitNumPageInfo;
};

export type BenefitProviderListPayload = BenefitGraphQlOperation & {
  __typename?: 'BenefitProviderListPayload';
  graphql_operation_id: Scalars['ID']['output'];
  providers: BenefitProviderBenefitProviderMetadataPaginatedListType;
};

export type BenefitProviderMetadata = GenericMetadataType & {
  __typename?: 'BenefitProviderMetadata';
  total_count: Scalars['Int']['output'];
  total_filtered: Scalars['Int']['output'];
};

export enum BenefitPublishStateEnum {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type BenefitQueryBuilder = {
  __typename?: 'BenefitQueryBuilder';
  get_allowed_country_filters: CoreCountryResponse;
  get_benefit_by_admin: BenefitResponse;
  get_benefit_categories: BenefitCategoriesResponse;
  get_benefit_categories_by_admin: AdminBenefitCategoriesResponse;
  get_benefit_category_by_admin: AdminBenefitCategoryResponse;
  get_benefit_providers_by_admin: ProviderListResponse;
  get_benefits: BenefitsConnection;
  get_benefits_by_admin: AdminBenefitsConnection;
  get_catalog_settings: CatalogSettingsResponse;
  get_catalog_settings_by_admin: CatalogSettingsResponse;
  get_core_countries_by_admin: CoreCountryResponse;
  get_highlighted_carousel: HighlightedCarouselResponse;
};


export type BenefitQueryBuilderGet_Allowed_Country_FiltersArgs = {
  input: CollaboratorCoreCountryListInput;
};


export type BenefitQueryBuilderGet_Benefit_By_AdminArgs = {
  input: AdminBenefitIInput;
};


export type BenefitQueryBuilderGet_Benefit_CategoriesArgs = {
  input: CollaboratorCategoriesListInput;
};


export type BenefitQueryBuilderGet_Benefit_Categories_By_AdminArgs = {
  input: AdminCategoriesListInput;
};


export type BenefitQueryBuilderGet_Benefit_Category_By_AdminArgs = {
  input: AdminCategoryInput;
};


export type BenefitQueryBuilderGet_Benefit_Providers_By_AdminArgs = {
  input: AdminProviderListInput;
};


export type BenefitQueryBuilderGet_BenefitsArgs = {
  input: CollaboratorBenefitsInput;
};


export type BenefitQueryBuilderGet_Benefits_By_AdminArgs = {
  input: AdminBenefitsInput;
};


export type BenefitQueryBuilderGet_Catalog_SettingsArgs = {
  input: CollaboratorCatalogSettingsInput;
};


export type BenefitQueryBuilderGet_Catalog_Settings_By_AdminArgs = {
  input: AdminCatalogSettingsInput;
};


export type BenefitQueryBuilderGet_Core_Countries_By_AdminArgs = {
  input: AdminCoreCountryListInput;
};


export type BenefitQueryBuilderGet_Highlighted_CarouselArgs = {
  input: CollaboratorCarouselListInput;
};

export type BenefitRedemptionCode = {
  __typename?: 'BenefitRedemptionCode';
  code: Scalars['String']['output'];
  expires_at?: Maybe<TimeStampType>;
  id: Scalars['ID']['output'];
  is_expired?: Maybe<Scalars['Boolean']['output']>;
};

export type BenefitResponse = BenefitPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type BenefitSearchInput = {
  category_id?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<CountryCodeEnum>;
  search_text?: InputMaybe<Scalars['String']['input']>;
};

export enum BenefitTypeEnum {
  /** Benefit provided by Crehana */
  Crehana = 'CREHANA',
  /** Benefit for own use */
  Own = 'OWN'
}

export enum BenefitValidityStatusEnum {
  /** Currently active and valid */
  Active = 'ACTIVE',
  /** Validity period has ended */
  Expired = 'EXPIRED',
  /** No validity period assigned */
  NoValidity = 'NO_VALIDITY'
}

export enum BenefitViewScopeEnum {
  SeeAllCountries = 'SEE_ALL_COUNTRIES',
  SeeOnlyYourCountry = 'SEE_ONLY_YOUR_COUNTRY'
}

export enum BenefitVisibilityStateEnum {
  Hidden = 'HIDDEN',
  Visible = 'VISIBLE'
}

export type BenefitsConnection = {
  __typename?: 'BenefitsConnection';
  /** A list of edges in this connection. */
  edges: Array<BenefitBenefitPaginationEdge>;
  metadata?: Maybe<BenefitMetadata>;
  /** Information to aid in pagination. */
  page_info: BenefitNumPageInfo;
};

export type BenefitsInCategoryNumPageInput = {
  first?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};

export type BidirectionalitySynchronizationMutationResponse = {
  __typename?: 'BidirectionalitySynchronizationMutationResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type BlockPlayerMutations = {
  __typename?: 'BlockPlayerMutations';
  update_block_player_by_organization: UpdateBlockPlayerByOrganizationResponse;
  update_block_player_by_organization_course: UpdateBlockPlayerByOrganizationCourseResponse;
};


export type BlockPlayerMutationsUpdate_Block_Player_By_OrganizationArgs = {
  input: UpdateBlockPlayerByOrganizationInput;
};


export type BlockPlayerMutationsUpdate_Block_Player_By_Organization_CourseArgs = {
  input: UpdateBlockPlayerByOrganizationCourseInput;
};

export type BlockPlayerQuery = {
  __typename?: 'BlockPlayerQuery';
  get_block_player_by_organization: GetBlockPlayerByOrganizationType;
  get_block_player_by_organization_course: GetBlockPlayerByOrganizationCourseType;
};


export type BlockPlayerQueryGet_Block_Player_By_OrganizationArgs = {
  input: GetBlockPlayerByOrganizationInput;
};


export type BlockPlayerQueryGet_Block_Player_By_Organization_CourseArgs = {
  input: GetBlockPlayerByOrganizationCourseInput;
};

export type BlogQuery = {
  __typename?: 'BlogQuery';
  article: Query;
};

export type BossFollowTracksType = {
  __typename?: 'BossFollowTracksType';
  pid_tracks_with_boss_follow: Scalars['Int']['output'];
  total_pid_tracks: Scalars['Int']['output'];
};

/** Boss or leader information for an employee. */
export type BossInfoNode = {
  __typename?: 'BossInfoNode';
  /** Boss email address. */
  email: Scalars['String']['output'];
  /** Boss first name. */
  firstname: Scalars['String']['output'];
  /** Boss last name. */
  lastname: Scalars['String']['output'];
  /** Boss job title. Null if the boss has no position assigned. */
  position_name?: Maybe<Scalars['String']['output']>;
  /** Boss centralized user ID. */
  user_id: Scalars['Int']['output'];
};

/** Allowed IMSS branch codes. */
export enum BranchCodeEnum {
  EmCuotaFija = 'EM_CUOTA_FIJA',
  EmExcedente_3Uma = 'EM_EXCEDENTE_3UMA',
  EmGastosMedicosPensionados = 'EM_GASTOS_MEDICOS_PENSIONADOS',
  EmPrestacionesDinero = 'EM_PRESTACIONES_DINERO',
  GpsPrincipal = 'GPS_PRINCIPAL',
  IvPrincipal = 'IV_PRINCIPAL',
  RcvCesantiaVejez = 'RCV_CESANTIA_VEJEZ',
  RcvRetiro = 'RCV_RETIRO',
  RtPrimaRiesgo = 'RT_PRIMA_RIESGO'
}

export enum BucketsEnum {
  CentralizedPrivateB2B = 'CENTRALIZED_PRIVATE_B2B',
  PrivateAttendancePhotos = 'PRIVATE_ATTENDANCE_PHOTOS',
  PrivateAuditlogReports = 'PRIVATE_AUDITLOG_REPORTS',
  PrivateB2B = 'PRIVATE_B2B',
  PrivateCertificateSignatures = 'PRIVATE_CERTIFICATE_SIGNATURES',
  PrivateCourseAttachment = 'PRIVATE_COURSE_ATTACHMENT',
  PrivateHris = 'PRIVATE_HRIS',
  PrivateIntercomms = 'PRIVATE_INTERCOMMS',
  PrivateTalentGeneral = 'PRIVATE_TALENT_GENERAL',
  PrivateTalentRecode = 'PRIVATE_TALENT_RECODE',
  PrivateUser = 'PRIVATE_USER',
  PrivateVideoSource = 'PRIVATE_VIDEO_SOURCE',
  PublicCatalog = 'PUBLIC_CATALOG',
  PublicDev = 'PUBLIC_DEV',
  PublicLesson = 'PUBLIC_LESSON',
  PublicSubtitle = 'PUBLIC_SUBTITLE',
  PublicTrailer = 'PUBLIC_TRAILER',
  PublicUser = 'PUBLIC_USER',
  PublicVideo = 'PUBLIC_VIDEO'
}

export type BuildInputs = {
  bucket: BucketsEnum;
  centralized_id?: InputMaybe<Scalars['Int']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  content_type: Scalars['String']['input'];
  file_path: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filepath?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type BuilderBatchMutation = {
  __typename?: 'BuilderBatchMutation';
  create_job: BatchResponse;
  run_job: BatchResponse;
};


export type BuilderBatchMutationCreate_JobArgs = {
  input: CreateJobInputs;
};


export type BuilderBatchMutationRun_JobArgs = {
  input: UpdateJobInputs;
};

export type BuilderFileMutation = {
  __typename?: 'BuilderFileMutation';
  create_object: AddFileResponse;
  generate_pre_signed_post: PreSignedResponse;
  update_status: UpdateStatusFileResponse;
};


export type BuilderFileMutationCreate_ObjectArgs = {
  input: BuildInputs;
};


export type BuilderFileMutationGenerate_Pre_Signed_PostArgs = {
  input: UploadFilePreSignedUrlInput;
};


export type BuilderFileMutationUpdate_StatusArgs = {
  input: UpdateStatusInputs;
};

export type BulkCreateAnswersPayload = GraphOperationI & {
  __typename?: 'BulkCreateAnswersPayload';
  answers?: Maybe<Array<PrivateAnswerChoiceType>>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

export type BulkCreateAnswersResponse = BulkCreateAnswersPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type BulkCreateOrUpdateQuizQuestionInput = {
  questions: Array<CreateOrUpdateQuestionBlockInput>;
  quiz_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Error detail for a single position in synchronous bulk creation. */
export type BulkCreatePositionErrorItem = {
  __typename?: 'BulkCreatePositionErrorItem';
  /** Position code that failed */
  code?: Maybe<Scalars['String']['output']>;
  /** Error detail */
  error: Scalars['String']['output'];
  /** Row index (1-based) of the failed position */
  index?: Maybe<Scalars['Int']['output']>;
  /** Position name that failed */
  name?: Maybe<Scalars['String']['output']>;
};

export type BulkCreatePositionsSyncInput = {
  organization_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
  positions: Array<PositionItemSyncInput>;
  send_to_talent?: Scalars['Boolean']['input'];
};

/** Result of synchronous bulk position creation, designed for agent use. */
export type BulkCreatePositionsSyncPayload = {
  __typename?: 'BulkCreatePositionsSyncPayload';
  /** Number of positions created */
  created: Scalars['Int']['output'];
  /** Detail of each failed position */
  errors: Array<BulkCreatePositionErrorItem>;
  /** Number of positions that failed */
  failed: Scalars['Int']['output'];
  /** Number of positions updated */
  updated: Scalars['Int']['output'];
};

export type BulkCreatePositionsSyncResponse = BulkCreatePositionsSyncPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

export type BulkCreateQuestionsMutationNode = {
  __typename?: 'BulkCreateQuestionsMutationNode';
  cursor?: Maybe<Scalars['String']['output']>;
  /** List of errors */
  errors: Array<Scalars['String']['output']>;
  questions: QuestionConnection;
  /**
   * This object contains information about the response
   *         code, response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BulkCreateQuestionsPayload = GraphOperationI & {
  __typename?: 'BulkCreateQuestionsPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
  questions: Array<PrivateQuizQuestionType>;
};

export type BulkCreateQuestionsResponse = BulkCreateQuestionsPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type BulkCreateTransactionsNode = {
  __typename?: 'BulkCreateTransactionsNode';
  /** Contains the nodes in this connection */
  edges?: Maybe<Array<RewardTransactionNodeEdge>>;
  /** List of errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * This object contains information about the response code,
   *         response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BulkImportAdminInfo = {
  __typename?: 'BulkImportAdminInfo';
  avatar_url?: Maybe<Scalars['String']['output']>;
  full_name: Scalars['String']['output'];
  position?: Maybe<Scalars['String']['output']>;
};

export type BulkImportBatchListInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Dirección de ordenamiento por fecha de creación (ASC/DESC). Por defecto DESC. */
  order_by?: InputMaybe<OrderDirectionEnum>;
  /** Página (1-based) */
  page?: Scalars['Int']['input'];
  /** Items por página (máx. 100) */
  page_size?: Scalars['Int']['input'];
  /** Policy ID */
  policy_id: Scalars['ID']['input'];
};

export type BulkImportBatchListResponse = BulkImportBatchListResult | ForbiddenErrorResponse;

export type BulkImportBatchListResult = {
  __typename?: 'BulkImportBatchListResult';
  items: Array<BulkImportBatchNode>;
  page: Scalars['Int']['output'];
  page_size: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type BulkImportBatchNode = {
  __typename?: 'BulkImportBatchNode';
  created_by: BulkImportAdminInfo;
  error_count: Scalars['Int']['output'];
  file_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  import_batch_id: Scalars['String']['output'];
  import_date: Scalars['DateTime']['output'];
  is_restore_eligible: Scalars['Boolean']['output'];
  is_restored: Scalars['Boolean']['output'];
  restore_seconds_remaining?: Maybe<Scalars['Int']['output']>;
  restored_at?: Maybe<Scalars['DateTime']['output']>;
  restored_by_name?: Maybe<Scalars['String']['output']>;
  status: BulkImportBatchStatusEnum;
  total_records: Scalars['Int']['output'];
};

export enum BulkImportBatchStatusEnum {
  Imported = 'IMPORTED',
  InProgress = 'IN_PROGRESS',
  Omitted = 'OMITTED'
}

export type BulkImportErrorGroupResult = {
  __typename?: 'BulkImportErrorGroupResult';
  count: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  error_code: Scalars['String']['output'];
  headers: Array<Scalars['String']['output']>;
  rows: BulkImportPaginatedRows;
  title: Scalars['String']['output'];
};

export type BulkImportInfoGroupResult = {
  __typename?: 'BulkImportInfoGroupResult';
  count: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  headers: Array<Scalars['String']['output']>;
  info_code: Scalars['String']['output'];
  rows: BulkImportPaginatedRows;
  title: Scalars['String']['output'];
};

export type BulkImportPaginatedRows = {
  __typename?: 'BulkImportPaginatedRows';
  items: Array<Scalars['JSON']['output']>;
  page: Scalars['Int']['output'];
  page_size: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BulkImportPolicyBalanceInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Share file ID in the files service */
  file_id: Scalars['Int']['input'];
  /** Policy ID */
  policy_id: Scalars['ID']['input'];
};

export type BulkImportPolicyBalanceResult = ForbiddenErrorResponse | HrisExcelValidationPayload | InternalErrorResponse | ValidationErrorResponse;

export type BulkImportResultInput = {
  /** Import batch ID */
  import_batch_id: Scalars['ID']['input'];
  /** Page size for all sections */
  page_size?: Scalars['Int']['input'];
};

export type BulkImportResultNode = {
  __typename?: 'BulkImportResultNode';
  error_groups: Array<BulkImportErrorGroupResult>;
  info_groups: Array<BulkImportInfoGroupResult>;
  status: HrisExcelValidationStatusEnum;
  summary: HrisExcelValidationSummary;
  valid_rows: BulkImportValidSection;
};

export type BulkImportRowsInput = {
  /** error_code or info_code; null for VALID section */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Import batch ID */
  import_batch_id: Scalars['ID']['input'];
  /** Page number (1-based) */
  page?: Scalars['Int']['input'];
  /** Items per page */
  page_size?: Scalars['Int']['input'];
  /** Filter by email ILIKE %search% */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Section: VALID | ERROR | INFO */
  section: BulkImportSection;
};

export type BulkImportRowsResult = {
  __typename?: 'BulkImportRowsResult';
  code?: Maybe<Scalars['String']['output']>;
  headers: Array<Scalars['String']['output']>;
  items: Array<Scalars['JSON']['output']>;
  page: Scalars['Int']['output'];
  page_size: Scalars['Int']['output'];
  section: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export enum BulkImportSection {
  Error = 'ERROR',
  Info = 'INFO',
  Valid = 'VALID'
}

export type BulkImportValidSection = {
  __typename?: 'BulkImportValidSection';
  headers: Array<Scalars['String']['output']>;
  items: Array<Scalars['JSON']['output']>;
  page: Scalars['Int']['output'];
  page_size: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BulkRewardTransactionFragmentNode = AdminBulkRewardTransactionNode | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export enum BulkScheduleModeInput {
  SaveNoSchedule = 'SAVE_NO_SCHEDULE',
  ScheduleAndSave = 'SCHEDULE_AND_SAVE'
}

export type CalculatedVariableMutation = {
  __typename?: 'CalculatedVariableMutation';
  /** Dispara el calculo de variables de nomina (per empleado) para el alcance dado (razon social -> registro patronal -> centro de trabajo -> empleado, dentro de periodicidad / tipo de nomina / numero de periodo) y persiste el resultado. Re-ejecutar reemplaza la corrida previa (soft-delete + insert). `created_by` se toma de la sesion. */
  calculate_variables: PayrollCalculateVariablesResult;
};


export type CalculatedVariableMutationCalculate_VariablesArgs = {
  input: PayrollCalculateVariablesInput;
};

export type CalculatedVariableQuery = {
  __typename?: 'CalculatedVariableQuery';
  /** Lee las variables de nomina ya persistidas para un alcance de corrida. Filtra opcionalmente por empleado (`centralized_user_id`) y por impacto (`payroll_impact`). Orden: (centralized_user_id, name) asc. */
  calculated_variables: PayrollListCalculatedVariablesResult;
};


export type CalculatedVariableQueryCalculated_VariablesArgs = {
  input: PayrollListCalculatedVariablesInput;
};

/** Una variable de nomina calculada (por empleado). */
export type CalculatedVariableSchema = {
  __typename?: 'CalculatedVariableSchema';
  centralized_organization_id: Scalars['ID']['output'];
  centralized_user_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  employer_registration_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  legal_entity_id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  payroll_impact: PayrollVariableImpactEnum;
  payroll_run_version_id: Scalars['ID']['output'];
  sat_code?: Maybe<Scalars['String']['output']>;
  value: Scalars['Decimal']['output'];
  value_type: PayrollVariableValueTypeEnum;
  work_location_id?: Maybe<Scalars['ID']['output']>;
};

export type CalendarLinkType = LinkI & {
  __typename?: 'CalendarLinkType';
  absolute_url?: Maybe<Scalars['String']['output']>;
  relative_url?: Maybe<Scalars['String']['output']>;
};

export type CallbackTwilioWhatsapInput = {
  message_sid: Scalars['String']['input'];
  message_status: Scalars['String']['input'];
};

/** Sortable columns for the campaign list */
export enum CampaignSortField {
  AudienceType = 'AUDIENCE_TYPE',
  CampaignType = 'CAMPAIGN_TYPE',
  CourseCount = 'COURSE_COUNT',
  EndDate = 'END_DATE',
  Name = 'NAME',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT'
}

/** Lifecycle state of a campaign */
export enum CampaignStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Finalized = 'FINALIZED',
  Paused = 'PAUSED'
}

/** Kind of campaign */
export enum CampaignType {
  FollowUp = 'FOLLOW_UP',
  Report = 'REPORT'
}

export type CanDeleteEmployerRegistrationInput = {
  centralized_organization_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type CanDeleteEmployerRegistrationResponse = {
  __typename?: 'CanDeleteEmployerRegistrationResponse';
  can_delete: Scalars['Boolean']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  linked_work_locations_count: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type CanDeleteLegalEntityInput = {
  centralized_organization_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type CanDeleteLegalEntityResponse = {
  __typename?: 'CanDeleteLegalEntityResponse';
  can_delete: Scalars['Boolean']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  linked_employer_registrations_count: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export enum CatalogBenefitStateEnum {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type CatalogCategoryNode = {
  __typename?: 'CatalogCategoryNode';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type CatalogCategoryStudioInput = {
  category_id: Scalars['ID']['input'];
  is_principal: Scalars['Boolean']['input'];
};

export type CatalogCategoryType = {
  __typename?: 'CatalogCategoryType';
  /** Tipo de categoría (ORGANIZATION_TYPE, CREHANA_TYPE, THIRD_PARTY_TYPE) */
  category_type: Scalars['String']['output'];
  /** Descripción de la categoría */
  description?: Maybe<Scalars['String']['output']>;
  /** ID de la categoría base */
  id: Scalars['ID']['output'];
  /** URL de la imagen de la categoría */
  image_url?: Maybe<Scalars['String']['output']>;
  /** Slug de la categoría */
  slug: Scalars['String']['output'];
  /** Título de la categoría */
  title: Scalars['String']['output'];
  /** Total de cursos/contenidos en la categoría */
  total_courses: Scalars['Int']['output'];
};

export type CatalogCategoryTypeCollaboratorCatalogCategoryType = CatalogCategoryType | CollaboratorCatalogCategoryType;

export type CatalogContentType = {
  __typename?: 'CatalogContentType';
  content_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CatalogFragment = AdminCatalogType | CatalogType;

export type CatalogNodeType = {
  __typename?: 'CatalogNodeType';
  /** Categoría base principal (modelo v2; category_type del resumen virtual) */
  base_category: CollaboratorCatalogCategoryType;
  /** Lista de contenidos de la categoría */
  contents: Array<CatalogContentType>;
  /** Lista de subcategorías */
  sub_categories: Array<CollaboratorCatalogCategoryType>;
  /** Total de contenidos */
  total_count: Scalars['Int']['output'];
};

export type CatalogSettingsPayload = BenefitGraphQlOperation & {
  __typename?: 'CatalogSettingsPayload';
  catalog: CatalogFragment;
  graphql_operation_id: Scalars['ID']['output'];
};

export type CatalogSettingsResponse = CatalogSettingsPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type CatalogSubCategoryStudioInput = {
  is_principal: Scalars['Boolean']['input'];
  sub_category_id: Scalars['ID']['input'];
};

export type CatalogType = {
  __typename?: 'CatalogType';
  allowed_countries: Array<Scalars['String']['output']>;
  benefit_visibility_scope: BenefitViewScopeEnum;
  can_view_catalog_content: Scalars['Boolean']['output'];
  catalog_benefit_state: CatalogBenefitStateEnum;
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type CategoryConnection = {
  __typename?: 'CategoryConnection';
  edges: Array<CategoryNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type CategoryInputOrderBy = {
  direction: OrderDirectionEnum;
  field: CategoryOrderByEnum;
};

export type CategoryNode = {
  __typename?: 'CategoryNode';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CategoryNodeEdge = {
  __typename?: 'CategoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CategoryNode;
};

export enum CategoryOrderByEnum {
  Title = 'TITLE'
}

export type CategoryRestrictionDetailType = {
  __typename?: 'CategoryRestrictionDetailType';
  operator_restriction?: Maybe<B2BCustomFieldSearchOperatorEnum>;
  restriction_details: Array<LearningCustomFieldOptionNode>;
};

export type CategoryRestrictionType = {
  __typename?: 'CategoryRestrictionType';
  category_id: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  operator_restriction: B2BCustomFieldSearchOperatorEnum;
  organization_id: Scalars['Int']['output'];
};

export enum CategoryType {
  CrehanaType = 'CREHANA_TYPE',
  OrganizationType = 'ORGANIZATION_TYPE',
  ThirdPartyType = 'THIRD_PARTY_TYPE'
}

export enum CategoryTypeV2Enum {
  EducationCategory = 'EDUCATION_CATEGORY',
  OrganizationCategory = 'ORGANIZATION_CATEGORY'
}

export type CeleryMutation = {
  __typename?: 'CeleryMutation';
  revoke_task: CeleryRevokeTaskPayload;
  run_task: CeleryRunTaskPayload;
};


export type CeleryMutationRevoke_TaskArgs = {
  input: CeleryRevokeTaskInput;
};


export type CeleryMutationRun_TaskArgs = {
  input: CeleryRunTaskInput;
};

export type CeleryQuery = {
  __typename?: 'CeleryQuery';
  get_task_info?: Maybe<CeleryTaskmeta>;
};


export type CeleryQueryGet_Task_InfoArgs = {
  task_id: Scalars['String']['input'];
};

export enum CeleryQueueEnum {
  QueueDefault = 'QUEUE_DEFAULT',
  QueueTranscripts = 'QUEUE_TRANSCRIPTS'
}

export type CeleryRevokeTaskInput = {
  task_id: Scalars['String']['input'];
};

export type CeleryRevokeTaskPayload = {
  __typename?: 'CeleryRevokeTaskPayload';
  revoked: Scalars['Boolean']['output'];
  task?: Maybe<CeleryTaskmeta>;
};

export type CeleryRunTaskInput = {
  args?: InputMaybe<Scalars['String']['input']>;
  delay?: InputMaybe<Scalars['Int']['input']>;
  kwargs?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  queue?: InputMaybe<CeleryQueueEnum>;
  task_name: CeleryTaskNameEnum;
};

export type CeleryRunTaskPayload = {
  __typename?: 'CeleryRunTaskPayload';
  task: CeleryTaskmeta;
};

export enum CeleryStatusEnum {
  TaskFailure = 'TASK_FAILURE',
  TaskPending = 'TASK_PENDING',
  TaskQueued = 'TASK_QUEUED',
  TaskSuccess = 'TASK_SUCCESS'
}

export enum CeleryTaskNameEnum {
  TaskCourseTranscribe = 'TASK_COURSE_TRANSCRIBE',
  TaskCourseTranslate = 'TASK_COURSE_TRANSLATE',
  TaskPing = 'TASK_PING',
  TaskVideoAssignSubtitle = 'TASK_VIDEO_ASSIGN_SUBTITLE',
  TaskVideoLectureTranscribe = 'TASK_VIDEO_LECTURE_TRANSCRIBE',
  TaskVideoLectureTranscribeProcess = 'TASK_VIDEO_LECTURE_TRANSCRIBE_PROCESS',
  TaskVideoTranscriptSegments = 'TASK_VIDEO_TRANSCRIPT_SEGMENTS',
  TaskVideoTranscriptSummary = 'TASK_VIDEO_TRANSCRIPT_SUMMARY',
  TaskVideoTranslate = 'TASK_VIDEO_TRANSLATE'
}

export type CeleryTaskmeta = {
  __typename?: 'CeleryTaskmeta';
  args?: Maybe<Scalars['JSON']['output']>;
  date_created?: Maybe<Scalars['DateTime']['output']>;
  date_done?: Maybe<Scalars['DateTime']['output']>;
  kwargs?: Maybe<Scalars['JSON']['output']>;
  name: CeleryTaskNameEnum;
  queue: CeleryQueueEnum;
  result?: Maybe<Scalars['JSON']['output']>;
  retries?: Maybe<Scalars['Int']['output']>;
  status: CeleryStatusEnum;
  task_id: Scalars['String']['output'];
  traceback?: Maybe<Scalars['String']['output']>;
  worker?: Maybe<Scalars['String']['output']>;
};

export type CentralizedAdminChangeUserPasswordInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
  confirm_password: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type CentralizedAdminChangeUserUsernameInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
  username: Scalars['String']['input'];
};

export type CentralizedAdminUserProfileNode = {
  __typename?: 'CentralizedAdminUserProfileNode';
  about_me?: Maybe<Scalars['String']['output']>;
  /** activation link sent by mail */
  activation_link?: Maybe<Scalars['String']['output']>;
  additional_information: Array<CentralizedUserCustomFieldTextNodeCentralizedUserCustomFieldDateNodeCentralizedUserCustomFieldNumberNodeCentralizedUserCustomFieldMultipleNode>;
  address?: Maybe<Scalars['String']['output']>;
  areas?: Maybe<CentralizedAreaLevelsNode>;
  assigned_role: UserOrganizationRoleEnum;
  /** Centralized user avatar */
  avatar: Scalars['String']['output'];
  birthday_date?: Maybe<Scalars['DateTime']['output']>;
  boss?: Maybe<CentralizedBossUserNode>;
  cellphone?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  civil_status?: Maybe<CivilStatusEnumInput>;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  deactivation_date?: Maybe<Scalars['DateTime']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  document_type?: Maybe<DocumentTypeEnumInput>;
  emergency_contact_email?: Maybe<Scalars['String']['output']>;
  emergency_contact_email_2?: Maybe<Scalars['String']['output']>;
  emergency_contact_name?: Maybe<Scalars['String']['output']>;
  emergency_contact_name_2?: Maybe<Scalars['String']['output']>;
  emergency_contact_phone?: Maybe<Scalars['String']['output']>;
  emergency_contact_phone_2?: Maybe<Scalars['String']['output']>;
  emergency_contact_relationship?: Maybe<Scalars['String']['output']>;
  emergency_contact_relationship_2?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['DateTime']['output']>;
  gender?: Maybe<GenderEnumInput>;
  headquarters?: Maybe<CentralizedUserHeadQuarterNode>;
  /** Centralized user organization id */
  id: Scalars['Int']['output'];
  incorporation_date?: Maybe<Scalars['DateTime']['output']>;
  last_activity?: Maybe<Scalars['DateTime']['output']>;
  leaving_date?: Maybe<Scalars['DateTime']['output']>;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  personal_email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<CentralizedUserPositionNode>;
  position_category?: Maybe<CentralizedUserPositionCategoryNode>;
  /** Centralized user profile completion */
  profile_completion: Scalars['Int']['output'];
  status: UserOrganizationStatus;
  web_site_url?: Maybe<Scalars['String']['output']>;
};

export type CentralizedAdminUserProfileNodeCentralizedMeUserProfileNodeCentralizedOtherUserProfileNode = CentralizedAdminUserProfileNode | CentralizedMeUserProfileNode | CentralizedOtherUserProfileNode;

export type CentralizedAreaAts = {
  __typename?: 'CentralizedAreaATS';
  area?: Maybe<CentralizedOrganizationArea>;
  area_id: Scalars['ID']['output'];
};

export type CentralizedAreaLevelsNode = {
  __typename?: 'CentralizedAreaLevelsNode';
  level_1: CentralizedUserAreaLevelNode;
  level_2?: Maybe<CentralizedUserAreaLevelNode>;
  level_3?: Maybe<CentralizedUserAreaLevelNode>;
  level_4?: Maybe<CentralizedUserAreaLevelNode>;
};

export type CentralizedAssignBossInput = {
  boss_email: Scalars['String']['input'];
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
};

export type CentralizedAssignBossResponse = {
  __typename?: 'CentralizedAssignBossResponse';
  boss_id?: Maybe<Scalars['ID']['output']>;
  centralized_user_organization_id: Scalars['ID']['output'];
};

export type CentralizedAssignBossResponseCentralizedMutationValidationErrorCentralizedMutationInternalError = CentralizedAssignBossResponse | CentralizedMutationInternalError | CentralizedMutationValidationError;

export type CentralizedBasicUser = {
  __typename?: 'CentralizedBasicUser';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last_name: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

/** Lightweight UserOrganization node exposing only the basic user info, learning_user_id and learning_user_organization_id. */
export type CentralizedBasicUserOrganization = {
  __typename?: 'CentralizedBasicUserOrganization';
  id: Scalars['ID']['output'];
  learning_user_id?: Maybe<Scalars['ID']['output']>;
  learning_user_organization_id?: Maybe<Scalars['ID']['output']>;
  user: CentralizedBasicUser;
};

export type CentralizedBasicUserOrganizationConnection = {
  __typename?: 'CentralizedBasicUserOrganizationConnection';
  /** A list of edges in this connection. */
  edges: Array<CentralizedBasicUserOrganizationEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type CentralizedBasicUserOrganizationConnectionValidationErrorResponseInternalErrorResponse = CentralizedBasicUserOrganizationConnection | InternalErrorResponse | ValidationErrorResponse;

export type CentralizedBasicUserOrganizationEdge = {
  __typename?: 'CentralizedBasicUserOrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CentralizedBasicUserOrganization;
};

export type CentralizedBossUserNode = {
  __typename?: 'CentralizedBossUserNode';
  first_name: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_name: Scalars['String']['output'];
};

export type CentralizedChangePasswordUserPayload = {
  __typename?: 'CentralizedChangePasswordUserPayload';
  centralized_user_id: Scalars['String']['output'];
};

export type CentralizedChangeUserPassworFromRecoverCodeInput = {
  centralized_organization_id: Scalars['ID']['input'];
  confirm_password: Scalars['String']['input'];
  password: Scalars['String']['input'];
  recover_code: Scalars['String']['input'];
};

export type CentralizedChangeUserPasswordInput = {
  confirm_password: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type CentralizedChangeUserPasswordPayload = {
  __typename?: 'CentralizedChangeUserPasswordPayload';
  centralized_organization_id: Scalars['ID']['output'];
  centralized_user_id: Scalars['ID']['output'];
};

export type CentralizedChangeUserPasswordPayloadSecurityMutationErrorInternalServerMutationError = CentralizedChangeUserPasswordPayload | InternalServerMutationError | SecurityMutationError;

export type CentralizedChangeUserUsernameInput = {
  username: Scalars['String']['input'];
};

export type CentralizedChangeUserUsernamePayload = {
  __typename?: 'CentralizedChangeUserUsernamePayload';
  centralized_organization_id: Scalars['ID']['output'];
  centralized_user_id: Scalars['ID']['output'];
  raw_username: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type CentralizedChangeUserUsernamePayloadSecurityMutationErrorInternalServerMutationError = CentralizedChangeUserUsernamePayload | InternalServerMutationError | SecurityMutationError;

export type CentralizedCheckMutationResponse = {
  __typename?: 'CentralizedCheckMutationResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export enum CentralizedCivilStatusEnum {
  DeFactoUnion = 'DE_FACTO_UNION',
  Divorced = 'DIVORCED',
  FreeUnion = 'FREE_UNION',
  Married = 'MARRIED',
  Other = 'OTHER',
  Single = 'SINGLE',
  Widowed = 'WIDOWED'
}

export type CentralizedConfigurationMutation = {
  __typename?: 'CentralizedConfigurationMutation';
  set_centralized_user_configuration: SetCentralizedUserConfigurationResponseMutationValidationErrorMutationInternalError;
};


export type CentralizedConfigurationMutationSet_Centralized_User_ConfigurationArgs = {
  input: SetCentralizedUserConfigurationInput;
};

export type CentralizedCorporationsOffsetPaginationInput = {
  page: Scalars['Int']['input'];
  page_size: Scalars['Int']['input'];
};

export type CentralizedCorporationsSearchInput = {
  fields: Array<GetChildrenCompaniesSearchFieldsEnum>;
  query: Scalars['String']['input'];
};

export type CentralizedCorporationsUpdateChildrenCompanyInput = {
  centralized_organization_id: Scalars['Int']['input'];
  children_org: CentralizedCorporationsUpdateCorporationChildrenOrgInput;
};

export type CentralizedCorporationsUpdateCorporationChildrenOrgInput = {
  country: Scalars['String']['input'];
  description: Scalars['String']['input'];
  licenses: Scalars['Int']['input'];
};

/** Crear razón social. */
export type CentralizedCreateLegalEntityInput = {
  /** Dirección (calle y número) */
  address_1: Scalars['String']['input'];
  /** Dirección 2 */
  address_2?: InputMaybe<Scalars['String']['input']>;
  /** Dirección 3 */
  address_3?: InputMaybe<Scalars['String']['input']>;
  /** ID de la organización centralizada */
  centralized_organization_id: Scalars['Int']['input'];
  /** Ciudad */
  city: Scalars['String']['input'];
  /** País */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Código de país (ISO) */
  country_code: Scalars['String']['input'];
  /** Código de moneda (ISO 4217) */
  currency_code: Scalars['String']['input'];
  /** Dirección fiscal alternativa */
  fiscal_address_override?: InputMaybe<Scalars['String']['input']>;
  /** Email de contacto fiscal */
  fiscal_contact_email?: InputMaybe<Scalars['String']['input']>;
  /** ID interno */
  internal_id: Scalars['String']['input'];
  /** Latitud */
  latitude?: InputMaybe<Scalars['String']['input']>;
  /** Razón social */
  legal_name: Scalars['String']['input'];
  /** Longitud */
  longitude?: InputMaybe<Scalars['String']['input']>;
  /** Código postal (5 dígitos) */
  postal_code: Scalars['String']['input'];
  /** Número REPSE */
  repse_number?: InputMaybe<Scalars['String']['input']>;
  /** Objeto social */
  social_object?: InputMaybe<Scalars['String']['input']>;
  /** Estado */
  state: Scalars['String']['input'];
  /** Identificación fiscal (RFC) */
  tax_id: Scalars['String']['input'];
  /** ID del régimen fiscal */
  tax_regime_id: Scalars['ID']['input'];
  /** Tipo de contribuyente */
  tax_type: Scalars['String']['input'];
  /** Nombre comercial */
  trade_name?: InputMaybe<Scalars['String']['input']>;
};

export type CentralizedCreateOrganizationPositionCategoryPayload = {
  __typename?: 'CentralizedCreateOrganizationPositionCategoryPayload';
  organization_position_category_id: Scalars['ID']['output'];
};

export type CentralizedCreateOrganizationPositionCategoryPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse = CentralizedCreateOrganizationPositionCategoryPayload | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

export type CentralizedCreateOrganizationPositionFamilyPayload = {
  __typename?: 'CentralizedCreateOrganizationPositionFamilyPayload';
  organization_position_family_id: Scalars['ID']['output'];
};

export type CentralizedCreateOrganizationPositionFamilyPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse = CentralizedCreateOrganizationPositionFamilyPayload | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

export type CentralizedCreateOrganizationPositionLevelPayload = {
  __typename?: 'CentralizedCreateOrganizationPositionLevelPayload';
  organization_position_level_id: Scalars['ID']['output'];
};

export type CentralizedCreateOrganizationPositionLevelPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse = CentralizedCreateOrganizationPositionLevelPayload | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

export type CentralizedCreateOrganizationPositionPayload = {
  __typename?: 'CentralizedCreateOrganizationPositionPayload';
  organization_position_id: Scalars['ID']['output'];
  /** Created position node */
  position?: Maybe<OrganizationPositionNode>;
};

export type CentralizedCreateOrganizationPositionPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse = CentralizedCreateOrganizationPositionPayload | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

export type CentralizedCreateSuperAdminAccountConfigurationInput = {
  deactivation_date: Scalars['DateTime']['input'];
};

export type CentralizedCreateSuperAdminBasicInfoInput = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  gender: CentralizedCreateSuperAdminGenderEnum;
  id_number: Scalars['String']['input'];
  id_type: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
};

export enum CentralizedCreateSuperAdminGenderEnum {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

export type CentralizedCreateSuperAdminInfoInput = {
  account_configuration: CentralizedCreateSuperAdminAccountConfigurationInput;
  basic_info: CentralizedCreateSuperAdminBasicInfoInput;
  position_info: CentralizedCreateSuperAdminPositionInfoInput;
};

export type CentralizedCreateSuperAdminInput = {
  centralized_organization_id: Scalars['Int']['input'];
  send_activation_email: Scalars['Boolean']['input'];
  super_admins: Array<CentralizedCreateSuperAdminInfoInput>;
};

export type CentralizedCreateSuperAdminPositionInfoInput = {
  area: Scalars['Int']['input'];
  headquarters: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
  position_category: Scalars['Int']['input'];
  start_date: Scalars['DateTime']['input'];
};

export type CentralizedCreateSuperAdminResponse = {
  __typename?: 'CentralizedCreateSuperAdminResponse';
  super_admin_id: Scalars['Int']['output'];
};

export type CentralizedCreateSuperAdminResponseCorporationsResponseIntegrityErrorCorporationsResponseInternalErrorCorporationsResponseValidationErrorCorporationsNotFoundResponseError = CentralizedCreateSuperAdminResponse | CorporationsNotFoundResponseError | CorporationsResponseIntegrityError | CorporationsResponseInternalError | CorporationsResponseValidationError;

/** Crear régimen fiscal. */
export type CentralizedCreateTaxRegimeInput = {
  /** Código del régimen fiscal */
  tax_regime_code: Scalars['String']['input'];
  /** Nombre del régimen fiscal */
  tax_regime_name: Scalars['String']['input'];
  /** Tipo de contribuyente asociado */
  tax_type?: InputMaybe<Scalars['String']['input']>;
};

/** Payload returned after deactivating an OrganizationPosition */
export type CentralizedDeactivateOrganizationPositionPayload = {
  __typename?: 'CentralizedDeactivateOrganizationPositionPayload';
  organization_position_id: Scalars['ID']['output'];
  position?: Maybe<OrganizationPositionNode>;
};

/** Eliminar (desactivar) razón social. */
export type CentralizedDeleteLegalEntityInput = {
  /** ID de la organización centralizada */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID de la razón social */
  id: Scalars['ID']['input'];
};

export enum CentralizedDocumentTypeEnum {
  Cc = 'CC',
  Ce = 'CE',
  Dni = 'DNI',
  Dui = 'DUI',
  Id = 'ID',
  Ife = 'IFE',
  Nit = 'NIT',
  Other = 'OTHER',
  Passport = 'PASSPORT',
  Rc = 'RC',
  Rut = 'RUT',
  Ti = 'TI'
}

/** Respuesta de validación de campo (existencia). */
export type CentralizedFieldValidationResponse = {
  __typename?: 'CentralizedFieldValidationResponse';
  exists: Scalars['Boolean']['output'];
  graphql_operation_id: Scalars['ID']['output'];
};

export type CentralizedGenerateInvitationLinkPayload = UsersGraphOperationI & {
  __typename?: 'CentralizedGenerateInvitationLinkPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  invitation_link: Scalars['String']['output'];
  metadata?: Maybe<UserMetadataOuput>;
};

export type CentralizedGenerateRecoverPasswordCodeInput = {
  centralized_organization_id: Scalars['ID']['input'];
  username: Scalars['String']['input'];
};

export type CentralizedGenerateRecoverPasswordCodePayload = {
  __typename?: 'CentralizedGenerateRecoverPasswordCodePayload';
  centralized_organization_id: Scalars['ID']['output'];
  centralized_user_id: Scalars['ID']['output'];
  recover_password_code: Scalars['String']['output'];
};

export type CentralizedGenerateRecoverPasswordCodePayloadSecurityMutationErrorInternalServerMutationError = CentralizedGenerateRecoverPasswordCodePayload | InternalServerMutationError | SecurityMutationError;

export type CentralizedGenerateRecoverUserPasswordFromMethodInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
  recovery_method: CentralizedOrganizationRecoveryMethodEnum;
};

export type CentralizedGenerateRecoverUserPasswordFromMethodPayload = {
  __typename?: 'CentralizedGenerateRecoverUserPasswordFromMethodPayload';
  centralized_organization_id: Scalars['ID']['output'];
  centralized_user_id: Scalars['ID']['output'];
  recovery_description: Scalars['String']['output'];
  recovery_method: CentralizedOrganizationRecoveryMethodEnum;
  recovery_method_value: Scalars['String']['output'];
};

export type CentralizedGenerateRecoverUserPasswordFromMethodPayloadValidationMutationErrorInternalServerMutationError = CentralizedGenerateRecoverUserPasswordFromMethodPayload | InternalServerMutationError | ValidationMutationError;

/** Obtener una razón social por ID. */
export type CentralizedGetLegalEntityInput = {
  /** ID de la organización centralizada */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID de la razón social */
  id: Scalars['ID']['input'];
};

/** Obtener un régimen fiscal por ID. */
export type CentralizedGetTaxRegimeInput = {
  /** ID del régimen fiscal */
  id: Scalars['ID']['input'];
};

export type CentralizedGetUserOrganizationsFilters = {
  area_id?: InputMaybe<Scalars['ID']['input']>;
  area_name?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Scalars['String']['input']>;
  document_type?: InputMaybe<Array<CentralizedDocumentTypeEnum>>;
  headquarter_id?: InputMaybe<Scalars['ID']['input']>;
  headquarter_name?: InputMaybe<Scalars['String']['input']>;
  position_category_id?: InputMaybe<Scalars['ID']['input']>;
  position_category_name?: InputMaybe<Scalars['String']['input']>;
  position_id?: InputMaybe<Scalars['ID']['input']>;
  position_name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<CentralizedUserOrganizationRoleEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<CentralizedUserOrganizationStatusEnum>>;
  user_email?: InputMaybe<Scalars['String']['input']>;
};

export type CentralizedGetUserOrganizationsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  filters?: InputMaybe<CentralizedGetUserOrganizationsFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Centralized Headquarter Node for work locations */
export type CentralizedHeadquarterNode = {
  __typename?: 'CentralizedHeadquarterNode';
  /** Address Line 1 */
  address1?: Maybe<Scalars['String']['output']>;
  /** Address Line 2 */
  address2?: Maybe<Scalars['String']['output']>;
  /** Address Line 3 */
  address3?: Maybe<Scalars['String']['output']>;
  /** City */
  city?: Maybe<Scalars['String']['output']>;
  /** Country Code (ISO 3166-1 alpha-2) */
  country_code?: Maybe<Scalars['String']['output']>;
  /** Headquarter ID */
  id: Scalars['Int']['output'];
  /** Is main headquarter */
  is_main: Scalars['Boolean']['output'];
  /** Latitude */
  latitude?: Maybe<Scalars['String']['output']>;
  /** Longitude */
  longitude?: Maybe<Scalars['String']['output']>;
  /** Headquarter Name */
  name: Scalars['String']['output'];
  /** Postal Code */
  postal_code?: Maybe<Scalars['String']['output']>;
  /** State */
  state?: Maybe<Scalars['String']['output']>;
};

export type CentralizedImageNode = {
  __typename?: 'CentralizedImageNode';
  /** URL of placeholder to use in case URL is empty */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** URL of image */
  url?: Maybe<Scalars['String']['output']>;
};

export type CentralizedIntegrityError = UsersGraphOperationI & {
  __typename?: 'CentralizedIntegrityError';
  code: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CentralizedInternalError = UsersGraphOperationI & {
  __typename?: 'CentralizedInternalError';
  code: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CentralizedInvalidUserSessionPayload = {
  __typename?: 'CentralizedInvalidUserSessionPayload';
  centralized_organization_id: Scalars['ID']['output'];
  centralized_user_id: Scalars['ID']['output'];
  session_id: Scalars['ID']['output'];
};

export type CentralizedInvalidUserSessionPayloadSecurityMutationErrorInternalServerMutationError = CentralizedInvalidUserSessionPayload | InternalServerMutationError | SecurityMutationError;

export type CentralizedLearningReportInputNode = {
  activity_end_date?: InputMaybe<Scalars['Date']['input']>;
  activity_start_date?: InputMaybe<Scalars['Date']['input']>;
  centralized_custom_fields?: InputMaybe<Array<InputMaybe<ReportCustomFieldInput>>>;
  centralized_custom_fields_operator?: InputMaybe<CustomFieldsOperatorEnum>;
  centralized_organization_slug: Scalars['String']['input'];
  centralized_predefined_attributes?: InputMaybe<Array<InputMaybe<ReportPredefinedAttributeInput>>>;
  centralized_user_role?: InputMaybe<Array<InputMaybe<UserRoleEnum>>>;
  centralized_user_status?: InputMaybe<Array<InputMaybe<AnalyticsUserStatusEnum>>>;
  centralized_users_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Column selection for the report. When provided, only the specified columns are included. */
  column_selection?: InputMaybe<ReportColumnSelectionInput>;
  course_enroll_status?: InputMaybe<Scalars['Boolean']['input']>;
  courses?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** ID of a saved CustomReport. When provided, the report config is loaded from the DB and all other filter fields are ignored. */
  custom_report_id?: InputMaybe<Scalars['Int']['input']>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  has_certificated?: InputMaybe<Scalars['Boolean']['input']>;
  has_course_completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Headquarter IDs to filter the report. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter before applying the filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  is_crehana_course?: InputMaybe<Scalars['Boolean']['input']>;
  /** Progress range end (inclusive). Keeps only enrollments the user made progress on (a study event) on or before this date. Requires progress_start_date; ignored if sent alone. */
  progress_end_date?: InputMaybe<Scalars['Date']['input']>;
  /** Progress range start. Keeps only enrollments the user made progress on (a study event) on or after this date, regardless of when the course was completed or last touched. Scopes the General, Cursos and Performance sheets of report_b2b_general: Performance lists only users who studied in the range, its per-user counts roll up only those enrollments and 'Horas de estudio' sums the study events in the range. Requires progress_end_date; ignored if sent alone. */
  progress_start_date?: InputMaybe<Scalars['Date']['input']>;
  quiz_status?: InputMaybe<Array<InputMaybe<QuizStatusEnum>>>;
  report_description?: InputMaybe<Scalars['String']['input']>;
  report_file_format?: InputMaybe<FileFormatEnum>;
  report_generation_type?: InputMaybe<ReportGenerationTypeEnum>;
  report_input_config?: InputMaybe<Scalars['JSON']['input']>;
  report_name?: InputMaybe<Scalars['String']['input']>;
  report_sheets?: InputMaybe<Array<InputMaybe<GeneralSheetsEnum>>>;
  report_type: ReportsEnum;
  routes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Optional segment ID to scope the report to a specific user segment. */
  segment_id?: InputMaybe<Scalars['Int']['input']>;
  /** Unified segmentation filter. When provided, takes priority over centralized_predefined_attributes, centralized_custom_fields and centralized_custom_fields_operator. */
  segmentation?: InputMaybe<AnalyticsSegmentInput>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
  /** Talent process selection. Only applies to product_performance reports; ignored for learning/management. */
  talent_process?: InputMaybe<TalentProcessInput>;
  team_id?: InputMaybe<Scalars['String']['input']>;
};

/** Respuesta con una lista paginada de razones sociales. */
export type CentralizedLegalEntityListResponse = {
  __typename?: 'CentralizedLegalEntityListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<CentralizedLegalEntityType>;
  total_count: Scalars['Int']['output'];
};

/** Respuesta con una razón social. */
export type CentralizedLegalEntityResponse = {
  __typename?: 'CentralizedLegalEntityResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: CentralizedLegalEntityType;
};

/** Razón social (identidad y datos fiscales). */
export type CentralizedLegalEntityType = {
  __typename?: 'CentralizedLegalEntityType';
  /** Dirección (calle y número) */
  address_1: Scalars['String']['output'];
  /** Dirección 2 */
  address_2?: Maybe<Scalars['String']['output']>;
  /** Dirección 3 */
  address_3?: Maybe<Scalars['String']['output']>;
  /** ID de la organización centralizada */
  centralized_organization_id: Scalars['Int']['output'];
  /** Ciudad */
  city: Scalars['String']['output'];
  /** País */
  country?: Maybe<Scalars['String']['output']>;
  /** Código de país (ISO) */
  country_code: Scalars['String']['output'];
  /** Código de moneda (ISO 4217) */
  currency_code: Scalars['String']['output'];
  /** Dirección fiscal alternativa */
  fiscal_address_override?: Maybe<Scalars['String']['output']>;
  /** Email de contacto fiscal */
  fiscal_contact_email?: Maybe<Scalars['String']['output']>;
  /** ID de la razón social */
  id: Scalars['ID']['output'];
  /** ID interno */
  internal_id: Scalars['String']['output'];
  /** Latitud */
  latitude?: Maybe<Scalars['String']['output']>;
  /** Razón social */
  legal_name: Scalars['String']['output'];
  /** Representantes legales */
  legal_representatives: Array<CentralizedLegalRepresentativeType>;
  /** Longitud */
  longitude?: Maybe<Scalars['String']['output']>;
  /** Código postal */
  postal_code: Scalars['String']['output'];
  /** Número REPSE */
  repse_number?: Maybe<Scalars['String']['output']>;
  /** Objeto social */
  social_object?: Maybe<Scalars['String']['output']>;
  /** Estado */
  state: Scalars['String']['output'];
  /** Estado (draft | active | inactive) */
  status: Scalars['String']['output'];
  /** Identificación fiscal (RFC) */
  tax_id: Scalars['String']['output'];
  /** ID del régimen fiscal */
  tax_regime_id: Scalars['ID']['output'];
  /** Tipo de contribuyente (persona_fisica | persona_moral) */
  tax_type: Scalars['String']['output'];
  /** Nombre comercial */
  trade_name?: Maybe<Scalars['String']['output']>;
};

/** Representante legal de una razón social. */
export type CentralizedLegalRepresentativeType = {
  __typename?: 'CentralizedLegalRepresentativeType';
  /** ID de la organización centralizada */
  centralized_organization_id: Scalars['Int']['output'];
  /** ID del usuario centralizado */
  centralized_user_id?: Maybe<Scalars['String']['output']>;
  /** ID de registro civil */
  civil_registry_id?: Maybe<Scalars['String']['output']>;
  /** Código de país */
  country_code?: Maybe<Scalars['String']['output']>;
  /** Facultades (JSON en texto) */
  faculties: Scalars['String']['output'];
  /** ID del representante legal */
  id: Scalars['ID']['output'];
  /** Nombre del representante */
  representative_name: Scalars['String']['output'];
  /** Tipo de representante */
  representative_type: Scalars['String']['output'];
  /** Identificación fiscal del representante */
  tax_id?: Maybe<Scalars['String']['output']>;
};

/** Listar razones sociales (filtros + paginación). */
export type CentralizedListLegalEntitiesInput = {
  /** ID de la organización centralizada */
  centralized_organization_id: Scalars['Int']['input'];
  /** Filtro por código de país (match exacto) */
  country_code?: InputMaybe<Scalars['String']['input']>;
  /** Cantidad por página */
  limit?: Scalars['Int']['input'];
  /** Desplazamiento */
  offset?: Scalars['Int']['input'];
  /** Búsqueda parcial (legal_name, trade_name, tax_id, internal_id) */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Orden: legal_name | internal_id | created_at */
  sort_by?: InputMaybe<Scalars['String']['input']>;
  /** Dirección: desc | asc */
  sort_direction?: InputMaybe<Scalars['String']['input']>;
  /** Filtro por estados; omitido excluye 'inactive' */
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtro por tipo de contribuyente (match exacto) */
  tax_type?: InputMaybe<Scalars['String']['input']>;
};

/** Listar regímenes fiscales (filtro por código). */
export type CentralizedListTaxRegimesInput = {
  /** Filtro parcial por código */
  code?: InputMaybe<Scalars['String']['input']>;
};

export type CentralizedLoginMutationInput = {
  centralized_organization_id: Scalars['ID']['input'];
  next_url?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CentralizedLoginMutationPayload = {
  __typename?: 'CentralizedLoginMutationPayload';
  centralized_organization_id: Scalars['ID']['output'];
  centralized_user_id: Scalars['ID']['output'];
  next_url: Scalars['String']['output'];
};

export type CentralizedLoginMutationPayloadSecurityMutationErrorInternalServerMutationError = CentralizedLoginMutationPayload | InternalServerMutationError | SecurityMutationError;

export type CentralizedLogoutMutationInput = {
  next_url?: InputMaybe<Scalars['String']['input']>;
};

export type CentralizedLogoutMutationPayload = {
  __typename?: 'CentralizedLogoutMutationPayload';
  centralized_organization_id?: Maybe<Scalars['ID']['output']>;
  centralized_user_id?: Maybe<Scalars['ID']['output']>;
  next_url: Scalars['String']['output'];
};

export type CentralizedLogoutMutationPayloadSecurityMutationErrorInternalServerMutationError = CentralizedLogoutMutationPayload | InternalServerMutationError | SecurityMutationError;

export type CentralizedMeUserProfileNode = {
  __typename?: 'CentralizedMeUserProfileNode';
  about_me?: Maybe<Scalars['String']['output']>;
  /** activation link sent by mail */
  activation_link?: Maybe<Scalars['String']['output']>;
  additional_information: Array<CentralizedUserCustomFieldTextNodeCentralizedUserCustomFieldDateNodeCentralizedUserCustomFieldNumberNodeCentralizedUserCustomFieldMultipleNode>;
  address?: Maybe<Scalars['String']['output']>;
  areas?: Maybe<CentralizedAreaLevelsNode>;
  assigned_role: UserOrganizationRoleEnum;
  /** Centralized user avatar */
  avatar: Scalars['String']['output'];
  birthday_date?: Maybe<Scalars['DateTime']['output']>;
  boss?: Maybe<CentralizedBossUserNode>;
  cellphone?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  civil_status?: Maybe<CivilStatusEnumInput>;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  document_type?: Maybe<DocumentTypeEnumInput>;
  emergency_contact_email?: Maybe<Scalars['String']['output']>;
  emergency_contact_email_2?: Maybe<Scalars['String']['output']>;
  emergency_contact_name?: Maybe<Scalars['String']['output']>;
  emergency_contact_name_2?: Maybe<Scalars['String']['output']>;
  emergency_contact_phone?: Maybe<Scalars['String']['output']>;
  emergency_contact_phone_2?: Maybe<Scalars['String']['output']>;
  emergency_contact_relationship?: Maybe<Scalars['String']['output']>;
  emergency_contact_relationship_2?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<GenderEnumInput>;
  headquarters?: Maybe<CentralizedUserHeadQuarterNode>;
  /** Centralized user organization id */
  id: Scalars['Int']['output'];
  incorporation_date?: Maybe<Scalars['DateTime']['output']>;
  last_activity?: Maybe<Scalars['DateTime']['output']>;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  personal_email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<CentralizedUserPositionNode>;
  position_category?: Maybe<CentralizedUserPositionCategoryNode>;
  /** Centralized user profile completion */
  profile_completion: Scalars['Int']['output'];
  web_site_url?: Maybe<Scalars['String']['output']>;
};

export type CentralizedMutationInternalError = {
  __typename?: 'CentralizedMutationInternalError';
  errors: Array<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
};

export type CentralizedMutationValidationError = {
  __typename?: 'CentralizedMutationValidationError';
  errors: Array<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
};

export type CentralizedOrganizationAnonymousSessionPayload = {
  __typename?: 'CentralizedOrganizationAnonymousSessionPayload';
  centralized_organization_id: Scalars['String']['output'];
  session_id: Scalars['String']['output'];
};

export type CentralizedOrganizationAnonymousSessionPayloadValidationMutationErrorInternalServerMutationError = CentralizedOrganizationAnonymousSessionPayload | InternalServerMutationError | ValidationMutationError;

export type CentralizedOrganizationArea = {
  __typename?: 'CentralizedOrganizationArea';
  /** Creation Date */
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Area Label */
  label: Scalars['String']['output'];
  /** Area Name */
  name: Scalars['String']['output'];
};

/** Represents an organization area */
export type CentralizedOrganizationAreaNode = {
  __typename?: 'CentralizedOrganizationAreaNode';
  area_level?: Maybe<OrganizationAreaLevelAllNode>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  /** Level Sequence */
  level_sequence: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<CentralizedOrganizationAreaNode>;
};

export type CentralizedOrganizationCheckMutationResponse = {
  __typename?: 'CentralizedOrganizationCheckMutationResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CentralizedOrganizationFromSlugInput = {
  centralized_organization_slug: Scalars['String']['input'];
};

export type CentralizedOrganizationFromSlugPayload = {
  __typename?: 'CentralizedOrganizationFromSlugPayload';
  centralized_organization: PublicCentralizedOrganization;
  centralized_organization_personalization: PublicCentralizedOrganizationPersonalization;
};

export type CentralizedOrganizationFromSlugPayloadQueryValidationErrorQueryInternalServerError = CentralizedOrganizationFromSlugPayload | QueryInternalServerError | QueryValidationError;

export type CentralizedOrganizationHeadquarter = {
  __typename?: 'CentralizedOrganizationHeadquarter';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Represents an Organization Headquarter */
export type CentralizedOrganizationHeadquarterNode = {
  __typename?: 'CentralizedOrganizationHeadquarterNode';
  /** Admin ID */
  admin_id?: Maybe<Scalars['Int']['output']>;
  /** Headquarter ID */
  id: Scalars['Int']['output'];
  /** Headquarter is main */
  is_main: Scalars['Boolean']['output'];
  /** Headquarter name */
  name: Scalars['String']['output'];
  /** Original ID */
  original_id: Scalars['Int']['output'];
};

export type CentralizedOrganizationLicences = {
  __typename?: 'CentralizedOrganizationLicences';
  available_licences: Scalars['Int']['output'];
  total_licences: Scalars['Int']['output'];
};

/** Centralized Organization Node */
export type CentralizedOrganizationNode = {
  __typename?: 'CentralizedOrganizationNode';
  /** Country code based on alpha 3 Characters (PER) */
  country?: Maybe<CountryNode>;
  /** Custom Fields (Also called Atributis Unificados) */
  custom_fields: Array<CustomFieldNode>;
  /** Departments related with the Organization */
  departaments: Array<OrganizationDepartmentNode>;
  /** Enterprises related with the Organization */
  enterprises: Array<OrganizationEnterpriseNode>;
  /** Headquarters related with the Organization */
  headquarters: Array<OrganizationHeadquarterNode>;
  /** Industry ID */
  industry_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the critical field is visible */
  is_criticality_visible: Scalars['Boolean']['output'];
  /** Indicates whether the key position field is visible */
  is_key_position_visible: Scalars['Boolean']['output'];
  /** Organization licenses without using enterprise model */
  licenses?: Maybe<LicensesNode>;
  /** Organization name */
  name: Scalars['String']['output'];
  /** Open opportunity ID */
  open_opportunity_id?: Maybe<Scalars['Int']['output']>;
  /** Original ID */
  original_id: Scalars['Int']['output'];
  /** Personalization data for the Organization */
  personalization?: Maybe<OrganizationPersonalizationNode>;
  /** Phone number */
  phone_number?: Maybe<PhoneNumberNode>;
  /** Position Categories (Also called Categorías de Cargo) */
  position_categories: Array<OrganizationPositionCategoryNode>;
  /** Positions related with the Organization (Also called Cargo) */
  positions: Array<OrganizationPositionNode>;
  /** Organization name with undercase and underscores for spaces */
  slug: Scalars['String']['output'];
  /** Type process organization */
  type_process_organization?: Maybe<Scalars['String']['output']>;
  /** User Creation Massive template. Pass verify_freshness=true to check whether any dropdown source (product, position, position category, headquarter, area level, area, role) changed since the cached template was built and regenerate it on read if so (TIM-239/TIM-67, SWAT-962, SWAT-939, CORE-1865) — costs several DB reads plus an S3 HEAD, so only the explicit 'download template' action should set it; general org queries should leave it off and just get the cached URL. */
  user_create_template: Scalars['String']['output'];
  /** Workplaces related with the Organization */
  workplaces: Array<OrganizationWorkplaceNode>;
};


/** Centralized Organization Node */
export type CentralizedOrganizationNodeUser_Create_TemplateArgs = {
  verify_freshness?: Scalars['Boolean']['input'];
};

export type CentralizedOrganizationPosition = {
  __typename?: 'CentralizedOrganizationPosition';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CentralizedOrganizationPositionCategory = {
  __typename?: 'CentralizedOrganizationPositionCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Full detail of a position within an organization. */
export type CentralizedOrganizationPositionDetail = {
  __typename?: 'CentralizedOrganizationPositionDetail';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  criticality?: Maybe<OrganizationPositionCriticalityOptionNode>;
  /** Criticality level for Succession Engine (HIGH, MEDIUM, LOW) */
  criticality_level?: Maybe<OrganizationPositionCriticalityLevelEnum>;
  /** Evaluation indicators configurations for the Fit Score */
  evaluation_indicators: Array<PositionEvaluationIndicatorNode>;
  functions_description?: Maybe<Scalars['String']['output']>;
  general_description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  key_position?: Maybe<OrganizationPositionKeyPositionOptionNode>;
  /** Keywords associated with this position */
  keywords: Array<PositionKeywordNode>;
  leader_position?: Maybe<OrganizationPositionNode>;
  name?: Maybe<Scalars['String']['output']>;
  position_code?: Maybe<Scalars['String']['output']>;
  position_family?: Maybe<CentralizedOrganizationPositionFamilyNode>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CentralizedOrganizationPositionFamilyNode = {
  __typename?: 'CentralizedOrganizationPositionFamilyNode';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Position level node. */
export type CentralizedOrganizationPositionLevelNode = {
  __typename?: 'CentralizedOrganizationPositionLevelNode';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Centralized Basic Organization Node */
export type CentralizedOrganizationPublicNode = {
  __typename?: 'CentralizedOrganizationPublicNode';
  /** Organization name */
  name: Scalars['String']['output'];
  /** Original ID */
  original_id: Scalars['Int']['output'];
  /** Personalization data for the Organization */
  personalization?: Maybe<OrganizationPersonalizationNode>;
  /** Organization name with undercase and underscores for spaces */
  slug: Scalars['String']['output'];
};

export enum CentralizedOrganizationRecoveryMethodEnum {
  RecoverMethodEmail = 'RECOVER_METHOD_EMAIL'
}

export type CentralizedOrganizationTenantBrandingNode = {
  __typename?: 'CentralizedOrganizationTenantBrandingNode';
  image_favicon: ImageFileNode;
  image_isotype: ImageFileNode;
  image_logo: ImageFileNode;
  image_page_login_hero: ImageFileNode;
  palette_colors: CentralizedOrganizationTenantPaletteColorsV1Node;
};

export type CentralizedOrganizationTenantBrandingNodeValidationErrorResponseInternalErrorResponse = CentralizedOrganizationTenantBrandingNode | InternalErrorResponse | ValidationErrorResponse;

export type CentralizedOrganizationTenantInput = {
  centralized_organization_slug: Scalars['String']['input'];
};

/** Centralized Tenant Organization Node */
export type CentralizedOrganizationTenantNode = {
  __typename?: 'CentralizedOrganizationTenantNode';
  /** Customization data (branding, config, etc.) for the Organization */
  branding: CentralizedOrganizationTenantBrandingNode;
  id: Scalars['ID']['output'];
  /** Learning organization ID */
  learning_id?: Maybe<Scalars['Int']['output']>;
  /** Organization name */
  name: Scalars['String']['output'];
  /** Organization name with lowercase and underscores for spaces */
  slug: Scalars['String']['output'];
  /** Talent organization ID */
  talent_id?: Maybe<Scalars['Int']['output']>;
};

export type CentralizedOrganizationTenantNodeInternalErrorResponseValidationErrorResponseNotFoundResponse = CentralizedOrganizationTenantNode | InternalErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type CentralizedOrganizationTenantPaletteColorsV1Node = {
  __typename?: 'CentralizedOrganizationTenantPaletteColorsV1Node';
  base: Scalars['String']['output'];
  dark: Scalars['String']['output'];
  darkest: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  light: Scalars['String']['output'];
  lightest: Scalars['String']['output'];
};

export type CentralizedOrganizationsQueries = {
  __typename?: 'CentralizedOrganizationsQueries';
  areas: OrganizationAreaQueries;
};

export type CentralizedOtherUserProfileNode = {
  __typename?: 'CentralizedOtherUserProfileNode';
  about_me?: Maybe<Scalars['String']['output']>;
  /** activation link sent by mail */
  activation_link?: Maybe<Scalars['String']['output']>;
  additional_information: Array<CentralizedUserCustomFieldTextNodeCentralizedUserCustomFieldDateNodeCentralizedUserCustomFieldNumberNodeCentralizedUserCustomFieldMultipleNode>;
  areas?: Maybe<CentralizedAreaLevelsNode>;
  /** Centralized user avatar */
  avatar: Scalars['String']['output'];
  birthday_date?: Maybe<Scalars['DateTime']['output']>;
  boss?: Maybe<CentralizedBossUserNode>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<GenderEnumInput>;
  headquarters?: Maybe<CentralizedUserHeadQuarterNode>;
  /** Centralized user organization id */
  id: Scalars['Int']['output'];
  incorporation_date?: Maybe<Scalars['DateTime']['output']>;
  last_activity?: Maybe<Scalars['DateTime']['output']>;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  position?: Maybe<CentralizedUserPositionNode>;
  /** Centralized user profile completion */
  profile_completion: Scalars['Int']['output'];
  web_site_url?: Maybe<Scalars['String']['output']>;
};

export type CentralizedPositionNode = {
  __typename?: 'CentralizedPositionNode';
  /** Cache identifier for Apollo Client normalization. Mirrors position_id so the InMemoryCache can dedupe positions shared across users; null when the position is unknown. */
  id?: Maybe<Scalars['ID']['output']>;
  /** ID of the position */
  position_id?: Maybe<Scalars['Int']['output']>;
  /** Name of the position */
  position_name?: Maybe<Scalars['String']['output']>;
};

export type CentralizedPositionsCreateOrganizationPositionCategoryInput = {
  name: Scalars['String']['input'];
  organization_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
};

export type CentralizedPositionsCreateOrganizationPositionFamilyInput = {
  name: Scalars['String']['input'];
  organization_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
};

export type CentralizedPositionsCreateOrganizationPositionInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  criticality_level?: InputMaybe<OrganizationPositionCriticalityLevelEnum>;
  functions_description?: InputMaybe<Scalars['String']['input']>;
  general_description?: InputMaybe<Scalars['String']['input']>;
  /** Keywords to associate with the position */
  keywords?: InputMaybe<Array<PositionKeywordInput>>;
  leader_position_id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  organization_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
  position_criticality_id?: InputMaybe<Scalars['Int']['input']>;
  position_family_id?: InputMaybe<Scalars['Int']['input']>;
  position_key_position_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CentralizedPositionsCreateOrganizationPositionLevelInput = {
  name: Scalars['String']['input'];
  organization_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
};

export type CentralizedPositionsDeactivateOrganizationPositionInput = {
  organization_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
  position_id: Scalars['Int']['input'];
};

export type CentralizedPositionsUpdateOrganizationPositionCategoryInput = {
  name: Scalars['String']['input'];
  organization_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
  position_category_id: Scalars['Int']['input'];
};

export type CentralizedPositionsUpdateOrganizationPositionInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  criticality_level?: InputMaybe<OrganizationPositionCriticalityLevelEnum>;
  functions_description?: InputMaybe<Scalars['String']['input']>;
  general_description?: InputMaybe<Scalars['String']['input']>;
  /** Keywords to associate with the position */
  keywords?: InputMaybe<Array<PositionKeywordInput>>;
  leader_position_id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  organization_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
  position_criticality_id?: InputMaybe<Scalars['Int']['input']>;
  position_family_id?: InputMaybe<Scalars['Int']['input']>;
  position_id: Scalars['Int']['input'];
  position_key_position_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CentralizedProduct = {
  __typename?: 'CentralizedProduct';
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CentralizedProductsNamespaceQuery = {
  __typename?: 'CentralizedProductsNamespaceQuery';
  get_products: GetCentralizedProductsPayloadQueryValidationErrorQueryInternalServerError;
};


export type CentralizedProductsNamespaceQueryGet_ProductsArgs = {
  input: GetCentralizedProductsInput;
};

export type CentralizedReportInputNode = {
  org_id?: InputMaybe<Scalars['Int']['input']>;
  report_id?: InputMaybe<Scalars['Int']['input']>;
  report_type: ReportsEnum;
  slug: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CentralizedReportMutation = {
  __typename?: 'CentralizedReportMutation';
  centralized_reports: ReportResponseAnalyticsMutationInternalError;
  /** This is exclusive mutation to create user centralized reports!! */
  create_centralized_report: ReportResponseAnalyticsMutationInternalError;
  /** This mutation deletes centralized reports */
  delete_learning_centralized_report: DeleteReportResponseAnalyticsMutationInternalError;
  /** Generic mutation to create learning reports cross centralized tables! */
  generate_learning_centralized_report: ReportLogNodeReportExistsResponseAnalyticsReportRateLimitErrorAnalyticsMutationValidationErrorAnalyticsMutationInternalError;
  /** Triggers a scheduled report generation. Receives minimal identifiers, loads the CustomReport config internally, and dispatches the job. */
  generate_scheduled_learning_centralized_report: ReportLogNodeAnalyticsMutationInternalError;
  /** Retries a failed report log by re-sending it to PubSub. Only allowed for statuses: FAILED, CANCELLED, RETRY_PENDING, PUBSUB_SENT. */
  retry_report_log: ReportLogNodeAnalyticsReportMaxRetriesErrorAnalyticsMutationInternalError;
  schedule_centralized_report: CentralizedReportResponse;
};


export type CentralizedReportMutationCentralized_ReportsArgs = {
  input: CentralizedReportInputNode;
};


export type CentralizedReportMutationCreate_Centralized_ReportArgs = {
  input: CentralizedReportInputNode;
};


export type CentralizedReportMutationDelete_Learning_Centralized_ReportArgs = {
  input: DeleteReportInput;
};


export type CentralizedReportMutationGenerate_Learning_Centralized_ReportArgs = {
  input: CentralizedLearningReportInputNode;
};


export type CentralizedReportMutationGenerate_Scheduled_Learning_Centralized_ReportArgs = {
  input: AnalyticsScheduledReportTriggerInput;
};


export type CentralizedReportMutationRetry_Report_LogArgs = {
  input: AnalyticsRetryReportLogInput;
};


export type CentralizedReportMutationSchedule_Centralized_ReportArgs = {
  input: ScheduledCentralizedReport;
};

export type CentralizedReportResponse = {
  __typename?: 'CentralizedReportResponse';
  error_code?: Maybe<Scalars['String']['output']>;
  failed_count?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  scheduled_count?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  total_organizations?: Maybe<Scalars['Int']['output']>;
};

export type CentralizedSecurityNamespaceMutation = {
  __typename?: 'CentralizedSecurityNamespaceMutation';
  /** @deprecated Usar security_policies.change_user_password. */
  centralized_admin_change_user_password: CentralizedChangeUserPasswordPayloadSecurityMutationErrorInternalServerMutationError;
  centralized_admin_change_user_username: CentralizedChangeUserUsernamePayloadSecurityMutationErrorInternalServerMutationError;
  /** @deprecated Usar security_policies.change_my_password (self) o security_policies.change_user_password (admin). */
  centralized_change_user_password: CentralizedChangeUserPasswordPayloadSecurityMutationErrorInternalServerMutationError;
  centralized_change_user_password_from_recover_code: CentralizedChangeUserPasswordPayloadSecurityMutationErrorInternalServerMutationError;
  centralized_change_user_username: CentralizedChangeUserUsernamePayloadSecurityMutationErrorInternalServerMutationError;
  centralized_generate_recover_password_code: CentralizedGenerateRecoverPasswordCodePayloadSecurityMutationErrorInternalServerMutationError;
  centralized_generate_recover_user_password_from_method: CentralizedGenerateRecoverUserPasswordFromMethodPayloadValidationMutationErrorInternalServerMutationError;
  centralized_invalid_user_session: CentralizedInvalidUserSessionPayloadSecurityMutationErrorInternalServerMutationError;
  centralized_login_user: CentralizedLoginMutationPayloadSecurityMutationErrorInternalServerMutationError;
  centralized_logout_user: CentralizedLogoutMutationPayloadSecurityMutationErrorInternalServerMutationError;
  next_to_talent: NextToTalentPayloadValidationMutationErrorInternalServerMutationError;
  next_to_talisis: NextToTalisisPayloadTalisisProductNotEnabledMutationErrorTalisisNotConfiguredMutationErrorValidationMutationErrorInternalServerMutationError;
  register_security_user_session: RegisterSecurityUserSessionPayloadValidationMutationErrorSecurityMutationErrorInternalServerMutationError;
};


export type CentralizedSecurityNamespaceMutationCentralized_Admin_Change_User_PasswordArgs = {
  input: CentralizedAdminChangeUserPasswordInput;
};


export type CentralizedSecurityNamespaceMutationCentralized_Admin_Change_User_UsernameArgs = {
  input: CentralizedAdminChangeUserUsernameInput;
};


export type CentralizedSecurityNamespaceMutationCentralized_Change_User_PasswordArgs = {
  input: CentralizedChangeUserPasswordInput;
};


export type CentralizedSecurityNamespaceMutationCentralized_Change_User_Password_From_Recover_CodeArgs = {
  input: CentralizedChangeUserPassworFromRecoverCodeInput;
};


export type CentralizedSecurityNamespaceMutationCentralized_Change_User_UsernameArgs = {
  input: CentralizedChangeUserUsernameInput;
};


export type CentralizedSecurityNamespaceMutationCentralized_Generate_Recover_Password_CodeArgs = {
  input: CentralizedGenerateRecoverPasswordCodeInput;
};


export type CentralizedSecurityNamespaceMutationCentralized_Generate_Recover_User_Password_From_MethodArgs = {
  input: CentralizedGenerateRecoverUserPasswordFromMethodInput;
};


export type CentralizedSecurityNamespaceMutationCentralized_Invalid_User_SessionArgs = {
  input: InvalidUserSessionInput;
};


export type CentralizedSecurityNamespaceMutationCentralized_Login_UserArgs = {
  input: CentralizedLoginMutationInput;
};


export type CentralizedSecurityNamespaceMutationCentralized_Logout_UserArgs = {
  input: CentralizedLogoutMutationInput;
};


export type CentralizedSecurityNamespaceMutationNext_To_TalentArgs = {
  input: NextToTalentInput;
};


export type CentralizedSecurityNamespaceMutationNext_To_TalisisArgs = {
  input: NextToTalisisInput;
};


export type CentralizedSecurityNamespaceMutationRegister_Security_User_SessionArgs = {
  input: RegisterSecurityUserSessionInput;
};

export type CentralizedSecurityNamespaceQuery = {
  __typename?: 'CentralizedSecurityNamespaceQuery';
  centralized_organization_from_slug: CentralizedOrganizationFromSlugPayloadQueryValidationErrorQueryInternalServerError;
  get_organization_public_info: OrganizationPublicInfoPayloadQueryValidationErrorQueryInternalServerError;
};


export type CentralizedSecurityNamespaceQueryCentralized_Organization_From_SlugArgs = {
  input: CentralizedOrganizationFromSlugInput;
};


export type CentralizedSecurityNamespaceQueryGet_Organization_Public_InfoArgs = {
  input: GetOrganizationPublicInfoInput;
};

export type CentralizedSession = {
  __typename?: 'CentralizedSession';
  centralized_admin_organization_ids?: Maybe<Array<Scalars['String']['output']>>;
  centralized_admin_organization_slugs?: Maybe<Array<Scalars['String']['output']>>;
  centralized_organization_id?: Maybe<Scalars['String']['output']>;
  centralized_organization_slug?: Maybe<Scalars['String']['output']>;
  centralized_user_country_code?: Maybe<Scalars['String']['output']>;
  centralized_user_id?: Maybe<Scalars['String']['output']>;
  centralized_user_organization?: Maybe<CentralizedSessionUserOrganization>;
  centralized_user_organization_id?: Maybe<Scalars['String']['output']>;
  centralized_user_organization_role?: Maybe<Scalars['String']['output']>;
};

export type CentralizedSessionOrganization = {
  __typename?: 'CentralizedSessionOrganization';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type CentralizedSessionUserOrganization = {
  __typename?: 'CentralizedSessionUserOrganization';
  area?: Maybe<CentralizedOrganizationArea>;
  avatar_id?: Maybe<Scalars['ID']['output']>;
  avatar_url: Scalars['String']['output'];
  headquarter?: Maybe<CentralizedOrganizationHeadquarter>;
  organization: CentralizedSessionOrganization;
  position?: Maybe<CentralizedOrganizationPosition>;
  position_category?: Maybe<CentralizedOrganizationPositionCategory>;
  role: CentralizedUserOrganizationRoleEnum;
  status: CentralizedUserOrganizationStatusEnum;
  user: CentralizedBasicUser;
};

/** Datos centralizados de un empleado de talent. El subgraph de talent declara el stub con la llave y lo cuelga de `PrivateTalentEmployee`; acá se aporta la imagen de perfil que vive en la base de datos centralizada, sucesora del `photo_url` legacy de talent. Type dedicado por consumidor, mismo criterio que `CrehanAICentralizedUser` (de52081e): la definición federada vive acá y talent sólo mantiene la referencia mínima que exige federación. */
export type CentralizedTalentEmployee = {
  __typename?: 'CentralizedTalentEmployee';
  /** Id crudo del archivo de la imagen (`user_organization.avatar_id`), o null si el empleado no tiene imagen. Leer esto en vez de `profile_url` evita una llamada HTTP por empleado cuando el cliente resuelve las URLs por su cuenta. */
  avatar_id?: Maybe<Scalars['Int']['output']>;
  /** URL de la imagen de perfil, o null si el empleado no tiene imagen en centralized — el cliente cae a su propio placeholder. Mismo contrato que `CrehanAICentralizedUser.profile_url` (de52081e). Resolverla cuesta una llamada HTTP al file service por empleado, así que sólo ocurre si se selecciona este campo. */
  profile_url?: Maybe<Scalars['String']['output']>;
  /** Id del empleado en talent (`user_enterprise.internal_id`) */
  talent_employee_id: Scalars['Int']['output'];
  /** Id de la compañía en talent (`organization_enterprise.internal_id`) */
  talent_organization_id: Scalars['Int']['output'];
};

/** Respuesta con una lista de regímenes fiscales. */
export type CentralizedTaxRegimeListResponse = {
  __typename?: 'CentralizedTaxRegimeListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<CentralizedTaxRegimeType>;
  total_count: Scalars['Int']['output'];
};

/** Respuesta con un régimen fiscal. */
export type CentralizedTaxRegimeResponse = {
  __typename?: 'CentralizedTaxRegimeResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: CentralizedTaxRegimeType;
};

/** Régimen fiscal (catálogo). */
export type CentralizedTaxRegimeType = {
  __typename?: 'CentralizedTaxRegimeType';
  /** ID del régimen fiscal */
  id: Scalars['ID']['output'];
  /** Código del régimen fiscal */
  tax_regime_code: Scalars['String']['output'];
  /** Nombre del régimen fiscal */
  tax_regime_name: Scalars['String']['output'];
  /** Tipo de contribuyente asociado */
  tax_type?: Maybe<Scalars['String']['output']>;
};

export type CentralizedUnassignBossInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
};

export type CentralizedUpdateCorporationChildrenOrgPayload = {
  __typename?: 'CentralizedUpdateCorporationChildrenOrgPayload';
  organization_id: Scalars['Int']['output'];
};

export type CentralizedUpdateCorporationChildrenOrgPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse = CentralizedUpdateCorporationChildrenOrgPayload | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

/** Actualizar razón social (parcial). */
export type CentralizedUpdateLegalEntityInput = {
  /** Dirección (calle y número) */
  address_1?: InputMaybe<Scalars['String']['input']>;
  /** Dirección 2 */
  address_2?: InputMaybe<Scalars['String']['input']>;
  /** Dirección 3 */
  address_3?: InputMaybe<Scalars['String']['input']>;
  /** ID de la organización centralizada */
  centralized_organization_id: Scalars['Int']['input'];
  /** Ciudad */
  city?: InputMaybe<Scalars['String']['input']>;
  /** País */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Código de país (ISO) */
  country_code?: InputMaybe<Scalars['String']['input']>;
  /** Código de moneda (ISO 4217) */
  currency_code?: InputMaybe<Scalars['String']['input']>;
  /** Dirección fiscal alternativa */
  fiscal_address_override?: InputMaybe<Scalars['String']['input']>;
  /** Email de contacto fiscal */
  fiscal_contact_email?: InputMaybe<Scalars['String']['input']>;
  /** ID de la razón social */
  id: Scalars['ID']['input'];
  /** ID interno */
  internal_id?: InputMaybe<Scalars['String']['input']>;
  /** Latitud */
  latitude?: InputMaybe<Scalars['String']['input']>;
  /** Razón social */
  legal_name?: InputMaybe<Scalars['String']['input']>;
  /** Longitud */
  longitude?: InputMaybe<Scalars['String']['input']>;
  /** Código postal (5 dígitos) */
  postal_code?: InputMaybe<Scalars['String']['input']>;
  /** Número REPSE */
  repse_number?: InputMaybe<Scalars['String']['input']>;
  /** Objeto social */
  social_object?: InputMaybe<Scalars['String']['input']>;
  /** Estado */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Identificación fiscal (RFC) */
  tax_id?: InputMaybe<Scalars['String']['input']>;
  /** ID del régimen fiscal */
  tax_regime_id?: InputMaybe<Scalars['ID']['input']>;
  /** Tipo de contribuyente */
  tax_type?: InputMaybe<Scalars['String']['input']>;
  /** Nombre comercial */
  trade_name?: InputMaybe<Scalars['String']['input']>;
};

export type CentralizedUpdateOrganizationPositionCategoryPayload = {
  __typename?: 'CentralizedUpdateOrganizationPositionCategoryPayload';
  organization_position_category_id: Scalars['ID']['output'];
  position_category?: Maybe<OrganizationPositionCategoryNode>;
};

export type CentralizedUpdateOrganizationPositionCategoryPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse = CentralizedUpdateOrganizationPositionCategoryPayload | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

/** Payload returned after updating an OrganizationPosition */
export type CentralizedUpdateOrganizationPositionPayload = {
  __typename?: 'CentralizedUpdateOrganizationPositionPayload';
  organization_position_id: Scalars['ID']['output'];
  position?: Maybe<OrganizationPositionNode>;
};

/** Actualizar régimen fiscal. */
export type CentralizedUpdateTaxRegimeInput = {
  /** ID del régimen fiscal */
  id: Scalars['ID']['input'];
  /** Código del régimen fiscal */
  tax_regime_code?: InputMaybe<Scalars['String']['input']>;
  /** Nombre del régimen fiscal */
  tax_regime_name?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de contribuyente asociado */
  tax_type?: InputMaybe<Scalars['String']['input']>;
};

export type CentralizedUser = {
  __typename?: 'CentralizedUser';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  lastname: Scalars['String']['output'];
  profile_picture: CentralizedImageNode;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_organization?: Maybe<CentralizedUserOrganizationNode>;
};

export type CentralizedUserAts = {
  __typename?: 'CentralizedUserATS';
  id: Scalars['String']['output'];
  user?: Maybe<CentralizedUser>;
  user_id: Scalars['ID']['output'];
};

export type CentralizedUserAreaLevelNode = {
  __typename?: 'CentralizedUserAreaLevelNode';
  custom_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<CentralizedUserAreaNode>;
};

export type CentralizedUserAreaNode = {
  __typename?: 'CentralizedUserAreaNode';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CentralizedUserChangePasswordInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
  confirm_password: Scalars['String']['input'];
  force_change_password?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
};

export type CentralizedUserCustomFieldChoiceNode = {
  __typename?: 'CentralizedUserCustomFieldChoiceNode';
  id: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type CentralizedUserCustomFieldDateNode = {
  __typename?: 'CentralizedUserCustomFieldDateNode';
  can_edit: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  is_mandatory: Scalars['Boolean']['output'];
  is_visible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  response?: Maybe<CentralizedUserCustomFieldResponseDate>;
};

export type CentralizedUserCustomFieldMultipleNode = {
  __typename?: 'CentralizedUserCustomFieldMultipleNode';
  can_edit: Scalars['Boolean']['output'];
  choices: Array<CentralizedUserCustomFieldChoiceNode>;
  id: Scalars['Int']['output'];
  is_mandatory: Scalars['Boolean']['output'];
  is_visible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  response?: Maybe<Array<CentralizedUserCustomFieldResponseChoice>>;
};

export type CentralizedUserCustomFieldNode = {
  __typename?: 'CentralizedUserCustomFieldNode';
  can_edit: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  is_mandatory: Scalars['Boolean']['output'];
  is_visible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CentralizedUserCustomFieldNumberNode = {
  __typename?: 'CentralizedUserCustomFieldNumberNode';
  can_edit: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  is_mandatory: Scalars['Boolean']['output'];
  is_visible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  response?: Maybe<CentralizedUserCustomFieldResponseInt>;
};

export type CentralizedUserCustomFieldResponseChoice = {
  __typename?: 'CentralizedUserCustomFieldResponseChoice';
  id?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export type CentralizedUserCustomFieldResponseDate = {
  __typename?: 'CentralizedUserCustomFieldResponseDate';
  id?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export type CentralizedUserCustomFieldResponseInt = {
  __typename?: 'CentralizedUserCustomFieldResponseInt';
  id?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export type CentralizedUserCustomFieldResponseStr = {
  __typename?: 'CentralizedUserCustomFieldResponseStr';
  id?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export type CentralizedUserCustomFieldTextNode = {
  __typename?: 'CentralizedUserCustomFieldTextNode';
  can_edit: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  is_mandatory: Scalars['Boolean']['output'];
  is_visible: Scalars['Boolean']['output'];
  max_length: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  response?: Maybe<CentralizedUserCustomFieldResponseStr>;
};

export type CentralizedUserCustomFieldTextNodeCentralizedUserCustomFieldDateNodeCentralizedUserCustomFieldNumberNodeCentralizedUserCustomFieldMultipleNode = CentralizedUserCustomFieldDateNode | CentralizedUserCustomFieldMultipleNode | CentralizedUserCustomFieldNumberNode | CentralizedUserCustomFieldTextNode;

export type CentralizedUserHeadQuarterNode = {
  __typename?: 'CentralizedUserHeadQuarterNode';
  id: Scalars['Int']['output'];
  is_main: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
};

/** Response containing the centralized user ID */
export type CentralizedUserIdNode = {
  __typename?: 'CentralizedUserIdNode';
  /** Centralized user ID */
  user_centralized_id: Scalars['Int']['output'];
  /** Learning internal ID of the user */
  user_learning_id?: Maybe<Scalars['Int']['output']>;
  /** Talent internal ID of the user */
  user_talent_id?: Maybe<Scalars['Int']['output']>;
  /** Workbeat internal ID of the user */
  user_workbeat_id?: Maybe<Scalars['Int']['output']>;
};

export type CentralizedUserIdNodeValidationErrorResponseInternalErrorResponse = CentralizedUserIdNode | InternalErrorResponse | ValidationErrorResponse;

/** Represents a user in a specific Organization */
export type CentralizedUserInfoNode = {
  __typename?: 'CentralizedUserInfoNode';
  centralized_organization_id: Scalars['Int']['output'];
  centralized_user_id: Scalars['Int']['output'];
  centralized_user_organization_id: Scalars['Int']['output'];
  /** Centralized user id */
  id: Scalars['Int']['output'];
  learning_organization_id?: Maybe<Scalars['Int']['output']>;
  learning_user_id?: Maybe<Scalars['Int']['output']>;
  /** Centralized user profile */
  profile?: Maybe<CentralizedAdminUserProfileNodeCentralizedMeUserProfileNodeCentralizedOtherUserProfileNode>;
  /** Centralized user */
  user?: Maybe<CentralizedUserNode>;
};

/** Centralized User Node */
export type CentralizedUserNode = {
  __typename?: 'CentralizedUserNode';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  id: Scalars['String']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  lastname: Scalars['String']['output'];
  /** Primary Key of User */
  original_id: Scalars['Int']['output'];
  /** Position of the user in the organization */
  position?: Maybe<CentralizedPositionNode>;
  profile_picture: CentralizedImageNode;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type CentralizedUserNodeApiPerformedByMigrationPerformedByImpersonatedPerformedBy = ApiPerformedBy | CentralizedUserNode | ImpersonatedPerformedBy | MigrationPerformedBy;

export type CentralizedUserNodeCustomConnection = {
  __typename?: 'CentralizedUserNodeCustomConnection';
  edges: Array<CentralizedUserNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type CentralizedUserNodeCustomEdge = {
  __typename?: 'CentralizedUserNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CentralizedUserNode;
};

export type CentralizedUserOrganization = {
  __typename?: 'CentralizedUserOrganization';
  area: CentralizedOrganizationArea;
  birthday_date?: Maybe<Scalars['Date']['output']>;
  civil_status?: Maybe<CentralizedCivilStatusEnum>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  document?: Maybe<Scalars['String']['output']>;
  document_type?: Maybe<CentralizedDocumentTypeEnum>;
  headquarter?: Maybe<CentralizedOrganizationHeadquarter>;
  id: Scalars['ID']['output'];
  incorporation_date?: Maybe<Scalars['Date']['output']>;
  learning_id?: Maybe<Scalars['ID']['output']>;
  learning_user_id?: Maybe<Scalars['ID']['output']>;
  learning_user_organization_id?: Maybe<Scalars['ID']['output']>;
  leaving_date?: Maybe<Scalars['Date']['output']>;
  position: CentralizedOrganizationPosition;
  position_category: CentralizedOrganizationPositionCategory;
  role: CentralizedUserOrganizationRoleEnum;
  status: CentralizedUserOrganizationStatusEnum;
  talent_employee_id?: Maybe<Scalars['ID']['output']>;
  talent_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user: CentralizedBasicUser;
};

export type CentralizedUserOrganizationConnection = {
  __typename?: 'CentralizedUserOrganizationConnection';
  /** A list of edges in this connection. */
  edges: Array<CentralizedUserOrganizationEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type CentralizedUserOrganizationEdge = {
  __typename?: 'CentralizedUserOrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CentralizedUserOrganization;
};

/** Represents a user in a specific Organization */
export type CentralizedUserOrganizationNode = {
  __typename?: 'CentralizedUserOrganizationNode';
  /** About Me */
  about_me?: Maybe<Scalars['String']['output']>;
  access_modules: Array<EnterpriseEnum>;
  /** Activate Date */
  activate_date?: Maybe<Scalars['DateTime']['output']>;
  /** Activation Link */
  activation_link?: Maybe<Scalars['String']['output']>;
  /** Address */
  address?: Maybe<Scalars['String']['output']>;
  /** All Catalog */
  all_catalog: Scalars['Boolean']['output'];
  area_level_1?: Maybe<OrganizationAreaNode>;
  /** Area levels structure */
  areas?: Maybe<CentralizedAreaLevelsNode>;
  /** Avatar ID */
  avatar_id?: Maybe<Scalars['Int']['output']>;
  /** Birthday Date */
  birthday_date?: Maybe<Scalars['DateTime']['output']>;
  /** Boss */
  boss?: Maybe<CentralizedUserNode>;
  /** Boss ID */
  boss_id?: Maybe<Scalars['Int']['output']>;
  /** Can Select Team */
  can_select_team: Scalars['Boolean']['output'];
  /** City */
  city?: Maybe<Scalars['String']['output']>;
  /** Civil Status */
  civil_status?: Maybe<CivilStatusEnum>;
  /** Country */
  country?: Maybe<Scalars['String']['output']>;
  /** Country Code */
  country_code?: Maybe<Scalars['String']['output']>;
  /** Custom Fields (Also called Atributos Unificados) */
  custom_fields_value?: Maybe<Array<CustomFieldValueNode>>;
  /** Deactivation Date */
  deactivation_date?: Maybe<Scalars['DateTime']['output']>;
  /** Department */
  departament?: Maybe<Scalars['String']['output']>;
  /**
   * Department
   * @deprecated This field is not in use
   */
  department?: Maybe<OrganizationDepartmentNode>;
  /**
   * Department ID
   * @deprecated This field is not in use
   */
  department_id?: Maybe<Scalars['Int']['output']>;
  /** Document */
  document?: Maybe<Scalars['String']['output']>;
  /** Document Type */
  document_type?: Maybe<DocumentTypeEnum>;
  /** Emergency Contact Email */
  emergency_contact_email?: Maybe<Scalars['String']['output']>;
  /** Emergency Contact Name */
  emergency_contact_name?: Maybe<Scalars['String']['output']>;
  /** Emergency Contact Phone */
  emergency_contact_phone?: Maybe<Scalars['String']['output']>;
  /** Emergency Contact Relationship */
  emergency_contact_relationship?: Maybe<Scalars['String']['output']>;
  /** Expiration Date */
  expiration_date?: Maybe<Scalars['DateTime']['output']>;
  /** First Select Team */
  first_select_team: Scalars['Boolean']['output'];
  /** Gender */
  gender?: Maybe<GenderEnum>;
  id: Scalars['String']['output'];
  /**
   * Identification
   * @deprecated This field is not in use
   */
  identification?: Maybe<Scalars['String']['output']>;
  /**
   * Identification Type
   * @deprecated This field is not in use
   */
  identification_type?: Maybe<IdentificationTypeNode>;
  /**
   * Identification Type ID
   * @deprecated This field is not in use
   */
  identification_type_id?: Maybe<Scalars['Int']['output']>;
  /** Incorporation Date */
  incorporation_date?: Maybe<Scalars['DateTime']['output']>;
  /** If the user is invited to the Organization */
  invitation_sent: Scalars['Boolean']['output'];
  /** Is CEO */
  is_ceo?: Maybe<Scalars['Boolean']['output']>;
  /** Is Confirmed */
  is_confirmed: Scalars['Boolean']['output'];
  /** Last Activity Date */
  last_activity_date?: Maybe<Scalars['DateTime']['output']>;
  /** Last Email Date */
  last_email_date?: Maybe<Scalars['DateTime']['output']>;
  /** Leaving Date */
  leaving_date?: Maybe<Scalars['DateTime']['output']>;
  /** Linkedin URL */
  linkedin_url?: Maybe<Scalars['String']['output']>;
  /** Organization */
  organization: CentralizedOrganizationNode;
  /** Area */
  organization_area?: Maybe<OrganizationAreaNode>;
  /** Headquarter */
  organization_headquarter?: Maybe<CentralizedOrganizationHeadquarterNode>;
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Personal Email */
  personal_email?: Maybe<Scalars['String']['output']>;
  /** Phone 1 */
  phone_1?: Maybe<Scalars['String']['output']>;
  /** Phone 2 */
  phone_2?: Maybe<Scalars['String']['output']>;
  /** Position */
  position?: Maybe<OrganizationPositionNode>;
  /** Position Category */
  position_category?: Maybe<OrganizationPositionCategoryNode>;
  /** Position Category ID */
  position_category_id?: Maybe<Scalars['Int']['output']>;
  /** Position ID */
  position_id?: Maybe<Scalars['Int']['output']>;
  /** Active product suite licenses assigned to the user in this organization */
  product_suites: Array<UserProductSuiteNode>;
  /** Profile Completion */
  profile_completion?: Maybe<Scalars['Int']['output']>;
  /** Talent Profile Link */
  profile_link?: Maybe<Scalars['String']['output']>;
  role: UserOrganizationRoleEnum;
  /** Status */
  status: UserOrganizationStatus;
  /** Sub Department */
  sub_departament?: Maybe<Scalars['String']['output']>;
  /** User */
  user: CentralizedUserNode;
  /** User ID */
  user_id: Scalars['Int']['output'];
  /** Web Site URL */
  web_site_url?: Maybe<Scalars['String']['output']>;
  /**
   * Department
   * @deprecated This field is not in use
   */
  workplace?: Maybe<OrganizationWorkplaceNode>;
};


/** Represents a user in a specific Organization */
export type CentralizedUserOrganizationNodeProfile_LinkArgs = {
  sso?: Scalars['Boolean']['input'];
};

export type CentralizedUserOrganizationNodeCustomConnection = {
  __typename?: 'CentralizedUserOrganizationNodeCustomConnection';
  edges: Array<CentralizedUserOrganizationNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type CentralizedUserOrganizationNodeCustomConnectionValidationErrorResponse = CentralizedUserOrganizationNodeCustomConnection | ValidationErrorResponse;

export type CentralizedUserOrganizationNodeCustomEdge = {
  __typename?: 'CentralizedUserOrganizationNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CentralizedUserOrganizationNode;
};

export type CentralizedUserOrganizationQueries = {
  __typename?: 'CentralizedUserOrganizationQueries';
  /** Get all user organizations */
  get_centralized_user_organizations: GetCentralizedUserOrganizationsResponse;
  /** Users domain queries */
  users: UsersQueries;
};


export type CentralizedUserOrganizationQueriesGet_Centralized_User_OrganizationsArgs = {
  input: CentralizedGetUserOrganizationsInput;
};

export enum CentralizedUserOrganizationRoleEnum {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Subadmin = 'SUBADMIN'
}

export enum CentralizedUserOrganizationStatusEnum {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export type CentralizedUserPayload = {
  __typename?: 'CentralizedUserPayload';
  centralized_organization_id: Scalars['ID']['output'];
  centralized_user_id: Scalars['ID']['output'];
  learning_organization_id: Scalars['ID']['output'];
  learning_user_id: Scalars['ID']['output'];
  talent_company_id: Scalars['ID']['output'];
  talent_employee_id: Scalars['ID']['output'];
};

export type CentralizedUserPayloadQueryValidationErrorQueryInternalServerError = CentralizedUserPayload | QueryInternalServerError | QueryValidationError;

export type CentralizedUserPositionCategoryNode = {
  __typename?: 'CentralizedUserPositionCategoryNode';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CentralizedUserPositionNode = {
  __typename?: 'CentralizedUserPositionNode';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CentralizedUserRecoverPasswordErrorNode = {
  __typename?: 'CentralizedUserRecoverPasswordErrorNode';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CentralizedUserRecoverPasswordInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
};

export type CentralizedUserRecoverPasswordNode = {
  __typename?: 'CentralizedUserRecoverPasswordNode';
  details?: Maybe<CentralizedUserRecoverPasswordErrorNode>;
  recover_link?: Maybe<Scalars['String']['output']>;
};

export type CentralizedUserReportResponse = {
  __typename?: 'CentralizedUserReportResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

/** Input for creating a single employee contact. */
export type CentralizedUsersCreateEmployeeContactInput = {
  /** Organization scope (mandatory for data isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Target user ID within the organization. */
  centralized_user_id: Scalars['Int']['input'];
  /** Contact data to create. */
  contact: EmployeeContactFieldsInput;
};

/** Input for soft-deleting a single employee contact. */
export type CentralizedUsersDeleteEmployeeContactInput = {
  /** Organization scope (mandatory for data isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Owner user ID within the organization. */
  centralized_user_id: Scalars['Int']['input'];
  /** ID of the contact record to delete. */
  contact_id: Scalars['Int']['input'];
};

/** Input for retrieving a single employee contact by ID. */
export type CentralizedUsersGetEmployeeContactInput = {
  /** Organization scope (mandatory for data isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Owner user ID within the organization. */
  centralized_user_id: Scalars['Int']['input'];
  /** ID of the contact record to retrieve. */
  contact_id: Scalars['Int']['input'];
};

/** Input for querying all contacts for an employee. */
export type CentralizedUsersGetEmployeeContactsInput = {
  /** Organization scope (mandatory for data isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Target user ID within the organization. */
  centralized_user_id: Scalars['Int']['input'];
};

/** Input for querying an employee's organizational structure. */
export type CentralizedUsersGetEmployeeOrgStructureInput = {
  /** Organization scope (mandatory for data isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Target user ID within the organization. */
  centralized_user_id: Scalars['Int']['input'];
};

/** Input for querying an employee's personal and contact information. */
export type CentralizedUsersGetEmployeePersonalInfoInput = {
  /** Organization scope (mandatory for data isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Target user ID within the organization. */
  centralized_user_id: Scalars['Int']['input'];
};

/** Input for querying organizational areas. Pass parent_id=null to get root areas (Dirección level); pass a parent_id to get its direct children. */
export type CentralizedUsersGetOrgAreasInput = {
  /** Organization scope (mandatory for data isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Parent area ID. Null returns root areas (Dirección); an ID returns direct children of that area. */
  parent_id?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for querying active headquarters (sedes) in an organization. */
export type CentralizedUsersGetOrgHeadquartersInput = {
  /** Organization scope (mandatory for data isolation). */
  centralized_organization_id: Scalars['Int']['input'];
};

/** Input for querying active position categories in an organization. */
export type CentralizedUsersGetOrgPositionCategoriesInput = {
  /** Organization scope (mandatory for data isolation). */
  centralized_organization_id: Scalars['Int']['input'];
};

/** Input for querying active positions in an organization. */
export type CentralizedUsersGetOrgPositionsInput = {
  /** Organization scope (mandatory for data isolation). */
  centralized_organization_id: Scalars['Int']['input'];
};

export type CentralizedUsersInOrganizationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  user_ids: Array<Scalars['ID']['input']>;
};

export type CentralizedUsersMutation = {
  __typename?: 'CentralizedUsersMutation';
  /** Create a new centralized user */
  create_centralized_user: CreateCentralizedUserPayloadCentralizedMutationValidationErrorCentralizedMutationInternalError;
  /** Crea un nuevo usuario en centralized. Falla si el usuario ya existe en la org. Asigna licencias si se proveen suite_codes. */
  create_centralized_user_v2: CreateCentralizedUserPayloadCentralizedMutationValidationErrorCentralizedMutationInternalError;
  /**
   * Crea o actualiza un usuario existente con el mismo correo en centralized, learning y talent
   * @deprecated Use create_centralized_user instead
   */
  create_or_update_centralized_user: CreateCentralizedUserResponse;
  /** Retira TODAS las sedes gestionadas de un usuario. */
  remove_all_managed_headquarters: RemoveManagedHeadquartersPayloadValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
  /** Desactiva una sede en todos los usuarios de la organización (AC-4/RN17). */
  remove_headquarter_from_all_users: RemoveHeadquarterFromAllUsersPayloadValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
  /** Retira sedes gestionadas puntuales de un usuario (idempotente). */
  remove_managed_headquarters: RemoveManagedHeadquartersPayloadValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
  /** Guarda el conjunto completo de sedes gestionadas por un usuario (reemplazo de conjunto). */
  set_managed_headquarters: ManagedHeadquartersPayloadValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
  /** Inicia (async) la aplicación de la carga masiva de restricciones de sede. Responde al instante; el procesamiento ocurre en background. */
  start_massive_managed_headquarters: ImportExcelFileResponse;
  /** Assigns and/or revokes product suite licenses for a user in a single atomic operation. Validates license capacity before making any changes. */
  update_user_product_suites: UpdateUserProductSuitesResponse;
  /** Users domain mutations */
  users: CentralizedUsersUsersMutation;
  /** Valida un Excel de carga masiva de restricciones de sede (email_usuario | nombre_sede). No escribe en BD. */
  validate_massive_managed_headquarters: ValidateMassiveManagedHeadquartersResponse;
};


export type CentralizedUsersMutationCreate_Centralized_UserArgs = {
  input: CreateCentralizedUserInput;
};


export type CentralizedUsersMutationCreate_Centralized_User_V2Args = {
  input: CreateCentralizedUserInput;
  suite_codes: Array<Scalars['String']['input']>;
};


export type CentralizedUsersMutationCreate_Or_Update_Centralized_UserArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  area_level_1_id: Scalars['Int']['input'];
  area_level_2_id?: InputMaybe<Scalars['Int']['input']>;
  area_level_3_id?: InputMaybe<Scalars['Int']['input']>;
  area_level_4_id?: InputMaybe<Scalars['Int']['input']>;
  boss_email?: InputMaybe<Scalars['String']['input']>;
  boss_id?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  civil_status?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  custom_fields?: InputMaybe<Array<CustomFieldUserCreationInput>>;
  deactivation_date?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Scalars['String']['input']>;
  document_type?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  email_validate?: InputMaybe<Scalars['Boolean']['input']>;
  first_name: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  headquarter_id?: InputMaybe<Scalars['Int']['input']>;
  incorporation_date?: InputMaybe<Scalars['String']['input']>;
  last_name: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
  permission_group_id?: InputMaybe<Scalars['Int']['input']>;
  phone_1?: InputMaybe<Scalars['String']['input']>;
  phone_2?: InputMaybe<Scalars['String']['input']>;
  position_category_id: Scalars['Int']['input'];
  position_id: Scalars['Int']['input'];
  send_invitation?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type CentralizedUsersMutationRemove_All_Managed_HeadquartersArgs = {
  input: RemoveAllManagedHeadquartersInput;
};


export type CentralizedUsersMutationRemove_Headquarter_From_All_UsersArgs = {
  input: RemoveHeadquarterFromAllUsersInput;
};


export type CentralizedUsersMutationRemove_Managed_HeadquartersArgs = {
  input: RemoveManagedHeadquartersInput;
};


export type CentralizedUsersMutationSet_Managed_HeadquartersArgs = {
  input: ManagedHeadquartersInput;
};


export type CentralizedUsersMutationStart_Massive_Managed_HeadquartersArgs = {
  input: MassiveManagedHeadquartersInput;
};


export type CentralizedUsersMutationUpdate_User_Product_SuitesArgs = {
  input: UpdateUserProductSuitesInput;
};


export type CentralizedUsersMutationValidate_Massive_Managed_HeadquartersArgs = {
  input: MassiveManagedHeadquartersInput;
};

/** Input for updating a single existing employee contact. */
export type CentralizedUsersUpdateEmployeeContactInput = {
  /** Organization scope (mandatory for data isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Owner user ID within the organization. */
  centralized_user_id: Scalars['Int']['input'];
  /** Contact fields to update. */
  contact: EmployeeContactFieldsInput;
  /** ID of the contact record to update. */
  contact_id: Scalars['Int']['input'];
};

/** Input for updating an employee's editable personal and contact fields. All fields are optional — only provided fields are updated (partial update semantics). */
export type CentralizedUsersUpdateEmployeePersonalInfoInput = {
  /** Short personal bio (max 600 characters recommended). */
  about_me?: InputMaybe<Scalars['String']['input']>;
  /** Home or mailing address. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth. Must not be in the future. */
  birthday_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Organization scope (mandatory for data isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Target user ID within the organization. */
  centralized_user_id: Scalars['Int']['input'];
  /** Civil/marital status. */
  civil_status?: InputMaybe<CivilStatusEnum>;
  /** Only relevant when incorporation_date changes. True (default) attempts balance recalculation immediately. Pass False to save the date without recalculating now — affected policies are marked as misaligned for a time-off admin to resolve later (HRIS-3981, AC-1). */
  confirm_recalculation?: Scalars['Boolean']['input'];
  /** Document number. When document_type is CURP, must match ^[A-Z]{4}\d{6}[HM][A-Z]{5}[A-Z0-9]\d$ (18 chars). */
  document?: InputMaybe<Scalars['String']['input']>;
  /** Type of identification document (e.g. CURP, PASSPORT). */
  document_type?: InputMaybe<DocumentTypeEnum>;
  /** First name of the employee. Must be non-empty if provided. */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** Fiscal/tax ID (RFC). When the employee's country of residence is Mexico (country='México' or country_code='MEX'), must match RFC persona física format ^[A-Z]{4}\d{6}[A-Z0-9]{3}$ (13 chars). Free text for other countries. */
  fiscal_id?: InputMaybe<Scalars['String']['input']>;
  /** Whether the employee has a declared disability. */
  has_disability?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date the employee joined the organization. */
  incorporation_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Primary last name (apellido paterno). Must be non-empty if provided. */
  lastname?: InputMaybe<Scalars['String']['input']>;
  /** Date the employee left the organization. Informative only: it does not deactivate the user, that is a separate mutation. */
  leaving_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** LinkedIn profile URL. */
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  /** Medical fitness status (occupational health evaluation result). */
  medical_fitness?: InputMaybe<MedicalFitnessEnum>;
  /** Personal email address. Must be a valid email format if provided. */
  personal_email?: InputMaybe<Scalars['String']['input']>;
  /** Landline phone number. */
  phone_1?: InputMaybe<Scalars['String']['input']>;
  /** Cellphone number. */
  phone_2?: InputMaybe<Scalars['String']['input']>;
  /** Second last name (apellido materno). */
  second_lastname?: InputMaybe<Scalars['String']['input']>;
  /** Username used for login. */
  username?: InputMaybe<Scalars['String']['input']>;
  /** Personal website URL. */
  web_site_url?: InputMaybe<Scalars['String']['input']>;
};

export type CentralizedUsersUsersMutation = {
  __typename?: 'CentralizedUsersUsersMutation';
  /** Create a single family/emergency contact for an employee. */
  create_employee_contact: CreateEmployeeContactResponse;
  /** Soft-delete a single family/emergency contact for an employee. The record is marked inactive (is_active=False) — not physically removed. */
  delete_employee_contact: DeleteEmployeeContactResponse;
  /** Update a single existing family/emergency contact for an employee. */
  update_employee_contact: UpdateEmployeeContactResponse;
  /** Update editable personal and contact fields for an employee. Only provided (non-null) fields are updated (partial update semantics). Passing null for an optional field leaves the current value unchanged — fields cannot be cleared via this mutation by design. Read-only fields (email, country, country_code, birth_country, birth_country_code, gender) are not accepted in this input. */
  update_employee_personal_info: UpdateEmployeePersonalInfoResponse;
};


export type CentralizedUsersUsersMutationCreate_Employee_ContactArgs = {
  input: CentralizedUsersCreateEmployeeContactInput;
};


export type CentralizedUsersUsersMutationDelete_Employee_ContactArgs = {
  input: CentralizedUsersDeleteEmployeeContactInput;
};


export type CentralizedUsersUsersMutationUpdate_Employee_ContactArgs = {
  input: CentralizedUsersUpdateEmployeeContactInput;
};


export type CentralizedUsersUsersMutationUpdate_Employee_Personal_InfoArgs = {
  input: CentralizedUsersUpdateEmployeePersonalInfoInput;
};

export type CentralizedValidationError = UsersGraphOperationI & {
  __typename?: 'CentralizedValidationError';
  code: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/** Represents the CEO of a specific organization. */
export type CeoInfoNode = {
  __typename?: 'CeoInfoNode';
  centralized_organization_id: Scalars['Int']['output'];
  centralized_user_id: Scalars['Int']['output'];
  centralized_user_organization_id: Scalars['Int']['output'];
  /** Centralized user id */
  id: Scalars['Int']['output'];
  learning_organization_id?: Maybe<Scalars['Int']['output']>;
  learning_user_id?: Maybe<Scalars['Int']['output']>;
  /** Centralized user profile */
  profile?: Maybe<CentralizedAdminUserProfileNode>;
  /** Centralized user */
  user?: Maybe<CentralizedUserNode>;
};

export type CertificateAdminQuery = {
  __typename?: 'CertificateAdminQuery';
  certificate_detail?: Maybe<CertificateDetailNode>;
};


export type CertificateAdminQueryCertificate_DetailArgs = {
  certificate_id: Scalars['Int']['input'];
  organization_id: Scalars['Int']['input'];
};

export type CertificateBuilderQuery = {
  __typename?: 'CertificateBuilderQuery';
  /** Check if organization has dc3 template configured */
  get_admin_check_organization_has_dc3_template: CheckOrganizationHasDc3TemplateNode;
  /** Compute total of certifies to download */
  get_admin_compute_total_certifies_to_download: ComputeTotalCertifiesToDownloadNode;
  /** Get Courses by organization template type */
  get_admin_courses_by_organization_template_type: CoursePageNumberPagination;
  /** Get certificate organization names */
  get_certificate_organization_names_admin: CertificateOrganizationNameNodeConnectionQueryInternalError;
  /** Get Course Organization Templates, Organization default templates */
  get_course_organization_templates_admin: GetCourseOrganizationTemplatesNode;
  /** Get DC3 Organization Names */
  get_dc3_organization_names_admin: Dc3OrganizationNameNodeConnectionQueryInternalError;
  /** Get DC3 Theme options */
  get_dc3_theme_options_admin: ThemeOptionPageNumberPagination;
  /** Get DC4 Organization attribute config */
  get_dc4_organization_attribute_admin?: Maybe<Dc4OrganizationAttributeNode>;
  /** Get Organization instructors */
  get_organization_course_instructors_admin: OrganizationCourseInstructorNodeConnectionQueryInternalError;
  /** Get Organization template */
  get_organization_template_admin?: Maybe<OrganizationTemplateNode>;
  /** Get Organization template base */
  get_organization_template_base_admin?: Maybe<OrganizationTemplateBaseNode>;
  /** Get Organization template bases */
  get_organization_template_bases_admin: OrganizationTemplateBaseConnection;
  /** Get Organization templates */
  get_organization_templates_admin: OrganizationTemplateConnection;
  /** Get Track Organization Templates, Organization default templates */
  get_track_organization_templates_admin: GetTrackOrganizationTemplatesNode;
};


export type CertificateBuilderQueryGet_Admin_Check_Organization_Has_Dc3_TemplateArgs = {
  input: CheckOrganizationHasDc3TemplateInput;
};


export type CertificateBuilderQueryGet_Admin_Compute_Total_Certifies_To_DownloadArgs = {
  input: DownloadCertificateInput;
};


export type CertificateBuilderQueryGet_Admin_Courses_By_Organization_Template_TypeArgs = {
  input: CoursesByOrganizationTemplateTypeInput;
};


export type CertificateBuilderQueryGet_Certificate_Organization_Names_AdminArgs = {
  input: GetCertificateOrganizationNamesInput;
};


export type CertificateBuilderQueryGet_Course_Organization_Templates_AdminArgs = {
  input: GetCourseOrganizationTemplatesInput;
};


export type CertificateBuilderQueryGet_Dc3_Organization_Names_AdminArgs = {
  input: Dc3OrganizationNamesInput;
};


export type CertificateBuilderQueryGet_Dc3_Theme_Options_AdminArgs = {
  input: Dc3ThemeOptionTypeInput;
};


export type CertificateBuilderQueryGet_Dc4_Organization_Attribute_AdminArgs = {
  input: GetDc4OrganizationAttributeTypeInput;
};


export type CertificateBuilderQueryGet_Organization_Course_Instructors_AdminArgs = {
  input: OrganizationCourseInstructorsInput;
};


export type CertificateBuilderQueryGet_Organization_Template_AdminArgs = {
  input: GetOrganizationTemplateInput;
};


export type CertificateBuilderQueryGet_Organization_Template_Base_AdminArgs = {
  input: GetOrganizationTemplateBaseInput;
};


export type CertificateBuilderQueryGet_Organization_Template_Bases_AdminArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CertificateBuilderQueryGet_Organization_Templates_AdminArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: OrganizationTemplatesInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CertificateBuilderQueryGet_Track_Organization_Templates_AdminArgs = {
  input: GetTrackOrganizationTemplatesInput;
};

export type CertificateCourseMetadataType = {
  __typename?: 'CertificateCourseMetadataType';
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type CertificateDashboard = {
  __typename?: 'CertificateDashboard';
  certificates: Scalars['Int']['output'];
  certificates_ranking: Array<CertificateUser>;
  custom_field_filters?: Maybe<Array<CustomFieldFilter>>;
  from_date?: Maybe<Scalars['Date']['output']>;
  organization_id: Scalars['ID']['output'];
  participation_certificate: Scalars['Int']['output'];
  to_date?: Maybe<Scalars['Date']['output']>;
};

export type CertificateDetailNode = {
  __typename?: 'CertificateDetailNode';
  certificate_id: Scalars['Int']['output'];
  course_id: Scalars['Int']['output'];
  course_is_mandatory: Scalars['Boolean']['output'];
  course_title: Scalars['String']['output'];
  current: CertificateVersionNode;
  history: Array<CertificateVersionNode>;
  user_avatar_url?: Maybe<Scalars['String']['output']>;
  user_department?: Maybe<Scalars['String']['output']>;
  user_email: Scalars['String']['output'];
  user_full_name: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
};

export enum CertificateDocumentTypeEnum {
  CertificateDocumentTypeCourseAccreditation = 'CERTIFICATE_DOCUMENT_TYPE_COURSE_ACCREDITATION',
  CertificateDocumentTypeDiploma = 'CERTIFICATE_DOCUMENT_TYPE_DIPLOMA',
  CertificateDocumentTypeLiveSession = 'CERTIFICATE_DOCUMENT_TYPE_LIVE_SESSION'
}

export enum CertificateEventType {
  CertificateByAutomationProcess = 'CERTIFICATE_BY_AUTOMATION_PROCESS',
  CertificateByManual = 'CERTIFICATE_BY_MANUAL',
  CertificateByProgress = 'CERTIFICATE_BY_PROGRESS',
  CertificateByProject = 'CERTIFICATE_BY_PROJECT',
  CertificateByQuizz = 'CERTIFICATE_BY_QUIZZ'
}

export type CertificateGenerationResult = {
  __typename?: 'CertificateGenerationResult';
  /** Document type that was generated. */
  document_type: CertificateDocumentTypeEnum;
  /** Error message if the generation failed, null on success. */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether the generation succeeded. */
  success: Scalars['Boolean']['output'];
};

export type CertificateGenerationResultPayload = {
  __typename?: 'CertificateGenerationResultPayload';
  /** Set when a pre-flight input error prevented generation (e.g. enrollment not found). Null when `results` reflects a completed (possibly empty) generation attempt. */
  error?: Maybe<Scalars['String']['output']>;
  /** List of generation results, one per attempted document type. Empty only when a pre-flight input error occurs or an unexpected internal error is raised; an unsupported document_type or a course with no configured document types still yields a single failed/fallback entry. */
  results: Array<CertificateGenerationResult>;
  /** Backward-compatible overall result. True only when at least one document was generated and every attempted document succeeded. Mirrors the legacy `success` field. */
  success: Scalars['Boolean']['output'];
};

export type CertificateMetadataType = {
  __typename?: 'CertificateMetadataType';
  total_accreditation_certificates?: Maybe<Scalars['Int']['output']>;
  total_certificates?: Maybe<Scalars['Int']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  total_course_certificates?: Maybe<Scalars['Int']['output']>;
  total_live_session_certificates?: Maybe<Scalars['Int']['output']>;
  total_participation_certificates?: Maybe<Scalars['Int']['output']>;
  total_track_certificates?: Maybe<Scalars['Int']['output']>;
};

export type CertificateNode = {
  __typename?: 'CertificateNode';
  attachment_url?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
};

export type CertificateNodeType = {
  __typename?: 'CertificateNodeType';
  attachment_url?: Maybe<Scalars['String']['output']>;
  certificate_type?: Maybe<CertificateTypeEnum>;
  code?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CertificateNodeTypePaginationEdge = {
  __typename?: 'CertificateNodeTypePaginationEdge';
  /** The item at the end of the edge. */
  node: CertificateNodeType;
};

export enum CertificateOrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type CertificateOrganizationNameNode = {
  __typename?: 'CertificateOrganizationNameNode';
  name: Scalars['String']['output'];
  organization_id: Scalars['Int']['output'];
};

export type CertificateOrganizationNameNodeConnection = {
  __typename?: 'CertificateOrganizationNameNodeConnection';
  /** A list of edges in this connection. */
  edges: Array<CertificateOrganizationNameNodeEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type CertificateOrganizationNameNodeConnectionQueryInternalError = CertificateOrganizationNameNodeConnection | QueryInternalError;

export type CertificateOrganizationNameNodeEdge = {
  __typename?: 'CertificateOrganizationNameNodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CertificateOrganizationNameNode;
};

export type CertificatePageNumberPagination = {
  __typename?: 'CertificatePageNumberPagination';
  edges: Array<CertificateNodeTypePaginationEdge>;
  metadata?: Maybe<CertificateMetadataType>;
  /** Information to aid in pagination. */
  page_info: NumberPageInfo;
  page_size?: Maybe<Scalars['Int']['output']>;
};

export type CertificatePolicyBuilderMutations = {
  __typename?: 'CertificatePolicyBuilderMutations';
  set_course_certificate_policy: SetCourseCertificatePolicyResponse;
};


export type CertificatePolicyBuilderMutationsSet_Course_Certificate_PolicyArgs = {
  input: SetCourseCertificatePolicyInput;
};

export type CertificatePolicyBuilderQuery = {
  __typename?: 'CertificatePolicyBuilderQuery';
  course_certificate_policy?: Maybe<CourseCertificatePolicyNode>;
};


export type CertificatePolicyBuilderQueryCourse_Certificate_PolicyArgs = {
  course_id: Scalars['Int']['input'];
  organization_id: Scalars['Int']['input'];
};

export type CertificateQuery = {
  __typename?: 'CertificateQuery';
  /** Get collaborator Certificates */
  get_certificates: CertificatePageNumberPagination;
};


export type CertificateQueryGet_CertificatesArgs = {
  input: GetCertificatesInput;
};

export type CertificateResponse = {
  __typename?: 'CertificateResponse';
  /** Public verification code of the certificate. */
  certificate_code?: Maybe<Scalars['String']['output']>;
  /** Download URL of the certificate PDF. Populated when the certificate is issued (or already existed); null otherwise. */
  certificate_url?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  /** URL of the certificate preview image (PNG); null when unavailable. */
  image_url?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum CertificateTypeEnum {
  CertificateTypeAcademy = 'CERTIFICATE_TYPE_ACADEMY',
  CertificateTypeCareer = 'CERTIFICATE_TYPE_CAREER',
  CertificateTypeCertification = 'CERTIFICATE_TYPE_CERTIFICATION',
  CertificateTypeCourse = 'CERTIFICATE_TYPE_COURSE',
  CertificateTypeCourseAccreditation = 'CERTIFICATE_TYPE_COURSE_ACCREDITATION',
  CertificateTypeLiveSession = 'CERTIFICATE_TYPE_LIVE_SESSION',
  CertificateTypeTrack = 'CERTIFICATE_TYPE_TRACK',
  ParticipationCertificateTypeCourse = 'PARTICIPATION_CERTIFICATE_TYPE_COURSE',
  ParticipationCertificateTypeMinedu = 'PARTICIPATION_CERTIFICATE_TYPE_MINEDU',
  ParticipationCertificateTypeSixthAnniversary = 'PARTICIPATION_CERTIFICATE_TYPE_SIXTH_ANNIVERSARY',
  ParticipationCertificateTypeWorkshop = 'PARTICIPATION_CERTIFICATE_TYPE_WORKSHOP'
}

export enum CertificateTypeFilterEnum {
  CertificateTypeAcademy = 'CERTIFICATE_TYPE_ACADEMY',
  CertificateTypeCareer = 'CERTIFICATE_TYPE_CAREER',
  CertificateTypeCertification = 'CERTIFICATE_TYPE_CERTIFICATION',
  CertificateTypeCourse = 'CERTIFICATE_TYPE_COURSE',
  CertificateTypeCourseAccreditation = 'CERTIFICATE_TYPE_COURSE_ACCREDITATION',
  CertificateTypeLiveSession = 'CERTIFICATE_TYPE_LIVE_SESSION',
  CertificateTypeParticipationCertificate = 'CERTIFICATE_TYPE_PARTICIPATION_CERTIFICATE',
  CertificateTypeTrack = 'CERTIFICATE_TYPE_TRACK'
}

export type CertificateUser = {
  __typename?: 'CertificateUser';
  certificates: Scalars['Int']['output'];
  user?: Maybe<User>;
  user_id: Scalars['ID']['output'];
};

export enum CertificateValidityStatus {
  Expired = 'EXPIRED',
  ExpiringSoon = 'EXPIRING_SOON',
  Superseded = 'SUPERSEDED',
  Valid = 'VALID'
}

export type CertificateVersionNode = {
  __typename?: 'CertificateVersionNode';
  days_to_expire?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  is_current: Scalars['Boolean']['output'];
  issued_at: Scalars['DateTime']['output'];
  origin: CertificateVersionOrigin;
  pdf_url?: Maybe<Scalars['String']['output']>;
  status: CertificateValidityStatus;
  version: Scalars['Int']['output'];
};

export enum CertificateVersionOrigin {
  AdminReset = 'ADMIN_RESET',
  AutoReassign = 'AUTO_REASSIGN',
  Backfill = 'BACKFILL',
  Initial = 'INITIAL'
}

export type CertificationRule = {
  __typename?: 'CertificationRule';
  course_id: Scalars['Int']['output'];
  organization_id: Scalars['Int']['output'];
  rule?: Maybe<CertificationRuleNode>;
};

export type CertificationRuleNode = {
  __typename?: 'CertificationRuleNode';
  has_approved_project: Scalars['Boolean']['output'];
  has_approved_quizz: Scalars['Boolean']['output'];
  has_completed_progress: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  no_certification: Scalars['Boolean']['output'];
};

export type ChangeMyPasswordInput = {
  password: Scalars['String']['input'];
};

export type ChangeMyPasswordPayload = {
  __typename?: 'ChangeMyPasswordPayload';
  next_url?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ChangeMyPasswordPayloadSecurityMutationErrorInternalServerMutationError = ChangeMyPasswordPayload | InternalServerMutationError | SecurityMutationError;

export type ChangeOrganizationUserEmailPayload = {
  __typename?: 'ChangeOrganizationUserEmailPayload';
  user_organization: CrehanaAuthUserOrganization;
};

export type ChangeOrganizationUserEmailPayloadUserOrganizationValidationMutationErrorInternalServerMutationError = ChangeOrganizationUserEmailPayload | InternalServerMutationError | UserOrganizationValidationMutationError;

export type ChangePassword = ChangePasswordResponse | ErrorResponse;

export type ChangePasswordResponse = {
  __typename?: 'ChangePasswordResponse';
  alternative_user_id: Scalars['Int']['output'];
  next_url: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ChangePasswordUserAutogeneratedPasswordPayload = {
  __typename?: 'ChangePasswordUserAutogeneratedPasswordPayload';
  autogenerated_password: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
};

export type ChangePasswordUserChangedPasswordPayload = {
  __typename?: 'ChangePasswordUserChangedPasswordPayload';
  user_id: Scalars['ID']['output'];
};

export type ChangeUserOrganizationEmailMutationInput = {
  email: Scalars['String']['input'];
  organization_id: Scalars['ID']['input'];
};

export type ChangeUserOrganizationEmailPayload = {
  __typename?: 'ChangeUserOrganizationEmailPayload';
  user_organization: UserOrganization;
};

export type ChangeUserOrganizationEmailPayloadUserOrganizationValidationMutationErrorInternalServerMutationError = ChangeUserOrganizationEmailPayload | InternalServerMutationError | UserOrganizationValidationMutationError;

export type ChangeUserPasswordInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
  confirm_password: Scalars['String']['input'];
  force_change_password?: Scalars['Boolean']['input'];
  password: Scalars['String']['input'];
};

export type ChangeUserPasswordPayload = {
  __typename?: 'ChangeUserPasswordPayload';
  success: Scalars['Boolean']['output'];
};

export type ChangeUserPasswordPayloadSecurityMutationErrorInternalServerMutationError = ChangeUserPasswordPayload | InternalServerMutationError | SecurityMutationError;

export type ChatConversation = {
  __typename?: 'ChatConversation';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mode: CopilotConversationModeEnum;
  organization_id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['ID']['output'];
};

export type ChatConversationConnection = {
  __typename?: 'ChatConversationConnection';
  edges: Array<ChatConversationEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type ChatConversationDataInput = {
  organization_id: Scalars['ID']['input'];
  prompt: Scalars['String']['input'];
};

export type ChatConversationDataPayload = {
  __typename?: 'ChatConversationDataPayload';
  chat_message: ChatMessage;
  graphql_operation_id: Scalars['ID']['output'];
};

export type ChatConversationDataPayloadMutationInternalError = ChatConversationDataPayload | MutationInternalError;

export type ChatConversationDataPayloadMutationValidationErrorMutationInternalError = ChatConversationDataPayload | MutationInternalError | MutationValidationError;

/** An edge in a connection. */
export type ChatConversationEdge = {
  __typename?: 'ChatConversationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ChatConversation;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  chat_conversation: ChatConversation;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  response?: Maybe<ChatMessageResponse>;
  /** Traza normalizada del agente (Planner o Supervisor) como lista tipada de eventos (status / tool / session_context). Cada evento lleva un `status` de ciclo de vida. None si el mensaje no tiene response_stream (p. ej. el pipeline legacy sin supervisor); [] si hay stream pero sin eventos. */
  response_events?: Maybe<Array<ChatMessageStreamEvent>>;
  /** Traza incremental del agente (Planner o Supervisor): contenido acumulado, fase actual y eventos. Se puebla durante y después de la ejecución; None si el mensaje no pasó por ninguno de los dos (p. ej. el pipeline legacy sin supervisor). */
  response_stream?: Maybe<ChatMessageStream>;
  status: ChatMessageStatusEnum;
  updated_at: Scalars['DateTime']['output'];
  user_id: Scalars['ID']['output'];
};

export type ChatMessageRatingDataInput = {
  category?: InputMaybe<RatingCategory>;
  chat_message_id: Scalars['ID']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
  liked: Scalars['Boolean']['input'];
};

export type ChatMessageRatingDataPayload = {
  __typename?: 'ChatMessageRatingDataPayload';
  chat_message_rating: CopilotChatMessageRatingNode;
  graphql_operation_id: Scalars['ID']['output'];
};

export type ChatMessageRatingDataPayloadMutationValidationErrorMutationInternalError = ChatMessageRatingDataPayload | MutationInternalError | MutationValidationError;

export type ChatMessageResponse = {
  __typename?: 'ChatMessageResponse';
  /** Gráfico que el agente adjuntó a esta respuesta, como **datos** (categorías/series o porciones, con sus ejes y su forma) para que el cliente lo dibuje: no es una imagen, un SVG ni una URL — para eso está `chart_url`. `null` es el caso normal: la mayoría de las respuestas no lleva gráfico, y un cliente que no lea este campo funciona igual que antes. */
  chart?: Maybe<PlannerChartComponent>;
  chart_url?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  recommendations?: Maybe<Array<Scalars['String']['output']>>;
  recommendations_title?: Maybe<Scalars['String']['output']>;
  report_url?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  time: Scalars['Decimal']['output'];
};

export type ChatMessageSessionContextEvent = {
  __typename?: 'ChatMessageSessionContextEvent';
  /** Si el contexto provino de caché. */
  cached?: Maybe<Scalars['Boolean']['output']>;
  /** Contexto de sesión serializado (JSON string), tal cual. */
  content?: Maybe<Scalars['String']['output']>;
  /** Estado del paso (normalmente COMPLETED). */
  status: ChatMessageStreamEventStatusEnum;
};

export enum ChatMessageStatusEnum {
  StatusCreated = 'STATUS_CREATED',
  StatusError = 'STATUS_ERROR',
  StatusFinished = 'STATUS_FINISHED',
  StatusPending = 'STATUS_PENDING',
  StatusQueued = 'STATUS_QUEUED',
  StatusRetried = 'STATUS_RETRIED',
  StatusStreaming = 'STATUS_STREAMING'
}

export type ChatMessageStatusEvent = {
  __typename?: 'ChatMessageStatusEvent';
  /** Texto legible del paso (data.label). */
  label?: Maybe<Scalars['String']['output']>;
  /** Fase tipada del loader; None si la fase no está mapeada (usar `label` como texto a mostrar). */
  phase?: Maybe<ChatMessageStreamEventPhaseEnum>;
  /** Estado del paso: COMPLETED cuando ya terminó; PENDING si es el último evento y el stream aún no está completo. */
  status: ChatMessageStreamEventStatusEnum;
};

export type ChatMessageStream = {
  __typename?: 'ChatMessageStream';
  content?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Scalars['JSON']['output']>;
  phase?: Maybe<Scalars['String']['output']>;
};

export type ChatMessageStreamEvent = ChatMessageSessionContextEvent | ChatMessageStatusEvent | ChatMessageToolEvent;

export enum ChatMessageStreamEventPhaseEnum {
  Analyzing = 'ANALYZING',
  Answering = 'ANSWERING',
  LoadingContext = 'LOADING_CONTEXT',
  Planning = 'PLANNING'
}

export enum ChatMessageStreamEventStatusEnum {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Pending = 'PENDING'
}

export type ChatMessageToolEvent = {
  __typename?: 'ChatMessageToolEvent';
  /** Argumentos con los que se invocó la tool. */
  arguments?: Maybe<Scalars['JSON']['output']>;
  /** Nombre de la tool invocada. */
  name: Scalars['String']['output'];
  /** Salida de la tool; None mientras está PENDING. */
  output?: Maybe<Scalars['String']['output']>;
  /** PENDING mientras solo se vio el tool_call; COMPLETED cuando llega el resultado; ERROR si el output indica fallo. */
  status: ChatMessageStreamEventStatusEnum;
};

export type CheckCompanyNameInput = {
  centralized_organization_id: Scalars['Int']['input'];
  company_name: Scalars['String']['input'];
};

export type CheckCompanyNamePayload = {
  __typename?: 'CheckCompanyNamePayload';
  company_name: Scalars['String']['output'];
  is_available: Scalars['Boolean']['output'];
};

export type CheckCompanyNamePayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse = CheckCompanyNamePayload | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

export type CheckCompanyNameQuery = {
  __typename?: 'CheckCompanyNameQuery';
  /** Check if a company name is available in the parent corporation. */
  check_company_name: CheckCompanyNamePayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse;
};


export type CheckCompanyNameQueryCheck_Company_NameArgs = {
  input: CheckCompanyNameInput;
};

/** Excel Template Generation Response */
export type CheckExcelTemplateUserResponse = {
  __typename?: 'CheckExcelTemplateUserResponse';
  url: Scalars['String']['output'];
};

export type CheckOrganizationHasDc3TemplateInput = {
  organization_id: Scalars['ID']['input'];
};

export type CheckOrganizationHasDc3TemplateNode = {
  __typename?: 'CheckOrganizationHasDc3TemplateNode';
  exists: Scalars['Boolean']['output'];
};

export type CheckPositionUsageInput = {
  /** ID of the organization */
  organization_id: Scalars['Int']['input'];
  /** Slug of the organization */
  organization_slug: Scalars['String']['input'];
  /** ID of the position to check */
  position_id: Scalars['Int']['input'];
};

export type CheckSlugInput = {
  slug: Scalars['String']['input'];
};

export type CheckSlugPayload = {
  __typename?: 'CheckSlugPayload';
  is_available: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
};

export type CheckSlugPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse = CheckSlugPayload | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

export type CheckSlugQuery = {
  __typename?: 'CheckSlugQuery';
  /** Check if a slug is available. */
  check_slug: CheckSlugPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse;
};


export type CheckSlugQueryCheck_SlugArgs = {
  input: CheckSlugInput;
};

export enum CivilStatusEnum {
  DeFactoUnion = 'DE_FACTO_UNION',
  Divorced = 'DIVORCED',
  FreeUnion = 'FREE_UNION',
  Married = 'MARRIED',
  Other = 'OTHER',
  Single = 'SINGLE',
  Widowed = 'WIDOWED'
}

export enum CivilStatusEnumInput {
  DeFactoUnion = 'DE_FACTO_UNION',
  Divorced = 'DIVORCED',
  Empty = 'EMPTY',
  FreeUnion = 'FREE_UNION',
  Married = 'MARRIED',
  Other = 'OTHER',
  Single = 'SINGLE',
  Widowed = 'WIDOWED'
}

export type ClassNoteConnection = {
  __typename?: 'ClassNoteConnection';
  edges: Array<ClassNoteNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type ClassNoteHighlightNode = {
  __typename?: 'ClassNoteHighlightNode';
  class_note_id: Scalars['Int']['output'];
  created_at: Scalars['String']['output'];
  highlight_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  prompt_version_key: Scalars['String']['output'];
};

export type ClassNoteMutationNode = {
  __typename?: 'ClassNoteMutationNode';
  class_note?: Maybe<ClassNoteNode>;
  /**
   * This object contains information about the response code,
   *         response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ClassNoteNode = {
  __typename?: 'ClassNoteNode';
  class_note_highlight?: Maybe<ClassNoteHighlightNode>;
  created_at: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_public?: Maybe<Scalars['Boolean']['output']>;
  time_position: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  video_lecture?: Maybe<CourseVideo>;
  video_lecture_id: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ClassNoteNodeEdge = {
  __typename?: 'ClassNoteNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ClassNoteNode;
};

export type ClimateAnswerOption = {
  __typename?: 'ClimateAnswerOption';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ClimateCollaboratorMutation = {
  __typename?: 'ClimateCollaboratorMutation';
  /** Finish the climate survey for the collaborator (Java validates all required answers). Identity via input.talent_employee_id. */
  finish: FinishClimateSurveyResult;
  /** Save ONE climate answer (auto-save) for the collaborator. Identity via input.talent_employee_id; answer params from input. */
  save_answer: SaveClimateAnswerResult;
};


export type ClimateCollaboratorMutationFinishArgs = {
  input: TalentFinishClimateSurveyInput;
};


export type ClimateCollaboratorMutationSave_AnswerArgs = {
  input: TalentSaveClimateAnswerInput;
};

export type ClimateCollaboratorQuery = {
  __typename?: 'ClimateCollaboratorQuery';
  /** A single climate survey with lazy config/questions facets (replaces the former survey_config + questions queries). */
  evaluation: ClimateSurvey;
  /** The collaborator's climate evaluations as a paged list (identity via input.talent_employee_id). 1-based offset pagination. */
  evaluations: ClimateEvaluationPage;
};


export type ClimateCollaboratorQueryEvaluationArgs = {
  input: TalentGetClimateEvaluationInput;
};


export type ClimateCollaboratorQueryEvaluationsArgs = {
  input: TalentListClimateEvaluationsInput;
};

/** A dimension grouping related questions. */
export type ClimateDimensionInput = {
  /** True if this is a pre-existing dimension in the system. */
  is_existing_dimension: Scalars['Boolean']['input'];
  /** Dimension name. */
  name: Scalars['String']['input'];
  /** Questions belonging to this dimension. */
  questions: Array<ClimateQuestionInput>;
};

/** A dimension grouping related questions. */
export type ClimateDimensionType = {
  __typename?: 'ClimateDimensionType';
  /** Dimension name. */
  name: Scalars['String']['output'];
  /** Questions belonging to this dimension. */
  questions: Array<AgentosClimateQuestionType>;
};

export type ClimateEvaluation = {
  __typename?: 'ClimateEvaluation';
  end_date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  model_id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  partaker_id: Scalars['ID']['output'];
  start_date: Scalars['DateTime']['output'];
  status: ClimateEvaluationStatus;
};

export type ClimateEvaluationFilterInput = {
  /** Restrict the list to these statuses (applied server-side). None/[] = no status constraint. */
  status_in?: InputMaybe<Array<ClimateEvaluationStatus>>;
};

export type ClimateEvaluationPage = {
  __typename?: 'ClimateEvaluationPage';
  items: Array<ClimateEvaluation>;
  page: Scalars['Int']['output'];
  page_size: Scalars['Int']['output'];
  total_count: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export enum ClimateEvaluationStatus {
  Closed = 'CLOSED',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export enum ClimateExpectationsErrorCodeEnum {
  FieldNotAllowedForSurveyType = 'FIELD_NOT_ALLOWED_FOR_SURVEY_TYPE',
  InvalidSemaphoreRange = 'INVALID_SEMAPHORE_RANGE',
  MissingRequiredFieldForSurveyType = 'MISSING_REQUIRED_FIELD_FOR_SURVEY_TYPE'
}

/** Typed validation error specific to the climate survey expectations step. */
export type ClimateExpectationsValidationError = {
  __typename?: 'ClimateExpectationsValidationError';
  /** Machine-readable error code. */
  code: ClimateExpectationsErrorCodeEnum;
  /** Name of the input field that caused the error, if applicable. */
  field?: Maybe<Scalars['String']['output']>;
  /** Request correlation identifier. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Human-readable description of the error. */
  message: Scalars['String']['output'];
};

/** Survey display and behaviour norms. */
export type ClimateNormsInput = {
  /** Number of questions displayed per page. */
  questions_per_page?: InputMaybe<Scalars['Int']['input']>;
  /** Show a back button on each page. */
  show_back_button?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show a progress indicator to respondents. */
  show_progress_bar?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Access and visibility permissions for the survey. */
export type ClimatePermissionsInput = {
  /** Allow team leaders to view aggregated results. */
  enable_leader_insights?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow unauthenticated access via a public link. */
  enable_public_link?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hide the evaluation from respondents after submission. */
  hide_evaluation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Require respondents to be logged in. */
  require_login?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClimateQuestion = {
  __typename?: 'ClimateQuestion';
  dependencies: Array<ClimateQuestionDependency>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  max_length?: Maybe<Scalars['Int']['output']>;
  options: Array<ClimateAnswerOption>;
  order: Scalars['Int']['output'];
  parent?: Maybe<ClimateQuestionDependency>;
  required: Scalars['Boolean']['output'];
  saved_multiple_responses: Array<Scalars['ID']['output']>;
  saved_response?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  type: ClimateQuestionType;
};

export type ClimateQuestionDependency = {
  __typename?: 'ClimateQuestionDependency';
  option_id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  question_id: Scalars['ID']['output'];
};

/** A single survey question. */
export type ClimateQuestionInput = {
  /** Whether this question is mandatory. */
  is_required: Scalars['Boolean']['input'];
  /** Answer options — required for SINGLE_CHOICE, forbidden for SCALE and OPEN. */
  options?: InputMaybe<Array<ClimateQuestionOptionInput>>;
  /** Question text. */
  text: Scalars['String']['input'];
  /** Question type. */
  type: ClimateQuestionTypeEnum;
};

export enum ClimateQuestionModeEnum {
  Ai = 'AI',
  Manual = 'MANUAL'
}

/** A single answer option for a SINGLE_CHOICE question. */
export type ClimateQuestionOptionInput = {
  /** Display text for this option. */
  label: Scalars['String']['input'];
  /** Numeric weight assigned to this option. */
  weight?: InputMaybe<Scalars['Int']['input']>;
};

/** A single answer option for a SINGLE_CHOICE question. */
export type ClimateQuestionOptionType = {
  __typename?: 'ClimateQuestionOptionType';
  /** Display text for this option. */
  label: Scalars['String']['output'];
  /** Numeric weight assigned to this option. */
  weight: Scalars['Int']['output'];
};

export enum ClimateQuestionSourceEnum {
  AiGenerated = 'AI_GENERATED',
  FallbackTemplate = 'FALLBACK_TEMPLATE',
  Manual = 'MANUAL'
}

export enum ClimateQuestionType {
  ClimateLabel = 'CLIMATE_LABEL',
  Enps = 'ENPS',
  MultipleAnswer = 'MULTIPLE_ANSWER',
  Open = 'OPEN',
  Sociodemographic = 'SOCIODEMOGRAPHIC'
}

export enum ClimateQuestionTypeEnum {
  Open = 'OPEN',
  Scale = 'SCALE',
  SingleChoice = 'SINGLE_CHOICE'
}

export enum ClimateQuestionsErrorCodeEnum {
  MissingOptionsForSingleChoice = 'MISSING_OPTIONS_FOR_SINGLE_CHOICE',
  MissingWeightOnOption = 'MISSING_WEIGHT_ON_OPTION',
  OptionsNotAllowedForType = 'OPTIONS_NOT_ALLOWED_FOR_TYPE',
  QuestionTypeNotAllowedForSurveyType = 'QUESTION_TYPE_NOT_ALLOWED_FOR_SURVEY_TYPE'
}

/** Typed validation error specific to the climate survey questions step. */
export type ClimateQuestionsValidationError = {
  __typename?: 'ClimateQuestionsValidationError';
  /** Machine-readable error code. */
  code: ClimateQuestionsErrorCodeEnum;
  /** Name of the dimension where the error occurred. */
  dimension_name?: Maybe<Scalars['String']['output']>;
  /** Request correlation identifier. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Human-readable description of the error. */
  message: Scalars['String']['output'];
  /** Text of the question that caused the error. */
  question_text?: Maybe<Scalars['String']['output']>;
};

export type ClimateScaleConfig = {
  __typename?: 'ClimateScaleConfig';
  max_label?: Maybe<Scalars['String']['output']>;
  min_label?: Maybe<Scalars['String']['output']>;
  neutral_label?: Maybe<Scalars['String']['output']>;
};

/** Semaphore configuration for Clima General surveys. */
export type ClimateSemaphoreInput = {
  /** Number of color bands (4 or 5). */
  color_count: Scalars['Int']['input'];
  /** Label for each band, in order from lowest to highest. */
  labels: Array<SemaphoreLabelInput>;
};

export type ClimateSurvey = {
  __typename?: 'ClimateSurvey';
  /** Start-screen configuration. Calls GET /survey/climate/configuration ONLY when this facet is selected. */
  config: ClimateSurveyConfig;
  model_id: Scalars['ID']['output'];
  /** Questionnaire (questions + options + saved answers). Calls GET /survey/climate/options + GET /survey/climate/questions ONLY when this facet is selected. Requires partaker_id at resolve time. */
  questions: Array<ClimateQuestion>;
};

/** Result after the survey has been activated in TLNT. */
export type ClimateSurveyActivationType = {
  __typename?: 'ClimateSurveyActivationType';
  /** Workflow identifier. */
  draft_id: Scalars['ID']['output'];
  /** How the questions were produced (AI, manual, fallback_template). */
  question_source?: Maybe<Scalars['String']['output']>;
  /** How many employees were assigned as recipients. */
  recipient_count: Scalars['Int']['output'];
  /** Identifier of the TLNT evaluation wrapping the model. */
  tlnt_evaluation_id?: Maybe<Scalars['String']['output']>;
  /** Identifier of the climate model created in TLNT. */
  tlnt_model_id: Scalars['String']['output'];
  /** Number of dimensions in the activated survey. */
  total_dimensions: Scalars['Int']['output'];
  /** Number of questions across all dimensions. */
  total_questions: Scalars['Int']['output'];
};

export type ClimateSurveyConfig = {
  __typename?: 'ClimateSurveyConfig';
  anonymous: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  end_date: Scalars['DateTime']['output'];
  end_text?: Maybe<Scalars['String']['output']>;
  has_dependence_questions: Scalars['Boolean']['output'];
  questions_per_page?: Maybe<Scalars['Int']['output']>;
  /** ENPS/CLIMATE scale anchor labels (min/max/neutral). Null for non-scale surveys. ⚠️ Sourced from a separate ADMIN Java endpoint as interim tech debt; fires ONLY when this field is selected. */
  scale_config?: Maybe<ClimateScaleConfig>;
  show_back_button: Scalars['Boolean']['output'];
  show_progress_bar: Scalars['Boolean']['output'];
  start_date: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  welcome_image_url?: Maybe<Scalars['String']['output']>;
  welcome_text?: Maybe<Scalars['String']['output']>;
};

/** Result after the context step of a climate survey wizard is confirmed. */
export type ClimateSurveyContextType = {
  __typename?: 'ClimateSurveyContextType';
  /** Workflow identifier — pass this in all subsequent wizard calls. */
  draft_id: Scalars['ID']['output'];
  /** Confirmed period end (ISO 8601). */
  period_end: Scalars['String']['output'];
  /** Confirmed period start (ISO 8601). */
  period_start: Scalars['String']['output'];
  /** Confirmed survey type. */
  survey_type: Scalars['String']['output'];
};

/** Step 2 result — the description the admin accepted. */
export type ClimateSurveyDescriptionType = {
  __typename?: 'ClimateSurveyDescriptionType';
  /** Text on screen: the accepted one, or the freshly drafted one. */
  description: Scalars['String']['output'];
  /** Workflow identifier. */
  draft_id: Scalars['ID']['output'];
};

/** Result after the expectations step of a climate survey wizard is confirmed. */
export type ClimateSurveyExpectationsType = {
  __typename?: 'ClimateSurveyExpectationsType';
  /** Workflow identifier — pass this in all subsequent wizard calls. */
  draft_id: Scalars['ID']['output'];
};

/** Input for the climate survey fallback template query. */
export type ClimateSurveyFallbackTemplateInput = {
  /** Survey type to retrieve the template for. */
  survey_type: ClimateSurveyTypeEnum;
};

export type ClimateSurveyMutation = {
  __typename?: 'ClimateSurveyMutation';
  /** Confirm the summary and activate the survey in TLNT. Last step of the wizard — writes the model, evaluation, configuration and recipients. */
  activate_climate_survey: ActivateClimateSurveyResponse;
  /** Confirm the context step of a climate survey wizard. Pass draft_id to re-confirm an existing session; omit it to start a new one. */
  save_climate_survey_context: SaveClimateSurveyContextResponse;
  /** Step 2 — accept the AI description, edit it, or ask for another draft. */
  save_climate_survey_description: SaveClimateSurveyDescriptionResponse;
  /** Confirm the expectations step of a climate survey wizard. */
  save_climate_survey_expectations: SaveClimateSurveyExpectationsResponse;
  /** Step 1 — name the survey. Starts the wizard and returns the draft_id plus the description the AI wrote from that name. */
  save_climate_survey_name: SaveClimateSurveyNameResponse;
  /** Confirm the participants step. Returns the summary to review before activating the survey. */
  save_climate_survey_participants: SaveClimateSurveyParticipantsResponse;
  /** Confirm the questions step of a climate survey wizard. */
  save_climate_survey_questions: SaveClimateSurveyQuestionsResponse;
  /** Confirm the questions gate — pick AI or MANUAL. Returns the dimensions to review, then confirm them with save_climate_survey_questions. */
  save_climate_survey_questions_mode: SaveClimateSurveyQuestionsModeResponse;
};


export type ClimateSurveyMutationActivate_Climate_SurveyArgs = {
  input: ActivateClimateSurveyInput;
};


export type ClimateSurveyMutationSave_Climate_Survey_ContextArgs = {
  input: SaveClimateSurveyContextInput;
};


export type ClimateSurveyMutationSave_Climate_Survey_DescriptionArgs = {
  input: SaveClimateSurveyDescriptionInput;
};


export type ClimateSurveyMutationSave_Climate_Survey_ExpectationsArgs = {
  input: SaveClimateSurveyExpectationsInput;
};


export type ClimateSurveyMutationSave_Climate_Survey_NameArgs = {
  input: SaveClimateSurveyNameInput;
};


export type ClimateSurveyMutationSave_Climate_Survey_ParticipantsArgs = {
  input: SaveClimateSurveyParticipantsInput;
};


export type ClimateSurveyMutationSave_Climate_Survey_QuestionsArgs = {
  input: SaveClimateSurveyQuestionsInput;
};


export type ClimateSurveyMutationSave_Climate_Survey_Questions_ModeArgs = {
  input: SaveClimateSurveyQuestionsModeInput;
};

/** Step 1 result — the wizard is open and the AI drafted a description. */
export type ClimateSurveyNameType = {
  __typename?: 'ClimateSurveyNameType';
  /** Description the AI drafted from the name. Editable in step 2. */
  description: Scalars['String']['output'];
  /** Workflow identifier — pass this in all subsequent wizard calls. */
  draft_id: Scalars['ID']['output'];
  /** Confirmed survey name. */
  evaluation_name: Scalars['String']['output'];
};

/** Result after the participants step is confirmed — carries the summary. */
export type ClimateSurveyParticipantsType = {
  __typename?: 'ClimateSurveyParticipantsType';
  /** Workflow identifier — pass this in all subsequent wizard calls. */
  draft_id: Scalars['ID']['output'];
  /** Plain-language description of the eNPS formula, when applicable. */
  formula_explanation?: Maybe<Scalars['String']['output']>;
  /** Full wizard summary to show before activating. */
  summary: Scalars['JSON']['output'];
};

export type ClimateSurveyQuery = {
  __typename?: 'ClimateSurveyQuery';
  /** Returns the static fallback question template for a climate survey type. Use this when AI generation fails or the user chooses the manual template. No LangGraph call is made — the template is hardcoded. */
  climate_survey_fallback_template: Array<ClimateDimensionType>;
};


export type ClimateSurveyQueryClimate_Survey_Fallback_TemplateArgs = {
  input: ClimateSurveyFallbackTemplateInput;
};

/** Result after the questions step of a climate survey wizard is confirmed. */
export type ClimateSurveyQuestionsDraft = {
  __typename?: 'ClimateSurveyQuestionsDraft';
  /** Workflow identifier — pass this in all subsequent wizard calls. */
  draft_id: Scalars['ID']['output'];
};

/** Result after the questions gate is confirmed. Carries the dimensions to review: AI-generated when question_mode was AI, empty when MANUAL. */
export type ClimateSurveyQuestionsModeType = {
  __typename?: 'ClimateSurveyQuestionsModeType';
  /** Dimensions to review. Empty in MANUAL mode. */
  dimensions: Array<ClimateDimensionType>;
  /** Workflow identifier — pass this in all subsequent wizard calls. */
  draft_id: Scalars['ID']['output'];
  /** Confirmed question mode. */
  question_mode: Scalars['String']['output'];
  /** True when AI generation was unavailable and a static template was used. */
  used_fallback: Scalars['Boolean']['output'];
};

export enum ClimateSurveyTypeEnum {
  ClimaGeneral = 'CLIMA_GENERAL',
  Enps = 'ENPS'
}

/** The workflow reported an error instead of advancing. LangGraph returns these as a successful HTTP call with status=error, so they are a normal result, not a transport failure. */
export type ClimateWorkflowError = {
  __typename?: 'ClimateWorkflowError';
  /** Wizard step the workflow was on when it failed. */
  current_step: Scalars['String']['output'];
  /** Request correlation identifier. */
  graphql_operation_id: Scalars['ID']['output'];
  /** User-facing reason the step could not be completed. */
  message: Scalars['String']['output'];
};

export type CollaboratorBenefitsInput = {
  centralized_organization_id: Scalars['ID']['input'];
  country_code?: InputMaybe<Scalars['String']['input']>;
  filter_by?: InputMaybe<BenefitSearchInput>;
  first?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};

export type CollaboratorCarouselListInput = {
  centralized_organization_id: Scalars['ID']['input'];
  country_code?: InputMaybe<Scalars['String']['input']>;
};

export type CollaboratorCatalogCategoryType = {
  __typename?: 'CollaboratorCatalogCategoryType';
  category_type: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image_file?: Maybe<File>;
  image_file_id?: Maybe<Scalars['Int']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  /** Si la categoría es nueva (últimos 30 días) */
  is_new: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** Total de cursos/contenidos en la categoría */
  total_courses: Scalars['Int']['output'];
};

/** Connection del catálogo de cursos del colaborador filtrado por organización. */
export type CollaboratorCatalogCourseConnection = {
  __typename?: 'CollaboratorCatalogCourseConnection';
  /** Contiene los nodos de esta connection */
  edges: Array<CollaboratorCatalogCourseNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

/** Un curso del catálogo del colaborador filtrado por organización. */
export type CollaboratorCatalogCourseNode = {
  __typename?: 'CollaboratorCatalogCourseNode';
  /** Vigencia del certificado de este curso para este colaborador. Es un stub federado: acá sólo viajan los tres ids y el subgrafo de certificados resuelve el resto. No consulta la base. Es null cuando el nodo se arma sin organización; el catálogo de una organización siempre la trae. */
  certificate_validity?: Maybe<CollaboratorCertificateValidity>;
  /** URL al detalle del contenido en KH */
  content_url: Scalars['String']['output'];
  /** Id del curso (columna content_value) */
  course_id: Scalars['Int']['output'];
  /** Descripción del curso */
  description?: Maybe<Scalars['String']['output']>;
  /** Duración del curso */
  duration?: Maybe<Scalars['Int']['output']>;
  /** URL para inscribirse al curso */
  enrollment_url: Scalars['String']['output'];
  /** Id único del nodo */
  id: Scalars['ID']['output'];
  /** URL de la imagen de portada */
  image_url?: Maybe<Scalars['String']['output']>;
  /** Si el usuario que pide el catálogo ya está inscrito */
  is_enrolled: Scalars['Boolean']['output'];
  /** Nombre del profesor */
  professor_name?: Maybe<Scalars['String']['output']>;
  /** Título del curso */
  title: Scalars['String']['output'];
};

/** An edge in a connection. */
export type CollaboratorCatalogCourseNodeEdge = {
  __typename?: 'CollaboratorCatalogCourseNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CollaboratorCatalogCourseNode;
};

/** Input del catálogo de cursos del colaborador filtrado por organización [Query]. */
export type CollaboratorCatalogCoursesInput = {
  /** Cursor de paginación */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cantidad de resultados por página */
  first?: Scalars['Int']['input'];
  /** Orden del catálogo (por ahora el único valor es NEWEST) */
  order_by?: CollaboratorCatalogOrderByEnum;
  /** Organización de la que se pide el catálogo publicado */
  organization_id: Scalars['Int']['input'];
};

export enum CollaboratorCatalogOrderByEnum {
  Newest = 'NEWEST'
}

export type CollaboratorCatalogSettingsInput = {
  centralized_organization_id: Scalars['ID']['input'];
  country_code?: InputMaybe<Scalars['String']['input']>;
};

export type CollaboratorCategoriesListInput = {
  centralized_organization_id: Scalars['ID']['input'];
  country_code?: InputMaybe<Scalars['String']['input']>;
};

export enum CollaboratorCategoryOrderByEnum {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export type CollaboratorCertificateValidity = {
  __typename?: 'CollaboratorCertificateValidity';
  course_id: Scalars['Int']['output'];
  /** Days until expires_at, negative once past, null when there is no expiry. Computed at read time, so it is always current -- prefer it over status whenever the two disagree. */
  days_to_expire?: Maybe<Scalars['Int']['output']>;
  /** Expiry of the current certificate version, fixed when it was issued. Null means this certificate never expires. A later change to the course policy does not move it. */
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  organization_id: Scalars['Int']['output'];
  /** Stored state, written by the daily expiration job. It is a snapshot, not a live computation, so it can lag reality: the job skips a row whose course has no policy or is draft or inactive, and such a row keeps its last state indefinitely. When this disagrees with days_to_expire, days_to_expire wins. */
  status?: Maybe<CertificateValidityStatus>;
  user_id: Scalars['Int']['output'];
};

export type CollaboratorContentByCategoryNode = {
  __typename?: 'CollaboratorContentByCategoryNode';
  base_category: CatalogCategoryTypeCollaboratorCatalogCategoryType;
  contents: CollaboratorContentConnection;
  sub_categories: Array<CollaboratorCatalogCategoryType>;
};

export type CollaboratorContentConnection = {
  __typename?: 'CollaboratorContentConnection';
  edges: Array<CollaboratorContentNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type CollaboratorContentNode = {
  __typename?: 'CollaboratorContentNode';
  content_type: Scalars['String']['output'];
  course?: Maybe<KnowledgeHubCourseNode>;
  document?: Maybe<KnowledgeHubDocumentNode>;
  id: Scalars['ID']['output'];
  is_crehana_content?: Maybe<Scalars['Boolean']['output']>;
  /** content_value */
  original_id: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  track?: Maybe<KnowledgeHubOrganizationTeamNode>;
  visibility_level?: Maybe<VisibilityLevelType>;
};

/** An edge in a connection. */
export type CollaboratorContentNodeEdge = {
  __typename?: 'CollaboratorContentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CollaboratorContentNode;
};

export type CollaboratorCoreCountryListInput = {
  centralized_organization_id: Scalars['ID']['input'];
  country_code?: InputMaybe<Scalars['String']['input']>;
  filter_by?: InputMaybe<CollaboratorCountrySearchInput>;
  first?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};

export type CollaboratorCountrySearchInput = {
  country?: InputMaybe<CountryCodeEnum>;
};

export type CollaboratorFilterCategoryNode = {
  __typename?: 'CollaboratorFilterCategoryNode';
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  /** Subcategorías hijas */
  sub_categories: Array<CollaboratorFilterCategoryNode>;
  title: Scalars['String']['output'];
  /** Total de contenidos visibles en la categoría */
  total_courses: Scalars['Int']['output'];
};

export type CollaboratorFiltersNode = {
  __typename?: 'CollaboratorFiltersNode';
  /** Hijos directos de la categoría principal (árbol visible). */
  category: Array<CollaboratorFilterCategoryNode>;
  /** Tipos de contenido presentes en el contenido visible. */
  content_types: Array<ContentTypeNode>;
  /** Idiomas presentes en el contenido visible. */
  languages: Array<LanguageNode>;
  /** Niveles presentes en el contenido visible de la categoría. */
  levels: Array<Level>;
};

export type CollaboratorGetCatalogInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtro de categorías a incluir: own, crehana, third_party. Si es None, retorna todas. */
  owner_type?: InputMaybe<Array<CollaboratorOwnerTypeEnum>>;
  /** Cantidad de contenidos de preview por categoría (default: 10, max: 20) */
  preview_limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CollaboratorGetCategoriesInput = {
  /** Límite de categorías (default interno, ej. 50; max 100) */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Orden: NAME_ASC, NAME_DESC */
  order_by?: InputMaybe<CollaboratorCategoryOrderByEnum>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Origen de categorías: OWN, CREHANA o THIRD_PARTY */
  owner_type: CollaboratorOwnerTypeEnum;
};

export type CollaboratorGetContentByCategoryInput = {
  /** Cursor después del cual paginar (contents). */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor antes del cual paginar (contents). */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Filtro por tipo de contenido (curso, track, documento). */
  content_type?: InputMaybe<Scalars['String']['input']>;
  /** Primeros n ítems en contents (paginación). */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Incluir categorías ocultas al buscar por parent_slug. */
  include_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtro por idiomas (ej. LANGUAGE_ES, es). */
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Últimos n ítems en contents (paginación). */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Filtro por nivel de curso. */
  level_id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Slug de la categoría base; si se omite, trae los 3 nodos raíz (own, crehana, third_party). Exclusivo con search_input. */
  parent_slug?: InputMaybe<Scalars['String']['input']>;
  /** Texto de búsqueda por título en el catálogo colaborador. Exclusivo con parent_slug. */
  search_input?: InputMaybe<Scalars['String']['input']>;
};

export type CollaboratorGetFiltersInput = {
  /** Slug de la categoría raíz desde la que se calculan los filtros. */
  main_category_slug: Scalars['String']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export enum CollaboratorOwnerTypeEnum {
  Crehana = 'CREHANA',
  Own = 'OWN',
  ThirdParty = 'THIRD_PARTY'
}

export type CollaboratorQuery = {
  __typename?: 'CollaboratorQuery';
  dip_data_sheet?: Maybe<ExcelResponse>;
  dip_learning_activities_by_employee_detail?: Maybe<DipEmployeeLeaningInfoResponse>;
  dip_pdf_report?: Maybe<PdfReportResponse>;
  pid_activities_employee?: Maybe<DipEmployeeActivityListResponse>;
  pid_activity_employee_detail?: Maybe<DipActivityEmployeeDetailResponse>;
  pid_configuration?: Maybe<PidConfigurationResponse>;
  pid_process_detail?: Maybe<DipProcessDetailResponse>;
  pid_process_list?: Maybe<DipProcessListResponse>;
};


export type CollaboratorQueryDip_Data_SheetArgs = {
  input: DataSheetInput;
};


export type CollaboratorQueryDip_Learning_Activities_By_Employee_DetailArgs = {
  input: PidProcessDetailInput;
};


export type CollaboratorQueryDip_Pdf_ReportArgs = {
  input: DataSheetInput;
};


export type CollaboratorQueryPid_Activities_EmployeeArgs = {
  filter?: InputMaybe<PidEmployeeActivityFilter>;
  input: PidProcessDetailInput;
};


export type CollaboratorQueryPid_Activity_Employee_DetailArgs = {
  input: PidActivityEmployeeInput;
};


export type CollaboratorQueryPid_ConfigurationArgs = {
  input: PidConfigurationInput;
};


export type CollaboratorQueryPid_Process_DetailArgs = {
  input: PidProcessDetailInput;
};


export type CollaboratorQueryPid_Process_ListArgs = {
  input: PidProcessListInput;
};

export enum CollaboratorSortField {
  Department = 'DEPARTMENT',
  LeaderName = 'LEADER_NAME',
  Name = 'NAME',
  Position = 'POSITION'
}

export enum CollaboratorTrackingStatus {
  Completed = 'COMPLETED',
  Partial = 'PARTIAL',
  Pending = 'PENDING'
}

/** Completion status of one evaluation x relation combination for a collaborator. combination_key is '{evaluation_id}:{relation}'. */
export type CombinationStatusType = {
  __typename?: 'CombinationStatusType';
  combination_key: Scalars['String']['output'];
  status: CompetencesCollaboratorStatus;
};

export type CommentForm = {
  __typename?: 'CommentForm';
  comment?: Maybe<Scalars['String']['output']>;
  comment_auto?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  original_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
};

export enum CompanyEmployeeFieldsEnum {
  EmployeeDocument = 'EMPLOYEE_DOCUMENT',
  EmployeeEmail = 'EMPLOYEE_EMAIL',
  EmployeeLastName = 'EMPLOYEE_LAST_NAME',
  EmployeeName = 'EMPLOYEE_NAME'
}

export enum CompanyEmployeeSortOrderEnum {
  EmployeeName = 'EMPLOYEE_NAME'
}

export enum CompanyMailTemplateFieldsEnum {
  MailTemplateCode = 'MAIL_TEMPLATE_CODE',
  MailTemplateSubject = 'MAIL_TEMPLATE_SUBJECT'
}

export enum CompanyMailTemplateSortOrderEnum {
  MailTemplateCode = 'MAIL_TEMPLATE_CODE',
  MailTemplateSubject = 'MAIL_TEMPLATE_SUBJECT'
}

export type CompanyTalentType = {
  __typename?: 'CompanyTalentType';
  domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<LanguageEnum>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ComparativePeriods = {
  __typename?: 'ComparativePeriods';
  current_period: OrganizationReproduction;
  previous_period: OrganizationReproduction;
  variation: Scalars['Int']['output'];
};

export type CompassMapsAddressStructureValidationErrorResponse = {
  __typename?: 'CompassMapsAddressStructureValidationErrorResponse';
  code: Scalars['String']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  missing_fields: Array<Scalars['String']['output']>;
};

export type CompassMapsGeocodeAddressInput = {
  address: Scalars['String']['input'];
  language_code?: Scalars['String']['input'];
};

export type CompassMapsGeocodeAddressPayload = {
  __typename?: 'CompassMapsGeocodeAddressPayload';
  location: CompassMapsLocationValue;
  missing_fields?: Maybe<Array<Scalars['String']['output']>>;
};

export type CompassMapsGeocodeAddressResult = CompassMapsAddressStructureValidationErrorResponse | CompassMapsGeocodeAddressPayload | ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

export type CompassMapsGeocodeByPlaceIdInput = {
  language_code?: Scalars['String']['input'];
  place_id: Scalars['String']['input'];
};

export type CompassMapsGeocodeByPlaceIdPayload = {
  __typename?: 'CompassMapsGeocodeByPlaceIdPayload';
  location: CompassMapsLocationValue;
  missing_fields?: Maybe<Array<Scalars['String']['output']>>;
};

export type CompassMapsGeocodeByPlaceIdResult = CompassMapsAddressStructureValidationErrorResponse | CompassMapsGeocodeByPlaceIdPayload | ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type CompassMapsLocationMetadata = {
  __typename?: 'CompassMapsLocationMetadata';
  address_components?: Maybe<Scalars['JSON']['output']>;
  coordinates?: Maybe<Scalars['JSON']['output']>;
  google_raw_response?: Maybe<Scalars['JSON']['output']>;
  latam_fiscal_payload?: Maybe<Scalars['JSON']['output']>;
  location_type?: Maybe<Scalars['String']['output']>;
  place_types?: Maybe<Array<Scalars['String']['output']>>;
  plus_code?: Maybe<CompassMapsPlusCode>;
  service_source?: Maybe<Scalars['String']['output']>;
  structured_address?: Maybe<Scalars['JSON']['output']>;
};

export type CompassMapsLocationSuggestion = {
  __typename?: 'CompassMapsLocationSuggestion';
  formatted_address: Scalars['String']['output'];
  main_text?: Maybe<Scalars['String']['output']>;
  place_id?: Maybe<Scalars['String']['output']>;
  secondary_text?: Maybe<Scalars['String']['output']>;
};

export type CompassMapsLocationValue = {
  __typename?: 'CompassMapsLocationValue';
  formatted_address: Scalars['String']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  metadata?: Maybe<CompassMapsLocationMetadata>;
  place_id?: Maybe<Scalars['String']['output']>;
};

export type CompassMapsPlusCode = {
  __typename?: 'CompassMapsPlusCode';
  compound_code?: Maybe<Scalars['String']['output']>;
  global_code?: Maybe<Scalars['String']['output']>;
};

export type CompassMapsReverseGeocodeInput = {
  language_code?: Scalars['String']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type CompassMapsReverseGeocodePayload = {
  __typename?: 'CompassMapsReverseGeocodePayload';
  location: CompassMapsLocationValue;
  missing_fields?: Maybe<Array<Scalars['String']['output']>>;
};

export type CompassMapsReverseGeocodeResult = CompassMapsAddressStructureValidationErrorResponse | CompassMapsReverseGeocodePayload | ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

export type CompassMapsSearchLocationsInput = {
  included_region_codes?: InputMaybe<Array<Scalars['String']['input']>>;
  language_code?: Scalars['String']['input'];
  max_results_addresses?: Scalars['Int']['input'];
  max_results_regions?: Scalars['Int']['input'];
  query: Scalars['String']['input'];
};

export type CompassMapsSearchLocationsPayload = {
  __typename?: 'CompassMapsSearchLocationsPayload';
  items: Array<CompassMapsLocationSuggestion>;
};

export type CompassMapsSearchLocationsResult = CompassMapsAddressStructureValidationErrorResponse | CompassMapsSearchLocationsPayload | ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

export type Competence = {
  __typename?: 'Competence';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  original_id?: Maybe<Scalars['Int']['output']>;
  questions?: Maybe<Array<Maybe<Question>>>;
  result?: Maybe<Scalars['String']['output']>;
};

export type CompetenceCollaboratorStatus = {
  __typename?: 'CompetenceCollaboratorStatus';
  created?: Maybe<Scalars['Int']['output']>;
  finished?: Maybe<Scalars['Int']['output']>;
  in_progress?: Maybe<Scalars['Int']['output']>;
};

export type CompetenceCollaboratorTeam = {
  __typename?: 'CompetenceCollaboratorTeam';
  employee?: Maybe<CompetencesEmployeeTalentType>;
  status?: Maybe<CompetenceCollaboratorStatus>;
};

export type CompetenceCollaboratorTeamEdge = {
  __typename?: 'CompetenceCollaboratorTeamEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CompetenceCollaboratorTeam>;
};

export type CompetenceForm = {
  __typename?: 'CompetenceForm';
  behaviors?: Maybe<Array<Maybe<BehaviorForm>>>;
  comments?: Maybe<Array<Maybe<CommentForm>>>;
  completed_competence?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  original_id?: Maybe<Scalars['Int']['output']>;
};

export type CompetenceFormEdge = {
  __typename?: 'CompetenceFormEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CompetenceForm>;
};

export type CompetenceFormPagination = {
  __typename?: 'CompetenceFormPagination';
  edges?: Maybe<Array<Maybe<CompetenceFormEdge>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type CompetenceGeneralForm = {
  __typename?: 'CompetenceGeneralForm';
  competences?: Maybe<CompetenceFormPagination>;
  evaluation?: Maybe<CompetencesEvaluation>;
  general_comments1?: Maybe<Array<Maybe<CommentForm>>>;
  general_comments2?: Maybe<Array<Maybe<CommentForm>>>;
  general_comments3?: Maybe<Array<Maybe<CommentForm>>>;
  questionnaires?: Maybe<Array<Maybe<Questionnaire>>>;
};

/** Dimension used to group the competence progress. */
export enum CompetenceGroupByDimension {
  Department = 'DEPARTMENT',
  Job = 'JOB',
  Level = 'LEVEL'
}

export enum CompetenceLanguageCodeEnum {
  En = 'EN',
  Es = 'ES',
  Pt = 'PT'
}

export type CompetenceMyTeamGeneral = {
  __typename?: 'CompetenceMyTeamGeneral';
  collaborators?: Maybe<CompetenceMyTeamPagination>;
};

export type CompetenceMyTeamPagination = {
  __typename?: 'CompetenceMyTeamPagination';
  edges?: Maybe<Array<Maybe<CompetenceCollaboratorTeamEdge>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type CompetenceMyTeamStat = {
  __typename?: 'CompetenceMyTeamStat';
  finished?: Maybe<CompetenceMyTeamStateStat>;
  general_progress: Scalars['Float']['output'];
  pending?: Maybe<CompetenceMyTeamStateStat>;
};

export type CompetenceMyTeamStateStat = {
  __typename?: 'CompetenceMyTeamStateStat';
  done: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  total: Scalars['Int']['output'];
};

export enum CompetenceNotificationTypeEnum {
  CompetencesInvitation = 'COMPETENCES_INVITATION',
  CompetencesReminder = 'COMPETENCES_REMINDER'
}

/** Deprecated */
export type CompetenceProcessResultDto = {
  __typename?: 'CompetenceProcessResultDto';
  percentage?: Maybe<Scalars['Float']['output']>;
  processId?: Maybe<Scalars['String']['output']>;
  processName?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['Float']['output']>;
};

/** QUERIES */
export type CompetenceQueries = {
  __typename?: 'CompetenceQueries';
  get_competences_employee_result_detail?: Maybe<TalentCompetencesEmployeeResultResponse>;
  /** Deprecated */
  get_competences_results_by_employee?: Maybe<CompetencesEmployeeDto>;
  get_competences_total_result_by_process?: Maybe<TalentCompetencesTotalResultResponse>;
  list_competences?: Maybe<TalentListCompetencesResponse>;
  list_competences_behavior_results?: Maybe<TalentListCompetencesBehaviorResultsResponse>;
  list_competences_division_result_by_process?: Maybe<TalentListCompetencesDivisionResultResponse>;
  list_competences_employee_result_by_process?: Maybe<TalentListCompetencesEmployeeResultResponse>;
  list_competences_employee_results?: Maybe<TalentListCompetencesEmployeeResultsResponse>;
  list_competences_employee_results_by_competence?: Maybe<TalentListCompetencesEmployeeResultsByCompetenceResponse>;
  list_competences_general_comments?: Maybe<TalentReportsListCompetencesGeneralCommentsResponse>;
  list_competences_result_by_process?: Maybe<TalentListCompetencesResultResponse>;
  list_competences_result_grouped_by_filter?: Maybe<TalentListCompetencesGroupedResultResponse>;
};


/** QUERIES */
export type CompetenceQueriesGet_Competences_Employee_Result_DetailArgs = {
  input: TalentCompetencesEmployeeResultDetailInput;
};


/** QUERIES */
export type CompetenceQueriesGet_Competences_Results_By_EmployeeArgs = {
  employee_id: Scalars['Int']['input'];
  process_id: Scalars['String']['input'];
};


/** QUERIES */
export type CompetenceQueriesGet_Competences_Total_Result_By_ProcessArgs = {
  input: TalentReportInput;
};


/** QUERIES */
export type CompetenceQueriesList_CompetencesArgs = {
  input: TalentReportsListCompetencesInput;
};


/** QUERIES */
export type CompetenceQueriesList_Competences_Behavior_ResultsArgs = {
  input: TalentListCompetencesBehaviorResultsInput;
};


/** QUERIES */
export type CompetenceQueriesList_Competences_Division_Result_By_ProcessArgs = {
  input: TalentReportInput;
};


/** QUERIES */
export type CompetenceQueriesList_Competences_Employee_Result_By_ProcessArgs = {
  input: TalentReportInput;
};


/** QUERIES */
export type CompetenceQueriesList_Competences_Employee_ResultsArgs = {
  input: TalentListCompetencesEmployeeResultsInput;
};


/** QUERIES */
export type CompetenceQueriesList_Competences_Employee_Results_By_CompetenceArgs = {
  input: TalentListCompetencesEmployeeResultsByCompetenceInput;
};


/** QUERIES */
export type CompetenceQueriesList_Competences_General_CommentsArgs = {
  input: TalentReportsListCompetencesGeneralCommentsInput;
};


/** QUERIES */
export type CompetenceQueriesList_Competences_Result_By_ProcessArgs = {
  input: TalentReportInput;
};


/** QUERIES */
export type CompetenceQueriesList_Competences_Result_Grouped_By_FilterArgs = {
  input: TalentReportInput;
};

export type CompetenceReport = {
  __typename?: 'CompetenceReport';
  url: Scalars['String']['output'];
};

export enum CompetenceResultTypeEnum {
  TypeAverageCompetenceRelationWeight = 'TYPE_AVERAGE_COMPETENCE_RELATION_WEIGHT',
  TypeBehaviorAndRelationWeight = 'TYPE_BEHAVIOR_AND_RELATION_WEIGHT',
  TypeBehaviorWeight = 'TYPE_BEHAVIOR_WEIGHT',
  TypeCompetenceWeight = 'TYPE_COMPETENCE_WEIGHT',
  TypeRelationWeight = 'TYPE_RELATION_WEIGHT',
  TypeRelationWeightQuestionnairesUnanswered = 'TYPE_RELATION_WEIGHT_QUESTIONNAIRES_UNANSWERED',
  TypeSimpleAverage = 'TYPE_SIMPLE_AVERAGE'
}

export type CompetenceSummary = {
  __typename?: 'CompetenceSummary';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  original_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_summary_competences?: Maybe<Array<Maybe<QuestionnaireSummary>>>;
};

export type CompetenceWithoutBehaviorsErrorV2 = {
  __typename?: 'CompetenceWithoutBehaviorsErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

/** Per-combination completion status of a collaborator. COMPLETED means every evaluator of that relation finished; otherwise PENDING. */
export enum CompetencesCollaboratorStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

/** Server-side completion filter for ONE evaluation x relation combination of the collaborators table (one relation column). It is a sibling field of `relations` instead of a field inside it so that `relations` keeps using EvaluationRelationInput: that input is shared with three other queries, and changing its usage would be flagged by the Apollo operation check as a breaking change for existing client traffic. */
export type CompetencesCollaboratorStatusFilterInput = {
  /** Competence evaluation id of the filtered combination. Must match one of the combinations listed in `relations`. */
  evaluation_id: Scalars['Int']['input'];
  /** Relation bucket of the filtered combination: AUTO, BOSS or OTHER_RELATIONS. Must match one of the combinations in `relations`. */
  relation_id: RelationFilter;
  /** Keep only collaborators whose status for THIS combination is COMPLETED or PENDING. Applied against the full result set, so total_count/total_pages reflect the subset. PENDING also covers collaborators with no assignment in this combination, mirroring the status returned in `states`. */
  status: CompetencesCollaboratorStatus;
};

/** One collaborator row of the competence detail table, with the completion status of each requested evaluation x relation combination. */
export type CompetencesCollaboratorType = {
  __typename?: 'CompetencesCollaboratorType';
  department: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  leader: Scalars['String']['output'];
  name: Scalars['String']['output'];
  states: Array<CombinationStatusType>;
};

/** Filters for the per-collaborator competence detail table. Returns, per collaborator, the completion status of each requested evaluation x relation combination. When `status_filters` carries more than one entry, the filters combine with AND (a collaborator must match every filtered column to appear). */
export type CompetencesCollaboratorsInput = {
  /** Talent company id. */
  company_id: Scalars['Int']['input'];
  /** Month (1-12) for the cumulative cut. */
  month: Scalars['Int']['input'];
  /** Page number (1-based). */
  page?: Scalars['Int']['input'];
  /** Number of collaborators per page. */
  page_size?: Scalars['Int']['input'];
  /** Evaluation x relation combinations to report (up to 3). */
  relations: Array<EvaluationRelationInput>;
  /** Optional case-insensitive filter on collaborator name or email. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Optional per-column completion filters. Each entry must reference a combination present in `relations`, and a combination can be filtered at most once. Several entries combine with AND. */
  status_filters?: InputMaybe<Array<CompetencesCollaboratorStatusFilterInput>>;
  /** Year for the cumulative cut. */
  year: Scalars['Int']['input'];
};

/** Paginated per-collaborator competence detail table. */
export type CompetencesCollaboratorsPageType = {
  __typename?: 'CompetencesCollaboratorsPageType';
  current_page: Scalars['Int']['output'];
  items: Array<CompetencesCollaboratorType>;
  total_count: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type CompetencesDetail = {
  __typename?: 'CompetencesDetail';
  competences?: Maybe<Array<Maybe<Competence>>>;
  employee_result?: Maybe<Scalars['String']['output']>;
  general_comment1?: Maybe<Scalars['String']['output']>;
  general_comment2?: Maybe<Scalars['String']['output']>;
  general_comment3?: Maybe<Scalars['String']['output']>;
};

export type CompetencesEmailTemplateInput = {
  code: CompetencesTemplate;
  company_id: Scalars['Int']['input'];
  employee_id: Scalars['Int']['input'];
  language: Scalars['String']['input'];
  process_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CompetencesEmailTemplateResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | SuccessCore;

/** Deprecated */
export type CompetencesEmployeeDto = {
  __typename?: 'CompetencesEmployeeDTO';
  employeeLabelResult?: Maybe<Scalars['String']['output']>;
  evaluatedId?: Maybe<Scalars['Int']['output']>;
  evaluationType?: Maybe<Scalars['String']['output']>;
  processId?: Maybe<Scalars['String']['output']>;
  scaleResult?: Maybe<Scalars['Float']['output']>;
  weightedResult?: Maybe<Scalars['Float']['output']>;
};

export type CompetencesEmployeeTalentEdge = {
  __typename?: 'CompetencesEmployeeTalentEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CompetencesEmployeeTalentType>;
};

export type CompetencesEmployeeTalentEdgePagination = {
  __typename?: 'CompetencesEmployeeTalentEdgePagination';
  edges?: Maybe<Array<Maybe<CompetencesEmployeeTalentEdge>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type CompetencesEmployeeTalentPagination = {
  __typename?: 'CompetencesEmployeeTalentPagination';
  employees?: Maybe<CompetencesEmployeeTalentEdgePagination>;
};

export type CompetencesEmployeeTalentType = {
  __typename?: 'CompetencesEmployeeTalentType';
  avatar?: Maybe<AvatarTalentType>;
  division?: Maybe<DivisionTalentType>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  job?: Maybe<JobTalentType>;
  original_id?: Maybe<Scalars['Int']['output']>;
};

export type CompetencesEvaluation = {
  __typename?: 'CompetencesEvaluation';
  date_final: Scalars['String']['output'];
  date_initial: Scalars['String']['output'];
  date_time_zone?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  employees?: Maybe<Array<Maybe<EmployeeCompetencesEvaluation>>>;
  evaluation_state_2: EvaluationStateEnum;
  finished_questionnaires?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  original_id: Scalars['Int']['output'];
  percentage_response?: Maybe<Scalars['String']['output']>;
  total_questionnaires?: Maybe<Scalars['Int']['output']>;
};

export type CompetencesEvaluationConfiguration = {
  __typename?: 'CompetencesEvaluationConfiguration';
  assign_competences_by_leader: Scalars['Boolean']['output'];
  disable_mass_qualification: Scalars['Boolean']['output'];
  enable_result_evaluate: Scalars['Boolean']['output'];
  has_active_behaviors_model: Scalars['Boolean']['output'];
  has_description_competence_active: Scalars['Boolean']['output'];
  hide_add_evaluators_leader: Scalars['Boolean']['output'];
  hide_competences_brief?: Maybe<Scalars['Boolean']['output']>;
  is_by_box: Scalars['Boolean']['output'];
  label_comment?: Maybe<Scalars['String']['output']>;
  label_comment2?: Maybe<Scalars['String']['output']>;
  label_comment3?: Maybe<Scalars['String']['output']>;
  min_comment_length: Scalars['Int']['output'];
  options_explanations?: Maybe<Scalars['String']['output']>;
  options_response?: Maybe<Array<Maybe<OptionResponse>>>;
  relations?: Maybe<Array<Maybe<RelationLabelType>>>;
  required_comment_behavior: Scalars['Boolean']['output'];
  required_comment_competence: Scalars['Boolean']['output'];
  required_comment_general: Scalars['Boolean']['output'];
  required_comment_general2: Scalars['Boolean']['output'];
  required_comment_general3: Scalars['Boolean']['output'];
  show_all_relations: Scalars['Boolean']['output'];
  show_autoevaluations_employees: Scalars['Boolean']['output'];
  show_comment_behavior: Scalars['Boolean']['output'];
  show_comment_competence: Scalars['Boolean']['output'];
  show_comment_general: Scalars['Boolean']['output'];
  show_comment_general2: Scalars['Boolean']['output'];
  show_comment_general3: Scalars['Boolean']['output'];
  show_competences_brief: Scalars['Boolean']['output'];
  show_dont_know: Scalars['Boolean']['output'];
  show_edit_evaluation: Scalars['Boolean']['output'];
  show_evaluators_icon: Scalars['Boolean']['output'];
  show_evaluators_table: Scalars['Boolean']['output'];
  show_my_team_tab: Scalars['Boolean']['output'];
  valid_zero_option?: Maybe<Scalars['Boolean']['output']>;
};

export type CompetencesEvaluationEdge = {
  __typename?: 'CompetencesEvaluationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CompetencesEvaluation>;
};

export type CompetencesEvaluationPagination = {
  __typename?: 'CompetencesEvaluationPagination';
  edges?: Maybe<Array<Maybe<CompetencesEvaluationEdge>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export enum CompetencesEvaluationStateMapEnum {
  ActiveStatus = 'ACTIVE_STATUS',
  DeletedStatus = 'DELETED_STATUS',
  InactiveStatus = 'INACTIVE_STATUS'
}

export type CompetencesGeneralEvaluationPagination = {
  __typename?: 'CompetencesGeneralEvaluationPagination';
  evaluations?: Maybe<CompetencesEvaluationPagination>;
};

export type CompetencesGeneralStatisticsInput = {
  fields: Array<EvaluationFieldsEnum>;
  query: Scalars['String']['input'];
};

export type CompetencesLabel = {
  __typename?: 'CompetencesLabel';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  original_id?: Maybe<Scalars['Int']['output']>;
};

export type CompetencesLabelSummary = {
  __typename?: 'CompetencesLabelSummary';
  competences_label_summary?: Maybe<Array<Maybe<CompetencesLabel>>>;
};

export enum CompetencesModelFieldsEnum {
  ModelName = 'MODEL_NAME'
}

/** Filters for the month-by-month competence progress query across a process date range (full-process evolution chart). */
export type CompetencesMonthlyProgressInput = {
  /** Talent company id. */
  company_id: Scalars['Int']['input'];
  /** Last month of the range, inclusive, in 'YYYY-MM'. */
  end_month: Scalars['String']['input'];
  /** Evaluation x relation combinations to plot (up to 3). */
  relations: Array<EvaluationRelationInput>;
  /** First month of the range, inclusive, in 'YYYY-MM'. */
  start_month: Scalars['String']['input'];
};

export type CompetencesResponseInternalError = {
  __typename?: 'CompetencesResponseInternalError';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CompetencesResponseValidationError = {
  __typename?: 'CompetencesResponseValidationError';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

/** Deprecated */
export type CompetencesResultDto = {
  __typename?: 'CompetencesResultDto';
  competenceName?: Maybe<Scalars['String']['output']>;
  competenceResult?: Maybe<Scalars['Float']['output']>;
};

export enum CompetencesResultFormatEnum {
  CompetencesResultFormatPercentage = 'COMPETENCES_RESULT_FORMAT_PERCENTAGE',
  CompetencesResultFormatScale = 'COMPETENCES_RESULT_FORMAT_SCALE'
}

export type CompetencesResultReport = {
  __typename?: 'CompetencesResultReport';
  /** Email of the collaborator's direct manager. */
  boss_email?: Maybe<Scalars['String']['output']>;
  /** **Centralized** collaborator id — the one the `centralized_users_ids` filter takes. Not the learning `user_id`. */
  centralized_user_id?: Maybe<Scalars['Int']['output']>;
  /** Level reached, resolved by Talent from the process semaphore configuration (`Cumple`, `Sobrepasa`…). Free text per organization: do not compare it across customers. */
  configured_label?: Maybe<Scalars['String']['output']>;
  /** Overall result as a **percentage** (normally 0–100), with the process scale configuration applied — the value Talent displays. Sent raw: a small share of rows exceeds 100 because of atypical scale configurations, so do not validate against a hard 100 and clamp to [0, 100] before averaging. Null when the collaborator has no result yet. */
  configured_percentage_result?: Maybe<Scalars['Float']['output']>;
  /** Overall result in the **process scale** (see `max_scale`), with the process result configuration applied. */
  configured_scale_result?: Maybe<Scalars['Float']['output']>;
  /** Level colour, hex without `#` (e.g. `80E0B4`). */
  configured_semaphore_color?: Maybe<Scalars['String']['output']>;
  /** Collaborator id in Talent (`evaluated_id`). */
  employee_id?: Maybe<Scalars['Int']['output']>;
  /** Competences evaluation id in Talent — the number the admin sees and the one the `evaluation_ids` filter takes. Derived from `process_id`; null when the process does not follow the `4M<id>P` encoding. */
  evaluation_id?: Maybe<Scalars['Int']['output']>;
  /** How the process weighted the relations (`COMPETENCE_WEIGHT`, `RELATION_WEIGHT`…), as emitted by Talent. */
  evaluation_type?: Maybe<Scalars['String']['output']>;
  /** Top of the process scale (5 for a 1–5 scale, 100 for a 1–100 one). It is the unit of `configured_scale_result`. */
  max_scale?: Maybe<Scalars['Float']['output']>;
  /** Process end date as configured in Talent. */
  process_end_date?: Maybe<Scalars['Date']['output']>;
  /** Process id as stored by Talent (`4M<id>P`). */
  process_id?: Maybe<Scalars['String']['output']>;
  /** Process name as configured in Talent. */
  process_name?: Maybe<Scalars['String']['output']>;
  /** Process status as emitted by Talent (`FINISHED`…), untranslated. */
  process_status?: Maybe<Scalars['String']['output']>;
  /** Timestamp of the last update of the result at the source (Talent pipeline). The time zone is not normalized by this service. */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Collaborator area. */
  user_area?: Maybe<Scalars['String']['output']>;
  /** Collaborator department. */
  user_department?: Maybe<Scalars['String']['output']>;
  /** Collaborator identity document. */
  user_document?: Maybe<Scalars['String']['output']>;
  /** Collaborator corporate email. */
  user_email?: Maybe<Scalars['String']['output']>;
  /** Collaborator headquarter (site). */
  user_headquarter?: Maybe<Scalars['String']['output']>;
  /** Collaborator job level. */
  user_level?: Maybe<Scalars['String']['output']>;
  /** Collaborator full name (first and last name). */
  user_name?: Maybe<Scalars['String']['output']>;
  /** Collaborator job title. */
  user_position?: Maybe<Scalars['String']['output']>;
  /** Collaborator status in the organization (`active`, `inactive`…). Inactive collaborators are included: they may hold results the integration needs. */
  user_status?: Maybe<Scalars['String']['output']>;
};

export type CompetencesResultReportConnection = {
  __typename?: 'CompetencesResultReportConnection';
  /** A list of edges in this connection. */
  edges: Array<CompetencesResultReportEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type CompetencesResultReportConnectionQueryValidationErrorQueryInternalError = CompetencesResultReportConnection | QueryInternalError | QueryValidationError;

export type CompetencesResultReportEdge = {
  __typename?: 'CompetencesResultReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CompetencesResultReport;
};

export enum CompetencesTemplate {
  ReminderNotificationCompleteActivities = 'REMINDER_NOTIFICATION_COMPLETE_ACTIVITIES'
}

export type CompleteTaskUserResponse = {
  __typename?: 'CompleteTaskUserResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CompleteUserNewsInput = {
  centralized_organization_id: Scalars['Int']['input'];
  user_news_id: Scalars['Int']['input'];
};

export type CompleteUserReadingDocumentInput = {
  centralized_organization_id: Scalars['Int']['input'];
  user_document_id: Scalars['Int']['input'];
};

export type CompletedItems = {
  __typename?: 'CompletedItems';
  completed_items: Scalars['Int']['output'];
  total_items: Scalars['Int']['output'];
};

export type CompletedTrackNode = {
  __typename?: 'CompletedTrackNode';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** A single item in the activity composition chart. */
export type CompositionItem = {
  __typename?: 'CompositionItem';
  /**
   * Deprecated — use delta_value sign instead. Direction of the delta trend.
   * @deprecated Use delta_value sign to determine direction. Positive = up, negative = down, zero = neutral.
   */
  delta_direction: Direction;
  /** Formatted percentage change vs previous month (e.g. '12.3%', '-2.4%'). */
  delta_percentage: Scalars['String']['output'];
  /** Raw numeric delta vs previous month (e.g. 12.3, -2.4). Positive = up, negative = down. */
  delta_value?: Maybe<Scalars['Float']['output']>;
  /** Icon name for the item (e.g. 'MessageCircle', 'GraduationCap', 'Award'). */
  icon: Scalars['String']['output'];
  /** Unique identifier (e.g. 'comms_interactions', 'courses_completed'). */
  key: Scalars['String']['output'];
  /** Display label (e.g. 'Interacciones en Comunicaciones'). */
  label: Scalars['String']['output'];
  /** Semantic color token for the item. Values: 'success', 'warning', 'danger', 'info', 'brand', 'pending', 'lime'. Null triggers frontend fallback by key. */
  semantic_color?: Maybe<Scalars['String']['output']>;
  /** Secondary label with module context (e.g. 'Reacciones + comentarios · Comms'). */
  sublabel: Scalars['String']['output'];
  /** Absolute count for this metric. */
  value: Scalars['Int']['output'];
};

export type ComputeTotalCertifiesToDownloadNode = {
  __typename?: 'ComputeTotalCertifiesToDownloadNode';
  total: Scalars['Int']['output'];
};

export type ConceptAssignmentMutation = {
  __typename?: 'ConceptAssignmentMutation';
  /** Define el paquete de conceptos de un tipo de nomina — que conceptos entran en cada tipo de corrida. Requiere `PlatformAdmin`: es configuracion de implementacion, no del cliente. La lista es el estado deseado completo y los conceptos que no vienen se desasignan. */
  set_concept_assignments: PayrollConceptAssignmentsResult;
};


export type ConceptAssignmentMutationSet_Concept_AssignmentsArgs = {
  input: PayrollSetConceptAssignmentsInput;
};

export type ConceptAssignmentQuery = {
  __typename?: 'ConceptAssignmentQuery';
  /** El paquete de conceptos de un tipo de nomina: que conceptos entran en ese tipo de corrida y como se activan. */
  list_concept_assignments: PayrollConceptAssignmentsResult;
  /** Vista cruzada: que tipos de nomina consumen un concepto. Es lo que deja ver el impacto de tocar un concepto antes de tocarlo. */
  list_payroll_types_for_concept: PayrollConceptAssignmentsResult;
};


export type ConceptAssignmentQueryList_Concept_AssignmentsArgs = {
  input: PayrollListConceptAssignmentsInput;
};


export type ConceptAssignmentQueryList_Payroll_Types_For_ConceptArgs = {
  input: PayrollListPayrollTypesForConceptInput;
};

export type ConfigAdminDetailNode = {
  __typename?: 'ConfigAdminDetailNode';
  has_catalog_available: ConfigurationAdminEnum;
  has_crehana_content_available: ConfigurationAdminEnum;
  has_third_party_content_available: ConfigurationAdminEnum;
  leader_can_assign_content: Scalars['Boolean']['output'];
};

export type ConfigDetailNode = {
  __typename?: 'ConfigDetailNode';
  crehana_content_allowed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  organization_content_allowed: Scalars['Boolean']['output'];
};

export type ConfigValidationError = {
  __typename?: 'ConfigValidationError';
  /** Error code */
  error_code: ConfigValidationErrorCode;
  /** Field that caused the error (if applicable) */
  field?: Maybe<Scalars['String']['output']>;
  /** File name that failed validation */
  file_name: Scalars['String']['output'];
  /** Human-readable error message */
  message: Scalars['String']['output'];
};

export enum ConfigValidationErrorCode {
  DateInFuture = 'DATE_IN_FUTURE',
  DateInPast = 'DATE_IN_PAST',
  DuplicateFile = 'DUPLICATE_FILE',
  EmailMismatch = 'EMAIL_MISMATCH',
  FileNotFound = 'FILE_NOT_FOUND',
  FolderAccessDenied = 'FOLDER_ACCESS_DENIED',
  FolderInactive = 'FOLDER_INACTIVE',
  FolderNotFound = 'FOLDER_NOT_FOUND',
  InternalError = 'INTERNAL_ERROR',
  InvalidDate = 'INVALID_DATE',
  InvalidValue = 'INVALID_VALUE',
  MissingRequiredField = 'MISSING_REQUIRED_FIELD',
  UserInactive = 'USER_INACTIVE',
  UserNotFound = 'USER_NOT_FOUND'
}

export enum ConfigurationAdminEnum {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Inactive = 'INACTIVE'
}

export type ConfirmSignatureDocumentVerificationCodeInput = {
  centralized_organization_id: Scalars['Int']['input'];
  code: Scalars['Int']['input'];
  document_signature_status_id: Scalars['Int']['input'];
};

export type ContentAcademyNode = {
  __typename?: 'ContentAcademyNode';
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
};

export type ContentAssignCourseByExcelResponse = DataFieldsSent | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type ContentAssignCourseByLeaderResponse = AssignContentCoursePayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type ContentAssignCourseResponse = AssignContentCoursePayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type ContentAssignOrganizationTeamToUserResponse = AssignOrganizationTeamToUserPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type ContentAssignTrackResponse = AssignContentTrackPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type ContentCertificateNode = {
  __typename?: 'ContentCertificateNode';
  attachment_url?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  enrollment_id: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['Int']['output'];
  user_team_id?: Maybe<Scalars['Int']['output']>;
};

export type ContentCourseNode = {
  __typename?: 'ContentCourseNode';
  attachments: Scalars['Int']['output'];
  category?: Maybe<Category>;
  comments: Scalars['Int']['output'];
  course_type?: Maybe<Scalars['String']['output']>;
  course_type_enum?: Maybe<CourseTypeEnum>;
  created_date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  due_date?: Maybe<Scalars['DateTime']['output']>;
  duration: Scalars['Int']['output'];
  enrollments: Scalars['Int']['output'];
  first_video_lecture_url?: Maybe<UrlNode>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  launch_date?: Maybe<Scalars['DateTime']['output']>;
  level?: Maybe<Level>;
  meta_description: Scalars['String']['output'];
  meta_keywords: Scalars['String']['output'];
  meta_title?: Maybe<Scalars['String']['output']>;
  modified_date?: Maybe<Scalars['DateTime']['output']>;
  modules: Array<CourseModule>;
  order_date?: Maybe<Scalars['DateTime']['output']>;
  price: Scalars['Float']['output'];
  professor?: Maybe<ProfessorNode>;
  professor_id?: Maybe<Scalars['ID']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  promo_image?: Maybe<ImageNode>;
  publish_date?: Maybe<Scalars['DateTime']['output']>;
  score: Scalars['Float']['output'];
  slug: Scalars['String']['output'];
  studio_course_config?: Maybe<StudioCourseConfigNode>;
  subcategory?: Maybe<Subcategory>;
  title: Scalars['String']['output'];
  trailer_source?: Maybe<CourseVideoTrailerNode>;
  url?: Maybe<Scalars['String']['output']>;
  videos: Scalars['String']['output'];
};

export type ContentDetailCategoryNode = {
  __typename?: 'ContentDetailCategoryNode';
  category_type: CategoryType;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ContentDetailCourseNode = {
  __typename?: 'ContentDetailCourseNode';
  course_level?: Maybe<Level>;
  course_type?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  is_mandatory?: Maybe<Scalars['Boolean']['output']>;
  level_id?: Maybe<Scalars['Int']['output']>;
  modified_date?: Maybe<Scalars['String']['output']>;
  modules: Array<CourseModule>;
  professor?: Maybe<ProfessorNode>;
  professor_id?: Maybe<Scalars['Int']['output']>;
  professor_name?: Maybe<Scalars['String']['output']>;
  requirements?: Maybe<Array<CourseRequirementNode>>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_attachments_number: Scalars['Int']['output'];
  video_trailer?: Maybe<CourseVideoTrailerNode>;
};

export type ContentDetailV2Node = {
  __typename?: 'ContentDetailV2Node';
  content_url?: Maybe<Scalars['String']['output']>;
  content_value?: Maybe<Scalars['String']['output']>;
  course?: Maybe<ContentDetailCourseNode>;
  description: Scalars['String']['output'];
  document?: Maybe<KnowledgeHubDocumentNode>;
  enrollment_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_enrolled?: Maybe<Scalars['Boolean']['output']>;
  modified_date?: Maybe<Scalars['DateTime']['output']>;
  modules: Array<CourseModule>;
  organization_id: Scalars['Int']['output'];
  original_id?: Maybe<Scalars['String']['output']>;
  related_categories: Array<ContentDetailCategoryNode>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  track?: Maybe<KnowledgeHubOrganizationTeamNode>;
};

export type ContentEnrollmentMutations = {
  __typename?: 'ContentEnrollmentMutations';
  assign_course_to_multiple_users: ContentAssignCourseResponse;
  /** Enrollment assignment by excel */
  assign_course_to_multiple_users_by_excel: ContentAssignCourseByExcelResponse;
  /** Leader Course Assignment */
  assign_course_to_multiple_users_by_leader: ContentAssignCourseByLeaderResponse;
  /** Force enrollment completed */
  force_enrollment_completed: ContentForceEnrollmentCompletedResponse;
  /** Reset one collaborator's progress on one course (admin/staff only): clears video progress and writes a durable audit trail (CELC-5029) */
  reset_course_progress: ResetCourseProgressResponse;
  /** Reset a batch of collaborators' progress on one course (admin/staff only): creates a job, persists one pending item per collaborator, and enqueues one coordinator message for the per-item fan-out to apply (CELC-5091/CELC-5115) */
  reset_course_progress_bulk: ResetCourseProgressBulkResponse;
  /** Enroll the session user into a course of their organization */
  self_enroll: SelfEnrollResponse;
};


export type ContentEnrollmentMutationsAssign_Course_To_Multiple_UsersArgs = {
  input: AssignCourseToMultipleUserInput;
};


export type ContentEnrollmentMutationsAssign_Course_To_Multiple_Users_By_ExcelArgs = {
  input: AssignCourseByExcelInput;
};


export type ContentEnrollmentMutationsAssign_Course_To_Multiple_Users_By_LeaderArgs = {
  input: AssignCourseToMultipleUserByLeaderInput;
};


export type ContentEnrollmentMutationsForce_Enrollment_CompletedArgs = {
  input: EnrollmentCompletedInput;
};


export type ContentEnrollmentMutationsReset_Course_ProgressArgs = {
  input: ResetCourseProgressInput;
};


export type ContentEnrollmentMutationsReset_Course_Progress_BulkArgs = {
  input: ResetCourseProgressBulkInput;
};


export type ContentEnrollmentMutationsSelf_EnrollArgs = {
  input: SelfEnrollCourseInput;
};

export type ContentFiltersInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  content_type?: InputMaybe<Array<ContentType>>;
  document_actions?: InputMaybe<Array<DocumentActionEnum>>;
  document_extensions?: InputMaybe<Array<DocumentExtension>>;
  is_new_content?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<ContentLanguages>>;
  levels?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  visibility_level?: InputMaybe<VisibilityLevelType>;
};

export type ContentForceEnrollmentCompletedResponse = EnrollmentCompletedPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type ContentInputOrderBy = {
  direction: OrderDirectionEnum;
  field: ContentOrderByEnum;
};

export enum ContentLanguages {
  LanguageEn = 'LANGUAGE_EN',
  LanguageEs = 'LANGUAGE_ES',
  LanguagePt = 'LANGUAGE_PT'
}

export enum ContentOrderByEnum {
  CreatedAt = 'CREATED_AT',
  Title = 'TITLE'
}

export type ContentOrganizationTeamCourseNode = {
  __typename?: 'ContentOrganizationTeamCourseNode';
  /** Fecha en que el curso fue agregado a la ruta de este usuario (UserOrganizationCourse.created_at). Es null si el usuario no tiene UserOrganizationCourse para ese curso. */
  assigned_at?: Maybe<Scalars['DateTime']['output']>;
  course?: Maybe<ContentCourseNode>;
  course_id?: Maybe<Scalars['ID']['output']>;
  course_user_summary?: Maybe<CourseUserSummaryNode>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  /** CELC-4928: UI-only signal, does not affect enrollment, access or completion. True only while the course carries a live coming-soon mark in its track. False with the feature flag off. Every surface that returns this node computes it (collaborator listing, admin listing and KnowledgeHub v1 track), so the value is meaningful wherever it is asked for. */
  is_coming_soon: Scalars['Boolean']['output'];
  is_required?: Maybe<Scalars['Boolean']['output']>;
  is_required_project?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type ContentOrganizationTeamCourseType = {
  course_id: Scalars['Int']['input'];
  is_required: Scalars['Boolean']['input'];
  order: Scalars['Int']['input'];
};

export type ContentOrganizationTeamInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  organization_team_id: Scalars['Int']['input'];
};

export type ContentOrganizationTeamType = {
  __typename?: 'ContentOrganizationTeamType';
  cover_image_id?: Maybe<Scalars['Int']['output']>;
  cover_image_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  expiration_time?: Maybe<Scalars['Int']['output']>;
  generate_certificate?: Maybe<Scalars['Boolean']['output']>;
  has_reward?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_draft?: Maybe<Scalars['Boolean']['output']>;
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  modality?: Maybe<TrackModalityEnum>;
  name: Scalars['String']['output'];
  start_date?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  version?: Maybe<TrackVersionEnum>;
};

export type ContentSearchConnection = {
  __typename?: 'ContentSearchConnection';
  edges: Array<ContentSearchNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type ContentSearchNode = {
  __typename?: 'ContentSearchNode';
  content?: Maybe<KnowledgeHubContentNode>;
  content_id: Scalars['String']['output'];
  content_type?: Maybe<Scalars['Int']['output']>;
  metadata: Scalars['JSON']['output'];
  organization_id?: Maybe<Scalars['Int']['output']>;
  page_content: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
};

/** An edge in a connection. */
export type ContentSearchNodeEdge = {
  __typename?: 'ContentSearchNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ContentSearchNode;
};

export type ContentStatisticsNode = {
  __typename?: 'ContentStatisticsNode';
  total_crehana_courses?: Maybe<Scalars['Int']['output']>;
  total_new_contents?: Maybe<Scalars['Int']['output']>;
  total_third_party_courses?: Maybe<Scalars['Int']['output']>;
};

/** Whether the campaign targets courses or time periods */
export enum ContentTargetType {
  Courses = 'COURSES',
  TimePeriod = 'TIME_PERIOD'
}

export enum ContentType {
  ContentTypeCourse = 'CONTENT_TYPE_COURSE',
  ContentTypeElevateCourse = 'CONTENT_TYPE_ELEVATE_COURSE',
  ContentTypeFile = 'CONTENT_TYPE_FILE',
  ContentTypePath = 'CONTENT_TYPE_PATH',
  ContentTypeThirdPartyCourse = 'CONTENT_TYPE_THIRD_PARTY_COURSE',
  ContentTypeTrack = 'CONTENT_TYPE_TRACK'
}

export type ContentTypeNode = {
  __typename?: 'ContentTypeNode';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export enum ContentTypeV2Enum {
  ContentTypeCourse = 'CONTENT_TYPE_COURSE',
  ContentTypeElevateCourse = 'CONTENT_TYPE_ELEVATE_COURSE',
  ContentTypeFile = 'CONTENT_TYPE_FILE',
  ContentTypeTrack = 'CONTENT_TYPE_TRACK'
}

export type ContentUpdateActionsPayload = {
  __typename?: 'ContentUpdateActionsPayload';
  async_process: Scalars['Boolean']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  rows_affected: Scalars['Int']['output'];
};

export type ContentUpdateActionsResponse = ContentUpdateActionsPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type ContentUpdateOrganizationTeamResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | UpdateOrganizationTeamPayload;

export type ContentVisibilityNode = {
  __typename?: 'ContentVisibilityNode';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type ContractHistoryEntry = {
  __typename?: 'ContractHistoryEntry';
  action: Scalars['String']['output'];
  change_blocks?: Maybe<Array<Scalars['String']['output']>>;
  change_reason?: Maybe<Scalars['String']['output']>;
  contract_id: Scalars['UUID']['output'];
  new_status: Scalars['String']['output'];
  performed_at: Scalars['DateTime']['output'];
  performed_by: Scalars['String']['output'];
  previous_status?: Maybe<Scalars['String']['output']>;
  section?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type ContractSalaryInfoType = {
  __typename?: 'ContractSalaryInfoType';
  bank_account_number?: Maybe<Scalars['String']['output']>;
  base_salary: Scalars['Decimal']['output'];
  centralized_org_unit_ref?: Maybe<Scalars['String']['output']>;
  centralized_position_ref?: Maybe<Scalars['String']['output']>;
  clabe?: Maybe<Scalars['String']['output']>;
  daily_salary: Scalars['Decimal']['output'];
  imss_salary_type: ImssSalaryTypeEnum;
  manager_ref?: Maybe<Scalars['String']['output']>;
  payment_method: PaymentMethodEnum;
  payroll_bank_code?: Maybe<Scalars['String']['output']>;
  sar_bank_code?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  work_center_ref?: Maybe<Scalars['String']['output']>;
};

/** Tipo de jornada laboral. */
export enum ContractShiftTypeEnum {
  Diurna = 'DIURNA',
  Mixta = 'MIXTA',
  Nocturna = 'NOCTURNA',
  Otra = 'OTRA',
  PorHora = 'POR_HORA',
  Reducida = 'REDUCIDA'
}

/** Tipo de contrato laboral (alineado con wireframe PAYR-370-371-372). */
export enum ContractTypeEnum {
  Fijo = 'FIJO',
  Honorarios = 'HONORARIOS',
  Indeterminado = 'INDETERMINADO',
  Obra = 'OBRA',
  Prueba = 'PRUEBA'
}

export type ConvertDocumentTemplateFromDocxInput = {
  centralized_organization_id: Scalars['Int']['input'];
  file_id: Scalars['Int']['input'];
};

export type ConvertToAdminResponse = {
  __typename?: 'ConvertToAdminResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

/** Input de la agregación escalar de learning_course_enrollments. */
export type CopilotAnalyticsAggregateLearningCourseEnrollmentInput = {
  /** Columna numérica a agregar. */
  column: CopilotAnalyticsLearningCourseEnrollmentAggregateColumnEnum;
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningCourseEnrollmentFilterInput>;
  /** Función de agregación a aplicar. */
  metric: CopilotAnalyticsAggregateMetricEnum;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
};

/** Input de la agregación escalar de learning_progress_hours. */
export type CopilotAnalyticsAggregateLearningProgressHourInput = {
  /** Columna numérica a agregar. */
  column: CopilotAnalyticsLearningProgressHourAggregateColumnEnum;
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningProgressHourFilterInput>;
  /** Función de agregación a aplicar. */
  metric: CopilotAnalyticsAggregateMetricEnum;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
};

/** Función de agregación a aplicar sobre la columna. */
export enum CopilotAnalyticsAggregateMetricEnum {
  Avg = 'AVG',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

export type CopilotAnalyticsAggregatePayload = {
  __typename?: 'CopilotAnalyticsAggregatePayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Cantidad de filas agregadas. Desambigua value = null (0 filas) de una suma que da cero. */
  row_count: Scalars['Int']['output'];
  /** Resultado de la agregación, sin redondear. null si ninguna fila matchea el filtro. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type CopilotAnalyticsAggregateResult = CopilotAnalyticsAggregatePayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Cuántas filas de cada lado matchean por la clave de la relación. */
export enum CopilotAnalyticsCardinality {
  ManyToMany = 'MANY_TO_MANY',
  ManyToOne = 'MANY_TO_ONE',
  OneToMany = 'ONE_TO_MANY',
  OneToOne = 'ONE_TO_ONE'
}

/** Una columna exportable de una fuente del catálogo. */
export type CopilotAnalyticsCatalogColumn = {
  __typename?: 'CopilotAnalyticsCatalogColumn';
  /** Capacidades de filtro y de forma que la columna admite. */
  capabilities: Array<CopilotAnalyticsColumnCapability>;
  /** Qué contiene la columna, con unidad o formato cuando aplica. */
  description: Scalars['String']['output'];
  /** Si la columna puede salir en un archivo a medida (CBC-5461). Solo se publican columnas exportables, así que es siempre true; existe para que el consumidor falle cerrado si el flag dejara de llegar. */
  exportable: Scalars['Boolean']['output'];
  /** Nombre expuesto de la columna (snake_case). */
  name: Scalars['String']['output'];
  /** Tipo del valor: int, str, bool, date, datetime o float. */
  type: Scalars['String']['output'];
};

/** Un par que NO se puede cruzar, con su motivo, para que el agente no lo intente. */
export type CopilotAnalyticsCatalogNotCombinable = {
  __typename?: 'CopilotAnalyticsCatalogNotCombinable';
  /** Motivo por el que el par no se puede cruzar. */
  reason: Scalars['String']['output'];
  /** query_name de la otra fuente del par. */
  target: Scalars['String']['output'];
};

/** Cómo se cruzan dos fuentes que NO comparten identificador, pasando por una tercera declarada (CBC-5471). El pedido nombra solo el destino: el servidor resuelve la fuente puente. */
export type CopilotAnalyticsCatalogPath = {
  __typename?: 'CopilotAnalyticsCatalogPath';
  /** query_name de la fuente intermedia por la que pasa el cruce. */
  bridge: Scalars['String']['output'];
  /** Cardinalidad COMPUESTA leída desde esta fuente: anticipa el abanico de filas antes de pedir el archivo. */
  cardinality: CopilotAnalyticsCardinality;
  /** Por qué ese puente y no otro; es dato publicado, no comentario. */
  reason: Scalars['String']['output'];
  /** query_name de la fuente con la que se cruza. */
  target: Scalars['String']['output'];
};

/** Cómo se cruzan dos fuentes del catálogo (RelationSpec declarada). */
export type CopilotAnalyticsCatalogRelation = {
  __typename?: 'CopilotAnalyticsCatalogRelation';
  /** Cardinalidad del cruce (una fila de un lado ↔ N del otro). */
  cardinality: CopilotAnalyticsCardinality;
  /** query_name del lado que manda el conteo (left o right). */
  driver: Scalars['String']['output'];
  /** query_name del lado izquierdo. */
  left: Scalars['String']['output'];
  /** Columna de la fuente izquierda por la que se cruza. */
  left_column: Scalars['String']['output'];
  /** Qué pasa con las filas sin pareja en el otro lado. */
  orphans: CopilotAnalyticsOrphans;
  /** query_name del lado derecho. */
  right: Scalars['String']['output'];
  /** Columna de la fuente derecha por la que se cruza. */
  right_column: Scalars['String']['output'];
};

/** Una fuente del catálogo de copilot_analytics con su metadata. */
export type CopilotAnalyticsCatalogSource = {
  __typename?: 'CopilotAnalyticsCatalogSource';
  /** Columnas exportables de la fuente. null en el listado corto; lista vacía para una fuente sin columnas exportables. */
  columns?: Maybe<Array<CopilotAnalyticsCatalogColumn>>;
  /** Qué es cada fila de la fuente. */
  description: Scalars['String']['output'];
  /** Dominio de la fuente: learning o hris. */
  domain: Scalars['String']['output'];
  /** Si el universo incluye bajas de la organización. false solo cuando el scope exige vínculo activo con la organización consultada (cohorte del reporte en las orgs con recorte de estado); los scopes por cuenta central activa siguen incluyendo bajas. true también para fuentes sin dimensión de persona (no aplican filtro de activos). */
  includes_inactive: Scalars['Boolean']['output'];
  /** Pares que no se pueden cruzar, con su motivo. null en el listado. */
  not_combinable?: Maybe<Array<CopilotAnalyticsCatalogNotCombinable>>;
  /** query_name de las fuentes alcanzables en DOS saltos por un camino declarado (CBC-5471). Se pasan como join_with igual que relates_to; el puente lo resuelve el servidor. */
  path_targets: Array<Scalars['String']['output']>;
  /** Caminos de dos saltos en los que participa. null en el listado. */
  paths?: Maybe<Array<CopilotAnalyticsCatalogPath>>;
  /** Identificador de la fuente; es lo que se pasa como source. */
  query_name: Scalars['String']['output'];
  /** query_name de las fuentes con las que existe una RelationSpec. Un par ausente no se puede cruzar. */
  relates_to: Array<Scalars['String']['output']>;
  /** Relaciones declaradas en las que participa. null en el listado. */
  relations?: Maybe<Array<CopilotAnalyticsCatalogRelation>>;
  /** Filas de la fuente con la tenencia y los scopes de la organización aplicados; el mismo número que devuelve count_<query_name> sin filtros. */
  total_rows: Scalars['Int']['output'];
  /** A qué universo corresponden las filas, derivado del scope real de la fuente para la organización consultada: cohorte del reporte, relaciones con cuenta central activa, miembros de la organización, filas sin recorte, o catálogo sin dimensión de persona. */
  universe: Scalars['String']['output'];
};

/** Qué acepta la columna en los filtros y en la forma del resultado: FILTER (igualdad), SEARCH (contiene texto), DATE_RANGE, NUMERIC_RANGE, IN (pertenencia a conjunto) y GROUP_BY. ORDER_BY está reservado por contrato y no se publica en v1: ninguna operación acepta un argumento de orden. */
export enum CopilotAnalyticsColumnCapability {
  DateRange = 'DATE_RANGE',
  Filter = 'FILTER',
  GroupBy = 'GROUP_BY',
  In = 'IN',
  NumericRange = 'NUMERIC_RANGE',
  OrderBy = 'ORDER_BY',
  Search = 'SEARCH'
}

/** Input del conteo de hris_daily_logins. */
export type CopilotAnalyticsCountHrisDailyLoginInput = {
  /** Centralized organization id (central_org_id) del que pide. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Cuenta valores distintos de esta columna en lugar de filas. Sin este campo se cuentan filas. */
  distinct_on?: InputMaybe<CopilotAnalyticsHrisDailyLoginDistinctEnum>;
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsHrisDailyLoginFilterInput>;
};

/** Input del conteo de hris_organizations. */
export type CopilotAnalyticsCountHrisOrganizationInput = {
  /** Centralized organization id (central_org_id) del que pide. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsHrisOrganizationFilterInput>;
};

/** Input del conteo de hris_user_area_levels. */
export type CopilotAnalyticsCountHrisUserAreaLevelInput = {
  /** Centralized organization id (central_org_id) del que pide. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsHrisUserAreaLevelFilterInput>;
};

/** Input del conteo de hris_user_custom_fields. */
export type CopilotAnalyticsCountHrisUserCustomFieldInput = {
  /** Centralized organization id (central_org_id) del que pide. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Cuenta valores distintos de esta columna en lugar de filas. Sin este campo se cuentan filas. */
  distinct_on?: InputMaybe<CopilotAnalyticsHrisUserCustomFieldDistinctEnum>;
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsHrisUserCustomFieldFilterInput>;
};

/** Input del conteo de hris_users. */
export type CopilotAnalyticsCountHrisUserInput = {
  /** Centralized organization id (central_org_id) del que pide. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Cuenta valores distintos de esta columna en lugar de filas. Sin este campo se cuentan filas. */
  distinct_on?: InputMaybe<CopilotAnalyticsHrisUserDistinctEnum>;
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsHrisUserFilterInput>;
};

/** Input del conteo de learning_course_enrollments. */
export type CopilotAnalyticsCountLearningCourseEnrollmentInput = {
  /** Cuenta valores distintos de esta columna en lugar de filas. Sin este campo se cuentan filas. */
  distinct_on?: InputMaybe<CopilotAnalyticsLearningCourseEnrollmentDistinctEnum>;
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningCourseEnrollmentFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
};

/** Input del conteo de learning_courses. */
export type CopilotAnalyticsCountLearningCourseInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningCourseFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
};

/** Input del conteo de learning_live_sessions. */
export type CopilotAnalyticsCountLearningLiveSessionInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningLiveSessionFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
};

/** Input del conteo de learning_live_session_users. */
export type CopilotAnalyticsCountLearningLiveSessionUserInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningLiveSessionUserFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
};

/** Input del conteo de learning_progress_hours. */
export type CopilotAnalyticsCountLearningProgressHourInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningProgressHourFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
};

/** Input del conteo de learning_quiz_attempts. */
export type CopilotAnalyticsCountLearningQuizAttemptInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningQuizAttemptFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
};

/** Input del conteo de learning_quiz_responses. */
export type CopilotAnalyticsCountLearningQuizResponseInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningQuizResponseFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
};

/** Input del conteo de learning_routes. */
export type CopilotAnalyticsCountLearningRouteInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningRouteFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
};

/** Input del conteo de learning_route_users. */
export type CopilotAnalyticsCountLearningRouteUserInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningRouteUserFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
};

/** Input del conteo de learning_user_course_routes. */
export type CopilotAnalyticsCountLearningUserCourseRouteInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningUserCourseRouteFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
};

/** Input del conteo de learning_user_work_teams. */
export type CopilotAnalyticsCountLearningUserWorkTeamInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningUserWorkTeamFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
};

export type CopilotAnalyticsCountPayload = {
  __typename?: 'CopilotAnalyticsCountPayload';
  /** Cantidad de filas que matchean. */
  count: Scalars['Int']['output'];
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
};

export type CopilotAnalyticsCountResult = CopilotAnalyticsCountPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CopilotAnalyticsCustomFileFilter = {
  column: Scalars['String']['input'];
  op: CopilotAnalyticsFilterOp;
  value: Scalars['JSON']['input'];
};

export type CopilotAnalyticsCustomFileRejected = {
  __typename?: 'CopilotAnalyticsCustomFileRejected';
  allowed: Array<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type CopilotAnalyticsCustomFileSummary = {
  __typename?: 'CopilotAnalyticsCustomFileSummary';
  columns: Array<Scalars['String']['output']>;
  driver_rows: Scalars['Int']['output'];
  driver_source: Scalars['String']['output'];
  excluded: Array<Scalars['String']['output']>;
  filters_applied: Array<Scalars['String']['output']>;
  inactive_included: Scalars['Int']['output'];
  includes_identity_document: Scalars['Boolean']['output'];
  joined_sources: Array<Scalars['String']['output']>;
  matches_dashboard: Scalars['Boolean']['output'];
  orphans_kept: Scalars['Int']['output'];
  persons: Scalars['Int']['output'];
  rows: Scalars['Int']['output'];
};

export type CopilotAnalyticsDateBetween = {
  /** Día final, inclusivo (YYYY-MM-DD). */
  end?: InputMaybe<Scalars['Date']['input']>;
  /** Día inicial, inclusivo (YYYY-MM-DD). */
  start?: InputMaybe<Scalars['Date']['input']>;
};

/** Input de describe_catalog. Sin source: el catálogo corto (todas las fuentes, sin columnas). Con source: una sola fuente con sus columnas exportables y sus relaciones. */
export type CopilotAnalyticsDescribeCatalogInput = {
  /** Centralized organization id (central_org_id) del que pide; total_rows se cuenta con la tenencia de esa organización. */
  centralized_organization_id: Scalars['ID']['input'];
  /** query_name de una fuente (tal como lo devuelve el listado). null = listado corto. */
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Fuentes del catálogo, ordenadas por grado DESC, total_rows DESC y query_name ASC. */
export type CopilotAnalyticsDescribeCatalogPayload = {
  __typename?: 'CopilotAnalyticsDescribeCatalogPayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Fuentes ordenadas por grado de combinación DESC, total_rows DESC y query_name ASC. */
  sources: Array<CopilotAnalyticsCatalogSource>;
};

export type CopilotAnalyticsDescribeCatalogResponse = CopilotAnalyticsDescribeCatalogPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export enum CopilotAnalyticsFilterOp {
  Between = 'BETWEEN',
  Contains = 'CONTAINS',
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  In = 'IN',
  Lt = 'LT',
  Lte = 'LTE',
  Ne = 'NE'
}

export type CopilotAnalyticsGenerateCustomFileInput = {
  centralized_organization_id: Scalars['ID']['input'];
  columns: Array<Scalars['String']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<CopilotAnalyticsCustomFileFilter>>;
  include_inactive?: InputMaybe<Scalars['Boolean']['input']>;
  join_with?: InputMaybe<Array<Scalars['String']['input']>>;
  source: Scalars['String']['input'];
};

export type CopilotAnalyticsGenerateCustomFilePayload = {
  __typename?: 'CopilotAnalyticsGenerateCustomFilePayload';
  download_url?: Maybe<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  report_id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  summary: CopilotAnalyticsCustomFileSummary;
};

export type CopilotAnalyticsGenerateCustomFileResponse = CopilotAnalyticsCustomFileRejected | CopilotAnalyticsGenerateCustomFilePayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Tamaño del bucket temporal: DAY (un bucket por día), WEEK (por semana, arranca el lunes) o MONTH (por mes). */
export enum CopilotAnalyticsGranularityEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type CopilotAnalyticsGroupByPayload = {
  __typename?: 'CopilotAnalyticsGroupByPayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Grupos (value/count) de esta página, ordenados por count desc. */
  items: Array<CopilotAnalyticsGroupCount>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Cantidad de grupos distintos (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsGroupByResult = CopilotAnalyticsGroupByPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CopilotAnalyticsGroupCount = {
  __typename?: 'CopilotAnalyticsGroupCount';
  /** Cantidad de filas (tras el filtro) en este grupo. */
  count: Scalars['Int']['output'];
  /** Valor distinto de la dimensión agrupada, serializado como texto (null agrupa las filas con la columna en NULL). */
  value?: Maybe<Scalars['String']['output']>;
};

/** Input de la agrupación de hris_daily_logins. */
export type CopilotAnalyticsGroupHrisDailyLoginInput = {
  /** Centralized organization id (central_org_id) del que pide. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsHrisDailyLoginFilterInput>;
  /** Dimensión por la que agrupar. */
  group_by: CopilotAnalyticsHrisDailyLoginGroupByEnum;
  /** Paginación offset de los grupos. */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

/** Input de la agrupación de hris_organizations. */
export type CopilotAnalyticsGroupHrisOrganizationInput = {
  /** Centralized organization id (central_org_id) del que pide. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsHrisOrganizationFilterInput>;
  /** Dimensión por la que agrupar. */
  group_by: CopilotAnalyticsHrisOrganizationGroupByEnum;
  /** Paginación offset de los grupos. */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

/** Input de la agrupación de hris_user_area_levels. */
export type CopilotAnalyticsGroupHrisUserAreaLevelInput = {
  /** Centralized organization id (central_org_id) del que pide. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsHrisUserAreaLevelFilterInput>;
  /** Dimensión por la que agrupar. */
  group_by: CopilotAnalyticsHrisUserAreaLevelGroupByEnum;
  /** Paginación offset de los grupos. */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

/** Input de la agrupación de hris_user_custom_fields. */
export type CopilotAnalyticsGroupHrisUserCustomFieldInput = {
  /** Centralized organization id (central_org_id) del que pide. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsHrisUserCustomFieldFilterInput>;
  /** Dimensión por la que agrupar. */
  group_by: CopilotAnalyticsHrisUserCustomFieldGroupByEnum;
  /** Paginación offset de los grupos. */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

/** Input de la agrupación de hris_users. */
export type CopilotAnalyticsGroupHrisUserInput = {
  /** Centralized organization id (central_org_id) del que pide. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsHrisUserFilterInput>;
  /** Dimensión por la que agrupar. */
  group_by: CopilotAnalyticsHrisUserGroupByEnum;
  /** Paginación offset de los grupos. */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

/** Input de la agrupación de learning_course_enrollments. */
export type CopilotAnalyticsGroupLearningCourseEnrollmentInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningCourseEnrollmentFilterInput>;
  /** Dimensión por la que agrupar. */
  group_by: CopilotAnalyticsLearningCourseEnrollmentGroupByEnum;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset de los grupos. */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

/** Input de la agrupación de learning_courses. */
export type CopilotAnalyticsGroupLearningCourseInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningCourseFilterInput>;
  /** Dimensión por la que agrupar. */
  group_by: CopilotAnalyticsLearningCourseGroupByEnum;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset de los grupos. */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

/** Input de la agrupación de learning_live_sessions. */
export type CopilotAnalyticsGroupLearningLiveSessionInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningLiveSessionFilterInput>;
  /** Dimensión por la que agrupar. */
  group_by: CopilotAnalyticsLearningLiveSessionGroupByEnum;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset de los grupos. */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

/** Input de la agrupación de learning_live_session_users. */
export type CopilotAnalyticsGroupLearningLiveSessionUserInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningLiveSessionUserFilterInput>;
  /** Dimensión por la que agrupar. */
  group_by: CopilotAnalyticsLearningLiveSessionUserGroupByEnum;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset de los grupos. */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

/** Input de la agrupación de learning_progress_hours. */
export type CopilotAnalyticsGroupLearningProgressHourInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningProgressHourFilterInput>;
  /** Dimensión por la que agrupar. */
  group_by: CopilotAnalyticsLearningProgressHourGroupByEnum;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset de los grupos. */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

/** Input de la agrupación de learning_quiz_attempts. */
export type CopilotAnalyticsGroupLearningQuizAttemptInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningQuizAttemptFilterInput>;
  /** Dimensión por la que agrupar. */
  group_by: CopilotAnalyticsLearningQuizAttemptGroupByEnum;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset de los grupos. */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

/** Input de la agrupación de learning_quiz_responses. */
export type CopilotAnalyticsGroupLearningQuizResponseInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningQuizResponseFilterInput>;
  /** Dimensión por la que agrupar. */
  group_by: CopilotAnalyticsLearningQuizResponseGroupByEnum;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset de los grupos. */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

/** Input de la agrupación de learning_routes. */
export type CopilotAnalyticsGroupLearningRouteInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningRouteFilterInput>;
  /** Dimensión por la que agrupar. */
  group_by: CopilotAnalyticsLearningRouteGroupByEnum;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset de los grupos. */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

/** Input de la agrupación de learning_route_users. */
export type CopilotAnalyticsGroupLearningRouteUserInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningRouteUserFilterInput>;
  /** Dimensión por la que agrupar. */
  group_by: CopilotAnalyticsLearningRouteUserGroupByEnum;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset de los grupos. */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

/** Input de la agrupación de learning_user_course_routes. */
export type CopilotAnalyticsGroupLearningUserCourseRouteInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningUserCourseRouteFilterInput>;
  /** Dimensión por la que agrupar. */
  group_by: CopilotAnalyticsLearningUserCourseRouteGroupByEnum;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset de los grupos. */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

/** Input de la agrupación de learning_user_work_teams. */
export type CopilotAnalyticsGroupLearningUserWorkTeamInput = {
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningUserWorkTeamFilterInput>;
  /** Dimensión por la que agrupar. */
  group_by: CopilotAnalyticsLearningUserWorkTeamGroupByEnum;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset de los grupos. */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

export enum CopilotAnalyticsHrisDailyLoginDistinctEnum {
  UserId = 'USER_ID'
}

export type CopilotAnalyticsHrisDailyLoginFilterInput = {
  /** Filtra por central_org_id (pertenece al conjunto). */
  central_org_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por company_id (igualdad). */
  company_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por company_id (pertenece al conjunto). */
  company_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por last_login_at en el rango de días [start, end] inclusivo. */
  last_login_at_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por last_login_at >= este día (YYYY-MM-DD). */
  last_login_at_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por last_login_at <= este día (YYYY-MM-DD). */
  last_login_at_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por login_count >. */
  login_count_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por login_count >=. */
  login_count_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por login_count <. */
  login_count_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por login_count <=. */
  login_count_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por login_date en el rango de días [start, end] inclusivo. */
  login_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por login_date >= este día (YYYY-MM-DD). */
  login_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por login_date <= este día (YYYY-MM-DD). */
  login_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por org_id (igualdad). */
  org_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por org_id (pertenece al conjunto). */
  org_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum CopilotAnalyticsHrisDailyLoginGroupByEnum {
  UserId = 'USER_ID'
}

export enum CopilotAnalyticsHrisDailyLoginSeriesColumnEnum {
  LoginDate = 'LOGIN_DATE'
}

/** Actividad de login diaria de un usuario en la organización centralizada. Una fila por usuario y día CON AL MENOS UN LOGIN (login_count dice cuántos hizo ese día); los días sin login no tienen fila. Para 'usuarios únicos con login en los últimos N días' usá el conteo con distinct_on = user_id: contar filas cuenta días, no personas. Es la misma fuente que la tarjeta '% de colaboradores con login' del dashboard; el denominador de ese porcentaje son los colaboradores activos (hris_users con status = active). */
export type CopilotAnalyticsHrisDailyLoginType = {
  __typename?: 'CopilotAnalyticsHrisDailyLoginType';
  /** id de la organización en el módulo centralizado */
  central_org_id?: Maybe<Scalars['Int']['output']>;
  /** id de la organización en Talent */
  company_id?: Maybe<Scalars['Int']['output']>;
  /** id del registro de login diario */
  id?: Maybe<Scalars['String']['output']>;
  /** último login de ese día (ISO-8601) */
  last_login_at?: Maybe<Scalars['DateTime']['output']>;
  /** cantidad de logins del usuario ese día */
  login_count?: Maybe<Scalars['Int']['output']>;
  /** día del login (fecha, sin hora) */
  login_date?: Maybe<Scalars['Date']['output']>;
  /** id de la organización en Learning */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** id del usuario en Learning */
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type CopilotAnalyticsHrisOrganizationFilterInput = {
  /** Filtra por central_org_id (pertenece al conjunto). */
  central_org_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por company_id (igualdad). */
  company_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por company_id (pertenece al conjunto). */
  company_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por country_code (igualdad). */
  country_code?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por created_date en el rango de días [start, end] inclusivo. */
  created_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por created_date >= este día (YYYY-MM-DD). */
  created_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por created_date <= este día (YYYY-MM-DD). */
  created_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por is_active (igualdad). */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por name (contiene texto, case-insensitive). */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por open_opportunity_id (pertenece al conjunto). */
  open_opportunity_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por org_id (igualdad). */
  org_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por org_id (pertenece al conjunto). */
  org_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por slug (igualdad). */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por slug (contiene texto, case-insensitive). */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por updated_date en el rango de días [start, end] inclusivo. */
  updated_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por updated_date >= este día (YYYY-MM-DD). */
  updated_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por updated_date <= este día (YYYY-MM-DD). */
  updated_date_lte?: InputMaybe<Scalars['Date']['input']>;
};

export enum CopilotAnalyticsHrisOrganizationGroupByEnum {
  CountryCode = 'COUNTRY_CODE',
  IsActive = 'IS_ACTIVE'
}

/** Metadata de la organización en el módulo centralizado, con sus ids internos de Learning (org_id) y Talent (company_id). Una fila por organización (central_org_id). */
export type CopilotAnalyticsHrisOrganizationType = {
  __typename?: 'CopilotAnalyticsHrisOrganizationType';
  /** id de la organización en el módulo centralizado */
  central_org_id?: Maybe<Scalars['Int']['output']>;
  /** id interno de la organización en Talent */
  company_id?: Maybe<Scalars['Int']['output']>;
  /** código de país de la organización */
  country_code?: Maybe<Scalars['String']['output']>;
  /** fecha de creación (ISO-8601) */
  created_date?: Maybe<Scalars['DateTime']['output']>;
  /** bandera: organización activa */
  is_active?: Maybe<Scalars['Boolean']['output']>;
  /** nombre de la organización */
  name?: Maybe<Scalars['String']['output']>;
  /** id de oportunidad abierta (CRM) */
  open_opportunity_id?: Maybe<Scalars['Int']['output']>;
  /** id interno de la organización en Learning */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** slug URL de la organización */
  slug?: Maybe<Scalars['String']['output']>;
  /** fecha de última actualización (ISO-8601) */
  updated_date?: Maybe<Scalars['DateTime']['output']>;
};

export type CopilotAnalyticsHrisUserAreaLevelFilterInput = {
  /** Filtra por area_id (igualdad). */
  area_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por area_id (pertenece al conjunto). */
  area_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por area_level_id (igualdad). */
  area_level_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por area_level_id (pertenece al conjunto). */
  area_level_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por area_level_name (contiene texto, case-insensitive). */
  area_level_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por area_name (contiene texto, case-insensitive). */
  area_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por central_org_id (pertenece al conjunto). */
  central_org_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por central_user_id (pertenece al conjunto). */
  central_user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por central_user_org_level_id (pertenece al conjunto). */
  central_user_org_level_id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por level_sequence (igualdad). */
  level_sequence?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por parent_id (igualdad). */
  parent_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por parent_id (pertenece al conjunto). */
  parent_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por user_area_id (pertenece al conjunto). */
  user_area_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum CopilotAnalyticsHrisUserAreaLevelGroupByEnum {
  AreaLevelName = 'AREA_LEVEL_NAME',
  AreaName = 'AREA_NAME',
  LevelSequence = 'LEVEL_SEQUENCE'
}

/** Árbol de áreas/niveles por usuario en la organización centralizada: cada fila es la pertenencia de un usuario a un área en un nivel de la jerarquía (parent_id enlaza al área padre). */
export type CopilotAnalyticsHrisUserAreaLevelType = {
  __typename?: 'CopilotAnalyticsHrisUserAreaLevelType';
  /** id del área */
  area_id?: Maybe<Scalars['Int']['output']>;
  /** id del nivel de área */
  area_level_id?: Maybe<Scalars['Int']['output']>;
  /** nombre del nivel de área */
  area_level_name?: Maybe<Scalars['String']['output']>;
  /** nombre del área */
  area_name?: Maybe<Scalars['String']['output']>;
  /** id de la organización en el módulo centralizado */
  central_org_id?: Maybe<Scalars['Int']['output']>;
  /** id del usuario en el módulo centralizado */
  central_user_id?: Maybe<Scalars['Int']['output']>;
  /** id de la relación usuario-área-nivel */
  central_user_org_level_id?: Maybe<Scalars['String']['output']>;
  /** secuencia/orden del nivel en la jerarquía */
  level_sequence?: Maybe<Scalars['Int']['output']>;
  /** id del área padre en la jerarquía */
  parent_id?: Maybe<Scalars['Int']['output']>;
  /** id de la relación usuario-área */
  user_area_id?: Maybe<Scalars['Int']['output']>;
};

export enum CopilotAnalyticsHrisUserCustomFieldDistinctEnum {
  CentralUserId = 'CENTRAL_USER_ID',
  FieldId = 'FIELD_ID',
  UserId = 'USER_ID'
}

export type CopilotAnalyticsHrisUserCustomFieldFilterInput = {
  /** Filtra por answer_id (pertenece al conjunto). */
  answer_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por central_org_id (pertenece al conjunto). */
  central_org_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por central_user_id (pertenece al conjunto). */
  central_user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por created_date en el rango de días [start, end] inclusivo. */
  created_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por created_date >= este día (YYYY-MM-DD). */
  created_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por created_date <= este día (YYYY-MM-DD). */
  created_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por field_id (igualdad). */
  field_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por field_id (pertenece al conjunto). */
  field_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por field_name (igualdad). */
  field_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por field_name (contiene texto, case-insensitive). */
  field_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por field_type (igualdad). */
  field_type?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por field_value (igualdad). */
  field_value?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por field_value (contiene texto, case-insensitive). */
  field_value_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por option_id (igualdad). */
  option_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por option_id (pertenece al conjunto). */
  option_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum CopilotAnalyticsHrisUserCustomFieldGroupByEnum {
  FieldId = 'FIELD_ID',
  FieldName = 'FIELD_NAME',
  FieldType = 'FIELD_TYPE',
  FieldValue = 'FIELD_VALUE',
  OptionId = 'OPTION_ID'
}

/** Valor de un campo personalizado (custom field) para un usuario. Una fila por respuesta: un usuario con 5 campos cargados tiene 5 filas, así que para contar PERSONAS hay que usar distinct_on = central_user_id (o user_id) — contar filas cuenta respuestas. field_value ya viene resuelto: en los campos de selección es el nombre de la opción elegida, en los de texto es la respuesta cargada. Es la misma fuente y la misma resolución que las columnas de custom fields del reporte descargable. Para segmentar: primero agrupá por field_name para ver qué campos tiene la organización, después filtrá por field_id y agrupá por field_value para ver la distribución de ese campo. user_id es el id de LEARNING y sirve para cruzar con las queries de learning (por ejemplo learning_course_enrollments con user_id_in); es null si el usuario no tiene cuenta de learning. */
export type CopilotAnalyticsHrisUserCustomFieldType = {
  __typename?: 'CopilotAnalyticsHrisUserCustomFieldType';
  /** id de la respuesta */
  answer_id?: Maybe<Scalars['Int']['output']>;
  /** id de la organización en el módulo centralizado */
  central_org_id?: Maybe<Scalars['Int']['output']>;
  /** id del usuario en el módulo centralizado */
  central_user_id?: Maybe<Scalars['Int']['output']>;
  /** fecha de carga de la respuesta (ISO-8601) */
  created_date?: Maybe<Scalars['DateTime']['output']>;
  /** id del campo personalizado; es el filtro RÁPIDO para acotar a un campo */
  field_id?: Maybe<Scalars['Int']['output']>;
  /** nombre del campo personalizado */
  field_name?: Maybe<Scalars['String']['output']>;
  /** tipo del campo (texto, selección, fecha, ... ) */
  field_type?: Maybe<Scalars['String']['output']>;
  /** VALOR del campo ya resuelto: nombre de la opción elegida o texto de la respuesta. Filtrar por este texto escanea las respuestas del campo — acotá primero por field_id (y por option_id si el campo es de selección) */
  field_value?: Maybe<Scalars['String']['output']>;
  /** id de la opción elegida en un campo de selección; null en los campos de texto libre */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** id del usuario en Learning (null si no tiene cuenta de learning); es la columna con la que se cruza contra las queries de learning */
  user_id?: Maybe<Scalars['Int']['output']>;
};

export enum CopilotAnalyticsHrisUserDistinctEnum {
  CentralUserId = 'CENTRAL_USER_ID',
  UserId = 'USER_ID'
}

export type CopilotAnalyticsHrisUserFilterInput = {
  /** Filtra por activate_date en el rango de días [start, end] inclusivo. */
  activate_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por activate_date >= este día (YYYY-MM-DD). */
  activate_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por activate_date <= este día (YYYY-MM-DD). */
  activate_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por area (igualdad). */
  area?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por area (contiene texto, case-insensitive). */
  area_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por area_id (igualdad). */
  area_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por area_id (pertenece al conjunto). */
  area_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por area_level_id (pertenece al conjunto). */
  area_level_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por avatar_id (pertenece al conjunto). */
  avatar_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por birthday_date en el rango de días [start, end] inclusivo. */
  birthday_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por birthday_date >= este día (YYYY-MM-DD). */
  birthday_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por birthday_date <= este día (YYYY-MM-DD). */
  birthday_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por boss_email (contiene texto, case-insensitive). */
  boss_email_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por boss_id (igualdad). */
  boss_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por boss_id (pertenece al conjunto). */
  boss_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por central_org_id (pertenece al conjunto). */
  central_org_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por central_user_id (pertenece al conjunto). */
  central_user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por central_user_org_id (pertenece al conjunto). */
  central_user_org_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por city (igualdad). */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por civil_status (igualdad). */
  civil_status?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por country (igualdad). */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por created_date en el rango de días [start, end] inclusivo. */
  created_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por created_date >= este día (YYYY-MM-DD). */
  created_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por created_date <= este día (YYYY-MM-DD). */
  created_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por deactivation_date en el rango de días [start, end] inclusivo. */
  deactivation_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por deactivation_date >= este día (YYYY-MM-DD). */
  deactivation_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por deactivation_date <= este día (YYYY-MM-DD). */
  deactivation_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por department (igualdad). */
  department?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por department (contiene texto, case-insensitive). */
  department_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por department_id (igualdad). */
  department_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por department_id (pertenece al conjunto). */
  department_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por document (contiene texto, case-insensitive). */
  document_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por document_type (igualdad). */
  document_type?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por employee_id (pertenece al conjunto). */
  employee_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por expiration_date en el rango de días [start, end] inclusivo. */
  expiration_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por expiration_date >= este día (YYYY-MM-DD). */
  expiration_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por expiration_date <= este día (YYYY-MM-DD). */
  expiration_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por gender (igualdad). */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por headquarter (igualdad). */
  headquarter?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por headquarter (contiene texto, case-insensitive). */
  headquarter_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por headquarter_id (pertenece al conjunto). */
  headquarter_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por identification (contiene texto, case-insensitive). */
  identification_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por incorporation_date en el rango de días [start, end] inclusivo. */
  incorporation_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por incorporation_date >= este día (YYYY-MM-DD). */
  incorporation_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por incorporation_date <= este día (YYYY-MM-DD). */
  incorporation_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por last_activity en el rango de días [start, end] inclusivo. */
  last_activity_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por last_activity >= este día (YYYY-MM-DD). */
  last_activity_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por last_activity <= este día (YYYY-MM-DD). */
  last_activity_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por leaving_date en el rango de días [start, end] inclusivo. */
  leaving_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por leaving_date >= este día (YYYY-MM-DD). */
  leaving_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por leaving_date <= este día (YYYY-MM-DD). */
  leaving_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por level (igualdad). */
  level?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por personal_email (contiene texto, case-insensitive). */
  personal_email_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por position (igualdad). */
  position?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por position_category (igualdad). */
  position_category?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por position_category_id (pertenece al conjunto). */
  position_category_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por position (contiene texto, case-insensitive). */
  position_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por position_id (igualdad). */
  position_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por position_id (pertenece al conjunto). */
  position_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por role (igualdad). */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por status (igualdad). */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por updated_date en el rango de días [start, end] inclusivo. */
  updated_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por updated_date >= este día (YYYY-MM-DD). */
  updated_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por updated_date <= este día (YYYY-MM-DD). */
  updated_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por user_email (contiene texto, case-insensitive). */
  user_email_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_first_name (contiene texto, case-insensitive). */
  user_first_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por user_last_name (contiene texto, case-insensitive). */
  user_last_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por workplace_id (pertenece al conjunto). */
  workplace_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum CopilotAnalyticsHrisUserGroupByEnum {
  Area = 'AREA',
  City = 'CITY',
  CivilStatus = 'CIVIL_STATUS',
  Country = 'COUNTRY',
  Department = 'DEPARTMENT',
  DocumentType = 'DOCUMENT_TYPE',
  Gender = 'GENDER',
  Headquarter = 'HEADQUARTER',
  Level = 'LEVEL',
  Position = 'POSITION',
  PositionCategory = 'POSITION_CATEGORY',
  Role = 'ROLE',
  Status = 'STATUS'
}

export enum CopilotAnalyticsHrisUserSeriesColumnEnum {
  ActivateDate = 'ACTIVATE_DATE',
  CreatedDate = 'CREATED_DATE',
  LastActivity = 'LAST_ACTIVITY'
}

/** Relación usuario↔organización del módulo centralizado: perfil, jerarquía (jefe), datos organizacionales y demográficos. Una fila por relación (central_user_org_id). Excluye el hash de autenticación. Universo: el del REPORTE de usuarios — solo relaciones cuyo usuario central está activo (CU.is_active). La tarjeta 'Colaboradores activos' del dashboard no aplica ese filtro, así que este conteo puede ser menor que el de la pantalla. Puede haber varias filas por usuario: para contar personas usá distinct_on. */
export type CopilotAnalyticsHrisUserType = {
  __typename?: 'CopilotAnalyticsHrisUserType';
  /** descripción personal del usuario */
  about_me?: Maybe<Scalars['String']['output']>;
  /** fecha de activación (ISO-8601) */
  activate_date?: Maybe<Scalars['DateTime']['output']>;
  /** dirección del usuario */
  address?: Maybe<Scalars['String']['output']>;
  /** nombre del área */
  area?: Maybe<Scalars['String']['output']>;
  /** id del área */
  area_id?: Maybe<Scalars['Int']['output']>;
  /** id del nivel de área */
  area_level_id?: Maybe<Scalars['Int']['output']>;
  /** id del avatar */
  avatar_id?: Maybe<Scalars['Int']['output']>;
  /** fecha de nacimiento (ISO-8601) */
  birthday_date?: Maybe<Scalars['DateTime']['output']>;
  /** correo del jefe directo */
  boss_email?: Maybe<Scalars['String']['output']>;
  /** nombre del jefe directo */
  boss_first_name?: Maybe<Scalars['String']['output']>;
  /** id del jefe directo */
  boss_id?: Maybe<Scalars['Int']['output']>;
  /** apellido del jefe directo */
  boss_last_name?: Maybe<Scalars['String']['output']>;
  /** id de la organización en el módulo centralizado */
  central_org_id?: Maybe<Scalars['Int']['output']>;
  /** id del usuario en el módulo centralizado */
  central_user_id?: Maybe<Scalars['Int']['output']>;
  /** id de la relación usuario-organización */
  central_user_org_id?: Maybe<Scalars['Int']['output']>;
  /** ciudad del usuario */
  city?: Maybe<Scalars['String']['output']>;
  /** estado civil del usuario */
  civil_status?: Maybe<Scalars['String']['output']>;
  /** país del usuario */
  country?: Maybe<Scalars['String']['output']>;
  /** código de país del usuario */
  country_code?: Maybe<Scalars['String']['output']>;
  /** fecha de creación (ISO-8601) */
  created_date?: Maybe<Scalars['DateTime']['output']>;
  /** fecha de desactivación (ISO-8601) */
  deactivation_date?: Maybe<Scalars['DateTime']['output']>;
  /** nombre del departamento */
  department?: Maybe<Scalars['String']['output']>;
  /** id del departamento */
  department_id?: Maybe<Scalars['Int']['output']>;
  /** número de documento de identidad */
  document?: Maybe<Scalars['String']['output']>;
  /** tipo de documento de identidad */
  document_type?: Maybe<Scalars['String']['output']>;
  /** correo del contacto de emergencia */
  emergency_contact_email?: Maybe<Scalars['String']['output']>;
  /** correo del contacto de emergencia 2 */
  emergency_contact_email_2?: Maybe<Scalars['String']['output']>;
  /** nombre del contacto de emergencia */
  emergency_contact_name?: Maybe<Scalars['String']['output']>;
  /** nombre del contacto de emergencia 2 */
  emergency_contact_name_2?: Maybe<Scalars['String']['output']>;
  /** teléfono del contacto de emergencia */
  emergency_contact_phone?: Maybe<Scalars['String']['output']>;
  /** teléfono del contacto de emergencia 2 */
  emergency_contact_phone_2?: Maybe<Scalars['String']['output']>;
  /** relación con el contacto de emergencia */
  emergency_contact_relationship?: Maybe<Scalars['String']['output']>;
  /** relación con el contacto de emergencia 2 */
  emergency_contact_relationship_2?: Maybe<Scalars['String']['output']>;
  /** id del empleado en Talent */
  employee_id?: Maybe<Scalars['Int']['output']>;
  /** fecha de expiración del acceso (ISO-8601) */
  expiration_date?: Maybe<Scalars['DateTime']['output']>;
  /** género del usuario */
  gender?: Maybe<Scalars['String']['output']>;
  /** nombre de la sede */
  headquarter?: Maybe<Scalars['String']['output']>;
  /** id de la sede */
  headquarter_id?: Maybe<Scalars['Int']['output']>;
  /** identificación interna del usuario */
  identification?: Maybe<Scalars['String']['output']>;
  /** fecha de incorporación (ISO-8601) */
  incorporation_date?: Maybe<Scalars['DateTime']['output']>;
  /** indica si se envió invitación (texto) */
  invitation_sent?: Maybe<Scalars['String']['output']>;
  /** fecha de última actividad (ISO-8601) */
  last_activity?: Maybe<Scalars['DateTime']['output']>;
  /** fecha de baja (ISO-8601) */
  leaving_date?: Maybe<Scalars['DateTime']['output']>;
  /** nombre del nivel de área */
  level?: Maybe<Scalars['String']['output']>;
  /** nombre del área de nivel 2 */
  level_2_area_name?: Maybe<Scalars['String']['output']>;
  /** correo electrónico personal */
  personal_email?: Maybe<Scalars['String']['output']>;
  /** teléfono principal */
  phone_1?: Maybe<Scalars['String']['output']>;
  /** teléfono secundario */
  phone_2?: Maybe<Scalars['String']['output']>;
  /** nombre del cargo */
  position?: Maybe<Scalars['String']['output']>;
  /** nombre de la categoría de cargo */
  position_category?: Maybe<Scalars['String']['output']>;
  /** id de la categoría de cargo */
  position_category_id?: Maybe<Scalars['Int']['output']>;
  /** id del cargo */
  position_id?: Maybe<Scalars['Int']['output']>;
  /** rol del usuario en la organización */
  role?: Maybe<Scalars['String']['output']>;
  /** estado del usuario (active/inactive/pending/deleted) */
  status?: Maybe<Scalars['String']['output']>;
  /** fecha de última actualización (ISO-8601) */
  updated_date?: Maybe<Scalars['DateTime']['output']>;
  /** correo electrónico del usuario */
  user_email?: Maybe<Scalars['String']['output']>;
  /** nombre del usuario */
  user_first_name?: Maybe<Scalars['String']['output']>;
  /** id del usuario en Learning */
  user_id?: Maybe<Scalars['Int']['output']>;
  /** apellido del usuario */
  user_last_name?: Maybe<Scalars['String']['output']>;
  /** id del lugar de trabajo */
  workplace_id?: Maybe<Scalars['Int']['output']>;
};

export enum CopilotAnalyticsLearningCourseEnrollmentAggregateColumnEnum {
  CourseDurationHours = 'COURSE_DURATION_HOURS',
  CourseProgress = 'COURSE_PROGRESS',
  CourseScore = 'COURSE_SCORE',
  ProgressHours = 'PROGRESS_HOURS',
  ProgressMinutes = 'PROGRESS_MINUTES',
  QuizResult = 'QUIZ_RESULT',
  TotalWatchSeconds = 'TOTAL_WATCH_SECONDS'
}

export enum CopilotAnalyticsLearningCourseEnrollmentDistinctEnum {
  CourseId = 'COURSE_ID',
  UserId = 'USER_ID'
}

export type CopilotAnalyticsLearningCourseEnrollmentFilterInput = {
  /** Filtra por assigned_by_name (contiene texto, case-insensitive). */
  assigned_by_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por assignment_source (igualdad). */
  assignment_source?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por certificate_date en el rango de días [start, end] inclusivo. */
  certificate_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por certificate_date >= este día (YYYY-MM-DD). */
  certificate_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por certificate_date <= este día (YYYY-MM-DD). */
  certificate_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por completed_date en el rango de días [start, end] inclusivo. */
  completed_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por completed_date >= este día (YYYY-MM-DD). */
  completed_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por completed_date <= este día (YYYY-MM-DD). */
  completed_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por course_category (contiene texto, case-insensitive). */
  course_category_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por course_id (igualdad). */
  course_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_id (pertenece al conjunto). */
  course_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por course_name (contiene texto, case-insensitive). */
  course_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por course_progress >. */
  course_progress_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_progress >=. */
  course_progress_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_progress <. */
  course_progress_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_progress <=. */
  course_progress_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_score >. */
  course_score_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_score >=. */
  course_score_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_score <. */
  course_score_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_score <=. */
  course_score_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_subcategory (contiene texto, case-insensitive). */
  course_subcategory_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por enroll_date en el rango de días [start, end] inclusivo. */
  enroll_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por enroll_date >= este día (YYYY-MM-DD). */
  enroll_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por enroll_date <= este día (YYYY-MM-DD). */
  enroll_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por enroll_id (pertenece al conjunto). */
  enroll_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por is_admin_assigned (igualdad). */
  is_admin_assigned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_certified (igualdad). */
  is_certified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_completed (igualdad). */
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_crehana (igualdad). */
  is_crehana?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_enroll_active (igualdad). */
  is_enroll_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por last_action_date en el rango de días [start, end] inclusivo. */
  last_action_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por last_action_date >= este día (YYYY-MM-DD). */
  last_action_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por last_action_date <= este día (YYYY-MM-DD). */
  last_action_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por progress_hours >. */
  progress_hours_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_hours >=. */
  progress_hours_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_hours <. */
  progress_hours_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_hours <=. */
  progress_hours_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por project_status (igualdad). */
  project_status?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por quiz_result >. */
  quiz_result_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por quiz_result >=. */
  quiz_result_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por quiz_result <. */
  quiz_result_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por quiz_result <=. */
  quiz_result_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por quiz_status (igualdad). */
  quiz_status?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por start_date en el rango de días [start, end] inclusivo. */
  start_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por start_date >= este día (YYYY-MM-DD). */
  start_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por start_date <= este día (YYYY-MM-DD). */
  start_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum CopilotAnalyticsLearningCourseEnrollmentGroupByEnum {
  CourseCategory = 'COURSE_CATEGORY',
  CourseName = 'COURSE_NAME',
  CourseSubcategory = 'COURSE_SUBCATEGORY',
  IsCertified = 'IS_CERTIFIED',
  IsCompleted = 'IS_COMPLETED',
  IsCrehana = 'IS_CREHANA',
  ProjectStatus = 'PROJECT_STATUS',
  QuizStatus = 'QUIZ_STATUS'
}

export enum CopilotAnalyticsLearningCourseEnrollmentSeriesColumnEnum {
  CertificateDate = 'CERTIFICATE_DATE',
  CompletedDate = 'COMPLETED_DATE',
  EnrollDate = 'ENROLL_DATE',
  LastActionDate = 'LAST_ACTION_DATE'
}

/** Inscripción de un usuario a un curso B2B, con progreso, certificación y resultado de evaluación. Una fila por inscripción (enroll_id). progress_hours son HORAS de progreso; el porcentaje de avance es course_progress. Universo: el del REPORTE descargable — usuarios de la cohorte centralizada, con fila en report_users, sin inscripciones a cursos de otra organización; las fechas se evalúan por día calendario de la organización. Las tarjetas del dashboard usan un universo distinto (colaboradores activos), así que un total puede no coincidir con lo que muestra la pantalla. */
export type CopilotAnalyticsLearningCourseEnrollmentType = {
  __typename?: 'CopilotAnalyticsLearningCourseEnrollmentType';
  /** nombre de quien asignó la inscripción */
  assigned_by_name?: Maybe<Scalars['String']['output']>;
  /** código de la fuente de asignación */
  assignment_source?: Maybe<Scalars['Int']['output']>;
  /** fecha de certificado de evaluación (ISO-8601) */
  certificate_date?: Maybe<Scalars['DateTime']['output']>;
  /** código del certificado de evaluación */
  code_certificate?: Maybe<Scalars['String']['output']>;
  /** fecha de completado (ISO-8601) */
  completed_date?: Maybe<Scalars['DateTime']['output']>;
  /** categoría principal del curso */
  course_category?: Maybe<Scalars['String']['output']>;
  /** comentario del usuario sobre el curso */
  course_comment?: Maybe<Scalars['String']['output']>;
  /** duración del curso en horas */
  course_duration_hours?: Maybe<Scalars['Float']['output']>;
  /** id del curso */
  course_id?: Maybe<Scalars['Int']['output']>;
  /** nombre del curso */
  course_name?: Maybe<Scalars['String']['output']>;
  /** PORCENTAJE de avance del usuario en el curso (0–100) */
  course_progress?: Maybe<Scalars['Int']['output']>;
  /** calificación del curso por el usuario */
  course_score?: Maybe<Scalars['Int']['output']>;
  /** subcategoría del curso */
  course_subcategory?: Maybe<Scalars['String']['output']>;
  /** fecha de inscripción (ISO-8601) */
  enroll_date?: Maybe<Scalars['DateTime']['output']>;
  /** id de la inscripción */
  enroll_id?: Maybe<Scalars['Int']['output']>;
  /** bandera: certificado de participación */
  has_participation_certificate?: Maybe<Scalars['Boolean']['output']>;
  /** bandera: inscripción asignada desde panel B2B */
  is_admin_assigned?: Maybe<Scalars['Boolean']['output']>;
  /** bandera: obtuvo certificado de evaluación */
  is_certified?: Maybe<Scalars['Boolean']['output']>;
  /** bandera: curso completado (progreso = 100) */
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  /** bandera: curso producido por Crehana */
  is_crehana?: Maybe<Scalars['Boolean']['output']>;
  /** bandera: inscripción activa */
  is_enroll_active?: Maybe<Scalars['Boolean']['output']>;
  /** fecha de la última acción (ISO-8601) */
  last_action_date?: Maybe<Scalars['DateTime']['output']>;
  /** fecha del certificado de participación (ISO-8601) */
  participation_certificate_date?: Maybe<Scalars['DateTime']['output']>;
  /** HORAS de progreso acumuladas (course_duration_hours × course_progress / 100) */
  progress_hours?: Maybe<Scalars['Float']['output']>;
  /** minutos de progreso acumulados (la misma magnitud que progress_hours, en minutos) */
  progress_minutes?: Maybe<Scalars['Float']['output']>;
  /** fecha del proyecto final (ISO-8601) */
  project_date?: Maybe<Scalars['DateTime']['output']>;
  /** estado del proyecto final */
  project_status?: Maybe<Scalars['String']['output']>;
  /** cantidad de intentos de evaluación */
  quiz_attempts?: Maybe<Scalars['Int']['output']>;
  /** resultado porcentual del mejor intento */
  quiz_result?: Maybe<Scalars['Float']['output']>;
  /** estado del mejor intento de evaluación */
  quiz_status?: Maybe<Scalars['String']['output']>;
  /** fecha de inicio del curso (ISO-8601) */
  start_date?: Maybe<Scalars['DateTime']['output']>;
  /** respuestas correctas (mejor intento) */
  total_correct_answer?: Maybe<Scalars['Int']['output']>;
  /** total de preguntas (mejor intento) */
  total_questions?: Maybe<Scalars['Int']['output']>;
  /** segundos efectivos de reproducción */
  total_watch_seconds?: Maybe<Scalars['Int']['output']>;
  /** respuestas incorrectas (mejor intento) */
  total_wrong_answer?: Maybe<Scalars['Int']['output']>;
  /** URL del certificado de evaluación */
  url_certificate?: Maybe<Scalars['String']['output']>;
  /** URL del certificado de participación */
  url_participation_certificate?: Maybe<Scalars['String']['output']>;
  /** id del usuario inscrito */
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type CopilotAnalyticsLearningCourseFilterInput = {
  /** Filtra por course_duration >. */
  course_duration_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_duration >=. */
  course_duration_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_duration <. */
  course_duration_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_duration <=. */
  course_duration_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_id (pertenece al conjunto). */
  course_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por course_name (contiene texto, case-insensitive). */
  course_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por course_provider (igualdad). */
  course_provider?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por has_certification_available (igualdad). */
  has_certification_available?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_active (igualdad). */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_crehana (igualdad). */
  is_crehana?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_mandatory (igualdad). */
  is_mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_third_party (igualdad). */
  is_third_party?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CopilotAnalyticsLearningCourseGroupByEnum {
  CourseProvider = 'COURSE_PROVIDER',
  IsActive = 'IS_ACTIVE',
  IsCrehana = 'IS_CREHANA',
  IsMandatory = 'IS_MANDATORY',
  IsThirdParty = 'IS_THIRD_PARTY',
  State = 'STATE'
}

/** Catálogo de cursos disponibles para la organización, con metadata de proveedor y configuración académica. Una fila por curso (course_id). Incluye los cursos propios de la organización y el catálogo compartido de Crehana. course_duration está en SEGUNDOS. Esta tabla NO expone categoría, nivel, idioma, skill ni dominio: para segmentar cursos por esos atributos hace falta otra fuente. Es el CATÁLOGO, no las inscripciones: para saber qué cursos tiene gente inscrita usá learning_course_enrollments. */
export type CopilotAnalyticsLearningCourseType = {
  __typename?: 'CopilotAnalyticsLearningCourseType';
  /** duración del curso en SEGUNDOS */
  course_duration?: Maybe<Scalars['Int']['output']>;
  /** id del curso */
  course_id?: Maybe<Scalars['Int']['output']>;
  /** nombre del curso */
  course_name?: Maybe<Scalars['String']['output']>;
  /** proveedor (OWN_COURSE, THIRD_PARTY_COURSE, CREHANA_COURSE) */
  course_provider?: Maybe<Scalars['String']['output']>;
  /** bandera: certificación disponible para el curso */
  has_certification_available?: Maybe<Scalars['Boolean']['output']>;
  /** bandera: curso activo */
  is_active?: Maybe<Scalars['Boolean']['output']>;
  /** bandera: curso producido por Crehana */
  is_crehana?: Maybe<Scalars['Boolean']['output']>;
  /** bandera: curso obligatorio (config studio) */
  is_mandatory?: Maybe<Scalars['Boolean']['output']>;
  /** bandera: curso de proveedor externo */
  is_third_party?: Maybe<Scalars['Boolean']['output']>;
  /** URL de la imagen promocional */
  promo_image?: Maybe<Scalars['String']['output']>;
  /** estado de la configuración del curso en studio */
  state?: Maybe<Scalars['String']['output']>;
};

export type CopilotAnalyticsLearningLiveSessionFilterInput = {
  /** Filtra por created_by (igualdad). */
  created_by?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por created_by (pertenece al conjunto). */
  created_by_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por created_date en el rango de días [start, end] inclusivo. */
  created_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por created_date >= este día (YYYY-MM-DD). */
  created_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por created_date <= este día (YYYY-MM-DD). */
  created_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por description (contiene texto, case-insensitive). */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por end_date en el rango de días [start, end] inclusivo. */
  end_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por end_date >= este día (YYYY-MM-DD). */
  end_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por end_date <= este día (YYYY-MM-DD). */
  end_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por location (contiene texto, case-insensitive). */
  location_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por session_id (pertenece al conjunto). */
  session_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por session_status (igualdad). */
  session_status?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por session_title (contiene texto, case-insensitive). */
  session_title_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por session_type (igualdad). */
  session_type?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por start_date en el rango de días [start, end] inclusivo. */
  start_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por start_date >= este día (YYYY-MM-DD). */
  start_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por start_date <= este día (YYYY-MM-DD). */
  start_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por updated_date en el rango de días [start, end] inclusivo. */
  updated_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por updated_date >= este día (YYYY-MM-DD). */
  updated_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por updated_date <= este día (YYYY-MM-DD). */
  updated_date_lte?: InputMaybe<Scalars['Date']['input']>;
};

export enum CopilotAnalyticsLearningLiveSessionGroupByEnum {
  SessionStatus = 'SESSION_STATUS',
  SessionType = 'SESSION_TYPE'
}

/** Sesión de formación en vivo/sincrónica de la organización, con agenda, estado y metadata de ubicación. Una fila por sesión (session_id). */
export type CopilotAnalyticsLearningLiveSessionType = {
  __typename?: 'CopilotAnalyticsLearningLiveSessionType';
  /** id del usuario que creó la sesión */
  created_by?: Maybe<Scalars['Int']['output']>;
  /** fecha de creación (ISO-8601) */
  created_date?: Maybe<Scalars['DateTime']['output']>;
  /** descripción de la sesión */
  description?: Maybe<Scalars['String']['output']>;
  /** fecha/hora de fin (ISO-8601) */
  end_date?: Maybe<Scalars['DateTime']['output']>;
  /** ubicación de la sesión */
  location?: Maybe<Scalars['String']['output']>;
  /** id de la sesión en vivo */
  session_id?: Maybe<Scalars['Int']['output']>;
  /** estado de la sesión */
  session_status?: Maybe<Scalars['String']['output']>;
  /** título de la sesión */
  session_title?: Maybe<Scalars['String']['output']>;
  /** tipo de sesión */
  session_type?: Maybe<Scalars['String']['output']>;
  /** fecha/hora de inicio (ISO-8601) */
  start_date?: Maybe<Scalars['DateTime']['output']>;
  /** zona horaria de la sesión */
  time_zone?: Maybe<Scalars['String']['output']>;
  /** fecha de última actualización (ISO-8601) */
  updated_date?: Maybe<Scalars['DateTime']['output']>;
};

export type CopilotAnalyticsLearningLiveSessionUserFilterInput = {
  /** Filtra por created_date en el rango de días [start, end] inclusivo. */
  created_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por created_date >= este día (YYYY-MM-DD). */
  created_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por created_date <= este día (YYYY-MM-DD). */
  created_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por has_confirmation_external (igualdad). */
  has_confirmation_external?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por has_participated (igualdad). */
  has_participated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por register_method (igualdad). */
  register_method?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por session_id (igualdad). */
  session_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por session_id (pertenece al conjunto). */
  session_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por session_user_id (pertenece al conjunto). */
  session_user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por updated_date en el rango de días [start, end] inclusivo. */
  updated_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por updated_date >= este día (YYYY-MM-DD). */
  updated_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por updated_date <= este día (YYYY-MM-DD). */
  updated_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por user_status (igualdad). */
  user_status?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_type (igualdad). */
  user_type?: InputMaybe<Scalars['String']['input']>;
};

export enum CopilotAnalyticsLearningLiveSessionUserGroupByEnum {
  HasConfirmationExternal = 'HAS_CONFIRMATION_EXTERNAL',
  HasParticipated = 'HAS_PARTICIPATED',
  RegisterMethod = 'REGISTER_METHOD',
  UserStatus = 'USER_STATUS',
  UserType = 'USER_TYPE'
}

/** Inscripción/asistencia de un usuario a una sesión en vivo. Una fila por relación usuario-sesión (session_user_id). */
export type CopilotAnalyticsLearningLiveSessionUserType = {
  __typename?: 'CopilotAnalyticsLearningLiveSessionUserType';
  /** fecha de creación (ISO-8601) */
  created_date?: Maybe<Scalars['DateTime']['output']>;
  /** bandera: confirmó asistencia externa */
  has_confirmation_external?: Maybe<Scalars['Boolean']['output']>;
  /** bandera: participó en la sesión */
  has_participated?: Maybe<Scalars['Boolean']['output']>;
  /** método de registro a la sesión */
  register_method?: Maybe<Scalars['String']['output']>;
  /** id de la sesión en vivo */
  session_id?: Maybe<Scalars['Int']['output']>;
  /** id de la relación usuario-sesión */
  session_user_id?: Maybe<Scalars['Int']['output']>;
  /** fecha de última actualización (ISO-8601) */
  updated_date?: Maybe<Scalars['DateTime']['output']>;
  /** id del usuario */
  user_id?: Maybe<Scalars['Int']['output']>;
  /** estado del usuario en la sesión */
  user_status?: Maybe<Scalars['String']['output']>;
  /** tipo de usuario en la sesión */
  user_type?: Maybe<Scalars['String']['output']>;
};

export enum CopilotAnalyticsLearningProgressHourAggregateColumnEnum {
  PlayedLectures = 'PLAYED_LECTURES',
  PlayedSeconds = 'PLAYED_SECONDS',
  ProgressHour = 'PROGRESS_HOUR',
  ProgressSeconds = 'PROGRESS_SECONDS'
}

export type CopilotAnalyticsLearningProgressHourFilterInput = {
  /** Filtra por course_id (igualdad). */
  course_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_id (pertenece al conjunto). */
  course_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por course_lectures >. */
  course_lectures_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_lectures >=. */
  course_lectures_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_lectures <. */
  course_lectures_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_lectures <=. */
  course_lectures_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por event_hour en el rango de días [start, end] inclusivo. */
  event_hour_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por event_hour >= este día (YYYY-MM-DD). */
  event_hour_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por event_hour <= este día (YYYY-MM-DD). */
  event_hour_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por played_lectures >. */
  played_lectures_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por played_lectures >=. */
  played_lectures_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por played_lectures <. */
  played_lectures_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por played_lectures <=. */
  played_lectures_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por played_seconds >. */
  played_seconds_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por played_seconds >=. */
  played_seconds_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por played_seconds <. */
  played_seconds_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por played_seconds <=. */
  played_seconds_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_hour >. */
  progress_hour_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_hour >=. */
  progress_hour_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_hour <. */
  progress_hour_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_hour <=. */
  progress_hour_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_seconds >. */
  progress_seconds_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_seconds >=. */
  progress_seconds_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_seconds <. */
  progress_seconds_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_seconds <=. */
  progress_seconds_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum CopilotAnalyticsLearningProgressHourGroupByEnum {
  CourseId = 'COURSE_ID'
}

/** Evento de horas de estudio de un usuario en un curso. Una fila por evento. La tabla no tiene columna de organización: se scopea por pertenencia (solo usuarios de la organización). progress_hour está en HORAS; played_seconds/progress_seconds en SEGUNDOS. */
export type CopilotAnalyticsLearningProgressHourType = {
  __typename?: 'CopilotAnalyticsLearningProgressHourType';
  /** duración del curso (segundos) */
  course_duration?: Maybe<Scalars['Float']['output']>;
  /** id del curso */
  course_id?: Maybe<Scalars['Int']['output']>;
  /** cantidad de clases del curso */
  course_lectures?: Maybe<Scalars['Int']['output']>;
  /** timestamp del evento (UTC, ISO-8601) */
  event_hour?: Maybe<Scalars['DateTime']['output']>;
  /** id del evento de horas de estudio */
  id?: Maybe<Scalars['String']['output']>;
  /** cantidad de clases reproducidas */
  played_lectures?: Maybe<Scalars['Int']['output']>;
  /** segundos efectivos reproducidos */
  played_seconds?: Maybe<Scalars['Float']['output']>;
  /** horas de progreso acumuladas (HORAS) */
  progress_hour?: Maybe<Scalars['Float']['output']>;
  /** segundos de progreso acumulados */
  progress_seconds?: Maybe<Scalars['Float']['output']>;
  /** id del usuario */
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type CopilotAnalyticsLearningQuizAttemptFilterInput = {
  /** Filtra por approval_percentage >. */
  approval_percentage_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por approval_percentage >=. */
  approval_percentage_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por approval_percentage <. */
  approval_percentage_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por approval_percentage <=. */
  approval_percentage_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por course_id (igualdad). */
  course_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_id (pertenece al conjunto). */
  course_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por created_date en el rango de días [start, end] inclusivo. */
  created_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por created_date >= este día (YYYY-MM-DD). */
  created_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por created_date <= este día (YYYY-MM-DD). */
  created_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por enroll_id (igualdad). */
  enroll_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por enroll_id (pertenece al conjunto). */
  enroll_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por evaluation_type (igualdad). */
  evaluation_type?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por is_best_attempt (igualdad). */
  is_best_attempt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_last_attempt (igualdad). */
  is_last_attempt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por quiz_attempts >. */
  quiz_attempts_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_attempts >=. */
  quiz_attempts_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_attempts <. */
  quiz_attempts_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_attempts <=. */
  quiz_attempts_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_id (igualdad). */
  quiz_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_id (pertenece al conjunto). */
  quiz_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por quiz_status (igualdad). */
  quiz_status?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por quiz_title (contiene texto, case-insensitive). */
  quiz_title_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por quiz_type (igualdad). */
  quiz_type?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por result >. */
  result_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por result >=. */
  result_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por result <. */
  result_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por result <=. */
  result_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_correct_answer >. */
  total_correct_answer_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por total_correct_answer >=. */
  total_correct_answer_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por total_correct_answer <. */
  total_correct_answer_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por total_correct_answer <=. */
  total_correct_answer_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por total_questions >. */
  total_questions_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por total_questions >=. */
  total_questions_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por total_questions <. */
  total_questions_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por total_questions <=. */
  total_questions_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por total_seconds >. */
  total_seconds_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_seconds >=. */
  total_seconds_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_seconds <. */
  total_seconds_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_seconds <=. */
  total_seconds_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_wrong_answer >. */
  total_wrong_answer_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por total_wrong_answer >=. */
  total_wrong_answer_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por total_wrong_answer <. */
  total_wrong_answer_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por total_wrong_answer <=. */
  total_wrong_answer_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_email (contiene texto, case-insensitive). */
  user_email_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por user_name (contiene texto, case-insensitive). */
  user_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_quiz_form_id (pertenece al conjunto). */
  user_quiz_form_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum CopilotAnalyticsLearningQuizAttemptGroupByEnum {
  CourseId = 'COURSE_ID',
  EvaluationType = 'EVALUATION_TYPE',
  IsBestAttempt = 'IS_BEST_ATTEMPT',
  IsLastAttempt = 'IS_LAST_ATTEMPT',
  QuizStatus = 'QUIZ_STATUS',
  QuizTitle = 'QUIZ_TITLE',
  QuizType = 'QUIZ_TYPE'
}

/** Intento de evaluación de un usuario en un curso B2B, con métricas de desempeño, estado y configuración por intento. Una fila por intento (user_quiz_form_id). Usa is_best_attempt = true para el mejor intento e is_last_attempt = true para el último. result es porcentaje o puntaje según el método de aprobación. */
export type CopilotAnalyticsLearningQuizAttemptType = {
  __typename?: 'CopilotAnalyticsLearningQuizAttemptType';
  /** % mínimo de aprobación configurado */
  approval_percentage?: Maybe<Scalars['Float']['output']>;
  /** orden cronológico del intento (1 = primero) */
  attempts_order?: Maybe<Scalars['Int']['output']>;
  /** id del curso al que pertenece la evaluación */
  course_id?: Maybe<Scalars['Int']['output']>;
  /** fecha de creación del intento (ISO-8601) */
  created_date?: Maybe<Scalars['DateTime']['output']>;
  /** id de la inscripción relacionada */
  enroll_id?: Maybe<Scalars['Int']['output']>;
  /** alcance de la evaluación (Final / Clase) */
  evaluation_type?: Maybe<Scalars['String']['output']>;
  /** bandera: es el mejor intento del usuario */
  is_best_attempt?: Maybe<Scalars['Boolean']['output']>;
  /** bandera: es el último intento del usuario */
  is_last_attempt?: Maybe<Scalars['Boolean']['output']>;
  /** total de intentos del usuario en esta evaluación */
  quiz_attempts?: Maybe<Scalars['Int']['output']>;
  /** id de la evaluación */
  quiz_id?: Maybe<Scalars['Int']['output']>;
  /** estado del intento (Aprobado, Desaprobado, Certificado, En progreso, ...) */
  quiz_status?: Maybe<Scalars['String']['output']>;
  /** título de la evaluación */
  quiz_title?: Maybe<Scalars['String']['output']>;
  /** clasificación académica (Formativa / Sumativa) */
  quiz_type?: Maybe<Scalars['String']['output']>;
  /** resultado como % o puntaje según el método de aprobación configurado */
  result?: Maybe<Scalars['Float']['output']>;
  /** límite de tiempo configurado (ej. '30 mins' o 'sin limite') */
  time_limit?: Maybe<Scalars['String']['output']>;
  /** respuestas correctas */
  total_correct_answer?: Maybe<Scalars['Int']['output']>;
  /** total de preguntas en el intento */
  total_questions?: Maybe<Scalars['Int']['output']>;
  /** tiempo total dedicado al intento en segundos */
  total_seconds?: Maybe<Scalars['Float']['output']>;
  /** respuestas incorrectas */
  total_wrong_answer?: Maybe<Scalars['Int']['output']>;
  /** correo electrónico del usuario */
  user_email?: Maybe<Scalars['String']['output']>;
  /** id del usuario que realizó el intento */
  user_id?: Maybe<Scalars['Int']['output']>;
  /** nombre completo del usuario */
  user_name?: Maybe<Scalars['String']['output']>;
  /** id único del intento de evaluación */
  user_quiz_form_id?: Maybe<Scalars['Int']['output']>;
};

export type CopilotAnalyticsLearningQuizResponseFilterInput = {
  /** Filtra por answer_date en el rango de días [start, end] inclusivo. */
  answer_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por answer_date >= este día (YYYY-MM-DD). */
  answer_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por answer_date <= este día (YYYY-MM-DD). */
  answer_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por answer_id (pertenece al conjunto). */
  answer_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por answer_text (contiene texto, case-insensitive). */
  answer_text_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por is_correct (igualdad). */
  is_correct?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por question_text (contiene texto, case-insensitive). */
  question_text_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por question_type (igualdad). */
  question_type?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_email (contiene texto, case-insensitive). */
  user_email_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por user_name (contiene texto, case-insensitive). */
  user_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_quiz_form_id (pertenece al conjunto). */
  user_quiz_form_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum CopilotAnalyticsLearningQuizResponseGroupByEnum {
  IsCorrect = 'IS_CORRECT',
  QuestionType = 'QUESTION_TYPE'
}

/** Respuesta individual de un usuario a una pregunta de evaluación. Una fila por respuesta; se une a learning_quiz_attempts por user_quiz_form_id. */
export type CopilotAnalyticsLearningQuizResponseType = {
  __typename?: 'CopilotAnalyticsLearningQuizResponseType';
  /** fecha de la respuesta (ISO-8601) */
  answer_date?: Maybe<Scalars['DateTime']['output']>;
  /** id de la respuesta */
  answer_id?: Maybe<Scalars['Int']['output']>;
  /** texto de la respuesta del usuario */
  answer_text?: Maybe<Scalars['String']['output']>;
  /** bandera: la respuesta es correcta */
  is_correct?: Maybe<Scalars['Boolean']['output']>;
  /** texto de la pregunta */
  question_text?: Maybe<Scalars['String']['output']>;
  /** tipo de pregunta */
  question_type?: Maybe<Scalars['String']['output']>;
  /** correo electrónico del usuario */
  user_email?: Maybe<Scalars['String']['output']>;
  /** id del usuario */
  user_id?: Maybe<Scalars['Int']['output']>;
  /** nombre completo del usuario */
  user_name?: Maybe<Scalars['String']['output']>;
  /** id del formulario/intento de evaluación */
  user_quiz_form_id?: Maybe<Scalars['Int']['output']>;
};

export type CopilotAnalyticsLearningRouteFilterInput = {
  /** Filtra por certificates_required >. */
  certificates_required_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por certificates_required >=. */
  certificates_required_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por certificates_required <. */
  certificates_required_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por certificates_required <=. */
  certificates_required_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_required >. */
  courses_required_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_required >=. */
  courses_required_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_required <. */
  courses_required_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_required <=. */
  courses_required_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por end_date en el rango de días [start, end] inclusivo. */
  end_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por end_date >= este día (YYYY-MM-DD). */
  end_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por end_date <= este día (YYYY-MM-DD). */
  end_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por has_reward (igualdad). */
  has_reward?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por has_skill (igualdad). */
  has_skill?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_hidden (igualdad). */
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por route_id (pertenece al conjunto). */
  route_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por route_name (contiene texto, case-insensitive). */
  route_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por start_date en el rango de días [start, end] inclusivo. */
  start_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por start_date >= este día (YYYY-MM-DD). */
  start_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por start_date <= este día (YYYY-MM-DD). */
  start_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por student_courses_completed >. */
  student_courses_completed_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por student_courses_completed >=. */
  student_courses_completed_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por student_courses_completed <. */
  student_courses_completed_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por student_courses_completed <=. */
  student_courses_completed_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por student_route_completed >. */
  student_route_completed_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por student_route_completed >=. */
  student_route_completed_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por student_route_completed <. */
  student_route_completed_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por student_route_completed <=. */
  student_route_completed_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por students_registered >. */
  students_registered_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por students_registered >=. */
  students_registered_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por students_registered <. */
  students_registered_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por students_registered <=. */
  students_registered_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por version (igualdad). */
  version?: InputMaybe<Scalars['String']['input']>;
};

export enum CopilotAnalyticsLearningRouteGroupByEnum {
  HasReward = 'HAS_REWARD',
  HasSkill = 'HAS_SKILL',
  IsHidden = 'IS_HIDDEN',
  Version = 'VERSION'
}

/** Ruta de aprendizaje de la organización con sus métricas agregadas de progreso (usuarios inscritos, cursos completados/certificados). Una fila por ruta (route_id). Incluye rutas ocultas: el dashboard las excluye, así que para reconciliar con él hay que filtrar is_hidden = false. */
export type CopilotAnalyticsLearningRouteType = {
  __typename?: 'CopilotAnalyticsLearningRouteType';
  /** certificados requeridos para completar */
  certificates_required?: Maybe<Scalars['Int']['output']>;
  /** cursos requeridos para completar la ruta */
  courses_required?: Maybe<Scalars['Int']['output']>;
  /** fecha de fin de la ruta (ISO-8601) */
  end_date?: Maybe<Scalars['DateTime']['output']>;
  /** plazo/fecha de expiración como texto (ej. '30 días', 'sin deadline') */
  expiration_date?: Maybe<Scalars['String']['output']>;
  /** bandera: la ruta otorga una recompensa */
  has_reward?: Maybe<Scalars['Boolean']['output']>;
  /** bandera: la ruta otorga un skill al completarse */
  has_skill?: Maybe<Scalars['Boolean']['output']>;
  /** bandera: ruta oculta para los usuarios */
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  /** id de la ruta de aprendizaje */
  route_id?: Maybe<Scalars['Int']['output']>;
  /** nombre de la ruta */
  route_name?: Maybe<Scalars['String']['output']>;
  /** fecha de inicio de la ruta (ISO-8601) */
  start_date?: Maybe<Scalars['DateTime']['output']>;
  /** usuarios que completaron al menos un curso de la ruta */
  student_courses_completed?: Maybe<Scalars['Int']['output']>;
  /** usuarios que completaron la ruta */
  student_route_completed?: Maybe<Scalars['Int']['output']>;
  /** total de usuarios inscritos en la ruta */
  students_registered?: Maybe<Scalars['Int']['output']>;
  /** versión de la ruta (version_1 / version_2) */
  version?: Maybe<Scalars['String']['output']>;
};

export type CopilotAnalyticsLearningRouteUserFilterInput = {
  /** Filtra por approved_quizzes >. */
  approved_quizzes_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por approved_quizzes >=. */
  approved_quizzes_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por approved_quizzes <. */
  approved_quizzes_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por approved_quizzes <=. */
  approved_quizzes_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por assigned_date en el rango de días [start, end] inclusivo. */
  assigned_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por assigned_date >= este día (YYYY-MM-DD). */
  assigned_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por assigned_date <= este día (YYYY-MM-DD). */
  assigned_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por certificates_progress >. */
  certificates_progress_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por certificates_progress >=. */
  certificates_progress_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por certificates_progress <. */
  certificates_progress_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por certificates_progress <=. */
  certificates_progress_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por completed_date en el rango de días [start, end] inclusivo. */
  completed_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por completed_date >= este día (YYYY-MM-DD). */
  completed_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por completed_date <= este día (YYYY-MM-DD). */
  completed_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por courses_assigned >. */
  courses_assigned_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_assigned >=. */
  courses_assigned_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_assigned <. */
  courses_assigned_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_assigned <=. */
  courses_assigned_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_certified >. */
  courses_certified_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_certified >=. */
  courses_certified_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_certified <. */
  courses_certified_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_certified <=. */
  courses_certified_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_completed >. */
  courses_completed_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_completed >=. */
  courses_completed_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_completed <. */
  courses_completed_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_completed <=. */
  courses_completed_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_progress >. */
  courses_progress_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_progress >=. */
  courses_progress_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_progress <. */
  courses_progress_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_progress <=. */
  courses_progress_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_required >. */
  courses_required_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_required >=. */
  courses_required_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_required <. */
  courses_required_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_required <=. */
  courses_required_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por end_date en el rango de días [start, end] inclusivo. */
  end_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por end_date >= este día (YYYY-MM-DD). */
  end_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por end_date <= este día (YYYY-MM-DD). */
  end_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por expiration_date en el rango de días [start, end] inclusivo. */
  expiration_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por expiration_date >= este día (YYYY-MM-DD). */
  expiration_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por expiration_date <= este día (YYYY-MM-DD). */
  expiration_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por is_completed (igualdad). */
  is_completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por project_certified >. */
  project_certified_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por project_certified >=. */
  project_certified_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por project_certified <. */
  project_certified_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por project_certified <=. */
  project_certified_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por registered_by (igualdad). */
  registered_by?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por route_id (igualdad). */
  route_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por route_id (pertenece al conjunto). */
  route_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por route_name (contiene texto, case-insensitive). */
  route_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por route_progress >. */
  route_progress_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por route_progress >=. */
  route_progress_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por route_progress <. */
  route_progress_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por route_progress <=. */
  route_progress_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por user_name (contiene texto, case-insensitive). */
  user_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_route_id (pertenece al conjunto). */
  user_route_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por user_status (igualdad). */
  user_status?: InputMaybe<Scalars['String']['input']>;
};

export enum CopilotAnalyticsLearningRouteUserGroupByEnum {
  IsCompleted = 'IS_COMPLETED',
  RegisteredBy = 'REGISTERED_BY',
  RouteName = 'ROUTE_NAME',
  UserStatus = 'USER_STATUS'
}

/** Progreso individual de un usuario dentro de una ruta de aprendizaje (cursos asignados/completados/certificados y % de avance). Una fila por relación usuario-ruta. courses_progress/certificates_progress/route_progress son PORCENTAJES (0–100). */
export type CopilotAnalyticsLearningRouteUserType = {
  __typename?: 'CopilotAnalyticsLearningRouteUserType';
  /** evaluaciones aprobadas o certificadas */
  approved_quizzes?: Maybe<Scalars['Int']['output']>;
  /** fecha de inscripción en la ruta (ISO-8601) */
  assigned_date?: Maybe<Scalars['DateTime']['output']>;
  /** PORCENTAJE de progreso por certificados requeridos (0–100), null si no aplica */
  certificates_progress?: Maybe<Scalars['Int']['output']>;
  /** fecha en que completó la ruta (ISO-8601) */
  completed_date?: Maybe<Scalars['DateTime']['output']>;
  /** cursos activos asignados al usuario */
  courses_assigned?: Maybe<Scalars['Int']['output']>;
  /** cursos con certificado obtenido */
  courses_certified?: Maybe<Scalars['Int']['output']>;
  /** cursos completados por el usuario (100%) */
  courses_completed?: Maybe<Scalars['Int']['output']>;
  /** PORCENTAJE de progreso por cursos requeridos (0–100), null si no aplica */
  courses_progress?: Maybe<Scalars['Int']['output']>;
  /** cursos requeridos para completar la ruta */
  courses_required?: Maybe<Scalars['Int']['output']>;
  /** URL de la imagen de portada de la ruta */
  cover_image_url?: Maybe<Scalars['String']['output']>;
  /** fecha de fin de la ruta (ISO-8601) */
  end_date?: Maybe<Scalars['DateTime']['output']>;
  /** fecha de expiración de la membresía (ISO-8601) */
  expiration_date?: Maybe<Scalars['DateTime']['output']>;
  /** bandera: el usuario completó la ruta */
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  /** tiempo de progreso acumulado en horas */
  progress_in_hours?: Maybe<Scalars['Int']['output']>;
  /** proyectos finales certificados en la ruta */
  project_certified?: Maybe<Scalars['Int']['output']>;
  /** fuente de registro del usuario en la ruta */
  registered_by?: Maybe<Scalars['String']['output']>;
  /** id de la ruta de aprendizaje */
  route_id?: Maybe<Scalars['Int']['output']>;
  /** nombre de la ruta */
  route_name?: Maybe<Scalars['String']['output']>;
  /** PORCENTAJE de progreso global en la ruta (0–100) */
  route_progress?: Maybe<Scalars['Int']['output']>;
  /** id del usuario inscrito en la ruta */
  user_id?: Maybe<Scalars['Int']['output']>;
  /** nombre completo del usuario */
  user_name?: Maybe<Scalars['String']['output']>;
  /** id de la relación usuario-ruta */
  user_route_id?: Maybe<Scalars['Int']['output']>;
  /** estado del usuario (PENDIENTE, ACTIVO, INACTIVO, ELIMINADO) */
  user_status?: Maybe<Scalars['String']['output']>;
};

export type CopilotAnalyticsLearningUserCourseRouteFilterInput = {
  /** Filtra por course_id (igualdad). */
  course_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_id (pertenece al conjunto). */
  course_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por is_active (igualdad). */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_hidden (igualdad). */
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por route_id (igualdad). */
  route_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por route_id (pertenece al conjunto). */
  route_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por route_name (contiene texto, case-insensitive). */
  route_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum CopilotAnalyticsLearningUserCourseRouteGroupByEnum {
  CourseId = 'COURSE_ID',
  IsActive = 'IS_ACTIVE',
  IsHidden = 'IS_HIDDEN',
  RouteId = 'ROUTE_ID',
  RouteName = 'ROUTE_NAME'
}

/** Relación ruta↔usuario↔curso: qué cursos de qué rutas tiene asignado cada usuario. Una fila por combinación (route_id + user_id + course_id). Filtra siempre is_active = true (curso activo dentro de la ruta), el mismo predicado que aplican el reporte general y el dashboard. */
export type CopilotAnalyticsLearningUserCourseRouteType = {
  __typename?: 'CopilotAnalyticsLearningUserCourseRouteType';
  /** id del curso dentro de la ruta */
  course_id?: Maybe<Scalars['Int']['output']>;
  /** bandera: curso activo dentro de la ruta */
  is_active?: Maybe<Scalars['Boolean']['output']>;
  /** bandera: ruta oculta para los usuarios */
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  /** id de la ruta de aprendizaje */
  route_id?: Maybe<Scalars['Int']['output']>;
  /** nombre de la ruta */
  route_name?: Maybe<Scalars['String']['output']>;
  /** id del usuario */
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type CopilotAnalyticsLearningUserWorkTeamFilterInput = {
  /** Filtra por created_date en el rango de días [start, end] inclusivo. */
  created_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por created_date >= este día (YYYY-MM-DD). */
  created_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por created_date <= este día (YYYY-MM-DD). */
  created_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por is_lead (igualdad). */
  is_lead?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por status (igualdad). */
  status?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por user_workteam_id (pertenece al conjunto). */
  user_workteam_id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por workteam_created_date en el rango de días [start, end] inclusivo. */
  workteam_created_date_between?: InputMaybe<CopilotAnalyticsDateBetween>;
  /** Filtra por workteam_created_date >= este día (YYYY-MM-DD). */
  workteam_created_date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por workteam_created_date <= este día (YYYY-MM-DD). */
  workteam_created_date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Filtra por workteam_id (igualdad). */
  workteam_id?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por workteam_id (pertenece al conjunto). */
  workteam_id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por workteam_is_active (igualdad). */
  workteam_is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por workteam_name (contiene texto, case-insensitive). */
  workteam_name_contains?: InputMaybe<Scalars['String']['input']>;
};

export enum CopilotAnalyticsLearningUserWorkTeamGroupByEnum {
  IsLead = 'IS_LEAD',
  Status = 'STATUS',
  WorkteamId = 'WORKTEAM_ID',
  WorkteamIsActive = 'WORKTEAM_IS_ACTIVE',
  WorkteamName = 'WORKTEAM_NAME'
}

/** Pertenencia de un usuario a un equipo de trabajo de la organización, con rol de líder y estado. Una fila por relación usuario-equipo. */
export type CopilotAnalyticsLearningUserWorkTeamType = {
  __typename?: 'CopilotAnalyticsLearningUserWorkTeamType';
  /** fecha de creación de la relación (ISO-8601) */
  created_date?: Maybe<Scalars['DateTime']['output']>;
  /** bandera: el usuario es líder del equipo */
  is_lead?: Maybe<Scalars['Boolean']['output']>;
  /** código de estado de la relación */
  status?: Maybe<Scalars['Int']['output']>;
  /** id del usuario */
  user_id?: Maybe<Scalars['Int']['output']>;
  /** id de la relación usuario-equipo */
  user_workteam_id?: Maybe<Scalars['String']['output']>;
  /** fecha de creación del equipo (ISO-8601) */
  workteam_created_date?: Maybe<Scalars['DateTime']['output']>;
  /** id del equipo de trabajo */
  workteam_id?: Maybe<Scalars['String']['output']>;
  /** bandera: equipo de trabajo activo */
  workteam_is_active?: Maybe<Scalars['Boolean']['output']>;
  /** nombre del equipo de trabajo */
  workteam_name?: Maybe<Scalars['String']['output']>;
};

/** Input del listado paginado de hris_daily_logins. */
export type CopilotAnalyticsListHrisDailyLoginInput = {
  /** Centralized organization id (central_org_id) del que pide. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtros del listado. */
  filter?: InputMaybe<CopilotAnalyticsHrisDailyLoginFilterInput>;
  /** Paginación offset (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

export type CopilotAnalyticsListHrisDailyLoginPayload = {
  __typename?: 'CopilotAnalyticsListHrisDailyLoginPayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Filas de esta página. */
  items: Array<CopilotAnalyticsHrisDailyLoginType>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Total de filas que matchean (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsListHrisDailyLoginResult = CopilotAnalyticsListHrisDailyLoginPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input del listado paginado de hris_organizations. */
export type CopilotAnalyticsListHrisOrganizationInput = {
  /** Centralized organization id (central_org_id) del que pide. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtros del listado. */
  filter?: InputMaybe<CopilotAnalyticsHrisOrganizationFilterInput>;
  /** Paginación offset (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

export type CopilotAnalyticsListHrisOrganizationPayload = {
  __typename?: 'CopilotAnalyticsListHrisOrganizationPayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Filas de esta página. */
  items: Array<CopilotAnalyticsHrisOrganizationType>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Total de filas que matchean (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsListHrisOrganizationResult = CopilotAnalyticsListHrisOrganizationPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input del listado paginado de hris_user_area_levels. */
export type CopilotAnalyticsListHrisUserAreaLevelInput = {
  /** Centralized organization id (central_org_id) del que pide. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtros del listado. */
  filter?: InputMaybe<CopilotAnalyticsHrisUserAreaLevelFilterInput>;
  /** Paginación offset (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

export type CopilotAnalyticsListHrisUserAreaLevelPayload = {
  __typename?: 'CopilotAnalyticsListHrisUserAreaLevelPayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Filas de esta página. */
  items: Array<CopilotAnalyticsHrisUserAreaLevelType>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Total de filas que matchean (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsListHrisUserAreaLevelResult = CopilotAnalyticsListHrisUserAreaLevelPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input del listado paginado de hris_user_custom_fields. */
export type CopilotAnalyticsListHrisUserCustomFieldInput = {
  /** Centralized organization id (central_org_id) del que pide. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtros del listado. */
  filter?: InputMaybe<CopilotAnalyticsHrisUserCustomFieldFilterInput>;
  /** Paginación offset (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

export type CopilotAnalyticsListHrisUserCustomFieldPayload = {
  __typename?: 'CopilotAnalyticsListHrisUserCustomFieldPayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Filas de esta página. */
  items: Array<CopilotAnalyticsHrisUserCustomFieldType>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Total de filas que matchean (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsListHrisUserCustomFieldResult = CopilotAnalyticsListHrisUserCustomFieldPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input del listado paginado de hris_users. */
export type CopilotAnalyticsListHrisUserInput = {
  /** Centralized organization id (central_org_id) del que pide. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtros del listado. */
  filter?: InputMaybe<CopilotAnalyticsHrisUserFilterInput>;
  /** Paginación offset (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

export type CopilotAnalyticsListHrisUserPayload = {
  __typename?: 'CopilotAnalyticsListHrisUserPayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Filas de esta página. */
  items: Array<CopilotAnalyticsHrisUserType>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Total de filas que matchean (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsListHrisUserResult = CopilotAnalyticsListHrisUserPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input del listado paginado de learning_course_enrollments. */
export type CopilotAnalyticsListLearningCourseEnrollmentInput = {
  /** Filtros del listado. */
  filter?: InputMaybe<CopilotAnalyticsLearningCourseEnrollmentFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

export type CopilotAnalyticsListLearningCourseEnrollmentPayload = {
  __typename?: 'CopilotAnalyticsListLearningCourseEnrollmentPayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Filas de esta página. */
  items: Array<CopilotAnalyticsLearningCourseEnrollmentType>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Total de filas que matchean (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsListLearningCourseEnrollmentResult = CopilotAnalyticsListLearningCourseEnrollmentPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input del listado paginado de learning_courses. */
export type CopilotAnalyticsListLearningCourseInput = {
  /** Filtros del listado. */
  filter?: InputMaybe<CopilotAnalyticsLearningCourseFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

export type CopilotAnalyticsListLearningCoursePayload = {
  __typename?: 'CopilotAnalyticsListLearningCoursePayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Filas de esta página. */
  items: Array<CopilotAnalyticsLearningCourseType>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Total de filas que matchean (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsListLearningCourseResult = CopilotAnalyticsListLearningCoursePayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input del listado paginado de learning_live_sessions. */
export type CopilotAnalyticsListLearningLiveSessionInput = {
  /** Filtros del listado. */
  filter?: InputMaybe<CopilotAnalyticsLearningLiveSessionFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

export type CopilotAnalyticsListLearningLiveSessionPayload = {
  __typename?: 'CopilotAnalyticsListLearningLiveSessionPayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Filas de esta página. */
  items: Array<CopilotAnalyticsLearningLiveSessionType>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Total de filas que matchean (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsListLearningLiveSessionResult = CopilotAnalyticsListLearningLiveSessionPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input del listado paginado de learning_live_session_users. */
export type CopilotAnalyticsListLearningLiveSessionUserInput = {
  /** Filtros del listado. */
  filter?: InputMaybe<CopilotAnalyticsLearningLiveSessionUserFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

export type CopilotAnalyticsListLearningLiveSessionUserPayload = {
  __typename?: 'CopilotAnalyticsListLearningLiveSessionUserPayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Filas de esta página. */
  items: Array<CopilotAnalyticsLearningLiveSessionUserType>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Total de filas que matchean (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsListLearningLiveSessionUserResult = CopilotAnalyticsListLearningLiveSessionUserPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input del listado paginado de learning_progress_hours. */
export type CopilotAnalyticsListLearningProgressHourInput = {
  /** Filtros del listado. */
  filter?: InputMaybe<CopilotAnalyticsLearningProgressHourFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

export type CopilotAnalyticsListLearningProgressHourPayload = {
  __typename?: 'CopilotAnalyticsListLearningProgressHourPayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Filas de esta página. */
  items: Array<CopilotAnalyticsLearningProgressHourType>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Total de filas que matchean (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsListLearningProgressHourResult = CopilotAnalyticsListLearningProgressHourPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input del listado paginado de learning_quiz_attempts. */
export type CopilotAnalyticsListLearningQuizAttemptInput = {
  /** Filtros del listado. */
  filter?: InputMaybe<CopilotAnalyticsLearningQuizAttemptFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

export type CopilotAnalyticsListLearningQuizAttemptPayload = {
  __typename?: 'CopilotAnalyticsListLearningQuizAttemptPayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Filas de esta página. */
  items: Array<CopilotAnalyticsLearningQuizAttemptType>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Total de filas que matchean (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsListLearningQuizAttemptResult = CopilotAnalyticsListLearningQuizAttemptPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input del listado paginado de learning_quiz_responses. */
export type CopilotAnalyticsListLearningQuizResponseInput = {
  /** Filtros del listado. */
  filter?: InputMaybe<CopilotAnalyticsLearningQuizResponseFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

export type CopilotAnalyticsListLearningQuizResponsePayload = {
  __typename?: 'CopilotAnalyticsListLearningQuizResponsePayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Filas de esta página. */
  items: Array<CopilotAnalyticsLearningQuizResponseType>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Total de filas que matchean (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsListLearningQuizResponseResult = CopilotAnalyticsListLearningQuizResponsePayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input del listado paginado de learning_routes. */
export type CopilotAnalyticsListLearningRouteInput = {
  /** Filtros del listado. */
  filter?: InputMaybe<CopilotAnalyticsLearningRouteFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

export type CopilotAnalyticsListLearningRoutePayload = {
  __typename?: 'CopilotAnalyticsListLearningRoutePayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Filas de esta página. */
  items: Array<CopilotAnalyticsLearningRouteType>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Total de filas que matchean (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsListLearningRouteResult = CopilotAnalyticsListLearningRoutePayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input del listado paginado de learning_route_users. */
export type CopilotAnalyticsListLearningRouteUserInput = {
  /** Filtros del listado. */
  filter?: InputMaybe<CopilotAnalyticsLearningRouteUserFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

export type CopilotAnalyticsListLearningRouteUserPayload = {
  __typename?: 'CopilotAnalyticsListLearningRouteUserPayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Filas de esta página. */
  items: Array<CopilotAnalyticsLearningRouteUserType>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Total de filas que matchean (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsListLearningRouteUserResult = CopilotAnalyticsListLearningRouteUserPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input del listado paginado de learning_user_course_routes. */
export type CopilotAnalyticsListLearningUserCourseRouteInput = {
  /** Filtros del listado. */
  filter?: InputMaybe<CopilotAnalyticsLearningUserCourseRouteFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

export type CopilotAnalyticsListLearningUserCourseRoutePayload = {
  __typename?: 'CopilotAnalyticsListLearningUserCourseRoutePayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Filas de esta página. */
  items: Array<CopilotAnalyticsLearningUserCourseRouteType>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Total de filas que matchean (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsListLearningUserCourseRouteResult = CopilotAnalyticsListLearningUserCourseRoutePayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input del listado paginado de learning_user_work_teams. */
export type CopilotAnalyticsListLearningUserWorkTeamInput = {
  /** Filtros del listado. */
  filter?: InputMaybe<CopilotAnalyticsLearningUserWorkTeamFilterInput>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

export type CopilotAnalyticsListLearningUserWorkTeamPayload = {
  __typename?: 'CopilotAnalyticsListLearningUserWorkTeamPayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Filas de esta página. */
  items: Array<CopilotAnalyticsLearningUserWorkTeamType>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Total de filas que matchean (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsListLearningUserWorkTeamResult = CopilotAnalyticsListLearningUserWorkTeamPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CopilotAnalyticsMutation = {
  __typename?: 'CopilotAnalyticsMutation';
  /** Archivo a medida (Excel) desde el catálogo de copilot_analytics: una fuente base, una lista cerrada de columnas calificadas 'source.column' (solo exportables), un cruce opcional (join_with) de un salto sobre una relación declarada o de dos saltos por un camino declarado (el servidor resuelve la fuente puente) y filtros del catálogo. Valida TODO el pedido antes de encolar: un pedido inválido devuelve CopilotAnalyticsCustomFileRejected con code y allowed (qué sí se podía) sin crear la corrida. El archivo se genera en segundo plano por el circuito de Reportería Centralizada: report_id es la fila en «Generados», status es el estado real al encolar y download_url llega cuando termina. summary sale de la misma consulta congelada que produce el archivo. Solo administrador de la organización. */
  generate_custom_file: CopilotAnalyticsGenerateCustomFileResponse;
};


export type CopilotAnalyticsMutationGenerate_Custom_FileArgs = {
  input: CopilotAnalyticsGenerateCustomFileInput;
};

/** Qué pasa con las filas sin pareja: DROP las descarta; KEEP_LEFT / KEEP_RIGHT conserva las huérfanas de ese lado con el otro vacío. */
export enum CopilotAnalyticsOrphans {
  Drop = 'DROP',
  KeepLeft = 'KEEP_LEFT',
  KeepRight = 'KEEP_RIGHT'
}

export type CopilotAnalyticsPaginationInput = {
  /** Máximo de filas a devolver (default y tope: 100). */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Cantidad de filas a saltar desde el inicio (default 0). */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CopilotAnalyticsQuery = {
  __typename?: 'CopilotAnalyticsQuery';
  /** Agregación escalar (SUM, AVG, MIN o MAX) de una columna numérica de learning_course_enrollments, con los mismos filtros que el listado. Devuelve el valor sin redondear y row_count con la cantidad de filas agregadas; value es null cuando ninguna fila matchea el filtro. */
  aggregate_learning_course_enrollments: CopilotAnalyticsAggregateResult;
  /** Agregación escalar (SUM, AVG, MIN o MAX) de una columna numérica de learning_progress_hours, con los mismos filtros que el listado. Devuelve el valor sin redondear y row_count con la cantidad de filas agregadas; value es null cuando ninguna fila matchea el filtro. */
  aggregate_learning_progress_hours: CopilotAnalyticsAggregateResult;
  /** Conteo de filas de hris_daily_logins (mismos filtros que el listado). */
  count_hris_daily_logins: CopilotAnalyticsCountResult;
  /** Conteo de filas de hris_organizations (mismos filtros que el listado). */
  count_hris_organizations: CopilotAnalyticsCountResult;
  /** Conteo de filas de hris_user_area_levels (mismos filtros que el listado). */
  count_hris_user_area_levels: CopilotAnalyticsCountResult;
  /** Conteo de filas de hris_user_custom_fields (mismos filtros que el listado). */
  count_hris_user_custom_fields: CopilotAnalyticsCountResult;
  /** Conteo de filas de hris_users (mismos filtros que el listado). */
  count_hris_users: CopilotAnalyticsCountResult;
  /** Conteo de filas de learning_course_enrollments (mismos filtros que el listado). */
  count_learning_course_enrollments: CopilotAnalyticsCountResult;
  /** Conteo de filas de learning_courses (mismos filtros que el listado). */
  count_learning_courses: CopilotAnalyticsCountResult;
  /** Conteo de filas de learning_live_session_users (mismos filtros que el listado). */
  count_learning_live_session_users: CopilotAnalyticsCountResult;
  /** Conteo de filas de learning_live_sessions (mismos filtros que el listado). */
  count_learning_live_sessions: CopilotAnalyticsCountResult;
  /** Conteo de filas de learning_progress_hours (mismos filtros que el listado). */
  count_learning_progress_hours: CopilotAnalyticsCountResult;
  /** Conteo de filas de learning_quiz_attempts (mismos filtros que el listado). */
  count_learning_quiz_attempts: CopilotAnalyticsCountResult;
  /** Conteo de filas de learning_quiz_responses (mismos filtros que el listado). */
  count_learning_quiz_responses: CopilotAnalyticsCountResult;
  /** Conteo de filas de learning_route_users (mismos filtros que el listado). */
  count_learning_route_users: CopilotAnalyticsCountResult;
  /** Conteo de filas de learning_routes (mismos filtros que el listado). */
  count_learning_routes: CopilotAnalyticsCountResult;
  /** Conteo de filas de learning_user_course_routes (mismos filtros que el listado). */
  count_learning_user_course_routes: CopilotAnalyticsCountResult;
  /** Conteo de filas de learning_user_work_teams (mismos filtros que el listado). */
  count_learning_user_work_teams: CopilotAnalyticsCountResult;
  /** Catálogo consultable de copilot_analytics. Sin source: todas las fuentes con descripción, universo, total_rows de la organización y con qué otras fuentes se pueden cruzar (relates_to), sin columnas. Con source: esa fuente con sus columnas exportables (nombre, descripción, tipo, capacidades) y sus relaciones (columna de cruce, cardinalidad, huérfanos, driver). Solo administrador de la organización; source inexistente → ValidationErrorResponse con code SOURCE_NOT_FOUND. Orden: grado de combinación DESC, total_rows DESC, query_name ASC. */
  describe_catalog: CopilotAnalyticsDescribeCatalogResponse;
  /** Valores distintos de la dimensión 'group_by' de hris_daily_logins con su conteo (mismos filtros; ordenado por count desc; total_count = grupos distintos). */
  group_hris_daily_logins_by: CopilotAnalyticsGroupByResult;
  /** Valores distintos de la dimensión 'group_by' de hris_organizations con su conteo (mismos filtros; ordenado por count desc; total_count = grupos distintos). */
  group_hris_organizations_by: CopilotAnalyticsGroupByResult;
  /** Valores distintos de la dimensión 'group_by' de hris_user_area_levels con su conteo (mismos filtros; ordenado por count desc; total_count = grupos distintos). */
  group_hris_user_area_levels_by: CopilotAnalyticsGroupByResult;
  /** Valores distintos de la dimensión 'group_by' de hris_user_custom_fields con su conteo (mismos filtros; ordenado por count desc; total_count = grupos distintos). */
  group_hris_user_custom_fields_by: CopilotAnalyticsGroupByResult;
  /** Valores distintos de la dimensión 'group_by' de hris_users con su conteo (mismos filtros; ordenado por count desc; total_count = grupos distintos). */
  group_hris_users_by: CopilotAnalyticsGroupByResult;
  /** Valores distintos de la dimensión 'group_by' de learning_course_enrollments con su conteo (mismos filtros; ordenado por count desc; total_count = grupos distintos). */
  group_learning_course_enrollments_by: CopilotAnalyticsGroupByResult;
  /** Valores distintos de la dimensión 'group_by' de learning_courses con su conteo (mismos filtros; ordenado por count desc; total_count = grupos distintos). */
  group_learning_courses_by: CopilotAnalyticsGroupByResult;
  /** Valores distintos de la dimensión 'group_by' de learning_live_session_users con su conteo (mismos filtros; ordenado por count desc; total_count = grupos distintos). */
  group_learning_live_session_users_by: CopilotAnalyticsGroupByResult;
  /** Valores distintos de la dimensión 'group_by' de learning_live_sessions con su conteo (mismos filtros; ordenado por count desc; total_count = grupos distintos). */
  group_learning_live_sessions_by: CopilotAnalyticsGroupByResult;
  /** Valores distintos de la dimensión 'group_by' de learning_progress_hours con su conteo (mismos filtros; ordenado por count desc; total_count = grupos distintos). */
  group_learning_progress_hours_by: CopilotAnalyticsGroupByResult;
  /** Valores distintos de la dimensión 'group_by' de learning_quiz_attempts con su conteo (mismos filtros; ordenado por count desc; total_count = grupos distintos). */
  group_learning_quiz_attempts_by: CopilotAnalyticsGroupByResult;
  /** Valores distintos de la dimensión 'group_by' de learning_quiz_responses con su conteo (mismos filtros; ordenado por count desc; total_count = grupos distintos). */
  group_learning_quiz_responses_by: CopilotAnalyticsGroupByResult;
  /** Valores distintos de la dimensión 'group_by' de learning_route_users con su conteo (mismos filtros; ordenado por count desc; total_count = grupos distintos). */
  group_learning_route_users_by: CopilotAnalyticsGroupByResult;
  /** Valores distintos de la dimensión 'group_by' de learning_routes con su conteo (mismos filtros; ordenado por count desc; total_count = grupos distintos). */
  group_learning_routes_by: CopilotAnalyticsGroupByResult;
  /** Valores distintos de la dimensión 'group_by' de learning_user_course_routes con su conteo (mismos filtros; ordenado por count desc; total_count = grupos distintos). */
  group_learning_user_course_routes_by: CopilotAnalyticsGroupByResult;
  /** Valores distintos de la dimensión 'group_by' de learning_user_work_teams con su conteo (mismos filtros; ordenado por count desc; total_count = grupos distintos). */
  group_learning_user_work_teams_by: CopilotAnalyticsGroupByResult;
  /** Listado read-only paginado (offset, 100 por página) con filtros de hris_daily_logins. */
  list_hris_daily_logins: CopilotAnalyticsListHrisDailyLoginResult;
  /** Listado read-only paginado (offset, 100 por página) con filtros de hris_organizations. */
  list_hris_organizations: CopilotAnalyticsListHrisOrganizationResult;
  /** Listado read-only paginado (offset, 100 por página) con filtros de hris_user_area_levels. */
  list_hris_user_area_levels: CopilotAnalyticsListHrisUserAreaLevelResult;
  /** Listado read-only paginado (offset, 100 por página) con filtros de hris_user_custom_fields. */
  list_hris_user_custom_fields: CopilotAnalyticsListHrisUserCustomFieldResult;
  /** Listado read-only paginado (offset, 100 por página) con filtros de hris_users. */
  list_hris_users: CopilotAnalyticsListHrisUserResult;
  /** Listado read-only paginado (offset, 100 por página) con filtros de learning_course_enrollments. */
  list_learning_course_enrollments: CopilotAnalyticsListLearningCourseEnrollmentResult;
  /** Listado read-only paginado (offset, 100 por página) con filtros de learning_courses. */
  list_learning_courses: CopilotAnalyticsListLearningCourseResult;
  /** Listado read-only paginado (offset, 100 por página) con filtros de learning_live_session_users. */
  list_learning_live_session_users: CopilotAnalyticsListLearningLiveSessionUserResult;
  /** Listado read-only paginado (offset, 100 por página) con filtros de learning_live_sessions. */
  list_learning_live_sessions: CopilotAnalyticsListLearningLiveSessionResult;
  /** Listado read-only paginado (offset, 100 por página) con filtros de learning_progress_hours. */
  list_learning_progress_hours: CopilotAnalyticsListLearningProgressHourResult;
  /** Listado read-only paginado (offset, 100 por página) con filtros de learning_quiz_attempts. */
  list_learning_quiz_attempts: CopilotAnalyticsListLearningQuizAttemptResult;
  /** Listado read-only paginado (offset, 100 por página) con filtros de learning_quiz_responses. */
  list_learning_quiz_responses: CopilotAnalyticsListLearningQuizResponseResult;
  /** Listado read-only paginado (offset, 100 por página) con filtros de learning_route_users. */
  list_learning_route_users: CopilotAnalyticsListLearningRouteUserResult;
  /** Listado read-only paginado (offset, 100 por página) con filtros de learning_routes. */
  list_learning_routes: CopilotAnalyticsListLearningRouteResult;
  /** Listado read-only paginado (offset, 100 por página) con filtros de learning_user_course_routes. */
  list_learning_user_course_routes: CopilotAnalyticsListLearningUserCourseRouteResult;
  /** Listado read-only paginado (offset, 100 por página) con filtros de learning_user_work_teams. */
  list_learning_user_work_teams: CopilotAnalyticsListLearningUserWorkTeamResult;
  /** Serie temporal de hris_daily_logins: agrupa las filas por el día, la semana o el mes de una columna de fecha y devuelve el conteo de cada período y, si se pide una métrica, su valor agregado. Los buckets van en orden cronológico ascendente y SOLO aparecen los períodos con filas: los vacíos no se rellenan con cero. Acotá el rango con el filtro de fecha de la misma columna, la página es de 100 buckets. */
  series_hris_daily_logins: CopilotAnalyticsSeriesResult;
  /** Serie temporal de hris_users: agrupa las filas por el día, la semana o el mes de una columna de fecha y devuelve el conteo de cada período y, si se pide una métrica, su valor agregado. Los buckets van en orden cronológico ascendente y SOLO aparecen los períodos con filas: los vacíos no se rellenan con cero. Acotá el rango con el filtro de fecha de la misma columna, la página es de 100 buckets. */
  series_hris_users: CopilotAnalyticsSeriesResult;
  /** Serie temporal de learning_course_enrollments: agrupa las filas por el día, la semana o el mes de una columna de fecha y devuelve el conteo de cada período y, si se pide una métrica, su valor agregado. Los buckets van en orden cronológico ascendente y SOLO aparecen los períodos con filas: los vacíos no se rellenan con cero. Acotá el rango con el filtro de fecha de la misma columna, la página es de 100 buckets. */
  series_learning_course_enrollments: CopilotAnalyticsSeriesResult;
};


export type CopilotAnalyticsQueryAggregate_Learning_Course_EnrollmentsArgs = {
  input: CopilotAnalyticsAggregateLearningCourseEnrollmentInput;
};


export type CopilotAnalyticsQueryAggregate_Learning_Progress_HoursArgs = {
  input: CopilotAnalyticsAggregateLearningProgressHourInput;
};


export type CopilotAnalyticsQueryCount_Hris_Daily_LoginsArgs = {
  input: CopilotAnalyticsCountHrisDailyLoginInput;
};


export type CopilotAnalyticsQueryCount_Hris_OrganizationsArgs = {
  input: CopilotAnalyticsCountHrisOrganizationInput;
};


export type CopilotAnalyticsQueryCount_Hris_User_Area_LevelsArgs = {
  input: CopilotAnalyticsCountHrisUserAreaLevelInput;
};


export type CopilotAnalyticsQueryCount_Hris_User_Custom_FieldsArgs = {
  input: CopilotAnalyticsCountHrisUserCustomFieldInput;
};


export type CopilotAnalyticsQueryCount_Hris_UsersArgs = {
  input: CopilotAnalyticsCountHrisUserInput;
};


export type CopilotAnalyticsQueryCount_Learning_Course_EnrollmentsArgs = {
  input: CopilotAnalyticsCountLearningCourseEnrollmentInput;
};


export type CopilotAnalyticsQueryCount_Learning_CoursesArgs = {
  input: CopilotAnalyticsCountLearningCourseInput;
};


export type CopilotAnalyticsQueryCount_Learning_Live_Session_UsersArgs = {
  input: CopilotAnalyticsCountLearningLiveSessionUserInput;
};


export type CopilotAnalyticsQueryCount_Learning_Live_SessionsArgs = {
  input: CopilotAnalyticsCountLearningLiveSessionInput;
};


export type CopilotAnalyticsQueryCount_Learning_Progress_HoursArgs = {
  input: CopilotAnalyticsCountLearningProgressHourInput;
};


export type CopilotAnalyticsQueryCount_Learning_Quiz_AttemptsArgs = {
  input: CopilotAnalyticsCountLearningQuizAttemptInput;
};


export type CopilotAnalyticsQueryCount_Learning_Quiz_ResponsesArgs = {
  input: CopilotAnalyticsCountLearningQuizResponseInput;
};


export type CopilotAnalyticsQueryCount_Learning_Route_UsersArgs = {
  input: CopilotAnalyticsCountLearningRouteUserInput;
};


export type CopilotAnalyticsQueryCount_Learning_RoutesArgs = {
  input: CopilotAnalyticsCountLearningRouteInput;
};


export type CopilotAnalyticsQueryCount_Learning_User_Course_RoutesArgs = {
  input: CopilotAnalyticsCountLearningUserCourseRouteInput;
};


export type CopilotAnalyticsQueryCount_Learning_User_Work_TeamsArgs = {
  input: CopilotAnalyticsCountLearningUserWorkTeamInput;
};


export type CopilotAnalyticsQueryDescribe_CatalogArgs = {
  input: CopilotAnalyticsDescribeCatalogInput;
};


export type CopilotAnalyticsQueryGroup_Hris_Daily_Logins_ByArgs = {
  input: CopilotAnalyticsGroupHrisDailyLoginInput;
};


export type CopilotAnalyticsQueryGroup_Hris_Organizations_ByArgs = {
  input: CopilotAnalyticsGroupHrisOrganizationInput;
};


export type CopilotAnalyticsQueryGroup_Hris_User_Area_Levels_ByArgs = {
  input: CopilotAnalyticsGroupHrisUserAreaLevelInput;
};


export type CopilotAnalyticsQueryGroup_Hris_User_Custom_Fields_ByArgs = {
  input: CopilotAnalyticsGroupHrisUserCustomFieldInput;
};


export type CopilotAnalyticsQueryGroup_Hris_Users_ByArgs = {
  input: CopilotAnalyticsGroupHrisUserInput;
};


export type CopilotAnalyticsQueryGroup_Learning_Course_Enrollments_ByArgs = {
  input: CopilotAnalyticsGroupLearningCourseEnrollmentInput;
};


export type CopilotAnalyticsQueryGroup_Learning_Courses_ByArgs = {
  input: CopilotAnalyticsGroupLearningCourseInput;
};


export type CopilotAnalyticsQueryGroup_Learning_Live_Session_Users_ByArgs = {
  input: CopilotAnalyticsGroupLearningLiveSessionUserInput;
};


export type CopilotAnalyticsQueryGroup_Learning_Live_Sessions_ByArgs = {
  input: CopilotAnalyticsGroupLearningLiveSessionInput;
};


export type CopilotAnalyticsQueryGroup_Learning_Progress_Hours_ByArgs = {
  input: CopilotAnalyticsGroupLearningProgressHourInput;
};


export type CopilotAnalyticsQueryGroup_Learning_Quiz_Attempts_ByArgs = {
  input: CopilotAnalyticsGroupLearningQuizAttemptInput;
};


export type CopilotAnalyticsQueryGroup_Learning_Quiz_Responses_ByArgs = {
  input: CopilotAnalyticsGroupLearningQuizResponseInput;
};


export type CopilotAnalyticsQueryGroup_Learning_Route_Users_ByArgs = {
  input: CopilotAnalyticsGroupLearningRouteUserInput;
};


export type CopilotAnalyticsQueryGroup_Learning_Routes_ByArgs = {
  input: CopilotAnalyticsGroupLearningRouteInput;
};


export type CopilotAnalyticsQueryGroup_Learning_User_Course_Routes_ByArgs = {
  input: CopilotAnalyticsGroupLearningUserCourseRouteInput;
};


export type CopilotAnalyticsQueryGroup_Learning_User_Work_Teams_ByArgs = {
  input: CopilotAnalyticsGroupLearningUserWorkTeamInput;
};


export type CopilotAnalyticsQueryList_Hris_Daily_LoginsArgs = {
  input: CopilotAnalyticsListHrisDailyLoginInput;
};


export type CopilotAnalyticsQueryList_Hris_OrganizationsArgs = {
  input: CopilotAnalyticsListHrisOrganizationInput;
};


export type CopilotAnalyticsQueryList_Hris_User_Area_LevelsArgs = {
  input: CopilotAnalyticsListHrisUserAreaLevelInput;
};


export type CopilotAnalyticsQueryList_Hris_User_Custom_FieldsArgs = {
  input: CopilotAnalyticsListHrisUserCustomFieldInput;
};


export type CopilotAnalyticsQueryList_Hris_UsersArgs = {
  input: CopilotAnalyticsListHrisUserInput;
};


export type CopilotAnalyticsQueryList_Learning_Course_EnrollmentsArgs = {
  input: CopilotAnalyticsListLearningCourseEnrollmentInput;
};


export type CopilotAnalyticsQueryList_Learning_CoursesArgs = {
  input: CopilotAnalyticsListLearningCourseInput;
};


export type CopilotAnalyticsQueryList_Learning_Live_Session_UsersArgs = {
  input: CopilotAnalyticsListLearningLiveSessionUserInput;
};


export type CopilotAnalyticsQueryList_Learning_Live_SessionsArgs = {
  input: CopilotAnalyticsListLearningLiveSessionInput;
};


export type CopilotAnalyticsQueryList_Learning_Progress_HoursArgs = {
  input: CopilotAnalyticsListLearningProgressHourInput;
};


export type CopilotAnalyticsQueryList_Learning_Quiz_AttemptsArgs = {
  input: CopilotAnalyticsListLearningQuizAttemptInput;
};


export type CopilotAnalyticsQueryList_Learning_Quiz_ResponsesArgs = {
  input: CopilotAnalyticsListLearningQuizResponseInput;
};


export type CopilotAnalyticsQueryList_Learning_Route_UsersArgs = {
  input: CopilotAnalyticsListLearningRouteUserInput;
};


export type CopilotAnalyticsQueryList_Learning_RoutesArgs = {
  input: CopilotAnalyticsListLearningRouteInput;
};


export type CopilotAnalyticsQueryList_Learning_User_Course_RoutesArgs = {
  input: CopilotAnalyticsListLearningUserCourseRouteInput;
};


export type CopilotAnalyticsQueryList_Learning_User_Work_TeamsArgs = {
  input: CopilotAnalyticsListLearningUserWorkTeamInput;
};


export type CopilotAnalyticsQuerySeries_Hris_Daily_LoginsArgs = {
  input: CopilotAnalyticsSeriesHrisDailyLoginInput;
};


export type CopilotAnalyticsQuerySeries_Hris_UsersArgs = {
  input: CopilotAnalyticsSeriesHrisUserInput;
};


export type CopilotAnalyticsQuerySeries_Learning_Course_EnrollmentsArgs = {
  input: CopilotAnalyticsSeriesLearningCourseEnrollmentInput;
};

export type CopilotAnalyticsSeriesBucket = {
  __typename?: 'CopilotAnalyticsSeriesBucket';
  /** Inicio del período (día, lunes de la semana o primero del mes). En tablas que bucketean por zona horaria, es el día calendario de la organización. */
  bucket?: Maybe<Scalars['Date']['output']>;
  /** Cantidad de filas del período. */
  count: Scalars['Int']['output'];
  /** Valor de la métrica pedida en el período. null si no se pidió métrica. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** Input de la serie temporal de hris_daily_logins. */
export type CopilotAnalyticsSeriesHrisDailyLoginInput = {
  /** Centralized organization id (central_org_id) del que pide. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Columna de fecha sobre la que se arma la serie. */
  column: CopilotAnalyticsHrisDailyLoginSeriesColumnEnum;
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsHrisDailyLoginFilterInput>;
  /** Tamaño del bucket temporal. */
  granularity: CopilotAnalyticsGranularityEnum;
  /** Paginación offset de los buckets (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

/** Input de la serie temporal de hris_users. */
export type CopilotAnalyticsSeriesHrisUserInput = {
  /** Centralized organization id (central_org_id) del que pide. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Columna de fecha sobre la que se arma la serie. */
  column: CopilotAnalyticsHrisUserSeriesColumnEnum;
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsHrisUserFilterInput>;
  /** Tamaño del bucket temporal. */
  granularity: CopilotAnalyticsGranularityEnum;
  /** Paginación offset de los buckets (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
};

/** Input de la serie temporal de learning_course_enrollments. */
export type CopilotAnalyticsSeriesLearningCourseEnrollmentInput = {
  /** Columna de fecha sobre la que se arma la serie. */
  column: CopilotAnalyticsLearningCourseEnrollmentSeriesColumnEnum;
  /** Filtros (mismos que el listado). */
  filter?: InputMaybe<CopilotAnalyticsLearningCourseEnrollmentFilterInput>;
  /** Tamaño del bucket temporal. */
  granularity: CopilotAnalyticsGranularityEnum;
  /** Métrica opcional a agregar dentro de cada bucket. Requiere value_column. */
  metric?: InputMaybe<CopilotAnalyticsAggregateMetricEnum>;
  /** Organization id de learning del que pide. */
  organization_id: Scalars['ID']['input'];
  /** Paginación offset de los buckets (limit/offset). */
  pagination?: InputMaybe<CopilotAnalyticsPaginationInput>;
  /** Columna numérica sobre la que se aplica metric. Requiere metric. */
  value_column?: InputMaybe<CopilotAnalyticsLearningCourseEnrollmentAggregateColumnEnum>;
};

export type CopilotAnalyticsSeriesPayload = {
  __typename?: 'CopilotAnalyticsSeriesPayload';
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Buckets de esta página, en orden cronológico ascendente. */
  items: Array<CopilotAnalyticsSeriesBucket>;
  /** Tamaño de página aplicado. */
  limit: Scalars['Int']['output'];
  /** Offset aplicado. */
  offset: Scalars['Int']['output'];
  /** Cantidad de buckets con filas (sin paginar). */
  total_count: Scalars['Int']['output'];
};

export type CopilotAnalyticsSeriesResult = CopilotAnalyticsSeriesPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CopilotCategoryNode = {
  __typename?: 'CopilotCategoryNode';
  copilot_prompts: Array<CopilotPromptNode>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CopilotChatMessageRatingNode = {
  __typename?: 'CopilotChatMessageRatingNode';
  category?: Maybe<Scalars['String']['output']>;
  chat_message_id: Scalars['ID']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  liked?: Maybe<Scalars['Boolean']['output']>;
};

export enum CopilotConversationModeEnum {
  Copilot = 'COPILOT',
  CopilotPlanner = 'COPILOT_PLANNER'
}

export type CopilotDataQuery = {
  __typename?: 'CopilotDataQuery';
  /** Puente de identidad del sistema centralizado de Tiempo & Asistencia: relaciona `central_user_id` con `user_id`. Cada fila mapea un usuario entre ambos sistemas. Listado read-only paginado (100 por página) con filtros. */
  data_central_users_organization: DataCentralUserOrganizationResult;
  /** Puente de identidad del sistema centralizado de Tiempo & Asistencia: relaciona `central_user_id` con `user_id`. Cada fila mapea un usuario entre ambos sistemas. Conteo de filas (mismos filtros que data_central_users_organization); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_central_users_organization_count: DataCountResult;
  /** Puente de identidad del sistema centralizado de Tiempo & Asistencia: relaciona `central_user_id` con `user_id`. Cada fila mapea un usuario entre ambos sistemas. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_central_users_organization, ordenado por count desc; total_count = grupos distintos). */
  data_central_users_organization_group_by: DataGroupCountResult;
  /** Inscripciones de usuarios a cursos: progreso, fechas de inicio/fin, categoría, nivel y certificados. Cada fila es la inscripción de un usuario a un curso. Formatos de campos: `played_seconds` → segundos; `course_current_progress` → porcentaje entero (0–100). Listado read-only paginado (100 por página) con filtros. */
  data_course_enrollments: DataCourseEnrollmentResult;
  /** Inscripciones de usuarios a cursos: progreso, fechas de inicio/fin, categoría, nivel y certificados. Cada fila es la inscripción de un usuario a un curso. Formatos de campos: `played_seconds` → segundos; `course_current_progress` → porcentaje entero (0–100). Conteo de filas (mismos filtros que data_course_enrollments); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_course_enrollments_count: DataCountResult;
  /** Inscripciones de usuarios a cursos: progreso, fechas de inicio/fin, categoría, nivel y certificados. Cada fila es la inscripción de un usuario a un curso. Formatos de campos: `played_seconds` → segundos; `course_current_progress` → porcentaje entero (0–100). Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_course_enrollments, ordenado por count desc; total_count = grupos distintos). */
  data_course_enrollments_group_by: DataGroupCountResult;
  /** Evaluaciones (quizzes) rendidas por los usuarios en cursos: intentos, respuestas incorrectas, puntaje y aprobación. Cada fila resume el desempeño de un usuario en un quiz. Formatos de campos: `total_seconds` → segundos; `percentage`, `quiz_approval_percentage` → porcentaje (0–100); `points`, `quiz_max_points` → puntos; `quiz_attempts_count`, `total_wrong_answer`, `quiz_num_questions` → cantidad. Listado read-only paginado (100 por página) con filtros. */
  data_course_quizzes: DataCourseQuizResult;
  /** Evaluaciones (quizzes) rendidas por los usuarios en cursos: intentos, respuestas incorrectas, puntaje y aprobación. Cada fila resume el desempeño de un usuario en un quiz. Formatos de campos: `total_seconds` → segundos; `percentage`, `quiz_approval_percentage` → porcentaje (0–100); `points`, `quiz_max_points` → puntos; `quiz_attempts_count`, `total_wrong_answer`, `quiz_num_questions` → cantidad. Conteo de filas (mismos filtros que data_course_quizzes); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_course_quizzes_count: DataCountResult;
  /** Evaluaciones (quizzes) rendidas por los usuarios en cursos: intentos, respuestas incorrectas, puntaje y aprobación. Cada fila resume el desempeño de un usuario en un quiz. Formatos de campos: `total_seconds` → segundos; `percentage`, `quiz_approval_percentage` → porcentaje (0–100); `points`, `quiz_max_points` → puntos; `quiz_attempts_count`, `total_wrong_answer`, `quiz_num_questions` → cantidad. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_course_quizzes, ordenado por count desc; total_count = grupos distintos). */
  data_course_quizzes_group_by: DataGroupCountResult;
  /** Cursos distintos (course_id + course_name) de la organización, agrupando course_enrollments. Filtrable por course_id (paginado, 100 por página). */
  data_courses: DataCourseResult;
  /** Relación entre cursos y rutas de aprendizaje. Cada fila asocia un curso a una ruta (track). Listado read-only paginado (100 por página) con filtros. */
  data_courses_tracks: DataCourseTrackResult;
  /** Relación entre cursos y rutas de aprendizaje. Cada fila asocia un curso a una ruta (track). Conteo de filas (mismos filtros que data_courses_tracks); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_courses_tracks_count: DataCountResult;
  /** Relación entre cursos y rutas de aprendizaje. Cada fila asocia un curso a una ruta (track). Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_courses_tracks, ordenado por count desc; total_count = grupos distintos). */
  data_courses_tracks_group_by: DataGroupCountResult;
  /** Reconocimientos y medallas entre colaboradores: categoría, nivel, puntos y feedback. Cada fila es un reconocimiento recibido por un usuario. Formatos de campos: `recognition_level_points` → puntos; `recognition_public_medal` → bandera 'true'/'false'. Listado read-only paginado (100 por página) con filtros. */
  data_employee_recognitions: DataEmployeeRecognitionResult;
  /** Reconocimientos y medallas entre colaboradores: categoría, nivel, puntos y feedback. Cada fila es un reconocimiento recibido por un usuario. Formatos de campos: `recognition_level_points` → puntos; `recognition_public_medal` → bandera 'true'/'false'. Conteo de filas (mismos filtros que data_employee_recognitions); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_employee_recognitions_count: DataCountResult;
  /** Reconocimientos y medallas entre colaboradores: categoría, nivel, puntos y feedback. Cada fila es un reconocimiento recibido por un usuario. Formatos de campos: `recognition_level_points` → puntos; `recognition_public_medal` → bandera 'true'/'false'. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_employee_recognitions, ordenado por count desc; total_count = grupos distintos). */
  data_employee_recognitions_group_by: DataGroupCountResult;
  /** Documentos HRIS de los usuarios: nombre, carpeta, estado y fechas. Cada fila es un documento asignado a un usuario. Listado read-only paginado (100 por página) con filtros. */
  data_hris_documents: DataHrisDocumentResult;
  /** Documentos HRIS de los usuarios: nombre, carpeta, estado y fechas. Cada fila es un documento asignado a un usuario. Conteo de filas (mismos filtros que data_hris_documents); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_hris_documents_count: DataCountResult;
  /** Documentos HRIS de los usuarios: nombre, carpeta, estado y fechas. Cada fila es un documento asignado a un usuario. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_hris_documents, ordenado por count desc; total_count = grupos distintos). */
  data_hris_documents_group_by: DataGroupCountResult;
  /** Colaboradores inactivos o dados de baja: histórico de identidad y datos laborales. Cada fila es un ex-colaborador. Listado read-only paginado (100 por página) con filtros. */
  data_inactive_users: DataInactiveUserResult;
  /** Colaboradores inactivos o dados de baja: histórico de identidad y datos laborales. Cada fila es un ex-colaborador. Conteo de filas (mismos filtros que data_inactive_users); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_inactive_users_count: DataCountResult;
  /** Colaboradores inactivos o dados de baja: histórico de identidad y datos laborales. Cada fila es un ex-colaborador. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_inactive_users, ordenado por count desc; total_count = grupos distintos). */
  data_inactive_users_group_by: DataGroupCountResult;
  /** Vacantes y candidatos de reclutamiento: afinidad del candidato, reclutador y tiempos de cierre. Cada fila es un candidato en una vacante. Formatos de campos: `days_to_closed_hiring` → días; `candidate_affinity_score` → puntaje; `hiring_number` → cantidad. Listado read-only paginado (100 por página) con filtros. */
  data_job_vacancy: DataJobVacancyResult;
  /** Vacantes y candidatos de reclutamiento: afinidad del candidato, reclutador y tiempos de cierre. Cada fila es un candidato en una vacante. Formatos de campos: `days_to_closed_hiring` → días; `candidate_affinity_score` → puntaje; `hiring_number` → cantidad. Conteo de filas (mismos filtros que data_job_vacancy); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_job_vacancy_count: DataCountResult;
  /** Vacantes y candidatos de reclutamiento: afinidad del candidato, reclutador y tiempos de cierre. Cada fila es un candidato en una vacante. Formatos de campos: `days_to_closed_hiring` → días; `candidate_affinity_score` → puntaje; `hiring_number` → cantidad. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_job_vacancy, ordenado por count desc; total_count = grupos distintos). */
  data_job_vacancy_group_by: DataGroupCountResult;
  /** Cuentas de organización: tipo, licencias, contrato y features habilitadas. Cada fila es una organización. Formatos de campos: `available_licenses` → cantidad. Listado read-only paginado (100 por página) con filtros. */
  data_organization_accounts: DataOrganizationAccountResult;
  /** Cuentas de organización: tipo, licencias, contrato y features habilitadas. Cada fila es una organización. Formatos de campos: `available_licenses` → cantidad. Conteo de filas (mismos filtros que data_organization_accounts); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_organization_accounts_count: DataCountResult;
  /** Cuentas de organización: tipo, licencias, contrato y features habilitadas. Cada fila es una organización. Formatos de campos: `available_licenses` → cantidad. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_organization_accounts, ordenado por count desc; total_count = grupos distintos). */
  data_organization_accounts_group_by: DataGroupCountResult;
  /** Consumo de contenido por usuario y curso en intervalos de tiempo: segundos reproducidos, clases y progreso. Cada fila es un intervalo de estudio. Formatos de campos: `played_seconds`, `progress_seconds` → segundos; `course_duration` → minutos; `progress_hours` → porcentaje entero (0–100); `course_lectures`, `played_lectures` → cantidad. Listado read-only paginado (100 por página) con filtros. */
  data_progress_hours: DataProgressHourResult;
  /** Consumo de contenido por usuario y curso en intervalos de tiempo: segundos reproducidos, clases y progreso. Cada fila es un intervalo de estudio. Formatos de campos: `played_seconds`, `progress_seconds` → segundos; `course_duration` → minutos; `progress_hours` → porcentaje entero (0–100); `course_lectures`, `played_lectures` → cantidad. Conteo de filas (mismos filtros que data_progress_hours); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_progress_hours_count: DataCountResult;
  /** Proyectos entregados por los usuarios en cursos: estado, fechas del flujo, vistas y certificación. Cada fila es un proyecto de un usuario. Formatos de campos: `likes`, `views` → cantidad; `current_action` → código. Listado read-only paginado (100 por página) con filtros. */
  data_projects: DataProjectResult;
  /** Proyectos entregados por los usuarios en cursos: estado, fechas del flujo, vistas y certificación. Cada fila es un proyecto de un usuario. Formatos de campos: `likes`, `views` → cantidad; `current_action` → código. Conteo de filas (mismos filtros que data_projects); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_projects_count: DataCountResult;
  /** Proyectos entregados por los usuarios en cursos: estado, fechas del flujo, vistas y certificación. Cada fila es un proyecto de un usuario. Formatos de campos: `likes`, `views` → cantidad; `current_action` → código. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_projects, ordenado por count desc; total_count = grupos distintos). */
  data_projects_group_by: DataGroupCountResult;
  /** Asignaciones de turno a usuarios (Tiempo & Asistencia): turno, vigencia y datos del colaborador. Cada fila es la asignación de un turno a un usuario. Formatos de campos: `is_active` → bandera 'true'/'false'. Listado read-only paginado (100 por página) con filtros. */
  data_ta_shifts_assignments: DataTaShiftAssignmentResult;
  /** Asignaciones de turno a usuarios (Tiempo & Asistencia): turno, vigencia y datos del colaborador. Cada fila es la asignación de un turno a un usuario. Formatos de campos: `is_active` → bandera 'true'/'false'. Conteo de filas (mismos filtros que data_ta_shifts_assignments); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_ta_shifts_assignments_count: DataCountResult;
  /** Asignaciones de turno a usuarios (Tiempo & Asistencia): turno, vigencia y datos del colaborador. Cada fila es la asignación de un turno a un usuario. Formatos de campos: `is_active` → bandera 'true'/'false'. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_ta_shifts_assignments, ordenado por count desc; total_count = grupos distintos). */
  data_ta_shifts_assignments_group_by: DataGroupCountResult;
  /** Definición de turnos fijos (no rotativos): horario semanal por día y descansos. Cada fila es un día de la semana de un turno. Formatos de campos: `tolerance_before_minutes`, `tolerance_after_minutes`, `day_worked_minutes`, `day_break_duration_minutes`, `break_slot_duration_minutes` → minutos; `break_slot_position` → posición/orden; `shift_is_active`, `day_is_working_day` → bandera 'true'/'false'. Listado read-only paginado (100 por página) con filtros. */
  data_ta_shifts_non_rotating: DataTaShiftNonRotatingResult;
  /** Definición de turnos fijos (no rotativos): horario semanal por día y descansos. Cada fila es un día de la semana de un turno. Formatos de campos: `tolerance_before_minutes`, `tolerance_after_minutes`, `day_worked_minutes`, `day_break_duration_minutes`, `break_slot_duration_minutes` → minutos; `break_slot_position` → posición/orden; `shift_is_active`, `day_is_working_day` → bandera 'true'/'false'. Conteo de filas (mismos filtros que data_ta_shifts_non_rotating); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_ta_shifts_non_rotating_count: DataCountResult;
  /** Definición de turnos fijos (no rotativos): horario semanal por día y descansos. Cada fila es un día de la semana de un turno. Formatos de campos: `tolerance_before_minutes`, `tolerance_after_minutes`, `day_worked_minutes`, `day_break_duration_minutes`, `break_slot_duration_minutes` → minutos; `break_slot_position` → posición/orden; `shift_is_active`, `day_is_working_day` → bandera 'true'/'false'. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_ta_shifts_non_rotating, ordenado por count desc; total_count = grupos distintos). */
  data_ta_shifts_non_rotating_group_by: DataGroupCountResult;
  /** Definición de turnos rotativos: ciclos de trabajo/descanso y horarios. Cada fila es un ciclo de un turno rotativo. Formatos de campos: `tolerance_before_minutes`, `tolerance_after_minutes`, `cycle_worked_minutes_per_day`, `cycle_break_duration_minutes`, `break_slot_duration_minutes` → minutos; `cycle_duration_days` → días; `cycle_order`, `break_slot_position` → posición/orden; `shift_is_active` → bandera 'true'/'false'. Listado read-only paginado (100 por página) con filtros. */
  data_ta_shifts_rotating: DataTaShiftRotatingResult;
  /** Definición de turnos rotativos: ciclos de trabajo/descanso y horarios. Cada fila es un ciclo de un turno rotativo. Formatos de campos: `tolerance_before_minutes`, `tolerance_after_minutes`, `cycle_worked_minutes_per_day`, `cycle_break_duration_minutes`, `break_slot_duration_minutes` → minutos; `cycle_duration_days` → días; `cycle_order`, `break_slot_position` → posición/orden; `shift_is_active` → bandera 'true'/'false'. Conteo de filas (mismos filtros que data_ta_shifts_rotating); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_ta_shifts_rotating_count: DataCountResult;
  /** Definición de turnos rotativos: ciclos de trabajo/descanso y horarios. Cada fila es un ciclo de un turno rotativo. Formatos de campos: `tolerance_before_minutes`, `tolerance_after_minutes`, `cycle_worked_minutes_per_day`, `cycle_break_duration_minutes`, `break_slot_duration_minutes` → minutos; `cycle_duration_days` → días; `cycle_order`, `break_slot_position` → posición/orden; `shift_is_active` → bandera 'true'/'false'. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_ta_shifts_rotating, ordenado por count desc; total_count = grupos distintos). */
  data_ta_shifts_rotating_group_by: DataGroupCountResult;
  /** Resultados de encuestas de clima laboral por proceso y dimensión, con etiqueta NPS. Cada fila es una dimensión/división de un proceso de clima. Formatos de campos: `avg_score` → puntaje; `employee_count`, `answers_count` → cantidad. Listado read-only paginado (100 por página) con filtros. */
  data_talent_climate: DataTalentClimateResult;
  /** Resultados de encuestas de clima laboral por proceso y dimensión, con etiqueta NPS. Cada fila es una dimensión/división de un proceso de clima. Formatos de campos: `avg_score` → puntaje; `employee_count`, `answers_count` → cantidad. Conteo de filas (mismos filtros que data_talent_climate); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_talent_climate_count: DataCountResult;
  /** Resultados de encuestas de clima laboral por proceso y dimensión, con etiqueta NPS. Cada fila es una dimensión/división de un proceso de clima. Formatos de campos: `avg_score` → puntaje; `employee_count`, `answers_count` → cantidad. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_talent_climate, ordenado por count desc; total_count = grupos distintos). */
  data_talent_climate_group_by: DataGroupCountResult;
  /** Resultados de evaluación de competencias por empleado: competencia, tipo de evaluación, resultado y relación del evaluador. Cada fila es una competencia evaluada a un usuario en un proceso POR UNA relación de evaluador (AUTO/BOSS/etc.): total_result es el puntaje de esa relación, NO el 'Resultado Total' ponderado de la competencia que muestra la plataforma (ese agregado ponderado nunca es esta columna). Formatos de campos: `total_weight` → porcentaje (0–100); `adj_result`, `total_result` → puntaje. Listado read-only paginado (100 por página) con filtros. */
  data_talent_competence_employee: DataTalentCompetenceEmployeeResult;
  /** Resultados de evaluación de competencias por empleado: competencia, tipo de evaluación, resultado y relación del evaluador. Cada fila es una competencia evaluada a un usuario en un proceso POR UNA relación de evaluador (AUTO/BOSS/etc.): total_result es el puntaje de esa relación, NO el 'Resultado Total' ponderado de la competencia que muestra la plataforma (ese agregado ponderado nunca es esta columna). Formatos de campos: `total_weight` → porcentaje (0–100); `adj_result`, `total_result` → puntaje. Conteo de filas (mismos filtros que data_talent_competence_employee); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_talent_competence_employee_count: DataCountResult;
  /** Resultados de evaluación de competencias por empleado: competencia, tipo de evaluación, resultado y relación del evaluador. Cada fila es una competencia evaluada a un usuario en un proceso POR UNA relación de evaluador (AUTO/BOSS/etc.): total_result es el puntaje de esa relación, NO el 'Resultado Total' ponderado de la competencia que muestra la plataforma (ese agregado ponderado nunca es esta columna). Formatos de campos: `total_weight` → porcentaje (0–100); `adj_result`, `total_result` → puntaje. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_talent_competence_employee, ordenado por count desc; total_count = grupos distintos). */
  data_talent_competence_employee_group_by: DataGroupCountResult;
  /** Resultado ponderado de la evaluación de competencias por proceso. Cada fila es el resultado global de un usuario en un proceso de competencias. Formatos de campos: `weighted_result` → puntaje. Listado read-only paginado (100 por página) con filtros. */
  data_talent_competence_process: DataTalentCompetenceProcessResult;
  /** Resultado ponderado de la evaluación de competencias por proceso. Cada fila es el resultado global de un usuario en un proceso de competencias. Formatos de campos: `weighted_result` → puntaje. Conteo de filas (mismos filtros que data_talent_competence_process); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_talent_competence_process_count: DataCountResult;
  /** Resultado ponderado de la evaluación de competencias por proceso. Cada fila es el resultado global de un usuario en un proceso de competencias. Formatos de campos: `weighted_result` → puntaje. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_talent_competence_process, ordenado por count desc; total_count = grupos distintos). */
  data_talent_competence_process_group_by: DataGroupCountResult;
  /** Planes individuales de desarrollo (PID/DIP): avance y actividades por usuario. Cada fila es el plan de desarrollo de un usuario en un proceso. Formatos de campos: `avg_results` → puntaje; `process_count`, `activities_completed`, `activities_count` → cantidad. Listado read-only paginado (100 por página) con filtros. */
  data_talent_dip: DataTalentDipResult;
  /** Planes individuales de desarrollo (PID/DIP): avance y actividades por usuario. Cada fila es el plan de desarrollo de un usuario en un proceso. Formatos de campos: `avg_results` → puntaje; `process_count`, `activities_completed`, `activities_count` → cantidad. Conteo de filas (mismos filtros que data_talent_dip); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_talent_dip_count: DataCountResult;
  /** Planes individuales de desarrollo (PID/DIP): avance y actividades por usuario. Cada fila es el plan de desarrollo de un usuario en un proceso. Formatos de campos: `avg_results` → puntaje; `process_count`, `activities_completed`, `activities_count` → cantidad. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_talent_dip, ordenado por count desc; total_count = grupos distintos). */
  data_talent_dip_group_by: DataGroupCountResult;
  /** Feedback entre colaboradores: tipo, motivo, estado, categoría y fechas. Cada fila es un feedback dado o solicitado. Listado read-only paginado (100 por página) con filtros. */
  data_talent_feedback: DataTalentFeedbackResult;
  /** Feedback entre colaboradores: tipo, motivo, estado, categoría y fechas. Cada fila es un feedback dado o solicitado. Conteo de filas (mismos filtros que data_talent_feedback); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_talent_feedback_count: DataCountResult;
  /** Feedback entre colaboradores: tipo, motivo, estado, categoría y fechas. Cada fila es un feedback dado o solicitado. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_talent_feedback, ordenado por count desc; total_count = grupos distintos). */
  data_talent_feedback_group_by: DataGroupCountResult;
  /** Objetivos/metas de empleados y de compañía: resultado, estado y periodo. Cada fila es una meta asignada a un usuario. Formatos de campos: `goal_result` → porcentaje (0–100). Listado read-only paginado (100 por página) con filtros. */
  data_talent_goals: DataTalentGoalResult;
  /** Objetivos/metas de empleados y de compañía: resultado, estado y periodo. Cada fila es una meta asignada a un usuario. Formatos de campos: `goal_result` → porcentaje (0–100). Conteo de filas (mismos filtros que data_talent_goals); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_talent_goals_count: DataCountResult;
  /** Objetivos/metas de empleados y de compañía: resultado, estado y periodo. Cada fila es una meta asignada a un usuario. Formatos de campos: `goal_result` → porcentaje (0–100). Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_talent_goals, ordenado por count desc; total_count = grupos distintos). */
  data_talent_goals_group_by: DataGroupCountResult;
  /** Inscripciones a rutas de aprendizaje (tracks): cursos requeridos y completados, fechas y certificación. Cada fila es la inscripción de un usuario a una ruta. Formatos de campos: `total_played_seconds` → segundos; `track_courses_to_complete`, `track_courses_to_certificate`, `user_track_courses_completed`, `courses_count` → cantidad. Listado read-only paginado (100 por página) con filtros. */
  data_tracks_enrollment: DataTrackEnrollmentResult;
  /** Inscripciones a rutas de aprendizaje (tracks): cursos requeridos y completados, fechas y certificación. Cada fila es la inscripción de un usuario a una ruta. Formatos de campos: `total_played_seconds` → segundos; `track_courses_to_complete`, `track_courses_to_certificate`, `user_track_courses_completed`, `courses_count` → cantidad. Conteo de filas (mismos filtros que data_tracks_enrollment); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_tracks_enrollment_count: DataCountResult;
  /** Inscripciones a rutas de aprendizaje (tracks): cursos requeridos y completados, fechas y certificación. Cada fila es la inscripción de un usuario a una ruta. Formatos de campos: `total_played_seconds` → segundos; `track_courses_to_complete`, `track_courses_to_certificate`, `user_track_courses_completed`, `courses_count` → cantidad. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_tracks_enrollment, ordenado por count desc; total_count = grupos distintos). */
  data_tracks_enrollment_group_by: DataGroupCountResult;
  /** Campos personalizados por usuario definidos por la organización (clave/valor). Cada fila es un campo personalizado de un usuario. Listado read-only paginado (100 por página) con filtros. */
  data_user_custom_fields: DataUserCustomFieldResult;
  /** Campos personalizados por usuario definidos por la organización (clave/valor). Cada fila es un campo personalizado de un usuario. Conteo de filas (mismos filtros que data_user_custom_fields); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_user_custom_fields_count: DataCountResult;
  /** Campos personalizados por usuario definidos por la organización (clave/valor). Cada fila es un campo personalizado de un usuario. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_user_custom_fields, ordenado por count desc; total_count = grupos distintos). */
  data_user_custom_fields_group_by: DataGroupCountResult;
  /** Estado de jefatura y fechas de ciclo de vida (registro, activación, inactivación) por usuario. El perfil completo vive en `users`. Formatos de campos: `is_manager` → bandera 0/1. Listado read-only paginado (100 por página) con filtros. */
  data_user_manager: DataUserManagerResult;
  /** Estado de jefatura y fechas de ciclo de vida (registro, activación, inactivación) por usuario. El perfil completo vive en `users`. Formatos de campos: `is_manager` → bandera 0/1. Conteo de filas (mismos filtros que data_user_manager); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_user_manager_count: DataCountResult;
  /** Estado de jefatura y fechas de ciclo de vida (registro, activación, inactivación) por usuario. El perfil completo vive en `users`. Formatos de campos: `is_manager` → bandera 0/1. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_user_manager, ordenado por count desc; total_count = grupos distintos). */
  data_user_manager_group_by: DataGroupCountResult;
  /** Colaboradores activos de la organización: identidad, equipo, cargo, ubicación y contacto. Cada fila es un usuario activo. Listado read-only paginado (100 por página) con filtros. */
  data_users: DataUserResult;
  /** Colaboradores activos de la organización: identidad, equipo, cargo, ubicación y contacto. Cada fila es un usuario activo. Conteo de filas (mismos filtros que data_users); sin 'distinct_by' -> COUNT(*), con él -> COUNT(DISTINCT <columna>). */
  data_users_count: DataCountResult;
  /** Colaboradores activos de la organización: identidad, equipo, cargo, ubicación y contacto. Cada fila es un usuario activo. Valores distintos de la columna 'group_by' con su conteo (mismos filtros que data_users, ordenado por count desc; total_count = grupos distintos). */
  data_users_group_by: DataGroupCountResult;
};


export type CopilotDataQueryData_Central_Users_OrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataCentralUserOrganizationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Central_Users_Organization_CountArgs = {
  distinct_by?: InputMaybe<DataCentralUserOrganizationDistinctByEnum>;
  filter?: InputMaybe<DataCentralUserOrganizationFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Central_Users_Organization_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataCentralUserOrganizationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataCentralUserOrganizationGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Course_EnrollmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataCourseEnrollmentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Course_Enrollments_CountArgs = {
  distinct_by?: InputMaybe<DataCourseEnrollmentDistinctByEnum>;
  filter?: InputMaybe<DataCourseEnrollmentFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Course_Enrollments_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataCourseEnrollmentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataCourseEnrollmentGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Course_QuizzesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataCourseQuizFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Course_Quizzes_CountArgs = {
  distinct_by?: InputMaybe<DataCourseQuizDistinctByEnum>;
  filter?: InputMaybe<DataCourseQuizFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Course_Quizzes_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataCourseQuizFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataCourseQuizGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_CoursesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataCourseFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Courses_TracksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataCourseTrackFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Courses_Tracks_CountArgs = {
  distinct_by?: InputMaybe<DataCourseTrackDistinctByEnum>;
  filter?: InputMaybe<DataCourseTrackFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Courses_Tracks_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataCourseTrackFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataCourseTrackGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Employee_RecognitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataEmployeeRecognitionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Employee_Recognitions_CountArgs = {
  distinct_by?: InputMaybe<DataEmployeeRecognitionDistinctByEnum>;
  filter?: InputMaybe<DataEmployeeRecognitionFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Employee_Recognitions_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataEmployeeRecognitionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataEmployeeRecognitionGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Hris_DocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataHrisDocumentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Hris_Documents_CountArgs = {
  distinct_by?: InputMaybe<DataHrisDocumentDistinctByEnum>;
  filter?: InputMaybe<DataHrisDocumentFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Hris_Documents_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataHrisDocumentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataHrisDocumentGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Inactive_UsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataInactiveUserFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Inactive_Users_CountArgs = {
  filter?: InputMaybe<DataInactiveUserFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Inactive_Users_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataInactiveUserFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataInactiveUserGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Job_VacancyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataJobVacancyFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Job_Vacancy_CountArgs = {
  distinct_by?: InputMaybe<DataJobVacancyDistinctByEnum>;
  filter?: InputMaybe<DataJobVacancyFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Job_Vacancy_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataJobVacancyFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataJobVacancyGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Organization_AccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataOrganizationAccountFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Organization_Accounts_CountArgs = {
  filter?: InputMaybe<DataOrganizationAccountFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Organization_Accounts_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataOrganizationAccountFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataOrganizationAccountGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Progress_HoursArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataProgressHourFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Progress_Hours_CountArgs = {
  distinct_by?: InputMaybe<DataProgressHourDistinctByEnum>;
  filter?: InputMaybe<DataProgressHourFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_ProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataProjectFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Projects_CountArgs = {
  distinct_by?: InputMaybe<DataProjectDistinctByEnum>;
  filter?: InputMaybe<DataProjectFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Projects_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataProjectFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataProjectGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Ta_Shifts_AssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTaShiftAssignmentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Ta_Shifts_Assignments_CountArgs = {
  distinct_by?: InputMaybe<DataTaShiftAssignmentDistinctByEnum>;
  filter?: InputMaybe<DataTaShiftAssignmentFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Ta_Shifts_Assignments_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTaShiftAssignmentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataTaShiftAssignmentGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Ta_Shifts_Non_RotatingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTaShiftNonRotatingFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Ta_Shifts_Non_Rotating_CountArgs = {
  distinct_by?: InputMaybe<DataTaShiftNonRotatingDistinctByEnum>;
  filter?: InputMaybe<DataTaShiftNonRotatingFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Ta_Shifts_Non_Rotating_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTaShiftNonRotatingFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataTaShiftNonRotatingGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Ta_Shifts_RotatingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTaShiftRotatingFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Ta_Shifts_Rotating_CountArgs = {
  distinct_by?: InputMaybe<DataTaShiftRotatingDistinctByEnum>;
  filter?: InputMaybe<DataTaShiftRotatingFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Ta_Shifts_Rotating_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTaShiftRotatingFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataTaShiftRotatingGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_ClimateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTalentClimateFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_Climate_CountArgs = {
  filter?: InputMaybe<DataTalentClimateFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_Climate_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTalentClimateFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataTalentClimateGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_Competence_EmployeeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTalentCompetenceEmployeeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_Competence_Employee_CountArgs = {
  distinct_by?: InputMaybe<DataTalentCompetenceEmployeeDistinctByEnum>;
  filter?: InputMaybe<DataTalentCompetenceEmployeeFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_Competence_Employee_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTalentCompetenceEmployeeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataTalentCompetenceEmployeeGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_Competence_ProcessArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTalentCompetenceProcessFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_Competence_Process_CountArgs = {
  distinct_by?: InputMaybe<DataTalentCompetenceProcessDistinctByEnum>;
  filter?: InputMaybe<DataTalentCompetenceProcessFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_Competence_Process_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTalentCompetenceProcessFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataTalentCompetenceProcessGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_DipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTalentDipFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_Dip_CountArgs = {
  distinct_by?: InputMaybe<DataTalentDipDistinctByEnum>;
  filter?: InputMaybe<DataTalentDipFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_Dip_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTalentDipFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataTalentDipGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_FeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTalentFeedbackFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_Feedback_CountArgs = {
  distinct_by?: InputMaybe<DataTalentFeedbackDistinctByEnum>;
  filter?: InputMaybe<DataTalentFeedbackFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_Feedback_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTalentFeedbackFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataTalentFeedbackGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_GoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTalentGoalFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_Goals_CountArgs = {
  distinct_by?: InputMaybe<DataTalentGoalDistinctByEnum>;
  filter?: InputMaybe<DataTalentGoalFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Talent_Goals_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTalentGoalFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataTalentGoalGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Tracks_EnrollmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTrackEnrollmentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Tracks_Enrollment_CountArgs = {
  distinct_by?: InputMaybe<DataTrackEnrollmentDistinctByEnum>;
  filter?: InputMaybe<DataTrackEnrollmentFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Tracks_Enrollment_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataTrackEnrollmentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataTrackEnrollmentGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_User_Custom_FieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataUserCustomFieldFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_User_Custom_Fields_CountArgs = {
  distinct_by?: InputMaybe<DataUserCustomFieldDistinctByEnum>;
  filter?: InputMaybe<DataUserCustomFieldFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_User_Custom_Fields_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataUserCustomFieldFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataUserCustomFieldGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_User_ManagerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataUserManagerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_User_Manager_CountArgs = {
  distinct_by?: InputMaybe<DataUserManagerDistinctByEnum>;
  filter?: InputMaybe<DataUserManagerFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_User_Manager_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataUserManagerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataUserManagerGroupByEnum;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_UsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataUserFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Users_CountArgs = {
  filter?: InputMaybe<DataUserFilterInput>;
  organization_id: Scalars['ID']['input'];
};


export type CopilotDataQueryData_Users_Group_ByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DataUserFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: DataUserGroupByEnum;
  organization_id: Scalars['ID']['input'];
};

export type CopilotKeyAnalytics = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CopilotMessageReportDataInput = {
  chat_message_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
};

export type CopilotMessageReportDataPayload = {
  __typename?: 'CopilotMessageReportDataPayload';
  download_link: Scalars['String']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  organization_id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type CopilotMessageReportDataPayloadAnalyticsMutationInternalError = AnalyticsMutationInternalError | CopilotMessageReportDataPayload;

export type CopilotMutation = {
  __typename?: 'CopilotMutation';
  accept_terms_and_conditions: DefaultDataPayloadMutationValidationErrorMutationInternalError;
  archive_copilot_planner_report: ArchiveCopilotPlannerReportResult;
  callback_whatsapp_twilio: TwilioWhatsappPayloadTwilioWhatsappErrorResponse;
  chat_conversation: ChatConversationDataPayloadMutationInternalError;
  create_conversation_from_message: ChatConversationDataPayloadMutationValidationErrorMutationInternalError;
  create_message_rating: ChatMessageRatingDataPayloadMutationValidationErrorMutationInternalError;
  create_prompt_for_analytics: CopilotPromptAnalyticsNodeMutationValidationErrorMutationInternalError;
  deactivate_message_rating: DefaultDataPayloadMutationValidationErrorMutationInternalError;
  delete_copilot_conversation: DefaultDataPayloadMutationValidationErrorMutationInternalError;
  export_copilot_planner_report_pdf: ExportCopilotPlannerReportPdfResult;
  grant_copilot_planner_report_access: GrantCopilotPlannerReportAccessResult;
  regenerate_copilot_planner_report: RegenerateCopilotPlannerReportResult;
  request_free_trial: DefaultDataPayloadMutationValidationErrorMutationInternalError;
  request_hana: DefaultDataPayloadMutationValidationErrorMutationInternalError;
  retry_chat_message: ChatConversationDataPayloadMutationValidationErrorMutationInternalError;
  revoke_copilot_planner_report_access: RevokeCopilotPlannerReportAccessResult;
  send_chat_message: ChatConversationDataPayloadMutationValidationErrorMutationInternalError;
  send_whatsapp_twilio_message: TwilioWhatsappPayloadTwilioWhatsappErrorResponse;
  unarchive_copilot_planner_report: UnarchiveCopilotPlannerReportResult;
  update_copilot_conversation: DefaultDataPayloadMutationInternalError;
  validate_smart_goals: SmartGoalsValidationPayloadMutationValidationErrorMutationInternalError;
  webhook_reply_whatsapp_twilio: TwilioWhatsappPayloadTwilioWhatsappErrorResponse;
  webhook_whatsapp_twilio: TwilioWhatsappPayloadTwilioWhatsappErrorResponse;
};


export type CopilotMutationAccept_Terms_And_ConditionsArgs = {
  organization_id: Scalars['ID']['input'];
};


export type CopilotMutationArchive_Copilot_Planner_ReportArgs = {
  input: ArchiveCopilotPlannerReportInput;
};


export type CopilotMutationCallback_Whatsapp_TwilioArgs = {
  input: CallbackTwilioWhatsapInput;
};


export type CopilotMutationChat_ConversationArgs = {
  input: ChatConversationDataInput;
};


export type CopilotMutationCreate_Conversation_From_MessageArgs = {
  input: CreateConversationFromMessageInput;
};


export type CopilotMutationCreate_Message_RatingArgs = {
  input: ChatMessageRatingDataInput;
};


export type CopilotMutationCreate_Prompt_For_AnalyticsArgs = {
  input: CreatePromptForAnalyticsInput;
};


export type CopilotMutationDeactivate_Message_RatingArgs = {
  chat_message_id: Scalars['ID']['input'];
};


export type CopilotMutationDelete_Copilot_ConversationArgs = {
  input: DeleteConversationInput;
};


export type CopilotMutationExport_Copilot_Planner_Report_PdfArgs = {
  input: ExportCopilotPlannerReportPdfInput;
};


export type CopilotMutationGrant_Copilot_Planner_Report_AccessArgs = {
  input: GrantCopilotPlannerReportAccessInput;
};


export type CopilotMutationRegenerate_Copilot_Planner_ReportArgs = {
  input: RegenerateCopilotPlannerReportInput;
};


export type CopilotMutationRequest_Free_TrialArgs = {
  organization_id: Scalars['ID']['input'];
};


export type CopilotMutationRequest_HanaArgs = {
  organization_id: Scalars['ID']['input'];
};


export type CopilotMutationRetry_Chat_MessageArgs = {
  input: RetryChatMessageInput;
};


export type CopilotMutationRevoke_Copilot_Planner_Report_AccessArgs = {
  input: RevokeCopilotPlannerReportAccessInput;
};


export type CopilotMutationSend_Chat_MessageArgs = {
  input: SendChatMessageInput;
};


export type CopilotMutationSend_Whatsapp_Twilio_MessageArgs = {
  input: SendWhatsappMessageInput;
};


export type CopilotMutationUnarchive_Copilot_Planner_ReportArgs = {
  input: UnarchiveCopilotPlannerReportInput;
};


export type CopilotMutationUpdate_Copilot_ConversationArgs = {
  input: UpdateConversationInput;
};


export type CopilotMutationValidate_Smart_GoalsArgs = {
  input: ValidateSmartGoalsInput;
};


export type CopilotMutationWebhook_Reply_Whatsapp_TwilioArgs = {
  input: WebhookReplyWhatsappTwilioInput;
};


export type CopilotMutationWebhook_Whatsapp_TwilioArgs = {
  input: WebhookTwilioWhatsapInput;
};

export type CopilotPlannerFilePayload = {
  __typename?: 'CopilotPlannerFilePayload';
  /** MIME type del archivo (p. ej. text/csv; charset=utf-8). */
  content_type: Scalars['String']['output'];
  /** Fecha/hora de generación (ISO-8601), o nulo si se desconoce. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** URL de S3 prefirmada de vida corta (Content-Disposition: attachment); expira a los expires_in segundos. */
  download_url: Scalars['String']['output'];
  /** Segundos de validez de download_url (FILES_PRESIGN_TTL). */
  expires_in: Scalars['Int']['output'];
  /** Formato del archivo (p. ej. csv, xlsx, pdf). */
  file_format: Scalars['String']['output'];
  /** Nombre del archivo. */
  filename: Scalars['String']['output'];
  /** Identificador de la operación GraphQL, para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** UUID del archivo. */
  id: Scalars['ID']['output'];
  /** UUID del reporte de tipo `file` que expone este archivo (AGNT-040): la página con su detalle y el botón de descarga, y lo que hay que compartir para que otra persona pueda bajarlo. Nulo en los archivos anteriores a esa feature, que siguen siendo descargables solo por su dueño. */
  report_id?: Maybe<Scalars['String']['output']>;
  /** Tamaño del archivo en bytes, o nulo si se desconoce. */
  size_bytes?: Maybe<Scalars['Int']['output']>;
};

export type CopilotPlannerFileResult = CopilotPlannerFilePayload | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CopilotPlannerReportAccess = {
  __typename?: 'CopilotPlannerReportAccess';
  centralized_user?: Maybe<CrehanAiCentralizedUser>;
  /** centralized_user_id del beneficiario: identidad estable del sistema centralizado (numérico, expuesto como ID). Mapea el campo user_id que devuelve el planner en GET /reports/{id}/accesses; es el id que se pasa a revoke_copilot_planner_report_access. Es la @key de federación: centralized-users lo usa para resolver el campo centralized_user. */
  centralized_user_id: Scalars['ID']['output'];
  /** Fecha de la concesión (ISO-8601), o nulo. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Siempre nulo aquí (solo se devuelven accesos vigentes); viaja en el contrato de todas formas. */
  deleted_at?: Maybe<Scalars['String']['output']>;
  /** Rol del acceso: owner | viewer. */
  role: Scalars['String']['output'];
};

export type CopilotPlannerReportAccessGrantedPayload = {
  __typename?: 'CopilotPlannerReportAccessGrantedPayload';
  /** True si la persona YA tenía acceso vigente: no se creó una concesión nueva ni se envió correo. La operación es idempotente. */
  already_had_access: Scalars['Boolean']['output'];
  /** centralized_user_id que quedó con acceso; numérico, expuesto como ID. Es el mismo que se pasa a revoke_copilot_planner_report_access. */
  centralized_user_id: Scalars['ID']['output'];
  /** Fecha de la concesión vigente (ISO-8601), o nulo. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Si el correo de aviso salió. False sin email en el input, en el caso idempotente, o si el envío falló — el acceso queda concedido igual. */
  email_sent: Scalars['Boolean']['output'];
  /** Identificador de la operación GraphQL, para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** UUID del reporte. */
  report_id: Scalars['ID']['output'];
  /** Rol del acceso resultante: viewer en un alta nueva; en el caso idempotente, el rol que la persona ya tenía (puede ser owner). */
  role: Scalars['String']['output'];
};

export type CopilotPlannerReportAccessRevokedPayload = {
  __typename?: 'CopilotPlannerReportAccessRevokedPayload';
  /** centralized_user_id cuyo acceso quedó revocado (o ya no existía); numérico, expuesto como ID. */
  centralized_user_id: Scalars['ID']['output'];
  /** Identificador de la operación GraphQL, para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** UUID del reporte. */
  report_id: Scalars['ID']['output'];
};

export type CopilotPlannerReportAccessesPayload = {
  __typename?: 'CopilotPlannerReportAccessesPayload';
  /** Accesos vigentes, ordenados por created_at (incluye el owner). */
  accesses: Array<CopilotPlannerReportAccess>;
  /** Identificador de la operación GraphQL, para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** UUID del reporte. */
  report_id: Scalars['ID']['output'];
};

export type CopilotPlannerReportAccessesResult = CopilotPlannerReportAccessesPayload | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CopilotPlannerReportArchivedPayload = {
  __typename?: 'CopilotPlannerReportArchivedPayload';
  /** Estado en el que quedó el reporte. Es siempre True acá y siempre False en el payload de restaurar: viaja para que el cliente pueda actualizar su fila sin acordarse de qué mutation llamó. */
  archived: Scalars['Boolean']['output'];
  /** Identificador de la operación GraphQL, para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** UUID del reporte que quedó archivado. */
  report_id: Scalars['ID']['output'];
};

export type CopilotPlannerReportListItem = {
  __typename?: 'CopilotPlannerReportListItem';
  /** Nombre del owner del reporte, o nulo si no está disponible. */
  author?: Maybe<Scalars['String']['output']>;
  /** Conversación en la que se generó el reporte, o nulo (AGNT-041). */
  conversation_id?: Maybe<Scalars['String']['output']>;
  /** Fecha de creación (ISO-8601, hora local del servidor), o nulo. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Id del archivo descargable de un reporte `KIND_FILE` ya completado (AGNT-054): con él el cliente arma el enlace de descarga y ofrece bajar el archivo desde el listado, sin abrir el reporte. **Nulo no significa solo «no es un archivo»**: también llega nulo un `KIND_FILE` que todavía se está generando, porque su spec placeholder no trae el `file_card`, así que la condición para dibujar el botón es ESTE campo y no `kind`. No se gatea por rol, a diferencia de `viewers`: la descarga autoriza a quien tiene acceso vigente al reporte, sea dueño o viewer. */
  file_id?: Maybe<Scalars['String']['output']>;
  /** UUID del reporte. */
  id: Scalars['ID']['output'];
  /** Tipo de reporte: KIND_DASHBOARD (métricas) o KIND_DOCUMENT (narrativo Markdown). Define el ícono del índice (AGNT-026). */
  kind: PlannerReportKindEnum;
  /** True si el reporte tiene receta y se puede volver a generar (AGNT-041). */
  regenerable: Scalars['Boolean']['output'];
  /** Rol del solicitante sobre el reporte: owner | viewer. */
  role: Scalars['String']['output'];
  /** True si el reporte tiene al menos un acceso viewer vigente (badge «Compartido» en el índice, AGNT-026). */
  shared: Scalars['Boolean']['output'];
  /** Cuántas personas tienen acceso viewer vigente (AGNT-053). Alimenta «Compartido con 5 personas» y viaja para CUALQUIER fila: es un número, no dice con quién. */
  shared_count: Scalars['Int']['output'];
  /** Estado efectivo del reporte (AGNT-041). Alimenta el chip «Generándose» (STATUS_CREATED/STATUS_PENDING) o «Falló» (STATUS_FAILED); STATUS_COMPLETED no lleva chip, es el caso normal. */
  status: PlannerReportStatusEnum;
  /** Título del reporte. */
  title: Scalars['String']['output'];
  /** URL canónica de preview del reporte (build_report_url). */
  url: Scalars['String']['output'];
  /** Los primeros colaboradores (tope del upstream: 3), para la pila de avatares. Llega VACÍO cuando `role` es viewer: quien recibió un reporte ve que está compartido, no con quién — la misma regla que hace owner-only a get_copilot_planner_report_accesses. El gateo lo aplica el planner, no este subgraph. */
  viewers: Array<CopilotPlannerReportViewer>;
};

export type CopilotPlannerReportPdfExportedPayload = {
  __typename?: 'CopilotPlannerReportPdfExportedPayload';
  /** Identificador de la operación GraphQL, para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** UUID del reporte NUEVO (de tipo file), en estado created. Es el que hay que mostrar; el de origen no cambió. */
  report_id: Scalars['ID']['output'];
  /** UUID del reporte exportado (linaje). */
  source_report_id: Scalars['ID']['output'];
  /** Título del reporte de origen (para el copy: «Generando el PDF de X…»). El del artefacto es el mismo con el sufijo « (PDF)». */
  source_title?: Maybe<Scalars['String']['output']>;
  /** Estado del artefacto al crearse: siempre 'created'. */
  status: Scalars['String']['output'];
  /** URL de la página del artefacto. Ya se puede abrir: dice que se está generando y se completa sola. */
  url: Scalars['String']['output'];
};

export type CopilotPlannerReportPromptPayload = {
  __typename?: 'CopilotPlannerReportPromptPayload';
  /** Fecha en que se guardó la receta (ISO-8601), o nulo. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Identificador de la operación GraphQL, para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Instrucciones por pasos, con las variables YA resueltas: es exactamente lo que ejecutaría una regeneración. Los saltos de línea son parte del contenido (son pasos numerados), así que hay que renderizarlo preformateado. Es texto del usuario: escaparlo al mostrarlo. */
  prompt: Scalars['String']['output'];
  /** UUID del reporte. */
  report_id: Scalars['ID']['output'];
  /** Nombre de la receta (por defecto, el título del reporte): es el nombre que el modelo le puso a lo reproducible. */
  title: Scalars['ID']['output'];
};

export type CopilotPlannerReportPromptResult = CopilotPlannerReportPromptPayload | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CopilotPlannerReportRegeneratedPayload = {
  __typename?: 'CopilotPlannerReportRegeneratedPayload';
  /** Conversación creada para hospedar la corrida. La respuesta del agente y el reporte terminado aparecen ahí, y el usuario puede continuarla. */
  chat_conversation_id: Scalars['ID']['output'];
  /** Mensaje que dispara la corrida. Su response_report ya apunta al reporte nuevo, antes de que la generación empiece. */
  chat_message_id: Scalars['ID']['output'];
  /** Identificador de la operación GraphQL, para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** UUID del reporte NUEVO, en estado created. Es el que hay que mostrar; el de origen no cambió. */
  report_id: Scalars['ID']['output'];
  /** UUID del reporte de origen (linaje). */
  source_report_id: Scalars['ID']['output'];
  /** Título del reporte de origen (para el copy: «Regenerando X…»). */
  source_title?: Maybe<Scalars['String']['output']>;
  /** Estado del reporte nuevo al crearse: siempre 'created'. */
  status: Scalars['String']['output'];
  /** URL de la página del reporte nuevo (ya visitable). */
  url: Scalars['String']['output'];
  /** Valores efectivos usados (override + defaults de la receta). */
  variables?: Maybe<Scalars['JSON']['output']>;
};

export type CopilotPlannerReportUnarchivedPayload = {
  __typename?: 'CopilotPlannerReportUnarchivedPayload';
  /** Estado en el que quedó el reporte: siempre False acá. */
  archived: Scalars['Boolean']['output'];
  /** Identificador de la operación GraphQL, para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** UUID del reporte que quedó restaurado. */
  report_id: Scalars['ID']['output'];
};

export type CopilotPlannerReportValuesPayload = {
  __typename?: 'CopilotPlannerReportValuesPayload';
  /** Nombre del dueño (autor) del reporte, o nulo (footer, AGNT-026). */
  author?: Maybe<Scalars['String']['output']>;
  /** Componentes del reporte, en orden, con sus valores crudos. */
  components: Array<PlannerReportComponent>;
  /** Conversación en la que se generó el reporte, o nulo (AGNT-041). */
  conversation_id?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora de generación (ISO-8601) o nulo. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Duración del plan que lo generó, en segundos, o nulo. */
  duration_time?: Maybe<Scalars['Float']['output']>;
  /** True si el reporte se puede exportar a PDF con export_copilot_planner_report_pdf (AGNT-051). Lo resuelve el planner, que combina el tipo (un file ya es un archivo), el estado (solo uno terminado tiene contenido) y si la feature está encendida en su despliegue — esa última condición el cliente no puede conocerla. NO incluye la pertenencia: dice si el reporte es exportable, no si quien pregunta puede hacerlo; eso se resuelve con la señal de owner, igual que con regenerable. */
  exportable: Scalars['Boolean']['output'];
  /** Por qué falló la generación, con status STATUS_FAILED (AGNT-050); nulo en cualquier otro estado. Es lo que permite a la página decir QUÉ pasó y no solo que falló. Si la corrida quedó varada —el proceso murió sin poder cerrar la fila— el motivo lo aporta el Planner Agent, porque no hay ninguno guardado. */
  failure_reason?: Maybe<Scalars['String']['output']>;
  /** Identificador de la operación GraphQL, para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** UUID del reporte. */
  id: Scalars['ID']['output'];
  /** Tipo de reporte: KIND_DASHBOARD (grilla de métricas), KIND_DOCUMENT (narrativo Markdown, AGNT-025) o KIND_FILE (ficha de un archivo descargable, AGNT-040). Define el layout al renderizar. */
  kind: PlannerReportKindEnum;
  /** Módulo de Talent del que habla el reporte (AGNT-060): 'competencias', 'metas', 'clima' o 'desempeno'; nulo si el reporte no es de Talent. Río arriba fija con qué componentes se puede armar; acá viaja para que el consumidor sepa qué está mirando sin tener que inferirlo de los componentes. */
  module?: Maybe<Scalars['String']['output']>;
  /** True si el reporte tiene receta guardada y se puede volver a generar con regenerate_copilot_planner_report (AGNT-041). */
  regenerable: Scalars['Boolean']['output'];
  /** Escala del semáforo del reporte, declarada UNA vez (AGNT-053 §b). Las celdas, las cifras, las donas y los puntos de una serie la referencian por `key`, así que sin ella un `state` no se puede resolver y el consumidor tiene que caer a neutral. El vocabulario es de la organización: dos reportes del mismo módulo pueden traer escalas distintas, y uno solo puede traer más de una (Metas y Clima lo hacen). */
  scale: Array<PlannerReportScaleLevel>;
  /** Estado efectivo del reporte (AGNT-041). Si no es STATUS_COMPLETED, los `components` son un placeholder («este reporte se está generando»), no el contenido: antes de tratar un reporte como contenido —cachearlo, contarlo, enviarlo por correo— hay que mirar este campo. */
  status: PlannerReportStatusEnum;
  /** Título de la página del reporte. */
  title: Scalars['String']['output'];
};

export type CopilotPlannerReportValuesResult = CopilotPlannerReportValuesPayload | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CopilotPlannerReportViewer = {
  __typename?: 'CopilotPlannerReportViewer';
  /** centralized_user_id del colaborador: identidad estable del sistema centralizado (numérico, expuesto como ID). Es la @key de federación. */
  centralized_user_id: Scalars['ID']['output'];
  /** Nombre denormalizado en el acceso, para las iniciales de la pila. Puede ser nulo en accesos viejos que no lo guardaron: es un respaldo de display, no la fuente autoritativa del nombre. */
  full_name?: Maybe<Scalars['String']['output']>;
};

export type CopilotPlannerReportsPayload = {
  __typename?: 'CopilotPlannerReportsPayload';
  /** Identificador de la operación GraphQL, para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** True si hay más páginas después de la actual. */
  has_more: Scalars['Boolean']['output'];
  /** Offset de la siguiente página, o nulo si no hay más. */
  next_offset?: Maybe<Scalars['Int']['output']>;
  /** Reportes de la página actual, en el orden que devuelve el upstream. */
  reports: Array<CopilotPlannerReportListItem>;
  /** Total de reportes visibles (todas las páginas). */
  total: Scalars['Int']['output'];
};

export type CopilotPlannerReportsResult = CopilotPlannerReportsPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CopilotPromptAnalyticsNode = {
  __typename?: 'CopilotPromptAnalyticsNode';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
};

export type CopilotPromptAnalyticsNodeMutationValidationErrorMutationInternalError = CopilotPromptAnalyticsNode | MutationInternalError | MutationValidationError;

export type CopilotPromptNode = {
  __typename?: 'CopilotPromptNode';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  template?: Maybe<TemplateNode>;
};

export type CopilotQuery = {
  __typename?: 'CopilotQuery';
  get_chat_message?: Maybe<ChatMessage>;
  get_chat_messages: Array<ChatMessage>;
  get_content_search: ContentSearchConnection;
  get_conversations: ChatConversationConnection;
  get_copilot_planner_file: CopilotPlannerFileResult;
  get_copilot_planner_report_accesses: CopilotPlannerReportAccessesResult;
  get_copilot_planner_report_prompt: CopilotPlannerReportPromptResult;
  get_copilot_planner_report_values: CopilotPlannerReportValuesResult;
  get_copilot_planner_reports: CopilotPlannerReportsResult;
  get_goals_attempts: Array<GoalsAttempt>;
};


export type CopilotQueryGet_Chat_MessageArgs = {
  chat_message_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
};


export type CopilotQueryGet_Chat_MessagesArgs = {
  chat_conversation_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
};


export type CopilotQueryGet_Content_SearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
  search_input: Scalars['String']['input'];
};


export type CopilotQueryGet_ConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from_date?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
  pin_conversation?: InputMaybe<Scalars['Boolean']['input']>;
  to_date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type CopilotQueryGet_Copilot_Planner_FileArgs = {
  input: GetCopilotPlannerFileInput;
};


export type CopilotQueryGet_Copilot_Planner_Report_AccessesArgs = {
  input: GetCopilotPlannerReportAccessesInput;
};


export type CopilotQueryGet_Copilot_Planner_Report_PromptArgs = {
  input: GetCopilotPlannerReportPromptInput;
};


export type CopilotQueryGet_Copilot_Planner_Report_ValuesArgs = {
  input: GetCopilotPlannerReportValuesInput;
};


export type CopilotQueryGet_Copilot_Planner_ReportsArgs = {
  input: GetCopilotPlannerReportsInput;
};


export type CopilotQueryGet_Goals_AttemptsArgs = {
  goals_session_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
};

export type CopilotReportMutation = {
  __typename?: 'CopilotReportMutation';
  copilot_message_report: CopilotMessageReportDataPayloadAnalyticsMutationInternalError;
};


export type CopilotReportMutationCopilot_Message_ReportArgs = {
  input: CopilotMessageReportDataInput;
};

export enum CopyCourseTypeEnum {
  CopyCourseTypeAll = 'COPY_COURSE_TYPE_ALL',
  CopyCourseTypeInformation = 'COPY_COURSE_TYPE_INFORMATION',
  CopyCourseTypeModule = 'COPY_COURSE_TYPE_MODULE'
}

export type CoreContentMutations = {
  __typename?: 'CoreContentMutations';
  /** Content Emails validation by excel! */
  email_validation_by_excel: EmailValidationResponse;
};


export type CoreContentMutationsEmail_Validation_By_ExcelArgs = {
  input: EmailValidationByExcel;
};

export type CoreCountryPayload = BenefitGraphQlOperation & {
  __typename?: 'CoreCountryPayload';
  countries: CountryTypeListType;
  graphql_operation_id: Scalars['ID']['output'];
};

export type CoreCountryResponse = CoreCountryPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type CoreMutationNode = {
  __typename?: 'CoreMutationNode';
  /**
   * This object contains information about the response code,
   *         response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CoreResponseNode = {
  __typename?: 'CoreResponseNode';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Subgraph HRIS - Corporate Document V2 Node */
export type CorporateDocumentV2Node = {
  __typename?: 'CorporateDocumentV2Node';
  /** List of allowed document formats */
  allowed_formats: Array<DocumentFileFormatEnum>;
  /** Document Assignment Date */
  assigned_at?: Maybe<Scalars['DateTime']['output']>;
  /** Document Creation Date */
  created_at: Scalars['DateTime']['output'];
  /** Document Deadline */
  deadline?: Maybe<Scalars['DateTime']['output']>;
  /** Document Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Document Type */
  document_type: DocumentFileTypeEnum;
  /** Document File ID */
  file_id?: Maybe<Scalars['Int']['output']>;
  /** Document File Info */
  file_info?: Maybe<File>;
  /** Folder ID */
  folder_id?: Maybe<Scalars['Int']['output']>;
  /** True if document has users */
  has_users: Scalars['Boolean']['output'];
  /** ID */
  id: Scalars['Int']['output'];
  /** Document Identifier */
  identifier: Scalars['String']['output'];
  /** Document location */
  location?: Maybe<Scalars['String']['output']>;
  /** Document Name */
  name: Scalars['String']['output'];
  /** Document Status */
  status?: Maybe<DocumentFileStateEnum>;
  /** User Document Progress */
  total_progress: Scalars['Int']['output'];
  /** Uploaded format only for Reading documents */
  uploaded_format?: Maybe<DocumentFileFormatEnum>;
};

/** Subgraph HRIS - Corporate Document V2 Node List */
export type CorporateDocumentV2NodeList = {
  __typename?: 'CorporateDocumentV2NodeList';
  /** List of documents */
  items: Array<CorporateDocumentV2Node>;
  /** Total count of documents */
  total_count: Scalars['Int']['output'];
};

export type CorporateDocumentsMutations = {
  __typename?: 'CorporateDocumentsMutations';
  /** Create document verification code */
  confirm_signature_document_verification_code: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  /** Create document verification code */
  create_document_verification_code: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  /** Create a signature document */
  create_signature_document: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
};


export type CorporateDocumentsMutationsConfirm_Signature_Document_Verification_CodeArgs = {
  input: ConfirmSignatureDocumentVerificationCodeInput;
};


export type CorporateDocumentsMutationsCreate_Document_Verification_CodeArgs = {
  input: CreateDocumentVerificationCodeInput;
};


export type CorporateDocumentsMutationsCreate_Signature_DocumentArgs = {
  input: CreateSignatureDocumentInput;
};

export type CorporateDocumentsQueries = {
  __typename?: 'CorporateDocumentsQueries';
  /** Get signature document template fields */
  get_signature_document_template_fields: DocumentAutocompleteFieldsTemplateNodeHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError;
  /** Get a Document Template by ID */
  get_template_from_document_id?: Maybe<DocumentTemplateNode>;
  /** Get a User Document template by ID */
  get_template_from_user_document_id?: Maybe<UserDocumentTemplateNode>;
  /** Gets User Document by ID */
  get_user_document_by_id: DocumentUserProfileInfoNodeHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError;
};


export type CorporateDocumentsQueriesGet_Signature_Document_Template_FieldsArgs = {
  file_id: Scalars['Int']['input'];
};


export type CorporateDocumentsQueriesGet_Template_From_Document_IdArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  document_id: Scalars['Int']['input'];
};


export type CorporateDocumentsQueriesGet_Template_From_User_Document_IdArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  user_document_id: Scalars['Int']['input'];
};


export type CorporateDocumentsQueriesGet_User_Document_By_IdArgs = {
  input: GetUserDocumentByIdInput;
};

export type CorporateOrganizationsPayload = {
  __typename?: 'CorporateOrganizationsPayload';
  corporation: CrehanaAuthOrganization;
  organizations: Array<CrehanaAuthOrganization>;
};

export type CorporationMutations = {
  __typename?: 'CorporationMutations';
  /** Create child companies. */
  create_child_companies: CreateChildCompaniesPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse;
  /** Update children company. */
  update_children_org: CentralizedUpdateCorporationChildrenOrgPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse;
};


export type CorporationMutationsCreate_Child_CompaniesArgs = {
  input: CreateChildCompaniesMutationInput;
};


export type CorporationMutationsUpdate_Children_OrgArgs = {
  input: CentralizedCorporationsUpdateChildrenCompanyInput;
};

export type CorporationQueries = {
  __typename?: 'CorporationQueries';
  centralized_organizations_licenses: LicenseQueries;
  check_company_name: CheckCompanyNameQuery;
  check_slug: CheckSlugQuery;
  children_companies: GetChildrenCompaniesQuery;
  navigation_data: NavigationDataQuery;
};

export type CorporationUserOrganizationAuth = {
  __typename?: 'CorporationUserOrganizationAuth';
  authentication_url: Scalars['String']['output'];
  method: AuthenticationMethodEnum;
  provider: AuthenticationProviderEnum;
};

export type CorporationUserOrganizationAuthPayload = {
  __typename?: 'CorporationUserOrganizationAuthPayload';
  authentication_methods: Array<CorporationUserOrganizationAuth>;
  user_organization: CrehanaAuthUserOrganization;
};

export type CorporationsCorporationLicenseUsage = {
  __typename?: 'CorporationsCorporationLicenseUsage';
  licenses_used: Scalars['Int']['output'];
  usage_percentage: Scalars['Int']['output'];
};

export type CorporationsNotFoundResponseError = {
  __typename?: 'CorporationsNotFoundResponseError';
  code?: Maybe<Scalars['Int']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type CorporationsOrganizationLicenseUsage = {
  __typename?: 'CorporationsOrganizationLicenseUsage';
  licenses_assigned: Scalars['Int']['output'];
  organization_id: Scalars['Int']['output'];
  organization_name: Scalars['String']['output'];
  usage_percentage: Scalars['Int']['output'];
};

export type CorporationsResponseIntegrityError = {
  __typename?: 'CorporationsResponseIntegrityError';
  code?: Maybe<Scalars['Int']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type CorporationsResponseInternalError = {
  __typename?: 'CorporationsResponseInternalError';
  code?: Maybe<Scalars['Int']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type CorporationsResponseValidationError = {
  __typename?: 'CorporationsResponseValidationError';
  attribute_value: Scalars['String']['output'];
  code?: Maybe<Scalars['Int']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type CosignerDocumentInput = {
  cosigner_type: DocumentCosignerUserTypeEnum;
  role?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export enum CountryCodeEnum {
  All = 'ALL',
  Argentina = 'ARGENTINA',
  Bolivia = 'BOLIVIA',
  Brazil = 'BRAZIL',
  Chile = 'CHILE',
  Colombia = 'COLOMBIA',
  CostaRica = 'COSTA_RICA',
  Cuba = 'CUBA',
  DominicanRepublic = 'DOMINICAN_REPUBLIC',
  Ecuador = 'ECUADOR',
  ElSalvador = 'EL_SALVADOR',
  Guatemala = 'GUATEMALA',
  Honduras = 'HONDURAS',
  Mexico = 'MEXICO',
  Nicaragua = 'NICARAGUA',
  Panama = 'PANAMA',
  Paraguay = 'PARAGUAY',
  Peru = 'PERU',
  PuertoRico = 'PUERTO_RICO',
  UnitedStates = 'UNITED_STATES',
  Uruguay = 'URUGUAY',
  Venezuela = 'VENEZUELA'
}

export type CountryCodeEnumListType = {
  __typename?: 'CountryCodeEnumListType';
  items: Array<CountryCodeEnum>;
  total_count: Scalars['Int']['output'];
  total_filtered: Scalars['Int']['output'];
};

export type CountryCodeType = {
  __typename?: 'CountryCodeType';
  enum: CountryCodeEnum;
  iso: Scalars['String']['output'];
};

/** Centralized Country Node */
export type CountryNode = {
  __typename?: 'CountryNode';
  /** Country 2 char value */
  alpha_2: Scalars['String']['output'];
  /** Country 3 char value */
  alpha_3: Scalars['String']['output'];
  /** Country name */
  name: Scalars['String']['output'];
  /** Country numeric value */
  numeric: Scalars['String']['output'];
};

export type CountryType = {
  __typename?: 'CountryType';
  country_code: CountryCodeType;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CountryTypeListType = {
  __typename?: 'CountryTypeListType';
  items: Array<CountryType>;
  total_count: Scalars['Int']['output'];
  total_filtered: Scalars['Int']['output'];
};

export type CountsByStatus = {
  __typename?: 'CountsByStatus';
  approved: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
};

export type CountsByType = {
  __typename?: 'CountsByType';
  altas: Scalars['Int']['output'];
  bajas: Scalars['Int']['output'];
  modificaciones: Scalars['Int']['output'];
  reingresos: Scalars['Int']['output'];
};

export type Course = {
  __typename?: 'Course';
  attached_files_url?: Maybe<Scalars['String']['output']>;
  attachment_set?: Maybe<Scalars['Void']['output']>;
  attachments: Scalars['Int']['output'];
  background_color?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Category>;
  comments: Scalars['Int']['output'];
  course_type?: Maybe<Scalars['String']['output']>;
  course_type_enum?: Maybe<CourseTypeEnum>;
  course_type_node?: Maybe<CourseTypeNode>;
  created_date: Scalars['DateTime']['output'];
  dashboard_url?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  due_date?: Maybe<Scalars['DateTime']['output']>;
  duration: Scalars['Int']['output'];
  enrollments: Scalars['Int']['output'];
  first_video_lecture_url?: Maybe<UrlNode>;
  has_certification_available?: Maybe<Scalars['Boolean']['output']>;
  has_review?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  is_mandatory?: Maybe<Scalars['Boolean']['output']>;
  last_video_event?: Maybe<Scalars['Void']['output']>;
  last_video_lecture_url?: Maybe<UrlNode>;
  launch_date?: Maybe<Scalars['DateTime']['output']>;
  level?: Maybe<Level>;
  meta_description: Scalars['String']['output'];
  meta_keywords: Scalars['String']['output'];
  meta_title?: Maybe<Scalars['String']['output']>;
  modified_date?: Maybe<Scalars['DateTime']['output']>;
  modules: Array<CourseModule>;
  order_date?: Maybe<Scalars['DateTime']['output']>;
  permissions_v2?: Maybe<Scalars['Void']['output']>;
  player_url?: Maybe<UrlNode>;
  price: Scalars['Float']['output'];
  professor?: Maybe<User>;
  professor_id?: Maybe<Scalars['ID']['output']>;
  professor_node?: Maybe<ProfessorNode>;
  progress?: Maybe<Scalars['Int']['output']>;
  project_guide_description?: Maybe<Scalars['String']['output']>;
  project_guide_title?: Maybe<Scalars['String']['output']>;
  promo_image?: Maybe<ImageNode>;
  publish_date?: Maybe<Scalars['DateTime']['output']>;
  score: Scalars['Float']['output'];
  slug: Scalars['String']['output'];
  subcategory?: Maybe<Subcategory>;
  subtitle?: Maybe<Array<Scalars['String']['output']>>;
  temporal_access_seconds_to_finish?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  trailer_source?: Maybe<CourseVideoTrailerNode>;
  url?: Maybe<Scalars['String']['output']>;
  videos: Scalars['String']['output'];
};

export type CourseAccessGrantedPayload = GraphOperationI & {
  __typename?: 'CourseAccessGrantedPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

export type CourseActorInput = {
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  learning_user_id?: InputMaybe<Scalars['ID']['input']>;
  system_process_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<AuditLogCourseActorTypeEnum>;
};

export type CourseAnalytics = {
  __typename?: 'CourseAnalytics';
  certified_count?: Maybe<Scalars['Int']['output']>;
  completed_course?: Maybe<Scalars['Int']['output']>;
  course?: Maybe<Course>;
  course_id: Scalars['ID']['output'];
  inscribed_course?: Maybe<Scalars['Int']['output']>;
  percent_progress?: Maybe<Scalars['Int']['output']>;
  started_course?: Maybe<Scalars['Int']['output']>;
};

export type CourseApprovalRequirementFragment = ProjectRequirementType | QuizRequirementType;

export type CourseAssignMentorPayload = {
  __typename?: 'CourseAssignMentorPayload';
  course?: Maybe<PrivateCourseType>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CourseAssignMentorResponse = CourseAssignMentorPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type CourseAuditLogOrderByInput = {
  direction: OrderDirectionEnum;
  field: AuditLogOrderFieldEnum;
};

export type CourseAutomatedTaskType = {
  __typename?: 'CourseAutomatedTaskType';
  company_id: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  object_id: Scalars['Int']['output'];
  result_data: Scalars['String']['output'];
  result_data_json: Scalars['String']['output'];
  started_at?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  task_type: Scalars['String']['output'];
};

export type CourseAutomationRuleType = {
  __typename?: 'CourseAutomationRuleType';
  course?: Maybe<PrivateCourseType>;
  course_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type CourseAutomationRuleTypeListResponse = {
  __typename?: 'CourseAutomationRuleTypeListResponse';
  items: Array<CourseAutomationRuleType>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type CourseBuilderMutations = {
  __typename?: 'CourseBuilderMutations';
  /** Mutation to assign a mentor to a Course. */
  assign_mentors: CourseAssignMentorResponse;
  /** Mutation to copy a Course. */
  copy_course: CourseResponse;
  /** Mutation to create a Course. */
  create_course: CourseResponse;
  /** Mutation to delete a Course. */
  delete_course: CourseDeleteResponse;
  /** Mutation to publish a Course. */
  publish_course: CourseResponse;
  /** Mutation to update a Course. */
  update_course: CourseResponse;
  /** Update (increment) the accumulated watch time for a user on a video lecture */
  update_user_course_watch_time: UpdateUserCourseWatchTimeResponse;
};


export type CourseBuilderMutationsAssign_MentorsArgs = {
  input: CourseStudioAssignMentorInput;
};


export type CourseBuilderMutationsCopy_CourseArgs = {
  input: CourseStudioCopyInput;
};


export type CourseBuilderMutationsCreate_CourseArgs = {
  input: CourseStudioCreateInput;
};


export type CourseBuilderMutationsDelete_CourseArgs = {
  input: CourseStudioDeleteInput;
};


export type CourseBuilderMutationsPublish_CourseArgs = {
  input: CourseStudioPublishInput;
};


export type CourseBuilderMutationsUpdate_CourseArgs = {
  input: CourseStudioUpdateInput;
};


export type CourseBuilderMutationsUpdate_User_Course_Watch_TimeArgs = {
  input: UpdateUserCourseWatchTimeInput;
};

export type CourseCertificatePolicyNode = {
  __typename?: 'CourseCertificatePolicyNode';
  auto_reassign: Scalars['Boolean']['output'];
  course_id: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  notify_push: Scalars['Boolean']['output'];
  organization_id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['Int']['output']>;
  validity_days: Scalars['Int']['output'];
};

export type CourseCertificatePolicyResponsePayload = {
  __typename?: 'CourseCertificatePolicyResponsePayload';
  course_certificate_policy: CourseCertificatePolicyNode;
};

export type CourseCertificationRuleNode = {
  __typename?: 'CourseCertificationRuleNode';
  certification_by_progress?: Maybe<Scalars['Boolean']['output']>;
  certification_by_project?: Maybe<Scalars['Boolean']['output']>;
  certification_by_quizz?: Maybe<Scalars['Boolean']['output']>;
  certification_participate?: Maybe<Scalars['Boolean']['output']>;
  course_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  organization_id: Scalars['Int']['output'];
};

export type CourseComponentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<AuditLogCourseComponentEnum>;
};

export enum CourseComponentTypeEnum {
  AccessAndRequirements = 'ACCESS_AND_REQUIREMENTS',
  Basic = 'BASIC',
  CertificationRequirement = 'CERTIFICATION_REQUIREMENT',
  Config = 'CONFIG',
  MentoringAssignment = 'MENTORING_ASSIGNMENT',
  Module = 'MODULE',
  VideoLecture = 'VIDEO_LECTURE'
}

export type CourseConfigType = StudioCourseConfigCertificationAvailableI & StudioCourseConfigInterface & StudioCourseConfigMandatoryI & StudioCourseConfigRequirementI & StudioCourseConfigVisibilityStateI & {
  __typename?: 'CourseConfigType';
  approval_requirement_enum: ApprovalRequirementStudioEnum;
  has_certification_available?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_mandatory?: Maybe<Scalars['Boolean']['output']>;
  requirements?: Maybe<CourseApprovalRequirementFragment>;
  visibility_state?: Maybe<StudioCourseConfigStateEnum>;
};

/** A connection to a list of items. */
export type CourseConnection = {
  __typename?: 'CourseConnection';
  /** Contains the nodes in this connection */
  edges: Array<CourseEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type CourseCreateInput = {
  level_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CourseDeletePayload = {
  __typename?: 'CourseDeletePayload';
  course?: Maybe<PrivateCourseType>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CourseDeleteResponse = CourseDeletePayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type CourseDependencieStatusNode = {
  __typename?: 'CourseDependencieStatusNode';
  course_dependency?: Maybe<Array<Course>>;
  course_id: Scalars['Int']['output'];
  is_blocked: Scalars['Boolean']['output'];
  organization_team_id?: Maybe<Scalars['Int']['output']>;
};

export type CourseDetailInput = {
  course_id: Scalars['ID']['input'];
};

export type CourseDetailPayload = GraphOperationI & {
  __typename?: 'CourseDetailPayload';
  course: ContentCourseNode;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

export type CourseDetailResponse = CourseDetailPayload | CourseIsHiddenType | CourseNotBelongType | CourseNotExistType | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

/** An edge in a connection. */
export type CourseEdge = {
  __typename?: 'CourseEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Course;
};

export type CourseFederationNode = {
  __typename?: 'CourseFederationNode';
  course?: Maybe<Course>;
  course_id: Scalars['ID']['output'];
};

export type CourseFederationNodePaginationEdge = {
  __typename?: 'CourseFederationNodePaginationEdge';
  /** The item at the end of the edge. */
  node: CourseFederationNode;
};

export type CourseFilterByInput = {
  has_certification_available?: InputMaybe<Scalars['Boolean']['input']>;
  is_mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  visibility_state?: InputMaybe<StudioCourseConfigStateEnum>;
};

/** Input for course connection query [Admin]. */
export type CourseFilterInput = {
  filter_by?: InputMaybe<CourseFilterByInput>;
  first?: Scalars['Int']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_draft?: InputMaybe<Scalars['Boolean']['input']>;
  knowledge_hub_visibility?: InputMaybe<VisibilityLevelType>;
  order_by?: InputMaybe<Array<CourseInputOrderBy>>;
  organization_id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search_key?: InputMaybe<Scalars['String']['input']>;
};

/** Course entry for the 'by course' project filter list [Admin]. */
export type CourseForProjectFilterType = {
  __typename?: 'CourseForProjectFilterType';
  course_id: Scalars['ID']['output'];
  grade_type?: Maybe<GradeTypeEnum>;
  max_grade?: Maybe<Scalars['Int']['output']>;
  min_grade?: Maybe<Scalars['Int']['output']>;
  passing_grade?: Maybe<Scalars['Int']['output']>;
  project_count: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/** Input for course detail query [Admin]. */
export type CourseGetInput = {
  course_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
};

/** Course */
export type CourseI = {
  background_color?: Maybe<Scalars['String']['output']>;
  best_seller?: Maybe<Scalars['Boolean']['output']>;
  course_attachments_set: Array<AttachmentType>;
  course_type?: Maybe<CourseTypeEnum>;
  description: Scalars['String']['output'];
  discount: Scalars['Int']['output'];
  duration: Scalars['Int']['output'];
  exclude: Scalars['Boolean']['output'];
  has_certificate?: Maybe<Scalars['Boolean']['output']>;
  home_image?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_flagship?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  meta_description: Scalars['String']['output'];
  meta_keywords: Scalars['String']['output'];
  meta_title?: Maybe<Scalars['String']['output']>;
  popular: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  professor_id?: Maybe<Scalars['Int']['output']>;
  promo_image?: Maybe<SimpleFile>;
  promo_image_video?: Maybe<Scalars['String']['output']>;
  promo_video?: Maybe<Scalars['String']['output']>;
  promo_video_hashed_id: Scalars['String']['output'];
  short_description?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  videos: Scalars['Int']['output'];
};

export type CourseInputOrderBy = {
  direction: OrderDirectionEnum;
  field: CourseOrderByEnum;
};

export type CourseIsHiddenType = {
  __typename?: 'CourseIsHiddenType';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CourseMetadataType = {
  __typename?: 'CourseMetadataType';
  total_count: Scalars['Int']['output'];
  total_draft: Scalars['Int']['output'];
  total_filtered: Scalars['Int']['output'];
  total_public: Scalars['Int']['output'];
};

export type CourseMetricsQuery = {
  __typename?: 'CourseMetricsQuery';
  course_statistic_summary: CourseSummaryMetricNode;
  course_statistics: CourseStatisticsNodeConnection;
  course_tracks_statistics: CourseRouteMetricConnection;
  course_user_statistic: CourseUserMetricNodeConnection;
};


export type CourseMetricsQueryCourse_Statistic_SummaryArgs = {
  course_id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type CourseMetricsQueryCourse_StatisticsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  is_crehana?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search_key?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  sort_by?: InputMaybe<Scalars['String']['input']>;
};


export type CourseMetricsQueryCourse_Tracks_StatisticsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  course_id: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};


export type CourseMetricsQueryCourse_User_StatisticArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  course_id: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  list_enrollment_status?: InputMaybe<Array<EnrollmentStatusEnum>>;
  search_key?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type CourseMirrorRetriesNode = {
  __typename?: 'CourseMirrorRetriesNode';
  course_id?: Maybe<Scalars['Int']['output']>;
  retries?: Maybe<Scalars['Int']['output']>;
};

export type CourseMirrorUserValidationNode = {
  __typename?: 'CourseMirrorUserValidationNode';
  can_generate_questions: Scalars['Boolean']['output'];
};

export type CourseModule = {
  __typename?: 'CourseModule';
  created_date: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration_module?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  videos: Array<CourseVideo>;
  zipped_attachment?: Maybe<Scalars['String']['output']>;
};

export type CourseModuleCreateInput = {
  course_id: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  organization_id: Scalars['String']['input'];
};

export type CourseModuleDeleteInput = {
  course_module_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
};

export type CourseModuleDeleteResponse = CourseModulePayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type CourseModuleMutations = {
  __typename?: 'CourseModuleMutations';
  /** Mutation to create a CourseModule. */
  create_course_module: CourseModuleResponse;
  /** Mutation to delete a CourseModule. */
  delete_course_module: CourseModuleDeleteResponse;
  /** Mutation to update a CourseModule. */
  update_course_module: CourseModuleUpdateResponse;
};


export type CourseModuleMutationsCreate_Course_ModuleArgs = {
  input: CourseModuleCreateInput;
};


export type CourseModuleMutationsDelete_Course_ModuleArgs = {
  input: CourseModuleDeleteInput;
};


export type CourseModuleMutationsUpdate_Course_ModuleArgs = {
  input: CourseModuleUpdateInput;
};

export type CourseModulePayload = VideoLectureTypePdfGraphOperationI & {
  __typename?: 'CourseModulePayload';
  course_module: PrivateCourseModuleType;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CourseModuleResponse = CourseModulePayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type CourseModuleUpdate = {
  course_id: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type CourseModuleUpdateInput = {
  course_modules: Array<CourseModuleUpdate>;
  organization_id: Scalars['ID']['input'];
};

export type CourseModuleUpdatePayload = VideoLectureTypePdfGraphOperationI & {
  __typename?: 'CourseModuleUpdatePayload';
  course_modules: Array<PrivateCourseModuleType>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  messages?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updated_count?: Maybe<Scalars['Int']['output']>;
};

export type CourseModuleUpdateResponse = CourseModuleUpdatePayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type CourseNotBelongType = {
  __typename?: 'CourseNotBelongType';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CourseNotExistType = {
  __typename?: 'CourseNotExistType';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CourseOptions = {
  __typename?: 'CourseOptions';
  course_id: Scalars['ID']['output'];
  disable_video_seeking: Scalars['Boolean']['output'];
  force_sequential_completion: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  organization_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum CourseOrderByEnum {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

export type CourseOrganizationTemplateData = {
  course_id: Scalars['Int']['input'];
  /** Accepted for backwards compatibility but ignored by create/update. Only the delete mutation uses this field via DeleteCourseOrganizationTemplateInput. */
  course_organization_template_id?: InputMaybe<Scalars['ID']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Primary organization template ID (diploma). Optional: when omitted alongside organization_template_id_secondary, the course is left without any active certificate template (both are deactivated). The desired set of templates sent here is reconciled against the active rows for the course. */
  organization_template_id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional secondary organization template ID. When provided, a second CourseOrganizationTemplate record is created or updated for this template alongside the primary one. Must be of type COURSE_ELEVATE or COURSE_ELEVATE_ACCREDITATION and cannot equal organization_template_id. */
  organization_template_id_secondary?: InputMaybe<Scalars['ID']['input']>;
};

export type CourseOrganizationTemplateInput = {
  course_organization_template: CourseOrganizationTemplateData;
  dc3_course_organization_template?: InputMaybe<Dc3CourseOrganizationTemplateData>;
};

export type CourseOrganizationTemplateNode = {
  __typename?: 'CourseOrganizationTemplateNode';
  course_id: Scalars['Int']['output'];
  dc3_course_organization_template?: Maybe<Dc3CourseOrganizationTemplateNode>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  organization_id: Scalars['Int']['output'];
  organization_template: OrganizationTemplateNode;
  organization_template_id: Scalars['ID']['output'];
};

export type CourseOrganizationTemplatePartialNode = {
  __typename?: 'CourseOrganizationTemplatePartialNode';
  course_id: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  organization_id: Scalars['Int']['output'];
  organization_template_id: Scalars['ID']['output'];
};

export type CourseOrganizationTemplateResponsePayload = {
  __typename?: 'CourseOrganizationTemplateResponsePayload';
  course_organization_template?: Maybe<CourseOrganizationTemplateNode>;
};

export type CoursePageNumberPagination = {
  __typename?: 'CoursePageNumberPagination';
  edges: Array<CourseFederationNodePaginationEdge>;
  metadata?: Maybe<CertificateCourseMetadataType>;
  /** Information to aid in pagination. */
  page_info: NumberPageInfo;
  page_size?: Maybe<Scalars['Int']['output']>;
};

export type CoursePayload = {
  __typename?: 'CoursePayload';
  course?: Maybe<PrivateCourseType>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type CourseProgressResetBulkItem = {
  __typename?: 'CourseProgressResetBulkItem';
  message?: Maybe<Scalars['String']['output']>;
  outcome: CourseProgressResetBulkItemOutcome;
  user_id: Scalars['Int']['output'];
};

export enum CourseProgressResetBulkItemOutcome {
  Applied = 'APPLIED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type CourseProgressResetBulkJobInput = {
  /** Bulk reset job to read */
  job_id: Scalars['Int']['input'];
  /** Organization the job belongs to */
  organization_id: Scalars['Int']['input'];
};

export type CourseProgressResetBulkJobNode = {
  __typename?: 'CourseProgressResetBulkJobNode';
  applied: Scalars['Int']['output'];
  course_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by_id: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  items: Array<CourseProgressResetBulkItem>;
  organization_id: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  status: CourseProgressResetBulkJobStatus;
  total: Scalars['Int']['output'];
};

export enum CourseProgressResetBulkJobStatus {
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type CourseProgressResetHistory = {
  __typename?: 'CourseProgressResetHistory';
  entries: Array<CourseProgressResetLogEntry>;
  /** Whether the audit trail holds more entries than this capped page */
  has_more: Scalars['Boolean']['output'];
  total_count: Scalars['Int']['output'];
};

export type CourseProgressResetLogEntry = {
  __typename?: 'CourseProgressResetLogEntry';
  applied_at?: Maybe<Scalars['DateTime']['output']>;
  created_by_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  is_sealed: Scalars['Boolean']['output'];
  previous_progress?: Maybe<Scalars['Int']['output']>;
  previous_was_completed?: Maybe<Scalars['Boolean']['output']>;
  requested_at: Scalars['DateTime']['output'];
  status: CourseProgressResetStatusEnum;
};

export enum CourseProgressResetOrigin {
  AdminReset = 'ADMIN_RESET',
  AutoReassign = 'AUTO_REASSIGN'
}

export enum CourseProgressResetStatusEnum {
  Applied = 'APPLIED',
  NoOp = 'NO_OP',
  Pending = 'PENDING',
  Unsealed = 'UNSEALED'
}

export type CourseProgressResetTargetInput = {
  /** Course to inspect */
  course_id: Scalars['Int']['input'];
  /** Organization of the collaborator */
  organization_id: Scalars['Int']['input'];
  /** Collaborator to inspect */
  user_id: Scalars['Int']['input'];
};

export type CourseProgressResetTrackNotice = {
  __typename?: 'CourseProgressResetTrackNotice';
  /** Whether this course is required by at least one track the collaborator has already completed. Membership only: it does NOT state that resetting the course would un-complete that track */
  belongs_to_completed_track: Scalars['Boolean']['output'];
  completed_tracks: Array<CompletedTrackNode>;
};

export type CourseQuery = {
  __typename?: 'CourseQuery';
  /** Check if course title exists */
  check_course_title_exists: CourseStudioTitleExistsNode;
  /** Catálogo de cursos filtrado por organización para el carrusel del Home. Sirve el catálogo publicado propio de la organización (v1 o v2, nunca mezclados); la rama es una propiedad de la organización, nunca del usuario. */
  get_collaborator_catalog_courses: CollaboratorCatalogCourseConnection;
  get_course_by_admin?: Maybe<PrivateCourseType>;
  get_course_detail: CourseDetailResponse;
  /** Get all course levels admin */
  get_course_levels_admin: Array<LevelType>;
  get_course_options: CourseOptions;
  get_course_restriction: CourseRestrictionResponse;
  get_courses_by_admin: PageNumberPaginationCourse;
  /** List courses with a final project configured, each with its active-project count, for the 'by course' filter [Admin]. */
  get_courses_for_project_filter: Array<CourseForProjectFilterType>;
  /** Get organization classroom course by course_id and organization_id */
  get_organization_classroom_course_admin?: Maybe<OrganizationClassroomCourseNode>;
};


export type CourseQueryCheck_Course_Title_ExistsArgs = {
  input: CourseStudioTitleExistsInput;
};


export type CourseQueryGet_Collaborator_Catalog_CoursesArgs = {
  input: CollaboratorCatalogCoursesInput;
};


export type CourseQueryGet_Course_By_AdminArgs = {
  input: CourseGetInput;
};


export type CourseQueryGet_Course_DetailArgs = {
  input: CourseDetailInput;
};


export type CourseQueryGet_Course_OptionsArgs = {
  course_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
};


export type CourseQueryGet_Course_RestrictionArgs = {
  input: CourseRestrictionInput;
};


export type CourseQueryGet_Courses_By_AdminArgs = {
  input: CourseFilterInput;
};


export type CourseQueryGet_Courses_For_Project_FilterArgs = {
  input: CoursesForProjectFilterInput;
};


export type CourseQueryGet_Organization_Classroom_Course_AdminArgs = {
  input: OrganizationClassroomCourseInput;
};

export type CourseQuizzSummaryType = {
  __typename?: 'CourseQuizzSummaryType';
  total_questions: Scalars['Int']['output'];
  total_quizzes: Scalars['Int']['output'];
};

export type CourseRequirementDetailNode = {
  __typename?: 'CourseRequirementDetailNode';
  position?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CourseRequirementNode = {
  __typename?: 'CourseRequirementNode';
  id?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  requirement_details?: Maybe<Array<CourseRequirementDetailNode>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CourseResponse = CoursePayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type CourseRestrictionInput = {
  course_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseRestrictionPayload = GraphOperationI & {
  __typename?: 'CourseRestrictionPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
  restriction_code: Scalars['Int']['output'];
  restriction_message: Scalars['String']['output'];
};

export type CourseRestrictionResponse = CourseAccessGrantedPayload | CourseRestrictionPayload;

export type CourseRouteMetric = {
  __typename?: 'CourseRouteMetric';
  course_count?: Maybe<Scalars['Int']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original_id: Scalars['Int']['output'];
  students_count?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type CourseRouteMetricConnection = {
  __typename?: 'CourseRouteMetricConnection';
  /** Contains the nodes in this connection */
  edges: Array<CourseRouteMetricEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type CourseRouteMetricEdge = {
  __typename?: 'CourseRouteMetricEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CourseRouteMetric;
};

export type CourseStatisticsNode = {
  __typename?: 'CourseStatisticsNode';
  certified_count?: Maybe<Scalars['Int']['output']>;
  completed_course?: Maybe<Scalars['Int']['output']>;
  has_quiz?: Maybe<Scalars['Boolean']['output']>;
  inscribed_course?: Maybe<Scalars['Int']['output']>;
  is_crehana?: Maybe<Scalars['Boolean']['output']>;
  original_id: Scalars['Int']['output'];
  percent_progress?: Maybe<Scalars['Float']['output']>;
  started_course?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type CourseStatisticsNodeConnection = {
  __typename?: 'CourseStatisticsNodeConnection';
  /** Contains the nodes in this connection */
  edges: Array<CourseStatisticsNodeEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type CourseStatisticsNodeEdge = {
  __typename?: 'CourseStatisticsNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CourseStatisticsNode;
};

export type CourseStudioAssignMentorInput = {
  course_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CourseStudioCopyInput = {
  copy_course_type_enum: CopyCourseTypeEnum;
  course_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type CourseStudioCreateInput = {
  course: CourseCreateInput;
  organization_id: Scalars['ID']['input'];
};

export type CourseStudioDeleteInput = {
  course_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
};

export type CourseStudioInput = {
  approval_requirement_enum?: InputMaybe<ApprovalRequirementStudioEnum>;
  background_color?: InputMaybe<Scalars['String']['input']>;
  catalog_categories?: InputMaybe<Array<CatalogCategoryStudioInput>>;
  catalog_sub_categories?: InputMaybe<Array<CatalogSubCategoryStudioInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimate_duration_in_hours?: InputMaybe<Scalars['Int']['input']>;
  estimate_duration_in_seconds?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  level_id?: InputMaybe<Scalars['Int']['input']>;
  proffessor_id?: InputMaybe<Scalars['String']['input']>;
  project_guide_attachment?: InputMaybe<AttachmentStudioInput>;
  project_guide_description?: InputMaybe<Scalars['String']['input']>;
  project_guide_title?: InputMaybe<Scalars['String']['input']>;
  quiz_id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CourseStudioPublishInput = {
  course_id: Scalars['ID']['input'];
  is_active: Scalars['Boolean']['input'];
  list_category_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  organization_id: Scalars['ID']['input'];
  visibility_level?: InputMaybe<VisibilityLevelType>;
};

export type CourseStudioTitleExistsInput = {
  organization_id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type CourseStudioTitleExistsNode = {
  __typename?: 'CourseStudioTitleExistsNode';
  exists: Scalars['Boolean']['output'];
};

export type CourseStudioUpdateInput = {
  bulk_organization_slug?: InputMaybe<Array<Scalars['String']['input']>>;
  can_upload_project?: InputMaybe<Scalars['Boolean']['input']>;
  course: CourseStudioInput;
  course_modules?: InputMaybe<Array<CourseModuleUpdate>>;
  has_certification_available?: InputMaybe<Scalars['Boolean']['input']>;
  is_mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  is_player_block_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  list_category_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  organization_id: Scalars['ID']['input'];
  required: Scalars['Boolean']['input'];
  tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  video_lectures?: InputMaybe<Array<VideoLectureUpdateInput>>;
  visibility_level?: InputMaybe<VisibilityLevelType>;
  visibility_state?: InputMaybe<StudioCourseConfigStateEnum>;
};

export type CourseSummaryMetricNode = {
  __typename?: 'CourseSummaryMetricNode';
  count_certified?: Maybe<Scalars['Int']['output']>;
  count_completed?: Maybe<Scalars['Int']['output']>;
  count_inscribed?: Maybe<Scalars['Int']['output']>;
  count_started?: Maybe<Scalars['Int']['output']>;
  hours_consumed?: Maybe<Scalars['Int']['output']>;
  original_id: Scalars['Int']['output'];
  percent_certified?: Maybe<Scalars['Float']['output']>;
  percent_completed?: Maybe<Scalars['Float']['output']>;
  percent_inscribed?: Maybe<Scalars['Float']['output']>;
  percent_progress?: Maybe<Scalars['Float']['output']>;
  percent_started?: Maybe<Scalars['Float']['output']>;
  played_hours?: Maybe<Scalars['Float']['output']>;
};

export type CourseTeamDependencePayload = {
  __typename?: 'CourseTeamDependencePayload';
  affected_users_estimate?: Maybe<Scalars['Int']['output']>;
  created: Scalars['Boolean']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  processing_async: Scalars['Boolean']['output'];
};

export type CourseTeamDependenceRuleInput = {
  course_id: Scalars['ID']['input'];
};

export enum CourseTypeContentEnum {
  CourseTypeCrehana = 'COURSE_TYPE_CREHANA',
  CourseTypeElevate = 'COURSE_TYPE_ELEVATE',
  CourseTypeExternal = 'COURSE_TYPE_EXTERNAL'
}

export enum CourseTypeEnum {
  B2B = 'B2B',
  B2BClassrooms = 'B2B_CLASSROOMS',
  CrehanaCourseType = 'CREHANA_COURSE_TYPE',
  Degree = 'DEGREE',
  ExternalCourseType = 'EXTERNAL_COURSE_TYPE',
  Free = 'FREE',
  Freemium = 'FREEMIUM',
  Hidden = 'HIDDEN',
  Membership = 'MEMBERSHIP',
  OwnCourseType = 'OWN_COURSE_TYPE',
  Paid = 'PAID',
  Partner = 'PARTNER',
  Rockstar = 'ROCKSTAR',
  TemporalAccess = 'TEMPORAL_ACCESS'
}

export enum CourseTypeFilterEnum {
  CrehanaCourses = 'CREHANA_COURSES',
  OwnCourses = 'OWN_COURSES'
}

export type CourseTypeNode = {
  __typename?: 'CourseTypeNode';
  course_type_enum: CourseTypeContentEnum;
  external_provider_name?: Maybe<Scalars['String']['output']>;
};

export type CourseUserMetricNode = {
  __typename?: 'CourseUserMetricNode';
  hours_used?: Maybe<Scalars['Int']['output']>;
  is_certified?: Maybe<Scalars['Boolean']['output']>;
  played_hours?: Maybe<Scalars['Float']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  project_status?: Maybe<Scalars['String']['output']>;
  project_url?: Maybe<Scalars['String']['output']>;
  quiz_result?: Maybe<Scalars['Float']['output']>;
  quiz_status?: Maybe<Scalars['String']['output']>;
  total_correct_answer?: Maybe<Scalars['Int']['output']>;
  total_questions?: Maybe<Scalars['Int']['output']>;
  total_wrong_answer?: Maybe<Scalars['Int']['output']>;
  user: MetricsUser;
};

/** A connection to a list of items. */
export type CourseUserMetricNodeConnection = {
  __typename?: 'CourseUserMetricNodeConnection';
  /** Contains the nodes in this connection */
  edges: Array<CourseUserMetricNodeEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type CourseUserMetricNodeEdge = {
  __typename?: 'CourseUserMetricNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CourseUserMetricNode;
};

export type CourseUserSummaryNode = {
  __typename?: 'CourseUserSummaryNode';
  has_project?: Maybe<Scalars['Boolean']['output']>;
  has_project_completed?: Maybe<Scalars['Boolean']['output']>;
  has_quiz?: Maybe<Scalars['Boolean']['output']>;
  has_quiz_completed?: Maybe<Scalars['Boolean']['output']>;
  has_video?: Maybe<Scalars['Boolean']['output']>;
  has_video_completed?: Maybe<Scalars['Boolean']['output']>;
};

export type CourseVideo = {
  __typename?: 'CourseVideo';
  created_date: Scalars['DateTime']['output'];
  duration: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_deleted: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  subtitle_file?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated_date: Scalars['DateTime']['output'];
  video?: Maybe<Video>;
  video_content_type?: Maybe<Scalars['String']['output']>;
  video_file?: Maybe<Scalars['String']['output']>;
  video_hashed_id: Scalars['String']['output'];
  video_image?: Maybe<Scalars['String']['output']>;
  video_processes: CourseVideoProcesses;
  video_size?: Maybe<Scalars['Int']['output']>;
  video_type?: Maybe<Scalars['String']['output']>;
  wistia_thumbnail?: Maybe<Scalars['String']['output']>;
};

export type CourseVideoHighlight = {
  __typename?: 'CourseVideoHighlight';
  course_id?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  prompt_version_key?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
  video_lecture_id?: Maybe<Scalars['ID']['output']>;
  weight: Scalars['Int']['output'];
};

export type CourseVideoHighlightPayload = {
  __typename?: 'CourseVideoHighlightPayload';
  highlight: CourseVideoHighlight;
};

export type CourseVideoProcesses = {
  __typename?: 'CourseVideoProcesses';
  segments?: Maybe<VideoProcess>;
  transcript?: Maybe<VideoProcess>;
};

export type CourseVideoProcessesInfo = {
  __typename?: 'CourseVideoProcessesInfo';
  category: VideoProcessCategoryEnum;
  course_id: Scalars['ID']['output'];
  status: CourseVideoProcessesStatusInfo;
  total_videos: Scalars['Int']['output'];
};

export type CourseVideoProcessesStatusInfo = {
  __typename?: 'CourseVideoProcessesStatusInfo';
  total_failed: Scalars['Int']['output'];
  total_pending: Scalars['Int']['output'];
  total_queue: Scalars['Int']['output'];
  total_retried: Scalars['Int']['output'];
  total_successed: Scalars['Int']['output'];
};

export type CourseVideoTrailerNode = {
  __typename?: 'CourseVideoTrailerNode';
  id: Scalars['ID']['output'];
  video_source_type: Scalars['String']['output'];
  video_url?: Maybe<Scalars['String']['output']>;
};

export enum CourseViewerAccessErrorEnum {
  CourseArchived = 'COURSE_ARCHIVED',
  CourseNotFound = 'COURSE_NOT_FOUND',
  CourseNotPublished = 'COURSE_NOT_PUBLISHED',
  NoOrganizationAccess = 'NO_ORGANIZATION_ACCESS'
}

export type CourseViewerAccessErrorPayload = {
  __typename?: 'CourseViewerAccessErrorPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  reason?: Maybe<CourseViewerAccessErrorEnum>;
};

export enum CourseViewerRoleEnum {
  Admin = 'ADMIN',
  CollaboratorCatalogCourse = 'COLLABORATOR_CATALOG_COURSE',
  CollaboratorEnrolledOrAssigned = 'COLLABORATOR_ENROLLED_OR_ASSIGNED',
  CollaboratorNotEnrolled = 'COLLABORATOR_NOT_ENROLLED'
}

export type CourseViewerRoleInput = {
  /** Id of the course whose link is being opened. */
  course_id: Scalars['Int']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseViewerRolePayload = {
  __typename?: 'CourseViewerRolePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  is_admin: Scalars['Boolean']['output'];
  is_catalog_course: Scalars['Boolean']['output'];
  is_enrolled_or_assigned: Scalars['Boolean']['output'];
  is_not_enrolled: Scalars['Boolean']['output'];
  role?: Maybe<CourseViewerRoleEnum>;
};

export type CourseViewerRoleResponse = CourseViewerAccessErrorPayload | CourseViewerRolePayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type CourseWithQuizzesType = {
  __typename?: 'CourseWithQuizzesType';
  course_id: Scalars['Int']['output'];
  course_quiz_summary: CourseQuizzSummaryType;
  course_title?: Maybe<Scalars['String']['output']>;
};

export type CourseWithQuizzesTypeConnection = {
  __typename?: 'CourseWithQuizzesTypeConnection';
  /** A list of edges in this connection. */
  edges: Array<CourseWithQuizzesTypeEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type CourseWithQuizzesTypeConnectionQueryInternalError = CourseWithQuizzesTypeConnection | QueryInternalError;

export type CourseWithQuizzesTypeEdge = {
  __typename?: 'CourseWithQuizzesTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CourseWithQuizzesType;
};

export type CoursesAutomatedCreateOrGetTaskInput = {
  company_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  object_id: Scalars['Int']['input'];
  result_data?: InputMaybe<Scalars['String']['input']>;
  task_type: TaskTypesEnum;
};

export type CoursesByOrganizationTemplateTypeInput = {
  download_document_type_enum: DownloadDocumentTypeEnum;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search_key?: InputMaybe<Scalars['String']['input']>;
};

export enum CoursesContentChangeAction {
  Added = 'ADDED',
  Removed = 'REMOVED'
}

export type CoursesContentChangeEntry = {
  __typename?: 'CoursesContentChangeEntry';
  /** Nombre del admin que hizo el cambio; null si no se pudo resolver. */
  author_name?: Maybe<Scalars['String']['output']>;
  /** Tipo de cambio: ADDED (curso agregado) o REMOVED (curso quitado). */
  change_type: CoursesContentChangeAction;
  /** Fecha de aplicacion del cambio (applied_at; fallback created_at). */
  changed_at: Scalars['DateTime']['output'];
  /** Id del curso afectado. */
  course_id: Scalars['Int']['output'];
  /** Titulo del curso afectado; null si no se pudo resolver. */
  course_title?: Maybe<Scalars['String']['output']>;
};

export type CoursesCreateOrGetTaskPayload = {
  __typename?: 'CoursesCreateOrGetTaskPayload';
  is_new: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  task: CourseAutomatedTaskType;
};

export type CoursesCreateOrGetTaskResponse = CoursesCreateOrGetTaskPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

/** Input for the 'by course' project filter list [Admin]. */
export type CoursesForProjectFilterInput = {
  organization_id: Scalars['ID']['input'];
  search_key?: InputMaybe<Scalars['String']['input']>;
};

export enum CoursesWithQuizzesSortEnum {
  CourseCreatedDate = 'COURSE_CREATED_DATE',
  CourseTitle = 'COURSE_TITLE'
}

export type CoursesWithQuizzesSortInput = {
  direction?: InputMaybe<SortDirectionEnum>;
  field?: InputMaybe<CoursesWithQuizzesSortEnum>;
};

/** Coverage metrics for a specific criticality level */
export type CoverageByCriticalityNode = {
  __typename?: 'CoverageByCriticalityNode';
  coverage_percentage: Scalars['Float']['output'];
  covered_positions: Scalars['Int']['output'];
  criticality_level: OrganizationPositionCriticalityLevelEnum;
  total_positions: Scalars['Int']['output'];
};

export type CreateAccessTokenFromJwtInput = {
  api_key: Scalars['String']['input'];
  backend: AccessTokenBackenEnum;
  secret_access: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type CreateAccessTokenFromJwtPayload = {
  __typename?: 'CreateAccessTokenFromJWTPayload';
  access_token: CrehanaAuthAccessToken;
};

export type CreateAndUpdateOrganizationResponse = {
  __typename?: 'CreateAndUpdateOrganizationResponse';
  organization?: Maybe<CentralizedOrganizationNode>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreateApplicationDocumentInput = {
  allowed_document_formats: Array<DocumentFileFormatEnum>;
  assign_on_creation?: Scalars['Boolean']['input'];
  centralized_organization_id: Scalars['Int']['input'];
  conditionals?: InputMaybe<Array<GenericConditionalInput>>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  folder_id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type CreateApprovedRequestResponse = {
  __typename?: 'CreateApprovedRequestResponse';
  graphql_operation_id: Scalars['ID']['output'];
  /** ID of the created (and auto-approved) request; null on failure. TIM-243 — lets the caller (Attendance) tag the justificante origin without a re-query. */
  request_id?: Maybe<Scalars['ID']['output']>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreateAreaInput = {
  detail: Array<FirstLevelAreaInput>;
  organization_id: Scalars['Int']['input'];
};

export type CreateAreaLevelInput = {
  custom_name?: InputMaybe<Scalars['String']['input']>;
  level_sequence: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type CreateAuthTokenFromInternalJwtInput = {
  crehana_api_key: Scalars['String']['input'];
  crehana_secret_access: Scalars['String']['input'];
  internal_jwt: Scalars['String']['input'];
  source: Scalars['String']['input'];
};

export type CreateAuthTokenFromInternalJwtPayload = {
  __typename?: 'CreateAuthTokenFromInternalJWTPayload';
  expiration_date: Scalars['DateTime']['output'];
  token: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
};

export type CreateAuthTokenFromInternalJwtPayloadValidationMutationErrorSecurityMutationErrorInternalServerMutationError = CreateAuthTokenFromInternalJwtPayload | InternalServerMutationError | SecurityMutationError | ValidationMutationError;

export type CreateBulkQuestionInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  questions: Array<CreateQuestionInput>;
};

export type CreateCategoryPayload = {
  __typename?: 'CreateCategoryPayload';
  category?: Maybe<KnowledgeHubCategoryType>;
  created: Scalars['Boolean']['output'];
};

export type CreateCategoryResponse = CreateCategoryPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type CreateCategoryRestrictionPayload = {
  __typename?: 'CreateCategoryRestrictionPayload';
  created: Scalars['Boolean']['output'];
};

export type CreateCategoryRestrictionResponse = CreateCategoryRestrictionPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type CreateCentralizedOrganizationAnonymousJwtSessionInput = {
  centralized_organization_id: Scalars['ID']['input'];
};

export type CreateCentralizedUser = {
  __typename?: 'CreateCentralizedUser';
  created_at: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  last_name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type CreateCentralizedUserError = {
  __typename?: 'CreateCentralizedUserError';
  error: Scalars['String']['output'];
  expected_value?: Maybe<Scalars['JSON']['output']>;
  field: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CreateCentralizedUserInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  area_level_1_id: Scalars['Int']['input'];
  area_level_2_id?: InputMaybe<Scalars['Int']['input']>;
  area_level_3_id?: InputMaybe<Scalars['Int']['input']>;
  area_level_4_id?: InputMaybe<Scalars['Int']['input']>;
  birth_date?: InputMaybe<Scalars['Date']['input']>;
  boss_email?: InputMaybe<Scalars['String']['input']>;
  boss_id?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  civil_status?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  custom_fields?: InputMaybe<Array<CreateUserCustomField>>;
  deactivation_date?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Scalars['String']['input']>;
  document_type?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  email_validate?: InputMaybe<Scalars['Boolean']['input']>;
  first_name: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  headquarter_id?: InputMaybe<Scalars['Int']['input']>;
  incorporation_date?: InputMaybe<Scalars['String']['input']>;
  last_name: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
  permission_group_id?: InputMaybe<Scalars['Int']['input']>;
  phone_1?: InputMaybe<Scalars['String']['input']>;
  phone_2?: InputMaybe<Scalars['String']['input']>;
  position_category_id: Scalars['Int']['input'];
  position_id: Scalars['Int']['input'];
  send_invitation?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCentralizedUserPayload = {
  __typename?: 'CreateCentralizedUserPayload';
  user: CreateCentralizedUser;
};

export type CreateCentralizedUserPayloadCentralizedMutationValidationErrorCentralizedMutationInternalError = CentralizedMutationInternalError | CentralizedMutationValidationError | CreateCentralizedUserPayload;

export type CreateCentralizedUserResponse = {
  __typename?: 'CreateCentralizedUserResponse';
  errors?: Maybe<Array<CreateCentralizedUserError>>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  user?: Maybe<CentralizedUserNode>;
};

export type CreateChildCompaniesInput = {
  country: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  industry: Scalars['Int']['input'];
  licenses: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type CreateChildCompaniesMutationInput = {
  centralized_organization_id: Scalars['Int']['input'];
  children_org: CreateChildCompaniesInput;
};

export type CreateChildCompaniesPayload = {
  __typename?: 'CreateChildCompaniesPayload';
  organization_id: Scalars['Int']['output'];
};

export type CreateChildCompaniesPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse = CreateChildCompaniesPayload | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

export type CreateContentByElevateCourse = {
  course_id: Scalars['Int']['input'];
  list_category_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  visibility_level: VisibilityLevelType;
};

export type CreateContentDocumentsResponse = AdminCreateContentDocumentsPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type CreateContentOrganizationTeamInput = {
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  cover_image_id?: InputMaybe<Scalars['Int']['input']>;
  cover_image_url?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Team end date in ISO format (YYYY-MM-DD) */
  end_date?: InputMaybe<Scalars['Date']['input']>;
  /** Modalidad de la ruta: STANDARD (Estandar, por defecto) u OPEN (Abierta, no certifica hasta cerrarse). Si se omite, queda STANDARD. */
  modality?: InputMaybe<TrackModalityEnum>;
  name: Scalars['String']['input'];
  /** Team start date in ISO format (YYYY-MM-DD) */
  start_date?: InputMaybe<Scalars['Date']['input']>;
  visibility_level?: InputMaybe<VisibilityLevelType>;
};

export type CreateContentPayload = {
  __typename?: 'CreateContentPayload';
  content?: Maybe<KnowledgeHubContentType>;
  created: Scalars['Boolean']['output'];
};

export type CreateContractInput = {
  absence_integration?: InputMaybe<Scalars['Boolean']['input']>;
  bank_account_type?: InputMaybe<BankAccountTypeEnum>;
  base_salary: Scalars['Decimal']['input'];
  centralized_org_unit_ref?: InputMaybe<Scalars['String']['input']>;
  centralized_position_ref?: InputMaybe<Scalars['String']['input']>;
  centralized_user_id: Scalars['Int']['input'];
  clabe?: InputMaybe<Scalars['String']['input']>;
  contract_type: ContractTypeEnum;
  country_name?: InputMaybe<Scalars['String']['input']>;
  employer_registration_id?: InputMaybe<Scalars['UUID']['input']>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  fiscal_id?: InputMaybe<Scalars['String']['input']>;
  has_payroll: Scalars['Boolean']['input'];
  imss_employee_type?: InputMaybe<ImssEmployeeTypeEnum>;
  imss_medical_unit_id?: InputMaybe<Scalars['Int']['input']>;
  imss_number?: InputMaybe<Scalars['String']['input']>;
  imss_registration_date?: InputMaybe<Scalars['Date']['input']>;
  imss_salary_type: ImssSalaryTypeEnum;
  imss_shift_type?: InputMaybe<ImssShiftTypeEnum>;
  labor_regime: LaborRegimeEnum;
  last_movement_type?: InputMaybe<ImssLastMovementTypeEnum>;
  last_salary_movement_date?: InputMaybe<Scalars['Date']['input']>;
  legal_entity_id: Scalars['UUID']['input'];
  manager_ref?: InputMaybe<Scalars['String']['input']>;
  pay_frequency?: InputMaybe<PayFrequencyEnum>;
  payment_method: PaymentMethodEnum;
  payroll_bank_code?: InputMaybe<Scalars['String']['input']>;
  pays_overtime?: InputMaybe<Scalars['Boolean']['input']>;
  pension_type?: InputMaybe<PensionTypeEnum>;
  prior_seniority_years?: InputMaybe<Scalars['Int']['input']>;
  sar_bank_code?: InputMaybe<Scalars['String']['input']>;
  shift_hours?: InputMaybe<Scalars['Int']['input']>;
  shift_type: ContractShiftTypeEnum;
  sicoss_period_id: Scalars['Int']['input'];
  start_date: Scalars['Date']['input'];
  unionized: Scalars['Boolean']['input'];
  vacation_days?: InputMaybe<Scalars['Int']['input']>;
  work_center_ref?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContractResponse = {
  __typename?: 'CreateContractResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmployeeContractType;
};

export type CreateContractResult = CreateContractResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CreateConversationFromMessageInput = {
  message: Scalars['String']['input'];
  /** Modo de procesamiento (opcional). COPILOT (default) enruta al flujo de copilot-actions; COPILOT_PLANNER enruta directo al Planner Agent. */
  mode?: InputMaybe<CopilotConversationModeEnum>;
  organization_id: Scalars['ID']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCrossAuthTalentUserInput = {
  company_id: Scalars['ID']['input'];
  next_url?: InputMaybe<Scalars['String']['input']>;
  role: AuthUserRoleEnum;
};

export type CreateCrossAuthTalentUserPayload = {
  __typename?: 'CreateCrossAuthTalentUserPayload';
  next_url?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type CreateCrossAuthTalentUserPayloadValidationMutationErrorInternalServerMutationError = CreateCrossAuthTalentUserPayload | InternalServerMutationError | ValidationMutationError;

export type CreateCustomFieldChoiceInput = {
  name: Scalars['NotEmptyStr']['input'];
};

export type CreateCustomFieldInput = {
  can_edit: Scalars['Boolean']['input'];
  custom_field_choices?: InputMaybe<Array<CreateCustomFieldChoiceInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_mandatory: Scalars['Boolean']['input'];
  is_visible: Scalars['Boolean']['input'];
  max_length?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['NotEmptyStr']['input'];
  type: CustomFieldTypeEnum;
  where_mandatory?: InputMaybe<CustomFieldMandatoryEnum>;
};

export type CreateCustomFieldResponse = {
  __typename?: 'CreateCustomFieldResponse';
  custom_field?: Maybe<CustomFieldNode>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreateCustomFieldResponseApi = {
  __typename?: 'CreateCustomFieldResponseApi';
  custom_field?: Maybe<CustomFieldNode>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreateDispersionAccountInput = {
  /** Número de cuenta opcional, máximo 20 dígitos (solo números). */
  account_number?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de cuenta: 'principal' o 'secondary'. */
  account_type: Scalars['String']['input'];
  /** ID del banco del catálogo. Debe existir. */
  bank_id: Scalars['ID']['input'];
  /** ID de la organización centralizada (owner). */
  centralized_organization_id: Scalars['ID']['input'];
  /** CLABE de 18 dígitos numéricos. Única entre cuentas activas por razón social. */
  clabe: Scalars['String']['input'];
  /** Estado activo de la cuenta. Por defecto true. */
  is_active?: Scalars['Boolean']['input'];
  /** ID de la razón social a la que pertenece la cuenta. */
  legal_entity_id: Scalars['ID']['input'];
  /** Lista opcional de IDs de periodos de pago asociados. */
  pay_period_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Referencia de pago opcional mostrada en los comprobantes. Texto libre, máximo 80 caracteres. */
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDispersionAccountResponse = DispersionAccountResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CreateDocumentResponse = CreateOrganizationDocumentPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type CreateDocumentVerificationCodeInput = {
  centralized_organization_id: Scalars['Int']['input'];
  centralized_user_id: Scalars['Int']['input'];
  document_signature_status_id: Scalars['Int']['input'];
};

/** Success payload for create_employee_contact mutation. */
export type CreateEmployeeContactPayload = {
  __typename?: 'CreateEmployeeContactPayload';
  /** The newly created contact. */
  contact: EmployeeContactNode;
};

/** Union response for create_employee_contact mutation. */
export type CreateEmployeeContactResponse = CreateEmployeeContactPayload | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type CreateEmployeeDependentInput = {
  birth_date: Scalars['Date']['input'];
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
  first_name: Scalars['String']['input'];
  gender: DependentGenderEnum;
  is_economic_dependent?: Scalars['Boolean']['input'];
  is_emergency_contact?: Scalars['Boolean']['input'];
  last_name_1: Scalars['String']['input'];
  last_name_2?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  relationship_type: DependentRelationshipTypeEnum;
};

export type CreateEmployeeDependentResult = EmployeeDependentResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CreateEmployeePensionInput = {
  beneficiary_name: Scalars['String']['input'];
  centralized_user_id: Scalars['ID']['input'];
  court_order_date: Scalars['String']['input'];
  discount_type: Scalars['String']['input'];
  discount_value: Scalars['Float']['input'];
  folio: Scalars['String']['input'];
  legal_entity_id: Scalars['ID']['input'];
};

export type CreateEmployeePensionResult = EmployeePensionItemResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CreateEmployerRegistrationInput = {
  centralized_organization_id: Scalars['ID']['input'];
  economic_activity_code: Scalars['String']['input'];
  economic_activity_description: Scalars['String']['input'];
  /** Contenido del archivo `.cer` de la e.firma en base64, tal como lo entrega el SAT. */
  idse_cer_file?: InputMaybe<Scalars['String']['input']>;
  /** Contrasena de la e.firma. Es la misma que protege la llave privada del .key, asi que sirve para el formato nuevo sin campo aparte. */
  idse_efirma_password?: InputMaybe<Scalars['String']['input']>;
  /** Contenido del archivo `.key` de la e.firma en base64, tal como lo entrega el SAT. Va cifrado con `idse_efirma_password`. */
  idse_key_file?: InputMaybe<Scalars['String']['input']>;
  /** Contrasena con que el usuario operara ante Terra (`pwdUsuario`). De 3 a 20 caracteres: letras sin acentos, numeros, guion, punto y guion bajo, sin espacios, y no puede empezar con guion, punto ni guion bajo. Se valida al capturarla y se guarda cifrada. */
  idse_password?: InputMaybe<Scalars['String']['input']>;
  /** Usuario IDSE del cliente. Se guarda porque otros servicios lo necesitan, pero **no viaja al proveedor**: Terra no tiene campo de nombre de usuario, la identidad del usuario es el GUID que devuelve. */
  idse_username?: InputMaybe<Scalars['String']['input']>;
  imss_subdelegation_id: Scalars['ID']['input'];
  is_active?: Scalars['Boolean']['input'];
  legal_entity_id: Scalars['ID']['input'];
  registration_number: Scalars['String']['input'];
  risk_class_id: Scalars['ID']['input'];
  risk_data_expiration_date?: InputMaybe<Scalars['Date']['input']>;
  risk_fraction?: InputMaybe<Scalars['Decimal']['input']>;
  risk_premium: Scalars['Decimal']['input'];
  salary_zone_id: Scalars['ID']['input'];
  work_center_location_type: PayrollWorkCenterLocationType;
  work_locations?: InputMaybe<Array<PayrollWorkLocationInput>>;
};

export type CreateEmployerRegistrationResponse = EmployerRegistrationResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CreateEndUserDocumentInput = {
  centralized_organization_id: Scalars['Int']['input'];
  documents_to_create?: Array<SingleEndUserDocumentInput>;
};

export type CreateFederalEntityInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateFederalEntityResponse = FederalEntityResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CreateFolderInput = {
  centralized_organization_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  feature_type?: InputMaybe<FeatureTypeEnum>;
  icon_id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  visualization_type: FolderVisualizationTypeEnum;
};

export type CreateGovernmentCreditInput = {
  centralized_user_id: Scalars['ID']['input'];
  /** Whether this credit also charges the INFONAVIT housing damage insurance. INFONAVIT only. When true, `damage_insurance_charge_on` is required. */
  charges_damage_insurance?: Scalars['Boolean']['input'];
  credit_number: Scalars['String']['input'];
  credit_type: Scalars['String']['input'];
  /** Which payroll of the BIMESTER withholds the insurance fee: FIRST_PERIOD or LAST_PERIOD. The institute charges it once per bimester and does not say in which payroll. */
  damage_insurance_charge_on?: InputMaybe<Scalars['String']['input']>;
  discount_type: Scalars['String']['input'];
  discount_value: Scalars['Float']['input'];
  installment_amount?: InputMaybe<Scalars['Float']['input']>;
  installments?: InputMaybe<Scalars['Int']['input']>;
  installments_paid_before?: Scalars['Int']['input'];
  legal_entity_id: Scalars['ID']['input'];
  start_date: Scalars['String']['input'];
  total_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateGovernmentCreditResult = GovernmentCreditItemResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CreateHeadquarterInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  is_main: Scalars['Boolean']['input'];
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type CreateHigherEducationTeamInput = {
  courses?: InputMaybe<Array<HigherEducationTeamCourse>>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_draft?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
  product_id?: InputMaybe<Scalars['ID']['input']>;
  project_type?: InputMaybe<Scalars['String']['input']>;
  required_projects?: InputMaybe<Scalars['Int']['input']>;
  team_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateHigherEducationTeamProductInput = {
  cover_image?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  has_seen_certification_tab?: InputMaybe<Scalars['Boolean']['input']>;
  has_seen_mentor_tab?: InputMaybe<Scalars['Boolean']['input']>;
  is_draft?: InputMaybe<Scalars['Boolean']['input']>;
  local_amount?: InputMaybe<Scalars['Float']['input']>;
  local_currency?: InputMaybe<Scalars['String']['input']>;
  local_fake_amount?: InputMaybe<Scalars['Float']['input']>;
  meta_description?: InputMaybe<Scalars['String']['input']>;
  meta_title?: InputMaybe<Scalars['String']['input']>;
  organization_slug: Scalars['String']['input'];
  product_category_id?: InputMaybe<Scalars['ID']['input']>;
  product_details?: InputMaybe<Array<ProductDetailInput>>;
  product_faqs?: InputMaybe<Array<ProductFaqInput>>;
  product_id?: InputMaybe<Scalars['ID']['input']>;
  product_skills?: InputMaybe<Array<ProductSkillInput>>;
  project_type?: InputMaybe<Scalars['String']['input']>;
  required_projects?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type CreateHigherEducationTeamProductResponse = {
  __typename?: 'CreateHigherEducationTeamProductResponse';
  error?: Maybe<ErrorResponse>;
  product?: Maybe<Product>;
  success: Scalars['Boolean']['output'];
};

export type CreateHigherEducationTeamResponse = {
  __typename?: 'CreateHigherEducationTeamResponse';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  team?: Maybe<MarketplaceOrganizationTeamNode>;
};

export type CreateHoliday = {
  end_date: Scalars['Date']['input'];
  holiday_rules?: InputMaybe<Array<GenericConditionalInput>>;
  is_recurrent?: InputMaybe<Scalars['Boolean']['input']>;
  is_restricted: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  recurrent_type?: InputMaybe<HolidayRecurrentTypeEnum>;
  start_date: Scalars['Date']['input'];
};

export type CreateHolidayInput = {
  centralized_organization_id: Scalars['ID']['input'];
  holiday: CreateHoliday;
};

export type CreateHolidayResponse = {
  __typename?: 'CreateHolidayResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreateImssMovementInput = {
  contract_type?: InputMaybe<Scalars['String']['input']>;
  daily_salary?: InputMaybe<Scalars['Decimal']['input']>;
  department_ref?: InputMaybe<Scalars['String']['input']>;
  employee_type?: InputMaybe<Scalars['Int']['input']>;
  family_medicine_unit?: InputMaybe<Scalars['Int']['input']>;
  imss_salary_type?: InputMaybe<Scalars['Int']['input']>;
  legal_entity_id: Scalars['UUID']['input'];
  movement_date: Scalars['Date']['input'];
  movement_type: Scalars['String']['input'];
  payroll_employee_id: Scalars['UUID']['input'];
  position_ref?: InputMaybe<Scalars['String']['input']>;
  reason_code: Scalars['String']['input'];
  reduced_schedule?: InputMaybe<Scalars['Int']['input']>;
  sdi?: InputMaybe<Scalars['Decimal']['input']>;
  shift_type?: InputMaybe<Scalars['Int']['input']>;
  variable_imss?: InputMaybe<Scalars['Decimal']['input']>;
  variable_integration?: InputMaybe<Scalars['Decimal']['input']>;
  work_center_ref?: InputMaybe<Scalars['String']['input']>;
};

export type CreateImssMovementResponse = {
  __typename?: 'CreateImssMovementResponse';
  graphql_operation_id: Scalars['ID']['output'];
  is_possible_duplicate: Scalars['Boolean']['output'];
  result: ImssMovementDetail;
};

export type CreateImssMovementResult = CreateImssMovementResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CreateIntegratedOrganization = {
  address?: InputMaybe<Scalars['String']['input']>;
  admin_email: Scalars['String']['input'];
  admin_first_name: Scalars['String']['input'];
  admin_last_name: Scalars['String']['input'];
  /** Assigned type: 1 for All catalog, 2 for onlypanel */
  assigned_type?: InputMaybe<Scalars['Int']['input']>;
  business_name?: InputMaybe<Scalars['String']['input']>;
  /** Certificate policy: 1 for crehana policy, 2 for non visible policy */
  certificate_policy?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_name?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['Int']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  expire_date?: InputMaybe<Scalars['String']['input']>;
  industry_id?: InputMaybe<Scalars['Int']['input']>;
  limit_free?: InputMaybe<Scalars['Int']['input']>;
  limit_pay?: InputMaybe<Scalars['Int']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  logo_certificate?: InputMaybe<Scalars['String']['input']>;
  logo_header?: InputMaybe<Scalars['String']['input']>;
  /** ApplicationProduct name codes to assign to this organization (e.g. ['LEARNING', 'TALENT_PERFORMANCE']). The system infers the ProductSuites from these modules. */
  modules?: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization_description?: InputMaybe<Scalars['String']['input']>;
  organization_parent_id?: InputMaybe<Scalars['Int']['input']>;
  /** Organization size: small, medium, enterprise */
  organization_size?: InputMaybe<Scalars['String']['input']>;
  /** Organization type: 1 for organization, 2 for demo */
  organization_type?: InputMaybe<Scalars['Int']['input']>;
  /** Project privacy: 1 for only organization, 2 for only user */
  project_privacy?: InputMaybe<Scalars['Int']['input']>;
  ruc?: InputMaybe<Scalars['String']['input']>;
  salesforce_id?: InputMaybe<Scalars['String']['input']>;
  salesforce_opportunity_id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  user_define_scope?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateInternalJwtTokenFromSessionInput = {
  federation_jwt: Scalars['String']['input'];
};

export type CreateInternalJwtTokenFromSessionPayload = {
  __typename?: 'CreateInternalJWTTokenFromSessionPayload';
  expiration_date: Scalars['DateTime']['output'];
  token: Scalars['String']['output'];
};

export type CreateInternalJwtTokenFromSessionPayloadValidationMutationErrorInternalServerMutationError = CreateInternalJwtTokenFromSessionPayload | InternalServerMutationError | ValidationMutationError;

export type CreateJwtError = {
  __typename?: 'CreateJWTError';
  errors: Array<Scalars['String']['output']>;
};

export type CreateJwtErrorApiClientErrorCreateAccessTokenFromJwtPayloadInternalServerMutationError = ApiClientError | CreateAccessTokenFromJwtPayload | CreateJwtError | InternalServerMutationError;

export type CreateJwtTokenFromSession = {
  organization_id: Scalars['ID']['input'];
};

export type CreateJwtTokenFromSessionPayload = {
  __typename?: 'CreateJWTTokenFromSessionPayload';
  token: Scalars['String']['output'];
};

export type CreateJwtTokenFromSessionPayloadInternalServerMutationError = CreateJwtTokenFromSessionPayload | InternalServerMutationError;

export type CreateJobApplicantProfileInput = {
  answers?: InputMaybe<Array<JobApplicantProfileAnswerInput>>;
  career_site_uid?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  disability?: InputMaybe<AtsDisabilityCandidatesEnum>;
  email: Scalars['String']['input'];
  file_cv_id?: InputMaybe<Scalars['Int']['input']>;
  first_name: Scalars['String']['input'];
  gender?: InputMaybe<AtsGenderCandidatesEnum>;
  is_internal_career_site?: InputMaybe<Scalars['Boolean']['input']>;
  last_name: Scalars['String']['input'];
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  origin_candidates?: InputMaybe<AtsOriginCandidatesEnum>;
  phone?: InputMaybe<Scalars['String']['input']>;
  vacancy_id: Scalars['Int']['input'];
};

export type CreateJobApplicantProfileResponse = CreateJobApplicantProfileSuccess | MutationApplicantBlockedEmailExistsError | MutationApplicantEmailExistsError | MutationApplicantInvalidLinkedinError | MutationInternalExistsError | MutationValidationExistsError;

export type CreateJobApplicantProfileSuccess = {
  __typename?: 'CreateJobApplicantProfileSuccess';
  applicant_profile: JobApplicantProfilePayload;
};

export type CreateJobInputs = {
  file_arguments: Scalars['String']['input'];
  file_id: Scalars['Int']['input'];
  graphql?: InputMaybe<Scalars['String']['input']>;
  message_ordering?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  schema_validate?: InputMaybe<Scalars['String']['input']>;
  service_domain: ServiceDomainEnum;
  subscription_type?: SubscriptionTypeEnum;
  title: Scalars['String']['input'];
  topic_name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLegalEntityInput = {
  address_1: Scalars['String']['input'];
  address_2?: InputMaybe<Scalars['String']['input']>;
  address_3?: InputMaybe<Scalars['String']['input']>;
  bank_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  city: Scalars['String']['input'];
  clabe_account?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code: Scalars['String']['input'];
  currency_code: Scalars['String']['input'];
  fiscal_address_override?: InputMaybe<Scalars['String']['input']>;
  fiscal_contact_email?: InputMaybe<Scalars['String']['input']>;
  internal_id: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  legal_name: Scalars['String']['input'];
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  postal_code: Scalars['String']['input'];
  repse_number?: InputMaybe<Scalars['String']['input']>;
  social_object?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  tax_id: Scalars['String']['input'];
  tax_regime_id?: InputMaybe<Scalars['ID']['input']>;
  tax_type?: InputMaybe<Scalars['String']['input']>;
  trade_name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLegalEntityResponse = CentralizedLegalEntityResponse | ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | LegalEntityResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CreateLegalRepresentativeInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  civil_registry_id?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  faculties: Array<Scalars['String']['input']>;
  legal_entity_id: Scalars['ID']['input'];
  representative_name: Scalars['String']['input'];
  representative_type: Scalars['String']['input'];
  tax_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLegalRepresentativeResult = InternalErrorResponse | LegalRepresentativeResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CreateLiveSessionUploadVideoInput = {
  content_type: Scalars['String']['input'];
  file_id: Scalars['Int']['input'];
  live_session_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
  source_origin?: InputMaybe<LiveSessionUploadVideoSourceEnum>;
};

export type CreateLiveSessionVideoClassInput = {
  live_session: BasicLiveSessionInput;
  organization_id: Scalars['ID']['input'];
  video_lecture_id: Scalars['ID']['input'];
};

export type CreateLogActionInput = {
  action_value: Scalars['Int']['input'];
  component_value: Scalars['Int']['input'];
  course_id: Scalars['Int']['input'];
  created_at: Scalars['String']['input'];
  meta_data?: Array<MetaDataCourseLog>;
  organization_id: Scalars['Int']['input'];
  /** Course representation */
  representation: Scalars['String']['input'];
  sub_component_value?: InputMaybe<Scalars['Int']['input']>;
  user_id: Scalars['Int']['input'];
};

export type CreateModuleInput = {
  is_active: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateModuleResponse = {
  __typename?: 'CreateModuleResponse';
  modules?: Maybe<Array<PlatformModuleNode>>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreateOAuth2JwtTokenInput = {
  next_url?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};

export type CreateOAuth2JwtTokenPayload = {
  __typename?: 'CreateOAuth2JWTTokenPayload';
  created_at: Scalars['DateTime']['output'];
  expires_at: Scalars['DateTime']['output'];
  next_url: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type CreateOAuth2JwtTokenPayloadMutationValidationErrorMutationInternalError = CreateOAuth2JwtTokenPayload | MutationInternalError | MutationValidationError;

export type CreateOAuthClientInput = {
  allowed_scopes?: Array<Scalars['String']['input']>;
  client_name: Scalars['String']['input'];
  client_type?: Scalars['String']['input'];
  redirect_uris?: Array<Scalars['String']['input']>;
  token_endpoint_auth_method?: Scalars['String']['input'];
};

export type CreateOAuthClientPayload = {
  __typename?: 'CreateOAuthClientPayload';
  client: OAuthClientPayload;
  client_secret?: Maybe<Scalars['String']['output']>;
};

export type CreateOAuthClientPayloadValidationMutationErrorIntegrityErrorMutationErrorInternalServerMutationError = CreateOAuthClientPayload | IntegrityErrorMutationError | InternalServerMutationError | ValidationMutationError;

export type CreateOrUpdateAnswerBlockInput = {
  answer_attachment_id?: InputMaybe<Scalars['Int']['input']>;
  answer_check?: InputMaybe<Scalars['Boolean']['input']>;
  answer_id?: InputMaybe<Scalars['ID']['input']>;
  answer_text: Scalars['String']['input'];
  is_trash?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOrUpdateAnswerInput = {
  answer_attachment_id?: InputMaybe<Scalars['ID']['input']>;
  answer_check?: InputMaybe<Scalars['Boolean']['input']>;
  answer_id?: InputMaybe<Scalars['Int']['input']>;
  answer_text: Scalars['String']['input'];
  is_trash?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  question_id: Scalars['ID']['input'];
};

export type CreateOrUpdateContentResponse = CreateContentPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type CreateOrUpdateCourseOrganizationTemplateResponse = CourseOrganizationTemplateResponsePayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type CreateOrUpdateCourseTeamDependenceInput = {
  course_id: Scalars['ID']['input'];
  depends_on: Array<CourseTeamDependenceRuleInput>;
};

export type CreateOrUpdateCourseTeamDependenceInputList = {
  courses_dependencies: Array<CreateOrUpdateCourseTeamDependenceInput>;
  is_active: Scalars['Boolean']['input'];
  organization_team_id: Scalars['ID']['input'];
};

export type CreateOrUpdateCourseTeamDependenceResponse = CourseTeamDependencePayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type CreateOrUpdateDc3OrganizationNameResponse = Dc3OrganizationNameResponsePayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type CreateOrUpdateDc4OrganizationAttributeResponse = Dc4OrganizationAttributeResponsePayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type CreateOrUpdateOrganizationCourseInstructorResponse = OrganizationCourseInstructorResponsePayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type CreateOrUpdateOrganizationTeamResponse = CreateTeamOrganizationPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type CreateOrUpdateOrganizationTemplateResponse = OrganizationTemplateResponsePayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type CreateOrUpdatePayload = {
  __typename?: 'CreateOrUpdatePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  scorm: ScormType;
};

export type CreateOrUpdateQuestionBlockInput = {
  answers?: InputMaybe<Array<CreateOrUpdateAnswerBlockInput>>;
  default_answer_order?: InputMaybe<AnswerFieldEnum>;
  feedback_text?: InputMaybe<Scalars['String']['input']>;
  help_text?: InputMaybe<Scalars['String']['input']>;
  is_trash?: InputMaybe<Scalars['Boolean']['input']>;
  question_attachment_id?: InputMaybe<Scalars['Int']['input']>;
  question_id?: InputMaybe<Scalars['ID']['input']>;
  question_text: Scalars['String']['input'];
  question_type: QuizQuestionTypeEnum;
  related_video_lecture_id?: InputMaybe<Scalars['ID']['input']>;
  value_percentage?: InputMaybe<Scalars['Float']['input']>;
  value_points?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOrUpdateQuizAnswerPayload = GraphOperationI & {
  __typename?: 'CreateOrUpdateQuizAnswerPayload';
  answer_choice?: Maybe<PrivateAnswerChoiceType>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

export type CreateOrUpdateQuizAnswerResponse = CreateOrUpdateQuizAnswerPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type CreateOrUpdateResponse = CreateOrUpdatePayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type CreateOrUpdateTrackOrganizationTemplateResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TrackOrganizationTemplateResponsePayload;

export type CreateOrganization = {
  /** Country code based on alpha 3 Characters (PER) */
  country_code?: InputMaybe<Scalars['String']['input']>;
  id_internal_crehana: Scalars['Int']['input'];
  id_internal_talent: Scalars['Int']['input'];
  industry_id?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  open_opportunity_id?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  slug_internal_crehana: Scalars['String']['input'];
  slug_internal_talent: Scalars['String']['input'];
  type_process_organization?: InputMaybe<TypeProcessOrganization>;
};

export type CreateOrganizationAccessTokenFromCredentialsInput = {
  organization_id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CreateOrganizationAreaLevelResponse = {
  __typename?: 'CreateOrganizationAreaLevelResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreateOrganizationAreaResponse = {
  __typename?: 'CreateOrganizationAreaResponse';
  already_created_area_names: Array<AreaNameNode>;
  has_area_names_in_blank: Scalars['Boolean']['output'];
  repeated_area_names: Array<AreaNameNode>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreateOrganizationCategoryInput = {
  image_file_id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  visibility_level: VisibilityLevelType;
};

export type CreateOrganizationDocumentInput = {
  organization_documents: Array<OrganizationDocumentInput>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOrganizationDocumentPayload = {
  __typename?: 'CreateOrganizationDocumentPayload';
  documents?: Maybe<Array<OrganizationDocumentType>>;
};

export type CreateOrganizationEnterpriseExternalInput = {
  enterprise: Scalars['String']['input'];
  external_id: Scalars['String']['input'];
  organization_id: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
  source_system?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrganizationEnterpriseExternalResponse = {
  __typename?: 'CreateOrganizationEnterpriseExternalResponse';
  organization_enterprise_external?: Maybe<OrganizationEnterpriseExternalNode>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreateOrganizationHeadquarterResponse = {
  __typename?: 'CreateOrganizationHeadquarterResponse';
  headquarters?: Maybe<Array<OrganizationHeadquarterNode>>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreateOrganizationJwtTokenInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  crehana_api_key: Scalars['String']['input'];
  crehana_secret_access: Scalars['String']['input'];
  learning_organization_id?: InputMaybe<Scalars['ID']['input']>;
  scope: ApiKeyJwtTokenScopeEnum;
  subject: Scalars['String']['input'];
};

export type CreateOrganizationJwtTokenPayload = {
  __typename?: 'CreateOrganizationJWTTokenPayload';
  expiration_date: Scalars['DateTime']['output'];
  token: Scalars['String']['output'];
};

export type CreateOrganizationJwtTokenPayloadSecurityMutationErrorInternalServerMutationError = CreateOrganizationJwtTokenPayload | InternalServerMutationError | SecurityMutationError;

export type CreateOrganizationPositionCategoryResponseApi = {
  __typename?: 'CreateOrganizationPositionCategoryResponseApi';
  position_category?: Maybe<OrganizationPositionCategoryNode>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreateOrganizationReward = CreateOrganizationRewardPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type CreateOrganizationRewardInput = {
  number_courses: Scalars['Int']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  organization_team_id: Scalars['ID']['input'];
};

export type CreateOrganizationRewardPayload = {
  __typename?: 'CreateOrganizationRewardPayload';
  organization_team_reward?: Maybe<OrganizationRewardType>;
};

export type CreateOrganizationTeamInput = {
  articles_list_ids: Array<Scalars['Int']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  integrations_list_ids: Array<Scalars['Int']['input']>;
  is_draft: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  organization_team_courses_list_ids: Array<Scalars['Int']['input']>;
  organization_team_id?: InputMaybe<Scalars['ID']['input']>;
  reward_courses_number: Scalars['Int']['input'];
  rules_data: OrganizationTeamRulesInput;
  start_date?: InputMaybe<Scalars['String']['input']>;
  user_ids: Array<Scalars['Int']['input']>;
  user_organization_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateOrganizationTeamPayload = {
  __typename?: 'CreateOrganizationTeamPayload';
  organization_team?: Maybe<ContentOrganizationTeamType>;
};

export type CreateOrganizationTeamResponse = CreateOrganizationTeamPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type CreatePaymentGatewayConfigInput = {
  general_config_value: Scalars['JSON']['input'];
  payment_gateway_id: Scalars['Int']['input'];
};

export type CreatePaymentGatewayConfigResponse = {
  __typename?: 'CreatePaymentGatewayConfigResponse';
  general_config_value?: Maybe<Scalars['JSON']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreatePaymentGatewayOrgConfigInput = {
  config_value?: InputMaybe<Scalars['JSON']['input']>;
  credentials_value?: InputMaybe<Scalars['JSON']['input']>;
  general_config_value?: InputMaybe<Scalars['JSON']['input']>;
  payment_gateway_org_id: Scalars['Int']['input'];
  payment_method_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreatePaymentGatewayOrgConfigResponse = {
  __typename?: 'CreatePaymentGatewayOrgConfigResponse';
  config_value?: Maybe<Scalars['JSON']['output']>;
  credentials_value?: Maybe<Scalars['JSON']['output']>;
  general_config_value?: Maybe<Scalars['JSON']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreatePayrollIncidenceResult = InternalErrorResponse | NotFoundErrorResponse | PayrollIncidence | UserPermissionErrorResponse | ValidationErrorResponse;

export type CreatePolicy = {
  /** Accumulation */
  accumulation?: InputMaybe<PolicyAccumulation>;
  /** Allow Discount Half Day */
  allow_discount_half_day?: Scalars['Boolean']['input'];
  /** Allow Negative Values */
  allow_negative_values?: InputMaybe<Scalars['Boolean']['input']>;
  /** Auto Resolvable Time Days */
  auto_resolvable_time_days?: InputMaybe<Scalars['Int']['input']>;
  /** Policy Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** First Period Delay Months */
  first_period_delay_months?: InputMaybe<Scalars['Int']['input']>;
  /** Has Deferred First Period */
  has_deferred_first_period?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has Rule By Age */
  has_rule_by_age?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has Time Limit To Use */
  has_time_limit_to_use?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Limited] Instructions */
  instructions?: InputMaybe<Scalars['String']['input']>;
  /** Is Apply Max Balance Accumulated */
  is_apply_max_balance_accumulated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Auto Resolvable */
  is_auto_resolvable?: InputMaybe<PolicyIsAutoResolvable>;
  /** Is Max Negative Accumulable */
  is_max_negative_accumulable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Max Time Transferable */
  is_max_time_transferable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Negative Value Next Period */
  is_negative_value_next_period?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Policy Paid */
  is_paid?: Scalars['Boolean']['input'];
  /** This policy has rules? */
  is_restricted?: Scalars['Boolean']['input'];
  /** Is Time Expirable */
  is_time_expirable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Transferable */
  is_transferable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limited or Unlimited */
  is_unlimited: Scalars['Boolean']['input'];
  /** Max Balance Accumulated Value */
  max_balance_accumulated_value?: InputMaybe<Scalars['Int']['input']>;
  /** Max Negative Accumulable Value */
  max_negative_accumulable_value?: InputMaybe<Scalars['Int']['input']>;
  /** Max Time */
  max_time: Scalars['Float']['input'];
  /** Max Time Transferable Value */
  max_time_transferable_value?: InputMaybe<Scalars['Int']['input']>;
  /** Min Time */
  min_time: Scalars['Float']['input'];
  /** Policy Name */
  name: Scalars['String']['input'];
  /** Needs Approvals */
  needs_approvals: Scalars['Boolean']['input'];
  /** Needs Leader Approval */
  needs_leader_approval?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow Overlap Holidays */
  overlap_holidays?: Scalars['Boolean']['input'];
  /** Policy Days */
  policy_days: CreatePolicyDays;
  policy_rules?: InputMaybe<Array<GenericConditionalInput>>;
  /** Policy Rules By Age */
  policy_rules_by_age?: InputMaybe<Array<CreatePolicyRuleByAge>>;
  /** Policy Type ID */
  policy_type_id: Scalars['ID']['input'];
  /** Policy Approvers */
  policy_user_approvers?: InputMaybe<Array<CreatePolicyApprover>>;
  /** Quantification */
  quantification: PolicyQuantification;
  /** Renovation */
  renovation?: InputMaybe<PolicyRenovation>;
  /** Renovation Day */
  renovation_day?: InputMaybe<Scalars['Int']['input']>;
  /** Renovation Granularity, required when renovation is BIRTHDAY */
  renovation_granularity?: InputMaybe<PolicyRenovationGranularity>;
  /** Renovation Month */
  renovation_month?: InputMaybe<Scalars['Int']['input']>;
  /** Start Accumulation Days */
  start_accumulation_days?: InputMaybe<Scalars['Int']['input']>;
  /** Time Distribution */
  time_distribution?: InputMaybe<PolicyTimeDistribution>;
  /** Time Distribution Frequency */
  time_distribution_frecuency?: InputMaybe<PolicyTimeDistributionFrequency>;
  /** Time Expirable Conditional */
  time_expirable_conditional?: InputMaybe<PolicyTimeExpirableConditional>;
  /** Time Expirable Period */
  time_expirable_period?: InputMaybe<PolicyTimeExpirablePeriod>;
  /** Time Expirable Value */
  time_expirable_value?: InputMaybe<Scalars['Int']['input']>;
  /** Time Limit To Use Days */
  time_limit_to_use_days?: InputMaybe<Scalars['Int']['input']>;
  /** [Limited] Total Time */
  total_value?: InputMaybe<Scalars['Int']['input']>;
  /** Working Hours */
  working_hours: Scalars['Int']['input'];
};

export type CreatePolicyApprover = {
  centralized_user_id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};

export type CreatePolicyApproverV2 = {
  centralized_user_id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};

export type CreatePolicyDays = {
  friday: Scalars['Boolean']['input'];
  monday: Scalars['Boolean']['input'];
  saturday: Scalars['Boolean']['input'];
  sunday: Scalars['Boolean']['input'];
  thursday: Scalars['Boolean']['input'];
  tuesday: Scalars['Boolean']['input'];
  wednesday: Scalars['Boolean']['input'];
};

export type CreatePolicyDaysV2 = {
  friday: Scalars['Boolean']['input'];
  monday: Scalars['Boolean']['input'];
  saturday: Scalars['Boolean']['input'];
  sunday: Scalars['Boolean']['input'];
  thursday: Scalars['Boolean']['input'];
  tuesday: Scalars['Boolean']['input'];
  wednesday: Scalars['Boolean']['input'];
};

export type CreatePolicyInput = {
  centralized_organization_id: Scalars['ID']['input'];
  policy: CreatePolicy;
};

export type CreatePolicyResponse = {
  __typename?: 'CreatePolicyResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreatePolicyRuleByAge = {
  /** Conditional */
  conditional: PolicyRuleByAgeConditional;
  /** Days */
  days: Scalars['Int']['input'];
  /** Years */
  years: Scalars['Int']['input'];
};

export type CreatePolicyRuleByAgeV2 = {
  /** Action: add or remove */
  conditional: PolicyRuleByAgeConditional;
  /** Days to add/remove (≥0.5) */
  days: Scalars['Float']['input'];
  /** Anniversary number (≥1, unique, ordered) */
  years: Scalars['Int']['input'];
};

export type CreatePolicyV2 = {
  /** Accumulation */
  accumulation?: InputMaybe<PolicyAccumulation>;
  /** Allow Discount Half Day */
  allow_discount_half_day?: Scalars['Boolean']['input'];
  /** Allow Negative Values */
  allow_negative_values?: InputMaybe<Scalars['Boolean']['input']>;
  /** Auto Resolvable Time Days */
  auto_resolvable_time_days?: InputMaybe<Scalars['Int']['input']>;
  /** ISO 3166-1 alpha-2 country code (e.g. 'PE'). Activates the matching legal profile for (country, policy_type), if one exists. */
  country_code?: InputMaybe<Scalars['String']['input']>;
  /** Policy Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** First Period Delay Months */
  first_period_delay_months?: InputMaybe<Scalars['Int']['input']>;
  /** Has Deferred First Period */
  has_deferred_first_period?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has Rule By Age */
  has_rule_by_age?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has Time Limit To Use */
  has_time_limit_to_use?: InputMaybe<Scalars['Boolean']['input']>;
  /** [Limited] Instructions */
  instructions?: InputMaybe<Scalars['String']['input']>;
  /** Is Apply Max Balance Accumulated */
  is_apply_max_balance_accumulated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Auto Resolvable */
  is_auto_resolvable?: InputMaybe<PolicyIsAutoResolvable>;
  /** Is Max Negative Accumulable */
  is_max_negative_accumulable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Max Time Transferable */
  is_max_time_transferable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Negative Value Next Period */
  is_negative_value_next_period?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Policy Paid */
  is_paid?: Scalars['Boolean']['input'];
  /** This policy has rules? */
  is_restricted?: Scalars['Boolean']['input'];
  /** Is Time Expirable */
  is_time_expirable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Transferable */
  is_transferable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limited or Unlimited */
  is_unlimited: Scalars['Boolean']['input'];
  /** Max Balance Accumulated Value */
  max_balance_accumulated_value?: InputMaybe<Scalars['Int']['input']>;
  /** Max Negative Accumulable Value */
  max_negative_accumulable_value?: InputMaybe<Scalars['Int']['input']>;
  /** Max Time (0=unlimited, >0=limited) */
  max_time: Scalars['Float']['input'];
  /** Max Time Transferable Value */
  max_time_transferable_value?: InputMaybe<Scalars['Int']['input']>;
  /** Min Time (>0) */
  min_time: Scalars['Float']['input'];
  /** Policy Name */
  name: Scalars['String']['input'];
  /** Needs Approvals */
  needs_approvals: Scalars['Boolean']['input'];
  /** Needs Leader Approval */
  needs_leader_approval?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow Overlap Holidays */
  overlap_holidays?: Scalars['Boolean']['input'];
  /** Policy Days */
  policy_days: CreatePolicyDaysV2;
  policy_rules?: InputMaybe<Array<GenericConditionalInput>>;
  /** V2: Policy Rules By Age with enhanced validation */
  policy_rules_by_age?: InputMaybe<Array<CreatePolicyRuleByAgeV2>>;
  /** Policy Type ID */
  policy_type_id: Scalars['ID']['input'];
  /** Policy Approvers */
  policy_user_approvers?: InputMaybe<Array<CreatePolicyApproverV2>>;
  /** Quantification */
  quantification: PolicyQuantification;
  /** Renovation */
  renovation?: InputMaybe<PolicyRenovation>;
  /** Renovation Day */
  renovation_day?: InputMaybe<Scalars['Int']['input']>;
  /** Renovation Granularity, required when renovation is BIRTHDAY */
  renovation_granularity?: InputMaybe<PolicyRenovationGranularity>;
  /** Renovation Month */
  renovation_month?: InputMaybe<Scalars['Int']['input']>;
  /** V2: How age rules apply (intervals or specific years) */
  rule_by_age_application_mode?: InputMaybe<PolicyRuleByAgeApplicationModeEnum>;
  /** V2: Whether age rules are cumulative */
  rule_by_age_is_cumulative?: InputMaybe<Scalars['Boolean']['input']>;
  /** SAT disability type (Mexico only): '01' work risk, '02' general illness. */
  sat_disability_type?: InputMaybe<PolicySatDisabilityTypeEnum>;
  /** Start Accumulation Days */
  start_accumulation_days?: InputMaybe<Scalars['Int']['input']>;
  /** Time Distribution */
  time_distribution?: InputMaybe<PolicyTimeDistribution>;
  /** Time Distribution Frequency */
  time_distribution_frecuency?: InputMaybe<PolicyTimeDistributionFrequency>;
  /** Time Expirable Conditional */
  time_expirable_conditional?: InputMaybe<PolicyTimeExpirableConditional>;
  /** Time Expirable Period */
  time_expirable_period?: InputMaybe<PolicyTimeExpirablePeriod>;
  /** Time Expirable Value */
  time_expirable_value?: InputMaybe<Scalars['Int']['input']>;
  /** Time Limit To Use Days */
  time_limit_to_use_days?: InputMaybe<Scalars['Int']['input']>;
  /** [Limited] Total Time */
  total_value?: InputMaybe<Scalars['Int']['input']>;
  /** Working Hours */
  working_hours: Scalars['Int']['input'];
};

export type CreatePolicyV2Input = {
  centralized_organization_id: Scalars['ID']['input'];
  policy: CreatePolicyV2;
  /** PolicyTemplate id to prefill this policy's values from. Only fills total_value when the input leaves it unset (null); any explicit total_value in the input, including 0, always wins. Values are copied once at creation time; the policy does not stay linked to the template. */
  template_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateProductCategoryResponse = {
  __typename?: 'CreateProductCategoryResponse';
  error?: Maybe<ErrorResponse>;
  product_category?: Maybe<ProductCategory>;
  success: Scalars['Boolean']['output'];
};

export type CreatePromptForAnalyticsInput = {
  organization_id: Scalars['ID']['input'];
  prompt_key: Scalars['String']['input'];
  variables: Array<CopilotKeyAnalytics>;
};

export type CreateQuestionFromXlsxInput = {
  extra_data?: InputMaybe<Scalars['String']['input']>;
  file_id?: InputMaybe<Scalars['ID']['input']>;
  file_url: Scalars['String']['input'];
};

export type CreateQuestionInput = {
  attachment_id?: InputMaybe<Scalars['Int']['input']>;
  default_answer_order: AnswerFieldEnum;
  feedback_text?: InputMaybe<Scalars['String']['input']>;
  help_text?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  question_help_text?: InputMaybe<Scalars['String']['input']>;
  question_text: Scalars['String']['input'];
  question_type: QuizQuestionTypeEnum;
  related_video_lecture_id?: InputMaybe<Scalars['ID']['input']>;
  value_percentage?: InputMaybe<Scalars['Float']['input']>;
  value_points?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateQuestionResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | QuestionMutationPayload;

export type CreateReadingDocumentInput = {
  centralized_organization_id: Scalars['Int']['input'];
  documents_to_create: Array<SingleDocumentInput>;
};

export type CreateRequest = {
  /** Indicates if the request is made by hours (uses the value field directly). When True or when policy quantification is HOURS, the value field represents hours instead of calculating days from dates. Required for partial day requests in day-based policies. */
  allow_request_by_hour?: InputMaybe<Scalars['Boolean']['input']>;
  comment: Scalars['String']['input'];
  end_date: Scalars['Date']['input'];
  /** IMSS folio for a Mexico incapacity request. Ignored for any other request type or country. */
  folio_imss?: InputMaybe<Scalars['String']['input']>;
  /** Policy ID */
  policy_id: Scalars['ID']['input'];
  /** List of files attached to the request */
  request_files?: InputMaybe<Array<CreateRequestFile>>;
  /** SAT disability type for a Mexico incapacity request. Ignored for any other request type or country. */
  sat_type?: InputMaybe<PolicySatDisabilityTypeEnum>;
  start_date: Scalars['Date']['input'];
  /** User ID */
  user_id: Scalars['ID']['input'];
  /** Value asked can be hours or days */
  value: Scalars['Float']['input'];
};

export type CreateRequestCommentInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Centralized User ID */
  centralized_user_id: Scalars['ID']['input'];
  /** Comment */
  comment: Scalars['String']['input'];
  /** Request ID */
  request_id: Scalars['ID']['input'];
};

export type CreateRequestCommentResponse = {
  __typename?: 'CreateRequestCommentResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreateRequestFile = {
  /** File ID */
  file_id: Scalars['ID']['input'];
};

export type CreateRequestInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Centralized User ID */
  centralized_user_id: Scalars['ID']['input'];
  /** Request */
  request: CreateRequest;
};

export type CreateRequestNotificationLogInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Centralized User ID */
  centralized_user_id: Scalars['ID']['input'];
  /** Request ID */
  request_id: Scalars['ID']['input'];
};

export type CreateRequestNotificationLogResponse = {
  __typename?: 'CreateRequestNotificationLogResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreateRequestNotificationLogsInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Request ID */
  request_id: Scalars['ID']['input'];
};

export type CreateRequestNotificationLogsResponse = {
  __typename?: 'CreateRequestNotificationLogsResponse';
  graphql_operation_id: Scalars['ID']['output'];
  notified_user_ids: Array<Scalars['ID']['output']>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreateRequestResponse = {
  __typename?: 'CreateRequestResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreateRiskClassInput = {
  class_code: Scalars['String']['input'];
  class_name: Scalars['String']['input'];
};

export type CreateRiskClassResponse = InternalErrorResponse | RiskClassResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CreateSaml2ClaimInput = {
  attribute_name: Scalars['String']['input'];
  attribute_value_source: Scalars['String']['input'];
  centralized_organization_id: Scalars['ID']['input'];
  is_required?: Scalars['Boolean']['input'];
};

export type CreateSaml2IdpConfigurationInput = {
  centralized_organization_id: Scalars['ID']['input'];
  entity_id: Scalars['String']['input'];
  name_id_format?: Scalars['String']['input'];
  validity_days?: Scalars['Int']['input'];
};

export type CreateSaml2SpConfigurationInput = {
  acs_url: Scalars['String']['input'];
  centralized_organization_id: Scalars['ID']['input'];
  entity_id: Scalars['String']['input'];
  name_id_format?: Scalars['String']['input'];
  sign_requests?: Scalars['Boolean']['input'];
  slo_url?: InputMaybe<Scalars['String']['input']>;
  validity_days?: Scalars['Int']['input'];
};

export type CreateSegmentsInput = {
  centralized_organization_id: Scalars['Int']['input'];
  segment: SegmentInput;
};

export type CreateSessionFromOAuth2JwtInput = {
  next_url: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type CreateSessionFromOAuth2JwtPayload = {
  __typename?: 'CreateSessionFromOAuth2JWTPayload';
  next_url: Scalars['String']['output'];
};

export type CreateSessionFromOAuth2JwtPayloadMutationValidationErrorMutationInternalError = CreateSessionFromOAuth2JwtPayload | MutationInternalError | MutationValidationError;

export type CreateSignatureDocumentInput = {
  assign_on_creation?: Scalars['Boolean']['input'];
  centralized_organization_id: Scalars['Int']['input'];
  conditionals?: InputMaybe<Array<GenericConditionalInput>>;
  cosigners?: InputMaybe<Array<CosignerDocumentInput>>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  folder_id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  template_file_id: Scalars['Int']['input'];
};

export type CreateSocialHubNewsInput = {
  centralized_organization_id: Scalars['Int']['input'];
  news_to_create: Array<SingleNewsInput>;
};

export type CreateSuperAdminResponse = {
  __typename?: 'CreateSuperAdminResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreateTalentAuthJwtMutationInput = {
  centralized_organization_id: Scalars['ID']['input'];
  user_role?: InputMaybe<AuthUserRoleEnum>;
};

export type CreateTalentAuthJwtPayload = {
  __typename?: 'CreateTalentAuthJWTPayload';
  next_url?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type CreateTalentAuthJwtPayloadSecurityMutationErrorInternalServerMutationErrorCreateJwtError = CreateJwtError | CreateTalentAuthJwtPayload | InternalServerMutationError | SecurityMutationError;

export type CreateTalentEvaluationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  evaluation: TalentEvaluationInput;
  /** Send invitation emails to employees when the evaluation starts. */
  send_email_to_employees?: InputMaybe<Scalars['Boolean']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateTaxRegimeInput = {
  tax_regime_code: Scalars['String']['input'];
  tax_regime_name: Scalars['String']['input'];
  tax_type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTaxRegimeResponse = CentralizedTaxRegimeResponse | ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TaxRegimeResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type CreateTeamOrganizationPayload = {
  __typename?: 'CreateTeamOrganizationPayload';
  created: Scalars['Boolean']['output'];
  organization_team?: Maybe<OrganizationTeamType>;
};

export type CreateTemplateDocumentInput = {
  centralized_organization_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  editor_state?: InputMaybe<Scalars['JSON']['input']>;
  folder_id?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<HrisDocumentPageFormatInput>;
  html?: InputMaybe<Scalars['String']['input']>;
  idempotency_key?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  segmentation_rules?: InputMaybe<Array<GenericConditionalInput>>;
  visibility?: DocumentTemplateVisibility;
  wildcards?: InputMaybe<Array<HrisDocumentTemplateWildcardInput>>;
};

export type CreateTrackOrganizationTemplateInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  organization_template_id: Scalars['Int']['input'];
  track_id: Scalars['Int']['input'];
};

export type CreateUser = CreateUserResponse | ErrorResponse;

export type CreateUserCustomField = {
  choice_id?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserQuizFormInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  video_lecture_user_quiz_id: Scalars['ID']['input'];
};

export type CreateUserResponse = {
  __typename?: 'CreateUserResponse';
  alternative_email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  marketplace_user_id: Scalars['Int']['output'];
  original_email: Scalars['String']['output'];
};

export type CreateVideoLectureInput = {
  organization_id: Scalars['ID']['input'];
  video_lectures: Array<VideoLectureInput>;
};

export type CreateVideoProcessInput = {
  category: VideoProcessCategoryEnum;
  user_id?: InputMaybe<Scalars['ID']['input']>;
  video_lecture_id: Scalars['ID']['input'];
};

export type CreateVideoProgressInput = {
  video_lecture_id: Scalars['ID']['input'];
};

export type CreateVideoProgressPayload = {
  __typename?: 'CreateVideoProgressPayload';
  enrollment?: Maybe<EnrollmentNode>;
  video_lecture?: Maybe<VideoLectureType>;
  video_progress?: Maybe<VideoProgressNode>;
};

export type CreateVideoProgressResponse = CreateVideoProgressPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type CreateWorkFlowInput = {
  centralized_organization_id: Scalars['ID']['input'];
  conditionals: Array<WorkFlowConditionalInput>;
  workflow: WorkflowInput;
};

export type CreateWorkFlowResponse = {
  __typename?: 'CreateWorkFlowResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  workflow_id?: Maybe<Scalars['ID']['output']>;
};

export type CreateWorkFlowTrigger = {
  blocks: Array<WorkFlowBlockInput>;
  detail: CreateWorkFlowTriggerDetail;
  flow_type: WorkFlowTypeEnum;
  is_starting_point?: Scalars['Boolean']['input'];
  trigger_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateWorkFlowTriggerDetail = {
  apply_from_launch?: Scalars['Boolean']['input'];
  days_after?: InputMaybe<Scalars['Int']['input']>;
  days_before?: InputMaybe<Scalars['Int']['input']>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  months_before?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
  trigger_type: WorkFlowTriggerTypeEnum;
  years_before?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateWorkbeatUserEnterpriseResponse = {
  __typename?: 'CreateWorkbeatUserEnterpriseResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  user_centralized_id?: Maybe<Scalars['Int']['output']>;
  workbeat_id?: Maybe<Scalars['Int']['output']>;
};

export type CreateWorkflowDetail = {
  centralized_organization_id: Scalars['ID']['input'];
  triggers: Array<CreateWorkFlowTrigger>;
  workflow_id: Scalars['ID']['input'];
};

export type CreateWorkflowTaskUserResponse = {
  __typename?: 'CreateWorkflowTaskUserResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreationTeamConditionalsResponse = {
  __typename?: 'CreationTeamConditionalsResponse';
  graphql_operation_id: Scalars['ID']['output'];
  organization_team_id?: Maybe<Scalars['Int']['output']>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreationTeamHeaderInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  segmentation_type?: InputMaybe<TeamSegmentationTypeEnum>;
};

export type CreationTeamInput = {
  creation_method: MethodCreationTeams;
  description: Scalars['String']['input'];
  members: Array<CreationTeamMemberInput>;
  name: Scalars['String']['input'];
  participants_selection_method: MethodCreationMembers;
  segmentation_type?: InputMaybe<TeamSegmentationTypeEnum>;
};

export type CreationTeamMemberInput = {
  email: Scalars['String']['input'];
  role_type: TeamRoleTypeEnum;
  user_id: Scalars['Int']['input'];
};

export type CreationTeamsErrorResponse = {
  __typename?: 'CreationTeamsErrorResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type CreationTeamsResponse = {
  __typename?: 'CreationTeamsResponse';
  error_response?: Maybe<CreationTeamsErrorResponse>;
  graphql_operation_id: Scalars['ID']['output'];
  organization_team_id?: Maybe<Scalars['Int']['output']>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type CreditInstallmentPaymentListResponse = {
  __typename?: 'CreditInstallmentPaymentListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: Array<CreditInstallmentPaymentType>;
};

/** One payment a payroll run made against one monthly installment of a government credit. A period straddling two months produces TWO rows for the same run, one per installment; a fortnightly run produces two rows for the same installment. So the pair (installment_number, payroll_run_id) is what identifies a row, not either one alone. */
export type CreditInstallmentPaymentType = {
  __typename?: 'CreditInstallmentPaymentType';
  /** What this run paid of this installment. Always greater than zero. Whether the installment is closed is `sum(amount) >= installment_amount` of the credit — there is no `is_partial` column, because a partial payment is a fact about the sum, not about the row. */
  amount: Scalars['Float']['output'];
  created_at: Scalars['DateTime']['output'];
  government_credit_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The recurring incidence the run took to find the credit. Nullable on purpose: the payment hangs from the credit, and losing the trace is acceptable where losing the payment would change the balance. */
  incidence_id?: Maybe<Scalars['ID']['output']>;
  /** First day of the month the installment belongs to. */
  installment_month: Scalars['Date']['output'];
  installment_number: Scalars['Int']['output'];
  payroll_run_id: Scalars['ID']['output'];
  period_end: Scalars['Date']['output'];
  period_start: Scalars['Date']['output'];
};

export type CrehanAiCentralizedUser = {
  __typename?: 'CrehanAICentralizedUser';
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastname: Scalars['String']['output'];
  profile_url?: Maybe<Scalars['String']['output']>;
};

export type CrehanaAuthAccessToken = {
  __typename?: 'CrehanaAuthAccessToken';
  application_id: Scalars['ID']['output'];
  backend: AccessTokenBackenEnum;
  created_date: Scalars['DateTime']['output'];
  expire_date: Scalars['DateTime']['output'];
  token: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
};

export type CrehanaAuthCoporation = {
  __typename?: 'CrehanaAuthCoporation';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type CrehanaAuthOrganization = {
  __typename?: 'CrehanaAuthOrganization';
  corporation?: Maybe<CrehanaAuthCoporation>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  login_url?: Maybe<Scalars['String']['output']>;
  logo_url: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type CrehanaAuthUser = {
  __typename?: 'CrehanaAuthUser';
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last_name: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type CrehanaAuthUserOrganization = {
  __typename?: 'CrehanaAuthUserOrganization';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  organization: CrehanaAuthOrganization;
  status: CrehanaUserOrganizationStatusEnum;
  updated_at: Scalars['DateTime']['output'];
  user: CrehanaAuthUser;
};

export type CrehanaSession = {
  __typename?: 'CrehanaSession';
  auth_user: User;
  auth_user_backend: Scalars['String']['output'];
  auth_user_hash: Scalars['String']['output'];
  auth_user_id: Scalars['String']['output'];
  session_key: Scalars['String']['output'];
  session_type: Scalars['String']['output'];
};

export type CrehanaSessionResponse = {
  __typename?: 'CrehanaSessionResponse';
  crehana_session?: Maybe<CrehanaSession>;
  success: Scalars['Boolean']['output'];
};

export type CrehanaUserData = {
  __typename?: 'CrehanaUserData';
  user_data: UserData;
  user_organization: CrehanaAuthUserOrganization;
};

export enum CrehanaUserOrganizationStatusEnum {
  UserOrganizationStatusActive = 'USER_ORGANIZATION_STATUS_ACTIVE',
  UserOrganizationStatusDeleted = 'USER_ORGANIZATION_STATUS_DELETED',
  UserOrganizationStatusInactive = 'USER_ORGANIZATION_STATUS_INACTIVE',
  UserOrganizationStatusPending = 'USER_ORGANIZATION_STATUS_PENDING'
}

export enum CrudActionEnum {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type CsdStatusResponse = {
  __typename?: 'CsdStatusResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: CsdStatusType;
};

export type CsdStatusType = {
  __typename?: 'CsdStatusType';
  days_until_expiration?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['Date']['output']>;
  has_cer: Scalars['Boolean']['output'];
  has_key: Scalars['Boolean']['output'];
  is_expired: Scalars['Boolean']['output'];
  is_valid: Scalars['Boolean']['output'];
  validated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CurrenciesResponse = {
  __typename?: 'CurrenciesResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<CurrencyItem>;
};

export type CurrencyAchievementMutationNode = {
  __typename?: 'CurrencyAchievementMutationNode';
  /** Contains an instance of the CurrencyEvent model */
  currency_achievement?: Maybe<Array<CurrencyEventNode>>;
  /**
   * This object contains information about the response code,
   *         response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CurrencyAchievementUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  original_id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum CurrencyEnum {
  Ars = 'ARS',
  Brl = 'BRL',
  Clp = 'CLP',
  Cop = 'COP',
  Eur = 'EUR',
  Mxn = 'MXN',
  Pen = 'PEN',
  Usd = 'USD'
}

export type CurrencyEventConnection = {
  __typename?: 'CurrencyEventConnection';
  /** Contains the nodes in this connection */
  edges: Array<CurrencyEventNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum CurrencyEventEnum {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Value = 'VALUE'
}

/** Currency Events fields enum to order queryset */
export enum CurrencyEventFieldsEnum {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Value = 'VALUE'
}

export type CurrencyEventFragmentConnection = {
  __typename?: 'CurrencyEventFragmentConnection';
  /** Contains the nodes in this connection */
  edges: Array<AdminCurrencyEventFragmentNodeEdgeUserCurrencyEventFragmentNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type CurrencyEventFragmentNode = AdminCurrencyEventFragmentNode | ResponseIntegrityError | ResponseInternalError | ResponseValidationError | UserCurrencyEventFragmentNode;

/** This input consolidates the list of events and achievements to be edited, each with its Pydantic validation. Additionally, it handles the traditional organization_id. */
export type CurrencyEventMutationEditInput = {
  achievement_set?: InputMaybe<Array<AchievementUpdateInput>>;
  event_set?: InputMaybe<Array<EventUpdateInput>>;
  organization_id: Scalars['ID']['input'];
};

export type CurrencyEventMutationNode = {
  __typename?: 'CurrencyEventMutationNode';
  /** List of currency events associated with this mutation node */
  currency_event?: Maybe<Array<Maybe<CurrencyEventNode>>>;
  /**
   * This object contains information about the response code,
   *         response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CurrencyEventNode = {
  __typename?: 'CurrencyEventNode';
  background_color?: Maybe<Scalars['String']['output']>;
  currency_point_id?: Maybe<Scalars['Int']['output']>;
  custom_description?: Maybe<Scalars['String']['output']>;
  custom_name: Scalars['String']['output'];
  custom_text?: Maybe<Scalars['String']['output']>;
  event_id?: Maybe<Scalars['Int']['output']>;
  /** EventName related to the CurrencyEvent's Event */
  event_subject?: Maybe<Scalars['String']['output']>;
  event_type_enum?: Maybe<EventTypeEnum>;
  icon?: Maybe<ImageNode>;
  id: Scalars['ID']['output'];
  is_custom_event: Scalars['Boolean']['output'];
  url_redirect?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CurrencyEventNodeEdge = {
  __typename?: 'CurrencyEventNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CurrencyEventNode;
};

export type CurrencyEventOrderByInput = {
  direction: OrderDirectionEnum;
  field: CurrencyEventEnum;
};

export type CurrencyEventQueryInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  currency_event_id?: InputMaybe<Scalars['ID']['input']>;
  currency_point_id?: InputMaybe<Scalars['ID']['input']>;
  event_subject_enum?: InputMaybe<EventSubjectEnum>;
  event_type_enum?: InputMaybe<EventTypeEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  object_id?: InputMaybe<Scalars['ID']['input']>;
  object_type?: InputMaybe<ObjectTypeEnum>;
  order_by?: InputMaybe<Array<CurrencyEventQueryOrderByInput>>;
  organization_id?: InputMaybe<Scalars['ID']['input']>;
  panel_admin?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Currency Event order by input */
export type CurrencyEventQueryOrderByInput = {
  direction: OrderDirectionEnum;
  field: CurrencyEventFieldsEnum;
};

export enum CurrencyEventTypeEnum {
  Achievement = 'ACHIEVEMENT',
  Event = 'EVENT'
}

export type CurrencyEventUpdateInput = {
  original_id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type CurrencyItem = {
  __typename?: 'CurrencyItem';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type CurrencyPointConfigNode = {
  __typename?: 'CurrencyPointConfigNode';
  allow_all_users?: Maybe<Scalars['Boolean']['output']>;
  currency_point_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type CurrencyPointConnection = {
  __typename?: 'CurrencyPointConnection';
  /** Contains the nodes in this connection */
  edges: Array<CurrencyPointNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

/** This enum represents the editing actions that can be performed on a currency_point object. */
export enum CurrencyPointEditFieldsEnum {
  DeletedAt = 'DELETED_AT',
  InitialSetup = 'INITIAL_SETUP',
  NameOrStatus = 'NAME_OR_STATUS',
  SetupCompleted = 'SETUP_COMPLETED'
}

export enum CurrencyPointEnum {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

/** Currency Points fields enum to order queryset */
export enum CurrencyPointFieldsEnum {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

export type CurrencyPointFragmentConnection = {
  __typename?: 'CurrencyPointFragmentConnection';
  /** Contains the nodes in this connection */
  edges: Array<AdminCurrencyPointNodeEdgeUserCurrencyPointNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type CurrencyPointFragmentNode = AdminCurrencyPointNode | ResponseIntegrityError | ResponseInternalError | ResponseValidationError | UserCurrencyPointNode;

/** This enum represents the initial states of a currency point. */
export enum CurrencyPointFragmentStatusEnum {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** This input contains the fields to be validated in order to create a currency point object, such as organization_id and panel_admin. */
export type CurrencyPointMutationCreateInput = {
  organization_id?: InputMaybe<Scalars['String']['input']>;
  panel_admin?: InputMaybe<Scalars['Boolean']['input']>;
};

/** This input contains the fields to be inserted in a currency point object, as well as the type of editing, which can be for name and/or status, initial_setup, setup_completed, and even deletion. The validations are performed with pydantic and its experimental combination with strawberry. */
export type CurrencyPointMutationEditInput = {
  edit_field: CurrencyPointEditFieldsEnum;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['String']['input'];
  status_enum?: InputMaybe<CurrencyPointFragmentStatusEnum>;
};

export type CurrencyPointMutationNode = {
  __typename?: 'CurrencyPointMutationNode';
  /** Contains an instance of the CurrencyPoint model */
  currency_point?: Maybe<CurrencyPointNode>;
  /**
   * This object contains information about the response code,
   *         response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CurrencyPointNode = {
  __typename?: 'CurrencyPointNode';
  /** List of allowed users */
  allowed_users: AllowedUserConnection;
  /** CurrencyPoint's config */
  currency_point_config?: Maybe<CurrencyPointConfigNode>;
  /** List of events associated with a currency point */
  events: CurrencyEventConnection;
  id?: Maybe<Scalars['ID']['output']>;
  initial_setup?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['ID']['output']>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  /** List of rewards associated with a currency point */
  rewards: RewardConnection;
  setup_completed?: Maybe<Scalars['Boolean']['output']>;
  status_enum?: Maybe<CurrencyPointStatusEnum>;
};


export type CurrencyPointNodeAllowed_UsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AllowedUsersOrderByInput>>;
};


export type CurrencyPointNodeEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<EventTypeEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CurrencyEventOrderByInput>>;
};


export type CurrencyPointNodeRewardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RewardOrderByInput>>;
};

export type CurrencyPointNodeEdge = {
  __typename?: 'CurrencyPointNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CurrencyPointNode;
};

export type CurrencyPointOrderByInput = {
  direction: OrderDirectionEnum;
  field: CurrencyPointEnum;
};

export type CurrencyPointQueryInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  currency_point_id?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CurrencyPointQueryOrderByInput>>;
  organization_id?: InputMaybe<Scalars['ID']['input']>;
  panel_admin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CurrencyPointQueryOrderByInput = {
  direction: OrderDirectionEnum;
  field: CurrencyPointFieldsEnum;
};

export enum CurrencyPointStatusEnum {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type CurrencyPointUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  original_id: Scalars['ID']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  status_enum?: InputMaybe<CurrencyPointStatusEnum>;
};

export type CurrencyPoints = {
  __typename?: 'CurrencyPoints';
  /** This resource displays the associated currency point for the organization. It supports fragments for standard users, admin users, and staff users. */
  currency_points: CurrencyPointFragmentConnection;
  /** This resource displays the currency point-related events or achievements associated with the organization. Each event or achievement is specifically tied to a currency point, and this resource supports fragments for standard users, admin users, and staff users. */
  events_or_achievements: CurrencyEventFragmentConnection;
  /** This resource displays the achievements obtained by a user. Each achievement is associated with a specific event subject and is accessible to admin, staff, and standard users. This resource provides various methods to retrieve and manage achievement data, allowing users to view and interact with their earned achievements. */
  user_achievements: UserAchievementFragmentConnection;
  /** User Unseen Reached Events is a resource that provides information about the events or achievements that have been reached by a user but remain unseen. This resource caters to the known levels of users, including standard users, admin users, and staff users */
  user_unseen_reached_events: CurrencyEventFragmentConnection;
};


export type CurrencyPointsCurrency_PointsArgs = {
  query_variables: CurrencyPointQueryInput;
};


export type CurrencyPointsEvents_Or_AchievementsArgs = {
  query_variables: CurrencyEventQueryInput;
};


export type CurrencyPointsUser_AchievementsArgs = {
  query_variables: CurrencyEventQueryInput;
};


export type CurrencyPointsUser_Unseen_Reached_EventsArgs = {
  query_variables: CurrencyEventQueryInput;
};

export type CursorPageInfo = PageInfoI & {
  __typename?: 'CursorPageInfo';
  /** When paginating forwards, the cursor to continue. */
  end_cursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  has_next_page: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  has_previous_page: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  start_cursor?: Maybe<Scalars['String']['output']>;
};

export type CursorPagination = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type CursorPaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  /** First elements */
  first?: Scalars['Int']['input'];
};

/** This input includes all the necessary fields to create a custom achievement. */
export type CustomCurrencyEventMutationEditInput = {
  background_color: Scalars['String']['input'];
  currency_point_value: Scalars['Float']['input'];
  custom_description?: InputMaybe<Scalars['String']['input']>;
  custom_icon_url: Scalars['String']['input'];
  custom_name: Scalars['String']['input'];
  organization_id: Scalars['String']['input'];
};

export type CustomEmailAttachmentInput = {
  file_id: Scalars['Int']['input'];
  file_key: Scalars['String']['input'];
  file_name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type CustomFieldAttachment = {
  __typename?: 'CustomFieldAttachment';
  fields: Array<SignedField>;
  file_name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Custom Field Choices relation Node */
export type CustomFieldChoicesNode = {
  __typename?: 'CustomFieldChoicesNode';
  /** Custom Field ID */
  custom_field_id: Scalars['Int']['output'];
  /** Name of the custom field */
  name: Scalars['String']['output'];
  original_id: Scalars['Int']['output'];
};

export type CustomFieldFilter = {
  __typename?: 'CustomFieldFilter';
  data_type: DataTypeEnum;
  field_id: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type CustomFieldFilterInput = {
  data_type: DataTypeEnum;
  field_id: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export enum CustomFieldMandatoryEnum {
  Creation = 'CREATION',
  Profile = 'PROFILE'
}

/** Custom Field relation Node */
export type CustomFieldNode = {
  __typename?: 'CustomFieldNode';
  /** If the custom field can be edited */
  can_edit: Scalars['Boolean']['output'];
  /** Custom field creation date */
  created_at: Scalars['DateTime']['output'];
  /** Author of the Custom Field related to a User */
  created_by?: Maybe<CentralizedUserNode>;
  /** Custom Fields related to the Organization */
  custom_field_choices: Array<CustomFieldChoicesNode>;
  /** Description of the custom field */
  description?: Maybe<Scalars['String']['output']>;
  /** If the custom field is mandatory */
  is_mandatory: Scalars['Boolean']['output'];
  /** If the custom field is visible */
  is_visible: Scalars['Boolean']['output'];
  /** Max length of the custom field */
  max_length?: Maybe<Scalars['Int']['output']>;
  /** Name of the custom field */
  name: Scalars['String']['output'];
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Original ID */
  original_id: Scalars['Int']['output'];
  /** Internal slug of the custom field, must be unique */
  slug: Scalars['String']['output'];
  /** Custom Fields related to a UserOrganization */
  total_count: Scalars['Int']['output'];
  /** Custom Field type: Text, Number, Date, Multiple */
  type: CustomFieldTypeEnum;
  /** Custom field updated date */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** User ID */
  user_id?: Maybe<Scalars['Int']['output']>;
  /** If the custom field is mandatory, where to show it */
  where_mandatory?: Maybe<CustomFieldMandatoryEnum>;
};

export type CustomFieldNodeCustomConnection = {
  __typename?: 'CustomFieldNodeCustomConnection';
  edges: Array<CustomFieldNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type CustomFieldNodeCustomEdge = {
  __typename?: 'CustomFieldNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CustomFieldNode;
};

export type CustomFieldPerformanceResponse = {
  __typename?: 'CustomFieldPerformanceResponse';
  has_partial_results: Scalars['Boolean']['output'];
  summary: Array<CustomFieldPerformanceSummary>;
};

export type CustomFieldPerformanceSummary = {
  __typename?: 'CustomFieldPerformanceSummary';
  active_user: Scalars['Int']['output'];
  certificates: Scalars['Int']['output'];
  completed_courses: Scalars['Int']['output'];
  initial_courses: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  projects_delivered: Scalars['Int']['output'];
  register_user: Scalars['Int']['output'];
  studying_user: Scalars['Int']['output'];
  users_id?: Maybe<Array<Scalars['Int']['output']>>;
};

export type CustomFieldType = {
  __typename?: 'CustomFieldType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum CustomFieldTypeEnum {
  Date = 'DATE',
  Multiple = 'MULTIPLE',
  Number = 'NUMBER',
  Text = 'TEXT'
}

export type CustomFieldUserCreationInput = {
  choice_id?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Custom Field User Values relation Node */
export type CustomFieldUserValueNode = {
  __typename?: 'CustomFieldUserValueNode';
  /** Custom Field Choice ID */
  custom_field_choice_id?: Maybe<Scalars['Int']['output']>;
  /** User email */
  email: Scalars['String']['output'];
  /** firstname */
  firstname: Scalars['String']['output'];
  /** lastname */
  lastname: Scalars['String']['output'];
  /** User ID */
  user_id: Scalars['Int']['output'];
  /** Answer of the custom field */
  value: Scalars['String']['output'];
};

export type CustomFieldUserValueNodeConnection = {
  __typename?: 'CustomFieldUserValueNodeConnection';
  /** A list of edges in this connection. */
  edges: Array<CustomFieldUserValueNodeEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type CustomFieldUserValueNodeEdge = {
  __typename?: 'CustomFieldUserValueNodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomFieldUserValueNode;
};

/** Custom Field Values relation Node */
export type CustomFieldValueNode = {
  __typename?: 'CustomFieldValueNode';
  /** Custom Field Choice ID */
  custom_field_choice_id?: Maybe<Scalars['Int']['output']>;
  /** Custom Field ID */
  custom_field_id: Scalars['Int']['output'];
  original_id: Scalars['Int']['output'];
  /** User ID */
  user_id: Scalars['Int']['output'];
  /** Answer of the custom field */
  value: Scalars['String']['output'];
};

export type CustomFieldValuesInput = {
  custom_field_id: Scalars['String']['input'];
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum CustomFieldsOperatorEnum {
  OperatorAnd = 'OPERATOR_AND',
  OperatorOr = 'OPERATOR_OR'
}

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type CustomPageInfo = {
  __typename?: 'CustomPageInfo';
  /** When paginating forwards, the cursor to continue. */
  end_cursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  has_next_page: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  has_previous_page: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  start_cursor?: Maybe<Scalars['String']['output']>;
};

export type CustomReportBulkMutationSuccess = {
  __typename?: 'CustomReportBulkMutationSuccess';
  /** List of created custom reports. */
  custom_reports: Array<CustomReportNode>;
  /** Operation trace ID. */
  graphql_operation_id: Scalars['String']['output'];
};

export type CustomReportBulkMutationSuccessCustomReportValidationErrorCustomReportScheduleLimitErrorCustomReportInternalError = CustomReportBulkMutationSuccess | CustomReportInternalError | CustomReportScheduleLimitError | CustomReportValidationError;

/** Full resolved detail of a CustomReport's configuration. All IDs in report_input_config are resolved to their display names. */
export type CustomReportConfigDetailNode = {
  __typename?: 'CustomReportConfigDetailNode';
  /** Courses selected, resolved to {id, name}. Empty if none. */
  courses: Array<ResolvedEntityNode>;
  /** The CustomReport ID. */
  custom_report_id: Scalars['Int']['output'];
  /** Custom report display name. */
  name: Scalars['String']['output'];
  /** Progress range end (Rango de fecha de avance), if configured. */
  progress_end_date?: Maybe<Scalars['Date']['output']>;
  /** Progress range start (Rango de fecha de avance), if configured. */
  progress_start_date?: Maybe<Scalars['Date']['output']>;
  /** The full raw report_input_config JSON for reference. */
  raw_config: Scalars['JSON']['output'];
  /** Report type value. */
  report_type: Scalars['String']['output'];
  /** Routes/tracks selected, resolved to {id, name}. Empty if none. */
  routes: Array<ResolvedEntityNode>;
  /** Segment ID, if configured. */
  segment_id?: Maybe<Scalars['Int']['output']>;
  /** Column selection per sheet, with IDs resolved to names. Empty if no column_selection. */
  sheets: Array<SheetColumnDetailNode>;
  /** Centralized users selected, resolved to {id, full_name}. Empty if none. */
  users: Array<ResolvedUserNode>;
};

/** A selectable course row for the custom-report course picker (ANLT-535): name, type (propio/catálogo), whether it has an evaluation, and assigned users. */
export type CustomReportCourseNode = {
  __typename?: 'CustomReportCourseNode';
  assigned_users?: Maybe<Scalars['Int']['output']>;
  course_id: Scalars['Int']['output'];
  course_name?: Maybe<Scalars['String']['output']>;
  has_evaluation?: Maybe<Scalars['Boolean']['output']>;
  /** True = catálogo Crehana, False = propio (Librería Organización). */
  is_crehana?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomReportCourseNodeConnection = {
  __typename?: 'CustomReportCourseNodeConnection';
  /** A list of edges in this connection. */
  edges: Array<CustomReportCourseNodeEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type CustomReportCourseNodeEdge = {
  __typename?: 'CustomReportCourseNodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomReportCourseNode;
};

/** ANLT-535: course-type filter for the custom-report course picker. ALL = todos, OWN = propios (Librería Organización), CREHANA = catálogo Crehana. */
export enum CustomReportCourseTypeInput {
  All = 'ALL',
  Crehana = 'CREHANA',
  Own = 'OWN'
}

export type CustomReportDeleteSuccess = {
  __typename?: 'CustomReportDeleteSuccess';
  /** Operation trace ID. */
  graphql_operation_id: Scalars['String']['output'];
  /** ID of the deleted custom report. */
  id: Scalars['ID']['output'];
  /** Name of the deleted custom report. */
  name: Scalars['String']['output'];
  /** Report type of the deleted custom report. */
  report_type: ReportsEnum;
};

export type CustomReportDeleteSuccessCustomReportValidationErrorCustomReportInternalError = CustomReportDeleteSuccess | CustomReportInternalError | CustomReportValidationError;

export type CustomReportInternalError = {
  __typename?: 'CustomReportInternalError';
  /** Operation trace ID. */
  graphql_operation_id: Scalars['String']['output'];
  /** Internal error message. */
  message: Scalars['String']['output'];
};

export type CustomReportMutationSuccess = {
  __typename?: 'CustomReportMutationSuccess';
  /** The created or updated custom report. */
  custom_report: CustomReportNode;
  /** Operation trace ID. */
  graphql_operation_id: Scalars['String']['output'];
};

export type CustomReportMutationSuccessCustomReportValidationErrorCustomReportScheduleLimitErrorCustomReportInternalError = CustomReportInternalError | CustomReportMutationSuccess | CustomReportScheduleLimitError | CustomReportValidationError;

export type CustomReportNode = {
  __typename?: 'CustomReportNode';
  /** Centralized organization this report belongs to. */
  centralized_organization_id: Scalars['Int']['output'];
  /** ISO creation timestamp. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Centralized user_id of the creator. */
  created_by_user_centralized_id: Scalars['Int']['output'];
  /** Optional description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Full name of the user who created this report. */
  generated_by_full_name?: Maybe<Scalars['String']['output']>;
  /** Display names of the headquarters (sedes) configured in report_input_config.headquarter_ids. Empty when the report is not scoped to specific headquarters. */
  headquarter_names: Array<Scalars['String']['output']>;
  /** Custom report ID. */
  id: Scalars['ID']['output'];
  /** False when soft-deleted. */
  is_active: Scalars['Boolean']['output'];
  /** Display name (max 50 chars). */
  name: Scalars['String']['output'];
  /** Product type of this report. */
  product_type: ProductTypeEnum;
  /** Wizard step 1 config: columns, filters, date ranges, segment. */
  report_input_config: Scalars['JSON']['output'];
  /** Report type (e.g. report_b2b_general) this custom report is based on. */
  report_type: ReportsEnum;
  /** Schedule config. None if no schedule has been configured. */
  schedule?: Maybe<CustomReportScheduleNode>;
  /** ISO last-updated timestamp. */
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type CustomReportNodeConnection = {
  __typename?: 'CustomReportNodeConnection';
  /** A list of edges in this connection. */
  edges: Array<CustomReportNodeEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type CustomReportNodeEdge = {
  __typename?: 'CustomReportNodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomReportNode;
};

export type CustomReportScheduleLimitError = {
  __typename?: 'CustomReportScheduleLimitError';
  /** Current number of active scheduled reports in the organization. */
  current_count: Scalars['Int']['output'];
  /** Operation trace ID. */
  graphql_operation_id: Scalars['String']['output'];
  /** Maximum number of active scheduled reports allowed per organization. */
  max_allowed: Scalars['Int']['output'];
  /** Limit error detail. */
  message: Scalars['String']['output'];
};

export type CustomReportScheduleNode = {
  __typename?: 'CustomReportScheduleNode';
  /** Day 1–31 for MONTHLY frequency. */
  day_of_month?: Maybe<Scalars['Int']['output']>;
  /** Day of week (MON–SUN) for WEEKLY frequency. */
  day_of_week?: Maybe<DayOfWeekInput>;
  /** Consecutive failure count. Resets on success. */
  failure_count: Scalars['Int']['output'];
  /** Frequency: DAILY | WEEKLY | MONTHLY. Null when mode=NONE. */
  frequency?: Maybe<ScheduleFrequencyInput>;
  /** Schedule ID. */
  id: Scalars['ID']['output'];
  /** True if the schedule runs on the last business day of the month. */
  last_business_day: Scalars['Boolean']['output'];
  /** ISO timestamp of the last successful run. */
  last_run_at?: Maybe<Scalars['String']['output']>;
  /** Schedule mode: ACTIVE | PAUSE | NONE. */
  mode: ScheduleModeInput;
  /** ISO timestamp of the next scheduled run. */
  next_run_at?: Maybe<Scalars['String']['output']>;
  /** user_ids that receive the report email. */
  recipients: Array<Scalars['Int']['output']>;
};

export type CustomReportValidationError = {
  __typename?: 'CustomReportValidationError';
  /** Operation trace ID. */
  graphql_operation_id: Scalars['String']['output'];
  /** Validation error detail. */
  message: Scalars['String']['output'];
};

export type CustomTagInterface = {
  tags: UserTagsType;
};

export type CustomizationActivationDateInput = {
  /** date when the automation will stop running */
  end_datetime?: InputMaybe<Scalars['DateTime']['input']>;
  start_datetime: Scalars['DateTime']['input'];
};

export type CustomizationActivationDateType = {
  __typename?: 'CustomizationActivationDateType';
  end_datetime?: Maybe<TimeStampType>;
  start_datetime?: Maybe<TimeStampType>;
};

export type Dc3CourseOrganizationTemplateData = {
  agent_name?: InputMaybe<Scalars['String']['input']>;
  agent_register_code_stps?: InputMaybe<Scalars['String']['input']>;
  agent_rfc?: InputMaybe<Scalars['String']['input']>;
  agent_signature_file_id?: InputMaybe<Scalars['Int']['input']>;
  agent_signature_name?: InputMaybe<Scalars['String']['input']>;
  agent_type_enum?: InputMaybe<AgentTypeEnum>;
  has_multiple_instructors?: InputMaybe<Scalars['Boolean']['input']>;
  instructor_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  modality_type_enum?: InputMaybe<ModalityTypeEnum>;
  theme_course_code: Scalars['Int']['input'];
  theme_option_id: Scalars['ID']['input'];
  trainer_name?: InputMaybe<Scalars['String']['input']>;
  trainer_register_code_stps?: InputMaybe<Scalars['String']['input']>;
  trainer_signature_file_id?: InputMaybe<Scalars['Int']['input']>;
  trainer_signature_name?: InputMaybe<Scalars['String']['input']>;
  training_objective_enum?: InputMaybe<TrainingObjectiveEnum>;
};

export type Dc3CourseOrganizationTemplateNode = {
  __typename?: 'DC3CourseOrganizationTemplateNode';
  agent_name?: Maybe<Scalars['String']['output']>;
  agent_register_code_stps?: Maybe<Scalars['String']['output']>;
  agent_rfc?: Maybe<Scalars['String']['output']>;
  agent_signature_file_id?: Maybe<Scalars['Int']['output']>;
  agent_signature_name?: Maybe<Scalars['String']['output']>;
  agent_type?: Maybe<AgentTypeEnum>;
  course_organization_template_id: Scalars['ID']['output'];
  document_agent_signature_file?: Maybe<File>;
  document_trainer_signature_file?: Maybe<File>;
  has_multiple_instructors: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  instructors?: Maybe<Array<OrganizationCourseInstructorNode>>;
  modality_type?: Maybe<ModalityTypeEnum>;
  theme_course_code: Scalars['Int']['output'];
  theme_option?: Maybe<Dc3ThemeOptionNode>;
  theme_option_id: Scalars['ID']['output'];
  trainer_name?: Maybe<Scalars['String']['output']>;
  trainer_register_code_stps?: Maybe<Scalars['String']['output']>;
  trainer_signature_file_id?: Maybe<Scalars['Int']['output']>;
  trainer_signature_name?: Maybe<Scalars['String']['output']>;
  training_objective?: Maybe<TrainingObjectiveEnum>;
};

export type Dc3OrganizationNameInput = {
  country_enum?: InputMaybe<AmericaCountryEnum>;
  dc3_organization_name_id?: InputMaybe<Scalars['Int']['input']>;
  employer_representation_signature_file_id?: InputMaybe<Scalars['Int']['input']>;
  employer_representation_signature_name?: InputMaybe<Scalars['String']['input']>;
  legal_address?: InputMaybe<Scalars['String']['input']>;
  legal_representation_signature_file_id?: InputMaybe<Scalars['Int']['input']>;
  legal_representation_signature_name?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['Int']['input'];
  organization_name: Scalars['String']['input'];
  organization_name_attribute_id: Scalars['String']['input'];
  organization_name_attribute_label?: InputMaybe<Scalars['String']['input']>;
  organization_rfc?: InputMaybe<Scalars['String']['input']>;
};

export type Dc3OrganizationNameNode = {
  __typename?: 'DC3OrganizationNameNode';
  country_enum?: Maybe<AmericaCountryEnum>;
  country_id?: Maybe<Scalars['String']['output']>;
  country_name?: Maybe<Scalars['String']['output']>;
  document_employer_representation_signature_file?: Maybe<File>;
  document_legal_representation_signature_file?: Maybe<File>;
  employer_representation_signature_file_id?: Maybe<Scalars['Int']['output']>;
  employer_representation_signature_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  legal_address?: Maybe<Scalars['String']['output']>;
  legal_representation_signature_file_id?: Maybe<Scalars['Int']['output']>;
  legal_representation_signature_name?: Maybe<Scalars['String']['output']>;
  organization_id: Scalars['Int']['output'];
  organization_name?: Maybe<Scalars['String']['output']>;
  organization_name_attribute_id?: Maybe<Scalars['String']['output']>;
  organization_name_attribute_label?: Maybe<Scalars['String']['output']>;
  organization_rfc?: Maybe<Scalars['String']['output']>;
};

export type Dc3OrganizationNameNodeConnection = {
  __typename?: 'DC3OrganizationNameNodeConnection';
  /** A list of edges in this connection. */
  edges: Array<Dc3OrganizationNameNodeEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type Dc3OrganizationNameNodeConnectionQueryInternalError = Dc3OrganizationNameNodeConnection | QueryInternalError;

export type Dc3OrganizationNameNodeEdge = {
  __typename?: 'DC3OrganizationNameNodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Dc3OrganizationNameNode;
};

export type Dc3OrganizationNameResponsePayload = {
  __typename?: 'DC3OrganizationNameResponsePayload';
  dc3_organization_name: Dc3OrganizationNameNode;
};

export type Dc3OrganizationNamesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<SearchInput>;
};

export type Dc3OrganizationTemplateData = {
  agent_name?: InputMaybe<Scalars['String']['input']>;
  agent_register_code_stps?: InputMaybe<Scalars['String']['input']>;
  agent_rfc?: InputMaybe<Scalars['String']['input']>;
  agent_type_enum?: InputMaybe<AgentTypeEnum>;
  employee_curp_attribute_id: Scalars['String']['input'];
  employee_curp_attribute_name: Scalars['String']['input'];
  employee_job_attribute_id: Scalars['String']['input'];
  employee_job_attribute_name: Scalars['String']['input'];
  employee_occupation_stps_attribute_id: Scalars['String']['input'];
  employee_occupation_stps_name: Scalars['String']['input'];
  employer_representation_signature_file_id?: InputMaybe<Scalars['Int']['input']>;
  employer_representation_signature_name?: InputMaybe<Scalars['String']['input']>;
  enterprise_activity?: InputMaybe<Scalars['String']['input']>;
  enterprise_employer_registration?: InputMaybe<Scalars['String']['input']>;
  enterprise_name?: InputMaybe<Scalars['String']['input']>;
  enterprise_rfc?: InputMaybe<Scalars['String']['input']>;
  is_default_agent_data?: InputMaybe<Scalars['Boolean']['input']>;
  is_default_employer_representation_signature_data?: InputMaybe<Scalars['Boolean']['input']>;
  is_default_enterprise_data?: InputMaybe<Scalars['Boolean']['input']>;
  is_default_legal_manager_signature_data?: InputMaybe<Scalars['Boolean']['input']>;
  is_default_template_logo?: InputMaybe<Scalars['Boolean']['input']>;
  is_default_trainer_data?: InputMaybe<Scalars['Boolean']['input']>;
  is_default_trainer_signature_data?: InputMaybe<Scalars['Boolean']['input']>;
  is_organization_name_automatic?: InputMaybe<Scalars['Boolean']['input']>;
  is_signatures_automatic?: InputMaybe<Scalars['Boolean']['input']>;
  legal_representation_signature_file_id?: InputMaybe<Scalars['Int']['input']>;
  legal_representation_signature_name?: InputMaybe<Scalars['String']['input']>;
  trainer_name?: InputMaybe<Scalars['String']['input']>;
  trainer_register_code_stps?: InputMaybe<Scalars['String']['input']>;
  trainer_representation_signature_file_id?: InputMaybe<Scalars['Int']['input']>;
  trainer_representation_signature_name?: InputMaybe<Scalars['String']['input']>;
};

export type Dc3OrganizationTemplateDataNode = {
  __typename?: 'DC3OrganizationTemplateDataNode';
  agent_name?: Maybe<Scalars['String']['output']>;
  agent_register_code_stps?: Maybe<Scalars['String']['output']>;
  agent_rfc?: Maybe<Scalars['String']['output']>;
  agent_type?: Maybe<AgentTypeEnum>;
  document_employer_representation_signature_file?: Maybe<File>;
  document_legal_representation_signature_file?: Maybe<File>;
  document_trainer_representation_signature_file?: Maybe<File>;
  employee_curp_attribute_id: Scalars['String']['output'];
  employee_curp_attribute_name: Scalars['String']['output'];
  employee_job_attribute_id: Scalars['String']['output'];
  employee_job_attribute_name: Scalars['String']['output'];
  employee_occupation_stps_attribute_id: Scalars['String']['output'];
  employee_occupation_stps_name: Scalars['String']['output'];
  employer_representation_signature_file_id?: Maybe<Scalars['Int']['output']>;
  employer_representation_signature_name?: Maybe<Scalars['String']['output']>;
  enterprise_activity?: Maybe<Scalars['String']['output']>;
  enterprise_employer_registration?: Maybe<Scalars['String']['output']>;
  enterprise_name?: Maybe<Scalars['String']['output']>;
  enterprise_rfc?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_default_agent_data?: Maybe<Scalars['Boolean']['output']>;
  is_default_employer_representation_signature_data?: Maybe<Scalars['Boolean']['output']>;
  is_default_enterprise_data?: Maybe<Scalars['Boolean']['output']>;
  is_default_legal_manager_signature_data?: Maybe<Scalars['Boolean']['output']>;
  is_default_template_logo?: Maybe<Scalars['Boolean']['output']>;
  is_default_trainer_data?: Maybe<Scalars['Boolean']['output']>;
  is_default_trainer_signature_data?: Maybe<Scalars['Boolean']['output']>;
  is_organization_name_automatic?: Maybe<Scalars['Boolean']['output']>;
  is_signatures_automatic?: Maybe<Scalars['Boolean']['output']>;
  legal_representation_signature_file_id?: Maybe<Scalars['Int']['output']>;
  legal_representation_signature_name?: Maybe<Scalars['String']['output']>;
  trainer_name?: Maybe<Scalars['String']['output']>;
  trainer_register_code_stps?: Maybe<Scalars['String']['output']>;
  trainer_representation_signature_file_id?: Maybe<Scalars['Int']['output']>;
  trainer_representation_signature_name?: Maybe<Scalars['String']['output']>;
};

export type Dc3ThemeOptionNode = {
  __typename?: 'DC3ThemeOptionNode';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type Dc3ThemeOptionNodePaginationEdge = {
  __typename?: 'DC3ThemeOptionNodePaginationEdge';
  /** The item at the end of the edge. */
  node: Dc3ThemeOptionNode;
};

export type Dc3ThemeOptionTypeInput = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search_key?: InputMaybe<Scalars['String']['input']>;
};

export type Dc4OrganizationAttributeInput = {
  company_name_key?: InputMaybe<Scalars['String']['input']>;
  company_name_key_name?: InputMaybe<Scalars['String']['input']>;
  company_rfc_key?: InputMaybe<Scalars['String']['input']>;
  company_rfc_key_name?: InputMaybe<Scalars['String']['input']>;
  course_key?: InputMaybe<Scalars['String']['input']>;
  course_key_name?: InputMaybe<Scalars['String']['input']>;
  dc4_organization_attribute_id?: InputMaybe<Scalars['Int']['input']>;
  education_level_key?: InputMaybe<Scalars['String']['input']>;
  education_level_key_name?: InputMaybe<Scalars['String']['input']>;
  establishment_key?: InputMaybe<Scalars['String']['input']>;
  establishment_key_name?: InputMaybe<Scalars['String']['input']>;
  institution_key?: InputMaybe<Scalars['String']['input']>;
  institution_key_name?: InputMaybe<Scalars['String']['input']>;
  municipality_key?: InputMaybe<Scalars['String']['input']>;
  municipality_key_name?: InputMaybe<Scalars['String']['input']>;
  occupation_key?: InputMaybe<Scalars['String']['input']>;
  occupation_key_name?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['Int']['input'];
  proof_document?: InputMaybe<Scalars['String']['input']>;
  proof_document_name?: InputMaybe<Scalars['String']['input']>;
  state_key?: InputMaybe<Scalars['String']['input']>;
  state_key_name?: InputMaybe<Scalars['String']['input']>;
  training_key?: InputMaybe<Scalars['String']['input']>;
  training_key_name?: InputMaybe<Scalars['String']['input']>;
};

export type Dc4OrganizationAttributeNode = {
  __typename?: 'DC4OrganizationAttributeNode';
  company_name_key?: Maybe<Scalars['String']['output']>;
  company_name_key_name?: Maybe<Scalars['String']['output']>;
  company_rfc_key?: Maybe<Scalars['String']['output']>;
  company_rfc_key_name?: Maybe<Scalars['String']['output']>;
  course_key?: Maybe<Scalars['String']['output']>;
  course_key_name?: Maybe<Scalars['String']['output']>;
  education_level_key?: Maybe<Scalars['String']['output']>;
  education_level_key_name?: Maybe<Scalars['String']['output']>;
  establishment_key?: Maybe<Scalars['String']['output']>;
  establishment_key_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  institution_key?: Maybe<Scalars['String']['output']>;
  institution_key_name?: Maybe<Scalars['String']['output']>;
  municipality_key?: Maybe<Scalars['String']['output']>;
  municipality_key_name?: Maybe<Scalars['String']['output']>;
  occupation_key?: Maybe<Scalars['String']['output']>;
  occupation_key_name?: Maybe<Scalars['String']['output']>;
  organization_id: Scalars['Int']['output'];
  proof_document?: Maybe<Scalars['String']['output']>;
  proof_document_name?: Maybe<Scalars['String']['output']>;
  state_key?: Maybe<Scalars['String']['output']>;
  state_key_name?: Maybe<Scalars['String']['output']>;
  training_key?: Maybe<Scalars['String']['output']>;
  training_key_name?: Maybe<Scalars['String']['output']>;
};

export type Dc4OrganizationAttributeResponsePayload = {
  __typename?: 'DC4OrganizationAttributeResponsePayload';
  dc4_organization_attribute: Dc4OrganizationAttributeNode;
};

export enum DiPemployeeState {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  NotInitiated = 'NOT_INITIATED',
  Pending = 'PENDING',
  PendingBySuperBoss = 'PENDING_BY_SUPER_BOSS',
  Rejected = 'REJECTED'
}

/** Filters for the day-by-day competence progress query. */
export type DailyProgressByMonthInput = {
  /** Talent company id. */
  company_id: Scalars['Int']['input'];
  /** Month (1-12) to chart day by day. */
  month: Scalars['Int']['input'];
  /** Evaluation x relation combinations to plot (up to 3). */
  relations: Array<EvaluationRelationInput>;
  /** Year of the charted month. */
  year: Scalars['Int']['input'];
};

/** Day-by-day cumulative competence progress per relation within a month (line chart of the 'Seguimiento de procesos' block). */
export type DailyProgressByMonthType = {
  __typename?: 'DailyProgressByMonthType';
  entries: Array<DailyProgressEntryType>;
};

/** Per-relation progress for a single day of the month. */
export type DailyProgressEntryType = {
  __typename?: 'DailyProgressEntryType';
  day: Scalars['Int']['output'];
  relations: Array<DailyRelationProgressType>;
};

/** Progress of one evaluation x relation series on a single day (one point of the 'Seguimiento de procesos' line chart). */
export type DailyRelationProgressType = {
  __typename?: 'DailyRelationProgressType';
  evaluation_id: Scalars['Int']['output'];
  evaluation_name: Scalars['String']['output'];
  progress_percentage: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

/** Response for Section D — actionable alerts. */
export type DashboardAlertsResponse = {
  __typename?: 'DashboardAlertsResponse';
  /** Section title (e.g. 'Alertas que necesitan atención'). */
  alert_title: Scalars['String']['output'];
  /** Alert items sorted by severity (RED first). */
  alerts: Array<AlertNode>;
  /** Localized timestamp of the most recent ETL sync for this widget's data. Format: '23 abr - 9:25am'. Null when freshness cannot be determined. */
  last_updated_at_formatted?: Maybe<Scalars['String']['output']>;
  /** Total number of active alerts. */
  total_count: Scalars['Int']['output'];
};

export type DashboardCollaboratorQuery = {
  __typename?: 'DashboardCollaboratorQuery';
  get_talent_dashboard_collaborator_timeline?: Maybe<TalentDashboardCollaboratorTimelineResponse>;
  get_talent_dashboard_collaborator_todo_list: TalentDashboardCollaboratorTodoListResponse;
};


export type DashboardCollaboratorQueryGet_Talent_Dashboard_Collaborator_TimelineArgs = {
  input: TalentDashboardCollaboratorTimelineInput;
};


export type DashboardCollaboratorQueryGet_Talent_Dashboard_Collaborator_Todo_ListArgs = {
  input: TalentDashboardCollaboratorTodoListInput;
};

export enum DashboardFilterEnum {
  Attributes = 'ATTRIBUTES',
  Segmentation = 'SEGMENTATION'
}

/** Response for a single KPI card widget. */
export type DashboardKpiCardResponse = {
  __typename?: 'DashboardKpiCardResponse';
  /** Footer text with context (e.g. 'Activos en los últimos 30 días · Fuente: Gestión / HRIS'). */
  bottom_label?: Maybe<Scalars['String']['output']>;
  /**
   * Deprecated — use delta_value sign instead. Direction of the delta trend.
   * @deprecated Use delta_value sign to determine direction. Positive = up, negative = down, zero = neutral.
   */
  delta_direction: Direction;
  /** Formatted delta percentage (e.g. '4.2%'). */
  delta_formatted?: Maybe<Scalars['String']['output']>;
  /** Period label for the delta (e.g. 'vs semana pasada'). */
  delta_label?: Maybe<Scalars['String']['output']>;
  /** Raw numeric delta (e.g. 4.2, -1.5, 0.0). Positive = up, negative = down. Frontend uses the sign to determine color. */
  delta_value?: Maybe<Scalars['Float']['output']>;
  /** Whether the current user has product-level access to this card. False means the org does not have the required product — frontend should hide the card. */
  has_permission: Scalars['Boolean']['output'];
  /** Localized timestamp of the most recent ETL sync for this widget's data. Format: '23 abr - 9:25am'. Null when freshness cannot be determined. */
  last_updated_at_formatted?: Maybe<Scalars['String']['output']>;
  /** License breakdown for the 'active_collaborators' card. Null when no license account is resolvable for the organization; null for other KPI cards. */
  licenses?: Maybe<DashboardKpiLicenses>;
  /** Collaborators pending first activation. Populated only for the 'active_collaborators' card; null for other KPI cards. */
  pending_count?: Maybe<Scalars['Int']['output']>;
  /** Formatted result for display (e.g. '1,247', '78.4%', '+4.7%'). */
  result_formatted?: Maybe<Scalars['String']['output']>;
  /** Main numeric result. Null when data is not available. */
  result_number?: Maybe<Scalars['Float']['output']>;
  /** Daily aggregated data points for the sparkline chart. */
  sparkline: Array<SparklinePoint>;
  /** Card title (e.g. 'Colaboradores activos'). */
  title: Scalars['String']['output'];
};

/** License breakdown for a KPI card. Null block = no license account resolvable for the organization. */
export type DashboardKpiLicenses = {
  __typename?: 'DashboardKpiLicenses';
  /** Contracted licenses minus active minus pending collaborators. */
  available: Scalars['Int']['output'];
  /** Total licenses contracted by the organization. */
  contracted: Scalars['Int']['output'];
};

export type DashboardLeaderMutation = {
  __typename?: 'DashboardLeaderMutation';
  approve_massive_goals: TalentDashboardApproveMassiveGoalsResponse;
};


export type DashboardLeaderMutationApprove_Massive_GoalsArgs = {
  input: TalentDashboardLeaderApproveMassiveGoalsInput;
};

export type DashboardLeaderQuery = {
  __typename?: 'DashboardLeaderQuery';
  get_competence_evaluations_details: TalentDashboardLeaderEvaluationsResponse;
  get_dashboard_leader_user_modules?: Maybe<DashboardLeaderUserModulesResponse>;
  get_pending_goal_tasks_details?: Maybe<TalentDashboardLeaderGoalDetailsResponse>;
};


export type DashboardLeaderQueryGet_Competence_Evaluations_DetailsArgs = {
  input: TalentDashboardLeaderEvaluationsInput;
};


export type DashboardLeaderQueryGet_Dashboard_Leader_User_ModulesArgs = {
  input: TalentDashboardLeaderEmployeeInput;
};


export type DashboardLeaderQueryGet_Pending_Goal_Tasks_DetailsArgs = {
  input: TalentDashboardLeaderGoalDetailsInput;
};

export type DashboardLeaderUserModulesResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TalentDashboardLeaderUserModulesCustomConnection;

/** Product type for module pulse cards. */
export enum DashboardProductEnum {
  ProductCommunication = 'PRODUCT_COMMUNICATION',
  ProductLearning = 'PRODUCT_LEARNING',
  ProductRecruitment = 'PRODUCT_RECRUITMENT',
  ProductTalent = 'PRODUCT_TALENT'
}

export type DataCentralUserOrganizationConnection = {
  __typename?: 'DataCentralUserOrganizationConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataCentralUserOrganizationNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataCentralUserOrganizationDistinctByEnum {
  CentralUserId = 'CENTRAL_USER_ID',
  UserId = 'USER_ID'
}

export type DataCentralUserOrganizationFilterInput = {
  /** Filtra por central_user_id (igualdad). */
  central_user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por central_user_id (pertenece al conjunto). */
  central_user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por department (igualdad). */
  department?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por department (pertenece al conjunto). */
  department_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por is_active (igualdad). */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por position (igualdad). */
  position?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por position (pertenece al conjunto). */
  position_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por user_first_name (contiene texto, case-insensitive). */
  user_first_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por user_last_name (contiene texto, case-insensitive). */
  user_last_name_contains?: InputMaybe<Scalars['String']['input']>;
};

export enum DataCentralUserOrganizationGroupByEnum {
  Department = 'DEPARTMENT',
  IsActive = 'IS_ACTIVE',
  Position = 'POSITION'
}

/** Puente de identidad del sistema centralizado de Tiempo & Asistencia: relaciona `central_user_id` con `user_id`. Cada fila mapea un usuario entre ambos sistemas. */
export type DataCentralUserOrganizationNode = {
  __typename?: 'DataCentralUserOrganizationNode';
  /** Identificador referencial (clave de entidad); no es una métrica. */
  central_user_id?: Maybe<Scalars['Int']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  user_first_name?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  user_id?: Maybe<Scalars['Int']['output']>;
  user_last_name?: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type DataCentralUserOrganizationNodeEdge = {
  __typename?: 'DataCentralUserOrganizationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataCentralUserOrganizationNode;
};

export type DataCentralUserOrganizationResult = DataCentralUserOrganizationConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataCountPayload = {
  __typename?: 'DataCountPayload';
  /** Cantidad de filas que matchean. */
  count: Scalars['Int']['output'];
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
};

export type DataCountResult = DataCountPayload | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataCourse = {
  __typename?: 'DataCourse';
  /** ID del curso. */
  course_id?: Maybe<Scalars['Int']['output']>;
  /** Nombre del curso. */
  course_name?: Maybe<Scalars['String']['output']>;
};

export type DataCourseConnection = {
  __typename?: 'DataCourseConnection';
  /** Contiene los nodos de cursos. */
  edges: Array<DataCourseEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DataCourseEdge = {
  __typename?: 'DataCourseEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataCourse;
};

export type DataCourseEnrollmentConnection = {
  __typename?: 'DataCourseEnrollmentConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataCourseEnrollmentNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataCourseEnrollmentDistinctByEnum {
  CourseId = 'COURSE_ID',
  UserId = 'USER_ID'
}

export type DataCourseEnrollmentFilterInput = {
  /** Filtra por category_description (contiene texto, case-insensitive). */
  category_description_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por category_title (igualdad). */
  category_title?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por category_title (pertenece al conjunto). */
  category_title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por certificate_created_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  certificate_created_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por certificate_created_date >= (fecha ISO-8601). */
  certificate_created_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por certificate_created_date <= (fecha ISO-8601). */
  certificate_created_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por course_current_progress >. */
  course_current_progress_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_current_progress >=. */
  course_current_progress_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_current_progress <. */
  course_current_progress_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_current_progress <=. */
  course_current_progress_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_domain (igualdad). */
  course_domain?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por course_domain (pertenece al conjunto). */
  course_domain_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por course_ended_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  course_ended_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por course_ended_date >= (fecha ISO-8601). */
  course_ended_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por course_ended_date <= (fecha ISO-8601). */
  course_ended_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por course_enrolled_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  course_enrolled_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por course_enrolled_date >= (fecha ISO-8601). */
  course_enrolled_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por course_enrolled_date <= (fecha ISO-8601). */
  course_enrolled_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por course_id (igualdad). */
  course_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_id (pertenece al conjunto). */
  course_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por course_is_active (igualdad). */
  course_is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por course_is_crehana (igualdad). */
  course_is_crehana?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por course_launch_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  course_launch_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por course_launch_date >= (fecha ISO-8601). */
  course_launch_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por course_launch_date <= (fecha ISO-8601). */
  course_launch_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por course_level (igualdad). */
  course_level?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por course_level (pertenece al conjunto). */
  course_level_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por course_name (igualdad). */
  course_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por course_name (contiene texto, case-insensitive). */
  course_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por has_certificate (igualdad). */
  has_certificate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por has_participation_certificate (igualdad). */
  has_participation_certificate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_finished (igualdad). */
  is_finished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por participation_certificate_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  participation_certificate_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por participation_certificate_date >= (fecha ISO-8601). */
  participation_certificate_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por participation_certificate_date <= (fecha ISO-8601). */
  participation_certificate_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por played_seconds >. */
  played_seconds_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por played_seconds >=. */
  played_seconds_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por played_seconds <. */
  played_seconds_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por played_seconds <=. */
  played_seconds_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por subcategory_description (contiene texto, case-insensitive). */
  subcategory_description_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por subcategory_title (igualdad). */
  subcategory_title?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por subcategory_title (pertenece al conjunto). */
  subcategory_title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum DataCourseEnrollmentGroupByEnum {
  CategoryTitle = 'CATEGORY_TITLE',
  CourseDomain = 'COURSE_DOMAIN',
  CourseIsActive = 'COURSE_IS_ACTIVE',
  CourseLevel = 'COURSE_LEVEL',
  HasCertificate = 'HAS_CERTIFICATE',
  IsFinished = 'IS_FINISHED',
  SubcategoryTitle = 'SUBCATEGORY_TITLE'
}

/** Inscripciones de usuarios a cursos: progreso, fechas de inicio/fin, categoría, nivel y certificados. Cada fila es la inscripción de un usuario a un curso. Formatos de campos: `played_seconds` → segundos; `course_current_progress` → porcentaje entero (0–100). */
export type DataCourseEnrollmentNode = {
  __typename?: 'DataCourseEnrollmentNode';
  category_description?: Maybe<Scalars['String']['output']>;
  category_title?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  certificate_created_date?: Maybe<Scalars['String']['output']>;
  certificate_type?: Maybe<Scalars['Int']['output']>;
  /** Porcentaje entero (0–100). */
  course_current_progress?: Maybe<Scalars['Int']['output']>;
  course_domain?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  course_ended_date?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  course_enrolled_date?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  course_id?: Maybe<Scalars['Int']['output']>;
  course_is_active?: Maybe<Scalars['Boolean']['output']>;
  course_is_crehana?: Maybe<Scalars['Boolean']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  course_launch_date?: Maybe<Scalars['String']['output']>;
  course_level?: Maybe<Scalars['String']['output']>;
  course_name?: Maybe<Scalars['String']['output']>;
  has_certificate?: Maybe<Scalars['Boolean']['output']>;
  has_participation_certificate?: Maybe<Scalars['Boolean']['output']>;
  is_finished?: Maybe<Scalars['Boolean']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  participation_certificate_date?: Maybe<Scalars['String']['output']>;
  /** Cantidad en segundos. */
  played_seconds?: Maybe<Scalars['Float']['output']>;
  subcategory_description?: Maybe<Scalars['String']['output']>;
  subcategory_title?: Maybe<Scalars['String']['output']>;
  url_certificate?: Maybe<Scalars['String']['output']>;
  url_participation_certificate?: Maybe<Scalars['String']['output']>;
  url_project?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type DataCourseEnrollmentNodeEdge = {
  __typename?: 'DataCourseEnrollmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataCourseEnrollmentNode;
};

export type DataCourseEnrollmentResult = DataCourseEnrollmentConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataCourseFilterInput = {
  /** Filtra cursos por categoría (igualdad). */
  category_title?: InputMaybe<Scalars['String']['input']>;
  /** Filtra cursos por categoría (conjunto). */
  category_title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por course_id (igualdad). */
  course_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_id (pertenece al conjunto). */
  course_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra cursos activos/inactivos. */
  course_is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra cursos por nivel (igualdad). */
  course_level?: InputMaybe<Scalars['String']['input']>;
  /** Filtra cursos por nivel (conjunto). */
  course_level_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por nombre del curso (contiene texto). */
  course_name_contains?: InputMaybe<Scalars['String']['input']>;
};

export type DataCourseQuizConnection = {
  __typename?: 'DataCourseQuizConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataCourseQuizNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataCourseQuizDistinctByEnum {
  CourseId = 'COURSE_ID',
  UserId = 'USER_ID'
}

export type DataCourseQuizFilterInput = {
  /** Filtra por course_id (igualdad). */
  course_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_id (pertenece al conjunto). */
  course_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por course_name (igualdad). */
  course_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por course_name (contiene texto, case-insensitive). */
  course_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por is_approved (igualdad). */
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por percentage >. */
  percentage_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por percentage >=. */
  percentage_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por percentage <. */
  percentage_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por percentage <=. */
  percentage_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por points >. */
  points_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por points >=. */
  points_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por points <. */
  points_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por points <=. */
  points_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por quiz_approval_percentage >. */
  quiz_approval_percentage_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_approval_percentage >=. */
  quiz_approval_percentage_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_approval_percentage <. */
  quiz_approval_percentage_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_approval_percentage <=. */
  quiz_approval_percentage_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_attempts_count >. */
  quiz_attempts_count_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_attempts_count >=. */
  quiz_attempts_count_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_attempts_count <. */
  quiz_attempts_count_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_attempts_count <=. */
  quiz_attempts_count_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_id (pertenece al conjunto). */
  quiz_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por quiz_max_points >. */
  quiz_max_points_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_max_points >=. */
  quiz_max_points_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_max_points <. */
  quiz_max_points_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_max_points <=. */
  quiz_max_points_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_num_questions >. */
  quiz_num_questions_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_num_questions >=. */
  quiz_num_questions_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_num_questions <. */
  quiz_num_questions_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por quiz_num_questions <=. */
  quiz_num_questions_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por total_seconds >. */
  total_seconds_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_seconds >=. */
  total_seconds_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_seconds <. */
  total_seconds_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_seconds <=. */
  total_seconds_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_wrong_answer >. */
  total_wrong_answer_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por total_wrong_answer >=. */
  total_wrong_answer_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por total_wrong_answer <. */
  total_wrong_answer_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por total_wrong_answer <=. */
  total_wrong_answer_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum DataCourseQuizGroupByEnum {
  IsApproved = 'IS_APPROVED'
}

/** Evaluaciones (quizzes) rendidas por los usuarios en cursos: intentos, respuestas incorrectas, puntaje y aprobación. Cada fila resume el desempeño de un usuario en un quiz. Formatos de campos: `total_seconds` → segundos; `percentage`, `quiz_approval_percentage` → porcentaje (0–100); `points`, `quiz_max_points` → puntos; `quiz_attempts_count`, `total_wrong_answer`, `quiz_num_questions` → cantidad. */
export type DataCourseQuizNode = {
  __typename?: 'DataCourseQuizNode';
  /** Identificador referencial (clave de entidad); no es una métrica. */
  course_id?: Maybe<Scalars['Int']['output']>;
  course_name?: Maybe<Scalars['String']['output']>;
  is_approved?: Maybe<Scalars['Boolean']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  /** Porcentaje (0–100). */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** Cantidad de puntos. */
  points?: Maybe<Scalars['Float']['output']>;
  /** Porcentaje (0–100). */
  quiz_approval_percentage?: Maybe<Scalars['Int']['output']>;
  /** Cantidad (conteo entero de unidades). */
  quiz_attempts_count?: Maybe<Scalars['Int']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  quiz_id?: Maybe<Scalars['Int']['output']>;
  quiz_is_completed_course_required?: Maybe<Scalars['String']['output']>;
  /** Cantidad de puntos. */
  quiz_max_points?: Maybe<Scalars['Int']['output']>;
  /** Cantidad (conteo entero de unidades). */
  quiz_num_questions?: Maybe<Scalars['Int']['output']>;
  /** Cantidad en segundos. */
  total_seconds?: Maybe<Scalars['Float']['output']>;
  /** Cantidad (conteo entero de unidades). */
  total_wrong_answer?: Maybe<Scalars['Int']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type DataCourseQuizNodeEdge = {
  __typename?: 'DataCourseQuizNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataCourseQuizNode;
};

export type DataCourseQuizResult = DataCourseQuizConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataCourseResult = DataCourseConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataCourseTrackConnection = {
  __typename?: 'DataCourseTrackConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataCourseTrackNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataCourseTrackDistinctByEnum {
  CourseId = 'COURSE_ID',
  TrackId = 'TRACK_ID'
}

export type DataCourseTrackFilterInput = {
  /** Filtra por course_id (igualdad). */
  course_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_id (pertenece al conjunto). */
  course_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por is_active (igualdad). */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por track_id (igualdad). */
  track_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por track_id (pertenece al conjunto). */
  track_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por track_name (igualdad). */
  track_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por track_name (contiene texto, case-insensitive). */
  track_name_contains?: InputMaybe<Scalars['String']['input']>;
};

export enum DataCourseTrackGroupByEnum {
  IsActive = 'IS_ACTIVE',
  TrackId = 'TRACK_ID',
  TrackName = 'TRACK_NAME'
}

/** Relación entre cursos y rutas de aprendizaje. Cada fila asocia un curso a una ruta (track). */
export type DataCourseTrackNode = {
  __typename?: 'DataCourseTrackNode';
  /** Identificador referencial (clave de entidad); no es una métrica. */
  course_id?: Maybe<Scalars['Int']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  track_id?: Maybe<Scalars['Int']['output']>;
  track_name?: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type DataCourseTrackNodeEdge = {
  __typename?: 'DataCourseTrackNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataCourseTrackNode;
};

export type DataCourseTrackResult = DataCourseTrackConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataDateBetween = {
  /** Límite superior inclusivo (fecha ISO-8601). */
  end?: InputMaybe<Scalars['String']['input']>;
  /** Límite inferior inclusivo (fecha ISO-8601). */
  start?: InputMaybe<Scalars['String']['input']>;
};

export type DataEmployeeRecognitionConnection = {
  __typename?: 'DataEmployeeRecognitionConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataEmployeeRecognitionNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataEmployeeRecognitionDistinctByEnum {
  SenderUserId = 'SENDER_USER_ID',
  UserId = 'USER_ID'
}

export type DataEmployeeRecognitionFilterInput = {
  /** Filtra por employee_division_name (igualdad). */
  employee_division_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por recognition_category (igualdad). */
  recognition_category?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por recognition_category (pertenece al conjunto). */
  recognition_category_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por recognition_description (contiene texto, case-insensitive). */
  recognition_description_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por recognition_feedback (contiene texto, case-insensitive). */
  recognition_feedback_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por recognition_id (pertenece al conjunto). */
  recognition_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por recognition_level_name (igualdad). */
  recognition_level_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por recognition_level_name (pertenece al conjunto). */
  recognition_level_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por recognition_level_points >. */
  recognition_level_points_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por recognition_level_points >=. */
  recognition_level_points_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por recognition_level_points <. */
  recognition_level_points_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por recognition_level_points <=. */
  recognition_level_points_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por recognition_name (igualdad). */
  recognition_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por recognition_name (contiene texto, case-insensitive). */
  recognition_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por recognition_name (pertenece al conjunto). */
  recognition_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por recognition_public_medal (igualdad). */
  recognition_public_medal?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por recognition_sent_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  recognition_sent_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por recognition_sent_date >= (fecha ISO-8601). */
  recognition_sent_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por recognition_sent_date <= (fecha ISO-8601). */
  recognition_sent_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por sender_user_id (igualdad). */
  sender_user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por sender_user_id (pertenece al conjunto). */
  sender_user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum DataEmployeeRecognitionGroupByEnum {
  EmployeeDivisionName = 'EMPLOYEE_DIVISION_NAME',
  RecognitionCategory = 'RECOGNITION_CATEGORY',
  RecognitionLevelName = 'RECOGNITION_LEVEL_NAME',
  RecognitionName = 'RECOGNITION_NAME',
  RecognitionPublicMedal = 'RECOGNITION_PUBLIC_MEDAL'
}

/** Reconocimientos y medallas entre colaboradores: categoría, nivel, puntos y feedback. Cada fila es un reconocimiento recibido por un usuario. Formatos de campos: `recognition_level_points` → puntos; `recognition_public_medal` → bandera 'true'/'false'. */
export type DataEmployeeRecognitionNode = {
  __typename?: 'DataEmployeeRecognitionNode';
  employee_division_name?: Maybe<Scalars['String']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  recognition_category?: Maybe<Scalars['String']['output']>;
  recognition_description?: Maybe<Scalars['String']['output']>;
  recognition_feedback?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  recognition_id?: Maybe<Scalars['Int']['output']>;
  recognition_level_name?: Maybe<Scalars['String']['output']>;
  /** Cantidad de puntos. */
  recognition_level_points?: Maybe<Scalars['Int']['output']>;
  recognition_name?: Maybe<Scalars['String']['output']>;
  /** Bandera booleana representada como texto ('true'/'false'). */
  recognition_public_medal?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  recognition_sent_date?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  sender_user_id?: Maybe<Scalars['Int']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type DataEmployeeRecognitionNodeEdge = {
  __typename?: 'DataEmployeeRecognitionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataEmployeeRecognitionNode;
};

export type DataEmployeeRecognitionResult = DataEmployeeRecognitionConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataFieldsSent = {
  __typename?: 'DataFieldsSent';
  data_sent: Scalars['JSON']['output'];
};

export type DataGroupCount = {
  __typename?: 'DataGroupCount';
  /** Cantidad de filas (tras el filtro) en este grupo. */
  count: Scalars['Int']['output'];
  /** Valor distinto de la dimensión agrupada, serializado como texto (null agrupa las filas con la columna en NULL). */
  value?: Maybe<Scalars['String']['output']>;
};

export type DataGroupCountConnection = {
  __typename?: 'DataGroupCountConnection';
  /** Contiene los grupos de esta conexión. */
  edges: Array<DataGroupCountEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DataGroupCountEdge = {
  __typename?: 'DataGroupCountEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataGroupCount;
};

export type DataGroupCountResult = DataGroupCountConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataHrisDocumentConnection = {
  __typename?: 'DataHrisDocumentConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataHrisDocumentNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataHrisDocumentDistinctByEnum {
  UserId = 'USER_ID'
}

export type DataHrisDocumentFilterInput = {
  /** Filtra por created_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  created_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por created_date >= (fecha ISO-8601). */
  created_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por created_date <= (fecha ISO-8601). */
  created_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por deadline en el rango [start, end] inclusivo (fecha ISO-8601). */
  deadline_between?: InputMaybe<DataDateBetween>;
  /** Filtra por deadline >= (fecha ISO-8601). */
  deadline_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por deadline <= (fecha ISO-8601). */
  deadline_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por description (contiene texto, case-insensitive). */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por document_name (igualdad). */
  document_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por document_name (contiene texto, case-insensitive). */
  document_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por folder_name (igualdad). */
  folder_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por folder_name (pertenece al conjunto). */
  folder_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por status (igualdad). */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por status (pertenece al conjunto). */
  status_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por updated_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  updated_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por updated_date >= (fecha ISO-8601). */
  updated_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por updated_date <= (fecha ISO-8601). */
  updated_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum DataHrisDocumentGroupByEnum {
  FolderName = 'FOLDER_NAME',
  Status = 'STATUS'
}

/** Documentos HRIS de los usuarios: nombre, carpeta, estado y fechas. Cada fila es un documento asignado a un usuario. */
export type DataHrisDocumentNode = {
  __typename?: 'DataHrisDocumentNode';
  /** Fecha/hora en formato ISO-8601. */
  created_date?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  deadline?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  document_name?: Maybe<Scalars['String']['output']>;
  folder_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  updated_date?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type DataHrisDocumentNodeEdge = {
  __typename?: 'DataHrisDocumentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataHrisDocumentNode;
};

export type DataHrisDocumentResult = DataHrisDocumentConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataInactiveUserConnection = {
  __typename?: 'DataInactiveUserConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataInactiveUserNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type DataInactiveUserFilterInput = {
  /** Filtra por area_name (igualdad). */
  area_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por area_name (pertenece al conjunto). */
  area_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por birthday_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  birthday_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por birthday_date >= (fecha ISO-8601). */
  birthday_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por birthday_date <= (fecha ISO-8601). */
  birthday_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por city (pertenece al conjunto). */
  city_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por company_name (contiene texto, case-insensitive). */
  company_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por country_name (igualdad). */
  country_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por country_name (pertenece al conjunto). */
  country_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por email (contiene texto, case-insensitive). */
  email_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por gender (igualdad). */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por gender (pertenece al conjunto). */
  gender_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por incorporation_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  incorporation_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por incorporation_date >= (fecha ISO-8601). */
  incorporation_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por incorporation_date <= (fecha ISO-8601). */
  incorporation_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por leader_name (contiene texto, case-insensitive). */
  leader_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por level_name (igualdad). */
  level_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por level_name (pertenece al conjunto). */
  level_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por name (igualdad). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por name (contiene texto, case-insensitive). */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por role_name (igualdad). */
  role_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por role_name (pertenece al conjunto). */
  role_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por sede (igualdad). */
  sede?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por sede (pertenece al conjunto). */
  sede_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por start_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  start_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por start_date >= (fecha ISO-8601). */
  start_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por start_date <= (fecha ISO-8601). */
  start_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por team_name (igualdad). */
  team_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por team_name (pertenece al conjunto). */
  team_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum DataInactiveUserGroupByEnum {
  AreaName = 'AREA_NAME',
  City = 'CITY',
  CountryName = 'COUNTRY_NAME',
  Gender = 'GENDER',
  LeaderName = 'LEADER_NAME',
  LevelName = 'LEVEL_NAME',
  RoleName = 'ROLE_NAME',
  Sede = 'SEDE',
  TeamName = 'TEAM_NAME'
}

/** Colaboradores inactivos o dados de baja: histórico de identidad y datos laborales. Cada fila es un ex-colaborador. */
export type DataInactiveUserNode = {
  __typename?: 'DataInactiveUserNode';
  about_me?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  area_name?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  birthday_date?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  civil_status?: Maybe<Scalars['String']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  country_name?: Maybe<Scalars['String']['output']>;
  document_type?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emergency_contact_email?: Maybe<Scalars['String']['output']>;
  emergency_contact_email_2?: Maybe<Scalars['String']['output']>;
  emergency_contact_name?: Maybe<Scalars['String']['output']>;
  emergency_contact_name_2?: Maybe<Scalars['String']['output']>;
  emergency_contact_phone?: Maybe<Scalars['String']['output']>;
  emergency_contact_phone_2?: Maybe<Scalars['String']['output']>;
  emergency_contact_relationship?: Maybe<Scalars['String']['output']>;
  emergency_contact_relationship_2?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  incorporation_date?: Maybe<Scalars['String']['output']>;
  leader_name?: Maybe<Scalars['String']['output']>;
  level_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  phone_1?: Maybe<Scalars['String']['output']>;
  phone_2?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  role_name?: Maybe<Scalars['String']['output']>;
  sede?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  start_date?: Maybe<Scalars['String']['output']>;
  team_name?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type DataInactiveUserNodeEdge = {
  __typename?: 'DataInactiveUserNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataInactiveUserNode;
};

export type DataInactiveUserResult = DataInactiveUserConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export enum DataJobVacancyCaseEnum {
  IsClosed = 'IS_CLOSED',
  IsPublished = 'IS_PUBLISHED'
}

export type DataJobVacancyConnection = {
  __typename?: 'DataJobVacancyConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataJobVacancyNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataJobVacancyDistinctByEnum {
  CandidateEmail = 'CANDIDATE_EMAIL',
  VacancyId = 'VACANCY_ID'
}

export type DataJobVacancyFilterInput = {
  /** Filtra por candidate_affinity_score >. */
  candidate_affinity_score_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por candidate_affinity_score >=. */
  candidate_affinity_score_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por candidate_affinity_score <. */
  candidate_affinity_score_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por candidate_affinity_score <=. */
  candidate_affinity_score_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por candidate_country (igualdad). */
  candidate_country?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por candidate_country (pertenece al conjunto). */
  candidate_country_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por candidate_email (contiene texto, case-insensitive). */
  candidate_email_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por candidate_first_name (contiene texto, case-insensitive). */
  candidate_first_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por candidate_gender (igualdad). */
  candidate_gender?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por candidate_gender (pertenece al conjunto). */
  candidate_gender_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por candidate_last_name (contiene texto, case-insensitive). */
  candidate_last_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por case (igualdad). */
  case?: InputMaybe<DataJobVacancyCaseEnum>;
  /** Filtra por case (pertenece al conjunto). */
  case_in?: InputMaybe<Array<DataJobVacancyCaseEnum>>;
  /** Filtra por closed_at en el rango [start, end] inclusivo (fecha ISO-8601). */
  closed_at_between?: InputMaybe<DataDateBetween>;
  /** Filtra por closed_at >= (fecha ISO-8601). */
  closed_at_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por closed_at <= (fecha ISO-8601). */
  closed_at_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por created_at en el rango [start, end] inclusivo (fecha ISO-8601). */
  created_at_between?: InputMaybe<DataDateBetween>;
  /** Filtra por created_at >= (fecha ISO-8601). */
  created_at_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por created_at <= (fecha ISO-8601). */
  created_at_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por days_to_closed_hiring >. */
  days_to_closed_hiring_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por days_to_closed_hiring >=. */
  days_to_closed_hiring_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por days_to_closed_hiring <. */
  days_to_closed_hiring_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por days_to_closed_hiring <=. */
  days_to_closed_hiring_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por hiring_number >. */
  hiring_number_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por hiring_number >=. */
  hiring_number_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por hiring_number <. */
  hiring_number_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por hiring_number <=. */
  hiring_number_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por recluter_first_name (contiene texto, case-insensitive). */
  recluter_first_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por recluter_last_name (contiene texto, case-insensitive). */
  recluter_last_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por title (igualdad). */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por title (contiene texto, case-insensitive). */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por vacancy_id (igualdad). */
  vacancy_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por vacancy_id (pertenece al conjunto). */
  vacancy_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum DataJobVacancyGroupByEnum {
  CandidateCountry = 'CANDIDATE_COUNTRY',
  CandidateGender = 'CANDIDATE_GENDER',
  Case = 'CASE'
}

/** Vacantes y candidatos de reclutamiento: afinidad del candidato, reclutador y tiempos de cierre. Cada fila es un candidato en una vacante. Formatos de campos: `days_to_closed_hiring` → días; `candidate_affinity_score` → puntaje; `hiring_number` → cantidad. */
export type DataJobVacancyNode = {
  __typename?: 'DataJobVacancyNode';
  /** Puntaje de afinidad del candidato, de 0 a 100 (decimal). */
  candidate_affinity_score?: Maybe<Scalars['Float']['output']>;
  candidate_country?: Maybe<Scalars['String']['output']>;
  candidate_email?: Maybe<Scalars['String']['output']>;
  candidate_first_name?: Maybe<Scalars['String']['output']>;
  candidate_gender?: Maybe<Scalars['String']['output']>;
  candidate_last_name?: Maybe<Scalars['String']['output']>;
  candidate_phone?: Maybe<Scalars['String']['output']>;
  case?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  closed_at?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Cantidad en días (cierre menos creación de la vacante). */
  days_to_closed_hiring?: Maybe<Scalars['Int']['output']>;
  /** Cantidad (conteo entero de unidades). */
  hiring_number?: Maybe<Scalars['Int']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  recluter_candidate_email?: Maybe<Scalars['String']['output']>;
  recluter_first_name?: Maybe<Scalars['String']['output']>;
  recluter_last_name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  vacancy_id?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type DataJobVacancyNodeEdge = {
  __typename?: 'DataJobVacancyNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataJobVacancyNode;
};

export type DataJobVacancyResult = DataJobVacancyConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataModelEdge = {
  __typename?: 'DataModelEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<DataModelPayload>;
};

export type DataModelInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DataModelListPayload = {
  __typename?: 'DataModelListPayload';
  employees?: Maybe<Array<Maybe<DataModelPayload>>>;
};

export type DataModelPaginationPayload = {
  __typename?: 'DataModelPaginationPayload';
  edges?: Maybe<Array<Maybe<DataModelEdge>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type DataModelPayload = {
  __typename?: 'DataModelPayload';
  avatar_url?: Maybe<Scalars['String']['output']>;
  division_name?: Maybe<Scalars['String']['output']>;
  feedback_delivered?: Maybe<Scalars['Int']['output']>;
  feedback_received?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  job_level_name?: Maybe<Scalars['String']['output']>;
  job_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DataOrganizationAccountConnection = {
  __typename?: 'DataOrganizationAccountConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataOrganizationAccountNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type DataOrganizationAccountFilterInput = {
  /** Filtra por account_id (pertenece al conjunto). */
  account_id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por assignment_type (igualdad). */
  assignment_type?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por available_licenses >. */
  available_licenses_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por available_licenses >=. */
  available_licenses_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por available_licenses <. */
  available_licenses_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por available_licenses <=. */
  available_licenses_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por end_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  end_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por end_date >= (fecha ISO-8601). */
  end_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por end_date <= (fecha ISO-8601). */
  end_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por has_contract (igualdad). */
  has_contract?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por has_full_suite (igualdad). */
  has_full_suite?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por has_gamification (igualdad). */
  has_gamification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por has_skillxp (igualdad). */
  has_skillxp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_active (igualdad). */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_active_manage (igualdad). */
  is_active_manage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_corporation (igualdad). */
  is_corporation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por learning_product (igualdad). */
  learning_product?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por org_name (igualdad). */
  org_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por org_name (contiene texto, case-insensitive). */
  org_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por org_parent_id (pertenece al conjunto). */
  org_parent_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por org_type_name (igualdad). */
  org_type_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por start_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  start_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por start_date >= (fecha ISO-8601). */
  start_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por start_date <= (fecha ISO-8601). */
  start_date_lte?: InputMaybe<Scalars['String']['input']>;
};

export enum DataOrganizationAccountGroupByEnum {
  AssignmentType = 'ASSIGNMENT_TYPE',
  HasContract = 'HAS_CONTRACT',
  HasFullSuite = 'HAS_FULL_SUITE',
  HasGamification = 'HAS_GAMIFICATION',
  HasSkillxp = 'HAS_SKILLXP',
  IsActive = 'IS_ACTIVE',
  IsActiveManage = 'IS_ACTIVE_MANAGE',
  IsCorporation = 'IS_CORPORATION',
  LearningProduct = 'LEARNING_PRODUCT',
  OrgTypeName = 'ORG_TYPE_NAME'
}

/** Cuentas de organización: tipo, licencias, contrato y features habilitadas. Cada fila es una organización. Formatos de campos: `available_licenses` → cantidad. */
export type DataOrganizationAccountNode = {
  __typename?: 'DataOrganizationAccountNode';
  /** Identificador referencial (clave de entidad); no es una métrica. */
  account_id?: Maybe<Scalars['String']['output']>;
  assignment_type?: Maybe<Scalars['String']['output']>;
  /** Cantidad (conteo entero de unidades). */
  available_licenses?: Maybe<Scalars['Int']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  end_date?: Maybe<Scalars['String']['output']>;
  has_contract?: Maybe<Scalars['Boolean']['output']>;
  has_full_suite?: Maybe<Scalars['Boolean']['output']>;
  has_gamification?: Maybe<Scalars['Boolean']['output']>;
  has_skillxp?: Maybe<Scalars['Boolean']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_active_manage?: Maybe<Scalars['Boolean']['output']>;
  is_corporation?: Maybe<Scalars['Boolean']['output']>;
  learning_product?: Maybe<Scalars['String']['output']>;
  org_name?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  org_parent_id?: Maybe<Scalars['Int']['output']>;
  org_type?: Maybe<Scalars['Int']['output']>;
  org_type_name?: Maybe<Scalars['String']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  start_date?: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type DataOrganizationAccountNodeEdge = {
  __typename?: 'DataOrganizationAccountNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataOrganizationAccountNode;
};

export type DataOrganizationAccountResult = DataOrganizationAccountConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataProgressHourConnection = {
  __typename?: 'DataProgressHourConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataProgressHourNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataProgressHourDistinctByEnum {
  CourseId = 'COURSE_ID',
  UserId = 'USER_ID'
}

export type DataProgressHourFilterInput = {
  /** Filtra por course_duration >. */
  course_duration_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por course_duration >=. */
  course_duration_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por course_duration <. */
  course_duration_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por course_duration <=. */
  course_duration_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por course_id (igualdad). */
  course_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_id (pertenece al conjunto). */
  course_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por course_lectures >. */
  course_lectures_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_lectures >=. */
  course_lectures_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_lectures <. */
  course_lectures_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_lectures <=. */
  course_lectures_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por event_hour en el rango [start, end] inclusivo (fecha ISO-8601). */
  event_hour_between?: InputMaybe<DataDateBetween>;
  /** Filtra por event_hour >= (fecha ISO-8601). */
  event_hour_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por event_hour <= (fecha ISO-8601). */
  event_hour_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por played_lectures >. */
  played_lectures_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por played_lectures >=. */
  played_lectures_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por played_lectures <. */
  played_lectures_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por played_lectures <=. */
  played_lectures_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por played_seconds >. */
  played_seconds_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por played_seconds >=. */
  played_seconds_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por played_seconds <. */
  played_seconds_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por played_seconds <=. */
  played_seconds_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_hours >. */
  progress_hours_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_hours >=. */
  progress_hours_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_hours <. */
  progress_hours_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_hours <=. */
  progress_hours_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_seconds >. */
  progress_seconds_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_seconds >=. */
  progress_seconds_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_seconds <. */
  progress_seconds_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por progress_seconds <=. */
  progress_seconds_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Consumo de contenido por usuario y curso en intervalos de tiempo: segundos reproducidos, clases y progreso. Cada fila es un intervalo de estudio. Formatos de campos: `played_seconds`, `progress_seconds` → segundos; `course_duration` → minutos; `progress_hours` → porcentaje entero (0–100); `course_lectures`, `played_lectures` → cantidad. */
export type DataProgressHourNode = {
  __typename?: 'DataProgressHourNode';
  /** Duración del curso en minutos. */
  course_duration?: Maybe<Scalars['Float']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  course_id?: Maybe<Scalars['Int']['output']>;
  /** Cantidad (conteo entero de unidades). */
  course_lectures?: Maybe<Scalars['Int']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  event_hour?: Maybe<Scalars['String']['output']>;
  /** Cantidad (conteo entero de unidades). */
  played_lectures?: Maybe<Scalars['Int']['output']>;
  /** Cantidad en segundos. */
  played_seconds?: Maybe<Scalars['Float']['output']>;
  /** Porcentaje de progreso del curso (0–100), pese al nombre. */
  progress_hours?: Maybe<Scalars['Float']['output']>;
  /** Segundos de avance en el intervalo. */
  progress_seconds?: Maybe<Scalars['Float']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type DataProgressHourNodeEdge = {
  __typename?: 'DataProgressHourNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataProgressHourNode;
};

export type DataProgressHourResult = DataProgressHourConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataProjectConnection = {
  __typename?: 'DataProjectConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataProjectNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataProjectCurrentActionEnum {
  Certified = 'CERTIFIED',
  Draft = 'DRAFT',
  Observed = 'OBSERVED',
  Pending = 'PENDING'
}

export enum DataProjectDistinctByEnum {
  CourseId = 'COURSE_ID',
  UserId = 'USER_ID'
}

export type DataProjectFilterInput = {
  /** Filtra por course_id (igualdad). */
  course_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por course_id (pertenece al conjunto). */
  course_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por created_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  created_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por created_date >= (fecha ISO-8601). */
  created_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por created_date <= (fecha ISO-8601). */
  created_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por current_action (igualdad). */
  current_action?: InputMaybe<DataProjectCurrentActionEnum>;
  /** Filtra por current_action_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  current_action_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por current_action_date >= (fecha ISO-8601). */
  current_action_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por current_action_date <= (fecha ISO-8601). */
  current_action_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por current_action >. */
  current_action_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por current_action >=. */
  current_action_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por current_action <. */
  current_action_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por current_action <=. */
  current_action_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por deactivated_at en el rango [start, end] inclusivo (fecha ISO-8601). */
  deactivated_at_between?: InputMaybe<DataDateBetween>;
  /** Filtra por deactivated_at >= (fecha ISO-8601). */
  deactivated_at_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por deactivated_at <= (fecha ISO-8601). */
  deactivated_at_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por flow_start_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  flow_start_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por flow_start_date >= (fecha ISO-8601). */
  flow_start_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por flow_start_date <= (fecha ISO-8601). */
  flow_start_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por is_active (igualdad). */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_certified (igualdad). */
  is_certified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_draft (igualdad). */
  is_draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_evaluated (igualdad). */
  is_evaluated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_featured_community (igualdad). */
  is_featured_community?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_featured_crehana (igualdad). */
  is_featured_crehana?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_featured_teacher (igualdad). */
  is_featured_teacher?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_new (igualdad). */
  is_new?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_resolved (igualdad). */
  is_resolved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por is_selected (igualdad). */
  is_selected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por language_code (igualdad). */
  language_code?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por publish_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  publish_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por publish_date >= (fecha ISO-8601). */
  publish_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por publish_date <= (fecha ISO-8601). */
  publish_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por resolved_at en el rango [start, end] inclusivo (fecha ISO-8601). */
  resolved_at_between?: InputMaybe<DataDateBetween>;
  /** Filtra por resolved_at >= (fecha ISO-8601). */
  resolved_at_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por resolved_at <= (fecha ISO-8601). */
  resolved_at_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por resolved_by_id (pertenece al conjunto). */
  resolved_by_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por state (igualdad). */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por title (igualdad). */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por title (contiene texto, case-insensitive). */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por updated_at en el rango [start, end] inclusivo (fecha ISO-8601). */
  updated_at_between?: InputMaybe<DataDateBetween>;
  /** Filtra por updated_at >= (fecha ISO-8601). */
  updated_at_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por updated_at <= (fecha ISO-8601). */
  updated_at_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por views >. */
  views_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por views >=. */
  views_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por views <. */
  views_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por views <=. */
  views_lte?: InputMaybe<Scalars['Int']['input']>;
};

export enum DataProjectGroupByEnum {
  CurrentAction = 'CURRENT_ACTION',
  IsActive = 'IS_ACTIVE',
  IsCertified = 'IS_CERTIFIED',
  IsDraft = 'IS_DRAFT',
  IsEvaluated = 'IS_EVALUATED',
  IsFeaturedCommunity = 'IS_FEATURED_COMMUNITY',
  IsFeaturedCrehana = 'IS_FEATURED_CREHANA',
  IsFeaturedTeacher = 'IS_FEATURED_TEACHER',
  IsNew = 'IS_NEW',
  IsResolved = 'IS_RESOLVED',
  IsSelected = 'IS_SELECTED',
  LanguageCode = 'LANGUAGE_CODE',
  State = 'STATE'
}

/** Proyectos entregados por los usuarios en cursos: estado, fechas del flujo, vistas y certificación. Cada fila es un proyecto de un usuario. Formatos de campos: `likes`, `views` → cantidad; `current_action` → código. */
export type DataProjectNode = {
  __typename?: 'DataProjectNode';
  /** Identificador referencial (clave de entidad); no es una métrica. */
  course_id?: Maybe<Scalars['Int']['output']>;
  course_name?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  created_date?: Maybe<Scalars['String']['output']>;
  /** Código entero. Valores: 1=DRAFT, 2=PENDING, 3=OBSERVED, 4=CERTIFIED. */
  current_action?: Maybe<Scalars['Int']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  current_action_date?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  deactivated_at?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  flow_start_date?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_certified?: Maybe<Scalars['Boolean']['output']>;
  is_draft?: Maybe<Scalars['Boolean']['output']>;
  is_evaluated?: Maybe<Scalars['Boolean']['output']>;
  is_featured_community?: Maybe<Scalars['Boolean']['output']>;
  is_featured_crehana?: Maybe<Scalars['Boolean']['output']>;
  is_featured_teacher?: Maybe<Scalars['Boolean']['output']>;
  is_new?: Maybe<Scalars['Boolean']['output']>;
  is_resolved?: Maybe<Scalars['Boolean']['output']>;
  is_selected?: Maybe<Scalars['Boolean']['output']>;
  language_code?: Maybe<Scalars['String']['output']>;
  /** Cantidad (conteo entero de unidades). */
  likes?: Maybe<Scalars['Int']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  participation_certificate_status?: Maybe<Scalars['String']['output']>;
  privacy?: Maybe<Scalars['Int']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  publish_date?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  resolved_at?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  resolved_by_id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  user_id?: Maybe<Scalars['Int']['output']>;
  /** Cantidad (conteo entero de unidades). */
  views?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type DataProjectNodeEdge = {
  __typename?: 'DataProjectNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataProjectNode;
};

export type DataProjectResult = DataProjectConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataSheetInput = {
  dip_id: Scalars['Int']['input'];
  employee_id: Scalars['Int']['input'];
};

export type DataTaShiftAssignmentConnection = {
  __typename?: 'DataTaShiftAssignmentConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataTaShiftAssignmentNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataTaShiftAssignmentDistinctByEnum {
  ShiftId = 'SHIFT_ID',
  UserId = 'USER_ID'
}

export type DataTaShiftAssignmentFilterInput = {
  /** Filtra por end_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  end_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por end_date >= (fecha ISO-8601). */
  end_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por end_date <= (fecha ISO-8601). */
  end_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por is_active (igualdad). */
  is_active?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por shift_assignment_id (igualdad). */
  shift_assignment_id?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_assignment_id (pertenece al conjunto). */
  shift_assignment_id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por shift_id (igualdad). */
  shift_id?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_id (pertenece al conjunto). */
  shift_id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por shift_name (contiene texto, case-insensitive). */
  shift_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_type (igualdad). */
  shift_type?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_type (pertenece al conjunto). */
  shift_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por start_cycle_id (pertenece al conjunto). */
  start_cycle_id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por start_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  start_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por start_date >= (fecha ISO-8601). */
  start_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por start_date <= (fecha ISO-8601). */
  start_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_area (igualdad). */
  user_area?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_area (pertenece al conjunto). */
  user_area_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por user_headquarter (igualdad). */
  user_headquarter?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_headquarter (pertenece al conjunto). */
  user_headquarter_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por user_name (contiene texto, case-insensitive). */
  user_name_contains?: InputMaybe<Scalars['String']['input']>;
};

export enum DataTaShiftAssignmentGroupByEnum {
  IsActive = 'IS_ACTIVE',
  ShiftType = 'SHIFT_TYPE',
  UserArea = 'USER_AREA',
  UserHeadquarter = 'USER_HEADQUARTER'
}

/** Asignaciones de turno a usuarios (Tiempo & Asistencia): turno, vigencia y datos del colaborador. Cada fila es la asignación de un turno a un usuario. Formatos de campos: `is_active` → bandera 'true'/'false'. */
export type DataTaShiftAssignmentNode = {
  __typename?: 'DataTaShiftAssignmentNode';
  assigned_by_name?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  end_date?: Maybe<Scalars['String']['output']>;
  /** Bandera booleana representada como texto ('true'/'false'). */
  is_active?: Maybe<Scalars['String']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  shift_assignment_id?: Maybe<Scalars['String']['output']>;
  shift_descripcion?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  shift_id?: Maybe<Scalars['String']['output']>;
  shift_name?: Maybe<Scalars['String']['output']>;
  shift_type?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  start_cycle_id?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  start_date?: Maybe<Scalars['String']['output']>;
  user_area?: Maybe<Scalars['String']['output']>;
  user_headquarter?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  user_id?: Maybe<Scalars['Int']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type DataTaShiftAssignmentNodeEdge = {
  __typename?: 'DataTaShiftAssignmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataTaShiftAssignmentNode;
};

export type DataTaShiftAssignmentResult = DataTaShiftAssignmentConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataTaShiftNonRotatingConnection = {
  __typename?: 'DataTaShiftNonRotatingConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataTaShiftNonRotatingNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataTaShiftNonRotatingDistinctByEnum {
  ShiftId = 'SHIFT_ID'
}

export type DataTaShiftNonRotatingFilterInput = {
  /** Filtra por break_slot_duration_minutes >. */
  break_slot_duration_minutes_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por break_slot_duration_minutes >=. */
  break_slot_duration_minutes_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por break_slot_duration_minutes <. */
  break_slot_duration_minutes_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por break_slot_duration_minutes <=. */
  break_slot_duration_minutes_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por day_break_duration_minutes >. */
  day_break_duration_minutes_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por day_break_duration_minutes >=. */
  day_break_duration_minutes_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por day_break_duration_minutes <. */
  day_break_duration_minutes_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por day_break_duration_minutes <=. */
  day_break_duration_minutes_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por day_is_working_day (igualdad). */
  day_is_working_day?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por day_of_week (igualdad). */
  day_of_week?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por day_of_week (pertenece al conjunto). */
  day_of_week_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por day_worked_minutes >. */
  day_worked_minutes_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por day_worked_minutes >=. */
  day_worked_minutes_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por day_worked_minutes <. */
  day_worked_minutes_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por day_worked_minutes <=. */
  day_worked_minutes_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por shift_deactivated_at en el rango [start, end] inclusivo (fecha ISO-8601). */
  shift_deactivated_at_between?: InputMaybe<DataDateBetween>;
  /** Filtra por shift_deactivated_at >= (fecha ISO-8601). */
  shift_deactivated_at_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_deactivated_at <= (fecha ISO-8601). */
  shift_deactivated_at_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_id (igualdad). */
  shift_id?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_id (pertenece al conjunto). */
  shift_id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por shift_is_active (igualdad). */
  shift_is_active?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_name (igualdad). */
  shift_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_name (contiene texto, case-insensitive). */
  shift_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_parent_id (pertenece al conjunto). */
  shift_parent_id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por shift_type (igualdad). */
  shift_type?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_type (pertenece al conjunto). */
  shift_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por tolerance_after_minutes >. */
  tolerance_after_minutes_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por tolerance_after_minutes >=. */
  tolerance_after_minutes_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por tolerance_after_minutes <. */
  tolerance_after_minutes_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por tolerance_after_minutes <=. */
  tolerance_after_minutes_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por tolerance_before_minutes >. */
  tolerance_before_minutes_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por tolerance_before_minutes >=. */
  tolerance_before_minutes_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por tolerance_before_minutes <. */
  tolerance_before_minutes_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por tolerance_before_minutes <=. */
  tolerance_before_minutes_lte?: InputMaybe<Scalars['Int']['input']>;
};

export enum DataTaShiftNonRotatingGroupByEnum {
  DayOfWeek = 'DAY_OF_WEEK',
  ShiftIsActive = 'SHIFT_IS_ACTIVE',
  ShiftType = 'SHIFT_TYPE'
}

/** Definición de turnos fijos (no rotativos): horario semanal por día y descansos. Cada fila es un día de la semana de un turno. Formatos de campos: `tolerance_before_minutes`, `tolerance_after_minutes`, `day_worked_minutes`, `day_break_duration_minutes`, `break_slot_duration_minutes` → minutos; `break_slot_position` → posición/orden; `shift_is_active`, `day_is_working_day` → bandera 'true'/'false'. */
export type DataTaShiftNonRotatingNode = {
  __typename?: 'DataTaShiftNonRotatingNode';
  /** Cantidad en minutos. */
  break_slot_duration_minutes?: Maybe<Scalars['Int']['output']>;
  break_slot_end_time?: Maybe<Scalars['String']['output']>;
  break_slot_label?: Maybe<Scalars['String']['output']>;
  /** Posición/orden (entero). */
  break_slot_position?: Maybe<Scalars['Int']['output']>;
  break_slot_start_time?: Maybe<Scalars['String']['output']>;
  /** Cantidad en minutos. */
  day_break_duration_minutes?: Maybe<Scalars['Int']['output']>;
  day_entry_time?: Maybe<Scalars['String']['output']>;
  day_exit_time?: Maybe<Scalars['String']['output']>;
  /** Bandera booleana representada como texto ('true'/'false'). */
  day_is_working_day?: Maybe<Scalars['String']['output']>;
  day_of_week?: Maybe<Scalars['String']['output']>;
  /** Cantidad en minutos. */
  day_worked_minutes?: Maybe<Scalars['Int']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  shift_deactivated_at?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  shift_id?: Maybe<Scalars['String']['output']>;
  /** Bandera booleana representada como texto ('true'/'false'). */
  shift_is_active?: Maybe<Scalars['String']['output']>;
  shift_name?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  shift_parent_id?: Maybe<Scalars['String']['output']>;
  shift_type?: Maybe<Scalars['String']['output']>;
  tolerance_after_applicable_events?: Maybe<Scalars['String']['output']>;
  /** Cantidad en minutos. */
  tolerance_after_minutes?: Maybe<Scalars['Int']['output']>;
  tolerance_before_applicable_events?: Maybe<Scalars['String']['output']>;
  /** Cantidad en minutos. */
  tolerance_before_minutes?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type DataTaShiftNonRotatingNodeEdge = {
  __typename?: 'DataTaShiftNonRotatingNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataTaShiftNonRotatingNode;
};

export type DataTaShiftNonRotatingResult = DataTaShiftNonRotatingConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataTaShiftRotatingConnection = {
  __typename?: 'DataTaShiftRotatingConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataTaShiftRotatingNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataTaShiftRotatingDistinctByEnum {
  ShiftId = 'SHIFT_ID'
}

export type DataTaShiftRotatingFilterInput = {
  /** Filtra por break_slot_duration_minutes >. */
  break_slot_duration_minutes_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por break_slot_duration_minutes >=. */
  break_slot_duration_minutes_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por break_slot_duration_minutes <. */
  break_slot_duration_minutes_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por break_slot_duration_minutes <=. */
  break_slot_duration_minutes_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por cycle_break_duration_minutes >. */
  cycle_break_duration_minutes_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por cycle_break_duration_minutes >=. */
  cycle_break_duration_minutes_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por cycle_break_duration_minutes <. */
  cycle_break_duration_minutes_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por cycle_break_duration_minutes <=. */
  cycle_break_duration_minutes_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por cycle_duration_days >. */
  cycle_duration_days_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por cycle_duration_days >=. */
  cycle_duration_days_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por cycle_duration_days <. */
  cycle_duration_days_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por cycle_duration_days <=. */
  cycle_duration_days_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por cycle_type (igualdad). */
  cycle_type?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por cycle_type (pertenece al conjunto). */
  cycle_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por cycle_worked_minutes_per_day >. */
  cycle_worked_minutes_per_day_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por cycle_worked_minutes_per_day >=. */
  cycle_worked_minutes_per_day_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por cycle_worked_minutes_per_day <. */
  cycle_worked_minutes_per_day_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por cycle_worked_minutes_per_day <=. */
  cycle_worked_minutes_per_day_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por shift_deactivated_at en el rango [start, end] inclusivo (fecha ISO-8601). */
  shift_deactivated_at_between?: InputMaybe<DataDateBetween>;
  /** Filtra por shift_deactivated_at >= (fecha ISO-8601). */
  shift_deactivated_at_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_deactivated_at <= (fecha ISO-8601). */
  shift_deactivated_at_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_id (igualdad). */
  shift_id?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_id (pertenece al conjunto). */
  shift_id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por shift_is_active (igualdad). */
  shift_is_active?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_name (igualdad). */
  shift_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_name (contiene texto, case-insensitive). */
  shift_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_parent_id (pertenece al conjunto). */
  shift_parent_id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por shift_type (igualdad). */
  shift_type?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por shift_type (pertenece al conjunto). */
  shift_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por tolerance_after_minutes >. */
  tolerance_after_minutes_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por tolerance_after_minutes >=. */
  tolerance_after_minutes_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por tolerance_after_minutes <. */
  tolerance_after_minutes_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por tolerance_after_minutes <=. */
  tolerance_after_minutes_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por tolerance_before_minutes >. */
  tolerance_before_minutes_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por tolerance_before_minutes >=. */
  tolerance_before_minutes_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por tolerance_before_minutes <. */
  tolerance_before_minutes_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por tolerance_before_minutes <=. */
  tolerance_before_minutes_lte?: InputMaybe<Scalars['Int']['input']>;
};

export enum DataTaShiftRotatingGroupByEnum {
  CycleType = 'CYCLE_TYPE',
  ShiftIsActive = 'SHIFT_IS_ACTIVE',
  ShiftType = 'SHIFT_TYPE'
}

/** Definición de turnos rotativos: ciclos de trabajo/descanso y horarios. Cada fila es un ciclo de un turno rotativo. Formatos de campos: `tolerance_before_minutes`, `tolerance_after_minutes`, `cycle_worked_minutes_per_day`, `cycle_break_duration_minutes`, `break_slot_duration_minutes` → minutos; `cycle_duration_days` → días; `cycle_order`, `break_slot_position` → posición/orden; `shift_is_active` → bandera 'true'/'false'. */
export type DataTaShiftRotatingNode = {
  __typename?: 'DataTaShiftRotatingNode';
  /** Cantidad en minutos. */
  break_slot_duration_minutes?: Maybe<Scalars['Int']['output']>;
  break_slot_end_time?: Maybe<Scalars['String']['output']>;
  break_slot_label?: Maybe<Scalars['String']['output']>;
  /** Posición/orden (entero). */
  break_slot_position?: Maybe<Scalars['Int']['output']>;
  break_slot_start_time?: Maybe<Scalars['String']['output']>;
  /** Cantidad en minutos. */
  cycle_break_duration_minutes?: Maybe<Scalars['Int']['output']>;
  /** Cantidad en días. */
  cycle_duration_days?: Maybe<Scalars['Int']['output']>;
  cycle_entry_time?: Maybe<Scalars['String']['output']>;
  cycle_exit_time?: Maybe<Scalars['String']['output']>;
  /** Posición/orden (entero). */
  cycle_order?: Maybe<Scalars['Int']['output']>;
  cycle_type?: Maybe<Scalars['String']['output']>;
  /** Cantidad en minutos. */
  cycle_worked_minutes_per_day?: Maybe<Scalars['Int']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  shift_deactivated_at?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  shift_id?: Maybe<Scalars['String']['output']>;
  /** Bandera booleana representada como texto ('true'/'false'). */
  shift_is_active?: Maybe<Scalars['String']['output']>;
  shift_name?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  shift_parent_id?: Maybe<Scalars['String']['output']>;
  shift_type?: Maybe<Scalars['String']['output']>;
  tolerance_after_applicable_events?: Maybe<Scalars['String']['output']>;
  /** Cantidad en minutos. */
  tolerance_after_minutes?: Maybe<Scalars['Int']['output']>;
  tolerance_before_applicable_events?: Maybe<Scalars['String']['output']>;
  /** Cantidad en minutos. */
  tolerance_before_minutes?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type DataTaShiftRotatingNodeEdge = {
  __typename?: 'DataTaShiftRotatingNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataTaShiftRotatingNode;
};

export type DataTaShiftRotatingResult = DataTaShiftRotatingConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataTalentClimateConnection = {
  __typename?: 'DataTalentClimateConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataTalentClimateNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type DataTalentClimateFilterInput = {
  /** Filtra por answers_count >. */
  answers_count_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por answers_count >=. */
  answers_count_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por answers_count <. */
  answers_count_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por answers_count <=. */
  answers_count_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por avg_score >. */
  avg_score_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por avg_score >=. */
  avg_score_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por avg_score <. */
  avg_score_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por avg_score <=. */
  avg_score_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por dimension_name (igualdad). */
  dimension_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por dimension_name (pertenece al conjunto). */
  dimension_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por division_name (igualdad). */
  division_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por division_name (pertenece al conjunto). */
  division_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por employee_count >. */
  employee_count_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por employee_count >=. */
  employee_count_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por employee_count <. */
  employee_count_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por employee_count <=. */
  employee_count_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por end_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  end_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por end_date >= (fecha ISO-8601). */
  end_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por end_date <= (fecha ISO-8601). */
  end_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por is_last_evaluation (igualdad). */
  is_last_evaluation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por nps_label (igualdad). */
  nps_label?: InputMaybe<DataTalentClimateNpsLabelEnum>;
  /** Filtra por nps_label (pertenece al conjunto). */
  nps_label_in?: InputMaybe<Array<DataTalentClimateNpsLabelEnum>>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por process_id (pertenece al conjunto). */
  process_id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por process_name (igualdad). */
  process_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por process_name (contiene texto, case-insensitive). */
  process_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por start_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  start_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por start_date >= (fecha ISO-8601). */
  start_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por start_date <= (fecha ISO-8601). */
  start_date_lte?: InputMaybe<Scalars['String']['input']>;
};

export enum DataTalentClimateGroupByEnum {
  DimensionName = 'DIMENSION_NAME',
  DivisionName = 'DIVISION_NAME',
  NpsLabel = 'NPS_LABEL',
  ProcessName = 'PROCESS_NAME'
}

/** Resultados de encuestas de clima laboral por proceso y dimensión, con etiqueta NPS. Cada fila es una dimensión/división de un proceso de clima. Formatos de campos: `avg_score` → puntaje; `employee_count`, `answers_count` → cantidad. */
export type DataTalentClimateNode = {
  __typename?: 'DataTalentClimateNode';
  /** Cantidad (conteo entero de unidades). */
  answers_count?: Maybe<Scalars['Int']['output']>;
  /** Puntaje (valor numérico). */
  avg_score?: Maybe<Scalars['Int']['output']>;
  dimension_name?: Maybe<Scalars['String']['output']>;
  division_name?: Maybe<Scalars['String']['output']>;
  /** Cantidad (conteo entero de unidades). */
  employee_count?: Maybe<Scalars['Int']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  end_date?: Maybe<Scalars['String']['output']>;
  is_last_evaluation?: Maybe<Scalars['Boolean']['output']>;
  nps_label?: Maybe<Scalars['String']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  process_id?: Maybe<Scalars['String']['output']>;
  process_name?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  start_date?: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type DataTalentClimateNodeEdge = {
  __typename?: 'DataTalentClimateNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataTalentClimateNode;
};

export enum DataTalentClimateNpsLabelEnum {
  Detractor = 'DETRACTOR',
  Neutral = 'NEUTRAL',
  Promoter = 'PROMOTER'
}

export type DataTalentClimateResult = DataTalentClimateConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataTalentCompetenceEmployeeConnection = {
  __typename?: 'DataTalentCompetenceEmployeeConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataTalentCompetenceEmployeeNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataTalentCompetenceEmployeeDistinctByEnum {
  EvaluatedId = 'EVALUATED_ID',
  UserId = 'USER_ID'
}

export type DataTalentCompetenceEmployeeFilterInput = {
  /** Filtra por adj_result >. */
  adj_result_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por adj_result >=. */
  adj_result_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por adj_result <. */
  adj_result_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por adj_result <=. */
  adj_result_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por competence_name (igualdad). */
  competence_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por competence_name (contiene texto, case-insensitive). */
  competence_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por competence_name (pertenece al conjunto). */
  competence_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por end_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  end_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por end_date >= (fecha ISO-8601). */
  end_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por end_date <= (fecha ISO-8601). */
  end_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por evaluated_id (igualdad). */
  evaluated_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por evaluated_id (pertenece al conjunto). */
  evaluated_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por evaluation_type (igualdad). */
  evaluation_type?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por evaluation_type (pertenece al conjunto). */
  evaluation_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por is_last (igualdad). */
  is_last?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por level_state (igualdad). */
  level_state?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por process_id (pertenece al conjunto). */
  process_id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por process_name (igualdad). */
  process_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por process_name (contiene texto, case-insensitive). */
  process_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por relation (igualdad). */
  relation?: InputMaybe<DataTalentCompetenceEmployeeRelationEnum>;
  /** Filtra por relation (pertenece al conjunto). */
  relation_in?: InputMaybe<Array<DataTalentCompetenceEmployeeRelationEnum>>;
  /** Filtra por start_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  start_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por start_date >= (fecha ISO-8601). */
  start_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por start_date <= (fecha ISO-8601). */
  start_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por total_result >. */
  total_result_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_result >=. */
  total_result_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_result <. */
  total_result_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_result <=. */
  total_result_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_weight >. */
  total_weight_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_weight >=. */
  total_weight_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_weight <. */
  total_weight_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_weight <=. */
  total_weight_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum DataTalentCompetenceEmployeeGroupByEnum {
  CompetenceName = 'COMPETENCE_NAME',
  EvaluationType = 'EVALUATION_TYPE',
  LevelState = 'LEVEL_STATE',
  ProcessName = 'PROCESS_NAME',
  Relation = 'RELATION'
}

/** Resultados de evaluación de competencias por empleado: competencia, tipo de evaluación, resultado y relación del evaluador. Cada fila es una competencia evaluada a un usuario en un proceso POR UNA relación de evaluador (AUTO/BOSS/etc.): total_result es el puntaje de esa relación, NO el 'Resultado Total' ponderado de la competencia que muestra la plataforma (ese agregado ponderado nunca es esta columna). Formatos de campos: `total_weight` → porcentaje (0–100); `adj_result`, `total_result` → puntaje. */
export type DataTalentCompetenceEmployeeNode = {
  __typename?: 'DataTalentCompetenceEmployeeNode';
  /** Puntaje (valor numérico). */
  adj_result?: Maybe<Scalars['Float']['output']>;
  competence_name?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  end_date?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  evaluated_id?: Maybe<Scalars['Int']['output']>;
  evaluation_type?: Maybe<Scalars['String']['output']>;
  is_last?: Maybe<Scalars['Boolean']['output']>;
  level_state?: Maybe<Scalars['String']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  process_id?: Maybe<Scalars['String']['output']>;
  process_name?: Maybe<Scalars['String']['output']>;
  relation?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  start_date?: Maybe<Scalars['String']['output']>;
  /** Puntaje (valor numérico). */
  total_result?: Maybe<Scalars['Float']['output']>;
  /** Porcentaje de peso de la competencia sobre el proceso (0–100). */
  total_weight?: Maybe<Scalars['Float']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type DataTalentCompetenceEmployeeNodeEdge = {
  __typename?: 'DataTalentCompetenceEmployeeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataTalentCompetenceEmployeeNode;
};

export enum DataTalentCompetenceEmployeeRelationEnum {
  Auto = 'AUTO',
  Boss = 'BOSS',
  Coworker = 'COWORKER',
  Subordinate = 'SUBORDINATE'
}

export type DataTalentCompetenceEmployeeResult = DataTalentCompetenceEmployeeConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataTalentCompetenceProcessConnection = {
  __typename?: 'DataTalentCompetenceProcessConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataTalentCompetenceProcessNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataTalentCompetenceProcessDistinctByEnum {
  UserId = 'USER_ID'
}

export type DataTalentCompetenceProcessFilterInput = {
  /** Filtra por end_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  end_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por end_date >= (fecha ISO-8601). */
  end_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por end_date <= (fecha ISO-8601). */
  end_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por evaluation_type (igualdad). */
  evaluation_type?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por evaluation_type (pertenece al conjunto). */
  evaluation_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por is_last (igualdad). */
  is_last?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por process_id (pertenece al conjunto). */
  process_id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por process_name (igualdad). */
  process_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por process_name (contiene texto, case-insensitive). */
  process_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por start_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  start_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por start_date >= (fecha ISO-8601). */
  start_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por start_date <= (fecha ISO-8601). */
  start_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por weighted_result >. */
  weighted_result_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por weighted_result >=. */
  weighted_result_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por weighted_result <. */
  weighted_result_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por weighted_result <=. */
  weighted_result_lte?: InputMaybe<Scalars['Float']['input']>;
};

export enum DataTalentCompetenceProcessGroupByEnum {
  EvaluationType = 'EVALUATION_TYPE',
  ProcessName = 'PROCESS_NAME'
}

/** Resultado ponderado de la evaluación de competencias por proceso. Cada fila es el resultado global de un usuario en un proceso de competencias. Formatos de campos: `weighted_result` → puntaje. */
export type DataTalentCompetenceProcessNode = {
  __typename?: 'DataTalentCompetenceProcessNode';
  /** Fecha/hora en formato ISO-8601. */
  end_date?: Maybe<Scalars['String']['output']>;
  evaluation_type?: Maybe<Scalars['String']['output']>;
  is_last?: Maybe<Scalars['Boolean']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  process_id?: Maybe<Scalars['String']['output']>;
  process_name?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  start_date?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  user_id?: Maybe<Scalars['Int']['output']>;
  /** Puntaje (valor numérico). */
  weighted_result?: Maybe<Scalars['Float']['output']>;
};

/** An edge in a connection. */
export type DataTalentCompetenceProcessNodeEdge = {
  __typename?: 'DataTalentCompetenceProcessNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataTalentCompetenceProcessNode;
};

export type DataTalentCompetenceProcessResult = DataTalentCompetenceProcessConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataTalentDipConnection = {
  __typename?: 'DataTalentDipConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataTalentDipNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataTalentDipDistinctByEnum {
  UserId = 'USER_ID'
}

export type DataTalentDipFilterInput = {
  /** Filtra por activities_completed >. */
  activities_completed_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por activities_completed >=. */
  activities_completed_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por activities_completed <. */
  activities_completed_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por activities_completed <=. */
  activities_completed_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por activities_count >. */
  activities_count_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por activities_count >=. */
  activities_count_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por activities_count <. */
  activities_count_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por activities_count <=. */
  activities_count_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por avg_results >. */
  avg_results_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por avg_results >=. */
  avg_results_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por avg_results <. */
  avg_results_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por avg_results <=. */
  avg_results_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por dip_name (igualdad). */
  dip_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por dip_name (contiene texto, case-insensitive). */
  dip_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por division_name (igualdad). */
  division_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por division_name (pertenece al conjunto). */
  division_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por end_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  end_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por end_date >= (fecha ISO-8601). */
  end_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por end_date <= (fecha ISO-8601). */
  end_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por is_last_process (igualdad). */
  is_last_process?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por process_count >. */
  process_count_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por process_count >=. */
  process_count_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por process_count <. */
  process_count_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por process_count <=. */
  process_count_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por process_id (igualdad). */
  process_id?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por process_id (pertenece al conjunto). */
  process_id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por start_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  start_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por start_date >= (fecha ISO-8601). */
  start_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por start_date <= (fecha ISO-8601). */
  start_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum DataTalentDipGroupByEnum {
  DipName = 'DIP_NAME',
  DivisionName = 'DIVISION_NAME',
  ProcessId = 'PROCESS_ID'
}

/** Planes individuales de desarrollo (PID/DIP): avance y actividades por usuario. Cada fila es el plan de desarrollo de un usuario en un proceso. Formatos de campos: `avg_results` → puntaje; `process_count`, `activities_completed`, `activities_count` → cantidad. */
export type DataTalentDipNode = {
  __typename?: 'DataTalentDipNode';
  /** Cantidad (conteo entero de unidades). */
  activities_completed?: Maybe<Scalars['Int']['output']>;
  /** Cantidad (conteo entero de unidades). */
  activities_count?: Maybe<Scalars['Int']['output']>;
  /** Puntaje (valor numérico). */
  avg_results?: Maybe<Scalars['Float']['output']>;
  dip_name?: Maybe<Scalars['String']['output']>;
  division_name?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  end_date?: Maybe<Scalars['String']['output']>;
  is_last_process?: Maybe<Scalars['Boolean']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  /** Cantidad (conteo entero de unidades). */
  process_count?: Maybe<Scalars['Int']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  process_id?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  start_date?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type DataTalentDipNodeEdge = {
  __typename?: 'DataTalentDipNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataTalentDipNode;
};

export type DataTalentDipResult = DataTalentDipConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export enum DataTalentFeedbackCategoryEnum {
  Competences = 'COMPETENCES',
  Dip = 'DIP',
  Goals = 'GOALS',
  Others = 'OTHERS',
  Performance = 'PERFORMANCE',
  Pid = 'PID'
}

export type DataTalentFeedbackConnection = {
  __typename?: 'DataTalentFeedbackConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataTalentFeedbackNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataTalentFeedbackDistinctByEnum {
  ReceiverUserId = 'RECEIVER_USER_ID',
  SenderUserId = 'SENDER_USER_ID'
}

export enum DataTalentFeedbackFeedbackTypeEnum {
  FaceToFace = 'FACE_TO_FACE',
  Request = 'REQUEST',
  Writing = 'WRITING'
}

export type DataTalentFeedbackFilterInput = {
  /** Filtra por category (igualdad). */
  category?: InputMaybe<DataTalentFeedbackCategoryEnum>;
  /** Filtra por category (pertenece al conjunto). */
  category_in?: InputMaybe<Array<DataTalentFeedbackCategoryEnum>>;
  /** Filtra por closed_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  closed_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por closed_date >= (fecha ISO-8601). */
  closed_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por closed_date <= (fecha ISO-8601). */
  closed_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por created_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  created_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por created_date >= (fecha ISO-8601). */
  created_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por created_date <= (fecha ISO-8601). */
  created_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por feedback_id (pertenece al conjunto). */
  feedback_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por feedback_motive (pertenece al conjunto). */
  feedback_motive_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por feedback_type (igualdad). */
  feedback_type?: InputMaybe<DataTalentFeedbackFeedbackTypeEnum>;
  /** Filtra por feedback_type (pertenece al conjunto). */
  feedback_type_in?: InputMaybe<Array<DataTalentFeedbackFeedbackTypeEnum>>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por receiver_user_id (igualdad). */
  receiver_user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por receiver_user_id (pertenece al conjunto). */
  receiver_user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por schedule_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  schedule_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por schedule_date >= (fecha ISO-8601). */
  schedule_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por schedule_date <= (fecha ISO-8601). */
  schedule_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por sender_user_id (igualdad). */
  sender_user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por sender_user_id (pertenece al conjunto). */
  sender_user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por status (igualdad). */
  status?: InputMaybe<DataTalentFeedbackStatusEnum>;
  /** Filtra por status (pertenece al conjunto). */
  status_in?: InputMaybe<Array<DataTalentFeedbackStatusEnum>>;
  /** Filtra por template_type (igualdad). */
  template_type?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por was_requested (igualdad). */
  was_requested?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DataTalentFeedbackGroupByEnum {
  Category = 'CATEGORY',
  FeedbackMotive = 'FEEDBACK_MOTIVE',
  FeedbackType = 'FEEDBACK_TYPE',
  Status = 'STATUS',
  TemplateType = 'TEMPLATE_TYPE'
}

/** Feedback entre colaboradores: tipo, motivo, estado, categoría y fechas. Cada fila es un feedback dado o solicitado. */
export type DataTalentFeedbackNode = {
  __typename?: 'DataTalentFeedbackNode';
  category?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  closed_date?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  created_date?: Maybe<Scalars['String']['output']>;
  feedback_detail?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  feedback_id?: Maybe<Scalars['Int']['output']>;
  feedback_motive?: Maybe<Scalars['String']['output']>;
  feedback_type?: Maybe<Scalars['String']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  receiver_user_id?: Maybe<Scalars['Int']['output']>;
  reminder_dates?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  schedule_date?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  sender_user_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  template_type?: Maybe<Scalars['Boolean']['output']>;
  was_requested?: Maybe<Scalars['Boolean']['output']>;
};

/** An edge in a connection. */
export type DataTalentFeedbackNodeEdge = {
  __typename?: 'DataTalentFeedbackNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataTalentFeedbackNode;
};

export type DataTalentFeedbackResult = DataTalentFeedbackConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export enum DataTalentFeedbackStatusEnum {
  Created = 'CREATED',
  Finished = 'FINISHED',
  Rejected = 'REJECTED'
}

export type DataTalentGoalConnection = {
  __typename?: 'DataTalentGoalConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataTalentGoalNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataTalentGoalDistinctByEnum {
  UserId = 'USER_ID'
}

export type DataTalentGoalFilterInput = {
  /** Filtra por company_goal_name (igualdad). */
  company_goal_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por company_goal_name (pertenece al conjunto). */
  company_goal_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por division_name (igualdad). */
  division_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por employee_goal_name (contiene texto, case-insensitive). */
  employee_goal_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por end_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  end_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por end_date >= (fecha ISO-8601). */
  end_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por end_date <= (fecha ISO-8601). */
  end_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por goal_process_name (igualdad). */
  goal_process_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por goal_process_name (pertenece al conjunto). */
  goal_process_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por goal_result >. */
  goal_result_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por goal_result >=. */
  goal_result_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por goal_result <. */
  goal_result_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por goal_result <=. */
  goal_result_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por goal_state (igualdad). */
  goal_state?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por is_last (igualdad). */
  is_last?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por process_id (pertenece al conjunto). */
  process_id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por start_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  start_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por start_date >= (fecha ISO-8601). */
  start_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por start_date <= (fecha ISO-8601). */
  start_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum DataTalentGoalGroupByEnum {
  CompanyGoalName = 'COMPANY_GOAL_NAME',
  DivisionName = 'DIVISION_NAME',
  GoalProcessName = 'GOAL_PROCESS_NAME',
  GoalState = 'GOAL_STATE'
}

/** Objetivos/metas de empleados y de compañía: resultado, estado y periodo. Cada fila es una meta asignada a un usuario. Formatos de campos: `goal_result` → porcentaje (0–100). */
export type DataTalentGoalNode = {
  __typename?: 'DataTalentGoalNode';
  company_goal_name?: Maybe<Scalars['String']['output']>;
  division_name?: Maybe<Scalars['String']['output']>;
  employee_goal_name?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  end_date?: Maybe<Scalars['String']['output']>;
  goal_process_name?: Maybe<Scalars['String']['output']>;
  /** Resultado/cumplimiento del objetivo (porcentaje). */
  goal_result?: Maybe<Scalars['Float']['output']>;
  goal_state?: Maybe<Scalars['String']['output']>;
  is_last?: Maybe<Scalars['Boolean']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  process_id?: Maybe<Scalars['String']['output']>;
  process_label?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  start_date?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type DataTalentGoalNodeEdge = {
  __typename?: 'DataTalentGoalNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataTalentGoalNode;
};

export type DataTalentGoalResult = DataTalentGoalConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataTrackEnrollmentConnection = {
  __typename?: 'DataTrackEnrollmentConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataTrackEnrollmentNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataTrackEnrollmentDistinctByEnum {
  TrackId = 'TRACK_ID',
  UserId = 'USER_ID'
}

export type DataTrackEnrollmentFilterInput = {
  /** Filtra por courses_count >. */
  courses_count_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_count >=. */
  courses_count_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_count <. */
  courses_count_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por courses_count <=. */
  courses_count_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por total_played_seconds >. */
  total_played_seconds_gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_played_seconds >=. */
  total_played_seconds_gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_played_seconds <. */
  total_played_seconds_lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por total_played_seconds <=. */
  total_played_seconds_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filtra por track_courses_to_certificate >. */
  track_courses_to_certificate_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por track_courses_to_certificate >=. */
  track_courses_to_certificate_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por track_courses_to_certificate <. */
  track_courses_to_certificate_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por track_courses_to_certificate <=. */
  track_courses_to_certificate_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por track_courses_to_complete >. */
  track_courses_to_complete_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por track_courses_to_complete >=. */
  track_courses_to_complete_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por track_courses_to_complete <. */
  track_courses_to_complete_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por track_courses_to_complete <=. */
  track_courses_to_complete_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por track_end_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  track_end_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por track_end_date >= (fecha ISO-8601). */
  track_end_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por track_end_date <= (fecha ISO-8601). */
  track_end_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por track_id (igualdad). */
  track_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por track_id (pertenece al conjunto). */
  track_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por track_name (igualdad). */
  track_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por track_name (contiene texto, case-insensitive). */
  track_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por track_start_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  track_start_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por track_start_date >= (fecha ISO-8601). */
  track_start_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por track_start_date <= (fecha ISO-8601). */
  track_start_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por user_track_courses_completed >. */
  user_track_courses_completed_gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_track_courses_completed >=. */
  user_track_courses_completed_gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_track_courses_completed <. */
  user_track_courses_completed_lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_track_courses_completed <=. */
  user_track_courses_completed_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_track_date_was_completed en el rango [start, end] inclusivo (fecha ISO-8601). */
  user_track_date_was_completed_between?: InputMaybe<DataDateBetween>;
  /** Filtra por user_track_date_was_completed >= (fecha ISO-8601). */
  user_track_date_was_completed_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_track_date_was_completed <= (fecha ISO-8601). */
  user_track_date_was_completed_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_track_is_certified (igualdad). */
  user_track_is_certified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por user_track_is_completed (igualdad). */
  user_track_is_completed?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DataTrackEnrollmentGroupByEnum {
  UserTrackIsCertified = 'USER_TRACK_IS_CERTIFIED',
  UserTrackIsCompleted = 'USER_TRACK_IS_COMPLETED'
}

/** Inscripciones a rutas de aprendizaje (tracks): cursos requeridos y completados, fechas y certificación. Cada fila es la inscripción de un usuario a una ruta. Formatos de campos: `total_played_seconds` → segundos; `track_courses_to_complete`, `track_courses_to_certificate`, `user_track_courses_completed`, `courses_count` → cantidad. */
export type DataTrackEnrollmentNode = {
  __typename?: 'DataTrackEnrollmentNode';
  /** Cantidad (conteo entero de unidades). */
  courses_count?: Maybe<Scalars['Int']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  /** Cantidad en segundos. */
  total_played_seconds?: Maybe<Scalars['Float']['output']>;
  /** Cantidad (conteo entero de unidades). */
  track_courses_to_certificate?: Maybe<Scalars['Int']['output']>;
  /** Cantidad (conteo entero de unidades). */
  track_courses_to_complete?: Maybe<Scalars['Int']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  track_end_date?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  track_id?: Maybe<Scalars['Int']['output']>;
  track_name?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  track_start_date?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  user_id?: Maybe<Scalars['Int']['output']>;
  /** Cantidad (conteo entero de unidades). */
  user_track_courses_completed?: Maybe<Scalars['Int']['output']>;
  user_track_date_was_completed?: Maybe<Scalars['String']['output']>;
  user_track_is_certified?: Maybe<Scalars['Boolean']['output']>;
  user_track_is_completed?: Maybe<Scalars['Boolean']['output']>;
};

/** An edge in a connection. */
export type DataTrackEnrollmentNodeEdge = {
  __typename?: 'DataTrackEnrollmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataTrackEnrollmentNode;
};

export type DataTrackEnrollmentResult = DataTrackEnrollmentConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export enum DataTypeEnum {
  Date = 'DATE',
  List = 'LIST',
  Number = 'NUMBER',
  Text = 'TEXT'
}

export type DataUserConnection = {
  __typename?: 'DataUserConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataUserNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type DataUserCustomFieldConnection = {
  __typename?: 'DataUserCustomFieldConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataUserCustomFieldNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataUserCustomFieldDistinctByEnum {
  UserId = 'USER_ID'
}

export type DataUserCustomFieldFilterInput = {
  /** Filtra por field_answer (igualdad). */
  field_answer?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por field_answer (contiene texto, case-insensitive). */
  field_answer_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por field_name (igualdad). */
  field_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por field_name (pertenece al conjunto). */
  field_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por product (igualdad). */
  product?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum DataUserCustomFieldGroupByEnum {
  FieldName = 'FIELD_NAME',
  Product = 'PRODUCT'
}

/** Campos personalizados por usuario definidos por la organización (clave/valor). Cada fila es un campo personalizado de un usuario. */
export type DataUserCustomFieldNode = {
  __typename?: 'DataUserCustomFieldNode';
  field_answer?: Maybe<Scalars['String']['output']>;
  field_name?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type DataUserCustomFieldNodeEdge = {
  __typename?: 'DataUserCustomFieldNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataUserCustomFieldNode;
};

export type DataUserCustomFieldResult = DataUserCustomFieldConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DataUserFilterInput = {
  /** Filtra por area_name (igualdad). */
  area_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por area_name (pertenece al conjunto). */
  area_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por birthday_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  birthday_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por birthday_date >= (fecha ISO-8601). */
  birthday_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por birthday_date <= (fecha ISO-8601). */
  birthday_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por city (igualdad). */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por city (pertenece al conjunto). */
  city_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por company_name (contiene texto, case-insensitive). */
  company_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por country_name (igualdad). */
  country_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por country_name (pertenece al conjunto). */
  country_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por email (igualdad). */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por email (contiene texto, case-insensitive). */
  email_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por gender (igualdad). */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por gender (pertenece al conjunto). */
  gender_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por incorporation_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  incorporation_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por incorporation_date >= (fecha ISO-8601). */
  incorporation_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por incorporation_date <= (fecha ISO-8601). */
  incorporation_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por leader_name (contiene texto, case-insensitive). */
  leader_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por level_name (igualdad). */
  level_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por level_name (pertenece al conjunto). */
  level_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por name (contiene texto, case-insensitive). */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por organization_id (igualdad). */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por position (igualdad). */
  position?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por position (contiene texto, case-insensitive). */
  position_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por position (pertenece al conjunto). */
  position_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por role_name (igualdad). */
  role_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por role_name (contiene texto, case-insensitive). */
  role_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por role_name (pertenece al conjunto). */
  role_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por sede (igualdad). */
  sede?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por sede (pertenece al conjunto). */
  sede_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por slug (igualdad). */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por slug (contiene texto, case-insensitive). */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por start_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  start_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por start_date >= (fecha ISO-8601). */
  start_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por start_date <= (fecha ISO-8601). */
  start_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por team_name (igualdad). */
  team_name?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por team_name (contiene texto, case-insensitive). */
  team_name_contains?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por team_name (pertenece al conjunto). */
  team_name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum DataUserGroupByEnum {
  AreaName = 'AREA_NAME',
  City = 'CITY',
  CompanyName = 'COMPANY_NAME',
  CountryName = 'COUNTRY_NAME',
  Gender = 'GENDER',
  LeaderName = 'LEADER_NAME',
  LevelName = 'LEVEL_NAME',
  Position = 'POSITION',
  RoleName = 'ROLE_NAME',
  Sede = 'SEDE',
  TeamName = 'TEAM_NAME'
}

export type DataUserManagerConnection = {
  __typename?: 'DataUserManagerConnection';
  /** Contiene los nodos de esta conexión. */
  edges: Array<DataUserManagerNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum DataUserManagerDistinctByEnum {
  UserId = 'USER_ID'
}

export type DataUserManagerFilterInput = {
  /** Filtra por activate_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  activate_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por activate_date >= (fecha ISO-8601). */
  activate_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por activate_date <= (fecha ISO-8601). */
  activate_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por inactivate_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  inactivate_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por inactivate_date >= (fecha ISO-8601). */
  inactivate_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por inactivate_date <= (fecha ISO-8601). */
  inactivate_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por is_manager (igualdad). */
  is_manager?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por is_manager (pertenece al conjunto). */
  is_manager_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filtra por register_date en el rango [start, end] inclusivo (fecha ISO-8601). */
  register_date_between?: InputMaybe<DataDateBetween>;
  /** Filtra por register_date >= (fecha ISO-8601). */
  register_date_gte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por register_date <= (fecha ISO-8601). */
  register_date_lte?: InputMaybe<Scalars['String']['input']>;
  /** Filtra por user_id (igualdad). */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por user_id (pertenece al conjunto). */
  user_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum DataUserManagerGroupByEnum {
  IsManager = 'IS_MANAGER'
}

/** Estado de jefatura y fechas de ciclo de vida (registro, activación, inactivación) por usuario. El perfil completo vive en `users`. Formatos de campos: `is_manager` → bandera 0/1. */
export type DataUserManagerNode = {
  __typename?: 'DataUserManagerNode';
  /** Fecha/hora en formato ISO-8601. */
  activate_date?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  inactivate_date?: Maybe<Scalars['String']['output']>;
  /** Bandera: 1 = es jefe/manager, 0 = no lo es. */
  is_manager?: Maybe<Scalars['Int']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  register_date?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type DataUserManagerNodeEdge = {
  __typename?: 'DataUserManagerNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataUserManagerNode;
};

export type DataUserManagerResult = DataUserManagerConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Colaboradores activos de la organización: identidad, equipo, cargo, ubicación y contacto. Cada fila es un usuario activo. */
export type DataUserNode = {
  __typename?: 'DataUserNode';
  about_me?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  area_name?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  birthday_date?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  civil_status?: Maybe<Scalars['String']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  country_name?: Maybe<Scalars['String']['output']>;
  document_type?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emergency_contact_email?: Maybe<Scalars['String']['output']>;
  emergency_contact_email_2?: Maybe<Scalars['String']['output']>;
  emergency_contact_name?: Maybe<Scalars['String']['output']>;
  emergency_contact_name_2?: Maybe<Scalars['String']['output']>;
  emergency_contact_phone?: Maybe<Scalars['String']['output']>;
  emergency_contact_phone_2?: Maybe<Scalars['String']['output']>;
  emergency_contact_relationship?: Maybe<Scalars['String']['output']>;
  emergency_contact_relationship_2?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  incorporation_date?: Maybe<Scalars['String']['output']>;
  leader_name?: Maybe<Scalars['String']['output']>;
  level_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Identificador de la organización. */
  organization_id?: Maybe<Scalars['Int']['output']>;
  phone_1?: Maybe<Scalars['String']['output']>;
  phone_2?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  role_name?: Maybe<Scalars['String']['output']>;
  sede?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  /** Fecha/hora en formato ISO-8601. */
  start_date?: Maybe<Scalars['String']['output']>;
  team_name?: Maybe<Scalars['String']['output']>;
  /** Identificador referencial (clave de entidad); no es una métrica. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type DataUserNodeEdge = {
  __typename?: 'DataUserNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DataUserNode;
};

export type DataUserResult = DataUserConnection | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DatafastGatewayNode = {
  __typename?: 'DatafastGatewayNode';
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
};

export type DatafastGatewayNodeEpaycoGatewayNodeFlywireGatewayNode = DatafastGatewayNode | EpaycoGatewayNode | FlywireGatewayNode;

export type DatafastTransaction = {
  __typename?: 'DatafastTransaction';
  amount?: Maybe<Scalars['String']['output']>;
  build_number?: Maybe<Scalars['String']['output']>;
  card?: Maybe<DatafastTransactionCard>;
  currency?: Maybe<Scalars['String']['output']>;
  custom_parameters?: Maybe<DatafastTransactionCustomParameters>;
  descriptor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  merchant_transaction_id?: Maybe<Scalars['String']['output']>;
  ndc?: Maybe<Scalars['String']['output']>;
  payment_brand?: Maybe<Scalars['String']['output']>;
  payment_type?: Maybe<Scalars['String']['output']>;
  result?: Maybe<DatafastTransactionResult>;
  result_details?: Maybe<DatafastTransactionResultDetails>;
  risk?: Maybe<DatafastTransactionRisk>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type DatafastTransactionCard = {
  __typename?: 'DatafastTransactionCard';
  bin?: Maybe<Scalars['String']['output']>;
  bin_country?: Maybe<Scalars['String']['output']>;
  expiry_month?: Maybe<Scalars['String']['output']>;
  expiry_year?: Maybe<Scalars['String']['output']>;
  holder?: Maybe<Scalars['String']['output']>;
  last4_digits?: Maybe<Scalars['String']['output']>;
};

export type DatafastTransactionCustomParameters = {
  __typename?: 'DatafastTransactionCustomParameters';
  val_base_0?: Maybe<Scalars['String']['output']>;
  val_base_imp?: Maybe<Scalars['String']['output']>;
  val_iva?: Maybe<Scalars['String']['output']>;
};

export type DatafastTransactionResult = {
  __typename?: 'DatafastTransactionResult';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type DatafastTransactionResultDetails = {
  __typename?: 'DatafastTransactionResultDetails';
  acquirer_code?: Maybe<Scalars['String']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  auth_code?: Maybe<Scalars['String']['output']>;
  batch_no?: Maybe<Scalars['String']['output']>;
  clearing_institute_name?: Maybe<Scalars['String']['output']>;
  extended_description?: Maybe<Scalars['String']['output']>;
  interest?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
  reference_no?: Maybe<Scalars['String']['output']>;
  request_id?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  response_code?: Maybe<Scalars['String']['output']>;
  risk_fraud_status_code?: Maybe<Scalars['String']['output']>;
  risk_response_code?: Maybe<Scalars['String']['output']>;
  risk_status_code?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['String']['output']>;
};

export type DatafastTransactionRisk = {
  __typename?: 'DatafastTransactionRisk';
  score?: Maybe<Scalars['String']['output']>;
};

export enum DayOfWeekInput {
  Fri = 'FRI',
  Mon = 'MON',
  Sat = 'SAT',
  Sun = 'SUN',
  Thu = 'THU',
  Tue = 'TUE',
  Wed = 'WED'
}

export enum DeactivateActionEnum {
  Deactivate = 'DEACTIVATE',
  Delete = 'DELETE',
  Purge = 'PURGE'
}

export type DeactivateOAuthClientInput = {
  client_id: Scalars['String']['input'];
};

export type DeactivateOAuthClientPayload = {
  __typename?: 'DeactivateOAuthClientPayload';
  client_id: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
};

export type DeactivateOAuthClientPayloadValidationMutationErrorInternalServerMutationError = DeactivateOAuthClientPayload | InternalServerMutationError | ValidationMutationError;

export type DeactivateOrganizationHeadquarterResponse = {
  __typename?: 'DeactivateOrganizationHeadquarterResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type DeactivateOrganizationPositionResponse = CentralizedDeactivateOrganizationPositionPayload | ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type DeactivatePolicyResponse = {
  __typename?: 'DeactivatePolicyResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type DeactivateSocialHubNewsInput = {
  centralized_organization_id: Scalars['Int']['input'];
  social_hub_news_ids: Array<Scalars['Int']['input']>;
};

export type DeactivateUserDocumentInput = {
  centralized_organization_id: Scalars['Int']['input'];
  user_document_ids: Array<Scalars['Int']['input']>;
};

export type DeactivateUserList = {
  action: DeactivateActionEnum;
  id: Scalars['Int']['input'];
};

export type DeactivateUserResponse = {
  __typename?: 'DeactivateUserResponse';
  failed_users: Array<UserDeactivateError>;
  response: ResponseNode;
  success: Scalars['Boolean']['output'];
};

export type DeactivateUserTeamInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  organization_team_id: Scalars['Int']['input'];
  success_file_id: Scalars['Int']['input'];
};

export type DeactivateUsersInput = {
  organization_slug: Scalars['String']['input'];
  users: Array<DeactivateUserList>;
};

export type DefaultDataPayload = {
  __typename?: 'DefaultDataPayload';
  graphql_operation_id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DefaultDataPayloadMutationInternalError = DefaultDataPayload | MutationInternalError;

export type DefaultDataPayloadMutationValidationErrorMutationInternalError = DefaultDataPayload | MutationInternalError | MutationValidationError;

export type DeleteCategoryPayload = {
  __typename?: 'DeleteCategoryPayload';
  category?: Maybe<KnowledgeHubCategoryType>;
  deleted: Scalars['Boolean']['output'];
};

export type DeleteCategoryResponse = DeleteCategoryPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type DeleteCategoryRestrictionPayload = {
  __typename?: 'DeleteCategoryRestrictionPayload';
  deleted: Scalars['Boolean']['output'];
  total_deleted: Scalars['Int']['output'];
};

export type DeleteCategoryRestrictionResponse = DeleteCategoryRestrictionPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type DeleteContentDocumentsResponse = AdminDeletedContentDocumentsPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type DeleteConversationInput = {
  chat_conversation_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
};

export type DeleteCourseInTeamOrganizationInput = {
  course_id: Scalars['Int']['input'];
  organization_team_id: Scalars['ID']['input'];
};

export type DeleteCourseInTeamOrganizationPayload = {
  __typename?: 'DeleteCourseInTeamOrganizationPayload';
  organization_team_course?: Maybe<OrganizationTeamCourseType>;
};

export type DeleteCourseInTeamOrganizationResponse = DeleteCourseInTeamOrganizationPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type DeleteCourseOrganizationTemplateInput = {
  course_organization_template_id: Scalars['Int']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type DeleteDc3OrganizationNameInput = {
  dc3_organization_name_id: Scalars['Int']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type DeleteDispersionAccountInput = {
  /** ID de la organización centralizada (owner). */
  centralized_organization_id: Scalars['ID']['input'];
  /** ID de la cuenta de dispersión a eliminar (soft delete). */
  id: Scalars['ID']['input'];
  /** ID de la razón social a la que pertenece la cuenta. */
  legal_entity_id: Scalars['ID']['input'];
};

export type DeleteDispersionAccountResponse = DispersionAccountResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DeleteDocumentInput = {
  action_type: DocumentDeleteTypeEnum;
  centralized_organization_id: Scalars['Int']['input'];
  document_ids: Array<Scalars['Int']['input']>;
};

/** Success payload for delete_employee_contact mutation. */
export type DeleteEmployeeContactPayload = {
  __typename?: 'DeleteEmployeeContactPayload';
  /** ID of the deleted contact record. */
  contact_id: Scalars['Int']['output'];
};

/** Union response for delete_employee_contact mutation. */
export type DeleteEmployeeContactResponse = DeleteEmployeeContactPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type DeleteEmployeeDependentInput = {
  centralized_organization_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type DeleteEmployeeDependentResult = EmployeeDependentResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DeleteEmployerRegistrationInput = {
  centralized_organization_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type DeleteEmployerRegistrationResponse = EmployerRegistrationResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DeleteEndUserDocumentInput = {
  centralized_organization_id: Scalars['Int']['input'];
  document_ids: Array<Scalars['Int']['input']>;
};

export type DeleteFileInput = {
  uid: Scalars['ID']['input'];
};

export type DeleteFileMutation = {
  __typename?: 'DeleteFileMutation';
  /** Hard-delete a file's S3 object by uid (right-to-erasure / retention). */
  delete_object: DeleteFileResponse;
};


export type DeleteFileMutationDelete_ObjectArgs = {
  input: DeleteFileInput;
};

export type DeleteFilePayload = {
  __typename?: 'DeleteFilePayload';
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  uid: Scalars['ID']['output'];
};

export type DeleteFileResponse = DeleteFilePayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type DeleteFolderInput = {
  action_type: FolderDeleteTypeEnum;
  centralized_organization_id: Scalars['Int']['input'];
  feature_type?: InputMaybe<FeatureTypeEnum>;
  folder_ids: Array<Scalars['Int']['input']>;
};

export type DeleteHigherEducationTeamProductResponse = {
  __typename?: 'DeleteHigherEducationTeamProductResponse';
  error?: Maybe<ErrorResponse>;
  products_id?: Maybe<Array<Scalars['Int']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteHolidayInput = {
  centralized_organization_id: Scalars['ID']['input'];
  holiday_id: Scalars['ID']['input'];
};

export type DeleteHolidayResponse = {
  __typename?: 'DeleteHolidayResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type DeleteHolidaysInput = {
  centralized_organization_id: Scalars['ID']['input'];
  holiday_ids: Array<Scalars['ID']['input']>;
};

export type DeleteHolidaysResponse = {
  __typename?: 'DeleteHolidaysResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type DeleteImssMovementInput = {
  legal_entity_id: Scalars['UUID']['input'];
  movement_id: Scalars['UUID']['input'];
};

export type DeleteImssMovementResponse = {
  __typename?: 'DeleteImssMovementResponse';
  graphql_operation_id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteImssMovementResult = DeleteImssMovementResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DeleteLegalEntityInput = {
  centralized_organization_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type DeleteLegalEntityResponse = CentralizedLegalEntityResponse | ForbiddenErrorResponse | InternalErrorResponse | LegalEntityResponse | NotAuthenticatedErrorResponse | NotFoundResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DeleteOrganizationAreaInput = {
  area_id: Scalars['Int']['input'];
  organization_id: Scalars['Int']['input'];
};

export type DeleteOrganizationAreaResponse = {
  __typename?: 'DeleteOrganizationAreaResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type DeleteOrganizationAreasInput = {
  area_ids: Array<Scalars['Int']['input']>;
  organization_id: Scalars['Int']['input'];
};

export type DeleteOrganizationCategoryInput = {
  category_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type DeleteOrganizationCourseInstructorInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  organization_instructor_id: Scalars['Int']['input'];
};

export type DeleteOrganizationTeamInput = {
  organization_id: Scalars['ID']['input'];
  organization_team_id: Scalars['ID']['input'];
};

export type DeleteOrganizationTeamPayload = {
  __typename?: 'DeleteOrganizationTeamPayload';
  organization_team?: Maybe<OrganizationTeamType>;
};

export type DeleteOrganizationTeamResponse = DeleteOrganizationTeamPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type DeleteOrganizationTemplateInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  organization_template_id: Scalars['Int']['input'];
};

export type DeletePayrollIncidenceResponse = {
  __typename?: 'DeletePayrollIncidenceResponse';
  graphql_operation_id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeletePayrollIncidenceResult = DeletePayrollIncidenceResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type DeletePolicyInput = {
  centralized_organization_id: Scalars['ID']['input'];
  policy_id: Scalars['ID']['input'];
};

export type DeletePolicyResponse = {
  __typename?: 'DeletePolicyResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type DeleteQuizInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteQuizPayload = GraphOperationI & {
  __typename?: 'DeleteQuizPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

export type DeleteQuizResponse = DeleteQuizPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type DeleteReportInput = {
  centralized_organization_slug: Scalars['String']['input'];
  report_identifier: Scalars['String']['input'];
};

export type DeleteReportResponse = {
  __typename?: 'DeleteReportResponse';
  message: Scalars['String']['output'];
  report_identifier: Scalars['String']['output'];
};

export type DeleteReportResponseAnalyticsMutationInternalError = AnalyticsMutationInternalError | DeleteReportResponse;

export type DeleteRequestInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Request ID */
  request_id: Scalars['ID']['input'];
};

export type DeleteRequestResponse = {
  __typename?: 'DeleteRequestResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type DeleteSaml2ClaimInput = {
  claim_id: Scalars['ID']['input'];
};

export type DeleteSaml2ClaimPayload = {
  __typename?: 'DeleteSaml2ClaimPayload';
  centralized_organization_id: Scalars['ID']['output'];
  claim_id: Scalars['ID']['output'];
  deleted: Scalars['Boolean']['output'];
};

export type DeleteSaml2ClaimPayloadValidationMutationErrorInternalServerMutationError = DeleteSaml2ClaimPayload | InternalServerMutationError | ValidationMutationError;

export type DeleteSaml2ServiceProviderInput = {
  service_provider_id: Scalars['ID']['input'];
};

export type DeleteSaml2ServiceProviderPayload = {
  __typename?: 'DeleteSaml2ServiceProviderPayload';
  centralized_organization_id: Scalars['ID']['output'];
  deleted: Scalars['Boolean']['output'];
  service_provider_id: Scalars['ID']['output'];
};

export type DeleteSaml2ServiceProviderPayloadValidationMutationErrorInternalServerMutationError = DeleteSaml2ServiceProviderPayload | InternalServerMutationError | ValidationMutationError;

export type DeleteSaml2TrustedIdpInput = {
  trusted_idp_id: Scalars['ID']['input'];
};

export type DeleteSaml2TrustedIdpPayload = {
  __typename?: 'DeleteSaml2TrustedIdpPayload';
  centralized_organization_id: Scalars['ID']['output'];
  deleted: Scalars['Boolean']['output'];
  trusted_idp_id: Scalars['ID']['output'];
};

export type DeleteSaml2TrustedIdpPayloadValidationMutationErrorInternalServerMutationError = DeleteSaml2TrustedIdpPayload | InternalServerMutationError | ValidationMutationError;

export type DeleteSegmentResponse = {
  __typename?: 'DeleteSegmentResponse';
  code: Scalars['String']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  segment: Segment;
};

export type DeleteSegmentResponseIntegrityErrorResponseValidationErrorResponseInternalErrorResponseNotFoundResponseForbiddenErrorResponse = DeleteSegmentResponse | ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type DeleteSegmentsInput = {
  centralized_organization_id: Scalars['Int']['input'];
  user_segment_id: Scalars['Int']['input'];
};

export type DeleteTeamResponse = {
  __typename?: 'DeleteTeamResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type DeleteTrackOrganizationTemplateInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  track_organization_template_id: Scalars['Int']['input'];
};

export type DeleteUserInTeamOrganizationInput = {
  filters?: InputMaybe<UserTeamBulkDeletionFilterInput>;
  organization_team_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
  user_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type DeleteUserInTeamOrganizationPayload = {
  __typename?: 'DeleteUserInTeamOrganizationPayload';
  user_ids: Array<Scalars['Int']['output']>;
};

export type DeleteUserInTeamOrganizationResponse = DeleteUserInTeamOrganizationPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type DeleteUsersCustomFieldAnswerResponse = {
  __typename?: 'DeleteUsersCustomFieldAnswerResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  users_failed: Array<UsersCustomFieldAnswerResponse>;
  users_success: Array<Scalars['Int']['output']>;
};

export type DeleteVideoLectureInput = {
  organization_id: Scalars['ID']['input'];
  video_lecture_id: Scalars['ID']['input'];
};

export type DeleteWorkFlowResponse = {
  __typename?: 'DeleteWorkFlowResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type DenyRequestInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Request ID */
  request_id: Scalars['ID']['input'];
};

export type DenyRequestResponse = {
  __typename?: 'DenyRequestResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

/** Gender of the dependent. */
export enum DependentGenderEnum {
  Female = 'FEMALE',
  Male = 'MALE',
  NonBinary = 'NON_BINARY',
  PreferNotToSay = 'PREFER_NOT_TO_SAY'
}

/** Relationship type between employee and dependent. */
export enum DependentRelationshipTypeEnum {
  Father = 'FATHER',
  Mother = 'MOTHER',
  Other = 'OTHER',
  Sibling = 'SIBLING',
  SonDaughter = 'SON_DAUGHTER',
  Spouse = 'SPOUSE'
}

export type DetachRequestFileInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Request File ID */
  request_file_id: Scalars['ID']['input'];
  /** Request ID */
  request_id: Scalars['ID']['input'];
};

export type DetachRequestFileResponse = {
  __typename?: 'DetachRequestFileResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type DipActivityEmployeeDetail = {
  __typename?: 'DipActivityEmployeeDetail';
  associate_process?: Maybe<PidAssociateProcess>;
  collaborator_progress?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dip_activity_attachment?: Maybe<Attachment>;
  dip_activity_class?: Maybe<Scalars['String']['output']>;
  dip_activity_id: Scalars['Int']['output'];
  displacement_comment?: Maybe<Scalars['String']['output']>;
  displacement_value?: Maybe<Scalars['Int']['output']>;
  end_date: Scalars['Date']['output'];
  extra_fields?: Maybe<DipExtraFieldQuestions>;
  id: Scalars['Int']['output'];
  leader_progress?: Maybe<Scalars['Float']['output']>;
  learning_info?: Maybe<LearningInfo>;
  model?: Maybe<PidModelLabels>;
  owner?: Maybe<DipActivityTypeEnum>;
  points?: Maybe<Scalars['Int']['output']>;
  state: Scalars['String']['output'];
  title: Scalars['String']['output'];
  track_start_date: Scalars['Date']['output'];
  tracks?: Maybe<Array<PidTrack>>;
  type_activity: PidActivityTypeEnum;
};

export type DipActivityEmployeeDetailResponse = DipActivityEmployeeDetail | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export enum DipActivityTypeEnum {
  Admin = 'ADMIN',
  Employee = 'EMPLOYEE',
  Learning = 'LEARNING'
}

export type DipApproveActivitiesInput = {
  activities_id_list: Array<Scalars['Int']['input']>;
};

export type DipApproveActivitiesResponse = DipSuccessType | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type DipEmailTemplate = {
  __typename?: 'DipEmailTemplate';
  batch?: Maybe<Scalars['Boolean']['output']>;
  company_id?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  receiver?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  sender_name?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type DipEmailTemplateInput = {
  code: EDipEmailTemplateType;
  collaborator_id?: InputMaybe<Scalars['Int']['input']>;
  dip_employee_id?: InputMaybe<Scalars['Int']['input']>;
  dip_employee_track_id?: InputMaybe<Scalars['Int']['input']>;
  plan_id: Scalars['Int']['input'];
};

export type DipEmailTemplateResponse = DipEmailTemplate | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type DipEmailTemplateTypeListResponse = EmailTemplateTypeList | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type DipEmployeeActivityListResponse = PidEmployeeActivityList | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type DipEmployeeBaseInfoInput = {
  description: Scalars['String']['input'];
  end_date: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type DipEmployeeExtraFieldInput = {
  dip_employee_id?: InputMaybe<Scalars['Int']['input']>;
  dip_employee_track_id?: InputMaybe<Scalars['Int']['input']>;
  dip_extra_field_id: Scalars['Int']['input'];
  dip_extra_field_option_id: Scalars['Int']['input'];
  dip_id: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  text_value?: InputMaybe<Scalars['String']['input']>;
};

export type DipEmployeeLeaningActivityList = {
  __typename?: 'DipEmployeeLeaningActivityList';
  employee_activities?: Maybe<Array<LearningInfo>>;
};

export type DipEmployeeLeaningInfoResponse = DipEmployeeLeaningActivityList | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type DipEmployeePayload = {
  __typename?: 'DipEmployeePayload';
  successful: Scalars['Boolean']['output'];
};

export type DipEmployeeTrackDatesInput = {
  end_date: Scalars['String']['input'];
  start_date: Scalars['String']['input'];
};

export type DipEmployeeTrackIdInput = {
  id: Scalars['Int']['input'];
};

export type DipEmployeeTrackInput = {
  end_date: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  start_date: Scalars['String']['input'];
};

export type DipEmployeeWithTrackInfoInput = {
  deleted_tracks?: InputMaybe<Array<DipEmployeeTrackIdInput>>;
  dip_employee_info: DipEmployeeBaseInfoInput;
  new_tracks?: InputMaybe<Array<DipEmployeeTrackDatesInput>>;
  updated_tracks?: InputMaybe<Array<DipEmployeeTrackInput>>;
};

export type DipEmployeeWithTrackResponse = DipEmployeePayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type DipEmployeesWithoutTrackErrorV2 = {
  __typename?: 'DipEmployeesWithoutTrackErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type DipEvaluationDetailInput = {
  attachment_id?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  is_final?: InputMaybe<Scalars['Boolean']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  progress?: InputMaybe<Scalars['Float']['input']>;
};

export type DipExtraFieldQuestion = {
  __typename?: 'DipExtraFieldQuestion';
  employee_extra_field_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  options: Array<DipExtraFieldQuestionOption>;
  ordered: Scalars['Int']['output'];
};

export type DipExtraFieldQuestionOption = {
  __typename?: 'DipExtraFieldQuestionOption';
  id: Scalars['Int']['output'];
  is_selected: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type DipExtraFieldQuestions = {
  __typename?: 'DipExtraFieldQuestions';
  questions?: Maybe<Array<DipExtraFieldQuestion>>;
};

export type DipProcess = {
  __typename?: 'DipProcess';
  end_date: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  original_id: Scalars['Int']['output'];
  start_date: Scalars['Date']['output'];
  state: Scalars['String']['output'];
  totals: PidTotalsActivities;
};

export type DipProcessDetailResponse = DipProcess | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type DipProcessListResponse = PidProcessList | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export enum DipProcessSearchFieldsEnum {
  DipName = 'DIP_NAME'
}

export type DipProcessSearchInput = {
  /** Fields to search over (e.g., DIP_NAME). */
  fields: Array<DipProcessSearchFieldsEnum>;
  /** Search query text; partial, case- and accent-insensitive. */
  query: Scalars['String']['input'];
};

export enum DipProcessSortFieldsEnum {
  DipEndDate = 'DIP_END_DATE',
  DipName = 'DIP_NAME',
  DipStartDate = 'DIP_START_DATE'
}

export enum DipProcessStateEnum {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Finished = 'FINISHED',
  Pending = 'PENDING'
}

export type DipProcessTypeRequiredErrorV2 = {
  __typename?: 'DipProcessTypeRequiredErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type DipSuccessType = {
  __typename?: 'DipSuccessType';
  successful: Scalars['Boolean']['output'];
};

export type DipTrackInput = {
  answers?: InputMaybe<Array<DipEmployeeExtraFieldInput>>;
  auto_evaluation?: InputMaybe<DipEvaluationDetailInput>;
  dip_employee_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  leader_evaluation?: InputMaybe<DipEvaluationDetailInput>;
};

export type DipTrackResponse = PidTrack | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export enum DipTrackingSeriesMonthEnum {
  April = 'APRIL',
  August = 'AUGUST',
  December = 'DECEMBER',
  February = 'FEBRUARY',
  January = 'JANUARY',
  July = 'JULY',
  June = 'JUNE',
  March = 'MARCH',
  May = 'MAY',
  November = 'NOVEMBER',
  October = 'OCTOBER',
  September = 'SEPTEMBER'
}

export type DipUpdateActivitiesStateInput = {
  activities_id_list: Array<Scalars['Int']['input']>;
  state: PidStatusEnum;
};

export type DipUpdateActivitiesStateResponse = DipSuccessType | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type DipUpdateEmployeeActivityDisplacementInput = {
  activity_id: Scalars['Int']['input'];
  displacement_comment: Scalars['String']['input'];
  displacement_value: Scalars['Int']['input'];
  employee_id: Scalars['Int']['input'];
};

/** Direction of a delta/trend indicator. */
export enum Direction {
  Down = 'DOWN',
  Neutral = 'NEUTRAL',
  Up = 'UP'
}

export type DispersionAccountListResponse = {
  __typename?: 'DispersionAccountListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<DispersionAccountType>;
  total_count: Scalars['Int']['output'];
};

export type DispersionAccountResponse = {
  __typename?: 'DispersionAccountResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: DispersionAccountType;
};

export type DispersionAccountType = {
  __typename?: 'DispersionAccountType';
  account_number?: Maybe<Scalars['String']['output']>;
  account_type: Scalars['String']['output'];
  bank_id: Scalars['ID']['output'];
  clabe: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  legal_entity_id: Scalars['ID']['output'];
  pay_period_ids: Array<Scalars['ID']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type DispersionLayoutColumnType = {
  __typename?: 'DispersionLayoutColumnType';
  canonical_key?: Maybe<Scalars['String']['output']>;
  header: Scalars['String']['output'];
  recognized: Scalars['Boolean']['output'];
  required: Scalars['Boolean']['output'];
  sample_value: Scalars['String']['output'];
};

export type DispersionLayoutConfigResponse = {
  __typename?: 'DispersionLayoutConfigResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: DispersionLayoutConfigType;
};

export type DispersionLayoutConfigType = {
  __typename?: 'DispersionLayoutConfigType';
  created_at: Scalars['DateTime']['output'];
  dispersion_account_id: Scalars['ID']['output'];
  encoding: Scalars['String']['output'];
  file_format: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  layout_file_content_type?: Maybe<Scalars['String']['output']>;
  layout_file_name?: Maybe<Scalars['String']['output']>;
  separator: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type DispersionLayoutFilePreviewResponse = {
  __typename?: 'DispersionLayoutFilePreviewResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: DispersionLayoutFilePreviewType;
};

export type DispersionLayoutFilePreviewType = {
  __typename?: 'DispersionLayoutFilePreviewType';
  columns: Array<DispersionLayoutColumnType>;
  header_source: Scalars['String']['output'];
  is_sample: Scalars['Boolean']['output'];
  missing_required_headers: Array<Scalars['String']['output']>;
  rows: Array<DispersionLayoutRowType>;
};

export type DispersionLayoutPreviewResponse = {
  __typename?: 'DispersionLayoutPreviewResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: DispersionLayoutPreviewType;
};

export type DispersionLayoutPreviewType = {
  __typename?: 'DispersionLayoutPreviewType';
  detail: Scalars['String']['output'];
  header: Scalars['String']['output'];
  rendered: Scalars['String']['output'];
  trailer: Scalars['String']['output'];
};

export type DispersionLayoutRowType = {
  __typename?: 'DispersionLayoutRowType';
  cells: Array<Scalars['String']['output']>;
};

export type DispersionLayoutSampleResponse = {
  __typename?: 'DispersionLayoutSampleResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: DispersionLayoutSampleType;
};

export type DispersionLayoutSampleType = {
  __typename?: 'DispersionLayoutSampleType';
  content_base64: Scalars['String']['output'];
  content_type: Scalars['String']['output'];
  file_name: Scalars['String']['output'];
};

export type DivisionTalentListType = {
  __typename?: 'DivisionTalentListType';
  divisions?: Maybe<Array<Maybe<DivisionTalentType>>>;
};

export type DivisionTalentType = {
  __typename?: 'DivisionTalentType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum DocumentActionEnum {
  Both = 'BOTH',
  Download = 'DOWNLOAD',
  Preview = 'PREVIEW'
}

export type DocumentActionNode = {
  __typename?: 'DocumentActionNode';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

/** Subgraph HRIS - Document Autocomplete Fields Template Node */
export type DocumentAutocompleteFieldsTemplateNode = {
  __typename?: 'DocumentAutocompleteFieldsTemplateNode';
  /** Cosigner fields */
  cosigners?: Maybe<Array<Array<AutocompleteFieldsTemplateEnum>>>;
  /** Main signer fields */
  signer?: Maybe<Array<AutocompleteFieldsTemplateEnum>>;
};

export type DocumentAutocompleteFieldsTemplateNodeHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError = DocumentAutocompleteFieldsTemplateNode | HrisQueryIntegrityError | HrisQueryInternalError | HrisQueryValidationError;

export type DocumentContentFiltersType = {
  __typename?: 'DocumentContentFiltersType';
  categories: Array<KnowledgeHubAdminFiltersCategoryType>;
  document_actions?: Maybe<Array<DocumentActionNode>>;
  document_extensions?: Maybe<Array<DocumentExtensionNode>>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  visibility_level: Array<ContentVisibilityNode>;
};

export enum DocumentCosignerUserTypeEnum {
  CosignerAdmin = 'COSIGNER_ADMIN',
  CosignerLeader = 'COSIGNER_LEADER',
  CosignerOther = 'COSIGNER_OTHER'
}

export enum DocumentDeleteTypeEnum {
  DeleteDocumentAndUserDocument = 'DELETE_DOCUMENT_AND_USER_DOCUMENT',
  DeleteOnlyDocument = 'DELETE_ONLY_DOCUMENT'
}

/** Subgraph END USER - Document Info Node */
export type DocumentEndUserInfoNode = {
  __typename?: 'DocumentEndUserInfoNode';
  /** Document Creation Date */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Document Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Document feature ID */
  document_feature_id?: Maybe<Scalars['Int']['output']>;
  /** Document Feature Type */
  feature_type?: Maybe<FeatureTypeEnum>;
  /** Document File ID */
  file_id?: Maybe<Scalars['Int']['output']>;
  /** Document File Info */
  file_info?: Maybe<File>;
  /** Folder ID */
  folder_id?: Maybe<Scalars['Int']['output']>;
  /** Folder Name */
  folder_name?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['Int']['output'];
  /** Document Identifier */
  identifier?: Maybe<Scalars['String']['output']>;
  /** Is document sensitive */
  is_sensitive: Scalars['Boolean']['output'];
  /** Document Name */
  name: Scalars['String']['output'];
  /** Qdrant ID */
  qdrant_id?: Maybe<Scalars['String']['output']>;
  /** List of questions */
  questions?: Maybe<Array<Scalars['String']['output']>>;
  /** Document Source Type */
  source?: Maybe<DocumentSourceTypeEnum>;
  /** Uploaded format */
  uploaded_format?: Maybe<HanaDocumentFileFormatEnum>;
  /** LINK to the document */
  url?: Maybe<Scalars['String']['output']>;
  /** Folder Visualization Type */
  visualization_type?: Maybe<FeatureVisualizationTypeEnum>;
};

export type DocumentEndUserInfoNodeCustomConnection = {
  __typename?: 'DocumentEndUserInfoNodeCustomConnection';
  edges: Array<DocumentEndUserInfoNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type DocumentEndUserInfoNodeCustomEdge = {
  __typename?: 'DocumentEndUserInfoNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DocumentEndUserInfoNode;
};

export enum DocumentExtension {
  ExtensionBmp = 'EXTENSION_BMP',
  ExtensionDoc = 'EXTENSION_DOC',
  ExtensionDocx = 'EXTENSION_DOCX',
  ExtensionGif = 'EXTENSION_GIF',
  ExtensionJpeg = 'EXTENSION_JPEG',
  ExtensionJpg = 'EXTENSION_JPG',
  ExtensionPdf = 'EXTENSION_PDF',
  ExtensionPng = 'EXTENSION_PNG',
  ExtensionPpt = 'EXTENSION_PPT',
  ExtensionPptx = 'EXTENSION_PPTX',
  ExtensionXls = 'EXTENSION_XLS',
  ExtensionXlsx = 'EXTENSION_XLSX',
  ExtensionZip = 'EXTENSION_ZIP'
}

export type DocumentExtensionNode = {
  __typename?: 'DocumentExtensionNode';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export enum DocumentFileFormatEnum {
  DocumentDocx = 'DOCUMENT_DOCX',
  DocumentJpg = 'DOCUMENT_JPG',
  DocumentPdf = 'DOCUMENT_PDF',
  DocumentPng = 'DOCUMENT_PNG',
  DocumentPpt = 'DOCUMENT_PPT',
  DocumentTxt = 'DOCUMENT_TXT',
  DocumentXlsx = 'DOCUMENT_XLSX',
  DocumentZip = 'DOCUMENT_ZIP'
}

export enum DocumentFileStateEnum {
  ApplicationStatusCompleted = 'APPLICATION_STATUS_COMPLETED',
  ApplicationStatusExpired = 'APPLICATION_STATUS_EXPIRED',
  ApplicationStatusPending = 'APPLICATION_STATUS_PENDING',
  ReadingStatusExpired = 'READING_STATUS_EXPIRED',
  ReadingStatusOpen = 'READING_STATUS_OPEN',
  ReadingStatusPending = 'READING_STATUS_PENDING',
  SignatureStatusCompleted = 'SIGNATURE_STATUS_COMPLETED',
  SignatureStatusExpired = 'SIGNATURE_STATUS_EXPIRED',
  SignatureStatusInProgress = 'SIGNATURE_STATUS_IN_PROGRESS',
  SignatureStatusPending = 'SIGNATURE_STATUS_PENDING',
  SignatureStatusSigned = 'SIGNATURE_STATUS_SIGNED'
}

export enum DocumentFileTypeEnum {
  DocumentApplication = 'DOCUMENT_APPLICATION',
  DocumentReading = 'DOCUMENT_READING',
  DocumentSignature = 'DOCUMENT_SIGNATURE',
  DocumentTemplate = 'DOCUMENT_TEMPLATE'
}

/** Subgraph END USER - Document Info Category Node */
export type DocumentInfoCategoryNode = {
  __typename?: 'DocumentInfoCategoryNode';
  /** Document Description */
  description?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['String']['output'];
  /** Document Name */
  name: Scalars['String']['output'];
  /** Template */
  template: QuestionInfoCategoryNode;
};

/** Subgraph HRIS - Document Info Node */
export type DocumentInfoNode = {
  __typename?: 'DocumentInfoNode';
  /** List of allowed document formats */
  allowed_formats: Array<DocumentFileFormatEnum>;
  /** Document Creation Date */
  created_at: Scalars['String']['output'];
  /** Document Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Document Type */
  document_type: DocumentFileTypeEnum;
  /** Document File ID */
  file_id?: Maybe<Scalars['Int']['output']>;
  /** Document File Info */
  file_info?: Maybe<File>;
  /** Folder ID */
  folder_id?: Maybe<Scalars['Int']['output']>;
  /** True if document has users */
  has_users: Scalars['Boolean']['output'];
  /** ID */
  id: Scalars['Int']['output'];
  /** Document Identifier */
  identifier: Scalars['String']['output'];
  /** Document location */
  location?: Maybe<Scalars['String']['output']>;
  /** Document Name */
  name: Scalars['String']['output'];
  /** User Document Progress */
  total_progress: Scalars['Int']['output'];
  /** Uploaded format onnly for Reading documents */
  uploaded_format?: Maybe<DocumentFileFormatEnum>;
};

export type DocumentInfoNodeCustomConnection = {
  __typename?: 'DocumentInfoNodeCustomConnection';
  edges: Array<DocumentInfoNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type DocumentInfoNodeCustomEdge = {
  __typename?: 'DocumentInfoNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DocumentInfoNode;
};

export enum DocumentManagementFilterByEnum {
  OrderByAz = 'ORDER_BY_AZ',
  OrderByCreatedAt = 'ORDER_BY_CREATED_AT',
  OrderByZa = 'ORDER_BY_ZA'
}

export enum DocumentManagementOrderByEnum {
  OrderByAsc = 'ORDER_BY_ASC',
  OrderByDesc = 'ORDER_BY_DESC'
}

export enum DocumentMargin {
  Amplio = 'AMPLIO',
  Estrecho = 'ESTRECHO',
  Normal = 'NORMAL'
}

/** Subgraph HRIS - Document Metric Detail Info Node */
export type DocumentMetricDetailInfoNode = {
  __typename?: 'DocumentMetricDetailInfoNode';
  /** Assigned */
  assigned: Scalars['Int']['output'];
  /** Completed */
  completed: Scalars['Int']['output'];
  /** Progress */
  progress: Scalars['Int']['output'];
};

export enum DocumentOrientation {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

export enum DocumentPageNumberFormat {
  GuionXGuion = 'GUION_X_GUION',
  PaginaXDeY = 'PAGINA_X_DE_Y',
  XDeY = 'X_DE_Y'
}

export enum DocumentPageSize {
  A4 = 'A4',
  Carta = 'CARTA',
  Oficio = 'OFICIO'
}

export enum DocumentPosition {
  Centro = 'CENTRO',
  Derecha = 'DERECHA',
  Izquierda = 'IZQUIERDA'
}

export type DocumentResumeNode = {
  __typename?: 'DocumentResumeNode';
  organization_document_config?: Maybe<OrganizationDocumentConfigNode>;
  statistics?: Maybe<DocumentStatisticsNode>;
};

/** Subgraph HRIS - Document Signature Report Template Node */
export type DocumentSignatureReportTemplateNode = {
  __typename?: 'DocumentSignatureReportTemplateNode';
  /** Signature Report Template */
  template: Scalars['JSON']['output'];
};

export enum DocumentSourceTypeEnum {
  DocumentExistingSource = 'DOCUMENT_EXISTING_SOURCE',
  DocumentNewSource = 'DOCUMENT_NEW_SOURCE',
  DocumentPublicLinkSource = 'DOCUMENT_PUBLIC_LINK_SOURCE'
}

export type DocumentStatisticsNode = {
  __typename?: 'DocumentStatisticsNode';
  public_documents: Scalars['Int']['output'];
  total_downloads: Scalars['Int']['output'];
  used_storage: Scalars['Float']['output'];
};

/** Subgraph HRIS - Document Info Node */
export type DocumentTemplateNode = {
  __typename?: 'DocumentTemplateNode';
  /** Document File ID */
  file_id?: Maybe<Scalars['Int']['output']>;
  /** Document File Info */
  file_info?: Maybe<File>;
  /** Document ID */
  id: Scalars['Int']['output'];
};

export enum DocumentTemplateVisibility {
  Restricted = 'RESTRICTED',
  Unrestricted = 'UNRESTRICTED'
}

export enum DocumentTypeEnum {
  Cc = 'CC',
  Ce = 'CE',
  Curp = 'CURP',
  Dni = 'DNI',
  Dui = 'DUI',
  Id = 'ID',
  Ife = 'IFE',
  Nit = 'NIT',
  Other = 'OTHER',
  Passport = 'PASSPORT',
  Rc = 'RC',
  Rut = 'RUT',
  Ti = 'TI'
}

export enum DocumentTypeEnumInput {
  Cc = 'CC',
  Ce = 'CE',
  Dni = 'DNI',
  Dui = 'DUI',
  Empty = 'EMPTY',
  Id = 'ID',
  Ife = 'IFE',
  Nit = 'NIT',
  Other = 'OTHER',
  Passport = 'PASSPORT',
  Rc = 'RC',
  Rut = 'RUT',
  Ti = 'TI'
}

/** Subgraph HRIS - Document User Profile Info Node */
export type DocumentUserProfileInfoNode = {
  __typename?: 'DocumentUserProfileInfoNode';
  /** List of allowed document formats */
  allowed_formats: Array<DocumentFileFormatEnum>;
  /** Document Assignation Date */
  assignation_date: Scalars['DateTime']['output'];
  /** Document Deadline */
  deadline?: Maybe<Scalars['DateTime']['output']>;
  /** Document Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Document ID */
  document_id: Scalars['Int']['output'];
  /** Document Signature Status ID */
  document_signature_status_id?: Maybe<Scalars['Int']['output']>;
  /** Document File ID */
  file_id?: Maybe<Scalars['Int']['output']>;
  /** Document File Info */
  file_info?: Maybe<File>;
  /** User Document ID */
  id: Scalars['Int']['output'];
  /** Document location */
  location?: Maybe<Scalars['String']['output']>;
  /** Document Name */
  name: Scalars['String']['output'];
  /** Document State */
  state: DocumentFileStateEnum;
  /** Document Type */
  type: DocumentFileTypeEnum;
  /** Uploaded format onnly for Reading documents */
  uploaded_format?: Maybe<DocumentFileFormatEnum>;
};

export type DocumentUserProfileInfoNodeCustomConnection = {
  __typename?: 'DocumentUserProfileInfoNodeCustomConnection';
  edges: Array<DocumentUserProfileInfoNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type DocumentUserProfileInfoNodeCustomConnectionHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError = DocumentUserProfileInfoNodeCustomConnection | HrisQueryIntegrityError | HrisQueryInternalError | HrisQueryValidationError;

export type DocumentUserProfileInfoNodeCustomEdge = {
  __typename?: 'DocumentUserProfileInfoNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DocumentUserProfileInfoNode;
};

export type DocumentUserProfileInfoNodeHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError = DocumentUserProfileInfoNode | HrisQueryIntegrityError | HrisQueryInternalError | HrisQueryValidationError;

/** Subgraph HRIS - Document User Profile Signature Status Info Node */
export type DocumentUserProfileSignatureStatusInfoNode = {
  __typename?: 'DocumentUserProfileSignatureStatusInfoNode';
  /** Document Assignation Date */
  assignation_date: Scalars['DateTime']['output'];
  /** Document Deadline */
  deadline?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  document_id: Scalars['Int']['output'];
  /** Document Signature Status ID */
  document_signature_status_id?: Maybe<Scalars['Int']['output']>;
  /** User Document ID */
  id: Scalars['Int']['output'];
  /** Document location */
  location?: Maybe<Scalars['String']['output']>;
  /** Document Name */
  name: Scalars['String']['output'];
  /** Document State */
  state: DocumentFileStateEnum;
};

export type DocumentUserProfileSignatureStatusInfoNodeCustomConnection = {
  __typename?: 'DocumentUserProfileSignatureStatusInfoNodeCustomConnection';
  edges: Array<DocumentUserProfileSignatureStatusInfoNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type DocumentUserProfileSignatureStatusInfoNodeCustomConnectionHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError = DocumentUserProfileSignatureStatusInfoNodeCustomConnection | HrisQueryIntegrityError | HrisQueryInternalError | HrisQueryValidationError;

export type DocumentUserProfileSignatureStatusInfoNodeCustomEdge = {
  __typename?: 'DocumentUserProfileSignatureStatusInfoNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: DocumentUserProfileSignatureStatusInfoNode;
};

export enum DocumentWildcardCategory {
  Atributos = 'ATRIBUTOS',
  Colaborador = 'COLABORADOR',
  Organizacion = 'ORGANIZACION'
}

export enum DocumentWildcardDataType {
  Date = 'DATE',
  Multiple = 'MULTIPLE',
  Number = 'NUMBER',
  Text = 'TEXT'
}

export enum DomainEnum {
  DomainAdmin = 'DOMAIN_ADMIN',
  DomainCampus = 'DOMAIN_CAMPUS',
  DomainLearning = 'DOMAIN_LEARNING',
  DomainTalent = 'DOMAIN_TALENT'
}

/** Provide metadata about the audit log report download or email request. */
export type DownloadAuditLogConnection = {
  __typename?: 'DownloadAuditLogConnection';
  code: Scalars['String']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type DownloadAuditLogConnectionInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = DownloadAuditLogConnection | ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type DownloadCertificateInput = {
  course_id?: InputMaybe<Scalars['ID']['input']>;
  course_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  download_document_type_enum: DownloadDocumentTypeEnum;
  end_date?: InputMaybe<Scalars['String']['input']>;
  is_select_all_courses?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id: Scalars['ID']['input'];
  start_date?: InputMaybe<Scalars['String']['input']>;
  user_attributes?: InputMaybe<Array<CustomFieldValuesInput>>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type DownloadCertificateResponse = DownloadCertificateResponsePayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type DownloadCertificateResponsePayload = {
  __typename?: 'DownloadCertificateResponsePayload';
  download_url?: Maybe<Scalars['String']['output']>;
  is_async_flow: Scalars['Boolean']['output'];
};

export type DownloadDispersionLayoutSampleInput = {
  /** ID de la organización centralizada (owner). */
  centralized_organization_id: Scalars['ID']['input'];
  /** ID de la cuenta de dispersión con configuración existente. */
  dispersion_account_id: Scalars['ID']['input'];
  /** ID de la razón social a la que pertenece la cuenta. */
  legal_entity_id: Scalars['ID']['input'];
};

export type DownloadDispersionLayoutSampleResponse = DispersionLayoutSampleResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export enum DownloadDocumentTypeEnum {
  DownloadDocumentTypeCourse = 'DOWNLOAD_DOCUMENT_TYPE_COURSE',
  DownloadDocumentTypeCourseAccreditation = 'DOWNLOAD_DOCUMENT_TYPE_COURSE_ACCREDITATION',
  DownloadDocumentTypeDc3 = 'DOWNLOAD_DOCUMENT_TYPE_DC3',
  DownloadDocumentTypeDc4 = 'DOWNLOAD_DOCUMENT_TYPE_DC4'
}

export type DownloadLinksType = {
  __typename?: 'DownloadLinksType';
  errorsReport?: Maybe<Scalars['String']['output']>;
};

/** Dummy Node */
export type DummyNode = {
  __typename?: 'DummyNode';
  message: Scalars['String']['output'];
};

export type DummyResponse = {
  __typename?: 'DummyResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type DuplicateFilterNameErrorV2 = {
  __typename?: 'DuplicateFilterNameErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type DuplicateOrganizationTeamInput = {
  /** Name of the NEW track. Required and unique inside the organization. The backend never generates it -- the '(Copia)' suffix is a frontend convention. */
  name: Scalars['String']['input'];
  /** Organization the source track belongs to. Must be the caller's own organization (or one of its sub-organizations); a mismatch is rejected before anything is read or written. */
  organization_id: Scalars['Int']['input'];
  /** Track (organization team) to duplicate. */
  organization_team_id: Scalars['Int']['input'];
};

export type DuplicateOrganizationTeamPayload = {
  __typename?: 'DuplicateOrganizationTeamPayload';
  /** True when this request matched one that had already succeeded, so nothing new was created and `organization_team` is the duplicate the first call produced. */
  already_duplicated: Scalars['Boolean']['output'];
  /** Courses of the source track that were NOT copied because they are no longer usable. Always present, empty when nothing was dropped. */
  excluded_courses: Array<DuplicatedTrackExcludedCourse>;
  graphql_operation_id: Scalars['ID']['output'];
  organization_team?: Maybe<ContentOrganizationTeamType>;
};

export type DuplicateOrganizationTeamResponse = DuplicateOrganizationTeamPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type DuplicatePolicyInput = {
  centralized_organization_id: Scalars['ID']['input'];
  policy_id: Scalars['ID']['input'];
};

export type DuplicatePolicyResponse = {
  __typename?: 'DuplicatePolicyResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type DuplicatedTrackExcludedCourse = {
  __typename?: 'DuplicatedTrackExcludedCourse';
  course_id: Scalars['Int']['output'];
  reason: TrackCourseExclusionReasonEnum;
  title: Scalars['String']['output'];
};

export enum EDipEmailTemplateType {
  DipBossActivities = 'DIP_BOSS_ACTIVITIES',
  DipBossNotifyContinuous = 'DIP_BOSS_NOTIFY_CONTINUOUS',
  DipBossRemainder = 'DIP_BOSS_REMAINDER',
  DipCollaboratorActivities = 'DIP_COLLABORATOR_ACTIVITIES',
  DipCollaboratorRemainder = 'DIP_COLLABORATOR_REMAINDER',
  DipCollNotifyContinuous = 'DIP_COLL_NOTIFY_CONTINUOUS',
  DipInvitation = 'DIP_INVITATION',
  DipModifyActivity = 'DIP_MODIFY_ACTIVITY',
  DipNewActivity = 'DIP_NEW_ACTIVITY',
  DipReminder = 'DIP_REMINDER',
  DipReminderBoss = 'DIP_REMINDER_BOSS',
  DipTrackingRequest = 'DIP_TRACKING_REQUEST'
}

export type EbanxBin = {
  __typename?: 'EbanxBin';
  bin?: Maybe<Scalars['String']['output']>;
  card_brand?: Maybe<Scalars['String']['output']>;
  card_type?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  full_bank_name?: Maybe<Scalars['String']['output']>;
  iso_country_a2?: Maybe<Scalars['String']['output']>;
};

export type EbanxBinList = {
  __typename?: 'EbanxBinList';
  bin_list?: Maybe<Array<EbanxBin>>;
  number_of_bins?: Maybe<Scalars['Int']['output']>;
};

export type EbanxDirectPaymentInput = {
  /** Tokenized card */
  card_token: Scalars['String']['input'];
  /** Device fingerprint generated in the client sdk */
  device_id?: InputMaybe<Scalars['String']['input']>;
  /** Payment gateway organization ID */
  gateway_org_id?: InputMaybe<Scalars['Int']['input']>;
  /** Invoice data ID */
  invoice_data_id: Scalars['Int']['input'];
  /** Payment method ID */
  payment_method_id?: InputMaybe<Scalars['Int']['input']>;
  payment_type_code: EbanxPaymentTypeCodeEnum;
  /** Product ID */
  product_id: Scalars['Int']['input'];
};

export type EbanxDirectPaymentResponse = {
  __typename?: 'EbanxDirectPaymentResponse';
  order_id?: Maybe<Scalars['String']['output']>;
  redirect_url: Scalars['String']['output'];
};

export type EbanxDirectPaymentResponsePaymentErrorNode = EbanxDirectPaymentResponse | PaymentErrorNode;

export enum EbanxPaymentTypeCodeEnum {
  CreditCard = 'CREDIT_CARD',
  DebitCard = 'DEBIT_CARD'
}

export type EditDocumentInput = {
  centralized_organization_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  document_id: Scalars['Int']['input'];
  folder_id?: InputMaybe<Scalars['Int']['input']>;
  is_sensitive_data?: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EditEndUserDocumentInput = {
  centralized_organization_id: Scalars['Int']['input'];
  document_id: Scalars['Int']['input'];
  folder_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  visualization_type?: InputMaybe<FeatureVisualizationTypeEnum>;
};

export type EditFolderInput = {
  centralized_organization_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  feature_type?: InputMaybe<FeatureTypeEnum>;
  folder_id: Scalars['Int']['input'];
  icon_id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  visualization_type?: InputMaybe<FolderVisualizationTypeEnum>;
};

export type EditUserDocumentDeadlineInput = {
  centralized_organization_id: Scalars['Int']['input'];
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  user_document_id: Scalars['Int']['input'];
};

export type EducationContentFiltersType = {
  __typename?: 'EducationContentFiltersType';
  categories: Array<KnowledgeHubAdminFiltersCategoryType>;
  languages: Array<LanguageNode>;
  levels?: Maybe<Array<Level>>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  providers?: Maybe<Array<ProviderType>>;
  visibility_level: Array<ContentVisibilityNode>;
};

export type EligibleAutomationCoursesInput = {
  audios?: Array<Scalars['String']['input']>;
  categories?: Array<Scalars['ID']['input']>;
  organization_id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search_text?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  subtitles?: Array<Scalars['String']['input']>;
};

export type EmailAttributes = {
  emails_data: Array<Scalars['JSON']['input']>;
  mailer: Scalars['String']['input'];
  template_data: Scalars['JSON']['input'];
};

export type EmailBuilderMutations = {
  __typename?: 'EmailBuilderMutations';
  centralized_send_custom_test_email: EmailResponse;
  send_custom_email: EmailResponse;
  send_custom_test_email: EmailResponse;
};


export type EmailBuilderMutationsCentralized_Send_Custom_Test_EmailArgs = {
  input: SendCustomEmailBaseInput;
};


export type EmailBuilderMutationsSend_Custom_EmailArgs = {
  input: SendCustomEmailToUsersInput;
};


export type EmailBuilderMutationsSend_Custom_Test_EmailArgs = {
  input: SendCustomEmailBaseInput;
};

export type EmailBuilderQuery = {
  __typename?: 'EmailBuilderQuery';
  email_tags: Array<EmailTag>;
};

export enum EmailContentTypeEnum {
  ContentTypeCourse = 'CONTENT_TYPE_COURSE',
  ContentTypeLiveSession = 'CONTENT_TYPE_LIVE_SESSION',
  ContentTypeTrack = 'CONTENT_TYPE_TRACK'
}

export type EmailDuplicatedErrorType = {
  __typename?: 'EmailDuplicatedErrorType';
  email?: Maybe<Scalars['String']['output']>;
  error_detail: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type EmailEmptyErrorType = {
  __typename?: 'EmailEmptyErrorType';
  email?: Maybe<Scalars['String']['output']>;
  error_detail: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  user_id?: Maybe<Scalars['Int']['output']>;
};

export enum EmailEnrollmentStatusEnum {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type EmailFormatErrorType = {
  __typename?: 'EmailFormatErrorType';
  email?: Maybe<Scalars['String']['output']>;
  error_detail: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type EmailGraphOperationI = {
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type EmailMutationNode = {
  __typename?: 'EmailMutationNode';
  /** Describes how many emails were sent */
  emails_sent?: Maybe<Scalars['String']['output']>;
  /**
   * This object contains information about the response code,
   *         response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EmailPayload = EmailGraphOperationI & {
  __typename?: 'EmailPayload';
  content_type?: Maybe<EmailContentTypeEnum>;
  content_value?: Maybe<Scalars['Int']['output']>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  section?: Maybe<EmailSectionEnum>;
};

export type EmailPublisherMutation = {
  __typename?: 'EmailPublisherMutation';
  send_email: EventResponse;
};


export type EmailPublisherMutationSend_EmailArgs = {
  inputs: EmailAttributes;
};

export type EmailResponse = EmailPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export enum EmailSectionEnum {
  HrisGeneralSection = 'HRIS_GENERAL_SECTION',
  SectionCourseStatistics = 'SECTION_COURSE_STATISTICS',
  SectionLiveSession = 'SECTION_LIVE_SESSION',
  SectionTrackPanel = 'SECTION_TRACK_PANEL',
  SectionUserPanel = 'SECTION_USER_PANEL'
}

export type EmailTag = {
  __typename?: 'EmailTag';
  description: Scalars['String']['output'];
  key: EmailTagEnum;
};

export enum EmailTagEnum {
  ContentName = 'CONTENT_NAME',
  FirstName = 'FIRST_NAME',
  FullName = 'FULL_NAME',
  LastLogin = 'LAST_LOGIN',
  LastName = 'LAST_NAME'
}

export type EmailTemplateTypeList = {
  __typename?: 'EmailTemplateTypeList';
  types?: Maybe<Array<EDipEmailTemplateType>>;
};

export type EmailValidationByExcel = {
  action: ValidationEmailAction;
  course_id?: InputMaybe<Scalars['ID']['input']>;
  file_id: Scalars['Int']['input'];
  live_session_id?: InputMaybe<Scalars['ID']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  organization_team_id?: InputMaybe<Scalars['ID']['input']>;
  send_email_to_all_selected_users?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmailValidationErrorData = {
  __typename?: 'EmailValidationErrorData';
  emails_data_invalid_format: EmailsValidationErrorDetail;
  emails_data_not_found: EmailsValidationErrorDetail;
  file_id?: Maybe<Scalars['Int']['output']>;
  total_errors_number: Scalars['Int']['output'];
};

export type EmailValidationPayload = {
  __typename?: 'EmailValidationPayload';
  assign_organization_user_file_id: Scalars['Int']['output'];
  error_data: EmailValidationErrorData;
  success_data: EmailsValidationSuccessData;
};

export type EmailValidationResponse = EmailValidationPayload | EmptyTemplateResponseError | InvalidTemplateResponseError | NotFoundTemplateResponseError | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type EmailsValidationErrorDetail = {
  __typename?: 'EmailsValidationErrorDetail';
  emails: Array<Scalars['String']['output']>;
  total_errors: Scalars['Int']['output'];
};

export type EmailsValidationSuccessData = {
  __typename?: 'EmailsValidationSuccessData';
  file_id?: Maybe<Scalars['Int']['output']>;
  total_success_number: Scalars['Int']['output'];
};

export type EmployeeCompetencesEvaluation = {
  __typename?: 'EmployeeCompetencesEvaluation';
  avatar?: Maybe<AvatarTalentType>;
  division?: Maybe<DivisionTalentType>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  job?: Maybe<JobTalentType>;
  original_id?: Maybe<Scalars['Int']['output']>;
};

/** Contact fields shared by create and update operations. */
export type EmployeeContactFieldsInput = {
  /** Contact's date of birth. */
  birth_date?: InputMaybe<Scalars['Date']['input']>;
  /** Contact's cellphone number. */
  cellphone?: InputMaybe<Scalars['String']['input']>;
  /** Contact's email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Legacy email field. */
  emergency_contact_email?: InputMaybe<Scalars['String']['input']>;
  /** Legacy full name field. */
  emergency_contact_name?: InputMaybe<Scalars['String']['input']>;
  /** Legacy phone field. */
  emergency_contact_phone?: InputMaybe<Scalars['String']['input']>;
  /** Legacy relationship field (free text). */
  emergency_contact_relationship?: InputMaybe<Scalars['String']['input']>;
  /** Contact's primary last name (apellido paterno). */
  first_lastname?: InputMaybe<Scalars['String']['input']>;
  /** Contact's gender. */
  gender?: InputMaybe<GenderEnum>;
  /** Whether this contact is an economic dependent of the employee. */
  is_economic_dependent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this contact should be notified in case of emergency. */
  is_emergency_contact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Relationship to the employee. */
  relationship?: InputMaybe<RelationshipEnum>;
  /** Contact's second last name (apellido materno). */
  second_lastname?: InputMaybe<Scalars['String']['input']>;
};

/** A family or emergency contact for an employee. */
export type EmployeeContactNode = {
  __typename?: 'EmployeeContactNode';
  /** Age in years, computed from birth_date. Null if birth_date is not set. */
  age?: Maybe<Scalars['Int']['output']>;
  /** Contact's date of birth. */
  birth_date?: Maybe<Scalars['Date']['output']>;
  /** Contact's cellphone number. */
  cellphone?: Maybe<Scalars['String']['output']>;
  /** Contact's email address. */
  email?: Maybe<Scalars['String']['output']>;
  /** Legacy email field. */
  emergency_contact_email?: Maybe<Scalars['String']['output']>;
  /** Legacy full name field. */
  emergency_contact_name?: Maybe<Scalars['String']['output']>;
  /** Legacy phone field. */
  emergency_contact_phone?: Maybe<Scalars['String']['output']>;
  /** Legacy relationship field (free text). */
  emergency_contact_relationship?: Maybe<Scalars['String']['output']>;
  /** Contact's primary last name (apellido paterno). */
  first_lastname?: Maybe<Scalars['String']['output']>;
  /** Contact's gender. */
  gender?: Maybe<GenderEnum>;
  /** Contact record ID. */
  id: Scalars['Int']['output'];
  /** Whether this contact is an economic dependent of the employee. */
  is_economic_dependent?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this contact should be notified in case of emergency. */
  is_emergency_contact?: Maybe<Scalars['Boolean']['output']>;
  /** Relationship to the employee. */
  relationship?: Maybe<RelationshipEnum>;
  /** Contact's second last name (apellido materno). */
  second_lastname?: Maybe<Scalars['String']['output']>;
  /** Owner employee user ID. */
  user_id: Scalars['Int']['output'];
};

export type EmployeeContractConfigType = {
  __typename?: 'EmployeeContractConfigType';
  absence_integration: Scalars['Boolean']['output'];
  centralized_organization_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  employee_contract_id: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  legal_entity_id: Scalars['UUID']['output'];
  payroll_bank_code?: Maybe<Scalars['String']['output']>;
  pays_overtime: Scalars['Boolean']['output'];
  pension_type?: Maybe<Scalars['Int']['output']>;
  prior_seniority_years?: Maybe<Scalars['Int']['output']>;
  sar_bank_code?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  vacation_days?: Maybe<Scalars['Int']['output']>;
};

export type EmployeeContractType = {
  __typename?: 'EmployeeContractType';
  bank_account_type?: Maybe<BankAccountTypeEnum>;
  base_salary: Scalars['Decimal']['output'];
  centralized_org_unit_ref?: Maybe<Scalars['String']['output']>;
  centralized_organization_id: Scalars['String']['output'];
  centralized_position_ref?: Maybe<Scalars['String']['output']>;
  change_blocks?: Maybe<Array<Scalars['String']['output']>>;
  change_reason?: Maybe<Scalars['String']['output']>;
  clabe?: Maybe<Scalars['String']['output']>;
  config?: Maybe<EmployeeContractConfigType>;
  contract_type: ContractTypeEnum;
  country_code: Scalars['String']['output'];
  country_name?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by: Scalars['String']['output'];
  employer_registration_id: Scalars['UUID']['output'];
  end_date?: Maybe<Scalars['Date']['output']>;
  fiscal_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  imss_employee_type?: Maybe<ImssEmployeeTypeEnum>;
  imss_medical_unit_id?: Maybe<Scalars['Int']['output']>;
  imss_number?: Maybe<Scalars['String']['output']>;
  imss_registration_date?: Maybe<Scalars['Date']['output']>;
  imss_salary_type: ImssSalaryTypeEnum;
  imss_shift_type?: Maybe<ImssShiftTypeEnum>;
  is_on_payroll: Scalars['Boolean']['output'];
  labor_regime: LaborRegimeEnum;
  last_movement_type?: Maybe<ImssLastMovementTypeEnum>;
  last_salary_movement_date?: Maybe<Scalars['Date']['output']>;
  legal_entity_id: Scalars['UUID']['output'];
  manager_ref?: Maybe<Scalars['String']['output']>;
  pay_frequency?: Maybe<PayFrequencyEnum>;
  payment_method: PaymentMethodEnum;
  payroll_employee_id?: Maybe<Scalars['UUID']['output']>;
  previous_contract_id?: Maybe<Scalars['UUID']['output']>;
  shift_hours?: Maybe<Scalars['Int']['output']>;
  shift_type: ContractShiftTypeEnum;
  sicoss_period_id: Scalars['Int']['output'];
  start_date: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  status_changed_at?: Maybe<Scalars['DateTime']['output']>;
  status_changed_by?: Maybe<Scalars['String']['output']>;
  termination_date?: Maybe<Scalars['Date']['output']>;
  termination_reason?: Maybe<Scalars['String']['output']>;
  unionized: Scalars['Boolean']['output'];
  updated_at: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
  work_center_ref?: Maybe<Scalars['String']['output']>;
};

export type EmployeeDependentListResponse = {
  __typename?: 'EmployeeDependentListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<EmployeeDependentType>;
  total_count: Scalars['Int']['output'];
};

export type EmployeeDependentResponse = {
  __typename?: 'EmployeeDependentResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmployeeDependentType;
};

export type EmployeeDependentType = {
  __typename?: 'EmployeeDependentType';
  birth_date: Scalars['Date']['output'];
  centralized_user_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by: Scalars['ID']['output'];
  first_name: Scalars['String']['output'];
  gender: DependentGenderEnum;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_economic_dependent: Scalars['Boolean']['output'];
  is_emergency_contact: Scalars['Boolean']['output'];
  last_name_1: Scalars['String']['output'];
  last_name_2?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  relationship_type: DependentRelationshipTypeEnum;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['ID']['output']>;
};

export type EmployeeEvaluationDataType = {
  __typename?: 'EmployeeEvaluationDataType';
  employee_id: Scalars['Int']['output'];
  job: Scalars['String']['output'];
  name: Scalars['String']['output'];
  total_track_avg_progress: Scalars['Int']['output'];
};

export type EmployeePensionItemResponse = {
  __typename?: 'EmployeePensionItemResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmployeePensionType;
};

export type EmployeePensionListResponse = {
  __typename?: 'EmployeePensionListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: Array<EmployeePensionType>;
};

export type EmployeePensionType = {
  __typename?: 'EmployeePensionType';
  beneficiary_name: Scalars['String']['output'];
  court_order_date: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by: Scalars['String']['output'];
  discount_type: Scalars['String']['output'];
  discount_value: Scalars['Float']['output'];
  folio: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
};

export type EmployeeTalentEdge = {
  __typename?: 'EmployeeTalentEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<EmployeeTalentType>;
};

export type EmployeeTalentEdgePagination = {
  __typename?: 'EmployeeTalentEdgePagination';
  edges?: Maybe<Array<Maybe<EmployeeTalentEdge>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type EmployeeTalentPagination = {
  __typename?: 'EmployeeTalentPagination';
  employees?: Maybe<EmployeeTalentEdgePagination>;
};

export type EmployeeTalentType = {
  __typename?: 'EmployeeTalentType';
  avatar?: Maybe<AvatarTalentType>;
  division?: Maybe<DivisionTalentType>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  job?: Maybe<JobTalentType>;
  level?: Maybe<LevelTalentType>;
  original_id?: Maybe<Scalars['Int']['output']>;
  subsidiary?: Maybe<SubsidiaryTalentType>;
};

export type EmployerRegistrationListResponse = {
  __typename?: 'EmployerRegistrationListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<EmployerRegistrationType>;
  total_count: Scalars['Int']['output'];
};

export type EmployerRegistrationResponse = {
  __typename?: 'EmployerRegistrationResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmployerRegistrationType;
};

export type EmployerRegistrationType = {
  __typename?: 'EmployerRegistrationType';
  centralized_organization_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  economic_activity_code: Scalars['String']['output'];
  economic_activity_description: Scalars['String']['output'];
  /** @deprecated Use get_idse_status query instead. */
  has_idse_efirma_password: Scalars['Boolean']['output'];
  /** @deprecated Use get_idse_status query instead. */
  has_idse_password: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use get_idse_status query instead. */
  idse_pfx_file?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use get_idse_status query instead. */
  idse_username?: Maybe<Scalars['String']['output']>;
  /** IMSS subdelegation associated with this employer registration. */
  imss_subdelegation?: Maybe<ImssSubdelegationType>;
  imss_subdelegation_id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  /** Legal entity associated with this employer registration. */
  legal_entity?: Maybe<LegalEntityType>;
  legal_entity_id: Scalars['ID']['output'];
  registration_number: Scalars['String']['output'];
  /** Risk class associated with this employer registration. */
  risk_class?: Maybe<RiskClassType>;
  risk_class_id: Scalars['ID']['output'];
  risk_data_expiration_date?: Maybe<Scalars['Date']['output']>;
  risk_fraction?: Maybe<Scalars['Decimal']['output']>;
  risk_premium: Scalars['Decimal']['output'];
  /** Salary zone associated with this employer registration. */
  salary_zone?: Maybe<SalaryZoneType>;
  salary_zone_id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  user_count?: Maybe<Scalars['Int']['output']>;
  work_center_location_type: PayrollWorkCenterLocationType;
  /** Work locations (headquarters) associated with this employer registration. */
  work_locations: Array<WorkLocationType>;
};

/** Certificado bancario recuperado del almacenamiento. `content_base64` son los bytes del PDF codificados — decodificalo a un Blob del lado del cliente para disparar la descarga. Mismo patron que `export_collaborators`; no se devuelven URLs prefirmadas. */
export type EmploymentBankCertificateType = {
  __typename?: 'EmploymentBankCertificateType';
  content_base64: Scalars['String']['output'];
  content_type: Scalars['String']['output'];
  file_name: Scalars['String']['output'];
};

/** Resultado de subir el certificado bancario. `s3_bank_cert_key` es la llave que el backend construyo y persistio en la version vigente del contrato — no la elige el cliente y no hay input para escribirla. */
export type EmploymentBankCertificateUploadType = {
  __typename?: 'EmploymentBankCertificateUploadType';
  contract_id: Scalars['UUID']['output'];
  s3_bank_cert_key: Scalars['String']['output'];
};

/** Applies a validated bulk upload. Queues the work and returns immediately: the writing happens in the background, and the batch detail reports the progress. */
export type EmploymentBulkUploadApplyInput = {
  /** The batch returned by `validateBulkUpload`. Everything else — case, country, legal entity, author — is read from the batch itself, so a re-send cannot apply with different parameters than the ones the admin confirmed. */
  import_batch_id: Scalars['UUID']['input'];
};

export type EmploymentBulkUploadApplyResponse = {
  __typename?: 'EmploymentBulkUploadApplyResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentBulkUploadApplyType;
};

export type EmploymentBulkUploadApplyResult = EmploymentBulkUploadApplyResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** What queueing an apply produced. The writing has **not** happened yet when this returns: it runs in the background, one chunk at a time, and `progress` is where it is reported. */
export type EmploymentBulkUploadApplyType = {
  __typename?: 'EmploymentBulkUploadApplyType';
  import_batch_id: Scalars['UUID']['output'];
  progress: EmploymentBulkUploadProgressType;
};

/** Who uploaded a file. Resolved in one bulk call per page against centralized-users. It is **null** when that service could not resolve the author — the row still carries `created_by`, so the screen degrades to showing the id instead of losing the history. */
export type EmploymentBulkUploadAuthorType = {
  __typename?: 'EmploymentBulkUploadAuthorType';
  centralized_user_id: Scalars['Int']['output'];
  full_name: Scalars['String']['output'];
};

/** One upload in the history. Every counter comes from the batch header, never from staging: staging empties by two normal routes — the apply deletes what it writes and the sweep deletes what expires — so reading it would report zeros for any upload older than a week. */
export type EmploymentBulkUploadBatchType = {
  __typename?: 'EmploymentBulkUploadBatchType';
  case: EmploymentBulkUploadCaseEnum;
  country_code: Scalars['String']['output'];
  /** The raw session user id that uploaded the file. Always present, unlike `uploaded_by`, which needs centralized-users to answer. */
  created_by: Scalars['String']['output'];
  /** Whether the correction file can still be downloaded. Measured against staging and not against the counters, because the rows expire at 7 days while the counters are permanent. */
  errors_downloadable: Scalars['Boolean']['output'];
  file: EmploymentBulkUploadFileType;
  import_batch_id: Scalars['UUID']['output'];
  legal_entity_id?: Maybe<Scalars['UUID']['output']>;
  progress?: Maybe<EmploymentBulkUploadProgressType>;
  /** How **the validation** came out. A fact of the past that never changes — where the apply got to is `progress`. */
  status: EmploymentBulkUploadStatusEnum;
  /** The counters of the validation, read from the header. */
  summary?: Maybe<EmploymentBulkUploadHistorySummaryType>;
  /** The resolved author, or null when it could not be read. */
  uploaded_by?: Maybe<EmploymentBulkUploadAuthorType>;
};

/** Bulk upload case. The operation is defined by the chosen template, never by a column of the uploaded file. */
export enum EmploymentBulkUploadCaseEnum {
  DataCorrection = 'DATA_CORRECTION',
  Hire = 'HIRE',
  SalaryChange = 'SALARY_CHANGE',
  Termination = 'TERMINATION'
}

/** The correction file: the rows that failed, in the **same template** the batch was uploaded with — dropdowns and «Catalogos» sheet included — plus two informational columns with the error code and the cell. `content_base64` is the raw .xlsx; decode it to a Blob client-side. The two extra columns are ignored by the parser, so the file can be corrected and re-uploaded as is. */
export type EmploymentBulkUploadErrorFileType = {
  __typename?: 'EmploymentBulkUploadErrorFileType';
  content_base64: Scalars['String']['output'];
  content_type: Scalars['String']['output'];
  /** Encodes the batch's variant (case, country, IMSS). The screen should preselect it on re-upload: case, country and `trigger_imss` are mutation input and not file columns, so picking a different variant makes the column guard reject the whole file. */
  file_name: Scalars['String']['output'];
};

/** The uploaded file, as the history recorded it. */
export type EmploymentBulkUploadFileType = {
  __typename?: 'EmploymentBulkUploadFileType';
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  uploaded_at: Scalars['DateTime']['output'];
};

/** Rows sharing one error or info code. `code` is the constant the frontend translates into a title and a description. */
export type EmploymentBulkUploadGroupType = {
  __typename?: 'EmploymentBulkUploadGroupType';
  code: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  rows: EmploymentBulkUploadRowsType;
};

/** The validation counters of one upload, as the batch header recorded them. **A different type from `EmploymentBulkUploadSummaryType` on purpose**: that one carries `error_groups_count` and `info_groups_count`, which count *distinct codes* and can only be answered by reading the staging rows — which this list deliberately does not do, so that it keeps telling the truth after the 7-day sweep empties them. Reusing it here would have meant sending 0 for «not computed», a value indistinguishable from «no error groups». For the grouped breakdown of one batch use `bulkUploadResult`. */
export type EmploymentBulkUploadHistorySummaryType = {
  __typename?: 'EmploymentBulkUploadHistorySummaryType';
  error_count: Scalars['Int']['output'];
  info_count: Scalars['Int']['output'];
  total_records: Scalars['Int']['output'];
  valid_count: Scalars['Int']['output'];
};

/** Where an upload is in its life cycle. **A different axis from the validation status**, and that is why they are two fields: a batch can be `SUCCESS` and still not be applied. This is the one that answers 'is it done yet'. */
export enum EmploymentBulkUploadLifecycleEnum {
  Imported = 'IMPORTED',
  InProgress = 'IN_PROGRESS',
  Omitted = 'OMITTED',
  Validated = 'VALIDATED'
}

/** How far the apply got. `applied` plus `failed` never exceeds the applicable rows the validation reported, and while `lifecycle` is `IN_PROGRESS` both keep moving — poll the batch detail to follow it. */
export type EmploymentBulkUploadProgressType = {
  __typename?: 'EmploymentBulkUploadProgressType';
  applicable: Scalars['Int']['output'];
  applied: Scalars['Int']['output'];
  applied_at?: Maybe<Scalars['DateTime']['output']>;
  failed: Scalars['Int']['output'];
  lifecycle: EmploymentBulkUploadLifecycleEnum;
};

/** Page 1 of the three sections of a validation result, in one call. Everything is read from staging — the file is never read again. */
export type EmploymentBulkUploadResultInput = {
  import_batch_id: Scalars['UUID']['input'];
  /** Items per section. Clamped to the 1..100 range. */
  page_size?: Scalars['Int']['input'];
};

export type EmploymentBulkUploadResultResponse = {
  __typename?: 'EmploymentBulkUploadResultResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentBulkUploadResultType;
};

export type EmploymentBulkUploadResultResult = EmploymentBulkUploadResultResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Page 1 of the three sections, in one call. Use it when showing the results for the first time; paginate each section afterwards. */
export type EmploymentBulkUploadResultType = {
  __typename?: 'EmploymentBulkUploadResultType';
  error_groups: Array<EmploymentBulkUploadGroupType>;
  info_groups: Array<EmploymentBulkUploadGroupType>;
  progress: EmploymentBulkUploadProgressType;
  status: EmploymentBulkUploadStatusEnum;
  summary: EmploymentBulkUploadSummaryType;
  valid_rows: EmploymentBulkUploadRowsType;
};

/** Pages through one section of a validation result. */
export type EmploymentBulkUploadRowsInput = {
  /** Error or info code identifying the group. Required for ERROR and INFO, where the section is made of groups; ignored for VALID. */
  code?: InputMaybe<Scalars['String']['input']>;
  import_batch_id: Scalars['UUID']['input'];
  /** Pagination configuration. Default: page 1, page_size 10. */
  pagination?: InputMaybe<EmploymentOffsetPaginationInput>;
  /** Filters the rows by email. */
  search?: InputMaybe<Scalars['String']['input']>;
  section: EmploymentBulkUploadSectionEnum;
};

export type EmploymentBulkUploadRowsResponse = {
  __typename?: 'EmploymentBulkUploadRowsResponse';
  code?: Maybe<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  rows: EmploymentBulkUploadRowsType;
  section: EmploymentBulkUploadSectionEnum;
};

export type EmploymentBulkUploadRowsResult = EmploymentBulkUploadRowsResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** A page of rows. The keys of every object in `items` are exactly the constants listed in `headers`, so both stay aligned without any extra mapping. No value here is translated text: the frontend resolves every constant with its own dictionary. */
export type EmploymentBulkUploadRowsType = {
  __typename?: 'EmploymentBulkUploadRowsType';
  headers: Array<Scalars['String']['output']>;
  items: Array<Scalars['JSON']['output']>;
  page: Scalars['Int']['output'];
  page_size: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Section of a validation result. Rows are classified by their code, not by a column of their own: no code is VALID, a code in the info set is INFO, anything else is ERROR. */
export enum EmploymentBulkUploadSectionEnum {
  Error = 'ERROR',
  Info = 'INFO',
  Valid = 'VALID'
}

/** Outcome of a bulk upload validation, derived from the counters — never stored as given. SUCCESS means the file can be applied as is. */
export enum EmploymentBulkUploadStatusEnum {
  Errors = 'ERRORS',
  Partial = 'PARTIAL',
  Success = 'SUCCESS'
}

/** The six counters of the standard. Info rows are counted apart from valid ones but **are applied**: they carry an automatic adjustment the admin should review, not an error. */
export type EmploymentBulkUploadSummaryType = {
  __typename?: 'EmploymentBulkUploadSummaryType';
  error_count: Scalars['Int']['output'];
  error_groups_count: Scalars['Int']['output'];
  info_count: Scalars['Int']['output'];
  info_groups_count: Scalars['Int']['output'];
  total_records: Scalars['Int']['output'];
  valid_count: Scalars['Int']['output'];
};

/** Selects which bulk upload template to generate. The same tuple the validation mutation receives alongside the file, so template and parser cannot diverge. */
export type EmploymentBulkUploadTemplateInput = {
  case: EmploymentBulkUploadCaseEnum;
  country_code: Scalars['String']['input'];
  /** Scope of the upload. Its presence makes christmas bonus days and vacation premium required. Mandatory for the MX hire template with IMSS payroll, whose employer registration column is validated against it. */
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Only meaningful for HIRE in MX: picks the with/without IMSS payroll variant of the template. */
  trigger_imss?: Scalars['Boolean']['input'];
};

export type EmploymentBulkUploadTemplateResponse = {
  __typename?: 'EmploymentBulkUploadTemplateResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentBulkUploadTemplateType;
};

export type EmploymentBulkUploadTemplateResult = EmploymentBulkUploadTemplateResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Generated bulk upload template. `content_base64` is the raw .xlsx bytes, base64-encoded — decode it to a Blob client-side to trigger the download. Nothing is persisted. The workbook carries a visible «Catalogos» sheet that feeds a dropdown on every catalog column. */
export type EmploymentBulkUploadTemplateType = {
  __typename?: 'EmploymentBulkUploadTemplateType';
  content_base64: Scalars['String']['output'];
  content_type: Scalars['String']['output'];
  file_name: Scalars['String']['output'];
};

/** Validates a bulk upload file and stages it. Writes no contract: the apply is a separate operation. The first four fields are the same tuple `generate_bulk_upload_template` receives, which is what keeps the downloaded template and the parser from diverging. */
export type EmploymentBulkUploadValidateInput = {
  case: EmploymentBulkUploadCaseEnum;
  country_code: Scalars['String']['input'];
  /** The .xlsx encoded in base64. Only .xlsx is accepted, and the content is what gets validated — not the extension. */
  file_base64: Scalars['String']['input'];
  /** Original file name, kept for the upload history. */
  file_name: Scalars['String']['input'];
  /** Scope of the upload. Every employer registration in the file is validated against it. */
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Only meaningful for HIRE in MX: picks the with/without IMSS payroll variant, and therefore which columns are expected. */
  trigger_imss?: Scalars['Boolean']['input'];
};

export type EmploymentBulkUploadValidateResponse = {
  __typename?: 'EmploymentBulkUploadValidateResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentBulkUploadValidateType;
};

export type EmploymentBulkUploadValidateResult = EmploymentBulkUploadValidateResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** What a validation produced. Nothing was written to `contract`: this is the review step, and the apply is a separate operation. */
export type EmploymentBulkUploadValidateType = {
  __typename?: 'EmploymentBulkUploadValidateType';
  file: EmploymentBulkUploadFileType;
  import_batch_id: Scalars['UUID']['output'];
  status: EmploymentBulkUploadStatusEnum;
  summary: EmploymentBulkUploadSummaryType;
};

export type EmploymentCatalogDetailType = {
  __typename?: 'EmploymentCatalogDetailType';
  catalog_group_id: Scalars['UUID']['output'];
  code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  is_active: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  sort_order: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type EmploymentCatalogGroupType = {
  __typename?: 'EmploymentCatalogGroupType';
  code: Scalars['String']['output'];
  country_code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type EmploymentCollaboratorType = {
  __typename?: 'EmploymentCollaboratorType';
  centralized_user_id: Scalars['Int']['output'];
  contract_id: Scalars['UUID']['output'];
  curp?: Maybe<Scalars['String']['output']>;
  employee_name?: Maybe<Scalars['String']['output']>;
  employer_registration_id?: Maybe<Scalars['UUID']['output']>;
  imss_contribution_base_salary?: Maybe<Scalars['Decimal']['output']>;
  imss_number?: Maybe<Scalars['String']['output']>;
  imss_registration_date?: Maybe<Scalars['Date']['output']>;
  legal_entity_id?: Maybe<Scalars['UUID']['output']>;
  user_status?: Maybe<Scalars['String']['output']>;
};

/** Spreadsheet generated at request time and returned inline. `content_base64` is the raw file bytes, base64-encoded — decode it to a Blob client-side to trigger the download. Nothing is persisted. */
export type EmploymentCollaboratorsExportType = {
  __typename?: 'EmploymentCollaboratorsExportType';
  content_base64: Scalars['String']['output'];
  content_type: Scalars['String']['output'];
  file_name: Scalars['String']['output'];
};

export type EmploymentContractAlertType = {
  __typename?: 'EmploymentContractAlertType';
  /** Dias naturales que faltan para la fecha del aviso. */
  days_remaining: Scalars['Int']['output'];
  /** Texto listo para mostrar, con la fecha y el plazo legal. */
  message: Scalars['String']['output'];
};

/** Una entrada de la auditoria: un campo que cambio de valor, con autor y momento (PAYR-582). */
export type EmploymentContractAuditEntryType = {
  __typename?: 'EmploymentContractAuditEntryType';
  changed_at: Scalars['DateTime']['output'];
  changed_by: Scalars['String']['output'];
  entity_id: Scalars['UUID']['output'];
  /** Tabla del cambio: `contract` o `mx_contract`. */
  entity_type: Scalars['String']['output'];
  field_name: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  new_value?: Maybe<Scalars['String']['output']>;
  old_value?: Maybe<Scalars['String']['output']>;
};

export type EmploymentContractHistoryEntry = {
  __typename?: 'EmploymentContractHistoryEntry';
  action: Scalars['String']['output'];
  change_blocks?: Maybe<Array<Scalars['String']['output']>>;
  change_reason?: Maybe<Scalars['String']['output']>;
  contract_id: Scalars['UUID']['output'];
  new_status: Scalars['String']['output'];
  performed_at: Scalars['DateTime']['output'];
  performed_by: Scalars['String']['output'];
  previous_status?: Maybe<Scalars['String']['output']>;
  section?: Maybe<Scalars['String']['output']>;
  /** Solo en las entradas con accion `suspended`: la causa y el periodo de esa suspension concreta. Cada episodio conserva los suyos, asi que una suspension anterior se sigue leyendo entera aunque despues haya habido otras. */
  suspension?: Maybe<EmploymentContractSuspensionType>;
  version: Scalars['Int']['output'];
};

export type EmploymentContractMutation = {
  __typename?: 'EmploymentContractMutation';
  /**
   * Applies a validated bulk upload. **Returns before anything is written**: the work is queued and runs in the background, one chunk at a time, so a thousand rows are not bounded by the request timeout. Follow it with `bulkUploadResult`, whose `progress` reports the advance and the end.
   *
   * Only one upload of the same case can be in flight per organization: a second one is rejected while the first runs. Rows that carry errors are never applied — they stay in the staging so they can be downloaded, fixed and re-uploaded.
   */
  apply_bulk_upload: EmploymentBulkUploadApplyResult;
  /** Turns a fixed-term contract into an indefinite one, keeping the recognised seniority of the original. Applies to active or expired contracts and optionally captures a new base salary, which recalculates the SBC/SDI. A future effective_date leaves the new version scheduled and the current one in force. */
  convert_contract_to_indefinite: EmploymentConvertContractToIndefiniteResult;
  /** Corrects mistyped contract data in place (PAYR-582). Does NOT create a version, does NOT show up in the contract history and does NOT induce an IMSS movement — it is a data fix, not a change of terms. Every corrected field lands in the audit trail. Only the fields sent are corrected. */
  correct_contract_data: EmploymentCorrectContractDataResult;
  /** Creates the first contract for an employee in a legal entity (or the next version if a previous one was terminated/expired), plus its Mexico extension and an induced IMSS Alta movement when the contract has a legal entity and an employer registration. That Alta carries the captured `reduced_schedule_id`, defaulting to 'jornada normal' when omitted. Requires `imss_salary_type_id` when it emits the Alta, and `christmas_bonus_days` / `vacation_premium_pct` whenever there is a legal entity. A `clabe` sent together with a `payroll_bank_id` must match the bank code. Returns a non-blocking `warnings` entry when the start date falls outside the IDSE filing window; the contract is persisted either way. Set `is_migration` to load historical records without emitting the Alta. Optionally accepts the bank certificate as a base64 PDF in `bank_certificate_file_base64`, saving the round trip to `upload_bank_certificate`: the file is validated before anything is written and uploaded in the same transaction, so a storage failure creates no contract at all. The backend still builds the storage key — the field carries the FILE, never the key. */
  create_contract: EmploymentCreateContractResult;
  /**
   * Dispatches the selected movements of one employer registration to the IMSS through the provider, and reports **what happened to each one**.
   *
   * **Irreversible.** The provider offers no cancellation or correction after the fact — it only allows retrying — and it charges per movement, so `confirmed` must be true. A movement that already went out is reported as not eligible instead of being sent twice.
   *
   * Partial success is real: the provider answers with a warning code when the file was processed *with erroneous movements inside it*, so the verdict is per movement and the batch carries no single status. A movement missing a datum the IMSS needs is held and **does not stop the others**. If the IMSS is down but the file is valid the provider queues it and returns a transaction id; that batch stays visible as queued — polling it ships with the follow-up block, not here.
   *
   * Nothing is sent when the group is blocked (no NRP, no certificate, no service user with the provider, no eligible movement), and in that case nothing is written either.
   */
  dispatch_imss_batch: EmploymentDispatchImssBatchResult;
  /** Closes the open suspension with the employee's real return date and creates a new active version. The only transition that requires the previous state to be suspended — use rehire_employee for terminated/expired contracts. Rejected when the employee already has another active contract under the same legal entity; a contract under a different one is allowed. Generates no IMSS movement. */
  reactivate_contract: EmploymentReactivateContractResult;
  /** Creates a new contract (not a new version of the previous one) for an employee whose previous contract is terminated or expired. For a contract with an employer registration it emits the IMSS Reingreso movement (code 08) and recalculates the contribution base salary — the new relationship starts with zero seniority. */
  rehire_employee: EmploymentRehireEmployeeResult;
  /** Append-only, single-purpose: only changes end_date. Applies to active or expired contracts. A renewal can only EXTEND the term, so new_end_date is required and must be later than the current one; leaving the contract without an end date is a conversion, not a renewal — use convert_contract_to_indefinite. */
  renew_contract: EmploymentRenewContractResult;
  /** Append-only — saves the legal/position section by marking the active contract as replaced and creating a new one with version+1. Replaces the fields of its section: omitting a nullable one clears it, which is how a fixed-term contract becomes indefinite. */
  save_contract_legal_info: EmploymentSaveContractLegalInfoResult;
  /** Updates salary, payment method and banking info in place (no versioning), recomputing the IMSS contribution base salary, the SDI and the daily salary with payroll's official calculator when the contract has a legal entity. Rejects with ValidationErrorResponse when the implied daily salary is below the legal minimum wage in force — nothing is persisted. */
  save_contract_salary_info: EmploymentSaveContractSalaryInfoResult;
  /** Suspends an active contract, recording the statutory cause and the period as a new version with status suspended. The cause is validated against the suspension_reason catalog group and no longer overwrites change_reason, so earlier suspensions survive intact as replaced versions. Generates no IMSS movement. Reversible via reactivate_contract. */
  suspend_contract: EmploymentSuspendContractResult;
  /** Irreversible — sets the contract status to terminated in place. For a contract with an employer registration it also emits the IMSS Baja movement (code 02) carrying the termination cause, and writes the IMSS deregistration date; termination_reason_id is required in that case. */
  terminate_contract: EmploymentTerminateContractResult;
  /** Append-only — never modifies the current active contract directly. Marks it as replaced and creates a new one with version+1. Sending `clabe` or `payroll_bank_id` validates the bank and cross-checks the merged pair (sent value, else stored) against the bank code. */
  update_contract: EmploymentUpdateContractResult;
  /** Uploads the employee's bank certificate (PDF, base64) for a contract and stores it in the service's private bucket, encrypted with KMS when `AWS_KMS_KEY_ID` is set. The backend builds the storage key from the organization and the contract and persists it on the contract's current version in the same transaction — the client never writes the key, and the three contract inputs no longer accept `s3_bank_cert_key`. Rejects anything that is not a PDF, malformed base64 or a file over 5 MB without touching the bucket or the contract row. Read it back with the `get_bank_certificate` query. */
  upload_bank_certificate: EmploymentUploadBankCertificateResult;
  /** Validates a bulk upload file and stages it row by row. **Writes no contract**: what it returns is the validation session, and the apply is a separate operation. From here on the file is never read again — the review queries read the staging. */
  validate_bulk_upload: EmploymentBulkUploadValidateResult;
};


export type EmploymentContractMutationApply_Bulk_UploadArgs = {
  input: EmploymentBulkUploadApplyInput;
};


export type EmploymentContractMutationConvert_Contract_To_IndefiniteArgs = {
  input: EmploymentConvertContractToIndefiniteInput;
};


export type EmploymentContractMutationCorrect_Contract_DataArgs = {
  input: EmploymentCorrectContractDataInput;
};


export type EmploymentContractMutationCreate_ContractArgs = {
  input: EmploymentCreateContractInput;
};


export type EmploymentContractMutationDispatch_Imss_BatchArgs = {
  input: EmploymentDispatchImssBatchInput;
};


export type EmploymentContractMutationReactivate_ContractArgs = {
  input: EmploymentReactivateContractInput;
};


export type EmploymentContractMutationRehire_EmployeeArgs = {
  input: EmploymentRehireEmployeeInput;
};


export type EmploymentContractMutationRenew_ContractArgs = {
  input: EmploymentRenewContractInput;
};


export type EmploymentContractMutationSave_Contract_Legal_InfoArgs = {
  input: EmploymentSaveContractLegalInfoInput;
};


export type EmploymentContractMutationSave_Contract_Salary_InfoArgs = {
  input: EmploymentSaveContractSalaryInfoInput;
};


export type EmploymentContractMutationSuspend_ContractArgs = {
  input: EmploymentSuspendContractInput;
};


export type EmploymentContractMutationTerminate_ContractArgs = {
  input: EmploymentTerminateContractInput;
};


export type EmploymentContractMutationUpdate_ContractArgs = {
  input: EmploymentUpdateContractInput;
};


export type EmploymentContractMutationUpload_Bank_CertificateArgs = {
  input: EmploymentUploadBankCertificateInput;
};


export type EmploymentContractMutationValidate_Bulk_UploadArgs = {
  input: EmploymentBulkUploadValidateInput;
};

export type EmploymentContractQuery = {
  __typename?: 'EmploymentContractQuery';
  /** Page 1 of the three sections of a validation result — valid rows, error groups and info groups — in one call. Use it when showing the results for the first time. Everything is read from the staging: the uploaded file is never read again, and no state travels through the client. */
  bulk_upload_result: EmploymentBulkUploadResultResult;
  /** Pages through one section of a validation result. `code` picks the group and is required for ERROR and INFO; `search` filters by email. */
  bulk_upload_rows: EmploymentBulkUploadRowsResult;
  /** Downloads the rows that failed as a correction file: the same template the batch was uploaded with, carrying only the failed rows plus the error code and the cell. Correct it and re-upload it as is — the two informational columns are ignored by the parser. Returns ValidationErrorResponse when there is nothing to download: the apply is still running, the batch had no row errors, it failed on the file format, or the rows already expired (they are kept for 7 days). */
  download_bulk_upload_errors: EmploymentDownloadBulkUploadErrorsResult;
  /** Generates the IMSS collaborator roster (name, NSS, status, CURP, current SBC, registration date, employer registration number) in the requested format and returns it base64-encoded. Honours the same legal_entity_id and search filters as list_collaborators, so the file matches what the user sees. Pure generation at request time; nothing is uploaded or persisted. Returns ValidationErrorResponse when there is no data to export or the result exceeds the row limit. */
  export_collaborators: EmploymentExportCollaboratorsResult;
  /** Generates the bulk upload template for a (case, country, legal entity, trigger_imss) tuple — the same tuple the validation mutation receives alongside the file, so the template and the parser cannot diverge. Returns the .xlsx in base64; nothing is persisted. */
  generate_bulk_upload_template: EmploymentBulkUploadTemplateResult;
  /** Returns the active contract for an employee in a legal entity. */
  get_active_contract: EmploymentGetActiveContractResult;
  /** Returns the contract's bank certificate with the PDF bytes base64-encoded and the file name to download it with. Decode `content_base64` to a Blob client-side; no presigned URL is issued. `result` is null — inside a successful response, not an error — when the contract has no certificate uploaded yet. The organization is resolved from the contract row and the session, so another organization's contract is rejected without returning any bytes. */
  get_bank_certificate: EmploymentGetBankCertificateResult;
  /** Returns IMSS-facing data for one employee's active, MX-extended contract by centralized_user_id: name, imss_number, CURP, current SBC, employer registration and user status. */
  get_collaborator: EmploymentGetCollaboratorResult;
  /** Returns any version of a contract by id, regardless of status (active, replaced, terminated, suspended, expired). */
  get_contract: EmploymentGetContractResult;
  /** Returns salary, payment method and banking info for the active contract. */
  get_contract_salary_info: EmploymentGetContractSalaryInfoResult;
  /** Aggregated IMSS movement counters for a legal entity: pending, sent, accepted and rejected (all-time, on the movement status), plus altas and bajas year-to-date. A legal entity with no movements returns every counter at zero, not an error. */
  get_movement_stats: EmploymentGetMovementStatsResult;
  /** The organization's bulk upload history, newest first: who uploaded which file, when, for which case, and how it came out. Covers every lifecycle state — an abandoned validation also has a row, and also has error rows to download. Every counter is read from the batch header, so it stays true after the staging sweep empties the rows. */
  list_bulk_upload_batches: EmploymentListBulkUploadBatchesResult;
  /** Lists catalog details, optionally filtered by catalog_group_id. */
  list_catalog_details: EmploymentListCatalogDetailsResult;
  /** Lists catalog groups, optionally filtered by country_code and/or code — both filters are independent and can be combined. */
  list_catalog_groups: EmploymentListCatalogGroupsResult;
  /** Lists active, MX-extended contracts under legal_entity_id with IMSS-facing employee data (imss_number, current SBC, registration date, employer registration, user status, CURP), optionally filtered by a search term matching the employee name or their NSS (imss_number). */
  list_collaborators: EmploymentListCollaboratorsResult;
  /** Field-by-field audit trail of an employee's contract data (PAYR-582): which value changed, who changed it and when, newest first. Spans every version of the lineage and its MX extensions, and unlike list_contract_history it also includes corrections, which do not version. Kept for five years. */
  list_contract_audit_trail: EmploymentListContractAuditTrailResult;
  /** Returns a timeline of discrete events (created, updated, renewed, rehired, terminated, suspended, reactivated) reconstructed from the contract's versioned rows, newest first. */
  list_contract_history: EmploymentListContractHistoryResult;
  /** Resolves an employment scope — legal entities, work centres — into the distinct centralized_user_id of every active contract inside it. This is the ids-only counterpart of `list_contracts`: the caller wants a set of employees to narrow a read that knows nothing about contracts, not the contracts themselves. `work_center_ids` matches on the MX extension, so a contract without one never matches it. Omitting **both** filters returns an empty list, not the whole organization: no scope means 'do not filter by person', and materialising the entire payroll to say so would be the expensive way to say nothing. An empty list in either filter also returns no ids — it is a filter that cannot match, not the absence of a filter. */
  list_contract_user_ids: EmploymentListContractUserIdsResult;
  /** Returns every version (active, replaced, terminated, suspended, expired) of an employee's contract, newest first. `mx_contract` is always null on each item — use `get_contract` for a specific version's full detail. */
  list_contract_versions: EmploymentListContractVersionsResult;
  /** Lists every active contract under legal_entity_id, each with its `mx_contract` extension resolved, in a single batch read. This is the entry point for consumers that process a whole legal entity per run (e.g. the payroll engine) instead of fanning out one `get_active_contract` per employee. Only active contracts are returned — use `list_contract_versions` for an employee's history. `mx_contract` is null for contracts without an MX extension. */
  list_contracts: EmploymentListContractsResult;
  /** Lists every country, optionally filtered by is_active. */
  list_countries: EmploymentListCountriesResult;
  /** Lists legal minimum vacation-day rule brackets by seniority, optionally filtered by country_code. */
  list_country_vacation_rules: EmploymentListCountryVacationRulesResult;
  /** Lists legal max-weekly-hours rules, optionally filtered by country_code. */
  list_country_work_hours_rules: EmploymentListCountryWorkHoursRulesResult;
  /** Lists the IMSS movement audit trail (status transitions) for every movement across all contracts of this employee, newest first. */
  list_imss_movement_history: EmploymentListImssMovementHistoryResult;
  /** Lists IDSE submission attempts — what was sent to IDSE and what it answered — **scoped to the caller's organization**, optionally filtered by `movement_id`, `idse_status` and/or `outcome`. The `outcome` filter is the only way to find the attempts whose result is unknown: their `idse_status` is the same as a clean send's, and they must be verified with the provider before any resend. */
  list_imss_movement_idse_submissions: EmploymentListImssMovementIdseSubmissionsResult;
  /** IMSS movements tray for a legal entity: **every** movement of the roster in all four statuses — including rejected ones, which are the ones needing action — with employee name, imss_number, the movement key, the contribution-base-salary pair already resolved for that key and the NRP of the employer registration it was filed under. Optional filters: a search term matching the employee name or their NSS, plus three multi-value filters — statuses, movement_types and employer_registration_ids. The last one is what isolates the batch that goes to the IDSE, which is assembled per employer registration and not per legal entity. Within one filter the values are OR; between filters they are AND. Omitting a filter, sending null or sending an empty list all mean the same: no narrowing. The single-value forms (status, movement_type, employer_registration_id) are deprecated but still honoured; if a client sends a singular and its plural together, a non-empty plural wins. Paginated (default page 1, page_size 10), newest movement_date first, with total_count describing the whole filtered set. The operation keeps its PAYR-448 name for compatibility even though it is no longer restricted to pending movements. */
  list_pending_imss_movements: EmploymentListPendingImssMovementsResult;
  /** Paginated IMSS roster for a legal entity: every active, MX-extended contract with NSS, CURP, current SBC, registration date and employer registration, plus the employee's IMSS movement history embedded. Optionally filtered by a search term matching the employee name or their NSS, by one or more employee statuses in the organization, and by one or more employer registrations — the latter matched against the contract's employer registration, which is the same id each row returns and NOT the column list_pending_imss_movements filters on. Within one filter the values are OR; between filters they are AND. Omitting a filter, sending null or sending an empty list all mean the same: no narrowing. The single-value employee_status is deprecated but still honoured; if both it and employee_statuses are sent, a non-empty plural wins. */
  list_registered_employees: EmploymentListRegisteredEmployeesResult;
  /** Returns the daily salary a monthly base salary yields, with no contract involved: `base_salary / 30`, quantized to two decimals (ROUND_HALF_UP). It is the same figure create_contract persists, and the one the SBC reported to the IMSS is built from — the hiring wizard shows it while the amount is still being typed, so requiring an existing contract would defeat the purpose. Echoes `base_salary` back so a debounced caller can discard the answer to an earlier keystroke. Does NOT return the SDI/SBC: that needs payroll's parameters for the legal entity and date plus the recognized seniority, none of which a preview has. Reads nothing — no database session is opened. */
  preview_daily_salary: EmploymentPreviewDailySalaryResult;
  /** Dispatch preview for a selection of IMSS movements: how many would go out, how many stay behind and why, **grouped by employer registration** — the provider receives one employer registration per submission, so a selection spanning several produces several batches. Read-only: nothing is persisted and no call is made to the IDSE provider. Each movement lands in exactly one of three buckets. `eligible` is what would be filed, in the same order the file will be written. `held` is what is missing a datum the IMSS needs, with **every** missing datum listed and not just the first. `not_eligible` is what its status rules out — already sent, already accepted, rejected pending correction — which is not the same as incomplete. A group also carries `blocking_reasons`: what belongs to the employer registration rather than to any movement (no NRP, no IDSE service user, no e.firma certificate, or nothing dispatchable). `dispatchable` is true only when that list is empty. Selected ids that do not exist or belong elsewhere come back in `unknown_movement_ids` instead of failing the call. Because nothing is persisted, the verdict is recomputed on every call — a movement whose missing datum was since captured becomes eligible again on its own. */
  preview_imss_batch_dispatch: EmploymentPreviewImssBatchDispatchResult;
};


export type EmploymentContractQueryBulk_Upload_ResultArgs = {
  input: EmploymentBulkUploadResultInput;
};


export type EmploymentContractQueryBulk_Upload_RowsArgs = {
  input: EmploymentBulkUploadRowsInput;
};


export type EmploymentContractQueryDownload_Bulk_Upload_ErrorsArgs = {
  input: EmploymentDownloadBulkUploadErrorsInput;
};


export type EmploymentContractQueryExport_CollaboratorsArgs = {
  input: EmploymentExportCollaboratorsInput;
};


export type EmploymentContractQueryGenerate_Bulk_Upload_TemplateArgs = {
  input: EmploymentBulkUploadTemplateInput;
};


export type EmploymentContractQueryGet_Active_ContractArgs = {
  input: EmploymentGetActiveContractInput;
};


export type EmploymentContractQueryGet_Bank_CertificateArgs = {
  input: EmploymentGetBankCertificateInput;
};


export type EmploymentContractQueryGet_CollaboratorArgs = {
  input: EmploymentGetCollaboratorInput;
};


export type EmploymentContractQueryGet_ContractArgs = {
  input: EmploymentGetContractInput;
};


export type EmploymentContractQueryGet_Contract_Salary_InfoArgs = {
  input: EmploymentGetContractSalaryInfoInput;
};


export type EmploymentContractQueryGet_Movement_StatsArgs = {
  input: EmploymentGetMovementStatsInput;
};


export type EmploymentContractQueryList_Bulk_Upload_BatchesArgs = {
  input: EmploymentListBulkUploadBatchesInput;
};


export type EmploymentContractQueryList_Catalog_DetailsArgs = {
  input: EmploymentListCatalogDetailsInput;
};


export type EmploymentContractQueryList_Catalog_GroupsArgs = {
  input: EmploymentListCatalogGroupsInput;
};


export type EmploymentContractQueryList_CollaboratorsArgs = {
  input: EmploymentListCollaboratorsInput;
};


export type EmploymentContractQueryList_Contract_Audit_TrailArgs = {
  input: EmploymentListContractAuditTrailInput;
};


export type EmploymentContractQueryList_Contract_HistoryArgs = {
  input: EmploymentListContractHistoryInput;
};


export type EmploymentContractQueryList_Contract_User_IdsArgs = {
  input: EmploymentListContractUserIdsInput;
};


export type EmploymentContractQueryList_Contract_VersionsArgs = {
  input: EmploymentListContractVersionsInput;
};


export type EmploymentContractQueryList_ContractsArgs = {
  input: EmploymentListContractsInput;
};


export type EmploymentContractQueryList_CountriesArgs = {
  input: EmploymentListCountriesInput;
};


export type EmploymentContractQueryList_Country_Vacation_RulesArgs = {
  input: EmploymentListCountryVacationRulesInput;
};


export type EmploymentContractQueryList_Country_Work_Hours_RulesArgs = {
  input: EmploymentListCountryWorkHoursRulesInput;
};


export type EmploymentContractQueryList_Imss_Movement_HistoryArgs = {
  input: EmploymentListImssMovementHistoryInput;
};


export type EmploymentContractQueryList_Imss_Movement_Idse_SubmissionsArgs = {
  input: EmploymentListImssMovementIdseSubmissionsInput;
};


export type EmploymentContractQueryList_Pending_Imss_MovementsArgs = {
  input: EmploymentListPendingImssMovementsInput;
};


export type EmploymentContractQueryList_Registered_EmployeesArgs = {
  input: EmploymentListRegisteredEmployeesInput;
};


export type EmploymentContractQueryPreview_Daily_SalaryArgs = {
  input: EmploymentPreviewDailySalaryInput;
};


export type EmploymentContractQueryPreview_Imss_Batch_DispatchArgs = {
  input: EmploymentPreviewImssBatchDispatchInput;
};

export type EmploymentContractSalaryInfoType = {
  __typename?: 'EmploymentContractSalaryInfoType';
  bank_account_type_id?: Maybe<Scalars['UUID']['output']>;
  base_salary: Scalars['Decimal']['output'];
  clabe?: Maybe<Scalars['String']['output']>;
  daily_salary: Scalars['Decimal']['output'];
  id: Scalars['UUID']['output'];
  imss_salary_type_id?: Maybe<Scalars['UUID']['output']>;
  number_account_bank?: Maybe<Scalars['String']['output']>;
  payment_method_id: Scalars['UUID']['output'];
  payroll_bank_id?: Maybe<Scalars['UUID']['output']>;
  salary_type_id: Scalars['UUID']['output'];
  sar_bank_id?: Maybe<Scalars['UUID']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

/** One active contract reduced to the two fields a filter needs: who, and under which razon social. An employee with active contracts in two legal entities appears twice. */
export type EmploymentContractScopeItemType = {
  __typename?: 'EmploymentContractScopeItemType';
  centralized_user_id: Scalars['Int']['output'];
  legal_entity_id?: Maybe<Scalars['UUID']['output']>;
};

/** Contract lifecycle status. */
export enum EmploymentContractStatusEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Replaced = 'REPLACED',
  Scheduled = 'SCHEDULED',
  Suspended = 'SUSPENDED',
  Terminated = 'TERMINATED'
}

export type EmploymentContractSuspensionType = {
  __typename?: 'EmploymentContractSuspensionType';
  /** Fecha real de reincorporacion. Nula mientras el episodio sigue abierto; se estampa al reactivar. */
  actual_return_date?: Maybe<Scalars['Date']['output']>;
  /** Fecha prevista de fin, si se capturo. Es un pronostico: la reincorporacion real puede caer despues. */
  expected_end_date?: Maybe<Scalars['Date']['output']>;
  /** Fecha de inicio de la suspension. */
  start_date: Scalars['Date']['output'];
  /** Causa de la suspension, del grupo de catalogo `suspension_reason` (Art. 42 de la LFT en Mexico). */
  suspension_reason_id: Scalars['UUID']['output'];
};

export type EmploymentContractType = {
  __typename?: 'EmploymentContractType';
  bank_account_type_id?: Maybe<Scalars['UUID']['output']>;
  base_salary: Scalars['Decimal']['output'];
  centralized_organization_id: Scalars['String']['output'];
  centralized_user_id: Scalars['Int']['output'];
  change_blocks?: Maybe<Array<Scalars['String']['output']>>;
  change_reason?: Maybe<Scalars['String']['output']>;
  /** Aviso derivado de que el contrato esta por vencer, nulo cuando no aplica. Se calcula al leer y no bloquea ninguna operacion. Nulo en un contrato por tiempo indeterminado, en uno que no rige hoy y en uno cuyo vencimiento cae fuera de la ventana de aviso. */
  contract_expiry_alert?: Maybe<EmploymentContractAlertType>;
  contract_type_id: Scalars['UUID']['output'];
  country_code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by: Scalars['String']['output'];
  currency_id: Scalars['UUID']['output'];
  /** Fecha desde la que aplican los terminos de esta version. Nulo en las versiones creadas antes de PAYR-582, que no tienen una fecha de vigencia real que declarar. */
  effective_date?: Maybe<Scalars['Date']['output']>;
  end_date?: Maybe<Scalars['Date']['output']>;
  has_payroll: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  is_pays_overtime: Scalars['Boolean']['output'];
  is_unionized: Scalars['Boolean']['output'];
  labor_regime_id: Scalars['UUID']['output'];
  legal_entity_id?: Maybe<Scalars['UUID']['output']>;
  mx_contract?: Maybe<EmploymentMxContractType>;
  number_account_bank?: Maybe<Scalars['String']['output']>;
  pay_frequency_id: Scalars['UUID']['output'];
  payment_method_id: Scalars['UUID']['output'];
  payroll_bank_id?: Maybe<Scalars['UUID']['output']>;
  previous_contract_id?: Maybe<Scalars['UUID']['output']>;
  /** Inicio reconocido de la relacion laboral. Se conserva entre versiones aunque `start_date` cambie y solo se reinicia al recontratar. Es el dato del que se derivan los anos de antiguedad que integran el SBC. */
  recognized_seniority_date: Scalars['Date']['output'];
  s3_bank_cert_key?: Maybe<Scalars['String']['output']>;
  salary_type_id: Scalars['UUID']['output'];
  shift_hours?: Maybe<Scalars['Int']['output']>;
  shift_type_id: Scalars['UUID']['output'];
  start_date: Scalars['Date']['output'];
  status: EmploymentContractStatusEnum;
  status_changed_at?: Maybe<Scalars['DateTime']['output']>;
  status_changed_by?: Maybe<Scalars['String']['output']>;
  /** Episodio de suspension de esta version, nulo cuando no la hubo. En la version vigente indica que el contrato esta suspendido y desde cuando; en una version reemplazada documenta una suspension ya cerrada, con su fecha real de reincorporacion. */
  suspension?: Maybe<EmploymentContractSuspensionType>;
  termination_date?: Maybe<Scalars['Date']['output']>;
  termination_reason_id?: Maybe<Scalars['UUID']['output']>;
  /** Aviso derivado de que el periodo de prueba o de capacitacion inicial esta por terminar, nulo cuando no aplica. Es INDEPENDIENTE de `contract_expiry_alert`: un contrato de prueba a punto de acabar dispara los dos, y cada uno pide una decision distinta. Se infiere de que la duracion del contrato coincida con los plazos de 3 o 6 meses de ley. */
  trial_period_alert?: Maybe<EmploymentContractAlertType>;
  union_id?: Maybe<Scalars['UUID']['output']>;
  updated_at: Scalars['DateTime']['output'];
  vacation_days?: Maybe<Scalars['Int']['output']>;
  version: Scalars['Int']['output'];
};

export type EmploymentConvertContractToIndefiniteInput = {
  /** Sueldo nuevo, si la conversion viene acompanada de uno. Omitirlo conserva el vigente y no recalcula el SBC. Es lo unico que esta operacion captura: prestaciones y datos bancarios van por `update_contract`. */
  base_salary?: InputMaybe<Scalars['Decimal']['input']>;
  centralized_user_id: Scalars['Int']['input'];
  contract_id: Scalars['UUID']['input'];
  /** Tipo de contrato destino, del grupo `contract_type`. Se envia en vez de resolverse solo porque el codigo del indeterminado es del catalogo mexicano y esta operacion sirve a cualquier pais. Borrar la fecha de fin sin moverlo dejaria la fila declarandose por tiempo determinado. */
  contract_type_id: Scalars['UUID']['input'];
  /** Fecha desde la que el contrato es indeterminado. Omitirla usa el dia siguiente al vencimiento. Admite retroactividad hasta la vigencia de la version actual, pero no puede dejar hueco despues del vencimiento: una interrupcion real es un reingreso (`rehire_employee`), que reinicia la antiguedad en vez de conservarla. */
  effective_date?: InputMaybe<Scalars['Date']['input']>;
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type EmploymentConvertContractToIndefiniteResponse = {
  __typename?: 'EmploymentConvertContractToIndefiniteResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentContractType;
  /** Avisos no bloqueantes de la operacion (PAYR-582). Hoy: la fecha de vigencia quedo fuera del plazo de presentacion ante el IMSS. La operacion se persistio igual. */
  warnings: Array<Scalars['String']['output']>;
};

export type EmploymentConvertContractToIndefiniteResult = EmploymentConvertContractToIndefiniteResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Correccion de datos mal capturados de un contrato (PAYR-582). Solo los campos enviados se corrigen. No crea version, no aparece en el historico de cambios de condiciones y no genera movimiento IMSS: para un cambio pactado usa update_contract. */
export type EmploymentCorrectContractDataInput = {
  bank_account_type_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Corregir el sueldo recalcula el SBC, el SDI y el salario diario: un sueldo mal capturado deja esas tres cifras desfasadas. */
  base_salary?: InputMaybe<Scalars['Decimal']['input']>;
  clabe?: InputMaybe<Scalars['String']['input']>;
  /** Version del contrato a corregir. Puede ser la vigente o una programada. */
  contract_id: Scalars['UUID']['input'];
  contract_type_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Moneda del contrato. Corregible SOLO por aca (PAYR-600): ninguna otra escritura la aceptaba, asi que una moneda mal elegida en el alta era permanente. No entra al camino versionado porque elegir mal la moneda es un error de captura, no un cambio pactado. */
  currency_id?: InputMaybe<Scalars['UUID']['input']>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  has_payroll?: InputMaybe<Scalars['Boolean']['input']>;
  /** NSS: 11 numeric digits whose last digit is a valid Luhn check digit. Required when the contract has both a legal entity and an employer registration — it identifies the employee in the IMSS affiliation movement filed at the IDSE. Sent as-is: surrounding whitespace is rejected, not trimmed. An empty string counts as not sent. */
  imss_number?: InputMaybe<Scalars['String']['input']>;
  is_unionized?: InputMaybe<Scalars['Boolean']['input']>;
  labor_regime_id?: InputMaybe<Scalars['UUID']['input']>;
  number_account_bank?: InputMaybe<Scalars['String']['input']>;
  /** Frecuencia de pago de la nomina. Corregible desde PAYR-600, igual que en `update_contract`. */
  pay_frequency_id?: InputMaybe<Scalars['UUID']['input']>;
  payment_method_id?: InputMaybe<Scalars['UUID']['input']>;
  payroll_bank_id?: InputMaybe<Scalars['UUID']['input']>;
  salary_type_id?: InputMaybe<Scalars['UUID']['input']>;
  sar_bank_id?: InputMaybe<Scalars['UUID']['input']>;
  shift_hours?: InputMaybe<Scalars['Int']['input']>;
  shift_type_id?: InputMaybe<Scalars['UUID']['input']>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
};

export type EmploymentCorrectContractDataResponse = {
  __typename?: 'EmploymentCorrectContractDataResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentContractType;
};

export type EmploymentCorrectContractDataResult = EmploymentCorrectContractDataResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type EmploymentCountryType = {
  __typename?: 'EmploymentCountryType';
  code: Scalars['String']['output'];
  has_country_extension: Scalars['Boolean']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
};

export type EmploymentCountryVacationRuleType = {
  __typename?: 'EmploymentCountryVacationRuleType';
  country_code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  entitled_days: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  is_active: Scalars['Boolean']['output'];
  max_seniority_years?: Maybe<Scalars['Int']['output']>;
  min_seniority_years: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type EmploymentCountryWorkHoursRuleType = {
  __typename?: 'EmploymentCountryWorkHoursRuleType';
  country_code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  is_active: Scalars['Boolean']['output'];
  max_weekly_hours: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type EmploymentCreateContractInput = {
  absence_integration?: Scalars['Boolean']['input'];
  bank_account_type_id?: InputMaybe<Scalars['UUID']['input']>;
  /** PDF del certificado bancario en base64, opcional. Ahorra el viaje extra a `upload_bank_certificate`: el alta queda con su respaldo en una sola peticion y de forma atomica, porque si S3 falla el contrato no se crea. Mismas reglas que esa mutation —firma de PDF y maximo 5 MB ya decodificado— y la misma llave, que construye el backend: aca viaja el ARCHIVO, nunca la ruta, que es justo la distincion que PAYR-637 hizo obligatoria. Omitirlo crea el contrato sin certificado y se adjunta despues. */
  bank_certificate_file_base64?: InputMaybe<Scalars['String']['input']>;
  base_salary: Scalars['Decimal']['input'];
  centralized_user_id: Scalars['Int']['input'];
  /** Dias de aguinaldo del contrato. Minimo legal 15 (LFT MX Art. 87). Obligatorio cuando el contrato tiene razon social, porque es insumo del factor de integracion del SBC. Sin razon social puede omitirse y queda nulo. */
  christmas_bonus_days?: InputMaybe<Scalars['Int']['input']>;
  clabe?: InputMaybe<Scalars['String']['input']>;
  contract_type_id: Scalars['UUID']['input'];
  country_code: Scalars['String']['input'];
  currency_id: Scalars['UUID']['input'];
  employer_registration_id?: InputMaybe<Scalars['UUID']['input']>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  /** Indica si el contrato entra a nomina. Flag manual: no se valida ni se deriva de `legal_entity_id`. Omitirlo guarda `false`. */
  has_payroll?: Scalars['Boolean']['input'];
  hiring_regime_id?: InputMaybe<Scalars['UUID']['input']>;
  imss_employee_type_id?: InputMaybe<Scalars['UUID']['input']>;
  /** NSS: 11 numeric digits whose last digit is a valid Luhn check digit. Required when the contract has both a legal entity and an employer registration — it identifies the employee in the IMSS affiliation movement filed at the IDSE. Sent as-is: surrounding whitespace is rejected, not trimmed. An empty string counts as not sent. */
  imss_number?: InputMaybe<Scalars['String']['input']>;
  imss_registration_date?: InputMaybe<Scalars['Date']['input']>;
  imss_salary_type_id?: InputMaybe<Scalars['UUID']['input']>;
  imss_shift_type_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Carga inicial de historico: el contrato se guarda SIN generar el movimiento de Alta ante el IMSS y sin la advertencia de retroactividad. Para trabajadores que ya estan inscritos, cuya Alta se presento fuera de esta plataforma; generarla llenaria la bandeja del IDSE de movimientos que nadie debe enviar. No cambia nada mas: el contrato, su extension mexicana y el SBC se calculan y se guardan igual. Sobre un contrato sin registro patronal no tiene efecto, porque ese no genera movimiento de todos modos. */
  is_migration?: Scalars['Boolean']['input'];
  is_pays_overtime?: Scalars['Boolean']['input'];
  is_unionized?: Scalars['Boolean']['input'];
  labor_regime_id: Scalars['UUID']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
  number_account_bank?: InputMaybe<Scalars['String']['input']>;
  pay_frequency_id: Scalars['UUID']['input'];
  payment_method_id: Scalars['UUID']['input'];
  payroll_bank_id?: InputMaybe<Scalars['UUID']['input']>;
  pension_type_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Inicio reconocido de la relacion laboral. Omitirlo la iguala a `start_date`, o sea 'sin antiguedad previa reconocida'. No puede ser posterior a `start_date`. Es insumo del factor de integracion del SBC: omitirlo cuando SI hay antiguedad reconocida subdeclara el SBC ante el IMSS. */
  recognized_seniority_date?: InputMaybe<Scalars['Date']['input']>;
  /** Jornada reducida con la que se presenta el movimiento de Alta ante el IDSE. Se valida contra el grupo `reduced_schedule` del pais. Omitirlo presenta 'jornada normal' como valor por omision, no como captura del usuario. NO se guarda en el contrato: describe el movimiento, asi que solo es consultable a traves de este. Si el contrato no tiene registro patronal no genera movimiento y el valor se valida y se descarta. */
  reduced_schedule_id?: InputMaybe<Scalars['UUID']['input']>;
  salary_type_id: Scalars['UUID']['input'];
  sar_bank_id?: InputMaybe<Scalars['UUID']['input']>;
  shift_hours?: InputMaybe<Scalars['Int']['input']>;
  shift_type_id: Scalars['UUID']['input'];
  start_date: Scalars['Date']['input'];
  union_id?: InputMaybe<Scalars['UUID']['input']>;
  vacation_days?: InputMaybe<Scalars['Int']['input']>;
  /** Prima vacacional como PORCENTAJE: 25.00 significa 25%, no 0.25. Minimo legal 25 (LFT MX Art. 80). Obligatorio cuando el contrato tiene razon social, porque es insumo del factor de integracion del SBC. Sin razon social puede omitirse y queda nulo. */
  vacation_premium_pct?: InputMaybe<Scalars['Decimal']['input']>;
  work_center_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type EmploymentCreateContractResponse = {
  __typename?: 'EmploymentCreateContractResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentContractType;
  /** Avisos no bloqueantes de la operacion (PAYR-581). Hoy: la fecha de inicio quedo fuera del plazo de presentacion ante el IMSS. La operacion se persistio igual. Vacio cuando el contrato no presenta movimiento —sin razon social, sin registro patronal o cargado con `is_migration`— porque entonces no le corre plazo. */
  warnings: Array<Scalars['String']['output']>;
};

export type EmploymentCreateContractResult = EmploymentCreateContractResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Salario diario derivado de un sueldo mensual, sin contrato de por medio (PAYR-600). */
export type EmploymentDailySalaryPreviewType = {
  __typename?: 'EmploymentDailySalaryPreviewType';
  /** El sueldo mensual recibido, devuelto tal cual. Sirve para descartar la respuesta de una pulsacion anterior cuando la pantalla llama con debounce. */
  base_salary: Scalars['Decimal']['output'];
  /** `base_salary / 30`, cuantizado a dos decimales con ROUND_HALF_UP. Es exactamente la cifra que `create_contract` persiste, y de ahi sale el SBC que se reporta al IMSS. No es el SDI. */
  daily_salary: Scalars['Decimal']['output'];
};

/**
 * Dispatches the selected movements of **one** employer registration to the IMSS through the provider. Irreversible: the provider offers no cancellation and charges per movement, so `confirmed` must be true and a batch that already went out cannot go out again.
 *
 * The selection is **re-classified at dispatch** and the preview's verdict is not a permit: between the screen and the button another admin may have corrected a contract or the nightly may have generated a new movement. Only movements that are eligible **and** complete at this moment reach the file; the rest are reported back, held or not eligible, and nothing about them is written.
 */
export type EmploymentDispatchImssBatchInput = {
  /** Must be **true** or the call is rejected without touching the provider. It is not a formality: the submission cannot be cancelled or corrected afterwards — the provider only allows retrying — so a human confirmation is the last point at which this is still undoable. */
  confirmed?: Scalars['Boolean']['input'];
  /** The employer registration this batch is filed under. **Required, and one per call**: the provider receives `registroPatronal` in the singular, so a batch with two employer registrations is not a big batch, it is two badly-assembled ones. Selected movements belonging to another employer registration are reported as unknown, not merged in. Dispatch each preview group with its own call. */
  employer_registration_id: Scalars['UUID']['input'];
  /** Legal entity the selected movements belong to. */
  legal_entity_id: Scalars['UUID']['input'];
  /** Ids of the selected movements. Duplicates are collapsed, so the same id sent twice is one movement. Rejected when empty or over the cap of 1000, which is the file's own limit. */
  movement_ids: Array<Scalars['UUID']['input']>;
};

/**
 * The result of dispatching one employer registration's batch.
 *
 * `batch_id` null means **no batch was ever composed**: the selection was blocked before the provider was touched, so there is no submission to speak of. With `batch_id` set the file went out — or was attempted — and the row proving it exists.
 *
 * `failure` null with `batch_id` set is the send that went through. Both set is a provider failure, already classified: the batch is on record and the movements are available again.
 */
export type EmploymentDispatchImssBatchResponse = {
  __typename?: 'EmploymentDispatchImssBatchResponse';
  batch_id?: Maybe<Scalars['UUID']['output']>;
  /** Non-empty means nothing was sent and nothing was written. Reasons accumulate, so a group can lack a certificate *and* have no dispatchable movement. */
  blocking_reasons: Array<EmploymentImssDispatchBlockType>;
  /** One entry per movement in the file, with its own verdict. */
  dispatched: Array<EmploymentImssDispatchedMovementType>;
  /** How many movements actually reached the file. */
  dispatched_count: Scalars['Int']['output'];
  employer_registration_id: Scalars['UUID']['output'];
  /**
   * `PROVIDER_REJECTED` — ours and correctable (bad format, expired certificate). `PROVIDER_UNAVAILABLE` — the provider or the IMSS were down **and the file provably never went out**; retry later. `PROVIDER_ERROR` — a provider fault or a cause we cannot attribute; escalate. In those three the movements stay available for a new attempt, which is a **new batch** — retries are manual and there are no automatic ones.
   *
   * `PROVIDER_OUTCOME_UNKNOWN` is the exception and the one to read carefully: the request was written and the answer was lost, so the provider may have processed the whole file. **Those movements do not come back to the tray.** Verify with the provider before deciding — a blind resend can charge twice and file the same movement at the IMSS twice.
   */
  failure?: Maybe<Scalars['String']['output']>;
  failure_message?: Maybe<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  /** Selected movements kept out because a datum the IMSS needs is missing. **They do not stop the others** (DEC-3.2): against a legal deadline, one worker with a missing field must not make the whole company non-compliant. */
  held: Array<EmploymentImssHeldMovementType>;
  /** Batch id the IMSS assigns. **Acknowledgement of receipt, not of registration** — the provider says so in its own documentation. */
  id_lote?: Maybe<Scalars['String']['output']>;
  /** Set when the IMSS was down and the provider queued the file. Such a batch stays visible as queued: **polling it is not in this cut**, it ships with the follow-up block. */
  id_transaccion?: Maybe<Scalars['String']['output']>;
  /** Response entries that could not be attributed to any movement of the batch. **In a healthy submission this is zero**: a non-zero count means the provider returned something unexpected or our mapping has a bug. They are stored, never discarded — losing what the IMSS said about a movement that can no longer be resent has no later remedy. */
  incident_count: Scalars['Int']['output'];
  /** Selected movements that cannot be dispatched for reasons other than missing data — most often because they already went out. This is also what makes a second dispatch of the same selection a no-op instead of a double charge. */
  not_eligible: Array<EmploymentImssNotEligibleMovementType>;
  provider_message?: Maybe<Scalars['String']['output']>;
  /** The provider's own code for the submission. `0` success, `9` **processed with erroneous movements inside**, negative values failures. Note the sign does not mean the same thing on other endpoints of this provider. */
  provider_result_code?: Maybe<Scalars['Int']['output']>;
  total_selected: Scalars['Int']['output'];
  /** Selected ids that do not exist, belong to another organization, another legal entity, **or another employer registration**. */
  unknown_movement_ids: Array<Scalars['UUID']['output']>;
};

export type EmploymentDispatchImssBatchResult = EmploymentDispatchImssBatchResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Downloads the rows that failed, as a correction file. Only the batch is needed: case, country, legal entity and `trigger_imss` are read from the header, which is what guarantees the file carries exactly the columns the admin uploaded. */
export type EmploymentDownloadBulkUploadErrorsInput = {
  import_batch_id: Scalars['UUID']['input'];
};

export type EmploymentDownloadBulkUploadErrorsResponse = {
  __typename?: 'EmploymentDownloadBulkUploadErrorsResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentBulkUploadErrorFileType;
};

export type EmploymentDownloadBulkUploadErrorsResult = EmploymentDownloadBulkUploadErrorsResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type EmploymentExportCollaboratorsInput = {
  /** Output file format: CSV or XLSX. */
  file_format?: EmploymentSpreadsheetFormat;
  /** Legal entity whose collaborator roster is exported. */
  legal_entity_id: Scalars['UUID']['input'];
  /** Optional search term. Matches the employee name (case-insensitive, resolved against centralized-users) or their NSS (partial match on imss_number). A blank value is treated as no search. The exported file honours this term, so it matches exactly what the user sees on screen. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type EmploymentExportCollaboratorsResponse = {
  __typename?: 'EmploymentExportCollaboratorsResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentCollaboratorsExportType;
};

export type EmploymentExportCollaboratorsResult = EmploymentExportCollaboratorsResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type EmploymentGetActiveContractInput = {
  centralized_user_id: Scalars['Int']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type EmploymentGetActiveContractResponse = {
  __typename?: 'EmploymentGetActiveContractResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentContractType;
};

export type EmploymentGetActiveContractResult = EmploymentGetActiveContractResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Recupera el certificado bancario de un contrato, con el contenido en base64. La organizacion se resuelve desde la fila y la sesion. */
export type EmploymentGetBankCertificateInput = {
  /** Contrato cuyo certificado bancario se quiere leer. */
  contract_id: Scalars['UUID']['input'];
};

export type EmploymentGetBankCertificateResponse = {
  __typename?: 'EmploymentGetBankCertificateResponse';
  graphql_operation_id: Scalars['ID']['output'];
  /** Nulo cuando el contrato existe pero todavia no tiene certificado subido. Es un estado normal y por eso viaja como respuesta exitosa: distinguirlo de un error no deberia obligar al cliente a leer un mensaje. */
  result?: Maybe<EmploymentBankCertificateType>;
};

export type EmploymentGetBankCertificateResult = EmploymentGetBankCertificateResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse;

export type EmploymentGetCollaboratorInput = {
  centralized_user_id: Scalars['Int']['input'];
};

export type EmploymentGetCollaboratorResponse = {
  __typename?: 'EmploymentGetCollaboratorResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentCollaboratorType;
};

export type EmploymentGetCollaboratorResult = EmploymentGetCollaboratorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse;

export type EmploymentGetContractInput = {
  centralized_user_id: Scalars['Int']['input'];
  contract_id: Scalars['UUID']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type EmploymentGetContractResponse = {
  __typename?: 'EmploymentGetContractResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentContractType;
};

export type EmploymentGetContractResult = EmploymentGetContractResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse;

export type EmploymentGetContractSalaryInfoInput = {
  centralized_user_id: Scalars['Int']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type EmploymentGetContractSalaryInfoResponse = {
  __typename?: 'EmploymentGetContractSalaryInfoResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentContractSalaryInfoType;
};

export type EmploymentGetContractSalaryInfoResult = EmploymentGetContractSalaryInfoResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse;

export type EmploymentGetMovementStatsInput = {
  /** Legal entity whose IMSS movement counters are aggregated. */
  legal_entity_id: Scalars['UUID']['input'];
};

export type EmploymentGetMovementStatsResponse = {
  __typename?: 'EmploymentGetMovementStatsResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentImssMovementStatsType;
};

export type EmploymentGetMovementStatsResult = EmploymentGetMovementStatsResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse;

/** The batch that would go out for one employer registration, plus what stays behind. There is one group per employer registration because the provider receives `registroPatronal` in the singular: a batch with two employer registrations is not a big batch, it is two badly-assembled ones. Each group carries its own verdict — a blocked one does not block the others. */
export type EmploymentImssBatchDispatchGroupType = {
  __typename?: 'EmploymentImssBatchDispatchGroupType';
  /** Empty when the batch can be dispatched. Reasons accumulate: a group can lack a certificate *and* have no dispatchable movement, and learning about one problem per trip is what this breakdown exists to avoid. */
  blocking_reasons: Array<EmploymentImssDispatchBlockType>;
  /** True only when blocking_reasons is empty. It is derived from that list and not stored beside it, so the two cannot contradict each other. */
  dispatchable: Scalars['Boolean']['output'];
  /** Ordered by (movement_date, movement_type_code, imss_number, id) — the same order the file will be written in. */
  eligible: Array<EmploymentImssEligibleMovementType>;
  eligible_count: Scalars['Int']['output'];
  employer_registration_id: Scalars['UUID']['output'];
  /** NRP of the employer registration (11 characters), resolved against payroll. Null both when payroll has none on file and when it could not be reached — and either way the group is not dispatchable, because the NRP is what the submission is filed with. **Which of the two it was is in `blocking_reasons`**: EMPLOYER_REGISTRATION_NUMBER_MISSING is the admin's to fix, EMPLOYER_REGISTRATION_UNVERIFIED is ours. */
  employer_registration_number?: Maybe<Scalars['String']['output']>;
  /** Ordered by the same key as `eligible`. Here the order promises nothing about the file — nothing in this bucket reaches it — only that two identical calls come back the same way, so the screen does not reshuffle the rows between refreshes while the admin is reviewing what stays behind. */
  held: Array<EmploymentImssHeldMovementType>;
  held_count: Scalars['Int']['output'];
  /** Ordered by the same key, for the same stability reason. */
  not_eligible: Array<EmploymentImssNotEligibleMovementType>;
  not_eligible_count: Scalars['Int']['output'];
};

/** One thing the movement is missing before it can be filed with the IMSS. A held movement carries **one entry per missing datum**, not just the first one found — sending the admin to fix one field only to find another missing on their return is one trip per datum. */
export type EmploymentImssCompletenessIssueType = {
  __typename?: 'EmploymentImssCompletenessIssueType';
  /** Stable identifier of the missing datum, e.g. NSS_MISSING, CONTRIBUTION_BASE_SALARY_MISSING, TERMINATION_REASON_MISSING. **Deliberately a String and not an enum**: this vocabulary grows with every field the IDSE layout spec turns out to require, and adding a value to an output enum breaks clients that treat it exhaustively. Treat an unknown code as a generic "incomplete data" message, never as an error. The current set is documented in docs/graphql/queries/preview_imss_batch_dispatch.md. */
  code: Scalars['String']['output'];
  /** Human-readable Spanish description of what is missing. */
  detail: Scalars['String']['output'];
  /** Name of the field to capture, as the person who captures it knows it — this is what lets the screen take the admin to the right input. */
  field: Scalars['String']['output'];
};

/** Why the whole batch of one employer registration cannot be dispatched. This is what belongs to the **employer registration** and not to any movement — its NRP, its IDSE service user, its certificate — so it blocks the batch without holding anyone: marking forty movements as incomplete over a datum that is in none of them would send the admin to fix forty contracts for a problem that lives somewhere else. The fix lives in step 3 of the employer registration wizard. */
export type EmploymentImssDispatchBlockType = {
  __typename?: 'EmploymentImssDispatchBlockType';
  /** EMPLOYER_REGISTRATION_UNRESOLVED, TERRA_USER_MISSING, CERTIFICATE_MISSING, CREDENTIALS_UNKNOWN or NO_ELIGIBLE_MOVEMENTS. CERTIFICATE_MISSING and CREDENTIALS_UNKNOWN are two codes on purpose: "you have no certificate" is the admin's work and "we could not verify your certificate" is ours, so the message cannot be the same. */
  code: Scalars['String']['output'];
  /** Human-readable Spanish reason. */
  detail: Scalars['String']['output'];
};

/** What the provider said about one movement of the dispatched batch. **The verdict is per movement and not per batch, deliberately**: the provider answers `9` when the file was processed *with erroneous movements inside it*, so partial success exists and a single batch status would have to lie about half of them. */
export type EmploymentImssDispatchedMovementType = {
  __typename?: 'EmploymentImssDispatchedMovementType';
  error_code?: Maybe<Scalars['String']['output']>;
  error_detail?: Maybe<Scalars['String']['output']>;
  /** `PROVIDER` when the intermediary caught it **before** the IMSS, so the movement never reached the institute and can be corrected and resent without having spent a charge. `IMSS` when the institute itself rejected it. The difference is what decides whether fixing it costs money. */
  error_source?: Maybe<Scalars['String']['output']>;
  movement_id: Scalars['UUID']['output'];
  /** `sent` — received by the IMSS. **Acknowledgement of receipt, not of registration**: the provider states that an IdLote only means the movements arrived. `queued` — the IMSS was down and the provider held the file. `duplicate` — the provider already had it; needs a human decision, it is not discarded on its own. `format_error` — the provider caught it and it **never reached the IMSS**, so it can be corrected and resent without having spent a movement. `imss_rejected` — the IMSS rejected it, with its reason. `submission_failed` — the send itself failed and the movement is available again. `unknown` — **the request went out and the answer was lost**; the movement stays in flight and does NOT return to the tray, because resending something the IMSS may already hold would duplicate a charge that cannot be undone. Verify with the provider before acting on it. */
  outcome: Scalars['String']['output'];
};

/** A selected movement that will be included in the batch. It carries no sequence number on purpose: the ordinal inside the file is assigned by whoever writes the file, not here. What this preview does guarantee is the **order** — promising an ordinal it does not control would turn the only key that maps format errors back to a movement into a lie. */
export type EmploymentImssEligibleMovementType = {
  __typename?: 'EmploymentImssEligibleMovementType';
  centralized_user_id: Scalars['Int']['output'];
  /** Null when the identity service no longer has that person, or when it could not be reached. **The name does gate the dispatch verdict**: the IMSS file requires the surname and given names, so a person with no name on record is held with `EMPLOYEE_NAME_MISSING`, and a batch whose names could not be looked up is blocked with `EMPLOYEE_NAMES_UNVERIFIED`. */
  employee_name?: Maybe<Scalars['String']['output']>;
  imss_number?: Maybe<Scalars['String']['output']>;
  movement_date?: Maybe<Scalars['Date']['output']>;
  movement_id: Scalars['UUID']['output'];
  /** Official IMSS layout key: 08, 07 or 02. */
  movement_type_code?: Maybe<Scalars['String']['output']>;
};

/** A selected movement held out of the batch because a datum the IMSS needs is missing. It is **not** persisted as held: the verdict is computed on every call, which is why a movement whose missing datum was since captured becomes eligible again on its own. */
export type EmploymentImssHeldMovementType = {
  __typename?: 'EmploymentImssHeldMovementType';
  centralized_user_id: Scalars['Int']['output'];
  employee_name?: Maybe<Scalars['String']['output']>;
  imss_number?: Maybe<Scalars['String']['output']>;
  /** Every missing datum, not just the first one. */
  issues: Array<EmploymentImssCompletenessIssueType>;
  movement_date?: Maybe<Scalars['Date']['output']>;
  movement_id: Scalars['UUID']['output'];
  movement_type_code?: Maybe<Scalars['String']['output']>;
};

/** Why a movement cannot be dispatched even though nothing is missing from it: its status says it already went out or is already closed. **Not incompleteness** — asking the admin to complete a movement that already reached the IMSS would send them looking for a datum that is already there. */
export type EmploymentImssIneligibilityReasonType = {
  __typename?: 'EmploymentImssIneligibilityReasonType';
  /** ALREADY_IN_PROCESS, ALREADY_ACCEPTED, REJECTED_NEEDS_CORRECTION or DELETED. */
  code: Scalars['String']['output'];
  /** Human-readable Spanish reason. */
  detail: Scalars['String']['output'];
};

/** Aggregated IMSS movement counters for one legal entity. The four status counters read `status` (the movement lifecycle), not `idse_status`, and are all-time — they are a live backlog, not a period cut. */
export type EmploymentImssMovementStatsType = {
  __typename?: 'EmploymentImssMovementStatsType';
  /** Movements accepted by IMSS (status accepted). */
  accepted_count: Scalars['Int']['output'];
  /** Altas registered in the current calendar year, by movement_date. Includes Reingresos: both share catalog code 08 and the catalog does not tell them apart. */
  altas_ytd: Scalars['Int']['output'];
  /** Bajas registered in the current calendar year, by movement_date (catalog code 02). */
  bajas_ytd: Scalars['Int']['output'];
  /** Movements awaiting submission (status pending_submission). */
  pending_count: Scalars['Int']['output'];
  /** Movements rejected by IMSS (status rejected). */
  rejected_count: Scalars['Int']['output'];
  /** Movements already sent and awaiting an answer (status in_process). */
  sent_count: Scalars['Int']['output'];
};

/** IMSS movement / IDSE submission status. */
export enum EmploymentImssMovementStatusEnum {
  Accepted = 'ACCEPTED',
  InProcess = 'IN_PROCESS',
  PendingSubmission = 'PENDING_SUBMISSION',
  Rejected = 'REJECTED'
}

/** IMSS movement type, by its official SUA layout key. ALTA_REINGRESO covers both a first registration and a rehire: before the IMSS they are the same movement (key 08), so filtering by it returns both. */
export enum EmploymentImssMovementTypeEnum {
  AltaReingreso = 'ALTA_REINGRESO',
  Baja = 'BAJA',
  ModificacionSalario = 'MODIFICACION_SALARIO'
}

/** A selected movement that cannot be dispatched, and **not because data is missing** — nothing needs completing here. Either its status rules it out (it already went to the IMSS, it is closed, or it was rejected and needs correcting first), or its movement key is one this service does not submit yet. See `reason.code`. */
export type EmploymentImssNotEligibleMovementType = {
  __typename?: 'EmploymentImssNotEligibleMovementType';
  centralized_user_id: Scalars['Int']['output'];
  employee_name?: Maybe<Scalars['String']['output']>;
  imss_number?: Maybe<Scalars['String']['output']>;
  movement_date?: Maybe<Scalars['Date']['output']>;
  movement_id: Scalars['UUID']['output'];
  movement_type_code?: Maybe<Scalars['String']['output']>;
  reason: EmploymentImssIneligibilityReasonType;
  /** The movement's lifecycle status. It is what rules the movement out in most cases, but not always: a movement excluded because its key is not submitted yet is still `pending_submission`. `reason.code` is the authoritative answer. */
  status: Scalars['String']['output'];
};

/** Filters the bulk upload history. Both filters are optional and combine with AND; leaving both out returns every upload of the organization, newest first. The history covers **every** lifecycle state, not only the applied ones: in this service the batch header is written when the file is validated, so an abandoned validation also has a row — and also has error rows its author may still need to download. */
export type EmploymentListBulkUploadBatchesInput = {
  /** Keeps only the uploads of this case. */
  case?: InputMaybe<EmploymentBulkUploadCaseEnum>;
  /** Keeps only the uploads in this lifecycle state. Not to be confused with the validation status: a batch can be `SUCCESS` and still be `VALIDATED` — that is, never applied. */
  lifecycle?: InputMaybe<EmploymentBulkUploadLifecycleEnum>;
  /** Pagination configuration. Default: page 1, page_size 10. */
  pagination?: InputMaybe<EmploymentOffsetPaginationInput>;
};

export type EmploymentListBulkUploadBatchesResponse = {
  __typename?: 'EmploymentListBulkUploadBatchesResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<EmploymentBulkUploadBatchType>;
  total_count: Scalars['Int']['output'];
};

export type EmploymentListBulkUploadBatchesResult = EmploymentListBulkUploadBatchesResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type EmploymentListCatalogDetailsInput = {
  catalog_group_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type EmploymentListCatalogDetailsResponse = {
  __typename?: 'EmploymentListCatalogDetailsResponse';
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<EmploymentCatalogDetailType>;
  total_count: Scalars['Int']['output'];
};

export type EmploymentListCatalogDetailsResult = EmploymentListCatalogDetailsResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse;

export type EmploymentListCatalogGroupsInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
};

export type EmploymentListCatalogGroupsResponse = {
  __typename?: 'EmploymentListCatalogGroupsResponse';
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<EmploymentCatalogGroupType>;
  total_count: Scalars['Int']['output'];
};

export type EmploymentListCatalogGroupsResult = EmploymentListCatalogGroupsResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse;

export type EmploymentListCollaboratorsInput = {
  /** Legal entity whose registered collaborators are listed. */
  legal_entity_id: Scalars['UUID']['input'];
  /** Optional search term. Matches the employee name (case-insensitive, resolved against centralized-users) or their NSS (partial match on imss_number). A blank value is treated as no search. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type EmploymentListCollaboratorsResponse = {
  __typename?: 'EmploymentListCollaboratorsResponse';
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<EmploymentCollaboratorType>;
  total_count: Scalars['Int']['output'];
};

export type EmploymentListCollaboratorsResult = EmploymentListCollaboratorsResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse;

/** Auditoria campo por campo de un empleado (PAYR-582): que valor cambio, quien lo cambio y cuando. Incluye las correcciones, que no aparecen en el historico de contratos. */
export type EmploymentListContractAuditTrailInput = {
  centralized_user_id: Scalars['Int']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Pagination configuration. Default: page 1, page_size 10. */
  pagination?: InputMaybe<EmploymentOffsetPaginationInput>;
};

export type EmploymentListContractAuditTrailResponse = {
  __typename?: 'EmploymentListContractAuditTrailResponse';
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<EmploymentContractAuditEntryType>;
  total_count: Scalars['Int']['output'];
};

export type EmploymentListContractAuditTrailResult = EmploymentListContractAuditTrailResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse;

export type EmploymentListContractHistoryInput = {
  centralized_user_id: Scalars['Int']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
};

export type EmploymentListContractHistoryResponse = {
  __typename?: 'EmploymentListContractHistoryResponse';
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<EmploymentContractHistoryEntry>;
  total_count: Scalars['Int']['output'];
};

export type EmploymentListContractHistoryResult = EmploymentListContractHistoryResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse;

/** Employment scope to resolve into the employees inside it. Both filters are optional, but omitting **both** returns an empty list rather than the whole organization: no scope means 'do not filter by person', which the caller expresses by not calling this at all. */
export type EmploymentListContractUserIdsInput = {
  /** Narrow the answer to these employees. Reading the query in the opposite direction: with this filter alone, `items` tells you **which legal entity each of these employees belongs to** — which is how a consumer displays the razon social of a row without keeping its own copy of the employment record. Omit for no filter; an empty list returns nothing. */
  centralized_user_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Legal entities (razones sociales) to resolve. Omit for no filter; an empty list returns no ids. */
  legal_entity_ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Pay frequencies (periodicidad de pago) to resolve, matched against the contract's own `pay_frequency_id`. Ids come from the `pay_frequency` catalog group — see list_catalog_details. This is the **contract's** frequency, the one agreed with each employee; it is not the payroll periodicity, which belongs to a payroll type and owns the periods. Omit for no filter; an empty list returns no ids. */
  pay_frequency_ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Work centres to resolve, matched against the MX extension. A contract without an MX extension has no work centre and therefore never matches this filter. Omit for no filter; an empty list returns no ids. */
  work_center_ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** The employees inside the requested employment scope, in two shapes for two uses. `centralized_user_ids` is the deduplicated set, to narrow another read. `items` keeps the legal entity of each contract, to label a row with its razon social. `total_count` sizes the set — not `items`, which can be longer when someone holds two active contracts. */
export type EmploymentListContractUserIdsResponse = {
  __typename?: 'EmploymentListContractUserIdsResponse';
  centralized_user_ids: Array<Scalars['Int']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<EmploymentContractScopeItemType>;
  total_count: Scalars['Int']['output'];
};

export type EmploymentListContractUserIdsResult = EmploymentListContractUserIdsResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse;

export type EmploymentListContractVersionsInput = {
  centralized_user_id: Scalars['Int']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type EmploymentListContractVersionsResponse = {
  __typename?: 'EmploymentListContractVersionsResponse';
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<EmploymentContractType>;
  total_count: Scalars['Int']['output'];
};

export type EmploymentListContractVersionsResult = EmploymentListContractVersionsResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse;

export type EmploymentListContractsInput = {
  /** Optional subset of employees to return. Omit it to get every active contract in the legal entity; an empty list returns no items. */
  centralized_user_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Legal entity whose active contracts are listed. */
  legal_entity_id: Scalars['UUID']['input'];
};

export type EmploymentListContractsResponse = {
  __typename?: 'EmploymentListContractsResponse';
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<EmploymentContractType>;
  total_count: Scalars['Int']['output'];
};

export type EmploymentListContractsResult = EmploymentListContractsResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse;

export type EmploymentListCountriesInput = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmploymentListCountriesResponse = {
  __typename?: 'EmploymentListCountriesResponse';
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<EmploymentCountryType>;
  total_count: Scalars['Int']['output'];
};

export type EmploymentListCountriesResult = EmploymentListCountriesResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse;

export type EmploymentListCountryVacationRulesInput = {
  country_code?: InputMaybe<Scalars['String']['input']>;
};

export type EmploymentListCountryVacationRulesResponse = {
  __typename?: 'EmploymentListCountryVacationRulesResponse';
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<EmploymentCountryVacationRuleType>;
  total_count: Scalars['Int']['output'];
};

export type EmploymentListCountryVacationRulesResult = EmploymentListCountryVacationRulesResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse;

export type EmploymentListCountryWorkHoursRulesInput = {
  country_code?: InputMaybe<Scalars['String']['input']>;
};

export type EmploymentListCountryWorkHoursRulesResponse = {
  __typename?: 'EmploymentListCountryWorkHoursRulesResponse';
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<EmploymentCountryWorkHoursRuleType>;
  total_count: Scalars['Int']['output'];
};

export type EmploymentListCountryWorkHoursRulesResult = EmploymentListCountryWorkHoursRulesResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse;

export type EmploymentListImssMovementHistoryInput = {
  centralized_user_id: Scalars['Int']['input'];
};

export type EmploymentListImssMovementHistoryResponse = {
  __typename?: 'EmploymentListImssMovementHistoryResponse';
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<EmploymentMxImssMovementAuditType>;
  total_count: Scalars['Int']['output'];
};

export type EmploymentListImssMovementHistoryResult = EmploymentListImssMovementHistoryResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse;

export type EmploymentListImssMovementIdseSubmissionsInput = {
  idse_status?: InputMaybe<Scalars['String']['input']>;
  movement_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Filters by the attempt's verdict. **The way to find the movements that need a human**: `unknown` (the request went out and the answer was lost — verify with the provider before resending) carries the same `idse_status` as a clean send, so without this filter those movements are indistinguishable. */
  outcome?: InputMaybe<Scalars['String']['input']>;
};

export type EmploymentListImssMovementIdseSubmissionsResponse = {
  __typename?: 'EmploymentListImssMovementIdseSubmissionsResponse';
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<EmploymentMxImssMovementIdseSubmissionType>;
  total_count: Scalars['Int']['output'];
};

export type EmploymentListImssMovementIdseSubmissionsResult = EmploymentListImssMovementIdseSubmissionsResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse;

export type EmploymentListPendingImssMovementsInput = {
  /** Optional filter on the employer registrations the movements were filed under, matched against `mx_imss_movements.employer_registration_id` — the same id each row returns in `movement.employer_registration_id`. A legal entity can hold several, and the IDSE batch is assembled per employer registration — this is what isolates one batch. Takes ids, not NRPs: the NRP lives in payroll. Several values are **OR** between themselves and **AND** against every other filter; a repeated id is one filter value, not two. Omitting it, sending `null` or sending an empty list are all the same thing: **no filter**, every employer registration of the legal entity is returned. An id that does not belong to this legal entity (or does not exist) is never an error: it simply matches nothing, so a mixed list keeps filtering by the valid ids and an all-alien list returns an empty page with total_count 0. At most 100 distinct values are honoured: the list is de-duplicated keeping the order sent and anything past the 100th value is dropped rather than rejected — a list longer than that is asking for a superset of what exists, never for a narrower filter. */
  employer_registration_ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Legal entity whose IMSS movements are listed. */
  legal_entity_id: Scalars['UUID']['input'];
  /** Optional filter on the IMSS movement type, by its layout key, matched against the catalog key of the movement type. Several values are **OR** between themselves and **AND** against every other filter. ALTA_REINGRESO returns both first registrations and rehires — they share key 08. Omitting it, sending `null` or sending an empty list are all the same thing: **no filter**, every type is returned. At most 100 distinct values are honoured: the list is de-duplicated keeping the order sent and anything past the 100th value is dropped rather than rejected — a list longer than that is asking for a superset of what exists, never for a narrower filter. */
  movement_types?: InputMaybe<Array<EmploymentImssMovementTypeEnum>>;
  /** Pagination configuration. Default: page 1, page_size 10. */
  pagination?: InputMaybe<EmploymentOffsetPaginationInput>;
  /** Optional search term. Matches the employee name (case-insensitive, resolved against centralized-users) or their NSS (partial match on imss_number). A blank value is treated as no search. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Optional filter on the movement lifecycle status, matched against `mx_imss_movements.status`. Several values are **OR** between themselves and **AND** against every other filter of this input. Omitting it, sending `null` or sending an empty list are all the same thing: **no filter** — the tray returns the four statuses (pending_submission, in_process, accepted and rejected) with no implicit narrowing. An empty list never means 'return nothing', deliberately unlike EmploymentListContractUserIdsInput, which resolves an explicit scope instead of narrowing one. Filters `status`, not `idse_status`: see list_imss_movement_idse_submissions for the IDSE channel. At most 100 distinct values are honoured: the list is de-duplicated keeping the order sent and anything past the 100th value is dropped rather than rejected — a list longer than that is asking for a superset of what exists, never for a narrower filter. */
  statuses?: InputMaybe<Array<EmploymentImssMovementStatusEnum>>;
};

export type EmploymentListPendingImssMovementsResponse = {
  __typename?: 'EmploymentListPendingImssMovementsResponse';
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<EmploymentPendingImssMovementType>;
  total_count: Scalars['Int']['output'];
};

export type EmploymentListPendingImssMovementsResult = EmploymentListPendingImssMovementsResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse;

export type EmploymentListRegisteredEmployeesInput = {
  /** Optional filter on the employee's status in the organization. Resolved against centralized-users before paging, so total_count already reflects it. Several values are **OR** between themselves and **AND** against every other filter. Omitting it, sending `null` or sending an empty list are all the same thing: **no filter**, every status is returned. At most 100 distinct values are honoured: the list is de-duplicated keeping the order sent and anything past the 100th value is dropped rather than rejected — a list longer than that is asking for a superset of what exists, never for a narrower filter. */
  employee_statuses?: InputMaybe<Array<EmploymentUserOrganizationStatusEnum>>;
  /** Optional filter on the employer registrations of the roster, matched against the **contract's** employer registration (`mx_contract.employer_registration_id`) — the same id each row returns in `employer_registration_id`. Note this is a different column from the one list_pending_imss_movements filters: the roster's grain is the active contract and its employer registration **today**, while a movement stays filed under the one in force when it was filed. An employee whose employer registration changed therefore appears in the roster under the new one while their old movements stay under the old one. A contract with **no** employer registration drops out of the roster while this filter is present (the column is nullable and a NULL matches no id) and is returned when it is absent. Several values are **OR** between themselves and **AND** against every other filter; a repeated id is one filter value. Omitting it, sending `null` or sending an empty list are all the same thing: **no filter**. An id outside this legal entity (or one that does not exist) is never an error — it simply matches nothing, so a mixed list keeps filtering by the valid ids and an all-alien list returns an empty page with total_count 0. At most 100 distinct values are honoured: the list is de-duplicated keeping the order sent and anything past the 100th value is dropped rather than rejected — a list longer than that is asking for a superset of what exists, never for a narrower filter. */
  employer_registration_ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Legal entity whose IMSS roster is listed. */
  legal_entity_id: Scalars['UUID']['input'];
  /** Pagination configuration. Default: page 1, page_size 10. */
  pagination?: InputMaybe<EmploymentOffsetPaginationInput>;
  /** Optional search term. Matches the employee name (case-insensitive, resolved against centralized-users) or their NSS (partial match on imss_number). A blank value is treated as no search. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type EmploymentListRegisteredEmployeesResponse = {
  __typename?: 'EmploymentListRegisteredEmployeesResponse';
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<EmploymentRegisteredEmployeeType>;
  total_count: Scalars['Int']['output'];
};

export type EmploymentListRegisteredEmployeesResult = EmploymentListRegisteredEmployeesResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse;

export type EmploymentMxContractType = {
  __typename?: 'EmploymentMxContractType';
  absence_integration: Scalars['Boolean']['output'];
  /** Dias de aguinaldo otorgados por el contrato. Minimo legal 15 (LFT MX Art. 87); mejorable por contrato. Nulo cuando el dato no fue capturado: el motor de nomina falla nombrando el campo en lugar de asumir el minimo. */
  christmas_bonus_days?: Maybe<Scalars['Int']['output']>;
  clabe?: Maybe<Scalars['String']['output']>;
  contract_id: Scalars['UUID']['output'];
  created_at: Scalars['DateTime']['output'];
  daily_salary?: Maybe<Scalars['Decimal']['output']>;
  employer_registration_id?: Maybe<Scalars['UUID']['output']>;
  hiring_regime_id?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  imss_contribution_base_salary?: Maybe<Scalars['Decimal']['output']>;
  imss_deregistration_date?: Maybe<Scalars['Date']['output']>;
  imss_employee_type_id?: Maybe<Scalars['UUID']['output']>;
  imss_number?: Maybe<Scalars['String']['output']>;
  imss_registration_date?: Maybe<Scalars['Date']['output']>;
  imss_salary_type_id?: Maybe<Scalars['UUID']['output']>;
  imss_shift_type_id?: Maybe<Scalars['UUID']['output']>;
  pension_type_id?: Maybe<Scalars['UUID']['output']>;
  sar_bank_id?: Maybe<Scalars['UUID']['output']>;
  sdi?: Maybe<Scalars['Decimal']['output']>;
  updated_at: Scalars['DateTime']['output'];
  /** Prima vacacional como PORCENTAJE: 25.00 significa 25%, no 0.25. Minimo legal 25 (LFT MX Art. 80); mejorable por contrato. Nulo cuando el dato no fue capturado. */
  vacation_premium_pct?: Maybe<Scalars['Decimal']['output']>;
  work_center_id?: Maybe<Scalars['UUID']['output']>;
};

export type EmploymentMxImssMovementAuditType = {
  __typename?: 'EmploymentMxImssMovementAuditType';
  action: Scalars['String']['output'];
  from_status?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  movement_id: Scalars['UUID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  performed_at: Scalars['DateTime']['output'];
  performed_by: Scalars['String']['output'];
  to_status: Scalars['String']['output'];
};

export type EmploymentMxImssMovementIdseSubmissionType = {
  __typename?: 'EmploymentMxImssMovementIdseSubmissionType';
  attempt_number: Scalars['Int']['output'];
  /** The submission this attempt belonged to. */
  batch_id?: Maybe<Scalars['UUID']['output']>;
  error_code?: Maybe<Scalars['String']['output']>;
  error_detail?: Maybe<Scalars['String']['output']>;
  /** `PROVIDER` when the intermediary caught it before the IMSS, so correcting it costs nothing; `IMSS` when the institute itself rejected it. */
  error_source?: Maybe<Scalars['String']['output']>;
  exported_at?: Maybe<Scalars['DateTime']['output']>;
  guia?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  idse_status: Scalars['String']['output'];
  movement_id: Scalars['UUID']['output'];
  /** The attempt's verdict. `unknown` is the one to watch: **the request went out and the answer was lost**, so the movement may already be filed at the IMSS. Verify with the provider before resending — its `idse_status` looks identical to a clean send. */
  outcome?: Maybe<Scalars['String']['output']>;
  sent_at?: Maybe<Scalars['DateTime']['output']>;
  /** Which line of the file this movement was written on. It is how a format error, which the provider reports by line number and nothing else, gets traced back here. */
  sequence_number?: Maybe<Scalars['Int']['output']>;
};

export type EmploymentMxImssMovementType = {
  __typename?: 'EmploymentMxImssMovementType';
  centralized_organization_id: Scalars['String']['output'];
  contract_id: Scalars['UUID']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_by?: Maybe<Scalars['String']['output']>;
  /** Ultimo dia habil para presentar el aviso ante el IDSE. Cinco dias habiles despues del movimiento (LFT Art. 74 para los descansos obligatorios), salvo la modificacion de salario VARIABLE, que vence el quinto dia habil del mes de reporte del bimestre y puede caer hasta dos meses despues del cambio. */
  due_end_at: Scalars['Date']['output'];
  /** Fecha del movimiento: desde cuando rige. En el alta, la baja y la modificacion de salario FIJO coincide con el inicio del plazo de presentacion. En la modificacion de salario VARIABLE no: ese aviso se presenta dentro del mes de reporte del bimestre (LSS Art. 34 fracc. III), asi que aqui la fecha es anterior a cuando el aviso puede presentarse. No usar este campo como inicio de la ventana. */
  due_start_at: Scalars['Date']['output'];
  employer_registration_id: Scalars['UUID']['output'];
  employer_worker_code?: Maybe<Scalars['String']['output']>;
  event_origin_id?: Maybe<Scalars['UUID']['output']>;
  event_origin_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  idse_status: EmploymentImssMovementStatusEnum;
  /** Contribution base salary declared by this movement. Its meaning depends on the movement key: on 08 and 07 it is the **new** figure, on 02 it is the one the employee was actually contributing on. Use the already-resolved pair on EmploymentPendingImssMovementType instead of re-deriving it. */
  imss_contribution_base_salary?: Maybe<Scalars['Decimal']['output']>;
  imss_employee_type_id?: Maybe<Scalars['UUID']['output']>;
  imss_salary_type_id?: Maybe<Scalars['UUID']['output']>;
  movement_date: Scalars['Date']['output'];
  movement_type_id: Scalars['UUID']['output'];
  origin: Scalars['String']['output'];
  /** Contribution base salary in force **before** this movement, frozen when the movement was generated. Only the salary modification (07) writes it — 08 has no previous figure and on 02 the previous figure is the column above. Null on every movement generated before PAYR-635: the value did not exist anywhere and cannot be backfilled. */
  previous_imss_contribution_base_salary?: Maybe<Scalars['Decimal']['output']>;
  reason_detail_id?: Maybe<Scalars['UUID']['output']>;
  reduced_schedule_id?: Maybe<Scalars['UUID']['output']>;
  status: EmploymentImssMovementStatusEnum;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** Offset pagination, shared by every list operation of this subgraph: 1-based `page`, `page_size` items each. Responses report `total_count` over the whole filtered set, not over the page, so the client can derive the number of pages. */
export type EmploymentOffsetPaginationInput = {
  /** Page number (1-based). */
  page?: Scalars['Int']['input'];
  /** Items per page. Clamped to the 1..100 range so a malformed value cannot turn into an unbounded scan. */
  page_size?: Scalars['Int']['input'];
};

/** One row of the IMSS movements tray: the movement, the employee it belongs to, and the contribution-base-salary pair already resolved for the movement's key. */
export type EmploymentPendingImssMovementType = {
  __typename?: 'EmploymentPendingImssMovementType';
  centralized_user_id: Scalars['Int']['output'];
  employee_name?: Maybe<Scalars['String']['output']>;
  /** NRP of the employer registration this movement was filed under (11 characters, e.g. B5401234567) — the value the user recognises. Resolved against payroll, which owns it; the id itself is movement.employer_registration_id. Null when payroll failed or does not know that id: the row is still returned, only without the number. */
  employer_registration_number?: Maybe<Scalars['String']['output']>;
  imss_number?: Maybe<Scalars['String']['output']>;
  movement: EmploymentMxImssMovementType;
  /** Official IMSS layout key of the movement: 08 (alta/reingreso), 07 (salary modification) or 02 (baja). Null only if the movement's catalog row no longer exists. Resolve its label with list_catalog_details on the movement_type group. */
  movement_type_code?: Maybe<Scalars['String']['output']>;
  /** Contribution base salary **after** the movement, already resolved for its key: the declared figure on 08 and 07, and null on 02 — a terminated employee stops contributing. */
  new_imss_contribution_base_salary?: Maybe<Scalars['Decimal']['output']>;
  /** Contribution base salary **before** the movement, already resolved for its key: null on 08 (a registration has no previous figure), the persisted previous figure on 07, and the stored one on 02 (what the employee was contributing on when they left). Null means *no previous figure to declare* — it is not the same as 0.00. */
  previous_imss_contribution_base_salary?: Maybe<Scalars['Decimal']['output']>;
};

/** Insumo de `preview_daily_salary`. Un solo campo: la operacion corre antes del alta, asi que no puede pedir contrato ni empleado. */
export type EmploymentPreviewDailySalaryInput = {
  /** Sueldo mensual bruto tal como se captura en el formulario. Debe ser mayor que cero: cero o negativo devuelve `ValidationErrorResponse`, el mismo invariante que aplica `create_contract`. */
  base_salary: Scalars['Decimal']['input'];
};

export type EmploymentPreviewDailySalaryResponse = {
  __typename?: 'EmploymentPreviewDailySalaryResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentDailySalaryPreviewType;
};

export type EmploymentPreviewDailySalaryResult = EmploymentPreviewDailySalaryResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** The selection the admin marked for dispatch. `movement_ids` is **required and must not be empty**: there is no "empty means everything pending". A human decides before an irreversible act, and an implicit default that dispatches everything is exactly the accident that decision exists to prevent — build "select all" from the tray query instead. Duplicates are collapsed, so the same id sent twice is one movement. */
export type EmploymentPreviewImssBatchDispatchInput = {
  /** Legal entity the selected movements belong to. A movement of another legal entity is reported as unknown, not as an error. */
  legal_entity_id: Scalars['UUID']['input'];
  /** Ids of the selected movements. Rejected with a validation error when empty or over the per-call cap (1000). That cap protects the query; the provider's own batch limit is undocumented and gets fixed when the dispatch itself is built. */
  movement_ids: Array<Scalars['UUID']['input']>;
};

export type EmploymentPreviewImssBatchDispatchResponse = {
  __typename?: 'EmploymentPreviewImssBatchDispatchResponse';
  graphql_operation_id: Scalars['ID']['output'];
  /** One per employer registration, ordered by id. */
  groups: Array<EmploymentImssBatchDispatchGroupType>;
  /** How many distinct movement ids the selection carried. `total_selected == len(unknown_movement_ids) + the sum of the three buckets across every group` is an identity, and it is what guarantees no selected movement is dropped silently. */
  total_selected: Scalars['Int']['output'];
  /** Selected ids that do not exist, belong to another organization or to another legal entity. Reported instead of failing the whole call: making the admin guess which of two hundred ids is stale would be worse than telling them. */
  unknown_movement_ids: Array<Scalars['UUID']['output']>;
};

export type EmploymentPreviewImssBatchDispatchResult = EmploymentPreviewImssBatchDispatchResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Reincorporacion de un contrato suspendido (PAYR-584). Cierra el episodio abierto y crea una version nueva con estatus `active`. */
export type EmploymentReactivateContractInput = {
  centralized_user_id: Scalars['Int']['input'];
  contract_id: Scalars['UUID']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Fecha real de reincorporacion. No puede ser anterior al inicio de la suspension. Cierra el episodio y es la vigencia de la version que vuelve a regir. */
  return_date: Scalars['Date']['input'];
};

export type EmploymentReactivateContractResponse = {
  __typename?: 'EmploymentReactivateContractResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentContractType;
};

export type EmploymentReactivateContractResult = EmploymentReactivateContractResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** One row of the IMSS roster: the active contract's IMSS-facing data plus the employee's embedded movement history. */
export type EmploymentRegisteredEmployeeType = {
  __typename?: 'EmploymentRegisteredEmployeeType';
  /** Employee id in centralized-users. */
  centralized_user_id: Scalars['Int']['output'];
  /** Active contract backing this roster row. */
  contract_id: Scalars['UUID']['output'];
  /** CURP, only when the user's identification document is of that type — centralized-users stores one generic document per user. */
  curp?: Maybe<Scalars['String']['output']>;
  /** Full name from centralized-users. Null only when that service no longer has the user. */
  employee_name?: Maybe<Scalars['String']['output']>;
  /** Employer registration (registro patronal) id. */
  employer_registration_id?: Maybe<Scalars['UUID']['output']>;
  /** Current SBC (salario base de cotizacion). */
  imss_contribution_base_salary?: Maybe<Scalars['Decimal']['output']>;
  /** NSS — 11-digit IMSS number, last digit a valid Luhn check digit. Null only on contracts without an employer registration. */
  imss_number?: Maybe<Scalars['String']['output']>;
  /** Date the employee was registered with IMSS. */
  imss_registration_date?: Maybe<Scalars['Date']['output']>;
  /** Legal entity the contract belongs to. */
  legal_entity_id?: Maybe<Scalars['UUID']['output']>;
  /** Every IMSS movement of this employee within the queried legal entity, across all contract versions, newest first. */
  movements: Array<EmploymentMxImssMovementType>;
  /** Employee status inside the organization. */
  user_status?: Maybe<Scalars['String']['output']>;
};

export type EmploymentRehireEmployeeInput = {
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  absence_integration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  bank_account_type_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Sueldo base de la nueva relacion laboral. OBLIGATORIO: una recontratacion no hereda el sueldo del contrato anterior porque es el insumo del SBC nuevo. Omitirlo rechaza la operacion. */
  base_salary?: InputMaybe<Scalars['Decimal']['input']>;
  centralized_user_id: Scalars['Int']['input'];
  /** Dias de aguinaldo de la nueva relacion laboral. Minimo legal 15 (LFT MX Art. 87). No se hereda del contrato anterior: es obligatorio cuando el contrato tiene razon social, porque sin el no hay SBC que calcular. Sin razon social queda nulo. */
  christmas_bonus_days?: InputMaybe<Scalars['Int']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  clabe?: InputMaybe<Scalars['String']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  contract_type_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. Debe pertenecer a la misma razon social del contrato anterior: recontratar en otra razon social es un alta, no una recontratacion. */
  employer_registration_id?: InputMaybe<Scalars['UUID']['input']>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  hiring_regime_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  imss_employee_type_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. NSS: 11 numeric digits whose last digit is a valid Luhn check digit. Required when the contract has both a legal entity and an employer registration — it identifies the employee in the IMSS affiliation movement filed at the IDSE. Sent as-is: surrounding whitespace is rejected, not trimmed. An empty string counts as not sent. */
  imss_number?: InputMaybe<Scalars['String']['input']>;
  /** Fecha de registro ante el IMSS. Omitirla usa `start_date` cuando la recontratacion emite movimiento afiliatorio, y la deja nula cuando no. `create_contract` y `update_contract` ya la aceptaban; aca se capturaba y se perdia. */
  imss_registration_date?: InputMaybe<Scalars['Date']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  imss_salary_type_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  imss_shift_type_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  is_pays_overtime?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  is_unionized?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  labor_regime_id?: InputMaybe<Scalars['UUID']['input']>;
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  number_account_bank?: InputMaybe<Scalars['String']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  pay_frequency_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  payment_method_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  payroll_bank_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  pension_type_id?: InputMaybe<Scalars['UUID']['input']>;
  previous_contract_id: Scalars['UUID']['input'];
  /** Inicio reconocido de la relacion laboral nueva. Omitirlo la iguala a `start_date`, que es como PAYR-582 (AC-5) definio la recontratacion: reinicia la antiguedad. Mandarlo reconoce antiguedad previa de forma explicita, que es insumo del factor de integracion del SBC. No puede ser posterior a `start_date`. */
  recognized_seniority_date?: InputMaybe<Scalars['Date']['input']>;
  /** Tipo de salario de la nueva relacion laboral. OBLIGATORIO, por el mismo motivo que `base_salary`. */
  salary_type_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  sar_bank_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  shift_hours?: InputMaybe<Scalars['Int']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  shift_type_id?: InputMaybe<Scalars['UUID']['input']>;
  start_date: Scalars['Date']['input'];
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  union_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  vacation_days?: InputMaybe<Scalars['Int']['input']>;
  /** Prima vacacional de la nueva relacion laboral como PORCENTAJE: 25.00 significa 25%, no 0.25. Minimo legal 25 (LFT MX Art. 80). Mismas reglas que `christmas_bonus_days`. */
  vacation_premium_pct?: InputMaybe<Scalars['Decimal']['input']>;
  /** Sobrescribe el valor del contrato anterior. Omitirlo hereda ese valor; enviar nulo equivale a omitirlo, no borra el dato. */
  work_center_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type EmploymentRehireEmployeeResponse = {
  __typename?: 'EmploymentRehireEmployeeResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentContractType;
};

export type EmploymentRehireEmployeeResult = EmploymentRehireEmployeeResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type EmploymentRenewContractInput = {
  centralized_user_id: Scalars['Int']['input'];
  contract_id: Scalars['UUID']['input'];
  /** Fecha desde la que aplica la prorroga. Omitirla usa la fecha de hoy. No puede ser anterior a la vigencia de la version previa. */
  effective_date?: InputMaybe<Scalars['Date']['input']>;
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Fecha de fin nueva. Obligatoria en la practica pese a admitir nulo en el esquema: una prorroga solo puede extender, asi que tiene que ser posterior a la vigente, y omitirla se rechaza. Volver indeterminado el contrato es otra operacion (`convert_contract_to_indefinite`). */
  new_end_date?: InputMaybe<Scalars['Date']['input']>;
};

export type EmploymentRenewContractResponse = {
  __typename?: 'EmploymentRenewContractResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentContractType;
  /** Avisos no bloqueantes de la operacion (PAYR-582). Hoy: la fecha de vigencia quedo fuera del plazo de presentacion ante el IMSS. La operacion se persistio igual. */
  warnings: Array<Scalars['String']['output']>;
};

export type EmploymentRenewContractResult = EmploymentRenewContractResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type EmploymentSaveContractLegalInfoInput = {
  centralized_user_id: Scalars['Int']['input'];
  /** Motivo del cambio. Los valores validos son los `code` del grupo de catalogo `change_reason` del pais del contrato. Para poblar el selector: `list_catalog_groups(input: {code: "change_reason", country_code: "<pais del contrato>"})`, y con ese id `list_catalog_details(input: {catalog_group_id: <id>})` **quedandote solo con los `is_active: true`** — esa query no filtra por si sola y un detalle apagado se rechaza al enviarlo. No es un enum de GraphQL: agregar o retirar un motivo no cambia el esquema. */
  change_reason: Scalars['String']['input'];
  contract_type_id: Scalars['UUID']['input'];
  /** Fecha desde la que aplican los terminos de la version nueva. Puede ser futura pero no anterior a la vigencia de la version previa. */
  effective_date: Scalars['Date']['input'];
  employer_registration_id?: InputMaybe<Scalars['UUID']['input']>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  /** Indica si el contrato entra a nomina. Flag manual: no se valida ni se deriva de `legal_entity_id`. Omitirlo guarda `false`. */
  has_payroll?: Scalars['Boolean']['input'];
  is_unionized: Scalars['Boolean']['input'];
  labor_regime_id: Scalars['UUID']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
  shift_hours?: InputMaybe<Scalars['Int']['input']>;
  shift_type_id: Scalars['UUID']['input'];
  start_date: Scalars['Date']['input'];
};

export type EmploymentSaveContractLegalInfoResponse = {
  __typename?: 'EmploymentSaveContractLegalInfoResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentContractType;
  /** Avisos no bloqueantes de la operacion (PAYR-582). Hoy: la fecha de vigencia quedo fuera del plazo de presentacion ante el IMSS. La operacion se persistio igual. */
  warnings: Array<Scalars['String']['output']>;
};

export type EmploymentSaveContractLegalInfoResult = EmploymentSaveContractLegalInfoResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type EmploymentSaveContractSalaryInfoInput = {
  bank_account_type_id?: InputMaybe<Scalars['UUID']['input']>;
  base_salary: Scalars['Decimal']['input'];
  centralized_user_id: Scalars['Int']['input'];
  /** Motivo del cambio. Los valores validos son los `code` del grupo de catalogo `change_reason` del pais del contrato. Para poblar el selector: `list_catalog_groups(input: {code: "change_reason", country_code: "<pais del contrato>"})`, y con ese id `list_catalog_details(input: {catalog_group_id: <id>})` **quedandote solo con los `is_active: true`** — esa query no filtra por si sola y un detalle apagado se rechaza al enviarlo. No es un enum de GraphQL: agregar o retirar un motivo no cambia el esquema. */
  change_reason: Scalars['String']['input'];
  clabe?: InputMaybe<Scalars['String']['input']>;
  /** Fecha desde la que aplica el sueldo nuevo. Puede ser futura pero no anterior a la vigencia de la version previa. No es la fecha con la que se resuelven los parametros del SBC, que siempre es hoy. */
  effective_date: Scalars['Date']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
  number_account_bank?: InputMaybe<Scalars['String']['input']>;
  payment_method_id: Scalars['UUID']['input'];
  payroll_bank_id?: InputMaybe<Scalars['UUID']['input']>;
  salary_type_id: Scalars['UUID']['input'];
  sar_bank_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type EmploymentSaveContractSalaryInfoResponse = {
  __typename?: 'EmploymentSaveContractSalaryInfoResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentContractSalaryInfoType;
  /** Avisos no bloqueantes de la operacion (PAYR-582). Hoy: la fecha de vigencia quedo fuera del plazo de presentacion ante el IMSS. La operacion se persistio igual. */
  warnings: Array<Scalars['String']['output']>;
};

export type EmploymentSaveContractSalaryInfoResult = EmploymentSaveContractSalaryInfoResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Output file format for generated spreadsheets. */
export enum EmploymentSpreadsheetFormat {
  Csv = 'CSV',
  Xlsx = 'XLSX'
}

/** A bracket (renglon) of an employment subsidy table. */
export type EmploymentSubsidyBracketSchema = {
  __typename?: 'EmploymentSubsidyBracketSchema';
  lower_limit: Scalars['Decimal']['output'];
  sort_order: Scalars['Int']['output'];
  subsidy_amount: Scalars['Decimal']['output'];
  upper_limit?: Maybe<Scalars['Decimal']['output']>;
};

/** List of employment subsidy table records. */
export type EmploymentSubsidyTableListResponse = {
  __typename?: 'EmploymentSubsidyTableListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<EmploymentSubsidyTableSchema>;
};

export type EmploymentSubsidyTableMutation = {
  __typename?: 'EmploymentSubsidyTableMutation';
  /** Activates (marks as vigente) an employment subsidy table. Requires internal Crehana admin role (crehana_internal_admin). Validates that brackets are contiguous and cover the full year before activation (AC-A5). Returns NotFoundErrorResponse if the table is not found. */
  activate_employment_subsidy_table: PayrollActivateEmploymentSubsidyTableResult;
  /** Creates a new employment subsidy table (header + brackets) as a draft (is_active=false). Requires internal Crehana admin role (crehana_internal_admin). Rejects if a table already exists for the same (org, fiscal_year, period_type) — AC-A4. */
  create_employment_subsidy_table: PayrollCreateEmploymentSubsidyTableResult;
  /** Deactivates an employment subsidy table (logical delete). Requires internal Crehana admin role (crehana_internal_admin). Sets is_active=false and records deactivation audit. Returns NotFoundErrorResponse if the table is not found. */
  deactivate_employment_subsidy_table: PayrollDeactivateEmploymentSubsidyTableResult;
  /** Seeds the official 2026 employment subsidy table (both brackets from EMPLOYMENT_SUBSIDY_2026) for an organization, already active so the payroll run can resolve it. Requires internal Crehana admin role (crehana_internal_admin). Idempotent: if a table already exists for (org, 2026, monthly) it is returned untouched — including a hand-loaded draft, which is neither activated nor overwritten (PAYR-522 AC-5 / AC-9). */
  seed_employment_subsidy_table: PayrollSeedEmploymentSubsidyTableResult;
  /** Updates an existing employment subsidy table. Requires internal Crehana admin role (crehana_internal_admin). Idempotent: returns the unmodified record if provided values match (AC-A6). Providing brackets replaces the entire set. Returns NotFoundErrorResponse if the table is not found. */
  update_employment_subsidy_table: PayrollUpdateEmploymentSubsidyTableResult;
};


export type EmploymentSubsidyTableMutationActivate_Employment_Subsidy_TableArgs = {
  input: PayrollActivateEmploymentSubsidyTableInput;
};


export type EmploymentSubsidyTableMutationCreate_Employment_Subsidy_TableArgs = {
  input: PayrollCreateEmploymentSubsidyTableInput;
};


export type EmploymentSubsidyTableMutationDeactivate_Employment_Subsidy_TableArgs = {
  input: PayrollDeactivateEmploymentSubsidyTableInput;
};


export type EmploymentSubsidyTableMutationSeed_Employment_Subsidy_TableArgs = {
  input: PayrollSeedEmploymentSubsidyTableInput;
};


export type EmploymentSubsidyTableMutationUpdate_Employment_Subsidy_TableArgs = {
  input: PayrollUpdateEmploymentSubsidyTableInput;
};

export type EmploymentSubsidyTableQuery = {
  __typename?: 'EmploymentSubsidyTableQuery';
  /** Returns the active employment subsidy table for the given fiscal year and period type scoped to the caller's organization. Returns null result if none exists. */
  get_employment_subsidy_table: PayrollGetEmploymentSubsidyTableResult;
  /** Returns all employment subsidy tables for the caller's organization, ordered by fiscal_year DESC. Includes inactive (draft / deactivated) records. Returns an empty list if no records exist. */
  list_employment_subsidy_tables: PayrollListEmploymentSubsidyTablesResult;
};


export type EmploymentSubsidyTableQueryGet_Employment_Subsidy_TableArgs = {
  input: PayrollGetEmploymentSubsidyTableInput;
};


export type EmploymentSubsidyTableQueryList_Employment_Subsidy_TablesArgs = {
  input: PayrollListEmploymentSubsidyTablesInput;
};

/** Single employment subsidy table response wrapper. */
export type EmploymentSubsidyTableResponse = {
  __typename?: 'EmploymentSubsidyTableResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result?: Maybe<EmploymentSubsidyTableSchema>;
};

/** Employment subsidy table record for a fiscal year and organization. */
export type EmploymentSubsidyTableSchema = {
  __typename?: 'EmploymentSubsidyTableSchema';
  brackets: Array<EmploymentSubsidyBracketSchema>;
  centralized_organization_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  deactivated_at?: Maybe<Scalars['DateTime']['output']>;
  deactivated_by?: Maybe<Scalars['Int']['output']>;
  fiscal_year: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  period_type: Scalars['String']['output'];
  source_reference: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
  valid_from: Scalars['Date']['output'];
};

/** Suspension de un contrato activo (PAYR-584). Crea una version nueva con estatus `suspended`; el episodio anterior, si lo hubo, se conserva completo en su propia version. */
export type EmploymentSuspendContractInput = {
  centralized_user_id: Scalars['Int']['input'];
  contract_id: Scalars['UUID']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Fecha prevista de fin, opcional. No puede ser anterior a la de inicio. Es un pronostico, no un limite: la reincorporacion real puede caer despues sin que se rechace. */
  suspension_expected_end_date?: InputMaybe<Scalars['Date']['input']>;
  /** Causa de la suspension. Tiene que ser un detalle del grupo de catalogo `suspension_reason` del pais del contrato — las 8 causas del Art. 42 de la LFT en Mexico. Sustituye al texto libre anterior, que no se validaba contra nada. */
  suspension_reason_id: Scalars['UUID']['input'];
  /** Fecha de inicio de la suspension. Es la vigencia de la version que se crea, pero NO condiciona el estatus: el contrato queda suspendido desde que se ejecuta la operacion, aunque esta fecha sea futura. */
  suspension_start_date: Scalars['Date']['input'];
};

export type EmploymentSuspendContractResponse = {
  __typename?: 'EmploymentSuspendContractResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentContractType;
};

export type EmploymentSuspendContractResult = EmploymentSuspendContractResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type EmploymentTerminateContractInput = {
  centralized_user_id: Scalars['Int']['input'];
  contract_id: Scalars['UUID']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
  termination_date: Scalars['Date']['input'];
  termination_reason_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type EmploymentTerminateContractResponse = {
  __typename?: 'EmploymentTerminateContractResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentContractType;
  /** Avisos no bloqueantes de la operacion (PAYR-582). Hoy: la fecha de vigencia quedo fuera del plazo de presentacion ante el IMSS. La operacion se persistio igual. */
  warnings: Array<Scalars['String']['output']>;
};

export type EmploymentTerminateContractResult = EmploymentTerminateContractResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type EmploymentUpdateContractInput = {
  absence_integration?: InputMaybe<Scalars['Boolean']['input']>;
  bank_account_type_id?: InputMaybe<Scalars['UUID']['input']>;
  base_salary?: InputMaybe<Scalars['Decimal']['input']>;
  /** Motivo del cambio. Los valores validos son los `code` del grupo de catalogo `change_reason` del pais del contrato. Para poblar el selector: `list_catalog_groups(input: {code: "change_reason", country_code: "<pais del contrato>"})`, y con ese id `list_catalog_details(input: {catalog_group_id: <id>})` **quedandote solo con los `is_active: true`** — esa query no filtra por si sola y un detalle apagado se rechaza al enviarlo. No es un enum de GraphQL: agregar o retirar un motivo no cambia el esquema. */
  change_reason: Scalars['String']['input'];
  /** Dias de aguinaldo del contrato. Minimo legal 15 (LFT MX Art. 87). Omitirlo conserva el valor de la version anterior. */
  christmas_bonus_days?: InputMaybe<Scalars['Int']['input']>;
  clabe?: InputMaybe<Scalars['String']['input']>;
  contract_id: Scalars['UUID']['input'];
  contract_type_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Fecha desde la que aplican los terminos de la version nueva. Puede ser futura (un cambio pactado para el proximo mes se registra hoy) pero no puede ser anterior a la vigencia de la version previa. */
  effective_date: Scalars['Date']['input'];
  end_date?: InputMaybe<Scalars['Date']['input']>;
  /** Indica si el contrato entra a nomina. Omitirlo conserva el valor actual; cambiarlo marca el bloque `contract_terms`. */
  has_payroll?: InputMaybe<Scalars['Boolean']['input']>;
  imss_employee_type_id?: InputMaybe<Scalars['UUID']['input']>;
  /** NSS: 11 numeric digits whose last digit is a valid Luhn check digit. Required when the contract has both a legal entity and an employer registration — it identifies the employee in the IMSS affiliation movement filed at the IDSE. Sent as-is: surrounding whitespace is rejected, not trimmed. An empty string counts as not sent. */
  imss_number?: InputMaybe<Scalars['String']['input']>;
  imss_registration_date?: InputMaybe<Scalars['Date']['input']>;
  imss_shift_type_id?: InputMaybe<Scalars['UUID']['input']>;
  is_pays_overtime?: InputMaybe<Scalars['Boolean']['input']>;
  is_unionized?: InputMaybe<Scalars['Boolean']['input']>;
  labor_regime_id?: InputMaybe<Scalars['UUID']['input']>;
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
  number_account_bank?: InputMaybe<Scalars['String']['input']>;
  /** Frecuencia de pago de la nomina. Omitirlo conserva el de la version anterior. Antes de PAYR-600 esta operacion no lo aceptaba: lo copiaba sin poder cambiarlo, asi que un error de captura era permanente. */
  pay_frequency_id?: InputMaybe<Scalars['UUID']['input']>;
  payment_method_id?: InputMaybe<Scalars['UUID']['input']>;
  payroll_bank_id?: InputMaybe<Scalars['UUID']['input']>;
  pension_type_id?: InputMaybe<Scalars['UUID']['input']>;
  salary_type_id?: InputMaybe<Scalars['UUID']['input']>;
  sar_bank_id?: InputMaybe<Scalars['UUID']['input']>;
  shift_hours?: InputMaybe<Scalars['Int']['input']>;
  shift_type_id?: InputMaybe<Scalars['UUID']['input']>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
  vacation_days?: InputMaybe<Scalars['Int']['input']>;
  /** Prima vacacional como PORCENTAJE: 25.00 significa 25%, no 0.25. Minimo legal 25 (LFT MX Art. 80). Omitirlo conserva el valor de la version anterior. */
  vacation_premium_pct?: InputMaybe<Scalars['Decimal']['input']>;
};

export type EmploymentUpdateContractResponse = {
  __typename?: 'EmploymentUpdateContractResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentContractType;
  /** Avisos no bloqueantes de la operacion (PAYR-582). Hoy: la fecha de vigencia quedo fuera del plazo de presentacion ante el IMSS. La operacion se persistio igual. */
  warnings: Array<Scalars['String']['output']>;
};

export type EmploymentUpdateContractResult = EmploymentUpdateContractResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Sube el certificado bancario de un contrato. El archivo viaja en base64 y el backend lo escribe en su bucket privado: la llave la construye el servicio, nunca el cliente. */
export type EmploymentUploadBankCertificateInput = {
  /** Contrato al que se adjunta el certificado. Tiene que ser la version vigente y pertenecer a la organizacion de la sesion. */
  contract_id: Scalars['UUID']['input'];
  /** PDF del certificado bancario codificado en base64. Se valida el contenido y no la extension: tiene que empezar con la firma de un PDF y no superar 5 MB. No existe un campo para mandar la llave: el cliente ya no la escribe. */
  file_base64: Scalars['String']['input'];
};

export type EmploymentUploadBankCertificateResponse = {
  __typename?: 'EmploymentUploadBankCertificateResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmploymentBankCertificateUploadType;
};

export type EmploymentUploadBankCertificateResult = EmploymentUploadBankCertificateResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Employee status inside the organization. Owned by centralized-users, not by this subgraph — these are the values of its UserOrganizationStatusEnum, mirrored here so the roster can be filtered by status. */
export enum EmploymentUserOrganizationStatusEnum {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export type EmptyTemplateResponseError = {
  __typename?: 'EmptyTemplateResponseError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum EnpsCalculationFormulaEnum {
  RoundedTotal = 'ROUNDED_TOTAL',
  Standard = 'STANDARD',
  StandardNormalized = 'STANDARD_NORMALIZED'
}

/** Semaphore configuration for eNPS surveys. */
export type EnpsSemaphoreInput = {
  /** Display label for detractors. */
  detractores_label: Scalars['String']['input'];
  /** Upper bound of the detractors band (inclusive). */
  detractores_max: Scalars['Int']['input'];
  /** Display label for neutrals. */
  neutrales_label: Scalars['String']['input'];
  /** Upper bound of the neutrals band (inclusive). Must exceed detractores_max. */
  neutrales_max: Scalars['Int']['input'];
  /** Display label for promoters. */
  promotores_label: Scalars['String']['input'];
};

export type EnrollmentBuilderQuery = {
  __typename?: 'EnrollmentBuilderQuery';
  /** Read a bulk course progress reset job by id (admin/staff only): status, counters, and every item's outcome (CELC-5091) */
  course_progress_reset_bulk_job?: Maybe<CourseProgressResetBulkJobNode>;
  /** Reset history for one collaborator's course (admin/staff only): most-recent-first audit trail written by reset_course_progress (CELC-5029) */
  course_progress_reset_history: CourseProgressResetHistory;
  /** Whether this course belongs to a track the collaborator already completed (admin/staff only), for the reset confirmation warning (CELC-5034) */
  course_progress_reset_track_notice: CourseProgressResetTrackNotice;
  /** Filters for enrollments */
  get_enrollment_filters: Array<EnrollmentFilterNode>;
  /** Retrieve history excel detail */
  get_enrollment_history_excels_upload: Array<AssignOrganizationUserFileNode>;
  /** Get organization enrollments by user with pagination and filtering */
  get_enrollments_by_user: EnrollmentConnection;
  /** Retrieve Enrollments by user id and courses id list */
  get_enrollments_by_user_and_course_ids: Array<EnrollmentNode>;
  /** User enrollment */
  user_enrollment?: Maybe<EnrollmentNode>;
  /** User enrollments */
  user_enrollments: EnrollmentConnection;
  /** Get user enrollments with new filter system */
  user_enrollments_with_v2_filters: EnrollmentConnection;
};


export type EnrollmentBuilderQueryCourse_Progress_Reset_Bulk_JobArgs = {
  input: CourseProgressResetBulkJobInput;
};


export type EnrollmentBuilderQueryCourse_Progress_Reset_HistoryArgs = {
  input: CourseProgressResetTargetInput;
};


export type EnrollmentBuilderQueryCourse_Progress_Reset_Track_NoticeArgs = {
  input: CourseProgressResetTargetInput;
};


export type EnrollmentBuilderQueryGet_Enrollment_History_Excels_UploadArgs = {
  input: EnrollmentRetrieveHistoryExcelInput;
};


export type EnrollmentBuilderQueryGet_Enrollments_By_UserArgs = {
  input: GetEnrollmentsByUserInput;
};


export type EnrollmentBuilderQueryGet_Enrollments_By_User_And_Course_IdsArgs = {
  input: EnrollmentCourseUserInput;
};


export type EnrollmentBuilderQueryUser_EnrollmentArgs = {
  course_id: Scalars['Int']['input'];
};


export type EnrollmentBuilderQueryUser_EnrollmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter_by?: InputMaybe<EnrollmentFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EnrollmentInputOrderBy>>;
};


export type EnrollmentBuilderQueryUser_Enrollments_With_V2_FiltersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter_by?: InputMaybe<EnrollmentFiltersInputV2>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EnrollmentInputOrderBy>>;
};

export type EnrollmentCompletedInput = {
  apply_certification?: Scalars['Boolean']['input'];
  apply_send_email_completed?: Scalars['Boolean']['input'];
  enrollment_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
};

export type EnrollmentCompletedPayload = {
  __typename?: 'EnrollmentCompletedPayload';
  course_id: Scalars['Int']['output'];
  date_completed?: Maybe<Scalars['String']['output']>;
  enrollment_id: Scalars['Int']['output'];
  progress: Scalars['Int']['output'];
  was_completed: Scalars['Boolean']['output'];
};

export type EnrollmentConnection = {
  __typename?: 'EnrollmentConnection';
  edges: Array<EnrollmentNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum EnrollmentCourseProgressState {
  Certified = 'CERTIFIED',
  Completed = 'COMPLETED',
  Initial = 'INITIAL',
  InProgress = 'IN_PROGRESS'
}

export enum EnrollmentCourseQuizStatusEnum {
  Approved = 'APPROVED',
  Certificate = 'CERTIFICATE',
  Disapproved = 'DISAPPROVED',
  Incomplete = 'INCOMPLETE',
  Initial = 'INITIAL',
  Progress = 'PROGRESS'
}

export type EnrollmentCourseQuizzNode = {
  __typename?: 'EnrollmentCourseQuizzNode';
  attempts: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_closed?: Maybe<Scalars['Boolean']['output']>;
  /** Quiz Status */
  quiz_status?: Maybe<EnrollmentCourseQuizStatusEnum>;
  /** Time to retry */
  retry_time?: Maybe<QuizRetryTimeEnum>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type EnrollmentCourseUserInput = {
  list_course_ids: Array<Scalars['Int']['input']>;
  user_id: Scalars['Int']['input'];
};

export type EnrollmentFilterNode = {
  __typename?: 'EnrollmentFilterNode';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<EnrollmentFilterNode>>;
};

export type EnrollmentFiltersInput = {
  assigned_courses?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the course is mandatory or not. By default, this value will be null. */
  course_is_mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  course_title?: InputMaybe<Scalars['String']['input']>;
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  progress_state?: InputMaybe<EnrollmentCourseProgressState>;
};

export type EnrollmentFiltersInputV2 = {
  course_title?: InputMaybe<Scalars['String']['input']>;
  filter_ids: Array<Scalars['ID']['input']>;
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnrollmentInputOrderBy = {
  direction: OrderDirectionEnum;
  field: EnrollmentOrderByEnum;
};

export type EnrollmentNode = {
  __typename?: 'EnrollmentNode';
  /** Certificate Information */
  certificate?: Maybe<ContentCertificateNode>;
  /** Certification Rule */
  certification_rule?: Maybe<CertificationRule>;
  /** Course Information */
  course?: Maybe<Course>;
  course_id: Scalars['Int']['output'];
  /** Enrollment course quiz */
  enrollment_quiz?: Maybe<EnrollmentCourseQuizzNode>;
  enrollment_type?: Maybe<Scalars['Int']['output']>;
  /** Enum enrollment type */
  enrollment_type_enum?: Maybe<EnrollmentTypeEnum>;
  id: Scalars['ID']['output'];
  is_certified: Scalars['Boolean']['output'];
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  progress: Scalars['Int']['output'];
  /** Project Information */
  project?: Maybe<ProjectNode>;
};

/** An edge in a connection. */
export type EnrollmentNodeEdge = {
  __typename?: 'EnrollmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: EnrollmentNode;
};

export enum EnrollmentOrderByEnum {
  CourseTitle = 'COURSE_TITLE',
  EnrollmentAt = 'ENROLLMENT_AT',
  LastActivity = 'LAST_ACTIVITY'
}

export type EnrollmentPayload = {
  __typename?: 'EnrollmentPayload';
  data: Scalars['JSON']['output'];
  enrollment_id?: Maybe<Scalars['Int']['output']>;
};

export type EnrollmentQuery = {
  __typename?: 'EnrollmentQuery';
  /** Get organization report enrollments by user with pagination and filtering */
  get_report_enrollments_by_user: ReportEnrollmentConnection;
  get_team_users_course_enrollments: LeaderUsersEnrollmentsPageNumberPagination;
  get_users_by_assigned_courses_with_search: UserAssignedByCourseResponse;
};


export type EnrollmentQueryGet_Report_Enrollments_By_UserArgs = {
  input: GetReportEnrollmentsByUserInput;
};


export type EnrollmentQueryGet_Team_Users_Course_EnrollmentsArgs = {
  input: GetUsersTeamEnrollmentsInput;
};


export type EnrollmentQueryGet_Users_By_Assigned_Courses_With_SearchArgs = {
  input: GetUsersCourseInput;
};

export type EnrollmentResponse = EnrollmentPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type EnrollmentRetrieveHistoryExcelInput = {
  action: ValidationEmailAction;
  course_id: Scalars['Int']['input'];
  organization_id: Scalars['Int']['input'];
};

export enum EnrollmentScopeEnum {
  AllEnrolled = 'ALL_ENROLLED',
  NewAndInProgress = 'NEW_AND_IN_PROGRESS'
}

export enum EnrollmentSearchFilterEnum {
  EnrollmentSearchFilterActive = 'ENROLLMENT_SEARCH_FILTER_ACTIVE',
  EnrollmentSearchFilterAll = 'ENROLLMENT_SEARCH_FILTER_ALL',
  EnrollmentSearchFilterCompleted = 'ENROLLMENT_SEARCH_FILTER_COMPLETED',
  EnrollmentSearchFilterHidden = 'ENROLLMENT_SEARCH_FILTER_HIDDEN',
  EnrollmentSearchFilterInactive = 'ENROLLMENT_SEARCH_FILTER_INACTIVE',
  EnrollmentSearchFilterInProgress = 'ENROLLMENT_SEARCH_FILTER_IN_PROGRESS',
  EnrollmentSearchFilterNotStarted = 'ENROLLMENT_SEARCH_FILTER_NOT_STARTED'
}

export enum EnrollmentStatusEnum {
  EnrollmentCompleted = 'ENROLLMENT_COMPLETED',
  EnrollmentInProgress = 'ENROLLMENT_IN_PROGRESS',
  EnrollmentNotInitialized = 'ENROLLMENT_NOT_INITIALIZED'
}

export enum EnrollmentTypeEnum {
  B2B = 'B2B',
  Degree = 'DEGREE',
  Free = 'FREE',
  Freemium = 'FREEMIUM',
  FreeMembership = 'FREE_MEMBERSHIP',
  GiftCard = 'GIFT_CARD',
  Membership = 'MEMBERSHIP',
  Mentor = 'MENTOR',
  Migrate = 'MIGRATE',
  Paid = 'PAID',
  PreviewTrial = 'PREVIEW_TRIAL',
  Professor = 'PROFESSOR',
  Staff = 'STAFF',
  TemporalAccess = 'TEMPORAL_ACCESS'
}

export enum EnterpriseEnum {
  Ats = 'ATS',
  Learning = 'LEARNING',
  Talent = 'TALENT',
  Workbeat = 'WORKBEAT'
}

export enum EntityState {
  Active = 'ACTIVE',
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Created = 'CREATED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Finished = 'FINISHED',
  Inactive = 'INACTIVE',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  PendingBySuperBoss = 'PENDING_BY_SUPER_BOSS',
  Rejected = 'REJECTED',
  Retired = 'RETIRED',
  Standby = 'STANDBY',
  Started = 'STARTED'
}

/** Define value for enum fields */
export type EnumI = {
  value: Scalars['ID']['output'];
};

export enum EnvironmentEnum {
  EnvironmentDemo_1 = 'ENVIRONMENT_DEMO_1',
  EnvironmentProduction = 'ENVIRONMENT_PRODUCTION',
  EnvironmentQa = 'ENVIRONMENT_QA'
}

export type EpaycoCcMethodNode = {
  __typename?: 'EpaycoCCMethodNode';
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  public_key?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type EpaycoCcMethodNodeEpaycoPseMethodNodeFlywireCardMethodNode = EpaycoCcMethodNode | EpaycoPseMethodNode | FlywireCardMethodNode;

export type EpaycoCcPaymentInput = {
  card_token: Scalars['String']['input'];
  /** Payment gateway organization ID */
  gateway_org_id?: InputMaybe<Scalars['Int']['input']>;
  /** Invoice data ID */
  invoice_data_id: Scalars['Int']['input'];
  /** Payment method ID */
  payment_method_id?: InputMaybe<Scalars['Int']['input']>;
  /** Product ID */
  product_id: Scalars['Int']['input'];
};

export type EpaycoGatewayNode = {
  __typename?: 'EpaycoGatewayNode';
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
};

export type EpaycoPseMethodNode = {
  __typename?: 'EpaycoPSEMethodNode';
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type EpaycoPsePaymentInput = {
  /** Payment gateway organization ID */
  gateway_org_id?: InputMaybe<Scalars['Int']['input']>;
  /** Invoice data ID */
  invoice_data_id: Scalars['Int']['input'];
  /** Payment method ID */
  payment_method_id?: InputMaybe<Scalars['Int']['input']>;
  /** Product ID */
  product_id: Scalars['Int']['input'];
  pse_bank_id: Scalars['String']['input'];
};

export type EpaycoPaymentResponse = {
  __typename?: 'EpaycoPaymentResponse';
  order_id?: Maybe<Scalars['String']['output']>;
  redirect_url: Scalars['String']['output'];
};

export type EpaycoPaymentResponsePaymentErrorNode = EpaycoPaymentResponse | PaymentErrorNode;

export type ErrorAssignment = {
  __typename?: 'ErrorAssignment';
  /** Excel cell reference */
  cell: Scalars['String']['output'];
  /** Column name where error occurred */
  column_name: Scalars['String']['output'];
  /** Document name related to this error (if applicable) */
  document_name?: Maybe<Scalars['String']['output']>;
  /** Error code */
  error_code: AssignmentValidationErrorCode;
  /** Human-readable error message */
  error_message: Scalars['String']['output'];
};

export enum ErrorCode {
  InternalError = 'INTERNAL_ERROR'
}

export enum ErrorDetail {
  /**
   * The deadline expired before the operation could complete.
   *
   * For operations that change the state of the system, this error
   * may be returned even if the operation has completed successfully.
   * For example, a successful response from a server could have been
   * delayed long enough for the deadline to expire.
   *
   * HTTP Mapping: 504 Gateway Timeout
   * Error Type: UNAVAILABLE
   */
  DeadlineExceeded = 'DEADLINE_EXCEEDED',
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   *
   * HTTP Mapping: 429 Too Many Requests or 420 Enhance Your Calm
   * Error Type: UNAVAILABLE
   */
  EnhanceYourCalm = 'ENHANCE_YOUR_CALM',
  /**
   * The requested field is not found in the schema.
   *
   * This differs from `NOT_FOUND` in that `NOT_FOUND` should be used when a
   * query is valid, but is unable to return a result (if, for example, a
   * specific video id doesn't exist). `FIELD_NOT_FOUND` is intended to be
   * returned by the server to signify that the requested field is not known to exist.
   * This may be returned in lieu of failing the entire query.
   * See also `PERMISSION_DENIED` for cases where the
   * requested field is invalid only for the given user or class of users.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: BAD_REQUEST
   */
  FieldNotFound = 'FIELD_NOT_FOUND',
  /**
   * The client specified an invalid argument.
   *
   * Note that this differs from `FAILED_PRECONDITION`.
   * `INVALID_ARGUMENT` indicates arguments that are problematic
   * regardless of the state of the system (e.g., a malformed file name).
   *
   * HTTP Mapping: 400 Bad Request
   * Error Type: BAD_REQUEST
   */
  InvalidArgument = 'INVALID_ARGUMENT',
  /**
   * The provided cursor is not valid.
   *
   * The most common usage for this error is when a client is paginating
   * through a list that uses stateful cursors. In that case, the provided
   * cursor may be expired.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: NOT_FOUND
   */
  InvalidCursor = 'INVALID_CURSOR',
  /**
   * Unable to perform operation because a required resource is missing.
   *
   * Example: Client is attempting to refresh a list, but the specified
   * list is expired. This requires an action by the client to get a new list.
   *
   * If the user is simply trying GET a resource that is not found,
   * use the NOT_FOUND error type. FAILED_PRECONDITION.MISSING_RESOURCE
   * is to be used particularly when the user is performing an operation
   * that requires a particular resource to exist.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   * Error Type: FAILED_PRECONDITION
   */
  MissingResource = 'MISSING_RESOURCE',
  /**
   * Service Error.
   *
   * There is a problem with an upstream service.
   *
   * This may be returned if a gateway receives an unknown error from a service
   * or if a service is unreachable.
   * If a request times out which waiting on a response from a service,
   * `DEADLINE_EXCEEDED` may be returned instead.
   * If a service returns a more specific error Type, the specific error Type may
   * be returned instead.
   *
   * HTTP Mapping: 502 Bad Gateway
   * Error Type: UNAVAILABLE
   */
  ServiceError = 'SERVICE_ERROR',
  /**
   * Request failed due to network errors.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  TcpFailure = 'TCP_FAILURE',
  /**
   * Request throttled based on server concurrency limits.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  ThrottledConcurrency = 'THROTTLED_CONCURRENCY',
  /**
   * Request throttled based on server CPU limits
   *
   * HTTP Mapping: 503 Unavailable.
   * Error Type: UNAVAILABLE
   */
  ThrottledCpu = 'THROTTLED_CPU',
  /**
   * The operation is not implemented or is not currently supported/enabled.
   *
   * HTTP Mapping: 501 Not Implemented
   * Error Type: BAD_REQUEST
   */
  Unimplemented = 'UNIMPLEMENTED',
  /**
   * Unknown error.
   *
   * This error should only be returned when no other error detail applies.
   * If a client sees an unknown errorDetail, it will be interpreted as UNKNOWN.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Unknown = 'UNKNOWN'
}

export type ErrorGroupDetailsType = {
  __typename?: 'ErrorGroupDetailsType';
  errors: Array<Scalars['JSON']['output']>;
  table_headers: Array<Scalars['String']['output']>;
};

export type ErrorGroupType = {
  __typename?: 'ErrorGroupType';
  count: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  details?: Maybe<ErrorGroupDetailsType>;
  errorType: Scalars['String']['output'];
  has_detail: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type ErrorResponse = {
  __typename?: 'ErrorResponse';
  error_code: Scalars['Int']['output'];
  error_message: Scalars['String']['output'];
  translation_key?: Maybe<Scalars['String']['output']>;
};

export enum ErrorType {
  /**
   * Bad Request.
   *
   * There is a problem with the request.
   * Retrying the same request is not likely to succeed.
   * An example would be a query or argument that cannot be deserialized.
   *
   * HTTP Mapping: 400 Bad Request
   */
  BadRequest = 'BAD_REQUEST',
  /**
   * The operation was rejected because the system is not in a state
   * required for the operation's execution.  For example, the directory
   * to be deleted is non-empty, an rmdir operation is applied to
   * a non-directory, etc.
   *
   * Service implementers can use the following guidelines to decide
   * between `FAILED_PRECONDITION` and `UNAVAILABLE`:
   *
   * - Use `UNAVAILABLE` if the client can retry just the failing call.
   * - Use `FAILED_PRECONDITION` if the client should not retry until
   * the system state has been explicitly fixed.  E.g., if an "rmdir"
   *      fails because the directory is non-empty, `FAILED_PRECONDITION`
   * should be returned since the client should not retry unless
   * the files are deleted from the directory.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   */
  FailedPrecondition = 'FAILED_PRECONDITION',
  /**
   * Internal error.
   *
   * An unexpected internal error was encountered. This means that some
   * invariants expected by the underlying system have been broken.
   * This error code is reserved for serious errors.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Internal = 'INTERNAL',
  /**
   * The requested entity was not found.
   *
   * This could apply to a resource that has never existed (e.g. bad resource id),
   * or a resource that no longer exists (e.g. cache expired.)
   *
   * Note to server developers: if a request is denied for an entire class
   * of users, such as gradual feature rollout or undocumented allowlist,
   * `NOT_FOUND` may be used. If a request is denied for some users within
   * a class of users, such as user-based access control, `PERMISSION_DENIED`
   * must be used.
   *
   * HTTP Mapping: 404 Not Found
   */
  NotFound = 'NOT_FOUND',
  /**
   * The caller does not have permission to execute the specified
   * operation.
   *
   * `PERMISSION_DENIED` must not be used for rejections
   * caused by exhausting some resource or quota.
   * `PERMISSION_DENIED` must not be used if the caller
   * cannot be identified (use `UNAUTHENTICATED`
   * instead for those errors).
   *
   * This error Type does not imply the
   * request is valid or the requested entity exists or satisfies
   * other pre-conditions.
   *
   * HTTP Mapping: 403 Forbidden
   */
  PermissionDenied = 'PERMISSION_DENIED',
  /**
   * The request does not have valid authentication credentials.
   *
   * This is intended to be returned only for routes that require
   * authentication.
   *
   * HTTP Mapping: 401 Unauthorized
   */
  Unauthenticated = 'UNAUTHENTICATED',
  /**
   * Currently Unavailable.
   *
   * The service is currently unavailable.  This is most likely a
   * transient condition, which can be corrected by retrying with
   * a backoff.
   *
   * HTTP Mapping: 503 Unavailable
   */
  Unavailable = 'UNAVAILABLE',
  /**
   * Unknown error.
   *
   * For example, this error may be returned when
   * an error code received from another address space belongs to
   * an error space that is not known in this address space.  Also
   * errors raised by APIs that do not return enough error information
   * may be converted to this error.
   *
   * If a client sees an unknown errorType, it will be interpreted as UNKNOWN.
   * Unknown errors MUST NOT trigger any special behavior. These MAY be treated
   * by an implementation as being equivalent to INTERNAL.
   *
   * When possible, a more specific error should be provided.
   *
   * HTTP Mapping: 520 Unknown Error
   */
  Unknown = 'UNKNOWN'
}

export type EvaluationCardSectionUnionResponse = PrivateAtsEvaluationCardNotesInfo | PrivateAtsEvaluationCardPointInfo | PrivateAtsEvaluationDetailCardQuestionInfo;

export enum EvaluationFieldsEnum {
  EvaluationName = 'EVALUATION_NAME'
}

/** Filters for the overall competence evaluation progress query. */
export type EvaluationProgressInput = {
  /** Talent company id. */
  company_id: Scalars['Int']['input'];
  /** Month (1-12) for the cumulative cut. */
  month: Scalars['Int']['input'];
  /** Evaluation x relation combinations to report (up to 3). */
  relations: Array<EvaluationRelationInput>;
  /** Year for the cumulative cut. */
  year: Scalars['Int']['input'];
};

/** Overall competence evaluation progress (average of the per-relation percentages) plus the per-relation completed/pending summary. */
export type EvaluationProgressType = {
  __typename?: 'EvaluationProgressType';
  overall_progress: Scalars['Float']['output'];
  relations: Array<RelationProgressSummaryType>;
};

export enum EvaluationRelationEnum {
  TypeRelationAuto = 'TYPE_RELATION_AUTO',
  TypeRelationBoss = 'TYPE_RELATION_BOSS',
  TypeRelationCoworker = 'TYPE_RELATION_COWORKER',
  TypeRelationExternCustomer = 'TYPE_RELATION_EXTERN_CUSTOMER',
  TypeRelationInternalCustomer = 'TYPE_RELATION_INTERNAL_CUSTOMER',
  TypeRelationOther = 'TYPE_RELATION_OTHER',
  TypeRelationProvider = 'TYPE_RELATION_PROVIDER',
  TypeRelationSubordinate = 'TYPE_RELATION_SUBORDINATE',
  TypeRelationSupervisor = 'TYPE_RELATION_SUPERVISOR',
  TypeRelationVp = 'TYPE_RELATION_VP'
}

/** A single evaluation x relation combination (one chart series). */
export type EvaluationRelationInput = {
  /** Competence evaluation id (mapped to process_id '4M<id>P'). */
  evaluation_id: Scalars['Int']['input'];
  /** Relation bucket: AUTO, BOSS or OTHER_RELATIONS. */
  relation_id: RelationFilter;
};

/** ENUMERATIONS */
export enum EvaluationStateEnum {
  Closed = 'CLOSED',
  Created = 'CREATED',
  Finished = 'FINISHED',
  Started = 'STARTED'
}

export type Evaluator = {
  id: Scalars['Int']['input'];
  relation: RelationQuestionnaireEnum;
};

export enum EvaluatorQuestionnaireStateFilterEnum {
  Assigned = 'ASSIGNED',
  Configure = 'CONFIGURE',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS'
}

export type EventAttributes = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  data: Scalars['JSON']['input'];
  message: Scalars['String']['input'];
  method: Scalars['String']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  schema: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};

export type EventCountConnection = {
  __typename?: 'EventCountConnection';
  /** Contains the nodes in this connection */
  edges: Array<EventCountNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

/** This node presents an achievement and the frequency with which it has been earned. */
export type EventCountNode = {
  __typename?: 'EventCountNode';
  event?: Maybe<CurrencyEventNode>;
  events_count: Scalars['Int']['output'];
};

export type EventCountNodeEdge = {
  __typename?: 'EventCountNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: EventCountNode;
};

export type EventMutationError = MutationError & {
  __typename?: 'EventMutationError';
  error_code?: Maybe<ErrorCode>;
  error_message?: Maybe<Scalars['String']['output']>;
};

export type EventNotificationSeenNode = {
  __typename?: 'EventNotificationSeenNode';
  events?: Maybe<Array<UserEventBankFragmentNode>>;
  total_count: Scalars['Int']['output'];
};

export type EventResponse = DataFieldsSent | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export enum EventSubjectEnum {
  CompleteCourse = 'COMPLETE_COURSE',
  CompleteProject = 'COMPLETE_PROJECT',
  CompleteQuiz = 'COMPLETE_QUIZ',
  LearningPath = 'LEARNING_PATH'
}

export enum EventTypeEnum {
  Achievement = 'ACHIEVEMENT',
  Event = 'EVENT'
}

/** This input inherits from the standard interface and adds one more field. The validations for this input are done with Pydantic. */
export type EventUpdateInput = {
  id: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type ExcelImportsInput = {
  organization_id: Scalars['Int']['input'];
  slug: PubSubEvents;
};

/** Centralized Excel Import Node */
export type ExcelImportsNode = {
  __typename?: 'ExcelImportsNode';
  /** Date created */
  created_at: Scalars['String']['output'];
  /** Excel Import file URL */
  file_url: Scalars['String']['output'];
  /** Original ID */
  original_id: Scalars['Int']['output'];
  /** Total records in the Excel File */
  records: Scalars['Int']['output'];
  /** Failed records in the Excel File */
  records_error: Scalars['Int']['output'];
  /** Centralized User Node */
  user: CentralizedUserNode;
};

export type ExcelImportsNodeCustomConnection = {
  __typename?: 'ExcelImportsNodeCustomConnection';
  edges: Array<ExcelImportsNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type ExcelImportsNodeCustomEdge = {
  __typename?: 'ExcelImportsNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ExcelImportsNode;
};

export type ExcelIssueItem = {
  __typename?: 'ExcelIssueItem';
  /** cell location in the Excel file (e.g., 'A2') */
  cell: Scalars['String']['output'];
  /** column header in the Excel file (e.g., 'Email') */
  column?: Maybe<Scalars['String']['output']>;
  /** specific detail about the validation issue, ej ('Invalid email format') */
  detail?: Maybe<Scalars['String']['output']>;
  /** additional information about the validation issue, ej ({'expected_format': 'email'}) */
  extra?: Maybe<Scalars['JSON']['output']>;
  /** main value of the record (email, name, document, etc.) */
  value?: Maybe<Scalars['String']['output']>;
};

export type ExcelReport = {
  __typename?: 'ExcelReport';
  absolute_url?: Maybe<Scalars['String']['output']>;
};

export type ExcelResponse = ExcelReport | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type ExcelValidItem = {
  __typename?: 'ExcelValidItem';
  /** cell location in the Excel file (e.g., 'A2') */
  cell: Scalars['String']['output'];
  /** additional metadata about the record (e.g., validation flags) */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** main value of the record (email, name, document, etc.) */
  value: Scalars['String']['output'];
};

export type ExcelValidationIssue = {
  __typename?: 'ExcelValidationIssue';
  /** number of records that triggered this validation issue */
  count: Scalars['Int']['output'];
  /** list of records that triggered this validation issue */
  data: Array<ExcelIssueItem>;
  /** detailed description of the validation issue */
  description?: Maybe<Scalars['String']['output']>;
  /** unique identifier for the validation issue, ej (INVALID_EMAIL) */
  error_code: Scalars['String']['output'];
  /** short title or summary of the validation issue */
  title: Scalars['String']['output'];
};

export type ExcelValidationResultInfo = {
  __typename?: 'ExcelValidationResultInfo';
  /** list of records that triggered validation errors */
  errors: Array<ExcelValidationIssue>;
  /** additional information about the validation result, ej ({'file_id': 1000, 'queue_id': 1000}) */
  extra?: Maybe<Scalars['JSON']['output']>;
  /** summary of the validation process */
  summary: ExcelValidationSummary;
  /** list of records that passed validation */
  valid: Array<ExcelValidItem>;
  /** list of records that triggered validation warnings */
  warnings: Array<ExcelValidationIssue>;
};

export type ExcelValidationSummary = {
  __typename?: 'ExcelValidationSummary';
  errorCount: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
  validCount: Scalars['Int']['output'];
  warningCount: Scalars['Int']['output'];
};

export type ExecutedCompetencesPayload = {
  __typename?: 'ExecutedCompetencesPayload';
  executed?: Maybe<Scalars['Boolean']['output']>;
};

/** Deprecated */
export type ExecutedTalentRecognitionPayload = {
  __typename?: 'ExecutedTalentRecognitionPayload';
  executed?: Maybe<Scalars['Boolean']['output']>;
};

export type ExportCopilotPlannerReportPdfInput = {
  /** UUID del reporte a exportar. Tiene que estar TERMINADO y ser de tipo dashboard o document: un reporte que ya es un archivo no se convierte, y uno que se está generando todavía no tiene contenido. El campo `exportable` de los valores del reporte dice si se puede. */
  report_id: Scalars['ID']['input'];
};

export type ExportCopilotPlannerReportPdfResult = CopilotPlannerReportPdfExportedPayload | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type ExportOrganizationPositionsInput = {
  centralized_organization_id: Scalars['Int']['input'];
  centralized_organization_slug: Scalars['String']['input'];
};

/** Async export request payload. Re-call the mutation to poll state (PENDING → PROCESSING → COMPLETE | ERROR). file_url is populated once state=COMPLETE. */
export type ExportOrganizationPositionsPayload = {
  __typename?: 'ExportOrganizationPositionsPayload';
  /** Error detail. Only present when state=ERROR. */
  error_detail?: Maybe<Scalars['JSON']['output']>;
  /** Presigned S3 URL. Only present when state=COMPLETE. */
  file_url?: Maybe<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  /** True if an existing in-flight request was returned. */
  is_cached: Scalars['Boolean']['output'];
  /** ID of the OrganizationPositionExportRequest record */
  request_id: Scalars['ID']['output'];
  /** PENDING | PROCESSING | COMPLETE | ERROR */
  state: Scalars['String']['output'];
};

export type ExportOrganizationPositionsResponse = ExportOrganizationPositionsPayload | ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse;

/** Consume info from LiveSessionUserSession model */
export type ExternalLiveSessionUserType = UserLiveSessionI & {
  __typename?: 'ExternalLiveSessionUserType';
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  has_participated: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  status: UserStatusEnum;
  user_image_url?: Maybe<Scalars['String']['output']>;
};

export type ExternalResourceType = {
  __typename?: 'ExternalResourceType';
  external_url_resource?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  resource_name?: Maybe<Scalars['String']['output']>;
  resource_type?: Maybe<ResourceTypeEnum>;
};

export type ExternalSessionResourceType = LiveSessionResourceI & {
  __typename?: 'ExternalSessionResourceType';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  upload_by?: Maybe<UserLiveSession>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FcmAttributes = {
  click_action: Scalars['String']['input'];
  extra_kwargs?: InputMaybe<Scalars['JSON']['input']>;
  message_text: Scalars['String']['input'];
  message_title: Scalars['String']['input'];
  notification_id?: InputMaybe<Scalars['Int']['input']>;
  platform: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type FcmPublisherMutation = {
  __typename?: 'FcmPublisherMutation';
  send_message: EventResponse;
};


export type FcmPublisherMutationSend_MessageArgs = {
  inputs: FcmAttributes;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  category: FeatureFlagCategoryEnum;
  description?: Maybe<Scalars['String']['output']>;
  name_key: Scalars['String']['output'];
  namespace_key: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['Boolean']['output']>;
};

export enum FeatureFlagCategoryEnum {
  CategoryExperimental = 'CATEGORY_EXPERIMENTAL',
  CategoryFeature = 'CATEGORY_FEATURE'
}

export enum FeatureTypeEnum {
  EndUser = 'END_USER',
  Hris = 'HRIS'
}

export type FeatureValidateResponse = {
  __typename?: 'FeatureValidateResponse';
  created_at: Scalars['DateTime']['output'];
  feature: Scalars['String']['output'];
  process_name: Scalars['String']['output'];
};

export type FeatureValidateResponseCustomConnection = {
  __typename?: 'FeatureValidateResponseCustomConnection';
  edges: Array<FeatureValidateResponseCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type FeatureValidateResponseCustomConnectionValidationErrorResponseInternalErrorResponse = FeatureValidateResponseCustomConnection | InternalErrorResponse | ValidationErrorResponse;

export type FeatureValidateResponseCustomEdge = {
  __typename?: 'FeatureValidateResponseCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: FeatureValidateResponse;
};

export enum FeatureVisualizationTypeEnum {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type FeaturesFlagQuery = {
  __typename?: 'FeaturesFlagQuery';
  get_feature_flag: GetFeatureFlagPayloadQueryInternalError;
  get_feature_flags: GetFeatureFlagsPayloadQueryValidationErrorQueryInternalError;
};


export type FeaturesFlagQueryGet_Feature_FlagArgs = {
  input: GetFeatureFlagInput;
};


export type FeaturesFlagQueryGet_Feature_FlagsArgs = {
  input: GetFeatureFlagsInput;
};

export type FeaturesMutation = {
  __typename?: 'FeaturesMutation';
  /** Marca el monolito de Talent como disponible o caido. Es la palanca de disponibilidad: el servicio esta arriba o abajo para todas las organizaciones a la vez. */
  set_talent_monolith_availability: SetTalentMonolithAvailabilityResponse;
  /** Mutation for activate or deactivate feature flag to organization */
  update_feature_flag_to_organization?: Maybe<FeatureFlag>;
};


export type FeaturesMutationSet_Talent_Monolith_AvailabilityArgs = {
  value: Scalars['Boolean']['input'];
};


export type FeaturesMutationUpdate_Feature_Flag_To_OrganizationArgs = {
  is_active?: Scalars['Boolean']['input'];
  name_key: Scalars['String']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  value?: Scalars['Boolean']['input'];
};

export type FederalEntityListResponse = {
  __typename?: 'FederalEntityListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<FederalEntityType>;
};

export type FederalEntityResponse = {
  __typename?: 'FederalEntityResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: FederalEntityType;
};

export type FederalEntityType = {
  __typename?: 'FederalEntityType';
  code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type FeedbackCategoryTemplateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FeedbackCategoryTemplatePayload = {
  __typename?: 'FeedbackCategoryTemplatePayload';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FeedbackCollaboratorFilterInput = {
  company_id: Scalars['Int']['input'];
  division_ids?: InputMaybe<Scalars['String']['input']>;
  employee_id?: InputMaybe<Scalars['Int']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  job_ids?: InputMaybe<Scalars['String']['input']>;
  job_level_id?: InputMaybe<Scalars['Int']['input']>;
  job_level_ids?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_delivered?: InputMaybe<Scalars['String']['input']>;
  order_requested?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
};

export type FeedbackDashboardAdminResume = {
  __typename?: 'FeedbackDashboardAdminResume';
  count_face_delivered: Scalars['Int']['output'];
  count_face_request: Scalars['Int']['output'];
  count_total_delivered: Scalars['Int']['output'];
  count_total_request: Scalars['Int']['output'];
  count_writing_delivered: Scalars['Int']['output'];
  count_writing_request: Scalars['Int']['output'];
};

export type FeedbackEdge = {
  __typename?: 'FeedbackEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<FeedbackPayload>;
};

export type FeedbackFilterInput = {
  company_id: Scalars['Int']['input'];
  employee_id: Scalars['Int']['input'];
  end_date?: InputMaybe<Scalars['String']['input']>;
  is_delivered: Scalars['Boolean']['input'];
  is_finished: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order_date?: InputMaybe<Scalars['String']['input']>;
  order_state?: InputMaybe<Scalars['String']['input']>;
  order_type?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
};

export type FeedbackGeneralPaginationPayload = {
  __typename?: 'FeedbackGeneralPaginationPayload';
  feedbacks?: Maybe<FeedbackPaginationPayload>;
};

export type FeedbackInput = {
  attachment?: InputMaybe<AttachmentInput>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  emisors?: InputMaybe<Array<InputMaybe<DataModelInput>>>;
  employee_id?: InputMaybe<Scalars['Int']['input']>;
  feedback_state?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_request?: InputMaybe<Scalars['Boolean']['input']>;
  meeting_date?: InputMaybe<Scalars['String']['input']>;
  process_type?: InputMaybe<FeedbackCategoryTemplateInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  receivers?: InputMaybe<Array<InputMaybe<DataModelInput>>>;
  state?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<FeedbackMessageInput>;
  template_selected?: InputMaybe<FeedbackTemplateInput>;
  topic?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FeedbackMessageInput = {
  attachment?: InputMaybe<AttachmentInput>;
  feedback_id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sender?: InputMaybe<DataModelInput>;
};

export type FeedbackMessagePayload = {
  __typename?: 'FeedbackMessagePayload';
  attachment?: Maybe<AttachmentPayload>;
  message?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<DataModelPayload>;
};

export type FeedbackOptionResponseInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
};

export type FeedbackOptionResponsePayload = {
  __typename?: 'FeedbackOptionResponsePayload';
  id?: Maybe<Scalars['ID']['output']>;
  label: Scalars['String']['output'];
};

export type FeedbackPaginationPayload = {
  __typename?: 'FeedbackPaginationPayload';
  edges?: Maybe<Array<Maybe<FeedbackEdge>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type FeedbackPayload = {
  __typename?: 'FeedbackPayload';
  agreement?: Maybe<Scalars['String']['output']>;
  attachment?: Maybe<AttachmentPayload>;
  email_date?: Maybe<Scalars['String']['output']>;
  emisors?: Maybe<Array<Maybe<DataModelPayload>>>;
  end_date?: Maybe<Scalars['String']['output']>;
  feedback_state?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_request?: Maybe<Scalars['Boolean']['output']>;
  meeting_date?: Maybe<Scalars['String']['output']>;
  message_receiver?: Maybe<Scalars['String']['output']>;
  process_type?: Maybe<FeedbackCategoryTemplatePayload>;
  reason?: Maybe<Scalars['String']['output']>;
  receivers?: Maybe<Array<Maybe<DataModelPayload>>>;
  state?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<FeedbackMessagePayload>;
  summary_old_version?: Maybe<Scalars['String']['output']>;
  template_selected?: Maybe<FeedbackTemplatePayload>;
  topic?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type FeedbackProcessInput = {
  activate_process?: InputMaybe<Scalars['Boolean']['input']>;
  active_feedback_type?: InputMaybe<Scalars['String']['input']>;
  feedback_type_request?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  limit_from_bosses?: InputMaybe<Scalars['Boolean']['input']>;
  limit_to_same_division?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeedbackProcessPayload = {
  __typename?: 'FeedbackProcessPayload';
  activate_process?: Maybe<Scalars['Boolean']['output']>;
  active_feedback_type?: Maybe<Scalars['String']['output']>;
  feedback_type_request?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  limit_from_bosses?: Maybe<Scalars['Boolean']['output']>;
  limit_to_same_division?: Maybe<Scalars['Boolean']['output']>;
};

export type FeedbackQuestionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
  options?: InputMaybe<Array<InputMaybe<FeedbackOptionResponseInput>>>;
  response?: InputMaybe<FeedbackOptionResponseInput>;
  type: Scalars['String']['input'];
};

export type FeedbackQuestionPayload = {
  __typename?: 'FeedbackQuestionPayload';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  label: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<FeedbackOptionResponsePayload>>>;
  response?: Maybe<FeedbackOptionResponsePayload>;
  type: Scalars['String']['output'];
};

export type FeedbackResponseInternalError = {
  __typename?: 'FeedbackResponseInternalError';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FeedbackResponseValidationError = {
  __typename?: 'FeedbackResponseValidationError';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FeedbackTemplateEdge = {
  __typename?: 'FeedbackTemplateEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<FeedbackTemplatePayload>;
};

export type FeedbackTemplateGeneralPaginationPayload = {
  __typename?: 'FeedbackTemplateGeneralPaginationPayload';
  templates?: Maybe<FeedbackTemplatePaginationPayload>;
};

export type FeedbackTemplateInput = {
  company_id?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enable_summary?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  questions?: InputMaybe<Array<InputMaybe<FeedbackQuestionInput>>>;
};

export type FeedbackTemplatePaginationPayload = {
  __typename?: 'FeedbackTemplatePaginationPayload';
  edges?: Maybe<Array<Maybe<FeedbackTemplateEdge>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type FeedbackTemplatePayload = {
  __typename?: 'FeedbackTemplatePayload';
  active: Scalars['Boolean']['output'];
  company_id?: Maybe<Scalars['Int']['output']>;
  created_date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enable_summary?: Maybe<Scalars['Boolean']['output']>;
  has_feedback_created?: Maybe<Scalars['Boolean']['output']>;
  has_feedback_started?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  info_default?: Maybe<TemplateDefaultPayload>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  questions?: Maybe<Array<Maybe<FeedbackQuestionPayload>>>;
};

export enum FeedbackTypeEnum {
  All = 'ALL',
  FaceToFace = 'FACE_TO_FACE',
  Writing = 'WRITING'
}

export type FeedbackUserPaginationPayload = {
  __typename?: 'FeedbackUserPaginationPayload';
  collaborators?: Maybe<DataModelPaginationPayload>;
};

export type FieldValidationResponse = {
  __typename?: 'FieldValidationResponse';
  exists: Scalars['Boolean']['output'];
  graphql_operation_id: Scalars['ID']['output'];
};

export type File = {
  __typename?: 'File';
  file?: Maybe<FileStorage>;
  id: Scalars['ID']['output'];
};

export type FileBaseInput = {
  id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export enum FileFormatEnum {
  CsvFormat = 'CSV_FORMAT',
  XlsxFormat = 'XLSX_FORMAT'
}

export type FileGraphOperationI = {
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type FileMetadataInput = {
  /** MIME type of the file (e.g., 'application/pdf') */
  content_type: Scalars['String']['input'];
  /** Full file name including extension (e.g., 'user@company.com-document.pdf') */
  file_name: Scalars['String']['input'];
  /** File size in bytes */
  file_size: Scalars['Int']['input'];
};

export type FilePreSignedUrlInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  uid: Scalars['String']['input'];
};

export type FilePreSignedUrlResponse = S3PreSignedPayload;

export type FileRecordType = LiveSessionRecordI & {
  __typename?: 'FileRecordType';
  file?: Maybe<File>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FileStorage = {
  __typename?: 'FileStorage';
  absolute_url?: Maybe<Scalars['String']['output']>;
  bucket_name?: Maybe<Scalars['String']['output']>;
  content_type: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  download_url?: Maybe<Scalars['String']['output']>;
  file_path?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  relative_url?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export enum FileStorageStatusEnum {
  StatusCompleted = 'STATUS_COMPLETED',
  StatusDeleted = 'STATUS_DELETED',
  StatusFailed = 'STATUS_FAILED',
  StatusInitialized = 'STATUS_INITIALIZED',
  StatusPending = 'STATUS_PENDING'
}

export enum FileUploadStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Uploading = 'UPLOADING'
}

export type FileV1Mutation = {
  __typename?: 'FileV1Mutation';
  generate_pre_signed_url: AddFileV1Response;
  uploaded_file: UploadedFileV1Response;
};


export type FileV1MutationGenerate_Pre_Signed_UrlArgs = {
  input: UploadFileV1Input;
};


export type FileV1MutationUploaded_FileArgs = {
  input: UploadedFileV1Input;
};

export type FileV1Type = ImageFileV1Type | MediaFileV1Type;

export type FileValidationError = {
  __typename?: 'FileValidationError';
  /** Error code */
  error_code: FileValidationErrorCode;
  /** File name that failed validation */
  file_name: Scalars['String']['output'];
  /** Human-readable error message */
  message: Scalars['String']['output'];
};

export enum FileValidationErrorCode {
  DuplicateFilename = 'DUPLICATE_FILENAME',
  FilenameTooLong = 'FILENAME_TOO_LONG',
  FileTooLarge = 'FILE_TOO_LARGE',
  InternalError = 'INTERNAL_ERROR',
  InvalidNomenclature = 'INVALID_NOMENCLATURE',
  SpecialChars = 'SPECIAL_CHARS',
  UnsupportedFormat = 'UNSUPPORTED_FORMAT',
  UserInactive = 'USER_INACTIVE',
  UserNotFound = 'USER_NOT_FOUND'
}

export type FilterBaseInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/**  INPUTS. */
export type FilterByCompetencesEvaluation = {
  job_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCompany = {
  company_id: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  division_id?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  job_name?: InputMaybe<Scalars['String']['input']>;
  level_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subsidary_id?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterCompetencesEvaluation = {
  after?: InputMaybe<Scalars['String']['input']>;
  employee_id: Scalars['Int']['input'];
  filter_by?: InputMaybe<FilterByCompetencesEvaluation>;
  first: Scalars['Int']['input'];
};

export type FilterCompetencesEvaluationQuestionnaire = {
  after?: InputMaybe<Scalars['String']['input']>;
  employee_id: Scalars['Int']['input'];
  evaluation_id: Scalars['Int']['input'];
  filter_by?: InputMaybe<FilterByCompetencesEvaluation>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterCompetencesGroup = {
  employee_id: Scalars['Int']['input'];
  evaluation_id: Scalars['Int']['input'];
  questionnaires_ids: Array<Scalars['Int']['input']>;
};

export type FilterCompetencesQuestionnaireEvaluator = {
  after?: InputMaybe<Scalars['String']['input']>;
  company_id: Scalars['Int']['input'];
  division_id?: InputMaybe<Scalars['Int']['input']>;
  evaluated_id: Scalars['Int']['input'];
  evaluation_id: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCourseAuditLogInput = {
  action_flag_enum?: InputMaybe<AuditLogActionFlagEnum>;
  component_type_enum?: InputMaybe<CourseComponentTypeEnum>;
  log_id?: InputMaybe<Scalars['ID']['input']>;
  video_lecture_type_enum?: InputMaybe<VideoLectureSubComponentTypeEnum>;
};

export type FilterDocumentsInput = {
  file_type?: InputMaybe<Array<DocumentFileTypeEnum>>;
  folder_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state_type?: InputMaybe<Array<DocumentFileStateEnum>>;
};

export type FilterDocumentsSignatureStatusInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  state_type?: InputMaybe<Array<DocumentFileStateEnum>>;
};

export type FilterFoldersInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for list a live sessions, NO PAGINATED [Query] */
export type FilterLiveSessionInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LiveSessionOrderBy>>;
  organization_id: Scalars['String']['input'];
  status: StatusSessionEnum;
};

export enum FilterQuizTypeEnum {
  QuizTypeCourse = 'QUIZ_TYPE_COURSE',
  QuizTypeVideoLecture = 'QUIZ_TYPE_VIDEO_LECTURE'
}

export type FilterSocialHubNewsInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum FilterTypeEnum {
  Division = 'DIVISION',
  Job = 'JOB',
  JobLevel = 'JOB_LEVEL'
}

export type FilterUserProgressSocialHubNewsInput = {
  area_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  state?: InputMaybe<SocialHubNewsStatusEnum>;
};

/** Input for list LiveSessionUserSession WITHOUT PAGINATION [Query] */
export type FilterUserSessionInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  live_session_id: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LiveSessionUsersOrderBy>>;
  organization_id: Scalars['ID']['input'];
  status?: InputMaybe<UserStatusEnum>;
  text_search?: InputMaybe<Scalars['String']['input']>;
};

/** Filters for querying user IDs within an organization. */
export type FilterUsersInput = {
  /** Organization ID to filter users in (required). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Filter by group/team IDs. */
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by position (cargo) IDs. */
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Partial, case-insensitive search on firstname, lastname, or email. */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Payload containing the list of user IDs matching the filters. */
export type FilterUsersPayload = {
  __typename?: 'FilterUsersPayload';
  /** List of distinct user IDs that match all applied filters. */
  user_ids: Array<Scalars['Int']['output']>;
};

export type FilterUsersResponse = FilterUsersPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

export type FinishClimateSurveyResult = FinishClimateSurveySuccess | InternalErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type FinishClimateSurveySuccess = {
  __typename?: 'FinishClimateSurveySuccess';
  finished: Scalars['Boolean']['output'];
};

export type FirstLevelAreaInput = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  area_level_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  nodes?: InputMaybe<Array<SecondLevelAreaInput>>;
};

export type FlywireCardMethodNode = {
  __typename?: 'FlywireCardMethodNode';
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type FlywireGatewayNode = {
  __typename?: 'FlywireGatewayNode';
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
};

export type FlywirePaymentProcessingResponse = {
  __typename?: 'FlywirePaymentProcessingResponse';
  order_id?: Maybe<Scalars['String']['output']>;
  redirect_url: Scalars['String']['output'];
};

export type FlywireTokenizeDataInput = {
  /** Payment gateway organization ID */
  gateway_org_id?: InputMaybe<Scalars['Int']['input']>;
  /** Invoice data ID */
  invoice_data_id: Scalars['Int']['input'];
  /** Payment method ID */
  payment_method_id?: InputMaybe<Scalars['Int']['input']>;
  /** Product ID */
  product_id: Scalars['Int']['input'];
};

export type FlywireTokenizeDataResponse = {
  __typename?: 'FlywireTokenizeDataResponse';
  order_id?: Maybe<Scalars['String']['output']>;
  redirect_url: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type FlywireTokenizeDataResponsePaymentErrorNode = FlywireTokenizeDataResponse | PaymentErrorNode;

export type FlywireValidatePaymentOrderInput = {
  order_id: Scalars['Int']['input'];
};

export type FlywireValidatePaymentOrderResponse = {
  __typename?: 'FlywireValidatePaymentOrderResponse';
  redirect_url: Scalars['String']['output'];
};

export type FlywireValidatePaymentOrderResponseFlywirePaymentProcessingResponsePaymentErrorNode = FlywirePaymentProcessingResponse | FlywireValidatePaymentOrderResponse | PaymentErrorNode;

export enum FolderDeleteTypeEnum {
  DeleteFolderAndDocument = 'DELETE_FOLDER_AND_DOCUMENT',
  DeleteFolderDocumentAndUserDocument = 'DELETE_FOLDER_DOCUMENT_AND_USER_DOCUMENT',
  DeleteOnlyFolder = 'DELETE_ONLY_FOLDER'
}

export type FolderInfo = {
  __typename?: 'FolderInfo';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Subgraph END USER - Folder Info Category Node */
export type FolderInfoCategoryNode = {
  __typename?: 'FolderInfoCategoryNode';
  /** Copilot Prompt */
  copilot_prompts: Array<DocumentInfoCategoryNode>;
  /** Folder Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Icon ID */
  icon_id?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['String']['output'];
  /** Folder Name */
  name: Scalars['String']['output'];
};

export type FolderInfoCategoryNodeCustomConnection = {
  __typename?: 'FolderInfoCategoryNodeCustomConnection';
  edges: Array<FolderInfoCategoryNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type FolderInfoCategoryNodeCustomEdge = {
  __typename?: 'FolderInfoCategoryNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: FolderInfoCategoryNode;
};

/** Subgraph HRIS - Folder Info Node */
export type FolderInfoNode = {
  __typename?: 'FolderInfoNode';
  /** Folder Creation Date */
  created_at: Scalars['String']['output'];
  /** Folder Description */
  description: Scalars['String']['output'];
  document_application_count: Scalars['Int']['output'];
  /** Folder Creation Date */
  document_count: Scalars['Int']['output'];
  /** Folder Feature Type */
  feature_type?: Maybe<FeatureTypeEnum>;
  /** True if folder has documents that has users */
  has_users: Scalars['Boolean']['output'];
  /** Folder icon */
  icon_id?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['Int']['output'];
  /** Folder Name */
  name: Scalars['String']['output'];
  /** Folder Document Progress */
  total_progress: Scalars['Int']['output'];
  /** Folder Visualization Type */
  visualization_type: FolderVisualizationTypeEnum;
};

export type FolderInfoNodeCustomConnection = {
  __typename?: 'FolderInfoNodeCustomConnection';
  edges: Array<FolderInfoNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type FolderInfoNodeCustomEdge = {
  __typename?: 'FolderInfoNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: FolderInfoNode;
};

/** Subgraph HRIS - Folder Metrics Info Node */
export type FolderMetricsInfoNode = {
  __typename?: 'FolderMetricsInfoNode';
  application_progress: DocumentMetricDetailInfoNode;
  reading_progress: DocumentMetricDetailInfoNode;
  signature_progress: DocumentMetricDetailInfoNode;
  total_progress: DocumentMetricDetailInfoNode;
};

/** Subgraph HRIS - Folder User Profile Info Node */
export type FolderUserProfileInfoNode = {
  __typename?: 'FolderUserProfileInfoNode';
  /** Folder Description */
  description: Scalars['String']['output'];
  /** Folder document count */
  document_count: Scalars['Int']['output'];
  /** ID */
  id: Scalars['Int']['output'];
  /** Folder Name */
  name: Scalars['String']['output'];
  /** Folder total progress */
  total_progress: Scalars['Int']['output'];
};

export type FolderUserProfileInfoNodeCustomConnection = {
  __typename?: 'FolderUserProfileInfoNodeCustomConnection';
  edges: Array<FolderUserProfileInfoNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type FolderUserProfileInfoNodeCustomConnectionHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError = FolderUserProfileInfoNodeCustomConnection | HrisQueryIntegrityError | HrisQueryInternalError | HrisQueryValidationError;

export type FolderUserProfileInfoNodeCustomEdge = {
  __typename?: 'FolderUserProfileInfoNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: FolderUserProfileInfoNode;
};

export enum FolderVisualizationTypeEnum {
  PrivateVisualization = 'PRIVATE_VISUALIZATION',
  PublicVisualization = 'PUBLIC_VISUALIZATION'
}

/** Returned when a user is not authorized to access a resource (403). */
export type ForbiddenErrorResponse = {
  __typename?: 'ForbiddenErrorResponse';
  /** Error code */
  code: Scalars['String']['output'];
  /** Operation ID for tracing */
  graphql_operation_id: Scalars['ID']['output'];
  /** Error message */
  message: Scalars['String']['output'];
};

/** ErrorType: User does not have sufficient permissions */
export type ForbiddenErrorV2 = {
  __typename?: 'ForbiddenErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type FormatValidationResponse = {
  __typename?: 'FormatValidationResponse';
  graphql_operation_id: Scalars['ID']['output'];
  is_valid: Scalars['Boolean']['output'];
};

export type FoundationHomeIntegrityError = GraphOperationI & {
  __typename?: 'FoundationHomeIntegrityError';
  code: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

export type FoundationHomeInternalError = GraphOperationI & {
  __typename?: 'FoundationHomeInternalError';
  code: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

export type FoundationHomeSpanConfig = {
  __typename?: 'FoundationHomeSpanConfig';
  lg: Scalars['Int']['output'];
  md: Scalars['Int']['output'];
  sm: Scalars['Int']['output'];
};

export type FoundationHomeUserIntegrityError = GraphOperationI & {
  __typename?: 'FoundationHomeUserIntegrityError';
  code: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

export type FoundationHomeUserInternalError = GraphOperationI & {
  __typename?: 'FoundationHomeUserInternalError';
  code: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

export type FoundationHomeUserQuery = {
  __typename?: 'FoundationHomeUserQuery';
  get_last_activity_by_user?: Maybe<GetLastActivityByUserResponse>;
  get_my_assigned_courses: MyAssignedCourseResponse;
  get_my_assigned_courses_optimized: MyAssignedCourseInfoV2ConnectionQueryValidationErrorQueryInternalError;
  get_my_learning_paths: MyLearningPathResponse;
  /** Retrieve widgets config by user session */
  get_widgets_config?: Maybe<FoundationHomeWidgetsResponse>;
};


export type FoundationHomeUserQueryGet_My_Assigned_CoursesArgs = {
  input: MyAssignedCoursesInput;
};


export type FoundationHomeUserQueryGet_My_Assigned_Courses_OptimizedArgs = {
  input: MyAssignedCoursesInputV2;
};


export type FoundationHomeUserQueryGet_My_Learning_PathsArgs = {
  input: MyAssignedPathsInput;
};

export type FoundationHomeUserValidationError = GraphOperationI & {
  __typename?: 'FoundationHomeUserValidationError';
  code: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

export type FoundationHomeValidationError = GraphOperationI & {
  __typename?: 'FoundationHomeValidationError';
  code: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

export type FoundationHomeWidget = {
  __typename?: 'FoundationHomeWidget';
  identifier: Scalars['String']['output'];
  span_config: FoundationHomeSpanConfig;
};

export type FoundationHomeWidgetsConfigPayload = {
  __typename?: 'FoundationHomeWidgetsConfigPayload';
  widgets: Array<FoundationHomeWidget>;
};

export type FoundationHomeWidgetsResponse = FoundationHomeUserIntegrityError | FoundationHomeUserInternalError | FoundationHomeUserValidationError | FoundationHomeWidgetsConfigPayload;

export type FoundationLeaderIntegrityError = GraphOperationI & {
  __typename?: 'FoundationLeaderIntegrityError';
  code: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

export type FoundationLeaderInternalError = GraphOperationI & {
  __typename?: 'FoundationLeaderInternalError';
  code: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

export type FoundationLeaderQuery = {
  __typename?: 'FoundationLeaderQuery';
  get_assigned_courses: AssignedCourseResponse;
  get_count_users_by_boss_on_current_session: UsersByBossOnCurrentSessionResponse;
  get_global_learning_progress: GlobalLearningProgressResponse;
  get_groups_comparison: GroupComparisonResponse;
  get_learning_paths: LearningPathResponse;
  get_positions_by_users: GetPositionByUsersResponse;
  get_student_ranking: StudentRankingResponse;
  get_users_by_assigned_courses: UserAssignedCourseResponse;
  get_users_by_learning_paths: UserLearningPathResponse;
  get_widgets_config: FoundationWidgetsConfigResponse;
};


export type FoundationLeaderQueryGet_Assigned_CoursesArgs = {
  input: GetAssignedCoursesInput;
};


export type FoundationLeaderQueryGet_Count_Users_By_Boss_On_Current_SessionArgs = {
  input: GetUsersByBossOnCurrentSessionInput;
};


export type FoundationLeaderQueryGet_Global_Learning_ProgressArgs = {
  input: GetGlobalLearningProgressInput;
};


export type FoundationLeaderQueryGet_Groups_ComparisonArgs = {
  input: GetGroupsComparisonInput;
};


export type FoundationLeaderQueryGet_Learning_PathsArgs = {
  input: GetLearningPathInput;
};


export type FoundationLeaderQueryGet_Student_RankingArgs = {
  input: GetStudentRankingInput;
};


export type FoundationLeaderQueryGet_Users_By_Assigned_CoursesArgs = {
  input: GetUsersByCourseInput;
};


export type FoundationLeaderQueryGet_Users_By_Learning_PathsArgs = {
  input: GetUsersByLearningPathInput;
};

export type FoundationLeaderValidationError = GraphOperationI & {
  __typename?: 'FoundationLeaderValidationError';
  code: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

export type FoundationLeaderWidget = {
  __typename?: 'FoundationLeaderWidget';
  identifier: Scalars['String']['output'];
  span_config: Array<FoundationSpanConfig>;
};

export type FoundationReportsBuilder = {
  __typename?: 'FoundationReportsBuilder';
  get_reports: Array<ReportType>;
};

export type FoundationReportsMutations = {
  __typename?: 'FoundationReportsMutations';
  generate_report: GenerateReportResponse;
  generate_report_by_group: GenerateReportResponse;
};

export type FoundationSpanConfig = {
  __typename?: 'FoundationSpanConfig';
  lg: Scalars['String']['output'];
  md: Scalars['String']['output'];
  sm: Scalars['String']['output'];
};

export type FoundationWidgetsConfigPayload = {
  __typename?: 'FoundationWidgetsConfigPayload';
  widgets: Array<FoundationLeaderWidget>;
};

export type FoundationWidgetsConfigResponse = FoundationLeaderIntegrityError | FoundationLeaderInternalError | FoundationLeaderValidationError | FoundationWidgetsConfigPayload;

export type FourthLevelAreaInput = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  area_level_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type FreeTrial = {
  __typename?: 'FreeTrial';
  activate_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  organization_id: Scalars['ID']['output'];
  status: FreeTrialStatusEnum;
  terms_and_conditions: Scalars['Boolean']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export enum FreeTrialStatusEnum {
  StatusEnded = 'STATUS_ENDED',
  StatusInitializing = 'STATUS_INITIALIZING',
  StatusNotStarted = 'STATUS_NOT_STARTED',
  StatusStarted = 'STATUS_STARTED'
}

/** Reminder frequency strategy */
export enum FrequencyType {
  CustomCalendar = 'CUSTOM_CALENDAR',
  CustomInterval = 'CUSTOM_INTERVAL',
  Smart = 'SMART',
  Weekly = 'WEEKLY'
}

export type Gamification = {
  __typename?: 'Gamification';
  get_configuration?: Maybe<PrivateCurrencyPointFragment>;
  get_gamification_detail?: Maybe<UserCurrencyPointFragment>;
  get_leaderboard: PrivateLeaderboardListType;
  get_leaderboard_boxes?: Maybe<PrivateLeaderboardBoxesType>;
  get_reward_configuration: PrivateRewardListType;
  get_user_assigment_configuration: PrivateLeaderboardListType;
  get_user_rewards: UserRewardListType;
};


export type GamificationGet_ConfigurationArgs = {
  input: QueryCurrencyPointInput;
};


export type GamificationGet_Gamification_DetailArgs = {
  input: QueryCurrencyPointInput;
};


export type GamificationGet_LeaderboardArgs = {
  input: QueryAllowedUserInput;
};


export type GamificationGet_Leaderboard_BoxesArgs = {
  input: QueryLeaderboardBoxInput;
};


export type GamificationGet_Reward_ConfigurationArgs = {
  input: QueryRewardInput;
};


export type GamificationGet_User_Assigment_ConfigurationArgs = {
  input: QueryAllowedUserInput;
};


export type GamificationGet_User_RewardsArgs = {
  input: QueryRewardInput;
};

export type GamificationImageType = {
  __typename?: 'GamificationImageType';
  /** Base64 representation of this image thumbnail */
  placeholder: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type GamificationMetadata = {
  __typename?: 'GamificationMetadata';
  total_count: Scalars['Int']['output'];
  total_filtered: Scalars['Int']['output'];
};

export type GamificationNumPageInfo = GamificationPageInfoInterface & {
  __typename?: 'GamificationNumPageInfo';
  /** When paginating forwards, are there more items? */
  has_next_page: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  has_previous_page: Scalars['Boolean']['output'];
  page_size: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type GamificationPageInfoInterface = {
  /** When paginating forwards, are there more items? */
  has_next_page: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  has_previous_page: Scalars['Boolean']['output'];
};

export enum GamificationStatusEnum {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum GateConditionType {
  CompleteAll = 'COMPLETE_ALL',
  CompletePercentage = 'COMPLETE_PERCENTAGE',
  CompleteSome = 'COMPLETE_SOME'
}

export enum GateTiming {
  DaysAfterAssignment = 'DAYS_AFTER_ASSIGNMENT',
  DaysAfterDeadline = 'DAYS_AFTER_DEADLINE',
  Immediate = 'IMMEDIATE'
}

export enum GaussBellColorEnum {
  GaussBellColorAquamarine = 'GAUSS_BELL_COLOR_AQUAMARINE',
  GaussBellColorBlue = 'GAUSS_BELL_COLOR_BLUE',
  GaussBellColorGreen = 'GAUSS_BELL_COLOR_GREEN',
  GaussBellColorOrange = 'GAUSS_BELL_COLOR_ORANGE',
  GaussBellColorRed = 'GAUSS_BELL_COLOR_RED',
  GaussBellColorRedWine = 'GAUSS_BELL_COLOR_RED_WINE',
  GaussBellColorYellow = 'GAUSS_BELL_COLOR_YELLOW'
}

export enum GenderEnum {
  Men = 'MEN',
  Other = 'OTHER',
  Women = 'WOMEN'
}

export enum GenderEnumInput {
  Empty = 'EMPTY',
  Men = 'MEN',
  Other = 'OTHER',
  Women = 'WOMEN'
}

export type GeneralProgress = {
  __typename?: 'GeneralProgress';
  progress_courses?: Maybe<CompletedItems>;
  progress_routes?: Maybe<CompletedItems>;
};

export enum GeneralReportUserStatusEnum {
  UserActive = 'USER_ACTIVE',
  UserDeleted = 'USER_DELETED',
  UserInactive = 'USER_INACTIVE',
  UserPending = 'USER_PENDING'
}

/** QUERIES */
export type GeneralReportsQueries = {
  __typename?: 'GeneralReportsQueries';
  get_general_dashboard_report?: Maybe<TalentReportsGeneralDashboardReportResponse>;
  get_talent_processes_by_company?: Maybe<TalentGeneralReportsResultResponse>;
  list_dashboard_employee_results?: Maybe<TalentListDashboardEmployeeResultsResponse>;
  list_employee_results?: Maybe<TalentReportsEmployeeResultsResponse>;
  /** TLNT-4779: tabla paginada "Resultados por colaborador" (admin y líder). */
  list_performance_employee_results?: Maybe<TalentReportsEmployeeResultsResponse>;
  talent_general_reports_administrator: TalentReportsAdministratorQuery;
};


/** QUERIES */
export type GeneralReportsQueriesGet_General_Dashboard_ReportArgs = {
  input: TalentReportsGeneralDashboardReportInput;
};


/** QUERIES */
export type GeneralReportsQueriesGet_Talent_Processes_By_CompanyArgs = {
  filter: TalentProcessesFilterInput;
};


/** QUERIES */
export type GeneralReportsQueriesList_Dashboard_Employee_ResultsArgs = {
  input: TalentDashboardResultsInput;
};


/** QUERIES */
export type GeneralReportsQueriesList_Employee_ResultsArgs = {
  input: TalentReportsEmployeeResultsInput;
};


/** QUERIES */
export type GeneralReportsQueriesList_Performance_Employee_ResultsArgs = {
  input: TalentReportsEmployeeResultsInput;
};

export enum GeneralSheetsEnum {
  ActivitySheet = 'ACTIVITY_SHEET',
  CourseSheet = 'COURSE_SHEET',
  GeneralSheet = 'GENERAL_SHEET',
  PerformanceSheet = 'PERFORMANCE_SHEET'
}

export type GenerateApplicantOtpPayload = {
  __typename?: 'GenerateApplicantOTPPayload';
  applicant_uid: Scalars['String']['output'];
  email: Scalars['String']['output'];
  expires_in_min: Scalars['Int']['output'];
};

export type GenerateCertificateInput = {
  /** Event type that triggers the certificate generation. */
  certificate_event_type: CertificateEventType;
  /** Document type to generate. When null or omitted, all configured document types for the course are generated (DIPLOMA and/or ACCREDITATION). */
  document_type_enum?: InputMaybe<CertificateDocumentTypeEnum>;
  /** ID of the enrollment to generate a certificate for. */
  enrollment_id: Scalars['ID']['input'];
  /** When True, skips the idempotency check and validation rules, forcing regeneration even if the certificate already exists. Use only for manual recovery operations. */
  force_regenerate?: InputMaybe<Scalars['Boolean']['input']>;
  /** When True, skips validation rules and uses debug template data. */
  is_debug?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization identifier. */
  organization_id: Scalars['Int']['input'];
};

export type GenerateCustomFieldTemplateResponse = {
  __typename?: 'GenerateCustomFieldTemplateResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  template_url?: Maybe<Scalars['String']['output']>;
};

export type GenerateDatafastCheckoutIdInput = {
  /** Payment gateway organization ID */
  gateway_org_id?: InputMaybe<Scalars['Int']['input']>;
  /** Invoice data ID */
  invoice_data_id: Scalars['Int']['input'];
  /** Payment method ID */
  payment_method_id?: InputMaybe<Scalars['Int']['input']>;
  /** Product ID */
  product_id: Scalars['Int']['input'];
};

export type GenerateDatafastCheckoutIdResponse = {
  __typename?: 'GenerateDatafastCheckoutIdResponse';
  checkout_id?: Maybe<Scalars['String']['output']>;
  redirect_url?: Maybe<Scalars['String']['output']>;
  /**
   * This object contains information about the response code,
   *         response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerateDefaultConfigInput = {
  /** Organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Default folder ID for all documents */
  default_folder_id?: InputMaybe<Scalars['Int']['input']>;
  /** Default visibility for all documents */
  default_visible?: Scalars['Boolean']['input'];
  /** List of uploaded file names to generate config for */
  file_names: Array<Scalars['String']['input']>;
  /** Unique identifier for the upload session */
  upload_uuid: Scalars['String']['input'];
};

export type GenerateDefaultConfigPayload = {
  __typename?: 'GenerateDefaultConfigPayload';
  /** Count of items with errors */
  error_count: Scalars['Int']['output'];
  /** GraphQL operation ID for tracking */
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** List of generated configuration items */
  items: Array<GeneratedConfigItem>;
  /** Count of valid items */
  valid_count: Scalars['Int']['output'];
};

export type GenerateDispersionLayoutPreviewInput = {
  /** ID de la organización centralizada (owner). */
  centralized_organization_id: Scalars['ID']['input'];
  /** CLABE de origen para el flujo de alta. Se ignora si se envía dispersion_account_id; si falta, se usa una CLABE ficticia. */
  clabe?: InputMaybe<Scalars['String']['input']>;
  /** ID de la cuenta de dispersión. Requerido para previsualizar la configuración guardada; omitirlo previsualiza una configuración enviada en la petición (flujo de alta, cuando la cuenta aún no existe). */
  dispersion_account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Codificación de una configuración sin guardar: 'utf8' o 'latin1'. Se envía junto con file_format y separator. */
  encoding?: InputMaybe<Scalars['String']['input']>;
  /** Formato de archivo de una configuración sin guardar: 'txt_estandar', 'csv' o 'fixed_width'. Se envía junto con separator y encoding. */
  file_format?: InputMaybe<Scalars['String']['input']>;
  /** ID de la razón social a la que pertenece la cuenta. */
  legal_entity_id: Scalars['ID']['input'];
  /** Separador de una configuración sin guardar: 'pipe', 'comma', 'tab' o 'semicolon'. Se envía junto con file_format y encoding. */
  separator?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateDispersionLayoutPreviewResponse = DispersionLayoutPreviewResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GenerateErrorReportResponse = {
  __typename?: 'GenerateErrorReportResponse';
  download_url?: Maybe<Scalars['String']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GenerateImssMovementErrorItem = {
  __typename?: 'GenerateImssMovementErrorItem';
  payroll_employee_id: Scalars['UUID']['output'];
  reason: Scalars['String']['output'];
};

export type GenerateImssMovementsInput = {
  legal_entity_id: Scalars['UUID']['input'];
  period_id: Scalars['UUID']['input'];
};

export type GenerateImssMovementsResponse = {
  __typename?: 'GenerateImssMovementsResponse';
  errors: Array<GenerateImssMovementErrorItem>;
  generated: Scalars['Int']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  incomplete: Scalars['Int']['output'];
  movements: Array<GeneratedMovementItem>;
  skipped: Scalars['Int']['output'];
};

export type GenerateImssMovementsResult = GenerateImssMovementsResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GenerateInvitationLinkInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
};

export type GenerateJobApplicantOtpInput = {
  applicant_uid: Scalars['String']['input'];
  email: Scalars['String']['input'];
  has_accepted_term: Scalars['Boolean']['input'];
  vacancy_uid: Scalars['String']['input'];
};

export type GenerateJobApplicantOtpResponse = GenerateApplicantOtpPayload | InternalErrorV2 | ValidationErrorV2;

export type GenerateMassiveUploadErrorReportInput = {
  errors: Array<ValidationErrorInput>;
  organization_id: Scalars['Int']['input'];
  upload_uuid: Scalars['String']['input'];
};

export type GenerateMassiveUploadTemplateInput = {
  /** List of document names that passed validation */
  document_names: Array<Scalars['String']['input']>;
  /** Organization ID */
  organization_id: Scalars['Int']['input'];
  /** UUID of the upload session (to pre-fill validated documents) */
  upload_uuid: Scalars['String']['input'];
};

export type GenerateMassiveUploadTemplatePayload = {
  __typename?: 'GenerateMassiveUploadTemplatePayload';
  /** Number of documents included in template */
  document_count: Scalars['Int']['output'];
  /** URL to download the template */
  download_url?: Maybe<Scalars['String']['output']>;
  /** Error message if generation failed */
  error_message?: Maybe<Scalars['String']['output']>;
  /** File ID of the generated Excel template */
  file_id?: Maybe<Scalars['Int']['output']>;
  /** Number of folders available for selection */
  folder_count: Scalars['Int']['output'];
  /** GraphQL operation ID for tracking */
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** Whether the template was generated */
  success: Scalars['Boolean']['output'];
};

export type GenerateMassiveUploadUuidResponse = {
  __typename?: 'GenerateMassiveUploadUuidResponse';
  success: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type GeneratePositionDescriptionInput = {
  /** Organization ID */
  organization_id: Scalars['Int']['input'];
  /** Job title to generate the description */
  position_name: Scalars['String']['input'];
};

/** Payload returned after generating position description with AI */
export type GeneratePositionDescriptionPayload = {
  __typename?: 'GeneratePositionDescriptionPayload';
  /** Funciones y responsabilidades del cargo generadas por IA */
  functions_description: Scalars['String']['output'];
  /** Descripción general del cargo generada por IA */
  general_description: Scalars['String']['output'];
  graphql_operation_id: Scalars['ID']['output'];
};

export type GeneratePositionDescriptionResponse = GeneratePositionDescriptionPayload | InternalErrorResponse | ValidationErrorResponse;

export type GeneratePositionKeywordsInput = {
  /** List of keywords to exclude */
  exclude_keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Job Overview */
  job_description: Scalars['String']['input'];
  /** Roles and responsibilities of the position */
  job_functions: Scalars['String']['input'];
  /** Organization ID */
  organization_id: Scalars['Int']['input'];
};

/** Payload returned after generating position keywords with AI */
export type GeneratePositionKeywordsPayload = {
  __typename?: 'GeneratePositionKeywordsPayload';
  graphql_operation_id: Scalars['ID']['output'];
  /** Lista de palabras clave generadas por IA */
  keywords_generated: Array<PositionKeywordTemporal>;
  /** Total de palabras clave generadas */
  total_generated: Scalars['Int']['output'];
};

export type GeneratePositionKeywordsResponse = GeneratePositionKeywordsPayload | InternalErrorResponse | ValidationErrorResponse;

export type GeneratePreSignedUrlResponse = {
  __typename?: 'GeneratePreSignedUrlResponse';
  error?: Maybe<ErrorResponse>;
  pre_signed_data?: Maybe<PreSignedData>;
  success: Scalars['Boolean']['output'];
};

/** Input to list employees from matched positions (STEP 2). */
export type GenerateRecommendationsInput = {
  centralized_organization_id: Scalars['Int']['input'];
  target_position_ids: Array<Scalars['Int']['input']>;
};

export type GenerateRecommendationsResponse = ForbiddenErrorResponse | GenerateRecommendationsSuccess | InternalErrorResponse | NotFoundResponse | ValidationErrorResponse;

/** Successful recommendation generation response. */
export type GenerateRecommendationsSuccess = {
  __typename?: 'GenerateRecommendationsSuccess';
  candidates: Array<RecommendationCandidateNode>;
  graphql_operation_id: Scalars['ID']['output'];
  total_candidates: Scalars['Int']['output'];
};

export type GenerateReportResponse = {
  __typename?: 'GenerateReportResponse';
  async_process: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  report_id: Scalars['String']['output'];
};

export type GenerateSaml2AssertionInput = {
  assertion_validity_seconds?: Scalars['Int']['input'];
  authn_request_id?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
  relay_state?: InputMaybe<Scalars['String']['input']>;
  sp_entity_id: Scalars['String']['input'];
};

export type GenerateSaml2SpAuthnRequestInput = {
  binding?: Scalars['String']['input'];
  centralized_organization_id: Scalars['ID']['input'];
  idp_entity_id: Scalars['String']['input'];
  relay_state?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateTemplateDocumentPdfInput = {
  centralized_organization_id: Scalars['Int']['input'];
  centralized_user_id: Scalars['Int']['input'];
  template_id: Scalars['Int']['input'];
};

export type GenerateTemplateDocumentPreviewInput = {
  centralized_organization_id: Scalars['Int']['input'];
  centralized_user_id: Scalars['Int']['input'];
  template_id: Scalars['Int']['input'];
};

export type GenerateTrackCertificateInput = {
  is_debug?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id: Scalars['Int']['input'];
  user_team_id: Scalars['Int']['input'];
};

export type GeneratedConfigItem = {
  __typename?: 'GeneratedConfigItem';
  /** Document name extracted from filename */
  document_name: Scalars['String']['output'];
  /** Email extracted from filename */
  email: Scalars['String']['output'];
  /** Original file name */
  file_name: Scalars['String']['output'];
  /** Default folder ID */
  folder_id?: Maybe<Scalars['Int']['output']>;
  /** Default folder name */
  folder_name?: Maybe<Scalars['String']['output']>;
  /** Whether the file passed basic validation */
  is_valid: Scalars['Boolean']['output'];
  /** Validation error message if is_valid is False */
  validation_error?: Maybe<Scalars['String']['output']>;
  /** Default visibility */
  visible: Scalars['Boolean']['output'];
};

export type GeneratedMovementItem = {
  __typename?: 'GeneratedMovementItem';
  event_origin_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  movement_date: Scalars['Date']['output'];
  movement_type: Scalars['String']['output'];
  payroll_employee_id: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
};

export type GenericConditionalInput = {
  data_type: SegmentationDataTypeEnum;
  field_id?: InputMaybe<Scalars['Int']['input']>;
  values: Array<GenericConditionalValueInput>;
};

export type GenericConditionalValueInput = {
  area_ids?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  operation: SegmentationConditionalEnum;
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GenericMetadataType = {
  total_count: Scalars['Int']['output'];
  total_filtered: Scalars['Int']['output'];
};

export enum GenericOrderByEnum {
  OrderByAz = 'ORDER_BY_AZ',
  OrderByCreatedAt = 'ORDER_BY_CREATED_AT',
  OrderByZa = 'ORDER_BY_ZA'
}

export type GenericTeamConditionalInput = {
  data_type: SegmentationDataTypeEnum;
  field_id?: InputMaybe<Scalars['Int']['input']>;
  values: Array<TeamConditionalValueInput>;
};

export type GerUserByTaskInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<OrderByInput>;
  search_key?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['ID']['input']>;
  workflow_id: Scalars['ID']['input'];
};

export type GetActiveContractInput = {
  centralized_user_id: Scalars['Int']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type GetActiveContractResponse = {
  __typename?: 'GetActiveContractResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmployeeContractType;
};

export type GetActiveContractResult = GetActiveContractResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetAssignedCoursesInput = {
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination: PaginationInput;
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<SearchInput>;
};

export type GetAttendanceDailyManagementReportInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  /** Ids **centralizados** de colaboradores a filtrar (no los de learning: para la misma persona son números distintos). Máximo 500. Una lista vacía significa 'ningún colaborador', no 'sin filtro'. */
  centralized_users_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from_date?: InputMaybe<Scalars['Date']['input']>;
  /** Id de la organización en **learning** — el mismo que valida la sesión. */
  organization_id: Scalars['ID']['input'];
  to_date?: InputMaybe<Scalars['Date']['input']>;
};

export type GetAttendanceMarksReportInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  /** Ids **centralizados** de colaboradores a filtrar (no los de learning: para la misma persona son números distintos). Máximo 500. Una lista vacía significa 'ningún colaborador', no 'sin filtro'. */
  centralized_users_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from_date?: InputMaybe<Scalars['Date']['input']>;
  /** Id de la organización en **learning** — el mismo que valida la sesión. */
  organization_id: Scalars['ID']['input'];
  to_date?: InputMaybe<Scalars['Date']['input']>;
};

export type GetAttendanceShiftsReportInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from_date?: InputMaybe<Scalars['Date']['input']>;
  /** Id de la organización en **learning** — el mismo que valida la sesión. El scoping de las tablas de asistencia usa el id centralizado, que se resuelve a partir de este. */
  organization_id: Scalars['ID']['input'];
  to_date?: InputMaybe<Scalars['Date']['input']>;
};

export type GetAttendanceShiftsScheduleReportInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  /** Ids **centralizados** de colaboradores a filtrar (no los de learning: para la misma persona son números distintos). Máximo 500. Una lista vacía significa 'ningún colaborador', no 'sin filtro'. */
  centralized_users_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from_date?: InputMaybe<Scalars['Date']['input']>;
  /** Id de la organización en **learning** — el mismo que valida la sesión. */
  organization_id: Scalars['ID']['input'];
  to_date?: InputMaybe<Scalars['Date']['input']>;
};

export type GetAuth2User = {
  __typename?: 'GetAuth2User';
  user_organization: CrehanaAuthUserOrganization;
};

export type GetAuth2UserQueryValidationError = GetAuth2User | QueryValidationError;

export type GetBankResponse = BankResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetBanksResponse = BankListResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetBlockPlayerByOrganizationCourseInput = {
  course_id: Scalars['Int']['input'];
  organization_id: Scalars['Int']['input'];
};

export type GetBlockPlayerByOrganizationCourseType = {
  __typename?: 'GetBlockPlayerByOrganizationCourseType';
  is_block_player_enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GetBlockPlayerByOrganizationInput = {
  organization_id: Scalars['Int']['input'];
};

export type GetBlockPlayerByOrganizationType = {
  __typename?: 'GetBlockPlayerByOrganizationType';
  crehana_and_partner_courses_activated?: Maybe<Scalars['Boolean']['output']>;
  own_courses_activated?: Maybe<Scalars['Boolean']['output']>;
};

export type GetByIdInput = {
  id: Scalars['ID']['input'];
};

export type GetCanDeleteEmployerRegistrationResponse = CanDeleteEmployerRegistrationResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetCanDeleteLegalEntityResponse = CanDeleteLegalEntityResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input for get_centralized_headquarters query */
export type GetCentralizedHeadquartersInput = {
  /** ID de la organizacion centralizada */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtro por codigo de pais ISO 3166-1 alpha-2 */
  country_code?: InputMaybe<Scalars['String']['input']>;
  /** Cantidad de registros por pagina (max 200) */
  limit?: Scalars['Int']['input'];
  /** Desplazamiento para paginacion */
  offset?: Scalars['Int']['input'];
  /** Busqueda parcial por nombre de sede */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Payload for get_centralized_headquarters query */
export type GetCentralizedHeadquartersPayload = {
  __typename?: 'GetCentralizedHeadquartersPayload';
  /** List of headquarters with complete address */
  results: Array<CentralizedHeadquarterNode>;
  /** Total count of headquarters matching the filters */
  total_count: Scalars['Int']['output'];
};

export type GetCentralizedHeadquartersResponse = GetCentralizedHeadquartersPayload | InternalErrorResponse;

export type GetCentralizedProductsInput = {
  centralized_organization_id: Scalars['ID']['input'];
};

export type GetCentralizedProductsPayload = {
  __typename?: 'GetCentralizedProductsPayload';
  products: Array<CentralizedProduct>;
};

export type GetCentralizedProductsPayloadQueryValidationErrorQueryInternalServerError = GetCentralizedProductsPayload | QueryInternalServerError | QueryValidationError;

export type GetCentralizedUserFromTalent = {
  talent_company_id: Scalars['ID']['input'];
  talent_employee_id: Scalars['ID']['input'];
};

export type GetCentralizedUserIdsInput = {
  enterprise_slug: Scalars['String']['input'];
  internal_user_id: Scalars['Int']['input'];
};

export type GetCentralizedUserOrganizationsResponse = CentralizedUserOrganizationConnection | ForbiddenErrorResponse | InternalErrorResponse | ValidationErrorResponse;

export type GetCertificateOrganizationNamesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['Int']['input'];
  search?: InputMaybe<SearchInput>;
};

export type GetCertificatesInput = {
  certificate_type_filter_enum?: InputMaybe<CertificateTypeFilterEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type GetChildrenCompaniesDetailNode = {
  __typename?: 'GetChildrenCompaniesDetailNode';
  countries: Array<MultipleOperandCountry>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  industry: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type GetChildrenCompaniesInput = {
  centralized_organization_id: Scalars['String']['input'];
  order?: InputMaybe<GetChildrenCompaniesOrderInput>;
  pagination: CentralizedCorporationsOffsetPaginationInput;
  search?: InputMaybe<CentralizedCorporationsSearchInput>;
};

export type GetChildrenCompaniesLicensesInput = {
  centralized_organization_id: Scalars['Int']['input'];
};

export type GetChildrenCompaniesNode = {
  __typename?: 'GetChildrenCompaniesNode';
  children_orgs: Array<GetChildrenCompaniesDetailNode>;
  total_count: Scalars['Int']['output'];
};

export type GetChildrenCompaniesNodeIntegrityErrorResponseInternalErrorResponseValidationErrorResponseNotFoundResponseNotAuthenticatedErrorResponse = GetChildrenCompaniesNode | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export enum GetChildrenCompaniesOrderEnum {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export type GetChildrenCompaniesOrderInput = {
  asc: Scalars['Boolean']['input'];
  field: GetChildrenCompaniesOrderEnum;
};

export type GetChildrenCompaniesQuery = {
  __typename?: 'GetChildrenCompaniesQuery';
  /** Get children organizations */
  get_children_orgs: GetChildrenCompaniesNodeIntegrityErrorResponseInternalErrorResponseValidationErrorResponseNotFoundResponseNotAuthenticatedErrorResponse;
};


export type GetChildrenCompaniesQueryGet_Children_OrgsArgs = {
  input: GetChildrenCompaniesInput;
};

export enum GetChildrenCompaniesSearchFieldsEnum {
  Name = 'NAME'
}

export type GetCompetencesResultsReportInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  /** **Centralized** collaborator ids to filter by (not the learning ones: different numbers for the same person). Max 500. An empty list means 'no collaborator', not 'no filter'. */
  centralized_users_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Competences evaluation ids in Talent (the number the admin sees; stored as `4M<id>P`). Without it every competences process of the organization is returned. Max 500. An empty list means 'no process', not 'no filter'. */
  evaluation_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  /** **Learning** organization id — the one the session validates. The report scopes by the centralized id and Talent's `company_id`, both resolved from it. */
  organization_id: Scalars['ID']['input'];
};

export type GetContractInput = {
  centralized_user_id: Scalars['Int']['input'];
  contract_id: Scalars['UUID']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type GetContractResponse = {
  __typename?: 'GetContractResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmployeeContractType;
};

export type GetContractResult = GetContractResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse;

export type GetContractSalaryInfoInput = {
  centralized_user_id: Scalars['Int']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type GetContractSalaryInfoResponse = {
  __typename?: 'GetContractSalaryInfoResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: ContractSalaryInfoType;
};

export type GetContractSalaryInfoResult = GetContractSalaryInfoResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetCopilotPlannerFileInput = {
  /** UUID del archivo generado por el Planner Agent a consultar. */
  file_id: Scalars['ID']['input'];
  /** Conversación del solicitante; opcional. Ayuda al Planner Agent a resolver su user_id desde el contexto de sesión (con fallback por auth_session). */
  session_id?: InputMaybe<Scalars['String']['input']>;
};

export type GetCopilotPlannerReportAccessesInput = {
  /** UUID del reporte del Planner Agent cuyos accesos se consultan. */
  report_id: Scalars['ID']['input'];
};

export type GetCopilotPlannerReportPromptInput = {
  /** UUID del reporte del Planner Agent. */
  report_id: Scalars['ID']['input'];
};

export type GetCopilotPlannerReportValuesInput = {
  /** UUID del reporte del Planner Agent a consultar. */
  report_id: Scalars['ID']['input'];
};

export type GetCopilotPlannerReportsInput = {
  /** Si es True, lista los reportes archivados del owner (GET /reports/archived) en vez de los vigentes visibles (GET /reports). */
  archived?: Scalars['Boolean']['input'];
  /** Tamaño de página (1..100). Por defecto 25; valores fuera de rango son un error de validación. */
  limit?: Scalars['Int']['input'];
  /** Desplazamiento de paginación (>= 0). */
  offset?: Scalars['Int']['input'];
};

export type GetCorporationChildrenOrgLicensesNode = {
  __typename?: 'GetCorporationChildrenOrgLicensesNode';
  centralized_organization_id: Scalars['Int']['output'];
  licenses: GetLicensesDistributionNode;
};

export type GetCorporationChildrenOrgLicensesNodeIntegrityErrorResponseInternalErrorResponseValidationErrorResponseNotFoundResponseNotAuthenticatedErrorResponse = GetCorporationChildrenOrgLicensesNode | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type GetCourseOrganizationTemplatesInput = {
  course_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  template_type_enum?: InputMaybe<TemplateTypeEnum>;
  template_type_enums?: InputMaybe<Array<TemplateTypeEnum>>;
};

export type GetCourseOrganizationTemplatesNode = {
  __typename?: 'GetCourseOrganizationTemplatesNode';
  course_organization_templates?: Maybe<Array<CourseOrganizationTemplateNode>>;
  organization_template_defaults?: Maybe<Array<OrganizationTemplateNode>>;
};

/** Input para obtener cursos con quizzes filtrados por organización */
export type GetCoursesWithQuizzesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter_quiz_type_enum?: InputMaybe<FilterQuizTypeEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['Int']['input'];
  search?: InputMaybe<SearchInput>;
  sort?: InputMaybe<Array<CoursesWithQuizzesSortInput>>;
};

export type GetCsdStatusInput = {
  centralized_organization_id: Scalars['ID']['input'];
  legal_entity_id: Scalars['ID']['input'];
};

export type GetCsdStatusResult = CsdStatusResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetCurrenciesResponse = CurrenciesResponse | InternalErrorResponse | UserPermissionErrorResponse;

export type GetDc4OrganizationAttributeTypeInput = {
  organization_id: Scalars['Int']['input'];
};

export type GetDispersionAccountInput = {
  /** ID de la organización centralizada (owner). */
  centralized_organization_id: Scalars['ID']['input'];
  /** ID de la cuenta de dispersión. */
  id: Scalars['ID']['input'];
  /** ID de la razón social a la que pertenece la cuenta. */
  legal_entity_id: Scalars['ID']['input'];
};

export type GetDispersionAccountResponse = DispersionAccountResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetDispersionAccountsResponse = DispersionAccountListResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetDispersionLayoutConfigInput = {
  /** ID de la organización centralizada (owner). */
  centralized_organization_id: Scalars['ID']['input'];
  /** ID de la cuenta de dispersión cuya configuración se consulta. */
  dispersion_account_id: Scalars['ID']['input'];
  /** ID de la razón social a la que pertenece la cuenta. */
  legal_entity_id: Scalars['ID']['input'];
};

export type GetDispersionLayoutConfigResponse = DispersionLayoutConfigResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetDispersionLayoutFilePreviewInput = {
  /** ID de la organización centralizada (owner). */
  centralized_organization_id: Scalars['ID']['input'];
  /** ID de la cuenta de dispersión cuyo archivo de layout cargado se lee para armar la vista previa. */
  dispersion_account_id: Scalars['ID']['input'];
  /** ID de la razón social a la que pertenece la cuenta. */
  legal_entity_id: Scalars['ID']['input'];
};

export type GetDispersionLayoutFilePreviewResponse = DispersionLayoutFilePreviewResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetDocumentByIdUserProfileInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  centralized_user_id: Scalars['Int']['input'];
  filter_by?: InputMaybe<FilterDocumentsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<DocumentManagementFilterByEnum>;
};

export type GetDocumentSignatureStatusByIdUserProfileInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  centralized_user_id: Scalars['Int']['input'];
  filter_by?: InputMaybe<FilterDocumentsSignatureStatusInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<DocumentManagementFilterByEnum>;
};

export type GetDocumentSignatureStatusUserProfileInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  filter_by?: InputMaybe<FilterDocumentsSignatureStatusInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<DocumentManagementFilterByEnum>;
};

export type GetDocumentUserProfileInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  filter_by?: InputMaybe<FilterDocumentsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<DocumentManagementFilterByEnum>;
};

/** Success payload for get_employee_contact query. */
export type GetEmployeeContactPayload = {
  __typename?: 'GetEmployeeContactPayload';
  /** The requested contact. */
  contact: EmployeeContactNode;
};

/** Union response for get_employee_contact query. */
export type GetEmployeeContactResponse = GetEmployeeContactPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

/** Success payload for get_employee_contacts query. */
export type GetEmployeeContactsPayload = {
  __typename?: 'GetEmployeeContactsPayload';
  /** List of active contacts for the employee. */
  contacts: Array<EmployeeContactNode>;
};

/** Union response for get_employee_contacts query. */
export type GetEmployeeContactsResponse = GetEmployeeContactsPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

/** Success payload for get_employee_org_structure query. */
export type GetEmployeeOrgStructurePayload = {
  __typename?: 'GetEmployeeOrgStructurePayload';
  /** 4-level area hierarchy. Null if no area is assigned. */
  areas?: Maybe<AreaLevelsNode>;
  /** Direct boss/leader. Null if no boss is assigned. */
  boss?: Maybe<BossInfoNode>;
  /** Sede (headquarter) ID. Null if no sede is assigned. */
  headquarter_id?: Maybe<Scalars['Int']['output']>;
  /** Sede (headquarter) name. Null if no sede is assigned. */
  headquarter_name?: Maybe<Scalars['String']['output']>;
  /** Position category ID. Null if no category is assigned. */
  position_category_id?: Maybe<Scalars['Int']['output']>;
  /** Position category name. Null if no category is assigned. */
  position_category_name?: Maybe<Scalars['String']['output']>;
  /** Job position ID. Null if no position is assigned. */
  position_id?: Maybe<Scalars['Int']['output']>;
  /** Job position title. Null if no position is assigned. */
  position_name?: Maybe<Scalars['String']['output']>;
  /** Centralized user ID. */
  user_id: Scalars['Int']['output'];
};

/** Union response for get_employee_org_structure query. */
export type GetEmployeeOrgStructureResponse = GetEmployeeOrgStructurePayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

/** Success payload for get_employee_personal_info query. */
export type GetEmployeePersonalInfoPayload = {
  __typename?: 'GetEmployeePersonalInfoPayload';
  /** Short personal bio. */
  about_me?: Maybe<Scalars['String']['output']>;
  /** Home or mailing address. */
  address?: Maybe<Scalars['String']['output']>;
  /** Age in years, computed from birthday_date. Null if birthday_date is not set. */
  age?: Maybe<Scalars['Int']['output']>;
  /** Country of birth (name). Read-only — not modifiable via mutation. */
  birth_country?: Maybe<Scalars['String']['output']>;
  /** Country of birth (3-letter ISO code). Read-only — not modifiable via mutation. */
  birth_country_code?: Maybe<Scalars['String']['output']>;
  /** Date of birth. */
  birthday_date?: Maybe<Scalars['DateTime']['output']>;
  /** Civil/marital status. */
  civil_status?: Maybe<CivilStatusEnum>;
  /** Country of residence (name). Read-only — not modifiable via mutation. */
  country?: Maybe<Scalars['String']['output']>;
  /** Country of residence (3-letter ISO code). Read-only — not modifiable via mutation. */
  country_code?: Maybe<Scalars['String']['output']>;
  /** Identification document number. */
  document?: Maybe<Scalars['String']['output']>;
  /** Type of identification document. */
  document_type?: Maybe<DocumentTypeEnum>;
  /** Primary email address. Read-only — not modifiable via mutation. */
  email: Scalars['String']['output'];
  /** First name. */
  firstname: Scalars['String']['output'];
  /** Fiscal/tax ID (RFC for Mexico, free text for other countries). */
  fiscal_id?: Maybe<Scalars['String']['output']>;
  /** Gender. Read-only — not modifiable via mutation. */
  gender?: Maybe<GenderEnum>;
  /** Whether the employee has a declared disability. */
  has_disability?: Maybe<Scalars['Boolean']['output']>;
  /** Date the employee joined the organization. */
  incorporation_date?: Maybe<Scalars['DateTime']['output']>;
  /** Primary last name (apellido paterno). */
  lastname: Scalars['String']['output'];
  /** Date the employee left or will leave the organization. */
  leaving_date?: Maybe<Scalars['DateTime']['output']>;
  /** LinkedIn profile URL. */
  linkedin_url?: Maybe<Scalars['String']['output']>;
  /** Medical fitness status (occupational health evaluation result). */
  medical_fitness?: Maybe<MedicalFitnessEnum>;
  /** Personal (non-work) email address. */
  personal_email?: Maybe<Scalars['String']['output']>;
  /** Landline phone number. */
  phone_1?: Maybe<Scalars['String']['output']>;
  /** Cellphone number. */
  phone_2?: Maybe<Scalars['String']['output']>;
  /** Second last name (apellido materno). */
  second_lastname?: Maybe<Scalars['String']['output']>;
  /** Centralized user ID. */
  user_id: Scalars['Int']['output'];
  /** Username used for login. */
  username?: Maybe<Scalars['String']['output']>;
  /** Personal website URL. */
  web_site_url?: Maybe<Scalars['String']['output']>;
};

/** Union response for get_employee_personal_info query. */
export type GetEmployeePersonalInfoResponse = GetEmployeePersonalInfoPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type GetEmployerRegistrationInput = {
  centralized_organization_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type GetEmployerRegistrationResponse = EmployerRegistrationResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetEmployerRegistrationsResponse = EmployerRegistrationListResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetEnrollmentVideoLectureQuizFormInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  video_lecture_user_quiz_id: Scalars['ID']['input'];
};

export type GetEnrollmentsByUserInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  centralized_user_id?: InputMaybe<Scalars['Int']['input']>;
  filter_by?: InputMaybe<EnrollmentSearchFilterEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learning_organization_id?: InputMaybe<Scalars['Int']['input']>;
  learning_user_id?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EnrollmentInputOrderBy>>;
  search_key?: InputMaybe<Scalars['String']['input']>;
};

export type GetFeatureFlagInput = {
  name_key: Scalars['String']['input'];
  organization_id?: InputMaybe<Scalars['ID']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type GetFeatureFlagPayload = {
  __typename?: 'GetFeatureFlagPayload';
  feature_flag?: Maybe<FeatureFlag>;
  operation_id: Scalars['String']['output'];
};

export type GetFeatureFlagPayloadQueryInternalError = GetFeatureFlagPayload | QueryInternalError;

export type GetFeatureFlagsInput = {
  name_keys?: InputMaybe<Array<Scalars['String']['input']>>;
  organization_id?: InputMaybe<Scalars['ID']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type GetFeatureFlagsPayload = {
  __typename?: 'GetFeatureFlagsPayload';
  feature_flags: Array<FeatureFlag>;
  operation_id: Scalars['String']['output'];
};

export type GetFeatureFlagsPayloadQueryValidationErrorQueryInternalError = GetFeatureFlagsPayload | QueryInternalError | QueryValidationError;

export type GetFederalEntitiesResponse = FederalEntityListResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetFederalEntityResponse = FederalEntityResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetFileResponse = AnotherFile | ApplicationFile | AudioFile | ImageFile | VideoFile;

export type GetFileV1Query = {
  __typename?: 'GetFileV1Query';
  get_object_v1?: Maybe<FileV1Type>;
};


export type GetFileV1QueryGet_Object_V1Args = {
  input: FileBaseInput;
};

export type GetFolderByIdUserProfileInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  centralized_user_id: Scalars['Int']['input'];
  filter_by?: InputMaybe<FilterFoldersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<DocumentManagementFilterByEnum>;
};

export type GetFolderUserProfileInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  filter_by?: InputMaybe<FilterFoldersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<DocumentManagementFilterByEnum>;
};

export type GetGeneralReportInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  course_enroll_date?: InputMaybe<Scalars['Date']['input']>;
  course_id?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from_date?: InputMaybe<Scalars['Date']['input']>;
  organization_id: Scalars['ID']['input'];
  to_date?: InputMaybe<Scalars['Date']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
  user_status?: InputMaybe<GeneralReportUserStatusEnum>;
};

export type GetGlobalLearningProgressInput = {
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type GetGroupsComparisonInput = {
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination: PaginationInput;
  period?: InputMaybe<PeriodInput>;
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<SearchInput>;
};

export type GetIdseStatusInput = {
  centralized_organization_id: Scalars['ID']['input'];
  employer_registration_id: Scalars['ID']['input'];
};

export type GetIdseStatusResult = IdseStatusResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Credenciales con que se firma un envio de movimientos ante Terra IDSE. Las consume el servicio de contrato, que es quien despacha el lote. */
export type GetIdseSubmissionCredentialsInput = {
  /** Organizacion a la que pertenece el registro patronal. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Registro patronal con cuyo usuario y certificado se envia. */
  employer_registration_id: Scalars['ID']['input'];
};

/** `ValidationErrorResponse` cubre tambien el registro patronal de otra organizacion: el repositorio filtra por organizacion, asi que el ajeno no se distingue del inexistente y ninguna credencial sale. */
export type GetIdseSubmissionCredentialsResult = IdseSubmissionCredentialsResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetImssDelegationResponse = ImssDelegationResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetImssDelegationsResponse = ImssDelegationListResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetImssFractionsInput = {
  risk_class_code?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetImssFractionsResponse = ImssFractionsResponse | InternalErrorResponse | UserPermissionErrorResponse;

export type GetImssMovementInput = {
  legal_entity_id: Scalars['UUID']['input'];
  movement_id: Scalars['UUID']['input'];
};

export type GetImssMovementResponse = {
  __typename?: 'GetImssMovementResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: ImssMovementDetail;
};

export type GetImssMovementResult = GetImssMovementResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse;

export type GetImssSubdelegationResponse = ImssSubdelegationResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetImssSubdelegationsResponse = ImssSubdelegationListResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetInvitationLinkResponse = CentralizedGenerateInvitationLinkPayload | CentralizedIntegrityError | CentralizedInternalError | CentralizedValidationError;

export type GetLastActivityByUserInfo = GraphOperationI & {
  __typename?: 'GetLastActivityByUserInfo';
  activity_type?: Maybe<ActivityTypeEnum>;
  course_id: Scalars['ID']['output'];
  course_name?: Maybe<Scalars['String']['output']>;
  course_type?: Maybe<CourseTypeEnum>;
  duration?: Maybe<Scalars['Int']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  is_required?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
  player_url?: Maybe<Scalars['String']['output']>;
  progress_seconds?: Maybe<Scalars['Int']['output']>;
  remaining_time?: Maybe<Scalars['Int']['output']>;
};

export type GetLastActivityByUserResponse = FoundationHomeUserIntegrityError | FoundationHomeUserInternalError | FoundationHomeUserValidationError | GetLastActivityByUserInfo;

export type GetLearningPathInput = {
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination: PaginationInput;
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<SearchInput>;
};

export type GetLegalEntitiesResponse = CentralizedLegalEntityListResponse | ForbiddenErrorResponse | InternalErrorResponse | LegalEntityListResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetLegalEntityByUserIdInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
};

export type GetLegalEntityByUserIdResponse = InternalErrorResponse | LegalEntityResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetLegalEntityInput = {
  centralized_organization_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type GetLegalEntityResponse = CentralizedLegalEntityResponse | ForbiddenErrorResponse | InternalErrorResponse | LegalEntityResponse | NotAuthenticatedErrorResponse | NotFoundResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetLegalRepresentativesResponse = InternalErrorResponse | LegalRepresentativeListResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetLicensesDistributionDetailsPayload = {
  __typename?: 'GetLicensesDistributionDetailsPayload';
  corporate_org_usage: CorporationsCorporationLicenseUsage;
  licenses_expiration_date: Scalars['DateTime']['output'];
  overall_usage_percentage: Scalars['Int']['output'];
  usage_by_organization: Array<CorporationsOrganizationLicenseUsage>;
};

export type GetLicensesDistributionInput = {
  centralized_organization_id: Scalars['Int']['input'];
};

export type GetLicensesDistributionMetricCount = {
  __typename?: 'GetLicensesDistributionMetricCount';
  count: Scalars['Int']['output'];
  percentage: Scalars['Int']['output'];
};

export type GetLicensesDistributionNode = {
  __typename?: 'GetLicensesDistributionNode';
  active: GetLicensesDistributionMetricCount;
  pending: GetLicensesDistributionMetricCount;
  percentage_of_corporation: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unassigned: GetLicensesDistributionMetricCount;
};

export type GetLicensesDistributionPayload = {
  __typename?: 'GetLicensesDistributionPayload';
  /** Get licenses distribution details. */
  licenses_distribution_details: GetLicensesDistributionDetailsPayload;
  /** Total corporate licenses. */
  total_corporate_licenses: Scalars['Int']['output'];
  /** Get licenses distribution. */
  unassigned_licenses: Scalars['Int']['output'];
};

export type GetLicensesDistributionPayloadIntegrityErrorResponseInternalErrorResponseValidationErrorResponseNotFoundResponseNotAuthenticatedErrorResponse = GetLicensesDistributionPayload | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type GetMassiveDocumentUploadDetailInput = {
  organization_id: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  page_size?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  upload_id: Scalars['Int']['input'];
};

export type GetOAuth2UserInput = {
  organization_id: Scalars['ID']['input'];
  username: Scalars['String']['input'];
};

export type GetOAuthClientInput = {
  client_id: Scalars['String']['input'];
};

export type GetOrCreateVideoLectureQuizResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | VideoLectureUserQuizFormPayload;

/** Success payload for get_organization_areas query. */
export type GetOrgAreasPayload = {
  __typename?: 'GetOrgAreasPayload';
  /** Active areas matching the given parent_id filter. */
  items: Array<OrgAreaNode>;
};

/** Union response for get_organization_areas query. */
export type GetOrgAreasResponse = GetOrgAreasPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

/** Success payload for get_organization_headquarters query. */
export type GetOrgHeadquartersPayload = {
  __typename?: 'GetOrgHeadquartersPayload';
  /** Active headquarters (sedes) in the organization. */
  items: Array<OrgHeadquarterNode>;
};

/** Union response for get_organization_headquarters query. */
export type GetOrgHeadquartersResponse = GetOrgHeadquartersPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

/** Success payload for get_organization_position_categories query. */
export type GetOrgPositionCategoriesPayload = {
  __typename?: 'GetOrgPositionCategoriesPayload';
  /** Active position categories in the organization. */
  items: Array<OrgPositionCategoryNode>;
};

/** Union response for get_organization_position_categories query. */
export type GetOrgPositionCategoriesResponse = GetOrgPositionCategoriesPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

/** Success payload for get_organization_positions query. */
export type GetOrgPositionsPayload = {
  __typename?: 'GetOrgPositionsPayload';
  /** Active positions in the organization. */
  items: Array<OrgPositionNode>;
};

/** Union response for get_organization_positions query. */
export type GetOrgPositionsResponse = GetOrgPositionsPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

export type GetOrganizationPositionsInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  organization_slug: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetOrganizationPublicInfoInput = {
  centralized_organization_slug: Scalars['String']['input'];
};

export type GetOrganizationTeamsByUserInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  centralized_user_id?: InputMaybe<Scalars['Int']['input']>;
  filter_by?: InputMaybe<UserTeamSearchFilterEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learning_organization_id?: InputMaybe<Scalars['Int']['input']>;
  learning_user_id?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserTeamInputOrderBy>>;
  search_key?: InputMaybe<Scalars['String']['input']>;
};

export type GetOrganizationTemplateBaseInput = {
  organization_template_base_id: Scalars['ID']['input'];
};

export type GetOrganizationTemplateInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  organization_template_id: Scalars['ID']['input'];
};

export type GetPasswordPolicyInput = {
  centralized_organization_id: Scalars['ID']['input'];
};

export type GetPasswordPolicyPayload = {
  __typename?: 'GetPasswordPolicyPayload';
  policy: PasswordPolicyType;
};

export type GetPasswordPolicyPayloadQueryValidationErrorQueryInternalServerError = GetPasswordPolicyPayload | QueryInternalServerError | QueryValidationError;

export type GetPayrollEmployeeInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
  legal_entity_id: Scalars['ID']['input'];
};

export type GetPayrollEmployeeResult = InternalErrorResponse | PayrollEmployeeResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetPayrollIncidenceResult = InternalErrorResponse | NotFoundErrorResponse | PayrollIncidence | UserPermissionErrorResponse;

export type GetPerformanceReportInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from_date?: InputMaybe<Scalars['Date']['input']>;
  last_action_date__is_null?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id: Scalars['ID']['input'];
  to_date?: InputMaybe<Scalars['Date']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
  user_status?: InputMaybe<PerformanceReportUserStatusEnum>;
};

export type GetPermissionsByUserInput = {
  centralized_organization_id: Scalars['Int']['input'];
  centralized_user_id: Scalars['Int']['input'];
};

export type GetPersonTypesResponse = InternalErrorResponse | PersonTypesResponse | UserPermissionErrorResponse;

export type GetPoliciesFilters = {
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policy_type_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetPoliciesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  filter?: InputMaybe<GetPoliciesFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<GenericOrderByEnum>;
};

export type GetPoliciesUserFilters = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetPoliciesUserInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
  filter?: InputMaybe<GetPoliciesUserFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<GenericOrderByEnum>;
};

export type GetPolicyBalanceTemplateInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Policy ID */
  policy_id: Scalars['ID']['input'];
};

export type GetPolicyInput = {
  centralized_organization_id: Scalars['ID']['input'];
  policy_id: Scalars['ID']['input'];
};

export type GetPolicyLegalProfileInput = {
  centralized_organization_id: Scalars['ID']['input'];
  policy_id: Scalars['ID']['input'];
};

export type GetPolicyRulesInput = {
  centralized_organization_id: Scalars['ID']['input'];
  policy_id: Scalars['ID']['input'];
};

export type GetPolicyTypesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type GetPolicyUserInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
  policy_id: Scalars['ID']['input'];
};

export type GetPolicyUsersFilters = {
  expiration_balance?: InputMaybe<Array<TimeoffExpirationBalanceFilterEnum>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type GetPolicyUsersInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  filter?: InputMaybe<GetPolicyUsersFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<GenericOrderByEnum>;
  order_by_is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  policy_id: Scalars['ID']['input'];
};

export type GetPositionByUsersResponse = FoundationLeaderIntegrityError | FoundationLeaderInternalError | FoundationLeaderValidationError | PositionListInfo;

/** Input for the full candidate pipeline: keyword matching + indicator filtering + scoring. */
export type GetPositionCandidatesInput = {
  centralized_organization_id: Scalars['Int']['input'];
  company_id: Scalars['Int']['input'];
  exclude_position_id?: InputMaybe<Scalars['Int']['input']>;
  indicators: Array<IndicatorInput>;
  keywords: Array<KeywordInput>;
};

export type GetPositionCandidatesResponse = ForbiddenErrorResponse | GetPositionCandidatesSuccess | InternalErrorResponse | NotFoundResponse | ValidationErrorResponse;

/** Successful response for get_position_candidates. */
export type GetPositionCandidatesSuccess = {
  __typename?: 'GetPositionCandidatesSuccess';
  candidates: Array<PositionCandidateNode>;
  graphql_operation_id: Scalars['ID']['output'];
  total_candidates: Scalars['Int']['output'];
};

export type GetPublicUserOrganizationAuthInput = {
  method?: InputMaybe<AuthenticationMethodEnum>;
  next_url?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['ID']['input'];
  username: Scalars['String']['input'];
};

export type GetQuizByClassInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  video_lecture_id: Scalars['ID']['input'];
};

export type GetQuizStudioInput = {
  course_id?: InputMaybe<Scalars['ID']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id?: InputMaybe<Scalars['ID']['input']>;
  video_lecture_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Input para obtener quizzes por course_id con detalle de preguntas */
export type GetQuizzesByCourseIdInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  course_id: Scalars['Int']['input'];
  filter_quiz_type_enum?: InputMaybe<FilterQuizTypeEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type GetReportEnrollmentsByUserInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  centralized_user_id?: InputMaybe<Scalars['Int']['input']>;
  filter_by?: InputMaybe<ReportEnrollmentSearchFilterEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learning_organization_id?: InputMaybe<Scalars['Int']['input']>;
  learning_user_id?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportEnrollmentInputOrderBy>>;
  search_key?: InputMaybe<Scalars['String']['input']>;
};

export type GetReportTeamsByUserInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  centralized_user_id?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  learning_organization_id?: InputMaybe<Scalars['Int']['input']>;
  learning_user_id?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportTeamInputOrderBy>>;
  search_key?: InputMaybe<Scalars['String']['input']>;
};

export type GetRiskClassDefaultsResponse = InternalErrorResponse | RiskClassDefaultsResponse | UserPermissionErrorResponse;

export type GetRiskClassResponse = InternalErrorResponse | RiskClassResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetRiskClassesResponse = InternalErrorResponse | RiskClassListResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input to retrieve aggregated statistics for a route */
export type GetRouteCompletedStatisticsInput = {
  organization_id: Scalars['Int']['input'];
  route_id: Scalars['Int']['input'];
};

export type GetRouteCoursesStatisticsInput = {
  filter?: InputMaybe<CourseTypeFilterEnum>;
  order?: InputMaybe<RouteCoursesStatisticsInputOrderBy>;
  organization_id: Scalars['Int']['input'];
  pagination?: InputMaybe<CursorPaginationInput>;
  route_id: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetRouteUserStatisticsInput = {
  filter?: InputMaybe<RouteUserStatisticsFilterInput>;
  order?: InputMaybe<RouteUserStatisticsInputOrderBy>;
  organization_id: Scalars['Int']['input'];
  pagination?: InputMaybe<CursorPaginationInput>;
  route_id: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetSalaryZoneResponse = InternalErrorResponse | SalaryZoneResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetSalaryZonesResponse = InternalErrorResponse | SalaryZoneListResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetSaml2ClaimsInput = {
  centralized_organization_id: Scalars['ID']['input'];
};

export type GetSaml2IdpConfigurationInput = {
  centralized_organization_id: Scalars['ID']['input'];
};

export type GetSaml2IdpMetadataInput = {
  centralized_organization_id: Scalars['ID']['input'];
  sso_url?: InputMaybe<Scalars['String']['input']>;
};

export type GetSaml2ServiceProvidersInput = {
  centralized_organization_id: Scalars['ID']['input'];
};

export type GetSaml2SpConfigurationInput = {
  centralized_organization_id: Scalars['ID']['input'];
};

export type GetSaml2SpMetadataInput = {
  centralized_organization_id: Scalars['ID']['input'];
};

export type GetSaml2SpSsoUrlInput = {
  centralized_organization_id: Scalars['ID']['input'];
  relay_state?: InputMaybe<Scalars['String']['input']>;
  trusted_idp_id: Scalars['ID']['input'];
};

export type GetSaml2TrustedIdpsInput = {
  centralized_organization_id: Scalars['ID']['input'];
};

export type GetSegmentedUsersInput = {
  centralized_organization_id: Scalars['Int']['input'];
  filter?: InputMaybe<SegmentFilterInput>;
  order?: InputMaybe<Array<SegmentOrderInput>>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  segmentation: SegmentInput;
};

export type GetSegmentsByConditionalsInput = {
  centralized_organization_id: Scalars['Int']['input'];
  custom_fields: Array<SegmentCustomFieldFilterInput>;
};

export type GetSegmentsByUserInput = {
  centralized_organization_id: Scalars['Int']['input'];
  user_id: Scalars['Int']['input'];
};

export type GetSegmentsInput = {
  centralized_organization_id: Scalars['Int']['input'];
  segment_ids: Array<Scalars['Int']['input']>;
};

export type GetSharedFilesQuery = {
  __typename?: 'GetSharedFilesQuery';
  get_object?: Maybe<GetFileResponse>;
  get_pre_signed_url?: Maybe<FilePreSignedUrlResponse>;
};


export type GetSharedFilesQueryGet_ObjectArgs = {
  inputs: FileBaseInput;
};


export type GetSharedFilesQueryGet_Pre_Signed_UrlArgs = {
  input: FilePreSignedUrlInput;
};

export type GetSocialHubNewsByIdInput = {
  centralized_organization_id: Scalars['Int']['input'];
  news_id: Scalars['Int']['input'];
};

export type GetSocialHubNewsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  filter_by?: InputMaybe<FilterSocialHubNewsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  published_date_order_by?: InputMaybe<DocumentManagementOrderByEnum>;
};

export type GetSocialSecurityInfoInput = {
  legal_entity_id: Scalars['ID']['input'];
  payroll_employee_id: Scalars['ID']['input'];
};

export type GetSocialSecurityInfoResult = InternalErrorResponse | NotFoundErrorResponse | SocialSecurityInfoResponse | UserPermissionErrorResponse;

export type GetStudentRankingInput = {
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination: PaginationInput;
  period?: InputMaybe<PeriodInput>;
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<SearchInput>;
};

/** Input for querying direct report user IDs of a boss within an organization. */
export type GetSubordinateUserIdsInput = {
  /** User ID of the boss whose direct reports are requested (required). */
  boss_user_id: Scalars['Int']['input'];
  /** Organization ID to scope the query (required). */
  centralized_organization_id: Scalars['Int']['input'];
  /** If provided, checks whether this user is a direct report of the boss. Returns the ID if true, empty list otherwise. */
  subordinate_user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** Payload containing the list of direct report user IDs for a boss. */
export type GetSubordinateUserIdsPayload = {
  __typename?: 'GetSubordinateUserIdsPayload';
  /** List of distinct user IDs that are direct reports of the given boss. */
  user_ids: Array<Scalars['Int']['output']>;
};

export type GetSubordinateUserIdsResponse = GetSubordinateUserIdsPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

export type GetTasksByUserInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  assigned_user?: InputMaybe<Scalars['Int']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<WorkFlowTaskOrderByInput>;
  search_key?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WorkFlowUserStatusEnum>;
  task_type?: InputMaybe<WorkFlowTaskTypeEnum>;
  user_id: Scalars['ID']['input'];
};

export type GetTaxRegimeResponse = CentralizedTaxRegimeResponse | ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TaxRegimeResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetTaxRegimesResponse = CentralizedTaxRegimeListResponse | ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TaxRegimeListResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GetTemplateDocumentDetailInput = {
  centralized_organization_id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  template_id?: InputMaybe<Scalars['Int']['input']>;
};

export type GetTimeoffCalendarInput = {
  centralized_organization_id: Scalars['ID']['input'];
  firstweekday?: InputMaybe<TimeoffCalendarWeekDayEnum>;
  month?: InputMaybe<Scalars['Int']['input']>;
  policy_id?: InputMaybe<Scalars['ID']['input']>;
  policy_type_id?: InputMaybe<Scalars['ID']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type GetTimeoffDayCalendarByDateInput = {
  calendar_date: Scalars['Date']['input'];
  centralized_organization_id: Scalars['ID']['input'];
  policy_id?: InputMaybe<Scalars['ID']['input']>;
  policy_type_id?: InputMaybe<Scalars['ID']['input']>;
};

export type GetTimeoffHolidayDatesByUserInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
  date_from: Scalars['Date']['input'];
  date_to: Scalars['Date']['input'];
};

export type GetTimeoffHolidaysByUserInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
  filter?: InputMaybe<GetTimeoffHolidaysFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<HrisGenericOrderByEnum>;
};

export type GetTimeoffHolidaysFilters = {
  is_recurrent?: InputMaybe<Scalars['Boolean']['input']>;
  is_restricted?: InputMaybe<Scalars['Boolean']['input']>;
  recurrent_type?: InputMaybe<HolidayRecurrentTypeEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type GetTimeoffHolidaysInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  filter?: InputMaybe<GetTimeoffHolidaysFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<HrisGenericOrderByEnum>;
};

export type GetTimeoffMisalignedBalancesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type GetTimeoffRequestCommentsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Request ID */
  request_id: Scalars['ID']['input'];
};

export type GetTimeoffRequestTimeCalculatorInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** End Date */
  end_date: Scalars['Date']['input'];
  /** Policy ID */
  policy_id: Scalars['ID']['input'];
  /** Start Date */
  start_date: Scalars['Date']['input'];
};

export type GetTimeoffRequestsBetweenDatesFilter = {
  /** This field is unused and exists only to satisfy GraphQL schema requirements. This input type is deprecated. */
  _unused?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetTimeoffRequestsByPolicyInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Policy ID */
  policy_id: Scalars['ID']['input'];
};

export type GetTimeoffRequestsByUserInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  /** Centralized User ID */
  centralized_user_id: Scalars['ID']['input'];
  filter?: InputMaybe<GetTimeoffRequestsFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  /** If true, also includes cancelled (is_active=False) requests, with cancelled_by_user/cancelled_at populated (HRIS-4059). Default false preserves the existing active-only behavior. */
  include_cancelled?: Scalars['Boolean']['input'];
  order_by?: InputMaybe<HrisGenericOrderByEnum>;
};

export type GetTimeoffRequestsFilters = {
  /** List of centralized user IDs to filter requests by `Request.user_id`. Empty or null means no user filter. */
  centralized_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Lower bound of the request-date window. Combined with `date_to` as an intersection: returns requests whose date range overlaps [date_from, date_to]. */
  date_from?: InputMaybe<Scalars['Date']['input']>;
  /** Upper bound of the request-date window. Must be on or after `date_from` when both are supplied. */
  date_to?: InputMaybe<Scalars['Date']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** List of Policy IDs to filter requests by `Request.policy_id`. Empty or null means no policy-id filter. */
  policy_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  policy_type_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  specific_date?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Array<RequestStatusEnum>>;
};

export type GetTimeoffRequestsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  filter?: InputMaybe<GetTimeoffRequestsFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<HrisGenericOrderByEnum>;
};

export type GetTimeoffRequestsReceivedToApprovalInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  /** Centralized User ID */
  centralized_user_id: Scalars['ID']['input'];
  filter?: InputMaybe<GetTimeoffRequestsFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<GenericOrderByEnum>;
};

export type GetTimeoffUserExpiringBalanceInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Centralized User ID */
  centralized_user_id: Scalars['ID']['input'];
  /** Filter by a specific policy. If omitted, returns all expirable policies. */
  policy_id?: InputMaybe<Scalars['ID']['input']>;
};

export type GetTimeoffWeekCalendarByDateInput = {
  calendar_date: Scalars['Date']['input'];
  centralized_organization_id: Scalars['ID']['input'];
  firstweekday?: InputMaybe<TimeoffCalendarWeekDayEnum>;
  policy_id?: InputMaybe<Scalars['ID']['input']>;
  policy_type_id?: InputMaybe<Scalars['ID']['input']>;
};

export type GetTrackOrganizationTemplatesInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  track_id: Scalars['ID']['input'];
};

export type GetTrackOrganizationTemplatesNode = {
  __typename?: 'GetTrackOrganizationTemplatesNode';
  organization_template_default?: Maybe<OrganizationTemplateNode>;
  track_organization_template?: Maybe<TrackOrganizationTemplateNode>;
};

export type GetUserDocumentByIdInput = {
  centralized_organization_id: Scalars['Int']['input'];
  user_document_id: Scalars['Int']['input'];
};

export type GetUserHelpCenterUrlInput = {
  next_url?: InputMaybe<Scalars['String']['input']>;
};

export type GetUserInitialPageUrlOptionsInput = {
  auto_activation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input para el detalle de sedes gestionadas por un usuario. */
export type GetUserManagedHeadquartersInput = {
  /** ID de la organización que scopea la consulta (requerido). */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID del usuario cuyas sedes se consultan (requerido). */
  user_id: Scalars['Int']['input'];
};

/** Lookup a UserOrganization by username within a specific organization. Used by the front to check username uniqueness during user creation/edition. */
export type GetUserOrganizationByUsernameInput = {
  /** Organization ID to scope the lookup (required). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Raw username typed by the user. The backend formats it with the internal `_{learning_id}` suffix when needed; auto-generated usernames (without suffix) are matched as-is. */
  username: Scalars['String']['input'];
};

export type GetUserPolicyBalanceLogInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Centralized User ID */
  centralized_user_id: Scalars['ID']['input'];
  /** Policy ID */
  policy_id: Scalars['ID']['input'];
  /** User Policy Balance Log ID */
  user_policy_balance_log_id: Scalars['ID']['input'];
};

export type GetUserPolicyBalanceLogsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  /** Centralized User ID */
  centralized_user_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Policy ID */
  policy_id: Scalars['ID']['input'];
};

export type GetUserProfileSocialHubNewsByIdInput = {
  /** Organization ID the news item belongs to */
  centralized_organization_id: Scalars['Int']['input'];
  /** Social Hub News ID */
  news_id: Scalars['Int']['input'];
};

export type GetUserProfileSocialHubNewsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  published_date_from?: InputMaybe<Scalars['Date']['input']>;
  published_date_to?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetUserQuizzesReportInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from_date?: InputMaybe<Scalars['Date']['input']>;
  organization_id: Scalars['ID']['input'];
  to_date?: InputMaybe<Scalars['Date']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type GetUserTeamEnrollmentsFilterInput = {
  custom_field_tags?: InputMaybe<Array<Scalars['String']['input']>>;
  is_enrolled?: InputMaybe<Scalars['Boolean']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
};

export type GetUsersByBossOnCurrentSessionInput = {
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type GetUsersByCourseInput = {
  course_id: Scalars['Int']['input'];
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination: PaginationInput;
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type GetUsersByLearningPathInput = {
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  learning_path_id: Scalars['Int']['input'];
  pagination: PaginationInput;
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type GetUsersBySegmentIdInput = {
  /** Organization scope. Enforces data isolation at the SQL level. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Pagination control. Omit to return all matching users. */
  pagination?: InputMaybe<OffsetPaginationInput>;
  /** Primary key of the OrganizationGroupTeam to look up. */
  segment_id: Scalars['Int']['input'];
};

export type GetUsersBySegmentIdResponse = ForbiddenErrorResponse | InternalErrorResponse | UsersSegment | ValidationErrorResponse;

export type GetUsersCourseInput = {
  course_id: Scalars['Int']['input'];
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination: PaginationInput;
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<SearchInput>;
};

export type GetUsersInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
  user_status?: InputMaybe<LearningUserOrganizationStatus>;
};

export type GetUsersOrganizationFilters = {
  enterprises?: InputMaybe<Array<EnterpriseEnum>>;
  invitation_sent_list?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  organization_area_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  organization_headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  roles?: InputMaybe<Array<UserOrganizationRoleFilterEnum>>;
  status_list?: InputMaybe<Array<UserOrganizationStatus>>;
};

export type GetUsersOrganizationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  filter_operator_and?: InputMaybe<Scalars['Boolean']['input']>;
  filters_list?: InputMaybe<Array<GetUsersOrganizationFilters>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<GenericOrderByEnum>;
};

export type GetUsersTeamEnrollmentsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  course_id: Scalars['Int']['input'];
  filters?: InputMaybe<GetUserTeamEnrollmentsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type GetWorkCentersResponse = InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse | WorkCenterListResponse;

export type GetWorkFlowDetailInput = {
  centralized_organization_id: Scalars['ID']['input'];
  workflow_id: Scalars['ID']['input'];
};

export type GetWorkFlowsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<OrderByInput>;
  search_key?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<WorkFlowStatusEnum>>;
  work_flow_type?: InputMaybe<WorkFlowTypeEnum>;
};

export type GetWorkflowBlocksInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalLearningProgressInfo = GraphOperationI & {
  __typename?: 'GlobalLearningProgressInfo';
  courses_progress?: Maybe<Scalars['Float']['output']>;
  global_progress?: Maybe<Scalars['Float']['output']>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  learning_paths_progress?: Maybe<Scalars['Float']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

export type GlobalLearningProgressResponse = FoundationLeaderIntegrityError | FoundationLeaderInternalError | FoundationLeaderValidationError | GlobalLearningProgressInfo;

export enum GoalEmployeeStateEnum {
  Approved = 'APPROVED',
  Created = 'CREATED',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
  PendingBySuperBoss = 'PENDING_BY_SUPER_BOSS'
}

export type GoalExtraFieldSummaryDto = {
  __typename?: 'GoalExtraFieldSummaryDTO';
  goalExtraFieldId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum GoalPeriodSearchFieldsEnum {
  GoalPeriodName = 'GOAL_PERIOD_NAME'
}

export enum GoalPeriodSortFieldsEnum {
  GoalPeriodName = 'GOAL_PERIOD_NAME'
}

export enum GoalPeriodStateEnum {
  Active = 'ACTIVE',
  Created = 'CREATED',
  Finished = 'FINISHED',
  Standby = 'STANDBY',
  Started = 'STARTED'
}

export type GoalProcessSearchInput = {
  fields: Array<GoalPeriodSearchFieldsEnum>;
  query: Scalars['String']['input'];
};

export type GoalReportDto = {
  __typename?: 'GoalReportDTO';
  attachmentBossName?: Maybe<Scalars['String']['output']>;
  attachmentBossUrl?: Maybe<Scalars['String']['output']>;
  attachmentEmpName?: Maybe<Scalars['String']['output']>;
  attachmentEmpUrl?: Maybe<Scalars['String']['output']>;
  bossComments?: Maybe<Scalars['String']['output']>;
  bossDateProgress?: Maybe<Scalars['String']['output']>;
  bossProgress?: Maybe<Scalars['Float']['output']>;
  bossResult?: Maybe<Scalars['String']['output']>;
  employeeComments?: Maybe<Scalars['String']['output']>;
  employeeDateProgress?: Maybe<Scalars['String']['output']>;
  employeeProgress?: Maybe<Scalars['Float']['output']>;
  employeeResult?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  trackName: Scalars['String']['output'];
};

export type GoalTrackDto = {
  __typename?: 'GoalTrackDTO';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** TYPES */
export type GoalTrackPeriodDto = {
  __typename?: 'GoalTrackPeriodDTO';
  id: Scalars['Int']['output'];
  tracks: Array<Maybe<GoalTrackDto>>;
  type: GoalTrackPeriodEnum;
};

/** ENUMS */
export enum GoalTrackPeriodEnum {
  Bimonthly = 'BIMONTHLY',
  Custom = 'CUSTOM',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Sixmonthly = 'SIXMONTHLY',
  Unknown = 'UNKNOWN',
  Yearly = 'YEARLY'
}

export enum GoalTrackTypeEnum {
  GoalTrackTypeCustom = 'GOAL_TRACK_TYPE_CUSTOM',
  GoalTrackTypePeriodically = 'GOAL_TRACK_TYPE_PERIODICALLY'
}

export type GoalsAttempt = {
  __typename?: 'GoalsAttempt';
  created_at: Scalars['DateTime']['output'];
  goals_session: GoalsSession;
  id: Scalars['ID']['output'];
  response?: Maybe<GoalsAttemptResponse>;
  status: SmartGoalsStatusEnum;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type GoalsAttemptResponse = {
  __typename?: 'GoalsAttemptResponse';
  data?: Maybe<Scalars['JSON']['output']>;
  input_language: Scalars['String']['output'];
  time: Scalars['Decimal']['output'];
};

export type GoalsByDimensionInput = {
  company_id: Scalars['Int']['input'];
  dimension: GoalsGroupByDimension;
  first?: Scalars['Int']['input'];
  month: Scalars['String']['input'];
  offset?: Scalars['Int']['input'];
  process_id: Scalars['String']['input'];
};

export type GoalsCollaboratorType = {
  __typename?: 'GoalsCollaboratorType';
  department: Scalars['String']['output'];
  employee_id: Scalars['Int']['output'];
  leader_name: Scalars['String']['output'];
  leader_status: CollaboratorTrackingStatus;
  name: Scalars['String']['output'];
  position: Scalars['String']['output'];
  self_tracking_status: CollaboratorTrackingStatus;
};

export type GoalsCollaboratorsInput = {
  company_id: Scalars['Int']['input'];
  leader_status?: InputMaybe<CollaboratorTrackingStatus>;
  month: Scalars['String']['input'];
  page?: Scalars['Int']['input'];
  page_size?: Scalars['Int']['input'];
  process_id: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  self_tracking_status?: InputMaybe<CollaboratorTrackingStatus>;
  sort_by?: CollaboratorSortField;
  sort_direction?: SortDirection;
};

export type GoalsCollaboratorsPageType = {
  __typename?: 'GoalsCollaboratorsPageType';
  current_page: Scalars['Int']['output'];
  items: Array<GoalsCollaboratorType>;
  total_count: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type GoalsDailyPointType = {
  __typename?: 'GoalsDailyPointType';
  date: Scalars['String']['output'];
  leader_pct: Scalars['Float']['output'];
  self_tracking_pct: Scalars['Float']['output'];
};

export type GoalsDailyTrackingInput = {
  company_id: Scalars['Int']['input'];
  month: Scalars['String']['input'];
  process_id: Scalars['String']['input'];
};

export type GoalsDimensionItemType = {
  __typename?: 'GoalsDimensionItemType';
  dimension_value: Scalars['String']['output'];
  leader_pct: Scalars['Float']['output'];
  overall_progress_pct: Scalars['Float']['output'];
  self_tracking_pct: Scalars['Float']['output'];
  total_expected: Scalars['Int']['output'];
};

export type GoalsDimensionPageType = {
  __typename?: 'GoalsDimensionPageType';
  has_next_page: Scalars['Boolean']['output'];
  items: Array<GoalsDimensionItemType>;
  total_count: Scalars['Int']['output'];
};

export type GoalsEmailTemplateInput = {
  code: GoalsTemplate;
  employee_id: Scalars['Int']['input'];
  language: Scalars['String']['input'];
  process_id: Scalars['Int']['input'];
};

export type GoalsEmailTemplateResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | SuccessCore;

export type GoalsEmployeeInfoDto = {
  __typename?: 'GoalsEmployeeInfoDTO';
  bossDivision?: Maybe<Scalars['String']['output']>;
  bossId?: Maybe<Scalars['Int']['output']>;
  bossImg?: Maybe<Scalars['String']['output']>;
  bossJob?: Maybe<Scalars['String']['output']>;
  bossName?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['Int']['output'];
  employeeImg: Scalars['String']['output'];
  employeeJob: Scalars['String']['output'];
  employeeName: Scalars['String']['output'];
};

export enum GoalsGroupByDimension {
  Country = 'COUNTRY',
  Department = 'DEPARTMENT',
  Leader = 'LEADER',
  Level = 'LEVEL',
  Location = 'LOCATION',
  Position = 'POSITION'
}

export type GoalsMonthlyPointType = {
  __typename?: 'GoalsMonthlyPointType';
  leader_pct?: Maybe<Scalars['Float']['output']>;
  month: Scalars['String']['output'];
  self_tracking_pct?: Maybe<Scalars['Float']['output']>;
};

export type GoalsMonthlyTrackingInput = {
  company_id: Scalars['Int']['input'];
  end_month: Scalars['String']['input'];
  process_id: Scalars['String']['input'];
  start_month: Scalars['String']['input'];
};

/** QUERIES */
export type GoalsQueries = {
  __typename?: 'GoalsQueries';
  get_goal_detail?: Maybe<TalentGoalDetailResponse>;
  get_goals_by_employee?: Maybe<TalentIndividualGoalsByEmployeeResponse>;
  get_goals_employee_result_detail?: Maybe<TalentGoalsEmployeeResultResponse>;
  get_goals_process_information?: Maybe<TalentGoalsProcessInformationResponse>;
  get_partakers_by_process?: Maybe<TalentGoalPartakersByProcessResponse>;
};


/** QUERIES */
export type GoalsQueriesGet_Goal_DetailArgs = {
  input?: InputMaybe<TalentGoalsIndividualGoalDetailInput>;
};


/** QUERIES */
export type GoalsQueriesGet_Goals_By_EmployeeArgs = {
  input?: InputMaybe<TalentGoalsByEmployeeInput>;
};


/** QUERIES */
export type GoalsQueriesGet_Goals_Employee_Result_DetailArgs = {
  input: TalentGoalsEmployeeResultInput;
};


/** QUERIES */
export type GoalsQueriesGet_Goals_Process_InformationArgs = {
  input?: InputMaybe<TalentGoalsGeneralInformationProcessInput>;
};


/** QUERIES */
export type GoalsQueriesGet_Partakers_By_ProcessArgs = {
  input: TalentGoalsPartakersInput;
};

export enum GoalsResultTypeEnum {
  GoalsResultTypeAverageAllTrackings = 'GOALS_RESULT_TYPE_AVERAGE_ALL_TRACKINGS',
  GoalsResultTypeAverageDoneTrackings = 'GOALS_RESULT_TYPE_AVERAGE_DONE_TRACKINGS',
  GoalsResultTypeConfiguredTracking = 'GOALS_RESULT_TYPE_CONFIGURED_TRACKING',
  GoalsResultTypeLastTrackingDone = 'GOALS_RESULT_TYPE_LAST_TRACKING_DONE'
}

export type GoalsSession = {
  __typename?: 'GoalsSession';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  organization_id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['ID']['output'];
};

export enum GoalsTemplate {
  CreateGoalsToCollaborator = 'CREATE_GOALS_TO_COLLABORATOR',
  EvaluateGoalsToCollaborator = 'EVALUATE_GOALS_TO_COLLABORATOR'
}

export type GoalsTrackingSummaryInput = {
  company_id: Scalars['Int']['input'];
  month: Scalars['String']['input'];
  process_id: Scalars['String']['input'];
};

export type GoalsTrackingSummaryType = {
  __typename?: 'GoalsTrackingSummaryType';
  leader_completed: Scalars['Int']['output'];
  leader_pct: Scalars['Float']['output'];
  month_avg_pct: Scalars['Float']['output'];
  month_label: Scalars['String']['output'];
  overall_progress_pct: Scalars['Float']['output'];
  self_completed: Scalars['Int']['output'];
  self_tracking_pct: Scalars['Float']['output'];
  total_expected: Scalars['Int']['output'];
};

export type GovernmentCreditItemResponse = {
  __typename?: 'GovernmentCreditItemResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: GovernmentCreditType;
};

export type GovernmentCreditListResponse = {
  __typename?: 'GovernmentCreditListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: Array<GovernmentCreditType>;
};

export type GovernmentCreditType = {
  __typename?: 'GovernmentCreditType';
  balance?: Maybe<Scalars['Float']['output']>;
  calculated_deduction?: Maybe<Scalars['Float']['output']>;
  charges_damage_insurance: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by: Scalars['String']['output'];
  credit_number: Scalars['String']['output'];
  credit_type: Scalars['String']['output'];
  damage_insurance_charge_on?: Maybe<Scalars['String']['output']>;
  discount_type: Scalars['String']['output'];
  discount_value: Scalars['Float']['output'];
  end_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  installment_amount?: Maybe<Scalars['Float']['output']>;
  installments?: Maybe<Scalars['Int']['output']>;
  installments_paid?: Maybe<Scalars['Int']['output']>;
  installments_paid_before: Scalars['Int']['output'];
  paid_amount?: Maybe<Scalars['Float']['output']>;
  start_date?: Maybe<Scalars['Date']['output']>;
  status: Scalars['String']['output'];
  total_amount?: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
};

export enum GradeTypeEnum {
  Cualitativa = 'CUALITATIVA',
  Cuantitativa = 'CUANTITATIVA'
}

export type GrantCopilotPlannerReportAccessInput = {
  /** centralized_user_id del colaborador a agregar (numérico, expuesto como ID). Es lo ÚNICO que gobierna la autorización: sale del selector con autocomplete de la página, que lo leyó de centralized_users.get_centralized_user_organizations. No puede ser el owner del reporte. */
  centralized_user_id: Scalars['ID']['input'];
  /** Correo del colaborador, para el aviso y para la lista de accesos. Es denormalización de display/auditoría, no de autorización. Sin él NO se envía el correo de aviso. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Nombre del colaborador para display/auditoría. El modal muestra el nombre federado (centralized_user), así que este valor no llega a la UI. */
  full_name?: InputMaybe<Scalars['String']['input']>;
  /** UUID del reporte del Planner Agent. */
  report_id: Scalars['ID']['input'];
};

export type GrantCopilotPlannerReportAccessResult = CopilotPlannerReportAccessGrantedPayload | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type GraphOperationI = {
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

/** Average performance score and its semaphore classification for one group (department / job / subsidiary / country / leader). */
export type GroupAverageResultType = {
  __typename?: 'GroupAverageResultType';
  average_score: Scalars['Float']['output'];
  group_id?: Maybe<Scalars['Int']['output']>;
  group_name: Scalars['String']['output'];
  semaphore_color: Scalars['String']['output'];
  semaphore_label: Scalars['String']['output'];
};

export type GroupComparisonConnection = {
  __typename?: 'GroupComparisonConnection';
  /** Contains the nodes in this connection */
  edges: Array<GroupComparisonInfoEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
  updated_date?: Maybe<Scalars['DateTime']['output']>;
};

export type GroupComparisonInfo = {
  __typename?: 'GroupComparisonInfo';
  courses_assigned: Scalars['Int']['output'];
  courses_completed: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_mine: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  progress_percentage: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  study_minutes: Scalars['Int']['output'];
  users_count: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GroupComparisonInfoEdge = {
  __typename?: 'GroupComparisonInfoEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: GroupComparisonInfo;
};

export type GroupComparisonResponse = FoundationLeaderIntegrityError | FoundationLeaderInternalError | FoundationLeaderValidationError | GroupComparisonConnection;

export enum GroupEnum {
  Default = 'DEFAULT',
  SelectAll = 'SELECT_ALL'
}

/** Progress of one group (department / job / level). */
export type GroupProgressType = {
  __typename?: 'GroupProgressType';
  group_id: Scalars['Int']['output'];
  group_name: Scalars['String']['output'];
  relations: Array<RelationProgressType>;
};

export type HcmEmployeesByCompanyCustomConnection = {
  __typename?: 'HCMEmployeesByCompanyCustomConnection';
  edges: Array<TalentEmployeeEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type HcmEmployeesByCompanyResponse = HcmEmployeesByCompanyCustomConnection | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type HrisCorporateDocumentsAdminDocumentsFilterInput = {
  folder_id?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Array<HrisCorporateDocumentsUserStatusEnum>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<HrisCorporateDocumentsDocumentTypeEnum>>;
};

export enum HrisCorporateDocumentsAllowedFormatEnum {
  Bmp = 'BMP',
  Csv = 'CSV',
  Doc = 'DOC',
  Docx = 'DOCX',
  Gif = 'GIF',
  Jpeg = 'JPEG',
  Jpg = 'JPG',
  Pdf = 'PDF',
  Png = 'PNG',
  Ppt = 'PPT',
  Pptx = 'PPTX',
  Txt = 'TXT',
  Xls = 'XLS',
  Xlsx = 'XLSX',
  Zip = 'ZIP'
}

export type HrisCorporateDocumentsCreateUserReadingDocumentInput = {
  assign_to_segment_on_creation?: Scalars['Boolean']['input'];
  /** List of conditionals, each must be non-null */
  conditionals?: InputMaybe<Array<GenericConditionalInput>>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Required file ID */
  file_id: Scalars['Int']['input'];
  folder_id?: InputMaybe<Scalars['Int']['input']>;
  /** Required document name */
  name: Scalars['String']['input'];
  readable_by_user?: Scalars['Boolean']['input'];
};

export type HrisCorporateDocumentsCreateUserReadingDocumentMutationInput = {
  /** Required centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Required list of documents, each must be non-null */
  documents: Array<HrisCorporateDocumentsCreateUserReadingDocumentInput>;
  /** Required list of user IDs, each must be non-null */
  user_ids: Array<Scalars['Int']['input']>;
};

export type HrisCorporateDocumentsCreateUserReadingDocumentMutationResponse = AuthorizationErrorResponse | HrisCorporateDocumentsUserDocumentsReadingPayload | IntegrityErrorResponse | InternalErrorResponse | NotFoundResponse | ValidationErrorResponse;

/** HRIS - Corporate Document Template Footer Config */
export type HrisCorporateDocumentsDocumentFooterConfig = {
  __typename?: 'HRISCorporateDocumentsDocumentFooterConfig';
  enabled: Scalars['Boolean']['output'];
  position: DocumentPosition;
  text?: Maybe<Scalars['String']['output']>;
};

/** HRIS - Corporate Document Template Header Config */
export type HrisCorporateDocumentsDocumentHeaderConfig = {
  __typename?: 'HRISCorporateDocumentsDocumentHeaderConfig';
  enabled: Scalars['Boolean']['output'];
  logo_asset_id?: Maybe<Scalars['Int']['output']>;
  position: DocumentPosition;
};

/** HRIS - Corporate Document Template Page Format */
export type HrisCorporateDocumentsDocumentPageFormat = {
  __typename?: 'HRISCorporateDocumentsDocumentPageFormat';
  footer: HrisCorporateDocumentsDocumentFooterConfig;
  header: HrisCorporateDocumentsDocumentHeaderConfig;
  line_height: Scalars['Float']['output'];
  margin: DocumentMargin;
  orientation: DocumentOrientation;
  page_number: HrisCorporateDocumentsDocumentPageNumberConfig;
  size: DocumentPageSize;
};

/** HRIS - Corporate Document Template Page Number Config */
export type HrisCorporateDocumentsDocumentPageNumberConfig = {
  __typename?: 'HRISCorporateDocumentsDocumentPageNumberConfig';
  enabled: Scalars['Boolean']['output'];
  format: DocumentPageNumberFormat;
  position: DocumentPosition;
};

/** HRIS - Corporate Document Template Detail */
export type HrisCorporateDocumentsDocumentTemplateDetail = {
  __typename?: 'HRISCorporateDocumentsDocumentTemplateDetail';
  description?: Maybe<Scalars['String']['output']>;
  editor_state: Scalars['JSON']['output'];
  folder_id?: Maybe<Scalars['ID']['output']>;
  format: HrisCorporateDocumentsDocumentPageFormat;
  graphql_operation_id: Scalars['ID']['output'];
  html: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  visibility: DocumentTemplateVisibility;
  wildcards: Array<HrisCorporateDocumentsDocumentTemplateWildcard>;
};

export type HrisCorporateDocumentsDocumentTemplateDetailHrisMutationValidationErrorHrisMutationInternalError = HrisCorporateDocumentsDocumentTemplateDetail | HrisMutationInternalError | HrisMutationValidationError;

/** HRIS - HTML content converted from an uploaded .docx file, used as editable content for a document template (wizard Step 1) */
export type HrisCorporateDocumentsDocumentTemplateDocxContent = {
  __typename?: 'HRISCorporateDocumentsDocumentTemplateDocxContent';
  graphql_operation_id: Scalars['ID']['output'];
  html: Scalars['String']['output'];
};

export type HrisCorporateDocumentsDocumentTemplateDocxContentHrisQueryValidationErrorHrisQueryInternalError = HrisCorporateDocumentsDocumentTemplateDocxContent | HrisQueryInternalError | HrisQueryValidationError;

/** HRIS - A document template wildcard that had no value for the requested collaborator */
export type HrisCorporateDocumentsDocumentTemplateMissingWildcard = {
  __typename?: 'HRISCorporateDocumentsDocumentTemplateMissingWildcard';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** HRIS - Downloadable PDF for a document template preview */
export type HrisCorporateDocumentsDocumentTemplatePdf = {
  __typename?: 'HRISCorporateDocumentsDocumentTemplatePdf';
  download_url: Scalars['String']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  missing_wildcards: Array<HrisCorporateDocumentsDocumentTemplateMissingWildcard>;
};

export type HrisCorporateDocumentsDocumentTemplatePdfHrisMutationValidationErrorHrisMutationInternalError = HrisCorporateDocumentsDocumentTemplatePdf | HrisMutationInternalError | HrisMutationValidationError;

/** HRIS - Document template preview with wildcards resolved */
export type HrisCorporateDocumentsDocumentTemplatePreview = {
  __typename?: 'HRISCorporateDocumentsDocumentTemplatePreview';
  footer: HrisCorporateDocumentsDocumentTemplatePreviewFooter;
  graphql_operation_id: Scalars['ID']['output'];
  header: HrisCorporateDocumentsDocumentTemplatePreviewHeader;
  html: Scalars['String']['output'];
  line_height: Scalars['Float']['output'];
  margin: DocumentMargin;
  missing_wildcards: Array<HrisCorporateDocumentsDocumentTemplateMissingWildcard>;
  orientation: DocumentOrientation;
  page_number: HrisCorporateDocumentsDocumentPageNumberConfig;
  page_size: DocumentPageSize;
};

/** HRIS - Resolved footer text shown below a document template preview */
export type HrisCorporateDocumentsDocumentTemplatePreviewFooter = {
  __typename?: 'HRISCorporateDocumentsDocumentTemplatePreviewFooter';
  enabled: Scalars['Boolean']['output'];
  position: DocumentPosition;
  text?: Maybe<Scalars['String']['output']>;
};

export type HrisCorporateDocumentsDocumentTemplatePreviewHrisQueryValidationErrorHrisQueryInternalError = HrisCorporateDocumentsDocumentTemplatePreview | HrisQueryInternalError | HrisQueryValidationError;

/** HRIS - Resolved header logo shown above a document template preview */
export type HrisCorporateDocumentsDocumentTemplatePreviewHeader = {
  __typename?: 'HRISCorporateDocumentsDocumentTemplatePreviewHeader';
  enabled: Scalars['Boolean']['output'];
  logo_url?: Maybe<Scalars['String']['output']>;
  position: DocumentPosition;
};

/** HRIS - Corporate Document Template Wildcard */
export type HrisCorporateDocumentsDocumentTemplateWildcard = {
  __typename?: 'HRISCorporateDocumentsDocumentTemplateWildcard';
  category: DocumentWildcardCategory;
  key: Scalars['String']['output'];
};

/** HRIS - Catalog entry for an available document template wildcard */
export type HrisCorporateDocumentsDocumentTemplateWildcardOption = {
  __typename?: 'HRISCorporateDocumentsDocumentTemplateWildcardOption';
  category: DocumentWildcardCategory;
  choices?: Maybe<Array<Scalars['String']['output']>>;
  data_type: DocumentWildcardDataType;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export enum HrisCorporateDocumentsDocumentTypeEnum {
  Reading = 'READING',
  Request = 'REQUEST',
  Signature = 'SIGNATURE',
  Template = 'TEMPLATE'
}

export type HrisCorporateDocumentsDocuments = HrisCorporateDocumentsDocumentsReading | HrisCorporateDocumentsDocumentsRequest | HrisCorporateDocumentsDocumentsSignature | HrisCorporateDocumentsDocumentsTemplate;

export type HrisCorporateDocumentsDocumentsOrder = {
  asc: Scalars['Boolean']['input'];
  field: HrisCorporateDocumentsDocumentsOrderEnum;
};

export enum HrisCorporateDocumentsDocumentsOrderEnum {
  CreatedAt = 'CREATED_AT',
  Title = 'TITLE'
}

/** HRIS - Corporate Reading Document Info */
export type HrisCorporateDocumentsDocumentsReading = {
  __typename?: 'HRISCorporateDocumentsDocumentsReading';
  created_at: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  location?: Maybe<HrisCorporateDocumentsFolder>;
  progress: Scalars['Int']['output'];
  reading_file: HrisCorporateDocumentsFile;
  title: Scalars['String']['output'];
};

/** HRIS - Corporate Request Document Info */
export type HrisCorporateDocumentsDocumentsRequest = {
  __typename?: 'HRISCorporateDocumentsDocumentsRequest';
  allowed_formats: Array<HrisCorporateDocumentsAllowedFormatEnum>;
  created_at: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  location?: Maybe<HrisCorporateDocumentsFolder>;
  progress: Scalars['Int']['output'];
  request_file?: Maybe<HrisCorporateDocumentsFile>;
  title: Scalars['String']['output'];
};

/** HRIS - Corporate Signature Document Info */
export type HrisCorporateDocumentsDocumentsSignature = {
  __typename?: 'HRISCorporateDocumentsDocumentsSignature';
  created_at: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  location?: Maybe<HrisCorporateDocumentsFolder>;
  progress: Scalars['Int']['output'];
  signature_file: HrisCorporateDocumentsFile;
  title: Scalars['String']['output'];
};

/** HRIS - Corporate Template Document Info */
export type HrisCorporateDocumentsDocumentsTemplate = {
  __typename?: 'HRISCorporateDocumentsDocumentsTemplate';
  created_at: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  location?: Maybe<HrisCorporateDocumentsFolder>;
  progress?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

/** HRIS - Corporate Documents File */
export type HrisCorporateDocumentsFile = {
  __typename?: 'HRISCorporateDocumentsFile';
  file: File;
  format: HrisCorporateDocumentsAllowedFormatEnum;
  id: Scalars['ID']['output'];
};

/** HRIS - Corporate Documents Folder */
export type HrisCorporateDocumentsFolder = {
  __typename?: 'HRISCorporateDocumentsFolder';
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type HrisCorporateDocumentsGetAdminDocumentsQueryInput = {
  centralized_organization_id: Scalars['Int']['input'];
  filter?: InputMaybe<HrisCorporateDocumentsAdminDocumentsFilterInput>;
  order?: InputMaybe<Array<HrisCorporateDocumentsDocumentsOrder>>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** HRIS - Get Admin Documents Payload */
export type HrisCorporateDocumentsGetAdminDocumentsQueryPayload = {
  __typename?: 'HRISCorporateDocumentsGetAdminDocumentsQueryPayload';
  documents: Array<HrisCorporateDocumentsDocuments>;
  success_message: Scalars['String']['output'];
  total_count: Scalars['Int']['output'];
};

export type HrisCorporateDocumentsGetAdminDocumentsQueryResponse = HrisCorporateDocumentsGetAdminDocumentsQueryPayload | IntegrityErrorResponse | InternalErrorResponse | ValidationErrorResponse;

export type HrisCorporateDocumentsGetUserDocumentsQueryInput = {
  centralized_organization_id: Scalars['Int']['input'];
  filter?: InputMaybe<HrisCorporateDocumentsUserDocumentsFilterInput>;
  order?: InputMaybe<Array<HrisCorporateDocumentsDocumentsOrder>>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  user_id: Scalars['Int']['input'];
};

/** HRIS - Get User Documents Payload */
export type HrisCorporateDocumentsGetUserDocumentsQueryPayload = {
  __typename?: 'HRISCorporateDocumentsGetUserDocumentsQueryPayload';
  documents: Array<HrisCorporateDocumentsUserDocuments>;
  success_message: Scalars['String']['output'];
  total_count: Scalars['Int']['output'];
};

export type HrisCorporateDocumentsGetUserDocumentsQueryResponse = AuthorizationErrorResponse | HrisCorporateDocumentsGetUserDocumentsQueryPayload | IntegrityErrorResponse | InternalErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type HrisCorporateDocumentsMutations = {
  __typename?: 'HRISCorporateDocumentsMutations';
  /** Create user reading document (V2) */
  create_user_reading_document: HrisCorporateDocumentsCreateUserReadingDocumentMutationResponse;
  /** Queue massive document upload fanout (V2: excelFileId optional) */
  massive_document_upload: HrisMassiveDocumentUploadPayload;
};


export type HrisCorporateDocumentsMutationsCreate_User_Reading_DocumentArgs = {
  input: HrisCorporateDocumentsCreateUserReadingDocumentMutationInput;
};


export type HrisCorporateDocumentsMutationsMassive_Document_UploadArgs = {
  input: HrisMassiveDocumentUploadInput;
};

export type HrisCorporateDocumentsQueries = {
  __typename?: 'HRISCorporateDocumentsQueries';
  /** Get admin corporate documents (V2) */
  get_admin_documents: HrisCorporateDocumentsGetAdminDocumentsQueryResponse;
  /** Get documents for a user in an organization */
  get_documents: CorporateDocumentV2NodeList;
  /** Get user documents (V2) */
  get_user_documents: HrisCorporateDocumentsGetUserDocumentsQueryResponse;
};


export type HrisCorporateDocumentsQueriesGet_Admin_DocumentsArgs = {
  input: HrisCorporateDocumentsGetAdminDocumentsQueryInput;
};


export type HrisCorporateDocumentsQueriesGet_DocumentsArgs = {
  document_type?: InputMaybe<Scalars['String']['input']>;
  folder_id?: InputMaybe<Scalars['Int']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  organization_id: Scalars['Int']['input'];
  user_id: Scalars['Int']['input'];
};


export type HrisCorporateDocumentsQueriesGet_User_DocumentsArgs = {
  input: HrisCorporateDocumentsGetUserDocumentsQueryInput;
};

export type HrisCorporateDocumentsUserDocuments = HrisCorporateDocumentsUserDocumentsReading | HrisCorporateDocumentsUserDocumentsRequest | HrisCorporateDocumentsUserDocumentsSignature | HrisCorporateDocumentsUserDocumentsTemplate;

export type HrisCorporateDocumentsUserDocumentsFilterInput = {
  folder_id?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Array<HrisCorporateDocumentsUserStatusEnum>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<HrisCorporateDocumentsDocumentTypeEnum>>;
};

/** HRIS - User Reading Document Info */
export type HrisCorporateDocumentsUserDocumentsReading = {
  __typename?: 'HRISCorporateDocumentsUserDocumentsReading';
  assigned_at: Scalars['DateTime']['output'];
  created_at: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  location?: Maybe<HrisCorporateDocumentsFolder>;
  progress?: Maybe<Scalars['Int']['output']>;
  reading_file: HrisCorporateDocumentsFile;
  reading_status: HrisCorporateDocumentsUserReadingStatusEnum;
  title: Scalars['String']['output'];
};

/** HRIS - Create User Reading Document Payload */
export type HrisCorporateDocumentsUserDocumentsReadingPayload = {
  __typename?: 'HRISCorporateDocumentsUserDocumentsReadingPayload';
  graphql_operation_id: Scalars['ID']['output'];
};

/** HRIS - User Request Document Info */
export type HrisCorporateDocumentsUserDocumentsRequest = {
  __typename?: 'HRISCorporateDocumentsUserDocumentsRequest';
  allowed_formats: Array<HrisCorporateDocumentsAllowedFormatEnum>;
  assigned_at: Scalars['DateTime']['output'];
  created_at: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  location?: Maybe<HrisCorporateDocumentsFolder>;
  progress?: Maybe<Scalars['Int']['output']>;
  requested_file?: Maybe<HrisCorporateDocumentsFile>;
  requested_status: HrisCorporateDocumentsUserRequestStatusEnum;
  title: Scalars['String']['output'];
};

/** HRIS - User Signature Document Info */
export type HrisCorporateDocumentsUserDocumentsSignature = {
  __typename?: 'HRISCorporateDocumentsUserDocumentsSignature';
  assigned_at: Scalars['DateTime']['output'];
  created_at: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  location?: Maybe<HrisCorporateDocumentsFolder>;
  progress?: Maybe<Scalars['Int']['output']>;
  signature_file: HrisCorporateDocumentsFile;
  signature_status: HrisCorporateDocumentsUserSignatureStatusEnum;
  title: Scalars['String']['output'];
};

/** HRIS - User Template Document Info */
export type HrisCorporateDocumentsUserDocumentsTemplate = {
  __typename?: 'HRISCorporateDocumentsUserDocumentsTemplate';
  assigned_at: Scalars['DateTime']['output'];
  created_at: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  location?: Maybe<HrisCorporateDocumentsFolder>;
  progress?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export enum HrisCorporateDocumentsUserReadingStatusEnum {
  Expired = 'EXPIRED',
  Hidden = 'HIDDEN',
  Opened = 'OPENED',
  Pending = 'PENDING'
}

export enum HrisCorporateDocumentsUserRequestStatusEnum {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export enum HrisCorporateDocumentsUserSignatureStatusEnum {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export enum HrisCorporateDocumentsUserStatusEnum {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Hidden = 'HIDDEN',
  InProgress = 'IN_PROGRESS',
  Opened = 'OPENED',
  Pending = 'PENDING'
}

export type HrisCorporationsGetChildrenOrgNavigationQueryPayload = {
  __typename?: 'HRISCorporationsGetChildrenOrgNavigationQueryPayload';
  current_org: HrisCorporationsGetCorporationChildrenOrgNavigationData;
  end_cursor?: Maybe<Scalars['String']['output']>;
  has_next_page: Scalars['Boolean']['output'];
  is_corporation: Scalars['Boolean']['output'];
  is_current_parent_org: Scalars['Boolean']['output'];
  organizations: Array<HrisCorporationsGetCorporationChildrenOrgNavigationData>;
  parent_org_id?: Maybe<Scalars['Int']['output']>;
  start_cursor?: Maybe<Scalars['String']['output']>;
  total_count: Scalars['Int']['output'];
};

export type HrisCorporationsGetChildrenOrgNavigationQueryPayloadIntegrityErrorResponseInternalErrorResponseValidationErrorResponseNotFoundResponseNotAuthenticatedErrorResponse = HrisCorporationsGetChildrenOrgNavigationQueryPayload | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type HrisCorporationsGetCorporationChildrenOrgNavigationData = {
  __typename?: 'HRISCorporationsGetCorporationChildrenOrgNavigationData';
  home_url: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type HrisDefaultResponse = {
  __typename?: 'HRISDefaultResponse';
  graphql_operation_id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError = HrisDefaultResponse | HrisMutationInternalError | HrisMutationValidationError;

export type HrisDocumentFooterConfigInput = {
  enabled: Scalars['Boolean']['input'];
  position?: DocumentPosition;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type HrisDocumentHeaderConfigInput = {
  enabled: Scalars['Boolean']['input'];
  logo_asset_id?: InputMaybe<Scalars['Int']['input']>;
  position?: DocumentPosition;
};

export type HrisDocumentPageFormatInput = {
  footer: HrisDocumentFooterConfigInput;
  header: HrisDocumentHeaderConfigInput;
  line_height: Scalars['Float']['input'];
  margin: DocumentMargin;
  orientation: DocumentOrientation;
  page_number: HrisDocumentPageNumberConfigInput;
  size: DocumentPageSize;
};

export type HrisDocumentPageNumberConfigInput = {
  enabled: Scalars['Boolean']['input'];
  format: DocumentPageNumberFormat;
  position: DocumentPosition;
};

export type HrisDocumentTemplateWildcardInput = {
  category: DocumentWildcardCategory;
  key: Scalars['String']['input'];
};

export type HrisExcelValidationFile = {
  __typename?: 'HRISExcelValidationFile';
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  uploaded_at: Scalars['String']['output'];
};

export type HrisExcelValidationPayload = {
  __typename?: 'HRISExcelValidationPayload';
  file: HrisExcelValidationFile;
  import_batch_id: Scalars['ID']['output'];
  status: HrisExcelValidationStatusEnum;
  summary: HrisExcelValidationSummary;
};

export enum HrisExcelValidationStatusEnum {
  Errors = 'ERRORS',
  Partial = 'PARTIAL',
  Success = 'SUCCESS'
}

export type HrisExcelValidationSummary = {
  __typename?: 'HRISExcelValidationSummary';
  error_count: Scalars['Int']['output'];
  error_groups_count: Scalars['Int']['output'];
  info_count: Scalars['Int']['output'];
  info_groups_count: Scalars['Int']['output'];
  total_records: Scalars['Int']['output'];
  valid_count: Scalars['Int']['output'];
};

export enum HrisGenericOrderByEnum {
  OrderByAz = 'ORDER_BY_AZ',
  OrderByCreatedAt = 'ORDER_BY_CREATED_AT',
  OrderByEndDateAsc = 'ORDER_BY_END_DATE_ASC',
  OrderByEndDateDesc = 'ORDER_BY_END_DATE_DESC',
  OrderByStartDateAsc = 'ORDER_BY_START_DATE_ASC',
  OrderByStartDateDesc = 'ORDER_BY_START_DATE_DESC',
  OrderByZa = 'ORDER_BY_ZA'
}

export type HrisMassiveDocumentUploadInput = {
  excelFileId?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};

export type HrisMassiveDocumentUploadPayload = {
  __typename?: 'HRISMassiveDocumentUploadPayload';
  correlationId: Scalars['String']['output'];
  queued: Scalars['Boolean']['output'];
};

export type HrisMassiveUploadAssignmentQueries = {
  __typename?: 'HRISMassiveUploadAssignmentQueries';
  /** Generate Excel template for massive upload configuration */
  generate_massive_upload_template: GenerateMassiveUploadTemplatePayload;
  /** Validate massive upload assignment configuration */
  validate_massive_upload_assignment: ValidateMassiveUploadAssignmentPayload;
};


export type HrisMassiveUploadAssignmentQueriesGenerate_Massive_Upload_TemplateArgs = {
  input: GenerateMassiveUploadTemplateInput;
};


export type HrisMassiveUploadAssignmentQueriesValidate_Massive_Upload_AssignmentArgs = {
  input: ValidateMassiveUploadAssignmentInput;
};

export type HrisMassiveUploadConfigQueries = {
  __typename?: 'HRISMassiveUploadConfigQueries';
  /** Generate default configuration from uploaded file names */
  generate_massive_upload_default_config: GenerateDefaultConfigPayload;
  /** Validate massive upload configuration items */
  validate_massive_upload_config: ValidateMassiveUploadConfigPayload;
};


export type HrisMassiveUploadConfigQueriesGenerate_Massive_Upload_Default_ConfigArgs = {
  input: GenerateDefaultConfigInput;
};


export type HrisMassiveUploadConfigQueriesValidate_Massive_Upload_ConfigArgs = {
  input: ValidateMassiveUploadConfigInput;
};

export type HrisMassiveUploadHistoryMutations = {
  __typename?: 'HRISMassiveUploadHistoryMutations';
  /** Generate an Excel error report from validation errors */
  generate_massive_upload_error_report: GenerateErrorReportResponse;
};


export type HrisMassiveUploadHistoryMutationsGenerate_Massive_Upload_Error_ReportArgs = {
  input: GenerateMassiveUploadErrorReportInput;
};

export type HrisMassiveUploadHistoryQueries = {
  __typename?: 'HRISMassiveUploadHistoryQueries';
  /** Get detailed view of a specific massive document upload */
  get_massive_document_upload_detail?: Maybe<MassiveDocumentUploadDetailResponse>;
  /** List massive document uploads for an organization with pagination */
  list_massive_document_uploads: MassiveDocumentUploadListResponse;
};


export type HrisMassiveUploadHistoryQueriesGet_Massive_Document_Upload_DetailArgs = {
  input: GetMassiveDocumentUploadDetailInput;
};


export type HrisMassiveUploadHistoryQueriesList_Massive_Document_UploadsArgs = {
  input: ListMassiveDocumentUploadsInput;
};

export type HrisMassiveUploadUuidQueries = {
  __typename?: 'HRISMassiveUploadUuidQueries';
  /** Generate a unique UUID for a massive document upload session. The UUID is guaranteed to not exist in any previous upload. */
  generate_massive_upload_uuid: GenerateMassiveUploadUuidResponse;
};

export type HrisMassiveUploadValidationQueries = {
  __typename?: 'HRISMassiveUploadValidationQueries';
  /** Validate metadata for massive document upload before uploading files */
  validate_massive_upload_metadata: ValidateMassiveUploadMetadataPayload;
};


export type HrisMassiveUploadValidationQueriesValidate_Massive_Upload_MetadataArgs = {
  input: ValidateMassiveUploadMetadataInput;
};

export type HrisMutationInternalError = {
  __typename?: 'HRISMutationInternalError';
  errors: Array<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
};

export type HrisMutationValidationError = {
  __typename?: 'HRISMutationValidationError';
  errors: Array<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
};

export type HrisMutations = {
  __typename?: 'HRISMutations';
  /**
   * Deprecated alias for HRIS corporate documents v2 mutations.
   * @deprecated Use hris.documents instead of hris.corporate_documents_v2.
   */
  corporate_documents_v2: HrisCorporateDocumentsMutations;
  documents: HrisCorporateDocumentsMutations;
  history: HrisMassiveUploadHistoryMutations;
  /**
   * Deprecated alias for massive upload history mutations.
   * @deprecated Use hris.history instead of hris.massive_upload_history.
   */
  massive_upload_history: HrisMassiveUploadHistoryMutations;
};

export type HrisOrgChartCollaboratorHierarchyQueryInput = {
  centralized_organization_id: Scalars['Int']['input'];
  team_pagination?: InputMaybe<OffsetPaginationInput>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** HRIS - Org Chart Collaborator Hierarchy Payload */
export type HrisOrgChartCollaboratorHierarchyQueryPayload = {
  __typename?: 'HRISOrgChartCollaboratorHierarchyQueryPayload';
  /** The collaborator the hierarchy is centered on */
  collaborator: HrisOrgChartCollaboratorNode;
  /** Direct leader, one hop up. Null when the collaborator is at the top of the hierarchy or the leader is outside the directory. */
  direct_leader?: Maybe<HrisOrgChartCollaboratorNode>;
  /** Direct reports, one hop down. The complete team unless team_pagination narrows it to a page. */
  direct_team: Array<HrisOrgChartCollaboratorNode>;
  /** Total direct reports, not the size of the returned page */
  direct_team_total_count: Scalars['Int']['output'];
  /** Success message */
  success_message: Scalars['String']['output'];
};

export type HrisOrgChartCollaboratorHierarchyQueryResponse = HrisOrgChartCollaboratorHierarchyQueryPayload | InternalErrorResponse | NotFoundResponse | ValidationErrorResponse;

/** Subgraph HRIS - Org Chart Collaborator Node */
export type HrisOrgChartCollaboratorNode = {
  __typename?: 'HRISOrgChartCollaboratorNode';
  /** Collaborator Area Name */
  area_name?: Maybe<Scalars['String']['output']>;
  /** Collaborator Avatar Info */
  avatar?: Maybe<File>;
  /** Collaborator Avatar ID */
  avatar_id?: Maybe<Scalars['Int']['output']>;
  /** Collaborator Full Name */
  full_name: Scalars['String']['output'];
  /** Collaborator Headquarter (sede) Name */
  headquarter_name?: Maybe<Scalars['String']['output']>;
  /** Day-precise incorporation (hire) date. Null when the collaborator has no incorporation date on record. */
  incorporation_date?: Maybe<Scalars['Date']['output']>;
  /** Collaborator Position Name */
  position_name?: Maybe<Scalars['String']['output']>;
  /** Whole years since the incorporation date. Null when the collaborator has no usable incorporation date. */
  seniority_years?: Maybe<Scalars['Int']['output']>;
  /** Centralized User ID */
  user_id: Scalars['Int']['output'];
};

export type HrisOrgChartQueries = {
  __typename?: 'HRISOrgChartQueries';
  /** Get the direct leader and direct team of an organization collaborator */
  get_collaborator_hierarchy: HrisOrgChartCollaboratorHierarchyQueryResponse;
  /** Search organization collaborators by name, area or position */
  search_collaborators: HrisOrgChartSearchCollaboratorsQueryResponse;
};


export type HrisOrgChartQueriesGet_Collaborator_HierarchyArgs = {
  input: HrisOrgChartCollaboratorHierarchyQueryInput;
};


export type HrisOrgChartQueriesSearch_CollaboratorsArgs = {
  input: HrisOrgChartSearchCollaboratorsQueryInput;
};

export type HrisOrgChartSearchCollaboratorsQueryInput = {
  centralized_organization_id: Scalars['Int']['input'];
  pagination?: InputMaybe<OffsetPaginationInput>;
  search: Scalars['String']['input'];
};

/** HRIS - Org Chart Search Collaborators Payload */
export type HrisOrgChartSearchCollaboratorsQueryPayload = {
  __typename?: 'HRISOrgChartSearchCollaboratorsQueryPayload';
  /** Matching collaborators for the requested page */
  collaborators: Array<HrisOrgChartCollaboratorNode>;
  /** Success message */
  success_message: Scalars['String']['output'];
  /** Total collaborators matching the search term */
  total_count: Scalars['Int']['output'];
};

export type HrisOrgChartSearchCollaboratorsQueryResponse = HrisOrgChartSearchCollaboratorsQueryPayload | InternalErrorResponse | ValidationErrorResponse;

export enum HrisPositionListOrderFieldEnum {
  Code = 'CODE',
  CreatedAt = 'CREATED_AT',
  FamilyName = 'FAMILY_NAME',
  Name = 'NAME',
  UsersCount = 'USERS_COUNT'
}

export type HrisQueries = {
  __typename?: 'HRISQueries';
  assignment: HrisMassiveUploadAssignmentQueries;
  config: HrisMassiveUploadConfigQueries;
  /**
   * Deprecated alias for HRIS corporate documents v2 queries.
   * @deprecated Use hris.documents instead of hris.corporate_documents_v2.
   */
  corporate_documents_v2: HrisCorporateDocumentsQueries;
  documents: HrisCorporateDocumentsQueries;
  history: HrisMassiveUploadHistoryQueries;
  /**
   * Deprecated alias for massive upload validation queries (Ticket 3).
   * @deprecated Use hris.validation instead of hris.massive_upload.
   */
  massive_upload: HrisMassiveUploadValidationQueries;
  /**
   * Deprecated alias for massive upload assignment queries.
   * @deprecated Use hris.assignment instead of hris.massive_upload_assignment.
   */
  massive_upload_assignment: HrisMassiveUploadAssignmentQueries;
  /**
   * Deprecated alias for massive upload config queries.
   * @deprecated Use hris.config instead of hris.massive_upload_config.
   */
  massive_upload_config: HrisMassiveUploadConfigQueries;
  /**
   * Deprecated alias for massive upload history queries.
   * @deprecated Use hris.history instead of hris.massive_upload_history.
   */
  massive_upload_history: HrisMassiveUploadHistoryQueries;
  /**
   * Deprecated alias for massive upload UUID queries.
   * @deprecated Use hris.uuid instead of hris.massive_upload_uuid.
   */
  massive_upload_uuid: HrisMassiveUploadUuidQueries;
  /**
   * Deprecated alias for massive upload validation queries.
   * @deprecated Use hris.validation instead of hris.massive_upload_validation.
   */
  massive_upload_validation: HrisMassiveUploadValidationQueries;
  org_chart: HrisOrgChartQueries;
  uuid: HrisMassiveUploadUuidQueries;
  validation: HrisMassiveUploadValidationQueries;
};

export type HrisQueryIntegrityError = {
  __typename?: 'HRISQueryIntegrityError';
  errors: Array<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
};

export type HrisQueryInternalError = {
  __typename?: 'HRISQueryInternalError';
  errors: Array<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
};

export type HrisQueryValidationError = {
  __typename?: 'HRISQueryValidationError';
  errors: Array<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
};

export type HrisValidationMassiveAssignmentDocumentResponse = {
  __typename?: 'HRISValidationMassiveAssignmentDocumentResponse';
  error_response?: Maybe<Array<MassiveErrorResponseNode>>;
  errors_quantity: Scalars['Int']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
  users_not_in_segment?: Maybe<Array<MassiveDetailErrorResponseNode>>;
  valid_users?: Maybe<Array<MassiveValidUserInfoResponseNode>>;
  valid_users_quantity: Scalars['Int']['output'];
  validation_response: MassiveValidationResponseNode;
};

export type HrisValidationMassiveAssignmentDocumentResponseHrisMutationValidationErrorHrisMutationInternalError = HrisMutationInternalError | HrisMutationValidationError | HrisValidationMassiveAssignmentDocumentResponse;

export type HrisValidationMassiveAssignmentFolderResponse = {
  __typename?: 'HRISValidationMassiveAssignmentFolderResponse';
  error_response?: Maybe<Array<MassiveErrorResponseNode>>;
  errors_quantity: Scalars['Int']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
  users_not_in_segment?: Maybe<Array<MassiveUserNotInSegmentResponseNode>>;
  valid_users?: Maybe<Array<MassiveValidUserInfoResponseNode>>;
  valid_users_quantity: Scalars['Int']['output'];
  validation_response: MassiveValidationResponseNode;
};

export type HrisValidationMassiveAssignmentFolderResponseHrisMutationValidationErrorHrisMutationInternalError = HrisMutationInternalError | HrisMutationValidationError | HrisValidationMassiveAssignmentFolderResponse;

export enum HanaDocumentFileFormatEnum {
  DocumentCsv = 'DOCUMENT_CSV',
  DocumentDocx = 'DOCUMENT_DOCX',
  DocumentJpg = 'DOCUMENT_JPG',
  DocumentMp3 = 'DOCUMENT_MP3',
  DocumentMp4 = 'DOCUMENT_MP4',
  DocumentPdf = 'DOCUMENT_PDF',
  DocumentPng = 'DOCUMENT_PNG',
  DocumentPpt = 'DOCUMENT_PPT',
  DocumentTxt = 'DOCUMENT_TXT',
  DocumentUrl = 'DOCUMENT_URL',
  DocumentWav = 'DOCUMENT_WAV',
  DocumentXlsx = 'DOCUMENT_XLSX',
  DocumentZip = 'DOCUMENT_ZIP'
}

export type HasUrlPermissionInput = {
  path: Scalars['String']['input'];
};

export type HasUrlPermissionPayload = {
  __typename?: 'HasURLPermissionPayload';
  has_permission: Scalars['Boolean']['output'];
};

export type HasUrlPermissionResponse = HasUrlPermissionPayload | PermissionValidationError | QueryInternalError | QueryValidationError;

export enum HeadquarterStatusActionEnum {
  Active = 'ACTIVE',
  Empty = 'EMPTY',
  Inactive = 'INACTIVE'
}

export type HigherEducationTeamCourse = {
  id: Scalars['ID']['input'];
  is_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_required_project?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
};

export type HighlightedCarouselPayload = BenefitGraphQlOperation & {
  __typename?: 'HighlightedCarouselPayload';
  benefits: BenefitListType;
  graphql_operation_id: Scalars['ID']['output'];
};

export type HighlightedCarouselResponse = HighlightedCarouselPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export enum HolidayRecurrentTypeEnum {
  HolidayRecurrentTypeDaily = 'HOLIDAY_RECURRENT_TYPE_DAILY',
  HolidayRecurrentTypeMonthly = 'HOLIDAY_RECURRENT_TYPE_MONTHLY',
  HolidayRecurrentTypeNone = 'HOLIDAY_RECURRENT_TYPE_NONE',
  HolidayRecurrentTypeWeekly = 'HOLIDAY_RECURRENT_TYPE_WEEKLY',
  HolidayRecurrentTypeYearly = 'HOLIDAY_RECURRENT_TYPE_YEARLY'
}

export type HomeFoundationQuery = {
  __typename?: 'HomeFoundationQuery';
  /** Query home foundation as collaborator */
  get_widgets_config?: Maybe<HomeFoundationWidgetsResponse>;
  /** Query home foundation as administrator */
  get_widgets_config_admin?: Maybe<HomeFoundationWidgetsResponse>;
};

export type HomeFoundationWidgetsResponse = FoundationHomeIntegrityError | FoundationHomeInternalError | FoundationHomeValidationError | FoundationHomeWidgetsConfigPayload;

export type HrisReportInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  from_date?: InputMaybe<Scalars['Date']['input']>;
  /** Headquarter IDs to filter the report. When the requesting user manages specific headquarters, these are validated against user_managed_headquarter before applying the filter. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  policy_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  report_type: HrisReportTypeEnum;
  to_date?: InputMaybe<Scalars['Date']['input']>;
};

export type HrisReportMutation = {
  __typename?: 'HrisReportMutation';
  report_progress_call: ReportResponseAnalyticsMutationInternalError;
};


export type HrisReportMutationReport_Progress_CallArgs = {
  input: HrisReportInput;
};

export enum HrisReportTypeEnum {
  DocumentStatusByUser = 'DOCUMENT_STATUS_BY_USER',
  DocumentStatusSummary = 'DOCUMENT_STATUS_SUMMARY',
  TimeoffGeneralBalancePolicies = 'TIMEOFF_GENERAL_BALANCE_POLICIES',
  TimeoffPoliciesRequest = 'TIMEOFF_POLICIES_REQUEST',
  WorkflowDetail = 'WORKFLOW_DETAIL',
  WorkflowUserDetail = 'WORKFLOW_USER_DETAIL'
}

export type IAllowedUserType = {
  achievements_set: Scalars['JSON']['output'];
  email?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
  last_name: Scalars['String']['output'];
  profile_picture?: Maybe<ImageNode>;
  tag_list: Scalars['JSON']['output'];
  user_id: Scalars['ID']['output'];
};

export type ICurrencyEventNode = {
  background_color?: Maybe<Scalars['String']['output']>;
  currency_point_id?: Maybe<Scalars['Int']['output']>;
  custom_description?: Maybe<Scalars['String']['output']>;
  custom_name: Scalars['String']['output'];
  custom_text?: Maybe<Scalars['String']['output']>;
  event_id?: Maybe<Scalars['Int']['output']>;
  /** EventName related to the CurrencyEvent's Event */
  event_subject?: Maybe<Scalars['String']['output']>;
  event_type_enum?: Maybe<EventTypeEnum>;
  icon?: Maybe<ImageNode>;
  id: Scalars['ID']['output'];
  is_custom_event: Scalars['Boolean']['output'];
  organization_id?: Maybe<Scalars['ID']['output']>;
  url_redirect?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ICurrencyEventType = {
  custom_description?: Maybe<Scalars['String']['output']>;
  custom_name?: Maybe<Scalars['String']['output']>;
  custom_text?: Maybe<Scalars['String']['output']>;
  event_type_enum?: Maybe<EventTypeEnum>;
  icon?: Maybe<ImageNode>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ICurrencyPointNode = {
  /** List of achievements associated with a currency point */
  achievements: CurrencyEventFragmentConnection;
  currency_point_config?: Maybe<AdminCurrencyPointConfigNode>;
  /** List of events associated with a currency point */
  events: CurrencyEventFragmentConnection;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['ID']['output']>;
  rewards: RewardFragmentConnection;
};


export type ICurrencyPointNodeAchievementsArgs = {
  query_variables?: InputMaybe<CurrencyEventQueryInput>;
};


export type ICurrencyPointNodeEventsArgs = {
  query_variables?: InputMaybe<CurrencyEventQueryInput>;
};


export type ICurrencyPointNodeRewardsArgs = {
  query_variables?: InputMaybe<RewardQueryInput>;
};

export type ICurrencyPointType = {
  name?: Maybe<Scalars['String']['output']>;
  status_enum?: Maybe<CurrencyPointStatusEnum>;
};

export type IGamificationNode = {
  organization_id?: Maybe<Scalars['ID']['output']>;
};

export type IRewardNode = {
  /** This field indicates whether a redemption can be made for a particular reward or not */
  can_redeemed_this_reward?: Maybe<Scalars['Boolean']['output']>;
  /** Reward cover */
  cover_attachment?: Maybe<ImageNode>;
  currency_point?: Maybe<Scalars['JSON']['output']>;
  currency_point_id?: Maybe<Scalars['ID']['output']>;
  currency_point_value?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_redeemable?: Maybe<Scalars['Boolean']['output']>;
  money_value?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['ID']['output']>;
  quantity_available?: Maybe<Scalars['Float']['output']>;
  quantity_reserved?: Maybe<Scalars['Float']['output']>;
  /** Field for allowed redemptions with a limit on the quantity of redemptions. */
  redemptions_allowed?: Maybe<Scalars['Int']['output']>;
  /** This field indicates the number of redemptions that can be made, it has a value when the admin has declared a value for the redemptions_allowed field. */
  redemptions_available?: Maybe<Scalars['Int']['output']>;
  reward_tags?: Maybe<Array<RewardTagNode>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type IRewardType = {
  /** Reward cover */
  cover_attachment?: Maybe<ImageNode>;
  currency_point_value?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
};

/** Base Leaderboard Interface */
export type ITextBoxNode = {
  default_image?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['Int']['output']>;
};

/** This node presents an user achievement */
export type IUserAchievementNode = {
  achievement_completed: Scalars['Boolean']['output'];
};

export type IUserEventBankNode = {
  currency_event?: Maybe<Scalars['JSON']['output']>;
  current_event_value?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  notification_seen?: Maybe<Scalars['Boolean']['output']>;
  object_id?: Maybe<Scalars['Int']['output']>;
  object_type_enum?: Maybe<ObjectTypeEnum>;
  organization_id?: Maybe<Scalars['ID']['output']>;
};

/** Summary node to appreciate the xp points, the currency points and the number of events obtained by each user. */
export type IUserSummaryNode = {
  available_currency_points?: Maybe<Scalars['Float']['output']>;
  events_bank: EventCountConnection;
  organization_id?: Maybe<Scalars['Int']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  redemption_expenses?: Maybe<Scalars['Float']['output']>;
  redemptions_count?: Maybe<Scalars['Float']['output']>;
  total_achievements?: Maybe<Scalars['Int']['output']>;
  total_events?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<MyUserNode>;
  user_id?: Maybe<Scalars['Int']['output']>;
  xp_points?: Maybe<Scalars['Float']['output']>;
};


/** Summary node to appreciate the xp points, the currency points and the number of events obtained by each user. */
export type IUserSummaryNodeEvents_BankArgs = {
  query_variables?: InputMaybe<CurrencyEventQueryInput>;
};

export enum IconEnum {
  BookOpen = 'BOOK_OPEN',
  Pencil = 'PENCIL',
  People = 'PEOPLE',
  Sun = 'SUN',
  ThermometerPlus = 'THERMOMETER_PLUS',
  Wifi = 'WIFI'
}

export type IcsLinkType = LinkI & {
  __typename?: 'IcsLinkType';
  absolute_url?: Maybe<Scalars['String']['output']>;
  relative_url?: Maybe<Scalars['String']['output']>;
};

export type IdentificationTypeNode = {
  __typename?: 'IdentificationTypeNode';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type IdseStatusResponse = {
  __typename?: 'IdseStatusResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: IdseStatusType;
};

export type IdseStatusType = {
  __typename?: 'IdseStatusType';
  /** Vencimiento de la e.firma, leido del propio archivo. Es de lo poco que se puede afirmar sin preguntarle al proveedor. */
  certificate_expires_at?: Maybe<Scalars['Date']['output']>;
  /** Cierto cuando la e.firma guardada ya vencio. */
  certificate_is_expired: Scalars['Boolean']['output'];
  /** Numero de serie de la e.firma guardada. */
  certificate_serial_number?: Maybe<Scalars['String']['output']>;
  /** Cierto cuando el `.cer` de la e.firma esta guardado. */
  has_cer_file: Scalars['Boolean']['output'];
  /** Cierto cuando el registro patronal tiene guardada una e.firma: el par de archivos y lo que se leyo de ellos. **No afirma que el certificado este operativo ante el IMSS**, porque el proveedor no permite verificarlo. */
  has_certificate: Scalars['Boolean']['output'];
  has_efirma_password: Scalars['Boolean']['output'];
  /** Cierto cuando el `.key` de la e.firma esta guardado. */
  has_key_file: Scalars['Boolean']['output'];
  has_password: Scalars['Boolean']['output'];
  has_pfx_file: Scalars['Boolean']['output'];
  /** Cierto cuando el registro patronal tiene persistido el identificador que Terra asigno a su usuario de servicio. Es la unica evidencia de que el alta prospero. **No afirma que la razon social este conectada con el IMSS**: el proveedor no ofrece forma de verificar que una transaccion se haya realizado. */
  has_terra_user: Scalars['Boolean']['output'];
  has_username: Scalars['Boolean']['output'];
  /** Ultimo intento de operacion de **certificado** contra el proveedor, con su resultado. `null` cuando nunca se intento. */
  last_certificate_attempt?: Maybe<TerraIdseAttemptType>;
  /** Ultimo intento sobre el **usuario de servicio**. `null` cuando nunca se intento, que no es lo mismo que un intento fallido. Los intentos de certificado van en `last_certificate_attempt`. */
  last_terra_attempt?: Maybe<TerraIdseAttemptType>;
};

export type IdseSubmissionCredentialsResponse = {
  __typename?: 'IdseSubmissionCredentialsResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: IdseSubmissionCredentialsType;
};

/**
 * Los tres datos que Terra exige en cada envio de movimientos: el identificador del usuario de servicio, el NPIE y el registro patronal. Los tres viven en payroll (D-12) y el envio vive en contrato (D-15), asi que viajan juntos.
 *
 * **No transporta el certificado**: ni el `.cer`, ni el `.key`, ni la contrasena de la e.firma, ni la del portal IDSE. Lo que se publica son las claves con que el certificado esta *nombrado* ante el proveedor, no su contenido.
 *
 * **No afirma que el envio vaya a prosperar**: Terra no ofrece consulta que verifique que el usuario opera ni que el certificado siga registrado.
 */
export type IdseSubmissionCredentialsType = {
  __typename?: 'IdseSubmissionCredentialsType';
  /** Numero de registro patronal **completo**, con su digito verificador. El recorte a los 10 caracteres que Terra pide como parametro lo hace contrato: payroll no conoce los formatos del proveedor. Sale del mismo intento que el NPIE, por el mismo motivo. */
  employer_registration_number: Scalars['String']['output'];
  /** NPIE con que el certificado esta nombrado ante Terra. Es el del intento que prospero, **no** el derivado del numero de registro patronal de hoy: el numero se puede editar y el certificado del proveedor sigue nombrado con el que tenia al registrarse. Cuando no hay ningun intento con exito se deriva del numero actual, que es lo que hara el alta cuando ocurra. */
  npie: Scalars['String']['output'];
  /** GUID que Terra asigno al usuario de servicio del registro patronal. `null` cuando el alta todavia no prospero, y en ese caso **la respuesta sigue siendo exitosa**: es lo que permite distinguir «este registro patronal no tiene usuario» de «payroll no contesto». Sin el no hay envio posible, porque el certificado esta colgado de este identificador. */
  terra_user_identifier?: Maybe<Scalars['String']['output']>;
};

export type ImageFile = {
  __typename?: 'ImageFile';
  absolute_url?: Maybe<Scalars['String']['output']>;
  bucket_name?: Maybe<Scalars['String']['output']>;
  content_type: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  download_url?: Maybe<Scalars['String']['output']>;
  file_path?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  relative_url?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

/** Standard Image File Node */
export type ImageFileNode = {
  __typename?: 'ImageFileNode';
  absolute_url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ImageFileV1Type = ShareFileV1Interface & {
  __typename?: 'ImageFileV1Type';
  absolute_url?: Maybe<Scalars['String']['output']>;
  content_type: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by_id?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  download_url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_b2b?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  relative_url: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

export type ImageFileV1TypeMediaFileV1Type = ImageFileV1Type | MediaFileV1Type;

export type ImageNode = {
  __typename?: 'ImageNode';
  /** Base64 representation of this image thumbnail */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Image masked url */
  url: Scalars['String']['output'];
};

export type ImageType = {
  __typename?: 'ImageType';
  placeholder: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Impersonated performed by type */
export type ImpersonatedPerformedBy = {
  __typename?: 'ImpersonatedPerformedBy';
  /** User who performed the impersonation. */
  impersonated_by: CentralizedUserNode;
  /** User who was impersonated. */
  user_impersonated: CentralizedUserNode;
};

export type ImpersonatedUsers = {
  organization_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};

export type ImpersonatedUsersType = {
  __typename?: 'ImpersonatedUsersType';
  organization_id: Scalars['ID']['output'];
  user_id: Scalars['ID']['output'];
};

/** Error on massive user imports */
export type ImportErrorsNode = {
  __typename?: 'ImportErrorsNode';
  error_message: Scalars['String']['output'];
  user_email: Scalars['String']['output'];
};

export type ImportErrorsNodeCustomConnection = {
  __typename?: 'ImportErrorsNodeCustomConnection';
  edges: Array<ImportErrorsNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type ImportErrorsNodeCustomEdge = {
  __typename?: 'ImportErrorsNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ImportErrorsNode;
};

export type ImportExcelFileResponse = {
  __typename?: 'ImportExcelFileResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type ImportPolicyBalanceInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Base64-encoded CSV content */
  csv_content: Scalars['String']['input'];
  /** Policy ID */
  policy_id: Scalars['ID']['input'];
};

export type ImportPolicyBalanceResponse = {
  __typename?: 'ImportPolicyBalanceResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  /** Import result with counts and errors */
  result?: Maybe<ImportPolicyBalanceResultNode>;
  success: Scalars['Boolean']['output'];
};

export type ImportPolicyBalanceResultNode = {
  __typename?: 'ImportPolicyBalanceResultNode';
  /** Per-row error details */
  row_errors: Array<ImportPolicyBalanceRowErrorNode>;
  /** Total rows with errors */
  total_errors: Scalars['Int']['output'];
  /** Total rows processed */
  total_processed: Scalars['Int']['output'];
  /** Total rows successfully imported */
  total_success: Scalars['Int']['output'];
};

export type ImportPolicyBalanceRowErrorNode = {
  __typename?: 'ImportPolicyBalanceRowErrorNode';
  /** Field name with error */
  field: Scalars['String']['output'];
  /** Error message */
  message: Scalars['String']['output'];
  /** Row number (1-indexed) */
  row_number: Scalars['Int']['output'];
};

export type ImssDelegationListResponse = {
  __typename?: 'ImssDelegationListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<ImssDelegationType>;
};

export type ImssDelegationResponse = {
  __typename?: 'ImssDelegationResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: ImssDelegationType;
};

export type ImssDelegationType = {
  __typename?: 'ImssDelegationType';
  code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

/** Tipo de trabajador IMSS (c_TipoTrabajador, layout SUA). */
export enum ImssEmployeeTypeEnum {
  EventualCampo = 'EVENTUAL_CAMPO',
  EventualCiudad = 'EVENTUAL_CIUDAD',
  EventualConstruccion = 'EVENTUAL_CONSTRUCCION',
  Permanente = 'PERMANENTE'
}

export type ImssFractionItem = {
  __typename?: 'ImssFractionItem';
  description: Scalars['String']['output'];
  economic_activity_code: Scalars['String']['output'];
  economic_activity_description: Scalars['String']['output'];
  fraction_code: Scalars['String']['output'];
  risk_class_code: Scalars['String']['output'];
};

export type ImssFractionsResponse = {
  __typename?: 'ImssFractionsResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<ImssFractionItem>;
};

/** Tipo de último movimiento IMSS registrado. */
export enum ImssLastMovementTypeEnum {
  Alta = 'ALTA',
  Ausentismo = 'AUSENTISMO',
  Baja = 'BAJA',
  CambioModalidad = 'CAMBIO_MODALIDAD',
  CambioRs = 'CAMBIO_RS',
  Fusion = 'FUSION',
  Incapacidad = 'INCAPACIDAD',
  ModificacionSalario = 'MODIFICACION_SALARIO',
  Reingreso = 'REINGRESO'
}

export type ImssMovementDetail = {
  __typename?: 'ImssMovementDetail';
  contract_type: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by: Scalars['String']['output'];
  daily_salary?: Maybe<Scalars['Decimal']['output']>;
  days_elapsed: Scalars['Int']['output'];
  days_remaining: Scalars['Int']['output'];
  deadline_status: Scalars['String']['output'];
  due_end_at: Scalars['Date']['output'];
  due_start_at: Scalars['Date']['output'];
  employee_contract_id?: Maybe<Scalars['UUID']['output']>;
  employee_type: Scalars['Int']['output'];
  /** @deprecated Will move to imss_movement_idse_submission. */
  error_detail?: Maybe<Scalars['String']['output']>;
  family_medicine_unit?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  idse_status?: Maybe<Scalars['String']['output']>;
  imss_salary_type?: Maybe<Scalars['Int']['output']>;
  integration_factor?: Maybe<Scalars['Decimal']['output']>;
  legal_entity_id: Scalars['UUID']['output'];
  movement_date: Scalars['Date']['output'];
  movement_type: Scalars['String']['output'];
  origin: Scalars['String']['output'];
  payroll_employee_id: Scalars['UUID']['output'];
  reason_code?: Maybe<Scalars['String']['output']>;
  reduced_schedule?: Maybe<Scalars['Int']['output']>;
  sdi: Scalars['Decimal']['output'];
  shift_type: Scalars['Int']['output'];
  sicoss_employee_number: Scalars['String']['output'];
  sicoss_period_id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use idse_status instead. */
  validated_at?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use idse_status instead. */
  validated_by?: Maybe<Scalars['String']['output']>;
  variable_imss: Scalars['Decimal']['output'];
  variable_integration: Scalars['Decimal']['output'];
};

export type ImssMovementItem = {
  __typename?: 'ImssMovementItem';
  created_at: Scalars['DateTime']['output'];
  daily_salary?: Maybe<Scalars['Decimal']['output']>;
  deadline_status: Scalars['String']['output'];
  due_end_at: Scalars['Date']['output'];
  employee_imss?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  movement_date: Scalars['Date']['output'];
  movement_type: Scalars['String']['output'];
  origin: Scalars['String']['output'];
  reason_code?: Maybe<Scalars['String']['output']>;
  sdi: Scalars['Decimal']['output'];
  sicoss_employee_number: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ImssMovementMutation = {
  __typename?: 'ImssMovementMutation';
  /** Creates a manual IMSS movement (origin='manual'). */
  create_imss_movement: CreateImssMovementResult;
  /** Soft-deletes an in_process IMSS movement. */
  delete_imss_movement: DeleteImssMovementResult;
  /** Generates IMSS movements for the active period by scanning contract events (altas, bajas, salary changes, rehires) within the period date range. */
  generate_imss_movements: GenerateImssMovementsResult;
  /**
   * Marks multiple exported IMSS movements as sent to IDSE.
   * @deprecated DEPRECATED (PAYR-297): the draft/validated/exported/sent pipeline was collapsed into status/idse_status. Use updateImssMovementIdseStatus instead.
   */
  mark_imss_movements_sent_batch: MarkImssMovementsSentBatchResult;
  /** Updates editable fields of an in_process IMSS movement. */
  update_imss_movement: UpdateImssMovementResult;
  /** Updates the IDSE reconciliation result for an IMSS movement. status mirrors idse_status exactly (in_process/accepted/rejected); 'accepted' is terminal. */
  update_imss_movement_idse_status: UpdateImssMovementIdseStatusResult;
  /**
   * Validates an IMSS movement, transitioning it from 'draft' to 'validated'.
   * @deprecated DEPRECATED (PAYR-297): the draft/validated/exported/sent pipeline was collapsed into status/idse_status. Use updateImssMovementIdseStatus instead.
   */
  validate_imss_movement: ValidateImssMovementResult;
  /**
   * Validates multiple IMSS movements in a single batch operation.
   * @deprecated DEPRECATED (PAYR-297): the draft/validated/exported/sent pipeline was collapsed into status/idse_status. Use updateImssMovementIdseStatus instead.
   */
  validate_imss_movements_batch: ValidateImssMovementsBatchResult;
};


export type ImssMovementMutationCreate_Imss_MovementArgs = {
  input: CreateImssMovementInput;
};


export type ImssMovementMutationDelete_Imss_MovementArgs = {
  input: DeleteImssMovementInput;
};


export type ImssMovementMutationGenerate_Imss_MovementsArgs = {
  input: GenerateImssMovementsInput;
};


export type ImssMovementMutationMark_Imss_Movements_Sent_BatchArgs = {
  input: MarkImssMovementsSentBatchInput;
};


export type ImssMovementMutationUpdate_Imss_MovementArgs = {
  input: UpdateImssMovementInput;
};


export type ImssMovementMutationUpdate_Imss_Movement_Idse_StatusArgs = {
  input: UpdateImssMovementIdseStatusInput;
};


export type ImssMovementMutationValidate_Imss_MovementArgs = {
  input: ValidateImssMovementInput;
};


export type ImssMovementMutationValidate_Imss_Movements_BatchArgs = {
  input: ValidateImssMovementsBatchInput;
};

export type ImssMovementQuery = {
  __typename?: 'ImssMovementQuery';
  /** Returns the full detail of a single IMSS movement. */
  get_imss_movement: GetImssMovementResult;
  /** Lists IMSS movements for a legal entity with optional filters. */
  list_imss_movements: ListImssMovementsResult;
};


export type ImssMovementQueryGet_Imss_MovementArgs = {
  input: GetImssMovementInput;
};


export type ImssMovementQueryList_Imss_MovementsArgs = {
  input: ListImssMovementsInput;
};

/** Single IMSS branch rate response wrapper. */
export type ImssRateBranchResponse = {
  __typename?: 'ImssRateBranchResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result?: Maybe<ImssRateBranchSchema>;
};

/** IMSS cuota por ramo (tasa obrera y patronal). */
export type ImssRateBranchSchema = {
  __typename?: 'ImssRateBranchSchema';
  branch_code: Scalars['String']['output'];
  branch_name: Scalars['String']['output'];
  calculation_base: Scalars['String']['output'];
  deactivated_at?: Maybe<Scalars['DateTime']['output']>;
  deactivated_by?: Maybe<Scalars['Int']['output']>;
  display_order: Scalars['Int']['output'];
  employee_rate: Scalars['Decimal']['output'];
  employer_rate: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
};

/** List of IMSS rate records. */
export type ImssRateListResponse = {
  __typename?: 'ImssRateListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<ImssRateSchema>;
};

export type ImssRateMutation = {
  __typename?: 'ImssRateMutation';
  /** Creates a single IMSS branch rate for the given fiscal year. If no rate record exists for that year, it is created automatically. Returns ValidationErrorResponse if the branch already exists for that year. Requires internal Crehana admin role (crehana_internal_admin). */
  create_imss_rate_branch: PayrollCreateImssRateBranchResult;
  /** Deactivates an IMSS rate record (logical delete). Requires internal Crehana admin role (crehana_internal_admin). Sets is_active=false and records deactivation audit (AC-7). Returns NotFoundErrorResponse if record not found. */
  deactivate_imss_rate: PayrollDeactivateImssRateResult;
  /** Deactivates a single IMSS branch rate by its branch UUID. Sets is_active=false and records deactivation audit. Returns NotFoundErrorResponse if the branch does not exist. Requires internal Crehana admin role (crehana_internal_admin). */
  deactivate_imss_rate_branch: PayrollDeactivateImssRateBranchResult;
  /** Seeds the official 2026 IMSS rates. Requires internal Crehana admin role (crehana_internal_admin). Idempotent: if the 2026 record already exists, returns it without creating a duplicate (BR-7 / AC-8). */
  seed_imss_rate: PayrollSeedImssRateResult;
  /** Updates a single IMSS branch rate by its branch UUID. Returns NotFoundErrorResponse if the branch does not exist. Requires internal Crehana admin role (crehana_internal_admin). */
  update_imss_rate_branch: PayrollUpdateImssRateBranchResult;
};


export type ImssRateMutationCreate_Imss_Rate_BranchArgs = {
  input: PayrollCreateImssRateBranchInput;
};


export type ImssRateMutationDeactivate_Imss_RateArgs = {
  input: PayrollDeactivateImssRateInput;
};


export type ImssRateMutationDeactivate_Imss_Rate_BranchArgs = {
  input: PayrollDeactivateImssRateBranchInput;
};


export type ImssRateMutationUpdate_Imss_Rate_BranchArgs = {
  input: PayrollUpdateImssRateBranchInput;
};

export type ImssRateQuery = {
  __typename?: 'ImssRateQuery';
  /** Returns the active IMSS rate record for the given fiscal year scoped to the caller's organization. Returns null result if no active record exists for the requested year (AC-1). */
  get_imss_rate: PayrollGetImssRateResult;
  /** Returns all IMSS rate records for the caller's organization, ordered by fiscal_year DESC. Optionally filters branches to a single branch_code. Returns an empty list if no records exist (AC-2). */
  list_imss_rates: PayrollListImssRatesResult;
};


export type ImssRateQueryGet_Imss_RateArgs = {
  input: PayrollGetImssRateInput;
};


export type ImssRateQueryList_Imss_RatesArgs = {
  input: PayrollListImssRatesInput;
};

/** Single IMSS rate record response wrapper. */
export type ImssRateResponse = {
  __typename?: 'ImssRateResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result?: Maybe<ImssRateSchema>;
};

/** Registro anual de cuotas IMSS. Contiene todos los ramos con sus tasas obrera y patronal. */
export type ImssRateSchema = {
  __typename?: 'ImssRateSchema';
  branches: Array<ImssRateBranchSchema>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  deactivated_at?: Maybe<Scalars['DateTime']['output']>;
  deactivated_by?: Maybe<Scalars['Int']['output']>;
  fiscal_year: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

/** Tipo de salario IMSS (c_TipoSalario, layout SUA). */
export enum ImssSalaryTypeEnum {
  Fijo = 'FIJO',
  Mixto = 'MIXTO',
  Variable = 'VARIABLE'
}

/** Tipo de jornada SAT c_TipoJornada (CFDI Nómina). */
export enum ImssShiftTypeEnum {
  Continuada = 'CONTINUADA',
  Diurna = 'DIURNA',
  Mixta = 'MIXTA',
  Nocturna = 'NOCTURNA',
  Partida = 'PARTIDA',
  PorHora = 'POR_HORA',
  PorTurnos = 'POR_TURNOS',
  Reducida = 'REDUCIDA',
  TiempoCompleto = 'TIEMPO_COMPLETO'
}

export type ImssSubdelegationListResponse = {
  __typename?: 'ImssSubdelegationListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<ImssSubdelegationType>;
};

export type ImssSubdelegationResponse = {
  __typename?: 'ImssSubdelegationResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: ImssSubdelegationType;
};

export type ImssSubdelegationType = {
  __typename?: 'ImssSubdelegationType';
  code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  delegation_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type InactiveAllowedUser = AllowedUserForAssignmentInterface & AllowedUserInterface & {
  __typename?: 'InactiveAllowedUser';
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  tags: UserTagsType;
  user: UserInfoType;
};

export type IncidenceHistoryResult = InternalErrorResponse | PayrollIncidenceHistoryResponse | UserPermissionErrorResponse;

export type IncidenceMutation = {
  __typename?: 'IncidenceMutation';
  /** Approves one or many pending payroll incidences (PENDING -> APPROVED), recording reviewer and timestamp. Idempotent: already terminal incidences are skipped, unknown ids are reported as not_found, and incidences whose period is covered by a run that no longer accepts input changes are reported in blocked with the reason. Scoped by centralized_organization_id. Requires permission payroll.incidencias.gestionar. */
  approve_incidences: ApproveIncidencesResult;
  /** Creates a manual payroll incidence (origin=MANUAL, status=PENDING) of any of the 9 types, associated to the active period. Requires permission payroll.incidencias.gestionar. */
  create_incidence: CreatePayrollIncidenceResult;
  /** Logically deletes a manual payroll incidence (origin=MANUAL). The row is marked inactive (is_active=False) with audit, never physically removed, and stops counting for the run. Blocked while a payroll calculation is in progress. Requires permission payroll.incidencias.gestionar. */
  delete_incidence: DeletePayrollIncidenceResult;
  /** Rejects one or many pending payroll incidences (PENDING -> REJECTED) with a mandatory non-empty reason, recording reviewer and timestamp. Idempotent: already terminal incidences are skipped, unknown ids are reported as not_found, and incidences whose period is covered by a run that no longer accepts input changes are reported in blocked with the reason. Scoped by centralized_organization_id. Requires permission payroll.incidencias.gestionar. */
  reject_incidences: RejectIncidencesResult;
  /** Reopens one or many rejected payroll incidences (REJECTED -> PENDING), clearing the previous review trail (reason, reviewer, timestamp) so they can be reviewed again. Idempotent: incidences not in REJECTED are skipped, unknown ids are reported as not_found, and incidences whose period is covered by a run that no longer accepts input changes are reported in blocked with the reason. Scoped by centralized_organization_id. Requires permission payroll.incidencias.gestionar. */
  reopen_incidences: ReopenIncidencesResult;
  /** Edits a manual payroll incidence. Allowed only when origin=MANUAL and status=PENDING. Requires permission payroll.incidencias.gestionar. */
  update_incidence: UpdatePayrollIncidenceResult;
};


export type IncidenceMutationApprove_IncidencesArgs = {
  input: PayrollApproveIncidencesInput;
};


export type IncidenceMutationCreate_IncidenceArgs = {
  input: PayrollCreateIncidenceInput;
};


export type IncidenceMutationDelete_IncidenceArgs = {
  input: PayrollDeleteIncidenceInput;
};


export type IncidenceMutationReject_IncidencesArgs = {
  input: PayrollRejectIncidencesInput;
};


export type IncidenceMutationReopen_IncidencesArgs = {
  input: PayrollReopenIncidencesInput;
};


export type IncidenceMutationUpdate_IncidenceArgs = {
  input: PayrollUpdateIncidenceInput;
};

export type IncidenceQuery = {
  __typename?: 'IncidenceQuery';
  /** Fetches the full detail of a single active incidence by its id. Soft-deleted incidences are not returned. Requires permission payroll.incidencias.gestionar. */
  get_incidence: GetPayrollIncidenceResult;
  /** Lists the action history of an incidence (creation, approval, rejection, edits) ordered from newest to oldest. Each entry carries the action, who performed it, when, and a JSON with specific changed fields (currently reject_reason on rejections). Requires permission payroll.incidencias.gestionar. */
  incidence_history: IncidenceHistoryResult;
  /** Aggregated incidence counts of a period (corrida) for the dashboard: grand total, counts by status (pending/approved/rejected) and counts by incidence type. Computed with SQL aggregations, without paging the full list. Requires permission payroll.incidencias.gestionar. */
  incidence_summary: IncidenceSummaryResult;
  /** Lists the incidences of a period (corrida) with optional filters by type, status and origin, plus pagination and counts by status. Requires permission payroll.incidencias.gestionar. */
  list_incidences: ListPayrollIncidencesResult;
  /** Translates the four context filters — payroll type, period, work centre, legal entity — into the two things list_incidences and incidence_summary accept: a date window and a set of centralized_user_id. Call it when the filters change, then pass its three fields verbatim into both queries. **null and an empty list in centralized_user_ids mean opposite things**: null is 'do not filter by person', an empty list is 'the scope contains nobody'. Check is_truncated before presenting the result as complete. Requires the PAYROLL product. */
  resolve_incidence_filters: ResolveIncidenceFiltersResult;
};


export type IncidenceQueryGet_IncidenceArgs = {
  input: PayrollGetIncidenceInput;
};


export type IncidenceQueryIncidence_HistoryArgs = {
  input: PayrollIncidenceHistoryInput;
};


export type IncidenceQueryIncidence_SummaryArgs = {
  input: PayrollIncidenceSummaryInput;
};


export type IncidenceQueryList_IncidencesArgs = {
  input: PayrollListIncidencesInput;
};


export type IncidenceQueryResolve_Incidence_FiltersArgs = {
  input: PayrollResolveIncidenceFiltersInput;
};

/** One incidence in a review batch that could not be touched because a payroll run covering its date no longer accepts changes to its inputs (PAYR-598 D-11). */
export type IncidenceReviewBlock = {
  __typename?: 'IncidenceReviewBlock';
  /** The incidence that was left untouched. */
  incidence_id: Scalars['UUID']['output'];
  /** Why it is blocked, in the operator's terms. It is NOT one fixed text: on EN_CALCULO it says to wait, on CALCULADO to recalculate the run, and on DISPERSADO or CERRADO that the money already left and the correction belongs in the next run. */
  reason: Scalars['String']['output'];
  /** Status of the run that blocks it. When several runs cover the date -- normal since PAYR-558, one per legal entity -- the MOST RESTRICTIVE one is reported, the same precedence period_run_status uses. Only EN_CALCULO, CALCULADO, DISPERSADO and CERRADO can appear here; the other members of the enum never block. */
  run_status: PayrollIncidencePeriodRunStatus;
};

export type IncidenceReviewResponse = {
  __typename?: 'IncidenceReviewResponse';
  /** Incidences left untouched because a payroll run covering their date is calculated, dispersed or closed. Empty in the normal case. These ids are NOT in skipped: skipped means the incidence was already in the target state and the call was a no-op, blocked means the change was refused and the operator has to act. */
  blocked: Array<IncidenceReviewBlock>;
  graphql_operation_id: Scalars['ID']['output'];
  not_found: Array<Scalars['UUID']['output']>;
  processed: Array<Scalars['UUID']['output']>;
  skipped: Array<Scalars['UUID']['output']>;
};

export type IncidenceSummaryResponse = {
  __typename?: 'IncidenceSummaryResponse';
  counts_by_status: CountsByStatus;
  counts_by_type: Array<IncidenceTypeCount>;
  graphql_operation_id: Scalars['ID']['output'];
  total: Scalars['Int']['output'];
};

export type IncidenceSummaryResult = IncidenceSummaryResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type IncidenceTypeCount = {
  __typename?: 'IncidenceTypeCount';
  count: Scalars['Int']['output'];
  incidence_type: Scalars['String']['output'];
};

export enum IncorporationDateRecalculationStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

/** An evaluation indicator with threshold and weight. */
export type IndicatorInput = {
  action?: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  threshold: Scalars['String']['input'];
  weight: Scalars['Int']['input'];
};

/** Raw score for a single indicator for a candidate. */
export type IndicatorScoreNode = {
  __typename?: 'IndicatorScoreNode';
  key: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
};

/** Indicator types for the Evaluation Model. Valores permitidos: PERFORMANCE, GOALS, COMPETENCES, NBOX, SENIORITY. */
export enum IndicatorTypeEnum {
  Competences = 'COMPETENCES',
  Goals = 'GOALS',
  Nbox = 'NBOX',
  Performance = 'PERFORMANCE',
  Seniority = 'SENIORITY'
}

export type IndividualGoalByEmployeeDto = {
  __typename?: 'IndividualGoalByEmployeeDTO';
  doneTracks: Scalars['Int']['output'];
  employeeComments?: Maybe<Scalars['String']['output']>;
  employeeResult?: Maybe<Scalars['Float']['output']>;
  goalId: Scalars['Int']['output'];
  goalName: Scalars['String']['output'];
  leaderComments?: Maybe<Scalars['String']['output']>;
  leaderResult?: Maybe<Scalars['Float']['output']>;
  totalTracks: Scalars['Int']['output'];
  trackPeriodId: Scalars['Int']['output'];
  trackPeriodType: GoalTrackPeriodEnum;
  weight: Scalars['Float']['output'];
};

export type IndividualGoalDetailDto = {
  __typename?: 'IndividualGoalDetailDTO';
  approachName?: Maybe<Scalars['String']['output']>;
  bottomLimit?: Maybe<Scalars['Float']['output']>;
  companyGoalName: Scalars['String']['output'];
  conversionType: Scalars['String']['output'];
  createdDate?: Maybe<Scalars['String']['output']>;
  goalDescription?: Maybe<Scalars['String']['output']>;
  goalId: Scalars['Int']['output'];
  goalName: Scalars['String']['output'];
  goalTrackPeriodName: Scalars['String']['output'];
  goalWeight: Scalars['Float']['output'];
  limit1?: Maybe<Scalars['String']['output']>;
  limit2?: Maybe<Scalars['String']['output']>;
  limit3?: Maybe<Scalars['String']['output']>;
  limit4?: Maybe<Scalars['String']['output']>;
  limit5?: Maybe<Scalars['String']['output']>;
  state: GoalEmployeeStateEnum;
  topLimit?: Maybe<Scalars['Float']['output']>;
  updatedDate?: Maybe<Scalars['String']['output']>;
};

/** List of INFONAVIT discount factor records. */
export type InfonavitDiscountFactorListResponse = {
  __typename?: 'InfonavitDiscountFactorListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<InfonavitDiscountFactorSchema>;
};

/** Single INFONAVIT discount factor response wrapper. */
export type InfonavitDiscountFactorResponse = {
  __typename?: 'InfonavitDiscountFactorResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result?: Maybe<InfonavitDiscountFactorSchema>;
};

/** INFONAVIT discount factor record for a fiscal year and organization. */
export type InfonavitDiscountFactorSchema = {
  __typename?: 'InfonavitDiscountFactorSchema';
  centralized_organization_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  damage_insurance_bimonthly?: Maybe<Scalars['Decimal']['output']>;
  deactivated_at?: Maybe<Scalars['DateTime']['output']>;
  deactivated_by?: Maybe<Scalars['Int']['output']>;
  discount_factor: Scalars['Decimal']['output'];
  fiscal_year: Scalars['Int']['output'];
  fixed_monthly_fee: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  mixed_unit_value?: Maybe<Scalars['Decimal']['output']>;
  sbc_percentage: Scalars['Decimal']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type InfonavitMutation = {
  __typename?: 'InfonavitMutation';
  /** Creates a new INFONAVIT discount factor record for an organization. Requires internal Crehana admin role (crehana_internal_admin). Rejects if a record already exists for the same (org, fiscal_year) — AC-5. */
  create_infonavit_discount_factor: PayrollCreateInfonavitDiscountFactorResult;
  /** Deactivates an INFONAVIT discount factor record (logical delete). Requires internal Crehana admin role (crehana_internal_admin). Sets is_active=false and records deactivation audit. Returns NotFoundErrorResponse if record not found. */
  deactivate_infonavit_discount_factor: PayrollDeactivateInfonavitDiscountFactorResult;
  /** Seeds the official 2026 INFONAVIT discount factor for an organization. Requires internal Crehana admin role (crehana_internal_admin). Idempotent: if the 2026 record already exists, returns it without creating a duplicate (BR-6 / AC-10). */
  seed_infonavit_discount_factor: PayrollSeedInfonavitDiscountFactorResult;
  /** Updates an existing INFONAVIT discount factor record. Requires internal Crehana admin role (crehana_internal_admin). Idempotent: returns the unmodified record if all provided values match current values (BR-6). Returns NotFoundErrorResponse if record not found. */
  update_infonavit_discount_factor: PayrollUpdateInfonavitDiscountFactorResult;
};


export type InfonavitMutationCreate_Infonavit_Discount_FactorArgs = {
  input: PayrollCreateInfonavitDiscountFactorInput;
};


export type InfonavitMutationDeactivate_Infonavit_Discount_FactorArgs = {
  input: PayrollDeactivateInfonavitDiscountFactorInput;
};


export type InfonavitMutationSeed_Infonavit_Discount_FactorArgs = {
  input: PayrollSeedInfonavitDiscountFactorInput;
};


export type InfonavitMutationUpdate_Infonavit_Discount_FactorArgs = {
  input: PayrollUpdateInfonavitDiscountFactorInput;
};

export type InfonavitQuery = {
  __typename?: 'InfonavitQuery';
  /** Returns the active INFONAVIT discount factor for the given fiscal year scoped to the caller's organization. Returns null result if no active record exists for the requested year (AC-1b). */
  get_infonavit_discount_factor: PayrollGetInfonavitDiscountFactorResult;
  /** Returns all INFONAVIT discount factor records for the caller's organization, ordered by fiscal_year DESC. Includes inactive records. Returns an empty list if no records exist (AC-2b). */
  list_infonavit_discount_factors: PayrollListInfonavitDiscountFactorsResult;
};


export type InfonavitQueryGet_Infonavit_Discount_FactorArgs = {
  input: PayrollGetInfonavitDiscountFactorInput;
};


export type InfonavitQueryList_Infonavit_Discount_FactorsArgs = {
  input: PayrollListInfonavitDiscountFactorsInput;
};

export type IntegrityErrorMutationError = {
  __typename?: 'IntegrityErrorMutationError';
  errors: Array<Scalars['String']['output']>;
};

export type IntegrityErrorResponse = {
  __typename?: 'IntegrityErrorResponse';
  /** Error code */
  code: Scalars['String']['output'];
  /** Operation ID for tracing */
  graphql_operation_id: Scalars['ID']['output'];
  /** Error message */
  message: Scalars['String']['output'];
};

/** ErrorType: Referential integrity violations */
export type IntegrityErrorV2 = {
  __typename?: 'IntegrityErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type IntercomQueries = {
  __typename?: 'IntercomQueries';
  /** This query return a jwt using intercom apikey. */
  get_jwt_encode: JwtResponseTypeJwtResponseTypeError;
};

export enum InterfaceEnum {
  InterfaceApi = 'INTERFACE_API',
  InterfaceUi = 'INTERFACE_UI'
}

export enum InternalCommsAnalyticsPostOrderFields {
  ChannelName = 'CHANNEL_NAME',
  PublishedAt = 'PUBLISHED_AT'
}

export enum InternalCommsAnalyticsPostSearchFields {
  PostId = 'POST_ID'
}

export type InternalCommsAnalyticsQueries = {
  __typename?: 'InternalCommsAnalyticsQueries';
  /** Get posts analytics. */
  get_posts_analytics: InternalCommsGetPostsAnalyticsPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
};


export type InternalCommsAnalyticsQueriesGet_Posts_AnalyticsArgs = {
  input: InternalCommsGetPostsAnalyticsInput;
};

export type InternalCommsChangeMainChannelInput = {
  channel_id: Scalars['UUID']['input'];
};

export type InternalCommsChangeMainChannelMutationPayload = {
  __typename?: 'InternalCommsChangeMainChannelMutationPayload';
  /** The channel changed. */
  channel: InternalCommsChannel;
  graphql_operation_id: Scalars['ID']['output'];
};

export type InternalCommsChangeMainChannelMutationPayloadInternalErrorResponseIntegrityErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsChangeMainChannelMutationPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsChannel = {
  __typename?: 'InternalCommsChannel';
  /** The ID of the cover file. */
  _cover_file_id?: Maybe<Scalars['Int']['output']>;
  /** The ID of the user who created the channel. */
  _created_by: Scalars['Int']['output'];
  /** The IDs of the moderators. */
  _moderator_ids?: Maybe<Array<Scalars['Int']['output']>>;
  /** The ID of user segment group */
  _user_segment_group_id?: Maybe<Scalars['Int']['output']>;
  /** Whether to add audience on creation. */
  add_audience_on_creation: Scalars['Boolean']['output'];
  /** Whether channel members can comment on posts. */
  allow_comments: Scalars['Boolean']['output'];
  /** Whether to allow leaving the channel. */
  allow_leave_channel: Scalars['Boolean']['output'];
  /** Persisted list of blocked words/phrases (returned regardless of the flag value). */
  blocked_words: Array<Scalars['String']['output']>;
  /** Whether comment blocking by offensive words is enabled. */
  blocked_words_enabled: Scalars['Boolean']['output'];
  /** The ID of the centralized organization. */
  centralized_organization_id: Scalars['Int']['output'];
  cover_file?: Maybe<File>;
  /** The creation date of the channel. */
  created_at: Scalars['DateTime']['output'];
  created_by: CentralizedUserNode;
  /** The description of the channel. */
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the post. */
  id: Scalars['UUID']['output'];
  /** Whether the channel is the main channel. */
  is_main_channel: Scalars['Boolean']['output'];
  /**
   * Whether the channel is public.
   * @deprecated Use is_public_audience instead.
   */
  is_public: Scalars['Boolean']['output'];
  /** Whether the channel is public audience. */
  is_public_audience: Scalars['Boolean']['output'];
  moderators: Array<CentralizedUserNode>;
  /** The name of the channel. */
  name: Scalars['String']['output'];
  /** The post policy of the channel. */
  post_policy: InternalCommsPostPolicy;
  user_can_post: Scalars['Boolean']['output'];
  user_segment_group_id?: Maybe<Scalars['Int']['output']>;
};

export type InternalCommsChannelAudienceInput = {
  channel_id: Scalars['UUID']['input'];
  order?: InputMaybe<Array<InternalCommsChannelMembersOrderInput>>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type InternalCommsChannelAudiencePayload = {
  __typename?: 'InternalCommsChannelAudiencePayload';
  members: Array<CentralizedUserNode>;
  total_count: Scalars['Int']['output'];
};

export type InternalCommsChannelAudiencePayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsChannelAudiencePayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsChannelDataInput = {
  add_audience_on_creation: Scalars['Boolean']['input'];
  /** Whether channel members can comment on posts. */
  allow_comments?: InputMaybe<Scalars['Boolean']['input']>;
  allow_leave_channel: Scalars['Boolean']['input'];
  /** List of blocked words/phrases. Subject to a configurable list-length cap, applied before deduplication. */
  blocked_words?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether comment blocking by offensive words is enabled. */
  blocked_words_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  cover_file_id?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  is_main_channel: Scalars['Boolean']['input'];
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  moderators?: InputMaybe<Array<Scalars['Int']['input']>>;
  name: Scalars['String']['input'];
  post_policy: InternalCommsPostPolicy;
  segmentation?: InputMaybe<SegmentInput>;
};

export type InternalCommsChannelInput = {
  centralized_organization_id: Scalars['Int']['input'];
  channel_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type InternalCommsChannelInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsChannel | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsChannelListInput = {
  centralized_organization_id: Scalars['Int']['input'];
  pagination?: InputMaybe<CursorPaginationInput>;
  search?: InputMaybe<InternalCommsGetChannelsSearchInput>;
};

export type InternalCommsChannelListPayload = {
  __typename?: 'InternalCommsChannelListPayload';
  members: Array<CentralizedUserNode>;
  total_count: Scalars['Int']['output'];
};

export type InternalCommsChannelListPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsChannelListPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsChannelMemberListInput = {
  channel_id: Scalars['UUID']['input'];
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Enum representing user attributes available for ordering the channel audience. */
export enum InternalCommsChannelMembersOrderEnum {
  Area = 'AREA',
  Email = 'EMAIL',
  FullName = 'FULL_NAME',
  Position = 'POSITION'
}

export type InternalCommsChannelMembersOrderInput = {
  desc: Scalars['Boolean']['input'];
  field: InternalCommsChannelMembersOrderEnum;
};

export enum InternalCommsChannelSearchFields {
  Name = 'NAME'
}

export type InternalCommsChannelsMutations = {
  __typename?: 'InternalCommsChannelsMutations';
  change_main_channel: InternalCommsChangeMainChannelMutationPayloadInternalErrorResponseIntegrityErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
  create_channel: InternalCommsCreateChannelMutationPayloadInternalErrorResponseIntegrityErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponse;
  delete_channel: InternalCommsDeleteChannelMutationPayloadInternalErrorResponseIntegrityErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
  join_channel: InternalCommsJoinChannelMutationPayloadInternalErrorResponseIntegrityErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
  leave_channel: InternalCommsLeaveChannelMutationPayloadInternalErrorResponseIntegrityErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
  update_channel: InternalCommsUpdateChannelMutationPayloadModeratorsNotInSegmentWarningResponseInternalErrorResponseIntegrityErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
};


export type InternalCommsChannelsMutationsChange_Main_ChannelArgs = {
  input: InternalCommsChangeMainChannelInput;
};


export type InternalCommsChannelsMutationsCreate_ChannelArgs = {
  input: InternalCommsChannelDataInput;
};


export type InternalCommsChannelsMutationsDelete_ChannelArgs = {
  input: InternalCommsDeleteChannelInput;
};


export type InternalCommsChannelsMutationsJoin_ChannelArgs = {
  input: InternalCommsJoinChannelInput;
};


export type InternalCommsChannelsMutationsLeave_ChannelArgs = {
  input: InternalCommsLeaveChannelInput;
};


export type InternalCommsChannelsMutationsUpdate_ChannelArgs = {
  input: InternalCommsUpdateChannelInput;
};

export type InternalCommsChannelsQueries = {
  __typename?: 'InternalCommsChannelsQueries';
  /** Explore channels. */
  explore_channels: InternalCommsExploreChannelsPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
  /** Retrieve a channel by its ID or the main channel by the centralized organization ID if the ID is not provided. */
  get_channel: InternalCommsChannelInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
  /** Retrieve a channel's audience: members and users who could join it. */
  get_channel_audience: InternalCommsChannelAudiencePayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
  /** Retrieve channel left members. */
  get_channel_left_members: InternalCommsChannelListPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
  /** Retrieve channel members. */
  get_channel_members: InternalCommsChannelListPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
  /** Retrieve filtered and paginated channels. */
  get_channels: InternalCommsGetChannelsPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
  /** Get user channels. */
  get_user_channels: InternalCommsGetUserChannelsPayloadInternalErrorResponseIntegrityErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
  /** Check if a channel name is available. */
  is_channel_name_available: InternalCommsIsChannelNameAvailablePayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
};


export type InternalCommsChannelsQueriesExplore_ChannelsArgs = {
  input: InternalCommsExploreChannelsInput;
};


export type InternalCommsChannelsQueriesGet_ChannelArgs = {
  input?: InputMaybe<InternalCommsChannelInput>;
};


export type InternalCommsChannelsQueriesGet_Channel_AudienceArgs = {
  input: InternalCommsChannelAudienceInput;
};


export type InternalCommsChannelsQueriesGet_Channel_Left_MembersArgs = {
  input: InternalCommsChannelMemberListInput;
};


export type InternalCommsChannelsQueriesGet_Channel_MembersArgs = {
  input: InternalCommsChannelMemberListInput;
};


export type InternalCommsChannelsQueriesGet_ChannelsArgs = {
  input?: InputMaybe<InternalCommsChannelListInput>;
};


export type InternalCommsChannelsQueriesGet_User_ChannelsArgs = {
  input: InternalCommsGetUserChannelsInput;
};


export type InternalCommsChannelsQueriesIs_Channel_Name_AvailableArgs = {
  input: InternalCommsIsChannelNameAvailableInput;
};

export type InternalCommsComment = {
  __typename?: 'InternalCommsComment';
  /** The ID of the user who created the comment. */
  _created_by_id: Scalars['Int']['output'];
  /** The content of the comment. */
  content: Scalars['String']['output'];
  /** The creation date of the comment. */
  created_at: Scalars['DateTime']['output'];
  created_by: CentralizedUserNode;
  /** File attached to the comment, federated to subgraph-file. */
  file?: Maybe<File>;
  /** The ID of the comment. */
  id: Scalars['UUID']['output'];
  /** Whether the current user has liked the comment. */
  liked: Scalars['Boolean']['output'];
  /** The ID of the post. */
  post_id: Scalars['UUID']['output'];
  /** The number of reactions on the comment. */
  reaction_count: Scalars['Int']['output'];
  /** Users mentioned (@) in this comment, with their active status in the organization. */
  tagged_users: Array<TaggedUserNode>;
  /** The last update date of the comment. */
  updated_at: Scalars['DateTime']['output'];
};

export type InternalCommsCommentListInput = {
  pagination?: InputMaybe<CursorPaginationInput>;
  post_id: Scalars['UUID']['input'];
};

export type InternalCommsCommentReactionsInput = {
  /** The comment id. */
  comment_id: Scalars['UUID']['input'];
  /** The pagination. */
  pagination: OffsetPaginationInput;
};

export type InternalCommsCommentsMutations = {
  __typename?: 'InternalCommsCommentsMutations';
  create_comment: InternalCommsCreateCommentMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseValidationErrorResponseIntegrityErrorResponseForbiddenErrorResponseNotFoundResponseOffensiveWordsBlockedError;
  delete_comment: InternalCommsDeleteCommentMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseValidationErrorResponseIntegrityErrorResponseForbiddenErrorResponseNotFoundResponse;
  update_comment: InternalCommsUpdateCommentMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseValidationErrorResponseIntegrityErrorResponseForbiddenErrorResponseNotFoundResponseOffensiveWordsBlockedError;
  update_comment_reaction: InternalCommsUpdateCommentReactionMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseValidationErrorResponseIntegrityErrorResponseForbiddenErrorResponseNotFoundResponse;
};


export type InternalCommsCommentsMutationsCreate_CommentArgs = {
  input: InternalCommsCreateCommentInput;
};


export type InternalCommsCommentsMutationsDelete_CommentArgs = {
  input: InternalCommsDeleteCommentInput;
};


export type InternalCommsCommentsMutationsUpdate_CommentArgs = {
  input: InternalCommsUpdateCommentInput;
};


export type InternalCommsCommentsMutationsUpdate_Comment_ReactionArgs = {
  input: InternalCommsUpdateCommentReactionInput;
};

export type InternalCommsCommentsQueries = {
  __typename?: 'InternalCommsCommentsQueries';
  /** Retrieve filtered and paginated comments. */
  get_comments: InternalCommsGetCommentsPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
};


export type InternalCommsCommentsQueriesGet_CommentsArgs = {
  input?: InputMaybe<InternalCommsCommentListInput>;
};

export type InternalCommsCreateChannelMutationPayload = {
  __typename?: 'InternalCommsCreateChannelMutationPayload';
  /** The channel created. */
  channel: InternalCommsChannel;
  graphql_operation_id: Scalars['ID']['output'];
};

export type InternalCommsCreateChannelMutationPayloadInternalErrorResponseIntegrityErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsCreateChannelMutationPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse;

export type InternalCommsCreateCommentInput = {
  /** Comment text. Optional when a file_id is provided. At least one of content or file_id must be set. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** File id owned by subgraph-file. Optional when content is provided. At least one of content or file_id must be set. */
  file_id?: InputMaybe<Scalars['Int']['input']>;
  post_id: Scalars['UUID']['input'];
};

export type InternalCommsCreateCommentMutationPayload = {
  __typename?: 'InternalCommsCreateCommentMutationPayload';
  /** The comment created. */
  comment: InternalCommsComment;
  graphql_operation_id: Scalars['ID']['output'];
};

export type InternalCommsCreateCommentMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseValidationErrorResponseIntegrityErrorResponseForbiddenErrorResponseNotFoundResponseOffensiveWordsBlockedError = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsCreateCommentMutationPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | OffensiveWordsBlockedError | ValidationErrorResponse;

export type InternalCommsCreateNewPostInput = {
  channel_id: Scalars['UUID']['input'];
  content_html: Scalars['String']['input'];
  /** List of file attachments with position (max 10). Use this instead of file_id. */
  files?: InputMaybe<Array<PostFileInput>>;
  /** Deprecated: Use file_id instead. This field will be removed in a future version. */
  image_id?: InputMaybe<Scalars['Int']['input']>;
  notify_users?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled_at?: InputMaybe<Scalars['String']['input']>;
  scheduled_timezone?: InputMaybe<InternalCommsScheduledTimezone>;
};

export type InternalCommsCreateNewPostMutationPayload = {
  __typename?: 'InternalCommsCreateNewPostMutationPayload';
  graphql_operation_id: Scalars['ID']['output'];
  /** The post created. */
  post: InternalCommsPost;
};

export type InternalCommsCreateNewPostMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseValidationErrorResponseIntegrityErrorResponseForbiddenErrorResponseNotFoundResponseOffensiveWordsBlockedError = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsCreateNewPostMutationPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | OffensiveWordsBlockedError | ValidationErrorResponse;

export type InternalCommsDeleteChannelInput = {
  channel_id: Scalars['UUID']['input'];
};

export type InternalCommsDeleteChannelMutationPayload = {
  __typename?: 'InternalCommsDeleteChannelMutationPayload';
  /** The channel deleted. */
  channel: InternalCommsChannel;
  graphql_operation_id: Scalars['ID']['output'];
};

export type InternalCommsDeleteChannelMutationPayloadInternalErrorResponseIntegrityErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsDeleteChannelMutationPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsDeleteCommentInput = {
  comment_id: Scalars['UUID']['input'];
};

export type InternalCommsDeleteCommentMutationPayload = {
  __typename?: 'InternalCommsDeleteCommentMutationPayload';
  /** The ID of the comment. */
  comment_id: Scalars['UUID']['output'];
  graphql_operation_id: Scalars['ID']['output'];
};

export type InternalCommsDeleteCommentMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseValidationErrorResponseIntegrityErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsDeleteCommentMutationPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsDeletePostInput = {
  post_id: Scalars['UUID']['input'];
};

export type InternalCommsDeletePostMutationPayload = {
  __typename?: 'InternalCommsDeletePostMutationPayload';
  graphql_operation_id: Scalars['ID']['output'];
  /** The ID of the post. */
  post_id: Scalars['UUID']['output'];
};

export type InternalCommsDeletePostMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseValidationErrorResponseIntegrityErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsDeletePostMutationPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsDeleteScheduledPostsInput = {
  channel_id: Scalars['UUID']['input'];
  post_ids: Array<Scalars['UUID']['input']>;
};

export type InternalCommsDeleteScheduledPostsMutationPayload = {
  __typename?: 'InternalCommsDeleteScheduledPostsMutationPayload';
  /** IDs of the posts that were deleted. */
  deleted_post_ids: Array<Scalars['UUID']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
};

export type InternalCommsDeleteScheduledPostsMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseValidationErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | InternalCommsDeleteScheduledPostsMutationPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsExploreChannelsInput = {
  centralized_organization_id: Scalars['Int']['input'];
  pagination?: InputMaybe<OffsetPaginationInput>;
  search?: InputMaybe<InternalCommsExploreChannelsSearchInput>;
};

export type InternalCommsExploreChannelsPayload = {
  __typename?: 'InternalCommsExploreChannelsPayload';
  /** The channels for the user to explore. */
  channels: Array<InternalCommsChannel>;
  /** The total count of the channels. */
  total_count: Scalars['Int']['output'];
};

export type InternalCommsExploreChannelsPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsExploreChannelsPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsExploreChannelsSearchInput = {
  fields: Array<InternalCommsChannelSearchFields>;
  query: Scalars['String']['input'];
};

export type InternalCommsGetChannelPostPayload = {
  __typename?: 'InternalCommsGetChannelPostPayload';
  /** The post. */
  post: InternalCommsPost;
};

export type InternalCommsGetChannelPostPayloadInternalCommsUserIsNotMemberPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsGetChannelPostPayload | InternalCommsUserIsNotMemberPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsGetChannelPostReaction = {
  __typename?: 'InternalCommsGetChannelPostReaction';
  /** The count of interests. */
  interest_count: Scalars['Int']['output'];
  /** The count of likes. */
  like_count: Scalars['Int']['output'];
  /** The count of loves. */
  love_count: Scalars['Int']['output'];
};

export type InternalCommsGetChannelPostsPayload = {
  __typename?: 'InternalCommsGetChannelPostsPayload';
  /** The ID of the channel. */
  channel_id: Scalars['UUID']['output'];
  /** The pagination information of the post connection. */
  page_info: PageInfo;
  /** The posts of the channel. */
  posts: Array<InternalCommsPost>;
  /** The total count of the post connection. */
  total_count: Scalars['Int']['output'];
};

export type InternalCommsGetChannelPostsPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsGetChannelPostsPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsGetChannelsPayload = {
  __typename?: 'InternalCommsGetChannelsPayload';
  /** The channels for centralized organization. */
  channels: Array<InternalCommsChannel>;
  /** The pagination information of the channels. */
  page_info: PageInfo;
  /** The total count of the channels. */
  total_count: Scalars['Int']['output'];
};

export type InternalCommsGetChannelsPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsGetChannelsPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsGetChannelsSearchInput = {
  fields: Array<InternalCommsChannelSearchFields>;
  query: Scalars['String']['input'];
};

export type InternalCommsGetCommentReactionsPayload = {
  __typename?: 'InternalCommsGetCommentReactionsPayload';
  /** The reaction count. */
  total_count: Scalars['Int']['output'];
  /** The total pages. */
  total_pages: Scalars['Int']['output'];
  /** The users. */
  users: Array<CentralizedUserNode>;
};

export type InternalCommsGetCommentReactionsPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsGetCommentReactionsPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsGetCommentsPayload = {
  __typename?: 'InternalCommsGetCommentsPayload';
  /** The comments for the post. */
  comments: Array<InternalCommsComment>;
  /** The pagination information of the comments. */
  page_info: PageInfo;
  /** The total count of the comments. */
  total_count: Scalars['Int']['output'];
};

export type InternalCommsGetCommentsPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsGetCommentsPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsGetPostReactionsPayload = {
  __typename?: 'InternalCommsGetPostReactionsPayload';
  /** The reactions counts. */
  reaction_count: InternalCommsGetChannelPostReaction;
  /** The total count. */
  total_count: Scalars['Int']['output'];
  /** The total pages. */
  total_pages: Scalars['Int']['output'];
  /** The users. */
  users: Array<CentralizedUserNode>;
};

export type InternalCommsGetPostReactionsPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsGetPostReactionsPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsGetPostsAnalyticsInput = {
  centralized_organization_id: Scalars['Int']['input'];
  filter?: InputMaybe<AnalyticsPostFilterInput>;
  order?: InputMaybe<Array<AnalyticsPostOrderInput>>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  search?: InputMaybe<AnalyticsPostSearchInput>;
};

export type InternalCommsGetPostsAnalyticsPayload = {
  __typename?: 'InternalCommsGetPostsAnalyticsPayload';
  /** The public posts information from all channels. */
  posts: Array<InternalCommsPostAnalytics>;
  /** The total count of the posts. */
  total_count: Scalars['Int']['output'];
  /** The total count of posts pages. */
  total_pages: Scalars['Int']['output'];
};

export type InternalCommsGetPostsAnalyticsPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsGetPostsAnalyticsPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsGetUserChannelsInput = {
  centralized_organization_id: Scalars['Int']['input'];
  pagination?: InputMaybe<CursorPaginationInput>;
  search?: InputMaybe<InternalCommsGetUserChannelsSearchInput>;
};

export type InternalCommsGetUserChannelsPayload = {
  __typename?: 'InternalCommsGetUserChannelsPayload';
  /** The channels for the user. */
  channels: Array<InternalCommsChannel>;
  /** The pagination information of the channels. */
  page_info: PageInfo;
  /** The total count of the channels. */
  total_count: Scalars['Int']['output'];
};

export type InternalCommsGetUserChannelsPayloadInternalErrorResponseIntegrityErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsGetUserChannelsPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsGetUserChannelsSearchInput = {
  fields: Array<InternalCommsUserChannelSearchFields>;
  query: Scalars['String']['input'];
};

export type InternalCommsIsChannelNameAvailableInput = {
  centralized_organization_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type InternalCommsIsChannelNameAvailablePayload = {
  __typename?: 'InternalCommsIsChannelNameAvailablePayload';
  /** Whether the channel name is available. */
  is_available: Scalars['Boolean']['output'];
};

export type InternalCommsIsChannelNameAvailablePayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsIsChannelNameAvailablePayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsJoinChannelInput = {
  channel_id: Scalars['UUID']['input'];
};

export type InternalCommsJoinChannelMutationPayload = {
  __typename?: 'InternalCommsJoinChannelMutationPayload';
  /** The channel the user is a member of. */
  channel: InternalCommsChannel;
  graphql_operation_id: Scalars['ID']['output'];
};

export type InternalCommsJoinChannelMutationPayloadInternalErrorResponseIntegrityErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsJoinChannelMutationPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsLeaveChannelInput = {
  channel_id: Scalars['UUID']['input'];
};

export type InternalCommsLeaveChannelMutationPayload = {
  __typename?: 'InternalCommsLeaveChannelMutationPayload';
  graphql_operation_id: Scalars['ID']['output'];
  /** The main channel of the centralized organization. */
  main_channel: InternalCommsChannel;
};

export type InternalCommsLeaveChannelMutationPayloadInternalErrorResponseIntegrityErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsLeaveChannelMutationPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsMutations = {
  __typename?: 'InternalCommsMutations';
  channels: InternalCommsChannelsMutations;
  comments: InternalCommsCommentsMutations;
  posts: InternalCommsPostsMutations;
};

export type InternalCommsPost = {
  __typename?: 'InternalCommsPost';
  _created_by_id: Scalars['Int']['output'];
  /** Whether channel members can comment on this post. Mirrors the channel's setting. */
  allow_comments: Scalars['Boolean']['output'];
  /**
   * The alternative text of the file.
   * @deprecated Use files[].alternative_file_text instead.
   */
  alternative_file_text?: Maybe<Scalars['String']['output']>;
  /** The ID of the channel. */
  channel_id: Scalars['UUID']['output'];
  /** The number of comments on the post. */
  comment_count: Scalars['Int']['output'];
  /** The HTML content of the post. */
  content_html: Scalars['String']['output'];
  /** The creation date of the post. */
  created_at: Scalars['DateTime']['output'];
  created_by: CentralizedUserNode;
  /**
   * The first file of the post.
   * @deprecated Use files instead.
   */
  file?: Maybe<File>;
  /** Ordered list of photo attachments for this post (carousel). */
  files: Array<PostFile>;
  /** The ID of the post. */
  id: Scalars['UUID']['output'];
  /** The reaction of the current user on the post.Can be 'like', 'love', 'interested', or null. */
  my_reaction?: Maybe<InternalCommsReactionType>;
  /** Whether users are notified when this post is published, for both immediate and scheduled publishes. When null, the system treats it as False (no notification). */
  notify_users?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The number of reactions on the post by type.
   * @deprecated Use reactions_count instead
   */
  reaction_count: InternalCommsGetChannelPostReaction;
  /** The number of reactions on the post. */
  reactions_count: Scalars['Int']['output'];
  /** Scheduled datetime as entered by the user (local timezone, e.g. 2026-03-01T10:30:00). */
  scheduled_at?: Maybe<Scalars['String']['output']>;
  /** IANA timezone used when scheduling (e.g. America/Lima). */
  scheduled_timezone?: Maybe<Scalars['String']['output']>;
  /** Users mentioned (@) in this post's body, with their active status in the organization. Only resolved by get_channel_posts and get_channel_post; always empty on scheduled posts and on create/update mutation payloads. */
  tagged_users: Array<TaggedUserNode>;
  /** The last update date of the post. */
  updated_at: Scalars['DateTime']['output'];
};

export type InternalCommsPostAnalytics = {
  __typename?: 'InternalCommsPostAnalytics';
  _created_by_id: Scalars['Int']['output'];
  /** The channel of the post. */
  channel: InternalCommsPostAnalyticsChannel;
  /** The number of comments on the post. */
  comment_count: Scalars['Int']['output'];
  /** The HTML content of the post. */
  content_html: Scalars['String']['output'];
  /** The creation date of the post. */
  created_at: Scalars['DateTime']['output'];
  created_by: CentralizedUserNode;
  /** The files of the post. */
  file?: Maybe<File>;
  /** The ID of the post. */
  id: Scalars['UUID']['output'];
  /** The number of reactions on the post. */
  reaction_count: Scalars['Int']['output'];
  /** The last update date of the post. */
  updated_at: Scalars['DateTime']['output'];
};

export type InternalCommsPostAnalyticsChannel = {
  __typename?: 'InternalCommsPostAnalyticsChannel';
  /** The ID of the channel. */
  id: Scalars['UUID']['output'];
  /** The name of the channel. */
  name: Scalars['String']['output'];
};

export type InternalCommsPostGetInput = {
  channel_id: Scalars['UUID']['input'];
  post_id: Scalars['UUID']['input'];
};

export type InternalCommsPostListInput = {
  channel_id: Scalars['UUID']['input'];
  pagination?: InputMaybe<CursorPaginationInput>;
};

export enum InternalCommsPostPolicy {
  Admin = 'ADMIN',
  AdminAndLeader = 'ADMIN_AND_LEADER',
  AllMembers = 'ALL_MEMBERS'
}

export type InternalCommsPostReactionsInput = {
  /** The pagination. */
  pagination: OffsetPaginationInput;
  /** The post id. */
  post_id: Scalars['UUID']['input'];
  /** The reaction type. */
  reaction_type: InternalCommsReactionType;
};

export type InternalCommsPostsMutations = {
  __typename?: 'InternalCommsPostsMutations';
  create_new_post: InternalCommsCreateNewPostMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseValidationErrorResponseIntegrityErrorResponseForbiddenErrorResponseNotFoundResponseOffensiveWordsBlockedError;
  delete_post: InternalCommsDeletePostMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseValidationErrorResponseIntegrityErrorResponseForbiddenErrorResponseNotFoundResponse;
  delete_scheduled_posts: InternalCommsDeleteScheduledPostsMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseValidationErrorResponseForbiddenErrorResponseNotFoundResponse;
  publish_scheduled_post_now: InternalCommsPublishScheduledPostNowMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseValidationErrorResponseIntegrityErrorResponseForbiddenErrorResponseNotFoundResponse;
  update_post: InternalCommsUpdatePostMutationPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponseForbiddenErrorResponseNotFoundResponseOffensiveWordsBlockedError;
  update_post_reaction: InternalCommsUpdatePostReactionMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponse;
};


export type InternalCommsPostsMutationsCreate_New_PostArgs = {
  input: InternalCommsCreateNewPostInput;
};


export type InternalCommsPostsMutationsDelete_PostArgs = {
  input: InternalCommsDeletePostInput;
};


export type InternalCommsPostsMutationsDelete_Scheduled_PostsArgs = {
  input: InternalCommsDeleteScheduledPostsInput;
};


export type InternalCommsPostsMutationsPublish_Scheduled_Post_NowArgs = {
  input: InternalCommsPublishScheduledPostNowInput;
};


export type InternalCommsPostsMutationsUpdate_PostArgs = {
  input: InternalCommsUpdatePostInput;
};


export type InternalCommsPostsMutationsUpdate_Post_ReactionArgs = {
  input: InternalCommsUpdatePostReactionInput;
};

export type InternalCommsPostsQueries = {
  __typename?: 'InternalCommsPostsQueries';
  /** Retrieve a single post by id and channel (e.g. preview). */
  get_channel_post: InternalCommsGetChannelPostPayloadInternalCommsUserIsNotMemberPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
  /** Retrieve filtered and paginated posts. */
  get_channel_posts: InternalCommsGetChannelPostsPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
  /** Retrieve paginated list of scheduled posts for a channel. Organization admins (application role) and channel moderators only. */
  get_channel_scheduled_posts: InternalCommsGetChannelPostsPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
};


export type InternalCommsPostsQueriesGet_Channel_PostArgs = {
  input: InternalCommsPostGetInput;
};


export type InternalCommsPostsQueriesGet_Channel_PostsArgs = {
  input?: InputMaybe<InternalCommsPostListInput>;
};


export type InternalCommsPostsQueriesGet_Channel_Scheduled_PostsArgs = {
  input: InternalCommsScheduledPostListInput;
};

export type InternalCommsPublishScheduledPostNowInput = {
  channel_id: Scalars['UUID']['input'];
  post_id: Scalars['UUID']['input'];
};

export type InternalCommsPublishScheduledPostNowMutationPayload = {
  __typename?: 'InternalCommsPublishScheduledPostNowMutationPayload';
  graphql_operation_id: Scalars['ID']['output'];
  /** The published post. */
  post: InternalCommsPost;
};

export type InternalCommsPublishScheduledPostNowMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseValidationErrorResponseIntegrityErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsPublishScheduledPostNowMutationPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsQueries = {
  __typename?: 'InternalCommsQueries';
  analytics: InternalCommsAnalyticsQueries;
  channels: InternalCommsChannelsQueries;
  comments: InternalCommsCommentsQueries;
  posts: InternalCommsPostsQueries;
  reactions: InternalCommsReactionsQueries;
};

export enum InternalCommsReactionType {
  Interested = 'INTERESTED',
  Like = 'LIKE',
  Love = 'LOVE'
}

export type InternalCommsReactionsQueries = {
  __typename?: 'InternalCommsReactionsQueries';
  get_comment_reactions: InternalCommsGetCommentReactionsPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
  get_post_reactions: InternalCommsGetPostReactionsPayloadInternalErrorResponseValidationErrorResponseIntegrityErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse;
};


export type InternalCommsReactionsQueriesGet_Comment_ReactionsArgs = {
  input: InternalCommsCommentReactionsInput;
};


export type InternalCommsReactionsQueriesGet_Post_ReactionsArgs = {
  input: InternalCommsPostReactionsInput;
};

export type InternalCommsScheduledPostListInput = {
  channel_id: Scalars['UUID']['input'];
  pagination?: InputMaybe<OffsetPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort_by?: InputMaybe<InternalCommsScheduledPostSortBy>;
};

export enum InternalCommsScheduledPostSortBy {
  CreatedAtDesc = 'CREATED_AT_DESC',
  ScheduledAtAsc = 'SCHEDULED_AT_ASC',
  ScheduledAtDesc = 'SCHEDULED_AT_DESC'
}

/** Allowed timezones for scheduling a publication. If scheduled_at and scheduled_timezone are sent, the post is scheduled for later; if not sent, it is published immediately. */
export enum InternalCommsScheduledTimezone {
  AmericaArgentinaBuenosAires = 'AMERICA_ARGENTINA_BUENOS_AIRES',
  AmericaBogota = 'AMERICA_BOGOTA',
  AmericaLima = 'AMERICA_LIMA',
  AmericaMexicoCity = 'AMERICA_MEXICO_CITY',
  AmericaSantiago = 'AMERICA_SANTIAGO',
  AmericaSaoPaulo = 'AMERICA_SAO_PAULO',
  EuropeBerlin = 'EUROPE_BERLIN'
}

export type InternalCommsUpdateChannelInput = {
  data: InternalCommsChannelDataInput;
  id: Scalars['UUID']['input'];
};

export type InternalCommsUpdateChannelMutationPayload = {
  __typename?: 'InternalCommsUpdateChannelMutationPayload';
  /** The channel updated. */
  channel: InternalCommsChannel;
  graphql_operation_id: Scalars['ID']['output'];
};

export type InternalCommsUpdateChannelMutationPayloadModeratorsNotInSegmentWarningResponseInternalErrorResponseIntegrityErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsUpdateChannelMutationPayload | InternalErrorResponse | ModeratorsNotInSegmentWarningResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsUpdateCommentInput = {
  comment_id: Scalars['UUID']['input'];
  /** Comment text. Optional when a file_id is provided. At least one of content or file_id must be set. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** File id owned by subgraph-file. Optional when content is provided. At least one of content or file_id must be set. */
  file_id?: InputMaybe<Scalars['Int']['input']>;
};

export type InternalCommsUpdateCommentMutationPayload = {
  __typename?: 'InternalCommsUpdateCommentMutationPayload';
  /** The comment updated. */
  comment: InternalCommsComment;
  graphql_operation_id: Scalars['ID']['output'];
};

export type InternalCommsUpdateCommentMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseValidationErrorResponseIntegrityErrorResponseForbiddenErrorResponseNotFoundResponseOffensiveWordsBlockedError = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsUpdateCommentMutationPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | OffensiveWordsBlockedError | ValidationErrorResponse;

export type InternalCommsUpdateCommentReactionInput = {
  comment_id: Scalars['UUID']['input'];
  liked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InternalCommsUpdateCommentReactionMutationPayload = {
  __typename?: 'InternalCommsUpdateCommentReactionMutationPayload';
  /** The comment updated. */
  comment: InternalCommsComment;
  graphql_operation_id: Scalars['ID']['output'];
};

export type InternalCommsUpdateCommentReactionMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseValidationErrorResponseIntegrityErrorResponseForbiddenErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsUpdateCommentReactionMutationPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type InternalCommsUpdatePostInput = {
  content_html: Scalars['String']['input'];
  /** List of file attachments with position (max 10). Use this instead of file_id. */
  files?: InputMaybe<Array<PostFileInput>>;
  /** Deprecated: Use file_id instead. This field will be removed in a future version. */
  image_id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to notify users about the post. Can only be set on scheduled posts. */
  notify_users?: InputMaybe<Scalars['Boolean']['input']>;
  post_id: Scalars['UUID']['input'];
  scheduled_at?: InputMaybe<Scalars['String']['input']>;
  scheduled_timezone?: InputMaybe<InternalCommsScheduledTimezone>;
};

export type InternalCommsUpdatePostMutationPayload = {
  __typename?: 'InternalCommsUpdatePostMutationPayload';
  graphql_operation_id: Scalars['ID']['output'];
  /** The post updated. */
  post: InternalCommsPost;
};

export type InternalCommsUpdatePostMutationPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponseForbiddenErrorResponseNotFoundResponseOffensiveWordsBlockedError = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsUpdatePostMutationPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | OffensiveWordsBlockedError | ValidationErrorResponse;

export type InternalCommsUpdatePostReactionInput = {
  post_id: Scalars['UUID']['input'];
  reaction_type?: InputMaybe<InternalCommsReactionType>;
};

export type InternalCommsUpdatePostReactionMutationPayload = {
  __typename?: 'InternalCommsUpdatePostReactionMutationPayload';
  graphql_operation_id: Scalars['ID']['output'];
  /** The reaction of the current user on the post. */
  my_reaction?: Maybe<InternalCommsReactionType>;
  /** The reaction count of the post. */
  reaction_count: InternalCommsGetChannelPostReaction;
};

export type InternalCommsUpdatePostReactionMutationPayloadInternalErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalCommsUpdatePostReactionMutationPayload | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export enum InternalCommsUserChannelSearchFields {
  Name = 'NAME'
}

export type InternalCommsUserIsNotMemberPayload = {
  __typename?: 'InternalCommsUserIsNotMemberPayload';
  /** Whether the non-member can publish. Always False. */
  can_publish: Scalars['Boolean']['output'];
  /** The ID of the channel the user is not a member of. */
  channel_id: Scalars['UUID']['output'];
  /** The channel description (may be null for legacy channels). */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the user is a member. Always False in this response. */
  is_member: Scalars['Boolean']['output'];
  /** The total number of members in the channel. */
  members_count: Scalars['Int']['output'];
  /** The name of the channel. */
  name: Scalars['String']['output'];
};

/** Returned when a response internal error occurs (500). */
export type InternalErrorResponse = {
  __typename?: 'InternalErrorResponse';
  /** Error code */
  code: Scalars['String']['output'];
  /** Operation ID for tracing */
  graphql_operation_id: Scalars['ID']['output'];
  /** Error message */
  message: Scalars['String']['output'];
};

/** ErrorType: Unexpected internal server error */
export type InternalErrorV2 = {
  __typename?: 'InternalErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

/** Consume info from Federation */
export type InternalLiveSessionUserType = UserLiveSessionI & {
  __typename?: 'InternalLiveSessionUserType';
  has_participated: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  status: UserStatusEnum;
  user: UserLiveSession;
  user_id: Scalars['ID']['output'];
  user_organization_id: Scalars['ID']['output'];
};

export type InternalResourceType = {
  __typename?: 'InternalResourceType';
  file: File;
  id: Scalars['ID']['output'];
};

export type InternalServerError = {
  __typename?: 'InternalServerError';
  errors: Array<Scalars['String']['output']>;
};

export type InternalServerMutationError = {
  __typename?: 'InternalServerMutationError';
  errors: Array<Scalars['String']['output']>;
};

export type InternalSessionResourceType = LiveSessionResourceI & {
  __typename?: 'InternalSessionResourceType';
  file?: Maybe<File>;
  id: Scalars['ID']['output'];
  upload_by?: Maybe<UserLiveSession>;
};

export type InvalidTemplateResponseError = {
  __typename?: 'InvalidTemplateResponseError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type InvalidUserSessionInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
  session_id: Scalars['ID']['input'];
};

export type InvoiceDataInput = {
  address_name: Scalars['String']['input'];
  birthday: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country_iso: Scalars['String']['input'];
  country_name: Scalars['String']['input'];
  document: Scalars['String']['input'];
  document_type: Scalars['String']['input'];
  email: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organization_id: Scalars['Int']['input'];
  phone_code: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  postal_code: Scalars['String']['input'];
  province: Scalars['String']['input'];
  street_number: Scalars['String']['input'];
};

export type InvoiceDataMutationNode = {
  __typename?: 'InvoiceDataMutationNode';
  /** Contains an instance of the Invoice model */
  invoice_data?: Maybe<InvoiceDataNode>;
  /**
   * This object contains information about the response code,
   *         response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type InvoiceDataNode = {
  __typename?: 'InvoiceDataNode';
  id: Scalars['Int']['output'];
};

export type InvoiceDataQueryNode = {
  __typename?: 'InvoiceDataQueryNode';
  address_name?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country_iso?: Maybe<Scalars['String']['output']>;
  country_name?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  document_type?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_code?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
};

/** List of ISN rate records. */
export type IsnRateListResponse = {
  __typename?: 'IsnRateListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<IsnRateSchema>;
};

export type IsnRateMutation = {
  __typename?: 'IsnRateMutation';
  /** Creates a single ISN state rate for the given fiscal year. If no rate header exists for that year, it is created automatically. Returns ValidationErrorResponse if the state already exists for that year. Requires internal Crehana admin role (crehana_internal_admin). */
  create_isn_rate_state: PayrollCreateIsnRateStateResult;
  /** Deactivates an ISN rate record (logical delete). Requires internal Crehana admin role (crehana_internal_admin). Sets is_active=false and records deactivation audit (AC-7). Returns NotFoundErrorResponse if record not found. */
  deactivate_isn_rate: PayrollDeactivateIsnRateResult;
  /** Deactivates a single ISN state rate by its UUID. Sets is_active=false and records deactivation audit. Returns NotFoundErrorResponse if the state does not exist. Requires internal Crehana admin role (crehana_internal_admin). */
  deactivate_isn_rate_state: PayrollDeactivateIsnRateStateResult;
  /** Seeds the official 2026 ISN rates for all organizations (global catalog). Requires internal Crehana admin role (crehana_internal_admin). Idempotent: if the 2026 record already exists, returns it without creating a duplicate (BR-7 / AC-8). */
  seed_isn_rate: PayrollSeedIsnRateResult;
  /** Updates a single ISN state rate by its state UUID. Returns NotFoundErrorResponse if the state does not exist. Requires internal Crehana admin role (crehana_internal_admin). */
  update_isn_rate_state: PayrollUpdateIsnRateStateResult;
};


export type IsnRateMutationCreate_Isn_Rate_StateArgs = {
  input: PayrollCreateIsnRateStateInput;
};


export type IsnRateMutationDeactivate_Isn_RateArgs = {
  input: PayrollDeactivateIsnRateInput;
};


export type IsnRateMutationDeactivate_Isn_Rate_StateArgs = {
  input: PayrollDeactivateIsnRateStateInput;
};


export type IsnRateMutationUpdate_Isn_Rate_StateArgs = {
  input: PayrollUpdateIsnRateStateInput;
};

export type IsnRateQuery = {
  __typename?: 'IsnRateQuery';
  /** Returns the active ISN rate record for the given fiscal year (global catalog — same rates for all organizations). Returns null result if no active record exists for the requested year (AC-1). */
  get_isn_rate: PayrollGetIsnRateResult;
  /** Returns a single ISN state rate by its UUID. Returns null result if the state does not exist. */
  get_isn_rate_state: PayrollGetIsnRateStateResult;
  /** Returns a paginated list of ISN state rates. Supports filtering by fiscal_year (exact), state_code (exact), and state_name (partial, case-insensitive). Default limit: 50 records. */
  list_isn_rate_states: PayrollListIsnRateStatesResult;
  /** Returns all ISN rate records globally, ordered by fiscal_year DESC. Optionally filters states to a single state_code. Returns an empty list if no records exist (AC-2). */
  list_isn_rates: PayrollListIsnRatesResult;
};


export type IsnRateQueryGet_Isn_RateArgs = {
  input: PayrollGetIsnRateInput;
};


export type IsnRateQueryGet_Isn_Rate_StateArgs = {
  input: PayrollGetIsnRateStateInput;
};


export type IsnRateQueryList_Isn_Rate_StatesArgs = {
  input: PayrollListIsnRateStatesInput;
};


export type IsnRateQueryList_Isn_RatesArgs = {
  input: PayrollListIsnRatesInput;
};

/** Single ISN rate record response wrapper. */
export type IsnRateResponse = {
  __typename?: 'IsnRateResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result?: Maybe<IsnRateSchema>;
};

/** Registro anual de tasas ISN por estado (catalogo global). Contiene los 32 estados de Mexico con su tasa de Impuesto Sobre Nomina. */
export type IsnRateSchema = {
  __typename?: 'IsnRateSchema';
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  deactivated_at?: Maybe<Scalars['DateTime']['output']>;
  deactivated_by?: Maybe<Scalars['Int']['output']>;
  fiscal_year: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  states: Array<IsnRateStateSchema>;
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
};

/** Paginated list of ISN state rates. */
export type IsnRateStateListResponse = {
  __typename?: 'IsnRateStateListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<IsnRateStateSchema>;
  total_count: Scalars['Int']['output'];
};

/** Single ISN state rate response wrapper. */
export type IsnRateStateResponse = {
  __typename?: 'IsnRateStateResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result?: Maybe<IsnRateStateSchema>;
};

/** Tasa ISN por estado (porcentaje 0-10%). */
export type IsnRateStateSchema = {
  __typename?: 'IsnRateStateSchema';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deactivated_at?: Maybe<Scalars['DateTime']['output']>;
  deactivated_by?: Maybe<Scalars['Int']['output']>;
  display_order: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  rate: Scalars['Decimal']['output'];
  state_code: Scalars['String']['output'];
  state_name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['Int']['output']>;
};

/** A bracket (renglon) of an ISR table. */
export type IsrBracketSchema = {
  __typename?: 'IsrBracketSchema';
  fixed_fee: Scalars['Decimal']['output'];
  lower_limit: Scalars['Decimal']['output'];
  percentage_over_lower_limit: Scalars['Decimal']['output'];
  sort_order: Scalars['Int']['output'];
  upper_limit?: Maybe<Scalars['Decimal']['output']>;
};

/** List of ISR table records. */
export type IsrTableListResponse = {
  __typename?: 'IsrTableListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<IsrTableSchema>;
};

export type IsrTableMutation = {
  __typename?: 'IsrTableMutation';
  /** Activates (marks as vigente) an ISR table. Requires internal Crehana admin role (crehana_internal_admin). Validates that brackets are contiguous and cover the full year before activation (AC-A5). Returns NotFoundErrorResponse if the table is not found. */
  activate_isr_table: PayrollActivateIsrTableResult;
  /** Creates a new ISR table (header + brackets) as a draft (is_active=false). Requires internal Crehana admin role (crehana_internal_admin). Rejects if a table already exists for the same (org, fiscal_year, period_type) — AC-A4. */
  create_isr_table: PayrollCreateIsrTableResult;
  /** Deactivates an ISR table (logical delete). Requires internal Crehana admin role (crehana_internal_admin). Sets is_active=false and records deactivation audit. Returns NotFoundErrorResponse if the table is not found. */
  deactivate_isr_table: PayrollDeactivateIsrTableResult;
  /** Seeds an official 2026 ISR tariff (11 brackets from ISR_TARIFFS_2026, verbatim) for an organization, already active so the payroll run can resolve it. `period_type` picks which one and defaults to MONTHLY. A biweekly run needs the monthly tariff too — the last-fortnight adjustment uses it (PAYR-596) — so seed it once per period type. Requires internal Crehana admin role (crehana_internal_admin). Idempotent per (org, 2026, period_type): an existing table is returned untouched — including a hand-loaded draft, which is neither activated nor overwritten (PAYR-522 AC-4 / AC-9) — and seeding one period type never touches another. */
  seed_isr_table: PayrollSeedIsrTableResult;
  /** Updates an existing ISR table. Requires internal Crehana admin role (crehana_internal_admin). Idempotent: returns the unmodified record if provided values match (AC-A6). Providing brackets replaces the entire set. Returns NotFoundErrorResponse if the table is not found. */
  update_isr_table: PayrollUpdateIsrTableResult;
};


export type IsrTableMutationActivate_Isr_TableArgs = {
  input: PayrollActivateIsrTableInput;
};


export type IsrTableMutationCreate_Isr_TableArgs = {
  input: PayrollCreateIsrTableInput;
};


export type IsrTableMutationDeactivate_Isr_TableArgs = {
  input: PayrollDeactivateIsrTableInput;
};


export type IsrTableMutationSeed_Isr_TableArgs = {
  input: PayrollSeedIsrTableInput;
};


export type IsrTableMutationUpdate_Isr_TableArgs = {
  input: PayrollUpdateIsrTableInput;
};

export type IsrTableQuery = {
  __typename?: 'IsrTableQuery';
  /** Returns the active ISR table for the given fiscal year and period type scoped to the caller's organization. Returns null result if none exists. */
  get_isr_table: PayrollGetIsrTableResult;
  /** Returns all ISR tables for the caller's organization, ordered by fiscal_year DESC. Includes inactive (draft / deactivated) records. Returns an empty list if no records exist. */
  list_isr_tables: PayrollListIsrTablesResult;
};


export type IsrTableQueryGet_Isr_TableArgs = {
  input: PayrollGetIsrTableInput;
};


export type IsrTableQueryList_Isr_TablesArgs = {
  input: PayrollListIsrTablesInput;
};

/** Single ISR table response wrapper. */
export type IsrTableResponse = {
  __typename?: 'IsrTableResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result?: Maybe<IsrTableSchema>;
};

/** ISR table record for a fiscal year and organization. */
export type IsrTableSchema = {
  __typename?: 'IsrTableSchema';
  brackets: Array<IsrBracketSchema>;
  centralized_organization_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  deactivated_at?: Maybe<Scalars['DateTime']['output']>;
  deactivated_by?: Maybe<Scalars['Int']['output']>;
  fiscal_year: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  period_type: Scalars['String']['output'];
  source_reference: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  updated_by?: Maybe<Scalars['Int']['output']>;
  valid_from: Scalars['Date']['output'];
};

export enum ItemStatusEnum {
  Failed = 'FAILED',
  Success = 'SUCCESS'
}

export type JwtResponseType = {
  __typename?: 'JWTResponseType';
  jwt_encode: Scalars['String']['output'];
};

export type JwtResponseTypeError = {
  __typename?: 'JWTResponseTypeError';
  error_message?: Maybe<Scalars['String']['output']>;
};

export type JwtResponseTypeJwtResponseTypeError = JwtResponseType | JwtResponseTypeError;

export type JobApplicantProfileAnswerInput = {
  answer_value: Scalars['String']['input'];
  question_id: Scalars['Int']['input'];
  question_name: Scalars['String']['input'];
  question_type: Scalars['String']['input'];
};

export type JobApplicantProfilePayload = {
  __typename?: 'JobApplicantProfilePayload';
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last_name: Scalars['String']['output'];
};

export type JobPayload = {
  __typename?: 'JobPayload';
  batch_id?: Maybe<Scalars['Int']['output']>;
  data: Scalars['JSON']['output'];
};

export type JobStatusInputs = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  video_code?: InputMaybe<Scalars['String']['input']>;
  video_id?: InputMaybe<Scalars['Int']['input']>;
  video_lecture_id?: InputMaybe<Scalars['Int']['input']>;
};

export type JobStatusResponse = DataFieldsSent | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type JobTalentType = {
  __typename?: 'JobTalentType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type JwksPayload = {
  __typename?: 'JwksPayload';
  keys: Scalars['JSON']['output'];
};

/** A keyword with metadata sent by the frontend. */
export type KeywordInput = {
  id: Scalars['String']['input'];
  is_ai_generated: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
};

/** Position that matched the input keywords. */
export type KeywordMatchNode = {
  __typename?: 'KeywordMatchNode';
  match_count: Scalars['Int']['output'];
  match_percentage: Scalars['Float']['output'];
  matched_keywords: Array<Scalars['String']['output']>;
  position_id: Scalars['Int']['output'];
  position_name: Scalars['String']['output'];
  talent_id?: Maybe<Scalars['Int']['output']>;
};

export type KeywordsBase = {
  is_manual: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  weight: AtsKeywordWeightEnum;
};

export type KnowledgeHubAdminBaseCategoryI = {
  category_type_enum?: Maybe<CategoryTypeV2Enum>;
  description?: Maybe<Scalars['String']['output']>;
  has_attributes_restriction: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image_info?: Maybe<KnowledgeHubCategoryImageFragment>;
  restriction_detail?: Maybe<CategoryRestrictionDetailType>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  total_content: Scalars['Int']['output'];
  total_visible_content: Scalars['Int']['output'];
  visibility_level?: Maybe<VisibilityLevelType>;
};

export type KnowledgeHubAdminCategoryMutation = {
  __typename?: 'KnowledgeHubAdminCategoryMutation';
  create_category: AdminCreateCategoryResponse;
  create_category_restriction: AdminCreateCategoryRestrictionResponse;
  delete_category: AdminDeleteCategoryResponse;
  delete_category_restriction: AdminDeleteCategoryRestrictionResponse;
  update_category: AdminUpdateCategoryResponse;
  update_category_restriction: AdminUpdateCategoryRestrictionResponse;
};


export type KnowledgeHubAdminCategoryMutationCreate_CategoryArgs = {
  input: AdminCreateOrganizationCategoryInput;
};


export type KnowledgeHubAdminCategoryMutationCreate_Category_RestrictionArgs = {
  input: AdminCreateCategoryRestrictionInput;
};


export type KnowledgeHubAdminCategoryMutationDelete_CategoryArgs = {
  input: AdminDeleteOrganizationCategoryInput;
};


export type KnowledgeHubAdminCategoryMutationDelete_Category_RestrictionArgs = {
  input: AdminDeleteCategoryRestrictionInput;
};


export type KnowledgeHubAdminCategoryMutationUpdate_CategoryArgs = {
  input: AdminUpdateOrganizationCategoryInput;
};


export type KnowledgeHubAdminCategoryMutationUpdate_Category_RestrictionArgs = {
  input: AdminUpdateCategoryRestrictionInput;
};

export type KnowledgeHubAdminCategoryType = KnowledgeHubAdminBaseCategoryI & KnowledgeHubBaseCategoryI & KnowledgeHubCategoryImageInfoI & KnowledgeHubCategoryRestrictionI & KnowledgeHubCategorySummaryI & KnowledgeHubCategoryTypeI & KnowledgeHubVisibilityLevelI & {
  __typename?: 'KnowledgeHubAdminCategoryType';
  category_type_enum?: Maybe<CategoryTypeV2Enum>;
  description?: Maybe<Scalars['String']['output']>;
  has_attributes_restriction: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image_info?: Maybe<KnowledgeHubCategoryImageFragment>;
  restriction_detail?: Maybe<CategoryRestrictionDetailType>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  total_content: Scalars['Int']['output'];
  total_visible_content: Scalars['Int']['output'];
  visibility_level?: Maybe<VisibilityLevelType>;
};

export type KnowledgeHubAdminCategoryTypePaginationEdge = {
  __typename?: 'KnowledgeHubAdminCategoryTypePaginationEdge';
  /** The item at the end of the edge. */
  node: KnowledgeHubAdminCategoryType;
};

export type KnowledgeHubAdminContentCourseType = KnowledgeHubAdminContentI & KnowledgeHubBaseContentI & KnowledgeHubContentRelatedCategoriesI & KnowledgeHubContentRelatedTagsI & KnowledgeHubVisibilityLevelI & {
  __typename?: 'KnowledgeHubAdminContentCourseType';
  content_url?: Maybe<Scalars['String']['output']>;
  /** Content value of the content (underlying course id) */
  content_value?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  image_info: BaseImagePathType;
  language_code?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Level>;
  owner_type?: Maybe<OwnerTypeType>;
  provider?: Maybe<ProviderType>;
  related_categories?: Maybe<Array<KnowledgeHubAdminCategoryType>>;
  related_tags?: Maybe<Array<TagType>>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  visibility_level?: Maybe<VisibilityLevelType>;
};

export type KnowledgeHubAdminContentDocumentMutation = {
  __typename?: 'KnowledgeHubAdminContentDocumentMutation';
  admin_create_content_document: CreateContentDocumentsResponse;
  admin_delete_content_document: DeleteContentDocumentsResponse;
  admin_update_content_document: UpdateContentDocumentResponse;
};


export type KnowledgeHubAdminContentDocumentMutationAdmin_Create_Content_DocumentArgs = {
  input: AdminCreateOrganizationDocumentsInput;
};


export type KnowledgeHubAdminContentDocumentMutationAdmin_Delete_Content_DocumentArgs = {
  input: AdminDeleteDocumentContentInput;
};


export type KnowledgeHubAdminContentDocumentMutationAdmin_Update_Content_DocumentArgs = {
  input: AdminUpdateOrganizationDocumentInput;
};

export type KnowledgeHubAdminContentDocumentType = KnowledgeHubAdminContentI & KnowledgeHubBaseContentI & KnowledgeHubContentRelatedCategoriesI & KnowledgeHubContentRelatedTagsI & KnowledgeHubVisibilityLevelI & {
  __typename?: 'KnowledgeHubAdminContentDocumentType';
  action: DocumentActionEnum;
  content_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  document_file?: Maybe<File>;
  extension?: Maybe<Scalars['String']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  owner_type?: Maybe<OwnerTypeType>;
  related_categories?: Maybe<Array<KnowledgeHubAdminCategoryType>>;
  related_tags?: Maybe<Array<TagType>>;
  size?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  visibility_level?: Maybe<VisibilityLevelType>;
};

export type KnowledgeHubAdminContentFragment = KnowledgeHubAdminContentCourseType | KnowledgeHubAdminContentDocumentType | KnowledgeHubAdminContentTrackType;

export type KnowledgeHubAdminContentI = {
  content_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  related_categories?: Maybe<Array<KnowledgeHubAdminCategoryType>>;
  related_tags?: Maybe<Array<TagType>>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  visibility_level?: Maybe<VisibilityLevelType>;
};

export type KnowledgeHubAdminContentMutation = {
  __typename?: 'KnowledgeHubAdminContentMutation';
  update_content_catalog_visibility: ContentUpdateActionsResponse;
  update_content_categories_relation: ContentUpdateActionsResponse;
  update_organization_content_config_by_course: ContentUpdateActionsResponse;
};


export type KnowledgeHubAdminContentMutationUpdate_Content_Catalog_VisibilityArgs = {
  input: AdminUpdateContentVisibilityInput;
};


export type KnowledgeHubAdminContentMutationUpdate_Content_Categories_RelationArgs = {
  input: AdminAssignCategoriesToContentInput;
};


export type KnowledgeHubAdminContentMutationUpdate_Organization_Content_Config_By_CourseArgs = {
  input: AdminUpdateOrganizationContentConfigInput;
};

export type KnowledgeHubAdminContentTrackType = KnowledgeHubAdminContentI & KnowledgeHubBaseContentI & KnowledgeHubContentRelatedCategoriesI & KnowledgeHubContentRelatedTagsI & KnowledgeHubVisibilityLevelI & {
  __typename?: 'KnowledgeHubAdminContentTrackType';
  content_url?: Maybe<Scalars['String']['output']>;
  course_quantity?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image_info: BaseImagePathType;
  owner_type?: Maybe<OwnerTypeType>;
  related_categories?: Maybe<Array<KnowledgeHubAdminCategoryType>>;
  related_tags?: Maybe<Array<TagType>>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  visibility_level?: Maybe<VisibilityLevelType>;
};

export type KnowledgeHubAdminContentType = {
  __typename?: 'KnowledgeHubAdminContentType';
  content?: Maybe<KnowledgeHubAdminContentFragment>;
};

export type KnowledgeHubAdminContentTypeCursorEdge = {
  __typename?: 'KnowledgeHubAdminContentTypeCursorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: KnowledgeHubAdminContentType;
};

export type KnowledgeHubAdminFiltersCategoryType = KnowledgeHubBaseCategoryI & {
  __typename?: 'KnowledgeHubAdminFiltersCategoryType';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  sub_categories: Array<KnowledgeHubAdminFiltersCategoryType>;
  title: Scalars['String']['output'];
};

export type KnowledgeHubAdminFiltersFragment = DocumentContentFiltersType | EducationContentFiltersType;

export type KnowledgeHubAdminQuery = {
  __typename?: 'KnowledgeHubAdminQuery';
  documents_resume: DocumentResumeNode;
  knowledge_hub_admin_filters: KnowledgeHubFiltersNode;
  knowledge_hub_admin_search?: Maybe<KnowledgeHubContentConnection>;
  knowledge_hub_content_by_organization?: Maybe<KnowledgeHubContentConnection>;
  knowledge_hub_content_detail?: Maybe<KnowledgeHubContentDetailNode>;
  knowledge_hub_content_resume: ContentStatisticsNode;
};


export type KnowledgeHubAdminQueryDocuments_ResumeArgs = {
  organization_id: Scalars['ID']['input'];
  use_kh_new_version?: InputMaybe<Scalars['Boolean']['input']>;
};


export type KnowledgeHubAdminQueryKnowledge_Hub_Admin_FiltersArgs = {
  content_types?: InputMaybe<Array<ContentType>>;
  organization_id: Scalars['ID']['input'];
};


export type KnowledgeHubAdminQueryKnowledge_Hub_Admin_SearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content_types?: InputMaybe<Array<ContentType>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
  search_input: Scalars['String']['input'];
};


export type KnowledgeHubAdminQueryKnowledge_Hub_Content_By_OrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content_types?: InputMaybe<Array<ContentType>>;
  filter_by?: InputMaybe<ContentFiltersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ContentInputOrderBy>>;
  organization_id: Scalars['ID']['input'];
};


export type KnowledgeHubAdminQueryKnowledge_Hub_Content_DetailArgs = {
  content_slug: Scalars['String']['input'];
  content_type: ContentType;
  organization_id: Scalars['ID']['input'];
};


export type KnowledgeHubAdminQueryKnowledge_Hub_Content_ResumeArgs = {
  content_types?: InputMaybe<Array<ContentType>>;
  organization_id: Scalars['ID']['input'];
};

export type KnowledgeHubAdminSimpleCategoryType = KnowledgeHubBaseCategoryI & {
  __typename?: 'KnowledgeHubAdminSimpleCategoryType';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type KnowledgeHubAdminTagMutation = {
  __typename?: 'KnowledgeHubAdminTagMutation';
  assign_tag_to_categories: AdminAssignTagToCategoriesResponse;
  assign_tags_to_content: AdminAssignTagsToContentResponse;
  create_tag: AdminCreateTagResponse;
  delete_tag: AdminDeleteTagResponse;
  update_tag: AdminUpdateTagResponse;
};


export type KnowledgeHubAdminTagMutationAssign_Tag_To_CategoriesArgs = {
  input: AdminAssignTagToCategoriesInput;
};


export type KnowledgeHubAdminTagMutationAssign_Tags_To_ContentArgs = {
  input: AdminAssignTagsToContentInput;
};


export type KnowledgeHubAdminTagMutationCreate_TagArgs = {
  input: AdminCreateTagInput;
};


export type KnowledgeHubAdminTagMutationDelete_TagArgs = {
  input: AdminDeleteTagInput;
};


export type KnowledgeHubAdminTagMutationUpdate_TagArgs = {
  input: AdminUpdateTagInput;
};

export type KnowledgeHubBaseCategoryI = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type KnowledgeHubBaseContentI = {
  content_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type KnowledgeHubCategoryConnection = {
  __typename?: 'KnowledgeHubCategoryConnection';
  edges: Array<KnowledgeHubCategoryNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type KnowledgeHubCategoryImageFragment = BaseImageFileType | BaseImagePathType;

export type KnowledgeHubCategoryImageInfoI = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image_info?: Maybe<KnowledgeHubCategoryImageFragment>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type KnowledgeHubCategoryMutation = {
  __typename?: 'KnowledgeHubCategoryMutation';
  create_category: CreateCategoryResponse;
  create_category_restriction: CreateCategoryRestrictionResponse;
  delete_category: DeleteCategoryResponse;
  delete_category_restriction: DeleteCategoryRestrictionResponse;
  update_category: UpdateCategoryResponse;
  update_category_restriction: UpdateCategoryRestrictionResponse;
};


export type KnowledgeHubCategoryMutationCreate_CategoryArgs = {
  input: CreateOrganizationCategoryInput;
};


export type KnowledgeHubCategoryMutationCreate_Category_RestrictionArgs = {
  input: RestrictCategoryInput;
};


export type KnowledgeHubCategoryMutationDelete_CategoryArgs = {
  input: DeleteOrganizationCategoryInput;
};


export type KnowledgeHubCategoryMutationDelete_Category_RestrictionArgs = {
  category_id: Scalars['ID']['input'];
  organization_id: Scalars['Int']['input'];
};


export type KnowledgeHubCategoryMutationUpdate_CategoryArgs = {
  input: UpdateOrganizationCategoryInput;
};


export type KnowledgeHubCategoryMutationUpdate_Category_RestrictionArgs = {
  input: RestrictCategoryInput;
};

export type KnowledgeHubCategoryNode = {
  __typename?: 'KnowledgeHubCategoryNode';
  attributes_restriction?: Maybe<Array<LearningCustomFieldOptionNode>>;
  category_type?: Maybe<CategoryType>;
  /** Category creation date */
  created_at?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  has_attributes_restriction: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image_file?: Maybe<File>;
  image_url?: Maybe<Scalars['String']['output']>;
  is_new: Scalars['Boolean']['output'];
  is_parent_category: Scalars['Boolean']['output'];
  operator?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['Int']['output']>;
  restriction_operator?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  total_all_courses?: Maybe<Scalars['Int']['output']>;
  total_courses?: Maybe<Scalars['Int']['output']>;
  total_paths?: Maybe<Scalars['Int']['output']>;
  total_sessions?: Maybe<Scalars['Int']['output']>;
  visibility_level?: Maybe<VisibilityLevelType>;
};

/** An edge in a connection. */
export type KnowledgeHubCategoryNodeEdge = {
  __typename?: 'KnowledgeHubCategoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: KnowledgeHubCategoryNode;
};

export type KnowledgeHubCategoryQuery = {
  __typename?: 'KnowledgeHubCategoryQuery';
  get_category: KnowledgeHubCategoryNode;
  list_category: KnowledgeHubCategoryConnection;
};


export type KnowledgeHubCategoryQueryGet_CategoryArgs = {
  category_id: Scalars['ID']['input'];
};


export type KnowledgeHubCategoryQueryList_CategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: ListCategoryInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type KnowledgeHubCategoryRestrictionI = {
  description?: Maybe<Scalars['String']['output']>;
  has_attributes_restriction: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  restriction_detail?: Maybe<CategoryRestrictionDetailType>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type KnowledgeHubCategorySubCategoryNode = {
  __typename?: 'KnowledgeHubCategorySubCategoryNode';
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  sub_categories: Array<KnowledgeHubCategoryNode>;
  title: Scalars['String']['output'];
  total_courses?: Maybe<Scalars['Int']['output']>;
};

export type KnowledgeHubCategorySummaryI = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  total_content: Scalars['Int']['output'];
  total_visible_content: Scalars['Int']['output'];
};

export type KnowledgeHubCategoryType = {
  __typename?: 'KnowledgeHubCategoryType';
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  visibility_level?: Maybe<VisibilityLevelType>;
};

export type KnowledgeHubCategoryTypeI = {
  category_type_enum?: Maybe<CategoryTypeV2Enum>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type KnowledgeHubConfigMutation = {
  __typename?: 'KnowledgeHubConfigMutation';
  update_config: UpdateOrganizationConfigurationResponse;
};


export type KnowledgeHubConfigMutationUpdate_ConfigArgs = {
  input: UpdateOrganizationConfigInput;
};

export type KnowledgeHubConfigNode = {
  __typename?: 'KnowledgeHubConfigNode';
  access_level?: Maybe<Scalars['String']['output']>;
  config_admin_detail: ConfigAdminDetailNode;
  config_detail?: Maybe<ConfigDetailNode>;
  has_knowledge_hub: Scalars['Boolean']['output'];
};

export type KnowledgeHubConfigQuery = {
  __typename?: 'KnowledgeHubConfigQuery';
  /** This query is used to get if a organization has KH loaded */
  knowledge_hub_config: KnowledgeHubConfigNode;
};


export type KnowledgeHubConfigQueryKnowledge_Hub_ConfigArgs = {
  organization_id: Scalars['ID']['input'];
};

export type KnowledgeHubContentConnection = {
  __typename?: 'KnowledgeHubContentConnection';
  edges: Array<KnowledgeHubContentNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type KnowledgeHubContentDetailNode = {
  __typename?: 'KnowledgeHubContentDetailNode';
  content_image_url?: Maybe<Scalars['String']['output']>;
  content_url?: Maybe<Scalars['String']['output']>;
  content_value?: Maybe<Scalars['String']['output']>;
  course?: Maybe<KnowledgeHubCourseNode>;
  course_level?: Maybe<Level>;
  description: Scalars['String']['output'];
  document?: Maybe<KnowledgeHubDocumentNode>;
  duration: Scalars['Float']['output'];
  enrollment_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_enrolled?: Maybe<Scalars['Boolean']['output']>;
  modified_date?: Maybe<Scalars['DateTime']['output']>;
  modules: Array<CourseModule>;
  organization_id: Scalars['Int']['output'];
  professor_name: Scalars['String']['output'];
  related_categories?: Maybe<Array<KnowledgeHubCategoryNode>>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  total_modules?: Maybe<Scalars['Int']['output']>;
  track?: Maybe<KnowledgeHubOrganizationTeamNode>;
};

export type KnowledgeHubContentMutation = {
  __typename?: 'KnowledgeHubContentMutation';
  create_content_elevate_course: CreateOrUpdateContentResponse;
  multiple_assign_categories: MultipleUpdateActionsResponse;
  multiple_delete_content: MultipleUpdateActionsResponse;
  multiple_update_content_visibility: MultipleUpdateActionsResponse;
  update_content_by_course: CreateOrUpdateContentResponse;
};


export type KnowledgeHubContentMutationCreate_Content_Elevate_CourseArgs = {
  data: CreateContentByElevateCourse;
};


export type KnowledgeHubContentMutationMultiple_Assign_CategoriesArgs = {
  input: MultipleAssignCategories;
};


export type KnowledgeHubContentMutationMultiple_Delete_ContentArgs = {
  input: MultipleDeleteContent;
};


export type KnowledgeHubContentMutationMultiple_Update_Content_VisibilityArgs = {
  input: MultipleUpdateContentVisibility;
};


export type KnowledgeHubContentMutationUpdate_Content_By_CourseArgs = {
  input: UpdateContentByCourseInput;
};

export type KnowledgeHubContentNode = {
  __typename?: 'KnowledgeHubContentNode';
  absolute_url?: Maybe<Scalars['String']['output']>;
  approval_requirement?: Maybe<Scalars['String']['output']>;
  content_image_url?: Maybe<Scalars['String']['output']>;
  content_type: Scalars['String']['output'];
  content_type_enum?: Maybe<Scalars['String']['output']>;
  content_url?: Maybe<Scalars['String']['output']>;
  content_value?: Maybe<Scalars['String']['output']>;
  course?: Maybe<KnowledgeHubCourseNode>;
  course_config?: Maybe<CourseConfigType>;
  course_level?: Maybe<Level>;
  course_type?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  document?: Maybe<KnowledgeHubDocumentNode>;
  duration: Scalars['Float']['output'];
  enrollment_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_crehana_content?: Maybe<Scalars['Boolean']['output']>;
  is_enrolled?: Maybe<Scalars['Boolean']['output']>;
  is_new_content: Scalars['Boolean']['output'];
  modified_date?: Maybe<Scalars['DateTime']['output']>;
  organization_id: Scalars['Int']['output'];
  original_id: Scalars['String']['output'];
  professor_name?: Maybe<Scalars['String']['output']>;
  related_categories?: Maybe<Array<KnowledgeHubCategoryNode>>;
  score?: Maybe<Scalars['String']['output']>;
  score_value?: Maybe<Scalars['Float']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  total_attachments?: Maybe<Scalars['Int']['output']>;
  total_enrollments?: Maybe<Scalars['Int']['output']>;
  total_modules?: Maybe<Scalars['Int']['output']>;
  track?: Maybe<KnowledgeHubOrganizationTeamNode>;
  url?: Maybe<Scalars['String']['output']>;
  video_trailer?: Maybe<CourseVideoTrailerNode>;
  visibility_level?: Maybe<VisibilityLevelType>;
};

/** An edge in a connection. */
export type KnowledgeHubContentNodeEdge = {
  __typename?: 'KnowledgeHubContentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: KnowledgeHubContentNode;
};

export type KnowledgeHubContentOrderByInput = {
  direction: OrderDirectionEnum;
  field: ContentOrderByEnum;
};

export type KnowledgeHubContentRelatedCategoriesI = {
  related_categories?: Maybe<Array<KnowledgeHubAdminCategoryType>>;
};

export type KnowledgeHubContentRelatedTagsI = {
  related_tags?: Maybe<Array<TagType>>;
};

export type KnowledgeHubContentType = {
  __typename?: 'KnowledgeHubContentType';
  content_value?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  visibility_level?: Maybe<VisibilityLevelType>;
};

export type KnowledgeHubCourseNode = {
  __typename?: 'KnowledgeHubCourseNode';
  approval_requirement?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Scalars['Int']['output']>;
  background_color?: Maybe<Scalars['String']['output']>;
  category_id?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  course_level?: Maybe<Level>;
  course_type?: Maybe<Scalars['String']['output']>;
  course_type_enum?: Maybe<CourseTypeEnum>;
  created_date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  enrollments?: Maybe<Scalars['Int']['output']>;
  first_video_lecture_url?: Maybe<UrlNode>;
  has_certification_available?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  is_enrolled?: Maybe<Scalars['Boolean']['output']>;
  is_mandatory?: Maybe<Scalars['Boolean']['output']>;
  launch_date?: Maybe<Scalars['String']['output']>;
  level_id?: Maybe<Scalars['Int']['output']>;
  modified_date?: Maybe<Scalars['String']['output']>;
  modules: Array<CourseModule>;
  original_language?: Maybe<Scalars['String']['output']>;
  professor?: Maybe<ProfessorNode>;
  professor_id?: Maybe<Scalars['ID']['output']>;
  professor_name?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  promo_image?: Maybe<ImageNode>;
  publish_date?: Maybe<Scalars['String']['output']>;
  requirements?: Maybe<Array<CourseRequirementNode>>;
  score?: Maybe<Scalars['Float']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  subcategory_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_attachments_number: Scalars['Int']['output'];
  total_enrollments?: Maybe<Scalars['Int']['output']>;
  total_modules_number: Scalars['Int']['output'];
  trailer_source?: Maybe<CourseVideoTrailerNode>;
  type?: Maybe<Scalars['String']['output']>;
  type_course?: Maybe<Scalars['String']['output']>;
  video_trailer?: Maybe<CourseVideoTrailerNode>;
  videos?: Maybe<Scalars['String']['output']>;
  /** This field indicates the course's visibility to collaborators. A course can be active but hidden from collaborators while remaining visible to administrators */
  visibility_state?: Maybe<StudioCourseConfigStateEnum>;
};

export type KnowledgeHubDocumentMutation = {
  __typename?: 'KnowledgeHubDocumentMutation';
  admin_create_documents: CreateDocumentResponse;
  admin_update_content_document: UpdateContentResponse;
};


export type KnowledgeHubDocumentMutationAdmin_Create_DocumentsArgs = {
  input: CreateOrganizationDocumentInput;
};


export type KnowledgeHubDocumentMutationAdmin_Update_Content_DocumentArgs = {
  input: UpdateContentInput;
};

export type KnowledgeHubDocumentNode = {
  __typename?: 'KnowledgeHubDocumentNode';
  action?: Maybe<DocumentActionEnum>;
  created_at?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  document_file?: Maybe<File>;
  extension?: Maybe<Scalars['String']['output']>;
  file_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['ID']['output'];
  size?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type KnowledgeHubFiltersNode = {
  __typename?: 'KnowledgeHubFiltersNode';
  category: Array<KnowledgeHubCategorySubCategoryNode>;
  content_types?: Maybe<Array<ContentTypeNode>>;
  document_actions?: Maybe<Array<DocumentActionNode>>;
  document_extensions?: Maybe<Array<DocumentExtensionNode>>;
  languages: Array<LanguageNode>;
  levels?: Maybe<Array<Level>>;
  visibility_levels?: Maybe<Array<ContentVisibilityNode>>;
};

export type KnowledgeHubNode = {
  __typename?: 'KnowledgeHubNode';
  base_category: KnowledgeHubCategoryNode;
  contents: KnowledgeHubContentConnection;
  sub_categories: Array<KnowledgeHubCategoryNode>;
};


export type KnowledgeHubNodeContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type KnowledgeHubNodeSub_CategoriesArgs = {
  order_by?: InputMaybe<Array<CategoryInputOrderBy>>;
};

export type KnowledgeHubOrganizationTeamNode = {
  __typename?: 'KnowledgeHubOrganizationTeamNode';
  certificate_name?: Maybe<Scalars['String']['output']>;
  content_duration?: Maybe<Scalars['Int']['output']>;
  courses_to_certificate?: Maybe<Scalars['Int']['output']>;
  courses_to_complete?: Maybe<Scalars['Int']['output']>;
  cover_image_id?: Maybe<Scalars['Int']['output']>;
  cover_image_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiration_time?: Maybe<Scalars['String']['output']>;
  generate_certificate?: Maybe<Scalars['Boolean']['output']>;
  has_reward?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_active_course_dependence?: Maybe<Scalars['Boolean']['output']>;
  is_draft?: Maybe<Scalars['Boolean']['output']>;
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id: Scalars['Int']['output'];
  organization_team_courses: Array<ContentOrganizationTeamCourseNode>;
  track_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type KnowledgeHubQuery = {
  __typename?: 'KnowledgeHubQuery';
  /** This query is used to get all content for catalog page */
  knowledge_hub_catalog: Array<KnowledgeHubNode>;
  knowledge_hub_content_by_category: KnowledgeHubContentConnection;
  knowledge_hub_content_by_collaborator?: Maybe<KnowledgeHubContentConnection>;
  knowledge_hub_content_by_course: KnowledgeHubContentNode;
  knowledge_hub_content_by_courses: KnowledgeHubContentConnection;
  knowledge_hub_content_detail: KnowledgeHubContentDetailNode;
  knowledge_hub_filters: KnowledgeHubFiltersNode;
  knowledge_hub_search: KnowledgeHubContentConnection;
};


export type KnowledgeHubQueryKnowledge_Hub_CatalogArgs = {
  content_type?: InputMaybe<ContentType>;
  languages?: InputMaybe<Array<ContentLanguages>>;
  level_id?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
  parent_slug?: InputMaybe<Scalars['String']['input']>;
};


export type KnowledgeHubQueryKnowledge_Hub_Content_By_CategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type KnowledgeHubQueryKnowledge_Hub_Content_By_CollaboratorArgs = {
  input: KnowledgehubContentByCollaboratorInput;
};


export type KnowledgeHubQueryKnowledge_Hub_Content_By_CourseArgs = {
  course_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
};


export type KnowledgeHubQueryKnowledge_Hub_Content_By_CoursesArgs = {
  course_ids: Array<Scalars['ID']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type KnowledgeHubQueryKnowledge_Hub_Content_DetailArgs = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  content_slug?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type KnowledgeHubQueryKnowledge_Hub_FiltersArgs = {
  main_category_slug: Scalars['String']['input'];
  organization_id: Scalars['ID']['input'];
};


export type KnowledgeHubQueryKnowledge_Hub_SearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
  search_input: Scalars['String']['input'];
};

export type KnowledgeHubV2AdminQuery = {
  __typename?: 'KnowledgeHubV2AdminQuery';
  get_admin_categories: AdminCategoriesPageNumberPagination;
  get_admin_content_by_category: AdminContentsCursorPagination;
  get_admin_content_by_tags: AdminContentsCursorPagination;
  get_admin_filters: KnowledgeHubAdminFiltersFragment;
  /** Get track detail for admin panel using KnowledgeHub v2 data sources */
  get_admin_track_detail: AdminTrackDetailType;
  get_category?: Maybe<KnowledgeHubAdminCategoryType>;
  get_content_document_list: AdminContentsPagePagination;
  get_content_resume: ContentStatisticsNode;
  get_education_course_content_list_by_admin: AdminContentsPagePagination;
  get_organization_course_content_by_content_value: KnowledgeHubAdminContentCourseType;
  get_tag_list: AdminTagsPagePagination;
  get_tags_by_content_value: Array<TagType>;
};


export type KnowledgeHubV2AdminQueryGet_Admin_CategoriesArgs = {
  input: AdminListCategoryInput;
};


export type KnowledgeHubV2AdminQueryGet_Admin_Content_By_CategoryArgs = {
  input: AdminListContentByCategoryInput;
};


export type KnowledgeHubV2AdminQueryGet_Admin_Content_By_TagsArgs = {
  input: AdminListContentByTagsInput;
};


export type KnowledgeHubV2AdminQueryGet_Admin_FiltersArgs = {
  input: AdminFiltersInput;
};


export type KnowledgeHubV2AdminQueryGet_Admin_Track_DetailArgs = {
  input: AdminGetTrackDetailInput;
};


export type KnowledgeHubV2AdminQueryGet_CategoryArgs = {
  input: AdminGetCategoryDetailInput;
};


export type KnowledgeHubV2AdminQueryGet_Content_Document_ListArgs = {
  input: AdminListContentDocumentsInput;
};


export type KnowledgeHubV2AdminQueryGet_Content_ResumeArgs = {
  input: AdminGetCatalogResumeInput;
};


export type KnowledgeHubV2AdminQueryGet_Education_Course_Content_List_By_AdminArgs = {
  input: AdminGetEducationCourseContentListInput;
};


export type KnowledgeHubV2AdminQueryGet_Organization_Course_Content_By_Content_ValueArgs = {
  input: AdminGetOrganizationContent;
};


export type KnowledgeHubV2AdminQueryGet_Tag_ListArgs = {
  input: AdminListTagsInput;
};


export type KnowledgeHubV2AdminQueryGet_Tags_By_Content_ValueArgs = {
  input: AdminGetTagsByContentValueInput;
};

export type KnowledgeHubV2CollaboratorQuery = {
  __typename?: 'KnowledgeHubV2CollaboratorQuery';
  /** Resumen del catálogo para colaborador por origen (own, crehana, third_party). */
  get_collaborator_catalog_summary?: Maybe<Array<CatalogNodeType>>;
  /** Lista categorías (y subcategorías si corresponde) para un owner_type en la organización. */
  get_collaborator_categories?: Maybe<Array<CollaboratorCatalogCategoryType>>;
  /** Contenido paginado por categoría. Sin parent_slug ni search_input: 3 raíces. search_input: búsqueda por título (exclusivo con parent_slug). */
  get_collaborator_content_by_category?: Maybe<Array<CollaboratorContentByCategoryNode>>;
  /** Detalle de un contenido (estructura v1, datos desde Knowledge Hub v2). OWN se filtra por organization_id de la petición; CREHANA y THIRD_PARTY son contenido global (sin organization_id en fila), el organization_id solo acota el contexto de org del colaborador para OWN. */
  get_collaborator_content_detail?: Maybe<ContentDetailV2Node>;
  /** Filtros disponibles para la categoría (árbol de subcategorías, levels, content_types, languages). */
  get_collaborator_filters: CollaboratorFiltersNode;
};


export type KnowledgeHubV2CollaboratorQueryGet_Collaborator_Catalog_SummaryArgs = {
  input: CollaboratorGetCatalogInput;
};


export type KnowledgeHubV2CollaboratorQueryGet_Collaborator_CategoriesArgs = {
  input: CollaboratorGetCategoriesInput;
};


export type KnowledgeHubV2CollaboratorQueryGet_Collaborator_Content_By_CategoryArgs = {
  input: CollaboratorGetContentByCategoryInput;
};


export type KnowledgeHubV2CollaboratorQueryGet_Collaborator_Content_DetailArgs = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  content_slug?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['ID']['input'];
};


export type KnowledgeHubV2CollaboratorQueryGet_Collaborator_FiltersArgs = {
  input: CollaboratorGetFiltersInput;
};

export type KnowledgeHubVisibilityLevelI = {
  visibility_level?: Maybe<VisibilityLevelType>;
};

export type KnowledgehubContentByCollaboratorInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content_types?: InputMaybe<Array<ContentType>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  is_new_content?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ContentInputOrderBy>>;
};

/** Type of KPI card to retrieve. */
export enum KpiTypeEnum {
  ActiveCollaborators = 'ACTIVE_COLLABORATORS',
  HeadcountGrowth = 'HEADCOUNT_GROWTH',
  LoginPercentage = 'LOGIN_PERCENTAGE'
}

export type LabelModule = {
  __typename?: 'LabelModule';
  label?: Maybe<Scalars['String']['output']>;
};

export type LabelTalentResponse = {
  __typename?: 'LabelTalentResponse';
  labels?: Maybe<Array<Maybe<LabelTalentType>>>;
};

export type LabelTalentType = {
  __typename?: 'LabelTalentType';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  module: Scalars['String']['output'];
};

/** Régimen laboral (SAT c_TipoRegimen). */
export enum LaborRegimeEnum {
  Asimilados = 'ASIMILADOS',
  Jubilados = 'JUBILADOS',
  OtrosIngresos = 'OTROS_INGRESOS',
  Pensionados = 'PENSIONADOS',
  SueldosSalarios = 'SUELDOS_SALARIOS'
}

export type LangNode = {
  __typename?: 'LangNode';
  en: Scalars['String']['output'];
  es: Scalars['String']['output'];
  pt: Scalars['String']['output'];
};

/**  Idiomas disponibles en Talent  */
export enum LanguageEnum {
  En = 'EN',
  Es = 'ES',
  Pt = 'PT'
}

export type LanguageNode = {
  __typename?: 'LanguageNode';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type LeaderDashboardActivityIndicatorsType = {
  __typename?: 'LeaderDashboardActivityIndicatorsType';
  created: Scalars['Int']['output'];
  evaluated: Scalars['Int']['output'];
  in_progress: Scalars['Int']['output'];
  not_initiated: Scalars['Int']['output'];
  to_approve: Scalars['Int']['output'];
};

export type LeaderDashboardIndicatorsType = {
  __typename?: 'LeaderDashboardIndicatorsType';
  total_users: Scalars['Int']['output'];
  with_activitities_to_approve: Scalars['Int']['output'];
  with_activitities_to_follow: Scalars['Int']['output'];
  without_activities: Scalars['Int']['output'];
};

export type LeaderDashboardPoints = {
  __typename?: 'LeaderDashboardPoints';
  total_points_team?: Maybe<Scalars['Int']['output']>;
};

export type LeaderMetricsQuery = {
  __typename?: 'LeaderMetricsQuery';
  users_work_team_statistic: UserWorkTeamStatisticNodeConnection;
};


export type LeaderMetricsQueryUsers_Work_Team_StatisticArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search_key?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  sort_by_progress?: InputMaybe<Scalars['Boolean']['input']>;
  work_team_id: Scalars['String']['input'];
};

export type LeaderQuery = {
  __typename?: 'LeaderQuery';
  activities_points?: Maybe<PidLeaderDashboardPointsResponse>;
  dip_employee_activities_on_track?: Maybe<Array<Scalars['Int']['output']>>;
  talent_pid_average_team_evaluation_data: PidAverageTeamEvaluationDataResponse;
  talent_pid_boss_tracks_report: PidBossTracksReportResponse;
  talent_pid_leader_dashboard_activities_data: PidLeaderDashboardActivitiesDataResponse;
  talent_pid_leader_dashboard_activity_indicators: PidLeaderDashboardActivityIndicatorsResponse;
  talent_pid_leader_dashboard_indicators: PidLeaderDashboardIndicatorsResponse;
  talent_pid_leader_dashboard_users_data: PidLeaderDashboardUsersDataResponse;
  talent_pid_lower_autoevaluation_users_data: PidLowerAutoevaluationUsersDataResponse;
};


export type LeaderQueryActivities_PointsArgs = {
  input: PidProcessDetailInput;
};


export type LeaderQueryDip_Employee_Activities_On_TrackArgs = {
  input: PidProcessDetailInput;
};


export type LeaderQueryTalent_Pid_Average_Team_Evaluation_DataArgs = {
  input: PidAverageTeamEvaluationDataInput;
};


export type LeaderQueryTalent_Pid_Boss_Tracks_ReportArgs = {
  input: PidBossTracksReportInput;
};


export type LeaderQueryTalent_Pid_Leader_Dashboard_Activities_DataArgs = {
  input: PidLeaderDashboardActivitiesDataInput;
};


export type LeaderQueryTalent_Pid_Leader_Dashboard_Activity_IndicatorsArgs = {
  input: PidLeaderDashboardActivityIndicatorsInput;
};


export type LeaderQueryTalent_Pid_Leader_Dashboard_IndicatorsArgs = {
  input: PidLeaderDashboardIndicatorsInput;
};


export type LeaderQueryTalent_Pid_Leader_Dashboard_Users_DataArgs = {
  input: PidLeaderDashboardUsersDataInput;
};


export type LeaderQueryTalent_Pid_Lower_Autoevaluation_Users_DataArgs = {
  input: PidLowerAutoevaluationUsersDataInput;
};

/** Which collaborators each leader reports on («Alcance del equipo») */
export enum LeaderScopeType {
  DirectTeam = 'DIRECT_TEAM',
  SpecificAreas = 'SPECIFIC_AREAS',
  WholeOrganization = 'WHOLE_ORGANIZATION'
}

export type LeaderUsersEnrollmentsMetadataType = {
  __typename?: 'LeaderUsersEnrollmentsMetadataType';
  total_count?: Maybe<Scalars['Int']['output']>;
  total_user_ids: Array<Scalars['Int']['output']>;
};

export type LeaderUsersEnrollmentsPageNumberPagination = {
  __typename?: 'LeaderUsersEnrollmentsPageNumberPagination';
  edges: Array<TeamUserEnrollmentTypePaginationEdge>;
  metadata?: Maybe<LeaderUsersEnrollmentsMetadataType>;
  /** Information to aid in pagination. */
  page_info: NumberPageInfo;
  page_size?: Maybe<Scalars['Int']['output']>;
};

export type Leaderboard = {
  __typename?: 'Leaderboard';
  /** This resource is responsible for providing the admin with a summary of the most popular achievement and event, along with the most requested reward by platform users. */
  leaderboard_boxes: LeaderboardFragmentNode;
  /** Leaderboard is a resource that presents a ranking system based on user performance and achievements. It offers a comprehensive overview of user rankings in a specific context, such as a game, competition, or any other measurable criteria. The leaderboard resource caters to standard users, admin users, and staff users, providing them with valuable insights and fostering healthy competition. */
  user_summary: UserSummaryFragmentConnection;
};


export type LeaderboardLeaderboard_BoxesArgs = {
  query_variables: CurrencyEventQueryInput;
};


export type LeaderboardUser_SummaryArgs = {
  query_variables: UserEventBankQueryInput;
};

export type LeaderboardFragmentNode = AdminLeaderboardFragmentNode | ResponseValidationError;

export type LeaderboardMetadata = {
  __typename?: 'LeaderboardMetadata';
  total_count: Scalars['Int']['output'];
  total_filtered: Scalars['Int']['output'];
  total_users_with_points: Scalars['Int']['output'];
  total_users_without_points: Scalars['Int']['output'];
};

/** Node that contains the 3 tabs initially arranged for the leaderboard */
export type LeaderboardNode = {
  __typename?: 'LeaderboardNode';
  tab_data_and_monitoring: TabDataAndMonitoringNode;
  tab_redemptions: TabRedemptionNode;
  tab_rewards: TabRewardNode;
};

export type LeaderboardPlayer = AllowedUserInterface & {
  __typename?: 'LeaderboardPlayer';
  achievements: Array<AllowedUserAchievement>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  stats: AllowedUserStats;
  tags: UserTagsType;
  user: UserInfoType;
};

export type LeaderboardPlayerLeaderboardMetadataGamificationPageNumConnectionGenerator = {
  __typename?: 'LeaderboardPlayerLeaderboardMetadataGamificationPageNumConnectionGenerator';
  /** A list of edges in this connection. */
  edges: Array<LeaderboardPlayerLeaderboardMetadataGamificationPaginationEdge>;
  metadata?: Maybe<LeaderboardMetadata>;
  /** Information to aid in pagination. */
  page_info: GamificationNumPageInfo;
};

export type LeaderboardPlayerLeaderboardMetadataGamificationPaginationEdge = {
  __typename?: 'LeaderboardPlayerLeaderboardMetadataGamificationPaginationEdge';
  /** The item at the end of the edge. */
  node: LeaderboardPlayer;
};

export type LeaderboardReportFragment = ReportLeaderboardResponse | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type LeaderboardReportInput = {
  organization_id: Scalars['ID']['input'];
};

export type LearningCustomField = {
  __typename?: 'LearningCustomField';
  data_type: DataTypeEnum;
  description?: Maybe<Scalars['String']['output']>;
  field_id: Scalars['String']['output'];
  field_name: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
  most_used: Array<MostUsedOptionAnswer>;
  options_answers?: Maybe<Array<Scalars['String']['output']>>;
};

export type LearningCustomFieldFilterGroup = {
  __typename?: 'LearningCustomFieldFilterGroup';
  filter_type: DashboardFilterEnum;
  group_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  rules: Array<LearningCustomFieldFilterRule>;
};

/** A connection to a list of items. */
export type LearningCustomFieldFilterGroupConnection = {
  __typename?: 'LearningCustomFieldFilterGroupConnection';
  /** Contains the nodes in this connection */
  edges: Array<LearningCustomFieldFilterGroupEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type LearningCustomFieldFilterGroupCreateInput = {
  filter_type?: InputMaybe<DashboardFilterEnum>;
  group_name: Scalars['String']['input'];
  org_id: Scalars['Int']['input'];
  rules: Array<CustomFieldFilterInput>;
  user_id: Scalars['Int']['input'];
};

/** An edge in a connection. */
export type LearningCustomFieldFilterGroupEdge = {
  __typename?: 'LearningCustomFieldFilterGroupEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: LearningCustomFieldFilterGroup;
};

export type LearningCustomFieldFilterGroupUpdateInput = {
  group_id: Scalars['Int']['input'];
  group_name?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<Array<CustomFieldFilterInput>>;
};

export type LearningCustomFieldFilterRule = {
  __typename?: 'LearningCustomFieldFilterRule';
  data_type: DataTypeEnum;
  field_id: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type LearningCustomFieldNode = {
  __typename?: 'LearningCustomFieldNode';
  can_delete: Scalars['Boolean']['output'];
  can_edit: Scalars['Boolean']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by_user_id: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_default: Scalars['Boolean']['output'];
  is_hidden: Scalars['Boolean']['output'];
  max_length?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  organization_id: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by_user_id?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type LearningCustomFieldNodeEdge = {
  __typename?: 'LearningCustomFieldNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: LearningCustomFieldNode;
};

export type LearningCustomFieldOptionNode = {
  __typename?: 'LearningCustomFieldOptionNode';
  custom_field_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type LearningCustomFieldWithOptions = {
  __typename?: 'LearningCustomFieldWithOptions';
  data_type: DataTypeEnum;
  description: Scalars['String']['output'];
  field_id: Scalars['String']['output'];
  field_name: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
  options_answer?: Maybe<Array<OptionAnswer>>;
};

export type LearningInfo = {
  __typename?: 'LearningInfo';
  course_slug?: Maybe<Scalars['String']['output']>;
  id_course: Scalars['Int']['output'];
  id_route: Scalars['Int']['output'];
  image: PidActivityImage;
  progress?: Maybe<Scalars['Int']['output']>;
};

export type LearningPathInfo = {
  __typename?: 'LearningPathInfo';
  id: Scalars['ID']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  users_pending_path?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type LearningPathInfoConnection = {
  __typename?: 'LearningPathInfoConnection';
  /** Contains the nodes in this connection */
  edges: Array<LearningPathInfoEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type LearningPathInfoEdge = {
  __typename?: 'LearningPathInfoEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: LearningPathInfo;
};

export type LearningPathResponse = FoundationLeaderIntegrityError | FoundationLeaderInternalError | FoundationLeaderValidationError | LearningPathInfoConnection;

export type LearningSession = {
  __typename?: 'LearningSession';
  organization_id?: Maybe<Scalars['String']['output']>;
  organization_slug?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  user_organization_id?: Maybe<Scalars['String']['output']>;
  user_organization_role?: Maybe<Scalars['String']['output']>;
};

export type LearningUser = {
  __typename?: 'LearningUser';
  custom_fields: Array<LearningUserCustomField>;
  email: Scalars['String']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type LearningUserCustomField = {
  __typename?: 'LearningUserCustomField';
  field_answer: Scalars['String']['output'];
  field_name: Scalars['String']['output'];
};

export type LearningUserOrganization = {
  __typename?: 'LearningUserOrganization';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  organization_id: Scalars['ID']['output'];
  role: LearningUserOrganizationRole;
  status: LearningUserOrganizationStatus;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user: LearningUser;
};

export type LearningUserOrganizationConnection = {
  __typename?: 'LearningUserOrganizationConnection';
  /** A list of edges in this connection. */
  edges: Array<LearningUserOrganizationEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type LearningUserOrganizationConnectionQueryValidationErrorQueryInternalError = LearningUserOrganizationConnection | QueryInternalError | QueryValidationError;

export type LearningUserOrganizationEdge = {
  __typename?: 'LearningUserOrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LearningUserOrganization;
};

export enum LearningUserOrganizationRole {
  UserOrganizationHighEducationMember = 'USER_ORGANIZATION_HIGH_EDUCATION_MEMBER',
  UserOrganizationRoleAdmin = 'USER_ORGANIZATION_ROLE_ADMIN',
  UserOrganizationRoleMember = 'USER_ORGANIZATION_ROLE_MEMBER',
  UserOrganizationRoleOwner = 'USER_ORGANIZATION_ROLE_OWNER'
}

export enum LearningUserOrganizationStatus {
  UserOrganizationStatusActive = 'USER_ORGANIZATION_STATUS_ACTIVE',
  UserOrganizationStatusDeactivated = 'USER_ORGANIZATION_STATUS_DEACTIVATED',
  UserOrganizationStatusDeleted = 'USER_ORGANIZATION_STATUS_DELETED',
  UserOrganizationStatusPending = 'USER_ORGANIZATION_STATUS_PENDING'
}

export type LegalEntitiesMutations = {
  __typename?: 'LegalEntitiesMutations';
  /** Crear una razón social. */
  create_legal_entity: CreateLegalEntityResponse;
  /** Crear un régimen fiscal. */
  create_tax_regime: CreateTaxRegimeResponse;
  /** Eliminar (desactivar) una razón social. */
  delete_legal_entity: DeleteLegalEntityResponse;
  /** Actualizar una razón social. */
  update_legal_entity: UpdateLegalEntityResponse;
  /** Actualizar un régimen fiscal. */
  update_tax_regime: UpdateTaxRegimeResponse;
};


export type LegalEntitiesMutationsCreate_Legal_EntityArgs = {
  input: CentralizedCreateLegalEntityInput;
};


export type LegalEntitiesMutationsCreate_Tax_RegimeArgs = {
  input: CentralizedCreateTaxRegimeInput;
};


export type LegalEntitiesMutationsDelete_Legal_EntityArgs = {
  input: CentralizedDeleteLegalEntityInput;
};


export type LegalEntitiesMutationsUpdate_Legal_EntityArgs = {
  input: CentralizedUpdateLegalEntityInput;
};


export type LegalEntitiesMutationsUpdate_Tax_RegimeArgs = {
  input: CentralizedUpdateTaxRegimeInput;
};

export type LegalEntitiesQueries = {
  __typename?: 'LegalEntitiesQueries';
  /** Listar razones sociales (filtros + paginación). */
  get_legal_entities: GetLegalEntitiesResponse;
  /** Obtener una razón social por ID. */
  get_legal_entity: GetLegalEntityResponse;
  /** Obtener un régimen fiscal por ID. */
  get_tax_regime: GetTaxRegimeResponse;
  /** Listar regímenes fiscales (filtro por código). */
  get_tax_regimes: GetTaxRegimesResponse;
  /** Validar disponibilidad de internal_id. */
  validate_internal_id: ValidateFieldResponse;
  /** Validar disponibilidad de legal_name. */
  validate_legal_name: ValidateFieldResponse;
  /** Validar tax_id (global; valida RFC si country_code es MX). */
  validate_tax_id: ValidateFieldResponse;
};


export type LegalEntitiesQueriesGet_Legal_EntitiesArgs = {
  input: CentralizedListLegalEntitiesInput;
};


export type LegalEntitiesQueriesGet_Legal_EntityArgs = {
  input: CentralizedGetLegalEntityInput;
};


export type LegalEntitiesQueriesGet_Tax_RegimeArgs = {
  input: CentralizedGetTaxRegimeInput;
};


export type LegalEntitiesQueriesGet_Tax_RegimesArgs = {
  input: CentralizedListTaxRegimesInput;
};


export type LegalEntitiesQueriesValidate_Internal_IdArgs = {
  input: ValidateInternalIdInput;
};


export type LegalEntitiesQueriesValidate_Legal_NameArgs = {
  input: ValidateLegalNameInput;
};


export type LegalEntitiesQueriesValidate_Tax_IdArgs = {
  input: ValidateTaxIdInput;
};

export type LegalEntityListResponse = {
  __typename?: 'LegalEntityListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<LegalEntityType>;
  total_count: Scalars['Int']['output'];
};

export type LegalEntityResponse = {
  __typename?: 'LegalEntityResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: LegalEntityType;
};

export type LegalEntityType = {
  __typename?: 'LegalEntityType';
  address_1: Scalars['String']['output'];
  address_2?: Maybe<Scalars['String']['output']>;
  address_3?: Maybe<Scalars['String']['output']>;
  /** Bank associated with this legal entity. */
  bank?: Maybe<BankType>;
  bank_id?: Maybe<Scalars['ID']['output']>;
  centralized_organization_id: Scalars['ID']['output'];
  city: Scalars['String']['output'];
  clabe_account?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  country_code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  currency_code: Scalars['String']['output'];
  fiscal_address_override?: Maybe<Scalars['String']['output']>;
  fiscal_contact_email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internal_id: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Decimal']['output']>;
  legal_name: Scalars['String']['output'];
  legal_representatives?: Maybe<Array<LegalRepresentativeType>>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  postal_code: Scalars['String']['output'];
  repse_number?: Maybe<Scalars['String']['output']>;
  social_object?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tax_id: Scalars['String']['output'];
  /** Tax regime associated with this legal entity. */
  tax_regime?: Maybe<TaxRegimeType>;
  tax_regime_id?: Maybe<Scalars['ID']['output']>;
  tax_type?: Maybe<Scalars['String']['output']>;
  trade_name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  /** Number of work centers of this legal entity. Counts DISTINCT headquarters reached through its ACTIVE employer registrations (is_active = true), so a physical place linked by two employer registrations counts once, and an employer registration whose risk data has expired ('vencido') still counts — the place operates, only a fiscal date lapsed. `0` and `null` mean different things: `0` is a verified fact (the legal entity has no work centers loaded) and is what lets a client omit the subtitle; `null` means the count could not be computed. Prefetched for the whole page in a single aggregation by get_legal_entities; on every other path it costs one query, and only when selected. Note it counts headquarters, not work_location links, so it is not the number of work_center_ids a contract can reference. */
  work_centers_count?: Maybe<Scalars['Int']['output']>;
};

export type LegalRepresentativeListResponse = {
  __typename?: 'LegalRepresentativeListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<LegalRepresentativeType>;
};

export type LegalRepresentativeResponse = {
  __typename?: 'LegalRepresentativeResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: LegalRepresentativeType;
};

export type LegalRepresentativeType = {
  __typename?: 'LegalRepresentativeType';
  centralized_organization_id: Scalars['ID']['output'];
  centralized_user_id?: Maybe<Scalars['ID']['output']>;
  civil_registry_id?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  faculties: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legal_entity_id: Scalars['ID']['output'];
  representative_name: Scalars['String']['output'];
  representative_type: Scalars['String']['output'];
  tax_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type Level = {
  __typename?: 'Level';
  created_date: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type LevelTalent = {
  __typename?: 'LevelTalent';
  id?: Maybe<Scalars['ID']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  original_id?: Maybe<Scalars['Int']['output']>;
};

export type LevelTalentListType = {
  __typename?: 'LevelTalentListType';
  levels?: Maybe<Array<Maybe<LevelTalent>>>;
};

export type LevelTalentType = {
  __typename?: 'LevelTalentType';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LevelType = {
  __typename?: 'LevelType';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type LicenseQueries = {
  __typename?: 'LicenseQueries';
  /** Get children companies licenses. */
  get_children_org_licenses: GetCorporationChildrenOrgLicensesNodeIntegrityErrorResponseInternalErrorResponseValidationErrorResponseNotFoundResponseNotAuthenticatedErrorResponse;
  /** Get a license by its ID. */
  get_licenses_distribution: GetLicensesDistributionPayloadIntegrityErrorResponseInternalErrorResponseValidationErrorResponseNotFoundResponseNotAuthenticatedErrorResponse;
};


export type LicenseQueriesGet_Children_Org_LicensesArgs = {
  input: GetChildrenCompaniesLicensesInput;
};


export type LicenseQueriesGet_Licenses_DistributionArgs = {
  input: GetLicensesDistributionInput;
};

/** Licenses Enterprise relation Node */
export type LicensesEnterpriseNode = {
  __typename?: 'LicensesEnterpriseNode';
  /** Enterprise ID */
  enterprise_id: Scalars['Int']['output'];
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Original ID */
  original_id: Scalars['Int']['output'];
  /** Total number of licenses available */
  total_licenses: Scalars['Int']['output'];
  /** Number of licenses currently in use */
  used_licenses: Scalars['Int']['output'];
};

/** Licenses */
export type LicensesNode = {
  __typename?: 'LicensesNode';
  /** Number of licenses availables */
  available_licenses: Scalars['Int']['output'];
  /** License expiration date */
  end_date?: Maybe<Scalars['DateTime']['output']>;
  /** Total number of licenses purchased */
  licenses_purchased: Scalars['Int']['output'];
  /** License activation date */
  start_date?: Maybe<Scalars['DateTime']['output']>;
  /** Number of licenses currently in use */
  used_licenses: Scalars['Int']['output'];
};

export type LinkI = {
  absolute_url?: Maybe<Scalars['String']['output']>;
  relative_url?: Maybe<Scalars['String']['output']>;
};

export type LinkedDataToCreate = {
  __typename?: 'LinkedDataToCreate';
  families: Array<Scalars['String']['output']>;
  levels: Array<Scalars['String']['output']>;
};

export type ListBanksInput = {
  bank_code?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Filters for the basic user organizations list. */
export type ListBasicUserOrganizationsFilters = {
  /** Exact-match filter on UserOrganization.document. */
  document?: InputMaybe<Scalars['String']['input']>;
};

/** Lightweight pagination input for listing user organizations with only basic user info and learning_user_id. */
export type ListBasicUserOrganizationsInput = {
  /** Opaque cursor returned by a previous page (forward pagination). */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Organization ID whose user organizations will be listed. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional structured filters. */
  filters?: InputMaybe<ListBasicUserOrganizationsFilters>;
  /** Number of items to return (forward pagination). Max 100. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Optional case-insensitive substring search on firstname, lastname or email. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ListCategoryInput = {
  category_type?: InputMaybe<CategoryType>;
  custom_field_option_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  has_restrictions?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  visibility_level?: InputMaybe<VisibilityLevelType>;
};

export type ListContractHistoryInput = {
  centralized_user_id: Scalars['Int']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
};

export type ListContractHistoryResponse = {
  __typename?: 'ListContractHistoryResponse';
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<ContractHistoryEntry>;
  total_count: Scalars['Int']['output'];
};

export type ListContractHistoryResult = InternalErrorResponse | ListContractHistoryResponse | UserPermissionErrorResponse;

export type ListContractVersionsInput = {
  centralized_user_id: Scalars['Int']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ListContractVersionsResponse = {
  __typename?: 'ListContractVersionsResponse';
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<EmployeeContractType>;
  total_count: Scalars['Int']['output'];
};

export type ListContractVersionsResult = InternalErrorResponse | ListContractVersionsResponse | UserPermissionErrorResponse;

/** The three ids are all required. The pair (centralized_user_id, legal_entity_id) is what scopes the read, the same way `list_government_credits` does: with only the credit uuid this query would return any worker's payment history to any organization admin. */
export type ListCreditInstallmentPaymentsInput = {
  centralized_user_id: Scalars['ID']['input'];
  government_credit_id: Scalars['ID']['input'];
  legal_entity_id: Scalars['ID']['input'];
};

export type ListCreditInstallmentPaymentsResult = CreditInstallmentPaymentListResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse;

export type ListDispersionAccountsInput = {
  /** Filtro opcional por tipo de cuenta. */
  account_type?: InputMaybe<Scalars['String']['input']>;
  /** Filtro opcional por banco. */
  bank_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID de la organización centralizada (owner). */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtro opcional por estado activo. */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID de la razón social cuyas cuentas se listan. */
  legal_entity_id: Scalars['ID']['input'];
  /** Máximo de resultados a retornar. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Cantidad de registros a omitir (paginación). */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Búsqueda parcial, sin distinguir mayúsculas, sobre número de cuenta o CLABE. Una cadena vacía o de espacios no filtra. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ListEmployeeDependentsInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
};

export type ListEmployeeDependentsResult = EmployeeDependentListResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type ListEmployeePensionsInput = {
  centralized_user_id: Scalars['ID']['input'];
  legal_entity_id: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ListEmployeePensionsResult = EmployeePensionListResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse;

export type ListEmployerRegistrationsInput = {
  centralized_organization_id: Scalars['ID']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  legal_entity_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  registration_number?: InputMaybe<Scalars['String']['input']>;
  risk_class_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ListFederalEntitiesInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ListGovernmentCreditsInput = {
  centralized_user_id: Scalars['ID']['input'];
  legal_entity_id: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ListGovernmentCreditsResult = GovernmentCreditListResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse;

export type ListImssDelegationsInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ListImssMovementsInput = {
  legal_entity_id: Scalars['UUID']['input'];
  movement_type?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  period_id?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ListImssMovementsResponse = {
  __typename?: 'ListImssMovementsResponse';
  counts_by_type: CountsByType;
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<ImssMovementItem>;
  total_count: Scalars['Int']['output'];
};

export type ListImssMovementsResult = InternalErrorResponse | ListImssMovementsResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type ListImssSubdelegationsInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  delegation_id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ListLegalEntitiesInput = {
  centralized_organization_id: Scalars['ID']['input'];
  country_code?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort_by?: InputMaybe<Scalars['String']['input']>;
  sort_direction?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  tax_type?: InputMaybe<Scalars['String']['input']>;
};

export type ListLegalRepresentativesInput = {
  centralized_organization_id: Scalars['ID']['input'];
  legal_entity_id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  representative_type?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ListMassiveDocumentUploadsInput = {
  organization_id: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  page_size?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ListOAuthClientsInput = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

export type ListPayrollIncidencesResponse = {
  __typename?: 'ListPayrollIncidencesResponse';
  counts_by_status: CountsByStatus;
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<PayrollIncidenceListItem>;
  total_count: Scalars['Int']['output'];
};

export type ListPayrollIncidencesResult = InternalErrorResponse | ListPayrollIncidencesResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type ListRiskClassesInput = {
  class_code?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ListSalaryZonesInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ListTaxRegimesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  tax_regime_code?: InputMaybe<Scalars['String']['input']>;
  tax_type?: InputMaybe<Scalars['String']['input']>;
};

/** Input para listar usuarios con restricciones de sedes activas. */
export type ListUsersWithManagedHeadquartersInput = {
  /** Cursor opaco devuelto por una página previa. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** ID de la organización que scopea el listado (requerido). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Cantidad de items a devolver (paginación hacia adelante). Máx. 100. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Filtro por sede(s), semántica OR: usuarios que gestionan CUALQUIERA de las sedes indicadas. None/vacío = todas. */
  headquarter_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Ordenamiento: A-Z / Z-A ordena por nombre; 'Created At' ordena por última modificación (desc) y 'Created At Asc' por última modificación (asc). None = última modificación (desc). */
  order_by?: InputMaybe<GenericOrderByEnum>;
  /** Filtro por Tipo (rol): p.ej. [ADMIN, SUBADMIN] para 'Administrador' o [MEMBER] para 'Usuario'. None = todos. */
  roles?: InputMaybe<Array<CentralizedUserOrganizationRoleEnum>>;
  /** Búsqueda case-insensitive por nombre o correo. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ListValueSegmentationInput = {
  custom_field_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  list_value?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ListWorkCentersInput = {
  centralized_organization_id: Scalars['ID']['input'];
  country_code?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type LiveSessionAccountProviderPayload = LiveSessionGraphOperationI & {
  __typename?: 'LiveSessionAccountProviderPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  live_session_account_provider?: Maybe<LiveSessionAccountProviderType>;
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type LiveSessionAccountProviderType = {
  __typename?: 'LiveSessionAccountProviderType';
  account_provider_uuid: Scalars['String']['output'];
  url_zoom_auth_external: Scalars['String']['output'];
};

export type LiveSessionAttemptsUploadVideoPayload = LiveSessionGraphOperationI & {
  __typename?: 'LiveSessionAttemptsUploadVideoPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  live_session_attempt_upload_video?: Maybe<LiveSessionAttemptsUploadVideoType>;
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type LiveSessionAttemptsUploadVideoResponse = LiveSessionAttemptsUploadVideoPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type LiveSessionAttemptsUploadVideoType = {
  __typename?: 'LiveSessionAttemptsUploadVideoType';
  content_type: Scalars['String']['output'];
  file?: Maybe<File>;
  id: Scalars['ID']['output'];
  live_session_id: Scalars['ID']['output'];
  source_origin: LiveSessionUploadVideoSourceEnum;
  upload_by?: Maybe<UserLiveSession>;
};

export type LiveSessionAttendanceResponse = LiveSessionUserSessionPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type LiveSessionAuthZoomResponse = LiveSessionAccountProviderPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type LiveSessionBuilderMutations = {
  __typename?: 'LiveSessionBuilderMutations';
  add_users_to_session: LiveSessionListUserSessionResponse;
  assign_users_to_live_session: LiveSessionUserEngagementResponse;
  authenticate_zoom_user: LiveSessionAuthZoomResponse;
  course_live_session_upload_video_register: LiveSessionAttemptsUploadVideoResponse;
  create_live_session: LiveSessionResponse;
  create_live_session_video_class: LiveSessionVideoClassResponse;
  delete_live_session: LiveSessionResponse;
  delete_live_session_resources: LiveSessionResourceResponse;
  delete_live_session_users: LiveSessionResponse;
  delete_record_file: LiveSessionResponse;
  massive_users_engagement: LiveSessionUserEngagementResponse;
  session_report_generator: LiveSessionReportResponse;
  session_user_engagement: LiveSessionUserEngagementResponse;
  update_attendance_live_session: LiveSessionAttendanceResponse;
  update_live_session: LiveSessionResponse;
  update_live_session_video_class: LiveSessionVideoClassResponse;
  update_user_participation: LiveSessionResponse;
  upload_record_file: LiveSessionResponse;
  upload_resources: LiveSessionResourceResponse;
};


export type LiveSessionBuilderMutationsAdd_Users_To_SessionArgs = {
  input: AddSessionUserInput;
};


export type LiveSessionBuilderMutationsAssign_Users_To_Live_SessionArgs = {
  input: AssignUsersToLiveSessionInput;
};


export type LiveSessionBuilderMutationsAuthenticate_Zoom_UserArgs = {
  input: OrganizationBaseInput;
};


export type LiveSessionBuilderMutationsCourse_Live_Session_Upload_Video_RegisterArgs = {
  input: CreateLiveSessionUploadVideoInput;
};


export type LiveSessionBuilderMutationsCreate_Live_SessionArgs = {
  input: LiveSessionInput;
};


export type LiveSessionBuilderMutationsCreate_Live_Session_Video_ClassArgs = {
  input: CreateLiveSessionVideoClassInput;
};


export type LiveSessionBuilderMutationsDelete_Live_SessionArgs = {
  input: LiveSessionDeleteInput;
};


export type LiveSessionBuilderMutationsDelete_Live_Session_ResourcesArgs = {
  input: LiveSessionResourceDeleteInput;
};


export type LiveSessionBuilderMutationsDelete_Live_Session_UsersArgs = {
  input: LiveSessionUserDeleteInput;
};


export type LiveSessionBuilderMutationsDelete_Record_FileArgs = {
  input: LiveSessionDeleteInput;
};


export type LiveSessionBuilderMutationsMassive_Users_EngagementArgs = {
  input: MassiveSessionUserEngagementInput;
};


export type LiveSessionBuilderMutationsSession_Report_GeneratorArgs = {
  input: LiveSessionReportInput;
};


export type LiveSessionBuilderMutationsSession_User_EngagementArgs = {
  input: SessionUserEngagementInput;
};


export type LiveSessionBuilderMutationsUpdate_Attendance_Live_SessionArgs = {
  input: UserSessionChangeStatusInput;
};


export type LiveSessionBuilderMutationsUpdate_Live_SessionArgs = {
  input: LiveSessionUpdateInput;
};


export type LiveSessionBuilderMutationsUpdate_Live_Session_Video_ClassArgs = {
  input: UpdateLiveSessionVideoClassInput;
};


export type LiveSessionBuilderMutationsUpdate_User_ParticipationArgs = {
  input: LiveSessionUserParticipantInput;
};


export type LiveSessionBuilderMutationsUpload_Record_FileArgs = {
  input: LiveSessionVideoRecordInput;
};


export type LiveSessionBuilderMutationsUpload_ResourcesArgs = {
  input: LiveSessionResourceInput;
};

/** Input for delete a live session [Mutation] */
export type LiveSessionDeleteInput = {
  live_session_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for retrieve a live session by alphanumeric code or qr_code [Query] */
export type LiveSessionDetailByCodeInput = {
  alphanum_code?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['ID']['input'];
  qr_hash_code?: InputMaybe<Scalars['String']['input']>;
};

/** Input for retrieve a live session [Query] */
export type LiveSessionDetailInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  organization_id: Scalars['ID']['input'];
  video_lecture_id?: InputMaybe<Scalars['ID']['input']>;
};

export type LiveSessionFragment = LiveSessionIsDeletedType | LiveSessionType | LiveSessionUserNotInvitedType | VideoLectureSessionType;

/** Input for retrieve a live session [Query] */
export type LiveSessionGetInput = {
  id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
};

/** Input for retrieve a live session resource [Query] */
export type LiveSessionGetResourceInput = {
  live_session_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type LiveSessionGraphOperationI = {
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type LiveSessionI = {
  cover_image?: Maybe<File>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<UserLiveSession>;
  description: Scalars['String']['output'];
  end_date: Scalars['String']['output'];
  end_date_original: Scalars['DateTime']['output'];
  home_image_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  instructor_name?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  record_file?: Maybe<File>;
  session_link?: Maybe<UrlType>;
  session_record?: Maybe<SessionRecordFragment>;
  session_title: Scalars['String']['output'];
  source_origin?: Maybe<LiveSessionSourceOriginType>;
  start_date: Scalars['String']['output'];
  start_date_original: Scalars['DateTime']['output'];
  time_zone: SessionTimeZoneEnum;
  timeline?: Maybe<SessionTimeLineEnum>;
  total_guests?: Maybe<Scalars['Int']['output']>;
  type_session: SessionTypeEnum;
};

/** Input for create a live session [Mutation] */
export type LiveSessionInput = {
  account_provider_uuid?: InputMaybe<Scalars['UUID']['input']>;
  cover_file_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_date: Scalars['String']['input'];
  has_qr_available?: InputMaybe<Scalars['Boolean']['input']>;
  instructor_name?: InputMaybe<Scalars['String']['input']>;
  is_zoom_session?: InputMaybe<Scalars['Boolean']['input']>;
  issues_certificate?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  participants_ids?: InputMaybe<Array<UserSessionInput>>;
  resource_external_urls?: InputMaybe<Array<ResourceExternalInput>>;
  resource_file_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  session_title: Scalars['String']['input'];
  start_date: Scalars['String']['input'];
  time_zone: SessionTimeZoneEnum;
  type_session: SessionTypeEnum;
};

export type LiveSessionIsDeletedType = {
  __typename?: 'LiveSessionIsDeletedType';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LiveSessionListType = {
  __typename?: 'LiveSessionListType';
  items: Array<LiveSessionType>;
  metadata: Scalars['JSON']['output'];
};

export type LiveSessionListUserSessionPayload = LiveSessionGraphOperationI & {
  __typename?: 'LiveSessionListUserSessionPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type LiveSessionListUserSessionResponse = LiveSessionListUserSessionPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type LiveSessionMetaDataType = SessionMetaData & {
  __typename?: 'LiveSessionMetaDataType';
  next_sessions_count: Scalars['Int']['output'];
  /** Refers to the number of records after having applied the filter(s) to them */
  page_size: Scalars['Int']['output'];
  past_sessions_count: Scalars['Int']['output'];
  /** Refers to the total number of records */
  total_count: Scalars['Int']['output'];
};

export type LiveSessionOrderBy = {
  direction: OrderDirectionEnum;
  field: LiveSessionOrderByEnum;
};

export enum LiveSessionOrderByEnum {
  CreatedAt = 'CREATED_AT',
  EndDate = 'END_DATE',
  Id = 'ID',
  StartDate = 'START_DATE'
}

export type LiveSessionPaginationInput = {
  page?: Scalars['Int']['input'];
  page_size?: Scalars['Int']['input'];
};

export type LiveSessionPayload = LiveSessionGraphOperationI & {
  __typename?: 'LiveSessionPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  live_session?: Maybe<PrivateLiveSessionType>;
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type LiveSessionQrAssistanceType = {
  __typename?: 'LiveSessionQRAssistanceType';
  qr_image?: Maybe<File>;
  qr_url: Scalars['String']['output'];
};

export type LiveSessionQuery = {
  __typename?: 'LiveSessionQuery';
  /** Admin Course LiveSession detail */
  get_admin_course_live_session?: Maybe<VideoLectureSessionType>;
  /** Admin Course LiveSessions related to course */
  get_admin_course_live_sessions: PrivateSessionConnection;
  /** Live Session retrieve for admins */
  get_admin_live_session?: Maybe<PrivateLiveSessionType>;
  get_admin_live_session_users_set: PrivateSessionUserConnection;
  get_admin_live_sessions: PrivateLiveSessionListType;
  get_admin_live_sessions_set: PrivateSessionConnection;
  /** Query About LiveSessions Details */
  get_live_session?: Maybe<LiveSessionType>;
  /** Query About LiveSession Detail [fragment] */
  get_live_session_detail?: Maybe<LiveSessionFragment>;
  /** Query get live session by hash or unique code */
  get_live_session_detail_by_unique_code?: Maybe<LiveSessionFragment>;
  /**
   * Query About List Resources from LiveSession. Fetches and returns
   * internal and external resources associated with a LiveSession
   */
  get_live_session_resources?: Maybe<LiveSessionResourcesType>;
  /** Query About UserSessions List */
  get_live_session_users: UserSessionListType;
  /** Query with LiveSessions list */
  get_live_sessions: LiveSessionListType;
};


export type LiveSessionQueryGet_Admin_Course_Live_SessionArgs = {
  input: AdminCourseLiveSessionGetInput;
};


export type LiveSessionQueryGet_Admin_Course_Live_SessionsArgs = {
  input: PaginatedCourseLiveSessionsInput;
};


export type LiveSessionQueryGet_Admin_Live_SessionArgs = {
  input: LiveSessionGetInput;
};


export type LiveSessionQueryGet_Admin_Live_Session_Users_SetArgs = {
  input: AdminLiveSessionUserSetInput;
};


export type LiveSessionQueryGet_Admin_Live_SessionsArgs = {
  input: FilterLiveSessionInput;
};


export type LiveSessionQueryGet_Admin_Live_Sessions_SetArgs = {
  input: PaginatedLiveSessionInput;
};


export type LiveSessionQueryGet_Live_SessionArgs = {
  input: LiveSessionGetInput;
};


export type LiveSessionQueryGet_Live_Session_DetailArgs = {
  input: LiveSessionDetailInput;
};


export type LiveSessionQueryGet_Live_Session_Detail_By_Unique_CodeArgs = {
  input: LiveSessionDetailByCodeInput;
};


export type LiveSessionQueryGet_Live_Session_ResourcesArgs = {
  input: LiveSessionGetResourceInput;
};


export type LiveSessionQueryGet_Live_Session_UsersArgs = {
  input: FilterUserSessionInput;
};


export type LiveSessionQueryGet_Live_SessionsArgs = {
  input: FilterLiveSessionInput;
};

export type LiveSessionRecordI = {
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Input for creating a live session report [Mutation] */
export type LiveSessionReportInput = {
  live_session_id: Scalars['String']['input'];
  organization_id: Scalars['String']['input'];
};

export type LiveSessionReportPayload = LiveSessionGraphOperationI & {
  __typename?: 'LiveSessionReportPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  live_session_report?: Maybe<LiveSessionReportType>;
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type LiveSessionReportResponse = LiveSessionReportPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type LiveSessionReportType = {
  __typename?: 'LiveSessionReportType';
  file?: Maybe<File>;
  state: SessionReportStateEnum;
  version?: Maybe<Scalars['String']['output']>;
};

/** Input for delete a live session resource [Mutation] */
export type LiveSessionResourceDeleteInput = {
  live_session_resource_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type LiveSessionResourceI = {
  id: Scalars['ID']['output'];
  upload_by?: Maybe<UserLiveSession>;
};

/** Input for create a live session resources [Mutation] */
export type LiveSessionResourceInput = {
  external_urls?: InputMaybe<Array<ResourceExternalInput>>;
  file_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  live_session_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type LiveSessionResourcePayload = LiveSessionGraphOperationI & {
  __typename?: 'LiveSessionResourcePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  live_session_resource?: Maybe<Array<PrivateLiveSessionResourceType>>;
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type LiveSessionResourceResponse = LiveSessionResourcePayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type LiveSessionResourcesType = {
  __typename?: 'LiveSessionResourcesType';
  external_resources?: Maybe<Array<ExternalResourceType>>;
  internal_resources?: Maybe<Array<InternalResourceType>>;
};

export type LiveSessionResponse = LiveSessionPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

/** It is used to define the creation source of the session */
export enum LiveSessionSourceEnum {
  Default = 'DEFAULT',
  LearningPath = 'LEARNING_PATH',
  VideoLecture = 'VIDEO_LECTURE'
}

export type LiveSessionSourceOriginType = EnumI & {
  __typename?: 'LiveSessionSourceOriginType';
  enum: LiveSessionSourceEnum;
  value: Scalars['ID']['output'];
};

/** Type defined for the collaborator */
export type LiveSessionType = LiveSessionI & {
  __typename?: 'LiveSessionType';
  calendar_link?: Maybe<CalendarLinkType>;
  cover_image?: Maybe<File>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<UserLiveSession>;
  description: Scalars['String']['output'];
  end_date: Scalars['String']['output'];
  end_date_original: Scalars['DateTime']['output'];
  has_confirmed_attendance: Scalars['Boolean']['output'];
  has_participated: Scalars['Boolean']['output'];
  has_progress_completed: Scalars['Boolean']['output'];
  home_image_id?: Maybe<Scalars['Int']['output']>;
  ics_link?: Maybe<IcsLinkType>;
  id: Scalars['ID']['output'];
  instructor_name?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  record_file?: Maybe<File>;
  session_link?: Maybe<UrlType>;
  session_record?: Maybe<SessionRecordFragment>;
  session_title: Scalars['String']['output'];
  source_origin?: Maybe<LiveSessionSourceOriginType>;
  start_date: Scalars['String']['output'];
  start_date_original: Scalars['DateTime']['output'];
  time_zone: SessionTimeZoneEnum;
  timeline?: Maybe<SessionTimeLineEnum>;
  total_guests?: Maybe<Scalars['Int']['output']>;
  type_session: SessionTypeEnum;
};

/** Input for update a live session [Mutation] */
export type LiveSessionUpdateInput = {
  account_provider_uuid?: InputMaybe<Scalars['UUID']['input']>;
  cover_file_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_date: Scalars['String']['input'];
  has_qr_available?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  instructor_name?: InputMaybe<Scalars['String']['input']>;
  is_zoom_session?: InputMaybe<Scalars['Boolean']['input']>;
  issues_certificate?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  participants_ids?: InputMaybe<Array<UserSessionInput>>;
  resource_external_urls?: InputMaybe<Array<ResourceExternalInput>>;
  resource_file_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  session_title: Scalars['String']['input'];
  start_date: Scalars['String']['input'];
  time_zone: SessionTimeZoneEnum;
  type_session: SessionTypeEnum;
};

/** It is used to define the upload source (UI/Section) of videos associated with the session */
export enum LiveSessionUploadVideoSourceEnum {
  LiveSession = 'LIVE_SESSION',
  Statistics = 'STATISTICS'
}

/** Input for delete a live session users [Mutation] */
export type LiveSessionUserDeleteInput = {
  live_session_id: Scalars['ID']['input'];
  live_session_user_ids: Array<UserSessionInput>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export enum LiveSessionUserEngagementMethodEnum {
  Manual = 'MANUAL',
  Massive = 'MASSIVE'
}

export type LiveSessionUserEngagementPayload = LiveSessionGraphOperationI & {
  __typename?: 'LiveSessionUserEngagementPayload';
  engagement?: Maybe<SessionUserEngagementFragment>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type LiveSessionUserEngagementResponse = LiveSessionUserEngagementPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export enum LiveSessionUserEngagementStateEnum {
  Finished = 'FINISHED',
  Processing = 'PROCESSING',
  Submitted = 'SUBMITTED',
  Validated = 'VALIDATED'
}

export type LiveSessionUserMetaDataType = SessionMetaData & {
  __typename?: 'LiveSessionUserMetaDataType';
  exclude_user_organization_ids: Array<Scalars['Int']['output']>;
  /** Refers to the number of records after having applied the filter(s) to them */
  page_size: Scalars['Int']['output'];
  total_attendees: Scalars['Int']['output'];
  total_confirmed: Scalars['Int']['output'];
  /** Refers to the total number of records */
  total_count: Scalars['Int']['output'];
  total_guests: Scalars['Int']['output'];
};

export type LiveSessionUserNotInvitedType = {
  __typename?: 'LiveSessionUserNotInvitedType';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Input for list LiveSessionUserSession Participant [Query] */
export type LiveSessionUserParticipantInput = {
  filter?: InputMaybe<GroupEnum>;
  has_participated: Scalars['Boolean']['input'];
  live_session_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  users_participant?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type LiveSessionUserSessionPayload = LiveSessionGraphOperationI & {
  __typename?: 'LiveSessionUserSessionPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  user_session?: Maybe<LiveSessionUserSessionType>;
};

export type LiveSessionUserSessionType = UserSessionI & {
  __typename?: 'LiveSessionUserSessionType';
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  has_participated?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  status: UserStatusEnum;
  user?: Maybe<UserLiveSession>;
  user_id?: Maybe<Scalars['ID']['output']>;
  user_image_url?: Maybe<Scalars['String']['output']>;
  user_organization_id?: Maybe<Scalars['Int']['output']>;
};

export type LiveSessionUserSetFilterInput = {
  live_session_id: Scalars['ID']['input'];
  status?: InputMaybe<UserStatusEnum>;
};

export type LiveSessionUserSetSearchInput = {
  fields?: Array<Scalars['String']['input']>;
  queryset: Scalars['String']['input'];
};

export enum LiveSessionUserTrackerTypeEnum {
  Assignment = 'ASSIGNMENT',
  Attendance = 'ATTENDANCE'
}

export type LiveSessionUsersOrderBy = {
  direction: OrderDirectionEnum;
  field: UserStatusOrderByEnum;
};

export type LiveSessionVideoClassPayload = LiveSessionGraphOperationI & {
  __typename?: 'LiveSessionVideoClassPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  live_session_video_class?: Maybe<VideoLectureSessionType>;
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export type LiveSessionVideoClassResponse = LiveSessionVideoClassPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type LiveSessionVideoRecordInput = {
  live_session_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  record_file_id?: InputMaybe<Scalars['ID']['input']>;
  record_file_name?: InputMaybe<Scalars['String']['input']>;
  record_file_url?: InputMaybe<Scalars['String']['input']>;
};

export type LocaleKey = {
  __typename?: 'LocaleKey';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  namespace: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
  values: Array<LocaleValue>;
};


export type LocaleKeyValueArgs = {
  language?: InputMaybe<LocaleLanguageEnum>;
};

export enum LocaleLanguageEnum {
  LocaleLanguageEn = 'LOCALE_LANGUAGE_EN',
  LocaleLanguageEs = 'LOCALE_LANGUAGE_ES',
  LocaleLanguagePt = 'LOCALE_LANGUAGE_PT'
}

export type LocaleMutation = {
  __typename?: 'LocaleMutation';
  add_locale_key: AddLocaleKeySuccessReponseMagiclinkMutationValidationErrorInternalServerError;
  add_locale_value: AddLocaleValueSuccessReponseMagiclinkMutationValidationErrorInternalServerError;
  add_or_update_locale_value: AddLocaleValueSuccessReponseMagiclinkMutationValidationErrorInternalServerError;
  translate_locale_key: TranslateLocaleKeySuccessReponseMagiclinkMutationValidationErrorInternalServerError;
};


export type LocaleMutationAdd_Locale_KeyArgs = {
  input: AddLocaleKeyInput;
};


export type LocaleMutationAdd_Locale_ValueArgs = {
  input: AddLocaleValueInput;
};


export type LocaleMutationAdd_Or_Update_Locale_ValueArgs = {
  input: AddLocaleValueInput;
};


export type LocaleMutationTranslate_Locale_KeyArgs = {
  input: TranslateLocaleKeyInput;
};

export type LocaleQuery = {
  __typename?: 'LocaleQuery';
  locale_keys: Array<LocaleKey>;
  locale_value?: Maybe<Array<LocaleValue>>;
  translation_keys: Array<TranslationKey>;
};


export type LocaleQueryLocale_KeysArgs = {
  namespaces: Array<Scalars['String']['input']>;
};


export type LocaleQueryLocale_ValueArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<LocaleLanguageEnum>;
  namespaces: Array<Scalars['String']['input']>;
};


export type LocaleQueryTranslation_KeysArgs = {
  namespaces: Array<Scalars['String']['input']>;
};

export type LocaleValue = {
  __typename?: 'LocaleValue';
  language: LocaleLanguageEnum;
  locale_key: LocaleKey;
  locale_key_name: Scalars['String']['output'];
  text: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type LoginFromJwtAuthTokenInput = {
  next_url?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type LoginFromJwtAuthTokenPayload = {
  __typename?: 'LoginFromJWTAuthTokenPayload';
  next_url: Scalars['String']['output'];
  organization_slug: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
};

export type LoginFromJwtAuthTokenPayloadSecurityMutationErrorInternalServerMutationError = InternalServerMutationError | LoginFromJwtAuthTokenPayload | SecurityMutationError;

export type LoginMutationInput = {
  next_url?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type LoginMutationPayload = {
  __typename?: 'LoginMutationPayload';
  next_url: Scalars['String']['output'];
  security_options?: Maybe<SecurityOptions>;
  user_id: Scalars['ID']['output'];
};

export type LoginMutationPayloadSecurityMutationErrorInternalServerMutationError = InternalServerMutationError | LoginMutationPayload | SecurityMutationError;

export type LoginUserInput = {
  next_url?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type LogoutMutationInput = {
  next_url?: InputMaybe<Scalars['String']['input']>;
};

export type LogoutMutationPayload = {
  __typename?: 'LogoutMutationPayload';
  next_url: Scalars['String']['output'];
};

export type MagiclinkMutationValidationError = {
  __typename?: 'MagiclinkMutationValidationError';
  errors: Array<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
};

export type ManageOrganizationArea = {
  action: CrudActionEnum;
  areas?: InputMaybe<Array<ManageOrganizationAreaSecond>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  level_sequence: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ManageOrganizationAreaFourth = {
  level_sequence: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type ManageOrganizationAreaInput = {
  areas: Array<ManageOrganizationArea>;
  organization_id: Scalars['Int']['input'];
};

export type ManageOrganizationAreaSecond = {
  areas?: InputMaybe<Array<ManageOrganizationAreaThird>>;
  level_sequence: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type ManageOrganizationAreaThird = {
  areas?: InputMaybe<Array<ManageOrganizationAreaFourth>>;
  level_sequence: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type ManageUserPolicyBalanceLog = {
  /** Balance */
  balance: Scalars['Float']['input'];
  /** Operation */
  operation: UserPolicyBalanceLogOperationEnum;
  /** Reason */
  reason: Scalars['String']['input'];
  /** Valid Date */
  valid_date: Scalars['Date']['input'];
};

export type ManageUserPolicyBalanceLogInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Centralized User ID */
  centralized_user_id: Scalars['ID']['input'];
  /** Policy ID */
  policy_id: Scalars['ID']['input'];
  /** User Policy Balance Log */
  user_policy_balance_log: ManageUserPolicyBalanceLog;
};

export type ManageUserPolicyBalanceLogResponse = {
  __typename?: 'ManageUserPolicyBalanceLogResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

/** Sede gestionada por un usuario, con su fecha de asignación. */
export type ManagedHeadquarterDetailNode = {
  __typename?: 'ManagedHeadquarterDetailNode';
  /** Fecha de asignación (la más reciente si hubo reasignación). */
  assigned_at?: Maybe<Scalars['DateTime']['output']>;
  /** ID de la sede. */
  headquarter_id: Scalars['Int']['output'];
  /** Nombre de la sede. */
  name: Scalars['String']['output'];
};

/** Fila del listado de usuarios con restricciones de sedes. */
export type ManagedHeadquarterUserNode = {
  __typename?: 'ManagedHeadquarterUserNode';
  /** Correo del usuario. */
  email: Scalars['String']['output'];
  /** Nombre completo del usuario. */
  full_name: Scalars['String']['output'];
  /** Fecha de la última modificación de sus restricciones. */
  last_modified_at?: Maybe<Scalars['DateTime']['output']>;
  /** Nombres de las sedes que el usuario puede gestionar, en orden alfabético (el front arma el chip con el primero + resto). */
  managed_headquarter_names: Array<Scalars['String']['output']>;
  /** Cantidad de sedes que el usuario puede gestionar. */
  managed_headquarters_count: Scalars['Int']['output'];
  /** Foto de perfil del usuario (misma forma que get_users_organization); así el front no necesita un segundo llamado para el avatar. */
  profile_picture: CentralizedImageNode;
  /** Rol del usuario en la organización (MEMBER / SUBADMIN / ADMIN). */
  role: CentralizedUserOrganizationRoleEnum;
  /** ID del usuario. */
  user_id: Scalars['Int']['output'];
};

export type ManagedHeadquarterUserNodeConnection = {
  __typename?: 'ManagedHeadquarterUserNodeConnection';
  /** A list of edges in this connection. */
  edges: Array<ManagedHeadquarterUserNodeEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type ManagedHeadquarterUserNodeConnectionNotAuthenticatedErrorResponseValidationErrorResponseInternalErrorResponse = InternalErrorResponse | ManagedHeadquarterUserNodeConnection | NotAuthenticatedErrorResponse | ValidationErrorResponse;

export type ManagedHeadquarterUserNodeEdge = {
  __typename?: 'ManagedHeadquarterUserNodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ManagedHeadquarterUserNode;
};

/** Input para guardar el conjunto completo de sedes gestionadas por un usuario (reemplazo de conjunto). */
export type ManagedHeadquartersInput = {
  /** ID de la organización que scopea la operación (requerido). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Conjunto de IDs de sedes que el usuario podrá gestionar. Reemplaza el conjunto anterior. */
  headquarter_ids: Array<Scalars['Int']['input']>;
  /** ID del usuario objetivo cuya restricción de sedes se guarda (requerido). */
  user_id: Scalars['Int']['input'];
};

/** Payload del guardado de sedes gestionadas por un usuario. */
export type ManagedHeadquartersPayload = {
  __typename?: 'ManagedHeadquartersPayload';
  /** Sedes agregadas en esta operación. */
  added_headquarter_ids: Array<Scalars['Int']['output']>;
  /** Conjunto final de sedes gestionadas tras el guardado. */
  managed_headquarter_ids: Array<Scalars['Int']['output']>;
  /** Sedes retiradas (soft delete) en esta operación. */
  removed_headquarter_ids: Array<Scalars['Int']['output']>;
  /** Indica si el guardado fue exitoso. */
  success: Scalars['Boolean']['output'];
  /** ID del usuario objetivo. */
  user_id: Scalars['Int']['output'];
};

export type ManagedHeadquartersPayloadValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse = IntegrityErrorResponse | InternalErrorResponse | ManagedHeadquartersPayload | NotFoundResponse | ValidationErrorResponse;

/** Management licenses from OrganizationOpportunity */
export type ManagementLicensesNode = {
  __typename?: 'ManagementLicensesNode';
  /** Remaining available seats */
  available_capacity: Scalars['Int']['output'];
  /** License expiration date */
  end_date?: Maybe<Scalars['DateTime']['output']>;
  /** Application product modules under Gestion */
  modules: Array<ApplicationProductNode>;
  /** License activation date */
  start_date?: Maybe<Scalars['DateTime']['output']>;
  /** Total seats purchased */
  total_capacity: Scalars['Int']['output'];
  /** Percentage of seats in use */
  usage_percentage: Scalars['Float']['output'];
  /** Seats currently in use (active users) */
  used_capacity: Scalars['Int']['output'];
};

export type MarkBenefitAsHighlightedInput = {
  benefit: BenefitAsHighlightedInput;
  centralized_organization_id: Scalars['ID']['input'];
};

export type MarkImssMovementsSentBatchInput = {
  legal_entity_id: Scalars['UUID']['input'];
  movement_ids: Array<Scalars['UUID']['input']>;
};

export type MarkImssMovementsSentBatchResponse = {
  __typename?: 'MarkImssMovementsSentBatchResponse';
  errors: Array<BatchOperationError>;
  graphql_operation_id: Scalars['ID']['output'];
  sent: Scalars['Int']['output'];
};

export type MarkImssMovementsSentBatchResult = InternalErrorResponse | MarkImssMovementsSentBatchResponse | UserPermissionErrorResponse;

export type MarketplaceClientsReportProgress = {
  __typename?: 'MarketplaceClientsReportProgress';
  error?: Maybe<ErrorResponse>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceClientsReportResponse = {
  __typename?: 'MarketplaceClientsReportResponse';
  error?: Maybe<ErrorResponse>;
  success: Scalars['Boolean']['output'];
};

export type MarketplaceConfigInput = {
  banner?: InputMaybe<Scalars['String']['input']>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  favicon?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  isotype?: InputMaybe<Scalars['String']['input']>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  logo_image?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['Int']['input'];
  organization_name?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
  text_over_primary_color?: InputMaybe<Scalars['String']['input']>;
  twitter_url?: InputMaybe<Scalars['String']['input']>;
};

export type MarketplaceConfigNode = {
  __typename?: 'MarketplaceConfigNode';
  available_licenses?: Maybe<Scalars['Int']['output']>;
  banner?: Maybe<ImageType>;
  country_currency?: Maybe<Scalars['String']['output']>;
  currencies: Array<CurrencyEnum>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  favicon?: Maybe<ImageType>;
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instagram_url?: Maybe<Scalars['String']['output']>;
  isotype?: Maybe<ImageType>;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  logo_image?: Maybe<ImageType>;
  organization_id: Scalars['ID']['output'];
  organization_name?: Maybe<Scalars['String']['output']>;
  primary_color?: Maybe<Scalars['String']['output']>;
  text_over_primary_color?: Maybe<Scalars['String']['output']>;
  total_available_licenses?: Maybe<Scalars['Int']['output']>;
  twitter_url?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceOrganizationTeamNode = {
  __typename?: 'MarketplaceOrganizationTeamNode';
  category?: Maybe<Scalars['String']['output']>;
  course_count?: Maybe<Scalars['Int']['output']>;
  courses_team?: Maybe<Array<OrganizationTeamCourseNode>>;
  courses_to_certificate?: Maybe<Scalars['Int']['output']>;
  courses_to_complete?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_draft?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  track_type?: Maybe<Scalars['String']['output']>;
};

export enum MarketplaceUserFieldEnum {
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL',
  Product = 'PRODUCT'
}

export type MarketplaceUserNode = {
  __typename?: 'MarketplaceUserNode';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organization_id: Scalars['Int']['output'];
  user?: Maybe<User>;
  user_id: Scalars['Int']['output'];
};

export type MarketplaceUserOrderByFieldInput = {
  direction: OrderDirectionEnum;
  field: MarketplaceUserFieldEnum;
};

export type MarketplaceUserProductNode = {
  __typename?: 'MarketplaceUserProductNode';
  id: Scalars['ID']['output'];
  marketplace_user?: Maybe<MarketplaceUserNode>;
  product?: Maybe<Product>;
  status?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceUserProductNodeConnection = {
  __typename?: 'MarketplaceUserProductNodeConnection';
  edges: Array<MarketplaceUserProductNodeEdge>;
  page_info: PageInfo;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type MarketplaceUserProductNodeEdge = {
  __typename?: 'MarketplaceUserProductNodeEdge';
  cursor: Scalars['String']['output'];
  node: MarketplaceUserProductNode;
};

export type MassiveAssignmentInput = {
  user_assignment_id: Scalars['ID']['input'];
};

export type MassiveAttendanceInput = {
  register_candidates: Scalars['Boolean']['input'];
  user_attendance_id: Scalars['ID']['input'];
};

export type MassiveCreationTeamsInfoValidationResponse = {
  __typename?: 'MassiveCreationTeamsInfoValidationResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

/** Subgraph HRIS - Massive Validation Detail Error Response Node */
export type MassiveDetailErrorResponseNode = {
  __typename?: 'MassiveDetailErrorResponseNode';
  centralized_user_id?: Maybe<Scalars['Int']['output']>;
  email: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type MassiveDocumentUploadDetail = {
  __typename?: 'MassiveDocumentUploadDetail';
  completed_count: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  failed_count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  status: UploadStatusEnum;
  total_count: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user: UserInfo;
  uuid: Scalars['String']['output'];
};

export type MassiveDocumentUploadDetailResponse = {
  __typename?: 'MassiveDocumentUploadDetailResponse';
  items: Array<MassiveDocumentUploadItemDetail>;
  page: Scalars['Int']['output'];
  page_size: Scalars['Int']['output'];
  total_items: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
  upload: MassiveDocumentUploadDetail;
};

export type MassiveDocumentUploadItemDetail = {
  __typename?: 'MassiveDocumentUploadItemDetail';
  assigned_at?: Maybe<Scalars['DateTime']['output']>;
  assigned_user?: Maybe<UserInfo>;
  document_name: Scalars['String']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  location?: Maybe<FolderInfo>;
  status: ItemStatusEnum;
  visible: Scalars['Boolean']['output'];
};

export type MassiveDocumentUploadListResponse = {
  __typename?: 'MassiveDocumentUploadListResponse';
  page: Scalars['Int']['output'];
  page_size: Scalars['Int']['output'];
  total_count: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
  uploads: Array<MassiveDocumentUploadSummary>;
};

export type MassiveDocumentUploadSummary = {
  __typename?: 'MassiveDocumentUploadSummary';
  completed_count?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  failed_count?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  status: UploadStatusEnum;
  total_count: Scalars['Int']['output'];
  user: UserInfo;
  uuid: Scalars['String']['output'];
};

/** Subgraph HRIS - Massive Validation Error Response Node */
export type MassiveErrorResponseNode = {
  __typename?: 'MassiveErrorResponseNode';
  code: Scalars['Int']['output'];
  errors: Array<MassiveSubErrorResponseNode>;
  message: Scalars['String']['output'];
};

export type MassiveManageUserPolicyBalanceLogsInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Query to apply in the update */
  query: QueryUserPolicyBalanceLog;
};

export type MassiveManageUserPolicyBalanceLogsResponse = {
  __typename?: 'MassiveManageUserPolicyBalanceLogsResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

/** Input de la carga masiva de restricciones de sede. Lo comparten validate y start: ambos reciben la organización y una referencia al Excel subido, sea por `file_id` (recomendado) o por `file_url`. */
export type MassiveManagedHeadquartersInput = {
  /** Organización objetivo. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Identificador del Excel en el file service (columnas email_usuario | nombre_sede). Es la forma recomendada: el archivo se ubica por id sin importar en qué bucket lo haya subido el cliente. */
  file_id?: InputMaybe<Scalars['Int']['input']>;
  /** URL del Excel, alternativa a `file_id`. Solo funciona si apunta al bucket privado de este servicio. */
  file_url?: InputMaybe<Scalars['String']['input']>;
};

export enum MassiveProcessTypeEnum {
  CompetencesModel = 'COMPETENCES_MODEL',
  CompetencesRelations = 'COMPETENCES_RELATIONS',
  CompetenceWeights = 'COMPETENCE_WEIGHTS',
  DipActivityAssignment = 'DIP_ACTIVITY_ASSIGNMENT',
  DipActivityTracking = 'DIP_ACTIVITY_TRACKING',
  DipLibraryActivity = 'DIP_LIBRARY_ACTIVITY',
  EvaluationDeleteRelations = 'EVALUATION_DELETE_RELATIONS',
  Participants = 'PARTICIPANTS'
}

/** Input used in massive_users_engagement [Mutation] */
export type MassiveSessionUserEngagementInput = {
  assignment?: InputMaybe<MassiveAssignmentInput>;
  attendance?: InputMaybe<MassiveAttendanceInput>;
  live_session_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

/** Subgraph HRIS - Massive Validation Sub Error Response Node */
export type MassiveSubErrorResponseNode = {
  __typename?: 'MassiveSubErrorResponseNode';
  sub_code: Scalars['Int']['output'];
  sub_errors: Array<MassiveDetailErrorResponseNode>;
};

export type MassiveUploadConfigItemInput = {
  /** When the document should be assigned (None = immediately) */
  assignment_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Display name for the document */
  document_name: Scalars['String']['input'];
  /** User email to assign the document to */
  email: Scalars['String']['input'];
  /** Original filename (must match uploaded file) */
  file_name: Scalars['String']['input'];
  /** Target folder ID (None = no folder) */
  folder_id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the document is visible to the user */
  visible?: Scalars['Boolean']['input'];
};

/** Node with information of File Uploaded */
export type MassiveUploadNode = {
  __typename?: 'MassiveUploadNode';
  fields: Array<PreSignedField>;
  file_name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Subgraph HRIS - Massive User Not In Segment Response Node */
export type MassiveUserNotInSegmentResponseNode = {
  __typename?: 'MassiveUserNotInSegmentResponseNode';
  document_id: Scalars['Int']['output'];
  document_name: Scalars['String']['output'];
  users: Array<MassiveDetailErrorResponseNode>;
};

export type MassiveValidUserInfoInput = {
  centralized_user_id: Scalars['Int']['input'];
  email: Scalars['String']['input'];
};

/** Subgraph HRIS - Massive Validation User Info Response Node */
export type MassiveValidUserInfoResponseNode = {
  __typename?: 'MassiveValidUserInfoResponseNode';
  centralized_user_id: Scalars['Int']['output'];
  email: Scalars['String']['output'];
};

/** Subgraph HRIS - Massive Validation Response Node */
export type MassiveValidationResponseNode = {
  __typename?: 'MassiveValidationResponseNode';
  /** Validation Code */
  code: Scalars['Int']['output'];
  /** Message */
  message: Scalars['String']['output'];
};

/** Input to find similar positions by keywords (STEP 1). */
export type MatchKeywordsByPositionInput = {
  centralized_organization_id: Scalars['Int']['input'];
  exclude_position_id?: InputMaybe<Scalars['Int']['input']>;
  keywords: Array<Scalars['String']['input']>;
};

export type MatchKeywordsResponse = ForbiddenErrorResponse | InternalErrorResponse | MatchKeywordsSuccess | ValidationErrorResponse;

/** Successful keyword matching response. */
export type MatchKeywordsSuccess = {
  __typename?: 'MatchKeywordsSuccess';
  graphql_operation_id: Scalars['ID']['output'];
  matches: Array<KeywordMatchNode>;
  total_matches: Scalars['Int']['output'];
};

export enum MedalState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type MediaFileV1Type = ShareFileV1Interface & {
  __typename?: 'MediaFileV1Type';
  absolute_url?: Maybe<Scalars['String']['output']>;
  content_type: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by_id?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  download_url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_b2b?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  relative_url: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

export enum MedicalFitnessEnum {
  Fit = 'FIT',
  FitWithRestrictions = 'FIT_WITH_RESTRICTIONS',
  PendingEvaluation = 'PENDING_EVALUATION',
  Unfit = 'UNFIT'
}

export type MentorAdminQuery = {
  __typename?: 'MentorAdminQuery';
  get_course_mentor_list: Array<OrganizationUserMentorType>;
};


export type MentorAdminQueryGet_Course_Mentor_ListArgs = {
  input: AdminGetCourseMentorsInput;
};

export type MenuCatalogInput = {
  application_name?: InputMaybe<ApplicationNameEnum>;
  centralized_organization_id: Scalars['Int']['input'];
  panel: MenuCatalogPanelEnum;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type MenuCatalogItem = {
  __typename?: 'MenuCatalogItem';
  default_label: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  is_shared: Scalars['Boolean']['output'];
  level: Scalars['Int']['output'];
  parent_key?: Maybe<Scalars['String']['output']>;
  section_key: Scalars['String']['output'];
};

export enum MenuCatalogPanelEnum {
  Admin = 'ADMIN',
  Collaborator = 'COLLABORATOR'
}

export type MenuCustomizationItemInput = {
  /** Nombre custom; vacío o nulo restaura el nombre default */
  custom_name?: InputMaybe<Scalars['String']['input']>;
  /** section_key de la sección a renombrar */
  section_key: Scalars['String']['input'];
};

export type MenuCustomizationResponse = {
  __typename?: 'MenuCustomizationResponse';
  customizations?: Maybe<Array<OrganizationMenuCustomizationNode>>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type MenuItemNode = {
  __typename?: 'MenuItemNode';
  children: Array<MenuItemNode>;
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_title: Scalars['Boolean']['output'];
  lang: LangNode;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type MenuModuleNode = {
  __typename?: 'MenuModuleNode';
  icon: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum MenuPanelType {
  Admin = 'ADMIN',
  Collaborator = 'COLLABORATOR'
}

export enum MenuTypeEnumNode {
  Admin = 'ADMIN',
  Collaborator = 'COLLABORATOR'
}

export type MenuTypeNode = {
  __typename?: 'MenuTypeNode';
  items: Array<MenuItemNode>;
  type_name: MenuTypeEnumNode;
};

export type MetaDataCourseLog = {
  component_type_id: Scalars['Int']['input'];
  /** Component or SubComponent title o name */
  representation: Scalars['String']['input'];
  sub_component_type_id?: InputMaybe<Scalars['Int']['input']>;
  update_fields?: InputMaybe<Scalars['String']['input']>;
};

/** Information to metadata for pagination. */
export type Metadata = {
  __typename?: 'Metadata';
  /** Max results per page */
  page_size: Scalars['Int']['output'];
  /** Total quantity of existing nodes */
  total_count: Scalars['Int']['output'];
};

export enum MethodCreationMembers {
  MassiveLoad = 'MASSIVE_LOAD',
  Segmentation = 'SEGMENTATION'
}

export enum MethodCreationTeams {
  Manual = 'MANUAL',
  MassiveLoad = 'MASSIVE_LOAD'
}

export type MetricsUser = {
  __typename?: 'MetricsUser';
  user?: Maybe<User>;
  user_id: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type MetricsUserConnection = {
  __typename?: 'MetricsUserConnection';
  /** Contains the nodes in this connection */
  edges: Array<MetricsUserEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type MetricsUserEdge = {
  __typename?: 'MetricsUserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: MetricsUser;
};

export type MigrateCustomFieldResponse = {
  __typename?: 'MigrateCustomFieldResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

/** Migration performed by type */
export type MigrationPerformedBy = {
  __typename?: 'MigrationPerformedBy';
  /** Type of performed by (Migration). */
  type: AuditLogPerformedByEnum;
};

/** Milestone type identifiers aligned with the frontend widget. */
export enum MilestoneIdEnum {
  Certifications = 'CERTIFICATIONS',
  Licenses = 'LICENSES',
  Pids = 'PIDS',
  StudyHours = 'STUDY_HOURS',
  TalentProcesses = 'TALENT_PROCESSES'
}

/** A milestone achieved in the period. */
export type MilestoneNode = {
  __typename?: 'MilestoneNode';
  /** Whether the organization has this module contracted. */
  contracted: Scalars['Boolean']['output'];
  /**
   * Deprecated — use delta_value instead. Percentage change vs previous month.
   * @deprecated Use delta_value instead. Will be removed once frontend migrates.
   */
  delta?: Maybe<Scalars['Float']['output']>;
  /** Raw numeric delta vs previous month (e.g. 24.0, -3.5). Positive = up, negative = down. Null when not available. */
  delta_value?: Maybe<Scalars['Float']['output']>;
  /** Short contextual text (e.g. '+24% vs mes pasado · Récord trimestral'). Null when not applicable. */
  helper_text?: Maybe<Scalars['String']['output']>;
  /** Icon name (e.g. 'timer', 'emoji_events', 'check_circle', 'description', 'group_add'). */
  icon: Scalars['String']['output'];
  /**
   * Deprecated — use semantic_color instead. Color for the icon circle.
   * @deprecated Use semantic_color instead. Will be removed once frontend migrates.
   */
  icon_color: Scalars['String']['output'];
  /** Milestone type identifier. */
  id: MilestoneIdEnum;
  /** Semantic color token for the milestone. Values: 'success', 'warning', 'danger', 'info', 'brand', 'pending', 'lime'. Null triggers frontend fallback by key. */
  semantic_color?: Maybe<Scalars['String']['output']>;
  /** Numeric value for the milestone (e.g. 500.0 for hours, 1247 for certs). */
  value: Scalars['Float']['output'];
};

/** Response for Section E3 — milestones achieved this month. */
export type MilestonesResponse = {
  __typename?: 'MilestonesResponse';
  /** Structured error code for degraded responses ('INVALID_PERIOD' on inconsistent period input). Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Icon name for the widget header (e.g. 'auto_awesome'). */
  icon: Scalars['String']['output'];
  /** Localized timestamp of the most recent ETL sync for this widget's data. Format: '23 abr - 9:25am'. Null when freshness cannot be determined. */
  last_updated_at_formatted?: Maybe<Scalars['String']['output']>;
  /** Milestones achieved, ordered by relevance. */
  milestones: Array<MilestoneNode>;
  /** Period range for the milestones. */
  period: PeriodRange;
  /** Period subtitle (e.g. 'Este mes · Mayo 2026'). */
  subtitle: Scalars['String']['output'];
  /** Widget title (e.g. 'Highlights del mes'). */
  title: Scalars['String']['output'];
};

export enum ModalityTypeEnum {
  ModalityTypeHybrid = 'MODALITY_TYPE_HYBRID',
  ModalityTypeInPerson = 'MODALITY_TYPE_IN_PERSON',
  ModalityTypeOnLine = 'MODALITY_TYPE_ON_LINE'
}

export type ModeratorsNotInSegmentWarningResponse = {
  __typename?: 'ModeratorsNotInSegmentWarningResponse';
  /** Code so the frontend can identify this alert. */
  code: Scalars['String']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  /** Human-readable message for the frontend to display. */
  message: Scalars['String']['output'];
  /** List of moderator user ids that would not be in the new segment. */
  moderator_ids_not_in_segment: Array<Scalars['Int']['output']>;
};

export type ModuleInfoResponse = {
  __typename?: 'ModuleInfoResponse';
  boss_full_name?: Maybe<Scalars['String']['output']>;
  company_id_talent?: Maybe<Scalars['Int']['output']>;
  degraded: Scalars['Boolean']['output'];
  division?: Maybe<Scalars['String']['output']>;
  /** Employee Id from Talent */
  employee_id: Scalars['String']['output'];
  is_boss: Scalars['Boolean']['output'];
  is_from_talent: Scalars['Boolean']['output'];
  job?: Maybe<Scalars['String']['output']>;
  modules: Array<TalentModuleInfo>;
  modules_admin: Array<TalentModuleInfo>;
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  subsidiary?: Maybe<Scalars['String']['output']>;
  talent_roles: Array<Scalars['String']['output']>;
};

/** A single KPI within a module pulse card. */
export type ModuleKpi = {
  __typename?: 'ModuleKpi';
  /** KPI label. */
  label: Scalars['String']['output'];
  /** Secondary detail line. */
  sublabel?: Maybe<Scalars['String']['output']>;
  /** Formatted value (e.g. '45%', '127', '4.3/5'). */
  value: Scalars['String']['output'];
};

/** Month-by-month cumulative competence progress per relation across a process date range (full-process evolution chart). Future months are null. */
export type MonthlyProgressByRangeType = {
  __typename?: 'MonthlyProgressByRangeType';
  entries: Array<MonthlyProgressEntryType>;
};

/** Per-relation progress for a single month of the range. */
export type MonthlyProgressEntryType = {
  __typename?: 'MonthlyProgressEntryType';
  month: Scalars['String']['output'];
  relations: Array<MonthlyRelationProgressType>;
};

/** Per-relation cumulative progress for a single month of the range. */
export type MonthlyRelationProgressType = {
  __typename?: 'MonthlyRelationProgressType';
  evaluation_id: Scalars['Int']['output'];
  evaluation_name: Scalars['String']['output'];
  progress_percentage?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export enum MonthsEnum {
  April = 'APRIL',
  August = 'AUGUST',
  December = 'DECEMBER',
  February = 'FEBRUARY',
  January = 'JANUARY',
  July = 'JULY',
  June = 'JUNE',
  March = 'MARCH',
  May = 'MAY',
  November = 'NOVEMBER',
  October = 'OCTOBER',
  September = 'SEPTEMBER'
}

/** Most Generated Event or Achievement */
export type MostCommonEvent = {
  __typename?: 'MostCommonEvent';
  default_image?: Maybe<Scalars['String']['output']>;
  frequency: Scalars['Int']['output'];
  item?: Maybe<CurrencyEventNode>;
};

/** Most Generated Event or Achievement */
export type MostCommonEventFragmentNode = ITextBoxNode & {
  __typename?: 'MostCommonEventFragmentNode';
  default_image?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['Int']['output']>;
  item?: Maybe<AdminCurrencyEventFragmentNode>;
};

/** Most requested reward */
export type MostRequestedRewardFragmentNode = ITextBoxNode & {
  __typename?: 'MostRequestedRewardFragmentNode';
  default_image?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['Int']['output']>;
  item?: Maybe<AdminRewardNode>;
};

/** Most requested reward */
export type MostRequestedRewardNode = {
  __typename?: 'MostRequestedRewardNode';
  default_image?: Maybe<Scalars['String']['output']>;
  frequency: Scalars['Int']['output'];
  item?: Maybe<RewardNode>;
};

export type MostUsedOptionAnswer = {
  __typename?: 'MostUsedOptionAnswer';
  count: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MultipleAssignCategories = {
  content_ids: Array<Scalars['ID']['input']>;
  filters?: InputMaybe<Array<FilterBaseInput>>;
  has_select_all?: InputMaybe<Scalars['Boolean']['input']>;
  list_category_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type MultipleDeleteContent = {
  content_ids: Array<Scalars['ID']['input']>;
  filters?: InputMaybe<Array<FilterBaseInput>>;
  has_select_all?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type MultipleOperand = {
  __typename?: 'MultipleOperand';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type MultipleOperandCountry = {
  __typename?: 'MultipleOperandCountry';
  iso_code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MultipleOperandGender = {
  __typename?: 'MultipleOperandGender';
  name: Scalars['String']['output'];
  value: SegmentRuleAlphabeticAttributeGenderEnum;
};

export type MultipleUpdateActionsPayload = {
  __typename?: 'MultipleUpdateActionsPayload';
  async_process: Scalars['Boolean']['output'];
  rows_affected: Scalars['Int']['output'];
};

export type MultipleUpdateActionsResponse = MultipleUpdateActionsPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type MultipleUpdateContentVisibility = {
  content_ids: Array<Scalars['ID']['input']>;
  filters?: InputMaybe<Array<FilterBaseInput>>;
  has_select_all?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  visibility_level: VisibilityLevelType;
};

/**  AGRUPACIÓN DE MUTATIONS */
export type Mutation = {
  __typename?: 'Mutation';
  accept_terms_and_conditions: DefaultDataPayloadMutationValidationErrorMutationInternalError;
  /** Activate/Deactivate an OrganizationAreaLevel for Organization */
  activate_deactivate_organization_area_level: ActivateDeactivateAreaLevelResponse;
  activate_learning_user: UserOrganizationActivationMutation;
  /** Activates an Organization Headquarter. https://crehana.atlassian.net/wiki/x/EYC1Gg */
  activate_organization_headquarter: ActivateOrganizationHeadquarterResponse;
  /** Reactiva un usuario en learning, talent y centralized, no valido para primera vez */
  activate_user: ActivateUserResponse;
  add_class_note_thumbnail: Response;
  add_course_higher_education_team: AddCourseHigherEducationTeamResponse;
  add_course_video_highlight?: Maybe<CourseVideoHighlightPayload>;
  add_course_video_transcript: AddVideoTranscriptPayloadAddVideoTranscriptValidationErrorAddVideoTranscriptInternalError;
  /** Add users in team organization */
  add_users_in_team_organization: AddUsersInTeamOrganizationResponse;
  add_video_transcript_segment: AddVideoTranscriptSegmentPayload;
  add_video_transcript_summary: AddVideoTranscriptSummaryPayload;
  agent_os: AgentOsMutation;
  allow_users?: Maybe<CurrencyPointMutationNode>;
  analytics_report: AnalyticsReportMutation;
  /** [Admin] Assign tasks to users */
  assign_tasks_to_affected_users: CreateWorkflowTaskUserResponse;
  assign_user_organization_area: AssignUserOrganizationAreaResponse;
  assign_user_organization_headquarter: AssignUserOrganizationHeadquarterResponse;
  /** Asigna un grupo de usuarios a un grupo de permisos */
  assign_users_to_permission_group: AssingnusersToPermissionGroupResponse;
  /** Type of all resources [Mutations] of the ATS Recruitment */
  ats_recruitment: AtsRecruitmentMutation;
  /** Namespace for audit log-related mutations. */
  audit_logs: AuditLogAtsEventMutation;
  authentication_saml2: AuthenticationSaml2NamespaceMutation;
  authorization_server: AuthorizationServerNamespaceMutation;
  /** Creates an object for the model Automated Tasks */
  automated_tasks: AutomatedTasksMutations;
  automation: AutomationBuilderMutation;
  batch_process: BuilderBatchMutation;
  benefit: BenefitMutationBuilder;
  /** Content Enrollment mutations */
  block_player: BlockPlayerMutations;
  /** Synchronously create or update a batch of organization positions. Designed for agent use: returns immediate results without Pub/Sub.  */
  bulk_create_positions_sync: BulkCreatePositionsSyncResponse;
  bulk_create_transactions?: Maybe<BulkCreateTransactionsNode>;
  celery: CeleryMutation;
  centralized_configuration: CentralizedConfigurationMutation;
  /** Namespace for corporation-related mutations. */
  centralized_corporation: CorporationMutations;
  centralized_organizations_check: CentralizedOrganizationCheckMutationResponse;
  centralized_report: CentralizedReportMutation;
  centralized_security: CentralizedSecurityNamespaceMutation;
  /** Namespace for corporation-related mutations. */
  centralized_super_admin: SuperAdminMutations;
  centralized_user_assign_boss: CentralizedAssignBossResponseCentralizedMutationValidationErrorCentralizedMutationInternalError;
  centralized_user_unassign_boss: CentralizedAssignBossResponseCentralizedMutationValidationErrorCentralizedMutationInternalError;
  centralized_users: CentralizedUsersMutation;
  centralized_users_admin_check: CentralizedCheckMutationResponse;
  centralized_users_check: CentralizedCheckMutationResponse;
  centralized_users_pubsub_check: CentralizedCheckMutationResponse;
  centralized_users_segmentation: SegmentationMutations;
  /** Mutation for generate a certificate of a course */
  certificate_generate_file: CertificateGenerationResultPayload;
  /** Certificate policy block actions */
  certificate_policy: CertificatePolicyBuilderMutations;
  change_password: ChangePassword;
  /** Complete task by user */
  complete_task_by_user: CompleteTaskUserResponse;
  /** Complete a reading document */
  complete_user_reading_document: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  /** Content Emails validation by excel */
  content_core: CoreContentMutations;
  /** Content Enrollment mutations */
  content_enrollment: ContentEnrollmentMutations;
  /** Organization team block actions */
  content_organization_team: OrganizationTeamBuilderMutations;
  contract: EmploymentContractMutation;
  /** Convierte un usuario a administrador en learning, talent y centralized */
  convert_to_admin: ConvertToAdminResponse;
  copilot: CopilotMutation;
  /** Mutaciones de analítica que consume el MCP del copilot (archivo a medida). */
  copilot_analytics: CopilotAnalyticsMutation;
  copilot_report: CopilotReportMutation;
  corporate_documents: CorporateDocumentsMutations;
  /** Creates an object for the model Course */
  course: CourseBuilderMutations;
  course_module: CourseModuleMutations;
  courses_enrollment_progress: UpdateEnrollmentMutation;
  /** Create an application document */
  create_application_document: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  /** Updates Talent organization and user IDs in centralized system based on existing Learning data */
  create_centralized_organization: CreateAndUpdateOrganizationResponse;
  /** Creates an organization in centralized from existing organization in learning and talent */
  create_centralized_organization_from_existing_company: CreateAndUpdateOrganizationResponse;
  /** Create a new centralized user */
  create_centralized_user: CreateCentralizedUserPayloadCentralizedMutationValidationErrorCentralizedMutationInternalError;
  /** Crea un nuevo usuario en centralized. Falla si el usuario ya existe en la org. Asigna licencias si se proveen suite_codes. */
  create_centralized_user_v2: CreateCentralizedUserPayloadCentralizedMutationValidationErrorCentralizedMutationInternalError;
  create_class_note: ClassNoteMutationNode;
  create_content_elevate_course: CreateOrUpdateContentResponse;
  create_currency_point?: Maybe<CurrencyPointMutationNode>;
  /** Mutation for editing a CurrencyEvent objects (EVENTS) */
  create_custom_event: CurrencyEventMutationNode;
  /** Create custom fields asociated to an Organization */
  create_custom_field: CreateCustomFieldResponse;
  /** Create custom fields associated to an Organization for api public */
  create_custom_field_api: CreateCustomFieldResponseApi;
  create_custom_field_filter_group: LearningCustomFieldFilterGroup;
  /** Create custom fields for REST integrations using upstream API-key validation */
  create_custom_field_rest: CreateCustomFieldResponse;
  /** Create a end user reading document */
  create_end_user_document: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  /** Create a folder */
  create_folder: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  create_higher_education_team: CreateHigherEducationTeamResponse;
  create_higher_education_team_product: CreateHigherEducationTeamProductResponse;
  /** Creates an organization in centralized, learning and talent */
  create_integrated_organization: CreateAndUpdateOrganizationResponse;
  create_message_rating: ChatMessageRatingDataPayloadMutationValidationErrorMutationInternalError;
  create_notification: NotificationMutationNode;
  /**
   * Crea o actualiza un usuario existente con el mismo correo en centralized, learning y talent
   * @deprecated Use create_centralized_user instead
   */
  create_or_update_centralized_user: CreateCentralizedUserResponse;
  /** This mutation create or update Course Team Dependence. */
  create_or_update_course_team_dependence: CreateOrUpdateCourseTeamDependenceResponse;
  /** Create organization team header */
  create_or_update_team_member: TeamMemberResponse;
  /** This mutation create or update one Organization Team */
  create_or_update_team_organization: CreateOrUpdateOrganizationTeamResponse;
  /** For internal use and organization creation for testing purposes only */
  create_organization: CentralizedOrganizationNode;
  create_organization_access_token_from_credentials_mutation: AccessTokenMutationResponse;
  /** Creates a new Organization Area (tree). */
  create_organization_area: CreateOrganizationAreaResponse;
  /** Creates an OrganizationAreaLevel for an Organization */
  create_organization_area_level: CreateOrganizationAreaLevelResponse;
  /** Creates an organization_enterprise and its associated organization_enterprise_external. The external record is used for third-party integrations (e.g. Intelexion/Workbeat) where the organization identifier is a non-numeric string (external_id). */
  create_organization_enterprise_external: CreateOrganizationEnterpriseExternalResponse;
  /** Create a new headquarter for an organization. https://crehana.atlassian.net/wiki/x/fwDEEg */
  create_organization_headquarter: CreateOrganizationHeadquarterResponse;
  /** Create PlatformModule for a Organization */
  create_organization_opportunity_module: CreateModuleResponse;
  /** Create organization position. */
  create_organization_position: CentralizedCreateOrganizationPositionPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse;
  /** Create organization position category. */
  create_organization_position_category: CentralizedCreateOrganizationPositionCategoryPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse;
  /** Create organization position category for public api */
  create_organization_position_category_api: CreateOrganizationPositionCategoryResponseApi;
  /** Create organization position family. */
  create_organization_position_family: CentralizedCreateOrganizationPositionFamilyPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse;
  /** Create organization position level. */
  create_organization_position_level: CentralizedCreateOrganizationPositionLevelPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse;
  /** Create Payment Gateway Config */
  create_payment_gateway_config: CreatePaymentGatewayConfigResponse;
  /** Create Payment Gateway Org Config */
  create_payment_gateway_org_config: CreatePaymentGatewayOrgConfigResponse;
  /** Crea un grupo de permisos con la informacion suministrada */
  create_permission_group: PermissionGroupResponse;
  /** Create organization Product Category */
  create_product_category: CreateProductCategoryResponse;
  create_questions_with_openai: BulkCreateQuestionsMutationNode;
  /** @deprecated This mutation creates quizzes. Use 'create_question_with_openai' instead */
  create_quiz_with_openai: QuizGeneratorMutationNode;
  /** Create a reading document */
  create_reading_document: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  create_reward: RewardMutationNode;
  /** This mutation is used to manually create the super admin permission group, However the permission group will be automatically generated with the cronjob */
  create_super_admin_role: CreateSuperAdminResponse;
  /** Create team conditionals */
  create_team_conditionals: CreationTeamConditionalsResponse;
  /** Create organization team header */
  create_team_header: CreationTeamsResponse;
  /** Create organization teams (header and members) */
  create_teams: CreationTeamsResponse;
  /** Create a template document */
  create_template_document: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  create_transaction: RewardTransactionMutationNode;
  create_user: CreateUser;
  create_user_device: UserDeviceMutationNode;
  create_video_process?: Maybe<VideoProcess>;
  /** Crea (o actualiza) el mapeo UserEnterprise de Workbeat: enlaza el workbeat_id con un usuario centralized. Idempotente para el mismo usuario; rechaza enlazar un workbeat_id ya asociado a otro centralized. */
  create_workbeat_user_enterprise: CreateWorkbeatUserEnterpriseResponse;
  /** [Admin] Creates a Work Flow */
  create_workflow: CreateWorkFlowResponse;
  /** [Admin] Creates a Work Flow details */
  create_workflow_detail: CreateWorkFlowResponse;
  deactivate_learning_user: UserOrganizationDeactivationMutation;
  deactivate_message_rating: DefaultDataPayloadMutationValidationErrorMutationInternalError;
  deactivate_notification: NotificationMutationNode;
  /** Deletes/Deactivates an Organization Headquarter. https://crehana.atlassian.net/wiki/x/JQCvGg */
  deactivate_organization_headquarter: DeactivateOrganizationHeadquarterResponse;
  /** Deactivate (soft-delete) an organization position. */
  deactivate_organization_position: DeactivateOrganizationPositionResponse;
  /** Desactiva un grupo de permisos con el id suministrado */
  deactivate_permission_group: PermissionGroupResponse;
  /** Desactiva un usuario en learning, talent y centralized */
  deactivate_user: DeactivateUserResponse;
  /** Deactivates multiple users in Learning, Talent, and Centralized systems. https://crehana.atlassian.net/wiki/x/HIBzFw */
  deactivate_users: DeactivateUserResponse;
  /** Deactivates (unassigns) one or more user documents by id */
  deactivate_users_document: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  delete_copilot_conversation: DefaultDataPayloadMutationValidationErrorMutationInternalError;
  /** Delete course in team organization */
  delete_course_in_team_organization: DeleteCourseInTeamOrganizationResponse;
  delete_currency_point?: Maybe<CoreMutationNode>;
  /** Delete custom fields asociated to an Organization */
  delete_custom_field: UpdateCustomFieldResponse;
  /** Delete a document */
  delete_document: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  /** Delete a document */
  delete_end_user_document: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  /** Delete a folder */
  delete_folder: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  delete_higher_education_team_product: DeleteHigherEducationTeamProductResponse;
  /** Deletes an Organization Area. */
  delete_organization_area: DeleteOrganizationAreaResponse;
  /** Deletes multiple Organization Areas. */
  delete_organization_areas: DeleteOrganizationAreaResponse;
  /** This mutation delete an Organization Team */
  delete_organization_team: DeleteOrganizationTeamResponse;
  delete_reward: RewardMutationNode;
  /** Delete organization team */
  delete_team: DeleteTeamResponse;
  /** Create organization team header */
  delete_team_member: TeamMemberResponse;
  /** Deletes a Custom Field Answer from a Multiple user_ids in a Organization */
  delete_user_custom_field_answer: DeleteUsersCustomFieldAnswerResponse;
  /** Delete user in team organization */
  delete_user_in_team_organization: DeleteUserInTeamOrganizationResponse;
  delete_workflow: DeleteWorkFlowResponse;
  dummy_mutation: DummyResponse;
  /** Ebanx direct payment mutation */
  ebanx_direct_payment: EbanxDirectPaymentResponsePaymentErrorNode;
  /** Edit a document */
  edit_document: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  /** Edit a end user document */
  edit_end_user_document: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  /** Edit a folder */
  edit_folder: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  edit_reward: RewardMutationNode;
  /** Edit deadline of a document of a specific user */
  edit_user_document_deadline: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  /** Email builder mutation */
  emails: EmailBuilderMutations;
  /** Epayco CC Payment */
  epayco_cc_payment: EpaycoPaymentResponsePaymentErrorNode;
  /** Create Epayco PSE Transaction */
  epayco_pse_payment: EpaycoPaymentResponsePaymentErrorNode;
  execute_massive_notifications: CoreMutationNode;
  /** Create or get an async Excel export of all active positions. If a PENDING or PROCESSING request already exists for the organization, it is returned (is_cached=True) without creating a new one. Re-call this mutation to poll state (PENDING → PROCESSING → COMPLETE | ERROR). file_url is populated once state=COMPLETE. */
  export_organization_positions_excel: ExportOrganizationPositionsResponse;
  feature_flag: FeaturesMutation;
  /** Current File Upload Process */
  file_builder: BuilderFileMutation;
  /** Hard-delete a stored file by uid (right-to-erasure / retention). */
  file_delete: DeleteFileMutation;
  file_update_status: UpdateStatusFileMutation;
  /** Old process - To Deprecated */
  file_upload: UploadFileMutation;
  files_v1: FileV1Mutation;
  foundation_reports: FoundationReportsMutations;
  gamification: MutationsGamification;
  gamification_currency_point: MutationCurrencyPoints;
  gamification_leaderboard: MutationLeaderboard;
  gamification_rewards: MutationRewards;
  gamification_v2: StableGamificationMutationV2;
  /** Generates a signed url to upload a file to S3. Returns the signed url. */
  generate_attachment_upload_url: MassiveUploadNode;
  /** Generates a report of the users in the centralized platform */
  generate_centralized_users_report: CentralizedUserReportResponse;
  /** This mutation is use to manually generate the template, However the template will be automatically generated each time a custom field is added or deleted */
  generate_custom_field_templates: GenerateCustomFieldTemplateResponse;
  /** Creates an template to upload for an Organization */
  generate_custom_upload_template: UploadTemplateResponse;
  /** Generate Datafast checkout id */
  generate_datafast_checkout_id: GenerateDatafastCheckoutIdResponse;
  /** Get invitation link for user */
  generate_invitation_link: GetInvitationLinkResponse;
  /** Generate position description and functions from title using AI. */
  generate_position_description: GeneratePositionDescriptionResponse;
  /** Generate position keywords from description and functions using AI. */
  generate_position_keywords: GeneratePositionKeywordsResponse;
  generate_pre_signed_url_image: GeneratePreSignedUrlResponse;
  /** @deprecated This mutation should not be used */
  generate_quiz: QuizGeneratorMutationNode;
  /** Generates a downloadable PDF for a document template preview */
  generate_template_document_pdf: HrisCorporateDocumentsDocumentTemplatePdfHrisMutationValidationErrorHrisMutationInternalError;
  /** Mutation for generate a track certificate */
  generate_track_certificate: CertificateResponse;
  /** Geocode a text address to coordinates and normalized metadata */
  geocode_address: CompassMapsGeocodeAddressResult;
  /** Resolve a place_id to final location (lat/lng, address and metadata) */
  geocode_by_place_id: CompassMapsGeocodeByPlaceIdResult;
  get_crehana_session?: Maybe<CrehanaSessionResponse>;
  health: Scalars['String']['output'];
  hris: HrisMutations;
  hris_report: HrisReportMutation;
  /** Namespace for internal comms-related mutations. */
  internal_comms: InternalCommsMutations;
  /** Knowledge Hub Mutation Namespace */
  knowledge_hub: KnowledgeHubContentMutation;
  knowledge_hub_admin_category_v2: KnowledgeHubAdminCategoryMutation;
  knowledge_hub_admin_content_document_v2: KnowledgeHubAdminContentDocumentMutation;
  knowledge_hub_admin_content_v2: KnowledgeHubAdminContentMutation;
  knowledge_hub_admin_tag_v2: KnowledgeHubAdminTagMutation;
  /** Knowledge Hub Category Mutation Namespace */
  knowledge_hub_category: KnowledgeHubCategoryMutation;
  /** Knowledge Hub Configuration Mutation Namespace */
  knowledge_hub_config: KnowledgeHubConfigMutation;
  /** Knowledge Hub Documents Mutation Namespace */
  knowledge_hub_document: KnowledgeHubDocumentMutation;
  /** Namespace for legal-entity-related mutations. */
  legal_entities: LegalEntitiesMutations;
  /** Creates an object for the model LiveSession */
  live_session: LiveSessionBuilderMutations;
  locale: LocaleMutation;
  /** Manages Organization Areas, including creating, updating, or deleting multiple areas. */
  manage_organization_areas: UpdateOrganizationAreaResponse;
  mark_notification_as_read: UserNotificationMutationNode;
  marketplace_clients_report: MarketplaceClientsReportResponse;
  /** Flywire Tokenize Data */
  marketplace_flywire_tokenize_data: FlywireTokenizeDataResponsePaymentErrorNode;
  /** Flywire Validate Payment Order */
  marketplace_flywire_validate_payment_order: FlywireValidatePaymentOrderResponseFlywirePaymentProcessingResponsePaymentErrorNode;
  /** Update Product field is_trash */
  marketplace_update_product_is_draft: UpdateProductIsDraftResponse;
  messaging_email_message: EmailPublisherMutation;
  messaging_fcm_notifications: FcmPublisherMutation;
  messaging_pubsub_publisher: PubSubPublisherMutation;
  messaging_sns_messages: SnsPublisherMutation;
  messaging_sqs_messages: SqsPublisherMutation;
  migrate_learning_custom_fields: MigrateCustomFieldResponse;
  multiple_assign_categories: MultipleUpdateActionsResponse;
  multiple_delete_content: MultipleUpdateActionsResponse;
  multiple_update_content_visibility: MultipleUpdateActionsResponse;
  /** Normaliza Cf options */
  normalize_custom_field_options: NormalizeResponse;
  /** set incorporation_date in centralized users */
  normalize_users_incorporation_date: SyncUserResponse;
  /** Namespace for notification hub mutations. */
  notification_hub: NotificationHubMutations;
  /** List of [Mutations] related to the notifications center module. */
  notifications_center: NotificationsCenterMutations;
  openai_conversation: OpenAiConversationMutation;
  /** Organization template block actions */
  organization_template: OrganizationTemplateBuilderMutations;
  /** Creates an object for the model OrganizationalChart */
  organizational: OrganizationalMutations;
  payroll: PayrollMutation;
  pending_transactions_emails: EmailMutationNode;
  /** Process marketplace failed product order */
  process_marketplace_failed_product_order?: Maybe<ProcessMarketplaceFailedProductOrderResponse>;
  /**
   * Process marketplace paid product order
   * @deprecated Move to payment_receive_messages in payment.pubsub.routers.py
   */
  process_marketplace_paid_product_order?: Maybe<ProcessMarketplacePaidProductOrderResponse>;
  publish_higher_education_team_product: PublishHigherEducationTeamProductResponse;
  /** Quick enroll made by coupon 100% or free product */
  quick_enroll: QuickEnrollResponsePaymentErrorNode;
  /** Creates an object for the model Quizzes */
  quizzes: QuizMainMutations;
  /** Creates an object for the model Quiz */
  quizzes_builder: QuizBuilderMutation;
  /** Reactivate deleted user */
  reactivate_deleted_user: ReactivateDeletedUserResponse;
  recover_password: RecoverPassword;
  /** Regenerates the bulk user upload Excel template with the updateddata of positions, headquarters, areas and custom fields. Useful afterimporting new charges to appear in the template dropdown. */
  regenerate_user_upload_template: RegenerateUserTemplateResponse;
  register_user_event: UserEventBankMutationNode;
  remove_course_higher_education_team: RemoveCourseHigherEducationTeamResponse;
  remove_marketplace_user: RemoveMarketplaceUserResponse;
  /** Remove a confirmed successor from the selected pool. Deletes the candidate row; it can be re-created by selecting again. */
  remove_selected_candidate: RemoveSelectedCandidateResponse;
  /** Remueve el rol de administrador de un usuario en learning, talent y centralized */
  remove_user_admin_role: RemoveUserAdminRoleResponse;
  /** Remueve un grupo de usuarios de un grupo de permisos */
  remove_users_from_permission_group: PermissionGroupResponse;
  request_free_trial: DefaultDataPayloadMutationValidationErrorMutationInternalError;
  request_hana: DefaultDataPayloadMutationValidationErrorMutationInternalError;
  /** Convert coordinates (lat, lng) to structured address and LATAM fiscal payload */
  reverse_geocode: CompassMapsReverseGeocodeResult;
  /** Runs the daily certificate expiration pass: transitions VALID/EXPIRING_SOON versions to EXPIRING_SOON/EXPIRED, stamps the matching timestamp, and dispatches a push per transition. A push that fails clears its stamp and is retried on a later run without repeating the transition -- delivery is at-least-once, never lost, occasionally duplicated. */
  run_certificate_expiration_job: RunCertificateExpirationJobPayload;
  /** Save user invoice data */
  save_invoice_data: InvoiceDataMutationNode;
  /** Save a massive User assignment to Document */
  save_massive_document_assignment: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  /** Save a massive User assignment to Folder */
  save_massive_folder_assignment: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  scorm: ScormMutation;
  security: SecurityMutation;
  security_policies: SecurityPoliciesNamespaceMutation;
  /** Select a successor for a position using non-destructive upsert semantics. If candidate does not exist, it is created as IDENTIFIED and promoted to SELECTED. If already SELECTED, mutation is idempotent and can update optional metadata. */
  select_succession_candidate: SelectSuccessionCandidateResponse;
  /** Envia un email de activacion a los usuarios que se han creado en la organizacion */
  send_user_email_activation: UserActivationResponse;
  send_user_email_invitation: UserInvitationResponse;
  send_user_email_invitation_organization: UserInvitationResponse;
  /** set deactivation date in centralized user */
  set_deactivation_date: SetDeactivationDateResponse;
  /** Asigna un uausio de talent con un usuario de centralized */
  set_talent_user: SetTalentUserResponse;
  /** Mark or unmark a track's course as coming soon */
  set_track_course_coming_soon: SetTrackCourseComingSoonResponse;
  social_hub: SocialHubMutations;
  start_bidirectionality_synchronization: BidirectionalitySynchronizationMutationResponse;
  /** Initializes the process of massive change password */
  start_massive_active_user: ValidateExcelFileResponseV2;
  /** Initializes the process of massive change password */
  start_massive_change_password: ImportExcelFileResponse;
  /** Inicia el proceso de asignacion masiva de usuarios a un grupo de permisos */
  start_massive_permission_group_user_assignment: ImportExcelFileResponse;
  /** Start massive creation of organization positions. */
  start_massive_position_creation: StartMassivePositionsResponse;
  /** Initializes the process of massive user batch. Use batch_mode=CREATE_ONLY to only create new users, UPDATE_ONLY to only update existing users. For update-only batches, consider passing send_invitation=False. */
  start_massive_user_batch: ImportExcelFileResponse;
  /** Initializes the process of massive user creation */
  start_massive_user_creation: ImportExcelFileResponse;
  /** Inicializa el proceso de desactivacion/eliminacion masiva de usuarios */
  start_massive_user_deactivation: ImportExcelFileResponse;
  start_personalization_synchronization: PersonalizationOrganizationResponse;
  /** sync custom fields */
  sync_custom_fields_from_centralized: SyncCustomFieldsResponse;
  /** sync custom fields */
  sync_custom_fields_from_learning: SyncCustomFieldsResponse;
  /** Sync evaluation indicators for a position. */
  sync_position_evaluation_indicators: SyncPositionEvaluationIndicatorsResponse;
  /** sync custom fields */
  sync_users_without_internal_id: SyncUserResponse;
  /** Synchronize user avatar from learning */
  synchronize_user_avatar_from_learning: UserProfileUpdateAvatarResponse;
  talent: TalentMutation;
  talent_competences?: Maybe<TalentCompetencesMutations>;
  talent_feedback?: Maybe<TalentFeedbackMutations>;
  talent_recognition?: Maybe<TalentRecognitionMutation>;
  talent_reports?: Maybe<TalentReportsMutation>;
  test: Scalars['String']['output'];
  /** Namespace for Time-related mutations. */
  time: TimeMutations;
  /** [Admin] Activates a specific time-off Policy */
  timeoff_activate_policy: ActivatePolicyResponse;
  /** [Admin] Enqueue an approved bulk time-off balance import for async processing */
  timeoff_apply_bulk_import: ApplyBulkImportResult;
  /** [Admin/User/Leader] Approves a specific time-off request */
  timeoff_approve_request: ApproveRequestResponse;
  /** [Admin] Assign user to Policy Balance Log */
  timeoff_assign_user_policy_balance_log: AssignUserPolicyBalanceLogResponse;
  /** [User] Attaches or replaces a file on an existing time-off request */
  timeoff_attach_request_file: AttachRequestFileResponse;
  /** [Admin] Validate and stage a bulk time-off balance import from Excel */
  timeoff_bulk_import_policy_balance: BulkImportPolicyBalanceResult;
  /** [Admin] Creates a time-off request already APPROVED, bypassing the approval chain. Used by Attendance to register a justificante on behalf of a collaborator (TIM-243). Org-admin only: the granular attendance permission is enforced upstream by the caller; HRIS trusts an org admin (mirrors the admin-on-behalf model of the TL admin drawer). */
  timeoff_create_approved_request: CreateApprovedRequestResponse;
  /** [Admin] Creates a specific time-off holiday */
  timeoff_create_holiday: CreateHolidayResponse;
  /** [Admin] Creates a specific time-off Policy */
  timeoff_create_policy: CreatePolicyResponse;
  /** [Admin] V2: Creates a time-off Policy with enhanced features (max_time=0 support, enhanced seniority rules) */
  timeoff_create_policy_v2: CreatePolicyResponse;
  /** [User] Creates a specific time-off request */
  timeoff_create_request: CreateRequestResponse;
  /** [Requester/Approver/Admin] Creates a specific time-off request comment. Authorized by participation in the request (requester or assigned approver); admins with the TimeOffRequestManageAdmin Edit permission bypass identity matching, participation, and status checks (same as before this authorization change). */
  timeoff_create_request_comment: CreateRequestCommentResponse;
  /** [Admin] Creates a specific time-off request notification log */
  timeoff_create_request_notification_log: CreateRequestNotificationLogResponse;
  /** [Admin] Creates a specific time-off request notification logs */
  timeoff_create_request_notification_logs: CreateRequestNotificationLogsResponse;
  /** [Admin] Deactivates a specific time-off Policy */
  timeoff_deactivate_policy: DeactivatePolicyResponse;
  /** [Admin] Deletes a specific time-off holiday */
  timeoff_delete_holiday: DeleteHolidayResponse;
  /** [Admin] Deletes a multiple time-off holidays */
  timeoff_delete_holidays: DeleteHolidaysResponse;
  /** [Admin] Deletes a specific time-off Policy */
  timeoff_delete_policy: DeletePolicyResponse;
  /** [User] Deletes a specific time-off request */
  timeoff_delete_request: DeleteRequestResponse;
  /** [Admin/User/Leader] Denies a specific time-off request */
  timeoff_deny_request: DenyRequestResponse;
  /** [User] Detaches (soft-deletes) a file from an existing time-off request */
  timeoff_detach_request_file: DetachRequestFileResponse;
  /** [Admin] Duplicates a specific time-off Policy */
  timeoff_duplicate_policy: DuplicatePolicyResponse;
  /** [Admin] Bulk import time-off balance adjustments for a policy via CSV */
  timeoff_import_policy_balance: ImportPolicyBalanceResponse;
  /** [Admin] Add/Remove Balance from a specific User */
  timeoff_manage_user_policy_balance_log: ManageUserPolicyBalanceLogResponse;
  /** [Admin/Internal ONLY] Massively update balances for an Organization */
  timeoff_massive_update_user_policy_balance_logs: MassiveManageUserPolicyBalanceLogsResponse;
  /** [Admin] Manually (re)triggers HRIS-3980's balance recalculation for a collaborator marked as misaligned (HRIS-3981, AC-1/AC-5) — a synchronous call into the existing recalculation service, not a new SQS event. */
  timeoff_recalculate_incorporation_date_balance: RecalculateIncorporationDateBalanceResponse;
  /** [Bulk] Resolves a specific time-off request approval chain. Cronjob usage only */
  timeoff_resolve_request_status: ResolveRequestStatusResponse;
  /** [Bulk] Auto Assign/Unassign a specific time-off Policy to a list of employees. Cronjob usage only */
  timeoff_resolve_users_policy: ResolvePolicyResponse;
  /** [Admin] Restaurar una importación masiva de saldos — cancela ajustes y solicitudes aprobadas */
  timeoff_restore_bulk_import: RestoreBulkImportResult;
  /** [Admin] Skips a specific time-off request approval chain */
  timeoff_skip_request_approval: SkipRequestApprovalResponse;
  /** [Admin] Recalculate and sync policy balances for an organization */
  timeoff_sync_organization_policy_balance: SyncOrganizationPolicyBalanceResponse;
  /** [Admin] Recalculate and sync policy balance for a specific user */
  timeoff_sync_user_policy_balance: SyncUserPolicyBalanceResponse;
  /** [Admin] Updates an specific time-off holiday */
  timeoff_update_holiday: UpdateHolidayResponse;
  /** [Admin] Updates an specific time-off Policy */
  timeoff_update_policy: UpdatePolicyResponse;
  /** [Admin] V2: Updates a time-off Policy with enhanced features (max_time=0 support, enhanced seniority rules) */
  timeoff_update_policy_v2: UpdatePolicyResponse;
  /** Dispara el barrido de cierre de rutas por fecha limite: publica un tick a la cola SQS y retorna de inmediato. El consumer hace el trabajo de escanear y cerrar. Lo llama el cron de crehana-fn-b2b por federacion. */
  trigger_close_routes_by_deadline: TriggerCloseRoutesByDeadlineResponse;
  unassign_user_organization_area: AssignUserOrganizationAreaResponse;
  /** Mutation for editing a CurrencyEvent objects (ACHIEVEMENTS) */
  update_achievements?: Maybe<CurrencyAchievementMutationNode>;
  /** update avatar in centralized users */
  update_avatar: UserProfileUpdateAvatarResponse;
  update_class_note: ClassNoteMutationNode;
  /** Update the configuration of an organization's area levels and headquarters. https://crehana.atlassian.net/wiki/x/KAA4Eg */
  update_configuration_area_and_headquarter: UpdateConfigurationAreaAndHeadquarterResponse;
  update_content_by_course: CreateOrUpdateContentResponse;
  update_copilot_conversation: DefaultDataPayloadMutationInternalError;
  /** Mutation for editing a CurrencyPoint object */
  update_currency_point?: Maybe<CurrencyPointMutationNode>;
  /** Mutation for editing a CurrencyPoint where setting its done */
  update_currency_point_setting_done?: Maybe<CurrencyPointMutationNode>;
  /** Update custom field and custom_field_choices asociated to an Organization */
  update_custom_field: UpdateCustomFieldResponse;
  /** Update custom field and custom_field_choices asociated to an Organization for api public */
  update_custom_field_api: UpdateCustomFieldResponseApi;
  update_custom_field_filter_group: LearningCustomFieldFilterGroup;
  /** Mutation for editing a CurrencyEvent objects (EVENTS) */
  update_events?: Maybe<CurrencyEventMutationNode>;
  /** Mutation to edit initial_setup field */
  update_initial_setup?: Maybe<CurrencyPointMutationNode>;
  update_marketplace_config: UpdateMarketplaceConfigResponse;
  update_notification: NotificationMutationNode;
  update_organization: CreateAndUpdateOrganizationResponse;
  /** Updates an Organization Area. */
  update_organization_area: UpdateOrganizationAreaResponse;
  /** Updadte an OrganizationAreaLevel for an Organization */
  update_organization_area_level: UpdateAreaLevelResponse;
  /** Update an existing headquarter for an organization. https://crehana.atlassian.net/wiki/x/AgDUEg */
  update_organization_headquarter: UpdateOrganizationHeadquarterResponse;
  /** Guarda/actualiza/restaura los nombres custom del menú de una organización para un panel. custom_name vacío restaura el default. White Labeling v2 — CORE-1605. */
  update_organization_menu_customization: MenuCustomizationResponse;
  /** Update an organization position (full update). */
  update_organization_position: UpdateOrganizationPositionResponse;
  /** Update organization position category. */
  update_organization_position_category: CentralizedUpdateOrganizationPositionCategoryPayloadInternalErrorResponseValidationErrorResponseNotAuthenticatedErrorResponseIntegrityErrorResponse;
  /** Update organization team course order */
  update_organization_team_course_order: UpdateOrganizationTeamCourseResponse;
  /** Update organization tenant branding (colors, images, etc.) */
  update_organization_tenant_branding: CentralizedOrganizationTenantBrandingNodeValidationErrorResponseInternalErrorResponse;
  /** Actualiza un grupo de permisos remplazando la antigua informacion con la nueva informacion suministrada */
  update_permission_group: PermissionGroupResponse;
  update_personalization_organization: PersonalizationOrganizationResponse;
  /** Update organization team header */
  update_team_header: UpdateTeamResponse;
  /** Update an existing template document */
  update_template_document: HrisCorporateDocumentsDocumentTemplateDetailHrisMutationValidationErrorHrisMutationInternalError;
  update_user_custom_fields: UpdateUserCustomFieldResponse;
  /** Actualiza el email de un usuario en centralized, learning y talent */
  update_user_email: UpdateUserEmailResponse;
  /** Sets the notification_seen field to True */
  update_user_event_bank: CoreMutationNode;
  /** Update centralized user information */
  update_user_info: UpdateUserInfoResponse;
  update_video_process?: Maybe<VideoProcess>;
  update_workflow: UpdateWorkFlowResponse;
  upload_file_import_info: UserImportsNode;
  /** Upload file to a specific user Application Document. */
  upload_file_user_application_document: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  user_organization: UserOrganizationMutation;
  user_password_update: UserUpdateResponse;
  /** Creates an object for the model UserProfile */
  user_profile: UserProfileMutations;
  user_recover_password: UserUpdateResponse;
  /** User team assignment */
  user_team_assignment: UserTeamAssignmentResponse;
  /** User team deactivation */
  user_team_deactivation: UserTeamDeactivationResponse;
  users_audit_log: AuditLogMutations;
  /** Validate the calling collaborator's track completion rules and, when met, generate their track certificate. Replaces the dependency on the monolith COMPLETED_TRACK pub/sub trigger so the certificate is issued on demand from the track detail (CELC-5055). */
  validate_and_generate_track_certificate: CertificateResponse;
  /** Valida que los usuarios de un archivo Excel pertenezcan a la organización y valida sus contraseñas */
  validate_change_password_excel_file: ValidateUsersOrganizationResponse;
  /** Validates the change-password Excel and returns errors grouped by cause for the new UI. Same validation as v1; only the response shape differs. */
  validate_change_password_excel_file_v2: ValidateUsersOrganizationResponseV2;
  /** Valida si los usuarios son validos para ser asignados a un rol manualmente */
  validate_manual_permission_group_user_assignment: ValidateManualRolUserAssignmentResponse;
  /** Validate Excel file for bulk creation of organization positions */
  validate_massive_create_organization_positions_excel: ValidatePositionsResponse;
  /** Validates the excel file for massive user creation */
  validate_massive_create_user_excel_file: ValidateMassiveCreateUserExcelFileResponse;
  /** Validates the excel file for massive user creation v2 */
  validate_massive_create_user_excel_v2: ValidateExcelFileResponseV2;
  /** Validate excel file in massive Creation Team members */
  validate_massive_creation_team_members: ValidateMassiveCreationTeamsResponse;
  /** Validate excel file in massive Creation Teams */
  validate_massive_creation_teams: ValidateMassiveCreationTeamsResponse;
  /** Validates an Excel file for massive deactivation of users. https://crehana.atlassian.net/wiki/x/AgDWFQ */
  validate_massive_deactivate_user_excel_file: ValidateMassiveDeactivateUserExcelFileResponse;
  /** Validate excel file in massive User assignment to Document */
  validate_massive_document_assignment: HrisValidationMassiveAssignmentDocumentResponseHrisMutationValidationErrorHrisMutationInternalError;
  /** Validate excel file in massive User assignment to Folder */
  validate_massive_folder_assignment: HrisValidationMassiveAssignmentFolderResponseHrisMutationValidationErrorHrisMutationInternalError;
  /** Valida el archivo de excel para la creacion masiva de areas */
  validate_massive_organization_area_excel_file: ValidateMassiveCreateOrganizationAreaExcelFileResponse;
  /** Valida si el archivo esta listo para ser importado */
  validate_massive_permission_group_user_assignment_excel_file: ValidateExcelFileResponse;
  /** Validates the excel file for massive user batch (create-only or update-only) */
  validate_massive_user_batch: ValidateExcelFileResponseV2;
  /** Validates an Organization Area for specified operations. */
  validate_organization_area: ValidateOrganizationAreaResponse;
  /** Validate Datafast Payment Order */
  validate_payment_order_datafast: ValidatePaymentOrderDatafastResponsePaymentErrorNode;
  /** Validate team name */
  validate_team_name: ValidateTeamNameResponse;
  /** This mutation validates the upload of users from Excel */
  validate_user_team_assignment: ValidateUserTeamAssignmentResponse;
  /** Creates an object for the models: VideoLectureType[PDF] */
  video_lecture: VideoLectureTypeBuilderMutations;
  video_progress: VideoProgressMutations;
  videos_media_convert: VideosMediaConvertMutation;
  videos_subtitle_process: SubtitleProcessMutation;
  videos_transcoder_process: TranscoderProcessMutation;
  /** Namespace for Workflows-related mutations. */
  workflows: WorkflowsMutations;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationAccept_Terms_And_ConditionsArgs = {
  organization_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationActivate_Deactivate_Organization_Area_LevelArgs = {
  is_active: Scalars['Boolean']['input'];
  organization_area_level_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationActivate_Organization_HeadquarterArgs = {
  headquarter_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationActivate_UserArgs = {
  organization_slug: Scalars['String']['input'];
  user_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationAdd_Class_Note_ThumbnailArgs = {
  class_note_id: Scalars['Int']['input'];
  thumbnail_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationAdd_Course_Higher_Education_TeamArgs = {
  add_input: AddCourseHigherEducationTeamInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationAdd_Course_Video_HighlightArgs = {
  text: Scalars['String']['input'];
  video_lecture_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationAdd_Course_Video_TranscriptArgs = {
  generate_summary?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<AddCourseVideoTranscriptInput>;
  language?: InputMaybe<VideoLanguageEnum>;
  text?: InputMaybe<Scalars['String']['input']>;
  video_lecture_id?: InputMaybe<Scalars['ID']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationAdd_Users_In_Team_OrganizationArgs = {
  input: AddUsersInTeamOrganizationInput;
  organization_id?: InputMaybe<Scalars['ID']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationAdd_Video_Transcript_SegmentArgs = {
  input: Array<AddVideoTranscriptSegmentInput>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationAdd_Video_Transcript_SummaryArgs = {
  input: AddVideoTranscriptSummaryInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationAllow_UsersArgs = {
  mutation_variables: AllowedUserCreateInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationAssign_Tasks_To_Affected_UsersArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  segment_type: WorkFlowSegmentTypeEnum;
  workflow_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationAssign_User_Organization_AreaArgs = {
  area_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
  user_ids: Array<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationAssign_User_Organization_HeadquarterArgs = {
  headquarter_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
  user_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationAssign_Users_To_Permission_GroupArgs = {
  organization_slug: Scalars['String']['input'];
  permission_group_id: Scalars['Int']['input'];
  users_email: Array<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationBulk_Create_Positions_SyncArgs = {
  input: BulkCreatePositionsSyncInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationBulk_Create_TransactionsArgs = {
  organization_slug: Scalars['String']['input'];
  transaction_status_enum: TransactionStatusEnum;
  transaction_type_enum: TransactionTypeEnum;
  transactions_ids: Array<Scalars['ID']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCentralized_User_Assign_BossArgs = {
  input: CentralizedAssignBossInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCentralized_User_Unassign_BossArgs = {
  input: CentralizedUnassignBossInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCentralized_Users_Pubsub_CheckArgs = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCertificate_Generate_FileArgs = {
  input: GenerateCertificateInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationChange_PasswordArgs = {
  activation_key: Scalars['String']['input'];
  password_1: Scalars['String']['input'];
  password_2: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationComplete_Task_By_UserArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  work_flow_task_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationComplete_User_Reading_DocumentArgs = {
  input: CompleteUserReadingDocumentInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationConvert_To_AdminArgs = {
  organization_slug: Scalars['String']['input'];
  user_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Application_DocumentArgs = {
  input: CreateApplicationDocumentInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Centralized_OrganizationArgs = {
  admin_email: Scalars['String']['input'];
  error_message?: InputMaybe<Scalars['String']['input']>;
  organization_slug: Scalars['String']['input'];
  status_code: Scalars['String']['input'];
  talent_organization_id: Scalars['String']['input'];
  talent_user_organization_id: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Centralized_Organization_From_Existing_CompanyArgs = {
  organization_info: Array<OrganizationIntegratedInput>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Centralized_UserArgs = {
  input: CreateCentralizedUserInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Centralized_User_V2Args = {
  input: CreateCentralizedUserInput;
  suite_codes: Array<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Class_NoteArgs = {
  description: Scalars['String']['input'];
  highlight_id?: InputMaybe<Scalars['Int']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  prompt_version_key?: InputMaybe<Scalars['String']['input']>;
  time_position: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  video_lecture_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Content_Elevate_CourseArgs = {
  data: CreateContentByElevateCourse;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Currency_PointArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Custom_EventArgs = {
  background_color: Scalars['String']['input'];
  currency_point_value: Scalars['Float']['input'];
  custom_description?: InputMaybe<Scalars['String']['input']>;
  custom_icon_url: Scalars['String']['input'];
  custom_name: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Custom_FieldArgs = {
  custom_field: CreateCustomFieldInput;
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Custom_Field_ApiArgs = {
  custom_field: CreateCustomFieldInput;
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Custom_Field_Filter_GroupArgs = {
  filter_group: LearningCustomFieldFilterGroupCreateInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Custom_Field_RestArgs = {
  custom_field: CreateCustomFieldInput;
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_End_User_DocumentArgs = {
  input: CreateEndUserDocumentInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_FolderArgs = {
  input: CreateFolderInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Higher_Education_TeamArgs = {
  team: CreateHigherEducationTeamInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Higher_Education_Team_ProductArgs = {
  product: CreateHigherEducationTeamProductInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Integrated_OrganizationArgs = {
  is_demo?: Scalars['Boolean']['input'];
  organization: CreateIntegratedOrganization;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Message_RatingArgs = {
  input: ChatMessageRatingDataInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_NotificationArgs = {
  category_id?: InputMaybe<Scalars['String']['input']>;
  icon_image?: InputMaybe<Scalars['String']['input']>;
  in_app_event?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  platforms: Array<Scalars['String']['input']>;
  redirect_url?: InputMaybe<Scalars['String']['input']>;
  redirect_url_name?: InputMaybe<Scalars['String']['input']>;
  subcategory_id?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Or_Update_Centralized_UserArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  area_level_1_id: Scalars['Int']['input'];
  area_level_2_id?: InputMaybe<Scalars['Int']['input']>;
  area_level_3_id?: InputMaybe<Scalars['Int']['input']>;
  area_level_4_id?: InputMaybe<Scalars['Int']['input']>;
  boss_email?: InputMaybe<Scalars['String']['input']>;
  boss_id?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  civil_status?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  custom_fields?: InputMaybe<Array<CustomFieldUserCreationInput>>;
  deactivation_date?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Scalars['String']['input']>;
  document_type?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  email_validate?: InputMaybe<Scalars['Boolean']['input']>;
  first_name: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  headquarter_id?: InputMaybe<Scalars['Int']['input']>;
  incorporation_date?: InputMaybe<Scalars['String']['input']>;
  last_name: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
  permission_group_id?: InputMaybe<Scalars['Int']['input']>;
  phone_1?: InputMaybe<Scalars['String']['input']>;
  phone_2?: InputMaybe<Scalars['String']['input']>;
  position_category_id: Scalars['Int']['input'];
  position_id: Scalars['Int']['input'];
  send_invitation?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Or_Update_Course_Team_DependenceArgs = {
  input: CreateOrUpdateCourseTeamDependenceInputList;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Or_Update_Team_MemberArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  delete_current_records?: Scalars['Boolean']['input'];
  input: Array<TeamMemberInput>;
  organization_team_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Or_Update_Team_OrganizationArgs = {
  data: CreateOrganizationTeamInput;
  organization_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_OrganizationArgs = {
  organization: CreateOrganization;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Organization_Access_Token_From_Credentials_MutationArgs = {
  input: CreateOrganizationAccessTokenFromCredentialsInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Organization_AreaArgs = {
  area_data: CreateAreaInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Organization_Area_LevelArgs = {
  area_level: CreateAreaLevelInput;
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Organization_Enterprise_ExternalArgs = {
  input: CreateOrganizationEnterpriseExternalInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Organization_HeadquarterArgs = {
  headquarters: Array<CreateHeadquarterInput>;
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Organization_Opportunity_ModuleArgs = {
  modules: Array<CreateModuleInput>;
  opportunity_id: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Organization_PositionArgs = {
  input: CentralizedPositionsCreateOrganizationPositionInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Organization_Position_CategoryArgs = {
  input: CentralizedPositionsCreateOrganizationPositionCategoryInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Organization_Position_Category_ApiArgs = {
  name: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Organization_Position_FamilyArgs = {
  input: CentralizedPositionsCreateOrganizationPositionFamilyInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Organization_Position_LevelArgs = {
  input: CentralizedPositionsCreateOrganizationPositionLevelInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Payment_Gateway_ConfigArgs = {
  data: CreatePaymentGatewayConfigInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Payment_Gateway_Org_ConfigArgs = {
  data: CreatePaymentGatewayOrgConfigInput;
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Permission_GroupArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
  permissions_config: Array<PermissionInput>;
  user_role?: InputMaybe<PermissionUserOrganizationRole>;
  users_email: Array<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Product_CategoryArgs = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_slug: Scalars['String']['input'];
  original_id?: InputMaybe<Scalars['ID']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Questions_With_OpenaiArgs = {
  course_id: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  questions_for_all_classes?: InputMaybe<Scalars['Boolean']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Quiz_With_OpenaiArgs = {
  course_id: Scalars['Int']['input'];
  questions_for_all_classes?: InputMaybe<Scalars['Boolean']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Reading_DocumentArgs = {
  input: CreateReadingDocumentInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_RewardArgs = {
  activation_date?: InputMaybe<Scalars['DateTime']['input']>;
  cover_attachment_id?: InputMaybe<Scalars['Int']['input']>;
  currency_point_id: Scalars['ID']['input'];
  currency_point_value?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  money_value?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  organization_id?: InputMaybe<Scalars['ID']['input']>;
  organization_slug?: InputMaybe<Scalars['String']['input']>;
  redemptions_allowed?: InputMaybe<Scalars['Int']['input']>;
  status_enum: RewardStatusEnum;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Super_Admin_RoleArgs = {
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Team_ConditionalsArgs = {
  conditionals: Array<GenericTeamConditionalInput>;
  organization_team_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Team_HeaderArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  input: CreationTeamHeaderInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_TeamsArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  input: Array<CreationTeamInput>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Template_DocumentArgs = {
  input: CreateTemplateDocumentInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_TransactionArgs = {
  organization_slug?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  related_transaction_id?: InputMaybe<Scalars['ID']['input']>;
  reward_id: Scalars['ID']['input'];
  transaction_status_enum: TransactionStatusEnum;
  transaction_type_enum: TransactionTypeEnum;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_UserArgs = {
  email: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_User_DeviceArgs = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  device: Scalars['String']['input'];
  device_identifier: Scalars['String']['input'];
  firebase_instance_id?: InputMaybe<Scalars['String']['input']>;
  last_active?: InputMaybe<Scalars['DateTime']['input']>;
  platform: Scalars['String']['input'];
  sdk_version?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  user_device_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Video_ProcessArgs = {
  input: CreateVideoProcessInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Workbeat_User_EnterpriseArgs = {
  user_id: Scalars['Int']['input'];
  workbeat_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_WorkflowArgs = {
  input: CreateWorkFlowInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationCreate_Workflow_DetailArgs = {
  input: CreateWorkflowDetail;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDeactivate_Message_RatingArgs = {
  chat_message_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDeactivate_NotificationArgs = {
  notification_id: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDeactivate_Organization_HeadquarterArgs = {
  headquarter_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDeactivate_Organization_PositionArgs = {
  input: CentralizedPositionsDeactivateOrganizationPositionInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDeactivate_Permission_GroupArgs = {
  organization_slug: Scalars['String']['input'];
  permission_group_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDeactivate_UserArgs = {
  organization_slug: Scalars['String']['input'];
  user_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDeactivate_UsersArgs = {
  input: DeactivateUsersInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDeactivate_Users_DocumentArgs = {
  input: DeactivateUserDocumentInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDelete_Copilot_ConversationArgs = {
  input: DeleteConversationInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDelete_Course_In_Team_OrganizationArgs = {
  input_type: DeleteCourseInTeamOrganizationInput;
  organization_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDelete_Currency_PointArgs = {
  currency_point_id: Scalars['ID']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDelete_Custom_FieldArgs = {
  custom_field_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDelete_DocumentArgs = {
  input: DeleteDocumentInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDelete_End_User_DocumentArgs = {
  input: DeleteEndUserDocumentInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDelete_FolderArgs = {
  input: DeleteFolderInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDelete_Higher_Education_Team_ProductArgs = {
  organization_slug: Scalars['String']['input'];
  products_id?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDelete_Organization_AreaArgs = {
  input: DeleteOrganizationAreaInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDelete_Organization_AreasArgs = {
  input: DeleteOrganizationAreasInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDelete_Organization_TeamArgs = {
  input_type: DeleteOrganizationTeamInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDelete_RewardArgs = {
  organization_id?: InputMaybe<Scalars['ID']['input']>;
  organization_slug?: InputMaybe<Scalars['String']['input']>;
  reward_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDelete_TeamArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  organization_team_ids: Array<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDelete_Team_MemberArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  input: Array<TeamMemberInput>;
  organization_team_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDelete_User_Custom_Field_AnswerArgs = {
  custom_field_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
  user_ids: Array<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDelete_User_In_Team_OrganizationArgs = {
  input: DeleteUserInTeamOrganizationInput;
  organization_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationDelete_WorkflowArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  delete_pending_tasks?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_ids: Array<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationEbanx_Direct_PaymentArgs = {
  data: EbanxDirectPaymentInput;
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationEdit_DocumentArgs = {
  input: EditDocumentInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationEdit_End_User_DocumentArgs = {
  input: EditEndUserDocumentInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationEdit_FolderArgs = {
  input: EditFolderInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationEdit_RewardArgs = {
  activation_date?: InputMaybe<Scalars['DateTime']['input']>;
  cover_attachment_id?: InputMaybe<Scalars['Int']['input']>;
  currency_point_value?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  money_value?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['ID']['input']>;
  organization_slug?: InputMaybe<Scalars['String']['input']>;
  redemptions_allowed?: InputMaybe<Scalars['Int']['input']>;
  reward_id: Scalars['ID']['input'];
  status_enum?: InputMaybe<RewardStatusEnum>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationEdit_User_Document_DeadlineArgs = {
  input: EditUserDocumentDeadlineInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationEpayco_Cc_PaymentArgs = {
  data: EpaycoCcPaymentInput;
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationEpayco_Pse_PaymentArgs = {
  data: EpaycoPsePaymentInput;
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationExport_Organization_Positions_ExcelArgs = {
  input: ExportOrganizationPositionsInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationGenerate_Attachment_Upload_UrlArgs = {
  file_name: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationGenerate_Centralized_Users_ReportArgs = {
  email: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationGenerate_Custom_Field_TemplatesArgs = {
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationGenerate_Custom_Upload_TemplateArgs = {
  organization_slug: Scalars['String']['input'];
  template_type: TemplateType;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationGenerate_Datafast_Checkout_IdArgs = {
  data: GenerateDatafastCheckoutIdInput;
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationGenerate_Invitation_LinkArgs = {
  input: GenerateInvitationLinkInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationGenerate_Position_DescriptionArgs = {
  input: GeneratePositionDescriptionInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationGenerate_Position_KeywordsArgs = {
  input: GeneratePositionKeywordsInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationGenerate_Pre_Signed_Url_ImageArgs = {
  content_type: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
  upload_to?: InputMaybe<UploadToEnum>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationGenerate_QuizArgs = {
  text_to_transcript: Scalars['String']['input'];
  video_lecture_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationGenerate_Template_Document_PdfArgs = {
  input: GenerateTemplateDocumentPdfInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationGenerate_Track_CertificateArgs = {
  input: GenerateTrackCertificateInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationGeocode_AddressArgs = {
  input: CompassMapsGeocodeAddressInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationGeocode_By_Place_IdArgs = {
  input: CompassMapsGeocodeByPlaceIdInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationGet_Crehana_SessionArgs = {
  session_key: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationManage_Organization_AreasArgs = {
  input: ManageOrganizationAreaInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationMark_Notification_As_ReadArgs = {
  user_notification_id: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationMarketplace_Clients_ReportArgs = {
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationMarketplace_Flywire_Tokenize_DataArgs = {
  data: FlywireTokenizeDataInput;
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationMarketplace_Flywire_Validate_Payment_OrderArgs = {
  data: FlywireValidatePaymentOrderInput;
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationMarketplace_Update_Product_Is_DraftArgs = {
  data: UpdateProductIsDraftInput;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationMigrate_Learning_Custom_FieldsArgs = {
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationMultiple_Assign_CategoriesArgs = {
  input: MultipleAssignCategories;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationMultiple_Delete_ContentArgs = {
  input: MultipleDeleteContent;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationMultiple_Update_Content_VisibilityArgs = {
  input: MultipleUpdateContentVisibility;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationNormalize_Custom_Field_OptionsArgs = {
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationNormalize_Users_Incorporation_DateArgs = {
  input: NormalizeUsersWithoutIncorporationDateInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationOpenai_ConversationArgs = {
  input?: InputMaybe<OpenAiConversationInput>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationPending_Transactions_EmailsArgs = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationProcess_Marketplace_Failed_Product_OrderArgs = {
  data: ProcessMarketplaceFailedProductOrderInput;
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationProcess_Marketplace_Paid_Product_OrderArgs = {
  data: ProcessMarketplacePaidProductOrderInput;
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationPublish_Higher_Education_Team_ProductArgs = {
  product: PublishHigherEducationTeamProductInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationQuick_EnrollArgs = {
  data: QuickEnrollInput;
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationReactivate_Deleted_UserArgs = {
  input: ReactivateUserInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationRecover_PasswordArgs = {
  email: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationRegenerate_User_Upload_TemplateArgs = {
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationRegister_User_EventArgs = {
  custom_event_id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  student_ids: Array<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationRemove_Course_Higher_Education_TeamArgs = {
  remove_input: RemoveCourseHigherEducationTeamInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationRemove_Marketplace_UserArgs = {
  marketplace_user_product_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationRemove_Selected_CandidateArgs = {
  input: RemoveSelectedCandidateInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationRemove_User_Admin_RoleArgs = {
  organization_slug: Scalars['String']['input'];
  user_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationRemove_Users_From_Permission_GroupArgs = {
  organization_slug: Scalars['String']['input'];
  permission_group_id: Scalars['Int']['input'];
  users_email: Array<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationRequest_Free_TrialArgs = {
  organization_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationRequest_HanaArgs = {
  organization_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationReverse_GeocodeArgs = {
  input: CompassMapsReverseGeocodeInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationRun_Certificate_Expiration_JobArgs = {
  input: RunCertificateExpirationJobInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationSave_Invoice_DataArgs = {
  invoice_data: InvoiceDataInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationSave_Massive_Document_AssignmentArgs = {
  input: SaveMassiveAssignmentDocumentInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationSave_Massive_Folder_AssignmentArgs = {
  input: SaveMassiveAssignmentFolderInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationSelect_Succession_CandidateArgs = {
  input: SelectSuccessionCandidateInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationSend_User_Email_ActivationArgs = {
  activation_info: UserActivationInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationSend_User_Email_InvitationArgs = {
  organization_slug: Scalars['String']['input'];
  users_emails: Array<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationSend_User_Email_Invitation_OrganizationArgs = {
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationSet_Deactivation_DateArgs = {
  input: SetDeactivationDateInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationSet_Talent_UserArgs = {
  chunk_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
  talent_users: Array<SetTalentInput>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationSet_Track_Course_Coming_SoonArgs = {
  input: SetTrackCourseComingSoonInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationStart_Massive_Active_UserArgs = {
  file_url: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationStart_Massive_Change_PasswordArgs = {
  file_url: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationStart_Massive_Permission_Group_User_AssignmentArgs = {
  file_url: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
  permission_group_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationStart_Massive_Position_CreationArgs = {
  input: StartMassiveOrganizationPositionsInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationStart_Massive_User_BatchArgs = {
  batch_mode?: BatchMode;
  file_url: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
  send_invitation?: Scalars['Boolean']['input'];
  suite_codes?: InputMaybe<Array<Scalars['String']['input']>>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationStart_Massive_User_CreationArgs = {
  file_url: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
  send_invitation?: Scalars['Boolean']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationStart_Massive_User_DeactivationArgs = {
  file_url: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
  send_invitation?: Scalars['Boolean']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationSync_Custom_Fields_From_CentralizedArgs = {
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationSync_Custom_Fields_From_LearningArgs = {
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationSync_Position_Evaluation_IndicatorsArgs = {
  input: SyncPositionEvaluationIndicatorsInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationSync_Users_Without_Internal_IdArgs = {
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationSynchronize_User_Avatar_From_LearningArgs = {
  input: SynchronizeUserAvatarFromLearningInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTestArgs = {
  input: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Activate_PolicyArgs = {
  input: ActivatePolicyInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Apply_Bulk_ImportArgs = {
  input: ApplyBulkImportInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Approve_RequestArgs = {
  input: ApproveRequestInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Assign_User_Policy_Balance_LogArgs = {
  input: AssignUserPolicyBalanceLogInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Attach_Request_FileArgs = {
  input: AttachRequestFileInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Bulk_Import_Policy_BalanceArgs = {
  input: BulkImportPolicyBalanceInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Create_Approved_RequestArgs = {
  input: CreateRequestInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Create_HolidayArgs = {
  input: CreateHolidayInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Create_PolicyArgs = {
  input: CreatePolicyInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Create_Policy_V2Args = {
  input: CreatePolicyV2Input;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Create_RequestArgs = {
  input: CreateRequestInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Create_Request_CommentArgs = {
  input: CreateRequestCommentInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Create_Request_Notification_LogArgs = {
  input: CreateRequestNotificationLogInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Create_Request_Notification_LogsArgs = {
  input: CreateRequestNotificationLogsInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Deactivate_PolicyArgs = {
  input: ActivatePolicyInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Delete_HolidayArgs = {
  input: DeleteHolidayInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Delete_HolidaysArgs = {
  input: DeleteHolidaysInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Delete_PolicyArgs = {
  input: DeletePolicyInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Delete_RequestArgs = {
  input: DeleteRequestInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Deny_RequestArgs = {
  input: DenyRequestInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Detach_Request_FileArgs = {
  input: DetachRequestFileInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Duplicate_PolicyArgs = {
  input: DuplicatePolicyInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Import_Policy_BalanceArgs = {
  input: ImportPolicyBalanceInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Manage_User_Policy_Balance_LogArgs = {
  input: ManageUserPolicyBalanceLogInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Massive_Update_User_Policy_Balance_LogsArgs = {
  input: MassiveManageUserPolicyBalanceLogsInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Recalculate_Incorporation_Date_BalanceArgs = {
  input: RecalculateIncorporationDateBalanceInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Resolve_Request_StatusArgs = {
  input: ResolveRequestStatusInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Resolve_Users_PolicyArgs = {
  input: ResolvePolicyInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Restore_Bulk_ImportArgs = {
  input: RestoreBulkImportInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Skip_Request_ApprovalArgs = {
  input: SkipRequestApprovalInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Sync_Organization_Policy_BalanceArgs = {
  input: SyncOrganizationPolicyBalanceInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Sync_User_Policy_BalanceArgs = {
  input: SyncUserPolicyBalanceInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Update_HolidayArgs = {
  input: UpdateHolidayInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Update_PolicyArgs = {
  input: UpdatePolicyInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTimeoff_Update_Policy_V2Args = {
  input: UpdatePolicyV2Input;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationTrigger_Close_Routes_By_DeadlineArgs = {
  input: TriggerCloseRoutesByDeadlineInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUnassign_User_Organization_AreaArgs = {
  organization_slug: Scalars['String']['input'];
  user_ids: Array<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_AchievementsArgs = {
  achievement_set: Array<InputMaybe<CurrencyAchievementUpdateInput>>;
  currency_point_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_AvatarArgs = {
  input: UpdateUserAvatarInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Class_NoteArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Configuration_Area_And_HeadquarterArgs = {
  organization_area_levels?: InputMaybe<Array<UpdateConfigurationAreaInput>>;
  organization_headquarter?: InputMaybe<UpdateConfigurationHeadquarterInput>;
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Content_By_CourseArgs = {
  input: UpdateContentByCourseInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Copilot_ConversationArgs = {
  input: UpdateConversationInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Currency_PointArgs = {
  currency_point_body: CurrencyPointUpdateInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Currency_Point_Setting_DoneArgs = {
  original_id: Scalars['Int']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Custom_FieldArgs = {
  custom_field: UpdateCustomFieldInput;
  custom_field_choices?: InputMaybe<Array<UpdateCustomFieldChoiceInput>>;
  custom_field_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Custom_Field_ApiArgs = {
  custom_field: UpdateCustomFieldInput;
  custom_field_choices?: InputMaybe<Array<UpdateCustomFieldChoiceInput>>;
  custom_field_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Custom_Field_Filter_GroupArgs = {
  filter_group: LearningCustomFieldFilterGroupUpdateInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_EventsArgs = {
  currency_point_id: Scalars['ID']['input'];
  event_set: Array<InputMaybe<CurrencyEventUpdateInput>>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Initial_SetupArgs = {
  original_id: Scalars['Int']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Marketplace_ConfigArgs = {
  config: MarketplaceConfigInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_NotificationArgs = {
  category_id?: InputMaybe<Scalars['String']['input']>;
  has_problem?: InputMaybe<Scalars['Boolean']['input']>;
  icon_image?: InputMaybe<Scalars['String']['input']>;
  in_app_event?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  notification_id: Scalars['String']['input'];
  platforms?: InputMaybe<Array<Scalars['String']['input']>>;
  redirect_url?: InputMaybe<Scalars['String']['input']>;
  redirect_url_name?: InputMaybe<Scalars['String']['input']>;
  subcategory_id?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_OrganizationArgs = {
  organization: UpdateOrganization;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Organization_AreaArgs = {
  input: UpdateOrganizationAreaInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Organization_Area_LevelArgs = {
  organization_area_level: UpdateOrganizationAreaLevelInput;
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Organization_HeadquarterArgs = {
  headquarter: UpdateHeadquarterInput;
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Organization_Menu_CustomizationArgs = {
  input: UpdateMenuCustomizationInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Organization_PositionArgs = {
  input: CentralizedPositionsUpdateOrganizationPositionInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Organization_Position_CategoryArgs = {
  input: CentralizedPositionsUpdateOrganizationPositionCategoryInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Organization_Team_Course_OrderArgs = {
  input: OrganizationTeamCourseInputList;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Organization_Tenant_BrandingArgs = {
  input: UpdateOrganizationTenantBrandingMutationInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Permission_GroupArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_slug: Scalars['String']['input'];
  permission_group_id: Scalars['Int']['input'];
  permissions_config?: InputMaybe<Array<PermissionInput>>;
  users_email?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Personalization_OrganizationArgs = {
  personalization: PersonalizationInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Team_HeaderArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  input: UpdateTeamHeaderInput;
  organization_team_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Template_DocumentArgs = {
  input: UpdateTemplateDocumentInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_User_Custom_FieldsArgs = {
  custom_fields: Array<UpdateUserCustomFieldInput>;
  organization_slug: Scalars['String']['input'];
  user_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_User_EmailArgs = {
  new_email: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
  user_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_User_Event_BankArgs = {
  event_type_enum?: InputMaybe<EventTypeEnum>;
  object_id?: InputMaybe<Scalars['Int']['input']>;
  object_type?: InputMaybe<ObjectTypeEnum>;
  organization_slug?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_User_InfoArgs = {
  input: UpdateUserInfoInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_Video_ProcessArgs = {
  input: UpdateVideoProcessInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpdate_WorkflowArgs = {
  input: UpdateWorkFlowInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpload_File_Import_InfoArgs = {
  file_info: UsersUploadUrl;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUpload_File_User_Application_DocumentArgs = {
  input: UploadFileUserApplicationDocumentInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUser_Password_UpdateArgs = {
  user_info: UserPasswordUpdateInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUser_Recover_PasswordArgs = {
  user_info: UserRecoverPasswordInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUser_Team_AssignmentArgs = {
  input: AssignUserTeamCreationInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationUser_Team_DeactivationArgs = {
  input: DeactivateUserTeamInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_And_Generate_Track_CertificateArgs = {
  input: ValidateAndGenerateTrackCertificateInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_Change_Password_Excel_FileArgs = {
  file_url: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_Change_Password_Excel_File_V2Args = {
  file_url: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_Manual_Permission_Group_User_AssignmentArgs = {
  emails: Array<Scalars['String']['input']>;
  organization_slug: Scalars['String']['input'];
  permission_group_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_Massive_Create_Organization_Positions_ExcelArgs = {
  input: ValidateMassiveOrganizationPositionsExcelInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_Massive_Create_User_Excel_FileArgs = {
  file_url: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_Massive_Create_User_Excel_V2Args = {
  file_url: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_Massive_Creation_Team_MembersArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  file_url: Scalars['String']['input'];
  organization_team_id?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_Massive_Creation_TeamsArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  file_url: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_Massive_Deactivate_User_Excel_FileArgs = {
  file_url: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_Massive_Document_AssignmentArgs = {
  input: ValidateMassiveAssignmentDocumentInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_Massive_Folder_AssignmentArgs = {
  input: ValidateMassiveAssignmentFolderInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_Massive_Organization_Area_Excel_FileArgs = {
  file_url: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_Massive_Permission_Group_User_Assignment_Excel_FileArgs = {
  file_url: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_Massive_User_BatchArgs = {
  batch_mode?: BatchMode;
  file_url: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
  suite_codes?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_Organization_AreaArgs = {
  input: ValidateAreaInput;
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_Payment_Order_DatafastArgs = {
  data: ValidatePaymentOrderDatafastInput;
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_Team_NameArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE MUTATIONS */
export type MutationValidate_User_Team_AssignmentArgs = {
  input: ValidateUserTeamAssignmentInput;
};

export type MutationApplicantBlockedEmailExistsError = {
  __typename?: 'MutationApplicantBlockedEmailExistsError';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type MutationApplicantEmailExistsError = {
  __typename?: 'MutationApplicantEmailExistsError';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type MutationApplicantInvalidLinkedinError = {
  __typename?: 'MutationApplicantInvalidLinkedinError';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type MutationAssigmentUserInput = {
  disallowed_user_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  organization_id: Scalars['String']['input'];
  user_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type MutationBulkUploadEmptyFileError = {
  __typename?: 'MutationBulkUploadEmptyFileError';
  bulk_upload_id?: Maybe<Scalars['ID']['output']>;
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type MutationBulkUploadInvalidHeaderError = {
  __typename?: 'MutationBulkUploadInvalidHeaderError';
  bulk_upload_id?: Maybe<Scalars['ID']['output']>;
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type MutationBulkUploadLongerFileError = {
  __typename?: 'MutationBulkUploadLongerFileError';
  bulk_upload_id?: Maybe<Scalars['ID']['output']>;
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type MutationBulkUploadValidationError = {
  __typename?: 'MutationBulkUploadValidationError';
  bulk_upload_id?: Maybe<Scalars['ID']['output']>;
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type MutationCompanyTagError = {
  __typename?: 'MutationCompanyTagError';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type MutationCurrencyPointInput = {
  allow_all_users?: InputMaybe<Scalars['Boolean']['input']>;
  initial_setup?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['String']['input'];
  original_id?: InputMaybe<Scalars['String']['input']>;
  setup_completed?: InputMaybe<Scalars['Boolean']['input']>;
  status_enum?: InputMaybe<CurrencyPointStatusEnum>;
};

export type MutationCurrencyPoints = {
  __typename?: 'MutationCurrencyPoints';
  /** This resource is responsible for adding players to gamification and marking certain attributes within its configuration. */
  create_allowed_users: CurrencyPointFragmentNode;
  /** This resource is responsible for creating a custom event (achievement) for gamification. */
  create_custom_event: CurrencyEventFragmentNode;
  /** This resource is responsible for performing multiple edits on the currency point model. Some of the editable fields include: Name or status, initial_setup, setup_completed, and deleted_at, which refers to the logical deletion of the object. */
  edit_currency_point: CurrencyPointFragmentNode;
  /** This resource is responsible for editing achievements and events during the initial setup of the playroom. */
  edit_events: SetCurrencyEventFragmentNode;
  /** This resource displays the associated currency point for the organization. It supports fragments for standard users, admin users, and staff users. */
  new_gamification: CurrencyPointFragmentNode;
};


export type MutationCurrencyPointsCreate_Allowed_UsersArgs = {
  mutation_variables: AllowedUserMutationCreateInput;
};


export type MutationCurrencyPointsCreate_Custom_EventArgs = {
  mutation_variables: CustomCurrencyEventMutationEditInput;
};


export type MutationCurrencyPointsEdit_Currency_PointArgs = {
  mutation_variables: CurrencyPointMutationEditInput;
};


export type MutationCurrencyPointsEdit_EventsArgs = {
  mutation_variables: CurrencyEventMutationEditInput;
};


export type MutationCurrencyPointsNew_GamificationArgs = {
  mutation_variables: CurrencyPointMutationCreateInput;
};

export type MutationDiscardStageActionError = {
  __typename?: 'MutationDiscardStageActionError';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type MutationError = {
  error_code?: Maybe<ErrorCode>;
  error_message?: Maybe<Scalars['String']['output']>;
};

export type MutationErrorResponse = {
  __typename?: 'MutationErrorResponse';
  message: Scalars['String']['output'];
};

export type MutationExcelInput = {
  organization_id: Scalars['String']['input'];
};

export type MutationIntegrityExistsError = {
  __typename?: 'MutationIntegrityExistsError';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type MutationInternalError = {
  __typename?: 'MutationInternalError';
  errors: Array<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
};

/** Legacy error type - prefer InternalErrorV2 */
export type MutationInternalExistsError = {
  __typename?: 'MutationInternalExistsError';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type MutationJobApplicantProfileVacancyTagError = {
  __typename?: 'MutationJobApplicantProfileVacancyTagError';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type MutationJobVacancyNoHiresError = {
  __typename?: 'MutationJobVacancyNoHiresError';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type MutationJobVacancyParticipantsExceededError = {
  __typename?: 'MutationJobVacancyParticipantsExceededError';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

/** This class is responsible for grouping all the mutations corresponding to the leaderboard app into the same class. */
export type MutationLeaderboard = {
  __typename?: 'MutationLeaderboard';
  /** Sets the notification_seen field to True */
  edit_notification_seen: NotificationSeenFragmentNode;
};


/** This class is responsible for grouping all the mutations corresponding to the leaderboard app into the same class. */
export type MutationLeaderboardEdit_Notification_SeenArgs = {
  mutation_variables: UserEventBankEditInput;
};

export type MutationRequisitionIdentifierError = {
  __typename?: 'MutationRequisitionIdentifierError';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

/** This class is responsible for grouping all the mutations corresponding to the reward app into the same class. */
export type MutationRewards = {
  __typename?: 'MutationRewards';
  /** This resource allows administrators and staff users to edit rewards for their organization (ADMIN) or any organization (STAFF). */
  delete_reward: RewardFragmentNode;
  /** This resource allows administrators and staff users to edit rewards for their organization (ADMIN) or any organization (STAFF). */
  edit_reward: RewardFragmentNode;
  /** This resource allows the admin to bulk approve pending transactions */
  new_bulk_reward_transactions: BulkRewardTransactionFragmentNode;
  /** This resource allows administrators and staff users to create rewards for their organization (ADMIN) or any organization (STAFF). */
  new_reward: RewardFragmentNode;
  /** This resource allows all organization users to perform transactions. Admins can perform stock transactions, reward adjustment and approval transactions. Admins can also perform redemption transactions. Non-admin users can only perform redemption actions. */
  new_reward_transaction: RewardTransactionFragmentNode;
};


/** This class is responsible for grouping all the mutations corresponding to the reward app into the same class. */
export type MutationRewardsDelete_RewardArgs = {
  mutation_variables: RewardMutationDeleteInput;
};


/** This class is responsible for grouping all the mutations corresponding to the reward app into the same class. */
export type MutationRewardsEdit_RewardArgs = {
  mutation_variables: RewardMutationEditInput;
};


/** This class is responsible for grouping all the mutations corresponding to the reward app into the same class. */
export type MutationRewardsNew_Bulk_Reward_TransactionsArgs = {
  mutation_variables: RewardTransactionBulkCreateInput;
};


/** This class is responsible for grouping all the mutations corresponding to the reward app into the same class. */
export type MutationRewardsNew_RewardArgs = {
  mutation_variables: RewardMutationCreateInput;
};


/** This class is responsible for grouping all the mutations corresponding to the reward app into the same class. */
export type MutationRewardsNew_Reward_TransactionArgs = {
  mutation_variables: RewardTransactionCreateInput;
};

export type MutationValidationError = {
  __typename?: 'MutationValidationError';
  errors: Array<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
};

export type MutationValidationErrorResponse = {
  __typename?: 'MutationValidationErrorResponse';
  errors: Array<Scalars['String']['output']>;
};

/** Legacy error type - prefer ValidationErrorV2 */
export type MutationValidationExistsError = {
  __typename?: 'MutationValidationExistsError';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type MutationsGamification = {
  __typename?: 'MutationsGamification';
  create_or_update_game: PrivateCurrencyPointFragment;
  leaderboard_excel_report: PrivateExcelReportFragment;
  progressive_assignment_of_players: PrivateLeaderboardListType;
};


export type MutationsGamificationCreate_Or_Update_GameArgs = {
  input: MutationCurrencyPointInput;
};


export type MutationsGamificationLeaderboard_Excel_ReportArgs = {
  input: MutationExcelInput;
};


export type MutationsGamificationProgressive_Assignment_Of_PlayersArgs = {
  input: MutationAssigmentUserInput;
};

export type MyAssignedCourseInfo = {
  __typename?: 'MyAssignedCourseInfo';
  course_type?: Maybe<CourseTypeEnum>;
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  is_certified?: Maybe<Scalars['Boolean']['output']>;
  player_url?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
};

/** An edge in a connection. */
export type MyAssignedCourseInfoEdge = {
  __typename?: 'MyAssignedCourseInfoEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: MyAssignedCourseInfo;
};

export type MyAssignedCourseInfoV2 = {
  __typename?: 'MyAssignedCourseInfoV2';
  course_type?: Maybe<CourseTypeEnum>;
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  is_certified?: Maybe<Scalars['Boolean']['output']>;
  player_url?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
};

export type MyAssignedCourseInfoV2Connection = {
  __typename?: 'MyAssignedCourseInfoV2Connection';
  /** A list of edges in this connection. */
  edges: Array<MyAssignedCourseInfoV2Edge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type MyAssignedCourseInfoV2ConnectionQueryValidationErrorQueryInternalError = MyAssignedCourseInfoV2Connection | QueryInternalError | QueryValidationError;

export type MyAssignedCourseInfoV2Edge = {
  __typename?: 'MyAssignedCourseInfoV2Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MyAssignedCourseInfoV2;
};

export type MyAssignedCourseList = {
  __typename?: 'MyAssignedCourseList';
  courses_started?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the nodes in this connection */
  edges: Array<MyAssignedCourseInfoEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type MyAssignedCourseResponse = FoundationHomeUserIntegrityError | FoundationHomeUserInternalError | FoundationHomeUserValidationError | MyAssignedCourseList;

export type MyAssignedCoursesInput = {
  pagination: PaginationInput;
  search?: InputMaybe<SearchInput>;
};

export type MyAssignedCoursesInputV2 = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<SearchInput>;
};

export type MyAssignedPathsInput = {
  pagination: PaginationInput;
  search?: InputMaybe<SearchInput>;
};

export type MyLearningPathInfo = {
  __typename?: 'MyLearningPathInfo';
  deadline?: Maybe<Scalars['String']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type MyLearningPathInfoEdge = {
  __typename?: 'MyLearningPathInfoEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: MyLearningPathInfo;
};

export type MyLearningPathList = {
  __typename?: 'MyLearningPathList';
  /** Contains the nodes in this connection */
  edges: Array<MyLearningPathInfoEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  path_started?: Maybe<Scalars['Boolean']['output']>;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type MyLearningPathResponse = FoundationHomeUserIntegrityError | FoundationHomeUserInternalError | FoundationHomeUserValidationError | MyLearningPathList;

export type MyTeamFilterInput = {
  company_id: Scalars['Int']['input'];
  division_ids?: InputMaybe<Scalars['String']['input']>;
  employee_id: Scalars['Int']['input'];
  job_ids?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_delivered?: InputMaybe<Scalars['String']['input']>;
  order_requested?: InputMaybe<Scalars['String']['input']>;
};

export type MyTeamResume = {
  __typename?: 'MyTeamResume';
  count_face_delivered: Scalars['Int']['output'];
  count_face_received: Scalars['Int']['output'];
  count_face_to_face: Scalars['Int']['output'];
  count_writing: Scalars['Int']['output'];
  count_writing_delivered: Scalars['Int']['output'];
  count_writing_received: Scalars['Int']['output'];
};

export type MyUserNode = {
  __typename?: 'MyUserNode';
  _email: Scalars['String']['output'];
  /** Mask email */
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  last_name: Scalars['String']['output'];
  organization_id?: Maybe<Scalars['Int']['output']>;
  profile_picture_url?: Maybe<ImageNode>;
  username: Scalars['String']['output'];
};

export type NcChannel = {
  __typename?: 'NCChannel';
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
  status: NcNotificationChannelStatus;
};

export enum NcChannelSlug {
  Email = 'EMAIL',
  InApp = 'IN_APP',
  Sms = 'SMS',
  Web = 'WEB'
}

export type NcGetChannelsInput = {
  /** Centralized organization id */
  centralized_organization_id: Scalars['ID']['input'];
};

export type NcGetChannelsPayload = {
  __typename?: 'NCGetChannelsPayload';
  channels: Array<NcChannel>;
};

export type NcGetChannelsPayloadResponseInternalErrorResponseValidationErrorResponseIntegrityError = NcGetChannelsPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type NcGetNotificationTemplateInput = {
  /** Centralized organization id */
  centralized_organization_id: Scalars['ID']['input'];
  channel_slug: NcChannelSlug;
  /** Template id */
  template_id: Scalars['ID']['input'];
};

export type NcGetNotificationTemplatePayload = {
  __typename?: 'NCGetNotificationTemplatePayload';
  template: NcNotificationEmailTemplateNcNotificationWebTemplateNcNotificationInAppTemplateNcNotificationSmsTemplate;
};

export type NcGetNotificationTemplatePayloadResponseInternalErrorResponseValidationErrorResponseIntegrityError = NcGetNotificationTemplatePayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type NcGetOrganizationNotificationInput = {
  /** Centralized organization id */
  centralized_organization_id: Scalars['ID']['input'];
  channel_slug: NcChannelSlug;
  /** Notification slug */
  notification_slug: Scalars['String']['input'];
};

export type NcGetOrganizationNotificationPayload = {
  __typename?: 'NCGetOrganizationNotificationPayload';
  notification_config?: Maybe<NcNotificationConfig>;
};

export type NcGetOrganizationNotificationPayloadResponseInternalErrorResponseValidationErrorResponseIntegrityError = NcGetOrganizationNotificationPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type NcGetOrganizationNotificationsFilterInput = {
  /** Filter by notification channel slug */
  channel_slug?: InputMaybe<NcChannelSlug>;
  /** Filter by notification is active */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by notification product id */
  product_id?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by notification product module id */
  product_module_id?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by notification slug */
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type NcGetOrganizationNotificationsInput = {
  /** Centralized organization id */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filter fields */
  filter?: InputMaybe<NcGetOrganizationNotificationsFilterInput>;
  /** Pagination fields */
  pagination?: InputMaybe<NcPaginationInput>;
  /** We can search across name, slug, description */
  search?: InputMaybe<NcSearchInput>;
  /** Sort fields */
  sort?: InputMaybe<NcGetOrganizationNotificationsSortInput>;
};

export type NcGetOrganizationNotificationsPayload = {
  __typename?: 'NCGetOrganizationNotificationsPayload';
  has_next: Scalars['Boolean']['output'];
  has_previous: Scalars['Boolean']['output'];
  notifications: Array<NcNotification>;
  page: Scalars['Int']['output'];
  page_size: Scalars['Int']['output'];
  total_count: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type NcGetOrganizationNotificationsPayloadResponseInternalErrorResponseValidationErrorResponseIntegrityError = NcGetOrganizationNotificationsPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type NcGetOrganizationNotificationsSortInput = {
  /** Sort by notification direction */
  direction?: InputMaybe<NcSortDirection>;
  /** Sort by notification field */
  field?: InputMaybe<NcSortField>;
};

export type NcNotification = {
  __typename?: 'NCNotification';
  channels: NcNotificationChannels;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Notification product id */
  product_id?: Maybe<Scalars['ID']['output']>;
  /** Notification product module id */
  product_module_id?: Maybe<Scalars['ID']['output']>;
  slug: Scalars['String']['output'];
};

export type NcNotificationChannel = {
  __typename?: 'NCNotificationChannel';
  id: Scalars['Int']['output'];
  slug: NcChannelSlug;
  status: NcNotificationChannelStatus;
  template_id?: Maybe<Scalars['Int']['output']>;
};

export type NcNotificationChannelEmail = {
  __typename?: 'NCNotificationChannelEmail';
  id: Scalars['Int']['output'];
  slug: NcChannelSlug;
  status: NcNotificationChannelStatus;
  template?: Maybe<NcNotificationEmailTemplate>;
  template_id?: Maybe<Scalars['Int']['output']>;
};

export enum NcNotificationChannelStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  NotSupported = 'NOT_SUPPORTED'
}

export type NcNotificationChannels = {
  __typename?: 'NCNotificationChannels';
  email: NcNotificationChannelEmail;
  in_app: NcNotificationChannel;
  sms: NcNotificationChannel;
  web: NcNotificationChannel;
};

export type NcNotificationConfig = {
  __typename?: 'NCNotificationConfig';
  channel_slug: NcChannelSlug;
  /** ID of the notification that belongs to this configuration */
  id: Scalars['ID']['output'];
  notification_slug: Scalars['String']['output'];
  status: NcNotificationChannelStatus;
};

export type NcNotificationEmailTemplate = {
  __typename?: 'NCNotificationEmailTemplate';
  created_at: Scalars['DateTime']['output'];
  /** Detail url to navigate to the template */
  detail_url?: Maybe<Scalars['String']['output']>;
  /** Edit url to navigate to the template */
  edit_url?: Maybe<Scalars['String']['output']>;
  /** Based on the channel slug, this will be html or text */
  html_content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type NcNotificationEmailTemplateNcNotificationWebTemplateNcNotificationInAppTemplateNcNotificationSmsTemplate = NcNotificationEmailTemplate | NcNotificationInAppTemplate | NcNotificationSmsTemplate | NcNotificationWebTemplate;

export type NcNotificationInAppTemplate = {
  __typename?: 'NCNotificationInAppTemplate';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type NcNotificationSmsTemplate = {
  __typename?: 'NCNotificationSmsTemplate';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type NcNotificationWebTemplate = {
  __typename?: 'NCNotificationWebTemplate';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type NcPaginationInput = {
  /** Page number (1-based) */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Items per page */
  page_size?: InputMaybe<Scalars['Int']['input']>;
};

export type NcSearchInput = {
  query: Scalars['String']['input'];
};

export enum NcSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum NcSortField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type NcUpdateOrCreateNotificationBulkInput = {
  /** Centralized organization id */
  centralized_organization_id: Scalars['ID']['input'];
  /** List of notifications to update or create */
  notifications: Array<NcUpdateOrCreateNotificationInputBase>;
};

export type NcUpdateOrCreateNotificationBulkPayload = {
  __typename?: 'NCUpdateOrCreateNotificationBulkPayload';
  message: Scalars['String']['output'];
  notifications: Array<NcUpdateOrCreateNotificationPayload>;
};

export type NcUpdateOrCreateNotificationBulkPayloadResponseInternalErrorResponseValidationErrorResponseIntegrityError = NcUpdateOrCreateNotificationBulkPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type NcUpdateOrCreateNotificationInput = {
  /** Centralized organization id */
  centralized_organization_id: Scalars['ID']['input'];
  channel_slug: NcChannelSlug;
  /** Notification id */
  notification_id: Scalars['ID']['input'];
  status: NcNotificationChannelStatus;
};

export type NcUpdateOrCreateNotificationInputBase = {
  channel_slug: NcChannelSlug;
  /** Notification id */
  notification_id: Scalars['ID']['input'];
  status: NcNotificationChannelStatus;
};

export type NcUpdateOrCreateNotificationPayload = {
  __typename?: 'NCUpdateOrCreateNotificationPayload';
  channel_slug: NcChannelSlug;
  created: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  notification_id: Scalars['ID']['output'];
  status: NcNotificationChannelStatus;
};

export type NcUpdateOrCreateNotificationPayloadResponseInternalErrorResponseValidationErrorResponseIntegrityError = NcUpdateOrCreateNotificationPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type NavigationDataInput = {
  pagination?: InputMaybe<CursorPaginationInput>;
  search?: InputMaybe<NavigationDataSearchInput>;
  slug: Scalars['String']['input'];
};

export type NavigationDataQuery = {
  __typename?: 'NavigationDataQuery';
  /** Get navigation data for a corporation */
  navigation_data: HrisCorporationsGetChildrenOrgNavigationQueryPayloadIntegrityErrorResponseInternalErrorResponseValidationErrorResponseNotFoundResponseNotAuthenticatedErrorResponse;
};


export type NavigationDataQueryNavigation_DataArgs = {
  input: NavigationDataInput;
};

export type NavigationDataSearchInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

/** MUTATIONS */
export type NboxMutations = {
  __typename?: 'NboxMutations';
  clean_talent_nbox_deleted_matrices?: Maybe<TalentNboxExecutionResponse>;
  close_talent_nbox_matrix_calibration?: Maybe<TalentNboxExecutionResponse>;
  create_talent_nbox_filter?: Maybe<TalentNboxFilterResponse>;
  delete_talent_nbox_filter?: Maybe<TalentNboxExecutionResponse>;
  delete_talent_nbox_matrix_calibration?: Maybe<TalentNboxExecutionResponse>;
  duplicate_talent_nbox_matrix?: Maybe<TalentNboxDuplicatedResponse>;
  reset_talent_nbox_matrix_calibration?: Maybe<TalentNboxExecutionResponse>;
  save_talent_nbox_matrix_calibration?: Maybe<TalentNboxMatrixCalibrationResponse>;
  update_matrix_axis_config?: Maybe<TalentNboxMatrixAxisConfigResponse>;
  update_matrix_quadrant_config?: Maybe<TalentNboxExecutionResponse>;
  update_matrix_visual_config?: Maybe<TalentNboxExecutionResponse>;
  update_talent_nbox_filter?: Maybe<TalentNboxFilterResponse>;
  update_talent_nbox_matrix_state?: Maybe<TalentNboxExecutionResponse>;
};


/** MUTATIONS */
export type NboxMutationsClean_Talent_Nbox_Deleted_MatricesArgs = {
  years: Scalars['Int']['input'];
};


/** MUTATIONS */
export type NboxMutationsClose_Talent_Nbox_Matrix_CalibrationArgs = {
  company_id: Scalars['Int']['input'];
  matrix_id: Scalars['Int']['input'];
};


/** MUTATIONS */
export type NboxMutationsCreate_Talent_Nbox_FilterArgs = {
  input: TalentNboxCreateFilterInput;
};


/** MUTATIONS */
export type NboxMutationsDelete_Talent_Nbox_FilterArgs = {
  company_id: Scalars['Int']['input'];
  filter_id: Scalars['Int']['input'];
  leader_id?: InputMaybe<Scalars['Int']['input']>;
};


/** MUTATIONS */
export type NboxMutationsDelete_Talent_Nbox_Matrix_CalibrationArgs = {
  calibration_id: Scalars['Int']['input'];
  company_id: Scalars['Int']['input'];
  updated_by: Scalars['String']['input'];
};


/** MUTATIONS */
export type NboxMutationsDuplicate_Talent_Nbox_MatrixArgs = {
  company_id: Scalars['Int']['input'];
  company_language: Scalars['String']['input'];
  matrix_id: Scalars['Int']['input'];
};


/** MUTATIONS */
export type NboxMutationsReset_Talent_Nbox_Matrix_CalibrationArgs = {
  company_id: Scalars['Int']['input'];
  matrix_id: Scalars['Int']['input'];
  updated_by: Scalars['String']['input'];
};


/** MUTATIONS */
export type NboxMutationsSave_Talent_Nbox_Matrix_CalibrationArgs = {
  input?: InputMaybe<TalentNboxMatrixCalibrationInput>;
};


/** MUTATIONS */
export type NboxMutationsUpdate_Matrix_Axis_ConfigArgs = {
  input: TalentNboxMatrixAxisConfigInput;
};


/** MUTATIONS */
export type NboxMutationsUpdate_Matrix_Quadrant_ConfigArgs = {
  input: TalentNboxQuadrantConfigInput;
};


/** MUTATIONS */
export type NboxMutationsUpdate_Matrix_Visual_ConfigArgs = {
  input: TalentNboxMatrixVisualConfigInput;
};


/** MUTATIONS */
export type NboxMutationsUpdate_Talent_Nbox_FilterArgs = {
  input: TalentNboxUpdateFilterInput;
};


/** MUTATIONS */
export type NboxMutationsUpdate_Talent_Nbox_Matrix_StateArgs = {
  matrix_id: Scalars['Int']['input'];
  state: TalentNboxMatrixStateEnum;
};

/** QUERIES */
export type NboxQueries = {
  __typename?: 'NboxQueries';
  get_talent_file?: Maybe<Scalars['String']['output']>;
  get_talent_nbox_filter_list?: Maybe<TalentNboxFiltersResponse>;
  get_talent_nbox_matrices_by_process?: Maybe<TalentNboxMatricesByProcessResponse>;
  get_talent_nbox_matrix?: Maybe<TalentNboxMatrixResponse>;
  get_talent_nbox_matrix_employee_result?: Maybe<TalentNboxEmployeeResultResponse>;
  get_talent_nbox_matrix_list?: Maybe<TalentNboxMatrixListResponse>;
  get_talent_nbox_matrix_report?: Maybe<TalentNboxMatrixReportResponse>;
  get_talent_nbox_matrix_results?: Maybe<TalentNboxMatrixResultResponse>;
  get_talent_nbox_processes_by_module?: Maybe<TalentNboxProcessByModuleResponse>;
  validate_talent_nbox_external_file?: Maybe<TalentNboxValidateFileResponse>;
};


/** QUERIES */
export type NboxQueriesGet_Talent_FileArgs = {
  input: Scalars['Int']['input'];
};


/** QUERIES */
export type NboxQueriesGet_Talent_Nbox_Filter_ListArgs = {
  input: TalentNboxFiltersInput;
};


/** QUERIES */
export type NboxQueriesGet_Talent_Nbox_Matrices_By_ProcessArgs = {
  input: TalentNboxMatricesByProcessInput;
};


/** QUERIES */
export type NboxQueriesGet_Talent_Nbox_MatrixArgs = {
  input: TalentNboxMatrixInput;
};


/** QUERIES */
export type NboxQueriesGet_Talent_Nbox_Matrix_Employee_ResultArgs = {
  input: TalentNboxEmployeeResultInput;
};


/** QUERIES */
export type NboxQueriesGet_Talent_Nbox_Matrix_ListArgs = {
  input: TalentNboxMatrixListInput;
};


/** QUERIES */
export type NboxQueriesGet_Talent_Nbox_Matrix_ReportArgs = {
  input: TalentNboxMatrixReportInput;
};


/** QUERIES */
export type NboxQueriesGet_Talent_Nbox_Matrix_ResultsArgs = {
  input: TalentNboxMatrixResultFilterInput;
};


/** QUERIES */
export type NboxQueriesGet_Talent_Nbox_Processes_By_ModuleArgs = {
  company_id: Scalars['Int']['input'];
};


/** QUERIES */
export type NboxQueriesValidate_Talent_Nbox_External_FileArgs = {
  input: TalentNboxValidateFileInput;
};

export type NextToTalentInput = {
  next_url?: InputMaybe<Scalars['String']['input']>;
  talent_company_id: Scalars['ID']['input'];
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
  talent_role?: InputMaybe<Scalars['String']['input']>;
};

export type NextToTalentPayload = {
  __typename?: 'NextToTalentPayload';
  next_url?: Maybe<Scalars['String']['output']>;
  talent_company_id: Scalars['ID']['output'];
  talent_employee_id?: Maybe<Scalars['ID']['output']>;
  talent_role?: Maybe<Scalars['String']['output']>;
};

export type NextToTalentPayloadValidationMutationErrorInternalServerMutationError = InternalServerMutationError | NextToTalentPayload | ValidationMutationError;

export type NextToTalisisInput = {
  next_url?: InputMaybe<Scalars['String']['input']>;
};

export type NextToTalisisPayload = {
  __typename?: 'NextToTalisisPayload';
  centralized_organization_id: Scalars['ID']['output'];
  next_url: Scalars['String']['output'];
  relay_state?: Maybe<Scalars['String']['output']>;
  sp_entity_id: Scalars['String']['output'];
};

export type NextToTalisisPayloadTalisisProductNotEnabledMutationErrorTalisisNotConfiguredMutationErrorValidationMutationErrorInternalServerMutationError = InternalServerMutationError | NextToTalisisPayload | TalisisNotConfiguredMutationError | TalisisProductNotEnabledMutationError | ValidationMutationError;

export type Nom035EmployeeNotInEvaluationErrorV2 = {
  __typename?: 'Nom035EmployeeNotInEvaluationErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type Nom035EvaluationAlreadyFinishedErrorV2 = {
  __typename?: 'Nom035EvaluationAlreadyFinishedErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type Nom035EvaluationClosedErrorV2 = {
  __typename?: 'Nom035EvaluationClosedErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type Nom035EvaluationInvalidStateErrorV2 = {
  __typename?: 'Nom035EvaluationInvalidStateErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type Nom035EvaluationNotFoundErrorV2 = {
  __typename?: 'Nom035EvaluationNotFoundErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type Nom035InvalidCompanyErrorV2 = {
  __typename?: 'Nom035InvalidCompanyErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type Nom035InvalidPeriodErrorV2 = {
  __typename?: 'Nom035InvalidPeriodErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type Nom035NoEvaluatedParticipantsErrorV2 = {
  __typename?: 'Nom035NoEvaluatedParticipantsErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type Nom035NoFinishedQuestionnairesErrorV2 = {
  __typename?: 'Nom035NoFinishedQuestionnairesErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type Nom035QuestionnaireEvaluationMismatchErrorV2 = {
  __typename?: 'Nom035QuestionnaireEvaluationMismatchErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export enum Nom035QuestionnaireFieldsEnum {
  Name = 'NAME',
  Relation = 'RELATION'
}

export type Nom035QuestionnaireNotFinishedErrorV2 = {
  __typename?: 'Nom035QuestionnaireNotFinishedErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type Nom035QuestionnaireNotFoundErrorV2 = {
  __typename?: 'Nom035QuestionnaireNotFoundErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export enum Nom035QuestionnaireRelationEnum {
  RelationNomAdmin = 'RELATION_NOM_ADMIN',
  RelationNomAuto = 'RELATION_NOM_AUTO',
  RelationNomBoss = 'RELATION_NOM_BOSS',
  RelationNomCoworker = 'RELATION_NOM_COWORKER',
  RelationNomExternalClient = 'RELATION_NOM_EXTERNAL_CLIENT',
  RelationNomInternalClient = 'RELATION_NOM_INTERNAL_CLIENT',
  RelationNomOther = 'RELATION_NOM_OTHER',
  RelationNomProvider = 'RELATION_NOM_PROVIDER',
  RelationNomSubordinate = 'RELATION_NOM_SUBORDINATE',
  RelationNomSupervisor = 'RELATION_NOM_SUPERVISOR',
  RelationNomVp = 'RELATION_NOM_VP'
}

export enum Nom035QuestionnaireStatusEnum {
  StatusNomAssigned = 'STATUS_NOM_ASSIGNED',
  StatusNomClosed = 'STATUS_NOM_CLOSED',
  StatusNomFinished = 'STATUS_NOM_FINISHED',
  StatusNomInProgress = 'STATUS_NOM_IN_PROGRESS'
}

export type Nom035ReportEmployeeNotFoundErrorV2 = {
  __typename?: 'Nom035ReportEmployeeNotFoundErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type Nom035RequiredFieldErrorV2 = {
  __typename?: 'Nom035RequiredFieldErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type NormalizeResponse = {
  __typename?: 'NormalizeResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type NormalizeUsersWithoutIncorporationDateInput = {
  centralized_organization_slug: Scalars['String']['input'];
};

/** Returned when a user is not authenticated (401). */
export type NotAuthenticatedErrorResponse = {
  __typename?: 'NotAuthenticatedErrorResponse';
  /** Error code */
  code: Scalars['String']['output'];
  /** Operation ID for tracing */
  graphql_operation_id: Scalars['ID']['output'];
  /** Error message */
  message: Scalars['String']['output'];
};

/** ErrorType: User is not authenticated */
export type NotAuthenticatedErrorV2 = {
  __typename?: 'NotAuthenticatedErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type NotFoundErrorResponse = {
  __typename?: 'NotFoundErrorResponse';
  /** Código de error fijo. */
  code: Scalars['String']['output'];
  /** Identificador de la operación GraphQL, para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Mensaje de recurso no encontrado. */
  message: Scalars['String']['output'];
};

/** ErrorType: Resource does not exist. For critical cases and null/empty for normal situations */
export type NotFoundErrorV2 = {
  __typename?: 'NotFoundErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

/** Returned when a resource is not found (404). */
export type NotFoundResponse = {
  __typename?: 'NotFoundResponse';
  /** Error code */
  code: Scalars['String']['output'];
  /** Operation ID for tracing */
  graphql_operation_id: Scalars['ID']['output'];
  /** Error message */
  message: Scalars['String']['output'];
};

export type NotFoundTemplateResponseError = {
  __typename?: 'NotFoundTemplateResponseError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  edges: Array<NotificationNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type NotificationHubActivateCampaignInput = {
  /** ID of the campaign to activate */
  campaign_id: Scalars['UUID']['input'];
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
};

export type NotificationHubActivateCampaignPayload = {
  __typename?: 'NotificationHubActivateCampaignPayload';
  /** The activated campaign */
  campaign: NotificationHubCampaign;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type NotificationHubActivateCampaignPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotificationHubValidationErrorsResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubActivateCampaignPayload | NotificationHubValidationErrorsResponse | ValidationErrorResponse;

export type NotificationHubAudienceImport = {
  __typename?: 'NotificationHubAudienceImport';
  /** Campaign it belongs to — null while the import is still floating, validated before the campaign was saved */
  campaign_id?: Maybe<Scalars['UUID']['output']>;
  /** Upload timestamp */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Rejected rows grouped by reason, largest group first */
  error_groups: Array<NotificationHubAudienceImportGroup>;
  /** Shared-files ID that was read */
  file_id: Scalars['String']['output'];
  /** Original file name */
  file_name?: Maybe<Scalars['String']['output']>;
  /** Import ID — pass it back to confirm or discard the result */
  id: Scalars['UUID']['output'];
  /** Distinct users the valid rows resolved to — lower than valid_count when the file lists the same person twice */
  recipient_count: Scalars['Int']['output'];
  /** PENDING until the admin confirms or discards it */
  status: NotificationHubAudienceImportStatusEnum;
  /** Data rows read from the file */
  total_rows: Scalars['Int']['output'];
  /** Centralized user who uploaded the file */
  uploaded_by: Scalars['Int']['output'];
  /** Rows that resolved to a user of this organization */
  valid_count: Scalars['Int']['output'];
  /** The accepted rows, in file order */
  valid_rows: Array<NotificationHubAudienceImportRow>;
};

export type NotificationHubAudienceImportGroup = {
  __typename?: 'NotificationHubAudienceImportGroup';
  /** Reason these rows were rejected */
  classification: NotificationHubRowClassificationEnum;
  /** Rows rejected for this reason */
  count: Scalars['Int']['output'];
  /** Human-readable reason, ready to show in the modal */
  reason: Scalars['String']['output'];
  /** The rejected rows themselves, in file order */
  rows: Array<NotificationHubAudienceImportRow>;
};

export type NotificationHubAudienceImportRow = {
  __typename?: 'NotificationHubAudienceImportRow';
  /** User the row resolved to, when it resolved to exactly one */
  centralized_user_id?: Maybe<Scalars['Int']['output']>;
  /** Whether the row was accepted, and if not, why */
  classification: NotificationHubRowClassificationEnum;
  /** Accounts the value matched — above 1 the row is ambiguous */
  match_count: Scalars['Int']['output'];
  /** The value exactly as it appeared in the file */
  raw_value: Scalars['String']['output'];
  /** 1-based line in the sheet, so the admin can find it in Excel */
  row_number: Scalars['Int']['output'];
};

export enum NotificationHubAudienceImportStatusEnum {
  Confirmed = 'CONFIRMED',
  Discarded = 'DISCARDED',
  Pending = 'PENDING'
}

export type NotificationHubAudienceImportsMutations = {
  __typename?: 'NotificationHubAudienceImportsMutations';
  /** Apply a validated import as the campaign's audience */
  confirm_audience_import: NotificationHubConfirmAudienceImportPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse;
  /** Discard a validated import without applying it */
  discard_audience_import: NotificationHubDiscardAudienceImportPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse;
  /** Validate an uploaded audience file row by row */
  validate_audience_import: NotificationHubValidateAudienceImportPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse;
};


export type NotificationHubAudienceImportsMutationsConfirm_Audience_ImportArgs = {
  input: NotificationHubConfirmAudienceImportInput;
};


export type NotificationHubAudienceImportsMutationsDiscard_Audience_ImportArgs = {
  input: NotificationHubDiscardAudienceImportInput;
};


export type NotificationHubAudienceImportsMutationsValidate_Audience_ImportArgs = {
  input: NotificationHubValidateAudienceImportInput;
};

export type NotificationHubCampaign = {
  __typename?: 'NotificationHubCampaign';
  /** Who receives the campaign */
  audience_type?: Maybe<AudienceType>;
  /** Kind of campaign */
  campaign_type?: Maybe<CampaignType>;
  /** Organization ID */
  centralized_organization_id: Scalars['Int']['output'];
  /** Whether the campaign targets courses or time periods */
  content_target_type?: Maybe<ContentTargetType>;
  /** Course IDs targeted by this campaign */
  course_ids: Array<Scalars['Int']['output']>;
  /** Creation timestamp */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who created the campaign */
  created_by: Scalars['Int']['output'];
  /** Campaign end date */
  end_date?: Maybe<Scalars['Date']['output']>;
  /** Emails failed counter */
  failed_count: Scalars['Int']['output'];
  /** Full frequency configuration, for rehydrating wizard step 3 */
  frequency?: Maybe<NotificationHubFrequency>;
  /** Frequency strategy (shorthand — see `frequency` for the full config) */
  frequency_type?: Maybe<FrequencyType>;
  /** Campaign unique identifier */
  id: Scalars['UUID']['output'];
  /** Whether the campaign is active */
  is_active: Scalars['Boolean']['output'];
  /** Area IDs the leaders report on (SPECIFIC_AREAS only, else empty) */
  leader_scope_area_ids: Array<Scalars['Int']['output']>;
  /** «Alcance del equipo» of a LEADER campaign; null for COLLABORATOR or while the draft has not chosen one */
  leader_scope_type?: Maybe<LeaderScopeType>;
  /** Campaign name */
  name?: Maybe<Scalars['String']['output']>;
  /** Product that owns the campaign */
  product_type?: Maybe<ProductType>;
  /** Progress range IDs for filtering */
  progress_range_ids: Array<Scalars['Int']['output']>;
  /** Emails queued counter */
  queued_count: Scalars['Int']['output'];
  /** Uploaded file ID the userIds list came from */
  segment_file_id?: Maybe<Scalars['ID']['output']>;
  /** External segment ID from segmentation service */
  segment_id?: Maybe<Scalars['ID']['output']>;
  /** Segment rules (SPECIFIC_SEGMENT) or userIds (SPECIFIC_USERS) */
  segment_snapshot?: Maybe<Scalars['JSON']['output']>;
  /** Audience segmentation mode */
  segmentation_type?: Maybe<SegmentationType>;
  /** Emails sent counter */
  sent_count: Scalars['Int']['output'];
  /** Campaign start date */
  start_date?: Maybe<Scalars['Date']['output']>;
  /** Current lifecycle status */
  status: CampaignStatus;
  /** Selected email template (id + name) to re-mark the card when editing; null while the draft has no template */
  template?: Maybe<NotificationHubCampaignTemplate>;
  /** Email template ID */
  template_id?: Maybe<Scalars['UUID']['output']>;
  /** Email template version the campaign is pinned to. Resolved by the backend (latest at pick time, moved by sync_campaign_template) */
  template_version_id?: Maybe<Scalars['UUID']['output']>;
  /** Time period IDs targeted by this campaign */
  time_period_ids: Array<Scalars['Int']['output']>;
  /** Last update timestamp */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who last updated the campaign */
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type NotificationHubCampaignAudienceItem = {
  __typename?: 'NotificationHubCampaignAudienceItem';
  /** Centralized user ID (the key) */
  user_id: Scalars['Int']['output'];
  /** Federated reference to the membership (centralized-users). Select user { firstname lastname email profile_picture { url } position { position_name } } for the person and «Cargo», organization_area { name } for «Área», role, boss, headquarter… */
  user_organization: CentralizedUserOrganizationNode;
};

export type NotificationHubCampaignListItem = {
  __typename?: 'NotificationHubCampaignListItem';
  /** Who receives it — the «Tipo» column (Colaborador / Líder) */
  audience_type?: Maybe<AudienceType>;
  /** Kind of campaign */
  campaign_type?: Maybe<CampaignType>;
  /** Which target the «Curso objetivo» chip shows: COURSES → course_ids, TIME_PERIOD → time_periods; null while the draft has neither */
  content_target_type?: Maybe<ContentTargetType>;
  /** Count of active course associations */
  course_count: Scalars['Int']['output'];
  /** Courses targeted, for the chip's popover. Names are resolved by the client (the courses live in another subgraph) */
  course_ids: Array<Scalars['Int']['output']>;
  /** Creation timestamp */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Campaign end date */
  end_date?: Maybe<Scalars['Date']['output']>;
  /** Emails failed counter */
  failed_count: Scalars['Int']['output'];
  /** Ready-to-render Spanish cadence («Semanal», «Cada 4 días», «Quincenal»); null while the draft has no frequency */
  frequency_label?: Maybe<Scalars['String']['output']>;
  /** Frequency strategy */
  frequency_type?: Maybe<FrequencyType>;
  /** Campaign unique identifier */
  id: Scalars['UUID']['output'];
  /** Campaign name */
  name?: Maybe<Scalars['String']['output']>;
  /** Emails queued counter */
  queued_count: Scalars['Int']['output'];
  /** Emails sent counter */
  sent_count: Scalars['Int']['output'];
  /** Campaign start date */
  start_date?: Maybe<Scalars['Date']['output']>;
  /** Current lifecycle status */
  status: CampaignStatus;
  /** Time periods targeted, label included, for the chip's popover */
  time_periods: Array<NotificationHubTimePeriod>;
};

export type NotificationHubCampaignMetrics = {
  __typename?: 'NotificationHubCampaignMetrics';
  /** Count of active campaigns */
  active_campaigns_count: Scalars['Int']['output'];
  /** Average open rate (null in V1, blocked by ANLT-388) */
  average_open_rate?: Maybe<Scalars['Float']['output']>;
  /** Total emails sent (lifetime in V1, per-month when send_logs ships) */
  emails_sent_this_month: Scalars['Int']['output'];
};

export type NotificationHubCampaignMetricsInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
};

export type NotificationHubCampaignMetricsPayload = {
  __typename?: 'NotificationHubCampaignMetricsPayload';
  /** Campaign metrics */
  metrics: NotificationHubCampaignMetrics;
};

export type NotificationHubCampaignMetricsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotificationHubCampaignMetricsPayload;

export type NotificationHubCampaignTemplate = {
  __typename?: 'NotificationHubCampaignTemplate';
  /** Email template ID */
  id: Scalars['UUID']['output'];
  /** Email template name */
  name: Scalars['String']['output'];
};

export type NotificationHubCampaignsMutations = {
  __typename?: 'NotificationHubCampaignsMutations';
  /** Activate a draft campaign (DRAFT → ACTIVE) */
  activate_campaign: NotificationHubActivateCampaignPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotificationHubValidationErrorsResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
  /** Create a new campaign in DRAFT status */
  create_campaign: NotificationHubCreateCampaignPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
  /** Soft-delete a campaign */
  delete_campaign: NotificationHubDeleteCampaignPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse;
  /** Duplicate a campaign into DRAFT status */
  duplicate_campaign: NotificationHubDuplicateCampaignPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
  /** Edit an existing campaign (progressive updates) */
  edit_campaign: NotificationHubEditCampaignPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
  /** Pause an active campaign (ACTIVE → PAUSED) */
  pause_campaign: NotificationHubPauseCampaignPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse;
  /** Resume a paused campaign (PAUSED → ACTIVE) */
  resume_campaign: NotificationHubResumeCampaignPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse;
  /** Sync a campaign's template to its latest version */
  sync_campaign_template: NotificationHubSyncCampaignTemplatePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse;
};


export type NotificationHubCampaignsMutationsActivate_CampaignArgs = {
  input: NotificationHubActivateCampaignInput;
};


export type NotificationHubCampaignsMutationsCreate_CampaignArgs = {
  input: NotificationHubCreateCampaignInput;
};


export type NotificationHubCampaignsMutationsDelete_CampaignArgs = {
  input: NotificationHubDeleteCampaignInput;
};


export type NotificationHubCampaignsMutationsDuplicate_CampaignArgs = {
  input: NotificationHubDuplicateCampaignInput;
};


export type NotificationHubCampaignsMutationsEdit_CampaignArgs = {
  input: NotificationHubEditCampaignInput;
};


export type NotificationHubCampaignsMutationsPause_CampaignArgs = {
  input: NotificationHubPauseCampaignInput;
};


export type NotificationHubCampaignsMutationsResume_CampaignArgs = {
  input: NotificationHubResumeCampaignInput;
};


export type NotificationHubCampaignsMutationsSync_Campaign_TemplateArgs = {
  input: NotificationHubSyncCampaignTemplateInput;
};

export type NotificationHubCampaignsQueries = {
  __typename?: 'NotificationHubCampaignsQueries';
  /** Get org-level campaign metrics */
  campaign_metrics: NotificationHubCampaignMetricsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
  /** Estimate how many people a targeting combination would reach (wizard step 2 counter) */
  estimate_audience: NotificationHubEstimateAudiencePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
  /** Get a single campaign by ID */
  get_campaign: NotificationHubGetCampaignPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse;
  /** List, page by page, the people a targeting combination would reach (the «Ver detalle de usuarios» modal of the summary step) */
  list_campaign_audience: NotificationHubListCampaignAudienceResponse;
  /** List campaigns with search, filter, sort, and pagination */
  list_campaigns: NotificationHubListCampaignsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
  /** List the products the campaigns module can be scoped to (the PRODUCTO picker), including the ones not launched yet */
  list_products: NotificationHubListProductsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
  /** List the progress range catalog (valid values for the wizard) */
  list_progress_ranges: NotificationHubListProgressRangesPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
  /** List the time period catalog (valid values for the wizard) */
  list_time_periods: NotificationHubListTimePeriodsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
  /** Check whether a campaign name can be saved, before saving */
  validate_campaign_name: NotificationHubValidateCampaignNamePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
};


export type NotificationHubCampaignsQueriesCampaign_MetricsArgs = {
  input: NotificationHubCampaignMetricsInput;
};


export type NotificationHubCampaignsQueriesEstimate_AudienceArgs = {
  input: NotificationHubEstimateAudienceInput;
};


export type NotificationHubCampaignsQueriesGet_CampaignArgs = {
  input: NotificationHubGetCampaignInput;
};


export type NotificationHubCampaignsQueriesList_Campaign_AudienceArgs = {
  input: NotificationHubListCampaignAudienceInput;
};


export type NotificationHubCampaignsQueriesList_CampaignsArgs = {
  input: NotificationHubListCampaignsInput;
};


export type NotificationHubCampaignsQueriesList_ProductsArgs = {
  input: NotificationHubListProductsInput;
};


export type NotificationHubCampaignsQueriesList_Progress_RangesArgs = {
  input: NotificationHubListProgressRangesInput;
};


export type NotificationHubCampaignsQueriesList_Time_PeriodsArgs = {
  input: NotificationHubListTimePeriodsInput;
};


export type NotificationHubCampaignsQueriesValidate_Campaign_NameArgs = {
  input: NotificationHubValidateCampaignNameInput;
};

export type NotificationHubConfirmAudienceImportInput = {
  /** Campaign to apply the audience to. Required only when the import was validated without one */
  campaign_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Import to confirm, as returned by validate_audience_import */
  import_id: Scalars['UUID']['input'];
};

export type NotificationHubConfirmAudienceImportPayload = {
  __typename?: 'NotificationHubConfirmAudienceImportPayload';
  /** The import, now CONFIRMED */
  audience_import: NotificationHubAudienceImport;
  /** Distinct users now set as the campaign's audience */
  recipient_count: Scalars['Int']['output'];
  /** Whether the audience was applied */
  success: Scalars['Boolean']['output'];
};

export type NotificationHubConfirmAudienceImportPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubConfirmAudienceImportPayload | ValidationErrorResponse;

export type NotificationHubCreateCampaignInput = {
  /** Who receives the campaign */
  audience_type?: InputMaybe<AudienceType>;
  /** Kind of campaign */
  campaign_type?: InputMaybe<CampaignType>;
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Whether the campaign targets courses or time periods */
  content_target_type?: InputMaybe<ContentTargetType>;
  /** Course IDs (for COURSES target type) */
  course_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Campaign end date (optional) */
  end_date?: InputMaybe<Scalars['Date']['input']>;
  /** Frequency configuration */
  frequency?: InputMaybe<NotificationHubFrequencyInput>;
  /** Client-generated UUID for deduplication */
  idempotency_key: Scalars['UUID']['input'];
  /** Area IDs for SPECIFIC_AREAS («Áreas incluidas»). Cleared for the other scopes */
  leader_scope_area_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** «Alcance del equipo» — LEADER campaigns only: which collaborators each leader reports on. Ignored (cleared) for COLLABORATOR */
  leader_scope_type?: InputMaybe<LeaderScopeType>;
  /** Campaign name (max 60 characters) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Product that owns the campaign */
  product_type?: InputMaybe<ProductType>;
  /** Progress range IDs for filtering */
  progress_range_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Uploaded file ID the SPECIFIC_USERS list came from, kept for later validation */
  segment_file_id?: InputMaybe<Scalars['ID']['input']>;
  /** External segment ID from the segmentation service (only for SPECIFIC_SEGMENT) */
  segment_id?: InputMaybe<Scalars['ID']['input']>;
  /** Segment rules snapshot (SPECIFIC_SEGMENT) or the userIds list of centralized users (SPECIFIC_USERS), as JSONB */
  segment_snapshot?: InputMaybe<Scalars['JSON']['input']>;
  /** Audience segmentation mode */
  segmentation_type?: InputMaybe<SegmentationType>;
  /** Campaign start date */
  start_date?: InputMaybe<Scalars['Date']['input']>;
  /** Email template ID */
  template_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Time period IDs (for TIME_PERIOD target type) */
  time_period_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NotificationHubCreateCampaignPayload = {
  __typename?: 'NotificationHubCreateCampaignPayload';
  /** The created campaign */
  campaign: NotificationHubCampaign;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type NotificationHubCreateCampaignPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubCreateCampaignPayload | NotificationHubValidationErrorsResponse | ValidationErrorResponse;

export type NotificationHubCreateEmailTemplateInput = {
  /** Files attached to the mail (max 3) */
  attachments?: InputMaybe<Array<NotificationHubTemplateAttachmentInput>>;
  /** Who the template addresses — frozen after creation */
  audience_type: AudienceType;
  /** Shared-files id of the 1200x360 banner */
  banner_file_id?: InputMaybe<Scalars['String']['input']>;
  /** Content blocks — list order IS the render order */
  blocks: Array<NotificationHubTemplateBlockInput>;
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Admin aliases for real Crehana attributes */
  custom_variables?: InputMaybe<Array<NotificationHubTemplateCustomVariableInput>>;
  /** What the template is for (max 150 chars) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Template name */
  name: Scalars['String']['input'];
  /** Product that owns the template */
  product_type: ProductType;
  /** Email subject, may contain {{tokens}} (max 60 chars) */
  subject: Scalars['String']['input'];
  /** Title rendered above the blocks */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationHubCreateEmailTemplatePayload = {
  __typename?: 'NotificationHubCreateEmailTemplatePayload';
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
  /** The created template */
  template: NotificationHubEmailTemplate;
  /** Version 1, with all its blocks — ready for the preview */
  version: NotificationHubEmailTemplateVersion;
};

export type NotificationHubCreateEmailTemplatePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotificationHubCreateEmailTemplatePayload | ValidationErrorResponse;

export type NotificationHubDeleteCampaignInput = {
  /** ID of the campaign to delete */
  campaign_id: Scalars['UUID']['input'];
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
};

export type NotificationHubDeleteCampaignPayload = {
  __typename?: 'NotificationHubDeleteCampaignPayload';
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type NotificationHubDeleteCampaignPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubDeleteCampaignPayload;

export type NotificationHubDeleteEmailTemplateInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID of the template to delete */
  template_id: Scalars['UUID']['input'];
};

export type NotificationHubDeleteEmailTemplatePayload = {
  __typename?: 'NotificationHubDeleteEmailTemplatePayload';
  /** Live campaigns that keep sending this template — the deletion retires it from the list, it does not stop them (ANLT-713 AC-2) */
  affected_campaigns: Array<NotificationHubTemplateCampaignUsage>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type NotificationHubDeleteEmailTemplatePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubDeleteEmailTemplatePayload | ValidationErrorResponse;

export type NotificationHubDiscardAudienceImportInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Import to discard */
  import_id: Scalars['UUID']['input'];
};

export type NotificationHubDiscardAudienceImportPayload = {
  __typename?: 'NotificationHubDiscardAudienceImportPayload';
  /** The import, now DISCARDED — the audience was left untouched */
  audience_import: NotificationHubAudienceImport;
  /** Whether the import was discarded */
  success: Scalars['Boolean']['output'];
};

export type NotificationHubDiscardAudienceImportPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubDiscardAudienceImportPayload;

export type NotificationHubDuplicateCampaignInput = {
  /** ID of the campaign to duplicate */
  campaign_id: Scalars['UUID']['input'];
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
};

export type NotificationHubDuplicateCampaignPayload = {
  __typename?: 'NotificationHubDuplicateCampaignPayload';
  /** The duplicated campaign */
  campaign: NotificationHubCampaign;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type NotificationHubDuplicateCampaignPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubDuplicateCampaignPayload;

export type NotificationHubEditCampaignInput = {
  /** Who receives the campaign */
  audience_type?: InputMaybe<AudienceType>;
  /** ID of the campaign to edit */
  campaign_id: Scalars['UUID']['input'];
  /** Kind of campaign */
  campaign_type?: InputMaybe<CampaignType>;
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Whether the campaign targets courses or time periods */
  content_target_type?: InputMaybe<ContentTargetType>;
  /** Course IDs targeted by this campaign */
  course_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Campaign end date (optional) */
  end_date?: InputMaybe<Scalars['Date']['input']>;
  /** Frequency configuration */
  frequency?: InputMaybe<NotificationHubFrequencyInput>;
  /** Area IDs for SPECIFIC_AREAS («Áreas incluidas»). Cleared for the other scopes */
  leader_scope_area_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** «Alcance del equipo» — LEADER campaigns only: which collaborators each leader reports on. Ignored (cleared) for COLLABORATOR */
  leader_scope_type?: InputMaybe<LeaderScopeType>;
  /** Campaign name (max 60 characters) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Product that owns the campaign */
  product_type?: InputMaybe<ProductType>;
  /** Progress range IDs for filtering */
  progress_range_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Uploaded file ID the SPECIFIC_USERS list came from, kept for later validation */
  segment_file_id?: InputMaybe<Scalars['ID']['input']>;
  /** External segment ID from the segmentation service (only for SPECIFIC_SEGMENT) */
  segment_id?: InputMaybe<Scalars['ID']['input']>;
  /** Segment rules snapshot (SPECIFIC_SEGMENT) or the userIds list of centralized users (SPECIFIC_USERS), as JSONB */
  segment_snapshot?: InputMaybe<Scalars['JSON']['input']>;
  /** Audience segmentation mode */
  segmentation_type?: InputMaybe<SegmentationType>;
  /** Campaign start date */
  start_date?: InputMaybe<Scalars['Date']['input']>;
  /** Email template ID */
  template_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Time period IDs (for TIME_PERIOD target type) */
  time_period_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NotificationHubEditCampaignPayload = {
  __typename?: 'NotificationHubEditCampaignPayload';
  /** The updated campaign */
  campaign: NotificationHubCampaign;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type NotificationHubEditCampaignPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubEditCampaignPayload | NotificationHubValidationErrorsResponse | ValidationErrorResponse;

export type NotificationHubEditEmailTemplateInput = {
  /** Files attached to the mail (max 3) */
  attachments?: InputMaybe<Array<NotificationHubTemplateAttachmentInput>>;
  /** Shared-files id of the 1200x360 banner */
  banner_file_id?: InputMaybe<Scalars['String']['input']>;
  /** Content blocks — list order IS the render order */
  blocks: Array<NotificationHubTemplateBlockInput>;
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Admin aliases for real Crehana attributes */
  custom_variables?: InputMaybe<Array<NotificationHubTemplateCustomVariableInput>>;
  /** What the template is for (max 150 chars) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Template name */
  name: Scalars['String']['input'];
  /** Email subject, may contain {{tokens}} (max 60 chars) */
  subject: Scalars['String']['input'];
  /** Template to edit */
  template_id: Scalars['UUID']['input'];
  /** Title rendered above the blocks */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationHubEditEmailTemplatePayload = {
  __typename?: 'NotificationHubEditEmailTemplatePayload';
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
  /** The updated template */
  template: NotificationHubEmailTemplate;
  /** The version this edit appended. Campaigns pinned to an older one keep it until sync_campaign_template runs */
  version: NotificationHubEmailTemplateVersion;
};

export type NotificationHubEditEmailTemplatePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubEditEmailTemplatePayload | ValidationErrorResponse;

export type NotificationHubEmailTemplate = {
  __typename?: 'NotificationHubEmailTemplate';
  /** Who the template addresses (the picker's badge) */
  audience_type: AudienceType;
  /** Creation timestamp */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** What the template is for, as typed in the wizard */
  description?: Maybe<Scalars['String']['output']>;
  /** Template unique identifier */
  id: Scalars['UUID']['output'];
  /** State of the «Activar / Desactivar» switch. A disabled template is still listed, greyed out — it is not a deleted one */
  is_enabled: Scalars['Boolean']['output'];
  /** Newest active version number — compare with the campaign's own version to know whether the template has newer content */
  latest_version?: Maybe<Scalars['Int']['output']>;
  /** Newest active version. Campaigns pin it automatically when they pick this template; sync_campaign_template moves them to it later */
  latest_version_id?: Maybe<Scalars['UUID']['output']>;
  /** Template name shown in the picker */
  name: Scalars['String']['output'];
  /** Whether it is a Crehana seed or user-authored */
  origin: TemplateOrigin;
  /** Product that owns the template */
  product_type: ProductType;
  /** Last update timestamp */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type NotificationHubEmailTemplateVersion = {
  __typename?: 'NotificationHubEmailTemplateVersion';
  /** Files attached to the mail */
  attachments: Array<NotificationHubTemplateAttachment>;
  /** Shared-files id of the banner */
  banner_file_id?: Maybe<Scalars['String']['output']>;
  /** Content blocks in render order */
  blocks: Array<NotificationHubTemplateBlock>;
  /** Creation timestamp */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Admin aliases for real Crehana attributes */
  custom_variables: Array<NotificationHubTemplateCustomVariable>;
  /** Version unique identifier */
  id: Scalars['UUID']['output'];
  /** Email subject, tokens included */
  subject: Scalars['String']['output'];
  /** Title above the blocks */
  title?: Maybe<Scalars['String']['output']>;
  /** Sequential version number */
  version: Scalars['Int']['output'];
};

export type NotificationHubEstimateAudienceInput = {
  /** Audience to estimate for when no template_id is sent (default COLLABORATOR) */
  audience_type?: InputMaybe<AudienceType>;
  /** Saved campaign to estimate. Its stored targeting is the baseline and every other field sent here overrides it; omit while the wizard has not saved anything yet. Unknown id → NotFoundResponse */
  campaign_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Course IDs targeted (for the COURSES content target) */
  course_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** LEADER + SPECIFIC_AREAS only: the areas included */
  leader_scope_area_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** LEADER only: «Alcance del equipo», narrows the collaborators covered */
  leader_scope_type?: InputMaybe<LeaderScopeType>;
  /** Progress range IDs to filter the audience by (omit for all) */
  progress_range_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** SPECIFIC_USERS: the uploaded file validated by validate_audience_import; its valid rows are counted when no userIds are sent */
  segment_file_id?: InputMaybe<Scalars['ID']['input']>;
  /** SPECIFIC_SEGMENT: external segment reference (opaque here) */
  segment_id?: InputMaybe<Scalars['ID']['input']>;
  /** SPECIFIC_SEGMENT: { rules: [...] } · SPECIFIC_USERS: { userIds: [...] } (the manual pick, counted exactly) */
  segment_snapshot?: InputMaybe<Scalars['JSON']['input']>;
  /** Audience mode: ALL_AUDIENCE (dynamic, from the content target), SPECIFIC_USERS (exact count of the picked/uploaded list) or SPECIFIC_SEGMENT (rules). Omit = ALL_AUDIENCE */
  segmentation_type?: InputMaybe<SegmentationType>;
  /** Template picked in step 1. Its audience type decides whether the estimate counts collaborators or leaders (it wins over audience_type) */
  template_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Time period IDs targeted (for the TIME_PERIOD content target) */
  time_period_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NotificationHubEstimateAudiencePayload = {
  __typename?: 'NotificationHubEstimateAudiencePayload';
  /** Who estimated_count counts: COLLABORATOR → collaborators reached; LEADER → leaders that receive the report */
  audience_type: AudienceType;
  /** LEADER only: collaborators the leaders' reports span, after the team scope («sobre N colaboradores»). null for COLLABORATOR */
  covered_collaborators_count?: Maybe<Scalars['Int']['output']>;
  /** People who would receive the next send, counted with the same resolver the dispatcher runs: the audience (step 2) crossed with the courses and progress ranges (step 1). 0 when no content target (courses or time periods) has been selected yet */
  estimated_count: Scalars['Int']['output'];
  /** TRUE only when a source could not be consulted and the count is partial: Learning unavailable (no progress filter applied) or a segment by rules (no segment engine yet). FALSE means the number is the real count as of now */
  is_provisional: Scalars['Boolean']['output'];
  /** Audience mode the estimate was computed for (ALL_AUDIENCE, SPECIFIC_USERS, SPECIFIC_SEGMENT); null when the wizard has not chosen one yet, which is estimated as ALL_AUDIENCE */
  segmentation_type?: Maybe<SegmentationType>;
};

export type NotificationHubEstimateAudiencePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubEstimateAudiencePayload;

export type NotificationHubFrequency = {
  __typename?: 'NotificationHubFrequency';
  /** Frequency strategy */
  frequency_type: FrequencyType;
  /** Interval in days for CUSTOM_INTERVAL */
  interval_days?: Maybe<Scalars['Int']['output']>;
  /** Time of day to send (SMART/WEEKLY/CUSTOM_INTERVAL) */
  send_time?: Maybe<Scalars['Time']['output']>;
  /** IANA timezone (e.g. America/Mexico_City) */
  timezone: Scalars['String']['output'];
  /** Day of week for WEEKLY (0=Monday .. 6=Sunday) */
  weekly_day?: Maybe<Scalars['Int']['output']>;
  /** Custom week schedule for CUSTOM_CALENDAR (empty otherwise) */
  weeks: Array<NotificationHubWeek>;
};

export type NotificationHubFrequencyInput = {
  /** Frequency strategy */
  frequency_type: FrequencyType;
  /** Interval in days for CUSTOM_INTERVAL */
  interval_days?: InputMaybe<Scalars['Int']['input']>;
  /** Time of day to send (required for SMART/WEEKLY/CUSTOM_INTERVAL) */
  send_time?: InputMaybe<Scalars['Time']['input']>;
  /** IANA timezone (e.g. America/Mexico_City) */
  timezone: Scalars['String']['input'];
  /** Day of week for WEEKLY (0=Monday .. 6=Sunday) */
  weekly_day?: InputMaybe<Scalars['Int']['input']>;
  /** Custom week schedule for CUSTOM_CALENDAR */
  weeks?: InputMaybe<Array<NotificationHubWeekInput>>;
};

export type NotificationHubGetCampaignInput = {
  /** ID of the campaign to retrieve */
  campaign_id: Scalars['UUID']['input'];
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
};

export type NotificationHubGetCampaignPayload = {
  __typename?: 'NotificationHubGetCampaignPayload';
  /** The retrieved campaign */
  campaign: NotificationHubCampaign;
  /** True if the template has a newer version than what this campaign uses */
  has_template_update: Scalars['Boolean']['output'];
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type NotificationHubGetCampaignPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubGetCampaignPayload;

export type NotificationHubGetEmailTemplateInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID of the template to open */
  template_id: Scalars['UUID']['input'];
};

export type NotificationHubGetEmailTemplatePayload = {
  __typename?: 'NotificationHubGetEmailTemplatePayload';
  /** Absolute URL of version.banner_file_id, resolved server-side. Null when there is no banner or shared-files could not resolve it */
  banner_url?: Maybe<Scalars['String']['output']>;
  /** One entry per distinct file id used by the version's IMAGE blocks, in render order, each with its resolved URL (or null) */
  image_urls: Array<NotificationHubTemplateImageUrl>;
  /** Identity and config: name, description, audience, product */
  template: NotificationHubEmailTemplate;
  /** Newest active version: subject, blocks, banner, attachments and custom variables. Null when the template has no active version — it exists, but there is nothing to open yet */
  version?: Maybe<NotificationHubEmailTemplateVersion>;
};

export type NotificationHubGetEmailTemplatePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubGetEmailTemplatePayload;

export type NotificationHubListCampaignAudienceInput = {
  /** Audience to estimate for when no template_id is sent (default COLLABORATOR) */
  audience_type?: InputMaybe<AudienceType>;
  /** Saved campaign to estimate. Its stored targeting is the baseline and every other field sent here overrides it; omit while the wizard has not saved anything yet. Unknown id → NotFoundResponse */
  campaign_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Course IDs targeted (for the COURSES content target) */
  course_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** LEADER + SPECIFIC_AREAS only: the areas included */
  leader_scope_area_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** LEADER only: «Alcance del equipo», narrows the collaborators covered */
  leader_scope_type?: InputMaybe<LeaderScopeType>;
  /** Page to return. Default: page 1, page_size 20 */
  pagination?: InputMaybe<NotificationHubListCampaignAudiencePaginationInput>;
  /** Progress range IDs to filter the audience by (omit for all) */
  progress_range_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Case-insensitive substring over full name, email and area (the modal's «Buscar por nombre, correo o área») */
  search?: InputMaybe<Scalars['String']['input']>;
  /** SPECIFIC_USERS: the uploaded file validated by validate_audience_import; its valid rows are counted when no userIds are sent */
  segment_file_id?: InputMaybe<Scalars['ID']['input']>;
  /** SPECIFIC_SEGMENT: external segment reference (opaque here) */
  segment_id?: InputMaybe<Scalars['ID']['input']>;
  /** SPECIFIC_SEGMENT: { rules: [...] } · SPECIFIC_USERS: { userIds: [...] } (the manual pick, counted exactly) */
  segment_snapshot?: InputMaybe<Scalars['JSON']['input']>;
  /** Audience mode: ALL_AUDIENCE (dynamic, from the content target), SPECIFIC_USERS (exact count of the picked/uploaded list) or SPECIFIC_SEGMENT (rules). Omit = ALL_AUDIENCE */
  segmentation_type?: InputMaybe<SegmentationType>;
  /** Template picked in step 1. Its audience type decides whether the estimate counts collaborators or leaders (it wins over audience_type) */
  template_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Time period IDs targeted (for the TIME_PERIOD content target) */
  time_period_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NotificationHubListCampaignAudiencePaginationInput = {
  /** Page number (1-based) */
  page?: Scalars['Int']['input'];
  /** Rows per page, 1..50. Above 50 the query answers ValidationErrorResponse(INVALID_PAGE_SIZE) instead of clamping */
  page_size?: Scalars['Int']['input'];
};

export type NotificationHubListCampaignAudiencePayload = {
  __typename?: 'NotificationHubListCampaignAudiencePayload';
  /** Who the rows are: COLLABORATOR → collaborators; LEADER → leaders */
  audience_type: AudienceType;
  /** Same meaning as in estimate_audience: TRUE when a source could not be consulted and the list is partial */
  is_provisional: Scalars['Boolean']['output'];
  /** TRUE when total_count exceeds list_limit: render «Mostrando {listed_count} de {total_count}. Usa el buscador para encontrar usuarios específicos» */
  is_truncated: Scalars['Boolean']['output'];
  /** The requested page, ordered by full name then email (the search, when sent, matched name, email or structured area) */
  items: Array<NotificationHubCampaignAudienceItem>;
  /** Maximum rows the list exposes (200). Sent so the client never hardcodes it */
  list_limit: Scalars['Int']['output'];
  /** How many of total_count can be paged through: min(total_count, list_limit). Pages past it come back empty */
  listed_count: Scalars['Int']['output'];
  /** Page returned (1-based) */
  page: Scalars['Int']['output'];
  /** Rows per page applied */
  page_size: Scalars['Int']['output'];
  /** Audience mode the list was resolved for; null = ALL_AUDIENCE */
  segmentation_type?: Maybe<SegmentationType>;
  /** People matching the search across ALL pages, cap or no cap. Without a search it equals estimate_audience.estimated_count for the same input */
  total_count: Scalars['Int']['output'];
};

export type NotificationHubListCampaignAudienceResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubListCampaignAudiencePayload | ValidationErrorResponse;

export type NotificationHubListCampaignsFilterInput = {
  /** Only campaigns of this product — the «PRODUCTO» selector above the table */
  product_type?: InputMaybe<ProductType>;
  /** Filter by one or more campaign statuses (omit for all) */
  statuses?: InputMaybe<Array<CampaignStatus>>;
};

export type NotificationHubListCampaignsInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Filter criteria */
  filter?: InputMaybe<NotificationHubListCampaignsFilterInput>;
  /** Pagination criteria */
  pagination?: InputMaybe<NotificationHubListCampaignsPaginationInput>;
  /** Search criteria */
  search?: InputMaybe<NotificationHubListCampaignsSearchInput>;
  /** Sort criteria (omit for last-updated first) */
  sort?: InputMaybe<NotificationHubListCampaignsSortInput>;
};

export type NotificationHubListCampaignsPaginationInput = {
  /** Page number (1-based) */
  page: Scalars['Int']['input'];
  /** Number of items per page (max 50) */
  page_size?: Scalars['Int']['input'];
};

export type NotificationHubListCampaignsPayload = {
  __typename?: 'NotificationHubListCampaignsPayload';
  /** Page of campaign items */
  items: Array<NotificationHubCampaignListItem>;
  /** Total number of campaigns matching the filters */
  total_count: Scalars['Int']['output'];
};

export type NotificationHubListCampaignsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotificationHubListCampaignsPayload;

export type NotificationHubListCampaignsSearchInput = {
  /** Search text (partial, case-insensitive) */
  query: Scalars['String']['input'];
};

export type NotificationHubListCampaignsSortInput = {
  /** Sort direction (ASC or DESC) */
  direction: SortDirection;
  /** Column to sort by */
  field: CampaignSortField;
};

export type NotificationHubListProductsInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
};

export type NotificationHubListProductsPayload = {
  __typename?: 'NotificationHubListProductsPayload';
  /** Every product in picker order, available ones flagged */
  items: Array<NotificationHubProduct>;
};

export type NotificationHubListProductsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotificationHubListProductsPayload;

export type NotificationHubListProgressRangesInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
};

export type NotificationHubListProgressRangesPayload = {
  __typename?: 'NotificationHubListProgressRangesPayload';
  /** Progress ranges in display order */
  items: Array<NotificationHubProgressRange>;
};

export type NotificationHubListProgressRangesPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotificationHubListProgressRangesPayload;

export type NotificationHubListTemplatesInput = {
  /** Only templates for this audience (omit for all) */
  audience_type?: InputMaybe<AudienceType>;
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Only templates of this product (omit for all) */
  product_type?: InputMaybe<ProductType>;
  /** Filter by name or description (partial, case-insensitive) */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Sort order (omit for last-updated first) */
  sort?: InputMaybe<NotificationHubTemplateSortInput>;
};

export type NotificationHubListTemplatesPayload = {
  __typename?: 'NotificationHubListTemplatesPayload';
  /** Templates ordered by name */
  items: Array<NotificationHubEmailTemplate>;
  /** Number of templates returned */
  total_count: Scalars['Int']['output'];
};

export type NotificationHubListTemplatesPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotificationHubListTemplatesPayload;

export type NotificationHubListTimePeriodsInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Filter by label (partial, case-insensitive) */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationHubListTimePeriodsPayload = {
  __typename?: 'NotificationHubListTimePeriodsPayload';
  /** Time periods in display order */
  items: Array<NotificationHubTimePeriod>;
};

export type NotificationHubListTimePeriodsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotificationHubListTimePeriodsPayload;

export type NotificationHubMutations = {
  __typename?: 'NotificationHubMutations';
  /** Mutations for audience file imports */
  audience_imports: NotificationHubAudienceImportsMutations;
  /** Mutations for campaigns */
  campaigns: NotificationHubCampaignsMutations;
  /** Mutations for the example resource */
  examples: TemplateExamplesMutations;
  /** Mutations for custom email templates */
  templates: NotificationHubTemplatesMutations;
};

export type NotificationHubPauseCampaignInput = {
  /** ID of the campaign to pause */
  campaign_id: Scalars['UUID']['input'];
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
};

export type NotificationHubPauseCampaignPayload = {
  __typename?: 'NotificationHubPauseCampaignPayload';
  /** The paused campaign */
  campaign: NotificationHubCampaign;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type NotificationHubPauseCampaignPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubPauseCampaignPayload | ValidationErrorResponse;

export type NotificationHubProduct = {
  __typename?: 'NotificationHubProduct';
  /** Position in the picker, ascending from 1 */
  display_order: Scalars['Int']['output'];
  /** TRUE when the product's campaigns are live. FALSE means the product is listed but not usable yet — render it disabled with the "Próximamente" hint */
  is_available: Scalars['Boolean']['output'];
  /** Commercial product name to display, in Spanish */
  label: Scalars['String']['output'];
  /** Machine-readable product key, sent back as a filter */
  product_type: ProductType;
};

export type NotificationHubProgressRange = {
  __typename?: 'NotificationHubProgressRange';
  /** Progress range ID */
  id: Scalars['Int']['output'];
  /** Human-readable label to display */
  label: Scalars['String']['output'];
  /** Upper bound of the range, null when not a percentage range */
  max_value?: Maybe<Scalars['Int']['output']>;
  /** Lower bound of the range, null when not a percentage range */
  min_value?: Maybe<Scalars['Int']['output']>;
  /** Stable machine-readable key */
  slug: Scalars['String']['output'];
};

export type NotificationHubQueries = {
  __typename?: 'NotificationHubQueries';
  /** Queries for campaigns */
  campaigns: NotificationHubCampaignsQueries;
  /** Queries for the example resource */
  examples: TemplateExamplesQueries;
  /** Queries for email templates */
  templates: NotificationHubTemplatesQueries;
};

export type NotificationHubResumeCampaignInput = {
  /** ID of the campaign to resume */
  campaign_id: Scalars['UUID']['input'];
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
};

export type NotificationHubResumeCampaignPayload = {
  __typename?: 'NotificationHubResumeCampaignPayload';
  /** The resumed campaign */
  campaign: NotificationHubCampaign;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type NotificationHubResumeCampaignPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubResumeCampaignPayload | ValidationErrorResponse;

export enum NotificationHubRowClassificationEnum {
  AccountNotFound = 'ACCOUNT_NOT_FOUND',
  AmbiguousUsername = 'AMBIGUOUS_USERNAME',
  InvalidFormat = 'INVALID_FORMAT',
  NotALeader = 'NOT_A_LEADER',
  Valid = 'VALID'
}

export type NotificationHubSendTemplateTestEmailInput = {
  /** Files attached to the mail (max 3) */
  attachments?: InputMaybe<Array<NotificationHubTemplateAttachmentInput>>;
  /** Who the template addresses — decides which variables apply */
  audience_type: AudienceType;
  /** Shared-files id of the 1200x360 banner */
  banner_file_id?: InputMaybe<Scalars['String']['input']>;
  /** Content blocks — list order IS the render order */
  blocks: Array<NotificationHubTemplateBlockInput>;
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Admin aliases for real Crehana attributes */
  custom_variables?: InputMaybe<Array<NotificationHubTemplateCustomVariableInput>>;
  /** Template name — required before a test can be sent */
  name: Scalars['String']['input'];
  /** Email subject, may contain {{variables}} (max 60 chars) */
  subject: Scalars['String']['input'];
  /** Title rendered above the blocks */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationHubSendTemplateTestEmailPayload = {
  __typename?: 'NotificationHubSendTemplateTestEmailPayload';
  /** Address the test was sent to — always the session admin's own, echoed back so the editor can show where to look */
  recipient_email: Scalars['String']['output'];
  /** Subject as it was sent, with its variables already resolved */
  subject: Scalars['String']['output'];
  /** Whether the mail was accepted for delivery */
  success: Scalars['Boolean']['output'];
};

export type NotificationHubSendTemplateTestEmailPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotificationHubValidationErrorsResponseValidationErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubSendTemplateTestEmailPayload | NotificationHubValidationErrorsResponse | ValidationErrorResponse;

export type NotificationHubSyncCampaignTemplateInput = {
  /** ID of the campaign to sync */
  campaign_id: Scalars['UUID']['input'];
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
};

export type NotificationHubSyncCampaignTemplatePayload = {
  __typename?: 'NotificationHubSyncCampaignTemplatePayload';
  /** The campaign with updated template version */
  campaign: NotificationHubCampaign;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type NotificationHubSyncCampaignTemplatePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubSyncCampaignTemplatePayload | ValidationErrorResponse;

export type NotificationHubTemplateAttachment = {
  __typename?: 'NotificationHubTemplateAttachment';
  /** MIME type */
  content_type?: Maybe<Scalars['String']['output']>;
  /** Shared-files id of the file */
  file_id: Scalars['String']['output'];
  /** Original file name */
  name?: Maybe<Scalars['String']['output']>;
  /** Size in bytes */
  size?: Maybe<Scalars['Int']['output']>;
};

export type NotificationHubTemplateAttachmentInput = {
  /** MIME type reported at upload */
  content_type?: InputMaybe<Scalars['String']['input']>;
  /** Shared-files id of the file */
  file_id: Scalars['String']['input'];
  /** Original file name, shown on the chip */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Size in bytes, shown on the chip */
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationHubTemplateBlock = {
  __typename?: 'NotificationHubTemplateBlock';
  /** Editor-side block id */
  id: Scalars['String']['output'];
  /** Block properties */
  props: Scalars['JSON']['output'];
  /** Block type */
  type: NotificationHubTemplateBlockTypeEnum;
};

export type NotificationHubTemplateBlockInput = {
  /** Editor-side block id, echoed back in validation errors */
  id: Scalars['String']['input'];
  /** Block properties, validated against the catalog signature */
  props: Scalars['JSON']['input'];
  /** Block type — must exist in the block catalog */
  type: NotificationHubTemplateBlockTypeEnum;
};

/** Kind of content block. Its allowed props are defined by the block catalog, not by this schema — see the props field */
export enum NotificationHubTemplateBlockTypeEnum {
  Button = 'BUTTON',
  Divider = 'DIVIDER',
  Image = 'IMAGE',
  Metrics = 'METRICS',
  Text = 'TEXT'
}

export type NotificationHubTemplateCampaignUsage = {
  __typename?: 'NotificationHubTemplateCampaignUsage';
  /** Campaign unique identifier */
  campaign_id: Scalars['UUID']['output'];
  /** Campaign name as the admin named it */
  name: Scalars['String']['output'];
  /** Lifecycle state — ACTIVE or PAUSED, the two that still send */
  status: CampaignStatus;
};

export type NotificationHubTemplateCustomVariable = {
  __typename?: 'NotificationHubTemplateCustomVariable';
  /** Attribute the renderer resolves */
  attribute: Scalars['String']['output'];
  /** Label shown on the chip */
  display_name: Scalars['String']['output'];
};

export type NotificationHubTemplateCustomVariableInput = {
  /** Closed-list attribute key the renderer resolves */
  attribute: Scalars['String']['input'];
  /** Label the editor shows on the chip */
  display_name: Scalars['String']['input'];
};

export type NotificationHubTemplateImageUrl = {
  __typename?: 'NotificationHubTemplateImageUrl';
  /** Shared-files id, as it appears in the block's props.file_id */
  file_id: Scalars['String']['output'];
  /** Absolute URL an <img> can load. Null when shared-files could not resolve the id — show a placeholder, the id is still valid to save */
  url?: Maybe<Scalars['String']['output']>;
};

export type NotificationHubTemplateSortInput = {
  /** Sort direction (ASC or DESC) */
  direction: SortDirection;
  /** Column to sort by */
  field: TemplateSortField;
};

export type NotificationHubTemplatesMutations = {
  __typename?: 'NotificationHubTemplatesMutations';
  /** Create a custom email template with its first version */
  create_email_template: NotificationHubCreateEmailTemplatePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
  /** Soft-delete a custom email template, keeping its history */
  delete_email_template: NotificationHubDeleteEmailTemplatePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse;
  /** Edit a custom email template — appends the next version */
  edit_email_template: NotificationHubEditEmailTemplatePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
  /** Send the template as a test email to the admin's own address */
  send_template_test_email: NotificationHubSendTemplateTestEmailPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotificationHubValidationErrorsResponseValidationErrorResponseNotFoundResponseInternalErrorResponse;
};


export type NotificationHubTemplatesMutationsCreate_Email_TemplateArgs = {
  input: NotificationHubCreateEmailTemplateInput;
};


export type NotificationHubTemplatesMutationsDelete_Email_TemplateArgs = {
  input: NotificationHubDeleteEmailTemplateInput;
};


export type NotificationHubTemplatesMutationsEdit_Email_TemplateArgs = {
  input: NotificationHubEditEmailTemplateInput;
};


export type NotificationHubTemplatesMutationsSend_Template_Test_EmailArgs = {
  input: NotificationHubSendTemplateTestEmailInput;
};

export type NotificationHubTemplatesQueries = {
  __typename?: 'NotificationHubTemplatesQueries';
  /** Read one template with the content the editor repaints */
  get_email_template: NotificationHubGetEmailTemplatePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse;
  /** List the products the templates module can be scoped to (the PRODUCTO picker of the templates tab), including the ones not launched yet */
  list_products: NotificationHubListProductsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
  /** List the organization's email templates */
  list_templates: NotificationHubListTemplatesPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
  /** Check whether a template name can be saved, before saving */
  validate_template_name: NotificationHubValidateTemplateNamePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
};


export type NotificationHubTemplatesQueriesGet_Email_TemplateArgs = {
  input: NotificationHubGetEmailTemplateInput;
};


export type NotificationHubTemplatesQueriesList_ProductsArgs = {
  input: NotificationHubListProductsInput;
};


export type NotificationHubTemplatesQueriesList_TemplatesArgs = {
  input: NotificationHubListTemplatesInput;
};


export type NotificationHubTemplatesQueriesValidate_Template_NameArgs = {
  input: NotificationHubValidateTemplateNameInput;
};

export type NotificationHubTimePeriod = {
  __typename?: 'NotificationHubTimePeriod';
  /** Time period ID */
  id: Scalars['Int']['output'];
  /** Human-readable label to display */
  label: Scalars['String']['output'];
  /** Stable machine-readable key */
  slug: Scalars['String']['output'];
};

export type NotificationHubValidateAudienceImportInput = {
  /** Who the campaign is addressed to. LEADER makes every row prove the account leads somebody. Wins over the campaign's own value, which is what the wizard still has unsaved; falls back to it when omitted */
  audience_type?: InputMaybe<AudienceType>;
  /** Campaign the imported audience belongs to. Omit it while the campaign has not been saved yet */
  campaign_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Shared-files ID of the uploaded XLSX */
  file_id: Scalars['ID']['input'];
};

export type NotificationHubValidateAudienceImportPayload = {
  __typename?: 'NotificationHubValidateAudienceImportPayload';
  /** The validation result, already stored as PENDING */
  audience_import: NotificationHubAudienceImport;
  /** Whether the file could be validated */
  success: Scalars['Boolean']['output'];
};

export type NotificationHubValidateAudienceImportPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | NotificationHubValidateAudienceImportPayload | ValidationErrorResponse;

export type NotificationHubValidateCampaignNameInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID of the campaign being edited, so its own current name is not reported as taken (omit when creating) */
  exclude_campaign_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Campaign name to check */
  name: Scalars['String']['input'];
};

export type NotificationHubValidateCampaignNamePayload = {
  __typename?: 'NotificationHubValidateCampaignNamePayload';
  /** Why it cannot — CAMPAIGN_NAME_ALREADY_EXISTS or CAMPAIGN_NAME_TOO_LONG; null when valid */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Ready-to-render Spanish message; null when valid */
  error_message?: Maybe<Scalars['String']['output']>;
  /** True when the name can be saved as-is for this organization */
  is_valid: Scalars['Boolean']['output'];
};

export type NotificationHubValidateCampaignNamePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotificationHubValidateCampaignNamePayload;

export type NotificationHubValidateTemplateNameInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID of the template being edited, so its own current name is not reported as taken (omit when creating) */
  exclude_template_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Template name to check */
  name: Scalars['String']['input'];
};

export type NotificationHubValidateTemplateNamePayload = {
  __typename?: 'NotificationHubValidateTemplateNamePayload';
  /** Why it cannot — TEMPLATE_NAME_ALREADY_EXISTS or TEMPLATE_NAME_TOO_LONG; null when valid */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Ready-to-render Spanish message; null when valid */
  error_message?: Maybe<Scalars['String']['output']>;
  /** True when the name can be saved as-is for this organization */
  is_valid: Scalars['Boolean']['output'];
};

export type NotificationHubValidateTemplateNamePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotificationHubValidateTemplateNamePayload;

export type NotificationHubValidationErrorsResponse = {
  __typename?: 'NotificationHubValidationErrorsResponse';
  /** Code of the FIRST issue, for clients that key on a single code */
  code: Scalars['String']['output'];
  /** Every issue found, ordered by the section they belong to */
  errors: Array<NotificationHubValidationIssueType>;
  /** Operation ID for tracing */
  graphql_operation_id: Scalars['ID']['output'];
  /** Message of the FIRST issue, for clients that show only one */
  message: Scalars['String']['output'];
};

export type NotificationHubValidationIssueType = {
  __typename?: 'NotificationHubValidationIssueType';
  /** Machine code for this single failure, e.g. CAMPAIGN_NAME_REQUIRED */
  code: Scalars['String']['output'];
  /** Input field the failure belongs to, in snake_case and dotted for nested inputs (e.g. name, course_ids, frequency.send_time, segment_snapshot.rules[0]). Null when no single field owns it. */
  field?: Maybe<Scalars['String']['output']>;
  /** Opaque section key the client maps to its own UI step. For campaigns: BASIC_INFO, CONTENT, TEMPLATE, FREQUENCY, AUDIENCE. */
  group?: Maybe<Scalars['String']['output']>;
  /** Human-readable message in Spanish */
  message: Scalars['String']['output'];
};

export type NotificationHubWeek = {
  __typename?: 'NotificationHubWeek';
  /** Days within this week */
  days: Array<NotificationHubWeekDay>;
  /** Whether this week is skipped */
  is_skipped: Scalars['Boolean']['output'];
  /** Week number (1-based) */
  week_number: Scalars['Int']['output'];
};

export type NotificationHubWeekDay = {
  __typename?: 'NotificationHubWeekDay';
  /** Day of week (0=Monday .. 6=Sunday) */
  day_of_week: Scalars['Int']['output'];
  /** Time to send on this day */
  send_time: Scalars['Time']['output'];
};

export type NotificationHubWeekDayInput = {
  /** Day of week (0=Monday .. 6=Sunday) */
  day_of_week: Scalars['Int']['input'];
  /** Time to send on this day */
  send_time: Scalars['Time']['input'];
};

export type NotificationHubWeekInput = {
  /** Days within this week */
  days?: Array<NotificationHubWeekDayInput>;
  /** Whether this week is skipped */
  is_skipped?: Scalars['Boolean']['input'];
  /** Week number (1-based) */
  week_number: Scalars['Int']['input'];
};

export type NotificationMutationNode = {
  __typename?: 'NotificationMutationNode';
  /** Contains an instance of the notification model */
  notification?: Maybe<NotificationNode>;
  /**
   * This object contains information about the response code,
   *         response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationNode = {
  __typename?: 'NotificationNode';
  /** Amplitud event type */
  amplitud_event_type?: Maybe<Scalars['String']['output']>;
  category_id?: Maybe<Scalars['String']['output']>;
  has_problem: Scalars['Boolean']['output'];
  icon_image?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  in_app_event?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  /** Notification type */
  notification_type: Scalars['String']['output'];
  platforms: Array<Scalars['String']['output']>;
  redirect_url?: Maybe<Scalars['String']['output']>;
  redirect_url_name?: Maybe<Scalars['String']['output']>;
  subcategory_id?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type NotificationNodeEdge = {
  __typename?: 'NotificationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: NotificationNode;
};

export type NotificationSeenFragmentNode = EventNotificationSeenNode | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type NotificationsCenterMutations = {
  __typename?: 'NotificationsCenterMutations';
  /** Update or create a notification configuration */
  update_or_create_notification_configuration: NcUpdateOrCreateNotificationPayloadResponseInternalErrorResponseValidationErrorResponseIntegrityError;
  /** Update or create a notification configuration bulk */
  update_or_create_notification_configuration_bulk: NcUpdateOrCreateNotificationBulkPayloadResponseInternalErrorResponseValidationErrorResponseIntegrityError;
};


export type NotificationsCenterMutationsUpdate_Or_Create_Notification_ConfigurationArgs = {
  input: NcUpdateOrCreateNotificationInput;
};


export type NotificationsCenterMutationsUpdate_Or_Create_Notification_Configuration_BulkArgs = {
  input: NcUpdateOrCreateNotificationBulkInput;
};

export type NotificationsCenterQueries = {
  __typename?: 'NotificationsCenterQueries';
  /** Retrieves all notification channels that the admin can manage. */
  get_channels: NcGetChannelsPayloadResponseInternalErrorResponseValidationErrorResponseIntegrityError;
  /** Retrieves a notification template for an specific centralized organization id */
  get_notification_template: NcGetNotificationTemplatePayloadResponseInternalErrorResponseValidationErrorResponseIntegrityError;
  /** Retrieves a notification configuration for an specific centralized organization id */
  get_organization_notification: NcGetOrganizationNotificationPayloadResponseInternalErrorResponseValidationErrorResponseIntegrityError;
  /** Retrieves filtered and paginated notification configurations */
  get_organization_notifications: NcGetOrganizationNotificationsPayloadResponseInternalErrorResponseValidationErrorResponseIntegrityError;
};


export type NotificationsCenterQueriesGet_ChannelsArgs = {
  input: NcGetChannelsInput;
};


export type NotificationsCenterQueriesGet_Notification_TemplateArgs = {
  input: NcGetNotificationTemplateInput;
};


export type NotificationsCenterQueriesGet_Organization_NotificationArgs = {
  input: NcGetOrganizationNotificationInput;
};


export type NotificationsCenterQueriesGet_Organization_NotificationsArgs = {
  input: NcGetOrganizationNotificationsInput;
};

export type NumberPageInfo = PageInfoI & {
  __typename?: 'NumberPageInfo';
  /** When paginating forwards, are there more items? */
  has_next_page: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  has_previous_page: Scalars['Boolean']['output'];
  total_pages: Scalars['Int']['output'];
};

export type OAuthAuthorizeInput = {
  client_id: Scalars['String']['input'];
  code_challenge?: InputMaybe<Scalars['String']['input']>;
  code_challenge_method?: Scalars['String']['input'];
  nonce?: InputMaybe<Scalars['String']['input']>;
  redirect_uri: Scalars['String']['input'];
  response_type?: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type OAuthAuthorizePayload = {
  __typename?: 'OAuthAuthorizePayload';
  code: Scalars['String']['output'];
  redirect_uri: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type OAuthAuthorizePayloadOAuthErrorResponse = OAuthAuthorizePayload | OAuthErrorResponse;

export type OAuthClientPayload = {
  __typename?: 'OAuthClientPayload';
  allowed_scopes: Array<Scalars['String']['output']>;
  client_id: Scalars['String']['output'];
  client_name: Scalars['String']['output'];
  client_type: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  redirect_uris: Array<Scalars['String']['output']>;
  token_endpoint_auth_method: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};

export type OAuthClientPayloadQueryValidationErrorQueryInternalServerError = OAuthClientPayload | QueryInternalServerError | QueryValidationError;

export type OAuthClientPayloadValidationMutationErrorInternalServerMutationError = InternalServerMutationError | OAuthClientPayload | ValidationMutationError;

export type OAuthClientsPayload = {
  __typename?: 'OAuthClientsPayload';
  clients: Array<OAuthClientPayload>;
  total: Scalars['Int']['output'];
};

export type OAuthClientsPayloadQueryInternalServerError = OAuthClientsPayload | QueryInternalServerError;

export type OAuthErrorResponse = {
  __typename?: 'OAuthErrorResponse';
  error: Scalars['String']['output'];
  error_description?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type OAuthIntrospectInput = {
  client_id?: InputMaybe<Scalars['String']['input']>;
  client_secret?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  token_type_hint?: InputMaybe<Scalars['String']['input']>;
};

export type OAuthIntrospectPayload = {
  __typename?: 'OAuthIntrospectPayload';
  active: Scalars['Boolean']['output'];
  aud?: Maybe<Scalars['String']['output']>;
  client_id?: Maybe<Scalars['String']['output']>;
  exp?: Maybe<Scalars['Int']['output']>;
  iss?: Maybe<Scalars['String']['output']>;
  jti?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  sub?: Maybe<Scalars['String']['output']>;
  token_type?: Maybe<Scalars['String']['output']>;
};

export type OAuthIntrospectPayloadOAuthErrorResponse = OAuthErrorResponse | OAuthIntrospectPayload;

export type OAuthRegisterClientInput = {
  client_name?: InputMaybe<Scalars['String']['input']>;
  grant_types?: InputMaybe<Array<Scalars['String']['input']>>;
  redirect_uris: Array<Scalars['String']['input']>;
  response_types?: InputMaybe<Array<Scalars['String']['input']>>;
  scope?: InputMaybe<Scalars['String']['input']>;
  token_endpoint_auth_method?: Scalars['String']['input'];
};

export type OAuthRegisterClientPayload = {
  __typename?: 'OAuthRegisterClientPayload';
  client_id: Scalars['String']['output'];
  client_id_issued_at: Scalars['Int']['output'];
  client_name?: Maybe<Scalars['String']['output']>;
  client_secret?: Maybe<Scalars['String']['output']>;
  grant_types: Array<Scalars['String']['output']>;
  redirect_uris: Array<Scalars['String']['output']>;
  response_types: Array<Scalars['String']['output']>;
  scope: Scalars['String']['output'];
  token_endpoint_auth_method: Scalars['String']['output'];
};

export type OAuthRegisterClientPayloadOAuthErrorResponse = OAuthErrorResponse | OAuthRegisterClientPayload;

export type OAuthRevokeInput = {
  client_id?: InputMaybe<Scalars['String']['input']>;
  client_secret?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  token_type_hint?: InputMaybe<Scalars['String']['input']>;
};

export type OAuthTokenInput = {
  client_id?: InputMaybe<Scalars['String']['input']>;
  client_secret?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_verifier?: InputMaybe<Scalars['String']['input']>;
  grant_type: Scalars['String']['input'];
  redirect_uri?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
};

export type OAuthTokenPayload = {
  __typename?: 'OAuthTokenPayload';
  access_token: Scalars['String']['output'];
  expires_in: Scalars['Int']['output'];
  id_token?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  scope: Scalars['String']['output'];
  token_type: Scalars['String']['output'];
};

export type OAuthTokenPayloadOAuthErrorResponse = OAuthErrorResponse | OAuthTokenPayload;

export type OAuthUserinfoInput = {
  access_token: Scalars['String']['input'];
};

export type OAuthUserinfoPayload = {
  __typename?: 'OAuthUserinfoPayload';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sub: Scalars['String']['output'];
};

export type OAuthUserinfoPayloadOAuthErrorResponse = OAuthErrorResponse | OAuthUserinfoPayload;

export enum ObjectTypeEnum {
  TypeCourse = 'TYPE_COURSE',
  TypeLearningPath = 'TYPE_LEARNING_PATH',
  TypeProject = 'TYPE_PROJECT',
  TypeQuiz = 'TYPE_QUIZ'
}

export type ObjectTypeInput = {
  object_id?: InputMaybe<Scalars['Int']['input']>;
  object_type?: InputMaybe<ObjectTypeEnum>;
};

export enum ObjectsForEnum {
  Course = 'COURSE',
  VideoLecture = 'VIDEO_LECTURE'
}

/** Returned when post or comment content matches one or more channel-configured blocked words/phrases. */
export type OffensiveWordsBlockedError = {
  __typename?: 'OffensiveWordsBlockedError';
  /** Stable code for this error so the frontend can branch on it. */
  code: Scalars['String']['output'];
  /** Identifier of the GraphQL operation, for log correlation. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Channel-stored blocked entries that matched the submitted content, deduplicated and in channel-list insertion order. */
  matched_words: Array<Scalars['String']['output']>;
  /** Default human-readable message; the frontend should compose its own copy from `matched_words`. */
  message: Scalars['String']['output'];
};

export enum OffsetDirection {
  After = 'AFTER',
  Before = 'BEFORE',
  On = 'ON'
}

export type OffsetPaginationInput = {
  /** Page number (1-based) */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Items per page */
  page_size?: InputMaybe<Scalars['Int']['input']>;
};

export enum OffsetUnit {
  Days = 'DAYS',
  Months = 'MONTHS'
}

export enum OkrPeriodSearchFieldsEnum {
  OkrPeriodName = 'OKR_PERIOD_NAME'
}

export type OkrPeriodSearchInput = {
  fields: Array<OkrPeriodSearchFieldsEnum>;
  query: Scalars['String']['input'];
};

export type OpenAiConversation = {
  __typename?: 'OpenAIConversation';
  created_at: Scalars['DateTime']['output'];
  openai_model: OpenAiConversationModelEnum;
  openai_organization?: Maybe<Scalars['String']['output']>;
  openai_stop: Array<Scalars['String']['output']>;
  uid: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type OpenAiConversationInput = {
  conversation_uid?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<OpenAiConversationModelEnum>;
};

export enum OpenAiConversationModelEnum {
  Gpt_3_5Turbo = 'GPT_3_5_TURBO',
  Gpt_4 = 'GPT_4',
  TextDavinci_003 = 'TEXT_DAVINCI_003'
}

export type OpenAiConversationMutation = {
  __typename?: 'OpenAIConversationMutation';
  send_message: OpenAiMessagePayload;
  send_message_prompt: OpenAiMessagePayload;
};


export type OpenAiConversationMutationSend_MessageArgs = {
  input: OpenAiConversationSendMessageInput;
};


export type OpenAiConversationMutationSend_Message_PromptArgs = {
  input: OpenAiConversationSendMessagePromptInput;
};

export type OpenAiConversationQuery = {
  __typename?: 'OpenAIConversationQuery';
  get_conversation?: Maybe<OpenAiConversation>;
  get_conversation_message?: Maybe<OpenAiMessage>;
  get_conversation_messages?: Maybe<Array<OpenAiMessage>>;
};


export type OpenAiConversationQueryGet_ConversationArgs = {
  conversation_uid: Scalars['String']['input'];
};


export type OpenAiConversationQueryGet_Conversation_MessageArgs = {
  message_uid: Scalars['String']['input'];
};


export type OpenAiConversationQueryGet_Conversation_MessagesArgs = {
  conversation_uid: Scalars['String']['input'];
};

export type OpenAiConversationSendMessageInput = {
  text: Scalars['String']['input'];
};

export type OpenAiConversationSendMessagePromptInput = {
  prompt_key: Scalars['String']['input'];
  prompt_kwargs?: InputMaybe<Scalars['String']['input']>;
  prompt_version?: InputMaybe<Scalars['Int']['input']>;
};

export type OpenAiMessage = {
  __typename?: 'OpenAIMessage';
  conversation: OpenAiConversation;
  created_at: Scalars['DateTime']['output'];
  finish_reason?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  openai_id?: Maybe<Scalars['String']['output']>;
  prompt_version?: Maybe<OpenAiPromptVersion>;
  response: Scalars['String']['output'];
  response_format?: Maybe<OpenAiMessageResponseFormatEnum>;
  response_formatted?: Maybe<Scalars['JSON']['output']>;
  response_ms?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
  uid: Scalars['ID']['output'];
  usage_completion_tokens?: Maybe<Scalars['String']['output']>;
  usage_prompt_tokens?: Maybe<Scalars['String']['output']>;
  usage_total_tokens?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type OpenAiMessagePayload = {
  __typename?: 'OpenAIMessagePayload';
  message: OpenAiMessage;
};

export enum OpenAiMessageResponseFormatEnum {
  FormatJson = 'FORMAT_JSON',
  FormatNone = 'FORMAT_NONE',
  FormatYaml = 'FORMAT_YAML'
}

export type OpenAiPrompt = {
  __typename?: 'OpenAIPrompt';
  created_at: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type OpenAiPromptVersion = {
  __typename?: 'OpenAIPromptVersion';
  created_at: Scalars['DateTime']['output'];
  is_active: Scalars['Boolean']['output'];
  model: OpenAiConversationModelEnum;
  prompt: OpenAiPrompt;
  text: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

export type OpenidConfigurationPayload = {
  __typename?: 'OpenidConfigurationPayload';
  authorization_endpoint: Scalars['String']['output'];
  code_challenge_methods_supported: Array<Scalars['String']['output']>;
  grant_types_supported: Array<Scalars['String']['output']>;
  id_token_signing_alg_values_supported: Array<Scalars['String']['output']>;
  introspection_endpoint: Scalars['String']['output'];
  issuer: Scalars['String']['output'];
  jwks_uri: Scalars['String']['output'];
  registration_endpoint?: Maybe<Scalars['String']['output']>;
  response_types_supported: Array<Scalars['String']['output']>;
  revocation_endpoint: Scalars['String']['output'];
  scopes_supported: Array<Scalars['String']['output']>;
  subject_types_supported: Array<Scalars['String']['output']>;
  token_endpoint: Scalars['String']['output'];
  token_endpoint_auth_methods_supported: Array<Scalars['String']['output']>;
  userinfo_endpoint: Scalars['String']['output'];
};

export type OptionAnswer = {
  __typename?: 'OptionAnswer';
  value: Scalars['String']['output'];
};

export type OptionResponse = {
  __typename?: 'OptionResponse';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  other: Scalars['Boolean']['output'];
  parent_key?: Maybe<Scalars['String']['output']>;
  percentage: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Order = {
  __typename?: 'Order';
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  invoice_data?: Maybe<InvoiceDataQueryNode>;
  local_amount?: Maybe<Scalars['Float']['output']>;
  local_currency?: Maybe<Scalars['String']['output']>;
  order_card?: Maybe<OrderCardNode>;
  organization_id: Scalars['Int']['output'];
  paid_at?: Maybe<Scalars['DateTime']['output']>;
  payment_gateway?: Maybe<PaymentGatewayNode>;
  payment_res_code?: Maybe<Scalars['String']['output']>;
  payment_res_message?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  product_id?: Maybe<Scalars['Int']['output']>;
  reference_code?: Maybe<Scalars['String']['output']>;
  refund_at?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  usd_amount?: Maybe<Scalars['Float']['output']>;
  user_id: Scalars['Int']['output'];
};

export enum OrderAndDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum OrderByColumnEnum {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  Status = 'STATUS'
}

export type OrderByInput = {
  column: OrderByColumnEnum;
  direction: OrderDirectionEnum;
};

export type OrderCardNode = {
  __typename?: 'OrderCardNode';
  brand?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  holder?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last4?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type OrderConnection = {
  __typename?: 'OrderConnection';
  /** Contains the nodes in this connection */
  edges: Array<OrderEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export enum OrderDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** An edge in a connection. */
export type OrderEdge = {
  __typename?: 'OrderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Order;
};

/** Enum representing user attributes available for ordering the user list. */
export enum OrderUserAttributeEnum {
  Area = 'AREA',
  Email = 'EMAIL',
  FullName = 'FULL_NAME',
  Position = 'POSITION'
}

/** An organizational area (Dirección, Departamento, Oficina, or Suboficina). */
export type OrgAreaNode = {
  __typename?: 'OrgAreaNode';
  /** Area ID. */
  id: Scalars['Int']['output'];
  /** Area name. */
  name: Scalars['String']['output'];
  /** Parent area ID. Null for root areas (Dirección level). */
  parent_id?: Maybe<Scalars['Int']['output']>;
};

/** A sede (headquarter) available in the organization. */
export type OrgHeadquarterNode = {
  __typename?: 'OrgHeadquarterNode';
  /** Headquarter ID. */
  id: Scalars['Int']['output'];
  /** Headquarter name. */
  name: Scalars['String']['output'];
};

/** A position category (categoría de cargo) available in the organization. */
export type OrgPositionCategoryNode = {
  __typename?: 'OrgPositionCategoryNode';
  /** Position category ID. */
  id: Scalars['Int']['output'];
  /** Position category name. */
  name: Scalars['String']['output'];
};

/** A job position (cargo) available in the organization. */
export type OrgPositionNode = {
  __typename?: 'OrgPositionNode';
  /** Position ID. */
  id: Scalars['Int']['output'];
  /** Position name. */
  name: Scalars['String']['output'];
};

export type OrganizationAccessLevelNode = {
  __typename?: 'OrganizationAccessLevelNode';
  access_level_enum: AccessLevelEnum;
  organization_id: Scalars['Int']['output'];
};

export type OrganizationAccountNode = {
  __typename?: 'OrganizationAccountNode';
  account_id?: Maybe<Scalars['Int']['output']>;
  has_full_suite?: Maybe<Scalars['Boolean']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_active_manage?: Maybe<Scalars['Boolean']['output']>;
  org_id: Scalars['ID']['output'];
  org_name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type OrganizationActivityPerDay = {
  __typename?: 'OrganizationActivityPerDay';
  day: Scalars['Date']['output'];
  played_seconds?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationActivityPerHour = {
  __typename?: 'OrganizationActivityPerHour';
  day_week: Scalars['String']['output'];
  hours: Array<ActivityPerHour>;
};

/** Area Node */
export type OrganizationAreaAllNode = {
  __typename?: 'OrganizationAreaAllNode';
  area_level: OrganizationAreaLevelAllNode;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parent_id?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationAreaAllNodeCustomConnection = {
  __typename?: 'OrganizationAreaAllNodeCustomConnection';
  edges: Array<OrganizationAreaAllNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type OrganizationAreaAllNodeCustomEdge = {
  __typename?: 'OrganizationAreaAllNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OrganizationAreaAllNode;
};

/** Enum representing area attributes available for ordering the user list. */
export enum OrganizationAreaAttributeEnum {
  CreatedAt = 'CREATED_AT',
  Level = 'LEVEL',
  Name = 'NAME'
}

/** Paginated list of users matched by segmentation conditionals. */
export type OrganizationAreaByOrganization = {
  __typename?: 'OrganizationAreaByOrganization';
  areas: Array<CentralizedOrganizationAreaNode>;
  page_info: PageInfo;
  total_count: Scalars['Int']['output'];
};

export enum OrganizationAreaFilterBy {
  Az = 'AZ',
  CreatedAt = 'CREATED_AT',
  Za = 'ZA'
}

/** Area Level Node */
export type OrganizationAreaLevelAllNode = {
  __typename?: 'OrganizationAreaLevelAllNode';
  custom_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  level_sequence: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Centralized Organization Area Levels Node */
export type OrganizationAreaLevelNode = {
  __typename?: 'OrganizationAreaLevelNode';
  /** Area Level Custom Name */
  custom_name: Scalars['String']['output'];
  /** Area Level Has Active Users */
  has_users: Scalars['Boolean']['output'];
  /** Area Level ID */
  id: Scalars['Int']['output'];
  /** Area Level Is Active */
  is_active: Scalars['Boolean']['output'];
  /** Area Level Sequence */
  level_sequence: Scalars['String']['output'];
  /** Area Level Name */
  name: Scalars['String']['output'];
};

/** Represents an organization area */
export type OrganizationAreaNode = {
  __typename?: 'OrganizationAreaNode';
  /** Area ID */
  id: Scalars['Int']['output'];
  /** Area Label */
  label: Scalars['String']['output'];
  /** Area Name */
  name: Scalars['String']['output'];
  /** Original ID */
  original_id: Scalars['Int']['output'];
};

export type OrganizationAreaQueries = {
  __typename?: 'OrganizationAreaQueries';
  /** Retrieve areas by parent_id and area levels. */
  get_areas_by_organization: OrganizationAreaQueryResponse;
  /** Search organization areas whose name contains the given text (case-insensitive substring; % and _ are matched literally, not as wildcards) and return the full ancestor path and hierarchy IDs ready for the move workflow. Requires at least 2 characters: shorter or blank input returns an empty result set instead of the whole tree. limit is capped at 10. */
  search_areas_by_name: AreaSearchResponse;
};


export type OrganizationAreaQueriesGet_Areas_By_OrganizationArgs = {
  input: AreaInput;
};


export type OrganizationAreaQueriesSearch_Areas_By_NameArgs = {
  input: AreaSearchInput;
};

export type OrganizationAreaQueryResponse = ForbiddenErrorResponse | InternalErrorResponse | NotFoundResponse | OrganizationAreaByOrganization;

export type OrganizationAuthenticationMethodPayload = {
  __typename?: 'OrganizationAuthenticationMethodPayload';
  method: AuthenticationMethodEnum;
  method_url: Scalars['String']['output'];
  organization: CrehanaAuthOrganization;
  provider: AuthenticationProviderEnum;
};

export type OrganizationBaseInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationBuilderQuery = {
  __typename?: 'OrganizationBuilderQuery';
  /** Resolve which access case applies to whoever opens a course link, from their session token and a course id. Returns flags only — never a link. */
  course_viewer_role: CourseViewerRoleResponse;
  /** Retrieve Organization Access Level */
  organization_access_level?: Maybe<OrganizationAccessLevelNode>;
  /** Retrieve Organization courses */
  organization_courses?: Maybe<OrganizationCoursesNode>;
};


export type OrganizationBuilderQueryCourse_Viewer_RoleArgs = {
  input: CourseViewerRoleInput;
};


export type OrganizationBuilderQueryOrganization_Access_LevelArgs = {
  input: OrganizationBaseInput;
};


export type OrganizationBuilderQueryOrganization_CoursesArgs = {
  input: OrganizationCoursesInput;
};

export type OrganizationCertificateNode = {
  __typename?: 'OrganizationCertificateNode';
  certificate_id: Scalars['Int']['output'];
  course_id: Scalars['Int']['output'];
  course_is_mandatory: Scalars['Boolean']['output'];
  course_title: Scalars['String']['output'];
  days_to_expire?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  issued_at: Scalars['DateTime']['output'];
  pdf_url?: Maybe<Scalars['String']['output']>;
  status: CertificateValidityStatus;
  user_avatar_url?: Maybe<Scalars['String']['output']>;
  user_department?: Maybe<Scalars['String']['output']>;
  user_email: Scalars['String']['output'];
  user_full_name: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
};

export enum OrganizationCertificateStatusFilter {
  Expired = 'EXPIRED',
  ExpiringSoon = 'EXPIRING_SOON',
  NoExpiration = 'NO_EXPIRATION',
  Valid = 'VALID'
}

export type OrganizationCertificatesConnection = {
  __typename?: 'OrganizationCertificatesConnection';
  items: Array<OrganizationCertificateNode>;
  page: Scalars['Int']['output'];
  page_size: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type OrganizationCertificatesFilter = {
  /** Partial, case-insensitive match over user name, email, course title, and certificate id. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Restrict results to this validity status, or NO_EXPIRATION. */
  status?: InputMaybe<OrganizationCertificateStatusFilter>;
};

export enum OrganizationCertificatesOrderField {
  ExpiresAt = 'EXPIRES_AT',
  IssuedAt = 'ISSUED_AT'
}

export type OrganizationChartAreaSummaryResponse = {
  __typename?: 'OrganizationChartAreaSummaryResponse';
  area?: Maybe<CentralizedUserAreaNode>;
  users?: Maybe<Array<OrganizationChartUser>>;
};

export type OrganizationChartConfigResponse = {
  __typename?: 'OrganizationChartConfigResponse';
  ceo?: Maybe<CeoInfoNode>;
  is_visible_to_members: Scalars['Boolean']['output'];
};

export type OrganizationChartInfoPayload = UsersGraphOperationI & {
  __typename?: 'OrganizationChartInfoPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<UserMetadataOuput>;
};

export type OrganizationChartInfoResponse = CentralizedIntegrityError | CentralizedInternalError | CentralizedValidationError | OrganizationChartInfoPayload;

export type OrganizationChartMetadataResponse = {
  __typename?: 'OrganizationChartMetadataResponse';
  code?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type OrganizationChartUser = {
  __typename?: 'OrganizationChartUser';
  areas: Array<Scalars['String']['output']>;
  boss_id?: Maybe<Scalars['Int']['output']>;
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  headquarter: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  image_url: Scalars['String']['output'];
  /** True si el solicitante no puede ver a esta persona por restricción de sedes: sus datos personales vienen vacíos y la foto es el placeholder genérico. El nodo sigue en el árbol para no romper la jerarquía, así que se puede bajar por sus reports. */
  is_private: Scalars['Boolean']['output'];
  lastname: Scalars['String']['output'];
  position: Scalars['String']['output'];
  reports?: Maybe<OrganizationChartUserReports>;
  role_category: Scalars['String']['output'];
};

export type OrganizationChartUserFilterByInput = {
  areas?: InputMaybe<AreaLevels>;
};

export type OrganizationChartUserReports = {
  __typename?: 'OrganizationChartUserReports';
  items?: Maybe<Array<OrganizationChartUser>>;
  total: Scalars['Int']['output'];
};

export type OrganizationChartUserResponse = {
  __typename?: 'OrganizationChartUserResponse';
  details?: Maybe<OrganizationChartMetadataResponse>;
  total_count?: Maybe<Scalars['Int']['output']>;
  total_user_with_joss?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<OrganizationChartUser>>;
};

export type OrganizationChartUserSummaryResponse = {
  __typename?: 'OrganizationChartUserSummaryResponse';
  area_members?: Maybe<OrganizationChartAreaSummaryResponse>;
  boss?: Maybe<OrganizationChartUser>;
  reports?: Maybe<Array<OrganizationChartUser>>;
};

/** Input for organization classroom curso detail query [Admin]. */
export type OrganizationClassroomCourseInput = {
  course_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
};

export type OrganizationClassroomCourseNode = {
  __typename?: 'OrganizationClassroomCourseNode';
  can_upload_project: Scalars['Boolean']['output'];
  course?: Maybe<PrivateCourseType>;
  required: Scalars['Boolean']['output'];
};

export type OrganizationCourseInstructorData = {
  agent_type_enum: AgentTypeEnum;
  code_dc5?: InputMaybe<Scalars['String']['input']>;
  code_stps?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization_id: Scalars['Int']['input'];
  organization_instructor_id?: InputMaybe<Scalars['ID']['input']>;
  organization_name_id?: InputMaybe<Scalars['ID']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
  signature_file_id?: InputMaybe<Scalars['Int']['input']>;
  signature_name?: InputMaybe<Scalars['String']['input']>;
  theme_option_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type OrganizationCourseInstructorInput = {
  organization_instructor: OrganizationCourseInstructorData;
};

export type OrganizationCourseInstructorNode = {
  __typename?: 'OrganizationCourseInstructorNode';
  agent_type: AgentTypeEnum;
  code_dc5?: Maybe<Scalars['String']['output']>;
  code_stps?: Maybe<Scalars['String']['output']>;
  document_signature_file?: Maybe<File>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization_id: Scalars['Int']['output'];
  organization_name?: Maybe<Dc3OrganizationNameNode>;
  rfc?: Maybe<Scalars['String']['output']>;
  signature_file_id?: Maybe<Scalars['Int']['output']>;
  signature_name?: Maybe<Scalars['String']['output']>;
  theme_options?: Maybe<Array<Dc3ThemeOptionNode>>;
};

export type OrganizationCourseInstructorNodeConnection = {
  __typename?: 'OrganizationCourseInstructorNodeConnection';
  /** A list of edges in this connection. */
  edges: Array<OrganizationCourseInstructorNodeEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type OrganizationCourseInstructorNodeConnectionQueryInternalError = OrganizationCourseInstructorNodeConnection | QueryInternalError;

export type OrganizationCourseInstructorNodeEdge = {
  __typename?: 'OrganizationCourseInstructorNodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrganizationCourseInstructorNode;
};

export type OrganizationCourseInstructorResponsePayload = {
  __typename?: 'OrganizationCourseInstructorResponsePayload';
  organization_instructor: OrganizationCourseInstructorNode;
  organization_name?: Maybe<Scalars['String']['output']>;
};

export type OrganizationCourseInstructorsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  agent_type_enum?: InputMaybe<AgentTypeEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<SearchInput>;
};

export type OrganizationCourseTeamDependenceRuleNode = {
  __typename?: 'OrganizationCourseTeamDependenceRuleNode';
  course: Course;
  course_id: Scalars['Int']['output'];
  original_id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
};

export type OrganizationCoursesInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationCoursesNode = {
  __typename?: 'OrganizationCoursesNode';
  new_courses_by_organization: Array<ContentCourseNode>;
};

export type OrganizationCreateDocumentInput = {
  action?: InputMaybe<DocumentActionEnum>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  extension: DocumentExtension;
  file_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  visibility_level: VisibilityLevelType;
};

/** Organization Department */
export type OrganizationDepartmentNode = {
  __typename?: 'OrganizationDepartmentNode';
  /** Department name */
  name: Scalars['String']['output'];
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Original ID */
  original_id: Scalars['Int']['output'];
};

/** Centralized Organization Main Area Node */
export type OrganizationDetailAreaNode = {
  __typename?: 'OrganizationDetailAreaNode';
  /** Area IDs List to get users */
  area_ids?: Maybe<Array<Scalars['Int']['output']>>;
  /** Creation Date */
  created_at: Scalars['String']['output'];
  /** Sub Areas Detail */
  detailed_areas: Array<OrganizationDetailSubAreaNode>;
  /** Users directly assigned */
  directly_assigned_users_count?: Maybe<Scalars['Int']['output']>;
  /** Area Hierarchy */
  hierarchy?: Maybe<Scalars['String']['output']>;
  /** Area Label */
  label: Scalars['String']['output'];
  /** Area Level Name */
  level_name: Scalars['String']['output'];
  /** Area Level Sequence */
  level_sequence: Scalars['Int']['output'];
  /** Area Name */
  name: Scalars['String']['output'];
  /** Sub Areas List */
  sub_areas: Array<OrganizationQuerySubAreaNode>;
  /** Total User Count */
  total_user_count: Scalars['Int']['output'];
};

/** Centralized Organization Detail Headquarter Node */
export type OrganizationDetailHeadquarterNode = {
  __typename?: 'OrganizationDetailHeadquarterNode';
  /** Address Line 1 */
  address1?: Maybe<Scalars['String']['output']>;
  /** Address Line 2 */
  address2?: Maybe<Scalars['String']['output']>;
  /** Address Line 3 */
  address3?: Maybe<Scalars['String']['output']>;
  /** City */
  city?: Maybe<Scalars['String']['output']>;
  /** Country Code (ISO 3166-1 alpha-2) */
  country_code?: Maybe<Scalars['String']['output']>;
  /** Creation Date */
  created_at: Scalars['String']['output'];
  /** If the Organization Headquarter is active */
  is_active: Scalars['Boolean']['output'];
  /** Main Organization Headquarter */
  is_main: Scalars['Boolean']['output'];
  /** Latitude */
  latitude?: Maybe<Scalars['String']['output']>;
  /** Longitude */
  longitude?: Maybe<Scalars['String']['output']>;
  /** Organization Headquarter Name */
  name: Scalars['String']['output'];
  /** Organization Area Level List */
  organization_area_levels?: Maybe<Array<OrganizationQueryAreaLevelNode>>;
  /** Organization Area List */
  organization_areas?: Maybe<Array<OrganizationDetailAreaNode>>;
  /** Original ID */
  original_id: Scalars['Int']['output'];
  /** Postal Code */
  postal_code?: Maybe<Scalars['String']['output']>;
  /** State */
  state?: Maybe<Scalars['String']['output']>;
  /** Total User Count */
  total_count: Scalars['Int']['output'];
};

/** Centralized Organization Sub Area Node */
export type OrganizationDetailSubAreaNode = {
  __typename?: 'OrganizationDetailSubAreaNode';
  /** Area IDs List to get users */
  area_ids?: Maybe<Array<Scalars['Int']['output']>>;
  /** Users directly assigned */
  directly_assigned_users_count?: Maybe<Scalars['Int']['output']>;
  /** Area Hierarchy */
  hierarchy?: Maybe<Scalars['String']['output']>;
  /** Area id */
  id: Scalars['Int']['output'];
  /** Area Label */
  label: Scalars['String']['output'];
  /** Area Level Name */
  level_name: Scalars['String']['output'];
  /** Area Level Sequence */
  level_sequence: Scalars['Int']['output'];
  /** Area Name */
  name: Scalars['String']['output'];
  sub_areas?: Maybe<Array<OrganizationDetailSubAreaNode>>;
  /** User Count */
  user_count: Scalars['Int']['output'];
};

export type OrganizationDocumentConfigNode = {
  __typename?: 'OrganizationDocumentConfigNode';
  extension_allowed: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  max_files_allowed_per_upload: Scalars['Int']['output'];
  max_size_file_to_upload: Scalars['Int']['output'];
  max_storage_size: Scalars['Int']['output'];
};

export type OrganizationDocumentInput = {
  action?: InputMaybe<DocumentActionEnum>;
  description: Scalars['String']['input'];
  extension: DocumentExtension;
  file_id: Scalars['Int']['input'];
  list_category_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  visibility_level: VisibilityLevelType;
};

export type OrganizationDocumentType = {
  __typename?: 'OrganizationDocumentType';
  extension?: Maybe<DocumentExtension>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Organization Enterprise External Node */
export type OrganizationEnterpriseExternalNode = {
  __typename?: 'OrganizationEnterpriseExternalNode';
  /** Creation timestamp */
  created_at: Scalars['DateTime']['output'];
  /** External UUID identifier */
  external_id: Scalars['String']['output'];
  /** Primary key ID */
  id: Scalars['Int']['output'];
  /** Organization Enterprise ID (FK) */
  organization_enterprise_id: Scalars['Int']['output'];
  /** Source system that generated this external ID */
  source_system?: Maybe<Scalars['String']['output']>;
  /** Last update timestamp */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** Response containing all organization enterprise IDs */
export type OrganizationEnterpriseIdsNode = {
  __typename?: 'OrganizationEnterpriseIdsNode';
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['output'];
  /** Learning organization internal ID */
  learning_organization_id?: Maybe<Scalars['Int']['output']>;
  /** Organization slug */
  organization_slug: Scalars['String']['output'];
  /** Talent organization internal ID */
  talent_organization_id?: Maybe<Scalars['Int']['output']>;
  /** Workbeat organization internal ID */
  workbeat_organization_id?: Maybe<Scalars['Int']['output']>;
};

/** Organization Enterprise relation Node */
export type OrganizationEnterpriseNode = {
  __typename?: 'OrganizationEnterpriseNode';
  /** Enterprise Slug */
  enterprise: Scalars['String']['output'];
  /** Enterprise Enum */
  enterprise_enum: EnterpriseEnum;
  /** Internal id used for sync data between Enterprises */
  internal_id?: Maybe<Scalars['Int']['output']>;
  /** Licenses related with the Enterprise */
  licenses?: Maybe<LicensesEnterpriseNode>;
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Internal slug for the organization in a specific Enterprise */
  slug?: Maybe<Scalars['String']['output']>;
};

/** Centralized Organization Team header Node */
export type OrganizationGroupTeamHeaderNode = {
  __typename?: 'OrganizationGroupTeamHeaderNode';
  /** Organization team description */
  team_description: Scalars['String']['output'];
  team_id: Scalars['Int']['output'];
  /** Organization team name */
  team_name: Scalars['String']['output'];
};

/** Centralized Organization Team Node */
export type OrganizationGroupTeamNode = {
  __typename?: 'OrganizationGroupTeamNode';
  areas: Array<OrganizationAreaNode>;
  conditionals?: Maybe<Array<OrganizationTeamConditionalNode>>;
  creation_method: Scalars['String']['output'];
  members: Array<OrganizationTeamUserNode>;
  members_count: Scalars['Int']['output'];
  participants_count: Scalars['Int']['output'];
  participants_selection_method: Scalars['String']['output'];
  segmentation_type?: Maybe<Scalars['String']['output']>;
  supervisors_count: Scalars['Int']['output'];
  /** Created datetime */
  team_created_at: Scalars['DateTime']['output'];
  /** Organization team description */
  team_description: Scalars['String']['output'];
  team_id: Scalars['Int']['output'];
  /** Organization team name */
  team_name: Scalars['String']['output'];
  /** Updated datetime */
  team_updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationGroupTeamNodeCustomConnection = {
  __typename?: 'OrganizationGroupTeamNodeCustomConnection';
  edges: Array<OrganizationGroupTeamNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type OrganizationGroupTeamNodeCustomEdge = {
  __typename?: 'OrganizationGroupTeamNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OrganizationGroupTeamNode;
};

export enum OrganizationHeadquarterFilterBy {
  Az = 'AZ',
  CreatedAt = 'CREATED_AT',
  Default = 'DEFAULT',
  Za = 'ZA'
}

/** Centralized Organization Headquarter Node */
export type OrganizationHeadquarterNode = {
  __typename?: 'OrganizationHeadquarterNode';
  /** Address Line 1 */
  address1?: Maybe<Scalars['String']['output']>;
  /** Address Line 2 */
  address2?: Maybe<Scalars['String']['output']>;
  /** Address Line 3 */
  address3?: Maybe<Scalars['String']['output']>;
  /** City */
  city?: Maybe<Scalars['String']['output']>;
  /** Country Code (ISO 3166-1 alpha-2) */
  country_code?: Maybe<Scalars['String']['output']>;
  /** Main Organization Headquarter */
  is_main: Scalars['String']['output'];
  /** Latitude */
  latitude?: Maybe<Scalars['String']['output']>;
  /** Longitude */
  longitude?: Maybe<Scalars['String']['output']>;
  /** Organization Headquarter Name */
  name: Scalars['String']['output'];
  /** Original ID */
  original_id: Scalars['Int']['output'];
  /** Postal Code */
  postal_code?: Maybe<Scalars['String']['output']>;
  /** State */
  state?: Maybe<Scalars['String']['output']>;
};

/** Centralized Organization Headquarter Status Node */
export type OrganizationHeadquarterStatusNode = {
  __typename?: 'OrganizationHeadquarterStatusNode';
  /** Organization Slug */
  slug: Scalars['String']['output'];
  /** Headquarter status */
  status: HeadquarterStatusActionEnum;
};

/** Input para consultar si la organización tiene sedes configuradas. */
export type OrganizationHeadquartersStatusInput = {
  /** ID de la organización (requerido). */
  centralized_organization_id: Scalars['Int']['input'];
};

/** Estado de configuración de sedes de la organización. */
export type OrganizationHeadquartersStatusPayload = {
  __typename?: 'OrganizationHeadquartersStatusPayload';
  /** True si la organización tiene al menos una sede activa configurada. */
  organization_has_configured_headquarters: Scalars['Boolean']['output'];
};

export type OrganizationHeadquartersStatusPayloadNotAuthenticatedErrorResponseValidationErrorResponseInternalErrorResponse = InternalErrorResponse | NotAuthenticatedErrorResponse | OrganizationHeadquartersStatusPayload | ValidationErrorResponse;

export type OrganizationHistoricalActivity = {
  __typename?: 'OrganizationHistoricalActivity';
  months: Array<ActivityPerMonth>;
  year: Scalars['Int']['output'];
};

/** Centralized Country Node */
export type OrganizationIndustryNode = {
  __typename?: 'OrganizationIndustryNode';
  /** Industry description optional value */
  description?: Maybe<Scalars['String']['output']>;
  /** Industry name */
  name: Scalars['String']['output'];
  /** Original ID */
  original_id: Scalars['Int']['output'];
  /** Industry slug */
  slug: Scalars['String']['output'];
};

export type OrganizationIntegratedInput = {
  admin_email: Scalars['String']['input'];
  admin_firstname: Scalars['String']['input'];
  admin_lastname: Scalars['String']['input'];
  learning_id?: InputMaybe<Scalars['String']['input']>;
  learning_slug?: InputMaybe<Scalars['String']['input']>;
  organization_name: Scalars['String']['input'];
  talent_id?: InputMaybe<Scalars['String']['input']>;
  talent_slug?: InputMaybe<Scalars['String']['input']>;
};

/** Organization licensing data including management and product licenses */
export type OrganizationLicensingNode = {
  __typename?: 'OrganizationLicensingNode';
  /** Organization ID for lazy loading */
  centralized_organization_id: Scalars['Int']['output'];
  /** Management licenses from OrganizationOpportunity */
  management_licenses: ManagementLicensesNode;
  /** Overall licensing summary combining management licenses and all product suite licenses */
  overall_summary: SuiteLicenseSummaryNode;
  /** Product suites with their licenses and products */
  product_suites: Array<OrganizationProductSuiteDetailNode>;
  /** Aggregated license totals across all active product suites for this organization */
  product_suites_summary: SuiteLicenseSummaryNode;
};

export type OrganizationLicensingQueries = {
  __typename?: 'OrganizationLicensingQueries';
  /** Complete organization licensing data for dashboard */
  organization_licensing?: Maybe<OrganizationLicensingNode>;
  /** List active product suites enabled for an organization. */
  organization_product_suites: Array<OrganizationProductSuiteNode>;
  /** Get audit log for a product suite license. */
  product_suite_license_audit_log: Array<ProductSuiteLicenseLogNode>;
  /** List all active product suites. */
  product_suites: Array<ProductSuiteNode>;
};


export type OrganizationLicensingQueriesOrganization_LicensingArgs = {
  organization_slug: Scalars['String']['input'];
};


export type OrganizationLicensingQueriesOrganization_Product_SuitesArgs = {
  organization_slug: Scalars['String']['input'];
};


export type OrganizationLicensingQueriesProduct_Suite_License_Audit_LogArgs = {
  license_id: Scalars['Int']['input'];
};

export type OrganizationMarketplaceNode = {
  __typename?: 'OrganizationMarketplaceNode';
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  marketplace_config: MarketplaceConfigNode;
  name: Scalars['String']['output'];
  original_id: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
};

/** Nombre custom de una sección del menú por organización y panel */
export type OrganizationMenuCustomizationNode = {
  __typename?: 'OrganizationMenuCustomizationNode';
  /** Nombre personalizado */
  custom_name: Scalars['String']['output'];
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Panel (colaborador o admin) */
  panel: MenuPanelType;
  /** section_key estable del sidebar (CORE-1653) */
  section_key: Scalars['String']['output'];
};

export type OrganizationMetricsNode = {
  __typename?: 'OrganizationMetricsNode';
  org_id: Scalars['Int']['output'];
  quantity_users: Scalars['Int']['output'];
  users: UserOrganizationMetricsConnection;
};


export type OrganizationMetricsNodeUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search_key?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationPersonalization = {
  __typename?: 'OrganizationPersonalization';
  primary?: Maybe<Scalars['String']['output']>;
  secondary?: Maybe<Scalars['String']['output']>;
};

/** Organization Personalization relation Node */
export type OrganizationPersonalizationNode = {
  __typename?: 'OrganizationPersonalizationNode';
  /** Organization Favicon */
  favicon?: Maybe<Scalars['String']['output']>;
  /** File Favicon ID */
  file_favicon_id?: Maybe<Scalars['Int']['output']>;
  /** File Favicon ID */
  file_favicon_info?: Maybe<File>;
  /** File Image Login ID */
  file_image_login_id?: Maybe<Scalars['Int']['output']>;
  /** File Image Login ID */
  file_image_login_info?: Maybe<File>;
  /** File Logo ID */
  file_logo_id?: Maybe<Scalars['Int']['output']>;
  /** File Logo ID */
  file_logo_info?: Maybe<File>;
  /** Organization Image for Login purposes */
  image_login?: Maybe<Scalars['String']['output']>;
  /** Organization Logo */
  logo?: Maybe<Scalars['String']['output']>;
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Original ID */
  original_id: Scalars['Int']['output'];
};

/** Represents a process blocking the deactivation of a position */
export type OrganizationPositionBlockingProcess = {
  __typename?: 'OrganizationPositionBlockingProcess';
  /** Creation date of the process */
  created_at: Scalars['DateTime']['output'];
  /** Type of functionality (e.g., 'Grupo', 'Flujo de trabajo') */
  functionality: Scalars['String']['output'];
  /** Process ID */
  id: Scalars['ID']['output'];
  /** Process name */
  name: Scalars['String']['output'];
};

/** Job Position Categories in an organization */
export type OrganizationPositionCategoryNode = {
  __typename?: 'OrganizationPositionCategoryNode';
  /** Is active */
  is_active: Scalars['Boolean']['output'];
  /** Category name */
  name: Scalars['String']['output'];
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Original ID */
  original_id: Scalars['Int']['output'];
  /** Slug for the category */
  slug: Scalars['String']['output'];
};

export type OrganizationPositionCategoryNodeCustomConnection = {
  __typename?: 'OrganizationPositionCategoryNodeCustomConnection';
  edges: Array<OrganizationPositionCategoryNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type OrganizationPositionCategoryNodeCustomEdge = {
  __typename?: 'OrganizationPositionCategoryNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OrganizationPositionCategoryNode;
};

/** Criticality level for succession engine */
export enum OrganizationPositionCriticalityLevelEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type OrganizationPositionCriticalityOptionNode = {
  __typename?: 'OrganizationPositionCriticalityOptionNode';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type OrganizationPositionCriticalityQueryResponse = ForbiddenErrorResponse | InternalErrorResponse | OrganizationPositionCriticalitySelect;

export type OrganizationPositionCriticalitySelect = {
  __typename?: 'OrganizationPositionCriticalitySelect';
  items: Array<OrganizationPositionCriticalityOptionNode>;
};

export type OrganizationPositionDetailResponse = CentralizedOrganizationPositionDetail | ForbiddenErrorResponse | InternalErrorResponse | NotFoundResponse;

/** Paginated result of families by organization. */
export type OrganizationPositionFamilyByOrganization = {
  __typename?: 'OrganizationPositionFamilyByOrganization';
  families: Array<CentralizedOrganizationPositionFamilyNode>;
  page_info: PageInfo;
  total_count: Scalars['Int']['output'];
};

export type OrganizationPositionFamilyQueryResponse = ForbiddenErrorResponse | InternalErrorResponse | NotFoundResponse | OrganizationPositionFamilyByOrganization;

export type OrganizationPositionFamilySelectResponse = ForbiddenErrorResponse | InternalErrorResponse | NotFoundResponse | PositionFamilySelectList;

export type OrganizationPositionKeyPositionOptionNode = {
  __typename?: 'OrganizationPositionKeyPositionOptionNode';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type OrganizationPositionKeyPositionQueryResponse = ForbiddenErrorResponse | InternalErrorResponse | OrganizationPositionKeyPositionSelect;

export type OrganizationPositionKeyPositionSelect = {
  __typename?: 'OrganizationPositionKeyPositionSelect';
  items: Array<OrganizationPositionKeyPositionOptionNode>;
};

/** Paginated result of position levels by organization. */
export type OrganizationPositionLevelByOrganization = {
  __typename?: 'OrganizationPositionLevelByOrganization';
  levels: Array<CentralizedOrganizationPositionLevelNode>;
  page_info: PageInfo;
  total_count: Scalars['Int']['output'];
};

export type OrganizationPositionLevelQueryResponse = ForbiddenErrorResponse | InternalErrorResponse | NotFoundResponse | OrganizationPositionLevelByOrganization;

/** Result for selects of levels per organization (without pagination). */
export type OrganizationPositionLevelSelectByOrganization = {
  __typename?: 'OrganizationPositionLevelSelectByOrganization';
  levels: Array<CentralizedOrganizationPositionLevelNode>;
  total_count: Scalars['Int']['output'];
};

export type OrganizationPositionLevelSelectQueryResponse = ForbiddenErrorResponse | InternalErrorResponse | NotFoundResponse | OrganizationPositionLevelSelectByOrganization;

/** Job Positions in an Organization */
export type OrganizationPositionNode = {
  __typename?: 'OrganizationPositionNode';
  /** Position code, unique within the organization */
  code?: Maybe<Scalars['String']['output']>;
  /** Criticality level for Succession Engine (HIGH, MEDIUM, LOW) */
  criticality_level?: Maybe<OrganizationPositionCriticalityLevelEnum>;
  /** Evaluation indicators configurations for the Fit Score */
  evaluation_indicators: Array<PositionEvaluationIndicatorNode>;
  /** Functions and responsibilities of the position. Null when not configured. */
  functions_description?: Maybe<Scalars['String']['output']>;
  /** General description of the position. Null when not configured. */
  general_description?: Maybe<Scalars['String']['output']>;
  /** Is active */
  is_active: Scalars['Boolean']['output'];
  /** Keywords associated with this position */
  keywords: Array<PositionKeywordNode>;
  /** Position name */
  name: Scalars['String']['output'];
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Original ID */
  original_id: Scalars['Int']['output'];
};

export type OrganizationPositionNodeCustomConnection = {
  __typename?: 'OrganizationPositionNodeCustomConnection';
  edges: Array<OrganizationPositionNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type OrganizationPositionNodeCustomEdge = {
  __typename?: 'OrganizationPositionNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OrganizationPositionNode;
};

/** Paginated result of positions for table view. */
export type OrganizationPositionTableByOrganization = {
  __typename?: 'OrganizationPositionTableByOrganization';
  positions: Array<OrganizationPositionTableItem>;
  total_count: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type OrganizationPositionTableItem = {
  __typename?: 'OrganizationPositionTableItem';
  code_position?: Maybe<Scalars['String']['output']>;
  family_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  users_count: Scalars['Int']['output'];
};

export type OrganizationPositionTableResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | OrganizationPositionTableByOrganization | ValidationErrorResponse;

/** Organization product suite with licenses and products */
export type OrganizationProductSuiteDetailNode = {
  __typename?: 'OrganizationProductSuiteDetailNode';
  /** Organization ID for lazy loading */
  centralized_organization_id: Scalars['Int']['output'];
  /** Date suite was enabled for this organization */
  enabled_at?: Maybe<Scalars['DateTime']['output']>;
  /** Organization product suite ID */
  id: Scalars['Int']['output'];
  /** Whether suite is active for this organization */
  is_active: Scalars['Boolean']['output'];
  /** License bags for this product suite */
  licenses: Array<SuiteLicenseNode>;
  /** Product suite catalog details */
  product_suite: ProductSuiteNode;
  /** Product suite ID for lazy loading */
  product_suite_id: Scalars['Int']['output'];
  /** Active products belonging to this suite for this organization */
  products: Array<ApplicationProductNode>;
  /** Aggregated license totals across all bags for this suite */
  summary: SuiteLicenseSummaryNode;
};

/** Organization-enabled product suite. */
export type OrganizationProductSuiteNode = {
  __typename?: 'OrganizationProductSuiteNode';
  /** Date suite was enabled */
  enabled_at?: Maybe<Scalars['DateTime']['output']>;
  /** Organization product suite ID */
  id: Scalars['Int']['output'];
  /** Whether suite is active for org */
  is_active: Scalars['Boolean']['output'];
  /** Product suite details */
  product_suite: ProductSuiteNode;
};

export type OrganizationPublicInfoPayload = {
  __typename?: 'OrganizationPublicInfoPayload';
  domain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  login_path: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type OrganizationPublicInfoPayloadQueryValidationErrorQueryInternalServerError = OrganizationPublicInfoPayload | QueryInternalServerError | QueryValidationError;

/** Centralized Organization Organization Area Level Node */
export type OrganizationQueryAreaLevelNode = {
  __typename?: 'OrganizationQueryAreaLevelNode';
  /** Organization Area Level Name */
  name: Scalars['String']['output'];
  /** Total User Count */
  total_count: Scalars['Int']['output'];
};

/** Centralized Organization Query Area Node */
export type OrganizationQueryAreaNode = {
  __typename?: 'OrganizationQueryAreaNode';
  /** Area ID */
  area_id: Scalars['Int']['output'];
  /** Creation Date */
  created_at: Scalars['String']['output'];
  /** Area Label */
  label: Scalars['String']['output'];
  /** Area Level Name */
  level_name: Scalars['String']['output'];
  /** Area Level Sequence */
  level_sequence: Scalars['Int']['output'];
  /** Area Name */
  name: Scalars['String']['output'];
  /** Sub Areas List */
  sub_areas: Array<OrganizationQuerySubAreaNode>;
  /** Total User Count */
  total_user_count: Scalars['Int']['output'];
};

export type OrganizationQueryAreaNodeCustomConnection = {
  __typename?: 'OrganizationQueryAreaNodeCustomConnection';
  edges: Array<OrganizationQueryAreaNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type OrganizationQueryAreaNodeCustomEdge = {
  __typename?: 'OrganizationQueryAreaNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OrganizationQueryAreaNode;
};

/** Centralized Organization Query Headquarter Node */
export type OrganizationQueryHeadquarterNode = {
  __typename?: 'OrganizationQueryHeadquarterNode';
  /** Address Line 1 */
  address1?: Maybe<Scalars['String']['output']>;
  /** Address Line 2 */
  address2?: Maybe<Scalars['String']['output']>;
  /** Address Line 3 */
  address3?: Maybe<Scalars['String']['output']>;
  /** City */
  city?: Maybe<Scalars['String']['output']>;
  /** Country Code (ISO 3166-1 alpha-2) */
  country_code?: Maybe<Scalars['String']['output']>;
  /** Creation Date */
  created_at: Scalars['String']['output'];
  /** If the Organization Headquarter is active */
  is_active: Scalars['Boolean']['output'];
  /** Main Organization Headquarter */
  is_main: Scalars['Boolean']['output'];
  /** Latitude */
  latitude?: Maybe<Scalars['String']['output']>;
  /** Longitude */
  longitude?: Maybe<Scalars['String']['output']>;
  /** Organization Headquarter Name */
  name: Scalars['String']['output'];
  /** Organization Area Level List */
  organization_area_levels?: Maybe<Array<OrganizationQueryAreaLevelNode>>;
  /** Original ID */
  original_id: Scalars['Int']['output'];
  /** Postal Code */
  postal_code?: Maybe<Scalars['String']['output']>;
  /** State */
  state?: Maybe<Scalars['String']['output']>;
  /** Total User Count */
  total_count: Scalars['Int']['output'];
};

export type OrganizationQueryHeadquarterNodeCustomConnection = {
  __typename?: 'OrganizationQueryHeadquarterNodeCustomConnection';
  edges: Array<OrganizationQueryHeadquarterNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type OrganizationQueryHeadquarterNodeCustomEdge = {
  __typename?: 'OrganizationQueryHeadquarterNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OrganizationQueryHeadquarterNode;
};

/** Centralized Organization Sub Area Detail Node */
export type OrganizationQuerySubAreaNode = {
  __typename?: 'OrganizationQuerySubAreaNode';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  user_count: Scalars['Int']['output'];
};

export type OrganizationReadinessNode = {
  __typename?: 'OrganizationReadinessNode';
  has_areas: Scalars['Boolean']['output'];
  has_headquarters: Scalars['Boolean']['output'];
  has_positions: Scalars['Boolean']['output'];
  /** True when the organization meets the mandatory configuration to start creating users (at least one level-1 area and one position). */
  is_ready_for_user_creation: Scalars['Boolean']['output'];
};

export enum OrganizationReportGenerationFrequencyEnum {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type OrganizationReproduction = {
  __typename?: 'OrganizationReproduction';
  average_user: Scalars['Int']['output'];
  played_seconds: Scalars['Int']['output'];
  users_with_reproduction: Scalars['Int']['output'];
};

export type OrganizationRewardType = {
  __typename?: 'OrganizationRewardType';
  created_at?: Maybe<Scalars['String']['output']>;
  has_project?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  number_courses?: Maybe<Scalars['Int']['output']>;
  number_users?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  taken?: Maybe<Scalars['Int']['output']>;
  team: OrganizationTeamType;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type OrganizationSettingsQueries = {
  __typename?: 'OrganizationSettingsQueries';
  get_sidebar: OrganizationSettingsSidebarResponse;
  /** Catálogo de secciones renombrables (L1 y L2) del panel, filtrado por productos activos de la organización. Consumido por el editor de nombres del menú (White Labeling v2) y por la validación de unicidad. */
  menu_catalog: Array<MenuCatalogItem>;
};


export type OrganizationSettingsQueriesGet_SidebarArgs = {
  input: OrganizationSettingsSidebarInput;
};


export type OrganizationSettingsQueriesMenu_CatalogArgs = {
  input: MenuCatalogInput;
};

export type OrganizationSettingsSidebarCustomization = {
  __typename?: 'OrganizationSettingsSidebarCustomization';
  primary_color?: Maybe<Scalars['String']['output']>;
};

export type OrganizationSettingsSidebarDisabledItem = {
  __typename?: 'OrganizationSettingsSidebarDisabledItem';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  is_shared: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  section_key?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type OrganizationSettingsSidebarExternalUrlItem = {
  __typename?: 'OrganizationSettingsSidebarExternalURLItem';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  is_shared: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  section_key?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type OrganizationSettingsSidebarInput = {
  application_name?: InputMaybe<ApplicationNameEnum>;
  application_role: ApplicationRoleEnum;
  centralized_organization_id: Scalars['Int']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationSettingsSidebarInternalUrlItem = {
  __typename?: 'OrganizationSettingsSidebarInternalURLItem';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  is_shared: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  locked: Scalars['Boolean']['output'];
  notifications: Scalars['Int']['output'];
  section_key?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type OrganizationSettingsSidebarItem = OrganizationSettingsSidebarDisabledItem | OrganizationSettingsSidebarExternalUrlItem | OrganizationSettingsSidebarInternalUrlItem | OrganizationSettingsSidebarListItem;

export type OrganizationSettingsSidebarListItem = {
  __typename?: 'OrganizationSettingsSidebarListItem';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  is_shared: Scalars['Boolean']['output'];
  items: Array<OrganizationSettingsSidebarItem>;
  label: Scalars['String']['output'];
  notifications: Scalars['Int']['output'];
  section_key?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type OrganizationSettingsSidebarPayload = {
  __typename?: 'OrganizationSettingsSidebarPayload';
  customization?: Maybe<OrganizationSettingsSidebarCustomization>;
  footer_section: Array<OrganizationSettingsSidebarItem>;
  product_section: Array<OrganizationSettingsSidebarItem>;
  profile_footer_section?: Maybe<Array<ProfileOrganizationSettingsSidebarItem>>;
  profile_regular_section?: Maybe<Array<ProfileOrganizationSettingsSidebarItem>>;
  regular_section: Array<OrganizationSettingsSidebarItem>;
};

export type OrganizationSettingsSidebarResponse = OrganizationSettingsSidebarPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type OrganizationTeamAdminNode = {
  __typename?: 'OrganizationTeamAdminNode';
  categories?: Maybe<Array<KnowledgeHubCategoryNode>>;
  /** Completion requirements currently in force for the track (epic CELC-4900). Null when the track has none configured: that is the empty state of the requirements tab, not an error. */
  completion_rule?: Maybe<TrackCompletionRuleType>;
  /** Fecha de ultima modificacion del contenido de la ruta (alta/baja de cursos, reorden o cambio de obligatoriedad). Null si el contenido nunca se edito despues de crear la ruta (CELC-4822). */
  content_updated_at?: Maybe<Scalars['DateTime']['output']>;
  cover_image_id?: Maybe<Scalars['Int']['output']>;
  cover_image_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  /** Team end date in ISO format (YYYY-MM-DD) */
  end_date?: Maybe<Scalars['Date']['output']>;
  expiration_time?: Maybe<Scalars['Int']['output']>;
  expiration_time_in_days?: Maybe<Scalars['Int']['output']>;
  generate_certificate?: Maybe<Scalars['Boolean']['output']>;
  has_reward?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_draft?: Maybe<Scalars['Boolean']['output']>;
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  last_closure?: Maybe<TrackClosureNode>;
  modality?: Maybe<TrackModalityEnum>;
  name: Scalars['String']['output'];
  organization_team_course_dependencies: Array<OrganizationTeamCourseDependencieNode>;
  organization_team_courses: Array<ContentOrganizationTeamCourseNode>;
  /** Fecha del ultimo cambio de prerrequisitos de la ruta. Null si nunca se editaron, o con la bandera ENABLE_TRACK_PREREQ_EDITING apagada (CELC-4686). */
  prereqs_updated_at?: Maybe<Scalars['DateTime']['output']>;
  reward?: Maybe<OrganizationTeamRewardNode>;
  /** Team start date in ISO format (YYYY-MM-DD) */
  start_date?: Maybe<Scalars['Date']['output']>;
  total_active_user_teams?: Maybe<Scalars['Int']['output']>;
  total_courses_number?: Maybe<Scalars['Int']['output']>;
  total_required_courses?: Maybe<Scalars['Int']['output']>;
  track_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  version?: Maybe<TrackVersionEnum>;
  visibility_level?: Maybe<VisibilityLevelType>;
};

export type OrganizationTeamAdminSummaryConnection = {
  __typename?: 'OrganizationTeamAdminSummaryConnection';
  edges: Array<OrganizationTeamAdminSummaryNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type OrganizationTeamAdminSummaryNode = {
  __typename?: 'OrganizationTeamAdminSummaryNode';
  academy?: Maybe<AcademyNode>;
  category?: Maybe<Scalars['String']['output']>;
  /** Fecha de ultima modificacion del contenido de la ruta (alta/baja de cursos, reorden o cambio de obligatoriedad). Null si el contenido nunca se edito despues de crear la ruta (CELC-4822). */
  content_updated_at?: Maybe<Scalars['DateTime']['output']>;
  courses_to_certificate?: Maybe<Scalars['Int']['output']>;
  courses_to_complete?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  creation_type?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['Date']['output']>;
  has_quizzes?: Maybe<Scalars['Boolean']['output']>;
  has_reward?: Maybe<Scalars['Boolean']['output']>;
  has_skill?: Maybe<Scalars['Boolean']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  last_closure?: Maybe<TrackClosureNode>;
  modality?: Maybe<TrackModalityEnum>;
  name?: Maybe<Scalars['String']['output']>;
  original_id: Scalars['ID']['output'];
  /** Fecha del ultimo cambio de prerrequisitos de la ruta. Null si nunca se editaron, o con la bandera ENABLE_TRACK_PREREQ_EDITING apagada (CELC-4686). */
  prereqs_updated_at?: Maybe<Scalars['DateTime']['output']>;
  project_count?: Maybe<Scalars['Int']['output']>;
  skill?: Maybe<SkillB2bTeamNode>;
  start_date?: Maybe<Scalars['Date']['output']>;
  total_courses_count?: Maybe<Scalars['Int']['output']>;
  total_users_count?: Maybe<Scalars['Int']['output']>;
  track?: Maybe<SkillB2bTrackNode>;
  track_type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type OrganizationTeamAdminSummaryNodeEdge = {
  __typename?: 'OrganizationTeamAdminSummaryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OrganizationTeamAdminSummaryNode;
};

export type OrganizationTeamBuilderMutations = {
  __typename?: 'OrganizationTeamBuilderMutations';
  assign_organization_team_to_user_member: ContentAssignOrganizationTeamToUserResponse;
  assign_track_to_multiple_users: ContentAssignTrackResponse;
  create_organization_reward: CreateOrganizationReward;
  create_organization_team: CreateOrganizationTeamResponse;
  /** Duplicate a learning track with its content and settings */
  duplicate_organization_team: DuplicateOrganizationTeamResponse;
  update_organization_team: ContentUpdateOrganizationTeamResponse;
};


export type OrganizationTeamBuilderMutationsAssign_Organization_Team_To_User_MemberArgs = {
  input: AssignOrganizationTeamToUserInput;
};


export type OrganizationTeamBuilderMutationsAssign_Track_To_Multiple_UsersArgs = {
  input: AssignTrackToMultipleUserInput;
};


export type OrganizationTeamBuilderMutationsCreate_Organization_RewardArgs = {
  input: CreateOrganizationRewardInput;
};


export type OrganizationTeamBuilderMutationsCreate_Organization_TeamArgs = {
  input: CreateContentOrganizationTeamInput;
  organization_id: Scalars['ID']['input'];
};


export type OrganizationTeamBuilderMutationsDuplicate_Organization_TeamArgs = {
  input: DuplicateOrganizationTeamInput;
};


export type OrganizationTeamBuilderMutationsUpdate_Organization_TeamArgs = {
  input: UpdateContentOrganizationTeamInput;
  organization_id: Scalars['ID']['input'];
  step: StepEnum;
};

export type OrganizationTeamBuilderQuery = {
  __typename?: 'OrganizationTeamBuilderQuery';
  /** Query Organization Team */
  dummy_query?: Maybe<Scalars['Void']['output']>;
  /** Get organization teams by user with pagination and filtering */
  get_organization_teams_by_user: UserOrganizationTeamConnection;
  /** Retrieve Detail of organization team for admin panel */
  organization_team_admin?: Maybe<OrganizationTeamAdminNode>;
  /** Lista paginada de rutas de una organizacion para el panel de admin */
  organization_teams_admin: OrganizationTeamAdminSummaryConnection;
  /** Retrieve Detail of user organization team by user session */
  user_organization_team?: Maybe<UserOrganizationTeamNode>;
  /** Retrieve all organization team by user session */
  user_organization_teams: UserOrganizationTeamConnection;
  /** Inquiry of courses taken by the user team for rewards */
  user_team_reward?: Maybe<UserTeamRewardResponse>;
  /** Whether the collaborator asking meets the completion requirements in force for a track, with the breakdown per requirement. The breakdown always leads with REQUIRED_COURSES_COMPLETED, a requirement no admin configures and every track carries. Null when the collaborator is not enrolled in the track. */
  user_track_completion_status?: Maybe<TrackCompletionStatusType>;
};


export type OrganizationTeamBuilderQueryGet_Organization_Teams_By_UserArgs = {
  input: GetOrganizationTeamsByUserInput;
};


export type OrganizationTeamBuilderQueryOrganization_Team_AdminArgs = {
  input: ContentOrganizationTeamInput;
};


export type OrganizationTeamBuilderQueryOrganization_Teams_AdminArgs = {
  input: OrganizationTeamsAdminInput;
  organization_id: Scalars['Int']['input'];
};


export type OrganizationTeamBuilderQueryUser_Organization_TeamArgs = {
  input: UserOrganizationTeamInput;
};


export type OrganizationTeamBuilderQueryUser_Organization_TeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter_by?: InputMaybe<UserTeamSearchFilterEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserTeamInputOrderBy>>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  organization_slug?: InputMaybe<Scalars['String']['input']>;
  search_input?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationTeamBuilderQueryUser_Team_RewardArgs = {
  input: UserTeamRewardInput;
};


export type OrganizationTeamBuilderQueryUser_Track_Completion_StatusArgs = {
  input: UserOrganizationTeamInput;
};

/** Centralized Organization Team Conditional Node */
export type OrganizationTeamConditionalNode = {
  __typename?: 'OrganizationTeamConditionalNode';
  conditional_type: Scalars['String']['output'];
  custom_field?: Maybe<CentralizedUserCustomFieldNode>;
  data_type: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type OrganizationTeamCourseDependencieNode = {
  __typename?: 'OrganizationTeamCourseDependencieNode';
  course: Course;
  course_id: Scalars['Int']['output'];
  depends_on: Array<OrganizationCourseTeamDependenceRuleNode>;
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  organization_team_id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
};

export type OrganizationTeamCourseInput = {
  course_id: Scalars['Int']['input'];
  order: Scalars['Int']['input'];
};

export type OrganizationTeamCourseInputList = {
  courses: Array<OrganizationTeamCourseInput>;
  organization_id: Scalars['Int']['input'];
  organization_team_id: Scalars['Int']['input'];
};

export type OrganizationTeamCourseNode = {
  __typename?: 'OrganizationTeamCourseNode';
  course?: Maybe<Course>;
  course_id?: Maybe<Scalars['ID']['output']>;
  end_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_required?: Maybe<Scalars['Boolean']['output']>;
  is_required_project?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationTeamCourseType = {
  __typename?: 'OrganizationTeamCourseType';
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_required: Scalars['Boolean']['output'];
  is_required_project: Scalars['Boolean']['output'];
};

export type OrganizationTeamDuplicate = {
  __typename?: 'OrganizationTeamDuplicate';
  message?: Maybe<Scalars['String']['output']>;
  team_exist: Scalars['Boolean']['output'];
};

export type OrganizationTeamNode = {
  __typename?: 'OrganizationTeamNode';
  academy?: Maybe<ContentAcademyNode>;
  content_duration?: Maybe<Scalars['Int']['output']>;
  cover_image_id?: Maybe<Scalars['Int']['output']>;
  cover_image_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  expiration_time?: Maybe<Scalars['Int']['output']>;
  generate_certificate?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_draft: Scalars['Boolean']['output'];
  is_hidden: Scalars['Boolean']['output'];
  modality?: Maybe<TrackModalityEnum>;
  name: Scalars['String']['output'];
  organization_id?: Maybe<Scalars['Int']['output']>;
  reward?: Maybe<OrganizationTeamRewardNode>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  team_image?: Maybe<ImageNode>;
  track_type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type OrganizationTeamRewardNode = {
  __typename?: 'OrganizationTeamRewardNode';
  has_project: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  number_courses: Scalars['Int']['output'];
  number_users: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  taken: Scalars['Int']['output'];
};

export enum OrganizationTeamRole {
  Participant = 'PARTICIPANT',
  Supervisor = 'SUPERVISOR'
}

export type OrganizationTeamRulesInput = {
  courses_to_certificate: Scalars['Int']['input'];
  courses_to_complete: Scalars['Int']['input'];
};

export type OrganizationTeamType = {
  __typename?: 'OrganizationTeamType';
  certificate_name?: Maybe<Scalars['String']['output']>;
  courses_recommend?: Maybe<Scalars['Int']['output']>;
  courses_to_certificate?: Maybe<Scalars['Int']['output']>;
  courses_to_complete?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  generate_certificate?: Maybe<Scalars['Boolean']['output']>;
  has_reward?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_active_course_dependence?: Maybe<Scalars['String']['output']>;
  is_draft?: Maybe<Scalars['Boolean']['output']>;
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  max_age?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  select_team_eligible?: Maybe<Scalars['Boolean']['output']>;
  send_skill?: Maybe<Scalars['Boolean']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  version_skill?: Maybe<Scalars['Int']['output']>;
};

/** Centralized Organization Team User Node */
export type OrganizationTeamUserNode = {
  __typename?: 'OrganizationTeamUserNode';
  areas?: Maybe<CentralizedAreaLevelsNode>;
  position?: Maybe<CentralizedUserPositionNode>;
  role_type: Scalars['String']['output'];
  user: CentralizedUserNode;
};

export type OrganizationTeamUserNodeCustomConnection = {
  __typename?: 'OrganizationTeamUserNodeCustomConnection';
  edges: Array<OrganizationTeamUserNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type OrganizationTeamUserNodeCustomEdge = {
  __typename?: 'OrganizationTeamUserNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OrganizationTeamUserNode;
};

/** Filtros y paginacion de la query organization_teams_admin. */
export type OrganizationTeamsAdminInput = {
  /** Cursor de paginacion hacia adelante. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor de paginacion hacia atras. */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Solo equipos que tienen este curso asignado (activo). */
  course_id?: InputMaybe<Scalars['Int']['input']>;
  /** Estado: all | current | expired | disabled | completed. */
  filter_by?: InputMaybe<TeamSearchFilterEnum>;
  /** Cantidad de elementos hacia adelante. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Vista de panel de admin: con is_draft=false incluye tambien los equipos inactivos ocultos (misma semantica que la query legacy). */
  is_admin_panel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por estado borrador. */
  is_draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filtra por visibilidad. */
  is_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cantidad de elementos hacia atras. */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por modalidad de ruta: STANDARD (incluye rutas sin configuracion, tratadas como Estandar) u OPEN. Omitido = sin filtro. Solo tiene efecto con la bandera de rutas abiertas prendida; apagada, STANDARD devuelve todo y OPEN vacio. */
  modality?: InputMaybe<TrackModalityEnum>;
  /** Restringe el resultado a estos ids de equipo. */
  organization_team_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Busqueda por nombre del equipo (sin distinguir mayusculas). */
  search_key?: InputMaybe<Scalars['String']['input']>;
  /** Tipo de equipo: TRACK o ACADEMY. */
  track_type?: InputMaybe<TeamTypeEnum>;
  /** Solo equipos que NO tienen este curso asignado. */
  without_course_id?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationTemplateBaseConnection = {
  __typename?: 'OrganizationTemplateBaseConnection';
  edges: Array<OrganizationTemplateBaseNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination, filters
   */
  total_objects?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationTemplateBaseNode = {
  __typename?: 'OrganizationTemplateBaseNode';
  background_image_file_id?: Maybe<Scalars['Int']['output']>;
  document_background_image_file?: Maybe<File>;
  document_preview_image_file?: Maybe<File>;
  html_content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_dc3_template?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  json_editor_configuration?: Maybe<Scalars['JSON']['output']>;
  json_extra_fields?: Maybe<Scalars['JSON']['output']>;
  organization_template_base_logos?: Maybe<Array<OrganizationTemplateLogoNode>>;
  orientation?: Maybe<Scalars['String']['output']>;
  preview_image_file_id?: Maybe<Scalars['Int']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  template_name?: Maybe<Scalars['String']['output']>;
  template_type: TemplateTypeEnum;
};

export type OrganizationTemplateBaseNodeEdge = {
  __typename?: 'OrganizationTemplateBaseNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OrganizationTemplateBaseNode;
};

export type OrganizationTemplateBuilderMutations = {
  __typename?: 'OrganizationTemplateBuilderMutations';
  create_dc3_organization_name: CreateOrUpdateDc3OrganizationNameResponse;
  create_dc4_organization_attribute: CreateOrUpdateDc4OrganizationAttributeResponse;
  create_or_update_course_organization_template: CreateOrUpdateCourseOrganizationTemplateResponse;
  create_organization_course_instructor_admin: CreateOrUpdateOrganizationCourseInstructorResponse;
  create_organization_template: CreateOrUpdateOrganizationTemplateResponse;
  create_track_organization_template: CreateOrUpdateTrackOrganizationTemplateResponse;
  delete_course_organization_template: CreateOrUpdateCourseOrganizationTemplateResponse;
  delete_dc3_organization_name: CreateOrUpdateDc3OrganizationNameResponse;
  delete_organization_course_instructor_admin: CreateOrUpdateOrganizationCourseInstructorResponse;
  delete_organization_template: CreateOrUpdateOrganizationTemplateResponse;
  delete_track_organization_template: CreateOrUpdateTrackOrganizationTemplateResponse;
  download_certificate: DownloadCertificateResponse;
  preview_organization_template: CertificatesPreviewOrganizationTemplateResponse;
  update_dc3_organization_name: CreateOrUpdateDc3OrganizationNameResponse;
  update_dc4_organization_attribute: CreateOrUpdateDc4OrganizationAttributeResponse;
  update_default_organization_template: CreateOrUpdateOrganizationTemplateResponse;
  update_organization_course_instructor_admin: CreateOrUpdateOrganizationCourseInstructorResponse;
  update_organization_template: CreateOrUpdateOrganizationTemplateResponse;
  update_track_organization_template: CreateOrUpdateTrackOrganizationTemplateResponse;
};


export type OrganizationTemplateBuilderMutationsCreate_Dc3_Organization_NameArgs = {
  input: Dc3OrganizationNameInput;
};


export type OrganizationTemplateBuilderMutationsCreate_Dc4_Organization_AttributeArgs = {
  input: Dc4OrganizationAttributeInput;
};


export type OrganizationTemplateBuilderMutationsCreate_Or_Update_Course_Organization_TemplateArgs = {
  input: CourseOrganizationTemplateInput;
};


export type OrganizationTemplateBuilderMutationsCreate_Organization_Course_Instructor_AdminArgs = {
  input: OrganizationCourseInstructorInput;
};


export type OrganizationTemplateBuilderMutationsCreate_Organization_TemplateArgs = {
  input: OrganizationTemplateInput;
};


export type OrganizationTemplateBuilderMutationsCreate_Track_Organization_TemplateArgs = {
  input: CreateTrackOrganizationTemplateInput;
};


export type OrganizationTemplateBuilderMutationsDelete_Course_Organization_TemplateArgs = {
  input: DeleteCourseOrganizationTemplateInput;
};


export type OrganizationTemplateBuilderMutationsDelete_Dc3_Organization_NameArgs = {
  input: DeleteDc3OrganizationNameInput;
};


export type OrganizationTemplateBuilderMutationsDelete_Organization_Course_Instructor_AdminArgs = {
  input: DeleteOrganizationCourseInstructorInput;
};


export type OrganizationTemplateBuilderMutationsDelete_Organization_TemplateArgs = {
  input: DeleteOrganizationTemplateInput;
};


export type OrganizationTemplateBuilderMutationsDelete_Track_Organization_TemplateArgs = {
  input: DeleteTrackOrganizationTemplateInput;
};


export type OrganizationTemplateBuilderMutationsDownload_CertificateArgs = {
  input: DownloadCertificateInput;
};


export type OrganizationTemplateBuilderMutationsPreview_Organization_TemplateArgs = {
  input: PreviewOrganizationTemplateInput;
};


export type OrganizationTemplateBuilderMutationsUpdate_Dc3_Organization_NameArgs = {
  input: Dc3OrganizationNameInput;
};


export type OrganizationTemplateBuilderMutationsUpdate_Dc4_Organization_AttributeArgs = {
  input: Dc4OrganizationAttributeInput;
};


export type OrganizationTemplateBuilderMutationsUpdate_Default_Organization_TemplateArgs = {
  input: UpdateDefaultOrganizationTemplateInput;
};


export type OrganizationTemplateBuilderMutationsUpdate_Organization_Course_Instructor_AdminArgs = {
  input: OrganizationCourseInstructorInput;
};


export type OrganizationTemplateBuilderMutationsUpdate_Organization_TemplateArgs = {
  input: OrganizationTemplateInput;
};


export type OrganizationTemplateBuilderMutationsUpdate_Track_Organization_TemplateArgs = {
  input: UpdateTrackOrganizationTemplateInput;
};

export type OrganizationTemplateConnection = {
  __typename?: 'OrganizationTemplateConnection';
  edges: Array<OrganizationTemplateNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination, filters
   */
  total_objects?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationTemplateData = {
  background_image_file_id?: InputMaybe<Scalars['Int']['input']>;
  html_content?: InputMaybe<Scalars['String']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  json_editor_configuration?: InputMaybe<Scalars['JSON']['input']>;
  json_extra_fields?: InputMaybe<Scalars['JSON']['input']>;
  organization_id: Scalars['ID']['input'];
  organization_template_id?: InputMaybe<Scalars['ID']['input']>;
  orientation_enum?: InputMaybe<TemplateOrientationEnum>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  status_enum?: InputMaybe<TemplateStatusEnum>;
  template_name?: InputMaybe<Scalars['String']['input']>;
  template_regulation_type_enum?: InputMaybe<TemplateRegulationTypeEnum>;
  template_type_enum?: InputMaybe<TemplateTypeEnum>;
};

export type OrganizationTemplateInput = {
  dc3_organization_template_data?: InputMaybe<Dc3OrganizationTemplateData>;
  organization_template: OrganizationTemplateData;
  organization_template_logos?: InputMaybe<Array<OrganizationTemplateLogoData>>;
};

export type OrganizationTemplateLogoData = {
  element_identifier?: InputMaybe<Scalars['String']['input']>;
  logo_file_id?: InputMaybe<Scalars['Int']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationTemplateLogoNode = {
  __typename?: 'OrganizationTemplateLogoNode';
  document_logo_file?: Maybe<File>;
  element_identifier?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo_file_id?: Maybe<Scalars['Int']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationTemplateNode = {
  __typename?: 'OrganizationTemplateNode';
  background_image_file_id?: Maybe<Scalars['Int']['output']>;
  course_organization_templates?: Maybe<Array<CourseOrganizationTemplatePartialNode>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  dc3_organization_template_data?: Maybe<Dc3OrganizationTemplateDataNode>;
  document_background_image_file?: Maybe<File>;
  document_preview_image_file?: Maybe<File>;
  html_content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_default?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  json_editor_configuration?: Maybe<Scalars['JSON']['output']>;
  json_extra_fields?: Maybe<Scalars['JSON']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  organization_template_logos?: Maybe<Array<OrganizationTemplateLogoNode>>;
  orientation?: Maybe<TemplateOrientationEnum>;
  preview_image_file_id?: Maybe<Scalars['Int']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<TemplateStatusEnum>;
  template_name?: Maybe<Scalars['String']['output']>;
  template_regulation_type?: Maybe<TemplateRegulationTypeEnum>;
  template_type: TemplateTypeEnum;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationTemplateNodeEdge = {
  __typename?: 'OrganizationTemplateNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OrganizationTemplateNode;
};

export type OrganizationTemplateResponsePayload = {
  __typename?: 'OrganizationTemplateResponsePayload';
  organization_template: OrganizationTemplateNode;
};

export type OrganizationTemplatesInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  search_text?: InputMaybe<Scalars['String']['input']>;
  status_enum?: InputMaybe<TemplateStatusEnum>;
  template_regulation_type_enum?: InputMaybe<TemplateRegulationTypeEnum>;
  template_type_enum?: InputMaybe<TemplateTypeEnum>;
  /** Filter by multiple template types (OR logic). Takes precedence over template_type_enum when provided. */
  template_type_enums?: InputMaybe<Array<TemplateTypeEnum>>;
};

export type OrganizationTransactionFragmentConnection = {
  __typename?: 'OrganizationTransactionFragmentConnection';
  /** Contains the nodes in this connection */
  edges: Array<OrganizationTransactionFragmentNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type OrganizationTransactionFragmentNode = {
  __typename?: 'OrganizationTransactionFragmentNode';
  created_at: Scalars['DateTime']['output'];
  created_by_id: Scalars['Int']['output'];
  currency_points_exchanged?: Maybe<Scalars['Float']['output']>;
  current_status: TransactionStatusEnum;
  original_id: Scalars['ID']['output'];
  quantity: Scalars['Float']['output'];
  related_transaction_id?: Maybe<Scalars['ID']['output']>;
  reward: RewardFragmentNode;
  reward_id: Scalars['ID']['output'];
  transaction_type: TransactionTypeEnum;
  /** User node */
  user?: Maybe<MyUserNode>;
};

export type OrganizationTransactionFragmentNodeEdge = {
  __typename?: 'OrganizationTransactionFragmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OrganizationTransactionFragmentNode;
};

export type OrganizationTransactionNode = {
  __typename?: 'OrganizationTransactionNode';
  created_at: Scalars['DateTime']['output'];
  created_by_id: Scalars['Int']['output'];
  currency_points_exchanged?: Maybe<Scalars['Float']['output']>;
  current_status: TransactionStatusEnum;
  original_id: Scalars['ID']['output'];
  quantity: Scalars['Float']['output'];
  related_transaction_id?: Maybe<Scalars['ID']['output']>;
  /** Reward node */
  reward: RewardNode;
  reward_id: Scalars['Int']['output'];
  transaction_type: TransactionTypeEnum;
  /** User node */
  user?: Maybe<MyUserNode>;
};

export type OrganizationTransactionNodeEdge = {
  __typename?: 'OrganizationTransactionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: OrganizationTransactionNode;
};

export type OrganizationTransactionsConnection = {
  __typename?: 'OrganizationTransactionsConnection';
  /** Contains the nodes of this connection */
  edges: Array<OrganizationTransactionNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type OrganizationUserMentorType = {
  __typename?: 'OrganizationUserMentorType';
  email: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
  user_organization_id: Scalars['Int']['output'];
};

/** Workplaces of an organization */
export type OrganizationWorkplaceNode = {
  __typename?: 'OrganizationWorkplaceNode';
  /** Position name */
  name: Scalars['String']['output'];
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Original ID */
  original_id: Scalars['Int']['output'];
};

export type OrganizationalMutations = {
  __typename?: 'OrganizationalMutations';
  /** Set CEO of a centralized organization */
  set_organization_ceo: OrganizationChartInfoResponse;
  /** Update organization chart configuration */
  update_organization_chart_config: OrganizationChartInfoResponse;
  /** Update organization chart of a centralized organization */
  update_organization_chart_visibility: OrganizationChartInfoResponse;
};


export type OrganizationalMutationsSet_Organization_CeoArgs = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
};


export type OrganizationalMutationsUpdate_Organization_Chart_ConfigArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  ceo_id?: InputMaybe<Scalars['Int']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrganizationalMutationsUpdate_Organization_Chart_VisibilityArgs = {
  centralized_organization_id: Scalars['ID']['input'];
  is_visible: Scalars['Boolean']['input'];
};

export enum OriginBlockedEnum {
  ProfileApplicant = 'PROFILE_APPLICANT',
  ReceptionApplicants = 'RECEPTION_APPLICANTS'
}

export type OwnerTypeType = {
  __typename?: 'OwnerTypeType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PidAverageTeamEvaluationDataInput = {
  employee_id: Scalars['Int']['input'];
  pid_id: Scalars['Int']['input'];
};

export type PidAverageTeamEvaluationDataResponse = PidAverageTeamEvaluationDataType | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type PidAverageTeamEvaluationDataType = {
  __typename?: 'PIDAverageTeamEvaluationDataType';
  higher_avg_progress_users: Array<EmployeeEvaluationDataType>;
  last_month_total_avg_progress: Scalars['Int']['output'];
  lower_avg_progress: Array<EmployeeEvaluationDataType>;
  percentage_versus_last_month: Scalars['Int']['output'];
  total_avg_progress: Scalars['Int']['output'];
};

export type PidBossTracksReportInput = {
  employee_id: Scalars['Int']['input'];
  pid_id: Scalars['Int']['input'];
};

export type PidBossTracksReportResponse = PidBossTracksReportType | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type PidBossTracksReportType = {
  __typename?: 'PIDBossTracksReportType';
  activities_with_boss_progress?: Maybe<Scalars['Int']['output']>;
  activities_without_boss_progress?: Maybe<Scalars['Int']['output']>;
  next_track_date?: Maybe<Scalars['String']['output']>;
  overdue_tracks?: Maybe<Scalars['Int']['output']>;
  percentage_versus_last_month?: Maybe<Scalars['Int']['output']>;
  total_tracks?: Maybe<Scalars['Int']['output']>;
  tracks_with_boss_progress?: Maybe<Scalars['Int']['output']>;
};

export type PidLeaderDashboardActivitiesDataInput = {
  activity_name_filter?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  employee_id: Scalars['Int']['input'];
  evaluated?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  in_progress?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  model_seventy_filter?: InputMaybe<Scalars['Boolean']['input']>;
  model_ten_filter?: InputMaybe<Scalars['Boolean']['input']>;
  model_twenty_filter?: InputMaybe<Scalars['Boolean']['input']>;
  not_initiated?: InputMaybe<Scalars['Boolean']['input']>;
  pid_id: Scalars['Int']['input'];
  sort_by_activity_name?: InputMaybe<Scalars['Boolean']['input']>;
  to_approve?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PidLeaderDashboardActivitiesDataResponse = ActivitiesDataListConnection | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type PidLeaderDashboardActivityIndicatorsInput = {
  employee_id: Scalars['Int']['input'];
  pid_id: Scalars['Int']['input'];
};

export type PidLeaderDashboardActivityIndicatorsResponse = LeaderDashboardActivityIndicatorsType | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type PidLeaderDashboardIndicatorsInput = {
  employee_id: Scalars['Int']['input'];
  pid_id: Scalars['Int']['input'];
};

export type PidLeaderDashboardIndicatorsResponse = LeaderDashboardIndicatorsType | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type PidLeaderDashboardPointsResponse = LeaderDashboardPoints | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type PidLeaderDashboardUsersDataInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  employee_id: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name_filter?: InputMaybe<Scalars['String']['input']>;
  pid_id: Scalars['Int']['input'];
  sort_by_boss_progress?: InputMaybe<Scalars['Boolean']['input']>;
  sort_by_name?: InputMaybe<Scalars['Boolean']['input']>;
  with_activitities_to_approve?: InputMaybe<Scalars['Boolean']['input']>;
  with_activitities_to_follow?: InputMaybe<Scalars['Boolean']['input']>;
  without_activities?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PidLeaderDashboardUsersDataResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | UserActivitiesDataListConnection;

export type PidLowerAutoevaluationUsersDataInput = {
  employee_id: Scalars['Int']['input'];
  pid_id: Scalars['Int']['input'];
};

export type PidLowerAutoevaluationUsersDataListType = {
  __typename?: 'PIDLowerAutoevaluationUsersDataListType';
  autoevaluation_users_data: Array<PidLowerAutoevaluationUsersDataType>;
  first_place: Array<PidLowerAutoevaluationUsersDataType>;
  less_than_half_users_without_progress?: Maybe<Scalars['Boolean']['output']>;
  perfect_current_autoevaluation_avg?: Maybe<Scalars['Boolean']['output']>;
  second_place: Array<PidLowerAutoevaluationUsersDataType>;
  third_place: Array<PidLowerAutoevaluationUsersDataType>;
};

export type PidLowerAutoevaluationUsersDataResponse = PidLowerAutoevaluationUsersDataListType | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type PidLowerAutoevaluationUsersDataType = {
  __typename?: 'PIDLowerAutoevaluationUsersDataType';
  current_autoevaluation_avg: Scalars['Int']['output'];
  employee_id: Scalars['Int']['output'];
  job: Scalars['String']['output'];
  last_month_autoevaluation_avg: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  percentage_versus_last_month: Scalars['Int']['output'];
};

export type PseBankData = {
  __typename?: 'PSEBankData';
  bank_code?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
};

/** Information to aid in pagination. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  end_cursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  has_next_page: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  has_previous_page: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  start_cursor?: Maybe<Scalars['String']['output']>;
};

export type PageInfoI = {
  /** When paginating forwards, are there more items? */
  has_next_page: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  has_previous_page: Scalars['Boolean']['output'];
};

export type PageNumberPaginationCourse = {
  __typename?: 'PageNumberPaginationCourse';
  edges: Array<PrivateCourseTypePaginationEdge>;
  metadata?: Maybe<CourseMetadataType>;
  /** Information to aid in pagination. */
  page_info: NumberPageInfo;
  page_size?: Maybe<Scalars['Int']['output']>;
};

/** Input for retrieve a course live session [Query] */
export type PaginatedCourseLiveSessionsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  course_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LiveSessionOrderBy>>;
  organization_id: Scalars['ID']['input'];
  text_search?: InputMaybe<Scalars['String']['input']>;
};

/** Input for list a live sessions, PAGINATED [Query] */
export type PaginatedLiveSessionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LiveSessionOrderBy>>;
  organization_id: Scalars['String']['input'];
  status: StatusSessionEnum;
  text_search?: InputMaybe<Scalars['String']['input']>;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  current_page: Scalars['Int']['output'];
  per_page: Scalars['Int']['output'];
  total_items: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type PaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PairAnswerChoiceOptionType = {
  __typename?: 'PairAnswerChoiceOptionType';
  id?: Maybe<Scalars['ID']['output']>;
  image_url?: Maybe<UrlNode>;
  option_image_id?: Maybe<Scalars['Int']['output']>;
  option_text?: Maybe<Scalars['String']['output']>;
  option_type?: Maybe<PairAnswerTypeEnum>;
};

export type PairAnswerChoiceType = {
  __typename?: 'PairAnswerChoiceType';
  id?: Maybe<Scalars['ID']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<PairAnswerChoiceOptionType>>;
  position?: Maybe<Scalars['Int']['output']>;
};

export enum PairAnswerTypeEnum {
  TypeConcept = 'TYPE_CONCEPT',
  TypeResponse = 'TYPE_RESPONSE'
}

export type ParametersMutation = {
  __typename?: 'ParametersMutation';
  /** Soft-delete (deactivate) an existing payroll parameter set. Requires internal Crehana admin role (crehana_internal_admin). */
  deactivate_payroll_parameters: PayrollDeactivatePayrollParametersResult;
  /** Seed the 2026 payroll parameter set for a legal entity. Idempotent: if an active set already exists for the same (legal_entity, fiscal_year), returns the existing one without creating a duplicate. */
  seed_payroll_parameters: PayrollSeedPayrollParametersResult;
  /** Update an existing payroll parameter set (UMA/SMG/caps). Only provided fields are applied; invariants are re-validated. Idempotent: returns the set unchanged if nothing differs. Requires internal Crehana admin role (crehana_internal_admin). */
  update_payroll_parameters: PayrollUpdatePayrollParametersResult;
};


export type ParametersMutationDeactivate_Payroll_ParametersArgs = {
  input: PayrollDeactivatePayrollParametersInput;
};


export type ParametersMutationSeed_Payroll_ParametersArgs = {
  input: PayrollSeedPayrollParametersInput;
};


export type ParametersMutationUpdate_Payroll_ParametersArgs = {
  input: PayrollUpdatePayrollParametersInput;
};

export type ParametersQuery = {
  __typename?: 'ParametersQuery';
  /** Calculate SDI (Salario Diario Integrado) applying LFT minimums (Art. 76 vacations, Art. 80 premium, Art. 87 bonus) and IMSS caps (25 UMAs). Pure calculator: does not persist anything. Returns SDI, sdi_capped, integration_factor, the vacation_days used and warnings. vacation_days is taken from the input when sent, and derived from seniority_years (Art. 76 LFT) only when it arrives null. */
  calculate_sdi: PayrollCalculateSdiResult;
  /** Return the payroll parameter set active on `as_of_date` for a legal entity. Scoped to the caller's organization. */
  get_payroll_parameters: PayrollGetPayrollParametersResult;
};


export type ParametersQueryCalculate_SdiArgs = {
  input: PayrollCalculateSdiInput;
};


export type ParametersQueryGet_Payroll_ParametersArgs = {
  input: PayrollGetPayrollParametersInput;
};

export type PasswordPolicyRuleType = {
  __typename?: 'PasswordPolicyRuleType';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  regex: Scalars['String']['output'];
};

export type PasswordPolicyType = {
  __typename?: 'PasswordPolicyType';
  centralized_organization_id: Scalars['ID']['output'];
  min_length: Scalars['Int']['output'];
  require_special_chars: Scalars['Boolean']['output'];
  require_uppercase_and_numbers: Scalars['Boolean']['output'];
  rules: Array<PasswordPolicyRuleType>;
};

/** Frecuencia de pago de nómina. */
export enum PayFrequencyEnum {
  Catorcenal = 'CATORCENAL',
  Mensual = 'MENSUAL',
  Quincenal = 'QUINCENAL',
  Semanal = 'SEMANAL'
}

export type PaymentErrorNode = {
  __typename?: 'PaymentErrorNode';
  code: Scalars['String']['output'];
  key: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
};

export type PaymentGatewayNode = {
  __typename?: 'PaymentGatewayNode';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  logo?: Maybe<ImageType>;
  payment_type?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PaymentGatewayOrgNode = {
  __typename?: 'PaymentGatewayOrgNode';
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  payment_gateway: PaymentGatewayNode;
  payment_method_ids?: Maybe<Array<Scalars['Int']['output']>>;
  payment_methods?: Maybe<Array<PaymentMethodNode>>;
};

export type PaymentGatewayOrgV2Node = {
  __typename?: 'PaymentGatewayOrgV2Node';
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  payment_gateway: DatafastGatewayNodeEpaycoGatewayNodeFlywireGatewayNode;
  payment_methods: Array<EpaycoCcMethodNodeEpaycoPseMethodNodeFlywireCardMethodNode>;
};

/** Método de pago de nómina. */
export enum PaymentMethodEnum {
  Cheque = 'CHEQUE',
  Efectivo = 'EFECTIVO',
  Transferencia = 'TRANSFERENCIA'
}

export type PaymentMethodNode = {
  __typename?: 'PaymentMethodNode';
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  logo?: Maybe<ImageType>;
  type: Scalars['String']['output'];
};

/** Input to activate (mark as vigente) an employment subsidy table (internal admin only). Validates that brackets cover the full year before activating (AC-A5). */
export type PayrollActivateEmploymentSubsidyTableInput = {
  /** Centralized organization ID for org isolation. */
  centralized_organization_id: Scalars['ID']['input'];
  /** UUID of the employment subsidy table to activate. */
  id: Scalars['ID']['input'];
};

export type PayrollActivateEmploymentSubsidyTableResult = EmploymentSubsidyTableResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input to activate (mark as vigente) an ISR table (internal admin only). Validates that brackets cover the full year before activating (AC-A5). */
export type PayrollActivateIsrTableInput = {
  /** Centralized organization ID for org isolation. */
  centralized_organization_id: Scalars['ID']['input'];
  /** UUID of the ISR table to activate. */
  id: Scalars['ID']['input'];
};

export type PayrollActivateIsrTableResult = InternalErrorResponse | IsrTableResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type PayrollApproveIncidencesInput = {
  /** Organization that owns the incidences (scope/isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Ids of the incidences to approve (one or many). Must contain at least one id. Only PENDING incidences are transitioned; already terminal ones are skipped (idempotent). */
  incidence_ids: Array<Scalars['UUID']['input']>;
};

/** Como se activa el concepto dentro del tipo de nomina. ALWAYS: el motor lo calcula para todos. CONDITIONAL: solo si hay una incidencia que lo gatille. OPTIONAL: solo por captura manual del admin. */
export enum PayrollAssignmentTypeEnum {
  Always = 'ALWAYS',
  Conditional = 'CONDITIONAL',
  Optional = 'OPTIONAL'
}

/** Payload for associate_payroll_types_to_periodicity. */
export type PayrollAssociatePayrollTypesPayload = {
  __typename?: 'PayrollAssociatePayrollTypesPayload';
  added: Array<Scalars['ID']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  payroll_types: Array<PayrollPeriodicityPayrollTypeRef>;
  periodicity: PayrollPeriodicitySchema;
  removed: Array<Scalars['ID']['output']>;
  warnings: Array<PayrollPeriodicityAssociationWarning>;
};

export type PayrollAssociatePayrollTypesResult = InternalErrorResponse | PayrollAssociatePayrollTypesPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/** Set declarativo de payroll types asociados a una periodicidad. La lista es el estado deseado completo: ids no incluidos se desasocian. Idempotente. */
export type PayrollAssociatePayrollTypesToPeriodicityInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Set deseado completo. Tipos no incluidos se desasocian. Lista vacia desasocia todo. Maximo 200 ids por llamada. */
  payroll_type_ids: Array<Scalars['ID']['input']>;
  /** Id of the periodicity. */
  periodicity_id: Scalars['ID']['input'];
};

/** Calcula la corrida abriendo una version nueva. Sirve al primer calculo, al re-calculo y al reproceso de una corrida cerrada. La version anterior se conserva. Falla si la corrida esta timbrada: en ese caso las correcciones se hacen con incidencias sobre la corrida siguiente. La razon social se lee de la corrida y ya no viaja en este input (PAYR-558 AC-4). */
export type PayrollCalculatePayrollRunInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Empleados (id entero) a calcular. Omitir = todos los empleados activos de la razon social, acotados por los filtros de registro patronal y centro de trabajo que se hayan pasado. */
  centralized_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filtra por registro patronal (employer registration). No define la corrida: solo acota a quien se le calcula. Omitir = toda la razon social de la corrida. Si no pertenece a esa razon social, la operacion falla y no calcula nada. */
  employer_registration_id?: InputMaybe<Scalars['ID']['input']>;
  /** Corrida a calcular. Su `legal_entity_id` define el alcance; si la corrida no tiene razon social, el calculo se rechaza. */
  payroll_run_id: Scalars['ID']['input'];
  /** Filtra por centro de trabajo (work location). No define la corrida: solo acota a quien se le calcula. Omitir = toda la razon social de la corrida. Si no pertenece a esa razon social, o no cuelga del registro patronal que se paso, la operacion falla y no calcula nada. */
  work_location_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Resultado de calculate_payroll_run: la corrida, la version recien abierta y las variables calculadas contra ella. */
export type PayrollCalculatePayrollRunPayload = {
  __typename?: 'PayrollCalculatePayrollRunPayload';
  created_count: Scalars['Int']['output'];
  /** Empleados que quedaron sin calcular (PAYR-535 AC-7.b). El resto de la corrida se persistio igual. */
  errors: Array<PayrollEmployeeCalculationErrorSchema>;
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<CalculatedVariableSchema>;
  run: PayrollRunSchema;
  skipped_count: Scalars['Int']['output'];
  version: PayrollRunVersionSchema;
};

export type PayrollCalculatePayrollRunResult = InternalErrorResponse | PayrollCalculatePayrollRunPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/**
 * Calcula la pre-nomina del paso 1 (PAYR-510): el mismo motor y las mismas formulas, sobre el subconjunto de conceptos que no necesita insumo fiscal.
 *
 * **No es un estimado, es un parcial exacto.** Lo que devuelve para el sueldo, la corrida completa lo devuelve identico — no hay una segunda implementacion.
 *
 * Abre una version `PRE_PAYROLL` con `is_current: false` y **no** marca las incidencias del periodo como consumidas.
 *
 * 🔴 Desde PAYR-598 **si** mueve la corrida a `PRE_NOMINA`, y solo hacia adelante: la transicion ocurre desde `PENDIENTE` o `EN_PREPARACION`. Se puede disparar desde cualquier otro estado —incluida una corrida ya calculada, que sigue siendo un caso soportado— y en esos casos devuelve la vista previa **sin tocar el estado**, para no retroceder el stepper ni cambiar cual es el resultado vigente.
 *
 * Mismo embudo opcional que `calculate_payroll_run`.
 */
export type PayrollCalculatePrePayrollInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Empleados (id entero) a calcular. Omitir = todos los empleados activos de la razon social, acotados por los filtros de registro patronal y centro de trabajo que se hayan pasado. */
  centralized_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filtra por registro patronal. No define la corrida: solo acota a quien se le calcula. Omitir = toda la razon social de la corrida. Si no pertenece a esa razon social, la operacion falla **antes** de abrir la version y no calcula nada. */
  employer_registration_id?: InputMaybe<Scalars['ID']['input']>;
  /** Corrida cuya pre-nomina se calcula. Su `legal_entity_id` define el alcance; si la corrida no tiene razon social, se rechaza. Falla tambien si esta timbrada, pagada o cancelada. */
  payroll_run_id: Scalars['ID']['input'];
  /** Filtra por centro de trabajo. No define la corrida: solo acota a quien se le calcula. Omitir = toda la razon social de la corrida. Si no pertenece a esa razon social, o no cuelga del registro patronal que se paso, la operacion falla y no calcula nada. */
  work_location_id?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Resultado de calculate_pre_payroll: el parcial exacto del paso 1, con su alcance declarado.
 *
 * 🔴 **Ningun campo de este payload es el costo de la nomina.** El subtotal excluye ISR, subsidio al empleo y cuotas IMSS; presentarlo como 'total', 'costo' o 'neto' se equivoca por entre 20% y 30%. La etiqueta correcta es **'Subtotal pre-nomina'**, y `excluded_summary` viene ya escrito para mostrarse al lado.
 *
 * ⚠️ **No sirve para revisar tratamiento fiscal.** No hay reparto gravado/exento (`includes_tax_split` es `false`): el tope de exencion se expresa en UMA y la UMA es un insumo fiscal. Sirve para revisar sueldos, dias e incidencias, y para eso es exacto.
 *
 * ⚠️ Una organizacion cuyo catalogo tenga conceptos sembrados **sin formula** no recibe menos numeros: recibe un `ValidationErrorResponse` con la lista de los conceptos a formular. Es el mismo comportamiento del calculo completo.
 */
export type PayrollCalculatePrePayrollPayload = {
  __typename?: 'PayrollCalculatePrePayrollPayload';
  /** Suma de las lineas de deduccion de esta version. Hoy suele ser `0`: las dos deducciones del catalogo estandar —cuota IMSS obrera e ISR— dependen de insumo fiscal y quedan fuera del subconjunto. */
  deductions_subtotal: Scalars['Decimal']['output'];
  /** Suma de las lineas de percepcion de esta version. */
  earnings_subtotal: Scalars['Decimal']['output'];
  /** Colaboradores con al menos una linea. Es la poblacion sobre la que esta calculado el subtotal: un parcial tiene que decir sobre cuantos lo es. */
  employees_calculated: Scalars['Int']['output'];
  /** Colaboradores que no se pudieron calcular. El resto del resultado se persistio igual. */
  employees_skipped: Scalars['Int']['output'];
  /**
   * Los salteados con su motivo por empleado. Misma forma que la tabla de validacion del paso 1, asi que el operador ya la conoce.
   *
   * ⚠️ Una caida del **servicio de contratos** no aparece aca: no es un fallo por empleado y tumba la operacion entera con `InternalErrorResponse`. Un subtotal sobre cero colaboradores no es informacion.
   */
  errors: Array<PayrollEmployeeCalculationErrorSchema>;
  /** Conceptos que quedaron fuera y por que. **Derivado del AST**, no de una lista configurada: un concepto entra a la pre-nomina si ni el ni nada de lo que depende transitivamente lee del snapshot fiscal o del acumulado. El dia que alguien formule un concepto que hoy no tiene regla, aparece solo del lado que le toque. */
  excluded_concepts: Array<PayrollPrePayrollExclusionSchema>;
  /** Frase lista para mostrar junto al subtotal, derivada de `excluded_concepts`. Existe para que la UI **no pueda** mostrar el subtotal sin decir que no incluye. */
  excluded_summary: Scalars['String']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  /** Conceptos que la pre-nomina si calculo, ordenados. Incluye los informativos (`SDI`, `FACTOR_INTEGRACION`), que entran al subconjunto sin producir linea de recibo. */
  included_concept_codes: Array<Scalars['String']['output']>;
  /** Si los importes traen reparto gravado/exento. **Siempre `false` en V1** y declarado como campo —y no asumido— para que conectarlo el dia que exista no sea un cambio de schema. */
  includes_tax_split: Scalars['Boolean']['output'];
  /** Percepciones incluidas menos deducciones incluidas. **Nunca se muestra como total, costo ni neto.** Ver `excluded_summary`. */
  pre_payroll_subtotal: Scalars['Decimal']['output'];
  /** La corrida tal como quedo. **Sigue en `pendiente`**: la pre-nomina no consume los estados del stepper, y es lo que mantiene la frontera paso 1 / paso 2. */
  run: PayrollRunSchema;
  /** La version que se abrio, con `calculation_scope: PRE_PAYROLL` y `is_current: false`. Queda en el historial de la corrida con su fecha y su subtotal. */
  version: PayrollRunVersionSchema;
};

export type PayrollCalculatePrePayrollResult = InternalErrorResponse | PayrollCalculatePrePayrollPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/** Calculate SDI (Salario Diario Integrado) applying LFT minimums and IMSS caps. */
export type PayrollCalculateSdiInput = {
  /** Date to resolve the active parameter set (UMA, SM, tope SBC). */
  as_of_date: Scalars['Date']['input'];
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Christmas bonus days (aguinaldo). Must be >= 15 (Art. 87 LFT). */
  days_of_bonus: Scalars['Int']['input'];
  /** Legal entity (used to look up active parameters for the date). */
  legal_entity_id: Scalars['ID']['input'];
  /** Daily salary in MXN. Must be >= min wage (Art. LFT). */
  salary_daily: Scalars['Decimal']['input'];
  /** Completed years of seniority. Determines vacation days per Art. 76 LFT (reforma 2023). */
  seniority_years: Scalars['Int']['input'];
  /** Actual vacation days granted by the contract. Optional: when null, they are derived from seniority_years per Art. 76 LFT (reforma 2023). Send it when the employer grants more than the legal minimum. */
  vacation_days?: InputMaybe<Scalars['Int']['input']>;
  /** Vacation premium percentage. Must be >= 25 (Art. 80 LFT). */
  vacation_premium_pct: Scalars['Decimal']['input'];
};

export type PayrollCalculateSdiResult = InternalErrorResponse | PayrollParametersNotFoundResponse | PayrollSdiCalculationPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/** Dispara el calculo y persiste las variables de una corrida (per empleado) para el alcance dado. */
export type PayrollCalculateVariablesInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Empleados (id entero) a recalcular. Omitir = todos los empleados activos del centro de trabajo. */
  centralized_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Registro patronal (employer registration) id. */
  employer_registration_id: Scalars['ID']['input'];
  /** Razon social (legal entity) id. */
  legal_entity_id: Scalars['ID']['input'];
  /** Version de la corrida sobre la que se calcula. Determina el tipo de nomina y el periodo, asi que no se mandan aparte. */
  payroll_run_version_id: Scalars['ID']['input'];
  /** Centro de trabajo (work location) id. */
  work_location_id: Scalars['ID']['input'];
};

/** Payload para calculate_variables. */
export type PayrollCalculateVariablesPayload = {
  __typename?: 'PayrollCalculateVariablesPayload';
  centralized_organization_id: Scalars['ID']['output'];
  created_count: Scalars['Int']['output'];
  employer_registration_id: Scalars['ID']['output'];
  /** Empleados salteados. Vacio no significa que se calculo a todos: `created_count` es lo que se persistio. */
  errors: Array<PayrollEmployeeCalculationErrorSchema>;
  graphql_operation_id: Scalars['ID']['output'];
  legal_entity_id: Scalars['ID']['output'];
  payroll_run_version_id: Scalars['ID']['output'];
  results: Array<CalculatedVariableSchema>;
  skipped_count: Scalars['Int']['output'];
  work_location_id: Scalars['ID']['output'];
};

export type PayrollCalculateVariablesResult = InternalErrorResponse | PayrollCalculateVariablesPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/** Offset/limit pagination. */
export type PayrollCalculatedVariablePagination = {
  /** Max items to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Items to skip. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Fila de la planilla que no se pudo cargar. */
export type PayrollCalendarImportRowError = {
  __typename?: 'PayrollCalendarImportRowError';
  /** Motivo del rechazo. */
  reason: Scalars['String']['output'];
  /** Numero de fila tal como se ve en la planilla. La fila 1 es el encabezado, asi que la primera fila de datos es la 2. */
  row_number: Scalars['Int']['output'];
};

/** Cancela la corrida. Es terminal para esa corrida pero no para el periodo: despues se puede abrir una nueva sobre el mismo par. No se puede cancelar una corrida timbrada. */
export type PayrollCancelPayrollRunInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Corrida a cancelar. */
  payroll_run_id: Scalars['ID']['input'];
};

/** CFDI payroll classification per SAT catalogue. */
export enum PayrollCfdiClassification {
  Extraordinaria = 'EXTRAORDINARIA',
  Ordinaria = 'ORDINARIA'
}

/**
 * Cierra la corrida. 🔴 **Es irreversible** (PAYR-598/D-2).
 *
 * Hasta PAYR-598 esta descripcion prometia lo contrario —'no es terminal, se puede reprocesar llamando a `calculate_payroll_run`'— y la maquina de estados lo respaldaba. Esa arista ya no existe: **la unica ventana de correccion es recalcular desde `CALCULADO`**, antes de generar el archivo de dispersion.
 *
 * Solo se cierra desde `DISPERSADO`. Una corrida en `CALCULADO` tiene que generar su archivo bancario primero; intentarlo antes devuelve `ValidationErrorResponse` nombrando los destinos admitidos.
 */
export type PayrollClosePayrollRunInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /**
   * Confirmacion de que **todos los pagos de la corrida ya fueron realizados**. Es la casilla del modal del paso 3, y es lo que hace legitimo que el cierre sea irreversible.
   *
   * Sin `true` el cierre se rechaza con `ValidationErrorResponse`. El default es `false` a proposito: quien no lo manda no confirmo nada.
   */
  payments_confirmed?: Scalars['Boolean']['input'];
  /** Corrida a cerrar. */
  payroll_run_id: Scalars['ID']['input'];
};

/** Un concepto dentro del paquete. */
export type PayrollConceptAssignmentItemInput = {
  /** ALWAYS / CONDITIONAL / OPTIONAL. */
  assignment_type?: PayrollAssignmentTypeEnum;
  /** Si la asignacion esta vigente. Distinto de que el concepto este activo en el catalogo: para calcularse hacen falta las dos. */
  is_active?: Scalars['Boolean']['input'];
  /** Concepto que se asigna al tipo de nomina. */
  payroll_concept_id: Scalars['ID']['input'];
};

/** Un concepto asignado a un tipo de nomina. El id es la identidad; el codigo y el nombre son lo que se muestra. */
export type PayrollConceptAssignmentSchema = {
  __typename?: 'PayrollConceptAssignmentSchema';
  assignment_type: PayrollAssignmentTypeEnum;
  /** Codigo del concepto asignado. */
  concept_code?: Maybe<Scalars['String']['output']>;
  /** Nombre del concepto asignado. */
  concept_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  payroll_concept_id: Scalars['ID']['output'];
  payroll_type_id: Scalars['ID']['output'];
  /** Nombre del tipo de nomina. Lo usa la vista cruzada. */
  payroll_type_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** Paquete de conceptos de un tipo de nomina. */
export type PayrollConceptAssignmentsPayload = {
  __typename?: 'PayrollConceptAssignmentsPayload';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<PayrollConceptAssignmentSchema>;
  total: Scalars['Int']['output'];
};

export type PayrollConceptAssignmentsResult = InternalErrorResponse | PayrollConceptAssignmentsPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/** Base de calculo del concepto: sobre que magnitud se aplica. */
export enum PayrollConceptCalcBase {
  DailySalary = 'DAILY_SALARY',
  FixedAmount = 'FIXED_AMOUNT',
  Formula = 'FORMULA',
  GravableIncome = 'GRAVABLE_INCOME',
  Percentage = 'PERCENTAGE',
  Sbc = 'SBC',
  Sdi = 'SDI'
}

/** Filter for list_payroll_concepts. */
export type PayrollConceptFilter = {
  /** Filter by concept type (PERCEPTION/DEDUCTION/INFORMATIONAL). */
  concept_type?: InputMaybe<PayrollConceptTypeEnum>;
  /** Filter by deprecated flag (set when SICOSS removes the concept). */
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by active flag. */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by mandatory flag (De Ley). */
  is_mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by new flag (`Nuevo` badge — set on first sync delta). */
  is_new?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Fila de la planilla de conceptos que no se pudo cargar. */
export type PayrollConceptImportRowError = {
  __typename?: 'PayrollConceptImportRowError';
  /** Motivo del rechazo. */
  reason: Scalars['String']['output'];
  /** Numero de fila tal como se ve en la planilla. La fila 1 es el encabezado, asi que la primera fila de datos es la 2. */
  row_number: Scalars['Int']['output'];
};

export type PayrollConceptMutation = {
  __typename?: 'PayrollConceptMutation';
  /** Crea una regla de calculo para un concepto. Requiere `PlatformAdmin`. Rechaza la formula si referencia un concepto que no existe o si cierra un ciclo. */
  create_concept_rule: PayrollConceptRuleMutationResult;
  /** Da de baja una regla de calculo. Requiere `PlatformAdmin`. Es baja logica: la regla con la que se timbro sigue siendo legible. */
  delete_concept_rule: PayrollDeleteConceptRuleResult;
  /** Carga el catalogo de conceptos de una organizacion desde una planilla `.csv` o `.xlsx`. Requiere `PlatformAdmin`. Upsert por `code`. Las filas invalidas se reportan con su numero de fila y su motivo, y no abortan la carga del resto. */
  import_payroll_concepts: PayrollImportPayrollConceptsResult;
  /** Siembra el catalogo estandar de conceptos en una organizacion — el Bloque 1 del §10 del PRD, minimo para una corrida ordinaria. Requiere `PlatformAdmin`. Idempotente: no duplica reglas, no pisa las formulas ya corregidas y respeta el `is_active` del cliente. */
  seed_standard_concepts: PayrollSeedStandardConceptsResult;
  /** Prende o apaga un concepto. Acepta solo el id y el booleano: es la unica escritura del admin del cliente sobre el catalogo y por eso no puede abrir ningun otro campo. Un concepto obligatorio por ley no lo puede apagar el cliente; `PlatformAdmin` si, porque si cambia la ley alguien tiene que poder retirarlo. */
  set_payroll_concept_active: PayrollConceptMutationResult;
  /** Edita una regla de calculo. Requiere `PlatformAdmin`. Corregir la formulacion de un ejercicio ya timbrado deberia hacerse con una regla nueva y `valid_from`, no editando la vigente. */
  update_concept_rule: PayrollConceptRuleMutationResult;
  /** Correccion puntual de un concepto ya cargado. Requiere `PlatformAdmin`: es la via de soporte, no la del admin del cliente. */
  update_payroll_concept: PayrollConceptMutationResult;
};


export type PayrollConceptMutationCreate_Concept_RuleArgs = {
  input: PayrollCreateConceptRuleInput;
};


export type PayrollConceptMutationDelete_Concept_RuleArgs = {
  input: PayrollDeleteConceptRuleInput;
};


export type PayrollConceptMutationImport_Payroll_ConceptsArgs = {
  input: PayrollImportPayrollConceptsInput;
};


export type PayrollConceptMutationSeed_Standard_ConceptsArgs = {
  input: PayrollSeedStandardConceptsInput;
};


export type PayrollConceptMutationSet_Payroll_Concept_ActiveArgs = {
  input: PayrollSetPayrollConceptActiveInput;
};


export type PayrollConceptMutationUpdate_Concept_RuleArgs = {
  input: PayrollUpdateConceptRuleInput;
};


export type PayrollConceptMutationUpdate_Payroll_ConceptArgs = {
  input: PayrollUpdatePayrollConceptInput;
};

export type PayrollConceptMutationResult = InternalErrorResponse | PayrollConceptResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Offset/limit pagination. */
export type PayrollConceptPagination = {
  /** Max items to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Items to skip. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** How the concept is fed during payroll calculation. */
export enum PayrollConceptProcessType {
  Automatico = 'AUTOMATICO',
  Captura = 'CAPTURA'
}

export type PayrollConceptQuery = {
  __typename?: 'PayrollConceptQuery';
  /** Lista el catalogo de conceptos de la organizacion con su tratamiento fiscal y sus reglas de calculo. Filtra por tipo / activo / de ley / deprecado / nuevo; busqueda case-insensitive sobre `name` y `code`. Orden por defecto: los de ley primero, despues por codigo. */
  list_payroll_concepts: PayrollListPayrollConceptsResult;
};


export type PayrollConceptQueryList_Payroll_ConceptsArgs = {
  input: PayrollListPayrollConceptsInput;
};

/** Un concepto referenciado por una formula. El codigo es la identidad; el nombre es lo que se muestra, porque `D040` no le dice nada a quien lee la formula. */
export type PayrollConceptReferenceSchema = {
  __typename?: 'PayrollConceptReferenceSchema';
  code: Scalars['String']['output'];
  /** Nombre del concepto referenciado. Vacio si el codigo no existe en el catalogo — pasa con expresiones cargadas antes de que la validacion de referencias existiera. */
  name?: Maybe<Scalars['String']['output']>;
};

/** Payload de una mutation sobre un concepto. */
export type PayrollConceptResponse = {
  __typename?: 'PayrollConceptResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: PayrollConceptSchema;
};

export type PayrollConceptRuleMutationResult = InternalErrorResponse | PayrollConceptRuleResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Payload de una mutation sobre una regla de calculo. */
export type PayrollConceptRuleResponse = {
  __typename?: 'PayrollConceptRuleResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: PayrollConceptRuleSchema;
};

/** Regla de calculo de un concepto, versionada por vigencia. Corregir una formula agrega una regla con `valid_from` nuevo en vez de pisar la anterior: recalcular una corrida de marzo tiene que usar la regla que era valida en marzo. */
export type PayrollConceptRuleSchema = {
  __typename?: 'PayrollConceptRuleSchema';
  /** Conceptos que esta regla usa como entrada, con su nombre. Derivado de los `ref.concept` y `depends_on` de la expresion. */
  concept_references: Array<PayrollConceptReferenceSchema>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** AST de la formula, en la forma `{op, args}` con `{literal}` como hoja (especificacion `payr-conceptos.md` §8). Lo produce el editor por bloques, no se teclea. */
  expression?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  payroll_concept_id: Scalars['ID']['output'];
  priority: Scalars['Int']['output'];
  rule_type: PayrollConceptRuleType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  valid_from?: Maybe<Scalars['Date']['output']>;
  valid_to?: Maybe<Scalars['Date']['output']>;
};

/** Tipo de regla de calculo. No todo concepto es una formula: el ISR se resuelve contra la tabla del ejercicio, una prestacion fija es un monto y un bono se captura. */
export enum PayrollConceptRuleType {
  Fixed = 'FIXED',
  Formula = 'FORMULA',
  ManualInput = 'MANUAL_INPUT',
  TableLookup = 'TABLE_LOOKUP'
}

/** Un concepto del catalogo de nomina de la organizacion. */
export type PayrollConceptSchema = {
  __typename?: 'PayrollConceptSchema';
  applies_to_imss: Scalars['Boolean']['output'];
  applies_to_isn: Scalars['Boolean']['output'];
  applies_to_isr: Scalars['Boolean']['output'];
  calc_base: PayrollConceptCalcBase;
  calc_order: Scalars['Int']['output'];
  centralized_organization_id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  concept_type: PayrollConceptTypeEnum;
  created_at: Scalars['DateTime']['output'];
  deprecated: Scalars['Boolean']['output'];
  formula?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_mandatory: Scalars['Boolean']['output'];
  is_new: Scalars['Boolean']['output'];
  last_sicoss_sync_at?: Maybe<Scalars['DateTime']['output']>;
  legal_basis?: Maybe<Scalars['String']['output']>;
  missing_sat_code: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  process_type?: Maybe<PayrollConceptProcessType>;
  /** Reglas de calculo vigentes del concepto, de mayor a menor prioridad. Vacio si todavia no se formulo. */
  rules: Array<PayrollConceptRuleSchema>;
  sat_code?: Maybe<Scalars['String']['output']>;
  sicoss_concept_type?: Maybe<Scalars['String']['output']>;
  tax_exemption_cap_uma?: Maybe<Scalars['Decimal']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

/** Payroll concept type — SICOSS classification. */
export enum PayrollConceptTypeEnum {
  Deduction = 'DEDUCTION',
  Informational = 'INFORMATIONAL',
  Perception = 'PERCEPTION'
}

/** Contract type for a payroll type. */
export enum PayrollContractType {
  Determinado = 'DETERMINADO',
  HonorariosAsimilados = 'HONORARIOS_ASIMILADOS',
  Indeterminado = 'INDETERMINADO',
  JubilacionPension = 'JUBILACION_PENSION'
}

/**
 * Crea una regla de calculo para un concepto. Requiere `PlatformAdmin`.
 *
 * `expression` es el arbol de la formula. Cada nodo interno es `{"op": <operador>, "args": [...]}` y la hoja de valor es `{"literal": <numero|texto numerico|booleano>}`.
 *
 * Operadores: aritmeticos (`add`, `sub`, `mul`, `div`, `mod`, `abs`, `min`, `max`, `floor`, `ceil`, `round`), comparadores (`eq`, `neq`, `gt`, `lt`, `gte`, `lte`), logicos (`and`, `or`, `not`), control (`if`), built-ins fiscales (`isr_lookup`, `subsidy_lookup`, `get`) y `depends_on`, que solo declara orden de calculo y no produce monto.
 *
 * Las referencias son `ref.concept`, `ref.contract`, `ref.run`, `ref.fiscal` y `ref.accumulator`, y toman strings planos como argumento, no nodos.
 *
 * Al guardar se valida la gramatica completa —operador conocido, aridad correcta, referencias permitidas— ademas de que los conceptos referenciados existan y no cierren un ciclo.
 */
export type PayrollCreateConceptRuleInput = {
  /** Organizacion duena del concepto. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Arbol de la formula. Obligatorio cuando `rule_type` es FORMULA. */
  expression?: InputMaybe<Scalars['JSON']['input']>;
  /** Concepto que la regla calcula. */
  payroll_concept_id: Scalars['ID']['input'];
  /** Desempata entre reglas del mismo concepto. Dos reglas con la misma prioridad y vigencia solapada se rechazan. */
  priority?: Scalars['Int']['input'];
  /** FORMULA / TABLE_LOOKUP / FIXED / MANUAL_INPUT. */
  rule_type: PayrollConceptRuleType;
  /** Inicio de vigencia. Vacio es vigencia abierta. */
  valid_from?: InputMaybe<Scalars['Date']['input']>;
  /** Fin de vigencia. Vacio es vigencia abierta. */
  valid_to?: InputMaybe<Scalars['Date']['input']>;
};

/** Input to create a new employment subsidy table (internal admin only). */
export type PayrollCreateEmploymentSubsidyTableInput = {
  /** Ordered list of brackets. Must be contiguous and cover the full domain to be activated (first lower_limit=0, last upper_limit=null). */
  brackets: Array<PayrollEmploymentSubsidyBracketInput>;
  /** Centralized organization ID that owns this record. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Fiscal year of validity (4 digits). Unique per org and period type. */
  fiscal_year: Scalars['Int']['input'];
  /** Period type of the table (monthly for v1). */
  period_type: PayrollEmploymentSubsidyPeriodTypeEnum;
  /** Official source reference (e.g. DOF publication). */
  source_reference: Scalars['String']['input'];
  /** Date from which this table is valid. */
  valid_from: Scalars['Date']['input'];
};

export type PayrollCreateEmploymentSubsidyTableResult = EmploymentSubsidyTableResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input to create a single IMSS branch rate for a fiscal year. If no rate record exists for that year, it is created automatically. Returns a conflict error if the branch already exists for the year. */
export type PayrollCreateImssRateBranchInput = {
  /** Branch rate data to create. */
  branch: PayrollImssRateBranchInput;
  /** Fiscal year to associate the branch with (4 digits). */
  fiscal_year: Scalars['Int']['input'];
};

export type PayrollCreateImssRateBranchResult = ImssRateBranchResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type PayrollCreateIncidenceInput = {
  /** Fixed amount (SAVINGS/INFONAVIT/PENSION/RECURRING/OTHER). Required for FONACOT, which no longer accepts a percentage. Expressed in the payroll currency; an explicit currency field is not available yet. */
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  /** SAVINGS/PENSION: beneficiary reference. */
  beneficiary_ref?: InputMaybe<Scalars['String']['input']>;
  /** Organization that owns the incidence. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Collaborator's centralized user reference the incidence applies to. */
  centralized_user_id: Scalars['Int']['input'];
  /** RECURRING/OTHER: concept description. */
  concept?: InputMaybe<Scalars['String']['input']>;
  /** INFONAVIT/FONACOT: credit number. Exactly 10 characters for INFONAVIT; FONACOT uses a different format and is not length-checked. */
  credit_number?: InputMaybe<Scalars['String']['input']>;
  /** DISABILITY: number of days (> 0). */
  days?: InputMaybe<Scalars['Int']['input']>;
  /** Optional free-text note (max 500 chars), any incidence type. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Type-specific extra data, e.g. OVERTIME factor_distribution: [{factor: 100, hours: 6.0}]. */
  details?: InputMaybe<Scalars['JSON']['input']>;
  /** DISABILITY: WORK_RISK, GENERAL_ILLNESS, MATERNITY or COMMUTING_RISK. */
  disability_type?: InputMaybe<Scalars['String']['input']>;
  /** End date (dated types, must be >= start_date). */
  end_date?: InputMaybe<Scalars['Date']['input']>;
  /** DISABILITY: IMSS disability folio (exactly 8 characters). */
  imss_folio?: InputMaybe<Scalars['String']['input']>;
  /** Incidence type. One of: ABSENTEEISM, DISABILITY, OVERTIME, SAVINGS, INFONAVIT, FONACOT, PENSION, RECURRING, OTHER. */
  incidence_type: Scalars['String']['input'];
  /** RECURRING/OTHER: perception (true) or deduction (false). */
  is_perception?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional payroll type the incidence belongs to. Omitted means the incidence is picked up by any payroll run covering its date, which is the safe default; send it to restrict the incidence to one payroll type when the organization runs several over the same period. */
  payroll_type_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Percentage 0-100 (SAVINGS/INFONAVIT/PENSION). Not accepted for FONACOT. */
  percentage?: InputMaybe<Scalars['Decimal']['input']>;
  /** Date the incidence applies on. Required for every type: it is what anchors the incidence to a payroll period, which the backend derives at calculation time. For types without a range (a fixed INFONAVIT discount, a savings contribution) send the date the amount applies on. The period does not need to exist in the calendar yet. */
  start_date: Scalars['Date']['input'];
  /** ABSENTEEISM: absence subtype. */
  subtype?: InputMaybe<Scalars['String']['input']>;
  /** OVERTIME: total overtime hours (> 0). */
  total_hours?: InputMaybe<Scalars['Decimal']['input']>;
  /** ABSENTEEISM: whether the absence is with pay. */
  with_pay?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input to create a new INFONAVIT discount factor record (internal admin only). */
export type PayrollCreateInfonavitDiscountFactorInput = {
  /** Centralized organization ID that owns this record. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Housing damage insurance fee in MXN, charged once per BIMESTER (not monthly). Optional. Must be greater than or equal to zero if provided. */
  damage_insurance_bimonthly?: InputMaybe<Scalars['Decimal']['input']>;
  /** Discount factor applied to the INFONAVIT credit. Must be greater than zero with up to 4 decimal places. */
  discount_factor: Scalars['Decimal']['input'];
  /** Fiscal year of validity (4 digits). Must be unique per organization. */
  fiscal_year: Scalars['Int']['input'];
  /** Fixed monthly fee in MXN. Must be greater than or equal to zero with up to 4 decimal places. */
  fixed_monthly_fee: Scalars['Decimal']['input'];
  /** Unidad Mixta INFONAVIT (UMI) for the fiscal year. Multiplies the credit's own VSM factor. Optional: a year can be created before INFONAVIT publishes it. Must be greater than zero if provided. */
  mixed_unit_value?: InputMaybe<Scalars['Decimal']['input']>;
  /** Percentage on SBC (Salario Base de Cotizacion). Must be between 0 and 100 with up to 4 decimal places. */
  sbc_percentage: Scalars['Decimal']['input'];
};

export type PayrollCreateInfonavitDiscountFactorResult = InfonavitDiscountFactorResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input to create a single ISN state rate for a fiscal year. If no rate header exists for that year, it is created automatically. Returns a conflict error if the state already exists for the year. Requires internal Crehana admin role (crehana_internal_admin). */
export type PayrollCreateIsnRateStateInput = {
  /** Fiscal year to associate the state rate with (4 digits). */
  fiscal_year: Scalars['Int']['input'];
  /** State rate data to create. */
  state: PayrollIsnRateStateInput;
};

export type PayrollCreateIsnRateStateResult = InternalErrorResponse | IsnRateStateResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input to create a new ISR table (internal admin only). */
export type PayrollCreateIsrTableInput = {
  /** Ordered list of brackets. Must be contiguous and cover the full domain to be activated (first lower_limit=0, last upper_limit=null). */
  brackets: Array<PayrollIsrBracketInput>;
  /** Centralized organization ID that owns this record. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Fiscal year of validity (4 digits). Unique per org and period type. */
  fiscal_year: Scalars['Int']['input'];
  /** Period type of the table (monthly for v1). */
  period_type: PayrollIsrPeriodTypeEnum;
  /** Official source reference (e.g. DOF publication). */
  source_reference: Scalars['String']['input'];
  /** Date from which this table is valid. */
  valid_from: Scalars['Date']['input'];
};

export type PayrollCreateIsrTableResult = InternalErrorResponse | IsrTableResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Abre una corrida de una razon social para un tipo de nomina sobre un periodo. Falla si ya existe una corrida no cancelada para ese trio, o si esa razon social ya tiene una corrida activa de ese tipo de nomina. */
export type PayrollCreatePayrollRunInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Razon social (legal entity) de la corrida. Opcional durante la transicion (PAYR-558/C-1); sin ella la corrida no se puede calcular y volvera a ser obligatoria en PAYR-599. */
  legal_entity_id?: InputMaybe<Scalars['ID']['input']>;
  /** Tipo de nomina de la corrida. A nivel de corrida es uno solo. */
  payroll_type_id: Scalars['ID']['input'];
  /** Periodo del calendario sobre el que se corre. Determina el ejercicio fiscal y el numero de periodo. */
  periodicity_period_id: Scalars['ID']['input'];
};

/** Create a new payroll type. */
export type PayrollCreatePayrollTypeInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** CFDI classification: ORDINARIA or EXTRAORDINARIA. */
  cfdi_classification: PayrollCfdiClassification;
  /** Contract type. */
  contract_type: PayrollContractType;
  /** ISO-4217 currency code. Default 'MXN'. */
  currency?: Scalars['String']['input'];
  /** Days base used to prorate the monthly ISR tariff. Only 30 or 30.4 are accepted; any other value is rejected, not rounded. Defaults to 30 when omitted. */
  days_base?: InputMaybe<Scalars['Decimal']['input']>;
  /** Optional description (<=250 chars). */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional idempotency key. If provided, the same key replays the original response instead of creating a duplicate. */
  idempotency_key?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable name. Unique per organization. */
  name: Scalars['String']['input'];
  /** Periodicity of this payroll type. */
  periodicity_code: PayrollPeriodicityCode;
  /** SAT code, 3 digits (e.g. '001', '009'). */
  sat_code: Scalars['String']['input'];
  /** SAT tax regime code (e.g. '002', '009', '010'). */
  tax_regime_code: Scalars['String']['input'];
};

export type PayrollCreatePayrollTypeResult = InternalErrorResponse | PayrollTypeResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Crea una periodicidad para la organizacion. */
export type PayrollCreatePeriodicityInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Descripcion opcional. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Nombre visible de la periodicidad. */
  name: Scalars['String']['input'];
  /** Dias que dura un periodo. Debe ser coherente con `sat_code`, salvo para la clave '99' (personalizada), que admite cualquier valor positivo. */
  period_days: Scalars['Int']['input'];
  /** Clave SAT de periodicidad de pago. */
  sat_code: PayrollSatPeriodicityCode;
};

/** Da de alta un periodo suelto del calendario. La carga inicial del ejercicio va por planilla; esta via es para agregar un periodo que falto o que se define despues. */
export type PayrollCreatePeriodicityPeriodInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Fecha de corte. Cierra el periodo: el rango es `start_date` - `cutoff_date`, ambos inclusive. */
  cutoff_date: Scalars['Date']['input'];
  /** Ejercicio fiscal del periodo. */
  fiscal_year: Scalars['Int']['input'];
  /** Fecha de pago. Puede caer despues del corte. */
  payment_date: Scalars['Date']['input'];
  /** Numero de periodo dentro del ejercicio. Unico por (periodicidad, ejercicio). */
  period_number: Scalars['Int']['input'];
  /** Periodicidad a la que pertenece el periodo. */
  periodicity_id: Scalars['ID']['input'];
  /** Inicio del periodo. */
  start_date: Scalars['Date']['input'];
  /** Estado inicial. */
  status?: PayrollPeriodStatus;
};

/** Input to deactivate an employment subsidy table (internal admin only). Sets is_active=false and records deactivation audit. */
export type PayrollDeactivateEmploymentSubsidyTableInput = {
  /** Centralized organization ID for org isolation. */
  centralized_organization_id: Scalars['ID']['input'];
  /** UUID of the employment subsidy table to deactivate. */
  id: Scalars['ID']['input'];
};

export type PayrollDeactivateEmploymentSubsidyTableResult = EmploymentSubsidyTableResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse;

/** Input to deactivate a single IMSS branch rate. Sets is_active=false and records deactivation audit. Returns NotFoundErrorResponse if the branch does not exist. */
export type PayrollDeactivateImssRateBranchInput = {
  /** UUID of the ImssRateBranch record to deactivate. */
  id: Scalars['ID']['input'];
};

export type PayrollDeactivateImssRateBranchResult = ImssRateBranchResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse;

/** Input to deactivate an IMSS rate record (internal admin only). Sets is_active=false and records deactivation audit. */
export type PayrollDeactivateImssRateInput = {
  /** UUID of the IMSS rate record to deactivate. */
  id: Scalars['ID']['input'];
};

export type PayrollDeactivateImssRateResult = ImssRateResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse;

/** Input to deactivate an INFONAVIT discount factor record (internal admin only). Sets is_active=false and records deactivation audit. */
export type PayrollDeactivateInfonavitDiscountFactorInput = {
  /** Centralized organization ID for org isolation. */
  centralized_organization_id: Scalars['ID']['input'];
  /** UUID of the INFONAVIT discount factor record to deactivate. */
  id: Scalars['ID']['input'];
};

export type PayrollDeactivateInfonavitDiscountFactorResult = InfonavitDiscountFactorResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse;

/** Input to deactivate an ISN rate record (internal admin only). Sets is_active=false and records deactivation audit. */
export type PayrollDeactivateIsnRateInput = {
  /** UUID of the ISN rate record to deactivate. */
  id: Scalars['ID']['input'];
};

export type PayrollDeactivateIsnRateResult = InternalErrorResponse | IsnRateResponse | NotFoundErrorResponse | UserPermissionErrorResponse;

/** Input to deactivate a single ISN state rate (internal admin only). Sets is_active=false and records deactivation audit. */
export type PayrollDeactivateIsnRateStateInput = {
  /** UUID of the IsnRateState record to deactivate. */
  id: Scalars['ID']['input'];
};

export type PayrollDeactivateIsnRateStateResult = InternalErrorResponse | IsnRateStateResponse | NotFoundErrorResponse | UserPermissionErrorResponse;

/** Input to deactivate an ISR table (internal admin only). Sets is_active=false and records deactivation audit. */
export type PayrollDeactivateIsrTableInput = {
  /** Centralized organization ID for org isolation. */
  centralized_organization_id: Scalars['ID']['input'];
  /** UUID of the ISR table to deactivate. */
  id: Scalars['ID']['input'];
};

export type PayrollDeactivateIsrTableResult = InternalErrorResponse | IsrTableResponse | NotFoundErrorResponse | UserPermissionErrorResponse;

/** Soft-delete (deactivate) an existing payroll parameter set. Internal Crehana admin only. */
export type PayrollDeactivatePayrollParametersInput = {
  /** Centralized organization id that owns the set. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Id of the parameter set to deactivate. */
  id: Scalars['ID']['input'];
  /** Legal entity that owns the set. */
  legal_entity_id: Scalars['ID']['input'];
};

export type PayrollDeactivatePayrollParametersResult = InternalErrorResponse | PayrollParametersNotFoundResponse | PayrollParametersResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Deactivate a payroll type. */
export type PayrollDeactivatePayrollTypeInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Id of the payroll type to deactivate. */
  payroll_type_id: Scalars['ID']['input'];
};

export type PayrollDeactivatePayrollTypeResult = InternalErrorResponse | PayrollTypeResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Desactiva una periodicidad. Falla si alguno de sus tipos de nomina tiene una corrida en proceso. */
export type PayrollDeactivatePeriodicityInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Id de la periodicidad a desactivar. */
  periodicity_id: Scalars['ID']['input'];
};

/** Da de baja una regla de calculo. Es baja logica: la regla con la que se timbro tiene que seguir siendo legible. */
export type PayrollDeleteConceptRuleInput = {
  /** Organizacion duena del concepto. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Regla a dar de baja. */
  concept_rule_id: Scalars['ID']['input'];
};

/** Payload de delete_concept_rule. */
export type PayrollDeleteConceptRulePayload = {
  __typename?: 'PayrollDeleteConceptRulePayload';
  graphql_operation_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type PayrollDeleteConceptRuleResult = InternalErrorResponse | PayrollDeleteConceptRulePayload | UserPermissionErrorResponse | ValidationErrorResponse;

export type PayrollDeleteIncidenceInput = {
  /** Id of the incidence to delete (logical delete, must be MANUAL origin). */
  incidence_id: Scalars['UUID']['input'];
};

/** Disassociate a payroll type from a periodicity. */
export type PayrollDisassociatePayrollTypeFromPeriodicityInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Id of the payroll type to disassociate. */
  payroll_type_id: Scalars['ID']['input'];
  /** Id of the periodicity. */
  periodicity_id: Scalars['ID']['input'];
};

/** Payload for disassociate_payroll_type_from_periodicity. */
export type PayrollDisassociatePayrollTypePayload = {
  __typename?: 'PayrollDisassociatePayrollTypePayload';
  graphql_operation_id: Scalars['ID']['output'];
  payroll_types: Array<PayrollPeriodicityPayrollTypeRef>;
  periodicity: PayrollPeriodicitySchema;
};

export type PayrollDisassociatePayrollTypeResult = InternalErrorResponse | PayrollDisassociatePayrollTypePayload | UserPermissionErrorResponse | ValidationErrorResponse;

/**
 * Una cuenta dispersora elegible para esta corrida.
 *
 * 'Elegible' no es solo activa: la cuenta es de la razon social de la corrida, esta activa, no esta borrada y **o** no tiene periodos de pago asociados **o** uno de ellos es el periodo de la corrida (vacio = sin restriccion).
 */
export type PayrollDispersionBankOptionType = {
  __typename?: 'PayrollDispersionBankOptionType';
  /** Numero de cuenta, si la cuenta lo declara. */
  account_number?: Maybe<Scalars['String']['output']>;
  /** `principal` o `secondary`. */
  account_type: Scalars['String']['output'];
  /** Banco de la cuenta. */
  bank_id: Scalars['ID']['output'];
  /** Nombre del banco. */
  bank_name: Scalars['String']['output'];
  /** CLABE completa, sin enmascarar. La cuenta es configuracion de la organizacion que el llamante ya administra por las operaciones de dispersion; enmascararla aca y no alla seria teatro inconsistente. */
  clabe: Scalars['String']['output'];
  /** Cuenta dispersora. Es el valor que espera `generate_payroll_run_dispersion_file`. */
  dispersion_account_id: Scalars['ID']['output'];
  /** Si la cuenta puede generar un archivo: tiene config **y** archivo del banco cargado. Con `false`, generar devuelve `ValidationErrorResponse`; existe para que la UI no tenga que descubrirlo intentando. */
  has_layout_config: Scalars['Boolean']['output'];
  /** Sugerencia de default: la unica cuenta `principal` activa. Con cero o con dos, ninguna queda marcada — elegir entre dos cuentas dispersoras no es una decision del backend. */
  is_default: Scalars['Boolean']['output'];
  /** Referencia de pago que se estampa en la columna `referencia` del archivo. ⚠️ Hoy suele venir vacia: el alta de cuentas todavia no la manda (PAYR-684). */
  reference?: Maybe<Scalars['String']['output']>;
};

/**
 * Las filas de un mismo motivo, con su conteo.
 *
 * Codigos posibles, **en este orden**: `NON_POSITIVE_NET`, `CONTRACT_NOT_RESOLVED`, `NOT_BANK_TRANSFER`, `UNRESOLVED_PAYMENT_METHOD`, `MISSING_CLABE`, `INVALID_CLABE`, `MISSING_BANK`, `UNRESOLVED_BANK`.
 *
 * El orden es fijo y **no** por conteo: una UI que los pinta en el orden de la respuesta no puede reordenarse entre dos lecturas de la misma corrida. Un empleado que dispara dos condiciones aparece **una** vez, bajo el primer codigo que matchea.
 */
export type PayrollDispersionWarningGroupType = {
  __typename?: 'PayrollDispersionWarningGroupType';
  /** Empleados en este grupo. */
  count: Scalars['Int']['output'];
  /** Si el motivo excluye del archivo. Hoy los excluyen todos. */
  excluded_from_file: Scalars['Boolean']['output'];
  /** Codigo del motivo. */
  reason: Scalars['String']['output'];
  /** Las filas del grupo, ordenadas por empleado. */
  rows: Array<PayrollDispersionWarningRowType>;
};

/** Un empleado con advertencia y su consecuencia sobre el archivo. */
export type PayrollDispersionWarningRowType = {
  __typename?: 'PayrollDispersionWarningRowType';
  /** Empleado. */
  centralized_user_id: Scalars['Int']['output'];
  /** Explicacion en prosa del motivo. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Referencia de federacion. El gateway pega `full_name` desde `crehana-centralized-users`: **ningun nombre se guarda aca**. */
  employee: CentralizedUserNode;
  /** Si esta persona queda fuera de los dos archivos. Es un campo y no una implicacion del grupo: el dia que exista una advertencia que no excluya, no hace falta cambiar el contrato. */
  excluded_from_file: Scalars['Boolean']['output'];
  /** Neto que esta persona **no** va a recibir por transferencia. La suma de estos importes sobre las filas excluidas es exactamente `excluded_amount` (AC-4), y el dominio lo verifica antes de responder. */
  net_amount?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * Causa por la que un empleado no se pudo calcular (PAYR-603).
 *
 * Es un identificador **estable**: sirve para agrupar los errores sin leer el texto de `reason`, que puede reescribirse sin aviso. `reason` sigue siendo el mensaje que se muestra; este codigo es la clave con la que se agrupa.
 *
 * 🔴 **El enum va a crecer.** Un valor que el cliente no reconozca se agrupa bajo 'Otros errores' y **nunca se descarta**: usar una guarda de pertenencia con cubeta de fallback, no un mapa exhaustivo que devuelva `undefined` para un codigo introducido despues del deploy del front. `UNKNOWN` significa que el motor no tiene mapeado ese tipo de fallo todavia, nunca que el dato falte.
 */
export enum PayrollEmployeeCalculationErrorCode {
  AccumulatorNotAvailable = 'ACCUMULATOR_NOT_AVAILABLE',
  CatalogValueUnknown = 'CATALOG_VALUE_UNKNOWN',
  ConceptExpressionEvaluation = 'CONCEPT_EXPRESSION_EVALUATION',
  ContractReferenceNotServed = 'CONTRACT_REFERENCE_NOT_SERVED',
  ContractReferenceUnknown = 'CONTRACT_REFERENCE_UNKNOWN',
  IncidenceReferenceNotResolved = 'INCIDENCE_REFERENCE_NOT_RESOLVED',
  IncidenceReferenceUnknown = 'INCIDENCE_REFERENCE_UNKNOWN',
  MissingContractField = 'MISSING_CONTRACT_FIELD',
  NoActiveContract = 'NO_ACTIVE_CONTRACT',
  OutOfRunScope = 'OUT_OF_RUN_SCOPE',
  PayrollRunLineInvalid = 'PAYROLL_RUN_LINE_INVALID',
  PayFrequencyDaysUnknown = 'PAY_FREQUENCY_DAYS_UNKNOWN',
  TaxExemptionCapUnsupported = 'TAX_EXEMPTION_CAP_UNSUPPORTED',
  Unknown = 'UNKNOWN',
  UnsupportedRuleType = 'UNSUPPORTED_RULE_TYPE'
}

/** Un empleado que quedo sin calcular. No aporta filas: no hay variables en cero para el, porque un cero se lee como resultado. */
export type PayrollEmployeeCalculationErrorSchema = {
  __typename?: 'PayrollEmployeeCalculationErrorSchema';
  /** Empleado que no se pudo calcular. */
  centralized_user_id: Scalars['ID']['output'];
  /**
   * Causa estable del fallo, para **agrupar** sin leer `reason` (PAYR-603). El texto del motivo puede reescribirse; este codigo no.
   *
   * Nunca es null en esta superficie: el clasificador corre en el mismo frame en que nace el fallo, asi que la ausencia es imposible y el peor caso es el miembro `UNKNOWN`.
   *
   * 🔴 **El enum va a crecer**: un valor no reconocido se agrupa bajo 'Otros errores', nunca se descarta.
   */
  code: PayrollEmployeeCalculationErrorCode;
  /** Dato de contrato que falta, o null cuando la causa no es un campo concreto (p. ej. sin contrato vigente en el alcance). */
  field?: Maybe<Scalars['String']['output']>;
  /** Motivo, listo para mostrarse. */
  reason: Scalars['String']['output'];
};

export type PayrollEmployeeResponse = {
  __typename?: 'PayrollEmployeeResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: PayrollEmployeeType;
};

export type PayrollEmployeeType = {
  __typename?: 'PayrollEmployeeType';
  absence_integration?: Maybe<Scalars['Boolean']['output']>;
  accounting_account?: Maybe<Scalars['String']['output']>;
  annual_isr_adjustment?: Maybe<Scalars['Boolean']['output']>;
  bank_account_number?: Maybe<Scalars['String']['output']>;
  bank_branch_number?: Maybe<Scalars['Int']['output']>;
  bank_plaza_code?: Maybe<Scalars['Int']['output']>;
  centralized_user_id: Scalars['ID']['output'];
  clabe?: Maybe<Scalars['String']['output']>;
  contributes_imss?: Maybe<Scalars['Boolean']['output']>;
  contributes_infonavit?: Maybe<Scalars['Boolean']['output']>;
  contributes_retirement?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['DateTime']['output'];
  curp?: Maybe<Scalars['String']['output']>;
  fonacot_number?: Maybe<Scalars['String']['output']>;
  has_disability?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  imss: Scalars['String']['output'];
  imss_medical_unit: Scalars['Int']['output'];
  imss_month_type?: Maybe<Scalars['Boolean']['output']>;
  isr_table_type?: Maybe<Scalars['Int']['output']>;
  last_paid_date?: Maybe<Scalars['Date']['output']>;
  legal_entity_id: Scalars['ID']['output'];
  medical_fitness?: Maybe<Scalars['String']['output']>;
  payment_location_code?: Maybe<Scalars['String']['output']>;
  payment_type?: Maybe<Scalars['Int']['output']>;
  payroll_bank_code?: Maybe<Scalars['String']['output']>;
  payroll_month_type?: Maybe<Scalars['Boolean']['output']>;
  pays_overtime?: Maybe<Scalars['Boolean']['output']>;
  pension_type: Scalars['Int']['output'];
  prior_seniority_years?: Maybe<Scalars['Int']['output']>;
  reports_to_sicoss_id?: Maybe<Scalars['String']['output']>;
  rfc: Scalars['String']['output'];
  sar_bank_code?: Maybe<Scalars['String']['output']>;
  sicoss_card_number?: Maybe<Scalars['String']['output']>;
  sicoss_employee_number: Scalars['String']['output'];
  time_clock_id?: Maybe<Scalars['Int']['output']>;
  union_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
  updated_by: Scalars['ID']['output'];
  vacation_days?: Maybe<Scalars['Int']['output']>;
  valuation: Scalars['Int']['output'];
  working_hours_per_day?: Maybe<Scalars['Int']['output']>;
};

/** Single bracket (renglon) of an employment subsidy table. */
export type PayrollEmploymentSubsidyBracketInput = {
  /** Lower limit of the bracket (limite inferior). Must be >= 0. */
  lower_limit: Scalars['Decimal']['input'];
  /** Employment subsidy amount (subsidio al empleo) for the bracket. Must be >= 0. */
  subsidy_amount: Scalars['Decimal']['input'];
  /** Upper limit of the bracket (limite superior). Null marks the open-ended last bracket. */
  upper_limit?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Period type for an employment subsidy table. */
export enum PayrollEmploymentSubsidyPeriodTypeEnum {
  Monthly = 'MONTHLY'
}

/**
 * Genera los archivos bancarios de la corrida para una cuenta dispersora, en el layout del archivo que esa cuenta tiene cargado.
 *
 * Devuelve **dos** archivos siempre —mismo banco e interbancario—, aunque uno quede vacio.
 *
 * Cada llamada exitosa produce una **generacion nueva** (1, 2, 3...) y no reemplaza a la anterior: el historial es append-only. Dos clicks concurrentes colisionan y el perdedor recibe un error pidiendo reintentar.
 */
export type PayrollGeneratePayrollRunDispersionFileInput = {
  /** Organizacion del llamante. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Cuenta dispersora con la que se paga. Tiene que ser una de las que `get_payroll_run_dispersion` devuelve en `bank_options` y tener `has_layout_config: true`: sin el archivo del banco cargado no se genera nada (AC-9). */
  dispersion_account_id: Scalars['ID']['input'];
  /** Corrida a dispersar. Se usa su version vigente. Falla si la corrida esta timbrada, pagada o cancelada (AC-7) o si la version todavia esta en calculo. */
  payroll_run_id: Scalars['ID']['input'];
};

/**
 * Resultado de una generacion: sus dos lotes y sus importes.
 *
 * `files` trae **exactamente dos** entradas, `same_bank` e `interbank`, aunque una tenga `employees_count: 0`.
 */
export type PayrollGeneratePayrollRunDispersionFilePayload = {
  __typename?: 'PayrollGeneratePayrollRunDispersionFilePayload';
  /** Neto que no entro a ningun archivo. */
  excluded_amount: Scalars['Decimal']['output'];
  /** Los dos lotes de esta generacion. */
  files: Array<PayrollRunDispersionFileType>;
  /** Numero de esta generacion para el par (version, cuenta). */
  generation: Scalars['Int']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  /** Version contra la que se genero. */
  payroll_run_version_id: Scalars['ID']['output'];
  /** Σ de los netos que los archivos mueven. */
  total_to_disperse?: Maybe<Scalars['Decimal']['output']>;
};

export type PayrollGeneratePayrollRunDispersionFileResult = InternalErrorResponse | PayrollGeneratePayrollRunDispersionFilePayload | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input to fetch the active employment subsidy table for a fiscal year and period type. */
export type PayrollGetEmploymentSubsidyTableInput = {
  /** Centralized organization ID of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Fiscal year for which to retrieve the active employment subsidy table. */
  fiscal_year: Scalars['Int']['input'];
  /** Period type of the table (monthly for v1). */
  period_type: PayrollEmploymentSubsidyPeriodTypeEnum;
};

export type PayrollGetEmploymentSubsidyTableResult = EmploymentSubsidyTableResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input to fetch the active IMSS rates for a fiscal year. */
export type PayrollGetImssRateInput = {
  /** Fiscal year for which to retrieve the active IMSS rates. Defaults to current calendar year if not provided. */
  fiscal_year: Scalars['Int']['input'];
};

export type PayrollGetImssRateResult = ImssRateResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type PayrollGetIncidenceInput = {
  /** Id of the active incidence to fetch. Soft-deleted incidences are not returned (yield not found). */
  incidence_id: Scalars['UUID']['input'];
};

/** Input to fetch the active INFONAVIT discount factor for a fiscal year. */
export type PayrollGetInfonavitDiscountFactorInput = {
  /** Centralized organization ID of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Fiscal year for which to retrieve the active factor. */
  fiscal_year: Scalars['Int']['input'];
};

export type PayrollGetInfonavitDiscountFactorResult = InfonavitDiscountFactorResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input to fetch the active ISN rates for a fiscal year (global catalog). */
export type PayrollGetIsnRateInput = {
  /** Fiscal year for which to retrieve the active ISN rates. */
  fiscal_year: Scalars['Int']['input'];
};

export type PayrollGetIsnRateResult = InternalErrorResponse | IsnRateResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input to get a single ISN state rate by its UUID. */
export type PayrollGetIsnRateStateInput = {
  /** UUID of the IsnRateState record to retrieve. */
  id: Scalars['ID']['input'];
};

export type PayrollGetIsnRateStateResult = InternalErrorResponse | IsnRateStateResponse | UserPermissionErrorResponse;

/** Input to fetch the active ISR table for a fiscal year and period type. */
export type PayrollGetIsrTableInput = {
  /** Centralized organization ID of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Fiscal year for which to retrieve the active ISR table. */
  fiscal_year: Scalars['Int']['input'];
  /** Period type of the table (monthly for v1). */
  period_type: PayrollIsrPeriodTypeEnum;
};

export type PayrollGetIsrTableResult = InternalErrorResponse | IsrTableResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Fetch the parameter set active on `as_of_date`. */
export type PayrollGetPayrollParametersInput = {
  /** Date used to resolve the active parameter set (returns the set with valid_from <= as_of_date and is_active=true). */
  as_of_date: Scalars['Date']['input'];
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Legal entity whose parameters are requested. */
  legal_entity_id: Scalars['ID']['input'];
};

export type PayrollGetPayrollParametersResult = InternalErrorResponse | PayrollParametersNotFoundResponse | PayrollParametersResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/**
 * Las tarjetas resumen del periodo activo de la organizacion.
 *
 * El periodo activo se resuelve por **contencion de fechas** y no por `periodicity_period.status`: ese estado se persiste tal cual lo manda la API y ninguna maquina de estados lo hace avanzar, asi que puede estar rancio.
 *
 * Si hoy cae en un hueco del calendario no hay error: los campos de identidad del periodo salen `null` y `collaborators_count` sale `0`, pero `next_closure_date` **se calcula igual** — es una pregunta hacia adelante.
 */
export type PayrollGetPayrollPeriodSummaryInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Acota `collaborators_count` a una razon social. Omitir = todas. */
  legal_entity_id?: InputMaybe<Scalars['ID']['input']>;
  /** Desambigua cual es el periodo activo cuando varias periodicidades cubren el mismo dia (una semanal y una quincenal, por ejemplo). Omitir = el de `start_date` mas temprano. */
  periodicity_id?: InputMaybe<Scalars['ID']['input']>;
};

export type PayrollGetPayrollPeriodSummaryResult = InternalErrorResponse | PayrollPeriodSummaryResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/**
 * Lee el paso de dispersion de una corrida calculada: el contexto, las cuentas dispersoras elegibles, las advertencias agrupadas y el historial de archivos ya generados.
 *
 * La entrada es **la corrida**, no la version — a diferencia de `payroll_receipts`. El dinero se paga una vez, con la version vigente: no existe una lectura legitima de 'dispersa la version 2 de 5', y aceptar un id de version dejaria generar un archivo bancario desde un calculo ya superado.
 */
export type PayrollGetPayrollRunDispersionInput = {
  /** Organizacion del llamante. El alcance se aplica atravesando la corrida: ni `payroll_run_version` ni `payroll_run_dispersion_file` tienen columna de organizacion propia. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Corrida cuyo paso de dispersion se lee. Se resuelve su version vigente; si no tiene ninguna, es `ValidationErrorResponse` con el motivo, no una respuesta vacia. */
  payroll_run_id: Scalars['ID']['input'];
};

export type PayrollGetPayrollRunDispersionResult = InternalErrorResponse | PayrollRunDispersionStepType | UserPermissionErrorResponse | ValidationErrorResponse;

/** Lee una corrida con su historial de versiones. */
export type PayrollGetPayrollRunInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Corrida a consultar. */
  payroll_run_id: Scalars['ID']['input'];
};

export type PayrollGetPayrollRunResult = InternalErrorResponse | PayrollRunDetailResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Fetch a single payroll type by id. */
export type PayrollGetPayrollTypeInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Id of the payroll type to fetch. */
  payroll_type_id: Scalars['ID']['input'];
};

export type PayrollGetPayrollTypeResult = InternalErrorResponse | PayrollTypeResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Fetch a single periodicity with its yearly calendar. */
export type PayrollGetPeriodicityInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Fiscal year of the calendar to include in the response. */
  fiscal_year: Scalars['Int']['input'];
  /** Id of the periodicity to fetch. */
  periodicity_id: Scalars['ID']['input'];
};

export type PayrollGetPeriodicityResult = InternalErrorResponse | PayrollPeriodicityDetailResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Carga el catalogo de conceptos de una organizacion desde una planilla `.csv` o `.xlsx`. Requiere `PlatformAdmin`: la ejecuta un agente de onboarding o soporte, no el admin del cliente. Columnas obligatorias: `code`, `name`, `concept_type`. Opcionales: `sat_code`, `calc_base`, `calc_order`, `applies_to_isr`, `applies_to_imss`, `applies_to_isn`, `tax_exemption_cap_uma`, `legal_basis`. Es un upsert por `code`: volver a subir la planilla corregida pisa lo cargado en vez de duplicarlo, y respeta el `is_active` que el cliente haya movido. */
export type PayrollImportPayrollConceptsInput = {
  /** Organizacion duena del catalogo. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Contenido del archivo en base64. Maximo 2 MB, 500 filas. */
  file_base64: Scalars['String']['input'];
  /** Nombre del archivo con extension. Solo `.csv` o `.xlsx`. */
  file_name: Scalars['String']['input'];
};

/** Resultado de import_payroll_concepts. Las filas invalidas se reportan y se saltean; las validas se cargan igual. */
export type PayrollImportPayrollConceptsPayload = {
  __typename?: 'PayrollImportPayrollConceptsPayload';
  created_count: Scalars['Int']['output'];
  errors: Array<PayrollConceptImportRowError>;
  failed_count: Scalars['Int']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  updated_count: Scalars['Int']['output'];
};

export type PayrollImportPayrollConceptsResult = InternalErrorResponse | PayrollImportPayrollConceptsPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/** Carga el calendario anual de una periodicidad desde una planilla. Requiere `PlatformAdmin`: la ejecuta un agente de onboarding, no el admin del cliente. Columnas obligatorias: `period_number`, `start_date`, `cutoff_date`, `payment_date`; `status` es opcional y por defecto queda en `pendiente`. Las fechas van en `YYYY-MM-DD`. Es un upsert por `period_number`: volver a subir la planilla corregida pisa lo cargado en vez de duplicarlo. */
export type PayrollImportPeriodicityCalendarInput = {
  /** Organizacion duena de la periodicidad. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Contenido del archivo en base64. Maximo 2 MB, 500 filas. */
  file_base64: Scalars['String']['input'];
  /** Nombre del archivo con extension. Solo `.csv` o `.xlsx`. */
  file_name: Scalars['String']['input'];
  /** Ejercicio fiscal a cargar. */
  fiscal_year: Scalars['Int']['input'];
  /** Periodicidad cuyo calendario se carga. */
  periodicity_id: Scalars['ID']['input'];
};

/** Resultado de import_periodicity_calendar. Las filas invalidas se reportan y se saltean; las validas se cargan igual. */
export type PayrollImportPeriodicityCalendarPayload = {
  __typename?: 'PayrollImportPeriodicityCalendarPayload';
  created_count: Scalars['Int']['output'];
  errors: Array<PayrollCalendarImportRowError>;
  failed_count: Scalars['Int']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  updated_count: Scalars['Int']['output'];
};

export type PayrollImportPeriodicityCalendarResult = InternalErrorResponse | PayrollImportPeriodicityCalendarPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/** Per-branch rates input for creating or updating an IMSS rate record. branch_name is derived automatically from branch_code. */
export type PayrollImssRateBranchInput = {
  /** Branch code identifying the IMSS insurance type. */
  branch_code: BranchCodeEnum;
  /** Calculation base. One of: SBC, UMA_DIARIA, SALARIO_INTEGRADO. */
  calculation_base: Scalars['String']['input'];
  /** Display order (1-based, ascending). Must be a positive integer. */
  display_order: Scalars['Int']['input'];
  /** Employee (obrero) contribution rate as a percentage (%). Must be >= 0 and <= employer_rate. Up to 5 decimal places. */
  employee_rate: Scalars['Decimal']['input'];
  /** Employer (patronal) contribution rate as a percentage (%). Must be >= employee_rate. Up to 5 decimal places. */
  employer_rate: Scalars['Decimal']['input'];
};

export type PayrollIncidence = {
  __typename?: 'PayrollIncidence';
  amount?: Maybe<Scalars['Decimal']['output']>;
  beneficiary_ref?: Maybe<Scalars['String']['output']>;
  centralized_organization_id: Scalars['Int']['output'];
  /** Collaborator (federated centralized user). */
  centralized_user: CentralizedUserNode;
  centralized_user_id: Scalars['Int']['output'];
  concept?: Maybe<Scalars['String']['output']>;
  consumed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by: Scalars['Int']['output'];
  /** User who created the incidence (federated). */
  created_by_user: CentralizedUserNode;
  credit_number?: Maybe<Scalars['String']['output']>;
  days?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['JSON']['output']>;
  disability_type?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['Date']['output']>;
  /** The government credit (FONACOT/INFONAVIT) this incidence hangs from, when it has one. Non-null only for `origin = RECURRING`: that incidence is created by the credit and carries no `amount`, `percentage` or `credit_number` of its own — the credit owns the data, the incidence is only how the payroll run finds it. */
  government_credit_id?: Maybe<Scalars['UUID']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  id: Scalars['UUID']['output'];
  imss_folio?: Maybe<Scalars['String']['output']>;
  incidence_type: Scalars['String']['output'];
  /** Whether a payroll run has already used this incidence to calculate. A consumed incidence can no longer be edited or deleted; cancelling or recalculating the run that took it releases it. Derived from consumedAt, so it costs no extra query. */
  is_consumed: Scalars['Boolean']['output'];
  is_perception?: Maybe<Scalars['Boolean']['output']>;
  origin: Scalars['String']['output'];
  payroll_type_id?: Maybe<Scalars['UUID']['output']>;
  percentage?: Maybe<Scalars['Decimal']['output']>;
  /** Status of the payroll run that governs this incidence's period, so consumers can stop offering edits over an already-stamped (timbrado) period. Resolved from the alive runs whose period contains the incidence's start date, scoped to the incidence's organization and narrowed by payroll type when the incidence has one. Since PAYR-558 a covered period can have one alive run per legal entity, and the MOST RESTRICTIVE state wins: if any run covering the period is closed (DISPERSADO, CERRADO, TIMBRADO, PAGADO), that is what is reported. Grouping: OPEN = SIN_CORRIDA, PENDIENTE, PRE_NOMINA, CANCELADO; IN PROGRESS = EN_CALCULO, CALCULADO; CLOSED = DISPERSADO, CERRADO, TIMBRADO, PAGADO. DISPERSADO counts as closed because the bank file was produced and the money already left, even though the run still has to be closed and stamped. SIN_CORRIDA means the period has no alive run, which is an open period. INDETERMINADO means the period could not be resolved (the start date falls in no loaded period, in periods of several periodicities, or every matching run belongs to another organization) and must NOT be grouped as open. Never null: both are answers, not missing data. */
  period_run_status: PayrollIncidencePeriodRunStatus;
  periodicity_period_id?: Maybe<Scalars['UUID']['output']>;
  start_date: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  subtype?: Maybe<Scalars['String']['output']>;
  total_hours?: Maybe<Scalars['Decimal']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by?: Maybe<Scalars['Int']['output']>;
  /** User who last updated the incidence (federated). */
  updated_by_user?: Maybe<CentralizedUserNode>;
  with_pay?: Maybe<Scalars['Boolean']['output']>;
};

export type PayrollIncidenceHistoryInput = {
  /** Id of the incidence whose action history is requested. */
  incidence_id: Scalars['UUID']['input'];
};

export type PayrollIncidenceHistoryItem = {
  __typename?: 'PayrollIncidenceHistoryItem';
  action: Scalars['String']['output'];
  changes?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['UUID']['output'];
  performed_at: Scalars['DateTime']['output'];
  performed_by: Scalars['Int']['output'];
  /** User who performed the action (federated). */
  performed_by_user: CentralizedUserNode;
};

export type PayrollIncidenceHistoryResponse = {
  __typename?: 'PayrollIncidenceHistoryResponse';
  graphql_operation_id: Scalars['ID']['output'];
  items: Array<PayrollIncidenceHistoryItem>;
};

export type PayrollIncidenceListItem = {
  __typename?: 'PayrollIncidenceListItem';
  amount?: Maybe<Scalars['Decimal']['output']>;
  /** Collaborator (federated centralized user). */
  centralized_user: CentralizedUserNode;
  centralized_user_id: Scalars['Int']['output'];
  concept?: Maybe<Scalars['String']['output']>;
  consumed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_by: Scalars['Int']['output'];
  /** User who created the incidence (federated). */
  created_by_user: CentralizedUserNode;
  days?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['Date']['output']>;
  /** The credit's MONTHLY charge, in the unit its `discount_type` dictates — read it together with that field, never alone. It is money only for `FIXED`; for `PERCENTAGE` it is a percentage of the employee's SBC and for `FACTOR` a VSM multiplier, and neither resolves to an amount until the run knows the employee's SBC or the year's UMI. **It is not what will be withheld this period**: the run derives that from the days actually paid. Like `government_credit_number`, it is not stored on the incidence — `amount` is always null on a recurring credit row, which is why the incidence list used to show 0.00 for every live credit. */
  government_credit_discount_amount?: Maybe<Scalars['Decimal']['output']>;
  /** `FIXED`, `PERCENTAGE` or `FACTOR` — the unit of `government_credit_discount_amount`. */
  government_credit_discount_type?: Maybe<Scalars['String']['output']>;
  /** The government credit (FONACOT/INFONAVIT) this incidence hangs from, when it has one. Non-null only for `origin = RECURRING`. */
  government_credit_id?: Maybe<Scalars['UUID']['output']>;
  /** Credit number of `government_credit_id`, resolved for the page in a single statement. It is NOT stored on the incidence: the recurring incidence keeps only the relation, so this is the only way to label the row without a query per row. */
  government_credit_number?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  incidence_type: Scalars['String']['output'];
  /** Whether a payroll run has already used this incidence to calculate. Consumed incidences can no longer be edited or deleted. */
  is_consumed: Scalars['Boolean']['output'];
  legal_name?: Maybe<Scalars['String']['output']>;
  origin: Scalars['String']['output'];
  percentage?: Maybe<Scalars['Decimal']['output']>;
  start_date: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  total_hours?: Maybe<Scalars['Decimal']['output']>;
};

/** Status of the payroll run that governs the incidence's period. Nine members mirror PayrollRunStatus so the value can be compared against what get_payroll_run publishes; two more are answers that are not run statuses. Grouping expected by consumers: OPEN = SIN_CORRIDA, PENDIENTE, PRE_NOMINA, CANCELADO; IN PROGRESS = EN_CALCULO, CALCULADO; CLOSED = DISPERSADO, CERRADO, TIMBRADO, PAGADO. INDETERMINADO belongs to no group and must NOT be treated as open: it means the period could not be resolved, not that it is editable. When several alive runs cover the period — normal since PAYR-558, one per legal entity — the MOST RESTRICTIVE state is reported, so CLOSED always wins over OPEN. PAYR-598 added PRE_NOMINA and DISPERSADO. DISPERSADO is grouped with CLOSED even though the run is not finished: the bank file was produced and the money left, so editing the incidence behind an already-paid amount is exactly what this field exists to prevent. PRE_NOMINA is grouped with OPEN: a pre-payroll is a preview that consumes no incidences. CANCELADO is published but currently unreachable, because list_alive_covering excludes cancelled runs; such a period reports SIN_CORRIDA. TIMBRADO and PAGADO are also unreachable today: nothing writes them. */
export enum PayrollIncidencePeriodRunStatus {
  Calculado = 'CALCULADO',
  Cancelado = 'CANCELADO',
  Cerrado = 'CERRADO',
  Dispersado = 'DISPERSADO',
  EnCalculo = 'EN_CALCULO',
  Indeterminado = 'INDETERMINADO',
  Pagado = 'PAGADO',
  Pendiente = 'PENDIENTE',
  PreNomina = 'PRE_NOMINA',
  SinCorrida = 'SIN_CORRIDA',
  Timbrado = 'TIMBRADO'
}

export type PayrollIncidenceSummaryInput = {
  /** Organization that owns the incidences (scope/isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional filter by one or more collaborators, with the same meaning as in list_incidences: omit for no filter, an empty list aggregates nothing. Send the **same** value both here and in list_incidences — otherwise the cards count incidences the table below does not show. */
  centralized_user_id?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Optional filter by one or more payroll types (OR), mirroring list_incidences. It exists for the same reason as the field above: **every filter the list accepts, the summary has to accept too**, or the cards aggregate a wider set than the table shows and the two numbers on the same screen disagree. */
  payroll_type_id?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Period (corrida) to aggregate, translated to its date window. Either this or the pair start_date_from/start_date_to is required. */
  periodicity_period_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Start of the date window to aggregate, inclusive. Must be sent together with start_date_to. */
  start_date_from?: InputMaybe<Scalars['Date']['input']>;
  /** End of the date window to aggregate, inclusive. Must be sent together with start_date_from and cannot be before it. */
  start_date_to?: InputMaybe<Scalars['Date']['input']>;
};

/** Per-state ISN rate input for creating or updating an ISN rate record. state_name is derived automatically from state_code. */
export type PayrollIsnRateStateInput = {
  /** Display order (1-based, ascending). Must be a positive integer. */
  display_order: Scalars['Int']['input'];
  /** Optional free text for state-specific rules documentation (max 200 characters). Informational only in v1. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** ISN rate as a percentage (%). Must be >= 0 and <= 10. Up to 2 decimal places. */
  rate: Scalars['Decimal']['input'];
  /** State code. One of the 32 Mexican state codes: AGS, BC, BCS, CAM, CHIS, CHIH, CDMX, COAH, COL, DGO, GTO, GRO, HGO, JAL, MEX, MICH, MOR, NAY, NL, OAX, PUE, QRO, QROO, SLP, SIN, SON, TAB, TAMPS, TLAX, VER, YUC, ZAC. */
  state_code: Scalars['String']['input'];
};

/** Single bracket (renglon) of an ISR table. */
export type PayrollIsrBracketInput = {
  /** Fixed fee (cuota fija) for the bracket. Must be >= 0. */
  fixed_fee: Scalars['Decimal']['input'];
  /** Lower limit of the bracket (limite inferior). Must be >= 0. */
  lower_limit: Scalars['Decimal']['input'];
  /** Percentage over the excess of the lower limit (% sobre excedente del limite inferior). Must be between 0 and 100. */
  percentage_over_lower_limit: Scalars['Decimal']['input'];
  /** Upper limit of the bracket (limite superior). Null marks the open-ended last bracket. */
  upper_limit?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Period type of a published ISR tariff. The authority publishes one tariff per payment periodicity with its own cent-rounded amounts; a biweekly tariff is not the monthly one prorated. */
export enum PayrollIsrPeriodTypeEnum {
  Biweekly = 'BIWEEKLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  TenDay = 'TEN_DAY',
  Weekly = 'WEEKLY'
}

/** Lee las variables ya persistidas de una version de corrida. Los tres ids de alcance son filtros opcionales: omitir uno significa **no filtrar por el**, nunca 'filtrar por null'. Es lo que permite leer la memoria de calculo de una corrida calculada sin filtros, que antes volvia como pagina vacia y exitosa. */
export type PayrollListCalculatedVariablesInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtra a un solo empleado (id entero). Omitir = todos. */
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  /** Filtra por registro patronal. Omitir = no filtrar por el. Una corrida calculada sin ese filtro tiene la columna en null, y omitirlo aca es la unica forma de leerla. */
  employer_registration_id?: InputMaybe<Scalars['ID']['input']>;
  /** Filtra por razon social (legal entity). Omitir = no filtrar por ella (no significa 'las filas sin razon social'). */
  legal_entity_id?: InputMaybe<Scalars['ID']['input']>;
  /** Pagination. */
  pagination?: InputMaybe<PayrollCalculatedVariablePagination>;
  /** Filtra por clase de impacto. Omitir = todas. */
  payroll_impact?: InputMaybe<PayrollVariableImpactEnum>;
  /** Version de la corrida sobre la que se calcula. Determina el tipo de nomina y el periodo, asi que no se mandan aparte. Es el unico id obligatorio: siempre acota la consulta. */
  payroll_run_version_id: Scalars['ID']['input'];
  /** Filtra por centro de trabajo. Omitir = no filtrar por el. Una corrida calculada sin ese filtro tiene la columna en null, y omitirlo aca es la unica forma de leerla. */
  work_location_id?: InputMaybe<Scalars['ID']['input']>;
};

/** List payload para calculated_variables. */
export type PayrollListCalculatedVariablesPayload = {
  __typename?: 'PayrollListCalculatedVariablesPayload';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<CalculatedVariableSchema>;
  total: Scalars['Int']['output'];
};

export type PayrollListCalculatedVariablesResult = InternalErrorResponse | PayrollListCalculatedVariablesPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/** Lista el paquete de conceptos de un tipo de nomina. */
export type PayrollListConceptAssignmentsInput = {
  /** Organizacion duena del tipo de nomina. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Solo las asignaciones vigentes. */
  only_active?: Scalars['Boolean']['input'];
  /** Tipo de nomina a consultar. */
  payroll_type_id: Scalars['ID']['input'];
};

/** Input to list all employment subsidy table records for an organization (history). */
export type PayrollListEmploymentSubsidyTablesInput = {
  /** Centralized organization ID of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
};

export type PayrollListEmploymentSubsidyTablesResult = EmploymentSubsidyTableListResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input to list all annual IMSS rate records, ordered by fiscal_year DESC. */
export type PayrollListImssRatesInput = {
  /** Optional branch code filter. If provided, each result's branches list is trimmed to only this branch. */
  branch_code?: InputMaybe<BranchCodeEnum>;
};

export type PayrollListImssRatesResult = ImssRateListResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type PayrollListIncidencesInput = {
  /** Organization that owns the incidences (scope/isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional filter by one or more collaborators (OR within the field). Omit it for no filter; an **empty list returns no rows** and is not the same as omitting it — it is the answer of a filter whose scope contains nobody. */
  centralized_user_id?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Optional filter by one or more types (OR). Values: ABSENTEEISM, DISABILITY, OVERTIME, SAVINGS, INFONAVIT, FONACOT, PENSION, RECURRING, OTHER. Omitted or empty = no filter. */
  incidence_type?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional filter by one or more origins/mediums (OR). Currently only MANUAL. Omitted or empty = no filter. */
  origin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Page number (1-based). Defaults to 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Items per page. Defaults to 20. */
  page_size?: InputMaybe<Scalars['Int']['input']>;
  /** Optional filter by one or more payroll types (OR). Incidences without a payroll type are excluded when this filter is applied. Omitted or empty = no filter. */
  payroll_type_id?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Period (corrida) to query. The backend translates it to the period's date window and matches incidences by their start date — incidences no longer store a period. Either this or the pair start_date_from/start_date_to is required; if both are sent, the explicit range wins. */
  periodicity_period_id?: InputMaybe<Scalars['UUID']['input']>;
  /** Start of the date window to query, inclusive, matched against the incidence start date. Must be sent together with start_date_to. */
  start_date_from?: InputMaybe<Scalars['Date']['input']>;
  /** End of the date window to query, inclusive. Must be sent together with start_date_from and cannot be before it. */
  start_date_to?: InputMaybe<Scalars['Date']['input']>;
  /** Optional filter by one or more statuses (OR): PENDING, APPROVED, REJECTED. Omitted or empty = no filter. */
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input to list all INFONAVIT discount factor records for an organization. */
export type PayrollListInfonavitDiscountFactorsInput = {
  /** Centralized organization ID of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
};

export type PayrollListInfonavitDiscountFactorsResult = InfonavitDiscountFactorListResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input to list ISN state rates with optional filters and pagination. */
export type PayrollListIsnRateStatesInput = {
  /** Filter by fiscal year (4 digits). */
  fiscal_year?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of records to return. Defaults to 50. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of records to skip. Defaults to 0. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Exact match filter by state code (e.g. CDMX, NL). */
  state_code?: InputMaybe<Scalars['String']['input']>;
  /** Partial match filter by state name (case-insensitive). */
  state_name?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollListIsnRateStatesResult = InternalErrorResponse | IsnRateStateListResponse | UserPermissionErrorResponse;

/** Input to list all annual ISN rate records, ordered by fiscal_year DESC. */
export type PayrollListIsnRatesInput = {
  /** Optional state code filter. If provided, each result's states list is trimmed to only this state. */
  state_code?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollListIsnRatesResult = InternalErrorResponse | IsnRateListResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input to list all ISR table records for an organization (history). */
export type PayrollListIsrTablesInput = {
  /** Centralized organization ID of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
};

export type PayrollListIsrTablesResult = InternalErrorResponse | IsrTableListResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** List payroll concepts for the organization. */
export type PayrollListPayrollConceptsInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Optional filters. */
  filter?: InputMaybe<PayrollConceptFilter>;
  /** Pagination. */
  pagination?: InputMaybe<PayrollConceptPagination>;
  /** Case-insensitive search on `name` and `code`. */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** List payload for list_payroll_concepts. */
export type PayrollListPayrollConceptsPayload = {
  __typename?: 'PayrollListPayrollConceptsPayload';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<PayrollConceptSchema>;
  total: Scalars['Int']['output'];
};

export type PayrollListPayrollConceptsResult = InternalErrorResponse | PayrollListPayrollConceptsPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/**
 * Lee las boletas de una version de corrida: cabecera comun, percepciones y deducciones por empleado en el orden del plan de calculo, y los tres totales guardados.
 *
 * La entrada es **la version**, no la corrida: una corrida tiene N versiones y una boleta pertenece a una sola. El id de la version vigente lo devuelve `get_payroll_run` en su historial (`is_current`).
 */
export type PayrollListPayrollReceiptsInput = {
  /** Centralized organization id of the caller. El scope se aplica atravesando la corrida: `payroll_run_version` no tiene columna de organizacion propia. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtra a un solo empleado (id entero). Omitir = toda la version, paginada. Es tambien la salida de emergencia cuando un descuadre de totales tumba la pagina completa: el error nombra al empleado y este filtro acota la lectura a el. */
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  /** Pagination. */
  pagination?: InputMaybe<PayrollReceiptPagination>;
  /** Version de la corrida cuyas boletas se leen. Es el **unico** punto de entrada: no se acepta un id de corrida ni una version opcional. */
  payroll_run_version_id: Scalars['ID']['input'];
};

/**
 * List payload de payroll_receipts. `total` es el tamano de la **union** de empleados calculados y salteados, no el de `results` ni el de las lineas: derivarlo de las lineas reportaria 120 para una corrida de 127 donde 7 se saltearon.
 *
 * Una version sin lineas y sin saltos devuelve `results: []`, `total: 0` y la cabecera **resuelta**. No es un error: una version recien abierta legitimamente no tiene ninguna de las dos cosas.
 */
export type PayrollListPayrollReceiptsPayload = {
  __typename?: 'PayrollListPayrollReceiptsPayload';
  graphql_operation_id: Scalars['ID']['output'];
  header: PayrollReceiptHeaderSchema;
  results: Array<PayrollReceiptSchema>;
  total: Scalars['Int']['output'];
};

export type PayrollListPayrollReceiptsResult = InternalErrorResponse | PayrollListPayrollReceiptsPayload | PayrollReceiptTotalsMismatchResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Lee los importes de una version **agregados por concepto**, para las tarjetas de resultado del paso 2 del wizard (ISR retenido, cuotas IMSS). No se pagina y no se filtra por empleado a proposito: la cantidad de filas es la cantidad de conceptos —decenas—, no la de empleados, asi que acotarla reintroduciria el truncado que esta operacion existe para eliminar. El comparativo contra el periodo anterior viene en la misma llamada. */
export type PayrollListPayrollRunConceptTotalsInput = {
  /** Centralized organization id of the caller. El scope se aplica atravesando la corrida: `payroll_run_version` no tiene columna de organizacion propia. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Version de la corrida cuyos importes se agregan. */
  payroll_run_version_id: Scalars['ID']['input'];
};

/** List payload de `payroll_run_concept_totals`. Una version sin lineas devuelve `results: []`, `total: 0` y `previous_period: null`, no un error — y **ningun escalar de dinero** que pueda ser cero: los importes de esa version no son cero, simplemente no existen. */
export type PayrollListPayrollRunConceptTotalsPayload = {
  __typename?: 'PayrollListPayrollRunConceptTotalsPayload';
  graphql_operation_id: Scalars['ID']['output'];
  /** El periodo contra el que se comparo, o `null` si no hay comparativo. Nunca un cero. */
  previous_period?: Maybe<PayrollRunConceptTotalsPreviousPeriodSchema>;
  /** Un elemento por concepto de la version pedida, ordenado por `concept_code`. Un concepto que existia en el periodo anterior y no en este no aparece: la lista son los conceptos de esta version. */
  results: Array<PayrollRunConceptTotalSchema>;
  /** Cantidad de conceptos devueltos. Es un **conteo de filas**, no un importe, asi que `0` es una respuesta legitima. */
  total: Scalars['Int']['output'];
};

export type PayrollListPayrollRunConceptTotalsResult = InternalErrorResponse | PayrollListPayrollRunConceptTotalsPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/** Lee las lineas del recibo ya persistidas para una version de corrida. Alimenta el recibo y el drawer de detalle. */
export type PayrollListPayrollRunLinesInput = {
  /** Centralized organization id of the caller. El scope se aplica atravesando la corrida: `payroll_run_version` no tiene columna de organizacion propia. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtra a un solo empleado (id entero). Omitir = todos. */
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  /** Pagination. */
  pagination?: InputMaybe<PayrollRunLinePagination>;
  /** Version de la corrida cuyas lineas se leen. */
  payroll_run_version_id: Scalars['ID']['input'];
};

/** List payload para payroll_run_lines. Una version sin lineas devuelve `results: []` y `total: 0`, no un error. */
export type PayrollListPayrollRunLinesPayload = {
  __typename?: 'PayrollListPayrollRunLinesPayload';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<PayrollRunLineSchema>;
  total: Scalars['Int']['output'];
};

export type PayrollListPayrollRunLinesResult = InternalErrorResponse | PayrollListPayrollRunLinesPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/**
 * Lista las corridas de la organizacion para el dashboard, una fila por corrida, con el total del universo completo del tab.
 *
 * Los cinco filtros de alcance son **opcionales de verdad**: omitirlos no acota. En particular, omitir `legal_entity_id` devuelve todas las razones sociales **incluidas las corridas cuyo `legal_entity_id` es `null`**, que durante la transicion de PAYR-558 son las que crea el front desplegado.
 *
 * `cfdi_classification` alimenta las pestanas Ordinarias / Extraordinarias. Es el unico filtro que **no** afecta a `ordinaria_count` / `extraordinaria_count` del payload: los dos contadores describen el universo de cada clasificacion bajo los demas filtros, para que elegir una pestana no ponga la otra en `0`.
 *
 * Un id de otra organizacion en cualquiera de los filtros devuelve `results: []` y `total: 0`, **no** un error: una pagina vacia no permite distinguir un id real de uno fabricado. El unico caso de permisos es que `centralized_organization_id` no coincida con la sesion.
 */
export type PayrollListPayrollRunsInput = {
  /** Centralized organization id of the caller. Va siempre en el `WHERE`: una corrida de otra organizacion no vuelve nunca. */
  centralized_organization_id: Scalars['ID']['input'];
  /**
   * Acota a la clasificacion CFDI del tipo de nomina de la corrida: es el filtro de las pestanas Ordinarias / Extraordinarias. Omitir = **las dos**.
   *
   * `ORDINARIA` no es un tipo de nomina sino la **clasificacion** de uno, y varios tipos de una organizacion pueden ser ordinarios; por eso `payroll_type_id`, que es singular, no puede expresar 'todas las ordinarias'.
   *
   * `total` **si** sigue a este filtro; `ordinaria_count` y `extraordinaria_count` **no**. Mandando ademas `payroll_type_id`, uno de los dos contadores queda siempre en `0`, porque un tipo de nomina tiene una sola clasificacion.
   *
   * ⚠️ `EXTRAORDINARIA` devuelve hoy una pagina vacia, y no por un defecto de esta consulta: ningun cliente puede crear todavia una corrida extraordinaria (PAYR-644, hallazgo H2 de PAYR-627 — el dialogo de creacion resuelve el tipo entre los candidatos ordinarios). Es la misma clase de aviso que ya lleva el tab `COMPLETED`.
   */
  cfdi_classification?: InputMaybe<PayrollCfdiClassification>;
  /** Acota a una razon social. Omitir = **todas**, incluidas las corridas sin razon social. Ojo: no es la semantica de `find_alive`/`calculate`, donde la ausencia de razon social identifica a la corrida que no tiene ninguna. */
  legal_entity_id?: InputMaybe<Scalars['ID']['input']>;
  /** Pagination. Omitir = 20 primeras. */
  pagination?: InputMaybe<PayrollRunPagination>;
  /** Acota a un tipo de nomina. Omitir = todos. */
  payroll_type_id?: InputMaybe<Scalars['ID']['input']>;
  /** Acota a todos los periodos de una periodicidad. Redundante cuando viene `periodicity_period_id`; los dos pueden mandarse y se aplican con AND. */
  periodicity_id?: InputMaybe<Scalars['ID']['input']>;
  /** Acota a un periodo del calendario. Omitir = todos. */
  periodicity_period_id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Acota a un conjunto de estados, **intersectado** con el universo del tab. Omitir o `null` = sin filtro.
   *
   * Una lista vacia (`[]`) es un **no-op**, no una pagina vacia: es lo que manda un multiselect sin seleccion, y leerlo como 'ninguno' vaciaria el dashboard sin explicacion.
   *
   * Una interseccion vacia —`tab: PENDING` con `status: [TIMBRADO]`— devuelve `results: []` y `total: 0`, **no** un error. Misma filosofia que un id de otra organizacion en cualquiera de los otros filtros.
   *
   * A diferencia de `cfdi_classification`, este filtro **si** alcanza a `total`, `ordinaria_count` y `extraordinaria_count`.
   *
   * ⚠️ Filtrar por `TIMBRADO` o `PAGADO` devuelve lista vacia hoy: ninguna operacion escribe esos estados. Ver `PayrollRunStatus`.
   */
  status?: InputMaybe<Array<PayrollRunStatus>>;
  /** `PENDING` o `COMPLETED`. Ver `PayrollRunTab` — desde PAYR-598 `CERRADO` cae en `COMPLETED` (antes en `PENDING`) y `COMPLETED` ya no viene vacio: contiene tambien `DISPERSADO`. */
  tab: PayrollRunTab;
};

/**
 * List payload de `list_payroll_runs`. `total` es el universo completo del tab y **no** el largo de la pagina. Un filtro que no matchea nada —incluido un id de otra organizacion— devuelve `results: []` y `total: 0`, no un error.
 *
 * `total = ordinaria_count + extraordinaria_count` cuando **no** se manda `cfdi_classification`. Con el filtro puesto, `total` es el de la clasificacion pedida y los contadores siguen siendo los dos universos. La unica excepcion al invariante es un tipo de nomina cuya clasificacion este fuera de `{ORDINARIA, EXTRAORDINARIA}`: su corrida cuenta en `total` —esta en la pagina— y en ningun contador.
 *
 * ⚠️ Una pagina puede mostrar `status: CALCULADO` junto a `employees_count: 0` para un calculo que esta terminando ahora mismo: las filas y sus agregados salen de sentencias distintas. Aceptable para un dashboard.
 */
export type PayrollListPayrollRunsPayload = {
  __typename?: 'PayrollListPayrollRunsPayload';
  /**
   * Corridas de clasificacion `EXTRAORDINARIA` en el mismo universo que `ordinaria_count`, con las mismas reglas: ignora `cfdi_classification` y la paginacion, respeta todos los demas filtros.
   *
   * ⚠️ Hoy vale `0` en cualquier organizacion, y no por un defecto de esta consulta: ningun cliente puede crear todavia una corrida extraordinaria (PAYR-644, hallazgo H2 de PAYR-627).
   */
  extraordinaria_count: Scalars['Int']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  /**
   * Corridas de clasificacion `ORDINARIA` en el universo que dejan los demas filtros. Es el numero de la pestana Ordinarias.
   *
   * **Ignora `cfdi_classification` y la paginacion**, y nada mas: razon social, periodicidad, periodo, `tab` y `payroll_type_id` si lo acotan. Por eso pedir `EXTRAORDINARIA` puede devolver `results: []` con este contador en 12 — es exactamente para lo que existe.
   *
   * Un `0` aca es un cero verificado y no un dato ausente; con `payroll_type_id` mandado, uno de los dos contadores es siempre `0` porque un tipo de nomina tiene una sola clasificacion.
   */
  ordinaria_count: Scalars['Int']['output'];
  results: Array<PayrollRunListItemSchema>;
  total: Scalars['Int']['output'];
};

export type PayrollListPayrollRunsResult = InternalErrorResponse | PayrollListPayrollRunsPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/** Vista cruzada: que tipos de nomina consumen un concepto. Es lo que deja ver el impacto de tocar un concepto antes de tocarlo. */
export type PayrollListPayrollTypesForConceptInput = {
  /** Organizacion duena del concepto. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Concepto a consultar. */
  payroll_concept_id: Scalars['ID']['input'];
};

/** List payroll types for an organization. */
export type PayrollListPayrollTypesInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Optional filters. */
  filter?: InputMaybe<PayrollPayrollTypeFilter>;
  /** Pagination. */
  pagination?: InputMaybe<PayrollPaginationInput>;
  /** Case-insensitive search on name/description. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Sort clauses (first entry is applied). */
  sort?: InputMaybe<Array<PayrollPayrollTypeSortInput>>;
};

/** List payload for payroll types. */
export type PayrollListPayrollTypesPayload = {
  __typename?: 'PayrollListPayrollTypesPayload';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<PayrollTypeSchema>;
  total: Scalars['Int']['output'];
};

export type PayrollListPayrollTypesResult = InternalErrorResponse | PayrollListPayrollTypesPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/** List periodicities for an organization. */
export type PayrollListPeriodicitiesInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Optional filters. */
  filter?: InputMaybe<PayrollPeriodicityFilter>;
  /** Pagination. */
  pagination?: InputMaybe<PayrollPeriodicityPagination>;
  /** Case-insensitive search on name/description. */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** List payload. */
export type PayrollListPeriodicitiesPayload = {
  __typename?: 'PayrollListPeriodicitiesPayload';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<PayrollPeriodicitySchema>;
  total: Scalars['Int']['output'];
};

export type PayrollListPeriodicitiesResult = InternalErrorResponse | PayrollListPeriodicitiesPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/** Filter for list_periodicity_payroll_types. */
export type PayrollListPeriodicityPayrollTypesFilter = {
  /** Filter by active flag of the associated payroll types. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

/** List the payroll types associated to a periodicity (hydrated). */
export type PayrollListPeriodicityPayrollTypesInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Optional filters. */
  filter?: InputMaybe<PayrollListPeriodicityPayrollTypesFilter>;
  /** Pagination. */
  pagination?: InputMaybe<PayrollPeriodicityPayrollTypesPagination>;
  /** Id of the periodicity whose associations are listed. */
  periodicity_id: Scalars['ID']['input'];
};

/** Payload for list_periodicity_payroll_types. */
export type PayrollListPeriodicityPayrollTypesPayload = {
  __typename?: 'PayrollListPeriodicityPayrollTypesPayload';
  graphql_operation_id: Scalars['ID']['output'];
  payroll_types: Array<PayrollTypeSchema>;
  periodicity_id: Scalars['ID']['output'];
  total: Scalars['Int']['output'];
};

export type PayrollListPeriodicityPayrollTypesResult = InternalErrorResponse | PayrollListPeriodicityPayrollTypesPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/** Calendario paginado de una periodicidad para un ejercicio fiscal. Alternativa acotada a `get_periodicity`, que devuelve el ejercicio completo sin tope (con periodicidad diaria son ~365 periodos). */
export type PayrollListPeriodicityPeriodsInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Filtros opcionales. */
  filter?: InputMaybe<PayrollPeriodicityPeriodFilter>;
  /** Ejercicio fiscal del calendario. */
  fiscal_year: Scalars['Int']['input'];
  /** Pagination. */
  pagination?: InputMaybe<PayrollPeriodicityPeriodPagination>;
  /** Id de la periodicidad cuyo calendario se lista. */
  periodicity_id: Scalars['ID']['input'];
};

/** Payload paginado de list_periodicity_periods. */
export type PayrollListPeriodicityPeriodsPayload = {
  __typename?: 'PayrollListPeriodicityPeriodsPayload';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<PayrollPeriodicityPeriodSchema>;
  total: Scalars['Int']['output'];
};

export type PayrollListPeriodicityPeriodsResult = InternalErrorResponse | PayrollListPeriodicityPeriodsPayload | UserPermissionErrorResponse | ValidationErrorResponse;

export type PayrollMutation = {
  __typename?: 'PayrollMutation';
  /** Adds a legal representative to a legal entity (razón social). Input: legal_entity_id (required), centralized_organization_id (required), representative_name (required, max 150), representative_type (required, 'platform_user' or 'external'), faculties (required, list of faculty names), centralized_user_id (required if platform_user), tax_id (optional), civil_registry_id (optional), country_code (optional, for id validation rules). */
  add_legal_representative: CreateLegalRepresentativeResult;
  /** Calculated payroll variable mutations: trigger calculation and persist the per-employee run. */
  calculated_variables: CalculatedVariableMutation;
  /** Paquete de conceptos: que conceptos entran en cada tipo de nomina. Configuracion de implementacion (`PlatformAdmin`). */
  concept_assignments: ConceptAssignmentMutation;
  /** Creates a new employee contract with payroll config and IMSS alta movement. */
  create_contract: CreateContractResult;
  /** Creates a dispersion account scoped to a legal entity (razón social). Validates that the bank exists, the legal entity belongs to the caller's organization, and the 18-digit CLABE is unique among active accounts. Records a creation audit entry in the same transaction. */
  create_dispersion_account: CreateDispersionAccountResponse;
  /** Creates a new dependent for an employee. */
  create_employee_dependent: CreateEmployeeDependentResult;
  /** Creates a new EmployerRegistration (registro patronal) for an organization. Step 1 fields: registration_number (NRP, required, letter + digits, max 11), legal_entity_id (required — razón social), work_center_location_type (required — 'fiscal_address', 'branch_address', or 'custom_address'), imss_subdelegation (required), salary_zone (required). Step 2 fields: risk_class_id (required), risk_premium (required, > 0), risk_fraction (optional, >= 0 if provided), economic_activity_code (required), economic_activity_description (required), risk_data_expiration_date (optional), is_active (optional, default true). */
  create_employer_registration: CreateEmployerRegistrationResponse;
  /** Creates a new FederalEntity. Input: code (required) — unique code identifying the federal entity (e.g. state or province code); name (required) — human-readable name of the federal entity. */
  create_federal_entity: CreateFederalEntityResponse;
  /** Creates a new LegalEntity (razón social) with status 'active'. Validates uniqueness of internal_id, legal_name (case-insensitive) and tax_id. Supported country_code values: MX, CO, CL, PE, AR — any other value is rejected outright. Input: centralized_organization_id (required), internal_id (required), trade_name (optional), legal_name (required), tax_id (required), country_code (required), currency_code (required), address_1 (required), city (required), state (required), postal_code (required; per-country rule: MX 5 digits, CO 6 digits, CL 7 digits, PE 5 digits, AR a CPA like C1425DKE or 4 digits), tax_type and tax_regime_id (required when country_code is MX, rejected otherwise — they are SAT concepts and do not exist outside Mexico), country (optional), address_2 (optional), address_3 (optional), latitude (optional), longitude (optional), fiscal_address_override (optional, max 500). */
  create_legal_entity: CreateLegalEntityResponse;
  /** Creates a new RiskClass. Input: class_code (required) — unique code identifying the risk class; class_name (required) — human-readable name of the risk class. */
  create_risk_class: CreateRiskClassResponse;
  /** Creates a new TaxRegime. Input: tax_regime_code (required) — unique code identifying the tax regime; tax_regime_name (required) — human-readable name of the tax regime. */
  create_tax_regime: CreateTaxRegimeResponse;
  /** Soft-deletes a dispersion account (sets deleted_at, removes it from listings) scoped to a legal entity and records a delete audit entry. */
  delete_dispersion_account: DeleteDispersionAccountResponse;
  /** Logically deletes a dependent by setting is_active to false. */
  delete_employee_dependent: DeleteEmployeeDependentResult;
  /** Logically deletes an EmployerRegistration by setting is_active to false. Input: id (required) — the employer registration ID; centralized_organization_id (required) — the organization it belongs to. */
  delete_employer_registration: DeleteEmployerRegistrationResponse;
  /** Logically deletes a LegalEntity by setting its status to 'inactive'. Input: id (required) — the legal entity ID; centralized_organization_id (required) — the organization it belongs to. */
  delete_legal_entity: DeleteLegalEntityResponse;
  /** Employment subsidy table mutations: create, update, deactivate, activate, seed. All operations require crehana_internal_admin role. */
  employment_subsidy: EmploymentSubsidyTableMutation;
  /** IMSS movement mutations: generate, validate, update, delete. */
  imss_movement: ImssMovementMutation;
  /** IMSS cuotas obrero/patronal mutations: create, update, deactivate, seed. All operations require crehana_internal_admin role. */
  imss_rate: ImssRateMutation;
  /** Manual payroll incidence mutations: create and edit. */
  incidences: IncidenceMutation;
  /** INFONAVIT discount factor mutations: create, update, deactivate, seed. All operations require crehana_internal_admin role. */
  infonavit: InfonavitMutation;
  /** ISN (Impuesto Sobre Nomina) rate mutations: create, update, deactivate, seed. All operations require crehana_internal_admin role. */
  isn_rate: IsnRateMutation;
  /** ISR table mutations: create, update, deactivate, activate, seed. All operations require crehana_internal_admin role. */
  isr_table: IsrTableMutation;
  /** Parametros de calculo (UMA, SM, topes) mutations: seed 2026. */
  parameters: ParametersMutation;
  /** Catalogo de conceptos: carga por planilla, correccion y reglas de calculo (`PlatformAdmin`); activacion (`OrganizationAdmin`). */
  payroll_concepts: PayrollConceptMutation;
  /** Payroll run lifecycle: open, calculate (opens a version), close and cancel. */
  payroll_runs: PayrollRunMutation;
  /** Payroll type (tipo de nomina) mutations: CRUD + deactivate. */
  payroll_types: PayrollTypeMutation;
  /** Periodicity mutations: associate/disassociate payroll types and SICOSS sync ingest (stub). */
  periodicities: PeriodicityMutation;
  /** Reactivates a suspended contract. */
  reactivate_contract: ReactivateContractResult;
  /** Rehires an employee by creating a new contract based on a previous terminated/expired one. */
  rehire_employee: RehireEmployeeResult;
  /** Removes a legal representative from a legal entity. Input: id (required) — the representative ID; legal_entity_id (required) — the legal entity it belongs to. */
  remove_legal_representative: RemoveLegalRepresentativeResult;
  /** Renews a contract (active or expired) creating a new version with updated end_date. Append-only — marks the current contract as replaced. */
  renew_contract: RenewContractResult;
  /** Vuelve a registrar ante Terra IDSE el certificado que el registro patronal ya tiene guardado, sin volver a subir los archivos: se leen de donde estan custodiados. Sirve cuando el intento anterior fallo por una indisponibilidad del IMSS o porque el usuario de servicio todavia no estaba dado de alta. */
  retry_terra_idse_certificate_registration: RetryTerraIdseCertificateRegistrationResult;
  /** Vuelve a solicitar el alta del usuario de servicio de Terra IDSE de un registro patronal que quedo sin identificador. Reutiliza la contrasena ya guardada, asi que no hay que volver a capturarla. Si el registro patronal ya tiene identificador no se pide otro: el proveedor no permite borrar usuarios, asi que un alta de mas quedaria para siempre. La respuesta es el estado IDSE con el intento recien registrado; que la respuesta sea un exito significa que el intento quedo asentado, no que Terra lo haya aceptado. */
  retry_terra_idse_user_registration: RetryTerraIdseUserRegistrationResult;
  /** Run dispersion mutations: generate the bank file(s) of a calculated run for a chosen dispersing account, in that account's configured layout. */
  run_dispersion: PayrollRunDispersionMutation;
  /** Updates Step 1 (legal info) and Step 2 (position/structure) of the active contract. */
  save_contract_legal_info: SaveContractLegalInfoResult;
  /** Updates salary, position and banking info for the active contract. */
  save_contract_salary_info: SaveContractSalaryInfoResult;
  /** Saves (upsert) the dispersion-layout configuration for an active dispersion account. Validates the account exists, belongs to the caller's organization via its legal entity, and is active. Records an audit entry. One configuration per account (idempotent on re-save). */
  save_dispersion_layout_config: SaveDispersionLayoutConfigResponse;
  /** Saves IDSE credentials for an employer registration. Input: centralized_organization_id (required), employer_registration_id (required), idse_username (required), idse_password (required). Stores credentials securely in AWS Secrets Manager. */
  save_idse_credentials: SaveIdseCredentialsResult;
  /** Toggles the active/inactive status of a dispersion account and records the previous/new value in the audit log. The account stays listed. */
  set_dispersion_account_active: SetDispersionAccountActiveResponse;
  /** Social security info, government credits and pension order mutations. */
  social_security: SocialSecurityMutation;
  /** Suspends an active contract temporarily. */
  suspend_contract: SuspendContractResult;
  /** Terminates an active contract. Irreversible. */
  terminate_contract: TerminateContractResult;
  /** Creates a new contract version applying the provided changes. Append-only — never modifies the current active contract directly. Marks the previous contract as replaced and creates a new one with version+1. */
  update_contract: UpdateContractResult;
  /** Updates a dispersion account scoped to a legal entity. Re-checks CLABE uniqueness when it changes and records an update audit entry. */
  update_dispersion_account: UpdateDispersionAccountResponse;
  /** Updates an existing employee dependent. */
  update_employee_dependent: UpdateEmployeeDependentResult;
  /** Updates an existing EmployerRegistration scoped to an organization. Input: id (required), centralized_organization_id (required). All other fields are optional and only provided fields will be updated. */
  update_employer_registration: UpdateEmployerRegistrationResponse;
  /** Updates an existing FederalEntity by its ID. Input: id (required) — the primary key of the federal entity to update; code (optional) — new unique code for the federal entity; name (optional) — new name for the federal entity. */
  update_federal_entity: UpdateFederalEntityResponse;
  /** Updates an existing LegalEntity (razón social) scoped to an organization. Validates uniqueness of internal_id, legal_name (case-insensitive) and tax_id on change. Every domain invariant is re-checked against the resulting state, so an edit that leaves the entity invalid is rejected — including the per-country postal_code rule, which follows the RESULTING country_code when country and postal code change in the same call. Moving an entity out of Mexico clears tax_type and tax_regime_id automatically: they are SAT concepts, and the caller has no way to send an explicit null. */
  update_legal_entity: UpdateLegalEntityResponse;
  /** Updates the payroll profile of an employee scoped to a legal entity. All fields except legal_entity_id, centralized_organization_id and centralized_user_id are optional — only provided fields are updated. payroll_employee_info (NOM-035) is upserted: created on first update if it doesn't exist. */
  update_payroll_employee: UpdatePayrollEmployeeResult;
  /** Updates an existing RiskClass by its ID. Input: id (required) — the primary key of the risk class to update; class_code (optional) — new unique code for the risk class; class_name (optional) — new name for the risk class. */
  update_risk_class: UpdateRiskClassResponse;
  /** Updates an existing TaxRegime by its ID. Input: id (required) — the primary key of the tax regime to update; tax_regime_code (optional) — new unique code for the tax regime; tax_regime_name (optional) — new name for the tax regime. */
  update_tax_regime: UpdateTaxRegimeResponse;
  /** Uploads a CSD certificate (.cer + .key) for a legal entity. Input: centralized_organization_id (required), legal_entity_id (required), cer_file (required, base64), key_file (required, base64), password (required). Validates the certificate pair, extracts expiration date, and stores securely in S3/KMS. */
  upload_csd_certificate: UploadCsdCertificateResult;
  /** Uploads a client layout file (.txt/.csv/.xlsx, max 5 MB, base64) and stores it in S3 associated with the dispersion-layout configuration. Rejects oversized or wrong-extension files with a validation error. */
  upload_dispersion_layout_file: UploadDispersionLayoutFileResponse;
  /** Carga la e.firma de un registro patronal y la registra ante Terra IDSE. Recibe el `.cer` y el `.key` en base64 con la contrasena de la llave privada; **el PFX ya no se procesa**. Los archivos van a S3 y la contrasena al gestor de secretos: en la fila solo quedan sus referencias. Devuelve el estado IDSE con el resultado del intento de registro; que el proveedor lo rechace no impide que el certificado quede guardado. */
  upload_efirma: UploadEfirmaResult;
  /** Validates a CSD certificate pair (.cer + .key) without persisting. Input: centralized_organization_id (required), legal_entity_id (required), cer_file (required, base64), key_file (required, base64), password (required). Returns certificate metadata: validity, expiration, serial number. */
  validate_csd_certificate: ValidateCsdCertificateResult;
  /** Validates step 1 (identity and location) of employer registration without persisting. Returns is_valid=true or a validation error. */
  validate_employer_registration_identity: ValidateEmployerRegistrationIdentityResult;
  /** Validates step 3 (IDSE credentials) of employer registration without persisting. Currently a stub that always returns is_valid=true. */
  validate_employer_registration_idse: ValidateEmployerRegistrationIdseResult;
  /** Validates step 2 (work safety) of employer registration without persisting. Returns is_valid=true or a validation error. */
  validate_employer_registration_safety: ValidateEmployerRegistrationSafetyResult;
  /** Valida el par `.cer`/`.key` de la e.firma y las credenciales IDSE sin guardar nada. Comprueba que el `.key` abra con su contrasena, que corresponda al `.cer` y que el certificado no este vencido, y devuelve lo que se leyo de el: vigencia, dias restantes y numero de serie. **El PFX ya no se procesa.** */
  validate_idse_efirma: ValidateIdseEfirmaResult;
};


export type PayrollMutationAdd_Legal_RepresentativeArgs = {
  input: CreateLegalRepresentativeInput;
};


export type PayrollMutationCreate_ContractArgs = {
  input: CreateContractInput;
};


export type PayrollMutationCreate_Dispersion_AccountArgs = {
  input: CreateDispersionAccountInput;
};


export type PayrollMutationCreate_Employee_DependentArgs = {
  input: CreateEmployeeDependentInput;
};


export type PayrollMutationCreate_Employer_RegistrationArgs = {
  input: CreateEmployerRegistrationInput;
};


export type PayrollMutationCreate_Federal_EntityArgs = {
  input: CreateFederalEntityInput;
};


export type PayrollMutationCreate_Legal_EntityArgs = {
  input: CreateLegalEntityInput;
};


export type PayrollMutationCreate_Risk_ClassArgs = {
  input: CreateRiskClassInput;
};


export type PayrollMutationCreate_Tax_RegimeArgs = {
  input: CreateTaxRegimeInput;
};


export type PayrollMutationDelete_Dispersion_AccountArgs = {
  input: DeleteDispersionAccountInput;
};


export type PayrollMutationDelete_Employee_DependentArgs = {
  input: DeleteEmployeeDependentInput;
};


export type PayrollMutationDelete_Employer_RegistrationArgs = {
  input: DeleteEmployerRegistrationInput;
};


export type PayrollMutationDelete_Legal_EntityArgs = {
  input: DeleteLegalEntityInput;
};


export type PayrollMutationReactivate_ContractArgs = {
  input: ReactivateContractInput;
};


export type PayrollMutationRehire_EmployeeArgs = {
  input: RehireEmployeeInput;
};


export type PayrollMutationRemove_Legal_RepresentativeArgs = {
  input: RemoveLegalRepresentativeInput;
};


export type PayrollMutationRenew_ContractArgs = {
  input: RenewContractInput;
};


export type PayrollMutationRetry_Terra_Idse_Certificate_RegistrationArgs = {
  input: RetryTerraIdseCertificateRegistrationInput;
};


export type PayrollMutationRetry_Terra_Idse_User_RegistrationArgs = {
  input: RetryTerraIdseUserRegistrationInput;
};


export type PayrollMutationSave_Contract_Legal_InfoArgs = {
  input: SaveContractLegalInfoInput;
};


export type PayrollMutationSave_Contract_Salary_InfoArgs = {
  input: SaveContractSalaryInfoInput;
};


export type PayrollMutationSave_Dispersion_Layout_ConfigArgs = {
  input: SaveDispersionLayoutConfigInput;
};


export type PayrollMutationSave_Idse_CredentialsArgs = {
  input: SaveIdseCredentialsInput;
};


export type PayrollMutationSet_Dispersion_Account_ActiveArgs = {
  input: SetDispersionAccountActiveInput;
};


export type PayrollMutationSuspend_ContractArgs = {
  input: SuspendContractInput;
};


export type PayrollMutationTerminate_ContractArgs = {
  input: TerminateContractInput;
};


export type PayrollMutationUpdate_ContractArgs = {
  input: UpdateContractInput;
};


export type PayrollMutationUpdate_Dispersion_AccountArgs = {
  input: UpdateDispersionAccountInput;
};


export type PayrollMutationUpdate_Employee_DependentArgs = {
  input: UpdateEmployeeDependentInput;
};


export type PayrollMutationUpdate_Employer_RegistrationArgs = {
  input: UpdateEmployerRegistrationInput;
};


export type PayrollMutationUpdate_Federal_EntityArgs = {
  input: UpdateFederalEntityInput;
};


export type PayrollMutationUpdate_Legal_EntityArgs = {
  input: UpdateLegalEntityInput;
};


export type PayrollMutationUpdate_Payroll_EmployeeArgs = {
  input: UpdatePayrollEmployeeInput;
};


export type PayrollMutationUpdate_Risk_ClassArgs = {
  input: UpdateRiskClassInput;
};


export type PayrollMutationUpdate_Tax_RegimeArgs = {
  input: UpdateTaxRegimeInput;
};


export type PayrollMutationUpload_Csd_CertificateArgs = {
  input: UploadCsdCertificateInput;
};


export type PayrollMutationUpload_Dispersion_Layout_FileArgs = {
  input: UploadDispersionLayoutFileInput;
};


export type PayrollMutationUpload_EfirmaArgs = {
  input: UploadEfirmaInput;
};


export type PayrollMutationValidate_Csd_CertificateArgs = {
  input: ValidateCsdCertificateInput;
};


export type PayrollMutationValidate_Employer_Registration_IdentityArgs = {
  input: ValidateEmployerRegistrationIdentityInput;
};


export type PayrollMutationValidate_Employer_Registration_IdseArgs = {
  input: ValidateEmployerRegistrationIdseInput;
};


export type PayrollMutationValidate_Employer_Registration_SafetyArgs = {
  input: ValidateEmployerRegistrationSafetyInput;
};


export type PayrollMutationValidate_Idse_EfirmaArgs = {
  input: ValidateIdseEfirmaInput;
};

/** Offset/limit pagination. */
export type PayrollPaginationInput = {
  /** Max number of items to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of items to skip. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Not-found wrapper for parameter lookups. */
export type PayrollParametersNotFoundResponse = {
  __typename?: 'PayrollParametersNotFoundResponse';
  graphql_operation_id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

/** Single-entity wrapper. */
export type PayrollParametersResponse = {
  __typename?: 'PayrollParametersResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: PayrollParametersSchema;
};

/** Payroll parameter set (UMA, SM, caps) for a fiscal year. */
export type PayrollParametersSchema = {
  __typename?: 'PayrollParametersSchema';
  centralized_organization_id: Scalars['ID']['output'];
  confirmed_at?: Maybe<Scalars['DateTime']['output']>;
  confirmed_by_user_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  fiscal_year: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  infonavit_cap: Scalars['Decimal']['output'];
  integration_factor_min: Scalars['Decimal']['output'];
  is_active: Scalars['Boolean']['output'];
  legal_entity_id: Scalars['ID']['output'];
  min_wage_general: Scalars['Decimal']['output'];
  min_wage_zlfn: Scalars['Decimal']['output'];
  sbc_cap: Scalars['Decimal']['output'];
  source_reference: Scalars['String']['output'];
  uma_annual: Scalars['Decimal']['output'];
  uma_daily: Scalars['Decimal']['output'];
  uma_monthly: Scalars['Decimal']['output'];
  updated_at: Scalars['DateTime']['output'];
  valid_from: Scalars['Date']['output'];
};

/** Filter options for listing payroll types. */
export type PayrollPayrollTypeFilter = {
  /** Filter by active flag. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by CFDI classification. */
  cfdi_classification?: InputMaybe<PayrollCfdiClassification>;
  /** Filter by base/seed flag. */
  is_base?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by periodicity code. */
  periodicity_code?: InputMaybe<PayrollPeriodicityCode>;
};

/** Sort field for payroll type listing. */
export enum PayrollPayrollTypeSortField {
  CreatedAt = 'CREATED_AT',
  LastRunAt = 'LAST_RUN_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

/** Sort clause for listing payroll types. */
export type PayrollPayrollTypeSortInput = {
  /** Sort direction. */
  direction?: PayrollSortDirection;
  /** Field to sort by. */
  field: PayrollPayrollTypeSortField;
};

/** Period status (8 values). */
export enum PayrollPeriodStatus {
  Activo = 'ACTIVO',
  Calculado = 'CALCULADO',
  Cancelado = 'CANCELADO',
  Cerrado = 'CERRADO',
  EnCalculo = 'EN_CALCULO',
  Pagado = 'PAGADO',
  Pendiente = 'PENDIENTE',
  Timbrado = 'TIMBRADO'
}

/** Single-entity wrapper para get_payroll_period_summary. */
export type PayrollPeriodSummaryResponse = {
  __typename?: 'PayrollPeriodSummaryResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: PayrollPeriodSummarySchema;
};

/** Las tarjetas resumen del periodo activo. Todos los campos de identidad del periodo son nullable: cuando hoy cae en un hueco del calendario no hay periodo activo, y eso no es un error. */
export type PayrollPeriodSummarySchema = {
  __typename?: 'PayrollPeriodSummarySchema';
  /** `"<nombre de la periodicidad> <numero de periodo>"`. Sus dos partes son datos, no traduccion; `periodicity_name` y `period_number` van aparte para que el cliente pueda armar su propia etiqueta. */
  active_period_name?: Maybe<Scalars['String']['output']>;
  /** 🔴 **No es headcount.** Cuenta colaboradores con al menos una linea calculada en las corridas no canceladas de este periodo. Un periodo cuyas corridas no se calcularon devuelve `0` aunque la empresa tenga empleados. La unica fuente real de headcount es `HeadcountPort`, cuyo unico adaptador devuelve `0` incondicionalmente: un cero stubbeado bajo una etiqueta que dice 'Colaboradores' es peor que un numero mas chico que es verdad. */
  collaborators_count: Scalars['Int']['output'];
  /** Corte del periodo activo, inclusive. */
  cutoff_date?: Maybe<Scalars['Date']['output']>;
  /**
   * Subtotal de la pre-nomina. **Hoy es siempre `null`**: depende de PAYR-510. El campo se publica ya tipado para que conectarlo no sea un cambio de schema.
   *
   * 🔴 Nunca se sustituye por el neto calculado. La tarjeta dice 'Nomina estimada' y contesta 'cuanto va a costar antes de calcular'; el neto calculado contesta 'cuanto costo'.
   */
  estimated_amount?: Maybe<Scalars['Decimal']['output']>;
  /** Ejercicio fiscal. */
  fiscal_year?: Maybe<Scalars['Int']['output']>;
  /** El `cutoff_date` mas proximo desde hoy, inclusive. Se calcula aunque no haya periodo activo. `null` solo si el calendario se termina antes de hoy. */
  next_closure_date?: Maybe<Scalars['Date']['output']>;
  /** Dias hasta `next_closure_date`, con piso en `0`: si el corte es hoy son cero dias, no uno. Va **junto** con `next_closure_date` — o los dos tienen valor o los dos son `null`. */
  next_closure_days_left?: Maybe<Scalars['Int']['output']>;
  /** Fecha de pago del periodo activo. */
  payment_date?: Maybe<Scalars['Date']['output']>;
  /** Numero de periodo dentro del ejercicio. */
  period_number?: Maybe<Scalars['Int']['output']>;
  /** Nombre de la periodicidad del periodo activo. */
  periodicity_name?: Maybe<Scalars['String']['output']>;
  /** Inicio del periodo activo. Se publican las tres fechas sueltas y **no** un `date_range` ya formateado: formatear es locale, y este subgraph no tiene locale. */
  start_date?: Maybe<Scalars['Date']['output']>;
};

/** Association warning — payroll_type in another periodicity. */
export type PayrollPeriodicityAssociationWarning = {
  __typename?: 'PayrollPeriodicityAssociationWarning';
  existing_periodicity_id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  payroll_type_id: Scalars['ID']['output'];
};

/** Periodicity code (derived from SAT c_PeriodicidadPago). */
export enum PayrollPeriodicityCode {
  Anual = 'ANUAL',
  Bimestral = 'BIMESTRAL',
  Catorcenal = 'CATORCENAL',
  Decenal = 'DECENAL',
  Diario = 'DIARIO',
  Eventual = 'EVENTUAL',
  Mensual = 'MENSUAL',
  Quincenal = 'QUINCENAL',
  Semanal = 'SEMANAL'
}

/** Single-entity wrapper for get_periodicity. */
export type PayrollPeriodicityDetailResponse = {
  __typename?: 'PayrollPeriodicityDetailResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: PayrollPeriodicityDetailSchema;
};

/** Periodicity detail with calendar + associations. */
export type PayrollPeriodicityDetailSchema = {
  __typename?: 'PayrollPeriodicityDetailSchema';
  collaborators_count: Scalars['Int']['output'];
  payroll_types: Array<PayrollPeriodicityPayrollTypeRef>;
  periodicity: PayrollPeriodicitySchema;
  periods: Array<PayrollPeriodicityPeriodSchema>;
};

/** Filter for list_periodicities. */
export type PayrollPeriodicityFilter = {
  /** Filter by active flag. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by SAT periodicity code. */
  sat_code?: InputMaybe<PayrollSatPeriodicityCode>;
};

export type PayrollPeriodicityMutationResult = InternalErrorResponse | PayrollPeriodicityResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Offset/limit pagination. */
export type PayrollPeriodicityPagination = {
  /** Max items to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Items to skip. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A payroll type associated with a periodicity. */
export type PayrollPeriodicityPayrollTypeRef = {
  __typename?: 'PayrollPeriodicityPayrollTypeRef';
  id: Scalars['ID']['output'];
};

/** Offset/limit pagination. */
export type PayrollPeriodicityPayrollTypesPagination = {
  /** Max items to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Items to skip. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Filtro para list_periodicity_periods. */
export type PayrollPeriodicityPeriodFilter = {
  /** Estados a incluir. Sin filtro devuelve el ejercicio completo: un calendario se ve entero. El selector de incidencias es el que restringe a los estados que todavia admiten carga. */
  statuses?: InputMaybe<Array<PayrollPeriodStatus>>;
};

export type PayrollPeriodicityPeriodMutationResult = InternalErrorResponse | PayrollPeriodicityPeriodResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Offset/limit pagination. */
export type PayrollPeriodicityPeriodPagination = {
  /** Max items to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Items to skip. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Single-entity wrapper para el CRUD de periodos. */
export type PayrollPeriodicityPeriodResponse = {
  __typename?: 'PayrollPeriodicityPeriodResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: PayrollPeriodicityPeriodSchema;
};

/** A single period within a periodicity calendar. El rango del periodo es `start_date` - `cutoff_date`, ambos inclusive: el corte cierra el periodo. `payment_date` es independiente y puede caer despues. */
export type PayrollPeriodicityPeriodSchema = {
  __typename?: 'PayrollPeriodicityPeriodSchema';
  cutoff_date: Scalars['Date']['output'];
  fiscal_year: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  payment_date: Scalars['Date']['output'];
  period_number: Scalars['Int']['output'];
  periodicity_id: Scalars['ID']['output'];
  start_date: Scalars['Date']['output'];
  status: PayrollPeriodStatus;
};

/** Single-entity wrapper para el CRUD de periodicidad. */
export type PayrollPeriodicityResponse = {
  __typename?: 'PayrollPeriodicityResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: PayrollPeriodicitySchema;
};

/** Periodicity read-model. */
export type PayrollPeriodicitySchema = {
  __typename?: 'PayrollPeriodicitySchema';
  active: Scalars['Boolean']['output'];
  centralized_organization_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  period_days: Scalars['Int']['output'];
  sat_code: PayrollSatPeriodicityCode;
  updated_at: Scalars['DateTime']['output'];
};

/** Un concepto que la pre-nomina **no** calculo, con el motivo legible. Es lo que permite decir 'SBC (usa la UMA)' y 'D003 (depende de SBC)' en vez de una lista de codigos que el operador no puede accionar. */
export type PayrollPrePayrollExclusionSchema = {
  __typename?: 'PayrollPrePayrollExclusionSchema';
  /** Codigo del concepto excluido. */
  code: Scalars['String']['output'];
  /** Nombre del concepto en el catalogo. Cae al codigo si el concepto no tiene nombre cargado. */
  name: Scalars['String']['output'];
  /** Por que quedo afuera. Nombra el insumo fiscal concreto —la tarifa del ISR, la tabla de subsidio, un catalogo fiscal, el acumulado— o dice que la exclusion es heredada de una dependencia. */
  reason: Scalars['String']['output'];
  /** Codigo de la dependencia contaminada cuando la exclusion es **transitiva**. `null` cuando el concepto lee el insumo fiscal por si mismo. */
  via?: Maybe<Scalars['String']['output']>;
};

export type PayrollQuery = {
  __typename?: 'PayrollQuery';
  /** Calculated payroll variable read operations: read back a persisted run scope (optionally filtered by employee / impact). */
  calculated_variables: CalculatedVariableQuery;
  /** Checks whether an EmployerRegistration can be safely deleted (soft-deleted). Returns can_delete=true if there are no work locations linked to it. */
  can_delete_employer_registration: GetCanDeleteEmployerRegistrationResponse;
  /** Checks whether a LegalEntity can be safely deleted (soft-deleted). Returns can_delete=true if there are no active employer registrations linked to it. */
  can_delete_legal_entity: GetCanDeleteLegalEntityResponse;
  /** Paquete de conceptos: que conceptos aplican a cada tipo de nomina, y la vista cruzada desde un concepto. */
  concept_assignments: ConceptAssignmentQuery;
  /** Generates a sample dispersion file with fictitious data in the configured format and returns it base64-encoded. Pure generation; no persistence. */
  download_dispersion_layout_sample: DownloadDispersionLayoutSampleResponse;
  /** Employment subsidy table read operations: get active table, list history. */
  employment_subsidy: EmploymentSubsidyTableQuery;
  /** Generates a layout preview (Header/Detail/Trailer) from the account's real data and stored configuration. Pure read; no persistence. */
  generate_dispersion_layout_preview: GenerateDispersionLayoutPreviewResponse;
  /** Returns the active contract for an employee in a legal entity, enriched with employer data. */
  get_active_contract: GetActiveContractResult;
  /** Returns a single Bank by its ID. Input: id (required) — the primary key of the bank. */
  get_bank: GetBankResponse;
  /** Returns a list of Banks, optionally filtered by country. Input: country_code (optional) — filter by country code (e.g. 'MX'); bank_code (optional, exact match) — filter by bank code; search (optional) — partial match on bank name; limit (optional) — max number of results; offset (optional) — number of records to skip. */
  get_banks: GetBanksResponse;
  /** Returns the full detail of a contract by its ID. */
  get_contract: GetContractResult;
  /** Returns salary, position and banking info for the active contract of an employee. */
  get_contract_salary_info: GetContractSalaryInfoResult;
  /** Returns the CSD certificate status for a legal entity. Input: legal_entity_id (required) — the legal entity ID; centralized_organization_id (required) — the organization ID. */
  get_csd_status: GetCsdStatusResult;
  /** Returns the list of available currencies. */
  get_currencies: GetCurrenciesResponse;
  /** Returns a single dispersion account scoped to a legal entity. Input: id (required), centralized_organization_id (required), legal_entity_id (required). */
  get_dispersion_account: GetDispersionAccountResponse;
  /** Returns the dispersion accounts of a legal entity (razón social). Input: centralized_organization_id (required), legal_entity_id (required); bank_id, account_type, is_active, limit, offset (all optional). */
  get_dispersion_accounts: GetDispersionAccountsResponse;
  /** Returns the stored dispersion-layout configuration for a dispersion account, scoped to the caller's organization and legal entity. */
  get_dispersion_layout_config: GetDispersionLayoutConfigResponse;
  /** Returns a preview of the uploaded dispersion-layout file so the client can render it as a table: the headers the file declares, each with required/optional metadata, plus its first data rows. When the file carries headers only, a single sample row is returned and is_sample is true. Requires the account to have a layout file already uploaded. */
  get_dispersion_layout_file_preview: GetDispersionLayoutFilePreviewResponse;
  /** Returns a single EmployerRegistration by its ID scoped to an organization. Input: id (required) — the primary key of the employer registration; centralized_organization_id (required) — the organization the registration belongs to. */
  get_employer_registration: GetEmployerRegistrationResponse;
  /** Returns a paginated list of EmployerRegistrations scoped to an organization. Input: centralized_organization_id (required) — the organization to filter by; legal_entity_ids (optional) — filter by one or more legal entities; registration_number (optional, exact match) — filter by registration number; search (optional) — partial match on registration number (NRP); risk_class_ids (optional) — filter by one or more risk classes; is_active (optional) — filter by active/inactive flag; statuses (optional) — filter by one or more computed statuses: activo, vencido, inactivo; limit (optional) — max number of results; offset (optional) — number of records to skip. Returns results with total_count for pagination. */
  get_employer_registrations: GetEmployerRegistrationsResponse;
  /** Returns a list of FederalEntities. Input: code (optional, exact match) — filter by federal entity code; limit (optional) — max number of results; offset (optional) — number of records to skip. */
  get_federal_entities: GetFederalEntitiesResponse;
  /** Returns a single FederalEntity by its ID. Input: id (required) — the primary key of the federal entity. */
  get_federal_entity: GetFederalEntityResponse;
  /** Returns the IDSE credentials status for an employer registration. Input: employer_registration_id (required) — the employer registration ID; centralized_organization_id (required) — the organization ID. */
  get_idse_status: GetIdseStatusResult;
  /**
   * Credenciales con que se firma un envio de movimientos ante Terra IDSE: el identificador del usuario de servicio, el NPIE y el numero de registro patronal. Las consume el servicio de contrato, que es quien despacha el lote (D-15).
   *
   * Es una query aparte y no campos de `get_idse_status` porque la terna solo tiene sentido junta: asi se arma una vez con la regla correcta del NPIE y nadie puede pedir media (D-1).
   *
   * **No devuelve el certificado** ni ninguna contrasena. Input: employer_registration_id (obligatorio); centralized_organization_id (obligatorio).
   */
  get_idse_submission_credentials: GetIdseSubmissionCredentialsResult;
  /** Returns a single ImssDelegation by its ID. Input: id (required) — the primary key of the IMSS delegation. */
  get_imss_delegation: GetImssDelegationResponse;
  /** Returns a list of IMSS Delegaciones. Input: code (optional, exact match) — filter by delegation code; limit (optional) — max number of results; offset (optional) — number of records to skip. */
  get_imss_delegations: GetImssDelegationsResponse;
  /** Returns the IMSS fractions catalog with risk class and economic activity. Supports optional filters. */
  get_imss_fractions: GetImssFractionsResponse;
  /** Returns a single ImssSubdelegation by its ID. Input: id (required) — the primary key of the IMSS subdelegation. */
  get_imss_subdelegation: GetImssSubdelegationResponse;
  /** Returns a list of IMSS Subdelegaciones, optionally filtered by delegation. Input: delegation_id (optional) — cascading filter by parent delegation; code (optional, exact match) — filter by subdelegation code; limit (optional) — max number of results; offset (optional) — number of records to skip. */
  get_imss_subdelegations: GetImssSubdelegationsResponse;
  /** Returns a paginated list of LegalEntities scoped to an organization. Input: centralized_organization_id (required) — the organization to filter by; country_code (optional, exact match) — filter by country code (e.g. 'MX'); tax_type (optional, exact match) — filter by tax type; search (optional) — partial match on legal_name, trade_name, tax_id, internal_id; limit (optional) — max number of results; offset (optional) — number of records to skip. Returns results with total_count for pagination. work_centers_count is resolved for the whole page in a single aggregation, so selecting it does not add a query per row. */
  get_legal_entities: GetLegalEntitiesResponse;
  /** Returns a single LegalEntity by its ID scoped to an organization. Includes nested legal_representatives. Input: id (required) — the primary key of the legal entity; centralized_organization_id (required) — the organization the legal entity belongs to. */
  get_legal_entity: GetLegalEntityResponse;
  /** Returns the legal entity a user belongs to, given their centralized_user_id. Input: centralized_user_id (required), centralized_organization_id (required). */
  get_legal_entity_by_user_id: GetLegalEntityByUserIdResponse;
  /** Returns a list of LegalRepresentatives for a legal entity. Input: legal_entity_id (required) — the legal entity to list representatives for; centralized_organization_id (required) — the organization the legal entity belongs to; limit (optional) — max number of results; offset (optional) — number of records to skip. */
  get_legal_representatives: GetLegalRepresentativesResponse;
  /** Returns the payroll profile of an employee scoped to a legal entity. Combines data from payroll_employee and payroll_employee_info tables. Input: legal_entity_id (required), centralized_organization_id (required), centralized_user_id (required). */
  get_payroll_employee: GetPayrollEmployeeResult;
  /** Returns the list of available person types (Persona Física, Persona Moral). */
  get_person_types: GetPersonTypesResponse;
  /** Returns a single RiskClass by its ID. Input: id (required) — the primary key of the risk class. */
  get_risk_class: GetRiskClassResponse;
  /** Returns the default risk premium for each IMSS risk class (Art. 73 LSS). */
  get_risk_class_defaults: GetRiskClassDefaultsResponse;
  /** Returns a list of RiskClasses. Input: class_code (optional, exact match) — filter by risk class code; limit (optional) — max number of results; offset (optional) — number of records to skip. */
  get_risk_classes: GetRiskClassesResponse;
  /** Returns a single SalaryZone by its ID. Input: id (required) — the primary key of the salary zone. */
  get_salary_zone: GetSalaryZoneResponse;
  /** Returns a list of Salary Zones (Zonas Salariales). Input: code (optional, exact match) — filter by zone code; limit (optional) — max number of results; offset (optional) — number of records to skip. */
  get_salary_zones: GetSalaryZonesResponse;
  /** Returns a single TaxRegime by its ID. Input: id (required) — the primary key of the tax regime. */
  get_tax_regime: GetTaxRegimeResponse;
  /** Returns a list of TaxRegimes. Input: tax_regime_code (optional, exact match) — filter by regime code; tax_type (optional) — filter by person type (e.g. persona_fisica, persona_moral); limit (optional) — max number of results; offset (optional) — number of records to skip. */
  get_tax_regimes: GetTaxRegimesResponse;
  /** Returns a list of work centers (headquarters) from centralized. Input: centralized_organization_id (required); country_code (optional, default 'MX'); search (optional) — partial match on headquarter name/address; limit (optional, default 50); offset (optional, default 0). */
  get_work_centers: GetWorkCentersResponse;
  /** IMSS movement read operations: list, get detail. */
  imss_movement: ImssMovementQuery;
  /** IMSS cuotas obrero/patronal read operations: get current rates, list history. */
  imss_rate: ImssRateQuery;
  /** Incidence read operations: paginated list with filters and dashboard aggregate summary (counts by status and type). */
  incidences: IncidenceQuery;
  /** INFONAVIT discount factor read operations: get current factor, list history. */
  infonavit: InfonavitQuery;
  /** ISN (Impuesto Sobre Nomina) rates by state read operations: get current rates, list history. */
  isn_rate: IsnRateQuery;
  /** ISR table read operations: get active table, list history. */
  isr_table: IsrTableQuery;
  /** Returns the full status and field-change history of all contracts for an employee in a legal entity, ordered by date DESC. */
  list_contract_history: ListContractHistoryResult;
  /** Returns all contract versions for an employee in a legal entity, ordered by version DESC. */
  list_contract_versions: ListContractVersionsResult;
  /** Returns the list of active dependents for an employee. Input: centralized_user_id (required), centralized_organization_id (required). */
  list_employee_dependents: ListEmployeeDependentsResult;
  /** Parametros de calculo read operations: get_payroll_parameters, calculate_sdi. */
  parameters: ParametersQuery;
  /** Payroll concept (catalogo SICOSS) read operations. */
  payroll_concepts: PayrollConceptQuery;
  /** Payroll receipt line read operations: the persisted lines of a run version, optionally filtered by employee. */
  payroll_run_lines: PayrollRunLineQuery;
  /** Payroll run read operations: a run with its version history. */
  payroll_runs: PayrollRunQuery;
  /** Payroll type (tipo de nomina) read operations. */
  payroll_types: PayrollTypeQuery;
  /** Periodicity read operations: list, get detail, period calendar. */
  periodicities: PeriodicityQuery;
  /** Payroll receipt read operations: the calculation result of a run version projected per employee, with the skipped employees. */
  receipts: PayrollReceiptQuery;
  /** Run dispersion read operations: the dispersion step of a calculated run — context, eligible dispersing accounts, grouped warnings and the history of generated bank files. */
  run_dispersion: PayrollRunDispersionQuery;
  /** Social security info, government credits and pension read operations. */
  social_security: SocialSecurityQuery;
  /** Validates CLABE format (18 digits) and check digit. Input: clabe (required), centralized_organization_id (required). */
  validate_clabe: ValidateFormatResult;
  /** Validates CURP format against the RENAPO specification (18 characters). Input: curp (required), centralized_organization_id (required). */
  validate_curp: ValidateFormatResult;
  /** Validates IMSS (NSS) format: exactly 11 digits. Input: imss (required), centralized_organization_id (required). */
  validate_imss: ValidateFormatResult;
  /** Validates whether an internal_id already exists for an organization. Returns exists=true if a duplicate is found. Input: centralized_organization_id (required), internal_id (required), exclude_id (optional) — ID to exclude from check (useful when updating). */
  validate_internal_id: ValidateFieldResponse;
  /** Validates whether a legal_name already exists for an organization (case-insensitive). Returns exists=true if a duplicate is found. Input: centralized_organization_id (required), legal_name (required), exclude_id (optional) — ID to exclude from check. */
  validate_legal_name: ValidateFieldResponse;
  /** Validates registration number format, check digit, and uniqueness. */
  validate_registration_number: ValidateRegistrationNumberResult;
  /** Validates RFC format against the SAT specification. Input: rfc (required), centralized_organization_id (required). */
  validate_rfc: ValidateFormatResult;
  /** Validates whether a tax_id already exists globally (case-insensitive). Returns exists=true if a duplicate is found. Input: tax_id (required), exclude_id (optional) — ID to exclude from check. */
  validate_tax_id: ValidateFieldResponse;
};


export type PayrollQueryCan_Delete_Employer_RegistrationArgs = {
  input: CanDeleteEmployerRegistrationInput;
};


export type PayrollQueryCan_Delete_Legal_EntityArgs = {
  input: CanDeleteLegalEntityInput;
};


export type PayrollQueryDownload_Dispersion_Layout_SampleArgs = {
  input: DownloadDispersionLayoutSampleInput;
};


export type PayrollQueryGenerate_Dispersion_Layout_PreviewArgs = {
  input: GenerateDispersionLayoutPreviewInput;
};


export type PayrollQueryGet_Active_ContractArgs = {
  input: GetActiveContractInput;
};


export type PayrollQueryGet_BankArgs = {
  input: GetByIdInput;
};


export type PayrollQueryGet_BanksArgs = {
  input: ListBanksInput;
};


export type PayrollQueryGet_ContractArgs = {
  input: GetContractInput;
};


export type PayrollQueryGet_Contract_Salary_InfoArgs = {
  input: GetContractSalaryInfoInput;
};


export type PayrollQueryGet_Csd_StatusArgs = {
  input: GetCsdStatusInput;
};


export type PayrollQueryGet_Dispersion_AccountArgs = {
  input: GetDispersionAccountInput;
};


export type PayrollQueryGet_Dispersion_AccountsArgs = {
  input: ListDispersionAccountsInput;
};


export type PayrollQueryGet_Dispersion_Layout_ConfigArgs = {
  input: GetDispersionLayoutConfigInput;
};


export type PayrollQueryGet_Dispersion_Layout_File_PreviewArgs = {
  input: GetDispersionLayoutFilePreviewInput;
};


export type PayrollQueryGet_Employer_RegistrationArgs = {
  input: GetEmployerRegistrationInput;
};


export type PayrollQueryGet_Employer_RegistrationsArgs = {
  input: ListEmployerRegistrationsInput;
};


export type PayrollQueryGet_Federal_EntitiesArgs = {
  input: ListFederalEntitiesInput;
};


export type PayrollQueryGet_Federal_EntityArgs = {
  input: GetByIdInput;
};


export type PayrollQueryGet_Idse_StatusArgs = {
  input: GetIdseStatusInput;
};


export type PayrollQueryGet_Idse_Submission_CredentialsArgs = {
  input: GetIdseSubmissionCredentialsInput;
};


export type PayrollQueryGet_Imss_DelegationArgs = {
  input: GetByIdInput;
};


export type PayrollQueryGet_Imss_DelegationsArgs = {
  input: ListImssDelegationsInput;
};


export type PayrollQueryGet_Imss_FractionsArgs = {
  input: GetImssFractionsInput;
};


export type PayrollQueryGet_Imss_SubdelegationArgs = {
  input: GetByIdInput;
};


export type PayrollQueryGet_Imss_SubdelegationsArgs = {
  input: ListImssSubdelegationsInput;
};


export type PayrollQueryGet_Legal_EntitiesArgs = {
  input: ListLegalEntitiesInput;
};


export type PayrollQueryGet_Legal_EntityArgs = {
  input: GetLegalEntityInput;
};


export type PayrollQueryGet_Legal_Entity_By_User_IdArgs = {
  input: GetLegalEntityByUserIdInput;
};


export type PayrollQueryGet_Legal_RepresentativesArgs = {
  input: ListLegalRepresentativesInput;
};


export type PayrollQueryGet_Payroll_EmployeeArgs = {
  input: GetPayrollEmployeeInput;
};


export type PayrollQueryGet_Risk_ClassArgs = {
  input: GetByIdInput;
};


export type PayrollQueryGet_Risk_ClassesArgs = {
  input: ListRiskClassesInput;
};


export type PayrollQueryGet_Salary_ZoneArgs = {
  input: GetByIdInput;
};


export type PayrollQueryGet_Salary_ZonesArgs = {
  input: ListSalaryZonesInput;
};


export type PayrollQueryGet_Tax_RegimeArgs = {
  input: GetByIdInput;
};


export type PayrollQueryGet_Tax_RegimesArgs = {
  input: ListTaxRegimesInput;
};


export type PayrollQueryGet_Work_CentersArgs = {
  input: ListWorkCentersInput;
};


export type PayrollQueryList_Contract_HistoryArgs = {
  input: ListContractHistoryInput;
};


export type PayrollQueryList_Contract_VersionsArgs = {
  input: ListContractVersionsInput;
};


export type PayrollQueryList_Employee_DependentsArgs = {
  input: ListEmployeeDependentsInput;
};


export type PayrollQueryValidate_ClabeArgs = {
  input: ValidateClabeInput;
};


export type PayrollQueryValidate_CurpArgs = {
  input: ValidateCurpInput;
};


export type PayrollQueryValidate_ImssArgs = {
  input: ValidateImssInput;
};


export type PayrollQueryValidate_Internal_IdArgs = {
  input: ValidateInternalIdInput;
};


export type PayrollQueryValidate_Legal_NameArgs = {
  input: ValidateLegalNameInput;
};


export type PayrollQueryValidate_Registration_NumberArgs = {
  input: ValidateRegistrationNumberInput;
};


export type PayrollQueryValidate_RfcArgs = {
  input: ValidateRfcInput;
};


export type PayrollQueryValidate_Tax_IdArgs = {
  input: ValidateTaxIdInput;
};

/** Un concepto de la boleta. `taxable_amount` y `exempt_amount` llegan con los 6 decimales con que se almacenan; `amount` es el corte a 2 decimales del entregable. Los tres juntos son lo que permite distinguir una diferencia por redondeo de una diferencia por formula. */
export type PayrollReceiptConceptSchema = {
  __typename?: 'PayrollReceiptConceptSchema';
  /** `round(gravado + exento)` a 2 decimales. Es el unico redondeo de todo el motor, y ocurre aca: en la boleta. */
  amount: Scalars['Decimal']['output'];
  /** Codigo del concepto. */
  concept_code: Scalars['String']['output'];
  /** Nombre del concepto. */
  concept_name: Scalars['String']['output'];
  /** Regla que produjo el importe. Es lo que hace la comparacion auditable y no solo igual. Null en los sub-totales y en los conceptos sin regla. */
  concept_rule_id?: Maybe<Scalars['ID']['output']>;
  /** Parte exenta, 6 dec. Separada del gravado porque el CFDI las declara aparte y el tope de exencion en UMA parte un mismo concepto en las dos columnas. */
  exempt_amount: Scalars['Decimal']['output'];
  /** Concepto del catalogo. */
  payroll_concept_id: Scalars['ID']['output'];
  /** Clave SAT estampada al calcular. No se re-lee del concepto: el CFDI declaro *este* valor y el catalogo es editable. */
  sat_code?: Maybe<Scalars['String']['output']>;
  /** Parte gravada, 6 dec. */
  taxable_amount: Scalars['Decimal']['output'];
};

/** Cabecera de la boleta. Es **por respuesta y no por recibo**: es identica para todos los empleados de la version, asi que repetirla seria carga util sin informacion. */
export type PayrollReceiptHeaderSchema = {
  __typename?: 'PayrollReceiptHeaderSchema';
  /** Cuando se calculo la version. Null si todavia no. */
  calculated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Cierre del periodo. Es la fecha que fijo la antiguedad y los dias de vacaciones con que se calculo. */
  cutoff_date: Scalars['Date']['output'];
  /** Base de prorrateo congelada en la version (30, 30.4...). No es decoracion: un centavo de diferencia contra un recibo hecho a mano es inatribuible sin saber por cuanto dividio el motor. Null mientras la version no la resolvio. */
  days_base?: Maybe<Scalars['Decimal']['output']>;
  /** Ejercicio fiscal. */
  fiscal_year: Scalars['Int']['output'];
  /** Razon social de la corrida. **Nullable**: es opcional durante la transicion de PAYR-558, asi que las versiones abiertas antes de esa guarda no la tienen. */
  legal_entity_id?: Maybe<Scalars['ID']['output']>;
  /** Nombre legal de la razon social. */
  legal_entity_name?: Maybe<Scalars['String']['output']>;
  /** Fecha de pago. */
  payment_date: Scalars['Date']['output'];
  /** Corrida. */
  payroll_run_id: Scalars['ID']['output'];
  /** Version leida. */
  payroll_run_version_id: Scalars['ID']['output'];
  /** Tipo de nomina. */
  payroll_type_id: Scalars['ID']['output'];
  /** Nombre del tipo de nomina. */
  payroll_type_name: Scalars['String']['output'];
  /** Periodo del calendario. */
  period_id: Scalars['ID']['output'];
  /** Numero de periodo. */
  period_number: Scalars['Int']['output'];
  /** Inicio del periodo. */
  start_date: Scalars['Date']['output'];
  /** Estado de la corrida. */
  status: Scalars['String']['output'];
  /** Numero de version. */
  version: Scalars['Int']['output'];
  /** Estado de la version. Una version en `en_calculo` se lee igual y devuelve datos parciales: negarse borraria la diferencia entre 'todavia calculando' y 'fallo'. */
  version_status: Scalars['String']['output'];
};

/** Offset/limit pagination. */
export type PayrollReceiptPagination = {
  /** **Boletas** por pagina, no lineas: la unidad de paginacion es el empleado. Rango cerrado [1, 100]; fuera de rango es `ValidationErrorResponse`, no un valor recortado en silencio. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Boletas a saltear. Negativo es error de validacion. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PayrollReceiptQuery = {
  __typename?: 'PayrollReceiptQuery';
  /**
   * La boleta de la corrida: el resultado del calculo proyectado por empleado. Cabecera comun (razon social, tipo de nomina, periodo, base de prorrateo), percepciones y deducciones como listas separadas en el orden del plan de calculo, y los tres totales **leidos de las lineas guardadas**.
   *
   * La entrada es la **version** de la corrida, no la corrida: una corrida tiene N versiones y una boleta pertenece a una sola.
   *
   * Los empleados que el motor salteo aparecen igual, con `skip.field`, `skip.reason` y `skip.code`: un empleado ausente y un empleado con boleta en cero son dos problemas distintos y hay que poder distinguirlos.
   *
   * `skip.code` (PAYR-603) es la causa **estable** con la que se agrupan los saltos sin leer el texto de `reason`. Es **nullable**: `null` significa que la fila se escribio antes de que el motor clasificara causas y la version no se recalculo desde entonces — se agrupa como 'sin clasificar', **no es un error**, y se recupera solo al recalcular.
   *
   * Si un total guardado no cuadra con la suma de sus lineas ya cortadas, la respuesta es `PayrollReceiptTotalsMismatchResponse` y **no** el payload: vale mas fallar que mostrar un numero redondeado que nadie va a auditar.
   */
  payroll_receipts: PayrollListPayrollReceiptsResult;
};


export type PayrollReceiptQueryPayroll_ReceiptsArgs = {
  input: PayrollListPayrollReceiptsInput;
};

/**
 * La boleta de un empleado, o la constancia de que no se le calculo.
 *
 * | Estado | `skip` | listas | totales |
 * |---|---|---|---|
 * | calculado, con importes | null | poblada | numeros |
 * | calculado, todo en cero | null | poblada con ceros | `0.00` |
 * | salteado | `{field, reason, code}` | vacias | null |
 *
 * Los tres totales son nullable y **null no es cero**: un cero se lee como 'esta boleta no paga nada', que es otra afirmacion y es falsa.
 */
export type PayrollReceiptSchema = {
  __typename?: 'PayrollReceiptSchema';
  /** Empleado. Es la clave cruda que el FE devuelve como filtro. */
  centralized_user_id: Scalars['Int']['output'];
  /** Deducciones, en el orden del plan de calculo. */
  deductions: Array<PayrollReceiptConceptSchema>;
  /** Percepciones, en el orden del plan de calculo (no el de insercion, que es un UUID aleatorio). */
  earnings: Array<PayrollReceiptConceptSchema>;
  /** Referencia de federacion al empleado. El gateway pega `full_name` desde `crehana-centralized-users`: **ningun nombre se lee ni se guarda aca**. */
  employee: CentralizedUserNode;
  /** `NETO_A_PAGAR` leido de la linea guardada. */
  net_pay?: Maybe<Scalars['Decimal']['output']>;
  /** Todo `payroll_impact` que no sea percepcion, deduccion o total. Hoy sale vacia y **eso no es el contrato**: el dia que la corrida pague subsidio para el empleo, esa linea aterriza aca y no se suma a ningun subtotal ni al neto. La cubeta existe para que ningun importe desaparezca de la boleta en silencio. */
  other: Array<PayrollReceiptConceptSchema>;
  /** No null solo si el motor salteo al empleado. */
  skip?: Maybe<PayrollReceiptSkipSchema>;
  /** `TOTAL_DEDUCCIONES` leido de la linea guardada. */
  total_deductions?: Maybe<Scalars['Decimal']['output']>;
  /** `TOTAL_PERCEPCIONES` **leido de la linea guardada**, nunca re-sumado al mostrar: un total calculado al desplegar se re-renderizaria distinto el dia que cambie el helper de redondeo. */
  total_earnings?: Maybe<Scalars['Decimal']['output']>;
};

/**
 * El motivo por el que el motor no calculo a este empleado.
 *
 * Tres campos, con tres usos distintos: `reason` es el mensaje que se muestra, `field` el insumo que falto —null cuando el fallo no es atribuible a un campo del contrato— y `code` la causa **estable** con la que se agrupa sin leer el texto (PAYR-603).
 *
 * 🔴 `code` es **nullable en esta superficie**, a diferencia del mismo enum en los payloads de calculo. `null` significa que la fila se escribio antes de que el motor clasificara causas: se agrupa como 'sin clasificar', **no es un error**, y se recupera solo en cuanto alguien recalcula esa version. Nunca se coacciona a `UNKNOWN`, que afirmaria que el clasificador corrio y fallo.
 */
export type PayrollReceiptSkipSchema = {
  __typename?: 'PayrollReceiptSkipSchema';
  /**
   * Causa estable del salto, para **agrupar** sin leer `reason` (PAYR-603).
   *
   * `null` = fila escrita antes de esta migracion y nunca recalculada. Es un tercer estado real, distinto de `UNKNOWN`: el clasificador no corrio, no es que corrio y fallo.
   *
   * 🔴 Dos avisos. **El enum va a crecer**: un valor no reconocido se agrupa como 'otros', nunca se descarta. Y **`code` significa tres cosas distintas en esta misma respuesta** — este enum, el `String!` fijo de `PayrollReceiptTotalsMismatchResponse.code` y el `String!` de las respuestas de error de la union. Discriminar siempre por `__typename` antes de leer un `.code`.
   */
  code?: Maybe<PayrollEmployeeCalculationErrorCode>;
  /** Insumo que falto (`christmas_bonus_days`, `rfc`...). */
  field?: Maybe<Scalars['String']['output']>;
  /** Mensaje que produjo el calculador. */
  reason: Scalars['String']['output'];
};

/**
 * Un total guardado no coincide con la suma de sus lineas ya cortadas a 2 decimales.
 *
 * Es un error de **negocio** con su propio tipo, no una excepcion filtrada: el total se guarda como suma de lineas redondeadas, nunca como redondeo del total crudo, y un centavo de diferencia hace que el SAT rechace el CFDI. Mostrar un numero redondeado que nadie va a auditar es el fallo que este tipo existe para impedir.
 *
 * ⚠️ Un empleado descuadrado **tumba la pagina entera**, por diseno: la alternativa es pintar 127 boletas donde una cifra esta mal y nada dice cual. La salida de emergencia esta en la misma query — el error nombra al empleado y `centralized_user_id` acota la lectura a el.
 */
export type PayrollReceiptTotalsMismatchResponse = {
  __typename?: 'PayrollReceiptTotalsMismatchResponse';
  /** Empleado cuya boleta no cuadra. */
  centralized_user_id?: Maybe<Scalars['Int']['output']>;
  code: Scalars['String']['output'];
  /** Total que no cuadra (`TOTAL_PERCEPCIONES`, `TOTAL_DEDUCCIONES`, `NETO_A_PAGAR`). */
  concept_code?: Maybe<Scalars['String']['output']>;
  /** La suma de las lineas ya cortadas a 2 decimales. */
  expected_amount?: Maybe<Scalars['Decimal']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  /** El valor que esta guardado en la linea de total. */
  stored_amount?: Maybe<Scalars['Decimal']['output']>;
};

export type PayrollRejectIncidencesInput = {
  /** Organization that owns the incidences (scope/isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Ids of the incidences to reject (one or many). Must contain at least one id. Only PENDING incidences are transitioned; already terminal ones are skipped (idempotent). */
  incidence_ids: Array<Scalars['UUID']['input']>;
  /** Mandatory non-empty rejection reason applied to all ids. */
  reason: Scalars['String']['input'];
};

export type PayrollReopenIncidencesInput = {
  /** Organization that owns the incidences (scope/isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Ids of the incidences to reopen (one or many). Must contain at least one id. Only REJECTED incidences are transitioned back to PENDING; anything else is skipped (idempotent). */
  incidence_ids: Array<Scalars['UUID']['input']>;
};

/** The context filters as the user picked them. Every field is optional; the ones present combine with AND, and the values inside each one with OR. */
export type PayrollResolveIncidenceFiltersInput = {
  /** Organization that owns the incidences (scope/isolation). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Legal entities (razones sociales), resolved to collaborators against the contract service. */
  legal_entity_ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Pay frequencies **of the contract** (periodicidad de pago), resolved to collaborators against the contract service. Ids come from that service's `pay_frequency` catalog group. Do not confuse it with the payroll periodicity: that one hangs off a payroll type and owns the periods, this one hangs off each employee. */
  pay_frequency_ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Payroll types. Echoed back unchanged: it is a column on the incidence and needs no resolution. */
  payroll_type_ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Periods to translate into a date window. Overrides start_date_from/start_date_to when present. Several periods collapse into one **continuous** window from the earliest start to the latest cutoff — with non-contiguous periods that window includes days that belong to neither, which is why the UI offers a single period. */
  periodicity_period_ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Raw window start, used when no period is chosen. Passed through untouched. */
  start_date_from?: InputMaybe<Scalars['Date']['input']>;
  /** Raw window end, used when no period is chosen. */
  start_date_to?: InputMaybe<Scalars['Date']['input']>;
  /** Work centres **by headquarter_id** — the key get_work_centers returns, which is what the UI shows. It is translated to work_location.id before asking the contract service, and it is also resolved against centralized-users; the two answers are **unioned**, because an employee without an MX contract still belongs to a work centre. */
  work_center_headquarter_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Un concepto de la version con su importe agregado y, si hay periodo anterior calculado, su comparativo. Las tres lineas de sub-total del recibo (TOTAL_PERCEPCIONES, TOTAL_DEDUCCIONES, NETO_A_PAGAR) **no** aparecen: son la suma de las otras, no un concepto que se sume. */
export type PayrollRunConceptTotalSchema = {
  __typename?: 'PayrollRunConceptTotalSchema';
  /** `taxable_amount + exempt_amount`, con los 6 decimales con que se almacenan las lineas. **No se redondea**: el corte a 2 decimales es del entregable (recibo / CFDI), y un agregado cortado deja de poder conciliarse contra la suma de sus partes, que es para lo que sirve. */
  amount: Scalars['Decimal']['output'];
  /** Codigo del concepto en el catalogo de la organizacion. Es por donde la tarjeta elige su fila; el backend no sabe cual concepto es el ISR. */
  concept_code: Scalars['String']['output'];
  /** Nombre del concepto, leido del catalogo y no estampado por linea: un recalculo parcial con el catalogo editado en el medio dejaria dos estampados distintos y partiria el concepto en dos filas. */
  concept_name: Scalars['String']['output'];
  /** Suma de la parte exenta. Separada del gravado porque el CFDI las declara aparte. */
  exempt_amount: Scalars['Decimal']['output'];
  /** Lineas plegadas en esta fila. Es tambien la cantidad de empleados que llevan el concepto: `uq_payroll_run_line_version_user_concept` hace unica la terna (version, empleado, concepto). */
  lines_count: Scalars['Int']['output'];
  /** Concepto del catalogo. Es la llave de agrupacion, y no el `sat_code`: `D040` (ISR retenido) y `E001` (Subsidio para el empleo) comparten `sat_code = 002`, asi que agrupar por SAT fundiria el subsidio dentro de la cifra de ISR que despues se entera. */
  payroll_concept_id: Scalars['ID']['output'];
  /** Como afecta al recibo. Es un atributo de la fila y **no** la llave: ISR, cuota IMSS obrera, INFONAVIT y FONACOT son todos `DEDUCTION`, y agrupar por impacto los meteria a todos en el mismo balde. Nunca llega `TOTAL`: esas lineas se excluyen. */
  payroll_impact: PayrollRunLineImpactEnum;
  /** Lo que sumo el mismo concepto en el periodo anterior. `null` significa que el concepto **no tuvo lineas** ahi; `0` significa que las tuvo y sumaron cero. Son dos afirmaciones distintas. */
  previous_amount?: Maybe<Scalars['Decimal']['output']>;
  /** Clave del concepto SAT, leida del catalogo. Es un atributo, nunca la llave de agrupacion: es nullable y no es unica. */
  sat_code?: Maybe<Scalars['String']['output']>;
  /** Suma de la parte gravada. Viene al lado de `amount` para que la cifra sea auditable sin una segunda llamada. */
  taxable_amount: Scalars['Decimal']['output'];
  /** Variacion contra el periodo anterior en porcentaje (`1.9` = +1,9 %). `null` cuando no hay contra que dividir —sin periodo anterior, o con un anterior de exactamente cero, que es indefinido y no infinito—. Es el **unico** numero redondeado de este payload (2 decimales, HALF_UP) porque es un ratio de presentacion y no dinero. */
  variation_percentage?: Maybe<Scalars['Decimal']['output']>;
};

/** Contra que se comparo. Presente **si y solo si** hay algo con que comparar: si la corrida anterior existe pero su version vigente no tiene lineas, esto viene `null`, para no publicar una referencia de periodo al lado de una columna entera de `previous_amount: null` que se leeria como 'el periodo anterior no pago nada'. */
export type PayrollRunConceptTotalsPreviousPeriodSchema = {
  __typename?: 'PayrollRunConceptTotalsPreviousPeriodSchema';
  /** Corte del periodo anterior. */
  cutoff_date: Scalars['Date']['output'];
  /** Ejercicio del periodo anterior. Puede no ser el de la corrida actual: el comparativo cruza el limite de ejercicio. */
  fiscal_year: Scalars['Int']['output'];
  /** Corrida del periodo anterior que aporto el comparativo. */
  payroll_run_id: Scalars['ID']['output'];
  /** Version vigente de esa corrida, que es la que se agrego. */
  payroll_run_version_id: Scalars['ID']['output'];
  /** Numero de periodo, para la etiqueta 'vs Q4'. */
  period_number: Scalars['Int']['output'];
  /** Periodo inmediatamente anterior del mismo calendario, resuelto por `cutoff_date` y no por `period_number - 1`. */
  periodicity_period_id: Scalars['ID']['output'];
  /** Inicio del periodo anterior. */
  start_date: Scalars['Date']['output'];
};

/** Single-entity wrapper para get_payroll_run. */
export type PayrollRunDetailResponse = {
  __typename?: 'PayrollRunDetailResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: PayrollRunDetailSchema;
};

/** Corrida con su historial de versiones. */
export type PayrollRunDetailSchema = {
  __typename?: 'PayrollRunDetailSchema';
  run: PayrollRunSchema;
  versions: Array<PayrollRunVersionSchema>;
};

/**
 * Un archivo bancario generado, o el registro de que su generacion fallo.
 *
 * `status` es `generated` o `failed`. **`generating` no existe**: la generacion es sincronica, como el motor de calculo. El dia que sea asincronica sera un valor nuevo, no un cambio de contrato.
 */
export type PayrollRunDispersionFileType = {
  __typename?: 'PayrollRunDispersionFileType';
  /** Σ de los montos ya cortados a 2 decimales de sus filas — nunca el corte de la suma. Un centavo de diferencia entre el total y sus lineas es un archivo que el banco rechaza. */
  amount: Scalars['Decimal']['output'];
  /** `same_bank` o `interbank`. */
  batch_type: Scalars['String']['output'];
  /** URL firmada de descarga, de vigencia corta: el archivo trae la CLABE y el sueldo de cada persona. `null` en un lote vacio, en uno fallido, o si la firma no se pudo generar. */
  download_url?: Maybe<Scalars['String']['output']>;
  /** Filas del archivo. `0` en un lote vacio, que se devuelve igual: 'no hay interbancarios' y 'el interbancario fallo' no pueden verse iguales. */
  employees_count: Scalars['Int']['output'];
  /** Motivo, solo cuando `status` es `failed`. */
  error_message?: Maybe<Scalars['String']['output']>;
  /** Nombre del archivo, p. ej. `BBVA_interbancario_Q5_2026.txt`. */
  file_name: Scalars['String']['output'];
  /** Cuando se genero. */
  generated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Quien la disparo. Null en sesiones de servicio. */
  generated_by?: Maybe<Scalars['Int']['output']>;
  /** Numero de generacion (1, 2, 3...) para el par (version, cuenta). Regenerar suma una; ninguna se sobreescribe. */
  generation: Scalars['Int']['output'];
  /** Archivo. */
  id: Scalars['ID']['output'];
  /** Banco dispersor **al momento de generar**. La fila guarda su id porque la cuenta es editable y el archivo se produjo contra ese banco. */
  source_bank_name?: Maybe<Scalars['String']['output']>;
  /** `generated` o `failed`. */
  status: Scalars['String']['output'];
};

export type PayrollRunDispersionMutation = {
  __typename?: 'PayrollRunDispersionMutation';
  /**
   * Genera los archivos bancarios de la corrida para una cuenta dispersora, aplicando el layout del archivo que esa cuenta tiene cargado.
   *
   * Devuelve **dos** archivos: mismo banco e interbancario. Los dos vienen siempre, aunque uno tenga `employees_count: 0`.
   *
   * Cada llamada produce una **generacion nueva** y conserva las anteriores (el historial esta en `get_payroll_run_dispersion.generated_files`). Dos clicks concurrentes colisionan en el indice unico y el perdedor recibe un `ValidationErrorResponse` pidiendo reintentar — nunca dos filas afirmando ser la misma generacion.
   *
   * Rechaza si: la corrida esta timbrada, pagada o cancelada; la version vigente todavia esta en calculo; la cuenta no es elegible para el periodo; la cuenta no tiene config de layout **o** no tiene el archivo del banco cargado; la plantilla no declara una columna obligatoria; o la plantilla pide una columna que este servicio no puede llenar (hoy, `rfc`). Ninguno de esos casos se resuelve emitiendo celdas vacias.
   *
   * Un fallo al subir el archivo **no** es un error de la operacion: la fila queda con `status: failed` y su motivo, porque el historial tiene que poder decir que se intento.
   */
  generate_payroll_run_dispersion_file: PayrollGeneratePayrollRunDispersionFileResult;
};


export type PayrollRunDispersionMutationGenerate_Payroll_Run_Dispersion_FileArgs = {
  input: PayrollGeneratePayrollRunDispersionFileInput;
};

export type PayrollRunDispersionQuery = {
  __typename?: 'PayrollRunDispersionQuery';
  /**
   * El paso de dispersion de la version vigente de una corrida: contexto, cuentas dispersoras elegibles, advertencias agrupadas e historial de archivos generados.
   *
   * La entrada es **la corrida** y no la version: el dinero se paga una vez, con la version vigente.
   *
   * ⚠️ Es una query que **sale a la red**: los insumos bancarios de cada empleado (CLABE, banco, metodo de pago) viven en `crehana-subgraph-contract`. Si ese servicio no responde, la respuesta es un error nombrado y no una lista de advertencias vacia.
   *
   * Los empleados sin transferencia bancaria, sin CLABE o sin banco resoluble **no** entran a ningun archivo y aparecen en `warnings` con su neto, para que el pago se pueda verificar por otra via.
   */
  get_payroll_run_dispersion: PayrollGetPayrollRunDispersionResult;
};


export type PayrollRunDispersionQueryGet_Payroll_Run_DispersionArgs = {
  input: PayrollGetPayrollRunDispersionInput;
};

/**
 * El paso de dispersion de la version vigente de una corrida.
 *
 * `net_paid` es lo que la corrida **debe**; `total_to_disperse` es lo que los archivos **van a mover**. Siempre `net_paid >= total_to_disperse`, y `excluded_amount` explica la diferencia: es exactamente la suma de los netos de las filas de `warnings` marcadas `excluded_from_file`.
 *
 * Los dos primeros son nullable y **null no es cero**: una version sin lineas de `NETO_A_PAGAR` da `null`, y un cero se leeria como 'esta corrida no paga nada', que es otra afirmacion y es falsa. `excluded_amount` en cambio siempre es un numero: es una diferencia, y 'no hay diferencia' es cero.
 */
export type PayrollRunDispersionStepType = {
  __typename?: 'PayrollRunDispersionStepType';
  /** Cuentas dispersoras elegibles para el periodo de la corrida. */
  bank_options: Array<PayrollDispersionBankOptionType>;
  /** Cuando se calculo la version. */
  calculated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Empleados con linea de neto en la version. **No** es lo mismo que `dispersable_count`. */
  collaborators_count: Scalars['Int']['output'];
  /** Nombre legal de la razon social. */
  company_name?: Maybe<Scalars['String']['output']>;
  /** Cierre del periodo. */
  cutoff_date: Scalars['Date']['output'];
  /** Empleados que van a entrar a un archivo. */
  dispersable_count: Scalars['Int']['output'];
  /** Banco de la unica cuenta `principal` activa, como sugerencia. `null` si no hay ninguna o si hay mas de una. No es un compromiso: la cuenta se fija al generar. */
  dispersor_bank_name?: Maybe<Scalars['String']['output']>;
  /** `net_paid - total_to_disperse`, materializado para que el front no lo re-derive. */
  excluded_amount: Scalars['Decimal']['output'];
  /** Ejercicio fiscal. */
  fiscal_year: Scalars['Int']['output'];
  /** Historial completo de generaciones de esta version, mas nueva primero. Vacio antes del primer click, que no es un error. */
  generated_files: Array<PayrollRunDispersionFileType>;
  graphql_operation_id: Scalars['ID']['output'];
  /** Razon social de la corrida. **Nullable** por la transicion de PAYR-558; en la practica una corrida sin razon social no puede leer este paso, porque sin ella no hay contratos que pedir ni cuentas que listar. */
  legal_entity_id?: Maybe<Scalars['ID']['output']>;
  /** Σ de los netos guardados de toda la version. */
  net_paid?: Maybe<Scalars['Decimal']['output']>;
  /** Fecha de pago. */
  payment_date: Scalars['Date']['output'];
  /** **Codigo** del metodo de pago dominante de la poblacion dispersable — en MX `01` es transferencia bancaria—, o `null` cuando es mixta. Es el valor sobre el que se decide, **no** el que se muestra: para la pantalla usar `payment_method_label`. ⚠️ **No es un hecho de nivel de corrida**: vive por contrato. La verdad por empleado esta en `warnings`. */
  payment_method?: Maybe<Scalars['String']['output']>;
  /** Etiqueta legible del mismo metodo — 'Transferencia bancaria' —, tal como la sirve el catalogo del servicio de contratos. **Es lo que va en pantalla.** `null` si la poblacion es mixta o si el catalogo no trae etiqueta; en ese caso no se cae al codigo, porque un '01' en pantalla no es una etiqueta. */
  payment_method_label?: Maybe<Scalars['String']['output']>;
  /** Nombre del tipo de nomina — el 'tipo de nomina' de la pantalla. */
  payment_type: Scalars['String']['output'];
  /** Corrida. */
  payroll_run_id: Scalars['ID']['output'];
  /** Version vigente, la que se dispersa. */
  payroll_run_version_id: Scalars['ID']['output'];
  /** Tipo de nomina. */
  payroll_type_id: Scalars['ID']['output'];
  /** Periodo del calendario. */
  period_id: Scalars['ID']['output'];
  /** Numero de periodo. */
  period_number: Scalars['Int']['output'];
  /** Inicio del periodo. */
  start_date: Scalars['Date']['output'];
  /** Estado de la corrida. */
  status: Scalars['String']['output'];
  /** Σ de los netos de los empleados que **si** entran a un archivo. */
  total_to_disperse?: Maybe<Scalars['Decimal']['output']>;
  /** Numero de version. */
  version: Scalars['Int']['output'];
  /** Estado de la version. */
  version_status: Scalars['String']['output'];
  /** Advertencias agrupadas por motivo, en orden fijo. */
  warnings: Array<PayrollDispersionWarningGroupType>;
};

/** Impacto de una linea del recibo. Es un enum **propio** y no el de `calculated_variable`: agrega `TOTAL`, que las tres lineas de sub-total impresas en el recibo llevan (TOTAL_PERCEPCIONES, TOTAL_DEDUCCIONES, NETO_A_PAGAR). Ensanchar `PayrollVariableImpactEnum` habria cambiado el contrato publicado de `calculated_variable`. Todo lector que sume lineas y el escritor del CFDI tienen que excluir `TOTAL`: TotalPercepciones y TotalDeducciones son atributos del nodo Nomina, no elementos <Percepcion>. */
export enum PayrollRunLineImpactEnum {
  Base = 'BASE',
  Deduction = 'DEDUCTION',
  Earning = 'EARNING',
  EmployerCost = 'EMPLOYER_COST',
  Informative = 'INFORMATIVE',
  OtherPayment = 'OTHER_PAYMENT',
  Total = 'TOTAL'
}

/** Offset/limit pagination. */
export type PayrollRunLinePagination = {
  /** Max items to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Items to skip. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PayrollRunLineQuery = {
  __typename?: 'PayrollRunLineQuery';
  /** Los importes de una version de corrida agregados **por concepto**, en una sola llamada. Alimenta las tarjetas de resultado del paso 2 del wizard: agrupar por `payroll_impact` no sirve porque ISR, cuota IMSS obrera, INFONAVIT y FONACOT son todos `DEDUCTION`. Las tres lineas de sub-total del recibo quedan excluidas. No pagina: la cantidad de filas es la de conceptos, no la de empleados. Trae ademas el comparativo contra el periodo inmediatamente anterior del mismo calendario cuando ese periodo tiene una corrida calculada para la misma razon social y tipo de nomina; si no la tiene, el comparativo viene **ausente**, nunca en `0`. Una version sin lineas devuelve lista vacia y `total: 0`, no un error. */
  payroll_run_concept_totals: PayrollListPayrollRunConceptTotalsResult;
  /** Lee las lineas del recibo de una version de corrida. Filtra opcionalmente por empleado (`centralized_user_id`). Orden: (centralized_user_id, payroll_concept_id) asc, determinista para el drawer de detalle. Una version sin lineas devuelve lista vacia y `total: 0`, no un error: una corrida recien abierta legitimamente todavia no tiene lineas. */
  payroll_run_lines: PayrollListPayrollRunLinesResult;
};


export type PayrollRunLineQueryPayroll_Run_Concept_TotalsArgs = {
  input: PayrollListPayrollRunConceptTotalsInput;
};


export type PayrollRunLineQueryPayroll_Run_LinesArgs = {
  input: PayrollListPayrollRunLinesInput;
};

/** Una linea del recibo: un concepto de un empleado en una version de corrida. Los importes vienen con los 6 decimales con que se almacenan; el corte a 2 es del entregable (recibo / CFDI). */
export type PayrollRunLineSchema = {
  __typename?: 'PayrollRunLineSchema';
  /** Empleado (UUID) al que se le calculo la linea. */
  centralized_user_id: Scalars['ID']['output'];
  /** Regla que produjo el importe. Null en las lineas de total y en los conceptos sin regla. Es lo que permite decir con que formula se timbro un monto. */
  concept_rule_id?: Maybe<Scalars['ID']['output']>;
  /** Cuando se escribio. */
  created_at: Scalars['DateTime']['output'];
  /** Usuario que disparo el calculo. */
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Parte exenta. Separada del gravado porque el CFDI las declara aparte y el tope de exencion en UMA parte un mismo concepto en las dos columnas. Siempre 0 en las lineas `TOTAL`. */
  exempt_amount: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  /** Concepto del catalogo. La linea se identifica por el concepto; el nombre a mostrar es el del concepto, no se copia aca. */
  payroll_concept_id: Scalars['ID']['output'];
  /** Como afecta al recibo. `TOTAL` marca las tres lineas de sub-total y hay que excluirlo de cualquier suma. */
  payroll_impact: PayrollRunLineImpactEnum;
  /** Version de corrida a la que pertenece la linea. */
  payroll_run_version_id: Scalars['ID']['output'];
  /** Clave del concepto SAT, estampada desde el concepto. */
  sat_code?: Maybe<Scalars['String']['output']>;
  /** Parte gravada. En una linea `TOTAL` lleva el total, que ya viene reconciliado como suma de las lineas cortadas. */
  taxable_amount: Scalars['Decimal']['output'];
};

/** Una fila del listado del dashboard: una corrida con su tipo de nomina, su periodo, su estado, su avance y los totales de su version vigente. */
export type PayrollRunListItemSchema = {
  __typename?: 'PayrollRunListItemSchema';
  /** Cuando se abrio la corrida. */
  created_at: Scalars['DateTime']['output'];
  /** Corte del periodo, inclusive: el corte cierra el periodo. */
  cutoff_date: Scalars['Date']['output'];
  /** Colaboradores distintos con lineas en la version vigente. `0` cuando todavia no se calculo nada. */
  employees_count: Scalars['Int']['output'];
  /** Ultima ejecucion: el `calculated_at` de la version vigente. No es una columna de la corrida — recalcular abre version nueva, asi que la vigente **es** la ultima ejecucion. `null` mientras no se calculo. */
  executed_at?: Maybe<Scalars['DateTime']['output']>;
  /** Usuario que disparo la ultima ejecucion (`calculated_by` de la version vigente). `null` mientras no se calculo. */
  executed_by?: Maybe<Scalars['Int']['output']>;
  /** Ejercicio fiscal del periodo. */
  fiscal_year: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Razon social de la corrida. `null` en las corridas creadas por un cliente que todavia no manda el campo (PAYR-558/C-1); esas corridas no se pueden calcular. */
  legal_entity_id?: Maybe<Scalars['ID']['output']>;
  /** Fecha de pago. Es independiente del corte y puede caer despues. */
  payment_date: Scalars['Date']['output'];
  /** Tipo de nomina de la corrida. */
  payroll_type_id: Scalars['ID']['output'];
  /** Nombre del tipo de nomina, resuelto por join. Es lo que la tabla muestra; el id va aparte para navegar. */
  payroll_type_name: Scalars['String']['output'];
  /** Numero de periodo dentro del ejercicio fiscal. */
  period_number: Scalars['Int']['output'];
  /** Periodo del calendario sobre el que corre. */
  periodicity_period_id: Scalars['ID']['output'];
  /**
   * Porcentaje de los 5 pasos del wizard (pre-nomina, calculo, dispersion, timbrado, reportes) **probadamente terminados**. Valores legales: 0, 20, 40, 60, 80, 100 y `null`.
   *
   * 🔴 **PAYR-598 re-derivo esta tabla.** Con la maquina de estados vieja los dos ordenes estaban invertidos (timbraba antes de pagar) y este campo tenia que contar pasos sueltos; D-1 los alineo.
   *
   * `PENDIENTE` 0 · `PRE_NOMINA` 20 · `EN_CALCULO` 20 · `CALCULADO` 40 · `DISPERSADO` 60 · `CERRADO` 60 · `TIMBRADO` 80 · `CANCELADO` y `PAGADO` `null`.
   *
   * ⚠️ **Dos valores cambiaron respecto de la version anterior:** `CERRADO` pasa de `40` a `60` —bajo D-1 el cierre viene despues de la dispersion, asi que el paso 3 esta probado— y `PAGADO` pasa de `80` a `null`, porque salio de la secuencia.
   *
   * `CERRADO` comparte `60` con `DISPERSADO`: cerrar confirma la dispersion, no completa un paso propio. No se pierde informacion — `status` viaja en la misma fila.
   *
   * `100` corresponde a `finalizado`, que **no se publica** y que nada escribe todavia (cierre formal, PAYR-167). O sea: sigue sin alcanzarse en la practica, pero ya no por imposibilidad de la maquina.
   *
   * `null` para `CANCELADO`, y deliberadamente no `0`: una corrida cancelada no es una corrida al 0%.
   */
  progress?: Maybe<Scalars['Int']['output']>;
  /** Inicio del periodo, inclusive. */
  start_date: Scalars['Date']['output'];
  /** Estado de la corrida. */
  status: PayrollRunStatus;
  /** Suma de `NETO_A_PAGAR` de la version vigente. **`null` y no `0`** cuando la corrida no tiene lineas: un cero se lee como 'esta corrida no paga nada'. */
  total_net?: Maybe<Scalars['Decimal']['output']>;
};

export type PayrollRunMutation = {
  __typename?: 'PayrollRunMutation';
  /** Calcula la corrida abriendo una version nueva. Sirve al primer calculo, al re-calculo y al reproceso de una corrida cerrada; la version anterior se conserva. Falla si esta timbrada: ahi las correcciones van por incidencia a la corrida siguiente. */
  calculate_payroll_run: PayrollCalculatePayrollRunResult;
  /**
   * Calcula la pre-nomina del paso 1 (PAYR-510): el mismo motor y las mismas formulas, sobre el subconjunto de conceptos que no lee ni el snapshot fiscal ni el acumulado de periodos anteriores.
   *
   * **No es un estimado, es un parcial exacto.** El sueldo que devuelve es identico al de `calculate_payroll_run` — mismas formulas, mismo `days_base` congelado en la version, mismos `Decimal`.
   *
   * Abre una version `PRE_PAYROLL` con `is_current: false`; las incidencias del periodo **no** se marcan como consumidas.
   *
   * 🔴 Desde PAYR-598 mueve la corrida a `PRE_NOMINA`, y **solo hacia adelante**: la transicion ocurre desde `PENDIENTE` o `EN_PREPARACION`. Llamarla en cualquier otro estado —por ejemplo sobre una corrida ya calculada— sigue siendo valido y devuelve la vista previa **sin tocar el estado**: retroceder el stepper seria peor que no avanzarlo.
   *
   * 🔴 El subtotal que devuelve **no incluye ISR, subsidio al empleo ni cuotas IMSS**. Mostrarlo como el costo del periodo se equivoca por entre 20% y 30%; el payload trae `excluded_summary` ya escrito para que la etiqueta no pueda omitirlo.
   */
  calculate_pre_payroll: PayrollCalculatePrePayrollResult;
  /** Cancela la corrida. Terminal para esa corrida pero no para el periodo: despues se puede abrir otra sobre el mismo par. No se puede cancelar una corrida timbrada. */
  cancel_payroll_run: PayrollRunMutationResult;
  /**
   * Cierra la corrida. 🔴 **Es irreversible** (PAYR-598/D-2).
   *
   * Hasta PAYR-598 esta descripcion decia 'no es terminal: reprocesar es volver a llamar a `calculate_payroll_run`'. Ya no: la arista `cerrado -> en_calculo` se elimino. La unica ventana de correccion es recalcular desde `CALCULADO`, **antes** de dispersar.
   *
   * Dos precondiciones, y las dos devuelven `ValidationErrorResponse`:
   * 1. La corrida viene de `DISPERSADO`. Desde `CALCULADO` ya no se cierra: hay que generar el archivo bancario primero.
   * 2. `payments_confirmed: true` — la casilla 'todos los pagos ya fueron realizados' del modal del paso 3.
   */
  close_payroll_run: PayrollRunMutationResult;
  /** Abre una corrida para un tipo de nomina sobre un periodo. Falla si ya existe una corrida no cancelada para ese par. */
  create_payroll_run: PayrollRunMutationResult;
};


export type PayrollRunMutationCalculate_Payroll_RunArgs = {
  input: PayrollCalculatePayrollRunInput;
};


export type PayrollRunMutationCalculate_Pre_PayrollArgs = {
  input: PayrollCalculatePrePayrollInput;
};


export type PayrollRunMutationCancel_Payroll_RunArgs = {
  input: PayrollCancelPayrollRunInput;
};


export type PayrollRunMutationClose_Payroll_RunArgs = {
  input: PayrollClosePayrollRunInput;
};


export type PayrollRunMutationCreate_Payroll_RunArgs = {
  input: PayrollCreatePayrollRunInput;
};

export type PayrollRunMutationResult = InternalErrorResponse | PayrollRunResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Offset/limit pagination. */
export type PayrollRunPagination = {
  /** Corridas por pagina. Rango cerrado [1, 100]; fuera de rango es `ValidationErrorResponse`, no un valor recortado en silencio. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Corridas a saltear. Negativo es error de validacion. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PayrollRunQuery = {
  __typename?: 'PayrollRunQuery';
  /**
   * Las tarjetas resumen del periodo activo de la organizacion.
   *
   * El periodo activo se resuelve por **contencion de fechas** y no por `periodicity_period.status`: ese estado se persiste tal cual lo manda la API y ninguna maquina de estados lo hace avanzar, asi que puede estar rancio.
   *
   * Sin periodo activo —hoy cae en un hueco del calendario, o el calendario no esta sembrado— no hay error: los campos de identidad salen `null` y `collaborators_count` sale `0`, pero `next_closure_date` **se calcula igual**.
   *
   * 🔴 `collaborators_count` **no es headcount** y `estimated_amount` es hoy **siempre `null`** (depende de PAYR-510, y nunca se sustituye por el neto calculado). Ver las descripciones de esos dos campos.
   */
  get_payroll_period_summary: PayrollGetPayrollPeriodSummaryResult;
  /** Lee una corrida con su historial de versiones, de la mas reciente a la mas antigua. La version vigente es la que tiene `is_current`. */
  get_payroll_run: PayrollGetPayrollRunResult;
  /**
   * Lista las corridas de la organizacion para el dashboard: una fila plana por corrida con su tipo de nomina, periodo, estado, avance, conteo de empleados, neto y auditoria de ejecucion, mas el `total` del universo completo del tab.
   *
   * Los filtros de alcance son opcionales: **omitir `legal_entity_id` devuelve todas las razones sociales, incluidas las corridas cuyo `legal_entity_id` es `null`** — que durante la transicion de PAYR-558 son las que crea el front desplegado. Un id de otra organizacion devuelve una pagina vacia, no un error.
   *
   * `cfdi_classification` acota a las corridas cuyo tipo de nomina tiene esa clasificacion: es el filtro de las pestanas Ordinarias / Extraordinarias. El payload trae ademas `ordinaria_count` y `extraordinaria_count`, los dos numeros de las pestanas, calculados sobre el universo que dejan los demas filtros **ignorando la clasificacion y la paginacion** — asi elegir una pestana no pone la otra en `0`. `payroll_type_id` de un tipo ordinario junto con `cfdi_classification: EXTRAORDINARIA` es una interseccion vacia: pagina vacia con `total: 0` y sin error.
   *
   * ⚠️ El tab `COMPLETED` viene vacio hoy y siempre: ninguna mutation de este subgraph escribe `timbrado` ni `pagado`. Y `EXTRAORDINARIA` viene vacio hasta que un cliente pueda crear una corrida extraordinaria (PAYR-644, hallazgo H2 de PAYR-627).
   *
   * ⚠️ Las filas y sus agregados salen de sentencias distintas, asi que una corrida que esta terminando de calcular puede aparecer con `status: CALCULADO` y `employees_count: 0`. Aceptable para un dashboard; la alternativa cuesta mas que la anomalia.
   */
  list_payroll_runs: PayrollListPayrollRunsResult;
  /** Resuelve los datos de contrato del alcance de la corrida y devuelve quien se puede calcular y quien no, con el campo que falta y el motivo. **No persiste nada y no transiciona la corrida**: es el paso previo al calculo, para excluir a los que les falta un dato en vez de recibir una corrida vacia sin explicacion. */
  validate_payroll_run_employees: PayrollValidatePayrollRunEmployeesResult;
};


export type PayrollRunQueryGet_Payroll_Period_SummaryArgs = {
  input: PayrollGetPayrollPeriodSummaryInput;
};


export type PayrollRunQueryGet_Payroll_RunArgs = {
  input: PayrollGetPayrollRunInput;
};


export type PayrollRunQueryList_Payroll_RunsArgs = {
  input: PayrollListPayrollRunsInput;
};


export type PayrollRunQueryValidate_Payroll_Run_EmployeesArgs = {
  input: PayrollValidatePayrollRunEmployeesInput;
};

/** Single-entity wrapper para el ciclo de vida de la corrida. */
export type PayrollRunResponse = {
  __typename?: 'PayrollRunResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: PayrollRunSchema;
};

/** Una corrida de nomina: una razon social y un tipo de nomina sobre un periodo. Los resultados viven en sus versiones, no aca. */
export type PayrollRunSchema = {
  __typename?: 'PayrollRunSchema';
  centralized_organization_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Razon social (legal entity) de la corrida. `null` en las corridas creadas antes de PAYR-558 o por un cliente que todavia no manda el campo; esas corridas no se pueden calcular. Vuelve a ser obligatorio en PAYR-599. */
  legal_entity_id?: Maybe<Scalars['ID']['output']>;
  payroll_type_id: Scalars['ID']['output'];
  periodicity_period_id: Scalars['ID']['output'];
  status: PayrollRunStatus;
  updated_at: Scalars['DateTime']['output'];
};

/**
 * Estado de una corrida de nomina (PAYR-598). `activo` no aparece: es un concepto de periodo ('el periodo vigente'), no de corrida.
 *
 * **La secuencia del wizard**, en orden:
 * `PENDIENTE` -> `PRE_NOMINA` -> `EN_CALCULO` -> `CALCULADO` -> `DISPERSADO` -> `CERRADO` -> `TIMBRADO`. Se paga **antes** de timbrar.
 *
 * `CANCELADO` sale de la secuencia y es alcanzable hasta `CALCULADO` inclusive; despues de dispersar ya no, porque el dinero salio.
 *
 * **Quien escribe cada uno hoy:**
 * - `PENDIENTE`: `create_payroll_run`.
 * - `PRE_NOMINA`: `calculate_pre_payroll`, y **solo hacia adelante** — disparar la pre-nomina sobre una corrida ya calculada devuelve su vista previa sin mover el estado.
 * - `EN_CALCULO` / `CALCULADO`: `calculate_payroll_run`.
 * - `DISPERSADO`: `generate_payroll_run_dispersion_file`, y **solo si los dos lotes se generaron**. Un lote fallido deja la corrida en `CALCULADO`.
 * - `CERRADO`: `close_payroll_run`, que exige `payments_confirmed: true` y que la corrida venga de `DISPERSADO`. 🔴 **Es irreversible**: la unica ventana de correccion es recalcular desde `CALCULADO`.
 * - `CANCELADO`: `cancel_payroll_run`.
 *
 * ⚠️ **`TIMBRADO` y `PAGADO` estan publicados y nada los escribe.** `TIMBRADO` lo escribira la epica de timbrado (PAYR-450); filtrar por el devuelve lista vacia hasta entonces. `PAGADO` esta **fuera de la secuencia** desde PAYR-598 —su lugar lo tomo `DISPERSADO`— y no tiene transiciones de entrada ni de salida: no lo uses para nada nuevo. Los dos se conservan porque quitar un miembro de un enum federado ya desplegado es un breaking change.
 *
 * El dominio tiene tres estados mas —`en_preparacion`, `por_calcular` y `finalizado`— que **no** se publican: ninguna operacion los escribe todavia (`finalizado` es del cierre formal, PAYR-167). Mandarlos en un filtro es un error de esquema, no una pagina vacia.
 */
export enum PayrollRunStatus {
  Calculado = 'CALCULADO',
  Cancelado = 'CANCELADO',
  Cerrado = 'CERRADO',
  Dispersado = 'DISPERSADO',
  EnCalculo = 'EN_CALCULO',
  Pagado = 'PAGADO',
  Pendiente = 'PENDIENTE',
  PreNomina = 'PRE_NOMINA',
  Timbrado = 'TIMBRADO'
}

/**
 * Tab del listado de corridas del dashboard (PAYR-506, re-definido en PAYR-598).
 *
 * `PENDING` = `PENDIENTE`, `PRE_NOMINA`, `EN_CALCULO`, `CALCULADO`, mas `en_preparacion` y `por_calcular`, que el dominio define y nadie escribe. `COMPLETED` = `DISPERSADO`, `CERRADO`, `TIMBRADO`, mas `finalizado`, en la misma situacion (lo escribira el cierre formal, PAYR-167).
 *
 * `CANCELADO` y `PAGADO` no aparecen en ninguno de los dos: para la primera el diseno no tiene tag, y la segunda salio de la maquina de estados.
 *
 * 🔴 **Cambio respecto de la version anterior: `CERRADO` se mudo de `PENDING` a `COMPLETED`.** Antes caia en `PENDING` porque la maquina decia que una corrida cerrada todavia podia recalcularse; con PAYR-598/D-2 el cierre es irreversible, asi que ya no admite trabajo del operador en el dashboard.
 *
 * ⚠️ **`COMPLETED` ya no viene vacio.** Lo estaba mientras solo contuviera `TIMBRADO` y `PAGADO`, que nada escribe. Ahora contiene `DISPERSADO` —lo escribe la generacion del archivo bancario— y `CERRADO`.
 */
export enum PayrollRunTab {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

/** Una version de resultados de una corrida. Recalcular agrega una version y conserva las anteriores: es lo que hace auditable un timbrado. */
export type PayrollRunVersionSchema = {
  __typename?: 'PayrollRunVersionSchema';
  calculated_at?: Maybe<Scalars['DateTime']['output']>;
  calculated_by?: Maybe<Scalars['Int']['output']>;
  /**
   * Que se calculo en esta version: `FULL` la corrida completa, `PRE_PAYROLL` la pre-nomina del paso 1 (PAYR-510).
   *
   * 🔴 Es obligatorio mirarlo antes de elegir una version para la boleta, la dispersion o el timbrado. Una `PRE_PAYROLL` no incluye ISR, subsidio ni cuotas IMSS, y llega con `is_current: false` justamente para que ningun consumidor la tome por accidente.
   *
   * Las versiones anteriores a PAYR-510 son todas `FULL`: el default de la columna es una afirmacion verdadera sobre cada una de ellas.
   */
  calculation_scope: PayrollRunVersionScope;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_current: Scalars['Boolean']['output'];
  /**
   * Estado de **esta version**, no de la corrida.
   *
   * 🔴 Reusa `PayrollRunStatus`, que publica 9 miembros, pero una version solo transita `EN_CALCULO -> CALCULADO`: son los **unicos dos alcanzables** aca. Los otros siete describen el ciclo de vida de la corrida y nunca aparecen en este campo. En particular, una version de una corrida en `PRE_NOMINA` sale `CALCULADO` cuando su calculo termina, no `PRE_NOMINA` — para saber que es una pre-nomina, mira `calculation_scope`.
   *
   * Un `PayrollRunVersionStatus` propio de dos miembros seria mas honesto y esta registrado como pendiente (PAYR-598 §9.1): cambiar el tipo de un campo federado ya desplegado exige agregarlo de forma aditiva y deprecar el viejo, asi que no entra en este ticket.
   */
  status: PayrollRunStatus;
  version: Scalars['Int']['output'];
};

/**
 * Que se calculo en una version de corrida (PAYR-510).
 *
 * `FULL` es la corrida completa. `PRE_PAYROLL` es la pre-nomina del paso 1: **el mismo motor y las mismas formulas**, sobre el subconjunto de conceptos que no lee ni el snapshot fiscal ni el acumulado de periodos anteriores. No es un estimado; es un parcial exacto, y por eso el sueldo que muestra es identico al de la corrida completa.
 *
 * 🔴 Una version `PRE_PAYROLL` **nunca** es el resultado vigente de la corrida: se abre con `is_current: false` y no baja a la vigente. Su subtotal no incluye ISR, subsidio ni cuotas IMSS, asi que leerlo como el neto seria un error de entre 20% y 30%.
 */
export enum PayrollRunVersionScope {
  Full = 'FULL',
  PrePayroll = 'PRE_PAYROLL'
}

/** SAT c_PeriodicidadPago codes. */
export enum PayrollSatPeriodicityCode {
  Bimestral = 'BIMESTRAL',
  Catorcenal = 'CATORCENAL',
  Diario = 'DIARIO',
  Mensual = 'MENSUAL',
  Otra = 'OTRA',
  Quincenal = 'QUINCENAL',
  Semanal = 'SEMANAL'
}

/** SDI calculation result (no persistence). */
export type PayrollSdiCalculationPayload = {
  __typename?: 'PayrollSdiCalculationPayload';
  graphql_operation_id: Scalars['ID']['output'];
  integration_factor: Scalars['Decimal']['output'];
  min_wage_applied: Scalars['Decimal']['output'];
  sbc_cap_applied: Scalars['Decimal']['output'];
  sdi: Scalars['Decimal']['output'];
  sdi_capped: Scalars['Decimal']['output'];
  vacation_days: Scalars['Int']['output'];
  warnings: Array<Scalars['String']['output']>;
};

/** Input to seed the official 2026 employment subsidy table for an organization (internal admin only). Both brackets come from the constant verbatim (0.01-11492.66 = 536.22, 11492.66-open = 0.00) and the table is created already active. Idempotent: if a table already exists for (org, 2026, monthly) it is returned untouched, whatever its state. */
export type PayrollSeedEmploymentSubsidyTableInput = {
  /** Centralized organization ID to seed. */
  centralized_organization_id: Scalars['ID']['input'];
};

export type PayrollSeedEmploymentSubsidyTableResult = EmploymentSubsidyTableResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type PayrollSeedImssRateResult = ImssRateResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input to seed the official 2026 INFONAVIT discount factor for an organization. Idempotent: if the 2026 record already exists, returns it without creating a duplicate. */
export type PayrollSeedInfonavitDiscountFactorInput = {
  /** Centralized organization ID to seed. */
  centralized_organization_id: Scalars['ID']['input'];
};

export type PayrollSeedInfonavitDiscountFactorResult = InfonavitDiscountFactorResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type PayrollSeedIsnRateResult = InternalErrorResponse | IsnRateResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input to seed an official 2026 ISR tariff for an organization (internal admin only). The 11 brackets come from the constant verbatim and the table is created already active. Idempotent: if a table already exists for (org, 2026, period_type) it is returned untouched, whatever its state. */
export type PayrollSeedIsrTableInput = {
  /** Centralized organization ID to seed. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Which published tariff to seed. Defaults to MONTHLY, the tariff every fiscal year needs — the last-fortnight adjustment uses it even when the run is biweekly, so it is never a substitution. A biweekly run needs BOTH: seed this twice, once per period type. Only MONTHLY and BIWEEKLY have a transcribed 2026 tariff; the others return a validation error naming what is seedable. */
  period_type?: PayrollIsrPeriodTypeEnum;
};

export type PayrollSeedIsrTableResult = InternalErrorResponse | IsrTableResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Seed the 2026 parameter set for a legal entity. */
export type PayrollSeedPayrollParametersInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Legal entity to seed. */
  legal_entity_id: Scalars['ID']['input'];
};

export type PayrollSeedPayrollParametersResult = InternalErrorResponse | PayrollParametersResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Siembra el catalogo estandar de conceptos en una organizacion. Requiere `PlatformAdmin`: es el arranque del onboarding, no una accion del cliente. Idempotente — volver a correrlo actualiza los conceptos, no pisa las formulas ya corregidas y respeta el `is_active` que el cliente haya movido. */
export type PayrollSeedStandardConceptsInput = {
  /** Organizacion donde se siembra el catalogo. */
  centralized_organization_id: Scalars['ID']['input'];
};

/** Resultado de seed_standard_concepts. Los conceptos sin formula se siembran igual: existen en el catalogo con su tratamiento fiscal y no calculan hasta que alguien los formule. */
export type PayrollSeedStandardConceptsPayload = {
  __typename?: 'PayrollSeedStandardConceptsPayload';
  created_count: Scalars['Int']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  rules_created_count: Scalars['Int']['output'];
  updated_count: Scalars['Int']['output'];
  without_formula_count: Scalars['Int']['output'];
};

export type PayrollSeedStandardConceptsResult = InternalErrorResponse | PayrollSeedStandardConceptsPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/** Define el paquete de conceptos de un tipo de nomina. Requiere `PlatformAdmin`: es configuracion de implementacion, no del cliente. La lista es el **estado deseado completo** — los conceptos que no vienen se desasignan. Idempotente. Mandarla vacia es valido y deja al tipo de nomina sin conceptos que calcular. */
export type PayrollSetConceptAssignmentsInput = {
  /** Estado deseado completo del paquete. */
  assignments: Array<PayrollConceptAssignmentItemInput>;
  /** Organizacion duena del tipo de nomina y de los conceptos. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Tipo de nomina cuyo paquete se define. */
  payroll_type_id: Scalars['ID']['input'];
};

/** Prende o apaga un concepto. Es la unica escritura del admin del cliente sobre el catalogo, y por eso acepta solo el id y el booleano: una mutation generica con campos opcionales le abriria la formulacion. Un concepto obligatorio por ley no se puede apagar. */
export type PayrollSetPayrollConceptActiveInput = {
  /** Organizacion duena del concepto. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Estado deseado. */
  is_active: Scalars['Boolean']['input'];
  /** Concepto a prender o apagar. */
  payroll_concept_id: Scalars['ID']['input'];
};

/** Sort direction for list queries. */
export enum PayrollSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Operacion que se le pidio a Terra IDSE. El alta del usuario se dispara al crear el registro patronal y la inhabilitacion al desactivarlo o borrarlo; las de certificado, al cargar o cambiar la e.firma y al retirar el registro patronal. Las de usuario aparecen en `last_terra_attempt` y las de certificado en `last_certificate_attempt`. */
export enum PayrollTerraIdseOperationEnum {
  CreateUser = 'CREATE_USER',
  DeleteCertificate = 'DELETE_CERTIFICATE',
  DisableUser = 'DISABLE_USER',
  RegisterCertificate = 'REGISTER_CERTIFICATE',
  UpdateCertificate = 'UPDATE_CERTIFICATE'
}

/** En que termino el intento. El codigo numerico que Terra devuelve no llega hasta aqui: lo traduce el servicio de contrato, que es quien habla con el proveedor. Lo que se expone es la familia del resultado, que es lo que determina que puede hacer quien opera. */
export enum PayrollTerraIdseOutcomeEnum {
  PermissionDenied = 'PERMISSION_DENIED',
  Rejected = 'REJECTED',
  ServiceError = 'SERVICE_ERROR',
  Succeeded = 'SUCCEEDED',
  Unavailable = 'UNAVAILABLE'
}

export type PayrollTypeMutation = {
  __typename?: 'PayrollTypeMutation';
  /** Create a new payroll type for the organization. */
  create_payroll_type: PayrollCreatePayrollTypeResult;
  /** Deactivate a payroll type (soft state change). */
  deactivate_payroll_type: PayrollDeactivatePayrollTypeResult;
  /** Update an existing payroll type (patch). */
  update_payroll_type: PayrollUpdatePayrollTypeResult;
};


export type PayrollTypeMutationCreate_Payroll_TypeArgs = {
  input: PayrollCreatePayrollTypeInput;
};


export type PayrollTypeMutationDeactivate_Payroll_TypeArgs = {
  input: PayrollDeactivatePayrollTypeInput;
};


export type PayrollTypeMutationUpdate_Payroll_TypeArgs = {
  input: PayrollUpdatePayrollTypeInput;
};

export type PayrollTypeQuery = {
  __typename?: 'PayrollTypeQuery';
  /** Fetch a single payroll type by id. */
  get_payroll_type: PayrollGetPayrollTypeResult;
  /** List payroll types for an organization. */
  list_payroll_types: PayrollListPayrollTypesResult;
};


export type PayrollTypeQueryGet_Payroll_TypeArgs = {
  input: PayrollGetPayrollTypeInput;
};


export type PayrollTypeQueryList_Payroll_TypesArgs = {
  input: PayrollListPayrollTypesInput;
};

/** Single-entity payload wrapper. */
export type PayrollTypeResponse = {
  __typename?: 'PayrollTypeResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: PayrollTypeSchema;
};

/** A payroll type (tipo de nomina) of an organization. */
export type PayrollTypeSchema = {
  __typename?: 'PayrollTypeSchema';
  active: Scalars['Boolean']['output'];
  can_edit_cfdi: Scalars['Boolean']['output'];
  centralized_organization_id: Scalars['ID']['output'];
  cfdi_classification: PayrollCfdiClassification;
  contract_type: PayrollContractType;
  created_at: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  /** Days base used to prorate the monthly ISR tariff (30 or 30.4). Exposed for read so the configured value can be verified against the amounts of a run. */
  days_base: Scalars['Decimal']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_base: Scalars['Boolean']['output'];
  last_run_at?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  periodicity_code: PayrollPeriodicityCode;
  sat_code: Scalars['String']['output'];
  tax_regime_code: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

/** Edita una regla de calculo. Requiere `PlatformAdmin`. El concepto al que pertenece no se puede cambiar: mover una regla de concepto es darla de baja y crear otra. */
export type PayrollUpdateConceptRuleInput = {
  /** Organizacion duena del concepto. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Regla a editar. */
  concept_rule_id: Scalars['ID']['input'];
  /** Arbol de la formula. */
  expression?: InputMaybe<Scalars['JSON']['input']>;
  /** Desempata entre reglas del mismo concepto. */
  priority?: Scalars['Int']['input'];
  /** FORMULA / TABLE_LOOKUP / FIXED / MANUAL_INPUT. */
  rule_type: PayrollConceptRuleType;
  /** Inicio de vigencia. */
  valid_from?: InputMaybe<Scalars['Date']['input']>;
  /** Fin de vigencia. */
  valid_to?: InputMaybe<Scalars['Date']['input']>;
};

/** Input to update an existing employment subsidy table (internal admin only). All fields are optional; only provided fields are updated. Providing brackets replaces the entire set. */
export type PayrollUpdateEmploymentSubsidyTableInput = {
  /** New full set of brackets, if provided (replaces existing). */
  brackets?: InputMaybe<Array<PayrollEmploymentSubsidyBracketInput>>;
  /** Centralized organization ID for org isolation. */
  centralized_organization_id: Scalars['ID']['input'];
  /** UUID of the employment subsidy table to update. */
  id: Scalars['ID']['input'];
  /** New source reference, if provided. */
  source_reference?: InputMaybe<Scalars['String']['input']>;
  /** New validity date, if provided. */
  valid_from?: InputMaybe<Scalars['Date']['input']>;
};

export type PayrollUpdateEmploymentSubsidyTableResult = EmploymentSubsidyTableResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input to update a single IMSS branch rate. Returns NotFoundErrorResponse if the branch does not exist. */
export type PayrollUpdateImssRateBranchInput = {
  /** Updated branch rate data. */
  branch: PayrollImssRateBranchInput;
  /** UUID of the ImssRateBranch record to update. */
  id: Scalars['ID']['input'];
};

export type PayrollUpdateImssRateBranchResult = ImssRateBranchResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type PayrollUpdateIncidenceInput = {
  /** Amount. Required for FONACOT, which no longer accepts a percentage. */
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  /** SAVINGS/PENSION: beneficiary reference. */
  beneficiary_ref?: InputMaybe<Scalars['String']['input']>;
  /** RECURRING/OTHER: concept. */
  concept?: InputMaybe<Scalars['String']['input']>;
  /** INFONAVIT/FONACOT: credit number. Exactly 10 characters for INFONAVIT; FONACOT uses a different format and is not length-checked. */
  credit_number?: InputMaybe<Scalars['String']['input']>;
  /** DISABILITY: days. */
  days?: InputMaybe<Scalars['Int']['input']>;
  /** Optional free-text note (max 500 chars), any incidence type. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Type-specific extra data. */
  details?: InputMaybe<Scalars['JSON']['input']>;
  /** DISABILITY: WORK_RISK, GENERAL_ILLNESS, MATERNITY or COMMUTING_RISK. */
  disability_type?: InputMaybe<Scalars['String']['input']>;
  /** New end date. */
  end_date?: InputMaybe<Scalars['Date']['input']>;
  /** DISABILITY: IMSS folio (exactly 8 characters). */
  imss_folio?: InputMaybe<Scalars['String']['input']>;
  /** Id of the incidence to edit (must be MANUAL + PENDING). */
  incidence_id: Scalars['UUID']['input'];
  /** RECURRING/OTHER: perception or deduction. */
  is_perception?: InputMaybe<Scalars['Boolean']['input']>;
  /** Percentage 0-100. Not accepted for FONACOT. */
  percentage?: InputMaybe<Scalars['Decimal']['input']>;
  /** New start date. */
  start_date?: InputMaybe<Scalars['Date']['input']>;
  /** ABSENTEEISM: subtype. */
  subtype?: InputMaybe<Scalars['String']['input']>;
  /** OVERTIME: total hours. */
  total_hours?: InputMaybe<Scalars['Decimal']['input']>;
  /** ABSENTEEISM: with pay. */
  with_pay?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input to update an existing INFONAVIT discount factor record (internal admin only). All factor fields are optional; only provided fields will be updated. */
export type PayrollUpdateInfonavitDiscountFactorInput = {
  /** Centralized organization ID for org isolation. */
  centralized_organization_id: Scalars['ID']['input'];
  /** New bimonthly housing damage insurance fee in MXN. Must be greater than or equal to zero if provided. Omitting it leaves the stored value untouched. */
  damage_insurance_bimonthly?: InputMaybe<Scalars['Decimal']['input']>;
  /** New discount factor. Must be greater than zero if provided. */
  discount_factor?: InputMaybe<Scalars['Decimal']['input']>;
  /** New fixed monthly fee in MXN. Must be greater than or equal to zero if provided. */
  fixed_monthly_fee?: InputMaybe<Scalars['Decimal']['input']>;
  /** UUID of the INFONAVIT discount factor record to update. */
  id: Scalars['ID']['input'];
  /** New Unidad Mixta INFONAVIT (UMI). Must be greater than zero if provided. Omitting it leaves the stored value untouched. */
  mixed_unit_value?: InputMaybe<Scalars['Decimal']['input']>;
  /** New percentage on SBC. Must be between 0 and 100 if provided. */
  sbc_percentage?: InputMaybe<Scalars['Decimal']['input']>;
};

export type PayrollUpdateInfonavitDiscountFactorResult = InfonavitDiscountFactorResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input to update a single ISN state rate. Returns NotFoundErrorResponse if the state does not exist. */
export type PayrollUpdateIsnRateStateInput = {
  /** UUID of the IsnRateState record to update. */
  id: Scalars['ID']['input'];
  /** Updated state rate data. */
  state: PayrollIsnRateStateInput;
};

export type PayrollUpdateIsnRateStateResult = InternalErrorResponse | IsnRateStateResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input to update an existing ISR table (internal admin only). All fields are optional; only provided fields are updated. Providing brackets replaces the entire set. */
export type PayrollUpdateIsrTableInput = {
  /** New full set of brackets, if provided (replaces existing). */
  brackets?: InputMaybe<Array<PayrollIsrBracketInput>>;
  /** Centralized organization ID for org isolation. */
  centralized_organization_id: Scalars['ID']['input'];
  /** UUID of the ISR table to update. */
  id: Scalars['ID']['input'];
  /** New source reference, if provided. */
  source_reference?: InputMaybe<Scalars['String']['input']>;
  /** New validity date, if provided. */
  valid_from?: InputMaybe<Scalars['Date']['input']>;
};

export type PayrollUpdateIsrTableResult = InternalErrorResponse | IsrTableResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Correccion puntual de un concepto ya cargado. Requiere `PlatformAdmin`. Reemplaza el conjunto completo de campos escribibles: la pantalla carga el concepto y devuelve todos sus valores. `code` e `is_mandatory` no se aceptan (el codigo es la identidad y `is_mandatory` se deriva de la lista de ley), y `is_active` tampoco: lo mueve el admin del cliente por `set_payroll_concept_active`. */
export type PayrollUpdatePayrollConceptInput = {
  /** El concepto integra el SBC para IMSS. */
  applies_to_imss?: Scalars['Boolean']['input'];
  /** El concepto integra la base del ISN estatal. */
  applies_to_isn?: Scalars['Boolean']['input'];
  /** El concepto integra la base de ISR. */
  applies_to_isr?: Scalars['Boolean']['input'];
  /** Magnitud sobre la que se aplica el concepto. */
  calc_base?: PayrollConceptCalcBase;
  /** Orden de calculo heredado. El motor deriva el orden real de las referencias entre conceptos, no de este numero. */
  calc_order?: Scalars['Int']['input'];
  /** Organizacion duena del concepto. */
  centralized_organization_id: Scalars['ID']['input'];
  /** PERCEPTION / DEDUCTION / INFORMATIONAL. */
  concept_type: PayrollConceptTypeEnum;
  /** Sustento legal, p. ej. `LFT Art. 87 · LISR Art. 93 frac. XIV`. Auditoria: no entra al calculo. */
  legal_basis?: InputMaybe<Scalars['String']['input']>;
  /** Nombre visible del concepto. */
  name: Scalars['String']['input'];
  /** Concepto a corregir. */
  payroll_concept_id: Scalars['ID']['input'];
  /** Clave del catalogo del SAT para el CFDI. */
  sat_code?: InputMaybe<Scalars['String']['input']>;
  /** Tope de exencion expresado en UMA. */
  tax_exemption_cap_uma?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Update an existing payroll parameter set (UMA/SMG/caps). Only provided fields are applied; the rest keep their current value. Internal Crehana admin only. */
export type PayrollUpdatePayrollParametersInput = {
  /** Centralized organization id that owns the set. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Id of the parameter set to update. */
  id: Scalars['ID']['input'];
  /** INFONAVIT cap (must be > 0). */
  infonavit_cap?: InputMaybe<Scalars['Decimal']['input']>;
  /** Minimum integration factor (must be >= 1.0000). */
  integration_factor_min?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal entity that owns the set. */
  legal_entity_id: Scalars['ID']['input'];
  /** General minimum wage (must be > 0). */
  min_wage_general?: InputMaybe<Scalars['Decimal']['input']>;
  /** Northern border zone minimum wage (must be > 0). */
  min_wage_zlfn?: InputMaybe<Scalars['Decimal']['input']>;
  /** SBC cap (must be > 0). */
  sbc_cap?: InputMaybe<Scalars['Decimal']['input']>;
  /** Official source reference (DOF, etc.). */
  source_reference?: InputMaybe<Scalars['String']['input']>;
  /** Annual UMA (must be > 0). */
  uma_annual?: InputMaybe<Scalars['Decimal']['input']>;
  /** Daily UMA (must be > 0). */
  uma_daily?: InputMaybe<Scalars['Decimal']['input']>;
  /** Monthly UMA (must be > 0). */
  uma_monthly?: InputMaybe<Scalars['Decimal']['input']>;
  /** New start date of validity. */
  valid_from?: InputMaybe<Scalars['Date']['input']>;
};

export type PayrollUpdatePayrollParametersResult = InternalErrorResponse | PayrollParametersNotFoundResponse | PayrollParametersResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Update an existing payroll type (patch semantics). */
export type PayrollUpdatePayrollTypeInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** New CFDI classification (rejected for base types). */
  cfdi_classification?: InputMaybe<PayrollCfdiClassification>;
  /** New contract type. */
  contract_type?: InputMaybe<PayrollContractType>;
  /** New currency (ISO-4217). */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** New days base for the ISR proration. Only 30 or 30.4 are accepted; any other value is rejected, not rounded. Omitting it leaves the current value untouched. */
  days_base?: InputMaybe<Scalars['Decimal']['input']>;
  /** New description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** New name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Id of the payroll type to update. */
  payroll_type_id: Scalars['ID']['input'];
  /** New periodicity. */
  periodicity_code?: InputMaybe<PayrollPeriodicityCode>;
  /** New SAT code (rejected for base types). */
  sat_code?: InputMaybe<Scalars['String']['input']>;
  /** New tax regime code. */
  tax_regime_code?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollUpdatePayrollTypeResult = InternalErrorResponse | PayrollTypeResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Actualiza una periodicidad. Los campos omitidos no se modifican. `sat_code` no es editable: cambiarlo convertiria la periodicidad en otra distinta arrastrando su calendario y sus asociaciones. */
export type PayrollUpdatePeriodicityInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Nueva descripcion. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Nuevo nombre. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Nuevos dias por periodo. Se revalida contra `sat_code`. */
  period_days?: InputMaybe<Scalars['Int']['input']>;
  /** Id de la periodicidad a actualizar. */
  periodicity_id: Scalars['ID']['input'];
};

/** Correccion puntual de un periodo. Los campos omitidos no se modifican. `periodicity_id`, `fiscal_year` y `period_number` no son editables: son la identidad del periodo y lo que apuntan las incidencias. */
export type PayrollUpdatePeriodicityPeriodInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Nueva fecha de corte. */
  cutoff_date?: InputMaybe<Scalars['Date']['input']>;
  /** Nueva fecha de pago. */
  payment_date?: InputMaybe<Scalars['Date']['input']>;
  /** Id del periodo a corregir. */
  period_id: Scalars['ID']['input'];
  /** Nuevo inicio. */
  start_date?: InputMaybe<Scalars['Date']['input']>;
  /** Nuevo estado. */
  status?: InputMaybe<PayrollPeriodStatus>;
};

/** Valida a quien se puede calcular en el alcance de la corrida, sin calcular ni persistir nada. Lleva el mismo embudo opcional que `calculate_payroll_run` —registro patronal, centro de trabajo, empleados—: los filtros acotan la poblacion de verdad, asi que una validacion que no los recibiera reportaria como calculables a empleados que el calculo posterior va a descartar. */
export type PayrollValidatePayrollRunEmployeesInput = {
  /** Centralized organization id of the caller. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Empleados (id entero) a validar. Omitir = todos los empleados activos de la razon social, acotados por los filtros de registro patronal y centro de trabajo que se hayan pasado. */
  centralized_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filtra por registro patronal (employer registration). No define la corrida: solo acota a quien se validaria. Omitir = toda la razon social de la corrida. Si no pertenece a esa razon social, la consulta falla en vez de validar otra poblacion. */
  employer_registration_id?: InputMaybe<Scalars['ID']['input']>;
  /** Corrida cuyo alcance se valida. Su `legal_entity_id` define el alcance y su periodo fija la fecha de corte con la que se derivan antiguedad y dias de vacaciones. */
  payroll_run_id: Scalars['ID']['input'];
  /** Filtra por centro de trabajo (work location). No define la corrida: solo acota a quien se validaria. Omitir = toda la razon social de la corrida. Si no pertenece a esa razon social, o no cuelga del registro patronal que se paso, la consulta falla. */
  work_location_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Resultado de validate_payroll_run_employees: quien se puede calcular y quien no, con el campo que falta. No se creo ninguna fila ni cambio el estado de la corrida. */
export type PayrollValidatePayrollRunEmployeesPayload = {
  __typename?: 'PayrollValidatePayrollRunEmployeesPayload';
  /** Empleados listos para calcular. Es la lista que va como `centralized_user_ids` de `calculate_payroll_run` para excluir al resto. */
  calculable: Array<Scalars['ID']['output']>;
  /** Cuantos empleados tienen todos sus insumos de contrato. */
  calculable_count: Scalars['Int']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  /** Empleados que no se pueden calcular, con el dato que falta y el motivo. Es la tabla de validacion del stepper (PAYR-330). */
  not_calculable: Array<PayrollEmployeeCalculationErrorSchema>;
  /** Cuantos quedarian afuera si se calculara ahora. */
  not_calculable_count: Scalars['Int']['output'];
  /** La corrida tal como quedo: la validacion no la transiciona. */
  run: PayrollRunSchema;
};

export type PayrollValidatePayrollRunEmployeesResult = InternalErrorResponse | PayrollValidatePayrollRunEmployeesPayload | UserPermissionErrorResponse | ValidationErrorResponse;

/** Impacto de la variable en el recibo de nomina. */
export enum PayrollVariableImpactEnum {
  Base = 'BASE',
  Deduction = 'DEDUCTION',
  Earning = 'EARNING',
  EmployerCost = 'EMPLOYER_COST',
  Informative = 'INFORMATIVE',
  OtherPayment = 'OTHER_PAYMENT'
}

/** Tipo de valor de una variable de nomina calculada. */
export enum PayrollVariableValueTypeEnum {
  Boolean = 'BOOLEAN',
  Days = 'DAYS',
  Factor = 'FACTOR',
  Money = 'MONEY',
  Percentage = 'PERCENTAGE',
  Quantity = 'QUANTITY'
}

/** Type of work center location for employer registration. */
export enum PayrollWorkCenterLocationType {
  BranchAddress = 'BRANCH_ADDRESS',
  FiscalAddress = 'FISCAL_ADDRESS'
}

export type PayrollWorkLocationInput = {
  headquarter_id: Scalars['ID']['input'];
};

export type PdfReport = {
  __typename?: 'PdfReport';
  absolute_url?: Maybe<Scalars['String']['output']>;
};

export type PdfReportResponse = PdfReport | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

/** Tipo de pensión IMSS. */
export enum PensionTypeEnum {
  CesantiaVejez = 'CESANTIA_VEJEZ',
  InvalidezVida = 'INVALIDEZ_VIDA',
  SinPension = 'SIN_PENSION'
}

export type PerceptionFeedback = {
  __typename?: 'PerceptionFeedback';
  percentage_acceptable: Scalars['String']['output'];
  percentage_excellent: Scalars['String']['output'];
  percentage_unsatisfactory: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

/** Filters for the performance average results by group query (Promedio de Resultados chart). Exactly one performance mode must be supplied: Dynamic (performance_period_id), Flex (competences_evaluation_id + goals_evaluation_id), or Basic (neither). */
export type PerformanceAverageResultsByGroupInput = {
  /** Talent company id. */
  company_id: Scalars['Int']['input'];
  /** Flex performance: competence evaluation id (mapped to '4M<id>P'). Must be combined with goals_evaluation_id. */
  competences_evaluation_id?: InputMaybe<Scalars['Int']['input']>;
  /** Flex performance: goals evaluation id (mapped to '6M<id>P'). Must be combined with competences_evaluation_id. */
  goals_evaluation_id?: InputMaybe<Scalars['Int']['input']>;
  /** Dimension to group by: DEPARTMENT, JOB, SUBSIDIARY, COUNTRY or LEADERS. */
  group_by: AverageGroupByDimension;
  /** Page number (1-based). */
  page?: Scalars['Int']['input'];
  /** Number of groups per page. */
  page_size?: Scalars['Int']['input'];
  /** Dynamic performance: the performance_period_id to filter by. Supply this field alone for Desempeño Dinámico. */
  performance_period_id?: InputMaybe<Scalars['Int']['input']>;
};

/** Paginated performance average results per group for the 'Promedio de Resultados' bar chart. */
export type PerformanceAverageResultsByGroupType = {
  __typename?: 'PerformanceAverageResultsByGroupType';
  groups: Array<GroupAverageResultType>;
  page_info: ProgressPageInfoType;
  total_count: Scalars['Int']['output'];
};

export type PerformanceComparisonInput = {
  company_id: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  page_size?: Scalars['Int']['input'];
  process_ids: Array<Scalars['String']['input']>;
};

export type PerformanceComparisonItemType = {
  __typename?: 'PerformanceComparisonItemType';
  distribution: Array<SemaphoreRangeCountType>;
  period_label: Scalars['String']['output'];
  process_id: Scalars['String']['output'];
  process_name: Scalars['String']['output'];
};

export type PerformanceComparisonPageType = {
  __typename?: 'PerformanceComparisonPageType';
  items: Array<PerformanceComparisonItemType>;
  page: Scalars['Int']['output'];
  page_size: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Filters for the performance distribution chart (campana de Gauss). At most one performance mode may be supplied: Dynamic (performance_period_id), Flex (competences_evaluation_id + goals_evaluation_id) or Basic/tradicional (none of them, uses the company-configured process). Flex and Basic distribute the WEIGHTED goals+competences result. The four demographic filters are multi-select: a list matches by inclusion, null/[] means no filter on that dimension. */
export type PerformanceDistributionInput = {
  /** Talent company id. */
  company_id: Scalars['Int']['input'];
  /** Flex performance: competence evaluation id (mapped to '4M<id>P'). Must be combined with goals_evaluation_id. */
  competences_evaluation_id?: InputMaybe<Scalars['Int']['input']>;
  /** Optional filter by country names (inclusion). */
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional filter by division names (inclusion). */
  department?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Flex performance: goals evaluation id (mapped to '6M<id>P'). Must be combined with competences_evaluation_id. */
  goals_evaluation_id?: InputMaybe<Scalars['Int']['input']>;
  /** Optional filter by subsidiary names (inclusion). */
  location?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Dynamic performance: the performance_period_id to distribute. Supply this field alone for Desempeño Dinámico. */
  performance_period_id?: InputMaybe<Scalars['Int']['input']>;
  /** Optional filter by job names (inclusion). */
  position?: InputMaybe<Array<Scalars['String']['input']>>;
  /** DEPRECATED — legacy Desempeño Dinámico entry point, kept so the already-deployed FE keeps working. Reads the goal-process semaphore limits instead of the company semaphore config. Use performance_period_id instead; cannot be combined with any of the three mode fields. */
  process_id?: InputMaybe<Scalars['String']['input']>;
};

export type PerformanceDistributionType = {
  __typename?: 'PerformanceDistributionType';
  ranges: Array<SemaphoreRangeDistributionType>;
  total_employees: Scalars['Int']['output'];
};

export enum PerformanceModuleTypeEnum {
  Climate = 'CLIMATE',
  Competencies = 'COMPETENCIES',
  Feedback = 'FEEDBACK',
  Goals = 'GOALS',
  Pid = 'PID'
}

export type PerformanceReport = {
  __typename?: 'PerformanceReport';
  centralized_organization_id: Scalars['ID']['output'];
  centralized_user_id: Scalars['ID']['output'];
  certificates_total: Scalars['Int']['output'];
  courses_complete_total: Scalars['Int']['output'];
  courses_complete_total_percentage: Scalars['Decimal']['output'];
  courses_organization_complete_total: Scalars['Int']['output'];
  courses_organization_complete_total_percentage: Scalars['Decimal']['output'];
  courses_organization_total: Scalars['Int']['output'];
  courses_total: Scalars['Int']['output'];
  last_action_date?: Maybe<Scalars['DateTime']['output']>;
  organization_id: Scalars['ID']['output'];
  participation_certificates_total: Scalars['Int']['output'];
  played_hours: Scalars['Decimal']['output'];
  progress_hours: Scalars['Decimal']['output'];
  projects_total: Scalars['Int']['output'];
  quizzes_total: Scalars['Int']['output'];
  tracks_complete_total: Scalars['Int']['output'];
  tracks_complete_total_percentage: Scalars['Decimal']['output'];
  tracks_total: Scalars['Int']['output'];
  user_activated_date?: Maybe<Scalars['DateTime']['output']>;
  user_created_date?: Maybe<Scalars['DateTime']['output']>;
  user_custom_fields?: Maybe<Array<PerformanceReportUserCustomFieldType>>;
  user_division?: Maybe<Scalars['String']['output']>;
  user_email: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
  user_info_extra?: Maybe<Scalars['String']['output']>;
  user_job?: Maybe<Scalars['String']['output']>;
  user_level?: Maybe<Scalars['String']['output']>;
  user_name: Scalars['String']['output'];
  user_role?: Maybe<Scalars['String']['output']>;
  user_status: PerformanceReportUserStatusEnum;
  user_subsidiary?: Maybe<Scalars['String']['output']>;
};

export type PerformanceReportConnection = {
  __typename?: 'PerformanceReportConnection';
  /** A list of edges in this connection. */
  edges: Array<PerformanceReportEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type PerformanceReportConnectionQueryInternalError = PerformanceReportConnection | QueryInternalError | QueryValidationError;

export type PerformanceReportEdge = {
  __typename?: 'PerformanceReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PerformanceReport;
};

export type PerformanceReportUserCustomFieldType = {
  __typename?: 'PerformanceReportUserCustomFieldType';
  field_answer: Scalars['String']['output'];
  field_name: Scalars['String']['output'];
};

export enum PerformanceReportUserStatusEnum {
  UserActive = 'USER_ACTIVE',
  UserDeleted = 'USER_DELETED',
  UserInactive = 'USER_INACTIVE',
  UserPending = 'USER_PENDING'
}

/** One semaphore range definition (order, label, upper limit, color). */
export type PerformanceSemaphoreRangeType = {
  __typename?: 'PerformanceSemaphoreRangeType';
  color: Scalars['String']['output'];
  label: Scalars['String']['output'];
  limit: Scalars['Float']['output'];
  order_id: Scalars['Int']['output'];
};

/** Input for the performance_semaphore_ranges query. */
export type PerformanceSemaphoreRangesInput = {
  /** Talent company id. */
  company_id: Scalars['Int']['input'];
};

/** Semaphore range definitions configured for a company. */
export type PerformanceSemaphoreRangesType = {
  __typename?: 'PerformanceSemaphoreRangesType';
  ranges: Array<PerformanceSemaphoreRangeType>;
};

export type PeriodDate = {
  from_date?: InputMaybe<Scalars['Date']['input']>;
  to_date?: InputMaybe<Scalars['Date']['input']>;
};

export enum PeriodEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type PeriodInput = {
  from_date?: InputMaybe<Scalars['Date']['input']>;
  to_date?: InputMaybe<Scalars['Date']['input']>;
};

/** Reusable date-range period for dashboard widgets. */
export type PeriodRange = {
  __typename?: 'PeriodRange';
  /** Period end date in ISO 8601 format (e.g. '2026-05-14'). */
  end: Scalars['String']['output'];
  /** Period start date in ISO 8601 format (e.g. '2026-04-14'). */
  start: Scalars['String']['output'];
};

export type PeriodicityMutation = {
  __typename?: 'PeriodicityMutation';
  /** Set declarativo de payroll types asociados a una periodicidad. La lista es el estado deseado completo: ids no incluidos se desasocian. Idempotente. Returns warnings if a payroll type to add is already associated to another periodicity (a type can belong to multiple periodicities). */
  associate_payroll_types_to_periodicity: PayrollAssociatePayrollTypesResult;
  /** Crea una periodicidad para la organizacion. `sat_code` debe pertenecer al catalogo SAT y `period_days` ser coherente con el, salvo para la clave '99' (personalizada). */
  create_periodicity: PayrollPeriodicityMutationResult;
  /** Da de alta un periodo suelto en el calendario. La carga inicial del ejercicio va por planilla; esta via es para agregar un periodo que falto. Rechaza numeros de periodo repetidos y rangos que se solapen con otro periodo del mismo ejercicio. */
  create_periodicity_period: PayrollPeriodicityPeriodMutationResult;
  /** Desactiva una periodicidad. Falla si alguno de sus tipos de nomina tiene una corrida en proceso. */
  deactivate_periodicity: PayrollPeriodicityMutationResult;
  /** Disassociate a payroll type from a periodicity. Rejects if there is an active run for the payroll type (CA-7). Idempotent — disassociating something not associated returns the periodicity unchanged. */
  disassociate_payroll_type_from_periodicity: PayrollDisassociatePayrollTypeResult;
  /** Carga el calendario anual de una periodicidad desde una planilla `.csv` o `.xlsx`. Requiere `PlatformAdmin`: la ejecuta un agente de onboarding, no el admin del cliente. Upsert por `period_number`. Las filas invalidas se reportan con su numero de fila y su motivo, y no abortan la carga del resto. */
  import_periodicity_calendar: PayrollImportPeriodicityCalendarResult;
  /** Actualiza una periodicidad. Los campos omitidos no se modifican. `sat_code` no es editable. */
  update_periodicity: PayrollPeriodicityMutationResult;
  /** Correccion puntual de un periodo. Los campos omitidos no se modifican. `periodicity_id`, `fiscal_year` y `period_number` no son editables. */
  update_periodicity_period: PayrollPeriodicityPeriodMutationResult;
};


export type PeriodicityMutationAssociate_Payroll_Types_To_PeriodicityArgs = {
  input: PayrollAssociatePayrollTypesToPeriodicityInput;
};


export type PeriodicityMutationCreate_PeriodicityArgs = {
  input: PayrollCreatePeriodicityInput;
};


export type PeriodicityMutationCreate_Periodicity_PeriodArgs = {
  input: PayrollCreatePeriodicityPeriodInput;
};


export type PeriodicityMutationDeactivate_PeriodicityArgs = {
  input: PayrollDeactivatePeriodicityInput;
};


export type PeriodicityMutationDisassociate_Payroll_Type_From_PeriodicityArgs = {
  input: PayrollDisassociatePayrollTypeFromPeriodicityInput;
};


export type PeriodicityMutationImport_Periodicity_CalendarArgs = {
  input: PayrollImportPeriodicityCalendarInput;
};


export type PeriodicityMutationUpdate_PeriodicityArgs = {
  input: PayrollUpdatePeriodicityInput;
};


export type PeriodicityMutationUpdate_Periodicity_PeriodArgs = {
  input: PayrollUpdatePeriodicityPeriodInput;
};

export type PeriodicityQuery = {
  __typename?: 'PeriodicityQuery';
  /** Fetch a single periodicity with its calendar (periods of the given fiscal_year) and associated payroll_types. */
  get_periodicity: PayrollGetPeriodicityResult;
  /** Lista las periodicidades de la organizacion. Admite filtros, busqueda y paginacion. */
  list_periodicities: PayrollListPeriodicitiesResult;
  /** List the payroll types associated to a periodicity, hydrated with their full schema. Focused alternative to `get_periodicity` when only the associations are needed (no calendar / headcount, no fiscal_year). */
  list_periodicity_payroll_types: PayrollListPeriodicityPayrollTypesResult;
  /** Calendario paginado de una periodicidad para un ejercicio fiscal, con filtro opcional por estado y `total`. Alternativa acotada a `get_periodicity`, que devuelve el ejercicio completo sin tope: con periodicidad diaria (`sat_code` '01') son ~365 periodos. */
  list_periodicity_periods: PayrollListPeriodicityPeriodsResult;
};


export type PeriodicityQueryGet_PeriodicityArgs = {
  input: PayrollGetPeriodicityInput;
};


export type PeriodicityQueryList_PeriodicitiesArgs = {
  input: PayrollListPeriodicitiesInput;
};


export type PeriodicityQueryList_Periodicity_Payroll_TypesArgs = {
  input: PayrollListPeriodicityPayrollTypesInput;
};


export type PeriodicityQueryList_Periodicity_PeriodsArgs = {
  input: PayrollListPeriodicityPeriodsInput;
};

export type Permission = {
  __typename?: 'Permission';
  can_be_edited: Scalars['Boolean']['output'];
  can_be_viewed: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enterprise: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  user_role?: Maybe<PermissionUserOrganizationRole>;
  user_role_type?: Maybe<PermissionUserRoleType>;
};

export type PermissionAssociation = {
  __typename?: 'PermissionAssociation';
  can_edit: Scalars['Boolean']['output'];
  can_view: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  permission: Permission;
};

export type PermissionGroup = {
  __typename?: 'PermissionGroup';
  created_at: Scalars['String']['output'];
  created_by: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization_id: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  user_role?: Maybe<PermissionUserOrganizationRole>;
  users_count: Scalars['Int']['output'];
};

export type PermissionGroupCustomConnection = {
  __typename?: 'PermissionGroupCustomConnection';
  edges: Array<PermissionGroupCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type PermissionGroupCustomEdge = {
  __typename?: 'PermissionGroupCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PermissionGroup;
};

export type PermissionGroupDetailed = {
  __typename?: 'PermissionGroupDetailed';
  created_at?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization_id: Scalars['Int']['output'];
  permissions: Array<PermissionAssociation>;
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  users: Array<CentralizedUserNode>;
};

export type PermissionGroupDetailedResponse = {
  __typename?: 'PermissionGroupDetailedResponse';
  created_at?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization_id: Scalars['Int']['output'];
  platform_modules: Array<PermissionGroupPlatformModuleResponse>;
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
  users: CentralizedUserOrganizationNodeCustomConnection;
};


export type PermissionGroupDetailedResponseUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PermissionGroupPermissionResponse = {
  __typename?: 'PermissionGroupPermissionResponse';
  can_be_edited: Scalars['Boolean']['output'];
  can_be_viewed: Scalars['Boolean']['output'];
  can_edit: Scalars['Boolean']['output'];
  can_view: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type PermissionGroupPlatformModuleResponse = {
  __typename?: 'PermissionGroupPlatformModuleResponse';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<PermissionGroupPermissionResponse>;
  slug: Scalars['String']['output'];
};

export type PermissionGroupResponse = {
  __typename?: 'PermissionGroupResponse';
  permission_groups?: Maybe<PermissionGroupDetailed>;
  response: ResponseNode;
  success: Scalars['Boolean']['output'];
};

export type PermissionGroupUserDetailedResponse = {
  __typename?: 'PermissionGroupUserDetailedResponse';
  created_at?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization_id: Scalars['Int']['output'];
  platform_modules: Array<PermissionGroupPlatformModuleResponse>;
  slug: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

export type PermissionInput = {
  can_edit: Scalars['Boolean']['input'];
  can_view: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};

export enum PermissionUserOrganizationRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export enum PermissionUserRoleType {
  Admin = 'ADMIN',
  Leader = 'LEADER',
  User = 'USER'
}

export type PermissionValidationError = {
  __typename?: 'PermissionValidationError';
  message: Scalars['String']['output'];
  operation_id: Scalars['String']['output'];
};

export type PersonTypeItem = {
  __typename?: 'PersonTypeItem';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PersonTypesResponse = {
  __typename?: 'PersonTypesResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<PersonTypeItem>;
};

export type PersonalizationInput = {
  favicon?: InputMaybe<Scalars['String']['input']>;
  file_favicon_id?: InputMaybe<Scalars['Int']['input']>;
  file_image_login_id?: InputMaybe<Scalars['Int']['input']>;
  file_logo_id?: InputMaybe<Scalars['Int']['input']>;
  image_login?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['Int']['input'];
};

export type PersonalizationOrganizationResponse = {
  __typename?: 'PersonalizationOrganizationResponse';
  personalization?: Maybe<OrganizationPersonalizationNode>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

/** Node for phone attributes */
export type PhoneNumberNode = {
  __typename?: 'PhoneNumberNode';
  /** 2 Letter country code */
  country_code: Scalars['String']['output'];
  /** Phone Number code for country (example: 51 for PE) */
  country_number_code: Scalars['String']['output'];
  /** Phone number without country code */
  value: Scalars['String']['output'];
};

export type PidActivityEmployeeInput = {
  activity_employee_id: Scalars['Int']['input'];
};

export type PidActivityImage = {
  __typename?: 'PidActivityImage';
  absolute_url?: Maybe<Scalars['String']['output']>;
};

export enum PidActivityTypeEnum {
  ClimateCulture = 'CLIMATE_CULTURE',
  Competence = 'COMPETENCE',
  CompetenceModel = 'COMPETENCE_MODEL',
  Goal = 'GOAL',
  Okr = 'OKR',
  Other = 'OTHER',
  Withoutprocess = 'WITHOUTPROCESS'
}

export type PidAssociateProcess = {
  __typename?: 'PidAssociateProcess';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  sub_description?: Maybe<Scalars['String']['output']>;
  sub_process_id?: Maybe<Scalars['Int']['output']>;
  sub_title?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type_module: PidActivityTypeEnum;
};

export type PidConfiguration = {
  __typename?: 'PidConfiguration';
  configuration_admin?: Maybe<PidConfigurationAdmin>;
  configuration_leader_collaborator?: Maybe<PidConfigurationLeaderCollaborator>;
  id: Scalars['Int']['output'];
};

export type PidConfigurationAdmin = {
  __typename?: 'PidConfigurationAdmin';
  allow_assign_existing_task: Scalars['Boolean']['output'];
  allow_max_act_comp_act: Scalars['Boolean']['output'];
  continuous_track_activities: Scalars['Boolean']['output'];
  create_activities_book_store: Scalars['Boolean']['output'];
  create_activities_others: Scalars['Boolean']['output'];
  create_activities_without_process: Scalars['Boolean']['output'];
  create_pid_from_feedback: Scalars['Boolean']['output'];
  enable_approved_all_task_collaborator: Scalars['Boolean']['output'];
  finish_date_process: Scalars['Date']['output'];
  has_continuous_tracking: Scalars['Boolean']['output'];
  hide_input_class: Scalars['Boolean']['output'];
  hide_report_pdf: Scalars['Boolean']['output'];
  init_date_process: Scalars['Date']['output'];
  model702010_activities: Scalars['Boolean']['output'];
  model702010_labels: PidModelLabels;
  name_process: Scalars['String']['output'];
  number_activities?: Maybe<Scalars['Int']['output']>;
  object_develop: Scalars['Boolean']['output'];
  process_associate: Array<PidModulesAssociate>;
  show_dashboard: Scalars['Boolean']['output'];
  show_displacement_percentage: Scalars['Boolean']['output'];
};

export type PidConfigurationInput = {
  dip_id: Scalars['Int']['input'];
};

export type PidConfigurationLeaderCollaborator = {
  __typename?: 'PidConfigurationLeaderCollaborator';
  approved_activities_by_leader: Scalars['Boolean']['output'];
  approved_activities_super_boss: Scalars['Boolean']['output'];
  behaviors_deficit: Scalars['Boolean']['output'];
  collaborator_track: Scalars['Boolean']['output'];
  create_activities_collaborator_process_inactive: Scalars['Boolean']['output'];
  enable_comment: Scalars['Boolean']['output'];
  enable_evidence_boss: Scalars['Boolean']['output'];
  enable_evidence_colab: Scalars['Boolean']['output'];
  evaluate_activities_leader_with_track_collaborator: Scalars['Boolean']['output'];
  process_collaborator_activities: Array<PidCrudActivityTypeEnum>;
  process_leader_activities: Array<PidCrudActivityTypeEnum>;
};

export type PidConfigurationResponse = PidConfiguration | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export enum PidCrudActivityTypeEnum {
  Create = 'CREATE',
  Delete = 'DELETE',
  Edit = 'EDIT'
}

export type PidEmployeeActivity = {
  __typename?: 'PidEmployeeActivity';
  collaborator_progress?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dip_activity_attachment?: Maybe<Attachment>;
  dip_activity_class?: Maybe<Scalars['String']['output']>;
  dip_activity_id: Scalars['Int']['output'];
  displacement_comment?: Maybe<Scalars['String']['output']>;
  displacement_value?: Maybe<Scalars['Int']['output']>;
  end_date: Scalars['Date']['output'];
  extra_fields?: Maybe<DipExtraFieldQuestions>;
  id: Scalars['Int']['output'];
  leader_progress?: Maybe<Scalars['Float']['output']>;
  learning_info?: Maybe<LearningInfo>;
  model?: Maybe<PidModelLabels>;
  owner?: Maybe<DipActivityTypeEnum>;
  points?: Maybe<Scalars['Int']['output']>;
  state: Scalars['String']['output'];
  title: Scalars['String']['output'];
  track_start_date: Scalars['Date']['output'];
  tracks?: Maybe<Array<PidTrack>>;
  type_activity: PidActivityTypeEnum;
};

export type PidEmployeeActivityFilter = {
  model?: InputMaybe<Array<ActivityDipModelLabelsEnum>>;
  type?: InputMaybe<PidStatusEnum>;
};

export type PidEmployeeActivityList = {
  __typename?: 'PidEmployeeActivityList';
  employee_activities?: Maybe<Array<PidEmployeeActivity>>;
};

export type PidEvaluationDetail = {
  __typename?: 'PidEvaluationDetail';
  comment?: Maybe<Scalars['String']['output']>;
  evidence?: Maybe<Attachment>;
  progress?: Maybe<Scalars['Float']['output']>;
};

export type PidLearningActivityEmployeeInput = {
  activity_employee_id: Scalars['Int']['input'];
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type PidModelLabels = {
  __typename?: 'PidModelLabels';
  seventy?: Maybe<Scalars['String']['output']>;
  ten?: Maybe<Scalars['String']['output']>;
  twenty?: Maybe<Scalars['String']['output']>;
};

export type PidModulesAssociate = {
  __typename?: 'PidModulesAssociate';
  id_process?: Maybe<Array<Scalars['Int']['output']>>;
  label?: Maybe<Scalars['String']['output']>;
  type_module: PidActivityTypeEnum;
};

export type PidModulesAssociateInput = {
  /** Ids of the linked elements for this module; omitted/empty means every element ("Todos" — RN-008b / RN-009c). For a COMPETENCE_MODEL module it carries the competences model id (persisted into allow_competences_model_id; RN-009 requires a model id, no "Todos"). */
  id_process?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Type of the associated module (COMPETENCE, GOAL, OKR, ...). */
  type_module: PidActivityTypeEnum;
};

export enum PidPendingActionEnum {
  CollaboratorTracking = 'COLLABORATOR_TRACKING',
  CreateActivities = 'CREATE_ACTIVITIES',
  LeaderApproval = 'LEADER_APPROVAL',
  LeaderTracking = 'LEADER_TRACKING'
}

export type PidProcess = {
  __typename?: 'PidProcess';
  end_date: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  original_id: Scalars['Int']['output'];
  show_dashboard: Scalars['Boolean']['output'];
  start_date: Scalars['Date']['output'];
  state: Scalars['String']['output'];
};

export type PidProcessDetailInput = {
  employee_id: Scalars['Int']['input'];
  pid_id: Scalars['Int']['input'];
};

export type PidProcessList = {
  __typename?: 'PidProcessList';
  processes?: Maybe<Array<PidProcess>>;
};

export type PidProcessListInput = {
  company_id: Scalars['Int']['input'];
  employee_id?: InputMaybe<Scalars['Int']['input']>;
  leader_employee_id?: InputMaybe<Scalars['Int']['input']>;
};

export enum PidStatusEnum {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  NotInitiated = 'NOT_INITIATED',
  Pending = 'PENDING',
  PendingBySuperBoss = 'PENDING_BY_SUPER_BOSS',
  Rejected = 'REJECTED',
  Standby = 'STANDBY',
  UnStarted = 'UN_STARTED'
}

export enum PidTemplateRecipientEnum {
  Both = 'BOTH',
  Collaborator = 'COLLABORATOR',
  Leader = 'LEADER'
}

export type PidTotalsActivities = {
  __typename?: 'PidTotalsActivities';
  created: Scalars['Int']['output'];
  evaluated: Scalars['Int']['output'];
  in_progress: Scalars['Int']['output'];
  points?: Maybe<Scalars['Int']['output']>;
  to_approve: Scalars['Int']['output'];
  un_started: Scalars['Int']['output'];
};

export type PidTrack = {
  __typename?: 'PidTrack';
  auto_evaluation: PidEvaluationDetail;
  end_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  leader_evaluation: PidEvaluationDetail;
  start_date: Scalars['Date']['output'];
  state: Scalars['String']['output'];
};

export type PlannerChartComponent = PlannerReportChartCardComponent | PlannerReportShareCardComponent;

export enum PlannerReportAlignEnum {
  AlignLeft = 'ALIGN_LEFT',
  AlignRight = 'ALIGN_RIGHT'
}

export type PlannerReportAnalysisCardComponent = {
  __typename?: 'PlannerReportAnalysisCardComponent';
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Hallazgos de la revisión de coherencia. */
  findings: Array<PlannerReportFinding>;
  /** Pie de la tarjeta. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportBlockComponent = {
  __typename?: 'PlannerReportBlockComponent';
  /** Componentes hijos de la sección, en orden. */
  children: Array<PlannerReportComponent>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Pie de la sección. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols (opcional). */
  icon?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportBubble = {
  __typename?: 'PlannerReportBubble';
  /** La palabra. */
  label?: Maybe<Scalars['String']['output']>;
  /** Nivel, con el vocabulario de la escala del reporte. */
  state?: Maybe<Scalars['String']['output']>;
  /** Su peso: el ÁREA de la burbuja es proporcional. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlannerReportBubbleCardComponent = {
  __typename?: 'PlannerReportBubbleCardComponent';
  /** Las palabras de la nube. */
  bubbles: Array<PlannerReportBubble>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportCardComponent = {
  __typename?: 'PlannerReportCardComponent';
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Detalle. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Sub-tarjetas de detalle. */
  detail_cards: Array<PlannerReportDetailCardComponent>;
  /** Pie de la tarjeta. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Sub-tarjetas de valor. */
  value_cards: Array<PlannerReportValueCardComponent>;
};

export type PlannerReportChartAxisConfig = {
  __typename?: 'PlannerReportChartAxisConfig';
  /** Formato de los ticks (number / percent); nulo si es desconocido. */
  format?: Maybe<PlannerReportChartAxisFormatEnum>;
  /** Etiqueta del eje. */
  label?: Maybe<Scalars['String']['output']>;
  /** Máximo de la escala; nulo para derivarlo del dato. */
  max?: Maybe<Scalars['Float']['output']>;
  /** Mínimo de la escala; nulo para derivarlo del dato. */
  min?: Maybe<Scalars['Float']['output']>;
  /** Sufijo de unidad del eje. */
  unit?: Maybe<Scalars['String']['output']>;
};

export enum PlannerReportChartAxisEnum {
  ChartAxisLeft = 'CHART_AXIS_LEFT',
  ChartAxisRight = 'CHART_AXIS_RIGHT'
}

export enum PlannerReportChartAxisFormatEnum {
  AxisFormatNumber = 'AXIS_FORMAT_NUMBER',
  AxisFormatPercent = 'AXIS_FORMAT_PERCENT'
}

export type PlannerReportChartCardComponent = {
  __typename?: 'PlannerReportChartCardComponent';
  /** Etiquetas del eje X, una por punto; definen el largo de cada serie. */
  categories: Array<Scalars['String']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Nota al pie de la card. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Configuración del eje de valores izquierdo. */
  left_axis?: Maybe<PlannerReportChartAxisConfig>;
  /** Si se muestra la leyenda. */
  legend?: Maybe<Scalars['Boolean']['output']>;
  /** Línea de corte horizontal contra el eje izquierdo (AGNT-057): el mínimo esperado, la meta, el «a la fecha». Es un umbral, no un dato. */
  reference?: Maybe<Scalars['Float']['output']>;
  /** Cómo se llama la línea de corte. Sin rótulo NO se dibuja: una línea punteada anónima se lee como una serie sin leyenda. */
  reference_label?: Maybe<Scalars['String']['output']>;
  /** Configuración del eje de valores secundario. */
  right_axis?: Maybe<PlannerReportChartAxisConfig>;
  /** Series del gráfico, en orden (la posición determina el color). */
  series: Array<PlannerReportChartSeries>;
  /** Apila todas las series `bar` que no declaren su propio `stack`. */
  stacked?: Maybe<Scalars['Boolean']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Etiqueta del eje X. */
  x_axis_label?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportChartSeries = {
  __typename?: 'PlannerReportChartSeries';
  /** Eje de valores contra el que se dibuja; nulo si es desconocido. */
  axis?: Maybe<PlannerReportChartAxisEnum>;
  /** Marca con la que se dibuja (bar / line / area); nulo si es desconocida. */
  kind?: Maybe<PlannerReportChartSeriesKindEnum>;
  /** Nombre de la serie (leyenda y tooltip). */
  name?: Maybe<Scalars['String']['output']>;
  /** Grupo de apilado: las series `bar` con el mismo valor se apilan. */
  stack?: Maybe<Scalars['String']['output']>;
  /** Nivel de CADA punto, en paralelo a `values` (AGNT-057). Con esto el punto baja una línea al eje con el tono de SU corte. No se deriva del valor: la escala declara etiquetas, no cortes numéricos. */
  states: Array<Maybe<Scalars['String']['output']>>;
  /** Sufijo de unidad para la leyenda y el tooltip. */
  unit?: Maybe<Scalars['String']['output']>;
  /** Valores, uno por categoría. Un nulo es un hueco: la línea se corta y la barra no se dibuja. */
  values: Array<Maybe<Scalars['Float']['output']>>;
};

export enum PlannerReportChartSeriesKindEnum {
  SeriesKindArea = 'SERIES_KIND_AREA',
  SeriesKindBar = 'SERIES_KIND_BAR',
  SeriesKindLine = 'SERIES_KIND_LINE'
}

export enum PlannerReportColumnDisplayEnum {
  ColumnDisplayBar = 'COLUMN_DISPLAY_BAR',
  ColumnDisplayFill = 'COLUMN_DISPLAY_FILL',
  ColumnDisplayText = 'COLUMN_DISPLAY_TEXT'
}

export type PlannerReportComponent = PlannerReportAnalysisCardComponent | PlannerReportBlockComponent | PlannerReportBubbleCardComponent | PlannerReportCardComponent | PlannerReportChartCardComponent | PlannerReportCoverComponent | PlannerReportDetailCardComponent | PlannerReportFileCardComponent | PlannerReportHeaderComponent | PlannerReportMarkdownContentComponent | PlannerReportProfileCardComponent | PlannerReportQuoteCardComponent | PlannerReportRadarCardComponent | PlannerReportRiskTableComponent | PlannerReportScaleLegendComponent | PlannerReportShareCardComponent | PlannerReportSummaryCardComponent | PlannerReportTableComponent | PlannerReportTalentClimateSummaryComponent | PlannerReportTalentComparisonComponent | PlannerReportTalentDemographicsComponent | PlannerReportTalentDepartmentTrendComponent | PlannerReportTalentDimensionDetailComponent | PlannerReportTalentDimensionRadarComponent | PlannerReportTalentGoalComparisonComponent | PlannerReportTalentGoalPeopleComponent | PlannerReportTalentHeatmapComponent | PlannerReportTalentModesComponent | PlannerReportTalentOverallResultComponent | PlannerReportTalentPeopleComponent | PlannerReportTalentPerformancePeopleComponent | PlannerReportTalentSkillSummaryComponent | PlannerReportTalentStrategicGoalsComponent | PlannerReportTalentTrackingComponent | PlannerReportTalentWordDispersionComponent | PlannerReportValueCardComponent;

export enum PlannerReportComponentTypeEnum {
  ComponentTypeAnalysisCard = 'COMPONENT_TYPE_ANALYSIS_CARD',
  ComponentTypeBlock = 'COMPONENT_TYPE_BLOCK',
  ComponentTypeBubbleCard = 'COMPONENT_TYPE_BUBBLE_CARD',
  ComponentTypeCard = 'COMPONENT_TYPE_CARD',
  ComponentTypeChartCard = 'COMPONENT_TYPE_CHART_CARD',
  ComponentTypeCover = 'COMPONENT_TYPE_COVER',
  ComponentTypeDetailCard = 'COMPONENT_TYPE_DETAIL_CARD',
  ComponentTypeFileCard = 'COMPONENT_TYPE_FILE_CARD',
  ComponentTypeHeader = 'COMPONENT_TYPE_HEADER',
  ComponentTypeMarkdownContent = 'COMPONENT_TYPE_MARKDOWN_CONTENT',
  ComponentTypeProfileCard = 'COMPONENT_TYPE_PROFILE_CARD',
  ComponentTypeQuoteCard = 'COMPONENT_TYPE_QUOTE_CARD',
  ComponentTypeRadarCard = 'COMPONENT_TYPE_RADAR_CARD',
  ComponentTypeRiskTable = 'COMPONENT_TYPE_RISK_TABLE',
  ComponentTypeScaleLegend = 'COMPONENT_TYPE_SCALE_LEGEND',
  ComponentTypeShareCard = 'COMPONENT_TYPE_SHARE_CARD',
  ComponentTypeSummaryCard = 'COMPONENT_TYPE_SUMMARY_CARD',
  ComponentTypeTable = 'COMPONENT_TYPE_TABLE',
  ComponentTypeTalentClimateSummary = 'COMPONENT_TYPE_TALENT_CLIMATE_SUMMARY',
  ComponentTypeTalentComparison = 'COMPONENT_TYPE_TALENT_COMPARISON',
  ComponentTypeTalentDemographics = 'COMPONENT_TYPE_TALENT_DEMOGRAPHICS',
  ComponentTypeTalentDepartmentTrend = 'COMPONENT_TYPE_TALENT_DEPARTMENT_TREND',
  ComponentTypeTalentDimensionDetail = 'COMPONENT_TYPE_TALENT_DIMENSION_DETAIL',
  ComponentTypeTalentDimensionRadar = 'COMPONENT_TYPE_TALENT_DIMENSION_RADAR',
  ComponentTypeTalentGoalComparison = 'COMPONENT_TYPE_TALENT_GOAL_COMPARISON',
  ComponentTypeTalentGoalPeople = 'COMPONENT_TYPE_TALENT_GOAL_PEOPLE',
  ComponentTypeTalentHeatmap = 'COMPONENT_TYPE_TALENT_HEATMAP',
  ComponentTypeTalentModes = 'COMPONENT_TYPE_TALENT_MODES',
  ComponentTypeTalentOverallResult = 'COMPONENT_TYPE_TALENT_OVERALL_RESULT',
  ComponentTypeTalentPeople = 'COMPONENT_TYPE_TALENT_PEOPLE',
  ComponentTypeTalentPerformancePeople = 'COMPONENT_TYPE_TALENT_PERFORMANCE_PEOPLE',
  ComponentTypeTalentSkillSummary = 'COMPONENT_TYPE_TALENT_SKILL_SUMMARY',
  ComponentTypeTalentStrategicGoals = 'COMPONENT_TYPE_TALENT_STRATEGIC_GOALS',
  ComponentTypeTalentTracking = 'COMPONENT_TYPE_TALENT_TRACKING',
  ComponentTypeTalentWordDispersion = 'COMPONENT_TYPE_TALENT_WORD_DISPERSION',
  ComponentTypeValueCard = 'COMPONENT_TYPE_VALUE_CARD'
}

export type PlannerReportCoverComponent = {
  __typename?: 'PlannerReportCoverComponent';
  /** Nombre de la organización. */
  brand?: Maybe<Scalars['String']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Fecha o período del reporte, ya formateado. */
  date_label?: Maybe<Scalars['String']['output']>;
  /** Rótulo en versalitas sobre el título. */
  eyebrow?: Maybe<Scalars['String']['output']>;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Datos del evaluado, en pares. */
  meta: Array<PlannerReportCoverMeta>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportCoverMeta = {
  __typename?: 'PlannerReportCoverMeta';
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportDetailCardComponent = {
  __typename?: 'PlannerReportDetailCardComponent';
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Detalle. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Pie de la tarjeta. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportFileCardComponent = {
  __typename?: 'PlannerReportFileCardComponent';
  /** Nombres de columna, en orden. Puede venir vacío. */
  columns: Array<Scalars['String']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Qué contiene el archivo, en lenguaje de negocio. Lo redacta el modelo: admite Markdown ligero y hay que escaparlo al renderizar. */
  description?: Maybe<Scalars['String']['output']>;
  /** Formato del archivo (xlsx, csv, txt, tsv). */
  file_format?: Maybe<Scalars['String']['output']>;
  /** UUID del archivo generado. Con él se pide la descarga (get_copilot_planner_file); no confundir con el id del reporte. */
  file_id?: Maybe<Scalars['String']['output']>;
  /** Nombre visible al descargar, con extensión. */
  filename?: Maybe<Scalars['String']['output']>;
  /** Filas de datos (sin el encabezado), o nulo si se desconoce. */
  row_count?: Maybe<Scalars['Int']['output']>;
  /** Tamaño del binario en bytes, o nulo si se desconoce. */
  size_bytes?: Maybe<Scalars['Int']['output']>;
};

export type PlannerReportFinding = {
  __typename?: 'PlannerReportFinding';
  /** Detalle del hallazgo. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Severidad del hallazgo (ok / warning / alert); nulo si es desconocida. */
  severity?: Maybe<PlannerReportFindingSeverityEnum>;
  /** Título del hallazgo. */
  title?: Maybe<Scalars['String']['output']>;
};

export enum PlannerReportFindingSeverityEnum {
  SeverityAlert = 'SEVERITY_ALERT',
  SeverityOk = 'SEVERITY_OK',
  SeverityWarning = 'SEVERITY_WARNING'
}

export type PlannerReportHeaderComponent = {
  __typename?: 'PlannerReportHeaderComponent';
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
};

export enum PlannerReportKindEnum {
  KindDashboard = 'KIND_DASHBOARD',
  KindDocument = 'KIND_DOCUMENT',
  KindFile = 'KIND_FILE'
}

export enum PlannerReportLegendPositionEnum {
  LegendPositionBelow = 'LEGEND_POSITION_BELOW',
  LegendPositionSide = 'LEGEND_POSITION_SIDE'
}

export type PlannerReportMarkdownContentComponent = {
  __typename?: 'PlannerReportMarkdownContentComponent';
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Nombre de icono Material Symbols (opcional). */
  icon?: Maybe<Scalars['String']['output']>;
  /** Cuerpo en Markdown completo (crudo, sin renderizar). */
  markdown?: Maybe<Scalars['String']['output']>;
  /** Título opcional del bloque de texto. */
  title?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportProfileCardComponent = {
  __typename?: 'PlannerReportProfileCardComponent';
  /** URL http/https del avatar (opcional). */
  avatar?: Maybe<Scalars['String']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Custom fields del perfil. */
  custom_fields: Array<PlannerReportProfileField>;
  /** Campos del perfil. */
  fields: Array<PlannerReportProfileField>;
  /** Pie de la tarjeta. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Nombre del usuario. */
  name?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportProfileField = {
  __typename?: 'PlannerReportProfileField';
  /** Etiqueta del campo del perfil. */
  label?: Maybe<Scalars['String']['output']>;
  /** Valor crudo del campo (número, texto, booleano o nulo). */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type PlannerReportQuoteCardComponent = {
  __typename?: 'PlannerReportQuoteCardComponent';
  /** Quién lo dijo. */
  author?: Maybe<Scalars['String']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Relación evaluadora, competencia o proceso. */
  context?: Maybe<Scalars['String']['output']>;
  /** El comentario, textual. */
  quote?: Maybe<Scalars['String']['output']>;
  /** Nivel del comentario, con el vocabulario de la escala del reporte. En Clima rotula el sentimiento. */
  state?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportRadarCardComponent = {
  __typename?: 'PlannerReportRadarCardComponent';
  /** Los vértices del polígono. */
  axes: Array<Scalars['String']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Tope de la escala; no siempre 100 (en una escala 1-5, es 5). */
  max?: Maybe<Scalars['Float']['output']>;
  /** Las series dibujadas. */
  series: Array<PlannerReportRadarSeries>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportRadarSeries = {
  __typename?: 'PlannerReportRadarSeries';
  /** Nombre. */
  name?: Maybe<Scalars['String']['output']>;
  /** 'fill' o 'outline'. */
  style?: Maybe<Scalars['String']['output']>;
  /** Un valor por eje, en el orden de `axes`. */
  values: Array<Maybe<Scalars['Float']['output']>>;
};

export type PlannerReportRiskRow = {
  __typename?: 'PlannerReportRiskRow';
  /** Interpretación del corte. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Categoría. */
  label?: Maybe<Scalars['String']['output']>;
  /** Nivel de riesgo, con el vocabulario del reporte. */
  level?: Maybe<Scalars['String']['output']>;
  /** Puntaje. */
  value?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportRiskTableComponent = {
  __typename?: 'PlannerReportRiskTableComponent';
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** El instrumento aplicado ('NOM-035'). */
  framework?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** La escala del instrumento. */
  levels: Array<PlannerReportScaleLevel>;
  /** Notas legales al pie. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Las categorías evaluadas. */
  rows: Array<PlannerReportRiskRow>;
  /** Veredicto del instrumento. */
  status?: Maybe<Scalars['String']['output']>;
  /** Tono del veredicto; nulo si es desconocido. */
  status_state?: Maybe<PlannerReportToneEnum>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
};

export enum PlannerReportScaleLayoutEnum {
  ScaleLayoutHorizontal = 'SCALE_LAYOUT_HORIZONTAL',
  ScaleLayoutVertical = 'SCALE_LAYOUT_VERTICAL'
}

export type PlannerReportScaleLegendComponent = {
  __typename?: 'PlannerReportScaleLegendComponent';
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Disposición; nula si es desconocida. */
  layout?: Maybe<PlannerReportScaleLayoutEnum>;
  /** Los cortes, del mejor al peor. */
  levels: Array<PlannerReportScaleLevel>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportScaleLevel = {
  __typename?: 'PlannerReportScaleLevel';
  /** Color hexadecimal del corte, cuando la organización lo configura (AGNT-060). Complementa a `tone`, no lo reemplaza: el tono sigue decidiendo el contraste del texto encima y el dibujo en papel. */
  color?: Maybe<Scalars['String']['output']>;
  /** El rango que abarca ('90 o más'). */
  detail?: Maybe<Scalars['String']['output']>;
  /** Nombre con el que los datos referencian el corte. */
  key?: Maybe<Scalars['String']['output']>;
  /** Cómo se muestra el corte. */
  label?: Maybe<Scalars['String']['output']>;
  /** Tono del corte; nulo si es desconocido. */
  tone?: Maybe<PlannerReportToneEnum>;
};

export type PlannerReportShareCardComponent = {
  __typename?: 'PlannerReportShareCardComponent';
  /** Texto del centro de la dona; por defecto, el total formateado. */
  center_label?: Maybe<Scalars['String']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Nota al pie de la card. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Si se muestra la leyenda. */
  legend?: Maybe<Scalars['Boolean']['output']>;
  /** Dónde va la leyenda; nula si es desconocida. */
  legend_position?: Maybe<PlannerReportLegendPositionEnum>;
  /** Forma (donut / pie / meter); nulo si es desconocida. */
  shape?: Maybe<PlannerReportShareShapeEnum>;
  /** Porciones, en el orden de entrada del dibujo. */
  slices: Array<PlannerReportShareSlice>;
  /** Orden de dibujo (desc / none); nulo si es desconocido. */
  sort?: Maybe<PlannerReportShareSortEnum>;
  /** Nivel de la composición, con el vocabulario de la escala del reporte (AGNT-057). El ANILLO no lo comunica: sus pasos son de la rampa de marca e identifican la serie, no el nivel. */
  state?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Total explícito. Obligatorio en `meter`; en torta/dona, si supera la suma de las porciones, el render agrega el «Resto». */
  total?: Maybe<Scalars['Float']['output']>;
  /** Sufijo de unidad de los valores. */
  unit?: Maybe<Scalars['String']['output']>;
  /** Cómo leer los valores (count / percent); nulo si es desconocido. */
  value_format?: Maybe<PlannerReportShareValueFormatEnum>;
};

export enum PlannerReportShareShapeEnum {
  ShareShapeDonut = 'SHARE_SHAPE_DONUT',
  ShareShapeMeter = 'SHARE_SHAPE_METER',
  ShareShapePie = 'SHARE_SHAPE_PIE',
  ShareShapeRing = 'SHARE_SHAPE_RING'
}

export type PlannerReportShareSlice = {
  __typename?: 'PlannerReportShareSlice';
  /** Etiqueta de la porción. */
  label?: Maybe<Scalars['String']['output']>;
  /** Valor de la porción (no negativo). */
  value?: Maybe<Scalars['Float']['output']>;
};

export enum PlannerReportShareSortEnum {
  ShareSortDesc = 'SHARE_SORT_DESC',
  ShareSortNone = 'SHARE_SORT_NONE'
}

export enum PlannerReportShareValueFormatEnum {
  ShareValueFormatCount = 'SHARE_VALUE_FORMAT_COUNT',
  ShareValueFormatPercent = 'SHARE_VALUE_FORMAT_PERCENT'
}

export enum PlannerReportStatusEnum {
  StatusCompleted = 'STATUS_COMPLETED',
  StatusCreated = 'STATUS_CREATED',
  StatusFailed = 'STATUS_FAILED',
  StatusPending = 'STATUS_PENDING'
}

export type PlannerReportSummaryCardComponent = {
  __typename?: 'PlannerReportSummaryCardComponent';
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Detalle. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Pie de la tarjeta. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Valor crudo destacado. */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type PlannerReportTableChip = {
  __typename?: 'PlannerReportTableChip';
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Texto. */
  label?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTableColumn = {
  __typename?: 'PlannerReportTableColumn';
  /** Alineación; nula si es desconocida. */
  align?: Maybe<PlannerReportAlignEnum>;
  /** Presentación de la columna; nula si es desconocida. */
  display?: Maybe<PlannerReportColumnDisplayEnum>;
  /** Rótulo. */
  label?: Maybe<Scalars['String']['output']>;
  /** Ancho CSS. No es cosmético: una celda cuyo único contenido es una barra colapsa a cero sin él. */
  width?: Maybe<Scalars['String']['output']>;
  /** Deja que esta columna envuelva el texto. */
  wrap: Scalars['Boolean']['output'];
};

export type PlannerReportTableComponent = {
  __typename?: 'PlannerReportTableComponent';
  /** Configuración por columna (AGNT-054). Va DESACOPLADA de `headers`: hay secciones sin fila de encabezado, y exigir el mismo largo las volvería inexpresables. */
  columns: Array<PlannerReportTableColumn>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Pie de la tabla. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Encabezados de columna. */
  headers: Array<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Chips de metadato del encabezado. */
  meta_chips: Array<PlannerReportTableChip>;
  /** Filas de la tabla (lista de listas de celdas crudas). */
  rows?: Maybe<Scalars['JSON']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Fila de totales al pie, o nulo. */
  total_row?: Maybe<PlannerReportTableTotal>;
};

export type PlannerReportTableTotal = {
  __typename?: 'PlannerReportTableTotal';
  /** Celdas del pie, una por columna menos la etiqueta. */
  cells?: Maybe<Scalars['JSON']['output']>;
  /** Etiqueta de la fila ('Total ponderado'). */
  label?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentClimateScaleRow = {
  __typename?: 'PlannerReportTalentClimateScaleRow';
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlannerReportTalentClimateSlice = {
  __typename?: 'PlannerReportTalentClimateSlice';
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Clave del nivel del semáforo; la resuelve el render. */
  state?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlannerReportTalentClimateStat = {
  __typename?: 'PlannerReportTalentClimateStat';
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentClimateSummaryComponent = {
  __typename?: 'PlannerReportTalentClimateSummaryComponent';
  /** Encabezado de la columna «bar». */
  bar_header?: Maybe<Scalars['String']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Contadores del proceso. */
  counters: Array<PlannerReportTalentClimateStat>;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Campo «nps_slices» del upstream. */
  nps_slices: Array<PlannerReportTalentClimateSlice>;
  /** Título de nps. */
  nps_title?: Maybe<Scalars['String']['output']>;
  /** Filas por página en pantalla; en el PDF sale todo. */
  page_size?: Maybe<Scalars['Int']['output']>;
  /** Campo «participation_state» del upstream. */
  participation_state?: Maybe<Scalars['String']['output']>;
  /** Título de participation. */
  participation_title?: Maybe<Scalars['String']['output']>;
  /** Campo «participation_value» del upstream. */
  participation_value?: Maybe<Scalars['Float']['output']>;
  /** Título de process. */
  process_title?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «scale». */
  scale_header?: Maybe<Scalars['String']['output']>;
  /** Campo «scale_rows» del upstream. */
  scale_rows: Array<PlannerReportTalentClimateScaleRow>;
  /** Datos del proceso. */
  stats: Array<PlannerReportTalentClimateStat>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Unidad de los valores ('%', 'puntos'). */
  unit?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentComparisonComponent = {
  __typename?: 'PlannerReportTalentComparisonComponent';
  /** Campo «chart» del upstream. */
  chart?: Maybe<Scalars['String']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Los cortes de la misma data. En el PDF se emiten TODOS. */
  scopes: Array<PlannerReportTalentComparisonScope>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Unidad de los valores ('%', 'puntos'). */
  unit?: Maybe<Scalars['String']['output']>;
  /** Rótulo de x axis. */
  x_axis_label?: Maybe<Scalars['String']['output']>;
  /** Rótulo de y axis. */
  y_axis_label?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentComparisonOption = {
  __typename?: 'PlannerReportTalentComparisonOption';
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Clave del nivel del semáforo; la resuelve el render. */
  state?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
  /** Una celda por columna: un objeto {value, state} o un escalar. */
  values: Array<Maybe<Scalars['Float']['output']>>;
};

export type PlannerReportTalentComparisonScope = {
  __typename?: 'PlannerReportTalentComparisonScope';
  /** Etiquetas del eje de categorías. */
  categories: Array<Scalars['String']['output']>;
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Las series del gráfico. */
  series: Array<PlannerReportTalentComparisonSeries>;
};

export type PlannerReportTalentComparisonSeries = {
  __typename?: 'PlannerReportTalentComparisonSeries';
  /** Las opciones del selector. */
  options: Array<PlannerReportTalentComparisonOption>;
  /** Rótulo de picker. */
  picker_label?: Maybe<Scalars['String']['output']>;
  /** Índice de la opción elegida por defecto. */
  selected?: Maybe<Scalars['Int']['output']>;
};

export type PlannerReportTalentDemographicChart = {
  __typename?: 'PlannerReportTalentDemographicChart';
  /** Campo «question» del upstream. */
  question?: Maybe<Scalars['String']['output']>;
  /** Las porciones de la dona. */
  slices: Array<PlannerReportTalentDemographicSlice>;
};

export type PlannerReportTalentDemographicSlice = {
  __typename?: 'PlannerReportTalentDemographicSlice';
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlannerReportTalentDemographicsComponent = {
  __typename?: 'PlannerReportTalentDemographicsComponent';
  /** Una dona por pregunta sociodemográfica. */
  charts: Array<PlannerReportTalentDemographicChart>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Unidad de los valores ('%', 'puntos'). */
  unit?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentDepartmentTrendComponent = {
  __typename?: 'PlannerReportTalentDepartmentTrendComponent';
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Los puntos de la serie. */
  points: Array<PlannerReportTalentTrendPoint>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Unidad de los valores ('%', 'puntos'). */
  unit?: Maybe<Scalars['String']['output']>;
  /** Rótulo de x axis. */
  x_axis_label?: Maybe<Scalars['String']['output']>;
  /** Rótulo de y axis. */
  y_axis_label?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentDimensionDetailComponent = {
  __typename?: 'PlannerReportTalentDimensionDetailComponent';
  /** Encabezado de la columna «answers». */
  answers_header?: Maybe<Scalars['String']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Filtros de pantalla. NO se emiten en el PDF. */
  filters: Array<PlannerReportTalentHeatmapFilter>;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «name». */
  name_header?: Maybe<Scalars['String']['output']>;
  /** Filas por página en pantalla; en el PDF sale todo. */
  page_size?: Maybe<Scalars['Int']['output']>;
  /** Encabezado de la columna «questions». */
  questions_header?: Maybe<Scalars['String']['output']>;
  /** Las filas. */
  rows: Array<PlannerReportTalentDimensionRow>;
  /** Texto del buscador; es de pantalla. */
  search_placeholder?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Unidad de los valores ('%', 'puntos'). */
  unit?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «value». */
  value_header?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentDimensionQuestion = {
  __typename?: 'PlannerReportTalentDimensionQuestion';
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Clave del nivel del semáforo; la resuelve el render. */
  state?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlannerReportTalentDimensionRadarComponent = {
  __typename?: 'PlannerReportTalentDimensionRadarComponent';
  /** Rótulo de average. */
  average_label?: Maybe<Scalars['String']['output']>;
  /** Título de chart. */
  chart_title?: Maybe<Scalars['String']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Campo «dimensions» del upstream. */
  dimensions: Array<PlannerReportTalentDimensionValue>;
  /** Filtros de pantalla. NO se emiten en el PDF. */
  filters: Array<PlannerReportTalentHeatmapFilter>;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Unidad de los valores ('%', 'puntos'). */
  unit?: Maybe<Scalars['String']['output']>;
  /** Rótulo de value. */
  value_label?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentDimensionRow = {
  __typename?: 'PlannerReportTalentDimensionRow';
  /** Rótulo con la cantidad de respuestas. */
  answers_label?: Maybe<Scalars['String']['output']>;
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Las preguntas de la dimensión. */
  questions: Array<PlannerReportTalentDimensionQuestion>;
  /** Rótulo con la cantidad de preguntas. */
  questions_label?: Maybe<Scalars['String']['output']>;
  /** Clave del nivel del semáforo; la resuelve el render. */
  state?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlannerReportTalentDimensionValue = {
  __typename?: 'PlannerReportTalentDimensionValue';
  /** Promedio de la compañía, para la segunda serie. */
  average?: Maybe<Scalars['Float']['output']>;
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlannerReportTalentGoalComparisonComponent = {
  __typename?: 'PlannerReportTalentGoalComparisonComponent';
  /** Etiquetas del eje de categorías. */
  categories: Array<Scalars['String']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Filtros de pantalla. NO se emiten en el PDF. */
  filters: Array<PlannerReportTalentHeatmapFilter>;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Las series del gráfico. */
  series: Array<PlannerReportTalentGoalSeries>;
  /** Clave del nivel del semáforo; la resuelve el render. */
  state?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Unidad de los valores ('%', 'puntos'). */
  unit?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
  /** Rótulo de x axis. */
  x_axis_label?: Maybe<Scalars['String']['output']>;
  /** Rótulo de y axis. */
  y_axis_label?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentGoalPeopleComponent = {
  __typename?: 'PlannerReportTalentGoalPeopleComponent';
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «goal». */
  goal_header?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «goals». */
  goals_header?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «leader». */
  leader_header?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «name». */
  name_header?: Maybe<Scalars['String']['output']>;
  /** Filas por página en pantalla; en el PDF sale todo. */
  page_size?: Maybe<Scalars['Int']['output']>;
  /** Las personas del listado. */
  people: Array<PlannerReportTalentGoalPerson>;
  /** Encabezado de la columna «role». */
  role_header?: Maybe<Scalars['String']['output']>;
  /** Texto del buscador; es de pantalla. */
  search_placeholder?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «self». */
  self_header?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Campo «team_count» del upstream. */
  team_count?: Maybe<Scalars['Int']['output']>;
  /** Rótulo de team. */
  team_label?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Unidad de los valores ('%', 'puntos'). */
  unit?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «value». */
  value_header?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentGoalPerson = {
  __typename?: 'PlannerReportTalentGoalPerson';
  /** URL de la foto; si falta se dibujan las iniciales. */
  avatar?: Maybe<Scalars['String']['output']>;
  /** Las metas de la persona. */
  goals: Array<PlannerReportTalentGoalTracking>;
  /** Rótulo de goals. */
  goals_label?: Maybe<Scalars['String']['output']>;
  /** Campo «name» del upstream. */
  name?: Maybe<Scalars['String']['output']>;
  /** Campo «progress» del upstream. */
  progress?: Maybe<Scalars['Float']['output']>;
  /** Rótulo de progress. */
  progress_label?: Maybe<Scalars['String']['output']>;
  /** Campo «role» del upstream. */
  role?: Maybe<Scalars['String']['output']>;
  /** Clave del nivel del semáforo; la resuelve el render. */
  state?: Maybe<Scalars['String']['output']>;
  /** Campo «total_weight» del upstream. */
  total_weight?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlannerReportTalentGoalSeries = {
  __typename?: 'PlannerReportTalentGoalSeries';
  /** Campo «name» del upstream. */
  name?: Maybe<Scalars['String']['output']>;
  /** Una celda por columna: un objeto {value, state} o un escalar. */
  values: Array<Maybe<Scalars['Float']['output']>>;
};

export type PlannerReportTalentGoalTracking = {
  __typename?: 'PlannerReportTalentGoalTracking';
  /** Campo «cadence» del upstream. */
  cadence?: Maybe<Scalars['String']['output']>;
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Campo «leader_comment» del upstream. */
  leader_comment?: Maybe<Scalars['String']['output']>;
  /** Campo «leader_value» del upstream. */
  leader_value?: Maybe<Scalars['String']['output']>;
  /** Campo «progress» del upstream. */
  progress?: Maybe<Scalars['Float']['output']>;
  /** Campo «self_comment» del upstream. */
  self_comment?: Maybe<Scalars['String']['output']>;
  /** Campo «self_value» del upstream. */
  self_value?: Maybe<Scalars['String']['output']>;
  /** Clave del nivel del semáforo; la resuelve el render. */
  state?: Maybe<Scalars['String']['output']>;
  /** Peso del proceso o de la meta. */
  weight?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentHeatmapComponent = {
  __typename?: 'PlannerReportTalentHeatmapComponent';
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Filtros de pantalla. NO se emiten en el PDF. */
  filters: Array<PlannerReportTalentHeatmapFilter>;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Cortes del semáforo declarados por el componente. */
  levels: Array<PlannerReportScaleLevel>;
  /** Filas por página en pantalla; en el PDF sale todo. */
  page_size?: Maybe<Scalars['Int']['output']>;
  /** Los cortes de la misma data. En el PDF se emiten TODOS. */
  scopes: Array<PlannerReportTalentHeatmapScope>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentHeatmapFilter = {
  __typename?: 'PlannerReportTalentHeatmapFilter';
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Las opciones del selector. */
  options: Array<Scalars['String']['output']>;
  /** Índice de la opción elegida por defecto. */
  selected?: Maybe<Scalars['Int']['output']>;
};

export type PlannerReportTalentHeatmapRow = {
  __typename?: 'PlannerReportTalentHeatmapRow';
  /** Filas o secciones hijas, en orden. */
  children: Array<PlannerReportTalentHeatmapRow>;
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Una celda por columna: un objeto {value, state} o un escalar. */
  values: Array<Scalars['JSON']['output']>;
};

export type PlannerReportTalentHeatmapScope = {
  __typename?: 'PlannerReportTalentHeatmapScope';
  /** Los encabezados de columna. */
  columns: Array<Scalars['String']['output']>;
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Rótulo de row. */
  row_label?: Maybe<Scalars['String']['output']>;
  /** Las filas. */
  rows: Array<PlannerReportTalentHeatmapRow>;
};

export type PlannerReportTalentMode = {
  __typename?: 'PlannerReportTalentMode';
  /** Las secciones del modo, en orden. */
  children: Array<PlannerReportComponent>;
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentModesComponent = {
  __typename?: 'PlannerReportTalentModesComponent';
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Los modos del reporte. En el PDF se emiten TODOS. */
  modes: Array<PlannerReportTalentMode>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentOverallResultComponent = {
  __typename?: 'PlannerReportTalentOverallResultComponent';
  /** Lectura del resultado; se deriva del nivel si falta. */
  caption?: Maybe<Scalars['String']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nota al pie del semáforo. */
  help_text?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Cortes del semáforo declarados por el componente. */
  levels: Array<PlannerReportScaleLevel>;
  /** Rótulo del semáforo. */
  scale_title?: Maybe<Scalars['String']['output']>;
  /** Campo «shape» del upstream. */
  shape?: Maybe<Scalars['String']['output']>;
  /** Clave del nivel del semáforo; la resuelve el render. */
  state?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Unidad de los valores ('%', 'puntos'). */
  unit?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type PlannerReportTalentPeopleComponent = {
  __typename?: 'PlannerReportTalentPeopleComponent';
  /** Encabezado de la columna «bar». */
  bar_header?: Maybe<Scalars['String']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Encabezado de la columna «department». */
  department_header?: Maybe<Scalars['String']['output']>;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «name». */
  name_header?: Maybe<Scalars['String']['output']>;
  /** Filas por página en pantalla; en el PDF sale todo. */
  page_size?: Maybe<Scalars['Int']['output']>;
  /** Las personas del listado. */
  people: Array<PlannerReportTalentPerson>;
  /** Encabezado de la columna «role». */
  role_header?: Maybe<Scalars['String']['output']>;
  /** Texto del buscador; es de pantalla. */
  search_placeholder?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «skill». */
  skill_header?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Unidad de los valores ('%', 'puntos'). */
  unit?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «value». */
  value_header?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentPerformancePeopleComponent = {
  __typename?: 'PlannerReportTalentPerformancePeopleComponent';
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Encabezado de la columna «department». */
  department_header?: Maybe<Scalars['String']['output']>;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «name». */
  name_header?: Maybe<Scalars['String']['output']>;
  /** Filas por página en pantalla; en el PDF sale todo. */
  page_size?: Maybe<Scalars['Int']['output']>;
  /** Las personas del listado. */
  people: Array<PlannerReportTalentPerformancePerson>;
  /** Encabezado de la columna «process». */
  process_header?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «result». */
  result_header?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «role». */
  role_header?: Maybe<Scalars['String']['output']>;
  /** Texto del buscador; es de pantalla. */
  search_placeholder?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Campo «team_count» del upstream. */
  team_count?: Maybe<Scalars['Int']['output']>;
  /** Rótulo de team. */
  team_label?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Unidad de los valores ('%', 'puntos'). */
  unit?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «value». */
  value_header?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «weight». */
  weight_header?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentPerformancePerson = {
  __typename?: 'PlannerReportTalentPerformancePerson';
  /** URL de la foto; si falta se dibujan las iniciales. */
  avatar?: Maybe<Scalars['String']['output']>;
  /** Campo «department» del upstream. */
  department?: Maybe<Scalars['String']['output']>;
  /** Campo «name» del upstream. */
  name?: Maybe<Scalars['String']['output']>;
  /** Los procesos que componen el resultado. */
  processes: Array<PlannerReportTalentPerformanceProcess>;
  /** Campo «role» del upstream. */
  role?: Maybe<Scalars['String']['output']>;
  /** Clave del nivel del semáforo; la resuelve el render. */
  state?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlannerReportTalentPerformanceProcess = {
  __typename?: 'PlannerReportTalentPerformanceProcess';
  /** Comentario textual; se muestra tal cual. */
  comment?: Maybe<Scalars['String']['output']>;
  /** Campo «comment_by» del upstream. */
  comment_by?: Maybe<Scalars['String']['output']>;
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Clave del nivel del semáforo; la resuelve el render. */
  state?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
  /** Peso del proceso o de la meta. */
  weight?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentPerson = {
  __typename?: 'PlannerReportTalentPerson';
  /** URL de la foto; si falta se dibujan las iniciales. */
  avatar?: Maybe<Scalars['String']['output']>;
  /** Campo «department» del upstream. */
  department?: Maybe<Scalars['String']['output']>;
  /** Campo «name» del upstream. */
  name?: Maybe<Scalars['String']['output']>;
  /** Campo «role» del upstream. */
  role?: Maybe<Scalars['String']['output']>;
  /** Las competencias de la persona. */
  skills: Array<PlannerReportTalentPersonSkill>;
  /** Clave del nivel del semáforo; la resuelve el render. */
  state?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlannerReportTalentPersonSkill = {
  __typename?: 'PlannerReportTalentPersonSkill';
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Clave del nivel del semáforo; la resuelve el render. */
  state?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlannerReportTalentSentimentComment = {
  __typename?: 'PlannerReportTalentSentimentComment';
  /** Clave del grupo de sentimiento. */
  sentiment?: Maybe<Scalars['String']['output']>;
  /** Campo «text» del upstream. */
  text?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentSentimentGroup = {
  __typename?: 'PlannerReportTalentSentimentGroup';
  /** Color hexadecimal que declara el back. */
  color?: Maybe<Scalars['String']['output']>;
  /** Cantidad de respuestas del grupo. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Campo «key» del upstream. */
  key?: Maybe<Scalars['String']['output']>;
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Tono del nivel. */
  tone?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlannerReportTalentSentimentWord = {
  __typename?: 'PlannerReportTalentSentimentWord';
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Clave del grupo de sentimiento. */
  sentiment?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlannerReportTalentSkillRow = {
  __typename?: 'PlannerReportTalentSkillRow';
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Clave del nivel del semáforo; la resuelve el render. */
  state?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlannerReportTalentSkillSummaryComponent = {
  __typename?: 'PlannerReportTalentSkillSummaryComponent';
  /** Encabezado de la columna «bar». */
  bar_header?: Maybe<Scalars['String']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Filtros de pantalla. NO se emiten en el PDF. */
  filters: Array<PlannerReportTalentHeatmapFilter>;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «label». */
  label_header?: Maybe<Scalars['String']['output']>;
  /** Filas por página en pantalla; en el PDF sale todo. */
  page_size?: Maybe<Scalars['Int']['output']>;
  /** Las filas. */
  rows: Array<PlannerReportTalentSkillRow>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Unidad de los valores ('%', 'puntos'). */
  unit?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentStrategicGoal = {
  __typename?: 'PlannerReportTalentStrategicGoal';
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Clave del nivel del semáforo; la resuelve el render. */
  state?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlannerReportTalentStrategicGoalsComponent = {
  __typename?: 'PlannerReportTalentStrategicGoalsComponent';
  /** Encabezado de la columna «bar». */
  bar_header?: Maybe<Scalars['String']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Encabezado de la columna «label». */
  label_header?: Maybe<Scalars['String']['output']>;
  /** Las filas. */
  rows: Array<PlannerReportTalentStrategicGoal>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Unidad de los valores ('%', 'puntos'). */
  unit?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentTrackingComponent = {
  __typename?: 'PlannerReportTalentTrackingComponent';
  /** Lectura del resultado; se deriva del nivel si falta. */
  caption?: Maybe<Scalars['String']['output']>;
  /** Título de card. */
  card_title?: Maybe<Scalars['String']['output']>;
  /** Campo «chart_note» del upstream. */
  chart_note?: Maybe<Scalars['String']['output']>;
  /** Título de chart. */
  chart_title?: Maybe<Scalars['String']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Rótulo de date. */
  date_label?: Maybe<Scalars['String']['output']>;
  /** Filtros de pantalla. NO se emiten en el PDF. */
  filters: Array<PlannerReportTalentHeatmapFilter>;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Campo «goal_filter» del upstream. */
  goal_filter?: Maybe<PlannerReportTalentHeatmapFilter>;
  /** Nota al pie del semáforo. */
  help_text?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Cortes del semáforo declarados por el componente. */
  levels: Array<PlannerReportScaleLevel>;
  /** Rótulo del semáforo. */
  scale_title?: Maybe<Scalars['String']['output']>;
  /** Los cortes de la misma data. En el PDF se emiten TODOS. */
  scopes: Array<PlannerReportTalentTrackingScope>;
  /** Campo «selected_unit» del upstream. */
  selected_unit?: Maybe<Scalars['Int']['output']>;
  /** Clave del nivel del semáforo; la resuelve el render. */
  state?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Unidad de los valores ('%', 'puntos'). */
  unit?: Maybe<Scalars['String']['output']>;
  /** Campo «units» del upstream. */
  units: Array<PlannerReportTalentTrackingUnit>;
  /** Rótulo de x axis. */
  x_axis_label?: Maybe<Scalars['String']['output']>;
  /** Rótulo de y axis. */
  y_axis_label?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentTrackingPoint = {
  __typename?: 'PlannerReportTalentTrackingPoint';
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Clave del nivel del semáforo; la resuelve el render. */
  state?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlannerReportTalentTrackingScope = {
  __typename?: 'PlannerReportTalentTrackingScope';
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Los puntos de la serie. */
  points: Array<PlannerReportTalentTrackingPoint>;
  /** Rótulo de series. */
  series_label?: Maybe<Scalars['String']['output']>;
  /** Campo «series_note» del upstream. */
  series_note?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentTrackingUnit = {
  __typename?: 'PlannerReportTalentTrackingUnit';
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['String']['output']>;
};

export type PlannerReportTalentTrendPoint = {
  __typename?: 'PlannerReportTalentTrendPoint';
  /** Etiqueta. */
  label?: Maybe<Scalars['String']['output']>;
  /** Clave del nivel del semáforo; la resuelve el render. */
  state?: Maybe<Scalars['String']['output']>;
  /** Valor. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type PlannerReportTalentWordDispersionComponent = {
  __typename?: 'PlannerReportTalentWordDispersionComponent';
  /** Los comentarios abiertos. */
  comments: Array<PlannerReportTalentSentimentComment>;
  /** Campo «comments_per_group» del upstream. */
  comments_per_group?: Maybe<Scalars['Int']['output']>;
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Filtros de pantalla. NO se emiten en el PDF. */
  filters: Array<PlannerReportTalentHeatmapFilter>;
  /** Pie. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Resumen por sentimiento. */
  sentiments: Array<PlannerReportTalentSentimentGroup>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Unidad de los valores ('%', 'puntos'). */
  unit?: Maybe<Scalars['String']['output']>;
  /** Las palabras, dimensionadas por relevancia. */
  words: Array<PlannerReportTalentSentimentWord>;
};

export enum PlannerReportToneEnum {
  ToneAlert = 'TONE_ALERT',
  ToneNeutral = 'TONE_NEUTRAL',
  ToneOk = 'TONE_OK',
  ToneOkStrong = 'TONE_OK_STRONG',
  ToneWarning = 'TONE_WARNING',
  ToneWarningSoft = 'TONE_WARNING_SOFT'
}

export type PlannerReportValueCardComponent = {
  __typename?: 'PlannerReportValueCardComponent';
  /** Discriminador del componente. */
  component_type: PlannerReportComponentTypeEnum;
  /** Descripción. */
  description?: Maybe<Scalars['String']['output']>;
  /** Pie de la tarjeta. */
  footer?: Maybe<Scalars['String']['output']>;
  /** Nombre de icono Material Symbols. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Tamaño de la cifra; nulo si es desconocido. */
  size?: Maybe<PlannerReportValueSizeEnum>;
  /** Nivel de la cifra, con el vocabulario de la escala del reporte (AGNT-057). La CIFRA no se tiñe salvo en `size: HERO`, donde la categoría va escrita debajo y el color deja de ser el único canal. */
  state?: Maybe<Scalars['String']['output']>;
  /** Subtítulo. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Título. */
  title?: Maybe<Scalars['String']['output']>;
  /** Valor crudo destacado. */
  value?: Maybe<Scalars['JSON']['output']>;
};

export enum PlannerReportValueSizeEnum {
  ValueSizeDefault = 'VALUE_SIZE_DEFAULT',
  ValueSizeHero = 'VALUE_SIZE_HERO'
}

export type PlatformModule = {
  __typename?: 'PlatformModule';
  description?: Maybe<Scalars['String']['output']>;
  enterprise: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Permission>;
  slug: Scalars['String']['output'];
};

/** PlatformModule Node */
export type PlatformModuleNode = {
  __typename?: 'PlatformModuleNode';
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum PolicyAccumulation {
  ByDate = 'BY_DATE',
  FirstDay = 'FIRST_DAY'
}

export type PolicyBalanceTemplateResponse = {
  __typename?: 'PolicyBalanceTemplateResponse';
  /** Base64-encoded CSV template content */
  csv_content?: Maybe<Scalars['String']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type PolicyBirthdayCoverageInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  policy_rules?: InputMaybe<Array<GenericConditionalInput>>;
};

export type PolicyCheckInput = {
  centralized_organization_id: Scalars['ID']['input'];
  policy_id: Scalars['ID']['input'];
};

export enum PolicyIsAutoResolvable {
  SelfApprove = 'SELF_APPROVE',
  SelfDeny = 'SELF_DENY'
}

export type PolicyNameExistsInput = {
  centralized_organization_id: Scalars['ID']['input'];
  exclude_policy_id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export enum PolicyQuantification {
  Days = 'DAYS',
  Hours = 'HOURS'
}

export enum PolicyRenovation {
  Anniversary = 'ANNIVERSARY',
  Birthday = 'BIRTHDAY',
  ByDate = 'BY_DATE'
}

export enum PolicyRenovationGranularity {
  ExactDay = 'EXACT_DAY',
  Month = 'MONTH'
}

export enum PolicyRuleByAgeApplicationModeEnum {
  Intervals = 'INTERVALS',
  SpecificYears = 'SPECIFIC_YEARS'
}

export enum PolicyRuleByAgeConditional {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export enum PolicySatDisabilityTypeEnum {
  GeneralIllness = 'GENERAL_ILLNESS',
  Maternity = 'MATERNITY',
  WorkRisk = 'WORK_RISK'
}

export enum PolicyTimeDistribution {
  Complete = 'COMPLETE',
  Partially = 'PARTIALLY'
}

export enum PolicyTimeDistributionFrequency {
  Annual = 'ANNUAL',
  Bimonthly = 'BIMONTHLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum PolicyTimeExpirableConditional {
  Days = 'DAYS',
  Months = 'MONTHS',
  Years = 'YEARS'
}

export enum PolicyTimeExpirablePeriod {
  EndedNextPeriod = 'ENDED_NEXT_PERIOD',
  TransferNextPeriod = 'TRANSFER_NEXT_PERIOD'
}

export enum PolicyTypeStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

/** Scored candidate returned by get_position_candidates. */
export type PositionCandidateNode = {
  __typename?: 'PositionCandidateNode';
  centralized_user_id?: Maybe<Scalars['Int']['output']>;
  current_position_name?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  indicator_scores: Array<IndicatorScoreNode>;
  keyword_match_percentage: Scalars['Float']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  talent_user_id: Scalars['Int']['output'];
};

export type PositionCriticalitySelectInput = {
  centralized_organization_id: Scalars['Int']['input'];
  only_active?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PositionDetailInput = {
  centralized_organization_id: Scalars['Int']['input'];
  position_id: Scalars['Int']['input'];
};

export type PositionEvaluationIndicatorInput = {
  /** Indicator ID. None → create new, present → update existing */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The indicator type. Opciones: PERFORMANCE, GOALS, COMPETENCES, NBOX, SENIORITY. */
  indicator: IndicatorTypeEnum;
  /** True if the indicator is active for Fit Score calculation */
  is_active?: Scalars['Boolean']['input'];
  /** The minimum threshold value. Numeric for PERFORMANCE/GOALS/COMPETENCES (e.g. '80'), categorical for NBOX (e.g. 'GREEN'). */
  minimum_threshold?: InputMaybe<Scalars['String']['input']>;
  /** The weight of the indicator (integer, 0-100) */
  weight?: InputMaybe<Scalars['Int']['input']>;
};

/** Evaluation Indicator linked to a position. */
export type PositionEvaluationIndicatorNode = {
  __typename?: 'PositionEvaluationIndicatorNode';
  /** Indicator ID */
  id: Scalars['Int']['output'];
  /** The indicator type (e.g., PERFORMANCE, GOALS) */
  indicator: IndicatorTypeEnum;
  /** True if the indicator is active for Fit Score calculation */
  is_active: Scalars['Boolean']['output'];
  /** The minimum threshold value. Numeric for PERFORMANCE/GOALS/COMPETENCES, categorical for NBOX. */
  minimum_threshold?: Maybe<Scalars['String']['output']>;
  /** The weight of the indicator (integer, 0-100) */
  weight?: Maybe<Scalars['Int']['output']>;
};

/** Attributes available to order families. */
export enum PositionFamilyAttributeEnum {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export type PositionFamilyListFilterInput = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PositionFamilyListInput = {
  centralized_organization_id: Scalars['Int']['input'];
  filter?: InputMaybe<PositionFamilyListFilterInput>;
  order?: InputMaybe<PositionFamilyListOrderInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PositionFamilyListOrderInput = {
  desc?: Scalars['Boolean']['input'];
  field: PositionFamilyAttributeEnum;
};

export type PositionFamilySelectInput = {
  centralized_organization_id: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PositionFamilySelectItem = {
  __typename?: 'PositionFamilySelectItem';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PositionFamilySelectList = {
  __typename?: 'PositionFamilySelectList';
  items: Array<PositionFamilySelectItem>;
  total_count: Scalars['Int']['output'];
};

export type PositionInfo = {
  __typename?: 'PositionInfo';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PositionItemSyncInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  criticality_level?: InputMaybe<OrganizationPositionCriticalityLevelEnum>;
  functions_description?: InputMaybe<Scalars['String']['input']>;
  general_description?: InputMaybe<Scalars['String']['input']>;
  leader_position_id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  position_criticality_id?: InputMaybe<Scalars['Int']['input']>;
  position_family?: InputMaybe<Scalars['String']['input']>;
  position_family_id?: InputMaybe<Scalars['Int']['input']>;
  position_key_position_id?: InputMaybe<Scalars['Int']['input']>;
};

export type PositionKeyPositionSelectInput = {
  centralized_organization_id: Scalars['Int']['input'];
  only_active?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PositionKeywordInput = {
  /** Keyword ID. None → create new, present → update existing */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** True when generated by AI */
  is_ai?: Scalars['Boolean']['input'];
  /** Soft-delete flag */
  is_deleted?: Scalars['Boolean']['input'];
  /** Keyword text */
  name: Scalars['String']['input'];
  /** Display/relevance order */
  sort_order?: Scalars['Int']['input'];
};

/** Persisted keyword linked to a position. */
export type PositionKeywordNode = {
  __typename?: 'PositionKeywordNode';
  /** Keyword ID */
  id: Scalars['Int']['output'];
  /** True when generated by AI */
  is_ai: Scalars['Boolean']['output'];
  /** Soft-delete flag */
  is_deleted: Scalars['Boolean']['output'];
  /** Keyword text */
  name: Scalars['String']['output'];
  /** Display/relevance order */
  sort_order: Scalars['Int']['output'];
};

export type PositionKeywordTemporal = {
  __typename?: 'PositionKeywordTemporal';
  /** Si fue agregada manualmente o generada por IA */
  is_manual: Scalars['Boolean']['output'];
  /** Palabra clave */
  name: Scalars['String']['output'];
  /** Porcentaje de relevancia calculado */
  percentage: Scalars['Float']['output'];
  /** Peso de la palabra clave (1=bajo, 2=medio, 3=alto) */
  weight: Scalars['Int']['output'];
};

/** Sortable attributes for position levels. */
export enum PositionLevelAttributeEnum {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export type PositionLevelListFilterInput = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PositionLevelListInput = {
  centralized_organization_id: Scalars['Int']['input'];
  filter?: InputMaybe<PositionLevelListFilterInput>;
  order?: InputMaybe<PositionLevelListOrderInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PositionLevelListOrderInput = {
  desc?: Scalars['Boolean']['input'];
  field: PositionLevelAttributeEnum;
};

export type PositionLevelSelectInput = {
  centralized_organization_id: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PositionListFilterInput = {
  has_family_eq?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  position_family_id_eq?: InputMaybe<Scalars['Int']['input']>;
  position_family_id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PositionListInfo = GraphOperationI & {
  __typename?: 'PositionListInfo';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
  positions?: Maybe<Array<PositionInfo>>;
};

export type PositionListOrderInput = {
  desc?: Scalars['Boolean']['input'];
  field?: HrisPositionListOrderFieldEnum;
};

export type PositionTableListInput = {
  centralized_organization_id: Scalars['Int']['input'];
  filter?: InputMaybe<PositionListFilterInput>;
  order?: InputMaybe<PositionListOrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PositionUsageCheckResponse = InternalErrorResponse | NotFoundResponse | PositionUsageCheckResponseNode | ValidationErrorResponse;

export type PositionUsageCheckResponseNode = {
  __typename?: 'PositionUsageCheckResponseNode';
  /** Whether the position can be modified (inverse of is_in_use) */
  can_be_modified: Scalars['Boolean']['output'];
  /** Unique identifier for the GraphQL operation */
  graphql_operation_id: Scalars['ID']['output'];
  /** Whether the position is currently in use */
  is_in_use: Scalars['Boolean']['output'];
  /** Human-readable message about the position usage status */
  message: Scalars['String']['output'];
  /** List of processes/rules that are blocking this position */
  processes: Array<OrganizationPositionBlockingProcess>;
  /** Number of processes/segmentation rules blocking this position */
  processes_count: Scalars['Int']['output'];
  /** Number of active users currently assigned to this position */
  users_count: Scalars['Int']['output'];
};

export type PostFile = {
  __typename?: 'PostFile';
  /** Optional alt text for this image (max 250 chars). */
  alternative_file_text?: Maybe<Scalars['String']['output']>;
  /** Federated file reference resolved by subgraph-file. */
  file: File;
  /** Zero-based order index defined by the user when creating the post. */
  position: Scalars['Int']['output'];
};

export type PostFileInput = {
  /** Optional alt text for this image (max 250 chars). */
  alternative_file_text?: InputMaybe<Scalars['String']['input']>;
  /** External file ID from subgraph-file. */
  file_id: Scalars['Int']['input'];
  /** Zero-based order index defined by the user. */
  position: Scalars['Int']['input'];
};

export type PreSignedData = {
  __typename?: 'PreSignedData';
  filename?: Maybe<Scalars['String']['output']>;
  pre_signed_url?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PreSignedEncryptedData = {
  __typename?: 'PreSignedEncryptedData';
  data: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

/** Node that represents key and value pairs */
export type PreSignedField = {
  __typename?: 'PreSignedField';
  field_name: Scalars['String']['output'];
  field_value: Scalars['String']['output'];
};

export type PreSignedPostPayload = FileGraphOperationI & {
  __typename?: 'PreSignedPostPayload';
  encrypted_data: PreSignedEncryptedData;
  file_id: Scalars['ID']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  uid: Scalars['ID']['output'];
};

export type PreSignedResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | PreSignedPostPayload;

export enum PrereqBannerType {
  CourseRemoved = 'COURSE_REMOVED',
  NewCoursePrereq = 'NEW_COURSE_PREREQ',
  PrereqRemoved = 'PREREQ_REMOVED',
  PrereqUpdated = 'PREREQ_UPDATED'
}

export type PrerequisiteChangeState = {
  __typename?: 'PrerequisiteChangeState';
  banner_type: PrereqBannerType;
  course_changes: Array<PrerequisiteCourseChange>;
  newly_blocked_course_ids: Array<Scalars['Int']['output']>;
  newly_unblocked_course_ids: Array<Scalars['Int']['output']>;
  next_blocked_course_id?: Maybe<Scalars['Int']['output']>;
  pending_prerequisite_course_ids: Array<Scalars['Int']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type PrerequisiteCourseChange = {
  __typename?: 'PrerequisiteCourseChange';
  course_id: Scalars['Int']['output'];
  current_prerequisite_course_ids: Array<Scalars['Int']['output']>;
  previous_prerequisite_course_ids: Array<Scalars['Int']['output']>;
};

export type PrerequisiteOrderWarning = {
  __typename?: 'PrerequisiteOrderWarning';
  locked_course_id: Scalars['ID']['output'];
  prerequisite_course_ids: Array<Scalars['ID']['output']>;
};

export enum PrerequisiteResolutionAction {
  RemoveFromSet = 'REMOVE_FROM_SET',
  Replace = 'REPLACE'
}

export type PrerequisiteResolutionInput = {
  action: PrerequisiteResolutionAction;
  removed_course_id: Scalars['ID']['input'];
  replacement_course_id?: InputMaybe<Scalars['ID']['input']>;
};

export type PreviewOrganizationTemplateInput = {
  /** Raw, unsaved template HTML from the editor. */
  html_content: Scalars['String']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Optional saved template id. If provided, its custom-attribute placeholders are added to the sample context (org-scoped, is_active=True). */
  organization_template_id?: InputMaybe<Scalars['ID']['input']>;
  /** Output format of the preview. Defaults to PDF. */
  output_format_enum?: InputMaybe<PreviewOutputFormatEnum>;
  /** Selects the sample-data shape and the rendering branch (Diploma / Acreditación / Course). */
  template_type_enum: TemplateTypeEnum;
};

export type PreviewOrganizationTemplateResponsePayload = {
  __typename?: 'PreviewOrganizationTemplateResponsePayload';
  content_type: Scalars['String']['output'];
  expires_at?: Maybe<Scalars['String']['output']>;
  preview_url: Scalars['String']['output'];
};

export enum PreviewOutputFormatEnum {
  Pdf = 'PDF',
  Png = 'PNG'
}

export type PrivateAtsAcceptOfferJobApplicantPayload = {
  __typename?: 'PrivateATSAcceptOfferJobApplicantPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsAddNoteAuditLogPayload = {
  __typename?: 'PrivateATSAddNoteAuditLogPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsAnswerLengthOutOfRangeError = {
  __typename?: 'PrivateATSAnswerLengthOutOfRangeError';
  cell: Scalars['String']['output'];
  error: Scalars['String']['output'];
  field: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type PrivateAtsApplicantConnection = {
  __typename?: 'PrivateATSApplicantConnection';
  edges: Array<PrivateAtsJobApplicantProfileEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateAtsApplicantErrorUnion = PrivateAtsAnswerLengthOutOfRangeError | PrivateAtsEmailDuplicateVacancyError | PrivateAtsEmailMisspellingError | PrivateAtsEmptyRequiredCellsError | PrivateAtsMultipleChoiceInvalidOptionError | PrivateAtsPersonalInfoInvalidFormatError | PrivateAtsSingleChoiceMultipleAnswersError | PrivateAtsYesNoInvalidValueError;

export type PrivateAtsApplicantPreviousParticipation = {
  __typename?: 'PrivateATSApplicantPreviousParticipation';
  /** ID de la participación anterior, para abrir su ficha. */
  applicant_id: Scalars['ID']['output'];
  /** Cuándo entró a esa vacante. */
  applied_at?: Maybe<Scalars['DateTime']['output']>;
  /** Cuántas PERSONAS distintas la evaluaron en esa vacante. No es el número de notas ni de atributos puntuados: una fila de scorecard es por atributo, así que contarlas devolvería atributos×secciones×evaluadores. El detalle con promedios ya se sirve por la ficha del candidato; un segundo productor del mismo promedio es como divergen los dos. */
  evaluators_count: Scalars['Int']['output'];
  /** Currículum de esa participación. Es el que se reutiliza si el reclutador trae el historial (AC-2); si empieza de cero no se copia (D3). */
  file_cv_id?: Maybe<Scalars['ID']['output']>;
  /** Cómo terminó: HIRED, DISCARDED o PROGRESS. Los tres particionan las participaciones no borradas y **descartado gana** sobre una oferta aceptada, la misma precedencia que el filtro de estado del tablero. */
  outcome: AtsJobApplicantStateEnum;
  /** Vacante en la que participó. */
  vacancy_id: Scalars['ID']['output'];
  /** Título de esa vacante. */
  vacancy_title: Scalars['String']['output'];
};

export type PrivateAtsApplicantPreviousParticipations = {
  __typename?: 'PrivateATSApplicantPreviousParticipations';
  /** Si esta persona ya participó antes. Es lo que dispara el aviso de AC-1, y se responde sin que el cliente tenga que interpretar el largo de una lista acotada. */
  has_previous_participations: Scalars['Boolean']['output'];
  /** Participaciones anteriores, de la más reciente a la más antigua. */
  participations: Array<PrivateAtsApplicantPreviousParticipation>;
  /** Cuántas participaciones anteriores tiene en total, aunque la lista venga acotada a las 10 más recientes. */
  total_count: Scalars['Int']['output'];
};

export type PrivateAtsApplicationFormExtraFieldInfo = PrivateAtsBaseExtraField & {
  __typename?: 'PrivateATSApplicationFormExtraFieldInfo';
  field_type: AtsExtraFieldTypeEnum;
  /** Job vacancy request form config extra field id */
  id: Scalars['ID']['output'];
  is_optional: Scalars['Boolean']['output'];
  is_recurring?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<PrivateAtsApplicationFormExtraFieldOption>>;
  sort_order: Scalars['Int']['output'];
};

export type PrivateAtsApplicationFormExtraFieldOption = PrivateAtsBaseExtraFieldOption & {
  __typename?: 'PrivateATSApplicationFormExtraFieldOption';
  /** Job vacancy request form config extra field option id */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
};

export type PrivateAtsApplicationFormInfo = {
  __typename?: 'PrivateATSApplicationFormInfo';
  form_info: Array<PrivateAtsApplicationFormInfoItem>;
};

export type PrivateAtsApplicationFormInfoItem = {
  __typename?: 'PrivateATSApplicationFormInfoItem';
  id: Scalars['ID']['output'];
  label: AtsFieldApplicationNameTypeEnum;
  visibility: AtsFieldVisibilityTypeEnum;
};

export type PrivateAtsApplicationFormInfoPayload = {
  __typename?: 'PrivateATSApplicationFormInfoPayload';
  application_form_info: PrivateAtsApplicationFormInfo;
  extra_field_info?: Maybe<Array<PrivateAtsApplicationFormExtraFieldInfo>>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsApproval = {
  __typename?: 'PrivateATSApproval';
  approval: Scalars['Boolean']['output'];
  approvers?: Maybe<Array<PrivateAtsApprover>>;
  job_vacancy_config_request_id: Scalars['ID']['output'];
  number_days?: Maybe<Scalars['Int']['output']>;
  type_resolution?: Maybe<AtsTypeResolutionTypeEnum>;
};

export type PrivateAtsApprover = {
  __typename?: 'PrivateATSApprover';
  approver_type: AtsApproverTypeEnum;
  id?: Maybe<Scalars['ID']['output']>;
  user_id?: Maybe<CentralizedUserAts>;
};

export type PrivateAtsApproverInput = {
  approver_type: AtsApproverTypeEnum;
  id?: InputMaybe<Scalars['ID']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type PrivateAtsAssignment = {
  __typename?: 'PrivateATSAssignment';
  id: Scalars['ID']['output'];
  restriction_by_attribute: Scalars['Boolean']['output'];
  task_rules?: Maybe<Array<PrivateAtsAssignmentRule>>;
  type_assignment: AtsTypeAssignmentTypeEnum;
};

export type PrivateAtsAssignmentJobVacancyCareerSitePayload = {
  __typename?: 'PrivateATSAssignmentJobVacancyCareerSitePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  total_assignments: Scalars['Int']['output'];
};

export type PrivateAtsAssignmentRule = {
  __typename?: 'PrivateATSAssignmentRule';
  attribute_id: Scalars['Int']['output'];
  conditional: Scalars['String']['output'];
  tag_ids: Array<Scalars['Int']['output']>;
};

export type PrivateAtsAssignmentRuleInput = {
  attribute_id: Scalars['ID']['input'];
  conditional: Scalars['String']['input'];
  tag_ids: Array<Scalars['ID']['input']>;
};

export type PrivateAtsAttachmentDocument = {
  __typename?: 'PrivateATSAttachmentDocument';
  allowed_formats: Array<AtsAttachmentAllowedFormatsEnum>;
  description_document?: Maybe<Scalars['String']['output']>;
  folder?: Maybe<PrivateAtsAttachmentFolder>;
  id?: Maybe<Scalars['ID']['output']>;
  name_document: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PrivateAtsAttachmentDocumentEdge = {
  __typename?: 'PrivateATSAttachmentDocumentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateAtsAttachmentDocument;
};

export type PrivateAtsAttachmentDocumentPayload = {
  __typename?: 'PrivateATSAttachmentDocumentPayload';
  documents: Array<PrivateAtsAttachmentDocument>;
};

export type PrivateAtsAttachmentFolder = {
  __typename?: 'PrivateATSAttachmentFolder';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  total_documents?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PrivateAtsAttachmentFolderEdge = {
  __typename?: 'PrivateATSAttachmentFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateAtsAttachmentFolder;
};

export type PrivateAtsAttachmentForm = {
  __typename?: 'PrivateATSAttachmentForm';
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_documents?: Maybe<Scalars['Int']['output']>;
  used_in_total_vacancies?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PrivateAtsAttachmentFormEdge = {
  __typename?: 'PrivateATSAttachmentFormEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateAtsAttachmentForm;
};

export type PrivateAtsAvgStageTime = {
  __typename?: 'PrivateATSAvgStageTime';
  avg_days: Scalars['Float']['output'];
  default_stage?: Maybe<Scalars['String']['output']>;
  stage_id: Scalars['Int']['output'];
  stage_name: Scalars['String']['output'];
};

export type PrivateAtsAvgStageTimeDashboard = {
  __typename?: 'PrivateATSAvgStageTimeDashboard';
  times: Array<PrivateAtsAvgStageTime>;
  vacancy_id: Scalars['ID']['output'];
};

export type PrivateAtsBaseExtraField = {
  field_type: AtsExtraFieldTypeEnum;
  is_optional: Scalars['Boolean']['output'];
  is_recurring?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
};

export type PrivateAtsBaseExtraFieldOption = {
  name: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
};

export type PrivateAtsBulkUpdateJobVacancyStagePayload = {
  __typename?: 'PrivateATSBulkUpdateJobVacancyStagePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  stages: Array<PrivateAtsJobVacancyStageDetail>;
};

export type PrivateAtsCandidateDisabilityStat = {
  __typename?: 'PrivateATSCandidateDisabilityStat';
  count_candidates_disability: Scalars['Int']['output'];
  disability_candidates: AtsDisabilityCandidatesEnum;
  percentage_disability_candidates: Scalars['Float']['output'];
};

export type PrivateAtsCandidateFormInfo = {
  __typename?: 'PrivateATSCandidateFormInfo';
  personal_info: Array<PrivateAtsPersonalInfoItem>;
  questions: Array<PrivateAtsCandidateFormQuestion>;
};

export type PrivateAtsCandidateFormQuestion = {
  __typename?: 'PrivateATSCandidateFormQuestion';
  allow_multiple_responses: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_dismiss: Scalars['Boolean']['output'];
  is_recurring?: Maybe<Scalars['Boolean']['output']>;
  is_required: Scalars['Boolean']['output'];
  question_options?: Maybe<Array<PrivateAtsCandidateFormQuestionsOption>>;
  question_state: AtsCandidateQuestionStatusEnum;
  question_type: AtsCandidateFormQuestionTypeEnum;
  response_size?: Maybe<AtsCandidateFormResponseQuestionTypeEnum>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type PrivateAtsCandidateFormQuestionsOption = {
  __typename?: 'PrivateATSCandidateFormQuestionsOption';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type PrivateAtsCandidateFormQuestionsOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type PrivateAtsCandidateGenderForVacancy = {
  __typename?: 'PrivateATSCandidateGenderForVacancy';
  count_candidates: Scalars['Int']['output'];
  gender_candidates: AtsGenderCandidatesEnum;
  percentage_gender_candidates: Scalars['Float']['output'];
};

export type PrivateAtsCandidateGenderStat = {
  __typename?: 'PrivateATSCandidateGenderStat';
  count_candidates: Scalars['Int']['output'];
  gender_candidates: AtsGenderCandidatesEnum;
  percentage_gender_candidates: Scalars['Float']['output'];
};

export type PrivateAtsCandidateProfileQuestion = {
  __typename?: 'PrivateATSCandidateProfileQuestion';
  answer_value?: Maybe<PrivateAtsJobApplicantAnswerUnion>;
  question_name?: Maybe<Scalars['String']['output']>;
  question_type?: Maybe<AtsCandidateFormQuestionTypeEnum>;
};

export type PrivateAtsCandidateProfileQuestions = {
  __typename?: 'PrivateATSCandidateProfileQuestions';
  id?: Maybe<Scalars['Int']['output']>;
  questions: Array<PrivateAtsCandidateProfileQuestion>;
};

export type PrivateAtsCandidateSource = {
  __typename?: 'PrivateATSCandidateSource';
  count: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  source: Scalars['String']['output'];
};

export type PrivateAtsCandidateSourceStat = {
  __typename?: 'PrivateATSCandidateSourceStat';
  count_candidates: Scalars['Int']['output'];
  percentage_candidates: Scalars['Float']['output'];
  source_candidates: AtsOriginCandidatesEnum;
};

export type PrivateAtsCandidateSourcesDistributionResponse = {
  __typename?: 'PrivateATSCandidateSourcesDistributionResponse';
  sources: Array<PrivateAtsCandidateSource>;
};

export type PrivateAtsCandidatesDisabilityStatsList = {
  __typename?: 'PrivateATSCandidatesDisabilityStatsList';
  disability_candidates: Array<PrivateAtsCandidateDisabilityStat>;
};

export type PrivateAtsCandidatesGenderForVacancyList = {
  __typename?: 'PrivateATSCandidatesGenderForVacancyList';
  gender_candidates: Array<PrivateAtsCandidateGenderForVacancy>;
};

export type PrivateAtsCandidatesGenderStatsList = {
  __typename?: 'PrivateATSCandidatesGenderStatsList';
  gender_candidates: Array<PrivateAtsCandidateGenderStat>;
};

export type PrivateAtsCandidatesSourceStatsList = {
  __typename?: 'PrivateATSCandidatesSourceStatsList';
  candidate_source: Array<PrivateAtsCandidateSourceStat>;
};

export type PrivateAtsCareerSiteConfig = {
  __typename?: 'PrivateATSCareerSiteConfig';
  /** Hex color for the background */
  background_color?: Maybe<Scalars['String']['output']>;
  background_image_file?: Maybe<File>;
  /** ID of the background image file */
  background_image_file_id?: Maybe<Scalars['Int']['output']>;
  /** Background type */
  background_type: AtsCareerSiteBackgroundTypeEnum;
  /** Hex color for the button */
  button_color?: Maybe<Scalars['String']['output']>;
  /** Whether the button is enabled */
  button_enabled: Scalars['Boolean']['output'];
  /** Text for the button */
  button_label?: Maybe<Scalars['String']['output']>;
  /** Description of the career site */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether description is enabled */
  description_enabled: Scalars['Boolean']['output'];
  /** ID of the career site configuration */
  id: Scalars['ID']['output'];
  /** Whether carer site is hidden */
  is_hidden: Scalars['Boolean']['output'];
  /** Whether the logo is enabled */
  logo_enabled: Scalars['Boolean']['output'];
  logo_file?: Maybe<File>;
  /** ID of the logo file */
  logo_file_id?: Maybe<Scalars['Int']['output']>;
  relative_url?: Maybe<Scalars['String']['output']>;
  /** Title of the career site */
  title: Scalars['String']['output'];
  /** Hex color for the title */
  title_color?: Maybe<Scalars['String']['output']>;
  /** Public unique identifier */
  uid?: Maybe<Scalars['String']['output']>;
  /** last updated date of career site config */
  updated_at: Scalars['DateTime']['output'];
  /** Number of vacancies */
  vacancies_count?: Maybe<Scalars['Int']['output']>;
  /** Hex color for the vacancies list */
  vacancies_list_color: Scalars['String']['output'];
  /** Style for vacancies list */
  vacancies_list_style: AtsCareerSiteVacanciesListTypeEnum;
  /** Title for vacancies list */
  vacancies_list_title: Scalars['String']['output'];
  /** visibility for vacancies list */
  visibility: AtsCareerSiteVisibilityEnum;
};

/** An edge in a connection. */
export type PrivateAtsCareerSiteConfigEdge = {
  __typename?: 'PrivateATSCareerSiteConfigEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateAtsCareerSiteConfig;
};

export type PrivateAtsCareerSiteConnection = {
  __typename?: 'PrivateATSCareerSiteConnection';
  edges: Array<PrivateAtsCareerSiteConfigEdge>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata: Metadata;
  page_info: PageInfo;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateAtsCommentJobVacancyRequestPayload = {
  __typename?: 'PrivateATSCommentJobVacancyRequestPayload';
  comment: PrivateAtsJobVacancyRequestComment;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsCompanyBadge = {
  __typename?: 'PrivateATSCompanyBadge';
  color_type: AtsCompanyBadgeColorEnum;
  created_at: Scalars['DateTime']['output'];
  /** company badge description */
  description?: Maybe<Scalars['String']['output']>;
  icon_type: AtsCompanyBadgeTypeEnum;
  /** ID of the company badge */
  id: Scalars['ID']['output'];
  is_default: Scalars['Boolean']['output'];
  /** company badge name */
  name: Scalars['String']['output'];
};

export type PrivateAtsCompanyBadgeConnection = {
  __typename?: 'PrivateATSCompanyBadgeConnection';
  edges: Array<PrivateAtsCompanyBadgeEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PrivateAtsCompanyBadgeEdge = {
  __typename?: 'PrivateATSCompanyBadgeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateAtsCompanyBadge;
};

export type PrivateAtsCreateApplicationFormPayload = {
  __typename?: 'PrivateATSCreateApplicationFormPayload';
  application_form_info: PrivateAtsApplicationFormInfo;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsCreateApprovalPayload = {
  __typename?: 'PrivateATSCreateApprovalPayload';
  approval_config: PrivateAtsApproval;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsCreateAssignmentPayload = {
  __typename?: 'PrivateATSCreateAssignmentPayload';
  assignment: PrivateAtsAssignment;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsCreateCandidateFormPayload = {
  __typename?: 'PrivateATSCreateCandidateFormPayload';
  candidate_form_info: PrivateAtsCandidateFormInfo;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsCreateCandidateFormQuestionPayload = {
  __typename?: 'PrivateATSCreateCandidateFormQuestionPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  question_info: PrivateAtsCandidateFormQuestion;
};

export type PrivateAtsCreateEvaluationCardQuestionResponsePayload = {
  __typename?: 'PrivateATSCreateEvaluationCardQuestionResponsePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  question_info: PrivateAtsEvaluationCardQuestionInfo;
};

export type PrivateAtsCreateJobApplicantTagPayload = {
  __typename?: 'PrivateATSCreateJobApplicantTagPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  job_applicant_tag: PrivateAtsTagJobApplicantProfile;
};

export type PrivateAtsCreateJobVacancyExtraField = PrivateAtsBaseExtraField & {
  __typename?: 'PrivateATSCreateJobVacancyExtraField';
  content?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  field_type: AtsExtraFieldTypeEnum;
  /** Job vacancy extra field id */
  id?: Maybe<Scalars['ID']['output']>;
  is_hidden: Scalars['Boolean']['output'];
  is_optional: Scalars['Boolean']['output'];
  is_recurring?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<PrivateAtsCreateJobVacancyExtraFieldOption>>;
  sort_order: Scalars['Int']['output'];
  /** Job vacancy id */
  vacancy_id: Scalars['ID']['output'];
};

export type PrivateAtsCreateJobVacancyExtraFieldOption = PrivateAtsBaseExtraFieldOption & {
  __typename?: 'PrivateATSCreateJobVacancyExtraFieldOption';
  /** Job vacancy extra field option id */
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
};

export type PrivateAtsCreateJobVacancyExtraFieldPayload = {
  __typename?: 'PrivateATSCreateJobVacancyExtraFieldPayload';
  extra_field_info: Array<PrivateAtsCreateJobVacancyExtraField>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsCreateJobVacancyStagePayload = {
  __typename?: 'PrivateATSCreateJobVacancyStagePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  stage: PrivateAtsJobVacancyStage;
};

export type PrivateAtsCreateOrUpdateJobVacancyStageActionTemplateInput = {
  /** Whether the action has automatic mail send */
  automatic_send?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the job vacancy action */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the action is deleted */
  is_deleted: Scalars['Boolean']['input'];
  /** Whether the action is mail discard */
  is_discard_action?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of action template, emailTemplateId or evaluationTemplateId */
  object_id: Scalars['Int']['input'];
  /** Type of the job vacancy action */
  type: AtsJobVacancyStageActionEnum;
};

export type PrivateAtsCreateOrUpdateJobVacancyStageTemplateInput = {
  /** List of main actions to update */
  actions: Array<PrivateAtsCreateOrUpdateJobVacancyStageActionTemplateInput>;
  default_stage?: InputMaybe<AtsJobVacancyStageDefaultEnum>;
  /** ID of the job vacancy stage */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the stage is deleted */
  is_deleted: Scalars['Boolean']['input'];
  /** Job vacancy stage name */
  name: Scalars['String']['input'];
  /** Job vacancy stage sort order */
  sort_order: Scalars['Int']['input'];
};

export type PrivateAtsCreateOrUpdateRecruitmentTeamPayload = {
  __typename?: 'PrivateATSCreateOrUpdateRecruitmentTeamPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  recruitment_team_info: PrivateAtsRecruitmentTeamInfo;
};

export type PrivateAtsCreateQuestionnaireResponsesPayload = {
  __typename?: 'PrivateATSCreateQuestionnaireResponsesPayload';
  answer_sections: Array<PrivateAtsStakeholderQuestionnaireUnionResponse>;
  applicant_profile: PrivateAtsJobApplicantProfile;
  evaluation_card: PrivateAtsEvaluationTemplate;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  progress: Scalars['Int']['output'];
};

export type PrivateAtsCreateUpdateCareerSiteConfigPayload = {
  __typename?: 'PrivateATSCreateUpdateCareerSiteConfigPayload';
  career_site_config: PrivateAtsCareerSiteConfig;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsCreateUpdateCompanyBadgesPayload = {
  __typename?: 'PrivateATSCreateUpdateCompanyBadgesPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsCreateUpdateJobApplicantTagPayload = {
  __typename?: 'PrivateATSCreateUpdateJobApplicantTagPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsCreateValidApplicantsPayload = {
  __typename?: 'PrivateATSCreateValidApplicantsPayload';
  created_count: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsCustomCentralizedOrganization = {
  __typename?: 'PrivateATSCustomCentralizedOrganization';
  centralized_organization_id: Scalars['ID']['output'];
  created_user?: Maybe<CentralizedUserAts>;
  has_hris: Scalars['Boolean']['output'];
  /** Whether the caller's organization has at least one active position in the centralized organization catalog. Gates the position selector on the vacancy requisition form. Always true or false, never null: it falls back to false when the catalog cannot be read. */
  has_organization_positions: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_demo: Scalars['Boolean']['output'];
  legal_file?: Maybe<File>;
  notify_approver: Scalars['Boolean']['output'];
  notify_requester: Scalars['Boolean']['output'];
  notify_team: Scalars['Boolean']['output'];
  recurring_extra_fields?: Maybe<Array<PrivateAtsCreateJobVacancyExtraField>>;
  recurring_questions?: Maybe<Array<PrivateAtsCandidateFormQuestion>>;
  rrss_logo?: Maybe<File>;
  show_client_identifier: Scalars['Boolean']['output'];
};

export type PrivateAtsDateCount = {
  __typename?: 'PrivateATSDateCount';
  date: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type PrivateAtsDeleteCompanyBadgesPayload = {
  __typename?: 'PrivateATSDeleteCompanyBadgesPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsDeleteJobVacancyConfigRequestPayload = {
  __typename?: 'PrivateATSDeleteJobVacancyConfigRequestPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsDeleteJobVacancyPayload = {
  __typename?: 'PrivateATSDeleteJobVacancyPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsDeletePipelineTemplateJobVacancyStagePayload = {
  __typename?: 'PrivateATSDeletePipelineTemplateJobVacancyStagePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsDeleteTagJobApplicantProfilePayload = {
  __typename?: 'PrivateATSDeleteTagJobApplicantProfilePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsDiscardJobApplicantPayload = {
  __typename?: 'PrivateATSDiscardJobApplicantPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsDuplicateJobVacancyPayload = {
  __typename?: 'PrivateATSDuplicateJobVacancyPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  job_vacancy: PrivateAtsJobVacancy;
};

export type PrivateAtsEditCandidateFormQuestionPayload = {
  __typename?: 'PrivateATSEditCandidateFormQuestionPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  question_info: PrivateAtsCandidateFormQuestion;
};

export type PrivateAtsEditEvaluationCardQuestionResponsePayload = {
  __typename?: 'PrivateATSEditEvaluationCardQuestionResponsePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  question_info: PrivateAtsEvaluationCardQuestionInfo;
};

export type PrivateAtsEmailDuplicateVacancyError = {
  __typename?: 'PrivateATSEmailDuplicateVacancyError';
  cell: Scalars['String']['output'];
  error: Scalars['String']['output'];
  field: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type PrivateAtsEmailMisspellingError = {
  __typename?: 'PrivateATSEmailMisspellingError';
  cell: Scalars['String']['output'];
  error: Scalars['String']['output'];
  field: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type PrivateAtsEmptyRequiredCellsError = {
  __typename?: 'PrivateATSEmptyRequiredCellsError';
  cell: Scalars['String']['output'];
  error: Scalars['String']['output'];
  field: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type PrivateAtsEnableJobVacancyCareerSitePayload = {
  __typename?: 'PrivateATSEnableJobVacancyCareerSitePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsEvaluationCardAttribute = {
  __typename?: 'PrivateATSEvaluationCardAttribute';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sort_order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type PrivateAtsEvaluationCardAttributeType = {
  __typename?: 'PrivateATSEvaluationCardAttributeType';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_deleted: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type PrivateAtsEvaluationCardAttributesInfo = {
  __typename?: 'PrivateATSEvaluationCardAttributesInfo';
  attributes: Array<PrivateAtsEvaluationCardAttribute>;
  total_attributes: Scalars['Int']['output'];
};

export type PrivateAtsEvaluationCardNotesInfo = {
  __typename?: 'PrivateATSEvaluationCardNotesInfo';
  id: Scalars['ID']['output'];
  section_type: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type PrivateAtsEvaluationCardPointInfo = {
  __typename?: 'PrivateATSEvaluationCardPointInfo';
  attributes_info: PrivateAtsEvaluationCardAttributesInfo;
  id: Scalars['ID']['output'];
  scale_info: PrivateAtsEvaluationCardScaleInfo;
  sort_order: Scalars['Int']['output'];
};

export type PrivateAtsEvaluationCardQuestionInfo = {
  __typename?: 'PrivateATSEvaluationCardQuestionInfo';
  id: Scalars['ID']['output'];
  is_required: Scalars['Boolean']['output'];
  question_text: Scalars['String']['output'];
  question_type: AtsCardTypeEnum;
};

export type PrivateAtsEvaluationCardScale = {
  __typename?: 'PrivateATSEvaluationCardScale';
  id: Scalars['ID']['output'];
  option_type: Scalars['Int']['output'];
  option_value: Scalars['Int']['output'];
  sort_order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type PrivateAtsEvaluationCardScaleInfo = {
  __typename?: 'PrivateATSEvaluationCardScaleInfo';
  /** For Evaluation card epic use the value of ATSEvaluationCardScaleTypeEnum. For stakeholder epic use the name of ATSEvaluationCardScaleTypeEnum */
  icon_type: Scalars['String']['output'];
  scale: Array<PrivateAtsEvaluationCardScale>;
  total_labels: Scalars['Int']['output'];
};

export type PrivateAtsEvaluationCardScaleType = {
  __typename?: 'PrivateATSEvaluationCardScaleType';
  icon_type: AtsEvaluationCardScaleTypeEnum;
  id: Scalars['Int']['output'];
  option_type: Scalars['Int']['output'];
  option_value: Scalars['Int']['output'];
  sort_order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type PrivateAtsEvaluationCardsConnection = {
  __typename?: 'PrivateATSEvaluationCardsConnection';
  edges: Array<PrivateAtsEvaluationTemplateEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateAtsEvaluationDetailCardQuestionInfo = {
  __typename?: 'PrivateATSEvaluationDetailCardQuestionInfo';
  id: Scalars['ID']['output'];
  is_optional: Scalars['Boolean']['output'];
  section_type: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type PrivateAtsEvaluationTemplate = {
  __typename?: 'PrivateATSEvaluationTemplate';
  attributes?: Maybe<Array<PrivateAtsEvaluationCardAttributeType>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  language_code: AtsLanguageCodeEnum;
  reference_template_id?: Maybe<Scalars['String']['output']>;
  scale_options?: Maybe<Array<PrivateAtsEvaluationCardScaleType>>;
  sections?: Maybe<Array<EvaluationCardSectionUnionResponse>>;
  state: AtsEvaluationTemplateStatusEnum;
  title?: Maybe<Scalars['String']['output']>;
  total_active_vacancies?: Maybe<Scalars['Int']['output']>;
  total_vacancies?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type PrivateAtsEvaluationTemplateCardSection = {
  __typename?: 'PrivateATSEvaluationTemplateCardSection';
  attributes_id?: Maybe<Array<Scalars['Int']['output']>>;
  card_type: AtsCardTypeEnum;
  evaluation_template_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  scale_option_ids?: Maybe<Array<Scalars['Int']['output']>>;
};

/** An edge in a connection. */
export type PrivateAtsEvaluationTemplateEdge = {
  __typename?: 'PrivateATSEvaluationTemplateEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateAtsEvaluationTemplate;
};

export type PrivateAtsFormInfoItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  label: AtsFieldApplicationNameTypeEnum;
  visibility: AtsFieldVisibilityTypeEnum;
};

export type PrivateAtsFunnelDashboard = {
  __typename?: 'PrivateATSFunnelDashboard';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  current_date: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  stages: Array<PrivateAtsFunnelStage>;
  total_discarded: Scalars['Int']['output'];
  total_discarded_percentage: Scalars['Float']['output'];
  total_received: Scalars['Int']['output'];
};

export type PrivateAtsFunnelStage = {
  __typename?: 'PrivateATSFunnelStage';
  advanced: Scalars['Int']['output'];
  conversion: Scalars['Float']['output'];
  default_stage?: Maybe<Scalars['String']['output']>;
  discarded: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  stage_id: Scalars['Int']['output'];
  stage_name: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  waiting: Scalars['Int']['output'];
};

export type PrivateAtsGeneralStatusVacancy = {
  __typename?: 'PrivateATSGeneralStatusVacancy';
  days_since_open: Scalars['Int']['output'];
  days_to_fill: Scalars['Int']['output'];
  days_to_hire: Scalars['Int']['output'];
};

export type PrivateAtsGetCareerSiteConfigPayload = {
  __typename?: 'PrivateATSGetCareerSiteConfigPayload';
  career_site_config: PrivateAtsCareerSiteConfig;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsHideCareerSiteConfigPayload = {
  __typename?: 'PrivateATSHideCareerSiteConfigPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsHiringBySourceStat = {
  __typename?: 'PrivateATSHiringBySourceStat';
  count_candidates_hired: Scalars['Int']['output'];
  percentage_candidates_hired: Scalars['Float']['output'];
  source_candidates_hired: AtsOriginCandidatesEnum;
};

export type PrivateAtsHiringBySourceStatsList = {
  __typename?: 'PrivateATSHiringBySourceStatsList';
  hiring_by_source: Array<PrivateAtsHiringBySourceStat>;
};

export type PrivateAtsHiringDashboardStats = {
  __typename?: 'PrivateATSHiringDashboardStats';
  /** Average number of DAYS between an application being created and the candidate ACCEPTING THE OFFER, TRUNCATED to whole days. The clock stops at offer acceptance, not at the moment HR creates the employee in the HRIS. Averaged over non-discarded applicants whose APPLICATION was created in the date range and who accepted an offer inside it. An acceptance with no recorded date cannot be averaged and is excluded here, although it still counts as a hire in every plain counter (hired_number, the recruiter's hired, the funnel, the candidate list). The numerator of total_hired on THIS payload also requires the date, so that field and this one describe exactly the same population. 0 when there are none. The clock now stops at the same EVENT as `days_to_hire` on the per-vacancy general status (offer acceptance), but the two numbers are NOT interchangeable: this one truncates both ends to whole dates, excludes discarded applicants and is restricted to the date range, and none of those three apply there. */
  days_to_hire: Scalars['Int']['output'];
  /** Average number of DAYS between a vacancy being published and its offer being accepted, TRUNCATED to whole days (an average of 6.9 is reported as 6), which is why an integer always arrives on this Float field. Averaged over the SAME population as `total_hired` and `days_to_hire`: non-discarded applicants whose APPLICATION was created in the date range and who accepted an offer inside it. 0 when there are none. Nothing forces acceptance to be later than publication, so anomalous data can make this negative. */
  fill_vacancy: Scalars['Float']['output'];
  /** Average number of DAYS that vacancies have been published, NOT a count of open vacancies, TRUNCATED to whole days. Computed as today minus publication date over vacancies that have ever been published (drafts excluded), whether still open or already closed. WITH a date range only vacancies whose PUBLICATION date falls in the range are averaged. For a count of open vacancies see `active_vacancies` on the vacancy dashboard stats, reading its caveat about paused vacancies first. */
  open_vacancy: Scalars['Int']['output'];
  /** Hiring conversion rate as a PERCENTAGE (0-100), NOT a count of hires. Computed as hired applicants / total applications * 100. A candidate counts as hired when they ACCEPTED THE OFFER and were not discarded; being linked as an employee in the HRIS afterwards is a separate event and is not required. With a date range the numerator is the INTERSECTION of both conditions: the application was created in the range AND the offer was accepted in the range. A candidate who applied before the range and accepted inside it is NOT counted, so this rate is not comparable to a standalone hire count. The denominator counts every application in the range, discarded ones included. Rounded with Python round(), which breaks .5 toward the even number. */
  total_hired: Scalars['Int']['output'];
};

export type PrivateAtsJobApplicantAnswerUnion = PrivateAtsJobApplicantAnswerValue | PrivateAtsJobApplicantFileQuestions;

export type PrivateAtsJobApplicantAnswerValue = {
  __typename?: 'PrivateATSJobApplicantAnswerValue';
  response_value: Scalars['String']['output'];
};

export type PrivateAtsJobApplicantAttachment = {
  __typename?: 'PrivateATSJobApplicantAttachment';
  attachments?: Maybe<Array<File>>;
};

export type PrivateAtsJobApplicantBadge = {
  __typename?: 'PrivateATSJobApplicantBadge';
  badge?: Maybe<PrivateAtsCompanyBadge>;
  comment?: Maybe<Scalars['String']['output']>;
};

export type PrivateAtsJobApplicantBlocked = {
  __typename?: 'PrivateATSJobApplicantBlocked';
  email_applicant: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_unlock?: Maybe<Scalars['Boolean']['output']>;
  job_applicant_profile_id: Scalars['ID']['output'];
  origin_blocked: OriginBlockedEnum;
  reason?: Maybe<Scalars['String']['output']>;
};

export type PrivateAtsJobApplicantCurriculum = {
  __typename?: 'PrivateATSJobApplicantCurriculum';
  curriculum?: Maybe<File>;
};

export type PrivateAtsJobApplicantFileQuestions = {
  __typename?: 'PrivateATSJobApplicantFileQuestions';
  file_question_id?: Maybe<File>;
};

export type PrivateAtsJobApplicantMassiveUploadDetail = {
  __typename?: 'PrivateATSJobApplicantMassiveUploadDetail';
  created_at: Scalars['DateTime']['output'];
  created_by_id?: Maybe<Scalars['Int']['output']>;
  error_details?: Maybe<Array<PrivateAtsApplicantErrorUnion>>;
  file_id?: Maybe<Scalars['ID']['output']>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  processed_data?: Maybe<Scalars['JSON']['output']>;
  total_errors: Scalars['Int']['output'];
  total_success: Scalars['Int']['output'];
  vacancy_id: Scalars['ID']['output'];
};

export type PrivateAtsJobApplicantProfile = {
  __typename?: 'PrivateATSJobApplicantProfile';
  /** ID del reclutador que presentó al candidato. Vacío si postuló por su cuenta o si es anterior al registro de atribución. */
  added_by_user_id?: Maybe<Scalars['Int']['output']>;
  affinity_negative_reason?: Maybe<Scalars['String']['output']>;
  affinity_positive_reason?: Maybe<Scalars['String']['output']>;
  affinity_score: Scalars['Decimal']['output'];
  affinity_summary?: Maybe<Scalars['String']['output']>;
  affinity_weight: AtsAffinityWeightEnum;
  ai_affinity_score?: Maybe<Scalars['Float']['output']>;
  badge?: Maybe<PrivateAtsJobApplicantBadge>;
  /** Si el reclutador trajo el historial previo de esta persona al presentarla. Vacío si no se preguntó: postulación pública, o anterior a esta función. */
  brings_previous_history?: Maybe<Scalars['Boolean']['output']>;
  centralized_organization_id: Scalars['ID']['output'];
  country: Scalars['String']['output'];
  created_at?: Maybe<Scalars['String']['output']>;
  disability?: Maybe<AtsDisabilityCandidatesEnum>;
  email: Scalars['String']['output'];
  file_cv?: Maybe<PrivateAtsJobApplicantCurriculum>;
  first_name: Scalars['String']['output'];
  from_job_vacancy?: Maybe<PrivateAtsJobVacancy>;
  fullname: Scalars['String']['output'];
  gender?: Maybe<AtsGenderCandidatesEnum>;
  has_accept_offer: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_blocked: Scalars['Boolean']['output'];
  is_discarded: Scalars['Boolean']['output'];
  is_internal_career_site?: Maybe<Scalars['Boolean']['output']>;
  is_marked: Scalars['Boolean']['output'];
  last_name: Scalars['String']['output'];
  linkedin_url?: Maybe<Scalars['String']['output']>;
  origin_candidates?: Maybe<AtsOriginCandidatesEnum>;
  phone: Scalars['String']['output'];
  stage?: Maybe<PrivateAtsJobVacancyStage>;
  tags?: Maybe<Array<PrivateAtsTagJobApplicantProfile>>;
  total_average_score_cards?: Maybe<Scalars['Float']['output']>;
  total_tags: Scalars['Int']['output'];
  uid?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  user?: Maybe<CentralizedUserAts>;
  vacancy: PrivateAtsJobVacancy;
};

/** An edge in a connection. */
export type PrivateAtsJobApplicantProfileEdge = {
  __typename?: 'PrivateATSJobApplicantProfileEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateAtsJobApplicantProfile;
};

export type PrivateAtsJobApplicantTagConnection = {
  __typename?: 'PrivateATSJobApplicantTagConnection';
  edges: Array<PrivateAtsTagJobApplicantProfileEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateAtsJobVacancy = {
  __typename?: 'PrivateATSJobVacancy';
  applicant_assigned?: Maybe<CentralizedUserAts>;
  applicant_user_id?: Maybe<Scalars['Int']['output']>;
  calculable_auto_currency?: Maybe<Scalars['String']['output']>;
  calculated_budget?: Maybe<Scalars['Float']['output']>;
  /** True when the vacancy is IS_PUBLISHED, defines a positive hiring_number and hired_number has reached it, i.e. the position can be closed as hired. is_paused is not part of the rule. WARNING: the value depends on hired_number being hydrated, and Boolean! cannot express 'not computed', so it reads false by design wherever the counter is never populated. Hydrated ONLY on: get_vacancy_detail_admin, and list_job_vacancy_admin when NOT filtered by only_published / only_available. Reads false-by-design on: the only_published / only_available listing routes, list_job_vacancy_career_site_admin, list_stakeholder_vacancies_collaborator, and any PrivateATSJobVacancy nested in a PrivateATSJobApplicantProfile (its .vacancy and .from_job_vacancy) — including the payload of set_applicant_profile_centralized_user, so do NOT re-read this flag off that mutation's own response. And accept_offer_job_applicant_admin — the gesture that NOW defines a hire — returns no vacancy at all, only an operation id, so there is nothing to re-read there either: refetch the vacancy detail instead. */
  can_be_closed_as_hired: Scalars['Boolean']['output'];
  /** Date the position was cancelled (search abandoned). Kept as historical fact even if the position is later reopened. */
  cancelled_at?: Maybe<Scalars['DateTime']['output']>;
  career_sites?: Maybe<Array<PrivateAtsCareerSiteConfig>>;
  change_by?: Maybe<CentralizedUserAts>;
  city?: Maybe<Scalars['String']['output']>;
  client_name?: Maybe<Scalars['String']['output']>;
  closed_at?: Maybe<Scalars['DateTime']['output']>;
  contract_type?: Maybe<AtsVacancyContractTypeEnum>;
  count_applicants?: Maybe<Scalars['Int']['output']>;
  count_data?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  extra_field_info?: Maybe<Array<PrivateAtsCreateJobVacancyExtraField>>;
  gross_margin?: Maybe<Scalars['Float']['output']>;
  gross_margin_amount?: Maybe<Scalars['Float']['output']>;
  /** Date the position was closed as hired. Not the candidate's hire date. Kept as historical fact even if the position is later reopened. */
  hired_at?: Maybe<Scalars['DateTime']['output']>;
  /** Number of candidates of this vacancy who ACCEPTED THE OFFER and were not discarded or deleted. This is the canonical definition of a hire in the ATS: it does NOT require HR to have created the employee in the HRIS, which is a later and separate event. Null where the counter is not hydrated -- see the caveat on `can_be_closed_as_hired` for the exact list of routes. */
  hired_number?: Maybe<Scalars['Int']['output']>;
  hiring_number?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_available_career_site?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_paused?: Maybe<Scalars['Boolean']['output']>;
  keywords?: Maybe<Array<PrivateAtsKeywords>>;
  mixed_scheme_compensation?: Maybe<Scalars['Float']['output']>;
  monthly_rate?: Maybe<Scalars['Float']['output']>;
  open_date?: Maybe<Scalars['DateTime']['output']>;
  /** Id of the organization position this vacancy was created from. Null when the requisition was filled without picking a position, or when the picked position could not be resolved. */
  origin_position_id?: Maybe<Scalars['Int']['output']>;
  /** Name the origin position had when the vacancy was created. A frozen snapshot: renaming the position does not change it. */
  origin_position_name?: Maybe<Scalars['String']['output']>;
  personal_info?: Maybe<Array<PrivateAtsPersonalInfoItem>>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  questions?: Maybe<Array<PrivateAtsCandidateFormQuestion>>;
  recruiter_assigned?: Maybe<CentralizedUserAts>;
  recruiter_user_id?: Maybe<Scalars['Int']['output']>;
  recruitment_team?: Maybe<PrivateAtsRecruitmentTeamInfo>;
  relative_url?: Maybe<Scalars['String']['output']>;
  requisition_identifier?: Maybe<Scalars['String']['output']>;
  salary?: Maybe<Scalars['Float']['output']>;
  service_monthly_compensation?: Maybe<Scalars['Float']['output']>;
  show_contract_type?: Maybe<Scalars['Boolean']['output']>;
  show_location?: Maybe<Scalars['Boolean']['output']>;
  show_salary?: Maybe<Scalars['Boolean']['output']>;
  show_work_mode?: Maybe<Scalars['Boolean']['output']>;
  show_work_team_id?: Maybe<Scalars['Boolean']['output']>;
  show_workday?: Maybe<Scalars['Boolean']['output']>;
  stages?: Maybe<Array<PrivateAtsJobVacancyStage>>;
  state?: Maybe<AtsJobVacancyStatusEnum>;
  template_monthly_compensation?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  total_keywords?: Maybe<Scalars['Int']['output']>;
  type_vacancy?: Maybe<AtsVacancyPositionStatusEnum>;
  work_mode?: Maybe<AtsVacancyWorkModalityEnum>;
  work_team?: Maybe<CentralizedAreaAts>;
  work_team_id?: Maybe<Scalars['Int']['output']>;
  workday?: Maybe<AtsVacancyWorkScheduleEnum>;
};

export type PrivateAtsJobVacancyAction = PrivateAtsJobVacancyAttachmentFormAction | PrivateAtsJobVacancyEmailAction | PrivateAtsJobVacancyEvaluationAction;

/** Action for attachment form in vacancy stage */
export type PrivateAtsJobVacancyAttachmentFormAction = {
  __typename?: 'PrivateATSJobVacancyAttachmentFormAction';
  attachment_form: PrivateAtsAttachmentForm;
  /** id of base job vacancy stage action pipeline template */
  base_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  type: AtsJobVacancyStageActionEnum;
};

export type PrivateAtsJobVacancyCareerSite = {
  __typename?: 'PrivateATSJobVacancyCareerSite';
  /** Career site configuration details */
  career_site?: Maybe<PrivateAtsCareerSiteConfig>;
  /** ID of the career site */
  career_site_config_id: Scalars['ID']['output'];
  /** Title of the career site */
  career_site_title?: Maybe<Scalars['String']['output']>;
  /** UID of the career site */
  career_site_uid?: Maybe<Scalars['String']['output']>;
  /** Creation timestamp */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the assignment */
  id: Scalars['ID']['output'];
  /** Whether the assignment is active */
  is_active: Scalars['Boolean']['output'];
  /** Job vacancy details */
  job_vacancy?: Maybe<PrivateAtsJobVacancy>;
  /** ID of the job vacancy */
  job_vacancy_id: Scalars['ID']['output'];
  /** When the vacancy was published on this career site */
  published_at?: Maybe<Scalars['DateTime']['output']>;
  /** Display order */
  sort_order: Scalars['Int']['output'];
  /** When the vacancy was unpublished from this career site */
  unpublished_at?: Maybe<Scalars['DateTime']['output']>;
  /** Last update timestamp */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type PrivateAtsJobVacancyCareerSiteConnection = {
  __typename?: 'PrivateATSJobVacancyCareerSiteConnection';
  edges: Array<PrivateAtsJobVacancyCareerSiteEdge>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata: Metadata;
  page_info: PageInfo;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PrivateAtsJobVacancyCareerSiteEdge = {
  __typename?: 'PrivateATSJobVacancyCareerSiteEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateAtsJobVacancyCareerSite;
};

export type PrivateAtsJobVacancyConfigRequest = {
  __typename?: 'PrivateATSJobVacancyConfigRequest';
  application_form?: Maybe<PrivateAtsApplicationFormInfo>;
  approval?: Maybe<PrivateAtsApproval>;
  assigned_recruiter?: Maybe<CentralizedUserAts>;
  assignment?: Maybe<PrivateAtsAssignment>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_visible?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  type_application: AtsTypeApplicationTypeEnum;
};

export type PrivateAtsJobVacancyConfigRequestConnection = {
  __typename?: 'PrivateATSJobVacancyConfigRequestConnection';
  edges: Array<PrivateAtsJobVacancyConfigRequestListItemEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateAtsJobVacancyConfigRequestListItem = {
  __typename?: 'PrivateATSJobVacancyConfigRequestListItem';
  created_at: Scalars['DateTime']['output'];
  created_by_id?: Maybe<CentralizedUserAts>;
  is_visible: Scalars['Boolean']['output'];
  job_vacancy_config_request_id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  people_count: Scalars['Int']['output'];
  request_count: Scalars['Int']['output'];
  requester_user_ids?: Maybe<Array<Scalars['Int']['output']>>;
  requester_users?: Maybe<Array<CentralizedUserAts>>;
  type_application: AtsTypeApplicationTypeEnum;
};

/** An edge in a connection. */
export type PrivateAtsJobVacancyConfigRequestListItemEdge = {
  __typename?: 'PrivateATSJobVacancyConfigRequestListItemEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateAtsJobVacancyConfigRequestListItem;
};

/** An edge in a connection. */
export type PrivateAtsJobVacancyEdge = {
  __typename?: 'PrivateATSJobVacancyEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateAtsJobVacancy;
};

export type PrivateAtsJobVacancyEmailAction = {
  __typename?: 'PrivateATSJobVacancyEmailAction';
  automatic_send: Scalars['Boolean']['output'];
  /** id of base job vacancy stage action pipeline template */
  base_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  mail_template: PrivateAtsMailTemplate;
  type: AtsJobVacancyStageActionEnum;
};

export type PrivateAtsJobVacancyEvaluationAction = {
  __typename?: 'PrivateATSJobVacancyEvaluationAction';
  /** id of base job vacancy stage action pipeline template */
  base_id?: Maybe<Scalars['ID']['output']>;
  evaluation_card: PrivateAtsEvaluationTemplate;
  /** is null when is a pipeline template */
  evaluator_ids?: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  type: AtsJobVacancyStageActionEnum;
};

export type PrivateAtsJobVacancyFilterOption = {
  __typename?: 'PrivateATSJobVacancyFilterOption';
  /** Distinct external-client names across the organization's vacancies. Internal and confidential: empty unless the organization enabled show_client_identifier. */
  client_name?: Maybe<Array<Scalars['String']['output']>>;
  contract_type?: Maybe<Array<AtsVacancyContractTypeEnum>>;
  country?: Maybe<Array<Scalars['String']['output']>>;
  /** Distinct recruiters assigned across the organization's vacancies, as federated references. Resolve the person's name through the supergraph; this subgraph only stores the id. Unordered. */
  recruiter_assigned?: Maybe<Array<CentralizedUserAts>>;
  salary_currency?: Maybe<Array<Scalars['String']['output']>>;
  vacancy_type?: Maybe<Array<AtsVacancyPositionStatusEnum>>;
  work_mode?: Maybe<Array<AtsVacancyWorkModalityEnum>>;
  work_team?: Maybe<Array<CentralizedAreaAts>>;
  workday?: Maybe<Array<AtsVacancyWorkScheduleEnum>>;
};

export type PrivateAtsJobVacancyRequest = {
  __typename?: 'PrivateATSJobVacancyRequest';
  approvers?: Maybe<Array<PrivateAtsRequestApprover>>;
  comment?: Maybe<Scalars['String']['output']>;
  config_request: PrivateAtsJobVacancyConfigRequest;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by: CentralizedUserAts;
  id: Scalars['ID']['output'];
  job_vacancy?: Maybe<PrivateAtsJobVacancy>;
  state: AtsRequestStateTypeEnum;
};

export type PrivateAtsJobVacancyRequestComment = {
  __typename?: 'PrivateATSJobVacancyRequestComment';
  created_at: Scalars['DateTime']['output'];
  created_by: CentralizedUserAts;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type PrivateAtsJobVacancyRequestCommentConnection = {
  __typename?: 'PrivateATSJobVacancyRequestCommentConnection';
  edges: Array<PrivateAtsJobVacancyRequestCommentEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PrivateAtsJobVacancyRequestCommentEdge = {
  __typename?: 'PrivateATSJobVacancyRequestCommentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateAtsJobVacancyRequestComment;
};

export type PrivateAtsJobVacancyRequestConnection = {
  __typename?: 'PrivateATSJobVacancyRequestConnection';
  edges: Array<PrivateAtsJobVacancyRequestEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PrivateAtsJobVacancyRequestEdge = {
  __typename?: 'PrivateATSJobVacancyRequestEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateAtsJobVacancyRequest;
};

export type PrivateAtsJobVacancyStage = {
  __typename?: 'PrivateATSJobVacancyStage';
  applicants_count?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  job_vacancy_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sort_order: Scalars['Int']['output'];
};

export type PrivateAtsJobVacancyStageActionBase = {
  __typename?: 'PrivateATSJobVacancyStageActionBase';
  automatic_send: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_discard: Scalars['Boolean']['output'];
  object_id: Scalars['Int']['output'];
  object_title?: Maybe<Scalars['String']['output']>;
  object_type: AtsJobVacancyStageActionEnum;
};

export type PrivateAtsJobVacancyStageBase = {
  __typename?: 'PrivateATSJobVacancyStageBase';
  actions: Array<PrivateAtsJobVacancyStageActionBase>;
  default_stage?: Maybe<AtsJobVacancyStageDefaultEnum>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
};

export type PrivateAtsJobVacancyStageDetail = {
  __typename?: 'PrivateATSJobVacancyStageDetail';
  actions: Array<PrivateAtsJobVacancyAction>;
  applicants_count?: Maybe<Scalars['Int']['output']>;
  /** id of base job vacancy stage pipeline template */
  base_id?: Maybe<Scalars['ID']['output']>;
  discard_actions?: Maybe<Array<PrivateAtsJobVacancyAction>>;
  /** id of job vacancy stage */
  id: Scalars['ID']['output'];
  is_blocked?: Maybe<Scalars['Boolean']['output']>;
  is_trash: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
};

export type PrivateAtsJobVacancyStagesPayload = {
  __typename?: 'PrivateATSJobVacancyStagesPayload';
  stages: Array<PrivateAtsJobVacancyStageDetail>;
};

export type PrivateAtsKeywords = KeywordsBase & {
  __typename?: 'PrivateATSKeywords';
  id: Scalars['ID']['output'];
  is_manual: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  weight: AtsKeywordWeightEnum;
};

export type PrivateAtsListJobApplicantTagsPayload = {
  __typename?: 'PrivateATSListJobApplicantTagsPayload';
  company_tags?: Maybe<Array<PrivateAtsTagJobApplicantProfile>>;
  tags?: Maybe<Array<PrivateAtsTagJobApplicantProfile>>;
};

export type PrivateAtsMailTemplate = {
  __typename?: 'PrivateATSMailTemplate';
  attachments?: Maybe<Array<PrivateAtsMailTemplateAttachment>>;
  body: Scalars['String']['output'];
  category: AtsMailTemplateCategoryEnum;
  change_by?: Maybe<CentralizedUserAts>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  default_identifier?: Maybe<AtsTemplateBaseEnum>;
  has_actions?: Maybe<Scalars['Boolean']['output']>;
  has_job_schedule?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  language_code: AtsLanguageCodeEnum;
  lexical_body?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<PrivateAtsScheduleInfo>;
  state: AtsMailTemplateStatusEnum;
  subject: Scalars['String']['output'];
  template_banner?: Maybe<File>;
  template_description?: Maybe<Scalars['String']['output']>;
  template_name: Scalars['String']['output'];
  template_reference_id?: Maybe<Scalars['ID']['output']>;
  template_reference_type?: Maybe<AtsTemplateEmailReferenceTypeEnum>;
};

export type PrivateAtsMailTemplateAttachment = {
  __typename?: 'PrivateATSMailTemplateAttachment';
  attachment?: Maybe<File>;
};

/** An edge in a connection. */
export type PrivateAtsMailTemplateEdge = {
  __typename?: 'PrivateATSMailTemplateEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateAtsMailTemplate;
};

export type PrivateAtsMailTemplatesConnection = {
  __typename?: 'PrivateATSMailTemplatesConnection';
  edges: Array<PrivateAtsMailTemplateEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateAtsMoveDiscardedJobApplicantPayload = {
  __typename?: 'PrivateATSMoveDiscardedJobApplicantPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsMoveStateJobApplicantPayload = {
  __typename?: 'PrivateATSMoveStateJobApplicantPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  number_job_applicants: Scalars['Int']['output'];
  stage: PrivateAtsStageType;
};

export type PrivateAtsMultipleChoiceInvalidOptionError = {
  __typename?: 'PrivateATSMultipleChoiceInvalidOptionError';
  cell: Scalars['String']['output'];
  error: Scalars['String']['output'];
  field: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type PrivateAtsPersonalInfoInvalidFormatError = {
  __typename?: 'PrivateATSPersonalInfoInvalidFormatError';
  cell: Scalars['String']['output'];
  error: Scalars['String']['output'];
  field: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type PrivateAtsPersonalInfoItem = {
  __typename?: 'PrivateATSPersonalInfoItem';
  id: Scalars['ID']['output'];
  label: AtsCandidatePersonalInfoTypeEnum;
  visibility: AtsCandidateFormVisibilityTypeEnum;
};

export type PrivateAtsPersonalInfoItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  label: AtsCandidatePersonalInfoTypeEnum;
  visibility: AtsCandidateFormVisibilityTypeEnum;
};

export type PrivateAtsPipelineByStage = {
  __typename?: 'PrivateATSPipelineByStage';
  automatic_send?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_offer: Scalars['Boolean']['output'];
  job_applicant_profiles: Array<PrivateAtsJobApplicantProfile>;
  name: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
  total_job_applicant: Scalars['Int']['output'];
};

export type PrivateAtsPipelineByStageList = {
  __typename?: 'PrivateATSPipelineByStageList';
  stages: Array<PrivateAtsPipelineByStage>;
};

export type PrivateAtsPipelineTemplateJobVacancyStage = {
  __typename?: 'PrivateATSPipelineTemplateJobVacancyStage';
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_default: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type PrivateAtsPipelineTemplateJobVacancyStageConnection = {
  __typename?: 'PrivateATSPipelineTemplateJobVacancyStageConnection';
  edges: Array<PrivateAtsPipelineTemplateJobVacancyStageInsightEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateAtsPipelineTemplateJobVacancyStageInsight = {
  __typename?: 'PrivateATSPipelineTemplateJobVacancyStageInsight';
  count_stages: Scalars['Int']['output'];
  count_vacancies: Scalars['Int']['output'];
  /** id of pipeline template job vacancy stage */
  id: Scalars['ID']['output'];
  template: PrivateAtsPipelineTemplateJobVacancyStage;
};

/** An edge in a connection. */
export type PrivateAtsPipelineTemplateJobVacancyStageInsightEdge = {
  __typename?: 'PrivateATSPipelineTemplateJobVacancyStageInsightEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateAtsPipelineTemplateJobVacancyStageInsight;
};

export type PrivateAtsPipelineTemplateJobVacancyStagePayload = {
  __typename?: 'PrivateATSPipelineTemplateJobVacancyStagePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** id of pipeline template job vacancy stage */
  id: Scalars['ID']['output'];
  stages: Array<PrivateAtsJobVacancyStageBase>;
  template: PrivateAtsPipelineTemplateJobVacancyStage;
};

export type PrivateAtsPipelineTemplateReducedJobVacancyStage = {
  __typename?: 'PrivateATSPipelineTemplateReducedJobVacancyStage';
  /** id of pipeline template job vacancy stage */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PrivateAtsPipelineTemplateReducedJobVacancyStagePayload = {
  __typename?: 'PrivateATSPipelineTemplateReducedJobVacancyStagePayload';
  templates: Array<PrivateAtsPipelineTemplateReducedJobVacancyStage>;
};

export type PrivateAtsPublishVacancyPayload = {
  __typename?: 'PrivateATSPublishVacancyPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  vacancy: PrivateAtsJobVacancy;
};

export type PrivateAtsQuestionApplicantProfile = {
  __typename?: 'PrivateATSQuestionApplicantProfile';
  question_id: Scalars['ID']['output'];
  question_text: Scalars['String']['output'];
  question_type: Scalars['String']['output'];
  responses: Array<PrivateAtsQuestionResponseApplicantProfile>;
};

export type PrivateAtsQuestionResponseApplicantProfile = {
  __typename?: 'PrivateATSQuestionResponseApplicantProfile';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  reviewer?: Maybe<CentralizedUserAts>;
  reviewer_id: Scalars['ID']['output'];
  work_team?: Maybe<CentralizedAreaAts>;
  work_team_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsRecruiterDetail = {
  __typename?: 'PrivateATSRecruiterDetail';
  id: Scalars['Int']['output'];
  user_info?: Maybe<CentralizedUserAts>;
};

export type PrivateAtsRecruitmentPerformance = {
  __typename?: 'PrivateATSRecruitmentPerformance';
  active_vacancies: Scalars['Int']['output'];
  candidate: Scalars['Int']['output'];
  /** Number of candidates of this recruiter's vacancies who ACCEPTED THE OFFER and were not discarded or deleted. A count, not a rate. Being linked as an employee in the HRIS afterwards is a separate event and is not required. Not comparable to `candidate`, which counts every candidate of those vacancies including discarded and deleted ones. */
  hired: Scalars['Int']['output'];
  /** Average number of DAYS between a candidate applying to one of this recruiter's vacancies and ACCEPTING THE OFFER, TRUNCATED to whole days. The clock stops at offer acceptance, not at the moment HR creates the employee in the HRIS. Averaged over the same population `hired` counts, minus acceptances with no recorded date, which cannot be averaged. 0 when there are none. */
  hiring_time?: Maybe<Scalars['Int']['output']>;
  recruitment?: Maybe<CentralizedUserAts>;
};

/** An edge in a connection. */
export type PrivateAtsRecruitmentPerformanceEdge = {
  __typename?: 'PrivateATSRecruitmentPerformanceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateAtsRecruitmentPerformance;
};

export type PrivateAtsRecruitmentTeamInfo = {
  __typename?: 'PrivateATSRecruitmentTeamInfo';
  evaluator_users?: Maybe<Array<PrivateAtsRecruiterDetail>>;
  /** vacancy id */
  id: Scalars['Int']['output'];
  recruiter_users?: Maybe<Array<PrivateAtsRecruiterDetail>>;
  seeker_users?: Maybe<Array<PrivateAtsRecruiterDetail>>;
  stakeholders_users?: Maybe<Array<PrivateAtsRecruiterDetail>>;
};

export type PrivateAtsRecruitmentTeamVacancyPerformance = {
  __typename?: 'PrivateATSRecruitmentTeamVacancyPerformance';
  active_days: Scalars['Int']['output'];
  candidates: Scalars['Int']['output'];
  name_vacancy: Scalars['String']['output'];
  state_vacancy: Scalars['String']['output'];
  vacancy_id: Scalars['Int']['output'];
};

export type PrivateAtsRecruitmentTeamVacancyPerformanceList = {
  __typename?: 'PrivateATSRecruitmentTeamVacancyPerformanceList';
  detail_recruitment_team: Array<PrivateAtsRecruitmentTeamVacancyPerformance>;
};

export type PrivateAtsReportRequest = {
  __typename?: 'PrivateATSReportRequest';
  file?: Maybe<File>;
  file_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_cached: Scalars['Boolean']['output'];
  state: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export type PrivateAtsRequestApprover = {
  __typename?: 'PrivateATSRequestApprover';
  id?: Maybe<Scalars['ID']['output']>;
  state: AtsRequestStateTypeEnum;
  user?: Maybe<CentralizedUserAts>;
};

export type PrivateAtsRequestReportPayload = {
  __typename?: 'PrivateATSRequestReportPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  report: PrivateAtsReportRequest;
};

export type PrivateAtsScheduleInfo = {
  __typename?: 'PrivateATSScheduleInfo';
  days: AtsScheduleDaysEnum;
  hour: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
};

export type PrivateAtsScoreCardAttributeApplicantProfile = {
  __typename?: 'PrivateATSScoreCardAttributeApplicantProfile';
  attribute_id: Scalars['ID']['output'];
  average_attribute: Scalars['Float']['output'];
  average_total_card: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  scores: Array<PrivateAtsScoreResponseApplicantProfile>;
  title: Scalars['String']['output'];
};

export type PrivateAtsScoreResponseApplicantProfile = {
  __typename?: 'PrivateATSScoreResponseApplicantProfile';
  reviewer?: Maybe<CentralizedUserAts>;
  reviewer_id: Scalars['ID']['output'];
  score: Scalars['Int']['output'];
};

export type PrivateAtsScoresAndQuestionsApplicantProfile = {
  __typename?: 'PrivateATSScoresAndQuestionsApplicantProfile';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  questions: Array<PrivateAtsQuestionApplicantProfile>;
  score_card_attributes: Array<PrivateAtsScoreCardAttributeApplicantProfile>;
  title: Scalars['String']['output'];
  total_average: Scalars['Float']['output'];
};

export type PrivateAtsSendNotificationPayload = {
  __typename?: 'PrivateATSSendNotificationPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  result?: Maybe<PrivateAtsSendNotificationResult>;
  success: Scalars['Boolean']['output'];
};

export type PrivateAtsSendNotificationResult = {
  __typename?: 'PrivateATSSendNotificationResult';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  failed_count: Scalars['Int']['output'];
  sent_count: Scalars['Int']['output'];
};

export type PrivateAtsSingleChoiceMultipleAnswersError = {
  __typename?: 'PrivateATSSingleChoiceMultipleAnswersError';
  cell: Scalars['String']['output'];
  error: Scalars['String']['output'];
  field: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type PrivateAtsStageType = {
  __typename?: 'PrivateATSStageType';
  id: Scalars['String']['output'];
  is_blocked?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type PrivateAtsStakeholderAttributeAnswer = {
  __typename?: 'PrivateATSStakeholderAttributeAnswer';
  /** job_applicant_card_question_id */
  answer_id?: Maybe<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  response_scale_id?: Maybe<Scalars['Int']['output']>;
  sort_order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type PrivateAtsStakeholderAttributesAnswerInfo = {
  __typename?: 'PrivateATSStakeholderAttributesAnswerInfo';
  attributes: Array<PrivateAtsStakeholderAttributeAnswer>;
  total_attributes: Scalars['Int']['output'];
};

export type PrivateAtsStakeholderAttributesSectionAnswerInfo = {
  __typename?: 'PrivateATSStakeholderAttributesSectionAnswerInfo';
  attributes_info: PrivateAtsStakeholderAttributesAnswerInfo;
  /** point_id */
  id: Scalars['ID']['output'];
  scale_info: PrivateAtsEvaluationCardScaleInfo;
  section_type: AtsCardTypeEnum;
  sort_order: Scalars['Int']['output'];
};

export type PrivateAtsStakeholderNotesSectionAnswerInfo = {
  __typename?: 'PrivateATSStakeholderNotesSectionAnswerInfo';
  /** job_applicant_card_question_id */
  answer_id?: Maybe<Scalars['ID']['output']>;
  /** card_section_id */
  id: Scalars['ID']['output'];
  response?: Maybe<Scalars['String']['output']>;
  section_type: AtsCardTypeEnum;
  sort_order: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type PrivateAtsStakeholderQuestionSectionAnswerInfo = {
  __typename?: 'PrivateATSStakeholderQuestionSectionAnswerInfo';
  /** job_applicant_card_question_id */
  answer_id?: Maybe<Scalars['ID']['output']>;
  /** card_section_id */
  id: Scalars['ID']['output'];
  is_optional: Scalars['Boolean']['output'];
  response?: Maybe<Scalars['String']['output']>;
  section_type: AtsCardTypeEnum;
  sort_order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type PrivateAtsStakeholderQuestionnaire = {
  __typename?: 'PrivateATSStakeholderQuestionnaire';
  answer_sections: Array<PrivateAtsStakeholderQuestionnaireUnionResponse>;
  applicant_profile: PrivateAtsJobApplicantProfile;
  evaluation_card: PrivateAtsEvaluationTemplate;
  progress: Scalars['Int']['output'];
};

export type PrivateAtsStakeholderQuestionnaireUnionResponse = PrivateAtsStakeholderAttributesSectionAnswerInfo | PrivateAtsStakeholderNotesSectionAnswerInfo | PrivateAtsStakeholderQuestionSectionAnswerInfo;

export type PrivateAtsStakeholderTask = {
  __typename?: 'PrivateATSStakeholderTask';
  applicant_profile: PrivateAtsJobApplicantProfile;
  evaluation_card?: Maybe<PrivateAtsEvaluationTemplate>;
  progress_stage: Scalars['Int']['output'];
};

export type PrivateAtsStakeholderTaskConnection = {
  __typename?: 'PrivateATSStakeholderTaskConnection';
  edges: Array<PrivateAtsStakeholderTaskEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PrivateAtsStakeholderTaskEdge = {
  __typename?: 'PrivateATSStakeholderTaskEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateAtsStakeholderTask;
};

export type PrivateAtsStakeholderVacancies = {
  __typename?: 'PrivateATSStakeholderVacancies';
  vacancies?: Maybe<Array<PrivateAtsJobVacancy>>;
};

export type PrivateAtsSuccessStatePayload = {
  __typename?: 'PrivateATSSuccessStatePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  request: PrivateAtsJobVacancyRequest;
};

export type PrivateAtsTagJobApplicantProfile = {
  __typename?: 'PrivateATSTagJobApplicantProfile';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_company_tag?: Maybe<Scalars['Boolean']['output']>;
  job_applicant_id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
};

/** An edge in a connection. */
export type PrivateAtsTagJobApplicantProfileEdge = {
  __typename?: 'PrivateATSTagJobApplicantProfileEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateAtsTagJobApplicantProfile;
};

export type PrivateAtsTrackVisitPayload = {
  __typename?: 'PrivateATSTrackVisitPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  registered: Scalars['Boolean']['output'];
};

export type PrivateAtsUpdateJobApplicantTagsPayload = {
  __typename?: 'PrivateATSUpdateJobApplicantTagsPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  job_applicant_id: Scalars['String']['output'];
  tags: Array<PrivateAtsTagJobApplicantProfile>;
};

export type PrivateAtsUpdateJobVacancyActionInput = {
  automatic_send?: InputMaybe<Scalars['Boolean']['input']>;
  evaluator_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  is_trash: Scalars['Boolean']['input'];
  object_id: Scalars['Int']['input'];
  type: AtsJobVacancyStageActionEnum;
};

export type PrivateAtsUpdateJobVacancyConfigRequestVisibilityPayload = {
  __typename?: 'PrivateATSUpdateJobVacancyConfigRequestVisibilityPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateAtsUpdateJobVacancyStageInput = {
  actions: Array<PrivateAtsUpdateJobVacancyActionInput>;
  discard_actions: Array<PrivateAtsUpdateJobVacancyActionInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  is_trash: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

export type PrivateAtsUpdateStateJobVacancyPayload = {
  __typename?: 'PrivateATSUpdateStateJobVacancyPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  vacancy: PrivateAtsJobVacancy;
};

export type PrivateAtsVacancyAttributionOptions = {
  __typename?: 'PrivateATSVacancyAttributionOptions';
  /** Quienes agregaron al menos un candidato en esta vacante, como referencias federadas: pedí `user { full_name }` en la misma consulta para el nombre. Vacío si todos postularon por su cuenta. */
  added_by: Array<CentralizedUserAts>;
};

export type PrivateAtsVacancyConnection = {
  __typename?: 'PrivateATSVacancyConnection';
  edges: Array<PrivateAtsJobVacancyEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateAtsVacancyDashboardStats = {
  __typename?: 'PrivateATSVacancyDashboardStats';
  /** Count of vacancies in PUBLISHED state - the closest field to 'how many open vacancies do I have', with two caveats. PAUSED VACANCIES ARE INCLUDED: pausing sets a separate is_paused flag and leaves the state untouched, so this can exceed what candidates actually see on the career site. And with a date range it counts published vacancies CREATED in that range, which is not the same as the vacancies that were open during it. */
  active_vacancies: Scalars['Int']['output'];
  /** Positions closed because the search was cancelled. */
  cancelled_vacancies: Scalars['Int']['output'];
  /** Count of applicants that are neither deleted nor discarded and belong to a PUBLISHED vacancy. Applicants of closed vacancies are excluded, so this does not add up to the applicants of `total_vacancies`. Unlike the vacancy counters above, this does NOT exclude applicants of soft-deleted vacancies: deleting a vacancy leaves its state untouched, so its applicants keep counting here while the vacancy itself disappears from `total_vacancies`. Filtered by application creation date when a date range is given. */
  candidates_in_process: Scalars['Int']['output'];
  /** Count of closed vacancies. Filtered by vacancy creation date when a date range is given. */
  closed_vacancies: Scalars['Int']['output'];
  /** Percentage of published positions that ended as hired. Only positions recorded with the hired state count towards it, so it reads low until recruiters adopt the new states. Drafts are excluded from the denominator. */
  fill_rate: Scalars['Float']['output'];
  /** Positions closed because somebody was hired. */
  hired_vacancies: Scalars['Int']['output'];
  /** Count of vacancies of the organization that are either published or closed. DRAFTS AND DELETED VACANCIES ARE EXCLUDED, so this is not the count of every vacancy ever created. Filtered by vacancy creation date when a date range is given. */
  total_vacancies: Scalars['Int']['output'];
};

export type PrivateAtsVisitsAndApplicationsVacancyAdminResponse = {
  __typename?: 'PrivateATSVisitsAndApplicationsVacancyAdminResponse';
  date_applications: Array<PrivateAtsDateCount>;
  date_visits: Array<PrivateAtsDateCount>;
};

export type PrivateAtsYesNoInvalidValueError = {
  __typename?: 'PrivateATSYesNoInvalidValueError';
  cell: Scalars['String']['output'];
  error: Scalars['String']['output'];
  field: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type PrivateAnswerChoiceType = BaseAnswerI & {
  __typename?: 'PrivateAnswerChoiceType';
  answer_text?: Maybe<Scalars['String']['output']>;
  attachment_id?: Maybe<Scalars['Int']['output']>;
  attachment_url?: Maybe<UrlNode>;
  created_by_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_automated?: Maybe<Scalars['Boolean']['output']>;
  is_correct_answer?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  question?: Maybe<PrivateQuizQuestionType>;
  updated_by_id?: Maybe<Scalars['Int']['output']>;
};

export type PrivateApproveJobVacancyRequestStakeholderPayload = {
  __typename?: 'PrivateApproveJobVacancyRequestStakeholderPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  request: PrivateAtsJobVacancyRequest;
};

export type PrivateAutomationRuleFragment = PrivateCourseAutomationRuleType | PrivateSkillXpAutomationRuleType | PrivateUserTeamAutomationRuleType;

export type PrivateAutomationRuleType = {
  current_version: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_paused: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rule_type: AutomationRuleTypeEnum;
  segmentation_rules: AutomationSegmentationRulesFragmentListResponse;
  user?: Maybe<UserAutomationRule>;
  users_created_at_range?: Maybe<UserCreateAtRangeType>;
};

export type PrivateBoxType = {
  __typename?: 'PrivateBoxType';
  default_image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  occurrences?: Maybe<Scalars['Float']['output']>;
};

export type PrivateCourseAutomationRuleType = PrivateAutomationRuleType & {
  __typename?: 'PrivateCourseAutomationRuleType';
  assigned_courses: CourseAutomationRuleTypeListResponse;
  current_version: Scalars['Int']['output'];
  customizations?: Maybe<AutomationRuleCustomizationType>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_paused: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rule_type: AutomationRuleTypeEnum;
  segmentation_rules: AutomationSegmentationRulesFragmentListResponse;
  user?: Maybe<UserAutomationRule>;
  users_created_at_range?: Maybe<UserCreateAtRangeType>;
};

export type PrivateCourseModuleType = {
  __typename?: 'PrivateCourseModuleType';
  course: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  lessons_set?: Maybe<Array<VideoLectureType>>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  zipped_attachment?: Maybe<Scalars['String']['output']>;
};

/** Type for Admin or Staff */
export type PrivateCourseType = CourseI & {
  __typename?: 'PrivateCourseType';
  background_color?: Maybe<Scalars['String']['output']>;
  best_seller?: Maybe<Scalars['Boolean']['output']>;
  course_attachments_set: Array<AttachmentType>;
  course_config?: Maybe<CourseConfigType>;
  course_type?: Maybe<CourseTypeEnum>;
  description: Scalars['String']['output'];
  discount: Scalars['Int']['output'];
  duration: Scalars['Int']['output'];
  exclude: Scalars['Boolean']['output'];
  has_certificate?: Maybe<Scalars['Boolean']['output']>;
  home_image?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_draft?: Maybe<Scalars['Boolean']['output']>;
  is_flagship?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  knowledge_hub_visibility: VisibilityLevelType;
  level?: Maybe<LevelType>;
  meta_description: Scalars['String']['output'];
  meta_keywords: Scalars['String']['output'];
  meta_title?: Maybe<Scalars['String']['output']>;
  modified_date?: Maybe<Scalars['DateTime']['output']>;
  modules_set: Array<PrivateCourseModuleType>;
  popular: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  professor_id?: Maybe<Scalars['Int']['output']>;
  promo_image?: Maybe<SimpleFile>;
  promo_image_video?: Maybe<Scalars['String']['output']>;
  promo_video?: Maybe<Scalars['String']['output']>;
  promo_video_hashed_id: Scalars['String']['output'];
  short_description?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  videos: Scalars['Int']['output'];
};

export type PrivateCourseTypePaginationEdge = {
  __typename?: 'PrivateCourseTypePaginationEdge';
  /** The item at the end of the edge. */
  node: PrivateCourseType;
};

export type PrivateCurrencyEventListType = {
  __typename?: 'PrivateCurrencyEventListType';
  items: Array<PrivateCurrencyEventType>;
  metadata: Scalars['JSON']['output'];
};

export type PrivateCurrencyEventType = ICurrencyEventType & {
  __typename?: 'PrivateCurrencyEventType';
  custom_description?: Maybe<Scalars['String']['output']>;
  custom_name?: Maybe<Scalars['String']['output']>;
  custom_text?: Maybe<Scalars['String']['output']>;
  event_type_enum?: Maybe<EventTypeEnum>;
  icon?: Maybe<ImageNode>;
  settings?: Maybe<Scalars['JSON']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type PrivateCurrencyPointFragment = PrivateCurrencyPointType | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type PrivateCurrencyPointType = ICurrencyPointType & {
  __typename?: 'PrivateCurrencyPointType';
  events: PrivateCurrencyEventListType;
  name?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  status_enum?: Maybe<CurrencyPointStatusEnum>;
};


export type PrivateCurrencyPointTypeEventsArgs = {
  input: QueryCurrencyEventInput;
};

export type PrivateExcelReport = {
  __typename?: 'PrivateExcelReport';
  download_url?: Maybe<Scalars['String']['output']>;
};

export type PrivateExcelReportFragment = PrivateExcelReport | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type PrivateGenerateKeywordsPayload = {
  __typename?: 'PrivateGenerateKeywordsPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  keywords_generated: Array<AtsKeywordsTemporal>;
  total_to_generate: Scalars['Int']['output'];
};

export type PrivateGetMassiveCompetencesStatusResponse = {
  __typename?: 'PrivateGetMassiveCompetencesStatusResponse';
  /** status information about the massive competences process, e.g. ({'state': 'FINISHED', 'processed_competences': 100}) */
  status_info: Scalars['JSON']['output'];
};

export type PrivateGetMassiveParticipantsStatusResponse = {
  __typename?: 'PrivateGetMassiveParticipantsStatusResponse';
  /** Status information about the massive participants upload process, e.g. ({'state': 'FINISHED', 'processed_participants': 100}) */
  status_info: Scalars['JSON']['output'];
};

export type PrivateLeaderboardBoxesType = {
  __typename?: 'PrivateLeaderboardBoxesType';
  most_common_achievement?: Maybe<PrivateBoxType>;
  most_common_event?: Maybe<PrivateBoxType>;
  most_common_reward?: Maybe<PrivateBoxType>;
};

export type PrivateLeaderboardListType = {
  __typename?: 'PrivateLeaderboardListType';
  items: Array<PrivateLeaderboardTypePrivateUserAssigmentType>;
  metadata: Scalars['JSON']['output'];
};

export type PrivateLeaderboardType = IAllowedUserType & {
  __typename?: 'PrivateLeaderboardType';
  achievements_set: Scalars['JSON']['output'];
  email?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  game_indicators?: Maybe<Scalars['JSON']['output']>;
  is_active: Scalars['Boolean']['output'];
  last_name: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['DateTime']['output']>;
  profile_picture?: Maybe<ImageNode>;
  tag_list: Scalars['JSON']['output'];
  user_id: Scalars['ID']['output'];
};

export type PrivateLeaderboardTypePrivateUserAssigmentType = PrivateLeaderboardType | PrivateUserAssigmentType;

export type PrivateLiveSessionListType = {
  __typename?: 'PrivateLiveSessionListType';
  items: Array<PrivateLiveSessionType>;
  metadata: Scalars['JSON']['output'];
};

export type PrivateLiveSessionResourceType = {
  __typename?: 'PrivateLiveSessionResourceType';
  external_url_resource?: Maybe<Scalars['String']['output']>;
  file?: Maybe<File>;
  id: Scalars['ID']['output'];
  upload_by?: Maybe<UserLiveSession>;
};

/** Type defined for the administrator - staff */
export type PrivateLiveSessionType = LiveSessionI & {
  __typename?: 'PrivateLiveSessionType';
  cover_image?: Maybe<File>;
  created_at: Scalars['DateTime']['output'];
  created_by?: Maybe<UserLiveSession>;
  created_by_id?: Maybe<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  end_date: Scalars['String']['output'];
  end_date_original: Scalars['DateTime']['output'];
  has_qr_available?: Maybe<Scalars['Boolean']['output']>;
  home_image_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  instructor_name?: Maybe<Scalars['String']['output']>;
  issues_certificate?: Maybe<Scalars['Boolean']['output']>;
  last_session_users_engagements: Array<SessionUserEngagementFragment>;
  location?: Maybe<Scalars['String']['output']>;
  qr_assistance?: Maybe<LiveSessionQrAssistanceType>;
  record_file?: Maybe<File>;
  record_file_id?: Maybe<Scalars['ID']['output']>;
  record_file_name?: Maybe<Scalars['String']['output']>;
  record_file_url?: Maybe<Scalars['String']['output']>;
  session_link?: Maybe<UrlType>;
  session_record?: Maybe<SessionRecordFragment>;
  session_report?: Maybe<LiveSessionReportType>;
  session_resources: SessionResourceListType;
  session_title: Scalars['String']['output'];
  source_origin?: Maybe<LiveSessionSourceOriginType>;
  start_date: Scalars['String']['output'];
  start_date_original: Scalars['DateTime']['output'];
  status_session?: Maybe<SessionStatusEnum>;
  time_zone: SessionTimeZoneEnum;
  timeline?: Maybe<SessionTimeLineEnum>;
  total_guests?: Maybe<Scalars['Int']['output']>;
  type_session: SessionTypeEnum;
  version_report?: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type PrivateLiveSessionTypeEdge = {
  __typename?: 'PrivateLiveSessionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateLiveSessionType;
};

export type PrivateQuizQuestionType = BaseQuestionI & {
  __typename?: 'PrivateQuizQuestionType';
  answer_set?: Maybe<Array<QuestionAnswerType>>;
  attachment_file?: Maybe<File>;
  attachment_id?: Maybe<Scalars['Int']['output']>;
  attachment_url?: Maybe<UrlNode>;
  created_by_id?: Maybe<Scalars['Int']['output']>;
  default_answer_order?: Maybe<Scalars['String']['output']>;
  feedback_text?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  pair_answer_set?: Maybe<Array<PairAnswerChoiceType>>;
  question_help_text?: Maybe<Scalars['String']['output']>;
  question_text?: Maybe<Scalars['String']['output']>;
  question_type?: Maybe<Scalars['String']['output']>;
  related_video_lecture_id?: Maybe<Scalars['Int']['output']>;
  value_percentage?: Maybe<Scalars['Float']['output']>;
  value_points?: Maybe<Scalars['Int']['output']>;
};

export type PrivateQuizType = BaseQuizI & {
  __typename?: 'PrivateQuizType';
  approval_method?: Maybe<QuizApprovalMethodEnum>;
  approval_percentage?: Maybe<QuizApprovalEnum>;
  approval_points?: Maybe<Scalars['Int']['output']>;
  created_by_id?: Maybe<Scalars['Int']['output']>;
  has_dinamic_questions?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_completed_course_required?: Maybe<Scalars['Boolean']['output']>;
  max_points?: Maybe<Scalars['Int']['output']>;
  num_question?: Maybe<Scalars['Int']['output']>;
  number_dinamic_questions?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  question_set?: Maybe<Array<PrivateQuizQuestionType>>;
  questions_in_random_order?: Maybe<Scalars['Boolean']['output']>;
  quiz_type?: Maybe<QuizTypeEnum>;
  retry_limit?: Maybe<QuizRetryLimitEnum>;
  retry_time?: Maybe<QuizRetryTimeEnum>;
  show_answers?: Maybe<QuizShowAnswerEnum>;
  show_answers_immediately?: Maybe<Scalars['Boolean']['output']>;
  time_to_complete?: Maybe<QuizTimeLimitEnum>;
  title?: Maybe<Scalars['String']['output']>;
  updated_by_id?: Maybe<Scalars['Int']['output']>;
};

export type PrivateQuizTypeConnection = {
  __typename?: 'PrivateQuizTypeConnection';
  /** A list of edges in this connection. */
  edges: Array<PrivateQuizTypeEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type PrivateQuizTypeConnectionQueryInternalError = PrivateQuizTypeConnection | QueryInternalError;

export type PrivateQuizTypeEdge = {
  __typename?: 'PrivateQuizTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PrivateQuizType;
};

export type PrivateRewardListType = {
  __typename?: 'PrivateRewardListType';
  items: Array<PrivateRewardType>;
  metadata: Scalars['JSON']['output'];
};

export type PrivateRewardType = IRewardType & {
  __typename?: 'PrivateRewardType';
  /** Reward cover */
  cover_attachment?: Maybe<ImageNode>;
  currency_point_value?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['JSON']['output']>;
  money_value?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Field for allowed redemptions with a limit on the quantity of redemptions. */
  redemptions_allowed?: Maybe<Scalars['Int']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  status_enum?: Maybe<RewardStatusEnum>;
  tags: Array<Scalars['String']['output']>;
};

export type PrivateSessionConnection = {
  __typename?: 'PrivateSessionConnection';
  /** A list of edges in this connection. */
  edges: Array<PrivateLiveSessionTypeEdge>;
  metadata?: Maybe<LiveSessionMetaDataType>;
  /** Pagination data for this connection */
  page_info: PageInfo;
};

export type PrivateSessionUserConnection = {
  __typename?: 'PrivateSessionUserConnection';
  /** A list of edges in this connection. */
  edges: Array<UserSessionFragmentPaginationEdge>;
  metadata?: Maybe<LiveSessionUserMetaDataType>;
  /** Information to aid in pagination. */
  page_info: NumberPageInfo;
  page_size?: Maybe<Scalars['Int']['output']>;
};

export type PrivateSkillXpAutomationRuleType = PrivateAutomationRuleType & {
  __typename?: 'PrivateSkillXpAutomationRuleType';
  assigned_skill_xp_tests: SkillXpAutomationRuleTypeListResponse;
  current_version: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_paused: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rule_type: AutomationRuleTypeEnum;
  segmentation_rules: AutomationSegmentationRulesFragmentListResponse;
  user?: Maybe<UserAutomationRule>;
  users_created_at_range?: Maybe<UserCreateAtRangeType>;
};

export type PrivateTalentActivateCompetencesModelPayload = {
  __typename?: 'PrivateTalentActivateCompetencesModelPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentAddEvaluatedToEvaluationPayload = {
  __typename?: 'PrivateTalentAddEvaluatedToEvaluationPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentAddEvaluatorsEvaluationPayload = {
  __typename?: 'PrivateTalentAddEvaluatorsEvaluationPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentAdvancedConfigurationEvaluation = {
  __typename?: 'PrivateTalentAdvancedConfigurationEvaluation';
  enable_result_evaluate: Scalars['Boolean']['output'];
  hide_relations: Scalars['Boolean']['output'];
  penalize_evaluation_not_finished: Scalars['Boolean']['output'];
  quit_results_in_zero: Scalars['Boolean']['output'];
  show_all_relations: Scalars['Boolean']['output'];
  show_in_platform: Scalars['Boolean']['output'];
};

export type PrivateTalentApplicationMedalsConnection = {
  __typename?: 'PrivateTalentApplicationMedalsConnection';
  edges: Array<PrivateTalentRecognitionApplicationsMedalsEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentBehavior = {
  __typename?: 'PrivateTalentBehavior';
  /** ID of the associated competence level */
  competence_level_id?: Maybe<Scalars['Int']['output']>;
  /** Behavior text shown to the evaluator, sourced from question2.description for the evaluator-evaluated pair. */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  /** Minimum expected value */
  min_expected?: Maybe<Scalars['Float']['output']>;
  /** Behavior name in English */
  name_en?: Maybe<Scalars['String']['output']>;
  /** Behavior name in Spanish */
  name_es?: Maybe<Scalars['String']['output']>;
  /** Behavior name in Portuguese */
  name_pt?: Maybe<Scalars['String']['output']>;
  /** Display sequence */
  sequence?: Maybe<Scalars['Int']['output']>;
  /** Activation state of the behavior */
  state?: Maybe<Scalars['String']['output']>;
  /** Subgroup the behavior belongs to */
  subgroup?: Maybe<Scalars['String']['output']>;
  /** Weight assigned to the behavior */
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PrivateTalentBoolResponse = {
  __typename?: 'PrivateTalentBoolResponse';
  response: Scalars['Boolean']['output'];
};

export type PrivateTalentClimateProcess = {
  __typename?: 'PrivateTalentClimateProcess';
  company_id?: Maybe<Scalars['Int']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  /** Climate evaluation ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Climate evaluation name */
  name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  /** Climate evaluation state (state2) */
  state?: Maybe<Scalars['String']['output']>;
};

export type PrivateTalentCommentBlock = {
  __typename?: 'PrivateTalentCommentBlock';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  mandatory?: Maybe<Scalars['Boolean']['output']>;
};

export type PrivateTalentCommentBox = {
  __typename?: 'PrivateTalentCommentBox';
  code: Scalars['String']['output'];
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  translations: Array<PrivateTalentCommentBoxTranslation>;
};

export type PrivateTalentCommentBoxTranslation = {
  __typename?: 'PrivateTalentCommentBoxTranslation';
  label?: Maybe<Scalars['String']['output']>;
  language_code?: Maybe<Scalars['String']['output']>;
};

export type PrivateTalentCommentsEvaluation = {
  __typename?: 'PrivateTalentCommentsEvaluation';
  by_behavior: PrivateTalentCommentBlock;
  by_competence: PrivateTalentCommentBlock;
  final_comments: PrivateTalentFinalComments;
};

export type PrivateTalentCompanyConfiguration = TalentCompanyConfigurationI & {
  __typename?: 'PrivateTalentCompanyConfiguration';
  configuration_profile_id?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  double_validation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Scalars['String']['output']>;
  selected: Scalars['Boolean']['output'];
  state?: Maybe<Scalars['Boolean']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PrivateTalentCompanyEmployeeConnection = {
  __typename?: 'PrivateTalentCompanyEmployeeConnection';
  edges: Array<PrivateTalentEmployeeEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentCompanyGoal = {
  __typename?: 'PrivateTalentCompanyGoal';
  /** Company goal description */
  description?: Maybe<Scalars['String']['output']>;
  /** Goal period the company goal belongs to */
  goal_period_id: Scalars['Int']['output'];
  /** Company goal ID */
  id: Scalars['Int']['output'];
  /** Company goal name */
  name: Scalars['String']['output'];
  /** Company goal state */
  state?: Maybe<Scalars['String']['output']>;
};

export type PrivateTalentCompanyLevel = {
  __typename?: 'PrivateTalentCompanyLevel';
  company_id: Scalars['Int']['output'];
  created_date?: Maybe<Scalars['DateTime']['output']>;
  deleted_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  is_selected_in_search?: Maybe<Scalars['Boolean']['output']>;
  last_inactivated_date?: Maybe<Scalars['DateTime']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  master_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PrivateTalentCompanyLevelListPayload = {
  __typename?: 'PrivateTalentCompanyLevelListPayload';
  levels: Array<PrivateTalentCompanyLevel>;
};

export type PrivateTalentCompanyMailTemplateConnection = {
  __typename?: 'PrivateTalentCompanyMailTemplateConnection';
  edges: Array<PrivateTalentMailTemplateEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentCompanyMailTemplatePayload = {
  __typename?: 'PrivateTalentCompanyMailTemplatePayload';
  mail_template: PrivateTalentMailTemplate;
};

export type PrivateTalentCompetence = {
  __typename?: 'PrivateTalentCompetence';
  active?: Maybe<Scalars['Boolean']['output']>;
  company_id?: Maybe<Scalars['Int']['output']>;
  competence_model_id?: Maybe<Scalars['Int']['output']>;
  competence_type_id?: Maybe<Scalars['Int']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  deleted_date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_inactivated_date?: Maybe<Scalars['DateTime']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  levels?: Maybe<Array<Scalars['Int']['output']>>;
  macro_competence?: Maybe<Scalars['String']['output']>;
  master_id?: Maybe<Scalars['Int']['output']>;
  min_expected?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  name_en?: Maybe<Scalars['String']['output']>;
  name_es?: Maybe<Scalars['String']['output']>;
  name_pt?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  sector_id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  update_results_not_include?: Maybe<Scalars['Boolean']['output']>;
};

export type PrivateTalentCompetenceDashboardPayload = {
  __typename?: 'PrivateTalentCompetenceDashboardPayload';
  /** Evaluation entity for the competence dashboard */
  evaluation: PrivateTalentEvaluation;
  /** Aggregated statistics for the competence dashboard */
  statistics: PrivateTalentCompetenceDashboardStatistics;
};

export type PrivateTalentCompetenceDashboardStatistics = {
  __typename?: 'PrivateTalentCompetenceDashboardStatistics';
  /** Relations in FINISHED state */
  total_completed_relations: Scalars['Int']['output'];
  /** Relations in CONFIGURE state */
  total_configured_relations: Scalars['Int']['output'];
  /** Total distinct participants with non-canceled relations */
  total_participants: Scalars['Int']['output'];
  /** Relations in ASSIGNED or IN_PROGRESS state */
  total_pending_relations: Scalars['Int']['output'];
  /** Completion progress percentage rounded to 2 decimals */
  total_progress: Scalars['Float']['output'];
  /** Total non-canceled relations */
  total_relations: Scalars['Int']['output'];
};

export type PrivateTalentCompetenceEmailTemplateItem = {
  __typename?: 'PrivateTalentCompetenceEmailTemplateItem';
  content?: Maybe<Scalars['String']['output']>;
  language_code: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
};

export type PrivateTalentCompetenceEvaluatedConnection = {
  __typename?: 'PrivateTalentCompetenceEvaluatedConnection';
  edges: Array<PrivateTalentCompetenceEvaluatedPayloadEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentCompetenceEvaluatedPayload = {
  __typename?: 'PrivateTalentCompetenceEvaluatedPayload';
  /** Behaviors (questions) assigned under this competence for the evaluator-evaluated pair. */
  behaviors: Array<PrivateTalentBehavior>;
  /** The competence the evaluator must grade. */
  competence: PrivateTalentCompetence;
};

/** An edge in a connection. */
export type PrivateTalentCompetenceEvaluatedPayloadEdge = {
  __typename?: 'PrivateTalentCompetenceEvaluatedPayloadEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentCompetenceEvaluatedPayload;
};

export type PrivateTalentCompetenceLevel = {
  __typename?: 'PrivateTalentCompetenceLevel';
  active: Scalars['Boolean']['output'];
  competence_id?: Maybe<Scalars['Int']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  deleted_date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  description_en?: Maybe<Scalars['String']['output']>;
  description_es?: Maybe<Scalars['String']['output']>;
  description_pt?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  last_inactivated_date?: Maybe<Scalars['DateTime']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  level_id?: Maybe<Scalars['Int']['output']>;
  min_expected?: Maybe<Scalars['Decimal']['output']>;
  minimum: Scalars['Float']['output'];
  state?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentCompetenceModelTemplatePayload = {
  __typename?: 'PrivateTalentCompetenceModelTemplatePayload';
  /** URL of the generated Excel template file for the competence model. */
  file_url: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentCompetenceStatistics = {
  __typename?: 'PrivateTalentCompetenceStatistics';
  level_behaviors_count?: Maybe<Array<PrivateTalentLevelBehaviorsCount>>;
};

export type PrivateTalentCompetenceWeightTemplatePayload = {
  __typename?: 'PrivateTalentCompetenceWeightTemplatePayload';
  /** URL of the generated Excel template file for massive competence weights upload. */
  file_url: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentCompetenceWithStatistics = {
  __typename?: 'PrivateTalentCompetenceWithStatistics';
  competence: PrivateTalentCompetence;
  statistics?: Maybe<PrivateTalentCompetenceStatistics>;
};

export type PrivateTalentCompetencesContext = {
  __typename?: 'PrivateTalentCompetencesContext';
  competence: PrivateTalentCompetence;
  status: Scalars['String']['output'];
};

export type PrivateTalentCompetencesDashboardUrlPayload = {
  __typename?: 'PrivateTalentCompetencesDashboardUrlPayload';
  /** Talent competences dashboard URL */
  url: Scalars['String']['output'];
};

export type PrivateTalentCompetencesFilter = {
  __typename?: 'PrivateTalentCompetencesFilter';
  competence_list: Array<Scalars['Int']['output']>;
  competence_model_id?: Maybe<Scalars['Int']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  division_filter_list?: Maybe<Array<Scalars['Int']['output']>>;
  id: Scalars['Int']['output'];
  job_filter_list?: Maybe<Array<Scalars['Int']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  profile_filter_list?: Maybe<Array<Scalars['Int']['output']>>;
  relation_filter_list?: Maybe<Array<Scalars['Int']['output']>>;
  state?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['DateTime']['output']>;
};

export type PrivateTalentCompetencesFilterConnection = {
  __typename?: 'PrivateTalentCompetencesFilterConnection';
  edges: Array<PrivateTalentCompetencesFilterEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentCompetencesFilterCoverage = {
  __typename?: 'PrivateTalentCompetencesFilterCoverage';
  competences_context: Array<PrivateTalentCompetencesContext>;
  filter: PrivateTalentCompetencesFilter;
};

/** An edge in a connection. */
export type PrivateTalentCompetencesFilterEdge = {
  __typename?: 'PrivateTalentCompetencesFilterEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentCompetencesFilter;
};

export type PrivateTalentCompetencesModel = TalentCompetencesModelI & {
  __typename?: 'PrivateTalentCompetencesModel';
  attachment_id?: Maybe<Scalars['Int']['output']>;
  behavior_weight_configuration?: Maybe<Scalars['Boolean']['output']>;
  company_id?: Maybe<Scalars['Int']['output']>;
  competence_weight_configuration?: Maybe<Scalars['Boolean']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  deleted_date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  field_macro_competence?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  last_inactivated_date?: Maybe<Scalars['DateTime']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  learning_file_id?: Maybe<Scalars['Int']['output']>;
  minimum_expected_configuration?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_model?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type_competence_model?: Maybe<Scalars['String']['output']>;
  user_admin?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentCompetencesModelListPayload = {
  __typename?: 'PrivateTalentCompetencesModelListPayload';
  competences_models: Array<PrivateTalentCompetencesModel>;
};

export type PrivateTalentCompetencesModelStatistic = {
  __typename?: 'PrivateTalentCompetencesModelStatistic';
  total_behaviors?: Maybe<Scalars['Int']['output']>;
  /** total evaluated collaborator in a evaluation associated in model */
  total_colab_associated?: Maybe<Scalars['Int']['output']>;
  total_competences?: Maybe<Scalars['Int']['output']>;
  total_evaluation_started?: Maybe<Scalars['Int']['output']>;
  total_evaluations?: Maybe<Scalars['Int']['output']>;
  total_macro_competences?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentCompetencesModelStatisticConnection = {
  __typename?: 'PrivateTalentCompetencesModelStatisticConnection';
  edges: Array<PrivateTalentCompetencesModelStatisticsEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentCompetencesModelStatistics = {
  __typename?: 'PrivateTalentCompetencesModelStatistics';
  competences_model: PrivateTalentCompetencesModel;
  /** competences model statistics like total evaluation by model */
  statistics: PrivateTalentCompetencesModelStatistic;
};

/** An edge in a connection. */
export type PrivateTalentCompetencesModelStatisticsEdge = {
  __typename?: 'PrivateTalentCompetencesModelStatisticsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentCompetencesModelStatistics;
};

export type PrivateTalentCompetencesStatistic = {
  __typename?: 'PrivateTalentCompetencesStatistic';
  total_evaluated?: Maybe<Scalars['Int']['output']>;
  total_finished?: Maybe<Scalars['Int']['output']>;
  total_questionnaires?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentCompetencesStatistics = {
  __typename?: 'PrivateTalentCompetencesStatistics';
  evaluation: PrivateTalentEvaluation;
  /** competences evaluation statistics like total questionnaires */
  statistics: PrivateTalentCompetencesStatistic;
};

export type PrivateTalentCompetencesStatisticsConnection = {
  __typename?: 'PrivateTalentCompetencesStatisticsConnection';
  edges: Array<PrivateTalentCompetencesStatisticsEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PrivateTalentCompetencesStatisticsEdge = {
  __typename?: 'PrivateTalentCompetencesStatisticsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentCompetencesStatistics;
};

export type PrivateTalentCreateBehaviorPayload = {
  __typename?: 'PrivateTalentCreateBehaviorPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** behavior id */
  id: Scalars['ID']['output'];
};

export type PrivateTalentCreateCompetenceFilterPayload = {
  __typename?: 'PrivateTalentCreateCompetenceFilterPayload';
  /** The newly created competence filter. */
  filter: PrivateTalentCompetencesFilter;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentCreateCompetenceLevelPayload = {
  __typename?: 'PrivateTalentCreateCompetenceLevelPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** competence level id */
  id: Scalars['ID']['output'];
};

export type PrivateTalentCreateCompetencePayload = {
  __typename?: 'PrivateTalentCreateCompetencePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** competence id */
  id: Scalars['ID']['output'];
};

export type PrivateTalentCreateDipLibraryActivityInput = {
  /** Activity class ("Clase"). Origin: activity_pid.class. */
  activity_class?: InputMaybe<Scalars['String']['input']>;
  /** Optional activity attachment. Origin: activity_pid.attachment_id. */
  attachment_id?: InputMaybe<Scalars['Int']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Job-level id the activity applies to (chips in the library view). Null = every job level ("Todos", RN-004). Origin: activity_pid.company_level. */
  company_level_id?: InputMaybe<Scalars['Int']['input']>;
  /** Activity description. Origin: activity_pid.description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Conditional detail (RN-003): ids of the module elements (competences / goals / OKRs) the activity is linked to. SEVERAL may be sent for one activity — the dropdown of the modal is multi-select — and the BE writes one bridge row per id in the table matching the type. Only valid when type != WITHOUTPROCESS; null/empty means no detail. */
  detail_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** PID process that owns the activity (RN-013). Origin: activity_pid.plan_id. */
  dip_id: Scalars['ID']['input'];
  /** 70-20-10 model bucket (SEVENTY / TWENTY / TEN). Origin: activity_pid.model_70_20_10. */
  model_70_20_10?: InputMaybe<ActivityDipModelLabelsEnum>;
  /** Activity name. Required (RN-002) -> ValidationErrorV2 if empty. Origin: activity_pid.name. */
  name: Scalars['String']['input'];
  /** Points the activity contributes. Origin: activity_pid.points. */
  points?: InputMaybe<Scalars['Int']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** "Proceso" of the modal = module the activity is linked to. WITHOUTPROCESS = "Sin proceso". Origin: activity_pid.type. Limited to the modules enabled in Step 1 (RN-011). */
  type: PidActivityTypeEnum;
};

export type PrivateTalentCreateDipLibraryActivityPayload = {
  __typename?: 'PrivateTalentCreateDipLibraryActivityPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** Id of the created library activity. */
  id: Scalars['ID']['output'];
};

export type PrivateTalentCreateDraftCompetencesModelPayload = {
  __typename?: 'PrivateTalentCreateDraftCompetencesModelPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** ID of the newly created draft competences model */
  id: Scalars['ID']['output'];
};

export type PrivateTalentCreateEvaluationPayload = {
  __typename?: 'PrivateTalentCreateEvaluationPayload';
  evaluation?: Maybe<PrivateTalentEvaluation>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentCreateRecognitionMedalPayload = {
  __typename?: 'PrivateTalentCreateRecognitionMedalPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  recognition_company_created: PrivateTalentRecognitionCompany;
};

export type PrivateTalentCreateRecognitionRewardPayload = {
  __typename?: 'PrivateTalentCreateRecognitionRewardPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  product?: Maybe<PrivateTalentRecognitionProduct>;
};

export type PrivateTalentDip = {
  __typename?: 'PrivateTalentDIP';
  act_approve_employee?: Maybe<Scalars['Boolean']['output']>;
  act_delete_boss?: Maybe<Scalars['Boolean']['output']>;
  act_delete_employee?: Maybe<Scalars['Boolean']['output']>;
  act_edit_boss?: Maybe<Scalars['Boolean']['output']>;
  acted_item_employee?: Maybe<Scalars['Boolean']['output']>;
  activity_create_boss_to_collaborator?: Maybe<Scalars['Boolean']['output']>;
  allow_assign_existing_task?: Maybe<Scalars['Boolean']['output']>;
  allow_assign_new_task?: Maybe<Scalars['Boolean']['output']>;
  allow_auto_questions: Scalars['Boolean']['output'];
  allow_climate_culture?: Maybe<Scalars['Boolean']['output']>;
  allow_climate_process?: Maybe<Scalars['Boolean']['output']>;
  allow_competence_act?: Maybe<Scalars['Boolean']['output']>;
  allow_goal_act?: Maybe<Scalars['Boolean']['output']>;
  allow_indicators_kpi?: Maybe<Scalars['Boolean']['output']>;
  allow_max_act_comp_act?: Maybe<Scalars['Boolean']['output']>;
  allow_okr_act?: Maybe<Scalars['Boolean']['output']>;
  allow_okr_process?: Maybe<Scalars['Boolean']['output']>;
  allow_other_act?: Maybe<Scalars['Boolean']['output']>;
  allow_without_process_activity?: Maybe<Scalars['Boolean']['output']>;
  approved_activities_super_boss?: Maybe<Scalars['Boolean']['output']>;
  assign_boss?: Maybe<Scalars['Boolean']['output']>;
  behavior_deficit?: Maybe<Scalars['Boolean']['output']>;
  climate_id_associate?: Maybe<Scalars['Int']['output']>;
  company_id: Scalars['Int']['output'];
  competences_model_id?: Maybe<Scalars['Int']['output']>;
  create_activities_collaborator_pid_inactive?: Maybe<Scalars['Boolean']['output']>;
  create_pid_in_feedback?: Maybe<Scalars['Boolean']['output']>;
  created_by?: Maybe<Scalars['Int']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  days_remainder?: Maybe<Scalars['Int']['output']>;
  deleted_date?: Maybe<Scalars['DateTime']['output']>;
  dip_new_emp?: Maybe<Scalars['Boolean']['output']>;
  employee_auto_eval?: Maybe<Scalars['Boolean']['output']>;
  employee_can_add_eval?: Maybe<Scalars['Boolean']['output']>;
  employee_eval_first?: Maybe<Scalars['Boolean']['output']>;
  enable_approved_all_task_collaborator?: Maybe<Scalars['Boolean']['output']>;
  end_date: Scalars['Date']['output'];
  evaluation_id?: Maybe<Scalars['Int']['output']>;
  feedback?: Maybe<Scalars['Boolean']['output']>;
  feedback_evi?: Maybe<Scalars['Boolean']['output']>;
  feedback_evi_boss?: Maybe<Scalars['Boolean']['output']>;
  feedback_req?: Maybe<Scalars['Boolean']['output']>;
  goal_period_id?: Maybe<Scalars['Int']['output']>;
  has_continuous_tracking: Scalars['Boolean']['output'];
  hide_input_class?: Maybe<Scalars['Boolean']['output']>;
  hide_report_pdf?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  last_inactivated_date?: Maybe<Scalars['DateTime']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  max_act_comp?: Maybe<Scalars['Int']['output']>;
  max_act_comp_act?: Maybe<Scalars['Boolean']['output']>;
  model_10_label?: Maybe<Scalars['String']['output']>;
  model_20_label?: Maybe<Scalars['String']['output']>;
  model_70_20_10?: Maybe<Scalars['Boolean']['output']>;
  model_70_label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  object_develop?: Maybe<Scalars['Boolean']['output']>;
  okr_id_associate?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Boolean']['output']>;
  show_dashboard?: Maybe<Scalars['Boolean']['output']>;
  show_displacement_percentage: Scalars['Boolean']['output'];
  start_date: Scalars['Date']['output'];
  state: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
};

export type PrivateTalentDashboardEvaluationConnection = {
  __typename?: 'PrivateTalentDashboardEvaluationConnection';
  edges: Array<PrivateTalentDashboardEvaluationNodeEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentDashboardEvaluationNode = {
  __typename?: 'PrivateTalentDashboardEvaluationNode';
  evaluation: PrivateTalentEvaluation;
  statistics: PrivateTalentDashboardEvaluationStatistics;
};

/** An edge in a connection. */
export type PrivateTalentDashboardEvaluationNodeEdge = {
  __typename?: 'PrivateTalentDashboardEvaluationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentDashboardEvaluationNode;
};

export type PrivateTalentDashboardEvaluationStatistics = {
  __typename?: 'PrivateTalentDashboardEvaluationStatistics';
  total_progress_evaluation?: Maybe<Scalars['Decimal']['output']>;
};

export type PrivateTalentDeleteAllEvaluationQuestionsPayload = {
  __typename?: 'PrivateTalentDeleteAllEvaluationQuestionsPayload';
  /** Number of questionnaires whose question relations were cleared. */
  affected_questionnaires: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentDeleteBehaviorPayload = {
  __typename?: 'PrivateTalentDeleteBehaviorPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentDeleteCompetenceFilterPayload = {
  __typename?: 'PrivateTalentDeleteCompetenceFilterPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentDeleteCompetenceLevelPayload = {
  __typename?: 'PrivateTalentDeleteCompetenceLevelPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentDeleteCompetencePayload = {
  __typename?: 'PrivateTalentDeleteCompetencePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentDeleteCompetencesEvaluationPayload = {
  __typename?: 'PrivateTalentDeleteCompetencesEvaluationPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentDeleteDipActivitiesResult = {
  __typename?: 'PrivateTalentDeleteDipActivitiesResult';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentDeleteDipProcessPayload = {
  __typename?: 'PrivateTalentDeleteDipProcessPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentDeleteEvaluatorEvaluationPayload = {
  __typename?: 'PrivateTalentDeleteEvaluatorEvaluationPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentDeleteGoalProcessPayload = {
  __typename?: 'PrivateTalentDeleteGoalProcessPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentDipActivity = {
  __typename?: 'PrivateTalentDipActivity';
  activity_class?: Maybe<Scalars['String']['output']>;
  attachment_id?: Maybe<Scalars['Int']['output']>;
  catalogue_route_id?: Maybe<Scalars['String']['output']>;
  company_id: Scalars['Int']['output'];
  company_level?: Maybe<Scalars['Int']['output']>;
  company_level_detail?: Maybe<PrivateTalentCompanyLevel>;
  created_date?: Maybe<Scalars['Date']['output']>;
  deleted_date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  model_70_20_10?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner_activity?: Maybe<Scalars['String']['output']>;
  plan_id?: Maybe<Scalars['Int']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_date?: Maybe<Scalars['DateTime']['output']>;
};

export type PrivateTalentDipActivityConnection = {
  __typename?: 'PrivateTalentDipActivityConnection';
  edges: Array<PrivateTalentDipLibraryActivityPayloadEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentDipActivityContext = {
  __typename?: 'PrivateTalentDipActivityContext';
  /** RN-003: ids of the linked Detalle (competences / goals / OKRs), the same selection ``detail_ids`` writes on create/update. Read from the module bridge tables, not from activity_pid. The library modal is multi-select, so it needs the whole selection back to prefill the field when an activity is re-opened for editing. Empty for the types without a bridge table (CLIMATE_CULTURE / OTHER / WITHOUTPROCESS). */
  detail_ids: Array<Scalars['Int']['output']>;
};

export type PrivateTalentDipEmployee = {
  __typename?: 'PrivateTalentDipEmployee';
  activity?: Maybe<PrivateTalentDipActivity>;
  activity_id?: Maybe<Scalars['Int']['output']>;
  activity_notify_to_boss?: Maybe<Scalars['Boolean']['output']>;
  activity_notify_to_coll?: Maybe<Scalars['Boolean']['output']>;
  activity_notify_to_super_boss?: Maybe<Scalars['Boolean']['output']>;
  actual_expertise_level?: Maybe<Scalars['String']['output']>;
  behavior_id?: Maybe<Scalars['Int']['output']>;
  boss_progress?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  complied?: Maybe<Scalars['Boolean']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  created_date?: Maybe<Scalars['Date']['output']>;
  creator_id?: Maybe<Scalars['Int']['output']>;
  deleted_date?: Maybe<Scalars['DateTime']['output']>;
  displacement_comment?: Maybe<Scalars['String']['output']>;
  displacement_value?: Maybe<Scalars['Int']['output']>;
  employee?: Maybe<PrivateTalentEmployee>;
  employee_id?: Maybe<Scalars['Int']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  feedback_date?: Maybe<Scalars['DateTime']['output']>;
  goal_comp_value?: Maybe<Scalars['Int']['output']>;
  goal_individual_value?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  notify_super_boss?: Maybe<Scalars['Boolean']['output']>;
  plan_id?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  ranking_boss?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  state: Scalars['String']['output'];
  target_expertise_level?: Maybe<Scalars['String']['output']>;
  track_end_date?: Maybe<Scalars['Date']['output']>;
  track_start_date?: Maybe<Scalars['Date']['output']>;
  type_goal_comp_value?: Maybe<Scalars['String']['output']>;
};

export type PrivateTalentDipEmployeeConnection = {
  __typename?: 'PrivateTalentDipEmployeeConnection';
  edges: Array<PrivateTalentDipEmployeeEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PrivateTalentDipEmployeeEdge = {
  __typename?: 'PrivateTalentDipEmployeeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentDipEmployee;
};

export type PrivateTalentDipLibraryActivityPayload = {
  __typename?: 'PrivateTalentDipLibraryActivityPayload';
  /** The library activity (mirror of activity_pid). */
  activity: PrivateTalentDipActivity;
  /** Derived Detalle context of the row (RN-003). */
  context: PrivateTalentDipActivityContext;
};

/** An edge in a connection. */
export type PrivateTalentDipLibraryActivityPayloadEdge = {
  __typename?: 'PrivateTalentDipLibraryActivityPayloadEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentDipLibraryActivityPayload;
};

export type PrivateTalentDipPartaker = {
  __typename?: 'PrivateTalentDipPartaker';
  /** Collaborator identity. The table reads person.name, division.name and photo_url. */
  employee: PrivateTalentEmployee;
  /** Stable row id for the FE — the enrollment id (dip_partaker.id), not the employee id. */
  id: Scalars['Int']['output'];
};

export type PrivateTalentDipPartakerConnection = {
  __typename?: 'PrivateTalentDipPartakerConnection';
  edges: Array<PrivateTalentPartakersResultEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentDipPartakerContext = {
  __typename?: 'PrivateTalentDipPartakerContext';
  /** True when the employee is already an active participant of the process (state != DELETED); always False in creation (dip_id null). */
  is_participant: Scalars['Boolean']['output'];
  /** Derived role of the employee (LEADER / COLLABORATOR). */
  role: TalentDipParticipantRole;
};

export type PrivateTalentDipPartakerPayload = {
  __typename?: 'PrivateTalentDipPartakerPayload';
  /** Participant context (is_participant + derived role). */
  context: PrivateTalentDipPartakerContext;
  /** The company employee (name, cargo, departamento). */
  employee: PrivateTalentEmployee;
};

export type PrivateTalentDipParticipantContext = {
  __typename?: 'PrivateTalentDipParticipantContext';
  /** Pending-action tags (RN-026) that currently apply to this participant: 0, 1 or several — no MULTIPLE/NONE members, the FE renders nothing / the tag / "Multiple" based on the list length. Always empty when the process is finished or "Sin iniciar". */
  pending_actions: Array<PidPendingActionEnum>;
};

export type PrivateTalentDipParticipantStatistics = {
  __typename?: 'PrivateTalentDipParticipantStatistics';
  /** Progress % (0-100). AGGREGATE over the participant's dip_employee assignments; 0 for "Sin iniciar" / no assignments. */
  total_progress: Scalars['Float']['output'];
};

export type PrivateTalentDipParticipantsPayload = {
  __typename?: 'PrivateTalentDipParticipantsPayload';
  /** Derived pending-action context (RN-026). */
  context: PrivateTalentDipParticipantContext;
  /** Enrollment identity (id + collaborator). */
  dip_partaker: PrivateTalentDipPartaker;
  /** Aggregated progress statistics. */
  statistics: PrivateTalentDipParticipantStatistics;
};

export type PrivateTalentDipParticipantsStatistic = {
  __typename?: 'PrivateTalentDipParticipantsStatistic';
  /** Number of active participants of the process (dip_partaker rows with state != DELETED); 0 in creation (dip_id null). Feeds the 'Seleccionados N' counter. */
  total_assigned: Scalars['Int']['output'];
};

export type PrivateTalentDipProcess = {
  __typename?: 'PrivateTalentDipProcess';
  company_id: Scalars['Int']['output'];
  created_date: Scalars['DateTime']['output'];
  end_date: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  show_dashboard?: Maybe<Scalars['Boolean']['output']>;
  start_date: Scalars['DateTime']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type PrivateTalentDipProcessConnection = {
  __typename?: 'PrivateTalentDipProcessConnection';
  edges: Array<PrivateTalentDipProcessEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PrivateTalentDipProcessEdge = {
  __typename?: 'PrivateTalentDipProcessEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentDipProcess;
};

export type PrivateTalentDipProcessParticipantConnection = {
  __typename?: 'PrivateTalentDipProcessParticipantConnection';
  /** Participants of the current page. */
  edges: Array<PrivateTalentDipProcessParticipantEdge>;
  /** Connection metadata (page size + total count). */
  metadata: Metadata;
  /** Pagination data for this connection. */
  page_info: PageInfo;
  /** Convenience mirror of metadata.total_count. */
  total_count: Scalars['Int']['output'];
};

export type PrivateTalentDipProcessParticipantEdge = {
  __typename?: 'PrivateTalentDipProcessParticipantEdge';
  /** Opaque pagination cursor. */
  cursor: Scalars['String']['output'];
  /** The participant at the end of the edge. */
  node: PrivateTalentDipParticipantsPayload;
};

export type PrivateTalentDipProcessProgressFunnel = {
  __typename?: 'PrivateTalentDipProcessProgressFunnel';
  /** All funnel metrics grouped under a single statistics object. */
  statistics: PrivateTalentDipProcessProgressFunnelStatistics;
};

export type PrivateTalentDipProcessProgressFunnelStatistics = {
  __typename?: 'PrivateTalentDipProcessProgressFunnelStatistics';
  /** Funnel stage 2 — "Aprobadas". Count of assignments that passed the boss approval gate. */
  total_approved: Scalars['Int']['output'];
  /** Funnel stage 4 — "Completadas". Count of fulfilled assignments. */
  total_completed: Scalars['Int']['output'];
  /** Funnel stage 1 — "Creadas". Count of assignments in the initial created stage. */
  total_created: Scalars['Int']['output'];
  /** Funnel stage 3 — "En curso". Count of assignments actively being worked. */
  total_in_progress: Scalars['Int']['output'];
  /** Overall progress % of the process, 0-100 (0 when no data). */
  total_progress: Scalars['Float']['output'];
};

export type PrivateTalentDipTrackingPoint = {
  __typename?: 'PrivateTalentDipTrackingPoint';
  /** Month of the tracking window as an i18n-safe ENUM (no display string from the BE). The FE maps month + year to the localized label. */
  month: DipTrackingSeriesMonthEnum;
  /** Seguimientos REALIZADOS: count of this month's windows with a registered check-in (by the boss or the collaborator). */
  total_done: Scalars['Int']['output'];
  /** Seguimientos ESPERADOS: count of scheduled tracking windows in this month (active rows only). */
  total_expected: Scalars['Int']['output'];
  /** Year of the tracking window; pairs with month so the series is unambiguous across year boundaries. */
  year: Scalars['Int']['output'];
};

export type PrivateTalentDipTrackingSeries = {
  __typename?: 'PrivateTalentDipTrackingSeries';
  /** Ordered expected-vs-done series. Empty list = no tracking data (continuous / "Sin iniciar" / dataless process). */
  points: Array<PrivateTalentDipTrackingPoint>;
};

export type PrivateTalentDivision = {
  __typename?: 'PrivateTalentDivision';
  boss_id?: Maybe<Scalars['Int']['output']>;
  company_id: Scalars['Int']['output'];
  created_date?: Maybe<Scalars['DateTime']['output']>;
  deleted_date?: Maybe<Scalars['DateTime']['output']>;
  demo?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  last_inactivated_date?: Maybe<Scalars['DateTime']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  master_division?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  parent_id?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
};

export type PrivateTalentDivisionTopMedalsStatisticConnection = {
  __typename?: 'PrivateTalentDivisionTopMedalsStatisticConnection';
  edges: Array<PrivateTalentRecognitionDivisionModelTopMedalsStatisticsEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentDontKnowOption = {
  __typename?: 'PrivateTalentDontKnowOption';
  comment_for_dont_know?: Maybe<Scalars['Boolean']['output']>;
  comment_mandatory_for_dont_know?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type PrivateTalentDuplicateCompetencePayload = {
  __typename?: 'PrivateTalentDuplicateCompetencePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** ID of the duplicated competence */
  id: Scalars['ID']['output'];
};

export type PrivateTalentDuplicateCompetencesModelPayload = {
  __typename?: 'PrivateTalentDuplicateCompetencesModelPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** ID of the duplicated competences model */
  id: Scalars['ID']['output'];
};

export type PrivateTalentEmployee = {
  __typename?: 'PrivateTalentEmployee';
  address?: Maybe<Scalars['String']['output']>;
  auth_token?: Maybe<Scalars['String']['output']>;
  average_label?: Maybe<Scalars['String']['output']>;
  average_score?: Maybe<Scalars['Decimal']['output']>;
  birth_date?: Maybe<Scalars['DateTime']['output']>;
  can_manipulate_data?: Maybe<Scalars['Boolean']['output']>;
  /** Referencia federada a los datos centralizados del empleado, que aporta la imagen de perfil resuelta desde la base de datos de centralized-users (sucesora del `photo_url` legacy de este type). Null cuando el empleado no tiene compañía de talent: sin las dos mitades de la llave no hay entidad que referenciar. */
  centralized_employee?: Maybe<CentralizedTalentEmployee>;
  city?: Maybe<Scalars['String']['output']>;
  civil_status?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  company_id?: Maybe<Scalars['Int']['output']>;
  company_level?: Maybe<PrivateTalentCompanyLevel>;
  competence_label?: Maybe<Scalars['String']['output']>;
  competence_score?: Maybe<Scalars['Decimal']['output']>;
  consent_accepted?: Maybe<Scalars['Boolean']['output']>;
  consent_approved?: Maybe<Scalars['Boolean']['output']>;
  consent_date?: Maybe<Scalars['DateTime']['output']>;
  contract_type?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  data_manipulation_date?: Maybe<Scalars['DateTime']['output']>;
  division?: Maybe<PrivateTalentDivision>;
  division_id?: Maybe<Scalars['Int']['output']>;
  division_names?: Maybe<Scalars['String']['output']>;
  emergency_contact_email?: Maybe<Scalars['String']['output']>;
  emergency_contact_name?: Maybe<Scalars['String']['output']>;
  emergency_contact_phone?: Maybe<Scalars['String']['output']>;
  emergency_contact_relationship?: Maybe<Scalars['String']['output']>;
  goal_label?: Maybe<Scalars['String']['output']>;
  hire_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  is_innovative?: Maybe<Scalars['Boolean']['output']>;
  job?: Maybe<PrivateTalentJob>;
  job_id?: Maybe<Scalars['Int']['output']>;
  kpi_score?: Maybe<Scalars['Decimal']['output']>;
  last_evaluation_id?: Maybe<Scalars['Int']['output']>;
  mobile_phone?: Maybe<Scalars['String']['output']>;
  person?: Maybe<PrivateTalentPerson>;
  person_id: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  photo_base64?: Maybe<Scalars['String']['output']>;
  photo_url?: Maybe<Scalars['String']['output']>;
  salary_amount?: Maybe<Scalars['Decimal']['output']>;
  salary_effective_date?: Maybe<Scalars['Date']['output']>;
  status: Scalars['String']['output'];
  subsidiary?: Maybe<PrivateTalentSubsidiary>;
  subsidiary_id?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PrivateTalentEmployeeEdge = {
  __typename?: 'PrivateTalentEmployeeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentEmployee;
};

export type PrivateTalentEmployeeEvaluationConnection = {
  __typename?: 'PrivateTalentEmployeeEvaluationConnection';
  edges: Array<PrivateTalentEmployeeEvaluationPayloadEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Evaluator limits and current counts per relation type for the evaluated */
  relation_limits?: Maybe<PrivateTalentEvaluationRelationLimits>;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentEmployeeEvaluationPayload = {
  __typename?: 'PrivateTalentEmployeeEvaluationPayload';
  address?: Maybe<Scalars['String']['output']>;
  auth_token?: Maybe<Scalars['String']['output']>;
  average_label?: Maybe<Scalars['String']['output']>;
  average_score?: Maybe<Scalars['Decimal']['output']>;
  birth_date?: Maybe<Scalars['DateTime']['output']>;
  can_manipulate_data?: Maybe<Scalars['Boolean']['output']>;
  /** Referencia federada a los datos centralizados del empleado, que aporta la imagen de perfil resuelta desde la base de datos de centralized-users (sucesora del `photo_url` legacy de este type). Null cuando el empleado no tiene compañía de talent: sin las dos mitades de la llave no hay entidad que referenciar. */
  centralized_employee?: Maybe<CentralizedTalentEmployee>;
  city?: Maybe<Scalars['String']['output']>;
  civil_status?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  company_id?: Maybe<Scalars['Int']['output']>;
  company_level?: Maybe<PrivateTalentCompanyLevel>;
  competence_label?: Maybe<Scalars['String']['output']>;
  competence_score?: Maybe<Scalars['Decimal']['output']>;
  consent_accepted?: Maybe<Scalars['Boolean']['output']>;
  consent_approved?: Maybe<Scalars['Boolean']['output']>;
  consent_date?: Maybe<Scalars['DateTime']['output']>;
  contract_type?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  data_manipulation_date?: Maybe<Scalars['DateTime']['output']>;
  division?: Maybe<PrivateTalentDivision>;
  division_id?: Maybe<Scalars['Int']['output']>;
  division_names?: Maybe<Scalars['String']['output']>;
  emergency_contact_email?: Maybe<Scalars['String']['output']>;
  emergency_contact_name?: Maybe<Scalars['String']['output']>;
  emergency_contact_phone?: Maybe<Scalars['String']['output']>;
  emergency_contact_relationship?: Maybe<Scalars['String']['output']>;
  employee_id?: Maybe<Scalars['Int']['output']>;
  evaluators?: Maybe<Array<PrivateTalentEmployeeEvaluationPayload>>;
  goal_label?: Maybe<Scalars['String']['output']>;
  hire_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  is_innovative?: Maybe<Scalars['Boolean']['output']>;
  job?: Maybe<PrivateTalentJob>;
  job_id?: Maybe<Scalars['Int']['output']>;
  kpi_score?: Maybe<Scalars['Decimal']['output']>;
  last_evaluation_id?: Maybe<Scalars['Int']['output']>;
  mobile_phone?: Maybe<Scalars['String']['output']>;
  person?: Maybe<PrivateTalentPerson>;
  person_id: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  photo_base64?: Maybe<Scalars['String']['output']>;
  photo_url?: Maybe<Scalars['String']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_status?: Maybe<Scalars['String']['output']>;
  relations?: Maybe<Scalars['String']['output']>;
  salary_amount?: Maybe<Scalars['Decimal']['output']>;
  salary_effective_date?: Maybe<Scalars['Date']['output']>;
  status: Scalars['String']['output'];
  subsidiary?: Maybe<PrivateTalentSubsidiary>;
  subsidiary_id?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PrivateTalentEmployeeEvaluationPayloadEdge = {
  __typename?: 'PrivateTalentEmployeeEvaluationPayloadEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentEmployeeEvaluationPayload;
};

export type PrivateTalentEmployeeStatistic = {
  __typename?: 'PrivateTalentEmployeeStatistic';
  total_collaborators?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentEmployeeStatistics = {
  __typename?: 'PrivateTalentEmployeeStatistics';
  employee: PrivateTalentEmployee;
  statistics: PrivateTalentEmployeeStatistic;
};

export type PrivateTalentEvaluation = {
  __typename?: 'PrivateTalentEvaluation';
  advanced_configuration: PrivateTalentAdvancedConfigurationEvaluation;
  affirmations_suggestion?: Maybe<Scalars['Boolean']['output']>;
  answer_type?: Maybe<Scalars['String']['output']>;
  available_time?: Maybe<Scalars['Int']['output']>;
  boss_limit?: Maybe<Scalars['Int']['output']>;
  calibration?: Maybe<Scalars['Boolean']['output']>;
  climate?: Maybe<Scalars['Boolean']['output']>;
  comment_competence?: Maybe<Scalars['Boolean']['output']>;
  comments: PrivateTalentCommentsEvaluation;
  comp_limit?: Maybe<Scalars['Decimal']['output']>;
  comp_limit_1?: Maybe<Scalars['Decimal']['output']>;
  comp_limit_1_color?: Maybe<Scalars['String']['output']>;
  comp_limit_1_label?: Maybe<Scalars['String']['output']>;
  comp_limit_2?: Maybe<Scalars['Decimal']['output']>;
  comp_limit_2_color?: Maybe<Scalars['String']['output']>;
  comp_limit_2_label?: Maybe<Scalars['String']['output']>;
  comp_limit_3?: Maybe<Scalars['Decimal']['output']>;
  comp_limit_3_color?: Maybe<Scalars['String']['output']>;
  comp_limit_3_label?: Maybe<Scalars['String']['output']>;
  comp_limit_4?: Maybe<Scalars['Decimal']['output']>;
  comp_limit_4_color?: Maybe<Scalars['String']['output']>;
  comp_limit_4_label?: Maybe<Scalars['String']['output']>;
  comp_limit_max_label?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['Int']['output']>;
  competence_model?: Maybe<PrivateTalentCompetencesModel>;
  competence_model_id?: Maybe<Scalars['Int']['output']>;
  competence_result_type?: Maybe<Scalars['String']['output']>;
  config360?: Maybe<Array<Scalars['String']['output']>>;
  configuration?: Maybe<Scalars['String']['output']>;
  cow_limit?: Maybe<Scalars['Int']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  custom_weight?: Maybe<Scalars['Boolean']['output']>;
  date_time_zone?: Maybe<Scalars['String']['output']>;
  default_level?: Maybe<Scalars['Int']['output']>;
  deleted_date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dont_know?: Maybe<Scalars['Boolean']['output']>;
  dtype?: Maybe<Scalars['String']['output']>;
  enable_hours?: Maybe<Scalars['Boolean']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  end_text?: Maybe<Scalars['String']['output']>;
  evaluation_demo?: Maybe<Scalars['Boolean']['output']>;
  form_id?: Maybe<Scalars['Int']['output']>;
  general_suggestion?: Maybe<Scalars['Boolean']['output']>;
  general_suggestion_2?: Maybe<Scalars['Boolean']['output']>;
  hide_evaluation_employee?: Maybe<Scalars['Boolean']['output']>;
  hide_relations?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label_comment_general?: Maybe<Scalars['String']['output']>;
  last_inactivated_date?: Maybe<Scalars['DateTime']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  login_dashboard?: Maybe<Scalars['Boolean']['output']>;
  max_limit?: Maybe<Scalars['Int']['output']>;
  max_limit_color?: Maybe<Scalars['String']['output']>;
  min_comment_length?: Maybe<Scalars['Int']['output']>;
  model_competence_weight?: Maybe<Scalars['Boolean']['output']>;
  model_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options_response: PrivateTalentOptionsResponseEvaluation;
  quit_results_in_zero?: Maybe<Scalars['Boolean']['output']>;
  reminder_date?: Maybe<Scalars['DateTime']['output']>;
  report_template_id?: Maybe<Scalars['Int']['output']>;
  required_comments?: Maybe<Scalars['String']['output']>;
  required_comments_dont_know?: Maybe<Scalars['Boolean']['output']>;
  show_comments_dont_know?: Maybe<Scalars['Boolean']['output']>;
  show_in_platform?: Maybe<Scalars['Boolean']['output']>;
  show_remainder?: Maybe<Scalars['Boolean']['output']>;
  show_results_goal?: Maybe<Scalars['Boolean']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  start_text?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_2?: Maybe<Scalars['String']['output']>;
  state_calibration_evaluation?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['Int']['output']>;
  sub_limit?: Maybe<Scalars['Int']['output']>;
  total_invalid_options?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  type_calibration?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  view_calibration?: Maybe<Scalars['Boolean']['output']>;
  welcome_text?: Maybe<Scalars['String']['output']>;
};

export type PrivateTalentEvaluationDeleteRelationsTemplatePayload = {
  __typename?: 'PrivateTalentEvaluationDeleteRelationsTemplatePayload';
  /** URL of the generated Excel template file for massive deletion of evaluation relations. */
  file_url: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentEvaluationRelationLimits = {
  __typename?: 'PrivateTalentEvaluationRelationLimits';
  /** Max boss evaluators allowed for this evaluation */
  boss_limit?: Maybe<Scalars['Int']['output']>;
  /** Current number of boss evaluators assigned to the evaluated */
  boss_limit_count?: Maybe<Scalars['Int']['output']>;
  /** Max peer evaluators allowed for this evaluation */
  cow_limit?: Maybe<Scalars['Int']['output']>;
  /** Current number of peer evaluators assigned to the evaluated */
  cow_limit_count?: Maybe<Scalars['Int']['output']>;
  /** Max subordinate evaluators allowed for this evaluation */
  sub_limit?: Maybe<Scalars['Int']['output']>;
  /** Current number of subordinate evaluators assigned to the evaluated */
  sub_limit_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentEvaluationRelationWeight = {
  __typename?: 'PrivateTalentEvaluationRelationWeight';
  /** Relation type (e.g. AUTO, BOSS) */
  relation: Scalars['String']['output'];
  /** Current weight percentage for this relation (0-100) */
  weight?: Maybe<Scalars['Decimal']['output']>;
};

export type PrivateTalentEvaluationRelationWeightsPayload = {
  __typename?: 'PrivateTalentEvaluationRelationWeightsPayload';
  /** One entry per evaluated person with their weight per relation type */
  cases: Array<PrivateTalentEvaluationWeightCase>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** Distinct relation types present in the evaluation (column headers) */
  relations: Array<Scalars['String']['output']>;
};

export type PrivateTalentEvaluationWeightCase = {
  __typename?: 'PrivateTalentEvaluationWeightCase';
  /** Evaluated person's full name */
  name: Scalars['String']['output'];
  /** Weight per relation type for this evaluated person */
  weights: Array<PrivateTalentEvaluationRelationWeight>;
};

export type PrivateTalentEvaluatorEvaluationPaginatedConnection = {
  __typename?: 'PrivateTalentEvaluatorEvaluationPaginatedConnection';
  edges: Array<PrivateTalentEmployeeEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentEvaluatorListPayload = {
  __typename?: 'PrivateTalentEvaluatorListPayload';
  evaluated: Array<PrivateTalentEmployee>;
};

export type PrivateTalentExcludeParticipantsMassiveEvaluationPayload = {
  __typename?: 'PrivateTalentExcludeParticipantsMassiveEvaluationPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** Total participants excluded from evaluation */
  total_excluded: Scalars['Int']['output'];
};

export type PrivateTalentFeedbackTemplate = {
  __typename?: 'PrivateTalentFeedbackTemplate';
  company_id?: Maybe<Scalars['Int']['output']>;
  created_date: Scalars['DateTime']['output'];
  deleted_date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enable_summary?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  is_default?: Maybe<Scalars['Boolean']['output']>;
  last_inactivated_date?: Maybe<Scalars['DateTime']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type PrivateTalentFinalComments = {
  __typename?: 'PrivateTalentFinalComments';
  boxes: Array<PrivateTalentCommentBox>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  min_comment_length?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentGaussConfigurationPayload = {
  __typename?: 'PrivateTalentGaussConfigurationPayload';
  /** gauss configurations */
  configurations: Array<TalentGaussConfiguration>;
};

export type PrivateTalentGenerateMassiveCompetencesRelationsTemplatePayload = {
  __typename?: 'PrivateTalentGenerateMassiveCompetencesRelationsTemplatePayload';
  file_url: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentGenerateQuestionnairesPayload = {
  __typename?: 'PrivateTalentGenerateQuestionnairesPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  total_created: Scalars['Int']['output'];
};

export type PrivateTalentGetCompetenceLevelPayload = {
  __typename?: 'PrivateTalentGetCompetenceLevelPayload';
  competence_level: PrivateTalentCompetenceLevel;
};

export type PrivateTalentGetCompetencesModelStatisticsPayload = {
  __typename?: 'PrivateTalentGetCompetencesModelStatisticsPayload';
  evaluations?: Maybe<Array<PrivateTalentCompetencesStatistics>>;
  model_info: PrivateTalentCompetencesModelStatistics;
};

export type PrivateTalentGetRecognitionConfigurationPayload = {
  __typename?: 'PrivateTalentGetRecognitionConfigurationPayload';
  recognition_configuration: PrivateTalentRecognitionConfiguration;
};

export type PrivateTalentGetRecognitionManualAnalysisReportPayload = {
  __typename?: 'PrivateTalentGetRecognitionManualAnalysisReportPayload';
  url?: Maybe<Scalars['String']['output']>;
};

export type PrivateTalentGetRecognitionMedalPayload = {
  __typename?: 'PrivateTalentGetRecognitionMedalPayload';
  recognition_company: PrivateTalentRecognitionCompany;
};

export type PrivateTalentGetRecognitionResultsDynamicReportPayload = {
  __typename?: 'PrivateTalentGetRecognitionResultsDynamicReportPayload';
  url?: Maybe<Scalars['String']['output']>;
};

export type PrivateTalentGetRecognitionResultsSummaryMetricsPayload = {
  __typename?: 'PrivateTalentGetRecognitionResultsSummaryMetricsPayload';
  most_frequently_sent_medal: PrivateTalentRecognitionCompanyModelPayload;
  user_most_medals_received: PrivateTalentRecognitionEmployeeModelPayload;
  user_most_medals_sent: PrivateTalentRecognitionEmployeeModelPayload;
};

export type PrivateTalentGoalPeriodConnection = {
  __typename?: 'PrivateTalentGoalPeriodConnection';
  edges: Array<TalentGoalProcessEdge>;
  metadata: Metadata;
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentGoalProcess = {
  __typename?: 'PrivateTalentGoalProcess';
  auto_eval_first?: Maybe<Scalars['Boolean']['output']>;
  boss_delete_goals?: Maybe<Scalars['Boolean']['output']>;
  company_id: Scalars['Int']['output'];
  created_date?: Maybe<Scalars['DateTime']['output']>;
  deleted_date?: Maybe<Scalars['DateTime']['output']>;
  edit_goal_with_track?: Maybe<Scalars['Boolean']['output']>;
  edit_goal_without_track?: Maybe<Scalars['Boolean']['output']>;
  edit_weight?: Maybe<Scalars['Boolean']['output']>;
  end_date: Scalars['DateTime']['output'];
  goal_track_id?: Maybe<Scalars['Int']['output']>;
  goals_days_emp?: Maybe<Scalars['Int']['output']>;
  goals_days_load?: Maybe<Scalars['Int']['output']>;
  goals_edit_boss?: Maybe<Scalars['Boolean']['output']>;
  goals_edit_emp?: Maybe<Scalars['Boolean']['output']>;
  goals_limit?: Maybe<Scalars['Float']['output']>;
  goals_max?: Maybe<Scalars['Int']['output']>;
  goals_min?: Maybe<Scalars['Int']['output']>;
  goals_new_boss?: Maybe<Scalars['Boolean']['output']>;
  goals_new_emp?: Maybe<Scalars['Boolean']['output']>;
  goals_result_type?: Maybe<GoalsResultTypeEnum>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  limit1?: Maybe<Scalars['Float']['output']>;
  limit2?: Maybe<Scalars['Float']['output']>;
  limit3?: Maybe<Scalars['Float']['output']>;
  limit4?: Maybe<Scalars['Float']['output']>;
  mail_collaborator?: Maybe<Scalars['Boolean']['output']>;
  mail_text?: Maybe<Scalars['String']['output']>;
  mail_text_boss?: Maybe<Scalars['String']['output']>;
  mail_text_collaborator?: Maybe<Scalars['String']['output']>;
  mail_text_evaluated?: Maybe<Scalars['String']['output']>;
  mail_text_evaluated_boss?: Maybe<Scalars['String']['output']>;
  meta_max?: Maybe<Scalars['Int']['output']>;
  meta_min?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  no_approve_required?: Maybe<Scalars['Boolean']['output']>;
  progress_conversion?: Maybe<Scalars['Boolean']['output']>;
  required_evidence?: Maybe<Scalars['Boolean']['output']>;
  required_feedback?: Maybe<Scalars['Boolean']['output']>;
  required_goals_same?: Maybe<Scalars['Boolean']['output']>;
  show_dashboard?: Maybe<Scalars['Boolean']['output']>;
  show_semaphore_labels?: Maybe<Scalars['Boolean']['output']>;
  start_date: Scalars['DateTime']['output'];
  state?: Maybe<EntityState>;
  track_type?: Maybe<GoalTrackTypeEnum>;
};

export type PrivateTalentGoalTrack = {
  __typename?: 'PrivateTalentGoalTrack';
  /** Goal period ID */
  goalperiod_id: Scalars['Int']['output'];
  /** Goal track ID */
  id: Scalars['Int']['output'];
  /** Goal track state */
  state?: Maybe<Scalars['String']['output']>;
  /** Goal track title */
  title: Scalars['String']['output'];
};

export type PrivateTalentJob = {
  __typename?: 'PrivateTalentJob';
  can_succeed?: Maybe<Scalars['Boolean']['output']>;
  company_id: Scalars['Int']['output'];
  created_date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PrivateTalentLevelBehaviorsCount = {
  __typename?: 'PrivateTalentLevelBehaviorsCount';
  behaviors_count: Scalars['Int']['output'];
  level_id: Scalars['Int']['output'];
};

/** Listado de competencias de un modelo, sin paginación ni estadísticas. */
export type PrivateTalentListAllCompetencesPayload = {
  __typename?: 'PrivateTalentListAllCompetencesPayload';
  /** Competencias activas del modelo (sin borradores), ordenadas por prioridad. Solo se consultan id y nombres; el resto de campos viaja en null. */
  competences: Array<PrivateTalentCompetence>;
};

export type PrivateTalentListBehaviorsByCategoryPayload = {
  __typename?: 'PrivateTalentListBehaviorsByCategoryPayload';
  /** List of behaviors for the given competence and job category */
  behaviors: Array<PrivateTalentBehavior>;
};

export type PrivateTalentListCompanyGoalsPayload = {
  __typename?: 'PrivateTalentListCompanyGoalsPayload';
  /** Company goals of the period, excluding deleted and INACTIVE ones, ordered by name */
  company_goals: Array<PrivateTalentCompanyGoal>;
};

export type PrivateTalentListCompanyResultsConfigurationsPayload = {
  __typename?: 'PrivateTalentListCompanyResultsConfigurationsPayload';
  competences_evaluation?: Maybe<TalentEvaluation>;
  configurations: Array<TalentCompanyConfiguration>;
  radar_evaluation_list: Array<TalentRadarEvaluationParameter>;
};

export type PrivateTalentListCompetencesConfigurationPayload = {
  __typename?: 'PrivateTalentListCompetencesConfigurationPayload';
  /** list of competences configurations in company */
  competences_configurations: Array<PrivateTalentCompanyConfiguration>;
};

export type PrivateTalentListCompetencesEvaluationsPayload = {
  __typename?: 'PrivateTalentListCompetencesEvaluationsPayload';
  evaluations: Array<TalentEvaluation>;
};

export type PrivateTalentListCompetencesFilterCoveragePayload = {
  __typename?: 'PrivateTalentListCompetencesFilterCoveragePayload';
  employee_info: PrivateTalentEmployeeStatistics;
  filters: Array<PrivateTalentCompetencesFilterCoverage>;
};

export type PrivateTalentListCompetencesPayload = {
  __typename?: 'PrivateTalentListCompetencesPayload';
  competences: Array<PrivateTalentCompetenceWithStatistics>;
};

export type PrivateTalentListGoalProcessPayload = {
  __typename?: 'PrivateTalentListGoalProcessPayload';
  /** list of goal process in company */
  goal_process?: Maybe<Array<TalentGoalProcess>>;
};

export type PrivateTalentListGoalTracksPayload = {
  __typename?: 'PrivateTalentListGoalTracksPayload';
  /** List of goal tracks in a goal period */
  goal_tracks: Array<PrivateTalentGoalTrack>;
};

export type PrivateTalentListObjectivesByOkrProcessPayload = {
  __typename?: 'PrivateTalentListObjectivesByOkrProcessPayload';
  /** Root objectives of the OKR process, excluding deleted ones, ordered by priority and name */
  objectives: Array<PrivateTalentObjectiveKeyResult>;
};

export type PrivateTalentListOkrPeriodPayload = {
  __typename?: 'PrivateTalentListOkrPeriodPayload';
  /** list of okr period in company */
  okr_period?: Maybe<Array<TalentOkrPeriod>>;
};

export type PrivateTalentListReportTemplatesPayload = {
  __typename?: 'PrivateTalentListReportTemplatesPayload';
  /** list of report templates in performance result configuration module */
  templates?: Maybe<Array<TalentReportTemplate>>;
};

export type PrivateTalentMailTemplate = {
  __typename?: 'PrivateTalentMailTemplate';
  code: Scalars['String']['output'];
  company_id?: Maybe<Scalars['Int']['output']>;
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  language_code: Scalars['String']['output'];
  recipient?: Maybe<PidTemplateRecipientEnum>;
  subject?: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type PrivateTalentMailTemplateEdge = {
  __typename?: 'PrivateTalentMailTemplateEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentMailTemplate;
};

export type PrivateTalentMassiveCompetencesFilePayload = {
  __typename?: 'PrivateTalentMassiveCompetencesFilePayload';
  file_url: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentMassiveCompetencesPayload = {
  __typename?: 'PrivateTalentMassiveCompetencesPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentMassiveCompetencesRelationsPayload = {
  __typename?: 'PrivateTalentMassiveCompetencesRelationsPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentMassiveDipActivityAssignmentFilePayload = {
  __typename?: 'PrivateTalentMassiveDipActivityAssignmentFilePayload';
  /** Download URL of the generated .xlsx assignment template. */
  file_url: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentMassiveDipActivityAssignmentPayload = {
  __typename?: 'PrivateTalentMassiveDipActivityAssignmentPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentMassiveDipActivityTrackingFilePayload = {
  __typename?: 'PrivateTalentMassiveDipActivityTrackingFilePayload';
  /** Download URL of the generated .xlsx tracking template. */
  file_url: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentMassiveDipActivityTrackingPayload = {
  __typename?: 'PrivateTalentMassiveDipActivityTrackingPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentMassiveDipLibraryActivityFilePayload = {
  __typename?: 'PrivateTalentMassiveDipLibraryActivityFilePayload';
  /** Download URL of the generated .xlsx library template. */
  file_url: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentMassiveDipLibraryActivityPayload = {
  __typename?: 'PrivateTalentMassiveDipLibraryActivityPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentMassiveParticipantsPayload = {
  __typename?: 'PrivateTalentMassiveParticipantsPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentMassiveRecognitionRewardPayload = {
  __typename?: 'PrivateTalentMassiveRecognitionRewardPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentNom035Context = {
  __typename?: 'PrivateTalentNom035Context';
  access_token?: Maybe<Scalars['String']['output']>;
  relation?: Maybe<Nom035QuestionnaireRelationEnum>;
  scheduled_start_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Nom035QuestionnaireStatusEnum>;
};

export type PrivateTalentNom035EvaluationConfig = {
  __typename?: 'PrivateTalentNom035EvaluationConfig';
  configuration: TalentNom035Configuration;
  evaluation: TalentNom035Evaluation;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  state: TalentNom035EvaluationStateEnum;
};

export type PrivateTalentNom035QuestionnaireConnection = {
  __typename?: 'PrivateTalentNom035QuestionnaireConnection';
  edges: Array<PrivateTalentNom035QuestionnairePayloadEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentNom035QuestionnairePayload = {
  __typename?: 'PrivateTalentNom035QuestionnairePayload';
  configuration?: Maybe<TalentNom035Configuration>;
  context?: Maybe<PrivateTalentNom035Context>;
  evaluation?: Maybe<TalentBaseEvaluation>;
  statistics?: Maybe<PrivateTalentNom035Statistics>;
};

/** An edge in a connection. */
export type PrivateTalentNom035QuestionnairePayloadEdge = {
  __typename?: 'PrivateTalentNom035QuestionnairePayloadEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentNom035QuestionnairePayload;
};

export type PrivateTalentNom035Statistics = {
  __typename?: 'PrivateTalentNom035Statistics';
  total_answered_questions: Scalars['Int']['output'];
  total_questions: Scalars['Int']['output'];
};

export type PrivateTalentObjectiveKeyResult = {
  __typename?: 'PrivateTalentObjectiveKeyResult';
  /** How the objective is assigned */
  assignment_type?: Maybe<Scalars['String']['output']>;
  /** Objective due date */
  due_date?: Maybe<Scalars['Date']['output']>;
  /** Objective / key result ID */
  id: Scalars['Int']['output'];
  /** Objective / key result name */
  name: Scalars['String']['output'];
  /** OKR period the objective belongs to */
  okr_period_id?: Maybe<Scalars['Int']['output']>;
  /** Name of the OKR period the objective belongs to. The process itself carries no name, so this is what identifies the process an objective comes from when objectives of several of them are listed together */
  okr_period_name?: Maybe<Scalars['String']['output']>;
  /** OKR process the objective belongs to */
  okr_process_id?: Maybe<Scalars['Int']['output']>;
  /** Ordering priority within the process */
  priority?: Maybe<Scalars['Int']['output']>;
  /** Current progress value */
  progress?: Maybe<Scalars['Decimal']['output']>;
  /** Qualitative progress state */
  progress_state?: Maybe<Scalars['String']['output']>;
  /** Objective state */
  state?: Maybe<EntityState>;
  /** Discriminates an objective from a key result */
  type: Scalars['String']['output'];
  /** Relative weight of the objective */
  weight?: Maybe<Scalars['Decimal']['output']>;
};

export type PrivateTalentOptionConfiguration = {
  __typename?: 'PrivateTalentOptionConfiguration';
  key?: Maybe<Scalars['String']['output']>;
  other?: Maybe<Scalars['Boolean']['output']>;
  translations: Array<PrivateTalentOptionTranslation>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PrivateTalentOptionTranslation = {
  __typename?: 'PrivateTalentOptionTranslation';
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  language_code?: Maybe<Scalars['String']['output']>;
};

export type PrivateTalentOptionsResponseEvaluation = {
  __typename?: 'PrivateTalentOptionsResponseEvaluation';
  configuration: Array<PrivateTalentOptionConfiguration>;
  dont_know: PrivateTalentDontKnowOption;
  response_type?: Maybe<Scalars['String']['output']>;
  scale_type?: Maybe<Scalars['String']['output']>;
  total_invalid_options?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentPartakersResult = {
  __typename?: 'PrivateTalentPartakersResult';
  /** The company employee enriched with its participant context. */
  participants: PrivateTalentDipPartakerPayload;
  /** Per-process aggregated counters (total_assigned). */
  statistics: PrivateTalentDipParticipantsStatistic;
};

/** An edge in a connection. */
export type PrivateTalentPartakersResultEdge = {
  __typename?: 'PrivateTalentPartakersResultEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentPartakersResult;
};

export type PrivateTalentPerformancePeriod = {
  __typename?: 'PrivateTalentPerformancePeriod';
  /** Company that owns the dynamic performance process */
  company_id?: Maybe<Scalars['Int']['output']>;
  /** Dynamic performance process end date */
  end_date?: Maybe<Scalars['DateTime']['output']>;
  /** Dynamic performance process ID (performance_period) */
  id?: Maybe<Scalars['Int']['output']>;
  /** Dynamic performance process name */
  name?: Maybe<Scalars['String']['output']>;
  /** Dynamic performance process start date */
  start_date?: Maybe<Scalars['DateTime']['output']>;
  /** Dynamic performance process state */
  state?: Maybe<Scalars['String']['output']>;
};

export type PrivateTalentPerformanceResultConfigurationPayload = {
  __typename?: 'PrivateTalentPerformanceResultConfigurationPayload';
  /** performance result configuration */
  configuration?: Maybe<TalentPerformanceResultConfiguration>;
};

export type PrivateTalentPerformanceResultConfigurationProcessPayload = {
  __typename?: 'PrivateTalentPerformanceResultConfigurationProcessPayload';
  competences_process?: Maybe<TalentEvaluation>;
  goal_period?: Maybe<TalentGoalProcess>;
  okr_period?: Maybe<TalentOkrPeriod>;
  report_template?: Maybe<TalentReportTemplate>;
};

export type PrivateTalentPerson = {
  __typename?: 'PrivateTalentPerson';
  age?: Maybe<Scalars['Int']['output']>;
  company_id: Scalars['Int']['output'];
  created_date?: Maybe<Scalars['DateTime']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  document_type?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  language?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type PrivateTalentPidDashboardUrlPayload = {
  __typename?: 'PrivateTalentPidDashboardUrlPayload';
  /** Talent PID dashboard URL */
  url: Scalars['String']['output'];
};

/** Resultado de add_recognition_participants_admin: cuántas filas quedaron habilitadas por esta llamada. */
export type PrivateTalentRecognitionAddParticipantsPayload = {
  __typename?: 'PrivateTalentRecognitionAddParticipantsPayload';
  /** Filas creadas + reactivadas. Los colaboradores que ya estaban ACTIVE NO cuentan (el alta es idempotente, RN-11) y los ids de otra empresa tampoco (se descartan). 0 es una respuesta exitosa: significa que todos los seleccionados ya estaban habilitados. */
  affected_count: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentRecognitionApplicationsMedals = {
  __typename?: 'PrivateTalentRecognitionApplicationsMedals';
  recognition_employee_model: PrivateTalentRecognitionEmployee;
};

/** An edge in a connection. */
export type PrivateTalentRecognitionApplicationsMedalsEdge = {
  __typename?: 'PrivateTalentRecognitionApplicationsMedalsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentRecognitionApplicationsMedals;
};

export type PrivateTalentRecognitionCompany = {
  __typename?: 'PrivateTalentRecognitionCompany';
  category?: Maybe<Scalars['String']['output']>;
  company_id: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  inactivated_at?: Maybe<Scalars['DateTime']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_leader?: Maybe<Scalars['Boolean']['output']>;
  level?: Maybe<PrivateTalentRecognitionLevel>;
  level_id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  recognition_configuration_plan_id?: Maybe<Scalars['Int']['output']>;
  state: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type PrivateTalentRecognitionCompanyMedals = {
  __typename?: 'PrivateTalentRecognitionCompanyMedals';
  recognition_company_model: PrivateTalentRecognitionCompany;
};

export type PrivateTalentRecognitionCompanyMedalsConnection = {
  __typename?: 'PrivateTalentRecognitionCompanyMedalsConnection';
  edges: Array<PrivateTalentRecognitionCompanyMedalsEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PrivateTalentRecognitionCompanyMedalsEdge = {
  __typename?: 'PrivateTalentRecognitionCompanyMedalsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentRecognitionCompanyMedals;
};

export type PrivateTalentRecognitionCompanyModelPayload = {
  __typename?: 'PrivateTalentRecognitionCompanyModelPayload';
  recognition_company_model?: Maybe<PrivateTalentRecognitionCompany>;
  /** Recognition Company model statistics like quantity sent */
  statistics: PrivateTalentRecognitionCompanyModelStatistic;
};

export type PrivateTalentRecognitionCompanyModelStatistic = {
  __typename?: 'PrivateTalentRecognitionCompanyModelStatistic';
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentRecognitionCompanyModelStatisticConnection = {
  __typename?: 'PrivateTalentRecognitionCompanyModelStatisticConnection';
  edges: Array<PrivateTalentRecognitionCompanyModelStatisticsEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentRecognitionCompanyModelStatistics = {
  __typename?: 'PrivateTalentRecognitionCompanyModelStatistics';
  recognition_company_model: PrivateTalentRecognitionCompany;
  /** recognition company model statistics like quantity by model */
  statistics: PrivateTalentRecognitionCompanyModelTopMedalsStatistic;
};

/** An edge in a connection. */
export type PrivateTalentRecognitionCompanyModelStatisticsEdge = {
  __typename?: 'PrivateTalentRecognitionCompanyModelStatisticsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentRecognitionCompanyModelStatistics;
};

export type PrivateTalentRecognitionCompanyModelTopMedalsStatistic = {
  __typename?: 'PrivateTalentRecognitionCompanyModelTopMedalsStatistic';
  quantity?: Maybe<Scalars['Int']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentRecognitionConfiguration = PublicTalentRecognitionConfiguration & {
  __typename?: 'PrivateTalentRecognitionConfiguration';
  allow_comments?: Maybe<Scalars['Boolean']['output']>;
  allow_medal_response?: Maybe<Scalars['Boolean']['output']>;
  are_medals_approved?: Maybe<Scalars['Boolean']['output']>;
  bronze_medals?: Maybe<Scalars['Int']['output']>;
  can_boss_send_medal?: Maybe<Scalars['Boolean']['output']>;
  comment_label?: Maybe<Scalars['String']['output']>;
  company_id: Scalars['Int']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Configured annual reset of the redemption points (RN-04). Origin: recognition_configuration_plan.force_init_date (1:1). YEAR-AGNOSTIC: only the month and the day are significant — the year carried here is NOT a floor, the server resolves the cycle in force against today. Applied INDEPENDENTLY of activate_limit, which caps SENDING and never the receiver's balance (PRD decision 4). null => full history (no reset). */
  force_init_date?: Maybe<Scalars['DateTime']['output']>;
  forced_start_date?: Maybe<Scalars['DateTime']['output']>;
  gold_medals?: Maybe<Scalars['Int']['output']>;
  has_participant_management?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** recognition_configuration_plan.activate_elements_ranking — mapped 1:1, no derivation (RecognitionConfigurationPlanNormalized.is_elements_ranking_active, db_column 'activate_elements_ranking'). Enables the NUMERIC VALUE PER ROW — the points or the medal count printed next to each collaborator, whichever metric is_public_ranking_points_enabled selected — and the ACCESS TO THE FULL PAGINATED RANKING (the 'ver todos' entry point). It never changes the ordering nor the positions: the ranking arrives ALREADY ORDERED and the listing publishes no position, so the client derives it from the index of the page it received ((page - 1) * page_size + index + 1, RN-08), while the CALLER'S OWN position is served explicitly by get_recognition_ranking_receiver_collaborator in context.ranking_position, computed over the COMPLETE ordered set and not over a page. Either way 1-3 carry the gold / silver / bronze icon and 4 onwards their number (RN-08). Only meaningful while is_public_ranking_enabled is true: with the block hidden there is no row to put a number on. NULLABLE like the column: null MUST be read as 'numbers and full ranking disabled' — never as 'unknown, assume enabled'. [PENDIENTE DE CONFIRMACION CON TALENT] the exact degraded render when this flag is false while is_public_ranking_enabled is true — whether the podium card still paints names, avatars and the three podium icons with the numbers stripped, or the card is hidden too. The column mapping itself is verified; only that UI consequence is pending. */
  is_elements_ranking_active?: Maybe<Scalars['Boolean']['output']>;
  is_justification_active?: Maybe<Scalars['Boolean']['output']>;
  is_justification_required?: Maybe<Scalars['Boolean']['output']>;
  is_limit_active?: Maybe<Scalars['Boolean']['output']>;
  is_module_active?: Maybe<Scalars['Boolean']['output']>;
  is_public_awarded_message_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** recognition_configuration_plan.public_ranking — mapped 1:1, no derivation (RecognitionConfigurationPlanNormalized.is_public_ranking_enabled, db_column 'public_ranking'). MASTER SWITCH OF THE WHOLE RANKING BLOCK of the collaborator app: false = the ranking card is not rendered at all, and that includes THE CALLER'S OWN POSITION, because the own position lives inside the same block (RN-02) — there is no standalone 'mi posicion' widget that survives the card being hidden. It is NOT the module gate: is_module_active is what turns recognition off entirely (RN-01), and a company may perfectly run recognition with the ranking hidden. NULLABLE like the column: a plan row written before the column existed answers null, and a null MUST be read as 'ranking hidden' — never as 'unknown, assume visible'. Both surfaces that implement this interface expose the SAME column under the SAME public name — unlike option_comments, which the admin renames to allow_comments. */
  is_public_ranking_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** recognition_configuration_plan.public_ranking_points — mapped 1:1, no derivation (RecognitionConfigurationPlanNormalized.is_public_ranking_points_enabled, db_column 'public_ranking_points'). RN-02 OF THE PRD: this single flag decides AT THE SAME TIME the ORDER CRITERION and the VISIBLE METRIC of the ranking, and the two are never shown together. true = rows arrive ordered by POINTS, the header reads 'Top puntos' and the numeric column shows points. false = rows arrive ordered by MEDALS, the header reads 'Top medallas' and the column shows medals. THE SAME HEADER AND THE SAME METRIC APPLY TO THE FULL PAGINATED RANKING (RN-03), so a client reads this flag ONCE and uses it for the podium card and for the paginated listing alike; the ranking operation orders its rows by this very flag server-side, so a client must never re-sort the page it received. WHAT THIS FLAG DOES NOT TOUCH: the window, which is ALWAYS the calendar quarter the read falls in, resolved server-side in the platform time zone (RN-04 — not a rolling three months, not user-configurable, not an input, and reboot_day does not shorten it, RN-05); and the side, which is ALWAYS recognitions RECEIVED, since v1 has no ranking of sent ones (RN-07). NULLABLE like the column: null MUST be read as false, i.e. the MEDALS branch ('Top medallas'), which is the legacy default — never as 'unknown, assume points'. */
  is_public_ranking_points_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Master switch for the redemption module. Maps the legacy numeric config 233 (ACTIVATE_RECOGNITION_REDEMPTION). DERIVED: NOT a column of recognition_configuration_plan — it comes from the numeric-config store (company_has_configuration(companyId, 233), D-06). The redemption double gate is is_module_active && is_redemption_active (RN-01). */
  is_redemption_active?: Maybe<Scalars['Boolean']['output']>;
  max_points_per_send?: Maybe<Scalars['Int']['output']>;
  medal_recognition_label?: Maybe<Scalars['String']['output']>;
  module_recognition_label?: Maybe<Scalars['String']['output']>;
  reboot_day?: Maybe<Scalars['Int']['output']>;
  silver_medals?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentRecognitionDivisionModelTopMedalsStatistic = {
  __typename?: 'PrivateTalentRecognitionDivisionModelTopMedalsStatistic';
  points?: Maybe<Scalars['Int']['output']>;
  quantity_medals?: Maybe<Scalars['Int']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentRecognitionDivisionModelTopMedalsStatistics = {
  __typename?: 'PrivateTalentRecognitionDivisionModelTopMedalsStatistics';
  division_model: PrivateTalentDivision;
  /** recognition division model statistics like quantity_medals by model */
  statistics: PrivateTalentRecognitionDivisionModelTopMedalsStatistic;
};

/** An edge in a connection. */
export type PrivateTalentRecognitionDivisionModelTopMedalsStatisticsEdge = {
  __typename?: 'PrivateTalentRecognitionDivisionModelTopMedalsStatisticsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentRecognitionDivisionModelTopMedalsStatistics;
};

export type PrivateTalentRecognitionEmployee = {
  __typename?: 'PrivateTalentRecognitionEmployee';
  approved_by_id?: Maybe<Scalars['Int']['output']>;
  approved_user_id?: Maybe<Scalars['Int']['output']>;
  comment_request?: Maybe<Scalars['String']['output']>;
  comments_option?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  employee?: Maybe<PrivateTalentEmployee>;
  employee_id: Scalars['Int']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  group_id?: Maybe<Scalars['Int']['output']>;
  has_new_message?: Maybe<Scalars['Boolean']['output']>;
  has_new_message_like?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  inactivated_at?: Maybe<Scalars['DateTime']['output']>;
  is_public_medal?: Maybe<Scalars['Boolean']['output']>;
  learning_file_id?: Maybe<Scalars['Int']['output']>;
  recognition_company?: Maybe<PrivateTalentRecognitionCompany>;
  recognition_company_id: Scalars['Int']['output'];
  recognition_file?: Maybe<Scalars['String']['output']>;
  request_date?: Maybe<Scalars['DateTime']['output']>;
  request_status?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<PrivateTalentEmployee>;
  sender_id: Scalars['Int']['output'];
  sent_at?: Maybe<Scalars['DateTime']['output']>;
  sent_from_admin?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type PrivateTalentRecognitionEmployeeModelPayload = {
  __typename?: 'PrivateTalentRecognitionEmployeeModelPayload';
  employee_model?: Maybe<PrivateTalentEmployee>;
  /** Recognition Employee model statistics like total medals */
  statistics: PrivateTalentRecognitionEmployeeModelStatistic;
};

export type PrivateTalentRecognitionEmployeeModelStatistic = {
  __typename?: 'PrivateTalentRecognitionEmployeeModelStatistic';
  total_medals?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentRecognitionEmployeeModelTopMedalsStatistic = {
  __typename?: 'PrivateTalentRecognitionEmployeeModelTopMedalsStatistic';
  points?: Maybe<Scalars['Int']['output']>;
  quantity_medals?: Maybe<Scalars['Int']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentRecognitionEmployeeModelTopMedalsStatisticConnection = {
  __typename?: 'PrivateTalentRecognitionEmployeeModelTopMedalsStatisticConnection';
  edges: Array<PrivateTalentRecognitionEmployeeModelTopMedalsStatisticsEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentRecognitionEmployeeModelTopMedalsStatistics = {
  __typename?: 'PrivateTalentRecognitionEmployeeModelTopMedalsStatistics';
  employee_model: PrivateTalentEmployee;
  /** recognition employee model statistics like quantity_medals by model */
  statistics: PrivateTalentRecognitionEmployeeModelTopMedalsStatistic;
};

/** An edge in a connection. */
export type PrivateTalentRecognitionEmployeeModelTopMedalsStatisticsEdge = {
  __typename?: 'PrivateTalentRecognitionEmployeeModelTopMedalsStatisticsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentRecognitionEmployeeModelTopMedalsStatistics;
};

export type PrivateTalentRecognitionLevel = {
  __typename?: 'PrivateTalentRecognitionLevel';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  points: Scalars['Int']['output'];
};

export type PrivateTalentRecognitionMailTemplateListPayload = {
  __typename?: 'PrivateTalentRecognitionMailTemplateListPayload';
  mail_templates: Array<PrivateTalentMailTemplate>;
};

export type PrivateTalentRecognitionParticipantConnection = {
  __typename?: 'PrivateTalentRecognitionParticipantConnection';
  edges: Array<PrivateTalentRecognitionParticipantNodeEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Un colaborador del selector de la lista de envío de medallas + su fila en la lista, si tiene. En el listado de ASIGNADOS participant_id y state nunca son null (la fila existe y está ACTIVE). En el de DISPONIBLES son null cuando el colaborador nunca fue asignado, y traen la fila con state=INACTIVE cuando fue dado de baja — el alta la reactiva en vez de insertar una segunda (RN-11). */
export type PrivateTalentRecognitionParticipantNode = {
  __typename?: 'PrivateTalentRecognitionParticipantNode';
  /** Catálogo del colaborador: nombre, foto, cargo (job), división y nivel. */
  employee: PrivateTalentEmployee;
  /** Id de la fila de recognition_partaker; null si nunca fue asignado. */
  participant_id?: Maybe<Scalars['ID']['output']>;
  /** Estado de la fila: ACTIVE o INACTIVE (los literales exactos que lee el legacy); null si nunca fue asignado. */
  state?: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type PrivateTalentRecognitionParticipantNodeEdge = {
  __typename?: 'PrivateTalentRecognitionParticipantNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentRecognitionParticipantNode;
};

export type PrivateTalentRecognitionProduct = {
  __typename?: 'PrivateTalentRecognitionProduct';
  code?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['Int']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  last_update_date?: Maybe<Scalars['DateTime']['output']>;
  last_update_stock?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stock?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type PrivateTalentRecognitionProductEdge = {
  __typename?: 'PrivateTalentRecognitionProductEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentRecognitionProduct;
};

export type PrivateTalentRecognitionRedemption = {
  __typename?: 'PrivateTalentRecognitionRedemption';
  employee?: Maybe<PrivateTalentEmployee>;
  id: Scalars['Int']['output'];
  points: Scalars['Int']['output'];
  product?: Maybe<PrivateTalentRecognitionProduct>;
  requested_at?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type PrivateTalentRecognitionRedemptionEdge = {
  __typename?: 'PrivateTalentRecognitionRedemptionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentRecognitionRedemption;
};

/** Resultado de remove_recognition_participants_admin: cuántas filas pasaron a INACTIVE por esta llamada. */
export type PrivateTalentRecognitionRemoveParticipantsPayload = {
  __typename?: 'PrivateTalentRecognitionRemoveParticipantsPayload';
  /** Filas que pasaron de ACTIVE a INACTIVE. Las que ya estaban INACTIVE (o que no existen) NO cuentan: quitar dos veces es un no-op exitoso con 0 (RN-12). */
  affected_count: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentRecognitionSubsidiaryModelTopMedalsStatistic = {
  __typename?: 'PrivateTalentRecognitionSubsidiaryModelTopMedalsStatistic';
  points?: Maybe<Scalars['Int']['output']>;
  quantity_medals?: Maybe<Scalars['Int']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentRecognitionSubsidiaryModelTopMedalsStatistics = {
  __typename?: 'PrivateTalentRecognitionSubsidiaryModelTopMedalsStatistics';
  /** recognition subsidiary model statistics like quantity_medals by model */
  statistics: PrivateTalentRecognitionSubsidiaryModelTopMedalsStatistic;
  subsidiary_model: PrivateTalentSubsidiary;
};

/** An edge in a connection. */
export type PrivateTalentRecognitionSubsidiaryModelTopMedalsStatisticsEdge = {
  __typename?: 'PrivateTalentRecognitionSubsidiaryModelTopMedalsStatisticsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: PrivateTalentRecognitionSubsidiaryModelTopMedalsStatistics;
};

export type PrivateTalentRedemptionConnection = {
  __typename?: 'PrivateTalentRedemptionConnection';
  edges: Array<PrivateTalentRecognitionRedemptionEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentReopenQuestionnairePayload = {
  __typename?: 'PrivateTalentReopenQuestionnairePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentRestartQuestionnairePayload = {
  __typename?: 'PrivateTalentRestartQuestionnairePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentRewardAdminConnection = {
  __typename?: 'PrivateTalentRewardAdminConnection';
  edges: Array<PrivateTalentRecognitionProductEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentSaveCompanyMailTemplatePayload = {
  __typename?: 'PrivateTalentSaveCompanyMailTemplatePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentSaveDipParticipantsPayload = {
  __typename?: 'PrivateTalentSaveDipParticipantsPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentSaveDipProcessGeneralConfigPayload = {
  __typename?: 'PrivateTalentSaveDipProcessGeneralConfigPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** Id of the created or updated PID process. */
  id: Scalars['ID']['output'];
};

export type PrivateTalentSendBulkCompanyEmailPayload = {
  __typename?: 'PrivateTalentSendBulkCompanyEmailPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentSendCompanyEmailPayload = {
  __typename?: 'PrivateTalentSendCompanyEmailPayload';
  mail_template: PrivateTalentSendCompanyEmailTemplate;
};

export type PrivateTalentSendCompanyEmailTemplate = {
  __typename?: 'PrivateTalentSendCompanyEmailTemplate';
  company_id?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  receiver?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type PrivateTalentSubsidiary = {
  __typename?: 'PrivateTalentSubsidiary';
  company_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PrivateTalentSubsidiaryTopMedalsStatisticConnection = {
  __typename?: 'PrivateTalentSubsidiaryTopMedalsStatisticConnection';
  edges: Array<PrivateTalentRecognitionSubsidiaryModelTopMedalsStatisticsEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentTimelineCompetencesContext = {
  __typename?: 'PrivateTalentTimelineCompetencesContext';
  employee_in_process?: Maybe<Scalars['Boolean']['output']>;
  employees_in_process?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentTimelineCompetencesPayload = {
  __typename?: 'PrivateTalentTimelineCompetencesPayload';
  competences_process: PrivateTalentEvaluation;
  context: PrivateTalentTimelineCompetencesContext;
  employes: Array<PrivateTalentEmployee>;
};

export type PrivateTalentTimelineDipContext = {
  __typename?: 'PrivateTalentTimelineDipContext';
  employee_in_process?: Maybe<Scalars['Boolean']['output']>;
  employees_in_process?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentTimelineDipPayload = {
  __typename?: 'PrivateTalentTimelineDipPayload';
  context: PrivateTalentTimelineDipContext;
  dip_process: PrivateTalentDipProcess;
  employes: Array<PrivateTalentEmployee>;
};

export type PrivateTalentTimelineGoalContext = {
  __typename?: 'PrivateTalentTimelineGoalContext';
  employee_in_process?: Maybe<Scalars['Boolean']['output']>;
  employees_in_process?: Maybe<Scalars['Int']['output']>;
};

export type PrivateTalentTimelineGoalPayload = {
  __typename?: 'PrivateTalentTimelineGoalPayload';
  context: PrivateTalentTimelineGoalContext;
  employes: Array<PrivateTalentEmployee>;
  goal_process: PrivateTalentGoalProcess;
};

export type PrivateTalentTimelinePayload = {
  __typename?: 'PrivateTalentTimelinePayload';
  competences: Array<PrivateTalentTimelineCompetencesPayload>;
  dip: Array<PrivateTalentTimelineDipPayload>;
  goals: Array<PrivateTalentTimelineGoalPayload>;
};

export type PrivateTalentUpdateBehaviorPayload = {
  __typename?: 'PrivateTalentUpdateBehaviorPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdateCompetenceFilterPayload = {
  __typename?: 'PrivateTalentUpdateCompetenceFilterPayload';
  /** The updated competence filter. */
  filter: PrivateTalentCompetencesFilter;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdateCompetenceLevelPayload = {
  __typename?: 'PrivateTalentUpdateCompetenceLevelPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdateCompetencesEvaluationConfigurationPayload = {
  __typename?: 'PrivateTalentUpdateCompetencesEvaluationConfigurationPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdateCompetencesModelPayload = {
  __typename?: 'PrivateTalentUpdateCompetencesModelPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdateCompetencesModelStatusPayload = {
  __typename?: 'PrivateTalentUpdateCompetencesModelStatusPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdateCompetencesPayload = {
  __typename?: 'PrivateTalentUpdateCompetencesPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdateDipCollaboratorActivityInput = {
  /** Activity class ("Clase"). Origin: activity_pid.class. */
  activity_class?: InputMaybe<Scalars['String']['input']>;
  /** Id of the EMPLOYEE-owned activity being edited (the ``dip_employee`` assignment's activity). Origin: activity_pid.id. */
  activity_id: Scalars['ID']['input'];
  /** Optional activity attachment. Origin: activity_pid.attachment_id. */
  attachment_id?: InputMaybe<Scalars['Int']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Job-level id the activity applies to (chips in the view). Null = every job level ("Todos", RN-004). Origin: activity_pid.company_level. */
  company_level_id?: InputMaybe<Scalars['Int']['input']>;
  /** Activity description. Origin: activity_pid.description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Conditional detail (RN-003): id of the module element (competence / goal / OKR) the activity is linked to. EXACTLY ONE is allowed here (unlike the library flows): the BE re-links it in the matching bridge table AND mirrors it in the collaborator's assignment (``dip_employee.goalcompvalue``, with the type in ``type_goalcompvalue``) whatever the module is. Only valid when type != WITHOUTPROCESS. */
  detail_id?: InputMaybe<Scalars['Int']['input']>;
  /** PID process that owns the activity (RN-013). Origin: activity_pid.plan_id. */
  dip_id: Scalars['ID']['input'];
  /** 70-20-10 model bucket (SEVENTY / TWENTY / TEN). Origin: activity_pid.model_70_20_10. */
  model_70_20_10?: InputMaybe<ActivityDipModelLabelsEnum>;
  /** Activity name. Required (RN-002) -> ValidationErrorV2 if empty. Origin: activity_pid.name. */
  name: Scalars['String']['input'];
  /** Points the activity contributes. Origin: activity_pid.points. */
  points?: InputMaybe<Scalars['Int']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** "Proceso" of the modal = module the activity is linked to. WITHOUTPROCESS = "Sin proceso". Origin: activity_pid.type. Limited to the modules enabled in Step 1 (RN-011). */
  type: PidActivityTypeEnum;
};

export type PrivateTalentUpdateDipCollaboratorActivityPayload = {
  __typename?: 'PrivateTalentUpdateDipCollaboratorActivityPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** Id of the updated employee-owned activity. */
  id: Scalars['ID']['output'];
};

export type PrivateTalentUpdateDipLibraryActivityInput = {
  /** Activity class ("Clase"). Origin: activity_pid.class. */
  activity_class?: InputMaybe<Scalars['String']['input']>;
  /** Id of the library activity being edited. Origin: activity_pid.id. */
  activity_id: Scalars['ID']['input'];
  /** Optional activity attachment. Origin: activity_pid.attachment_id. */
  attachment_id?: InputMaybe<Scalars['Int']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Job-level id the activity applies to (chips in the library view). Null = every job level ("Todos", RN-004). Origin: activity_pid.company_level. */
  company_level_id?: InputMaybe<Scalars['Int']['input']>;
  /** Activity description. Origin: activity_pid.description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Conditional detail (RN-003): ids of the module elements (competences / goals / OKRs) the activity is linked to. SEVERAL may be sent for one activity; the list REPLACES the activity's current links (one bridge row per id). Only valid when type != WITHOUTPROCESS; null/empty leaves the existing links untouched. */
  detail_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** PID process that owns the activity (RN-013). Origin: activity_pid.plan_id. */
  dip_id: Scalars['ID']['input'];
  /** 70-20-10 model bucket (SEVENTY / TWENTY / TEN). Origin: activity_pid.model_70_20_10. */
  model_70_20_10?: InputMaybe<ActivityDipModelLabelsEnum>;
  /** Activity name. Required (RN-002) -> ValidationErrorV2 if empty. Origin: activity_pid.name. */
  name: Scalars['String']['input'];
  /** Points the activity contributes. Origin: activity_pid.points. */
  points?: InputMaybe<Scalars['Int']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** "Proceso" of the modal = module the activity is linked to. WITHOUTPROCESS = "Sin proceso". Origin: activity_pid.type. Limited to the modules enabled in Step 1 (RN-011). */
  type: PidActivityTypeEnum;
};

export type PrivateTalentUpdateDipLibraryActivityPayload = {
  __typename?: 'PrivateTalentUpdateDipLibraryActivityPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** Id of the updated library activity. */
  id: Scalars['ID']['output'];
};

export type PrivateTalentUpdateEvaluationPayload = {
  __typename?: 'PrivateTalentUpdateEvaluationPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  is_behavioral_option_valid: Scalars['Boolean']['output'];
};

export type PrivateTalentUpdateEvaluationRelationWeightsPayload = {
  __typename?: 'PrivateTalentUpdateEvaluationRelationWeightsPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdatePerformanceGaussConfigurationPayload = {
  __typename?: 'PrivateTalentUpdatePerformanceGaussConfigurationPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdatePerformanceResultConfigurationPayload = {
  __typename?: 'PrivateTalentUpdatePerformanceResultConfigurationPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdatePersonLanguagePayload = {
  __typename?: 'PrivateTalentUpdatePersonLanguagePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdateRecognitionConfigurationPayload = {
  __typename?: 'PrivateTalentUpdateRecognitionConfigurationPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdateRecognitionMailTemplatePayload = {
  __typename?: 'PrivateTalentUpdateRecognitionMailTemplatePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdateRecognitionMedalPayload = {
  __typename?: 'PrivateTalentUpdateRecognitionMedalPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdateRecognitionMedalRequestStatusPayload = {
  __typename?: 'PrivateTalentUpdateRecognitionMedalRequestStatusPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdateRecognitionMedalStatusPayload = {
  __typename?: 'PrivateTalentUpdateRecognitionMedalStatusPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdateRecognitionRewardPayload = {
  __typename?: 'PrivateTalentUpdateRecognitionRewardPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  product?: Maybe<PrivateTalentRecognitionProduct>;
};

export type PrivateTalentUpdateRecognitionRewardRedemptionStatusPayload = {
  __typename?: 'PrivateTalentUpdateRecognitionRewardRedemptionStatusPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdateRecognitionRewardStatusPayload = {
  __typename?: 'PrivateTalentUpdateRecognitionRewardStatusPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpdateStatusCompetencesEvaluationPayload = {
  __typename?: 'PrivateTalentUpdateStatusCompetencesEvaluationPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateTalentUpsertCompetenceEmailTemplatePayload = {
  __typename?: 'PrivateTalentUpsertCompetenceEmailTemplatePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type PrivateUserAssigmentType = IAllowedUserType & {
  __typename?: 'PrivateUserAssigmentType';
  achievements_set: Scalars['JSON']['output'];
  email?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
  last_name: Scalars['String']['output'];
  profile_picture?: Maybe<ImageNode>;
  tag_list: Scalars['JSON']['output'];
  user_id: Scalars['ID']['output'];
};

export type PrivateUserTeamAutomationRuleType = PrivateAutomationRuleType & {
  __typename?: 'PrivateUserTeamAutomationRuleType';
  assigned_user_teams: UserTeamAutomationRuleTypeListResponse;
  current_version: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_paused: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rule_type: AutomationRuleTypeEnum;
  segmentation_rules: AutomationSegmentationRulesFragmentListResponse;
  user?: Maybe<UserAutomationRule>;
  users_created_at_range?: Maybe<UserCreateAtRangeType>;
};

export type ProcessMarketplaceFailedProductOrderInput = {
  product_id: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  user_id: Scalars['Int']['input'];
};

export type ProcessMarketplaceFailedProductOrderResponse = {
  __typename?: 'ProcessMarketplaceFailedProductOrderResponse';
  /**
   * This object contains information about the response code,
   *         response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ProcessMarketplacePaidProductOrderInput = {
  product_id: Scalars['Int']['input'];
  user_id: Scalars['Int']['input'];
};

export type ProcessMarketplacePaidProductOrderResponse = {
  __typename?: 'ProcessMarketplacePaidProductOrderResponse';
  /**
   * This object contains information about the response code,
   *         response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ProcessSaml2SpResponseInput = {
  centralized_organization_id: Scalars['ID']['input'];
  relay_state?: InputMaybe<Scalars['String']['input']>;
  saml_response: Scalars['String']['input'];
};

export type Product = {
  __typename?: 'Product';
  /** @deprecated Remove field */
  approved_certificate_template?: Maybe<ImageType>;
  /** @deprecated Remove field */
  certificate_description?: Maybe<Scalars['String']['output']>;
  cover_image?: Maybe<ImageType>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  has_seen_certification_tab: Scalars['Boolean']['output'];
  has_seen_mentor_tab: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_draft: Scalars['Boolean']['output'];
  is_index?: Maybe<Scalars['Boolean']['output']>;
  item_type?: Maybe<Scalars['Int']['output']>;
  item_value?: Maybe<Scalars['String']['output']>;
  local_amount?: Maybe<Scalars['Float']['output']>;
  local_currency?: Maybe<Scalars['String']['output']>;
  local_fake_amount?: Maybe<Scalars['Float']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  organization_id: Scalars['ID']['output'];
  preview_url?: Maybe<Scalars['String']['output']>;
  product_category?: Maybe<ProductCategory>;
  product_details: Array<ProductDetail>;
  product_faqs: Array<ProductFaq>;
  product_skills: Array<ProductSkills>;
  /** @deprecated Remove field */
  promo_image?: Maybe<ImageType>;
  seo_image?: Maybe<ImageType>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  usd_amount?: Maybe<Scalars['Float']['output']>;
};


export type ProductProduct_DetailsArgs = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductProduct_FaqsArgs = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductProduct_SkillsArgs = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization_id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
};

export type ProductConnection = {
  __typename?: 'ProductConnection';
  edges: Array<ProductEdge>;
  page_info: PageInfo;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type ProductDetail = {
  __typename?: 'ProductDetail';
  /** @deprecated Remove field */
  cohort_finish_date?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Remove field */
  cohort_start_date?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Remove field */
  cohort_status?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Remove field */
  cohort_title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  /** @deprecated Remove field */
  is_synchronous_class: Scalars['Boolean']['output'];
  item?: Maybe<Course>;
  item_type: Scalars['Int']['output'];
  item_value: Scalars['ID']['output'];
  product: Product;
};

export type ProductDetailConnection = {
  __typename?: 'ProductDetailConnection';
  edges: Array<ProductDetailEdge>;
  page_info: PageInfo;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type ProductDetailEdge = {
  __typename?: 'ProductDetailEdge';
  cursor: Scalars['String']['output'];
  node: ProductDetail;
};

export type ProductDetailInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  item_value?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductEdge = {
  __typename?: 'ProductEdge';
  cursor: Scalars['String']['output'];
  node: Product;
};

export type ProductFaq = {
  __typename?: 'ProductFAQ';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  product?: Maybe<Product>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProductFaqInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum ProductFieldEnum {
  BestSeller = 'BEST_SELLER',
  CreatedAt = 'CREATED_AT',
  Title = 'TITLE'
}

export type ProductOrderByFieldInput = {
  direction: OrderDirectionEnum;
  field: ProductFieldEnum;
};

/** A product pulse card showing key KPIs for a product. */
export type ProductPulseCard = {
  __typename?: 'ProductPulseCard';
  /** Relative URL to the product's detail view (e.g. '/analytics-hub/admin/learning'). */
  detail_url?: Maybe<Scalars['String']['output']>;
  /** Structured error code for degraded cards ('INVALID_PERIOD' on inconsistent period input). Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Whether the current user has permissions to view this product module. When false, frontend should hide the widget and KPIs will be empty. */
  has_permissions: Scalars['Boolean']['output'];
  /** Icon name for the card header (e.g. 'school', 'target', 'work', 'send'). */
  icon: Scalars['String']['output'];
  /** Key metrics for this product (2–3 items). */
  kpis: Array<ModuleKpi>;
  /** Display name of the product. */
  label: Scalars['String']['output'];
  /** Localized timestamp of the most recent ETL sync for this widget's data. Format: '23 abr - 9:25am'. Null when freshness cannot be determined. */
  last_updated_at_formatted?: Maybe<Scalars['String']['output']>;
  /** Resolved calendar window [start, end] the KPIs cover, for the applied date-filter tag. Null on permission-denied cards. */
  period?: Maybe<PeriodRange>;
  /** Product identifier matching DashboardProductEnum (e.g. 'product_learning'). */
  product_type: Scalars['String']['output'];
};

export type ProductSkillInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductSkills = {
  __typename?: 'ProductSkills';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  product?: Maybe<Product>;
};

/** Audit log entry for license changes. */
export type ProductSuiteLicenseLogNode = {
  __typename?: 'ProductSuiteLicenseLogNode';
  /** Action performed */
  action: Scalars['String']['output'];
  /** When the change was made */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Change amount */
  delta: Scalars['Int']['output'];
  /** Total after change */
  new_total: Scalars['Int']['output'];
  /** Email of person who made the change */
  performed_by_email: Scalars['String']['output'];
  /** Total before change */
  previous_total: Scalars['Int']['output'];
  /** Reason for the change */
  reason?: Maybe<Scalars['String']['output']>;
};

/** Product suite catalog entry. */
export type ProductSuiteNode = {
  __typename?: 'ProductSuiteNode';
  /** Unique product suite code */
  code: Scalars['String']['output'];
  /** Suite description */
  description?: Maybe<Scalars['String']['output']>;
  /** Suite icon URL or identifier */
  icon?: Maybe<Scalars['String']['output']>;
  /** Whether the suite is active */
  is_active: Scalars['Boolean']['output'];
  /** Display name */
  name: Scalars['String']['output'];
};

/** Crehana product that owns the campaign */
export enum ProductType {
  Engagement = 'ENGAGEMENT',
  Learning = 'LEARNING',
  Payroll = 'PAYROLL',
  Performance = 'PERFORMANCE',
  PersonasHris = 'PERSONAS_HRIS',
  Recruitment = 'RECRUITMENT'
}

export enum ProductTypeEnum {
  ProductAts = 'PRODUCT_ATS',
  ProductClimate = 'PRODUCT_CLIMATE',
  ProductConnection = 'PRODUCT_CONNECTION',
  ProductHana = 'PRODUCT_HANA',
  ProductHris = 'PRODUCT_HRIS',
  ProductLearning = 'PRODUCT_LEARNING',
  ProductManagement = 'PRODUCT_MANAGEMENT',
  ProductPerformance = 'PRODUCT_PERFORMANCE',
  ProductRecognition = 'PRODUCT_RECOGNITION',
  ProductRecruitment = 'PRODUCT_RECRUITMENT',
  ProductTalent = 'PRODUCT_TALENT',
  ProductTimeAndAttendance = 'PRODUCT_TIME_AND_ATTENDANCE'
}

export type ProfessorNode = {
  __typename?: 'ProfessorNode';
  full_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occupation?: Maybe<Scalars['String']['output']>;
  profile_picture?: Maybe<Scalars['String']['output']>;
  profile_picture_url?: Maybe<ImageNode>;
  profile_url?: Maybe<Scalars['String']['output']>;
};

export type ProfileBossType = {
  __typename?: 'ProfileBossType';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProfileDivisionType = {
  __typename?: 'ProfileDivisionType';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProfileJobType = {
  __typename?: 'ProfileJobType';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProfileOrganizationSettingsSidebarItem = OrganizationSettingsSidebarExternalUrlItem | OrganizationSettingsSidebarInternalUrlItem;

/** Filters for the competence progress query. */
export type ProgressByGroupInput = {
  /** Talent company id. */
  company_id: Scalars['Int']['input'];
  /** Dimension to group by: DEPARTMENT, JOB or LEVEL. */
  group_by: CompetenceGroupByDimension;
  /** Optional filter by the ids of the selected dimension. */
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Month (1-12) for the cumulative cut. */
  month: Scalars['Int']['input'];
  /** Page number (1-based). */
  page?: Scalars['Int']['input'];
  /** Number of groups per page. */
  page_size?: Scalars['Int']['input'];
  /** Evaluation x relation pairs to report (up to 3). */
  relations: Array<EvaluationRelationInput>;
  /** Year for the cumulative cut. */
  year: Scalars['Int']['input'];
};

/** Paginated competence progress grouped by a dimension. */
export type ProgressByGroupType = {
  __typename?: 'ProgressByGroupType';
  edges: Array<GroupProgressType>;
  page_info: ProgressPageInfoType;
  total_count: Scalars['Int']['output'];
};

/** Pagination metadata. */
export type ProgressPageInfoType = {
  __typename?: 'ProgressPageInfoType';
  current_page: Scalars['Int']['output'];
  has_next_page: Scalars['Boolean']['output'];
  has_previous_page: Scalars['Boolean']['output'];
  total_pages: Scalars['Int']['output'];
};

export type ProgressiveAssignmentInput = {
  filter_by?: InputMaybe<UserFilterByInput>;
  selected_all?: Scalars['Boolean']['input'];
  user_ids_in?: Array<Scalars['Int']['input']>;
  user_ids_nin?: Array<Scalars['Int']['input']>;
};

export type ProjectNode = {
  __typename?: 'ProjectNode';
  current_action_state?: Maybe<StatusProjectEnum>;
  description?: Maybe<Scalars['String']['output']>;
  has_certification?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_draft: Scalars['Boolean']['output'];
  project_image?: Maybe<Scalars['String']['output']>;
  publish_date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<UrlNode>;
};

export type ProjectRequirementType = {
  __typename?: 'ProjectRequirementType';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ProviderListResponse = BenefitProviderListPayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type ProviderType = {
  __typename?: 'ProviderType';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<File>;
  is_new: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum PubSubEvents {
  AllowedUserSync = 'ALLOWED_USER_SYNC',
  ApplyMassiveManagedHeadquarters = 'APPLY_MASSIVE_MANAGED_HEADQUARTERS',
  AssignPermissionGroupBatch = 'ASSIGN_PERMISSION_GROUP_BATCH',
  AssignUserToPermissionGroup = 'ASSIGN_USER_TO_PERMISSION_GROUP',
  AuditLogUserChanges = 'AUDIT_LOG_USER_CHANGES',
  AuditLogUserChangesMassive = 'AUDIT_LOG_USER_CHANGES_MASSIVE',
  BulkMassiveUserCreation = 'BULK_MASSIVE_USER_CREATION',
  BulkMassiveUserDelete = 'BULK_MASSIVE_USER_DELETE',
  CheckSingleUserToSyncInTalent = 'CHECK_SINGLE_USER_TO_SYNC_IN_TALENT',
  CreateUserReport = 'CREATE_USER_REPORT',
  DummyEvent = 'DUMMY_EVENT',
  DynamicSegmentationMassive = 'DYNAMIC_SEGMENTATION_MASSIVE',
  ExtractMassiveAssignUserToPermissionGroup = 'EXTRACT_MASSIVE_ASSIGN_USER_TO_PERMISSION_GROUP',
  ExtractMassiveUserCreation = 'EXTRACT_MASSIVE_USER_CREATION',
  ExtractMassiveUserDeactivation = 'EXTRACT_MASSIVE_USER_DEACTIVATION',
  GetAllUsersToSyncInTalent = 'GET_ALL_USERS_TO_SYNC_IN_TALENT',
  HrisApplyWorkflowTasks = 'HRIS_APPLY_WORKFLOW_TASKS',
  IntelexionUserSync = 'INTELEXION_USER_SYNC',
  LearningAssignCustomField = 'LEARNING_ASSIGN_CUSTOM_FIELD',
  LearningCreateUser = 'LEARNING_CREATE_USER',
  MassiveAssignmentToSegmentationGroup = 'MASSIVE_ASSIGNMENT_TO_SEGMENTATION_GROUP',
  MassiveUserCreation = 'MASSIVE_USER_CREATION',
  MassiveUserDeactivation = 'MASSIVE_USER_DEACTIVATION',
  NotifyMassiveUserCreation = 'NOTIFY_MASSIVE_USER_CREATION',
  NotifyMassiveUserDeactivation = 'NOTIFY_MASSIVE_USER_DEACTIVATION',
  ReceiveLearningOrgLogoToSyncInCentralized = 'RECEIVE_LEARNING_ORG_LOGO_TO_SYNC_IN_CENTRALIZED',
  ReceiveLearningUsersToSyncInCentralized = 'RECEIVE_LEARNING_USERS_TO_SYNC_IN_CENTRALIZED',
  SendUserActivationEmail = 'SEND_USER_ACTIVATION_EMAIL',
  StartSyncLearningProfilePictureToCentralizedAndTalent = 'START_SYNC_LEARNING_PROFILE_PICTURE_TO_CENTRALIZED_AND_TALENT',
  SyncCustomFieldsFromCentralized = 'SYNC_CUSTOM_FIELDS_FROM_CENTRALIZED',
  SyncLearningUser = 'SYNC_LEARNING_USER',
  TalentCreateUser = 'TALENT_CREATE_USER'
}

export type PubSubPublisherMutation = {
  __typename?: 'PubSubPublisherMutation';
  publish_batch: EventResponse;
  publish_schema: EventResponse;
  publish_simple: EventResponse;
};


export type PubSubPublisherMutationPublish_BatchArgs = {
  inputs: BatchAttributes;
};


export type PubSubPublisherMutationPublish_SchemaArgs = {
  inputs: EventAttributes;
};


export type PubSubPublisherMutationPublish_SimpleArgs = {
  inputs: SimpleEventAttributes;
};

export type PublicCentralizedOrganization = {
  __typename?: 'PublicCentralizedOrganization';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type PublicCentralizedOrganizationPersonalization = {
  __typename?: 'PublicCentralizedOrganizationPersonalization';
  favicon_url?: Maybe<Scalars['String']['output']>;
  login_url?: Maybe<Scalars['String']['output']>;
  logo_url?: Maybe<Scalars['String']['output']>;
};

export type PublicCorporationUserOrganizationAuthPayload = {
  __typename?: 'PublicCorporationUserOrganizationAuthPayload';
  authentication_methods: Array<CorporationUserOrganizationAuth>;
};

export type PublicTalentRecognitionConfiguration = {
  are_medals_approved?: Maybe<Scalars['Boolean']['output']>;
  can_boss_send_medal?: Maybe<Scalars['Boolean']['output']>;
  comment_label?: Maybe<Scalars['String']['output']>;
  company_id: Scalars['Int']['output'];
  /** Configured annual reset of the redemption points (RN-04). Origin: recognition_configuration_plan.force_init_date (1:1). YEAR-AGNOSTIC: only the month and the day are significant — the year carried here is NOT a floor, the server resolves the cycle in force against today. Applied INDEPENDENTLY of activate_limit, which caps SENDING and never the receiver's balance (PRD decision 4). null => full history (no reset). */
  force_init_date?: Maybe<Scalars['DateTime']['output']>;
  has_participant_management?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** recognition_configuration_plan.activate_elements_ranking — mapped 1:1, no derivation (RecognitionConfigurationPlanNormalized.is_elements_ranking_active, db_column 'activate_elements_ranking'). Enables the NUMERIC VALUE PER ROW — the points or the medal count printed next to each collaborator, whichever metric is_public_ranking_points_enabled selected — and the ACCESS TO THE FULL PAGINATED RANKING (the 'ver todos' entry point). It never changes the ordering nor the positions: the ranking arrives ALREADY ORDERED and the listing publishes no position, so the client derives it from the index of the page it received ((page - 1) * page_size + index + 1, RN-08), while the CALLER'S OWN position is served explicitly by get_recognition_ranking_receiver_collaborator in context.ranking_position, computed over the COMPLETE ordered set and not over a page. Either way 1-3 carry the gold / silver / bronze icon and 4 onwards their number (RN-08). Only meaningful while is_public_ranking_enabled is true: with the block hidden there is no row to put a number on. NULLABLE like the column: null MUST be read as 'numbers and full ranking disabled' — never as 'unknown, assume enabled'. [PENDIENTE DE CONFIRMACION CON TALENT] the exact degraded render when this flag is false while is_public_ranking_enabled is true — whether the podium card still paints names, avatars and the three podium icons with the numbers stripped, or the card is hidden too. The column mapping itself is verified; only that UI consequence is pending. */
  is_elements_ranking_active?: Maybe<Scalars['Boolean']['output']>;
  is_justification_active?: Maybe<Scalars['Boolean']['output']>;
  is_justification_required?: Maybe<Scalars['Boolean']['output']>;
  is_limit_active?: Maybe<Scalars['Boolean']['output']>;
  is_module_active?: Maybe<Scalars['Boolean']['output']>;
  is_public_awarded_message_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** recognition_configuration_plan.public_ranking — mapped 1:1, no derivation (RecognitionConfigurationPlanNormalized.is_public_ranking_enabled, db_column 'public_ranking'). MASTER SWITCH OF THE WHOLE RANKING BLOCK of the collaborator app: false = the ranking card is not rendered at all, and that includes THE CALLER'S OWN POSITION, because the own position lives inside the same block (RN-02) — there is no standalone 'mi posicion' widget that survives the card being hidden. It is NOT the module gate: is_module_active is what turns recognition off entirely (RN-01), and a company may perfectly run recognition with the ranking hidden. NULLABLE like the column: a plan row written before the column existed answers null, and a null MUST be read as 'ranking hidden' — never as 'unknown, assume visible'. Both surfaces that implement this interface expose the SAME column under the SAME public name — unlike option_comments, which the admin renames to allow_comments. */
  is_public_ranking_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** recognition_configuration_plan.public_ranking_points — mapped 1:1, no derivation (RecognitionConfigurationPlanNormalized.is_public_ranking_points_enabled, db_column 'public_ranking_points'). RN-02 OF THE PRD: this single flag decides AT THE SAME TIME the ORDER CRITERION and the VISIBLE METRIC of the ranking, and the two are never shown together. true = rows arrive ordered by POINTS, the header reads 'Top puntos' and the numeric column shows points. false = rows arrive ordered by MEDALS, the header reads 'Top medallas' and the column shows medals. THE SAME HEADER AND THE SAME METRIC APPLY TO THE FULL PAGINATED RANKING (RN-03), so a client reads this flag ONCE and uses it for the podium card and for the paginated listing alike; the ranking operation orders its rows by this very flag server-side, so a client must never re-sort the page it received. WHAT THIS FLAG DOES NOT TOUCH: the window, which is ALWAYS the calendar quarter the read falls in, resolved server-side in the platform time zone (RN-04 — not a rolling three months, not user-configurable, not an input, and reboot_day does not shorten it, RN-05); and the side, which is ALWAYS recognitions RECEIVED, since v1 has no ranking of sent ones (RN-07). NULLABLE like the column: null MUST be read as false, i.e. the MEDALS branch ('Top medallas'), which is the legacy default — never as 'unknown, assume points'. */
  is_public_ranking_points_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Master switch for the redemption module. Maps the legacy numeric config 233 (ACTIVATE_RECOGNITION_REDEMPTION). DERIVED: NOT a column of recognition_configuration_plan — it comes from the numeric-config store (company_has_configuration(companyId, 233), D-06). The redemption double gate is is_module_active && is_redemption_active (RN-01). */
  is_redemption_active?: Maybe<Scalars['Boolean']['output']>;
  max_points_per_send?: Maybe<Scalars['Int']['output']>;
  medal_recognition_label?: Maybe<Scalars['String']['output']>;
  module_recognition_label?: Maybe<Scalars['String']['output']>;
  reboot_day?: Maybe<Scalars['Int']['output']>;
};

export type PublicTalentRecognitionProduct = {
  /** recognition_product.description. */
  description?: Maybe<Scalars['String']['output']>;
  /** recognition_product.id. */
  id?: Maybe<Scalars['ID']['output']>;
  /** recognition_product.image — S3 URL. */
  image?: Maybe<Scalars['String']['output']>;
  /** recognition_product.name. */
  name?: Maybe<Scalars['String']['output']>;
  /** recognition_product.points — cost in recognition points. */
  points?: Maybe<Scalars['Int']['output']>;
  /** recognition_product.state — lifecycle state. */
  state?: Maybe<TalentRecognitionProductStateEnum>;
};

export type PublicTalentRecognitionRedemption = {
  /** recognition_redemption.employee_id — FK to the collaborator who redeemed (raw DB reference). */
  employee_id?: Maybe<Scalars['Int']['output']>;
  /** recognition_redemption.id — surrogate PK. */
  id: Scalars['Int']['output'];
  /** recognition_redemption.points — points charged for this redemption. */
  points: Scalars['Int']['output'];
  /** The redeemed product (shared PublicTalentRecognitionProduct interface). */
  product?: Maybe<PublicTalentRecognitionProduct>;
};

export type PublishHigherEducationTeamProductInput = {
  organization_slug: Scalars['String']['input'];
  product_id: Scalars['ID']['input'];
};

export type PublishHigherEducationTeamProductResponse = {
  __typename?: 'PublishHigherEducationTeamProductResponse';
  error?: Maybe<ErrorResponse>;
  invalid_fields?: Maybe<Array<TeamFieldErrorNode>>;
  product?: Maybe<Product>;
  success: Scalars['Boolean']['output'];
};

export enum QualifiedPerceptionEnum {
  Acceptable = 'ACCEPTABLE',
  Excellent = 'EXCELLENT',
  Unsatisfactory = 'UNSATISFACTORY'
}

export type QualifyPayload = {
  __typename?: 'QualifyPayload';
  behavior_id?: Maybe<Scalars['Int']['output']>;
  competence_id?: Maybe<Scalars['Int']['output']>;
  completed_behavior?: Maybe<Scalars['Boolean']['output']>;
  completed_competence?: Maybe<Scalars['Boolean']['output']>;
  completed_question?: Maybe<Scalars['Boolean']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type QualifySummary = {
  __typename?: 'QualifySummary';
  competences_summary?: Maybe<Array<Maybe<CompetenceSummary>>>;
  questionnaires_general_summary?: Maybe<Array<Maybe<QuestionnaireSummary>>>;
};

export enum QualifyTypeEnum {
  CompetenceComment = 'COMPETENCE_COMMENT',
  GeneralComment1 = 'GENERAL_COMMENT1',
  GeneralComment2 = 'GENERAL_COMMENT2',
  GeneralComment3 = 'GENERAL_COMMENT3',
  QuestionComment = 'QUESTION_COMMENT',
  QuestionResponse = 'QUESTION_RESPONSE'
}

/**  AGRUPACIÓN DE QUERIES */
export type Query = {
  __typename?: 'Query';
  access_token?: Maybe<AuthenticationAccessToken>;
  agent_os: AgentOsQuery;
  analytics_centralized_organization: AnalyticsCentralizedOrganizationQuery;
  analytics_organization: AnalyticsOrganizationQuery;
  analytics_organization_teams: AnalyticsOrganizationTeamsQuery;
  assign_organization_team_user_history: Array<AssignOrganizationUserFileNode>;
  assign_organization_user_file: QueryAssignOrganizationUserFile;
  /** Type of all resources [Queries] of the ATS Recruitment */
  ats_recruitment: AtsRecruitmentQuery;
  /** Namespace for audit log-related queries. */
  audit_logs: AuditLogResolvers;
  authentication_saml2: AuthenticationSaml2NamespaceQuery;
  authorization_server: AuthorizationServerNamespaceQuery;
  automation: AutomationBuilderQuery;
  /** This query shows active users who have organization. */
  b2b_users: Array<Maybe<User>>;
  /** This query shows active users who have organization. */
  b2b_users_counter: UserCounter;
  benefit: BenefitQueryBuilder;
  block_player: BlockPlayerQuery;
  blog: BlogQuery;
  catalog_category: Array<CatalogCategoryNode>;
  /** List of categories */
  categories: CategoryConnection;
  celery: CeleryQuery;
  /** Get Custom Field by id */
  centralized_custom_field_by_id?: Maybe<CustomFieldNode>;
  /** Gets organization information */
  centralized_organization?: Maybe<CentralizedOrganizationNode>;
  centralized_organizations: CentralizedOrganizationsQueries;
  centralized_products: CentralizedProductsNamespaceQuery;
  centralized_security: CentralizedSecurityNamespaceQuery;
  centralized_users: CentralizedUserOrganizationQueries;
  centralized_users_segmentation: SegmentationQueries;
  /** Get certificate information by course_id */
  certificate?: Maybe<CertificateNode>;
  certificate_admin: CertificateAdminQuery;
  certificate_collaborator: CertificateQuery;
  /** Get courses certification rules. */
  certificate_course_rules: Array<CourseCertificationRuleNode>;
  certificate_policy: CertificatePolicyBuilderQuery;
  certificate_template: CertificateBuilderQuery;
  /** Query for organization dashboard with ranking */
  certificates?: Maybe<CertificateDashboard>;
  /** Check if a position is currently in use by users or segmentation rules. This query helps validate if a position can be safely modified or deactivated. */
  check_position_usage: PositionUsageCheckResponse;
  class_notes: ClassNoteConnection;
  /** Consult Datafast Transaction */
  consult_datafast_transaction?: Maybe<DatafastTransaction>;
  content_enrollments: EnrollmentBuilderQuery;
  content_organization: OrganizationBuilderQuery;
  content_organization_team: OrganizationTeamBuilderQuery;
  contract: EmploymentContractQuery;
  /** HRIS - Converts an uploaded .docx file into the HTML content used to build a document template (wizard Step 1). */
  convert_document_template_from_docx: HrisCorporateDocumentsDocumentTemplateDocxContentHrisQueryValidationErrorHrisQueryInternalError;
  copilot: CopilotQuery;
  /** Queries read-only de analítica que consume el MCP del copilot. */
  copilot_analytics: CopilotAnalyticsQuery;
  copilot_categories: Array<CopilotCategoryNode>;
  copilot_data: CopilotDataQuery;
  corporate_documents: CorporateDocumentsQueries;
  /** Namespace for corporation-related queries. */
  corporation: CorporationQueries;
  /** Gets complete countries Information */
  countries?: Maybe<Array<CountryNode>>;
  /** Gets country Information using alpha 3 (PER) */
  country?: Maybe<CountryNode>;
  /** Type of all Courses [Queries] course app */
  course: CourseQuery;
  /** Namespace for course audit logs queries. */
  course_audit_logs: AdminAuditLogCourseQueries;
  /**
   * Course dependencies status query that uses the user's session to obtain the status of the course enrollment
   * @deprecated Use "course_dependencies_status_in_track" instead
   */
  course_dependencies_status: Array<CourseDependencieStatusNode>;
  /** Course dependencies status query that uses the user's session to obtain the status of the course enrollment */
  course_dependencies_status_in_track: Array<CourseDependencieStatusNode>;
  course_metrics: CourseMetricsQuery;
  course_modules: Array<CourseModule>;
  /** Query organization course ranking */
  course_ranking_by_org: Array<CourseAnalytics>;
  course_video_highlights: Array<CourseVideoHighlight>;
  course_video_transcript?: Maybe<VideoTranscript>;
  course_video_transcripts?: Maybe<Array<VideoTranscript>>;
  course_videos?: Maybe<Array<CourseVideo>>;
  /** The Currency Event or Currency Achievement detail */
  currency_event_or_achievement_detail?: Maybe<CurrencyEventNode>;
  /** The Currency Event or Currency Achievement list */
  currency_event_or_achievement_list?: Maybe<CurrencyEventConnection>;
  /** The Currency point detail */
  currency_point_detail?: Maybe<CurrencyPointNode>;
  /** The Currency point list */
  currency_point_list?: Maybe<CurrencyPointConnection>;
  custom_field: B2BCustomFieldBuilderQuery;
  custom_field_by_id?: Maybe<LearningCustomFieldWithOptions>;
  /** Query custom field performance summary */
  custom_field_performance_summary: CustomFieldPerformanceResponse;
  /** Get Organization Custom Fields Template */
  custom_field_template: CustomFieldAttachment;
  /** Get Organization Custom Fields */
  custom_fields?: Maybe<Array<CustomFieldNode>>;
  custom_fields_by_org: Array<LearningCustomField>;
  custom_fields_filter_groups_by_org_user: LearningCustomFieldFilterGroupConnection;
  /** Get Organization Custom Fields */
  custom_fields_v2: CustomFieldNodeCustomConnection;
  dasboard?: Maybe<AccountFunnel>;
  /** Type of all resources [Queries] of the Dashboard app */
  dashboards: ReportDashboardQuery;
  /** Gets organization information */
  dummy_query: DummyNode;
  emails: EmailBuilderQuery;
  /** Enrollments Queries Namespace */
  enrollments: EnrollmentQuery;
  /** Get banks from PSE */
  epayco_pse_banks: Array<PseBankData>;
  /** Return a list of Excel Import historical data */
  excel_imports: ExcelImportsNodeCustomConnection;
  /** @deprecated Use get_feature_flag instead */
  feature_flag?: Maybe<FeatureFlag>;
  features_flags: FeaturesFlagQuery;
  files_v1: GetFileV1Query;
  /** Type of all resources [Queries] of the foundation home app */
  foundation_home: HomeFoundationQuery;
  /** Foundation Home User Queries Namespace */
  foundation_home_user: FoundationHomeUserQuery;
  /** Foundation Leader Queries Namespace */
  foundation_leader: FoundationLeaderQuery;
  /** Foundation Reports Queries Namespace */
  foundation_reports: FoundationReportsBuilder;
  gamification: Gamification;
  gamification_currency_point: CurrencyPoints;
  gamification_leaderboard: Leaderboard;
  gamification_reward: Rewards;
  gamification_v2: StableGamificationQueriesV2;
  /** Lists employees assigned to the given positions (STEP 2). */
  generate_recommendations: GenerateRecommendationsResponse;
  /** HRIS - Resolves a document template's wildcards with a specific collaborator's data and returns the merged HTML. Does not generate a PDF (see HRIS-3939). */
  generate_template_document_preview: HrisCorporateDocumentsDocumentTemplatePreviewHrisQueryValidationErrorHrisQueryInternalError;
  /** Return active modules in an organization */
  get_active_modules: Array<MenuModuleNode>;
  get_admin_by_organization: Array<UserOrganization>;
  /** Gets affected users by conditionals information */
  get_affected_users_by_conditionals: AffectedUsersByConditionalsNodeCustomConnection;
  /** Gets all organization enterprise IDs (learning, talent, workbeat) given an internal_id and enterprise */
  get_all_organization_enterprise_ids?: Maybe<OrganizationEnterpriseIdsNode>;
  /** Return dynamic menu by user */
  get_allowed_modules?: Maybe<ModuleInfoResponse>;
  get_api_client?: Maybe<AuthenticationApiClient>;
  /** Reporte 4 de Asistencia — Gestión diaria de marcas. Una fila por colaborador y día. Las duraciones se expresan en minutos. `from_date`/`to_date` son obligatorios y la ventana máxima es de 31 días. */
  get_attendance_daily_management_report: AttendanceDailyManagementReportConnectionQueryValidationErrorQueryInternalError;
  /** Reporte 3 de Asistencia — Recepción de marcas. Una fila por marca. `from_date`/`to_date` son obligatorios y la ventana máxima es de 31 días: la tabla es de altísima cardinalidad. */
  get_attendance_marks_report: AttendanceMarkReportConnectionQueryValidationErrorQueryInternalError;
  /** Reporte 1 de Asistencia — Creación de turnos. Catálogo de turnos configurados, una fila por turno. El rango de fechas (opcional) se aplica sobre la fecha de creación del turno. */
  get_attendance_shifts_report: AttendanceShiftReportConnectionQueryValidationErrorQueryInternalError;
  /** Reporte 2 de Asistencia — Programación de turnos. Asignaciones vigentes turno ↔ colaborador. El rango de fechas (opcional) se aplica sobre el inicio de la asignación. */
  get_attendance_shifts_schedule_report: AttendanceShiftScheduleReportConnectionQueryValidationErrorQueryInternalError;
  /** Get Ebanx bin list */
  get_bin_list_ebanx?: Maybe<EbanxBinList>;
  /** Fetch headquarters with complete address for an organization. Returns a flat list with offset/limit pagination. Implicitly filters for active headquarters with complete address (address1, city, state, postal_code not null). */
  get_centralized_headquarters: GetCentralizedHeadquartersResponse;
  /** Gets tenant information */
  get_centralized_organization?: Maybe<CentralizedOrganizationTenantNodeInternalErrorResponseValidationErrorResponseNotFoundResponse>;
  /** Retrieves centralized organization licenses */
  get_centralized_organization_licences?: Maybe<CentralizedOrganizationLicences>;
  /** Get Organization Position */
  get_centralized_organization_position: OrganizationPositionNodeCustomConnection;
  /** Get Organization Position Categories */
  get_centralized_organization_position_category: OrganizationPositionCategoryNodeCustomConnection;
  get_centralized_user_from_talent: CentralizedUserPayloadQueryValidationErrorQueryInternalServerError;
  /** Gets the centralized user_id given an internal_id and enterprise */
  get_centralized_user_ids?: Maybe<CentralizedUserIdNodeValidationErrorResponseInternalErrorResponse>;
  /** Reporte de resultados de competencias. Una fila por colaborador evaluado y proceso, con el resultado configurado (escala y porcentaje) y el nivel del semáforo tal como los muestra Talent. Filtrable por evaluación y por colaborador; sin filtros devuelve todos los procesos de la organización. */
  get_competences_results_report: CompetencesResultReportConnectionQueryValidationErrorQueryInternalError;
  get_coporation_user_organization_auth: CorporationUserOrganizationAuthPayload;
  get_course?: Maybe<Course>;
  /** Get the number of retries of the course */
  get_course_retries?: Maybe<CourseMirrorRetriesNode>;
  /** Get validation of the course for quiz */
  get_course_validation_quiz?: Maybe<CourseMirrorUserValidationNode>;
  get_courses: CourseConnection;
  /** Criticality Tag list. */
  get_criticalities_by_organization: OrganizationPositionCriticalityQueryResponse;
  get_current_user_organization: UserOrganization;
  /** Return a list of Custom Field Values related to a Custom Field */
  get_custom_field_users: CustomFieldUserValueNodeConnection;
  /** Get a document by ID */
  get_document_by_id?: Maybe<DocumentInfoNode>;
  /** Get document template to sign */
  get_document_signature_report?: Maybe<DocumentSignatureReportTemplateNode>;
  /** HRIS - Catalog of available document template wildcards, optionally filtered by category. `centralized_organization_id` is required to include the ATRIBUTOS (custom fields) group — without it, that group is omitted from the result. */
  get_document_wildcards_catalog: Array<HrisCorporateDocumentsDocumentTemplateWildcardOption>;
  /** Gets documents information */
  get_documents: DocumentInfoNodeCustomConnection;
  /** Get list of documents by Folder ID */
  get_documents_by_folder_id: DocumentInfoNodeCustomConnection;
  /** Get a documents by list of IDs */
  get_documents_by_ids?: Maybe<Array<DocumentInfoNode>>;
  /** Return dynamic menu by user */
  get_dynamic_menu: Array<MenuTypeNode>;
  /** Gets en user documents information */
  get_end_user_documents: DocumentEndUserInfoNodeCustomConnection;
  /** Imports made */
  get_error_imports_excel: ImportErrorsNodeCustomConnection;
  /** Imports made */
  get_excel_imports: UserImportsNodeCustomConnection;
  /** Gets Template for User upload (massive) */
  get_excel_template: CheckExcelTemplateUserResponse;
  /** Valida si los custom fields se están usando en diferentes features de la plataforma */
  get_features_by_custom_fields: FeatureValidateResponseCustomConnectionValidationErrorResponseInternalErrorResponse;
  /** Get a folder by ID */
  get_folder_by_id?: Maybe<FolderInfoNode>;
  /** Get folder category */
  get_folder_category: FolderInfoCategoryNodeCustomConnection;
  /** Get folder metrics */
  get_folder_metrics?: Maybe<FolderMetricsInfoNode>;
  /** Gets folders information */
  get_folders: FolderInfoNodeCustomConnection;
  get_free_trial?: Maybe<FreeTrial>;
  /** Return a list of User's related to a Headquarter */
  get_headquarter_users: CentralizedUserNodeCustomConnection;
  /** Key Position labels list. */
  get_key_positions_by_organization: OrganizationPositionKeyPositionQueryResponse;
  get_learning_general_report: ReportGeneralConnectionQueryValidationErrorQueryInternalError;
  get_learning_general_report_v2: ReportGeneralConnectionQueryValidationErrorQueryInternalError;
  get_learning_performance_report: PerformanceReportConnectionQueryInternalError;
  get_organization_authencation_methods: Array<OrganizationAuthenticationMethodPayload>;
  /** Retrieves organization id based on learning organization slug */
  get_organization_by_learning_slug?: Maybe<CentralizedOrganizationNode>;
  /** Get CEO of a centralized organization */
  get_organization_ceo?: Maybe<CeoInfoNode>;
  /** Get organizational chart information */
  get_organization_chart?: Maybe<OrganizationChartUserResponse>;
  /** Get organizational chart configuration */
  get_organization_chart_config?: Maybe<OrganizationChartConfigResponse>;
  /** Get organizational chart summary */
  get_organization_chart_summary?: Maybe<OrganizationChartUserSummaryResponse>;
  /** Gets Organization if organization from enterprise exists */
  get_organization_enterprise?: Maybe<CentralizedOrganizationNode>;
  /** Get organization enterprise by external UUID */
  get_organization_enterprise_by_external_id?: Maybe<OrganizationEnterpriseExternalNode>;
  /** Get organization headquarter status */
  get_organization_headquarter_status: OrganizationHeadquarterStatusNode;
  /** Obtain users using Organization ID filtered by state */
  get_organization_inactive_users: CentralizedUserOrganizationNodeCustomConnectionValidationErrorResponse;
  /** Get Organization Positions by slug, code or search term. Returns a list of OrganizationPositionNode objects. */
  get_organization_positions: Array<OrganizationPositionNode>;
  /** Obtain a user list with or without filters using Organization ID */
  get_organization_users: CentralizedUserOrganizationNodeCustomConnection;
  get_organizations_from_corporation?: Maybe<CorporateOrganizationsPayload>;
  /** Return a permission group with all its associated data */
  get_permission_group_detailed?: Maybe<PermissionGroupDetailedResponse>;
  /** Return a permission group with all its associated data for an specific user */
  get_permission_group_user_detailed?: Maybe<PermissionGroupUserDetailedResponse>;
  /** Return a list of group permissions based on the organization and permission group name */
  get_permission_groups: PermissionGroupCustomConnection;
  /** Return a list of permissions based on the enterprise */
  get_permissions: Array<PlatformModule>;
  /** Return a list of active permissions by user */
  get_permissions_by_user: Array<Permission>;
  /** Full candidate pipeline: keyword matching + indicator filtering + scoring (STEP 3). */
  get_position_candidates: GetPositionCandidatesResponse;
  /** Get a position detail by ID within an organization. */
  get_position_detail_by_organization: OrganizationPositionDetailResponse;
  /** List families by organization ID */
  get_position_families_by_organization: OrganizationPositionFamilyQueryResponse;
  /** List families for a select (without pagination), with optional search by name. */
  get_position_families_select_by_organization: OrganizationPositionFamilySelectResponse;
  /** List position levels by organization (search, order, cursor pagination). */
  get_position_levels_by_organization: OrganizationPositionLevelQueryResponse;
  /** List ALL position levels by organization for select (optional search by name, no pagination). */
  get_position_levels_select_by_organization: OrganizationPositionLevelSelectQueryResponse;
  /** List positions for table view (code, name, family, users_count) with search, filters, ordering and cursor pagination. */
  get_positions_by_organization: OrganizationPositionTableResponse;
  get_public_user_organization_auth: PublicCorporationUserOrganizationAuthPayload;
  /** Get Recover Password Link for User */
  get_recover_password_link: CentralizedUserRecoverPasswordNode;
  get_shared_files: GetSharedFilesQuery;
  /** Return a list of Organization Team header */
  get_team_header: OrganizationGroupTeamHeaderNode;
  /** Return Team members */
  get_team_members: OrganizationTeamUserNodeCustomConnection;
  /** Return Team members by supervisor */
  get_team_members_by_supervisor: OrganizationTeamUserNodeCustomConnection;
  /** Return a list of Organization Teams */
  get_teams: OrganizationGroupTeamNodeCustomConnection;
  /** Return a list of Organization Teams by Member team */
  get_teams_by_member: OrganizationGroupTeamNodeCustomConnection;
  /** Return a list of Organization Teams by User */
  get_teams_by_user: OrganizationGroupTeamNodeCustomConnection;
  /** Get the full detail of a document template, by template_id (stable across renames, HRIS-3941) or by name. */
  get_template_document_detail?: Maybe<HrisCorporateDocumentsDocumentTemplateDetail>;
  /** Get assigned users and download detail for a document template */
  get_template_document_users_detail: TemplateDocumentUserDetailNodeCustomConnection;
  /**
   * This query returns an active instance of the user.
   * @deprecated Use users.get_learning_users instead
   */
  get_user?: Maybe<User>;
  /** Get centralized user information */
  get_user_info?: Maybe<CentralizedUserInfoNode>;
  /** Gets first user_org if user is not deleted */
  get_user_organization?: Maybe<CentralizedUserOrganizationNode>;
  get_user_organization_auth: Array<UserOrganizationAuth>;
  get_user_organization_from_talent_email: CrehanaUserData;
  /** Get user progress by Document ID */
  get_user_progress_by_document_id: UserDocumentInfoNodeCustomConnection;
  get_user_quizzes_report: ReportQuizzesConnectionQueryValidationErrorQueryInternalError;
  /**
   * This query shows all active users
   * @deprecated Use users.get_learning_users instead
   */
  get_users: Array<User>;
  /** [New] Get and Search Users in a Organization with filters */
  get_users_organization: CentralizedUserOrganizationNodeCustomConnection;
  /** Query organization global progress */
  global_progress_organization?: Maybe<GeneralProgress>;
  health: Scalars['String']['output'];
  /** Trivial healthcheck query for the contract subgraph. */
  healthcheck: Scalars['String']['output'];
  hris: HrisQueries;
  /** Get Industries with name filter optional */
  industries?: Maybe<Array<OrganizationIndustryNode>>;
  intercom: IntercomQueries;
  /** Namespace for internal comms-related queries. */
  internal_comms: InternalCommsQueries;
  /** Knowledge Hub Queries Namespace */
  knowledge_hub: KnowledgeHubQuery;
  /** Knowledge Hub Admin Queries Namespace */
  knowledge_hub_admin: KnowledgeHubAdminQuery;
  /** KnowledgeHub v2 queries for the admin role */
  knowledge_hub_admin_v2: KnowledgeHubV2AdminQuery;
  /** This query is used to get all content for catalog page */
  knowledge_hub_catalog: Array<KnowledgeHubNode>;
  /** Knowledge Hub Category Queries Namespace */
  knowledge_hub_category: KnowledgeHubCategoryQuery;
  /** KnowledgeHub v2 queries for the collaborator role */
  knowledge_hub_collaborator_v2: KnowledgeHubV2CollaboratorQuery;
  /** Knowledge Hub Config Queries Namespace */
  knowledge_hub_config: KnowledgeHubConfigQuery;
  knowledge_hub_content_by_category: KnowledgeHubContentConnection;
  knowledge_hub_content_by_collaborator?: Maybe<KnowledgeHubContentConnection>;
  knowledge_hub_content_by_course: KnowledgeHubContentNode;
  knowledge_hub_content_by_courses: KnowledgeHubContentConnection;
  knowledge_hub_content_detail: KnowledgeHubContentDetailNode;
  knowledge_hub_filters: KnowledgeHubFiltersNode;
  knowledge_hub_search: KnowledgeHubContentConnection;
  leader_metrics: LeaderMetricsQuery;
  /** Leaderboard Panel */
  leaderboard_panel?: Maybe<LeaderboardNode>;
  /** Namespace for legal-entity-related queries. */
  legal_entities: LegalEntitiesQueries;
  licensing: OrganizationLicensingQueries;
  /** Type of all resources [Queries] of the Livesession app */
  live_session: LiveSessionQuery;
  locale: LocaleQuery;
  marketplace?: Maybe<MarketplaceConfigNode>;
  marketplace_clients_report_progress: MarketplaceClientsReportProgress;
  marketplace_courses: ProductDetailConnection;
  /** Get data from the last invoice of the user */
  marketplace_invoice_data?: Maybe<InvoiceDataQueryNode>;
  marketplace_user_products: MarketplaceUserProductNodeConnection;
  /** Finds similar positions by keywords in the description (STEP 1). */
  match_keywords_by_position: MatchKeywordsResponse;
  /** Gets current authenticated user */
  me?: Maybe<CentralizedUserOrganizationNode>;
  /** Mentor queries for the admin role */
  mentor_admin: MentorAdminQuery;
  /** Namespace for notification hub queries. */
  notification_hub: NotificationHubQueries;
  /** List of notifications */
  notifications: NotificationConnection;
  /** List of [Queries] related to the notifications center product. */
  notifications_center: NotificationsCenterQueries;
  openai_conversation: OpenAiConversationQuery;
  organization?: Maybe<OrganizationMarketplaceNode>;
  /** Query for show organization activity per day */
  organization_activity_per_day: Array<OrganizationActivityPerDay>;
  /** Query for show organization activity per hour */
  organization_activity_per_hour: Array<OrganizationActivityPerHour>;
  /** Get Organization Area Detail */
  organization_area_detail?: Maybe<OrganizationDetailAreaNode>;
  /** Get Organization Area Levels */
  organization_area_levels?: Maybe<Array<OrganizationAreaLevelNode>>;
  /** Get Organization Areas */
  organization_areas: OrganizationQueryAreaNodeCustomConnection;
  /** Get all Organization Areas */
  organization_areas_all: OrganizationAreaAllNodeCustomConnection;
  /** Admin-only paginated, filterable, searchable, sortable list of an organization's certificates (HU-8). */
  organization_certificates?: Maybe<OrganizationCertificatesConnection>;
  /** Query for show organization comparative periods */
  organization_comparative_periods: ComparativePeriods;
  /** Query for show organization general activity */
  organization_general_activity: OrganizationReproduction;
  /** Fetch a specific Organization Headquarter with expanded details. https://crehana.atlassian.net/wiki/x/A4DUEg */
  organization_headquarter?: Maybe<OrganizationDetailHeadquarterNode>;
  /** Fetch multiple Organization Headquarters with expanded details. https://crehana.atlassian.net/wiki/x/BIDcEg */
  organization_headquarters: OrganizationQueryHeadquarterNodeCustomConnection;
  /** Query for show organization historical activity */
  organization_historical_activity: Array<OrganizationHistoricalActivity>;
  /** Nombres custom guardados del menú por organización y panel. Lo consume graphql-users por graph para hacer overlay de labels en el sidebar (CORE-1606). Solo lectura, sin gate de Super Admin. */
  organization_menu_customizations: Array<OrganizationMenuCustomizationNode>;
  /** Query for show organization monthly activity */
  organization_monthly_activity: Array<ActivityPerMonth>;
  /** Get Organization Platform Modules */
  organization_platform_modules?: Maybe<Array<PlatformModuleNode>>;
  /** Check whether an organization meets the minimum configuration required to start creating users (e.g. enabling the massive user upload flow). */
  organization_readiness: OrganizationReadinessNode;
  organization_settings: OrganizationSettingsQueries;
  organization_team?: Maybe<MarketplaceOrganizationTeamNode>;
  organization_team_course_dependencies: Array<OrganizationTeamCourseDependencieNode>;
  /** List of organization's transactions */
  organization_transactions: OrganizationTransactionsConnection;
  /** Get Payment Gateways by org */
  payment_gateways: Array<PaymentGatewayOrgNode>;
  /** Get Payment Gateways by organization */
  payment_gateways_by_org: Array<PaymentGatewayOrgV2Node>;
  /** Get user's payment order */
  payment_order?: Maybe<Order>;
  /** List user's payment orders */
  payment_orders: OrderConnection;
  payroll: PayrollQuery;
  product?: Maybe<Product>;
  /** Get product categories for marketplace teams */
  product_categories: Array<ProductCategory>;
  products: ProductConnection;
  /** Basic information organization */
  public_centralized_organization?: Maybe<CentralizedOrganizationPublicNode>;
  quiz_metrics: QuizMetricsQuery;
  /** Creates an object for the model Quizzes */
  quizzes: QuizMainQueries;
  quizzes_studio: QuizzesStudioQuery;
  /** Type of all resources [Queries] of the Reports app */
  reports: ReportQueryV2;
  /** List of rewards */
  reward_list: RewardConnection;
  /** List of rewards */
  reward_redemptions_allowed?: Maybe<RedemptionAllowedNode>;
  /** List of reward transactions */
  reward_transactions_list: RewardTransactionConnection;
  routes_metrics: RoutesMetricsQuery;
  scorm: ScormQuery;
  /** Search location suggestions for autocomplete */
  search_locations: CompassMapsSearchLocationsResult;
  security: SecurityQuery;
  security_policies: SecurityPoliciesNamespaceQuery;
  /** Return the confirmed successors (status=SELECTED) for a given position. Results are ordered by selected_at ascending (oldest selection first). */
  selected_candidates: SelectedCandidatesResponse;
  social_hub: SocialHubQueries;
  /** Get succession coverage dashboard aggregated metrics */
  succession_coverage_dashboard: SuccessionCoverageDashboardResponse;
  /** List positions with their succession coverage status */
  succession_coverage_list: SuccessionCoverageListResponse;
  /** Talent Queries Namespace */
  talent: TalentQuery;
  talent_competences?: Maybe<TalentCompetencesQueries>;
  talent_feedback?: Maybe<TalentFeedbackQueries>;
  talent_recognition?: Maybe<TalentRecognitionQuery>;
  talent_reports?: Maybe<TalentReportsQuery>;
  /** Get talent user information */
  talent_user?: Maybe<TalentUserInfo>;
  /** Gets user modules */
  talent_user_modules?: Maybe<TalentUserInfo>;
  test: Scalars['String']['output'];
  thumbnail?: Maybe<Thumbnail>;
  thumbnails: Array<Thumbnail>;
  /** Namespace for Time-related queries. */
  time: TimeQueries;
  timeoff: TimeoffQueries;
  user_course_dependencies: Array<UserCourseTeamDependenceNode>;
  /** List of event or currency Achievement of an user */
  user_event_achievement_list?: Maybe<UserCurrencyEventConnection>;
  user_metrics: UserMetricsQuery;
  /** List of user notifications */
  user_notifications: UserNotificationConnection;
  user_profile: UserProfileQueries;
  /** List of user's transactions */
  user_reward_transactions: OrganizationTransactionsConnection;
  /** General list of users by organization */
  user_summary: UserSummaryConnection;
  /** Detailed summary by user of an organization */
  user_summary_detail?: Maybe<UserSummaryNode>;
  /** List of unseen reached event or currency Achievement of an user */
  user_unseen_reached_event_achievement_list?: Maybe<CurrencyEventConnection>;
  users: UsersQuery;
  users_audit_log: AuditLogQueries;
  /** Get users organization for your company identifiers */
  users_in_organization_from_ids: CentralizedUserOrganizationNodeCustomConnection;
  /** Query users inactivity summary */
  users_inactivity_summary: UsersInactivitySummaryResponse;
  /** Query users pending tasks */
  users_pending_task_list: UserPendingDetailConnection;
  validate_duplicate_team: OrganizationTeamDuplicate;
  /** Validates user activation key */
  validate_recovery_hash: UserUpdateResponse;
  video: VideoQuery;
  video_lecture?: Maybe<CourseVideo>;
  video_lecture_options: VideoLectureOptions;
  video_process?: Maybe<VideoProcess>;
  video_progress?: Maybe<Array<CourseVideo>>;
  videos_media_convert: VideosMediaConvertQuery;
  videos_processes_info?: Maybe<CourseVideoProcessesInfo>;
  workflow: WorkFlowQueries;
  /** Namespace for Workflows-related queries. */
  workflows: WorkflowsQueries;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryAccess_TokenArgs = {
  api_key?: InputMaybe<Scalars['String']['input']>;
  secret_access?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryAssign_Organization_Team_User_HistoryArgs = {
  action?: InputMaybe<ActionType>;
  organization_id: Scalars['Int']['input'];
  organization_team_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryAssign_Organization_User_FileArgs = {
  input: AssignOrganizationUserFileQueryInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryB2b_UsersArgs = {
  filter_by?: InputMaybe<SingleUserFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryB2b_Users_CounterArgs = {
  filter_by: UserWithCounterFilterInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCatalog_CategoryArgs = {
  category_id?: InputMaybe<Scalars['ID']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCentralized_Custom_Field_By_IdArgs = {
  custom_field_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCentralized_OrganizationArgs = {
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCertificateArgs = {
  course_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCertificate_Course_RulesArgs = {
  course_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCertificatesArgs = {
  custom_field_filters?: InputMaybe<Array<CustomFieldFilterInput>>;
  organization_id: Scalars['ID']['input'];
  period_date?: InputMaybe<PeriodDate>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCheck_Position_UsageArgs = {
  input: CheckPositionUsageInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryClass_NotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  course_id: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  video_lecture_id?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryConsult_Datafast_TransactionArgs = {
  gateway_org_id?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['Int']['input'];
  transaction_id: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryConvert_Document_Template_From_DocxArgs = {
  input: ConvertDocumentTemplateFromDocxInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCountryArgs = {
  country_code: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCourse_Dependencies_StatusArgs = {
  organization_team_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCourse_Dependencies_Status_In_TrackArgs = {
  organization_team_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCourse_ModulesArgs = {
  course_id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCourse_Ranking_By_OrgArgs = {
  custom_field_filters?: InputMaybe<Array<CustomFieldFilterInput>>;
  organization_id: Scalars['Int']['input'];
  period_date?: InputMaybe<PeriodDate>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCourse_Video_HighlightsArgs = {
  prompt_version_key?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  video_lecture_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCourse_Video_TranscriptArgs = {
  transcribe_language?: InputMaybe<VideoLanguageEnum>;
  video_lecture_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCourse_Video_TranscriptsArgs = {
  course_id?: InputMaybe<Scalars['ID']['input']>;
  transcribe_language?: InputMaybe<VideoLanguageEnum>;
  video_lecture_id?: InputMaybe<Scalars['ID']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCourse_VideosArgs = {
  course_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCurrency_Event_Or_Achievement_DetailArgs = {
  event_achievement_id: Scalars['ID']['input'];
  event_type?: InputMaybe<EventTypeEnum>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCurrency_Event_Or_Achievement_ListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  event_subject?: InputMaybe<EventSubjectEnum>;
  event_type?: InputMaybe<EventTypeEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CurrencyEventOrderByInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCurrency_Point_DetailArgs = {
  admin_panel?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CurrencyPointStatusEnum>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCurrency_Point_ListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CurrencyPointOrderByInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CurrencyPointStatusEnum>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCustom_Field_By_IdArgs = {
  field_id: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCustom_Field_Performance_SummaryArgs = {
  attribute_id: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCustom_FieldsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  organization_slug: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCustom_Fields_By_OrgArgs = {
  org_id: Scalars['Int']['input'];
  search_key?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCustom_Fields_Filter_Groups_By_Org_UserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter_type?: InputMaybe<DashboardFilterEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  org_id: Scalars['Int']['input'];
  search_key?: InputMaybe<Scalars['String']['input']>;
  user_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryCustom_Fields_V2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_slug: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryDasboardArgs = {
  organization_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryEpayco_Pse_BanksArgs = {
  gateway_org_id: Scalars['Int']['input'];
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryExcel_ImportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: ExcelImportsInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryFeature_FlagArgs = {
  name_key: Scalars['String']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGenerate_RecommendationsArgs = {
  input: GenerateRecommendationsInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGenerate_Template_Document_PreviewArgs = {
  input: GenerateTemplateDocumentPreviewInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Active_ModulesArgs = {
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Admin_By_OrganizationArgs = {
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Affected_Users_By_ConditionalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  conditionals: Array<GenericConditionalInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_All_Organization_Enterprise_IdsArgs = {
  enterprise_slug: Scalars['String']['input'];
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Allowed_ModulesArgs = {
  email: Scalars['String']['input'];
  organization_slug?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Api_ClientArgs = {
  api_key: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Attendance_Daily_Management_ReportArgs = {
  input: GetAttendanceDailyManagementReportInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Attendance_Marks_ReportArgs = {
  input: GetAttendanceMarksReportInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Attendance_Shifts_ReportArgs = {
  input: GetAttendanceShiftsReportInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Attendance_Shifts_Schedule_ReportArgs = {
  input: GetAttendanceShiftsScheduleReportInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Bin_List_EbanxArgs = {
  country: Scalars['String']['input'];
  gateway_org_id?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Centralized_HeadquartersArgs = {
  input: GetCentralizedHeadquartersInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Centralized_OrganizationArgs = {
  input: CentralizedOrganizationTenantInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Centralized_Organization_LicencesArgs = {
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Centralized_Organization_PositionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Centralized_Organization_Position_CategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Centralized_User_From_TalentArgs = {
  input: GetCentralizedUserFromTalent;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Centralized_User_IdsArgs = {
  input: GetCentralizedUserIdsInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Competences_Results_ReportArgs = {
  input: GetCompetencesResultsReportInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Coporation_User_Organization_AuthArgs = {
  method?: InputMaybe<AuthenticationMethodEnum>;
  next_url?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['ID']['input'];
  username: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_CourseArgs = {
  id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Course_RetriesArgs = {
  course_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Course_Validation_QuizArgs = {
  course_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_CoursesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  classroom_courses?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  search_key?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Criticalities_By_OrganizationArgs = {
  input: PositionCriticalitySelectInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Current_User_OrganizationArgs = {
  organization_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Custom_Field_UsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  custom_field_id: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organization_slug: Scalars['String']['input'];
  search_by_user_name?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Document_By_IdArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  document_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Document_Signature_ReportArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  user_document_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Document_Wildcards_CatalogArgs = {
  category?: InputMaybe<DocumentWildcardCategory>;
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_DocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  filter_by_document_file_type?: InputMaybe<Array<DocumentFileTypeEnum>>;
  filter_by_user_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<DocumentManagementFilterByEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Documents_By_Folder_IdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  filter_by_document_file_type?: InputMaybe<Array<DocumentFileTypeEnum>>;
  filter_by_user_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder_id: Scalars['Int']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<DocumentManagementFilterByEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Documents_By_IdsArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  document_ids: Array<Scalars['Int']['input']>;
  filter_by_document_file_type?: InputMaybe<Array<DocumentFileTypeEnum>>;
  folder_id?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Dynamic_MenuArgs = {
  email: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_End_User_DocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  document_id?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folder_id?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<DocumentManagementFilterByEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Error_Imports_ExcelArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excel_import_id: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Excel_ImportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excel_import_id?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Excel_TemplateArgs = {
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Features_By_Custom_FieldsArgs = {
  input: GetSegmentsByConditionalsInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Folder_By_IdArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  feature_type?: InputMaybe<FeatureTypeEnum>;
  folder_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Folder_CategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  folder_id?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Folder_MetricsArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  folder_id?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_FoldersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  feature_type?: InputMaybe<FeatureTypeEnum>;
  filter_by_visualization_type?: InputMaybe<FolderVisualizationTypeEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<DocumentManagementFilterByEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Free_TrialArgs = {
  organization_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Headquarter_UsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  headquarter_id: Scalars['Int']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  organization_slug: Scalars['String']['input'];
  search_by_user_name?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Key_Positions_By_OrganizationArgs = {
  input: PositionKeyPositionSelectInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Learning_General_ReportArgs = {
  input: GetGeneralReportInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Learning_General_Report_V2Args = {
  input: GetGeneralReportInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Learning_Performance_ReportArgs = {
  input: GetPerformanceReportInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Organization_Authencation_MethodsArgs = {
  next_url: Scalars['String']['input'];
  organization_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Organization_By_Learning_SlugArgs = {
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Organization_CeoArgs = {
  centralized_organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Organization_ChartArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  centralized_user_id?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<OrganizationChartUserFilterByInput>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Organization_Chart_ConfigArgs = {
  centralized_organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Organization_Chart_SummaryArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  centralized_user_id?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Organization_EnterpriseArgs = {
  enterprise_slug: Scalars['String']['input'];
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Organization_Enterprise_By_External_IdArgs = {
  external_id: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Organization_Headquarter_StatusArgs = {
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Organization_Inactive_UsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scalars['String']['input']>>;
  organization_id: Scalars['Int']['input'];
  organization_slug?: InputMaybe<Scalars['String']['input']>;
  personalized_filters?: InputMaybe<Array<UserOrganizationPersonalizedFilter>>;
  state_list?: InputMaybe<Array<InputMaybe<UserOrganizationStatusInput>>>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Organization_PositionsArgs = {
  input: GetOrganizationPositionsInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Organization_UsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  area_id?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  enterprise?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invitation_sent?: InputMaybe<Scalars['Boolean']['input']>;
  invitation_sent_list?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scalars['String']['input']>>;
  organization_id: Scalars['Int']['input'];
  organization_slug?: InputMaybe<Scalars['String']['input']>;
  personalized_filters?: InputMaybe<Array<UserOrganizationPersonalizedFilter>>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_list?: InputMaybe<Array<InputMaybe<UserOrganizationStatusInput>>>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Organizations_From_CorporationArgs = {
  parent_organization_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Permission_Group_DetailedArgs = {
  organization_slug: Scalars['String']['input'];
  permission_group_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Permission_Group_User_DetailedArgs = {
  organization_slug: Scalars['String']['input'];
  user_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Permission_GroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_slug: Scalars['String']['input'];
  user_role?: InputMaybe<PermissionUserOrganizationRole>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_PermissionsArgs = {
  enterprise?: InputMaybe<Scalars['String']['input']>;
  user_role?: InputMaybe<PermissionUserOrganizationRole>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Permissions_By_UserArgs = {
  input: GetPermissionsByUserInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Position_CandidatesArgs = {
  input: GetPositionCandidatesInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Position_Detail_By_OrganizationArgs = {
  input: PositionDetailInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Position_Families_By_OrganizationArgs = {
  input: PositionFamilyListInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Position_Families_Select_By_OrganizationArgs = {
  input: PositionFamilySelectInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Position_Levels_By_OrganizationArgs = {
  input: PositionLevelListInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Position_Levels_Select_By_OrganizationArgs = {
  input: PositionLevelSelectInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Positions_By_OrganizationArgs = {
  input: PositionTableListInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Public_User_Organization_AuthArgs = {
  input: GetPublicUserOrganizationAuthInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Recover_Password_LinkArgs = {
  input: CentralizedUserRecoverPasswordInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Team_HeaderArgs = {
  organization_team_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Team_MembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RetrieveTeamMembersInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Team_Members_By_SupervisorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RetrieveTeamMembersInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_TeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RetrieveOrganizationTeamsInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Teams_By_MemberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RetrieveOrganizationTeamsByMemberInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Teams_By_UserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RetrieveOrganizationTeamsByMemberInput;
  last?: InputMaybe<Scalars['Int']['input']>;
  user_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Template_Document_DetailArgs = {
  input: GetTemplateDocumentDetailInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Template_Document_Users_DetailArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  document_id: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by_assigned_date?: InputMaybe<DocumentManagementOrderByEnum>;
  order_by_fullname?: InputMaybe<DocumentManagementOrderByEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_UserArgs = {
  username?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_User_InfoArgs = {
  centralized_organization_id: Scalars['Int']['input'];
  centralized_user_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_User_OrganizationArgs = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  user_email: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_User_Organization_AuthArgs = {
  next_url?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_User_Organization_From_Talent_EmailArgs = {
  user_email: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_User_Progress_By_Document_IdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  document_id: Scalars['Int']['input'];
  filter_by_document_status?: InputMaybe<Array<DocumentFileStateEnum>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by_assigned_date?: InputMaybe<DocumentManagementOrderByEnum>;
  order_by_deadline?: InputMaybe<DocumentManagementOrderByEnum>;
  order_by_fullname?: InputMaybe<DocumentManagementOrderByEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_User_Quizzes_ReportArgs = {
  input: GetUserQuizzesReportInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_UsersArgs = {
  filter_set?: InputMaybe<Array<UserFilterInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGet_Users_OrganizationArgs = {
  input: GetUsersOrganizationInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryGlobal_Progress_OrganizationArgs = {
  custom_field_filters?: InputMaybe<Array<CustomFieldFilterInput>>;
  organization_id: Scalars['Int']['input'];
  period_date?: InputMaybe<PeriodDate>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryIndustriesArgs = {
  name_filter?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryKnowledge_Hub_CatalogArgs = {
  content_type?: InputMaybe<ContentType>;
  languages?: InputMaybe<Array<ContentLanguages>>;
  level_id?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
  parent_slug?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryKnowledge_Hub_Content_By_CategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category_id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryKnowledge_Hub_Content_By_CollaboratorArgs = {
  input: KnowledgehubContentByCollaboratorInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryKnowledge_Hub_Content_By_CourseArgs = {
  course_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryKnowledge_Hub_Content_By_CoursesArgs = {
  course_ids: Array<Scalars['ID']['input']>;
  organization_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryKnowledge_Hub_Content_DetailArgs = {
  content_id?: InputMaybe<Scalars['Int']['input']>;
  content_slug?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryKnowledge_Hub_FiltersArgs = {
  main_category_slug: Scalars['String']['input'];
  organization_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryKnowledge_Hub_SearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['ID']['input'];
  search_input: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryLeaderboard_PanelArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryMarketplaceArgs = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryMarketplace_Clients_Report_ProgressArgs = {
  organization_slug: Scalars['String']['input'];
  report_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryMarketplace_CoursesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['Int']['input'];
  product_id?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryMarketplace_Invoice_DataArgs = {
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryMarketplace_User_ProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<MarketplaceUserOrderByFieldInput>>>;
  organization_id: Scalars['Int']['input'];
  search_key?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryMatch_Keywords_By_PositionArgs = {
  input: MatchKeywordsByPositionInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganizationArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_Activity_Per_DayArgs = {
  custom_field_filters?: InputMaybe<Array<CustomFieldFilterInput>>;
  organization_id: Scalars['ID']['input'];
  period_date?: InputMaybe<PeriodDate>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_Activity_Per_HourArgs = {
  custom_field_filters?: InputMaybe<Array<CustomFieldFilterInput>>;
  organization_id: Scalars['ID']['input'];
  period_date?: InputMaybe<PeriodDate>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_Area_DetailArgs = {
  organization_area_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_Area_LevelsArgs = {
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_AreasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_by?: InputMaybe<OrganizationAreaFilterBy>;
  organization_slug: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_Areas_AllArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  level_sequence?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_CertificatesArgs = {
  direction?: CertificateOrderDirection;
  filter?: InputMaybe<OrganizationCertificatesFilter>;
  order_by?: OrganizationCertificatesOrderField;
  organization_id: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  page_size?: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_Comparative_PeriodsArgs = {
  custom_field_filters?: InputMaybe<Array<CustomFieldFilterInput>>;
  organization_id: Scalars['ID']['input'];
  period: PeriodEnum;
  period_date?: InputMaybe<PeriodDate>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_General_ActivityArgs = {
  custom_field_filters?: InputMaybe<Array<CustomFieldFilterInput>>;
  organization_id: Scalars['ID']['input'];
  period_date?: InputMaybe<PeriodDate>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_HeadquarterArgs = {
  headquarter_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_HeadquartersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_by?: InputMaybe<OrganizationHeadquarterFilterBy>;
  organization_slug: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  show_all_headquarters?: InputMaybe<Scalars['Boolean']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_Historical_ActivityArgs = {
  custom_field_filters?: InputMaybe<Array<CustomFieldFilterInput>>;
  organization_id: Scalars['ID']['input'];
  period_date?: InputMaybe<PeriodDate>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_Menu_CustomizationsArgs = {
  organization_id: Scalars['Int']['input'];
  panel: MenuPanelType;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_Monthly_ActivityArgs = {
  answers?: InputMaybe<Scalars['String']['input']>;
  attribute?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  organization_id: Scalars['ID']['input'];
  start_date?: InputMaybe<Scalars['Date']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_Platform_ModulesArgs = {
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_ReadinessArgs = {
  organization_slug: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_TeamArgs = {
  organization_team_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_Team_Course_DependenciesArgs = {
  organization_team_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryOrganization_TransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organization_slug?: InputMaybe<Scalars['String']['input']>;
  transaction_status_enum?: InputMaybe<TransactionStatusEnum>;
  transaction_type_enum?: InputMaybe<TransactionTypeEnum>;
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryPayment_GatewaysArgs = {
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryPayment_Gateways_By_OrgArgs = {
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryPayment_OrderArgs = {
  id: Scalars['Int']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryPayment_OrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['Int']['input'];
  search_key?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryProductArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  is_draft?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  product_slug?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryProduct_CategoriesArgs = {
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  is_draft?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InputMaybe<ProductOrderByFieldInput>>>;
  organization_id: Scalars['Int']['input'];
  search_key?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryPublic_Centralized_OrganizationArgs = {
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryReward_ListArgs = {
  admin_panel?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organization_slug?: InputMaybe<Scalars['String']['input']>;
  reward_name?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryReward_Redemptions_AllowedArgs = {
  query_variables: RewardRedemptionAllowedInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryReward_Transactions_ListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  created_after?: InputMaybe<Scalars['DateTime']['input']>;
  created_before?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reward_id: Scalars['ID']['input'];
  transaction_id?: InputMaybe<Scalars['ID']['input']>;
  transaction_status_enum?: InputMaybe<TransactionStatusEnum>;
  transaction_type_enum?: InputMaybe<TransactionTypeEnum>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QuerySearch_LocationsArgs = {
  input: CompassMapsSearchLocationsInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QuerySelected_CandidatesArgs = {
  input: SelectedCandidatesInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QuerySuccession_Coverage_DashboardArgs = {
  input: SuccessionCoverageDashboardInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QuerySuccession_Coverage_ListArgs = {
  input: SuccessionCoverageListInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryTalent_UserArgs = {
  email: Scalars['String']['input'];
  organization_slug?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryTalent_User_ModulesArgs = {
  company_id: Scalars['Int']['input'];
  email: Scalars['String']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryThumbnailArgs = {
  id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryThumbnailsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  video_lecture_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryUser_Course_DependenciesArgs = {
  course_id?: InputMaybe<Scalars['Int']['input']>;
  course_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  organization_id: Scalars['ID']['input'];
  team_id?: InputMaybe<Scalars['Int']['input']>;
  user_team_id?: InputMaybe<Scalars['Int']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryUser_Event_Achievement_ListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  event_subject?: InputMaybe<EventSubjectEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CurrencyEventOrderByInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryUser_NotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  created_timestamp?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  is_readed?: InputMaybe<Scalars['Boolean']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryUser_Reward_TransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  transaction_status_enum?: InputMaybe<TransactionStatusEnum>;
  transaction_type_enum?: InputMaybe<TransactionTypeEnum>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryUser_SummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserSummaryOrderByInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryUser_Summary_DetailArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryUser_Unseen_Reached_Event_Achievement_ListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input_object_type?: InputMaybe<ObjectTypeInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CurrencyEventOrderByInput>>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryUsers_In_Organization_From_IdsArgs = {
  input: CentralizedUsersInOrganizationInput;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryUsers_Inactivity_SummaryArgs = {
  custom_field_filters?: InputMaybe<Array<CustomFieldFilterInput>>;
  organization_id: Scalars['ID']['input'];
  period_date?: InputMaybe<PeriodDate>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryUsers_Pending_Task_ListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  custom_field_filters?: InputMaybe<Array<CustomFieldFilterInput>>;
  first?: Scalars['Int']['input'];
  organization_id: Scalars['ID']['input'];
  period_date?: InputMaybe<PeriodDate>;
  search_key?: InputMaybe<Scalars['String']['input']>;
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryValidate_Duplicate_TeamArgs = {
  name: Scalars['String']['input'];
  organization_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryValidate_Recovery_HashArgs = {
  activation_key: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
  user_id: Scalars['Int']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryVideo_LectureArgs = {
  video_lecture_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryVideo_Lecture_OptionsArgs = {
  video_lecture_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryVideo_ProcessArgs = {
  video_process_uid: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryVideo_ProgressArgs = {
  course_id: Scalars['ID']['input'];
};


/**  AGRUPACIÓN DE QUERIES */
export type QueryVideos_Processes_InfoArgs = {
  category?: InputMaybe<VideoProcessCategoryEnum>;
  course_id: Scalars['ID']['input'];
};

export type QueryAllowedUserInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organization_id: Scalars['String']['input'];
};

export type QueryAssignOrganizationUserFile = AssignOrganizationUserFileNode | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type QueryCourseAuditLogInput = {
  course_id: Scalars['ID']['input'];
  filter_by?: InputMaybe<FilterCourseAuditLogInput>;
  language_key?: InputMaybe<AuditLogActionLangEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CourseAuditLogOrderByInput>>;
  organization_id: Scalars['ID']['input'];
};

export type QueryCurrencyEventInput = {
  event_type_enum?: InputMaybe<CurrencyEventTypeEnum>;
  organization_id: Scalars['String']['input'];
  original_id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCurrencyPointInput = {
  organization_id: Scalars['String']['input'];
  original_id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryInternalError = {
  __typename?: 'QueryInternalError';
  errors: Array<Scalars['String']['output']>;
  operation_id: Scalars['String']['output'];
};

export type QueryInternalServerError = {
  __typename?: 'QueryInternalServerError';
  errors: Array<Scalars['String']['output']>;
  operation_id: Scalars['String']['output'];
};

export type QueryLeaderboardBoxInput = {
  organization_id: Scalars['ID']['input'];
};

export type QueryRewardInput = {
  organization_id: Scalars['String']['input'];
  original_id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUserPolicyBalanceLog = {
  /** Is Active */
  is_active: Scalars['Boolean']['input'];
  /** Policy ID */
  policy_id?: InputMaybe<Scalars['ID']['input']>;
  /** Reason equal */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Reason alike */
  reason_alike?: InputMaybe<Scalars['String']['input']>;
};

export type QueryValidationError = {
  __typename?: 'QueryValidationError';
  errors: Array<Scalars['String']['output']>;
  operation_id: Scalars['String']['output'];
};

export type Question = {
  __typename?: 'Question';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  original_id?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['Float']['output']>;
  suggestion?: Maybe<Scalars['String']['output']>;
};

export type QuestionAnswerType = {
  __typename?: 'QuestionAnswerType';
  answer_text?: Maybe<Scalars['String']['output']>;
  attachment_file?: Maybe<File>;
  attachment_id?: Maybe<Scalars['Int']['output']>;
  attachment_url?: Maybe<UrlNode>;
  created_by_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_automated?: Maybe<Scalars['Boolean']['output']>;
  is_correct_answer?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  updated_by_id?: Maybe<Scalars['Int']['output']>;
};

export type QuestionConnection = {
  __typename?: 'QuestionConnection';
  /** Contains the nodes in this connection */
  edges: Array<QuestionNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type QuestionForm = {
  __typename?: 'QuestionForm';
  comment?: Maybe<Scalars['String']['output']>;
  comment_auto?: Maybe<Scalars['String']['output']>;
  completed_question?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  original_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['Float']['output']>;
  response_auto?: Maybe<Scalars['Float']['output']>;
};

export type QuestionFromXlsxType = BaseQuestionI & {
  __typename?: 'QuestionFromXlsxType';
  answers?: Maybe<Array<QuestionAnswerType>>;
  attachment_id?: Maybe<Scalars['Int']['output']>;
  feedback_text?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  question_help_text?: Maybe<Scalars['String']['output']>;
  question_text?: Maybe<Scalars['String']['output']>;
  question_type?: Maybe<Scalars['String']['output']>;
  row?: Maybe<Scalars['String']['output']>;
};

/** Subgraph END USER - Question Info Category Node */
export type QuestionInfoCategoryNode = {
  __typename?: 'QuestionInfoCategoryNode';
  /** ID */
  id: Scalars['String']['output'];
  /** Question Name */
  name: Scalars['String']['output'];
  /** Question Prompt */
  prompt: Scalars['String']['output'];
};

export type QuestionMutationPayload = GraphOperationI & {
  __typename?: 'QuestionMutationPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
  quiz_question: PrivateQuizQuestionType;
};

export type QuestionNode = {
  __typename?: 'QuestionNode';
  /** List of answer associated */
  answers: AnswerConnection;
  id?: Maybe<Scalars['ID']['output']>;
  is_automated: Scalars['Boolean']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  original_id?: Maybe<Scalars['Int']['output']>;
  question_text?: Maybe<Scalars['String']['output']>;
  video_lecture_id?: Maybe<Scalars['Int']['output']>;
};

export type QuestionNodeEdge = {
  __typename?: 'QuestionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: QuestionNode;
};

export type QuestionSetType = {
  __typename?: 'QuestionSetType';
  questions: Array<QuestionType>;
  total_count: Scalars['Int']['output'];
};

export type QuestionType = {
  __typename?: 'QuestionType';
  id: Scalars['ID']['output'];
};

export enum QuestionTypeEnum {
  QuestionEvaluative = 'QUESTION_EVALUATIVE',
  QuestionMultiple = 'QUESTION_MULTIPLE',
  QuestionOpen = 'QUESTION_OPEN'
}

export type Questionnaire = {
  __typename?: 'Questionnaire';
  allow_delete?: Maybe<Scalars['Boolean']['output']>;
  employee_result?: Maybe<Scalars['Float']['output']>;
  evaluated?: Maybe<EmployeeCompetencesEvaluation>;
  group_key?: Maybe<Scalars['String']['output']>;
  grouped_questionnaires?: Maybe<Array<Maybe<Questionnaire>>>;
  id: Scalars['ID']['output'];
  original_id?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  relation?: Maybe<Scalars['String']['output']>;
  relation_enum?: Maybe<RelationQuestionnaireEnum>;
  similar_competences_key?: Maybe<Scalars['String']['output']>;
  state: QuestionnaireStateEnum;
};

export type QuestionnaireEdge = {
  __typename?: 'QuestionnaireEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Questionnaire>;
};

export type QuestionnaireEvaluators = {
  employee_id: Scalars['Int']['input'];
  evaluated_id: Scalars['Int']['input'];
  evaluation_id: Scalars['Int']['input'];
  evaluators?: InputMaybe<Array<InputMaybe<Evaluator>>>;
};

export type QuestionnaireGeneralPagination = {
  __typename?: 'QuestionnaireGeneralPagination';
  evaluation?: Maybe<CompetencesEvaluation>;
  questionnaires?: Maybe<QuestionnairePagination>;
};

export type QuestionnaireGrade = {
  __typename?: 'QuestionnaireGrade';
  behavior_id: Scalars['Int']['output'];
  employee_id: Scalars['Int']['output'];
  grade: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  original_id?: Maybe<Scalars['Int']['output']>;
};

export type QuestionnaireGradeSummary = {
  __typename?: 'QuestionnaireGradeSummary';
  questionnaire_grade_summary?: Maybe<Array<Maybe<QuestionnaireGrade>>>;
};

export type QuestionnairePagination = {
  __typename?: 'QuestionnairePagination';
  edges?: Maybe<Array<Maybe<QuestionnaireEdge>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type QuestionnaireQualify = {
  all_questionnaires?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  comment_competence?: InputMaybe<Scalars['String']['input']>;
  competence_id?: InputMaybe<Scalars['Int']['input']>;
  general_comment1?: InputMaybe<Scalars['String']['input']>;
  general_comment2?: InputMaybe<Scalars['String']['input']>;
  general_comment3?: InputMaybe<Scalars['String']['input']>;
  is_to_delete?: InputMaybe<Scalars['Boolean']['input']>;
  question_comment?: InputMaybe<Scalars['String']['input']>;
  question_id?: InputMaybe<Scalars['Int']['input']>;
  question_response?: InputMaybe<Scalars['Float']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  type: QualifyTypeEnum;
};

export enum QuestionnaireStateEnum {
  Assigned = 'ASSIGNED',
  Configure = 'CONFIGURE',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS'
}

export type QuestionnaireSummary = {
  __typename?: 'QuestionnaireSummary';
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<Scalars['Float']['output']>;
};

export type QuestionsFromXlsxPayload = GraphOperationI & {
  __typename?: 'QuestionsFromXlsxPayload';
  assertion_errors: Array<AssertionCodeType>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
  questions: Array<QuestionFromXlsxType>;
};

export type QuestionsFromXlsxResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | QuestionsFromXlsxPayload;

export type QuickEnrollInput = {
  /** Invoice data ID */
  invoice_data_id: Scalars['Int']['input'];
  /** Product ID */
  product_id: Scalars['Int']['input'];
};

export type QuickEnrollResponse = {
  __typename?: 'QuickEnrollResponse';
  order_id?: Maybe<Scalars['String']['output']>;
  redirect_url: Scalars['String']['output'];
};

export type QuickEnrollResponsePaymentErrorNode = PaymentErrorNode | QuickEnrollResponse;

/** Input for delete a live session [Mutation] */
export type QuizAddAttemptInput = {
  course_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  user_id: Scalars['ID']['input'];
};

export type QuizAddAttemptPayload = GraphOperationI & {
  __typename?: 'QuizAddAttemptPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

export type QuizAddAttemptResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | QuizAddAttemptPayload;

export enum QuizApprovalEnum {
  Approval_50Percent = 'APPROVAL_50_PERCENT',
  Approval_60Percent = 'APPROVAL_60_PERCENT',
  Approval_70Percent = 'APPROVAL_70_PERCENT',
  Approval_80Percent = 'APPROVAL_80_PERCENT',
  Approval_90Percent = 'APPROVAL_90_PERCENT',
  Approval_100Percent = 'APPROVAL_100_PERCENT'
}

export enum QuizApprovalMethodEnum {
  ApprovalMethodPercentage = 'APPROVAL_METHOD_PERCENTAGE',
  ApprovalMethodPoints = 'APPROVAL_METHOD_POINTS'
}

/** Input for delete a live session [Mutation] */
export type QuizAssignInput = {
  object_id: Scalars['ID']['input'];
  object_type: ObjectsForEnum;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_id: Scalars['ID']['input'];
};

export type QuizAssignPayload = GraphOperationI & {
  __typename?: 'QuizAssignPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
};

export type QuizAssignResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | QuizAssignPayload;

export type QuizBuilderMutation = {
  __typename?: 'QuizBuilderMutation';
  bulk_create_answers: BulkCreateAnswersResponse;
  bulk_create_questions: BulkCreateQuestionsResponse;
  create_or_update_answer: CreateOrUpdateQuizAnswerResponse;
  create_question: CreateQuestionResponse;
  create_questions_from_xlsx: QuestionsFromXlsxResponse;
  delete_quiz: DeleteQuizResponse;
  update_question: CreateQuestionResponse;
};


export type QuizBuilderMutationBulk_Create_AnswersArgs = {
  input: AnswerBulkInput;
};


export type QuizBuilderMutationBulk_Create_QuestionsArgs = {
  input: CreateBulkQuestionInput;
};


export type QuizBuilderMutationCreate_Or_Update_AnswerArgs = {
  input: CreateOrUpdateAnswerInput;
};


export type QuizBuilderMutationCreate_QuestionArgs = {
  input: CreateQuestionInput;
};


export type QuizBuilderMutationCreate_Questions_From_XlsxArgs = {
  input: CreateQuestionFromXlsxInput;
};


export type QuizBuilderMutationDelete_QuizArgs = {
  input: DeleteQuizInput;
};


export type QuizBuilderMutationUpdate_QuestionArgs = {
  input: UpdateQuestionInput;
};

/** Input for duplicate course quizzes [Mutation] */
export type QuizDuplicateCourseInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  scope: QuizDuplicationScopeEnum;
  source_course_id: Scalars['ID']['input'];
  target_course_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
  video_lecture_map: Array<VideoLectureMapInput>;
};

export type QuizDuplicateCoursePayload = GraphOperationI & {
  __typename?: 'QuizDuplicateCoursePayload';
  duplicated_quiz_ids: Array<Scalars['ID']['output']>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
  skipped: Array<QuizSkipReportType>;
};

export type QuizDuplicateCourseResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | QuizDuplicateCoursePayload;

/** It is used to define which branches get duplicated */
export enum QuizDuplicationScopeEnum {
  Both = 'BOTH',
  ClassQuizzes = 'CLASS_QUIZZES',
  FinalQuiz = 'FINAL_QUIZ'
}

export type QuizGeneratorMutationNode = {
  __typename?: 'QuizGeneratorMutationNode';
  /** Contains an instance of the QuizGenerator model */
  quiz_generator?: Maybe<QuizGeneratorNode>;
  /**
   * This object contains information about the response
   *         code, response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type QuizGeneratorNode = {
  __typename?: 'QuizGeneratorNode';
  id?: Maybe<Scalars['ID']['output']>;
  /** List of questions associated */
  questions: QuestionConnection;
  text_output?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Scalars['String']['output']>;
  video_lecture_id?: Maybe<Scalars['Int']['output']>;
};

export type QuizMainMutations = {
  __typename?: 'QuizMainMutations';
  add_attempt: QuizAddAttemptResponse;
  assign_quiz_admin: QuizAssignResponse;
  create_or_update_quiz_question_in_bulk_admin: QuizzesBulkCreateOrUpdateQuizQuestionResponse;
  create_quiz_form_by_class: UserQuizFormResponse;
  duplicate_course_quizzes: QuizDuplicateCourseResponse;
  get_or_create_user_video_lecture_quiz: GetOrCreateVideoLectureQuizResponse;
  reset_course_class_quizzes: QuizResetCourseClassQuizzesResponse;
  reset_course_quiz: QuizResetCourseEvaluationResponse;
  update_quiz_form_by_class: UserQuizFormResponse;
};


export type QuizMainMutationsAdd_AttemptArgs = {
  input: QuizAddAttemptInput;
};


export type QuizMainMutationsAssign_Quiz_AdminArgs = {
  input: QuizAssignInput;
};


export type QuizMainMutationsCreate_Or_Update_Quiz_Question_In_Bulk_AdminArgs = {
  input: BulkCreateOrUpdateQuizQuestionInput;
};


export type QuizMainMutationsCreate_Quiz_Form_By_ClassArgs = {
  input: CreateUserQuizFormInput;
};


export type QuizMainMutationsDuplicate_Course_QuizzesArgs = {
  input: QuizDuplicateCourseInput;
};


export type QuizMainMutationsGet_Or_Create_User_Video_Lecture_QuizArgs = {
  input: VideoLectureQuizInput;
};


export type QuizMainMutationsReset_Course_Class_QuizzesArgs = {
  input: QuizResetCourseClassQuizzesInput;
};


export type QuizMainMutationsReset_Course_QuizArgs = {
  input: QuizResetCourseEvaluationInput;
};


export type QuizMainMutationsUpdate_Quiz_Form_By_ClassArgs = {
  input: UpdateUserQuizFormInput;
};

export type QuizMainQueries = {
  __typename?: 'QuizMainQueries';
  get_admin_quiz?: Maybe<PrivateQuizType>;
  /** Obtiene un listado paginado de cursos con sus quizzes filtrados por porcentaje de aprobación */
  get_courses_with_quizzes: CourseWithQuizzesTypeConnectionQueryInternalError;
  get_enrollment_vide_lecture_quiz?: Maybe<VideoLectureUserQuizFormType>;
  get_quiz_by_class?: Maybe<QuizType>;
  /** Obtiene el listado paginado de quizzes por course_id con el detalle de preguntas */
  get_quizzes_by_course_id: PrivateQuizTypeConnectionQueryInternalError;
};


export type QuizMainQueriesGet_Admin_QuizArgs = {
  input: GetQuizStudioInput;
};


export type QuizMainQueriesGet_Courses_With_QuizzesArgs = {
  input: GetCoursesWithQuizzesInput;
};


export type QuizMainQueriesGet_Enrollment_Vide_Lecture_QuizArgs = {
  input: GetEnrollmentVideoLectureQuizFormInput;
};


export type QuizMainQueriesGet_Quiz_By_ClassArgs = {
  input: GetQuizByClassInput;
};


export type QuizMainQueriesGet_Quizzes_By_Course_IdArgs = {
  input: GetQuizzesByCourseIdInput;
};

export type QuizMetricsQuery = {
  __typename?: 'QuizMetricsQuery';
  quiz_sumary: QuizSumaryNode;
};


export type QuizMetricsQueryQuiz_SumaryArgs = {
  course_id: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};

export type QuizQuestionType = BaseQuestionI & {
  __typename?: 'QuizQuestionType';
  attachment_id?: Maybe<Scalars['Int']['output']>;
  feedback_text?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  question_help_text?: Maybe<Scalars['String']['output']>;
  question_text?: Maybe<Scalars['String']['output']>;
  question_type?: Maybe<Scalars['String']['output']>;
};

export enum QuizQuestionTypeEnum {
  TypeDevelopment = 'TYPE_DEVELOPMENT',
  TypeMultiple = 'TYPE_MULTIPLE',
  TypePairs = 'TYPE_PAIRS',
  TypeSimple = 'TYPE_SIMPLE',
  TypeTrueOrFalse = 'TYPE_TRUE_OR_FALSE'
}

export type QuizRequirementType = {
  __typename?: 'QuizRequirementType';
  question_set?: Maybe<QuestionSetType>;
  quiz_id: Scalars['ID']['output'];
  quiz_type: QuizTypeEnum;
};

/** Input for reset course class quizzes [Mutation] */
export type QuizResetCourseClassQuizzesInput = {
  course_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  requested_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  user_id: Scalars['ID']['input'];
};

export type QuizResetCourseClassQuizzesPayload = GraphOperationI & {
  __typename?: 'QuizResetCourseClassQuizzesPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
  reset_count: Scalars['Int']['output'];
};

export type QuizResetCourseClassQuizzesResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | QuizResetCourseClassQuizzesPayload;

/** Input for reset course evaluation [Mutation] */
export type QuizResetCourseEvaluationInput = {
  course_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  requested_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  user_id: Scalars['ID']['input'];
};

export type QuizResetCourseEvaluationPayload = GraphOperationI & {
  __typename?: 'QuizResetCourseEvaluationPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
  reset: Scalars['Boolean']['output'];
};

export type QuizResetCourseEvaluationResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | QuizResetCourseEvaluationPayload;

export enum QuizRetryLimitEnum {
  RetryLimit_1 = 'RETRY_LIMIT_1',
  RetryLimit_2 = 'RETRY_LIMIT_2',
  RetryLimit_3 = 'RETRY_LIMIT_3',
  RetryLimit_4 = 'RETRY_LIMIT_4',
  RetryLimit_5 = 'RETRY_LIMIT_5',
  RetryLimitUnlimited = 'RETRY_LIMIT_UNLIMITED'
}

export enum QuizRetryTimeEnum {
  RetryTime_60Min = 'RETRY_TIME_60_MIN',
  RetryTime_120Min = 'RETRY_TIME_120_MIN',
  RetryTime_180Min = 'RETRY_TIME_180_MIN',
  RetryTime_240Min = 'RETRY_TIME_240_MIN',
  RetryWithoutTime = 'RETRY_WITHOUT_TIME'
}

export enum QuizShowAnswerEnum {
  ShowAnswerEnd = 'SHOW_ANSWER_END',
  ShowAnswerImmediately = 'SHOW_ANSWER_IMMEDIATELY',
  ShowAnswerNotShow = 'SHOW_ANSWER_NOT_SHOW'
}

/** Why a source quiz was not duplicated onto the target course */
export enum QuizSkipReasonEnum {
  CloneFailed = 'CLONE_FAILED',
  TargetClassQuizNotDuplicated = 'TARGET_CLASS_QUIZ_NOT_DUPLICATED',
  TargetFinalQuizNotDuplicated = 'TARGET_FINAL_QUIZ_NOT_DUPLICATED',
  VideoLectureNotInMap = 'VIDEO_LECTURE_NOT_IN_MAP'
}

export type QuizSkipReportType = {
  __typename?: 'QuizSkipReportType';
  reason: QuizSkipReasonEnum;
  source_quiz_id: Scalars['ID']['output'];
};

export enum QuizStatusEnum {
  Approved = 'APPROVED',
  Certificated = 'CERTIFICATED',
  Disapproved = 'DISAPPROVED',
  InProgress = 'IN_PROGRESS',
  NotCompleted = 'NOT_COMPLETED',
  NotInitialized = 'NOT_INITIALIZED'
}

export type QuizSumaryNode = {
  __typename?: 'QuizSumaryNode';
  approved_quizzes: Scalars['Int']['output'];
  average_duration: Scalars['Int']['output'];
  completed_quizzes: Scalars['Int']['output'];
  time_limit: Scalars['String']['output'];
};

export enum QuizTimeLimitEnum {
  Time_30Min = 'TIME_30_MIN',
  Time_45Min = 'TIME_45_MIN',
  Time_60Min = 'TIME_60_MIN',
  Time_120Min = 'TIME_120_MIN',
  TimeWithout = 'TIME_WITHOUT'
}

export type QuizType = BaseQuizI & {
  __typename?: 'QuizType';
  approval_method?: Maybe<QuizApprovalMethodEnum>;
  approval_percentage?: Maybe<QuizApprovalEnum>;
  approval_points?: Maybe<Scalars['Int']['output']>;
  has_dinamic_questions?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_completed_course_required?: Maybe<Scalars['Boolean']['output']>;
  max_points?: Maybe<Scalars['Int']['output']>;
  num_question?: Maybe<Scalars['Int']['output']>;
  number_dinamic_questions?: Maybe<Scalars['Int']['output']>;
  quiz_type?: Maybe<QuizTypeEnum>;
  retry_limit?: Maybe<QuizRetryLimitEnum>;
  retry_time?: Maybe<QuizRetryTimeEnum>;
  show_answers?: Maybe<QuizShowAnswerEnum>;
  show_answers_immediately?: Maybe<Scalars['Boolean']['output']>;
  time_to_complete?: Maybe<QuizTimeLimitEnum>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum QuizTypeEnum {
  TypeCumulative = 'TYPE_CUMULATIVE',
  TypeFormative = 'TYPE_FORMATIVE'
}

export type QuizzesBulkCreateOrUpdateQuizQuestionPayload = GraphOperationI & {
  __typename?: 'QuizzesBulkCreateOrUpdateQuizQuestionPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
  questions: Array<PrivateQuizQuestionType>;
};

export type QuizzesBulkCreateOrUpdateQuizQuestionResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | QuizzesBulkCreateOrUpdateQuizQuestionPayload;

export type QuizzesStudioQuery = {
  __typename?: 'QuizzesStudioQuery';
  /** @deprecated moved to new namespace */
  get_quiz?: Maybe<PrivateQuizType>;
};


export type QuizzesStudioQueryGet_QuizArgs = {
  input: GetQuizStudioInput;
};

export enum RatingCategory {
  InappropriateContent = 'INAPPROPRIATE_CONTENT',
  IncorrectData = 'INCORRECT_DATA',
  NotFollowInstructions = 'NOT_FOLLOW_INSTRUCTIONS',
  NotLikeStyle = 'NOT_LIKE_STYLE',
  Other = 'OTHER'
}

export type ReactivateContractInput = {
  centralized_user_id: Scalars['Int']['input'];
  contract_id: Scalars['UUID']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ReactivateContractResponse = {
  __typename?: 'ReactivateContractResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmployeeContractType;
};

export type ReactivateContractResult = InternalErrorResponse | NotFoundErrorResponse | ReactivateContractResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type ReactivateDeletedUserResponse = {
  __typename?: 'ReactivateDeletedUserResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type ReactivateUserInput = {
  centralized_organization_id: Scalars['Int']['input'];
  user_id: Scalars['Int']['input'];
};

/** Readiness level derived from fit_score (@property, not stored in DB). SHORT_TERM: ≥85%, MEDIUM_TERM: ≥70%, LONG_TERM: ≥50%, NOT_READY: <50%. */
export enum ReadinessLevelEnum {
  LongTerm = 'LONG_TERM',
  MediumTerm = 'MEDIUM_TERM',
  NotReady = 'NOT_READY',
  ShortTerm = 'SHORT_TERM'
}

export type RecalculateIncorporationDateBalanceInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Centralized User ID */
  centralized_user_id: Scalars['ID']['input'];
};

export type RecalculateIncorporationDateBalanceResponse = {
  __typename?: 'RecalculateIncorporationDateBalanceResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

/** Employee assigned to one of the matched positions. */
export type RecommendationCandidateNode = {
  __typename?: 'RecommendationCandidateNode';
  current_position_name?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  employee_id: Scalars['Int']['output'];
  firstname: Scalars['String']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
};

export type RecoverChangePasswordInput = {
  code: Scalars['String']['input'];
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type RecoverChangePasswordPayload = {
  __typename?: 'RecoverChangePasswordPayload';
  messages: Array<RecoverPasswordMessage>;
  organization_slug?: Maybe<Scalars['String']['output']>;
  redirect_url?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<RecoverSegment>;
  success: Scalars['Boolean']['output'];
};

export type RecoverPassword = ErrorResponse | RecoverPasswordResponse;

export type RecoverPasswordMessage = {
  __typename?: 'RecoverPasswordMessage';
  error_code: Scalars['String']['output'];
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type RecoverPasswordResponse = {
  __typename?: 'RecoverPasswordResponse';
  activation_key: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum RecoverSegment {
  B2B = 'B2B',
  B2BOrg = 'B2B_ORG',
  B2C = 'B2C'
}

export type RecoverValidateTokenInput = {
  code: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type RecoverValidateTokenPayload = {
  __typename?: 'RecoverValidateTokenPayload';
  masked_email?: Maybe<Scalars['String']['output']>;
  password_policy?: Maybe<PasswordPolicyType>;
  valid: Scalars['Boolean']['output'];
};

export type RecoverValidateTokenPayloadQueryInternalServerError = QueryInternalServerError | RecoverValidateTokenPayload;

export type RedemptionAllowedNode = {
  __typename?: 'RedemptionAllowedNode';
  can_redeemed_this_reward: Scalars['Boolean']['output'];
  reward_id: Scalars['ID']['output'];
  reward_redemptions_allowed?: Maybe<Scalars['Int']['output']>;
  reward_redemptions_available?: Maybe<Scalars['Int']['output']>;
};

export type RefreshUserSessionPayload = {
  __typename?: 'RefreshUserSessionPayload';
  next_url?: Maybe<Scalars['String']['output']>;
  session_id: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
};

export type RefreshUserSessionPayloadValidationMutationErrorInternalServerMutationError = InternalServerMutationError | RefreshUserSessionPayload | ValidationMutationError;

export type RegenerateCopilotPlannerReportInput = {
  /** Organización con la que se persiste la conversación que hospeda la corrida. **Opcional**: por defecto se usa la organización de learning de la sesión, que es lo que ya prefiere el resolver. Solo hace falta mandarla si la sesión no la trae — la página del reporte en el web-proxy, por ejemplo, conoce el slug pero no el id. */
  organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** UUID del reporte de ORIGEN: el que tiene la receta. No se modifica; se crea otro a partir de ella. */
  report_id: Scalars['ID']['input'];
  /** Valores que reemplazan a los defaults de la receta, como objeto plano ({"periodo": "julio 2026"}). Las claves que no correspondan a una variable declarada las ignora el planner. Sin este campo se usan los valores por defecto, que es el caso del botón «Regenerar». */
  variables?: InputMaybe<Scalars['JSON']['input']>;
};

export type RegenerateCopilotPlannerReportResult = CopilotPlannerReportRegeneratedPayload | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type RegenerateSaml2CertificateInput = {
  centralized_organization_id: Scalars['ID']['input'];
  validity_days?: Scalars['Int']['input'];
};

export type RegenerateSaml2SpCertificateInput = {
  centralized_organization_id: Scalars['ID']['input'];
  validity_days?: Scalars['Int']['input'];
};

export type RegenerateUserTemplateResponse = {
  __typename?: 'RegenerateUserTemplateResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  template_url?: Maybe<Scalars['String']['output']>;
};

export type RegisterSaml2ServiceProviderInput = {
  acs_url: Scalars['String']['input'];
  centralized_organization_id: Scalars['ID']['input'];
  entity_id: Scalars['String']['input'];
  name_id_format?: Scalars['String']['input'];
  name_id_source?: InputMaybe<Scalars['String']['input']>;
  slo_url?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterSaml2TrustedIdpInput = {
  centralized_organization_id: Scalars['ID']['input'];
  certificate: Scalars['String']['input'];
  entity_id: Scalars['String']['input'];
  name_id_format?: Scalars['String']['input'];
  slo_url?: InputMaybe<Scalars['String']['input']>;
  sso_url: Scalars['String']['input'];
};

export type RegisterSecurityUserSessionInput = {
  authentication_method?: InputMaybe<Scalars['String']['input']>;
  expiration_date?: InputMaybe<Scalars['DateTime']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['ID']['input'];
  session_application?: InputMaybe<SecurityUserSessionApplicationEnum>;
  session_id: Scalars['String']['input'];
  session_type?: InputMaybe<SecurityUserSessionTypeEnum>;
  session_user_id: Scalars['Int']['input'];
  user_agent?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterSecurityUserSessionPayload = {
  __typename?: 'RegisterSecurityUserSessionPayload';
  authentication_method?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  session_application?: Maybe<SecurityUserSessionApplicationEnum>;
  session_id: Scalars['String']['output'];
  session_type?: Maybe<SecurityUserSessionTypeEnum>;
  session_user_id: Scalars['Int']['output'];
};

export type RegisterSecurityUserSessionPayloadValidationMutationErrorSecurityMutationErrorInternalServerMutationError = InternalServerMutationError | RegisterSecurityUserSessionPayload | SecurityMutationError | ValidationMutationError;

export type RehireEmployeeInput = {
  centralized_user_id: Scalars['Int']['input'];
  end_date?: InputMaybe<Scalars['Date']['input']>;
  legal_entity_id: Scalars['UUID']['input'];
  previous_contract_id: Scalars['UUID']['input'];
  start_date: Scalars['Date']['input'];
};

export type RehireEmployeeResponse = {
  __typename?: 'RehireEmployeeResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmployeeContractType;
};

export type RehireEmployeeResult = InternalErrorResponse | NotFoundErrorResponse | RehireEmployeeResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type RejectIncidencesResult = IncidenceReviewResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Relation bucket. OTHER_RELATIONS groups every relation that is not AUTO or BOSS (SUBORDINATE, COWORKER, SUPERVISOR, ...). */
export enum RelationFilter {
  Auto = 'AUTO',
  Boss = 'BOSS',
  OtherRelations = 'OTHER_RELATIONS'
}

export type RelationLabelType = {
  __typename?: 'RelationLabelType';
  label: Scalars['String']['output'];
  value: RelationQuestionnaireEnum;
};

/** Completed vs pending summary for a single evaluation x relation combination (one 'avance por relación' card). */
export type RelationProgressSummaryType = {
  __typename?: 'RelationProgressSummaryType';
  completed: Scalars['Int']['output'];
  evaluation_id: Scalars['Int']['output'];
  evaluation_name: Scalars['String']['output'];
  pending: Scalars['Int']['output'];
  progress_percentage: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

/** Progress of a single evaluation x relation combination. */
export type RelationProgressType = {
  __typename?: 'RelationProgressType';
  evaluation_id: Scalars['Int']['output'];
  evaluation_name: Scalars['String']['output'];
  progress_percentage: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export enum RelationQuestionnaireEnum {
  Auto = 'AUTO',
  Boss = 'BOSS',
  ClienteExterno = 'CLIENTE_EXTERNO',
  ClienteInterno = 'CLIENTE_INTERNO',
  Coworker = 'COWORKER',
  Otro = 'OTRO',
  Proveedor = 'PROVEEDOR',
  Subordinate = 'SUBORDINATE',
  Supervisor = 'SUPERVISOR',
  Vp = 'VP'
}

export enum RelationshipEnum {
  Child = 'CHILD',
  Cousin = 'COUSIN',
  DomesticPartner = 'DOMESTIC_PARTNER',
  Grandchild = 'GRANDCHILD',
  Grandparent = 'GRANDPARENT',
  NephewNiece = 'NEPHEW_NIECE',
  Other = 'OTHER',
  Parent = 'PARENT',
  Sibling = 'SIBLING',
  Spouse = 'SPOUSE',
  UncleAunt = 'UNCLE_AUNT'
}

export type ReminderUnsupportedModuleErrorV2 = {
  __typename?: 'ReminderUnsupportedModuleErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

/** Input para retirar TODAS las sedes gestionadas de un usuario. */
export type RemoveAllManagedHeadquartersInput = {
  /** ID de la organización que scopea la operación (requerido). */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID del usuario objetivo al que se le retiran todas las sedes (requerido). */
  user_id: Scalars['Int']['input'];
};

export type RemoveCourseHigherEducationTeamInput = {
  course_id?: InputMaybe<Scalars['ID']['input']>;
  organization_slug: Scalars['String']['input'];
  team_id: Scalars['ID']['input'];
};

export type RemoveCourseHigherEducationTeamResponse = {
  __typename?: 'RemoveCourseHigherEducationTeamResponse';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Input para desactivar una sede en todos los usuarios de la organización (AC-4/RN17). */
export type RemoveHeadquarterFromAllUsersInput = {
  /** ID de la organización que scopea la operación (requerido). */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID de la sede que se retira de todos los usuarios que la tuvieran asignada (requerido). */
  headquarter_id: Scalars['Int']['input'];
};

/** Payload del retiro de una sede en todos los usuarios de la organización. */
export type RemoveHeadquarterFromAllUsersPayload = {
  __typename?: 'RemoveHeadquarterFromAllUsersPayload';
  /** Cantidad de usuarios afectados por el retiro. */
  affected_count: Scalars['Int']['output'];
  /** IDs de los usuarios a los que se les retiró la sede. */
  affected_user_ids: Array<Scalars['Int']['output']>;
  /** ID de la sede retirada. */
  headquarter_id: Scalars['Int']['output'];
  /** Indica si el retiro fue exitoso. */
  success: Scalars['Boolean']['output'];
};

export type RemoveHeadquarterFromAllUsersPayloadValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse = IntegrityErrorResponse | InternalErrorResponse | NotFoundResponse | RemoveHeadquarterFromAllUsersPayload | ValidationErrorResponse;

export type RemoveLegalRepresentativeInput = {
  id: Scalars['ID']['input'];
  legal_entity_id: Scalars['ID']['input'];
};

export type RemoveLegalRepresentativeResponse = {
  __typename?: 'RemoveLegalRepresentativeResponse';
  graphql_operation_id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type RemoveLegalRepresentativeResult = InternalErrorResponse | RemoveLegalRepresentativeResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Input para retirar sedes gestionadas puntuales de un usuario (idempotente). */
export type RemoveManagedHeadquartersInput = {
  /** ID de la organización que scopea la operación (requerido). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Conjunto de IDs de sedes a retirar del usuario. Retirar una sede ya inactiva o ajena es un no-op. */
  headquarter_ids: Array<Scalars['Int']['input']>;
  /** ID del usuario objetivo al que se le retiran sedes (requerido). */
  user_id: Scalars['Int']['input'];
};

/** Payload del retiro de sedes gestionadas de un usuario. */
export type RemoveManagedHeadquartersPayload = {
  __typename?: 'RemoveManagedHeadquartersPayload';
  /** Sedes gestionadas que el usuario conserva tras el retiro. */
  remaining_headquarter_ids: Array<Scalars['Int']['output']>;
  /** Sedes retiradas (soft delete) en esta operación. */
  removed_headquarter_ids: Array<Scalars['Int']['output']>;
  /** Indica si el retiro fue exitoso. */
  success: Scalars['Boolean']['output'];
  /** ID del usuario objetivo. */
  user_id: Scalars['Int']['output'];
};

export type RemoveManagedHeadquartersPayloadValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse = IntegrityErrorResponse | InternalErrorResponse | NotFoundResponse | RemoveManagedHeadquartersPayload | ValidationErrorResponse;

export type RemoveMarketplaceUserResponse = {
  __typename?: 'RemoveMarketplaceUserResponse';
  error?: Maybe<ErrorResponse>;
  success: Scalars['Boolean']['output'];
};

export type RemoveSelectedCandidateInput = {
  /** ID of the centralized organization that owns the position */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID of the OrganizationPosition from which the successor is removed */
  position_id: Scalars['Int']['input'];
  /** ID of the User to demote from SELECTED to IDENTIFIED */
  user_id: Scalars['Int']['input'];
};

/** Payload returned after demoting a confirmed successor back to IDENTIFIED. */
export type RemoveSelectedCandidatePayload = {
  __typename?: 'RemoveSelectedCandidatePayload';
  /** The updated succession candidate record with status=IDENTIFIED */
  candidate: SuccessionCandidateNode;
};

export type RemoveSelectedCandidateResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | RemoveSelectedCandidatePayload | ValidationErrorResponse;

export type RemoveUserAdminRoleResponse = {
  __typename?: 'RemoveUserAdminRoleResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type RenewContractInput = {
  centralized_user_id: Scalars['Int']['input'];
  contract_id: Scalars['UUID']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
  new_end_date?: InputMaybe<Scalars['Date']['input']>;
};

export type RenewContractResponse = {
  __typename?: 'RenewContractResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmployeeContractType;
};

export type RenewContractResult = InternalErrorResponse | NotFoundErrorResponse | RenewContractResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type ReopenIncidencesResult = IncidenceReviewResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type Report = {
  __typename?: 'Report';
  download_url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type ReportColumnConfigResponse = {
  __typename?: 'ReportColumnConfigResponse';
  /** Si este reporte soporta niveles de área. */
  has_area_levels: Scalars['Boolean']['output'];
  /** Si este reporte soporta custom fields. */
  has_custom_fields: Scalars['Boolean']['output'];
  /** Key del tipo de reporte. */
  report_type_key: Scalars['String']['output'];
  /** Nombre legible del tipo de reporte. */
  report_type_name: Scalars['String']['output'];
  /** Hojas del reporte con sus secciones y columnas. */
  sheets: Array<ReportSheetNode>;
};

export type ReportColumnNode = {
  __typename?: 'ReportColumnNode';
  /** Orden dentro de la sección. */
  display_order: Scalars['Int']['output'];
  /** Column ID. */
  id: Scalars['ID']['output'];
  /** True = seleccionada por defecto. */
  is_default: Scalars['Boolean']['output'];
  /** True = no se puede deseleccionar. */
  is_required: Scalars['Boolean']['output'];
  /** False si está oculta para esta org. */
  is_visible: Scalars['Boolean']['output'];
  /** Identificador interno de la columna. */
  key: Scalars['String']['output'];
  /** Label visible para el usuario. */
  name: Scalars['String']['output'];
};

/** Column selection for report generation. Contains per-sheet column selections. */
export type ReportColumnSelectionInput = {
  /** Selección de columnas por hoja del reporte. */
  sheets: Array<SheetColumnSelectionInput>;
};

export type ReportCustomFieldInput = {
  field_answers: Array<Scalars['String']['input']>;
  field_id: Scalars['String']['input'];
  field_type?: InputMaybe<AnalyticsCustomFieldTypeEnum>;
};

export type ReportDashboardQuery = {
  __typename?: 'ReportDashboardQuery';
  /** Section B, Chart 2 — Activity composition by module (horizontal bars). */
  get_activity_composition: ActivityCompositionResponse;
  /** Section B, Chart 1 — Platform activity timeline (line chart, daily unique users). */
  get_activity_timeline: ActivityTimelineResponse;
  /** Section D — Actionable alerts requiring admin attention. */
  get_alerts: DashboardAlertsResponse;
  /** Section E2 — Top areas by percentage of active collaborators. */
  get_areas_engagement: AreasEngagementResponse;
  /** KPI cards widget. Send one or more kpi_types to get multiple cards in a single request. Returns cards in the same order as kpi_types. */
  get_kpi_cards: Array<DashboardKpiCardResponse>;
  /** Historical certificates and survey-satisfaction data: certificate totals + monthly series, and survey CSAT (1-5) per route launched in the last 90 days. Period-independent. */
  get_learning_certificates_satisfaction: AnalyticsLearningCertificatesSatisfaction;
  /** Detail drawer for one course: satisfacción promedio (CSAT) and the top users by course progress. ('Avance por módulo' is deferred — refined has no per-module granularity.) */
  get_learning_course_detail: AnalyticsLearningCourseDetail;
  /** Learning 'Por cursos' deep-dive table (paginated): per course — type (own/catalog), enrolled, started, completed, evaluation-approved rate, avg progress, study hours, certificates and CSAT. Filterable by catalog type, searchable by course name, and segmentable by attribute; period scopes started/completed. */
  get_learning_courses_deep_dive: AnalyticsLearningCourseTableRowConnection;
  /** Learning 'Por cursos' KPI band for the organization: active courses (current-state, split into own vs Crehana catalog) plus period-scoped enrollments, started, completed and completion rate. Filterable by catalog type (all / own / Crehana). */
  get_learning_courses_kpis: AnalyticsLearningCoursesKpis;
  /** Breakdown of the 'Por cursos' KPIs by the top values of a chosen attribute (employee-base default or custom field) — medallero (ANLT-396). Same band math as get_learning_courses_kpis per segment. */
  get_learning_courses_kpis_by_segment: AnalyticsLearningCoursesKpisBySegment;
  /** Learning dashboard context: resolved organization (by centralized id or slug), Learning module gating, permitted scope and data freshness. Called once per screen load by the dashboard shell. Not-contracted is a valid response, never an error. */
  get_learning_dashboard_context: AnalyticsLearningDashboardContext;
  /** Filter catalog for the Learning deep-dive tabs: every filterable attribute (employee-base defaults + customer custom fields) with its selectable values for the organization. Powers the FE filter panel. */
  get_learning_filter_options: AnalyticsLearningFilterOptions;
  /** Historical Learning series for the organization: quarterly enrollments/completions split by origin (own vs catalog) with consolidated detail, and the monthly trend of key indicators. Period-independent — ignores the global period filter. */
  get_learning_historical_series: AnalyticsLearningHistoricalSeries;
  /** The 7 Learning key indicators for the organization and period (engaged collaborators, enrollments, completions and completion rate, hours, certificates, satisfaction, inactive users), each with its variation vs the previous period. Period defaults to the current month. */
  get_learning_key_metrics: AnalyticsLearningKeyMetrics;
  /** Learning metrics of the period grouped by the values of one segmentation attribute (default or custom). Empty list when the attribute has no values. */
  get_learning_metrics_by_attribute: AnalyticsLearningMetricsByAttribute;
  /** Learning rankings: top learners by completions and top courses by certificates (period-dependent), plus active users with no access in >30 days (fixed threshold). */
  get_learning_rankings: AnalyticsLearningRankings;
  /** Detail drawer for one learning route: per-course completion and the top users by route progress. */
  get_learning_route_detail: AnalyticsLearningRouteDetail;
  /** Learning 'Por rutas' deep-dive table (paginated, sortable, searchable by route name): per route, enrolled, completion rate, courses/certificates required, evaluation & project approvals, CSAT and status. Current-state list. */
  get_learning_routes_deep_dive: AnalyticsLearningRouteTableRowConnection;
  /** Learning 'Por rutas' KPI band: completitud total plus rutas completadas, cursos completados, evaluaciones aprobadas and proyectos aprobados (percentages). Segmentable by attribute. */
  get_learning_routes_kpis: AnalyticsLearningRoutesKpis;
  /** Breakdown of the 'Por rutas' KPIs by the top values of a chosen attribute (employee-base default or custom field) — medallero (ANLT-395). Same band math as get_learning_routes_kpis per segment. */
  get_learning_routes_kpis_by_segment: AnalyticsLearningRoutesKpisBySegment;
  /** Learning routes table for the organization (all-time): per route, enrolled, courses completed, route completed, courses required and completion rate. Ordered by enrolled descending. */
  get_learning_routes_table: AnalyticsLearningRoutesTable;
  /** Catalog of attributes the organization can segment Learning metrics by: defaults from the collaborator base plus the company's custom fields. */
  get_learning_segmentation_attributes: AnalyticsLearningSegmentationAttributes;
  /** Detail drawer for one user: routes in progress (with %) and recent course activity. */
  get_learning_user_detail: AnalyticsLearningUserDetail;
  /** Learning 'Por usuarios' deep-dive table (paginated): per active user — área, all courses, admin-assigned, completed, avg progress, routes, certificates, study hours and last activity. Searchable by name/email and segmentable by attribute. */
  get_learning_users_deep_dive: AnalyticsLearningUserTableRowConnection;
  /** Learning 'Por usuarios' KPI band: active users, users studying (≥1 course started in the period), average study hours per participating user, and users with ≥1 certificate in the period. Segmentable by attribute. */
  get_learning_users_kpis: AnalyticsLearningUsersKpis;
  /** Breakdown of the 'Por usuarios' KPIs by the top values of a chosen attribute (employee-base default or custom field). */
  get_learning_users_kpis_by_segment: AnalyticsLearningUsersKpisBySegment;
  /** Section E3 — Milestones achieved this month. */
  get_milestones: MilestonesResponse;
  /** Product pulse cards. Send one or more product_types to get multiple cards in a single request. Returns cards in the same order. */
  get_product_pulse: Array<ProductPulseCard>;
  /** The goals of ONE collaborator in the process (M-R6, expandable row): name, weight and result of each. The collaborator is checked against the process cohort, so an id from another organization returns nothing rather than someone else's goals. */
  get_talent_collaborator_goals: AnalyticsTalentCollaboratorGoals;
  /** Per-collaborator competences detail (C-S6): one server-resolved page of the process cohort with the state of each person's evaluation in every relation. Each cell has THREE states — «nobody assigned to evaluate you» is a configuration problem and «your evaluator has not done it yet» is a reminder problem, and folding them together would hide the first behind the second. The `block` filter returns only the collaborators in that situation, and `total_count` reflects that filtered subset — its three values are the same three the relation cards count. An empty page is a success, not an error. */
  get_talent_competences_detail: AnalyticsTalentCompetencesDetail;
  /**
   * Competences progress per EVALUATOR (C-S5), one server-resolved page: how many evaluations each person was assigned, how many they submitted and how many they still owe. Sorted by pending descending by default — the question the table exists to answer. The unit of accountability is the evaluator, not the leader. An empty page is a success, not an error.
   *
   * ⚠️ Only evaluators who are ACTIVE members of the organization appear: the join that provides them is also the only tenancy isolation available, since the relations table has no company column. An external evaluator or someone who left has no row here, while the SC-15 downloadable lists them with a blank name.
   */
  get_talent_competences_evaluators: AnalyticsTalentCompetencesEvaluators;
  /**
   * Perception gap per competence (C-R5): for each competence, the average self-evaluation, the average leader result, and the difference. Widest gap first.
   *
   * Only collaborators with **both** views are compared — a gap needs two sides, and averaging one over 200 people and the other over 50 would compare different populations. Those left out are reported in `excluded_count`.
   *
   * ⚠️ Check `is_applicable` first: a process that did not configure both relations has NO gap, which is different from a gap of zero. Rendering zero would read as «everyone perfectly aligned» — the opposite of «we never asked».
   */
  get_talent_competences_gap: AnalyticsTalentCompetencesGap;
  /** Progress of every OPEN competences process at once (M-C1): name, date window, enrolled count and completion rate, ordered by the closest to expiring. Progress counts (evaluator, evaluated) PAIRS — each evaluation someone was asked to complete — over the same active-member cohort the downloadable report uses, so the two reconcile. Cancelled evaluations are excluded from both sides. A process with nothing assigned reports a NULL rate, not zero. */
  get_talent_competences_processes_progress: AnalyticsTalentCompetencesProcessesProgress;
  /** Competences progress per CONFIGURED relation (M-C2), plus the three blocking situations. A relation the process configured but nobody ever evaluated comes back with zeros and sorts FIRST — that absence is the finding, and hiding it would hide the very problem the block exists to show. Relations evaluated but not configured also come back, flagged, because they represent work that really happened. The blocking counts are people, over the same cohort the process selector shows. */
  get_talent_competences_progress_by_relation: AnalyticsTalentCompetencesProgressByRelation;
  /** Competences progress cut by an attribute of the EVALUATOR (M-C4): which group is going to keep the process from closing. Grouped by the evaluator because that is who holds the pending work — and it is the same subject the process card counts, so the groups add up to it exactly. Collaborators with no value land under «Sin asignar» instead of being dropped. Worst first; a group with nothing assigned reports a NULL percentage, not zero. */
  get_talent_competences_progress_by_segment: AnalyticsTalentCompetencesProgressBySegment;
  /**
   * Competences of the model ranked from WORST to best result (C-R4) — the list you build next cycle's training plan from.
   *
   * Every competence the model defines is listed, including the ones nobody was evaluated on: that absence is a finding, not a missing row. Those come back with a null result and sort LAST — «not measured» is not «the worst».
   *
   * ⚠️ The expected minimum is configured **per job level**, so an analyst and a manager can be held to different bars on the same competence. When they differ, `expected_percentage` is null and `expected_varies_by_role` is true: publishing one of them, or their average, would show a threshold nobody configured.
   */
  get_talent_competences_ranking: AnalyticsTalentCompetenceRanking;
  /**
   * Competences RESULTS for one closed process (C-R1): the organization's average, how many were evaluated out of how many were enrolled, the size of the process, and the distribution across the scale. This is the result — execution progress lives in the Seguimiento tab.
   *
   * ⚠️ The average is clamped to [0, 100] BEFORE averaging: the source exceeds 100 in 1.28 % of rows, and clamping afterwards turns a real 83 into a reported 100.
   */
  get_talent_competences_results: AnalyticsTalentCompetencesResults;
  /**
   * Competences results cut by group (C-R3): for each value of the chosen attribute, the group's average, how many people it has, how many of them have a result, and **the competence dragging it down** — which is what turns the cut into a development plan.
   *
   * Small groups come back with their count instead of being hidden: the interface decides how to present them, and filtering them here would drop them from the overall figures too. Groups with nobody evaluated report a NULL average and sort last — unknown, not worst.
   */
  get_talent_competences_results_by_group: AnalyticsTalentCompetencesResultsByGroup;
  /**
   * Collaborators of a closed competences process, paginated, each with their overall result, the level they reached, and their score competence by competence (ANLT-642).
   *
   * The expandable detail lists **every competence of the model** for every person, including the ones they were not evaluated on, which travel with a null result — so the rows stay comparable and the gaps stay visible. Search, sort and pagination are resolved server-side, and `total_count` reflects the same filters as the page.
   */
  get_talent_competences_results_detail: AnalyticsTalentCompetenceResultsDetail;
  /** Compliance by goal category (M-R4): for every strategy and every approach, how many goals it holds and their average result. The unit is the GOAL, so this average does not have to match the results band, which averages people's weighted results; the two differ by design. Goals with no category are grouped under «Sin categoría» instead of being dropped. */
  get_talent_goals_by_category: AnalyticsTalentGoalsByCategory;
  /** Goals cycle progress for one process: how many collaborators completed each stage (loaded, approved, self-reported, boss-reported) out of those enrolled, plus the three blocking situations. A collaborator completes a stage when ALL their goals reached it, matching the «Jefe Evaluó Todas» rule of the «Estado seguimiento de metas» report. Collaborators never included in the process are excluded from every count. */
  get_talent_goals_cycle_progress: AnalyticsTalentGoalsCycleProgress;
  /** Paged collaborator detail for a goals process: each person's current stage, progress, leader and organizational data. Page, order and search are resolved on the server. The `block` filter is how the FE drills from a blocking card into the people behind it, and its count uses the same predicates as the rows. */
  get_talent_goals_detail: AnalyticsTalentGoalsDetail;
  /** Follow-up discipline (M-R5): how many collaborators kept the tracking ritual through every cycle already under way, and the same cut by group. It measures SELF-reports, which is NOT what the report's «Jefe Evaluó Todas» column measures — that one tracks the BOSS's completion and says «complies» for people who never self-assessed even once, so the two numbers differ by a lot. Collaborators with no approved goal are reported apart: they had nothing to report. */
  get_talent_goals_discipline: AnalyticsTalentGoalsDiscipline;
  /** How the evaluated collaborators spread across the organization's configured scale (M-R2) — the block that answers whether the headline average is hiding extremes. It counts COLLABORATORS, not goals, so its bands add up to the same evaluated population the results band reports. Collaborators with no result are reported APART, in without_result_count, and are never a band: «not measured» is not «scored zero». */
  get_talent_goals_distribution: AnalyticsTalentGoalsDistribution;
  /** Day-by-day evolution of a goals cycle: for each day of the process window, how many collaborators had completed each stage by then. ONLY the self-report and boss-report stages can be drawn — the goals table carries no date for «loaded» or «approved», so those two are named in `stages_without_date_source` and must NOT be rendered as a flat line: they are unknown, not zero. */
  get_talent_goals_evolution: AnalyticsTalentGoalsEvolution;
  /** Paged leader detail for a goals process: whose team is on track and whose is holding the cycle back, with the pending count per stage so the admin knows what to remind about. Ordered by team progress ascending by default — the table exists to find who is behind, not to congratulate whoever finished. Collaborators with no leader on record form their own group, which is what makes the sum of all teams equal the band's enrolled count. */
  get_talent_goals_leaders: AnalyticsTalentGoalsLeaders;
  /** Goals cycle progress cut by a collaborator attribute — the organization's standard attributes (División, Cargo, Sede) or the custom fields it configured in Talent. Groups come ordered worst progress first, so what needs attention is on top, and the block carries its own attribute selector in `available_attributes`. Collaborators with no value loaded form a real «Sin asignar» group. */
  get_talent_goals_progress_by_segment: AnalyticsTalentGoalsProgressBySegment;
  /** Paged collaborator ranking for a closed goals process (M-R6): each person's weighted result, their scale band and their leader. Order, search and paging are resolved SERVER-SIDE from a closed list of columns — the client's text never reaches the SQL. The default order is worst first, matching the rest of the tab, with the unevaluated at the end: having no result is not being the worst. */
  get_talent_goals_ranking: AnalyticsTalentGoalsRanking;
  /** Results band of a closed goals process: the official compliance figure, the plain weighted average next to it, how many collaborators met the threshold, how many landed in the critical band, and the coverage. The official figure is the PERCENTAGE OF EVALUATED COLLABORATORS WHO MET THE THRESHOLD, not the average of their results — the average moves with one anomalous row, this does not. Both the configured scale and the tracking cycle travel back so the UI can label what it is showing. */
  get_talent_goals_results: AnalyticsTalentGoalsResults;
  /** Compliance cut by an attribute (M-R3): every group's full distribution across the configured scale plus its average, so a low area can be told apart from an area with a couple of low cases. Groups below any significance threshold are returned too, with their count — the interface decides how to present them; hiding them here would make the groups stop adding up. */
  get_talent_goals_results_by_segment: AnalyticsTalentGoalsResultsBySegment;
  /** Talent process catalog for one module (Goals or Competencies), newest first, with each process' window, state and enrolled collaborators, plus the process the tab preselects and the data freshness mark. Called once per tab load; the returned process_id keys every other Talent block. Module not contracted and empty catalog are valid responses, never errors. */
  get_talent_process_catalog: AnalyticsTalentProcessCatalog;
  /** Section E1 — Top 5 most completed courses in the period. */
  get_top_courses: TopCoursesResponse;
  /** Apollo cache normalization keyk — returns centralized_organization_id from the JWT session. Prevents cache collisions when multiple queries target the same ReportDashboardQuery type. */
  id: Scalars['ID']['output'];
};


export type ReportDashboardQueryGet_Activity_CompositionArgs = {
  input: AnalyticsDashboardPeriodInput;
};


export type ReportDashboardQueryGet_Activity_TimelineArgs = {
  input: AnalyticsDashboardPeriodInput;
};


export type ReportDashboardQueryGet_AlertsArgs = {
  input: AnalyticsDashboardInput;
};


export type ReportDashboardQueryGet_Areas_EngagementArgs = {
  input: AnalyticsDashboardInput;
};


export type ReportDashboardQueryGet_Kpi_CardsArgs = {
  input: AnalyticsDashboardKpiInput;
};


export type ReportDashboardQueryGet_Learning_Certificates_SatisfactionArgs = {
  input: AnalyticsLearningCertificatesSatisfactionInput;
};


export type ReportDashboardQueryGet_Learning_Course_DetailArgs = {
  input: AnalyticsLearningCourseDetailInput;
};


export type ReportDashboardQueryGet_Learning_Courses_Deep_DiveArgs = {
  input: AnalyticsLearningCoursesDeepDiveInput;
};


export type ReportDashboardQueryGet_Learning_Courses_KpisArgs = {
  input: AnalyticsLearningCoursesKpisInput;
};


export type ReportDashboardQueryGet_Learning_Courses_Kpis_By_SegmentArgs = {
  input: AnalyticsLearningCoursesSegmentInput;
};


export type ReportDashboardQueryGet_Learning_Dashboard_ContextArgs = {
  input: AnalyticsLearningDashboardContextInput;
};


export type ReportDashboardQueryGet_Learning_Filter_OptionsArgs = {
  input: AnalyticsLearningFilterOptionsInput;
};


export type ReportDashboardQueryGet_Learning_Historical_SeriesArgs = {
  input: AnalyticsLearningHistoricalSeriesInput;
};


export type ReportDashboardQueryGet_Learning_Key_MetricsArgs = {
  input: AnalyticsLearningKeyMetricsInput;
};


export type ReportDashboardQueryGet_Learning_Metrics_By_AttributeArgs = {
  input: AnalyticsLearningMetricsByAttributeInput;
};


export type ReportDashboardQueryGet_Learning_RankingsArgs = {
  input: AnalyticsLearningRankingsInput;
};


export type ReportDashboardQueryGet_Learning_Route_DetailArgs = {
  input: AnalyticsLearningRouteDetailInput;
};


export type ReportDashboardQueryGet_Learning_Routes_Deep_DiveArgs = {
  input: AnalyticsLearningRoutesDeepDiveInput;
};


export type ReportDashboardQueryGet_Learning_Routes_KpisArgs = {
  input: AnalyticsLearningRoutesKpisInput;
};


export type ReportDashboardQueryGet_Learning_Routes_Kpis_By_SegmentArgs = {
  input: AnalyticsLearningRoutesSegmentInput;
};


export type ReportDashboardQueryGet_Learning_Routes_TableArgs = {
  input: AnalyticsLearningRoutesTableInput;
};


export type ReportDashboardQueryGet_Learning_Segmentation_AttributesArgs = {
  input: AnalyticsLearningSegmentationAttributesInput;
};


export type ReportDashboardQueryGet_Learning_User_DetailArgs = {
  input: AnalyticsLearningUserDetailInput;
};


export type ReportDashboardQueryGet_Learning_Users_Deep_DiveArgs = {
  input: AnalyticsLearningUsersDeepDiveInput;
};


export type ReportDashboardQueryGet_Learning_Users_KpisArgs = {
  input: AnalyticsLearningUsersKpisInput;
};


export type ReportDashboardQueryGet_Learning_Users_Kpis_By_SegmentArgs = {
  input: AnalyticsLearningUsersSegmentInput;
};


export type ReportDashboardQueryGet_MilestonesArgs = {
  input: AnalyticsDashboardPeriodInput;
};


export type ReportDashboardQueryGet_Product_PulseArgs = {
  input: AnalyticsDashboardPulseInput;
};


export type ReportDashboardQueryGet_Talent_Collaborator_GoalsArgs = {
  input: AnalyticsTalentCollaboratorGoalsInput;
};


export type ReportDashboardQueryGet_Talent_Competences_DetailArgs = {
  input: AnalyticsTalentCompetencesDetailInput;
};


export type ReportDashboardQueryGet_Talent_Competences_EvaluatorsArgs = {
  input: AnalyticsTalentCompetencesEvaluatorsInput;
};


export type ReportDashboardQueryGet_Talent_Competences_GapArgs = {
  input: AnalyticsTalentCompetencesGapInput;
};


export type ReportDashboardQueryGet_Talent_Competences_Processes_ProgressArgs = {
  input: AnalyticsTalentCompetencesProcessesProgressInput;
};


export type ReportDashboardQueryGet_Talent_Competences_Progress_By_RelationArgs = {
  input: AnalyticsTalentCompetencesProgressByRelationInput;
};


export type ReportDashboardQueryGet_Talent_Competences_Progress_By_SegmentArgs = {
  input: AnalyticsTalentCompetencesProgressBySegmentInput;
};


export type ReportDashboardQueryGet_Talent_Competences_RankingArgs = {
  input: AnalyticsTalentCompetencesResultsInput;
};


export type ReportDashboardQueryGet_Talent_Competences_ResultsArgs = {
  input: AnalyticsTalentCompetencesResultsInput;
};


export type ReportDashboardQueryGet_Talent_Competences_Results_By_GroupArgs = {
  input: AnalyticsTalentCompetencesResultsByGroupInput;
};


export type ReportDashboardQueryGet_Talent_Competences_Results_DetailArgs = {
  input: AnalyticsTalentCompetencesResultsDetailInput;
};


export type ReportDashboardQueryGet_Talent_Goals_By_CategoryArgs = {
  input: AnalyticsTalentGoalsByCategoryInput;
};


export type ReportDashboardQueryGet_Talent_Goals_Cycle_ProgressArgs = {
  input: AnalyticsTalentGoalsCycleProgressInput;
};


export type ReportDashboardQueryGet_Talent_Goals_DetailArgs = {
  input: AnalyticsTalentGoalsDetailInput;
};


export type ReportDashboardQueryGet_Talent_Goals_DisciplineArgs = {
  input: AnalyticsTalentGoalsDisciplineInput;
};


export type ReportDashboardQueryGet_Talent_Goals_DistributionArgs = {
  input: AnalyticsTalentGoalsDistributionInput;
};


export type ReportDashboardQueryGet_Talent_Goals_EvolutionArgs = {
  input: AnalyticsTalentGoalsEvolutionInput;
};


export type ReportDashboardQueryGet_Talent_Goals_LeadersArgs = {
  input: AnalyticsTalentGoalsLeadersInput;
};


export type ReportDashboardQueryGet_Talent_Goals_Progress_By_SegmentArgs = {
  input: AnalyticsTalentGoalsProgressBySegmentInput;
};


export type ReportDashboardQueryGet_Talent_Goals_RankingArgs = {
  input: AnalyticsTalentGoalsRankingInput;
};


export type ReportDashboardQueryGet_Talent_Goals_ResultsArgs = {
  input: AnalyticsTalentGoalsResultsInput;
};


export type ReportDashboardQueryGet_Talent_Goals_Results_By_SegmentArgs = {
  input: AnalyticsTalentGoalsResultsBySegmentInput;
};


export type ReportDashboardQueryGet_Talent_Process_CatalogArgs = {
  input: AnalyticsTalentProcessCatalogInput;
};


export type ReportDashboardQueryGet_Top_CoursesArgs = {
  input: AnalyticsDashboardPeriodInput;
};

export type ReportEnrollmentConnection = {
  __typename?: 'ReportEnrollmentConnection';
  /** Number of completed enrollments */
  completed_enrollments_count?: Maybe<Scalars['Int']['output']>;
  edges: Array<ReportEnrollmentNodeEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
  /** Number of total enrollments */
  total_enrollments_count?: Maybe<Scalars['Int']['output']>;
};

export type ReportEnrollmentInputOrderBy = {
  direction: OrderDirectionEnum;
  field: ReportEnrollmentOrderByEnum;
};

export type ReportEnrollmentNode = {
  __typename?: 'ReportEnrollmentNode';
  assigned_by_name?: Maybe<Scalars['String']['output']>;
  assignment_source?: Maybe<Scalars['Int']['output']>;
  certificate_date?: Maybe<Scalars['String']['output']>;
  code_certificate?: Maybe<Scalars['String']['output']>;
  completed_date?: Maybe<Scalars['String']['output']>;
  course_category?: Maybe<Scalars['String']['output']>;
  course_comment?: Maybe<Scalars['String']['output']>;
  course_duration_hours?: Maybe<Scalars['Float']['output']>;
  course_id: Scalars['Int']['output'];
  course_name: Scalars['String']['output'];
  course_progress: Scalars['Int']['output'];
  course_score?: Maybe<Scalars['Int']['output']>;
  course_subcategory?: Maybe<Scalars['String']['output']>;
  enroll_date: Scalars['String']['output'];
  enroll_id: Scalars['ID']['output'];
  /** Enum enrollment type based on assignment source */
  enrollment_type_enum?: Maybe<ReportEnrollmentTypeEnum>;
  has_participation_certificate?: Maybe<Scalars['Boolean']['output']>;
  is_admin_assigned?: Maybe<Scalars['Boolean']['output']>;
  is_certified: Scalars['Boolean']['output'];
  is_completed: Scalars['Boolean']['output'];
  is_crehana: Scalars['Boolean']['output'];
  is_enroll_active: Scalars['Boolean']['output'];
  last_action_date?: Maybe<Scalars['String']['output']>;
  participation_certificate_date?: Maybe<Scalars['String']['output']>;
  played_hours?: Maybe<Scalars['Float']['output']>;
  /** return player url */
  player_url?: Maybe<Scalars['String']['output']>;
  progress_hours?: Maybe<Scalars['Float']['output']>;
  project_date?: Maybe<Scalars['String']['output']>;
  project_status?: Maybe<Scalars['String']['output']>;
  quiz_attemps?: Maybe<Scalars['Int']['output']>;
  quiz_result?: Maybe<Scalars['Float']['output']>;
  quiz_status?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  total_correct_answer?: Maybe<Scalars['Int']['output']>;
  total_questions?: Maybe<Scalars['Int']['output']>;
  total_wrong_answer?: Maybe<Scalars['Int']['output']>;
  url_certificate?: Maybe<Scalars['String']['output']>;
  url_participation_certificate?: Maybe<Scalars['String']['output']>;
  url_project?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportEnrollmentNodeEdge = {
  __typename?: 'ReportEnrollmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ReportEnrollmentNode;
};

export enum ReportEnrollmentOrderByEnum {
  CourseTitle = 'COURSE_TITLE',
  EnrollmentAt = 'ENROLLMENT_AT'
}

export enum ReportEnrollmentSearchFilterEnum {
  EnrollmentSearchFilterActive = 'ENROLLMENT_SEARCH_FILTER_ACTIVE',
  EnrollmentSearchFilterAll = 'ENROLLMENT_SEARCH_FILTER_ALL',
  EnrollmentSearchFilterCompleted = 'ENROLLMENT_SEARCH_FILTER_COMPLETED',
  EnrollmentSearchFilterInactive = 'ENROLLMENT_SEARCH_FILTER_INACTIVE',
  EnrollmentSearchFilterInProgress = 'ENROLLMENT_SEARCH_FILTER_IN_PROGRESS',
  EnrollmentSearchFilterNotStarted = 'ENROLLMENT_SEARCH_FILTER_NOT_STARTED'
}

export enum ReportEnrollmentTypeEnum {
  B2B = 'B2B',
  Degree = 'DEGREE',
  Free = 'FREE',
  Freemium = 'FREEMIUM',
  FreeMembership = 'FREE_MEMBERSHIP',
  GiftCard = 'GIFT_CARD',
  Membership = 'MEMBERSHIP',
  Mentor = 'MENTOR',
  Migrate = 'MIGRATE',
  Paid = 'PAID',
  PreviewTrial = 'PREVIEW_TRIAL',
  Professor = 'PROFESSOR',
  Staff = 'STAFF',
  TemporalAccess = 'TEMPORAL_ACCESS'
}

export type ReportExistsResponse = {
  __typename?: 'ReportExistsResponse';
  can_reuse: Scalars['Boolean']['output'];
  error: Scalars['String']['output'];
  existing_report_id: Scalars['Int']['output'];
  existing_report_status: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum ReportFlowVersionEnum {
  Version_1 = 'VERSION_1',
  Version_2 = 'VERSION_2'
}

export type ReportGeneral = {
  __typename?: 'ReportGeneral';
  assigned_by_name?: Maybe<Scalars['String']['output']>;
  certificate_type_name?: Maybe<Scalars['String']['output']>;
  course_category?: Maybe<Scalars['String']['output']>;
  course_certificated_date?: Maybe<Scalars['String']['output']>;
  course_certificated_url?: Maybe<Scalars['String']['output']>;
  course_complete_date?: Maybe<Scalars['Date']['output']>;
  course_duration_hours: Scalars['Float']['output'];
  course_enroll_date?: Maybe<Scalars['Date']['output']>;
  course_has_participation_certificate: Scalars['Boolean']['output'];
  course_id: Scalars['ID']['output'];
  course_is_certified?: Maybe<Scalars['Boolean']['output']>;
  course_is_completed: Scalars['Boolean']['output'];
  course_is_reward: Scalars['String']['output'];
  course_last_action_date?: Maybe<Scalars['DateTime']['output']>;
  course_name: Scalars['String']['output'];
  course_participation_certificate_url?: Maybe<Scalars['String']['output']>;
  course_progress: Scalars['Float']['output'];
  course_progress_hours: Scalars['Float']['output'];
  course_start_date?: Maybe<Scalars['Date']['output']>;
  course_subcategory?: Maybe<Scalars['String']['output']>;
  course_type: Scalars['String']['output'];
  is_admin_assigned: Scalars['Boolean']['output'];
  is_enroll_active: Scalars['Boolean']['output'];
  project_date?: Maybe<Scalars['Date']['output']>;
  project_status?: Maybe<Scalars['String']['output']>;
  project_url?: Maybe<Scalars['String']['output']>;
  quiz_attemps?: Maybe<Scalars['String']['output']>;
  quiz_best_correct_answers?: Maybe<Scalars['Int']['output']>;
  quiz_best_result?: Maybe<Scalars['Float']['output']>;
  quiz_best_wrong_answers?: Maybe<Scalars['Int']['output']>;
  quiz_status?: Maybe<Scalars['String']['output']>;
  quiz_total_questions?: Maybe<Scalars['Int']['output']>;
  row_num?: Maybe<Scalars['Int']['output']>;
  track_id?: Maybe<Scalars['String']['output']>;
  track_is_hidden?: Maybe<Scalars['Boolean']['output']>;
  track_name?: Maybe<Scalars['String']['output']>;
  user_custom_fields?: Maybe<Array<ReportGeneralUserCustomFieldType>>;
  user_division?: Maybe<Scalars['String']['output']>;
  user_email: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
  user_info_extra?: Maybe<Scalars['String']['output']>;
  user_job?: Maybe<Scalars['String']['output']>;
  user_level?: Maybe<Scalars['String']['output']>;
  user_name: Scalars['String']['output'];
  user_role?: Maybe<Scalars['String']['output']>;
  user_status: GeneralReportUserStatusEnum;
  user_subsidiary?: Maybe<Scalars['String']['output']>;
};

export type ReportGeneralConnection = {
  __typename?: 'ReportGeneralConnection';
  /** A list of edges in this connection. */
  edges: Array<ReportGeneralEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type ReportGeneralConnectionQueryValidationErrorQueryInternalError = QueryInternalError | QueryValidationError | ReportGeneralConnection;

export type ReportGeneralEdge = {
  __typename?: 'ReportGeneralEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReportGeneral;
};

export type ReportGeneralUserCustomFieldType = {
  __typename?: 'ReportGeneralUserCustomFieldType';
  field_answer: Scalars['String']['output'];
  field_name: Scalars['String']['output'];
};

export enum ReportGenerationTypeEnum {
  FromTemplate = 'FROM_TEMPLATE',
  OnDemand = 'ON_DEMAND',
  Scheduled = 'SCHEDULED'
}

export type ReportInputNode = {
  activity_end_date?: InputMaybe<Scalars['Date']['input']>;
  activity_start_date?: InputMaybe<Scalars['Date']['input']>;
  course_enroll_status?: InputMaybe<Scalars['Boolean']['input']>;
  courses?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  custom_fields?: InputMaybe<Array<InputMaybe<ReportCustomFieldInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  direct_download?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  file_format?: InputMaybe<FileFormatEnum>;
  generation_frequency?: InputMaybe<OrganizationReportGenerationFrequencyEnum>;
  generation_type?: InputMaybe<ReportGenerationTypeEnum>;
  has_certificated?: InputMaybe<Scalars['Boolean']['input']>;
  has_course_completed?: InputMaybe<Scalars['Boolean']['input']>;
  is_crehana_course?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_status?: InputMaybe<Array<InputMaybe<QuizStatusEnum>>>;
  report_id?: InputMaybe<Scalars['Int']['input']>;
  report_type: ReportsEnum;
  routes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sheets?: InputMaybe<Array<InputMaybe<GeneralSheetsEnum>>>;
  slug: Scalars['String']['input'];
  start_date?: InputMaybe<Scalars['Date']['input']>;
  team_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  user_role?: InputMaybe<Array<InputMaybe<UserRoleEnum>>>;
  user_status?: InputMaybe<Array<InputMaybe<AnalyticsUserStatusEnum>>>;
  users_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ReportLeaderboardResponse = {
  __typename?: 'ReportLeaderboardResponse';
  graphql_operation_id: Scalars['ID']['output'];
  report?: Maybe<Report>;
};

export type ReportLogNode = {
  __typename?: 'ReportLogNode';
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  created_at_formatted?: Maybe<Scalars['String']['output']>;
  created_at_formatted_time?: Maybe<Scalars['String']['output']>;
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  download_url?: Maybe<Scalars['String']['output']>;
  generated_by_full_name?: Maybe<Scalars['String']['output']>;
  processed_at?: Maybe<Scalars['DateTime']['output']>;
  /** Progress range end used by this run. Null if not filtered. */
  progress_end_date?: Maybe<Scalars['Date']['output']>;
  /** Progress range start used by this run. Null if not filtered. */
  progress_start_date?: Maybe<Scalars['Date']['output']>;
  /** Lista de destinatarios al momento del envío. */
  recipients: Array<ReportLogRecipientNode>;
  /** Total de destinatarios de esta corrida. */
  recipients_count: Scalars['Int']['output'];
  report_description?: Maybe<Scalars['String']['output']>;
  report_id: Scalars['Int']['output'];
  report_identifier: Scalars['String']['output'];
  report_module?: Maybe<Scalars['String']['output']>;
  report_name?: Maybe<Scalars['String']['output']>;
  report_product_type?: Maybe<Scalars['String']['output']>;
  report_source?: Maybe<ReportGenerationTypeEnum>;
  status: Scalars['String']['output'];
  unique_identifier?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type ReportLogNodeAnalyticsMutationInternalError = AnalyticsMutationInternalError | ReportLogNode;

export type ReportLogNodeAnalyticsReportMaxRetriesErrorAnalyticsMutationInternalError = AnalyticsMutationInternalError | AnalyticsReportMaxRetriesError | ReportLogNode;

export type ReportLogNodeConnection = {
  __typename?: 'ReportLogNodeConnection';
  /** A list of edges in this connection. */
  edges: Array<ReportLogNodeEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type ReportLogNodeConnectionQueryValidationErrorQueryInternalError = QueryInternalError | QueryValidationError | ReportLogNodeConnection;

export type ReportLogNodeEdge = {
  __typename?: 'ReportLogNodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReportLogNode;
};

export type ReportLogNodeReportExistsResponseAnalyticsReportRateLimitErrorAnalyticsMutationValidationErrorAnalyticsMutationInternalError = AnalyticsMutationInternalError | AnalyticsMutationValidationError | AnalyticsReportRateLimitError | ReportExistsResponse | ReportLogNode;

/** Snapshot of a recipient at the time the report was sent. */
export type ReportLogRecipientNode = {
  __typename?: 'ReportLogRecipientNode';
  /** ID del usuario en el sistema centralizado. */
  centralized_user_id: Scalars['Int']['output'];
  /** Email del destinatario. */
  email: Scalars['String']['output'];
  /** Nombre completo del destinatario. */
  full_name: Scalars['String']['output'];
};

export type ReportLogsFilterInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_slug: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Performance module to filter report logs (competencies, goals, feedback) */
  module?: InputMaybe<PerformanceModuleTypeEnum>;
  /** Product type to filter report logs */
  product_type?: InputMaybe<ProductTypeEnum>;
  report_type?: InputMaybe<ReportsEnum>;
  search?: InputMaybe<SearchInput>;
};

/** ENUMS */
export enum ReportModule {
  Competences = 'COMPETENCES',
  DynamicPerformance = 'DYNAMIC_PERFORMANCE',
  Goals = 'GOALS',
  Okrs = 'OKRS',
  Pid = 'PID'
}

export type ReportModuleNode = {
  __typename?: 'ReportModuleNode';
  /** Module icon */
  icon: Scalars['String']['output'];
  /** Module display name */
  label: Scalars['String']['output'];
  /** Module identifier */
  value: Scalars['String']['output'];
};

export type ReportPendingResponse = {
  __typename?: 'ReportPendingResponse';
  emails_sent: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  reports_found: Scalars['Int']['output'];
  sent_email: Scalars['Boolean']['output'];
};

export type ReportPendingResponseEventMutationError = EventMutationError | ReportPendingResponse;

export type ReportPredefinedAttributeInput = {
  attribute: AnalyticsPredefinedAttributeEnum;
  values: Array<Scalars['String']['input']>;
};

export type ReportProductTypeListResponse = {
  __typename?: 'ReportProductTypeListResponse';
  /** List of active product types from report templates */
  product_types: Array<ReportProductTypeNode>;
};

export type ReportProductTypeNode = {
  __typename?: 'ReportProductTypeNode';
  /** Product type icon */
  icon: Scalars['String']['output'];
  /** Product type display name */
  label: Scalars['String']['output'];
  /** List of available modules within this product type */
  modules?: Maybe<Array<ReportModuleNode>>;
  /** Product type value */
  value: Scalars['String']['output'];
};

export type ReportProgress = {
  __typename?: 'ReportProgress';
  download_url?: Maybe<Scalars['String']['output']>;
  is_async_process?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  progress: Scalars['Int']['output'];
  report_id: Scalars['String']['output'];
  status: ReportStatus;
};

export type ReportQueryV2 = {
  __typename?: 'ReportQueryV2';
  /** Retrieve a single custom report by ID. */
  get_custom_report?: Maybe<CustomReportNode>;
  /** Get the resolved detail of a custom report's configuration. All IDs in report_input_config (custom fields, area levels, routes, courses, users) are resolved to their display names. */
  get_custom_report_config_detail?: Maybe<CustomReportConfigDetailNode>;
  /** Obtiene la configuración de columnas para un tipo de reporte, con visibilidad filtrada por organización. */
  get_report_column_config: ReportColumnConfigResponse;
  /** Get active product types from report templates */
  get_report_logs: ReportLogNodeConnectionQueryValidationErrorQueryInternalError;
  /** List scheduled runs (report_logs) for a specific custom report. Returns paginated history of executions with status and timestamps. */
  get_report_logs_by_custom_report_id: ReportLogNodeConnection;
  /** Get active product types from report templates */
  get_report_product_types: ReportProductTypeListResponse;
  /** Obtiene los tipos de reporte disponibles por producto y organización */
  get_templates_reports_by_product: ReportTemplateListResponse;
  /** ANLT-535 (AC-5): resolve every course_id matching the current type + search filter, so the frontend can 'select all' the filtered set — not only the visible page. Org-scoped. */
  list_custom_report_course_ids: Array<Scalars['Int']['output']>;
  /** ANLT-535: list the courses selectable when building a custom course report. Filter by type (OWN propios / CREHANA catálogo / ALL todos), free-text name search, and offset pagination — all org-scoped. */
  list_custom_report_courses: CustomReportCourseNodeConnection;
  /** List custom reports for an organization. Optionally filter by product_type, schedule_mode, or search (case/accent-insensitive match on report name). */
  list_custom_reports: CustomReportNodeConnection;
  /** List active scheduled custom reports for an organization filtered by report_type. Creator and recipients are returned as federation user entities so the gateway can resolve name, photo, and other profile fields */
  list_custom_reports_by_report_type: CustomReportNodeConnection;
};


export type ReportQueryV2Get_Custom_ReportArgs = {
  input: AnalyticsGetCustomReportInput;
};


export type ReportQueryV2Get_Custom_Report_Config_DetailArgs = {
  input: AnalyticsGetCustomReportInput;
};


export type ReportQueryV2Get_Report_Column_ConfigArgs = {
  input: AnalyticsGetReportColumnConfigInput;
};


export type ReportQueryV2Get_Report_LogsArgs = {
  input: ReportLogsFilterInput;
};


export type ReportQueryV2Get_Report_Logs_By_Custom_Report_IdArgs = {
  input: AnalyticsListCustomReportRunsInput;
};


export type ReportQueryV2Get_Templates_Reports_By_ProductArgs = {
  input: ReportsByProductInput;
};


export type ReportQueryV2List_Custom_Report_Course_IdsArgs = {
  input: AnalyticsListCustomReportCourseIdsInput;
};


export type ReportQueryV2List_Custom_Report_CoursesArgs = {
  input: AnalyticsListCustomReportCoursesInput;
};


export type ReportQueryV2List_Custom_ReportsArgs = {
  input: AnalyticsListCustomReportsInput;
};


export type ReportQueryV2List_Custom_Reports_By_Report_TypeArgs = {
  input: AnalyticsListCustomReportsByReportTypeInput;
};

export type ReportQuizzes = {
  __typename?: 'ReportQuizzes';
  best_correct_answers: Scalars['Int']['output'];
  best_result: Scalars['Decimal']['output'];
  best_result_at: Scalars['DateTime']['output'];
  best_status: Scalars['String']['output'];
  best_total_answers: Scalars['Int']['output'];
  best_total_questions: Scalars['Int']['output'];
  best_wrong_answers: Scalars['Int']['output'];
  course_id: Scalars['ID']['output'];
  duration_seconds: Scalars['Decimal']['output'];
  enroll_id: Scalars['ID']['output'];
  enrollment_quiz_id: Scalars['ID']['output'];
  first_quiz_date: Scalars['DateTime']['output'];
  last_quiz_date: Scalars['DateTime']['output'];
  organization_id: Scalars['ID']['output'];
  quiz_attemps: Scalars['Int']['output'];
  quiz_status: Scalars['String']['output'];
  result: Scalars['Decimal']['output'];
  time_limit: Scalars['String']['output'];
  total_correct_answer: Scalars['Int']['output'];
  total_questions: Scalars['Int']['output'];
  total_wrong_answer: Scalars['Int']['output'];
  user_email: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
  user_name: Scalars['String']['output'];
};

export type ReportQuizzesConnection = {
  __typename?: 'ReportQuizzesConnection';
  /** A list of edges in this connection. */
  edges: Array<ReportQuizzesEdge>;
  /** Information to aid in pagination. */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type ReportQuizzesConnectionQueryValidationErrorQueryInternalError = QueryInternalError | QueryValidationError | ReportQuizzesConnection;

export type ReportQuizzesEdge = {
  __typename?: 'ReportQuizzesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReportQuizzes;
};

export type ReportResponse = {
  __typename?: 'ReportResponse';
  error: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  sync_report: Scalars['Boolean']['output'];
  url_report: Scalars['String']['output'];
};

export type ReportResponseAnalyticsMutationInternalError = AnalyticsMutationInternalError | ReportResponse;

export type ReportResponseReportExistsResponseAnalyticsMutationInternalError = AnalyticsMutationInternalError | ReportExistsResponse | ReportResponse;

export type ReportRoutesUsersNode = {
  __typename?: 'ReportRoutesUsersNode';
  approved_quizzes: Scalars['Int']['output'];
  courses_completed: Scalars['Int']['output'];
  progress_in_hours: Scalars['Float']['output'];
  project_certified: Scalars['Int']['output'];
  route_id: Scalars['Int']['output'];
  route_progress: Scalars['Float']['output'];
  user_id: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type ReportRoutesUsersNodeConnection = {
  __typename?: 'ReportRoutesUsersNodeConnection';
  /** Contains the nodes in this connection */
  edges: Array<ReportRoutesUsersNodeEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type ReportRoutesUsersNodeEdge = {
  __typename?: 'ReportRoutesUsersNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ReportRoutesUsersNode;
};

export type ReportSectionNode = {
  __typename?: 'ReportSectionNode';
  /** Columnas activas dentro de esta sección. */
  columns: Array<ReportColumnNode>;
  /** Descripción corta del grupo. */
  description: Scalars['String']['output'];
  /** Orden de presentación. */
  display_order: Scalars['Int']['output'];
  /** True = columnas dinámicas per-org (custom fields, area levels). */
  is_dynamic: Scalars['Boolean']['output'];
  /** Identificador de la sección. */
  key: Scalars['String']['output'];
  /** Label visible de la sección. */
  name: Scalars['String']['output'];
};

export type ReportSheetNode = {
  __typename?: 'ReportSheetNode';
  /** Orden de presentación. */
  display_order: Scalars['Int']['output'];
  /** True = el usuario puede excluir esta hoja. */
  is_optional: Scalars['Boolean']['output'];
  /** Identificador de la hoja. */
  key: Scalars['String']['output'];
  /** Nombre visible de la pestaña. */
  name: Scalars['String']['output'];
  /** Secciones con sus columnas dentro de esta hoja. */
  sections: Array<ReportSectionNode>;
};

export enum ReportStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type ReportTeamConnection = {
  __typename?: 'ReportTeamConnection';
  completed_routes_count?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection */
  edges: Array<ReportTeamNodeEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
  total_routes_count?: Maybe<Scalars['Int']['output']>;
};

export type ReportTeamInputOrderBy = {
  direction: OrderDirectionEnum;
  field: ReportTeamOrderByEnum;
};

export type ReportTeamNode = {
  __typename?: 'ReportTeamNode';
  assigned_date?: Maybe<Scalars['DateTime']['output']>;
  completed_date?: Maybe<Scalars['DateTime']['output']>;
  courses_assigned?: Maybe<Scalars['Int']['output']>;
  courses_completed?: Maybe<Scalars['Int']['output']>;
  courses_progress?: Maybe<Scalars['Int']['output']>;
  courses_required?: Maybe<Scalars['Int']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  org_id: Scalars['Int']['output'];
  route_id: Scalars['Int']['output'];
  route_name: Scalars['String']['output'];
  route_progress?: Maybe<Scalars['Int']['output']>;
  user_id: Scalars['Int']['output'];
  user_name: Scalars['String']['output'];
  user_route_id: Scalars['ID']['output'];
  user_status: Scalars['String']['output'];
};

/** An edge in a connection. */
export type ReportTeamNodeEdge = {
  __typename?: 'ReportTeamNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ReportTeamNode;
};

export enum ReportTeamOrderByEnum {
  AssignedDate = 'ASSIGNED_DATE',
  CompletedDate = 'COMPLETED_DATE',
  IsCompleted = 'IS_COMPLETED',
  RouteName = 'ROUTE_NAME',
  RouteProgress = 'ROUTE_PROGRESS'
}

export type ReportTemplateListResponse = {
  __typename?: 'ReportTemplateListResponse';
  reports: Array<ReportTemplateNode>;
  total_count: Scalars['Int']['output'];
};

export type ReportTemplateNode = {
  __typename?: 'ReportTemplateNode';
  can_create_custom_report: Scalars['Boolean']['output'];
  custom_report_description?: Maybe<Scalars['String']['output']>;
  custom_report_label?: Maybe<Scalars['String']['output']>;
  custom_report_logo?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  /** Indica si el reporte incluye información de clima */
  has_climate: Scalars['Boolean']['output'];
  /** Indica si el reporte incluye información de competencias */
  has_competences: Scalars['Boolean']['output'];
  /** Indica si el reporte incluye información de feedback */
  has_feedbacks: Scalars['Boolean']['output'];
  /** Indica si el reporte incluye información de metas */
  has_goals: Scalars['Boolean']['output'];
  /** Indica si el reporte incluye información de PID */
  has_pid: Scalars['Boolean']['output'];
  has_redirect: Scalars['Boolean']['output'];
  /** Indica si el reporte incluye información de seguimientos de meta */
  has_tracking_goals: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  /** UTC unix timestamp of the oldest MAX(loaded_at_utc) among all tables used by this report type. Represents the data freshness bottleneck — the moment the pipeline last refreshed the most-lagged table. */
  last_updated_at?: Maybe<Scalars['Int']['output']>;
  /** Human-readable time of last_updated_at localized to the requesting user's country timezone. Format: HH:MM:SS. */
  last_updated_at_formatted?: Maybe<Scalars['String']['output']>;
  mutation_schema?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  period_text: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  product_type: Scalars['String']['output'];
  redirect_url?: Maybe<Scalars['String']['output']>;
  report_type: Scalars['String']['output'];
  report_type_enum: ReportsEnum;
  structure_text: Scalars['String']['output'];
};

export enum ReportTemplateSearchFieldsEnum {
  ReportInstanceName = 'REPORT_INSTANCE_NAME',
  ReportTemplateName = 'REPORT_TEMPLATE_NAME'
}

export type ReportTemplateSearchInput = {
  fields: Array<ReportTemplateSearchFieldsEnum>;
  query: Scalars['String']['input'];
};

export type ReportType = {
  __typename?: 'ReportType';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  period: Scalars['String']['output'];
};

export type ReportsByProductInput = {
  can_create_custom_report?: InputMaybe<Scalars['Boolean']['input']>;
  flow_version?: ReportFlowVersionEnum;
  /** Performance module filter (e.g. COMPETENCIES, FEEDBACK). Only applies to product_performance. */
  module?: InputMaybe<PerformanceModuleTypeEnum>;
  organization_slug: Scalars['String']['input'];
  product_type: ProductTypeEnum;
  /** Optional free-text search over the report template name. Case-insensitive and accent-insensitive (e.g. 'Diseno' matches 'Diseño'). */
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum ReportsEnum {
  CopilotAnalyticsCustomFile = 'COPILOT_ANALYTICS_CUSTOM_FILE',
  DocumentStatusByUser = 'DOCUMENT_STATUS_BY_USER',
  DocumentStatusSummary = 'DOCUMENT_STATUS_SUMMARY',
  JobApplicantsInfoByJobVacancy = 'JOB_APPLICANTS_INFO_BY_JOB_VACANCY',
  JobApplicantInfoPdf = 'JOB_APPLICANT_INFO_PDF',
  JobVacanciesInfoByOrganization = 'JOB_VACANCIES_INFO_BY_ORGANIZATION',
  JobVacanciesMetricsInfoByVacancy = 'JOB_VACANCIES_METRICS_INFO_BY_VACANCY',
  JobVacanciesStatsInfoByOrganization = 'JOB_VACANCIES_STATS_INFO_BY_ORGANIZATION',
  PerformanceClimateModelDownload = 'PERFORMANCE_CLIMATE_MODEL_DOWNLOAD',
  PerformanceClimateParticipantStatus = 'PERFORMANCE_CLIMATE_PARTICIPANT_STATUS',
  PerformanceClimateParticipantStatusNom035 = 'PERFORMANCE_CLIMATE_PARTICIPANT_STATUS_NOM035',
  PerformanceCompetenciesActiveFilters = 'PERFORMANCE_COMPETENCIES_ACTIVE_FILTERS',
  PerformanceCompetenciesActiveFiltersSummary = 'PERFORMANCE_COMPETENCIES_ACTIVE_FILTERS_SUMMARY',
  PerformanceCompetenciesComments = 'PERFORMANCE_COMPETENCIES_COMMENTS',
  PerformanceCompetenciesEvaluationData = 'PERFORMANCE_COMPETENCIES_EVALUATION_DATA',
  PerformanceCompetenciesGeneralReport = 'PERFORMANCE_COMPETENCIES_GENERAL_REPORT',
  PerformanceCompetenciesModelByProcess = 'PERFORMANCE_COMPETENCIES_MODEL_BY_PROCESS',
  PerformanceCompetenciesParticipantsValidation = 'PERFORMANCE_COMPETENCIES_PARTICIPANTS_VALIDATION',
  PerformanceCompetenciesResponsesData = 'PERFORMANCE_COMPETENCIES_RESPONSES_DATA',
  PerformanceFeedbackFaceToFace = 'PERFORMANCE_FEEDBACK_FACE_TO_FACE',
  PerformanceFeedbackGeneralStatus = 'PERFORMANCE_FEEDBACK_GENERAL_STATUS',
  PerformanceFeedbackRegistered = 'PERFORMANCE_FEEDBACK_REGISTERED',
  PerformanceFeedbackTotal = 'PERFORMANCE_FEEDBACK_TOTAL',
  PerformanceFeedbackWritten = 'PERFORMANCE_FEEDBACK_WRITTEN',
  PerformanceGoalsEvaluatedSummary = 'PERFORMANCE_GOALS_EVALUATED_SUMMARY',
  PerformanceGoalsEvaluatedWithLimits = 'PERFORMANCE_GOALS_EVALUATED_WITH_LIMITS',
  PerformanceGoalsIndividualSummary = 'PERFORMANCE_GOALS_INDIVIDUAL_SUMMARY',
  PerformanceGoalsIndividualTracking = 'PERFORMANCE_GOALS_INDIVIDUAL_TRACKING',
  PerformanceGoalsLoadSummary = 'PERFORMANCE_GOALS_LOAD_SUMMARY',
  PerformanceGoalsManagement = 'PERFORMANCE_GOALS_MANAGEMENT',
  PerformanceGoalsStrategicSummary = 'PERFORMANCE_GOALS_STRATEGIC_SUMMARY',
  PerformanceGoalsTrackingStatus = 'PERFORMANCE_GOALS_TRACKING_STATUS',
  PerformancePidActivitiesProgressByTracks = 'PERFORMANCE_PID_ACTIVITIES_PROGRESS_BY_TRACKS',
  PerformancePidActivitiesSummary = 'PERFORMANCE_PID_ACTIVITIES_SUMMARY',
  PerformancePidActivityState = 'PERFORMANCE_PID_ACTIVITY_STATE',
  PerformancePidEmployeesWithActivities = 'PERFORMANCE_PID_EMPLOYEES_WITH_ACTIVITIES',
  PerformancePidEmployeePlan = 'PERFORMANCE_PID_EMPLOYEE_PLAN',
  PerformancePidEvaluatedActivitiesSummary = 'PERFORMANCE_PID_EVALUATED_ACTIVITIES_SUMMARY',
  PerformancePidLastActivityTracking = 'PERFORMANCE_PID_LAST_ACTIVITY_TRACKING',
  RecognitionRegistered = 'RECOGNITION_REGISTERED',
  ReportAdhocPosadasQuizAndGeneral = 'REPORT_ADHOC_POSADAS_QUIZ_AND_GENERAL',
  ReportB2BAssignmentAlerts = 'REPORT_B2B_ASSIGNMENT_ALERTS',
  ReportB2BCourses = 'REPORT_B2B_COURSES',
  ReportB2BElevateCourses = 'REPORT_B2B_ELEVATE_COURSES',
  ReportB2BGeneral = 'REPORT_B2B_GENERAL',
  ReportB2BInactivateUsers = 'REPORT_B2B_INACTIVATE_USERS',
  ReportB2BLeaders = 'REPORT_B2B_LEADERS',
  ReportB2BLiveSessions = 'REPORT_B2B_LIVE_SESSIONS',
  ReportB2BNotStudyingUsers = 'REPORT_B2B_NOT_STUDYING_USERS',
  ReportB2BPendingUsers = 'REPORT_B2B_PENDING_USERS',
  ReportB2BQuizzResponsesByClasses = 'REPORT_B2B_QUIZZ_RESPONSES_BY_CLASSES',
  ReportB2BResultQuizzByClasses = 'REPORT_B2B_RESULT_QUIZZ_BY_CLASSES',
  ReportB2BTracks = 'REPORT_B2B_TRACKS',
  ReportB2BUsers = 'REPORT_B2B_USERS',
  ReportCentralizedUsers = 'REPORT_CENTRALIZED_USERS',
  ReportGroups = 'REPORT_GROUPS',
  ReportProfileAudit = 'REPORT_PROFILE_AUDIT',
  ReportTaAttendanceMarks = 'REPORT_TA_ATTENDANCE_MARKS',
  ReportTaDailyManagement = 'REPORT_TA_DAILY_MANAGEMENT',
  ReportTaShiftsCreation = 'REPORT_TA_SHIFTS_CREATION',
  ReportTaShiftsSchedule = 'REPORT_TA_SHIFTS_SCHEDULE',
  ReportUserAdditionsRemovals = 'REPORT_USER_ADDITIONS_REMOVALS',
  ReportUserGeneral = 'REPORT_USER_GENERAL',
  TimeoffGeneralBalancePolicies = 'TIMEOFF_GENERAL_BALANCE_POLICIES',
  TimeoffPoliciesRequest = 'TIMEOFF_POLICIES_REQUEST'
}

export type ReportsSearchInput = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query: Scalars['String']['input'];
};

export enum RequestApprovalStatusEnum {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  InProgress = 'IN_PROGRESS',
  Omitted = 'OMITTED',
  Skipped = 'SKIPPED'
}

export type RequestPasswordRecoveryInput = {
  next_url?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type RequestPasswordRecoveryPayload = {
  __typename?: 'RequestPasswordRecoveryPayload';
  messages: Array<RecoverPasswordMessage>;
  success: Scalars['Boolean']['output'];
};

export enum RequestStatusEnum {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  InProgress = 'IN_PROGRESS'
}

export type RequestTimeCalculatorAffectedDay = {
  __typename?: 'RequestTimeCalculatorAffectedDay';
  /** Date evaluated in the calculator (ISO format YYYY-MM-DD) */
  date: Scalars['String']['output'];
  /** Name of the holiday if this date is a holiday, otherwise null */
  holiday_name?: Maybe<Scalars['String']['output']>;
  /** Whether this date contributes to the final result */
  is_counted: Scalars['Boolean']['output'];
  /** Whether this date is considered a holiday for the user */
  is_holiday: Scalars['Boolean']['output'];
  /** Whether this weekday is enabled in the policy */
  is_policy_day: Scalars['Boolean']['output'];
  /** Value contributed by this date in policy units */
  value: Scalars['Float']['output'];
};

export type RequestTimeCalculatorResponse = {
  __typename?: 'RequestTimeCalculatorResponse';
  /** Detailed breakdown of all dates affected by the request */
  affected_days: Array<RequestTimeCalculatorAffectedDay>;
  /** True if end_date exceeds the latest active expiration date. Null if policy is not time-expirable. */
  exceeds_expiration?: Maybe<Scalars['Boolean']['output']>;
  /** Days to consume per expiring period, ordered by nearest expiration. Null if policy is not time-expirable. */
  expiring_periods_to_consume?: Maybe<Array<TimeoffPeriodConsumption>>;
  /** True if the first day of the request falls on a holiday */
  is_first_day_holiday: Scalars['Boolean']['output'];
  /** Latest expiration date among active periods with positive balance. Null if policy is not time-expirable. */
  max_expiration_date?: Maybe<Scalars['Date']['output']>;
  /** Requested days not covered by any expirable period (overflow). Null if policy is not time-expirable. */
  regular_days_to_use?: Maybe<Scalars['Float']['output']>;
  /** Result */
  result?: Maybe<Scalars['Float']['output']>;
};

export type RequiredAttachmentDocumentInput = {
  document_id: Scalars['ID']['input'];
  external_file_id: Scalars['ID']['input'];
};

export type ResetCourseProgressBulkInput = {
  /** Course to reset for every listed collaborator */
  course_id: Scalars['Int']['input'];
  /** Organization of the collaborators */
  organization_id: Scalars['Int']['input'];
  /** Optional reason recorded on every audit row */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Collaborators whose progress is reset */
  user_ids: Array<Scalars['Int']['input']>;
};

export type ResetCourseProgressBulkPayload = {
  __typename?: 'ResetCourseProgressBulkPayload';
  course_id: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  job_id: Scalars['Int']['output'];
  organization_id: Scalars['Int']['output'];
  status: CourseProgressResetBulkJobStatus;
  total: Scalars['Int']['output'];
};

export type ResetCourseProgressBulkResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | ResetCourseProgressBulkPayload;

export type ResetCourseProgressInput = {
  /** Course to reset */
  course_id: Scalars['Int']['input'];
  /** Organization of the collaborator */
  organization_id: Scalars['Int']['input'];
  origin?: InputMaybe<CourseProgressResetOrigin>;
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Collaborator whose progress is reset */
  user_id: Scalars['Int']['input'];
};

export type ResetCourseProgressPayload = {
  __typename?: 'ResetCourseProgressPayload';
  applied: Scalars['Boolean']['output'];
  audit_log_id?: Maybe<Scalars['Int']['output']>;
  cleared_org_course: Scalars['Int']['output'];
  cleared_video_progress: Scalars['Int']['output'];
  cleared_video_progress_detail: Scalars['Int']['output'];
  course_id: Scalars['Int']['output'];
  enrollment_id: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  user_id: Scalars['Int']['output'];
};

export type ResetCourseProgressResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | ResetCourseProgressPayload;

export type ResetScormDataPayload = {
  __typename?: 'ResetScormDataPayload';
  graphql_operation_id: Scalars['ID']['output'];
  user_scorm_data: UserScormData;
};

export type ResetScormDataPayloadMutationInternalError = MutationInternalError | ResetScormDataPayload;

export type ResetUserScormDataInput = {
  scorm_version?: InputMaybe<ScormDataVersion>;
  video_lecture_id: Scalars['ID']['input'];
};

/** The four context filters translated into what list_incidences and incidence_summary actually accept. Feed these three fields straight into both queries — the same values in both, or the cards will count incidences the table does not show. */
export type ResolveIncidenceFiltersResponse = {
  __typename?: 'ResolveIncidenceFiltersResponse';
  /** Collaborators in the chosen scope. **null means do not filter by person**; an empty list means the scope contains nobody and the table must come back empty. They are different answers and both are correct — pass this value through verbatim. */
  centralized_user_ids?: Maybe<Array<Scalars['Int']['output']>>;
  graphql_operation_id: Scalars['ID']['output'];
  /** True when the scope matched more collaborators than the cap and the set was cut. The result is then **incomplete**: say so instead of showing it as final, and ask the user to narrow the filter. */
  is_truncated: Scalars['Boolean']['output'];
  /** How many collaborators the scope really matched, **before** the cap. Compare it against the length of centralized_user_ids to tell the user how much was left out. */
  matched_user_count: Scalars['Int']['output'];
  /** Echoed back unchanged: the payroll type is a column on the incidence, so it needs no resolution and travels straight to list_incidences. */
  payroll_type_ids?: Maybe<Array<Scalars['UUID']['output']>>;
  /** Start of the window, derived from the period when one was chosen. */
  start_date_from?: Maybe<Scalars['Date']['output']>;
  /** End of the window, derived from the period when one was chosen. */
  start_date_to?: Maybe<Scalars['Date']['output']>;
};

export type ResolveIncidenceFiltersResult = InternalErrorResponse | ResolveIncidenceFiltersResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type ResolvePolicyInput = {
  centralized_organization_id: Scalars['ID']['input'];
  policy_id: Scalars['ID']['input'];
};

export type ResolvePolicyResponse = {
  __typename?: 'ResolvePolicyResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type ResolveRequestStatusInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Request ID */
  request_id: Scalars['ID']['input'];
};

export type ResolveRequestStatusResponse = {
  __typename?: 'ResolveRequestStatusResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

/** Resolve a batch of emails to user ids inside an organization context. Used by subgraphs (e.g. subgraph-time bulk shift assignment) to map Excel-side identifiers to internal user ids in a single round-trip. */
export type ResolveUserIdsByEmailsInput = {
  /** Organization ID to scope the membership check against. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Emails to resolve. Case-insensitive. Duplicates and whitespace are normalized. Up to 2500 entries per request. */
  emails: Array<Scalars['String']['input']>;
  /** When False (default) only globally-active users are returned, preserving the original behaviour. When True, deactivated users are also resolved (each carrying is_active=False) so the caller can distinguish a deactivated user from a non-existent one. */
  include_inactive?: Scalars['Boolean']['input'];
};

/** Payload listing the resolved users for the input emails. */
export type ResolveUserIdsByEmailsPayload = {
  __typename?: 'ResolveUserIdsByEmailsPayload';
  /** Resolved users, one per email that matched. Emails not present globally are absent here. */
  users: Array<ResolvedUserByEmailNode>;
};

export type ResolveUserIdsByEmailsResponse = InternalErrorResponse | NotAuthenticatedErrorResponse | ResolveUserIdsByEmailsPayload | ValidationErrorResponse;

/** An area level resolved from its ID. */
export type ResolvedAreaLevelNode = {
  __typename?: 'ResolvedAreaLevelNode';
  /** Area level ID. */
  id: Scalars['Int']['output'];
  /** Position in the org hierarchy (1 = top). */
  level_sequence?: Maybe<Scalars['Int']['output']>;
  /** Area level name (custom_name if set, else name). */
  name: Scalars['String']['output'];
};

/** A static column selected for this section, resolved to key + name. */
export type ResolvedColumnNode = {
  __typename?: 'ResolvedColumnNode';
  /** Order within the section. */
  display_order: Scalars['Int']['output'];
  /** Column key (e.g. 'user_email'). */
  key: Scalars['String']['output'];
  /** Column display name. */
  name: Scalars['String']['output'];
};

/** An entity resolved from an ID (e.g. custom field, route, course). */
export type ResolvedEntityNode = {
  __typename?: 'ResolvedEntityNode';
  /** Entity ID. */
  id: Scalars['Int']['output'];
  /** Entity display name. */
  name: Scalars['String']['output'];
};

/** A user resolved from a bulk email lookup. Only users that exist globally appear; emails not matching any user are simply absent from the parent payload's ``users`` list. */
export type ResolvedUserByEmailNode = {
  __typename?: 'ResolvedUserByEmailNode';
  /** Original email as stored in the User table (preserves casing). */
  email: Scalars['String']['output'];
  /** Global User.is_active flag. Always True for the default (active-only) lookup; only meaningful when the request sets include_inactive=True, where False means the user is deactivated/eliminated globally. */
  is_active: Scalars['Boolean']['output'];
  /** True when the user has an ACTIVE or PENDING UserOrganization in the requested centralized_organization_id; False otherwise. */
  is_in_organization: Scalars['Boolean']['output'];
  /** Internal numeric user id. */
  user_id: Scalars['Int']['output'];
};

/** A centralized user resolved from its ID. */
export type ResolvedUserNode = {
  __typename?: 'ResolvedUserNode';
  /** Full name (first + last). Null if user not found. */
  full_name?: Maybe<Scalars['String']['output']>;
  /** Centralized user ID. */
  id: Scalars['Int']['output'];
};

/** Input for represent a live session External resource [Mutation] */
export type ResourceExternalInput = {
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export enum ResourceType {
  Course = 'COURSE',
  Document = 'DOCUMENT',
  LiveSession = 'LIVE_SESSION',
  Route = 'ROUTE',
  Task = 'TASK'
}

export enum ResourceTypeEnum {
  File = 'FILE',
  Url = 'URL'
}

export type Response = {
  __typename?: 'Response';
  error_message?: Maybe<Scalars['String']['output']>;
  has_error: Scalars['Boolean']['output'];
  is_success: Scalars['Boolean']['output'];
};

export type ResponseAttachment = AttachmentPayload | FeedbackResponseInternalError | FeedbackResponseValidationError;

export type ResponseCompetenceGeneralForm = CompetenceGeneralForm | CompetencesResponseInternalError | CompetencesResponseValidationError;

export type ResponseCompetenceMyTeam = CompetenceMyTeamGeneral | CompetencesResponseInternalError | CompetencesResponseValidationError;

export type ResponseCompetenceReport = CompetenceReport | CompetencesResponseInternalError | CompetencesResponseValidationError;

export type ResponseCompetenceStatMyTeam = CompetenceMyTeamStat | CompetencesResponseInternalError | CompetencesResponseValidationError;

export type ResponseCompetencesConfiguration = CompetencesEvaluationConfiguration | CompetencesResponseInternalError | CompetencesResponseValidationError;

export type ResponseCompetencesEmployee = CompetencesEmployeeTalentPagination | CompetencesResponseInternalError | CompetencesResponseValidationError;

/**  UNIONS */
export type ResponseCompetencesEvaluation = CompetencesGeneralEvaluationPagination | CompetencesResponseInternalError | CompetencesResponseValidationError;

export type ResponseCompetencesLabelByEvaluation = CompetencesLabelSummary | CompetencesResponseInternalError | CompetencesResponseValidationError;

export type ResponseConfiguration = FeedbackProcessPayload | FeedbackResponseInternalError | FeedbackResponseValidationError;

export type ResponseDashboard = FeedbackDashboardAdminResume | FeedbackResponseInternalError | FeedbackResponseValidationError;

export type ResponseEmployee = DataModelListPayload | FeedbackResponseInternalError | FeedbackResponseValidationError;

export type ResponseExecutedPayload = {
  __typename?: 'ResponseExecutedPayload';
  executed?: Maybe<Scalars['Boolean']['output']>;
};

export type ResponseExecutionCompetences = CompetencesResponseInternalError | CompetencesResponseValidationError | ExecutedCompetencesPayload;

export type ResponseExecutionFeedback = FeedbackResponseInternalError | FeedbackResponseValidationError | ResponseExecutedPayload;

/** Deprecated */
export type ResponseExecutionTalentRecognition = ExecutedTalentRecognitionPayload | TalentRecognitionResponseInternalError | TalentRecognitionResponseValidationError;

export type ResponseFeedback = FeedbackGeneralPaginationPayload | FeedbackResponseInternalError | FeedbackResponseValidationError;

export type ResponseFeedbackUser = FeedbackResponseInternalError | FeedbackResponseValidationError | FeedbackUserPaginationPayload;

/** Legacy error type - prefer IntegrityErrorV2 */
export type ResponseIntegrityError = {
  __typename?: 'ResponseIntegrityError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Legacy error type - prefer InternalErrorV2 */
export type ResponseInternalError = {
  __typename?: 'ResponseInternalError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ResponseLabel = LabelTalentResponse | TalentResponseInternalError | TalentResponseValidationError;

export type ResponseModule = FeedbackResponseInternalError | FeedbackResponseValidationError | LabelModule;

export type ResponseMyTeam = DataModelPayload | FeedbackResponseInternalError | FeedbackResponseValidationError | MyTeamResume;

export type ResponseNode = {
  __typename?: 'ResponseNode';
  code: Scalars['Int']['output'];
  extra?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ResponseNodeExtra = {
  __typename?: 'ResponseNodeExtra';
  code: Scalars['Int']['output'];
  extra?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ResponsePerception = FeedbackResponseInternalError | FeedbackResponseValidationError | PerceptionFeedback;

export type ResponseQualifySummary = CompetencesResponseInternalError | CompetencesResponseValidationError | QualifySummary;

export type ResponseQuestionnaire = CompetencesResponseInternalError | CompetencesResponseValidationError | QuestionnaireGeneralPagination;

export type ResponseQuestionnaireDetail = CompetencesDetail | CompetencesResponseInternalError | CompetencesResponseValidationError;

export type ResponseQuestionnaireQualify = CompetencesResponseInternalError | CompetencesResponseValidationError | QualifyPayload;

export type ResponseQuestionnairesGrade = CompetencesResponseInternalError | CompetencesResponseValidationError | QuestionnaireGradeSummary;

/** Response scale configuration (eNPS only). */
export type ResponseScaleInput = {
  /** Label for the high end of the scale. */
  end_label: Scalars['String']['input'];
  /** Maximum scale value. */
  max: Scalars['Int']['input'];
  /** Label for the midpoint of the scale. */
  mid_label: Scalars['String']['input'];
  /** Minimum scale value. */
  min: Scalars['Int']['input'];
  /** Label for the low end of the scale. */
  start_label: Scalars['String']['input'];
};

export type ResponseTemplate = FeedbackResponseInternalError | FeedbackResponseValidationError | FeedbackTemplateGeneralPaginationPayload | FeedbackTemplatePayload;

export type ResponseUrlPresignedS3 = FeedbackResponseInternalError | FeedbackResponseValidationError | UrlPresignedS3Payload;

/** Legacy error type - prefer ValidationErrorV2 */
export type ResponseValidationError = {
  __typename?: 'ResponseValidationError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type RestoreBulkImportInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['ID']['input'];
  /** Import batch UUID */
  import_batch_id: Scalars['ID']['input'];
  /** Policy ID */
  policy_id: Scalars['ID']['input'];
};

export type RestoreBulkImportPayload = {
  __typename?: 'RestoreBulkImportPayload';
  import_batch_id: Scalars['String']['output'];
};

export type RestoreBulkImportPreview = {
  __typename?: 'RestoreBulkImportPreview';
  affected_employees: Scalars['Int']['output'];
  approved_requests_to_cancel: Scalars['Int']['output'];
  in_progress_requests_affected: Scalars['Int']['output'];
};

export type RestoreBulkImportPreviewInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['ID']['input'];
  /** Import batch UUID */
  import_batch_id: Scalars['ID']['input'];
  /** Policy ID */
  policy_id: Scalars['ID']['input'];
};

export type RestoreBulkImportPreviewResult = ForbiddenErrorResponse | InternalErrorResponse | RestoreBulkImportPreview | ValidationErrorResponse;

export type RestoreBulkImportResult = ForbiddenErrorResponse | InternalErrorResponse | RestoreBulkImportPayload | ValidationErrorResponse;

export type RestrictCategoryInput = {
  category_id: Scalars['ID']['input'];
  custom_field_option_ids: Array<Scalars['ID']['input']>;
  operator: B2BCustomFieldSearchOperatorEnum;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type RetrieveOrganizationTeamsByMemberInput = {
  centralized_organization_id: Scalars['Int']['input'];
  order_by?: InputMaybe<GenericOrderByEnum>;
  role_type?: InputMaybe<TeamRoleTypeEnum>;
  search_by_member_name?: InputMaybe<Scalars['String']['input']>;
  search_by_team_name?: InputMaybe<Scalars['String']['input']>;
};

export type RetrieveOrganizationTeamsInput = {
  centralized_organization_id: Scalars['Int']['input'];
  order_by?: InputMaybe<GenericOrderByEnum>;
  search_by_team_name?: InputMaybe<Scalars['String']['input']>;
};

export type RetrieveTeamMembersInput = {
  centralized_organization_id: Scalars['Int']['input'];
  order_by?: InputMaybe<GenericOrderByEnum>;
  organization_team_id: Scalars['Int']['input'];
  role_type?: InputMaybe<OrganizationTeamRole>;
  search_by_user_name?: InputMaybe<Scalars['String']['input']>;
};

export type RetryChatMessageInput = {
  chat_conversation_id: Scalars['ID']['input'];
  chat_message_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Vuelve a registrar ante Terra IDSE el certificado que el registro patronal ya tiene guardado. Los archivos y la contrasena se leen de donde estan custodiados: no hay que volver a subirlos. */
export type RetryTerraIdseCertificateRegistrationInput = {
  /** Organizacion a la que pertenece el registro patronal. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Registro patronal cuyo certificado se vuelve a registrar. */
  employer_registration_id: Scalars['ID']['input'];
};

export type RetryTerraIdseCertificateRegistrationResult = InternalErrorResponse | TerraIdseCertificateRegistrationResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Vuelve a solicitar el alta del usuario de servicio de Terra IDSE de un registro patronal que quedo sin identificador. Si ya tiene uno, no se pide otro: el proveedor no permite borrar usuarios, asi que un alta de mas quedaria para siempre. */
export type RetryTerraIdseUserRegistrationInput = {
  /** Organizacion a la que pertenece el registro patronal. */
  centralized_organization_id: Scalars['ID']['input'];
  /** Registro patronal cuyo usuario de conexion se solicita. */
  employer_registration_id: Scalars['ID']['input'];
};

export type RetryTerraIdseUserRegistrationResult = InternalErrorResponse | TerraIdseUserRegistrationResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type RevokeCopilotPlannerReportAccessInput = {
  /** centralized_user_id a quitar: el mismo que devuelve get_copilot_planner_report_accesses (numérico, expuesto como ID). Mapea al segmento {user_id} del DELETE del planner. No puede ser el owner. */
  centralized_user_id: Scalars['ID']['input'];
  /** UUID del reporte del Planner Agent. */
  report_id: Scalars['ID']['input'];
};

export type RevokeCopilotPlannerReportAccessResult = CopilotPlannerReportAccessRevokedPayload | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type RewardConnection = {
  __typename?: 'RewardConnection';
  /** Contains the nodes in this connection */
  edges: Array<RewardNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum RewardEnum {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

/** Reward fields enum to order queryset */
export enum RewardFieldsEnum {
  CreatedAt = 'CREATED_AT',
  Id = 'ID'
}

export type RewardFragmentConnection = {
  __typename?: 'RewardFragmentConnection';
  /** Contains the nodes in this connection */
  edges: Array<AdminRewardNodeEdgeUserRewardNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type RewardFragmentNode = AdminRewardNode | ResponseIntegrityError | ResponseInternalError | ResponseValidationError | UserRewardNode;

/** This input is the object that receives the values to be inserted into the database for the Reward model. */
export type RewardMutationCreateInput = {
  activation_date?: InputMaybe<Scalars['DateTime']['input']>;
  cover_attachment_id?: InputMaybe<Scalars['Int']['input']>;
  currency_point_value?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  money_value?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  organization_id: Scalars['String']['input'];
  redemptions_allowed?: InputMaybe<Scalars['Int']['input']>;
  reward_tags?: Array<RewardTagInput>;
  status: RewardStatusEnum;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RewardMutationDeleteInput = {
  organization_id: Scalars['String']['input'];
  reward_id: Scalars['String']['input'];
};

/** This input is the object that receives the values to be inserted into the database for the Reward model. */
export type RewardMutationEditInput = {
  activation_date?: InputMaybe<Scalars['DateTime']['input']>;
  cover_attachment_id?: InputMaybe<Scalars['Int']['input']>;
  currency_point_value?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  money_value?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  organization_id: Scalars['String']['input'];
  redemptions_allowed?: InputMaybe<Scalars['Int']['input']>;
  reward_id: Scalars['String']['input'];
  reward_tags?: Array<RewardTagInput>;
  status?: InputMaybe<RewardStatusEnum>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RewardMutationNode = {
  __typename?: 'RewardMutationNode';
  /**
   * This object contains information about the response code,
   *         response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Contains an instance of the Reward model */
  reward?: Maybe<RewardNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RewardNode = {
  __typename?: 'RewardNode';
  activation_date?: Maybe<Scalars['DateTime']['output']>;
  can_be_deleted?: Maybe<Scalars['Boolean']['output']>;
  can_redeemed_this_reward?: Maybe<Scalars['Boolean']['output']>;
  /** Reward cover */
  cover_attachment?: Maybe<ImageNode>;
  created_by_id?: Maybe<Scalars['Int']['output']>;
  /** Related Currency point */
  currency_point: CurrencyPointNode;
  currency_point_id?: Maybe<Scalars['Int']['output']>;
  currency_point_value?: Maybe<Scalars['Float']['output']>;
  deactivation_date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_redeemable?: Maybe<Scalars['Boolean']['output']>;
  money_value?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['ID']['output']>;
  quantity_available?: Maybe<Scalars['Float']['output']>;
  quantity_reserved?: Maybe<Scalars['Float']['output']>;
  redemptions_allowed?: Maybe<Scalars['Int']['output']>;
  redemptions_available?: Maybe<Scalars['Int']['output']>;
  status_enum?: Maybe<RewardStatusEnum>;
};

export type RewardNodeEdge = {
  __typename?: 'RewardNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: RewardNode;
};

export type RewardOrderByInput = {
  direction: OrderDirectionEnum;
  field: RewardEnum;
};

export type RewardOrganizationTransactionsQueryInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['ID']['input']>;
  panel_admin?: InputMaybe<Scalars['Boolean']['input']>;
  transaction_status_enum?: InputMaybe<TransactionStatusEnum>;
  transaction_type_enum?: InputMaybe<TransactionTypeEnum>;
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RewardQueryInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  currency_point_id?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RewardQueryOrderByInput>>;
  organization_id?: InputMaybe<Scalars['ID']['input']>;
  panel_admin?: InputMaybe<Scalars['Boolean']['input']>;
  reward_name?: InputMaybe<Scalars['String']['input']>;
  reward_tags?: InputMaybe<Array<RewardTagFilterInput>>;
  status_enum?: InputMaybe<RewardStatusEnum>;
  transaction_created_by?: InputMaybe<Scalars['ID']['input']>;
};

export type RewardQueryOrderByInput = {
  direction: OrderDirectionEnum;
  field: RewardFieldsEnum;
};

export type RewardRedemptionAllowedInput = {
  organization_id?: InputMaybe<Scalars['ID']['input']>;
  panel_admin?: InputMaybe<Scalars['Boolean']['input']>;
  reward_id: Scalars['String']['input'];
};

export enum RewardStatusEnum {
  StatusActive = 'STATUS_ACTIVE',
  StatusDraft = 'STATUS_DRAFT',
  StatusExpired = 'STATUS_EXPIRED',
  StatusInactive = 'STATUS_INACTIVE'
}

export type RewardTagFilterInput = {
  tag: Scalars['String']['input'];
  tag_id: Scalars['ID']['input'];
};

export type RewardTagInput = {
  id: Scalars['ID']['input'];
  is_active: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type RewardTagNode = {
  __typename?: 'RewardTagNode';
  is_active: Scalars['Boolean']['output'];
  tag?: Maybe<Scalars['String']['output']>;
  tag_id?: Maybe<Scalars['String']['output']>;
};

/** This input allows generating a bulk approval transaction by the organization administrator */
export type RewardTransactionBulkCreateInput = {
  organization_id: Scalars['String']['input'];
  transactions_ids: Array<Scalars['String']['input']>;
};

export type RewardTransactionConnection = {
  __typename?: 'RewardTransactionConnection';
  /** Contains the nodes in this connection */
  edges: Array<RewardTransactionNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

/** This input receives the input data to perform different types of transactions on a reward in combination with the statuses */
export type RewardTransactionCreateInput = {
  organization_id: Scalars['String']['input'];
  panel_admin: Scalars['Boolean']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  related_transaction_id?: InputMaybe<Scalars['String']['input']>;
  reward_id: Scalars['String']['input'];
  transaction_status: TransactionStatusEnum;
  transaction_type: TransactionTypeEnum;
};

export type RewardTransactionFragmentConnection = {
  __typename?: 'RewardTransactionFragmentConnection';
  /** Contains the nodes in this connection */
  edges: Array<StandartRewardTransactionNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type RewardTransactionFragmentNode = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | StandartRewardTransactionNode;

export type RewardTransactionMutationNode = {
  __typename?: 'RewardTransactionMutationNode';
  /**
   * This object contains information about the response code,
   *         response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Contains an instance of the RewardTransaction model */
  reward_transaction?: Maybe<RewardTransactionNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RewardTransactionNode = {
  __typename?: 'RewardTransactionNode';
  created_at: Scalars['DateTime']['output'];
  created_by_id: Scalars['Int']['output'];
  currency_points_exchanged?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  related_transaction_id?: Maybe<Scalars['ID']['output']>;
  reward: RewardNode;
  transaction_status_enum: TransactionStatusEnum;
  transaction_type_enum: TransactionTypeEnum;
};

export type RewardTransactionNodeEdge = {
  __typename?: 'RewardTransactionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: RewardTransactionNode;
};

export type RewardTransactionQueryInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  created_after?: InputMaybe<Scalars['DateTime']['input']>;
  created_before?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['ID']['input']>;
  panel_admin?: InputMaybe<Scalars['Boolean']['input']>;
  reward_id: Scalars['ID']['input'];
  transaction_id?: InputMaybe<Scalars['ID']['input']>;
  transaction_status_enum?: InputMaybe<TransactionStatusEnum>;
  transaction_type_enum?: InputMaybe<TransactionTypeEnum>;
};

export type Rewards = {
  __typename?: 'Rewards';
  /** The Organization Reward Transactions resource provides an overview of all the transactions made for the available rewards within the organization. It serves as a centralized dashboard displaying the transaction history for each reward, including information such as transaction dates, amounts, associated users, and any additional notes or comments. This resource allows the organization to effectively monitor and manage the transaction activities related to its reward system. */
  organization_transactions: OrganizationTransactionFragmentConnection;
  /** The Reward Transactions resource displays the transaction history associated with rewards. It provides a comprehensive record of all transactions related to rewards, including the details of each transaction and the parties involved. */
  reward_transactions: RewardTransactionFragmentConnection;
  /** This resource displays the associated rewards for the currency point. It supports fragments for standard users, admin users, and staff users. */
  rewards: RewardFragmentConnection;
  /** The Reward Transactions resource focuses on the transaction history of a specific user for a particular reward. It allows users to view and track their individual transaction records related to a specific reward, including details such as transaction dates, amounts, and any relevant notes or comments. */
  user_reward_transactions: OrganizationTransactionFragmentConnection;
};


export type RewardsOrganization_TransactionsArgs = {
  query_variables: RewardOrganizationTransactionsQueryInput;
};


export type RewardsReward_TransactionsArgs = {
  query_variables: RewardTransactionQueryInput;
};


export type RewardsRewardsArgs = {
  query_variables: RewardQueryInput;
};


export type RewardsUser_Reward_TransactionsArgs = {
  query_variables: RewardOrganizationTransactionsQueryInput;
};

export type RiskClassDefaultItem = {
  __typename?: 'RiskClassDefaultItem';
  class_code: Scalars['String']['output'];
  class_name: Scalars['String']['output'];
  default_premium: Scalars['Decimal']['output'];
};

export type RiskClassDefaultsResponse = {
  __typename?: 'RiskClassDefaultsResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<RiskClassDefaultItem>;
};

export type RiskClassListResponse = {
  __typename?: 'RiskClassListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<RiskClassType>;
};

export type RiskClassResponse = {
  __typename?: 'RiskClassResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: RiskClassType;
};

export type RiskClassType = {
  __typename?: 'RiskClassType';
  class_code: Scalars['String']['output'];
  class_name: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export enum RoleEnum {
  Admin = 'ADMIN',
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER',
  MultAdmin = 'MULT_ADMIN',
  Reader = 'READER',
  Root = 'ROOT'
}

export type RotateClientSecretInput = {
  client_id: Scalars['String']['input'];
};

export type RotateClientSecretPayload = {
  __typename?: 'RotateClientSecretPayload';
  client_id: Scalars['String']['output'];
  client_secret: Scalars['String']['output'];
};

export type RotateClientSecretPayloadValidationMutationErrorInternalServerMutationError = InternalServerMutationError | RotateClientSecretPayload | ValidationMutationError;

/** Aggregated statistics for a route */
export type RouteCompletedStatisticsNode = {
  __typename?: 'RouteCompletedStatisticsNode';
  certified_courses_count: Scalars['Int']['output'];
  completed_courses_count: Scalars['Int']['output'];
  completed_users_count: Scalars['Int']['output'];
  last_updated_at_formatted: Scalars['String']['output'];
  rewards_claimed_count: Scalars['Int']['output'];
  rewards_total_count: Scalars['Int']['output'];
  started_users_count: Scalars['Int']['output'];
  total_study_hours: Scalars['Float']['output'];
  total_users_count: Scalars['Int']['output'];
};

export type RouteCourseStatisticConnection = {
  __typename?: 'RouteCourseStatisticConnection';
  /** Contains the nodes in this connection */
  edges: Array<RouteCourseStatisticNodeEdge>;
  last_updated_at_formatted?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type RouteCourseStatisticNode = {
  __typename?: 'RouteCourseStatisticNode';
  assigned_at?: Maybe<Scalars['DateTime']['output']>;
  avg_progress: Scalars['Float']['output'];
  certified_users: Scalars['Int']['output'];
  completed_users: Scalars['Int']['output'];
  course_analytics?: Maybe<CourseAnalytics>;
  course_id: Scalars['Int']['output'];
  course_name: Scalars['String']['output'];
  is_crehana: Scalars['Boolean']['output'];
  total_progress_hours: Scalars['Float']['output'];
  total_progress_hours_formatted: Scalars['String']['output'];
};

/** An edge in a connection. */
export type RouteCourseStatisticNodeEdge = {
  __typename?: 'RouteCourseStatisticNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: RouteCourseStatisticNode;
};

export type RouteCoursesStatisticsInputOrderBy = {
  direction: OrderDirectionEnum;
  field: RouteCoursesStatisticsOrderByEnum;
};

export enum RouteCoursesStatisticsOrderByEnum {
  AvgProgress = 'AVG_PROGRESS',
  CertifiedUsers = 'CERTIFIED_USERS',
  CompletedUsers = 'COMPLETED_USERS',
  CourseName = 'COURSE_NAME',
  TotalProgressHours = 'TOTAL_PROGRESS_HOURS'
}

export enum RouteUserFilterEnum {
  TrackCompleted = 'TRACK_COMPLETED',
  TrackInProgress = 'TRACK_IN_PROGRESS'
}

export type RouteUserStatisticConnection = {
  __typename?: 'RouteUserStatisticConnection';
  /** Contains the nodes in this connection */
  edges: Array<RouteUserStatisticNodeEdge>;
  last_updated_at_formatted?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type RouteUserStatisticNode = {
  __typename?: 'RouteUserStatisticNode';
  assigned_date?: Maybe<Scalars['DateTime']['output']>;
  completed_date?: Maybe<Scalars['DateTime']['output']>;
  completed_quiz_count: Scalars['Int']['output'];
  courses_assigned: Scalars['Int']['output'];
  courses_certified: Scalars['Int']['output'];
  courses_completed: Scalars['Int']['output'];
  courses_required: Scalars['Int']['output'];
  end_date?: Maybe<Scalars['DateTime']['output']>;
  is_admin_assigned: Scalars['Boolean']['output'];
  is_completed: Scalars['Boolean']['output'];
  org_id: Scalars['Int']['output'];
  progress_in_hours: Scalars['Int']['output'];
  progress_in_hours_formatted: Scalars['String']['output'];
  route_id: Scalars['Int']['output'];
  route_name: Scalars['String']['output'];
  route_progress: Scalars['Int']['output'];
  total_progress_hours: Scalars['Float']['output'];
  user_analytics?: Maybe<MetricsUser>;
  user_id: Scalars['Int']['output'];
  user_name: Scalars['String']['output'];
};

/** An edge in a connection. */
export type RouteUserStatisticNodeEdge = {
  __typename?: 'RouteUserStatisticNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: RouteUserStatisticNode;
};

export type RouteUserStatisticsFilterInput = {
  role?: InputMaybe<UserRoleFilterEnum>;
  track?: InputMaybe<Array<RouteUserFilterEnum>>;
};

export type RouteUserStatisticsInputOrderBy = {
  direction: OrderDirectionEnum;
  field: RouteUserStatisticsOrderByEnum;
};

export enum RouteUserStatisticsOrderByEnum {
  CoursesCompleted = 'COURSES_COMPLETED',
  IsCompleted = 'IS_COMPLETED',
  ProgressHours = 'PROGRESS_HOURS',
  RouteProgress = 'ROUTE_PROGRESS',
  UserName = 'USER_NAME'
}

export type RoutesMetricsQuery = {
  __typename?: 'RoutesMetricsQuery';
  report_routes_users: ReportRoutesUsersNodeConnection;
  routes_stats_general?: Maybe<RoutesStatsGeneralNode>;
};


export type RoutesMetricsQueryReport_Routes_UsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  route_id: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};


export type RoutesMetricsQueryRoutes_Stats_GeneralArgs = {
  route_id: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};

export type RoutesStatsGeneralNode = {
  __typename?: 'RoutesStatsGeneralNode';
  certificate_project: Scalars['Int']['output'];
  completed_course: Scalars['Int']['output'];
  completed_route: Scalars['Int']['output'];
  route_id: Scalars['Int']['output'];
  started_course: Scalars['Int']['output'];
  started_project: Scalars['Int']['output'];
  total_users: Scalars['Int']['output'];
  users_pending: MetricsUserConnection;
};


export type RoutesStatsGeneralNodeUsers_PendingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type RunCertificateExpirationJobInput = {
  /** Page size for the keyset-paged candidate read. Independent of the volume-alert threshold. */
  batch_size?: Scalars['Int']['input'];
  /** When true, returns the counts the run would have applied without writing any status, stamp, or push. */
  dry_run?: Scalars['Boolean']['input'];
  /** Restrict processing to this organization. Omitted (null) processes every organization -- the shape the daily cron always uses. */
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type RunCertificateExpirationJobPayload = {
  __typename?: 'RunCertificateExpirationJobPayload';
  /** Wall-clock duration of the run, in milliseconds. */
  duration_ms: Scalars['Int']['output'];
  /** Per-row processing failures, for example a push publish failure. Never represents a whole-run failure -- that surfaces through the GraphQL top-level errors array instead. */
  errors: Scalars['Int']['output'];
  /** Whether ENABLE_CERTIFICATE_EXPIRATION was true for this run. */
  feature_enabled: Scalars['Boolean']['output'];
  /** Rows whose status was written as EXPIRED. */
  marked_expired: Scalars['Int']['output'];
  /** Rows whose status was written as EXPIRING_SOON. */
  marked_expiring_soon: Scalars['Int']['output'];
  /** Number of candidate pages this run actually fetched and processed. */
  pages: Scalars['Int']['output'];
  /** Every candidate row read from a page, regardless of outcome. */
  processed: Scalars['Int']['output'];
  /** Always 0 in this change -- reserved for CELC-5083's reassignment counter. */
  reassigned: Scalars['Int']['output'];
  /** Retries whose push succeeded: a row already at its target status, whose previous push failed and whose stamp was cleared, resent without a new status transition. Never inflates marked_expiring_soon/marked_expired. */
  renotified: Scalars['Int']['output'];
  /** Opaque correlation id for this run, generated even when the feature flag is off. */
  run_id: Scalars['String']['output'];
  /** Rows read but not transitioned: no policy row, an ineligible course, or already at their correct target status. */
  skipped: Scalars['Int']['output'];
  /** Rows that did transition (or were retried) but whose push was never attempted -- notify_push=false in the course's policy, or the collaborator's organization membership is no longer active. Distinct from skipped: the row's status write still happened. */
  suppressed: Scalars['Int']['output'];
  /** True when the run stopped because it reached MAX_PAGES_PER_RUN with candidates still left unprocessed, rather than because candidates were exhausted. A truncated run is not a failure -- the untouched rows remain candidates for the next run. */
  truncated: Scalars['Boolean']['output'];
};

export type S3PreSignedPayload = {
  __typename?: 'S3PreSignedPayload';
  file_id: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  pre_signed_url: Scalars['String']['output'];
};

export type S3PresignDataFields = {
  __typename?: 'S3PresignDataFields';
  data_s3: Scalars['JSON']['output'];
  file_id?: Maybe<Scalars['Int']['output']>;
};

export type SnsEventAttributes = {
  message_attributes?: InputMaybe<Scalars['JSON']['input']>;
  message_body: Scalars['JSON']['input'];
  tag_name: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};

export type SnsPublisherMutation = {
  __typename?: 'SNSPublisherMutation';
  send_sns_message: EventResponse;
};


export type SnsPublisherMutationSend_Sns_MessageArgs = {
  inputs: SnsEventAttributes;
};

export type SqsEventAttributes = {
  delay?: InputMaybe<Scalars['Int']['input']>;
  message_attributes?: InputMaybe<Scalars['JSON']['input']>;
  message_body: Scalars['JSON']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  queue: Scalars['String']['input'];
  tag_name: Scalars['String']['input'];
};

export type SqsPublisherMutation = {
  __typename?: 'SQSPublisherMutation';
  send_message: EventResponse;
  send_message_fifo: EventResponse;
};


export type SqsPublisherMutationSend_MessageArgs = {
  inputs: SqsEventAttributes;
};


export type SqsPublisherMutationSend_Message_FifoArgs = {
  inputs: SqsEventAttributes;
};

export type SalaryZoneListResponse = {
  __typename?: 'SalaryZoneListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<SalaryZoneType>;
};

export type SalaryZoneResponse = {
  __typename?: 'SalaryZoneResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: SalaryZoneType;
};

export type SalaryZoneType = {
  __typename?: 'SalaryZoneType';
  code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type Saml2AssertionPayload = {
  __typename?: 'Saml2AssertionPayload';
  acs_url: Scalars['String']['output'];
  assertion_id: Scalars['String']['output'];
  centralized_organization_id: Scalars['ID']['output'];
  relay_state?: Maybe<Scalars['String']['output']>;
  saml_response_b64: Scalars['String']['output'];
  sp_entity_id: Scalars['String']['output'];
};

export type Saml2AssertionPayloadValidationMutationErrorInternalServerMutationError = InternalServerMutationError | Saml2AssertionPayload | ValidationMutationError;

export type Saml2AuthnRequestPayload = {
  __typename?: 'Saml2AuthnRequestPayload';
  acs_url: Scalars['String']['output'];
  authn_request_id: Scalars['String']['output'];
  name_id_format: Scalars['String']['output'];
  relay_state?: Maybe<Scalars['String']['output']>;
  sp_entity_id: Scalars['String']['output'];
};

export type Saml2AuthnRequestPayloadValidationMutationErrorInternalServerMutationError = InternalServerMutationError | Saml2AuthnRequestPayload | ValidationMutationError;

export type Saml2ClaimPayload = {
  __typename?: 'Saml2ClaimPayload';
  attribute_name: Scalars['String']['output'];
  attribute_value_source: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_required: Scalars['Boolean']['output'];
  saml2_idp_configuration_id: Scalars['ID']['output'];
  updated_at: Scalars['String']['output'];
};

export type Saml2ClaimPayloadValidationMutationErrorInternalServerMutationError = InternalServerMutationError | Saml2ClaimPayload | ValidationMutationError;

export type Saml2ClaimsPayload = {
  __typename?: 'Saml2ClaimsPayload';
  centralized_organization_id: Scalars['ID']['output'];
  claims: Array<Saml2ClaimPayload>;
};

export type Saml2ClaimsPayloadQueryValidationErrorQueryInternalServerError = QueryInternalServerError | QueryValidationError | Saml2ClaimsPayload;

export type Saml2IdpConfigurationPayload = {
  __typename?: 'Saml2IdpConfigurationPayload';
  centralized_organization_id: Scalars['ID']['output'];
  certificate: Scalars['String']['output'];
  certificate_expires_at: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  entity_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name_id_format: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};

export type Saml2IdpConfigurationPayloadQueryValidationErrorQueryInternalServerError = QueryInternalServerError | QueryValidationError | Saml2IdpConfigurationPayload;

export type Saml2IdpConfigurationPayloadValidationMutationErrorInternalServerMutationError = InternalServerMutationError | Saml2IdpConfigurationPayload | ValidationMutationError;

export type Saml2IdpMetadataPayload = {
  __typename?: 'Saml2IdpMetadataPayload';
  centralized_organization_id: Scalars['ID']['output'];
  entity_id: Scalars['String']['output'];
  metadata_xml: Scalars['String']['output'];
};

export type Saml2IdpMetadataPayloadQueryValidationErrorQueryInternalServerError = QueryInternalServerError | QueryValidationError | Saml2IdpMetadataPayload;

export type Saml2ServiceProviderPayload = {
  __typename?: 'Saml2ServiceProviderPayload';
  acs_url: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  entity_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name_id_format: Scalars['String']['output'];
  name_id_source?: Maybe<Scalars['String']['output']>;
  saml2_idp_configuration_id: Scalars['ID']['output'];
  slo_url?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['String']['output'];
};

export type Saml2ServiceProviderPayloadValidationMutationErrorInternalServerMutationError = InternalServerMutationError | Saml2ServiceProviderPayload | ValidationMutationError;

export type Saml2ServiceProvidersPayload = {
  __typename?: 'Saml2ServiceProvidersPayload';
  centralized_organization_id: Scalars['ID']['output'];
  service_providers: Array<Saml2ServiceProviderPayload>;
};

export type Saml2ServiceProvidersPayloadQueryValidationErrorQueryInternalServerError = QueryInternalServerError | QueryValidationError | Saml2ServiceProvidersPayload;

export type Saml2SpAttributePayload = {
  __typename?: 'Saml2SpAttributePayload';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Saml2SpAuthnRequestPayload = {
  __typename?: 'Saml2SpAuthnRequestPayload';
  authn_request_id: Scalars['String']['output'];
  binding: Scalars['String']['output'];
  idp_entity_id: Scalars['String']['output'];
  idp_sso_url: Scalars['String']['output'];
  redirect_url?: Maybe<Scalars['String']['output']>;
  relay_state?: Maybe<Scalars['String']['output']>;
  saml_request_b64: Scalars['String']['output'];
};

export type Saml2SpAuthnRequestPayloadValidationMutationErrorInternalServerMutationError = InternalServerMutationError | Saml2SpAuthnRequestPayload | ValidationMutationError;

export type Saml2SpConfigurationPayload = {
  __typename?: 'Saml2SpConfigurationPayload';
  acs_url: Scalars['String']['output'];
  centralized_organization_id: Scalars['ID']['output'];
  certificate?: Maybe<Scalars['String']['output']>;
  certificate_expires_at?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  entity_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name_id_format: Scalars['String']['output'];
  sign_requests: Scalars['Boolean']['output'];
  slo_url?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['String']['output'];
};

export type Saml2SpConfigurationPayloadQueryValidationErrorQueryInternalServerError = QueryInternalServerError | QueryValidationError | Saml2SpConfigurationPayload;

export type Saml2SpConfigurationPayloadValidationMutationErrorInternalServerMutationError = InternalServerMutationError | Saml2SpConfigurationPayload | ValidationMutationError;

export type Saml2SpMetadataPayload = {
  __typename?: 'Saml2SpMetadataPayload';
  centralized_organization_id: Scalars['ID']['output'];
  entity_id: Scalars['String']['output'];
  metadata_xml: Scalars['String']['output'];
};

export type Saml2SpMetadataPayloadQueryValidationErrorQueryInternalServerError = QueryInternalServerError | QueryValidationError | Saml2SpMetadataPayload;

export type Saml2SpProcessedResponsePayload = {
  __typename?: 'Saml2SpProcessedResponsePayload';
  attributes: Array<Saml2SpAttributePayload>;
  centralized_organization_id: Scalars['ID']['output'];
  idp_entity_id: Scalars['String']['output'];
  name_id: Scalars['String']['output'];
  name_id_format: Scalars['String']['output'];
  relay_state?: Maybe<Scalars['String']['output']>;
  session_index?: Maybe<Scalars['String']['output']>;
};

export type Saml2SpProcessedResponsePayloadValidationMutationErrorInternalServerMutationError = InternalServerMutationError | Saml2SpProcessedResponsePayload | ValidationMutationError;

export type Saml2SpSsoUrlPayload = {
  __typename?: 'Saml2SpSsoUrlPayload';
  authn_request_id: Scalars['String']['output'];
  idp_entity_id: Scalars['String']['output'];
  idp_sso_url: Scalars['String']['output'];
  redirect_url: Scalars['String']['output'];
};

export type Saml2SpSsoUrlPayloadQueryValidationErrorQueryInternalServerError = QueryInternalServerError | QueryValidationError | Saml2SpSsoUrlPayload;

export type Saml2TrustedIdpPayload = {
  __typename?: 'Saml2TrustedIdpPayload';
  created_at: Scalars['String']['output'];
  entity_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name_id_format: Scalars['String']['output'];
  saml2_sp_configuration_id: Scalars['ID']['output'];
  slo_url?: Maybe<Scalars['String']['output']>;
  sso_url: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};

export type Saml2TrustedIdpPayloadValidationMutationErrorInternalServerMutationError = InternalServerMutationError | Saml2TrustedIdpPayload | ValidationMutationError;

export type Saml2TrustedIdpsPayload = {
  __typename?: 'Saml2TrustedIdpsPayload';
  centralized_organization_id: Scalars['ID']['output'];
  trusted_idps: Array<Saml2TrustedIdpPayload>;
};

export type Saml2TrustedIdpsPayloadQueryValidationErrorQueryInternalServerError = QueryInternalServerError | QueryValidationError | Saml2TrustedIdpsPayload;

export type SaveClimateAnswerResult = InternalErrorV2 | NotFoundErrorV2 | SaveClimateAnswerSuccess | ValidationErrorV2;

export type SaveClimateAnswerSuccess = {
  __typename?: 'SaveClimateAnswerSuccess';
  saved: Scalars['Boolean']['output'];
};

/** Create or confirm the context step of a climate survey wizard. Omit draft_id to start a new session; provide it to re-confirm an existing one. */
export type SaveClimateSurveyContextInput = {
  /** Workflow identifier returned by the name step (step 1). */
  draft_id: Scalars['ID']['input'];
  /** Survey period end date and time. */
  period_end: Scalars['DateTime']['input'];
  /** Survey period start date and time. */
  period_start: Scalars['DateTime']['input'];
  /** Survey type: CLIMA_GENERAL or ENPS. */
  survey_type: ClimateSurveyTypeEnum;
};

export type SaveClimateSurveyContextResponse = ClimateSurveyContextType | ClimateWorkflowError | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Step 2 — accept, edit or redraft the description. */
export type SaveClimateSurveyDescriptionInput = {
  /** Edited text. Omit to accept the draft as written. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Workflow identifier returned by the name step. */
  draft_id: Scalars['ID']['input'];
  /** Ask for another AI draft instead of confirming this one. */
  regenerate?: Scalars['Boolean']['input'];
};

export type SaveClimateSurveyDescriptionResponse = ClimateSurveyDescriptionType | ClimateWorkflowError | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Confirm the expectations step of a climate survey wizard. */
export type SaveClimateSurveyExpectationsInput = {
  /** Semaphore bands (CLIMA_GENERAL only, not allowed for ENPS). */
  climate_semaphore?: InputMaybe<ClimateSemaphoreInput>;
  /** Draft workflow ID returned by save_climate_survey_context. */
  draft_id: Scalars['ID']['input'];
  /** eNPS score formula (required for ENPS, not allowed for CLIMA_GENERAL). */
  enps_calculation_formula?: InputMaybe<EnpsCalculationFormulaEnum>;
  /** eNPS semaphore bands (required for ENPS, not allowed for CLIMA_GENERAL). */
  enps_semaphore?: InputMaybe<EnpsSemaphoreInput>;
  /** Survey display norms. */
  norms: ClimateNormsInput;
  /** Survey access permissions. */
  permissions: ClimatePermissionsInput;
  /** Response scale (required for ENPS, not allowed for CLIMA_GENERAL). */
  response_scale?: InputMaybe<ResponseScaleInput>;
  /** Survey type — must match the value confirmed in the context step. */
  survey_type: ClimateSurveyTypeEnum;
};

export type SaveClimateSurveyExpectationsResponse = ClimateExpectationsValidationError | ClimateSurveyExpectationsType | ClimateWorkflowError | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Step 1 — name the survey. Starts the wizard. */
export type SaveClimateSurveyNameInput = {
  /** Survey name, 1-150 chars. Unique per organization in TLNT. */
  evaluation_name: Scalars['String']['input'];
};

export type SaveClimateSurveyNameResponse = ClimateSurveyNameType | ClimateWorkflowError | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Confirm the participants step of a climate survey wizard. */
export type SaveClimateSurveyParticipantsInput = {
  /** Draft workflow ID returned by save_climate_survey_context. */
  draft_id: Scalars['ID']['input'];
  /** Exclude recent hires. Forwarded but not applied yet — TLNT does not expose a hire date (CBC-5350). */
  exclude_new_hires?: Scalars['Boolean']['input'];
  /** Minimum tenure in months for a recipient to be included. Forwarded but not applied yet (CBC-5350). */
  min_seniority_months?: Scalars['Int']['input'];
  /** Send the survey to every active employee in the company. */
  send_to_all?: Scalars['Boolean']['input'];
};

export type SaveClimateSurveyParticipantsResponse = ClimateSurveyParticipantsType | ClimateWorkflowError | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Confirm the questions step of a climate survey wizard. */
export type SaveClimateSurveyQuestionsInput = {
  /** Dimensions and their questions. */
  dimensions: Array<ClimateDimensionInput>;
  /** Draft workflow ID returned by save_climate_survey_context. */
  draft_id: Scalars['ID']['input'];
  /** How the questions were generated (AI, manual, or fallback template). */
  source: ClimateQuestionSourceEnum;
  /** Survey type — must match the value confirmed in the context step. */
  survey_type: ClimateSurveyTypeEnum;
};

/** Confirm the questions gate of a climate survey wizard — choose whether the questions are AI-generated or entered manually. Returns the dimensions to review, which you then confirm with save_climate_survey_questions. */
export type SaveClimateSurveyQuestionsModeInput = {
  /** Draft workflow ID returned by save_climate_survey_context. */
  draft_id: Scalars['ID']['input'];
  /** AI to have the questions generated, MANUAL to enter them yourself. */
  question_mode: ClimateQuestionModeEnum;
};

export type SaveClimateSurveyQuestionsModeResponse = ClimateSurveyQuestionsModeType | ClimateWorkflowError | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type SaveClimateSurveyQuestionsResponse = ClimateQuestionsValidationError | ClimateSurveyQuestionsDraft | ClimateWorkflowError | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type SaveContractLegalInfoInput = {
  centralized_org_unit_ref?: InputMaybe<Scalars['String']['input']>;
  centralized_position_ref?: InputMaybe<Scalars['String']['input']>;
  centralized_user_id: Scalars['Int']['input'];
  contract_type: ContractTypeEnum;
  employer_registration_id: Scalars['UUID']['input'];
  end_date?: InputMaybe<Scalars['Date']['input']>;
  labor_regime: LaborRegimeEnum;
  legal_entity_id: Scalars['UUID']['input'];
  manager_ref?: InputMaybe<Scalars['String']['input']>;
  shift_hours?: InputMaybe<Scalars['Int']['input']>;
  shift_type: ContractShiftTypeEnum;
  sicoss_period_id: Scalars['Int']['input'];
  start_date: Scalars['Date']['input'];
  unionized: Scalars['Boolean']['input'];
  work_center_ref?: InputMaybe<Scalars['String']['input']>;
};

export type SaveContractLegalInfoResponse = {
  __typename?: 'SaveContractLegalInfoResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmployeeContractType;
};

export type SaveContractLegalInfoResult = InternalErrorResponse | NotFoundErrorResponse | SaveContractLegalInfoResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type SaveContractSalaryInfoInput = {
  bank_account_number?: InputMaybe<Scalars['String']['input']>;
  base_salary: Scalars['Decimal']['input'];
  centralized_org_unit_ref?: InputMaybe<Scalars['String']['input']>;
  centralized_position_ref?: InputMaybe<Scalars['String']['input']>;
  centralized_user_id: Scalars['Int']['input'];
  clabe?: InputMaybe<Scalars['String']['input']>;
  imss_salary_type: ImssSalaryTypeEnum;
  legal_entity_id: Scalars['UUID']['input'];
  manager_ref?: InputMaybe<Scalars['String']['input']>;
  payment_method: PaymentMethodEnum;
  payroll_bank_code?: InputMaybe<Scalars['String']['input']>;
  payroll_employee_id: Scalars['UUID']['input'];
  sar_bank_code?: InputMaybe<Scalars['String']['input']>;
  work_center_ref?: InputMaybe<Scalars['String']['input']>;
};

export type SaveContractSalaryInfoResponse = {
  __typename?: 'SaveContractSalaryInfoResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: ContractSalaryInfoType;
  salary_warning: Scalars['Boolean']['output'];
};

export type SaveContractSalaryInfoResult = InternalErrorResponse | NotFoundErrorResponse | SaveContractSalaryInfoResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type SaveDispersionLayoutConfigInput = {
  /** ID de la organización centralizada (owner). */
  centralized_organization_id: Scalars['ID']['input'];
  /** ID de la cuenta de dispersión activa a configurar. */
  dispersion_account_id: Scalars['ID']['input'];
  /** Codificación del archivo: 'utf8' o 'latin1'. */
  encoding: Scalars['String']['input'];
  /** Formato de archivo: 'txt_estandar', 'csv' o 'fixed_width'. */
  file_format: Scalars['String']['input'];
  /** ID de la razón social a la que pertenece la cuenta. */
  legal_entity_id: Scalars['ID']['input'];
  /** Separador de campos: 'pipe', 'comma', 'tab' o 'semicolon'. */
  separator: Scalars['String']['input'];
};

export type SaveDispersionLayoutConfigResponse = DispersionLayoutConfigResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type SaveIdseCredentialsInput = {
  centralized_organization_id: Scalars['ID']['input'];
  employer_registration_id: Scalars['ID']['input'];
  idse_password: Scalars['String']['input'];
  idse_username: Scalars['String']['input'];
};

export type SaveIdseCredentialsResult = EmployerRegistrationResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type SaveMassiveAssignmentDocumentInput = {
  centralized_organization_id: Scalars['Int']['input'];
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  document_id: Scalars['Int']['input'];
  idempotency_key?: InputMaybe<Scalars['String']['input']>;
  valid_users: Array<MassiveValidUserInfoInput>;
};

export type SaveMassiveAssignmentFolderInput = {
  centralized_organization_id: Scalars['Int']['input'];
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  folder_id: Scalars['Int']['input'];
  valid_users: Array<MassiveValidUserInfoInput>;
};

export type SaveScormPreviewResultInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  result: Scalars['JSON']['input'];
  video_lecture_id: Scalars['ID']['input'];
};

export type SaveScormPreviewResultPayload = {
  __typename?: 'SaveScormPreviewResultPayload';
  graphql_operation_id: Scalars['ID']['output'];
  scorm: ScormType;
};

export type SaveScormPreviewResultResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | SaveScormPreviewResultPayload;

export type SaveScormValidationResultInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  result: Scalars['JSON']['input'];
  video_lecture_id: Scalars['ID']['input'];
};

export type SaveScormValidationResultPayload = {
  __typename?: 'SaveScormValidationResultPayload';
  graphql_operation_id: Scalars['ID']['output'];
  scorm: ScormType;
};

export type SaveScormValidationResultResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | SaveScormValidationResultPayload;

export type SaveSocialSecurityInfoInput = {
  imss: Scalars['String']['input'];
  imss_employee_type: Scalars['Int']['input'];
  imss_medical_unit?: InputMaybe<Scalars['Int']['input']>;
  imss_salary_type: Scalars['Int']['input'];
  imss_shift_type: Scalars['Int']['input'];
  legal_entity_id: Scalars['ID']['input'];
  payroll_employee_id: Scalars['ID']['input'];
};

export type SaveSocialSecurityInfoResult = InternalErrorResponse | NotFoundErrorResponse | SocialSecurityInfoResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type ScheduleConfigInput = {
  /** Day 1–31 for MONTHLY frequency. Mutually exclusive with last_business_day. */
  day_of_month?: InputMaybe<Scalars['Int']['input']>;
  /** Required when frequency=WEEKLY. Day of week (MON–SUN). */
  day_of_week?: InputMaybe<DayOfWeekInput>;
  /** Required when mode=ACTIVE. DAILY / WEEKLY / MONTHLY. */
  frequency?: InputMaybe<ScheduleFrequencyInput>;
  /** If True, runs on the last business day of the month (MONTHLY only). */
  last_business_day?: Scalars['Boolean']['input'];
  /** Schedule mode: ACTIVE enables cron, NONE disables it. */
  mode: ScheduleModeInput;
  /** Internal user_ids to receive the report email (max 15). Creator is always included. */
  recipients?: Array<Scalars['Int']['input']>;
};

export enum ScheduleFrequencyInput {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum ScheduleModeInput {
  Active = 'ACTIVE',
  None = 'NONE',
  Pause = 'PAUSE'
}

export type ScheduledCentralizedReport = {
  filters?: InputMaybe<Scalars['String']['input']>;
  notify_email?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  report_type: ReportsEnum;
  scheduled_at?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum ScormDataVersion {
  ScormVersion_1_2 = 'SCORM_VERSION_1_2',
  ScormVersion_2004 = 'SCORM_VERSION_2004'
}

export enum ScormInfoLessonModeEnum {
  LessonModeNormal = 'LESSON_MODE_NORMAL'
}

export enum ScormInfoLessonStatusEnum {
  LessonStatusCompleted = 'LESSON_STATUS_COMPLETED',
  LessonStatusIncomplete = 'LESSON_STATUS_INCOMPLETE'
}

export enum ScormInfoSuccessStatusEnum {
  SuccessStatusFailed = 'SUCCESS_STATUS_FAILED',
  SuccessStatusPassed = 'SUCCESS_STATUS_PASSED',
  SuccessStatusUnknown = 'SUCCESS_STATUS_UNKNOWN'
}

export type ScormMutation = {
  __typename?: 'ScormMutation';
  create_or_update: CreateOrUpdateResponse;
  reset_user_scorm_data: ResetScormDataPayloadMutationInternalError;
  save_scorm_preview_result: SaveScormPreviewResultResponse;
  save_scorm_validation_result: SaveScormValidationResultResponse;
  update_scorm_options: UpdateScormOptionsPayloadMutationInternalError;
  update_user_scorm_data: UpdateScormDataPayloadMutationInternalError;
};


export type ScormMutationCreate_Or_UpdateArgs = {
  input: UpdateOrCreateScormInput;
};


export type ScormMutationReset_User_Scorm_DataArgs = {
  input: ResetUserScormDataInput;
};


export type ScormMutationSave_Scorm_Preview_ResultArgs = {
  input: SaveScormPreviewResultInput;
};


export type ScormMutationSave_Scorm_Validation_ResultArgs = {
  input: SaveScormValidationResultInput;
};


export type ScormMutationUpdate_Scorm_OptionsArgs = {
  input: UpdateScormOptionsInput;
};


export type ScormMutationUpdate_User_Scorm_DataArgs = {
  input: UserScormDataInput;
};

export type ScormOptions = {
  __typename?: 'ScormOptions';
  completion_method: ScormOptionsCompletionMethodEnum;
  completion_quiz_score?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  video_lecture_id: Scalars['ID']['output'];
};

export enum ScormOptionsCompletionMethodEnum {
  CompletionMethodLessonCompleted = 'COMPLETION_METHOD_LESSON_COMPLETED',
  CompletionMethodManual = 'COMPLETION_METHOD_MANUAL',
  CompletionMethodQuizScore = 'COMPLETION_METHOD_QUIZ_SCORE'
}

export type ScormQuery = {
  __typename?: 'ScormQuery';
  get_scorm_options: ScormOptions;
  get_user_scorm_data?: Maybe<UserScormData>;
};


export type ScormQueryGet_Scorm_OptionsArgs = {
  video_lecture_id: Scalars['ID']['input'];
};


export type ScormQueryGet_User_Scorm_DataArgs = {
  video_lecture_id: Scalars['ID']['input'];
};

export enum ScormStatusEnum {
  StatusComplete = 'STATUS_COMPLETE',
  StatusError = 'STATUS_ERROR',
  StatusInvalid = 'STATUS_INVALID',
  StatusProgressing = 'STATUS_PROGRESSING',
  StatusSubmitted = 'STATUS_SUBMITTED'
}

export type ScormType = {
  __typename?: 'ScormType';
  absolute_url?: Maybe<Scalars['String']['output']>;
  attachment_id?: Maybe<Scalars['ID']['output']>;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  manifest_path?: Maybe<Scalars['String']['output']>;
  relative_url?: Maybe<Scalars['String']['output']>;
  status_enum?: Maybe<ScormStatusEnum>;
  video_lecture: Scalars['ID']['output'];
};

export type SearchInput = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type SecondLevelAreaInput = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  area_level_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  nodes?: InputMaybe<Array<ThirdLevelAreaInput>>;
};

/** A section within a sheet, with the selected columns resolved. */
export type SectionColumnDetailNode = {
  __typename?: 'SectionColumnDetailNode';
  /** Area levels selected in this section, resolved to {id, name, level_sequence}. */
  area_levels: Array<ResolvedAreaLevelNode>;
  /** Static columns selected in this section, resolved to {key, name}. */
  columns: Array<ResolvedColumnNode>;
  /** Custom fields selected in this section, resolved to {id, name}. */
  custom_fields: Array<ResolvedEntityNode>;
  /** Order within the sheet. */
  display_order: Scalars['Int']['output'];
  /** True = dynamic columns per-org (custom fields, area levels). */
  is_dynamic: Scalars['Boolean']['output'];
  /** Section identifier (e.g. 'identity'). */
  key: Scalars['String']['output'];
  /** Section display name. */
  name: Scalars['String']['output'];
};

export type SecurityMutation = {
  __typename?: 'SecurityMutation';
  activate_account_with_link: LoginMutationPayloadSecurityMutationErrorInternalServerMutationError;
  add_audit_log: AddAuditLogSuccessResponseAddAuditLogErrorResponseServerInternalErrorMutationValidationErrorResponse;
  authenticate_from_talent_session: AuthenticateFromTalentSessionPayloadValidationMutationErrorInternalServerMutationError;
  autoactivate_centralized_user: AutoactivateCentralizedUserPayloadValidationMutationErrorInternalServerMutationError;
  autogenerate_password_user: SecurityMutationErrorInternalServerMutationErrorChangePasswordUserAutogeneratedPasswordPayload;
  centralized_change_password_user: SecurityMutationErrorInternalServerMutationErrorCentralizedChangePasswordUserPayload;
  change_password_user: SecurityMutationErrorInternalServerMutationErrorChangePasswordUserChangedPasswordPayload;
  change_user_organization_email: ChangeOrganizationUserEmailPayloadUserOrganizationValidationMutationErrorInternalServerMutationError;
  change_user_organization_username: UpdateUsernamePayloadSecurityMutationError;
  create_access_token_from_jwt_token: CreateJwtErrorApiClientErrorCreateAccessTokenFromJwtPayloadInternalServerMutationError;
  create_auth_token_from_internal_jwt: CreateAuthTokenFromInternalJwtPayloadValidationMutationErrorSecurityMutationErrorInternalServerMutationError;
  create_centralized_organization_anonymous_jwt_session: CentralizedOrganizationAnonymousSessionPayloadValidationMutationErrorInternalServerMutationError;
  create_cross_auth_talent_user: CreateCrossAuthTalentUserPayloadValidationMutationErrorInternalServerMutationError;
  create_internal_jwt_token_from_session: CreateInternalJwtTokenFromSessionPayloadValidationMutationErrorInternalServerMutationError;
  create_jwt_token_from_session: CreateJwtTokenFromSessionPayloadInternalServerMutationError;
  create_oauth2_jwt_token: CreateOAuth2JwtTokenPayloadMutationValidationErrorMutationInternalError;
  create_organization_access_token_from_credentials_mutation: AccessTokenMutationResponse;
  create_organization_jwt_token: CreateOrganizationJwtTokenPayloadSecurityMutationErrorInternalServerMutationError;
  create_session_from_oauth2_jwt_token: CreateSessionFromOAuth2JwtPayloadMutationValidationErrorMutationInternalError;
  create_talent_auth_jwt: CreateTalentAuthJwtPayloadSecurityMutationErrorInternalServerMutationErrorCreateJwtError;
  login_from_jwt_auth_token: LoginFromJwtAuthTokenPayloadSecurityMutationErrorInternalServerMutationError;
  login_user: LoginMutationPayloadSecurityMutationErrorInternalServerMutationError;
  login_user_general: LoginMutationPayloadSecurityMutationErrorInternalServerMutationError;
  logout_user: LogoutMutationPayload;
  refresh_user_session: RefreshUserSessionPayloadValidationMutationErrorInternalServerMutationError;
  return_switch_user_account: SwitchedUserPayloadSecurityMutationErrorInternalServerMutationErrorCreateJwtErrorLoginMutationPayload;
  switch_user_account: SwitchedUserPayloadSecurityMutationErrorInternalServerMutationErrorCreateJwtError;
};


export type SecurityMutationActivate_Account_With_LinkArgs = {
  input: ActivateAccountInput;
};


export type SecurityMutationAdd_Audit_LogArgs = {
  input: AddAuditLogInput;
};


export type SecurityMutationAuthenticate_From_Talent_SessionArgs = {
  input: AuthenticateFromTalentSessionInput;
};


export type SecurityMutationAutogenerate_Password_UserArgs = {
  input: UserChangeAutogeneratePasswordInput;
};


export type SecurityMutationCentralized_Change_Password_UserArgs = {
  input: CentralizedUserChangePasswordInput;
};


export type SecurityMutationChange_Password_UserArgs = {
  input: UserChangePasswordInput;
};


export type SecurityMutationChange_User_Organization_EmailArgs = {
  input: ChangeUserOrganizationEmailMutationInput;
};


export type SecurityMutationChange_User_Organization_UsernameArgs = {
  input: UserChangeChangeUsernameInput;
};


export type SecurityMutationCreate_Access_Token_From_Jwt_TokenArgs = {
  input: CreateAccessTokenFromJwtInput;
};


export type SecurityMutationCreate_Auth_Token_From_Internal_JwtArgs = {
  input: CreateAuthTokenFromInternalJwtInput;
};


export type SecurityMutationCreate_Centralized_Organization_Anonymous_Jwt_SessionArgs = {
  input: CreateCentralizedOrganizationAnonymousJwtSessionInput;
};


export type SecurityMutationCreate_Cross_Auth_Talent_UserArgs = {
  input: CreateCrossAuthTalentUserInput;
};


export type SecurityMutationCreate_Internal_Jwt_Token_From_SessionArgs = {
  input: CreateInternalJwtTokenFromSessionInput;
};


export type SecurityMutationCreate_Jwt_Token_From_SessionArgs = {
  input: CreateJwtTokenFromSession;
};


export type SecurityMutationCreate_Oauth2_Jwt_TokenArgs = {
  input: CreateOAuth2JwtTokenInput;
};


export type SecurityMutationCreate_Organization_Access_Token_From_Credentials_MutationArgs = {
  input: CreateOrganizationAccessTokenFromCredentialsInput;
};


export type SecurityMutationCreate_Organization_Jwt_TokenArgs = {
  input: CreateOrganizationJwtTokenInput;
};


export type SecurityMutationCreate_Session_From_Oauth2_Jwt_TokenArgs = {
  input: CreateSessionFromOAuth2JwtInput;
};


export type SecurityMutationCreate_Talent_Auth_JwtArgs = {
  input: CreateTalentAuthJwtMutationInput;
};


export type SecurityMutationLogin_From_Jwt_Auth_TokenArgs = {
  input: LoginFromJwtAuthTokenInput;
};


export type SecurityMutationLogin_UserArgs = {
  input: LoginMutationInput;
};


export type SecurityMutationLogin_User_GeneralArgs = {
  input: LoginUserInput;
};


export type SecurityMutationLogout_UserArgs = {
  input: LogoutMutationInput;
};


export type SecurityMutationReturn_Switch_User_AccountArgs = {
  input: UserSwitchesAccount;
};


export type SecurityMutationSwitch_User_AccountArgs = {
  input: UserSwitchesAccount;
};

export type SecurityMutationError = {
  __typename?: 'SecurityMutationError';
  errors: Array<Scalars['String']['output']>;
};

export type SecurityMutationErrorInternalServerMutationErrorCentralizedChangePasswordUserPayload = CentralizedChangePasswordUserPayload | InternalServerMutationError | SecurityMutationError;

export type SecurityMutationErrorInternalServerMutationErrorChangePasswordUserAutogeneratedPasswordPayload = ChangePasswordUserAutogeneratedPasswordPayload | InternalServerMutationError | SecurityMutationError;

export type SecurityMutationErrorInternalServerMutationErrorChangePasswordUserChangedPasswordPayload = ChangePasswordUserChangedPasswordPayload | InternalServerMutationError | SecurityMutationError;

export type SecurityOptions = {
  __typename?: 'SecurityOptions';
  force_change_email: Scalars['Boolean']['output'];
  force_change_password: Scalars['Boolean']['output'];
  force_change_password_v2: Scalars['Boolean']['output'];
  force_mfa: Scalars['Boolean']['output'];
};

export type SecurityPoliciesNamespaceMutation = {
  __typename?: 'SecurityPoliciesNamespaceMutation';
  change_my_password: ChangeMyPasswordPayloadSecurityMutationErrorInternalServerMutationError;
  change_password_with_recovery: RecoverChangePasswordPayload;
  change_user_password: ChangeUserPasswordPayloadSecurityMutationErrorInternalServerMutationError;
  request_password_recovery: RequestPasswordRecoveryPayload;
  update_password_policy: UpdatePasswordPolicyPayloadSecurityMutationErrorInternalServerMutationError;
};


export type SecurityPoliciesNamespaceMutationChange_My_PasswordArgs = {
  input: ChangeMyPasswordInput;
};


export type SecurityPoliciesNamespaceMutationChange_Password_With_RecoveryArgs = {
  input: RecoverChangePasswordInput;
};


export type SecurityPoliciesNamespaceMutationChange_User_PasswordArgs = {
  input: ChangeUserPasswordInput;
};


export type SecurityPoliciesNamespaceMutationRequest_Password_RecoveryArgs = {
  input: RequestPasswordRecoveryInput;
};


export type SecurityPoliciesNamespaceMutationUpdate_Password_PolicyArgs = {
  input: UpdatePasswordPolicyInput;
};

export type SecurityPoliciesNamespaceQuery = {
  __typename?: 'SecurityPoliciesNamespaceQuery';
  password_policy: GetPasswordPolicyPayloadQueryValidationErrorQueryInternalServerError;
  validate_recovery_token: RecoverValidateTokenPayloadQueryInternalServerError;
};


export type SecurityPoliciesNamespaceQueryPassword_PolicyArgs = {
  input: GetPasswordPolicyInput;
};


export type SecurityPoliciesNamespaceQueryValidate_Recovery_TokenArgs = {
  input: RecoverValidateTokenInput;
};

export type SecurityQuery = {
  __typename?: 'SecurityQuery';
  audit_logs?: Maybe<AuditLog>;
  current_session?: Maybe<UserSession>;
  get_centralized_user_from_talent: CentralizedUserPayloadQueryValidationErrorQueryInternalServerError;
  get_coporation_user_organization_auth: CorporationUserOrganizationAuthPayload;
  get_oauth2_user: GetAuth2UserQueryValidationError;
  get_organization_authencation_methods: Array<OrganizationAuthenticationMethodPayload>;
  get_organizations_from_corporation?: Maybe<CorporateOrganizationsPayload>;
  get_public_user_organization_auth: PublicCorporationUserOrganizationAuthPayload;
  get_user_organization_auth: Array<UserOrganizationAuth>;
  get_user_organization_from_talent_email: CrehanaUserData;
  ping: Scalars['String']['output'];
  talent_current_session?: Maybe<TalentUserSession>;
  user_from_jwt_token?: Maybe<UserSession>;
};


export type SecurityQueryAudit_LogsArgs = {
  uid: Scalars['ID']['input'];
};


export type SecurityQueryGet_Centralized_User_From_TalentArgs = {
  input: GetCentralizedUserFromTalent;
};


export type SecurityQueryGet_Coporation_User_Organization_AuthArgs = {
  method?: InputMaybe<AuthenticationMethodEnum>;
  next_url?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['ID']['input'];
  username: Scalars['String']['input'];
};


export type SecurityQueryGet_Oauth2_UserArgs = {
  input: GetOAuth2UserInput;
};


export type SecurityQueryGet_Organization_Authencation_MethodsArgs = {
  next_url: Scalars['String']['input'];
  organization_id: Scalars['ID']['input'];
};


export type SecurityQueryGet_Organizations_From_CorporationArgs = {
  parent_organization_id: Scalars['ID']['input'];
};


export type SecurityQueryGet_Public_User_Organization_AuthArgs = {
  input: GetPublicUserOrganizationAuthInput;
};


export type SecurityQueryGet_User_Organization_AuthArgs = {
  next_url?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};


export type SecurityQueryGet_User_Organization_From_Talent_EmailArgs = {
  user_email: Scalars['String']['input'];
};

export enum SecurityUserSessionApplicationEnum {
  Centralized = 'CENTRALIZED',
  Learning = 'LEARNING',
  Talent = 'TALENT'
}

export enum SecurityUserSessionTypeEnum {
  CentralizedJwtSession = 'CENTRALIZED_JWT_SESSION',
  CookieSession = 'COOKIE_SESSION',
  JwtSession = 'JWT_SESSION',
  Oauth2Session = 'OAUTH2_SESSION'
}

/** Segment Node */
export type Segment = {
  __typename?: 'Segment';
  global_modifier: SegmentGlobalModifier;
  id: Scalars['ID']['output'];
  rules: Array<SegmentRule>;
  type: SegmentTypeEnum;
};

/** Enum that defines the type of attribute used in user segmentation conditionals. */
export enum SegmentAttributeTypeEnum {
  Alphabetic = 'ALPHABETIC',
  CustomField = 'CUSTOM_FIELD',
  Date = 'DATE',
  Numeric = 'NUMERIC'
}

export type SegmentCustomFieldFilterInput = {
  custom_field_id: Scalars['Int']['input'];
  options?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SegmentFilterInput = {
  areas?: InputMaybe<Array<Scalars['Int']['input']>>;
  positions?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Enum that defines the global modifier for user segmentation groups. */
export enum SegmentGlobalModifier {
  And = 'AND',
  Or = 'OR'
}

/** Segment ID */
export type SegmentId = {
  __typename?: 'SegmentID';
  id: Scalars['ID']['output'];
};

export type SegmentInput = {
  global_modifier: SegmentGlobalModifier;
  rules: Array<SegmentRuleInput>;
  type: SegmentTypeEnum;
};

export type SegmentOrderInput = {
  desc: Scalars['Boolean']['input'];
  field: OrderUserAttributeEnum;
};

export type SegmentQueryResponse = SegmentationGroupNotFoundResponseError | SegmentationGroupResponseIntegrityError | SegmentationGroupResponseInternalError | SegmentationGroupResponseValidationError | UsersSegment;

export type SegmentResponse = {
  __typename?: 'SegmentResponse';
  segment: Segment;
};

export type SegmentResponseIntegrityErrorResponseValidationErrorResponseInternalErrorResponseNotFoundResponseForbiddenErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotFoundResponse | SegmentResponse | ValidationErrorResponse;

/** Regla de segmentación que puede ser alfabética, de área, numérica o de fecha. */
export type SegmentRule = SegmentRuleAlphabetic | SegmentRuleArea | SegmentRuleDate | SegmentRuleNumeric;

export type SegmentRuleAlphabetic = {
  __typename?: 'SegmentRuleAlphabetic';
  alphabetic_attribute: SegmentRuleAlphabeticAttribute;
  alphabetic_condition: SegmentRuleAlphabeticCondition;
  id: Scalars['ID']['output'];
};

export type SegmentRuleAlphabeticAttribute = SegmentRuleAlphabeticAttributeCustomField | SegmentRuleAlphabeticAttributeLiteralField;

export type SegmentRuleAlphabeticAttributeCustomField = {
  __typename?: 'SegmentRuleAlphabeticAttributeCustomField';
  alphabetic_type: SegmentRuleAlphabeticAttributeCustomFieldTypeEnum;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Enum that defines the type of attribute used in user segmentation conditionals. */
export enum SegmentRuleAlphabeticAttributeCustomFieldTypeEnum {
  MultipleChoiceCustomField = 'MULTIPLE_CHOICE_CUSTOM_FIELD',
  StringCustomField = 'STRING_CUSTOM_FIELD'
}

/** Enum that defines the type of attribute used in user segmentation conditionals. */
export enum SegmentRuleAlphabeticAttributeGenderEnum {
  Men = 'MEN',
  Other = 'OTHER',
  Women = 'WOMEN'
}

/** Available attributes for alphabetic segmentation rules. */
export enum SegmentRuleAlphabeticAttributeLiteralEnum {
  Branch = 'BRANCH',
  Country = 'COUNTRY',
  Gender = 'GENDER',
  Position = 'POSITION',
  PositionCategory = 'POSITION_CATEGORY',
  Role = 'ROLE'
}

export type SegmentRuleAlphabeticAttributeLiteralField = {
  __typename?: 'SegmentRuleAlphabeticAttributeLiteralField';
  literal_value: SegmentRuleAlphabeticAttributeLiteralEnum;
};

export type SegmentRuleAlphabeticCondition = SegmentRuleAlphabeticConditionMultiple | SegmentRuleAlphabeticConditionSingle | SegmentRuleAlphabeticCountryConditionMultiple | SegmentRuleAlphabeticGenderConditionMultiple;

export type SegmentRuleAlphabeticConditionMultiple = {
  __typename?: 'SegmentRuleAlphabeticConditionMultiple';
  alphabetic_multiple_operand: Array<MultipleOperand>;
  alphabetic_multiple_operator: SegmentRuleAlphabeticConditionMultipleEnum;
};

/** Condition for alphabetic rules using multiple choice values. */
export enum SegmentRuleAlphabeticConditionMultipleEnum {
  EqualToOption = 'EQUAL_TO_OPTION'
}

export type SegmentRuleAlphabeticConditionSingle = {
  __typename?: 'SegmentRuleAlphabeticConditionSingle';
  alphabetic_single_operand: Scalars['String']['output'];
  alphabetic_single_operator: SegmentRuleAlphabeticConditionSingleEnum;
};

/** Conditions for alphabetic rules using single values. */
export enum SegmentRuleAlphabeticConditionSingleEnum {
  Contains = 'CONTAINS',
  DoesNotContain = 'DOES_NOT_CONTAIN',
  EndsWith = 'ENDS_WITH',
  EqualToString = 'EQUAL_TO_STRING',
  StartsWith = 'STARTS_WITH'
}

export type SegmentRuleAlphabeticCountryConditionMultiple = {
  __typename?: 'SegmentRuleAlphabeticCountryConditionMultiple';
  alphabetic_multiple_country: Array<MultipleOperandCountry>;
};

export type SegmentRuleAlphabeticGenderConditionMultiple = {
  __typename?: 'SegmentRuleAlphabeticGenderConditionMultiple';
  alphabetic_multiple_gender: Array<MultipleOperandGender>;
};

export type SegmentRuleAlphabeticInput = {
  alphabetic_literal_attribute?: InputMaybe<SegmentRuleAlphabeticAttributeLiteralEnum>;
  alphabetic_multiple_operand?: InputMaybe<Array<Scalars['String']['input']>>;
  alphabetic_multiple_operator?: InputMaybe<SegmentRuleAlphabeticConditionMultipleEnum>;
  alphabetic_single_operand?: InputMaybe<Scalars['String']['input']>;
  alphabetic_single_operator?: InputMaybe<SegmentRuleAlphabeticConditionSingleEnum>;
  custom_field_attribute_id?: InputMaybe<Scalars['Int']['input']>;
};

export type SegmentRuleArea = {
  __typename?: 'SegmentRuleArea';
  areas: Array<CentralizedOrganizationAreaNode>;
  id: Scalars['ID']['output'];
};

export type SegmentRuleAreaInput = {
  area_ids: Array<Scalars['Int']['input']>;
};

/** Segment Rule Date Node */
export type SegmentRuleDate = {
  __typename?: 'SegmentRuleDate';
  date_attribute: SegmentRuleDateAttribute;
  date_condition: SegmentRuleDateCondition;
  id: Scalars['ID']['output'];
};

export type SegmentRuleDateAttribute = SegmentRuleDateAttributeCustomField | SegmentRuleDateAttributeLiteralField;

export type SegmentRuleDateAttributeCustomField = {
  __typename?: 'SegmentRuleDateAttributeCustomField';
  date_type: SegmentRuleDateAttributeCustomFieldTypeEnum;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Enum that defines the type of attribute used in user segmentation conditionals. */
export enum SegmentRuleDateAttributeCustomFieldTypeEnum {
  DateCustomField = 'DATE_CUSTOM_FIELD'
}

/** Literal date attributes for segmentation rules. */
export enum SegmentRuleDateAttributeLiteralEnum {
  DateOfBirth = 'DATE_OF_BIRTH',
  DateOfJoining = 'DATE_OF_JOINING'
}

export type SegmentRuleDateAttributeLiteralField = {
  __typename?: 'SegmentRuleDateAttributeLiteralField';
  date_literal_value: SegmentRuleDateAttributeLiteralEnum;
};

export type SegmentRuleDateCondition = SegmentRuleDateConditionRange | SegmentRuleDateConditionSingle;

/** Segment Rule Date Condition Range Node */
export type SegmentRuleDateConditionRange = {
  __typename?: 'SegmentRuleDateConditionRange';
  date_from_value: Scalars['String']['output'];
  date_range_operator: SegmentRuleDateConditionRangeEnum;
  date_to_value: Scalars['String']['output'];
};

/** Condition for date rules defining a range. */
export enum SegmentRuleDateConditionRangeEnum {
  Range = 'RANGE'
}

/** Segment Rule Date Condition Single Node */
export type SegmentRuleDateConditionSingle = {
  __typename?: 'SegmentRuleDateConditionSingle';
  date_single_operand: Scalars['String']['output'];
  date_single_operator: SegmentRuleDateConditionSingleEnum;
};

/** Conditions for date rules using single values. */
export enum SegmentRuleDateConditionSingleEnum {
  EqualTo = 'EQUAL_TO'
}

export type SegmentRuleDateInput = {
  custom_field_attribute_id?: InputMaybe<Scalars['Int']['input']>;
  date_literal_attribute?: InputMaybe<SegmentRuleDateAttributeLiteralEnum>;
  date_range_operand?: InputMaybe<Array<Scalars['Date']['input']>>;
  date_range_operator?: InputMaybe<SegmentRuleDateConditionRangeEnum>;
  date_single_operand?: InputMaybe<Scalars['Date']['input']>;
  date_single_operator?: InputMaybe<SegmentRuleDateConditionSingleEnum>;
};

export type SegmentRuleInput = {
  alphabetic_rule?: InputMaybe<SegmentRuleAlphabeticInput>;
  area_rule?: InputMaybe<SegmentRuleAreaInput>;
  date_rule?: InputMaybe<SegmentRuleDateInput>;
  numeric_rule?: InputMaybe<SegmentRuleNumericInput>;
};

export type SegmentRuleNumeric = {
  __typename?: 'SegmentRuleNumeric';
  id: Scalars['ID']['output'];
  numeric_attribute: SegmentRuleNumericAttribute;
  numeric_condition: SegmentRuleNumericCondition;
};

export type SegmentRuleNumericAttribute = SegmentRuleNumericAttributeCustomField;

export type SegmentRuleNumericAttributeCustomField = {
  __typename?: 'SegmentRuleNumericAttributeCustomField';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SegmentRuleNumericCondition = SegmentRuleNumericConditionRange | SegmentRuleNumericConditionSingle;

export type SegmentRuleNumericConditionRange = {
  __typename?: 'SegmentRuleNumericConditionRange';
  numeric_from_value: Scalars['Int']['output'];
  numeric_multiple_operator: SegmentRuleNumericConditionRangeEnum;
  numeric_to_value: Scalars['Int']['output'];
};

/** Numeric condition that defines a range. */
export enum SegmentRuleNumericConditionRangeEnum {
  Range = 'RANGE'
}

export type SegmentRuleNumericConditionSingle = {
  __typename?: 'SegmentRuleNumericConditionSingle';
  numeric_single_operand: Scalars['Int']['output'];
  numeric_single_operator: SegmentRuleNumericConditionSingleEnum;
};

/** Conditions for numeric rules using single values. */
export enum SegmentRuleNumericConditionSingleEnum {
  Contains = 'CONTAINS',
  DoesNotContain = 'DOES_NOT_CONTAIN',
  EndsWith = 'ENDS_WITH',
  EqualTo = 'EQUAL_TO',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN',
  StartsWith = 'STARTS_WITH'
}

export type SegmentRuleNumericInput = {
  custom_field_attribute_id?: InputMaybe<Scalars['Int']['input']>;
  numeric_range_operand?: InputMaybe<Array<Scalars['Int']['input']>>;
  numeric_range_operator?: InputMaybe<SegmentRuleNumericConditionRangeEnum>;
  numeric_single_operand?: InputMaybe<Scalars['Int']['input']>;
  numeric_single_operator?: InputMaybe<SegmentRuleNumericConditionSingleEnum>;
};

/** Enum that defines the type of user segmentation. */
export enum SegmentTypeEnum {
  Dynamic = 'DYNAMIC',
  Static = 'STATIC'
}

export type SegmentUnion = Segment | SegmentId;

export enum SegmentationConditionalEnum {
  BeginsWith = 'BEGINS_WITH',
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  EqualTo = 'EQUAL_TO',
  NotContains = 'NOT_CONTAINS',
  NotEqualTo = 'NOT_EQUAL_TO',
  Range = 'RANGE'
}

export enum SegmentationDataTypeEnum {
  Area = 'AREA',
  CompanyEntry = 'COMPANY_ENTRY',
  Country = 'COUNTRY',
  CustomField = 'CUSTOM_FIELD',
  Gender = 'GENDER',
  Headquarter = 'HEADQUARTER',
  Position = 'POSITION',
  PositionCategory = 'POSITION_CATEGORY'
}

export type SegmentationGroupNotFoundResponseError = {
  __typename?: 'SegmentationGroupNotFoundResponseError';
  code?: Maybe<Scalars['Int']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type SegmentationGroupResponseIntegrityError = {
  __typename?: 'SegmentationGroupResponseIntegrityError';
  attribute_type?: Maybe<SegmentAttributeTypeEnum>;
  code?: Maybe<Scalars['Int']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type SegmentationGroupResponseInternalError = {
  __typename?: 'SegmentationGroupResponseInternalError';
  code?: Maybe<Scalars['Int']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type SegmentationGroupResponseValidationError = {
  __typename?: 'SegmentationGroupResponseValidationError';
  attribute_type?: Maybe<SegmentAttributeTypeEnum>;
  attribute_value: Scalars['String']['output'];
  code?: Maybe<Scalars['Int']['output']>;
  graphql_operation_id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type SegmentationMutations = {
  __typename?: 'SegmentationMutations';
  /** Create a user segment from SegmentInput. */
  create_segment: SegmentResponseIntegrityErrorResponseValidationErrorResponseInternalErrorResponseNotFoundResponseForbiddenErrorResponse;
  /** Delete a segment group from DeleteSegmentsInput. */
  delete_segments: DeleteSegmentResponseIntegrityErrorResponseValidationErrorResponseInternalErrorResponseNotFoundResponseForbiddenErrorResponse;
  resync_segment_membership: AssignSupervisorsResponseNotFoundResponse;
  /** Update a group of user segment rules from UpdateSegmentsInput. */
  update_segments: SegmentResponseIntegrityErrorResponseValidationErrorResponseInternalErrorResponseNotFoundResponseForbiddenErrorResponse;
};


export type SegmentationMutationsCreate_SegmentArgs = {
  input: CreateSegmentsInput;
};


export type SegmentationMutationsDelete_SegmentsArgs = {
  input: DeleteSegmentsInput;
};


export type SegmentationMutationsResync_Segment_MembershipArgs = {
  group_id: Scalars['Int']['input'];
  supervisor_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type SegmentationMutationsUpdate_SegmentsArgs = {
  input: UpdateSegmentsInput;
};

export type SegmentationQueries = {
  __typename?: 'SegmentationQueries';
  /** Retrieve users by conditional filters */
  get_segments: SegmentsResponseValidationErrorResponseInternalErrorResponseNotFoundResponseForbiddenErrorResponse;
  /** Retrieve segments by user */
  get_segments_by_user: SegmentsResponseValidationErrorResponseInternalErrorResponseNotFoundResponseForbiddenErrorResponse;
  /** Return users belonging to a group (OrganizationGroupTeam) given its segment_id. */
  get_users_by_segment_id: GetUsersBySegmentIdResponse;
  /** Retrieve users by conditional filters */
  get_users_in_segment: SegmentQueryResponse;
};


export type SegmentationQueriesGet_SegmentsArgs = {
  input: GetSegmentsInput;
};


export type SegmentationQueriesGet_Segments_By_UserArgs = {
  input: GetSegmentsByUserInput;
};


export type SegmentationQueriesGet_Users_By_Segment_IdArgs = {
  input: GetUsersBySegmentIdInput;
};


export type SegmentationQueriesGet_Users_In_SegmentArgs = {
  input: GetSegmentedUsersInput;
};

export type SegmentationRulesInput = {
  conditional_type: AutomationConditionalTypesEnum;
  list_value_condition?: InputMaybe<ListValueSegmentationInput>;
  text_value_condition?: InputMaybe<TextValueSegmentationInput>;
};

/** Audience segmentation mode */
export enum SegmentationType {
  AllAudience = 'ALL_AUDIENCE',
  SpecificSegment = 'SPECIFIC_SEGMENT',
  SpecificUsers = 'SPECIFIC_USERS'
}

export type SegmentedUserAutomationRuleI = {
  user: UserAutomationRule;
  user_id: Scalars['ID']['output'];
  user_type: AutomationUserTypeEnum;
};

export type SegmentedUsersListInput = {
  automation_rule_id?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  segmentation_rules?: InputMaybe<Array<SegmentationRulesInput>>;
  /** Date when users are added to the platform (including reactivated users). You can select a date range or apply the rules to all */
  user_creation_date_range?: InputMaybe<UserCreationDateRangeInput>;
  user_filters?: InputMaybe<UserFiltersInput>;
};

export type SegmentedUsersMetadataType = {
  __typename?: 'SegmentedUsersMetadataType';
  total_count?: Maybe<Scalars['Int']['output']>;
  total_eligible?: Maybe<Scalars['Int']['output']>;
  total_in_rules?: Maybe<Scalars['Int']['output']>;
  total_segmented?: Maybe<Scalars['Int']['output']>;
};

export type SegmentedUsersPageNumberPagination = {
  __typename?: 'SegmentedUsersPageNumberPagination';
  edges: Array<UserAutomationRuleFragmentPaginationEdge>;
  metadata?: Maybe<SegmentedUsersMetadataType>;
  /** Information to aid in pagination. */
  page_info: NumberPageInfo;
  page_size?: Maybe<Scalars['Int']['output']>;
};

export type SegmentsResponse = {
  __typename?: 'SegmentsResponse';
  segments: Array<SegmentUnion>;
};

export type SegmentsResponseValidationErrorResponseInternalErrorResponseNotFoundResponseForbiddenErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotFoundResponse | SegmentsResponse | ValidationErrorResponse;

export type SelectSuccessionCandidateInput = {
  /** ID of the centralized organization that owns the position */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional fit score override (0-100) */
  fit_score?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the OrganizationPosition receiving the successor */
  position_id: Scalars['Int']['input'];
  /** Optional origin override for the candidate (AI or MANUAL) */
  suggested_by_type?: InputMaybe<SuggestedByTypeEnum>;
  /** Optional nominator user id when suggestion origin is MANUAL */
  suggested_by_user_id?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the User to promote as confirmed successor */
  user_id: Scalars['Int']['input'];
};

/** Payload returned after promoting a candidate to SELECTED (confirmed successor). */
export type SelectSuccessionCandidatePayload = {
  __typename?: 'SelectSuccessionCandidatePayload';
  /** The updated succession candidate record with status=SELECTED */
  candidate: SuccessionCandidateNode;
};

export type SelectSuccessionCandidateResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | SelectSuccessionCandidatePayload | ValidationErrorResponse;

export type SelectedCandidatesInput = {
  /** ID of the centralized organization */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID of the OrganizationPosition whose selected candidates to retrieve */
  position_id: Scalars['Int']['input'];
};

/** Payload containing the list of confirmed successors (status=SELECTED) for a position. */
export type SelectedCandidatesListPayload = {
  __typename?: 'SelectedCandidatesListPayload';
  /** Confirmed successors ordered by selected_at ascending */
  candidates: Array<SuccessionCandidateNode>;
};

export type SelectedCandidatesResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | SelectedCandidatesListPayload | ValidationErrorResponse;

export enum SelfEnrollAppSourceEnum {
  MobileB2B = 'MOBILE_B2B',
  PanelB2B = 'PANEL_B2B'
}

export type SelfEnrollCourseInput = {
  /** Client that originates the enrollment */
  app_source: SelfEnrollAppSourceEnum;
  /** Course to enroll into */
  course_id: Scalars['Int']['input'];
  /** Organization the session user belongs to */
  organization_id: Scalars['Int']['input'];
};

export type SelfEnrollPayload = {
  __typename?: 'SelfEnrollPayload';
  already_enrolled: Scalars['Boolean']['output'];
  course_id: Scalars['Int']['output'];
  enrollment_id: Scalars['Int']['output'];
  enrollment_type: EnrollmentTypeEnum;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type SelfEnrollResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | SelfEnrollPayload;

export type SemaphoreDto = {
  __typename?: 'SemaphoreDTO';
  color: Scalars['String']['output'];
  compLimit: Scalars['Float']['output'];
  label: Scalars['String']['output'];
};

/** Single label entry for a semaphore band. */
export type SemaphoreLabelInput = {
  /** Display label for this range. */
  label: Scalars['String']['input'];
};

export type SemaphoreRangeCountType = {
  __typename?: 'SemaphoreRangeCountType';
  count: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  range_name: Scalars['String']['output'];
};

export type SemaphoreRangeDistributionType = {
  __typename?: 'SemaphoreRangeDistributionType';
  color: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  percentage_range: Scalars['String']['output'];
  range_name: Scalars['String']['output'];
};

export type SendChatMessageInput = {
  chat_conversation_id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  organization_id: Scalars['ID']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type SendCustomEmailBaseInput = {
  attachments?: InputMaybe<Array<CustomEmailAttachmentInput>>;
  banner_file_id?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  content_type?: InputMaybe<EmailContentTypeEnum>;
  content_value?: InputMaybe<Scalars['ID']['input']>;
  custom_template_identifier: Scalars['String']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  section?: InputMaybe<EmailSectionEnum>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type SendCustomEmailToUsersInput = {
  attachments?: InputMaybe<Array<CustomEmailAttachmentInput>>;
  banner_file_id?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  content_type?: InputMaybe<EmailContentTypeEnum>;
  content_value?: InputMaybe<Scalars['ID']['input']>;
  custom_template_identifier: Scalars['String']['input'];
  enrollment_status?: InputMaybe<EmailEnrollmentStatusEnum>;
  has_select_all?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  section?: InputMaybe<EmailSectionEnum>;
  subject?: InputMaybe<Scalars['String']['input']>;
  user_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_ids_out?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SendTestEmailInput = {
  attachments?: InputMaybe<Array<AttachmentOrderInput>>;
  banner_file_id?: InputMaybe<Scalars['ID']['input']>;
  banner_file_url?: InputMaybe<Scalars['String']['input']>;
  body: Scalars['String']['input'];
  centralized_company_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_email: Scalars['String']['input'];
  centralized_logo?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  organization_name: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type SendWhatsappMessageInput = {
  message_body: Scalars['String']['input'];
  organization_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};

export type ServerInternalError = {
  __typename?: 'ServerInternalError';
  message: Scalars['String']['output'];
};

export enum ServiceDomainEnum {
  ServiceDomainCampus = 'SERVICE_DOMAIN_CAMPUS',
  ServiceDomainCrehanaApi = 'SERVICE_DOMAIN_CREHANA_API',
  ServiceDomainFederation = 'SERVICE_DOMAIN_FEDERATION',
  ServiceDomainTalent = 'SERVICE_DOMAIN_TALENT'
}

export type SessionMetaData = {
  /** Refers to the number of records after having applied the filter(s) to them */
  page_size: Scalars['Int']['output'];
  /** Refers to the total number of records */
  total_count: Scalars['Int']['output'];
};

export type SessionRecordFragment = FileRecordType | UrlRecordType;

/** The `ReportState` enum represents the different states that a report can have throughout its lifecycle. */
export enum SessionReportStateEnum {
  /** This state indicates that the report has failed to process or has encountered an error during processing. */
  Failed = 'FAILED',
  /** This state indicates that the report has been successfully completed or finalized. */
  Finished = 'FINISHED',
  /** This state indicates that the report has been initialized or created but has not yet started processing. */
  Initial = 'INITIAL',
  /** This state indicates that the report is currently being processed or is in progress. */
  Processing = 'PROCESSING'
}

export type SessionResourceFragment = ExternalSessionResourceType | InternalSessionResourceType;

export type SessionResourceListType = {
  __typename?: 'SessionResourceListType';
  items?: Maybe<Array<SessionResourceFragment>>;
};

/** Used in model */
export enum SessionStatusEnum {
  Future = 'FUTURE',
  Past = 'PAST'
}

export enum SessionTimeLineEnum {
  ForStart = 'FOR_START',
  Future = 'FUTURE',
  Live = 'LIVE',
  Past = 'PAST'
}

export enum SessionTimeZoneEnum {
  TimeZoneBz = 'TIME_ZONE_BZ',
  TimeZoneCr = 'TIME_ZONE_CR',
  TimeZoneEcGalapagos = 'TIME_ZONE_EC_GALAPAGOS',
  TimeZoneEcGuayaquil = 'TIME_ZONE_EC_GUAYAQUIL',
  TimeZoneEsAr = 'TIME_ZONE_ES_AR',
  TimeZoneEsBo = 'TIME_ZONE_ES_BO',
  TimeZoneEsCl = 'TIME_ZONE_ES_CL',
  TimeZoneEsCo = 'TIME_ZONE_ES_CO',
  TimeZoneEsCu = 'TIME_ZONE_ES_CU',
  TimeZoneEsDo = 'TIME_ZONE_ES_DO',
  TimeZoneEsEs = 'TIME_ZONE_ES_ES',
  TimeZoneEsMx = 'TIME_ZONE_ES_MX',
  TimeZoneEsPe = 'TIME_ZONE_ES_PE',
  TimeZoneEsPr = 'TIME_ZONE_ES_PR',
  TimeZoneEsPy = 'TIME_ZONE_ES_PY',
  TimeZoneEsUy = 'TIME_ZONE_ES_UY',
  TimeZoneEsVe = 'TIME_ZONE_ES_VE',
  TimeZoneGt = 'TIME_ZONE_GT',
  TimeZoneHn = 'TIME_ZONE_HN',
  TimeZoneHt = 'TIME_ZONE_HT',
  TimeZoneNi = 'TIME_ZONE_NI',
  TimeZonePa = 'TIME_ZONE_PA',
  TimeZonePtBr = 'TIME_ZONE_PT_BR',
  TimeZoneSv = 'TIME_ZONE_SV'
}

export enum SessionTypeEnum {
  Online = 'ONLINE',
  Presence = 'PRESENCE'
}

export type SessionUserAssignmentType = SessionUserEngagementType & {
  __typename?: 'SessionUserAssignmentType';
  end_date?: Maybe<Scalars['DateTime']['output']>;
  error_details: SessionUserEngagementErrorDetailType;
  error_file?: Maybe<File>;
  id: Scalars['ID']['output'];
  method: LiveSessionUserEngagementMethodEnum;
  start_date: Scalars['DateTime']['output'];
  state: LiveSessionUserEngagementStateEnum;
  total_errors: Scalars['Int']['output'];
  total_success: Scalars['Int']['output'];
};

export type SessionUserAttendanceSummaryType = {
  __typename?: 'SessionUserAttendanceSummaryType';
  candidates_was_confirmed: Scalars['Boolean']['output'];
  general_total_count: Scalars['Int']['output'];
  total_attendance_marked: Scalars['Int']['output'];
  total_candidates: Scalars['Int']['output'];
};

export type SessionUserAttendanceType = SessionUserEngagementType & {
  __typename?: 'SessionUserAttendanceType';
  attendance_summary: SessionUserAttendanceSummaryType;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  error_details: SessionUserEngagementErrorDetailType;
  error_file?: Maybe<File>;
  id: Scalars['ID']['output'];
  method: LiveSessionUserEngagementMethodEnum;
  start_date: Scalars['DateTime']['output'];
  state: LiveSessionUserEngagementStateEnum;
  total_errors: Scalars['Int']['output'];
  total_success: Scalars['Int']['output'];
};

export type SessionUserEngagementErrorDetailType = {
  __typename?: 'SessionUserEngagementErrorDetailType';
  items: Array<SessionUserEngagementErrorFragment>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type SessionUserEngagementErrorFragment = EmailDuplicatedErrorType | EmailEmptyErrorType | EmailFormatErrorType | UserAlreadyRegisteredErrorType | UserInactiveErrorType | UserNotFoundErrorType;

export type SessionUserEngagementFragment = SessionUserAssignmentType | SessionUserAttendanceType;

/** Input used in session_user_engagement [Mutation] */
export type SessionUserEngagementInput = {
  live_session_id: Scalars['ID']['input'];
  manual_data?: InputMaybe<SessionUserManualInput>;
  massive_data?: InputMaybe<SessionUserMassiveInput>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  validation_type: LiveSessionUserTrackerTypeEnum;
};

export type SessionUserEngagementType = {
  end_date?: Maybe<Scalars['DateTime']['output']>;
  error_details: SessionUserEngagementErrorDetailType;
  error_file?: Maybe<File>;
  id: Scalars['ID']['output'];
  method: LiveSessionUserEngagementMethodEnum;
  start_date: Scalars['DateTime']['output'];
  state: LiveSessionUserEngagementStateEnum;
  total_errors: Scalars['Int']['output'];
  total_success: Scalars['Int']['output'];
};

export type SessionUserManualInput = {
  selected_all?: InputMaybe<Scalars['Boolean']['input']>;
  users_id_list?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SessionUserMassiveInput = {
  extra_data?: InputMaybe<Scalars['String']['input']>;
  file_id: Scalars['ID']['input'];
  file_url: Scalars['String']['input'];
};

export type SetCentralizedUserConfigurationInput = {
  centralized_organization_id: Scalars['Int']['input'];
  centralized_user_id: Scalars['Int']['input'];
  language: UserConfigurationLanguageEnum;
};

export type SetCentralizedUserConfigurationResponse = {
  __typename?: 'SetCentralizedUserConfigurationResponse';
  user_configuration: UserConfigurationType;
};

export type SetCentralizedUserConfigurationResponseMutationValidationErrorMutationInternalError = MutationInternalError | MutationValidationError | SetCentralizedUserConfigurationResponse;

export type SetCourseCertificatePolicyInput = {
  auto_reassign: Scalars['Boolean']['input'];
  course_id: Scalars['Int']['input'];
  notify_push: Scalars['Boolean']['input'];
  organization_id: Scalars['Int']['input'];
  validity_days: Scalars['Int']['input'];
};

export type SetCourseCertificatePolicyResponse = CourseCertificatePolicyResponsePayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type SetCurrencyEvent = {
  __typename?: 'SetCurrencyEvent';
  achievement_set?: Maybe<Array<AdminCurrencyEventFragmentNode>>;
  event_set?: Maybe<Array<AdminCurrencyEventFragmentNode>>;
};

export type SetCurrencyEventFragmentNode = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | SetCurrencyEvent;

export type SetDeactivationDateInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
  deactivation_date?: InputMaybe<Scalars['DateTime']['input']>;
  delete_account_on_deactivation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetDeactivationDatePayload = UsersGraphOperationI & {
  __typename?: 'SetDeactivationDatePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<UserMetadataOuput>;
};

export type SetDeactivationDateResponse = CentralizedIntegrityError | CentralizedInternalError | CentralizedValidationError | SetDeactivationDatePayload;

export type SetDispersionAccountActiveInput = {
  /** ID de la organización centralizada (owner). */
  centralized_organization_id: Scalars['ID']['input'];
  /** ID de la cuenta de dispersión. */
  id: Scalars['ID']['input'];
  /** Nuevo estado activo/inactivo de la cuenta. */
  is_active: Scalars['Boolean']['input'];
  /** ID de la razón social a la que pertenece la cuenta. */
  legal_entity_id: Scalars['ID']['input'];
};

export type SetDispersionAccountActiveResponse = DispersionAccountResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Suspends, reactivates or liquidates a credit. A suspended credit stops being discounted and keeps its payments. Archiving has its own operation. */
export type SetGovernmentCreditStatusInput = {
  credit_id: Scalars['ID']['input'];
  legal_entity_id: Scalars['ID']['input'];
  /** active, suspended or liquidated. */
  status: Scalars['String']['input'];
};

export type SetGovernmentCreditStatusResult = GovernmentCreditItemResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type SetTalentInput = {
  email: Scalars['String']['input'];
  field_and_error?: InputMaybe<Scalars['JSON']['input']>;
  talent_user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type SetTalentMonolithAvailabilityPayload = {
  __typename?: 'SetTalentMonolithAvailabilityPayload';
  feature_flag: FeatureFlag;
  operation_id: Scalars['String']['output'];
};

export type SetTalentMonolithAvailabilityResponse = QueryInternalError | QueryValidationError | SetTalentMonolithAvailabilityPayload;

export type SetTalentUserResponse = {
  __typename?: 'SetTalentUserResponse';
  success: Scalars['Boolean']['output'];
};

export type SetTrackCourseComingSoonInput = {
  /** Course to mark or unmark. It must currently be an active course of the track. */
  course_id: Scalars['Int']['input'];
  /** Target state, not a toggle: true MARKS the course as coming soon, false UNMARKS it. Required on purpose -- there is no default, so a malformed call cannot silently become an unmark. */
  is_coming_soon: Scalars['Boolean']['input'];
  /** Organization the track belongs to. Must be the caller's own organization (or one of its sub-organizations); a mismatch is rejected before anything is read or written. */
  organization_id: Scalars['Int']['input'];
  /** Track (organization team) that contains the course. */
  organization_team_id: Scalars['Int']['input'];
};

export type SetTrackCourseComingSoonPayload = {
  __typename?: 'SetTrackCourseComingSoonPayload';
  changed: Scalars['Boolean']['output'];
  course_id: Scalars['Int']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  is_coming_soon: Scalars['Boolean']['output'];
  track_id: Scalars['Int']['output'];
};

export type SetTrackCourseComingSoonResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | SetTrackCourseComingSoonPayload;

export type ShareFileV1Interface = {
  absolute_url?: Maybe<Scalars['String']['output']>;
  content_type: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by_id?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  download_url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_b2b?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

/** Resolved column selection for a single sheet within report_input_config. */
export type SheetColumnDetailNode = {
  __typename?: 'SheetColumnDetailNode';
  /** Order of this sheet in the report. */
  display_order: Scalars['Int']['output'];
  /** Sections with their selected columns, in display order. */
  sections: Array<SectionColumnDetailNode>;
  /** Sheet identifier (e.g. 'user_general_sheet'). */
  sheet_key: Scalars['String']['output'];
  /** Sheet display name (e.g. 'General'). */
  sheet_name: Scalars['String']['output'];
};

/** Column selection per sheet. Groups static column keys, custom field IDs and area level IDs for a single sheet. */
export type SheetColumnSelectionInput = {
  /** Area level IDs to include (from centralized_central_users_organization_levels.area_level_id). */
  area_level_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Custom field IDs to include (from centralized_central_custom_fields.field_id). */
  custom_field_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Static column keys from ReportColumnConfig (e.g. 'first_name', 'email', 'position'). */
  report_columns?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Key de la hoja del reporte (e.g. 'users_sheet', 'courses_sheet'). */
  sheet_key: Scalars['String']['input'];
};

export type SignedField = {
  __typename?: 'SignedField';
  field_name: Scalars['String']['output'];
  field_value: Scalars['String']['output'];
};

export type SimpleEventAttributes = {
  data: Scalars['JSON']['input'];
  message: Scalars['String']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  topic: Scalars['String']['input'];
};

export type SimpleFile = SimpleFileI & {
  __typename?: 'SimpleFile';
  placeholder?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type SimpleFileI = {
  placeholder?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type SimulateTimeoffIncorporationDateImpactInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Centralized User ID */
  centralized_user_id: Scalars['ID']['input'];
  /** Hypothetical new incorporation date to simulate */
  new_incorporation_date: Scalars['Date']['input'];
};

export type SingleDocumentInput = {
  assign_on_creation?: Scalars['Boolean']['input'];
  conditionals?: InputMaybe<Array<GenericConditionalInput>>;
  created_for_assignment?: Scalars['Boolean']['input'];
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  file_id: Scalars['Int']['input'];
  folder_id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  readable_by_user?: Scalars['Boolean']['input'];
  uploaded_format: DocumentFileFormatEnum;
};

export type SingleEndUserDocumentInput = {
  allowed_formats?: InputMaybe<Array<Scalars['String']['input']>>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  file_id?: InputMaybe<Scalars['Int']['input']>;
  folder_id?: InputMaybe<Scalars['Int']['input']>;
  is_sensitive_data?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  question?: InputMaybe<Array<Scalars['String']['input']>>;
  uploaded_format?: InputMaybe<HanaDocumentFileFormatEnum>;
  url?: InputMaybe<Scalars['String']['input']>;
  visualization_type?: InputMaybe<FeatureVisualizationTypeEnum>;
};

export type SingleNewsInput = {
  assign_on_creation?: Scalars['Boolean']['input'];
  conditionals?: InputMaybe<Array<GenericConditionalInput>>;
  file_id: Scalars['Int']['input'];
  front_page_image_id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
  uploaded_format?: InputMaybe<DocumentFileFormatEnum>;
};

/** User Filters */
export type SingleUserFilterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SkillB2bTeamNode = {
  __typename?: 'SkillB2bTeamNode';
  completed_skill_count?: Maybe<Scalars['Int']['output']>;
  total_skill_count?: Maybe<Scalars['Int']['output']>;
};

export type SkillB2bTrackNode = {
  __typename?: 'SkillB2bTrackNode';
  icon_source?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SkillXpAutomationRuleType = {
  __typename?: 'SkillXpAutomationRuleType';
  id: Scalars['ID']['output'];
  skill_xp_id: Scalars['ID']['output'];
};

export type SkillXpAutomationRuleTypeListResponse = {
  __typename?: 'SkillXpAutomationRuleTypeListResponse';
  items: Array<SkillXpAutomationRuleType>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type SkipRequestApprovalInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Request ID */
  request_id: Scalars['ID']['input'];
  /** Status */
  status: RequestStatusEnum;
};

export type SkipRequestApprovalResponse = {
  __typename?: 'SkipRequestApprovalResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export enum SmartGoalsStatusEnum {
  StatusCreated = 'STATUS_CREATED',
  StatusError = 'STATUS_ERROR',
  StatusFinished = 'STATUS_FINISHED',
  StatusPending = 'STATUS_PENDING',
  StatusQueued = 'STATUS_QUEUED',
  StatusRetried = 'STATUS_RETRIED'
}

export type SmartGoalsValidationPayload = {
  __typename?: 'SmartGoalsValidationPayload';
  goals_attempt: GoalsAttempt;
  graphql_operation_id: Scalars['ID']['output'];
};

export type SmartGoalsValidationPayloadMutationValidationErrorMutationInternalError = MutationInternalError | MutationValidationError | SmartGoalsValidationPayload;

export type SocialHubMutations = {
  __typename?: 'SocialHubMutations';
  /** News seen by user */
  complete_user_news: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  /** Create Social Hub News */
  create_news: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
  /** Deactivate social hub news */
  deactivate_news: HrisDefaultResponseHrisMutationValidationErrorHrisMutationInternalError;
};


export type SocialHubMutationsComplete_User_NewsArgs = {
  input: CompleteUserNewsInput;
};


export type SocialHubMutationsCreate_NewsArgs = {
  input: CreateSocialHubNewsInput;
};


export type SocialHubMutationsDeactivate_NewsArgs = {
  input: DeactivateSocialHubNewsInput;
};

/** Subgraph HRIS - Document User Profile Info Node */
export type SocialHubNewsInfoNode = {
  __typename?: 'SocialHubNewsInfoNode';
  /** Completed Users */
  completed_users: Scalars['Int']['output'];
  /** Social Hub News File ID */
  file_id: Scalars['Int']['output'];
  /** Social Hub News File Info */
  file_info?: Maybe<File>;
  /** Social Hub News Front Page Image ID */
  front_page_image_id?: Maybe<Scalars['Int']['output']>;
  /** Social Hub News Front Page Image Info */
  front_page_image_info?: Maybe<File>;
  /** ID */
  id: Scalars['Int']['output'];
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Social Hub News Published Date */
  published_date: Scalars['DateTime']['output'];
  /** Social Hub News Title */
  title: Scalars['String']['output'];
  /** Total Assigned Users */
  total_asigned_users: Scalars['Int']['output'];
  /** Uploaded format */
  uploaded_format?: Maybe<DocumentFileFormatEnum>;
  /** User */
  user?: Maybe<CentralizedUserNode>;
  /** User ID */
  user_id: Scalars['Int']['output'];
  /** User Progress */
  user_progress: Scalars['Int']['output'];
  /** User Segment */
  user_segment?: Maybe<Scalars['Int']['output']>;
};

export type SocialHubNewsInfoNodeCustomConnection = {
  __typename?: 'SocialHubNewsInfoNodeCustomConnection';
  edges: Array<SocialHubNewsInfoNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type SocialHubNewsInfoNodeCustomConnectionHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError = HrisQueryIntegrityError | HrisQueryInternalError | HrisQueryValidationError | SocialHubNewsInfoNodeCustomConnection;

export type SocialHubNewsInfoNodeCustomEdge = {
  __typename?: 'SocialHubNewsInfoNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: SocialHubNewsInfoNode;
};

export enum SocialHubNewsStatusEnum {
  SocialHubNewsStatusCompleted = 'SOCIAL_HUB_NEWS_STATUS_COMPLETED',
  SocialHubNewsStatusPending = 'SOCIAL_HUB_NEWS_STATUS_PENDING'
}

export type SocialHubQueries = {
  __typename?: 'SocialHubQueries';
  /** Get social hub news */
  get_news: SocialHubNewsInfoNodeCustomConnectionHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError;
  /** Get a social hub news by ID */
  get_news_by_id?: Maybe<SocialHubNewsInfoNode>;
  /** Get user progress by Social Hub News ID */
  get_user_progress_by_news_id: UserProgressSocialHubNewsInfoNodeCustomConnectionHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError;
  /** Gets User Profile - Social Hub News information */
  social_hub_get_my_news: UserProfileSocialHubNewsInfoNodeCustomConnectionHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError;
  /** Gets User Profile - a single Social Hub News by its ID */
  social_hub_get_my_news_by_id: UserProfileSocialHubNewsByIdResponse;
};


export type SocialHubQueriesGet_NewsArgs = {
  input: GetSocialHubNewsInput;
};


export type SocialHubQueriesGet_News_By_IdArgs = {
  input: GetSocialHubNewsByIdInput;
};


export type SocialHubQueriesGet_User_Progress_By_News_IdArgs = {
  input: UserProgressSocialHubNewsInput;
};


export type SocialHubQueriesSocial_Hub_Get_My_NewsArgs = {
  input: GetUserProfileSocialHubNewsInput;
};


export type SocialHubQueriesSocial_Hub_Get_My_News_By_IdArgs = {
  input: GetUserProfileSocialHubNewsByIdInput;
};

export type SocialSecurityInfoResponse = {
  __typename?: 'SocialSecurityInfoResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: SocialSecurityInfoType;
};

export type SocialSecurityInfoType = {
  __typename?: 'SocialSecurityInfoType';
  current_daily_salary?: Maybe<Scalars['Float']['output']>;
  current_sdi?: Maybe<Scalars['Float']['output']>;
  imss?: Maybe<Scalars['String']['output']>;
  imss_employee_type?: Maybe<Scalars['Int']['output']>;
  imss_medical_unit?: Maybe<Scalars['Int']['output']>;
  imss_salary_type?: Maybe<Scalars['Int']['output']>;
  imss_shift_type?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type SocialSecurityMutation = {
  __typename?: 'SocialSecurityMutation';
  /** Archives a pension order (logical delete). */
  archive_employee_pension: ArchiveEmployeePensionResult;
  /** Cancels a government credit: the credit moves to `archived` and its recurring incidences are deactivated in the same transaction, so the discount stops and nothing is left pointing at a credit nobody can see. To stop the discount without losing the incidence, use `set_government_credit_status` with `suspended`. */
  archive_government_credit: ArchiveGovernmentCreditResult;
  /** Creates a pension order for an employee. **The employee is not validated to exist.** The check that used to require a real row for `centralized_user_id` in that legal entity was replaced by `has_active_contract`, which is stubbed to always return true until the federated contract adapter lands (PAYR-519). Until then neither the user nor the legal entity is verified. */
  create_employee_pension: CreateEmployeePensionResult;
  /** Creates a government credit (INFONAVIT/FONACOT) for an employee. **The employee is not validated to exist.** The check that used to require a real row for `centralized_user_id` in that legal entity was replaced by `has_active_contract`, which is stubbed to always return true until the federated contract adapter lands (PAYR-519). Until then neither the user nor the legal entity is verified. */
  create_government_credit: CreateGovernmentCreditResult;
  /** Updates social security info (NSS, UMF, IMSS contract fields) for an employee. */
  save_social_security_info: SaveSocialSecurityInfoResult;
  /** Suspends, reactivates or liquidates a government credit. A suspended credit stops being discounted and keeps its payments. */
  set_government_credit_status: SetGovernmentCreditStatusResult;
  /** Updates an existing government credit. Partial: only the provided fields change. Realigns the credit's recurring incidences when the validity dates move. */
  update_government_credit: UpdateGovernmentCreditResult;
};


export type SocialSecurityMutationArchive_Employee_PensionArgs = {
  input: ArchiveEmployeePensionInput;
};


export type SocialSecurityMutationArchive_Government_CreditArgs = {
  input: ArchiveGovernmentCreditInput;
};


export type SocialSecurityMutationCreate_Employee_PensionArgs = {
  input: CreateEmployeePensionInput;
};


export type SocialSecurityMutationCreate_Government_CreditArgs = {
  input: CreateGovernmentCreditInput;
};


export type SocialSecurityMutationSave_Social_Security_InfoArgs = {
  input: SaveSocialSecurityInfoInput;
};


export type SocialSecurityMutationSet_Government_Credit_StatusArgs = {
  input: SetGovernmentCreditStatusInput;
};


export type SocialSecurityMutationUpdate_Government_CreditArgs = {
  input: UpdateGovernmentCreditInput;
};

export type SocialSecurityQuery = {
  __typename?: 'SocialSecurityQuery';
  /** Returns social security info for an employee. */
  get_social_security_info: GetSocialSecurityInfoResult;
  /** Lists the installment payments of ONE government credit, newest installment first, for the credit installments drawer. Rows are NOT grouped by installment: a fortnightly run pays one installment in two rows and a period straddling two months pays two installments in the same run, so the consumer groups by `installment_number` and compares the sum against the credit's `installment_amount` to tell Partial from Complete. Scoped by (centralized_user_id, legal_entity_id): a credit that does not belong to that pair answers NotFound, with the same message as one that does not exist. */
  list_credit_installment_payments: ListCreditInstallmentPaymentsResult;
  /** Lists pension orders for an employee. **The employee is not validated to exist**: an unknown `centralized_user_id` returns an empty list instead of an error, because `has_active_contract` is stubbed to always return true until the federated contract adapter lands (PAYR-519). */
  list_employee_pensions: ListEmployeePensionsResult;
  /** Lists government credits for an employee. **The employee is not validated to exist**: an unknown `centralized_user_id` returns an empty list instead of an error, because `has_active_contract` is stubbed to always return true until the federated contract adapter lands (PAYR-519). */
  list_government_credits: ListGovernmentCreditsResult;
};


export type SocialSecurityQueryGet_Social_Security_InfoArgs = {
  input: GetSocialSecurityInfoInput;
};


export type SocialSecurityQueryList_Credit_Installment_PaymentsArgs = {
  input: ListCreditInstallmentPaymentsInput;
};


export type SocialSecurityQueryList_Employee_PensionsArgs = {
  input: ListEmployeePensionsInput;
};


export type SocialSecurityQueryList_Government_CreditsArgs = {
  input: ListGovernmentCreditsInput;
};

/** Sort order direction */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** INPUTS */
export type SortInput = {
  direction: SortDirection;
  field: Scalars['String']['input'];
};

/** A single daily point for sparkline charts. */
export type SparklinePoint = {
  __typename?: 'SparklinePoint';
  /** Date in YYYY-MM-DD format. */
  date: Scalars['String']['output'];
  /** Count for this date. */
  value: Scalars['Int']['output'];
};

export type StableGamificationMutationV2 = {
  __typename?: 'StableGamificationMutationV2';
  user_assignments_by_admin: AssignmentSummaryFragment;
};


export type StableGamificationMutationV2User_Assignments_By_AdminArgs = {
  input: UserAssignmentsActionInput;
};

export type StableGamificationQueriesV2 = {
  __typename?: 'StableGamificationQueriesV2';
  get_allowed_user_summary_by_collaborator: UserSummaryFragment;
  get_report_download_url: LeaderboardReportFragment;
  get_users_for_assignment_by_admin: UsersForAssignmentFragmentGamificationMetadataGamificationPageNumConnectionGenerator;
  get_users_for_leaderboard_by_admin: LeaderboardPlayerLeaderboardMetadataGamificationPageNumConnectionGenerator;
};


export type StableGamificationQueriesV2Get_Allowed_User_Summary_By_CollaboratorArgs = {
  input: UserSummaryInput;
};


export type StableGamificationQueriesV2Get_Report_Download_UrlArgs = {
  input: LeaderboardReportInput;
};


export type StableGamificationQueriesV2Get_Users_For_Assignment_By_AdminArgs = {
  input: UsersForAssignmentInput;
};


export type StableGamificationQueriesV2Get_Users_For_Leaderboard_By_AdminArgs = {
  input: UsersForLeaderboardInput;
};

export type StandartRewardTransactionNode = {
  __typename?: 'StandartRewardTransactionNode';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  created_by_id?: Maybe<Scalars['Int']['output']>;
  currency_points_exchanged?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  related_transaction_id?: Maybe<Scalars['ID']['output']>;
  reward: RewardFragmentNode;
  reward_id?: Maybe<Scalars['ID']['output']>;
  transaction_status_enum?: Maybe<TransactionStatusEnum>;
  transaction_type_enum?: Maybe<TransactionTypeEnum>;
};

export type StandartRewardTransactionNodeEdge = {
  __typename?: 'StandartRewardTransactionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: StandartRewardTransactionNode;
};

export type StartMassiveOrganizationPositionsInput = {
  file_url: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
  send_to_talent?: Scalars['Boolean']['input'];
};

export type StartMassivePositionsPayload = {
  __typename?: 'StartMassivePositionsPayload';
  chunks_published: Scalars['Int']['output'];
  excel_import_id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  total_records: Scalars['Int']['output'];
};

export type StartMassivePositionsResponse = IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | StartMassivePositionsPayload | ValidationErrorResponse;

export enum StateEnum {
  Active = 'ACTIVE',
  Retired = 'RETIRED'
}

export enum StatusProjectEnum {
  Certified = 'CERTIFIED',
  Draft = 'DRAFT',
  Finished = 'FINISHED',
  Observed = 'OBSERVED',
  Published = 'PUBLISHED',
  Resolved = 'RESOLVED'
}

/** Used to filter queries */
export enum StatusSessionEnum {
  Next = 'NEXT',
  Past = 'PAST'
}

export enum StepEnum {
  StepContent = 'STEP_CONTENT',
  StepInformation = 'STEP_INFORMATION',
  StepRequirements = 'STEP_REQUIREMENTS',
  StepSummary = 'STEP_SUMMARY'
}

export type StrListType = {
  __typename?: 'StrListType';
  items: Array<Scalars['String']['output']>;
  total_count: Scalars['Int']['output'];
  total_filtered: Scalars['Int']['output'];
};

export type StudentRankingConnection = {
  __typename?: 'StudentRankingConnection';
  /** Contains the nodes in this connection */
  edges: Array<StudentRankingInfoEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
  updated_date?: Maybe<Scalars['DateTime']['output']>;
};

export type StudentRankingInfo = {
  __typename?: 'StudentRankingInfo';
  avatar_url?: Maybe<Scalars['String']['output']>;
  courses_assigned: Scalars['Int']['output'];
  courses_completed: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  progress_percentage: Scalars['Int']['output'];
  projects_completed: Scalars['Int']['output'];
  projects_required: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  study_minutes: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StudentRankingInfoEdge = {
  __typename?: 'StudentRankingInfoEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: StudentRankingInfo;
};

export type StudentRankingResponse = FoundationLeaderIntegrityError | FoundationLeaderInternalError | FoundationLeaderValidationError | StudentRankingConnection;

export type StudioCourseConfigCertificationAvailableI = {
  has_certification_available?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export type StudioCourseConfigInterface = {
  id: Scalars['ID']['output'];
};

export type StudioCourseConfigMandatoryI = {
  id: Scalars['ID']['output'];
  is_mandatory?: Maybe<Scalars['Boolean']['output']>;
};

export type StudioCourseConfigNode = StudioCourseConfigInterface & StudioCourseConfigVisibilityStateI & {
  __typename?: 'StudioCourseConfigNode';
  id: Scalars['ID']['output'];
  visibility_state?: Maybe<StudioCourseConfigStateEnum>;
};

export type StudioCourseConfigRequirementI = {
  approval_requirement_enum: ApprovalRequirementStudioEnum;
  id: Scalars['ID']['output'];
  requirements?: Maybe<CourseApprovalRequirementFragment>;
};

export enum StudioCourseConfigStateEnum {
  Hidden = 'HIDDEN'
}

export type StudioCourseConfigVisibilityStateI = {
  id: Scalars['ID']['output'];
  visibility_state?: Maybe<StudioCourseConfigStateEnum>;
};

export type Subcategory = {
  __typename?: 'Subcategory';
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  report_progress: ReportProgress;
};


export type SubscriptionReport_ProgressArgs = {
  report_id: Scalars['String']['input'];
};

export enum SubscriptionTypeEnum {
  SubscriptionPull = 'SUBSCRIPTION_PULL',
  SubscriptionPush = 'SUBSCRIPTION_PUSH'
}

export type SubsidiaryTalent = {
  __typename?: 'SubsidiaryTalent';
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  original_id?: Maybe<Scalars['Int']['output']>;
};

export type SubsidiaryTalentListType = {
  __typename?: 'SubsidiaryTalentListType';
  subsidiarys?: Maybe<Array<Maybe<SubsidiaryTalent>>>;
};

export type SubsidiaryTalentType = {
  __typename?: 'SubsidiaryTalentType';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SubtitleLanguageInput = {
  language_code: VideoLanguageEnum;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  transcript_name?: InputMaybe<Scalars['String']['input']>;
  transcript_url: Scalars['String']['input'];
  video_lecture_id: Scalars['Int']['input'];
};

export type SubtitleLanguagePayload = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | SubtitleProcess;

export type SubtitleProcess = {
  __typename?: 'SubtitleProcess';
  video_lecture_id?: Maybe<Scalars['ID']['output']>;
};

export type SubtitleProcessInputs = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  transcript_segment_group_id: Scalars['ID']['input'];
};

export type SubtitleProcessMutation = {
  __typename?: 'SubtitleProcessMutation';
  create_original_language_subtitle: AddSubtitleSrt;
  create_subtitle_multiple_language: SubtitleLanguagePayload;
};


export type SubtitleProcessMutationCreate_Original_Language_SubtitleArgs = {
  inputs: SubtitleProcessInputs;
};


export type SubtitleProcessMutationCreate_Subtitle_Multiple_LanguageArgs = {
  input: SubtitleLanguageInput;
};

export type SuccessCore = {
  __typename?: 'SuccessCore';
  successful: Scalars['Boolean']['output'];
};

export type SuccessType = {
  __typename?: 'SuccessType';
  successful: Scalars['Boolean']['output'];
};

/** A confirmed or identified succession candidate for a position. */
export type SuccessionCandidateNode = {
  __typename?: 'SuccessionCandidateNode';
  /** Match percentage 0–100 calculated by the evaluation engine */
  fit_score: Scalars['Float']['output'];
  /** Primary key of the candidate record */
  id: Scalars['Int']['output'];
  /** FK to OrganizationPosition */
  position_id: Scalars['Int']['output'];
  /** Name of the associated position */
  position_name?: Maybe<Scalars['String']['output']>;
  /** Public URL of candidate avatar image */
  profile_image_url?: Maybe<Scalars['String']['output']>;
  /** Readiness level derived from fit_score. SHORT_TERM ≥85, MEDIUM_TERM ≥70, LONG_TERM ≥50, NOT_READY <50 */
  readiness: ReadinessLevelEnum;
  /** Timestamp when promoted to SELECTED. Null if status=IDENTIFIED */
  selected_at?: Maybe<Scalars['DateTime']['output']>;
  /** Lifecycle status: IDENTIFIED (suggested) or SELECTED (confirmed successor) */
  status: Scalars['String']['output'];
  /** Origin of suggestion: AI (engine) or MANUAL (nominated by a user) */
  suggested_by_type: SuggestedByTypeEnum;
  /** FK to the User who nominated manually. Null when suggested_by_type=AI */
  suggested_by_user_id?: Maybe<Scalars['Int']['output']>;
  /** Candidate full name */
  user_full_name?: Maybe<Scalars['String']['output']>;
  /** FK to User (the succession candidate) */
  user_id: Scalars['Int']['output'];
  /** Federated user reference resolved by user_id */
  user_info?: Maybe<CentralizedUserAts>;
};

export type SuccessionCoverageDashboardInput = {
  /** ID of the centralized organization */
  centralized_organization_id: Scalars['Int']['input'];
};

/** Aggregate metrics for the succession coverage dashboard */
export type SuccessionCoverageDashboardPayload = {
  __typename?: 'SuccessionCoverageDashboardPayload';
  by_criticality: Array<CoverageByCriticalityNode>;
  coverage_percentage: Scalars['Float']['output'];
  covered_positions: Scalars['Int']['output'];
  last_updated_at?: Maybe<Scalars['DateTime']['output']>;
  total_positions: Scalars['Int']['output'];
  uncovered_percentage: Scalars['Float']['output'];
  uncovered_positions: Scalars['Int']['output'];
};

export type SuccessionCoverageDashboardResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | SuccessionCoverageDashboardPayload | ValidationErrorResponse;

export type SuccessionCoverageListInput = {
  /** ID of the centralized organization */
  centralized_organization_id: Scalars['Int']['input'];
  /** Filter by a specific criticality level */
  criticality_level?: InputMaybe<OrganizationPositionCriticalityLevelEnum>;
  /** True = only positions with successors. False = uncovered positions. */
  has_confirmed_successor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pagination parameters */
  pagination?: InputMaybe<OffsetPaginationInput>;
  /** Filter by generic search on name or code */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated list of succession coverage rows */
export type SuccessionCoverageListPayload = {
  __typename?: 'SuccessionCoverageListPayload';
  pagination: SuccessionCoveragePaginationMetadata;
  results: Array<SuccessionCoverageRowNode>;
};

export type SuccessionCoverageListResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | SuccessionCoverageListPayload | ValidationErrorResponse;

/** Pagination data for lists */
export type SuccessionCoveragePaginationMetadata = {
  __typename?: 'SuccessionCoveragePaginationMetadata';
  current_page: Scalars['Int']['output'];
  total_count: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

/** Represents a single row in the paginated succession coverage list */
export type SuccessionCoverageRowNode = {
  __typename?: 'SuccessionCoverageRowNode';
  /** Position Code */
  code?: Maybe<Scalars['String']['output']>;
  /** Position Criticality (HIGH, MEDIUM, LOW) */
  criticality_level?: Maybe<OrganizationPositionCriticalityLevelEnum>;
  /** True if at least one candidate was generated by AI */
  has_ai_suggestions: Scalars['Boolean']['output'];
  /** True if selected_count > 0 */
  has_confirmed_successor: Scalars['Boolean']['output'];
  /** Position name */
  name: Scalars['String']['output'];
  position_id: Scalars['ID']['output'];
  /** Total number of candidates with status=SELECTED */
  selected_count: Scalars['Int']['output'];
};

/** Origin of the candidate suggestion: AI or MANUAL. */
export enum SuggestedByTypeEnum {
  Ai = 'AI',
  Manual = 'MANUAL'
}

export type SuggestedPromptNode = {
  __typename?: 'SuggestedPromptNode';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
};

/** Product suite license details */
export type SuiteLicenseNode = {
  __typename?: 'SuiteLicenseNode';
  /** Remaining available licenses */
  available_licenses: Scalars['Int']['output'];
  /** License expiration date */
  ends_at?: Maybe<Scalars['Date']['output']>;
  /** License ID */
  id: Scalars['Int']['output'];
  /** Whether the license record is active (not soft-deleted) */
  is_active: Scalars['Boolean']['output'];
  /** Whether the license is currently within its validity period (not expired) */
  is_valid: Scalars['Boolean']['output'];
  /** License type (SEAT, CONCURRENT, UNLIMITED) */
  license_type: Scalars['String']['output'];
  /** License activation date */
  starts_at?: Maybe<Scalars['Date']['output']>;
  /** Total licenses allocated */
  total_licenses: Scalars['Int']['output'];
  /** Percentage of licenses in use */
  usage_percentage: Scalars['Float']['output'];
  /** Licenses currently assigned to users */
  used_licenses: Scalars['Int']['output'];
};

/** Aggregated license totals across all bags for a suite */
export type SuiteLicenseSummaryNode = {
  __typename?: 'SuiteLicenseSummaryNode';
  /** Total available licenses */
  available_licenses: Scalars['Int']['output'];
  /** Total licenses across all active bags */
  total_licenses: Scalars['Int']['output'];
  /** Overall percentage of licenses in use */
  usage_percentage: Scalars['Float']['output'];
  /** Total licenses assigned to users */
  used_licenses: Scalars['Int']['output'];
};

export type SuperAdminMutations = {
  __typename?: 'SuperAdminMutations';
  /** Create a new super admin */
  create_super_admin: CentralizedCreateSuperAdminResponseCorporationsResponseIntegrityErrorCorporationsResponseInternalErrorCorporationsResponseValidationErrorCorporationsNotFoundResponseError;
};


export type SuperAdminMutationsCreate_Super_AdminArgs = {
  input: CentralizedCreateSuperAdminInput;
};

export type SuspendContractInput = {
  centralized_user_id: Scalars['Int']['input'];
  contract_id: Scalars['UUID']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
  suspension_reason: Scalars['String']['input'];
};

export type SuspendContractResponse = {
  __typename?: 'SuspendContractResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmployeeContractType;
};

export type SuspendContractResult = InternalErrorResponse | NotFoundErrorResponse | SuspendContractResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type SwitchedUserPayload = {
  __typename?: 'SwitchedUserPayload';
  impersonated_user_id: Scalars['String']['output'];
  impersonated_users_list?: Maybe<Array<ImpersonatedUsersType>>;
  impersonating_user_id: Scalars['String']['output'];
};

export type SwitchedUserPayloadSecurityMutationErrorInternalServerMutationErrorCreateJwtError = CreateJwtError | InternalServerMutationError | SecurityMutationError | SwitchedUserPayload;

export type SwitchedUserPayloadSecurityMutationErrorInternalServerMutationErrorCreateJwtErrorLoginMutationPayload = CreateJwtError | InternalServerMutationError | LoginMutationPayload | SecurityMutationError | SwitchedUserPayload;

export type SyncCustomFieldsResponse = {
  __typename?: 'SyncCustomFieldsResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type SyncOrganizationPolicyBalanceInput = {
  batch_size?: InputMaybe<Scalars['Int']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
};

export type SyncOrganizationPolicyBalanceResponse = {
  __typename?: 'SyncOrganizationPolicyBalanceResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type SyncPositionEvaluationIndicatorsInput = {
  /** List of evaluation indicators to sync with the position */
  evaluation_indicators: Array<PositionEvaluationIndicatorInput>;
  organization_id: Scalars['Int']['input'];
  organization_slug: Scalars['String']['input'];
  position_id: Scalars['Int']['input'];
};

/** Payload returned after syncing a position's evaluation indicators */
export type SyncPositionEvaluationIndicatorsPayload = {
  __typename?: 'SyncPositionEvaluationIndicatorsPayload';
  organization_position_id: Scalars['ID']['output'];
  position?: Maybe<OrganizationPositionNode>;
};

export type SyncPositionEvaluationIndicatorsResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | SyncPositionEvaluationIndicatorsPayload | ValidationErrorResponse;

export type SyncUserPolicyBalanceInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
};

export type SyncUserPolicyBalanceResponse = {
  __typename?: 'SyncUserPolicyBalanceResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type SyncUserResponse = {
  __typename?: 'SyncUserResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type SynchronizeUserAvatarFromLearningInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
};

/** definicion del proceso seleccionado */
export type TModuleProcessData = {
  __typename?: 'TModuleProcessData';
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** This node presents the 3 boxes that are presented in the data and monitoring tab */
export type TabDataAndMonitoringNode = {
  __typename?: 'TabDataAndMonitoringNode';
  box_one: MostCommonEvent;
  box_three: MostRequestedRewardNode;
  box_two: MostCommonEvent;
};

export type TabRedemptionNode = {
  __typename?: 'TabRedemptionNode';
  box_one?: Maybe<Scalars['String']['output']>;
  box_three?: Maybe<Scalars['String']['output']>;
  box_two?: Maybe<Scalars['String']['output']>;
};

export type TabRewardNode = {
  __typename?: 'TabRewardNode';
  box_one?: Maybe<Scalars['String']['output']>;
  box_three?: Maybe<Scalars['String']['output']>;
  box_two?: Maybe<Scalars['String']['output']>;
};

export type TagType = {
  __typename?: 'TagType';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization_id?: Maybe<Scalars['Int']['output']>;
};

export type TagWithCountersType = {
  __typename?: 'TagWithCountersType';
  crehana_count: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  own_count: Scalars['Int']['output'];
  third_party_count: Scalars['Int']['output'];
  total_count: Scalars['Int']['output'];
};

export type TagWithCountersTypePaginationEdge = {
  __typename?: 'TagWithCountersTypePaginationEdge';
  /** The item at the end of the edge. */
  node: TagWithCountersType;
};

/** A user mentioned (@) in a post or comment. */
export type TaggedUserNode = {
  __typename?: 'TaggedUserNode';
  /** The ID of the tagged user. */
  id: Scalars['Int']['output'];
  /** Whether the tagged user is active in the organization. */
  is_active: Scalars['Boolean']['output'];
  /** The name of the tagged user. */
  name: Scalars['String']['output'];
};

/** Input to activate a DRAFT competence model. */
export type TalentActivateCompetencesModelInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competence model to activate. */
  competences_model_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentActivateCompetencesModelResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentActivateCompetencesModelPayload | ValidationErrorV2;

/** Input to add one or more evaluated employees to an active 360 evaluation. Either provide an explicit ``employees_id`` list, or set ``select_all=true`` to target every active employee of the company that is not already participating in the evaluation. The batch is atomic: if any evaluated fails, no questionnaires are persisted. */
export type TalentAddEvaluatedToEvaluationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The IDs of the employees to add as evaluated to the evaluation. Each receives its own AUTO / BOSS / SUBORDINATE / COWORKER questionnaire matrix. Ignored when ``select_all`` is true. Duplicates are de-duplicated. */
  employees_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The ID of the active 360 evaluation that will receive the evaluated employees. */
  evaluation_id: Scalars['ID']['input'];
  /** When true, the use case resolves every active employee of the company that is not already a participant of this evaluation and adds them all. ``employees_id`` is ignored in this case. */
  select_all?: InputMaybe<Scalars['Boolean']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentAddEvaluatedToEvaluationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentAddEvaluatedToEvaluationPayload | ValidationErrorV2;

export type TalentAddEvaluatorsEvaluationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Evaluated employee ID */
  evaluated_id: Scalars['ID']['input'];
  /** Evaluation ID */
  evaluation_id: Scalars['ID']['input'];
  /** List of evaluators with their relation to the evaluated */
  evaluators: Array<TalentEvaluatorRelationInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentAddEvaluatorsEvaluationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentAddEvaluatorsEvaluationPayload | ValidationErrorV2;

export type TalentAddRecognitionCommentCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The text of the comment. Persisted as recognition_comment.comment, TRIMMED of leading and trailing whitespace. RN-09 / AC-2: the length OF THE TRIMMED text must be between 3 and 500 characters — under 3 answers ValidationErrorV2 COMMENT_TOO_SHORT, over 500 answers COMMENT_TOO_LONG, and both bounds are INCLUSIVE. So an empty string and a whitespace-only string are both TOO_SHORT, and a 504-character input padded with two spaces on each side is accepted and stored as its 500 real characters. The rule is enforced server-side even though the client also enforces it. IT IS CHECKED FIRST of all the checks, in the input itself: a two-character comment answers COMMENT_TOO_SHORT before anything else is read, including for a recognition the caller cannot touch. */
  comment: Scalars['String']['input'];
  /** innpulsa.recognitionemployee.id of the recognition being commented. Stays an Int! and stays OUTSIDE the identity envelope (G-05): it is the domain id of the target, not the identity of the caller. It must clear the SAME visibility predicate the wall uses, so anything the feed does not list cannot be commented either: it must exist, belong to talent_company_id, be staterequest = APPROVED (RN-02), still be available (U4), sit inside the one-year senddate window (RN-03) and be either PUBLIC or a recognition the CALLER took part in. IT IS NOT RANGE-CHECKED: a value <= 0 is not told apart from an unreachable one, so every id that is not a writable recognition of this wall collapses into the SAME NotFoundErrorV2 RECOGNITION_NOT_FOUND and the id space is not enumerable. A PRIVATE recognition is commentable ONLY by its SENDER and its RECEIVER — the same two people get_recognition_post_detail_collaborator opens it for — and answers that same not-found to every other caller. THIS IS NOW THE ONLY SERVER-SIDE GATE OF THE WRITE: RN-10 (option_comments) no longer refuses anything here, so a company that turned comments off in its plan is commented like any other — that flag governs the feed and recognitionemployee.comments_option, not recognition_comment. The only fault that still wins over this one is the comment itself being outside the 3..500 range, which is refused before everything else. */
  recognition_employee_id: Scalars['Int']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator making the request. REQUIRED at resolve time: an absent, non-positive or non-canonical value answers NotAuthenticatedErrorV2 NOT_AUTHENTICATED. It is also the row's AUTHOR, persisted as recognition_comment.emisor_employee_id (the U1 audit pair, AC-4). */
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentAddRecognitionCommentCollaboratorPayload = {
  __typename?: 'TalentAddRecognitionCommentCollaboratorPayload';
  /** recognition_comment.id of the row this call created, generated by the sequence recognition.seq_recognition_comment. IT IS THE WHOLE PAYLOAD: the comment row itself is not served any more, so a client that needs the author, the creation instant or the text as stored re-reads the thread through list_recognition_comments_collaborator — where this comment is the LAST one, because the thread is ordered createddate ASC and this row is stamped now — and matches it by this id. It is also the id the reaction mutation needs to like this comment (RN-08). EVERY successful call creates a NEW row and answers a NEW id: the write is not idempotent, so a client that retries a request whose response it lost gets a second comment and not the first one's id again. */
  id: Scalars['Int']['output'];
};

export type TalentAddRecognitionCommentCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentAddRecognitionCommentCollaboratorPayload | ValidationErrorV2;

export type TalentAdministratorTimelineInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  month_number: Scalars['Int']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  year_number?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentAdvancedConfigurationInput = {
  enable_result_evaluate?: InputMaybe<Scalars['Boolean']['input']>;
  hide_relations?: InputMaybe<Scalars['Boolean']['input']>;
  penalize_evaluation_not_finished?: InputMaybe<Scalars['Boolean']['input']>;
  quit_results_in_zero?: InputMaybe<Scalars['Boolean']['input']>;
  show_all_relations?: InputMaybe<Scalars['Boolean']['input']>;
  show_in_platform?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TalentAvailableMedalsToSendFilterInput = {
  /** Filter by leader-exclusive medals — recognitioncompany.leader. true returns only leader-exclusive medals, false only the medals every collaborator can send, null (default) returns both. Replaces the legacy ?leader= query param. Note this is a CATALOG filter, not a permission check: whether the collaborator may send at all is answered by get_can_send_recognition_collaborator (RN-02 / RN-20). */
  is_leader?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TalentAvatar = {
  __typename?: 'TalentAvatar';
  absolute_url: Scalars['String']['output'];
  relative_url: Scalars['String']['output'];
};

export type TalentBaseEvaluation = {
  __typename?: 'TalentBaseEvaluation';
  company_id?: Maybe<Scalars['Int']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type TalentBasePaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentBasicModuleInfo = {
  __typename?: 'TalentBasicModuleInfo';
  module?: Maybe<TalentProcessTypeEnum>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TalentBehavior = {
  __typename?: 'TalentBehavior';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TalentBehaviorRelationResult = {
  __typename?: 'TalentBehaviorRelationResult';
  behavior?: Maybe<TalentBehavior>;
  relation_type?: Maybe<TalentRelationTypeEnum>;
  relation_weight?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<TalentResult>;
};

export type TalentBehaviorResult = {
  __typename?: 'TalentBehaviorResult';
  behavior?: Maybe<TalentBehavior>;
  behavior_weight?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Array<Maybe<TalentComment>>>;
  relation_results?: Maybe<Array<Maybe<TalentBehaviorRelationResult>>>;
  total_result?: Maybe<TalentResult>;
};

export type TalentCanSendRecognitionCollaboratorPayload = {
  __typename?: 'TalentCanSendRecognitionCollaboratorPayload';
  /** Situational state of the collaborator against the gating rules. */
  context: TalentCanSendRecognitionContext;
  /** Budget metrics of the sender in the current window. */
  statistics: TalentCanSendRecognitionStatistics;
};

export type TalentCanSendRecognitionContext = {
  __typename?: 'TalentCanSendRecognitionContext';
  /** Whether the collaborator is ACTIVE in the company whitelist (RN-03). Reported always, even when whitelist management is switched off in the configuration — it only constrains the verdict when has_participant_management is true. Named after has_participant_management of the configuration plan; the PRD calls the same value is_partaker. */
  is_participant: Scalars['Boolean']['output'];
};

export type TalentCanSendRecognitionStatistics = {
  __typename?: 'TalentCanSendRecognitionStatistics';
  /** Points left to send in the window: the company limit minus total_points_sent, never negative. Null when the company has no points cap, so the app hides the indicator (RN-05 / RN-22). */
  available_points?: Maybe<Scalars['Int']['output']>;
  /** Points the collaborator has ALREADY spent in the current budget window: SUM of the level points of every recognition they sent with a state other than REJECTED (PENDING consumes too, RN-10) and not granted on their behalf by an admin. Always present, also when the company has no cap — it then reports without constraining. */
  total_points_sent: Scalars['Int']['output'];
};

export type TalentClimateAdministratorNom035 = {
  __typename?: 'TalentClimateAdministratorNom035';
  talent_climate_nom035_administrator: TalentClimateNom035Administrator;
};

export type TalentClimateAdministratorNom035Mutations = {
  __typename?: 'TalentClimateAdministratorNom035Mutations';
  talent_climate_nom035_administrator: TalentClimateNom035AdministratorMutations;
};

export type TalentClimateCollaboratorNom035 = {
  __typename?: 'TalentClimateCollaboratorNom035';
  talent_climate_nom035_collaborator: TalentClimateNom035Collaborator;
};

export type TalentClimateCollaboratorNom035Mutations = {
  __typename?: 'TalentClimateCollaboratorNom035Mutations';
  talent_climate_nom035_collaborator: TalentClimateNom035CollaboratorMutations;
};

export type TalentClimateMutation = {
  __typename?: 'TalentClimateMutation';
  /** Collaborator (respondent) climate-survey mutations. */
  talent_climate_collaborator: ClimateCollaboratorMutation;
};

export type TalentClimateNom035Administrator = {
  __typename?: 'TalentClimateNom035Administrator';
  /** Precarga de la configuración del Paso 1 (wizard NOM035, modo edición): devuelve la evaluación completa + la fila nom035_configuration + el state derivado. Aislada a la empresa del usuario (U2); un id inexistente / de otra empresa resuelve NotFoundErrorV2 (nunca filtra otra evaluación). */
  get_evaluation_config_nom035_admin: TalentNom035GetEvaluationConfigAdminResponse;
  /** Catálogo fijo de guías de referencia NOM035 + headcount de la empresa + guía sugerida (RN-6/RN-7) para el Paso 2 del wizard. Aislado a la empresa del usuario (U2, headcount por empresa). */
  get_reference_guides_nom035_admin: TalentNom035GetReferenceGuidesAdminResponse;
  /** List the NOM035 evaluations (processes) of the admin's company with the full evaluation entity, calculated progress and the BE-derived state, with name search, optional state filter and server-side pagination. Company isolation is by data (talent_company_id). */
  list_evaluations_nom035_admin: TalentNom035ListEvaluationsAdminResponse;
  /** Lista los colaboradores que AÚN NO participan (buscador del popup 'Agregar participante'): empleados de la empresa sin questionnaire2 activo en la evaluación (nunca agregados o excluidos/CANCELED). Mismo nodo que participantes; questionnaire es nullable (fila CANCELED si fue excluido, null si nunca participó). Búsqueda, filtros y paginación. Aislada a la empresa del admin (U2). */
  list_non_participants_nom035_admin: TalentNom035ListNonParticipantsAdminResponse;
  /** Lista los PARTICIPANTES activos de una evaluación NOM035 (Paso 2): colaboradores con un questionnaire2 relation=AUTO y state <> CANCELED. Cada nodo trae el colaborador (Categoría=company_level, Departamento=division, Cargo=job) + su cuestionario. Búsqueda por nombre, filtros por Categoría/División y paginación server-side. Aislada a la empresa del admin (U2, vía evaluation.company_id). El permiso CLIMATE-create lo gobierna el FE/gateway. */
  list_participants_nom035_admin: TalentNom035ListParticipantsAdminResponse;
  /** Dashboard 'Estado del proceso' (E5): lista los EVALUADOS activos de una evaluación NOM035 (questionnaire2 con state <> CANCELED) + los contadores de la cabecera. Cada nodo trae el colaborador (Categoría=company_level, Departamento=division, Cargo=job) y su cuestionario, con el badge de Estado (ASSIGNED='Pendiente' / IN_PROGRESS='En progreso' / FINISHED='Finalizada'). Búsqueda por NOMBRE COMPLETO, filtros por Categoría/Departamento/Estado/Evaluadores y paginación, todos server-side (RN-2). metadata trae la dona (answered/total), 'Total de evaluados', el state2 CRUDO de la evaluación, su fecha fin/inicio (formato legacy UTC-0 sin 'Z'), su zona horaria e is_closed (derivado: enddate < now(), RN-4). Aislada a la empresa del admin (U2, vía evaluation.company_id): una evaluación inexistente o de otra empresa resuelve NotFoundErrorV2, nunca una página vacía. ⚠ Esta LECTURA no está gateada por permiso: 'CLIMATE – create' (→ ClimateAdminEdit) es el permiso de ESCRITURA de la pantalla, y sin él el dashboard se renderiza COMPLETO en SOLO LECTURA (front-v1); el acceso al tab lo gatea el producto TALENT_CLIMATE en el ruteo del FE, que ni siquiera dispara esta query. ForbiddenErrorV2 queda en la unión solo por forma del contrato. */
  list_questionnaires_nom035_admin: TalentNom035ListQuestionnairesAdminResponse;
  /** Valida en tiempo real si ya existe una evaluación NOM035 con ese nombre en la empresa (unicidad, RN nombre único). Devuelve un booleano: true = el nombre ya está en uso. Aislado por empresa (U2, talent_company_id). */
  validate_evaluation_name_nom035_admin: TalentNom035ValidateEvaluationNameAdminResponse;
};


export type TalentClimateNom035AdministratorGet_Evaluation_Config_Nom035_AdminArgs = {
  input: TalentNom035GetEvaluationConfigAdminInput;
};


export type TalentClimateNom035AdministratorGet_Reference_Guides_Nom035_AdminArgs = {
  input: TalentNom035GetReferenceGuidesAdminInput;
};


export type TalentClimateNom035AdministratorList_Evaluations_Nom035_AdminArgs = {
  input: TalentNom035ListEvaluationsAdminInput;
};


export type TalentClimateNom035AdministratorList_Non_Participants_Nom035_AdminArgs = {
  input: TalentNom035ListNonParticipantsAdminInput;
};


export type TalentClimateNom035AdministratorList_Participants_Nom035_AdminArgs = {
  input: TalentNom035ListParticipantsAdminInput;
};


export type TalentClimateNom035AdministratorList_Questionnaires_Nom035_AdminArgs = {
  input: TalentNom035ListQuestionnairesAdminInput;
};


export type TalentClimateNom035AdministratorValidate_Evaluation_Name_Nom035_AdminArgs = {
  input: TalentNom035ValidateEvaluationNameAdminInput;
};

export type TalentClimateNom035AdministratorMutations = {
  __typename?: 'TalentClimateNom035AdministratorMutations';
  /** Agrega participantes desde el popup 'Agregar participante' (RN-4): crea/revive un questionnaire2 (AUTO) para los colaboradores dados; select_all agrega a todos los no-participantes. Idempotente (U3). Devuelve graphql_operation_id (el FE relee con list_participants). Aislada (U2) y auditada (U1). */
  add_participants_nom035_admin: TalentNom035AddParticipantsAdminResponse;
  /** Crea la encuesta NOM035 en estado 'En borrador' desde '+ Crear encuesta' (RN-11): INSERTa la evaluación (dtype='FormEvaluation', step=2) + la fila nom035_configuration con los defaults RN-14, y devuelve la entidad completa (id nuevo + defaults + state DRAFT) para rutear al wizard. Aislada a la empresa del usuario (U2), idempotente (un borrador vacío se reutiliza, U3) y auditada (U1). */
  create_draft_evaluation_nom035_admin: TalentNom035CreateDraftEvaluationAdminResponse;
  /** Soft-delete (mark inactive) a NOM035 evaluation of the admin's company. Only allowed while the derived state is DRAFT or NOT_STARTED (RN-6); any other state returns ValidationErrorV2 (INVALID_STATE). The data is never physically removed and the delete is audited (who / when / what, AC-5). Company isolation is by data (talent_company_id): an id from another company is a not-found. The CLIMATE-create permission is enforced by the gateway/FE, not here. */
  delete_evaluation_nom035_admin: TalentNom035DeleteEvaluationAdminResponse;
  /** Elimina UN cuestionario del dashboard 'Estado del proceso' (kebab de la fila -> 'Eliminar', RN-6): SOFT DELETE questionnaire2.state='CANCELED' (U4 — questionnaire2 no tiene columna deleteddate, así que CANCELED ES el borrado lógico). La fila y sus respuestas de innpulsa.form_data se conservan (solo reiniciar borra respuestas) y la fila deja de aparecer en el listado. Disponible en CUALQUIER estado (ASSIGNED / IN_PROGRESS / FINISHED) e idempotente (U3: repetirlo sobre una fila ya CANCELED responde éxito sin volver a descontar 'Total de evaluados'). ⚠ RN-6 se detiene a nivel de PROCESO: si está cerrado a escritura (ventana vencida O state2=FINISHED, decisión D4) rechaza con 4001_EVALUATION_CLOSED — borrar en un proceso cerrado cambiaría el denominador de un resultado ya reportado. Devuelve los contadores recalculados (el FE quita la fila sin refetch). Aislada a la empresa (U2) y auditada (U1). El permiso CLIMATE-create lo gobierna el FE/gateway. */
  delete_questionnaire_nom035_admin: TalentNom035DeleteQuestionnaireAdminResponse;
  /** Excluye participantes (ícono de papelera / opt-out): soft-delete (state=CANCELED) de los questionnaire2 dados (participants_id = questionnaire2.id); select_all excluye a todos los activos. Idempotente (U3), soft-delete (U4). Devuelve graphql_operation_id (el FE relee con list_participants). Aislada (U2) y auditada (U1). */
  exclude_participants_nom035_admin: TalentNom035ExcludeParticipantsAdminResponse;
  /** Genera los participantes de la encuesta al pasar del Paso 1 al Paso 2 (RN-3/RN-4): crea un questionnaire2 (relation=AUTO, evaluator_id=evaluated_id, state=ASSIGNED) por cada colaborador ACTIVO de la empresa. Idempotente (U3): si la evaluación YA tiene cuestionarios cargados (ASSIGNED, IN_PROGRESS o FINISHED) no genera nada — no crea ni reescribe participantes (no-op) — y nunca duplica ni revive a los excluidos. Devuelve graphql_operation_id (el FE relee con list_participants). Aislada a la empresa (U2) y auditada (U1). El permiso CLIMATE-create lo gobierna el FE/gateway. */
  generate_participants_nom035_admin: TalentNom035GenerateParticipantsAdminResponse;
  /** Genera el EXCEL de progreso / participación de una evaluación NOM035 (combobox 'Reportes' -> 'Progreso de la evaluación'). RECURSO NUEVO (decisión del dev C): los DATOS ya existían — son los mismos contadores que mueven la dona del dashboard más el estado por fila del listado —, lo que no existía era el RENDERER. SÍNCRONO y no por pereza: no tiene fan-out, lee contadores y filas de la BD transaccional sin pasar por el motor legacy Flex (y por lo tanto sin el timeout de 20 s por ítem), así que devuelve state OK con absolute_url en la PRIMERA respuesta y el FE no hace polling. El payload igual lleva state para que el FE maneje los 3 ítems del combobox con UN handler. Contadores calculados con el MISMO predicado que la dona, así que el archivo y la pantalla no pueden contradecirse; pending_count cubre ASSIGNED ('Pendiente') e IN_PROGRESS ('PENDING' NO existe en el enum). ⚠ NO aplica RN-13: una evaluación donde nadie contestó tiene progreso 0 %, que ES información — lo que sí se rechaza es una evaluación SIN evaluados (4001_NO_EVALUATED_PARTICIPANTS). ⚠ Tampoco aplica el guard de proceso cerrado (D4): un proceso cerrado sigue siendo reportable. Aislada a la empresa (U2), idempotente (U3: re-renderiza, no crea nada) y auditada (U1). El permiso CLIMATE-create lo gobierna el FE/gateway. */
  generate_progress_report_nom035_admin: TalentNom035GenerateProgressReportAdminResponse;
  /** Reinicia UN cuestionario del dashboard 'Estado del proceso' (kebab de la fila -> 'Reiniciar', RN-5): borra sus respuestas de innpulsa.form_data (borrado FÍSICO, excepción documentada a U4), devuelve el estado a ASSIGNED (badge 'Pendiente' — 'PENDING' NO existe en el enum), limpia open_date/end_date y regenera questionnaire2.securitycode. ⚠ El q_token del colaborador es base64(questionnaire2.id), calculado en RUNTIME y NO persistido: no se puede regenerar sin cambiar el id de la fila, así que el securitycode es lo único reseteable. Solo válido sobre FINISHED; sobre ASSIGNED es un no-op idempotente exitoso (U3); IN_PROGRESS/ERROR rechazan (4001_QUESTIONNAIRE_NOT_FINISHED) y CANCELED responde NotFoundErrorV2. Si el proceso está cerrado a escritura (ventana vencida O state2=FINISHED, decisión D4) rechaza con 4001_EVALUATION_CLOSED ANTES de mirar el estado de la fila. Devuelve la fila actualizada + los contadores recalculados (el FE repinta sin refetch). Aislada a la empresa (U2, vía evaluation.company_id) y auditada (U1). El permiso CLIMATE-create lo gobierna el FE/gateway, igual que el resto del módulo. */
  restart_questionnaire_nom035_admin: TalentNom035RestartQuestionnaireAdminResponse;
  /** Programa la evaluación (modal 'Programar evaluación'): escribe startdate/enddate (fecha + hora combinadas) + date_time_zone y transiciona el estado fuera de borrador (RN-10). NO crea cuestionarios. Valida al menos un participante activo (RN-7) y fin > inicio (RN-8). Devuelve graphql_operation_id (el FE relee la evaluación). Aislada (U2) y auditada (U1). */
  schedule_evaluation_nom035_admin: TalentNom035ScheduleEvaluationAdminResponse;
  /** Guardado single-shot del Paso 1 (RN-13): persiste los datos de la encuesta (nombre requerido máx. 50, imagen URL, temporizador en MINUTOS -> SEGUNDOS, preguntas por página 1..100), la guía y los toggles de una sola vez. TAMBIÉN es la operación de las 2 acciones de la cabecera del dashboard (TL-2143 E5), como PATCH DE CAMPO: editar fecha fin -> evaluation: { end_date }; finalizar encuesta -> evaluation: { state_2: FINISHED, end_date: <ahora en UTC-0, lo estampa el FE> }, configuration: {}. Rechazos con code propio: 4001_INVALID_PERIOD (la fecha fin debe ser posterior a la fecha de inicio ALMACENADA — por eso finalizar una evaluación que no arrancó se rechaza), 4001_EVALUATION_ALREADY_FINISHED (el proceso ya finalizó y no se reabre; reenviar FINISHED es un no-op exitoso que NO pisa la fecha del cierre original) y 4001_INVALID_STATE (por esta vía solo se finaliza; eliminar/inactivar va por el borrado lógico auditado). Devuelve graphql_operation_id (el FE relee con get_evaluation_config). Aislada a la empresa (U2), auditada (U1) e idempotente (U3). */
  update_evaluation_config_nom035_admin: TalentNom035UpdateEvaluationConfigAdminResponse;
};


export type TalentClimateNom035AdministratorMutationsAdd_Participants_Nom035_AdminArgs = {
  input: TalentNom035AddParticipantsAdminInput;
};


export type TalentClimateNom035AdministratorMutationsCreate_Draft_Evaluation_Nom035_AdminArgs = {
  input: TalentNom035CreateDraftEvaluationAdminInput;
};


export type TalentClimateNom035AdministratorMutationsDelete_Evaluation_Nom035_AdminArgs = {
  input: TalentNom035DeleteEvaluationAdminInput;
};


export type TalentClimateNom035AdministratorMutationsDelete_Questionnaire_Nom035_AdminArgs = {
  input: TalentNom035DeleteQuestionnaireAdminInput;
};


export type TalentClimateNom035AdministratorMutationsExclude_Participants_Nom035_AdminArgs = {
  input: TalentNom035ExcludeParticipantsAdminInput;
};


export type TalentClimateNom035AdministratorMutationsGenerate_Participants_Nom035_AdminArgs = {
  input: TalentNom035GenerateParticipantsAdminInput;
};


export type TalentClimateNom035AdministratorMutationsGenerate_Progress_Report_Nom035_AdminArgs = {
  input: TalentNom035GenerateProgressReportAdminInput;
};


export type TalentClimateNom035AdministratorMutationsRestart_Questionnaire_Nom035_AdminArgs = {
  input: TalentNom035RestartQuestionnaireAdminInput;
};


export type TalentClimateNom035AdministratorMutationsSchedule_Evaluation_Nom035_AdminArgs = {
  input: TalentNom035ScheduleEvaluationAdminInput;
};


export type TalentClimateNom035AdministratorMutationsUpdate_Evaluation_Config_Nom035_AdminArgs = {
  input: TalentNom035UpdateEvaluationConfigAdminInput;
};

export type TalentClimateNom035Collaborator = {
  __typename?: 'TalentClimateNom035Collaborator';
  /** List the NOM035 evaluations assigned to the authenticated collaborator. */
  list_dashboard_climate_nom035: TalentMyNom035QuestionnairesResponse;
  /** Return the full NOM035 questionnaire detail for a collaborator q_token: header, sections/questions, previous answers, progress and presentation config. Public (session-less): the q_token is the only credential and the company is decoded from it (RN-008/009). The 5 status pages + login are modelled as context.status, not errors. */
  nom035_questionnaire_detail: TalentNom035QuestionnaireDetailResponse;
};


export type TalentClimateNom035CollaboratorList_Dashboard_Climate_Nom035Args = {
  input: TalentListNom035QuestionnairesCollaboratorInput;
};


export type TalentClimateNom035CollaboratorNom035_Questionnaire_DetailArgs = {
  input: TalentNom035QuestionnaireDetailInput;
};

export type TalentClimateNom035CollaboratorMutations = {
  __typename?: 'TalentClimateNom035CollaboratorMutations';
  /** Genera un reporte NOM035 y devuelve su URL absoluta de descarga. DOS artefactos, un solo resolver, discriminados por input.report_type (TL-2143 E5, decisión del dev D2): REPORT_BY_COLLABORATOR_NOM035 = UN PDF de UN evaluado, SÍNCRONO (lo consume el kebab 'Descargar reporte' de la fila y el panel del colaborador que ya está en QA — es el DEFAULT, así que ese flujo no cambia); REPORT_INDIVIDUAL_NOM035 = un ZIP con el PDF de TODOS los evaluados, ASÍNCRONO (combobox 'Reportes individuales'): crea una instancia de generación, encola el job y devuelve state SENT/PROCESSING; el FE hace polling RE-ENVIANDO esta misma mutation con el input idéntico (no existe query de estado en el BE y no se inventó ninguna) y la instancia se reutiliza, no se duplica. ⚠ El ZIP es la cadena de N llamadas Flex type='Individual', NUNCA type='Massive' (que es el PDF agregado de empresa). Aislado a la empresa por datos (talent_company_id, U2: una evaluación de otra empresa es un not-found, nunca Forbidden) y auditado (U1). ⚠ NO está sujeto al guard de proceso cerrado: un proceso cerrado sigue siendo reportable. El permiso CLIMATE-create lo gobierna el FE/gateway. */
  generate_nom035_report: TalentGenerateNom035ReportResponse;
  /** Save ONE NOM035 answer for a collaborator q_token (save-per-question, RN-007). Idempotent upsert by (questionnaire, field) — a retry replaces the value, never duplicates it (RN-016). Returns the saved row + the updated progress. Public (session-less): the q_token is the only credential and the company is decoded from it (RN-008/009). */
  save_nom035_response: TalentNom035SaveResponseResponse;
  /** Finalize the NOM035 questionnaire for a collaborator q_token (RN-013): validate all required answers on the server, register the submit date and leave it FINISHED (no longer answerable). Idempotent — a retry returns the same submit date (RN-016). Public (session-less): the q_token is the only credential (RN-008/009). */
  submit_nom035_questionnaire: TalentNom035SubmitQuestionnaireResponse;
};


export type TalentClimateNom035CollaboratorMutationsGenerate_Nom035_ReportArgs = {
  input: TalentGenerateNom035ReportCollaboratorInput;
};


export type TalentClimateNom035CollaboratorMutationsSave_Nom035_ResponseArgs = {
  input: TalentNom035SaveResponseInput;
};


export type TalentClimateNom035CollaboratorMutationsSubmit_Nom035_QuestionnaireArgs = {
  input: TalentNom035SubmitQuestionnaireInput;
};

export type TalentClimateNom035Mutations = {
  __typename?: 'TalentClimateNom035Mutations';
  talent_climate_administrator: TalentClimateAdministratorNom035Mutations;
  talent_climate_collaborator: TalentClimateCollaboratorNom035Mutations;
};

export type TalentClimateNom035Queries = {
  __typename?: 'TalentClimateNom035Queries';
  talent_climate_administrator: TalentClimateAdministratorNom035;
  talent_climate_collaborator: TalentClimateCollaboratorNom035;
};

export type TalentClimateQuery = {
  __typename?: 'TalentClimateQuery';
  /** Collaborator (respondent) climate-survey queries. */
  talent_climate_collaborator: ClimateCollaboratorQuery;
};

export type TalentComment = {
  __typename?: 'TalentComment';
  avatar_url: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  employee_id: Scalars['Int']['output'];
  employee_name?: Maybe<Scalars['String']['output']>;
  relation_type?: Maybe<TalentRelationTypeEnum>;
};

export type TalentCommentBoxInput = {
  code: Scalars['String']['input'];
  mandatory?: Scalars['Boolean']['input'];
  translations: Array<TalentCommentBoxTranslationInput>;
};

export type TalentCommentBoxTranslationInput = {
  label: Scalars['String']['input'];
  language_code: Scalars['String']['input'];
};

export type TalentCommentsInput = {
  boxes: Array<TalentCommentBoxInput>;
  by_behavior_enabled?: Scalars['Boolean']['input'];
  by_behavior_mandatory?: Scalars['Boolean']['input'];
  by_competence_enabled?: Scalars['Boolean']['input'];
  by_competence_mandatory?: Scalars['Boolean']['input'];
  final_comments_enabled?: Scalars['Boolean']['input'];
  final_comments_min_length?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentCompany = {
  __typename?: 'TalentCompany';
  domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<LanguageEnum>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TalentCompanyConfiguration = TalentCompanyConfigurationI & {
  __typename?: 'TalentCompanyConfiguration';
  configuration_profile_id?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  double_validation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parent?: Maybe<Scalars['String']['output']>;
  selected: Scalars['Boolean']['output'];
  state?: Maybe<Scalars['Boolean']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TalentCompanyConfigurationI = {
  configuration_profile_id?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  double_validation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Scalars['String']['output']>;
  selected: Scalars['Boolean']['output'];
  state?: Maybe<Scalars['Boolean']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TalentCompanyEmployeeFilterInput = {
  company_level_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  division_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  job_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  subsidiary_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TalentCompanyEmployeeSearchInput = {
  fields: Array<CompanyEmployeeFieldsEnum>;
  query: Scalars['String']['input'];
};

export type TalentCompanyEmployeeSortOrderInput = {
  direction?: OrderDirectionEnum;
  field: CompanyEmployeeSortOrderEnum;
};

export type TalentCompanyFilter = {
  __typename?: 'TalentCompanyFilter';
  filter_type: TalentCompanyFilterEnum;
  options: Array<TalentCompanyFilterOption>;
  total_options: Scalars['Int']['output'];
};

export enum TalentCompanyFilterEnum {
  City = 'CITY',
  CompanyLevel = 'COMPANY_LEVEL',
  Country = 'COUNTRY',
  Division = 'DIVISION',
  Gender = 'GENDER',
  Job = 'JOB',
  Subsidiary = 'SUBSIDIARY'
}

export type TalentCompanyFilterOption = {
  __typename?: 'TalentCompanyFilterOption';
  filter_id?: Maybe<Scalars['Int']['output']>;
  filter_name: Scalars['String']['output'];
};

export type TalentCompanyFiltersInfo = {
  __typename?: 'TalentCompanyFiltersInfo';
  filters: Array<TalentCompanyFilter>;
};

export type TalentCompanyFiltersInput = {
  company_id: Scalars['Int']['input'];
  employee_id?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Array<TalentCompanyFilterEnum>>;
};

export type TalentCompanyFiltersResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TalentCompanyFiltersInfo;

export type TalentCompanyLevel = {
  __typename?: 'TalentCompanyLevel';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TalentCompanyLevelInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCompanyMailTemplateFilterInput = {
  code_in?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input to search company mail templates by code and subject */
export type TalentCompanyMailTemplateSearchInput = {
  fields: Array<CompanyMailTemplateFieldsEnum>;
  query: Scalars['String']['input'];
};

export type TalentCompanyMailTemplateSortOrderInput = {
  direction?: OrderDirectionEnum;
  field: CompanyMailTemplateSortOrderEnum;
};

export type TalentCompanyPerformanceConfigurationInput = {
  competences_evaluation_id?: InputMaybe<Scalars['Int']['input']>;
  competences_evaluation_report_template_id?: InputMaybe<Scalars['Int']['input']>;
  competences_percentage?: InputMaybe<Scalars['Int']['input']>;
  competences_result_format: CompetencesResultFormatEnum;
  date_from?: InputMaybe<Scalars['DateTime']['input']>;
  goals_percentage?: InputMaybe<Scalars['Int']['input']>;
  goals_period_id?: InputMaybe<Scalars['Int']['input']>;
  goals_result_type?: InputMaybe<GoalsResultTypeEnum>;
  limit_1?: InputMaybe<Scalars['Float']['input']>;
  limit_2?: InputMaybe<Scalars['Float']['input']>;
  limit_3?: InputMaybe<Scalars['Float']['input']>;
  limit_4?: InputMaybe<Scalars['Float']['input']>;
  limit_5?: InputMaybe<Scalars['Float']['input']>;
  okr_period_id?: InputMaybe<Scalars['Int']['input']>;
  report_template_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentCompanyRecognitionFeedCollaboratorConnection = {
  __typename?: 'TalentCompanyRecognitionFeedCollaboratorConnection';
  edges: Array<TalentCompanyRecognitionFeedCollaboratorEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type TalentCompanyRecognitionFeedCollaboratorEdge = {
  __typename?: 'TalentCompanyRecognitionFeedCollaboratorEdge';
  /** Position of the row in the FILTERED result set, base64-encoded the way every offset connection of this repo encodes it. IT IS NOT A STABLE POINTER TO A ROW and a client must not page with it: it is derived from the position and nothing else, so a recognition sent while the client scrolls shifts every cursor after it by one. Paging is `pagination`, always. */
  cursor: Scalars['String']['output'];
  /** The card at the end of the edge. */
  node: TalentCompanyRecognitionFeedPost;
};

export type TalentCompanyRecognitionFeedFilterInput = {
  /** Which feed the collaborator is looking at. Null — the default — and the whole `filter` omitted are the SAME answer, TODOS: the absence of a filter is not a third feed. Semantics of each value are on the enum, and each one changes WHICH ROWS are listed and nothing else — the order, the page shape and the node are identical on the three segments. */
  feed_eq?: InputMaybe<TalentRecognitionFeedEqEnum>;
};

export type TalentCompanyRecognitionFeedPost = {
  __typename?: 'TalentCompanyRecognitionFeedPost';
  /** What is true about this card FOR THE COLLABORATOR IN SESSION — today, their own reaction. Nullable for the same envelope reason and always present here: a caller with no reaction gets a context whose reaction is null, never a null context. */
  context?: Maybe<TalentRecognitionEmployeeCallerContext>;
  /** The row of recognitionemployee — columns and joins only: the medal, both texts, the visibility, the corporate flag, the date, and the RECEIVER and SENDER resolved as the platform's own employee node. sender is null when is_from_admin is true (the organization granted the medal, not a person) — a client must read is_from_admin to decide 'corporate' and never sender == null, because the sender side is also null when the sender id no longer resolves to an employee. groups_info travels null on this read: the batch MARKER is group_id, and the roster is what opening the recognition loads — the same decision the CAC-1872 medal wall took, since a page of eight group cards would pay for eight rosters nobody opened. Nullable for envelope symmetry with the other node wrappers of this schema; every edge of this connection carries one. */
  recognition_employee?: Maybe<TalentRecognitionEmployee>;
  /** The four derived counters of this card, company-wide. Nullable for the same envelope reason and, likewise, always present here: a card with no interaction answers four zeros, never a null block. */
  statistics?: Maybe<TalentRecognitionEmployeeReactionsStatistics>;
};

export type TalentCompetence = {
  __typename?: 'TalentCompetence';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TalentCompetenceBehaviorFilter = {
  employee_id_eq?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentCompetenceEmployeeFilter = {
  employee_id_eq?: InputMaybe<Scalars['Int']['input']>;
  leader_id_eq?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentCompetenceFilter = {
  level_id_eq?: InputMaybe<Scalars['Int']['input']>;
  model_id_eq?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentCompetencesBehaviorsResult = {
  __typename?: 'TalentCompetencesBehaviorsResult';
  behaviors_results?: Maybe<Array<Maybe<TalentBehaviorResult>>>;
  comments?: Maybe<Array<Maybe<TalentComment>>>;
  competence?: Maybe<TalentCompetence>;
  total_result?: Maybe<TalentResult>;
};

/** Deprecated */
export type TalentCompetencesDetailedResult = {
  __typename?: 'TalentCompetencesDetailedResult';
  competence_id: Scalars['Int']['output'];
  competence_name: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  scale: Scalars['Float']['output'];
};

export type TalentCompetencesDivisionResult = {
  __typename?: 'TalentCompetencesDivisionResult';
  competences_results?: Maybe<Array<Maybe<TalentCompetencesResultByFilter>>>;
  division_result?: Maybe<TalentCompetencesDivisionTotalResult>;
};

export type TalentCompetencesDivisionTotalResult = {
  __typename?: 'TalentCompetencesDivisionTotalResult';
  competences_results?: Maybe<Array<Maybe<TalentCompetencesDetailedResult>>>;
  division_id: Scalars['Int']['output'];
  division_name: Scalars['String']['output'];
};

/** Deprecated */
export type TalentCompetencesEmployeeDetailedResult = {
  __typename?: 'TalentCompetencesEmployeeDetailedResult';
  competences_results?: Maybe<Array<Maybe<TalentCompetencesDetailedResult>>>;
  division_id: Scalars['Int']['output'];
  division_name: Scalars['String']['output'];
  employee_id: Scalars['Int']['output'];
  employee_name: Scalars['String']['output'];
  job_id: Scalars['Int']['output'];
  job_name: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  scale: Scalars['Float']['output'];
};

export type TalentCompetencesEmployeeResult = {
  __typename?: 'TalentCompetencesEmployeeResult';
  calculation_type?: Maybe<Scalars['String']['output']>;
  competences_results?: Maybe<Array<Maybe<TalentCompetencesResult>>>;
  employee?: Maybe<TalentEmployee>;
  process_id?: Maybe<Scalars['Int']['output']>;
  process_name?: Maybe<Scalars['String']['output']>;
  total_result?: Maybe<TalentResult>;
};

export type TalentCompetencesEmployeeResultByCompetence = {
  __typename?: 'TalentCompetencesEmployeeResultByCompetence';
  competence_result?: Maybe<TalentCompetencesResult>;
  employee?: Maybe<TalentEmployee>;
};

export type TalentCompetencesEmployeeResultDetailInput = {
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  centralized_user_id?: InputMaybe<Scalars['Int']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  employee_id?: InputMaybe<Scalars['Int']['input']>;
  process_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentCompetencesEmployeeResultResponse = ResponseInternalError | ResponseValidationError | TalentCompetencesEmployeeResult;

export type TalentCompetencesEvaluationDetail = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  evaluation_id: Scalars['Int']['input'];
  /** The talent company id owning the evaluation. */
  talent_company_id: Scalars['ID']['input'];
};

export type TalentCompetencesEvaluationDetailResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCompetencesDashboardUrlPayload | ValidationErrorV2;

export type TalentCompetencesGroupedResult = {
  __typename?: 'TalentCompetencesGroupedResult';
  competences_results?: Maybe<Array<Maybe<TalentCompetencesDetailedResult>>>;
  object_id?: Maybe<Scalars['Int']['output']>;
  object_name?: Maybe<Scalars['String']['output']>;
  object_type?: Maybe<TalentReportGroupingFilterEnum>;
  percentage?: Maybe<Scalars['Float']['output']>;
  scale?: Maybe<Scalars['Float']['output']>;
};

export type TalentCompetencesGroupedResultPayload = {
  __typename?: 'TalentCompetencesGroupedResultPayload';
  results?: Maybe<Array<Maybe<TalentCompetencesGroupedResult>>>;
};

export type TalentCompetencesModelI = {
  attachment_id?: Maybe<Scalars['Int']['output']>;
  behavior_weight_configuration?: Maybe<Scalars['Boolean']['output']>;
  company_id?: Maybe<Scalars['Int']['output']>;
  competence_weight_configuration?: Maybe<Scalars['Boolean']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  deleted_date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  field_macro_competence?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  last_inactivated_date?: Maybe<Scalars['DateTime']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  learning_file_id?: Maybe<Scalars['Int']['output']>;
  minimum_expected_configuration?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_model?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type_competence_model?: Maybe<Scalars['String']['output']>;
  user_admin?: Maybe<Scalars['Int']['output']>;
};

export type TalentCompetencesModelInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCompetencesModelSearchInput = {
  fields: Array<CompetencesModelFieldsEnum>;
  query: Scalars['String']['input'];
};

export enum TalentCompetencesModelSortOrderEnum {
  ModelName = 'MODEL_NAME'
}

export type TalentCompetencesModelSortOrderInput = {
  direction?: OrderDirectionEnum;
  field: TalentCompetencesModelSortOrderEnum;
};

/**  MUTATIONS */
export type TalentCompetencesMutations = {
  __typename?: 'TalentCompetencesMutations';
  create_competence_questionnaire_evaluators?: Maybe<ResponseExecutionCompetences>;
  create_competence_questionnaire_group?: Maybe<ResponseExecutionCompetences>;
  create_competence_similar_keys?: Maybe<ResponseExecutionCompetences>;
  delete_competence_questionnaire_evaluator?: Maybe<ResponseExecutionCompetences>;
  delete_competence_questionnaire_group?: Maybe<ResponseExecutionCompetences>;
  finish_competence_questionnaires?: Maybe<ResponseExecutionCompetences>;
  penalize_incomplete_evaluations?: Maybe<ResponseExecutionCompetences>;
  qualify_competence_questionnaire?: Maybe<ResponseQuestionnaireQualify>;
  save_questions_by_competences?: Maybe<ResponseExecutionCompetences>;
};


/**  MUTATIONS */
export type TalentCompetencesMutationsCreate_Competence_Questionnaire_EvaluatorsArgs = {
  input: QuestionnaireEvaluators;
};


/**  MUTATIONS */
export type TalentCompetencesMutationsCreate_Competence_Questionnaire_GroupArgs = {
  input: FilterCompetencesGroup;
};


/**  MUTATIONS */
export type TalentCompetencesMutationsCreate_Competence_Similar_KeysArgs = {
  questionnaire_id: Scalars['Int']['input'];
};


/**  MUTATIONS */
export type TalentCompetencesMutationsDelete_Competence_Questionnaire_EvaluatorArgs = {
  questionnaire_id: Scalars['Int']['input'];
};


/**  MUTATIONS */
export type TalentCompetencesMutationsDelete_Competence_Questionnaire_GroupArgs = {
  evaluation_id: Scalars['Int']['input'];
  group_key: Scalars['String']['input'];
};


/**  MUTATIONS */
export type TalentCompetencesMutationsFinish_Competence_QuestionnairesArgs = {
  employee_id: Scalars['Int']['input'];
  evaluation_id: Scalars['Int']['input'];
  questionnaires_id: Array<InputMaybe<Scalars['Int']['input']>>;
};


/**  MUTATIONS */
export type TalentCompetencesMutationsQualify_Competence_QuestionnaireArgs = {
  input: QuestionnaireQualify;
};


/**  MUTATIONS */
export type TalentCompetencesMutationsSave_Questions_By_CompetencesArgs = {
  competences_id: Array<InputMaybe<Scalars['Int']['input']>>;
  questionnaire_id: Scalars['Int']['input'];
};

/**  QUERIES */
export type TalentCompetencesQueries = {
  __typename?: 'TalentCompetencesQueries';
  get_competences_evaluation_configuration?: Maybe<ResponseCompetencesConfiguration>;
  get_competences_evaluation_questionnaire_detail?: Maybe<ResponseQuestionnaireDetail>;
  get_competences_evaluation_questionnaires?: Maybe<ResponseQuestionnaire>;
  get_competences_evaluations?: Maybe<ResponseCompetencesEvaluation>;
  get_competences_label_by_evaluation?: Maybe<ResponseCompetencesLabelByEvaluation>;
  get_competences_last_questionnaires_grade?: Maybe<ResponseQuestionnairesGrade>;
  get_competences_my_team_report?: Maybe<ResponseCompetenceReport>;
  get_competences_qualify_summary?: Maybe<ResponseQualifySummary>;
  get_competences_questionnaires_available_evaluators?: Maybe<ResponseCompetencesEmployee>;
  get_competences_questionnaires_evaluators?: Maybe<ResponseQuestionnaire>;
  get_competences_questionnaires_my_team?: Maybe<ResponseCompetenceMyTeam>;
  get_competences_questionnaires_my_team_stats?: Maybe<ResponseCompetenceStatMyTeam>;
  get_competences_questions_by_questionnaires?: Maybe<ResponseCompetenceGeneralForm>;
};


/**  QUERIES */
export type TalentCompetencesQueriesGet_Competences_Evaluation_ConfigurationArgs = {
  employee_id: Scalars['Int']['input'];
  evaluation_id: Scalars['Int']['input'];
};


/**  QUERIES */
export type TalentCompetencesQueriesGet_Competences_Evaluation_Questionnaire_DetailArgs = {
  employee_id: Scalars['Int']['input'];
  questionnaire_id: Scalars['Int']['input'];
};


/**  QUERIES */
export type TalentCompetencesQueriesGet_Competences_Evaluation_QuestionnairesArgs = {
  input?: InputMaybe<FilterCompetencesEvaluationQuestionnaire>;
};


/**  QUERIES */
export type TalentCompetencesQueriesGet_Competences_EvaluationsArgs = {
  input?: InputMaybe<FilterCompetencesEvaluation>;
};


/**  QUERIES */
export type TalentCompetencesQueriesGet_Competences_Label_By_EvaluationArgs = {
  collaborator_id: Scalars['Int']['input'];
  employee_id: Scalars['Int']['input'];
  evaluation_id: Scalars['Int']['input'];
};


/**  QUERIES */
export type TalentCompetencesQueriesGet_Competences_Last_Questionnaires_GradeArgs = {
  competence_id: Scalars['Int']['input'];
  employees_id: Array<InputMaybe<Scalars['Int']['input']>>;
  evaluation_id: Scalars['Int']['input'];
  evaluator_id: Scalars['Int']['input'];
};


/**  QUERIES */
export type TalentCompetencesQueriesGet_Competences_My_Team_ReportArgs = {
  employee_id: Scalars['Int']['input'];
  evaluation_id: Scalars['Int']['input'];
};


/**  QUERIES */
export type TalentCompetencesQueriesGet_Competences_Qualify_SummaryArgs = {
  employee_id: Scalars['Int']['input'];
  evaluation_id: Scalars['Int']['input'];
  questionnaires_id: Array<InputMaybe<Scalars['Int']['input']>>;
};


/**  QUERIES */
export type TalentCompetencesQueriesGet_Competences_Questionnaires_Available_EvaluatorsArgs = {
  input: FilterCompetencesQuestionnaireEvaluator;
};


/**  QUERIES */
export type TalentCompetencesQueriesGet_Competences_Questionnaires_EvaluatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  employee_id: Scalars['Int']['input'];
  evaluated_id: Scalars['Int']['input'];
  evaluation_id: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
};


/**  QUERIES */
export type TalentCompetencesQueriesGet_Competences_Questionnaires_My_TeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  employee_id: Scalars['Int']['input'];
  evaluation_id: Scalars['Int']['input'];
  filter_name?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**  QUERIES */
export type TalentCompetencesQueriesGet_Competences_Questionnaires_My_Team_StatsArgs = {
  employee_id: Scalars['Int']['input'];
  evaluation_id: Scalars['Int']['input'];
};


/**  QUERIES */
export type TalentCompetencesQueriesGet_Competences_Questions_By_QuestionnairesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  employee_id: Scalars['Int']['input'];
  evaluation_id: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  questionnaires_id: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type TalentCompetencesResult = {
  __typename?: 'TalentCompetencesResult';
  competence_id: Scalars['Int']['output'];
  competence_name: Scalars['String']['output'];
  result: TalentResult;
};

export type TalentCompetencesResultByFilter = {
  __typename?: 'TalentCompetencesResultByFilter';
  competences_results?: Maybe<Array<Maybe<TalentCompetencesDetailedResult>>>;
  object_id?: Maybe<Scalars['Int']['output']>;
  object_name?: Maybe<Scalars['String']['output']>;
};

export enum TalentCompetencesStateEnum {
  ActiveStatus = 'ACTIVE_STATUS',
  DeletedStatus = 'DELETED_STATUS',
  InactiveStatus = 'INACTIVE_STATUS'
}

/** TYPES */
export type TalentCompetencesTotalResult = {
  __typename?: 'TalentCompetencesTotalResult';
  competences_results?: Maybe<Array<Maybe<TalentCompetencesDetailedResult>>>;
  object_id: Scalars['Int']['output'];
  object_name?: Maybe<Scalars['String']['output']>;
  percentage: Scalars['Float']['output'];
  scale: Scalars['Float']['output'];
};

/** REPONSES */
export type TalentCompetencesTotalResultPayload = {
  __typename?: 'TalentCompetencesTotalResultPayload';
  results?: Maybe<Array<Maybe<TalentCompetencesTotalResult>>>;
};

/** UNIONS */
export type TalentCompetencesTotalResultResponse = ResponseInternalError | ResponseValidationError | TalentCompetencesTotalResultPayload;

export type TalentCreateBehaviorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competence level */
  competence_level_id: Scalars['ID']['input'];
  /** The minimum expected value for the behavior */
  min_expected?: InputMaybe<Scalars['Decimal']['input']>;
  /** Behavior name in English */
  name_en?: InputMaybe<Scalars['String']['input']>;
  /** Behavior name in Spanish */
  name_es?: InputMaybe<Scalars['String']['input']>;
  /** Behavior name in Portuguese */
  name_pt?: InputMaybe<Scalars['String']['input']>;
  /** The sequence of the behavior */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  /** The subgroup to which the behavior belongs */
  subgroup?: InputMaybe<Scalars['String']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** The weight of the behavior */
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type TalentCreateBehaviorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCreateBehaviorPayload | ValidationErrorV2;

export type TalentCreateCompetenceFilterInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** List of competence IDs included in this filter. */
  competence_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** ID of the competence model this filter belongs to. */
  competence_model_id?: InputMaybe<Scalars['ID']['input']>;
  /** List of division IDs used to match this filter. */
  division_filter_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of job IDs used to match this filter. */
  job_filter_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Display name of the competence filter. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of profile type IDs used to match this filter. */
  profile_filter_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of relation type IDs used to match this filter. */
  relation_filter_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCreateCompetenceFilterResponse = CompetenceWithoutBehaviorsErrorV2 | DuplicateFilterNameErrorV2 | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCreateCompetenceFilterPayload | ValidationErrorV2;

export type TalentCreateCompetenceInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competence model in edition or creation. */
  competence_model_id: Scalars['ID']['input'];
  competence_type_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  macro_competence?: InputMaybe<Scalars['String']['input']>;
  master_id?: InputMaybe<Scalars['ID']['input']>;
  min_expected?: InputMaybe<Scalars['Decimal']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  sector_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  update_results_not_include?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TalentCreateCompetenceLevelInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competence in edition or creation. */
  competence_id: Scalars['ID']['input'];
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the category level in competence. */
  level_id: Scalars['ID']['input'];
  min_expected?: InputMaybe<Scalars['Float']['input']>;
  minimum?: InputMaybe<Scalars['Float']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type TalentCreateCompetenceLevelResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCreateCompetenceLevelPayload | ValidationErrorV2;

export type TalentCreateCompetenceResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCreateCompetencePayload | ValidationErrorV2;

export type TalentCreateCompetencesModelInput = {
  behavior_weight_configuration?: InputMaybe<Scalars['Boolean']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  competence_weight_configuration?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  field_macro_competence?: InputMaybe<Scalars['Boolean']['input']>;
  minimum_expected_configuration?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  type_competence_model?: InputMaybe<Scalars['String']['input']>;
};

export type TalentCreateDipLibraryActivityResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCreateDipLibraryActivityPayload | ValidationErrorV2;

export type TalentCreateDraftCompetencesModelResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCreateDraftCompetencesModelPayload | ValidationErrorV2;

export type TalentCreateEvaluationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  competence_model_id: Scalars['ID']['input'];
  competence_result_type: CompetenceResultTypeEnum;
  date_time_zone?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCreateEvaluationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCreateEvaluationPayload | ValidationErrorV2;

export type TalentCreateMassiveCompetencesFileInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The language of the file to create. */
  language: LanguageEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCreateMassiveCompetencesFileResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentMassiveCompetencesFilePayload | ValidationErrorV2;

export type TalentCreateMassiveCompetencesInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Flag to generate competences model or delete from job. */
  generate: Scalars['Boolean']['input'];
  /** The ID of the job to create process queue. */
  job_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCreateMassiveCompetencesRelationsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The job ID returned by the upload validation step. */
  job_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCreateMassiveCompetencesRelationsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentMassiveCompetencesRelationsPayload | ValidationErrorV2;

export type TalentCreateMassiveCompetencesResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentMassiveCompetencesPayload | ValidationErrorV2;

export type TalentCreateMassiveDipActivityAssignmentFileInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** PID process (RN-013); enables a pre-filled template. */
  dip_id: Scalars['ID']['input'];
  /** Template language: EN | ES | PT. */
  language: LanguageEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCreateMassiveDipActivityAssignmentFileResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentMassiveDipActivityAssignmentFilePayload | ValidationErrorV2;

export type TalentCreateMassiveDipActivityAssignmentInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The job_id returned by the upload/validate step (extra.job_id). */
  job_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCreateMassiveDipActivityAssignmentResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentMassiveDipActivityAssignmentPayload | ValidationErrorV2;

export type TalentCreateMassiveDipActivityTrackingFileInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** PID process (RN-013); enables a pre-filled template. */
  dip_id: Scalars['ID']['input'];
  /** Template language: EN | ES | PT. */
  language: LanguageEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCreateMassiveDipActivityTrackingFileResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentMassiveDipActivityTrackingFilePayload | ValidationErrorV2;

export type TalentCreateMassiveDipActivityTrackingInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The job_id returned by the upload/validate step (extra.job_id). */
  job_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCreateMassiveDipActivityTrackingResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentMassiveDipActivityTrackingPayload | ValidationErrorV2;

export type TalentCreateMassiveDipLibraryActivityFileInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** PID process (RN-013); enables a pre-filled template. */
  dip_id: Scalars['ID']['input'];
  /** Template language: EN | ES | PT. */
  language: LanguageEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCreateMassiveDipLibraryActivityFileResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentMassiveDipLibraryActivityFilePayload | ValidationErrorV2;

export type TalentCreateMassiveDipLibraryActivityInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The job_id returned by the upload/validate step (extra.job_id). */
  job_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCreateMassiveDipLibraryActivityResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentMassiveDipLibraryActivityPayload | ValidationErrorV2;

export type TalentCreateMassiveEvaluationDeleteRelationsProcessInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the evaluation whose relations are being deleted. */
  evaluation_id: Scalars['ID']['input'];
  /** If true, enqueues the deletion job in SQS. If false, discards the staged Redis entry (cancellation). */
  generate: Scalars['Boolean']['input'];
  /** The job ID returned by the validation mutation. */
  job_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCreateMassiveEvaluationDeleteRelationsProcessResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentMassiveCompetencesPayload | ValidationErrorV2;

export type TalentCreateMassiveParticipantsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The job ID returned by the upload validation step. */
  job_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCreateMassiveParticipantsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentMassiveParticipantsPayload | ValidationErrorV2;

export type TalentCreateMassiveRecognitionRewardInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The job ID returned by the upload validation step. */
  job_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCreateMassiveRecognitionRewardResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentMassiveRecognitionRewardPayload | ValidationErrorV2;

export type TalentCreateRecognitionMedalInput = {
  attachment_id?: InputMaybe<Scalars['Int']['input']>;
  category: TalentRecognitionMedalCategoryEnum;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  is_leader: Scalars['Boolean']['input'];
  level: TalentRecognitionMedalLevelEnum;
  name: Scalars['String']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCreateRecognitionMedalResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCreateRecognitionMedalPayload | ValidationErrorV2;

export type TalentCreateRecognitionRedemptionCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** recognition_product.id of the reward being redeemed. REQUIRED and the ONLY thing the client states about the cost — the server resolves the current points itself (RN-12 / D-15). */
  recognition_product_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator redeeming. NON-NULL, like recognition_product_id below: it is persisted to recognition_redemption.employee_id and scopes the balance check to this collaborator. */
  talent_employee_id: Scalars['ID']['input'];
};

export type TalentCreateRecognitionRedemptionCollaboratorPayload = {
  __typename?: 'TalentCreateRecognitionRedemptionCollaboratorPayload';
  /** recognition_redemption.id of the created redemption request — its initial state is PENDING. */
  redemption_id: Scalars['Int']['output'];
};

export type TalentCreateRecognitionRedemptionCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentCreateRecognitionRedemptionCollaboratorPayload | ValidationErrorV2;

export type TalentCreateRecognitionRewardInput = {
  /** Optional attachment ID used to resolve the product image */
  attachment_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional product code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Optional description of the recognition product (max 500 chars) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Set to true to create the product as ACTIVE or false to create it as INACTIVE */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name of the recognition product (max 500 chars) */
  name: Scalars['String']['input'];
  /** Number of recognition points required to redeem this product (must be > 0) */
  points: Scalars['Int']['input'];
  /** Optional available quantity. None means unlimited stock. Must be >= 0 when provided. */
  stock?: InputMaybe<Scalars['Int']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional product type classification, e.g. TANGIGLE o INTANGIBLE (max 20 chars) */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TalentCreateRecognitionRewardResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCreateRecognitionRewardPayload | ValidationErrorV2;

export type TalentCreateUpdateRecognitionReactionCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** recognition.recognition_comment.id — THE COMMENT a CREATE is aimed at, and THE DISCRIMINATOR OF THAT BRANCH: send it and the reaction lands on that comment (recognition_reaction.dtype = 'COMMENT'), omit it and it lands on the post itself (dtype = 'MEDAL'). There is no separate type member to keep in agreement with it any more — the DTO derives the dtype from this field, so MEDAL-with-a-comment and COMMENT-without-one are both unrepresentable and REACTION_TARGET_MISMATCH is gone. A value that travelled but is not a canonical decimal integer is still refused (ValidationErrorV2 COMMENT_ID_REQUIRED): a client that meant to like a comment must not silently react to the card above it. The comment must be live AND belong to the post named in recognition_employee_id; every other case answers NotFoundErrorV2 COMMENT_NOT_FOUND. Only LIKE is accepted on a comment (RN-08). RN-10 does NOT apply here: reacting to an existing comment works even where option_comments is false or null — that gate only closes the comment composer. NOT READ on an UPDATE or a DELETE: the row already names its target, so those branches take the dtype off the row and never off this field. */
  comment_id?: InputMaybe<Scalars['ID']['input']>;
  /** TRUE = SOFT DELETE (U4). The row named by recognition_reaction_id goes to state = 'INACTIVE' and gets deleteddate stamped, the counters drop it, and the payload answers reaction: null — there is no live reaction left to render. IT REQUIRES AN ID: is_deleted true with recognition_reaction_id null is ValidationErrorV2 REACTION_ID_REQUIRED, never 'delete whatever I have there' — the server does not resolve targets into rows on this branch, because doing so would put the toggle back in. reaction_type is still required by the schema when deleting and is NOT written: the row keeps the type it had, which is what makes a later re-reaction with that same type land back on the SAME row. It IS still validated against RN-08. DEFAULT false, so a CREATE and an UPDATE both work without mentioning it. */
  is_deleted?: Scalars['Boolean']['input'];
  /** THE TYPE THE COLLABORATOR TAPPED — LIKE / LOVE / INTERESTING. THE CLIENT SENDS THE ENUM AND NEVER AN ID: the three usable rows of innpulsa.recognition_reaction_type are fixed data (recognition_type_id 1 LIKE / 2 LOVE / 3 INTERESTING, company_id NULL on all of them), so the FK the column stores is resolved server-side by the RECOGNITION_REACTION_TYPE_ID_BY_NAME mapper and no client has to hardcode a primary key. NON-NULL: there is always a type, because there is no 'remove' value to send — removal is is_deleted, and the legacy sentinel (recognitionTypeId 0, whose reaction_name is the literal string 'NULL') has no equivalent here. WRITTEN on a CREATE (the type of the new row) and on an UPDATE (the new type of the row named by recognition_reaction_id); NOT written on a delete. IT IS NOT A COMMAND AND NOT A COMPARISON EITHER: the server does not compare it against anything the caller already has, so sending the type the row already carries is an UPDATE that changes nothing and answers the same row, NOT a removal. Deciding that the user is un-tapping is the client's job, from context.reaction.reaction_type, and it is expressed with is_deleted. There is nothing to validate about the value itself — the enum admits exactly three, so an unknown one is a GraphQL validation error and never a ValidationErrorV2 node. The ONE runtime rule is RN-08: on a comment only LIKE is accepted, and LOVE / INTERESTING answer ValidationErrorV2 COMMENT_REACTION_ONLY_LIKE. */
  reaction_type: TalentRecognitionReactionTypeEnum;
  /** innpulsa.recognitionemployee.id of the post being reacted to — THE TARGET OF A CREATE, and read on that branch only. It stays OUTSIDE the envelope (G-05): it is the domain id of the target, not the identity of the caller. REQUIRED ON EVERY CREATE, A COMMENT LIKE INCLUDED: recognition_reaction.recognition_id is NOT NULL on every row of the table, so a reaction to a comment stores the POST the comment hangs off just as a reaction to the post does — sending comment_id does not replace this field, it accompanies it, and the pair is also what proves the comment belongs to the post being named. REQUIRED WHEN recognition_reaction_id IS NULL — absent (or spelled in a way that is not a canonical decimal integer) answers ValidationErrorV2 RECOGNITION_EMPLOYEE_ID_REQUIRED. NOT READ on an UPDATE or a DELETE: the row already names its post, so a contradicting value there is neither used nor refused. Every unreachable post collapses into ONE answer, NotFoundErrorV2 RECOGNITION_NOT_FOUND, so a caller cannot enumerate another tenant's ids: unknown, soft-deleted (U4), outside the RN-03 one-year window, not APPROVED (RN-02), of another Razón Social (RN-04 / U2), or PRIVATE and the caller took no part in it. A PRIVATE RECOGNITION IS REACTABLE ONLY BY ITS SENDER AND ITS RECEIVER — the same two people get_recognition_post_detail_collaborator opens it for — and answers that same code to every other caller. A comment of a post the caller cannot reach is refused by this same check, BEFORE the comment is looked up, and the row's own post is re-checked on an UPDATE or a DELETE, so a reaction cannot be edited on a card that has left the wall. */
  recognition_employee_id?: InputMaybe<Scalars['ID']['input']>;
  /** innpulsa.recognition_reaction.id of the row being edited or deleted — THE FIELD THAT PICKS THE BRANCH. NULL OR OMITTED = CREATE: the server inserts a new row over the target named by recognition_employee_id / comment_id, and it does NOT look for an existing reaction to update instead — an ACTIVE one is REFUSED (ValidationErrorV2 REACTION_ALREADY_EXISTS) and an INACTIVE one of the same type is REVIVED rather than duplicated, which keeps one reaction per person per target per type the way a unique constraint would. PRESENT = UPDATE or SOFT DELETE of THAT EXACT ROW, decided by is_deleted; the row must exist, be live and BELONG TO THE CALLER, and all three failures collapse into NotFoundErrorV2 REACTION_NOT_FOUND on purpose — a separate 'not yours' code would confirm that somebody else's reaction id exists. The post the row hangs from must still be reachable too, or the answer is RECOGNITION_NOT_FOUND, so a reaction cannot be edited on a card that has left the wall. WHERE THE CLIENT GETS IT: context.reaction.id of the feed node, reactions[] of the post detail, comment_reactions[] of the comment thread, or the reaction the last CREATE or UPDATE answered — there is no lookup operation that trades a target for a reaction id, because the reads already carry it. Coerced strictly as a CANONICAL decimal integer like every other id of the envelope, and a spelling that is not one answers REACTION_NOT_FOUND rather than falling back to a CREATE. */
  recognition_reaction_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator making the request. REQUIRED at resolve time: an absent, non-positive or non-canonical value answers NotAuthenticatedErrorV2 NOT_AUTHENTICATED. It is also the row's REACTOR — persisted as recognition_reaction.emisor_employee_id on a CREATE, and the ownership check of an UPDATE or a DELETE. */
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentCreateUpdateRecognitionReactionCollaboratorPayload = {
  __typename?: 'TalentCreateUpdateRecognitionReactionCollaboratorPayload';
  /** innpulsa.recognition_reaction.id of the row this call wrote — THE ONE THING THE CLIENT COULD NOT KNOW ALREADY, and the value it must hold to change or remove that reaction later, since this mutation is addressed by recognition_reaction_id. ANSWERED ON ALL THREE BRANCHES: on a CREATE it is the brand-new row, or the REVIVED one the collaborator had deleted with that same type (its ORIGINAL id comes back, which is why a client must store what this field says rather than assume every create mints a new number); on an UPDATE it is the same id that was sent, because swapping the type never moves the row; on a SOFT DELETE it is the row that was just deactivated (state = 'INACTIVE' plus a deleteddate, U4 — the row is still there, it is simply not live), so the client should DROP the id from its state rather than reuse it: a later re-reaction goes back through a CREATE, which is what may revive that very row and answer this same number again. It is NOT a confirmation that a reaction is live — the client knows which branch it asked for from the is_deleted it sent. */
  recognition_reaction_id: Scalars['Int']['output'];
};

export type TalentCreateUpdateRecognitionReactionCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentCreateUpdateRecognitionReactionCollaboratorPayload | ValidationErrorV2;

export type TalentDipMutation = {
  __typename?: 'TalentDIPMutation';
  approve_dip_activities: DipApproveActivitiesResponse;
  create_dip_employee_track?: Maybe<DipTrackResponse>;
  delete_dip_employee?: Maybe<DipActivityEmployeeDetailResponse>;
  edit_dip_employee_track?: Maybe<DipTrackResponse>;
  talent_performance_develop_individual_plan_administrator: TalentPerformanceDipAdministratorMutations;
  update_dip_activities_state: DipUpdateActivitiesStateResponse;
  update_dip_employee_activity_displacement: DipUpdateActivitiesStateResponse;
  update_dip_employee_and_tracks?: Maybe<DipEmployeeWithTrackResponse>;
  update_dip_employee_track_timer?: Maybe<DipEmailTemplateTypeListResponse>;
};


export type TalentDipMutationApprove_Dip_ActivitiesArgs = {
  input: DipApproveActivitiesInput;
};


export type TalentDipMutationCreate_Dip_Employee_TrackArgs = {
  input: DipTrackInput;
};


export type TalentDipMutationDelete_Dip_EmployeeArgs = {
  input: PidLearningActivityEmployeeInput;
};


export type TalentDipMutationEdit_Dip_Employee_TrackArgs = {
  input: DipTrackInput;
};


export type TalentDipMutationUpdate_Dip_Activities_StateArgs = {
  input: DipUpdateActivitiesStateInput;
};


export type TalentDipMutationUpdate_Dip_Employee_Activity_DisplacementArgs = {
  input: DipUpdateEmployeeActivityDisplacementInput;
};


export type TalentDipMutationUpdate_Dip_Employee_And_TracksArgs = {
  input: DipEmployeeWithTrackInfoInput;
};


export type TalentDipMutationUpdate_Dip_Employee_Track_TimerArgs = {
  input: DipTrackInput;
};

export type TalentDipQuery = {
  __typename?: 'TalentDIPQuery';
  collaborator: CollaboratorQuery;
  leader: LeaderQuery;
  talent_performance_develop_individual_plan_administrator: TalentPerformanceDipAdministratorQueries;
};

export type TalentDashboardAdministrator = {
  __typename?: 'TalentDashboardAdministrator';
  get_closed_processes: TalentDashboardAdministratorLastProcessesResponse;
  get_processes_and_users_participation: TalentUserParticipationResponse;
  /** Company-wide administrator timeline (goals, competences, PID) for a given month */
  get_talent_dashboard_administrator_timeline: TalentTimelineResponse;
};


export type TalentDashboardAdministratorGet_Closed_ProcessesArgs = {
  company_id: Scalars['Int']['input'];
};


export type TalentDashboardAdministratorGet_Processes_And_Users_ParticipationArgs = {
  input: TalentUserParticipationInput;
};


export type TalentDashboardAdministratorGet_Talent_Dashboard_Administrator_TimelineArgs = {
  input: TalentAdministratorTimelineInput;
};

export type TalentDashboardAdministratorLastProcess = {
  __typename?: 'TalentDashboardAdministratorLastProcess';
  end_date: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  module_name: Scalars['String']['output'];
  name: Scalars['String']['output'];
  percentage_completeness: Scalars['Float']['output'];
  start_date: Scalars['Date']['output'];
};

export type TalentDashboardAdministratorLastProcessList = {
  __typename?: 'TalentDashboardAdministratorLastProcessList';
  processes: Array<TalentDashboardAdministratorLastProcess>;
};

export type TalentDashboardAdministratorLastProcessesResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TalentDashboardAdministratorLastProcessList;

export type TalentDashboardApproveMassiveGoalsResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TalentDashboardLeaderApproveMassiveGoalsPayload;

export type TalentDashboardCollaboratorTimeline = {
  __typename?: 'TalentDashboardCollaboratorTimeline';
  competences?: Maybe<Array<TimelineType>>;
  goals?: Maybe<Array<TimelineType>>;
  pid?: Maybe<Array<TimelineType>>;
};

export type TalentDashboardCollaboratorTimelineInput = {
  company_id?: InputMaybe<Scalars['Int']['input']>;
  month_number: Scalars['Int']['input'];
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  year_number?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentDashboardCollaboratorTimelineResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TalentDashboardCollaboratorTimeline;

export type TalentDashboardCollaboratorTodoList = {
  __typename?: 'TalentDashboardCollaboratorTodoList';
  competences?: Maybe<Array<TodoType>>;
  goals?: Maybe<Array<TodoType>>;
  pid?: Maybe<Array<TodoType>>;
};

export type TalentDashboardCollaboratorTodoListInput = {
  company_id?: InputMaybe<Scalars['Int']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentDashboardCollaboratorTodoListResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TalentDashboardCollaboratorTodoList;

export type TalentDashboardLeaderApproveMassiveGoalsInput = {
  company_id: Scalars['Int']['input'];
  employee_id: Scalars['Int']['input'];
  process_id: Scalars['Int']['input'];
};

export type TalentDashboardLeaderApproveMassiveGoalsPayload = {
  __typename?: 'TalentDashboardLeaderApproveMassiveGoalsPayload';
  successful: Scalars['Boolean']['output'];
};

export type TalentDashboardLeaderEmployeeInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  company_id: Scalars['Int']['input'];
  division_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  employee_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  job_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  job_names?: InputMaybe<Array<Scalars['String']['input']>>;
  leader_id?: InputMaybe<Scalars['Int']['input']>;
  level_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  person_email?: InputMaybe<Scalars['String']['input']>;
  person_name?: InputMaybe<Scalars['String']['input']>;
  subsidiary_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TalentDashboardLeaderEmployeeTaskInfo = {
  __typename?: 'TalentDashboardLeaderEmployeeTaskInfo';
  task_id: Scalars['Int']['output'];
  weight: Scalars['Float']['output'];
};

export type TalentDashboardLeaderEmployeeTasks = {
  __typename?: 'TalentDashboardLeaderEmployeeTasks';
  employee_task_info: Array<TalentDashboardLeaderEmployeeTaskInfo>;
  total_employee_tasks: Scalars['Int']['output'];
  total_employee_tasks_weight: Scalars['Float']['output'];
};

export type TalentDashboardLeaderEvaluationDetail = {
  __typename?: 'TalentDashboardLeaderEvaluationDetail';
  end_date: Scalars['String']['output'];
  name: Scalars['String']['output'];
  process_id: Scalars['Int']['output'];
  state: TalentDashboardLeaderEvaluationStateEnum;
};

export enum TalentDashboardLeaderEvaluationStateEnum {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Finished = 'FINISHED',
  Inactive = 'INACTIVE',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type TalentDashboardLeaderEvaluations = {
  __typename?: 'TalentDashboardLeaderEvaluations';
  evaluations: Array<TalentDashboardLeaderEvaluationDetail>;
};

export type TalentDashboardLeaderEvaluationsInput = {
  company_id: Scalars['Int']['input'];
  employee_id: Scalars['Int']['input'];
};

export type TalentDashboardLeaderEvaluationsResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TalentDashboardLeaderEvaluations;

export type TalentDashboardLeaderGoalDetailsInput = {
  employee_id: Scalars['Int']['input'];
};

export type TalentDashboardLeaderGoalDetailsResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TalentDashboardLeaderGoalModuleInfo;

export type TalentDashboardLeaderGoalModule = {
  __typename?: 'TalentDashboardLeaderGoalModule';
  company_id: Scalars['Int']['output'];
  module_info: TalentBasicModuleInfo;
  module_tasks: Array<TalentDashboardLeaderModuleTask>;
};

export type TalentDashboardLeaderGoalModuleConf = {
  __typename?: 'TalentDashboardLeaderGoalModuleConf';
  approved_goals: Scalars['Boolean']['output'];
  auto_eval: Scalars['Boolean']['output'];
  end_date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  limited_days: Scalars['Boolean']['output'];
  max_goals: Scalars['Int']['output'];
  max_weight: Scalars['Int']['output'];
  min_goals: Scalars['Int']['output'];
  min_weight: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  only_admin: Scalars['Boolean']['output'];
};

export type TalentDashboardLeaderGoalModuleInfo = {
  __typename?: 'TalentDashboardLeaderGoalModuleInfo';
  user_goal_module_info: TalentDashboardLeaderGoalModule;
};

export type TalentDashboardLeaderModuleTask = {
  __typename?: 'TalentDashboardLeaderModuleTask';
  module_conf: TalentDashboardLeaderGoalModuleConf;
  process_tasks: TalentDashboardLeaderProcessTasks;
  total_pending_process_tasks: Scalars['Int']['output'];
};

export type TalentDashboardLeaderPendingTaskInfo = {
  __typename?: 'TalentDashboardLeaderPendingTaskInfo';
  task_id: Scalars['Int']['output'];
};

export type TalentDashboardLeaderPendingTasks = {
  __typename?: 'TalentDashboardLeaderPendingTasks';
  pending_tasks_info: Array<TalentDashboardLeaderPendingTaskInfo>;
  total_pending_tasks: Scalars['Int']['output'];
};

export type TalentDashboardLeaderProcessTasks = {
  __typename?: 'TalentDashboardLeaderProcessTasks';
  employee_tasks?: Maybe<TalentDashboardLeaderEmployeeTasks>;
  pending_tasks?: Maybe<TalentDashboardLeaderPendingTasks>;
  tracking_tasks?: Maybe<TalentDashboardLeaderTrackingTasks>;
};

export type TalentDashboardLeaderTrackingTasks = {
  __typename?: 'TalentDashboardLeaderTrackingTasks';
  total_pending_tracking: Scalars['Int']['output'];
  total_pending_tracking_tasks: Scalars['Int']['output'];
  tracking_tasks_info: Array<TalentDashboardLeaderTrackingTasksInfo>;
};

export type TalentDashboardLeaderTrackingTasksInfo = {
  __typename?: 'TalentDashboardLeaderTrackingTasksInfo';
  boss_progress?: Maybe<Scalars['Int']['output']>;
  colab_progress?: Maybe<Scalars['Int']['output']>;
  pending_tracking: Scalars['Int']['output'];
  task_id: Scalars['Int']['output'];
};

export type TalentDashboardLeaderUserModule = {
  __typename?: 'TalentDashboardLeaderUserModule';
  employee: TalentEmployee;
  modules?: Maybe<Array<Maybe<TalentDashboardLeaderUserModuleData>>>;
};

export type TalentDashboardLeaderUserModuleData = {
  __typename?: 'TalentDashboardLeaderUserModuleData';
  module?: Maybe<TalentProcessTypeEnum>;
  name?: Maybe<Scalars['String']['output']>;
  next_process_end_date?: Maybe<Scalars['String']['output']>;
  total_pending_sub_task?: Maybe<Scalars['Int']['output']>;
  total_pending_task?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type TalentDashboardLeaderUserModuleEdge = {
  __typename?: 'TalentDashboardLeaderUserModuleEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TalentDashboardLeaderUserModule;
};

export type TalentDashboardLeaderUserModulesCustomConnection = {
  __typename?: 'TalentDashboardLeaderUserModulesCustomConnection';
  edges: Array<TalentDashboardLeaderUserModuleEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type TalentDashboardMutation = {
  __typename?: 'TalentDashboardMutation';
  talent_dashboard_leader: DashboardLeaderMutation;
};

export type TalentDashboardQuery = {
  __typename?: 'TalentDashboardQuery';
  talent_dashboard_administrator: TalentDashboardAdministrator;
  talent_dashboard_collaborator: DashboardCollaboratorQuery;
  talent_dashboard_leader: DashboardLeaderQuery;
};

export type TalentDashboardResultsFilter = {
  competences_process_id_eq?: InputMaybe<Scalars['Int']['input']>;
  dynamic_performance_id_eq?: InputMaybe<Scalars['Int']['input']>;
  flexible_performance?: InputMaybe<Scalars['Boolean']['input']>;
  goals_process_id_eq?: InputMaybe<Scalars['Int']['input']>;
  leader_id_eq: Scalars['Int']['input'];
  /**  @deprecated Use matrix_id_eq */
  matrixId?: InputMaybe<Scalars['Int']['input']>;
  matrix_id_eq?: InputMaybe<Scalars['Int']['input']>;
  /**  @deprecated Use dynamic_performance_id_eq for dynamic performance */
  performance_process_id_eq?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentDashboardResultsInput = {
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  filter: TalentDashboardResultsFilter;
  pagination?: InputMaybe<OffsetPaginationInput>;
  search?: InputMaybe<ReportsSearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type TalentDeleteAllEvaluationQuestionsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the evaluation whose ASSIGNED questionnaires will have all their question relations cleared. */
  evaluation_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDeleteAllEvaluationQuestionsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDeleteAllEvaluationQuestionsPayload | ValidationErrorV2;

export type TalentDeleteBehaviorInput = {
  /** The ID of the behavior to delete. */
  behavior_id: Scalars['ID']['input'];
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competence level the behavior belongs to. */
  competence_level_id: Scalars['ID']['input'];
  /** The ID of the competence model to which the behavior belongs. */
  competence_model_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDeleteBehaviorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDeleteBehaviorPayload | ValidationErrorV2;

export type TalentDeleteCompetenceFilterInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the competence filter to delete. Required if model_id is not provided. */
  filter_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the competence model to delete all its filters. Required if filter_id is not provided. */
  model_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDeleteCompetenceFilterResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDeleteCompetenceFilterPayload | ValidationErrorV2;

export type TalentDeleteCompetenceInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** id of the competence to delete. */
  competence_id: Scalars['ID']['input'];
  /** The ID of the competence model in edition or creation. */
  competence_model_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDeleteCompetenceLevelInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competence owning the level */
  competence_id: Scalars['ID']['input'];
  /** The ID of the competence level to delete */
  competence_level_id: Scalars['ID']['input'];
  /** The ID of the competence model in edition or creation. */
  competence_model_id: Scalars['ID']['input'];
  /** The ID of the category level in competence. */
  level_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDeleteCompetenceLevelResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDeleteCompetenceLevelPayload | ValidationErrorV2;

export type TalentDeleteCompetenceResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDeleteCompetencePayload | ValidationErrorV2;

export type TalentDeleteCompetencesEvaluationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competences evaluation to delete. */
  evaluation_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDeleteCompetencesEvaluationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDeleteCompetencesEvaluationPayload | ValidationErrorV2;

export type TalentDeleteDipActivitiesResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDeleteDipActivitiesResult | ValidationErrorV2;

export type TalentDeleteDipCollaboratorActivitiesInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** SELECT ALL mode: soft-delete every assignment of the process. When true, ids is ignored and the scope is dip_id minus excluded_ids. */
  delete_all?: Scalars['Boolean']['input'];
  /** Scope of the SELECT ALL mode: PID process (dip_employee.plan_id, RN-013). Also scopes a by-selection delete when provided. */
  dip_id?: InputMaybe<Scalars['ID']['input']>;
  /** When delete_all is true: dip_employee.id to EXCLUDE (rows the admin deselected by hand). */
  excluded_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** By-SELECTION mode: dip_employee.id to soft-delete (single = 1; many = "Eliminar seleccionados"). Required and non-empty when delete_all is false. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDeleteDipLibraryActivitiesInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** SELECT ALL mode: soft-delete every library activity of the process. When true, ids is ignored and the scope is dip_id minus excluded_ids. */
  delete_all?: Scalars['Boolean']['input'];
  /** Scope of the SELECT ALL mode: PID process (activity_pid.plan_id, RN-013). Also scopes a by-selection delete when provided. */
  dip_id?: InputMaybe<Scalars['ID']['input']>;
  /** When delete_all is true: activity_pid.id to EXCLUDE (rows the admin deselected by hand). */
  excluded_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** By-SELECTION mode: activity_pid.id to soft-delete (single = 1; many = "Eliminar seleccionados"). Required and non-empty when delete_all is false. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDeleteDipProcessInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** develop individual plan id */
  dip_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDeleteDipProcessResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDeleteDipProcessPayload | ValidationErrorV2;

export type TalentDeleteEvaluatorEvaluationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Evaluated participant ID */
  evaluated_id: Scalars['ID']['input'];
  /** Evaluation ID */
  evaluation_id: Scalars['ID']['input'];
  /** Evaluator ID to be removed */
  evaluator_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDeleteEvaluatorEvaluationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDeleteEvaluatorEvaluationPayload | ValidationErrorV2;

export type TalentDeleteGoalProcessInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** goal period id */
  goal_period_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDeleteGoalProcessResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDeleteGoalProcessPayload | ValidationErrorV2;

export type TalentDipActivitiesByCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDipEmployeeConnection | ValidationErrorV2;

export type TalentDipActivitiesFilterInput = {
  /** Filter by 70-20-10 model bucket(s). Origin: activity_pid.model_70_20_10. */
  model_702010_in?: InputMaybe<Array<ActivityDipModelLabelsEnum>>;
  /** Filter by activity TYPE (module), not by process id: COMPETENCE / GOAL / OKR / OTHER / CLIMATE_CULTURE / WITHOUTPROCESS. Origin: activity_pid.type (via the assignment's activity). */
  type_in?: InputMaybe<Array<PidActivityTypeEnum>>;
};

export enum TalentDipActivitiesSearchField {
  ActivityName = 'ACTIVITY_NAME',
  EmployeeEmail = 'EMPLOYEE_EMAIL',
  EmployeeName = 'EMPLOYEE_NAME'
}

export type TalentDipActivitiesSearchInput = {
  /** Fields to search over (one or more). Empty/null disables search entirely. */
  fields?: InputMaybe<Array<TalentDipActivitiesSearchField>>;
  /** Search text; partial, case- and accent-insensitive. */
  query?: InputMaybe<Scalars['String']['input']>;
};

export enum TalentDipActivitiesSortField {
  ActivityName = 'ACTIVITY_NAME',
  EmployeeName = 'EMPLOYEE_NAME',
  Model = 'MODEL',
  Process = 'PROCESS'
}

export type TalentDipActivitiesSortInput = {
  /** Sort direction: ASC or DESC. */
  direction: OrderDirectionEnum;
  /** Field to sort by (ACTIVITY_NAME, PROCESS, MODEL, EMPLOYEE_NAME). */
  field: TalentDipActivitiesSortField;
};

export type TalentDipPaginationInput = {
  /** Page number to retrieve (1-based). */
  page?: Scalars['Int']['input'];
  /** Number of items per page. */
  page_size?: Scalars['Int']['input'];
};

export enum TalentDipParticipantRole {
  Collaborator = 'COLLABORATOR',
  Leader = 'LEADER'
}

export enum TalentDipParticipantSortField {
  EmployeeName = 'EMPLOYEE_NAME'
}

export type TalentDipParticipantsFilterInput = {
  /** Keep only employees whose division (departamento) id is in this list. */
  division_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Keep only employees whose job (cargo) id is in this list. */
  job_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Keep only employees whose derived role (LEADER / COLLABORATOR) is in this list. */
  role_in?: InputMaybe<Array<TalentDipParticipantRole>>;
};

export type TalentDipParticipantsSearchInput = {
  /** Employee fields to search over (e.g., EMPLOYEE_NAME). Defaults to the employee name when omitted. */
  fields?: InputMaybe<Array<CompanyEmployeeFieldsEnum>>;
  /** Search query text; partial, case- and accent-insensitive. */
  query?: InputMaybe<Scalars['String']['input']>;
};

export enum TalentDipParticipantsSortField {
  EmployeeName = 'EMPLOYEE_NAME'
}

export type TalentDipParticipantsSortOrderInput = {
  /** Sort direction: ascending or descending. */
  direction?: OrderDirectionEnum;
  /** Field to sort by (EMPLOYEE_NAME). */
  field: TalentDipParticipantSortField;
};

export type TalentDipProcessActivitiesListInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Identifier of the PID process whose assignments are listed. */
  dip_id: Scalars['ID']['input'];
  /** Filters (activity type, 70-20-10 model). */
  filter?: InputMaybe<TalentDipActivitiesFilterInput>;
  /** Pagination parameters (page, page_size). */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  /** Multi-field search parameters. */
  search?: InputMaybe<TalentDipActivitiesSearchInput>;
  /** Sort field and direction. */
  sort?: InputMaybe<TalentDipActivitiesSortInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDipProcessFilterInput = {
  /** Filter PID processes whose state matches any of the given values (DRAFT, NOT_INITIATED, ACTIVE, FINISHED). Omit or pass an empty list to skip the state filter. */
  state_in?: InputMaybe<Array<DipProcessStateEnum>>;
};

export type TalentDipProcessGeneralConfigInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Identifier of the PID process whose general config is loaded for edit pre-load. The centralized_organization_id / talent_company_id pair scopes the lookup to the admin's company (U2). */
  dip_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDipProcessGeneralConfigResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDip | ValidationErrorV2;

export type TalentDipProcessLibraryActivitiesResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDipActivityConnection | ValidationErrorV2;

export type TalentDipProcessParticipantsFilterInput = {
  /** Filter by department (employee division id). Matches the participant's division; omit/empty to skip. */
  department_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by pending-action tag (RN-026 derivation). Matches rows whose computed pending_actions include any of these; a MULTIPLE-collapsed row matches MULTIPLE (the displayed tag), not its underlying individual actions. Omit/empty to skip. */
  pending_action_in?: InputMaybe<Array<PidPendingActionEnum>>;
};

export type TalentDipProcessParticipantsListInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Identifier of the PID process (develop_individual_plan.id) whose participants are returned. Scoped to the admin's company (RN-015 / U3); a dip_id from another company -> NotFoundErrorV2. */
  dip_id: Scalars['ID']['input'];
  /** Department / pending-action filters (RN-008 / RN-023). */
  filter?: InputMaybe<TalentDipProcessParticipantsFilterInput>;
  /** Pagination parameters (page, page_size). */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  /** Collaborator-name search (RN-008). */
  search?: InputMaybe<TalentDipProcessParticipantsSearchInput>;
  /** Sort by collaborator name (RN-023). */
  sort?: InputMaybe<TalentDipProcessParticipantsSortInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDipProcessParticipantsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDipProcessParticipantConnection | ValidationErrorV2;

export type TalentDipProcessParticipantsSearchInput = {
  /** Collaborator name search; partial, accent-insensitive. */
  query?: InputMaybe<Scalars['String']['input']>;
};

export type TalentDipProcessParticipantsSortInput = {
  /** Sort direction: ascending (ASC) or descending (DESC). */
  direction: OrderDirectionEnum;
  /** Field to sort by (EMPLOYEE_NAME in v1). */
  field: TalentDipParticipantsSortField;
};

export type TalentDipProcessProgressFunnelInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Identifier of the PID process (develop_individual_plan.id) whose progress funnel is returned. The centralized_organization_id / talent_company_id pair scopes the lookup to the admin's company (RN-015 / U3). Not paginated. */
  dip_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDipProcessProgressFunnelResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDipProcessProgressFunnel | ValidationErrorV2;

export type TalentDipProcessTrackingSeriesInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Identifier of the PID process (develop_individual_plan.id) whose expected-vs-done tracking series is returned for the "Seguimiento de actividades" chart. Periodic processes only (RN-002); continuous processes yield an empty series (RN-001). The centralized_organization_id / talent_company_id pair scopes the lookup to the admin's company (RN-015 / U3). */
  dip_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDipProcessTrackingSeriesResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDipTrackingSeries | ValidationErrorV2;

export type TalentDipSortOrderInput = {
  /** Sort direction: ascending or descending. */
  direction: OrderDirectionEnum;
  /** Field to sort by (DIP_NAME, DIP_START_DATE, DIP_END_DATE). */
  field: DipProcessSortFieldsEnum;
};

export type TalentDivision = {
  __typename?: 'TalentDivision';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TalentDuplicateCompetenceInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competence to duplicate. */
  competence_id: Scalars['ID']['input'];
  /** The ID of the competence model that owns the competence. */
  competence_model_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDuplicateCompetenceResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDuplicateCompetencePayload | ValidationErrorV2;

export type TalentDuplicateCompetencesModelInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competences model to duplicate. */
  competence_model_id: Scalars['ID']['input'];
  /** The language code for the duplicated competence model name. */
  language_code: LanguageEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentDuplicateCompetencesModelResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDuplicateCompetencesModelPayload | ValidationErrorV2;

/** TYPES */
export type TalentEmployee = {
  __typename?: 'TalentEmployee';
  avatar?: Maybe<TalentAvatar>;
  company?: Maybe<TalentCompany>;
  company_id: Scalars['Int']['output'];
  division?: Maybe<TalentDivision>;
  id: Scalars['Int']['output'];
  job?: Maybe<TalentJob>;
  level?: Maybe<TalentCompanyLevel>;
  person: TalentPerson;
  subsidiary?: Maybe<TalentSubsidiary>;
};

export type TalentEmployeeDashboardResult = {
  __typename?: 'TalentEmployeeDashboardResult';
  competences_result?: Maybe<TalentResult>;
  employee: TalentEmployee;
  employee_status?: Maybe<TalentEmployeeStatusEnum>;
  feedback_count?: Maybe<Scalars['Int']['output']>;
  goals_result?: Maybe<TalentResult>;
  nbox_result?: Maybe<TalentNboxEmployeeResultDetail>;
  performance_result?: Maybe<TalentResult>;
};

/** An edge in a connection. */
export type TalentEmployeeEdge = {
  __typename?: 'TalentEmployeeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TalentEmployee;
};

export type TalentEmployeeGoalSummaryDto = {
  __typename?: 'TalentEmployeeGoalSummaryDto';
  employeeId: Scalars['Int']['output'];
  numGoals: Scalars['Int']['output'];
  percentageResult?: Maybe<Scalars['Float']['output']>;
  scaleResult?: Maybe<Scalars['Float']['output']>;
};

export type TalentEmployeeInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  company_id: Scalars['Int']['input'];
  division_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  employee_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  job_names?: InputMaybe<Array<Scalars['String']['input']>>;
  leader_id?: InputMaybe<Scalars['Int']['input']>;
  level_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  person_email?: InputMaybe<Scalars['String']['input']>;
  person_name?: InputMaybe<Scalars['String']['input']>;
  subsidiary_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/**  Rol del colaborador dentro de la compañía (derivado de boss_id en talent_employees). */
export enum TalentEmployeeRoleEnum {
  Collaborator = 'COLLABORATOR',
  Leader = 'LEADER'
}

export enum TalentEmployeeStatusEnum {
  Active = 'ACTIVE',
  Retired = 'RETIRED'
}

export type TalentEvaluation = {
  __typename?: 'TalentEvaluation';
  advanced_configuration: PrivateTalentAdvancedConfigurationEvaluation;
  affirmations_suggestion?: Maybe<Scalars['Boolean']['output']>;
  answer_type?: Maybe<Scalars['String']['output']>;
  available_time?: Maybe<Scalars['Int']['output']>;
  boss_limit?: Maybe<Scalars['Int']['output']>;
  calibration?: Maybe<Scalars['Boolean']['output']>;
  climate?: Maybe<Scalars['Boolean']['output']>;
  comment_competence?: Maybe<Scalars['Boolean']['output']>;
  comments: PrivateTalentCommentsEvaluation;
  comp_limit?: Maybe<Scalars['Decimal']['output']>;
  comp_limit_1?: Maybe<Scalars['Decimal']['output']>;
  comp_limit_1_color?: Maybe<Scalars['String']['output']>;
  comp_limit_1_label?: Maybe<Scalars['String']['output']>;
  comp_limit_2?: Maybe<Scalars['Decimal']['output']>;
  comp_limit_2_color?: Maybe<Scalars['String']['output']>;
  comp_limit_2_label?: Maybe<Scalars['String']['output']>;
  comp_limit_3?: Maybe<Scalars['Decimal']['output']>;
  comp_limit_3_color?: Maybe<Scalars['String']['output']>;
  comp_limit_3_label?: Maybe<Scalars['String']['output']>;
  comp_limit_4?: Maybe<Scalars['Decimal']['output']>;
  comp_limit_4_color?: Maybe<Scalars['String']['output']>;
  comp_limit_4_label?: Maybe<Scalars['String']['output']>;
  comp_limit_max_label?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['Int']['output']>;
  competence_model?: Maybe<PrivateTalentCompetencesModel>;
  competence_model_id?: Maybe<Scalars['Int']['output']>;
  competence_result_type?: Maybe<Scalars['String']['output']>;
  config360?: Maybe<Array<Scalars['String']['output']>>;
  configuration?: Maybe<Scalars['String']['output']>;
  cow_limit?: Maybe<Scalars['Int']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  custom_weight?: Maybe<Scalars['Boolean']['output']>;
  date_time_zone?: Maybe<Scalars['String']['output']>;
  default_level?: Maybe<Scalars['Int']['output']>;
  deleted_date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dont_know?: Maybe<Scalars['Boolean']['output']>;
  dtype?: Maybe<Scalars['String']['output']>;
  enable_hours?: Maybe<Scalars['Boolean']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  end_text?: Maybe<Scalars['String']['output']>;
  evaluation_demo?: Maybe<Scalars['Boolean']['output']>;
  form_id?: Maybe<Scalars['Int']['output']>;
  general_suggestion?: Maybe<Scalars['Boolean']['output']>;
  general_suggestion_2?: Maybe<Scalars['Boolean']['output']>;
  hide_evaluation_employee?: Maybe<Scalars['Boolean']['output']>;
  hide_relations?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  label_comment_general?: Maybe<Scalars['String']['output']>;
  last_inactivated_date?: Maybe<Scalars['DateTime']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  login_dashboard?: Maybe<Scalars['Boolean']['output']>;
  max_limit?: Maybe<Scalars['Int']['output']>;
  max_limit_color?: Maybe<Scalars['String']['output']>;
  min_comment_length?: Maybe<Scalars['Int']['output']>;
  model_competence_weight?: Maybe<Scalars['Boolean']['output']>;
  model_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options_response: PrivateTalentOptionsResponseEvaluation;
  quit_results_in_zero?: Maybe<Scalars['Boolean']['output']>;
  reminder_date?: Maybe<Scalars['DateTime']['output']>;
  report_template_id?: Maybe<Scalars['Int']['output']>;
  required_comments?: Maybe<Scalars['String']['output']>;
  required_comments_dont_know?: Maybe<Scalars['Boolean']['output']>;
  show_comments_dont_know?: Maybe<Scalars['Boolean']['output']>;
  show_in_platform?: Maybe<Scalars['Boolean']['output']>;
  show_remainder?: Maybe<Scalars['Boolean']['output']>;
  show_results_goal?: Maybe<Scalars['Boolean']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  start_text?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_2?: Maybe<Scalars['String']['output']>;
  state_calibration_evaluation?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['Int']['output']>;
  sub_limit?: Maybe<Scalars['Int']['output']>;
  total_invalid_options?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  type_calibration?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  view_calibration?: Maybe<Scalars['Boolean']['output']>;
  welcome_text?: Maybe<Scalars['String']['output']>;
};

export enum TalentEvaluationDashboardSortOrderEnum {
  CreatedDate = 'CREATED_DATE',
  EndDate = 'END_DATE',
  Name = 'NAME',
  StartDate = 'START_DATE',
  State = 'STATE'
}

export type TalentEvaluationDashboardSortOrderInput = {
  direction?: OrderDirectionEnum;
  field: TalentEvaluationDashboardSortOrderEnum;
};

export enum TalentEvaluationEvaluatorsFieldsEnum {
  NameEvaluator = 'NAME_EVALUATOR'
}

export type TalentEvaluationEvaluatorsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  evaluation_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentEvaluationEvaluatorsSearchInput = {
  fields: Array<TalentEvaluationEvaluatorsFieldsEnum>;
  query: Scalars['String']['input'];
};

export enum TalentEvaluationFieldsEnum {
  Name = 'NAME',
  State = 'STATE'
}

export type TalentEvaluationInput = {
  /** Advanced evaluation settings. */
  advanced_configuration?: InputMaybe<TalentAdvancedConfigurationInput>;
  /** Enable affirmation-style suggestion comments. */
  affirmations_suggestion?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of answer options (e.g. scale, text). */
  answer_type?: InputMaybe<Scalars['String']['input']>;
  /** Time limit in minutes for completing the evaluation. */
  available_time?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of boss evaluators. */
  boss_limit?: InputMaybe<Scalars['Int']['input']>;
  /** Enable calibration phase for this evaluation. */
  calibration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable climate survey mode. */
  climate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable comments per competence. */
  comment_competence?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration for comment fields. */
  comments?: InputMaybe<TalentCommentsInput>;
  /** Upper boundary of the highest competence score range. */
  comp_limit?: InputMaybe<Scalars['Decimal']['input']>;
  /** Lower boundary of competence score range 1. */
  comp_limit_1?: InputMaybe<Scalars['Decimal']['input']>;
  /** Hex color for competence score range 1. */
  comp_limit_1_color?: InputMaybe<Scalars['String']['input']>;
  /** Label for competence score range 1. */
  comp_limit_1_label?: InputMaybe<Scalars['String']['input']>;
  /** Lower boundary of competence score range 2. */
  comp_limit_2?: InputMaybe<Scalars['Decimal']['input']>;
  /** Hex color for competence score range 2. */
  comp_limit_2_color?: InputMaybe<Scalars['String']['input']>;
  /** Label for competence score range 2. */
  comp_limit_2_label?: InputMaybe<Scalars['String']['input']>;
  /** Lower boundary of competence score range 3. */
  comp_limit_3?: InputMaybe<Scalars['Decimal']['input']>;
  /** Hex color for competence score range 3. */
  comp_limit_3_color?: InputMaybe<Scalars['String']['input']>;
  /** Label for competence score range 3. */
  comp_limit_3_label?: InputMaybe<Scalars['String']['input']>;
  /** Lower boundary of competence score range 4. */
  comp_limit_4?: InputMaybe<Scalars['Decimal']['input']>;
  /** Hex color for competence score range 4. */
  comp_limit_4_color?: InputMaybe<Scalars['String']['input']>;
  /** Label for competence score range 4. */
  comp_limit_4_label?: InputMaybe<Scalars['String']['input']>;
  /** Label for the maximum score range. */
  comp_limit_max_label?: InputMaybe<Scalars['String']['input']>;
  /** ID of the competence model to use. */
  competence_model_id?: InputMaybe<Scalars['ID']['input']>;
  /** Method used to calculate competence results. */
  competence_result_type?: InputMaybe<CompetenceResultTypeEnum>;
  /** List of relation types included in the 360 evaluation. */
  config360?: InputMaybe<Array<EvaluationRelationEnum>>;
  /** JSON string with answer option configuration. */
  configuration?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of peer evaluators. */
  cow_limit?: InputMaybe<Scalars['Int']['input']>;
  /** Creation date of the evaluation. */
  created_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Allow custom weights per competence. */
  custom_weight?: InputMaybe<Scalars['Boolean']['input']>;
  /** Timezone identifier for date fields (e.g. America/Bogota). */
  date_time_zone?: InputMaybe<Scalars['String']['input']>;
  /** Default company level ID applied to participants. */
  default_level?: InputMaybe<Scalars['Int']['input']>;
  /** Description of the evaluation. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Allow evaluators to select a 'don't know' answer. */
  dont_know?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include hours in date/time fields. */
  enable_hours?: InputMaybe<Scalars['Boolean']['input']>;
  /** End date of the evaluation. */
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Text shown at the end of the evaluation. */
  end_text?: InputMaybe<Scalars['String']['input']>;
  evaluation_id?: InputMaybe<Scalars['ID']['input']>;
  /** Enable general suggestion comment box. */
  general_suggestion?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable a second general suggestion comment box. */
  general_suggestion_2?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hide the evaluation from the evaluated employee. */
  hide_evaluation_employee?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to hide relation types from evaluators. */
  hide_relations?: InputMaybe<Scalars['Boolean']['input']>;
  /** Label for the general comment field. */
  label_comment_general?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of evaluators per evaluated employee. */
  max_limit?: InputMaybe<Scalars['Int']['input']>;
  /** Hex color for the maximum score range. */
  max_limit_color?: InputMaybe<Scalars['String']['input']>;
  /** Minimum character length for comment fields. */
  min_comment_length?: InputMaybe<Scalars['Int']['input']>;
  /** Use the competence model's defined weights. */
  model_competence_weight?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the evaluation. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Configuration for answer options and scale. */
  options_response?: InputMaybe<TalentOptionsResponseInput>;
  /** Set results to zero for incomplete evaluations. */
  quit_results_in_zero?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date when reminder notifications are sent. */
  reminder_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID of the report template to use. */
  report_template_id?: InputMaybe<Scalars['Int']['input']>;
  /** JSON string specifying which comment fields are required. */
  required_comments?: InputMaybe<Scalars['String']['input']>;
  /** Require a comment when 'don't know' is selected. */
  required_comments_dont_know?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show a comment field when 'don't know' is selected. */
  show_comments_dont_know?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show results to employees in the platform. */
  show_in_platform?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show a remainder indicator to evaluators. */
  show_remainder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show goal results alongside competence results. */
  show_results_goal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start date of the evaluation. */
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Introductory text shown at the start of the evaluation. */
  start_text?: InputMaybe<Scalars['String']['input']>;
  /** State of the evaluation. */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Secondary state of the evaluation. */
  state_2?: InputMaybe<Scalars['String']['input']>;
  /** Current state of the calibration phase. */
  state_calibration_evaluation?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of subordinate evaluators. */
  sub_limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of answer options considered invalid (not scored). */
  total_invalid_options?: InputMaybe<Scalars['Int']['input']>;
  /** Calibration type identifier. */
  type_calibration?: InputMaybe<Scalars['String']['input']>;
  /** Allow employees to view calibration results. */
  view_calibration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Welcome message displayed to evaluators. */
  welcome_text?: InputMaybe<Scalars['String']['input']>;
};

export enum TalentEvaluationParticipantsFieldsEnum {
  NameCollaborator = 'NAME_COLLABORATOR'
}

export type TalentEvaluationParticipantsSearchInput = {
  fields: Array<TalentEvaluationParticipantsFieldsEnum>;
  query: Scalars['String']['input'];
};

export enum TalentEvaluationParticipantsSortOrderEnum {
  JobLevel = 'JOB_LEVEL',
  NameCollaborator = 'NAME_COLLABORATOR',
  Subsidiary = 'SUBSIDIARY'
}

export type TalentEvaluationParticipantsSortOrderInput = {
  direction?: OrderDirectionEnum;
  field: TalentEvaluationParticipantsSortOrderEnum;
};

export type TalentEvaluationSearchInput = {
  fields: Array<TalentEvaluationFieldsEnum>;
  query: Scalars['String']['input'];
};

export enum TalentEvaluationSortOrderEnum {
  EvaluationName = 'EVALUATION_NAME'
}

export type TalentEvaluationSortOrderInput = {
  direction?: OrderDirectionEnum;
  field: TalentEvaluationSortOrderEnum;
};

export type TalentEvaluatorRelationInput = {
  /** Evaluator employee ID */
  evaluator_id: Scalars['ID']['input'];
  /** Relation of the evaluator with the evaluated */
  relation: EvaluationRelationEnum;
};

export enum TalentEvaluatorsFieldsEnum {
  EmployeeCategory = 'EMPLOYEE_CATEGORY',
  EmployeeDivision = 'EMPLOYEE_DIVISION',
  EmployeeDocument = 'EMPLOYEE_DOCUMENT',
  EmployeeEmail = 'EMPLOYEE_EMAIL',
  EmployeeLastName = 'EMPLOYEE_LAST_NAME',
  EmployeeName = 'EMPLOYEE_NAME'
}

export type TalentEvaluatorsSearchInput = {
  fields: Array<TalentEvaluatorsFieldsEnum>;
  query: Scalars['String']['input'];
};

export type TalentExcludeParticipantsMassiveEvaluationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Evaluation id */
  evaluation_id: Scalars['ID']['input'];
  /** Participants evaluated ids */
  participants_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Flag to exclude all participants in the evaluation */
  select_all?: Scalars['Boolean']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentExcludeParticipantsMassiveEvaluationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentExcludeParticipantsMassiveEvaluationPayload | ValidationErrorV2;

export type TalentFeedbackMutations = {
  __typename?: 'TalentFeedbackMutations';
  complete_feedback?: Maybe<ResponseExecutionFeedback>;
  create_feedback_attachment?: Maybe<ResponseAttachment>;
  create_or_update_feedback?: Maybe<ResponseExecutionFeedback>;
  create_or_update_feedback_configuration?: Maybe<ResponseConfiguration>;
  create_or_update_feedback_template?: Maybe<ResponseExecutionFeedback>;
  delete_feedback?: Maybe<ResponseExecutionFeedback>;
  delete_feedback_template?: Maybe<ResponseExecutionFeedback>;
  duplicate_feedback_template?: Maybe<ResponseTemplate>;
  generate_feedback_presigned_url?: Maybe<ResponseUrlPresignedS3>;
  qualify_feedback?: Maybe<ResponseExecutionFeedback>;
  reject_feedback?: Maybe<ResponseExecutionFeedback>;
  save_feedback_message_receiver?: Maybe<ResponseExecutionFeedback>;
  send_feedback_reminder?: Maybe<ResponseExecutionFeedback>;
  update_status_feedback_default_template?: Maybe<ResponseExecutionFeedback>;
  update_status_feedback_template?: Maybe<ResponseExecutionFeedback>;
};


export type TalentFeedbackMutationsComplete_FeedbackArgs = {
  input: FeedbackInput;
};


export type TalentFeedbackMutationsCreate_Feedback_AttachmentArgs = {
  input: AttachmentInput;
};


export type TalentFeedbackMutationsCreate_Or_Update_FeedbackArgs = {
  input: FeedbackInput;
};


export type TalentFeedbackMutationsCreate_Or_Update_Feedback_ConfigurationArgs = {
  employee_id?: InputMaybe<Scalars['Int']['input']>;
  input: FeedbackProcessInput;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type TalentFeedbackMutationsCreate_Or_Update_Feedback_TemplateArgs = {
  input: FeedbackTemplateInput;
};


export type TalentFeedbackMutationsDelete_FeedbackArgs = {
  employee_id: Scalars['Int']['input'];
  feedback_id: Scalars['Int']['input'];
};


export type TalentFeedbackMutationsDelete_Feedback_TemplateArgs = {
  feedback_template_id: Scalars['Int']['input'];
};


export type TalentFeedbackMutationsDuplicate_Feedback_TemplateArgs = {
  feedback_template_id: Scalars['Int']['input'];
};


export type TalentFeedbackMutationsGenerate_Feedback_Presigned_UrlArgs = {
  bucket_name: Scalars['String']['input'];
  file_name: Scalars['String']['input'];
};


export type TalentFeedbackMutationsQualify_FeedbackArgs = {
  feedback_id: Scalars['Int']['input'];
  input: QualifiedPerceptionEnum;
};


export type TalentFeedbackMutationsReject_FeedbackArgs = {
  input: FeedbackMessageInput;
};


export type TalentFeedbackMutationsSave_Feedback_Message_ReceiverArgs = {
  employee_id: Scalars['Int']['input'];
  feedback_id: Scalars['Int']['input'];
  message: Scalars['String']['input'];
};


export type TalentFeedbackMutationsSend_Feedback_ReminderArgs = {
  company_id: Scalars['Int']['input'];
  feedback_id: Scalars['Int']['input'];
};


export type TalentFeedbackMutationsUpdate_Status_Feedback_Default_TemplateArgs = {
  company_id: Scalars['Int']['input'];
};


export type TalentFeedbackMutationsUpdate_Status_Feedback_TemplateArgs = {
  feedback_template_id: Scalars['Int']['input'];
};

export type TalentFeedbackQueries = {
  __typename?: 'TalentFeedbackQueries';
  get_feedback_configuration?: Maybe<ResponseConfiguration>;
  get_feedback_dashboard?: Maybe<ResponseDashboard>;
  get_feedback_duplicate_template_name?: Maybe<ResponseExecutionFeedback>;
  get_feedback_employee_list?: Maybe<ResponseEmployee>;
  get_feedback_module_name?: Maybe<ResponseModule>;
  get_feedback_my_team_active_person?: Maybe<ResponseMyTeam>;
  get_feedback_my_team_resume?: Maybe<ResponseMyTeam>;
  get_feedback_perception?: Maybe<ResponsePerception>;
  get_feedback_qualified?: Maybe<ResponseExecutionFeedback>;
  get_feedback_templates?: Maybe<ResponseTemplate>;
  get_feedbacks_by_company_or_team?: Maybe<ResponseFeedbackUser>;
  get_feedbacks_by_employee?: Maybe<ResponseFeedback>;
  get_feedbacks_by_team?: Maybe<ResponseFeedbackUser>;
  get_filters_by_company?: Maybe<ResponseEmployee>;
  get_module_name?: Maybe<ResponseModule>;
};


export type TalentFeedbackQueriesGet_Feedback_ConfigurationArgs = {
  company_id: Scalars['Int']['input'];
  employee_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type TalentFeedbackQueriesGet_Feedback_DashboardArgs = {
  company_id: Scalars['Int']['input'];
  end_date?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
};


export type TalentFeedbackQueriesGet_Feedback_Duplicate_Template_NameArgs = {
  company_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  template_id?: InputMaybe<Scalars['Int']['input']>;
};


export type TalentFeedbackQueriesGet_Feedback_Employee_ListArgs = {
  company_id: Scalars['Int']['input'];
  division_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type TalentFeedbackQueriesGet_Feedback_Module_NameArgs = {
  code: Scalars['String']['input'];
  company_id: Scalars['Int']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};


export type TalentFeedbackQueriesGet_Feedback_My_Team_Active_PersonArgs = {
  employee_id: Scalars['Int']['input'];
};


export type TalentFeedbackQueriesGet_Feedback_My_Team_ResumeArgs = {
  employee_id: Scalars['Int']['input'];
};


export type TalentFeedbackQueriesGet_Feedback_PerceptionArgs = {
  company_id: Scalars['Int']['input'];
};


export type TalentFeedbackQueriesGet_Feedback_QualifiedArgs = {
  feedback_id: Scalars['Int']['input'];
};


export type TalentFeedbackQueriesGet_Feedback_TemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  company_id: Scalars['Int']['input'];
  employee_id?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type TalentFeedbackQueriesGet_Feedbacks_By_Company_Or_TeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  input: FeedbackCollaboratorFilterInput;
};


export type TalentFeedbackQueriesGet_Feedbacks_By_EmployeeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: FeedbackFilterInput;
};


export type TalentFeedbackQueriesGet_Feedbacks_By_TeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  input: MyTeamFilterInput;
};


export type TalentFeedbackQueriesGet_Filters_By_CompanyArgs = {
  company_id: Scalars['Int']['input'];
  employee_id?: InputMaybe<Scalars['Int']['input']>;
  type: FilterTypeEnum;
};


export type TalentFeedbackQueriesGet_Module_NameArgs = {
  code: Scalars['String']['input'];
  company_id: Scalars['Int']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};

export type TalentFinishClimateSurveyInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Centralized user id of the collaborator (standard identity envelope; accepted but not consumed by climate). */
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  /** Survey model id to finish. */
  model_id: Scalars['ID']['input'];
  /** Participant id to finish. Optional in the schema; required at resolve time. */
  partaker_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator. Required at resolve time — scopes every climate read/write to this collaborator. */
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent user id of the collaborator (standard identity envelope). */
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGaussConfiguration = {
  __typename?: 'TalentGaussConfiguration';
  color?: Maybe<GaussBellColorEnum>;
  company_id?: Maybe<Scalars['ID']['output']>;
  final_scale_limit?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  initial_scale_limit?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TalentGaussConfigurationInput = {
  color: GaussBellColorEnum;
  final_scale_limit: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  initial_scale_limit?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

/** UNIONS */
export type TalentGeneralReportsResultResponse = ResponseInternalError | ResponseValidationError | TalentReportsProcessByModuleList;

export type TalentGenerateCompetenceWeightTemplateInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the competence model to generate the weight template for. */
  competences_model_id: Scalars['ID']['input'];
  /** Language code for the generated template headers and content (ES, EN, PT). */
  language: LanguageEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGenerateCompetenceWeightTemplateResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCompetenceWeightTemplatePayload | ValidationErrorV2;

export type TalentGenerateEvaluationDeleteRelationsTemplateInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the evaluation whose questionnaires will populate the template. */
  evaluation_id: Scalars['ID']['input'];
  /** Language code for the generated template headers and content (ES, EN, PT). */
  language: LanguageEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGenerateEvaluationDeleteRelationsTemplateResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentEvaluationDeleteRelationsTemplatePayload | ValidationErrorV2;

export type TalentGenerateMassiveUploadCompetencesTemplateInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the evaluation for which the competences template will be generated. */
  evaluation_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGenerateMassiveUploadCompetencesTemplateResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentGenerateMassiveCompetencesRelationsTemplatePayload | ValidationErrorV2;

export type TalentGenerateMassiveUploadTemplateInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Evaluation ID */
  evaluation_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGenerateMassiveUploadTemplatePayload = {
  __typename?: 'TalentGenerateMassiveUploadTemplatePayload';
  file_url: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type TalentGenerateMassiveUploadTemplateResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentGenerateMassiveUploadTemplatePayload | ValidationErrorV2;

export type TalentGenerateNom035ReportCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID del colaborador evaluado (innpulsa.employee2.id) — el mismo valor numérico que el listado del dashboard expone como node.employee.id. REQUERIDO para REPORT_BY_COLLABORATOR_NOM035 (se convierte en el selectedEmployeeId de Flex); IGNORADO para REPORT_INDIVIDUAL_NOM035, cuyo universo se deriva de evaluation_id. */
  employee_id?: InputMaybe<Scalars['Int']['input']>;
  /** ID de la evaluación NOM035 -> evaluation.evaluation.id (dtype='FormEvaluation' AND step=2). Requerido de hecho para los dos tipos. */
  evaluation_id?: InputMaybe<Scalars['Int']['input']>;
  /** Qué artefacto producir. Default REPORT_BY_COLLABORATOR_NOM035 para que el panel del colaborador que ya está en QA (que no manda este campo) siga recibiendo su PDF individual. Un null EXPLÍCITO se resuelve al mismo default en el BE. */
  report_type?: InputMaybe<TalentNom035ReportTypeEnum>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGenerateNom035ReportResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | Nom035EmployeeNotInEvaluationErrorV2 | Nom035EvaluationNotFoundErrorV2 | Nom035InvalidCompanyErrorV2 | Nom035NoEvaluatedParticipantsErrorV2 | Nom035NoFinishedQuestionnairesErrorV2 | Nom035QuestionnaireNotFinishedErrorV2 | Nom035ReportEmployeeNotFoundErrorV2 | Nom035RequiredFieldErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035ReportPayload | ValidationErrorV2;

export type TalentGenerateQuestionnairesInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  evaluation_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGenerateQuestionnairesResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentGenerateQuestionnairesPayload | ValidationErrorV2;

export type TalentGetCanSendRecognitionCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Centralized (Crehana core) user id of the caller (standard identity envelope). Used for the audit trail only — never a query filter. */
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator making the request. Required at resolve time: it scopes the operation to this collaborator and is recorded in the audit trail. */
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent user id of the caller (standard identity envelope). Used for the audit trail only — never a query filter. */
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetCanSendRecognitionCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentCanSendRecognitionCollaboratorPayload | ValidationErrorV2;

export type TalentGetClimateEvaluationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Centralized user id of the collaborator (standard identity envelope; accepted but not consumed by climate). */
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  /** Survey model id to load. */
  model_id: Scalars['ID']['input'];
  /** Participant id whose saved answers are loaded. Optional in the schema; required at resolve time IF the questions facet is selected. */
  partaker_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator. Required at resolve time — scopes every climate read/write to this collaborator. */
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent user id of the collaborator (standard identity envelope). */
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetCompanyMailTemplateInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  code: Scalars['String']['input'];
  language: LanguageEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetCompanyMailTemplateResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCompanyMailTemplatePayload | ValidationErrorV2;

export type TalentGetCompanyResultsConfigurationsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  language?: LanguageEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetCompanyResultsConfigurationsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentListCompanyResultsConfigurationsPayload | ValidationErrorV2;

export type TalentGetCompetenceDashboardInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the evaluation to get the dashboard statistics for. */
  evaluation_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetCompetenceDashboardResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCompetenceDashboardPayload | ValidationErrorV2;

export type TalentGetCompetenceEmailTemplatesInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the competences evaluation */
  evaluation_id: Scalars['Int']['input'];
  /** Language code of the template: ES, EN or PT */
  language_code: CompetenceLanguageCodeEnum;
  /** Type of email template: COMPETENCES_INVITATION or COMPETENCES_REMINDER */
  notification_type: CompetenceNotificationTypeEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetCompetenceEmailTemplatesResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCompetenceEmailTemplateItem | ValidationErrorV2;

export type TalentGetCompetenceLevelInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competence to get competence level. */
  competence_id: Scalars['ID']['input'];
  /** The ID of the category level in competence. */
  level_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetCompetenceLevelResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentGetCompetenceLevelPayload | ValidationErrorV2;

export type TalentGetCompetenceModelTemplateInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the competence model to export as an Excel template. */
  competences_model_id: Scalars['ID']['input'];
  /** Language code for the generated template headers and content (ES, EN, PT). */
  language: LanguageEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetCompetenceModelTemplateResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCompetenceModelTemplatePayload | ValidationErrorV2;

export type TalentGetCompetencesModelStatisticsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competences model to get details. */
  competences_model_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetCompetencesModelStatisticsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentGetCompetencesModelStatisticsPayload | ValidationErrorV2;

export type TalentGetConfigurationGeneralEvaluationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the evaluation to get general configuration. */
  evaluation_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetConfigurationGeneralEvaluationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentEvaluation | ValidationErrorV2;

export type TalentGetEmployeeCompetencesCoverageInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competence model to filter the coverage. */
  competence_model_id: Scalars['ID']['input'];
  /** The ID of the employee to get competences coverage. */
  employee_id: Scalars['ID']['input'];
  /** The language code for translating competence names. */
  language_code: LanguageEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetEvaluationRelationWeightsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the evaluation to get relation weights for. */
  evaluation_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetEvaluationRelationWeightsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentEvaluationRelationWeightsPayload | ValidationErrorV2;

export type TalentGetMassiveCompetencesRelationsStatusInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The job ID of the massive competences relations upload process. */
  job_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetMassiveCompetencesRelationsStatusResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateGetMassiveParticipantsStatusResponse | ValidationErrorV2;

export type TalentGetMassiveCompetencesStatusInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the sqs job. */
  job_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetMassiveCompetencesStatusResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateGetMassiveCompetencesStatusResponse | ValidationErrorV2;

export type TalentGetMassiveParticipantsStatusInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The job ID of the massive participants upload process. */
  job_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetMassiveParticipantsStatusResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateGetMassiveParticipantsStatusResponse | ValidationErrorV2;

export type TalentGetMassiveProcessStatusInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The job ID of the massive upload process to query. */
  job_id: Scalars['ID']['input'];
  /** The type of massive process. One of: COMPETENCES_RELATIONS, PARTICIPANTS, COMPETENCES_MODEL, COMPETENCE_WEIGHTS, EVALUATION_DELETE_RELATIONS, DIP_ACTIVITY_ASSIGNMENT, DIP_ACTIVITY_TRACKING, DIP_LIBRARY_ACTIVITY. */
  process_type: MassiveProcessTypeEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetMassiveProcessStatusResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateGetMassiveParticipantsStatusResponse | ValidationErrorV2;

export type TalentGetPerformanceResultConfigurationGaussInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetPerformanceResultConfigurationGaussResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentGaussConfigurationPayload | ValidationErrorV2;

export type TalentGetPerformanceResultConfigurationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetPerformanceResultConfigurationProcessInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetPerformanceResultConfigurationProcessResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentPerformanceResultConfigurationProcessPayload | ValidationErrorV2;

export type TalentGetPerformanceResultConfigurationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentPerformanceResultConfigurationPayload | ValidationErrorV2;

export type TalentGetRecognitionApplicationsMedalsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentApplicationMedalsConnection | ValidationErrorV2;

export type TalentGetRecognitionConfigurationCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Centralized (Crehana core) user id of the caller (standard identity envelope). Used for the audit trail only — never a query filter. */
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator making the request. Required at resolve time: it scopes the operation to this collaborator and is recorded in the audit trail. */
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent user id of the caller (standard identity envelope). Used for the audit trail only — never a query filter. */
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetRecognitionConfigurationCollaboratorPayload = {
  __typename?: 'TalentGetRecognitionConfigurationCollaboratorPayload';
  recognition_configuration: TalentRecognitionConfiguration;
};

export type TalentGetRecognitionConfigurationCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentGetRecognitionConfigurationCollaboratorPayload | ValidationErrorV2;

export type TalentGetRecognitionDetailCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** recognitionemployee.id of the row the collaborator tapped in the medal wall — the same value both listing operations return. For a group send it may be ANY member's row, not only the representative id the outbox exposed (RN-010): the answer is always the detail of THAT row, with its own request_status and comment_request, never a sibling's. Must be a positive integer id (INVALID_RECOGNITION_EMPLOYEE_ID). */
  recognition_employee_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator making the request. Recorded in the audit trail; it does NOT filter the read (✏️ dev decision, 2026-08-11 — the operation is a generic get, so any collaborator of the razón social opens any recognition of it by id). */
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetRecognitionDetailCollaboratorPayload = {
  __typename?: 'TalentGetRecognitionDetailCollaboratorPayload';
  /** The recognitionemployee row that was asked for, with both of its parties: sender and receiver are whoever the row names, and sender is null only when is_from_admin — the COMPANY granted the medal and the admin's identity is deliberately not surfaced (RN-009). The SPECIFIC row identified by recognition_employee_id, which for a batch may be any member's and not the representative the outbox exposed (RN-010), with its OWN request_status / comment_request, which describe only that row — a sibling's verdict is never implied. groups_info carries the full roster of the batch, unfiltered by state; it is null when the recognition was not part of one. */
  recognition: TalentRecognitionEmployee;
};

export type TalentGetRecognitionDetailCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentGetRecognitionDetailCollaboratorPayload | ValidationErrorV2;

export type TalentGetRecognitionPostDetailCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** innpulsa.recognitionemployee.id — the post being opened, the same value every edge of the company wall returns as node.recognition_employee.id. Stays an Int! and stays OUTSIDE the identity envelope (G-05): it is the domain id of the target, not the identity of the caller. For a mass send it may be ANY member's row, never only a representative one: the answer is always the detail of THAT row. IT IS NOT RANGE-CHECKED: every id the caller cannot reach answers the SAME NotFoundErrorV2 RECOGNITION_NOT_FOUND — it is 0 or negative, it does not exist, it was deleted (U4), it is PENDING or REJECTED (RN-02), it is older than a year (RN-03), it belongs to another company, or it is PRIVATE and the caller is neither its receiver nor its sender. */
  recognition_employee_id: Scalars['Int']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator making the request. REQUIRED at resolve time: an absent, non-positive or non-canonical value answers NotAuthenticatedErrorV2 NOT_AUTHENTICATED. It also decides whether a PRIVATE post opens at all: only its receiver or its sender may read one. */
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetRecognitionPostDetailCollaboratorPayload = {
  __typename?: 'TalentGetRecognitionPostDetailCollaboratorPayload';
  /** The WHOLE comment thread of the post, each comment with its own reactions — the same node list_recognition_comments_collaborator puts in its edges. Ordered createddate ASC NULLS LAST, id ASC, the same order the paginated listing serves, so the two operations can never disagree about what the thread IS or how it reads: a dateless comment closes the thread and a same-timestamp group has a total order. NOT PAGINATED here — this is one post's contents, not a page of a listing. EMPTY, NEVER NULL, on a post nobody has commented. Deleted comments never appear (the active-row rule, both branches of it, U4). */
  comments: Array<TalentRecognitionCommentWithReactions>;
  /** The reactions of the POST itself: innpulsa.recognition_reaction WHERE recognition_id = recognitionemployee.id AND dtype = 'MEDAL' AND the row is active, ordered by id ASC, each row carrying the collaborator who reacted. dtype = 'MEDAL' IS WHAT KEEPS THE COMMENT LIKES OUT OF THIS LIST: the DDL makes recognition_id NOT NULL on a comment reaction too — it points at the post the comment hangs off — so a query filtering by recognition_id alone would merge the likes of the thread into the reactions of the post. The comment likes travel inside comments[].comment_reactions, keyed by comment_id. EMPTY, NEVER NULL, in two situations the client cannot tell apart and does not need to: nobody ever reacted, and every reaction was removed. DERIVATION: the caller's own reaction on the post is the entry whose employee.id == input.talent_employee_id; that entry's id is the recognition_reaction_id the reaction mutation updates or deletes, and its reaction_type is what the button paints. THE COMPANY WALL DOES NOT MAKE THE CLIENT SCAN THIS LIST — its node carries context.reaction, the caller's own row already picked out. This operation serves the whole list because the detail screen renders every reactor. */
  reactions: Array<TalentRecognitionReaction>;
  /** The row of recognitionemployee — THE shared row of the module, the same node the wall serves inside its edges, so a client reuses the fragment it already has for a card: the medal, both texts, the visibility, the corporate flag, the date, and the RECEIVER and SENDER resolved as the platform's employee node. sender is null when is_from_admin is true (the organization granted the medal, not a person, RN-11) — a client must read is_from_admin to decide 'corporate' and never sender == null, because the sender side is also null when the sender id no longer resolves to an employee. groups_info IS ALWAYS NULL ON THIS OPERATION and that is an explicit decision, not an absence of data: this read never loads the batch roster, so a post that really belongs to a batch and really has siblings still answers null here, and the COMPANY WALL is where a client reads them. Nullable for envelope symmetry with the other node wrappers of this schema; on this operation the row is always present, since a payload without it would have nothing to be about. */
  recognition_employee?: Maybe<TalentRecognitionEmployee>;
  /** The four counters of the post — the SAME block the company wall puts on every card, not redeclared here, so the numbers on the card and the numbers on its detail are one formula. Counted on every read, never stored: a reaction or a comment written through this epic's own mutations moves them on the very next call. IT IS REDUNDANT WITH THE TWO LISTS BELOW, and deliberately so — total_comments == comments.length and total_like + total_love + total_interesting == reactions.length on every answer — because the card the client already renders reads THESE, and because a client that only needs the header of the screen can select statistics and skip both lists. Nullable for envelope symmetry and, likewise, always present: a post with no interaction answers four zeros, never a null block. */
  statistics?: Maybe<TalentRecognitionEmployeeReactionsStatistics>;
};

export type TalentGetRecognitionPostDetailCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentGetRecognitionPostDetailCollaboratorPayload | ValidationErrorV2;

export type TalentGetRecognitionRankingReceiverCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** RN-02, THE ORDER CRITERION, SUPPLIED BY THE CLIENT. true orders the rows by POINTS and the header reads 'Top puntos'; false (and null) orders them by MEDALS, 'Top medallas'. IT IS THE SAME VALUE THE CLIENT ALREADY HOLDS: get_recognition_configuration_collaborator publishes is_public_ranking_points_enabled off recognition_configuration_plan.public_ranking_points, and passing it here is what lets this operation answer WITHOUT READING THAT TABLE AGAIN — one query per request instead of two. SEND WHAT THE CONFIGURATION QUERY GAVE YOU AND NOTHING ELSE: the value is the COMPANY's decision, so inventing it per user, remembering a stale one or flipping it as a UI toggle makes the server order a page by a criterion the company never chose, and nothing on the server can detect that any more. NULL IS NOT 'unknown, ask the server' — it is the MEDALS branch, the same reading a null column has, which is also what an omitted member gets. THE SERVER STILL ORDERS: this picks the ordering it applies, it does not ask the client to sort, and metadata.data.order_criterion echoes back the criterion the rows were ACTUALLY ordered by, so a client can assert the two agree. */
  is_public_ranking_points_enabled: Scalars['Boolean']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** The employee whose row is being read, and the only one this operation  */
  talent_employee_id: Scalars['ID']['input'];
};

export type TalentGetRecognitionRankingReceiverCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentRecognitionRankingReceiver | ValidationErrorV2;

export type TalentGetRecognitionReactionDetailsCollaboratorConnection = {
  __typename?: 'TalentGetRecognitionReactionDetailsCollaboratorConnection';
  edges: Array<TalentGetRecognitionReactionDetailsCollaboratorEdge>;
  metadata: TalentMetadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** recognitionemployee.id of the inspected post — echoed back so the client can key the popup cache to the post it opened. */
  recognition_employee_id: Scalars['ID']['output'];
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type TalentGetRecognitionReactionDetailsCollaboratorEdge = {
  __typename?: 'TalentGetRecognitionReactionDetailsCollaboratorEdge';
  /** Position of the reaction in the FILTERED tab, base64 of `arrayconnection:<offset>` like every offset connection of this repo, so page 2 of page_size 8 starts at the encoding of 8. NOT A STABLE POINTER TO A ROW: a reaction written while the client pages shifts every cursor after it by one. Paging is `pagination`, always. */
  cursor: Scalars['String']['output'];
  /** The reaction at the end of the edge, with its reactor RESOLVED into the shared TalentEmployee (person, job, division, avatar) — the same person node the comment author and both sides of a wall card are served as, so one client fragment covers all of them. It is null only when the reactor no longer resolves to an employee2 row (they left the directory): the reaction still counts and still travels, and only that side goes null, because a fabricated placeholder person would be worse — the client could not tell it from a real one. RN-12: the avatar URLs are KNOWN BROKEN post-migration and the column may be null, so the client MUST fall back to the default avatar and never block on it. */
  node: TalentRecognitionReaction;
};

export type TalentGetRecognitionReactionDetailsCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The selected tab. Omitting it — or sending filter: null — opens the popup on LOVE, NOT on the first value of the enum and NOT on 'everything': this operation always answers ONE type. It replaces the old optional reaction_type that returned EVERY group when null, because the popup does not need every reactor of every type on open — it needs the three numbers for the tab headers (which ride in metadata.data, unfiltered and unpaged) and the people of the open tab only. */
  filter?: InputMaybe<TalentRecognitionReactionDetailsFilterInput>;
  /** Standard 1-based offset pagination, the shared TalentBasePaginationInput (page: 1, page_size: 8 by default), resolved IN THE DATABASE as OFFSET (page - 1) * page_size LIMIT page_size. 1-BASED, and that CHANGED MEANING on this operation: the legacy REST was 0-indexed, so page 0 used to be the FIRST page and now answers ValidationErrorV2 INVALID_PAGE, as does any negative. page_size is bounded 1..50, the ONE ceiling of the epic (this popup used to allow 100), and a value outside it is refused rather than clamped so the client can trust the size it divides total_count by; the old default of 20 reactors per tab is gone, so a tab of more than 8 needs a second call or an explicit page_size. Omitting the block, sending {} or nulling either member all fall back to the shared defaults, and `page` is validated before `page_size`. The window applies to the SELECTED TAB only — the three counters in metadata.data are never paged, which is what keeps the tab headers correct while their tab is being scrolled. The legacy in-memory pagination (PageableUtil.getPageFromList, quirk Q-03) is deliberately NOT replicated. A page PAST THE END is not an error: it answers edges [] with the real total_count, the real counters and has_next_page false. */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  /** recognitionemployee.id of the post whose reactions are being inspected. The post must exist, be staterequest = APPROVED (RN-02), inside the one-year senddate window (RN-03), not soft-deleted (U4), belong to talent_company_id (RN-04 / U2) and be either PUBLIC or a recognition the CALLER took part in; every failure answers the SAME NotFoundErrorV2 RECOGNITION_NOT_FOUND so a caller cannot enumerate another tenant's ids. A PRIVATE POST HAS A READABLE REACTION BREAKDOWN FOR ITS SENDER AND ITS RECEIVER and none for anybody else — the same rule get_recognition_post_detail_collaborator opens it under. Stays an ID! and stays OUTSIDE the envelope (G-05) — it is a domain id — but it is now coerced with the SAME strict rule as the envelope ids: only the CANONICAL decimal form is accepted (digits, no leading zero) and it must be positive, or the answer is ValidationErrorV2 INVALID_RECOGNITION_EMPLOYEE_ID. That is a CHANGE: the old raw Number() normalised surrounding blanks, leading zeros and a redundant '.0', so ' 9018', '09018' and '9018.0' all resolved post 9018 — four spellings of one id is how a cache ends up holding the same post under four keys. Well-formed input echoes back unchanged. */
  recognition_employee_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator making the request. REQUIRED at resolve time: an absent, non-positive or non-canonical value answers NotAuthenticatedErrorV2 NOT_AUTHENTICATED. It authorises the read and resolves NO field of the payload. */
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetRecognitionReactionDetailsCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentGetRecognitionReactionDetailsCollaboratorConnection | ValidationErrorV2;

export type TalentGetRecognitionRedemptionBalanceCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator making the request. NON-NULL: it scopes the balance to this collaborator (recognition_redemption.employee_id / recognitionemployee.employee_id), so the schema rejects a request without it instead of the resolver. */
  talent_employee_id: Scalars['ID']['input'];
};

export type TalentGetRecognitionRedemptionBalanceCollaboratorPayload = {
  __typename?: 'TalentGetRecognitionRedemptionBalanceCollaboratorPayload';
  /** Point balance of the caller: total earned, already spent and available to spend (RN-02). Single aggregate, no pagination. */
  statistics: TalentRecognitionRedemptionBalanceStatistics;
};

export type TalentGetRecognitionRedemptionBalanceCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentGetRecognitionRedemptionBalanceCollaboratorPayload | ValidationErrorV2;

export type TalentGetRecognitionResultsDynamicReportResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentGetRecognitionResultsDynamicReportPayload | ValidationErrorV2;

export type TalentGetRecognitionResultsManualAnalysisReportResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentGetRecognitionManualAnalysisReportPayload | ValidationErrorV2;

export type TalentGetRecognitionResultsSummaryMetricsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentGetRecognitionResultsSummaryMetricsPayload | ValidationErrorV2;

export type TalentGetRecognitionRewardCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** recognition_product.id of the reward to read. REQUIRED. A non-existent id, a soft-deleted product or one of another company all answer the SAME NotFoundErrorV2 (REWARD_NOT_AVAILABLE) so another tenant's id space is not enumerable. */
  recognition_product_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentGetRecognitionRewardCollaboratorPayload = {
  __typename?: 'TalentGetRecognitionRewardCollaboratorPayload';
  /** The resolved reward — the shared TalentRecognitionProduct node (id, name, description, image, points, type, has_stock, state). */
  reward: TalentRecognitionProduct;
};

export type TalentGetRecognitionRewardCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentGetRecognitionRewardCollaboratorPayload | ValidationErrorV2;

export type TalentGoalDetail = {
  __typename?: 'TalentGoalDetail';
  employeeInfo: GoalsEmployeeInfoDto;
  goalDetail?: Maybe<IndividualGoalDetailDto>;
  goalExtraFields?: Maybe<Array<Maybe<GoalExtraFieldSummaryDto>>>;
  goalTrackingList?: Maybe<Array<Maybe<GoalReportDto>>>;
};

export type TalentGoalDetailResponse = ResponseInternalError | ResponseValidationError | TalentGoalDetail;

export type TalentGoalPartakersByProcessResponse = ResponseInternalError | ResponseValidationError | TalentGoalsPartakersByProcessPayload;

export type TalentGoalPeriodSortOrderInput = {
  direction: OrderDirectionEnum;
  field: GoalPeriodSortFieldsEnum;
};

export type TalentGoalProcess = {
  __typename?: 'TalentGoalProcess';
  auto_eval_first?: Maybe<Scalars['Boolean']['output']>;
  boss_delete_goals?: Maybe<Scalars['Boolean']['output']>;
  company_id: Scalars['Int']['output'];
  created_date?: Maybe<Scalars['DateTime']['output']>;
  deleted_date?: Maybe<Scalars['DateTime']['output']>;
  edit_goal_with_track?: Maybe<Scalars['Boolean']['output']>;
  edit_goal_without_track?: Maybe<Scalars['Boolean']['output']>;
  edit_weight?: Maybe<Scalars['Boolean']['output']>;
  end_date: Scalars['DateTime']['output'];
  goal_track_id?: Maybe<Scalars['Int']['output']>;
  goals_days_emp?: Maybe<Scalars['Int']['output']>;
  goals_days_load?: Maybe<Scalars['Int']['output']>;
  goals_edit_boss?: Maybe<Scalars['Boolean']['output']>;
  goals_edit_emp?: Maybe<Scalars['Boolean']['output']>;
  goals_limit?: Maybe<Scalars['Float']['output']>;
  goals_max?: Maybe<Scalars['Int']['output']>;
  goals_min?: Maybe<Scalars['Int']['output']>;
  goals_new_boss?: Maybe<Scalars['Boolean']['output']>;
  goals_new_emp?: Maybe<Scalars['Boolean']['output']>;
  goals_result_type?: Maybe<GoalsResultTypeEnum>;
  id: Scalars['Int']['output'];
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  limit1?: Maybe<Scalars['Float']['output']>;
  limit2?: Maybe<Scalars['Float']['output']>;
  limit3?: Maybe<Scalars['Float']['output']>;
  limit4?: Maybe<Scalars['Float']['output']>;
  mail_collaborator?: Maybe<Scalars['Boolean']['output']>;
  mail_text?: Maybe<Scalars['String']['output']>;
  mail_text_boss?: Maybe<Scalars['String']['output']>;
  mail_text_collaborator?: Maybe<Scalars['String']['output']>;
  mail_text_evaluated?: Maybe<Scalars['String']['output']>;
  mail_text_evaluated_boss?: Maybe<Scalars['String']['output']>;
  meta_max?: Maybe<Scalars['Int']['output']>;
  meta_min?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  no_approve_required?: Maybe<Scalars['Boolean']['output']>;
  progress_conversion?: Maybe<Scalars['Boolean']['output']>;
  required_evidence?: Maybe<Scalars['Boolean']['output']>;
  required_feedback?: Maybe<Scalars['Boolean']['output']>;
  required_goals_same?: Maybe<Scalars['Boolean']['output']>;
  show_dashboard?: Maybe<Scalars['Boolean']['output']>;
  show_semaphore_labels?: Maybe<Scalars['Boolean']['output']>;
  start_date: Scalars['DateTime']['output'];
  state?: Maybe<EntityState>;
  track_type?: Maybe<GoalTrackTypeEnum>;
};

/** An edge in a connection. */
export type TalentGoalProcessEdge = {
  __typename?: 'TalentGoalProcessEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TalentGoalProcess;
};

export type TalentGoalsByEmployeeInput = {
  company_id: Scalars['Int']['input'];
  employee_id: Scalars['Int']['input'];
  process_id: Scalars['Int']['input'];
  track_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentGoalsEmployeeResult = {
  __typename?: 'TalentGoalsEmployeeResult';
  calculation_type?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<TalentEmployee>;
  process_id: Scalars['Int']['output'];
  process_name: Scalars['String']['output'];
  total_result?: Maybe<TalentResult>;
};

export type TalentGoalsEmployeeResultInput = {
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  centralized_user_id?: InputMaybe<Scalars['Int']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  employee_id: Scalars['Int']['input'];
  process_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentGoalsEmployeeResultResponse = ResponseInternalError | ResponseValidationError | TalentGoalsEmployeeResult;

/** INPUTS */
export type TalentGoalsGeneralInformationProcessInput = {
  company_id: Scalars['Int']['input'];
  employee_id?: InputMaybe<Scalars['Int']['input']>;
  process_id: Scalars['Int']['input'];
};

export type TalentGoalsIndividualGoalDetailInput = {
  company_id: Scalars['Int']['input'];
  employee_id: Scalars['Int']['input'];
  goal_id: Scalars['Int']['input'];
  process_id: Scalars['Int']['input'];
};

export type TalentGoalsPartakerDto = {
  __typename?: 'TalentGoalsPartakerDTO';
  avatarUrl: Scalars['String']['output'];
  employeeId: Scalars['Int']['output'];
  job: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numGoals: Scalars['Int']['output'];
  percentageResult?: Maybe<Scalars['Float']['output']>;
  scaleResult?: Maybe<Scalars['Float']['output']>;
  semaphoreColor?: Maybe<Scalars['String']['output']>;
  semaphoreLabel?: Maybe<Scalars['String']['output']>;
};

export type TalentGoalsPartakersByProcessPayload = {
  __typename?: 'TalentGoalsPartakersByProcessPayload';
  partakers?: Maybe<Array<Maybe<TalentGoalsPartakerDto>>>;
  total_count: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type TalentGoalsPartakersFilter = {
  leaderId_eq?: InputMaybe<Scalars['Int']['input']>;
  trackPeriodId_eq?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentGoalsPartakersInput = {
  company_id: Scalars['Int']['input'];
  filter?: InputMaybe<TalentGoalsPartakersFilter>;
  pagination: OffsetPaginationInput;
  process_id: Scalars['Int']['input'];
  search?: InputMaybe<ReportsSearchInput>;
  sort?: InputMaybe<SortInput>;
};

/** RESPONSES */
export type TalentGoalsProcessInformation = {
  __typename?: 'TalentGoalsProcessInformation';
  employeeSummary?: Maybe<TalentEmployeeGoalSummaryDto>;
  tracks: Array<Maybe<GoalTrackPeriodDto>>;
};

/** UNIONS */
export type TalentGoalsProcessInformationResponse = ResponseInternalError | ResponseValidationError | TalentGoalsProcessInformation;

export type TalentHcmQuery = {
  __typename?: 'TalentHCMQuery';
  advanced_configuration?: Maybe<AdvancedConfigurationResponse>;
  get_company_filters?: Maybe<TalentCompanyFiltersResponse>;
  get_hcm_employees_by_company?: Maybe<HcmEmployeesByCompanyResponse>;
  get_labels_translation?: Maybe<TalentLabelResponse>;
  /** Query to get new label translates */
  get_labels_translation_without_cache: TalentListNewLabelsResponse;
  /** Query to get new label translates */
  list_talent_new_label: TalentListNewLabelsResponse;
  /** Query to list company processes grouped by module */
  list_talent_processes_by_company?: Maybe<TalentProcessesByCompanyResponse>;
  talent_mail: TalentMailQuery;
};


export type TalentHcmQueryAdvanced_ConfigurationArgs = {
  input: AdvancedConfigurationInput;
};


export type TalentHcmQueryGet_Company_FiltersArgs = {
  input: TalentCompanyFiltersInput;
};


export type TalentHcmQueryGet_Hcm_Employees_By_CompanyArgs = {
  input: TalentEmployeeInput;
};


export type TalentHcmQueryGet_Labels_TranslationArgs = {
  input: TalentLabelInput;
};


export type TalentHcmQueryGet_Labels_Translation_Without_CacheArgs = {
  input: TalentListNewLabelsInput;
};


export type TalentHcmQueryList_Talent_New_LabelArgs = {
  input: TalentListNewLabelsInput;
};


export type TalentHcmQueryList_Talent_Processes_By_CompanyArgs = {
  input: TalentListProcessesInput;
};

export enum TalentHcmFilterTypeEnum {
  City = 'CITY',
  Country = 'COUNTRY',
  Division = 'DIVISION',
  Gender = 'GENDER',
  Job = 'JOB',
  Subsidiary = 'SUBSIDIARY'
}

export type TalentIndividualGoalsByEmployee = {
  __typename?: 'TalentIndividualGoalsByEmployee';
  goals: Array<Maybe<IndividualGoalByEmployeeDto>>;
};

export type TalentIndividualGoalsByEmployeeResponse = ResponseInternalError | ResponseValidationError | TalentIndividualGoalsByEmployee;

export type TalentJob = {
  __typename?: 'TalentJob';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TalentLabel = {
  __typename?: 'TalentLabel';
  id?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TalentLabelInput = {
  company_id: Scalars['Int']['input'];
  labels: Array<Scalars['String']['input']>;
  language: LanguageEnum;
};

export type TalentLabelList = {
  __typename?: 'TalentLabelList';
  labels: Array<TalentLabel>;
};

export type TalentLabelNewAppInput = {
  /** Label code (identifier within the module) */
  code: Scalars['String']['input'];
  /** English translation */
  en: Scalars['String']['input'];
  /** Spanish translation */
  es: Scalars['String']['input'];
  /** Module/namespace the label belongs to */
  module: Scalars['String']['input'];
  /** Portuguese translation */
  pt: Scalars['String']['input'];
};

export type TalentLabelResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TalentLabelList;

export enum TalentLanguage {
  English = 'ENGLISH',
  Portuguese = 'PORTUGUESE',
  Spanish = 'SPANISH'
}

export type TalentListActiveCompetencesModelResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCompetencesModelListPayload | ValidationErrorV2;

export type TalentListAllCompetencesInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competence model to list its competences. When omitted, the competences of every model of the company are returned */
  competence_model_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListAllCompetencesResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentListAllCompetencesPayload | ValidationErrorV2;

export type TalentListAvailableMedalsToSendCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Centralized (Crehana core) user id of the caller (standard identity envelope). Used for the audit trail only — never a query filter. */
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional catalog filters (leader-exclusive medals). */
  filter?: InputMaybe<TalentAvailableMedalsToSendFilterInput>;
  /** Standard 1-based offset pagination (page: 1, page_size: 8 by default). 1-based on purpose — the legacy endpoint was 0-indexed and its client sent page - 1. */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator making the request. Required at resolve time: it scopes the operation to this collaborator and is recorded in the audit trail. */
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent user id of the caller (standard identity envelope). Used for the audit trail only — never a query filter. */
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListAvailableMedalsToSendCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentRecognitionCompanyMedalsConnection | ValidationErrorV2;

export type TalentListBehaviorsByCategoryInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competence to filter behaviors. */
  competence_id: Scalars['ID']['input'];
  /** The ID of the competence level linked to the competence. */
  competence_level_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListBehaviorsByCategoryResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentListBehaviorsByCategoryPayload | ValidationErrorV2;

export type TalentListClimateEvaluationsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Centralized user id of the collaborator (standard identity envelope; accepted but not consumed by climate). */
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional server-side filters for the evaluations list. */
  filter?: InputMaybe<ClimateEvaluationFilterInput>;
  /** Standard offset pagination (shared ``TalentBasePaginationInput``). ``page`` is 1-based; the service translates it to the 0-based page the Java endpoint expects. Defaults to page 1, page_size 10 when omitted entirely. */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator. Required at resolve time — scopes every climate read/write to this collaborator. */
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent user id of the collaborator (standard identity envelope). */
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListCompanyEmployeesInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<TalentCompanyEmployeeFilterInput>;
  pagination?: InputMaybe<TalentBasePaginationInput>;
  search?: InputMaybe<TalentCompanyEmployeeSearchInput>;
  sort?: InputMaybe<Array<TalentCompanyEmployeeSortOrderInput>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListCompanyEmployeesResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCompanyEmployeeConnection | ValidationErrorV2;

export type TalentListCompanyGoalsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Goal period ID to filter company goals. When omitted, the company goals of every period are returned */
  goal_period_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListCompanyGoalsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentListCompanyGoalsPayload | ValidationErrorV2;

export type TalentListCompanyLevelsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCompanyLevelListPayload | ValidationErrorV2;

export type TalentListCompanyRecognitionFeedCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The feed selector, and the ONLY domain member of this input. Omitted, {} and { feed_eq: null } all mean TODOS. */
  filter?: InputMaybe<TalentCompanyRecognitionFeedFilterInput>;
  /** Standard 1-based offset pagination, the shared TalentBasePaginationInput (page: 1, page_size: 8 by default). 1-BASED: page 1 is the first page and the server resolves it as OFFSET (page - 1) * page_size LIMIT page_size, IN THE DATABASE — the legacy REST read every row of the year and paginated the list in memory, which this deliberately does not replicate. Sending page 0 is an error, not 'the first page'; page_size is bounded to 1..50 and a value outside it is refused rather than clamped, so the client can trust the size it divides total_count by. A page PAST THE END is not an error: it answers edges [] with the real total_count and has_next_page false. */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator making the request. REQUIRED at resolve time: an absent, non-positive or non-canonical value answers NotAuthenticatedErrorV2 NOT_AUTHENTICATED. It also decides WHICH ROWS are listed: on filter.feed_eq EMPLOYEE it IS the filter, and with no filter it selects the private rows the caller took part in. */
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListCompanyRecognitionFeedCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentCompanyRecognitionFeedCollaboratorConnection | ValidationErrorV2;

export type TalentListCompetencesBehaviorResultsEdge = {
  __typename?: 'TalentListCompetencesBehaviorResultsEdge';
  page_info?: Maybe<PageInfo>;
  results?: Maybe<Array<Maybe<TalentCompetencesBehaviorsResult>>>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type TalentListCompetencesBehaviorResultsInput = {
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<TalentCompetenceBehaviorFilter>;
  language?: InputMaybe<LanguageEnum>;
  pagination: CursorPagination;
  process_id: Scalars['Int']['input'];
};

export type TalentListCompetencesBehaviorResultsResponse = ResponseInternalError | ResponseValidationError | TalentListCompetencesBehaviorResultsEdge;

export type TalentListCompetencesConfigurationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  language_code: LanguageEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListCompetencesConfigurationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentListCompetencesConfigurationPayload | ValidationErrorV2;

export type TalentListCompetencesDivisionResultPayload = {
  __typename?: 'TalentListCompetencesDivisionResultPayload';
  results?: Maybe<Array<Maybe<TalentCompetencesDivisionResult>>>;
};

export type TalentListCompetencesDivisionResultResponse = ResponseInternalError | ResponseValidationError | TalentListCompetencesDivisionResultPayload;

export type TalentListCompetencesEmployeeResultPayload = {
  __typename?: 'TalentListCompetencesEmployeeResultPayload';
  results?: Maybe<Array<Maybe<TalentCompetencesEmployeeResult>>>;
};

export type TalentListCompetencesEmployeeResultResponse = ResponseInternalError | ResponseValidationError | TalentListCompetencesEmployeeResultPayload;

export type TalentListCompetencesEmployeeResultsByCompetenceEdge = {
  __typename?: 'TalentListCompetencesEmployeeResultsByCompetenceEdge';
  page_info?: Maybe<PageInfo>;
  results?: Maybe<Array<Maybe<TalentCompetencesEmployeeResultByCompetence>>>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type TalentListCompetencesEmployeeResultsByCompetenceInput = {
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  competence_id: Scalars['Int']['input'];
  filter?: InputMaybe<TalentCompetenceEmployeeFilter>;
  language?: InputMaybe<LanguageEnum>;
  pagination: CursorPagination;
  process_id: Scalars['Int']['input'];
};

export type TalentListCompetencesEmployeeResultsByCompetenceResponse = ResponseInternalError | ResponseValidationError | TalentListCompetencesEmployeeResultsByCompetenceEdge;

export type TalentListCompetencesEmployeeResultsInput = {
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<TalentCompetenceEmployeeFilter>;
  pagination: OffsetPaginationInput;
  process_id: Scalars['Int']['input'];
  search?: InputMaybe<ReportsSearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type TalentListCompetencesEmployeeResultsPage = {
  __typename?: 'TalentListCompetencesEmployeeResultsPage';
  result?: Maybe<Array<Maybe<TalentCompetencesEmployeeResult>>>;
  total_count?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type TalentListCompetencesEmployeeResultsResponse = ResponseInternalError | ResponseValidationError | TalentListCompetencesEmployeeResultsPage;

export type TalentListCompetencesEvaluationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListCompetencesEvaluationsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentListCompetencesEvaluationsPayload | ValidationErrorV2;

export type TalentListCompetencesFilterCoverageResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentListCompetencesFilterCoveragePayload | ValidationErrorV2;

export type TalentListCompetencesFilterInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the competence model to list filters from. */
  competence_model_id: Scalars['ID']['input'];
  /** Pagination options (page, page_size). */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListCompetencesFilterResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCompetencesFilterConnection | ValidationErrorV2;

export type TalentListCompetencesGeneralStatisticsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<TalentBasePaginationInput>;
  search?: InputMaybe<CompetencesGeneralStatisticsInput>;
  sort?: InputMaybe<Array<TalentEvaluationSortOrderInput>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListCompetencesGroupedResultResponse = ResponseInternalError | ResponseValidationError | TalentCompetencesGroupedResultPayload;

export type TalentListCompetencesInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competence model in edition or creation. */
  competence_model_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListCompetencesModelInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<TalentBasePaginationInput>;
  search?: InputMaybe<TalentCompetencesModelSearchInput>;
  sort?: InputMaybe<Array<TalentCompetencesModelSortOrderInput>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListCompetencesModelStatisticsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCompetencesModelStatisticConnection | ValidationErrorV2;

export type TalentListCompetencesPage = {
  __typename?: 'TalentListCompetencesPage';
  result?: Maybe<Array<Maybe<TalentCompetence>>>;
  total_count?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type TalentListCompetencesResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentListCompetencesPayload | ResponseInternalError | ResponseValidationError | TalentListCompetencesPage | ValidationErrorV2;

export type TalentListCompetencesResultPayload = {
  __typename?: 'TalentListCompetencesResultPayload';
  results?: Maybe<Array<Maybe<TalentCompetencesDetailedResult>>>;
};

export type TalentListCompetencesResultResponse = ResponseInternalError | ResponseValidationError | TalentListCompetencesResultPayload;

export type TalentListCompetencesStatisticsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCompetencesStatisticsConnection | ValidationErrorV2;

export type TalentListDashboardEmployeeResultsPayload = {
  __typename?: 'TalentListDashboardEmployeeResultsPayload';
  results?: Maybe<Array<Maybe<TalentEmployeeDashboardResult>>>;
  total_count: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type TalentListDashboardEmployeeResultsResponse = ResponseInternalError | ResponseValidationError | TalentListDashboardEmployeeResultsPayload;

export type TalentListDashboardEvaluationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<TalentBasePaginationInput>;
  search?: InputMaybe<TalentEvaluationSearchInput>;
  sort?: InputMaybe<Array<TalentEvaluationDashboardSortOrderInput>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListDashboardEvaluationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDashboardEvaluationConnection | ValidationErrorV2;

export type TalentListDipParticipantsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** PID process id. When null (creation) every employee comes back with is_participant=false. When set (edition) each employee is cross-checked against the process participants so already-assigned ones can be pre-selected. The company scope (centralized_organization_id / talent_company_id) also gates the process lookup (U2). */
  dip_id?: InputMaybe<Scalars['ID']['input']>;
  /** Filter parameters (cargo / departamento / rol derivado). */
  filter?: InputMaybe<TalentDipParticipantsFilterInput>;
  /** Pagination parameters (page, page_size). */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  /** Search parameters for the participant listing. */
  search?: InputMaybe<TalentDipParticipantsSearchInput>;
  /** Sort order entries applied in sequence. */
  sort?: InputMaybe<Array<TalentDipParticipantsSortOrderInput>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListDipParticipantsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDipPartakerConnection | ValidationErrorV2;

export type TalentListDipProcessInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Filter parameters for the PID process listing. */
  filter?: InputMaybe<TalentDipProcessFilterInput>;
  /** Pagination parameters (page, page_size). */
  pagination?: InputMaybe<TalentDipPaginationInput>;
  /** Search parameters for the listing. */
  search?: InputMaybe<DipProcessSearchInput>;
  /** Sort order entries applied in sequence. */
  sort?: InputMaybe<Array<TalentDipSortOrderInput>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListDipProcessResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDipProcessConnection | ValidationErrorV2;

export type TalentListEmployeeEvaluationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentEmployeeEvaluationConnection | ValidationErrorV2;

export type TalentListEvaluatedCompetencesBehaviorsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Language for the localized competence, competence level and behavior text (ES, EN, PT). Defaults to ES. */
  language_code?: LanguageEnum;
  /** ID of the competence model to filter competences and behaviors. */
  model_id: Scalars['ID']['input'];
  /** Pagination parameters (page, page_size) over competences. */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  /** ID of the questionnaire to list competences and behaviors for. */
  questionnaire_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListEvaluatedCompetencesBehaviorsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCompetenceEvaluatedConnection | ValidationErrorV2;

export type TalentListEvaluationEvaluatorsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the evaluation to list evaluators for. */
  evaluation_id: Scalars['ID']['input'];
  /** Pagination parameters (page, page_size). */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  /** Search query to filter evaluators by name, email, department, or category. */
  search?: InputMaybe<TalentEvaluatorsSearchInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListEvaluationEvaluatorsPaginatedResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentEvaluatorEvaluationPaginatedConnection | ValidationErrorV2;

export type TalentListEvaluatorsEvaluationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the evaluated employee to exclude from results */
  evaluated_id: Scalars['Int']['input'];
  /** The ID of the evaluation */
  evaluation_id: Scalars['Int']['input'];
  /** Filter by division IDs. Defaults to evaluated employee's division. */
  filter_divisions_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination?: InputMaybe<TalentBasePaginationInput>;
  search?: InputMaybe<TalentEvaluationEvaluatorsSearchInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListEvaluatorsEvaluationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentEmployeeEvaluationConnection | ValidationErrorV2;

export type TalentListEvaluatorsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentEvaluatorListPayload | ValidationErrorV2;

export type TalentListGoalPeriodInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<TalentBasePaginationInput>;
  /** Optional search filter for goal periods */
  search?: InputMaybe<GoalProcessSearchInput>;
  /** Optional sort order for goal periods */
  sort?: InputMaybe<Array<TalentGoalPeriodSortOrderInput>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListGoalPeriodResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentGoalPeriodConnection | ValidationErrorV2;

export type TalentListGoalProcessInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<GoalProcessSearchInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListGoalProcessResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentListGoalProcessPayload | ValidationErrorV2;

export type TalentListGoalTracksInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Goal period ID to filter goal tracks */
  goal_period_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListGoalTracksResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentListGoalTracksPayload | ValidationErrorV2;

/** Input to list company mail templates by module and language */
export type TalentListMailTemplatesInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<TalentCompanyMailTemplateFilterInput>;
  /** Language of the templates to return (ES, EN, PT) */
  language: LanguageEnum;
  /** Talent module whose mail templates are requested (e.g. PID) */
  module: TalentModuleEnum;
  pagination?: InputMaybe<TalentBasePaginationInput>;
  search?: InputMaybe<TalentCompanyMailTemplateSearchInput>;
  sort?: InputMaybe<Array<TalentCompanyMailTemplateSortOrderInput>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListMailTemplatesResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCompanyMailTemplateConnection | ValidationErrorV2;

export type TalentListNewLabelPayload = {
  __typename?: 'TalentListNewLabelPayload';
  /** list of new labels */
  labels?: Maybe<Array<TalentNewLabel>>;
};

export type TalentListNewLabelsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  labels: Array<Scalars['String']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListNewLabelsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentListNewLabelPayload | ValidationErrorV2;

export type TalentListNom035QuestionnairesCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID del colaborador autenticado. */
  employee_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filtra por estado calculado del cuestionario (selección múltiple). Valores: STATUS_NOM_ASSIGNED, STATUS_NOM_IN_PROGRESS, STATUS_NOM_FINISHED, STATUS_NOM_CLOSED. Por defecto no filtra. */
  filter_status?: InputMaybe<Array<Nom035QuestionnaireStatusEnum>>;
  /** Opciones de paginación. Por defecto page=1, page_size=8. */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  /** Filtro de búsqueda. fields: NAME (nombre evaluación), RELATION (tipo relación). */
  search?: InputMaybe<TalentNom035QuestionnairesSearchInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListNonParticipantsEvaluationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the evaluation whose non-participants will be listed. */
  evaluation_id: Scalars['ID']['input'];
  /** Optional filters by company level, division, job, or subsidiary. */
  filter?: InputMaybe<TalentCompanyEmployeeFilterInput>;
  /** Limit/offset pagination input. */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  /** Optional search term applied over employee fields. */
  search?: InputMaybe<TalentCompanyEmployeeSearchInput>;
  /** Optional sort directives applied to the result. */
  sort?: InputMaybe<Array<TalentCompanyEmployeeSortOrderInput>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListNonParticipantsEvaluationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentCompanyEmployeeConnection | ValidationErrorV2;

export type TalentListObjectivesByOkrProcessInput = {
  /** When true, list every ACTIVE objective that has an ACTIVE assignment — objectives aligned to a division included — instead of only the root ones. Used by the PID activity Detalle selector, which needs the aligned objectives too. Defaults to false so the listing keeps its original scope for every other consumer */
  assigned_only?: Scalars['Boolean']['input'];
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** OKR process ID whose root objectives will be listed. When omitted, the root objectives of every OKR process of the company are returned */
  okr_process_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListObjectivesByOkrProcessResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentListObjectivesByOkrProcessPayload | ValidationErrorV2;

export type TalentListOkrPeriodInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<OkrPeriodSearchInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListOkrPeriodResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentListOkrPeriodPayload | ValidationErrorV2;

export type TalentListParticipantsEvaluationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the evaluation to fetch questionnaires */
  evaluation_id: Scalars['Int']['input'];
  /** The ID of the category level. */
  filter_categories_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The ID of the divisions. */
  filter_divisions_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter participants by their evaluators' division IDs. */
  filter_evaluator_divisions_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filters participants and their evaluators to the given questionnaire states. Defaults to ASSIGNED, IN_PROGRESS and FINISHED. */
  filter_evaluator_states?: InputMaybe<Array<EvaluatorQuestionnaireStateFilterEnum>>;
  /** The ID of the evaluators */
  filter_evaluators_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filters participants by their questionnaire relation type (e.g. AUTO, BOSS, SUBORDINATE, COWORKER). */
  filter_relations?: InputMaybe<Array<EvaluationRelationEnum>>;
  pagination?: InputMaybe<TalentBasePaginationInput>;
  search?: InputMaybe<TalentEvaluationParticipantsSearchInput>;
  sort?: InputMaybe<Array<TalentEvaluationParticipantsSortOrderInput>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListProcessesFilterInput = {
  /** Filter processes where the given employee participates (employee is evaluated in competences, owns goals, etc.). */
  employee_id_eq?: InputMaybe<Scalars['Int']['input']>;
  /** Filter processes where the given employee is the leader/boss of the participants (BOSS relation in competences). */
  leader_id_eq?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentListProcessesInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<TalentListProcessesFilterInput>;
  modules: Array<TalentProcessModuleEnum>;
  process_states?: InputMaybe<Array<EntityState>>;
  /** Sort criteria applied in order to every module. When omitted each module keeps its default ordering. */
  sort?: InputMaybe<Array<TalentListProcessesSortOrderInput>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListProcessesSortOrderInput = {
  direction?: OrderDirectionEnum;
  /** Field to sort processes by: NAME (alphabetical) or CREATED_DATE (chronological). Applied to every requested module. */
  field: TalentProcessSortFieldEnum;
};

export type TalentListReceivedMedalsCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Standard 1-based offset pagination (page: 1, page_size: 8 by default). 1-based on purpose — the legacy EP-01 URL was 0-indexed and its client sent page - 1 with size = 5 hardcoded inside the component. */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator making the request. Required at resolve time: it scopes the operation to this collaborator and is recorded in the audit trail. */
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListReceivedMedalsCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentReceivedMedalsCollaboratorConnection | ValidationErrorV2;

export type TalentListRecognitionCommentsCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Standard 1-based offset pagination, the shared TalentBasePaginationInput (page: 1, page_size: 8 by default). 1-BASED, and that CHANGED MEANING on this operation: the legacy REST was 0-indexed, so page 0 used to be the FIRST page and now answers ValidationErrorV2 INVALID_PAGE. The server resolves a page as OFFSET (page - 1) * page_size LIMIT page_size, IN THE DATABASE — the legacy loaded every comment of the recognition and sliced the list in memory, which this deliberately does not replicate. page_size is bounded 1..50, the ONE ceiling of the epic (this thread used to allow up to 100), and a value outside it is refused rather than clamped, so the client can trust the size it divides total_count by. Omitting the block, sending {} or nulling either member all fall back to the shared defaults. `page` is validated before `page_size`. A page PAST THE END is not an error: it answers edges [] with the real total_count and has_next_page false. Because the thread is ordered oldest first, a comment written during the session lands at the END of the LAST page — so the optimistic update after add_recognition_comment_collaborator is an APPEND, never a prepend. */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  /** innpulsa.recognitionemployee.id — the recognition whose comment thread is requested. Filters recognition_comment.recognition_employee_id. Stays an Int! and stays OUTSIDE the identity envelope (G-05): it is the domain id of the thread being read, not the identity of the caller. IT IS NOT RANGE-CHECKED but it IS RESOLVED: the post is looked up under talent_company_id BEFORE the thread is read, so an id that is 0, negative, unknown, deleted, PENDING or REJECTED, older than a year, of another company, or PRIVATE and belonging to a recognition the caller took no part in, all answer the SAME NotFoundErrorV2 RECOGNITION_NOT_FOUND. An EMPTY page — total_count 0 with edges [] — means the post is readable and has no comments yet, which is a different answer and a different screen. */
  recognition_employee_id: Scalars['Int']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator making the request. REQUIRED at resolve time: an absent, non-positive or non-canonical value answers NotAuthenticatedErrorV2 NOT_AUTHENTICATED. It authorises the read and resolves NO field of the payload. */
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListRecognitionCommentsCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentRecognitionCommentsCollaboratorConnection | ValidationErrorV2;

export type TalentListRecognitionCompanyMedalsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentRecognitionCompanyMedalsConnection | ValidationErrorV2;

export type TalentListRecognitionCompanyModelStatisticsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentRecognitionCompanyModelStatisticConnection | ValidationErrorV2;

export type TalentListRecognitionDivisionModelStatisticsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentDivisionTopMedalsStatisticConnection | ValidationErrorV2;

export type TalentListRecognitionEmployeeModelStatisticsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentRecognitionEmployeeModelTopMedalsStatisticConnection | ValidationErrorV2;

export type TalentListRecognitionMailTemplatesInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  language: LanguageEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListRecognitionMailTemplatesResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentRecognitionMailTemplateListPayload | ValidationErrorV2;

export type TalentListRecognitionRankingReceiversCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** RN-02, THE ORDER CRITERION, SUPPLIED BY THE CLIENT. true orders the rows by POINTS and the header reads 'Top puntos'; false (and null) orders them by MEDALS, 'Top medallas'. IT IS THE SAME VALUE THE CLIENT ALREADY HOLDS: get_recognition_configuration_collaborator publishes is_public_ranking_points_enabled off recognition_configuration_plan.public_ranking_points, and passing it here is what lets this operation answer WITHOUT READING THAT TABLE AGAIN — one query per request instead of two. SEND WHAT THE CONFIGURATION QUERY GAVE YOU AND NOTHING ELSE: the value is the COMPANY's decision, so inventing it per user, remembering a stale one or flipping it as a UI toggle makes the server order a page by a criterion the company never chose, and nothing on the server can detect that any more. NULL IS NOT 'unknown, ask the server' — it is the MEDALS branch, the same reading a null column has, which is also what an omitted member gets. THE SERVER STILL ORDERS: this picks the ordering it applies, it does not ask the client to sort, and metadata.data.order_criterion echoes back the criterion the rows were ACTUALLY ordered by, so a client can assert the two agree. */
  is_public_ranking_points_enabled: Scalars['Boolean']['input'];
  /** Standard 1-based offset pagination, the shared TalentBasePaginationInput (page: 1, page_size: 8 by default). The server resolves it as OFFSET (page - 1) * page_size LIMIT page_size over the ORDERED ranking, in the database. 1-BASED, which CHANGES MEANING against the legacy REST: that one was 0-indexed, so page 0 used to be the first page and now answers ValidationErrorV2 / INVALID_PAGE, as does any negative. page_size is bounded 1..50 — the one ceiling of the epic — and a value outside it is REFUSED rather than clamped, because a client that divides total_count by a size the server silently changed computes a page count that does not exist. Omitting the block, sending {} or nulling either member all fall back to the shared defaults, and page is validated before page_size. THIS BLOCK IS NOT THE SOURCE OF THE POSITION: that travels per row in node.context.ranking_position, and page / page_size are pure windowing. What they still owe is the invariant node.context.ranking_position == (page - 1) * page_size + <index in edges> + 1 on every page. A page PAST THE END is not an error: it answers edges [] with the real total_count and has_next_page false. */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListRecognitionRankingReceiversCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentRecognitionRankingReceiversCollaboratorConnection | ValidationErrorV2;

export type TalentListRecognitionRedemptionsCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Standard 1-based offset pagination (page: 1, page_size: 8 by default). */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Collaborator scope — the redemptions listed are the ones this employee made. recognition_redemption.employee_id. NON-NULL: the schema rejects a request without it. */
  talent_employee_id: Scalars['ID']['input'];
};

export type TalentListRecognitionRedemptionsCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentRecognitionRedemptionsCollaboratorConnection | ValidationErrorV2;

export type TalentListRecognitionRewardsAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<TalentBasePaginationInput>;
  search?: InputMaybe<TalentRecognitionRewardsAdminSearchInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListRecognitionRewardsAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentRewardAdminConnection | ValidationErrorV2;

export type TalentListRecognitionRewardsCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Standard 1-based offset pagination (page: 1, page_size: 8 by default). The catalog is company-scoped, so pagination is the only knob the caller drives. */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListRecognitionRewardsCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentRecognitionRewardsCollaboratorConnection | ValidationErrorV2;

export type TalentListRecognitionRewardsRedemptionsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<TalentBasePaginationInput>;
  search?: InputMaybe<TalentRecognitionRewardsRedemptionsSearchInput>;
  status?: InputMaybe<TalentRecognitionRewardsRedemptionsStatusFilterEnum>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListRecognitionRewardsRedemptionsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentRedemptionConnection | ValidationErrorV2;

export type TalentListRecognitionSubsidiaryModelStatisticsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentSubsidiaryTopMedalsStatisticConnection | ValidationErrorV2;

export type TalentListRecognitionTopSentMedalsCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListRecognitionTopSentMedalsCollaboratorPayload = {
  __typename?: 'TalentListRecognitionTopSentMedalsCollaboratorPayload';
  /** The podium rows, ALREADY ORDERED — the client must NEVER re-sort them, because the order IS the ranking and positions are derived from the array index. ORDER: statistics.total_sent DESC, tie-broken by the medal id ASC so a re-read of unchanged data can never swap two rows. INVARIANT — THE LENGTH IS 1..3, NEVER 0 AND NEVER null: 3 IS A MAXIMUM, NOT A SIZE. A company that handed out only one or two distinct medals inside the window receives one or two rows, and the server NEVER pads the list with zero-count medals from the catalog. If the list would be empty the response is the NotFoundErrorV2 member with code TOP_MEDALS_NOT_AVAILABLE instead of this payload (dev decision 2, overriding AC-03 of the story) — AND THAT NotFound IS THE EMPTY STATE: map it to the empty state of the tab, never to the error state. WHAT IS EXCLUDED FROM THE COUNTING, all of it server-side and in ONE place so this tab and the ranking tab always summarise the SAME deliveries: everything dated before the current quarter and everything with senddate NULL, PENDING and REJECTED sends, soft-deleted delivery rows, every delivery of an INACTIVE medal (U4 / AC-05) and every delivery whose RECEIVER is not an active employee — which is why total_sent means 'deliveries to active employees'. A medal left with zero countable deliveries is ABSENT from the list, not present with total_sent 0. STILL UNDECIDED and able to change this podium outright: whether admin-issued deliveries count (sended_from_admin, [PENDIENTE DE CONFIRMACION CON TALENT]). */
  medals: Array<TalentRecognitionTopSentMedal>;
};

export type TalentListRecognitionTopSentMedalsCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentListRecognitionTopSentMedalsCollaboratorPayload | ValidationErrorV2;

export type TalentListReportTemplatesInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<ReportTemplateSearchInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListReportTemplatesResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentListReportTemplatesPayload | ValidationErrorV2;

export type TalentListSentMedalsCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional state narrowing of the outbox (the state chips, RN-018). Omit it — the default — to list every state (RN-003). */
  filter?: InputMaybe<TalentSentMedalsCollaboratorFilterInput>;
  /** Standard 1-based offset pagination (page: 1, page_size: 8 by default). 1-based on purpose — the legacy EP-02 endpoint was 0-indexed and the Angular client sent page - 1 (quirk Q-03). Counted in SENDS, not in recognitionemployee rows: a batch to five people is one item of the page, not five (RN-010). */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator making the request. Required at resolve time: it scopes the operation to this collaborator and is recorded in the audit trail. */
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentListSentMedalsCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentSentMedalsCollaboratorConnection | ValidationErrorV2;

export type TalentMailQuery = {
  __typename?: 'TalentMailQuery';
  dip_email_template_content?: Maybe<DipEmailTemplateResponse>;
  dip_email_timer?: Maybe<DipEmailTemplateResponse>;
  send_competences_email_by_template: CompetencesEmailTemplateResponse;
  send_goals_email_by_template: GoalsEmailTemplateResponse;
};


export type TalentMailQueryDip_Email_Template_ContentArgs = {
  input: DipEmailTemplateInput;
};


export type TalentMailQueryDip_Email_TimerArgs = {
  input: DipEmailTemplateInput;
};


export type TalentMailQuerySend_Competences_Email_By_TemplateArgs = {
  input: CompetencesEmailTemplateInput;
};


export type TalentMailQuerySend_Goals_Email_By_TemplateArgs = {
  input: GoalsEmailTemplateInput;
};

/** One language translation (subject + content) of a company mail template */
export type TalentMailTemplateTranslationInput = {
  /** Email body (rich text) */
  content: Scalars['String']['input'];
  /** Language of this translation (ES, EN, PT) */
  language_code: LanguageEnum;
  /** Email subject (plain text, maximum 256 characters) */
  subject: Scalars['String']['input'];
};

export type TalentManagementAdministrator = {
  __typename?: 'TalentManagementAdministrator';
  talent_management_company_administrator: TalentManagementCompanyAdministrator;
};

export type TalentManagementAdministratorMutations = {
  __typename?: 'TalentManagementAdministratorMutations';
  talent_management_company_administrator: TalentManagementCompanyAdministratorMutations;
};

export type TalentManagementCompanyAdministrator = {
  __typename?: 'TalentManagementCompanyAdministrator';
  /** Query to get company mail template by code and language */
  get_company_mail_template: TalentGetCompanyMailTemplateResponse;
  /** Query to list company employee */
  list_company_employee_admin: TalentListCompanyEmployeesResponse;
  /** List company levels by company (no pagination) */
  list_company_levels_admin: TalentListCompanyLevelsResponse;
  /** Query to list company mail templates by module and language */
  list_mail_templates_paginated_admin: TalentListMailTemplatesResponse;
  /** Query to send company email */
  send_company_email: TalentSendCompanyEmailResponse;
};


export type TalentManagementCompanyAdministratorGet_Company_Mail_TemplateArgs = {
  input: TalentGetCompanyMailTemplateInput;
};


export type TalentManagementCompanyAdministratorList_Company_Employee_AdminArgs = {
  input: TalentListCompanyEmployeesInput;
};


export type TalentManagementCompanyAdministratorList_Company_Levels_AdminArgs = {
  input: TalentCompanyLevelInput;
};


export type TalentManagementCompanyAdministratorList_Mail_Templates_Paginated_AdminArgs = {
  input: TalentListMailTemplatesInput;
};


export type TalentManagementCompanyAdministratorSend_Company_EmailArgs = {
  input: TalentSendCompanyEmailInput;
};

export type TalentManagementCompanyAdministratorMutations = {
  __typename?: 'TalentManagementCompanyAdministratorMutations';
  /** Mutation to create or update a company mail template */
  save_company_mail_template_admin: TalentSaveCompanyMailTemplateResponse;
};


export type TalentManagementCompanyAdministratorMutationsSave_Company_Mail_Template_AdminArgs = {
  input: TalentSaveCompanyMailTemplateInput;
};

export type TalentManagementLabelsMutations = {
  __typename?: 'TalentManagementLabelsMutations';
  /** Mutation to create or update new_app labels for a company */
  update_labels_new_app: TalentUpdateLabelsNewAppResponse;
};


export type TalentManagementLabelsMutationsUpdate_Labels_New_AppArgs = {
  input: TalentUpdateLabelsNewAppInput;
};

export type TalentManagementMutations = {
  __typename?: 'TalentManagementMutations';
  talent_management_administrator: TalentManagementAdministratorMutations;
  talent_management_labels: TalentManagementLabelsMutations;
  /** Mutation to update the language of a person by company_id and email */
  update_person_language_admin: TalentUpdatePersonLanguageResponse;
};


export type TalentManagementMutationsUpdate_Person_Language_AdminArgs = {
  input: TalentUpdatePersonLanguageInput;
};

export type TalentManagementQueries = {
  __typename?: 'TalentManagementQueries';
  talent_management_administrator: TalentManagementAdministrator;
};

/** Pagination metadata plus the extra counters of a talent listing. */
export type TalentMetadata = {
  __typename?: 'TalentMetadata';
  /** Extra counters of this specific listing, as a flat object — null when the listing has none. Its keys are documented by the operation that returns it, never assumed to be present. */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Max results per page */
  page_size: Scalars['Int']['output'];
  /** Total quantity of existing nodes */
  total_count: Scalars['Int']['output'];
};

export enum TalentModuleEnum {
  Climate = 'CLIMATE',
  Competences = 'COMPETENCES',
  Feedback = 'FEEDBACK',
  Goals = 'GOALS',
  Nom035 = 'NOM035',
  Okrs = 'OKRS',
  Pid = 'PID',
  Recognition = 'RECOGNITION'
}

export type TalentModuleInfo = {
  __typename?: 'TalentModuleInfo';
  code: Scalars['String']['output'];
  company_custom_domain: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  icon_hover?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  submodules: Array<TalentModuleInfo>;
  url?: Maybe<Scalars['String']['output']>;
};


export type TalentModuleInfoLabelArgs = {
  language?: TalentLanguage;
};


export type TalentModuleInfoUrlArgs = {
  sso?: Scalars['Boolean']['input'];
};

export type TalentMutation = {
  __typename?: 'TalentMutation';
  approve_pid_activities: ApprovePidActivitiesResponse;
  develop_individual_plan: TalentDipMutation;
  talent_climate: TalentClimateMutation;
  talent_climate_nom035: TalentClimateNom035Mutations;
  talent_dashboard: TalentDashboardMutation;
  talent_management: TalentManagementMutations;
  talent_performance: TalentPerformanceMutations;
  talent_recognition: TalentRecognitionMutations;
  talent_reports: TalentReportsSpoonRequestMutation;
  update_pid_activities_state: UpdatePidActivitiesStateResponse;
};


export type TalentMutationApprove_Pid_ActivitiesArgs = {
  input: ApprovePidActivitiesInput;
};


export type TalentMutationUpdate_Pid_Activities_StateArgs = {
  input: UpdatePidActivitiesStateInput;
};

export type TalentMyNom035QuestionnairesResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentNom035QuestionnaireConnection | ValidationErrorV2;

/** definición de los rangos de un eje */
export type TalentNboxAxis = {
  __typename?: 'TalentNboxAxis';
  id: Scalars['Int']['output'];
  max_value: Scalars['Int']['output'];
  min_value?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/**  definición de los rangos de un eje  */
export type TalentNboxAxisConfig = {
  max_value: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

/**  definición de los módulos y procesos de un eje  */
export type TalentNboxAxisModuleList = {
  __typename?: 'TalentNboxAxisModuleList';
  module?: Maybe<TalentNboxMatrixModulesEnum>;
  process?: Maybe<Scalars['String']['output']>;
};

export type TalentNboxAxisResult = {
  __typename?: 'TalentNboxAxisResult';
  axis?: Maybe<TalentNboxMatrixAxisEnum>;
  axis_name?: Maybe<Scalars['String']['output']>;
  axis_result?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  processes?: Maybe<Array<Maybe<TalentNboxModuleProcessesResult>>>;
};

export enum TalentNboxCalibrationState {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  None = 'NONE'
}

/** Input para guardar filtro */
export type TalentNboxCreateFilterInput = {
  company_id: Scalars['Int']['input'];
  filters: Array<InputMaybe<TalentNboxFilterCategoryInput>>;
  leader_id?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type TalentNboxDuplicatedPayload = {
  __typename?: 'TalentNboxDuplicatedPayload';
  executed?: Maybe<Scalars['Boolean']['output']>;
  matrix_id?: Maybe<Scalars['Int']['output']>;
};

export type TalentNboxDuplicatedResponse = ResponseInternalError | ResponseValidationError | TalentNboxDuplicatedPayload;

export type TalentNboxEmployeeCalibrationPayload = {
  __typename?: 'TalentNboxEmployeeCalibrationPayload';
  axisXValue: Scalars['Float']['output'];
  axisYValue: Scalars['Float']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  matrixId: Scalars['Int']['output'];
  totalResult: Scalars['Float']['output'];
};

export type TalentNboxEmployeeResult = {
  __typename?: 'TalentNboxEmployeeResult';
  avatar_url?: Maybe<Scalars['String']['output']>;
  axies?: Maybe<Array<Maybe<TalentNboxAxisResult>>>;
  calibration?: Maybe<TalentNboxEmployeeCalibrationPayload>;
  division_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employee_result?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  job_level_name?: Maybe<Scalars['String']['output']>;
  job_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subsidiary_name?: Maybe<Scalars['String']['output']>;
};

export type TalentNboxEmployeeResultDetail = {
  __typename?: 'TalentNboxEmployeeResultDetail';
  axis?: Maybe<Array<Maybe<TalentNboxAxisResult>>>;
  employee?: Maybe<TalentEmployee>;
  employee_result?: Maybe<Scalars['Float']['output']>;
  matrix_id?: Maybe<Scalars['Int']['output']>;
  matrix_name?: Maybe<Scalars['String']['output']>;
  quadrant_color?: Maybe<Scalars['String']['output']>;
  quadrant_label?: Maybe<Scalars['String']['output']>;
};

export type TalentNboxEmployeeResultInput = {
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  centralized_user_id?: InputMaybe<Scalars['Int']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  employee_id?: InputMaybe<Scalars['Int']['input']>;
  matrix_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentNboxEmployeeResultList = {
  __typename?: 'TalentNboxEmployeeResultList';
  employees_result?: Maybe<Array<Maybe<TalentNboxEmployeeResult>>>;
};

export type TalentNboxEmployeeResultResponse = ResponseInternalError | ResponseValidationError | TalentNboxEmployeeResultDetail;

export type TalentNboxExecutedPayload = {
  __typename?: 'TalentNboxExecutedPayload';
  executed?: Maybe<Scalars['Boolean']['output']>;
};

export type TalentNboxExecutionResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TalentNboxExecutedPayload;

/**  configuración para un modulo variable externa  */
export type TalentNboxExternalData = {
  __typename?: 'TalentNboxExternalData';
  bucket_name: Scalars['String']['output'];
  content_type: Scalars['String']['output'];
  download_url: Scalars['String']['output'];
  file_id: Scalars['Int']['output'];
  file_name: Scalars['String']['output'];
  relative_url?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
};

/**  configuración para un modulo variable externa  */
export type TalentNboxExternalDataConfig = {
  bucket_name: Scalars['String']['input'];
  content_type: Scalars['String']['input'];
  download_url: Scalars['String']['input'];
  file_id: Scalars['Int']['input'];
  file_name: Scalars['String']['input'];
  relative_url?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
};

export type TalentNboxFileValidation = {
  __typename?: 'TalentNboxFileValidation';
  errors?: Maybe<Array<Maybe<TalentNboxFileValidationError>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TalentNboxFileValidationError = {
  __typename?: 'TalentNboxFileValidationError';
  error_type?: Maybe<TalentNboxValidationFileTypeError>;
  errors_detail?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TalentNboxFilter = {
  __typename?: 'TalentNboxFilter';
  categories?: Maybe<Array<Maybe<TalentNboxFilterCategory>>>;
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type TalentNboxFilterCategory = {
  __typename?: 'TalentNboxFilterCategory';
  category?: Maybe<TalentHcmFilterTypeEnum>;
  values?: Maybe<Array<Maybe<TalentNboxFilterData>>>;
};

export type TalentNboxFilterCategoryInput = {
  category?: InputMaybe<TalentHcmFilterTypeEnum>;
  values?: InputMaybe<Array<InputMaybe<TalentNboxFilterDataInput>>>;
};

export type TalentNboxFilterData = {
  __typename?: 'TalentNboxFilterData';
  filter_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TalentNboxFilterDataInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TalentNboxFilterListEdge = {
  __typename?: 'TalentNboxFilterListEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<TalentNboxFilter>;
};

export type TalentNboxFilterListPage = {
  __typename?: 'TalentNboxFilterListPage';
  edges?: Maybe<Array<Maybe<TalentNboxFilterListEdge>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type TalentNboxFilterResponse = ResponseInternalError | ResponseValidationError | TalentNboxFilter;

export type TalentNboxFiltersInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  company_id: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
  leader_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentNboxFiltersResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TalentNboxFilterListPage;

/**  input para listar las matrices que tienen configurado alguno de los procesos indicados  */
export type TalentNboxMatricesByProcessInput = {
  categories?: InputMaybe<Array<InputMaybe<TalentNboxMatrixCategoryEnum>>>;
  company_id: Scalars['Int']['input'];
  matrix_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  processes: Array<TalentNboxProcessRefInput>;
  states?: InputMaybe<Array<InputMaybe<TalentNboxMatrixStateEnum>>>;
};

/**  listado de matrices asociadas a los procesos indicados  */
export type TalentNboxMatricesByProcessList = {
  __typename?: 'TalentNboxMatricesByProcessList';
  matrices?: Maybe<Array<Maybe<TalentNboxMatrixByProcess>>>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type TalentNboxMatricesByProcessResponse = ResponseInternalError | ResponseValidationError | TalentNboxMatricesByProcessList;

/** definición de una matriz */
export type TalentNboxMatrix = {
  __typename?: 'TalentNboxMatrix';
  calibration_state?: Maybe<TalentNboxCalibrationState>;
  color_style?: Maybe<TalentNboxMatrixColorStyleEnum>;
  created_date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_update?: Maybe<Scalars['String']['output']>;
  quadrants?: Maybe<Array<Maybe<TalentNboxMatrixQuadrant>>>;
  size?: Maybe<TalentNboxMatrixSizeEnum>;
  state?: Maybe<TalentNboxMatrixStateEnum>;
  title?: Maybe<Scalars['String']['output']>;
  viewing_permissions?: Maybe<Array<Maybe<TalentNboxMatrixViewPermissions>>>;
  x_axis?: Maybe<TalentNboxMatrixAxis>;
  y_axis?: Maybe<TalentNboxMatrixAxis>;
};

/** definicion de un eje */
export type TalentNboxMatrixAxis = {
  __typename?: 'TalentNboxMatrixAxis';
  id?: Maybe<Scalars['String']['output']>;
  modules?: Maybe<Array<Maybe<TalentNboxModule>>>;
  ranges_configuration?: Maybe<Array<Maybe<TalentNboxAxis>>>;
  title?: Maybe<Scalars['String']['output']>;
};

/**  definición de la configuracion por eje  */
export type TalentNboxMatrixAxisConfigInput = {
  axis_quadrant: Array<InputMaybe<TalentNboxAxisConfig>>;
  axis_title: Scalars['String']['input'];
  axis_type: TalentNboxMatrixAxisEnum;
  company_id: Scalars['Int']['input'];
  matrix_id: Scalars['Int']['input'];
  modules: Array<InputMaybe<TalentNboxModuleConfig>>;
};

export type TalentNboxMatrixAxisConfigPayload = {
  __typename?: 'TalentNboxMatrixAxisConfigPayload';
  matrix_state?: Maybe<TalentNboxMatrixStateEnum>;
  successful: Scalars['Boolean']['output'];
};

export type TalentNboxMatrixAxisConfigResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TalentNboxMatrixAxisConfigPayload;

/**  ejes disponibles  */
export enum TalentNboxMatrixAxisEnum {
  X = 'X',
  Y = 'Y'
}

export enum TalentNboxMatrixBoxColorsEnum {
  Blue = 'BLUE',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED',
  Yellow = 'YELLOW'
}

/**  matriz asociada a un proceso (goals/competences/...) configurado en alguno de sus ejes  */
export type TalentNboxMatrixByProcess = {
  __typename?: 'TalentNboxMatrixByProcess';
  calibration_state?: Maybe<TalentNboxCalibrationState>;
  category: TalentNboxMatrixCategoryEnum;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  state: TalentNboxMatrixStateEnum;
  title: Scalars['String']['output'];
};

export type TalentNboxMatrixCalibrationInput = {
  axisXValue: Scalars['Float']['input'];
  axisYValue: Scalars['Float']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['Int']['input'];
  matrixId: Scalars['Int']['input'];
  totalResult: Scalars['Float']['input'];
};

export type TalentNboxMatrixCalibrationResponse = ResponseInternalError | ResponseValidationError | TalentNboxEmployeeCalibrationPayload;

export enum TalentNboxMatrixCategoryEnum {
  Custom = 'CUSTOM',
  Default = 'DEFAULT',
  Empty = 'EMPTY'
}

/**  estilos disponibles de color  */
export enum TalentNboxMatrixColorStyleEnum {
  Border = 'BORDER',
  Fill = 'FILL',
  None = 'NONE'
}

export type TalentNboxMatrixInput = {
  company_id: Scalars['Int']['input'];
  matrix_id: Scalars['Int']['input'];
};

/**  definición de una matriz  */
export type TalentNboxMatrixList = {
  __typename?: 'TalentNboxMatrixList';
  calibration_state?: Maybe<TalentNboxCalibrationState>;
  category: TalentNboxMatrixCategoryEnum;
  color_style: TalentNboxMatrixColorStyleEnum;
  created_date: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  size: TalentNboxMatrixSizeEnum;
  state: TalentNboxMatrixStateEnum;
  title: Scalars['String']['output'];
  x_axis_modules?: Maybe<Array<Maybe<TalentNboxAxisModuleList>>>;
  y_axis_modules?: Maybe<Array<Maybe<TalentNboxAxisModuleList>>>;
};

/** REPONSES */
export type TalentNboxMatrixListCustomConnection = {
  __typename?: 'TalentNboxMatrixListCustomConnection';
  edges?: Maybe<Array<Maybe<TalentNboxMatrixListEdge>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type TalentNboxMatrixListEdge = {
  __typename?: 'TalentNboxMatrixListEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<TalentNboxMatrixList>;
};

export type TalentNboxMatrixListInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<TalentNboxMatrixCategoryEnum>>>;
  company_id: Scalars['Int']['input'];
  employee_id?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
  job_level_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  leader_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<TalentNboxMatrixStateEnum>>>;
};

/** UNIONS */
export type TalentNboxMatrixListResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TalentNboxMatrixListCustomConnection;

/**  posibles modulos para variables  */
export enum TalentNboxMatrixModulesEnum {
  Competences = 'COMPETENCES',
  External = 'EXTERNAL',
  Goals = 'GOALS',
  Okrs = 'OKRS',
  Pid = 'PID'
}

/** definicion de configuracion para un cuadrante */
export type TalentNboxMatrixQuadrant = {
  __typename?: 'TalentNboxMatrixQuadrant';
  color?: Maybe<TalentNboxMatrixBoxColorsEnum>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  x_axis?: Maybe<TalentNboxAxis>;
  y_axis?: Maybe<TalentNboxAxis>;
};

export type TalentNboxMatrixReportInput = {
  company_id: Scalars['Int']['input'];
  employee_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  is_calibrated: Scalars['Boolean']['input'];
  language?: InputMaybe<LanguageEnum>;
  leader_id?: InputMaybe<Scalars['Int']['input']>;
  matrix_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentNboxMatrixReportResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TalentNboxMatrixReportResult;

export type TalentNboxMatrixReportResult = {
  __typename?: 'TalentNboxMatrixReportResult';
  result?: Maybe<Scalars['String']['output']>;
};

export type TalentNboxMatrixResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TalentNboxMatrix;

export type TalentNboxMatrixResultFilterInput = {
  cities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  division_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  employee_id?: InputMaybe<Scalars['Int']['input']>;
  genders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  job_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  leader_id?: InputMaybe<Scalars['Int']['input']>;
  matrix_id?: InputMaybe<Scalars['Int']['input']>;
  subsidiary_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type TalentNboxMatrixResultResponse = ResponseInternalError | ResponseValidationError | TalentNboxEmployeeResultList;

/**  posibles tamaños de la matriz  */
export enum TalentNboxMatrixSizeEnum {
  Size_3X3 = 'SIZE_3X3',
  Size_3X4 = 'SIZE_3X4',
  Size_4X3 = 'SIZE_4X3',
  Size_4X4 = 'SIZE_4X4'
}

/**  posibles estados de una matriz  */
export enum TalentNboxMatrixStateEnum {
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type TalentNboxMatrixViewPermissions = {
  __typename?: 'TalentNboxMatrixViewPermissions';
  category?: Maybe<TalentNboxMatrixVisualizationCategoryEnum>;
  type_id?: Maybe<Scalars['Int']['output']>;
  type_name?: Maybe<Scalars['String']['output']>;
};

/**
 *  Contiene la informacion de los permisos de visualizacion de la matriz
 * category: Contiene el nombre de la categoria a la cual se esta configurando los permisos de visualizacion ej: JOB_LEVEL, DIVISION
 * type_id: El identificador de la categoria ej: level_id, division_id
 * type_name: El nombre de la categoria ej: level_name, division_name
 */
export type TalentNboxMatrixViewPermissionsInput = {
  category: TalentNboxMatrixVisualizationCategoryEnum;
  type_id: Scalars['Int']['input'];
  type_name: Scalars['String']['input'];
};

export type TalentNboxMatrixVisualConfigInput = {
  color_style?: InputMaybe<TalentNboxMatrixColorStyleEnum>;
  company_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  matrix_id: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  viewing_permissions?: InputMaybe<Array<InputMaybe<TalentNboxMatrixViewPermissionsInput>>>;
};

/** Contiene los enum que seran parametrizados como permisos de visualizacion  */
export enum TalentNboxMatrixVisualizationCategoryEnum {
  JobLevel = 'JOB_LEVEL'
}

/** definición de los modulos de la matriz */
export type TalentNboxModule = {
  __typename?: 'TalentNboxModule';
  external_data_config?: Maybe<TalentNboxExternalData>;
  id: Scalars['Int']['output'];
  module?: Maybe<TalentNboxMatrixModulesEnum>;
  process_id: Scalars['Int']['output'];
  process_name: Scalars['String']['output'];
  state?: Maybe<TalentNboxModuleStateEnum>;
  weight: Scalars['Int']['output'];
};

/**  definición de los modulos de la matriz  */
export type TalentNboxModuleConfig = {
  external_data_config?: InputMaybe<TalentNboxExternalDataConfig>;
  module?: InputMaybe<TalentNboxMatrixModulesEnum>;
  process_id: Scalars['Int']['input'];
  process_name: Scalars['String']['input'];
  weight: Scalars['Int']['input'];
};

export type TalentNboxModuleProcessesResult = {
  __typename?: 'TalentNboxModuleProcessesResult';
  id?: Maybe<Scalars['Int']['output']>;
  module?: Maybe<TalentNboxMatrixModulesEnum>;
  process_name?: Maybe<Scalars['String']['output']>;
  process_result?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export enum TalentNboxModuleStateEnum {
  Active = 'ACTIVE',
  Finished = 'FINISHED'
}

export type TalentNboxProcess = {
  __typename?: 'TalentNboxProcess';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type TalentNboxProcessByModule = {
  __typename?: 'TalentNboxProcessByModule';
  module?: Maybe<TalentNboxMatrixModulesEnum>;
  processes?: Maybe<Array<Maybe<TalentNboxProcess>>>;
};

export type TalentNboxProcessByModuleList = {
  __typename?: 'TalentNboxProcessByModuleList';
  modules?: Maybe<Array<Maybe<TalentNboxProcessByModule>>>;
};

export type TalentNboxProcessByModuleResponse = ResponseInternalError | ResponseValidationError | TalentNboxProcessByModuleList;

/**  referencia a un proceso configurado en un eje: modulo + id del proceso  */
export type TalentNboxProcessRefInput = {
  module: TalentNboxMatrixModulesEnum;
  process_id: Scalars['Int']['input'];
};

export type TalentNboxQuadrantConfigInput = {
  color?: InputMaybe<TalentNboxMatrixBoxColorsEnum>;
  company_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TalentNboxUpdateFilterInput = {
  company_id: Scalars['Int']['input'];
  filter_id: Scalars['Int']['input'];
  filters: Array<InputMaybe<TalentNboxFilterCategoryInput>>;
  leader_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TalentNboxValidateFileInput = {
  company_id: Scalars['Int']['input'];
  download_file_url: Scalars['String']['input'];
  validation_type: TalentNboxValidationFileType;
};

export type TalentNboxValidateFileResponse = ResponseInternalError | ResponseValidationError | TalentNboxFileValidation;

export enum TalentNboxValidationFileType {
  EmailFormat = 'EMAIL_FORMAT',
  FileFormat = 'FILE_FORMAT',
  RecordsNumber = 'RECORDS_NUMBER',
  ResultsFormat = 'RESULTS_FORMAT'
}

/**
 * RECORDS_NUMBER: Número de registros enviados
 * EMAIL_FORMAT: Emails con problemas de formato
 * DUPLICATED_EMAIL: Emails duplicados
 * USERS_ACTIVE: Emails de usuarios inactivos
 * RESULT_EMPTY: Archivo con resultados vacios
 * RESULT_OUT_OF_RANGE: Resultados fuera del rango (0 - 100)
 * RESULT_BAD_FORMAT: Resultados no numericos
 * FILE_EMPTY: Archivo vacio
 * FILE_INVALID_HEADERS: Archivo con encabezados invalidos
 * FILE_INVALID_TYPE: Archivo con formato invalido (.xls - .xlsx)
 */
export enum TalentNboxValidationFileTypeError {
  DuplicatedEmail = 'DUPLICATED_EMAIL',
  EmailFormat = 'EMAIL_FORMAT',
  FileEmpty = 'FILE_EMPTY',
  FileInvalidHeaders = 'FILE_INVALID_HEADERS',
  FileInvalidType = 'FILE_INVALID_TYPE',
  RecordsNumber = 'RECORDS_NUMBER',
  ResultBadFormat = 'RESULT_BAD_FORMAT',
  ResultEmpty = 'RESULT_EMPTY',
  ResultOutOfRange = 'RESULT_OUT_OF_RANGE',
  UsersActive = 'USERS_ACTIVE'
}

export type TalentNewLabel = {
  __typename?: 'TalentNewLabel';
  code?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['Int']['output']>;
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  module?: Maybe<Scalars['String']['output']>;
  process?: Maybe<Scalars['Int']['output']>;
  pt?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

/** Input for add_participants_nom035_admin (popup 'Agregar participante'): crea/revive un questionnaire2 (AUTO) para los colaboradores dados. select_all=true agrega a todos los no-participantes; en ese caso employees_id se ignora. */
export type TalentNom035AddParticipantsAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Ids de colaborador (employee2.id) a agregar; ignorado si select_all. */
  employees_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Evaluación a la que se agregan participantes. */
  evaluation_id: Scalars['ID']['input'];
  /** Agregar a todos los no-participantes activos de la empresa. */
  select_all?: Scalars['Boolean']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Payload mínimo de add_participants_nom035_admin (CoreGraphOperation): solo graphql_operation_id. El FE relee vía list_participants_nom035_admin. */
export type TalentNom035AddParticipantsAdminPayload = {
  __typename?: 'TalentNom035AddParticipantsAdminPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type TalentNom035AddParticipantsAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035AddParticipantsAdminPayload | ValidationErrorV2;

/** Configuración avanzada NOM035 por evaluación (innpulsa.nom035_configuration); defaults de la migración cuando no hay fila. */
export type TalentNom035Configuration = {
  __typename?: 'TalentNom035Configuration';
  /** Permitir volver atrás (RN-012, legacy 66). */
  allow_back_button: Scalars['Boolean']['output'];
  /** RS/empresa dueña de la evaluación. */
  company_id?: Maybe<Scalars['ID']['output']>;
  /** Autor de la fila (auditoría, admin). */
  created_by?: Maybe<Scalars['ID']['output']>;
  /** Fecha de creación de la fila (auditoría, admin). */
  created_date?: Maybe<Scalars['String']['output']>;
  /** Evaluación a la que aplica la configuración. */
  evaluation_id?: Maybe<Scalars['ID']['output']>;
  /** Id de la fila de configuración; null si default. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Última actualización de la fila (auditoría, admin). */
  last_updated_date?: Maybe<Scalars['String']['output']>;
  /** Reporte individual disponible (legacy 135). */
  report_available: Scalars['Boolean']['output'];
  /** Si al programar se pidió enviar el correo de invitación (TL-2140). Persistido en innpulsa.nom035_configuration (NOT NULL, default false). */
  send_invitation: Scalars['Boolean']['output'];
  /** Mostrar barra de avance (RN-011, legacy 114). */
  show_progress_bar: Scalars['Boolean']['output'];
};

/** Mirror of the innpulsa.nom035_configuration entity (behaviour toggles + report_available persisted without a UI toggle). ALL fields optional (UNSET) — send only what changed. */
export type TalentNom035ConfigurationInput = {
  /** -> nom035_configuration.back_button (legacy 66). */
  back_button?: InputMaybe<Scalars['Boolean']['input']>;
  /** -> nom035_configuration.progress_bar (legacy 114). */
  progress_bar?: InputMaybe<Scalars['Boolean']['input']>;
  /** -> nom035_configuration.report_available (legacy 135; sin toggle UI). */
  report_available?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for create_draft_evaluation_nom035_admin: creates the 'En borrador' NOM035 evaluation from '+ Crear encuesta' (RN-11). Inherits TalentBaseInput (company isolation, U2). Option B: the draft is born WITH the Paso 1 data + a real name (it no longer nace vacía); the admin keeps configuring it in the following steps. Reuses the SAME entity mirrors as the update — only difference is there is no evaluation_id yet. */
export type TalentNom035CreateDraftEvaluationAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Entity mirror of nom035_configuration (back_button / progress_bar / report_available). Optional: if omitted, the RN-14 defaults stand. */
  configuration?: InputMaybe<TalentNom035ConfigurationInput>;
  /** Entity mirror of evaluation with the Paso 1 data. Required so the borrador is born with a real name (RN-2/RN-3, máx. 50) plus any Paso 1 field the admin already filled (welcome_image, questions_per_page, form_id, login_dashboard, hide_evaluation_employee). */
  evaluation: TalentNom035EvaluationInput;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentNom035CreateDraftEvaluationAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentNom035EvaluationConfig | ValidationErrorV2;

/** CALCULADO (BE) — cabecera del dashboard 'Estado del proceso'. Ningún campo es una columna almacenada tal cual: son contadores sobre innpulsa.questionnaire2 más cuatro columnas de evaluation.evaluation. Los contadores IGNORAN el filtro activo (describen la evaluación completa): el total del filtro vive en total_count. */
export type TalentNom035DashboardMetadata = {
  __typename?: 'TalentNom035DashboardMetadata';
  /** Numerador de la dona — COUNT(questionnaire2 WHERE evaluation_id=:id AND state = 'FINISHED'). */
  answered_count: Scalars['Int']['output'];
  /** evaluation.enddate — pinta 'Finaliza {dd-mm-aa}'. ⚠ FORMATO LEGACY 'YYYY-MM-DD HH:mm:ss.SSS' (UTC-0, SIN 'T' y SIN sufijo 'Z'): NO es ISO-8601 y NO es el formato de questionnaire.open_date/end_date. El FE necesita un parser dedicado. */
  evaluation_end_date?: Maybe<Scalars['String']['output']>;
  /** evaluation.startdate — el FE deshabilita 'Finalizar encuesta' mientras el proceso no arrancó. MISMO formato y MISMA zona que evaluation_end_date (texto UTC-0 sin sufijo 'Z'), para que el FE use un solo parser. Sale de la MISMA fila de la evaluación: sin join ni query extra. */
  evaluation_start_date?: Maybe<Scalars['String']['output']>;
  /** evaluation.state2 CRUDO (CREATED|STARTED|FINISHED|INCOMPLETE|DELETED). NO pasa por el deriver de 5 estados de E1/E2 (ese da prioridad a CLOSED y es otra cosa). RN-3 (auto-finalizado por completitud) quedó FUERA de v1 (decisión del dev D6), así que este campo no deriva FINISHED por completitud: lo hace el botón manual 'Finalizar encuesta'. Un state2 nulo o fuera del enum resuelve null. */
  evaluation_state?: Maybe<TalentNom035EvaluationState>;
  /** evaluation.date_time_zone — identificador IANA (ej. 'America/Mexico_City'). El FE formatea la fecha fin en la zona de la EVALUACIÓN, no en la del navegador, para que el mismo proceso no muestre días distintos según quién lo mire. Sale de la MISMA fila. */
  evaluation_time_zone?: Maybe<Scalars['String']['output']>;
  /** DERIVADO, no es una columna: evaluation.enddate < now() (RN-4). La fecha fin cierra la ventana de respuesta aunque state2 no sea FINISHED. ⚠ NO es 'cerrado a escritura': las tres acciones de escritura rechazan un proceso 'ventana vencida O estado FINISHED' (D4); este booleano es solo una de las dos cláusulas. */
  is_closed: Scalars['Boolean']['output'];
  /** La dona — round(answered_count / total_evaluated * 100); 0 cuando total_evaluated = 0 (AC-8, nunca división por cero ni 100%). */
  progress_percentage: Scalars['Int']['output'];
  /** 'Total de evaluados' — COUNT(questionnaire2 WHERE evaluation_id=:id AND state <> 'CANCELED'). INVARIANTE: cuenta exactamente el mismo conjunto del que se paginan los edges sin filtro, así que la dona y la tabla nunca pueden contradecirse. */
  total_evaluated: Scalars['Int']['output'];
};

/** Paginación server-side de la tabla de evaluados. page por defecto 1, page_size por defecto 10 (el prototipo muestra 'Items por página: 10'). page >= 1 y page_size entre 1 y 20; fuera de rango es ValidationErrorV2 / 4001_INVALID_PAGINATION. 20 es el tamaño de página más grande que el paginador compartido del subgraph puede SERVIR (HARD_LIMIT), así que pedir más es un error explícito y nunca una página recortada en silencio. */
export type TalentNom035DashboardPaginationInput = {
  /** Página solicitada, 1-based. Por defecto 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Filas por página, entre 1 y 20. Por defecto 10. El selector del prototipo ofrece 10 / 15 / 20. */
  page_size?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentNom035DeleteEvaluationAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Evaluación a eliminar (de la empresa del administrador). */
  evaluation_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Resultado de eliminar (soft delete) una evaluación NOM035 del listado admin. El graphql_operation_id identifica la operación; los errores llegan por los types *ErrorV2 de la union. */
export type TalentNom035DeleteEvaluationAdminPayload = {
  __typename?: 'TalentNom035DeleteEvaluationAdminPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type TalentNom035DeleteEvaluationAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035DeleteEvaluationAdminPayload | ValidationErrorV2;

/** Input de delete_questionnaire_nom035_admin: elimina UN cuestionario de la evaluación con SOFT DELETE (questionnaire2.state='CANCELED', RN-6 / U4) — disponible en CUALQUIER estado de la fila y idempotente (U3, no descuenta 'Total de evaluados' dos veces). Las respuestas NO se borran (eso solo lo hace reiniciar). Si el proceso está cerrado a escritura (ventana vencida O estado FINISHED) rechaza con 4001_EVALUATION_CLOSED. */
export type TalentNom035DeleteQuestionnaireAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Evaluación dueña de la fila -> evaluation.id (dtype='FormEvaluation' AND step=2) = questionnaire2.evaluation_id. Si el cuestionario existe pero pertenece a OTRA evaluación, la respuesta es IntegrityErrorV2 / 4002_QUESTIONNAIRE_EVALUATION_MISMATCH (par inconsistente, bug del FE). */
  evaluation_id: Scalars['ID']['input'];
  /** Cuestionario objetivo -> innpulsa.questionnaire2.id (el mismo id que devuelve list_questionnaires_nom035_admin). Vacío -> ValidationErrorV2 / 4001_REQUIRED_FIELD. */
  questionnaire_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Payload de delete_questionnaire_nom035_admin: trace id + los contadores recalculados, para que el FE quite la fila y repinte 'Total de evaluados' + la dona sin refetch (front-v1-acciones-cuestionario AC-5). NO devuelve la fila: quedó CANCELED y sale del listado. */
export type TalentNom035DeleteQuestionnaireAdminPayload = {
  __typename?: 'TalentNom035DeleteQuestionnaireAdminPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** CALCULADO — cabecera recalculada DESPUÉS del soft delete: total_evaluated baja en 1 (la fila CANCELED sale del universo) y la dona se recalcula sobre el nuevo denominador. En el repetido idempotente (la fila ya estaba CANCELED, U3) los contadores NO se mueven. */
  metadata: TalentNom035DashboardMetadata;
};

export type TalentNom035DeleteQuestionnaireAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | Nom035EvaluationClosedErrorV2 | Nom035InvalidCompanyErrorV2 | Nom035QuestionnaireEvaluationMismatchErrorV2 | Nom035QuestionnaireNotFinishedErrorV2 | Nom035QuestionnaireNotFoundErrorV2 | Nom035RequiredFieldErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035DeleteQuestionnaireAdminPayload | ValidationErrorV2;

export type TalentNom035Evaluation = {
  __typename?: 'TalentNom035Evaluation';
  available_time?: Maybe<Scalars['Int']['output']>;
  climate?: Maybe<Scalars['Boolean']['output']>;
  climate_model_id?: Maybe<Scalars['ID']['output']>;
  comp_limit?: Maybe<Scalars['Float']['output']>;
  comp_limit_1?: Maybe<Scalars['Float']['output']>;
  comp_limit_1_color?: Maybe<Scalars['String']['output']>;
  comp_limit_2?: Maybe<Scalars['Float']['output']>;
  comp_limit_2_color?: Maybe<Scalars['String']['output']>;
  comp_limit_3?: Maybe<Scalars['Float']['output']>;
  comp_limit_3_color?: Maybe<Scalars['String']['output']>;
  comp_limit_4?: Maybe<Scalars['Float']['output']>;
  comp_limit_4_color?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['ID']['output']>;
  configuration?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['ID']['output']>;
  created_date?: Maybe<Scalars['String']['output']>;
  date_time_zone?: Maybe<Scalars['String']['output']>;
  deleted_date?: Maybe<Scalars['String']['output']>;
  dtype: Scalars['String']['output'];
  e2646?: Maybe<Scalars['String']['output']>;
  end_date: Scalars['String']['output'];
  end_text?: Maybe<Scalars['String']['output']>;
  form_id?: Maybe<Scalars['ID']['output']>;
  group_id?: Maybe<Scalars['ID']['output']>;
  hide_evaluation_employee?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  last_inactivated_date?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['String']['output']>;
  login_dashboard?: Maybe<Scalars['Boolean']['output']>;
  max_limit?: Maybe<Scalars['Int']['output']>;
  max_limit_color?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  questions_per_page?: Maybe<Scalars['Int']['output']>;
  report_template?: Maybe<Scalars['ID']['output']>;
  report_template_extra_field?: Maybe<Scalars['ID']['output']>;
  start_date: Scalars['String']['output'];
  start_text?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_2?: Maybe<TalentNom035EvaluationState>;
  step: Scalars['Int']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
  welcome_image?: Maybe<Scalars['String']['output']>;
  welcome_text?: Maybe<Scalars['String']['output']>;
};

export type TalentNom035EvaluationAdminConnection = {
  __typename?: 'TalentNom035EvaluationAdminConnection';
  edges: Array<TalentNom035EvaluationAdminNodeEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Contexto calculado por el BE para la fila del listado (no en BD). */
export type TalentNom035EvaluationAdminContext = {
  __typename?: 'TalentNom035EvaluationAdminContext';
  /** Estado derivado por el BE en cada lectura (DRAFT / NOT_STARTED / IN_PROGRESS / FINISHED / CLOSED); el FE solo lo muestra. */
  state: TalentNom035EvaluationStateEnum;
};

/** Fila del listado admin: entidad evaluation completa + statistics calculadas + contexto calculado (estado derivado por el BE). */
export type TalentNom035EvaluationAdminNode = {
  __typename?: 'TalentNom035EvaluationAdminNode';
  context: TalentNom035EvaluationAdminContext;
  evaluation: TalentNom035Evaluation;
  id: Scalars['ID']['output'];
  statistics: TalentNom035EvaluationAdminStatistics;
};

/** An edge in a connection. */
export type TalentNom035EvaluationAdminNodeEdge = {
  __typename?: 'TalentNom035EvaluationAdminNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TalentNom035EvaluationAdminNode;
};

/** Métricas de avance calculadas por el BE (no existen en BD). */
export type TalentNom035EvaluationAdminStatistics = {
  __typename?: 'TalentNom035EvaluationAdminStatistics';
  /** Cuestionarios FINISHED (excluye CANCELED/DELETED/ERROR). */
  answered: Scalars['Int']['output'];
  /** round(answered / válidos * 100); 0 si no hay válidos. */
  progress_percentage: Scalars['Int']['output'];
};

/** Mirror of the evaluation.evaluation entity for the Paso 1 save. ALL fields are optional (default UNSET) — send only what changed; an omitted field is left untouched, an explicit null clears the column. The DORMIDO semáforo fields are accepted for entity fidelity but not persisted (semáforo removed from the NOM035 flow). */
export type TalentNom035EvaluationInput = {
  /** -> evaluation.climate (no usar como filtro NOM035). */
  climate?: InputMaybe<Scalars['Boolean']['input']>;
  /** -> evaluation.climate_model_id (clima nuevo, no NOM035). */
  climate_model_id?: InputMaybe<Scalars['ID']['input']>;
  /** DORMIDO — semáforo removido del flujo NOM035 (no se persiste). */
  comp_limit?: InputMaybe<Scalars['Float']['input']>;
  /** DORMIDO — semáforo removido del flujo NOM035 (no se persiste). */
  comp_limit_1?: InputMaybe<Scalars['Float']['input']>;
  /** DORMIDO — semáforo removido del flujo NOM035 (no se persiste). */
  comp_limit_1_color?: InputMaybe<Scalars['String']['input']>;
  /** DORMIDO — semáforo removido del flujo NOM035 (no se persiste). */
  comp_limit_2?: InputMaybe<Scalars['Float']['input']>;
  /** DORMIDO — semáforo removido del flujo NOM035 (no se persiste). */
  comp_limit_2_color?: InputMaybe<Scalars['String']['input']>;
  /** DORMIDO — semáforo removido del flujo NOM035 (no se persiste). */
  comp_limit_3?: InputMaybe<Scalars['Float']['input']>;
  /** DORMIDO — semáforo removido del flujo NOM035 (no se persiste). */
  comp_limit_3_color?: InputMaybe<Scalars['String']['input']>;
  /** DORMIDO — semáforo removido del flujo NOM035 (no se persiste). */
  comp_limit_4?: InputMaybe<Scalars['Float']['input']>;
  /** DORMIDO — semáforo removido del flujo NOM035 (no se persiste). */
  comp_limit_4_color?: InputMaybe<Scalars['String']['input']>;
  /** -> evaluation.configuration (blob de configuración del proceso). */
  configuration?: InputMaybe<Scalars['String']['input']>;
  /** -> evaluation.date_time_zone (IANA, ej. America/Mexico_City). */
  date_time_zone?: InputMaybe<Scalars['String']['input']>;
  /** -> evaluation.e2646 (clasificador NOM-035; 'DATOS' = PSOCIAL). */
  e2646?: InputMaybe<Scalars['String']['input']>;
  /** -> evaluation.enddate (ts límite; UTC0 sin 'Z'). */
  end_date?: InputMaybe<Scalars['String']['input']>;
  /** -> evaluation.end_text. */
  end_text?: InputMaybe<Scalars['String']['input']>;
  /** -> evaluation.form_id (guía/plantilla NOM-035 seleccionada). */
  form_id?: InputMaybe<Scalars['ID']['input']>;
  /** -> evaluation.group_id (innpulsa.group_questionnaire). */
  group_id?: InputMaybe<Scalars['ID']['input']>;
  /** -> nom035_configuration.hide_evaluation_employee (toggle 'Ocultar en escritorio'). TL-2141: migrado desde evaluation; se sigue enviando aquí por compat de contrato y el BE lo enruta a la config. */
  hide_evaluation_employee?: InputMaybe<Scalars['Boolean']['input']>;
  /** -> nom035_configuration.login_dashboard (toggle 'Inicio de sesión requerido'). TL-2141: migrado desde evaluation; se sigue enviando aquí por compat de contrato y el BE lo enruta a la config. */
  login_dashboard?: InputMaybe<Scalars['Boolean']['input']>;
  /** DORMIDO — semáforo removido del flujo NOM035 (no se persiste). */
  max_limit?: InputMaybe<Scalars['Int']['input']>;
  /** DORMIDO — semáforo removido del flujo NOM035 (no se persiste). */
  max_limit_color?: InputMaybe<Scalars['String']['input']>;
  /** -> evaluation.name (requerido de negocio: máx. 50, RN-2/RN-3). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** -> evaluation.questionsperpage (Int 1..100; RN-17; default vacío). */
  questions_per_page?: InputMaybe<Scalars['Int']['input']>;
  /** -> evaluation.report_template (innpulsa.report_template). */
  report_template?: InputMaybe<Scalars['ID']['input']>;
  /** -> evaluation.report_template_extra_field. */
  report_template_extra_field?: InputMaybe<Scalars['ID']['input']>;
  /** -> evaluation.startdate (ts inicio de la ventana; UTC0 sin 'Z'). */
  start_date?: InputMaybe<Scalars['String']['input']>;
  /** -> evaluation.start_text. */
  start_text?: InputMaybe<Scalars['String']['input']>;
  /** -> evaluation.state (estado legacy del registro). */
  state?: InputMaybe<Scalars['String']['input']>;
  /** -> evaluation.state2 (CREATED/STARTED/FINISHED/INCOMPLETE/DELETED). */
  state_2?: InputMaybe<TalentNom035EvaluationState>;
  /** -> evaluation.welcomeimage (URL ya subida por el servicio de upload cifrado; PNG/JPG, RN-4). */
  welcome_image?: InputMaybe<Scalars['String']['input']>;
  /** -> evaluation.welcome_text (texto de bienvenida, HTML). */
  welcome_text?: InputMaybe<Scalars['String']['input']>;
};

export enum TalentNom035EvaluationState {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Finished = 'FINISHED',
  Incomplete = 'INCOMPLETE',
  Started = 'STARTED'
}

export enum TalentNom035EvaluationStateEnum {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type TalentNom035EvaluationsAdminSearchInput = {
  /** Campos de búsqueda; el listado admin busca por 'name'. */
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  query: Scalars['String']['input'];
};

/** Input for exclude_participants_nom035_admin (ícono de papelera / opt-out): soft-delete (state=CANCELED) de los participantes dados. participants_id son ids de questionnaire2 (NO de colaborador). select_all=true excluye a todos los participantes activos; en ese caso participants_id se ignora. */
export type TalentNom035ExcludeParticipantsAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Evaluación de la que se excluyen participantes. */
  evaluation_id: Scalars['ID']['input'];
  /** Ids de questionnaire2 a excluir; ignorado si select_all. */
  participants_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Excluir a todos los participantes activos de la evaluación. */
  select_all?: Scalars['Boolean']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Payload mínimo de exclude_participants_nom035_admin (CoreGraphOperation): solo graphql_operation_id. El FE relee vía list_participants_nom035_admin. */
export type TalentNom035ExcludeParticipantsAdminPayload = {
  __typename?: 'TalentNom035ExcludeParticipantsAdminPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type TalentNom035ExcludeParticipantsAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035ExcludeParticipantsAdminPayload | ValidationErrorV2;

export type TalentNom035FormData = {
  __typename?: 'TalentNom035FormData';
  ddate?: Maybe<Scalars['String']['output']>;
  dnumber?: Maybe<Scalars['Float']['output']>;
  dtext?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  form_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  object_id: Scalars['ID']['output'];
  object_type: Scalars['String']['output'];
};

/** Input for generate_participants_nom035_admin: al pasar del Paso 1 al Paso 2, crea un questionnaire2 (relation=AUTO, state=ASSIGNED) por cada colaborador ACTIVO de la empresa. Idempotente. Hereda TalentBaseInput (aislamiento U2). */
export type TalentNom035GenerateParticipantsAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Evaluación cuyos participantes se materializan. */
  evaluation_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Payload mínimo de generate_participants_nom035_admin (CoreGraphOperation): solo graphql_operation_id. El FE relee los participantes con list_participants_nom035_admin. */
export type TalentNom035GenerateParticipantsAdminPayload = {
  __typename?: 'TalentNom035GenerateParticipantsAdminPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type TalentNom035GenerateParticipantsAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035GenerateParticipantsAdminPayload | ValidationErrorV2;

/** Input de generate_progress_report_nom035_admin: genera el EXCEL de progreso / participación de una evaluación NOM035 (ítem «Progreso de la evaluación» del combobox «Reportes»). Devuelve el link de descarga en la MISMA respuesta — es síncrono, no hay polling. Aislado a la empresa del admin (U2) e idempotente (U3: repetirlo re-renderiza el mismo archivo, no crea nada). ⚠ NO exige cuestionarios finalizados: una evaluación donde nadie contestó tiene progreso 0 %, que ES información. */
export type TalentNom035GenerateProgressReportAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Evaluación a reportar -> evaluation.evaluation.id (dtype='FormEvaluation' AND step=2). Vacío -> ValidationErrorV2 / 4001_REQUIRED_FIELD. Una evaluación de otra empresa -> NotFoundErrorV2 / 4004_EVALUATION_NOT_FOUND (nunca Forbidden: sin fuga de existencia). Una evaluación SIN evaluados -> ValidationErrorV2 / 4001_NO_EVALUATED_PARTICIPANTS (no hay filas que escribir). */
  evaluation_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentNom035GenerateProgressReportAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | Nom035EvaluationNotFoundErrorV2 | Nom035InvalidCompanyErrorV2 | Nom035NoEvaluatedParticipantsErrorV2 | Nom035RequiredFieldErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035ProgressReportAdminPayload | ValidationErrorV2;

/** Input for get_evaluation_config_nom035_admin: the evaluation whose Paso 1 configuration is precargada in Edit mode. Inherits TalentBaseInput (centralized_organization_id / talent_company_id) — the company drives the isolation (U2) and is never trusted as a free argument. */
export type TalentNom035GetEvaluationConfigAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** evaluation.evaluation id to precargar. A non-existent / soft-deleted / other-company id resolves to NotFoundErrorV2 (never leaks another evaluation). */
  evaluation_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentNom035GetEvaluationConfigAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentNom035EvaluationConfig | ValidationErrorV2;

/** Input for get_reference_guides_nom035_admin: returns the fixed NOM035 guide catalog + the company headcount + the suggested guide (RN-6/RN-7). Inherits TalentBaseInput (centralized_organization_id / talent_company_id) — the company drives the isolation (U2, headcount count) and is never trusted as a free argument. */
export type TalentNom035GetReferenceGuidesAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Opcional (edición de un proceso existente). No cambia la respuesta — el catálogo es fijo (RN-6) y el headcount es por empresa (RN-7); se acepta por fidelidad de contrato. */
  evaluation_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentNom035GetReferenceGuidesAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035ReferenceGuidesPayload | ValidationErrorV2;

export type TalentNom035ListEvaluationsAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Restricción opcional a evaluaciones puntuales. Permite traer un proceso conocido por id aunque quede fuera de la página ordenada por fecha de creación (el selector de procesos de E4 lo necesita para resolver el proceso del '?process=' cuando es antiguo). El aislamiento por empresa sigue aplicando encima. */
  evaluation_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Paginación server-side. Por defecto page=1, page_size=10. */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  /** Búsqueda por nombre de la evaluación (insensible a mayúsculas). Vacío o ausente devuelve todas las evaluaciones de la empresa. */
  search?: InputMaybe<TalentNom035EvaluationsAdminSearchInput>;
  /** Filtro opcional por estado derivado (uno de los 5 estados). */
  state?: InputMaybe<TalentNom035EvaluationStateEnum>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentNom035ListEvaluationsAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035EvaluationAdminConnection | ValidationErrorV2;

/** Metadata del listado (page_size). */
export type TalentNom035ListMetadata = {
  __typename?: 'TalentNom035ListMetadata';
  /** Tamaño de página solicitado (para calcular la cantidad de páginas). */
  page_size: Scalars['Int']['output'];
};

/** Input for list_non_participants_nom035_admin: lista los colaboradores de la empresa que AÚN NO participan (candidatos del popup 'Agregar participante'), con búsqueda, filtros y paginación. */
export type TalentNom035ListNonParticipantsAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Evaluación cuyo complemento de candidatos se calcula. */
  evaluation_id: Scalars['ID']['input'];
  /** Filtros por Categoría (company_level) y Departamento. */
  filters?: InputMaybe<TalentNom035ParticipantFiltersInput>;
  /** Paginación server-side. Por defecto page=1, page_size=10. */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  /** Búsqueda por nombre; vacío devuelve todos los candidatos. */
  search?: InputMaybe<TalentNom035ParticipantsSearchInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentNom035ListNonParticipantsAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035NonParticipantAdminConnection | ValidationErrorV2;

/** Input for list_participants_nom035_admin: lista los participantes ACTIVOS (questionnaire2 con state <> CANCELED) de la evaluación de la empresa del admin, con búsqueda por nombre, filtros por Categoría/Departamento y paginación server-side. */
export type TalentNom035ListParticipantsAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Evaluación (de la empresa del admin) cuyos participantes se listan. */
  evaluation_id: Scalars['ID']['input'];
  /** Filtros por Categoría (company_level) y Departamento. */
  filters?: InputMaybe<TalentNom035ParticipantFiltersInput>;
  /** Paginación server-side. Por defecto page=1, page_size=10. */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  /** Búsqueda por nombre; vacío devuelve todos los participantes. */
  search?: InputMaybe<TalentNom035ParticipantsSearchInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentNom035ListParticipantsAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035ParticipantAdminConnection | ValidationErrorV2;

/** Input for list_questionnaires_nom035_admin: lista los EVALUADOS activos (questionnaire2 con state <> CANCELED) de una evaluación NOM035 de la empresa del admin, con búsqueda por nombre completo, filtros por Categoría/Departamento/Estado/Evaluadores y paginación server-side, más los contadores de la cabecera del dashboard. */
export type TalentNom035ListQuestionnairesAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Evaluación (de la empresa del admin) cuyos evaluados se listan -> evaluation.id (dtype='FormEvaluation' AND step=2) = questionnaire2.evaluation_id. */
  evaluation_id: Scalars['ID']['input'];
  /** Filtros por Categoría / Departamento / Estado / Evaluadores. */
  filters?: InputMaybe<TalentNom035QuestionnaireFiltersInput>;
  /** Paginación server-side. Por defecto page=1, page_size=10 (el prototipo muestra 'Items por página: 10'). page >= 1 y page_size entre 1 y 20; fuera de rango es ValidationErrorV2 / 4001_INVALID_PAGINATION. ⚠ 20 es el techo REAL: es el HARD_LIMIT del paginador compartido, y pedir 50 devolvía 20 filas con el total_count verdadero, así que el FE dibujaba menos páginas de las que el BE servía y la cola del listado quedaba inalcanzable (dev decision D-P1). */
  pagination?: InputMaybe<TalentNom035DashboardPaginationInput>;
  /** 'Buscar usuarios': busca el NOMBRE COMPLETO del colaborador (person2.name + person2.last_name concatenados, insensible a mayúsculas y acentos). Un fragmento puede cruzar el espacio entre las dos columnas ('a Sofía R' encuentra 'Ana Sofía Reyes'), pero debe ser contiguo ('garcía maría' no encuentra 'María García'). 'fields' se acepta y se IGNORA: las columnas buscadas las fija el contrato, no el cliente. Vacío devuelve todos los evaluados. */
  search?: InputMaybe<TalentNom035ParticipantsSearchInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentNom035ListQuestionnairesAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035QuestionnaireAdminConnection | ValidationErrorV2;

export type TalentNom035NonParticipantAdminConnection = {
  __typename?: 'TalentNom035NonParticipantAdminConnection';
  edges: Array<TalentNom035NonParticipantAdminNodeEdge>;
  metadata: TalentNom035ListMetadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Candidato del popup 'Agregar participante' = un colaborador SIN cuestionario activo. questionnaire es null si nunca participó, o la fila CANCELED si fue excluido (opt-out, se puede volver a agregar). */
export type TalentNom035NonParticipantAdminNode = {
  __typename?: 'TalentNom035NonParticipantAdminNode';
  /** Catálogo del colaborador candidato a agregar. */
  employee: PrivateTalentEmployee;
  /** Fila CANCELED si fue excluido; null si nunca participó. */
  questionnaire?: Maybe<TalentNom035QuestionnaireAdmin>;
};

/** An edge in a connection. */
export type TalentNom035NonParticipantAdminNodeEdge = {
  __typename?: 'TalentNom035NonParticipantAdminNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TalentNom035NonParticipantAdminNode;
};

export type TalentNom035ParticipantAdminConnection = {
  __typename?: 'TalentNom035ParticipantAdminConnection';
  edges: Array<TalentNom035ParticipantAdminNodeEdge>;
  metadata: TalentNom035ParticipantsAdminMetadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Un participante = un colaborador (employee2) + su cuestionario ACTIVO (questionnaire2 con state <> CANCELED). Categoría=company_level.name, Departamento=division.name, Cargo=job.name (del employee). */
export type TalentNom035ParticipantAdminNode = {
  __typename?: 'TalentNom035ParticipantAdminNode';
  /** Catálogo del colaborador (person/job/division/company_level). */
  employee: PrivateTalentEmployee;
  /** Cuestionario activo del participante (state <> CANCELED). */
  questionnaire: TalentNom035QuestionnaireAdmin;
};

/** An edge in a connection. */
export type TalentNom035ParticipantAdminNodeEdge = {
  __typename?: 'TalentNom035ParticipantAdminNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TalentNom035ParticipantAdminNode;
};

/** Filtros del listado de participantes. company_level_ids filtra Categoría (company_level.id); division_ids filtra Departamento (division.id). Ambos permiten múltiples valores. */
export type TalentNom035ParticipantFiltersInput = {
  /** Ids de Categoría (company_level.id). */
  company_level_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Ids de Departamento (division.id). */
  division_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Metadata del listado de participantes (page_size + total). */
export type TalentNom035ParticipantsAdminMetadata = {
  __typename?: 'TalentNom035ParticipantsAdminMetadata';
  /** Tamaño de página solicitado (para calcular la cantidad de páginas). */
  page_size: Scalars['Int']['output'];
  /** Total de participantes activos de la evaluación SIN filtros (contador 'Participantes {N}', RN-7). */
  total_participants: Scalars['Int']['output'];
};

/** Búsqueda por nombre del colaborador (insensible a mayúsculas/acentos). query es el término; fields se acepta por compatibilidad de contrato pero el listado busca por nombre. */
export type TalentNom035ParticipantsSearchInput = {
  /** Campos de búsqueda; el listado busca por nombre del colaborador. */
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  query: Scalars['String']['input'];
};

/** Resultado del EXCEL de progreso: el archivo + los tres contadores que describen su contenido. Los contadores salen del MISMO cálculo que la dona del dashboard, así que el archivo descargado y la pantalla no pueden contradecirse. */
export type TalentNom035ProgressReportAdminPayload = {
  __typename?: 'TalentNom035ProgressReportAdminPayload';
  /** Poblado cuando state = OK. URL INDIRECTA del file-service ({base_domain}/api/rest/file/download/{file_id}/), nunca una URL cruda de S3, y su último segmento es un FILE ID, no el nombre. ⚠ El host depende del entorno: consumila como URL OPACA. */
  absolute_url?: Maybe<Scalars['String']['output']>;
  /** COUNT de los que están en FINISHED — el numerador de la dona. */
  answered_count: Scalars['Int']['output'];
  /** Ej. nom035_progress_4503.xlsx — es un EXCEL (formato confirmado por el dev, decisión D2); sólo la convención de nombre queda por confirmar. */
  file_name?: Maybe<Scalars['String']['output']>;
  /** Trace id de la operación; sin columna en BD. */
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** DERIVADO: total_evaluated - answered_count. Cubre ASSIGNED ('Pendiente') Y IN_PROGRESS ('En progreso') — el reporte es sobre quién NO terminó. ⚠ 'PENDING' NO existe en el enum de estados: el badge 'Pendiente' es ASSIGNED. */
  pending_count: Scalars['Int']['output'];
  /** null mientras la operación es síncrona. Reservado para el caso en que el render se mueva al worker del spoon: entonces lleva el id de la instancia y el FE hace polling de esta mutation igual que con el ZIP. */
  report_instance_id?: Maybe<Scalars['ID']['output']>;
  /** OK en la primera respuesta: el render es SÍNCRONO (lee contadores y filas de la BD transaccional, sin pasar por el motor Flex y por lo tanto sin el timeout de 20 s por ítem). Nunca SENT/PROCESSING hoy — el campo existe para que el FE comparta el handler con el ZIP y para que esta operación pueda volverse asíncrona sin cambiar el contrato. */
  state: TalentNom035ReportStateEnum;
  /** COUNT de questionnaire2 de la evaluación con state <> 'CANCELED'. El MISMO valor que metadata.total_evaluated del listado, calculado por el mismo predicado. */
  total_evaluated: Scalars['Int']['output'];
};

/** Pregunta parseada del fieldList (type='T'). */
export type TalentNom035Question = {
  __typename?: 'TalentNom035Question';
  /** Alias del campo (= form_data.field). */
  alias: Scalars['String']['output'];
  /** Etiqueta de columna de reportería. */
  extra_columns?: Maybe<Scalars['String']['output']>;
  /** Categoría / factor de riesgo. */
  group?: Maybe<Scalars['String']['output']>;
  /** Texto de la pregunta. */
  label: Scalars['String']['output'];
  /** Máx. caracteres (texto abierto). */
  max_length?: Maybe<Scalars['Int']['output']>;
  /** Opciones (vacío para Simple/OPEN). */
  options: Array<TalentNom035QuestionOption>;
  /** Posición entre preguntas (1-based). */
  order: Scalars['Int']['output'];
  /** Si la pregunta es obligatoria. */
  required: Scalars['Boolean']['output'];
  /** fieldList[].subType crudo (Radio/Lista/Simple). */
  sub_type: Scalars['String']['output'];
  /** Nivel más fino dentro de group. */
  subgroup?: Maybe<Scalars['String']['output']>;
  /** Control UI: Radio->RADIO, Lista->SELECT, Simple->OPEN. */
  ui_type: TalentNom035QuestionUiType;
};

/** Opción de respuesta (Radio/Lista). */
export type TalentNom035QuestionOption = {
  __typename?: 'TalentNom035QuestionOption';
  /** Etiqueta visible de la opción. */
  label: Scalars['String']['output'];
  /** Valor persistido en form_data (dnumber/dtext). */
  value: Scalars['String']['output'];
};

export enum TalentNom035QuestionUiType {
  Open = 'OPEN',
  Radio = 'RADIO',
  Select = 'SELECT'
}

export type TalentNom035Questionnaire2 = {
  __typename?: 'TalentNom035Questionnaire2';
  additional_evaluator?: Maybe<Scalars['Boolean']['output']>;
  assigned_date?: Maybe<Scalars['String']['output']>;
  available_time?: Maybe<Scalars['Int']['output']>;
  division_name?: Maybe<Scalars['String']['output']>;
  dont_know?: Maybe<Scalars['Boolean']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  evaluated_id?: Maybe<Scalars['ID']['output']>;
  evaluation_id: Scalars['ID']['output'];
  evaluator_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  job_id?: Maybe<Scalars['ID']['output']>;
  mail_evaluator?: Maybe<Scalars['String']['output']>;
  notification_date?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<Scalars['Int']['output']>;
  open_date?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  person_name?: Maybe<Scalars['String']['output']>;
  postulation_id?: Maybe<Scalars['ID']['output']>;
  process_group?: Maybe<Scalars['ID']['output']>;
  relation?: Maybe<TalentNom035QuestionnaireRelation>;
  revision_text?: Maybe<Scalars['String']['output']>;
  security_code?: Maybe<Scalars['String']['output']>;
  similar_competence_key?: Maybe<Scalars['String']['output']>;
  state: TalentNom035QuestionnaireState;
  state_backup_calibration?: Maybe<Scalars['String']['output']>;
  suggestions?: Maybe<Scalars['String']['output']>;
  suggestions_2?: Maybe<Scalars['String']['output']>;
  suggestions_3?: Maybe<Scalars['String']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
  user_ip?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

/** Cuestionario del participante — espejo 1:1 de innpulsa.questionnaire2. Su id identifica al participante (lo usa exclude_participants). En NOM035 relation es siempre AUTO (autoevaluación). */
export type TalentNom035QuestionnaireAdmin = {
  __typename?: 'TalentNom035QuestionnaireAdmin';
  /** questionnaire2.assigneddate */
  assigned_date?: Maybe<Scalars['Date']['output']>;
  /** questionnaire2.availabletime (temporizador; null = sin límite). */
  available_time?: Maybe<Scalars['Int']['output']>;
  /** questionnaire2.divisionname (snapshot al asignar). */
  division_name?: Maybe<Scalars['String']['output']>;
  /** questionnaire2.enddate */
  end_date?: Maybe<Scalars['DateTime']['output']>;
  /** questionnaire2.evaluated_id (= employee2.id). */
  evaluated_id?: Maybe<Scalars['ID']['output']>;
  /** questionnaire2.evaluation_id */
  evaluation_id?: Maybe<Scalars['ID']['output']>;
  /** questionnaire2.evaluator_id (= evaluated_id en AUTO). */
  evaluator_id?: Maybe<Scalars['ID']['output']>;
  /** questionnaire2.id */
  id: Scalars['ID']['output'];
  /** questionnaire2.job_id */
  job_id?: Maybe<Scalars['ID']['output']>;
  /** questionnaire2.mailevaluator */
  mail_evaluator?: Maybe<Scalars['String']['output']>;
  /** questionnaire2.opendate */
  open_date?: Maybe<Scalars['DateTime']['output']>;
  /** questionnaire2.relation — AUTO en NOM035; otros valores -> null. */
  relation?: Maybe<TalentNom035QuestionnaireRelation>;
  /** questionnaire2.securitycode (semilla del enlace). */
  security_code?: Maybe<Scalars['String']['output']>;
  /** questionnaire2.state (ASSIGNED/IN_PROGRESS/FINISHED/CANCELED/ERROR). */
  state: TalentNom035QuestionnaireState;
  /** questionnaire2.weight */
  weight?: Maybe<Scalars['Decimal']['output']>;
};

export type TalentNom035QuestionnaireAdminConnection = {
  __typename?: 'TalentNom035QuestionnaireAdminConnection';
  edges: Array<TalentNom035ParticipantAdminNodeEdge>;
  metadata: TalentNom035DashboardMetadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Contexto calculado — siempre presente (RN-020). */
export type TalentNom035QuestionnaireContext = {
  __typename?: 'TalentNom035QuestionnaireContext';
  /** Logo de la empresa. */
  company_logo_url?: Maybe<Scalars['String']['output']>;
  /** Nombre de la empresa (visible por evaluación). */
  company_name?: Maybe<Scalars['String']['output']>;
  /** Secciones parseadas; vacío si status != AVAILABLE. */
  sections: Array<TalentNom035Section>;
  /** Estado calculado que decide la pantalla. */
  status: TalentNom035QuestionnaireStatus;
  /** Timer del proceso en minutos (calculado: ceil de evaluation.available_time, que guarda segundos); null si sin timer o status != AVAILABLE. */
  timer_minutes?: Maybe<Scalars['Int']['output']>;
};

export type TalentNom035QuestionnaireDetailInput = {
  /** Credencial única del colaborador = base64(questionnaire2.id). La empresa y el evaluado se decodifican del token (RN-008/009). */
  q_token: Scalars['String']['input'];
};

/** Detalle del cuestionario NOM035 por q_token. */
export type TalentNom035QuestionnaireDetailPayload = {
  __typename?: 'TalentNom035QuestionnaireDetailPayload';
  /** Configuración avanzada por evaluación (barra de avance, botón atrás, modal de confidencialidad, reporte); solo AVAILABLE. */
  configuration?: Maybe<TalentNom035Configuration>;
  /** Contexto calculado — siempre presente (RN-020). */
  context: TalentNom035QuestionnaireContext;
  /** Solo cuando status = AVAILABLE. */
  evaluation?: Maybe<TalentNom035Evaluation>;
  /** Respuestas ya guardadas (retomar, RN-007); solo AVAILABLE. */
  form_data?: Maybe<Array<TalentNom035FormData>>;
  /** Solo cuando status = AVAILABLE. */
  questionnaire?: Maybe<TalentNom035Questionnaire2>;
  /** Solo cuando status = AVAILABLE. */
  questionnaire_form?: Maybe<TalentNom035QuestionnaireForm>;
  /** Solo cuando status = AVAILABLE. */
  statistics?: Maybe<TalentNom035QuestionnaireStatistics>;
};

export type TalentNom035QuestionnaireDetailResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035QuestionnaireDetailPayload | ValidationErrorV2;

/** Filtros por cabecera de columna de la tabla de evaluados. Todos son ACUMULATIVOS: AND entre filtros, OR dentro de cada lista (RN-2). Una lista vacía u omitida no filtra. */
export type TalentNom035QuestionnaireFiltersInput = {
  /** 'Categoría' -> company_level.id. */
  company_level_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** 'Departamento' -> division.id. */
  division_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** 'Evaluadores' -> questionnaire2.evaluator_id. NOM035 es siempre relation='AUTO', así que evaluator_id = evaluated_id = el colaborador de la fila. */
  evaluator_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Badge 'Estado' -> questionnaire2.state: ASSIGNED ('Pendiente') / IN_PROGRESS ('En progreso') / FINISHED ('Finalizada'). ⚠ PENDING NO EXISTE: el label visible es 'Pendiente' pero el valor es ASSIGNED. CANCELED nunca aparece en este listado (es el soft delete), así que filtrar por CANCELED devuelve legítimamente una página vacía. */
  states?: InputMaybe<Array<TalentNom035QuestionnaireState>>;
};

export type TalentNom035QuestionnaireForm = {
  __typename?: 'TalentNom035QuestionnaireForm';
  account_id: Scalars['ID']['output'];
  company_id?: Maybe<Scalars['ID']['output']>;
  configuration?: Maybe<Scalars['String']['output']>;
  excel_layout?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  import_file?: Maybe<Scalars['String']['output']>;
  import_file_2?: Maybe<Scalars['String']['output']>;
  import_file_3?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  template?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  type_2?: Maybe<Scalars['String']['output']>;
};

export enum TalentNom035QuestionnaireRelation {
  Auto = 'AUTO'
}

export enum TalentNom035QuestionnaireState {
  Assigned = 'ASSIGNED',
  Canceled = 'CANCELED',
  Error = 'ERROR',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS'
}

/** Estadísticas calculadas (no existen en BD). */
export type TalentNom035QuestionnaireStatistics = {
  __typename?: 'TalentNom035QuestionnaireStatistics';
  /** Preguntas respondidas. */
  answered_questions: Scalars['Int']['output'];
  /** Avance % (RN-011). */
  progress_percentage: Scalars['Int']['output'];
  /** Preguntas totales. */
  total_questions: Scalars['Int']['output'];
  /** Filas de form_data (respondidas o no). */
  total_responses: Scalars['Int']['output'];
  /** Secciones totales. */
  total_sections: Scalars['Int']['output'];
};

export enum TalentNom035QuestionnaireStatus {
  AlreadyCompleted = 'ALREADY_COMPLETED',
  Available = 'AVAILABLE',
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  LoginRequired = 'LOGIN_REQUIRED',
  NoAccess = 'NO_ACCESS'
}

export type TalentNom035QuestionnairesSearchInput = {
  fields: Array<Nom035QuestionnaireFieldsEnum>;
  query: Scalars['String']['input'];
};

/** Una guía de referencia NOM-035 del catálogo fijo (RN-6). Los umbrales de colaboradores son informativos para la card de la UI. */
export type TalentNom035ReferenceGuide = {
  __typename?: 'TalentNom035ReferenceGuide';
  /** Copy fijo del catálogo (rango de colaboradores / propósito). */
  description: Scalars['String']['output'];
  /** Id estable del catálogo UI ('1'/'2'/'3'); mapea a la guía/form NOM-035 al persistir la selección en evaluation.form_id. */
  id: Scalars['ID']['output'];
  /** Umbral superior sugerido de colaboradores (null = sin máximo). */
  max_collaborators?: Maybe<Scalars['Int']['output']>;
  /** Umbral inferior sugerido de colaboradores (null = sin mínimo). */
  min_collaborators?: Maybe<Scalars['Int']['output']>;
  /** Copy fijo del catálogo (label exacto de la plantilla). */
  name: Scalars['String']['output'];
};

/** Payload de get_reference_guides_nom035_admin: catálogo fijo de 3 guías (RN-6) + headcount de la empresa (RN-7) + guía preseleccionada derivada del headcount (RN-7). Hereda graphql_operation_id (CoreGraphOperation). */
export type TalentNom035ReferenceGuidesPayload = {
  __typename?: 'TalentNom035ReferenceGuidesPayload';
  /** COUNT(employee2) de la empresa — usado para la preselección de guía (RN-7). */
  company_headcount: Scalars['Int']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** Catálogo fijo de guías NOM-035 (3 plantillas). */
  guides: Array<TalentNom035ReferenceGuide>;
  /** Id de la guía preseleccionada, derivado del headcount (RN-7): <=50 -> '1' (I, II V); >50 -> '2' (I, III V). El admin puede sobreescribirla. */
  suggested_guide_id: Scalars['ID']['output'];
};

export type TalentNom035ReportPayload = {
  __typename?: 'TalentNom035ReportPayload';
  /** URL absoluta de descarga: el PDF (tipo síncrono) o el ZIP (cuando el job terminó). null mientras state = SENT / PROCESSING. Es la URL INDIRECTA del file-service ({base_domain}/api/rest/file/download/{file_id}/), nunca una URL cruda de S3, y su último segmento es un FILE ID — el nombre de descarga viaja en file_name. ⚠ El host depende del entorno (federation.crehana.com en prd, qa.creha.co en el resto): consumila como URL OPACA, nunca la reconstruyas. */
  absolute_url?: Maybe<Scalars['String']['output']>;
  /** Nombre del archivo para la descarga, para que el FE no tenga que parsear absolute_url (que termina en un file id, no en el nombre). PDF individual: nom035_report_{employee_id}_{evaluation_id}.pdf. ZIP: nom035_reports_{evaluation_id}.zip. */
  file_name?: Maybe<Scalars['String']['output']>;
  /** Trace id de la operación (convención del repo, CoreGraphOperation). */
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** Numerador del progreso: PDFs ya producidos y empaquetados. Alimenta 'Generando reporte… 5/15', que es lo que hace verificable el 'sin loader infinito'. */
  processed_reports?: Maybe<Scalars['Int']['output']>;
  /** Id de la instancia de generación (AC-2): la fila de manage_django.talent_report. null para el tipo SÍNCRONO, que no crea instancia. Es una PK numérica aunque el campo sea ID (viaja como string numérico): parsealo como entero. */
  report_instance_id?: Maybe<Scalars['ID']['output']>;
  /** Eco del tipo RESUELTO (con el default ya aplicado): le dice al FE qué rama respondió, incluso si mandó el campo en null. */
  report_type?: Maybe<TalentNom035ReportTypeEnum>;
  /** La señal sync/async, y lo único que decide si el FE tiene que hacer polling. REPORT_BY_COLLABORATOR_NOM035 -> siempre OK en la primera respuesta. REPORT_INDIVIDUAL_NOM035 -> SENT/PROCESSING y después OK. ⚠ state = ERROR es el SEGUNDO canal de error del contrato: 'la instancia que estoy consultando falló', algo que un miembro de la unión no puede expresar (la unión significa 'tu petición fue rechazada'). */
  state?: Maybe<TalentNom035ReportStateEnum>;
  /** Denominador del progreso: cuántos cuestionarios FINISHED entran al ZIP. 1 para el tipo síncrono. ⚠ Se CONGELA al crear la instancia (es lo que se le pidió producir), así que si se elimina o reinicia una fila mientras el ZIP está en vuelo, el job y la dona del dashboard pueden diferir. */
  total_reports?: Maybe<Scalars['Int']['output']>;
};

export enum TalentNom035ReportStateEnum {
  /** La generación falló. */
  Error = 'ERROR',
  /** Archivo listo, absolute_url poblado. */
  Ok = 'OK',
  /** PDFs renderizándose / empaquetándose. */
  Processing = 'PROCESSING',
  /** Solicitud rechazada antes de producir nada. Declarado por paridad con la columna; hoy ninguna regla lo dispara. */
  Rejected = 'REJECTED',
  /** Aceptada, todavía no se produjo nada (default de la columna). */
  Sent = 'SENT'
}

export enum TalentNom035ReportTypeEnum {
  /** Lo que YA existe: UN PDF de UN evaluado (template Flex 29311). Una sola llamada, SÍNCRONA. Lo consume el kebab de la fila 'Descargar reporte', visible sólo en cuestionarios FINISHED. DEFAULT del input a propósito: preserva byte a byte el comportamiento del panel del colaborador que ya está en QA, cuyo hook no manda este campo. */
  ReportByCollaboratorNom035 = 'REPORT_BY_COLLABORATOR_NOM035',
  /** NUEVO: un ZIP con el PDF de TODOS los evaluados de la evaluación. Es un FAN-OUT del valor anterior (N llamadas con Flex type='Individual', una por cuestionario FINISHED) + empaquetado + subida. ASÍNCRONO y no negociable (20 s de timeout por PDF, sin concurrencia). Lo consume el combobox 'Reportes individuales'. */
  ReportIndividualNom035 = 'REPORT_INDIVIDUAL_NOM035'
}

/** Input de restart_questionnaire_nom035_admin: reinicia UN cuestionario FINALIZADO de una evaluación NOM035 de la empresa del admin — borra sus respuestas, vuelve el estado a ASSIGNED ('Pendiente'), limpia open_date / end_date y regenera el security_code (RN-5). Sobre ASSIGNED es un no-op idempotente exitoso (U3); sobre IN_PROGRESS/ERROR rechaza; sobre CANCELED responde NotFoundErrorV2. Si el proceso está cerrado a escritura (ventana vencida O estado FINISHED) rechaza con 4001_EVALUATION_CLOSED, cualquiera sea el estado de la fila. */
export type TalentNom035RestartQuestionnaireAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Evaluación dueña de la fila -> evaluation.id (dtype='FormEvaluation' AND step=2) = questionnaire2.evaluation_id. Si el cuestionario existe pero pertenece a OTRA evaluación, la respuesta es IntegrityErrorV2 / 4002_QUESTIONNAIRE_EVALUATION_MISMATCH (par inconsistente, bug del FE). */
  evaluation_id: Scalars['ID']['input'];
  /** Cuestionario objetivo -> innpulsa.questionnaire2.id (el mismo id que devuelve list_questionnaires_nom035_admin). Vacío -> ValidationErrorV2 / 4001_REQUIRED_FIELD. */
  questionnaire_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Payload de restart_questionnaire_nom035_admin: la fila YA actualizada + los contadores recalculados, para que el FE repinte el badge y la dona sin refetch (front-v1-acciones-cuestionario AC-2). */
export type TalentNom035RestartQuestionnaireAdminPayload = {
  __typename?: 'TalentNom035RestartQuestionnaireAdminPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** CALCULADO — cabecera recalculada DESPUÉS del reinicio (COUNT sobre questionnaire2 por estado, state <> 'CANCELED'): la dona baja porque una fila FINISHED volvió a ASSIGNED. Mismo tipo y mismos contadores que list_questionnaires_nom035_admin, así que el valor que pinta el FE sin refetch coincide con el del próximo page load. */
  metadata: TalentNom035DashboardMetadata;
  /** La fila de innpulsa.questionnaire2 DESPUÉS del UPDATE: state=ASSIGNED (badge 'Pendiente'), open_date/end_date en null y un security_code NUEVO — esa diferencia ES la regeneración observable. En el no-op idempotente (la fila ya estaba ASSIGNED, U3/AC-6) devuelve la fila SIN tocar: mismo security_code, y no se borran respuestas otra vez. */
  questionnaire: TalentNom035QuestionnaireAdmin;
};

export type TalentNom035RestartQuestionnaireAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | Nom035EvaluationClosedErrorV2 | Nom035InvalidCompanyErrorV2 | Nom035QuestionnaireEvaluationMismatchErrorV2 | Nom035QuestionnaireNotFinishedErrorV2 | Nom035QuestionnaireNotFoundErrorV2 | Nom035RequiredFieldErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035RestartQuestionnaireAdminPayload | ValidationErrorV2;

export type TalentNom035SaveResponseInput = {
  /** Valor fecha ISO (YYYY-MM-DD) -> form_data.ddate. */
  ddate?: InputMaybe<Scalars['String']['input']>;
  /** Valor numérico -> form_data.dnumber. */
  dnumber?: InputMaybe<Scalars['Float']['input']>;
  /** Valor de texto -> form_data.dtext (texto libre o selección). */
  dtext?: InputMaybe<Scalars['String']['input']>;
  /** Alias del campo en el fieldList (= form_data.field, ej. 'p_001'). */
  field: Scalars['String']['input'];
  /** Credencial única = base64(questionnaire2.id) (RN-008/009). */
  q_token: Scalars['String']['input'];
};

/** Respuesta guardada + avance actualizado (RN-007). */
export type TalentNom035SaveResponsePayload = {
  __typename?: 'TalentNom035SaveResponsePayload';
  /** La fila de form_data guardada (upsert idempotente, RN-016). */
  form_data: TalentNom035FormData;
  /** Cuestionario actualizado (refleja ASSIGNED -> IN_PROGRESS). */
  questionnaire: TalentNom035Questionnaire2;
  /** Avance actualizado (respondidas / total, RN-011). */
  statistics: TalentNom035QuestionnaireStatistics;
};

export type TalentNom035SaveResponseResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035SaveResponsePayload | ValidationErrorV2;

/** Input for schedule_evaluation_nom035_admin (TL-2140, modal 'Programar evaluación'): programa el período + horario + zona horaria y transiciona el estado fuera de borrador. NO crea cuestionarios (los crean generate/add). Reusa el mismo input-espejo TalentNom035EvaluationInput que update-config: start_date/end_date son timestamps (fecha + hora combinadas), date_time_zone es IANA. Hereda TalentBaseInput (aislamiento U2). */
export type TalentNom035ScheduleEvaluationAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Input-espejo de evaluation con la programación: start_date / end_date (ts fecha + hora) + date_time_zone (IANA). Requeridos de negocio (RN — período + horario + zona horaria); fin > inicio (RN-8). */
  evaluation: TalentNom035EvaluationInput;
  /** evaluation.evaluation id a programar. Un id inexistente / de otra empresa resuelve NotFoundErrorV2 (U2). */
  evaluation_id: Scalars['ID']['input'];
  /** Enviar la invitación por correo (E4). Sin flag persistido confirmado; se acepta por fidelidad de contrato. */
  send_invitation?: Scalars['Boolean']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Payload mínimo de schedule_evaluation_nom035_admin (CoreGraphOperation): solo graphql_operation_id. El FE relee la evaluación con get_evaluation_config / list_evaluations. */
export type TalentNom035ScheduleEvaluationAdminPayload = {
  __typename?: 'TalentNom035ScheduleEvaluationAdminPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type TalentNom035ScheduleEvaluationAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035ScheduleEvaluationAdminPayload | ValidationErrorV2;

/** Sección/guía parseada del fieldList (type='LB'). */
export type TalentNom035Section = {
  __typename?: 'TalentNom035Section';
  /** Alias del LB. */
  alias: Scalars['String']['output'];
  /** Posición del LB (1-based). */
  order: Scalars['Int']['output'];
  /** Preguntas de la sección. */
  questions: Array<TalentNom035Question>;
  /** fieldList[].style crudo (jerarquía visual) o null. */
  style?: Maybe<Scalars['String']['output']>;
  /** Título de la sección. */
  title: Scalars['String']['output'];
};

export type TalentNom035SubmitQuestionnaireInput = {
  /** Credencial única = base64(questionnaire2.id) (RN-008/009). */
  q_token: Scalars['String']['input'];
};

/** Cuestionario finalizado + contexto de éxito (RN-013). */
export type TalentNom035SubmitQuestionnairePayload = {
  __typename?: 'TalentNom035SubmitQuestionnairePayload';
  /** Contexto calculado (status=ALREADY_COMPLETED, sections vacío). */
  context: TalentNom035QuestionnaireContext;
  /** Cuestionario finalizado (state=FINISHED, enddate registrada). */
  questionnaire: TalentNom035Questionnaire2;
  /** Snapshot final del avance. */
  statistics: TalentNom035QuestionnaireStatistics;
};

export type TalentNom035SubmitQuestionnaireResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035SubmitQuestionnairePayload | ValidationErrorV2;

/** Input for update_evaluation_config_nom035_admin: single-shot save del Paso 1 (RN-13). Inherits TalentBaseInput (company isolation, U2). Groups the changes into the two entity mirrors (evaluation + configuration). */
export type TalentNom035UpdateEvaluationConfigAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Entity mirror of nom035_configuration (toggles avanzados). */
  configuration: TalentNom035ConfigurationInput;
  /** Entity mirror of evaluation (datos + guía + los 2 flags nativos). */
  evaluation: TalentNom035EvaluationInput;
  /** evaluation.evaluation id to configure. A non-existent / other-company id resolves to NotFoundErrorV2 (U2). */
  evaluation_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Payload MÍNIMO de update_evaluation_config_nom035_admin (patrón CoreGraphOperation): solo graphql_operation_id. El FE relee la configuración con get_evaluation_config (o actualiza su caché de Apollo). */
export type TalentNom035UpdateEvaluationConfigAdminPayload = {
  __typename?: 'TalentNom035UpdateEvaluationConfigAdminPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type TalentNom035UpdateEvaluationConfigAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | Nom035EvaluationAlreadyFinishedErrorV2 | Nom035EvaluationInvalidStateErrorV2 | Nom035InvalidPeriodErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentNom035UpdateEvaluationConfigAdminPayload | ValidationErrorV2;

/** Input de validate_evaluation_name_nom035_admin: valida en tiempo real que el nombre de la evaluación NOM035 no esté duplicado en la empresa. Hereda TalentBaseInput (aislamiento por talent_company_id). */
export type TalentNom035ValidateEvaluationNameAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Nombre de la evaluación a validar (unicidad por empresa). */
  name: Scalars['String']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentNom035ValidateEvaluationNameAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentBoolResponse | ValidationErrorV2;

export type TalentOkrPeriod = {
  __typename?: 'TalentOkrPeriod';
  created_by?: Maybe<Scalars['Int']['output']>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  deleted_date?: Maybe<Scalars['DateTime']['output']>;
  end_date: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  last_inactivated_date?: Maybe<Scalars['DateTime']['output']>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  okr_process_id?: Maybe<Scalars['Int']['output']>;
  start_date: Scalars['DateTime']['output'];
  state?: Maybe<EntityState>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type TalentOptionConfigurationInput = {
  key: Scalars['String']['input'];
  other?: InputMaybe<Scalars['Boolean']['input']>;
  translations: Array<TalentOptionTranslationInput>;
  value: Scalars['String']['input'];
};

export type TalentOptionTranslationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  language_code: Scalars['String']['input'];
};

export type TalentOptionsResponseInput = {
  comment_for_dont_know?: InputMaybe<Scalars['Boolean']['input']>;
  comment_mandatory_for_dont_know?: InputMaybe<Scalars['Boolean']['input']>;
  configuration?: InputMaybe<Array<TalentOptionConfigurationInput>>;
  dont_know?: InputMaybe<Scalars['Boolean']['input']>;
  response_type?: InputMaybe<TalentResponseTypeEnum>;
  scale_type?: InputMaybe<TalentScaleTypeEnum>;
  total_invalid_options?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentPerformanceAdministrator = {
  __typename?: 'TalentPerformanceAdministrator';
  talent_performance_competences_administrator: TalentPerformanceCompetencesAdministrator;
  talent_performance_goals_administrator: TalentPerformanceGoalsAdministrator;
  talent_performance_okr_administrator: TalentPerformanceOkrAdministrator;
  talent_performance_results_administrator: TalentPerformanceResultsAdministrator;
};

export type TalentPerformanceAdministratorMutation = {
  __typename?: 'TalentPerformanceAdministratorMutation';
  talent_performance_competences_administrator: TalentPerformanceCompetencesAdministratorMutations;
  talent_performance_dip_administrator: TalentPerformanceDipConfigAdministratorMutations;
  talent_performance_goals_administrator: TalentPerformanceGoalAdministratorMutations;
  talent_performance_results_administrator: TalentPerformanceResultsAdministratorMutations;
};

export type TalentPerformanceCompetencesAdministrator = {
  __typename?: 'TalentPerformanceCompetencesAdministrator';
  /** Query to get competence dashboard statistics for a single evaluation */
  get_competence_dashboard_admin: TalentGetCompetenceDashboardResponse;
  /** Get competence email template (custom or default) for a specific language */
  get_competence_email_templates_evaluation: TalentGetCompetenceEmailTemplatesResponse;
  /** Query to get company level from competence */
  get_competence_level_admin: TalentGetCompetenceLevelResponse;
  /** query to get massive competences status */
  get_competences_massive_status_admin: TalentGetMassiveCompetencesStatusResponse;
  /** Query to get competences evaluation model statistics */
  get_competences_model_statistics_admin: TalentGetCompetencesModelStatisticsResponse;
  /** Query to get general configuration of evaluation */
  get_configuration_general_for_step_evaluation_admin: TalentGetConfigurationGeneralEvaluationResponse;
  /** Returns the distinct relation types and their current weight percentages for a 360 evaluation. Used to populate the 'Edit weights by relation' modal. Requires evaluation.custom_weight = True (PESOS_CONFIGURABLES). Only FINISHED questionnaires are taken into account. */
  get_evaluation_relation_weights_admin: TalentGetEvaluationRelationWeightsResponse;
  /** Query to get the status of a massive competences relations upload process. */
  get_massive_competences_relations_status_admin: TalentGetMassiveCompetencesRelationsStatusResponse;
  /** Query to get the status of a massive participants upload process. */
  get_massive_participants_status_admin: TalentGetMassiveParticipantsStatusResponse;
  /** Returns the current status of a massive process job. Use process_type to specify which process: COMPETENCES_RELATIONS, PARTICIPANTS, COMPETENCES_MODEL, COMPETENCE_WEIGHTS, EVALUATION_DELETE_RELATIONS, DIP_ACTIVITY_ASSIGNMENT, DIP_ACTIVITY_TRACKING, or DIP_LIBRARY_ACTIVITY. */
  get_massive_process_status_admin: TalentGetMassiveProcessStatusResponse;
  /** query to validate a massive competence-weights Excel file and stage valid rows in Redis */
  get_validations_massive_competence_weights_admin: TalentValidateMassiveCompetenceWeightsResponse;
  /** List active competences models by company (no pagination) */
  list_all_competences_models_admin: TalentListActiveCompetencesModelResponse;
  /** Query to list behaviors by competence and job category */
  list_behaviors_by_competence_category_admin: TalentListBehaviorsByCategoryResponse;
  /** Query to get competences in competences model  */
  list_competences_admin: TalentListCompetencesResponse;
  /** Query to list company configuration for competences evaluation */
  list_competences_configuration_admin: TalentListCompetencesConfigurationResponse;
  /** Query to list company evaluations */
  list_competences_evaluations: TalentListCompetencesEvaluationsResponse;
  /** List all competences filters for a given competence model and company. */
  list_competences_filter_admin: TalentListCompetencesFilterResponse;
  /** Query to get competences coverage for an employee */
  list_competences_filter_coverage_admin: TalentListCompetencesFilterCoverageResponse;
  /** Query to get performance competences general statistics */
  list_competences_general_statistics_admin: TalentListCompetencesStatisticsResponse;
  /** Query to list competences evaluation models */
  list_competences_models_admin: TalentListCompetencesModelStatisticsResponse;
  /** Query to list dashboard evaluations */
  list_dashboard_evaluations_admin: TalentListDashboardEvaluationResponse;
  /** List the competences (grouped) and their assigned behaviors/questions for an evaluator-evaluated pair within a 360 evaluation. */
  list_evaluated_competences_behaviors: TalentListEvaluatedCompetencesBehaviorsResponse;
  /** List evaluators available in evaluation (no pagination) */
  list_evaluation_evaluators_admin: TalentListEvaluatorsResponse;
  /** List evaluators available in evaluation with pagination and filters */
  list_evaluation_evaluators_paginated_admin: TalentListEvaluationEvaluatorsPaginatedResponse;
  /** Query to list available evaluators for an evaluated employee */
  list_evaluators_evaluation_admin: TalentListEvaluatorsEvaluationResponse;
  /** Query to list company employees who are not participating in a given evaluation (paginated). */
  list_non_participants_evaluation_admin: TalentListNonParticipantsEvaluationResponse;
  /** Query to list active competences in a competences model, without statistics or pagination. Only id and names are queried; the remaining fields of the competence type travel as null. The company is taken from the session token, so the talent_company_id input field is ignored */
  list_only_competences_admin: TalentListAllCompetencesResponse;
  /** Query to list participants with evaluators */
  list_participants_evaluation_admin: TalentListEmployeeEvaluationResponse;
  /** Validate if an evaluation name already exists */
  validate_evaluation_name_admin: TalentValidateNameEvaluationResponse;
};


export type TalentPerformanceCompetencesAdministratorGet_Competence_Dashboard_AdminArgs = {
  input: TalentGetCompetenceDashboardInput;
};


export type TalentPerformanceCompetencesAdministratorGet_Competence_Email_Templates_EvaluationArgs = {
  input: TalentGetCompetenceEmailTemplatesInput;
};


export type TalentPerformanceCompetencesAdministratorGet_Competence_Level_AdminArgs = {
  input: TalentGetCompetenceLevelInput;
};


export type TalentPerformanceCompetencesAdministratorGet_Competences_Massive_Status_AdminArgs = {
  input: TalentGetMassiveCompetencesStatusInput;
};


export type TalentPerformanceCompetencesAdministratorGet_Competences_Model_Statistics_AdminArgs = {
  input: TalentGetCompetencesModelStatisticsInput;
};


export type TalentPerformanceCompetencesAdministratorGet_Configuration_General_For_Step_Evaluation_AdminArgs = {
  input: TalentGetConfigurationGeneralEvaluationInput;
};


export type TalentPerformanceCompetencesAdministratorGet_Evaluation_Relation_Weights_AdminArgs = {
  input: TalentGetEvaluationRelationWeightsInput;
};


export type TalentPerformanceCompetencesAdministratorGet_Massive_Competences_Relations_Status_AdminArgs = {
  input: TalentGetMassiveCompetencesRelationsStatusInput;
};


export type TalentPerformanceCompetencesAdministratorGet_Massive_Participants_Status_AdminArgs = {
  input: TalentGetMassiveParticipantsStatusInput;
};


export type TalentPerformanceCompetencesAdministratorGet_Massive_Process_Status_AdminArgs = {
  input: TalentGetMassiveProcessStatusInput;
};


export type TalentPerformanceCompetencesAdministratorGet_Validations_Massive_Competence_Weights_AdminArgs = {
  input: TalentValidateMassiveCompetenceWeightsInput;
};


export type TalentPerformanceCompetencesAdministratorList_All_Competences_Models_AdminArgs = {
  input: TalentCompetencesModelInput;
};


export type TalentPerformanceCompetencesAdministratorList_Behaviors_By_Competence_Category_AdminArgs = {
  input: TalentListBehaviorsByCategoryInput;
};


export type TalentPerformanceCompetencesAdministratorList_Competences_AdminArgs = {
  input: TalentListCompetencesInput;
};


export type TalentPerformanceCompetencesAdministratorList_Competences_Configuration_AdminArgs = {
  input: TalentListCompetencesConfigurationInput;
};


export type TalentPerformanceCompetencesAdministratorList_Competences_EvaluationsArgs = {
  input: TalentListCompetencesEvaluationInput;
};


export type TalentPerformanceCompetencesAdministratorList_Competences_Filter_AdminArgs = {
  input: TalentListCompetencesFilterInput;
};


export type TalentPerformanceCompetencesAdministratorList_Competences_Filter_Coverage_AdminArgs = {
  input: TalentGetEmployeeCompetencesCoverageInput;
};


export type TalentPerformanceCompetencesAdministratorList_Competences_General_Statistics_AdminArgs = {
  input: TalentListCompetencesGeneralStatisticsInput;
};


export type TalentPerformanceCompetencesAdministratorList_Competences_Models_AdminArgs = {
  input: TalentListCompetencesModelInput;
};


export type TalentPerformanceCompetencesAdministratorList_Dashboard_Evaluations_AdminArgs = {
  input: TalentListDashboardEvaluationInput;
};


export type TalentPerformanceCompetencesAdministratorList_Evaluated_Competences_BehaviorsArgs = {
  input: TalentListEvaluatedCompetencesBehaviorsInput;
};


export type TalentPerformanceCompetencesAdministratorList_Evaluation_Evaluators_AdminArgs = {
  input: TalentEvaluationEvaluatorsInput;
};


export type TalentPerformanceCompetencesAdministratorList_Evaluation_Evaluators_Paginated_AdminArgs = {
  input: TalentListEvaluationEvaluatorsInput;
};


export type TalentPerformanceCompetencesAdministratorList_Evaluators_Evaluation_AdminArgs = {
  input: TalentListEvaluatorsEvaluationInput;
};


export type TalentPerformanceCompetencesAdministratorList_Non_Participants_Evaluation_AdminArgs = {
  input: TalentListNonParticipantsEvaluationInput;
};


export type TalentPerformanceCompetencesAdministratorList_Only_Competences_AdminArgs = {
  input: TalentListAllCompetencesInput;
};


export type TalentPerformanceCompetencesAdministratorList_Participants_Evaluation_AdminArgs = {
  input: TalentListParticipantsEvaluationInput;
};


export type TalentPerformanceCompetencesAdministratorValidate_Evaluation_Name_AdminArgs = {
  input: TalentValidateNameEvaluationInput;
};

export type TalentPerformanceCompetencesAdministratorMutations = {
  __typename?: 'TalentPerformanceCompetencesAdministratorMutations';
  /** Activate a DRAFT competence model, cascading ACTIVE state to its competences, levels and behaviors while preserving DELETED rows. */
  activate_competences_model_admin: TalentActivateCompetencesModelResponse;
  /** Mutation to add one or more evaluators to an evaluated participant in an evaluation */
  add_evaluators_evaluation_admin: TalentAddEvaluatorsEvaluationResponse;
  /** mutation to create a behavior for a competence level */
  create_behavior_admin: TalentCreateBehaviorResponse;
  /** mutation to create a competence */
  create_competence_admin: TalentCreateCompetenceResponse;
  /** Create a new competence filter for a competence model. */
  create_competence_filter_admin: TalentCreateCompetenceFilterResponse;
  /** mutation to create a competence level */
  create_competence_level_admin: TalentCreateCompetenceLevelResponse;
  /** mutation to generate Excel template for massive competence weights upload. */
  create_competence_massive_weight_file_admin: TalentGenerateCompetenceWeightTemplateResponse;
  /** mutation to create process queue for massive update of competence weights and minimums */
  create_competence_weights_massive_process_admin: TalentCreateMassiveCompetencesResponse;
  /** mutation to create massive file of competences evaluation model  */
  create_competences_massive_file_admin: TalentCreateMassiveCompetencesFileResponse;
  /** mutation to create process queue for massive process of competences evaluation model  */
  create_competences_massive_process_admin: TalentCreateMassiveCompetencesResponse;
  /** Create a competences model in DRAFT state. */
  create_competences_model_admin: TalentCreateDraftCompetencesModelResponse;
  /** Adds one or more evaluated employees to an active 360 evaluation and creates the AUTO (self-assessment) questionnaire for each, regardless of the evaluation's config360. Atomic batch: if any evaluated fails (e.g. no active job role), the corresponding error is returned and no questionnaires are persisted. Idempotent. */
  create_evaluated_competence_evaluation_admin: TalentAddEvaluatedToEvaluationResponse;
  /** mutation to create the SQS process for a previously validated massive evaluation delete-relations job, or to discard it (cancellation). */
  create_evaluation_delete_relations_massive_process_admin: TalentCreateMassiveEvaluationDeleteRelationsProcessResponse;
  /** Mutation to enqueue the massive competences relations async process. */
  create_massive_competences_relations_process_admin: TalentCreateMassiveCompetencesRelationsResponse;
  /** mutation to generate Excel template for massive deletion of evaluation relations. */
  create_massive_evaluation_delete_relations_file_admin: TalentGenerateEvaluationDeleteRelationsTemplateResponse;
  /** Mutation to enqueue the massive participants async process. */
  create_massive_participants_process_admin: TalentCreateMassiveParticipantsResponse;
  /** Mutation to create evaluation in logical DRAFT state (step 1) */
  create_talent_evaluation_admin: TalentCreateEvaluationResponse;
  /** Clears all question relations of the ASSIGNED questionnaires of an evaluation, leaving those questionnaires in ASSIGNED state with zero linked questions. Returns the count of affected questionnaires. */
  delete_all_evaluation_questions_admin: TalentDeleteAllEvaluationQuestionsResponse;
  /** mutation to delete a behavior from a competence level */
  delete_behavior_admin: TalentDeleteBehaviorResponse;
  /** mutation to delete a competence */
  delete_competence_admin: TalentDeleteCompetenceResponse;
  /** Delete an existing competence filter. */
  delete_competence_filter_admin: TalentDeleteCompetenceFilterResponse;
  /** mutation to delete a single competence level */
  delete_competence_level_admin: TalentDeleteCompetenceLevelResponse;
  /** mutation to update competences evaluation to delete state */
  delete_competences_evaluation_admin: TalentDeleteCompetencesEvaluationResponse;
  /** Mutation to delete an evaluator from an evaluated participant in an evaluation */
  delete_evaluator_evaluation_admin: TalentDeleteEvaluatorEvaluationResponse;
  /** mutation to duplicate an existing competence including its levels and behaviors */
  duplicate_competence_admin: TalentDuplicateCompetenceResponse;
  /** Duplicate a competences model with all its competences, levels and behaviors */
  duplicate_competences_model_admin: TalentDuplicateCompetencesModelResponse;
  /** Mutation to exclude participants massively from evaluation */
  exclude_participants_massive_evaluation_admin: TalentExcludeParticipantsMassiveEvaluationResponse;
  /** Generates a Excel template for massive competence assignment by relationship */
  generate_massive_upload_competences_relations_template: TalentGenerateMassiveUploadCompetencesTemplateResponse;
  /** Generates a pre-filled Excel template for massive relationship upload */
  generate_massive_upload_template: TalentGenerateMassiveUploadTemplateResponse;
  /** Generate questionnaires for a evaluation */
  generate_talent_evaluation_questionnaires: TalentGenerateQuestionnairesResponse;
  /** Reopens a finished questionnaire, setting its state back to IN_PROGRESS so the evaluator can resume answering. The questionnaire must be in FINISHED state. */
  reopen_questionnaire_admin: TalentReopenQuestionnaireResponse;
  /** Restarts a questionnaire, resetting it to ASSIGNED state and deleting all answers. Clears opendate, enddate, suggestions, and similar_competence_key (unless company has config 267). The questionnaire must be in FINISHED or IN_PROGRESS state. */
  restart_questionnaire_admin: TalentRestartQuestionnaireResponse;
  /** Encola el recordatorio masivo por correo de una evaluación. Sirve a DOS módulos a través de `type_reminder` (TalentModuleEnum, nullable con default COMPETENCES — el FE de Competencias que ya está en QA no cambia): COMPETENCES mantiene el comportamiento actual y NOM035 agrega el aislamiento por empresa sobre evaluation.evaluation (dtype='FormEvaluation' step=2; una evaluación de otra empresa o inexistente responde 4004_EVALUATION_NOT_FOUND, nunca Forbidden) y el guard de proceso cerrado a escritura (ventana vencida O state2=FINISHED, decisión D4) que rechaza con 4001_EVALUATION_CLOSED ANTES de encolar un solo correo y ANTES de validar el contenido del mail. Los destinatarios los resuelve el worker con el predicado ya existente de Competencias, que devuelve exactamente los ASSIGNED + IN_PROGRESS de la evaluación. Fire-and-forget: publica en SQS y responde solo graphql_operation_id (no hay conteo de enviados). El envío NOM035 queda auditado (quién / cuándo / qué). El permiso CLIMATE-create lo gobierna el FE/gateway, igual que el resto del módulo. */
  send_evaluators_reminder_email: TalentSendBulkCompanyEmailResponse;
  /** mutation to update a behavior for a competence level */
  update_behavior_admin: TalentUpdateBehaviorResponse;
  /** Update an existing competence filter. */
  update_competence_filter_admin: TalentUpdateCompetenceFilterResponse;
  /** mutation to update a competence level */
  update_competence_level_admin: TalentUpdateCompetenceLevelResponse;
  /** mutation to generate and retrieve the Excel template file for a competence model. */
  update_competence_model_file_admin: TalentGetCompetenceModelTemplateResponse;
  /** mutation to update competences */
  update_competences_admin: TalentUpdateCompetencesResponse;
  /** mutation to update competences evaluation configuration */
  update_competences_evaluation_configuration_admin: TalentUpdateCompetencesEvaluationConfigurationResponse;
  /** Update competences model */
  update_competences_model_admin: TalentUpdateCompetencesModelResponse;
  /** mutation to update competences evaluation model to inactive state */
  update_competences_model_status_admin: TalentUpdateCompetencesModelStatusResponse;
  /** Updates questionnaire weights by relation type for a 360 evaluation. All provided weights must sum to exactly 100. Mirrors saveConfigurationWeight from the legacy Java service. Cases are matched against FINISHED questionnaires. */
  update_evaluation_relation_weights_admin: TalentUpdateEvaluationRelationWeightsResponse;
  /** Mutation to update competences evaluation status (ACTIVE, INACTIVE, DELETED) */
  update_status_competences_evaluation_admin: TalentUpdateStatusCompetencesEvaluationResponse;
  /** Mutation to update evaluation draft progressively */
  update_talent_evaluation_admin: TalentUpdateEvaluationResponse;
  /** mutation to upload massive competences evaluation model */
  upload_competences_massive_admin: TalentUploadMassiveCompetencesResponse;
  /** Mutation to validate and upload a massive competences relations file for a 360 evaluation. */
  upload_massive_competences_by_relations_admin: TalentUploadMassiveCompetencesRelationsResponse;
  /** Mutation to validate and upload a massive participants (relationships) file for a 360 evaluation. */
  upload_massive_participants_admin: TalentUploadMassiveParticipantsResponse;
  /** Create or update a competence email template for a specific language */
  upsert_competence_email_template_evaluation: TalentUpsertCompetenceEmailTemplateResponse;
  /** mutation to validate a massive evaluation delete-relations Excel file and stage rows in Redis for async processing. */
  validate_massive_evaluation_delete_relations_file_admin: TalentValidateMassiveEvaluationDeleteRelationsFileResponse;
};


export type TalentPerformanceCompetencesAdministratorMutationsActivate_Competences_Model_AdminArgs = {
  input: TalentActivateCompetencesModelInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsAdd_Evaluators_Evaluation_AdminArgs = {
  input: TalentAddEvaluatorsEvaluationInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsCreate_Behavior_AdminArgs = {
  input: TalentCreateBehaviorInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsCreate_Competence_AdminArgs = {
  input: TalentCreateCompetenceInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsCreate_Competence_Filter_AdminArgs = {
  input: TalentCreateCompetenceFilterInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsCreate_Competence_Level_AdminArgs = {
  input: TalentCreateCompetenceLevelInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsCreate_Competence_Massive_Weight_File_AdminArgs = {
  input: TalentGenerateCompetenceWeightTemplateInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsCreate_Competence_Weights_Massive_Process_AdminArgs = {
  input: TalentCreateMassiveCompetencesInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsCreate_Competences_Massive_File_AdminArgs = {
  input: TalentCreateMassiveCompetencesFileInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsCreate_Competences_Massive_Process_AdminArgs = {
  input: TalentCreateMassiveCompetencesInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsCreate_Competences_Model_AdminArgs = {
  input: TalentCreateCompetencesModelInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsCreate_Evaluated_Competence_Evaluation_AdminArgs = {
  input: TalentAddEvaluatedToEvaluationInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsCreate_Evaluation_Delete_Relations_Massive_Process_AdminArgs = {
  input: TalentCreateMassiveEvaluationDeleteRelationsProcessInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsCreate_Massive_Competences_Relations_Process_AdminArgs = {
  input: TalentCreateMassiveCompetencesRelationsInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsCreate_Massive_Evaluation_Delete_Relations_File_AdminArgs = {
  input: TalentGenerateEvaluationDeleteRelationsTemplateInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsCreate_Massive_Participants_Process_AdminArgs = {
  input: TalentCreateMassiveParticipantsInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsCreate_Talent_Evaluation_AdminArgs = {
  input: TalentCreateEvaluationInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsDelete_All_Evaluation_Questions_AdminArgs = {
  input: TalentDeleteAllEvaluationQuestionsInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsDelete_Behavior_AdminArgs = {
  input: TalentDeleteBehaviorInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsDelete_Competence_AdminArgs = {
  input: TalentDeleteCompetenceInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsDelete_Competence_Filter_AdminArgs = {
  input: TalentDeleteCompetenceFilterInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsDelete_Competence_Level_AdminArgs = {
  input: TalentDeleteCompetenceLevelInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsDelete_Competences_Evaluation_AdminArgs = {
  input: TalentDeleteCompetencesEvaluationInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsDelete_Evaluator_Evaluation_AdminArgs = {
  input: TalentDeleteEvaluatorEvaluationInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsDuplicate_Competence_AdminArgs = {
  input: TalentDuplicateCompetenceInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsDuplicate_Competences_Model_AdminArgs = {
  input: TalentDuplicateCompetencesModelInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsExclude_Participants_Massive_Evaluation_AdminArgs = {
  input: TalentExcludeParticipantsMassiveEvaluationInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsGenerate_Massive_Upload_Competences_Relations_TemplateArgs = {
  input: TalentGenerateMassiveUploadCompetencesTemplateInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsGenerate_Massive_Upload_TemplateArgs = {
  input: TalentGenerateMassiveUploadTemplateInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsGenerate_Talent_Evaluation_QuestionnairesArgs = {
  input: TalentGenerateQuestionnairesInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsReopen_Questionnaire_AdminArgs = {
  input: TalentReopenQuestionnaireInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsRestart_Questionnaire_AdminArgs = {
  input: TalentRestartQuestionnaireInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsSend_Evaluators_Reminder_EmailArgs = {
  input: TalentSendBulkReminderEmailInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsUpdate_Behavior_AdminArgs = {
  input: TalentUpdateBehaviorInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsUpdate_Competence_Filter_AdminArgs = {
  input: TalentUpdateCompetenceFilterInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsUpdate_Competence_Level_AdminArgs = {
  input: TalentUpdateCompetenceLevelInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsUpdate_Competence_Model_File_AdminArgs = {
  input: TalentGetCompetenceModelTemplateInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsUpdate_Competences_AdminArgs = {
  input: TalentUpdateCompetencesInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsUpdate_Competences_Evaluation_Configuration_AdminArgs = {
  input: TalentUpdateCompetencesEvaluationConfigurationInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsUpdate_Competences_Model_AdminArgs = {
  input: TalentUpdateCompetencesModelInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsUpdate_Competences_Model_Status_AdminArgs = {
  input: TalentUpdateCompetencesModelStatusInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsUpdate_Evaluation_Relation_Weights_AdminArgs = {
  input: TalentUpdateEvaluationRelationWeightsInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsUpdate_Status_Competences_Evaluation_AdminArgs = {
  input: TalentUpdateStatusCompetencesEvaluationInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsUpdate_Talent_Evaluation_AdminArgs = {
  input: CreateTalentEvaluationInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsUpload_Competences_Massive_AdminArgs = {
  input: TalentUploadMassiveCompetencesInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsUpload_Massive_Competences_By_Relations_AdminArgs = {
  input: TalentUploadMassiveCompetencesRelationsInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsUpload_Massive_Participants_AdminArgs = {
  input: TalentUploadMassiveParticipantsInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsUpsert_Competence_Email_Template_EvaluationArgs = {
  input: TalentUpsertCompetenceEmailTemplateInput;
};


export type TalentPerformanceCompetencesAdministratorMutationsValidate_Massive_Evaluation_Delete_Relations_File_AdminArgs = {
  input: TalentValidateMassiveEvaluationDeleteRelationsFileInput;
};

export type TalentPerformanceDipAdministratorMutations = {
  __typename?: 'TalentPerformanceDipAdministratorMutations';
  /** mutation to delete performance develop individual plan */
  delete_performance_dip_process_admin: TalentDeleteDipProcessResponse;
};


export type TalentPerformanceDipAdministratorMutationsDelete_Performance_Dip_Process_AdminArgs = {
  input: TalentDeleteDipProcessInput;
};

export type TalentPerformanceDipAdministratorQueries = {
  __typename?: 'TalentPerformanceDipAdministratorQueries';
  /** Query that returns the full general configuration of a PID process (flat entity) to pre-load the edit form. Scoped by company. */
  get_dip_process_general_config_admin: TalentDipProcessGeneralConfigResponse;
  /** Query that returns the progress funnel of a PID process for the "Estado del proceso" admin page: total progress % + the 4 funnel metrics (created / approved / in_progress / completed), aggregated over the plan's active dip_employee assignments. Applies to continuous and periodic processes. "Sin iniciar" / no data -> zeros. Scoped by company (RN-015 / U3); not paginated. */
  get_dip_process_progress_funnel_admin: TalentDipProcessProgressFunnelResponse;
  /** Query that returns the Talent PID dashboard URL given a PID id. */
  get_url_pid_process_detail: TalentPidDetailResponse;
  /** Query to list the active company employees that feed the PID participant selector (name, cargo, departamento, derived role). When dip_id is set (edition) each employee is flagged as already assigned or not, so the front can pre-select the assigned ones. Scoped by company (R6 / U2). */
  list_dip_participants_admin: TalentListDipParticipantsResponse;
  /** Query that lists a PID process's activity assignments (dip_employee) for the Step-3 "Por colaborador" view, with multi-field search (activity / person name / person email), filter by activity type and pagination. Scoped by company (U2); excludes soft-deleted assignments (RN-006). */
  list_dip_process_activities_by_collaborator_admin: TalentDipActivitiesByCollaboratorResponse;
  /** Query to list DIP processes for a company */
  list_dip_process_admin: TalentListDipProcessResponse;
  /** Query that lists a PID process's activity library (activity_pid) for the Step-3 "Por librería" view, with search by activity name, filter by activity type and 70-20-10 model, and pagination. Scoped by company (U2); excludes soft-deleted activities (RN-006). */
  list_dip_process_library_activities_admin: TalentDipProcessLibraryActivitiesResponse;
  /** Query that returns the participants of a PID process for the "Actividades por colaborador" table: each collaborator with their identity, aggregated progress % and the DERIVED pending-action tags computed from the process config (RN-026 / RN-018). Supports search by name, sort by name (ASC/DESC) and filters by department and pending action (RN-008 / RN-023). In "Sin iniciar" / "Finalizado" the rows come without computed actions ([NONE]). Scoped by company (RN-015 / U3); dip_id from another company -> NotFoundErrorV2. Read-only; excludes soft-deleted participants (U4). */
  list_dip_process_participants_admin: TalentDipProcessParticipantsResponse;
  /** Query that returns the expected-vs-done follow-up time series of a PID process for the "Seguimiento de actividades" line chart. PERIODIC processes only (RN-002); continuous processes yield an empty series (RN-001). "Sin iniciar" / no data -> empty series. Scoped by company (RN-015 / U3); dip_id must belong to the admin's company or NotFoundErrorV2. Read-only, not paginated. */
  list_dip_process_tracking_series_admin: TalentDipProcessTrackingSeriesResponse;
};


export type TalentPerformanceDipAdministratorQueriesGet_Dip_Process_General_Config_AdminArgs = {
  input: TalentDipProcessGeneralConfigInput;
};


export type TalentPerformanceDipAdministratorQueriesGet_Dip_Process_Progress_Funnel_AdminArgs = {
  input: TalentDipProcessProgressFunnelInput;
};


export type TalentPerformanceDipAdministratorQueriesGet_Url_Pid_Process_DetailArgs = {
  input: TalentPidDetail;
};


export type TalentPerformanceDipAdministratorQueriesList_Dip_Participants_AdminArgs = {
  input: TalentListDipParticipantsInput;
};


export type TalentPerformanceDipAdministratorQueriesList_Dip_Process_Activities_By_Collaborator_AdminArgs = {
  input: TalentDipProcessActivitiesListInput;
};


export type TalentPerformanceDipAdministratorQueriesList_Dip_Process_AdminArgs = {
  input: TalentListDipProcessInput;
};


export type TalentPerformanceDipAdministratorQueriesList_Dip_Process_Library_Activities_AdminArgs = {
  input: TalentDipProcessActivitiesListInput;
};


export type TalentPerformanceDipAdministratorQueriesList_Dip_Process_Participants_AdminArgs = {
  input: TalentDipProcessParticipantsListInput;
};


export type TalentPerformanceDipAdministratorQueriesList_Dip_Process_Tracking_Series_AdminArgs = {
  input: TalentDipProcessTrackingSeriesInput;
};

export type TalentPerformanceDipConfigAdministratorMutations = {
  __typename?: 'TalentPerformanceDipConfigAdministratorMutations';
  /** STEP 0 (template) — generate the downloadable .xlsx template to massively assign activities to collaborators, in the requested language, and return its download URL. Scoped by company (U2). */
  create_dip_activity_assignment_massive_file_admin: TalentCreateMassiveDipActivityAssignmentFileResponse;
  /** STEP 0 (template) — generate the downloadable .xlsx template to massively track (progress + rating) activities assigned to collaborators, in the requested language, and return its download URL. Scoped by company (U2). */
  create_dip_activity_tracking_massive_file_admin: TalentCreateMassiveDipActivityTrackingFileResponse;
  /** Create one activity in the PID process library (Step 3, 'Por bookshop' view). Scoped by company (U2); enforces the required name (RN-002), the conditional detail (RN-003) and the type limited to enabled modules (RN-011). Returns the id of the created activity. */
  create_dip_library_activity_admin: TalentCreateDipLibraryActivityResponse;
  /** STEP 0 (template) — generate the downloadable .xlsx template to massively create or update activities of the process library, in the requested language, and return its download URL. The template's Modelo 70-20-10 column is only included when the process has that methodology enabled. Scoped by company (U2); process scoped by dip_id (RN-013). */
  create_dip_library_activity_massive_file_admin: TalentCreateMassiveDipLibraryActivityFileResponse;
  /** STEP 2 (SQS) — enqueue the worker that applies the error-free rows of a validated upload (job_id from step 1) as dip_employee assignments (async). Returns a minimal payload. Scoped by company (U2); audited (U1); idempotent on re-upload (U3). */
  create_massive_dip_activity_assignment_process_admin: TalentCreateMassiveDipActivityAssignmentResponse;
  /** STEP 2 (SQS) — enqueue the worker that applies the error-free rows of a validated upload (job_id from step 1) as dip_employee_track updates (progress + rating, async). Returns a minimal payload. Scoped by company (U2); audited (U1); idempotent on re-upload (U3). */
  create_massive_dip_activity_tracking_process_admin: TalentCreateMassiveDipActivityTrackingResponse;
  /** STEP 2 (SQS) — enqueue the worker that applies the error-free rows of a validated upload (job_id from step 1) as activity_pid creates or updates (async, AC-3). Returns a minimal payload. Scoped by company (U2); audited (U1); idempotent on re-upload (U3). */
  create_massive_dip_library_activity_process_admin: TalentCreateMassiveDipLibraryActivityResponse;
  /** Soft-delete one or several COLLABORATOR assignments (Step 3, 'Por collaborator' view). Supports single, batch ('Eliminate selected') and select-all. Scoped by company (U2); marks rows inactive (RN-006 / U4), never a physical delete; idempotent on replay (U3) and audited (U1). Returns only the operation id; the FE re-fetches the list. */
  delete_dip_collaborator_activities_admin: TalentDeleteDipActivitiesResponse;
  /** Soft-delete one or several LIBRARY activities (Step 3, 'Por librería' view). Supports single, batch ('Eliminar seleccionados') and select-all. Scoped by company (U2); marks rows inactive (RN-006 / U4), never a physical delete; idempotent on replay (U3) and audited (U1). Returns only the operation id; the FE re-fetches the list. */
  delete_dip_library_activities_admin: TalentDeleteDipActivitiesResponse;
  /** Save a delta over the participant selection of a PID process (Step 2, R3): assigned_employee_ids are inserted or reactivated, unassigned_employee_ids are soft-deleted (U4), and assign_all assigns every selectable employee of the company. Requires at least one change and at least one participant after the delta (R1), the process to belong to the admin's company (R6 / U2) and to still be editable (R5); the change is audited (U1). */
  save_dip_participants_admin: TalentSaveDipParticipantsResponse;
  /** Create (id null) or update (id present) the full general configuration of a PID process in a single operation. Scoped by company; returns only the id that continues to Step 2. */
  save_dip_process_general_config_admin: TalentSaveDipProcessGeneralConfigResponse;
  /** Edit one existing EMPLOYEE-owned activity of the Step-3 'Por colaborador' view (the activity of a dip_employee assignment). The employee-owned counterpart of update_dip_library_activity_admin: only EMPLOYEE-owned, non-catalogue (RN-010) activities are editable here (ADMIN-owned library activities use update_dip_library_activity_admin). Scoped by company (U2); enforces the required name (RN-002), the conditional detail (RN-003) and the type limited to enabled modules (RN-011). Returns the id of the edited activity. */
  update_dip_collaborator_activity_admin: TalentUpdateDipCollaboratorActivityResponse;
  /** Edit one existing activity of the PID process library (Step 3, 'Por librería' view). Scoped by company (U2); enforces the required name (RN-002), the conditional detail (RN-003), the type limited to enabled modules (RN-011) and the read-only catalogue rule (RN-010). Returns the id of the edited activity. */
  update_dip_library_activity_admin: TalentUpdateDipLibraryActivityResponse;
  /** STEP 1 (SQS) — upload & validate the .xlsx to massively assign activities to collaborators. Validates each row (max 1000, RN-008) without aborting the batch and returns the validation result; extra.job_id chains into the create step. Applies nothing yet. Scoped by company (U2); process scoped by dip_id (RN-013). */
  upload_massive_dip_activity_assignment_admin: TalentUploadMassiveDipActivityAssignmentResponse;
  /** STEP 1 (SQS) — upload & validate the .xlsx to massively track activities of collaborators. Validates each row (max 1000, RN-008): the required id (the tracking record it targets — a seguimiento window for periodic processes, the assignment for continuous ones; must resolve inside the process/company and not repeat in the file) and the progress (0-100); the rating comment is optional free text. Does not abort the batch and returns the validation result; extra.job_id chains into the create step. Applies nothing yet. Scoped by company (U2); process scoped by dip_id (RN-013). */
  upload_massive_dip_activity_tracking_admin: TalentUploadMassiveDipActivityTrackingResponse;
  /** STEP 1 (SQS) — upload & validate the .xlsx to massively create or update activities of the process library. Validates each row (max 1000, RN-008), including the required name (RN-002) and the process limited to the enabled modules (RN-011), without aborting the batch, and tells crear vs actualizar apart by the 'Code' column (AC-3). Returns the validation result; extra.job_id chains into the create step. Applies nothing yet. Scoped by company (U2); process scoped by dip_id (RN-013). */
  upload_massive_dip_library_activity_admin: TalentUploadMassiveDipLibraryActivityResponse;
};


export type TalentPerformanceDipConfigAdministratorMutationsCreate_Dip_Activity_Assignment_Massive_File_AdminArgs = {
  input: TalentCreateMassiveDipActivityAssignmentFileInput;
};


export type TalentPerformanceDipConfigAdministratorMutationsCreate_Dip_Activity_Tracking_Massive_File_AdminArgs = {
  input: TalentCreateMassiveDipActivityTrackingFileInput;
};


export type TalentPerformanceDipConfigAdministratorMutationsCreate_Dip_Library_Activity_AdminArgs = {
  input: PrivateTalentCreateDipLibraryActivityInput;
};


export type TalentPerformanceDipConfigAdministratorMutationsCreate_Dip_Library_Activity_Massive_File_AdminArgs = {
  input: TalentCreateMassiveDipLibraryActivityFileInput;
};


export type TalentPerformanceDipConfigAdministratorMutationsCreate_Massive_Dip_Activity_Assignment_Process_AdminArgs = {
  input: TalentCreateMassiveDipActivityAssignmentInput;
};


export type TalentPerformanceDipConfigAdministratorMutationsCreate_Massive_Dip_Activity_Tracking_Process_AdminArgs = {
  input: TalentCreateMassiveDipActivityTrackingInput;
};


export type TalentPerformanceDipConfigAdministratorMutationsCreate_Massive_Dip_Library_Activity_Process_AdminArgs = {
  input: TalentCreateMassiveDipLibraryActivityInput;
};


export type TalentPerformanceDipConfigAdministratorMutationsDelete_Dip_Collaborator_Activities_AdminArgs = {
  input: TalentDeleteDipCollaboratorActivitiesInput;
};


export type TalentPerformanceDipConfigAdministratorMutationsDelete_Dip_Library_Activities_AdminArgs = {
  input: TalentDeleteDipLibraryActivitiesInput;
};


export type TalentPerformanceDipConfigAdministratorMutationsSave_Dip_Participants_AdminArgs = {
  input: TalentSaveDipParticipantsInput;
};


export type TalentPerformanceDipConfigAdministratorMutationsSave_Dip_Process_General_Config_AdminArgs = {
  input: TalentSaveDipProcessGeneralConfigInput;
};


export type TalentPerformanceDipConfigAdministratorMutationsUpdate_Dip_Collaborator_Activity_AdminArgs = {
  input: PrivateTalentUpdateDipCollaboratorActivityInput;
};


export type TalentPerformanceDipConfigAdministratorMutationsUpdate_Dip_Library_Activity_AdminArgs = {
  input: PrivateTalentUpdateDipLibraryActivityInput;
};


export type TalentPerformanceDipConfigAdministratorMutationsUpload_Massive_Dip_Activity_Assignment_AdminArgs = {
  input: TalentUploadMassiveDipActivityAssignmentInput;
};


export type TalentPerformanceDipConfigAdministratorMutationsUpload_Massive_Dip_Activity_Tracking_AdminArgs = {
  input: TalentUploadMassiveDipActivityTrackingInput;
};


export type TalentPerformanceDipConfigAdministratorMutationsUpload_Massive_Dip_Library_Activity_AdminArgs = {
  input: TalentUploadMassiveDipLibraryActivityInput;
};

export type TalentPerformanceGoalAdministratorMutations = {
  __typename?: 'TalentPerformanceGoalAdministratorMutations';
  /** mutation to delete performance goal period */
  delete_performance_goal_process_admin: TalentDeleteGoalProcessResponse;
};


export type TalentPerformanceGoalAdministratorMutationsDelete_Performance_Goal_Process_AdminArgs = {
  input: TalentDeleteGoalProcessInput;
};

export type TalentPerformanceGoalsAdministrator = {
  __typename?: 'TalentPerformanceGoalsAdministrator';
  /** Query that returns the Talent Competences dashboard URL given a Competences process id. */
  get_url_competences_process_detail_admin: TalentCompetencesEvaluationDetailResponse;
  /** Query to get performance result config */
  list_goal_process_admin: TalentListGoalProcessResponse;
  /** Query to list goal tracks by goal period, filtered by company */
  list_goal_tracks_admin: TalentListGoalTracksResponse;
  /** Query to list goal periods for a company */
  list_goals_period_admin: TalentListGoalPeriodResponse;
  /** Query to list the company goals of a goal period, filtered by company. When goal_period_id is omitted, all periods of the company are returned */
  list_only_company_goals_admin: TalentListCompanyGoalsResponse;
};


export type TalentPerformanceGoalsAdministratorGet_Url_Competences_Process_Detail_AdminArgs = {
  input: TalentCompetencesEvaluationDetail;
};


export type TalentPerformanceGoalsAdministratorList_Goal_Process_AdminArgs = {
  input: TalentListGoalProcessInput;
};


export type TalentPerformanceGoalsAdministratorList_Goal_Tracks_AdminArgs = {
  input: TalentListGoalTracksInput;
};


export type TalentPerformanceGoalsAdministratorList_Goals_Period_AdminArgs = {
  input: TalentListGoalPeriodInput;
};


export type TalentPerformanceGoalsAdministratorList_Only_Company_Goals_AdminArgs = {
  input: TalentListCompanyGoalsInput;
};

export type TalentPerformanceMutations = {
  __typename?: 'TalentPerformanceMutations';
  talent_performance_administrator: TalentPerformanceAdministratorMutation;
};

export type TalentPerformanceOkrAdministrator = {
  __typename?: 'TalentPerformanceOkrAdministrator';
  /** Query to get okr periods */
  list_okr_period_admin: TalentListOkrPeriodResponse;
  /** Query to list the root objectives of an OKR process, or of every process of the company when okr_process_id is omitted. Every descendant (key results and aligned child objectives) hangs off a parent and is not part of this listing */
  list_only_objectives_by_okr_process_admin: TalentListObjectivesByOkrProcessResponse;
};


export type TalentPerformanceOkrAdministratorList_Okr_Period_AdminArgs = {
  input: TalentListOkrPeriodInput;
};


export type TalentPerformanceOkrAdministratorList_Only_Objectives_By_Okr_Process_AdminArgs = {
  input: TalentListObjectivesByOkrProcessInput;
};

export type TalentPerformanceQueries = {
  __typename?: 'TalentPerformanceQueries';
  talent_performance_administrator: TalentPerformanceAdministrator;
};

export type TalentPerformanceResultConfiguration = {
  __typename?: 'TalentPerformanceResultConfiguration';
  competences_evaluation_id?: Maybe<Scalars['Int']['output']>;
  competences_percentage?: Maybe<Scalars['Int']['output']>;
  competences_result_format?: Maybe<CompetencesResultFormatEnum>;
  date_from?: Maybe<Scalars['DateTime']['output']>;
  goals_percentage?: Maybe<Scalars['Int']['output']>;
  goals_period_id?: Maybe<Scalars['Int']['output']>;
  goals_result_type?: Maybe<GoalsResultTypeEnum>;
  id?: Maybe<Scalars['Int']['output']>;
  limit_1?: Maybe<Scalars['Float']['output']>;
  limit_2?: Maybe<Scalars['Float']['output']>;
  limit_3?: Maybe<Scalars['Float']['output']>;
  limit_4?: Maybe<Scalars['Float']['output']>;
  limit_5?: Maybe<Scalars['Float']['output']>;
  okr_period_id?: Maybe<Scalars['Int']['output']>;
  report_template_id?: Maybe<Scalars['Int']['output']>;
};

export type TalentPerformanceResultsAdministrator = {
  __typename?: 'TalentPerformanceResultsAdministrator';
  /** Query to get the company results configuration list */
  get_company_results_configurations_admin: TalentGetCompanyResultsConfigurationsResponse;
  /** Query to get performance result configuration */
  get_performance_results_configuration_admin: TalentGetPerformanceResultConfigurationResponse;
  /** Query to get performance result gauss configuration */
  get_performance_results_configuration_gauss_admin: TalentGetPerformanceResultConfigurationGaussResponse;
  /** Query to get performance result configuration */
  get_performance_results_configuration_process_admin: TalentGetPerformanceResultConfigurationProcessResponse;
};


export type TalentPerformanceResultsAdministratorGet_Company_Results_Configurations_AdminArgs = {
  input: TalentGetCompanyResultsConfigurationsInput;
};


export type TalentPerformanceResultsAdministratorGet_Performance_Results_Configuration_AdminArgs = {
  input: TalentGetPerformanceResultConfigurationInput;
};


export type TalentPerformanceResultsAdministratorGet_Performance_Results_Configuration_Gauss_AdminArgs = {
  input: TalentGetPerformanceResultConfigurationGaussInput;
};


export type TalentPerformanceResultsAdministratorGet_Performance_Results_Configuration_Process_AdminArgs = {
  input: TalentGetPerformanceResultConfigurationProcessInput;
};

export type TalentPerformanceResultsAdministratorMutations = {
  __typename?: 'TalentPerformanceResultsAdministratorMutations';
  /** mutation to update performance result configuration result */
  update_performance_results_configuration_admin: TalentUpdatePerformanceResultConfigurationResponse;
  /** mutation to update performance result configuration result */
  update_performance_results_configuration_gauss_admin: TalentUpdatePerformanceGaussConfigurationResponse;
  /** mutation to update performance result general configuration */
  update_performance_results_general_configuration_admin: TalentUpdatePerformanceResultConfigurationResponse;
};


export type TalentPerformanceResultsAdministratorMutationsUpdate_Performance_Results_Configuration_AdminArgs = {
  input: TalentUpdatePerformanceResultConfigurationInput;
};


export type TalentPerformanceResultsAdministratorMutationsUpdate_Performance_Results_Configuration_Gauss_AdminArgs = {
  input: TalentUpdatePerformanceGaussConfigurationInput;
};


export type TalentPerformanceResultsAdministratorMutationsUpdate_Performance_Results_General_Configuration_AdminArgs = {
  input: TalentUpdateCompanyPerformanceResultConfigurationInput;
};

export type TalentPerson = {
  __typename?: 'TalentPerson';
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type TalentPidDetail = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Identifier of the PID process. */
  pid_id: Scalars['Int']['input'];
  /** The talent company id owning the PID. */
  talent_company_id: Scalars['ID']['input'];
};

export type TalentPidDetailResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentPidDashboardUrlPayload | ValidationErrorV2;

export type TalentProcessInput = {
  /** ID of a climate evaluation process. */
  climate_id?: InputMaybe<Scalars['Int']['input']>;
  /** ID of a competence evaluation process. */
  competence_id?: InputMaybe<Scalars['Int']['input']>;
  /** ID of a DIP (individual development plan) process. */
  dip_id?: InputMaybe<Scalars['Int']['input']>;
  /** ID of a feedback process. */
  feedback_id?: InputMaybe<Scalars['Int']['input']>;
  /** ID of a goals process. */
  goal_id?: InputMaybe<Scalars['Int']['input']>;
  /** ID of a goals tracking process. */
  goal_tracking?: InputMaybe<Scalars['Int']['input']>;
  /** ID of a PID (plan individual de desarrollo) process. */
  pid_id?: InputMaybe<Scalars['Int']['input']>;
};

/** Talent module a process belongs to. Names match `list_talent_processes_by_company` in crehana-subgraph-talent so the same module vocabulary works across both subgraphs. */
export enum TalentProcessModule {
  Climate = 'CLIMATE',
  Competences = 'COMPETENCES',
  DynamicPerformance = 'DYNAMIC_PERFORMANCE',
  Goals = 'GOALS',
  Nom035 = 'NOM035',
  Okrs = 'OKRS',
  Pid = 'PID'
}

/** How many processes a requested module has. */
export type TalentProcessModuleCountType = {
  __typename?: 'TalentProcessModuleCountType';
  module: TalentProcessModule;
  /** Processes this company has in the module, before pagination. Zero means the company has no processes there — it is not an error, and it is indistinguishable from the module not being contracted. */
  total_count: Scalars['Int']['output'];
};

export enum TalentProcessModuleEnum {
  Climate = 'CLIMATE',
  Competences = 'COMPETENCES',
  DynamicPerformance = 'DYNAMIC_PERFORMANCE',
  Feedback = 'FEEDBACK',
  Goals = 'GOALS',
  Okrs = 'OKRS',
  Pid = 'PID'
}

export enum TalentProcessSortFieldEnum {
  CreatedDate = 'CREATED_DATE',
  Name = 'NAME'
}

export enum TalentProcessStateEnum {
  Active = 'ACTIVE',
  Created = 'CREATED',
  Finished = 'FINISHED',
  Standby = 'STANDBY',
  Started = 'STARTED'
}

/** Lifecycle state of a Talent process. */
export enum TalentProcessStatus {
  Active = 'ACTIVE',
  Created = 'CREATED',
  Finished = 'FINISHED',
  Standby = 'STANDBY',
  Started = 'STARTED'
}

/** A single Talent process. */
export type TalentProcessType = {
  __typename?: 'TalentProcessType';
  /** Creation date, ISO-8601 'YYYY-MM-DD'. Null if not set. */
  created_date?: Maybe<Scalars['String']['output']>;
  /** Process end date, ISO-8601 'YYYY-MM-DD'. Null if not set. */
  end_date?: Maybe<Scalars['String']['output']>;
  /** Plain numeric process id, ready to use. Pass it as `process_id` (or `evaluation_id` / `performance_period_id`, depending on the query) to the other talent.* queries — no decoding or prefixing needed. For NOM035 this is the evaluation_id; for DYNAMIC_PERFORMANCE it is the performance_period_id. */
  id: Scalars['String']['output'];
  /** Module this process belongs to. Pass it back alongside `id`. */
  module: TalentProcessModule;
  /** Process name as configured by the company. */
  name: Scalars['String']['output'];
  /** Process start date, ISO-8601 'YYYY-MM-DD'. Null if not set. */
  start_date?: Maybe<Scalars['String']['output']>;
  /** Lifecycle state: ACTIVE, FINISHED, CREATED, STANDBY or STARTED. Null when the source table leaves it unset. */
  status?: Maybe<Scalars['String']['output']>;
  /** Last update date, ISO-8601 'YYYY-MM-DD'. Always null for OKRS and DYNAMIC_PERFORMANCE — those sources do not record it. */
  updated_date?: Maybe<Scalars['String']['output']>;
};

export enum TalentProcessTypeEnum {
  Competence = 'COMPETENCE',
  Goal = 'GOAL',
  Okr = 'OKR'
}

export type TalentProcessesByCompanyPayload = {
  __typename?: 'TalentProcessesByCompanyPayload';
  /** Climate evaluations of the company */
  climate?: Maybe<Array<PrivateTalentClimateProcess>>;
  /** Competence evaluations of the company */
  competences?: Maybe<Array<PrivateTalentEvaluation>>;
  /** DIP/PID processes of the company */
  dip?: Maybe<Array<PrivateTalentDipProcess>>;
  /** Dynamic performance processes (performance periods) of the company */
  dynamic_performance?: Maybe<Array<PrivateTalentPerformancePeriod>>;
  /** Feedback templates of the company */
  feedback?: Maybe<Array<PrivateTalentFeedbackTemplate>>;
  /** Goal periods of the company */
  goals?: Maybe<Array<PrivateTalentGoalProcess>>;
};

export type TalentProcessesByCompanyResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentProcessesByCompanyPayload | ValidationErrorV2;

/** INPUTS */
export type TalentProcessesFilterInput = {
  company_id: Scalars['Int']['input'];
  employee_id?: InputMaybe<Scalars['Int']['input']>;
  leader_id?: InputMaybe<Scalars['Int']['input']>;
  modules: Array<InputMaybe<ReportModule>>;
  process_states?: InputMaybe<Array<InputMaybe<TalentProcessStateEnum>>>;
  /** deprecado */
  state?: InputMaybe<Scalars['String']['input']>;
  /** deprecado */
  states?: InputMaybe<Array<InputMaybe<GoalPeriodStateEnum>>>;
};

export type TalentProcessesInput = {
  company_id: Scalars['Int']['input'];
  modules: Array<TalentProcessModule>;
  page?: Scalars['Int']['input'];
  page_size?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<TalentProcessStatus>>;
};

/** A page of Talent processes across the requested modules. A successful response is always complete: if any module fails to resolve, the whole query errors instead of returning a partial list. */
export type TalentProcessesPageType = {
  __typename?: 'TalentProcessesPageType';
  /** One entry per requested module, always — including modules with no processes. Use it to tell 'this module has none' from 'this module was not requested'. */
  counts_by_module: Array<TalentProcessModuleCountType>;
  current_page: Scalars['Int']['output'];
  items: Array<TalentProcessType>;
  page_size: Scalars['Int']['output'];
  /** Total processes across all requested modules, before pagination. */
  total_count: Scalars['Int']['output'];
  /** Total pages available. Stop paginating when current_page reaches it. */
  total_pages: Scalars['Int']['output'];
};

export type TalentQuery = {
  __typename?: 'TalentQuery';
  /** Paginated per-collaborator competence detail: for each collaborator, the completion status of each requested evaluation x relation combination (Detalle por colaborador table). `status_filters` filters the table server-side by the completion status of a given column; several entries combine with AND and total_count/total_pages reflect the filtered subset. */
  competences_collaborators: CompetencesCollaboratorsPageType;
  /** Month-by-month cumulative competence progress per relation across a process date range (full-process evolution chart). Future months are null so the FE line stops at 'today'. */
  competences_monthly_progress: MonthlyProgressByRangeType;
  /** Day-by-day cumulative competence progress per relation within a month (line chart of the 'Seguimiento de procesos' block). */
  daily_progress_by_month: DailyProgressByMonthType;
  /** Overall competence evaluation progress plus the per-relation completed/pending summary (Avance General block + relation cards). */
  evaluation_progress: EvaluationProgressType;
  get_division_list_by_company?: Maybe<TalentResponseDivision>;
  get_employee_list_by_company?: Maybe<TalentResponseEmployee>;
  get_level_list_by_company?: Maybe<TalentResponseLevel>;
  get_subsidiary_list_by_company?: Maybe<TalentResponseSubsidiary>;
  get_talent_module_labels?: Maybe<ResponseLabel>;
  /** Returns tracking completion grouped by a given dimension */
  goals_by_dimension: GoalsDimensionPageType;
  /** Returns paginated collaborators with their tracking status */
  goals_collaborators: GoalsCollaboratorsPageType;
  /** Returns daily cumulative tracking completion for a given month */
  goals_daily_tracking: Array<GoalsDailyPointType>;
  /** Returns one cumulative tracking point per month across a process date range (start_month..end_month). Future months are null. */
  goals_monthly_tracking: Array<GoalsMonthlyPointType>;
  /** Returns goals tracking summary for a given month */
  goals_tracking_summary: GoalsTrackingSummaryType;
  /** Average performance score per group with semaphore classification (Promedio de Resultados bar chart). */
  performance_average_results_by_group: PerformanceAverageResultsByGroupType;
  /** Returns performance comparison across dynamic processes with semaphore distribution */
  performance_comparison: PerformanceComparisonPageType;
  /** Returns performance distribution grouped by semaphore ranges, for Dynamic (performance_period_id), Flex (competences + goals evaluation ids) or Basic/tradicional (no ids). Flex and Basic distribute the weighted goals+competences result. */
  performance_distribution: PerformanceDistributionType;
  /** Semaphore range definitions configured for a company. */
  performance_semaphore_ranges: PerformanceSemaphoreRangesType;
  /** Lists the Talent processes of a company for the requested modules. Entry point for the rest of talent.*: the returned `id` is the plain process id those queries expect, so pair it with `module` and pass it straight through. Only the requested modules are queried — one query per module, run concurrently. A module with no processes comes back as an empty list plus a zero entry in `counts_by_module`, never as an error; if any module fails to resolve the whole query errors, so a successful response is always complete. */
  processes: TalentProcessesPageType;
  /** Competence evaluation progress grouped by a dimension (department / job / level) and broken down by relation. */
  progress_by_group: ProgressByGroupType;
  talentDIP: TalentDipQuery;
  talentHCM: TalentHcmQuery;
  talent_climate: TalentClimateQuery;
  talent_climate_nom035: TalentClimateNom035Queries;
  talent_dashboard: TalentDashboardQuery;
  talent_get_user_profile?: Maybe<UserTalentType>;
  talent_management: TalentManagementQueries;
  talent_performance: TalentPerformanceQueries;
  talent_recognition: TalentRecognitionQueries;
};


export type TalentQueryCompetences_CollaboratorsArgs = {
  input: CompetencesCollaboratorsInput;
};


export type TalentQueryCompetences_Monthly_ProgressArgs = {
  input: CompetencesMonthlyProgressInput;
};


export type TalentQueryDaily_Progress_By_MonthArgs = {
  input: DailyProgressByMonthInput;
};


export type TalentQueryEvaluation_ProgressArgs = {
  input: EvaluationProgressInput;
};


export type TalentQueryGet_Division_List_By_CompanyArgs = {
  company_id: Scalars['Int']['input'];
};


export type TalentQueryGet_Employee_List_By_CompanyArgs = {
  input: FilterCompany;
};


export type TalentQueryGet_Level_List_By_CompanyArgs = {
  company_id: Scalars['Int']['input'];
};


export type TalentQueryGet_Subsidiary_List_By_CompanyArgs = {
  company_id: Scalars['Int']['input'];
};


export type TalentQueryGet_Talent_Module_LabelsArgs = {
  company_id: Scalars['Int']['input'];
  language: Scalars['String']['input'];
  namespaces: Array<Scalars['String']['input']>;
};


export type TalentQueryGoals_By_DimensionArgs = {
  input: GoalsByDimensionInput;
};


export type TalentQueryGoals_CollaboratorsArgs = {
  input: GoalsCollaboratorsInput;
};


export type TalentQueryGoals_Daily_TrackingArgs = {
  input: GoalsDailyTrackingInput;
};


export type TalentQueryGoals_Monthly_TrackingArgs = {
  input: GoalsMonthlyTrackingInput;
};


export type TalentQueryGoals_Tracking_SummaryArgs = {
  input: GoalsTrackingSummaryInput;
};


export type TalentQueryPerformance_Average_Results_By_GroupArgs = {
  input: PerformanceAverageResultsByGroupInput;
};


export type TalentQueryPerformance_ComparisonArgs = {
  input: PerformanceComparisonInput;
};


export type TalentQueryPerformance_DistributionArgs = {
  input: PerformanceDistributionInput;
};


export type TalentQueryPerformance_Semaphore_RangesArgs = {
  input: PerformanceSemaphoreRangesInput;
};


export type TalentQueryProcessesArgs = {
  input: TalentProcessesInput;
};


export type TalentQueryProgress_By_GroupArgs = {
  input: ProgressByGroupInput;
};


export type TalentQueryTalent_Get_User_ProfileArgs = {
  input: UserProfileInput;
};

export type TalentRadarCompanyConfigurationInput = {
  /** Auto result comparative */
  auto_result_comparative?: InputMaybe<Scalars['Boolean']['input']>;
  /** Boss result comparative */
  boss_result_comparative?: InputMaybe<Scalars['Boolean']['input']>;
  /** Comp min expected */
  comp_min_expected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Company level comparative */
  company_level_comparative?: InputMaybe<Scalars['Boolean']['input']>;
  /** Competence level min expected */
  competence_level_min_expected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Division comparative */
  division_comparative?: InputMaybe<Scalars['Boolean']['input']>;
  /** Radar evaluation id */
  evaluation_id?: InputMaybe<Scalars['Int']['input']>;
  /** General comparative */
  general_comparative?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TalentRadarEvaluationParameter = {
  __typename?: 'TalentRadarEvaluationParameter';
  help_text?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  param_name: Scalars['String']['output'];
  param_value: Scalars['Boolean']['output'];
};

export type TalentReceivedMedal = {
  __typename?: 'TalentReceivedMedal';
  /** The recognitionemployee row — medal, points, date, sender and batch id. This read fills exactly those: receiver, sender.division and groups_info travel null on the wall (✏️ dev decision, 2026-08-10 — the receiver is the collaborator in session, no card renders the division, and the batch roster is loaded when the detail is opened). Nullable only for envelope symmetry with the other node wrappers of this schema; every edge of this connection carries one. */
  recognition_employee?: Maybe<TalentRecognitionEmployee>;
};

export type TalentReceivedMedalsCollaboratorConnection = {
  __typename?: 'TalentReceivedMedalsCollaboratorConnection';
  edges: Array<TalentReceivedMedalsCollaboratorEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type TalentReceivedMedalsCollaboratorEdge = {
  __typename?: 'TalentReceivedMedalsCollaboratorEdge';
  /** Opaque pagination cursor. */
  cursor: Scalars['String']['output'];
  /** The medal wall card at the end of the edge. */
  node: TalentReceivedMedal;
};

/** Input de add_recognition_participants_admin: agrega colaboradores a la lista de habilitados a enviar medallas, en lote. Idempotente (RN-11): si el colaborador ya está ACTIVE es no-op, si tiene fila INACTIVE se reactiva y si no tiene fila se crea. Los employees_id que no pertenecen a la empresa del request se descartan sin romper la operación. NO existe select_all: asignar a toda la empresa equivale a no tener restricción. */
export type TalentRecognitionAddParticipantsAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Ids de colaborador (employee2.id) a habilitar. Requerido y no vacío. */
  employees_id: Array<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentRecognitionAddParticipantsAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentRecognitionAddParticipantsPayload | ValidationErrorV2;

export type TalentRecognitionAdministratorMutations = {
  __typename?: 'TalentRecognitionAdministratorMutations';
  /** Agrega colaboradores a la lista de habilitados a enviar medallas, en lote. IDEMPOTENTE (RN-11): al colaborador que ya está ACTIVE no le pasa nada, el que tiene fila INACTIVE se REACTIVA (no se inserta una segunda fila) y el que no tiene fila se crea con state=ACTIVE, el plan de la empresa y sus fechas de auditoría. Agregar a alguien que ya está NO es un error. Los employees_id que no pertenecen a la empresa del request se descartan y el resto del lote sí se escribe. Todo en una transacción. Devuelve affected_count = filas creadas + reactivadas (los ya activos no cuentan), así el FE puede confirmar y refrescar. Aislada a la empresa del admin (RN-U02) y al plan de esa empresa (RN-14): el plan se resuelve del talent_company_id, nunca viaja en el input, y si no pertenece a la empresa responde NotFoundErrorV2 sin escribir nada. Escribe la misma tabla y los mismos literales de estado que ya leen el gate nuevo (canSendRecognition) y el legacy (Angular + microservicio Java), así que el colaborador agregado ve el botón 'Enviar medalla' sin desplegar nada del legacy. */
  add_recognition_participants_admin: TalentRecognitionAddParticipantsAdminResponse;
  /** Mutation to enqueue the massive recognition reward async process. */
  create_massive_recognition_reward_process_admin: TalentCreateMassiveRecognitionRewardResponse;
  /** Mutation to create recognition medal */
  create_recognition_medal_admin: TalentCreateRecognitionMedalResponse;
  /** Mutation to create a recognition product (reward) manually (admin) */
  create_recognition_reward_admin: TalentCreateRecognitionRewardResponse;
  /** Quita colaboradores de la lista de envío de medallas, en lote, por BAJA LÓGICA (RN-12): la fila pasa a state=INACTIVE con lastinactivateddate; NUNCA se borra y deleteddate no se toca, así que reactivar al colaborador después revive esa misma fila en vez de crear otra. Quitar a alguien que ya estaba quitado NO es un error: es un no-op con affected_count 0. select_all=true es el 'Borrar todo' de la pantalla — da de baja toda la lista activa de la empresa en una sola llamada y employees_id se ignora; con select_all=false se requiere al menos un id. Devuelve affected_count = filas que pasaron de ACTIVE a INACTIVE. Aislada a la empresa del admin (RN-U02) y al plan de esa empresa (RN-14): el plan se resuelve del talent_company_id y si no pertenece a la empresa responde NotFoundErrorV2 sin escribir nada. El colaborador dado de baja deja de ver el botón 'Enviar medalla' tanto en la UI nueva como en la Angular actual, sin desplegar nada del legacy. */
  remove_recognition_participants_admin: TalentRecognitionRemoveParticipantsAdminResponse;
  /** Mutation to update or create recognition configuration data */
  update_recognition_configuration_admin: TalentUpdateRecognitionConfigurationResponse;
  /** Mutation to update recognition mail template */
  update_recognition_mail_template_admin: TalentUpdateRecognitionMailTemplateResponse;
  /** Mutation to update recognition medal */
  update_recognition_medal_admin: TalentUpdateRecognitionMedalResponse;
  /** Mutation to update recognition medal request status */
  update_recognition_medal_request_status_admin: TalentUpdateRecognitionMedalRequestStatusResponse;
  /** Mutation to update recognition medal status */
  update_recognition_medal_status_admin: TalentUpdateRecognitionMedalStatusResponse;
  /** Mutation to edit an existing recognition reward product (admin) */
  update_recognition_reward_admin: TalentUpdateRecognitionRewardResponse;
  /** Mutation to update recognition reward redemption status (admin) */
  update_recognition_reward_redemption_status_admin: TalentUpdateRecognitionRewardRedemptionStatusResponse;
  /** Mutation to update the status of one or more recognition reward products (admin) */
  update_recognition_reward_status_admin: TalentUpdateRecognitionRewardStatusResponse;
  /** Mutation to validate and upload a massive recognition rewards file (admin). */
  upload_massive_recognition_rewards_admin: TalentUploadMassiveRecognitionRewardsResponse;
};


export type TalentRecognitionAdministratorMutationsAdd_Recognition_Participants_AdminArgs = {
  input: TalentRecognitionAddParticipantsAdminInput;
};


export type TalentRecognitionAdministratorMutationsCreate_Massive_Recognition_Reward_Process_AdminArgs = {
  input: TalentCreateMassiveRecognitionRewardInput;
};


export type TalentRecognitionAdministratorMutationsCreate_Recognition_Medal_AdminArgs = {
  input: TalentCreateRecognitionMedalInput;
};


export type TalentRecognitionAdministratorMutationsCreate_Recognition_Reward_AdminArgs = {
  input: TalentCreateRecognitionRewardInput;
};


export type TalentRecognitionAdministratorMutationsRemove_Recognition_Participants_AdminArgs = {
  input: TalentRecognitionRemoveParticipantsAdminInput;
};


export type TalentRecognitionAdministratorMutationsUpdate_Recognition_Configuration_AdminArgs = {
  input: TalentUpdateRecognitionConfigurationInput;
};


export type TalentRecognitionAdministratorMutationsUpdate_Recognition_Mail_Template_AdminArgs = {
  input: TalentUpdateRecognitionMailTemplateInput;
};


export type TalentRecognitionAdministratorMutationsUpdate_Recognition_Medal_AdminArgs = {
  input: TalentUpdateRecognitionMedalInput;
};


export type TalentRecognitionAdministratorMutationsUpdate_Recognition_Medal_Request_Status_AdminArgs = {
  input: TalentUpdateRecognitionMedalRequestStatusInput;
};


export type TalentRecognitionAdministratorMutationsUpdate_Recognition_Medal_Status_AdminArgs = {
  input: TalentUpdateRecognitionMedalStatusInput;
};


export type TalentRecognitionAdministratorMutationsUpdate_Recognition_Reward_AdminArgs = {
  input: TalentUpdateRecognitionRewardInput;
};


export type TalentRecognitionAdministratorMutationsUpdate_Recognition_Reward_Redemption_Status_AdminArgs = {
  input: TalentUpdateRecognitionRewardRedemptionStatusInput;
};


export type TalentRecognitionAdministratorMutationsUpdate_Recognition_Reward_Status_AdminArgs = {
  input: TalentUpdateRecognitionRewardStatusInput;
};


export type TalentRecognitionAdministratorMutationsUpload_Massive_Recognition_Rewards_AdminArgs = {
  input: TalentUploadMassiveRecognitionRewardsInput;
};

export type TalentRecognitionAdministratorQueries = {
  __typename?: 'TalentRecognitionAdministratorQueries';
  /** Query to get recognition configuration data */
  get_recognition_configuration_admin: TalentRecognitionConfigurationResponse;
  /** Query to get recognition dynamic report url */
  get_recognition_dynamic_report_admin: TalentGetRecognitionResultsDynamicReportResponse;
  /** Query to get recognition manual analysis report url */
  get_recognition_manual_analysis_report_admin: TalentGetRecognitionResultsManualAnalysisReportResponse;
  /** Query to get recognition medal data */
  get_recognition_medal_admin: TalentRecognitionMedalResponse;
  /** Query to get recognition results summary metrics data */
  get_recognition_results_summary_metrics_admin: TalentGetRecognitionResultsSummaryMetricsResponse;
  /** Query to list recognition application medals */
  list_recognition_application_medals_admin: TalentGetRecognitionApplicationsMedalsResponse;
  /** Query to list recognition company medals */
  list_recognition_company_medals_admin: TalentListRecognitionCompanyMedalsResponse;
  /** Query to list recognition mail templates by company and language */
  list_recognition_mail_templates_admin: TalentListRecognitionMailTemplatesResponse;
  /** Lista los colaboradores DISPONIBLES para agregar a la lista de envío de medallas: colaboradores ACTIVOS de la empresa del admin que NO tienen fila ACTIVE en recognition_partaker para el plan de la empresa (RN-15). Un colaborador dado de baja de la lista SÍ aparece acá y trae su participant_id + state=INACTIVE, para que el alta reactive esa fila en vez de insertar otra (RN-11). Búsqueda insensible a mayúsculas/acentos, filtros de colaborador y paginación server-side; orden por nombre ascendente. Aislada a la empresa del admin (RN-U02) y al plan de esa empresa (RN-14): el plan se resuelve del talent_company_id, nunca viaja en el input. Una lista vacía es una conexión vacía con total_count 0, nunca un NotFoundErrorV2. */
  list_recognition_non_participants_admin: TalentRecognitionListParticipantsAdminResponse;
  /** Lista los colaboradores YA ASIGNADOS a la lista de envío de medallas: colaboradores ACTIVOS de la empresa del admin con fila ACTIVE en recognition_partaker para el plan de la empresa. Acá participant_id y state nunca son null; las filas INACTIVE no aparecen (esas vuelven a la lista de disponibles, RN-11). Mismo input, mismo nodo y misma conexión que list_recognition_non_participants_admin — sólo se invierte el filtro sobre la lista. Aislada a la empresa del admin (RN-U02) y al plan de esa empresa (RN-14). Una lista vacía es una conexión vacía con total_count 0, nunca un NotFoundErrorV2: una empresa sin lista armada es una configuración legítima. */
  list_recognition_participants_admin: TalentRecognitionListParticipantsAdminResponse;
  /** Query to list reward redemption requests for admin */
  list_recognition_reward_redemptions_admin: TalentListRecognitionRewardsRedemptionsResponse;
  /** Query to list recognition rewards (vitrina) for admin */
  list_recognition_rewards_admin: TalentListRecognitionRewardsAdminResponse;
  /** Query to list recognition results top divisions medals */
  list_recognition_top_divisions_medals_admin: TalentListRecognitionDivisionModelStatisticsResponse;
  /** Query to list recognition results top medals */
  list_recognition_top_medals_admin: TalentListRecognitionCompanyModelStatisticsResponse;
  /** Query to list recognition results top subsidiaries medals */
  list_recognition_top_subsidiaries_medals_admin: TalentListRecognitionSubsidiaryModelStatisticsResponse;
  /** Query to list recognition results top users medals */
  list_recognition_top_users_medals_admin: TalentListRecognitionEmployeeModelStatisticsResponse;
};


export type TalentRecognitionAdministratorQueriesGet_Recognition_Configuration_AdminArgs = {
  input: TalentRecognitionConfigurationInput;
};


export type TalentRecognitionAdministratorQueriesGet_Recognition_Dynamic_Report_AdminArgs = {
  input: TalentRecognitionResultsDynamicReportInput;
};


export type TalentRecognitionAdministratorQueriesGet_Recognition_Manual_Analysis_Report_AdminArgs = {
  input: TalentRecognitionResultsManualAnalysisReportInput;
};


export type TalentRecognitionAdministratorQueriesGet_Recognition_Medal_AdminArgs = {
  input: TalentRecognitionMedalInput;
};


export type TalentRecognitionAdministratorQueriesGet_Recognition_Results_Summary_Metrics_AdminArgs = {
  input: TalentRecognitionResultsSummaryMetricsInput;
};


export type TalentRecognitionAdministratorQueriesList_Recognition_Application_Medals_AdminArgs = {
  input: TalentRecognitionApplicationsMedalsInput;
};


export type TalentRecognitionAdministratorQueriesList_Recognition_Company_Medals_AdminArgs = {
  input: TalentRecognitionCompanyMedalsInput;
};


export type TalentRecognitionAdministratorQueriesList_Recognition_Mail_Templates_AdminArgs = {
  input: TalentListRecognitionMailTemplatesInput;
};


export type TalentRecognitionAdministratorQueriesList_Recognition_Non_Participants_AdminArgs = {
  input: TalentRecognitionListParticipantsAdminInput;
};


export type TalentRecognitionAdministratorQueriesList_Recognition_Participants_AdminArgs = {
  input: TalentRecognitionListParticipantsAdminInput;
};


export type TalentRecognitionAdministratorQueriesList_Recognition_Reward_Redemptions_AdminArgs = {
  input: TalentListRecognitionRewardsRedemptionsInput;
};


export type TalentRecognitionAdministratorQueriesList_Recognition_Rewards_AdminArgs = {
  input: TalentListRecognitionRewardsAdminInput;
};


export type TalentRecognitionAdministratorQueriesList_Recognition_Top_Divisions_Medals_AdminArgs = {
  input: TalentRecognitionResultsTopDivisionsMedalsInput;
};


export type TalentRecognitionAdministratorQueriesList_Recognition_Top_Medals_AdminArgs = {
  input: TalentRecognitionResultsTopMedalsInput;
};


export type TalentRecognitionAdministratorQueriesList_Recognition_Top_Subsidiaries_Medals_AdminArgs = {
  input: TalentRecognitionResultsTopSubsidiariesMedalsInput;
};


export type TalentRecognitionAdministratorQueriesList_Recognition_Top_Users_Medals_AdminArgs = {
  input: TalentRecognitionResultsTopUsersMedalsInput;
};

export enum TalentRecognitionApplicationsMedalsFilterEnum {
  ModelSentAt = 'MODEL_SENT_AT'
}

export type TalentRecognitionApplicationsMedalsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<TalentBasePaginationInput>;
  range_date_filter?: InputMaybe<TalentRecognitionEmployeeModelRangeDateFilterInput>;
  search?: InputMaybe<TalentRecognitionApplicationsMedalsSearchInput>;
  status?: InputMaybe<TalentRecognitionApplicationsMedalsStatusFilterEnum>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum TalentRecognitionApplicationsMedalsSearchEnum {
  ModelEmployeeName = 'MODEL_EMPLOYEE_NAME',
  ModelSenderName = 'MODEL_SENDER_NAME'
}

export type TalentRecognitionApplicationsMedalsSearchInput = {
  fields: Array<TalentRecognitionApplicationsMedalsSearchEnum>;
  query: Scalars['String']['input'];
};

export enum TalentRecognitionApplicationsMedalsStatusFilterEnum {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type TalentRecognitionCollaboratorMutations = {
  __typename?: 'TalentRecognitionCollaboratorMutations';
  /** Adds a comment to a recognition of the company wall (as-is EP-04, PRD op #5). Writes exactly ONE row in recognition_comment with the author (recognition_comment.emisor_employee_id) and the creation timestamp (recognition_comment.createddate) resolved server-side — that pair is the U1 audit trail (AC-4) — and state = 'ACTIVE', the flag the listing filters on and the one a future soft delete flips (U4). EVERYTHING IS VALIDATED BEFORE ANYTHING IS WRITTEN, so a rejected call creates nothing. RN-10 NO LONGER GATES THIS WRITE (✏️ dev decision): recognition_configuration_plan.option_comments governs the feed and the recognition itself (recognitionemployee.comments_option), not recognition_comment, so a company whose flag was off could be commented from the feed while replying to one of its recognitions answered ForbiddenErrorV2 COMMENTS_DISABLED. That code is GONE from this operation and the plan is not read at all; talent_company_id is still REQUIRED and still scopes the recognition lookup. So the one server-side gate left is reachability, and the CONTENT is checked before it — a two-character comment aimed at a recognition the caller cannot touch answers COMMENT_TOO_SHORT. RN-09 / AC-2: the TRIMMED text must be 3..500 characters, both bounds inclusive, and the trimmed value is what gets persisted. A PRIVATE recognition can be commented ONLY by the two people who took part in it, its sender and its receiver — the same rule get_recognition_post_detail_collaborator opens it under. Every other caller gets the same NotFoundErrorV2 RECOGNITION_NOT_FOUND an unknown id gets, so the id space is not enumerable. THE WRITE IS NOT IDEMPOTENT (✏️ dev decision, withdrawing U3 / AC-5): there is no client_mutation_id, no is_duplicate and no IDEMPOTENCY_KEY_REUSED, because the only way to honour a key was a cross-process ledger — recognition_comment has no column for it — and that cost was judged out of proportion to the story. So TWO CALLS WRITE TWO ROWS: a client that retries a request whose response it lost creates a second comment, which the collaborator can see and delete. The created comment is immediately visible to list_recognition_comments_collaborator, at the END of the thread since it reads oldest first, and bumps the card's statistics.total_comments on the very next read (AC-3). THE PAYLOAD IS THE NEW ROW'S ID AND NOTHING ELSE (✏️ dev decision): the comment row used to travel whole so the client could splice it into the thread without a refetch, so a client that needs the author, the instant or the stored text now RE-READS the thread and matches it by this id. */
  add_recognition_comment_collaborator: TalentAddRecognitionCommentCollaboratorResponse;
  /** Redeem one reward from the vitrina for the calling collaborator. The client sends ONLY recognition_product_id — the server looks up the reward's current cost itself (RN-12); the client never states the price (D-15). Validates BEFORE writing: the reward must exist, be ACTIVE, in stock / not reserved and belong to the caller's Razón Social (else NotFoundErrorV2 REWARD_NOT_AVAILABLE, 'ya no disponible'); and its cost must fit the caller's available points (else ValidationErrorV2 INSUFFICIENT_POINTS). No idempotency (D-08). On success writes one recognition_redemption row in PENDING and returns ONLY its id (redemption_id); a write that could not complete returns the real error and creates nothing (RN-13). */
  create_recognition_redemption_collaborator: TalentCreateRecognitionRedemptionCollaboratorResponse;
  /** Creates, updates or soft-deletes the calling collaborator's reaction over a recognition post or over one of its comments, and returns the resulting state of that target (as-is EP-05, PRD op #6). ONE mutation, THREE writes — and THE CLIENT DECIDES WHICH ONE RUNS: recognition_reaction_id null is a CREATE, an id is an UPDATE of that row's reaction_type, and an id with is_deleted true is a SOFT DELETE (U4 — state INACTIVE plus a deleteddate, never a DELETE). The server NEVER reads the caller's current reaction to choose; it validates what was asked and applies it, which is also why a delete NEEDS the id — resolving 'the reaction I have here' into a row would be the old toggle. WHERE THE CLIENT GETS THE ID: every read that shows a reactable card already carries the caller's own row — node.context.reaction on the company wall, reactions[] on the post detail, comment_reactions[] on the comment thread — so the decision is local: no reaction means CREATE with the tapped type, another type means UPDATE that id, the same type means DELETE that id (un-tap). A DUPLICATE CREATE FAILS LOUDLY with ValidationErrorV2 REACTION_ALREADY_EXISTS when the caller already has an ACTIVE reaction over that target: it is NOT a silent upsert, and that is a decision — a second create means the client's state is stale or its button was not debounced. THERE IS NO client_mutation_id AND NO IDEMPOTENCY LEDGER: an update and a delete are idempotent by nature, and a retried create answers REACTION_ALREADY_EXISTS, which means the first attempt landed — read the card instead of writing again. CONCURRENCY: six parallel taps used to converge on one row (1 ADDED + 5 CHANGED) and are now six creates racing, where the first wins and the other five see the collision — nothing is duplicated either way, but debounce the button or send an UPDATE for the taps after the first. A REVIVED ROW IS STILL A CREATE: re-reacting with the SAME type over the SAME target brings the INACTIVE row back with its original id and created_date instead of inserting a second one, which is what keeps one reaction per person per target per type on a table with no unique constraint; a DIFFERENT type inserts a new row and leaves the dead one behind. comment_id IS THE DISCRIMINATOR OF A CREATE: send it and the reaction lands on that comment (dtype COMMENT), omit it and it lands on the post (dtype MEDAL) — there is no type member to keep in agreement with it and REACTION_TARGET_MISMATCH is gone, though a comment_id that travelled and is not a canonical decimal integer is still refused (ValidationErrorV2 COMMENT_ID_REQUIRED) rather than dropped onto the post. An UPDATE or a DELETE reads the dtype off its ROW and ignores both coordinates. reaction_type TRAVELS AS THE ENUM AND NEVER AS AN ID: the three usable rows of recognition_reaction_type are fixed global data (1 LIKE / 2 LOVE / 3 INTERESTING, company_id null on all of them), so the FK is mapped server-side and no client hardcodes a primary key. Sending the type the row already carries is an UPDATE that changes nothing, NOT a removal — the un-tap is is_deleted. RN-08: a comment accepts LIKE and nothing else, checked against the derived target on a create and against the ROW's dtype on an update or a delete. RN-10 does NOT gate this operation: option_comments closes the comment composer, so reacting to an existing comment works on a company whose comments are off. A PRIVATE RECOGNITION CAN BE REACTED TO ONLY BY THE TWO PEOPLE WHO TOOK PART IN IT, its sender and its receiver — the same rule get_recognition_post_detail_collaborator opens it under. Every other caller gets NotFoundErrorV2 RECOGNITION_NOT_FOUND; a comment of a post the caller cannot reach is refused by that same check BEFORE the comment is looked up, and the guard also runs on an update or a delete against the row's own post, so a reaction cannot be edited on a card that has left the wall. What IS scoped to the collaborator's Razón Social is every ROW this mutation touches (RN-04 / U2 / AC-7); talent_company_id alone proves nothing about who is calling, which is why talent_employee_id is the field that authorizes the write and why a recognition_reaction_id that is not the caller's own answers REACTION_NOT_FOUND. THE PAYLOAD IS ONE FIELD, recognition_reaction_id — the row that was written, answered on all three branches — because it is the only thing the client could not know already and the value the next update or delete is addressed by. There is no reactions_count any more: the counter belongs to the WALL and moves for reasons unrelated to this caller, so refetch the card (or patch it optimistically) instead of trusting a number that is stale the instant it is serialized. */
  create_update_recognition_reaction_collaborator: TalentCreateUpdateRecognitionReactionCollaboratorResponse;
  /** Send a recognition to one colleague or to a whole team in a single operation — every receiver of receiver_employee_ids shares the medal, the comment and the visibility. Replaces the legacy REST create and fires the notification email server-side as part of the same operation (RN-14 / RN-15), one per created recognition: APPROVED notifies the receiver, PENDING asks the company administrators to review it. Every rule is validated BEFORE anything is written (RN-07) — gating, self-recognition, message, medal availability and the points cap — so a rejected send creates nothing and charges nothing. A batch is ALL-OR-NOTHING (RN-17): the cap is charged for the whole batch (number of receivers x medal points, RN-06), one invalid receiver rejects every other one, the inserts run in a single transaction and the created rows share a groups id — so there is never a half-sent batch. The initial state is derived by the server from the company plan (RN-09); the client never sets it. Each rejection carries a specific code so the app can show the matching message. */
  send_recognitions_collaborator: TalentSendRecognitionsCollaboratorResponse;
};


export type TalentRecognitionCollaboratorMutationsAdd_Recognition_Comment_CollaboratorArgs = {
  input: TalentAddRecognitionCommentCollaboratorInput;
};


export type TalentRecognitionCollaboratorMutationsCreate_Recognition_Redemption_CollaboratorArgs = {
  input: TalentCreateRecognitionRedemptionCollaboratorInput;
};


export type TalentRecognitionCollaboratorMutationsCreate_Update_Recognition_Reaction_CollaboratorArgs = {
  input: TalentCreateUpdateRecognitionReactionCollaboratorInput;
};


export type TalentRecognitionCollaboratorMutationsSend_Recognitions_CollaboratorArgs = {
  input: TalentSendRecognitionsCollaboratorInput;
};

export type TalentRecognitionCollaboratorQueries = {
  __typename?: 'TalentRecognitionCollaboratorQueries';
  /** Raw inputs of the send decision for the calling collaborator (RN-20): how many points they already spent in the current budget window, how many are left, and whether they are in the company whitelist. Consolidates the configuration read, the whitelist read and the points calculation the legacy split in three. It returns no verdict — the client composes it with the configuration plan, the role it holds in the session and the medal catalog — and being blocked is never an error. */
  get_can_send_recognition_collaborator: TalentGetCanSendRecognitionCollaboratorResponse;
  /** Recognition module configuration plan of the collaborator's company — source of truth for the access gate (is_module_active), the send cap (is_limit_active + max_points_per_send + reboot_day), the message / public-visibility rules of the send form, the comment switch of the recognition detail (option_comments, RN-10 of feed-empresa) and the configurable labels of the module. A company with the module off is not an error: the plan comes back with is_module_active = false, which is how the app hides the entry point with no empty state — this is the ONE operation of the recognition surface that reports that state instead of refusing, so every other one answers ForbiddenErrorV2 MODULE_NOT_ACTIVE for the same company. */
  get_recognition_configuration_collaborator: TalentGetRecognitionConfigurationCollaboratorResponse;
  /** Full detail of ONE recognition of the medal wall — the popup opened from a card of either sub-tab. A generic get: the ONE medal identified by input.recognition_employee_id inside input.talent_company_id, whatever its state and whichever side the caller is on. Never a list: a group send reports its full roster on recognition.groups_info (RN-010), not as extra items, and the row's own request_status / comment_request describe only that row — an admin resolves each receiver of a batch independently. Both parties travel on the node; sender is null only when the medal was granted by an administrator, where the client renders the company's own branding instead (RN-009). groups_info is the WHOLE batch the send went to, unfiltered by state, and null when the recognition was not part of one. On a REJECTED row the admin's reason travels on comment_request, signed 'Administración' by the client. Read-only: no action on the request is exposed here (RN-007). A recognition that does not exist, was deleted or belongs to another razón social answers NotFoundErrorV2 RECOGNITION_NOT_AVAILABLE so the app can show 'ya no está disponible' (U4). */
  get_recognition_detail_collaborator: TalentGetRecognitionDetailCollaboratorResponse;
  /** Full detail of ONE post of the company wall, in one round trip: the canonical recognitionemployee row, its four counters, its whole comment thread with the reactions of each comment, and the reactions of the post with the collaborator behind each one. IT IS NOT get_recognition_detail_collaborator — that one belongs to epic CAC-1872, is a generic get by id, and returns { recognition } with the caller as audit trail. groups_info DOES NOT TRAVEL HERE: it is answered as null on the row, even on a post that really belongs to a batch, and the company wall is where a client reads the batch siblings of a post. VISIBILITY IS THE FEED'S: a PRIVATE recognition opens for whoever took part in it — its receiver or its sender — and answers NotFoundErrorV2 RECOGNITION_NOT_FOUND to everybody else, the same code and message an unknown id gets. That makes this operation caller-dependent: the same recognition_employee_id legitimately answers a payload for one member of a company and a NotFound for another, so a client must never cache the answer under the post id alone. The same single NotFound also covers an unknown id, a soft-deleted post (U4), a PENDING or REJECTED one (RN-02), one sent more than a year ago (RN-03) and one of another Razón Social (RN-04 / U2) — six situations, one answer, so another tenant's id space is not enumerable — a non-positive id included, since the id is not range-checked and simply names no reachable post. talent_company_id is REQUIRED and it is the only thing that scopes the post: it is not derived from the caller, and an absent or malformed one answers ValidationErrorV2 / INVALID_COMPANY. RN-01 IS NOT CHECKED HERE — this operation does not read the company's plan, so a company whose module is off still opens its posts. statistics is redundant with the two lists on purpose — total_comments == comments.length and the three reaction counters add up to reactions.length — because the card the client already renders reads the counters, and a client that only needs the header can select statistics and skip both lists. Both lists are EMPTY, never null. RN-10 is not answered here: the comment composer is gated by option_comments, which get_recognition_configuration_collaborator reports, and both writes re-check it server-side. */
  get_recognition_post_detail_collaborator: TalentGetRecognitionPostDetailCollaboratorResponse;
  /** The ranking row of THE COLLABORATOR IN SESSION over THE CALENDAR QUARTER IN PROGRESS — the own-position card of the ranking modal, sibling of list_recognition_ranking_receivers_collaborator. IT RETURNS THE SAME TYPE AS A ROW OF THE LISTING AND IT RETURNS IT BARE: the success member of the union IS TalentRecognitionRankingReceiver — employee + statistics { total_points, total_medals } + context { ranking_position } — with no payload wrapper and no `receiver` field to unwrap, so ONE client fragment covers the own-position card AND the list rows and the card can never render a different projection of the same person than the row below it. Same window, same aggregation, same filters (RN-07 received deliveries, APPROVED, live row, ACTIVE medal, ACTIVE employee, U4) and same codes as the listing. THE POSITION RIDES IN context.ranking_position, the RowNumber over the COMPLETE ordered set of the company, numbered with the very order the listing pages — the criterion DESC, the other metric DESC, employee2.id ASC — so the two surfaces answer the same number for the same person by construction: this is the SAME queryset with a filter applied AFTER the window function, never a second query with its own ordering. It closes AC-03 in ONE round trip: the metric from statistics, the position from context. WHICH METRIC TO PRINT is not decided here — this operation carries no metadata, so no order_criterion; the client already holds it from get_recognition_configuration_collaborator (is_public_ranking_points_enabled, RN-02) or from the listing's metadata.data, and both numbers travel here regardless. THE UPPER BOUND DOES NOT TRAVEL EITHER: '4 de 16' needs the listing's total_count. talent_employee_id DOES TWO JOBS: it authorises AND it selects the row, so this operation can only ever answer the session user's own row and 'the row I asked for belongs to another company' is not a distinct error — it IS CALLER_COMPANY_MISMATCH. A USER WITH NOTHING IN THE QUARTER IS NotFoundErrorV2 / RANKING_RECEIVER_NOT_AVAILABLE, not a zeroed row, which is also what makes the three fields of the success member non-null; the code is its own because 'you are not in the ranking' is not 'your company has no ranking', and the company can be answering a full listing in the same breath. An OFFBOARDED caller gets the same answer: only ACTIVE employees are ranked. FE CONTRACT: map it to the EMPTY state of the card, never to the error state. ERROR VARIANTS, IN EVALUATION ORDER: RANKING_RECEIVER_NOT_AVAILABLE, and that is the only rule-driven code this operation can answer. NO INVALID_COMPANY (this read validates nothing about talent_company_id: a 0, a negative or a '01' reaches the query as sent and comes back as the empty state), NO CALLER_NOT_FOUND, NO CALLER_COMPANY_MISMATCH and NO MODULE_NOT_ACTIVE. talent_employee_id is a pure ROW SELECTOR — an id matching nobody is RANKING_RECEIVER_NOT_AVAILABLE, not a rejection — and nothing checks who is asking, nor for which company; the sibling LISTING does still refuse a malformed company. A value that is not a number at all surfaces as a generic ValidationErrorV2 with no contract code. The order criterion arrives in the input, so this operation reads no configuration row either. There is deliberately no INVALID_PAGE / INVALID_PAGE_SIZE (no pagination) and no date validation (no date input). */
  get_recognition_ranking_receiver_collaborator: TalentGetRecognitionRankingReceiverCollaboratorResponse;
  /** Who reacted to a company-wall post, ONE reaction type at a time — the data behind the popup with tabs (PRD section 10, screen #5). Replaces legacy REST EP-06. The tabs are the three values of TalentRecognitionReactionTypeEnum — the whole of recognition_reaction_type, which has exactly three usable rows and a NULL company_id on all of them — so there is no catalog to read and none to list, and the client knows its three tabs at compile time. filter.reaction_type_eq selects the open tab and DEFAULTS TO LOVE when the filter or the member is null: deliberately not the first value of the enum and not the most used reaction. THE THREE TAB HEADERS RIDE IN metadata.data as { total_like, total_love, total_interesting }, unfiltered and unpaged, which is what lets the popup keep its headers correct while showing an EMPTY tab — a type nobody used on this post answers edges [] with total_count 0 while the other two numbers still travel. They are the SAME three numbers the wall card serves in statistics, computed from the same predicates, so a card and the popup it opens can never disagree. Only reactions with state = 'ACTIVE' and dtype = 'MEDAL' are counted or listed (U4 soft delete; the likes on the post's COMMENTS are rows of the same table with the same recognition_id and are NOT part of this answer). Ordered by recognition_reaction.id ASC — insertion order, which is also reaction-time order, so a page boundary never reshuffles rows the client already painted and a reaction that was removed and re-added REVIVES its original row and reappears in the position it always had. Each node is the SHARED TalentRecognitionReaction with its reactor resolved into a TalentEmployee (person, job, division, avatar); RN-12 — the avatar URLs are known broken post-migration and may be null, so the client MUST fall back to the default avatar. The post must belong to the caller's company (RN-04 / U2 / AC-7), be staterequest = APPROVED (RN-02), inside the one-year window (RN-03), not soft-deleted (U4) AND either PUBLIC or one the CALLER took part in; otherwise the answer is NotFoundErrorV2 RECOGNITION_NOT_FOUND. A PRIVATE POST HAS NO READABLE BREAKDOWN FOR A BYSTANDER, and it has one for its sender and its receiver — the same rule get_recognition_post_detail_collaborator opens it under; there is no private-specific code, because one would confirm the recognition exists and is private. The caller AUTHORISES the read and resolves nothing in it: two collaborators who can both reach the post get identical payloads, so a page is cacheable per POST for the audience that can read it. Pagination is offset-based and resolved IN THE DATABASE (page 1-based, page_size bounded 1..50, default 8); the legacy in-memory pagination over a 0-indexed page is deliberately not replicated, so page 0 now answers ValidationErrorV2 INVALID_PAGE. A post with no reactions, a post whose reactions were all removed, an unused tab and a page past the end all answer the connection with edges [] — never an error — and only the last one is distinguishable, through total_count. */
  get_recognition_reaction_details_collaborator: TalentGetRecognitionReactionDetailsCollaboratorResponse;
  /** Redemption points balance of the calling collaborator, returned under statistics: total earned, already spent and available to spend (RN-02). Single aggregate, no pagination. statistics.total_points sums the level points of the medals the caller received with staterequest=APPROVED; statistics.total_points_redeemed sums the caller's PENDING and DELIVERED redemptions (REJECTED excluded, points restored — D-05); statistics.total_points_available = max(0, total_points - total_points_redeemed). Counts only movements of the CYCLE IN FORCE when the company configured an annual reset: its month/day resolved against today — this year's anniversary once it has passed, last year's while it has not. The year stored in force_init_date is not significant (RN-04). No reset configured => the whole history counts. */
  get_recognition_redemption_balance_collaborator: TalentGetRecognitionRedemptionBalanceCollaboratorResponse;
  /** Full detail of ONE reward of the redemption vitrina — the popup opened from a catalog card. Read-only: no redemption action is exposed here (that is create_recognition_redemption_collaborator). Returns the shared TalentRecognitionProduct (id, name, description, image, points, type, has_stock, state). A product that does not exist, is not ACTIVE (INACTIVE or soft-deleted) or belongs to another Razón Social answers NotFoundErrorV2 REWARD_NOT_AVAILABLE so the app can render 'ya no está disponible'. */
  get_recognition_reward_collaborator: TalentGetRecognitionRewardCollaboratorResponse;
  /** Active medal catalog of the collaborator's company, already filtered server-side by the points they have left in the current budget window (RN-04): what comes back is what they can actually send, so the client never re-implements the budget rule. Without a points cap the whole active catalog travels (RN-05). The cost of each medal travels in level.points (RN-23). An empty page is a valid answer, not an error: total_count 0 means nothing is affordable, or the company has no active medal (U4). */
  list_available_medals_to_send_collaborator: TalentListAvailableMedalsToSendCollaboratorResponse;
  /** Paginated company wall ('Mi compañía') of the collaborator app — the central read of the epic. Returns the APPROVED recognitions of the company named in talent_company_id (RN-02) sent within the last year (RN-03), isolated by Razón Social on the receiver (RN-04 / U2), ordered by senddate DESC with ties broken by id DESC, and scoped by filter.feed_eq: no filter means TODOS, EMPLOYEE the ones addressed to the caller, COMPANY the corporate sends. Each row arrives already resolved into a renderable card — receiver and sender as the platform's employee node, the medal, the message, the visibility and the corporate flag on recognition_employee; the four company-wide counters on statistics; and the caller's own reaction on context. THE CARD IS SELF-SUFFICIENT FOR REACTING: context.reaction is both the 'you already reacted' state and the recognition_reaction_id the reaction mutation needs to change or remove it, so a client no longer opens one detail per card to paint a button. PRIVACY DOES NOT SELECT ROWS (RN-14 / RN-15): every approved, live recognition of the company inside the window is listed whatever its visibility, and a PRIVATE one travels whole — medal, points, both parties, the visibility flag itself and the four counters — with ONLY feedback withheld (null). A corporate send (COMPANY) keeps its message whatever public_medal says, because nobody sets that column on an admin-granted medal and blanking it would hide the one message a company wall exists to show. THE WALL IS THEREFORE THE SAME FOR EVERY MEMBER of a company: total_count does not depend on who is asking, a page is cacheable per company and per segment, and the only member that varies per caller is context.reaction. ONE ASYMMETRY TO RENDER AROUND: the wall LISTS a private card that the rest of the post surface will not open for a bystander (the detail, the comment thread, the comment write, the reaction write and the reactions popup all answer RECOGNITION_NOT_FOUND to anyone who neither received nor sent it), so a private card should be painted non-tappable and non-reactable rather than tapped into a not-found. talent_company_id is REQUIRED and it is the only thing that scopes the wall: it is not derived from the caller, and an absent or malformed one answers ValidationErrorV2 / INVALID_COMPANY. RN-01 IS NOT CHECKED HERE — this operation no longer reads the company's plan, so a company whose module is off still answers its wall; get_recognition_configuration_collaborator is what reports that state, and the app hides the entry point with it. Pagination is offset-based and resolved IN THE DATABASE (page 1-based, page_size bounded 1..50); the legacy in-memory pagination is deliberately not replicated. An empty feed answers total_count 0 with edges [], never an error. */
  list_company_recognition_feed_collaborator: TalentListCompanyRecognitionFeedCollaboratorResponse;
  /** Medal wall of the collaborator: the APPROVED recognitions received by input.talent_employee_id inside input.talent_company_id, newest first (RN-002 / RN-019). PENDING and REJECTED recognitions never reach a receiver's wall and soft-deleted rows are excluded (U4), so every item that travels is a published recognition. total_count is the 'Histórico' counter of the tab — the count of the whole filtered query, not of the page. An EMPTY page is a valid answer, not an error: total_count 0 means this collaborator has not received any medal yet. Each card carries the medal with its level, the SENDER (person and job; null when the COMPANY granted the medal, RN-009) and group_id as the mass-grant marker. It does NOT carry receiver (that is the collaborator in session), sender.division, or groups_info — the batch roster is loaded by get_recognition_detail_collaborator when a card is opened. */
  list_received_medals_collaborator: TalentListReceivedMedalsCollaboratorResponse;
  /** Paginated comment thread of a single recognition of the company wall: each edge carries the comment row and the reactions that hang off it, so the client paints the like button, its counter and the 'own comment' affordances from ONE payload and never issues a second round trip. WHAT IT NO LONGER SERVES, and where the client reads it instead: likes_count = comment_reactions.length · has_own_like = an entry whose employee.id is the caller · own_reaction_id = that entry's id · is_own_comment = comment.employee.id is the caller. RN-08 (a comment accepts LIKE and nothing else) is what makes the first three exact, and the consequence is that talent_employee_id resolves NO field of this payload — it authorises the read and nothing more, so two collaborators of one company read byte-identical pages and a page is cacheable per recognition instead of per caller. Scoped to ACTIVE comments (U4) of the recognition_employee_id given, ordered createddate ASC NULLS LAST, id ASC — oldest first, chat reading order, and the second key is not decoration: the DDL lets createddate be null and a dateless comment must not float, while a same-timestamp group needs a total order or a paginated client drops one row and repeats another across a page boundary. Because the thread reads oldest first, a comment written during the session lands at the END of the LAST page, so the optimistic update after add_recognition_comment_collaborator is an APPEND. RN-10 does NOT gate this read: option_comments governs the comment BOX, so a company that turned comments off still returns the thread it already accumulated and the client just does not render the composer. THE RECOGNITION IS GATED, THOUGH, AND THAT GATE IS WHAT ISOLATES THIS READ BY RAZÓN SOCIAL: the post is looked up under talent_company_id before the thread is touched, and an unknown id, a soft-deleted, PENDING or REJECTED post (RN-02 / U4), one older than a year (RN-03), one of another Razón Social (RN-04 / U2 / AC-6) and a PRIVATE one the caller took no part in all answer the SAME NotFoundErrorV2 / RECOGNITION_NOT_FOUND, so the id space cannot be walked. A PRIVATE recognition IS readable HERE by its receiver and its sender — the same two people get_recognition_post_detail_collaborator opens it for, so the thread served inside that payload is the thread this operation pages. talent_company_id is REQUIRED by the input (an absent or malformed one answers ValidationErrorV2 / INVALID_COMPANY) and it is the only thing that scopes the gate. Pagination is offset-based and resolved IN THE DATABASE (page 1-based, page_size bounded 1..50); the legacy in-memory pagination over a 0-indexed page is deliberately not replicated, and the page window is checked BEFORE the post is looked up. An empty thread answers total_count 0 with edges [], never an error — and so does a page past the end. */
  list_recognition_comments_collaborator: TalentListRecognitionCommentsCollaboratorResponse;
  /** GENERAL ranking of RECEIVED recognitions of the caller company over THE CALENDAR QUARTER IN PROGRESS, paginated — the central read of the ranking modal. THE COMPANY-WIDE LIST ONLY: the row of the collaborator in session is served by get_recognition_ranking_receiver_collaborator, which returns THE VERY SAME TYPE, TalentRecognitionRankingReceiver, unwrapped as the success member of its own union. ROWS ARE RECEIVERS, one per collaborator (RN-07 — v1 has no ranking of senders), scoped to talent_company_id on the receiver's own company (U2), counting only APPROVED, live deliveries of ACTIVE medals to ACTIVE employees (U4). THE POSITION TRAVELS ON EVERY ROW, in node.context.ranking_position: the client READS it and does not derive it. The pagination formula survives as an INVARIANT to assert, not as an algorithm — node.context.ranking_position == (page - 1) * page_size + <index in edges> + 1 on every page, with page_size from metadata.page_size — and if the two numbers ever differ the server has two orderings of one set, which is a server defect. THE ORDER IS TOTAL: the company criterion DESC, the other metric DESC, employee2.id ASC, and it is the same order the rows are numbered with. THE ORDER IS STILL THE COMPANY'S DECISION (RN-02) BUT THE VALUE NOW TRAVELS IN THE INPUT: send is_public_ranking_points_enabled, the flag get_recognition_configuration_collaborator already gave you, and this operation orders by it WITHOUT reading recognition_configuration_plan.public_ranking_points again — one query per request instead of two. Null and false both mean MEDALS. NOTHING ON THE SERVER VALIDATES THAT THE VALUE MATCHES THE COMPANY'S COLUMN any more, so a client sending a value it did not get from the configuration query receives a page ordered by a criterion the company never chose. metadata.data.order_criterion echoes the criterion the rows were ACTUALLY ordered by, and it is the metric to paint — the same one for the podium and for the full listing (RN-03). BOTH METRICS TRAVEL ON EVERY ROW regardless, as total_points and total_medals, so a client never re-queries to switch. THE WINDOW IS FIXED AND SERVER-RESOLVED (RN-04): the calendar quarter the read falls in over recognitionemployee.senddate — not a rolling three months — it does not travel in the input, it is not echoed in the output, and reboot_day does not shorten it (RN-05). It is resolved in the platform time zone, so two environments running in different zones rotate the quarter hours apart. THERE IS NO CALLER MEMBER ON THE INPUT: talent_employee_id was removed because no field of this answer ever depended on it, so the page is a pure function of talent_company_id — two clients reading one company receive byte-identical pages and a page is cacheable per company — and CALLER_NOT_FOUND / CALLER_COMPANY_MISMATCH are NOT among this operation's variants (the sibling single-record read still answers both, since there the caller also selects the row). EMPTY IS NotFoundErrorV2 / RANKING_NOT_AVAILABLE and a page PAST THE END IS NOT: nothing inside the quarter refuses, while a page beyond the end of a company that HAS data answers edges [] with the real total_count and has_next_page false. FE CONTRACT: map RANKING_NOT_AVAILABLE to the EMPTY state, never to the ERROR state. ERROR VARIANTS, IN EVALUATION ORDER: INVALID_COMPANY -> INVALID_PAGE (page 0 included: the listing is 1-based) -> INVALID_PAGE_SIZE (refused outside 1..50, never clamped) -> RANKING_NOT_AVAILABLE, AND THAT IS THE WHOLE CHAIN — four codes, none of them a permission check. There is no CALLER_NOT_FOUND and no CALLER_COMPANY_MISMATCH (this operation takes no caller) and no MODULE_NOT_ACTIVE: the RN-01 gate was removed because the app resolves is_module_active before opening the modal, so a company with recognition switched off answers its ranking instead of a refusal. THIS OPERATION NO LONGER READS recognition_configuration_plan AT ALL — the module flag is the client's to check and the order criterion arrives in the input — so talent_company_id as sent is the whole of its isolation. */
  list_recognition_ranking_receivers_collaborator: TalentListRecognitionRankingReceiversCollaboratorResponse;
  /** Top of the MOST-HANDED-OUT MEDALS of the caller's company inside THE CALENDAR QUARTER IN PROGRESS, capped at 3 BY THE SERVER (RN-06) — the 'Top medallas' tab of the recognition modal, sibling of list_recognition_ranking_receivers_collaborator. IT IS NOT A PEOPLE RANKING, so RN-07 ('always on RECEIVED') does not apply: 'sent' here means 'handed out by the company', and v1 has no ranking of senders. The two tabs are two GROUP BYs of the SAME filtered deliveries — by receiver on the Ranking tab, by medal here — which is why a medal counting 4 here is made of the same 4 deliveries that pushed its receivers up the ranking. SHAPE: <medal entity, statistics> per row, mirroring the ResultEntity(entity, statistics) the repository already returns, so the medal is the SAME TalentRecognitionCompany the catalog serves and the FE reuses its existing fragment. THE POSITION IS THE ARRAY INDEX and deliberately not a field, so it cannot contradict the order: rows arrive ordered by statistics.total_sent DESC, tie-broken by the medal id ASC, and the client must never re-sort them. LENGTH IS 1..3 — 3 IS A MAXIMUM, NOT A SIZE: a company with one or two qualifying medals receives one or two rows and the server NEVER pads the list from the catalog. THE WINDOW IS THE CALENDAR QUARTER, NOT LIFETIME AND NOT A ROLLING THREE MONTHS: PRD RN-06 and AC-01 of the story say 'histórico total' and are STALE — the real repository was already windowed — and reboot_day does not clip it (RN-05, that day caps SENDING, never reading). It is resolved server-side in the platform time zone, does not travel in the input and is not echoed in the output (no window_from / window_to), so two environments whose processes run in different zones rotate the quarter hours apart. WHAT total_sent ACTUALLY COUNTS: DELIVERIES TO ACTIVE EMPLOYEES, not deliveries — the state of the RECEIVER is filtered inside the count, so offboarding one person retroactively lowers the counters of the medals they received and can reorder this podium. APPROVED only, soft-deleted delivery rows excluded, senddate NULL counted nowhere, INACTIVE medals excluded from the counting itself (U4 / AC-05), and whether admin-issued deliveries count (sended_from_admin) is still [PENDIENTE DE CONFIRMACION CON TALENT]. AN EMPTY WINDOW IS NotFoundErrorV2 / TOP_MEDALS_NOT_AVAILABLE, never a payload with an empty list (overriding AC-03 of the story) — FE CONTRACT: map it to the EMPTY state of the tab, never to the error state. It is a STANDING state: the first days of every quarter answer it. There is no pagination, so the ranking tab's 'a page past the end is not an error' rule has no analogue. THE CALLER ONLY AUTHORISES: the top is company-wide and identical for every collaborator of the company, so a response is cacheable per company. Isolation runs on talent_company_id alone (U2) AND NOTHING RECONCILES IT WITH THE CALLER: the caller guard was removed from this operation, so a collaborator of another company receives the podium instead of a refusal — the ranking listing beside it now answers on the same terms, while the ranking's single-record read still refuses. ERROR VARIANTS, IN EVALUATION ORDER: INVALID_COMPANY -> TOP_MEDALS_NOT_AVAILABLE, and that is the whole chain. THIS OPERATION RUNS NO COMPANY-LEVEL CHECK AT ALL: the RN-01 module gate was removed because the app already resolves is_module_active from the configuration query before opening the modal, so the podium never reads recognition_configuration_plan and publishes no MODULE_NOT_ACTIVE; the caller reconciliation is gone too, so neither CALLER_NOT_FOUND nor CALLER_COMPANY_MISMATCH. A company with recognition switched off answers its podium instead of a refusal. There is deliberately no INVALID_PAGE / INVALID_PAGE_SIZE (no pagination) and no date validation (no date input). */
  list_recognition_ranking_top_sent_medals_collaborator: TalentListRecognitionTopSentMedalsCollaboratorResponse;
  /** Collaborator 'mis canjes': the paginated history of the calling collaborator's OWN reward redemptions, newest first, scoped to their company (talent_company_id) and to themselves (talent_employee_id) — never the global company queue (RN-09 / U2). Returns EVERY lifecycle state (RN-10): each node's state is one of PENDING / APPROVED / REJECTED, with the DB DELIVERED mapped to APPROVED (D-01); soft-deleted / unknown rows are filtered out. Each node carries id, state, product (name, image, points), points and created_date. Read-only. An EMPTY page means the collaborator has not redeemed anything yet, not an error. */
  list_recognition_redemptions_collaborator: TalentListRecognitionRedemptionsCollaboratorResponse;
  /** Collaborator redemption vitrina (catalog): the paginated list of ACTIVE recognition products the calling collaborator can redeem, scoped to their company (RN: aislamiento por Razón Social). ACTIVE only (RN-05); a TANGIBLE product is hidden when it has no stock (RN-06) or when all its units are reserved by pending redemptions (RN-07); INTANGIBLE products are always shown (RN-08). Ordered by cost in points ascending (RN-14). has_stock is a boolean derived from stock — the raw count is never exposed (D-12). Read-only. An EMPTY page means the company has no redeemable product yet, not an error. */
  list_recognition_rewards_collaborator: TalentListRecognitionRewardsCollaboratorResponse;
  /** History of the recognitions input.talent_employee_id SENT inside input.talent_company_id ('Mis medallas' -> Enviadas), newest first. Every state travels by default (RN-003) — a send still waiting for approval is something the collaborator did — and input.filter.state_request_in narrows it to the states the chips asked for (RN-018). A FLAT listing of recognitionemployee rows: one row is one item, so a massive send to five people is five items, each with its OWN request_status — an admin resolves each receiver independently — and each naming the whole roster of its send in groups_info (RN-010), which the state filter never narrows. sender is always null: on this tab it is the collaborator in session. total_count counts ROWS after the filter — the number the state chips display (RN-019). Soft-deleted rows are never included (U4). An EMPTY page is a valid answer, not an error. */
  list_sent_medals_collaborator: TalentListSentMedalsCollaboratorResponse;
};


export type TalentRecognitionCollaboratorQueriesGet_Can_Send_Recognition_CollaboratorArgs = {
  input: TalentGetCanSendRecognitionCollaboratorInput;
};


export type TalentRecognitionCollaboratorQueriesGet_Recognition_Configuration_CollaboratorArgs = {
  input: TalentGetRecognitionConfigurationCollaboratorInput;
};


export type TalentRecognitionCollaboratorQueriesGet_Recognition_Detail_CollaboratorArgs = {
  input: TalentGetRecognitionDetailCollaboratorInput;
};


export type TalentRecognitionCollaboratorQueriesGet_Recognition_Post_Detail_CollaboratorArgs = {
  input: TalentGetRecognitionPostDetailCollaboratorInput;
};


export type TalentRecognitionCollaboratorQueriesGet_Recognition_Ranking_Receiver_CollaboratorArgs = {
  input: TalentGetRecognitionRankingReceiverCollaboratorInput;
};


export type TalentRecognitionCollaboratorQueriesGet_Recognition_Reaction_Details_CollaboratorArgs = {
  input: TalentGetRecognitionReactionDetailsCollaboratorInput;
};


export type TalentRecognitionCollaboratorQueriesGet_Recognition_Redemption_Balance_CollaboratorArgs = {
  input: TalentGetRecognitionRedemptionBalanceCollaboratorInput;
};


export type TalentRecognitionCollaboratorQueriesGet_Recognition_Reward_CollaboratorArgs = {
  input: TalentGetRecognitionRewardCollaboratorInput;
};


export type TalentRecognitionCollaboratorQueriesList_Available_Medals_To_Send_CollaboratorArgs = {
  input: TalentListAvailableMedalsToSendCollaboratorInput;
};


export type TalentRecognitionCollaboratorQueriesList_Company_Recognition_Feed_CollaboratorArgs = {
  input: TalentListCompanyRecognitionFeedCollaboratorInput;
};


export type TalentRecognitionCollaboratorQueriesList_Received_Medals_CollaboratorArgs = {
  input: TalentListReceivedMedalsCollaboratorInput;
};


export type TalentRecognitionCollaboratorQueriesList_Recognition_Comments_CollaboratorArgs = {
  input: TalentListRecognitionCommentsCollaboratorInput;
};


export type TalentRecognitionCollaboratorQueriesList_Recognition_Ranking_Receivers_CollaboratorArgs = {
  input: TalentListRecognitionRankingReceiversCollaboratorInput;
};


export type TalentRecognitionCollaboratorQueriesList_Recognition_Ranking_Top_Sent_Medals_CollaboratorArgs = {
  input: TalentListRecognitionTopSentMedalsCollaboratorInput;
};


export type TalentRecognitionCollaboratorQueriesList_Recognition_Redemptions_CollaboratorArgs = {
  input: TalentListRecognitionRedemptionsCollaboratorInput;
};


export type TalentRecognitionCollaboratorQueriesList_Recognition_Rewards_CollaboratorArgs = {
  input: TalentListRecognitionRewardsCollaboratorInput;
};


export type TalentRecognitionCollaboratorQueriesList_Sent_Medals_CollaboratorArgs = {
  input: TalentListSentMedalsCollaboratorInput;
};

export type TalentRecognitionComment = {
  __typename?: 'TalentRecognitionComment';
  /** recognition_comment.comment — the text the collaborator wrote, persisted TRIMMED of leading and trailing whitespace, which is also the string the RN-09 length check (3..500) measures. Never null: a row whose trimmed text is under 3 characters cannot exist, because the write refuses it before the insert. */
  comment: Scalars['String']['output'];
  /** recognition_comment.createddate — when the comment was written (the 'when' half of the U1 audit trail) and the ASC sort key of the thread. Stamped server-side; the client never sends it. NULLABLE, AND THE DDL IS WHY: the column is `timestamp NULL`, unlike innpulsa.recognition_reaction's equivalent, so a row with no date is a legal row of this table (a legacy comment written before the column was populated) and the client must render it without one. It is ALSO why the thread's order carries two keys — createddate ASC NULLS LAST, id ASC — so a dateless comment CLOSES its thread instead of landing in an undefined position. Legacy quirk NOT replicated: the as-is query selects lastupdateddate and maps it onto a field named createdDate, so there an edited comment reports its edit time as its creation time. */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** The collaborator who wrote it (recognition_comment.emisor_employee_id), as the platform's own employee node — the same person type the company wall, the post detail and the reactions serve, so one client fragment covers all of them. On a READ it is what `is_own_comment` used to say: the client compares this id with its own caller id. NULLABLE for ONE reason: the author no longer resolves to an employee2 row. There is no error code for it — the column is a NOT NULL FK — and a read that meets a dangling row nulls THIS SIDE and serves the comment, so the thread does not break. The flat placeholder person the legacy node invented for that case is deliberately gone: a fabricated name is worse than an explicit null, because the client cannot tell it from a real one. RN-12 applies to employee.avatar — the S3 URLs are known broken post-migration, so the client needs an onError fallback and not only a null check. */
  employee?: Maybe<TalentEmployee>;
  /** recognition_comment.id (PK), generated by the sequence recognition.seq_recognition_comment — and the id the reaction mutation needs to like this comment (RN-08). */
  id: Scalars['Int']['output'];
  /** recognition_comment.recognition_employee_id — FK to innpulsa.recognitionemployee, the post this comment hangs from. Echoed so the client can place the comment on the right feed card without refetching the whole feed. */
  recognition_employee_id: Scalars['Int']['output'];
};

export type TalentRecognitionCommentWithReactions = {
  __typename?: 'TalentRecognitionCommentWithReactions';
  /** The row of recognition_comment — columns and the author, nothing derived. Nullable for envelope symmetry with the other node wrappers of this schema; on every operation that serves this node it is present, since a node with no row would be a node with nothing in it. */
  comment?: Maybe<TalentRecognitionComment>;
  /** The ACTIVE reactions of THIS comment: innpulsa.recognition_reaction WHERE comment_id = recognition_comment.id AND dtype = 'COMMENT' AND the row is active, ordered by id ASC (insertion order, which is also reaction order), each row carrying the collaborator who left it. BOTH COLUMNS ARE IN THAT FILTER AND BOTH ARE NEEDED: the DDL makes recognition_id NOT NULL on a comment reaction too — it points at the POST the comment hangs off — so filtering by it alone would return the MEDAL reactions of the post as likes of this comment, and filtering by comment_id alone would be right only by luck. 'ACTIVE' is the module's active-row rule, both branches of it: deleteddate IS NULL AND (state IS NULL OR state = 'ACTIVE'), so a legacy row whose state was never written IS served and a row that still reads ACTIVE while carrying a delete instant is NOT. EMPTY, NEVER NULL, when nobody reacted or when every reaction was removed — the two look the same to a client on purpose (U4). THIS LIST IS WHAT REPLACED likes_count, has_own_like and own_reaction_id; the derivations are on the type's own docstring. */
  comment_reactions: Array<TalentRecognitionReaction>;
};

export type TalentRecognitionCommentsCollaboratorConnection = {
  __typename?: 'TalentRecognitionCommentsCollaboratorConnection';
  edges: Array<TalentRecognitionCommentsCollaboratorEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type TalentRecognitionCommentsCollaboratorEdge = {
  __typename?: 'TalentRecognitionCommentsCollaboratorEdge';
  /** Position of the comment in the FULL thread, base64-encoded the way every offset connection of this repo encodes it (`arrayconnection:<offset>`), so page 2 of page_size 8 starts at the encoding of 8. IT IS NOT A STABLE POINTER TO A ROW and a client must not page with it: it is derived from the position and nothing else, so a comment written while the client reads shifts every cursor after it by one — and on THIS operation the new comment is always APPENDED at the end, which is the one place where that shift is harmless. Paging is `pagination`, always. */
  cursor: Scalars['String']['output'];
  /** The comment at the end of the edge, with its reactions. */
  node: TalentRecognitionCommentWithReactions;
};

export type TalentRecognitionCompany = {
  __typename?: 'TalentRecognitionCompany';
  /** recognitioncompany.category — legacy values VALUES / COMPETENCES / GOALS / OTHERS. Kept as String because the column is a free-form varchar. */
  category?: Maybe<Scalars['String']['output']>;
  /** recognitioncompany.company_id — the RS that owns the medal (U2). */
  company_id: Scalars['Int']['output'];
  /** recognitioncompany.description. Also the labelmedalla template variable of the notification email. */
  description?: Maybe<Scalars['String']['output']>;
  /** recognitioncompany.icon — S3 asset. Known as-is issue: some pre-signed URLs do not resolve; the client degrades to a placeholder, never blocks. */
  icon: Scalars['String']['output'];
  /** recognitioncompany.id — the value the send mutation carries as medal_id (the legacy DTO called it recognitionCompanyId even though it holds the MEDAL id). */
  id: Scalars['Int']['output'];
  /** recognitioncompany.bolstate — whether the medal is active. The catalog only ever returns active medals (U4), so this is informational. */
  is_active?: Maybe<Scalars['Boolean']['output']>;
  /** recognitioncompany.leader — leader-exclusive medal. It is what the catalog's is_leader filter selects on; it is not a permission check. */
  is_leader?: Maybe<Scalars['Boolean']['output']>;
  /** The medal's level, joined through level_id. This is where the cost lives: level.points. */
  level?: Maybe<TalentRecognitionLevel>;
  /** recognitioncompany.level_id — FK to recognitionlevel. */
  level_id?: Maybe<Scalars['Int']['output']>;
  /** recognitioncompany.name — shown in the card. */
  name: Scalars['String']['output'];
};

export type TalentRecognitionCompanyDto = {
  __typename?: 'TalentRecognitionCompanyDTO';
  bol_state?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['Int']['output']>;
  created_date?: Maybe<Scalars['String']['output']>;
  deleted_date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  last_inactivated_date?: Maybe<Scalars['String']['output']>;
  last_updated_date?: Maybe<Scalars['String']['output']>;
  leader?: Maybe<Scalars['Boolean']['output']>;
  level_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  recognition_configuration_plan_id?: Maybe<Scalars['Int']['output']>;
  state: MedalState;
};

export type TalentRecognitionCompanyFilter = {
  /** Ids de las divisiones de las cuales pertenecen los empleados a los cuales se les va a asignar el reconocimiento */
  division_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Nombres de los cargos que tienen los empleados a los cuales se les va a asignar el reconocimiento */
  job_names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Ids del nivel de cargo que tienen los empleados a los cuales se les va a asignar el reconocimiento */
  level_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Ids de las sucursales de las cuales pertenecen los empleados a los cuales se les va a asignar el reconocimiento */
  subsidiary_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type TalentRecognitionCompanyInput = {
  /** Bolean el cual indica si se debe realizar la asignacion del reconocimiento teniendo en cuenta los filtros o no  */
  all_by_filter: Scalars['Boolean']['input'];
  /** Comentario de la medalla  */
  comment: Scalars['String']['input'];
  company_id: Scalars['Int']['input'];
  /** Ids del empleado al cual se le envia la medalla */
  employee_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Identificador de la medalla */
  medal_id: Scalars['Int']['input'];
  /** Id del empleado que asigna la medalla */
  sender_id: Scalars['Int']['input'];
};

export type TalentRecognitionCompanyMedals = {
  __typename?: 'TalentRecognitionCompanyMedals';
  /** The medal. */
  recognition_company?: Maybe<TalentRecognitionCompany>;
};

export type TalentRecognitionCompanyMedalsConnection = {
  __typename?: 'TalentRecognitionCompanyMedalsConnection';
  edges: Array<TalentRecognitionCompanyMedalsEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type TalentRecognitionCompanyMedalsEdge = {
  __typename?: 'TalentRecognitionCompanyMedalsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TalentRecognitionCompanyMedals;
};

export type TalentRecognitionCompanyMedalsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<TalentBasePaginationInput>;
  search?: InputMaybe<TalentRecognitionCompanyMedalsSearchInput>;
  status?: InputMaybe<TalentRecognitionCompanyMedalsStatusFilterEnum>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum TalentRecognitionCompanyMedalsSearchEnum {
  ModelMedalName = 'MODEL_MEDAL_NAME'
}

export type TalentRecognitionCompanyMedalsSearchInput = {
  fields: Array<TalentRecognitionCompanyMedalsSearchEnum>;
  query: Scalars['String']['input'];
};

export enum TalentRecognitionCompanyMedalsStatusFilterEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum TalentRecognitionCompanyModelFieldsEnum {
  ModelName = 'MODEL_NAME'
}

export type TalentRecognitionCompanyModelFilterInput = {
  date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  date_lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TalentRecognitionCompanyModelSearchInput = {
  fields: Array<TalentRecognitionCompanyModelFieldsEnum>;
  query: Scalars['String']['input'];
};

export enum TalentRecognitionCompanyModelSortOrderEnum {
  Quantity = 'QUANTITY'
}

export type TalentRecognitionCompanyModelSortOrderInput = {
  direction?: OrderDirectionEnum;
  field: TalentRecognitionCompanyModelSortOrderEnum;
};

export type TalentRecognitionConfiguration = PublicTalentRecognitionConfiguration & {
  __typename?: 'TalentRecognitionConfiguration';
  are_medals_approved?: Maybe<Scalars['Boolean']['output']>;
  can_boss_send_medal?: Maybe<Scalars['Boolean']['output']>;
  comment_label?: Maybe<Scalars['String']['output']>;
  company_id: Scalars['Int']['output'];
  /** Configured annual reset of the redemption points (RN-04). Origin: recognition_configuration_plan.force_init_date (1:1). YEAR-AGNOSTIC: only the month and the day are significant — the year carried here is NOT a floor, the server resolves the cycle in force against today. Applied INDEPENDENTLY of activate_limit, which caps SENDING and never the receiver's balance (PRD decision 4). null => full history (no reset). */
  force_init_date?: Maybe<Scalars['DateTime']['output']>;
  has_participant_management?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** recognition_configuration_plan.activate_elements_ranking — mapped 1:1, no derivation (RecognitionConfigurationPlanNormalized.is_elements_ranking_active, db_column 'activate_elements_ranking'). Enables the NUMERIC VALUE PER ROW — the points or the medal count printed next to each collaborator, whichever metric is_public_ranking_points_enabled selected — and the ACCESS TO THE FULL PAGINATED RANKING (the 'ver todos' entry point). It never changes the ordering nor the positions: the ranking arrives ALREADY ORDERED and the listing publishes no position, so the client derives it from the index of the page it received ((page - 1) * page_size + index + 1, RN-08), while the CALLER'S OWN position is served explicitly by get_recognition_ranking_receiver_collaborator in context.ranking_position, computed over the COMPLETE ordered set and not over a page. Either way 1-3 carry the gold / silver / bronze icon and 4 onwards their number (RN-08). Only meaningful while is_public_ranking_enabled is true: with the block hidden there is no row to put a number on. NULLABLE like the column: null MUST be read as 'numbers and full ranking disabled' — never as 'unknown, assume enabled'. [PENDIENTE DE CONFIRMACION CON TALENT] the exact degraded render when this flag is false while is_public_ranking_enabled is true — whether the podium card still paints names, avatars and the three podium icons with the numbers stripped, or the card is hidden too. The column mapping itself is verified; only that UI consequence is pending. */
  is_elements_ranking_active?: Maybe<Scalars['Boolean']['output']>;
  is_justification_active?: Maybe<Scalars['Boolean']['output']>;
  is_justification_required?: Maybe<Scalars['Boolean']['output']>;
  is_limit_active?: Maybe<Scalars['Boolean']['output']>;
  is_module_active?: Maybe<Scalars['Boolean']['output']>;
  is_public_awarded_message_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** recognition_configuration_plan.public_ranking — mapped 1:1, no derivation (RecognitionConfigurationPlanNormalized.is_public_ranking_enabled, db_column 'public_ranking'). MASTER SWITCH OF THE WHOLE RANKING BLOCK of the collaborator app: false = the ranking card is not rendered at all, and that includes THE CALLER'S OWN POSITION, because the own position lives inside the same block (RN-02) — there is no standalone 'mi posicion' widget that survives the card being hidden. It is NOT the module gate: is_module_active is what turns recognition off entirely (RN-01), and a company may perfectly run recognition with the ranking hidden. NULLABLE like the column: a plan row written before the column existed answers null, and a null MUST be read as 'ranking hidden' — never as 'unknown, assume visible'. Both surfaces that implement this interface expose the SAME column under the SAME public name — unlike option_comments, which the admin renames to allow_comments. */
  is_public_ranking_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** recognition_configuration_plan.public_ranking_points — mapped 1:1, no derivation (RecognitionConfigurationPlanNormalized.is_public_ranking_points_enabled, db_column 'public_ranking_points'). RN-02 OF THE PRD: this single flag decides AT THE SAME TIME the ORDER CRITERION and the VISIBLE METRIC of the ranking, and the two are never shown together. true = rows arrive ordered by POINTS, the header reads 'Top puntos' and the numeric column shows points. false = rows arrive ordered by MEDALS, the header reads 'Top medallas' and the column shows medals. THE SAME HEADER AND THE SAME METRIC APPLY TO THE FULL PAGINATED RANKING (RN-03), so a client reads this flag ONCE and uses it for the podium card and for the paginated listing alike; the ranking operation orders its rows by this very flag server-side, so a client must never re-sort the page it received. WHAT THIS FLAG DOES NOT TOUCH: the window, which is ALWAYS the calendar quarter the read falls in, resolved server-side in the platform time zone (RN-04 — not a rolling three months, not user-configurable, not an input, and reboot_day does not shorten it, RN-05); and the side, which is ALWAYS recognitions RECEIVED, since v1 has no ranking of sent ones (RN-07). NULLABLE like the column: null MUST be read as false, i.e. the MEDALS branch ('Top medallas'), which is the legacy default — never as 'unknown, assume points'. */
  is_public_ranking_points_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Master switch for the redemption module. Maps the legacy numeric config 233 (ACTIVATE_RECOGNITION_REDEMPTION). DERIVED: NOT a column of recognition_configuration_plan — it comes from the numeric-config store (company_has_configuration(companyId, 233), D-06). The redemption double gate is is_module_active && is_redemption_active (RN-01). */
  is_redemption_active?: Maybe<Scalars['Boolean']['output']>;
  max_points_per_send?: Maybe<Scalars['Int']['output']>;
  medal_recognition_label?: Maybe<Scalars['String']['output']>;
  module_recognition_label?: Maybe<Scalars['String']['output']>;
  /** recognition_configuration_plan.optioncomments — mapped 1:1, no derivation, and the field is NAMED AFTER THE COLUMN ( dev decision, CAC-1873 STOP 1: 'G-03 deja el equivalente de la base de datos'). Master switch of the comment box on the recognition DETAIL screen (RN-10): true = the collaborator may write comments on a recognition, false = the box is not rendered even though comment_label still carries its label. It does NOT gate the feed listing (RN-02 / RN-03 and the visibility rule decide which cards travel) and it does NOT gate reactions. NULLABLE like the column: a plan row written before the column existed answers null, and a null MUST be read as 'commenting disabled' — never as 'unknown, assume enabled'. The ADMIN surface exposes the SAME column under a DIFFERENT public name (PrivateTalentRecognitionConfiguration.allow_comments); that divergence is deliberate — admin says allow_comments, collaborator says option_comments, one column underneath. */
  option_comments?: Maybe<Scalars['Boolean']['output']>;
  reboot_day?: Maybe<Scalars['Int']['output']>;
};

export type TalentRecognitionConfigurationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentRecognitionConfigurationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentGetRecognitionConfigurationPayload | ValidationErrorV2;

export type TalentRecognitionDivisionModelFilterInput = {
  date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  date_lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum TalentRecognitionDivisionModelTopMedalsSearchEnum {
  ModelName = 'MODEL_NAME'
}

export type TalentRecognitionDivisionModelTopMedalsSearchInput = {
  fields: Array<TalentRecognitionDivisionModelTopMedalsSearchEnum>;
  query: Scalars['String']['input'];
};

export enum TalentRecognitionDivisionModelTopMedalsSortEnum {
  Points = 'POINTS',
  QuantityMedals = 'QUANTITY_MEDALS'
}

export type TalentRecognitionDivisionModelTopMedalsSortOrderInput = {
  direction?: OrderDirectionEnum;
  field: TalentRecognitionDivisionModelTopMedalsSortEnum;
};

export type TalentRecognitionEmployee = {
  __typename?: 'TalentRecognitionEmployee';
  /** recognitionemployee.commentrequest — the ADMIN's own comment when approving or rejecting the recognition (RN-08 / RN-11), NOT the sender's message (that is ``message``, mapped from feedback). Travels ONLY when request_status is REJECTED, where it is the reason the medal did not go through; null in every other state. Always null on a row this mutation just created: nobody has reviewed it yet. Always null on the 'Recibidas' side too — those rows are APPROVED by construction (RN-002) and a rejected recognition never reaches its receiver (RN-008). */
  comment_request?: Maybe<Scalars['String']['output']>;
  /** recognitionemployee.employee_id — the RECEIVER of the recognition (FK to employee2). One row per receiver, so a batch of N returns N nodes (RN-17). */
  employee_id: Scalars['Int']['output'];
  /** recognitionemployee.groups — shared batch id. Null for a single-receiver send; the same value for every row of a batch (RN-17). */
  group_id?: Maybe<Scalars['Int']['output']>;
  /** Every employee who received this recognition as part of the same mass/batch send — the rows ONE SENDER wrote with the same recognitionemployee.groups value (RN-010), this row's own receiver INCLUDED. Null (never an empty list) when the recognition was not part of a batch, so the client never has to tell 'no group' from 'group of zero'. Same roster whichever row of the group is being read. */
  groups_info?: Maybe<Array<TalentEmployee>>;
  /** recognitionemployee.id (PK), as Int! — the type of the column and the type this node has shipped with since CAC-1831 (✏️ dev decision, 2026-08-11: an intermediate revision typed it ID!, which would have forced an FE codegen change for no gain). */
  id: Scalars['Int']['output'];
  /** recognitionemployee.sended_from_admin — true when an administrator granted the medal on behalf of the company (RN-09 of CAC-1872). Always false for a row created here: this mutation is the COLLABORATOR send, and the flag is also what keeps admin-granted medals out of the collaborator budget (RN-07). Defaults to false because the legacy column is nullable and a NULL there means 'not from admin', the same reading the budget query applies. */
  is_from_admin: Scalars['Boolean']['output'];
  /** recognitionemployee.public_medal — the value actually PERSISTED after applying the RN-12 gate, which may be false even when the client sent true. */
  is_public_medal?: Maybe<Scalars['Boolean']['output']>;
  /** recognitionemployee.learning_file_id — the file-service id persisted with the recognition. Null for a send that carried no photo or that used the deprecated recognition_file reference; use it to tell the two attachment flows apart, and recognition_file to render the photo. */
  learning_file_id?: Maybe<Scalars['Int']['output']>;
  /** recognitionemployee.feedback — the dedication the SENDER wrote with the recognition, echoed back as it was persisted. This is the column the message belongs in: an earlier version of this flow wrote it to commentrequest instead, replicating as-is quirk Q-07 of the legacy Angular app rather than correcting it (fixed at STOP 1 of CAC-1872). Null when the company does not ask for a message (RN-11). */
  message?: Maybe<Scalars['String']['output']>;
  /** The receiver of THIS row (recognitionemployee.employee_id), as the platform's own employee node — one row is one receiver (RN-17), so a batch is N nodes and never a list here: on list_sent_medals_collaborator this is where the card reads who each avatar is. Null only on a read that trims the relation off — the medal wall (list_received_medals_collaborator) is exactly that case, because there the receiver is the collaborator in session. */
  receiver?: Maybe<TalentEmployee>;
  /** The medal, joined through recognitioncompany_id — the same base type the catalog returns, so its level.points is the cost that was charged (RN-06 / RN-23). */
  recognition_company?: Maybe<TalentRecognitionCompany>;
  /** recognitionemployee.recognitioncompany_id — the MEDAL id despite the column name, the same value the mutation received as medal_id. */
  recognition_company_id: Scalars['Int']['output'];
  /** The attachment of the recognition, RESOLVED (v3, RN-13). When the send carried a learning_file_id this is the file-service download URL built from it; otherwise it is the legacy recognitionemployee.filerecognition reference as stored. Null when the send had no photo. */
  recognition_file?: Maybe<Scalars['String']['output']>;
  /** recognitionemployee.daterequest — request timestamp (U1 audit). Set to the same instant as sent_at, as the legacy client did. */
  request_date?: Maybe<Scalars['DateTime']['output']>;
  /** recognitionemployee.staterequest, DERIVED server-side on create (RN-09): PENDING when the company reviews medals, APPROVED otherwise. Both states consume budget (RN-10); only an admin rejection moves it to REJECTED. The client never sets this value. MANDATORY (non-null): the legacy column allows NULL, but the dev confirmed the DB always generates a value for every row this flow can read — from_entity raises rather than silently defaulting if that invariant is ever violated. Named after the entity/column pair it maps (✏️ dev decision, 2026-08-11 — it shipped as state_request in an intermediate revision) and never to be confused with recognitionemployee.state, a DIFFERENT column (ACTIVE/INACTIVE soft delete, U4) that is never exposed and is enforced server-side as a row filter. */
  request_status: TalentRecognitionRequestStateEnum;
  /** Who sent the recognition (recognitionemployee.sender_id), as the platform's own employee node. Null when is_from_admin is true (RN-009 of CAC-1872): the COMPANY granted the medal, not a person, and the admin's identity is deliberately not surfaced even though sender_id is still populated. Null as well on a read that trims the relation off — which is every row of list_sent_medals_collaborator, where the sender is the collaborator in session (U2). */
  sender?: Maybe<TalentEmployee>;
  /** recognitionemployee.sender_id — always the authenticated sender (input.talent_employee_id), echoed back for audit traceability (U1). */
  sender_id: Scalars['Int']['output'];
  /** recognitionemployee.senddate — send timestamp (U1 audit). */
  sent_at?: Maybe<Scalars['DateTime']['output']>;
};

export type TalentRecognitionEmployeeCallerContext = {
  __typename?: 'TalentRecognitionEmployeeCallerContext';
  /** The reaction of the COLLABORATOR IN SESSION over this recognition — their ACTIVE row of recognition_reaction with dtype = 'MEDAL'. NULL when they have not reacted, and equally null once they delete their reaction: the soft-deleted row is not live, so it is not this one, and the two are the same thing to a client on purpose — there is no 'you reacted and removed it' state to paint. MEDAL ONLY: a like the caller left on a COMMENT of this card travels with the thread, not here. IT IS THE HANDLE OF THE NEXT WRITE, and that is the point of serving it: the client reads it and picks the branch of the reaction mutation — no row means CREATE, a different reaction_type means UPDATE this id, the same reaction_type means DELETE this id. The server no longer makes that decision, so a client that does not read this field can only ever create. */
  reaction?: Maybe<TalentRecognitionReaction>;
};

export type TalentRecognitionEmployeeModelFilterInput = {
  field: TalentRecognitionApplicationsMedalsFilterEnum;
  month?: MonthsEnum;
};

export type TalentRecognitionEmployeeModelRangeDateFilterInput = {
  field: TalentRecognitionApplicationsMedalsFilterEnum;
  gte: Scalars['DateTime']['input'];
  lte: Scalars['DateTime']['input'];
};

export enum TalentRecognitionEmployeeModelTopMedalsSearchEnum {
  ModelPersonName = 'MODEL_PERSON_NAME'
}

export type TalentRecognitionEmployeeModelTopMedalsSearchInput = {
  fields: Array<TalentRecognitionEmployeeModelTopMedalsSearchEnum>;
  query: Scalars['String']['input'];
};

export enum TalentRecognitionEmployeeModelTopMedalsSortEnum {
  Points = 'POINTS',
  QuantityMedals = 'QUANTITY_MEDALS'
}

export type TalentRecognitionEmployeeModelTopMedalsSortOrderInput = {
  direction?: OrderDirectionEnum;
  field: TalentRecognitionEmployeeModelTopMedalsSortEnum;
};

export type TalentRecognitionEmployeeReactionsStatistics = {
  __typename?: 'TalentRecognitionEmployeeReactionsStatistics';
  /** COUNT of the ACTIVE rows of recognition_comment over this recognition. It can never disagree with the thread the card opens: the listing of comments keeps the same rows under the same rule, so the number on the card and the number of comments served are one query written twice, never two numbers. */
  total_comments: Scalars['Int']['output'];
  /** Same formula as total_like with recognition_type_id = 3 (INTERESTING). */
  total_interesting: Scalars['Int']['output'];
  /** COUNT of the ACTIVE rows of recognition_reaction over this recognition with dtype = 'MEDAL' and recognition_type_id = 1 (LIKE). dtype is what keeps comment likes out of this number: a reaction to a COMMENT carries the SAME recognition_id, so a counter filtered by the recognition alone would add the likes of the thread to the reactions of the card. */
  total_like: Scalars['Int']['output'];
  /** Same formula as total_like with recognition_type_id = 2 (LOVE). */
  total_love: Scalars['Int']['output'];
};

export enum TalentRecognitionFeedEqEnum {
  /** EMPRESA — the corporate sends (recognitionemployee.sended_from_admin), and only the PUBLIC ones. This is the institutional wall: no private row is ever listed here, not even to the collaborator who received it, which makes it the one segment a client may cache per company instead of per caller. */
  Company = 'COMPANY',
  /** RECIBIDOS — the recognitions addressed TO the collaborator in session (recognitionemployee.employee_id), THEIR PRIVATE ONES INCLUDED: visibility is not consulted at all on this segment, because a recognition you received is yours to read whatever its public_medal says. Receiver side ONLY — sending a medal is not receiving one — so a collaborator who has only sent recognitions reads an empty feed, which is a valid answer. */
  Employee = 'EMPLOYEE'
}

export type TalentRecognitionLevel = {
  __typename?: 'TalentRecognitionLevel';
  /** recognitionlevel.id */
  id: Scalars['Int']['output'];
  /** recognitionlevel.name — 'Oro' / 'Plata' / 'Bronce' by default, or whatever the company renamed its levels to. Raw value: it is not normalized to an enum, so a renamed level still renders. */
  name?: Maybe<Scalars['String']['output']>;
  /** recognitionlevel.points — the cost of sending a medal of this level (RN-23) and the number the budget rules charge (RN-06 / RN-07). SINGLE source of the cost: never derive it from the configuration plan's per-level columns. */
  points: Scalars['Int']['output'];
};

/** Input de list_recognition_non_participants_admin y de list_recognition_participants_admin: ambas listan colaboradores ACTIVOS de la empresa del admin con búsqueda, filtros y paginación server-side, y se diferencian sólo en el lado de la lista de envío que devuelven. El plan de configuración NO viaja en el input: se resuelve de la empresa (RN-14). */
export type TalentRecognitionListParticipantsAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Filtros por división, cargo, nivel y sucursal. */
  filters?: InputMaybe<TalentRecognitionParticipantsFiltersInput>;
  /** Paginación server-side. Por defecto page=1, page_size=8. */
  pagination?: InputMaybe<TalentBasePaginationInput>;
  /** Búsqueda por colaborador; vacía devuelve la lista completa. */
  search?: InputMaybe<TalentRecognitionParticipantsSearchInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentRecognitionListParticipantsAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentRecognitionParticipantConnection | ValidationErrorV2;

export enum TalentRecognitionMedalCategoryEnum {
  CompetencesCategory = 'COMPETENCES_CATEGORY',
  GoalsCategory = 'GOALS_CATEGORY',
  OthersCategory = 'OTHERS_CATEGORY',
  ValuesCategory = 'VALUES_CATEGORY'
}

export type TalentRecognitionMedalInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  recognition_company_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum TalentRecognitionMedalLevelEnum {
  Bronze = 'BRONZE',
  Gold = 'GOLD',
  Silver = 'SILVER'
}

export type TalentRecognitionMedalResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentGetRecognitionMedalPayload | ValidationErrorV2;

/**
 * Mutation para realizar la asignacion de reconocimientos masiva, recibe como parametro el talentRecognitionCompanyInput
 * en el cual se encuentran los datos necesarios para asignar reconocimientos y talentRecognitionCompanyFilter el cual contiene
 * los filtros para realizar la busqueda de los empleados a los cuales se les va a asignar el reconocimiento
 */
export type TalentRecognitionMutation = {
  __typename?: 'TalentRecognitionMutation';
  /** Deprecated */
  save_talent_recognition_employees?: Maybe<ResponseExecutionTalentRecognition>;
  save_talent_recognition_employees_by_filters?: Maybe<TalentRecognitionResponseExecution>;
};


/**
 * Mutation para realizar la asignacion de reconocimientos masiva, recibe como parametro el talentRecognitionCompanyInput
 * en el cual se encuentran los datos necesarios para asignar reconocimientos y talentRecognitionCompanyFilter el cual contiene
 * los filtros para realizar la busqueda de los empleados a los cuales se les va a asignar el reconocimiento
 */
export type TalentRecognitionMutationSave_Talent_Recognition_EmployeesArgs = {
  comment: Scalars['String']['input'];
  employee_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  medal_id: Scalars['Int']['input'];
  sender_id: Scalars['Int']['input'];
};


/**
 * Mutation para realizar la asignacion de reconocimientos masiva, recibe como parametro el talentRecognitionCompanyInput
 * en el cual se encuentran los datos necesarios para asignar reconocimientos y talentRecognitionCompanyFilter el cual contiene
 * los filtros para realizar la busqueda de los empleados a los cuales se les va a asignar el reconocimiento
 */
export type TalentRecognitionMutationSave_Talent_Recognition_Employees_By_FiltersArgs = {
  talentRecognitionCompanyFilter?: InputMaybe<TalentRecognitionCompanyFilter>;
  talentRecognitionCompanyInput: TalentRecognitionCompanyInput;
};

export type TalentRecognitionMutations = {
  __typename?: 'TalentRecognitionMutations';
  talent_recognition_administrator: TalentRecognitionAdministratorMutations;
  /** Collaborator (sender) recognition mutations. */
  talent_recognition_collaborator: TalentRecognitionCollaboratorMutations;
};

/** Campos por los que el selector de colaboradores puede buscar. La búsqueda es insensible a mayúsculas y acentos, y hace OR entre los campos pedidos. */
export enum TalentRecognitionParticipantsFieldsEnum {
  EmployeeDocument = 'EMPLOYEE_DOCUMENT',
  EmployeeEmail = 'EMPLOYEE_EMAIL',
  EmployeeLastName = 'EMPLOYEE_LAST_NAME',
  EmployeeName = 'EMPLOYEE_NAME'
}

/** Filtros del selector de colaboradores, los mismos del listado de colaboradores de la empresa. Cada uno acepta múltiples ids y se combinan en AND entre sí. */
export type TalentRecognitionParticipantsFiltersInput = {
  /** Ids de nivel/categoría (company_level.id). */
  company_level_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Ids de división (division.id). */
  division_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Ids de cargo (job.id). */
  job_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Ids de sucursal (subsidiary.id). */
  subsidiary_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Búsqueda de colaboradores del selector: query es el término e insensible a mayúsculas y acentos; fields son los campos en los que se busca (OR entre ellos). */
export type TalentRecognitionParticipantsSearchInput = {
  /** Campos de búsqueda; el selector busca por nombre en la UI. */
  fields: Array<TalentRecognitionParticipantsFieldsEnum>;
  query: Scalars['String']['input'];
};

export type TalentRecognitionPayload = {
  __typename?: 'TalentRecognitionPayload';
  executed?: Maybe<Scalars['Boolean']['output']>;
};

export type TalentRecognitionProduct = PublicTalentRecognitionProduct & {
  __typename?: 'TalentRecognitionProduct';
  /** recognition_product.description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the product is available to redeem — derived from stock, NOT the raw count (D-12). Always true for INTANGIBLE; for TANGIBLE, true iff units remain and are not all reserved by pending redemptions (RN-06 / RN-07). */
  has_stock?: Maybe<Scalars['Boolean']['output']>;
  /** recognition_product.id — primary key of the catalog product. */
  id: Scalars['ID']['output'];
  /** recognition_product.image — S3 URL. */
  image?: Maybe<Scalars['String']['output']>;
  /** recognition_product.name. */
  name?: Maybe<Scalars['String']['output']>;
  /** recognition_product.points — cost of the reward in recognition points, normalized to Int. */
  points: Scalars['Int']['output'];
  /** recognition_product.state — lifecycle state. */
  state?: Maybe<TalentRecognitionProductStateEnum>;
  /** recognition_product.type mapped to the TalentRecognitionProductType enum (DIGITAL / EXPERIENCIA collapse to INTANGIBLE). Collaborator-only — not on the shared interface. */
  type?: Maybe<TalentRecognitionProductType>;
};

export enum TalentRecognitionProductStateEnum {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export enum TalentRecognitionProductType {
  Intangible = 'INTANGIBLE',
  Tangible = 'TANGIBLE'
}

export type TalentRecognitionQueries = {
  __typename?: 'TalentRecognitionQueries';
  talent_recognition_administrator: TalentRecognitionAdministratorQueries;
  /** Collaborator (sender) recognition queries. */
  talent_recognition_collaborator: TalentRecognitionCollaboratorQueries;
};

/** Query para obtener las medallas por compañia, recibe como parametro el companyId */
export type TalentRecognitionQuery = {
  __typename?: 'TalentRecognitionQuery';
  get_talent_recognition_medals_by_company?: Maybe<Array<Maybe<TalentRecognitionCompanyDto>>>;
};


/** Query para obtener las medallas por compañia, recibe como parametro el companyId */
export type TalentRecognitionQueryGet_Talent_Recognition_Medals_By_CompanyArgs = {
  company_id?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<MedalState>;
};

export type TalentRecognitionRankingReceiver = {
  __typename?: 'TalentRecognitionRankingReceiver';
  /** WHERE THIS ROW STANDS in the company ranking of the current calendar quarter — today, only ranking_position. It travels on every row of the listing and on the single-record read, same type and same number for the same person. Despite the name it is NOT caller-dependent on the listing: it is a property of the ROW, so a page stays cacheable per company. */
  context: TalentRecognitionRankingReceiverCallerContext;
  /** The RECEIVER, resolved from innpulsa.employee2 into the canonical TalentEmployee — the same person node the company wall, the post detail and the reactions serve, so one client fragment covers all of them. What the ranking card paints: person.name / person.last_name, job.name and avatar. TWO PRODUCTION STATES TO HANDLE: avatar is null for a receiver whose migrated URL did not survive (fall back to the default avatar, with an onError fallback too), and job is null for a receiver with no hcm.jobrole row. THE job NULL IS AN INTENTIONAL DIVERGENCE FROM THE LEGACY: the legacy SQL INNER JOINed jobrole, so an employee with no cargo row disappeared from the ranking entirely; this reconstruction keeps them ranked with job null. A parity diff against the legacy screen will therefore show EXTRA ROWS — one per employee without cargo — and every ranking_position after each of them will differ by one, as will total_count. That is the contract working, not a bug. */
  employee: TalentEmployee;
  /** The receiver's two numbers over the current calendar quarter: total_points and total_medals. Both always travel, whichever one order_criterion selects, so the client switches metric without a second read. NO POSITION RIDES HERE — it is context.ranking_position of this same node, deliberately outside the aggregates. */
  statistics: TalentRecognitionRankingReceiverStatistics;
};

export type TalentRecognitionRankingReceiverCallerContext = {
  __typename?: 'TalentRecognitionRankingReceiverCallerContext';
  /** The 1-BASED position of this row in the company ranking of the CURRENT CALENDAR QUARTER. DERIVED, never stored: the RowNumber a window function assigns over the COMPLETE ordered set of the company — not over a page and not over any subset — which is why it is identical whatever page_size the client asks for, and why the two operations of the epic answer the same number for the same person by construction. THE ORDER IT NUMBERS IS THE LISTING'S ORDER: order_criterion DESC (RN-02), then the OTHER metric DESC, then employee2.id ASC. TIES DO NOT SHARE A POSITION — it is a RowNumber and not a Rank, so two receivers level on both metrics get CONSECUTIVE numbers, never the same one, and there are no gaps. ON THE LISTING IT IS REDUNDANT WITH THE INDEX OF THE EDGE, ON PURPOSE, and that redundancy is an invariant a client can assert: ranking_position == (page - 1) * page_size + index + 1 on every page. A mismatch means the server has TWO orderings of one set and is a server defect to report, not an ambiguity to resolve by picking a favourite number. 1 / 2 / 3 carry the gold / silver / bronze icon and 4 onwards print the plain number (RN-08). The upper bound is the listing's total_count, which the single-record read does not publish. IT MOVES WITHOUT THIS RECEIVER DOING ANYTHING: a medal handed to a colleague changes it while leaving employee and statistics untouched. */
  ranking_position: Scalars['Int']['output'];
};

export type TalentRecognitionRankingReceiverEdge = {
  __typename?: 'TalentRecognitionRankingReceiverEdge';
  /** AN OPAQUE PAGING TOKEN, base64 of 'arrayconnection:<n>' like every offset connection of this repo, encoding the row's position in the filtered result set. NOT A STABLE POINTER TO A ROW — a delivery approved while the client pages reshuffles everything after it — and NOT THE POSITION: the client must not decode it, for a position or for anything else. Since the position is a field (node.context.ranking_position) there is no motive left to try. Paging is `pagination`, always. */
  cursor: Scalars['String']['output'];
  /** The ranked receiver at the end of the edge — THE SAME TYPE the single-record sibling returns bare, with the same three fields, so this row carries its own ranking_position. */
  node: TalentRecognitionRankingReceiver;
};

export type TalentRecognitionRankingReceiverStatistics = {
  __typename?: 'TalentRecognitionRankingReceiverStatistics';
  /** COUNT of the deliveries this collaborator RECEIVED inside the current calendar quarter (RN-07 — received, never sent), counting only APPROVED deliveries that are not soft-deleted, of ACTIVE medals, to an ACTIVE employee (U4). senddate is nullable and a dated-null delivery is counted by nothing. It is the ORDER KEY when order_criterion is MEDALS and the TIE-BREAK when it is POINTS. Always >= 1: a receiver with zero is simply not a row. */
  total_medals: Scalars['Int']['output'];
  /** SUM of recognitionlevel.points over exactly the deliveries total_medals counts, joined recognitionemployee.recognition_id -> recognitioncompany -> recognitionlevel. DERIVED, never stored on the delivery: re-pricing a level moves this number and the ordering with it. It is the ORDER KEY when metadata.data.order_criterion is POINTS and the TIE-BREAK when it is MEDALS. A medal with no level contributes 0 — the column is declared non-null but the table is legacy and unmanaged, and a level-less medal would otherwise make the SUM null. */
  total_points: Scalars['Int']['output'];
};

export type TalentRecognitionRankingReceiversCollaboratorConnection = {
  __typename?: 'TalentRecognitionRankingReceiversCollaboratorConnection';
  edges: Array<TalentRecognitionRankingReceiverEdge>;
  metadata: TalentMetadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type TalentRecognitionReaction = {
  __typename?: 'TalentRecognitionReaction';
  /** recognition_reaction.comment_id — FK to recognition_comment.id. NULL for post reactions (target MEDAL); set only on the COMMENT subtype. */
  comment_id?: Maybe<Scalars['Int']['output']>;
  /** recognition_reaction.createddate — when the reaction was FIRST left (U1 'when'), never the instant of the last write: a row whose type was changed keeps the timestamp it already had. The last-update timestamp is deliberately not exposed — it moves on every write and no screen reads it. */
  created_date?: Maybe<Scalars['DateTime']['output']>;
  /** recognition_reaction.emisor_employee_id resolved as the platform's own employee node: the collaborator who reacted, with their person, job, division and avatar. The same person type the comment author and both sides of a wall card are served as, so one client fragment covers all of them. It is the RESOLVED PROJECTION of employee_id, which stays on the row — two projections of ONE column, never two sources, so they cannot disagree. SERVED ONLY BY THE READS THAT SHOW EVERY REACTOR — the post detail (get_recognition_post_detail_collaborator), on the reactions of the post and on the likes of each comment. It is NULL on the company wall's context.reaction, and not because the person is unknown: there the reaction is the CALLER's own by construction, so resolving employee2 once per card would buy a name the app already holds. DERIVATION THE CLIENT NEEDS: in a list of reactions, the caller's own is the entry whose employee.id equals their talent_employee_id, and that entry's id is the row the reaction mutation updates or deletes. Null ALSO when the reactor no longer resolves to an employee2 row (they left the directory): the reaction still counts and still travels, and only this side goes null — a fabricated placeholder person would be worse, because the client could not tell it from a real one. */
  employee?: Maybe<TalentEmployee>;
  /** recognition_reaction.emisor_employee_id — the collaborator who reacted (U1 'who'). On the wall's context.reaction it is always the caller: nobody's reaction but their own is served there. */
  employee_id: Scalars['Int']['output'];
  /** recognition_reaction.id — AND THE ARGUMENT OF THE NEXT WRITE. A client that holds this id can change the row's type or soft-delete it; one that does not hold one can only create. STABLE ACROSS AN UPDATE (swapping the type keeps the row and the id) and NOT a handle across a delete: the row goes INACTIVE, stops being served, and the id must be dropped from the client's state. */
  id: Scalars['Int']['output'];
  /** recognition_reaction.recognition_type_id resolved into the enum (1 LIKE / 2 LOVE / 3 INTERESTING) — WHICH reaction this row is. It is the member that makes the wall's context.reaction enough to paint a card: the client knows it reacted (the row is there), with what (this field) and which row to address next (the id). MANDATORY, and safe to be: every read of this epic filters the table down to the three declared types, so a legacy row pointing at a catalog id nobody declared is not served at all rather than projected with a guessed type — which is the legacy quirk (reading a four-row table by list position) this rebuild does not inherit. */
  reaction_type: TalentRecognitionReactionTypeEnum;
  /** recognition_reaction.recognition_id — FK to recognitionemployee.id, the post being reacted to. Always present, also on comment reactions, so the client can locate the card in its cache. */
  recognition_employee_id: Scalars['Int']['output'];
  /** recognition_reaction.state. ALWAYS ACTIVE on a served row, and that is a property of the READ and not a copy of the column: a reaction is only ever served while it is live (deleteddate IS NULL and the state is ACTIVE or NULL), and a deleted one stops being served instead of travelling as INACTIVE — the caller's own reaction goes null and the counters drop by one. A NULL column on a live legacy row therefore reads ACTIVE here, which is what it means. Exposed to keep the state machine explicit in the contract, never to be branched on. */
  state: TalentRecognitionReactionStateEnum;
  /** recognition_reaction.dtype — MEDAL for the post, COMMENT for one of its comments. MANDATORY, and safe to be for the same reason as reaction_type: every read of this epic filters by this column, so a legacy row with no dtype is not served rather than served with an unknown target. */
  target: TalentRecognitionReactionTargetEnum;
};

export type TalentRecognitionReactionDetailsFilterInput = {
  /** The reaction type whose reactors are listed. DEFAULTS TO LOVE when the whole filter is null or this member is null (✏️ dev decision, CAC-1873 STOP 1). The default is deliberately NOT the first value of the enum and NOT the most used reaction, so it is exactly the kind of default a later reader 'corrects' by accident: it is written down here, in the constant the DTO applies and in the contract. It is also NOT 'everything' — this operation always answers ONE type, and the three numbers the tab headers need ride in metadata.data, unfiltered and unpaged. There is no invalid value to guard against: the schema refuses anything outside LIKE / LOVE / INTERESTING before the resolver runs, which is why the epic's old UNKNOWN_REACTION_TYPE code no longer exists — it validated a type against a per-company catalog the database does not have. A type nobody used on this post is a VALID answer, not an error: edges [] with total_count 0, while metadata.data still reports the real counters of the other two tabs. */
  reaction_type_eq?: InputMaybe<TalentRecognitionReactionTypeEnum>;
};

export enum TalentRecognitionReactionStateEnum {
  /** The reaction is live and is the one that counts towards the card's counters. */
  Active = 'ACTIVE',
  /** The collaborator deleted the reaction: the row stays in the table with a deleteddate stamped on it and is excluded from every counter. Never returned by a read — the value is declared so the state machine is explicit. */
  Inactive = 'INACTIVE'
}

export enum TalentRecognitionReactionTargetEnum {
  /** dtype = 'COMMENT' — a like on one comment of the recognition (comment_id points at recognition_comment.id). */
  Comment = 'COMMENT',
  /** dtype = 'MEDAL' — a reaction to the recognition post itself (comment_id is NULL). */
  Medal = 'MEDAL'
}

export enum TalentRecognitionReactionTypeEnum {
  /** recognition_reaction_type id 3 — 'Me interesa'. Post reactions only. */
  Interesting = 'INTERESTING',
  /** recognition_reaction_type id 1 — 'Me gusta'. The only type a COMMENT accepts. */
  Like = 'LIKE',
  /** recognition_reaction_type id 2 — 'Me encanta'. Post reactions only. */
  Love = 'LOVE'
}

export type TalentRecognitionRedemption = PublicTalentRecognitionRedemption & {
  __typename?: 'TalentRecognitionRedemption';
  /** recognition_redemption.created_date — when the collaborator submitted the redemption. */
  created_date?: Maybe<Scalars['DateTime']['output']>;
  /** recognition_redemption.employee_id — FK to the collaborator who redeemed. Raw DB reference (dev decision, STOP 1): the collaborator surface exposes the id, NOT the full employee object the admin type carries. */
  employee_id?: Maybe<Scalars['Int']['output']>;
  /** recognition_redemption.id — surrogate PK of the redemption row. */
  id: Scalars['Int']['output'];
  /** recognition_redemption.points — points charged for this redemption (snapshot of the reward cost at redemption time). */
  points: Scalars['Int']['output'];
  /** The redeemed product, resolved via recognition_redemption.recognitionproduct_id -> recognition_product. Shared TalentRecognitionProduct (owned by list-rewards). */
  product?: Maybe<TalentRecognitionProduct>;
  /** recognition_redemption.state, mapped DELIVERED -> APPROVED (D-01). Non-null: every redemption that travels has a state (soft-deleted / unknown rows are filtered out of the read). */
  state: TalentRecognitionRedemptionStateEnum;
};

export type TalentRecognitionRedemptionBalanceStatistics = {
  __typename?: 'TalentRecognitionRedemptionBalanceStatistics';
  /** Sum of the level points over the medals the collaborator received with staterequest=APPROVED (via recognitionemployee -> recognition medal level). Window: the cycle in force of the annual reset — the configured month/day resolved against today, never the stored year (RN-04). */
  total_points: Scalars['Int']['output'];
  /** max(0, total_points - total_points_redeemed) (RN-02). Never negative. */
  total_points_available: Scalars['Int']['output'];
  /** Sum of recognition_redemption.points of the collaborator whose state is PENDING or DELIVERED (exposed as APPROVED). REJECTED ones are EXCLUDED — their points are restored (RN-02 / RN-10 / D-05). */
  total_points_redeemed: Scalars['Int']['output'];
};

export enum TalentRecognitionRedemptionStateEnum {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type TalentRecognitionRedemptionsCollaboratorConnection = {
  __typename?: 'TalentRecognitionRedemptionsCollaboratorConnection';
  edges: Array<TalentRecognitionRedemptionsCollaboratorEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type TalentRecognitionRedemptionsCollaboratorEdge = {
  __typename?: 'TalentRecognitionRedemptionsCollaboratorEdge';
  /** Opaque pagination cursor. */
  cursor: Scalars['String']['output'];
  /** One redemption of the calling collaborator at this position. */
  node: TalentRecognitionRedemption;
};

/** Input de remove_recognition_participants_admin: quita colaboradores de la lista de envío por BAJA LÓGICA (state=INACTIVE + lastinactivateddate, RN-12); nunca se borra la fila. Quitar dos veces es no-op. select_all=true es el 'Borrar todo' de la pantalla: da de baja toda la lista activa de la empresa y employees_id se ignora. */
export type TalentRecognitionRemoveParticipantsAdminInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Ids de colaborador (employee2.id) a dar de baja; ignorado si select_all. Requerido cuando select_all es false. */
  employees_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Dar de baja a TODOS los colaboradores activos de la lista de la empresa ('Borrar todo'). */
  select_all?: Scalars['Boolean']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentRecognitionRemoveParticipantsAdminResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentRecognitionRemoveParticipantsPayload | ValidationErrorV2;

export enum TalentRecognitionRequestStateEnum {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/**  UNIONS */
export type TalentRecognitionResponseExecution = TalentRecognitionPayload | TalentRecognitionResponseInternalError | TalentRecognitionResponseValidationError;

export type TalentRecognitionResponseInternalError = {
  __typename?: 'TalentRecognitionResponseInternalError';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type TalentRecognitionResponseValidationError = {
  __typename?: 'TalentRecognitionResponseValidationError';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type TalentRecognitionResultsDynamicReportInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentRecognitionResultsManualAnalysisReportInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentRecognitionResultsSummaryMetricsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  date_from?: InputMaybe<Scalars['DateTime']['input']>;
  date_to?: InputMaybe<Scalars['DateTime']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentRecognitionResultsTopDivisionsMedalsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<TalentRecognitionDivisionModelFilterInput>;
  pagination?: InputMaybe<TalentBasePaginationInput>;
  search?: InputMaybe<TalentRecognitionDivisionModelTopMedalsSearchInput>;
  sort?: InputMaybe<Array<TalentRecognitionDivisionModelTopMedalsSortOrderInput>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentRecognitionResultsTopMedalsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<TalentRecognitionCompanyModelFilterInput>;
  pagination?: InputMaybe<TalentBasePaginationInput>;
  search?: InputMaybe<TalentRecognitionCompanyModelSearchInput>;
  sort?: InputMaybe<Array<TalentRecognitionCompanyModelSortOrderInput>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentRecognitionResultsTopSubsidiariesMedalsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<TalentRecognitionSubsidiaryModelFilterInput>;
  pagination?: InputMaybe<TalentBasePaginationInput>;
  search?: InputMaybe<TalentRecognitionSubsidiaryModelTopMedalsSearchInput>;
  sort?: InputMaybe<Array<TalentRecognitionSubsidiaryModelTopMedalsSortOrderInput>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentRecognitionResultsTopUsersMedalsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<TalentRecognitionCompanyModelFilterInput>;
  pagination?: InputMaybe<TalentBasePaginationInput>;
  search?: InputMaybe<TalentRecognitionEmployeeModelTopMedalsSearchInput>;
  sort?: InputMaybe<Array<TalentRecognitionEmployeeModelTopMedalsSortOrderInput>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum TalentRecognitionRewardStatusUpdateEnum {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export enum TalentRecognitionRewardsAdminSearchEnum {
  ProductName = 'PRODUCT_NAME'
}

export type TalentRecognitionRewardsAdminSearchInput = {
  fields: Array<TalentRecognitionRewardsAdminSearchEnum>;
  query: Scalars['String']['input'];
};

export type TalentRecognitionRewardsCollaboratorConnection = {
  __typename?: 'TalentRecognitionRewardsCollaboratorConnection';
  edges: Array<TalentRecognitionRewardsCollaboratorEdge>;
  metadata: Metadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type TalentRecognitionRewardsCollaboratorEdge = {
  __typename?: 'TalentRecognitionRewardsCollaboratorEdge';
  /** Opaque pagination cursor. */
  cursor: Scalars['String']['output'];
  /** The product at this position of the catalog. */
  node: TalentRecognitionProduct;
};

export enum TalentRecognitionRewardsRedemptionStatusUpdateEnum {
  Delivered = 'DELIVERED',
  Rejected = 'REJECTED'
}

export enum TalentRecognitionRewardsRedemptionsSearchEnum {
  EmployeeName = 'EMPLOYEE_NAME'
}

export type TalentRecognitionRewardsRedemptionsSearchInput = {
  fields: Array<TalentRecognitionRewardsRedemptionsSearchEnum>;
  query: Scalars['String']['input'];
};

export enum TalentRecognitionRewardsRedemptionsStatusFilterEnum {
  Delivered = 'DELIVERED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type TalentRecognitionSubsidiaryModelFilterInput = {
  date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  date_lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum TalentRecognitionSubsidiaryModelTopMedalsSearchEnum {
  ModelName = 'MODEL_NAME'
}

export type TalentRecognitionSubsidiaryModelTopMedalsSearchInput = {
  fields: Array<TalentRecognitionSubsidiaryModelTopMedalsSearchEnum>;
  query: Scalars['String']['input'];
};

export enum TalentRecognitionSubsidiaryModelTopMedalsSortEnum {
  Points = 'POINTS',
  QuantityMedals = 'QUANTITY_MEDALS'
}

export type TalentRecognitionSubsidiaryModelTopMedalsSortOrderInput = {
  direction?: OrderDirectionEnum;
  field: TalentRecognitionSubsidiaryModelTopMedalsSortEnum;
};

export type TalentRecognitionTopSentMedal = {
  __typename?: 'TalentRecognitionTopSentMedal';
  /** THE CANONICAL MEDAL — innpulsa.recognitioncompany joined to innpulsa.recognitionlevel through level_id — the SAME TalentRecognitionCompany the medal catalog of this surface serves, reused whole instead of reprojected into loose scalars, so the two cannot drift and the FE reuses its existing medal fragment. Its per-column origins are documented on the type itself: id, company_id, name, category, description, icon, bolstate -> is_active, leader -> is_leader, level_id, level. FOUR THINGS TO HANDLE: `category` is NULLABLE and is a LEGACY TOKEN (VALUES / COMPETENCES / GOALS / OTHERS) that the client must map to a label and never print raw, falling back to hiding the chip for an unknown value; `level.name` is NOT an enum and may be null, so the badge renders an arbitrary string (AC-01's 'Bronce / Plata / Oro' cannot be guaranteed — a company may have renamed its levels); the COST of the medal is `level.points` and nothing else, never the configuration plan's per-level columns; and `icon` is non-null but its URL may not RESOLVE, so the client degrades to a placeholder with an onError fallback and never blocks. `is_active` travels but is informational: this podium only lists ACTIVE medals (U4 / AC-05), an inactive one being excluded from the counting itself. AC-02 IS COVERED BY CONSTRUCTION — `name` and `category` are two distinct fields of the same entity and both always travel; it was never 'one or the other'. */
  medal: TalentRecognitionCompany;
  /** How many times this medal was handed out inside the current calendar quarter — always present, because the row exists only because the number does, and a row of the top without its number would be unrenderable. */
  statistics: TalentRecognitionTopSentMedalStatistics;
};

export type TalentRecognitionTopSentMedalStatistics = {
  __typename?: 'TalentRecognitionTopSentMedalStatistics';
  /** How many times this medal was handed out inside the CURRENT CALENDAR QUARTER: COUNT(recognitionemployee) of rows pointing at this medal with staterequest = 'APPROVED', the delivery row not soft-deleted, the medal ACTIVE (U4 / AC-05) AND THE RECEIVER AN ACTIVE EMPLOYEE. READ THAT LAST FILTER AGAIN, BECAUSE IT CHANGES WHAT THIS NUMBER MEANS: total_sent IS NOT 'how many times the medal was handed out' — IT IS 'HOW MANY TIMES IT WAS HANDED OUT TO EMPLOYEES WHO ARE ACTIVE TODAY'. The state of the receiver is filtered INSIDE the count, so offboarding one person retroactively lowers the counter of every medal they ever received and can reorder the podium of a quarter that is already closed. That is the behaviour of the database; no client can guess it from the field name. It counts DELIVERIES, not distinct receivers: the same medal handed to the same person three times counts three. IT IS ALWAYS >= 1, because the list is built FROM the counters — a medal with zero inside the window is simply ABSENT, never present with total_sent 0. senddate is NULLABLE and a delivery with no date falls inside no window and is counted by nothing. WINDOW: the calendar quarter the read falls in, resolved server-side in the platform time zone — NOT lifetime (PRD RN-06 and AC-01 of the story say 'histórico total' and are stale) and not a rolling three months either. Whether admin-issued deliveries count (sended_from_admin) is still [PENDIENTE DE CONFIRMACION CON TALENT]; today every delivery counts. The admin surface calls this exact number `quantity` — same Count, same filters, different public name. */
  total_sent: Scalars['Int']['output'];
};

export enum TalentRelationTypeEnum {
  Admin = 'ADMIN',
  Auto = 'AUTO',
  Boss = 'BOSS',
  ClienteExterno = 'CLIENTE_EXTERNO',
  ClienteInterno = 'CLIENTE_INTERNO',
  Coworker = 'COWORKER',
  Otro = 'OTRO',
  Proveedor = 'PROVEEDOR',
  Subordinate = 'SUBORDINATE',
  Supervisor = 'SUPERVISOR',
  Vp = 'VP'
}

export type TalentRelationWeightCaseInput = {
  /** Relation-weight pairs for this case. Only include relations that exist for this group of evaluated people. The sum must equal exactly 100. */
  weights: Array<TalentRelationWeightItemInput>;
};

export type TalentRelationWeightItemInput = {
  /** Relation type key (e.g. AUTO, BOSS, SUBORDINATE, COWORKER, SUPERVISOR). */
  relation: Scalars['String']['input'];
  /** Weight percentage for this relation type (0–100). All weights must sum to 100. */
  weight: Scalars['Decimal']['input'];
};

export type TalentReminderEmailTranslationInput = {
  /** Email body (HTML-sanitized) for receivers with this language. */
  email_body: Scalars['String']['input'];
  /** Email subject line for receivers with this language. */
  email_subject: Scalars['String']['input'];
  /** Language this subject/body pair is written in. */
  language: CompetenceLanguageCodeEnum;
};

export type TalentReopenQuestionnaireInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the competences evaluation that owns the questionnaire. */
  evaluation_id: Scalars['ID']['input'];
  /** ID of the questionnaire to reopen. Must be in FINISHED state. */
  questionnaire_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentReopenQuestionnaireResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentReopenQuestionnairePayload | ValidationErrorV2;

/** INPUTS */
export type TalentReportFilterInput = {
  city_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  division_id_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  employee_id_eq?: InputMaybe<Scalars['Int']['input']>;
  external_field_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gender_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grouping_filter?: InputMaybe<TalentReportGroupingFilterEnum>;
  job_id_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  leader_id_eq?: InputMaybe<Scalars['Int']['input']>;
  level_id_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subsidiary_id_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/**  idiomas disponibles en Talent  */
export enum TalentReportGroupingFilterEnum {
  Boss = 'BOSS',
  Division = 'DIVISION',
  JobLevel = 'JOB_LEVEL',
  MacroCompetence = 'MACRO_COMPETENCE',
  Subsidiary = 'SUBSIDIARY'
}

export type TalentReportInput = {
  company_id: Scalars['Int']['input'];
  filter?: InputMaybe<TalentReportFilterInput>;
  is_calibrated: Scalars['Boolean']['input'];
  language?: InputMaybe<LanguageEnum>;
  process_id: Scalars['Int']['input'];
};

export type TalentReportResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TalentReportType;

export type TalentReportSpoonInput = {
  company_id: Scalars['Int']['input'];
  goals_process_id?: InputMaybe<Scalars['String']['input']>;
  process_id: Scalars['String']['input'];
  type_report: Scalars['String']['input'];
};

export type TalentReportTemplate = {
  __typename?: 'TalentReportTemplate';
  company_id: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  evaluations?: Maybe<Scalars['String']['output']>;
  goal_period_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  instance_name: Scalars['String']['output'];
  is_base_template: Scalars['Boolean']['output'];
  is_landscape?: Maybe<Scalars['Boolean']['output']>;
  is_type_individual?: Maybe<Scalars['Boolean']['output']>;
  previous_evaluation_id?: Maybe<Scalars['Int']['output']>;
  template_info_name?: Maybe<Scalars['String']['output']>;
  template_name: Scalars['String']['output'];
  template_prefix_name?: Maybe<Scalars['String']['output']>;
  template_suffix_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type TalentReportType = {
  __typename?: 'TalentReportType';
  company_id: Scalars['Int']['output'];
  created_at: Scalars['String']['output'];
  file_url?: Maybe<Scalars['String']['output']>;
  goals_process_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  process_id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type_report: Scalars['String']['output'];
};

export type TalentReportsAdministratorQuery = {
  __typename?: 'TalentReportsAdministratorQuery';
  /** Query to get report templates */
  list_report_templates_admin: TalentListReportTemplatesResponse;
};


export type TalentReportsAdministratorQueryList_Report_Templates_AdminArgs = {
  input: TalentListReportTemplatesInput;
};

export type TalentReportsCompetencesGeneralCommentsFilter = {
  employee_id_eq: Scalars['Int']['input'];
};

export type TalentReportsCompetencesGeneralCommentsPayload = {
  __typename?: 'TalentReportsCompetencesGeneralCommentsPayload';
  process_id: Scalars['Int']['output'];
  process_name?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<Maybe<TalentReportsCompetencesQuestion>>>;
};

export type TalentReportsCompetencesQuestion = {
  __typename?: 'TalentReportsCompetencesQuestion';
  comments?: Maybe<Array<Maybe<TalentComment>>>;
  id: Scalars['Int']['output'];
  question: Scalars['String']['output'];
};

export type TalentReportsEmployeeResult = {
  __typename?: 'TalentReportsEmployeeResult';
  competences_result?: Maybe<TalentResult>;
  employee: TalentEmployee;
  employee_status?: Maybe<TalentEmployeeStatusEnum>;
  feedback_count?: Maybe<Scalars['Int']['output']>;
  goals_result?: Maybe<TalentResult>;
  nbox_result?: Maybe<TalentNboxEmployeeResultDetail>;
  performance_result?: Maybe<TalentResult>;
  /**  Líder / Colaborador. Siempre presente para list_performance_employee_results (TLNT-4779). */
  role?: Maybe<TalentEmployeeRoleEnum>;
};

export type TalentReportsEmployeeResultsFilter = {
  competences_process_id_eq?: InputMaybe<Scalars['Int']['input']>;
  /**  País -> country_code */
  countries_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /**  Departamento -> division_id */
  division_ids_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  dynamic_performance_id_eq?: InputMaybe<Scalars['Int']['input']>;
  /**  Acota el conteo de feedback a uno o varios templates de la compañía */
  feedback_template_ids_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  flexible_performance?: InputMaybe<Scalars['Boolean']['input']>;
  goals_process_id_eq?: InputMaybe<Scalars['Int']['input']>;
  /**  Cargo (position) */
  job_ids_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  leader_id_eq?: InputMaybe<Scalars['Int']['input']>;
  matrix_id_eq?: InputMaybe<Scalars['Int']['input']>;
  /**
   * --- TLNT-4779: filtros de la tabla "Resultados por colaborador" (admin) ---
   * Líder / Colaborador (derivado de boss_id)
   */
  role_eq?: InputMaybe<TalentEmployeeRoleEnum>;
  /**  Sede -> subsidiary_id */
  subsidiary_ids_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TalentReportsEmployeeResultsInput = {
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  company_id: Scalars['Int']['input'];
  filter?: InputMaybe<TalentReportsEmployeeResultsFilter>;
  modules?: InputMaybe<Array<TalentReportsModuleEnum>>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  search?: InputMaybe<ReportsSearchInput>;
  sort?: InputMaybe<SortInput>;
};

export type TalentReportsEmployeeResultsPayload = {
  __typename?: 'TalentReportsEmployeeResultsPayload';
  results?: Maybe<Array<Maybe<TalentReportsEmployeeResult>>>;
  total_count: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type TalentReportsEmployeeResultsResponse = ResponseInternalError | ResponseValidationError | TalentReportsEmployeeResultsPayload;

export enum TalentReportsGeneralDashboardModuleEnum {
  Competences = 'COMPETENCES',
  Feedback = 'FEEDBACK',
  Goals = 'GOALS',
  Nbox = 'NBOX',
  Performance = 'PERFORMANCE'
}

export type TalentReportsGeneralDashboardReportFilter = {
  competences_process_id_eq?: InputMaybe<Scalars['Int']['input']>;
  dynamic_performance_id_eq?: InputMaybe<Scalars['Int']['input']>;
  flexible_performance?: InputMaybe<Scalars['Boolean']['input']>;
  goals_process_id_eq?: InputMaybe<Scalars['Int']['input']>;
  leader_id_eq: Scalars['Int']['input'];
  matrix_id_eq?: InputMaybe<Scalars['Int']['input']>;
  /**  @deprecated Use dynamic_performance_id_eq for dynamic performance */
  performance_process_id_eq?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentReportsGeneralDashboardReportInput = {
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<TalentReportsGeneralDashboardReportFilter>;
  language?: InputMaybe<LanguageEnum>;
  modules?: InputMaybe<Array<InputMaybe<TalentReportsGeneralDashboardModuleEnum>>>;
};

export type TalentReportsGeneralDashboardReportResponse = ResponseInternalError | ResponseValidationError | TalentReportsGeneralDashboardReportResult;

export type TalentReportsGeneralDashboardReportResult = {
  __typename?: 'TalentReportsGeneralDashboardReportResult';
  result?: Maybe<Scalars['String']['output']>;
};

export type TalentReportsListCompetencesGeneralCommentsInput = {
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  filter: TalentReportsCompetencesGeneralCommentsFilter;
  process_id: Scalars['Int']['input'];
};

export type TalentReportsListCompetencesGeneralCommentsResponse = ResponseInternalError | ResponseValidationError | TalentReportsCompetencesGeneralCommentsPayload;

export type TalentReportsListCompetencesInput = {
  centralized_organization_id?: InputMaybe<Scalars['Int']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<TalentCompetenceFilter>;
  language?: InputMaybe<LanguageEnum>;
  pagination: OffsetPaginationInput;
  process_id: Scalars['Int']['input'];
  search?: InputMaybe<ReportsSearchInput>;
  sort?: InputMaybe<SortInput>;
};

export enum TalentReportsModuleEnum {
  Competences = 'COMPETENCES',
  Feedback = 'FEEDBACK',
  Goals = 'GOALS',
  Nbox = 'NBOX',
  Performance = 'PERFORMANCE'
}

export type TalentReportsMutation = {
  __typename?: 'TalentReportsMutation';
  talent_nbox?: Maybe<NboxMutations>;
};

export type TalentReportsProcess = {
  __typename?: 'TalentReportsProcess';
  configurations?: Maybe<Array<Maybe<TalentReportsProcessConfiguration>>>;
  id: Scalars['Int']['output'];
  inScale?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  semaphore?: Maybe<Array<Maybe<SemaphoreDto>>>;
};

/** TYPES */
export type TalentReportsProcessByModule = {
  __typename?: 'TalentReportsProcessByModule';
  module: ReportModule;
  processes: Array<Maybe<TalentReportsProcess>>;
};

/** RESPONSES */
export type TalentReportsProcessByModuleList = {
  __typename?: 'TalentReportsProcessByModuleList';
  processes_result: Array<Maybe<TalentReportsProcessByModule>>;
};

export type TalentReportsProcessConfiguration = {
  __typename?: 'TalentReportsProcessConfiguration';
  code?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TalentReportsQuery = {
  __typename?: 'TalentReportsQuery';
  talent_competence?: Maybe<CompetenceQueries>;
  talent_general_reports?: Maybe<GeneralReportsQueries>;
  talent_goals?: Maybe<GoalsQueries>;
  talent_nbox?: Maybe<NboxQueries>;
};

export type TalentReportsSpoonRequestMutation = {
  __typename?: 'TalentReportsSpoonRequestMutation';
  create_or_get_talent_report?: Maybe<TalentReportResponse>;
};


export type TalentReportsSpoonRequestMutationCreate_Or_Get_Talent_ReportArgs = {
  input: TalentReportSpoonInput;
};

export type TalentResponseDivision = DivisionTalentListType | TalentResponseInternalError | TalentResponseValidationError;

export type TalentResponseEmployee = EmployeeTalentPagination | TalentResponseInternalError | TalentResponseValidationError;

/**  TALENT. */
export type TalentResponseInternalError = {
  __typename?: 'TalentResponseInternalError';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type TalentResponseLevel = LevelTalentListType | TalentResponseInternalError | TalentResponseValidationError;

export type TalentResponseSubsidiary = SubsidiaryTalentListType | TalentResponseInternalError | TalentResponseValidationError;

export enum TalentResponseTypeEnum {
  Box = 'BOX',
  Radio = 'RADIO'
}

export type TalentResponseValidationError = {
  __typename?: 'TalentResponseValidationError';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type TalentRestartQuestionnaireInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the competences evaluation that owns the questionnaire. */
  evaluation_id: Scalars['ID']['input'];
  /** ID of the questionnaire to restart. Must be in FINISHED or IN_PROGRESS state. */
  questionnaire_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentRestartQuestionnaireResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentRestartQuestionnairePayload | ValidationErrorV2;

export type TalentResult = {
  __typename?: 'TalentResult';
  percentage: Scalars['Float']['output'];
  scale: Scalars['Float']['output'];
  semaphore_color: Scalars['String']['output'];
  semaphore_label: Scalars['String']['output'];
};

export type TalentSaveClimateAnswerInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Centralized user id of the collaborator (standard identity envelope; accepted but not consumed by climate). */
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  /** Survey model id the answer belongs to. */
  model_id: Scalars['ID']['input'];
  /** Selected option ids — only for MULTIPLE_ANSWER. */
  option_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Participant id the answer is saved against. Optional in the schema; required at resolve time. */
  partaker_id?: InputMaybe<Scalars['ID']['input']>;
  /** Question id being answered. */
  question_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator. Required at resolve time — scopes every climate read/write to this collaborator. */
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent user id of the collaborator (standard identity envelope). */
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
  /** Question type; selects how value/option_ids are interpreted. */
  type: ClimateQuestionType;
  /** Scalar answer. For option-based types send the chosen ClimateAnswerOption.LABEL (never its id): the quantitative SCALE VALUE for CLIMATE_LABEL / ENPS, and the option id for SOCIODEMOGRAPHIC (where label already equals the id). Free text for OPEN. Null for MULTIPLE_ANSWER (use option_ids). NOTE: CLIMATE_LABEL is a quantitative question in Java (stored via Integer.valueOf) — sending the option id instead of its scale value makes the backend reject it. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Input to create or update a company mail template (bulk by language) */
export type TalentSaveCompanyMailTemplateInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Mail template code; identifies the template within the company */
  code: Scalars['String']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Per-language subject/content to upsert. Languages not sent that lack a company override are seeded from the global default. */
  translations: Array<TalentMailTemplateTranslationInput>;
};

export type TalentSaveCompanyMailTemplateResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentSaveCompanyMailTemplatePayload | ValidationErrorV2;

export type TalentSaveDipParticipantsInput = {
  /** When true, assign every selectable employee of the company (insert / reactivate); the explicit id lists are ignored. There is no unassign_all counterpart. */
  assign_all?: InputMaybe<Scalars['Boolean']['input']>;
  /** Employee ids to add to the selection: each one is inserted or, if it was previously soft-deleted, reactivated in place (U3). */
  assigned_employee_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Id of the PID process whose participants are being saved. The process must belong to the admin's company and still be editable (R5). */
  dip_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Employee ids to drop from the selection: each active partaker is soft-deleted (state='DELETED', U4). Ignored when assign_all is true. */
  unassigned_employee_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TalentSaveDipParticipantsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentSaveDipParticipantsPayload | ValidationErrorV2;

export type TalentSaveDipProcessGeneralConfigInput = {
  /** Leader approval required for new activities. */
  act_approve_employee?: Scalars['Boolean']['input'];
  /** Allow creating "Otros" (free) activities. */
  allow_other_act?: Scalars['Boolean']['input'];
  /** Allow activities without an active process. */
  allow_without_process_activity?: Scalars['Boolean']['input'];
  /** Second approval by the area manager (★ Nuevo, persisted; FE v2). */
  approved_activities_super_boss?: Scalars['Boolean']['input'];
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Allow creating activities from the library. */
  create_activities_book_store?: Scalars['Boolean']['input'];
  /** Collaborator can create activities without an active process. */
  create_activities_collaborator_pid_inactive?: Scalars['Boolean']['input'];
  /** Allow creating a PID from feedback. */
  create_pid_in_feedback?: Scalars['Boolean']['input'];
  /** Tracking done by the collaborator. */
  employee_auto_eval?: Scalars['Boolean']['input'];
  /** Evaluation after the tracking step. */
  employee_eval_first?: Scalars['Boolean']['input'];
  /** Enable the collaborator "Approve all" button. */
  enable_approved_all_task_collaborator?: Scalars['Boolean']['input'];
  /** End date. Required; must be >= start_date (RN-004). */
  end_date: Scalars['Date']['input'];
  /** Mandatory evidence (collaborator). */
  feedback_evi?: Scalars['Boolean']['input'];
  /** Mandatory evidence (leader). */
  feedback_evi_boss?: Scalars['Boolean']['input'];
  /** Comment required. */
  feedback_req?: Scalars['Boolean']['input'];
  /** Tracking type: continuous (true) vs periodic. */
  has_continuous_tracking?: Scalars['Boolean']['input'];
  /** Hide the "Clase" input. */
  hide_input_class?: Scalars['Boolean']['input'];
  /** Hide the PDF report download. */
  hide_report_pdf?: Scalars['Boolean']['input'];
  /** null => create a new PID process; present => update it. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Max activities per person: 1-99; null/omitted = no limit (RN-006). */
  max_act_comp?: InputMaybe<Scalars['Int']['input']>;
  /** Label for the 10% (formal learning) block. */
  model_10_label?: InputMaybe<Scalars['String']['input']>;
  /** Label for the 20% (learning from others) block. */
  model_20_label?: InputMaybe<Scalars['String']['input']>;
  /** Whether the 70-20-10 methodology is enabled. */
  model_70_20_10?: Scalars['Boolean']['input'];
  /** Label for the 70% (on-the-job experience) block. */
  model_70_label?: InputMaybe<Scalars['String']['input']>;
  /** Process name. Required, 1-75 characters (RN-001, RN-002). */
  name: Scalars['String']['input'];
  /** Associated modules (Competencias / Metas / OKRs / Clima). Persisted in v1; a module omitted here is turned off (RN-008/009 · AC-4). */
  process_associate?: InputMaybe<Array<PidModulesAssociateInput>>;
  /** Collaborator CRUD permissions over their own activities. */
  process_collaborator_activities?: InputMaybe<Array<PidCrudActivityTypeEnum>>;
  /** Leader CRUD permissions over the collaborator activities. */
  process_leader_activities?: InputMaybe<Array<PidCrudActivityTypeEnum>>;
  /** Visibility for employees (RN-016 default true). */
  show_dashboard?: Scalars['Boolean']['input'];
  /** Show the displacement percentage. */
  show_displacement_percentage?: Scalars['Boolean']['input'];
  /** Start date. Required; must be >= today when creating (RN-003). */
  start_date: Scalars['Date']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentSaveDipProcessGeneralConfigResponse = DipEmployeesWithoutTrackErrorV2 | DipProcessTypeRequiredErrorV2 | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentSaveDipProcessGeneralConfigPayload | ValidationErrorV2;

export enum TalentScaleTypeEnum {
  Basic = 'BASIC',
  BehaviorWeightModelConfiguration = 'BEHAVIOR_WEIGHT_MODEL_CONFIGURATION',
  Custom = 'CUSTOM'
}

export type TalentSendBulkCompanyEmailResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | Nom035EvaluationClosedErrorV2 | Nom035EvaluationNotFoundErrorV2 | Nom035InvalidCompanyErrorV2 | Nom035RequiredFieldErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentSendBulkCompanyEmailPayload | ReminderUnsupportedModuleErrorV2 | ValidationErrorV2;

export type TalentSendBulkReminderEmailInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Subject/body pairs for ES, EN and PT. Each receiver gets the pair matching their language; the ES pair is the default for languages without a pair. ES is required unless the legacy email_subject/email_body fields are sent instead. */
  email_translations?: InputMaybe<Array<TalentReminderEmailTranslationInput>>;
  /** The ID of the evaluation to send reminders for. */
  evaluation_id: Scalars['Int']['input'];
  /** List of employee IDs to send reminders to. Ignored if send_all is true. */
  receiver_employee_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** If true, send reminders to all evaluation participants and ignore receiver_employee_ids. */
  send_all?: InputMaybe<Scalars['Boolean']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Module this reminder belongs to (TL-2143 E5, dev decision E): the discriminator that lets ONE operation serve Competencias and NOM035 instead of duplicating the mutation. NULLABLE WITH DEFAULT COMPETENCES, which is what keeps the change additive — the Competencias FE already in QA does not send this field and its request stays valid byte for byte. Nullable and not only defaulted, because a client can still send an EXPLICIT null, so the BE coalesces `type_reminder or COMPETENCES` before branching. Runtime domain: COMPETENCES | NOM035; any other member of TalentModuleEnum is rejected with 4001_UNSUPPORTED_REMINDER_TYPE. It is TalentModuleEnum and not a dedicated enum on purpose: the same value the FE sends to list_mail_templates_paginated_admin(input.module) for the step-2 template, with no mapping table in between. */
  type_reminder?: InputMaybe<TalentModuleEnum>;
};

export type TalentSendCompanyEmailInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  content: Scalars['String']['input'];
  receiver: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentSendCompanyEmailResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentSendCompanyEmailPayload | ValidationErrorV2;

export type TalentSendRecognitionsCollaboratorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Centralized (Crehana core) user id of the caller (standard identity envelope). Used for the audit trail only — never a query filter. */
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  /** Message the sender writes. Persisted as recognitionemployee.commentrequest (NOT in feedback, which stays unused). Required — minimum 3 characters — only when the company has both the message box enabled and marked required (RN-11), otherwise it may be omitted. Hard limit 550 characters (COMMENT_TOO_LONG). */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Requested visibility of the recognition, persisted as recognitionemployee.public_medal. Honoured only when the company enabled the public awarded message AND the message box (RN-12); otherwise the backend forces false whatever is sent here — read the persisted value back from the payload, not from this field. */
  is_public_medal?: InputMaybe<Scalars['Boolean']['input']>;
  /** File-service id of the photo attached to the send (RN-13), returned by the standard upload. This is the CURRENT way to attach a photo and it replaces recognition_file: persisted as recognitionemployee.learning_file_id, and every read surface (the admin review listing and the payload of this mutation) turns it into a download URL served by the file service, so the bucket and the key are never exposed. Optional and non-blocking by absence: omitted or null creates the recognition without a photo. A value that IS sent must be a positive id; it is stored as-is and never verified against the file service, because the bytes were already uploaded when this mutation runs. In a massive send the same id is attached to every recognition of the batch (RN-17). If both this field and recognition_file travel, each is stored in its own column and the reads prefer this one. */
  learning_file_id?: InputMaybe<Scalars['Int']['input']>;
  /** Medal being sent. Persisted as recognitionemployee.recognitioncompany_id — despite the column name it holds the MEDAL id (recognitioncompany.id), not a company id. Re-checked at send time against the company's active catalog (U4): a medal an admin deactivated after the grid loaded answers MEDAL_NOT_AVAILABLE. */
  medal_id: Scalars['ID']['input'];
  /** Receivers of the recognition — one recognitionemployee row per id. Send one id to recognize a single colleague, several to recognize a whole team in one operation: from two ids up the rows share a groups id and the batch is atomic (RN-17). Must not be empty (EMPTY_RECEIVERS), must not contain talent_employee_id (SELF_RECOGNITION_NOT_ALLOWED, RN-21) and every id must be an active member of talent_company_id (EMPLOYEE_NOT_IN_COMPANY, U2). Every rule is aggregate: one invalid receiver rejects the whole list, and the points cap is charged for the batch as a whole (number of receivers x medal points, RN-06), never receiver by receiver. Repeated ids are collapsed: one recognition per colleague, charged once. */
  receiver_employee_ids: Array<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent employee id of the collaborator making the request. Required at resolve time: it scopes the operation to this collaborator and is recorded in the audit trail. */
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
  /** Talent user id of the caller (standard identity envelope). Used for the audit trail only — never a query filter. */
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentSendRecognitionsCollaboratorPayload = {
  __typename?: 'TalentSendRecognitionsCollaboratorPayload';
  /** Batch-level state shared by every created row. */
  context: TalentSendRecognitionsContext;
  /** The rows created in recognitionemployee, one per receiver, in the same order as input.receiver_employee_ids. Never partial: the batch is atomic (RN-17), which corrects the as-is behaviour of iterating receivers without a transaction and leaving half-sent batches behind. */
  recognitions: Array<TalentRecognitionEmployee>;
  /** What the send consumed from the sender's budget. */
  statistics: TalentSendRecognitionsStatistics;
};

export type TalentSendRecognitionsCollaboratorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentSendRecognitionsCollaboratorPayload | ValidationErrorV2;

export type TalentSendRecognitionsContext = {
  __typename?: 'TalentSendRecognitionsContext';
  /** recognitionemployee.groups shared by the whole batch, read back from the created rows. Null when the send had a single receiver, which is not a batch (RN-17). */
  group_id?: Maybe<Scalars['Int']['output']>;
};

export type TalentSendRecognitionsStatistics = {
  __typename?: 'TalentSendRecognitionsStatistics';
  /** Budget this send consumed: number of receivers x the medal's level points (RN-06). Exposed so the confirmation screen states the consumption without recomputing it — recomputing it on the client from a different source is what produced the legacy FE/BE divergence (RN-08). */
  total_points_consumed: Scalars['Int']['output'];
};

export type TalentSentMedalsCollaboratorConnection = {
  __typename?: 'TalentSentMedalsCollaboratorConnection';
  edges: Array<TalentSentMedalsCollaboratorEdge>;
  metadata: TalentMetadata;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type TalentSentMedalsCollaboratorEdge = {
  __typename?: 'TalentSentMedalsCollaboratorEdge';
  /** Opaque pagination cursor. */
  cursor: Scalars['String']['output'];
  /** The recognitionemployee row at the end of the edge — medal with its level, points, date, its OWN request_status and comment_request, the receiver it was sent to and, when it was part of a massive send, the whole roster of that send in groups_info (RN-010, never narrowed by the state filter). sender travels null: on this tab it is the collaborator in session (U2). */
  node: TalentRecognitionEmployee;
};

export type TalentSentMedalsCollaboratorFilterInput = {
  /** Keep only the recognitions whose own state is one of these, matched against recognitionemployee.staterequest (RN-018). null — the default — or an empty list returns EVERY state, which is what the tab shows before the collaborator picks a chip (RN-003). Filtering is server-side on purpose: total_count has to reflect it (RN-019), which the client cannot compute from a page it received already filtered. It operates on ROWS, which is what the items of this listing are: a batch with 3 APPROVED and 2 PENDING receivers contributes 3 items under one chip and 2 under the other, and every one of them still names the WHOLE roster of the batch in groups_info — the filter never narrows that. */
  state_request_in?: InputMaybe<Array<TalentRecognitionRequestStateEnum>>;
};

export type TalentSession = {
  __typename?: 'TalentSession';
  company_id?: Maybe<Scalars['String']['output']>;
  employee_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  user_role?: Maybe<Scalars['String']['output']>;
};

export type TalentSubsidiary = {
  __typename?: 'TalentSubsidiary';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TalentTimelineResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentTimelinePayload | ValidationErrorV2;

export type TalentUpdateBehaviorInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competence level */
  competence_level_id: Scalars['ID']['input'];
  /** The ID of the behavior to update. */
  id: Scalars['ID']['input'];
  /** behavior status */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** The minimum expected value for the behavior */
  min_expected?: InputMaybe<Scalars['Decimal']['input']>;
  /** Behavior name in English */
  name_en?: InputMaybe<Scalars['String']['input']>;
  /** Behavior name in Spanish */
  name_es?: InputMaybe<Scalars['String']['input']>;
  /** Behavior name in Portuguese */
  name_pt?: InputMaybe<Scalars['String']['input']>;
  /** The sequence of the behavior */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  /** The subgroup to which the behavior belongs */
  subgroup?: InputMaybe<Scalars['String']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** The weight of the behavior */
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type TalentUpdateBehaviorResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateBehaviorPayload | ValidationErrorV2;

export type TalentUpdateCompanyConfigurationsInput = {
  /** List of active configuration ids */
  active_configuration_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of inactive configuration ids */
  inactive_configuration_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TalentUpdateCompanyPerformanceResultConfigurationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Company configurations */
  company_configurations?: InputMaybe<TalentUpdateCompanyConfigurationsInput>;
  /** Radar configurations */
  radar_configurations?: InputMaybe<TalentRadarCompanyConfigurationInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpdateCompetenceFilterInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** List of competence IDs included in this filter. */
  competence_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** ID of the competence model this filter belongs to. */
  competence_model_id?: InputMaybe<Scalars['ID']['input']>;
  /** List of division IDs used to match this filter. */
  division_filter_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** ID of the competence filter to update. */
  id: Scalars['ID']['input'];
  /** List of job IDs used to match this filter. */
  job_filter_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Display name of the competence filter. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of profile type IDs used to match this filter. */
  profile_filter_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of relation type IDs used to match this filter. */
  relation_filter_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpdateCompetenceFilterResponse = CompetenceWithoutBehaviorsErrorV2 | DuplicateFilterNameErrorV2 | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateCompetenceFilterPayload | ValidationErrorV2;

export type TalentUpdateCompetenceInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the competence model in edition or creation. */
  competence_model_id: Scalars['ID']['input'];
  competence_type_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the competence to update. */
  id: Scalars['ID']['input'];
  macro_competence?: InputMaybe<Scalars['String']['input']>;
  master_id?: InputMaybe<Scalars['ID']['input']>;
  min_expected?: InputMaybe<Scalars['Decimal']['input']>;
  name_en?: InputMaybe<Scalars['String']['input']>;
  name_es?: InputMaybe<Scalars['String']['input']>;
  name_pt?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  sector_id?: InputMaybe<Scalars['ID']['input']>;
  update_results_not_include?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TalentUpdateCompetenceLevelInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competence in edition or creation. */
  competence_id: Scalars['ID']['input'];
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the competence level to update. */
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the category level in competence. */
  level_id: Scalars['ID']['input'];
  min_expected?: InputMaybe<Scalars['Float']['input']>;
  minimum?: InputMaybe<Scalars['Float']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type TalentUpdateCompetenceLevelResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateCompetenceLevelPayload | ValidationErrorV2;

export type TalentUpdateCompetencesEvaluationConfigurationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Competences evaluation configurations ids to update in company configuration */
  competences_evaluation_configurations: TalentUpdateCompanyConfigurationsInput;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpdateCompetencesEvaluationConfigurationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateCompetencesEvaluationConfigurationPayload | ValidationErrorV2;

export type TalentUpdateCompetencesInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competence model in edition or creation. */
  competence_model_id: Scalars['ID']['input'];
  /** The list of competences to update. */
  competences: Array<TalentUpdateCompetenceInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpdateCompetencesModelInput = {
  behavior_weight_configuration?: InputMaybe<Scalars['Boolean']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  competence_weight_configuration?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  field_macro_competence?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the competences model to update. */
  id: Scalars['ID']['input'];
  minimum_expected_configuration?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  type_competence_model?: InputMaybe<Scalars['String']['input']>;
};

export type TalentUpdateCompetencesModelResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateCompetencesModelPayload | ValidationErrorV2;

export type TalentUpdateCompetencesModelStatusInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competences model to update. */
  competences_model_id: Scalars['ID']['input'];
  /** The status to update the competences model to. */
  status: TalentCompetencesStateEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpdateCompetencesModelStatusResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateCompetencesModelStatusPayload | ValidationErrorV2;

export type TalentUpdateCompetencesResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateCompetencesPayload | ValidationErrorV2;

export type TalentUpdateDipCollaboratorActivityResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateDipCollaboratorActivityPayload | ValidationErrorV2;

export type TalentUpdateDipLibraryActivityResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateDipLibraryActivityPayload | ValidationErrorV2;

export type TalentUpdateEvaluationRelationWeightsInput = {
  /** One entry per case (distinct relation set). Each case targets only the evaluated people whose questionnaire relation set matches exactly the case's relations. Each case's weights must independently sum to 100. */
  cases: Array<TalentRelationWeightCaseInput>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the evaluation whose questionnaire weights will be updated. */
  evaluation_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpdateEvaluationRelationWeightsResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateEvaluationRelationWeightsPayload | ValidationErrorV2;

export type TalentUpdateEvaluationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateEvaluationPayload | ValidationErrorV2;

export type TalentUpdateLabelInput = {
  code: Scalars['String']['input'];
  company_id?: InputMaybe<Scalars['Int']['input']>;
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  module: Scalars['String']['input'];
  process?: InputMaybe<Scalars['Int']['input']>;
  pt?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentUpdateLabelsNewAppInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** List of new_app labels to create or update for the company */
  labels: Array<TalentLabelNewAppInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpdateLabelsNewAppPayload = {
  __typename?: 'TalentUpdateLabelsNewAppPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type TalentUpdateLabelsNewAppResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | TalentUpdateLabelsNewAppPayload | ValidationErrorV2;

export type TalentUpdatePerformanceGaussConfigurationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Gauss bell configurations semaphore */
  configurations: Array<TalentGaussConfigurationInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpdatePerformanceGaussConfigurationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdatePerformanceGaussConfigurationPayload | ValidationErrorV2;

export type TalentUpdatePerformanceResultConfigurationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  company_configuration: TalentCompanyPerformanceConfigurationInput;
  labels: Array<TalentUpdateLabelInput>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpdatePerformanceResultConfigurationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdatePerformanceResultConfigurationPayload | ValidationErrorV2;

export type TalentUpdatePersonLanguageInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  employee_email: Scalars['String']['input'];
  language: LanguageEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpdatePersonLanguageResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdatePersonLanguagePayload | ValidationErrorV2;

export type TalentUpdateRecognitionConfigurationInput = {
  allow_comments?: InputMaybe<Scalars['Boolean']['input']>;
  allow_medal_response?: InputMaybe<Scalars['Boolean']['input']>;
  are_medals_approved?: InputMaybe<Scalars['Boolean']['input']>;
  bronze_medals?: InputMaybe<Scalars['Int']['input']>;
  can_boss_send_medal?: InputMaybe<Scalars['Boolean']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  comment_label?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['Int']['input']>;
  forced_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  gold_medals?: InputMaybe<Scalars['Int']['input']>;
  has_participant_management?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_elements_ranking_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_justification_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_justification_required?: InputMaybe<Scalars['Boolean']['input']>;
  is_limit_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_module_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_public_awarded_message_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_public_ranking_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_public_ranking_points_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<TalentUpdateLabelInput>>;
  max_points_per_send?: InputMaybe<Scalars['Int']['input']>;
  medal_recognition_label?: InputMaybe<Scalars['String']['input']>;
  module_recognition_label?: InputMaybe<Scalars['String']['input']>;
  reboot_day?: InputMaybe<Scalars['Int']['input']>;
  silver_medals?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentUpdateRecognitionConfigurationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateRecognitionConfigurationPayload | ValidationErrorV2;

export type TalentUpdateRecognitionMailTemplateInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  content: Scalars['String']['input'];
  mail_template_id: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpdateRecognitionMailTemplateResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateRecognitionMailTemplatePayload | ValidationErrorV2;

export type TalentUpdateRecognitionMedalInput = {
  attachment_id?: InputMaybe<Scalars['Int']['input']>;
  category: TalentRecognitionMedalCategoryEnum;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  is_leader: Scalars['Boolean']['input'];
  level: TalentRecognitionMedalLevelEnum;
  name: Scalars['String']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpdateRecognitionMedalRequestStatusInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<LanguageEnum>;
  recognition_employee_id: Scalars['ID']['input'];
  status: TalentRecognitionApplicationsMedalsStatusFilterEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpdateRecognitionMedalRequestStatusResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateRecognitionMedalRequestStatusPayload | ValidationErrorV2;

export type TalentUpdateRecognitionMedalResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateRecognitionMedalPayload | ValidationErrorV2;

export type TalentUpdateRecognitionMedalStatusInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  recognition_company_id: Scalars['ID']['input'];
  status: TalentRecognitionCompanyMedalsStatusFilterEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpdateRecognitionMedalStatusResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateRecognitionMedalStatusPayload | ValidationErrorV2;

export type TalentUpdateRecognitionRewardInput = {
  /** Attachment ID used to resolve the updated product image */
  attachment_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Updated description of the recognition product (max 500 chars) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Set to true to enable (ACTIVE) or false to disable (INACTIVE) the product */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated display name of the recognition product (max 50 chars) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Updated number of recognition points required (must be > 0) */
  points?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the recognition reward to edit */
  reward_id: Scalars['ID']['input'];
  /** Updated available quantity. Must be >= 0 when provided. */
  stock?: InputMaybe<Scalars['Int']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Updated product type, e.g. TANGIBLE or INTANGIBLE */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TalentUpdateRecognitionRewardRedemptionStatusInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_user_id?: InputMaybe<Scalars['ID']['input']>;
  /** List of redemption IDs to exclude when select_all is true. */
  excluded_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of redemption IDs to update. Required when select_all is false. */
  redemption_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When true, update all pending redemptions for the company. Cannot be used together with redemption_ids. */
  select_all?: InputMaybe<Scalars['Boolean']['input']>;
  /** New status to apply to the selected redemptions (DELIVERED or REJECTED) */
  status: TalentRecognitionRewardsRedemptionStatusUpdateEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  talent_employee_id?: InputMaybe<Scalars['ID']['input']>;
  talent_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpdateRecognitionRewardRedemptionStatusResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateRecognitionRewardRedemptionStatusPayload | ValidationErrorV2;

export type TalentUpdateRecognitionRewardResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateRecognitionRewardPayload | ValidationErrorV2;

export type TalentUpdateRecognitionRewardStatusInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** List of reward IDs to exclude when select_all is true. */
  excluded_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of recognition reward IDs to update. Required when select_all is false. */
  reward_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When true, update all rewards for the company. Cannot be used together with reward_ids. */
  select_all?: InputMaybe<Scalars['Boolean']['input']>;
  /** New status to apply to the selected rewards (ACTIVE, INACTIVE, or DELETED) */
  status: TalentRecognitionRewardStatusUpdateEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpdateRecognitionRewardStatusResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateRecognitionRewardStatusPayload | ValidationErrorV2;

export type TalentUpdateStatusCompetencesEvaluationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the competences evaluation to update. */
  evaluation_id: Scalars['ID']['input'];
  process_state: CompetencesEvaluationStateMapEnum;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpdateStatusCompetencesEvaluationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpdateStatusCompetencesEvaluationPayload | ValidationErrorV2;

export type TalentUploadMassiveCompetencesInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the file to upload. */
  file_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the user uploading the file. */
  user_id: Scalars['ID']['input'];
};

export type TalentUploadMassiveCompetencesRelationsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the evaluation for which competences relations are being uploaded. */
  evaluation_id: Scalars['ID']['input'];
  /** The file ID of the uploaded Excel competences relations file. */
  file_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the user uploading the file. */
  user_id: Scalars['ID']['input'];
};

export type TalentUploadMassiveCompetencesRelationsResponse = ExcelValidationResultInfo | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type TalentUploadMassiveCompetencesResponse = ExcelValidationResultInfo | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type TalentUploadMassiveDipActivityAssignmentInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** PID process the activities are assigned into (RN-013). */
  dip_id: Scalars['ID']['input'];
  /** Id of the uploaded .xlsx (FileUploadService). */
  file_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Employee id of the admin performing the upload. */
  talent_employee_id: Scalars['ID']['input'];
};

export type TalentUploadMassiveDipActivityAssignmentResponse = ExcelValidationResultInfo | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type TalentUploadMassiveDipActivityTrackingInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** PID process whose activities are being tracked (RN-013). */
  dip_id: Scalars['ID']['input'];
  /** Id of the uploaded .xlsx (FileUploadService). */
  file_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Employee id of the admin performing the upload. */
  talent_employee_id: Scalars['ID']['input'];
};

export type TalentUploadMassiveDipActivityTrackingResponse = ExcelValidationResultInfo | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type TalentUploadMassiveDipLibraryActivityInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** PID process whose library is being loaded (RN-013). */
  dip_id: Scalars['ID']['input'];
  /** Id of the uploaded .xlsx (FileUploadService). */
  file_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** Employee id of the admin performing the upload. */
  talent_employee_id: Scalars['ID']['input'];
};

export type TalentUploadMassiveDipLibraryActivityResponse = ExcelValidationResultInfo | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type TalentUploadMassiveParticipantsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the evaluation for which participants are being uploaded. */
  evaluation_id: Scalars['ID']['input'];
  /** The ID of the uploaded Excel file. */
  file_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the user uploading the file. */
  user_id: Scalars['ID']['input'];
};

export type TalentUploadMassiveParticipantsResponse = ExcelValidationResultInfo | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type TalentUploadMassiveRecognitionRewardsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the uploaded Excel file containing the reward products. */
  file_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the employee performing the upload. */
  talent_employee_id: Scalars['ID']['input'];
};

export type TalentUploadMassiveRecognitionRewardsResponse = ExcelValidationResultInfo | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type TalentUpsertCompetenceEmailTemplateInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Full HTML content of the email */
  content?: InputMaybe<Scalars['String']['input']>;
  /** ID of the competences evaluation */
  evaluation_id: Scalars['Int']['input'];
  /** Language code of the template to update: ES, EN or PT. Required together with subject and content. */
  language_code?: InputMaybe<CompetenceLanguageCodeEnum>;
  /** Type of email template. If omitted, all types are initialized with defaults. */
  notification_type?: InputMaybe<CompetenceNotificationTypeEnum>;
  /** Email subject */
  subject?: InputMaybe<Scalars['String']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentUpsertCompetenceEmailTemplateResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentUpsertCompetenceEmailTemplatePayload | ValidationErrorV2;

export type TalentUserInfo = {
  __typename?: 'TalentUserInfo';
  boss_full_name?: Maybe<Scalars['String']['output']>;
  company_id_talent?: Maybe<Scalars['Int']['output']>;
  division?: Maybe<Scalars['String']['output']>;
  /** Employee Id from Talent */
  employee_id: Scalars['String']['output'];
  is_boss: Scalars['Boolean']['output'];
  job?: Maybe<Scalars['String']['output']>;
  modules: Array<TalentModuleInfo>;
  modules_admin: Array<TalentModuleInfo>;
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  subsidiary?: Maybe<Scalars['String']['output']>;
  talent_roles: Array<Scalars['String']['output']>;
};

export type TalentUserParticipation = {
  __typename?: 'TalentUserParticipation';
  avatar: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TalentUserParticipationInput = {
  code_module: TalentModuleEnum;
  company_id: Scalars['Int']['input'];
};

export type TalentUserParticipationProcess = {
  __typename?: 'TalentUserParticipationProcess';
  closed_date: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  participation: Scalars['Float']['output'];
  started_date: Scalars['Date']['output'];
  state?: Maybe<Scalars['String']['output']>;
  total_users: Scalars['Int']['output'];
  users: Array<TalentUserParticipation>;
};

export type TalentUserParticipationProcessPayload = {
  __typename?: 'TalentUserParticipationProcessPayload';
  process_list: Array<TalentUserParticipationProcess>;
};

export type TalentUserParticipationResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TalentUserParticipationProcessPayload;

export type TalentUserSession = {
  __typename?: 'TalentUserSession';
  company_id: Scalars['String']['output'];
  employee_id: Scalars['String']['output'];
  flex_sid_token?: Maybe<Scalars['String']['output']>;
  url_parent?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['String']['output'];
  user_parent_id?: Maybe<Scalars['String']['output']>;
  user_role: Scalars['String']['output'];
};

export type TalentValidateMassiveCompetenceWeightsInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the competence model the weights file targets. */
  competences_model_id: Scalars['ID']['input'];
  /** Internal file-upload service ID. */
  file_id?: InputMaybe<Scalars['ID']['input']>;
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentValidateMassiveCompetenceWeightsResponse = ExcelValidationResultInfo | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type TalentValidateMassiveEvaluationDeleteRelationsFileInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the evaluation whose relations are being validated for deletion. */
  evaluation_id: Scalars['ID']['input'];
  /** Internal file-upload service ID for the uploaded Excel file. */
  file_id: Scalars['ID']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentValidateMassiveEvaluationDeleteRelationsFileResponse = ExcelValidationResultInfo | ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | ValidationErrorV2;

export type TalentValidateNameEvaluationInput = {
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  /** Name of the evaluation to validate. */
  name_evaluation: Scalars['String']['input'];
  talent_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TalentValidateNameEvaluationResponse = ForbiddenErrorV2 | IntegrityErrorV2 | InternalErrorV2 | NotAuthenticatedErrorV2 | NotFoundErrorV2 | PrivateTalentBoolResponse | ValidationErrorV2;

export type TalisisNotConfiguredMutationError = {
  __typename?: 'TalisisNotConfiguredMutationError';
  errors: Array<Scalars['String']['output']>;
};

export type TalisisProductNotEnabledMutationError = {
  __typename?: 'TalisisProductNotEnabledMutationError';
  errors: Array<Scalars['String']['output']>;
};

export enum TaskTimeLimitCompleteEnum {
  DaysAfterAssignment = 'DAYS_AFTER_ASSIGNMENT',
  NoTimeLimit = 'NO_TIME_LIMIT',
  TaskIsAssigned = 'TASK_IS_ASSIGNED'
}

export enum TaskTypesEnum {
  TeamsSync = 'TEAMS_SYNC'
}

export type TaxRegimeListResponse = {
  __typename?: 'TaxRegimeListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<TaxRegimeType>;
};

export type TaxRegimeResponse = {
  __typename?: 'TaxRegimeResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: TaxRegimeType;
};

export type TaxRegimeType = {
  __typename?: 'TaxRegimeType';
  /** List of applicable person types derived from tax_type. */
  applicable_person_types: Array<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  tax_regime_code: Scalars['String']['output'];
  tax_regime_name: Scalars['String']['output'];
  tax_type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type TeamConditionalValueInput = {
  operation: SegmentationConditionalEnum;
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TeamFieldErrorNode = {
  __typename?: 'TeamFieldErrorNode';
  field: Scalars['String']['output'];
  key: Scalars['String']['output'];
  value_allowed?: Maybe<Scalars['String']['output']>;
};

export type TeamMemberInput = {
  role_type?: InputMaybe<TeamRoleTypeEnum>;
  user_id: Scalars['Int']['input'];
};

export type TeamMemberResponse = {
  __typename?: 'TeamMemberResponse';
  graphql_operation_id: Scalars['ID']['output'];
  organization_team_id?: Maybe<Scalars['Int']['output']>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  user_ids?: Maybe<Array<Scalars['Int']['output']>>;
};

export enum TeamRoleTypeEnum {
  Participant = 'PARTICIPANT',
  Supervisor = 'SUPERVISOR'
}

export enum TeamSearchFilterEnum {
  All = 'all',
  Completed = 'completed',
  Current = 'current',
  Disabled = 'disabled',
  Expired = 'expired'
}

export enum TeamSegmentationTypeEnum {
  DynamicType = 'DYNAMIC_TYPE',
  StaticType = 'STATIC_TYPE'
}

export enum TeamTypeEnum {
  Academy = 'ACADEMY',
  Track = 'TRACK'
}

export type TeamUserEnrollmentType = {
  __typename?: 'TeamUserEnrollmentType';
  avatar?: Maybe<Scalars['String']['output']>;
  centralized_user_id: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  has_enrollment?: Maybe<Scalars['Boolean']['output']>;
  last_name: Scalars['String']['output'];
  learning_user_id: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  user_custom_fields?: Maybe<Array<UserCustomFieldSelectedTag>>;
};

export type TeamUserEnrollmentTypePaginationEdge = {
  __typename?: 'TeamUserEnrollmentTypePaginationEdge';
  /** The item at the end of the edge. */
  node: TeamUserEnrollmentType;
};

export type TemplateCreateExampleInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional example description (max 500 characters) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Example name (required, max 150 characters) */
  name: Scalars['String']['input'];
};

export type TemplateCreateExamplePayload = {
  __typename?: 'TemplateCreateExamplePayload';
  /** The created example */
  example: TemplateExample;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type TemplateCreateExamplePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TemplateCreateExamplePayload | ValidationErrorResponse;

export type TemplateDefaultPayload = {
  __typename?: 'TemplateDefaultPayload';
  categories?: Maybe<Array<Maybe<FeedbackCategoryTemplatePayload>>>;
  competences?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Subgraph HRIS - assigned user detail (with downloads) for a document template */
export type TemplateDocumentUserDetailNode = {
  __typename?: 'TemplateDocumentUserDetailNode';
  /** Assignation date */
  assigned_at: Scalars['DateTime']['output'];
  /** Always 'No aplica' -- templates have no deadline */
  deadline: Scalars['String']['output'];
  /** How many times this user generated/downloaded the document */
  download_count: Scalars['Int']['output'];
  /** Whether this user has profile data missing for one or more wildcards of the template */
  has_incomplete_data: Scalars['Boolean']['output'];
  /** OrganizationUserDocument ID */
  id: Scalars['Int']['output'];
  /** Timestamp of the last download, null if never downloaded */
  last_downloaded_at?: Maybe<Scalars['DateTime']['output']>;
  /** Wildcards without a resolved value for this user */
  missing_wildcards: Array<HrisCorporateDocumentsDocumentTemplateMissingWildcard>;
  /** Always 'No aplica' -- templates have no progress lifecycle */
  progress: Scalars['String']['output'];
  /** User Full Name */
  user_fullname: Scalars['String']['output'];
};

export type TemplateDocumentUserDetailNodeCustomConnection = {
  __typename?: 'TemplateDocumentUserDetailNodeCustomConnection';
  edges: Array<TemplateDocumentUserDetailNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type TemplateDocumentUserDetailNodeCustomEdge = {
  __typename?: 'TemplateDocumentUserDetailNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TemplateDocumentUserDetailNode;
};

export type TemplateExample = {
  __typename?: 'TemplateExample';
  /** Organization ID */
  centralized_organization_id: Scalars['Int']['output'];
  /** Creation timestamp */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who created the example */
  created_by: Scalars['Int']['output'];
  /** Example description */
  description?: Maybe<Scalars['String']['output']>;
  /** Example unique identifier */
  id: Scalars['UUID']['output'];
  /** Whether the example is active */
  is_active: Scalars['Boolean']['output'];
  /** Example name */
  name: Scalars['String']['output'];
  /** Last update timestamp */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who last updated the example */
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TemplateExamplesMutations = {
  __typename?: 'TemplateExamplesMutations';
  /** Create a new example */
  create_example: TemplateCreateExamplePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
};


export type TemplateExamplesMutationsCreate_ExampleArgs = {
  input: TemplateCreateExampleInput;
};

export type TemplateExamplesQueries = {
  __typename?: 'TemplateExamplesQueries';
  /** Get an example by ID */
  get_example: TemplateGetExamplePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse;
  /** List active examples with search and pagination */
  list_examples: TemplateListExamplesPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
};


export type TemplateExamplesQueriesGet_ExampleArgs = {
  input: TemplateGetExampleInput;
};


export type TemplateExamplesQueriesList_ExamplesArgs = {
  input: TemplateListExamplesInput;
};

export type TemplateGetExampleInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** UUID of the example to retrieve */
  example_id: Scalars['ID']['input'];
};

export type TemplateGetExamplePayload = {
  __typename?: 'TemplateGetExamplePayload';
  /** The retrieved example */
  example: TemplateExample;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type TemplateGetExamplePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TemplateGetExamplePayload;

export type TemplateListExamplesInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Pagination configuration. Default: page 1, page_size 10 */
  pagination?: InputMaybe<TemplateListExamplesPaginationInput>;
  /** Search by name */
  search?: InputMaybe<TemplateListExamplesSearchInput>;
};

export type TemplateListExamplesPaginationInput = {
  /** Page number (1-based) */
  page?: Scalars['Int']['input'];
  /** Number of items per page */
  page_size?: Scalars['Int']['input'];
};

export type TemplateListExamplesPayload = {
  __typename?: 'TemplateListExamplesPayload';
  /** Page of examples matching the filters */
  examples: Array<TemplateExample>;
  /** Total examples matching the filters (without pagination) */
  total_count: Scalars['Int']['output'];
};

export type TemplateListExamplesPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TemplateListExamplesPayload;

export type TemplateListExamplesSearchInput = {
  /** Case-insensitive partial match on the example name */
  query: Scalars['String']['input'];
};

export type TemplateNode = {
  __typename?: 'TemplateNode';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  suggested_prompt: Array<SuggestedPromptNode>;
};

export enum TemplateOrientationEnum {
  OrientationHorizontalTemplate = 'ORIENTATION_HORIZONTAL_TEMPLATE',
  OrientationVerticalTemplate = 'ORIENTATION_VERTICAL_TEMPLATE'
}

/** Whether the template is a Crehana seed or user-authored */
export enum TemplateOrigin {
  Crehana = 'CREHANA',
  Custom = 'CUSTOM'
}

export enum TemplateRegulationTypeEnum {
  TemplateRegulationTypeDc3 = 'TEMPLATE_REGULATION_TYPE_DC3',
  TemplateRegulationTypeOwn = 'TEMPLATE_REGULATION_TYPE_OWN'
}

/** Sortable columns of the templates table */
export enum TemplateSortField {
  AudienceType = 'AUDIENCE_TYPE',
  Name = 'NAME',
  Origin = 'ORIGIN',
  UpdatedAt = 'UPDATED_AT'
}

export enum TemplateStatusEnum {
  TemplateStatusCompleted = 'TEMPLATE_STATUS_COMPLETED',
  TemplateStatusDeleted = 'TEMPLATE_STATUS_DELETED',
  TemplateStatusDraft = 'TEMPLATE_STATUS_DRAFT'
}

export enum TemplateType {
  TemplateAreaLevel = 'TEMPLATE_AREA_LEVEL',
  TemplateMassiveUsers = 'TEMPLATE_MASSIVE_USERS'
}

export enum TemplateTypeEnum {
  TemplateTypeCourse = 'TEMPLATE_TYPE_COURSE',
  TemplateTypeCourseElevate = 'TEMPLATE_TYPE_COURSE_ELEVATE',
  TemplateTypeCourseElevateAccreditation = 'TEMPLATE_TYPE_COURSE_ELEVATE_ACCREDITATION',
  TemplateTypeLiveSession = 'TEMPLATE_TYPE_LIVE_SESSION',
  TemplateTypeParticipationCertificate = 'TEMPLATE_TYPE_PARTICIPATION_CERTIFICATE',
  TemplateTypeTrack = 'TEMPLATE_TYPE_TRACK',
  TemplateTypeTrackAcademy = 'TEMPLATE_TYPE_TRACK_ACADEMY'
}

export type TerminateContractInput = {
  centralized_user_id: Scalars['Int']['input'];
  contract_id: Scalars['UUID']['input'];
  legal_entity_id?: InputMaybe<Scalars['UUID']['input']>;
  termination_date: Scalars['Date']['input'];
  termination_reason?: InputMaybe<Scalars['String']['input']>;
};

export type TerminateContractResponse = {
  __typename?: 'TerminateContractResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmployeeContractType;
};

export type TerminateContractResult = InternalErrorResponse | NotFoundErrorResponse | TerminateContractResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Un intento de operacion contra Terra IDSE. Registra hechos verificables —que se pidio, cuando, que respondio y si vino identificador— y nada mas: el proveedor no permite confirmar despues si una transaccion se realizo. */
export type TerraIdseAttemptType = {
  __typename?: 'TerraIdseAttemptType';
  /** Cuando se pidio. */
  attempted_at: Scalars['DateTime']['output'];
  /** Cierto cuando el intento devolvio el identificador del usuario. Solo puede serlo en un alta con exito. */
  identifier_obtained: Scalars['Boolean']['output'];
  /** Cierto cuando volver a intentar puede dar un resultado distinto. Un rechazo de datos no lo es: hay que corregir el dato primero. */
  is_retryable: Scalars['Boolean']['output'];
  /** Motivo del fallo, redactado para quien opera. Nunca lleva datos personales. `null` cuando el intento tuvo exito. */
  message?: Maybe<Scalars['String']['output']>;
  /** Cierto cuando el nombre o el apellido de quien opera se recortaron para caber en lo que Terra admite (30 y 25 caracteres). Explica por que el usuario ante el IMSS puede no llamarse exactamente como la persona. */
  name_truncated: Scalars['Boolean']['output'];
  /** Que se pidio. */
  operation: PayrollTerraIdseOperationEnum;
  /** En que termino. */
  outcome: PayrollTerraIdseOutcomeEnum;
  /** Codigo tipado con que respondio el servicio de contrato. `null` cuando el intento no llego a salir porque la validacion previa lo detuvo, que es justamente el caso en que no se gasto una llamada. */
  response_code?: Maybe<Scalars['String']['output']>;
};

/** Resultado de una operacion de certificado contra Terra IDSE. Devuelve el estado IDSE del registro patronal con el intento recien asentado: la operacion puede haber sido rechazada por el proveedor y aun asi la respuesta es un exito, porque lo que se confirma es que el certificado quedo guardado y que el intento quedo registrado. El motivo del rechazo esta en `last_certificate_attempt`. */
export type TerraIdseCertificateRegistrationResponse = {
  __typename?: 'TerraIdseCertificateRegistrationResponse';
  /** Cierto cuando la operacion llego a pedirse al proveedor. **Falso cuando no habia nada que pedir**: el certificado guardado es el que ya esta registrado, asi que no se gasto una llamada (AC-9). En ese caso `last_certificate_attempt` es el de una operacion anterior y no el resultado de esta, que es justo lo que este campo permite distinguir. */
  attempted: Scalars['Boolean']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  result: IdseStatusType;
};

/** Resultado de solicitar el alta del usuario de servicio de Terra IDSE. Devuelve el estado IDSE del registro patronal con el intento recien registrado: la solicitud puede haber fallado y aun asi la respuesta es un exito, porque lo que se confirma es que el intento quedo asentado. */
export type TerraIdseUserRegistrationResponse = {
  __typename?: 'TerraIdseUserRegistrationResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: IdseStatusType;
};

export type TextValueSegmentationInput = {
  custom_field_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  text_value?: InputMaybe<Scalars['String']['input']>;
};

export type ThemeOptionMetadataType = {
  __typename?: 'ThemeOptionMetadataType';
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type ThemeOptionPageNumberPagination = {
  __typename?: 'ThemeOptionPageNumberPagination';
  edges: Array<Dc3ThemeOptionNodePaginationEdge>;
  metadata?: Maybe<ThemeOptionMetadataType>;
  /** Information to aid in pagination. */
  page_info: NumberPageInfo;
  page_size?: Maybe<Scalars['Int']['output']>;
};

export type ThirdLevelAreaInput = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  area_level_id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  nodes?: InputMaybe<Array<FourthLevelAreaInput>>;
};

export type Thumbnail = {
  __typename?: 'Thumbnail';
  created_date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
  time: Scalars['Int']['output'];
  video_lecture_id: Scalars['Int']['output'];
};

export type TimeActivateOvertimeConfigInput = {
  /** Organization scope (required; enforced by AC-4) */
  centralized_organization_id: Scalars['Int']['input'];
  /** Overtime config unique identifier to activate */
  id: Scalars['UUID']['input'];
};

export type TimeActivateOvertimeConfigPayload = {
  __typename?: 'TimeActivateOvertimeConfigPayload';
  /** The activated configuration */
  overtime_config: TimeOvertimeConfig;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type TimeActivateOvertimeConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeActivateOvertimeConfigPayload;

export type TimeAndAttendanceAdminCreateJustificationError = {
  __typename?: 'TimeAndAttendanceAdminCreateJustificationError';
  /** PERMISSION_DENIED for the org gate; UNKNOWN for every other rejection */
  code: TimeAndAttendanceAdminCreateJustificationErrorCode;
  /** Human-readable rejection reason (for UNKNOWN, the HRIS/local validation message rides here verbatim) */
  message: Scalars['String']['output'];
};

export enum TimeAndAttendanceAdminCreateJustificationErrorCode {
  PermissionDenied = 'PERMISSION_DENIED',
  Unknown = 'UNKNOWN'
}

export type TimeAndAttendanceAdminCreateJustificationInput = {
  /** Centralized organization ID (org-scoping gate input) */
  centralized_organization_id: Scalars['Int']['input'];
  /** Collaborator the justificante is created for */
  centralized_user_id: Scalars['Int']['input'];
  /** Single day to justify (maps to an HRIS request with start_date = end_date = date) */
  date: Scalars['Date']['input'];
  /** Requested duration: FULL_DAY, or a half day (only when the policy allows half-day discount). The AM/PM half is display-only and is not persisted. */
  fraction: TimeJustificationFraction;
  /** Reason for the justificante (required, max 150 characters) */
  motivo: Scalars['String']['input'];
  /** HRIS Time Off policy the request is created under */
  policy_id: Scalars['ID']['input'];
  /** Optional evidence: 0 to 3 file references (20 MB total is enforced upstream by the file-upload subgraph) */
  request_files: Array<TimeJustificationRequestFileInput>;
};

export type TimeAndAttendanceAdminCreateJustificationSuccess = {
  __typename?: 'TimeAndAttendanceAdminCreateJustificationSuccess';
  /** ID of the created (auto-approved) HRIS request — the key the origin marker and TIM-337's delete-gating resolve on */
  request_id: Scalars['ID']['output'];
  /** Whether the operation was successful (always true here) */
  success: Scalars['Boolean']['output'];
};

export type TimeAndAttendanceAdminCreateJustificationSuccessTimeAndAttendanceAdminCreateJustificationErrorNotAuthenticatedErrorResponseInternalErrorResponse = InternalErrorResponse | NotAuthenticatedErrorResponse | TimeAndAttendanceAdminCreateJustificationError | TimeAndAttendanceAdminCreateJustificationSuccess;

export type TimeApplyBulkImportInput = {
  /** Organization scope for the import */
  centralized_organization_id: Scalars['Int']['input'];
  /** Original file name the FE sends, recorded as the import name */
  file_name: Scalars['String']['input'];
  /** Staged batch id to apply */
  import_batch_id: Scalars['ID']['input'];
  /** Decision applied to existing duplicate marks (OVERWRITE / IGNORE) */
  on_duplicate?: TimeBulkImportDuplicatePolicyEnum;
};

export type TimeApplyBulkImportPayload = {
  __typename?: 'TimeApplyBulkImportPayload';
  /** Marks newly created */
  created_count: Scalars['Int']['output'];
  /** Duplicate rows skipped (IGNORE / idéntica no-op) */
  ignored_count: Scalars['Int']['output'];
  /** Applied batch id */
  import_batch_id: Scalars['ID']['output'];
  /** Existing marks overwritten (OVERWRITE) */
  overwritten_count: Scalars['Int']['output'];
};

export type TimeApplyBulkImportPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeApplyBulkImportPayload | ValidationErrorResponse;

export type TimeAssignDeviceMarkingLocationInput = {
  /** Active marking place of the organization to attribute this device's FUTURE punches to */
  attendance_location_id: Scalars['UUID']['input'];
  /** Organization scope */
  centralized_organization_id: Scalars['Int']['input'];
  /** Device identifier as the provider reports it; not editable */
  device_id: Scalars['String']['input'];
  /** Punch provider that reports the device (e.g. 'ziphra') */
  provider: Scalars['String']['input'];
};

export type TimeAssignDeviceMarkingLocationPayload = {
  __typename?: 'TimeAssignDeviceMarkingLocationPayload';
  /** The mapping now in force for this device */
  device_location_mapping: TimeDeviceLocationMapping;
  /** Marking place the device pointed at before this call; null when this was the device's first assignment (AC-5) */
  previous_attendance_location_id?: Maybe<Scalars['UUID']['output']>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type TimeAssignDeviceMarkingLocationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeAssignDeviceMarkingLocationPayload | ValidationErrorResponse;

export type TimeAssignMarkingLocationInput = {
  /** Whether mobile app marking is allowed */
  allow_mobile_app: Scalars['Boolean']['input'];
  /** Whether the collaborator can mark from Attendance module locations */
  can_mark_from_module_places: Scalars['Boolean']['input'];
  /** Organization scope */
  centralized_organization_id: Scalars['Int']['input'];
  /** Attendance location ID to assign */
  marking_location_id: Scalars['UUID']['input'];
  /** Collaborator's centralized user ID */
  user_id: Scalars['Int']['input'];
};

export type TimeAssignMarkingLocationPayload = {
  __typename?: 'TimeAssignMarkingLocationPayload';
  /** The assigned marking location with attendance location details */
  marking_location?: Maybe<TimeAttendanceLocation>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type TimeAssignMarkingLocationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeAssignMarkingLocationPayload | ValidationErrorResponse;

export type TimeAssignShiftInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** End date of the assignment (YYYY-MM-DD). Null means indefinite. */
  end_date?: InputMaybe<Scalars['Date']['input']>;
  /** UUID of the shift to assign */
  shift_id: Scalars['ID']['input'];
  /** UUID of the starting cycle for rotating shifts. Required for rotating shifts, must be null for non-rotating shifts. */
  start_cycle_id?: InputMaybe<Scalars['ID']['input']>;
  /** Start date of the assignment (YYYY-MM-DD) */
  start_date: Scalars['Date']['input'];
  /** List of collaborator IDs to assign the shift to */
  user_ids: Array<Scalars['Int']['input']>;
};

export type TimeAssignShiftPayload = {
  __typename?: 'TimeAssignShiftPayload';
  /** List of created assignments (one per user_id) */
  assignments: Array<TimeShiftAssignment>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeAssignShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeAssignShiftPayload | TimeShiftAssignmentBlockedResponse | ValidationErrorResponse;

export type TimeAssignedUsersPaginationInput = {
  /** Page number (1-based). Default: 1. */
  page?: Scalars['Int']['input'];
  /** Number of items per page. Default: 10. */
  page_size?: Scalars['Int']['input'];
};

export type TimeAttendanceBreakTimeSlot = {
  __typename?: 'TimeAttendanceBreakTimeSlot';
  /** Label of the break (e.g., lunch) */
  break_label: Scalars['String']['output'];
  /** Duration of the break in minutes */
  duration_minutes: Scalars['Int']['output'];
  /** Break end adjusted by tolerance (null if no tolerance applies) */
  effective_break_end?: Maybe<Scalars['DateTime']['output']>;
  /** Break start adjusted by tolerance (null if no tolerance applies) */
  effective_break_start?: Maybe<Scalars['DateTime']['output']>;
  /** Scheduled break end time (ISO 8601 with offset) */
  end_time?: Maybe<Scalars['DateTime']['output']>;
  /** Display order of the break slot */
  position: Scalars['Int']['output'];
  /** Scheduled break start time (ISO 8601 with offset) */
  start_time?: Maybe<Scalars['DateTime']['output']>;
};

export type TimeAttendanceCardDay = {
  __typename?: 'TimeAttendanceCardDay';
  /** Calendar date */
  date: Scalars['Date']['output'];
  /** Day of the week (MONDAY..SUNDAY) */
  day_of_week: TimeDayOfWeek;
  /** Rendering hint (WORKING, NOT_WORKING, REST_CYCLE, NO_SHIFT) */
  day_status: TimeCardDayStatus;
  /** Expected events for this day (empty for non-working days) */
  events: Array<TimeAttendanceCardEvent>;
  /** Shift display name for this day (null when NO_SHIFT) */
  shift_name?: Maybe<Scalars['String']['output']>;
  /** NON_ROTATING or ROTATING for this day (null when NO_SHIFT) */
  shift_type?: Maybe<TimeShiftType>;
};

export type TimeAttendanceCardEvent = {
  __typename?: 'TimeAttendanceCardEvent';
  /** Type of event (ENTRY, BREAK_START, BREAK_END, EXIT) */
  event_type: TimeCardEventType;
  /** Actual mark timestamp (null if not yet registered) */
  registered_time?: Maybe<Scalars['DateTime']['output']>;
  /** Expected time from shift config (timezone-aware) */
  scheduled_time?: Maybe<Scalars['DateTime']['output']>;
  /** Classification of the mark (PENDING, NO_RECORD, ON_TIME, etc.) */
  status: TimeAttendanceMarkStatus;
};

export enum TimeAttendanceCardMetric {
  /** Count of days that count as attendance in the period. */
  AttendanceDays = 'ATTENDANCE_DAYS',
  /** Total excess net minutes in the period. */
  ExcessNet = 'EXCESS_NET',
  /** Total extra minutes in the period. */
  Extra = 'EXTRA',
  /** Total GROSS lost minutes in the period (tardiness + early exit + extended break), before Mechanism 1 nets it against same-day excess. Use this for punctuality: LOST_NET reports 0 for someone 30 min late who stayed 30 min longer. */
  Lost = 'LOST',
  /** Total lost net minutes in the period. */
  LostNet = 'LOST_NET',
  /** Count of paid justified absence days in the period. */
  PaidJustifiedAbsenceDays = 'PAID_JUSTIFIED_ABSENCE_DAYS',
  /** Total replacement minutes in the period. */
  Replacement = 'REPLACEMENT',
  /** Total scheduled minutes in the period. */
  Scheduled = 'SCHEDULED',
  /** Count of unjustified absence days (faltas) in the period. */
  UnjustifiedAbsenceDays = 'UNJUSTIFIED_ABSENCE_DAYS',
  /** Count of unpaid justified absence days in the period. */
  UnpaidJustifiedAbsenceDays = 'UNPAID_JUSTIFIED_ABSENCE_DAYS',
  /** Total worked net minutes in the period. */
  Worked = 'WORKED'
}

export type TimeAttendanceCardMetricFilterInput = {
  /** Strict lower bound in minutes for the period sum of the metric */
  gt_minutes: Scalars['Int']['input'];
  /** Which net hour-metric the threshold applies to */
  metric: TimeAttendanceCardMetric;
};

export type TimeAttendanceCardRow = {
  __typename?: 'TimeAttendanceCardRow';
  /** Σ days counted as attendance over the period (AC-2) */
  attendance_days: Scalars['Int']['output'];
  /** Σ net excess minutes (Mechanism-1-applied) over the period (AC-3) */
  excess_net_minutes_total: Scalars['Int']['output'];
  /** Σ assigned extra minutes over the period (AC-3). 0 when Mechanism 2 is inactive (AC-4/D3). */
  extra_minutes_total: Scalars['Int']['output'];
  /**
   * Deprecated; use `user`. Collaborator display name (best-effort).
   * @deprecated Use the federated `user` (`user.full_name`). Resolved imperatively and is null where the centralized-users name query is unavailable.
   */
  full_name?: Maybe<Scalars['String']['output']>;
  /** Σ justified-absence minutes EXCLUDING vacation policies — the numerator an absenteeism rate wants, since vacation is planned agreed time off, not absenteeism. Vacation is identified by matching the snapshotted policy-type NAME against a configured list, because HRIS models the policy type as free text per organization with no discriminator: an organization that renames its policy stops being excluded. Pair with scheduled minutes on the same row to build a rate. */
  justified_absence_minutes_excluding_vacation_total: Scalars['Int']['output'];
  /** Σ minutes of JUSTIFIED absence (approved Time Off) over the period. FULL coverage contributes the day's scheduled bracket, HALF contributes half of it. A degraded row (Time Off source unreachable) contributes nothing rather than a silent 0. */
  justified_absence_minutes_total: Scalars['Int']['output'];
  /** Σ gross lost minutes over the period (tardiness + early exit + extended break), BEFORE Mechanism 1 nets them against same-day excess. Compare with lost_net_minutes_total: the difference is the intra-day compensation the period absorbed. */
  lost_minutes_total: Scalars['Int']['output'];
  /** Σ net lost minutes (Mechanism-1-applied) over the period (AC-3) */
  lost_net_minutes_total: Scalars['Int']['output'];
  /** Σ days counted as paid justified absence (AC-2) */
  paid_justified_absence_days: Scalars['Int']['output'];
  /** Σ justified-absence minutes whose policy is PAID (con goce de haber). Paid + unpaid equals the total only when no row is degraded. */
  paid_justified_absence_minutes_total: Scalars['Int']['output'];
  /** Σ assigned replacement minutes over the period (AC-3). 0 when Mechanism 2 is inactive (AC-4/D3). */
  replacement_minutes_total: Scalars['Int']['output'];
  /** Σ scheduled minutes EXCLUDING holidays and vacation-covered days — the denominator for an absenteeism rate, so the same days are out of both sides of the ratio. Differs from scheduled_minutes_total, which does NOT exclude holidays: a holiday on a scheduled working weekday keeps its full bracket there. Vacation is identified by the same configured policy-type name list as the justified-absence totals, with the same known limitation. */
  scheduled_minutes_excluding_vacation_and_holiday_total: Scalars['Int']['output'];
  /** Σ minutes the collaborator was scheduled to work over the period, as calculated by the engine. Days with no shift assigned, Time Off without a shift, and worked holidays / rest days contribute 0 — they have no scheduled bracket. */
  scheduled_minutes_total: Scalars['Int']['output'];
  /** Σ days counted as unjustified absence (AC-2) */
  unjustified_absence_days: Scalars['Int']['output'];
  /** Σ unjustified-absence minutes over the period — feeds the 'Tiempo en ausencia' column (AC-3) */
  unjustified_absent_minutes_total: Scalars['Int']['output'];
  /** Σ days counted as unpaid justified absence (AC-2) */
  unpaid_justified_absence_days: Scalars['Int']['output'];
  /** Σ justified-absence minutes whose policy is UNPAID (sin goce de haber). */
  unpaid_justified_absence_minutes_total: Scalars['Int']['output'];
  /** Federated user reference — name/avatar resolved by the gateway (like TimeWorkday.user in TIM-210). Use `user.full_name`. Nullable by design: a period aggregate can include a collaborator whose centralized user no longer resolves (e.g. a deleted user with historical results), so the gateway degrades that row to `user=null` instead of failing the whole page on a non-null reference. (QA finding: ids unknown to centralized-users collapsed the entire response when `user` was non-null.) */
  user?: Maybe<CentralizedUserNode>;
  /** Collaborator identifier (centralized user original_id) */
  user_id: Scalars['Int']['output'];
  /** Σ worked minutes over the period (AC-3) */
  worked_minutes_total: Scalars['Int']['output'];
};

export enum TimeAttendanceCardSortField {
  AttendanceDays = 'ATTENDANCE_DAYS',
  ExcessNetMinutesTotal = 'EXCESS_NET_MINUTES_TOTAL',
  ExtraMinutesTotal = 'EXTRA_MINUTES_TOTAL',
  FullName = 'FULL_NAME',
  LostMinutesTotal = 'LOST_MINUTES_TOTAL',
  LostNetMinutesTotal = 'LOST_NET_MINUTES_TOTAL',
  PaidJustifiedAbsenceDays = 'PAID_JUSTIFIED_ABSENCE_DAYS',
  ReplacementMinutesTotal = 'REPLACEMENT_MINUTES_TOTAL',
  ScheduledMinutesTotal = 'SCHEDULED_MINUTES_TOTAL',
  UnjustifiedAbsenceDays = 'UNJUSTIFIED_ABSENCE_DAYS',
  UnpaidJustifiedAbsenceDays = 'UNPAID_JUSTIFIED_ABSENCE_DAYS',
  WorkedMinutesTotal = 'WORKED_MINUTES_TOTAL'
}

export type TimeAttendanceCardsQueries = {
  __typename?: 'TimeAttendanceCardsQueries';
  /** Merged mark + shift + overtime-adjustment change history for one collaborator over a period, most-recent-first (Historial de cambios drawer, TIM-226/TIM-306). Read-only — no recompute. */
  get_period_change_history: TimeGetPeriodChangeHistoryPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** Day-by-day attendance detail for one collaborator over a period (Tarjeta detallada drawer, TIM-226). Read-only — no recompute. */
  get_period_detail: TimeGetPeriodDetailPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** List per-(collaborator × period) attendance aggregates for the Attendance Cards admin screen (CU5) */
  list_attendance_cards: TimeListAttendanceCardsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** List the Time-Off-backed justified-absence days for one collaborator over a period, each enriched with the approval metadata ('aprobado por X el Y') from HRIS (Justificantes drawer, TIM-242). Read-only — no recompute. */
  list_period_justificantes: TimeListPeriodJustificantesPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeAttendanceCardsQueriesGet_Period_Change_HistoryArgs = {
  input: TimeGetPeriodChangeHistoryInput;
};


export type TimeAttendanceCardsQueriesGet_Period_DetailArgs = {
  input: TimeGetPeriodDetailInput;
};


export type TimeAttendanceCardsQueriesList_Attendance_CardsArgs = {
  input: TimeListAttendanceCardsInput;
};


export type TimeAttendanceCardsQueriesList_Period_JustificantesArgs = {
  input: TimeListPeriodJustificantesInput;
};

export type TimeAttendanceLocation = {
  __typename?: 'TimeAttendanceLocation';
  /** Attendance location address */
  address?: Maybe<Scalars['String']['output']>;
  /** Number of users assigned to this location */
  assigned_user_count: Scalars['Int']['output'];
  /** Organization ID */
  centralized_organization_id: Scalars['Int']['output'];
  /** Creation timestamp */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who created the location */
  created_by: Scalars['Int']['output'];
  /** Whether this location can anchor a geofence circle. False means the location is INCOMPLETE: the geofence resolver skips it, so it never validates a single mark even though it looks healthy in the listing. Surface it in the admin UI so the location can be fixed (TIM-410, AC-5). False when both coordinates are absent, or when they are exactly (0, 0) — a sentinel that passes range validation but is not a real place. Since TIM-410 no new location can be persisted this way; false only occurs on rows created earlier. */
  has_resolvable_coordinates: Scalars['Boolean']['output'];
  /** Federated reference to the OrganizationHeadquarterNode owned by centralized-organizations. Null only when location_type = CUSTOM_ADDRESS. When non-null, fields beyond original_id (name, address, latitude, longitude, etc.) are resolved by the gateway against centralized-organizations and may be null individually if the upstream entity has been deleted. */
  headquarter?: Maybe<OrganizationHeadquarterNode>;
  /** External headquarter ID when location type is HEADQUARTER */
  headquarter_id?: Maybe<Scalars['Int']['output']>;
  /** Attendance location unique identifier */
  id: Scalars['UUID']['output'];
  /** Whether the location is active */
  is_active: Scalars['Boolean']['output'];
  /** Geographic latitude in decimal degrees */
  latitude?: Maybe<Scalars['Decimal']['output']>;
  /** Authorized perimeter radius in meters */
  location_radius: Scalars['Int']['output'];
  /** Type of attendance location */
  location_type: TimeAttendanceLocationType;
  /** Geographic longitude in decimal degrees */
  longitude?: Maybe<Scalars['Decimal']['output']>;
  /** Attendance location name */
  name: Scalars['String']['output'];
  /** Last update timestamp */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who last updated the location */
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export enum TimeAttendanceLocationType {
  CustomAddress = 'CUSTOM_ADDRESS',
  Headquarter = 'HEADQUARTER'
}

export type TimeAttendanceLocationsMutations = {
  __typename?: 'TimeAttendanceLocationsMutations';
  /** Create a new attendance location */
  create_attendance_location: TimeCreateAttendanceLocationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
  /** Soft delete one or more attendance locations */
  delete_attendance_location: TimeDeleteAttendanceLocationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
  /** Edit an attendance location */
  edit_attendance_location: TimeEditAttendanceLocationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
};


export type TimeAttendanceLocationsMutationsCreate_Attendance_LocationArgs = {
  input: TimeCreateAttendanceLocationInput;
};


export type TimeAttendanceLocationsMutationsDelete_Attendance_LocationArgs = {
  input: TimeDeleteAttendanceLocationInput;
};


export type TimeAttendanceLocationsMutationsEdit_Attendance_LocationArgs = {
  input: TimeEditAttendanceLocationInput;
};

export type TimeAttendanceLocationsQueries = {
  __typename?: 'TimeAttendanceLocationsQueries';
  /** Get an attendance location by ID */
  get_attendance_location: TimeGetAttendanceLocationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse;
  /** List all active attendance locations with search and pagination */
  list_attendance_locations: TimeListAttendanceLocationsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
  /** List users with home marking enabled, paginated */
  list_home_marking_users: TimeListHomeMarkingUsersPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
};


export type TimeAttendanceLocationsQueriesGet_Attendance_LocationArgs = {
  input: TimeGetAttendanceLocationInput;
};


export type TimeAttendanceLocationsQueriesList_Attendance_LocationsArgs = {
  input: TimeListAttendanceLocationsInput;
};


export type TimeAttendanceLocationsQueriesList_Home_Marking_UsersArgs = {
  input: TimeListHomeMarkingUsersInput;
};

export type TimeAttendanceMark = {
  __typename?: 'TimeAttendanceMark';
  /** Resolved attendance location for this mark. Null when no GPS was sent (AC-8) or when geofence found no match while can_mark_from_any_place is True. */
  attendance_location?: Maybe<TimeAttendanceMarkLocation>;
  /** Mark identifier */
  id: Scalars['UUID']['output'];
  /** Date the mark belongs to */
  mark_date: Scalars['Date']['output'];
  /** Type of mark */
  mark_type: TimeAttendanceMarkType;
  /** UTC timestamp when the mark was recorded */
  marked_at: Scalars['DateTime']['output'];
  /** Ready-to-render photo node (TIM-335) with the uid and a server-templated download URL. Null when the mark has no photo. */
  photo?: Maybe<TimeAttendanceMarkPhoto>;
  /**
   * Opaque file reference (nanoid uid) for the photo associated with this mark, originated in crehana-subgraph-file. Null when the mark was recorded without a photo. Echoed verbatim; the frontend builds the secure download URL client-side (no server-side resolution).
   * @deprecated Use `photo { id url }` instead (TIM-335). The uid is still returned verbatim on `photo.id`; this scalar is kept for backward compatibility and will be removed once no consumer reads it.
   */
  photo_file_id?: Maybe<Scalars['ID']['output']>;
  /** Computed status of the mark relative to shift schedule */
  status: TimeAttendanceMarkStatus;
  /** IANA timezone from user's device */
  timezone: Scalars['String']['output'];
};

export type TimeAttendanceMarkConflictCandidate = {
  __typename?: 'TimeAttendanceMarkConflictCandidate';
  /** Attendance location address (may be null) */
  address?: Maybe<Scalars['String']['output']>;
  /** Haversine distance in meters between the device and this candidate */
  distance_meters: Scalars['Float']['output'];
  /** Attendance location ID */
  id: Scalars['UUID']['output'];
  /** Geographic latitude of the candidate location in decimal degrees */
  latitude: Scalars['Decimal']['output'];
  /** Geographic longitude of the candidate location in decimal degrees */
  longitude: Scalars['Decimal']['output'];
  /** Attendance location name */
  name: Scalars['String']['output'];
};

export type TimeAttendanceMarkConflictResponse = {
  __typename?: 'TimeAttendanceMarkConflictResponse';
  /** Candidate locations ordered ASC by distance_meters */
  candidates: Array<TimeAttendanceMarkConflictCandidate>;
  /** Stable code for the conflict outcome */
  code: Scalars['String']['output'];
  /** Correlation id for telemetry */
  graphql_operation_id: Scalars['ID']['output'];
  /** Human-readable message explaining the conflict */
  message: Scalars['String']['output'];
};

export type TimeAttendanceMarkListItem = {
  __typename?: 'TimeAttendanceMarkListItem';
  /** Marking location associated with this mark (coordinates, address and name for the detail map). Null when the mark has no registered location. */
  attendance_location?: Maybe<TimeAttendanceMarkLocation>;
  /** Stored classification status (not computed in this query) */
  classification?: Maybe<TimeAttendanceMarkStatus>;
  /** Mark identifier */
  id: Scalars['UUID']['output'];
  /** Integrity state of this row's cryptographic seal (TIM-399). NON-NULLABLE and always one of the five members — never `null`. `NOT_APPLICABLE` means 'No aplica': the row predates the seal and was never backfilled. It is NOT 'unknown' and NOT 'unverified' — that is `PENDING_CALCULATION`, for a row that IS sealed but was missing an input at seal time. Never branch on falsiness here: every member is a real state and must be discriminated by name. `CORRECTED` (an authorized edit re-sealed the row) and `ALTERED` (the verification sweep found the row was changed outside that flow) BOTH have a producer as of TIM-405 / TIM-406 and do return rows. Filtering by either is meaningful; render both states. */
  integrity_status: TimeMarkIntegrityStatus;
  /** Date the mark belongs to */
  mark_date: Scalars['Date']['output'];
  /** Type of mark (ENTRY, BREAK_START, BREAK_END, EXIT) */
  mark_type: TimeAttendanceMarkType;
  /** UTC timestamp when the mark was recorded */
  marked_at: Scalars['DateTime']['output'];
  /** Device-origin latitude captured at marking time (TIM-350). Distinct from `attendance_location.latitude`: this is where the device actually was, persisted even when the mark resolved to no location (mark-anywhere mode). Null when the mark was recorded without GPS. */
  origin_latitude?: Maybe<Scalars['Decimal']['output']>;
  /** Device-origin longitude captured at marking time (TIM-350). Distinct from `attendance_location.longitude`: this is where the device actually was, persisted even when the mark resolved to no location (mark-anywhere mode). Null when the mark was recorded without GPS. */
  origin_longitude?: Maybe<Scalars['Decimal']['output']>;
  /** Ready-to-render photo node (TIM-335) with the uid and a server-templated download URL. Null when the mark has no photo. */
  photo?: Maybe<TimeAttendanceMarkPhoto>;
  /**
   * Opaque file reference (nanoid uid) for the photo associated with this mark, originated in crehana-subgraph-file. Null when the mark was recorded without a photo. Echoed verbatim; the frontend builds the secure download URL client-side (no server-side resolution).
   * @deprecated Use `photo { id url }` instead (TIM-335). The uid is still returned verbatim on `photo.id`; this scalar is kept for backward compatibility and will be removed once no consumer reads it.
   */
  photo_file_id?: Maybe<Scalars['ID']['output']>;
  /** Resolved shift (null if no assignment) */
  shift?: Maybe<TimeAttendanceMarkShiftNode>;
  /** Origin of the mark, rendered as the 'Dispositivo' cell (TIM-190). EXCEL = bulk import ('Carga masiva'). */
  source: TimeMarkSource;
  /** IANA timezone from user's device */
  timezone: Scalars['String']['output'];
  /** Federated user reference */
  user: CentralizedUserNode;
};

export type TimeAttendanceMarkLocation = {
  __typename?: 'TimeAttendanceMarkLocation';
  /** Resolved attendance location address (may be null) */
  address?: Maybe<Scalars['String']['output']>;
  /** Haversine distance in meters between the device and the resolved location. Null when geofence was skipped (AC-4 selected by user) or on the marks-listing path. */
  distance_meters?: Maybe<Scalars['Float']['output']>;
  /** Resolved attendance location ID */
  id: Scalars['UUID']['output'];
  /** Latitude of the resolved location (may be null) */
  latitude?: Maybe<Scalars['Decimal']['output']>;
  /** Longitude of the resolved location (may be null) */
  longitude?: Maybe<Scalars['Decimal']['output']>;
  /** Resolved attendance location name */
  name: Scalars['String']['output'];
};

export type TimeAttendanceMarkPhoto = {
  __typename?: 'TimeAttendanceMarkPhoto';
  /** The stored file uid (nanoid). Same value as the sibling photo_file_id scalar. */
  id: Scalars['ID']['output'];
  /** Ready-to-render download URL, templated server-side from the uid as a relative/same-origin path (/api/v5/rest/files/download/{uid}/). Env-agnostic (no host). */
  url: Scalars['String']['output'];
};

export type TimeAttendanceMarkShiftNode = {
  __typename?: 'TimeAttendanceMarkShiftNode';
  /** Expected entry time for this date (HH:MM format, null if rest day) */
  expected_time?: Maybe<Scalars['String']['output']>;
  /** Shift UUID */
  id: Scalars['UUID']['output'];
  /** Shift name */
  name: Scalars['String']['output'];
  /** Raw HH:mm anchors per slot for the Edit jornada dialog (TIM-211); null on the marks-listing path where slots are not resolved. */
  shift_slots?: Maybe<TimeWorkdayShiftSlots>;
};

export enum TimeAttendanceMarkSortField {
  MarkedAt = 'MARKED_AT'
}

export enum TimeAttendanceMarkStatus {
  Acceptable = 'ACCEPTABLE',
  Early = 'EARLY',
  Late = 'LATE',
  NoRecord = 'NO_RECORD',
  OnTime = 'ON_TIME',
  OutOfSchedule = 'OUT_OF_SCHEDULE',
  Pending = 'PENDING',
  Registered = 'REGISTERED',
  SystemExit = 'SYSTEM_EXIT'
}

export enum TimeAttendanceMarkType {
  BreakEnd = 'BREAK_END',
  BreakStart = 'BREAK_START',
  Entry = 'ENTRY',
  Exit = 'EXIT'
}

export type TimeAttendanceMarksMutations = {
  __typename?: 'TimeAttendanceMarksMutations';
  /** Permanently delete a collaborator's attendance-mark photos (right-to-erasure). Admin-on-behalf-of: org-scoped via can_manage_organization. Deletes each photo in subgraph-file, unlinks photo_file_id on confirmation (the mark survives), and returns an aggregate confirmation. Idempotent; re-run until remaining_count reaches 0. */
  delete_collaborator_mark_photos: TimeDeleteCollaboratorMarkPhotosPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseIntegrityErrorResponseInternalErrorResponse;
  /** Record a single attendance mark */
  record_attendance_mark: TimeRecordAttendanceMarkPayloadTimeAttendanceMarkConflictResponseNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse;
};


export type TimeAttendanceMarksMutationsDelete_Collaborator_Mark_PhotosArgs = {
  input: TimeDeleteCollaboratorMarkPhotosInput;
};


export type TimeAttendanceMarksMutationsRecord_Attendance_MarkArgs = {
  input: TimeRecordAttendanceMarkInput;
};

export type TimeAttendanceMarksQueries = {
  __typename?: 'TimeAttendanceMarksQueries';
  /** Get the attendance card (period grid) for a user */
  get_attendance_card: TimeGetAttendanceCardPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
  /** Get the daily marking context for the attendance widget */
  get_daily_marking_context: TimeGetDailyMarkingContextPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
  /** Get the full integrity detail of ONE attendance mark: the 'Usuario y marca' block, the 'Integridad' block with the hash recomputed on the fly, and the alteration sub-block. Read-only — it never seals, never re-seals, and never writes. */
  get_mark_integrity_detail: TimeGetMarkIntegrityDetailResult;
  /** Get unregistered users from a leader's team on a date */
  get_team_unregistered_users: TimeGetTeamUnregisteredUsersPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** List attendance marks for admin management */
  list_attendance_marks: TimeListAttendanceMarksPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** List attendance marks for a leader's team (paginated) */
  list_team_attendance_marks: TimeListAttendanceMarksPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** List users with module config who have not registered on a date */
  list_unregistered_users: TimeListUnregisteredUsersPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeAttendanceMarksQueriesGet_Attendance_CardArgs = {
  input: TimeGetAttendanceCardInput;
};


export type TimeAttendanceMarksQueriesGet_Daily_Marking_ContextArgs = {
  input: TimeGetDailyMarkingContextInput;
};


export type TimeAttendanceMarksQueriesGet_Mark_Integrity_DetailArgs = {
  input: TimeGetMarkIntegrityDetailInput;
};


export type TimeAttendanceMarksQueriesGet_Team_Unregistered_UsersArgs = {
  input: TimeGetTeamUnregisteredUsersInput;
};


export type TimeAttendanceMarksQueriesList_Attendance_MarksArgs = {
  input: TimeListAttendanceMarksInput;
};


export type TimeAttendanceMarksQueriesList_Team_Attendance_MarksArgs = {
  input: TimeListTeamAttendanceMarksInput;
};


export type TimeAttendanceMarksQueriesList_Unregistered_UsersArgs = {
  input: TimeListUnregisteredUsersInput;
};

export enum TimeAttendanceReportConcept {
  /** Compensación — excess time netted against lost time instead of being paid. */
  CompensatedTime = 'COMPENSATED_TIME',
  /** Salida anticipada — minutes between the actual exit and the scheduled end of the journey, when the collaborator left early. A gross quantity: the same minutes also count inside the day's unjustified absence, and Payroll applies the rule. */
  EarlyDeparture = 'EARLY_DEPARTURE',
  /** Horas extra — overtime priced on the MAIN factor ladder. */
  ExtraHours = 'EXTRA_HOURS',
  /** Tiempo libre con goce — paid time off that is not sick leave. */
  PaidTimeOff = 'PAID_TIME_OFF',
  /** Incapacidad — the 'Enfermedad' time-off policy type. Takes precedence over paid/unpaid time off for the same day. */
  SickLeave = 'SICK_LEAVE',
  /** Jornada dominical — the journey worked on a day that falls on a Sunday, as a bare duration with no factor. It OVERLAPS the overtime and holiday concepts by design: Payroll applies the pay rule, Asistencia only reports the quantity. */
  SundayWorkday = 'SUNDAY_WORKDAY',
  /** Retardo — minutes the collaborator arrived late. */
  Tardiness = 'TARDINESS',
  /** Falta injustificada — absent minutes with no justificante. */
  UnjustifiedAbsence = 'UNJUSTIFIED_ABSENCE',
  /** Tiempo libre sin goce — unpaid time off. */
  UnpaidTimeOff = 'UNPAID_TIME_OFF',
  /** Trabajo en día festivo — overtime on the worked-holiday ladder. */
  WorkedHoliday = 'WORKED_HOLIDAY',
  /** Trabajo en descanso — overtime on the worked-rest ladder. */
  WorkedRestDay = 'WORKED_REST_DAY'
}

export enum TimeAttendanceReportExportFailureCategory {
  /** The requesting admin has no resolvable email address. */
  AdminEmailUnresolved = 'ADMIN_EMAIL_UNRESOLVED',
  /** Reading the period's attendance data failed. */
  DataReadFailed = 'DATA_READ_FAILED',
  /** The transactional email service could not be reached. */
  EmailUnavailable = 'EMAIL_UNAVAILABLE',
  /** The job row was committed but the queue refused the message, so nothing will ever pick it up. The request itself answered with an internal error. */
  EnqueueFailed = 'ENQUEUE_FAILED',
  /** The report exceeded the configured safety row bound. */
  RowLimitExceeded = 'ROW_LIMIT_EXCEEDED',
  /** Uploading the generated file failed. */
  StorageUnavailable = 'STORAGE_UNAVAILABLE',
  /** An unclassified failure. Check the job's failure_reason. */
  Unknown = 'UNKNOWN'
}

export type TimeAttendanceReportExportFilterInput = {
  /** Incidence concepts to include. De-duplicated server-side before validation, so [TARDINESS, TARDINESS] is ONE concept and never two rows in a payroll input file. At least one is required (CONCEPTS_REQUIRED); selecting the whole catalog is allowed. */
  concepts: Array<TimeAttendanceReportConcept>;
  /** Start of the INCLUSIVE period (VAL-001). A single-day report is valid: date_from == date_to is accepted. */
  date_from: Scalars['Date']['input'];
  /** End of the INCLUSIVE period (VAL-002). The range may span at most 31 calendar days — a wider window is rejected with MAX_RANGE_EXCEEDED, and date_to before date_from with INVALID_DATE_RANGE. */
  date_to: Scalars['Date']['input'];
};

export type TimeAttendanceReportExportNode = {
  __typename?: 'TimeAttendanceReportExportNode';
  /** When the consumer claimed the job. Null while QUEUED. */
  claimed_at?: Maybe<Scalars['DateTime']['output']>;
  /** When the job stopped moving — set on DONE and on ERROR. */
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  /** The requested concepts, de-duplicated and sorted — the criteria as the job will actually run them. */
  concepts: Array<TimeAttendanceReportConcept>;
  /** When the job was enqueued. */
  created_at: Scalars['DateTime']['output'];
  /** Start of the requested inclusive period. */
  date_from: Scalars['Date']['output'];
  /** End of the requested inclusive period. */
  date_to: Scalars['Date']['output'];
  /** When the emailed download link stops working. The URL itself is never exposed here — it exists only inside the email. */
  download_expires_at?: Maybe<Scalars['DateTime']['output']>;
  /** When the email was handed to Mailman AND accepted — which is not the same as delivered, so it must never be rendered as received. The Mailman consumer acks its own message even when the provider rejects it (measured in qa on 2026-08-18: Mandrill answered 401 Invalid_Key, the mail was dropped with no retry) and nothing reports that back, so this subgraph cannot see past the handoff. */
  email_sent_at?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier of the job. */
  export_id: Scalars['ID']['output'];
  /** Why the job failed. Populated only when status is ERROR. */
  failure_category?: Maybe<TimeAttendanceReportExportFailureCategory>;
  /** centralized_user_id of the admin who requested the report. */
  requested_by: Scalars['Int']['output'];
  /** Rows written to the sheet. Zero is a valid successful outcome: a period with no incidences yields a header-only file. */
  row_count: Scalars['Int']['output'];
  /** Current lifecycle state of the job. */
  status: TimeAttendanceReportExportStatus;
  /** How many COLLABORATORS in the period had no resolvable email address. One per person, not per row: a single unresolved collaborator can account for many missing rows across the period. Their rows are left OUT of the file (an anonymous row is unusable in a payroll input), so on a DONE job a positive value is a soft warning — the file shipped, but it is missing that many people. */
  unresolved_email_count: Scalars['Int']['output'];
};

export type TimeAttendanceReportExportNodeNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeAttendanceReportExportNode | ValidationErrorResponse;

export enum TimeAttendanceReportExportStatus {
  /** The .xlsx was uploaded and the email sent. Check unresolved_email_count: a positive value is a soft warning, not an error — the file still shipped. */
  Done = 'DONE',
  /** The job failed; failure_category says where. */
  Error = 'ERROR',
  /** The consumer claimed the job before doing any work, which is what makes a redelivery a no-op instead of a second email. */
  Processing = 'PROCESSING',
  /** Accepted and enqueued. The admin was answered without waiting for the file (RN-003). */
  Queued = 'QUEUED'
}

export type TimeAttendanceReportExportsMutations = {
  __typename?: 'TimeAttendanceReportExportsMutations';
  /** Request the asynchronous generation of the attendance-incidence report for a period and a set of concepts. Answers immediately with the job id; the .xlsx arrives by email with a time-limited link. */
  attendance_report_export_request: TimeRequestAttendanceReportExportPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
};


export type TimeAttendanceReportExportsMutationsAttendance_Report_Export_RequestArgs = {
  input: TimeRequestAttendanceReportExportInput;
};

export type TimeAttendanceReportExportsQueries = {
  __typename?: 'TimeAttendanceReportExportsQueries';
  /** Read the state of one attendance-report export job (QUEUED, PROCESSING, DONE, ERROR) so the request is never in an ambiguous state. Never returns a download URL — the link travels only in the delivery email. */
  attendance_report_export: TimeAttendanceReportExportNodeNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeAttendanceReportExportsQueriesAttendance_Report_ExportArgs = {
  input: TimeGetAttendanceReportExportInput;
};

export type TimeBreakConfig = {
  __typename?: 'TimeBreakConfig';
  /** Type of break */
  break_type: TimeBreakType;
  /** How break time is deducted */
  deduction_method: TimeBreakDeductionMethod;
};

export type TimeBreakConfigInput = {
  /** Type of break: FIXED_SCHEDULE (specific time) or FIXED_DURATION (defined duration) */
  break_type: TimeBreakType;
  /** How break time is deducted from worked hours */
  deduction_method: TimeBreakDeductionMethod;
};

export enum TimeBreakDeductionMethod {
  Fixed = 'FIXED',
  Real = 'REAL'
}

export enum TimeBreakLabel {
  CoffeeBreak = 'COFFEE_BREAK',
  Lunch = 'LUNCH',
  Rest = 'REST'
}

export type TimeBreakTimeSlot = {
  __typename?: 'TimeBreakTimeSlot';
  /** Label/type of the break (LUNCH, COFFEE_BREAK, REST) */
  break_label: TimeBreakLabel;
  /** Duration of this break in minutes */
  duration_minutes: Scalars['Int']['output'];
  /** Break end time in HH:MM format */
  end_time: Scalars['String']['output'];
  /** Position/order of this break (1, 2, 3...) */
  position: Scalars['Int']['output'];
  /** Break start time in HH:MM format */
  start_time: Scalars['String']['output'];
};

export type TimeBreakTimeSlotInput = {
  /** Label/type of the break (LUNCH, COFFEE_BREAK, REST) */
  break_label: TimeBreakLabel;
  /** Break end time in HH:MM format (represents returning to work) */
  end_time: Scalars['String']['input'];
  /** Break start time in HH:MM format (represents leaving work for break) */
  start_time: Scalars['String']['input'];
};

export enum TimeBreakType {
  FixedDuration = 'FIXED_DURATION',
  FixedSchedule = 'FIXED_SCHEDULE'
}

export type TimeBulkAssignmentRow = {
  __typename?: 'TimeBulkAssignmentRow';
  /** VALID_NEW / VALID_REPLACEMENT / INVALID */
  classification: TimeBulkRowClassification;
  /** Excel value (original casing) */
  email: Scalars['String']['output'];
  /** ISO YYYY-MM-DD; null when unparseable, blank, or no_end_date=true */
  end_date?: Maybe<Scalars['String']['output']>;
  /** Row-level error code; null when classification != INVALID */
  error_code?: Maybe<TimeBulkRowErrorCode>;
  /** Localized error message; null when classification != INVALID */
  message?: Maybe<Scalars['String']['output']>;
  /** True when the Excel column 'Sin fecha de fin' was truthy. Lets the FE distinguish open-ended from INVALID_DATE_FORMAT. */
  no_end_date: Scalars['Boolean']['output'];
  /** Zero-based index of the data row in the sheet */
  row_index: Scalars['Int']['output'];
  /** Resolved shift UUID; null when unresolved */
  shift_id?: Maybe<Scalars['ID']['output']>;
  /** Excel value (original casing) */
  shift_name: Scalars['String']['output'];
  /** ISO YYYY-MM-DD; null when unparseable */
  start_date?: Maybe<Scalars['String']['output']>;
  /** Resolved internal user id; null when unresolved */
  user_id?: Maybe<Scalars['Int']['output']>;
};

export enum TimeBulkImportDuplicatePolicyEnum {
  Ignore = 'IGNORE',
  Overwrite = 'OVERWRITE'
}

export type TimeBulkImportErrorGroupResult = {
  __typename?: 'TimeBulkImportErrorGroupResult';
  /** Number of rows in this group */
  count: Scalars['Int']['output'];
  /**
   * DEPRECATED (v3.2): always null; the FE resolves the description.
   * @deprecated Excel Validation Standard v3.2: the backend no longer translates. The FE resolves the group title/description from error_code / info_code (TIM-357). Scheduled for removal once Apollo shows 0 usage.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** Row error code (stable constant) */
  error_code: Scalars['String']['output'];
  /** Column identifier constants (UPPER_SNAKE_CASE) */
  headers: Array<Scalars['String']['output']>;
  /** Page-1 rows for this group */
  rows: TimeBulkImportPaginatedRows;
  /**
   * DEPRECATED (v3.2): echoes error_code; the FE resolves the title.
   * @deprecated Excel Validation Standard v3.2: the backend no longer translates. The FE resolves the group title/description from error_code / info_code (TIM-357). Scheduled for removal once Apollo shows 0 usage.
   */
  title: Scalars['String']['output'];
};

export type TimeBulkImportInfoGroupResult = {
  __typename?: 'TimeBulkImportInfoGroupResult';
  /** Number of rows in this group */
  count: Scalars['Int']['output'];
  /**
   * DEPRECATED (v3.2): always null; the FE resolves the description.
   * @deprecated Excel Validation Standard v3.2: the backend no longer translates. The FE resolves the group title/description from error_code / info_code (TIM-357). Scheduled for removal once Apollo shows 0 usage.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** Column identifier constants (UPPER_SNAKE_CASE) */
  headers: Array<Scalars['String']['output']>;
  /** Row info code (stable constant) */
  info_code: Scalars['String']['output'];
  /** Page-1 rows for this group */
  rows: TimeBulkImportPaginatedRows;
  /**
   * DEPRECATED (v3.2): echoes info_code; the FE resolves the title.
   * @deprecated Excel Validation Standard v3.2: the backend no longer translates. The FE resolves the group title/description from error_code / info_code (TIM-357). Scheduled for removal once Apollo shows 0 usage.
   */
  title: Scalars['String']['output'];
};

export type TimeBulkImportMarksInput = {
  /** Organization scope for the import */
  centralized_organization_id: Scalars['Int']['input'];
  /** subgraph-file id of the uploaded .xlsx marks file */
  file_id: Scalars['ID']['input'];
  /** IANA timezone selected in the wizard, used to build marked_at */
  timezone: Scalars['String']['input'];
};

export type TimeBulkImportMarksMutations = {
  __typename?: 'TimeBulkImportMarksMutations';
  /** Apply a staged bulk-import batch atomically (sync). */
  attendance_apply_bulk_import: TimeApplyBulkImportPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** Validate an uploaded marks .xlsx and stage it for review. */
  attendance_bulk_import_marks: TimeExcelValidationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeBulkImportMarksMutationsAttendance_Apply_Bulk_ImportArgs = {
  input: TimeApplyBulkImportInput;
};


export type TimeBulkImportMarksMutationsAttendance_Bulk_Import_MarksArgs = {
  input: TimeBulkImportMarksInput;
};

export type TimeBulkImportMarksQueries = {
  __typename?: 'TimeBulkImportMarksQueries';
  /** Bootstrap the review surface for a staged batch (page 1). */
  attendance_bulk_import_result: TimeBulkImportResultNodeNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse;
  /** Page a single section/code of a staged batch. */
  attendance_bulk_import_rows: TimeBulkImportRowsResultNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse;
  /** Download the bulk-import marks .xlsx template (base64 inline). */
  attendance_bulk_import_template: TimeBulkImportTemplatePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
};


export type TimeBulkImportMarksQueriesAttendance_Bulk_Import_ResultArgs = {
  input: TimeBulkImportResultInput;
};


export type TimeBulkImportMarksQueriesAttendance_Bulk_Import_RowsArgs = {
  input: TimeBulkImportRowsInput;
};


export type TimeBulkImportMarksQueriesAttendance_Bulk_Import_TemplateArgs = {
  input: TimeBulkImportTemplateInput;
};

export type TimeBulkImportPaginatedRows = {
  __typename?: 'TimeBulkImportPaginatedRows';
  /** Column identifier constants (UPPER_SNAKE_CASE); also the keys of each item. The FE resolves them to localized labels. */
  headers: Array<Scalars['String']['output']>;
  /** List of constant-keyed row objects for the page */
  items: Array<Scalars['JSON']['output']>;
  /** 1-based page number */
  page: Scalars['Int']['output'];
  /** Page size */
  page_size: Scalars['Int']['output'];
  /** Total rows in this section/code */
  total: Scalars['Int']['output'];
};

export type TimeBulkImportResultInput = {
  /** Staged batch id returned by the validate mutation */
  import_batch_id: Scalars['ID']['input'];
  /** Page size for the VALID rows page (max 100) */
  page_size?: Scalars['Int']['input'];
};

export type TimeBulkImportResultNode = {
  __typename?: 'TimeBulkImportResultNode';
  /** One entry per distinct ERROR code */
  error_groups: Array<TimeBulkImportErrorGroupResult>;
  /** One entry per distinct INFO code */
  info_groups: Array<TimeBulkImportInfoGroupResult>;
  /** Overall validate-phase status */
  status: TimeExcelValidationStatusEnum;
  /** Aggregate counts for the staged batch */
  summary: TimeExcelValidationSummary;
  /** Page-1 of the VALID section */
  valid_rows: TimeBulkImportValidSection;
};

export type TimeBulkImportResultNodeNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeBulkImportResultNode | ValidationErrorResponse;

export type TimeBulkImportRowsInput = {
  /** Row code to filter (required for ERROR and INFO sections) */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Staged batch id returned by the validate mutation */
  import_batch_id: Scalars['ID']['input'];
  /** 1-based page number */
  page?: Scalars['Int']['input'];
  /** Page size (max 100) */
  page_size?: Scalars['Int']['input'];
  /** Case-insensitive email substring filter */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Section to page (VALID / ERROR / INFO) */
  section: TimeBulkImportSection;
};

export type TimeBulkImportRowsResult = {
  __typename?: 'TimeBulkImportRowsResult';
  /** Row code filtered (null for VALID) */
  code?: Maybe<Scalars['String']['output']>;
  /** Column identifier constants (UPPER_SNAKE_CASE) */
  headers: Array<Scalars['String']['output']>;
  /** List of constant-keyed row objects for the page */
  items: Array<Scalars['JSON']['output']>;
  /** 1-based page number */
  page: Scalars['Int']['output'];
  /** Page size */
  page_size: Scalars['Int']['output'];
  /** Section paged (VALID / ERROR / INFO) */
  section: Scalars['String']['output'];
  /** Total rows in this section/code */
  total: Scalars['Int']['output'];
};

export type TimeBulkImportRowsResultNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeBulkImportRowsResult | ValidationErrorResponse;

export enum TimeBulkImportSection {
  Error = 'ERROR',
  Info = 'INFO',
  Valid = 'VALID'
}

export type TimeBulkImportShiftsMutations = {
  __typename?: 'TimeBulkImportShiftsMutations';
  /** Apply a staged bulk-import shift batch atomically (sync). */
  shifts_bulk_import_apply: TimeShiftsBulkImportApplyPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** Validate an uploaded shift-assignment .xlsx and stage it. */
  shifts_bulk_import_validate: TimeExcelValidationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeBulkImportShiftsMutationsShifts_Bulk_Import_ApplyArgs = {
  input: TimeShiftsBulkImportApplyInput;
};


export type TimeBulkImportShiftsMutationsShifts_Bulk_Import_ValidateArgs = {
  input: TimeShiftsBulkImportValidateInput;
};

export type TimeBulkImportShiftsQueries = {
  __typename?: 'TimeBulkImportShiftsQueries';
  /** Bootstrap the review surface for a staged shift batch (page 1). */
  shifts_bulk_import_result: TimeBulkImportResultNodeNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse;
  /** Page a single section/code of a staged shift batch. */
  shifts_bulk_import_rows: TimeBulkImportRowsResultNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse;
  /** Download the shift-assignment .xlsx template (base64 inline). */
  shifts_bulk_import_template: TimeBulkImportTemplatePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
};


export type TimeBulkImportShiftsQueriesShifts_Bulk_Import_ResultArgs = {
  input: TimeBulkImportResultInput;
};


export type TimeBulkImportShiftsQueriesShifts_Bulk_Import_RowsArgs = {
  input: TimeBulkImportRowsInput;
};


export type TimeBulkImportShiftsQueriesShifts_Bulk_Import_TemplateArgs = {
  input: TimeBulkImportTemplateInput;
};

export type TimeBulkImportTemplateInput = {
  /** Organization scope (authorization only; template is static) */
  centralized_organization_id: Scalars['Int']['input'];
};

export type TimeBulkImportTemplatePayload = {
  __typename?: 'TimeBulkImportTemplatePayload';
  /** Base64-encoded .xlsx template content (FE decodes to a Blob) */
  content_base64: Scalars['String']['output'];
  /** MIME type of the template file */
  content_type: Scalars['String']['output'];
  /** Suggested download file name */
  file_name: Scalars['String']['output'];
};

export type TimeBulkImportTemplatePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeBulkImportTemplatePayload;

export type TimeBulkImportValidSection = {
  __typename?: 'TimeBulkImportValidSection';
  /** Column identifier constants (UPPER_SNAKE_CASE); the FE resolves them to localized labels */
  headers: Array<Scalars['String']['output']>;
  /** List of constant-keyed VALID row objects for the page */
  items: Array<Scalars['JSON']['output']>;
  /** 1-based page number */
  page: Scalars['Int']['output'];
  /** Page size */
  page_size: Scalars['Int']['output'];
  /** Total VALID rows */
  total: Scalars['Int']['output'];
};

export enum TimeBulkRowClassification {
  Invalid = 'INVALID',
  ValidNew = 'VALID_NEW',
  ValidReplacement = 'VALID_REPLACEMENT'
}

export enum TimeBulkRowErrorCode {
  BulkRowPersistenceError = 'BULK_ROW_PERSISTENCE_ERROR',
  InvalidDateFormat = 'INVALID_DATE_FORMAT',
  MissingField = 'MISSING_FIELD',
  RotatingShiftNotSupported = 'ROTATING_SHIFT_NOT_SUPPORTED',
  ShiftInactive = 'SHIFT_INACTIVE',
  ShiftNotFound = 'SHIFT_NOT_FOUND',
  StartAfterEnd = 'START_AFTER_END',
  UserNotFound = 'USER_NOT_FOUND',
  UserNotInOrg = 'USER_NOT_IN_ORG'
}

export type TimeBulkShiftAssignmentInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Identifier returned by crehana-subgraph-file after S3 upload */
  file_id: Scalars['String']['input'];
};

export type TimeCancelOvertimeRequestInput = {
  /** Organization scope identifier. The caller must belong to it or the request is FORBIDDEN, refused before any read. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Identifier of the request to cancel — feed back the id the listing or the creation payload returned. It must be one of YOUR OWN requests and be PENDING or DENIED. A request that is not yours, or that does not exist, answers the SAME FORBIDDEN response on purpose: this operation is not an existence oracle. An APPROVED one answers OVERTIME_REQUEST_APPROVED_CANNOT_CANCEL, and cancelling an already-cancelled request succeeds again (it is idempotent). */
  overtime_request_id: Scalars['ID']['input'];
};

export type TimeCancelOvertimeRequestPayload = {
  __typename?: 'TimeCancelOvertimeRequestPayload';
  /** The request as it now stands, with status CANCELLED. Returned identically when the request was ALREADY cancelled — the operation is idempotent and a repeat is a success, not an error. */
  overtime_request: TimeOvertimeRequest;
};

export type TimeCancelOvertimeRequestPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeCancelOvertimeRequestPayload | ValidationErrorResponse;

export enum TimeCardDayStatus {
  NotWorking = 'NOT_WORKING',
  NoShift = 'NO_SHIFT',
  RestCycle = 'REST_CYCLE',
  Working = 'WORKING'
}

export enum TimeCardEventType {
  BreakEnd = 'BREAK_END',
  BreakStart = 'BREAK_START',
  Entry = 'ENTRY',
  Exit = 'EXIT'
}

export type TimeChangeShiftInput = {
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
  /** ISO date 'YYYY-MM-DD' whose shift is being changed */
  date: Scalars['Date']['input'];
  /** Optional admin note for the change (max 500 chars after trim; whitespace-only is stored as none). */
  motivo?: InputMaybe<Scalars['String']['input']>;
  /** Target shift UUID to assign for the day. Null or omitted clears the shift ('Quitar turno'). */
  new_shift_id?: InputMaybe<Scalars['ID']['input']>;
  /** Composite key '{user_original_id}-{date}' — same as TimeWorkday.id */
  record_id: Scalars['ID']['input'];
};

export type TimeChangeShiftPayload = {
  __typename?: 'TimeChangeShiftPayload';
  /** The recomputed workday — the FE replaces the table row with this */
  record: TimeWorkday;
  /** Whether the shift change was applied successfully */
  success: Scalars['Boolean']['output'];
};

export type TimeChangeShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeChangeShiftPayload | ValidationErrorResponse;

export type TimeClassifiedOvertimeCategory = {
  __typename?: 'TimeClassifiedOvertimeCategory';
  /** The pay multiplier applied to these minutes (e.g. 2.0, 3.0, 1.75). A FLOAT, not a closed enum: the admin's tier table allows any positive 0.1-step value with no upper bound, so 'dobles'/'triples' is a presentation label the FE derives — the BE only sends the number. */
  factor: Scalars['Float']['output'];
  /** Which factor ladder priced these minutes */
  group_type: TimeOvertimePaymentFactorGroup;
  /** Total minutes in the period priced at this factor */
  minutes: Scalars['Int']['output'];
  /** Day/night slot. Always DAY today (D7). */
  slot: TimeOvertimePaymentSlot;
};

export type TimeClassifiedOvertimeCollaborator = {
  __typename?: 'TimeClassifiedOvertimeCollaborator';
  /** One entry per (factor, group_type, slot) with minutes. Combinations with zero minutes are omitted; the entries sum to classified_minutes. */
  categories: Array<TimeClassifiedOvertimeCategory>;
  /** Sum of the minutes that received a factor */
  classified_minutes: Scalars['Int']['output'];
  /** Total extra minutes in the period. Reused verbatim from the shipped attendance-cards aggregate, never re-derived, so both screens always agree. Zero everywhere until the manual classification path starts populating extra time. */
  extra_minutes_total: Scalars['Int']['output'];
  /** Days whose rounding was skipped because the config's rounding tramos do not cover the full hour. Those days are still classified, with exact (unrounded) minutes. */
  rounding_degraded_days: Scalars['Int']['output'];
  /** True when unprocessed_minutes had to be clamped at 0. The three buckets then do NOT sum to extra_minutes_total: the totals and the breakdown were computed from different tables and have drifted (typically a day edited without re-running the engine). */
  totals_degraded: Scalars['Boolean']['output'];
  /** Sum of the minutes with no factor (see unclassified_reasons) */
  unclassified_minutes: Scalars['Int']['output'];
  /** One entry per degradation reason. The entries sum to unclassified_minutes. */
  unclassified_reasons: Array<TimeOvertimeUnclassifiedReasonCount>;
  /** Extra minutes that never passed through the classification engine (history predating the engine, plus the manual-edit paths). CLAMPED AT 0 — see totals_degraded. */
  unprocessed_minutes: Scalars['Int']['output'];
  /** Collaborator identifier (centralized user original_id) */
  user_id: Scalars['Int']['output'];
};

export type TimeCollaboratorAttendanceAccessQueries = {
  __typename?: 'TimeCollaboratorAttendanceAccessQueries';
  /** List the users with access to a collaborator's attendance information, paginated */
  list_users_with_attendance_access: TimeListUsersWithAttendanceAccessResult;
};


export type TimeCollaboratorAttendanceAccessQueriesList_Users_With_Attendance_AccessArgs = {
  input: TimeListUsersWithAttendanceAccessInput;
};

export type TimeCollaboratorCompliance = {
  __typename?: 'TimeCollaboratorCompliance';
  /** Sum of auto-compensated minutes — punctuality cancelled against excess within the day. Informative only: it scores NOTHING here, because the cap that would score it (COMP_SEMANA) is out of scope */
  compensated_minutes: Scalars['Int']['output'];
  /** Count of days with more than 0 gross excess, premium-bearing days excluded. This is the value DIAS_CON_HE is scored against */
  days_with_excess: Scalars['Int']['output'];
  /** Count of days whose calculation ran with a degraded external source (Time Off or holidays unreachable). The days were still evaluated, but a degraded holiday lookup means the day was classified as ordinary, so its excess is not the number a premium-bearing day would have had — which is the exact number that decides `state` */
  degraded_days: Scalars['Int']['output'];
  /** Count of days in the window with a scheduled shift. ZERO means no exigible ordinary jornada, so nothing was scored and `state` is NO_DATA — never NO_ALERTS */
  evaluable_days: Scalars['Int']['output'];
  /** Sum of GROSS excess minutes over the window, with the premium-bearing worked days EXCLUDED (holiday worked, rest day worked, worked time off). Deliberately NOT the same number the 'Tiempo excedente' card of Gestion diaria shows for the same week, which includes those days: work on a rest day is paid double and is not overtime, so it cannot count against the overtime caps */
  excess_minutes: Scalars['Int']['output'];
  /** Sum of authorized overtime minutes. Legitimately 0 for an organization with no active overtime configuration — that zero is real, not a missing producer */
  extra_minutes: Scalars['Int']['output'];
  /** Sum of the engine's scheduled bracket over the window */
  scheduled_minutes: Scalars['Int']['output'];
  /** The WORST of this collaborator's verdicts (EXCEEDED > AT_RISK > NO_ALERTS), or NO_DATA when `verdicts` is empty */
  state: TimeComplianceState;
  /** Federated user reference — name/avatar resolved by the gateway. Use `user.full_name`. Nullable by design: a collaborator with historical results whose centralized user no longer resolves degrades THIS row to `user=null` instead of collapsing the whole page on a non-null reference (TIM-225 QA finding) */
  user?: Maybe<CentralizedUserNode>;
  /** Collaborator identifier (centralized user original_id) */
  user_id: Scalars['Int']['output'];
  /** One entry per cap that was actually scored for this collaborator. EMPTY when nothing could be measured (`state` NO_DATA). A cap that is inactive, or active with an incomplete band, is omitted — never reported with a zeroed value */
  verdicts: Array<TimeComplianceThresholdVerdict>;
  /** Sum of worked minutes over the window. Informative — it includes the premium-bearing days that the caps exclude, so a NO_DATA row can legitimately show a full worked day */
  worked_minutes: Scalars['Int']['output'];
};

export type TimeCollaboratorComplianceDetailPayload = {
  __typename?: 'TimeCollaboratorComplianceDetailPayload';
  /** Always seven rows, Monday first, gap days synthesized */
  days: Array<TimeComplianceDayRow>;
  /** The DAY-window caps actually scored on each day row, after dropping inactive or incomplete ones. Empty ⇒ every day is NO_DATA */
  evaluated_day_codes: Array<TimeComplianceThresholdCode>;
  /** The WEEK-window caps actually scored on the total row. Empty ⇒ the total is NO_DATA */
  evaluated_week_codes: Array<TimeComplianceThresholdCode>;
  /** The resolved LFT week (window is always WEEK): Monday..Sunday, both inclusive */
  period: TimeCompliancePeriod;
  /** The week's total row. The same aggregate the listing renders for this collaborator and week, by construction */
  total: TimeComplianceWeekTotal;
  /** Federated reference to the collaborator; the gateway resolves the name. Nullable by design: an unresolvable user degrades to null instead of collapsing the payload */
  user?: Maybe<CentralizedUserNode>;
  /** Centralized id of the collaborator */
  user_id: Scalars['Int']['output'];
};

/** Collaborator marking configuration exposed to other subgraphs */
export type TimeCollaboratorMarkingConfig = {
  __typename?: 'TimeCollaboratorMarkingConfig';
  /** Whether computer marking is allowed */
  allow_computer: Scalars['Boolean']['output'];
  /** Whether mobile app marking is allowed */
  allow_mobile_app: Scalars['Boolean']['output'];
  /** Whether the collaborator can mark from any unspecified location */
  can_mark_from_any_place: Scalars['Boolean']['output'];
  /** Whether the collaborator can mark from their home address */
  can_mark_from_home: Scalars['Boolean']['output'];
  /** Whether the collaborator can mark from Attendance module locations */
  can_mark_from_module_places: Scalars['Boolean']['output'];
  /** Organization scope */
  centralized_organization_id: Scalars['Int']['output'];
  /** Creation timestamp */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who created the config */
  created_by: Scalars['Int']['output'];
  /** Config unique identifier */
  id: Scalars['UUID']['output'];
  /** Attendance locations assigned to this collaborator */
  marking_locations: Array<TimeAttendanceLocation>;
  /** Whether the collaborator must register attendance from a device */
  must_register_from_device: Scalars['Boolean']['output'];
  /** Last update timestamp */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who last updated the config */
  updated_by?: Maybe<Scalars['Int']['output']>;
  /** Collaborator's centralized user ID */
  user_id: Scalars['Int']['output'];
};

export type TimeCollaboratorMarkingConfigsMutations = {
  __typename?: 'TimeCollaboratorMarkingConfigsMutations';
  /** Assign an attendance location to a collaborator's marking config */
  assign_marking_location: TimeAssignMarkingLocationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
  /** Create a new collaborator marking configuration */
  create_collaborator_marking_config: TimeCreateCollaboratorMarkingConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
  /** Remove an attendance location from a collaborator's marking config */
  unassign_marking_location: TimeUnassignMarkingLocationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse;
  /** Update a collaborator's marking configuration */
  update_collaborator_marking_config: TimeUpdateCollaboratorMarkingConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
};


export type TimeCollaboratorMarkingConfigsMutationsAssign_Marking_LocationArgs = {
  input: TimeAssignMarkingLocationInput;
};


export type TimeCollaboratorMarkingConfigsMutationsCreate_Collaborator_Marking_ConfigArgs = {
  input: TimeCreateCollaboratorMarkingConfigInput;
};


export type TimeCollaboratorMarkingConfigsMutationsUnassign_Marking_LocationArgs = {
  input: TimeUnassignMarkingLocationInput;
};


export type TimeCollaboratorMarkingConfigsMutationsUpdate_Collaborator_Marking_ConfigArgs = {
  input: TimeUpdateCollaboratorMarkingConfigInput;
};

export type TimeCollaboratorMarkingConfigsQueries = {
  __typename?: 'TimeCollaboratorMarkingConfigsQueries';
  /** Get a collaborator's marking configuration with paginated locations */
  get_collaborator_marking_config: TimeGetCollaboratorMarkingConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse;
  /** Batch-read the marking configuration of several collaborators, each with its assigned marking locations */
  list_collaborator_marking_configs: TimeListCollaboratorMarkingConfigsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeCollaboratorMarkingConfigsQueriesGet_Collaborator_Marking_ConfigArgs = {
  input: TimeGetCollaboratorMarkingConfigInput;
};


export type TimeCollaboratorMarkingConfigsQueriesList_Collaborator_Marking_ConfigsArgs = {
  input: TimeListCollaboratorMarkingConfigsInput;
};

export enum TimeComplianceCountry {
  Mx = 'MX'
}

export type TimeComplianceDayRow = {
  __typename?: 'TimeComplianceDayRow';
  /** Minutes auto-compensated that day (the same column the listing reports). Informative: the compensation cap is not evaluated */
  compensated_minutes: Scalars['Int']['output'];
  /** The calendar day */
  date: Scalars['Date']['output'];
  /** The engine's persisted day status (same enum as Gestión diaria); null on a synthesized day */
  day_status?: Maybe<TimeDayStatus>;
  /** True when the day was calculated with a degraded external source (Time Off or holidays unreachable). Scored anyway, but its excess may not be the number a premium day would have had */
  degraded: Scalars['Boolean']['output'];
  /** GROSS excess of the day, HE-ELIGIBLE: 0 on a premium-bearing day (worked holiday, worked rest day, worked time off) even though the engine wrote the whole jornada there. This is the number HE_DIARIA is scored against, so it can differ from Gestión diaria's excess for the same day */
  excess_minutes: Scalars['Int']['output'];
  /** Minutes the engine classified as paid overtime that day */
  extra_minutes: Scalars['Int']['output'];
  /** False when the engine persisted no row for this day: every minute is then 0, state is NO_DATA, verdicts is empty and day_status / shift_name are null. Never an error (AC-3) */
  has_result: Scalars['Boolean']['output'];
  /** True when the day had a scheduled bracket (scheduled_minutes > 0) and could therefore be scored. False is exactly the NO_DATA case */
  is_evaluable: Scalars['Boolean']['output'];
  /** The engine's scheduled bracket for the day; 0 without a shift */
  scheduled_minutes: Scalars['Int']['output'];
  /** Name of the shift the day was calculated against, as the engine snapshotted it. ONE name per row: a two-shift day is one row with the minutes summed, and which name it should show is an open product question (RN-051) — until then this is the snapshot as persisted. Null without a shift or on a synthesized day */
  shift_name?: Maybe<Scalars['String']['output']>;
  /** The worst verdict among the DAY-window caps for this day, or NO_DATA when the day has no scheduled bracket (no shift, or no row) or no DAY cap is evaluable */
  state: TimeComplianceState;
  /** One verdict per DAY-window cap scored for this day (today only HE_DIARIA). Empty exactly when state is NO_DATA */
  verdicts: Array<TimeComplianceThresholdVerdict>;
  /** Worked minutes of the day. Informative — real even on a premium-bearing day or a NO_DATA no-shift day with marks */
  worked_minutes: Scalars['Int']['output'];
};

export type TimeComplianceEvaluationQueries = {
  __typename?: 'TimeComplianceEvaluationQueries';
  /** Break down ONE collaborator's LFT week (Monday..Sunday) against the MX overtime-compliance caps: seven day rows scored against the DAY caps plus one total row scored against the WEEK caps, in a single operation. The week is the one containing reference_date, or today's when omitted. Read-only: it never recomputes, never writes, and cannot block mark registration, overtime calculation or the payroll push. A collaborator with no calculated day returns seven NO_DATA rows and a NO_DATA total, never an error */
  get_collaborator_compliance_detail: TimeGetCollaboratorComplianceDetailResult;
  /** Evaluate every collaborator of the organization against the effective MX overtime-compliance caps for a DAY or WEEK window and return each one's traffic-light state plus the four per-state counts. Read-only: it never recomputes, never writes, and cannot block mark registration, overtime calculation or the payroll push. The population is the collaborators with at least one calculated day in the window — a collaborator with no shift AND no marks for the whole window has no row and does not appear at all */
  list_collaborator_compliance: TimeListCollaboratorComplianceResult;
};


export type TimeComplianceEvaluationQueriesGet_Collaborator_Compliance_DetailArgs = {
  input: TimeGetCollaboratorComplianceDetailInput;
};


export type TimeComplianceEvaluationQueriesList_Collaborator_ComplianceArgs = {
  input: TimeListCollaboratorComplianceInput;
};

export type TimeCompliancePeriod = {
  __typename?: 'TimeCompliancePeriod';
  /** First day of the resolved window, inclusive. Equal to date_to for DAY; the Monday of the LFT week for WEEK */
  date_from: Scalars['Date']['output'];
  /** Last day of the resolved window, inclusive. The Sunday of the LFT week for WEEK */
  date_to: Scalars['Date']['output'];
  /** The requested window (DAY or WEEK) */
  window: TimeComplianceThresholdEvaluationWindow;
};

export type TimeCompliancePeriodInput = {
  /** Any date inside the window to evaluate — for WEEK it need not be the Monday. Defaults to today resolved in `timezone` (UTC when that is omitted or invalid). The resolved window always comes back in `period`, so the caller can see which day it got */
  reference_date?: InputMaybe<Scalars['Date']['input']>;
  /** DAY evaluates the reference date alone and scores only the DAY-window caps. WEEK evaluates the inclusive Monday-to-Sunday LFT week containing the reference date and scores the WEEK caps over the week plus the DAY cap day by day, with the WORST day winning */
  window: TimeComplianceThresholdEvaluationWindow;
};

export enum TimeComplianceState {
  AtRisk = 'AT_RISK',
  Exceeded = 'EXCEEDED',
  NoAlerts = 'NO_ALERTS',
  NoData = 'NO_DATA'
}

export type TimeComplianceStateCounts = {
  __typename?: 'TimeComplianceStateCounts';
  /** Collaborators whose worst cap landed in the amber band */
  at_risk: Scalars['Int']['output'];
  /** Collaborators who passed at least one legal cap */
  exceeded: Scalars['Int']['output'];
  /** Collaborators below every green break */
  no_alerts: Scalars['Int']['output'];
  /** Collaborators for whom NOTHING could be measured — no scheduled day in the window, or no active cap with a complete band. Not a green */
  no_data: Scalars['Int']['output'];
};

export type TimeComplianceThreshold = {
  __typename?: 'TimeComplianceThreshold';
  /** Drawer section. A property of the code, not of the org */
  category: TimeComplianceThresholdCategory;
  /** Which of the six MX thresholds this is */
  code: TimeComplianceThresholdCode;
  /** Window the threshold is evaluated over (DAY or WEEK). A property of the code. WEEK is the inclusive Monday-to-Sunday LFT week; the timezone that resolves an omitted reference date travels in the request, not in the organization record (TIM-544 D15) */
  evaluation_window: TimeComplianceThresholdEvaluationWindow;
  /** True when this threshold is LAXER than the legal floor (risk_until above it). Informative only — it never blocks a save. Always false for an inactive threshold */
  exceeds_legal_floor: Scalars['Boolean']['output'];
  /** Whether this threshold participates in evaluation. An inactive threshold KEEPS its values, so reactivating restores them */
  is_active: Scalars['Boolean']['output'];
  /** Legal-floor reference for normal_until, in the code's unit */
  legal_normal_until: Scalars['Int']['output'];
  /** Legal-floor reference for risk_until, in the code's unit */
  legal_risk_until: Scalars['Int']['output'];
  /** Unit of normal_until/risk_until: MINUTES for whole minutes, DAYS for whole days. The discriminator for the value fields */
  metric: TimeComplianceThresholdMetric;
  /** Upper break of the green band, in the unit given by metric. Null only on a row that was never given a value */
  normal_until?: Maybe<Scalars['Int']['output']>;
  /** Upper break of the amber band, in the unit given by metric. May EQUAL normal_until (required for COMP_SEMANA = 0/0) */
  risk_until?: Maybe<Scalars['Int']['output']>;
  /** PERSISTED when a row exists for this code, DEFAULT when the value was synthesized from the domain defaults. Row existence, not value equality */
  source: TimeComplianceThresholdSource;
  /** Last real change. Null on a DEFAULT threshold (no row was ever written) — render 'nunca modificado', never a blank date */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Centralized user id of the last editor; null on a DEFAULT */
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export enum TimeComplianceThresholdCategory {
  Compensation = 'COMPENSATION',
  Overtime = 'OVERTIME',
  WorkTime = 'WORK_TIME'
}

export enum TimeComplianceThresholdCode {
  CompSemana = 'COMP_SEMANA',
  DiasConHe = 'DIAS_CON_HE',
  HeDiaria = 'HE_DIARIA',
  HeSemanalTotal = 'HE_SEMANAL_TOTAL',
  JornadaTotal = 'JORNADA_TOTAL',
  JornadaTotalSemana = 'JORNADA_TOTAL_SEMANA'
}

export type TimeComplianceThresholdEntryInput = {
  /** Which of the six MX thresholds this entry sets */
  code: TimeComplianceThresholdCode;
  /** Whether the threshold participates in evaluation. Flipping this IS a real change and is written and audited on its own */
  is_active: Scalars['Boolean']['input'];
  /** Upper break of the green band, in the unit the code's metric gives (MINUTES = whole minutes, DAYS = whole days). Omit or send null to leave the current value untouched. Must be >= 0; zero is valid */
  normal_until?: InputMaybe<Scalars['Int']['input']>;
  /** Upper break of the amber band, same unit as normal_until. Omit or send null to leave the current value untouched. Must be >= normal_until; equality is valid and required for COMP_SEMANA */
  risk_until?: InputMaybe<Scalars['Int']['input']>;
};

export enum TimeComplianceThresholdErrorCode {
  DuplicateCode = 'DUPLICATE_CODE',
  EmptyThresholdList = 'EMPTY_THRESHOLD_LIST',
  ExceedsDailyTotal = 'EXCEEDS_DAILY_TOTAL',
  ExceedsWeekDays = 'EXCEEDS_WEEK_DAYS',
  ExceedsWindowCapacity = 'EXCEEDS_WINDOW_CAPACITY',
  MustBeNonNegative = 'MUST_BE_NON_NEGATIVE',
  RequiredWhenActive = 'REQUIRED_WHEN_ACTIVE',
  RiskBelowNormal = 'RISK_BELOW_NORMAL'
}

export enum TimeComplianceThresholdEvaluationWindow {
  Day = 'DAY',
  Week = 'WEEK'
}

export enum TimeComplianceThresholdField {
  IsActive = 'IS_ACTIVE',
  NormalUntil = 'NORMAL_UNTIL',
  RiskUntil = 'RISK_UNTIL'
}

export type TimeComplianceThresholdFieldError = {
  __typename?: 'TimeComplianceThresholdFieldError';
  /** Threshold the verdict is about. Null for a verdict on the LIST itself (EMPTY_THRESHOLD_LIST) */
  code?: Maybe<TimeComplianceThresholdCode>;
  /** Stable code the FE translates to copy */
  error_code: TimeComplianceThresholdErrorCode;
  /** Input the verdict points at, for form-field mapping. Null when the verdict is about the threshold or the list as a whole */
  field?: Maybe<TimeComplianceThresholdField>;
  /** The OTHER threshold involved in a cross-threshold rule, when there is one. Lets the FE say 'no puedes bajar Jornada total a 8h porque HE diaria esta en 4h' instead of blaming an input the admin never touched. Null for single-threshold verdicts */
  related_code?: Maybe<TimeComplianceThresholdCode>;
};

export enum TimeComplianceThresholdMetric {
  Days = 'DAYS',
  Minutes = 'MINUTES'
}

export enum TimeComplianceThresholdSource {
  Default = 'DEFAULT',
  Persisted = 'PERSISTED'
}

export type TimeComplianceThresholdValidationErrorResponse = {
  __typename?: 'TimeComplianceThresholdValidationErrorResponse';
  /** Error code */
  code: Scalars['String']['output'];
  /** One entry per violated rule; never empty */
  errors: Array<TimeComplianceThresholdFieldError>;
  /** Operation ID for tracing */
  graphql_operation_id: Scalars['ID']['output'];
  /** Error message */
  message: Scalars['String']['output'];
};

export type TimeComplianceThresholdVerdict = {
  __typename?: 'TimeComplianceThresholdVerdict';
  /** Which MX cap this verdict is about */
  code: TimeComplianceThresholdCode;
  /** The cap's OWN window (a property of the code), not the requested one. A DAY cap appearing in a WEEK request was scored day by day */
  evaluation_window: TimeComplianceThresholdEvaluationWindow;
  /** Unit of `value`, `normal_until` and `risk_until`: MINUTES for whole minutes, DAYS for whole days. A property of the code */
  metric: TimeComplianceThresholdMetric;
  /** Upper break of the green band this verdict was computed against */
  normal_until: Scalars['Int']['output'];
  /** Upper break of the amber band this verdict was computed against. Equal to normal_until means the amber band is empty and AT_RISK is unreachable for this cap */
  risk_until: Scalars['Int']['output'];
  /** Band `value` fell in for this cap. Never NO_DATA — an unmeasurable cap produces no verdict at all instead of a null one */
  state: TimeComplianceState;
  /** The measured value, in the unit `metric` gives. For HE_DIARIA in a WEEK window this is the WORST single day, not a weekly sum. For DIAS_CON_HE it is a day COUNT compared against a day count */
  value: Scalars['Int']['output'];
};

export type TimeComplianceThresholdsMutations = {
  __typename?: 'TimeComplianceThresholdsMutations';
  /** Restore the legal-floor defaults for all six of the organization's MX overtime-compliance thresholds (TIM-549). Uses the same per-threshold diff as the save, so only codes that actually differ are written and audited with kind=RESET; an organization with no rows is a COMPLETE no-op, because its effective catalog already IS the default. */
  reset_compliance_thresholds: TimeResetComplianceThresholdsResult;
  /** Save one or more of the organization's MX overtime-compliance thresholds. Partial: codes absent from the list are left untouched, and only codes whose (is_active, normal_until, risk_until) triple actually differs are written and audited — so re-submitting the catalog unchanged writes nothing and returns changed_codes: []. Cross-threshold rules are always evaluated against the FULL effective catalog, so a partial list cannot bypass them. */
  save_compliance_thresholds: TimeSaveComplianceThresholdsResult;
};


export type TimeComplianceThresholdsMutationsReset_Compliance_ThresholdsArgs = {
  input: TimeResetComplianceThresholdsInput;
};


export type TimeComplianceThresholdsMutationsSave_Compliance_ThresholdsArgs = {
  input: TimeSaveComplianceThresholdsInput;
};

export type TimeComplianceThresholdsQueries = {
  __typename?: 'TimeComplianceThresholdsQueries';
  /** Read the organization's six MX overtime-compliance thresholds with their traffic-light breaks. A code the organization never saved comes back synthesized from the legal defaults with source=DEFAULT — 'no rows' is the default, never an absence, so this never returns NotFound and never writes anything. */
  list_compliance_thresholds: TimeListComplianceThresholdsResult;
};


export type TimeComplianceThresholdsQueriesList_Compliance_ThresholdsArgs = {
  input: TimeListComplianceThresholdsInput;
};

export type TimeComplianceWeekTotal = {
  __typename?: 'TimeComplianceWeekTotal';
  /** Sum of auto-compensated minutes over the week — the 'tiempo de compensación' column of RN-051 as an INFORMATIVE total. Which column that concept should read is the open question that descoped the compensation cap; this one is the listing's, so the two screens agree */
  compensated_minutes: Scalars['Int']['output'];
  /** Days of the week with HE-eligible excess > 0 — the value DIAS_CON_HE is scored against */
  days_with_excess: Scalars['Int']['output'];
  /** Days calculated with a degraded external source */
  degraded_days: Scalars['Int']['output'];
  /** Days with a scheduled bracket. 0 is exactly the NO_DATA total */
  evaluable_days: Scalars['Int']['output'];
  /** Sum of GROSS, HE-eligible excess over the week — the value HE_SEMANAL_TOTAL is scored against. Equals the sum of the day rows' excess_minutes */
  excess_minutes: Scalars['Int']['output'];
  /** Sum of minutes classified as paid overtime over the week */
  extra_minutes: Scalars['Int']['output'];
  /** Sum of the engine's scheduled bracket over the week */
  scheduled_minutes: Scalars['Int']['output'];
  /** The worst verdict among the WEEK-window caps (DIAS_CON_HE, HE_SEMANAL_TOTAL), or NO_DATA when no day of the week had a scheduled bracket or no WEEK cap is evaluable. HE_DIARIA is deliberately NOT folded in here: the day rows already answer it, and repeating it would count one bad day as a weekly finding */
  state: TimeComplianceState;
  /** One verdict per WEEK-window cap scored. Empty exactly when state is NO_DATA */
  verdicts: Array<TimeComplianceThresholdVerdict>;
  /** Sum of worked minutes over the seven days (informative) */
  worked_minutes: Scalars['Int']['output'];
};

export type TimeCountActiveAssignmentsByShiftInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** UUID of the shift to count active users for */
  shift_id: Scalars['ID']['input'];
};

export type TimeCountActiveAssignmentsByShiftPayload = {
  __typename?: 'TimeCountActiveAssignmentsByShiftPayload';
  /** Number of distinct active users assigned to the shift */
  count: Scalars['Int']['output'];
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeCountActiveAssignmentsByShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeCountActiveAssignmentsByShiftPayload;

export type TimeCountUsersWithAssignmentsInRangeInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** End date of the range (inclusive). Null means no end date. */
  end_date?: InputMaybe<Scalars['Date']['input']>;
  /** Start date of the range (inclusive) */
  start_date: Scalars['Date']['input'];
  /** List of collaborator IDs to check */
  user_ids: Array<Scalars['Int']['input']>;
};

export type TimeCountUsersWithAssignmentsInRangePayload = {
  __typename?: 'TimeCountUsersWithAssignmentsInRangePayload';
  /** Number of distinct users with active assignments in the range */
  count: Scalars['Int']['output'];
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeCountUsersWithAssignmentsInRangePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeCountUsersWithAssignmentsInRangePayload | ValidationErrorResponse;

export type TimeCountUsersWithShiftConflictsInput = {
  /** Organization scope identifier. The caller must be able to manage it (org gate) or the request is FORBIDDEN. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional filters (omit for the whole organization). */
  filter?: InputMaybe<TimeShiftConflictsFilterInput>;
};

export type TimeCountUsersWithShiftConflictsPayload = {
  __typename?: 'TimeCountUsersWithShiftConflictsPayload';
  /** Number of DISTINCT collaborators with at least one active conflict. Not a row count. */
  count: Scalars['Int']['output'];
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeCountUsersWithShiftConflictsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeCountUsersWithShiftConflictsPayload;

export type TimeCreateAttendanceLocationInput = {
  /** Attendance location address (max 255 characters). Required when location_type = CUSTOM_ADDRESS; optional when location_type = HEADQUARTER. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Federated headquarter ID owned by centralized-organizations. Required when location_type = HEADQUARTER; must be null when location_type = CUSTOM_ADDRESS. */
  headquarter_id?: InputMaybe<Scalars['Int']['input']>;
  /** Geographic latitude in decimal degrees. Range [-90, 90]. Required for every location_type: a location without resolvable coordinates is rejected, and (0, 0) is not accepted. */
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  /** Authorized perimeter radius in meters. Configured default applied when omitted (see settings.default_location_radius_meters). */
  location_radius?: InputMaybe<Scalars['Int']['input']>;
  /** Type of attendance location. HEADQUARTER associates the location with a sede registered in the centralized Gestión module; CUSTOM_ADDRESS uses a custom address chosen on the map. Defaults to CUSTOM_ADDRESS for backward compatibility with pre-TIM-197 clients. */
  location_type?: TimeAttendanceLocationType;
  /** Geographic longitude in decimal degrees. Range [-180, 180]. Required for every location_type: a location without resolvable coordinates is rejected, and (0, 0) is not accepted. */
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  /** Attendance location name (required, max 150 characters) */
  name: Scalars['String']['input'];
};

export type TimeCreateAttendanceLocationPayload = {
  __typename?: 'TimeCreateAttendanceLocationPayload';
  /** The created attendance location */
  attendance_location: TimeAttendanceLocation;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeCreateAttendanceLocationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeCreateAttendanceLocationPayload | ValidationErrorResponse;

export type TimeCreateCollaboratorMarkingConfigInput = {
  /** Whether computer marking is allowed */
  allow_computer?: Scalars['Boolean']['input'];
  /** Whether mobile app marking is allowed */
  allow_mobile_app?: Scalars['Boolean']['input'];
  /** Whether the collaborator can mark from any unspecified location */
  can_mark_from_any_place?: Scalars['Boolean']['input'];
  /** Whether the collaborator can mark from their home address */
  can_mark_from_home?: Scalars['Boolean']['input'];
  /** Whether the collaborator can mark from Attendance module locations */
  can_mark_from_module_places?: Scalars['Boolean']['input'];
  /** Organization scope */
  centralized_organization_id: Scalars['Int']['input'];
  /** Attendance location IDs to assign on creation */
  marking_location_ids?: Array<Scalars['UUID']['input']>;
  /** Whether the collaborator must register attendance from a device */
  must_register_from_device?: Scalars['Boolean']['input'];
  /** Collaborator's centralized user ID */
  user_id: Scalars['Int']['input'];
};

export type TimeCreateCollaboratorMarkingConfigPayload = {
  __typename?: 'TimeCreateCollaboratorMarkingConfigPayload';
  /** The created configuration */
  collaborator_marking_config: TimeCollaboratorMarkingConfig;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type TimeCreateCollaboratorMarkingConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeCreateCollaboratorMarkingConfigPayload | ValidationErrorResponse;

export type TimeCreateNonRotatingShiftInput = {
  /** If true, all working days must have the same entry_time and exit_time. When enabled, any changes to one working day's schedule will apply to all working days. */
  apply_same_schedule_to_all_working_days?: Scalars['Boolean']['input'];
  /** Optional break/rest configuration */
  break_config?: InputMaybe<TimeBreakConfigInput>;
  /** If true, break time is counted as worked hours and not deducted by the hours-calculation engine. Defaults to false. */
  break_counts_as_worked?: Scalars['Boolean']['input'];
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Color for calendar display (future feature) */
  color?: TimeShiftColor;
  /** Shift description (optional, max 250 characters) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** If true, worked minutes must be provided manually for each working day */
  edit_worked_minutes?: Scalars['Boolean']['input'];
  /** Window in hours [1-12] used to decide if an attendance mark belongs to this shift. Marks outside the expanded [entry - window, exit + window] range are not associated to the shift. Defaults to 2. */
  mark_association_window_hours?: Scalars['Int']['input'];
  /** Shift name (required, max 150 characters) */
  name: Scalars['String']['input'];
  /** Optional tolerance configuration for entry/break/exit times */
  tolerance_config?: InputMaybe<TimeToleranceConfigInput>;
  /** Weekly schedule with day configurations (Monday-Sunday) */
  weekly_schedule: Array<TimeDayScheduleInput>;
};

export type TimeCreateNonRotatingShiftPayload = {
  __typename?: 'TimeCreateNonRotatingShiftPayload';
  /** The created shift */
  shift: TimeNonRotatingShift;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeCreateNonRotatingShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeCreateNonRotatingShiftPayload | ValidationErrorResponse;

export type TimeCreateOvertimeConfigInput = {
  /** Accrual period for compensation */
  accrual_unit: TimeOvertimeAccrualUnit;
  /** Organization scope */
  centralized_organization_id: Scalars['Int']['input'];
  /** Whether excess time is classified as payable overtime (default true — the behaviour of every pre-TIM-396 config) */
  classify_as_overtime?: Scalars['Boolean']['input'];
  /** Whether compensation is active (default false in all countries) */
  compensation_active?: Scalars['Boolean']['input'];
  /** Window over which pending excess stays compensable — applies only when compensation_active; otherwise stored null (TIM-396) */
  compensation_window?: InputMaybe<TimeOvertimeCompensationWindow>;
  /** Country (drives FE-preloaded defaults; never blocks a save) */
  country: TimeOvertimeCountry;
  /** Optional description (≤250 chars) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Mexico daily legal-floor indicator — applies only for MX with WEEKLY/MONTHLY accrual (default true there); otherwise stored null */
  mexico_daily_legal_floor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Config name (unique per org, ≤150 chars) */
  name: Scalars['String']['input'];
  /** Payment-factor tier groups */
  payment_factors: TimeOvertimePaymentFactorsInput;
  /** Quantification type and per-tramo rounding */
  quantification: TimeOvertimeQuantificationInput;
  /** Payroll razón-social IDs (UUID, from get_legal_entities; 1–10, deduped) */
  razon_social_ids: Array<Scalars['UUID']['input']>;
  /** Local shift IDs to associate (1–10, validated existence+org) */
  shift_ids: Array<Scalars['UUID']['input']>;
  /** Whether day/night slots apply */
  slot_modality: TimeOvertimeSlotModality;
  /** Day slot when slot_modality is WITH_SLOT; omit for WITHOUT_SLOT */
  slots?: InputMaybe<TimeOvertimeSlotsInput>;
};

export type TimeCreateOvertimeConfigPayload = {
  __typename?: 'TimeCreateOvertimeConfigPayload';
  /** The created configuration */
  overtime_config: TimeOvertimeConfig;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type TimeCreateOvertimeConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeCreateOvertimeConfigPayload | ValidationErrorResponse;

export type TimeCreateOvertimeRequestInput = {
  /** Organization scope identifier. The caller must belong to it or the request is FORBIDDEN. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Overtime worked, in minutes. May be 0 as long as replacement_minutes is greater than 0. Capped at 1440 (one calendar day), individually and summed with replacement_minutes. */
  extra_minutes: Scalars['Int']['input'];
  /** Why the request is being filed. Required, trimmed before it is validated and stored, at most 250 characters after trimming. */
  reason: Scalars['String']['input'];
  /** Time to make up for, in minutes. May be 0 as long as extra_minutes is greater than 0. A value greater than 0 is what engages the razón-social compensation check; a 0 never does. */
  replacement_minutes: Scalars['Int']['input'];
  /** The day the extra work or the shortfall happened, as an ORGANIZATION-LOCAL calendar date. It may be past, present or future — a future date is accepted on purpose (AC-5) and there is no upper bound. */
  request_date: Scalars['Date']['input'];
  /** Which of the day's shifts the request belongs to. Omit it when the day has exactly one shift — the system associates it — and when the day has none. REQUIRED only when the day has two or more; omitting it then returns OVERTIME_REQUEST_SHIFT_REQUIRED. Feed back an id the shift listing returned; a shift that is not the collaborator's that day returns OVERTIME_REQUEST_SHIFT_NOT_ASSIGNED. */
  shift_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TimeCreateOvertimeRequestPayload = {
  __typename?: 'TimeCreateOvertimeRequestPayload';
  /** The request as persisted, with the shift it was associated to. */
  overtime_request: TimeOvertimeRequest;
};

export type TimeCreateOvertimeRequestPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeCreateOvertimeRequestPayload | ValidationErrorResponse;

export type TimeCreateRotatingShiftInput = {
  /** Optional break/rest configuration (applies to all work cycles) */
  break_config?: InputMaybe<TimeBreakConfigInput>;
  /** If true, break time is counted as worked hours and not deducted by the hours-calculation engine. Defaults to false. */
  break_counts_as_worked?: Scalars['Boolean']['input'];
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Color for calendar display (future feature) */
  color?: TimeShiftColor;
  /** Ordered list of cycles forming the rotation pattern. Order in the list determines cycle order (1st item = Cycle 1, etc.). At least one cycle is required. */
  cycles: Array<TimeShiftCycleInput>;
  /** Shift description (optional, max 250 characters) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** If true, worked minutes per day must be provided manually for each work cycle */
  edit_worked_minutes?: Scalars['Boolean']['input'];
  /** Window in hours [1-12] used to decide if an attendance mark belongs to this shift. Marks outside the expanded [entry - window, exit + window] range are not associated to the shift. Defaults to 2. */
  mark_association_window_hours?: Scalars['Int']['input'];
  /** Shift name (required, max 150 characters) */
  name: Scalars['String']['input'];
  /** Optional tolerance configuration for entry/break/exit times */
  tolerance_config?: InputMaybe<TimeToleranceConfigInput>;
};

export type TimeCreateRotatingShiftPayload = {
  __typename?: 'TimeCreateRotatingShiftPayload';
  /** The created shift */
  shift: TimeRotatingShift;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeCreateRotatingShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeCreateRotatingShiftPayload | ValidationErrorResponse;

export enum TimeCycleType {
  Rest = 'REST',
  Work = 'WORK'
}

export type TimeDailyAttendanceQueries = {
  __typename?: 'TimeDailyAttendanceQueries';
  /** Read the already-persisted calculation detail of ONE collaborator's day for the 'Cálculo del día' drawer — times, the overtime classification with its factors, and the two explicit 'not configured / not available' conditions */
  get_workday_overtime_snapshot: TimeGetWorkdayOvertimeSnapshotPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** List calculated daily workdays for admin day-to-day management */
  list_workdays: TimeListWorkdaysPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** Count the payroll incidences of ONE organization that are stuck awaiting manual action, so the 'Gestión diaria' banner can read the real outbox instead of a front-end mock */
  payroll_incidence_sync_summary: TimePayrollIncidenceSyncSummaryPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeDailyAttendanceQueriesGet_Workday_Overtime_SnapshotArgs = {
  input: TimeGetWorkdayOvertimeSnapshotInput;
};


export type TimeDailyAttendanceQueriesList_WorkdaysArgs = {
  input: TimeListWorkdaysInput;
};


export type TimeDailyAttendanceQueriesPayroll_Incidence_Sync_SummaryArgs = {
  input: TimePayrollIncidenceSyncSummaryInput;
};

export type TimeDailyMarkingContext = {
  __typename?: 'TimeDailyMarkingContext';
  /** True when all expected marks are registered */
  all_marks_completed: Scalars['Boolean']['output'];
  /** Ordered list of expected marks with status */
  expected_marks: Array<TimeExpectedMark>;
  /** Next mark type to record (null if all done) */
  next_pending_mark?: Maybe<TimeAttendanceMarkType>;
  /** Schedule info for the next day (for navigation) */
  next_schedule?: Maybe<TimeDaySchedule>;
  /** Schedule info for the previous day (for navigation) */
  previous_schedule?: Maybe<TimeDaySchedule>;
  /** Resolved shift info for the current day (null if no shift) */
  shift_context?: Maybe<TimeShiftContext>;
};

export type TimeDailyScheduleCell = {
  __typename?: 'TimeDailyScheduleCell';
  /** Cell type: WORKING, REST, or UNASSIGNED */
  cell_type: TimeScheduleCellType;
  /** ISO date (YYYY-MM-DD) */
  date: Scalars['String']['output'];
  /** Day of the week */
  day_of_week: TimeDayOfWeek;
  /** Pre-computed display text (null if UNASSIGNED) */
  display_label?: Maybe<Scalars['String']['output']>;
  /** Entry time HH:MM (null if REST or UNASSIGNED) */
  entry_time?: Maybe<Scalars['String']['output']>;
  /** Exit time HH:MM (null if REST or UNASSIGNED) */
  exit_time?: Maybe<Scalars['String']['output']>;
  /** True when a schedule conflict is persisted for THIS assignment on THIS date: another shift of the same collaborator overlaps it. Marked per (assignment, date), so a clash between two of a collaborator's shifts marks only the two rows that take part. Two boundaries are intentional and are not bugs: the conflict date is resolved in UTC while this grid's range is calendar dates, so a clash starting late in the evening can mark the next day's cell; and the conflicts banner counts from today forward across the whole organization while this flag covers only the requested range, so the two numbers legitimately differ. REST and UNASSIGNED cells can carry it too — the flag belongs to the (assignment, date) pair, not to the cell type. */
  has_warning: Scalars['Boolean']['output'];
  /** Worked minutes for this day (0 for REST/UNASSIGNED) */
  planned_minutes: Scalars['Int']['output'];
  /** Shift color (null if UNASSIGNED) */
  shift_color?: Maybe<TimeShiftColor>;
  /** Shift ID (null if UNASSIGNED) */
  shift_id?: Maybe<Scalars['ID']['output']>;
  /** Shift name (null if UNASSIGNED) */
  shift_name?: Maybe<Scalars['String']['output']>;
  /** Shift type: NON_ROTATING or ROTATING (null if UNASSIGNED) */
  shift_type?: Maybe<TimeShiftType>;
  /** Last update timestamp of the assignment (null if never updated) */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who last updated the assignment (null if never updated) */
  updated_by?: Maybe<CentralizedUserNode>;
};

export enum TimeDayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type TimeDaySchedule = {
  __typename?: 'TimeDaySchedule';
  /** Scheduled entry time (ISO 8601 with offset) */
  entry_time?: Maybe<Scalars['DateTime']['output']>;
  /** Scheduled exit time (ISO 8601 with offset) */
  exit_time?: Maybe<Scalars['DateTime']['output']>;
  /** Expected worked minutes */
  expected_minutes?: Maybe<Scalars['Int']['output']>;
  /** Whether this is a working day */
  is_working_day: Scalars['Boolean']['output'];
  /** Name of the assigned shift */
  shift_name: Scalars['String']['output'];
  /** Type of shift (NON_ROTATING or ROTATING) */
  shift_type: TimeShiftType;
};

export type TimeDayScheduleInput = {
  /** Total break duration in minutes for this day. Required for FIXED_DURATION break type. */
  break_duration_minutes?: InputMaybe<Scalars['Int']['input']>;
  /** Break time slots for this day. Required for FIXED_SCHEDULE break type. Each slot defines a specific break (e.g., lunch 13:00-14:00). */
  break_time_slots?: InputMaybe<Array<TimeBreakTimeSlotInput>>;
  /** Day of the week */
  day: TimeDayOfWeek;
  /** Entry/start time in HH:MM format (required if is_working_day=true) */
  entry_time?: InputMaybe<Scalars['String']['input']>;
  /** Exit/end time in HH:MM format (required if is_working_day=true) */
  exit_time?: InputMaybe<Scalars['String']['input']>;
  /** Whether this is a working day */
  is_working_day: Scalars['Boolean']['input'];
  /** Worked minutes for the day (required when edit_worked_minutes is true) */
  worked_minutes?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeDayScheduleResult = TimeNonWorkingDaySchedule | TimeWorkingDaySchedule;

export enum TimeDayStatus {
  Holiday = 'HOLIDAY',
  Incomplete = 'INCOMPLETE',
  Justified = 'JUSTIFIED',
  NoShift = 'NO_SHIFT',
  Ok = 'OK',
  RestDay = 'REST_DAY',
  UnjustifiedAbsence = 'UNJUSTIFIED_ABSENCE',
  WithNovelty = 'WITH_NOVELTY',
  WorkedHoliday = 'WORKED_HOLIDAY',
  WorkedRestDay = 'WORKED_REST_DAY',
  WorkedTimeOff = 'WORKED_TIME_OFF'
}

export type TimeDeactivateOvertimeConfigInput = {
  /** Organization scope (required; enforced by AC-4) */
  centralized_organization_id: Scalars['Int']['input'];
  /** Overtime config unique identifier to deactivate */
  id: Scalars['UUID']['input'];
};

export type TimeDeactivateOvertimeConfigPayload = {
  __typename?: 'TimeDeactivateOvertimeConfigPayload';
  /** The deactivated configuration */
  overtime_config: TimeOvertimeConfig;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type TimeDeactivateOvertimeConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeDeactivateOvertimeConfigPayload;

export type TimeDeactivateShiftAssignmentInput = {
  /** UUID of the ASSIGNMENT to deactivate — not the shift's id. This is the identifier the weekly grid already exposes as TimeWeeklyAssignmentRow.id, and the only stable one: editing a shift versions shift_id, never assignment_id. Only this assignment is deactivated; the collaborator's other shifts on the same day stay active. */
  assignment_id: Scalars['ID']['input'];
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
};

export type TimeDeactivateShiftAssignmentPayload = {
  __typename?: 'TimeDeactivateShiftAssignmentPayload';
  /** The assignment that was deactivated. Exactly one element when the row was still active when the call arrived; EMPTY when it was already inactive — a second identical call is idempotent success, not an error. There is no created_assignments counterpart: the row is the assignment and it is deactivated whole (no split/trim). */
  deactivated_assignments: Array<TimeShiftAssignment>;
  /** True on both branches above. Invariant: success == true means the assignment is inactive after the call, regardless of which call made it inactive. */
  success: Scalars['Boolean']['output'];
};

export type TimeDeactivateShiftAssignmentResult = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeDeactivateShiftAssignmentPayload | ValidationErrorResponse;

export type TimeDeleteAttendanceLocationInput = {
  /** List of UUIDs of the attendance locations to delete */
  attendance_location_ids: Array<Scalars['ID']['input']>;
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
};

export type TimeDeleteAttendanceLocationPayload = {
  __typename?: 'TimeDeleteAttendanceLocationPayload';
  /** The deleted attendance locations (with is_active=False) */
  attendance_locations: Array<TimeAttendanceLocation>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeDeleteAttendanceLocationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeDeleteAttendanceLocationPayload | ValidationErrorResponse;

export type TimeDeleteCollaboratorMarkPhotosInput = {
  /** Organization scope identifier. Drives BOTH the can_manage_organization permission gate AND the repository dual-filter — a caller may only erase photos in an org they manage; naming a foreign org is rejected (FORBIDDEN). */
  centralized_organization_id: Scalars['Int']['input'];
  /** Centralized user id of the target collaborator whose mark photos are erased. A collaborator in a different org yields 0 marks (an idempotent no-op), never a cross-org deletion. */
  user_id: Scalars['Int']['input'];
};

export type TimeDeleteCollaboratorMarkPhotosPayload = {
  __typename?: 'TimeDeleteCollaboratorMarkPhotosPayload';
  /** Photos deleted and unlinked in this call. */
  deleted_count: Scalars['Int']['output'];
  /** Photos whose deletion failed this call; their photo_file_id is left intact (no false erasure) and retried on a re-run. */
  failed_count: Scalars['Int']['output'];
  /** Photo-bearing marks not yet deleted (cap truncation or failures) — re-run until 0. */
  remaining_count: Scalars['Int']['output'];
  /** Centralized user id of the collaborator whose photos were erased. */
  requested_user_id: Scalars['Int']['output'];
  /** True ONLY when nothing is left to do for the collaborator (failed_count == 0 AND remaining_count == 0). A capped/truncated or partially-failed run returns False so the admin re-runs. */
  success: Scalars['Boolean']['output'];
};

export type TimeDeleteCollaboratorMarkPhotosPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeDeleteCollaboratorMarkPhotosPayload;

export type TimeDeleteOvertimeConfigInput = {
  /** Organization scope (required; enforced by AC-3) */
  centralized_organization_id: Scalars['Int']['input'];
  /** Overtime config unique identifier to delete */
  id: Scalars['UUID']['input'];
};

export type TimeDeleteOvertimeConfigPayload = {
  __typename?: 'TimeDeleteOvertimeConfigPayload';
  /** The deleted configuration */
  overtime_config: TimeOvertimeConfig;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type TimeDeleteOvertimeConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeDeleteOvertimeConfigPayload | ValidationErrorResponse;

export type TimeDeleteShiftInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** UUID of the shift to delete */
  shift_id: Scalars['ID']['input'];
};

export type TimeDeleteShiftPayload = {
  __typename?: 'TimeDeleteShiftPayload';
  /** The deleted shift (with is_active=False) */
  shift: TimeShiftResult;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeDeleteShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeDeleteShiftPayload | ValidationErrorResponse;

export type TimeDeviceLocationMapping = {
  __typename?: 'TimeDeviceLocationMapping';
  /** Marking place this device's future punches are attributed to */
  attendance_location_id: Scalars['UUID']['output'];
  /** Organization that owns the device */
  centralized_organization_id: Scalars['Int']['output'];
  /** Creation timestamp */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who created this mapping */
  created_by: Scalars['Int']['output'];
  /** Device identifier from the provider */
  device_id: Scalars['String']['output'];
  /** Mapping unique identifier */
  id: Scalars['UUID']['output'];
  /** Whether this is the device's current mapping */
  is_active: Scalars['Boolean']['output'];
  /** Provider that reports the device */
  provider: Scalars['String']['output'];
  /** Last update timestamp */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who last modified this mapping */
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TimeDeviceLocationMappingsMutations = {
  __typename?: 'TimeDeviceLocationMappingsMutations';
  /** Assign or change the marking place of a biometric device */
  assign_device_marking_location: TimeAssignDeviceMarkingLocationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
};


export type TimeDeviceLocationMappingsMutationsAssign_Device_Marking_LocationArgs = {
  input: TimeAssignDeviceMarkingLocationInput;
};

export type TimeDeviceLocationMappingsQueries = {
  __typename?: 'TimeDeviceLocationMappingsQueries';
  /** List every biometric device Ziphra has reported for an organization, aggregated by (provider, device_id) — its marking place (or the absence of one), most recent punch and how many punches it has sent. */
  list_devices_with_punches: TimeListDevicesWithPunchesPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeDeviceLocationMappingsQueriesList_Devices_With_PunchesArgs = {
  input: TimeListDevicesWithPunchesInput;
};

export enum TimeDeviceType {
  MobileApp = 'MOBILE_APP',
  Web = 'WEB'
}

export type TimeDeviceWithPunches = {
  __typename?: 'TimeDeviceWithPunches';
  /** Marking place this device's punches are currently attributed to; null when the device has no active mapping, or its mapping resolves to a soft-deleted or cross-organization place */
  attendance_location_id?: Maybe<Scalars['UUID']['output']>;
  /** Name of the marking place above; null exactly when attendance_location_id is null */
  attendance_location_name?: Maybe<Scalars['String']['output']>;
  /** Device identifier as the provider reports it */
  device_id: Scalars['String']['output'];
  /** Instant of this device's most recent punch, as reported by the provider */
  last_punch_marked_at: Scalars['DateTime']['output'];
  /** Instant this device's most recent punch arrived at the inbox */
  last_punch_received_at: Scalars['DateTime']['output'];
  /** Punch provider that reports the device (e.g. 'ziphra') */
  provider: Scalars['String']['output'];
  /** Ponches recibidos y retenidos en base para este dispositivo. No son marcas de asistencia derivadas, y no es un histórico total garantizado: device_punches no tiene política de retención con dueño. */
  punch_count: Scalars['Int']['output'];
};

export type TimeEditAttendanceLocationInput = {
  /** Attendance location address (max 255 characters). Required when location_type = CUSTOM_ADDRESS; optional when location_type = HEADQUARTER. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the attendance location to edit */
  attendance_location_id: Scalars['ID']['input'];
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Federated headquarter ID owned by centralized-organizations. Required when location_type = HEADQUARTER; must be null when location_type = CUSTOM_ADDRESS. Send null to clear the column during a HEADQUARTER → CUSTOM_ADDRESS transition. */
  headquarter_id?: InputMaybe<Scalars['Int']['input']>;
  /** Geographic latitude in decimal degrees. Range [-90, 90]. Required for every location_type, including a CUSTOM_ADDRESS → HEADQUARTER transition. (0, 0) is not accepted. PUT semantics: send the full state on every edit. */
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  /** Authorized perimeter radius in meters. Optional: configured default applied when omitted (see settings.default_location_radius_meters). The admin UI does not expose a radius selector yet, so callers without UI support can omit this field. */
  location_radius?: InputMaybe<Scalars['Int']['input']>;
  /** Type of attendance location. PUT semantics: send the full target state on every edit. HEADQUARTER ↔ CUSTOM_ADDRESS transitions are supported; the caller must set headquarter_id consistently. Defaults to CUSTOM_ADDRESS for backward compatibility with pre-TIM-197 clients. */
  location_type?: TimeAttendanceLocationType;
  /** Geographic longitude in decimal degrees. Range [-180, 180]. Required for every location_type, including a CUSTOM_ADDRESS → HEADQUARTER transition. (0, 0) is not accepted. PUT semantics: send the full state on every edit. */
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  /** Attendance location name (required, max 150 characters) */
  name: Scalars['String']['input'];
};

export type TimeEditAttendanceLocationPayload = {
  __typename?: 'TimeEditAttendanceLocationPayload';
  /** The updated attendance location */
  attendance_location: TimeAttendanceLocation;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeEditAttendanceLocationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeEditAttendanceLocationPayload | ValidationErrorResponse;

export type TimeEditNonRotatingShiftInput = {
  /** If true, all working days must have the same entry_time and exit_time */
  apply_same_schedule_to_all_working_days?: Scalars['Boolean']['input'];
  /** Optional break/rest configuration */
  break_config?: InputMaybe<TimeBreakConfigInput>;
  /** If true, break time is counted as worked hours and not deducted by the hours-calculation engine. Defaults to false. */
  break_counts_as_worked?: Scalars['Boolean']['input'];
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Color for calendar display */
  color?: TimeShiftColor;
  /** Shift description (optional, max 250 characters) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** If true, worked minutes must be provided manually for each working day */
  edit_worked_minutes?: Scalars['Boolean']['input'];
  /** Window in hours [1-12] used to decide if an attendance mark belongs to this shift. Marks outside the expanded [entry - window, exit + window] range are not associated to the shift. Defaults to 2. */
  mark_association_window_hours?: Scalars['Int']['input'];
  /** Shift name (required, max 150 characters) */
  name: Scalars['String']['input'];
  /** UUID of the shift to edit */
  shift_id: Scalars['ID']['input'];
  /** Optional tolerance configuration for entry/break/exit times */
  tolerance_config?: InputMaybe<TimeToleranceConfigInput>;
  /** Weekly schedule with day configurations (Monday-Sunday) */
  weekly_schedule: Array<TimeDayScheduleInput>;
};

export type TimeEditNonRotatingShiftPayload = {
  __typename?: 'TimeEditNonRotatingShiftPayload';
  /** The new shift version created by the edit */
  shift: TimeNonRotatingShift;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeEditNonRotatingShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeEditNonRotatingShiftPayload | ValidationErrorResponse;

export type TimeEditRotatingShiftInput = {
  /** Optional break/rest configuration (applies to all work cycles) */
  break_config?: InputMaybe<TimeBreakConfigInput>;
  /** If true, break time is counted as worked hours and not deducted by the hours-calculation engine. Defaults to false. */
  break_counts_as_worked?: Scalars['Boolean']['input'];
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Color for calendar display */
  color?: TimeShiftColor;
  /** Ordered list of cycles forming the rotation pattern. At least one work cycle and one rest cycle required. */
  cycles: Array<TimeShiftCycleInput>;
  /** Shift description (optional, max 250 characters) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** If true, worked minutes per day must be provided manually for each work cycle */
  edit_worked_minutes?: Scalars['Boolean']['input'];
  /** Window in hours [1-12] used to decide if an attendance mark belongs to this shift. Marks outside the expanded [entry - window, exit + window] range are not associated to the shift. Defaults to 2. */
  mark_association_window_hours?: Scalars['Int']['input'];
  /** Shift name (required, max 150 characters) */
  name: Scalars['String']['input'];
  /** UUID of the shift to edit */
  shift_id: Scalars['ID']['input'];
  /** Optional tolerance configuration for entry/break/exit times */
  tolerance_config?: InputMaybe<TimeToleranceConfigInput>;
};

export type TimeEditRotatingShiftPayload = {
  __typename?: 'TimeEditRotatingShiftPayload';
  /** The new shift version created by the edit */
  shift: TimeRotatingShift;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeEditRotatingShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeEditRotatingShiftPayload | ValidationErrorResponse;

export type TimeEditWorkdayInput = {
  /** TIM-537 AC-4: true when this save came from the 'Aplicar horas estimadas del turno' action, so the day's change history shows ONE event naming the shift used instead of one row per mark. Additive and optional: omitted/null behaves exactly as today (the marks are audited one row each). It changes NOTHING about what is saved on the marks themselves — only how the audit rows of this one save are grouped and read back. The backend cannot infer it: the client skips the slots blocked by time off and rewrites those with the record's original value, so an applied day is not always four of four matches against the shift's slots. Ignored when the day has no resolvable shift — there would be no shift to name. */
  applied_shift_hours?: InputMaybe<Scalars['Boolean']['input']>;
  /** TIM-607: which of the day's shifts this edit targets — the assignment_id of one TimeWorkday.shift_journeys entry. OMITTED (UNSET) keeps today's behaviour exactly: the edit lands on the shift the day's row anchors on, and on a day with a single shift that is the identity. A value narrows the upsert, the absent-field DELETE and the order validation to THAT shift, so the other shifts' marks are never candidates for deletion. Rejected with INVALID_EDIT_INPUT when the id is not one of the day's shifts for this collaborator — a nonexistent id, another day's, another organization's, another collaborator's and an inactive one are all answered identically, on purpose: distinguishing them would be an existence oracle. */
  assignment_id?: InputMaybe<Scalars['ID']['input']>;
  /** BREAK_END mark HH:mm. Value upserts; absent/empty/null deletes. */
  break_end_iso?: InputMaybe<Scalars['String']['input']>;
  /** BREAK_START mark HH:mm. Value upserts; absent/empty/null deletes. */
  break_start_iso?: InputMaybe<Scalars['String']['input']>;
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
  /** ISO date 'YYYY-MM-DD' the edited marks belong to */
  date: Scalars['Date']['input'];
  /** ENTRY mark HH:mm. Value upserts; absent/empty/null deletes. */
  entry_iso?: InputMaybe<Scalars['String']['input']>;
  /** EXIT mark HH:mm. Value upserts; absent/empty/null deletes. */
  exit_iso?: InputMaybe<Scalars['String']['input']>;
  /** TIM-306: minutes of the day's NET excess time to classify as horas extra. DELTA semantics, not presence: omitted/null keeps the stored value (it is NEVER read as 0), while a value is a write intent. If the resulting (extra_hours_minutes, reposicion_minutes) pair equals the stored pair the save is a no-op — no motivo, no audit row. Sending 0 over a stored non-zero IS a change: it clears the allocation and requires a motivo. The SUM of both fields may not exceed the day's excess_net_minutes, the day must be closed (an EXIT mark exists) and it must have a shift; otherwise the save is rejected with a ValidationErrorResponse code. */
  extra_hours_minutes?: InputMaybe<Scalars['Int']['input']>;
  /** TIM-306: admin note for the overtime-allocation change (AC-7). Trimmed server-side; whitespace-only is treated as absent. Max 250 characters after trim (MOTIVO_TOO_LONG beyond that) — deliberately NOT the 500 change_shift uses. REQUIRED whenever the resulting allocation pair differs from the stored one, and ignored when it does not. It is recorded on the overtime-adjustment audit rows only — never on the mark-change or shift-change rows. */
  motivo?: InputMaybe<Scalars['String']['input']>;
  /** Optional retroactive shift change applied atomically with the mark edits (TIM-338). Semantics identical to change_shift's new_shift_id: OMITTED (UNSET) leaves the day's shift untouched; a shift UUID assigns/changes the day's shift; null clears it ('Quitar turno'). When present, turno + marcas + recompute + audit run in a single transaction with one shift-audit row and one recompute. */
  new_shift_id?: InputMaybe<Scalars['ID']['input']>;
  /** Composite key '{user_original_id}-{date}' — same as TimeWorkday.id */
  record_id: Scalars['ID']['input'];
  /** TIM-306: minutes of the day's NET excess time to reserve as tiempo a compensar. Same DELTA semantics as extra_hours_minutes (omitted/null keeps the stored value, 0 over a stored non-zero clears it and needs a motivo). Rejected with COMPENSATION_NOT_AVAILABLE when the turno's overtime config has compensation switched off and a value > 0 is requested; a requested 0 never trips that. */
  reposicion_minutes?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeEditWorkdayPayload = {
  __typename?: 'TimeEditWorkdayPayload';
  /** Whether the edit was applied successfully */
  success: Scalars['Boolean']['output'];
  /** The recomputed workday — the FE replaces the table row with this */
  workday: TimeWorkday;
};

export type TimeEditWorkdayPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeEditWorkdayPayload | ValidationErrorResponse;

export type TimeEligibleShift = {
  __typename?: 'TimeEligibleShift';
  /** Representative shift window formatted 'HH:MM — HH:MM' */
  expected_time: Scalars['String']['output'];
  /** Shift unique identifier */
  id: Scalars['ID']['output'];
  /** Shift display name */
  name: Scalars['String']['output'];
};

export type TimeExcelValidationFile = {
  __typename?: 'TimeExcelValidationFile';
  /** Original file name */
  name: Scalars['String']['output'];
  /** File size in bytes */
  size: Scalars['Int']['output'];
  /** ISO-8601 timestamp the file was recorded (validate time) */
  uploaded_at: Scalars['String']['output'];
};

export type TimeExcelValidationPayload = {
  __typename?: 'TimeExcelValidationPayload';
  /** Echo of the uploaded file metadata */
  file: TimeExcelValidationFile;
  /** Staged batch id for the paged review queries and apply */
  import_batch_id: Scalars['ID']['output'];
  /** Overall validate-phase status */
  status: TimeExcelValidationStatusEnum;
  /** Aggregate counts for the staged batch */
  summary: TimeExcelValidationSummary;
};

export type TimeExcelValidationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeExcelValidationPayload | ValidationErrorResponse;

export enum TimeExcelValidationStatusEnum {
  Errors = 'ERRORS',
  Partial = 'PARTIAL',
  Success = 'SUCCESS'
}

export type TimeExcelValidationSummary = {
  __typename?: 'TimeExcelValidationSummary';
  /** Rows categorized as ERROR */
  error_count: Scalars['Int']['output'];
  /** Number of distinct ERROR codes */
  error_groups_count: Scalars['Int']['output'];
  /** Rows categorized as INFO */
  info_count: Scalars['Int']['output'];
  /** Number of distinct INFO codes */
  info_groups_count: Scalars['Int']['output'];
  /** Total parsed data rows */
  total_records: Scalars['Int']['output'];
  /** Rows categorized as VALID */
  valid_count: Scalars['Int']['output'];
};

export type TimeExpectedMark = {
  __typename?: 'TimeExpectedMark';
  /** Type of expected mark */
  mark_type: TimeAttendanceMarkType;
  /** Timestamp when marked (null if PENDING) */
  marked_at?: Maybe<Scalars['DateTime']['output']>;
  /** Computed status (PENDING, ON_TIME, LATE, etc.) */
  status: TimeAttendanceMarkStatus;
};

export enum TimeFacet {
  Compensated = 'COMPENSATED',
  Excess = 'EXCESS',
  Extra = 'EXTRA'
}

export type TimeGetAttendanceCardInput = {
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
  /** End of the period (inclusive, ISO format) */
  end_date: Scalars['Date']['input'];
  /** Start of the period (inclusive, ISO format) */
  start_date: Scalars['Date']['input'];
  /** IANA timezone for display (e.g., America/Lima) */
  timezone: Scalars['String']['input'];
  /** User ID to query (defaults to authenticated user if omitted) */
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeGetAttendanceCardPayload = {
  __typename?: 'TimeGetAttendanceCardPayload';
  /** One entry per day in the range (start_date to end_date inclusive) */
  days: Array<TimeAttendanceCardDay>;
  /** End of the period (from input) */
  end_date: Scalars['Date']['output'];
  /** Start of the period (from input) */
  start_date: Scalars['Date']['output'];
  /** IANA timezone used for all time computations */
  timezone: Scalars['String']['output'];
};

export type TimeGetAttendanceCardPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeGetAttendanceCardPayload;

export type TimeGetAttendanceLocationInput = {
  /** Pagination for assigned users list. Default: page 1, page_size 10 */
  assigned_users_pagination?: InputMaybe<TimeAssignedUsersPaginationInput>;
  /** UUID of the attendance location to retrieve */
  attendance_location_id: Scalars['ID']['input'];
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
};

export type TimeGetAttendanceLocationPayload = {
  __typename?: 'TimeGetAttendanceLocationPayload';
  /** Paginated list of users assigned to this location */
  assigned_users: Array<CentralizedUserNode>;
  /** Total count of assigned users for pagination */
  assigned_users_total_count: Scalars['Int']['output'];
  /** The retrieved attendance location */
  attendance_location: TimeAttendanceLocation;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeGetAttendanceLocationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeGetAttendanceLocationPayload;

export type TimeGetAttendanceReportExportInput = {
  /** Organization scope identifier. A job belonging to another organization is reported as NOT FOUND, never as forbidden. */
  centralized_organization_id: Scalars['Int']['input'];
  /** The export_id returned by attendance_report_export_request. Feed it back verbatim — never rebuild it. */
  export_id: Scalars['ID']['input'];
};

export type TimeGetCollaboratorComplianceDetailInput = {
  /** Organization scope. Gated: the caller must administer it */
  centralized_organization_id: Scalars['Int']['input'];
  /** Country whose catalog to evaluate against (MX only for now) */
  country: TimeComplianceCountry;
  /** Any date inside the week to break down — it need not be the Monday. Defaults to today resolved in `timezone` (UTC when that is omitted or invalid), i.e. the week containing today (AC-4). The resolved Monday..Sunday always comes back in `period` */
  reference_date?: InputMaybe<Scalars['Date']['input']>;
  /** IANA timezone used ONLY to resolve today when reference_date is omitted (e.g. America/Mexico_City). Falls back to UTC when omitted or invalid — invalid is not an error. It never shifts the minute totals */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Centralized id of the collaborator to break down. Must be >= 1 — anything else is a typed ValidationErrorResponse with code INVALID_USER_ID, never an all-NO_DATA week. A collaborator outside the viewer's sede scope is a ForbiddenErrorResponse */
  user_id: Scalars['Int']['input'];
};

export type TimeGetCollaboratorComplianceDetailResult = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeCollaboratorComplianceDetailPayload | ValidationErrorResponse;

export type TimeGetCollaboratorMarkingConfigInput = {
  /** Organization scope */
  centralized_organization_id: Scalars['Int']['input'];
  /** Pagination for marking locations list. Default: page 1, page_size 5 */
  marking_locations_pagination?: InputMaybe<TimeMarkingLocationsPaginationInput>;
  /** Search filter for marking locations by name or address */
  marking_locations_search?: InputMaybe<TimeMarkingLocationsSearchInput>;
  /** Collaborator's centralized user ID */
  user_id: Scalars['Int']['input'];
};

export type TimeGetCollaboratorMarkingConfigPayload = {
  __typename?: 'TimeGetCollaboratorMarkingConfigPayload';
  /** The collaborator marking configuration with paginated marking_locations */
  collaborator_marking_config: TimeCollaboratorMarkingConfig;
  /** Total count of marking locations matching the filters */
  marking_locations_total_count: Scalars['Int']['output'];
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type TimeGetCollaboratorMarkingConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeGetCollaboratorMarkingConfigPayload;

export type TimeGetDailyMarkingContextInput = {
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
  /** Date to query (ISO format, e.g., 2026-04-02) */
  date: Scalars['Date']['input'];
  /** IANA timezone for display (e.g., America/Lima) */
  timezone: Scalars['String']['input'];
};

export type TimeGetDailyMarkingContextPayload = {
  __typename?: 'TimeGetDailyMarkingContextPayload';
  /** Full daily marking context */
  context: TimeDailyMarkingContext;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeGetDailyMarkingContextPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeGetDailyMarkingContextPayload;

export type TimeGetMarkIntegrityDetailInput = {
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
  /** Identifier of the attendance mark to inspect. This is the mark's `id` — exactly the value the marks listing returns — and NOT its chain sequence number, which restarts per organization and day, carries no unique constraint and is null for every row recorded before the integrity seal shipped. Using the id is also what lets a copied link keep working after an authorized edit: the replacement row gets a new id, and the original one stays resolvable through the version trail. */
  mark_id: Scalars['ID']['input'];
};

export type TimeGetMarkIntegrityDetailPayload = {
  __typename?: 'TimeGetMarkIntegrityDetailPayload';
  /** Value the record was expected to hold, for a detected alteration, as `Campo: valor; Campo: valor`, where `Campo` is a Spanish, human-readable LABEL (`Hora`, `Evento`, `Jornada`…) and never the internal snapshot key — this string is rendered VERBATIM by the UI, so it is the audit text itself. The VALUE stays canonical (ISO-8601 in UTC, enum tokens as stored): it is evidence, not a formatted display value. Taken from the stored snapshot of the record's latest version. Null unless the integrity verification has stamped this record as `ALTERED`: this query recomputes the digest but never issues the verdict, so a record whose hashes differ and that the verification has not yet examined still reports null here. A few keys are shown by name with their value redacted — they are internal identifiers that no other field of this API exposes. Two caveats when parsing: each of the two strings is truncated independently at 1000 characters with a trailing ` …`, so the last pair may be cut — do not assume a split on `; ` yields whole pairs. And for a CHAIN-BREAK verdict the expected side carries the synthetic key `chain_hash`, which is the successor's frozen link value and is NOT a field of the stored snapshot. */
  alteration_expected_value?: Maybe<Scalars['String']['output']>;
  /** Value actually found in the record now, in the same `Campo: valor` shape and aligned key by key with `alteration_expected_value`. Each of the two is readable on its own. Null under the same conditions as `alteration_expected_value`. */
  alteration_found_value?: Maybe<Scalars['String']['output']>;
  /** When the alteration was FIRST detected, in UTC ISO-8601. It does not move while the same alteration keeps being re-detected; a different alteration resets it together with the two values above. Null under the same conditions as `alteration_expected_value`. */
  alteration_recalculated_at?: Maybe<Scalars['String']['output']>;
  /** Attendance location attributed to the mark. Null when the mark resolved to no location, and ALSO null when the location row was since deleted — a missing location must never turn the whole detail into a not-found answer. */
  attendance_location?: Maybe<TimeAttendanceMarkLocation>;
  /** Moment of the mark in UTC, ISO-8601 with SECOND precision and a `Z` suffix (e.g. `2026-08-12T01:07:00Z`). Typed as a string, not a DateTime scalar, because the serializer emits microseconds while the screen renders the value as received. Read it together with `time`: a 20:07 punch in America/Lima is `2026-08-12T01:07:00Z`, the NEXT calendar day, so rendering this field alone shows the wrong date. */
  date: Scalars['String']['output'];
  /** Tag of the formula used to seal this row (e.g. `v1`). Null on a row that was never sealed. */
  hash_formula_version?: Maybe<Scalars['String']['output']>;
  /** Identifier of the RESOLVED mark. Differs from the requested `mark_id` when the link was recovered through the version trail after an authorized edit replaced the row. */
  id: Scalars['UUID']['output'];
  /** Name of the file the bulk import was loaded from. Null when the mark was not bulk-imported, and ALSO null on the owner branch — upload file names routinely carry an organization's internal nomenclature. */
  import_file_name?: Maybe<Scalars['String']['output']>;
  /** Federated reference to the admin who ran the bulk import that created this mark. Null when the mark was not bulk-imported, and ALSO null when the caller reached this screen as the record's OWNER rather than as an organization admin: an owner verifies their own integrity from the hashes, and does not need the identity of the admin who imported them. */
  imported_by?: Maybe<CentralizedUserNode>;
  /** The STORED integrity state of the seal, never a verdict computed by this query. Non-nullable: a row that predates the seal reports NOT_APPLICABLE, which is a real state and not 'unknown'. This field is not flipped on a hash mismatch — the mismatch is visible in the two hash fields, and the transition belongs to the verification ticket. */
  integrity_status: TimeMarkIntegrityStatus;
  /** Origin of the mark (app, web, manual, Excel, biometric, system) */
  mark_source: TimeMarkSource;
  /** Event the mark represents (entry, break start/end, exit) */
  mark_type: TimeAttendanceMarkType;
  /** Device or terminal identifier behind the mark. Always null today: biometric punches are stored in their own inbox with no reference back to the mark they produced, so there is nothing to join on. Tracked as upstream debt; no substitute value is invented. */
  method_identifier?: Maybe<Scalars['String']['output']>;
  /** Device-origin GPS latitude recorded with the mark, if any */
  origin_latitude?: Maybe<Scalars['Decimal']['output']>;
  /** Device-origin GPS longitude recorded with the mark, if any */
  origin_longitude?: Maybe<Scalars['Decimal']['output']>;
  /** Ready-to-render photo node with a server-templated download URL. Non-null exactly when `photo_status` is AVAILABLE. */
  photo?: Maybe<TimeAttendanceMarkPhoto>;
  /** When the photo's bytes were purged, in UTC ISO-8601 with second precision. Null means 'no purge recorded' — which legitimately covers both 'never had a photo' and 'purged before this field existed', since purges are not backfilled. The frontend authors the copy for that case; the backend sends no placeholder. */
  photo_deleted_at?: Maybe<Scalars['String']['output']>;
  /** SHA-256 digest of the photo's final bytes, which survives a purge as proof the photo existed. Always null today: its producing pipeline is outstanding debt, tracked separately. */
  photo_hash?: Maybe<Scalars['String']['output']>;
  /** Whether the evidence photo is available, was purged by request, or never applied. Derived from the stored file reference and the photo digest — non-nullable, because 'never had a photo' is a real state with its own member and not an absence. */
  photo_status: TimeMarkPhotoStatus;
  /** Digest this row chained from. May be the genesis sentinel for the first mark of a chain, which is deliberately NOT a well-formed digest so a chain head is identifiable by length alone. Projected verbatim. */
  previous_hash?: Maybe<Scalars['String']['output']>;
  /** Biometric provider behind the mark. Always null today, for the same missing join as `method_identifier`. Null rather than a derived constant: a constant here would be both a sentinel and backend-authored copy. */
  provider?: Maybe<Scalars['String']['output']>;
  /** The digest recomputed in-process from this row's current columns, for comparison against `stored_hash`. Null in two distinct cases, told apart by `recalculation_degraded`: the row was never sealed (nothing to verify), or the recompute could not be produced. */
  recalculated_hash?: Maybe<Scalars['String']['output']>;
  /** True if and only if the row IS sealed AND the on-the-fly recompute could not be produced (for instance because the stored timezone is not a resolvable IANA name). An unsealed row is always false — it is the designed state, not a degradation. This flag does NOT mean the record was altered: a recompute that succeeds and DIFFERS from `stored_hash` reports false. */
  recalculation_degraded: Scalars['Boolean']['output'];
  /** Computed status of the mark against its shift. NULLABLE: the column is nullable and no sentinel is substituted, so `null` means 'not classified' — the same state the marks listing already renders. */
  record_status?: Maybe<TimeAttendanceMarkStatus>;
  /** How many generations of this logical mark exist, starting at 1. The one integrity field that carries a real value even on a row that was never sealed, and a different number from `sequence_number`. */
  record_version: Scalars['Int']['output'];
  /** Position of this mark in its (organization, day) hash chain. This is the CHAIN sequence and a different number from `record_version`. Null on a row that was never sealed. */
  sequence_number?: Maybe<Scalars['Int']['output']>;
  /** The digest persisted when the row was sealed. Null on a row that was never sealed. */
  stored_hash?: Maybe<Scalars['String']['output']>;
  /** Local wall-clock time of the mark as `HH:MM`, in the mark's own `timezone`. Null when that timezone is blank or is not a resolvable IANA name — deliberately null rather than a fallback hour: on an audit screen a wrong local time is worse than none, because it can make a reader conclude the punch happened on a different day. */
  time?: Maybe<Scalars['String']['output']>;
  /** IANA timezone recorded with the mark, echoed verbatim as stored. Present so `time` is self-describing for an auditor, and so a timezone that failed to resolve is still visible. */
  timezone: Scalars['String']['output'];
  /** Federated reference to the collaborator who owns the mark */
  user: CentralizedUserNode;
};

export type TimeGetMarkIntegrityDetailResult = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeGetMarkIntegrityDetailPayload | ValidationErrorResponse;

export type TimeGetOrganizationAttendancePreferenceInput = {
  /** Organization scope */
  centralized_organization_id: Scalars['Int']['input'];
};

export type TimeGetOrganizationAttendancePreferencePayload = {
  __typename?: 'TimeGetOrganizationAttendancePreferencePayload';
  /** The preference (synthesized OFF default when unset) */
  organization_attendance_preference: TimeOrganizationAttendancePreference;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type TimeGetOrganizationAttendancePreferencePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeGetOrganizationAttendancePreferencePayload | ValidationErrorResponse;

export type TimeGetOvertimeConfigInput = {
  /** Organization scope (required; enforced by AC-2 org-scoping) */
  centralized_organization_id: Scalars['Int']['input'];
  /** Overtime config unique identifier to retrieve */
  id: Scalars['UUID']['input'];
};

export type TimeGetOvertimeConfigPayload = {
  __typename?: 'TimeGetOvertimeConfigPayload';
  /** The requested configuration's full current detail */
  overtime_config: TimeOvertimeConfig;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type TimeGetOvertimeConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeGetOvertimeConfigPayload;

export type TimeGetPeriodChangeHistoryInput = {
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
  /** Date-range filter (defaults to the last full calendar month) */
  filter?: InputMaybe<TimeGetPeriodDetailFilterInput>;
  /** IANA timezone used to resolve the default last-full-month range when the filter omits date_from/date_to (e.g. America/Lima). Falls back to UTC when omitted. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Collaborator identifier (centralized user original_id) */
  user_id: Scalars['Int']['input'];
};

export type TimeGetPeriodChangeHistoryPayload = {
  __typename?: 'TimeGetPeriodChangeHistoryPayload';
  /** Merged mark + shift + overtime-adjustment change rows, ordered most-recent-first */
  changes: Array<TimePeriodChangeRow>;
};

export type TimeGetPeriodChangeHistoryPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeGetPeriodChangeHistoryPayload | ValidationErrorResponse;

export type TimeGetPeriodDetailFilterInput = {
  /** Start of the inclusive date range. Defaults to the first day of the last full calendar month when the whole range is omitted (AC-1). */
  date_from?: InputMaybe<Scalars['Date']['input']>;
  /** End of the inclusive date range. Defaults to the last day of the last full calendar month when omitted. The range may span at most 31 calendar days; a wider window is rejected with MAX_RANGE_EXCEEDED. */
  date_to?: InputMaybe<Scalars['Date']['input']>;
};

export type TimeGetPeriodDetailInput = {
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
  /** Date-range filter (defaults to the last full calendar month) */
  filter?: InputMaybe<TimeGetPeriodDetailFilterInput>;
  /** IANA timezone used to resolve the default last-full-month range when the filter omits date_from/date_to (e.g. America/Lima). Falls back to UTC when omitted. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Collaborator identifier (centralized user original_id) */
  user_id: Scalars['Int']['input'];
};

export type TimeGetPeriodDetailPayload = {
  __typename?: 'TimeGetPeriodDetailPayload';
  /** Σ days counted as attendance over the period (AC-2) */
  attendance_days: Scalars['Int']['output'];
  /** Σ net excess minutes over the period (AC-3) */
  excess_net_minutes_total: Scalars['Int']['output'];
  /** Σ assigned extra minutes over the period (AC-3) */
  extra_minutes_total: Scalars['Int']['output'];
  /** Σ justified-absence minutes EXCLUDING vacation policies — the numerator an absenteeism rate wants, since vacation is planned agreed time off, not absenteeism. Vacation is identified by matching the snapshotted policy-type NAME against a configured list, because HRIS models the policy type as free text per organization with no discriminator: an organization that renames its policy stops being excluded. Pair with scheduled minutes on the same row to build a rate. */
  justified_absence_minutes_excluding_vacation_total: Scalars['Int']['output'];
  /** Σ minutes of JUSTIFIED absence (approved Time Off) over the period. FULL coverage contributes the day's scheduled bracket, HALF contributes half of it. A degraded row (Time Off source unreachable) contributes nothing rather than a silent 0. */
  justified_absence_minutes_total: Scalars['Int']['output'];
  /** Σ gross lost minutes over the period (tardiness + early exit + extended break), BEFORE Mechanism 1 nets them against same-day excess. Compare with lost_net_minutes_total: the difference is the intra-day compensation the period absorbed. */
  lost_minutes_total: Scalars['Int']['output'];
  /** Σ net lost minutes over the period (AC-3) */
  lost_net_minutes_total: Scalars['Int']['output'];
  /** Σ days counted as paid justified absence (AC-2) */
  paid_justified_absence_days: Scalars['Int']['output'];
  /** Σ justified-absence minutes whose policy is PAID (con goce de haber). Paid + unpaid equals the total only when no row is degraded. */
  paid_justified_absence_minutes_total: Scalars['Int']['output'];
  /** Σ assigned replacement minutes over the period (AC-3) */
  replacement_minutes_total: Scalars['Int']['output'];
  /** One row per calendar day in the range, ascending by date */
  rows: Array<TimePeriodDayRow>;
  /** Σ scheduled minutes EXCLUDING holidays and vacation-covered days — the denominator for an absenteeism rate, so the same days are out of both sides of the ratio. Differs from scheduled_minutes_total, which does NOT exclude holidays: a holiday on a scheduled working weekday keeps its full bracket there. Vacation is identified by the same configured policy-type name list as the justified-absence totals, with the same known limitation. */
  scheduled_minutes_excluding_vacation_and_holiday_total: Scalars['Int']['output'];
  /** Σ minutes the collaborator was scheduled to work over the period, as calculated by the engine. Days with no shift assigned, Time Off without a shift, and worked holidays / rest days contribute 0. */
  scheduled_minutes_total: Scalars['Int']['output'];
  /** Σ days counted as unjustified absence (AC-2) */
  unjustified_absence_days: Scalars['Int']['output'];
  /** Σ unjustified-absence minutes over the period — feeds the 'Tiempo en ausencia' column (AC-3) */
  unjustified_absent_minutes_total: Scalars['Int']['output'];
  /** Σ days counted as unpaid justified absence (AC-2) */
  unpaid_justified_absence_days: Scalars['Int']['output'];
  /** Σ justified-absence minutes whose policy is UNPAID (sin goce de haber). */
  unpaid_justified_absence_minutes_total: Scalars['Int']['output'];
  /** Collaborator identifier (centralized user original_id) */
  user_id: Scalars['Int']['output'];
  /** Σ worked minutes over the period (AC-3) */
  worked_minutes_total: Scalars['Int']['output'];
};

export type TimeGetPeriodDetailPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeGetPeriodDetailPayload | ValidationErrorResponse;

export type TimeGetShiftConflictReportExportInput = {
  /** Organization scope identifier. A job belonging to another organization is reported as NOT FOUND, never as forbidden. */
  centralized_organization_id: Scalars['Int']['input'];
  /** The export_id returned by shift_conflict_report_export_request. Feed it back verbatim — never rebuild it. After a request that cleared a stale job, the NEW id is the one to poll. */
  export_id: Scalars['ID']['input'];
};

export type TimeGetShiftInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** UUID of the shift to retrieve */
  shift_id: Scalars['ID']['input'];
};

export type TimeGetShiftPayload = {
  __typename?: 'TimeGetShiftPayload';
  /** The retrieved shift (non-rotating or rotating) */
  shift: TimeShiftResult;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeGetShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeGetShiftPayload;

export type TimeGetTeamUnregisteredUsersInput = {
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
  /** Date to check for absence of marks (ISO format) */
  date: Scalars['Date']['input'];
  /** Pagination options (page, page_size) */
  pagination?: InputMaybe<TimeListAttendanceMarksPaginationInput>;
  /** Search options (user name query) */
  search?: InputMaybe<TimeListAttendanceMarksSearchInput>;
  /** IANA timezone for display (e.g., America/Bogota) */
  timezone: Scalars['String']['input'];
};

export type TimeGetTeamUnregisteredUsersPayload = {
  __typename?: 'TimeGetTeamUnregisteredUsersPayload';
  /** Total unregistered subordinates matching filters (for pagination) */
  total_count: Scalars['Int']['output'];
  /** Paginated list of unregistered team members */
  users: Array<TimeUnregisteredUserListItem>;
};

export type TimeGetTeamUnregisteredUsersPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeGetTeamUnregisteredUsersPayload | ValidationErrorResponse;

export type TimeGetWorkdayOvertimeSnapshotInput = {
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
  /** Composite key '{user_original_id}-{ISO date}' — the same value TimeWorkday.id carries, fed straight back from the clicked row. Split on the FIRST hyphen so the ISO date's own hyphens survive. */
  record_id: Scalars['ID']['input'];
};

export type TimeGetWorkdayOvertimeSnapshotPayload = {
  __typename?: 'TimeGetWorkdayOvertimeSnapshotPayload';
  /** Unjustified absence minutes */
  absence_minutes: Scalars['Int']['output'];
  /** When what you are looking at was computed: the most recent re-run (recalculated_at) when there is one, else the original calculated_at. A COALESCE, not a max() — a re-run wins even if its timestamp is older. NULL means the day has NO persisted row at all, i.e. it never closed; that is the discriminator for the 'sin calcular' state. */
  calculated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Mecanismo 1: minutes auto-compensated within the day */
  compensated_minutes: Scalars['Int']['output'];
  /** AC-4: whether that same governing config has compensation switched on. Same field and resolution as TimeWorkday.compensation_available. */
  compensation_available: Scalars['Boolean']['output'];
  /** The compensation window of the config that PRICED the day (a historical label, like quantification), projected faithfully. Null when no pricing config resolves or when it has compensation off. The 'No aplica' derivation is FE-side and WIDER than null — the FE also treats DAILY as not applicable. */
  compensation_window?: Maybe<TimeOvertimeCompensationWindow>;
  /** Per-day breakdown of the above. Constant empty list in V1 (D14) — field shipped, ledger not. */
  compensations: Array<TimeWorkdayCrossDayCompensation>;
  /** Why no single config could be resolved for the day: NO_ACTIVE_CONFIG (0 match the shift), MULTIPLE_ACTIVE_CONFIGS (2+ match, so none can be chosen), or NO_SHIFT (the day carries no shift snapshot). NULL means exactly one config resolved. It is the ONLY way to tell the 0-config case from the ambiguous one — the two booleans render both as false. ⚠️ Two provenances for this enum: here it describes the LIVE resolution, while list_classified_overtime projects it from PERSISTED segments; for the same day the two may legitimately disagree. */
  config_resolution_reason?: Maybe<TimeOvertimeUnclassifiedReason>;
  /** Minutes of this day's excess used to cover OTHER days. Constant 0 in V1 (D14): no day→day compensation ledger exists yet. */
  cross_day_compensated_minutes: Scalars['Int']['output'];
  /** The calendar day, parsed from record_id */
  date: Scalars['Date']['output'];
  /** Gross delay / tiempo perdido */
  delay_minutes: Scalars['Int']['output'];
  /** GROSS excedente — the same figure the clicked listing row shows */
  excess_minutes: Scalars['Int']['output'];
  /** NET excedente: gross minus the intra-day auto compensation (excess_net == excess - compensated). This is the bag that gets split into extra_hours_minutes + reposicion_minutes, so without it the drawer cannot make the three numbers add up. */
  excess_net_minutes: Scalars['Int']['output'];
  /** Mecanismo 2: minutes of the net excess classified as horas extra */
  extra_hours_minutes: Scalars['Int']['output'];
  /** The day's segments, raw and ordered by ``segment_ordinal`` ascending. Unpaginated by design — the count is bounded by the tier ladder. Empty on a day with no extra time (the default case while overtime allocation is switched off org-wide). */
  factors: Array<TimeWorkdayOvertimeFactor>;
  /** The day's extra minutes BEFORE quantification/rounding (time_daily_result.extra_minutes). */
  original_minutes: Scalars['Int']['output'];
  /** AC-3: whether exactly one live + active overtime config governs this day's shift RIGHT NOW. Same field, same resolution and same value as TimeWorkday.overtime_config_active for the same day. */
  overtime_config_active: Scalars['Boolean']['output'];
  /** How the config that PRICED this day quantified overtime, as an ENUM — the FE owns the Spanish copy; the BE never sends rendered text. Null when no pricing config can be resolved (the day has no segment carrying a config id, or that config was hard-removed). */
  quantification?: Maybe<TimeOvertimeQuantificationType>;
  /** Echoed identity, rebuilt CANONICALLY as '{user_id}-{ISO date}' — not the raw input. The parser tolerates wider forms (compact '20260115', ISO-week '2026-W03-1', underscore separators), and echoing them back would give one day several cache keys in the FE's normalized store. */
  record_id: Scalars['ID']['output'];
  /** Mecanismo 2: minutes of the net excess reserved as tiempo a compensar */
  reposicion_minutes: Scalars['Int']['output'];
  /** The day's extra minutes AFTER rounding = the sum of the factor segments. Expected to DIFFER from original_minutes: the classifier builds the segments from the rounded value (up with NEXT, down with PREVIOUS). Never assume the two balance. */
  rounded_minutes: Scalars['Int']['output'];
  /** True when ANY segment of the day flagged the coverage warning (any, not all — one exact segment must not hide it). Note that on a degraded day rounded_minutes EQUALS original_minutes, so a 'we rounded' message must not fire on this combination. A day degraded as a WHOLE reports false: that writer stamps the flag off. */
  rounding_degraded: Scalars['Boolean']['output'];
  /** The collaborator, parsed from record_id */
  user_id: Scalars['Int']['output'];
  /** Minutes effectively worked on the day */
  worked_minutes: Scalars['Int']['output'];
};

export type TimeGetWorkdayOvertimeSnapshotPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeGetWorkdayOvertimeSnapshotPayload | ValidationErrorResponse;

export type TimeHomeMarkingCount = {
  __typename?: 'TimeHomeMarkingCount';
  /** Count of users with home marking enabled */
  home_user_count: Scalars['Int']['output'];
};

export enum TimeJustificanteOrigin {
  Manual = 'MANUAL',
  TimeOff = 'TIME_OFF'
}

export type TimeJustificationBreakdown = {
  __typename?: 'TimeJustificationBreakdown';
  /** JUSTIFIED days with HALF Time Off coverage */
  half_day: Scalars['Int']['output'];
  /** JUSTIFIED days with FULL coverage counted as paid */
  with_pay: Scalars['Int']['output'];
  /** JUSTIFIED days with FULL coverage counted as unpaid */
  without_pay: Scalars['Int']['output'];
};

export enum TimeJustificationBucket {
  HalfDay = 'HALF_DAY',
  WithoutPay = 'WITHOUT_PAY',
  WithPay = 'WITH_PAY'
}

export enum TimeJustificationFraction {
  FullDay = 'FULL_DAY',
  HalfDayAfternoon = 'HALF_DAY_AFTERNOON',
  HalfDayMorning = 'HALF_DAY_MORNING'
}

export type TimeJustificationRequestFileInput = {
  /** File ID returned by the file-upload subgraph */
  file_id: Scalars['ID']['input'];
};

export type TimeJustificationsMutations = {
  __typename?: 'TimeJustificationsMutations';
  /** Create an APPROVED time-off request (justificante) for a collaborator+day directly from daily attendance management. Thin orchestrator: HRIS performs create + auto-approval + balance deduction atomically; the day is recomputed inline so the refetch reads origin=MANUAL. */
  create_justification: TimeAndAttendanceAdminCreateJustificationSuccessTimeAndAttendanceAdminCreateJustificationErrorNotAuthenticatedErrorResponseInternalErrorResponse;
};


export type TimeJustificationsMutationsCreate_JustificationArgs = {
  input: TimeAndAttendanceAdminCreateJustificationInput;
};

export type TimeLateMarkReview = {
  __typename?: 'TimeLateMarkReview';
  /** Organization the review belongs to. */
  centralized_organization_id: Scalars['Int']['output'];
  /** When the FIRST late punch for this day was detected. Never advanced afterwards — it is the audit anchor of how long the day has waited. */
  first_detected_at: Scalars['DateTime']['output'];
  /** Identifier of the review row. */
  id: Scalars['ID']['output'];
  /** When the most recent late punch for this day was detected. */
  last_detected_at: Scalars['DateTime']['output'];
  /** The REAL time of the newest late punch, as the device recorded it — what an operator sorts by. Null on a row opened by re-deriving an older inbox entry. */
  last_punch_marked_at?: Maybe<Scalars['DateTime']['output']>;
  /** True only under DAY_SENT_TO_PAYROLL. Render it as 'this may also need a human at Nómina', NOT as 'this will land': a day in a closed period settles as REQUIRES_MANUAL_ACTION, and a reviewer-rejected incidence is never re-sent at all. */
  payroll_resend_expected: Scalars['Boolean']['output'];
  /** How many late punches have landed on this day. An offline burst collapses into ONE row and increments this — it never opens a second row. */
  punch_count: Scalars['Int']['output'];
  /** IANA zone the derivation used, carried so a manual recalculation republishes the SAME zone. Null falls back to the configured default. */
  punch_timezone?: Maybe<Scalars['String']['output']>;
  /** The state the day was in when the late punch was detected. */
  reason: TimeLateMarkReviewReason;
  /** When the decision was applied. Null while pending. */
  resolved_at?: Maybe<Scalars['DateTime']['output']>;
  /** centralized_user_id of the acting administrator. Null while pending. */
  resolved_by_user_id?: Maybe<Scalars['Int']['output']>;
  /** The TARGET day under review, resolved in the DEVICE's timezone — not the day the punch arrived. */
  result_date: Scalars['Date']['output'];
  /** The decision applied, or PENDING_REVIEW while none has been. */
  state: TimeLateMarkReviewState;
  /** centralized_user_id of the collaborator whose day changed. */
  user_id: Scalars['Int']['output'];
};

export enum TimeLateMarkReviewReason {
  /** The day was already computed locally but never sent to payroll. Recalculating corrects a figure that exists. */
  DayCalculated = 'DAY_CALCULATED',
  /** The day is past the open window and has no computed result at all. Recalculating produces one for the first time. */
  DayNotCalculated = 'DAY_NOT_CALCULATED',
  /** Nómina already holds a figure for this day. Recalculating will derive an UPDATE against the receiver's existing record — the only reason that sets payroll_resend_expected. */
  DaySentToPayroll = 'DAY_SENT_TO_PAYROLL',
  /** The punch is older than the configured maximum acceptance age. It was still recorded and still derived — the window is a triage LABEL, never a rejection. Inert while the maximum age is unbounded (the shipped default). */
  OutsideWindow = 'OUTSIDE_WINDOW'
}

export enum TimeLateMarkReviewState {
  /** An administrator left the day as it stands. Nothing was published and no figure changed. */
  Dismissed = 'DISMISSED',
  /** A late punch changed this day and its automatic recomputation was withheld. Nobody has decided yet. */
  PendingReview = 'PENDING_REVIEW',
  /** An administrator asked for the day to be recomputed. The recalculation was published; whether it also reaches Nómina depends on payroll_resend_expected. */
  Recalculated = 'RECALCULATED'
}

export type TimeLateMarkReviewsMutations = {
  __typename?: 'TimeLateMarkReviewsMutations';
  /** Dismiss a withheld day: record that an administrator looked at it and chose to leave it as it stands. Nothing is published and no figure changes — including at Nómina. */
  dismiss_late_mark_review: TimeResolveLateMarkReviewPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse;
  /** Recalculate a day whose automatic recomputation was withheld because a biometric punch arrived late. Publishes the SAME recomputation the derivation would have published. When payroll_resend_expected is true this will also update the day at Nómina. */
  recalculate_late_mark_review: TimeResolveLateMarkReviewPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeLateMarkReviewsMutationsDismiss_Late_Mark_ReviewArgs = {
  input: TimeResolveLateMarkReviewInput;
};


export type TimeLateMarkReviewsMutationsRecalculate_Late_Mark_ReviewArgs = {
  input: TimeResolveLateMarkReviewInput;
};

export type TimeLateMarkReviewsQueries = {
  __typename?: 'TimeLateMarkReviewsQueries';
  /** List the days whose automatic recomputation was withheld because a biometric punch arrived after the day was already settled. One row per (collaborator, day) — an offline burst collapses into one row and increments punch_count. */
  list_late_mark_reviews: TimeListLateMarkReviewsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeLateMarkReviewsQueriesList_Late_Mark_ReviewsArgs = {
  input: TimeListLateMarkReviewsInput;
};

export type TimeListAttendanceCardsFilterInput = {
  /** Start of the inclusive date range. Defaults to the first day of the last full calendar month (resolved in the request/org timezone) when the whole range is omitted (AC-1/D7). */
  date_from?: InputMaybe<Scalars['Date']['input']>;
  /** End of the inclusive date range. Defaults to the last day of the last full calendar month when omitted. The range may span at most 31 calendar days; a wider window is rejected with MAX_RANGE_EXCEEDED. */
  date_to?: InputMaybe<Scalars['Date']['input']>;
  /** Presence filter (multiselect): returns collaborators with at least one day in any listed status (D6). Within-field OR; absent or empty applies no constraint. NOT a dominant-status mode. */
  day_status?: InputMaybe<Array<TimeDayStatus>>;
  /** Filter by user group IDs (external service: grupos) */
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by marking-location UUIDs (lugar de marcaje) */
  marking_location_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Metric-range thresholds applied as HAVING on the period sums (AC-5/D8). Multiple thresholds combine with AND. */
  metric_filters?: InputMaybe<Array<TimeAttendanceCardMetricFilterInput>>;
  /** Filter by user position IDs (external service: cargo) */
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by shift UUIDs (resolved locally to shift assignments) */
  shift_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TimeListAttendanceCardsInput = {
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
  /** Filter options (date range, status presence, shift, etc.) */
  filter?: InputMaybe<TimeListAttendanceCardsFilterInput>;
  /** Pagination options (page, page_size; default 10) */
  pagination?: InputMaybe<TimeListAttendanceMarksPaginationInput>;
  /** Search options (user name / position query) */
  search?: InputMaybe<TimeListAttendanceMarksSearchInput>;
  /** Sort options (field, direction; default FULL_NAME ASC) */
  sort?: InputMaybe<TimeListAttendanceCardsSortInput>;
  /** IANA timezone used to resolve the default last-full-month range when the filter omits date_from/date_to (e.g. America/Lima). Falls back to UTC when omitted. */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type TimeListAttendanceCardsPayload = {
  __typename?: 'TimeListAttendanceCardsPayload';
  /** Page of per-collaborator period aggregate rows */
  rows: Array<TimeAttendanceCardRow>;
  /** Total distinct collaborators matching filters (for FE-side total_pages = ceil(total_count / page_size)) */
  total_count: Scalars['Int']['output'];
};

export type TimeListAttendanceCardsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListAttendanceCardsPayload | ValidationErrorResponse;

export type TimeListAttendanceCardsSortInput = {
  /** Sort direction (ASC or DESC) */
  direction?: TimeSortDirection;
  /** Column to sort by. Defaults to FULL_NAME ASC (D1). */
  field?: TimeAttendanceCardSortField;
};

export type TimeListAttendanceLocationsInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Pagination configuration. Default: page 1, page_size 10 */
  pagination?: InputMaybe<TimeListAttendanceLocationsPaginationInput>;
  /** Search by name or address */
  search?: InputMaybe<TimeListAttendanceLocationsSearchInput>;
};

export type TimeListAttendanceLocationsPaginationInput = {
  /** Page number (1-based). Default: 1. */
  page?: Scalars['Int']['input'];
  /** Number of items per page. Default: 10. */
  page_size?: Scalars['Int']['input'];
};

export type TimeListAttendanceLocationsPayload = {
  __typename?: 'TimeListAttendanceLocationsPayload';
  /** List of attendance locations */
  attendance_locations: Array<TimeAttendanceLocation>;
  /** Home marking user count. Only populated on page 1, null on page 2+. */
  home_marking_summary?: Maybe<TimeHomeMarkingCount>;
  /** Total count of locations matching the filters (without pagination) */
  total_count: Scalars['Int']['output'];
};

export type TimeListAttendanceLocationsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListAttendanceLocationsPayload;

export type TimeListAttendanceLocationsSearchInput = {
  /** Search query for partial name or address match (case-insensitive) */
  query: Scalars['String']['input'];
};

export type TimeListAttendanceMarksFilterInput = {
  /** Filter by classification status (ON_TIME, ACCEPTABLE, LATE, etc.) */
  classifications?: InputMaybe<Array<TimeAttendanceMarkStatus>>;
  /** Filter by specific date */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by user group IDs (external service) */
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by integrity seal state (TIM-399). Multiselect with the same semantics as `mark_sources`: within-field OR, AND-combined with the other filters, and absent or empty applies no constraint. Admin-only — there is no equivalent on the team listing, which exposes the FIELD but not this filter. `NOT_APPLICABLE` selects the pre-rollout rows that were never sealed (no backfill), and mixes with the other members as an OR — so selecting all FIVE members IS equivalent to 'Todos'. */
  integrity_statuses?: InputMaybe<Array<TimeMarkIntegrityStatus>>;
  /** Filter by marking channel / 'source' (App / Web / Biometric / Excel / Manual / System) — the same axis TIM-339 exposes on the daily-management view. Multiselect: within-field OR (a mark matches when its source is in the selection), AND-combined with the other filters. Absent or empty applies no channel constraint. */
  mark_sources?: InputMaybe<Array<TimeMarkSource>>;
  /** Filter by mark type (ENTRY, BREAK_START, BREAK_END, EXIT) */
  mark_types?: InputMaybe<Array<TimeAttendanceMarkType>>;
  /** Filter by user position IDs (external service) */
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by shift UUIDs */
  shift_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TimeListAttendanceMarksInput = {
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
  /** Filter options (date, position, groups) */
  filter?: InputMaybe<TimeListAttendanceMarksFilterInput>;
  /** Pagination options (page, page_size) */
  pagination?: InputMaybe<TimeListAttendanceMarksPaginationInput>;
  /** Search options (user name query) */
  search?: InputMaybe<TimeListAttendanceMarksSearchInput>;
  /** Sort by mark date. Default: MARKED_AT DESC (most recent first). */
  sort?: InputMaybe<TimeListAttendanceMarksSortInput>;
};

export type TimeListAttendanceMarksPaginationInput = {
  /** Page number (1-based) */
  page?: Scalars['Int']['input'];
  /** Items per page (max 150) */
  page_size?: Scalars['Int']['input'];
};

export type TimeListAttendanceMarksPayload = {
  __typename?: 'TimeListAttendanceMarksPayload';
  /** Page of attendance marks */
  attendance_marks: Array<TimeAttendanceMarkListItem>;
  /** Total marks matching filters (for pagination) */
  total_count: Scalars['Int']['output'];
};

export type TimeListAttendanceMarksPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListAttendanceMarksPayload | ValidationErrorResponse;

export type TimeListAttendanceMarksSearchInput = {
  /** Free-text search on user name (external service) */
  query: Scalars['String']['input'];
};

export type TimeListAttendanceMarksSortInput = {
  /** Sort direction applied to the full result set before paginating. DESC = most recent first, ASC = oldest first. Default: DESC. */
  direction?: TimeSortDirection;
  /** Field to sort by. Default: MARKED_AT. */
  field?: TimeAttendanceMarkSortField;
};

export type TimeListClassifiedOvertimeInput = {
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
  /** Start of the inclusive period. The period is a filter over rows already factorized at write time — narrowing it never restarts a tier ladder nor changes a day's factor. */
  date_from: Scalars['Date']['input'];
  /** End of the inclusive period. The range may span at most 31 calendar days; a wider window is rejected with MAX_RANGE_EXCEEDED. */
  date_to: Scalars['Date']['input'];
  /** Pagination options (page, page_size; default page 1, size 10). Rows are ordered by user_id ascending — no name resolution. */
  pagination?: InputMaybe<TimeListAttendanceMarksPaginationInput>;
  /** Restrict to these collaborators. Omitted or null means ALL collaborators of the organization; an explicit empty list returns an EMPTY result and must never be sent as a 'no filter' sentinel. */
  user_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TimeListClassifiedOvertimePayload = {
  __typename?: 'TimeListClassifiedOvertimePayload';
  /** The requested page, ordered by user_id ascending */
  collaborators: Array<TimeClassifiedOvertimeCollaborator>;
  /** Total collaborators with at least one calculated day in the period, before pagination. No zero-row synthesis. */
  total_count: Scalars['Int']['output'];
};

export type TimeListClassifiedOvertimePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListClassifiedOvertimePayload | ValidationErrorResponse;

export type TimeListCollaboratorComplianceFilterInput = {
  /** Filter by user group IDs (external service: grupos) */
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by marking-location UUIDs (lugar de marcaje) */
  marking_location_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by user position IDs (external service: cargo) */
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by shift UUIDs, resolved locally to shift assignments. Known limitation: the resolution keeps only ACTIVE assignments, so over a historical window a collaborator whose assignment was later deactivated does not appear under this filter (pre-existing behaviour shared with the attendance-cards and daily-workdays listings) */
  shift_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TimeListCollaboratorComplianceInput = {
  /** Organization scope. Gated: the caller must administer it */
  centralized_organization_id: Scalars['Int']['input'];
  /** Country whose catalog to evaluate against (MX only for now) */
  country: TimeComplianceCountry;
  /** Filter options (cargo, grupos, lugar de marcaje, turno) */
  filter?: InputMaybe<TimeListCollaboratorComplianceFilterInput>;
  /** Pagination options (page >= 1, page_size 1..150; default page 1, size 10). A page_size above the cap is a typed ValidationErrorResponse with code INVALID_PAGINATION, never a silently clamped page. total_count and state_counts always cover the FULL filtered set, so a page past the last is empty with non-zero counters */
  pagination?: InputMaybe<TimeListAttendanceMarksPaginationInput>;
  /** Window to evaluate (DAY or WEEK) and its reference date */
  period: TimeCompliancePeriodInput;
  /** Free-text search on collaborator name (external service). Omitting `search` applies no constraint; sending an EMPTY or blank query is a provided filter and IS resolved upstream */
  search?: InputMaybe<TimeListAttendanceMarksSearchInput>;
  /** IANA timezone used ONLY to resolve today when period.reference_date is omitted (e.g. America/Mexico_City). Falls back to UTC when omitted or invalid — invalid is not an error. It never shifts the minute totals */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type TimeListCollaboratorCompliancePayload = {
  __typename?: 'TimeListCollaboratorCompliancePayload';
  /** The requested page, ordered by user_id ascending. Empty is a valid success state — an empty result is an empty page, never a NotFound */
  collaborators: Array<TimeCollaboratorCompliance>;
  /** Exactly the caps scored for this request, after dropping the ones incompatible with the window and the ones that are inactive or have an incomplete band. EMPTY is a valid answer: every collaborator is then NO_DATA and the minute columns are still real */
  evaluated_codes: Array<TimeComplianceThresholdCode>;
  /** The window that was evaluated, resolved and echoed back */
  period: TimeCompliancePeriod;
  /** The four summary-card counts over the full filtered set */
  state_counts: TimeComplianceStateCounts;
  /** Collaborators in the FULL filtered set — every collaborator with at least one calculated day in the window. Computed before the page slice */
  total_count: Scalars['Int']['output'];
};

export type TimeListCollaboratorComplianceResult = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListCollaboratorCompliancePayload | ValidationErrorResponse;

export type TimeListCollaboratorMarkingConfigsInput = {
  /** Organization scope */
  centralized_organization_id: Scalars['Int']['input'];
  /** Collaborators' centralized user IDs to read (max 500 per call). Users without a marking configuration are omitted from the response — absence means 'not configured', not 'all disabled'. */
  user_ids: Array<Scalars['Int']['input']>;
};

export type TimeListCollaboratorMarkingConfigsPayload = {
  __typename?: 'TimeListCollaboratorMarkingConfigsPayload';
  /** Configurations found for the requested users, each with its assigned marking locations. Users without a configuration are omitted. */
  collaborator_marking_configs: Array<TimeCollaboratorMarkingConfig>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
  /** Number of configurations returned */
  total_count: Scalars['Int']['output'];
};

export type TimeListCollaboratorMarkingConfigsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListCollaboratorMarkingConfigsPayload | ValidationErrorResponse;

export type TimeListComplianceThresholdsInput = {
  /** Organization scope */
  centralized_organization_id: Scalars['Int']['input'];
  /** Country whose catalog to read (MX only for now) */
  country: TimeComplianceCountry;
};

export type TimeListComplianceThresholdsPayload = {
  __typename?: 'TimeListComplianceThresholdsPayload';
  /** All six MX thresholds, with the domain default synthesized for any code that has no row. Never empty, never more than six */
  thresholds: Array<TimeComplianceThreshold>;
};

export type TimeListComplianceThresholdsResult = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListComplianceThresholdsPayload | ValidationErrorResponse;

export type TimeListDevicesWithPunchesFilterInput = {
  /** Marking place ids to filter by. Null or empty means 'every marking place' UNLESS include_without_location is also set — see the truth table in this input's docstring: with include_without_location=true and this empty/null, the result is ONLY devices without a marking place, not every device. With this non-empty AND include_without_location=true, the result is the UNION of both (devices at these places plus devices with none), never their intersection. */
  attendance_location_ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Include devices with no resolved marking place. Combined with attendance_location_ids per the truth table in this input's docstring: alone (with attendance_location_ids empty/null) it narrows to ONLY unmapped devices; alongside a non-empty attendance_location_ids it ADDS them (union, never intersection). */
  include_without_location?: Scalars['Boolean']['input'];
};

export type TimeListDevicesWithPunchesInput = {
  /** Organization scope */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional filter by marking place, including 'without a marking place'. Omitted means every device in the organization. */
  filter?: InputMaybe<TimeListDevicesWithPunchesFilterInput>;
  /** Optional page/page_size. Omitted defaults to page 1, page_size 20. */
  pagination?: InputMaybe<TimeListDevicesWithPunchesPaginationInput>;
};

export type TimeListDevicesWithPunchesPaginationInput = {
  /** 1-based page number. A value below 1 is normalized to 1, never rejected. */
  page?: Scalars['Int']['input'];
  /** Rows per page, capped at 100. A value above the cap or below 1 is rejected with a ValidationErrorResponse. */
  page_size?: Scalars['Int']['input'];
};

export type TimeListDevicesWithPunchesPayload = {
  __typename?: 'TimeListDevicesWithPunchesPayload';
  /** This page's rows, ordered by most recent punch first */
  devices: Array<TimeDeviceWithPunches>;
  /** Total matching devices before this page's slice, with the same filters as the page */
  total_count: Scalars['Int']['output'];
};

export type TimeListDevicesWithPunchesPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListDevicesWithPunchesPayload | ValidationErrorResponse;

export type TimeListEligibleShiftsInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Composite key '{user_original_id}-{date}' — same as TimeWorkday.id */
  record_id: Scalars['ID']['input'];
};

export type TimeListEligibleShiftsPayload = {
  __typename?: 'TimeListEligibleShiftsPayload';
  /** Active org shifts eligible for the row (FE dedupes the current one) */
  eligible_shifts: Array<TimeEligibleShift>;
};

export type TimeListEligibleShiftsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListEligibleShiftsPayload | ValidationErrorResponse;

export type TimeListHomeMarkingUsersInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Pagination configuration. Default: page 1, page_size 10 */
  pagination?: InputMaybe<TimeListHomeMarkingUsersPaginationInput>;
};

export type TimeListHomeMarkingUsersPaginationInput = {
  /** Page number (1-based). Default: 1. */
  page?: Scalars['Int']['input'];
  /** Number of items per page. Default: 10. */
  page_size?: Scalars['Int']['input'];
};

export type TimeListHomeMarkingUsersPayload = {
  __typename?: 'TimeListHomeMarkingUsersPayload';
  /** Total count of home marking users for pagination */
  total_count: Scalars['Int']['output'];
  /** Paginated list of users with home marking enabled */
  users: Array<CentralizedUserNode>;
};

export type TimeListHomeMarkingUsersPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListHomeMarkingUsersPayload;

export type TimeListLateMarkReviewsFilterInput = {
  /** Earliest TARGET day to include (inclusive). This filters the day under review, not when the punch was detected. */
  date_from?: InputMaybe<Scalars['Date']['input']>;
  /** Latest TARGET day to include (inclusive). */
  date_to?: InputMaybe<Scalars['Date']['input']>;
  /** Restrict to one day-state-at-detection. Omit for every reason. */
  reason?: InputMaybe<TimeLateMarkReviewReason>;
  /** Restrict to one decision state. Omit for every state; the queue screen normally passes PENDING_REVIEW. */
  state?: InputMaybe<TimeLateMarkReviewState>;
  /** Restrict to one collaborator. Omit for the whole organization. */
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeListLateMarkReviewsInput = {
  /** Organization scope identifier. The caller must be able to manage it (org gate) or the request is FORBIDDEN. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional filters (omit for the whole organization's queue). */
  filter?: InputMaybe<TimeListLateMarkReviewsFilterInput>;
  /** Optional pagination (defaults page=1, page_size=20). */
  pagination?: InputMaybe<TimeListLateMarkReviewsPaginationInput>;
};

export type TimeListLateMarkReviewsPaginationInput = {
  /** Page number (1-indexed, clamped >= 1) */
  page?: Scalars['Int']['input'];
  /** Items per page (clamped [1, 100]) */
  page_size?: Scalars['Int']['input'];
};

export type TimeListLateMarkReviewsPayload = {
  __typename?: 'TimeListLateMarkReviewsPayload';
  /** The page of review rows, newest target day first. */
  late_mark_reviews: Array<TimeLateMarkReview>;
  /** Total matching rows BEFORE pagination. Zero is a valid success — an empty queue means no day is waiting on a person. */
  total_count: Scalars['Int']['output'];
};

export type TimeListLateMarkReviewsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListLateMarkReviewsPayload | ValidationErrorResponse;

export type TimeListMyOvertimeRequestsInput = {
  /** Organization scope identifier. The caller must belong to it or the request is FORBIDDEN, refused before any read. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Offset pagination. Omitted, null or an empty object all mean page 1 with 20 rows. */
  pagination?: InputMaybe<TimeListMyOvertimeRequestsPaginationInput>;
};

export type TimeListMyOvertimeRequestsPaginationInput = {
  /** 1-based page number. A value below 1 is NORMALIZED to 1 rather than rejected, and a page past the last one is an empty page with the real total_count — not an error. */
  page?: Scalars['Int']['input'];
  /** Rows per page, between 1 and 100. Outside that range the request is REJECTED with OVERTIME_REQUEST_PAGE_SIZE_INVALID (below 1) or OVERTIME_REQUEST_PAGE_SIZE_EXCEEDED (above 100) — never silently clamped, so a client asking for 500 rows learns it did not get them. */
  page_size?: Scalars['Int']['input'];
};

export type TimeListMyOvertimeRequestsPayload = {
  __typename?: 'TimeListMyOvertimeRequestsPayload';
  /** The page of requests the caller filed, ordered by filing time, newest first. Never another collaborator's: the author is the session. */
  overtime_requests: Array<TimeOvertimeRequest>;
  /** Total requests matching the caller and the organization BEFORE pagination. Zero is a valid success — a collaborator who has never filed anything gets an empty list, not an error. It is computed by its own statement, so under the default isolation level it can disagree with the page by a row the caller created from another tab in between; that skew is inherent to offset pagination and is accepted, not mitigated. */
  total_count: Scalars['Int']['output'];
};

export type TimeListMyOvertimeRequestsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListMyOvertimeRequestsPayload | ValidationErrorResponse;

export type TimeListOvertimeConfigsFilterInput = {
  /** Filter by countries (list of country codes) */
  countries: Array<TimeOvertimeCountry>;
};

export type TimeListOvertimeConfigsInput = {
  /** Organization scope (required; enforced by AC-4) */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional country filter (omit for no country filter) */
  filter?: InputMaybe<TimeListOvertimeConfigsFilterInput>;
  /** Optional pagination (defaults page=1, page_size=10) */
  pagination?: InputMaybe<TimeListOvertimeConfigsPaginationInput>;
  /** Optional name search (omit for no search filter) */
  search?: InputMaybe<TimeListOvertimeConfigsSearchInput>;
  /** Optional sort spec (default UPDATED_AT DESC) */
  sort?: InputMaybe<TimeListOvertimeConfigsSortInput>;
};

export type TimeListOvertimeConfigsPaginationInput = {
  /** Page number (1-indexed, clamped >= 1) */
  page?: Scalars['Int']['input'];
  /** Items per page (clamped [1, 100]) */
  page_size?: Scalars['Int']['input'];
};

export type TimeListOvertimeConfigsPayload = {
  __typename?: 'TimeListOvertimeConfigsPayload';
  /** List of overtime configurations (paginated) */
  overtime_configs: Array<TimeOvertimeConfigListItem>;
  /** Total number of matching configurations (before pagination) */
  total_count: Scalars['Int']['output'];
};

export type TimeListOvertimeConfigsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListOvertimeConfigsPayload;

export type TimeListOvertimeConfigsSearchInput = {
  /** Partial name match (case-insensitive, % and _ escaped) */
  query: Scalars['String']['input'];
};

export type TimeListOvertimeConfigsSortInput = {
  /** Sort direction (ASC or DESC) */
  direction: TimeSortDirection;
  /** Field to sort by (NAME, COUNTRY, STATUS, UPDATED_AT) */
  field: TimeOvertimeConfigSortField;
};

export type TimeListPeriodJustificantesInput = {
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
  /** Date-range filter (defaults to the last full calendar month) */
  filter?: InputMaybe<TimeGetPeriodDetailFilterInput>;
  /** Pagination options (page, page_size; default page 1, size 10) */
  pagination?: InputMaybe<TimeListAttendanceMarksPaginationInput>;
  /** IANA timezone used to resolve the default last-full-month range when the filter omits date_from/date_to (e.g. America/Lima). Falls back to UTC when omitted. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Collaborator identifier (centralized user original_id) */
  user_id: Scalars['Int']['input'];
};

export type TimeListPeriodJustificantesPayload = {
  __typename?: 'TimeListPeriodJustificantesPayload';
  /** Page of Time-Off-backed justified days, ascending by date */
  items: Array<TimePeriodJustificante>;
  /** Current page number (1-based) */
  page: Scalars['Int']['output'];
  /** Page size used for this page */
  page_size: Scalars['Int']['output'];
  /** Total justificantes matching the period (for FE-side total_pages = ceil(total_count / page_size)) */
  total_count: Scalars['Int']['output'];
};

export type TimeListPeriodJustificantesPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListPeriodJustificantesPayload | ValidationErrorResponse;

export type TimeListShiftConflictsInput = {
  /** Organization scope identifier. The caller must be able to manage it (org gate) or the request is FORBIDDEN. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional filters (omit for the whole organization). */
  filter?: InputMaybe<TimeShiftConflictsFilterInput>;
  /** Optional pagination (defaults page=1, page_size=20). */
  pagination?: InputMaybe<TimeListShiftConflictsPaginationInput>;
};

export type TimeListShiftConflictsPaginationInput = {
  /** Page number (1-indexed; a non-positive page is read as 1) */
  page?: Scalars['Int']['input'];
  /** Items per page. Maximum 100 — a larger value is a validation error, never a silent clamp. */
  page_size?: Scalars['Int']['input'];
};

export type TimeListShiftConflictsPayload = {
  __typename?: 'TimeListShiftConflictsPayload';
  /** One row per (collaborator, shift A, shift B); may be empty */
  conflicts: Array<TimeShiftConflictRow>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** Total matching rows before pagination */
  total_count: Scalars['Int']['output'];
};

export type TimeListShiftConflictsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListShiftConflictsPayload | ValidationErrorResponse;

export type TimeListShiftsFilterInput = {
  /** Filter by active status. If not set, returns all. */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by shift type (NON_ROTATING or ROTATING). If not set, returns both types. */
  shift_type?: InputMaybe<TimeShiftType>;
};

export type TimeListShiftsInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Filter by shift type and/or active status */
  filter?: InputMaybe<TimeListShiftsFilterInput>;
  /** Pagination configuration. Default: page 1, page_size 10 */
  pagination?: InputMaybe<TimeListShiftsPaginationInput>;
  /** Search by shift name (partial, case-insensitive) */
  search?: InputMaybe<TimeListShiftsSearchInput>;
  /** Sort configuration. Default: CREATED_AT DESC (most recent first) */
  sort?: InputMaybe<TimeListShiftsSortInput>;
};

export type TimeListShiftsPaginationInput = {
  /** Page number (1-based). Default: 1. */
  page?: Scalars['Int']['input'];
  /** Number of items per page. Default: 10. */
  page_size?: Scalars['Int']['input'];
};

export type TimeListShiftsPayload = {
  __typename?: 'TimeListShiftsPayload';
  /** List of shifts (union of TimeNonRotatingShift | TimeRotatingShift) */
  shifts: Array<TimeShiftResult>;
  /** Total count of shifts matching the filters (without pagination) */
  total_count: Scalars['Int']['output'];
};

export type TimeListShiftsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListShiftsPayload;

export type TimeListShiftsSearchInput = {
  /** Search query for partial name match (case-insensitive ILIKE) */
  query: Scalars['String']['input'];
};

export type TimeListShiftsSortInput = {
  /** Sort direction (ASC or DESC). Default: DESC. */
  direction?: TimeSortDirection;
  /** Field to sort by (NAME or CREATED_AT). Default: CREATED_AT. */
  field?: TimeShiftSortField;
};

export type TimeListTeamAttendanceMarksFilterInput = {
  /** Filter by classification (ON_TIME, ACCEPTABLE, LATE, etc.) */
  classifications?: InputMaybe<Array<TimeAttendanceMarkStatus>>;
  /** Filter by device type (MOBILE_APP, WEB) */
  devices?: InputMaybe<Array<TimeDeviceType>>;
  /** Filter by user group IDs (external service) */
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by mark type (ENTRY, BREAK_START, BREAK_END, EXIT) */
  mark_types?: InputMaybe<Array<TimeAttendanceMarkType>>;
  /** Filter by marking location UUIDs */
  marking_location_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by must_register_from_device flag */
  marks_attendance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by user position IDs (external service) */
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by shift UUIDs */
  shift_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TimeListTeamAttendanceMarksInput = {
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
  /** End date of the range (inclusive, ISO format) */
  end_date: Scalars['Date']['input'];
  /** Filter options */
  filter?: InputMaybe<TimeListTeamAttendanceMarksFilterInput>;
  /** Pagination options (page, page_size) */
  pagination?: InputMaybe<TimeListAttendanceMarksPaginationInput>;
  /** Search options (user name query) */
  search?: InputMaybe<TimeListAttendanceMarksSearchInput>;
  /** Start date of the range (inclusive, ISO format) */
  start_date: Scalars['Date']['input'];
};

export type TimeListTeamLastStatusFilterInput = {
  /** Filter by computed member status (ENTRY, BREAK_START, etc.) */
  mark_types?: InputMaybe<Array<TimeTeamMemberStatusFilter>>;
  /** Filter by must_register_from_device flag */
  marks_attendance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by shift IDs (users assigned to any of these shifts) */
  shift_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TimeListTeamLastStatusInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Target date (ISO YYYY-MM-DD). Defaults to today if omitted. */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Filter options */
  filter?: InputMaybe<TimeListTeamLastStatusFilterInput>;
  /** Pagination options */
  pagination?: InputMaybe<TimeListTeamLastStatusPaginationInput>;
  /** User name/email search */
  search?: InputMaybe<TimeListTeamLastStatusSearchInput>;
};

export type TimeListTeamLastStatusPaginationInput = {
  /** Page number (1-based) */
  page?: Scalars['Int']['input'];
  /** Number of rows per page */
  page_size?: Scalars['Int']['input'];
};

export type TimeListTeamLastStatusPayload = {
  __typename?: 'TimeListTeamLastStatusPayload';
  /** Paginated list of team member status rows */
  members: Array<TimeTeamMemberStatusRow>;
  /** Total members matching filters (before pagination) */
  total_count: Scalars['Int']['output'];
};

export type TimeListTeamLastStatusPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListTeamLastStatusPayload | ValidationErrorResponse;

export type TimeListTeamLastStatusSearchInput = {
  /** User name/email search (resolved via centralized-user) */
  query: Scalars['String']['input'];
};

export type TimeListTeamWeeklyScheduleInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** End date of the range (ISO date YYYY-MM-DD) */
  end_date: Scalars['String']['input'];
  /** Local and external filter options */
  filter?: InputMaybe<TimeListWeeklyAssignmentsFilterInput>;
  /** Pagination options */
  pagination?: InputMaybe<TimeListWeeklyAssignmentsPaginationInput>;
  /** User name search */
  search?: InputMaybe<TimeListWeeklyAssignmentsSearchInput>;
  /** Start date of the range (ISO date YYYY-MM-DD) */
  start_date: Scalars['String']['input'];
};

export type TimeListUnregisteredUsersFilterInput = {
  /** Date to check for absence of marks */
  date: Scalars['Date']['input'];
  /** Filter by user group IDs (external service) */
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by user position IDs (external service) */
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by shift UUIDs */
  shift_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TimeListUnregisteredUsersInput = {
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
  /** Filter options (date is required) */
  filter: TimeListUnregisteredUsersFilterInput;
  /** Pagination options (page, page_size) */
  pagination?: InputMaybe<TimeListAttendanceMarksPaginationInput>;
  /** Search options (user name query) */
  search?: InputMaybe<TimeListAttendanceMarksSearchInput>;
};

export type TimeListUnregisteredUsersPayload = {
  __typename?: 'TimeListUnregisteredUsersPayload';
  /** Total unregistered users matching filters (for pagination) */
  total_count: Scalars['Int']['output'];
  /** Page of unregistered users */
  users: Array<TimeUnregisteredUserListItem>;
};

export type TimeListUnregisteredUsersPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListUnregisteredUsersPayload | ValidationErrorResponse;

export type TimeListUsersWithAttendanceAccessInput = {
  /** Centralized organization ID of the collaborator. */
  centralized_organization_id: Scalars['Int']['input'];
  /** Pagination configuration. Default: page 1, page_size 10. */
  pagination?: InputMaybe<TimeListUsersWithAttendanceAccessPaginationInput>;
  /** Centralized user ID of the COLLABORATOR whose drawer is open — not the caller. */
  user_id: Scalars['Int']['input'];
};

export type TimeListUsersWithAttendanceAccessPaginationInput = {
  /** Page number (1-based). Default: 1. */
  page?: Scalars['Int']['input'];
  /** Number of items per page. Default: 10. Maximum: 50. */
  page_size?: Scalars['Int']['input'];
};

export type TimeListUsersWithAttendanceAccessPayload = {
  __typename?: 'TimeListUsersWithAttendanceAccessPayload';
  /** Size of the full result set before slicing, for the paginator. An empty page with total_count 0 is a SUCCESS (nobody has specific access), never an error. */
  total_count: Scalars['Int']['output'];
  /** The requested page of users with access. */
  users: Array<TimeUserWithAttendanceAccess>;
};

export type TimeListUsersWithAttendanceAccessResult = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListUsersWithAttendanceAccessPayload | ValidationErrorResponse;

export type TimeListWeeklyAssignmentsFilterInput = {
  /** Filter by allowed device types (MOBILE_APP, WEB) */
  devices?: InputMaybe<Array<TimeDeviceType>>;
  /** Filter by group IDs (external, resolved via centralized-user) */
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by assigned marking location IDs (any match) */
  marking_location_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by must_register_from_device flag */
  marks_attendance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by position IDs (external, resolved via centralized-user) */
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by shift IDs (users assigned to any of these shifts) */
  shift_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TimeListWeeklyAssignmentsInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** End date of the range (ISO date YYYY-MM-DD) */
  end_date: Scalars['String']['input'];
  /** Local and external filter options */
  filter?: InputMaybe<TimeListWeeklyAssignmentsFilterInput>;
  /** Pagination options */
  pagination?: InputMaybe<TimeListWeeklyAssignmentsPaginationInput>;
  /** User name search */
  search?: InputMaybe<TimeListWeeklyAssignmentsSearchInput>;
  /** Start date of the range (ISO date YYYY-MM-DD) */
  start_date: Scalars['String']['input'];
};

export type TimeListWeeklyAssignmentsPaginationInput = {
  /** Page number (1-based) */
  page?: Scalars['Int']['input'];
  /** Number of rows per page */
  page_size?: Scalars['Int']['input'];
};

export type TimeListWeeklyAssignmentsPayload = {
  __typename?: 'TimeListWeeklyAssignmentsPayload';
  /** One entry per ACTIVE ASSIGNMENT of the paged collaborators, not one per collaborator: a collaborator with two overlapping assignments appears twice, each entry carrying its own id, its own daily_cells and its own total_planned_minutes. A collaborator's entries are always CONTIGUOUS, and within that block they are ordered by the earliest non-null entry_time among the entry's cells inside the requested range (rows with no entry_time at all come last, ties keep the underlying order). The range minimum is the criterion because a rotating shift can start at different hours on different days, so no single vertical order is chronological in every column. The list is never truncated: the cap of three shifts is a per-day write-side rule, not a limit on this list. Its length counts assignments while total_count counts collaborators — deliberately different units, never compared. */
  employees: Array<TimeWeeklyAssignmentRow>;
  /** Total distinct users matching filters (before pagination). PAGINATION IS BY COLLABORATOR TOO, so this counter and the page share one unit and can feed a paginator directly: page_size is a number of collaborators, and every assignment of a paged collaborator is returned. It is NOT the length of employees — that is a number of assignments and is legitimately larger. */
  total_count: Scalars['Int']['output'];
  /** Echoed date range from input */
  week: TimeWeekRange;
};

export type TimeListWeeklyAssignmentsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListWeeklyAssignmentsPayload | ValidationErrorResponse;

export type TimeListWeeklyAssignmentsSearchInput = {
  /** User name search query (resolved via centralized-user) */
  query: Scalars['String']['input'];
};

export type TimeListWorkdaysFilterInput = {
  /** Start of the inclusive date range. Defaults to today (resolved in the request/org timezone) when omitted. */
  date_from?: InputMaybe<Scalars['Date']['input']>;
  /** End of the inclusive date range. Defaults to today when omitted. The range may span at most 31 calendar days, i.e. (date_to - date_from) of at most 30 days; a 31-day diff is rejected with MAX_RANGE_EXCEEDED (AC-4). */
  date_to?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by day status (multiselect). Within-field OR; absent or empty applies no constraint. */
  day_status?: InputMaybe<Array<TimeDayStatus>>;
  /** Filter by user group IDs (external service) */
  group_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by marking channel / 'Dispositivo' (TIM-339): the origin of the day's representative attendance mark (App / Web / Biometric / Excel / Manual / System). Multiselect — within-field OR; absent or empty applies no constraint. A day matches when the source of its representative mark is in the selection. The representative mark is the first present in canonical order ENTRY > BREAK_START > BREAK_END > EXIT (the punch that opens the day); a day with no marks has no channel and is excluded from any selection. */
  mark_sources?: InputMaybe<Array<TimeMarkSource>>;
  /** Filter by marking-location UUIDs (lugar de marcaje) */
  marking_location_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by user position IDs (external service) */
  position_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by shift UUIDs */
  shift_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by time facet (TIM-355): narrows the table to days carrying the selected overtime/compensation dimension — EXCESS (excess_minutes > 0), EXTRA (extra_minutes > 0) or COMPENSATED (auto_compensated_minutes > 0). Multiselect — within-field OR; absent or empty applies no constraint. The facets are independent and overlapping, so a fully-compensated day matches both EXCESS and COMPENSATED. This filter narrows the listed rows and total_count only; the summary counters (with_excess_time / with_extra_time / with_compensated_time) and the day-status chips stay stable when a facet is selected. */
  time_facets?: InputMaybe<Array<TimeFacet>>;
};

export type TimeListWorkdaysInput = {
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
  /** Filter options (date range, status, shift, position, groups, marking location) */
  filter?: InputMaybe<TimeListWorkdaysFilterInput>;
  /** Pagination options (page, page_size; default 10) */
  pagination?: InputMaybe<TimeListAttendanceMarksPaginationInput>;
  /** Search options (user name / position query) */
  search?: InputMaybe<TimeListAttendanceMarksSearchInput>;
  /** IANA timezone used to resolve the default 'today' range when the filter omits date_from/date_to (e.g. America/Lima). Falls back to UTC when omitted. */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type TimeListWorkdaysPayload = {
  __typename?: 'TimeListWorkdaysPayload';
  /** Per-status summary chips over the filtered set, independent of the day_status filter (stay stable when filtering by status) */
  status_counts: TimeWorkdayStatusCounts;
  /** Total rows matching filters (for pagination) */
  total_count: Scalars['Int']['output'];
  /** Page of calculated workday rows */
  workdays: Array<TimeWorkday>;
};

export type TimeListWorkdaysPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeListWorkdaysPayload | ValidationErrorResponse;

export type TimeMark = {
  __typename?: 'TimeMark';
  /** Type of time mark (ENTRY_TIME, LUNCH_OUT_TIME, etc.) */
  mark_type: TimeMarkType;
  /** Time in HH:MM format */
  time: Scalars['String']['output'];
};

export enum TimeMarkIntegrityStatus {
  Altered = 'ALTERED',
  Corrected = 'CORRECTED',
  NotApplicable = 'NOT_APPLICABLE',
  PendingCalculation = 'PENDING_CALCULATION',
  Verified = 'VERIFIED'
}

export enum TimeMarkPhotoStatus {
  Available = 'AVAILABLE',
  DeletedByRequest = 'DELETED_BY_REQUEST',
  NotApplicable = 'NOT_APPLICABLE'
}

export enum TimeMarkSource {
  App = 'APP',
  Biometric = 'BIOMETRIC',
  Excel = 'EXCEL',
  Manual = 'MANUAL',
  System = 'SYSTEM',
  Web = 'WEB'
}

export enum TimeMarkType {
  CoffeeBreakInTime = 'COFFEE_BREAK_IN_TIME',
  CoffeeBreakOutTime = 'COFFEE_BREAK_OUT_TIME',
  EntryTime = 'ENTRY_TIME',
  ExitTime = 'EXIT_TIME',
  LunchInTime = 'LUNCH_IN_TIME',
  LunchOutTime = 'LUNCH_OUT_TIME',
  RestInTime = 'REST_IN_TIME',
  RestOutTime = 'REST_OUT_TIME'
}

export type TimeMarkingLocationsPaginationInput = {
  /** Page number (1-based). Default: 1. */
  page?: Scalars['Int']['input'];
  /** Number of items per page. Default: 5. */
  page_size?: Scalars['Int']['input'];
};

export type TimeMarkingLocationsSearchInput = {
  /** Search query for partial name or address match (case-insensitive) */
  query: Scalars['String']['input'];
};

export type TimeMutations = {
  __typename?: 'TimeMutations';
  /** Mutations for attendance location management */
  attendance_locations: TimeAttendanceLocationsMutations;
  /** Mutations for attendance mark management */
  attendance_marks: TimeAttendanceMarksMutations;
  /** Mutations for the payroll attendance-report export — enqueue the asynchronous .xlsx generation (TIM-448) */
  attendance_report_exports: TimeAttendanceReportExportsMutations;
  /** Mutations for bulk-importing attendance marks (TIM-190) */
  bulk_import_marks: TimeBulkImportMarksMutations;
  /** Mutations for bulk-importing shift assignments (TIM-282) */
  bulk_import_shifts: TimeBulkImportShiftsMutations;
  /** Mutations for collaborator marking config management */
  collaborator_marking_configs: TimeCollaboratorMarkingConfigsMutations;
  /** Mutations for the MX overtime-compliance threshold catalog — save a partial list of caps or reset them to the legal floor (TIM-548 / TIM-549) */
  compliance_thresholds: TimeComplianceThresholdsMutations;
  /** Mutations for biometric device marking-place management */
  device_location_mappings: TimeDeviceLocationMappingsMutations;
  /** Mutations for attendance justificantes — create a time-off justificante from daily attendance (TIM-243) */
  justifications: TimeJustificationsMutations;
  /** Mutations for resolving a withheld day — recalculate or dismiss a late biometric punch over an already-settled day (TIM-470) */
  late_mark_reviews: TimeLateMarkReviewsMutations;
  /** Mutations for bulk-importing non-rotating shift definitions (TIM-283) */
  non_rotating_shifts_bulk_import: TimeNonRotatingShiftsBulkImportMutations;
  /** Mutations for the org-level attendance preferences (TIM-330) */
  organization_attendance_preferences: TimeOrganizationAttendancePreferencesMutations;
  /** Mutations for overtime configuration management (TIM-316) */
  overtime_configs: TimeOvertimeConfigsMutations;
  /** Mutations for collaborator overtime / compensable-time requests — file one for a date and shift, for the administrator to review (TIM-552) */
  overtime_requests: TimeOvertimeRequestsMutations;
  /** Mutations for bulk-importing rotating shift definitions (TIM-284) */
  rotating_shifts_bulk_import: TimeRotatingShiftsBulkImportMutations;
  /** Mutations for shift assignment management */
  shift_assignments: TimeShiftAssignmentsMutations;
  /** Mutations for the multi-shift conflicts report export — enqueue the asynchronous .xlsx generation (TIM-424) */
  shift_conflict_report_exports: TimeShiftConflictReportExportsMutations;
  /** Mutations for shift management */
  shifts: TimeShiftsMutations;
  /** Mutations for editing calculated workdays (TIM-211) */
  workdays: TimeWorkdaysMutations;
};

export type TimeNonRotatingShift = {
  __typename?: 'TimeNonRotatingShift';
  /** Whether the same schedule (times_config) applies to all working days */
  apply_same_schedule_to_all_working_days: Scalars['Boolean']['output'];
  /** Break/rest configuration */
  break_config?: Maybe<TimeBreakConfig>;
  /** Whether break time is counted as worked hours (no deduction in the hours-calculation engine) */
  break_counts_as_worked: Scalars['Boolean']['output'];
  /** Organization ID */
  centralized_organization_id: Scalars['Int']['output'];
  /** Color for calendar display (future feature) */
  color: TimeShiftColor;
  /** Creation timestamp */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who created the shift */
  created_by: Scalars['Int']['output'];
  /** How the shift was created (MANUAL | BULK_IMPORT) — AC-2 audit origin */
  created_via: TimeShiftSource;
  /** Timestamp when this shift was deactivated (replaced by a new version) */
  deactivated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Shift description */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether worked minutes are manually edited */
  edit_worked_minutes: Scalars['Boolean']['output'];
  /** Shift unique identifier */
  id: Scalars['UUID']['output'];
  /** Whether the shift is active */
  is_active: Scalars['Boolean']['output'];
  /** Window in hours [1-12] used to decide if an attendance mark belongs to this shift */
  mark_association_window_hours: Scalars['Int']['output'];
  /** Shift name */
  name: Scalars['String']['output'];
  /** ID of the parent shift (previous version) if this shift was created by editing */
  parent_id?: Maybe<Scalars['UUID']['output']>;
  /** Type of shift (NON_ROTATING) */
  shift_type: TimeShiftType;
  /** Tolerance configuration */
  tolerance_config?: Maybe<TimeToleranceConfig>;
  /** Total worked hours per week */
  total_worked_hours_per_week: Scalars['Float']['output'];
  /** Total number of working days per week */
  total_working_days: Scalars['Int']['output'];
  /** Last update timestamp */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Weekly schedule configuration (union of working/non-working day types) */
  weekly_schedule: Array<TimeDayScheduleResult>;
};

export type TimeNonRotatingShiftsBulkImportApplyInput = {
  /** Organization scope for the import */
  centralized_organization_id: Scalars['Int']['input'];
  /** Id of the staged batch (from validate) to create the shifts from */
  import_batch_id: Scalars['ID']['input'];
};

export type TimeNonRotatingShiftsBulkImportApplyPayload = {
  __typename?: 'TimeNonRotatingShiftsBulkImportApplyPayload';
  /** Number of shift definitions created in this apply */
  created_count: Scalars['Int']['output'];
  /** Commit-level failure message (null on success; FE Reintentar) */
  error_message?: Maybe<Scalars['String']['output']>;
  /** Id of the staged batch that was applied */
  import_batch_id: Scalars['ID']['output'];
  /** Whether the atomic apply committed (false ⇒ rolled back) */
  success: Scalars['Boolean']['output'];
};

export type TimeNonRotatingShiftsBulkImportApplyPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeNonRotatingShiftsBulkImportApplyPayload | ValidationErrorResponse;

export type TimeNonRotatingShiftsBulkImportMutations = {
  __typename?: 'TimeNonRotatingShiftsBulkImportMutations';
  /** Apply a staged non-rotating-shift batch atomically (sync). */
  non_rotating_shifts_bulk_import_apply: TimeNonRotatingShiftsBulkImportApplyPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** Validate an uploaded non-rotating-shift .xlsx and stage it. */
  non_rotating_shifts_bulk_import_validate: TimeExcelValidationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeNonRotatingShiftsBulkImportMutationsNon_Rotating_Shifts_Bulk_Import_ApplyArgs = {
  input: TimeNonRotatingShiftsBulkImportApplyInput;
};


export type TimeNonRotatingShiftsBulkImportMutationsNon_Rotating_Shifts_Bulk_Import_ValidateArgs = {
  input: TimeNonRotatingShiftsBulkImportValidateInput;
};

export type TimeNonRotatingShiftsBulkImportQueries = {
  __typename?: 'TimeNonRotatingShiftsBulkImportQueries';
  /** Bootstrap the review surface for a staged shift-definition batch. */
  non_rotating_shifts_bulk_import_result: TimeBulkImportResultNodeNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse;
  /** Page a single section/code of a staged shift-definition batch. */
  non_rotating_shifts_bulk_import_rows: TimeBulkImportRowsResultNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse;
  /** Download the non-rotating-shift .xlsx template (base64 inline). */
  non_rotating_shifts_bulk_import_template: TimeBulkImportTemplatePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
};


export type TimeNonRotatingShiftsBulkImportQueriesNon_Rotating_Shifts_Bulk_Import_ResultArgs = {
  input: TimeBulkImportResultInput;
};


export type TimeNonRotatingShiftsBulkImportQueriesNon_Rotating_Shifts_Bulk_Import_RowsArgs = {
  input: TimeBulkImportRowsInput;
};


export type TimeNonRotatingShiftsBulkImportQueriesNon_Rotating_Shifts_Bulk_Import_TemplateArgs = {
  input: TimeBulkImportTemplateInput;
};

export type TimeNonRotatingShiftsBulkImportValidateInput = {
  /** Organization scope for the import */
  centralized_organization_id: Scalars['Int']['input'];
  /** subgraph-file id of the uploaded .xlsx shift-definition file */
  file_id: Scalars['ID']['input'];
};

export type TimeNonWorkingDaySchedule = {
  __typename?: 'TimeNonWorkingDaySchedule';
  /** Day of the week */
  day: TimeDayOfWeek;
};

/** Organization-level 'request photo on mark' preference exposed to other subgraphs. Absence of a stored value resolves to request_photo_on_mark=false. */
export type TimeOrganizationAttendancePreference = {
  __typename?: 'TimeOrganizationAttendancePreference';
  /** Organization scope */
  centralized_organization_id: Scalars['Int']['output'];
  /** Creation timestamp; null for a synthesized default */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who first set the preference; null for a synthesized default */
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Preference row identifier; null for a synthesized OFF default */
  id?: Maybe<Scalars['UUID']['output']>;
  /** Whether the marking app should request a photo at marking time. false (synthesized) when no value has been stored for the org. */
  request_photo_on_mark: Scalars['Boolean']['output'];
  /** Last update timestamp */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who last updated the preference */
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TimeOrganizationAttendancePreferencesMutations = {
  __typename?: 'TimeOrganizationAttendancePreferencesMutations';
  /** Set the organization-level 'request photo on mark' preference */
  set_organization_attendance_preference: TimeSetOrganizationAttendancePreferencePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
};


export type TimeOrganizationAttendancePreferencesMutationsSet_Organization_Attendance_PreferenceArgs = {
  input: TimeSetOrganizationAttendancePreferenceInput;
};

export type TimeOrganizationAttendancePreferencesQueries = {
  __typename?: 'TimeOrganizationAttendancePreferencesQueries';
  /** Get the organization-level 'request photo on mark' preference (synthesized OFF default when unset) */
  get_organization_attendance_preference: TimeGetOrganizationAttendancePreferencePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeOrganizationAttendancePreferencesQueriesGet_Organization_Attendance_PreferenceArgs = {
  input: TimeGetOrganizationAttendancePreferenceInput;
};

export enum TimeOvertimeAccrualUnit {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type TimeOvertimeClassificationQueries = {
  __typename?: 'TimeOvertimeClassificationQueries';
  /** List the overtime factor breakdown per collaborator for a period (categories by factor, degradation reasons, minute buckets) */
  list_classified_overtime: TimeListClassifiedOvertimePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeOvertimeClassificationQueriesList_Classified_OvertimeArgs = {
  input: TimeListClassifiedOvertimeInput;
};

export enum TimeOvertimeCompensationWindow {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type TimeOvertimeConfig = {
  __typename?: 'TimeOvertimeConfig';
  /** Accrual period for compensation */
  accrual_unit: TimeOvertimeAccrualUnit;
  /** Organization scope */
  centralized_organization_id: Scalars['Int']['output'];
  /** Whether excess time is classified as payable overtime (TIM-396) */
  classify_as_overtime: Scalars['Boolean']['output'];
  /** Whether compensation is active */
  compensation_active: Scalars['Boolean']['output'];
  /** Compensation window; null when compensation is inactive (TIM-396) */
  compensation_window?: Maybe<TimeOvertimeCompensationWindow>;
  /** Country */
  country: TimeOvertimeCountry;
  /** Creation timestamp */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who created the config */
  created_by: Scalars['Int']['output'];
  /** Optional description */
  description?: Maybe<Scalars['String']['output']>;
  /** Config unique identifier */
  id: Scalars['UUID']['output'];
  /** Whether the config is active */
  is_active: Scalars['Boolean']['output'];
  /** Mexico daily legal-floor indicator (null when not applicable) */
  mexico_daily_legal_floor?: Maybe<Scalars['Boolean']['output']>;
  /** Config name */
  name: Scalars['String']['output'];
  /** Payment-factor tier groups */
  payment_factors: TimeOvertimePaymentFactors;
  /** Quantification type and per-tramo rounding */
  quantification: TimeOvertimeQuantification;
  /** Associated payroll razón-social IDs (UUID, from get_legal_entities; active) */
  razon_social_ids: Array<Scalars['UUID']['output']>;
  /** Associated local shift IDs */
  shift_ids: Array<Scalars['UUID']['output']>;
  /** Whether day/night slots apply */
  slot_modality: TimeOvertimeSlotModality;
  /** Day + derived night slots (null when WITHOUT_SLOT) */
  slots?: Maybe<TimeOvertimeSlots>;
  /** Last update timestamp */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who last updated the config */
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type TimeOvertimeConfigListItem = {
  __typename?: 'TimeOvertimeConfigListItem';
  /** Collaborators affected by this config's activation/deactivation (TIM-312). Ships degraded to constant 0 this ticket; the real per-org/per-razón-social formula is a deferred product decision. */
  affected_users: Scalars['Int']['output'];
  /** Country (one of 5 supported) */
  country: TimeOvertimeCountry;
  /** Config unique identifier */
  id: Scalars['UUID']['output'];
  /** Whether the config is active */
  is_active: Scalars['Boolean']['output'];
  /** Config name */
  name: Scalars['String']['output'];
  /** Count of ACTIVE razón-social associations (== len(razonSocialIds)) */
  razon_social_count: Scalars['Int']['output'];
  /** Associated payroll razón-social IDs (UUID, from get_legal_entities; ACTIVE only) */
  razon_social_ids: Array<Scalars['UUID']['output']>;
  /** Count of associated shifts (== len(shifts)) */
  shift_count: Scalars['Int']['output'];
  /** Associated shifts (id + name) for the tooltip; ordered by name */
  shifts: Array<TimeOvertimeConfigShiftItem>;
  /** Last edit timestamp (or creation time if never edited) */
  updated_at: Scalars['DateTime']['output'];
  /** Last editor (or creator if never edited); fullName federates via gateway */
  updated_by: CentralizedUserNode;
};

export type TimeOvertimeConfigShiftItem = {
  __typename?: 'TimeOvertimeConfigShiftItem';
  /** Shift unique identifier */
  id: Scalars['UUID']['output'];
  /** Shift name */
  name: Scalars['String']['output'];
};

export enum TimeOvertimeConfigSortField {
  Country = 'COUNTRY',
  Name = 'NAME',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT'
}

export type TimeOvertimeConfigsMutations = {
  __typename?: 'TimeOvertimeConfigsMutations';
  /** Activate an existing overtime configuration */
  activate_overtime_config: TimeActivateOvertimeConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
  /** Create a new overtime configuration */
  create_overtime_config: TimeCreateOvertimeConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
  /** Deactivate an existing overtime configuration */
  deactivate_overtime_config: TimeDeactivateOvertimeConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
  /** Soft-delete an existing overtime configuration */
  delete_overtime_config: TimeDeleteOvertimeConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
  /** Edit an existing overtime configuration */
  update_overtime_config: TimeUpdateOvertimeConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
};


export type TimeOvertimeConfigsMutationsActivate_Overtime_ConfigArgs = {
  input: TimeActivateOvertimeConfigInput;
};


export type TimeOvertimeConfigsMutationsCreate_Overtime_ConfigArgs = {
  input: TimeCreateOvertimeConfigInput;
};


export type TimeOvertimeConfigsMutationsDeactivate_Overtime_ConfigArgs = {
  input: TimeDeactivateOvertimeConfigInput;
};


export type TimeOvertimeConfigsMutationsDelete_Overtime_ConfigArgs = {
  input: TimeDeleteOvertimeConfigInput;
};


export type TimeOvertimeConfigsMutationsUpdate_Overtime_ConfigArgs = {
  input: TimeUpdateOvertimeConfigInput;
};

export type TimeOvertimeConfigsQueries = {
  __typename?: 'TimeOvertimeConfigsQueries';
  /** Get the full detail of a single overtime configuration by id */
  get_overtime_config: TimeGetOvertimeConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse;
  /** List overtime configurations with search, country filter, sort, and pagination */
  list_overtime_configs: TimeListOvertimeConfigsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
  /** List the razón-social IDs already in use by an active overtime config */
  razon_social_ids_in_use: TimeRazonSocialIdsInUsePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
};


export type TimeOvertimeConfigsQueriesGet_Overtime_ConfigArgs = {
  input: TimeGetOvertimeConfigInput;
};


export type TimeOvertimeConfigsQueriesList_Overtime_ConfigsArgs = {
  input: TimeListOvertimeConfigsInput;
};


export type TimeOvertimeConfigsQueriesRazon_Social_Ids_In_UseArgs = {
  input: TimeRazonSocialIdsInUseInput;
};

export enum TimeOvertimeCountry {
  Ar = 'AR',
  Co = 'CO',
  Do = 'DO',
  Mx = 'MX',
  Pe = 'PE'
}

export enum TimeOvertimePaymentFactorGroup {
  Main = 'MAIN',
  WorkedHoliday = 'WORKED_HOLIDAY',
  WorkedRest = 'WORKED_REST'
}

export type TimeOvertimePaymentFactorTier = {
  __typename?: 'TimeOvertimePaymentFactorTier';
  /** Day payment factor */
  factor: Scalars['Float']['output'];
  /** Tier start hours (inclusive) */
  from_hours: Scalars['Float']['output'];
  /** Night-slot payment factor; null when the config has no day/night split or none was configured (TIM-396) */
  night_factor?: Maybe<Scalars['Float']['output']>;
  /** Tier end hours (exclusive); null on an open/unlimited last tier */
  to_hours?: Maybe<Scalars['Float']['output']>;
};

export type TimeOvertimePaymentFactors = {
  __typename?: 'TimeOvertimePaymentFactors';
  /** Main tiers */
  main: Array<TimeOvertimePaymentFactorTier>;
  /** Worked-holiday tiers */
  worked_holiday: Array<TimeOvertimePaymentFactorTier>;
  /** Worked-rest-day tiers */
  worked_rest: Array<TimeOvertimePaymentFactorTier>;
};

export type TimeOvertimePaymentFactorsInput = {
  /** Main tiers (1–3, at least one required) */
  main: Array<TimeOvertimeTierInput>;
  /** Worked-holiday tiers (optional, up to 3) */
  worked_holiday?: Array<TimeOvertimeTierInput>;
  /** Worked-rest-day tiers (optional, up to 3) */
  worked_rest?: Array<TimeOvertimeTierInput>;
};

export enum TimeOvertimePaymentSlot {
  Day = 'DAY',
  Night = 'NIGHT'
}

export type TimeOvertimeQuantification = {
  __typename?: 'TimeOvertimeQuantification';
  /** Per-tramo rounding rules */
  tramos: Array<TimeOvertimeTramo>;
  /** Quantification type */
  type: TimeOvertimeQuantificationType;
};

export type TimeOvertimeQuantificationInput = {
  /** Per-tramo rounding rules (at least one) */
  tramos: Array<TimeOvertimeTramoInput>;
  /** Quantification type */
  type: TimeOvertimeQuantificationType;
};

export enum TimeOvertimeQuantificationType {
  ExactTime = 'EXACT_TIME',
  FifteenMin = 'FIFTEEN_MIN',
  HourBlock = 'HOUR_BLOCK',
  ThirtyMin = 'THIRTY_MIN'
}

export type TimeOvertimeRequest = {
  __typename?: 'TimeOvertimeRequest';
  /** Organization the request belongs to. */
  centralized_organization_id: Scalars['Int']['output'];
  /** True when the razón-social compensation check could NOT be evaluated at filing time — there was no shift, or no single active overtime configuration for it — so it is still owed at approval. Always False when replacement_minutes == 0: with nothing to compensate there is no check to defer. Render it as information, never as an error: the request was created successfully. */
  compensation_check_deferred: Scalars['Boolean']['output'];
  /** When the request was filed, in UTC (timezone-aware). */
  created_at: Scalars['DateTime']['output'];
  /** Overtime worked, in minutes. */
  extra_minutes: Scalars['Int']['output'];
  /** The overtime minutes that were FINALLY settled, once the administrator's decision was applied. Null while nothing has been settled — which is every row today: no operation writes it yet (TIM-555 / TIM-564 / TIM-563 do). Exposed whenever it is persisted, unconditionally: showing it only when it differs is a RENDERING rule, and has_final_amount_difference is the flag that drives it. */
  final_extra_minutes?: Maybe<Scalars['Int']['output']>;
  /** The compensable minutes that were FINALLY settled. Same semantics as final_extra_minutes: null while nothing has been settled, which is every row today. */
  final_replacement_minutes?: Maybe<Scalars['Int']['output']>;
  /** True when the request is APPROVED and a settled amount ended up DIFFERENT from the approved one, on either the overtime or the compensable pair. A null on either side of a pair means 'not written yet', and an unwritten value is not a difference. Non-nullable on purpose: with no settled amount there is, by definition, no difference — that is False, not 'unknown'. Today it is False for every row; it becomes meaningful once the settlement tickets ship. Do not render it as an empty state. */
  has_final_amount_difference: Scalars['Boolean']['output'];
  /** Identifier of the request. */
  id: Scalars['ID']['output'];
  /** The reason as filed, already trimmed. */
  reason: Scalars['String']['output'];
  /** Time to make up for, in minutes. */
  replacement_minutes: Scalars['Int']['output'];
  /** The day the request is about, as an organization-local calendar date. Never compare it against created_at, which is UTC. */
  request_date: Scalars['Date']['output'];
  /** The shift the system ASSOCIATED — not necessarily the one sent: it is auto-filled on a single-shift day and null on a day with no assignment. The shift becomes mandatory only at approval. */
  shift_id?: Maybe<Scalars['ID']['output']>;
  /** The shift's name at the moment of filing (a snapshot, so it survives a later rename or deletion). Null when there is no shift, and also when the associated shift has no usable configuration — which does not block the request. */
  shift_name?: Maybe<Scalars['String']['output']>;
  /** Where the request stands. Always PENDING on creation, and always CANCELLED in the cancel_overtime_request payload. A CANCELLED request no longer appears in the collaborator's listing, so that is the one place a client normally sees the value. */
  status: TimeOvertimeRequestStatus;
  /** centralized_user_id of the collaborator who filed it — always the caller, taken from the session. */
  user_id: Scalars['Int']['output'];
};

export enum TimeOvertimeRequestStatus {
  /** The administrator acknowledged the request (TIM-555). */
  Approved = 'APPROVED',
  /** The collaborator withdrew the request (TIM-551). It no longer occupies its date+shift slot — the same day and shift can be requested again — and it no longer appears in the collaborator's listing, so a client will normally only ever see this value in the cancel_overtime_request payload itself. */
  Cancelled = 'CANCELLED',
  /** The administrator refused the request (TIM-556). */
  Denied = 'DENIED',
  /** Filed and waiting for the administrator. The only status create_overtime_request can produce. */
  Pending = 'PENDING'
}

export type TimeOvertimeRequestsMutations = {
  __typename?: 'TimeOvertimeRequestsMutations';
  /** Cancel one of YOUR OWN overtime / compensable-time requests. Only a PENDING or a DENIED request can be cancelled; an APPROVED one is refused with OVERTIME_REQUEST_APPROVED_CANNOT_CANCEL. The request is kept, not deleted: it becomes CANCELLED, stops appearing in your listing and releases its date+shift slot, so you can file the same day and shift again. The operation is IDEMPOTENT — cancelling an already-cancelled request returns the same success payload, never an error. A request that is not yours and one that does not exist answer the SAME FORBIDDEN response on purpose. */
  cancel_overtime_request: TimeCancelOvertimeRequestPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
  /** File a request for overtime worked and/or time to make up for, on one date and one shift, with a single reason. The collaborator files for themselves: the author is taken from the session and the input has no user field. Creation is deliberately permissive — it does not block on a missing shift, a future date or a workday that has not closed. It blocks only on duplication (an own non-cancelled request for the same date and shift, or a day an administrator already classified by hand) and on field validation. */
  create_overtime_request: TimeCreateOvertimeRequestPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
};


export type TimeOvertimeRequestsMutationsCancel_Overtime_RequestArgs = {
  input: TimeCancelOvertimeRequestInput;
};


export type TimeOvertimeRequestsMutationsCreate_Overtime_RequestArgs = {
  input: TimeCreateOvertimeRequestInput;
};

export type TimeOvertimeRequestsQueries = {
  __typename?: 'TimeOvertimeRequestsQueries';
  /** List the overtime / compensable-time requests the CALLER filed, paginated and ordered by filing time, newest first. Never another collaborator's: the author is taken from the session and the input has no user field. An empty list is a success, not an error. The calculated excess time is deliberately never part of this response. */
  list_my_overtime_requests: TimeListMyOvertimeRequestsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeOvertimeRequestsQueriesList_My_Overtime_RequestsArgs = {
  input: TimeListMyOvertimeRequestsInput;
};

export enum TimeOvertimeRoundingDirection {
  Next = 'NEXT',
  Previous = 'PREVIOUS'
}

export type TimeOvertimeSlot = {
  __typename?: 'TimeOvertimeSlot';
  /** Slot end time */
  end: Scalars['Time']['output'];
  /** Slot start time */
  start: Scalars['Time']['output'];
};

export type TimeOvertimeSlotInput = {
  /** Slot end time (HH:MM) */
  end: Scalars['Time']['input'];
  /** Slot start time (HH:MM) */
  start: Scalars['Time']['input'];
};

export enum TimeOvertimeSlotModality {
  WithoutSlot = 'WITHOUT_SLOT',
  WithSlot = 'WITH_SLOT'
}

export type TimeOvertimeSlots = {
  __typename?: 'TimeOvertimeSlots';
  /** Day slot */
  day: TimeOvertimeSlot;
  /** Night slot (24h complement of the day slot) */
  night: TimeOvertimeSlot;
};

export type TimeOvertimeSlotsInput = {
  /** Day slot (start < end); the night slot is the 24h complement */
  day: TimeOvertimeSlotInput;
};

export type TimeOvertimeTierInput = {
  /** Day payment factor (positive, 0.1 steps) */
  factor: Scalars['Float']['input'];
  /** Tier start hours (inclusive, 0.5 steps) */
  from_hours: Scalars['Float']['input'];
  /** Night-slot payment factor (positive, 0.1 steps). Send only when slot_modality is WITH_SLOT; stored null otherwise (TIM-396) */
  night_factor?: InputMaybe<Scalars['Float']['input']>;
  /** Tier end hours (exclusive, 0.5 steps). Omit/null on the LAST tier for an open/unlimited upper bound ('Hasta' vacío) */
  to_hours?: InputMaybe<Scalars['Float']['input']>;
};

export type TimeOvertimeTramo = {
  __typename?: 'TimeOvertimeTramo';
  /** Whether this tramo is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Rounding direction (null for EXACT_TIME) */
  rounding_direction?: Maybe<TimeOvertimeRoundingDirection>;
};

export type TimeOvertimeTramoInput = {
  /** Whether this tramo is enabled */
  enabled: Scalars['Boolean']['input'];
  /** Rounding direction — required on an enabled block-based tramo; must be null for EXACT_TIME quantification */
  rounding_direction?: InputMaybe<TimeOvertimeRoundingDirection>;
};

export enum TimeOvertimeUnclassifiedReason {
  /** The selected group has ZERO tiers (worked-rest / worked-holiday are optional). Distinct from OUTSIDE_CONFIGURED_TIERS. */
  EmptyFactorGroup = 'EMPTY_FACTOR_GROUP',
  /** Two or more live + active configs claim the day's shift, so none can be chosen. Self-extinguishing once the razón-social half of the predicate becomes resolvable. */
  MultipleActiveConfigs = 'MULTIPLE_ACTIVE_CONFIGS',
  /** The day's shift matches no live + active overtime config. */
  NoActiveConfig = 'NO_ACTIVE_CONFIG',
  /** The daily result carries no shift, so no config applies. */
  NoShift = 'NO_SHIFT',
  /** The minutes fall off the configured ladder — above a CLOSED top tier, or below a first tier that does not start at 0. Never clamped to the nearest tier, because clamping would invent pay. */
  OutsideConfiguredTiers = 'OUTSIDE_CONFIGURED_TIERS'
}

export type TimeOvertimeUnclassifiedReasonCount = {
  __typename?: 'TimeOvertimeUnclassifiedReasonCount';
  /** Distinct days in the period affected by this reason */
  days: Scalars['Int']['output'];
  /** Total unclassified minutes attributed to this reason */
  minutes: Scalars['Int']['output'];
  /** Why these minutes carry no factor */
  reason: TimeOvertimeUnclassifiedReason;
};

export type TimePayrollIncidenceSyncSummaryInput = {
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
};

export type TimePayrollIncidenceSyncSummaryPayload = {
  __typename?: 'TimePayrollIncidenceSyncSummaryPayload';
  /** Number of this organization's payroll incidences currently in REQUIRES_MANUAL_ACTION. Always a number, never null: 0 means 'nothing to resolve', not 'unknown'. */
  requires_manual_action_count: Scalars['Int']['output'];
};

export type TimePayrollIncidenceSyncSummaryPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimePayrollIncidenceSyncSummaryPayload | ValidationErrorResponse;

export enum TimePeriodChangeEventType {
  ExtraHoursAdded = 'EXTRA_HOURS_ADDED',
  ExtraHoursRemoved = 'EXTRA_HOURS_REMOVED',
  Generic = 'GENERIC',
  JustificationCreated = 'JUSTIFICATION_CREATED',
  MarkCreated = 'MARK_CREATED',
  MarkDeleted = 'MARK_DELETED',
  MarkEdited = 'MARK_EDITED',
  OvertimeRequestApproved = 'OVERTIME_REQUEST_APPROVED',
  OvertimeRequestCancelled = 'OVERTIME_REQUEST_CANCELLED',
  OvertimeRequestCappedAtClose = 'OVERTIME_REQUEST_CAPPED_AT_CLOSE',
  OvertimeRequestCreated = 'OVERTIME_REQUEST_CREATED',
  OvertimeRequestDenied = 'OVERTIME_REQUEST_DENIED',
  OvertimeRequestInvalidatedByShiftDeletion = 'OVERTIME_REQUEST_INVALIDATED_BY_SHIFT_DELETION',
  OvertimeRequestPayrollCorrectionGenerated = 'OVERTIME_REQUEST_PAYROLL_CORRECTION_GENERATED',
  ReplacementAdded = 'REPLACEMENT_ADDED',
  ReplacementRemoved = 'REPLACEMENT_REMOVED',
  ShiftAssigned = 'SHIFT_ASSIGNED',
  ShiftChanged = 'SHIFT_CHANGED',
  ShiftCleared = 'SHIFT_CLEARED',
  ShiftHoursApplied = 'SHIFT_HOURS_APPLIED',
  TimeOffApproved = 'TIME_OFF_APPROVED',
  TimeOffDenied = 'TIME_OFF_DENIED',
  TimeOffRequested = 'TIME_OFF_REQUESTED'
}

export enum TimePeriodChangeKind {
  Justificante = 'JUSTIFICANTE',
  Mark = 'MARK',
  Overtime = 'OVERTIME',
  OvertimeRequest = 'OVERTIME_REQUEST',
  Shift = 'SHIFT',
  TimeOff = 'TIME_OFF'
}

export type TimePeriodChangeRow = {
  __typename?: 'TimePeriodChangeRow';
  /** OVERTIME rows: which minute field the admin adjusted — 'extra_hours' (horas extra) or 'replacement' (tiempo a compensar). Lowercase to match the sibling 'mark_type' on this same type ('entry'/'exit'). TIM-639: this type now also carries two real GraphQL enums in UPPER_SNAKE ('kind' and 'event_type'), so a consumer does parse two casings — these two fields stay String for backward compatibility with the shipped contract, and the enums are where new tokens go. */
  adjustment_kind?: Maybe<Scalars['String']['output']>;
  /** TIM-639: email of the admin who made the change ('Realizado por'). Null when the centralized-user service does not know the id, has no address on record for it, or is unavailable — the row is delivered either way (AC-5). */
  author_email?: Maybe<Scalars['String']['output']>;
  /** Centralized user id of the admin who made the change */
  author_user_id: Scalars['Int']['output'];
  /** TIM-541: duration of the absence — 'full' or 'half'. Set on JUSTIFICANTE and TIME_OFF rows; null on every other kind. Lowercase to match the sibling 'mark_type' / 'adjustment_kind' on this same type. The morning-vs-afternoon half is never modeled: both collapse to 'half'. */
  coverage?: Maybe<Scalars['String']['output']>;
  /** When the change was recorded (ordering key, most-recent-first) */
  created_at: Scalars['DateTime']['output'];
  /** TIM-639: machine-readable event token for the day-history drawer — an i18n key, never an assembled sentence (RN-002). Non-null: an unclassifiable row is delivered as GENERIC, never dropped (RN-010). TIM-537 AC-4: SHIFT_HOURS_APPLIED is ONE event for a whole 'aplicar las horas estimadas del turno' save — its per-mark fields are null on purpose and the shift it used travels on new_shift_id / new_shift_name. */
  event_type: TimePeriodChangeEventType;
  /** TIM-636: extra time the collaborator asked for, in minutes. Set on OVERTIME_REQUEST rows only. Sent alongside 'replacement_minutes' because ONE request may carry both amounts — the event is the request, not one of its two halves, so the summary picks its wording from which of the two is greater than zero. Not to be confused with 'new_minutes', which is an admin's adjustment of the day's totals on an OVERTIME row. */
  extra_minutes?: Maybe<Scalars['Int']['output']>;
  /** TIM-639: stable identifier of this audit row — the UUID of the row in whichever of the three audit tables produced it. Unique across the three sources. It exists so a client can key the list: two rows of the same 'mark_type' on one multi-shift day are otherwise indistinguishable. Opaque — nothing parses it, and no write operation accepts it. */
  id: Scalars['String']['output'];
  /** Source surface of the change (MARK, SHIFT or OVERTIME) */
  kind: TimePeriodChangeKind;
  /** MARK rows: which mark type changed (ENTRY/BREAK_START/...) */
  mark_type?: Maybe<Scalars['String']['output']>;
  /** OVERTIME rows: the adjusted field's value after the save */
  new_minutes?: Maybe<Scalars['Int']['output']>;
  /** SHIFT rows: new shift UUID (null = shift cleared). TIM-537 AC-4: also set on a SHIFT_HOURS_APPLIED row, where it is the shift whose estimated hours were applied — recorded when the action happened, so a later shift change does not rewrite the past. */
  new_shift_id?: Maybe<Scalars['String']['output']>;
  /** TIM-639: name of the new shift. Null when the shift was cleared and when the id no longer resolves. Set on SHIFT and on SHIFT_HOURS_APPLIED rows (TIM-537 AC-4); null on every other row. */
  new_shift_name?: Maybe<Scalars['String']['output']>;
  /** MARK rows: new HH:mm value (null = mark deleted) */
  new_value?: Maybe<Scalars['String']['output']>;
  /** The calendar day the change affected (mark_date / change_date) */
  occurred_date: Scalars['Date']['output'];
  /** TIM-541: name of the Time Off policy — the justificante's TYPE, as the summary template names it. Set on JUSTIFICANTE and TIME_OFF rows; null on every other kind. On a JUSTIFICANTE row it is a SNAPSHOT taken when the action happened, so renaming the policy later never rewrites the history. Null when upstream returned no name — the row is delivered either way. */
  policy_name?: Maybe<Scalars['String']['output']>;
  /** OVERTIME rows: the adjusted field's value before the save (0 when the day carried no allocation) */
  previous_minutes?: Maybe<Scalars['Int']['output']>;
  /** SHIFT rows: prior shift UUID (null = first assignment) */
  previous_shift_id?: Maybe<Scalars['String']['output']>;
  /** TIM-639: name of the prior shift, so the FE can put it inside a sentence (a UUID cannot be interpolated). Null on non-SHIFT rows, on a first assignment, and when the id no longer resolves. A DEACTIVATED shift still resolves its name — the normal case here. */
  previous_shift_name?: Maybe<Scalars['String']['output']>;
  /** MARK rows: prior HH:mm value (null = mark did not exist) */
  previous_value?: Maybe<Scalars['String']['output']>;
  /** Optional admin note recorded with the change */
  reason?: Maybe<Scalars['String']['output']>;
  /** TIM-636: make-up time the collaborator asked for, in minutes. Set on OVERTIME_REQUEST rows only. See 'extra_minutes'. */
  replacement_minutes?: Maybe<Scalars['Int']['output']>;
  /** TIM-541: first day of the Time Off request's own span (AC-2). Set on TIME_OFF rows only. NOT the same as 'occurred_date': a request covering five days produces one row for each day inside the queried window, and all of them repeat this same span. */
  request_date_from?: Maybe<Scalars['Date']['output']>;
  /** TIM-541: last day of the Time Off request's own span (AC-2). Set on TIME_OFF rows only. */
  request_date_to?: Maybe<Scalars['Date']['output']>;
};

export type TimePeriodDayRow = {
  __typename?: 'TimePeriodDayRow';
  /** BREAK_END mark (null when not registered) */
  break_end?: Maybe<TimeWorkdayMark>;
  /** BREAK_START mark (null when not registered) */
  break_start?: Maybe<TimeWorkdayMark>;
  /** Calendar date this row belongs to */
  date: Scalars['Date']['output'];
  /** ENTRY mark (null when not registered) */
  entry?: Maybe<TimeWorkdayMark>;
  /** Net excess minutes (Mechanism-1-applied) for the day */
  excess_net_minutes: Scalars['Int']['output'];
  /** EXIT mark (null when not registered) */
  exit?: Maybe<TimeWorkdayMark>;
  /** Assigned extra minutes for the day (0 when Mechanism 2 inactive) */
  extra_minutes: Scalars['Int']['output'];
  /** Calendar holiday name (TIM-220 snapshot for a persisted FERIADO_TRABAJADO row, or the batch HRIS lookup for a synthesized bare-FERIADO day) — the badge label for FERIADO / FERIADO_TRABAJADO states (TIM-221). Null on non-holiday rows. */
  holiday_name?: Maybe<Scalars['String']['output']>;
  /** Whether the day is a rest day per the collaborator's SHIFT SCHEDULE (the rotating rest cycle or a non-working weekday — 'Descanso de turno'). Derived from the resolved schedule, NOT from the NO_SHIFT state: a persisted NO_SHIFT day (marks present, no shift) is an anomaly and stays false. A national/regional holiday is now classified by TIM-221 (state FERIADO / FERIADO_TRABAJADO) and named via the `holiday_name` field below; this flag continues to reflect only the shift-schedule rest day. */
  is_holiday_or_rest: Scalars['Boolean']['output'];
  /** Net lost minutes (Mechanism-1-applied) for the day */
  lost_net_minutes: Scalars['Int']['output'];
  /** Assigned replacement minutes for the day (0 when Mechanism 2 inactive) */
  replacement_minutes: Scalars['Int']['output'];
  /** Minutes the collaborator was scheduled to work on the day, as calculated by the engine. 0 on days with no shift assigned, Time Off without a shift, worked holidays / rest days, and on days with no calculated row. */
  scheduled_minutes: Scalars['Int']['output'];
  /** Name of the shift assigned on the day; null when no assignment */
  shift_name?: Maybe<Scalars['String']['output']>;
  /** Crehana day status for the day (see the TimeDayStatus enum) */
  state: TimeDayStatus;
  /** Sub-detail of the day status. For INCOMPLETE days, a comma-separated list of missing mark types (e.g. 'entry,exit'). Null when not applicable. */
  state_detail?: Maybe<Scalars['String']['output']>;
  /** Time Off snapshot for the day (null when none applied) */
  time_off?: Maybe<TimeWorkdayTimeOff>;
  /** Minutes effectively worked on the day */
  worked_minutes: Scalars['Int']['output'];
};

export type TimePeriodJustificante = {
  __typename?: 'TimePeriodJustificante';
  /** When the request's last APPROVED transition was recorded. Nullable — null on HRIS degrade or ambiguous approval (A1/A9). */
  approval_date?: Maybe<Scalars['DateTime']['output']>;
  /** Centralized user id of the approver (federation resolves the User from the id). Nullable — null on HRIS degrade or ambiguous approval. */
  approved_by_user_id?: Maybe<Scalars['Int']['output']>;
  /** Coverage 'valor' of the justificante (FULL or HALF). FE derives the display label client-side; MORNING/AFTERNOON is not modeled (A3). */
  coverage: Scalars['String']['output'];
  /** The justified calendar day */
  date: Scalars['Date']['output'];
  /** Whether the Time Off is paid (goce de haber) */
  is_paid: Scalars['Boolean']['output'];
  /** Source of the justificante, resolved from the local origin marker (TIM-243): MANUAL when it was created from Asistencia, TIME_OFF for a regular Time Off request (the absent-marker default). */
  origin: TimeJustificanteOrigin;
  /** Snapshot of the Time Off policy display name on the day */
  policy_name: Scalars['String']['output'];
  /** Snapshot of the Time Off policy-type display name on the day */
  policy_type_name: Scalars['String']['output'];
  /** The approved Time Off request (TimeoffRequest.id) backing the day */
  request_id: Scalars['String']['output'];
  /** Optional HH:MM-complement minute count for FE reconciliation (A3); null when the policy carries no minute-level granularity. */
  time_off_minutes?: Maybe<Scalars['Int']['output']>;
};

export type TimeQueries = {
  __typename?: 'TimeQueries';
  /** Queries for per-collaborator period aggregates (tarjetas de asistencia) */
  attendance_cards: TimeAttendanceCardsQueries;
  /** Queries for attendance location management */
  attendance_locations: TimeAttendanceLocationsQueries;
  /** Queries for attendance mark management */
  attendance_marks: TimeAttendanceMarksQueries;
  /** Queries for the payroll attendance-report export — job state readback (TIM-448) */
  attendance_report_exports: TimeAttendanceReportExportsQueries;
  /** Queries for the bulk-import marks review surface (TIM-190) */
  bulk_import_marks: TimeBulkImportMarksQueries;
  /** Queries for the bulk-import shifts review surface (TIM-282) */
  bulk_import_shifts: TimeBulkImportShiftsQueries;
  /** Queries for the users with access to a collaborator's attendance information (TIM-479) */
  collaborator_attendance_access: TimeCollaboratorAttendanceAccessQueries;
  /** Queries for collaborator marking configuration management */
  collaborator_marking_configs: TimeCollaboratorMarkingConfigsQueries;
  /** Queries for the MX overtime-compliance EVALUATION — each collaborator's traffic light against the org's caps for a day or a week, plus the per-state counts (TIM-544). The catalog those caps come from lives in compliance_thresholds */
  compliance_evaluation: TimeComplianceEvaluationQueries;
  /** Queries for the MX overtime-compliance threshold catalog — the org's six legal caps and their traffic-light breaks (TIM-548) */
  compliance_thresholds: TimeComplianceThresholdsQueries;
  /** Queries for calculated daily workdays (jornadas calculadas) */
  daily_attendance: TimeDailyAttendanceQueries;
  /** Queries for biometric device marking places — the read surface for devices Ziphra has reported (TIM-528) */
  device_location_mappings: TimeDeviceLocationMappingsQueries;
  /** Queries for the late-mark review queue — days whose recomputation was withheld because a biometric punch arrived late (TIM-470) */
  late_mark_reviews: TimeLateMarkReviewsQueries;
  /** Queries for the non-rotating-shift bulk-import review surface (TIM-283) */
  non_rotating_shifts_bulk_import: TimeNonRotatingShiftsBulkImportQueries;
  /** Queries for the org-level attendance preferences (TIM-330) */
  organization_attendance_preferences: TimeOrganizationAttendancePreferencesQueries;
  /** Queries for the overtime factor-classification breakdown (TIM-271) */
  overtime_classification: TimeOvertimeClassificationQueries;
  /** Queries for overtime configuration management (TIM-310) */
  overtime_configs: TimeOvertimeConfigsQueries;
  /** Queries for the collaborator's OWN overtime / compensable-time requests — the listing that lets them follow their status without being told (TIM-553) */
  overtime_requests: TimeOvertimeRequestsQueries;
  /** Queries for the rotating-shift bulk-import review surface (TIM-284) */
  rotating_shifts_bulk_import: TimeRotatingShiftsBulkImportQueries;
  /** Queries for shift assignment management */
  shift_assignments: TimeShiftAssignmentsQueries;
  /** Queries for the multi-shift conflicts report export — job state readback (TIM-424) */
  shift_conflict_report_exports: TimeShiftConflictReportExportsQueries;
  /** Queries for shift management */
  shifts: TimeShiftsQueries;
};

export type TimeRazonSocialIdsInUseInput = {
  /** Organization scope (required; enforced by org-scoping) */
  centralized_organization_id: Scalars['Int']['input'];
  /** Optional config to exclude (the edit flow, so a config does not self-warn with its own razón-social IDs) */
  exclude_config_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type TimeRazonSocialIdsInUsePayload = {
  __typename?: 'TimeRazonSocialIdsInUsePayload';
  /** Distinct razón-social IDs already in use by an active config */
  razon_social_ids: Array<Scalars['UUID']['output']>;
};

export type TimeRazonSocialIdsInUsePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeRazonSocialIdsInUsePayload;

export type TimeRecordAttendanceMarkInput = {
  /** Organization scope identifier */
  centralized_organization_id: Scalars['Int']['input'];
  /** Device GPS latitude in decimal degrees. Optional — when omitted the geofence step is skipped (AC-8). Must be sent together with longitude. */
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  /** Device GPS longitude in decimal degrees. Optional — must be provided together with latitude. */
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  /** Type of mark to record (ENTRY, BREAK_START, BREAK_END, EXIT) */
  mark_type: TimeAttendanceMarkType;
  /** Opaque file reference (nanoid uid) for the photo associated with this mark, originated in crehana-subgraph-file. Optional — the mobile app sends it on live marks; web/admin callers omit it. Stored and echoed verbatim; this subgraph never resolves it to a URL nor validates it (it is not a UUID or coordinate). */
  photo_file_id?: InputMaybe<Scalars['ID']['input']>;
  /** Resolved attendance location chosen by the user after a conflict response. When provided, the server skips the geofence computation and persists the mark associated to this location. */
  selected_location_id?: InputMaybe<Scalars['ID']['input']>;
  /** Origin of the mark, rendered as the 'Dispositivo' cell. The mobile app must send APP on every live mark; web/admin callers omit it and default to MANUAL. */
  source?: TimeMarkSource;
  /** IANA timezone from user's device (e.g., America/Lima) */
  timezone: Scalars['String']['input'];
};

export type TimeRecordAttendanceMarkPayload = {
  __typename?: 'TimeRecordAttendanceMarkPayload';
  /** Full updated daily marking context */
  context: TimeDailyMarkingContext;
  /** The recorded attendance mark with computed status */
  mark: TimeAttendanceMark;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeRecordAttendanceMarkPayloadTimeAttendanceMarkConflictResponseNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeAttendanceMarkConflictResponse | TimeRecordAttendanceMarkPayload | ValidationErrorResponse;

export type TimeRequestAttendanceReportExportInput = {
  /** Organization scope identifier. The caller must be able to manage it (org gate) or the request is FORBIDDEN. */
  centralized_organization_id: Scalars['Int']['input'];
  /** The report criteria (period + concepts). */
  filter: TimeAttendanceReportExportFilterInput;
};

export type TimeRequestAttendanceReportExportPayload = {
  __typename?: 'TimeRequestAttendanceReportExportPayload';
  /** True when this request matched a job that was ALREADY live: nothing was written, no second message was published and no second email will be sent. Render it as a plain success — an accidental double click does not deserve an error toast (ticket AC-3). */
  already_queued: Scalars['Boolean']['output'];
  /** Identifier of the export job. Feed it back to attendance_report_export to poll the state. */
  export_id: Scalars['ID']['output'];
  /** State of the job at the moment of the answer (QUEUED for a new one). */
  status: TimeAttendanceReportExportStatus;
  /** True when a job is live for this request (new or existing). */
  success: Scalars['Boolean']['output'];
};

export type TimeRequestAttendanceReportExportPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeRequestAttendanceReportExportPayload | ValidationErrorResponse;

export type TimeRequestShiftConflictReportExportInput = {
  /** Organization scope identifier. The caller must be able to manage it (org gate) or the request is FORBIDDEN. Isolation is by ORGANIZATION, never by razón social. */
  centralized_organization_id: Scalars['Int']['input'];
};

export type TimeRequestShiftConflictReportExportPayload = {
  __typename?: 'TimeRequestShiftConflictReportExportPayload';
  /** True when this request matched a job that was ALREADY live: nothing was written, no second message was published and no second email will be sent. Render it as a plain success and resume polling the returned export_id — an accidental double click does not deserve an error toast. Note it comes back FALSE with a new export_id when the previous attempt was found abandoned and cleared. */
  already_queued: Scalars['Boolean']['output'];
  /** Identifier of the export job. Feed it back to shift_conflict_report_export to poll the state. */
  export_id: Scalars['ID']['output'];
  /** State of the job at the moment of the answer (QUEUED for a new one). */
  status: TimeShiftConflictReportExportStatus;
  /** True when a job is live for this request (new or existing). */
  success: Scalars['Boolean']['output'];
};

export type TimeRequestShiftConflictReportExportPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeRequestShiftConflictReportExportPayload | ValidationErrorResponse;

export type TimeResetComplianceThresholdsInput = {
  /** Organization scope */
  centralized_organization_id: Scalars['Int']['input'];
  /** Country whose catalog to reset (MX only for now) */
  country: TimeComplianceCountry;
};

export type TimeResetComplianceThresholdsPayload = {
  __typename?: 'TimeResetComplianceThresholdsPayload';
  /** Exactly the codes that were written back to the default and audited with kind=RESET. Empty when nothing differed */
  changed_codes: Array<TimeComplianceThresholdCode>;
  /** Whether the reset completed. True on a complete no-op too — an organization with no rows already IS at the defaults */
  success: Scalars['Boolean']['output'];
  /** The FULL effective catalog after the reset — all six */
  thresholds: Array<TimeComplianceThreshold>;
};

export type TimeResetComplianceThresholdsResult = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeResetComplianceThresholdsPayload | ValidationErrorResponse;

export type TimeResolveLateMarkReviewInput = {
  /** Organization scope identifier. A review belonging to another organization is reported as NOT FOUND, never as forbidden. */
  centralized_organization_id: Scalars['Int']['input'];
  /** The id returned by list_late_mark_reviews. Feed it back verbatim — never rebuild it. */
  review_id: Scalars['ID']['input'];
};

export type TimeResolveLateMarkReviewPayload = {
  __typename?: 'TimeResolveLateMarkReviewPayload';
  /** Whether the recomputation message actually reached the queue. Always false for a dismissal (nothing is published, by design). It can also be false on a RECALCULATED row: the resolution is already committed and the publish is best-effort, so a broker failure is reported here rather than by failing a mutation that DID succeed. The remedy is to resolve the row again once it re-opens. */
  recalculation_published: Scalars['Boolean']['output'];
  /** The row as it now stands, with its actor and timestamp. */
  review: TimeLateMarkReview;
};

export type TimeResolveLateMarkReviewPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeResolveLateMarkReviewPayload | ValidationErrorResponse;

export type TimeRestCycle = {
  __typename?: 'TimeRestCycle';
  /** Position in the pattern (1, 2, 3, ...) */
  cycle_order: Scalars['Int']['output'];
  /** Type of cycle: REST */
  cycle_type: TimeCycleType;
  /** Number of days in this cycle */
  duration_days: Scalars['Int']['output'];
  /** Cycle unique identifier */
  id: Scalars['UUID']['output'];
};

export type TimeRotatingShift = {
  __typename?: 'TimeRotatingShift';
  /** Break/rest configuration */
  break_config?: Maybe<TimeBreakConfig>;
  /** Whether break time is counted as worked hours (no deduction in the hours-calculation engine) */
  break_counts_as_worked: Scalars['Boolean']['output'];
  /** Organization ID */
  centralized_organization_id: Scalars['Int']['output'];
  /** Color for calendar display (future feature) */
  color: TimeShiftColor;
  /** Creation timestamp */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who created the shift */
  created_by: Scalars['Int']['output'];
  /** Ordered list of cycles forming the rotation pattern (union of TimeWorkCycle | TimeRestCycle) */
  cycles: Array<TimeShiftCycleResult>;
  /** Timestamp when this shift was deactivated (replaced by a new version) */
  deactivated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Shift description */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether worked minutes per day are manually edited */
  edit_worked_minutes: Scalars['Boolean']['output'];
  /** Shift unique identifier */
  id: Scalars['UUID']['output'];
  /** Whether the shift is active */
  is_active: Scalars['Boolean']['output'];
  /** Window in hours [1-12] used to decide if an attendance mark belongs to this shift */
  mark_association_window_hours: Scalars['Int']['output'];
  /** Shift name */
  name: Scalars['String']['output'];
  /** Number of cycles in the pattern */
  number_of_cycles: Scalars['Int']['output'];
  /** ID of the parent shift (previous version) if this shift was created by editing */
  parent_id?: Maybe<Scalars['UUID']['output']>;
  /** Type of shift (ROTATING) */
  shift_type: TimeShiftType;
  /** Tolerance configuration */
  tolerance_config?: Maybe<TimeToleranceConfig>;
  /** Total number of days in one complete rotation pattern */
  total_pattern_days: Scalars['Int']['output'];
  /** Total number of rest days in one complete pattern */
  total_rest_days: Scalars['Int']['output'];
  /** Total number of work days in one complete pattern */
  total_work_days: Scalars['Int']['output'];
  /** Last update timestamp */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type TimeRotatingShiftsBulkImportApplyInput = {
  /** Organization scope for the import */
  centralized_organization_id: Scalars['Int']['input'];
  /** Id of the staged batch (from validate) to create the shifts from */
  import_batch_id: Scalars['ID']['input'];
};

export type TimeRotatingShiftsBulkImportApplyPayload = {
  __typename?: 'TimeRotatingShiftsBulkImportApplyPayload';
  /** Number of rotating shifts created (contiguous-name groups, not staged cycle rows) */
  created_count: Scalars['Int']['output'];
  /** Commit-level failure message (null on success; FE Reintentar) */
  error_message?: Maybe<Scalars['String']['output']>;
  /** Id of the staged batch that was applied */
  import_batch_id: Scalars['ID']['output'];
  /** Whether the atomic apply committed (false ⇒ rolled back) */
  success: Scalars['Boolean']['output'];
};

export type TimeRotatingShiftsBulkImportApplyPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeRotatingShiftsBulkImportApplyPayload | ValidationErrorResponse;

export type TimeRotatingShiftsBulkImportMutations = {
  __typename?: 'TimeRotatingShiftsBulkImportMutations';
  /** Apply a staged rotating-shift batch atomically (sync). */
  rotating_shifts_bulk_import_apply: TimeRotatingShiftsBulkImportApplyPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** Validate an uploaded rotating-shift .xlsx and stage it. */
  rotating_shifts_bulk_import_validate: TimeExcelValidationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeRotatingShiftsBulkImportMutationsRotating_Shifts_Bulk_Import_ApplyArgs = {
  input: TimeRotatingShiftsBulkImportApplyInput;
};


export type TimeRotatingShiftsBulkImportMutationsRotating_Shifts_Bulk_Import_ValidateArgs = {
  input: TimeRotatingShiftsBulkImportValidateInput;
};

export type TimeRotatingShiftsBulkImportQueries = {
  __typename?: 'TimeRotatingShiftsBulkImportQueries';
  /** Bootstrap the review surface for a staged rotating-shift-definition batch. */
  rotating_shifts_bulk_import_result: TimeBulkImportResultNodeNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse;
  /** Page a single section/code of a staged rotating-shift-definition batch. */
  rotating_shifts_bulk_import_rows: TimeBulkImportRowsResultNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse;
  /** Download the rotating-shift .xlsx template (base64 inline). */
  rotating_shifts_bulk_import_template: TimeBulkImportTemplatePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
};


export type TimeRotatingShiftsBulkImportQueriesRotating_Shifts_Bulk_Import_ResultArgs = {
  input: TimeBulkImportResultInput;
};


export type TimeRotatingShiftsBulkImportQueriesRotating_Shifts_Bulk_Import_RowsArgs = {
  input: TimeBulkImportRowsInput;
};


export type TimeRotatingShiftsBulkImportQueriesRotating_Shifts_Bulk_Import_TemplateArgs = {
  input: TimeBulkImportTemplateInput;
};

export type TimeRotatingShiftsBulkImportValidateInput = {
  /** Organization ID for authorization and data scoping. */
  centralized_organization_id: Scalars['Int']['input'];
  /** File ID from crehana-subgraph-file after upload. */
  file_id: Scalars['String']['input'];
};

export type TimeSaveComplianceThresholdsInput = {
  /** Organization scope */
  centralized_organization_id: Scalars['Int']['input'];
  /** Country whose catalog to write (MX only for now) */
  country: TimeComplianceCountry;
  /** One or more thresholds to save. An EMPTY list is rejected with EMPTY_THRESHOLD_LIST — AC-1 says 'one or more', and an empty save is almost always a form serialization bug that a silent success would hide. Submitting the six unchanged is a different thing and is a legitimate no-op (changed_codes == []) */
  thresholds: Array<TimeComplianceThresholdEntryInput>;
};

export type TimeSaveComplianceThresholdsPayload = {
  __typename?: 'TimeSaveComplianceThresholdsPayload';
  /** Exactly the codes that were written and audited. Always a subset of the submitted codes; empty means zero rows and zero audit rows were written */
  changed_codes: Array<TimeComplianceThresholdCode>;
  /** Codes of the post-save catalog that are LAXER than the legal floor. A non-blocking warning banner, not an error */
  exceeds_legal_floor_codes: Array<TimeComplianceThresholdCode>;
  /** Whether the save completed. True even when nothing changed — a no-op is a success, distinguished by changed_codes == [] */
  success: Scalars['Boolean']['output'];
  /** The FULL effective catalog after the save — all six */
  thresholds: Array<TimeComplianceThreshold>;
};

export type TimeSaveComplianceThresholdsResult = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeComplianceThresholdValidationErrorResponse | TimeSaveComplianceThresholdsPayload | ValidationErrorResponse;

export enum TimeScheduleCellType {
  Rest = 'REST',
  Unassigned = 'UNASSIGNED',
  Working = 'WORKING'
}

export type TimeSetOrganizationAttendancePreferenceInput = {
  /** Organization scope */
  centralized_organization_id: Scalars['Int']['input'];
  /** Whether the marking app should request a photo at marking time (compliance opt-in gate). Default OFF. */
  request_photo_on_mark: Scalars['Boolean']['input'];
};

export type TimeSetOrganizationAttendancePreferencePayload = {
  __typename?: 'TimeSetOrganizationAttendancePreferencePayload';
  /** The persisted preference */
  organization_attendance_preference: TimeOrganizationAttendancePreference;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type TimeSetOrganizationAttendancePreferencePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeSetOrganizationAttendancePreferencePayload | ValidationErrorResponse;

export type TimeShiftAssignment = {
  __typename?: 'TimeShiftAssignment';
  /** Admin who created the assignment */
  assigned_by: CentralizedUserNode;
  /** Organization ID */
  centralized_organization_id: Scalars['Int']['output'];
  /** Creation timestamp */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Assignment end date (null = indefinite) */
  end_date?: Maybe<Scalars['Date']['output']>;
  /** Assignment unique identifier */
  id: Scalars['UUID']['output'];
  /** Whether the assignment is active */
  is_active: Scalars['Boolean']['output'];
  /** Assigned shift ID */
  shift_id: Scalars['UUID']['output'];
  /** Starting cycle ID for rotating shifts */
  start_cycle_id?: Maybe<Scalars['UUID']['output']>;
  /** Assignment start date */
  start_date: Scalars['Date']['output'];
  /** Last update timestamp */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who last updated the assignment (null if never updated) */
  updated_by?: Maybe<CentralizedUserNode>;
  /** Assigned collaborator */
  user: CentralizedUserNode;
};

export type TimeShiftAssignmentBlockedResponse = {
  __typename?: 'TimeShiftAssignmentBlockedResponse';
  /** Error code */
  code: Scalars['String']['output'];
  /** Operation ID for tracing */
  graphql_operation_id: Scalars['ID']['output'];
  /** Non-user-facing message; the FE composes its own copy */
  message: Scalars['String']['output'];
  /** Every collaborator evaluated — allowed, duplicate and blocked alike — so the FE can show which lines failed and which were fine */
  results: Array<TimeShiftAssignmentValidationResult>;
};

export type TimeShiftAssignmentValidationResult = {
  __typename?: 'TimeShiftAssignmentValidationResult';
  /** Single blocking reason; null unless verdict is BLOCKED */
  blocking_code?: Maybe<TimeShiftClashBlockingCode>;
  /** First violating date found walking chronologically; null unless verdict is BLOCKED */
  conflict_date?: Maybe<Scalars['Date']['output']>;
  /** Fin de la ventana en conflicto (exclusivo), resuelto para conflict_date. Null en los mismos casos que conflict_start_time. */
  conflict_end_time?: Maybe<Scalars['DateTime']['output']>;
  /** Inicio de la ventana en conflicto, YA RESUELTO para conflict_date. Puede caer el día anterior cuando esa ocurrencia cruza medianoche. Null cuando blocking_code no es SHIFT_TIME_OVERLAP: el techo diario no lo produce una ventana concreta. */
  conflict_start_time?: Maybe<Scalars['DateTime']['output']>;
  /** The colliding shift. Populated for SHIFT_TIME_OVERLAP; DELIBERATELY null for DAILY_SHIFT_LIMIT_EXCEEDED — there are three co-equal shifts that date and no deterministic tiebreak, so naming one would be showing wrong data. Compose that copy from resulting_shift_count. */
  conflicting_shift?: Maybe<TimeShiftClashConflictingShift>;
  /** Los turnos que el colaborador YA tiene en la fecha del veredicto, para el preview de horario del día. En BLOCKED es conflict_date; en ALLOWED y NOOP_DUPLICATE, el primer día del rango en que el candidato tiene ocurrencia. Cuenta los que ARRANCAN ese día, igual que el techo diario: un turno 22:00→06:00 pertenece al día en que empieza. Vacía cuando no hay con qué convivir. */
  existing_shifts: Array<TimeShiftClashOccurrence>;
  /** Shifts the collaborator ends up with on the relevant date (4 on a rejected ceiling). The FE warns from 2 upwards. */
  resulting_shift_count: Scalars['Int']['output'];
  /** Collaborator ID */
  user_id: Scalars['Int']['output'];
  /** ALLOWED (will be added), NOOP_DUPLICATE (already assigned identically — do not even fire the mutation) or BLOCKED */
  verdict: TimeShiftClashVerdict;
};

export type TimeShiftAssignmentsMutations = {
  __typename?: 'TimeShiftAssignmentsMutations';
  /** Assign a shift to one or more collaborators */
  assign_shift: TimeAssignShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse;
  /** Deactivate ONE shift assignment by its id, leaving the collaborator's other shifts of the same day active (soft delete) */
  deactivate_shift_assignment: TimeDeactivateShiftAssignmentResult;
  /**
   * Persist a bulk-assignment Excel file (re-validates from scratch).
   * @deprecated Superseded by time.bulk_import_shifts.shifts_bulk_import_apply (TIM-282, Excel Validation Standard). Removal rides a follow-up once Apollo shows 0 usage.
   */
  submit_bulk_shift_assignment: TimeSubmitBulkShiftAssignmentPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** Unassign shifts for given users within a date range (soft delete) */
  unassign_shift: TimeUnassignShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
  /**
   * Validate a bulk-assignment Excel file (preview only, no persistence).
   * @deprecated Superseded by time.bulk_import_shifts.shifts_bulk_import_validate (TIM-282, Excel Validation Standard). Removal rides a follow-up once Apollo shows 0 usage.
   */
  validate_bulk_shift_assignment: TimeValidateBulkShiftAssignmentPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeShiftAssignmentsMutationsAssign_ShiftArgs = {
  input: TimeAssignShiftInput;
};


export type TimeShiftAssignmentsMutationsDeactivate_Shift_AssignmentArgs = {
  input: TimeDeactivateShiftAssignmentInput;
};


export type TimeShiftAssignmentsMutationsSubmit_Bulk_Shift_AssignmentArgs = {
  input: TimeBulkShiftAssignmentInput;
};


export type TimeShiftAssignmentsMutationsUnassign_ShiftArgs = {
  input: TimeUnassignShiftInput;
};


export type TimeShiftAssignmentsMutationsValidate_Bulk_Shift_AssignmentArgs = {
  input: TimeBulkShiftAssignmentInput;
};

export type TimeShiftAssignmentsQueries = {
  __typename?: 'TimeShiftAssignmentsQueries';
  /** Count distinct active users assigned to a shift */
  count_active_assignments_by_shift: TimeCountActiveAssignmentsByShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse;
  /** Count users with active assignments overlapping a date range */
  count_users_with_assignments_in_range: TimeCountUsersWithAssignmentsInRangePayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** Count collaborators with at least one active schedule conflict. Counts collaborators, not rows. */
  count_users_with_shift_conflicts: TimeCountUsersWithShiftConflictsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
  /** List schedule conflicts grouped by unique (collaborator, shift A, shift B), with every conflicting date consolidated. */
  list_shift_conflicts: TimeListShiftConflictsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** List weekly shift assignment schedule for a leader's team */
  list_team_weekly_schedule: TimeListWeeklyAssignmentsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** List last attendance status for each member of a leader's team */
  list_team_weekly_schedule_last_status: TimeListTeamLastStatusPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** List weekly shift assignment schedule grid */
  list_weekly_schedule: TimeListWeeklyAssignmentsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** Preview an assignment before saving it: per-collaborator clash verdicts plus can_apply. Read-only — writes nothing. */
  validate_shift_assignment: TimeValidateShiftAssignmentPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse;
};


export type TimeShiftAssignmentsQueriesCount_Active_Assignments_By_ShiftArgs = {
  input: TimeCountActiveAssignmentsByShiftInput;
};


export type TimeShiftAssignmentsQueriesCount_Users_With_Assignments_In_RangeArgs = {
  input: TimeCountUsersWithAssignmentsInRangeInput;
};


export type TimeShiftAssignmentsQueriesCount_Users_With_Shift_ConflictsArgs = {
  input: TimeCountUsersWithShiftConflictsInput;
};


export type TimeShiftAssignmentsQueriesList_Shift_ConflictsArgs = {
  input: TimeListShiftConflictsInput;
};


export type TimeShiftAssignmentsQueriesList_Team_Weekly_ScheduleArgs = {
  input: TimeListTeamWeeklyScheduleInput;
};


export type TimeShiftAssignmentsQueriesList_Team_Weekly_Schedule_Last_StatusArgs = {
  input: TimeListTeamLastStatusInput;
};


export type TimeShiftAssignmentsQueriesList_Weekly_ScheduleArgs = {
  input: TimeListWeeklyAssignmentsInput;
};


export type TimeShiftAssignmentsQueriesValidate_Shift_AssignmentArgs = {
  input: TimeValidateShiftAssignmentInput;
};

export enum TimeShiftClashBlockingCode {
  DailyShiftLimitExceeded = 'DAILY_SHIFT_LIMIT_EXCEEDED',
  ShiftTimeOverlap = 'SHIFT_TIME_OVERLAP'
}

export type TimeShiftClashConflictingShift = {
  __typename?: 'TimeShiftClashConflictingShift';
  /** UUID of the active assignment that produced the conflict */
  assignment_id: Scalars['ID']['output'];
  /** UUID of the conflicting shift */
  shift_id: Scalars['ID']['output'];
  /** Name of the conflicting shift, for the FE copy */
  shift_name: Scalars['String']['output'];
};

export type TimeShiftClashOccurrence = {
  __typename?: 'TimeShiftClashOccurrence';
  /** UUID de la asignación activa que lo produce */
  assignment_id: Scalars['ID']['output'];
  /** Fin de la ocurrencia (exclusivo) */
  occurrence_end: Scalars['DateTime']['output'];
  /** Inicio de la ocurrencia, resuelto para esa fecha */
  occurrence_start: Scalars['DateTime']['output'];
  /** UUID del turno */
  shift_id: Scalars['ID']['output'];
  /** Nombre del turno */
  shift_name: Scalars['String']['output'];
};

export enum TimeShiftClashVerdict {
  Allowed = 'ALLOWED',
  Blocked = 'BLOCKED',
  NoopDuplicate = 'NOOP_DUPLICATE'
}

export enum TimeShiftColor {
  Beige = 'BEIGE',
  Blue = 'BLUE',
  Gray = 'GRAY',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Pink = 'PINK',
  Purple = 'PURPLE',
  YellowGreen = 'YELLOW_GREEN'
}

export enum TimeShiftConflictReportExportFailureCategory {
  /** The REQUESTING ADMIN has no resolvable email address, so the report has nowhere to go. Unrelated to a collaborator whose address does not resolve — that never fails the job, it renders as 'No aplica'. */
  AdminEmailUnresolved = 'ADMIN_EMAIL_UNRESOLVED',
  /** A required upstream read failed: either the conflict source itself, or the collaborator-email lookup returning nothing usable for EVERY row, which is a broken read rather than a data shape. */
  DataReadFailed = 'DATA_READ_FAILED',
  /** The transactional email service could not be reached. */
  EmailUnavailable = 'EMAIL_UNAVAILABLE',
  /** The job row was committed but the queue refused the message, so nothing will ever pick it up. The request itself answered with an internal error. */
  EnqueueFailed = 'ENQUEUE_FAILED',
  /** The report exceeded the configured safety row bound. The job fails rather than shipping a truncated file. */
  RowLimitExceeded = 'ROW_LIMIT_EXCEEDED',
  /** A previous attempt was abandoned mid-flight (typically a consumer restarted during a deploy) and was cleared when this admin requested again. It is a resolved condition, not a live failure: the request that cleared it returned a NEW export_id which is the one to poll. */
  StaleAbandoned = 'STALE_ABANDONED',
  /** Uploading the generated file failed. */
  StorageUnavailable = 'STORAGE_UNAVAILABLE',
  /** An unclassified failure. Diagnosis lives in the job's logs. */
  Unknown = 'UNKNOWN'
}

export type TimeShiftConflictReportExportNode = {
  __typename?: 'TimeShiftConflictReportExportNode';
  /** When the consumer claimed the job. Null while QUEUED. */
  claimed_at?: Maybe<Scalars['DateTime']['output']>;
  /** When the job stopped moving — set on DONE and on ERROR. */
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  /** When the job was enqueued. */
  created_at: Scalars['DateTime']['output'];
  /** When the emailed download link stops working. The URL itself is never exposed here — it exists only inside the email. */
  download_expires_at?: Maybe<Scalars['DateTime']['output']>;
  /** When the email was handed to Mailman AND accepted — which is not the same as delivered, so it must never be rendered as received. The Mailman consumer acks its own message even when the provider rejects it (measured in qa on 2026-08-18: Mandrill answered 401 Invalid_Key, the mail was dropped with no retry) and nothing reports that back, so this subgraph cannot see past the handoff. */
  email_sent_at?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier of the job. */
  export_id: Scalars['ID']['output'];
  /** Why the job failed. Populated only when status is ERROR. There is deliberately no free-text companion field: if product needs a new human-readable failure, the answer is a new enum member. */
  failure_category?: Maybe<TimeShiftConflictReportExportFailureCategory>;
  /** centralized_user_id of the admin who requested the report. */
  requested_by: Scalars['Int']['output'];
  /** Rows written to the sheet — one per conflicting shift pair. Zero is a valid successful outcome: an organization whose conflicts were resolved between the click and the run yields a header-only file, and the email is sent normally. */
  row_count: Scalars['Int']['output'];
  /** Current lifecycle state of the job. */
  status: TimeShiftConflictReportExportStatus;
  /** How many ROWS of the file render 'No aplica' in the Usuario column because the collaborator's email could not be resolved upstream. ⚠ This means the OPPOSITE of the identically-named field on the attendance-report export: there, unresolved rows are DROPPED and the counter measures what is MISSING. Here the rows are SHIPPED, because the file must keep matching the conflicts banner count — so a positive value means 'some usernames show as No aplica', never 'the file is incomplete'. Do not port that copy across. */
  unresolved_email_count: Scalars['Int']['output'];
};

export type TimeShiftConflictReportExportNodeNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeShiftConflictReportExportNode | ValidationErrorResponse;

export enum TimeShiftConflictReportExportStatus {
  /** The .xlsx was uploaded and the email sent. Check unresolved_email_count: a positive value is a soft warning about how CELLS render, never a claim that the file is incomplete. */
  Done = 'DONE',
  /** The job failed; failure_category says where. */
  Error = 'ERROR',
  /** The consumer claimed the job before doing any work, which is what makes a redelivery a no-op instead of a second email. */
  Processing = 'PROCESSING',
  /** Accepted and enqueued. The admin was answered without waiting for the file. */
  Queued = 'QUEUED'
}

export type TimeShiftConflictReportExportsMutations = {
  __typename?: 'TimeShiftConflictReportExportsMutations';
  /** Request the asynchronous generation of the shift-conflict report for an organization. Answers immediately with the job id; the .xlsx arrives by email with a time-limited link. */
  shift_conflict_report_export_request: TimeRequestShiftConflictReportExportPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
};


export type TimeShiftConflictReportExportsMutationsShift_Conflict_Report_Export_RequestArgs = {
  input: TimeRequestShiftConflictReportExportInput;
};

export type TimeShiftConflictReportExportsQueries = {
  __typename?: 'TimeShiftConflictReportExportsQueries';
  /** Read the state of one shift-conflict export job (QUEUED, PROCESSING, DONE, ERROR) so the request is never in an ambiguous state. Never returns a download URL — the link travels only in the delivery email. */
  shift_conflict_report_export: TimeShiftConflictReportExportNodeNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeShiftConflictReportExportsQueriesShift_Conflict_Report_ExportArgs = {
  input: TimeGetShiftConflictReportExportInput;
};

export type TimeShiftConflictRow = {
  __typename?: 'TimeShiftConflictRow';
  /** Every date this pair conflicts on, ascending and complete. Never truncated: the '+ N more' copy is composed by the client. */
  conflict_dates: Array<Scalars['Date']['output']>;
  /** The shift whose occurrence starts earlier on the first conflict date */
  shift_a: TimeShiftConflictShiftRef;
  /** The other shift of the pair */
  shift_b: TimeShiftConflictShiftRef;
  /** A third shift the collaborator also had that day, or null when there is none. The placeholder copy is the client's to render. */
  third_shift?: Maybe<TimeShiftConflictShiftRef>;
  /** Collaborator with the conflict */
  user_id: Scalars['Int']['output'];
};

export type TimeShiftConflictShiftRef = {
  __typename?: 'TimeShiftConflictShiftRef';
  /** Assignment through which the collaborator holds this shift */
  assignment_id: Scalars['ID']['output'];
  /** Conflicting shift ID */
  shift_id: Scalars['ID']['output'];
  /** Conflicting shift name */
  shift_name: Scalars['String']['output'];
};

export type TimeShiftConflictsFilterInput = {
  /** Narrow to these collaborators. Omit, null or an empty list all mean the whole organization. */
  user_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TimeShiftContext = {
  __typename?: 'TimeShiftContext';
  /** Break slots with effective boundaries */
  break_time_slots: Array<TimeAttendanceBreakTimeSlot>;
  /** Exit time adjusted by tolerance (exit_time + tolerance_after) */
  effective_shift_end?: Maybe<Scalars['DateTime']['output']>;
  /** Entry time adjusted by tolerance (entry_time - tolerance_before) */
  effective_shift_start?: Maybe<Scalars['DateTime']['output']>;
  /** Scheduled entry time (ISO 8601 with offset) */
  entry_time?: Maybe<Scalars['DateTime']['output']>;
  /** Scheduled exit time (ISO 8601 with offset) */
  exit_time?: Maybe<Scalars['DateTime']['output']>;
  /** Expected worked minutes from shift config */
  expected_minutes?: Maybe<Scalars['Int']['output']>;
  /** Whether this is a working day according to the shift */
  is_working_day: Scalars['Boolean']['output'];
  /** Name of the assigned shift */
  shift_name: Scalars['String']['output'];
  /** Type of shift (NON_ROTATING or ROTATING) */
  shift_type: TimeShiftType;
};

export type TimeShiftCycleInput = {
  /** Total break duration in minutes for this cycle. Required for FIXED_DURATION break type. */
  break_duration_minutes?: InputMaybe<Scalars['Int']['input']>;
  /** Break time slots for this cycle. Required for FIXED_SCHEDULE break type. Each slot defines a specific break (e.g., lunch 13:00-14:00). */
  break_time_slots?: InputMaybe<Array<TimeBreakTimeSlotInput>>;
  /** Type of cycle: WORK (requires schedule) or REST (no schedule) */
  cycle_type: TimeCycleType;
  /** Number of days in this cycle (minimum 1) */
  duration_days: Scalars['Int']['input'];
  /** Entry/start time in HH:MM format (required for WORK cycles) */
  entry_time?: InputMaybe<Scalars['String']['input']>;
  /** Exit/end time in HH:MM format (required for WORK cycles) */
  exit_time?: InputMaybe<Scalars['String']['input']>;
  /** Worked minutes per day for WORK cycles (required when edit_worked_minutes is true) */
  worked_minutes_per_day?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeShiftCycleResult = TimeRestCycle | TimeWorkCycle;

export type TimeShiftNameExistsInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Exact shift name to check for existence */
  name: Scalars['String']['input'];
};

export type TimeShiftNameExistsPayload = {
  __typename?: 'TimeShiftNameExistsPayload';
  /** Whether a shift with the given name exists in the organization */
  exists: Scalars['Boolean']['output'];
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeShiftNameExistsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeShiftNameExistsPayload;

export type TimeShiftResult = TimeNonRotatingShift | TimeRotatingShift;

export enum TimeShiftSortField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export enum TimeShiftSource {
  BulkImport = 'BULK_IMPORT',
  Manual = 'MANUAL'
}

export enum TimeShiftType {
  NonRotating = 'NON_ROTATING',
  Rotating = 'ROTATING'
}

export type TimeShiftsBulkImportApplyInput = {
  /** Organization scope for the import */
  centralized_organization_id: Scalars['Int']['input'];
  /** Staged batch id to apply */
  import_batch_id: Scalars['ID']['input'];
};

export type TimeShiftsBulkImportApplyPayload = {
  __typename?: 'TimeShiftsBulkImportApplyPayload';
  /** Rows that created OR replaced an active assignment */
  assigned_count: Scalars['Int']['output'];
  /** Commit-level failure message (null on success; FE Reintentar) */
  error_message?: Maybe<Scalars['String']['output']>;
  /** Rows the apply dropped when it re-validated them against the current assignments (TIM-418 D23). 0 means what was previewed is what was written. */
  revalidation_dropped_count: Scalars['Int']['output'];
  /** The dropped rows, so the admin sees WHY fewer rows landed than the validation screen showed. Codes, not copy. */
  revalidation_dropped_rows: Array<TimeShiftsBulkImportRevalidationDrop>;
  /** No-op rows (an active assignment already matched exactly) */
  skipped_count: Scalars['Int']['output'];
  /** Whether the atomic apply committed (false ⇒ rolled back) */
  success: Scalars['Boolean']['output'];
};

export type TimeShiftsBulkImportApplyPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeShiftsBulkImportApplyPayload | ValidationErrorResponse;

export type TimeShiftsBulkImportRevalidationDrop = {
  __typename?: 'TimeShiftsBulkImportRevalidationDrop';
  /** SHIFT_TIME_OVERLAP, DAILY_SHIFT_LIMIT_EXCEEDED or SHIFT_INACTIVE (TIM-421: the shift was deactivated between the validation and the apply) — the same dictionary the validation screen and the assignment modal use. Free-form String on purpose, so a new code is not a breaking federation change */
  blocking_code: Scalars['String']['output'];
  /** First violating date found walking chronologically; null unless the drop names a conflict */
  conflict_date?: Maybe<Scalars['Date']['output']>;
  /** The already-assigned shift this row collided with. Populated for SHIFT_TIME_OVERLAP; DELIBERATELY null for DAILY_SHIFT_LIMIT_EXCEEDED — three co-equal shifts that date and no deterministic tiebreak, so naming one would be showing wrong data. */
  conflicting_shift?: Maybe<TimeShiftClashOccurrence>;
  /** Collaborator email of the row */
  email: Scalars['String']['output'];
  /** The spreadsheet line the admin sees (1 header line + 1-based numbering, blank rows included) — the SAME base as the row items' FILE_ROW key. Named 'row_index' for backward compatibility only; it is not the parser's 0-based index. */
  row_index: Scalars['Int']['output'];
};

export type TimeShiftsBulkImportValidateInput = {
  /** Organization scope for the import */
  centralized_organization_id: Scalars['Int']['input'];
  /** subgraph-file id of the uploaded .xlsx shift-assignment file */
  file_id: Scalars['ID']['input'];
};

export type TimeShiftsMutations = {
  __typename?: 'TimeShiftsMutations';
  /** Create a new non-rotating shift */
  create_non_rotating_shift: TimeCreateNonRotatingShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
  /** Create a new rotating shift */
  create_rotating_shift: TimeCreateRotatingShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
  /** Soft delete a shift (set is_active=False) */
  delete_shift: TimeDeleteShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
  /** Edit a non-rotating shift (creates new version) */
  edit_non_rotating_shift: TimeEditNonRotatingShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
  /** Edit a rotating shift (creates new version) */
  edit_rotating_shift: TimeEditRotatingShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
};


export type TimeShiftsMutationsCreate_Non_Rotating_ShiftArgs = {
  input: TimeCreateNonRotatingShiftInput;
};


export type TimeShiftsMutationsCreate_Rotating_ShiftArgs = {
  input: TimeCreateRotatingShiftInput;
};


export type TimeShiftsMutationsDelete_ShiftArgs = {
  input: TimeDeleteShiftInput;
};


export type TimeShiftsMutationsEdit_Non_Rotating_ShiftArgs = {
  input: TimeEditNonRotatingShiftInput;
};


export type TimeShiftsMutationsEdit_Rotating_ShiftArgs = {
  input: TimeEditRotatingShiftInput;
};

export type TimeShiftsQueries = {
  __typename?: 'TimeShiftsQueries';
  /** Get a shift by ID (non-rotating or rotating) */
  get_shift: TimeGetShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse;
  /** List the active org shifts an admin may assign to a workday row (TIM-212). Read-only; the FE dedupes the row's current shift. */
  list_eligible_shifts_for_workday: TimeListEligibleShiftsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
  /** List all shifts (non-rotating and rotating) with search, filter, sort, and pagination */
  list_shifts: TimeListShiftsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
  /** Check if a shift name already exists in an organization */
  shift_name_exists: TimeShiftNameExistsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
};


export type TimeShiftsQueriesGet_ShiftArgs = {
  input: TimeGetShiftInput;
};


export type TimeShiftsQueriesList_Eligible_Shifts_For_WorkdayArgs = {
  input: TimeListEligibleShiftsInput;
};


export type TimeShiftsQueriesList_ShiftsArgs = {
  input: TimeListShiftsInput;
};


export type TimeShiftsQueriesShift_Name_ExistsArgs = {
  input: TimeShiftNameExistsInput;
};

export type TimeSimpleShiftNode = {
  __typename?: 'TimeSimpleShiftNode';
  /** Entry time HH:MM (null if rest day) */
  entry_time?: Maybe<Scalars['String']['output']>;
  /** Exit time HH:MM (null if rest day) */
  exit_time?: Maybe<Scalars['String']['output']>;
  /** Shift UUID */
  id: Scalars['ID']['output'];
  /** Shift name */
  name: Scalars['String']['output'];
};

export enum TimeSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type TimeStampType = {
  __typename?: 'TimeStampType';
  server_timezone: Scalars['String']['output'];
  utc_timezone: Scalars['String']['output'];
};

export type TimeSubmitBulkShiftAssignmentPayload = {
  __typename?: 'TimeSubmitBulkShiftAssignmentPayload';
  /** Newly persisted shift assignments (one per successful row) */
  created_assignments: Array<TimeShiftAssignment>;
  /** Rows that failed to persist */
  error_count: Scalars['Int']['output'];
  /** Persisted VALID_NEW rows */
  new_count: Scalars['Int']['output'];
  /** Persisted VALID_REPLACEMENT rows */
  replaced_count: Scalars['Int']['output'];
  /** All rows, with classification reflecting submit-phase verdict */
  rows: Array<TimeBulkAssignmentRow>;
  /** Whether the submit ran end-to-end */
  success: Scalars['Boolean']['output'];
  /** Total persisted rows (= new_count + replaced_count) */
  success_count: Scalars['Int']['output'];
};

export type TimeSubmitBulkShiftAssignmentPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeSubmitBulkShiftAssignmentPayload | ValidationErrorResponse;

export enum TimeTeamMemberStatusFilter {
  BreakEnd = 'BREAK_END',
  BreakStart = 'BREAK_START',
  Entry = 'ENTRY',
  Exit = 'EXIT',
  NoRecord = 'NO_RECORD',
  NoShift = 'NO_SHIFT',
  RestDay = 'REST_DAY'
}

export type TimeTeamMemberStatusRow = {
  __typename?: 'TimeTeamMemberStatusRow';
  /** Timestamp of the last attendance mark (null if no marks) */
  last_mark_at?: Maybe<Scalars['DateTime']['output']>;
  /** Computed status: ENTRY, BREAK_START, BREAK_END, EXIT, NO_RECORD, REST_DAY, NO_SHIFT */
  last_status?: Maybe<Scalars['String']['output']>;
  /** Shift info for the target date (null if no shift assigned) */
  shift?: Maybe<TimeSimpleShiftNode>;
  /** Federated user reference */
  user: CentralizedUserNode;
  /** Collaborator user ID */
  user_id: Scalars['Int']['output'];
};

export type TimeToleranceConfig = {
  __typename?: 'TimeToleranceConfig';
  /** Events to which after tolerance applies (ENTRY, BREAK, EXIT) */
  after_applicable_events: Array<TimeToleranceEvent>;
  /** Tolerance in minutes after scheduled time */
  after_minutes: Scalars['Int']['output'];
  /** Events to which before tolerance applies (ENTRY, BREAK, EXIT) */
  before_applicable_events: Array<TimeToleranceEvent>;
  /** Tolerance in minutes before scheduled time */
  before_minutes: Scalars['Int']['output'];
};

export type TimeToleranceConfigInput = {
  /** Events to which after tolerance applies (ENTRY, BREAK, EXIT). BREAK can only be included if the shift has break_config configured. */
  after_applicable_events: Array<TimeToleranceEvent>;
  /** Tolerance after scheduled time, expressed in minutes (e.g. 10 = 10 minutes). The frontend is responsible for converting HH:MM:SS display format to minutes before sending. */
  after_minutes: Scalars['Int']['input'];
  /** Events to which before tolerance applies (ENTRY, BREAK, EXIT). BREAK can only be included if the shift has break_config configured. */
  before_applicable_events: Array<TimeToleranceEvent>;
  /** Tolerance before scheduled time, expressed in minutes (e.g. 10 = 10 minutes). The frontend is responsible for converting HH:MM:SS display format to minutes before sending. */
  before_minutes: Scalars['Int']['input'];
};

export enum TimeToleranceEvent {
  Break = 'BREAK',
  Entry = 'ENTRY',
  Exit = 'EXIT'
}

export type TimeUnassignMarkingLocationInput = {
  /** Organization scope */
  centralized_organization_id: Scalars['Int']['input'];
  /** Attendance location ID to remove */
  marking_location_id: Scalars['UUID']['input'];
  /** Collaborator's centralized user ID */
  user_id: Scalars['Int']['input'];
};

export type TimeUnassignMarkingLocationPayload = {
  __typename?: 'TimeUnassignMarkingLocationPayload';
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type TimeUnassignMarkingLocationPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeUnassignMarkingLocationPayload;

export type TimeUnassignShiftInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** End date of the range (inclusive). Null means no end date. */
  end_date?: InputMaybe<Scalars['Date']['input']>;
  /** Start date of the range (inclusive) */
  start_date: Scalars['Date']['input'];
  /** List of collaborator IDs whose assignments to deactivate */
  user_ids: Array<Scalars['Int']['input']>;
};

export type TimeUnassignShiftPayload = {
  __typename?: 'TimeUnassignShiftPayload';
  /** New assignments created from split/trim of originals */
  created_assignments: Array<TimeShiftAssignment>;
  /** Original assignments that were deactivated */
  deactivated_assignments: Array<TimeShiftAssignment>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TimeUnassignShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeUnassignShiftPayload | ValidationErrorResponse;

export type TimeUnregisteredUserListItem = {
  __typename?: 'TimeUnregisteredUserListItem';
  /** Names of authorized marking locations for this user */
  marking_location_names: Array<Scalars['String']['output']>;
  /** Resolved shift with expected entry time (null if no assignment) */
  shift?: Maybe<TimeAttendanceMarkShiftNode>;
  /** Federated user reference */
  user: CentralizedUserNode;
};

export type TimeUpdateCollaboratorMarkingConfigInput = {
  /** Whether computer marking is allowed */
  allow_computer: Scalars['Boolean']['input'];
  /** Whether mobile app marking is allowed */
  allow_mobile_app: Scalars['Boolean']['input'];
  /** Whether the collaborator can mark from any unspecified location */
  can_mark_from_any_place: Scalars['Boolean']['input'];
  /** Whether the collaborator can mark from their home address */
  can_mark_from_home: Scalars['Boolean']['input'];
  /** Whether the collaborator can mark from Attendance module locations */
  can_mark_from_module_places: Scalars['Boolean']['input'];
  /** Organization scope */
  centralized_organization_id: Scalars['Int']['input'];
  /** Attendance location IDs that REPLACE the assigned set. Omit (null) to leave the current assignments untouched. */
  marking_location_ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Whether the collaborator must register attendance from a device */
  must_register_from_device: Scalars['Boolean']['input'];
  /** Collaborator's centralized user ID */
  user_id: Scalars['Int']['input'];
};

export type TimeUpdateCollaboratorMarkingConfigPayload = {
  __typename?: 'TimeUpdateCollaboratorMarkingConfigPayload';
  /** The updated configuration */
  collaborator_marking_config: TimeCollaboratorMarkingConfig;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type TimeUpdateCollaboratorMarkingConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeUpdateCollaboratorMarkingConfigPayload | ValidationErrorResponse;

export type TimeUpdateOvertimeConfigInput = {
  /** Accrual period for compensation */
  accrual_unit: TimeOvertimeAccrualUnit;
  /** Organization scope (required; enforced by AC-Permiso) */
  centralized_organization_id: Scalars['Int']['input'];
  /** Whether excess time is classified as payable overtime (default true — the behaviour of every pre-TIM-396 config) */
  classify_as_overtime?: Scalars['Boolean']['input'];
  /** Whether compensation is active (default false in all countries) */
  compensation_active?: Scalars['Boolean']['input'];
  /** Window over which pending excess stays compensable — applies only when compensation_active; otherwise stored null (TIM-396) */
  compensation_window?: InputMaybe<TimeOvertimeCompensationWindow>;
  /** Country (drives FE-preloaded defaults; never blocks a save) */
  country: TimeOvertimeCountry;
  /** Optional description (≤250 chars) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Overtime config unique identifier to edit */
  id: Scalars['UUID']['input'];
  /** Mexico daily legal-floor indicator — applies only for MX with WEEKLY/MONTHLY accrual (default true there); otherwise stored null */
  mexico_daily_legal_floor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Config name (unique per org, ≤150 chars) */
  name: Scalars['String']['input'];
  /** Payment-factor tier groups */
  payment_factors: TimeOvertimePaymentFactorsInput;
  /** Quantification type and per-tramo rounding */
  quantification: TimeOvertimeQuantificationInput;
  /** Payroll razón-social IDs (UUID, from get_legal_entities; 1–10, deduped) */
  razon_social_ids: Array<Scalars['UUID']['input']>;
  /** Local shift IDs to associate (1–10, validated existence+org) */
  shift_ids: Array<Scalars['UUID']['input']>;
  /** Whether day/night slots apply */
  slot_modality: TimeOvertimeSlotModality;
  /** Day slot when slot_modality is WITH_SLOT; omit for WITHOUT_SLOT */
  slots?: InputMaybe<TimeOvertimeSlotsInput>;
};

export type TimeUpdateOvertimeConfigPayload = {
  __typename?: 'TimeUpdateOvertimeConfigPayload';
  /** The updated configuration */
  overtime_config: TimeOvertimeConfig;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type TimeUpdateOvertimeConfigPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeUpdateOvertimeConfigPayload | ValidationErrorResponse;

export type TimeUserWithAttendanceAccess = {
  __typename?: 'TimeUserWithAttendanceAccess';
  /** True when the user has zero headquarter restrictions, which grants access to every headquarter (RN-003). When true, managed_headquarters is empty and must NOT be rendered as 'no headquarters'. */
  has_unrestricted_access: Scalars['Boolean']['output'];
  /** Federated references to ALL headquarters this user administers — not only the one that matched the collaborator. Empty when the user has no restriction; read has_unrestricted_access BEFORE rendering this list. ELEMENTS are nullable for the same TIM-241 reason as ``user``: a non-null element that the gateway cannot resolve null-propagates up through this list and the row and collapses the page, so a deleted headquarter would take the section down instead of leaving one hole. */
  managed_headquarters: Array<Maybe<OrganizationHeadquarterNode>>;
  /** Federated reference to the user with access. The gateway resolves full_name, position and profile_picture. Nullable by design (TIM-241 pattern, TECH-3 §3: 'aplicar este patron a todo tipo federado embebido en listados'): a permission holder who has been off-boarded still has a permission_group_user row upstream, so this list can legitimately carry a user_id that centralized-users no longer resolves. With a NON-null reference the gateway's failed entity resolution null-propagates and collapses the WHOLE page to data: null; nullable degrades only that row. The FE must render a per-row fallback. Made nullable before ship (TIM-479 D31): free now, breaking once TIM-480 consumes it. */
  user?: Maybe<CentralizedUserNode>;
};

export type TimeValidateBulkShiftAssignmentPayload = {
  __typename?: 'TimeValidateBulkShiftAssignmentPayload';
  /**
   * Rows with classification == VALID_REPLACEMENT
   * @deprecated Superseded by the TIM-282 Excel Validation Standard (time.bulk_import_shifts). There, an overlap surfaces as the BLOCKING SHIFT_TIME_OVERLAP ERROR group once the multi-shift clash engine is enabled (TIM-418) and as the non-blocking SHIFT_OVERLAP INFO group while it is not. This deprecated operation keeps replacing either way.
   */
  conflict_rows: Array<TimeBulkAssignmentRow>;
  /**
   * Rows with classification == INVALID
   * @deprecated Superseded by the TIM-282 Excel Validation Standard (time.bulk_import_shifts). Errors now surface as ERROR groups.
   */
  error_rows: Array<TimeBulkAssignmentRow>;
  /** Rows classified as INVALID */
  invalid_count: Scalars['Int']['output'];
  /** Whether the preview ran */
  success: Scalars['Boolean']['output'];
  /** Total data rows in the sheet */
  total_rows: Scalars['Int']['output'];
  /** Rows classified as VALID_NEW */
  valid_new_count: Scalars['Int']['output'];
  /** Rows classified as VALID_REPLACEMENT */
  valid_replacement_count: Scalars['Int']['output'];
  /**
   * Rows with classification == VALID_NEW
   * @deprecated Superseded by the TIM-282 Excel Validation Standard (time.bulk_import_shifts). Use shifts_bulk_import_result.valid_rows.
   */
  valid_rows: Array<TimeBulkAssignmentRow>;
};

export type TimeValidateBulkShiftAssignmentPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | TimeValidateBulkShiftAssignmentPayload | ValidationErrorResponse;

export type TimeValidateShiftAssignmentInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** End date of the assignment (YYYY-MM-DD). Null means indefinite. */
  end_date?: InputMaybe<Scalars['Date']['input']>;
  /** UUID of the shift to validate */
  shift_id: Scalars['ID']['input'];
  /** UUID of the starting cycle for rotating shifts. Required for rotating shifts, must be null for non-rotating shifts. */
  start_cycle_id?: InputMaybe<Scalars['ID']['input']>;
  /** Start date of the assignment (YYYY-MM-DD) */
  start_date: Scalars['Date']['input'];
  /** List of collaborator IDs the shift would be assigned to */
  user_ids: Array<Scalars['Int']['input']>;
};

export type TimeValidateShiftAssignmentPayload = {
  __typename?: 'TimeValidateShiftAssignmentPayload';
  /** True when NO collaborator is blocked. The all-or-nothing rule lives in the backend: bind the save button to this field, never to a per-row recomputation. */
  can_apply: Scalars['Boolean']['output'];
  /** One entry per collaborator, in the order they were sent */
  results: Array<TimeShiftAssignmentValidationResult>;
};

export type TimeValidateShiftAssignmentPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TimeValidateShiftAssignmentPayload | ValidationErrorResponse;

export type TimeWeekRange = {
  __typename?: 'TimeWeekRange';
  /** End date (ISO YYYY-MM-DD) */
  end_date: Scalars['String']['output'];
  /** Start date (ISO YYYY-MM-DD) */
  start_date: Scalars['String']['output'];
};

export type TimeWeeklyAssignmentRow = {
  __typename?: 'TimeWeeklyAssignmentRow';
  /** One cell per day in the selected date range */
  daily_cells: Array<TimeDailyScheduleCell>;
  /** True when at least one daily_cell OF THIS ROW has has_warning true, i.e. this assignment clashes with another shift of the same collaborator on some day of the requested range. Scoped to this assignment, never the collaborator's whole week repeated on every row; the same UTC and banner-window notes as has_warning apply. */
  has_total_warning: Scalars['Boolean']['output'];
  /** UUID of the ASSIGNMENT this row represents — not the shift's id, and not the collaborator's. It is the stable key: editing a shift versions shift_id, never assignment_id. Feed it verbatim to deactivate_shift_assignment to remove exactly this row. */
  id: Scalars['ID']['output'];
  /** Sum of planned_minutes across THIS assignment's daily cells in the requested range. One row is one assignment, so a collaborator with two shifts has two rows and adding this field across them gives that person's combined total — it is never a multiple of it. */
  total_planned_minutes: Scalars['Int']['output'];
  /** Federated user reference */
  user: CentralizedUserNode;
  /** Collaborator user ID */
  user_id: Scalars['Int']['output'];
};

export type TimeWorkCycle = {
  __typename?: 'TimeWorkCycle';
  /** Break duration in minutes for this cycle (FIXED_DURATION) */
  break_duration_minutes?: Maybe<Scalars['Int']['output']>;
  /** Break time slots for this cycle (FIXED_SCHEDULE) */
  break_time_slots?: Maybe<Array<TimeBreakTimeSlot>>;
  /** Position in the pattern (1, 2, 3, ...) */
  cycle_order: Scalars['Int']['output'];
  /** Type of cycle: WORK */
  cycle_type: TimeCycleType;
  /** Number of days in this cycle */
  duration_days: Scalars['Int']['output'];
  /** Entry/start time in HH:MM format */
  entry_time: Scalars['String']['output'];
  /** Exit/end time in HH:MM format */
  exit_time: Scalars['String']['output'];
  /** Cycle unique identifier */
  id: Scalars['UUID']['output'];
  /** Calculated worked minutes per day */
  worked_minutes_per_day: Scalars['Int']['output'];
};

export type TimeWorkday = {
  __typename?: 'TimeWorkday';
  /** Ausencias in minutes (FE contract §2) */
  absence_minutes: Scalars['Int']['output'];
  /** BREAK_END mark (null when not registered) */
  break_end?: Maybe<TimeWorkdayMark>;
  /** BREAK_START mark (null when not registered) */
  break_start?: Maybe<TimeWorkdayMark>;
  /** Whether the requesting admin may change the shift for this row (permission-derived, same for all rows). Defaults False until the scheduling permission is wired (TIM-212). */
  can_change_shift: Scalars['Boolean']['output'];
  /** Minutes auto-compensated by Mechanism 1 (min of excess/lost) */
  compensated_minutes: Scalars['Int']['output'];
  /** AC-4: whether that same governing config has compensation switched on. Independent of overtime_config_active — a resolved config with compensation off yields true/false. Both false when no single config resolves. Non-nullable for the same reason as the flag above. */
  compensation_available: Scalars['Boolean']['output'];
  /** Calendar date this workday belongs to */
  date: Scalars['Date']['output'];
  /**
   * Deprecated alias of `state`; kept for non-breaking TIM-210 clients.
   * @deprecated Use `state` (TIM-211 convergence); same six-state enum.
   */
  day_status: TimeDayStatus;
  /** Sub-detail of the day status. For INCOMPLETE days, a comma-separated list of missing mark types (e.g. 'entry,exit' using MarkType values). Null when not applicable. */
  day_status_detail?: Maybe<Scalars['String']['output']>;
  /** Gross delay / tiempo perdido */
  delay_minutes: Scalars['Int']['output'];
  /** ENTRY mark (null when not registered) */
  entry?: Maybe<TimeWorkdayMark>;
  /** Gross excedente (extra time over expected) */
  excess_minutes: Scalars['Int']['output'];
  /** EXIT mark (null when not registered) */
  exit?: Maybe<TimeWorkdayMark>;
  /** Mecanismo 2: minutes of the day's net excess classified as horas extra (FE contract §2). Writable via edit_workday (TIM-306). */
  extra_hours_minutes: Scalars['Int']['output'];
  /** Calendar holiday name (TIM-220 snapshot) when the day is a recognized HRIS holiday — the badge label for FERIADO / FERIADO_TRABAJADO states (TIM-221). Null on non-holiday rows. */
  holiday_name?: Maybe<Scalars['String']['output']>;
  /** Daily result identifier */
  id: Scalars['UUID']['output'];
  /**
   * Deprecated net lost minutes; kept for non-breaking TIM-210 clients.
   * @deprecated Compute client-side as max(0, delay_minutes - compensated_minutes).
   */
  lost_net_minutes: Scalars['Int']['output'];
  /** Whether Mechanism 1 auto-compensation was active when this workday was last computed (org-level toggle, same for all rows). Always True in V1 (not configurable). */
  mechanism1_active: Scalars['Boolean']['output'];
  /** AC-3: whether exactly one live + active overtime config governs this day's shift RIGHT NOW (resolved live by turno, never from the snapshot). False when the shift matches 0 configs, when 2+ configs claim it (ambiguous — see config_resolution_reason on the day-detail payload), or when the day carries no shift snapshot at all (pre-TIM-326 rows). Non-nullable on purpose: an 'indeterminate' null would be read as CONFIGURED by any `?? true` fallback. */
  overtime_config_active: Scalars['Boolean']['output'];
  /** Mecanismo 2: minutes of the day's net excess reserved as tiempo a compensar (FE contract §2). Writable via edit_workday (TIM-306). */
  reposicion_minutes: Scalars['Int']['output'];
  /** Minutes the collaborator was scheduled to work on the day, as calculated by the engine (schedule bracket minus break). 0 on days with no shift assigned, Time Off without a shift, and worked holidays / rest days — those days have no scheduled bracket. */
  scheduled_minutes: Scalars['Int']['output'];
  /** Resolved shift (with raw shift_slots for the Edit jornada dialog); null if no assignment */
  shift?: Maybe<TimeAttendanceMarkShiftNode>;
  /** Every active shift of this day, ordered by nominal entry time (slot 1 first), each with its own marks. Empty when the day has no active assignment. Marks sitting on a slot no active assignment backs are not listed here but remain visible in the day-wide entry/break_start/break_end/exit fields, which are unchanged. */
  shift_journeys: Array<TimeWorkdayShiftJourney>;
  /** Crehana six-state day status (FE contract §1.1 / §2). */
  state: TimeDayStatus;
  /** Time Off snapshot for the day (null when none applied) */
  time_off?: Maybe<TimeWorkdayTimeOff>;
  /** Federated user reference (name/avatar resolved by gateway). Nullable by design (TIM-241, same fix as TIM-225 for TimeAttendanceCardRow.user): a workday row can carry a user_id that centralized-users no longer resolves (a deleted/off-boarded collaborator with historical time_daily_result, or an orphan id). With a non-null reference the gateway's failed entity resolution null-propagates and collapses the whole page (data:null). Nullable degrades that single row to `user=null` instead of failing the listing. (Repro: org lambda, page 3, 2026-06-02→07-02.) */
  user?: Maybe<CentralizedUserNode>;
  /** Minutes effectively worked on the day */
  worked_minutes: Scalars['Int']['output'];
};

export type TimeWorkdayCrossDayCompensation = {
  __typename?: 'TimeWorkdayCrossDayCompensation';
  /** The compensated day. Never populated in V1 (D14). */
  compensated_date: Scalars['Date']['output'];
  /** Minutes applied to that day. Never populated in V1 (D14). */
  minutes: Scalars['Int']['output'];
};

export type TimeWorkdayMark = {
  __typename?: 'TimeWorkdayMark';
  /** Per-mark punctuality classification. Null means no calculation (e.g. system-generated exit or a mark with no shift). */
  classification?: Maybe<TimeAttendanceMarkStatus>;
  /** Marking channel / 'Dispositivo' this punch came from — App / Web / Biometric / Excel / Manual / System (TIM-339). Preserved from the underlying mark's source; the day's representative channel (used by the list_workdays mark_sources filter) is this field on the first present mark in order ENTRY > BREAK_START > BREAK_END > EXIT. Null only on a synthesized workday row with no persisted mark. */
  source?: Maybe<TimeMarkSource>;
  /** HH:mm — 24h, e.g. '08:03' */
  time_iso: Scalars['String']['output'];
};

export type TimeWorkdayOvertimeFactor = {
  __typename?: 'TimeWorkdayOvertimeFactor';
  /** Pay multiplier applied to these minutes (e.g. 1.25, 1.75). A FLOAT, not an enum — 'dobles'/'triples' is an FE label, same reasoning as the shipped TimeClassifiedOvertimeCategory.factor. Null on an unclassified segment, where unclassified_reason is set instead. */
  factor?: Maybe<Scalars['Float']['output']>;
  /** Minutes in this segment; always > 0 by domain invariant */
  minutes: Scalars['Int']['output'];
  /** Which factor ladder priced these minutes (MAIN / WORKED_REST / WORKED_HOLIDAY). Null on an unclassified segment, by invariant. */
  payment_factor_group?: Maybe<TimeOvertimePaymentFactorGroup>;
  /** Per-segment coverage warning: the config's rounding tramos did not cover the hour, so quantification was skipped and the minutes were taken exact. Counter-intuitive but correct — on a degraded segment the rounded total EQUALS the original. */
  rounding_degraded: Scalars['Boolean']['output'];
  /** 0-BASED position of this segment within the day, contiguous 0..n-1 and returned in ascending order. It is the persisted ``segment_ordinal`` column verbatim — a list KEY, not a display number. A UI that numbers factors for a human must render ``segment_ordinal + 1``; the field is deliberately NOT named ``index`` because that name invited exactly that off-by-one (the FE's frozen copy read 'Factor {{index}} aplicado' and would have rendered 'Factor 0' on every first segment). Physical row order is not stable across recomputes, so never key on position instead. */
  segment_ordinal: Scalars['Int']['output'];
  /** Day/night slot. Always DAY today — NIGHT is carved in the model and never produced by the engine. Do not build a day/night surface yet. */
  slot: TimeOvertimePaymentSlot;
  /** Why these minutes carry no factor. Null on a priced segment (factor XOR unclassified_reason). A data outcome, never an error. */
  unclassified_reason?: Maybe<TimeOvertimeUnclassifiedReason>;
};

export type TimeWorkdayShiftJourney = {
  __typename?: 'TimeWorkdayShiftJourney';
  /** Shift assignment UUID — the discriminator to send back as TimeEditWorkdayInput.assignment_id when editing THIS shift. The only stable identifier: editing a shift versions its shift_id, never the assignment id. */
  assignment_id: Scalars['ID']['output'];
  /** BREAK_END mark of THIS shift (null when not registered) */
  break_end?: Maybe<TimeWorkdayMark>;
  /** BREAK_START mark of THIS shift (null when not registered) */
  break_start?: Maybe<TimeWorkdayMark>;
  /** ENTRY mark of THIS shift (null when not registered) */
  entry?: Maybe<TimeWorkdayMark>;
  /** EXIT mark of THIS shift (null when not registered) */
  exit?: Maybe<TimeWorkdayMark>;
  /** The shift itself (id / name / expected_time / raw shift_slots). Null in ONE case only: the shift row is unreadable (not loadable for this assignment). A NON-WORKING day (or a rest cycle) does NOT null this field — the shift comes back with id/name populated, shift_slots null and expected_time empty ('') — the same non-null-shift shape the day-wide TimeWorkday.shift field already returns on a non-working day (its own expected_time degrades to null there rather than to ''). Render the null branch as a fallback, and read an empty/null expected_time as 'no scheduled window that day', never as a missing shift. */
  shift?: Maybe<TimeAttendanceMarkShiftNode>;
  /** The slot this shift occupies in the day (1 = the earliest by nominal entry time). Resolved, not a list index: the ordinal is not stable over time, while a mark's slot is persisted forever. Not capped at 3 — the product ceiling has no backstop in the data. */
  shift_slot: Scalars['Int']['output'];
};

export type TimeWorkdayShiftSlots = {
  __typename?: 'TimeWorkdayShiftSlots';
  /** Shift break-end anchor (HH:mm); null when no break window */
  break_end_iso?: Maybe<Scalars['String']['output']>;
  /** Shift break-start anchor (HH:mm); null when no break window */
  break_start_iso?: Maybe<Scalars['String']['output']>;
  /** Shift entry anchor (HH:mm) */
  entry_iso: Scalars['String']['output'];
  /** Shift exit anchor (HH:mm); may wrap past 24h for night shifts */
  exit_iso: Scalars['String']['output'];
};

export type TimeWorkdayStatusCounts = {
  __typename?: 'TimeWorkdayStatusCounts';
  /** Count of INCOMPLETE days */
  incomplete: Scalars['Int']['output'];
  /** JUSTIFIED sub-breakdown by pay and coverage */
  justification_breakdown: TimeJustificationBreakdown;
  /** Count of JUSTIFIED days */
  justified: Scalars['Int']['output'];
  /** Count of NO_SHIFT days */
  no_shift: Scalars['Int']['output'];
  /** Count of OK days */
  ok: Scalars['Int']['output'];
  /** Count of UNJUSTIFIED_ABSENCE days */
  unjustified_absence: Scalars['Int']['output'];
  /** Count of rows with auto-compensated time (auto_compensated_minutes > 0); powers the compensated-time header card. Overlapping facet with withExcessTime (TIM-355) */
  with_compensated_time: Scalars['Int']['output'];
  /** Count of rows with gross excess time (excess_minutes > 0); powers the excess-time header card. Overlapping facet — a fully-compensated day also counts in withCompensatedTime, not a disjoint bucket (TIM-355) */
  with_excess_time: Scalars['Int']['output'];
  /** Count of rows with classified extra time (extra_minutes > 0); powers the extra-time header card. Legitimately 0 for orgs without an active overtime-config Mechanism 2 (TIM-355) */
  with_extra_time: Scalars['Int']['output'];
  /** Count of WITH_NOVELTY days */
  with_novelty: Scalars['Int']['output'];
  /** Count of WORKED_HOLIDAY days (feriados trabajados); powers the worked-holiday filter chip (TIM-340) */
  worked_holiday: Scalars['Int']['output'];
  /** Count of WORKED_REST_DAY days (descansos trabajados); powers the worked-rest-day filter chip (TIM-340) */
  worked_rest_day: Scalars['Int']['output'];
  /** Count of WORKED_TIME_OFF days (tiempo libre trabajado): a scheduled day fully covered by approved Time Off that was worked anyway, so its minutes flow to excess instead of being discarded. These days are NOT counted in justified nor in justification_breakdown any more. Always 0 until the worked_time_off kill switch is enabled (TIM-389) */
  worked_time_off: Scalars['Int']['output'];
};

export type TimeWorkdayTimeOff = {
  __typename?: 'TimeWorkdayTimeOff';
  /** Coverage of the Time Off for the day (FULL or HALF) */
  coverage?: Maybe<Scalars['String']['output']>;
  /** Per-row justification bucket, isomorphic to the summary cards' justification_breakdown so a per-row badge agrees 1:1 with the card counts (with_pay / without_pay / half_day). Null = 'sin detalle' (partial / unknown coverage). TIM-236 P1. */
  justification?: Maybe<TimeJustificationBucket>;
  /** Source of the justificante that produced this JUSTIFIED day. Always TIME_OFF in v1; MANUAL (created-from-Asistencia) arrives additively with TIM-243. FE must switch the row's Ver/Eliminar menu on THIS field, not on the presence/absence of request_id (TIM-337 CA1 — replaces the fragile requestId heuristic). */
  origin: TimeJustificanteOrigin;
  /** Snapshot of the Time Off policy display name on the day */
  policy_name?: Maybe<Scalars['String']['output']>;
  /** Snapshot of the Time Off policy-type display name on the day */
  policy_type_name?: Maybe<Scalars['String']['output']>;
  /** Approved Time Off request id (TimeoffRequest.id) that applied on the day; null when none. Deep-links the Edit jornada 'Ir a Tiempo Libre' CTA (TIM-236 P3). */
  request_id?: Maybe<Scalars['String']['output']>;
};

export type TimeWorkdaysMutations = {
  __typename?: 'TimeWorkdaysMutations';
  /** Retroactively assign, change, or clear the shift for one (collaborator × day) and recompute that day inline */
  change_shift: TimeChangeShiftPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseNotFoundResponseInternalErrorResponse;
  /** Edit the four marks of a workday and recompute it inline */
  edit_workday: TimeEditWorkdayPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
};


export type TimeWorkdaysMutationsChange_ShiftArgs = {
  input: TimeChangeShiftInput;
};


export type TimeWorkdaysMutationsEdit_WorkdayArgs = {
  input: TimeEditWorkdayInput;
};

export type TimeWorkingDaySchedule = {
  __typename?: 'TimeWorkingDaySchedule';
  /** Break duration in minutes for this day (FIXED_DURATION) */
  break_duration_minutes?: Maybe<Scalars['Int']['output']>;
  /** Break time slots for this day (FIXED_SCHEDULE) */
  break_time_slots?: Maybe<Array<TimeBreakTimeSlot>>;
  /** Day of the week */
  day: TimeDayOfWeek;
  /** Whether this is a working day */
  is_working_day: Scalars['Boolean']['output'];
  /** Ordered list of time marks for matrix display. Includes ENTRY_TIME and EXIT_TIME, plus break marks (LUNCH_OUT_TIME, LUNCH_IN_TIME, etc.) if breaks are configured. */
  times_config?: Maybe<Array<TimeMark>>;
  /** Calculated worked time in minutes for this day */
  worked_minutes?: Maybe<Scalars['Int']['output']>;
};

/** A single point in a sparkline or timeline. */
export type TimelinePoint = {
  __typename?: 'TimelinePoint';
  /** Date label (e.g. '2026-05-14'). */
  date: Scalars['String']['output'];
  /** Numeric value for this date. */
  value: Scalars['Int']['output'];
};

export type TimelineType = {
  __typename?: 'TimelineType';
  employee_in_process?: Maybe<Scalars['Boolean']['output']>;
  employees_data?: Maybe<Array<UserTalentType>>;
  employees_in_process?: Maybe<Scalars['Int']['output']>;
  end_date: Scalars['Date']['output'];
  process_id: Scalars['Int']['output'];
  process_name: Scalars['String']['output'];
  start_date: Scalars['Date']['output'];
};

/** Subgraph HRIS - Individual entry that composes the accumulated balance */
export type TimeoffAccumulatedPeriod = {
  __typename?: 'TimeoffAccumulatedPeriod';
  /** Action that generated this entry */
  action: UserPolicyBalanceLogActionEnum;
  /** Balance amount for this entry */
  balance: Scalars['Float']['output'];
  /** Reason or period description for this entry */
  reason?: Maybe<Scalars['String']['output']>;
  /** Date this entry is valid from */
  valid_date: Scalars['Date']['output'];
};

export enum TimeoffCalendarWeekDayEnum {
  CalendarWeekFriday = 'CALENDAR_WEEK_FRIDAY',
  CalendarWeekMonday = 'CALENDAR_WEEK_MONDAY',
  CalendarWeekSaturday = 'CALENDAR_WEEK_SATURDAY',
  CalendarWeekSunday = 'CALENDAR_WEEK_SUNDAY',
  CalendarWeekThursday = 'CALENDAR_WEEK_THURSDAY',
  CalendarWeekTuesday = 'CALENDAR_WEEK_TUESDAY',
  CalendarWeekWednesday = 'CALENDAR_WEEK_WEDNESDAY'
}

export enum TimeoffExpirationBalanceFilterEnum {
  ExpiresIn_10Days = 'EXPIRES_IN_10_DAYS',
  ExpiresIn_30Days = 'EXPIRES_IN_30_DAYS',
  NoExpiringBalance = 'NO_EXPIRING_BALANCE'
}

/** Subgraph HRIS - Expiring days for a specific policy and deadline */
export type TimeoffExpiringDeadline = {
  __typename?: 'TimeoffExpiringDeadline';
  /** Days expiring before this deadline */
  days: Scalars['Float']['output'];
  /** Expiration date */
  expiration_date: Scalars['Date']['output'];
  /** ID of the policy these days belong to */
  policy_id: Scalars['Int']['output'];
};

/** Subgraph HRIS - Accrual period with upcoming expiration */
export type TimeoffExpiringPeriod = {
  __typename?: 'TimeoffExpiringPeriod';
  /** Days expiring in this period */
  days_remaining: Scalars['Float']['output'];
  /** Date these days expire */
  expiration_date: Scalars['Date']['output'];
};

export type TimeoffGetPolicyTemplatesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  /** Country ISO code, e.g. 'PE' */
  country_code: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Timeoff Holiday Type */
export type TimeoffHoliday = {
  __typename?: 'TimeoffHoliday';
  /** Holiday created at */
  created_at: Scalars['DateTime']['output'];
  /** Holiday end date */
  end_date: Scalars['Date']['output'];
  /** Holiday ID */
  id: Scalars['ID']['output'];
  /** Holiday is active */
  is_active: Scalars['Boolean']['output'];
  /** Holiday is recurrent */
  is_recurrent: Scalars['Boolean']['output'];
  /** Holiday is restricted */
  is_restricted: Scalars['Boolean']['output'];
  /** Holiday Name */
  name: Scalars['String']['output'];
  /** Organization ID */
  organization_id: Scalars['ID']['output'];
  /** Holiday recurrent type */
  recurrent_type: HolidayRecurrentTypeEnum;
  /** Holiday start date */
  start_date: Scalars['Date']['output'];
  /** Holiday updated at */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type TimeoffHolidayCustomConnection = {
  __typename?: 'TimeoffHolidayCustomConnection';
  edges: Array<TimeoffHolidayCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type TimeoffHolidayCustomEdge = {
  __typename?: 'TimeoffHolidayCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TimeoffHoliday;
};

/** A single date covered by a holiday applicable to a user */
export type TimeoffHolidayDate = {
  __typename?: 'TimeoffHolidayDate';
  /** Date covered by the holiday */
  holiday_date: Scalars['Date']['output'];
  /** Holiday name */
  holiday_name: Scalars['String']['output'];
};

export enum TimeoffIncorporationDateSimulationNoChangesReasonEnum {
  NoAffectedPolicies = 'NO_AFFECTED_POLICIES',
  SameIncorporationDate = 'SAME_INCORPORATION_DATE'
}

/** Pending requests on affected policies, informational until the simulated balance exists */
export type TimeoffIncorporationDateSimulationPendingRequests = {
  __typename?: 'TimeoffIncorporationDateSimulationPendingRequests';
  /** True while it's not yet possible to tell which of these requests would exceed the simulated balance (RN-015 depends on the simulated balance from AC-1/AC-4, not yet implemented). */
  at_risk_evaluation_pending: Scalars['Boolean']['output'];
  /** Pending (IN_PROGRESS) requests on affected policies */
  pending_requests_count: Scalars['Int']['output'];
  /** Total days requested across those pending requests */
  pending_requests_days: Scalars['Float']['output'];
};

/** Simulated impact of an incorporation date change on a single affected policy */
export type TimeoffIncorporationDateSimulationPolicy = {
  __typename?: 'TimeoffIncorporationDateSimulationPolicy';
  /** simulated_balance - current_balance. Null while pending. */
  balance_difference?: Maybe<Scalars['Float']['output']>;
  /** True while the full timeline replay (simulated balance, difference, negative flag) is not yet implemented — see HRIS-3978 follow-up work. `current_balance` and `simulated_seniority_years` are already accurate. */
  balance_simulation_pending: Scalars['Boolean']['output'];
  /** Conserved events: bulk import operations (BULK_IMPORT and its restore variants) */
  conserved_bulk_import_count: Scalars['Int']['output'];
  /** Events that stay untouched by the simulation */
  conserved_events_count: Scalars['Int']['output'];
  /** Conserved events: manual adjustments (MANUAL_ADJUSTMENT, BALANCE_RESET) */
  conserved_manual_adjustment_count: Scalars['Int']['output'];
  /** Conserved events that don't fit the named buckets above (LINKED, UNLINKED, REINSTATED) */
  conserved_other_count: Scalars['Int']['output'];
  /** Conserved events: consumed days (USED) */
  conserved_used_count: Scalars['Int']['output'];
  /** Current balance for this policy, unaffected by the simulation */
  current_balance: Scalars['Float']['output'];
  /** True if simulated_balance would be negative. Null while pending. */
  is_negative?: Maybe<Scalars['Boolean']['output']>;
  /** Policy ID */
  policy_id: Scalars['Int']['output'];
  /** Policy name */
  policy_name: Scalars['String']['output'];
  /** Automatic events (START, ACCUMULATION, RENEWAL, EXPIRED) that would be recalculated */
  recalculated_events_count: Scalars['Int']['output'];
  /** Balance this policy would have with the new incorporation date. Null while pending. */
  simulated_balance?: Maybe<Scalars['Float']['output']>;
  /** Years of service that would result from the new incorporation date */
  simulated_seniority_years: Scalars['Int']['output'];
};

/** Result of simulating the impact of an incorporation date change on a collaborator's time-off balances */
export type TimeoffIncorporationDateSimulationResponse = {
  __typename?: 'TimeoffIncorporationDateSimulationResponse';
  /** Per-policy simulation results, empty when has_changes is False */
  affected_policies: Array<TimeoffIncorporationDateSimulationPolicy>;
  /** False when the new date doesn't affect any policy balance */
  has_changes: Scalars['Boolean']['output'];
  /** Populated only when has_changes is False */
  no_changes_reason?: Maybe<TimeoffIncorporationDateSimulationNoChangesReasonEnum>;
  /** Null when has_changes is False */
  pending_requests?: Maybe<TimeoffIncorporationDateSimulationPendingRequests>;
};

/** Subgraph HRIS - the legal profile active for a policy, resolved from its (country, policy type). Its rules cannot be edited or disabled from the wizard (BR-1). */
export type TimeoffLegalProfile = {
  __typename?: 'TimeoffLegalProfile';
  /** Country ISO code */
  country_code: Scalars['String']['output'];
  /** ID */
  id: Scalars['Int']['output'];
  /** Name of the TimeoffPolicyType this profile applies to */
  policy_type_name: Scalars['String']['output'];
  /** Rules declared by this profile, with their current status */
  rules: Array<TimeoffLegalProfileRule>;
};

/** Subgraph HRIS - one rule of a country legal profile */
export type TimeoffLegalProfileRule = {
  __typename?: 'TimeoffLegalProfileRule';
  /** Rule code, e.g. 'PE-V1' */
  code: Scalars['String']['output'];
  /** Why a pending rule is not covered yet. Empty for covered rules. */
  depends_on: Scalars['String']['output'];
  /** Rule description */
  description: Scalars['String']['output'];
  /** HRIS-4028 AC-1: which Policy field this rule sets a legal minimum for. Null for rules with no comparable numeric floor (most PE-V1..V9 rules are behavioral, not a minimum). */
  field_name?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['Int']['output'];
  /** HRIS-4028 AC-1: the legal minimum for field_name. Null whenever field_name is null. */
  min_value?: Maybe<Scalars['Float']['output']>;
  /** 'covered' or 'pending' */
  status: Scalars['String']['output'];
};

/** A collaborator whose time-off balance is marked as misaligned by a pending or failed incorporation date recalculation (HRIS-3981). Only the latest recalculation event per collaborator is considered — once it COMPLETES the collaborator stops appearing here (AC-3). */
export type TimeoffMisalignedBalance = {
  __typename?: 'TimeoffMisalignedBalance';
  /** Why the recalculation failed. Null while IN_PROGRESS. */
  failure_reason?: Maybe<Scalars['String']['output']>;
  /** True when the admin can trigger a manual recalculation (status=FAILED). False while a recalculation is already IN_PROGRESS (AC-7) — retrying it would race the one already running. */
  is_retryable: Scalars['Boolean']['output'];
  /** Incorporation date that triggered this recalculation */
  new_incorporation_date: Scalars['Date']['output'];
  /** Centralized Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Incorporation date before the change that triggered this recalculation */
  previous_incorporation_date: Scalars['Date']['output'];
  /** Latest recalculation status. Never COMPLETED — those are excluded from this list. */
  status: IncorporationDateRecalculationStatusEnum;
  /** Collaborator */
  user?: Maybe<CentralizedUserNode>;
  /** Centralized User ID */
  user_id: Scalars['Int']['output'];
};

export type TimeoffMisalignedBalanceCustomConnection = {
  __typename?: 'TimeoffMisalignedBalanceCustomConnection';
  edges: Array<TimeoffMisalignedBalanceCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type TimeoffMisalignedBalanceCustomEdge = {
  __typename?: 'TimeoffMisalignedBalanceCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TimeoffMisalignedBalance;
};

/** Subgraph HRIS - Days to consume from a single expiring period */
export type TimeoffPeriodConsumption = {
  __typename?: 'TimeoffPeriodConsumption';
  /** Days consumed from this expiring period */
  days_to_use: Scalars['Float']['output'];
  /** Expiration date of this period */
  expiration_date: Scalars['Date']['output'];
};

/** Subgraph HRIS - Timeoff Policy Type */
export type TimeoffPolicy = {
  __typename?: 'TimeoffPolicy';
  /** Accumulation */
  accumulation?: Maybe<PolicyAccumulation>;
  /** Admin ID */
  admin_id?: Maybe<Scalars['ID']['output']>;
  /** Allow Discount Half Day */
  allow_discount_half_day: Scalars['Boolean']['output'];
  /** Allow Negative Values */
  allow_negative_values?: Maybe<Scalars['Boolean']['output']>;
  /** Auto Resolvable Time Days */
  auto_resolvable_time_days?: Maybe<Scalars['Int']['output']>;
  /** Country ISO code declared for this Policy, or null if none was declared */
  country?: Maybe<Scalars['String']['output']>;
  /** Policy creation date */
  created_at: Scalars['DateTime']['output'];
  /** Admin who created this Policy */
  created_by?: Maybe<CentralizedUserNode>;
  /** Policy Description */
  description?: Maybe<Scalars['String']['output']>;
  /** First Period Delay Months */
  first_period_delay_months?: Maybe<Scalars['Int']['output']>;
  /** Has Deferred First Period */
  has_deferred_first_period?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this Policy's linked collaborators span more than one country */
  has_multiple_countries: Scalars['Boolean']['output'];
  /** Has Rule By Age */
  has_rule_by_age?: Maybe<Scalars['Boolean']['output']>;
  /** Has Time Limit To Use */
  has_time_limit_to_use?: Maybe<Scalars['Boolean']['output']>;
  /** Policy ID */
  id: Scalars['ID']['output'];
  /** Policy Instructions */
  instructions?: Maybe<Scalars['String']['output']>;
  /** If Policy is active */
  is_active: Scalars['Boolean']['output'];
  /** Is Apply Max Balance Accumulated */
  is_apply_max_balance_accumulated?: Maybe<Scalars['Boolean']['output']>;
  /** Is Auto Resolvable */
  is_auto_resolvable?: Maybe<PolicyIsAutoResolvable>;
  /** Is Max Negative Accumulable */
  is_max_negative_accumulable?: Maybe<Scalars['Boolean']['output']>;
  /** Is Max Time Transferable */
  is_max_time_transferable?: Maybe<Scalars['Boolean']['output']>;
  /** Is Negative Value Next Period */
  is_negative_value_next_period?: Maybe<Scalars['Boolean']['output']>;
  /** Is Policy Paid */
  is_paid: Scalars['Boolean']['output'];
  /** Is Restricted */
  is_restricted: Scalars['Boolean']['output'];
  /** Is Time Expirable */
  is_time_expirable?: Maybe<Scalars['Boolean']['output']>;
  /** Is Transferable */
  is_transferable?: Maybe<Scalars['Boolean']['output']>;
  /** Is Policy Unlimited */
  is_unlimited: Scalars['Boolean']['output'];
  /** The legal profile active for this Policy, resolved from its declared country and policy type. Null when the policy has no country declared, or no profile matches its (country, type). */
  legal_profile?: Maybe<TimeoffLegalProfile>;
  /** Max Balance Accumulated Value */
  max_balance_accumulated_value?: Maybe<Scalars['Int']['output']>;
  /** Max Negative Accumulable Value */
  max_negative_accumulable_value?: Maybe<Scalars['Int']['output']>;
  /** Max Time */
  max_time: Scalars['Float']['output'];
  /** Max Time Transferable Value */
  max_time_transferable_value?: Maybe<Scalars['Int']['output']>;
  /** Min Time */
  min_time: Scalars['Float']['output'];
  /** Policy Name */
  name: Scalars['String']['output'];
  /** Needs Approvals */
  needs_approvals: Scalars['Boolean']['output'];
  /** Needs Leader Approval */
  needs_leader_approval?: Maybe<Scalars['Boolean']['output']>;
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Allow Overlap Holidays */
  overlap_holidays: Scalars['Boolean']['output'];
  /** Policy Affected user count */
  policy_affected_users_count?: Maybe<Scalars['Int']['output']>;
  /** Days related to this Policy */
  policy_days?: Maybe<TimeoffPolicyDays>;
  /** Policy rules related to this Policy */
  policy_rules?: Maybe<Array<TimeoffPolicyRule>>;
  /** Policy rules related to this Policy */
  policy_rules_by_age?: Maybe<Array<TimeoffPolicyRuleByAge>>;
  /** Policy rules (labeled) related to this Policy */
  policy_rules_labeled?: Maybe<Array<TimeoffPolicyLabeledRule>>;
  /** Policy type related to this Policy */
  policy_type: TimeoffPolicyType;
  /** Policy Type ID */
  policy_type_id: Scalars['Int']['output'];
  /** Policy users approvers related to this Policy */
  policy_user_approvers?: Maybe<Array<TimeoffPolicyUserApprover>>;
  /** Quantification */
  quantification: PolicyQuantification;
  /** Renovation */
  renovation?: Maybe<PolicyRenovation>;
  /** Renovation Day */
  renovation_day?: Maybe<Scalars['Int']['output']>;
  /** Renovation Granularity, set when renovation is BIRTHDAY */
  renovation_granularity?: Maybe<PolicyRenovationGranularity>;
  /** Renovation Month */
  renovation_month?: Maybe<Scalars['Int']['output']>;
  /** V2: Application mode (intervals or specific_years) */
  rule_by_age_application_mode?: Maybe<Scalars['String']['output']>;
  /** V2: Enum version for application mode (new field) */
  rule_by_age_application_mode_enum?: Maybe<PolicyRuleByAgeApplicationModeEnum>;
  /** V2: Whether age rules are cumulative */
  rule_by_age_is_cumulative?: Maybe<Scalars['Boolean']['output']>;
  /** SAT disability type declared for this Policy (Mexico only), or null if none was declared */
  sat_disability_type?: Maybe<PolicySatDisabilityTypeEnum>;
  /** Start Accumulation Days */
  start_accumulation_days?: Maybe<Scalars['Int']['output']>;
  /** Policy Status (enabled/disabled) */
  status: Scalars['String']['output'];
  /** Time Distribution */
  time_distribution?: Maybe<PolicyTimeDistribution>;
  /** Time Distribution Frequency */
  time_distribution_frecuency?: Maybe<PolicyTimeDistributionFrequency>;
  /** Time Expirable Conditional */
  time_expirable_conditional?: Maybe<PolicyTimeExpirableConditional>;
  /** Time Expirable Period */
  time_expirable_period?: Maybe<PolicyTimeExpirablePeriod>;
  /** Time Expirable Value */
  time_expirable_value?: Maybe<Scalars['Int']['output']>;
  /** Time Limit To Use Days */
  time_limit_to_use_days?: Maybe<Scalars['Int']['output']>;
  /** Total Time */
  total_value?: Maybe<Scalars['Int']['output']>;
  /** Policy updated date */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Working Hours */
  working_hours: Scalars['Int']['output'];
};

/** Subgraph HRIS - Policy assignment segment */
export type TimeoffPolicyAssignmentSegment = {
  __typename?: 'TimeoffPolicyAssignmentSegment';
  /** Segmentation data type */
  data_type: SegmentationDataTypeEnum;
  /** Custom field ID or policy rule ID */
  field_id?: Maybe<Scalars['Int']['output']>;
  /** Custom field label */
  field_label?: Maybe<Scalars['String']['output']>;
  /** Segment label */
  label: Scalars['String']['output'];
  /** Segmentation conditional operation */
  operation: SegmentationConditionalEnum;
  /** Segment values */
  values: Array<Scalars['String']['output']>;
};

/** Subgraph HRIS - Birthday date coverage for a policy segment */
export type TimeoffPolicyBirthdayCoverage = {
  __typename?: 'TimeoffPolicyBirthdayCoverage';
  /** True when the policy_rules include a segmentation data_type not supported by this query (e.g. AREA). The counts above ignore that condition. */
  has_unsupported_segmentation: Scalars['Boolean']['output'];
  /** Count of segment users with birthday_date registered */
  users_with_birthday_date: Scalars['Int']['output'];
  /** Count of segment users without birthday_date registered */
  users_without_birthday_date: Scalars['Int']['output'];
  /** Collaborators in the segment without birthday_date registered */
  users_without_birthday_date_detail: TimeoffPolicyBirthdayCoverageUserCustomConnection;
};

/** Subgraph HRIS - Collaborator without birthday_date registered */
export type TimeoffPolicyBirthdayCoverageUser = {
  __typename?: 'TimeoffPolicyBirthdayCoverageUser';
  /** User Area Name */
  area_name?: Maybe<Scalars['String']['output']>;
  /** Centralized User ID */
  centralized_user_id: Scalars['Int']['output'];
  /** User Email */
  email: Scalars['String']['output'];
  /** User Firstname */
  firstname: Scalars['String']['output'];
  /** User Headquarter Name */
  headquarter_name?: Maybe<Scalars['String']['output']>;
  /** User Lastname */
  lastname: Scalars['String']['output'];
};

export type TimeoffPolicyBirthdayCoverageUserCustomConnection = {
  __typename?: 'TimeoffPolicyBirthdayCoverageUserCustomConnection';
  edges: Array<TimeoffPolicyBirthdayCoverageUserCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type TimeoffPolicyBirthdayCoverageUserCustomEdge = {
  __typename?: 'TimeoffPolicyBirthdayCoverageUserCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TimeoffPolicyBirthdayCoverageUser;
};

/** Subgraph HRIS - Policy Check Response Node */
export type TimeoffPolicyCheck = {
  __typename?: 'TimeoffPolicyCheck';
  /** User count related to a Policy */
  users_assigned_to_policy: Scalars['Int']['output'];
  /** User count related to a planned to use a approved Request */
  users_with_future_requests: Scalars['Int']['output'];
  /** User count related to a Request in progress */
  users_with_requests: Scalars['Int']['output'];
};

export type TimeoffPolicyCustomConnection = {
  __typename?: 'TimeoffPolicyCustomConnection';
  edges: Array<TimeoffPolicyCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type TimeoffPolicyCustomEdge = {
  __typename?: 'TimeoffPolicyCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TimeoffPolicy;
};

/** Subgraph HRIS - Policy days Type */
export type TimeoffPolicyDays = {
  __typename?: 'TimeoffPolicyDays';
  friday: Scalars['Boolean']['output'];
  /** ID */
  id: Scalars['Int']['output'];
  monday: Scalars['Boolean']['output'];
  saturday: Scalars['Boolean']['output'];
  sunday: Scalars['Boolean']['output'];
  thursday: Scalars['Boolean']['output'];
  tuesday: Scalars['Boolean']['output'];
  wednesday: Scalars['Boolean']['output'];
};

/** Subgraph HRIS - Policy rule labeled Type */
export type TimeoffPolicyLabeledRule = {
  __typename?: 'TimeoffPolicyLabeledRule';
  data_type: SegmentationDataTypeEnum;
  field_id?: Maybe<Scalars['Int']['output']>;
  field_label?: Maybe<Scalars['String']['output']>;
  values: Array<TimeoffPolicyLabeledValueRule>;
};

/** Subgraph HRIS - Policy rule labeled value Type */
export type TimeoffPolicyLabeledValueRule = {
  __typename?: 'TimeoffPolicyLabeledValueRule';
  operation: SegmentationConditionalEnum;
  value?: Maybe<Array<Scalars['String']['output']>>;
};

/** Subgraph HRIS - Policy rule Type */
export type TimeoffPolicyRule = {
  __typename?: 'TimeoffPolicyRule';
  /** Icon slug */
  conditional_type: SegmentationConditionalEnum;
  /** Policy rule creation date */
  created_at: Scalars['DateTime']['output'];
  /** Custom Field ID */
  custom_field_id?: Maybe<Scalars['Int']['output']>;
  /** Icon slug */
  data_type: SegmentationDataTypeEnum;
  /** ID */
  id: Scalars['Int']['output'];
  /** Is Active */
  is_active: Scalars['Int']['output'];
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Policy ID */
  policy_id: Scalars['Int']['output'];
  /** Policy rule updated date */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Values */
  values: Scalars['String']['output'];
};

/** Subgraph HRIS - Policy rule by age Type */
export type TimeoffPolicyRuleByAge = {
  __typename?: 'TimeoffPolicyRuleByAge';
  /** Conditional */
  conditional: PolicyRuleByAgeConditional;
  /** Policy rule by age creation date */
  created_at: Scalars['DateTime']['output'];
  /** Days */
  days: Scalars['Int']['output'];
  /** ID */
  id: Scalars['Int']['output'];
  /** Is Active */
  is_active: Scalars['Int']['output'];
  /** Policy ID */
  policy_id: Scalars['Int']['output'];
  /** Policy rule by age updated date */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Years */
  years: Scalars['Int']['output'];
};

/** Subgraph HRIS - Policy template Type */
export type TimeoffPolicyTemplate = {
  __typename?: 'TimeoffPolicyTemplate';
  /** Country ISO code */
  country_code: Scalars['String']['output'];
  /** Policy template creation date */
  created_at: Scalars['DateTime']['output'];
  /** Legal basis for this template, in admin-facing language */
  description: Scalars['String']['output'];
  /** Whether this template has an associated country legal profile */
  has_legal_profile: Scalars['Boolean']['output'];
  /** ID */
  id: Scalars['Int']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Name of the TimeoffPolicyType this template maps to */
  policy_type_name: Scalars['String']['output'];
  /** Policy template updated date */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Prefill values for this template */
  values: Scalars['JSON']['output'];
};

export type TimeoffPolicyTemplateCustomConnection = {
  __typename?: 'TimeoffPolicyTemplateCustomConnection';
  edges: Array<TimeoffPolicyTemplateCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type TimeoffPolicyTemplateCustomEdge = {
  __typename?: 'TimeoffPolicyTemplateCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TimeoffPolicyTemplate;
};

/** Subgraph HRIS - Policy type Type */
export type TimeoffPolicyType = {
  __typename?: 'TimeoffPolicyType';
  /** Policy type creation date */
  created_at: Scalars['DateTime']['output'];
  /** Icon slug */
  icon: IconEnum;
  /** ID */
  id: Scalars['Int']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Policy type status */
  status: PolicyTypeStatus;
  /** Policy type updated date */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type TimeoffPolicyTypeCustomConnection = {
  __typename?: 'TimeoffPolicyTypeCustomConnection';
  edges: Array<TimeoffPolicyTypeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type TimeoffPolicyTypeCustomEdge = {
  __typename?: 'TimeoffPolicyTypeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TimeoffPolicyType;
};

/** Subgraph HRIS - Policy User Response Node */
export type TimeoffPolicyUser = {
  __typename?: 'TimeoffPolicyUser';
  /** Accumulated [UTC] */
  accumulated: Scalars['Float']['output'];
  /** Breakdown of the individual entries that compose the accumulated balance [UTC] */
  accumulated_periods: Array<TimeoffAccumulatedPeriod>;
  /** Balance [UTC] */
  balance: Scalars['Float']['output'];
  /** [HRIS-4016] Birthday benefit usage window for the current cycle. None only when the policy's renovation isn't BIRTHDAY (caller/schema mismatch) -- for a BIRTHDAY policy this always resolves to an object, check undetermined_reason for why eligible_dates/expiration_date may be empty. */
  birthday_usage_window?: Maybe<TimeoffPolicyUserBirthdayWindow>;
  /** End Balance [UTC] */
  end_balance: Scalars['Float']['output'];
  /** ID */
  id: Scalars['ID']['output'];
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Policy */
  policy: TimeoffPolicy;
  /** Policy Type ID */
  policy_id: Scalars['Int']['output'];
  /** Rules */
  policy_rules?: Maybe<Array<TimeoffPolicyRule>>;
  /** Rules by age */
  policy_rules_by_age?: Maybe<Array<TimeoffPolicyRuleByAge>>;
  /** Scheduled (based on Requests) [UTC] */
  scheduled: Scalars['Float']['output'];
  /** Used [UTC] */
  used: Scalars['Float']['output'];
  /** User ID */
  user_id: Scalars['Int']['output'];
};

/** Subgraph HRIS - Policy User Approver Type */
export type TimeoffPolicyUserApprover = {
  __typename?: 'TimeoffPolicyUserApprover';
  /** Admin ID */
  admin_id: Scalars['Int']['output'];
  /** Policy User Approver created date */
  created_at: Scalars['DateTime']['output'];
  /** Policy User Approver ID */
  id: Scalars['ID']['output'];
  /** Order */
  order: Scalars['Int']['output'];
  /** Policy ID */
  policy_id: Scalars['ID']['output'];
  /** Policy User Approver updated date */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Admin who created this Policy */
  user?: Maybe<CentralizedUserNode>;
  /** User ID */
  user_id: Scalars['ID']['output'];
};

export enum TimeoffPolicyUserBirthdayBalanceStatusEnum {
  Available = 'AVAILABLE',
  Consumed = 'CONSUMED',
  Expired = 'EXPIRED',
  PendingAccrual = 'PENDING_ACCRUAL'
}

/** Subgraph HRIS - Birthday benefit usage window (HRIS-4016) */
export type TimeoffPolicyUserBirthdayWindow = {
  __typename?: 'TimeoffPolicyUserBirthdayWindow';
  /** Days left until expiration. None when undetermined_reason is set (window not determined). */
  days_until_expiry?: Maybe<Scalars['Int']['output']>;
  /** Explicit list of eligible dates for the current cycle (already filtered by holidays, non-policy weekdays and existing requests). Empty when the current cycle's window already expired. */
  eligible_dates: Array<Scalars['Date']['output']>;
  /** Date until which the balance stays valid. None when undetermined_reason is set (window not determined). */
  expiration_date?: Maybe<Scalars['Date']['output']>;
  /** [HRIS-4019] Balance status: AVAILABLE, CONSUMED, EXPIRED or PENDING_ACCRUAL. None only when undetermined_reason is MISSING_GRANULARITY (misconfigured policy, no window to judge). */
  status?: Maybe<TimeoffPolicyUserBirthdayBalanceStatusEnum>;
  /** Why eligible_dates/expiration_date could not be determined for this BIRTHDAY policy: MISSING_BIRTHDAY_DATE (the collaborator has no birthday_date on record) or MISSING_GRANULARITY (the policy has no renovation_granularity configured). None when the window was fully determined. */
  undetermined_reason?: Maybe<TimeoffPolicyUserBirthdayWindowUndeterminedReasonEnum>;
};

export enum TimeoffPolicyUserBirthdayWindowUndeterminedReasonEnum {
  CycleAlreadyEnded = 'CYCLE_ALREADY_ENDED',
  MissingBirthdayDate = 'MISSING_BIRTHDAY_DATE',
  MissingGranularity = 'MISSING_GRANULARITY'
}

export type TimeoffPolicyUserCustomConnection = {
  __typename?: 'TimeoffPolicyUserCustomConnection';
  edges: Array<TimeoffPolicyUserCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type TimeoffPolicyUserCustomEdge = {
  __typename?: 'TimeoffPolicyUserCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TimeoffPolicyUser;
};

/** Subgraph HRIS - Timeoff Policy Type V2 */
export type TimeoffPolicyV2 = {
  __typename?: 'TimeoffPolicyV2';
  /** Accumulation */
  accumulation?: Maybe<PolicyAccumulation>;
  /** Admin ID */
  admin_id?: Maybe<Scalars['ID']['output']>;
  /** Allow Discount Half Day */
  allow_discount_half_day: Scalars['Boolean']['output'];
  /** Allow Negative Values */
  allow_negative_values?: Maybe<Scalars['Boolean']['output']>;
  /** Policy assignment labels for list view */
  assignment_labels: Array<Scalars['String']['output']>;
  /** Policy assignment segments (standardized) */
  assignment_segments: Array<TimeoffPolicyAssignmentSegment>;
  /** Auto Resolvable Time Days */
  auto_resolvable_time_days?: Maybe<Scalars['Int']['output']>;
  /** Country ISO code declared for this Policy, or null if none was declared */
  country?: Maybe<Scalars['String']['output']>;
  /** Policy creation date */
  created_at: Scalars['DateTime']['output'];
  /** Admin who created this Policy */
  created_by?: Maybe<CentralizedUserNode>;
  /** Policy Description */
  description?: Maybe<Scalars['String']['output']>;
  /** First Period Delay Months */
  first_period_delay_months?: Maybe<Scalars['Int']['output']>;
  /** Has Deferred First Period */
  has_deferred_first_period?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this Policy's linked collaborators span more than one country */
  has_multiple_countries: Scalars['Boolean']['output'];
  /** Has Rule By Age */
  has_rule_by_age?: Maybe<Scalars['Boolean']['output']>;
  /** Has Time Limit To Use */
  has_time_limit_to_use?: Maybe<Scalars['Boolean']['output']>;
  /** Policy ID */
  id: Scalars['ID']['output'];
  /** Policy Instructions */
  instructions?: Maybe<Scalars['String']['output']>;
  /** If Policy is active */
  is_active: Scalars['Boolean']['output'];
  /** Is Apply Max Balance Accumulated */
  is_apply_max_balance_accumulated?: Maybe<Scalars['Boolean']['output']>;
  /** Is Auto Resolvable */
  is_auto_resolvable?: Maybe<PolicyIsAutoResolvable>;
  /** Is Max Negative Accumulable */
  is_max_negative_accumulable?: Maybe<Scalars['Boolean']['output']>;
  /** Is Max Time Transferable */
  is_max_time_transferable?: Maybe<Scalars['Boolean']['output']>;
  /** Is Negative Value Next Period */
  is_negative_value_next_period?: Maybe<Scalars['Boolean']['output']>;
  /** Is Policy Paid */
  is_paid: Scalars['Boolean']['output'];
  /** Is Restricted */
  is_restricted: Scalars['Boolean']['output'];
  /** Is Time Expirable */
  is_time_expirable?: Maybe<Scalars['Boolean']['output']>;
  /** Is Transferable */
  is_transferable?: Maybe<Scalars['Boolean']['output']>;
  /** Is Policy Unlimited */
  is_unlimited: Scalars['Boolean']['output'];
  /** The legal profile active for this Policy, resolved from its declared country and policy type. Null when the policy has no country declared, or no profile matches its (country, type). */
  legal_profile?: Maybe<TimeoffLegalProfile>;
  /** Max Balance Accumulated Value */
  max_balance_accumulated_value?: Maybe<Scalars['Int']['output']>;
  /** Max Negative Accumulable Value */
  max_negative_accumulable_value?: Maybe<Scalars['Int']['output']>;
  /** Max Time */
  max_time: Scalars['Float']['output'];
  /** Max Time Transferable Value */
  max_time_transferable_value?: Maybe<Scalars['Int']['output']>;
  /** Min Time */
  min_time: Scalars['Float']['output'];
  /** Policy Name */
  name: Scalars['String']['output'];
  /** Needs Approvals */
  needs_approvals: Scalars['Boolean']['output'];
  /** Needs Leader Approval */
  needs_leader_approval?: Maybe<Scalars['Boolean']['output']>;
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Allow Overlap Holidays */
  overlap_holidays: Scalars['Boolean']['output'];
  /** Policy Affected user count */
  policy_affected_users_count?: Maybe<Scalars['Int']['output']>;
  /** Days related to this Policy */
  policy_days?: Maybe<TimeoffPolicyDays>;
  /** Policy rules related to this Policy */
  policy_rules?: Maybe<Array<TimeoffPolicyRule>>;
  /** Policy rules related to this Policy */
  policy_rules_by_age?: Maybe<Array<TimeoffPolicyRuleByAge>>;
  /** Policy rules (labeled) related to this Policy */
  policy_rules_labeled?: Maybe<Array<TimeoffPolicyLabeledRule>>;
  /** Policy type related to this Policy */
  policy_type: TimeoffPolicyType;
  /** Policy Type ID */
  policy_type_id: Scalars['Int']['output'];
  /** Policy users approvers related to this Policy */
  policy_user_approvers?: Maybe<Array<TimeoffPolicyUserApprover>>;
  /** Quantification */
  quantification: PolicyQuantification;
  /** Renovation */
  renovation?: Maybe<PolicyRenovation>;
  /** Renovation Day */
  renovation_day?: Maybe<Scalars['Int']['output']>;
  /** Renovation Month */
  renovation_month?: Maybe<Scalars['Int']['output']>;
  /** V2: Application mode (intervals or specific_years) */
  rule_by_age_application_mode?: Maybe<Scalars['String']['output']>;
  /** V2: Enum version for application mode (new field) */
  rule_by_age_application_mode_enum?: Maybe<PolicyRuleByAgeApplicationModeEnum>;
  /** V2: Whether age rules are cumulative */
  rule_by_age_is_cumulative?: Maybe<Scalars['Boolean']['output']>;
  /** SAT disability type declared for this Policy (Mexico only), or null if none was declared */
  sat_disability_type?: Maybe<PolicySatDisabilityTypeEnum>;
  /** Start Accumulation Days */
  start_accumulation_days?: Maybe<Scalars['Int']['output']>;
  /** Policy Status (enabled/disabled) */
  status: Scalars['String']['output'];
  /** Time Distribution */
  time_distribution?: Maybe<PolicyTimeDistribution>;
  /** Time Distribution Frequency */
  time_distribution_frecuency?: Maybe<PolicyTimeDistributionFrequency>;
  /** Time Expirable Conditional */
  time_expirable_conditional?: Maybe<PolicyTimeExpirableConditional>;
  /** Time Expirable Period */
  time_expirable_period?: Maybe<PolicyTimeExpirablePeriod>;
  /** Time Expirable Value */
  time_expirable_value?: Maybe<Scalars['Int']['output']>;
  /** Time Limit To Use Days */
  time_limit_to_use_days?: Maybe<Scalars['Int']['output']>;
  /** Total Time */
  total_value?: Maybe<Scalars['Int']['output']>;
  /** Policy updated date */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Working Hours */
  working_hours: Scalars['Int']['output'];
};

export type TimeoffPolicyV2CustomConnection = {
  __typename?: 'TimeoffPolicyV2CustomConnection';
  edges: Array<TimeoffPolicyV2CustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type TimeoffPolicyV2CustomEdge = {
  __typename?: 'TimeoffPolicyV2CustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TimeoffPolicyV2;
};

export type TimeoffQueries = {
  __typename?: 'TimeoffQueries';
  /** Get timeoff calendar */
  get_timeoff_calendar: Array<TimeoffRequestCalendarDate>;
  /** Get Timeoff Day Calendar by date */
  get_timeoff_day_calendar_by_date: TimeoffRequestCalendarDate;
  /** Get Timeoff Holiday by ID */
  get_timeoff_holiday_by_id?: Maybe<TimeoffHoliday>;
  /** [Service] Get the holiday dates applicable to a user within a date range, expanding recurrent holidays and segmentation rules (TIM-220) */
  get_timeoff_holiday_dates_by_user: Array<TimeoffHolidayDate>;
  /** Get Timeoff Holidays List */
  get_timeoff_holidays: TimeoffHolidayCustomConnection;
  /** Get Timeoff Holidays by User */
  get_timeoff_holidays_by_user: TimeoffHolidayCustomConnection;
  /** [Admin] Simulate the impact on a collaborator's time-off balances of changing their incorporation date, without applying it (RN-002) */
  get_timeoff_incorporation_date_simulation: TimeoffIncorporationDateSimulationResponse;
  /** [Admin] Collaborators whose time-off balance is currently marked as misaligned by a pending or failed incorporation date recalculation (HRIS-3981, AC-1/AC-3/AC-4/AC-5). Viewing this list only requires View — executing the recalculation (the mutation) requires Edit (AC-2). */
  get_timeoff_misaligned_balances: TimeoffMisalignedBalanceCustomConnection;
  /** [Admin] Get Policy List of the Centralized Organization. */
  get_timeoff_policies: TimeoffPolicyCustomConnection;
  /** [User] Get Policy List of the User in the Centralized Organization. */
  get_timeoff_policies_user: TimeoffPolicyUserCustomConnection;
  /** [Admin] Get Policy List V2 of the Centralized Organization with segmentation fields. */
  get_timeoff_policies_v2: TimeoffPolicyV2CustomConnection;
  /** Get Policy of the Centralized Organization. */
  get_timeoff_policy: TimeoffPolicy;
  /** [Admin] Get birthday_date coverage for a policy segment: how many collaborators in the segment have/don't have birthday_date registered, and the detail of those who don't. */
  get_timeoff_policy_birthday_coverage: TimeoffPolicyBirthdayCoverage;
  /** [Admin] Get user count related to a Policy, Requests and User Balance */
  get_timeoff_policy_check: TimeoffPolicyCheck;
  /** [Admin] Get the legal profile active for a policy, resolved from its declared country and policy type (AC-1/AC-2/AC-3). Returns null when the policy has no country declared, or when its (country, type) combination has no legal profile. */
  get_timeoff_policy_legal_profile?: Maybe<TimeoffLegalProfile>;
  /** [Admin] Validate if a policy name already exists in the organization */
  get_timeoff_policy_name_exists: Scalars['Boolean']['output'];
  /** Get Timeoff Policies rules list */
  get_timeoff_policy_rules?: Maybe<Array<TimeoffPolicyRule>>;
  /** [Admin] Get available policy templates for a country */
  get_timeoff_policy_templates: TimeoffPolicyTemplateCustomConnection;
  /** Get Timeoff Policies types list */
  get_timeoff_policy_types: TimeoffPolicyTypeCustomConnection;
  /** [User] Get Policy of the User in the Centralized Organization. */
  get_timeoff_policy_user: TimeoffPolicyUser;
  /** [Admin] Get User List with Balances in a Policy. */
  get_timeoff_policy_users: TimeoffUserPolicyBalanceLogCustomConnection;
  /** [Admin] Get Policy V2 of the Centralized Organization with segmentation fields. */
  get_timeoff_policy_v2: TimeoffPolicyV2;
  /** [Request] Gets Timeoff Request by ID */
  get_timeoff_request_by_id?: Maybe<TimeoffRequest>;
  /** Get Timeoff Requests comments */
  get_timeoff_request_comments: TimeoffRequestCommentCustomConnection;
  /** [Request] Get Timeoff Request time calculator */
  get_timeoff_request_time_calculator: RequestTimeCalculatorResponse;
  /** [Request] Gets Timeoff Requests List */
  get_timeoff_requests: TimeoffRequestCustomConnection;
  /** [Request] Get Timeoff Requests by Policy ID */
  get_timeoff_requests_by_policy: TimeoffRequestCustomConnection;
  /** [Request] Get Timeoff Requests by an specific User ID */
  get_timeoff_requests_by_user: TimeoffRequestCustomConnection;
  /** [Request] Get Timeoff Requests received to approval */
  get_timeoff_requests_received_to_approval: TimeoffRequestCustomConnection;
  /** [User] Total expiring balance within next 30 days across all expirable policies */
  get_timeoff_user_expiring_balance: TimeoffUserExpiringBalance;
  /** [User] Get User Policy Balance Logs List */
  get_timeoff_user_policy_balance_logs: TimeoffUserPolicyBalanceLogUserCustomConnection;
  /** Get Timeoff Week calendar by date */
  get_timeoff_week_calendar_by_date: Array<TimeoffRequestCalendarDate>;
  /** [User] Get User Policy Balance Log */
  get_user_policy_balance_log: TimeoffUserPolicyBalanceLogUser;
  /** [Admin] List bulk import batches for a policy, ordered by creation date (DESC by default) */
  timeoff_bulk_import_batch_list: BulkImportBatchListResponse;
  /** [Admin] Bootstrap query — returns page 1 of every section from persisted import rows */
  timeoff_bulk_import_detail_result: BulkImportResultNode;
  /** [Admin] Per-section query — paginate/search ONE section from persisted import rows */
  timeoff_bulk_import_detail_rows: BulkImportRowsResult;
  /** [Admin] Bootstrap query — returns page 1 of every section in one call */
  timeoff_bulk_import_result: BulkImportResultNode;
  /** [Admin] Per-section query — paginate/search ONE section independently */
  timeoff_bulk_import_rows: BulkImportRowsResult;
  /** [Admin] Download CSV template for policy balance import */
  timeoff_get_policy_balance_template: PolicyBalanceTemplateResponse;
  /** [Admin] Preview del impacto de restaurar una importación masiva — sin aplicar cambios */
  timeoff_restore_bulk_import_preview: RestoreBulkImportPreviewResult;
};


export type TimeoffQueriesGet_Timeoff_CalendarArgs = {
  input: GetTimeoffCalendarInput;
};


export type TimeoffQueriesGet_Timeoff_Day_Calendar_By_DateArgs = {
  input: GetTimeoffDayCalendarByDateInput;
};


export type TimeoffQueriesGet_Timeoff_Holiday_By_IdArgs = {
  centralized_organization_id: Scalars['ID']['input'];
  holiday_id: Scalars['ID']['input'];
};


export type TimeoffQueriesGet_Timeoff_Holiday_Dates_By_UserArgs = {
  input: GetTimeoffHolidayDatesByUserInput;
};


export type TimeoffQueriesGet_Timeoff_HolidaysArgs = {
  input: GetTimeoffHolidaysInput;
};


export type TimeoffQueriesGet_Timeoff_Holidays_By_UserArgs = {
  input: GetTimeoffHolidaysByUserInput;
};


export type TimeoffQueriesGet_Timeoff_Incorporation_Date_SimulationArgs = {
  input: SimulateTimeoffIncorporationDateImpactInput;
};


export type TimeoffQueriesGet_Timeoff_Misaligned_BalancesArgs = {
  input: GetTimeoffMisalignedBalancesInput;
};


export type TimeoffQueriesGet_Timeoff_PoliciesArgs = {
  input: GetPoliciesInput;
};


export type TimeoffQueriesGet_Timeoff_Policies_UserArgs = {
  input: GetPoliciesUserInput;
};


export type TimeoffQueriesGet_Timeoff_Policies_V2Args = {
  input: GetPoliciesInput;
};


export type TimeoffQueriesGet_Timeoff_PolicyArgs = {
  input: GetPolicyInput;
};


export type TimeoffQueriesGet_Timeoff_Policy_Birthday_CoverageArgs = {
  input: PolicyBirthdayCoverageInput;
};


export type TimeoffQueriesGet_Timeoff_Policy_CheckArgs = {
  input: PolicyCheckInput;
};


export type TimeoffQueriesGet_Timeoff_Policy_Legal_ProfileArgs = {
  input: GetPolicyLegalProfileInput;
};


export type TimeoffQueriesGet_Timeoff_Policy_Name_ExistsArgs = {
  input: PolicyNameExistsInput;
};


export type TimeoffQueriesGet_Timeoff_Policy_RulesArgs = {
  input: GetPolicyRulesInput;
};


export type TimeoffQueriesGet_Timeoff_Policy_TemplatesArgs = {
  input: TimeoffGetPolicyTemplatesInput;
};


export type TimeoffQueriesGet_Timeoff_Policy_TypesArgs = {
  input: GetPolicyTypesInput;
};


export type TimeoffQueriesGet_Timeoff_Policy_UserArgs = {
  input: GetPolicyUserInput;
};


export type TimeoffQueriesGet_Timeoff_Policy_UsersArgs = {
  input: GetPolicyUsersInput;
};


export type TimeoffQueriesGet_Timeoff_Policy_V2Args = {
  input: GetPolicyInput;
};


export type TimeoffQueriesGet_Timeoff_Request_By_IdArgs = {
  centralized_organization_id: Scalars['ID']['input'];
  timeoff_request_id: Scalars['ID']['input'];
};


export type TimeoffQueriesGet_Timeoff_Request_CommentsArgs = {
  input: GetTimeoffRequestCommentsInput;
};


export type TimeoffQueriesGet_Timeoff_Request_Time_CalculatorArgs = {
  input: GetTimeoffRequestTimeCalculatorInput;
};


export type TimeoffQueriesGet_Timeoff_RequestsArgs = {
  input: GetTimeoffRequestsInput;
};


export type TimeoffQueriesGet_Timeoff_Requests_By_PolicyArgs = {
  input: GetTimeoffRequestsByPolicyInput;
};


export type TimeoffQueriesGet_Timeoff_Requests_By_UserArgs = {
  input: GetTimeoffRequestsByUserInput;
};


export type TimeoffQueriesGet_Timeoff_Requests_Received_To_ApprovalArgs = {
  input: GetTimeoffRequestsReceivedToApprovalInput;
};


export type TimeoffQueriesGet_Timeoff_User_Expiring_BalanceArgs = {
  input: GetTimeoffUserExpiringBalanceInput;
};


export type TimeoffQueriesGet_Timeoff_User_Policy_Balance_LogsArgs = {
  input: GetUserPolicyBalanceLogsInput;
};


export type TimeoffQueriesGet_Timeoff_Week_Calendar_By_DateArgs = {
  input: GetTimeoffWeekCalendarByDateInput;
};


export type TimeoffQueriesGet_User_Policy_Balance_LogArgs = {
  input: GetUserPolicyBalanceLogInput;
};


export type TimeoffQueriesTimeoff_Bulk_Import_Batch_ListArgs = {
  input: BulkImportBatchListInput;
};


export type TimeoffQueriesTimeoff_Bulk_Import_Detail_ResultArgs = {
  input: BulkImportResultInput;
};


export type TimeoffQueriesTimeoff_Bulk_Import_Detail_RowsArgs = {
  input: BulkImportRowsInput;
};


export type TimeoffQueriesTimeoff_Bulk_Import_ResultArgs = {
  input: BulkImportResultInput;
};


export type TimeoffQueriesTimeoff_Bulk_Import_RowsArgs = {
  input: BulkImportRowsInput;
};


export type TimeoffQueriesTimeoff_Get_Policy_Balance_TemplateArgs = {
  input: GetPolicyBalanceTemplateInput;
};


export type TimeoffQueriesTimeoff_Restore_Bulk_Import_PreviewArgs = {
  input: RestoreBulkImportPreviewInput;
};

/** Subgraph HRIS - Request Type */
export type TimeoffRequest = {
  __typename?: 'TimeoffRequest';
  /** Auto-resolution info when the request timed out per the policy's schedule, null if not applicable (including when the chain was skipped by an admin, or fully settled by an explicit approve/deny) */
  approval_chain_auto_resolved?: Maybe<ApprovalChainAutoResolvedType>;
  /** Who skipped this request's approval chain and when, null if not applicable */
  approval_chain_skip?: Maybe<ApprovalChainSkipType>;
  /** When the request was cancelled, null if not cancelled or if it was cancelled before this field existed (HRIS-4059) */
  cancelled_at?: Maybe<Scalars['DateTime']['output']>;
  /** Who cancelled the request, null if not cancelled or if it was cancelled before this field existed (HRIS-4059) */
  cancelled_by_user?: Maybe<CentralizedUserNode>;
  /** Request comment */
  comment: Scalars['String']['output'];
  /** Request created at */
  created_at: Scalars['DateTime']['output'];
  /** Request end date */
  end_date: Scalars['Date']['output'];
  /** Request ID */
  id: Scalars['ID']['output'];
  /** Request is active */
  is_active: Scalars['Boolean']['output'];
  /** True if the requesting admin is part of this request's approval chain. Always False for non-admin callers. */
  is_current_user_approver: Scalars['Boolean']['output'];
  /** Organization ID */
  organization_id: Scalars['ID']['output'];
  /** Policy */
  policy: TimeoffPolicy;
  /** Policy ID */
  policy_id: Scalars['ID']['output'];
  /** Approvals */
  request_approval?: Maybe<Array<TimeoffRequestApproval>>;
  /** Files */
  request_files?: Maybe<Array<File>>;
  /** Request start date */
  start_date: Scalars['Date']['output'];
  /** Request status */
  status: RequestStatusEnum;
  /** Request updated at */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** User */
  user: CentralizedUserNode;
  /** User ID */
  user_id: Scalars['ID']['output'];
  /** User Balance */
  value: Scalars['Float']['output'];
};

/** Subgraph HRIS - Request Approval Type */
export type TimeoffRequestApproval = {
  __typename?: 'TimeoffRequestApproval';
  /** Request created at */
  created_at: Scalars['DateTime']['output'];
  /** Request Approval ID */
  id: Scalars['ID']['output'];
  /** Last Notification Log */
  last_request_notification_log?: Maybe<TimeoffRequestNotificationLog>;
  /** Request ID */
  request_id: Scalars['ID']['output'];
  /** Approval status */
  status: RequestApprovalStatusEnum;
  /** Request updated at */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** User */
  user?: Maybe<CentralizedUserNode>;
  /** User ID */
  user_id: Scalars['ID']['output'];
};

/** Timeoff Request Calendar Date Type */
export type TimeoffRequestCalendarDate = {
  __typename?: 'TimeoffRequestCalendarDate';
  /** Calendar Date */
  calendar_date: Scalars['Date']['output'];
  /** Original ID */
  id: Scalars['String']['output'];
  /** Organization ID */
  organization_id: Scalars['ID']['output'];
  /** Timeoff Holidays */
  timeoff_holidays: Array<TimeoffHoliday>;
  /** Timeoff Requests */
  timeoff_requests: Array<TimeoffRequest>;
  /** Week Number */
  week_day: TimeoffCalendarWeekDayEnum;
};

/** Subgraph HRIS - Request Comment Type */
export type TimeoffRequestComment = {
  __typename?: 'TimeoffRequestComment';
  /** Request comment */
  comment: Scalars['String']['output'];
  /** Request created at */
  created_at: Scalars['DateTime']['output'];
  /** Comment ID */
  id: Scalars['ID']['output'];
  /** Organization ID */
  organization_id: Scalars['ID']['output'];
  /** User Related to this Comment */
  user?: Maybe<CentralizedUserNode>;
  /** User ID */
  user_id: Scalars['ID']['output'];
};

export type TimeoffRequestCommentCustomConnection = {
  __typename?: 'TimeoffRequestCommentCustomConnection';
  edges: Array<TimeoffRequestCommentCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type TimeoffRequestCommentCustomEdge = {
  __typename?: 'TimeoffRequestCommentCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TimeoffRequestComment;
};

export type TimeoffRequestCustomConnection = {
  __typename?: 'TimeoffRequestCustomConnection';
  edges: Array<TimeoffRequestCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type TimeoffRequestCustomEdge = {
  __typename?: 'TimeoffRequestCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TimeoffRequest;
};

/** Timeoff RequestNotificationLog Type */
export type TimeoffRequestNotificationLog = {
  __typename?: 'TimeoffRequestNotificationLog';
  /** Created at */
  created_at: Scalars['DateTime']['output'];
  /** RequestNotificationLog ID */
  id: Scalars['ID']['output'];
  /** Is active */
  is_active: Scalars['Boolean']['output'];
  /** Notification Date */
  notification_date: Scalars['Date']['output'];
  /** Request ID */
  request_id: Scalars['ID']['output'];
  /** Updated at */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** User ID */
  user_id: Scalars['ID']['output'];
};

/** Subgraph HRIS - Aggregated expiring balance across all expirable policies */
export type TimeoffUserExpiringBalance = {
  __typename?: 'TimeoffUserExpiringBalance';
  /** Per-policy expiring deadlines ordered by nearest expiration date */
  expiring_deadlines: Array<TimeoffExpiringDeadline>;
  /** Total days expiring within 30 days across all expirable policies */
  total_expiring_days: Scalars['Float']['output'];
};

/** [Admin] Subgraph HRIS - User Balance Log Type */
export type TimeoffUserPolicyBalanceLog = {
  __typename?: 'TimeoffUserPolicyBalanceLog';
  /** Accumulated [UTC] */
  accumulated: Scalars['Float']['output'];
  action: UserPolicyBalanceLogActionEnum;
  /** Admin ID */
  admin_id?: Maybe<Scalars['Int']['output']>;
  /** Admin */
  author?: Maybe<CentralizedUserNode>;
  /** Balance [UTC] */
  balance: Scalars['Float']['output'];
  /** User Balance Log creation date */
  created_at: Scalars['DateTime']['output'];
  /** End Balance [UTC] */
  end_balance: Scalars['Float']['output'];
  /** Total expiring days across all upcoming periods [UTC] */
  expiring_days_total?: Maybe<Scalars['Float']['output']>;
  /** Upcoming expiring balance periods [UTC] */
  expiring_periods?: Maybe<Array<TimeoffExpiringPeriod>>;
  /** ID */
  id: Scalars['Int']['output'];
  operation: UserPolicyBalanceLogOperationEnum;
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Policy */
  policy: TimeoffPolicy;
  /** Policy ID */
  policy_id: Scalars['Int']['output'];
  /** Reason */
  reason?: Maybe<Scalars['String']['output']>;
  /** Request ID */
  request_id?: Maybe<Scalars['Int']['output']>;
  /** Scheduled (Based on Requests) [UTC] */
  scheduled: Scalars['Float']['output'];
  /** Used [UTC] */
  used: Scalars['Float']['output'];
  /** User */
  user?: Maybe<CentralizedUserNode>;
  /** User ID */
  user_id: Scalars['Int']['output'];
  /** User Balance Log valid date */
  valid_date: Scalars['Date']['output'];
};

export type TimeoffUserPolicyBalanceLogCustomConnection = {
  __typename?: 'TimeoffUserPolicyBalanceLogCustomConnection';
  edges: Array<TimeoffUserPolicyBalanceLogCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type TimeoffUserPolicyBalanceLogCustomEdge = {
  __typename?: 'TimeoffUserPolicyBalanceLogCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TimeoffUserPolicyBalanceLog;
};

/** [User] Subgraph HRIS - User Balance Log Type */
export type TimeoffUserPolicyBalanceLogUser = {
  __typename?: 'TimeoffUserPolicyBalanceLogUser';
  /** Accumulated */
  accumulated: Scalars['Float']['output'];
  action: UserPolicyBalanceLogActionEnum;
  /** Admin ID */
  admin_id?: Maybe<Scalars['Int']['output']>;
  /** Author */
  author?: Maybe<CentralizedUserNode>;
  /** User Balance */
  balance: Scalars['Float']['output'];
  /** User Balance Log creation date */
  created_at: Scalars['DateTime']['output'];
  /** ID */
  id: Scalars['Int']['output'];
  operation: UserPolicyBalanceLogOperationEnum;
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Policy */
  policy: TimeoffPolicy;
  /** Policy ID */
  policy_id: Scalars['Int']['output'];
  /** Reason */
  reason?: Maybe<Scalars['String']['output']>;
  /** Request */
  request?: Maybe<TimeoffRequest>;
  /** Request ID */
  request_id?: Maybe<Scalars['Int']['output']>;
  /** Used */
  used: Scalars['Float']['output'];
  /** User */
  user?: Maybe<CentralizedUserNode>;
  /** User ID */
  user_id: Scalars['Int']['output'];
};

export type TimeoffUserPolicyBalanceLogUserCustomConnection = {
  __typename?: 'TimeoffUserPolicyBalanceLogUserCustomConnection';
  edges: Array<TimeoffUserPolicyBalanceLogUserCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type TimeoffUserPolicyBalanceLogUserCustomEdge = {
  __typename?: 'TimeoffUserPolicyBalanceLogUserCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TimeoffUserPolicyBalanceLogUser;
};

export type TodoType = {
  __typename?: 'TodoType';
  end_date?: Maybe<Scalars['Date']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  process_id?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ToggleBenefitPublishStateInput = {
  benefit_ids?: Array<Scalars['ID']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  filter_by?: InputMaybe<AdminBenefitSearchInput>;
  publish_state: BenefitPublishStateEnum;
  selected_all?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A top course entry in the ranking. */
export type TopCourseNode = {
  __typename?: 'TopCourseNode';
  /** Average hours to complete the course. */
  avg_hours: Scalars['Float']['output'];
  /** Number of completions in the period. */
  completions: Scalars['Int']['output'];
  /** Course ID. */
  course_id: Scalars['Int']['output'];
  /** Course name. */
  course_name: Scalars['String']['output'];
  /** Position in the ranking (1–5). */
  rank: Scalars['Int']['output'];
  /** Color for the rank circle (e.g. 'green', 'blue', 'gray'). */
  rank_color: Scalars['String']['output'];
  /** Badge color for the source label (e.g. 'blue', 'green'). */
  source_color: Scalars['String']['output'];
  /** Badge label for the course source (e.g. 'Propio', 'Catálogo'). */
  source_label: Scalars['String']['output'];
};

/** Response for Section E1 — top 5 most completed courses. */
export type TopCoursesResponse = {
  __typename?: 'TopCoursesResponse';
  /** Top courses ranked by completions (max 5, pre-sorted by BE). */
  courses: Array<TopCourseNode>;
  /** Structured error code for degraded responses ('INVALID_PERIOD' on inconsistent period input). Null on success. */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Whether the current user has product-level access (Learning). False means the org does not have Learning — frontend should hide the widget. */
  has_permission: Scalars['Boolean']['output'];
  /** Icon name for the widget header (e.g. 'star'). */
  icon: Scalars['String']['output'];
  /** Localized timestamp of the most recent ETL sync for this widget's data. Format: '23 abr - 9:25am'. Null when freshness cannot be determined. */
  last_updated_at_formatted?: Maybe<Scalars['String']['output']>;
  /** Period range for the top courses ranking. */
  period: PeriodRange;
  /** Period subtitle (e.g. 'Este mes · 14 abr – 14 may'). */
  subtitle: Scalars['String']['output'];
  /** Widget title (e.g. 'Top 5 cursos más completados'). */
  title: Scalars['String']['output'];
};

export enum TrackCloseReasonEnum {
  Deadline = 'DEADLINE',
  Manual = 'MANUAL'
}

export type TrackClosureNode = {
  __typename?: 'TrackClosureNode';
  close_reason?: Maybe<TrackCloseReasonEnum>;
  closed_at?: Maybe<Scalars['DateTime']['output']>;
  scope: TrackClosureScopeEnum;
};

export enum TrackClosureScopeEnum {
  Member = 'MEMBER',
  Track = 'TRACK'
}

/** State of ONE requirement of the completion rule for the collaborator asking (epic CELC-4900, decision D-2). 'satisfied' is the verdict and 'current_value'/'threshold' are the progress behind it, on the 0-100 scale, for every requirement that has something to measure. */
export type TrackCompletionRequirementStatusType = {
  __typename?: 'TrackCompletionRequirementStatusType';
  /** Value reached by the collaborator, normalized to the same scale as 'threshold'. On FINAL_PROJECT_APPROVED it is the percentage of the projects of the track already delivered and approved (two of four is 50). On REQUIRED_COURSES_COMPLETED it is the percentage of the required courses of the track already finished, over the collaborator's effective target. On CONTENT_COMPLETION it is the viewing averaged over ALL the active courses of the track, optional ones included. Usually null whenever 'threshold' is null, because there is nothing to measure — but REQUIRED_COURSES_COMPLETED can be null with a threshold of 100 (no count or no readable target), and it can also read 100 while 'satisfied' is false, because the percentage clamps at 100 and the underlying comparison does not. */
  current_value?: Maybe<Scalars['Int']['output']>;
  /** Requirement being asked of the collaborator. Closed list. */
  requirement_type: TrackCompletionRequirementTypeEnum;
  /** TRUE if THIS individual requirement is met by the collaborator. */
  satisfied: Scalars['Boolean']['output'];
  /** Minimum required, 0-100. On FINAL_PROJECT_APPROVED and on REQUIRED_COURSES_COMPLETED it is always 100 and not a number the admin can move: every project of the track has to be approved, and every required course of the track has to be finished. Null when the requirement has nothing to measure for this track — no evaluation to grade, or no course approved by a final project — which is also when it is satisfied trivially. REQUIRED_COURSES_COMPLETED is the exception to that last sentence: it is never null and never satisfied for free, because it is the criterion that was in force before any of this was configurable. */
  threshold?: Maybe<Scalars['Int']['output']>;
};

/** Requisito de completitud de una ruta (epic CELC-4900). Lista cerrada de cuatro valores. Tres los configura el admin: CONTENT_COMPLETION (visualizacion minima del contenido, medida sobre TODOS los cursos activos de la ruta, obligatorios y opcionales), FINAL_EVALUATION_APPROVED (evaluacion final aprobada) y FINAL_PROJECT_APPROVED (proyecto final entregado y aprobado). El cuarto, REQUIRED_COURSES_COMPLETED (cursos obligatorios de la ruta terminados), es IMPLICITO: no tiene casilla ni minimo configurable, se exige siempre —exista o no una configuracion de completitud— y su minimo es un 100 fijo. Solo aparece en la lectura del colaborador, como discriminador del detalle por requisito: el admin configura los requisitos por campo, no por lista. */
export enum TrackCompletionRequirementTypeEnum {
  ContentCompletion = 'CONTENT_COMPLETION',
  FinalEvaluationApproved = 'FINAL_EVALUATION_APPROVED',
  FinalProjectApproved = 'FINAL_PROJECT_APPROVED',
  RequiredCoursesCompleted = 'REQUIRED_COURSES_COMPLETED'
}

/** Requisitos de completitud de la ruta (epic CELC-4900). Cada requisito activo se compara con MAYOR O IGUAL contra su propio minimo y todos los activos deben cumplirse a la vez: no hay operadores AND/OR ni orden entre ellos. */
export type TrackCompletionRequirementsInput = {
  /** Exige la completitud del contenido de los cursos de la ruta (checkbox 'Completitud del contenido de los cursos de la ruta'). Mide VISUALIZACION sobre todos los cursos activos de la ruta, no cursos terminados: para eso esta el requisito implicito REQUIRED_COURSES_COMPLETED, que se exige aunque esta casilla quede apagada. */
  content_completion_required?: Scalars['Boolean']['input'];
  /** Exige la evaluacion final aprobada. */
  final_evaluation_required?: Scalars['Boolean']['input'];
  /** Exige el proyecto final entregado y aprobado. Requisito booleano: una ruta sin ningun curso obligatorio que se apruebe por proyecto final lo cumple de forma trivial ('si algun curso de la ruta lo requiere'). */
  final_project_required?: Scalars['Boolean']['input'];
  /** Visualizacion minima requerida, entero 0-100. Solo aplica cuando content_completion_required es true: si se omite, el servidor la completa con 100 y guarda ese valor. Se guarda en null cuando el requisito esta apagado. El porcentaje se promedia sobre TODOS los cursos activos de la ruta: en una ruta de 4 cursos con 2 obligatorios, ver enteros los 2 obligatorios da 50. */
  min_content_progress?: InputMaybe<Scalars['Int']['input']>;
  /** Nota minima requerida, entero 0-100. Solo aplica cuando final_evaluation_required es true: si se omite, el servidor la completa con 80 y guarda ese valor. Se guarda en null cuando el requisito esta apagado. */
  min_evaluation_score?: InputMaybe<Scalars['Int']['input']>;
};

/** Completion requirements an admin CONFIGURED for a track (epic CELC-4900). Every active requirement is compared with >= against its own minimum and all of them have to hold at once. This type describes only the configured part: a collaborator is also asked, always and without any admin switching it on, for the required courses of the track to be finished (REQUIRED_COURSES_COMPLETED in the collaborator breakdown), and that requirement has no representation here because there is no row behind it. */
export type TrackCompletionRuleType = {
  __typename?: 'TrackCompletionRuleType';
  /** The content of the courses of the track must be completed. */
  content_completion_required: Scalars['Boolean']['output'];
  /** Cohort the rule applies to (NEW_AND_IN_PROGRESS | ALL_ENROLLED). */
  enrollment_scope: EnrollmentScopeEnum;
  /** The final evaluation must be approved. */
  final_evaluation_required: Scalars['Boolean']['output'];
  /** The final project must be delivered and approved. It has no minimum box because the minimum is fixed: EVERY required course of the track approved by a final project has to be delivered and approved, counted one by one. A track with no such course satisfies it trivially. */
  final_project_required: Scalars['Boolean']['output'];
  /** Rule row id. */
  id: Scalars['ID']['output'];
  /** Minimum content progress required, 0-100. Null when the content requirement is off. */
  min_content_progress?: Maybe<Scalars['Int']['output']>;
  /** Minimum grade required, 0-100. Null when the final-evaluation requirement is off. */
  min_evaluation_score?: Maybe<Scalars['Int']['output']>;
  /** Id of the track (OrganizationTeam) the rule belongs to. */
  track_id: Scalars['Int']['output'];
  /** Version of the rule. Bumped only when a save really changes the configuration, so re-saving the same rule leaves it untouched. */
  version: Scalars['Int']['output'];
};

/** Whether the collaborator asking meets the completion requirements in force for a track, with the breakdown per requirement (epic CELC-4900, D-2). A track with no configured requirements is answered under the implicit criterion that predates the epic — see 'uses_default_rule'. */
export type TrackCompletionStatusType = {
  __typename?: 'TrackCompletionStatusType';
  /** TRUE if the collaborator finished the required courses of the track AND, when a completion configuration exists, also meets every requirement it switched on. A membership already marked complete stays complete even if the requirements changed afterwards. */
  completed: Scalars['Boolean']['output'];
  /** Breakdown per requirement actually being asked of the collaborator. The first entry is always REQUIRED_COURSES_COMPLETED, the implicit requirement nobody configures; the configured ones follow, in the order of the admin tab. Absent means not asked: either nobody switched the requirement on, or it has no subject in this track — no course approved by a final project, no gradable evaluation — in which case it was always satisfied for free and listing it described a criterion that does not exist. With no configuration at all the list carries that single implicit line (see 'uses_default_rule'). The list is never empty. */
  requirements: Array<TrackCompletionRequirementStatusType>;
  /** TRUE when no completion configuration exists for this track, so the only requirement in force is the implicit one: the required courses finished. It turns FALSE the moment an admin saves a completion configuration, and from then on the configured requirements apply ON TOP of the implicit one — they never replace it. */
  uses_default_rule: Scalars['Boolean']['output'];
};

export enum TrackCourseExclusionReasonEnum {
  CourseNotInOrganization = 'COURSE_NOT_IN_ORGANIZATION',
  CourseUnavailable = 'COURSE_UNAVAILABLE'
}

export enum TrackManualCloseActionEnum {
  Close = 'CLOSE',
  Reopen = 'REOPEN'
}

export enum TrackModalityEnum {
  Open = 'OPEN',
  Standard = 'STANDARD'
}

export type TrackOrganizationTemplateNode = {
  __typename?: 'TrackOrganizationTemplateNode';
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  organization_id: Scalars['Int']['output'];
  organization_template: OrganizationTemplateNode;
  organization_template_id: Scalars['Int']['output'];
  track_id: Scalars['Int']['output'];
};

export type TrackOrganizationTemplateResponsePayload = {
  __typename?: 'TrackOrganizationTemplateResponsePayload';
  track_organization_template: TrackOrganizationTemplateNode;
};

export enum TrackVersionEnum {
  Version_1 = 'VERSION_1',
  Version_2 = 'VERSION_2'
}

export enum TrainingObjectiveEnum {
  TrainingObjectiveKey_1 = 'TRAINING_OBJECTIVE_KEY_1',
  TrainingObjectiveKey_2 = 'TRAINING_OBJECTIVE_KEY_2',
  TrainingObjectiveKey_3 = 'TRAINING_OBJECTIVE_KEY_3',
  TrainingObjectiveKey_4 = 'TRAINING_OBJECTIVE_KEY_4',
  TrainingObjectiveKey_5 = 'TRAINING_OBJECTIVE_KEY_5'
}

export enum TransactionStatusEnum {
  StatusDone = 'STATUS_DONE',
  StatusPending = 'STATUS_PENDING',
  StatusRejected = 'STATUS_REJECTED'
}

export enum TransactionTypeEnum {
  TypeAdjustment = 'TYPE_ADJUSTMENT',
  TypeExchanged = 'TYPE_EXCHANGED',
  TypeStocking = 'TYPE_STOCKING'
}

export type TranscoderProcessMutation = {
  __typename?: 'TranscoderProcessMutation';
  update_job_status: JobStatusResponse;
};


export type TranscoderProcessMutationUpdate_Job_StatusArgs = {
  inputs: JobStatusInputs;
};

export type TranslateLocaleKeyInput = {
  key: Scalars['String']['input'];
  languages?: InputMaybe<Array<LocaleLanguageEnum>>;
  namespace: Scalars['String']['input'];
  replace?: Scalars['Boolean']['input'];
};

export type TranslateLocaleKeySuccessReponse = {
  __typename?: 'TranslateLocaleKeySuccessReponse';
  locale_key: LocaleKey;
};

export type TranslateLocaleKeySuccessReponseMagiclinkMutationValidationErrorInternalServerError = InternalServerError | MagiclinkMutationValidationError | TranslateLocaleKeySuccessReponse;

export type TranslationKey = {
  __typename?: 'TranslationKey';
  keys: Array<LocaleKey>;
  namespace: Scalars['String']['output'];
};

export type TriggerCloseRoutesByDeadlineInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TriggerCloseRoutesByDeadlinePayload = {
  __typename?: 'TriggerCloseRoutesByDeadlinePayload';
  accepted: Scalars['Boolean']['output'];
  graphql_operation_id: Scalars['ID']['output'];
};

export type TriggerCloseRoutesByDeadlineResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | TriggerCloseRoutesByDeadlinePayload;

export enum TriggerType {
  Immediate = 'IMMEDIATE',
  OnEntryDate = 'ON_ENTRY_DATE',
  OnExitDate = 'ON_EXIT_DATE',
  OnUserCreate = 'ON_USER_CREATE'
}

export type TwilioWhatsappErrorResponse = {
  __typename?: 'TwilioWhatsappErrorResponse';
  error: Scalars['String']['output'];
  operation_id: Scalars['String']['output'];
};

export type TwilioWhatsappPayload = {
  __typename?: 'TwilioWhatsappPayload';
  info: Scalars['String']['output'];
  operation_id: Scalars['String']['output'];
};

export type TwilioWhatsappPayloadTwilioWhatsappErrorResponse = TwilioWhatsappErrorResponse | TwilioWhatsappPayload;

export enum TypeProcessOrganization {
  ClosedOpportunity = 'CLOSED_OPPORTUNITY',
  Demo = 'DEMO',
  Test = 'TEST'
}

export type UrlRecordType = LiveSessionRecordI & {
  __typename?: 'URLRecordType';
  file_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UnarchiveCopilotPlannerReportInput = {
  /** UUID del reporte del Planner Agent a restaurar. */
  report_id: Scalars['ID']['input'];
};

export type UnarchiveCopilotPlannerReportResult = CopilotPlannerReportUnarchivedPayload | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type UpdateAreaLevelResponse = {
  __typename?: 'UpdateAreaLevelResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type UpdateAvatarPayload = UsersGraphOperationI & {
  __typename?: 'UpdateAvatarPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<UserMetadataOuput>;
};

export type UpdateBlockPlayerByOrganizationCourseInput = {
  course_id: Scalars['Int']['input'];
  is_block_player_enabled: Scalars['Boolean']['input'];
  organization_id: Scalars['Int']['input'];
};

export type UpdateBlockPlayerByOrganizationCoursePayload = {
  __typename?: 'UpdateBlockPlayerByOrganizationCoursePayload';
  course_id: Scalars['Int']['output'];
  is_block_player_enabled: Scalars['Boolean']['output'];
  organization_id: Scalars['Int']['output'];
};

export type UpdateBlockPlayerByOrganizationCourseResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | UpdateBlockPlayerByOrganizationCoursePayload;

export type UpdateBlockPlayerByOrganizationInput = {
  activate_crehana_and_partner_courses?: InputMaybe<Scalars['Boolean']['input']>;
  activate_own_courses?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id: Scalars['Int']['input'];
};

export type UpdateBlockPlayerByOrganizationPayload = {
  __typename?: 'UpdateBlockPlayerByOrganizationPayload';
  activate_crehana_and_partner_courses?: Maybe<Scalars['Boolean']['output']>;
  activate_own_courses?: Maybe<Scalars['Boolean']['output']>;
  organization_id: Scalars['Int']['output'];
};

export type UpdateBlockPlayerByOrganizationResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | UpdateBlockPlayerByOrganizationPayload;

export type UpdateCatalogInput = {
  benefit_visibility_scope?: BenefitViewScopeEnum;
  catalog_benefit_state?: CatalogBenefitStateEnum;
};

export type UpdateCatalogSettingsInput = {
  catalog: UpdateCatalogInput;
  centralized_organization_id: Scalars['ID']['input'];
};

export type UpdateCategoryPayload = {
  __typename?: 'UpdateCategoryPayload';
  category?: Maybe<KnowledgeHubCategoryType>;
  updated: Scalars['Boolean']['output'];
};

export type UpdateCategoryResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | UpdateCategoryPayload;

export type UpdateCategoryRestrictionPayload = {
  __typename?: 'UpdateCategoryRestrictionPayload';
  updated: Scalars['Boolean']['output'];
};

export type UpdateCategoryRestrictionResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | UpdateCategoryRestrictionPayload;

export type UpdateConfigurationAreaAndHeadquarterResponse = {
  __typename?: 'UpdateConfigurationAreaAndHeadquarterResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type UpdateConfigurationAreaInput = {
  id: Scalars['Int']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConfigurationHeadquarterInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  is_active_all?: InputMaybe<Scalars['Boolean']['input']>;
  is_main?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateContentByCourseInput = {
  course_id: Scalars['Int']['input'];
  list_category_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  visibility_level: VisibilityLevelType;
};

export type UpdateContentDocumentResponse = AdminUpdateContentDocumentPayload | MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError;

export type UpdateContentInput = {
  content_id: Scalars['ID']['input'];
  content_type: ContentType;
  document_input?: InputMaybe<UpdateOrganizationDocumentInput>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateContentOrganizationTeamInput = {
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Si es true, elimina explicitamente la fecha limite de la ruta (absoluta o relativa) y limpia el vencimiento de todos los colaboradores. Mutuamente excluyente con end_date y expiration_time_in_days. */
  clear_deadline?: InputMaybe<Scalars['Boolean']['input']>;
  /** Requisitos de completitud de la ruta (epic CELC-4900). Reemplaza por completo la configuracion anterior: omitirlo conserva la regla guardada y enviarlo con los tres requisitos apagados se rechaza (debe quedar al menos uno activo). Cada requisito activo se evalua con mayor o igual contra su minimo y todos deben cumplirse. El alcance retroactivo se expresa con el campo enrollment_scope de este mismo input. La regla guardada vuelve en organization_team.completion_rule de la respuesta. */
  completion_requirements?: InputMaybe<TrackCompletionRequirementsInput>;
  /** Confirmacion explicita requerida para cerrar una ruta Abierta con generate_certificate=False (no emitira ningun certificado). Por defecto True: aun no existe UI de confirmacion en el front (mejora futura); el cliente puede mandar False de forma explicita para reactivar el bloqueo. */
  confirm_close_without_certificate?: InputMaybe<Scalars['Boolean']['input']>;
  courses_dependencies?: InputMaybe<Array<CreateOrUpdateCourseTeamDependenceInput>>;
  cover_image_id?: InputMaybe<Scalars['Int']['input']>;
  cover_image_url?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Team end date in ISO format (YYYY-MM-DD) */
  end_date?: InputMaybe<Scalars['Date']['input']>;
  /** Optional cohort scope for an active-route content edit (NEW_AND_IN_PROGRESS | ALL_ENROLLED). Persisted on the change log; defaults to NEW_AND_IN_PROGRESS server-side when omitted. */
  enrollment_scope?: InputMaybe<EnrollmentScopeEnum>;
  expiration_time_in_days?: InputMaybe<Scalars['Int']['input']>;
  /** Si la ruta entrega certificado. Omitirlo conserva el valor guardado y no lo modifica. Una vez activada la ruta esta config es inmutable: mandar un valor distinto al guardado se rechaza. */
  generate_certificate?: InputMaybe<Scalars['Boolean']['input']>;
  is_active_course_dependencies?: InputMaybe<Scalars['Boolean']['input']>;
  is_draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cierre/reapertura manual de una ruta Abierta: CLOSE o REOPEN. Si se omite, no se cambia el estado de cierre (edicion normal). */
  manual_close_action?: InputMaybe<TrackManualCloseActionEnum>;
  /** Modalidad de la ruta: STANDARD (Estandar) u OPEN (Abierta). Si se omite, no se cambia la modalidad actual de la ruta. */
  modality?: InputMaybe<TrackModalityEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_team_courses?: InputMaybe<Array<ContentOrganizationTeamCourseType>>;
  organization_team_id: Scalars['Int']['input'];
  /** One resolution per removed prerequisite course (REMOVE_FROM_SET or REPLACE). Required when the removal affects an active prerequisite rule; ignored when ENABLE_TRACK_PREREQ_EDITING is off. */
  prerequisite_resolutions?: InputMaybe<Array<PrerequisiteResolutionInput>>;
  /** Ids de categorias (kh_category) elegibles para el reward de la ruta. Omitido/None = no modificar; [] = sin restriccion (catalogo de reward completo). */
  reward_eligible_category_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  rewards_numbers?: InputMaybe<Scalars['Int']['input']>;
  /** Team start date in ISO format (YYYY-MM-DD) */
  start_date?: InputMaybe<Scalars['Date']['input']>;
  visibility_level?: InputMaybe<VisibilityLevelType>;
};

export type UpdateContentPayload = {
  __typename?: 'UpdateContentPayload';
  content?: Maybe<KnowledgeHubContentType>;
};

export type UpdateContentResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | UpdateContentPayload;

export type UpdateContractInput = {
  absence_integration?: InputMaybe<Scalars['Boolean']['input']>;
  base_salary?: InputMaybe<Scalars['Decimal']['input']>;
  centralized_org_unit_ref?: InputMaybe<Scalars['String']['input']>;
  centralized_position_ref?: InputMaybe<Scalars['String']['input']>;
  change_reason: Scalars['String']['input'];
  clabe?: InputMaybe<Scalars['String']['input']>;
  contract_id: Scalars['UUID']['input'];
  contract_type?: InputMaybe<ContractTypeEnum>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  imss_employee_type?: InputMaybe<ImssEmployeeTypeEnum>;
  imss_medical_unit_id?: InputMaybe<Scalars['Int']['input']>;
  imss_number?: InputMaybe<Scalars['String']['input']>;
  imss_registration_date?: InputMaybe<Scalars['Date']['input']>;
  imss_salary_type?: InputMaybe<ImssSalaryTypeEnum>;
  imss_shift_type?: InputMaybe<ImssShiftTypeEnum>;
  isr_table_type?: InputMaybe<Scalars['Int']['input']>;
  labor_regime?: InputMaybe<LaborRegimeEnum>;
  last_movement_type?: InputMaybe<ImssLastMovementTypeEnum>;
  last_salary_movement_date?: InputMaybe<Scalars['Date']['input']>;
  legal_entity_id: Scalars['UUID']['input'];
  manager_ref?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<PaymentMethodEnum>;
  payroll_bank_code?: InputMaybe<Scalars['String']['input']>;
  pays_overtime?: InputMaybe<Scalars['Boolean']['input']>;
  pension_type?: InputMaybe<PensionTypeEnum>;
  prior_seniority_years?: InputMaybe<Scalars['Int']['input']>;
  sar_bank_code?: InputMaybe<Scalars['String']['input']>;
  shift_hours?: InputMaybe<Scalars['Int']['input']>;
  shift_type?: InputMaybe<ContractShiftTypeEnum>;
  sicoss_period_id?: InputMaybe<Scalars['Int']['input']>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
  unionized?: InputMaybe<Scalars['Boolean']['input']>;
  vacation_days?: InputMaybe<Scalars['Int']['input']>;
  work_center_ref?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractResponse = {
  __typename?: 'UpdateContractResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: EmployeeContractType;
};

export type UpdateContractResult = InternalErrorResponse | NotFoundErrorResponse | UpdateContractResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type UpdateConversationInput = {
  chat_conversation_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
  pin_conversation?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomFieldChoiceInput = {
  action: CrudActionEnum;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateCustomFieldInput = {
  can_edit: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  is_mandatory: Scalars['Boolean']['input'];
  is_visible: Scalars['Boolean']['input'];
  max_length?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  type: CustomFieldTypeEnum;
  where_mandatory?: InputMaybe<CustomFieldMandatoryEnum>;
};

export type UpdateCustomFieldResponse = {
  __typename?: 'UpdateCustomFieldResponse';
  custom_field?: Maybe<CustomFieldNode>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type UpdateCustomFieldResponseApi = {
  __typename?: 'UpdateCustomFieldResponseApi';
  custom_field?: Maybe<CustomFieldNode>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type UpdateDefaultOrganizationTemplateInput = {
  is_default: Scalars['Boolean']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  organization_template_id: Scalars['Int']['input'];
};

export type UpdateDispersionAccountInput = {
  /** Nuevo número de cuenta, máximo 20 dígitos. */
  account_number?: InputMaybe<Scalars['String']['input']>;
  /** Nuevo tipo de cuenta: 'principal' o 'secondary'. */
  account_type?: InputMaybe<Scalars['String']['input']>;
  /** Nuevo ID de banco. Debe existir si se envía. */
  bank_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID de la organización centralizada (owner). */
  centralized_organization_id: Scalars['ID']['input'];
  /** Nueva CLABE de 18 dígitos numéricos. */
  clabe?: InputMaybe<Scalars['String']['input']>;
  /** ID de la cuenta de dispersión a actualizar. */
  id: Scalars['ID']['input'];
  /** ID de la razón social a la que pertenece la cuenta. */
  legal_entity_id: Scalars['ID']['input'];
  /** Nueva lista de IDs de periodos de pago (reemplaza la existente). */
  pay_period_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Nueva referencia de pago, máximo 80 caracteres. Omitir o enviar null conserva la actual; enviar cadena vacía la limpia. */
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDispersionAccountResponse = DispersionAccountResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Success payload for update_employee_contact mutation. */
export type UpdateEmployeeContactPayload = {
  __typename?: 'UpdateEmployeeContactPayload';
  /** The updated contact. */
  contact: EmployeeContactNode;
};

/** Union response for update_employee_contact mutation. */
export type UpdateEmployeeContactResponse = IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | UpdateEmployeeContactPayload | ValidationErrorResponse;

export type UpdateEmployeeDependentInput = {
  birth_date?: InputMaybe<Scalars['Date']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<DependentGenderEnum>;
  id: Scalars['ID']['input'];
  is_economic_dependent?: InputMaybe<Scalars['Boolean']['input']>;
  is_emergency_contact?: InputMaybe<Scalars['Boolean']['input']>;
  last_name_1?: InputMaybe<Scalars['String']['input']>;
  last_name_2?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  relationship_type?: InputMaybe<DependentRelationshipTypeEnum>;
};

export type UpdateEmployeeDependentResult = EmployeeDependentResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Success payload for update_employee_personal_info mutation. */
export type UpdateEmployeePersonalInfoPayload = {
  __typename?: 'UpdateEmployeePersonalInfoPayload';
  /** Short personal bio. */
  about_me?: Maybe<Scalars['String']['output']>;
  /** Home or mailing address. */
  address?: Maybe<Scalars['String']['output']>;
  /** Age in years, computed from birthday_date. Null if birthday_date is not set. */
  age?: Maybe<Scalars['Int']['output']>;
  /** Present only when incorporation_date changed but balance recalculation was not applied immediately (HRIS-3981, AC-1/AC-2) — explains why, and that a time-off admin must apply it from the balance screen. */
  balance_recalculation_message?: Maybe<Scalars['String']['output']>;
  /** Country of birth (name). Read-only — not modifiable via mutation. */
  birth_country?: Maybe<Scalars['String']['output']>;
  /** Country of birth (3-letter ISO code). Read-only — not modifiable via mutation. */
  birth_country_code?: Maybe<Scalars['String']['output']>;
  /** Date of birth. */
  birthday_date?: Maybe<Scalars['DateTime']['output']>;
  /** Civil/marital status. */
  civil_status?: Maybe<CivilStatusEnum>;
  /** Country of residence (name). Read-only — not modifiable via mutation. */
  country?: Maybe<Scalars['String']['output']>;
  /** Country of residence (3-letter ISO code). Read-only — not modifiable via mutation. */
  country_code?: Maybe<Scalars['String']['output']>;
  /** Identification document number. */
  document?: Maybe<Scalars['String']['output']>;
  /** Type of identification document. */
  document_type?: Maybe<DocumentTypeEnum>;
  /** Primary email address. Read-only — not modifiable via mutation. */
  email: Scalars['String']['output'];
  /** First name. */
  firstname: Scalars['String']['output'];
  /** Fiscal/tax ID (RFC for Mexico, free text for other countries). */
  fiscal_id?: Maybe<Scalars['String']['output']>;
  /** Gender. Read-only — not modifiable via mutation. */
  gender?: Maybe<GenderEnum>;
  /** Whether the employee has a declared disability. */
  has_disability?: Maybe<Scalars['Boolean']['output']>;
  /** Date the employee joined the organization. */
  incorporation_date?: Maybe<Scalars['DateTime']['output']>;
  /** Primary last name (apellido paterno). */
  lastname: Scalars['String']['output'];
  /** Date the employee left or will leave the organization. */
  leaving_date?: Maybe<Scalars['DateTime']['output']>;
  /** LinkedIn profile URL. */
  linkedin_url?: Maybe<Scalars['String']['output']>;
  /** Medical fitness status (occupational health evaluation result). */
  medical_fitness?: Maybe<MedicalFitnessEnum>;
  /** Personal (non-work) email address. */
  personal_email?: Maybe<Scalars['String']['output']>;
  /** Landline phone number. */
  phone_1?: Maybe<Scalars['String']['output']>;
  /** Cellphone number. */
  phone_2?: Maybe<Scalars['String']['output']>;
  /** Second last name (apellido materno). */
  second_lastname?: Maybe<Scalars['String']['output']>;
  /** Centralized user ID. */
  user_id: Scalars['Int']['output'];
  /** Username used for login. */
  username?: Maybe<Scalars['String']['output']>;
  /** Personal website URL. */
  web_site_url?: Maybe<Scalars['String']['output']>;
};

/** Union response for update_employee_personal_info mutation. */
export type UpdateEmployeePersonalInfoResponse = IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | UpdateEmployeePersonalInfoPayload | ValidationErrorResponse;

export type UpdateEmployerRegistrationInput = {
  centralized_organization_id: Scalars['ID']['input'];
  economic_activity_code?: InputMaybe<Scalars['String']['input']>;
  economic_activity_description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** Contenido del archivo `.cer` de la e.firma en base64, tal como lo entrega el SAT. */
  idse_cer_file?: InputMaybe<Scalars['String']['input']>;
  /** Contrasena de la e.firma. Es la misma que protege la llave privada del .key, asi que sirve para el formato nuevo sin campo aparte. */
  idse_efirma_password?: InputMaybe<Scalars['String']['input']>;
  /** Contenido del archivo `.key` de la e.firma en base64, tal como lo entrega el SAT. Va cifrado con `idse_efirma_password`. */
  idse_key_file?: InputMaybe<Scalars['String']['input']>;
  /** Contrasena con que el usuario operara ante Terra (`pwdUsuario`). De 3 a 20 caracteres: letras sin acentos, numeros, guion, punto y guion bajo, sin espacios, y no puede empezar con guion, punto ni guion bajo. Se valida al capturarla y se guarda cifrada. */
  idse_password?: InputMaybe<Scalars['String']['input']>;
  /** Usuario IDSE del cliente. Se guarda porque otros servicios lo necesitan, pero **no viaja al proveedor**: Terra no tiene campo de nombre de usuario, la identidad del usuario es el GUID que devuelve. */
  idse_username?: InputMaybe<Scalars['String']['input']>;
  imss_subdelegation_id?: InputMaybe<Scalars['ID']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  legal_entity_id?: InputMaybe<Scalars['ID']['input']>;
  registration_number?: InputMaybe<Scalars['String']['input']>;
  risk_class_id?: InputMaybe<Scalars['ID']['input']>;
  risk_data_expiration_date?: InputMaybe<Scalars['Date']['input']>;
  risk_fraction?: InputMaybe<Scalars['Decimal']['input']>;
  risk_premium?: InputMaybe<Scalars['Decimal']['input']>;
  salary_zone_id?: InputMaybe<Scalars['ID']['input']>;
  work_center_location_type?: InputMaybe<PayrollWorkCenterLocationType>;
  work_locations?: InputMaybe<Array<PayrollWorkLocationInput>>;
};

export type UpdateEmployerRegistrationResponse = EmployerRegistrationResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type UpdateEnrollmentInput = {
  course_id: Scalars['Int']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateEnrollmentMutation = {
  __typename?: 'UpdateEnrollmentMutation';
  fix_course_progress: EnrollmentResponse;
};


export type UpdateEnrollmentMutationFix_Course_ProgressArgs = {
  input: UpdateEnrollmentInput;
};

export type UpdateEvaluationCardAttributeInputType = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  is_deleted?: Scalars['Boolean']['input'];
  order: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type UpdateEvaluationCardScaleInputType = {
  icon_type: AtsEvaluationCardScaleTypeEnum;
  scale_options: Array<UpdateScaleOptionInputType>;
};

export type UpdateFederalEntityInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFederalEntityResponse = FederalEntityResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Partial update of a government credit. Only the provided fields change; omitting one leaves the stored value untouched. Credit type and employee are not editable, and status has its own operation. */
export type UpdateGovernmentCreditInput = {
  charges_damage_insurance?: InputMaybe<Scalars['Boolean']['input']>;
  credit_id: Scalars['ID']['input'];
  credit_number?: InputMaybe<Scalars['String']['input']>;
  damage_insurance_charge_on?: InputMaybe<Scalars['String']['input']>;
  discount_type?: InputMaybe<Scalars['String']['input']>;
  discount_value?: InputMaybe<Scalars['Float']['input']>;
  installment_amount?: InputMaybe<Scalars['Float']['input']>;
  installments?: InputMaybe<Scalars['Int']['input']>;
  installments_paid_before?: InputMaybe<Scalars['Int']['input']>;
  legal_entity_id: Scalars['ID']['input'];
  start_date?: InputMaybe<Scalars['String']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateGovernmentCreditResult = GovernmentCreditItemResponse | InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type UpdateHeadquarterInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  is_main: Scalars['Boolean']['input'];
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHoliday = {
  end_date: Scalars['Date']['input'];
  holiday_id: Scalars['ID']['input'];
  holiday_rules?: InputMaybe<Array<UpdateHolidayRule>>;
  is_recurrent?: InputMaybe<Scalars['Boolean']['input']>;
  is_restricted: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  recurrent_type?: InputMaybe<HolidayRecurrentTypeEnum>;
  start_date: Scalars['Date']['input'];
};

export type UpdateHolidayInput = {
  centralized_organization_id: Scalars['ID']['input'];
  holiday: UpdateHoliday;
};

export type UpdateHolidayResponse = {
  __typename?: 'UpdateHolidayResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type UpdateHolidayRule = {
  data_type: SegmentationDataTypeEnum;
  field_id?: InputMaybe<Scalars['ID']['input']>;
  values: Array<UpdateHolidayRuleValue>;
};

export type UpdateHolidayRuleValue = {
  operation: SegmentationConditionalEnum;
  value: Array<Scalars['String']['input']>;
};

export type UpdateImssMovementIdseStatusInput = {
  error_detail?: InputMaybe<Scalars['String']['input']>;
  idse_status: Scalars['String']['input'];
  legal_entity_id: Scalars['UUID']['input'];
  movement_id: Scalars['UUID']['input'];
};

export type UpdateImssMovementIdseStatusResponse = {
  __typename?: 'UpdateImssMovementIdseStatusResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: ImssMovementDetail;
};

export type UpdateImssMovementIdseStatusResult = InternalErrorResponse | NotFoundErrorResponse | UpdateImssMovementIdseStatusResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type UpdateImssMovementInput = {
  daily_salary?: InputMaybe<Scalars['Decimal']['input']>;
  department_ref?: InputMaybe<Scalars['String']['input']>;
  family_medicine_unit?: InputMaybe<Scalars['Int']['input']>;
  imss_salary_type?: InputMaybe<Scalars['Int']['input']>;
  legal_entity_id: Scalars['UUID']['input'];
  movement_date?: InputMaybe<Scalars['Date']['input']>;
  movement_id: Scalars['UUID']['input'];
  position_ref?: InputMaybe<Scalars['String']['input']>;
  reason_code?: InputMaybe<Scalars['String']['input']>;
  reduced_schedule?: InputMaybe<Scalars['Int']['input']>;
  sdi?: InputMaybe<Scalars['Decimal']['input']>;
  shift_type?: InputMaybe<Scalars['Int']['input']>;
  work_center_ref?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateImssMovementResponse = {
  __typename?: 'UpdateImssMovementResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: ImssMovementDetail;
};

export type UpdateImssMovementResult = InternalErrorResponse | NotFoundErrorResponse | UpdateImssMovementResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type UpdateJobInputs = {
  batch_id: Scalars['Int']['input'];
};

export type UpdateLegalEntityInput = {
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  address_3?: InputMaybe<Scalars['String']['input']>;
  bank_id?: InputMaybe<Scalars['ID']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  clabe_account?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  currency_code?: InputMaybe<Scalars['String']['input']>;
  fiscal_address_override?: InputMaybe<Scalars['String']['input']>;
  fiscal_contact_email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  internal_id?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  repse_number?: InputMaybe<Scalars['String']['input']>;
  social_object?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  tax_id?: InputMaybe<Scalars['String']['input']>;
  tax_regime_id?: InputMaybe<Scalars['ID']['input']>;
  tax_type?: InputMaybe<Scalars['String']['input']>;
  trade_name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLegalEntityResponse = CentralizedLegalEntityResponse | ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | LegalEntityResponse | NotAuthenticatedErrorResponse | NotFoundResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type UpdateLiveSessionVideoClassInput = {
  live_session_data: BasicLiveSessionInput;
  live_session_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
  video_lecture_id: Scalars['ID']['input'];
};

export type UpdateMarketplaceConfigResponse = {
  __typename?: 'UpdateMarketplaceConfigResponse';
  error?: Maybe<ErrorResponse>;
  marketplace_config?: Maybe<MarketplaceConfigNode>;
  success: Scalars['Boolean']['output'];
};

export type UpdateMenuCustomizationInput = {
  items: Array<MenuCustomizationItemInput>;
  organization_id: Scalars['Int']['input'];
  panel: MenuPanelType;
};

export type UpdateOAuthClientInput = {
  allowed_scopes?: InputMaybe<Array<Scalars['String']['input']>>;
  client_id: Scalars['String']['input'];
  client_name?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  redirect_uris?: InputMaybe<Array<Scalars['String']['input']>>;
  token_endpoint_auth_method?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrCreateScormInput = {
  file_v1_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  scorm_version?: InputMaybe<ScormDataVersion>;
  video_lecture_id: Scalars['ID']['input'];
};

export type UpdateOrganization = {
  industry_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationArea = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type UpdateOrganizationAreaInput = {
  area: UpdateOrganizationArea;
  organization_id: Scalars['Int']['input'];
};

export type UpdateOrganizationAreaLevelInput = {
  /** Organization Area Level ID */
  id: Scalars['Int']['input'];
  /** Organization Area Level Name */
  name: Scalars['String']['input'];
};

export type UpdateOrganizationAreaResponse = {
  __typename?: 'UpdateOrganizationAreaResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationCategoryInput = {
  category_id: Scalars['ID']['input'];
  image_file_id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  visibility_level?: InputMaybe<VisibilityLevelType>;
};

export type UpdateOrganizationConfigInput = {
  crehana_content_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  enable_catalog?: InputMaybe<Scalars['Boolean']['input']>;
  leader_can_assign_content?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  third_party_content_allowed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrganizationConfigurationPayload = {
  __typename?: 'UpdateOrganizationConfigurationPayload';
  updated: Scalars['Boolean']['output'];
};

export type UpdateOrganizationConfigurationResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | UpdateOrganizationConfigurationPayload;

export type UpdateOrganizationDocumentInput = {
  action?: InputMaybe<DocumentActionEnum>;
  description: Scalars['String']['input'];
  list_category_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  visibility_level: VisibilityLevelType;
};

export type UpdateOrganizationHeadquarterResponse = {
  __typename?: 'UpdateOrganizationHeadquarterResponse';
  headquarter?: Maybe<OrganizationHeadquarterNode>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationPositionResponse = CentralizedUpdateOrganizationPositionPayload | ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse;

export type UpdateOrganizationTeamCourseResponse = DataFieldsSent | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type UpdateOrganizationTeamPayload = {
  __typename?: 'UpdateOrganizationTeamPayload';
  organization_team?: Maybe<OrganizationTeamAdminNode>;
  /** Non-blocking warnings about a locked course now preceding one of its prerequisites after a reorder (CELC-4680 CA5). Always present and empty by default, independent of ENABLE_TRACK_PREREQ_EDITING. */
  prerequisite_order_warnings: Array<PrerequisiteOrderWarning>;
};

export type UpdateOrganizationTenantBrandingColors = {
  raw_data: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

export type UpdateOrganizationTenantBrandingImage = {
  file_id: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};

export type UpdateOrganizationTenantBrandingInput = {
  brand_colors?: InputMaybe<UpdateOrganizationTenantBrandingColors>;
  image_favicon?: InputMaybe<UpdateOrganizationTenantBrandingImage>;
  image_isotype?: InputMaybe<UpdateOrganizationTenantBrandingImage>;
  image_logo?: InputMaybe<UpdateOrganizationTenantBrandingImage>;
  image_page_login_hero?: InputMaybe<UpdateOrganizationTenantBrandingImage>;
};

export type UpdateOrganizationTenantBrandingMutationInput = {
  branding_input: UpdateOrganizationTenantBrandingInput;
  centralized_organization_id: Scalars['Int']['input'];
};

export type UpdatePasswordPolicyInput = {
  centralized_organization_id: Scalars['ID']['input'];
  force_change_for_existing_users?: Scalars['Boolean']['input'];
  min_length: Scalars['Int']['input'];
  require_special_chars: Scalars['Boolean']['input'];
  require_uppercase_and_numbers: Scalars['Boolean']['input'];
};

export type UpdatePasswordPolicyPayload = {
  __typename?: 'UpdatePasswordPolicyPayload';
  policy: PasswordPolicyType;
  users_marked_for_force_change: Scalars['Int']['output'];
};

export type UpdatePasswordPolicyPayloadSecurityMutationErrorInternalServerMutationError = InternalServerMutationError | SecurityMutationError | UpdatePasswordPolicyPayload;

export type UpdatePayrollEmployeeInput = {
  absence_integration?: InputMaybe<Scalars['Boolean']['input']>;
  accounting_account?: InputMaybe<Scalars['String']['input']>;
  annual_isr_adjustment?: InputMaybe<Scalars['Boolean']['input']>;
  bank_account_number?: InputMaybe<Scalars['String']['input']>;
  bank_branch_number?: InputMaybe<Scalars['Int']['input']>;
  bank_plaza_code?: InputMaybe<Scalars['Int']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
  clabe?: InputMaybe<Scalars['String']['input']>;
  contributes_imss?: InputMaybe<Scalars['Boolean']['input']>;
  contributes_infonavit?: InputMaybe<Scalars['Boolean']['input']>;
  contributes_retirement?: InputMaybe<Scalars['Boolean']['input']>;
  curp?: InputMaybe<Scalars['String']['input']>;
  fonacot_number?: InputMaybe<Scalars['String']['input']>;
  has_disability?: InputMaybe<Scalars['Boolean']['input']>;
  imss?: InputMaybe<Scalars['String']['input']>;
  imss_medical_unit?: InputMaybe<Scalars['Int']['input']>;
  imss_month_type?: InputMaybe<Scalars['Boolean']['input']>;
  isr_table_type?: InputMaybe<Scalars['Int']['input']>;
  last_paid_date?: InputMaybe<Scalars['Date']['input']>;
  legal_entity_id: Scalars['ID']['input'];
  medical_fitness?: InputMaybe<Scalars['String']['input']>;
  payment_location_code?: InputMaybe<Scalars['String']['input']>;
  payment_type?: InputMaybe<Scalars['Int']['input']>;
  payroll_bank_code?: InputMaybe<Scalars['String']['input']>;
  payroll_month_type?: InputMaybe<Scalars['Boolean']['input']>;
  pays_overtime?: InputMaybe<Scalars['Boolean']['input']>;
  pension_type?: InputMaybe<Scalars['Int']['input']>;
  prior_seniority_years?: InputMaybe<Scalars['Int']['input']>;
  reports_to_sicoss_id?: InputMaybe<Scalars['String']['input']>;
  rfc?: InputMaybe<Scalars['String']['input']>;
  sar_bank_code?: InputMaybe<Scalars['String']['input']>;
  sicoss_card_number?: InputMaybe<Scalars['String']['input']>;
  sicoss_employee_number?: InputMaybe<Scalars['String']['input']>;
  time_clock_id?: InputMaybe<Scalars['Int']['input']>;
  union_id?: InputMaybe<Scalars['Int']['input']>;
  vacation_days?: InputMaybe<Scalars['Int']['input']>;
  valuation?: InputMaybe<Scalars['Int']['input']>;
  working_hours_per_day?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePayrollEmployeeResult = InternalErrorResponse | PayrollEmployeeResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type UpdatePayrollIncidenceResult = InternalErrorResponse | NotFoundErrorResponse | PayrollIncidence | UserPermissionErrorResponse | ValidationErrorResponse;

export type UpdatePidActivitiesStateInput = {
  activities_id_list: Array<Scalars['Int']['input']>;
  state: DiPemployeeState;
};

export type UpdatePidActivitiesStateResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | SuccessType;

export type UpdatePolicy = {
  /** Accumulation */
  accumulation?: InputMaybe<PolicyAccumulation>;
  /** Allow Discount Half Day */
  allow_discount_half_day?: Scalars['Boolean']['input'];
  /** Allow Negative Values */
  allow_negative_values: Scalars['Boolean']['input'];
  /** Auto Resolvable Time Days */
  auto_resolvable_time_days?: InputMaybe<Scalars['Int']['input']>;
  /** Policy Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** First Period Delay Months */
  first_period_delay_months?: InputMaybe<Scalars['Int']['input']>;
  /** Has Deferred First Period */
  has_deferred_first_period?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has Rule By Age */
  has_rule_by_age: Scalars['Boolean']['input'];
  /** Has Time Limit To Use */
  has_time_limit_to_use: Scalars['Boolean']['input'];
  /** Policy Instructions */
  instructions?: InputMaybe<Scalars['String']['input']>;
  /** Is Apply Max Balance Accumulated */
  is_apply_max_balance_accumulated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Auto Resolvable */
  is_auto_resolvable?: InputMaybe<PolicyIsAutoResolvable>;
  /** Is Max Negative Accumulable */
  is_max_negative_accumulable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Max Time Transferable */
  is_max_time_transferable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Negative Value Next Period */
  is_negative_value_next_period?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Policy Paid */
  is_paid?: Scalars['Boolean']['input'];
  /** Is Restricted */
  is_restricted?: Scalars['Boolean']['input'];
  /** Is Time Expirable */
  is_time_expirable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Transferable */
  is_transferable: Scalars['Boolean']['input'];
  /** Is Policy Unlimited */
  is_unlimited: Scalars['Boolean']['input'];
  /** Max Balance Accumulated Value */
  max_balance_accumulated_value?: InputMaybe<Scalars['Int']['input']>;
  /** Max Negative Accumulable Value */
  max_negative_accumulable_value?: InputMaybe<Scalars['Int']['input']>;
  /** Max Time */
  max_time: Scalars['Float']['input'];
  /** Max Time Transferable Value */
  max_time_transferable_value?: InputMaybe<Scalars['Int']['input']>;
  /** Min Time */
  min_time: Scalars['Float']['input'];
  /** Policy Name */
  name: Scalars['String']['input'];
  /** Needs Approvals */
  needs_approvals: Scalars['Boolean']['input'];
  /** Needs Leader Approval */
  needs_leader_approval?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow Overlap Holidays */
  overlap_holidays?: Scalars['Boolean']['input'];
  /** Policy Days */
  policy_days: UpdatePolicyDays;
  policy_rules?: InputMaybe<Array<GenericConditionalInput>>;
  /** Policy Rules By Age */
  policy_rules_by_age?: InputMaybe<Array<UpdatePolicyRuleByAge>>;
  /** Policy Type ID */
  policy_type_id: Scalars['ID']['input'];
  /** Policy Approvers */
  policy_user_approvers?: InputMaybe<Array<UpdatePolicyApprover>>;
  /** Quantification */
  quantification: PolicyQuantification;
  /** Renovation */
  renovation?: InputMaybe<PolicyRenovation>;
  /** Renovation Day */
  renovation_day?: InputMaybe<Scalars['Int']['input']>;
  /** Renovation Granularity, required when renovation is BIRTHDAY */
  renovation_granularity?: InputMaybe<PolicyRenovationGranularity>;
  /** Renovation Month */
  renovation_month?: InputMaybe<Scalars['Int']['input']>;
  /** Start Accumulation Days */
  start_accumulation_days?: InputMaybe<Scalars['Int']['input']>;
  /** Time Distribution */
  time_distribution?: InputMaybe<PolicyTimeDistribution>;
  /** Time Distribution Frequency */
  time_distribution_frecuency?: InputMaybe<PolicyTimeDistributionFrequency>;
  /** Time Expirable Conditional */
  time_expirable_conditional?: InputMaybe<PolicyTimeExpirableConditional>;
  /** Time Expirable Period */
  time_expirable_period?: InputMaybe<PolicyTimeExpirablePeriod>;
  /** Time Expirable Value */
  time_expirable_value?: InputMaybe<Scalars['Int']['input']>;
  /** Time Limit To Use Days */
  time_limit_to_use_days?: InputMaybe<Scalars['Int']['input']>;
  /** Total Time */
  total_value?: InputMaybe<Scalars['Int']['input']>;
  /** Working Hours */
  working_hours: Scalars['Int']['input'];
};

export type UpdatePolicyApprover = {
  centralized_user_id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};

export type UpdatePolicyApproverV2 = {
  centralized_user_id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};

export type UpdatePolicyDays = {
  friday: Scalars['Boolean']['input'];
  monday: Scalars['Boolean']['input'];
  saturday: Scalars['Boolean']['input'];
  sunday: Scalars['Boolean']['input'];
  thursday: Scalars['Boolean']['input'];
  tuesday: Scalars['Boolean']['input'];
  wednesday: Scalars['Boolean']['input'];
};

export type UpdatePolicyDaysV2 = {
  friday: Scalars['Boolean']['input'];
  monday: Scalars['Boolean']['input'];
  saturday: Scalars['Boolean']['input'];
  sunday: Scalars['Boolean']['input'];
  thursday: Scalars['Boolean']['input'];
  tuesday: Scalars['Boolean']['input'];
  wednesday: Scalars['Boolean']['input'];
};

export type UpdatePolicyInput = {
  centralized_organization_id: Scalars['ID']['input'];
  policy: UpdatePolicy;
  policy_id: Scalars['ID']['input'];
};

export type UpdatePolicyResponse = {
  __typename?: 'UpdatePolicyResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type UpdatePolicyRuleByAge = {
  /** Conditional */
  conditional: PolicyRuleByAgeConditional;
  /** Days */
  days: Scalars['Int']['input'];
  /** Years */
  years: Scalars['Int']['input'];
};

export type UpdatePolicyRuleByAgeV2 = {
  /** Action: add or remove */
  conditional: PolicyRuleByAgeConditional;
  /** Days to add/remove (≥0.5) */
  days: Scalars['Float']['input'];
  /** Anniversary number (≥1, unique, ordered) */
  years: Scalars['Int']['input'];
};

export type UpdatePolicyV2 = {
  /** Accumulation */
  accumulation?: InputMaybe<PolicyAccumulation>;
  /** Allow Discount Half Day */
  allow_discount_half_day?: Scalars['Boolean']['input'];
  /** Allow Negative Values */
  allow_negative_values: Scalars['Boolean']['input'];
  /** Auto Resolvable Time Days */
  auto_resolvable_time_days?: InputMaybe<Scalars['Int']['input']>;
  /** ISO 3166-1 alpha-2 country code (e.g. 'PE'). Activates the matching legal profile for (country, policy_type), if one exists. Omit the field to leave the current country untouched; send null to clear it. */
  country_code?: InputMaybe<Scalars['String']['input']>;
  /** Policy Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** First Period Delay Months */
  first_period_delay_months?: InputMaybe<Scalars['Int']['input']>;
  /** Has Deferred First Period */
  has_deferred_first_period?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has Rule By Age */
  has_rule_by_age: Scalars['Boolean']['input'];
  /** Has Time Limit To Use */
  has_time_limit_to_use: Scalars['Boolean']['input'];
  /** Policy Instructions */
  instructions?: InputMaybe<Scalars['String']['input']>;
  /** Is Apply Max Balance Accumulated */
  is_apply_max_balance_accumulated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Auto Resolvable */
  is_auto_resolvable?: InputMaybe<PolicyIsAutoResolvable>;
  /** Is Max Negative Accumulable */
  is_max_negative_accumulable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Max Time Transferable */
  is_max_time_transferable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Negative Value Next Period */
  is_negative_value_next_period?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Policy Paid */
  is_paid?: Scalars['Boolean']['input'];
  /** Is Restricted */
  is_restricted?: Scalars['Boolean']['input'];
  /** Is Time Expirable */
  is_time_expirable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is Transferable */
  is_transferable: Scalars['Boolean']['input'];
  /** Is Policy Unlimited */
  is_unlimited: Scalars['Boolean']['input'];
  /** Max Balance Accumulated Value */
  max_balance_accumulated_value?: InputMaybe<Scalars['Int']['input']>;
  /** Max Negative Accumulable Value */
  max_negative_accumulable_value?: InputMaybe<Scalars['Int']['input']>;
  /** Max Time (0=unlimited, >0=limited) */
  max_time: Scalars['Float']['input'];
  /** Max Time Transferable Value */
  max_time_transferable_value?: InputMaybe<Scalars['Int']['input']>;
  /** Min Time (>0) */
  min_time: Scalars['Float']['input'];
  /** Policy Name */
  name: Scalars['String']['input'];
  /** Needs Approvals */
  needs_approvals: Scalars['Boolean']['input'];
  /** Needs Leader Approval */
  needs_leader_approval?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow Overlap Holidays */
  overlap_holidays?: Scalars['Boolean']['input'];
  /** Policy Days */
  policy_days: UpdatePolicyDaysV2;
  policy_rules?: InputMaybe<Array<GenericConditionalInput>>;
  /** V2: Policy Rules By Age with enhanced validation */
  policy_rules_by_age?: InputMaybe<Array<UpdatePolicyRuleByAgeV2>>;
  /** Policy Type ID */
  policy_type_id: Scalars['ID']['input'];
  /** Policy Approvers */
  policy_user_approvers?: InputMaybe<Array<UpdatePolicyApproverV2>>;
  /** Quantification */
  quantification: PolicyQuantification;
  /** Renovation */
  renovation?: InputMaybe<PolicyRenovation>;
  /** Renovation Day */
  renovation_day?: InputMaybe<Scalars['Int']['input']>;
  /** Renovation Granularity, required when renovation is BIRTHDAY */
  renovation_granularity?: InputMaybe<PolicyRenovationGranularity>;
  /** Renovation Month */
  renovation_month?: InputMaybe<Scalars['Int']['input']>;
  /** V2: How age rules apply (intervals or specific years) */
  rule_by_age_application_mode?: InputMaybe<PolicyRuleByAgeApplicationModeEnum>;
  /** V2: Whether age rules are cumulative */
  rule_by_age_is_cumulative?: InputMaybe<Scalars['Boolean']['input']>;
  /** SAT disability type (Mexico only): '01' work risk, '02' general illness. Omit the field to leave the current type untouched; send null to clear it. */
  sat_disability_type?: InputMaybe<PolicySatDisabilityTypeEnum>;
  /** Start Accumulation Days */
  start_accumulation_days?: InputMaybe<Scalars['Int']['input']>;
  /** Time Distribution */
  time_distribution?: InputMaybe<PolicyTimeDistribution>;
  /** Time Distribution Frequency */
  time_distribution_frecuency?: InputMaybe<PolicyTimeDistributionFrequency>;
  /** Time Expirable Conditional */
  time_expirable_conditional?: InputMaybe<PolicyTimeExpirableConditional>;
  /** Time Expirable Period */
  time_expirable_period?: InputMaybe<PolicyTimeExpirablePeriod>;
  /** Time Expirable Value */
  time_expirable_value?: InputMaybe<Scalars['Int']['input']>;
  /** Time Limit To Use Days */
  time_limit_to_use_days?: InputMaybe<Scalars['Int']['input']>;
  /** Total Time */
  total_value?: InputMaybe<Scalars['Int']['input']>;
  /** Working Hours */
  working_hours: Scalars['Int']['input'];
};

export type UpdatePolicyV2Input = {
  centralized_organization_id: Scalars['ID']['input'];
  policy: UpdatePolicyV2;
  policy_id: Scalars['ID']['input'];
};

export type UpdateProductIsDraftInput = {
  is_draft: Scalars['Boolean']['input'];
  product_id: Scalars['Int']['input'];
};

export type UpdateProductIsDraftResponse = {
  __typename?: 'UpdateProductIsDraftResponse';
  error?: Maybe<ErrorResponse>;
  product?: Maybe<Product>;
  success: Scalars['Boolean']['output'];
};

export type UpdateQuestionInput = {
  attachment_id?: InputMaybe<Scalars['Int']['input']>;
  default_answer_order: AnswerFieldEnum;
  feedback_text?: InputMaybe<Scalars['String']['input']>;
  help_text?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  question_help_text?: InputMaybe<Scalars['String']['input']>;
  question_id: Scalars['ID']['input'];
  question_text: Scalars['String']['input'];
  question_type: QuizQuestionTypeEnum;
  related_video_lecture_id?: InputMaybe<Scalars['ID']['input']>;
  value_percentage?: InputMaybe<Scalars['Float']['input']>;
  value_points?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRiskClassInput = {
  class_code?: InputMaybe<Scalars['String']['input']>;
  class_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateRiskClassResponse = InternalErrorResponse | RiskClassResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type UpdateSaml2ClaimInput = {
  attribute_name?: InputMaybe<Scalars['String']['input']>;
  attribute_value_source?: InputMaybe<Scalars['String']['input']>;
  claim_id: Scalars['ID']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSaml2IdpConfigurationInput = {
  centralized_organization_id: Scalars['ID']['input'];
  entity_id?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name_id_format?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSaml2ServiceProviderInput = {
  acs_url?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name_id_format?: InputMaybe<Scalars['String']['input']>;
  name_id_source?: InputMaybe<Scalars['String']['input']>;
  service_provider_id: Scalars['ID']['input'];
  slo_url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSaml2SpConfigurationInput = {
  acs_url?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['ID']['input'];
  entity_id?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  sign_requests?: InputMaybe<Scalars['Boolean']['input']>;
  slo_url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSaml2TrustedIdpInput = {
  certificate?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name_id_format?: InputMaybe<Scalars['String']['input']>;
  slo_url?: InputMaybe<Scalars['String']['input']>;
  sso_url?: InputMaybe<Scalars['String']['input']>;
  trusted_idp_id: Scalars['ID']['input'];
};

export type UpdateScaleOptionInputType = {
  id?: InputMaybe<Scalars['Int']['input']>;
  label: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type UpdateScormDataPayload = {
  __typename?: 'UpdateScormDataPayload';
  graphql_operation_id: Scalars['ID']['output'];
  user_scorm_data: UserScormData;
};

export type UpdateScormDataPayloadMutationInternalError = MutationInternalError | UpdateScormDataPayload;

export type UpdateScormOptionsInput = {
  completion_method: ScormOptionsCompletionMethodEnum;
  video_lecture_id: Scalars['ID']['input'];
};

export type UpdateScormOptionsPayload = {
  __typename?: 'UpdateScormOptionsPayload';
  graphql_operation_id: Scalars['ID']['output'];
  scorm_options: ScormOptions;
};

export type UpdateScormOptionsPayloadMutationInternalError = MutationInternalError | UpdateScormOptionsPayload;

export type UpdateSegmentsInput = {
  attributes: CreateSegmentsInput;
  user_segment_id: Scalars['Int']['input'];
};

export type UpdateStatusFileMutation = {
  __typename?: 'UpdateStatusFileMutation';
  /** ToDelete */
  update_status: UpdateStatusFileResponse;
};


export type UpdateStatusFileMutationUpdate_StatusArgs = {
  input: UpdateStatusInputs;
};

export type UpdateStatusFileResponse = AnotherFile | ApplicationFile | AudioFile | ImageFile | ResponseIntegrityError | ResponseInternalError | ResponseValidationError | VideoFile;

export type UpdateStatusInputs = {
  centralized_id?: InputMaybe<Scalars['Int']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  file_id: Scalars['Int']['input'];
  new_status: FileStorageStatusEnum;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTaxRegimeInput = {
  id: Scalars['ID']['input'];
  tax_regime_code?: InputMaybe<Scalars['String']['input']>;
  tax_regime_name?: InputMaybe<Scalars['String']['input']>;
  tax_type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaxRegimeResponse = CentralizedTaxRegimeResponse | ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | TaxRegimeResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type UpdateTeamHeaderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  segmentation_type?: InputMaybe<TeamSegmentationTypeEnum>;
};

export type UpdateTeamResponse = {
  __typename?: 'UpdateTeamResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type UpdateTemplateDocumentInput = {
  centralized_organization_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  editor_state: Scalars['JSON']['input'];
  folder_id?: InputMaybe<Scalars['Int']['input']>;
  format: HrisDocumentPageFormatInput;
  html: Scalars['String']['input'];
  name: Scalars['String']['input'];
  segmentation_rules?: InputMaybe<Array<GenericConditionalInput>>;
  template_id: Scalars['Int']['input'];
  visibility?: DocumentTemplateVisibility;
  wildcards: Array<HrisDocumentTemplateWildcardInput>;
};

export type UpdateTrackOrganizationTemplateInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  organization_template_id: Scalars['Int']['input'];
  track_id: Scalars['Int']['input'];
  track_organization_template_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserAvatarInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
  file_id: Scalars['ID']['input'];
};

/** Input for updating user course watch time */
export type UpdateUserCourseWatchTimeInput = {
  /** ID of the course */
  course_id: Scalars['Int']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Time in seconds to add to the accumulated watch time */
  time_duration: Scalars['Int']['input'];
  /** ID of the user */
  user_id: Scalars['Int']['input'];
  /** ID of the video lecture */
  video_lecture_id: Scalars['Int']['input'];
};

export type UpdateUserCourseWatchTimePayload = {
  __typename?: 'UpdateUserCourseWatchTimePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  user_course_watch_time?: Maybe<UserCourseWatchTimeType>;
};

export type UpdateUserCourseWatchTimeResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | UpdateUserCourseWatchTimePayload;

export type UpdateUserCustomFieldInput = {
  choice_id?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  type: CustomFieldTypeEnum;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserCustomFieldResponse = {
  __typename?: 'UpdateUserCustomFieldResponse';
  custom_fields?: Maybe<Array<CustomFieldValueNode>>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserEmailResponse = {
  __typename?: 'UpdateUserEmailResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserInfoInput = {
  centralized_organization_id: Scalars['ID']['input'];
  centralized_user_id: Scalars['ID']['input'];
  input: UserProfileUpdateInput;
};

export type UpdateUserInfoPayload = UsersGraphOperationI & {
  __typename?: 'UpdateUserInfoPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<UserMetadataOuput>;
};

export type UpdateUserInfoResponse = CentralizedIntegrityError | CentralizedInternalError | CentralizedValidationError | UpdateUserInfoPayload;

export type UpdateUserProductSuitesInput = {
  /** Organization the user belongs to */
  centralized_organization_id: Scalars['Int']['input'];
  /** Suite codes to assign to the user (e.g. ['TALENT']). Empty list = no assignments. */
  suites_to_assign: Array<Scalars['String']['input']>;
  /** Suite codes to revoke from the user. Empty list = no revocations. */
  suites_to_revoke: Array<Scalars['String']['input']>;
  /** User whose licenses will be updated */
  user_id: Scalars['Int']['input'];
};

export type UpdateUserProductSuitesPayload = {
  __typename?: 'UpdateUserProductSuitesPayload';
  /** Suite codes that were assigned in this operation */
  assigned_suite_codes: Array<Scalars['String']['output']>;
  /** All active product suite licenses for the user after the operation */
  product_suites: Array<UserProductSuiteNode>;
  /** Suite codes that were revoked in this operation */
  revoked_suite_codes: Array<Scalars['String']['output']>;
};

export type UpdateUserProductSuitesResponse = InternalErrorResponse | NotAuthenticatedErrorResponse | UpdateUserProductSuitesPayload | ValidationErrorResponse;

export type UpdateUserQuizFormInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  quiz_form_id: Scalars['ID']['input'];
  reason_fail?: InputMaybe<Scalars['String']['input']>;
  total_seconds?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUsernamePayload = {
  __typename?: 'UpdateUsernamePayload';
  full_username: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

export type UpdateUsernamePayloadSecurityMutationError = SecurityMutationError | UpdateUsernamePayload;

export type UpdateVideoLectureInput = {
  ignore_cache?: Scalars['Boolean']['input'];
  organization_id: Scalars['ID']['input'];
  video_lectures: Array<VideoLectureUpdateInput>;
};

export type UpdateVideoProcessInput = {
  status: VideoProcessStatusEnum;
  user_id?: InputMaybe<Scalars['ID']['input']>;
  video_process_uid: Scalars['ID']['input'];
};

export type UpdateWorkFlowInput = {
  centralized_organization_id: Scalars['ID']['input'];
  conditionals: Array<WorkFlowConditionalInput>;
  detail: CreateWorkflowDetail;
  workflow: WorkflowInput;
  workflow_id: Scalars['ID']['input'];
};

export type UpdateWorkFlowResponse = {
  __typename?: 'UpdateWorkFlowResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type UploadCsdCertificateInput = {
  centralized_organization_id: Scalars['ID']['input'];
  cer_file: Scalars['String']['input'];
  key_file: Scalars['String']['input'];
  legal_entity_id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
};

export type UploadCsdCertificateResult = CsdStatusResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type UploadDispersionLayoutFileInput = {
  /** ID de la organización centralizada (owner). */
  centralized_organization_id: Scalars['ID']['input'];
  /** ID de la cuenta de dispersión con configuración existente. */
  dispersion_account_id: Scalars['ID']['input'];
  /** Contenido del archivo de layout en base64 (.txt/.csv/.xlsx, máx 5 MB). */
  file_base64: Scalars['String']['input'];
  /** Nombre original del archivo, usado para validar la extensión. */
  file_name: Scalars['String']['input'];
  /** ID de la razón social a la que pertenece la cuenta. */
  legal_entity_id: Scalars['ID']['input'];
};

export type UploadDispersionLayoutFileResponse = DispersionLayoutConfigResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Carga de la e.firma de un registro patronal, en el formato en que la entrega el SAT: el `.cer` y el `.key` por separado. **El PFX ya no se admite** (PAYR-654): Terra solo acepta ese par, y convertir un PFX obligaria a re-cifrar la llave privada con un formato que el proveedor podria no leer. */
export type UploadEfirmaInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Contenido del archivo `.cer` en base64. */
  cer_file?: InputMaybe<Scalars['String']['input']>;
  /** Contrasena de la llave privada. Es obligatoria: el `.key` de una e.firma viene cifrado y sin ella no hay llave que usar. */
  efirma_password: Scalars['String']['input'];
  employer_registration_id: Scalars['ID']['input'];
  /** Contenido del archivo `.key` en base64, tal como lo entrega el SAT. */
  key_file?: InputMaybe<Scalars['String']['input']>;
};

/** El estado IDSE con el intento de registro recien asentado. `EmployerRegistrationResponse` se conserva en el union por compatibilidad: ninguna carga lo devuelve desde PAYR-654. */
export type UploadEfirmaResult = EmployerRegistrationResponse | InternalErrorResponse | TerraIdseCertificateRegistrationResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type UploadFileMutation = {
  __typename?: 'UploadFileMutation';
  generate_presigned: AddFileResponse;
};


export type UploadFileMutationGenerate_PresignedArgs = {
  input: UploadFilePreSignedUrlInput;
};

export type UploadFilePreSignedUrlInput = {
  bucket: BucketsEnum;
  centralized_id?: InputMaybe<Scalars['Int']['input']>;
  centralized_organization_id?: InputMaybe<Scalars['ID']['input']>;
  company_id?: InputMaybe<Scalars['Int']['input']>;
  content_type: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filepath?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFileUserApplicationDocumentInput = {
  centralized_organization_id: Scalars['Int']['input'];
  file_id: Scalars['Int']['input'];
  uploaded_format?: InputMaybe<DocumentFileFormatEnum>;
  user_document_id: Scalars['Int']['input'];
};

export type UploadFileV1Input = {
  content_type: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export enum UploadStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Partial = 'PARTIAL',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type UploadTemplateResponse = {
  __typename?: 'UploadTemplateResponse';
  success: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export enum UploadToEnum {
  MarketplaceConfigLogo = 'MARKETPLACE_CONFIG_LOGO',
  ProductCoverImage = 'PRODUCT_COVER_IMAGE'
}

export type UploadedFileV1Input = {
  id: Scalars['ID']['input'];
  is_pdf_lecture?: InputMaybe<Scalars['Boolean']['input']>;
  is_scorm?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadedFileV1Payload = {
  __typename?: 'UploadedFileV1Payload';
  file: ImageFileV1TypeMediaFileV1Type;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type UploadedFileV1Response = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | UploadedFileV1Payload;

export type UrlNode = {
  __typename?: 'UrlNode';
  absolute_url: Scalars['String']['output'];
  relative_url: Scalars['String']['output'];
};

export type UrlPresignedS3Payload = {
  __typename?: 'UrlPresignedS3Payload';
  url?: Maybe<Scalars['String']['output']>;
};

export type UrlType = {
  __typename?: 'UrlType';
  absolute_url: Scalars['String']['output'];
  relative_url?: Maybe<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  allowed_user?: Maybe<AllowedUserNode>;
  date_joined: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  enrollments: Scalars['Int']['output'];
  first_name: Scalars['String']['output'];
  has_organization?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_organization?: Maybe<Scalars['Boolean']['output']>;
  is_organization_admin?: Maybe<Scalars['Boolean']['output']>;
  last_activity?: Maybe<Scalars['DateTime']['output']>;
  last_login?: Maybe<Scalars['DateTime']['output']>;
  last_name: Scalars['String']['output'];
  occupation: Scalars['String']['output'];
  organization_id?: Maybe<Scalars['Int']['output']>;
  profile_picture_absolute_url: Scalars['String']['output'];
  profile_picture_url: Scalars['String']['output'];
  segmentation: Scalars['Int']['output'];
  username: Scalars['String']['output'];
};

export type UserAchievementFragmentConnection = {
  __typename?: 'UserAchievementFragmentConnection';
  /** Contains the nodes in this connection */
  edges: Array<AdminAchievementFragmentNodeEdgeUserAchievementFragmentNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type UserAchievementFragmentNode = IUserAchievementNode & {
  __typename?: 'UserAchievementFragmentNode';
  achievement_completed: Scalars['Boolean']['output'];
  event?: Maybe<UserCurrencyEventFragmentNode>;
};

export type UserAchievementFragmentNodeEdge = {
  __typename?: 'UserAchievementFragmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserAchievementFragmentNode;
};

export type UserActivationInput = {
  organization_slug: Scalars['String']['input'];
  users_ids: Array<Scalars['Int']['input']>;
};

export type UserActivationResponse = {
  __typename?: 'UserActivationResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  users_failed: Array<Scalars['Int']['output']>;
  users_success: Array<Scalars['Int']['output']>;
};

export type UserActivitiesDataListConnection = {
  __typename?: 'UserActivitiesDataListConnection';
  edges: Array<UserActivitiesDataTypeEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type UserActivitiesDataType = {
  __typename?: 'UserActivitiesDataType';
  accomplishment_percentage?: Maybe<Scalars['Int']['output']>;
  activities_count: Scalars['Int']['output'];
  activities_to_approve: Array<Scalars['Int']['output']>;
  activities_to_follow: Array<Scalars['Int']['output']>;
  boss_follow_tracks: BossFollowTracksType;
  boss_progress_percentage?: Maybe<Scalars['Int']['output']>;
  employee_id: Scalars['Int']['output'];
  job: Scalars['String']['output'];
  my_tracks: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  points: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserActivitiesDataTypeEdge = {
  __typename?: 'UserActivitiesDataTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserActivitiesDataType;
};

export type UserAlreadyRegisteredErrorType = {
  __typename?: 'UserAlreadyRegisteredErrorType';
  email?: Maybe<Scalars['String']['output']>;
  error_detail: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type UserAssignedByCourseResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | UserCourseInfoConnection;

export type UserAssignedCourseInfo = {
  __typename?: 'UserAssignedCourseInfo';
  avatar?: Maybe<Scalars['String']['output']>;
  centralized_user_id: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  is_certified?: Maybe<Scalars['Boolean']['output']>;
  last_name: Scalars['String']['output'];
  progress: Scalars['Float']['output'];
};

/** A connection to a list of items. */
export type UserAssignedCourseInfoConnection = {
  __typename?: 'UserAssignedCourseInfoConnection';
  /** Contains the nodes in this connection */
  edges: Array<UserAssignedCourseInfoEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserAssignedCourseInfoEdge = {
  __typename?: 'UserAssignedCourseInfoEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserAssignedCourseInfo;
};

export type UserAssignedCourseResponse = FoundationLeaderIntegrityError | FoundationLeaderInternalError | FoundationLeaderValidationError | UserAssignedCourseInfoConnection;

export type UserAssignmentsActionInput = {
  allow_all_users?: Scalars['Boolean']['input'];
  organization_id: Scalars['ID']['input'];
  progressive?: InputMaybe<ProgressiveAssignmentInput>;
};

export type UserAutomationRule = {
  __typename?: 'UserAutomationRule';
  user?: Maybe<User>;
  user_id: Scalars['ID']['output'];
};

export type UserAutomationRuleFragment = UserEligibleForAutomationRuleType | UserInAutomationRuleType;

export type UserAutomationRuleFragmentPaginationEdge = {
  __typename?: 'UserAutomationRuleFragmentPaginationEdge';
  /** The item at the end of the edge. */
  node: UserAutomationRuleFragment;
};

export type UserChangeAutogeneratePasswordInput = {
  organization_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};

export type UserChangeChangeUsernameInput = {
  organization_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserChangePasswordInput = {
  confirm_password: Scalars['String']['input'];
  force_change_password?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum UserConfigurationLanguageEnum {
  LanguageEn = 'LANGUAGE_EN',
  LanguageEs = 'LANGUAGE_ES',
  LanguagePt = 'LANGUAGE_PT'
}

export type UserConfigurationType = {
  __typename?: 'UserConfigurationType';
  centralized_organization_id: Scalars['Int']['output'];
  centralized_user_id: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  language: UserConfigurationLanguageEnum;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type UserCounter = {
  __typename?: 'UserCounter';
  total_count: Scalars['Int']['output'];
  user_list: Array<User>;
};

export type UserCourseInfo = {
  __typename?: 'UserCourseInfo';
  avatar?: Maybe<Scalars['String']['output']>;
  centralized_user_id: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  is_certified?: Maybe<Scalars['Boolean']['output']>;
  last_name: Scalars['String']['output'];
  progress: Scalars['Float']['output'];
};

/** A connection to a list of items. */
export type UserCourseInfoConnection = {
  __typename?: 'UserCourseInfoConnection';
  /** Contains the nodes in this connection */
  edges: Array<UserCourseInfoEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserCourseInfoEdge = {
  __typename?: 'UserCourseInfoEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserCourseInfo;
};

export type UserCourseTeamDependenceDependsOnNode = {
  __typename?: 'UserCourseTeamDependenceDependsOnNode';
  courses: Array<UserCourseTeamDependenceRuleNode>;
  organization_team_id: Scalars['Int']['output'];
};

export type UserCourseTeamDependenceNode = {
  __typename?: 'UserCourseTeamDependenceNode';
  course: Course;
  course_id: Scalars['Int']['output'];
  depends_on: Array<UserCourseTeamDependenceDependsOnNode>;
  is_unlocked: Scalars['Boolean']['output'];
};

export type UserCourseTeamDependenceRuleNode = {
  __typename?: 'UserCourseTeamDependenceRuleNode';
  course: Course;
  course_id: Scalars['Int']['output'];
  is_unlocked: Scalars['Boolean']['output'];
};

/** User course watch time record */
export type UserCourseWatchTimeType = {
  __typename?: 'UserCourseWatchTimeType';
  course_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  organization_id: Scalars['Int']['output'];
  time_duration: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
  video_lecture_id: Scalars['Int']['output'];
};

export type UserCreateAtRangeType = {
  __typename?: 'UserCreateAtRangeType';
  end_datetime?: Maybe<TimeStampType>;
  start_datetime?: Maybe<TimeStampType>;
};

export type UserCreationDateRangeInput = {
  end_datetime?: InputMaybe<Scalars['DateTime']['input']>;
  start_datetime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserCurrencyEventConnection = {
  __typename?: 'UserCurrencyEventConnection';
  /** Contains the nodes in this connection */
  edges: Array<UserCurrencyEventNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type UserCurrencyEventFragmentNode = ICurrencyEventNode & IGamificationNode & {
  __typename?: 'UserCurrencyEventFragmentNode';
  background_color?: Maybe<Scalars['String']['output']>;
  currency_point_id?: Maybe<Scalars['Int']['output']>;
  custom_description?: Maybe<Scalars['String']['output']>;
  custom_name: Scalars['String']['output'];
  custom_text?: Maybe<Scalars['String']['output']>;
  event_id?: Maybe<Scalars['Int']['output']>;
  /** EventName related to the CurrencyEvent's Event */
  event_subject?: Maybe<Scalars['String']['output']>;
  event_type_enum?: Maybe<EventTypeEnum>;
  icon?: Maybe<ImageNode>;
  id: Scalars['ID']['output'];
  is_custom_event: Scalars['Boolean']['output'];
  organization_id?: Maybe<Scalars['ID']['output']>;
  url_redirect?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type UserCurrencyEventFragmentNodeEdge = {
  __typename?: 'UserCurrencyEventFragmentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserCurrencyEventFragmentNode;
};

export type UserCurrencyEventListType = {
  __typename?: 'UserCurrencyEventListType';
  items: Array<UserCurrencyEventType>;
  metadata: Scalars['JSON']['output'];
};

/** This node presents an user achievement */
export type UserCurrencyEventNode = {
  __typename?: 'UserCurrencyEventNode';
  event?: Maybe<CurrencyEventNode>;
  event_completed: Scalars['Boolean']['output'];
};

export type UserCurrencyEventNodeEdge = {
  __typename?: 'UserCurrencyEventNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserCurrencyEventNode;
};

export type UserCurrencyEventType = ICurrencyEventType & {
  __typename?: 'UserCurrencyEventType';
  custom_description?: Maybe<Scalars['String']['output']>;
  custom_name?: Maybe<Scalars['String']['output']>;
  custom_text?: Maybe<Scalars['String']['output']>;
  event_type_enum?: Maybe<EventTypeEnum>;
  icon?: Maybe<ImageNode>;
  settings?: Maybe<Scalars['JSON']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type UserCurrencyPointFragment = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | UserCurrencyPointType;

/** Node for organization user. */
export type UserCurrencyPointNode = ICurrencyPointNode & IGamificationNode & {
  __typename?: 'UserCurrencyPointNode';
  /** List of achievements associated with a currency point */
  achievements: CurrencyEventFragmentConnection;
  currency_point_config?: Maybe<AdminCurrencyPointConfigNode>;
  /** List of events associated with a currency point */
  events: CurrencyEventFragmentConnection;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['ID']['output']>;
  rewards: RewardFragmentConnection;
};


/** Node for organization user. */
export type UserCurrencyPointNodeAchievementsArgs = {
  query_variables?: InputMaybe<CurrencyEventQueryInput>;
};


/** Node for organization user. */
export type UserCurrencyPointNodeEventsArgs = {
  query_variables?: InputMaybe<CurrencyEventQueryInput>;
};


/** Node for organization user. */
export type UserCurrencyPointNodeRewardsArgs = {
  query_variables?: InputMaybe<RewardQueryInput>;
};

export type UserCurrencyPointNodeEdge = {
  __typename?: 'UserCurrencyPointNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserCurrencyPointNode;
};

export type UserCurrencyPointType = ICurrencyPointType & {
  __typename?: 'UserCurrencyPointType';
  events: UserCurrencyEventListType;
  name?: Maybe<Scalars['String']['output']>;
  status_enum?: Maybe<CurrencyPointStatusEnum>;
};


export type UserCurrencyPointTypeEventsArgs = {
  input: QueryCurrencyEventInput;
};

export type UserCustomFieldSelectedTag = {
  __typename?: 'UserCustomFieldSelectedTag';
  answer: Scalars['String']['output'];
  custom_field_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type UserData = {
  __typename?: 'UserData';
  organization_id: Scalars['ID']['output'];
  user_id: Scalars['ID']['output'];
  user_organization_id: Scalars['ID']['output'];
};

export type UserDeactivateError = {
  __typename?: 'UserDeactivateError';
  email: Scalars['String']['output'];
  error: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
};

export type UserDeviceMutationNode = {
  __typename?: 'UserDeviceMutationNode';
  /**
   * This object contains information about the response code,
   *         response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
  user_device?: Maybe<UserDeviceNode>;
};

export type UserDeviceNode = {
  __typename?: 'UserDeviceNode';
  app_version?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  device: Scalars['String']['output'];
  device_identifier: Scalars['String']['output'];
  firebase_instance_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  last_active?: Maybe<Scalars['DateTime']['output']>;
  platform: Scalars['String']['output'];
  sdk_version?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user_device_id: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
};

/** Subgraph HRIS - User Document Info Node */
export type UserDocumentInfoNode = {
  __typename?: 'UserDocumentInfoNode';
  /** User Avatar ID */
  avatar_id?: Maybe<Scalars['Int']['output']>;
  /** User Avatar Info */
  avatar_info?: Maybe<File>;
  /** User Document Creation-Assignation Date */
  created_at: Scalars['String']['output'];
  /** User Document Deadline */
  deadline?: Maybe<Scalars['String']['output']>;
  /** Document File State */
  document_file_state: DocumentFileStateEnum;
  /** Document File ID */
  file_id?: Maybe<Scalars['Int']['output']>;
  /** Document File Info */
  file_info?: Maybe<File>;
  /** ID */
  id: Scalars['Int']['output'];
  /** Document Identifier */
  identifier: Scalars['String']['output'];
  /** Document uploaded format */
  uploaded_format?: Maybe<DocumentFileFormatEnum>;
  /** User Full Name */
  user_fullname: Scalars['String']['output'];
};

export type UserDocumentInfoNodeCustomConnection = {
  __typename?: 'UserDocumentInfoNodeCustomConnection';
  edges: Array<UserDocumentInfoNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type UserDocumentInfoNodeCustomEdge = {
  __typename?: 'UserDocumentInfoNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserDocumentInfoNode;
};

/** Subgraph HRIS - Document Info Node */
export type UserDocumentTemplateNode = {
  __typename?: 'UserDocumentTemplateNode';
  /** Document File ID */
  file_id?: Maybe<Scalars['Int']['output']>;
  /** Document File Info */
  file_info?: Maybe<File>;
  /** User Document ID */
  id: Scalars['Int']['output'];
};

export type UserEligibleForAutomationRuleType = SegmentedUserAutomationRuleI & {
  __typename?: 'UserEligibleForAutomationRuleType';
  user: UserAutomationRule;
  user_id: Scalars['ID']['output'];
  user_type: AutomationUserTypeEnum;
};

export type UserEventBankEditInput = {
  event_type?: InputMaybe<EventTypeEnum>;
  object_id?: InputMaybe<Scalars['Int']['input']>;
  object_type?: InputMaybe<ObjectTypeEnum>;
  organization_id: Scalars['String']['input'];
};

export type UserEventBankFragmentNode = IUserEventBankNode & {
  __typename?: 'UserEventBankFragmentNode';
  currency_event?: Maybe<Scalars['JSON']['output']>;
  current_event_value?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  notification_seen?: Maybe<Scalars['Boolean']['output']>;
  object_id?: Maybe<Scalars['Int']['output']>;
  object_type_enum?: Maybe<ObjectTypeEnum>;
  organization_id?: Maybe<Scalars['ID']['output']>;
};

export type UserEventBankMutationNode = {
  __typename?: 'UserEventBankMutationNode';
  /** Contains the nodes in this connection */
  edges?: Maybe<Array<UserEventBankNodeEdge>>;
  /**
   * This object contains information about the response code,
   *         response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UserEventBankNode = {
  __typename?: 'UserEventBankNode';
  /** The CurrencyEvent associated with the class */
  currency_event?: Maybe<CurrencyEventNode>;
  current_event_value: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  notification_seen: Scalars['Boolean']['output'];
  object_id?: Maybe<Scalars['Int']['output']>;
  object_type?: Maybe<ObjectTypeEnum>;
  /** User node */
  user?: Maybe<MyUserNode>;
};

export type UserEventBankNodeEdge = {
  __typename?: 'UserEventBankNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserEventBankNode;
};

export type UserEventBankQueryInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserSummaryOrderByInput>>;
  organization_id?: InputMaybe<Scalars['ID']['input']>;
  panel_admin?: InputMaybe<Scalars['Boolean']['input']>;
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum UserFieldsEnum {
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  FullName = 'FULL_NAME',
  Id = 'ID',
  LastName = 'LAST_NAME'
}

export type UserFilterByInput = {
  search_text?: InputMaybe<Scalars['String']['input']>;
  tags?: Array<Scalars['String']['input']>;
};

export type UserFilterInput = {
  field: UserFieldsEnum;
  value: Scalars['String']['input'];
};

export type UserFiltersInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  user_type?: InputMaybe<AutomationUserTypeEnum>;
};

/** Information of previous user imports */
export type UserImportsNode = {
  __typename?: 'UserImportsNode';
  /** Url to file uploaded */
  file_url: Scalars['String']['output'];
  /** Name of the file what was uploaded */
  filename: Scalars['String']['output'];
  original_id: Scalars['Int']['output'];
  /** Number of records successfully processed */
  records?: Maybe<Scalars['Int']['output']>;
  /** Number of records that failed when processed */
  records_error?: Maybe<Scalars['Int']['output']>;
  /** Number of records successfully processed */
  records_success?: Maybe<Scalars['Int']['output']>;
  /** Status of uploaded process */
  status: FileUploadStatus;
  /** Date when file was uploaded */
  uploaded_at?: Maybe<Scalars['DateTime']['output']>;
  user_email: Scalars['String']['output'];
  user_name: Scalars['String']['output'];
};

export type UserImportsNodeCustomConnection = {
  __typename?: 'UserImportsNodeCustomConnection';
  edges: Array<UserImportsNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type UserImportsNodeCustomEdge = {
  __typename?: 'UserImportsNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserImportsNode;
};

export type UserInAutomationRuleType = SegmentedUserAutomationRuleI & {
  __typename?: 'UserInAutomationRuleType';
  automation_rule_id: Scalars['ID']['output'];
  create_at: TimeStampType;
  id: Scalars['ID']['output'];
  user: UserAutomationRule;
  user_id: Scalars['ID']['output'];
  user_type: AutomationUserTypeEnum;
  version: Scalars['Int']['output'];
};

/** Represents a user and their status regarding segmentation conditionals. */
export type UserInSegment = {
  __typename?: 'UserInSegment';
  /** Returns the organizational areas associated with the user. */
  area?: Maybe<Scalars['String']['output']>;
  /** User's email address. */
  email: Scalars['String']['output'];
  /** User's first name. */
  full_name: Scalars['String']['output'];
  /** Indicates whether the user already belongs to a group. */
  has_group: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** Date the user joined the organization. */
  incorporation_date?: Maybe<Scalars['Date']['output']>;
  /** User's internal id in the learning platform (None if not provisioned in learning). */
  learning_user_id?: Maybe<Scalars['Int']['output']>;
  /** Date the user left the organization. */
  leaving_date?: Maybe<Scalars['Date']['output']>;
  /** Indicates whether the user matches the applied rules. */
  matches_rules: Scalars['Boolean']['output'];
  /** Returns the user's position within the organization. */
  position?: Maybe<OrganizationPositionNode>;
  /** User profile picture */
  profile_picture: CentralizedImageNode;
  user_id: Scalars['Int']['output'];
};

export type UserInactiveErrorType = {
  __typename?: 'UserInactiveErrorType';
  email?: Maybe<Scalars['String']['output']>;
  error_detail: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type UserInfoType = {
  __typename?: 'UserInfoType';
  email: Scalars['String']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  gender: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  profile_picture: GamificationImageType;
};

export type UserInvitationResponse = {
  __typename?: 'UserInvitationResponse';
  invalid_emails: Array<Scalars['String']['output']>;
  mail_not_sent: Array<Scalars['String']['output']>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type UserLearningPathInfo = {
  __typename?: 'UserLearningPathInfo';
  avatar?: Maybe<Scalars['String']['output']>;
  centralized_user_id: Scalars['ID']['output'];
  deadline?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  progress: Scalars['Float']['output'];
};

/** A connection to a list of items. */
export type UserLearningPathInfoConnection = {
  __typename?: 'UserLearningPathInfoConnection';
  /** Contains the nodes in this connection */
  edges: Array<UserLearningPathInfoEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserLearningPathInfoEdge = {
  __typename?: 'UserLearningPathInfoEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserLearningPathInfo;
};

export type UserLearningPathResponse = FoundationLeaderIntegrityError | FoundationLeaderInternalError | FoundationLeaderValidationError | UserLearningPathInfoConnection;

export type UserLiveSession = {
  __typename?: 'UserLiveSession';
  user?: Maybe<User>;
  user_id: Scalars['ID']['output'];
};

export type UserLiveSessionI = {
  has_participated: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  status: UserStatusEnum;
};

/** Detalle de sedes gestionadas por un usuario. */
export type UserManagedHeadquartersDetailPayload = {
  __typename?: 'UserManagedHeadquartersDetailPayload';
  /** Sedes gestionadas por el usuario, con su fecha de asignación. */
  headquarters: Array<ManagedHeadquarterDetailNode>;
  /** Cargo del usuario (misma forma que get_users_organization). */
  position?: Maybe<CentralizedPositionNode>;
  /** ID del usuario. */
  user_id: Scalars['Int']['output'];
};

export type UserManagedHeadquartersDetailPayloadNotAuthenticatedErrorResponseValidationErrorResponseInternalErrorResponse = InternalErrorResponse | NotAuthenticatedErrorResponse | UserManagedHeadquartersDetailPayload | ValidationErrorResponse;

export type UserMetadataOuput = {
  __typename?: 'UserMetadataOuput';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UserMetricsActivityNode = {
  __typename?: 'UserMetricsActivityNode';
  dates?: Maybe<Array<Scalars['String']['output']>>;
  days?: Maybe<Scalars['Int']['output']>;
  previous_days?: Maybe<Scalars['Int']['output']>;
};

export type UserMetricsCategoryNode = {
  __typename?: 'UserMetricsCategoryNode';
  name?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['Int']['output']>;
};

export type UserMetricsDetailNode = {
  __typename?: 'UserMetricsDetailNode';
  activity: UserMetricsActivityNode;
  category: Array<UserMetricsCategoryNode>;
  org_id?: Maybe<Scalars['Int']['output']>;
  progress: UserMetricsProgressNode;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type UserMetricsNode = {
  __typename?: 'UserMetricsNode';
  courses_organization_completed?: Maybe<Scalars['Int']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  metrics: UserMetricsDetailNode;
  org_id: Scalars['Int']['output'];
  projects?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  user?: Maybe<MetricsUser>;
};

export type UserMetricsProgressDatesNode = {
  __typename?: 'UserMetricsProgressDatesNode';
  day?: Maybe<Scalars['String']['output']>;
  previous_seconds?: Maybe<Scalars['Int']['output']>;
  seconds?: Maybe<Scalars['Int']['output']>;
};

export type UserMetricsProgressNode = {
  __typename?: 'UserMetricsProgressNode';
  dates?: Maybe<Array<UserMetricsProgressDatesNode>>;
  previous_seconds?: Maybe<Scalars['Int']['output']>;
  seconds?: Maybe<Scalars['Int']['output']>;
};

export type UserMetricsQuery = {
  __typename?: 'UserMetricsQuery';
  organization_metrics: OrganizationMetricsNode;
  user_detail: UserMetricsNode;
};


export type UserMetricsQueryOrganization_MetricsArgs = {
  slug: Scalars['String']['input'];
};


export type UserMetricsQueryUser_DetailArgs = {
  slug: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UserNode = {
  __typename?: 'UserNode';
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_name: Scalars['String']['output'];
  profile_picture: Scalars['String']['output'];
  profile_picture_url?: Maybe<ImageNode>;
  username: Scalars['String']['output'];
};

/** An edge in a connection. */
export type UserNodeEdge = {
  __typename?: 'UserNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserNode;
};

export type UserNotFoundErrorType = {
  __typename?: 'UserNotFoundErrorType';
  email?: Maybe<Scalars['String']['output']>;
  error_detail: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type UserNotificationConnection = {
  __typename?: 'UserNotificationConnection';
  edges: Array<UserNotificationNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
  /** A total count of the total number of notifications unread */
  total_unread?: Maybe<Scalars['Int']['output']>;
};

export type UserNotificationMutationNode = {
  __typename?: 'UserNotificationMutationNode';
  /**
   * This object contains information about the response code,
   *         response type and a descriptive message.
   */
  response?: Maybe<CoreResponseNode>;
  /** Indicates if the mutation has been executed correctly. */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** Contains an instance of the user notification model */
  user_notification?: Maybe<UserNotificationNode>;
};

export type UserNotificationNode = {
  __typename?: 'UserNotificationNode';
  created_at: Scalars['DateTime']['output'];
  created_timestamp?: Maybe<Scalars['Int']['output']>;
  icon_image?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  in_app_event?: Maybe<Scalars['String']['output']>;
  is_readed: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  /** Notification node */
  notification?: Maybe<NotificationNode>;
  notification_id: Scalars['String']['output'];
  readed_at?: Maybe<Scalars['DateTime']['output']>;
  redirect_url?: Maybe<Scalars['String']['output']>;
  redirect_url_name?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
};

export type UserNotificationNodeEdge = {
  __typename?: 'UserNotificationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserNotificationNode;
};

export type UserOrganization = {
  __typename?: 'UserOrganization';
  is_active: Scalars['Boolean']['output'];
  organization_id: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  user: User;
  user_id: Scalars['ID']['output'];
};

export type UserOrganizationActivationMutation = {
  __typename?: 'UserOrganizationActivationMutation';
  activate_learning_user: UserOrganizationMutationPayloadUserOrganizationValidationMutationErrorInternalServerMutationError;
};

export type UserOrganizationAuth = {
  __typename?: 'UserOrganizationAuth';
  auth_url: Scalars['String']['output'];
  organization: CrehanaAuthOrganization;
};

export type UserOrganizationDeactivationMutation = {
  __typename?: 'UserOrganizationDeactivationMutation';
  deactivate_learning_user: UserOrganizationDeactivationMutationPayloadInternalServerMutationError;
  massive_deactivate_learning_user: UserOrganizationDeactivationMutationPayloadInternalServerMutationError;
};


export type UserOrganizationDeactivationMutationDeactivate_Learning_UserArgs = {
  input: UserOrganizationDeactivationMutationInput;
};


export type UserOrganizationDeactivationMutationMassive_Deactivate_Learning_UserArgs = {
  input: Array<UserOrganizationDeactivationMutationInput>;
};

export type UserOrganizationDeactivationMutationInput = {
  organization_slug: Scalars['String']['input'];
  status: Scalars['Int']['input'];
  user_id: Scalars['Int']['input'];
};

export type UserOrganizationDeactivationMutationPayload = {
  __typename?: 'UserOrganizationDeactivationMutationPayload';
  error?: Maybe<Scalars['String']['output']>;
  response: Scalars['Boolean']['output'];
};

export type UserOrganizationDeactivationMutationPayloadInternalServerMutationError = InternalServerMutationError | UserOrganizationDeactivationMutationPayload;

export type UserOrganizationErrorNode = {
  __typename?: 'UserOrganizationErrorNode';
  email: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum UserOrganizationFilterTypeEnum {
  Select = 'select'
}

export type UserOrganizationInterface = {
  tags: UserTagsType;
  user: UserInfoType;
};

export type UserOrganizationMetrics = {
  __typename?: 'UserOrganizationMetrics';
  certified?: Maybe<Scalars['Int']['output']>;
  courses_assigned?: Maybe<Scalars['Int']['output']>;
  courses_completed?: Maybe<Scalars['Int']['output']>;
  courses_organization_assigned?: Maybe<Scalars['Int']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  hours_used?: Maybe<Scalars['String']['output']>;
  projects?: Maybe<Scalars['Int']['output']>;
  tracks_completed?: Maybe<Scalars['Int']['output']>;
  user: MetricsUser;
};

/** A connection to a list of items. */
export type UserOrganizationMetricsConnection = {
  __typename?: 'UserOrganizationMetricsConnection';
  /** Contains the nodes in this connection */
  edges: Array<UserOrganizationMetricsEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserOrganizationMetricsEdge = {
  __typename?: 'UserOrganizationMetricsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserOrganizationMetrics;
};

export type UserOrganizationMutation = {
  __typename?: 'UserOrganizationMutation';
  change_user_organization_email: ChangeUserOrganizationEmailPayloadUserOrganizationValidationMutationErrorInternalServerMutationError;
};


export type UserOrganizationMutationChange_User_Organization_EmailArgs = {
  input: ChangeUserOrganizationEmailMutationInput;
};

export type UserOrganizationMutationPayload = {
  __typename?: 'UserOrganizationMutationPayload';
  next_url?: Maybe<Scalars['String']['output']>;
  response: Scalars['Boolean']['output'];
};

export type UserOrganizationMutationPayloadUserOrganizationValidationMutationErrorInternalServerMutationError = InternalServerMutationError | UserOrganizationMutationPayload | UserOrganizationValidationMutationError;

export type UserOrganizationNode = {
  __typename?: 'UserOrganizationNode';
  id: Scalars['ID']['output'];
  status: Scalars['Int']['output'];
};

export type UserOrganizationPersonalizedFilter = {
  slug: Scalars['String']['input'];
  type: UserOrganizationFilterTypeEnum;
  value: Scalars['String']['input'];
};

export enum UserOrganizationRoleEnum {
  Admin = 'ADMIN',
  Leader = 'LEADER',
  Member = 'MEMBER',
  Subadmin = 'SUBADMIN'
}

export enum UserOrganizationRoleFilterEnum {
  Admin = 'ADMIN',
  Leader = 'LEADER',
  Member = 'MEMBER',
  Subadmin = 'SUBADMIN'
}

export enum UserOrganizationStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export enum UserOrganizationStatusInput {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export type UserOrganizationTeamConnection = {
  __typename?: 'UserOrganizationTeamConnection';
  /** Number of completed teams */
  completed_teams_count?: Maybe<Scalars['Int']['output']>;
  edges: Array<UserOrganizationTeamNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
  /** Number of total teams */
  total_teams_count?: Maybe<Scalars['Int']['output']>;
};

export type UserOrganizationTeamCourseSummaryNode = {
  __typename?: 'UserOrganizationTeamCourseSummaryNode';
  completed_courses?: Maybe<Scalars['Int']['output']>;
  completed_quiz_courses?: Maybe<Scalars['Int']['output']>;
  created_projects?: Maybe<Scalars['Int']['output']>;
  in_progress_courses?: Maybe<Scalars['Int']['output']>;
  is_completed: Scalars['Boolean']['output'];
  required_courses?: Maybe<Scalars['Int']['output']>;
  required_projects?: Maybe<Scalars['Int']['output']>;
  required_quiz_courses?: Maybe<Scalars['Int']['output']>;
  total_courses?: Maybe<Scalars['Int']['output']>;
};

export type UserOrganizationTeamInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  /** Id of the learning track (organization_team) the collaborator is asking about. The membership is always resolved from the session user: this input carries no user id. */
  organization_team_id: Scalars['Int']['input'];
};

export type UserOrganizationTeamNode = {
  __typename?: 'UserOrganizationTeamNode';
  academy_name?: Maybe<Scalars['String']['output']>;
  certificate?: Maybe<ContentCertificateNode>;
  /** Motivo del cierre que aplica al colaborador (CELC-4622/HU3, CELC-4984): MANUAL o DEADLINE. Si vencio su propio plazo se informa ese motivo; si no, el de la ruta. Null cuando no hay cierre, la bandera esta apagada o el valor guardado no se reconoce. */
  close_reason?: Maybe<TrackCloseReasonEnum>;
  coming_soon_courses_number?: Maybe<Scalars['Int']['output']>;
  /** Historial de altas y bajas de cursos aplicadas en la ruta del colaborador (CELC-4964): tipo de cambio, curso, fecha y admin autor. Solo cambios efectivamente aplicados; orden cronologico descendente. Lista vacia si la ruta no tuvo cambios desde la asignacion. */
  content_change_history: Array<CoursesContentChangeEntry>;
  /** Fecha de ultima modificacion del contenido de la ruta (alta/baja de cursos, reorden o cambio de obligatoriedad). Null si el contenido nunca se edito despues de crear la ruta (CELC-4822). */
  content_updated_at?: Maybe<Scalars['DateTime']['output']>;
  date_was_completed?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  in_progress_project?: Maybe<ProjectNode>;
  is_active: Scalars['Boolean']['output'];
  is_certified: Scalars['Boolean']['output'];
  /** Si el colaborador tiene el avance cerrado (CELC-4622/HU3, CELC-4984). True si la ruta completa esta cerrada o si vencio su propio plazo relativo. Un cierre sigue dejando la ruta visible, pero no admite avance en sus cursos. False sin cierre, sin config o con la bandera ENABLE_OPEN_TRACKS apagada. */
  is_closed: Scalars['Boolean']['output'];
  is_completed: Scalars['Boolean']['output'];
  /** Ultimo cierre vigente que aplica al colaborador: fecha, motivo y alcance (CELC-4618/HU7, CELC-4984). Si vencio su propio plazo se informa ese cierre con scope MEMBER; si no, el de la ruta con scope TRACK. Null si no hay cierre vigente, si la ruta se reabrio despues del ultimo cierre, o con la bandera ENABLE_OPEN_TRACKS apagada. */
  last_closure?: Maybe<TrackClosureNode>;
  organization_team: OrganizationTeamNode;
  /** Fecha del ultimo cambio de prerrequisitos de la ruta. Null si nunca se editaron, o con la bandera ENABLE_TRACK_PREREQ_EDITING apagada (CELC-4686). Paridad exacta con el nodo de admin; NO se gatea por ENABLE_OPEN_TRACKS. */
  prereqs_updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Detalle del ultimo cambio de prerrequisitos que afecta al colaborador: banner, listas antes/despues y proximo curso bloqueado (CELC-4686). Null sin cambio relevante para este colaborador, o con la bandera ENABLE_TRACK_PREREQ_EDITING apagada. */
  prerequisite_change?: Maybe<PrerequisiteChangeState>;
  progress: Scalars['Int']['output'];
  team_courses: Array<ContentOrganizationTeamCourseNode>;
  team_id: Scalars['Int']['output'];
  team_name?: Maybe<Scalars['String']['output']>;
  user_organization_team_summary: UserOrganizationTeamCourseSummaryNode;
  user_reward?: Maybe<UserTeamRewardNode>;
};

/** An edge in a connection. */
export type UserOrganizationTeamNodeEdge = {
  __typename?: 'UserOrganizationTeamNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserOrganizationTeamNode;
};

/** Node User - User Summary info */
export type UserOrganizationUserSummaryNode = IUserSummaryNode & {
  __typename?: 'UserOrganizationUserSummaryNode';
  available_currency_points?: Maybe<Scalars['Float']['output']>;
  events_bank: EventCountConnection;
  organization_id?: Maybe<Scalars['Int']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  redemption_expenses?: Maybe<Scalars['Float']['output']>;
  redemptions_count?: Maybe<Scalars['Float']['output']>;
  total_achievements?: Maybe<Scalars['Int']['output']>;
  total_events?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<MyUserNode>;
  user_id?: Maybe<Scalars['Int']['output']>;
  xp_points?: Maybe<Scalars['Float']['output']>;
};


/** Node User - User Summary info */
export type UserOrganizationUserSummaryNodeEvents_BankArgs = {
  query_variables?: InputMaybe<CurrencyEventQueryInput>;
};

export type UserOrganizationUserSummaryNodeEdge = {
  __typename?: 'UserOrganizationUserSummaryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserOrganizationUserSummaryNode;
};

export type UserOrganizationValidationMutationError = {
  __typename?: 'UserOrganizationValidationMutationError';
  errors: Array<Scalars['String']['output']>;
};

export type UserPasswordUpdateInput = {
  new_password: Scalars['String']['input'];
  old_password: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
  user_id: Scalars['Int']['input'];
};

export type UserPendingDetail = {
  __typename?: 'UserPendingDetail';
  courses_completed?: Maybe<Scalars['Int']['output']>;
  courses_enrolled?: Maybe<Scalars['Int']['output']>;
  last_activity_date?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  user_id: Scalars['ID']['output'];
  user_name?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type UserPendingDetailConnection = {
  __typename?: 'UserPendingDetailConnection';
  /** Contains the nodes in this connection */
  edges: Array<UserPendingDetailEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserPendingDetailEdge = {
  __typename?: 'UserPendingDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserPendingDetail;
};

/** Returned when a user does not have the required permissions (403). */
export type UserPermissionErrorResponse = {
  __typename?: 'UserPermissionErrorResponse';
  /** Código de error. */
  code: Scalars['String']['output'];
  /** ID de la operación para trazabilidad. */
  graphql_operation_id: Scalars['ID']['output'];
  /** Detalle del error de permisos. */
  message: Scalars['String']['output'];
};

export enum UserPolicyBalanceLogActionEnum {
  Accumulation = 'ACCUMULATION',
  BalanceReset = 'BALANCE_RESET',
  BulkImport = 'BULK_IMPORT',
  BulkImportRestore = 'BULK_IMPORT_RESTORE',
  BulkImportRestorePartial = 'BULK_IMPORT_RESTORE_PARTIAL',
  BulkImportRestoreRequestCancelled = 'BULK_IMPORT_RESTORE_REQUEST_CANCELLED',
  Expired = 'EXPIRED',
  IncorporationDateRecalculation = 'INCORPORATION_DATE_RECALCULATION',
  Linked = 'LINKED',
  ManualAdjustment = 'MANUAL_ADJUSTMENT',
  Reinstated = 'REINSTATED',
  Renewal = 'RENEWAL',
  Start = 'START',
  Unlinked = 'UNLINKED',
  Used = 'USED'
}

export enum UserPolicyBalanceLogOperationEnum {
  Add = 'ADD',
  Manage = 'MANAGE',
  Remove = 'REMOVE'
}

export type UserProductSuiteNode = {
  __typename?: 'UserProductSuiteNode';
  /** Date the license was assigned to the user */
  assigned_at: Scalars['Date']['output'];
  /** License expiration date; null means no expiry */
  ends_at?: Maybe<Scalars['Date']['output']>;
  /** Product suite code (e.g. TALENT) */
  suite_code: Scalars['String']['output'];
  /** Product suite display name */
  suite_name: Scalars['String']['output'];
};

export type UserProfileInput = {
  company_id?: InputMaybe<Scalars['Int']['input']>;
  employee_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  user_parent_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UserProfileMutations = {
  __typename?: 'UserProfileMutations';
  /** Get invitation link for user */
  generate_invitation_link: GetInvitationLinkResponse;
  /** set deactivation date in centralized user */
  set_deactivation_date: SetDeactivationDateResponse;
  /** Synchronize user avatar from learning */
  synchronize_user_avatar_from_learning: UserProfileUpdateAvatarResponse;
  /** update avatar in centralized users */
  update_avatar: UserProfileUpdateAvatarResponse;
  /** Update centralized user information */
  update_user_info: UpdateUserInfoResponse;
};


export type UserProfileMutationsGenerate_Invitation_LinkArgs = {
  input: GenerateInvitationLinkInput;
};


export type UserProfileMutationsSet_Deactivation_DateArgs = {
  input: SetDeactivationDateInput;
};


export type UserProfileMutationsSynchronize_User_Avatar_From_LearningArgs = {
  input: SynchronizeUserAvatarFromLearningInput;
};


export type UserProfileMutationsUpdate_AvatarArgs = {
  input: UpdateUserAvatarInput;
};


export type UserProfileMutationsUpdate_User_InfoArgs = {
  input: UpdateUserInfoInput;
};

export type UserProfileQueries = {
  __typename?: 'UserProfileQueries';
  /** Gets User Profile - documents information */
  user_profile_get_documents: DocumentUserProfileInfoNodeCustomConnectionHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError;
  /** Gets User Profile - documents signature status information */
  user_profile_get_documents_signature_status: DocumentUserProfileSignatureStatusInfoNodeCustomConnectionHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError;
  /** Gets User Profile - folders information */
  user_profile_get_folders: FolderUserProfileInfoNodeCustomConnectionHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError;
  /** Gets User Profile - documents information by user_id */
  user_profile_get_user_documents: DocumentUserProfileInfoNodeCustomConnectionHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError;
  /** Gets User Profile - documents signature status information by user_id */
  user_profile_get_user_documents_signature_status: DocumentUserProfileSignatureStatusInfoNodeCustomConnectionHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError;
  /** Gets User Profile - folders information by user_id */
  user_profile_get_user_folders: FolderUserProfileInfoNodeCustomConnectionHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError;
};


export type UserProfileQueriesUser_Profile_Get_DocumentsArgs = {
  input: GetDocumentUserProfileInput;
};


export type UserProfileQueriesUser_Profile_Get_Documents_Signature_StatusArgs = {
  input: GetDocumentSignatureStatusUserProfileInput;
};


export type UserProfileQueriesUser_Profile_Get_FoldersArgs = {
  input: GetFolderUserProfileInput;
};


export type UserProfileQueriesUser_Profile_Get_User_DocumentsArgs = {
  input: GetDocumentByIdUserProfileInput;
};


export type UserProfileQueriesUser_Profile_Get_User_Documents_Signature_StatusArgs = {
  input: GetDocumentSignatureStatusByIdUserProfileInput;
};


export type UserProfileQueriesUser_Profile_Get_User_FoldersArgs = {
  input: GetFolderByIdUserProfileInput;
};

export type UserProfileSocialHubNewsByIdResponse = ForbiddenErrorResponse | InternalErrorResponse | NotFoundResponse | UserProfileSocialHubNewsInfoNode | ValidationErrorResponse;

/** Subgraph HRIS - Document User Profile Info Node */
export type UserProfileSocialHubNewsInfoNode = {
  __typename?: 'UserProfileSocialHubNewsInfoNode';
  /** Social Hub News File ID */
  file_id: Scalars['Int']['output'];
  /** Social Hub News File Info */
  file_info?: Maybe<File>;
  /** Social Hub News Front Page Image ID */
  front_page_image_id?: Maybe<Scalars['Int']['output']>;
  /** Social Hub News Front Page Image Info */
  front_page_image_info?: Maybe<File>;
  /** ID */
  id: Scalars['Int']['output'];
  /** Social Hub News Published Date */
  published_date: Scalars['DateTime']['output'];
  /** User News Status */
  status: SocialHubNewsStatusEnum;
  /** Social Hub News Title */
  title: Scalars['String']['output'];
  /** Uploaded format */
  uploaded_format?: Maybe<DocumentFileFormatEnum>;
};

export type UserProfileSocialHubNewsInfoNodeCustomConnection = {
  __typename?: 'UserProfileSocialHubNewsInfoNodeCustomConnection';
  edges: Array<UserProfileSocialHubNewsInfoNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type UserProfileSocialHubNewsInfoNodeCustomConnectionHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError = HrisQueryIntegrityError | HrisQueryInternalError | HrisQueryValidationError | UserProfileSocialHubNewsInfoNodeCustomConnection;

export type UserProfileSocialHubNewsInfoNodeCustomEdge = {
  __typename?: 'UserProfileSocialHubNewsInfoNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserProfileSocialHubNewsInfoNode;
};

export type UserProfileUpdateAreasInput = {
  level_1: Scalars['Int']['input'];
  level_2?: InputMaybe<Scalars['Int']['input']>;
  level_3?: InputMaybe<Scalars['Int']['input']>;
  level_4?: InputMaybe<Scalars['Int']['input']>;
};

export type UserProfileUpdateAvatarResponse = CentralizedIntegrityError | CentralizedInternalError | CentralizedValidationError | UpdateAvatarPayload;

export type UserProfileUpdateCustomFieldInput = {
  id: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type UserProfileUpdateInput = {
  about_me?: InputMaybe<Scalars['String']['input']>;
  additional_information?: InputMaybe<Array<UserProfileUpdateCustomFieldInput>>;
  address?: InputMaybe<Scalars['String']['input']>;
  areas?: InputMaybe<UserProfileUpdateAreasInput>;
  birthday_date?: InputMaybe<Scalars['Date']['input']>;
  boss_id?: InputMaybe<Scalars['Int']['input']>;
  cellphone?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  civil_status?: InputMaybe<CivilStatusEnumInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  deactivation_date?: InputMaybe<Scalars['DateTime']['input']>;
  document?: InputMaybe<Scalars['String']['input']>;
  document_type?: InputMaybe<DocumentTypeEnumInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_email?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_email_2?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_name?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_name_2?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_phone?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_phone_2?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_relationship?: InputMaybe<Scalars['String']['input']>;
  emergency_contact_relationship_2?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnumInput>;
  headquarter_id?: InputMaybe<Scalars['Int']['input']>;
  incorporation_date?: InputMaybe<Scalars['DateTime']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  leaving_date?: InputMaybe<Scalars['DateTime']['input']>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  personal_email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position_category_id?: InputMaybe<Scalars['Int']['input']>;
  position_id?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  web_site_url?: InputMaybe<Scalars['String']['input']>;
};

/** Subgraph HRIS - Document User Profile Info Node */
export type UserProgressSocialHubNewsInfoNode = {
  __typename?: 'UserProgressSocialHubNewsInfoNode';
  /** Social Hub News Area Name */
  area_name?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['Int']['output'];
  /** Organization ID */
  organization_id: Scalars['Int']['output'];
  /** Social Hub News Position Name */
  position_name?: Maybe<Scalars['String']['output']>;
  /** Social Hub News State */
  state: SocialHubNewsStatusEnum;
  /** User */
  user?: Maybe<CentralizedUserNode>;
  /** User ID */
  user_id: Scalars['Int']['output'];
  /** Social Hub News Visualization Date */
  visualization_date?: Maybe<Scalars['DateTime']['output']>;
};

export type UserProgressSocialHubNewsInfoNodeCustomConnection = {
  __typename?: 'UserProgressSocialHubNewsInfoNodeCustomConnection';
  edges: Array<UserProgressSocialHubNewsInfoNodeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type UserProgressSocialHubNewsInfoNodeCustomConnectionHrisQueryValidationErrorHrisQueryInternalErrorHrisQueryIntegrityError = HrisQueryIntegrityError | HrisQueryInternalError | HrisQueryValidationError | UserProgressSocialHubNewsInfoNodeCustomConnection;

export type UserProgressSocialHubNewsInfoNodeCustomEdge = {
  __typename?: 'UserProgressSocialHubNewsInfoNodeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserProgressSocialHubNewsInfoNode;
};

export type UserProgressSocialHubNewsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  filter_by?: InputMaybe<FilterUserProgressSocialHubNewsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  social_hub_news_id: Scalars['Int']['input'];
  user_name_order_by?: InputMaybe<DocumentManagementOrderByEnum>;
};

export type UserQuizFormPayload = GraphOperationI & {
  __typename?: 'UserQuizFormPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
  quiz_form: UserQuizFormType;
};

export type UserQuizFormResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | UserQuizFormPayload;

export enum UserQuizFormStatusEnum {
  Approved = 'APPROVED',
  Certificate = 'CERTIFICATE',
  Disapproved = 'DISAPPROVED',
  Incomplete = 'INCOMPLETE',
  Initial = 'INITIAL',
  Progress = 'PROGRESS'
}

export type UserQuizFormType = {
  __typename?: 'UserQuizFormType';
  id?: Maybe<Scalars['ID']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  question_set?: Maybe<Array<QuizQuestionType>>;
  quiz?: Maybe<QuizType>;
  total_correct_answer?: Maybe<Scalars['Int']['output']>;
  total_questions?: Maybe<Scalars['Int']['output']>;
  total_seconds?: Maybe<Scalars['Float']['output']>;
  total_wrong_answer?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type UserRecoverPasswordInput = {
  next_url?: InputMaybe<Scalars['String']['input']>;
  organization_slug: Scalars['String']['input'];
  user_id: Scalars['Int']['input'];
};

export enum UserRegisterMethodEnum {
  AdminMethod = 'ADMIN_METHOD',
  AlphanumCode = 'ALPHANUM_CODE',
  QrLinkMethod = 'QR_LINK_METHOD'
}

export type UserRewardListType = {
  __typename?: 'UserRewardListType';
  items: Array<UserRewardType>;
  metadata: Scalars['JSON']['output'];
};

export type UserRewardNode = IGamificationNode & IRewardNode & {
  __typename?: 'UserRewardNode';
  /** This field indicates whether a redemption can be made for a particular reward or not */
  can_redeemed_this_reward?: Maybe<Scalars['Boolean']['output']>;
  /** Reward cover */
  cover_attachment?: Maybe<ImageNode>;
  currency_point?: Maybe<Scalars['JSON']['output']>;
  currency_point_id?: Maybe<Scalars['ID']['output']>;
  currency_point_value?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_redeemable?: Maybe<Scalars['Boolean']['output']>;
  money_value?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['ID']['output']>;
  quantity_available?: Maybe<Scalars['Float']['output']>;
  quantity_reserved?: Maybe<Scalars['Float']['output']>;
  /** Field for allowed redemptions with a limit on the quantity of redemptions. */
  redemptions_allowed?: Maybe<Scalars['Int']['output']>;
  /** This field indicates the number of redemptions that can be made, it has a value when the admin has declared a value for the redemptions_allowed field. */
  redemptions_available?: Maybe<Scalars['Int']['output']>;
  reward_tags?: Maybe<Array<RewardTagNode>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type UserRewardNodeEdge = {
  __typename?: 'UserRewardNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserRewardNode;
};

export type UserRewardType = IRewardType & {
  __typename?: 'UserRewardType';
  /** Reward cover */
  cover_attachment?: Maybe<ImageNode>;
  currency_point_value?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  tags: Array<Scalars['String']['output']>;
};

export enum UserRoleEnum {
  RoleAdmin = 'ROLE_ADMIN',
  RoleMembers = 'ROLE_MEMBERS',
  RoleSubAdmin = 'ROLE_SUB_ADMIN'
}

export enum UserRoleFilterEnum {
  Admin = 'ADMIN',
  User = 'USER'
}

export type UserScormData = {
  __typename?: 'UserScormData';
  /** @deprecated Changed to "scorm_data" field */
  data?: Maybe<Scalars['String']['output']>;
  hash_data?: Maybe<Scalars['String']['output']>;
  scorm_data?: Maybe<Scalars['String']['output']>;
  scorm_info?: Maybe<UserScormInfo>;
  scorm_version: ScormDataVersion;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id: Scalars['ID']['output'];
  video_lecture_id: Scalars['ID']['output'];
};

export type UserScormDataInput = {
  scorm_data: Scalars['String']['input'];
  scorm_version?: InputMaybe<ScormDataVersion>;
  video_lecture_id: Scalars['ID']['input'];
};

export type UserScormInfo = {
  __typename?: 'UserScormInfo';
  lesson_mode?: Maybe<ScormInfoLessonModeEnum>;
  lesson_progress?: Maybe<Scalars['Float']['output']>;
  lesson_status?: Maybe<ScormInfoLessonStatusEnum>;
  session_time?: Maybe<Scalars['String']['output']>;
  student_id?: Maybe<Scalars['ID']['output']>;
  student_name?: Maybe<Scalars['String']['output']>;
  success_status?: Maybe<ScormInfoSuccessStatusEnum>;
};

export type UserSession = {
  __typename?: 'UserSession';
  application_language?: Maybe<Scalars['String']['output']>;
  application_permissions?: Maybe<Array<Scalars['String']['output']>>;
  application_products?: Maybe<Array<Scalars['String']['output']>>;
  application_roles?: Maybe<Array<Scalars['String']['output']>>;
  auth_method?: Maybe<Scalars['String']['output']>;
  centralized_session?: Maybe<CentralizedSession>;
  country_code?: Maybe<Scalars['String']['output']>;
  feature_flags?: Maybe<Scalars['JSON']['output']>;
  learning_session?: Maybe<LearningSession>;
  personalization?: Maybe<OrganizationPersonalization>;
  session_data: Scalars['JSON']['output'];
  session_key: Scalars['String']['output'];
  session_permissions?: Maybe<Array<Scalars['String']['output']>>;
  session_type: Scalars['String']['output'];
  session_user: User;
  session_user_id?: Maybe<Scalars['ID']['output']>;
  talent_session?: Maybe<TalentSession>;
};

/** Input for update a live session users status [Mutation] */
export type UserSessionChangeStatusInput = {
  live_session_id: Scalars['ID']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  register_method?: InputMaybe<UserRegisterMethodEnum>;
  status: UserStatusEnum;
  user_session_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserSessionFragment = ExternalLiveSessionUserType | InternalLiveSessionUserType;

export type UserSessionFragmentPaginationEdge = {
  __typename?: 'UserSessionFragmentPaginationEdge';
  /** The item at the end of the edge. */
  node: UserSessionFragment;
};

export type UserSessionI = {
  has_participated?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  status: UserStatusEnum;
  user_id?: Maybe<Scalars['ID']['output']>;
  user_image_url?: Maybe<Scalars['String']['output']>;
  user_organization_id?: Maybe<Scalars['Int']['output']>;
};

/** This input is used in queries or mutation, represent basic user fields [Queries or Mutation] */
export type UserSessionInput = {
  user_id?: InputMaybe<Scalars['ID']['input']>;
  user_organization_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UserSessionListType = {
  __typename?: 'UserSessionListType';
  items: Array<LiveSessionUserSessionType>;
  metadata: UserSessionMetadata;
  total_attendees: Scalars['Int']['output'];
  total_confirmed: Scalars['Int']['output'];
  total_guests: Scalars['Int']['output'];
};

export type UserSessionMetadata = {
  __typename?: 'UserSessionMetadata';
  exclude_user_organization_ids: Array<Scalars['Int']['output']>;
  total_items_count: Scalars['Int']['output'];
};

export enum UserStatusEnum {
  Confirmed = 'CONFIRMED',
  NoConfirmed = 'NO_CONFIRMED',
  Rejected = 'REJECTED'
}

export enum UserStatusOrderByEnum {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Status = 'STATUS'
}

export type UserSummaryConnection = {
  __typename?: 'UserSummaryConnection';
  /** Contains the nodes in this connection */
  edges: Array<UserSummaryNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export enum UserSummaryEnum {
  Achievements = 'ACHIEVEMENTS',
  CurrencyPoint = 'CURRENCY_POINT',
  Rank = 'RANK',
  XpPoint = 'XP_POINT'
}

export type UserSummaryFragment = AllowedUserSummaryUserSummaryResponse | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type UserSummaryFragmentConnection = {
  __typename?: 'UserSummaryFragmentConnection';
  /** Contains the nodes in this connection */
  edges: Array<AdminOrganizationUserSummaryNodeEdgeUserOrganizationUserSummaryNodeEdge>;
  /** Errors for queries */
  errors?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /**
   * A total count of the total number of objects in this
   *         connection, ignoring pagination.
   */
  total_count: Scalars['Int']['output'];
};

export type UserSummaryInput = {
  organization_id: Scalars['ID']['input'];
};

/** Summary node to appreciate the xp points, the currency points and the number of events obtained by each user. */
export type UserSummaryNode = {
  __typename?: 'UserSummaryNode';
  available_currency_points?: Maybe<Scalars['Float']['output']>;
  events_bank?: Maybe<EventCountConnection>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  redemption_expenses?: Maybe<Scalars['Float']['output']>;
  redemptions_count?: Maybe<Scalars['Float']['output']>;
  total_achievements?: Maybe<Scalars['Int']['output']>;
  total_events?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<MyUserNode>;
  user_id?: Maybe<Scalars['Int']['output']>;
  xp_points?: Maybe<Scalars['Float']['output']>;
};


/** Summary node to appreciate the xp points, the currency points and the number of events obtained by each user. */
export type UserSummaryNodeEvents_BankArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserSummaryNodeEdge = {
  __typename?: 'UserSummaryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserSummaryNode;
};

export type UserSummaryOrderByInput = {
  direction: OrderDirectionEnum;
  field: UserSummaryEnum;
};

export type UserSwitchesAccount = {
  impersonated_users: Array<ImpersonatedUsers>;
  impersonating_user_id: Scalars['ID']['input'];
  organization_id: Scalars['ID']['input'];
};

export type UserTagsType = {
  __typename?: 'UserTagsType';
  items: Array<Scalars['String']['output']>;
  total_count: Scalars['Int']['output'];
};

export type UserTalentType = {
  __typename?: 'UserTalentType';
  avatar?: Maybe<AvatarTalentType>;
  boss?: Maybe<ProfileBossType>;
  collaborators_count?: Maybe<Scalars['Int']['output']>;
  company?: Maybe<CompanyTalentType>;
  division?: Maybe<ProfileDivisionType>;
  email?: Maybe<Scalars['String']['output']>;
  employee_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_boss?: Maybe<Scalars['Boolean']['output']>;
  job?: Maybe<ProfileJobType>;
  language?: Maybe<LanguageEnum>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<RoleEnum>;
  state?: Maybe<StateEnum>;
  super_boss?: Maybe<ProfileBossType>;
};

export type UserTeamAssignmentResponse = DataFieldsSent | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type UserTeamAutomationRuleType = {
  __typename?: 'UserTeamAutomationRuleType';
  id: Scalars['ID']['output'];
  user: UserAutomationRule;
  user_id: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

export type UserTeamAutomationRuleTypeListResponse = {
  __typename?: 'UserTeamAutomationRuleTypeListResponse';
  items: Array<UserTeamAutomationRuleType>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type UserTeamBulkDeletionFilterInput = {
  apply_to_all: Scalars['Boolean']['input'];
  exclude_user_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  search_query?: InputMaybe<Scalars['String']['input']>;
};

export type UserTeamDeactivationResponse = DataFieldsSent | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;

export type UserTeamInputOrderBy = {
  direction: OrderDirectionEnum;
  field: UserTeamOrderByEnum;
};

export enum UserTeamOrderByEnum {
  OrganizationTeamEndDate = 'ORGANIZATION_TEAM_END_DATE',
  UserTeamExpirationDate = 'USER_TEAM_EXPIRATION_DATE'
}

export type UserTeamRewardInput = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  organization_team_id: Scalars['Int']['input'];
};

export type UserTeamRewardNode = {
  __typename?: 'UserTeamRewardNode';
  completed_courses?: Maybe<Scalars['Int']['output']>;
  completed_project?: Maybe<Scalars['Int']['output']>;
  course_progress?: Maybe<Scalars['Int']['output']>;
  courses?: Maybe<Array<Course>>;
  id: Scalars['ID']['output'];
  project_progress?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  total_courses?: Maybe<Scalars['Int']['output']>;
  total_project?: Maybe<Scalars['Int']['output']>;
};

export type UserTeamRewardResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | UserTeamRewardNode;

export enum UserTeamSearchFilterEnum {
  TeamSearchFilterAll = 'TEAM_SEARCH_FILTER_ALL',
  TeamSearchFilterCompleted = 'TEAM_SEARCH_FILTER_COMPLETED',
  TeamSearchFilterCurrent = 'TEAM_SEARCH_FILTER_CURRENT',
  TeamSearchFilterDisabled = 'TEAM_SEARCH_FILTER_DISABLED',
  TeamSearchFilterExpired = 'TEAM_SEARCH_FILTER_EXPIRED',
  TeamSearchFilterNotCompleted = 'TEAM_SEARCH_FILTER_NOT_COMPLETED'
}

export enum UserTypeEnum {
  UserTypeSystem = 'USER_TYPE_SYSTEM',
  UserTypeUser = 'USER_TYPE_USER'
}

export type UserUpdateResponse = {
  __typename?: 'UserUpdateResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

/** User Filters with counter */
export type UserWithCounterFilterInput = {
  name_or_email?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['ID']['input'];
  user_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UserWorkTeamStatisticNode = {
  __typename?: 'UserWorkTeamStatisticNode';
  certified_projects?: Maybe<Scalars['Int']['output']>;
  last_activity?: Maybe<Scalars['DateTime']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  total_hours?: Maybe<Scalars['Int']['output']>;
  total_projects?: Maybe<Scalars['Int']['output']>;
  user: MetricsUser;
};

/** A connection to a list of items. */
export type UserWorkTeamStatisticNodeConnection = {
  __typename?: 'UserWorkTeamStatisticNodeConnection';
  /** Contains the nodes in this connection */
  edges: Array<UserWorkTeamStatisticNodeEdge>;
  /** Pagination data for this connection */
  page_info: PageInfo;
  /** Total quantity of existing nodes */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserWorkTeamStatisticNodeEdge = {
  __typename?: 'UserWorkTeamStatisticNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: UserWorkTeamStatisticNode;
};

export type UsersByBossOnCurrentSessionInfo = GraphOperationI & {
  __typename?: 'UsersByBossOnCurrentSessionInfo';
  count?: Maybe<Scalars['Float']['output']>;
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
  updated_date?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersByBossOnCurrentSessionResponse = FoundationLeaderIntegrityError | FoundationLeaderInternalError | FoundationLeaderValidationError | UsersByBossOnCurrentSessionInfo;

export type UsersCustomFieldAnswerResponse = {
  __typename?: 'UsersCustomFieldAnswerResponse';
  error?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export enum UsersForAssignmentField {
  UserId = 'USER_ID'
}

export type UsersForAssignmentFieldUsersForAssignmentOrderByInput = {
  direction: OrderAndDirectionEnum;
  field: UsersForAssignmentField;
};

/** Fragment representing the users involved in the assignment process of a gamification */
export type UsersForAssignmentFragment = ActiveAllowedUser | ApplicantUser | InactiveAllowedUser;

export type UsersForAssignmentFragmentGamificationMetadataGamificationPageNumConnectionGenerator = {
  __typename?: 'UsersForAssignmentFragmentGamificationMetadataGamificationPageNumConnectionGenerator';
  /** A list of edges in this connection. */
  edges: Array<UsersForAssignmentFragmentGamificationMetadataGamificationPaginationEdge>;
  metadata?: Maybe<GamificationMetadata>;
  /** Information to aid in pagination. */
  page_info: GamificationNumPageInfo;
};

export type UsersForAssignmentFragmentGamificationMetadataGamificationPaginationEdge = {
  __typename?: 'UsersForAssignmentFragmentGamificationMetadataGamificationPaginationEdge';
  /** The item at the end of the edge. */
  node: UsersForAssignmentFragment;
};

export type UsersForAssignmentInput = {
  filter_by?: UserFilterByInput;
  first?: Scalars['Int']['input'];
  order_by?: Array<UsersForAssignmentFieldUsersForAssignmentOrderByInput>;
  organization_id: Scalars['ID']['input'];
  page?: Scalars['Int']['input'];
};

export type UsersForLeaderboardInput = {
  filter_by?: UserFilterByInput;
  first?: Scalars['Int']['input'];
  organization_id: Scalars['ID']['input'];
  page?: Scalars['Int']['input'];
};

export type UsersGraphOperationI = {
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type UsersInactivitySummaryResponse = {
  __typename?: 'UsersInactivitySummaryResponse';
  percent_inactive: Scalars['Int']['output'];
  total_users: Scalars['Int']['output'];
  total_users_with_activity: Scalars['Int']['output'];
  total_users_without_activity: Scalars['Int']['output'];
};

export type UsersQueries = {
  __typename?: 'UsersQueries';
  /** Returns user IDs matching the given filters within an organization. */
  filter_users: FilterUsersResponse;
  /** Returns a single active contact by ID for an employee. */
  get_employee_contact: GetEmployeeContactResponse;
  /** Returns all active family and emergency contacts for an employee. Requires can_manage_organization or can_manage_or_is_self permission. */
  get_employee_contacts: GetEmployeeContactsResponse;
  /** Returns the organizational structure for an employee: job position, position category, area hierarchy (up to 4 levels), sede, and direct boss. Requires can_manage_organization or can_manage_or_is_self permission. */
  get_employee_org_structure: GetEmployeeOrgStructureResponse;
  /** Returns all personal and contact information for an employee within the given organization. Requires can_manage_organization or can_manage_or_is_self permission. */
  get_employee_personal_info: GetEmployeePersonalInfoResponse;
  /** Returns active areas for the organization filtered by parent. Pass parent_id=null to get root areas (Dirección level); pass a parent_id to get direct children. Requires can_manage_organization permission over the organization. */
  get_organization_areas: GetOrgAreasResponse;
  /** Returns all active headquarters (sedes) for the organization. Requires can_manage_organization permission over the organization. */
  get_organization_headquarters: GetOrgHeadquartersResponse;
  /** Returns all active position categories (categorías de cargo) for the organization. Requires can_manage_organization permission over the organization. */
  get_organization_position_categories: GetOrgPositionCategoriesResponse;
  /** Returns all active job positions (cargos) for the organization. Requires can_manage_organization permission over the organization. */
  get_organization_positions: GetOrgPositionsResponse;
  /** Returns user IDs of direct reports for a given boss within an organization. */
  get_subordinate_user_ids: GetSubordinateUserIdsResponse;
  /** Detail of the headquarters a user is allowed to manage, each with its assignment date. */
  get_user_managed_headquarters: UserManagedHeadquartersDetailPayloadNotAuthenticatedErrorResponseValidationErrorResponseInternalErrorResponse;
  /** Returns the UserOrganization matching the given username within an organization, or null if none exists. Used by the front to validate username uniqueness during user creation/edition. Mirrors the shape of the email-based lookup. */
  get_user_organization_by_username?: Maybe<CentralizedUserOrganizationNode>;
  /** Sedes que el solicitante puede ver/gestionar con el conteo de usuarios por sede (panel lateral). Si el solicitante no tiene restricciones, devuelve todas las sedes activas de la organización. Disponible para cualquier miembro de la organización: un colaborador consulta así sus propias sedes. */
  get_viewer_allowed_headquarters: ViewerAllowedHeadquartersPayloadNotAuthenticatedErrorResponseValidationErrorResponseInternalErrorResponse;
  /** Lightweight paginated list of user organizations with basic user info and learning_user_id. Single optimized SQL query, no joins beyond User and UserEnterprise(LEARNING). */
  list_basic_user_organizations: CentralizedBasicUserOrganizationConnectionValidationErrorResponseInternalErrorResponse;
  /** Paginated list of users with active headquarter restrictions in an organization (name, email, user type, headquarters count, last modification date). */
  list_users_with_managed_headquarters: ManagedHeadquarterUserNodeConnectionNotAuthenticatedErrorResponseValidationErrorResponseInternalErrorResponse;
  /** Returns whether the organization has at least one active headquarter configured (used for the empty-state of the restrictions table). */
  organization_has_configured_headquarters: OrganizationHeadquartersStatusPayloadNotAuthenticatedErrorResponseValidationErrorResponseInternalErrorResponse;
  /** Resolve a batch of emails to user ids inside an organization. Returns one entry per email that matches an active user globally; emails not matching any user are absent from the response. Each entry indicates whether the user has an ACTIVE/PENDING UserOrganization in the requested organization. */
  resolve_user_ids_by_emails: ResolveUserIdsByEmailsResponse;
};


export type UsersQueriesFilter_UsersArgs = {
  input: FilterUsersInput;
};


export type UsersQueriesGet_Employee_ContactArgs = {
  input: CentralizedUsersGetEmployeeContactInput;
};


export type UsersQueriesGet_Employee_ContactsArgs = {
  input: CentralizedUsersGetEmployeeContactsInput;
};


export type UsersQueriesGet_Employee_Org_StructureArgs = {
  input: CentralizedUsersGetEmployeeOrgStructureInput;
};


export type UsersQueriesGet_Employee_Personal_InfoArgs = {
  input: CentralizedUsersGetEmployeePersonalInfoInput;
};


export type UsersQueriesGet_Organization_AreasArgs = {
  input: CentralizedUsersGetOrgAreasInput;
};


export type UsersQueriesGet_Organization_HeadquartersArgs = {
  input: CentralizedUsersGetOrgHeadquartersInput;
};


export type UsersQueriesGet_Organization_Position_CategoriesArgs = {
  input: CentralizedUsersGetOrgPositionCategoriesInput;
};


export type UsersQueriesGet_Organization_PositionsArgs = {
  input: CentralizedUsersGetOrgPositionsInput;
};


export type UsersQueriesGet_Subordinate_User_IdsArgs = {
  input: GetSubordinateUserIdsInput;
};


export type UsersQueriesGet_User_Managed_HeadquartersArgs = {
  input: GetUserManagedHeadquartersInput;
};


export type UsersQueriesGet_User_Organization_By_UsernameArgs = {
  input: GetUserOrganizationByUsernameInput;
};


export type UsersQueriesGet_Viewer_Allowed_HeadquartersArgs = {
  input: ViewerAllowedHeadquartersInput;
};


export type UsersQueriesList_Basic_User_OrganizationsArgs = {
  input: ListBasicUserOrganizationsInput;
};


export type UsersQueriesList_Users_With_Managed_HeadquartersArgs = {
  input: ListUsersWithManagedHeadquartersInput;
};


export type UsersQueriesOrganization_Has_Configured_HeadquartersArgs = {
  input: OrganizationHeadquartersStatusInput;
};


export type UsersQueriesResolve_User_Ids_By_EmailsArgs = {
  input: ResolveUserIdsByEmailsInput;
};

export type UsersQuery = {
  __typename?: 'UsersQuery';
  get_language_test: Scalars['String']['output'];
  /** This query shows all learning users */
  get_learning_users: LearningUserOrganizationConnectionQueryValidationErrorQueryInternalError;
  get_user_help_center_url: Scalars['String']['output'];
  get_user_initial_page_url: Scalars['String']['output'];
  has_url_permission: HasUrlPermissionResponse;
};


export type UsersQueryGet_Learning_UsersArgs = {
  input: GetUsersInput;
};


export type UsersQueryGet_User_Help_Center_UrlArgs = {
  input?: InputMaybe<GetUserHelpCenterUrlInput>;
};


export type UsersQueryGet_User_Initial_Page_UrlArgs = {
  next_url?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<GetUserInitialPageUrlOptionsInput>;
};


export type UsersQueryHas_Url_PermissionArgs = {
  input: HasUrlPermissionInput;
};

/** Paginated list of users matched by segmentation conditionals. */
export type UsersSegment = {
  __typename?: 'UsersSegment';
  total_count: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
  /** List of all user IDs matching the segmentation conditionals */
  total_users_id: Array<Scalars['Int']['output']>;
  users: Array<UserInSegment>;
};

export type UsersUploadUrl = {
  file_upload?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
};

export type ValidAssignment = {
  __typename?: 'ValidAssignment';
  /** Assignment date (DD/MM/YYYY format) */
  assignment_date?: Maybe<Scalars['String']['output']>;
  /** Excel cell reference (e.g., 'A15', 'B2', 'C10') */
  cell: Scalars['String']['output'];
  /** Document name */
  document_name: Scalars['String']['output'];
  /** Target folder ID */
  folder_id?: Maybe<Scalars['Int']['output']>;
  /** Target folder name (null = only in profile) */
  folder_name?: Maybe<Scalars['String']['output']>;
  /** Whether the document will be visible to user */
  will_be_visible: Scalars['Boolean']['output'];
};

export type ValidConfigItem = {
  __typename?: 'ValidConfigItem';
  /** When the document will be assigned */
  assignment_date?: Maybe<Scalars['DateTime']['output']>;
  /** Display name for the document */
  document_name: Scalars['String']['output'];
  /** User email */
  email: Scalars['String']['output'];
  /** Original file name */
  file_name: Scalars['String']['output'];
  /** Target folder ID */
  folder_id?: Maybe<Scalars['Int']['output']>;
  /** Target folder name (for display) */
  folder_name?: Maybe<Scalars['String']['output']>;
  /** User ID */
  user_id: Scalars['Int']['output'];
  /** User Organization ID for assignment */
  user_organization_id: Scalars['Int']['output'];
  /** Whether the document is visible to the user */
  visible: Scalars['Boolean']['output'];
};

export type ValidFileMetadata = {
  __typename?: 'ValidFileMetadata';
  /** Document name extracted from filename */
  document_name: Scalars['String']['output'];
  /** Email extracted from filename */
  extracted_email: Scalars['String']['output'];
  /** Original file name */
  file_name: Scalars['String']['output'];
  /** User ID in the organization */
  user_id: Scalars['Int']['output'];
  /** User Organization ID for assignment */
  user_organization_id: Scalars['Int']['output'];
};

export type ValidateAndGenerateTrackCertificateInput = {
  /** Organization identifier. */
  organization_id: Scalars['Int']['input'];
  /** Learning track (organization_team) identifier. */
  organization_team_id: Scalars['Int']['input'];
};

export type ValidateArea = {
  action: CrudActionEnum;
  area?: InputMaybe<ValidateAreaSecond>;
  id?: InputMaybe<Scalars['Int']['input']>;
  level_sequence: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parent_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ValidateAreaFourth = {
  id: Scalars['Int']['input'];
  level_sequence: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type ValidateAreaInput = {
  area: ValidateArea;
  organization_id: Scalars['Int']['input'];
};

export type ValidateAreaSecond = {
  area?: InputMaybe<ValidateAreaThird>;
  id: Scalars['Int']['input'];
  level_sequence: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type ValidateAreaThird = {
  area?: InputMaybe<ValidateAreaFourth>;
  id: Scalars['Int']['input'];
  level_sequence: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type ValidateClabeInput = {
  centralized_organization_id: Scalars['ID']['input'];
  clabe: Scalars['String']['input'];
};

export type ValidateCsdCertificateInput = {
  centralized_organization_id: Scalars['ID']['input'];
  cer_file: Scalars['String']['input'];
  key_file: Scalars['String']['input'];
  legal_entity_id?: InputMaybe<Scalars['ID']['input']>;
  password: Scalars['String']['input'];
};

export type ValidateCsdCertificateResponse = {
  __typename?: 'ValidateCsdCertificateResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: ValidateCsdCertificateType;
};

export type ValidateCsdCertificateResult = InternalErrorResponse | UserPermissionErrorResponse | ValidateCsdCertificateResponse | ValidationErrorResponse;

export type ValidateCsdCertificateType = {
  __typename?: 'ValidateCsdCertificateType';
  certificate_serial_number?: Maybe<Scalars['String']['output']>;
  days_until_expiration?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['Date']['output']>;
  is_expired: Scalars['Boolean']['output'];
  is_valid: Scalars['Boolean']['output'];
};

export type ValidateCurpInput = {
  centralized_organization_id: Scalars['ID']['input'];
  curp: Scalars['String']['input'];
};

export type ValidateEmployerRegistrationIdentityInput = {
  centralized_organization_id: Scalars['ID']['input'];
  imss_subdelegation_id: Scalars['ID']['input'];
  legal_entity_id: Scalars['ID']['input'];
  registration_number: Scalars['String']['input'];
  salary_zone_id: Scalars['ID']['input'];
  work_center_location_type: PayrollWorkCenterLocationType;
  work_locations?: InputMaybe<Array<PayrollWorkLocationInput>>;
};

export type ValidateEmployerRegistrationIdentityResponse = {
  __typename?: 'ValidateEmployerRegistrationIdentityResponse';
  graphql_operation_id: Scalars['ID']['output'];
  is_valid: Scalars['Boolean']['output'];
};

export type ValidateEmployerRegistrationIdentityResult = InternalErrorResponse | UserPermissionErrorResponse | ValidateEmployerRegistrationIdentityResponse | ValidationErrorResponse;

export type ValidateEmployerRegistrationIdseInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Contrasena del usuario de servicio de Terra. Se valida contra las reglas del proveedor sin gastar una llamada: un rechazo cuesta un viaje, y Terra no permite borrar un usuario creado por error. */
  idse_password?: InputMaybe<Scalars['String']['input']>;
  /** Usuario IDSE del cliente. */
  idse_username?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateEmployerRegistrationIdseResponse = {
  __typename?: 'ValidateEmployerRegistrationIdseResponse';
  graphql_operation_id: Scalars['ID']['output'];
  is_valid: Scalars['Boolean']['output'];
};

export type ValidateEmployerRegistrationIdseResult = InternalErrorResponse | UserPermissionErrorResponse | ValidateEmployerRegistrationIdseResponse | ValidationErrorResponse;

export type ValidateEmployerRegistrationSafetyInput = {
  centralized_organization_id: Scalars['ID']['input'];
  economic_activity_code: Scalars['String']['input'];
  economic_activity_description: Scalars['String']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  risk_class_id: Scalars['ID']['input'];
  risk_data_expiration_date?: InputMaybe<Scalars['Date']['input']>;
  risk_fraction?: InputMaybe<Scalars['Decimal']['input']>;
  risk_premium: Scalars['Decimal']['input'];
};

export type ValidateEmployerRegistrationSafetyResponse = {
  __typename?: 'ValidateEmployerRegistrationSafetyResponse';
  graphql_operation_id: Scalars['ID']['output'];
  is_valid: Scalars['Boolean']['output'];
};

export type ValidateEmployerRegistrationSafetyResult = InternalErrorResponse | UserPermissionErrorResponse | ValidateEmployerRegistrationSafetyResponse | ValidationErrorResponse;

export type ValidateErrorSummaryType = {
  __typename?: 'ValidateErrorSummaryType';
  error_groups: Scalars['Int']['output'];
  total_errors: Scalars['Int']['output'];
  total_warnings: Scalars['Int']['output'];
  warning_groups: Scalars['Int']['output'];
};

export type ValidateExcelFileResponse = {
  __typename?: 'ValidateExcelFileResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
};

export type ValidateExcelFileResponseV2 = {
  __typename?: 'ValidateExcelFileResponseV2';
  downloadLinks?: Maybe<DownloadLinksType>;
  error_groups: Array<ErrorGroupType>;
  invalid_records_count: Scalars['Int']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  summary: ValidateErrorSummaryType;
  total_records_count: Scalars['Int']['output'];
  valid_records: Array<Scalars['String']['output']>;
  valid_records_count: Scalars['Int']['output'];
  warning_groups: Array<ErrorGroupType>;
  warning_records_count: Scalars['Int']['output'];
};

export type ValidateFieldResponse = CentralizedFieldValidationResponse | FieldValidationResponse | ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

export type ValidateFormatResult = FormatValidationResponse | InternalErrorResponse | UserPermissionErrorResponse | ValidationErrorResponse;

/** Validacion del par de la e.firma y de las credenciales IDSE, sin guardar nada. Sirve para que quien captura sepa que su e.firma no funciona antes de que cueste una llamada al proveedor. */
export type ValidateIdseEfirmaInput = {
  centralized_organization_id: Scalars['ID']['input'];
  /** Contenido del archivo `.cer` en base64. */
  cer_file?: InputMaybe<Scalars['String']['input']>;
  /** Contrasena de la llave privada. */
  efirma_password: Scalars['String']['input'];
  employer_registration_id?: InputMaybe<Scalars['ID']['input']>;
  idse_password: Scalars['String']['input'];
  idse_username: Scalars['String']['input'];
  /** Contenido del archivo `.key` en base64. */
  key_file?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateIdseEfirmaResponse = {
  __typename?: 'ValidateIdseEfirmaResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: ValidateIdseEfirmaType;
};

export type ValidateIdseEfirmaResult = InternalErrorResponse | UserPermissionErrorResponse | ValidateIdseEfirmaResponse | ValidationErrorResponse;

/** Lo que se leyo del certificado al validarlo. Los campos `pfx_*` se conservan con el mismo valor que sus equivalentes `certificate_*`: la e.firma ya no se recibe como PFX (PAYR-654), pero el nombre viejo sigue sirviendose para no romper a quien todavia lo lee. */
export type ValidateIdseEfirmaType = {
  __typename?: 'ValidateIdseEfirmaType';
  /** Dias que faltan para el vencimiento. Sirve para avisar a tiempo. */
  certificate_days_until_expiration?: Maybe<Scalars['Int']['output']>;
  /** Vencimiento leido del propio certificado. */
  certificate_expires_at?: Maybe<Scalars['Date']['output']>;
  /** Siempre falso en una validacion que tuvo exito: un certificado vencido se rechaza en vez de devolverse como valido. */
  certificate_is_expired: Scalars['Boolean']['output'];
  /** Numero de serie del certificado. */
  certificate_serial_number?: Maybe<Scalars['String']['output']>;
  is_valid: Scalars['Boolean']['output'];
  /**
   * Mismo valor que `certificate_days_until_expiration`.
   * @deprecated Usa certificate_days_until_expiration.
   */
  pfx_days_until_expiration?: Maybe<Scalars['Int']['output']>;
  /**
   * Mismo valor que `certificate_expires_at`.
   * @deprecated Usa certificate_expires_at.
   */
  pfx_expires_at?: Maybe<Scalars['Date']['output']>;
  /**
   * Mismo valor que `certificate_is_expired`.
   * @deprecated Usa certificate_is_expired.
   */
  pfx_is_expired: Scalars['Boolean']['output'];
  /**
   * Mismo valor que `certificate_serial_number`.
   * @deprecated Usa certificate_serial_number.
   */
  pfx_serial_number?: Maybe<Scalars['String']['output']>;
};

export type ValidateImssInput = {
  centralized_organization_id: Scalars['ID']['input'];
  imss: Scalars['String']['input'];
};

export type ValidateImssMovementInput = {
  legal_entity_id: Scalars['UUID']['input'];
  movement_id: Scalars['UUID']['input'];
};

export type ValidateImssMovementResponse = {
  __typename?: 'ValidateImssMovementResponse';
  graphql_operation_id: Scalars['ID']['output'];
  result: ImssMovementDetail;
};

export type ValidateImssMovementResult = InternalErrorResponse | NotFoundErrorResponse | UserPermissionErrorResponse | ValidateImssMovementResponse | ValidationErrorResponse;

export type ValidateImssMovementsBatchInput = {
  legal_entity_id: Scalars['UUID']['input'];
  movement_ids: Array<Scalars['UUID']['input']>;
};

export type ValidateImssMovementsBatchResponse = {
  __typename?: 'ValidateImssMovementsBatchResponse';
  errors: Array<BatchOperationError>;
  graphql_operation_id: Scalars['ID']['output'];
  validated: Scalars['Int']['output'];
};

export type ValidateImssMovementsBatchResult = InternalErrorResponse | UserPermissionErrorResponse | ValidateImssMovementsBatchResponse;

/** Validar internal_id (existencia, scope organización). */
export type ValidateInternalIdInput = {
  /** ID de la organización centralizada */
  centralized_organization_id: Scalars['ID']['input'];
  /** Excluir esta razón social (edición) */
  exclude_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID interno a validar */
  internal_id: Scalars['String']['input'];
};

/** Validar legal_name (existencia, scope organización). */
export type ValidateLegalNameInput = {
  /** ID de la organización centralizada */
  centralized_organization_id: Scalars['ID']['input'];
  /** Excluir esta razón social (edición) */
  exclude_id?: InputMaybe<Scalars['ID']['input']>;
  /** Razón social a validar */
  legal_name: Scalars['String']['input'];
};

export type ValidateManualRolUserAssignmentError = {
  __typename?: 'ValidateManualRolUserAssignmentError';
  email: Scalars['String']['output'];
  error: Scalars['String']['output'];
  permission_group_name?: Maybe<Scalars['String']['output']>;
};

export type ValidateManualRolUserAssignmentResponse = {
  __typename?: 'ValidateManualRolUserAssignmentResponse';
  invalid_emails: Array<ValidateManualRolUserAssignmentError>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  users_in_other_rol: Array<ValidateManualRolUserAssignmentError>;
  valid_emails: Array<Scalars['String']['output']>;
};

export type ValidateMassiveAssignmentDocumentInput = {
  centralized_organization_id: Scalars['Int']['input'];
  document_id: Scalars['Int']['input'];
  file_id: Scalars['Int']['input'];
};

export type ValidateMassiveAssignmentFolderInput = {
  centralized_organization_id: Scalars['Int']['input'];
  file_id: Scalars['Int']['input'];
  folder_id: Scalars['Int']['input'];
};

export type ValidateMassiveCreateOrganizationAreaExcelFileResponse = {
  __typename?: 'ValidateMassiveCreateOrganizationAreaExcelFileResponse';
  existing_records: Scalars['JSON']['output'];
  existing_records_count: Scalars['Int']['output'];
  input_to_create_areas: Scalars['JSON']['output'];
  invalid_headers: Scalars['JSON']['output'];
  invalid_records: Scalars['JSON']['output'];
  invalid_records_count: Scalars['Int']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  valid_headers: Array<Scalars['String']['output']>;
  valid_records: Scalars['JSON']['output'];
  valid_records_count: Scalars['Int']['output'];
};

export type ValidateMassiveCreateUserExcelFileResponse = {
  __typename?: 'ValidateMassiveCreateUserExcelFileResponse';
  invalid_headers: Scalars['JSON']['output'];
  invalid_records: Scalars['JSON']['output'];
  invalid_records_count: Scalars['Int']['output'];
  missing_headers: Scalars['JSON']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  total_records_count: Scalars['Int']['output'];
  valid_headers: Scalars['JSON']['output'];
  valid_records: Array<Scalars['String']['output']>;
  valid_records_count: Scalars['Int']['output'];
  warning_records: Scalars['JSON']['output'];
  warning_records_count: Scalars['Int']['output'];
};

/** Centralized User - Massive Creation Error Response Node */
export type ValidateMassiveCreationTeamsErrorResponseNode = {
  __typename?: 'ValidateMassiveCreationTeamsErrorResponseNode';
  code: Scalars['Int']['output'];
  errors: Array<ValidationErrorCreationTeamsResponseNode>;
  message: Scalars['String']['output'];
};

export type ValidateMassiveCreationTeamsResponse = {
  __typename?: 'ValidateMassiveCreationTeamsResponse';
  error_response?: Maybe<Array<ValidateMassiveCreationTeamsErrorResponseNode>>;
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  valid_teams?: Maybe<Array<ValidationCreationTeamsResponseNode>>;
  valid_teams_count?: Maybe<Scalars['Int']['output']>;
  validation_response?: Maybe<MassiveCreationTeamsInfoValidationResponse>;
};

export type ValidateMassiveDeactivateUserExcelFileResponse = {
  __typename?: 'ValidateMassiveDeactivateUserExcelFileResponse';
  invalid_headers: Scalars['JSON']['output'];
  invalid_records: Scalars['JSON']['output'];
  invalid_records_count: Scalars['Int']['output'];
  missing_headers: Scalars['JSON']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  total_records_count: Scalars['Int']['output'];
  valid_headers: Scalars['JSON']['output'];
  valid_records: Array<Scalars['String']['output']>;
  valid_records_count: Scalars['Int']['output'];
  warning_records: Scalars['JSON']['output'];
  warning_records_count: Scalars['Int']['output'];
};

/** Resultado de la validación de carga masiva de restricciones de sede (CORE-1726): usuarios con nuevas reglas (valid), con actualizaciones (warning_groups) y errores agrupados por tipo (error_groups). */
export type ValidateMassiveManagedHeadquartersResponse = {
  __typename?: 'ValidateMassiveManagedHeadquartersResponse';
  error_groups: Array<ErrorGroupType>;
  invalid_records_count: Scalars['Int']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  summary: ValidateErrorSummaryType;
  total_records_count: Scalars['Int']['output'];
  valid_records: Array<Scalars['String']['output']>;
  valid_records_count: Scalars['Int']['output'];
  warning_groups: Array<ErrorGroupType>;
  warning_records_count: Scalars['Int']['output'];
};

export type ValidateMassiveOrganizationPositionsExcelInput = {
  file_url: Scalars['String']['input'];
  organization_slug: Scalars['String']['input'];
};

export type ValidateMassiveUploadAssignmentInput = {
  /** List of document names to validate assignment for */
  document_names: Array<Scalars['String']['input']>;
  /** Excel file ID with configuration (null = use default config) */
  excel_file_id?: InputMaybe<Scalars['Int']['input']>;
  /** Organization ID */
  organization_id: Scalars['Int']['input'];
  /** UUID of the upload session */
  upload_uuid: Scalars['String']['input'];
};

export type ValidateMassiveUploadAssignmentPayload = {
  __typename?: 'ValidateMassiveUploadAssignmentPayload';
  /** List of errors (blocking) */
  errors: Array<ErrorAssignment>;
  /** GraphQL operation ID for tracking */
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** Summary of validation results */
  summary: AssignmentSummary;
  /** List of valid assignments */
  valid: Array<ValidAssignment>;
  /** List of warnings (non-blocking) */
  warnings: Array<WarningAssignment>;
};

export type ValidateMassiveUploadConfigInput = {
  /** Organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** List of configuration items to validate */
  items: Array<MassiveUploadConfigItemInput>;
  /** Unique identifier for the upload session */
  upload_uuid: Scalars['String']['input'];
};

export type ValidateMassiveUploadConfigPayload = {
  __typename?: 'ValidateMassiveUploadConfigPayload';
  /** List of items that failed validation */
  errors: Array<ConfigValidationError>;
  /** GraphQL operation ID for tracking */
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** Count of items with errors */
  total_errors: Scalars['Int']['output'];
  /** Count of valid items */
  total_valid: Scalars['Int']['output'];
  /** List of items that passed validation */
  valid: Array<ValidConfigItem>;
};

export type ValidateMassiveUploadMetadataInput = {
  /** Organization ID for the upload */
  centralized_organization_id: Scalars['Int']['input'];
  /** List of file metadata to validate (batch) */
  files: Array<FileMetadataInput>;
  /** Unique identifier for the upload session */
  upload_uuid: Scalars['String']['input'];
};

export type ValidateMassiveUploadMetadataPayload = {
  __typename?: 'ValidateMassiveUploadMetadataPayload';
  /** List of files that failed validation */
  errors: Array<FileValidationError>;
  /** GraphQL operation ID for tracking */
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  /** Count of files with errors */
  total_errors: Scalars['Int']['output'];
  /** Count of valid files */
  total_valid: Scalars['Int']['output'];
  /** List of files that passed validation */
  valid: Array<ValidFileMetadata>;
};

export type ValidateOrganizationAreaResponse = {
  __typename?: 'ValidateOrganizationAreaResponse';
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  validation?: Maybe<ValidateOrganizationAreaValidations>;
};

export type ValidateOrganizationAreaValidations = {
  __typename?: 'ValidateOrganizationAreaValidations';
  action: CrudActionEnum;
  code?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  level_sequence?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['Int']['output']>;
};

export type ValidatePaymentOrderDatafastInput = {
  order_id: Scalars['Int']['input'];
  resource_path?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
};

export type ValidatePaymentOrderDatafastResponse = {
  __typename?: 'ValidatePaymentOrderDatafastResponse';
  redirect_url: Scalars['String']['output'];
};

export type ValidatePaymentOrderDatafastResponsePaymentErrorNode = PaymentErrorNode | ValidatePaymentOrderDatafastResponse;

export type ValidatePositionsDownloadLink = {
  __typename?: 'ValidatePositionsDownloadLink';
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ValidatePositionsErrorSummary = {
  __typename?: 'ValidatePositionsErrorSummary';
  error_groups: Scalars['Int']['output'];
  total_errors: Scalars['Int']['output'];
};

export type ValidatePositionsExcelFileResponse = {
  __typename?: 'ValidatePositionsExcelFileResponse';
  downloadLinks?: Maybe<Array<ValidatePositionsDownloadLink>>;
  error_groups: Array<ValidatePositionsGroupedError>;
  invalid_records_count: Scalars['Int']['output'];
  linkedDataToCreate?: Maybe<LinkedDataToCreate>;
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  summary: ValidatePositionsErrorSummary;
  total_records_count: Scalars['Int']['output'];
  valid_records: Array<Scalars['String']['output']>;
  valid_records_count: Scalars['Int']['output'];
  warning_records_count: Scalars['Int']['output'];
};

export type ValidatePositionsGroupDetailItem = {
  __typename?: 'ValidatePositionsGroupDetailItem';
  col: Scalars['String']['output'];
  detail: Scalars['String']['output'];
  job_id: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type ValidatePositionsGroupDetails = {
  __typename?: 'ValidatePositionsGroupDetails';
  errors: Array<ValidatePositionsGroupDetailItem>;
  table_headers: Array<Scalars['String']['output']>;
};

export type ValidatePositionsGroupedError = {
  __typename?: 'ValidatePositionsGroupedError';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<ValidatePositionsGroupDetails>;
  job_id?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ValidatePositionsResponse = IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidatePositionsExcelFileResponse | ValidationErrorResponse;

export type ValidateRegistrationNumberInput = {
  centralized_organization_id: Scalars['ID']['input'];
  exclude_id?: InputMaybe<Scalars['ID']['input']>;
  registration_number: Scalars['String']['input'];
};

export type ValidateRegistrationNumberResponse = {
  __typename?: 'ValidateRegistrationNumberResponse';
  /**
   * DEPRECATED (PAYR-258): check-digit validation was removed. Always returns null. Will be removed in a future release.
   * @deprecated Check-digit validation was removed in PAYR-258 — field is kept temporarily to avoid breaking clients that select it.
   */
  check_digit_warning?: Maybe<Scalars['String']['output']>;
  exists: Scalars['Boolean']['output'];
  graphql_operation_id: Scalars['ID']['output'];
  is_valid: Scalars['Boolean']['output'];
};

export type ValidateRegistrationNumberResult = InternalErrorResponse | UserPermissionErrorResponse | ValidateRegistrationNumberResponse | ValidationErrorResponse;

export type ValidateRfcInput = {
  centralized_organization_id: Scalars['ID']['input'];
  rfc: Scalars['String']['input'];
};

export type ValidateSaml2AuthnRequestInput = {
  binding?: Scalars['String']['input'];
  centralized_organization_id: Scalars['ID']['input'];
  relay_state?: InputMaybe<Scalars['String']['input']>;
  saml_request: Scalars['String']['input'];
};

export type ValidateSmartGoalsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  goals_session_id?: InputMaybe<Scalars['ID']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

/** Validar tax_id (existencia global; RFC si MX). */
export type ValidateTaxIdInput = {
  /** Si es 'MX', valida formato RFC antes de unicidad */
  country_code?: InputMaybe<Scalars['String']['input']>;
  /** Excluir esta razón social (edición) */
  exclude_id?: InputMaybe<Scalars['ID']['input']>;
  /** Identificación fiscal a validar */
  tax_id: Scalars['String']['input'];
};

export type ValidateTeamNameResponse = {
  __typename?: 'ValidateTeamNameResponse';
  graphql_operation_id: Scalars['ID']['output'];
  response: ResponseNodeExtra;
  team_exists?: Maybe<Scalars['Boolean']['output']>;
};

export type ValidateUserTeamAssignmentErrorData = {
  __typename?: 'ValidateUserTeamAssignmentErrorData';
  file_id?: Maybe<Scalars['Int']['output']>;
  invalid_format: ValidateUserTeamAssignmentErrorDetailData;
  not_found: ValidateUserTeamAssignmentErrorDetailData;
  total_errors: Scalars['Int']['output'];
};

export type ValidateUserTeamAssignmentErrorDetailData = {
  __typename?: 'ValidateUserTeamAssignmentErrorDetailData';
  emails: Array<Scalars['String']['output']>;
  total_errors: Scalars['Int']['output'];
};

export type ValidateUserTeamAssignmentInput = {
  action?: InputMaybe<ActionType>;
  file_id: Scalars['Int']['input'];
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  organization_team_id: Scalars['ID']['input'];
};

export type ValidateUserTeamAssignmentPayload = {
  __typename?: 'ValidateUserTeamAssignmentPayload';
  assign_organization_user_file_id: Scalars['Int']['output'];
  error_data: ValidateUserTeamAssignmentErrorData;
  parent_file_id?: Maybe<Scalars['Int']['output']>;
  success_data: ValidateUserTeamAssignmentSuccessData;
};

export type ValidateUserTeamAssignmentResponse = AssignmentEmptyTemplateResponseError | AssignmentInvalidTemplateResponseError | AssignmentNotFoundTemplateResponseError | ResponseIntegrityError | ResponseInternalError | ResponseValidationError | ValidateUserTeamAssignmentPayload;

export type ValidateUserTeamAssignmentSuccessData = {
  __typename?: 'ValidateUserTeamAssignmentSuccessData';
  file_id?: Maybe<Scalars['Int']['output']>;
  number_emails: Scalars['Int']['output'];
};

export type ValidateUsersOrganizationResponse = {
  __typename?: 'ValidateUsersOrganizationResponse';
  invalid_records: Scalars['JSON']['output'];
  invalid_records_count: Scalars['Int']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  total_records_count: Scalars['Int']['output'];
  valid_records: Array<Scalars['String']['output']>;
  valid_records_count: Scalars['Int']['output'];
};

export type ValidateUsersOrganizationResponseV2 = {
  __typename?: 'ValidateUsersOrganizationResponseV2';
  error_groups: Array<ErrorGroupType>;
  invalid_records_count: Scalars['Int']['output'];
  response: ResponseNodeExtra;
  success: Scalars['Boolean']['output'];
  summary: ValidateErrorSummaryType;
  total_records_count: Scalars['Int']['output'];
  valid_records: Array<Scalars['String']['output']>;
  valid_records_count: Scalars['Int']['output'];
};

/** Centralized User - Massive Creation teams Response Detail Node */
export type ValidationCreationTeamsMembersResponseNode = {
  __typename?: 'ValidationCreationTeamsMembersResponseNode';
  email: Scalars['String']['output'];
  role_type: TeamRoleTypeEnum;
  user_id: Scalars['Int']['output'];
};

/** Centralized User - Massive Creation teams Response Node */
export type ValidationCreationTeamsResponseNode = {
  __typename?: 'ValidationCreationTeamsResponseNode';
  creation_method: MethodCreationTeams;
  description: Scalars['String']['output'];
  members: Array<ValidationCreationTeamsMembersResponseNode>;
  name: Scalars['String']['output'];
  participants_selection_method: MethodCreationMembers;
};

export enum ValidationEmailAction {
  ActionAssignment = 'ACTION_ASSIGNMENT',
  ActionUnassignment = 'ACTION_UNASSIGNMENT'
}

/** Centralized User - Massive Creation teams Detail Error Response Node */
export type ValidationErrorCreationTeamsDetailErrorResponseNode = {
  __typename?: 'ValidationErrorCreationTeamsDetailErrorResponseNode';
  email?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  team_name?: Maybe<Scalars['String']['output']>;
};

/** Centralized User - Massive Creation teams Error Response Node */
export type ValidationErrorCreationTeamsResponseNode = {
  __typename?: 'ValidationErrorCreationTeamsResponseNode';
  count: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  sub_code: Scalars['Int']['output'];
  sub_errors?: Maybe<Array<ValidationErrorCreationTeamsDetailErrorResponseNode>>;
};

export type ValidationErrorInput = {
  document_name: Scalars['String']['input'];
  error_code: Scalars['String']['input'];
  error_message: Scalars['String']['input'];
};

/** Returned when a response validation error occurs (400). */
export type ValidationErrorResponse = {
  __typename?: 'ValidationErrorResponse';
  /** Error code */
  code: Scalars['String']['output'];
  /** Operation ID for tracing */
  graphql_operation_id: Scalars['ID']['output'];
  /** Error message */
  message: Scalars['String']['output'];
};

/** ErrorType: Poorly formatted, invalid or inconsistent data */
export type ValidationErrorV2 = {
  __typename?: 'ValidationErrorV2';
  code: Scalars['String']['output'];
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type ValidationMutationError = {
  __typename?: 'ValidationMutationError';
  errors: Array<Scalars['String']['output']>;
};

export type Video = {
  __typename?: 'Video';
  code: Scalars['String']['output'];
  duration?: Maybe<Scalars['Decimal']['output']>;
  input_key?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type VideoFile = {
  __typename?: 'VideoFile';
  absolute_url?: Maybe<Scalars['String']['output']>;
  bucket_name?: Maybe<Scalars['String']['output']>;
  content_type: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  download_url?: Maybe<Scalars['String']['output']>;
  file_path?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  relative_url?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type VideoJobInput = {
  is_legacy?: InputMaybe<Scalars['Boolean']['input']>;
  video_id: Scalars['Int']['input'];
  video_lecture_id: Scalars['Int']['input'];
};

export type VideoJobPayload = {
  __typename?: 'VideoJobPayload';
  metadata: Scalars['JSON']['output'];
};

export type VideoJobProcessResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | VideoJobPayload;

export type VideoKeyInput = {
  video_code: Scalars['String']['input'];
  video_id?: InputMaybe<Scalars['Int']['input']>;
  video_lecture_id?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoKeyPayload = {
  __typename?: 'VideoKeyPayload';
  content: Scalars['String']['output'];
  content_type: Scalars['String']['output'];
  has_cache?: Maybe<Scalars['Boolean']['output']>;
  video_code: Scalars['String']['output'];
};

export type VideoKeyResponse = ResponseIntegrityError | ResponseInternalError | ResponseValidationError | VideoKeyPayload;

export enum VideoLanguageEnum {
  VideoLanguageEn = 'VIDEO_LANGUAGE_EN',
  VideoLanguageEs = 'VIDEO_LANGUAGE_ES',
  VideoLanguagePt = 'VIDEO_LANGUAGE_PT'
}

export type VideoLectureClassType = {
  __typename?: 'VideoLectureClassType';
  subtitle_file?: Maybe<Scalars['String']['output']>;
  subtitle_language?: Maybe<Scalars['String']['output']>;
  video_file?: Maybe<Scalars['String']['output']>;
  video_hashed_id?: Maybe<Scalars['String']['output']>;
  video_optimized?: Maybe<Scalars['String']['output']>;
};

export type VideoLectureDeletePayload = VideoLectureTypePdfGraphOperationI & {
  __typename?: 'VideoLectureDeletePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  video_lecture: VideoLectureType;
};

export type VideoLectureDeleteResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | VideoLectureDeletePayload;

export type VideoLectureIframeInput = {
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  organization_id: Scalars['String']['input'];
  unit_name: Scalars['String']['input'];
  video_lecture_id: Scalars['String']['input'];
  web_address?: InputMaybe<Scalars['String']['input']>;
};

export type VideoLectureIframeResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | VideoLectureTypeIframePayload;

export type VideoLectureIframeType = {
  __typename?: 'VideoLectureIframeType';
  complete: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  unit_name: Scalars['String']['output'];
  video_lecture_id: Scalars['ID']['output'];
  web_address?: Maybe<Scalars['String']['output']>;
};

export type VideoLectureInput = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  module_id: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  video_content_type?: InputMaybe<Scalars['String']['input']>;
  video_type?: InputMaybe<VideoLectureTypeEnum>;
};

export type VideoLectureMapInput = {
  source_id: Scalars['ID']['input'];
  target_id: Scalars['ID']['input'];
};

export type VideoLectureOptions = {
  __typename?: 'VideoLectureOptions';
  class_note_ai_suggestion: Scalars['Boolean']['output'];
};

export type VideoLecturePdfInput = {
  attachment_id: Scalars['String']['input'];
  organization_id: Scalars['String']['input'];
  private?: InputMaybe<Scalars['Boolean']['input']>;
  video_lecture_id: Scalars['String']['input'];
};

export type VideoLecturePdfResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | VideoLectureTypePdfPayload;

export type VideoLecturePdfType = {
  __typename?: 'VideoLecturePDFType';
  attachment_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  private: Scalars['Boolean']['output'];
  video_lecture_id: Scalars['ID']['output'];
};

export type VideoLecturePayload = VideoLectureTypePdfGraphOperationI & {
  __typename?: 'VideoLecturePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  video_lectures?: Maybe<Array<VideoLectureType>>;
};

export type VideoLectureQuizInput = {
  course_id?: InputMaybe<Scalars['ID']['input']>;
  enrollment_id?: InputMaybe<Scalars['ID']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  video_lecture_id: Scalars['ID']['input'];
};

export type VideoLectureResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | VideoLecturePayload;

export type VideoLectureSessionType = {
  __typename?: 'VideoLectureSessionType';
  course_id?: Maybe<Scalars['ID']['output']>;
  course_title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  live_session: LiveSessionType;
  module_name?: Maybe<Scalars['String']['output']>;
  video_lecture_id: Scalars['ID']['output'];
};

export enum VideoLectureSubComponentTypeEnum {
  VideoLectureBreak = 'VIDEO_LECTURE_BREAK',
  VideoLectureClass = 'VIDEO_LECTURE_CLASS',
  VideoLectureExercise = 'VIDEO_LECTURE_EXERCISE',
  VideoLectureIframe = 'VIDEO_LECTURE_IFRAME',
  VideoLectureLiveSession = 'VIDEO_LECTURE_LIVE_SESSION',
  VideoLecturePdf = 'VIDEO_LECTURE_PDF',
  VideoLectureQuiz = 'VIDEO_LECTURE_QUIZ',
  VideoLectureScorm = 'VIDEO_LECTURE_SCORM',
  VideoLectureSurvey = 'VIDEO_LECTURE_SURVEY'
}

export type VideoLectureSurveyInput = {
  organization_id: Scalars['String']['input'];
  video_lecture_id: Scalars['String']['input'];
};

export type VideoLectureSurveyResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | VideoLectureTypeSurveyPayload;

export type VideoLectureSurveyType = {
  __typename?: 'VideoLectureSurveyType';
  id: Scalars['ID']['output'];
  question_type_enum: QuestionTypeEnum;
  video_lecture_id: Scalars['ID']['output'];
};

export type VideoLectureType = {
  __typename?: 'VideoLectureType';
  created_date?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  lesson_detail?: Maybe<VideoLectureTypeFragment>;
  order: Scalars['Int']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  show_player_logo?: Maybe<Scalars['Boolean']['output']>;
  subtitle_file?: Maybe<Scalars['String']['output']>;
  subtitle_language?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated_date?: Maybe<Scalars['DateTime']['output']>;
  video_content_type?: Maybe<Scalars['String']['output']>;
  video_file?: Maybe<Scalars['String']['output']>;
  video_hashed_id?: Maybe<Scalars['String']['output']>;
  video_optimized?: Maybe<Scalars['String']['output']>;
  video_size?: Maybe<Scalars['Int']['output']>;
  video_type?: Maybe<Scalars['String']['output']>;
  video_type_enum?: Maybe<VideoLectureTypeEnum>;
};

export type VideoLectureTypeBuilderMutations = {
  __typename?: 'VideoLectureTypeBuilderMutations';
  /** Mutation to create a VideoLecture. */
  create_video_lecture: VideoLectureResponse;
  /** Mutation to create a VideoLectureTypeIframe. */
  create_video_lecture_type_iframe: VideoLectureIframeResponse;
  /** Mutation to create a VideoLectureTypePdf. */
  create_video_lecture_type_pdf: VideoLecturePdfResponse;
  /** Mutation to create a VideoLectureTypeSurvey. */
  create_video_lecture_type_survey: VideoLectureSurveyResponse;
  /** Mutation to delete a VideoLecture. */
  delete_video_lecture: VideoLectureDeleteResponse;
  /** Mutation to update a VideoLecture. */
  update_video_lecture: VideoLectureUpdateResponse;
};


export type VideoLectureTypeBuilderMutationsCreate_Video_LectureArgs = {
  input: CreateVideoLectureInput;
};


export type VideoLectureTypeBuilderMutationsCreate_Video_Lecture_Type_IframeArgs = {
  input: VideoLectureIframeInput;
};


export type VideoLectureTypeBuilderMutationsCreate_Video_Lecture_Type_PdfArgs = {
  input: VideoLecturePdfInput;
};


export type VideoLectureTypeBuilderMutationsCreate_Video_Lecture_Type_SurveyArgs = {
  input: VideoLectureSurveyInput;
};


export type VideoLectureTypeBuilderMutationsDelete_Video_LectureArgs = {
  input: DeleteVideoLectureInput;
};


export type VideoLectureTypeBuilderMutationsUpdate_Video_LectureArgs = {
  input: UpdateVideoLectureInput;
};

export enum VideoLectureTypeEnum {
  VideoLectureBreak = 'VIDEO_LECTURE_BREAK',
  VideoLectureClass = 'VIDEO_LECTURE_CLASS',
  VideoLectureExercise = 'VIDEO_LECTURE_EXERCISE',
  VideoLectureH5P = 'VIDEO_LECTURE_H5P',
  VideoLectureIframe = 'VIDEO_LECTURE_IFRAME',
  VideoLectureLiveSession = 'VIDEO_LECTURE_LIVE_SESSION',
  VideoLecturePdf = 'VIDEO_LECTURE_PDF',
  VideoLectureQuiz = 'VIDEO_LECTURE_QUIZ',
  VideoLectureScorm = 'VIDEO_LECTURE_SCORM',
  VideoLectureSurvey = 'VIDEO_LECTURE_SURVEY'
}

export type VideoLectureTypeFragment = ScormType | VideoLectureClassType | VideoLectureIframeType | VideoLecturePdfType | VideoLectureSessionType | VideoLectureSurveyType;

export type VideoLectureTypeIframePayload = VideoLectureTypePdfGraphOperationI & {
  __typename?: 'VideoLectureTypeIframePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  video_lecture_iframe?: Maybe<VideoLectureIframeType>;
};

export type VideoLectureTypePdfGraphOperationI = {
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
};

export type VideoLectureTypePdfPayload = VideoLectureTypePdfGraphOperationI & {
  __typename?: 'VideoLectureTypePDFPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  video_lecture_pdf?: Maybe<VideoLecturePdfType>;
};

export type VideoLectureTypeSurveyPayload = VideoLectureTypePdfGraphOperationI & {
  __typename?: 'VideoLectureTypeSurveyPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  video_lecture_survey?: Maybe<VideoLectureSurveyType>;
};

export type VideoLectureUpdateInput = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  module_id: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  video_content_type?: InputMaybe<Scalars['String']['input']>;
  video_hashed_id?: InputMaybe<Scalars['String']['input']>;
  video_type?: InputMaybe<VideoLectureTypeEnum>;
};

export type VideoLectureUpdatePayload = VideoLectureTypePdfGraphOperationI & {
  __typename?: 'VideoLectureUpdatePayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  updated_count: Scalars['Int']['output'];
  video_lectures?: Maybe<Array<VideoLectureType>>;
};

export type VideoLectureUpdateResponse = MutationIntegrityExistsError | MutationInternalExistsError | MutationValidationExistsError | VideoLectureUpdatePayload;

export type VideoLectureUserQuizFormPayload = GraphOperationI & {
  __typename?: 'VideoLectureUserQuizFormPayload';
  graphql_operation_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<BaseMetaDataNode>;
  video_lecture_quiz: VideoLectureUserQuizFormType;
};

export type VideoLectureUserQuizFormType = BaseEnrollmentUserQuizFormI & {
  __typename?: 'VideoLectureUserQuizFormType';
  approved_at?: Maybe<Scalars['DateTime']['output']>;
  attempts: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_closed: Scalars['Boolean']['output'];
  last_record_attempts?: Maybe<Scalars['Int']['output']>;
  quiz: QuizType;
  quiz_form_id?: Maybe<Scalars['Int']['output']>;
  status: UserQuizFormStatusEnum;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type VideoOptions = {
  __typename?: 'VideoOptions';
  aspect_ratio?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  orientation: VideoOrientationEnum;
  video_lecture_id: Scalars['ID']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export enum VideoOrientationEnum {
  VideoOrientationLandspace = 'VIDEO_ORIENTATION_LANDSPACE',
  VideoOrientationPortrait = 'VIDEO_ORIENTATION_PORTRAIT'
}

export type VideoProcess = {
  __typename?: 'VideoProcess';
  category: VideoProcessCategoryEnum;
  created_at: Scalars['DateTime']['output'];
  status: VideoProcessStatusEnum;
  uid: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
  video_lecture_id: Scalars['ID']['output'];
};

export enum VideoProcessCategoryEnum {
  VideoProcessCategoryOptimize = 'VIDEO_PROCESS_CATEGORY_OPTIMIZE',
  VideoProcessCategorySubtitle = 'VIDEO_PROCESS_CATEGORY_SUBTITLE',
  VideoProcessCategoryTranscoder = 'VIDEO_PROCESS_CATEGORY_TRANSCODER',
  VideoProcessCategoryTranscript = 'VIDEO_PROCESS_CATEGORY_TRANSCRIPT',
  VideoProcessCategoryTranscriptSegments = 'VIDEO_PROCESS_CATEGORY_TRANSCRIPT_SEGMENTS',
  VideoProcessCategoryTranscriptSummary = 'VIDEO_PROCESS_CATEGORY_TRANSCRIPT_SUMMARY'
}

export enum VideoProcessStatusEnum {
  VideoProcessStatusCanceled = 'VIDEO_PROCESS_STATUS_CANCELED',
  VideoProcessStatusException = 'VIDEO_PROCESS_STATUS_EXCEPTION',
  VideoProcessStatusFailed = 'VIDEO_PROCESS_STATUS_FAILED',
  VideoProcessStatusPending = 'VIDEO_PROCESS_STATUS_PENDING',
  VideoProcessStatusQueue = 'VIDEO_PROCESS_STATUS_QUEUE',
  VideoProcessStatusRetried = 'VIDEO_PROCESS_STATUS_RETRIED',
  VideoProcessStatusSuccessed = 'VIDEO_PROCESS_STATUS_SUCCESSED',
  VideoProcessStatusTimeout = 'VIDEO_PROCESS_STATUS_TIMEOUT'
}

export type VideoProgressMutations = {
  __typename?: 'VideoProgressMutations';
  create_video_progress: CreateVideoProgressResponse;
};


export type VideoProgressMutationsCreate_Video_ProgressArgs = {
  input: CreateVideoProgressInput;
};

export type VideoProgressNode = {
  __typename?: 'VideoProgressNode';
  date_completed?: Maybe<Scalars['DateTime']['output']>;
  date_started: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  progress: Scalars['Int']['output'];
  user_id: Scalars['ID']['output'];
  video_lecture_id: Scalars['ID']['output'];
};

export type VideoQuery = {
  __typename?: 'VideoQuery';
  get_video_options?: Maybe<VideoOptions>;
};


export type VideoQueryGet_Video_OptionsArgs = {
  video_lecture_id: Scalars['ID']['input'];
};

export type VideoTranscript = {
  __typename?: 'VideoTranscript';
  category?: Maybe<VideoTranscriptCategoryEnum>;
  course_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  module_id: Scalars['ID']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  text_parts: Array<Scalars['String']['output']>;
  uid: Scalars['ID']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
  video_lecture_id: Scalars['ID']['output'];
};

export enum VideoTranscriptCategoryEnum {
  VideoClosure = 'VIDEO_CLOSURE',
  VideoExplanation = 'VIDEO_EXPLANATION',
  VideoIntroduction = 'VIDEO_INTRODUCTION'
}

export type VideoTranscriptSegment = {
  __typename?: 'VideoTranscriptSegment';
  avg_logprob?: Maybe<Scalars['Float']['output']>;
  compression_ratio?: Maybe<Scalars['Float']['output']>;
  end: Scalars['Float']['output'];
  no_speech_prob?: Maybe<Scalars['Float']['output']>;
  seek: Scalars['Float']['output'];
  segment_group: VideoTranscriptSegmentGroup;
  segment_id: Scalars['Int']['output'];
  start: Scalars['Float']['output'];
  temperature?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  tokens?: Maybe<Scalars['String']['output']>;
  uid: Scalars['ID']['output'];
};

export type VideoTranscriptSegmentGroup = {
  __typename?: 'VideoTranscriptSegmentGroup';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  uid: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
  video_transcript: VideoTranscript;
};

export type VideosMediaConvertMutation = {
  __typename?: 'VideosMediaConvertMutation';
  create_job_hls: VideoJobProcessResponse;
  create_job_mp4: VideoJobProcessResponse;
};


export type VideosMediaConvertMutationCreate_Job_HlsArgs = {
  input: VideoJobInput;
};


export type VideosMediaConvertMutationCreate_Job_Mp4Args = {
  input: VideoJobInput;
};

export type VideosMediaConvertQuery = {
  __typename?: 'VideosMediaConvertQuery';
  /** Query to get email templates for the admin interface */
  get_video_key_decrypt: VideoKeyResponse;
};


export type VideosMediaConvertQueryGet_Video_Key_DecryptArgs = {
  input: VideoKeyInput;
};

/** Input del panel de sedes permitidas del solicitante. */
export type ViewerAllowedHeadquartersInput = {
  /** Organización objetivo. Aísla el panel por organización. */
  centralized_organization_id: Scalars['Int']['input'];
};

/** Panel de sedes permitidas del solicitante con conteo por sede. */
export type ViewerAllowedHeadquartersPayload = {
  __typename?: 'ViewerAllowedHeadquartersPayload';
  headquarters: Array<AllowedHeadquarterNode>;
  /** True si el solicitante tiene restricción de sedes activa. Úsalo para mostrar u ocultar el panel: NO se puede inferir de `headquarters`, porque un solicitante sin restricción recibe todas las sedes de la organización (lista no vacía). Un solicitante restringido cuyas sedes fueron eliminadas de la organización devuelve True con `headquarters` vacío: sigue restringido y no ve a nadie. */
  viewer_is_restricted: Scalars['Boolean']['output'];
};

export type ViewerAllowedHeadquartersPayloadNotAuthenticatedErrorResponseValidationErrorResponseInternalErrorResponse = InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse | ViewerAllowedHeadquartersPayload;

export enum VisibilityLevelType {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED'
}

export type WarningAssignment = {
  __typename?: 'WarningAssignment';
  /** Excel cell reference */
  cell: Scalars['String']['output'];
  /** Document name */
  document_name: Scalars['String']['output'];
  /** Warning message */
  message: Scalars['String']['output'];
};

export type WebhookReplyWhatsappTwilioInput = {
  account_sid: Scalars['String']['input'];
  api_version: Scalars['String']['input'];
  message_body: Scalars['String']['input'];
  message_from: Scalars['String']['input'];
  message_sid: Scalars['String']['input'];
  message_to: Scalars['String']['input'];
  message_type: Scalars['String']['input'];
  profile_name: Scalars['String']['input'];
  whatsapp_id: Scalars['String']['input'];
};

export type WebhookTwilioWhatsapInput = {
  account_sid: Scalars['String']['input'];
  api_version: Scalars['String']['input'];
  message_body: Scalars['String']['input'];
  message_from: Scalars['String']['input'];
  message_sid: Scalars['String']['input'];
  message_to: Scalars['String']['input'];
  message_type: Scalars['String']['input'];
  profile_name: Scalars['String']['input'];
  whatsapp_id: Scalars['String']['input'];
};

export type WorkCenterListResponse = {
  __typename?: 'WorkCenterListResponse';
  graphql_operation_id: Scalars['ID']['output'];
  results: Array<WorkCenterType>;
  total_count: Scalars['Int']['output'];
};

export type WorkCenterType = {
  __typename?: 'WorkCenterType';
  address_1?: Maybe<Scalars['String']['output']>;
  address_2?: Maybe<Scalars['String']['output']>;
  address_3?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  headquarter_id: Scalars['ID']['output'];
  is_main: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** Subgraph HRIS - WorkFlow */
export type WorkFlow = {
  __typename?: 'WorkFlow';
  /** WorkFlow segmentation rules conditionals */
  conditionals: Array<WorkflowConditional>;
  /** Work flow creation date */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** User Related to this Comment */
  created_by?: Maybe<CentralizedUserNode>;
  /** User ID */
  created_by_id: Scalars['Int']['output'];
  /** WorkFlow description */
  description?: Maybe<Scalars['String']['output']>;
  /** WorkFlow ID */
  id: Scalars['ID']['output'];
  /** WorkFlow Name */
  name: Scalars['String']['output'];
  /** Organization ID */
  organization_id: Scalars['ID']['output'];
  /** WorkFlow progress */
  progress: Scalars['Int']['output'];
  /** WorkFlow segment type */
  segment_type: WorkFlowSegmentTypeEnum;
  /** WorkFlow segmentation rule */
  segmentation_rule: WorkFlowSegmentationRoleEnum;
  /** workflow status */
  status: WorkFlowStatusEnum;
  /** Total tasks completed */
  tasks_completed: Scalars['Int']['output'];
  /** Total tasks */
  total_tasks: Scalars['Int']['output'];
  /** List of Triggers */
  triggers: Array<WorkFlowTrigger>;
  /** Work flow update date */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type WorkFlowBlockInput = {
  block_id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notify_by_email?: InputMaybe<WorkFlowBlockNotifyEnum>;
  tasks?: InputMaybe<Array<WorkFlowTaskInput>>;
};

export enum WorkFlowBlockNotifyEnum {
  EmailPerTask = 'EMAIL_PER_TASK',
  NotNotify = 'NOT_NOTIFY',
  OnlyEmail = 'ONLY_EMAIL'
}

export type WorkFlowBlockType = {
  __typename?: 'WorkFlowBlockType';
  /** Work flow detail create date */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** User who created the block */
  created_by: CentralizedUserNode;
  id: Scalars['ID']['output'];
  /** Indicates if this  workflow is active */
  is_active: Scalars['Boolean']['output'];
  /** Is block reused */
  is_reused: Scalars['Boolean']['output'];
  /** WorkFlow block name */
  name: Scalars['String']['output'];
  /** Task notification type */
  notify_by_email: WorkFlowBlockNotifyEnum;
  /** List of task */
  tasks: Array<WorkFlowTaskType>;
  /** Work flow detail update date */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type WorkFlowBlockTypeCustomConnection = {
  __typename?: 'WorkFlowBlockTypeCustomConnection';
  edges: Array<WorkFlowBlockTypeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type WorkFlowBlockTypeCustomEdge = {
  __typename?: 'WorkFlowBlockTypeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: WorkFlowBlockType;
};

export enum WorkFlowCompleteByEnum {
  Leader = 'LEADER',
  SpecificUser = 'SPECIFIC_USER',
  UserMatchesRule = 'USER_MATCHES_RULE'
}

export type WorkFlowConditionalInput = {
  conditional_type: SegmentationConditionalEnum;
  custom_field_id?: InputMaybe<Scalars['Int']['input']>;
  data_type: SegmentationDataTypeEnum;
  values: Scalars['String']['input'];
};

export type WorkFlowCustomConnection = {
  __typename?: 'WorkFlowCustomConnection';
  edges: Array<WorkFlowCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type WorkFlowCustomEdge = {
  __typename?: 'WorkFlowCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: WorkFlow;
};

export type WorkFlowQueries = {
  __typename?: 'WorkFlowQueries';
  /** Gets affected users by triggers information */
  get_affected_users_by_triggers: AffectedUsersByConditionalsNodeCustomConnection;
  /** Gets affected users by triggers information before workflow created */
  get_affected_users_by_triggers_before_workflow: AffectedUsersByConditionalsNodeCustomConnection;
  /** Gets affected users by triggers information */
  get_blocks: WorkFlowBlockTypeCustomConnection;
  /** Get user Tasks */
  get_tasks_by_user: WorkFlowTaskUserTypeCustomConnection;
  /** Get user by task */
  get_users_by_task: WorkFlowTaskUserTypeCustomConnection;
  /** Get Workflow */
  get_workflow?: Maybe<WorkFlow>;
  /** Get Workflows List */
  get_workflows: WorkFlowCustomConnection;
};


export type WorkFlowQueriesGet_Affected_Users_By_TriggersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  workflow_id: Scalars['Int']['input'];
};


export type WorkFlowQueriesGet_Affected_Users_By_Triggers_Before_WorkflowArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  centralized_organization_id: Scalars['Int']['input'];
  conditional_input: Array<GenericConditionalInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  flow_type: WorkFlowTypeEnum;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  trigger_input: CreateWorkFlowTriggerDetail;
  user_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type WorkFlowQueriesGet_BlocksArgs = {
  input: GetWorkflowBlocksInput;
};


export type WorkFlowQueriesGet_Tasks_By_UserArgs = {
  input: GetTasksByUserInput;
};


export type WorkFlowQueriesGet_Users_By_TaskArgs = {
  input: GerUserByTaskInput;
};


export type WorkFlowQueriesGet_WorkflowArgs = {
  input: GetWorkFlowDetailInput;
};


export type WorkFlowQueriesGet_WorkflowsArgs = {
  input: GetWorkFlowsInput;
};

export enum WorkFlowSegmentTypeEnum {
  Dynamic = 'DYNAMIC',
  Static = 'STATIC'
}

export enum WorkFlowSegmentationRoleEnum {
  Restricted = 'RESTRICTED',
  Unrestricted = 'UNRESTRICTED'
}

export enum WorkFlowStatusEnum {
  StatusActive = 'STATUS_ACTIVE',
  StatusCompleted = 'STATUS_COMPLETED',
  StatusDeleted = 'STATUS_DELETED',
  StatusDraft = 'STATUS_DRAFT',
  StatusPaused = 'STATUS_PAUSED'
}

export type WorkFlowTaskInput = {
  complete_by_id?: InputMaybe<Scalars['String']['input']>;
  days_complete_task?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  task_complete_by?: InputMaybe<WorkFlowCompleteByEnum>;
  task_id?: InputMaybe<Scalars['ID']['input']>;
  task_type?: WorkFlowTaskTypeEnum;
  time_limit_complete?: InputMaybe<TaskTimeLimitCompleteEnum>;
};

export enum WorkFlowTaskOrderByEnum {
  CreatedAt = 'CREATED_AT',
  LimitDate = 'LIMIT_DATE',
  Name = 'NAME'
}

export type WorkFlowTaskOrderByInput = {
  column: WorkFlowTaskOrderByEnum;
  direction: OrderDirectionEnum;
};

export type WorkFlowTaskType = {
  __typename?: 'WorkFlowTaskType';
  /** User Related to this Comment */
  complete_by?: Maybe<CentralizedUserNode>;
  /** complete_by_id */
  complete_by_id?: Maybe<Scalars['ID']['output']>;
  /** Work flow task create date */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** days_complete_task */
  days_complete_task?: Maybe<Scalars['Int']['output']>;
  /** WorkFlow task description */
  description?: Maybe<Scalars['String']['output']>;
  /** Task documents */
  documents?: Maybe<Array<DocumentInfoNode>>;
  id: Scalars['ID']['output'];
  /** Indicates if this  task is active */
  is_active: Scalars['Boolean']['output'];
  /** WorkFlow task name */
  name: Scalars['String']['output'];
  /** task progress */
  progress?: Maybe<Scalars['Float']['output']>;
  /** task_complete_by */
  task_complete_by: WorkFlowCompleteByEnum;
  /** task_type */
  task_type: WorkFlowTaskTypeEnum;
  /** time_limit_complete */
  time_limit_complete: TaskTimeLimitCompleteEnum;
  /** Work flow task update date */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export enum WorkFlowTaskTypeEnum {
  CompleteProfile = 'COMPLETE_PROFILE',
  CustomTask = 'CUSTOM_TASK',
  Documents = 'DOCUMENTS'
}

export type WorkFlowTaskUserType = {
  __typename?: 'WorkFlowTaskUserType';
  /** User affected */
  affected_user?: Maybe<CentralizedUserNode>;
  /** Affected user */
  affected_user_id: Scalars['ID']['output'];
  /** Assigned to leader */
  assigned_to_leader?: Maybe<Scalars['Boolean']['output']>;
  /** User assigned */
  assigned_user?: Maybe<CentralizedUserNode>;
  /** Assigned User */
  assigned_user_id: Scalars['ID']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  /** Work flow task create date */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  document_id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated document_id without relationship */
  document_response?: Maybe<DocumentInfoNode>;
  id: Scalars['ID']['output'];
  /** Indicates if this  task is active */
  is_active: Scalars['Boolean']['output'];
  limit_date?: Maybe<Scalars['DateTime']['output']>;
  /** User affected */
  status: WorkFlowUserStatusEnum;
  /** task */
  task: WorkFlowTaskType;
  /** Work flow task update date */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  work_flow_id: Scalars['ID']['output'];
  /** workflow id */
  workflow_id: Scalars['ID']['output'];
  /** workflow task id */
  workflow_task_id: Scalars['ID']['output'];
};

export type WorkFlowTaskUserTypeCustomConnection = {
  __typename?: 'WorkFlowTaskUserTypeCustomConnection';
  edges: Array<WorkFlowTaskUserTypeCustomEdge>;
  /** Pagination data for the connection */
  page_info: CustomPageInfo;
  /** Total count of items */
  total_count: Scalars['Int']['output'];
};

export type WorkFlowTaskUserTypeCustomEdge = {
  __typename?: 'WorkFlowTaskUserTypeCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: WorkFlowTaskUserType;
};

/** Subgraph HRIS - WorkFlow Trigger */
export type WorkFlowTrigger = {
  __typename?: 'WorkFlowTrigger';
  /** List of blocks */
  blocks: Array<WorkFlowBlockType>;
  /** Work flow creation date */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** flow_type */
  flow_type: WorkFlowTypeEnum;
  /** WorkFlow Trigger ID */
  id: Scalars['ID']['output'];
  /** Indicates if the trigger is active */
  is_active: Scalars['Boolean']['output'];
  /** Indicates if this is the starting point */
  is_starting_point: Scalars['Boolean']['output'];
  /** trigger details */
  trigger_detail: WorkFlowTriggerDetailType;
  /** Work flow update date */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** WorkFlow ID */
  work_flow_id: Scalars['ID']['output'];
};

export type WorkFlowTriggerDetailType = {
  __typename?: 'WorkFlowTriggerDetailType';
  /** indicates whether it is applied since its launch. */
  apply_from_launch: Scalars['Boolean']['output'];
  /** Work flow detail create date */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  days_after?: Maybe<Scalars['Int']['output']>;
  days_before?: Maybe<Scalars['Int']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Indicates if this  workflow is active */
  is_active: Scalars['Boolean']['output'];
  months_before?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
  /** trigger_type */
  trigger_type: WorkFlowTriggerTypeEnum;
  /** Work flow detail update date */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  work_flow_trigger_id: Scalars['ID']['output'];
  years_before?: Maybe<Scalars['Int']['output']>;
};

export enum WorkFlowTriggerTypeEnum {
  AfterStartDate = 'AFTER_START_DATE',
  CreateUser = 'CREATE_USER',
  ExitCompany = 'EXIT_COMPANY',
  FirstDayInCompany = 'FIRST_DAY_IN_COMPANY',
  OutTracking = 'OUT_TRACKING',
  PriorStartDate = 'PRIOR_START_DATE'
}

export enum WorkFlowTypeEnum {
  Offboarding = 'OFFBOARDING',
  Onboarding = 'ONBOARDING'
}

export enum WorkFlowUserStatusEnum {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  ReadyToSign = 'READY_TO_SIGN',
  Signed = 'SIGNED'
}

export type WorkLocationType = {
  __typename?: 'WorkLocationType';
  created_at: Scalars['DateTime']['output'];
  employer_registration_id: Scalars['ID']['output'];
  headquarter_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

/** Subgraph HRIS - Workflow Conditional */
export type WorkflowConditional = {
  __typename?: 'WorkflowConditional';
  /** WorkFlow conditional type */
  conditional_type: SegmentationConditionalEnum;
  /** Custom Field ID */
  custom_field_id?: Maybe<Scalars['Int']['output']>;
  /** workflow data type */
  data_type: SegmentationDataTypeEnum;
  /** Workflow Conditional ID */
  id: Scalars['ID']['output'];
  /** Conditional values */
  values: Scalars['String']['output'];
};

export type WorkflowInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  segment_type: WorkFlowSegmentTypeEnum;
  segmentation_rule: WorkFlowSegmentationRoleEnum;
};

export enum WorkflowStage {
  Development = 'DEVELOPMENT',
  None = 'NONE',
  Offboarding = 'OFFBOARDING',
  Onboarding = 'ONBOARDING',
  Other = 'OTHER',
  PreHire = 'PRE_HIRE',
  Retention = 'RETENTION'
}

export enum WorkflowStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE'
}

export type WorkflowsCreateWorkflowInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Workflow description (required, max 150 characters) */
  description: Scalars['String']['input'];
  /** Optional workflow end date (ISO 8601 date string) */
  end_date?: InputMaybe<Scalars['String']['input']>;
  /** Workflow name (required, max 150 characters) */
  name: Scalars['String']['input'];
  /** Notifica al usuario cuando este workflow es activado para él. Default: false */
  notify_on_activation?: Scalars['Boolean']['input'];
  /** Notify users with pending resources. Default: false */
  notify_pending?: Scalars['Boolean']['input'];
  /** Retire assignments when user exits segment. Default: true */
  retire_on_group_exit?: Scalars['Boolean']['input'];
  /** Optional segment definition; creates a new segment and assigns it to the workflow. When absent the workflow applies to all active users. */
  segmentation?: InputMaybe<SegmentInput>;
  /** Workflow stage: pre_hire, onboarding, development, retention, offboarding, other, none */
  stage: WorkflowStage;
  /** Workflow start date (ISO 8601 date string, e.g. '2026-06-01') */
  start_date: Scalars['String']['input'];
  /** Initial status. 'draft' persists an incomplete workflow (relaxes the completeness checks) and does not run triggers or enrollments until it is activated. Default: 'active'. */
  status?: WorkflowStatus;
  /** Workflow steps (at least one required, positions must be consecutive from 1) */
  steps: Array<WorkflowsStepInput>;
  /** Trigger that activates the workflow */
  trigger: WorkflowsTriggerInput;
};

export type WorkflowsCreateWorkflowPayload = {
  __typename?: 'WorkflowsCreateWorkflowPayload';
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The created workflow with all nested entities */
  workflow: WorkflowsWorkflow;
};

export type WorkflowsCreateWorkflowPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse | WorkflowsCreateWorkflowPayload;

export type WorkflowsDeleteWorkflowInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** UUID of the workflow to delete */
  workflow_id: Scalars['ID']['input'];
};

export type WorkflowsDeleteWorkflowPayload = {
  __typename?: 'WorkflowsDeleteWorkflowPayload';
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** UUID of the deleted workflow */
  workflow_id: Scalars['UUID']['output'];
};

export type WorkflowsDeleteWorkflowPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | WorkflowsDeleteWorkflowPayload;

export type WorkflowsEditStepInput = {
  /** Advancement gate (required for position > 1, forbidden for position = 1) */
  gate?: InputMaybe<WorkflowsStepGateInput>;
  /** Existing step UUID (null = new step to be created) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Step position (1-based); must match current DB position for existing steps */
  position: Scalars['Int']['input'];
  /** Resource groups for this step (at least one required) */
  resource_groups: Array<WorkflowsStepResourceGroupInput>;
};

export type WorkflowsEditWorkflowInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Workflow name (required, max 150 characters) */
  name: Scalars['String']['input'];
  /** UUID of the workflow to edit */
  workflow_id: Scalars['ID']['input'];
};

export type WorkflowsEditWorkflowPayload = {
  __typename?: 'WorkflowsEditWorkflowPayload';
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The updated workflow */
  workflow: WorkflowsWorkflow;
};

export type WorkflowsEditWorkflowPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse = ForbiddenErrorResponse | IntegrityErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse | WorkflowsEditWorkflowPayload;

export type WorkflowsGetWorkflowInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** UUID of the workflow to retrieve */
  workflow_id: Scalars['ID']['input'];
};

export type WorkflowsGetWorkflowPayload = {
  __typename?: 'WorkflowsGetWorkflowPayload';
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The retrieved workflow */
  workflow: WorkflowsWorkflow;
};

export type WorkflowsGetWorkflowPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse | WorkflowsGetWorkflowPayload;

export type WorkflowsListWorkflowsInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Pagination configuration. Default: page 1, page_size 10 */
  pagination?: InputMaybe<WorkflowsListWorkflowsPaginationInput>;
  /** Search by workflow name */
  search?: InputMaybe<WorkflowsListWorkflowsSearchInput>;
  /** Filter by stage (multi-select). Null or empty list returns all stages. */
  stages?: InputMaybe<Array<WorkflowStage>>;
};

export type WorkflowsListWorkflowsPaginationInput = {
  /** Page number (1-based). Default: 1. */
  page?: Scalars['Int']['input'];
  /** Number of items per page. Default: 10. */
  page_size?: Scalars['Int']['input'];
};

export type WorkflowsListWorkflowsPayload = {
  __typename?: 'WorkflowsListWorkflowsPayload';
  /** Total count of workflows matching the filters (without pagination) */
  total_count: Scalars['Int']['output'];
  /** Page of workflows */
  workflows: Array<WorkflowsWorkflow>;
};

export type WorkflowsListWorkflowsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | ValidationErrorResponse | WorkflowsListWorkflowsPayload;

export type WorkflowsListWorkflowsSearchInput = {
  /** Search query for partial name match (case-insensitive) */
  query: Scalars['String']['input'];
};

export type WorkflowsMutations = {
  __typename?: 'WorkflowsMutations';
  /** Mutations for workflow management */
  workflows: WorkflowsWorkflowsMutations;
};

export type WorkflowsNotifyGroupUsersChangedInput = {
  /** Centralized organization the group belongs to */
  centralized_organization_id: Scalars['Int']['input'];
  /** Segmentation group whose user membership changed */
  group_id: Scalars['Int']['input'];
};

export type WorkflowsNotifyGroupUsersChangedPayload = {
  __typename?: 'WorkflowsNotifyGroupUsersChangedPayload';
  /** Whether the event was accepted and enqueued for processing */
  accepted: Scalars['Boolean']['output'];
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type WorkflowsNotifyGroupUsersChangedPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | WorkflowsNotifyGroupUsersChangedPayload;

export type WorkflowsQueries = {
  __typename?: 'WorkflowsQueries';
  /** Queries for workflow management */
  workflows: WorkflowsWorkflowsQueries;
};

export type WorkflowsResource = {
  __typename?: 'WorkflowsResource';
  /** External resource identifier */
  id: Scalars['String']['output'];
  /** Display label when resolved (e.g. live session title), else null */
  label?: Maybe<Scalars['String']['output']>;
  /** Type of resource */
  type: ResourceType;
};

export type WorkflowsRetryJobInput = {
  /** Organization that owns the job */
  centralized_organization_id: Scalars['Int']['input'];
  /** ID of the dead job to retry */
  job_id: Scalars['UUID']['input'];
};

export type WorkflowsRetryJobPayload = {
  __typename?: 'WorkflowsRetryJobPayload';
  /** ID of the newly created retry job */
  new_job_id: Scalars['UUID']['output'];
  /** Whether the retry was dispatched */
  success: Scalars['Boolean']['output'];
};

export type WorkflowsRetryJobPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse | WorkflowsRetryJobPayload;

export type WorkflowsStep = {
  __typename?: 'WorkflowsStep';
  /** Advancement gate (present for position > 1) */
  gate?: Maybe<WorkflowsStepGate>;
  /** Step unique identifier */
  id: Scalars['UUID']['output'];
  /** Step position within the workflow */
  position: Scalars['Int']['output'];
  /** Resource groups assigned to this step, grouped by type */
  resource_groups: Array<WorkflowsStepResourceGroup>;
};

export type WorkflowsStepGate = {
  __typename?: 'WorkflowsStepGate';
  /** Gate condition: complete_all, complete_some or complete_percentage */
  condition_type: GateConditionType;
  /** Deadline date for days_after_deadline timing */
  deadline_date?: Maybe<Scalars['Date']['output']>;
  /** Required resources for complete_some gates */
  gate_items: Array<WorkflowsStepGateItem>;
  /** Gate unique identifier */
  id: Scalars['UUID']['output'];
  /** Required completion percentage (0..100) for complete_percentage gates; null otherwise */
  percentage_threshold?: Maybe<Scalars['Int']['output']>;
  /** Gate timing mode */
  timing: GateTiming;
  /** Days for timed gate modes */
  timing_days?: Maybe<Scalars['Int']['output']>;
};

export type WorkflowsStepGateInput = {
  /** Gate condition: complete_all, complete_some or complete_percentage */
  condition_type: GateConditionType;
  /** Deadline date (required for days_after_deadline) */
  deadline_date?: InputMaybe<Scalars['Date']['input']>;
  /** Resources required to pass the gate (required for complete_some) */
  gate_items?: Array<WorkflowsStepGateItemInput>;
  /** Required completion percentage 0..100 (required for complete_percentage; must be null otherwise) */
  percentage_threshold?: InputMaybe<Scalars['Int']['input']>;
  /** When the gate is evaluated: immediate, days_after_assignment, or days_after_deadline */
  timing: GateTiming;
  /** Number of days (required for days_after_assignment and days_after_deadline) */
  timing_days?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkflowsStepGateItem = {
  __typename?: 'WorkflowsStepGateItem';
  /** Gate item unique identifier */
  id: Scalars['UUID']['output'];
  /** Resolved resource context for this gate item, or null when the step resource cannot be resolved */
  resource?: Maybe<WorkflowsResource>;
  /** UUID of the required step resource */
  step_resource_id: Scalars['UUID']['output'];
};

export type WorkflowsStepGateItemInput = {
  /** resource_id of a resource in the immediately preceding step (position N-1) that must be completed */
  resource_id: Scalars['String']['input'];
  /** resource_type of the resource (required to disambiguate when the same resource_id exists across different types) */
  resource_type: ResourceType;
};

export type WorkflowsStepInput = {
  /** Advancement gate (required for position > 1, forbidden for position 1) */
  gate?: InputMaybe<WorkflowsStepGateInput>;
  /** Step position (consecutive integers starting from 1) */
  position: Scalars['Int']['input'];
  /** Resource groups for this step. Each group is a different resource type with its own responsible user (at least one group required, max one group per resource type) */
  resource_groups: Array<WorkflowsStepResourceGroupInput>;
};

export type WorkflowsStepResourceGroup = {
  __typename?: 'WorkflowsStepResourceGroup';
  /**
   * External resource identifiers in this group (legacy; prefer 'resources' for type, id, and label)
   * @deprecated Legacy IDs only; use resources for type, id, and label.
   */
  resource_ids: Array<Scalars['String']['output']>;
  /** Type of resource */
  resource_type: ResourceType;
  /** Enriched resources with type, id, and label; one entry per step resource, preserving order and duplicates */
  resources: Array<WorkflowsResource>;
  /** Optional responsible user ID for this group */
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
};

export type WorkflowsStepResourceGroupInput = {
  /** Optional dynamic deadline in whole days (RN-006). The concrete deadline is computed at assignment time as the block activation date plus these days. Must be a positive integer when set; null means no deadline. */
  deadline_offset_days?: InputMaybe<Scalars['Int']['input']>;
  /** External resource identifiers (at least one required) */
  resource_ids: Array<Scalars['String']['input']>;
  /** Type of resource: course, route, live_session, document, task */
  resource_type: ResourceType;
  /** Optional responsible user ID for all resources in this group */
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Retain-history policy for route resources (RN-002). Only applies when resource_type is route: when True (default) the completed child courses of the route stay in the learner's academic history if the route is later unassigned; when False the admin opted into deleting that history too. Ignored for other resource types. */
  retain_history?: Scalars['Boolean']['input'];
};

export type WorkflowsTrigger = {
  __typename?: 'WorkflowsTrigger';
  /** Trigger unique identifier */
  id: Scalars['UUID']['output'];
  /** Offset direction for date-based triggers */
  offset_direction?: Maybe<OffsetDirection>;
  /** Offset unit: days or months */
  offset_unit?: Maybe<OffsetUnit>;
  /** Offset quantity for before/after directions */
  offset_value?: Maybe<Scalars['Int']['output']>;
  /** Trigger type */
  type: TriggerType;
};

export type WorkflowsTriggerInput = {
  /** Offset direction (required for on_entry_date and on_exit_date) */
  offset_direction?: InputMaybe<OffsetDirection>;
  /** Offset unit: days or months (required when offset_direction is before or after) */
  offset_unit?: InputMaybe<OffsetUnit>;
  /** Offset quantity (required when offset_direction is before or after) */
  offset_value?: InputMaybe<Scalars['Int']['input']>;
  /** Trigger type: immediate, on_user_create, on_entry_date, on_exit_date */
  type: TriggerType;
};

export type WorkflowsTriggerWatchdogInput = {
  idempotency_key?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowsTriggerWatchdogPayload = {
  __typename?: 'WorkflowsTriggerWatchdogPayload';
  /** Whether the trigger was accepted and enqueued */
  accepted: Scalars['Boolean']['output'];
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type WorkflowsTriggerWatchdogPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | WorkflowsTriggerWatchdogPayload;

export type WorkflowsUpdateWorkflowInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** Workflow description (required, max 150 characters) */
  description: Scalars['String']['input'];
  /** Optional workflow end date (ISO 8601 date string) */
  end_date?: InputMaybe<Scalars['String']['input']>;
  /** Current group_id (cannot change to a different non-null value) */
  group_id?: InputMaybe<Scalars['Int']['input']>;
  /** Workflow name (required, max 150 characters) */
  name: Scalars['String']['input'];
  /** Notify user when this workflow is activated for them. Default: false */
  notify_on_activation?: Scalars['Boolean']['input'];
  /** Notify users with pending resources. Default: false */
  notify_pending?: Scalars['Boolean']['input'];
  /** Retire assignments when user exits segment. Default: true */
  retire_on_group_exit?: Scalars['Boolean']['input'];
  /** New segmentation rules. Used to create or update the segment. */
  segmentation?: InputMaybe<SegmentInput>;
  /** Workflow stage: pre_hire, onboarding, development, retention, offboarding, other, none */
  stage: WorkflowStage;
  /** Workflow start date (ISO 8601 date string) */
  start_date: Scalars['String']['input'];
  /** All desired steps. Must include all existing active steps plus any new ones. v1: deletion and reordering of existing steps are not supported. */
  steps: Array<WorkflowsEditStepInput>;
  /** Trigger definition (updates the existing trigger) */
  trigger: WorkflowsTriggerInput;
  /** UUID of the workflow to update */
  workflow_id: Scalars['ID']['input'];
};

export type WorkflowsUpdateWorkflowStatusInput = {
  /** Centralized organization ID */
  centralized_organization_id: Scalars['Int']['input'];
  /** New status for the workflow: ACTIVE or INACTIVE */
  status: WorkflowStatus;
  /** UUID of the workflow whose status will be updated */
  workflow_id: Scalars['ID']['input'];
};

export type WorkflowsUpdateWorkflowStatusPayload = {
  __typename?: 'WorkflowsUpdateWorkflowStatusPayload';
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** The workflow with its updated status */
  workflow: WorkflowsWorkflow;
};

export type WorkflowsUpdateWorkflowStatusPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse = ForbiddenErrorResponse | InternalErrorResponse | NotAuthenticatedErrorResponse | NotFoundResponse | ValidationErrorResponse | WorkflowsUpdateWorkflowStatusPayload;

export type WorkflowsWorkflow = {
  __typename?: 'WorkflowsWorkflow';
  /** Centralized organization that owns the workflow */
  centralized_organization_id: Scalars['Int']['output'];
  /** Percentage of enrolled users who completed this workflow (0.0–100.0, rounded to 2 decimals) */
  completion_percentage: Scalars['Float']['output'];
  /** Timestamp when the workflow was created */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the user who created the workflow */
  created_by?: Maybe<Scalars['Int']['output']>;
  /** Workflow description */
  description: Scalars['String']['output'];
  /** Optional workflow end date */
  end_date?: Maybe<Scalars['Date']['output']>;
  /** Group ID (null means all active users) */
  group_id?: Maybe<Scalars['String']['output']>;
  /** Workflow unique identifier */
  id: Scalars['UUID']['output'];
  /** Workflow name */
  name: Scalars['String']['output'];
  /** Whether to notify the user when this workflow is activated for them */
  notify_on_activation: Scalars['Boolean']['output'];
  /** Whether to notify users with pending resources */
  notify_pending: Scalars['Boolean']['output'];
  /** Whether to retire assignments when a user exits the group */
  retire_on_group_exit: Scalars['Boolean']['output'];
  /** Workflow stage */
  stage: WorkflowStage;
  /** Workflow start date */
  start_date: Scalars['Date']['output'];
  /** Workflow status */
  status: WorkflowStatus;
  /** Ordered workflow steps */
  steps: Array<WorkflowsStep>;
  /** Workflow trigger */
  trigger?: Maybe<WorkflowsTrigger>;
  /** Timestamp of the last update */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the user who last updated the workflow */
  updated_by?: Maybe<Scalars['Int']['output']>;
};

export type WorkflowsWorkflowsMutations = {
  __typename?: 'WorkflowsWorkflowsMutations';
  /** Create a new workflow with trigger and steps */
  create_workflow: WorkflowsCreateWorkflowPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
  /** Delete a workflow */
  delete_workflow: WorkflowsDeleteWorkflowPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseInternalErrorResponse;
  /** Edit an existing workflow */
  edit_workflow: WorkflowsEditWorkflowPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
  /** Notify that a segmentation group's user membership changed */
  notify_group_users_changed: WorkflowsNotifyGroupUsersChangedPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
  /** Retry a dead workflow job by creating a new pending job */
  retry_job: WorkflowsRetryJobPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse;
  /** Trigger the watchdog (machine-to-machine, invoked by EventBridge Lambda) */
  trigger_watchdog: WorkflowsTriggerWatchdogPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseInternalErrorResponse;
  /** Update an existing workflow (trigger, steps, resources, segmentation) */
  update_workflow: WorkflowsEditWorkflowPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseIntegrityErrorResponseInternalErrorResponse;
  /** Update the status of a workflow (active ↔ inactive) */
  update_workflow_status: WorkflowsUpdateWorkflowStatusPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse;
};


export type WorkflowsWorkflowsMutationsCreate_WorkflowArgs = {
  input: WorkflowsCreateWorkflowInput;
};


export type WorkflowsWorkflowsMutationsDelete_WorkflowArgs = {
  input: WorkflowsDeleteWorkflowInput;
};


export type WorkflowsWorkflowsMutationsEdit_WorkflowArgs = {
  input: WorkflowsEditWorkflowInput;
};


export type WorkflowsWorkflowsMutationsNotify_Group_Users_ChangedArgs = {
  input: WorkflowsNotifyGroupUsersChangedInput;
};


export type WorkflowsWorkflowsMutationsRetry_JobArgs = {
  input: WorkflowsRetryJobInput;
};


export type WorkflowsWorkflowsMutationsTrigger_WatchdogArgs = {
  input: WorkflowsTriggerWatchdogInput;
};


export type WorkflowsWorkflowsMutationsUpdate_WorkflowArgs = {
  input: WorkflowsUpdateWorkflowInput;
};


export type WorkflowsWorkflowsMutationsUpdate_Workflow_StatusArgs = {
  input: WorkflowsUpdateWorkflowStatusInput;
};

export type WorkflowsWorkflowsQueries = {
  __typename?: 'WorkflowsWorkflowsQueries';
  /** Get a workflow by ID */
  get_workflow: WorkflowsGetWorkflowPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseNotFoundResponseValidationErrorResponseInternalErrorResponse;
  /** List workflows with search and pagination */
  list_workflows: WorkflowsListWorkflowsPayloadNotAuthenticatedErrorResponseForbiddenErrorResponseValidationErrorResponseInternalErrorResponse;
};


export type WorkflowsWorkflowsQueriesGet_WorkflowArgs = {
  input: WorkflowsGetWorkflowInput;
};


export type WorkflowsWorkflowsQueriesList_WorkflowsArgs = {
  input: WorkflowsListWorkflowsInput;
};

export type CertificatesPreviewOrganizationTemplateResponse = PreviewOrganizationTemplateResponsePayload | ResponseIntegrityError | ResponseInternalError | ResponseValidationError;
